/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;
(function (root) {
  // Detect free variables `exports`.
  var freeExports = typeof exports == 'object' && exports;

  // Detect free variable `module`.
  var freeModule = typeof module == 'object' && module && module.exports == freeExports && module;

  // Detect free variable `global`, from Node.js or Browserified code,
  // and use it as `root`.
  var freeGlobal = typeof global == 'object' && global;
  if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
    root = freeGlobal;
  }

  /*--------------------------------------------------------------------------*/

  // All astral symbols.
  var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  // All ASCII symbols (not just printable ASCII) except those listed in the
  // first column of the overrides table.
  // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
  var regexAsciiWhitelist = /[\x01-\x7F]/g;
  // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
  // code points listed in the first column of the overrides table on
  // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
  var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
  var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
  var encodeMap = {
    '\xAD': 'shy',
    '\u200C': 'zwnj',
    '\u200D': 'zwj',
    '\u200E': 'lrm',
    '\u2063': 'ic',
    '\u2062': 'it',
    '\u2061': 'af',
    '\u200F': 'rlm',
    '\u200B': 'ZeroWidthSpace',
    '\u2060': 'NoBreak',
    '\u0311': 'DownBreve',
    '\u20DB': 'tdot',
    '\u20DC': 'DotDot',
    '\t': 'Tab',
    '\n': 'NewLine',
    '\u2008': 'puncsp',
    '\u205F': 'MediumSpace',
    '\u2009': 'thinsp',
    '\u200A': 'hairsp',
    '\u2004': 'emsp13',
    '\u2002': 'ensp',
    '\u2005': 'emsp14',
    '\u2003': 'emsp',
    '\u2007': 'numsp',
    '\xA0': 'nbsp',
    '\u205F\u200A': 'ThickSpace',
    '\u203E': 'oline',
    '_': 'lowbar',
    '\u2010': 'dash',
    '\u2013': 'ndash',
    '\u2014': 'mdash',
    '\u2015': 'horbar',
    ',': 'comma',
    ';': 'semi',
    '\u204F': 'bsemi',
    ':': 'colon',
    '\u2A74': 'Colone',
    '!': 'excl',
    '\xA1': 'iexcl',
    '?': 'quest',
    '\xBF': 'iquest',
    '.': 'period',
    '\u2025': 'nldr',
    '\u2026': 'mldr',
    '\xB7': 'middot',
    '\'': 'apos',
    '\u2018': 'lsquo',
    '\u2019': 'rsquo',
    '\u201A': 'sbquo',
    '\u2039': 'lsaquo',
    '\u203A': 'rsaquo',
    '"': 'quot',
    '\u201C': 'ldquo',
    '\u201D': 'rdquo',
    '\u201E': 'bdquo',
    '\xAB': 'laquo',
    '\xBB': 'raquo',
    '(': 'lpar',
    ')': 'rpar',
    '[': 'lsqb',
    ']': 'rsqb',
    '{': 'lcub',
    '}': 'rcub',
    '\u2308': 'lceil',
    '\u2309': 'rceil',
    '\u230A': 'lfloor',
    '\u230B': 'rfloor',
    '\u2985': 'lopar',
    '\u2986': 'ropar',
    '\u298B': 'lbrke',
    '\u298C': 'rbrke',
    '\u298D': 'lbrkslu',
    '\u298E': 'rbrksld',
    '\u298F': 'lbrksld',
    '\u2990': 'rbrkslu',
    '\u2991': 'langd',
    '\u2992': 'rangd',
    '\u2993': 'lparlt',
    '\u2994': 'rpargt',
    '\u2995': 'gtlPar',
    '\u2996': 'ltrPar',
    '\u27E6': 'lobrk',
    '\u27E7': 'robrk',
    '\u27E8': 'lang',
    '\u27E9': 'rang',
    '\u27EA': 'Lang',
    '\u27EB': 'Rang',
    '\u27EC': 'loang',
    '\u27ED': 'roang',
    '\u2772': 'lbbrk',
    '\u2773': 'rbbrk',
    '\u2016': 'Vert',
    '\xA7': 'sect',
    '\xB6': 'para',
    '@': 'commat',
    '*': 'ast',
    '/': 'sol',
    'undefined': null,
    '&': 'amp',
    '#': 'num',
    '%': 'percnt',
    '\u2030': 'permil',
    '\u2031': 'pertenk',
    '\u2020': 'dagger',
    '\u2021': 'Dagger',
    '\u2022': 'bull',
    '\u2043': 'hybull',
    '\u2032': 'prime',
    '\u2033': 'Prime',
    '\u2034': 'tprime',
    '\u2057': 'qprime',
    '\u2035': 'bprime',
    '\u2041': 'caret',
    '`': 'grave',
    '\xB4': 'acute',
    '\u02DC': 'tilde',
    '^': 'Hat',
    '\xAF': 'macr',
    '\u02D8': 'breve',
    '\u02D9': 'dot',
    '\xA8': 'die',
    '\u02DA': 'ring',
    '\u02DD': 'dblac',
    '\xB8': 'cedil',
    '\u02DB': 'ogon',
    '\u02C6': 'circ',
    '\u02C7': 'caron',
    '\xB0': 'deg',
    '\xA9': 'copy',
    '\xAE': 'reg',
    '\u2117': 'copysr',
    '\u2118': 'wp',
    '\u211E': 'rx',
    '\u2127': 'mho',
    '\u2129': 'iiota',
    '\u2190': 'larr',
    '\u219A': 'nlarr',
    '\u2192': 'rarr',
    '\u219B': 'nrarr',
    '\u2191': 'uarr',
    '\u2193': 'darr',
    '\u2194': 'harr',
    '\u21AE': 'nharr',
    '\u2195': 'varr',
    '\u2196': 'nwarr',
    '\u2197': 'nearr',
    '\u2198': 'searr',
    '\u2199': 'swarr',
    '\u219D': 'rarrw',
    '\u219D\u0338': 'nrarrw',
    '\u219E': 'Larr',
    '\u219F': 'Uarr',
    '\u21A0': 'Rarr',
    '\u21A1': 'Darr',
    '\u21A2': 'larrtl',
    '\u21A3': 'rarrtl',
    '\u21A4': 'mapstoleft',
    '\u21A5': 'mapstoup',
    '\u21A6': 'map',
    '\u21A7': 'mapstodown',
    '\u21A9': 'larrhk',
    '\u21AA': 'rarrhk',
    '\u21AB': 'larrlp',
    '\u21AC': 'rarrlp',
    '\u21AD': 'harrw',
    '\u21B0': 'lsh',
    '\u21B1': 'rsh',
    '\u21B2': 'ldsh',
    '\u21B3': 'rdsh',
    '\u21B5': 'crarr',
    '\u21B6': 'cularr',
    '\u21B7': 'curarr',
    '\u21BA': 'olarr',
    '\u21BB': 'orarr',
    '\u21BC': 'lharu',
    '\u21BD': 'lhard',
    '\u21BE': 'uharr',
    '\u21BF': 'uharl',
    '\u21C0': 'rharu',
    '\u21C1': 'rhard',
    '\u21C2': 'dharr',
    '\u21C3': 'dharl',
    '\u21C4': 'rlarr',
    '\u21C5': 'udarr',
    '\u21C6': 'lrarr',
    '\u21C7': 'llarr',
    '\u21C8': 'uuarr',
    '\u21C9': 'rrarr',
    '\u21CA': 'ddarr',
    '\u21CB': 'lrhar',
    '\u21CC': 'rlhar',
    '\u21D0': 'lArr',
    '\u21CD': 'nlArr',
    '\u21D1': 'uArr',
    '\u21D2': 'rArr',
    '\u21CF': 'nrArr',
    '\u21D3': 'dArr',
    '\u21D4': 'iff',
    '\u21CE': 'nhArr',
    '\u21D5': 'vArr',
    '\u21D6': 'nwArr',
    '\u21D7': 'neArr',
    '\u21D8': 'seArr',
    '\u21D9': 'swArr',
    '\u21DA': 'lAarr',
    '\u21DB': 'rAarr',
    '\u21DD': 'zigrarr',
    '\u21E4': 'larrb',
    '\u21E5': 'rarrb',
    '\u21F5': 'duarr',
    '\u21FD': 'loarr',
    '\u21FE': 'roarr',
    '\u21FF': 'hoarr',
    '\u2200': 'forall',
    '\u2201': 'comp',
    '\u2202': 'part',
    '\u2202\u0338': 'npart',
    '\u2203': 'exist',
    '\u2204': 'nexist',
    '\u2205': 'empty',
    '\u2207': 'Del',
    '\u2208': 'in',
    '\u2209': 'notin',
    '\u220B': 'ni',
    '\u220C': 'notni',
    '\u03F6': 'bepsi',
    '\u220F': 'prod',
    '\u2210': 'coprod',
    '\u2211': 'sum',
    '+': 'plus',
    '\xB1': 'pm',
    '\xF7': 'div',
    '\xD7': 'times',
    '<': 'lt',
    '\u226E': 'nlt',
    '<\u20D2': 'nvlt',
    '=': 'equals',
    '\u2260': 'ne',
    '=\u20E5': 'bne',
    '\u2A75': 'Equal',
    '>': 'gt',
    '\u226F': 'ngt',
    '>\u20D2': 'nvgt',
    '\xAC': 'not',
    '|': 'vert',
    '\xA6': 'brvbar',
    '\u2212': 'minus',
    '\u2213': 'mp',
    '\u2214': 'plusdo',
    '\u2044': 'frasl',
    '\u2216': 'setmn',
    '\u2217': 'lowast',
    '\u2218': 'compfn',
    '\u221A': 'Sqrt',
    '\u221D': 'prop',
    '\u221E': 'infin',
    '\u221F': 'angrt',
    '\u2220': 'ang',
    '\u2220\u20D2': 'nang',
    '\u2221': 'angmsd',
    '\u2222': 'angsph',
    '\u2223': 'mid',
    '\u2224': 'nmid',
    '\u2225': 'par',
    '\u2226': 'npar',
    '\u2227': 'and',
    '\u2228': 'or',
    '\u2229': 'cap',
    '\u2229\uFE00': 'caps',
    '\u222A': 'cup',
    '\u222A\uFE00': 'cups',
    '\u222B': 'int',
    '\u222C': 'Int',
    '\u222D': 'tint',
    '\u2A0C': 'qint',
    '\u222E': 'oint',
    '\u222F': 'Conint',
    '\u2230': 'Cconint',
    '\u2231': 'cwint',
    '\u2232': 'cwconint',
    '\u2233': 'awconint',
    '\u2234': 'there4',
    '\u2235': 'becaus',
    '\u2236': 'ratio',
    '\u2237': 'Colon',
    '\u2238': 'minusd',
    '\u223A': 'mDDot',
    '\u223B': 'homtht',
    '\u223C': 'sim',
    '\u2241': 'nsim',
    '\u223C\u20D2': 'nvsim',
    '\u223D': 'bsim',
    '\u223D\u0331': 'race',
    '\u223E': 'ac',
    '\u223E\u0333': 'acE',
    '\u223F': 'acd',
    '\u2240': 'wr',
    '\u2242': 'esim',
    '\u2242\u0338': 'nesim',
    '\u2243': 'sime',
    '\u2244': 'nsime',
    '\u2245': 'cong',
    '\u2247': 'ncong',
    '\u2246': 'simne',
    '\u2248': 'ap',
    '\u2249': 'nap',
    '\u224A': 'ape',
    '\u224B': 'apid',
    '\u224B\u0338': 'napid',
    '\u224C': 'bcong',
    '\u224D': 'CupCap',
    '\u226D': 'NotCupCap',
    '\u224D\u20D2': 'nvap',
    '\u224E': 'bump',
    '\u224E\u0338': 'nbump',
    '\u224F': 'bumpe',
    '\u224F\u0338': 'nbumpe',
    '\u2250': 'doteq',
    '\u2250\u0338': 'nedot',
    '\u2251': 'eDot',
    '\u2252': 'efDot',
    '\u2253': 'erDot',
    '\u2254': 'colone',
    '\u2255': 'ecolon',
    '\u2256': 'ecir',
    '\u2257': 'cire',
    '\u2259': 'wedgeq',
    '\u225A': 'veeeq',
    '\u225C': 'trie',
    '\u225F': 'equest',
    '\u2261': 'equiv',
    '\u2262': 'nequiv',
    '\u2261\u20E5': 'bnequiv',
    '\u2264': 'le',
    '\u2270': 'nle',
    '\u2264\u20D2': 'nvle',
    '\u2265': 'ge',
    '\u2271': 'nge',
    '\u2265\u20D2': 'nvge',
    '\u2266': 'lE',
    '\u2266\u0338': 'nlE',
    '\u2267': 'gE',
    '\u2267\u0338': 'ngE',
    '\u2268\uFE00': 'lvnE',
    '\u2268': 'lnE',
    '\u2269': 'gnE',
    '\u2269\uFE00': 'gvnE',
    '\u226A': 'll',
    '\u226A\u0338': 'nLtv',
    '\u226A\u20D2': 'nLt',
    '\u226B': 'gg',
    '\u226B\u0338': 'nGtv',
    '\u226B\u20D2': 'nGt',
    '\u226C': 'twixt',
    '\u2272': 'lsim',
    '\u2274': 'nlsim',
    '\u2273': 'gsim',
    '\u2275': 'ngsim',
    '\u2276': 'lg',
    '\u2278': 'ntlg',
    '\u2277': 'gl',
    '\u2279': 'ntgl',
    '\u227A': 'pr',
    '\u2280': 'npr',
    '\u227B': 'sc',
    '\u2281': 'nsc',
    '\u227C': 'prcue',
    '\u22E0': 'nprcue',
    '\u227D': 'sccue',
    '\u22E1': 'nsccue',
    '\u227E': 'prsim',
    '\u227F': 'scsim',
    '\u227F\u0338': 'NotSucceedsTilde',
    '\u2282': 'sub',
    '\u2284': 'nsub',
    '\u2282\u20D2': 'vnsub',
    '\u2283': 'sup',
    '\u2285': 'nsup',
    '\u2283\u20D2': 'vnsup',
    '\u2286': 'sube',
    '\u2288': 'nsube',
    '\u2287': 'supe',
    '\u2289': 'nsupe',
    '\u228A\uFE00': 'vsubne',
    '\u228A': 'subne',
    '\u228B\uFE00': 'vsupne',
    '\u228B': 'supne',
    '\u228D': 'cupdot',
    '\u228E': 'uplus',
    '\u228F': 'sqsub',
    '\u228F\u0338': 'NotSquareSubset',
    '\u2290': 'sqsup',
    '\u2290\u0338': 'NotSquareSuperset',
    '\u2291': 'sqsube',
    '\u22E2': 'nsqsube',
    '\u2292': 'sqsupe',
    '\u22E3': 'nsqsupe',
    '\u2293': 'sqcap',
    '\u2293\uFE00': 'sqcaps',
    '\u2294': 'sqcup',
    '\u2294\uFE00': 'sqcups',
    '\u2295': 'oplus',
    '\u2296': 'ominus',
    '\u2297': 'otimes',
    '\u2298': 'osol',
    '\u2299': 'odot',
    '\u229A': 'ocir',
    '\u229B': 'oast',
    '\u229D': 'odash',
    '\u229E': 'plusb',
    '\u229F': 'minusb',
    '\u22A0': 'timesb',
    '\u22A1': 'sdotb',
    '\u22A2': 'vdash',
    '\u22AC': 'nvdash',
    '\u22A3': 'dashv',
    '\u22A4': 'top',
    '\u22A5': 'bot',
    '\u22A7': 'models',
    '\u22A8': 'vDash',
    '\u22AD': 'nvDash',
    '\u22A9': 'Vdash',
    '\u22AE': 'nVdash',
    '\u22AA': 'Vvdash',
    '\u22AB': 'VDash',
    '\u22AF': 'nVDash',
    '\u22B0': 'prurel',
    '\u22B2': 'vltri',
    '\u22EA': 'nltri',
    '\u22B3': 'vrtri',
    '\u22EB': 'nrtri',
    '\u22B4': 'ltrie',
    '\u22EC': 'nltrie',
    '\u22B4\u20D2': 'nvltrie',
    '\u22B5': 'rtrie',
    '\u22ED': 'nrtrie',
    '\u22B5\u20D2': 'nvrtrie',
    '\u22B6': 'origof',
    '\u22B7': 'imof',
    '\u22B8': 'mumap',
    '\u22B9': 'hercon',
    '\u22BA': 'intcal',
    '\u22BB': 'veebar',
    '\u22BD': 'barvee',
    '\u22BE': 'angrtvb',
    '\u22BF': 'lrtri',
    '\u22C0': 'Wedge',
    '\u22C1': 'Vee',
    '\u22C2': 'xcap',
    '\u22C3': 'xcup',
    '\u22C4': 'diam',
    '\u22C5': 'sdot',
    '\u22C6': 'Star',
    '\u22C7': 'divonx',
    '\u22C8': 'bowtie',
    '\u22C9': 'ltimes',
    '\u22CA': 'rtimes',
    '\u22CB': 'lthree',
    '\u22CC': 'rthree',
    '\u22CD': 'bsime',
    '\u22CE': 'cuvee',
    '\u22CF': 'cuwed',
    '\u22D0': 'Sub',
    '\u22D1': 'Sup',
    '\u22D2': 'Cap',
    '\u22D3': 'Cup',
    '\u22D4': 'fork',
    '\u22D5': 'epar',
    '\u22D6': 'ltdot',
    '\u22D7': 'gtdot',
    '\u22D8': 'Ll',
    '\u22D8\u0338': 'nLl',
    '\u22D9': 'Gg',
    '\u22D9\u0338': 'nGg',
    '\u22DA\uFE00': 'lesg',
    '\u22DA': 'leg',
    '\u22DB': 'gel',
    '\u22DB\uFE00': 'gesl',
    '\u22DE': 'cuepr',
    '\u22DF': 'cuesc',
    '\u22E6': 'lnsim',
    '\u22E7': 'gnsim',
    '\u22E8': 'prnsim',
    '\u22E9': 'scnsim',
    '\u22EE': 'vellip',
    '\u22EF': 'ctdot',
    '\u22F0': 'utdot',
    '\u22F1': 'dtdot',
    '\u22F2': 'disin',
    '\u22F3': 'isinsv',
    '\u22F4': 'isins',
    '\u22F5': 'isindot',
    '\u22F5\u0338': 'notindot',
    '\u22F6': 'notinvc',
    '\u22F7': 'notinvb',
    '\u22F9': 'isinE',
    '\u22F9\u0338': 'notinE',
    '\u22FA': 'nisd',
    '\u22FB': 'xnis',
    '\u22FC': 'nis',
    '\u22FD': 'notnivc',
    '\u22FE': 'notnivb',
    '\u2305': 'barwed',
    '\u2306': 'Barwed',
    '\u230C': 'drcrop',
    '\u230D': 'dlcrop',
    '\u230E': 'urcrop',
    '\u230F': 'ulcrop',
    '\u2310': 'bnot',
    '\u2312': 'profline',
    '\u2313': 'profsurf',
    '\u2315': 'telrec',
    '\u2316': 'target',
    '\u231C': 'ulcorn',
    '\u231D': 'urcorn',
    '\u231E': 'dlcorn',
    '\u231F': 'drcorn',
    '\u2322': 'frown',
    '\u2323': 'smile',
    '\u232D': 'cylcty',
    '\u232E': 'profalar',
    '\u2336': 'topbot',
    '\u233D': 'ovbar',
    '\u233F': 'solbar',
    '\u237C': 'angzarr',
    '\u23B0': 'lmoust',
    '\u23B1': 'rmoust',
    '\u23B4': 'tbrk',
    '\u23B5': 'bbrk',
    '\u23B6': 'bbrktbrk',
    '\u23DC': 'OverParenthesis',
    '\u23DD': 'UnderParenthesis',
    '\u23DE': 'OverBrace',
    '\u23DF': 'UnderBrace',
    '\u23E2': 'trpezium',
    '\u23E7': 'elinters',
    '\u2423': 'blank',
    '\u2500': 'boxh',
    '\u2502': 'boxv',
    '\u250C': 'boxdr',
    '\u2510': 'boxdl',
    '\u2514': 'boxur',
    '\u2518': 'boxul',
    '\u251C': 'boxvr',
    '\u2524': 'boxvl',
    '\u252C': 'boxhd',
    '\u2534': 'boxhu',
    '\u253C': 'boxvh',
    '\u2550': 'boxH',
    '\u2551': 'boxV',
    '\u2552': 'boxdR',
    '\u2553': 'boxDr',
    '\u2554': 'boxDR',
    '\u2555': 'boxdL',
    '\u2556': 'boxDl',
    '\u2557': 'boxDL',
    '\u2558': 'boxuR',
    '\u2559': 'boxUr',
    '\u255A': 'boxUR',
    '\u255B': 'boxuL',
    '\u255C': 'boxUl',
    '\u255D': 'boxUL',
    '\u255E': 'boxvR',
    '\u255F': 'boxVr',
    '\u2560': 'boxVR',
    '\u2561': 'boxvL',
    '\u2562': 'boxVl',
    '\u2563': 'boxVL',
    '\u2564': 'boxHd',
    '\u2565': 'boxhD',
    '\u2566': 'boxHD',
    '\u2567': 'boxHu',
    '\u2568': 'boxhU',
    '\u2569': 'boxHU',
    '\u256A': 'boxvH',
    '\u256B': 'boxVh',
    '\u256C': 'boxVH',
    '\u2580': 'uhblk',
    '\u2584': 'lhblk',
    '\u2588': 'block',
    '\u2591': 'blk14',
    '\u2592': 'blk12',
    '\u2593': 'blk34',
    '\u25A1': 'squ',
    '\u25AA': 'squf',
    '\u25AB': 'EmptyVerySmallSquare',
    '\u25AD': 'rect',
    '\u25AE': 'marker',
    '\u25B1': 'fltns',
    '\u25B3': 'xutri',
    '\u25B4': 'utrif',
    '\u25B5': 'utri',
    '\u25B8': 'rtrif',
    '\u25B9': 'rtri',
    '\u25BD': 'xdtri',
    '\u25BE': 'dtrif',
    '\u25BF': 'dtri',
    '\u25C2': 'ltrif',
    '\u25C3': 'ltri',
    '\u25CA': 'loz',
    '\u25CB': 'cir',
    '\u25EC': 'tridot',
    '\u25EF': 'xcirc',
    '\u25F8': 'ultri',
    '\u25F9': 'urtri',
    '\u25FA': 'lltri',
    '\u25FB': 'EmptySmallSquare',
    '\u25FC': 'FilledSmallSquare',
    '\u2605': 'starf',
    '\u2606': 'star',
    '\u260E': 'phone',
    '\u2640': 'female',
    '\u2642': 'male',
    '\u2660': 'spades',
    '\u2663': 'clubs',
    '\u2665': 'hearts',
    '\u2666': 'diams',
    '\u266A': 'sung',
    '\u2713': 'check',
    '\u2717': 'cross',
    '\u2720': 'malt',
    '\u2736': 'sext',
    '\u2758': 'VerticalSeparator',
    '\u27C8': 'bsolhsub',
    '\u27C9': 'suphsol',
    '\u27F5': 'xlarr',
    '\u27F6': 'xrarr',
    '\u27F7': 'xharr',
    '\u27F8': 'xlArr',
    '\u27F9': 'xrArr',
    '\u27FA': 'xhArr',
    '\u27FC': 'xmap',
    '\u27FF': 'dzigrarr',
    '\u2902': 'nvlArr',
    '\u2903': 'nvrArr',
    '\u2904': 'nvHarr',
    '\u2905': 'Map',
    '\u290C': 'lbarr',
    '\u290D': 'rbarr',
    '\u290E': 'lBarr',
    '\u290F': 'rBarr',
    '\u2910': 'RBarr',
    '\u2911': 'DDotrahd',
    '\u2912': 'UpArrowBar',
    '\u2913': 'DownArrowBar',
    '\u2916': 'Rarrtl',
    '\u2919': 'latail',
    '\u291A': 'ratail',
    '\u291B': 'lAtail',
    '\u291C': 'rAtail',
    '\u291D': 'larrfs',
    '\u291E': 'rarrfs',
    '\u291F': 'larrbfs',
    '\u2920': 'rarrbfs',
    '\u2923': 'nwarhk',
    '\u2924': 'nearhk',
    '\u2925': 'searhk',
    '\u2926': 'swarhk',
    '\u2927': 'nwnear',
    '\u2928': 'toea',
    '\u2929': 'tosa',
    '\u292A': 'swnwar',
    '\u2933': 'rarrc',
    '\u2933\u0338': 'nrarrc',
    '\u2935': 'cudarrr',
    '\u2936': 'ldca',
    '\u2937': 'rdca',
    '\u2938': 'cudarrl',
    '\u2939': 'larrpl',
    '\u293C': 'curarrm',
    '\u293D': 'cularrp',
    '\u2945': 'rarrpl',
    '\u2948': 'harrcir',
    '\u2949': 'Uarrocir',
    '\u294A': 'lurdshar',
    '\u294B': 'ldrushar',
    '\u294E': 'LeftRightVector',
    '\u294F': 'RightUpDownVector',
    '\u2950': 'DownLeftRightVector',
    '\u2951': 'LeftUpDownVector',
    '\u2952': 'LeftVectorBar',
    '\u2953': 'RightVectorBar',
    '\u2954': 'RightUpVectorBar',
    '\u2955': 'RightDownVectorBar',
    '\u2956': 'DownLeftVectorBar',
    '\u2957': 'DownRightVectorBar',
    '\u2958': 'LeftUpVectorBar',
    '\u2959': 'LeftDownVectorBar',
    '\u295A': 'LeftTeeVector',
    '\u295B': 'RightTeeVector',
    '\u295C': 'RightUpTeeVector',
    '\u295D': 'RightDownTeeVector',
    '\u295E': 'DownLeftTeeVector',
    '\u295F': 'DownRightTeeVector',
    '\u2960': 'LeftUpTeeVector',
    '\u2961': 'LeftDownTeeVector',
    '\u2962': 'lHar',
    '\u2963': 'uHar',
    '\u2964': 'rHar',
    '\u2965': 'dHar',
    '\u2966': 'luruhar',
    '\u2967': 'ldrdhar',
    '\u2968': 'ruluhar',
    '\u2969': 'rdldhar',
    '\u296A': 'lharul',
    '\u296B': 'llhard',
    '\u296C': 'rharul',
    '\u296D': 'lrhard',
    '\u296E': 'udhar',
    '\u296F': 'duhar',
    '\u2970': 'RoundImplies',
    '\u2971': 'erarr',
    '\u2972': 'simrarr',
    '\u2973': 'larrsim',
    '\u2974': 'rarrsim',
    '\u2975': 'rarrap',
    '\u2976': 'ltlarr',
    '\u2978': 'gtrarr',
    '\u2979': 'subrarr',
    '\u297B': 'suplarr',
    '\u297C': 'lfisht',
    '\u297D': 'rfisht',
    '\u297E': 'ufisht',
    '\u297F': 'dfisht',
    '\u299A': 'vzigzag',
    '\u299C': 'vangrt',
    '\u299D': 'angrtvbd',
    '\u29A4': 'ange',
    '\u29A5': 'range',
    '\u29A6': 'dwangle',
    '\u29A7': 'uwangle',
    '\u29A8': 'angmsdaa',
    '\u29A9': 'angmsdab',
    '\u29AA': 'angmsdac',
    '\u29AB': 'angmsdad',
    '\u29AC': 'angmsdae',
    '\u29AD': 'angmsdaf',
    '\u29AE': 'angmsdag',
    '\u29AF': 'angmsdah',
    '\u29B0': 'bemptyv',
    '\u29B1': 'demptyv',
    '\u29B2': 'cemptyv',
    '\u29B3': 'raemptyv',
    '\u29B4': 'laemptyv',
    '\u29B5': 'ohbar',
    '\u29B6': 'omid',
    '\u29B7': 'opar',
    '\u29B9': 'operp',
    '\u29BB': 'olcross',
    '\u29BC': 'odsold',
    '\u29BE': 'olcir',
    '\u29BF': 'ofcir',
    '\u29C0': 'olt',
    '\u29C1': 'ogt',
    '\u29C2': 'cirscir',
    '\u29C3': 'cirE',
    '\u29C4': 'solb',
    '\u29C5': 'bsolb',
    '\u29C9': 'boxbox',
    '\u29CD': 'trisb',
    '\u29CE': 'rtriltri',
    '\u29CF': 'LeftTriangleBar',
    '\u29CF\u0338': 'NotLeftTriangleBar',
    '\u29D0': 'RightTriangleBar',
    '\u29D0\u0338': 'NotRightTriangleBar',
    '\u29DC': 'iinfin',
    '\u29DD': 'infintie',
    '\u29DE': 'nvinfin',
    '\u29E3': 'eparsl',
    '\u29E4': 'smeparsl',
    '\u29E5': 'eqvparsl',
    '\u29EB': 'lozf',
    '\u29F4': 'RuleDelayed',
    '\u29F6': 'dsol',
    '\u2A00': 'xodot',
    '\u2A01': 'xoplus',
    '\u2A02': 'xotime',
    '\u2A04': 'xuplus',
    '\u2A06': 'xsqcup',
    '\u2A0D': 'fpartint',
    '\u2A10': 'cirfnint',
    '\u2A11': 'awint',
    '\u2A12': 'rppolint',
    '\u2A13': 'scpolint',
    '\u2A14': 'npolint',
    '\u2A15': 'pointint',
    '\u2A16': 'quatint',
    '\u2A17': 'intlarhk',
    '\u2A22': 'pluscir',
    '\u2A23': 'plusacir',
    '\u2A24': 'simplus',
    '\u2A25': 'plusdu',
    '\u2A26': 'plussim',
    '\u2A27': 'plustwo',
    '\u2A29': 'mcomma',
    '\u2A2A': 'minusdu',
    '\u2A2D': 'loplus',
    '\u2A2E': 'roplus',
    '\u2A2F': 'Cross',
    '\u2A30': 'timesd',
    '\u2A31': 'timesbar',
    '\u2A33': 'smashp',
    '\u2A34': 'lotimes',
    '\u2A35': 'rotimes',
    '\u2A36': 'otimesas',
    '\u2A37': 'Otimes',
    '\u2A38': 'odiv',
    '\u2A39': 'triplus',
    '\u2A3A': 'triminus',
    '\u2A3B': 'tritime',
    '\u2A3C': 'iprod',
    '\u2A3F': 'amalg',
    '\u2A40': 'capdot',
    '\u2A42': 'ncup',
    '\u2A43': 'ncap',
    '\u2A44': 'capand',
    '\u2A45': 'cupor',
    '\u2A46': 'cupcap',
    '\u2A47': 'capcup',
    '\u2A48': 'cupbrcap',
    '\u2A49': 'capbrcup',
    '\u2A4A': 'cupcup',
    '\u2A4B': 'capcap',
    '\u2A4C': 'ccups',
    '\u2A4D': 'ccaps',
    '\u2A50': 'ccupssm',
    '\u2A53': 'And',
    '\u2A54': 'Or',
    '\u2A55': 'andand',
    '\u2A56': 'oror',
    '\u2A57': 'orslope',
    '\u2A58': 'andslope',
    '\u2A5A': 'andv',
    '\u2A5B': 'orv',
    '\u2A5C': 'andd',
    '\u2A5D': 'ord',
    '\u2A5F': 'wedbar',
    '\u2A66': 'sdote',
    '\u2A6A': 'simdot',
    '\u2A6D': 'congdot',
    '\u2A6D\u0338': 'ncongdot',
    '\u2A6E': 'easter',
    '\u2A6F': 'apacir',
    '\u2A70': 'apE',
    '\u2A70\u0338': 'napE',
    '\u2A71': 'eplus',
    '\u2A72': 'pluse',
    '\u2A73': 'Esim',
    '\u2A77': 'eDDot',
    '\u2A78': 'equivDD',
    '\u2A79': 'ltcir',
    '\u2A7A': 'gtcir',
    '\u2A7B': 'ltquest',
    '\u2A7C': 'gtquest',
    '\u2A7D': 'les',
    '\u2A7D\u0338': 'nles',
    '\u2A7E': 'ges',
    '\u2A7E\u0338': 'nges',
    '\u2A7F': 'lesdot',
    '\u2A80': 'gesdot',
    '\u2A81': 'lesdoto',
    '\u2A82': 'gesdoto',
    '\u2A83': 'lesdotor',
    '\u2A84': 'gesdotol',
    '\u2A85': 'lap',
    '\u2A86': 'gap',
    '\u2A87': 'lne',
    '\u2A88': 'gne',
    '\u2A89': 'lnap',
    '\u2A8A': 'gnap',
    '\u2A8B': 'lEg',
    '\u2A8C': 'gEl',
    '\u2A8D': 'lsime',
    '\u2A8E': 'gsime',
    '\u2A8F': 'lsimg',
    '\u2A90': 'gsiml',
    '\u2A91': 'lgE',
    '\u2A92': 'glE',
    '\u2A93': 'lesges',
    '\u2A94': 'gesles',
    '\u2A95': 'els',
    '\u2A96': 'egs',
    '\u2A97': 'elsdot',
    '\u2A98': 'egsdot',
    '\u2A99': 'el',
    '\u2A9A': 'eg',
    '\u2A9D': 'siml',
    '\u2A9E': 'simg',
    '\u2A9F': 'simlE',
    '\u2AA0': 'simgE',
    '\u2AA1': 'LessLess',
    '\u2AA1\u0338': 'NotNestedLessLess',
    '\u2AA2': 'GreaterGreater',
    '\u2AA2\u0338': 'NotNestedGreaterGreater',
    '\u2AA4': 'glj',
    '\u2AA5': 'gla',
    '\u2AA6': 'ltcc',
    '\u2AA7': 'gtcc',
    '\u2AA8': 'lescc',
    '\u2AA9': 'gescc',
    '\u2AAA': 'smt',
    '\u2AAB': 'lat',
    '\u2AAC': 'smte',
    '\u2AAC\uFE00': 'smtes',
    '\u2AAD': 'late',
    '\u2AAD\uFE00': 'lates',
    '\u2AAE': 'bumpE',
    '\u2AAF': 'pre',
    '\u2AAF\u0338': 'npre',
    '\u2AB0': 'sce',
    '\u2AB0\u0338': 'nsce',
    '\u2AB3': 'prE',
    '\u2AB4': 'scE',
    '\u2AB5': 'prnE',
    '\u2AB6': 'scnE',
    '\u2AB7': 'prap',
    '\u2AB8': 'scap',
    '\u2AB9': 'prnap',
    '\u2ABA': 'scnap',
    '\u2ABB': 'Pr',
    '\u2ABC': 'Sc',
    '\u2ABD': 'subdot',
    '\u2ABE': 'supdot',
    '\u2ABF': 'subplus',
    '\u2AC0': 'supplus',
    '\u2AC1': 'submult',
    '\u2AC2': 'supmult',
    '\u2AC3': 'subedot',
    '\u2AC4': 'supedot',
    '\u2AC5': 'subE',
    '\u2AC5\u0338': 'nsubE',
    '\u2AC6': 'supE',
    '\u2AC6\u0338': 'nsupE',
    '\u2AC7': 'subsim',
    '\u2AC8': 'supsim',
    '\u2ACB\uFE00': 'vsubnE',
    '\u2ACB': 'subnE',
    '\u2ACC\uFE00': 'vsupnE',
    '\u2ACC': 'supnE',
    '\u2ACF': 'csub',
    '\u2AD0': 'csup',
    '\u2AD1': 'csube',
    '\u2AD2': 'csupe',
    '\u2AD3': 'subsup',
    '\u2AD4': 'supsub',
    '\u2AD5': 'subsub',
    '\u2AD6': 'supsup',
    '\u2AD7': 'suphsub',
    '\u2AD8': 'supdsub',
    '\u2AD9': 'forkv',
    '\u2ADA': 'topfork',
    '\u2ADB': 'mlcp',
    '\u2AE4': 'Dashv',
    '\u2AE6': 'Vdashl',
    '\u2AE7': 'Barv',
    '\u2AE8': 'vBar',
    '\u2AE9': 'vBarv',
    '\u2AEB': 'Vbar',
    '\u2AEC': 'Not',
    '\u2AED': 'bNot',
    '\u2AEE': 'rnmid',
    '\u2AEF': 'cirmid',
    '\u2AF0': 'midcir',
    '\u2AF1': 'topcir',
    '\u2AF2': 'nhpar',
    '\u2AF3': 'parsim',
    '\u2AFD': 'parsl',
    '\u2AFD\u20E5': 'nparsl',
    '\u266D': 'flat',
    '\u266E': 'natur',
    '\u266F': 'sharp',
    '\xA4': 'curren',
    '\xA2': 'cent',
    '$': 'dollar',
    '\xA3': 'pound',
    '\xA5': 'yen',
    '\u20AC': 'euro',
    '\xB9': 'sup1',
    '\xBD': 'half',
    '\u2153': 'frac13',
    '\xBC': 'frac14',
    '\u2155': 'frac15',
    '\u2159': 'frac16',
    '\u215B': 'frac18',
    '\xB2': 'sup2',
    '\u2154': 'frac23',
    '\u2156': 'frac25',
    '\xB3': 'sup3',
    '\xBE': 'frac34',
    '\u2157': 'frac35',
    '\u215C': 'frac38',
    '\u2158': 'frac45',
    '\u215A': 'frac56',
    '\u215D': 'frac58',
    '\u215E': 'frac78',
    '\uD835\uDCB6': 'ascr',
    '\uD835\uDD52': 'aopf',
    '\uD835\uDD1E': 'afr',
    '\uD835\uDD38': 'Aopf',
    '\uD835\uDD04': 'Afr',
    '\uD835\uDC9C': 'Ascr',
    '\xAA': 'ordf',
    '\xE1': 'aacute',
    '\xC1': 'Aacute',
    '\xE0': 'agrave',
    '\xC0': 'Agrave',
    '\u0103': 'abreve',
    '\u0102': 'Abreve',
    '\xE2': 'acirc',
    '\xC2': 'Acirc',
    '\xE5': 'aring',
    '\xC5': 'angst',
    '\xE4': 'auml',
    '\xC4': 'Auml',
    '\xE3': 'atilde',
    '\xC3': 'Atilde',
    '\u0105': 'aogon',
    '\u0104': 'Aogon',
    '\u0101': 'amacr',
    '\u0100': 'Amacr',
    '\xE6': 'aelig',
    '\xC6': 'AElig',
    '\uD835\uDCB7': 'bscr',
    '\uD835\uDD53': 'bopf',
    '\uD835\uDD1F': 'bfr',
    '\uD835\uDD39': 'Bopf',
    '\u212C': 'Bscr',
    '\uD835\uDD05': 'Bfr',
    '\uD835\uDD20': 'cfr',
    '\uD835\uDCB8': 'cscr',
    '\uD835\uDD54': 'copf',
    '\u212D': 'Cfr',
    '\uD835\uDC9E': 'Cscr',
    '\u2102': 'Copf',
    '\u0107': 'cacute',
    '\u0106': 'Cacute',
    '\u0109': 'ccirc',
    '\u0108': 'Ccirc',
    '\u010D': 'ccaron',
    '\u010C': 'Ccaron',
    '\u010B': 'cdot',
    '\u010A': 'Cdot',
    '\xE7': 'ccedil',
    '\xC7': 'Ccedil',
    '\u2105': 'incare',
    '\uD835\uDD21': 'dfr',
    '\u2146': 'dd',
    '\uD835\uDD55': 'dopf',
    '\uD835\uDCB9': 'dscr',
    '\uD835\uDC9F': 'Dscr',
    '\uD835\uDD07': 'Dfr',
    '\u2145': 'DD',
    '\uD835\uDD3B': 'Dopf',
    '\u010F': 'dcaron',
    '\u010E': 'Dcaron',
    '\u0111': 'dstrok',
    '\u0110': 'Dstrok',
    '\xF0': 'eth',
    '\xD0': 'ETH',
    '\u2147': 'ee',
    '\u212F': 'escr',
    '\uD835\uDD22': 'efr',
    '\uD835\uDD56': 'eopf',
    '\u2130': 'Escr',
    '\uD835\uDD08': 'Efr',
    '\uD835\uDD3C': 'Eopf',
    '\xE9': 'eacute',
    '\xC9': 'Eacute',
    '\xE8': 'egrave',
    '\xC8': 'Egrave',
    '\xEA': 'ecirc',
    '\xCA': 'Ecirc',
    '\u011B': 'ecaron',
    '\u011A': 'Ecaron',
    '\xEB': 'euml',
    '\xCB': 'Euml',
    '\u0117': 'edot',
    '\u0116': 'Edot',
    '\u0119': 'eogon',
    '\u0118': 'Eogon',
    '\u0113': 'emacr',
    '\u0112': 'Emacr',
    '\uD835\uDD23': 'ffr',
    '\uD835\uDD57': 'fopf',
    '\uD835\uDCBB': 'fscr',
    '\uD835\uDD09': 'Ffr',
    '\uD835\uDD3D': 'Fopf',
    '\u2131': 'Fscr',
    '\uFB00': 'fflig',
    '\uFB03': 'ffilig',
    '\uFB04': 'ffllig',
    '\uFB01': 'filig',
    'fj': 'fjlig',
    '\uFB02': 'fllig',
    '\u0192': 'fnof',
    '\u210A': 'gscr',
    '\uD835\uDD58': 'gopf',
    '\uD835\uDD24': 'gfr',
    '\uD835\uDCA2': 'Gscr',
    '\uD835\uDD3E': 'Gopf',
    '\uD835\uDD0A': 'Gfr',
    '\u01F5': 'gacute',
    '\u011F': 'gbreve',
    '\u011E': 'Gbreve',
    '\u011D': 'gcirc',
    '\u011C': 'Gcirc',
    '\u0121': 'gdot',
    '\u0120': 'Gdot',
    '\u0122': 'Gcedil',
    '\uD835\uDD25': 'hfr',
    '\u210E': 'planckh',
    '\uD835\uDCBD': 'hscr',
    '\uD835\uDD59': 'hopf',
    '\u210B': 'Hscr',
    '\u210C': 'Hfr',
    '\u210D': 'Hopf',
    '\u0125': 'hcirc',
    '\u0124': 'Hcirc',
    '\u210F': 'hbar',
    '\u0127': 'hstrok',
    '\u0126': 'Hstrok',
    '\uD835\uDD5A': 'iopf',
    '\uD835\uDD26': 'ifr',
    '\uD835\uDCBE': 'iscr',
    '\u2148': 'ii',
    '\uD835\uDD40': 'Iopf',
    '\u2110': 'Iscr',
    '\u2111': 'Im',
    '\xED': 'iacute',
    '\xCD': 'Iacute',
    '\xEC': 'igrave',
    '\xCC': 'Igrave',
    '\xEE': 'icirc',
    '\xCE': 'Icirc',
    '\xEF': 'iuml',
    '\xCF': 'Iuml',
    '\u0129': 'itilde',
    '\u0128': 'Itilde',
    '\u0130': 'Idot',
    '\u012F': 'iogon',
    '\u012E': 'Iogon',
    '\u012B': 'imacr',
    '\u012A': 'Imacr',
    '\u0133': 'ijlig',
    '\u0132': 'IJlig',
    '\u0131': 'imath',
    '\uD835\uDCBF': 'jscr',
    '\uD835\uDD5B': 'jopf',
    '\uD835\uDD27': 'jfr',
    '\uD835\uDCA5': 'Jscr',
    '\uD835\uDD0D': 'Jfr',
    '\uD835\uDD41': 'Jopf',
    '\u0135': 'jcirc',
    '\u0134': 'Jcirc',
    '\u0237': 'jmath',
    '\uD835\uDD5C': 'kopf',
    '\uD835\uDCC0': 'kscr',
    '\uD835\uDD28': 'kfr',
    '\uD835\uDCA6': 'Kscr',
    '\uD835\uDD42': 'Kopf',
    '\uD835\uDD0E': 'Kfr',
    '\u0137': 'kcedil',
    '\u0136': 'Kcedil',
    '\uD835\uDD29': 'lfr',
    '\uD835\uDCC1': 'lscr',
    '\u2113': 'ell',
    '\uD835\uDD5D': 'lopf',
    '\u2112': 'Lscr',
    '\uD835\uDD0F': 'Lfr',
    '\uD835\uDD43': 'Lopf',
    '\u013A': 'lacute',
    '\u0139': 'Lacute',
    '\u013E': 'lcaron',
    '\u013D': 'Lcaron',
    '\u013C': 'lcedil',
    '\u013B': 'Lcedil',
    '\u0142': 'lstrok',
    '\u0141': 'Lstrok',
    '\u0140': 'lmidot',
    '\u013F': 'Lmidot',
    '\uD835\uDD2A': 'mfr',
    '\uD835\uDD5E': 'mopf',
    '\uD835\uDCC2': 'mscr',
    '\uD835\uDD10': 'Mfr',
    '\uD835\uDD44': 'Mopf',
    '\u2133': 'Mscr',
    '\uD835\uDD2B': 'nfr',
    '\uD835\uDD5F': 'nopf',
    '\uD835\uDCC3': 'nscr',
    '\u2115': 'Nopf',
    '\uD835\uDCA9': 'Nscr',
    '\uD835\uDD11': 'Nfr',
    '\u0144': 'nacute',
    '\u0143': 'Nacute',
    '\u0148': 'ncaron',
    '\u0147': 'Ncaron',
    '\xF1': 'ntilde',
    '\xD1': 'Ntilde',
    '\u0146': 'ncedil',
    '\u0145': 'Ncedil',
    '\u2116': 'numero',
    '\u014B': 'eng',
    '\u014A': 'ENG',
    '\uD835\uDD60': 'oopf',
    '\uD835\uDD2C': 'ofr',
    '\u2134': 'oscr',
    '\uD835\uDCAA': 'Oscr',
    '\uD835\uDD12': 'Ofr',
    '\uD835\uDD46': 'Oopf',
    '\xBA': 'ordm',
    '\xF3': 'oacute',
    '\xD3': 'Oacute',
    '\xF2': 'ograve',
    '\xD2': 'Ograve',
    '\xF4': 'ocirc',
    '\xD4': 'Ocirc',
    '\xF6': 'ouml',
    '\xD6': 'Ouml',
    '\u0151': 'odblac',
    '\u0150': 'Odblac',
    '\xF5': 'otilde',
    '\xD5': 'Otilde',
    '\xF8': 'oslash',
    '\xD8': 'Oslash',
    '\u014D': 'omacr',
    '\u014C': 'Omacr',
    '\u0153': 'oelig',
    '\u0152': 'OElig',
    '\uD835\uDD2D': 'pfr',
    '\uD835\uDCC5': 'pscr',
    '\uD835\uDD61': 'popf',
    '\u2119': 'Popf',
    '\uD835\uDD13': 'Pfr',
    '\uD835\uDCAB': 'Pscr',
    '\uD835\uDD62': 'qopf',
    '\uD835\uDD2E': 'qfr',
    '\uD835\uDCC6': 'qscr',
    '\uD835\uDCAC': 'Qscr',
    '\uD835\uDD14': 'Qfr',
    '\u211A': 'Qopf',
    '\u0138': 'kgreen',
    '\uD835\uDD2F': 'rfr',
    '\uD835\uDD63': 'ropf',
    '\uD835\uDCC7': 'rscr',
    '\u211B': 'Rscr',
    '\u211C': 'Re',
    '\u211D': 'Ropf',
    '\u0155': 'racute',
    '\u0154': 'Racute',
    '\u0159': 'rcaron',
    '\u0158': 'Rcaron',
    '\u0157': 'rcedil',
    '\u0156': 'Rcedil',
    '\uD835\uDD64': 'sopf',
    '\uD835\uDCC8': 'sscr',
    '\uD835\uDD30': 'sfr',
    '\uD835\uDD4A': 'Sopf',
    '\uD835\uDD16': 'Sfr',
    '\uD835\uDCAE': 'Sscr',
    '\u24C8': 'oS',
    '\u015B': 'sacute',
    '\u015A': 'Sacute',
    '\u015D': 'scirc',
    '\u015C': 'Scirc',
    '\u0161': 'scaron',
    '\u0160': 'Scaron',
    '\u015F': 'scedil',
    '\u015E': 'Scedil',
    '\xDF': 'szlig',
    '\uD835\uDD31': 'tfr',
    '\uD835\uDCC9': 'tscr',
    '\uD835\uDD65': 'topf',
    '\uD835\uDCAF': 'Tscr',
    '\uD835\uDD17': 'Tfr',
    '\uD835\uDD4B': 'Topf',
    '\u0165': 'tcaron',
    '\u0164': 'Tcaron',
    '\u0163': 'tcedil',
    '\u0162': 'Tcedil',
    '\u2122': 'trade',
    '\u0167': 'tstrok',
    '\u0166': 'Tstrok',
    '\uD835\uDCCA': 'uscr',
    '\uD835\uDD66': 'uopf',
    '\uD835\uDD32': 'ufr',
    '\uD835\uDD4C': 'Uopf',
    '\uD835\uDD18': 'Ufr',
    '\uD835\uDCB0': 'Uscr',
    '\xFA': 'uacute',
    '\xDA': 'Uacute',
    '\xF9': 'ugrave',
    '\xD9': 'Ugrave',
    '\u016D': 'ubreve',
    '\u016C': 'Ubreve',
    '\xFB': 'ucirc',
    '\xDB': 'Ucirc',
    '\u016F': 'uring',
    '\u016E': 'Uring',
    '\xFC': 'uuml',
    '\xDC': 'Uuml',
    '\u0171': 'udblac',
    '\u0170': 'Udblac',
    '\u0169': 'utilde',
    '\u0168': 'Utilde',
    '\u0173': 'uogon',
    '\u0172': 'Uogon',
    '\u016B': 'umacr',
    '\u016A': 'Umacr',
    '\uD835\uDD33': 'vfr',
    '\uD835\uDD67': 'vopf',
    '\uD835\uDCCB': 'vscr',
    '\uD835\uDD19': 'Vfr',
    '\uD835\uDD4D': 'Vopf',
    '\uD835\uDCB1': 'Vscr',
    '\uD835\uDD68': 'wopf',
    '\uD835\uDCCC': 'wscr',
    '\uD835\uDD34': 'wfr',
    '\uD835\uDCB2': 'Wscr',
    '\uD835\uDD4E': 'Wopf',
    '\uD835\uDD1A': 'Wfr',
    '\u0175': 'wcirc',
    '\u0174': 'Wcirc',
    '\uD835\uDD35': 'xfr',
    '\uD835\uDCCD': 'xscr',
    '\uD835\uDD69': 'xopf',
    '\uD835\uDD4F': 'Xopf',
    '\uD835\uDD1B': 'Xfr',
    '\uD835\uDCB3': 'Xscr',
    '\uD835\uDD36': 'yfr',
    '\uD835\uDCCE': 'yscr',
    '\uD835\uDD6A': 'yopf',
    '\uD835\uDCB4': 'Yscr',
    '\uD835\uDD1C': 'Yfr',
    '\uD835\uDD50': 'Yopf',
    '\xFD': 'yacute',
    '\xDD': 'Yacute',
    '\u0177': 'ycirc',
    '\u0176': 'Ycirc',
    '\xFF': 'yuml',
    '\u0178': 'Yuml',
    '\uD835\uDCCF': 'zscr',
    '\uD835\uDD37': 'zfr',
    '\uD835\uDD6B': 'zopf',
    '\u2128': 'Zfr',
    '\u2124': 'Zopf',
    '\uD835\uDCB5': 'Zscr',
    '\u017A': 'zacute',
    '\u0179': 'Zacute',
    '\u017E': 'zcaron',
    '\u017D': 'Zcaron',
    '\u017C': 'zdot',
    '\u017B': 'Zdot',
    '\u01B5': 'imped',
    '\xFE': 'thorn',
    '\xDE': 'THORN',
    '\u0149': 'napos',
    '\u03B1': 'alpha',
    '\u0391': 'Alpha',
    '\u03B2': 'beta',
    '\u0392': 'Beta',
    '\u03B3': 'gamma',
    '\u0393': 'Gamma',
    '\u03B4': 'delta',
    '\u0394': 'Delta',
    '\u03B5': 'epsi',
    '\u03F5': 'epsiv',
    '\u0395': 'Epsilon',
    '\u03DD': 'gammad',
    '\u03DC': 'Gammad',
    '\u03B6': 'zeta',
    '\u0396': 'Zeta',
    '\u03B7': 'eta',
    '\u0397': 'Eta',
    '\u03B8': 'theta',
    '\u03D1': 'thetav',
    '\u0398': 'Theta',
    '\u03B9': 'iota',
    '\u0399': 'Iota',
    '\u03BA': 'kappa',
    '\u03F0': 'kappav',
    '\u039A': 'Kappa',
    '\u03BB': 'lambda',
    '\u039B': 'Lambda',
    '\u03BC': 'mu',
    '\xB5': 'micro',
    '\u039C': 'Mu',
    '\u03BD': 'nu',
    '\u039D': 'Nu',
    '\u03BE': 'xi',
    '\u039E': 'Xi',
    '\u03BF': 'omicron',
    '\u039F': 'Omicron',
    '\u03C0': 'pi',
    '\u03D6': 'piv',
    '\u03A0': 'Pi',
    '\u03C1': 'rho',
    '\u03F1': 'rhov',
    '\u03A1': 'Rho',
    '\u03C3': 'sigma',
    '\u03A3': 'Sigma',
    '\u03C2': 'sigmaf',
    '\u03C4': 'tau',
    '\u03A4': 'Tau',
    '\u03C5': 'upsi',
    '\u03A5': 'Upsilon',
    '\u03D2': 'Upsi',
    '\u03C6': 'phi',
    '\u03D5': 'phiv',
    '\u03A6': 'Phi',
    '\u03C7': 'chi',
    '\u03A7': 'Chi',
    '\u03C8': 'psi',
    '\u03A8': 'Psi',
    '\u03C9': 'omega',
    '\u03A9': 'ohm',
    '\u0430': 'acy',
    '\u0410': 'Acy',
    '\u0431': 'bcy',
    '\u0411': 'Bcy',
    '\u0432': 'vcy',
    '\u0412': 'Vcy',
    '\u0433': 'gcy',
    '\u0413': 'Gcy',
    '\u0453': 'gjcy',
    '\u0403': 'GJcy',
    '\u0434': 'dcy',
    '\u0414': 'Dcy',
    '\u0452': 'djcy',
    '\u0402': 'DJcy',
    '\u0435': 'iecy',
    '\u0415': 'IEcy',
    '\u0451': 'iocy',
    '\u0401': 'IOcy',
    '\u0454': 'jukcy',
    '\u0404': 'Jukcy',
    '\u0436': 'zhcy',
    '\u0416': 'ZHcy',
    '\u0437': 'zcy',
    '\u0417': 'Zcy',
    '\u0455': 'dscy',
    '\u0405': 'DScy',
    '\u0438': 'icy',
    '\u0418': 'Icy',
    '\u0456': 'iukcy',
    '\u0406': 'Iukcy',
    '\u0457': 'yicy',
    '\u0407': 'YIcy',
    '\u0439': 'jcy',
    '\u0419': 'Jcy',
    '\u0458': 'jsercy',
    '\u0408': 'Jsercy',
    '\u043A': 'kcy',
    '\u041A': 'Kcy',
    '\u045C': 'kjcy',
    '\u040C': 'KJcy',
    '\u043B': 'lcy',
    '\u041B': 'Lcy',
    '\u0459': 'ljcy',
    '\u0409': 'LJcy',
    '\u043C': 'mcy',
    '\u041C': 'Mcy',
    '\u043D': 'ncy',
    '\u041D': 'Ncy',
    '\u045A': 'njcy',
    '\u040A': 'NJcy',
    '\u043E': 'ocy',
    '\u041E': 'Ocy',
    '\u043F': 'pcy',
    '\u041F': 'Pcy',
    '\u0440': 'rcy',
    '\u0420': 'Rcy',
    '\u0441': 'scy',
    '\u0421': 'Scy',
    '\u0442': 'tcy',
    '\u0422': 'Tcy',
    '\u045B': 'tshcy',
    '\u040B': 'TSHcy',
    '\u0443': 'ucy',
    '\u0423': 'Ucy',
    '\u045E': 'ubrcy',
    '\u040E': 'Ubrcy',
    '\u0444': 'fcy',
    '\u0424': 'Fcy',
    '\u0445': 'khcy',
    '\u0425': 'KHcy',
    '\u0446': 'tscy',
    '\u0426': 'TScy',
    '\u0447': 'chcy',
    '\u0427': 'CHcy',
    '\u045F': 'dzcy',
    '\u040F': 'DZcy',
    '\u0448': 'shcy',
    '\u0428': 'SHcy',
    '\u0449': 'shchcy',
    '\u0429': 'SHCHcy',
    '\u044A': 'hardcy',
    '\u042A': 'HARDcy',
    '\u044B': 'ycy',
    '\u042B': 'Ycy',
    '\u044C': 'softcy',
    '\u042C': 'SOFTcy',
    '\u044D': 'ecy',
    '\u042D': 'Ecy',
    '\u044E': 'yucy',
    '\u042E': 'YUcy',
    '\u044F': 'yacy',
    '\u042F': 'YAcy',
    '\u2135': 'aleph',
    '\u2136': 'beth',
    '\u2137': 'gimel',
    '\u2138': 'daleth'
  };
  var regexEscape = /["&'<>`]/g;
  var escapeMap = {
    '"': '&quot;',
    '&': '&amp;',
    '\'': '&#x27;',
    '<': '&lt;',
    // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
    // following is not strictly necessary unless it’s part of a tag or an
    // unquoted attribute value. We’re only escaping it to support those
    // situations, and for XML support.
    '>': '&gt;',
    // In Internet Explorer ≤ 8, the backtick character can be used
    // to break out of (un)quoted attribute values or HTML comments.
    // See http://html5sec.org/#102, http://html5sec.org/#108, and
    // http://html5sec.org/#133.
    '`': '&#x60;'
  };
  var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
  var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
  var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
  var decodeMap = {
    'aacute': '\xE1',
    'Aacute': '\xC1',
    'abreve': '\u0103',
    'Abreve': '\u0102',
    'ac': '\u223E',
    'acd': '\u223F',
    'acE': '\u223E\u0333',
    'acirc': '\xE2',
    'Acirc': '\xC2',
    'acute': '\xB4',
    'acy': '\u0430',
    'Acy': '\u0410',
    'aelig': '\xE6',
    'AElig': '\xC6',
    'af': '\u2061',
    'afr': '\uD835\uDD1E',
    'Afr': '\uD835\uDD04',
    'agrave': '\xE0',
    'Agrave': '\xC0',
    'alefsym': '\u2135',
    'aleph': '\u2135',
    'alpha': '\u03B1',
    'Alpha': '\u0391',
    'amacr': '\u0101',
    'Amacr': '\u0100',
    'amalg': '\u2A3F',
    'amp': '&',
    'AMP': '&',
    'and': '\u2227',
    'And': '\u2A53',
    'andand': '\u2A55',
    'andd': '\u2A5C',
    'andslope': '\u2A58',
    'andv': '\u2A5A',
    'ang': '\u2220',
    'ange': '\u29A4',
    'angle': '\u2220',
    'angmsd': '\u2221',
    'angmsdaa': '\u29A8',
    'angmsdab': '\u29A9',
    'angmsdac': '\u29AA',
    'angmsdad': '\u29AB',
    'angmsdae': '\u29AC',
    'angmsdaf': '\u29AD',
    'angmsdag': '\u29AE',
    'angmsdah': '\u29AF',
    'angrt': '\u221F',
    'angrtvb': '\u22BE',
    'angrtvbd': '\u299D',
    'angsph': '\u2222',
    'angst': '\xC5',
    'angzarr': '\u237C',
    'aogon': '\u0105',
    'Aogon': '\u0104',
    'aopf': '\uD835\uDD52',
    'Aopf': '\uD835\uDD38',
    'ap': '\u2248',
    'apacir': '\u2A6F',
    'ape': '\u224A',
    'apE': '\u2A70',
    'apid': '\u224B',
    'apos': '\'',
    'ApplyFunction': '\u2061',
    'approx': '\u2248',
    'approxeq': '\u224A',
    'aring': '\xE5',
    'Aring': '\xC5',
    'ascr': '\uD835\uDCB6',
    'Ascr': '\uD835\uDC9C',
    'Assign': '\u2254',
    'ast': '*',
    'asymp': '\u2248',
    'asympeq': '\u224D',
    'atilde': '\xE3',
    'Atilde': '\xC3',
    'auml': '\xE4',
    'Auml': '\xC4',
    'awconint': '\u2233',
    'awint': '\u2A11',
    'backcong': '\u224C',
    'backepsilon': '\u03F6',
    'backprime': '\u2035',
    'backsim': '\u223D',
    'backsimeq': '\u22CD',
    'Backslash': '\u2216',
    'Barv': '\u2AE7',
    'barvee': '\u22BD',
    'barwed': '\u2305',
    'Barwed': '\u2306',
    'barwedge': '\u2305',
    'bbrk': '\u23B5',
    'bbrktbrk': '\u23B6',
    'bcong': '\u224C',
    'bcy': '\u0431',
    'Bcy': '\u0411',
    'bdquo': '\u201E',
    'becaus': '\u2235',
    'because': '\u2235',
    'Because': '\u2235',
    'bemptyv': '\u29B0',
    'bepsi': '\u03F6',
    'bernou': '\u212C',
    'Bernoullis': '\u212C',
    'beta': '\u03B2',
    'Beta': '\u0392',
    'beth': '\u2136',
    'between': '\u226C',
    'bfr': '\uD835\uDD1F',
    'Bfr': '\uD835\uDD05',
    'bigcap': '\u22C2',
    'bigcirc': '\u25EF',
    'bigcup': '\u22C3',
    'bigodot': '\u2A00',
    'bigoplus': '\u2A01',
    'bigotimes': '\u2A02',
    'bigsqcup': '\u2A06',
    'bigstar': '\u2605',
    'bigtriangledown': '\u25BD',
    'bigtriangleup': '\u25B3',
    'biguplus': '\u2A04',
    'bigvee': '\u22C1',
    'bigwedge': '\u22C0',
    'bkarow': '\u290D',
    'blacklozenge': '\u29EB',
    'blacksquare': '\u25AA',
    'blacktriangle': '\u25B4',
    'blacktriangledown': '\u25BE',
    'blacktriangleleft': '\u25C2',
    'blacktriangleright': '\u25B8',
    'blank': '\u2423',
    'blk12': '\u2592',
    'blk14': '\u2591',
    'blk34': '\u2593',
    'block': '\u2588',
    'bne': '=\u20E5',
    'bnequiv': '\u2261\u20E5',
    'bnot': '\u2310',
    'bNot': '\u2AED',
    'bopf': '\uD835\uDD53',
    'Bopf': '\uD835\uDD39',
    'bot': '\u22A5',
    'bottom': '\u22A5',
    'bowtie': '\u22C8',
    'boxbox': '\u29C9',
    'boxdl': '\u2510',
    'boxdL': '\u2555',
    'boxDl': '\u2556',
    'boxDL': '\u2557',
    'boxdr': '\u250C',
    'boxdR': '\u2552',
    'boxDr': '\u2553',
    'boxDR': '\u2554',
    'boxh': '\u2500',
    'boxH': '\u2550',
    'boxhd': '\u252C',
    'boxhD': '\u2565',
    'boxHd': '\u2564',
    'boxHD': '\u2566',
    'boxhu': '\u2534',
    'boxhU': '\u2568',
    'boxHu': '\u2567',
    'boxHU': '\u2569',
    'boxminus': '\u229F',
    'boxplus': '\u229E',
    'boxtimes': '\u22A0',
    'boxul': '\u2518',
    'boxuL': '\u255B',
    'boxUl': '\u255C',
    'boxUL': '\u255D',
    'boxur': '\u2514',
    'boxuR': '\u2558',
    'boxUr': '\u2559',
    'boxUR': '\u255A',
    'boxv': '\u2502',
    'boxV': '\u2551',
    'boxvh': '\u253C',
    'boxvH': '\u256A',
    'boxVh': '\u256B',
    'boxVH': '\u256C',
    'boxvl': '\u2524',
    'boxvL': '\u2561',
    'boxVl': '\u2562',
    'boxVL': '\u2563',
    'boxvr': '\u251C',
    'boxvR': '\u255E',
    'boxVr': '\u255F',
    'boxVR': '\u2560',
    'bprime': '\u2035',
    'breve': '\u02D8',
    'Breve': '\u02D8',
    'brvbar': '\xA6',
    'bscr': '\uD835\uDCB7',
    'Bscr': '\u212C',
    'bsemi': '\u204F',
    'bsim': '\u223D',
    'bsime': '\u22CD',
    'bsol': '\\',
    'bsolb': '\u29C5',
    'bsolhsub': '\u27C8',
    'bull': '\u2022',
    'bullet': '\u2022',
    'bump': '\u224E',
    'bumpe': '\u224F',
    'bumpE': '\u2AAE',
    'bumpeq': '\u224F',
    'Bumpeq': '\u224E',
    'cacute': '\u0107',
    'Cacute': '\u0106',
    'cap': '\u2229',
    'Cap': '\u22D2',
    'capand': '\u2A44',
    'capbrcup': '\u2A49',
    'capcap': '\u2A4B',
    'capcup': '\u2A47',
    'capdot': '\u2A40',
    'CapitalDifferentialD': '\u2145',
    'caps': '\u2229\uFE00',
    'caret': '\u2041',
    'caron': '\u02C7',
    'Cayleys': '\u212D',
    'ccaps': '\u2A4D',
    'ccaron': '\u010D',
    'Ccaron': '\u010C',
    'ccedil': '\xE7',
    'Ccedil': '\xC7',
    'ccirc': '\u0109',
    'Ccirc': '\u0108',
    'Cconint': '\u2230',
    'ccups': '\u2A4C',
    'ccupssm': '\u2A50',
    'cdot': '\u010B',
    'Cdot': '\u010A',
    'cedil': '\xB8',
    'Cedilla': '\xB8',
    'cemptyv': '\u29B2',
    'cent': '\xA2',
    'centerdot': '\xB7',
    'CenterDot': '\xB7',
    'cfr': '\uD835\uDD20',
    'Cfr': '\u212D',
    'chcy': '\u0447',
    'CHcy': '\u0427',
    'check': '\u2713',
    'checkmark': '\u2713',
    'chi': '\u03C7',
    'Chi': '\u03A7',
    'cir': '\u25CB',
    'circ': '\u02C6',
    'circeq': '\u2257',
    'circlearrowleft': '\u21BA',
    'circlearrowright': '\u21BB',
    'circledast': '\u229B',
    'circledcirc': '\u229A',
    'circleddash': '\u229D',
    'CircleDot': '\u2299',
    'circledR': '\xAE',
    'circledS': '\u24C8',
    'CircleMinus': '\u2296',
    'CirclePlus': '\u2295',
    'CircleTimes': '\u2297',
    'cire': '\u2257',
    'cirE': '\u29C3',
    'cirfnint': '\u2A10',
    'cirmid': '\u2AEF',
    'cirscir': '\u29C2',
    'ClockwiseContourIntegral': '\u2232',
    'CloseCurlyDoubleQuote': '\u201D',
    'CloseCurlyQuote': '\u2019',
    'clubs': '\u2663',
    'clubsuit': '\u2663',
    'colon': ':',
    'Colon': '\u2237',
    'colone': '\u2254',
    'Colone': '\u2A74',
    'coloneq': '\u2254',
    'comma': ',',
    'commat': '@',
    'comp': '\u2201',
    'compfn': '\u2218',
    'complement': '\u2201',
    'complexes': '\u2102',
    'cong': '\u2245',
    'congdot': '\u2A6D',
    'Congruent': '\u2261',
    'conint': '\u222E',
    'Conint': '\u222F',
    'ContourIntegral': '\u222E',
    'copf': '\uD835\uDD54',
    'Copf': '\u2102',
    'coprod': '\u2210',
    'Coproduct': '\u2210',
    'copy': '\xA9',
    'COPY': '\xA9',
    'copysr': '\u2117',
    'CounterClockwiseContourIntegral': '\u2233',
    'crarr': '\u21B5',
    'cross': '\u2717',
    'Cross': '\u2A2F',
    'cscr': '\uD835\uDCB8',
    'Cscr': '\uD835\uDC9E',
    'csub': '\u2ACF',
    'csube': '\u2AD1',
    'csup': '\u2AD0',
    'csupe': '\u2AD2',
    'ctdot': '\u22EF',
    'cudarrl': '\u2938',
    'cudarrr': '\u2935',
    'cuepr': '\u22DE',
    'cuesc': '\u22DF',
    'cularr': '\u21B6',
    'cularrp': '\u293D',
    'cup': '\u222A',
    'Cup': '\u22D3',
    'cupbrcap': '\u2A48',
    'cupcap': '\u2A46',
    'CupCap': '\u224D',
    'cupcup': '\u2A4A',
    'cupdot': '\u228D',
    'cupor': '\u2A45',
    'cups': '\u222A\uFE00',
    'curarr': '\u21B7',
    'curarrm': '\u293C',
    'curlyeqprec': '\u22DE',
    'curlyeqsucc': '\u22DF',
    'curlyvee': '\u22CE',
    'curlywedge': '\u22CF',
    'curren': '\xA4',
    'curvearrowleft': '\u21B6',
    'curvearrowright': '\u21B7',
    'cuvee': '\u22CE',
    'cuwed': '\u22CF',
    'cwconint': '\u2232',
    'cwint': '\u2231',
    'cylcty': '\u232D',
    'dagger': '\u2020',
    'Dagger': '\u2021',
    'daleth': '\u2138',
    'darr': '\u2193',
    'dArr': '\u21D3',
    'Darr': '\u21A1',
    'dash': '\u2010',
    'dashv': '\u22A3',
    'Dashv': '\u2AE4',
    'dbkarow': '\u290F',
    'dblac': '\u02DD',
    'dcaron': '\u010F',
    'Dcaron': '\u010E',
    'dcy': '\u0434',
    'Dcy': '\u0414',
    'dd': '\u2146',
    'DD': '\u2145',
    'ddagger': '\u2021',
    'ddarr': '\u21CA',
    'DDotrahd': '\u2911',
    'ddotseq': '\u2A77',
    'deg': '\xB0',
    'Del': '\u2207',
    'delta': '\u03B4',
    'Delta': '\u0394',
    'demptyv': '\u29B1',
    'dfisht': '\u297F',
    'dfr': '\uD835\uDD21',
    'Dfr': '\uD835\uDD07',
    'dHar': '\u2965',
    'dharl': '\u21C3',
    'dharr': '\u21C2',
    'DiacriticalAcute': '\xB4',
    'DiacriticalDot': '\u02D9',
    'DiacriticalDoubleAcute': '\u02DD',
    'DiacriticalGrave': '`',
    'DiacriticalTilde': '\u02DC',
    'diam': '\u22C4',
    'diamond': '\u22C4',
    'Diamond': '\u22C4',
    'diamondsuit': '\u2666',
    'diams': '\u2666',
    'die': '\xA8',
    'DifferentialD': '\u2146',
    'digamma': '\u03DD',
    'disin': '\u22F2',
    'div': '\xF7',
    'divide': '\xF7',
    'divideontimes': '\u22C7',
    'divonx': '\u22C7',
    'djcy': '\u0452',
    'DJcy': '\u0402',
    'dlcorn': '\u231E',
    'dlcrop': '\u230D',
    'dollar': '$',
    'dopf': '\uD835\uDD55',
    'Dopf': '\uD835\uDD3B',
    'dot': '\u02D9',
    'Dot': '\xA8',
    'DotDot': '\u20DC',
    'doteq': '\u2250',
    'doteqdot': '\u2251',
    'DotEqual': '\u2250',
    'dotminus': '\u2238',
    'dotplus': '\u2214',
    'dotsquare': '\u22A1',
    'doublebarwedge': '\u2306',
    'DoubleContourIntegral': '\u222F',
    'DoubleDot': '\xA8',
    'DoubleDownArrow': '\u21D3',
    'DoubleLeftArrow': '\u21D0',
    'DoubleLeftRightArrow': '\u21D4',
    'DoubleLeftTee': '\u2AE4',
    'DoubleLongLeftArrow': '\u27F8',
    'DoubleLongLeftRightArrow': '\u27FA',
    'DoubleLongRightArrow': '\u27F9',
    'DoubleRightArrow': '\u21D2',
    'DoubleRightTee': '\u22A8',
    'DoubleUpArrow': '\u21D1',
    'DoubleUpDownArrow': '\u21D5',
    'DoubleVerticalBar': '\u2225',
    'downarrow': '\u2193',
    'Downarrow': '\u21D3',
    'DownArrow': '\u2193',
    'DownArrowBar': '\u2913',
    'DownArrowUpArrow': '\u21F5',
    'DownBreve': '\u0311',
    'downdownarrows': '\u21CA',
    'downharpoonleft': '\u21C3',
    'downharpoonright': '\u21C2',
    'DownLeftRightVector': '\u2950',
    'DownLeftTeeVector': '\u295E',
    'DownLeftVector': '\u21BD',
    'DownLeftVectorBar': '\u2956',
    'DownRightTeeVector': '\u295F',
    'DownRightVector': '\u21C1',
    'DownRightVectorBar': '\u2957',
    'DownTee': '\u22A4',
    'DownTeeArrow': '\u21A7',
    'drbkarow': '\u2910',
    'drcorn': '\u231F',
    'drcrop': '\u230C',
    'dscr': '\uD835\uDCB9',
    'Dscr': '\uD835\uDC9F',
    'dscy': '\u0455',
    'DScy': '\u0405',
    'dsol': '\u29F6',
    'dstrok': '\u0111',
    'Dstrok': '\u0110',
    'dtdot': '\u22F1',
    'dtri': '\u25BF',
    'dtrif': '\u25BE',
    'duarr': '\u21F5',
    'duhar': '\u296F',
    'dwangle': '\u29A6',
    'dzcy': '\u045F',
    'DZcy': '\u040F',
    'dzigrarr': '\u27FF',
    'eacute': '\xE9',
    'Eacute': '\xC9',
    'easter': '\u2A6E',
    'ecaron': '\u011B',
    'Ecaron': '\u011A',
    'ecir': '\u2256',
    'ecirc': '\xEA',
    'Ecirc': '\xCA',
    'ecolon': '\u2255',
    'ecy': '\u044D',
    'Ecy': '\u042D',
    'eDDot': '\u2A77',
    'edot': '\u0117',
    'eDot': '\u2251',
    'Edot': '\u0116',
    'ee': '\u2147',
    'efDot': '\u2252',
    'efr': '\uD835\uDD22',
    'Efr': '\uD835\uDD08',
    'eg': '\u2A9A',
    'egrave': '\xE8',
    'Egrave': '\xC8',
    'egs': '\u2A96',
    'egsdot': '\u2A98',
    'el': '\u2A99',
    'Element': '\u2208',
    'elinters': '\u23E7',
    'ell': '\u2113',
    'els': '\u2A95',
    'elsdot': '\u2A97',
    'emacr': '\u0113',
    'Emacr': '\u0112',
    'empty': '\u2205',
    'emptyset': '\u2205',
    'EmptySmallSquare': '\u25FB',
    'emptyv': '\u2205',
    'EmptyVerySmallSquare': '\u25AB',
    'emsp': '\u2003',
    'emsp13': '\u2004',
    'emsp14': '\u2005',
    'eng': '\u014B',
    'ENG': '\u014A',
    'ensp': '\u2002',
    'eogon': '\u0119',
    'Eogon': '\u0118',
    'eopf': '\uD835\uDD56',
    'Eopf': '\uD835\uDD3C',
    'epar': '\u22D5',
    'eparsl': '\u29E3',
    'eplus': '\u2A71',
    'epsi': '\u03B5',
    'epsilon': '\u03B5',
    'Epsilon': '\u0395',
    'epsiv': '\u03F5',
    'eqcirc': '\u2256',
    'eqcolon': '\u2255',
    'eqsim': '\u2242',
    'eqslantgtr': '\u2A96',
    'eqslantless': '\u2A95',
    'Equal': '\u2A75',
    'equals': '=',
    'EqualTilde': '\u2242',
    'equest': '\u225F',
    'Equilibrium': '\u21CC',
    'equiv': '\u2261',
    'equivDD': '\u2A78',
    'eqvparsl': '\u29E5',
    'erarr': '\u2971',
    'erDot': '\u2253',
    'escr': '\u212F',
    'Escr': '\u2130',
    'esdot': '\u2250',
    'esim': '\u2242',
    'Esim': '\u2A73',
    'eta': '\u03B7',
    'Eta': '\u0397',
    'eth': '\xF0',
    'ETH': '\xD0',
    'euml': '\xEB',
    'Euml': '\xCB',
    'euro': '\u20AC',
    'excl': '!',
    'exist': '\u2203',
    'Exists': '\u2203',
    'expectation': '\u2130',
    'exponentiale': '\u2147',
    'ExponentialE': '\u2147',
    'fallingdotseq': '\u2252',
    'fcy': '\u0444',
    'Fcy': '\u0424',
    'female': '\u2640',
    'ffilig': '\uFB03',
    'fflig': '\uFB00',
    'ffllig': '\uFB04',
    'ffr': '\uD835\uDD23',
    'Ffr': '\uD835\uDD09',
    'filig': '\uFB01',
    'FilledSmallSquare': '\u25FC',
    'FilledVerySmallSquare': '\u25AA',
    'fjlig': 'fj',
    'flat': '\u266D',
    'fllig': '\uFB02',
    'fltns': '\u25B1',
    'fnof': '\u0192',
    'fopf': '\uD835\uDD57',
    'Fopf': '\uD835\uDD3D',
    'forall': '\u2200',
    'ForAll': '\u2200',
    'fork': '\u22D4',
    'forkv': '\u2AD9',
    'Fouriertrf': '\u2131',
    'fpartint': '\u2A0D',
    'frac12': '\xBD',
    'frac13': '\u2153',
    'frac14': '\xBC',
    'frac15': '\u2155',
    'frac16': '\u2159',
    'frac18': '\u215B',
    'frac23': '\u2154',
    'frac25': '\u2156',
    'frac34': '\xBE',
    'frac35': '\u2157',
    'frac38': '\u215C',
    'frac45': '\u2158',
    'frac56': '\u215A',
    'frac58': '\u215D',
    'frac78': '\u215E',
    'frasl': '\u2044',
    'frown': '\u2322',
    'fscr': '\uD835\uDCBB',
    'Fscr': '\u2131',
    'gacute': '\u01F5',
    'gamma': '\u03B3',
    'Gamma': '\u0393',
    'gammad': '\u03DD',
    'Gammad': '\u03DC',
    'gap': '\u2A86',
    'gbreve': '\u011F',
    'Gbreve': '\u011E',
    'Gcedil': '\u0122',
    'gcirc': '\u011D',
    'Gcirc': '\u011C',
    'gcy': '\u0433',
    'Gcy': '\u0413',
    'gdot': '\u0121',
    'Gdot': '\u0120',
    'ge': '\u2265',
    'gE': '\u2267',
    'gel': '\u22DB',
    'gEl': '\u2A8C',
    'geq': '\u2265',
    'geqq': '\u2267',
    'geqslant': '\u2A7E',
    'ges': '\u2A7E',
    'gescc': '\u2AA9',
    'gesdot': '\u2A80',
    'gesdoto': '\u2A82',
    'gesdotol': '\u2A84',
    'gesl': '\u22DB\uFE00',
    'gesles': '\u2A94',
    'gfr': '\uD835\uDD24',
    'Gfr': '\uD835\uDD0A',
    'gg': '\u226B',
    'Gg': '\u22D9',
    'ggg': '\u22D9',
    'gimel': '\u2137',
    'gjcy': '\u0453',
    'GJcy': '\u0403',
    'gl': '\u2277',
    'gla': '\u2AA5',
    'glE': '\u2A92',
    'glj': '\u2AA4',
    'gnap': '\u2A8A',
    'gnapprox': '\u2A8A',
    'gne': '\u2A88',
    'gnE': '\u2269',
    'gneq': '\u2A88',
    'gneqq': '\u2269',
    'gnsim': '\u22E7',
    'gopf': '\uD835\uDD58',
    'Gopf': '\uD835\uDD3E',
    'grave': '`',
    'GreaterEqual': '\u2265',
    'GreaterEqualLess': '\u22DB',
    'GreaterFullEqual': '\u2267',
    'GreaterGreater': '\u2AA2',
    'GreaterLess': '\u2277',
    'GreaterSlantEqual': '\u2A7E',
    'GreaterTilde': '\u2273',
    'gscr': '\u210A',
    'Gscr': '\uD835\uDCA2',
    'gsim': '\u2273',
    'gsime': '\u2A8E',
    'gsiml': '\u2A90',
    'gt': '>',
    'Gt': '\u226B',
    'GT': '>',
    'gtcc': '\u2AA7',
    'gtcir': '\u2A7A',
    'gtdot': '\u22D7',
    'gtlPar': '\u2995',
    'gtquest': '\u2A7C',
    'gtrapprox': '\u2A86',
    'gtrarr': '\u2978',
    'gtrdot': '\u22D7',
    'gtreqless': '\u22DB',
    'gtreqqless': '\u2A8C',
    'gtrless': '\u2277',
    'gtrsim': '\u2273',
    'gvertneqq': '\u2269\uFE00',
    'gvnE': '\u2269\uFE00',
    'Hacek': '\u02C7',
    'hairsp': '\u200A',
    'half': '\xBD',
    'hamilt': '\u210B',
    'hardcy': '\u044A',
    'HARDcy': '\u042A',
    'harr': '\u2194',
    'hArr': '\u21D4',
    'harrcir': '\u2948',
    'harrw': '\u21AD',
    'Hat': '^',
    'hbar': '\u210F',
    'hcirc': '\u0125',
    'Hcirc': '\u0124',
    'hearts': '\u2665',
    'heartsuit': '\u2665',
    'hellip': '\u2026',
    'hercon': '\u22B9',
    'hfr': '\uD835\uDD25',
    'Hfr': '\u210C',
    'HilbertSpace': '\u210B',
    'hksearow': '\u2925',
    'hkswarow': '\u2926',
    'hoarr': '\u21FF',
    'homtht': '\u223B',
    'hookleftarrow': '\u21A9',
    'hookrightarrow': '\u21AA',
    'hopf': '\uD835\uDD59',
    'Hopf': '\u210D',
    'horbar': '\u2015',
    'HorizontalLine': '\u2500',
    'hscr': '\uD835\uDCBD',
    'Hscr': '\u210B',
    'hslash': '\u210F',
    'hstrok': '\u0127',
    'Hstrok': '\u0126',
    'HumpDownHump': '\u224E',
    'HumpEqual': '\u224F',
    'hybull': '\u2043',
    'hyphen': '\u2010',
    'iacute': '\xED',
    'Iacute': '\xCD',
    'ic': '\u2063',
    'icirc': '\xEE',
    'Icirc': '\xCE',
    'icy': '\u0438',
    'Icy': '\u0418',
    'Idot': '\u0130',
    'iecy': '\u0435',
    'IEcy': '\u0415',
    'iexcl': '\xA1',
    'iff': '\u21D4',
    'ifr': '\uD835\uDD26',
    'Ifr': '\u2111',
    'igrave': '\xEC',
    'Igrave': '\xCC',
    'ii': '\u2148',
    'iiiint': '\u2A0C',
    'iiint': '\u222D',
    'iinfin': '\u29DC',
    'iiota': '\u2129',
    'ijlig': '\u0133',
    'IJlig': '\u0132',
    'Im': '\u2111',
    'imacr': '\u012B',
    'Imacr': '\u012A',
    'image': '\u2111',
    'ImaginaryI': '\u2148',
    'imagline': '\u2110',
    'imagpart': '\u2111',
    'imath': '\u0131',
    'imof': '\u22B7',
    'imped': '\u01B5',
    'Implies': '\u21D2',
    'in': '\u2208',
    'incare': '\u2105',
    'infin': '\u221E',
    'infintie': '\u29DD',
    'inodot': '\u0131',
    'int': '\u222B',
    'Int': '\u222C',
    'intcal': '\u22BA',
    'integers': '\u2124',
    'Integral': '\u222B',
    'intercal': '\u22BA',
    'Intersection': '\u22C2',
    'intlarhk': '\u2A17',
    'intprod': '\u2A3C',
    'InvisibleComma': '\u2063',
    'InvisibleTimes': '\u2062',
    'iocy': '\u0451',
    'IOcy': '\u0401',
    'iogon': '\u012F',
    'Iogon': '\u012E',
    'iopf': '\uD835\uDD5A',
    'Iopf': '\uD835\uDD40',
    'iota': '\u03B9',
    'Iota': '\u0399',
    'iprod': '\u2A3C',
    'iquest': '\xBF',
    'iscr': '\uD835\uDCBE',
    'Iscr': '\u2110',
    'isin': '\u2208',
    'isindot': '\u22F5',
    'isinE': '\u22F9',
    'isins': '\u22F4',
    'isinsv': '\u22F3',
    'isinv': '\u2208',
    'it': '\u2062',
    'itilde': '\u0129',
    'Itilde': '\u0128',
    'iukcy': '\u0456',
    'Iukcy': '\u0406',
    'iuml': '\xEF',
    'Iuml': '\xCF',
    'jcirc': '\u0135',
    'Jcirc': '\u0134',
    'jcy': '\u0439',
    'Jcy': '\u0419',
    'jfr': '\uD835\uDD27',
    'Jfr': '\uD835\uDD0D',
    'jmath': '\u0237',
    'jopf': '\uD835\uDD5B',
    'Jopf': '\uD835\uDD41',
    'jscr': '\uD835\uDCBF',
    'Jscr': '\uD835\uDCA5',
    'jsercy': '\u0458',
    'Jsercy': '\u0408',
    'jukcy': '\u0454',
    'Jukcy': '\u0404',
    'kappa': '\u03BA',
    'Kappa': '\u039A',
    'kappav': '\u03F0',
    'kcedil': '\u0137',
    'Kcedil': '\u0136',
    'kcy': '\u043A',
    'Kcy': '\u041A',
    'kfr': '\uD835\uDD28',
    'Kfr': '\uD835\uDD0E',
    'kgreen': '\u0138',
    'khcy': '\u0445',
    'KHcy': '\u0425',
    'kjcy': '\u045C',
    'KJcy': '\u040C',
    'kopf': '\uD835\uDD5C',
    'Kopf': '\uD835\uDD42',
    'kscr': '\uD835\uDCC0',
    'Kscr': '\uD835\uDCA6',
    'lAarr': '\u21DA',
    'lacute': '\u013A',
    'Lacute': '\u0139',
    'laemptyv': '\u29B4',
    'lagran': '\u2112',
    'lambda': '\u03BB',
    'Lambda': '\u039B',
    'lang': '\u27E8',
    'Lang': '\u27EA',
    'langd': '\u2991',
    'langle': '\u27E8',
    'lap': '\u2A85',
    'Laplacetrf': '\u2112',
    'laquo': '\xAB',
    'larr': '\u2190',
    'lArr': '\u21D0',
    'Larr': '\u219E',
    'larrb': '\u21E4',
    'larrbfs': '\u291F',
    'larrfs': '\u291D',
    'larrhk': '\u21A9',
    'larrlp': '\u21AB',
    'larrpl': '\u2939',
    'larrsim': '\u2973',
    'larrtl': '\u21A2',
    'lat': '\u2AAB',
    'latail': '\u2919',
    'lAtail': '\u291B',
    'late': '\u2AAD',
    'lates': '\u2AAD\uFE00',
    'lbarr': '\u290C',
    'lBarr': '\u290E',
    'lbbrk': '\u2772',
    'lbrace': '{',
    'lbrack': '[',
    'lbrke': '\u298B',
    'lbrksld': '\u298F',
    'lbrkslu': '\u298D',
    'lcaron': '\u013E',
    'Lcaron': '\u013D',
    'lcedil': '\u013C',
    'Lcedil': '\u013B',
    'lceil': '\u2308',
    'lcub': '{',
    'lcy': '\u043B',
    'Lcy': '\u041B',
    'ldca': '\u2936',
    'ldquo': '\u201C',
    'ldquor': '\u201E',
    'ldrdhar': '\u2967',
    'ldrushar': '\u294B',
    'ldsh': '\u21B2',
    'le': '\u2264',
    'lE': '\u2266',
    'LeftAngleBracket': '\u27E8',
    'leftarrow': '\u2190',
    'Leftarrow': '\u21D0',
    'LeftArrow': '\u2190',
    'LeftArrowBar': '\u21E4',
    'LeftArrowRightArrow': '\u21C6',
    'leftarrowtail': '\u21A2',
    'LeftCeiling': '\u2308',
    'LeftDoubleBracket': '\u27E6',
    'LeftDownTeeVector': '\u2961',
    'LeftDownVector': '\u21C3',
    'LeftDownVectorBar': '\u2959',
    'LeftFloor': '\u230A',
    'leftharpoondown': '\u21BD',
    'leftharpoonup': '\u21BC',
    'leftleftarrows': '\u21C7',
    'leftrightarrow': '\u2194',
    'Leftrightarrow': '\u21D4',
    'LeftRightArrow': '\u2194',
    'leftrightarrows': '\u21C6',
    'leftrightharpoons': '\u21CB',
    'leftrightsquigarrow': '\u21AD',
    'LeftRightVector': '\u294E',
    'LeftTee': '\u22A3',
    'LeftTeeArrow': '\u21A4',
    'LeftTeeVector': '\u295A',
    'leftthreetimes': '\u22CB',
    'LeftTriangle': '\u22B2',
    'LeftTriangleBar': '\u29CF',
    'LeftTriangleEqual': '\u22B4',
    'LeftUpDownVector': '\u2951',
    'LeftUpTeeVector': '\u2960',
    'LeftUpVector': '\u21BF',
    'LeftUpVectorBar': '\u2958',
    'LeftVector': '\u21BC',
    'LeftVectorBar': '\u2952',
    'leg': '\u22DA',
    'lEg': '\u2A8B',
    'leq': '\u2264',
    'leqq': '\u2266',
    'leqslant': '\u2A7D',
    'les': '\u2A7D',
    'lescc': '\u2AA8',
    'lesdot': '\u2A7F',
    'lesdoto': '\u2A81',
    'lesdotor': '\u2A83',
    'lesg': '\u22DA\uFE00',
    'lesges': '\u2A93',
    'lessapprox': '\u2A85',
    'lessdot': '\u22D6',
    'lesseqgtr': '\u22DA',
    'lesseqqgtr': '\u2A8B',
    'LessEqualGreater': '\u22DA',
    'LessFullEqual': '\u2266',
    'LessGreater': '\u2276',
    'lessgtr': '\u2276',
    'LessLess': '\u2AA1',
    'lesssim': '\u2272',
    'LessSlantEqual': '\u2A7D',
    'LessTilde': '\u2272',
    'lfisht': '\u297C',
    'lfloor': '\u230A',
    'lfr': '\uD835\uDD29',
    'Lfr': '\uD835\uDD0F',
    'lg': '\u2276',
    'lgE': '\u2A91',
    'lHar': '\u2962',
    'lhard': '\u21BD',
    'lharu': '\u21BC',
    'lharul': '\u296A',
    'lhblk': '\u2584',
    'ljcy': '\u0459',
    'LJcy': '\u0409',
    'll': '\u226A',
    'Ll': '\u22D8',
    'llarr': '\u21C7',
    'llcorner': '\u231E',
    'Lleftarrow': '\u21DA',
    'llhard': '\u296B',
    'lltri': '\u25FA',
    'lmidot': '\u0140',
    'Lmidot': '\u013F',
    'lmoust': '\u23B0',
    'lmoustache': '\u23B0',
    'lnap': '\u2A89',
    'lnapprox': '\u2A89',
    'lne': '\u2A87',
    'lnE': '\u2268',
    'lneq': '\u2A87',
    'lneqq': '\u2268',
    'lnsim': '\u22E6',
    'loang': '\u27EC',
    'loarr': '\u21FD',
    'lobrk': '\u27E6',
    'longleftarrow': '\u27F5',
    'Longleftarrow': '\u27F8',
    'LongLeftArrow': '\u27F5',
    'longleftrightarrow': '\u27F7',
    'Longleftrightarrow': '\u27FA',
    'LongLeftRightArrow': '\u27F7',
    'longmapsto': '\u27FC',
    'longrightarrow': '\u27F6',
    'Longrightarrow': '\u27F9',
    'LongRightArrow': '\u27F6',
    'looparrowleft': '\u21AB',
    'looparrowright': '\u21AC',
    'lopar': '\u2985',
    'lopf': '\uD835\uDD5D',
    'Lopf': '\uD835\uDD43',
    'loplus': '\u2A2D',
    'lotimes': '\u2A34',
    'lowast': '\u2217',
    'lowbar': '_',
    'LowerLeftArrow': '\u2199',
    'LowerRightArrow': '\u2198',
    'loz': '\u25CA',
    'lozenge': '\u25CA',
    'lozf': '\u29EB',
    'lpar': '(',
    'lparlt': '\u2993',
    'lrarr': '\u21C6',
    'lrcorner': '\u231F',
    'lrhar': '\u21CB',
    'lrhard': '\u296D',
    'lrm': '\u200E',
    'lrtri': '\u22BF',
    'lsaquo': '\u2039',
    'lscr': '\uD835\uDCC1',
    'Lscr': '\u2112',
    'lsh': '\u21B0',
    'Lsh': '\u21B0',
    'lsim': '\u2272',
    'lsime': '\u2A8D',
    'lsimg': '\u2A8F',
    'lsqb': '[',
    'lsquo': '\u2018',
    'lsquor': '\u201A',
    'lstrok': '\u0142',
    'Lstrok': '\u0141',
    'lt': '<',
    'Lt': '\u226A',
    'LT': '<',
    'ltcc': '\u2AA6',
    'ltcir': '\u2A79',
    'ltdot': '\u22D6',
    'lthree': '\u22CB',
    'ltimes': '\u22C9',
    'ltlarr': '\u2976',
    'ltquest': '\u2A7B',
    'ltri': '\u25C3',
    'ltrie': '\u22B4',
    'ltrif': '\u25C2',
    'ltrPar': '\u2996',
    'lurdshar': '\u294A',
    'luruhar': '\u2966',
    'lvertneqq': '\u2268\uFE00',
    'lvnE': '\u2268\uFE00',
    'macr': '\xAF',
    'male': '\u2642',
    'malt': '\u2720',
    'maltese': '\u2720',
    'map': '\u21A6',
    'Map': '\u2905',
    'mapsto': '\u21A6',
    'mapstodown': '\u21A7',
    'mapstoleft': '\u21A4',
    'mapstoup': '\u21A5',
    'marker': '\u25AE',
    'mcomma': '\u2A29',
    'mcy': '\u043C',
    'Mcy': '\u041C',
    'mdash': '\u2014',
    'mDDot': '\u223A',
    'measuredangle': '\u2221',
    'MediumSpace': '\u205F',
    'Mellintrf': '\u2133',
    'mfr': '\uD835\uDD2A',
    'Mfr': '\uD835\uDD10',
    'mho': '\u2127',
    'micro': '\xB5',
    'mid': '\u2223',
    'midast': '*',
    'midcir': '\u2AF0',
    'middot': '\xB7',
    'minus': '\u2212',
    'minusb': '\u229F',
    'minusd': '\u2238',
    'minusdu': '\u2A2A',
    'MinusPlus': '\u2213',
    'mlcp': '\u2ADB',
    'mldr': '\u2026',
    'mnplus': '\u2213',
    'models': '\u22A7',
    'mopf': '\uD835\uDD5E',
    'Mopf': '\uD835\uDD44',
    'mp': '\u2213',
    'mscr': '\uD835\uDCC2',
    'Mscr': '\u2133',
    'mstpos': '\u223E',
    'mu': '\u03BC',
    'Mu': '\u039C',
    'multimap': '\u22B8',
    'mumap': '\u22B8',
    'nabla': '\u2207',
    'nacute': '\u0144',
    'Nacute': '\u0143',
    'nang': '\u2220\u20D2',
    'nap': '\u2249',
    'napE': '\u2A70\u0338',
    'napid': '\u224B\u0338',
    'napos': '\u0149',
    'napprox': '\u2249',
    'natur': '\u266E',
    'natural': '\u266E',
    'naturals': '\u2115',
    'nbsp': '\xA0',
    'nbump': '\u224E\u0338',
    'nbumpe': '\u224F\u0338',
    'ncap': '\u2A43',
    'ncaron': '\u0148',
    'Ncaron': '\u0147',
    'ncedil': '\u0146',
    'Ncedil': '\u0145',
    'ncong': '\u2247',
    'ncongdot': '\u2A6D\u0338',
    'ncup': '\u2A42',
    'ncy': '\u043D',
    'Ncy': '\u041D',
    'ndash': '\u2013',
    'ne': '\u2260',
    'nearhk': '\u2924',
    'nearr': '\u2197',
    'neArr': '\u21D7',
    'nearrow': '\u2197',
    'nedot': '\u2250\u0338',
    'NegativeMediumSpace': '\u200B',
    'NegativeThickSpace': '\u200B',
    'NegativeThinSpace': '\u200B',
    'NegativeVeryThinSpace': '\u200B',
    'nequiv': '\u2262',
    'nesear': '\u2928',
    'nesim': '\u2242\u0338',
    'NestedGreaterGreater': '\u226B',
    'NestedLessLess': '\u226A',
    'NewLine': '\n',
    'nexist': '\u2204',
    'nexists': '\u2204',
    'nfr': '\uD835\uDD2B',
    'Nfr': '\uD835\uDD11',
    'nge': '\u2271',
    'ngE': '\u2267\u0338',
    'ngeq': '\u2271',
    'ngeqq': '\u2267\u0338',
    'ngeqslant': '\u2A7E\u0338',
    'nges': '\u2A7E\u0338',
    'nGg': '\u22D9\u0338',
    'ngsim': '\u2275',
    'ngt': '\u226F',
    'nGt': '\u226B\u20D2',
    'ngtr': '\u226F',
    'nGtv': '\u226B\u0338',
    'nharr': '\u21AE',
    'nhArr': '\u21CE',
    'nhpar': '\u2AF2',
    'ni': '\u220B',
    'nis': '\u22FC',
    'nisd': '\u22FA',
    'niv': '\u220B',
    'njcy': '\u045A',
    'NJcy': '\u040A',
    'nlarr': '\u219A',
    'nlArr': '\u21CD',
    'nldr': '\u2025',
    'nle': '\u2270',
    'nlE': '\u2266\u0338',
    'nleftarrow': '\u219A',
    'nLeftarrow': '\u21CD',
    'nleftrightarrow': '\u21AE',
    'nLeftrightarrow': '\u21CE',
    'nleq': '\u2270',
    'nleqq': '\u2266\u0338',
    'nleqslant': '\u2A7D\u0338',
    'nles': '\u2A7D\u0338',
    'nless': '\u226E',
    'nLl': '\u22D8\u0338',
    'nlsim': '\u2274',
    'nlt': '\u226E',
    'nLt': '\u226A\u20D2',
    'nltri': '\u22EA',
    'nltrie': '\u22EC',
    'nLtv': '\u226A\u0338',
    'nmid': '\u2224',
    'NoBreak': '\u2060',
    'NonBreakingSpace': '\xA0',
    'nopf': '\uD835\uDD5F',
    'Nopf': '\u2115',
    'not': '\xAC',
    'Not': '\u2AEC',
    'NotCongruent': '\u2262',
    'NotCupCap': '\u226D',
    'NotDoubleVerticalBar': '\u2226',
    'NotElement': '\u2209',
    'NotEqual': '\u2260',
    'NotEqualTilde': '\u2242\u0338',
    'NotExists': '\u2204',
    'NotGreater': '\u226F',
    'NotGreaterEqual': '\u2271',
    'NotGreaterFullEqual': '\u2267\u0338',
    'NotGreaterGreater': '\u226B\u0338',
    'NotGreaterLess': '\u2279',
    'NotGreaterSlantEqual': '\u2A7E\u0338',
    'NotGreaterTilde': '\u2275',
    'NotHumpDownHump': '\u224E\u0338',
    'NotHumpEqual': '\u224F\u0338',
    'notin': '\u2209',
    'notindot': '\u22F5\u0338',
    'notinE': '\u22F9\u0338',
    'notinva': '\u2209',
    'notinvb': '\u22F7',
    'notinvc': '\u22F6',
    'NotLeftTriangle': '\u22EA',
    'NotLeftTriangleBar': '\u29CF\u0338',
    'NotLeftTriangleEqual': '\u22EC',
    'NotLess': '\u226E',
    'NotLessEqual': '\u2270',
    'NotLessGreater': '\u2278',
    'NotLessLess': '\u226A\u0338',
    'NotLessSlantEqual': '\u2A7D\u0338',
    'NotLessTilde': '\u2274',
    'NotNestedGreaterGreater': '\u2AA2\u0338',
    'NotNestedLessLess': '\u2AA1\u0338',
    'notni': '\u220C',
    'notniva': '\u220C',
    'notnivb': '\u22FE',
    'notnivc': '\u22FD',
    'NotPrecedes': '\u2280',
    'NotPrecedesEqual': '\u2AAF\u0338',
    'NotPrecedesSlantEqual': '\u22E0',
    'NotReverseElement': '\u220C',
    'NotRightTriangle': '\u22EB',
    'NotRightTriangleBar': '\u29D0\u0338',
    'NotRightTriangleEqual': '\u22ED',
    'NotSquareSubset': '\u228F\u0338',
    'NotSquareSubsetEqual': '\u22E2',
    'NotSquareSuperset': '\u2290\u0338',
    'NotSquareSupersetEqual': '\u22E3',
    'NotSubset': '\u2282\u20D2',
    'NotSubsetEqual': '\u2288',
    'NotSucceeds': '\u2281',
    'NotSucceedsEqual': '\u2AB0\u0338',
    'NotSucceedsSlantEqual': '\u22E1',
    'NotSucceedsTilde': '\u227F\u0338',
    'NotSuperset': '\u2283\u20D2',
    'NotSupersetEqual': '\u2289',
    'NotTilde': '\u2241',
    'NotTildeEqual': '\u2244',
    'NotTildeFullEqual': '\u2247',
    'NotTildeTilde': '\u2249',
    'NotVerticalBar': '\u2224',
    'npar': '\u2226',
    'nparallel': '\u2226',
    'nparsl': '\u2AFD\u20E5',
    'npart': '\u2202\u0338',
    'npolint': '\u2A14',
    'npr': '\u2280',
    'nprcue': '\u22E0',
    'npre': '\u2AAF\u0338',
    'nprec': '\u2280',
    'npreceq': '\u2AAF\u0338',
    'nrarr': '\u219B',
    'nrArr': '\u21CF',
    'nrarrc': '\u2933\u0338',
    'nrarrw': '\u219D\u0338',
    'nrightarrow': '\u219B',
    'nRightarrow': '\u21CF',
    'nrtri': '\u22EB',
    'nrtrie': '\u22ED',
    'nsc': '\u2281',
    'nsccue': '\u22E1',
    'nsce': '\u2AB0\u0338',
    'nscr': '\uD835\uDCC3',
    'Nscr': '\uD835\uDCA9',
    'nshortmid': '\u2224',
    'nshortparallel': '\u2226',
    'nsim': '\u2241',
    'nsime': '\u2244',
    'nsimeq': '\u2244',
    'nsmid': '\u2224',
    'nspar': '\u2226',
    'nsqsube': '\u22E2',
    'nsqsupe': '\u22E3',
    'nsub': '\u2284',
    'nsube': '\u2288',
    'nsubE': '\u2AC5\u0338',
    'nsubset': '\u2282\u20D2',
    'nsubseteq': '\u2288',
    'nsubseteqq': '\u2AC5\u0338',
    'nsucc': '\u2281',
    'nsucceq': '\u2AB0\u0338',
    'nsup': '\u2285',
    'nsupe': '\u2289',
    'nsupE': '\u2AC6\u0338',
    'nsupset': '\u2283\u20D2',
    'nsupseteq': '\u2289',
    'nsupseteqq': '\u2AC6\u0338',
    'ntgl': '\u2279',
    'ntilde': '\xF1',
    'Ntilde': '\xD1',
    'ntlg': '\u2278',
    'ntriangleleft': '\u22EA',
    'ntrianglelefteq': '\u22EC',
    'ntriangleright': '\u22EB',
    'ntrianglerighteq': '\u22ED',
    'nu': '\u03BD',
    'Nu': '\u039D',
    'num': '#',
    'numero': '\u2116',
    'numsp': '\u2007',
    'nvap': '\u224D\u20D2',
    'nvdash': '\u22AC',
    'nvDash': '\u22AD',
    'nVdash': '\u22AE',
    'nVDash': '\u22AF',
    'nvge': '\u2265\u20D2',
    'nvgt': '>\u20D2',
    'nvHarr': '\u2904',
    'nvinfin': '\u29DE',
    'nvlArr': '\u2902',
    'nvle': '\u2264\u20D2',
    'nvlt': '<\u20D2',
    'nvltrie': '\u22B4\u20D2',
    'nvrArr': '\u2903',
    'nvrtrie': '\u22B5\u20D2',
    'nvsim': '\u223C\u20D2',
    'nwarhk': '\u2923',
    'nwarr': '\u2196',
    'nwArr': '\u21D6',
    'nwarrow': '\u2196',
    'nwnear': '\u2927',
    'oacute': '\xF3',
    'Oacute': '\xD3',
    'oast': '\u229B',
    'ocir': '\u229A',
    'ocirc': '\xF4',
    'Ocirc': '\xD4',
    'ocy': '\u043E',
    'Ocy': '\u041E',
    'odash': '\u229D',
    'odblac': '\u0151',
    'Odblac': '\u0150',
    'odiv': '\u2A38',
    'odot': '\u2299',
    'odsold': '\u29BC',
    'oelig': '\u0153',
    'OElig': '\u0152',
    'ofcir': '\u29BF',
    'ofr': '\uD835\uDD2C',
    'Ofr': '\uD835\uDD12',
    'ogon': '\u02DB',
    'ograve': '\xF2',
    'Ograve': '\xD2',
    'ogt': '\u29C1',
    'ohbar': '\u29B5',
    'ohm': '\u03A9',
    'oint': '\u222E',
    'olarr': '\u21BA',
    'olcir': '\u29BE',
    'olcross': '\u29BB',
    'oline': '\u203E',
    'olt': '\u29C0',
    'omacr': '\u014D',
    'Omacr': '\u014C',
    'omega': '\u03C9',
    'Omega': '\u03A9',
    'omicron': '\u03BF',
    'Omicron': '\u039F',
    'omid': '\u29B6',
    'ominus': '\u2296',
    'oopf': '\uD835\uDD60',
    'Oopf': '\uD835\uDD46',
    'opar': '\u29B7',
    'OpenCurlyDoubleQuote': '\u201C',
    'OpenCurlyQuote': '\u2018',
    'operp': '\u29B9',
    'oplus': '\u2295',
    'or': '\u2228',
    'Or': '\u2A54',
    'orarr': '\u21BB',
    'ord': '\u2A5D',
    'order': '\u2134',
    'orderof': '\u2134',
    'ordf': '\xAA',
    'ordm': '\xBA',
    'origof': '\u22B6',
    'oror': '\u2A56',
    'orslope': '\u2A57',
    'orv': '\u2A5B',
    'oS': '\u24C8',
    'oscr': '\u2134',
    'Oscr': '\uD835\uDCAA',
    'oslash': '\xF8',
    'Oslash': '\xD8',
    'osol': '\u2298',
    'otilde': '\xF5',
    'Otilde': '\xD5',
    'otimes': '\u2297',
    'Otimes': '\u2A37',
    'otimesas': '\u2A36',
    'ouml': '\xF6',
    'Ouml': '\xD6',
    'ovbar': '\u233D',
    'OverBar': '\u203E',
    'OverBrace': '\u23DE',
    'OverBracket': '\u23B4',
    'OverParenthesis': '\u23DC',
    'par': '\u2225',
    'para': '\xB6',
    'parallel': '\u2225',
    'parsim': '\u2AF3',
    'parsl': '\u2AFD',
    'part': '\u2202',
    'PartialD': '\u2202',
    'pcy': '\u043F',
    'Pcy': '\u041F',
    'percnt': '%',
    'period': '.',
    'permil': '\u2030',
    'perp': '\u22A5',
    'pertenk': '\u2031',
    'pfr': '\uD835\uDD2D',
    'Pfr': '\uD835\uDD13',
    'phi': '\u03C6',
    'Phi': '\u03A6',
    'phiv': '\u03D5',
    'phmmat': '\u2133',
    'phone': '\u260E',
    'pi': '\u03C0',
    'Pi': '\u03A0',
    'pitchfork': '\u22D4',
    'piv': '\u03D6',
    'planck': '\u210F',
    'planckh': '\u210E',
    'plankv': '\u210F',
    'plus': '+',
    'plusacir': '\u2A23',
    'plusb': '\u229E',
    'pluscir': '\u2A22',
    'plusdo': '\u2214',
    'plusdu': '\u2A25',
    'pluse': '\u2A72',
    'PlusMinus': '\xB1',
    'plusmn': '\xB1',
    'plussim': '\u2A26',
    'plustwo': '\u2A27',
    'pm': '\xB1',
    'Poincareplane': '\u210C',
    'pointint': '\u2A15',
    'popf': '\uD835\uDD61',
    'Popf': '\u2119',
    'pound': '\xA3',
    'pr': '\u227A',
    'Pr': '\u2ABB',
    'prap': '\u2AB7',
    'prcue': '\u227C',
    'pre': '\u2AAF',
    'prE': '\u2AB3',
    'prec': '\u227A',
    'precapprox': '\u2AB7',
    'preccurlyeq': '\u227C',
    'Precedes': '\u227A',
    'PrecedesEqual': '\u2AAF',
    'PrecedesSlantEqual': '\u227C',
    'PrecedesTilde': '\u227E',
    'preceq': '\u2AAF',
    'precnapprox': '\u2AB9',
    'precneqq': '\u2AB5',
    'precnsim': '\u22E8',
    'precsim': '\u227E',
    'prime': '\u2032',
    'Prime': '\u2033',
    'primes': '\u2119',
    'prnap': '\u2AB9',
    'prnE': '\u2AB5',
    'prnsim': '\u22E8',
    'prod': '\u220F',
    'Product': '\u220F',
    'profalar': '\u232E',
    'profline': '\u2312',
    'profsurf': '\u2313',
    'prop': '\u221D',
    'Proportion': '\u2237',
    'Proportional': '\u221D',
    'propto': '\u221D',
    'prsim': '\u227E',
    'prurel': '\u22B0',
    'pscr': '\uD835\uDCC5',
    'Pscr': '\uD835\uDCAB',
    'psi': '\u03C8',
    'Psi': '\u03A8',
    'puncsp': '\u2008',
    'qfr': '\uD835\uDD2E',
    'Qfr': '\uD835\uDD14',
    'qint': '\u2A0C',
    'qopf': '\uD835\uDD62',
    'Qopf': '\u211A',
    'qprime': '\u2057',
    'qscr': '\uD835\uDCC6',
    'Qscr': '\uD835\uDCAC',
    'quaternions': '\u210D',
    'quatint': '\u2A16',
    'quest': '?',
    'questeq': '\u225F',
    'quot': '"',
    'QUOT': '"',
    'rAarr': '\u21DB',
    'race': '\u223D\u0331',
    'racute': '\u0155',
    'Racute': '\u0154',
    'radic': '\u221A',
    'raemptyv': '\u29B3',
    'rang': '\u27E9',
    'Rang': '\u27EB',
    'rangd': '\u2992',
    'range': '\u29A5',
    'rangle': '\u27E9',
    'raquo': '\xBB',
    'rarr': '\u2192',
    'rArr': '\u21D2',
    'Rarr': '\u21A0',
    'rarrap': '\u2975',
    'rarrb': '\u21E5',
    'rarrbfs': '\u2920',
    'rarrc': '\u2933',
    'rarrfs': '\u291E',
    'rarrhk': '\u21AA',
    'rarrlp': '\u21AC',
    'rarrpl': '\u2945',
    'rarrsim': '\u2974',
    'rarrtl': '\u21A3',
    'Rarrtl': '\u2916',
    'rarrw': '\u219D',
    'ratail': '\u291A',
    'rAtail': '\u291C',
    'ratio': '\u2236',
    'rationals': '\u211A',
    'rbarr': '\u290D',
    'rBarr': '\u290F',
    'RBarr': '\u2910',
    'rbbrk': '\u2773',
    'rbrace': '}',
    'rbrack': ']',
    'rbrke': '\u298C',
    'rbrksld': '\u298E',
    'rbrkslu': '\u2990',
    'rcaron': '\u0159',
    'Rcaron': '\u0158',
    'rcedil': '\u0157',
    'Rcedil': '\u0156',
    'rceil': '\u2309',
    'rcub': '}',
    'rcy': '\u0440',
    'Rcy': '\u0420',
    'rdca': '\u2937',
    'rdldhar': '\u2969',
    'rdquo': '\u201D',
    'rdquor': '\u201D',
    'rdsh': '\u21B3',
    'Re': '\u211C',
    'real': '\u211C',
    'realine': '\u211B',
    'realpart': '\u211C',
    'reals': '\u211D',
    'rect': '\u25AD',
    'reg': '\xAE',
    'REG': '\xAE',
    'ReverseElement': '\u220B',
    'ReverseEquilibrium': '\u21CB',
    'ReverseUpEquilibrium': '\u296F',
    'rfisht': '\u297D',
    'rfloor': '\u230B',
    'rfr': '\uD835\uDD2F',
    'Rfr': '\u211C',
    'rHar': '\u2964',
    'rhard': '\u21C1',
    'rharu': '\u21C0',
    'rharul': '\u296C',
    'rho': '\u03C1',
    'Rho': '\u03A1',
    'rhov': '\u03F1',
    'RightAngleBracket': '\u27E9',
    'rightarrow': '\u2192',
    'Rightarrow': '\u21D2',
    'RightArrow': '\u2192',
    'RightArrowBar': '\u21E5',
    'RightArrowLeftArrow': '\u21C4',
    'rightarrowtail': '\u21A3',
    'RightCeiling': '\u2309',
    'RightDoubleBracket': '\u27E7',
    'RightDownTeeVector': '\u295D',
    'RightDownVector': '\u21C2',
    'RightDownVectorBar': '\u2955',
    'RightFloor': '\u230B',
    'rightharpoondown': '\u21C1',
    'rightharpoonup': '\u21C0',
    'rightleftarrows': '\u21C4',
    'rightleftharpoons': '\u21CC',
    'rightrightarrows': '\u21C9',
    'rightsquigarrow': '\u219D',
    'RightTee': '\u22A2',
    'RightTeeArrow': '\u21A6',
    'RightTeeVector': '\u295B',
    'rightthreetimes': '\u22CC',
    'RightTriangle': '\u22B3',
    'RightTriangleBar': '\u29D0',
    'RightTriangleEqual': '\u22B5',
    'RightUpDownVector': '\u294F',
    'RightUpTeeVector': '\u295C',
    'RightUpVector': '\u21BE',
    'RightUpVectorBar': '\u2954',
    'RightVector': '\u21C0',
    'RightVectorBar': '\u2953',
    'ring': '\u02DA',
    'risingdotseq': '\u2253',
    'rlarr': '\u21C4',
    'rlhar': '\u21CC',
    'rlm': '\u200F',
    'rmoust': '\u23B1',
    'rmoustache': '\u23B1',
    'rnmid': '\u2AEE',
    'roang': '\u27ED',
    'roarr': '\u21FE',
    'robrk': '\u27E7',
    'ropar': '\u2986',
    'ropf': '\uD835\uDD63',
    'Ropf': '\u211D',
    'roplus': '\u2A2E',
    'rotimes': '\u2A35',
    'RoundImplies': '\u2970',
    'rpar': ')',
    'rpargt': '\u2994',
    'rppolint': '\u2A12',
    'rrarr': '\u21C9',
    'Rrightarrow': '\u21DB',
    'rsaquo': '\u203A',
    'rscr': '\uD835\uDCC7',
    'Rscr': '\u211B',
    'rsh': '\u21B1',
    'Rsh': '\u21B1',
    'rsqb': ']',
    'rsquo': '\u2019',
    'rsquor': '\u2019',
    'rthree': '\u22CC',
    'rtimes': '\u22CA',
    'rtri': '\u25B9',
    'rtrie': '\u22B5',
    'rtrif': '\u25B8',
    'rtriltri': '\u29CE',
    'RuleDelayed': '\u29F4',
    'ruluhar': '\u2968',
    'rx': '\u211E',
    'sacute': '\u015B',
    'Sacute': '\u015A',
    'sbquo': '\u201A',
    'sc': '\u227B',
    'Sc': '\u2ABC',
    'scap': '\u2AB8',
    'scaron': '\u0161',
    'Scaron': '\u0160',
    'sccue': '\u227D',
    'sce': '\u2AB0',
    'scE': '\u2AB4',
    'scedil': '\u015F',
    'Scedil': '\u015E',
    'scirc': '\u015D',
    'Scirc': '\u015C',
    'scnap': '\u2ABA',
    'scnE': '\u2AB6',
    'scnsim': '\u22E9',
    'scpolint': '\u2A13',
    'scsim': '\u227F',
    'scy': '\u0441',
    'Scy': '\u0421',
    'sdot': '\u22C5',
    'sdotb': '\u22A1',
    'sdote': '\u2A66',
    'searhk': '\u2925',
    'searr': '\u2198',
    'seArr': '\u21D8',
    'searrow': '\u2198',
    'sect': '\xA7',
    'semi': ';',
    'seswar': '\u2929',
    'setminus': '\u2216',
    'setmn': '\u2216',
    'sext': '\u2736',
    'sfr': '\uD835\uDD30',
    'Sfr': '\uD835\uDD16',
    'sfrown': '\u2322',
    'sharp': '\u266F',
    'shchcy': '\u0449',
    'SHCHcy': '\u0429',
    'shcy': '\u0448',
    'SHcy': '\u0428',
    'ShortDownArrow': '\u2193',
    'ShortLeftArrow': '\u2190',
    'shortmid': '\u2223',
    'shortparallel': '\u2225',
    'ShortRightArrow': '\u2192',
    'ShortUpArrow': '\u2191',
    'shy': '\xAD',
    'sigma': '\u03C3',
    'Sigma': '\u03A3',
    'sigmaf': '\u03C2',
    'sigmav': '\u03C2',
    'sim': '\u223C',
    'simdot': '\u2A6A',
    'sime': '\u2243',
    'simeq': '\u2243',
    'simg': '\u2A9E',
    'simgE': '\u2AA0',
    'siml': '\u2A9D',
    'simlE': '\u2A9F',
    'simne': '\u2246',
    'simplus': '\u2A24',
    'simrarr': '\u2972',
    'slarr': '\u2190',
    'SmallCircle': '\u2218',
    'smallsetminus': '\u2216',
    'smashp': '\u2A33',
    'smeparsl': '\u29E4',
    'smid': '\u2223',
    'smile': '\u2323',
    'smt': '\u2AAA',
    'smte': '\u2AAC',
    'smtes': '\u2AAC\uFE00',
    'softcy': '\u044C',
    'SOFTcy': '\u042C',
    'sol': '/',
    'solb': '\u29C4',
    'solbar': '\u233F',
    'sopf': '\uD835\uDD64',
    'Sopf': '\uD835\uDD4A',
    'spades': '\u2660',
    'spadesuit': '\u2660',
    'spar': '\u2225',
    'sqcap': '\u2293',
    'sqcaps': '\u2293\uFE00',
    'sqcup': '\u2294',
    'sqcups': '\u2294\uFE00',
    'Sqrt': '\u221A',
    'sqsub': '\u228F',
    'sqsube': '\u2291',
    'sqsubset': '\u228F',
    'sqsubseteq': '\u2291',
    'sqsup': '\u2290',
    'sqsupe': '\u2292',
    'sqsupset': '\u2290',
    'sqsupseteq': '\u2292',
    'squ': '\u25A1',
    'square': '\u25A1',
    'Square': '\u25A1',
    'SquareIntersection': '\u2293',
    'SquareSubset': '\u228F',
    'SquareSubsetEqual': '\u2291',
    'SquareSuperset': '\u2290',
    'SquareSupersetEqual': '\u2292',
    'SquareUnion': '\u2294',
    'squarf': '\u25AA',
    'squf': '\u25AA',
    'srarr': '\u2192',
    'sscr': '\uD835\uDCC8',
    'Sscr': '\uD835\uDCAE',
    'ssetmn': '\u2216',
    'ssmile': '\u2323',
    'sstarf': '\u22C6',
    'star': '\u2606',
    'Star': '\u22C6',
    'starf': '\u2605',
    'straightepsilon': '\u03F5',
    'straightphi': '\u03D5',
    'strns': '\xAF',
    'sub': '\u2282',
    'Sub': '\u22D0',
    'subdot': '\u2ABD',
    'sube': '\u2286',
    'subE': '\u2AC5',
    'subedot': '\u2AC3',
    'submult': '\u2AC1',
    'subne': '\u228A',
    'subnE': '\u2ACB',
    'subplus': '\u2ABF',
    'subrarr': '\u2979',
    'subset': '\u2282',
    'Subset': '\u22D0',
    'subseteq': '\u2286',
    'subseteqq': '\u2AC5',
    'SubsetEqual': '\u2286',
    'subsetneq': '\u228A',
    'subsetneqq': '\u2ACB',
    'subsim': '\u2AC7',
    'subsub': '\u2AD5',
    'subsup': '\u2AD3',
    'succ': '\u227B',
    'succapprox': '\u2AB8',
    'succcurlyeq': '\u227D',
    'Succeeds': '\u227B',
    'SucceedsEqual': '\u2AB0',
    'SucceedsSlantEqual': '\u227D',
    'SucceedsTilde': '\u227F',
    'succeq': '\u2AB0',
    'succnapprox': '\u2ABA',
    'succneqq': '\u2AB6',
    'succnsim': '\u22E9',
    'succsim': '\u227F',
    'SuchThat': '\u220B',
    'sum': '\u2211',
    'Sum': '\u2211',
    'sung': '\u266A',
    'sup': '\u2283',
    'Sup': '\u22D1',
    'sup1': '\xB9',
    'sup2': '\xB2',
    'sup3': '\xB3',
    'supdot': '\u2ABE',
    'supdsub': '\u2AD8',
    'supe': '\u2287',
    'supE': '\u2AC6',
    'supedot': '\u2AC4',
    'Superset': '\u2283',
    'SupersetEqual': '\u2287',
    'suphsol': '\u27C9',
    'suphsub': '\u2AD7',
    'suplarr': '\u297B',
    'supmult': '\u2AC2',
    'supne': '\u228B',
    'supnE': '\u2ACC',
    'supplus': '\u2AC0',
    'supset': '\u2283',
    'Supset': '\u22D1',
    'supseteq': '\u2287',
    'supseteqq': '\u2AC6',
    'supsetneq': '\u228B',
    'supsetneqq': '\u2ACC',
    'supsim': '\u2AC8',
    'supsub': '\u2AD4',
    'supsup': '\u2AD6',
    'swarhk': '\u2926',
    'swarr': '\u2199',
    'swArr': '\u21D9',
    'swarrow': '\u2199',
    'swnwar': '\u292A',
    'szlig': '\xDF',
    'Tab': '\t',
    'target': '\u2316',
    'tau': '\u03C4',
    'Tau': '\u03A4',
    'tbrk': '\u23B4',
    'tcaron': '\u0165',
    'Tcaron': '\u0164',
    'tcedil': '\u0163',
    'Tcedil': '\u0162',
    'tcy': '\u0442',
    'Tcy': '\u0422',
    'tdot': '\u20DB',
    'telrec': '\u2315',
    'tfr': '\uD835\uDD31',
    'Tfr': '\uD835\uDD17',
    'there4': '\u2234',
    'therefore': '\u2234',
    'Therefore': '\u2234',
    'theta': '\u03B8',
    'Theta': '\u0398',
    'thetasym': '\u03D1',
    'thetav': '\u03D1',
    'thickapprox': '\u2248',
    'thicksim': '\u223C',
    'ThickSpace': '\u205F\u200A',
    'thinsp': '\u2009',
    'ThinSpace': '\u2009',
    'thkap': '\u2248',
    'thksim': '\u223C',
    'thorn': '\xFE',
    'THORN': '\xDE',
    'tilde': '\u02DC',
    'Tilde': '\u223C',
    'TildeEqual': '\u2243',
    'TildeFullEqual': '\u2245',
    'TildeTilde': '\u2248',
    'times': '\xD7',
    'timesb': '\u22A0',
    'timesbar': '\u2A31',
    'timesd': '\u2A30',
    'tint': '\u222D',
    'toea': '\u2928',
    'top': '\u22A4',
    'topbot': '\u2336',
    'topcir': '\u2AF1',
    'topf': '\uD835\uDD65',
    'Topf': '\uD835\uDD4B',
    'topfork': '\u2ADA',
    'tosa': '\u2929',
    'tprime': '\u2034',
    'trade': '\u2122',
    'TRADE': '\u2122',
    'triangle': '\u25B5',
    'triangledown': '\u25BF',
    'triangleleft': '\u25C3',
    'trianglelefteq': '\u22B4',
    'triangleq': '\u225C',
    'triangleright': '\u25B9',
    'trianglerighteq': '\u22B5',
    'tridot': '\u25EC',
    'trie': '\u225C',
    'triminus': '\u2A3A',
    'TripleDot': '\u20DB',
    'triplus': '\u2A39',
    'trisb': '\u29CD',
    'tritime': '\u2A3B',
    'trpezium': '\u23E2',
    'tscr': '\uD835\uDCC9',
    'Tscr': '\uD835\uDCAF',
    'tscy': '\u0446',
    'TScy': '\u0426',
    'tshcy': '\u045B',
    'TSHcy': '\u040B',
    'tstrok': '\u0167',
    'Tstrok': '\u0166',
    'twixt': '\u226C',
    'twoheadleftarrow': '\u219E',
    'twoheadrightarrow': '\u21A0',
    'uacute': '\xFA',
    'Uacute': '\xDA',
    'uarr': '\u2191',
    'uArr': '\u21D1',
    'Uarr': '\u219F',
    'Uarrocir': '\u2949',
    'ubrcy': '\u045E',
    'Ubrcy': '\u040E',
    'ubreve': '\u016D',
    'Ubreve': '\u016C',
    'ucirc': '\xFB',
    'Ucirc': '\xDB',
    'ucy': '\u0443',
    'Ucy': '\u0423',
    'udarr': '\u21C5',
    'udblac': '\u0171',
    'Udblac': '\u0170',
    'udhar': '\u296E',
    'ufisht': '\u297E',
    'ufr': '\uD835\uDD32',
    'Ufr': '\uD835\uDD18',
    'ugrave': '\xF9',
    'Ugrave': '\xD9',
    'uHar': '\u2963',
    'uharl': '\u21BF',
    'uharr': '\u21BE',
    'uhblk': '\u2580',
    'ulcorn': '\u231C',
    'ulcorner': '\u231C',
    'ulcrop': '\u230F',
    'ultri': '\u25F8',
    'umacr': '\u016B',
    'Umacr': '\u016A',
    'uml': '\xA8',
    'UnderBar': '_',
    'UnderBrace': '\u23DF',
    'UnderBracket': '\u23B5',
    'UnderParenthesis': '\u23DD',
    'Union': '\u22C3',
    'UnionPlus': '\u228E',
    'uogon': '\u0173',
    'Uogon': '\u0172',
    'uopf': '\uD835\uDD66',
    'Uopf': '\uD835\uDD4C',
    'uparrow': '\u2191',
    'Uparrow': '\u21D1',
    'UpArrow': '\u2191',
    'UpArrowBar': '\u2912',
    'UpArrowDownArrow': '\u21C5',
    'updownarrow': '\u2195',
    'Updownarrow': '\u21D5',
    'UpDownArrow': '\u2195',
    'UpEquilibrium': '\u296E',
    'upharpoonleft': '\u21BF',
    'upharpoonright': '\u21BE',
    'uplus': '\u228E',
    'UpperLeftArrow': '\u2196',
    'UpperRightArrow': '\u2197',
    'upsi': '\u03C5',
    'Upsi': '\u03D2',
    'upsih': '\u03D2',
    'upsilon': '\u03C5',
    'Upsilon': '\u03A5',
    'UpTee': '\u22A5',
    'UpTeeArrow': '\u21A5',
    'upuparrows': '\u21C8',
    'urcorn': '\u231D',
    'urcorner': '\u231D',
    'urcrop': '\u230E',
    'uring': '\u016F',
    'Uring': '\u016E',
    'urtri': '\u25F9',
    'uscr': '\uD835\uDCCA',
    'Uscr': '\uD835\uDCB0',
    'utdot': '\u22F0',
    'utilde': '\u0169',
    'Utilde': '\u0168',
    'utri': '\u25B5',
    'utrif': '\u25B4',
    'uuarr': '\u21C8',
    'uuml': '\xFC',
    'Uuml': '\xDC',
    'uwangle': '\u29A7',
    'vangrt': '\u299C',
    'varepsilon': '\u03F5',
    'varkappa': '\u03F0',
    'varnothing': '\u2205',
    'varphi': '\u03D5',
    'varpi': '\u03D6',
    'varpropto': '\u221D',
    'varr': '\u2195',
    'vArr': '\u21D5',
    'varrho': '\u03F1',
    'varsigma': '\u03C2',
    'varsubsetneq': '\u228A\uFE00',
    'varsubsetneqq': '\u2ACB\uFE00',
    'varsupsetneq': '\u228B\uFE00',
    'varsupsetneqq': '\u2ACC\uFE00',
    'vartheta': '\u03D1',
    'vartriangleleft': '\u22B2',
    'vartriangleright': '\u22B3',
    'vBar': '\u2AE8',
    'Vbar': '\u2AEB',
    'vBarv': '\u2AE9',
    'vcy': '\u0432',
    'Vcy': '\u0412',
    'vdash': '\u22A2',
    'vDash': '\u22A8',
    'Vdash': '\u22A9',
    'VDash': '\u22AB',
    'Vdashl': '\u2AE6',
    'vee': '\u2228',
    'Vee': '\u22C1',
    'veebar': '\u22BB',
    'veeeq': '\u225A',
    'vellip': '\u22EE',
    'verbar': '|',
    'Verbar': '\u2016',
    'vert': '|',
    'Vert': '\u2016',
    'VerticalBar': '\u2223',
    'VerticalLine': '|',
    'VerticalSeparator': '\u2758',
    'VerticalTilde': '\u2240',
    'VeryThinSpace': '\u200A',
    'vfr': '\uD835\uDD33',
    'Vfr': '\uD835\uDD19',
    'vltri': '\u22B2',
    'vnsub': '\u2282\u20D2',
    'vnsup': '\u2283\u20D2',
    'vopf': '\uD835\uDD67',
    'Vopf': '\uD835\uDD4D',
    'vprop': '\u221D',
    'vrtri': '\u22B3',
    'vscr': '\uD835\uDCCB',
    'Vscr': '\uD835\uDCB1',
    'vsubne': '\u228A\uFE00',
    'vsubnE': '\u2ACB\uFE00',
    'vsupne': '\u228B\uFE00',
    'vsupnE': '\u2ACC\uFE00',
    'Vvdash': '\u22AA',
    'vzigzag': '\u299A',
    'wcirc': '\u0175',
    'Wcirc': '\u0174',
    'wedbar': '\u2A5F',
    'wedge': '\u2227',
    'Wedge': '\u22C0',
    'wedgeq': '\u2259',
    'weierp': '\u2118',
    'wfr': '\uD835\uDD34',
    'Wfr': '\uD835\uDD1A',
    'wopf': '\uD835\uDD68',
    'Wopf': '\uD835\uDD4E',
    'wp': '\u2118',
    'wr': '\u2240',
    'wreath': '\u2240',
    'wscr': '\uD835\uDCCC',
    'Wscr': '\uD835\uDCB2',
    'xcap': '\u22C2',
    'xcirc': '\u25EF',
    'xcup': '\u22C3',
    'xdtri': '\u25BD',
    'xfr': '\uD835\uDD35',
    'Xfr': '\uD835\uDD1B',
    'xharr': '\u27F7',
    'xhArr': '\u27FA',
    'xi': '\u03BE',
    'Xi': '\u039E',
    'xlarr': '\u27F5',
    'xlArr': '\u27F8',
    'xmap': '\u27FC',
    'xnis': '\u22FB',
    'xodot': '\u2A00',
    'xopf': '\uD835\uDD69',
    'Xopf': '\uD835\uDD4F',
    'xoplus': '\u2A01',
    'xotime': '\u2A02',
    'xrarr': '\u27F6',
    'xrArr': '\u27F9',
    'xscr': '\uD835\uDCCD',
    'Xscr': '\uD835\uDCB3',
    'xsqcup': '\u2A06',
    'xuplus': '\u2A04',
    'xutri': '\u25B3',
    'xvee': '\u22C1',
    'xwedge': '\u22C0',
    'yacute': '\xFD',
    'Yacute': '\xDD',
    'yacy': '\u044F',
    'YAcy': '\u042F',
    'ycirc': '\u0177',
    'Ycirc': '\u0176',
    'ycy': '\u044B',
    'Ycy': '\u042B',
    'yen': '\xA5',
    'yfr': '\uD835\uDD36',
    'Yfr': '\uD835\uDD1C',
    'yicy': '\u0457',
    'YIcy': '\u0407',
    'yopf': '\uD835\uDD6A',
    'Yopf': '\uD835\uDD50',
    'yscr': '\uD835\uDCCE',
    'Yscr': '\uD835\uDCB4',
    'yucy': '\u044E',
    'YUcy': '\u042E',
    'yuml': '\xFF',
    'Yuml': '\u0178',
    'zacute': '\u017A',
    'Zacute': '\u0179',
    'zcaron': '\u017E',
    'Zcaron': '\u017D',
    'zcy': '\u0437',
    'Zcy': '\u0417',
    'zdot': '\u017C',
    'Zdot': '\u017B',
    'zeetrf': '\u2128',
    'ZeroWidthSpace': '\u200B',
    'zeta': '\u03B6',
    'Zeta': '\u0396',
    'zfr': '\uD835\uDD37',
    'Zfr': '\u2128',
    'zhcy': '\u0436',
    'ZHcy': '\u0416',
    'zigrarr': '\u21DD',
    'zopf': '\uD835\uDD6B',
    'Zopf': '\u2124',
    'zscr': '\uD835\uDCCF',
    'Zscr': '\uD835\uDCB5',
    'zwj': '\u200D',
    'zwnj': '\u200C'
  };
  var decodeMapLegacy = {
    'aacute': '\xE1',
    'Aacute': '\xC1',
    'acirc': '\xE2',
    'Acirc': '\xC2',
    'acute': '\xB4',
    'aelig': '\xE6',
    'AElig': '\xC6',
    'agrave': '\xE0',
    'Agrave': '\xC0',
    'amp': '&',
    'AMP': '&',
    'aring': '\xE5',
    'Aring': '\xC5',
    'atilde': '\xE3',
    'Atilde': '\xC3',
    'auml': '\xE4',
    'Auml': '\xC4',
    'brvbar': '\xA6',
    'ccedil': '\xE7',
    'Ccedil': '\xC7',
    'cedil': '\xB8',
    'cent': '\xA2',
    'copy': '\xA9',
    'COPY': '\xA9',
    'curren': '\xA4',
    'deg': '\xB0',
    'divide': '\xF7',
    'eacute': '\xE9',
    'Eacute': '\xC9',
    'ecirc': '\xEA',
    'Ecirc': '\xCA',
    'egrave': '\xE8',
    'Egrave': '\xC8',
    'eth': '\xF0',
    'ETH': '\xD0',
    'euml': '\xEB',
    'Euml': '\xCB',
    'frac12': '\xBD',
    'frac14': '\xBC',
    'frac34': '\xBE',
    'gt': '>',
    'GT': '>',
    'iacute': '\xED',
    'Iacute': '\xCD',
    'icirc': '\xEE',
    'Icirc': '\xCE',
    'iexcl': '\xA1',
    'igrave': '\xEC',
    'Igrave': '\xCC',
    'iquest': '\xBF',
    'iuml': '\xEF',
    'Iuml': '\xCF',
    'laquo': '\xAB',
    'lt': '<',
    'LT': '<',
    'macr': '\xAF',
    'micro': '\xB5',
    'middot': '\xB7',
    'nbsp': '\xA0',
    'not': '\xAC',
    'ntilde': '\xF1',
    'Ntilde': '\xD1',
    'oacute': '\xF3',
    'Oacute': '\xD3',
    'ocirc': '\xF4',
    'Ocirc': '\xD4',
    'ograve': '\xF2',
    'Ograve': '\xD2',
    'ordf': '\xAA',
    'ordm': '\xBA',
    'oslash': '\xF8',
    'Oslash': '\xD8',
    'otilde': '\xF5',
    'Otilde': '\xD5',
    'ouml': '\xF6',
    'Ouml': '\xD6',
    'para': '\xB6',
    'plusmn': '\xB1',
    'pound': '\xA3',
    'quot': '"',
    'QUOT': '"',
    'raquo': '\xBB',
    'reg': '\xAE',
    'REG': '\xAE',
    'sect': '\xA7',
    'shy': '\xAD',
    'sup1': '\xB9',
    'sup2': '\xB2',
    'sup3': '\xB3',
    'szlig': '\xDF',
    'thorn': '\xFE',
    'THORN': '\xDE',
    'times': '\xD7',
    'uacute': '\xFA',
    'Uacute': '\xDA',
    'ucirc': '\xFB',
    'Ucirc': '\xDB',
    'ugrave': '\xF9',
    'Ugrave': '\xD9',
    'uml': '\xA8',
    'uuml': '\xFC',
    'Uuml': '\xDC',
    'yacute': '\xFD',
    'Yacute': '\xDD',
    'yen': '\xA5',
    'yuml': '\xFF'
  };
  var decodeMapNumeric = {
    '0': '\uFFFD',
    '128': '\u20AC',
    '130': '\u201A',
    '131': '\u0192',
    '132': '\u201E',
    '133': '\u2026',
    '134': '\u2020',
    '135': '\u2021',
    '136': '\u02C6',
    '137': '\u2030',
    '138': '\u0160',
    '139': '\u2039',
    '140': '\u0152',
    '142': '\u017D',
    '145': '\u2018',
    '146': '\u2019',
    '147': '\u201C',
    '148': '\u201D',
    '149': '\u2022',
    '150': '\u2013',
    '151': '\u2014',
    '152': '\u02DC',
    '153': '\u2122',
    '154': '\u0161',
    '155': '\u203A',
    '156': '\u0153',
    '158': '\u017E',
    '159': '\u0178'
  };
  var invalidReferenceCodePoints = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65000, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];

  /*--------------------------------------------------------------------------*/

  var stringFromCharCode = String.fromCharCode;
  var object = {};
  var hasOwnProperty = object.hasOwnProperty;
  var has = function (object, propertyName) {
    return hasOwnProperty.call(object, propertyName);
  };
  var contains = function (array, value) {
    var index = -1;
    var length = array.length;
    while (++index < length) {
      if (array[index] == value) {
        return true;
      }
    }
    return false;
  };
  var merge = function (options, defaults) {
    if (!options) {
      return defaults;
    }
    var result = {};
    var key;
    for (key in defaults) {
      // A `hasOwnProperty` check is not needed here, since only recognized
      // option names are used anyway. Any others are ignored.
      result[key] = has(options, key) ? options[key] : defaults[key];
    }
    return result;
  };

  // Modified version of `ucs2encode`; see https://mths.be/punycode.
  var codePointToSymbol = function (codePoint, strict) {
    var output = '';
    if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
      // See issue #4:
      // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
      // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
      // REPLACEMENT CHARACTER.”
      if (strict) {
        parseError('character reference outside the permissible Unicode range');
      }
      return '\uFFFD';
    }
    if (has(decodeMapNumeric, codePoint)) {
      if (strict) {
        parseError('disallowed character reference');
      }
      return decodeMapNumeric[codePoint];
    }
    if (strict && contains(invalidReferenceCodePoints, codePoint)) {
      parseError('disallowed character reference');
    }
    if (codePoint > 0xFFFF) {
      codePoint -= 0x10000;
      output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    output += stringFromCharCode(codePoint);
    return output;
  };
  var hexEscape = function (codePoint) {
    return '&#x' + codePoint.toString(16).toUpperCase() + ';';
  };
  var decEscape = function (codePoint) {
    return '&#' + codePoint + ';';
  };
  var parseError = function (message) {
    throw Error('Parse error: ' + message);
  };

  /*--------------------------------------------------------------------------*/

  var encode = function (string, options) {
    options = merge(options, encode.options);
    var strict = options.strict;
    if (strict && regexInvalidRawCodePoint.test(string)) {
      parseError('forbidden code point');
    }
    var encodeEverything = options.encodeEverything;
    var useNamedReferences = options.useNamedReferences;
    var allowUnsafeSymbols = options.allowUnsafeSymbols;
    var escapeCodePoint = options.decimal ? decEscape : hexEscape;
    var escapeBmpSymbol = function (symbol) {
      return escapeCodePoint(symbol.charCodeAt(0));
    };
    if (encodeEverything) {
      // Encode ASCII symbols.
      string = string.replace(regexAsciiWhitelist, function (symbol) {
        // Use named references if requested & possible.
        if (useNamedReferences && has(encodeMap, symbol)) {
          return '&' + encodeMap[symbol] + ';';
        }
        return escapeBmpSymbol(symbol);
      });
      // Shorten a few escapes that represent two symbols, of which at least one
      // is within the ASCII range.
      if (useNamedReferences) {
        string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
      }
      // Encode non-ASCII symbols.
      if (useNamedReferences) {
        // Encode non-ASCII symbols that can be replaced with a named reference.
        string = string.replace(regexEncodeNonAscii, function (string) {
          // Note: there is no need to check `has(encodeMap, string)` here.
          return '&' + encodeMap[string] + ';';
        });
      }
      // Note: any remaining non-ASCII symbols are handled outside of the `if`.
    } else if (useNamedReferences) {
      // Apply named character references.
      // Encode `<>"'&` using named character references.
      if (!allowUnsafeSymbols) {
        string = string.replace(regexEscape, function (string) {
          return '&' + encodeMap[string] + ';'; // no need to check `has()` here
        });
      }
      // Shorten escapes that represent two symbols, of which at least one is
      // `<>"'&`.
      string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
      // Encode non-ASCII symbols that can be replaced with a named reference.
      string = string.replace(regexEncodeNonAscii, function (string) {
        // Note: there is no need to check `has(encodeMap, string)` here.
        return '&' + encodeMap[string] + ';';
      });
    } else if (!allowUnsafeSymbols) {
      // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
      // using named character references.
      string = string.replace(regexEscape, escapeBmpSymbol);
    }
    return string
    // Encode astral symbols.
    .replace(regexAstralSymbols, function ($0) {
      // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      var high = $0.charCodeAt(0);
      var low = $0.charCodeAt(1);
      var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
      return escapeCodePoint(codePoint);
    })
    // Encode any remaining BMP symbols that are not printable ASCII symbols
    // using a hexadecimal escape.
    .replace(regexBmpWhitelist, escapeBmpSymbol);
  };
  // Expose default options (so they can be overridden globally).
  encode.options = {
    'allowUnsafeSymbols': false,
    'encodeEverything': false,
    'strict': false,
    'useNamedReferences': false,
    'decimal': false
  };
  var decode = function (html, options) {
    options = merge(options, decode.options);
    var strict = options.strict;
    if (strict && regexInvalidEntity.test(html)) {
      parseError('malformed character reference');
    }
    return html.replace(regexDecode, function ($0, $1, $2, $3, $4, $5, $6, $7, $8) {
      var codePoint;
      var semicolon;
      var decDigits;
      var hexDigits;
      var reference;
      var next;
      if ($1) {
        reference = $1;
        // Note: there is no need to check `has(decodeMap, reference)`.
        return decodeMap[reference];
      }
      if ($2) {
        // Decode named character references without trailing `;`, e.g. `&amp`.
        // This is only a parse error if it gets converted to `&`, or if it is
        // followed by `=` in an attribute context.
        reference = $2;
        next = $3;
        if (next && options.isAttributeValue) {
          if (strict && next == '=') {
            parseError('`&` did not start a character reference');
          }
          return $0;
        } else {
          if (strict) {
            parseError('named character reference was not terminated by a semicolon');
          }
          // Note: there is no need to check `has(decodeMapLegacy, reference)`.
          return decodeMapLegacy[reference] + (next || '');
        }
      }
      if ($4) {
        // Decode decimal escapes, e.g. `&#119558;`.
        decDigits = $4;
        semicolon = $5;
        if (strict && !semicolon) {
          parseError('character reference was not terminated by a semicolon');
        }
        codePoint = parseInt(decDigits, 10);
        return codePointToSymbol(codePoint, strict);
      }
      if ($6) {
        // Decode hexadecimal escapes, e.g. `&#x1D306;`.
        hexDigits = $6;
        semicolon = $7;
        if (strict && !semicolon) {
          parseError('character reference was not terminated by a semicolon');
        }
        codePoint = parseInt(hexDigits, 16);
        return codePointToSymbol(codePoint, strict);
      }

      // If we’re still here, `if ($7)` is implied; it’s an ambiguous
      // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
      if (strict) {
        parseError('named character reference was not terminated by a semicolon');
      }
      return $0;
    });
  };
  // Expose default options (so they can be overridden globally).
  decode.options = {
    'isAttributeValue': false,
    'strict': false
  };
  var escape = function (string) {
    return string.replace(regexEscape, function ($0) {
      // Note: there is no need to check `has(escapeMap, $0)` here.
      return escapeMap[$0];
    });
  };

  /*--------------------------------------------------------------------------*/

  var he = {
    'version': '1.2.0',
    'encode': encode,
    'decode': decode,
    'escape': escape,
    'unescape': decode
  };

  // Some AMD build optimizers, like r.js, check for specific condition patterns
  // like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    define(function () {
      return he;
    });
  } else if (freeExports && !freeExports.nodeType) {
    if (freeModule) {
      // in Node.js, io.js, or RingoJS v0.8.0+
      freeModule.exports = he;
    } else {
      // in Narwhal or RingoJS v0.7.0-
      for (var key in he) {
        has(he, key) && (freeExports[key] = he[key]);
      }
    }
  } else {
    // in Rhino or a web browser
    root.he = he;
  }
})(this);
/*
 * Javascript Diff Algorithm
 *  By John Resig (http://ejohn.org/)
 *  Modified by Chu Alan "sprite"
 *
 * Released under the MIT license.
 *
 * More Info:
 *  http://ejohn.org/projects/javascript-diff-algorithm/
 */

function diffEscape(s) {
  var n = s;
  n = n.replace(/&/g, "&amp;");
  n = n.replace(/</g, "&lt;");
  n = n.replace(/>/g, "&gt;");
  n = n.replace(/"/g, "&quot;");
  return n;
}
function diffString(o, n) {
  o = o.replace(/\s+$/, '');
  n = n.replace(/\s+$/, '');
  var out = diff(o == "" ? [] : o.split(/\s+/), n == "" ? [] : n.split(/\s+/));
  var str = "";
  var oSpace = o.match(/\s+/g);
  if (oSpace == null) {
    oSpace = ["\n"];
  } else {
    oSpace.push("\n");
  }
  var nSpace = n.match(/\s+/g);
  if (nSpace == null) {
    nSpace = ["\n"];
  } else {
    nSpace.push("\n");
  }
  if (out.n.length == 0) {
    for (var i = 0; i < out.o.length; i++) {
      str += '<del>' + diffEscape(out.o[i]) + oSpace[i] + "</del>";
    }
  } else {
    if (out.n[0].text == null) {
      for (n = 0; n < out.o.length && out.o[n].text == null; n++) {
        str += '<del>' + diffEscape(out.o[n]) + oSpace[n] + "</del>";
      }
    }
    for (var i = 0; i < out.n.length; i++) {
      if (out.n[i].text == null) {
        str += '<ins>' + diffEscape(out.n[i]) + nSpace[i] + "</ins>";
      } else {
        var pre = "";
        for (n = out.n[i].row + 1; n < out.o.length && out.o[n].text == null; n++) {
          pre += '<del>' + diffEscape(out.o[n]) + oSpace[n] + "</del>";
        }
        str += " " + out.n[i].text + nSpace[i] + pre;
      }
    }
  }
  return str;
}
function randomColor() {
  return "rgb(" + Math.random() * 100 + "%, " + Math.random() * 100 + "%, " + Math.random() * 100 + "%)";
}
function diffString2(o, n) {
  o = o.replace(/\s+$/, '');
  n = n.replace(/\s+$/, '');
  var out = diff(o == "" ? [] : o.split(/\s+/), n == "" ? [] : n.split(/\s+/));
  var oSpace = o.match(/\s+/g);
  if (oSpace == null) {
    oSpace = ["\n"];
  } else {
    oSpace.push("\n");
  }
  var nSpace = n.match(/\s+/g);
  if (nSpace == null) {
    nSpace = ["\n"];
  } else {
    nSpace.push("\n");
  }
  var os = "";
  var colors = new Array();
  for (var i = 0; i < out.o.length; i++) {
    colors[i] = randomColor();
    if (out.o[i].text != null) {
      os += '<span style="background-color: ' + colors[i] + '">' + diffEscape(out.o[i].text) + oSpace[i] + "</span>";
    } else {
      os += "<del>" + diffEscape(out.o[i]) + oSpace[i] + "</del>";
    }
  }
  var ns = "";
  for (var i = 0; i < out.n.length; i++) {
    if (out.n[i].text != null) {
      ns += '<span style="background-color: ' + colors[out.n[i].row] + '">' + diffEscape(out.n[i].text) + nSpace[i] + "</span>";
    } else {
      ns += "<ins>" + diffEscape(out.n[i]) + nSpace[i] + "</ins>";
    }
  }
  return {
    o: os,
    n: ns
  };
}
function diff(o, n) {
  var ns = new Object();
  var os = new Object();
  for (var i = 0; i < n.length; i++) {
    if (ns[n[i]] == null) ns[n[i]] = {
      rows: new Array(),
      o: null
    };
    ns[n[i]].rows.push(i);
  }
  for (var i = 0; i < o.length; i++) {
    if (os[o[i]] == null) os[o[i]] = {
      rows: new Array(),
      n: null
    };
    os[o[i]].rows.push(i);
  }
  for (var i in ns) {
    if (ns[i].rows.length == 1 && typeof os[i] != "undefined" && os[i].rows.length == 1) {
      n[ns[i].rows[0]] = {
        text: n[ns[i].rows[0]],
        row: os[i].rows[0]
      };
      o[os[i].rows[0]] = {
        text: o[os[i].rows[0]],
        row: ns[i].rows[0]
      };
    }
  }
  for (var i = 0; i < n.length - 1; i++) {
    if (n[i].text != null && n[i + 1].text == null && n[i].row + 1 < o.length && o[n[i].row + 1].text == null && n[i + 1] == o[n[i].row + 1]) {
      n[i + 1] = {
        text: n[i + 1],
        row: n[i].row + 1
      };
      o[n[i].row + 1] = {
        text: o[n[i].row + 1],
        row: i + 1
      };
    }
  }
  for (var i = n.length - 1; i > 0; i--) {
    if (n[i].text != null && n[i - 1].text == null && n[i].row > 0 && o[n[i].row - 1].text == null && n[i - 1] == o[n[i].row - 1]) {
      n[i - 1] = {
        text: n[i - 1],
        row: n[i].row - 1
      };
      o[n[i].row - 1] = {
        text: o[n[i].row - 1],
        row: i - 1
      };
    }
  }
  return {
    o: o,
    n: n
  };
}
/*! modernizr 3.4.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-adownload-canvas-filereader-inputtypes-svg-webp-setclasses !*/
!function (e, t, n) {
  function a(e, t) {
    return typeof e === t;
  }
  function A() {
    var e, t, n, A, i, o, s;
    for (var u in r) if (r.hasOwnProperty(u)) {
      if (e = [], t = r[u], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
      for (A = a(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++) o = e[i], s = o.split("."), 1 === s.length ? Modernizr[s[0]] = A : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = A), l.push((A ? "" : "no-") + s.join("-"));
    }
  }
  function i(e) {
    var t = c.className,
      n = Modernizr._config.classPrefix || "";
    if (f && (t = t.baseVal), Modernizr._config.enableJSClass) {
      var a = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(a, "$1" + n + "js$2");
    }
    Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), f ? c.className.baseVal = t : c.className = t);
  }
  function o() {
    return "function" != typeof t.createElement ? t.createElement(arguments[0]) : f ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
  }
  function s(e, t) {
    if ("object" == typeof e) for (var n in e) d(e, n) && s(n, e[n]);else {
      e = e.toLowerCase();
      var a = e.split("."),
        A = Modernizr[a[0]];
      if (2 == a.length && (A = A[a[1]]), "undefined" != typeof A) return Modernizr;
      t = "function" == typeof t ? t() : t, 1 == a.length ? Modernizr[a[0]] = t : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = t), i([(t && 0 != t ? "" : "no-") + a.join("-")]), Modernizr._trigger(e, t);
    }
    return Modernizr;
  }
  var l = [],
    r = [],
    u = {
      _version: "3.4.0",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0
      },
      _q: [],
      on: function (e, t) {
        var n = this;
        setTimeout(function () {
          t(n[e]);
        }, 0);
      },
      addTest: function (e, t, n) {
        r.push({
          name: e,
          fn: t,
          options: n
        });
      },
      addAsyncTest: function (e) {
        r.push({
          name: null,
          fn: e
        });
      }
    },
    Modernizr = function () {};
  Modernizr.prototype = u, Modernizr = new Modernizr(), Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), Modernizr.addTest("filereader", !!(e.File && e.FileList && e.FileReader));
  var c = t.documentElement,
    f = "svg" === c.nodeName.toLowerCase();
  Modernizr.addTest("canvas", function () {
    var e = o("canvas");
    return !(!e.getContext || !e.getContext("2d"));
  }), Modernizr.addTest("adownload", !e.externalHost && "download" in o("a"));
  var d;
  !function () {
    var e = {}.hasOwnProperty;
    d = a(e, "undefined") || a(e.call, "undefined") ? function (e, t) {
      return t in e && a(e.constructor.prototype[t], "undefined");
    } : function (t, n) {
      return e.call(t, n);
    };
  }(), u._l = {}, u.on = function (e, t) {
    this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {
      Modernizr._trigger(e, Modernizr[e]);
    }, 0);
  }, u._trigger = function (e, t) {
    if (this._l[e]) {
      var n = this._l[e];
      setTimeout(function () {
        var e, a;
        for (e = 0; e < n.length; e++) (a = n[e])(t);
      }, 0), delete this._l[e];
    }
  }, Modernizr._q.push(function () {
    u.addTest = s;
  }), Modernizr.addAsyncTest(function () {
    function e(e, t, n) {
      function a(t) {
        var a = t && "load" === t.type ? 1 == A.width : !1,
          i = "webp" === e;
        s(e, i && a ? new Boolean(a) : a), n && n(t);
      }
      var A = new Image();
      A.onerror = a, A.onload = a, A.src = t;
    }
    var t = [{
        uri: "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",
        name: "webp"
      }, {
        uri: "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",
        name: "webp.alpha"
      }, {
        uri: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
        name: "webp.animation"
      }, {
        uri: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",
        name: "webp.lossless"
      }],
      n = t.shift();
    e(n.name, n.uri, function (n) {
      if (n && "load" === n.type) for (var a = 0; a < t.length; a++) e(t[a].name, t[a].uri);
    });
  });
  var p = o("input"),
    g = "search tel url email datetime date month week time datetime-local number range color".split(" "),
    m = {};
  Modernizr.inputtypes = function (e) {
    for (var a, A, i, o = e.length, s = "1)", l = 0; o > l; l++) p.setAttribute("type", a = e[l]), i = "text" !== p.type && "style" in p, i && (p.value = s, p.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(a) && p.style.WebkitAppearance !== n ? (c.appendChild(p), A = t.defaultView, i = A.getComputedStyle && "textfield" !== A.getComputedStyle(p, null).WebkitAppearance && 0 !== p.offsetHeight, c.removeChild(p)) : /^(search|tel)$/.test(a) || (i = /^(url|email)$/.test(a) ? p.checkValidity && p.checkValidity() === !1 : p.value != s)), m[e[l]] = !!i;
    return m;
  }(g), A(), i(l), delete u.addTest, delete u.addAsyncTest;
  for (var h = 0; h < Modernizr._q.length; h++) Modernizr._q[h]();
  e.Modernizr = Modernizr;
}(window, document);
/**
  @license
                                 Apache License
                         Version 2.0, January 2004
                      http://www.apache.org/licenses/

 TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

 1. Definitions.

    "License" shall mean the terms and conditions for use, reproduction,
    and distribution as defined by Sections 1 through 9 of this document.

    "Licensor" shall mean the copyright owner or entity authorized by
    the copyright owner that is granting the License.

    "Legal Entity" shall mean the union of the acting entity and all
    other entities that control, are controlled by, or are under common
    control with that entity. For the purposes of this definition,
    "control" means (i) the power, direct or indirect, to cause the
    direction or management of such entity, whether by contract or
    otherwise, or (ii) ownership of fifty percent (50%) or more of the
    outstanding shares, or (iii) beneficial ownership of such entity.

    "You" (or "Your") shall mean an individual or Legal Entity
    exercising permissions granted by this License.

    "Source" form shall mean the preferred form for making modifications,
    including but not limited to software source code, documentation
    source, and configuration files.

    "Object" form shall mean any form resulting from mechanical
    transformation or translation of a Source form, including but
    not limited to compiled object code, generated documentation,
    and conversions to other media types.

    "Work" shall mean the work of authorship, whether in Source or
    Object form, made available under the License, as indicated by a
    copyright notice that is included in or attached to the work
    (an example is provided in the Appendix below).

    "Derivative Works" shall mean any work, whether in Source or Object
    form, that is based on (or derived from) the Work and for which the
    editorial revisions, annotations, elaborations, or other modifications
    represent, as a whole, an original work of authorship. For the purposes
    of this License, Derivative Works shall not include works that remain
    separable from, or merely link (or bind by name) to the interfaces of,
    the Work and Derivative Works thereof.

    "Contribution" shall mean any work of authorship, including
    the original version of the Work and any modifications or additions
    to that Work or Derivative Works thereof, that is intentionally
    submitted to Licensor for inclusion in the Work by the copyright owner
    or by an individual or Legal Entity authorized to submit on behalf of
    the copyright owner. For the purposes of this definition, "submitted"
    means any form of electronic, verbal, or written communication sent
    to the Licensor or its representatives, including but not limited to
    communication on electronic mailing lists, source code control systems,
    and issue tracking systems that are managed by, or on behalf of, the
    Licensor for the purpose of discussing and improving the Work, but
    excluding communication that is conspicuously marked or otherwise
    designated in writing by the copyright owner as "Not a Contribution."

    "Contributor" shall mean Licensor and any individual or Legal Entity
    on behalf of whom a Contribution has been received by Licensor and
    subsequently incorporated within the Work.

 2. Grant of Copyright License. Subject to the terms and conditions of
    this License, each Contributor hereby grants to You a perpetual,
    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
    copyright license to reproduce, prepare Derivative Works of,
    publicly display, publicly perform, sublicense, and distribute the
    Work and such Derivative Works in Source or Object form.

 3. Grant of Patent License. Subject to the terms and conditions of
    this License, each Contributor hereby grants to You a perpetual,
    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
    (except as stated in this section) patent license to make, have made,
    use, offer to sell, sell, import, and otherwise transfer the Work,
    where such license applies only to those patent claims licensable
    by such Contributor that are necessarily infringed by their
    Contribution(s) alone or by combination of their Contribution(s)
    with the Work to which such Contribution(s) was submitted. If You
    institute patent litigation against any entity (including a
    cross-claim or counterclaim in a lawsuit) alleging that the Work
    or a Contribution incorporated within the Work constitutes direct
    or contributory patent infringement, then any patent licenses
    granted to You under this License for that Work shall terminate
    as of the date such litigation is filed.

 4. Redistribution. You may reproduce and distribute copies of the
    Work or Derivative Works thereof in any medium, with or without
    modifications, and in Source or Object form, provided that You
    meet the following conditions:

    (a) You must give any other recipients of the Work or
        Derivative Works a copy of this License; and

    (b) You must cause any modified files to carry prominent notices
        stating that You changed the files; and

    (c) You must retain, in the Source form of any Derivative Works
        that You distribute, all copyright, patent, trademark, and
        attribution notices from the Source form of the Work,
        excluding those notices that do not pertain to any part of
        the Derivative Works; and

    (d) If the Work includes a "NOTICE" text file as part of its
        distribution, then any Derivative Works that You distribute must
        include a readable copy of the attribution notices contained
        within such NOTICE file, excluding those notices that do not
        pertain to any part of the Derivative Works, in at least one
        of the following places: within a NOTICE text file distributed
        as part of the Derivative Works; within the Source form or
        documentation, if provided along with the Derivative Works; or,
        within a display generated by the Derivative Works, if and
        wherever such third-party notices normally appear. The contents
        of the NOTICE file are for informational purposes only and
        do not modify the License. You may add Your own attribution
        notices within Derivative Works that You distribute, alongside
        or as an addendum to the NOTICE text from the Work, provided
        that such additional attribution notices cannot be construed
        as modifying the License.

    You may add Your own copyright statement to Your modifications and
    may provide additional or different license terms and conditions
    for use, reproduction, or distribution of Your modifications, or
    for any such Derivative Works as a whole, provided Your use,
    reproduction, and distribution of the Work otherwise complies with
    the conditions stated in this License.

 5. Submission of Contributions. Unless You explicitly state otherwise,
    any Contribution intentionally submitted for inclusion in the Work
    by You to the Licensor shall be under the terms and conditions of
    this License, without any additional terms or conditions.
    Notwithstanding the above, nothing herein shall supersede or modify
    the terms of any separate license agreement you may have executed
    with Licensor regarding such Contributions.

 6. Trademarks. This License does not grant permission to use the trade
    names, trademarks, service marks, or product names of the Licensor,
    except as required for reasonable and customary use in describing the
    origin of the Work and reproducing the content of the NOTICE file.

 7. Disclaimer of Warranty. Unless required by applicable law or
    agreed to in writing, Licensor provides the Work (and each
    Contributor provides its Contributions) on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
    implied, including, without limitation, any warranties or conditions
    of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
    PARTICULAR PURPOSE. You are solely responsible for determining the
    appropriateness of using or redistributing the Work and assume any
    risks associated with Your exercise of permissions under this License.

 8. Limitation of Liability. In no event and under no legal theory,
    whether in tort (including negligence), contract, or otherwise,
    unless required by applicable law (such as deliberate and grossly
    negligent acts) or agreed to in writing, shall any Contributor be
    liable to You for damages, including any direct, indirect, special,
    incidental, or consequential damages of any character arising as a
    result of this License or out of the use or inability to use the
    Work (including but not limited to damages for loss of goodwill,
    work stoppage, computer failure or malfunction, or any and all
    other commercial damages or losses), even if such Contributor
    has been advised of the possibility of such damages.

 9. Accepting Warranty or Additional Liability. While redistributing
    the Work or Derivative Works thereof, You may choose to offer,
    and charge a fee for, acceptance of support, warranty, indemnity,
    or other liability obligations and/or rights consistent with this
    License. However, in accepting such obligations, You may act only
    on Your own behalf and on Your sole responsibility, not on behalf
    of any other Contributor, and only if You agree to indemnify,
    defend, and hold each Contributor harmless for any liability
    incurred by, or claims asserted against, such Contributor by reason
    of your accepting any such warranty or additional liability.

 END OF TERMS AND CONDITIONS

 APPENDIX: How to apply the Apache License to your work.

    To apply the Apache License to your work, attach the following
    boilerplate notice, with the fields enclosed by brackets "[]"
    replaced with your own identifying information. (Don't include
    the brackets!)  The text should be enclosed in the appropriate
    comment syntax for the file format. We also recommend that a
    file or class name and description of purpose be included on the
    same "printed page" as the copyright notice for easier
    identification within third-party archives.

 Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 

 **/
/**
  @license
                                 Apache License
                         Version 2.0, January 2004
                      http://www.apache.org/licenses/

 TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

 1. Definitions.

    "License" shall mean the terms and conditions for use, reproduction,
    and distribution as defined by Sections 1 through 9 of this document.

    "Licensor" shall mean the copyright owner or entity authorized by
    the copyright owner that is granting the License.

    "Legal Entity" shall mean the union of the acting entity and all
    other entities that control, are controlled by, or are under common
    control with that entity. For the purposes of this definition,
    "control" means (i) the power, direct or indirect, to cause the
    direction or management of such entity, whether by contract or
    otherwise, or (ii) ownership of fifty percent (50%) or more of the
    outstanding shares, or (iii) beneficial ownership of such entity.

    "You" (or "Your") shall mean an individual or Legal Entity
    exercising permissions granted by this License.

    "Source" form shall mean the preferred form for making modifications,
    including but not limited to software source code, documentation
    source, and configuration files.

    "Object" form shall mean any form resulting from mechanical
    transformation or translation of a Source form, including but
    not limited to compiled object code, generated documentation,
    and conversions to other media types.

    "Work" shall mean the work of authorship, whether in Source or
    Object form, made available under the License, as indicated by a
    copyright notice that is included in or attached to the work
    (an example is provided in the Appendix below).

    "Derivative Works" shall mean any work, whether in Source or Object
    form, that is based on (or derived from) the Work and for which the
    editorial revisions, annotations, elaborations, or other modifications
    represent, as a whole, an original work of authorship. For the purposes
    of this License, Derivative Works shall not include works that remain
    separable from, or merely link (or bind by name) to the interfaces of,
    the Work and Derivative Works thereof.

    "Contribution" shall mean any work of authorship, including
    the original version of the Work and any modifications or additions
    to that Work or Derivative Works thereof, that is intentionally
    submitted to Licensor for inclusion in the Work by the copyright owner
    or by an individual or Legal Entity authorized to submit on behalf of
    the copyright owner. For the purposes of this definition, "submitted"
    means any form of electronic, verbal, or written communication sent
    to the Licensor or its representatives, including but not limited to
    communication on electronic mailing lists, source code control systems,
    and issue tracking systems that are managed by, or on behalf of, the
    Licensor for the purpose of discussing and improving the Work, but
    excluding communication that is conspicuously marked or otherwise
    designated in writing by the copyright owner as "Not a Contribution."

    "Contributor" shall mean Licensor and any individual or Legal Entity
    on behalf of whom a Contribution has been received by Licensor and
    subsequently incorporated within the Work.

 2. Grant of Copyright License. Subject to the terms and conditions of
    this License, each Contributor hereby grants to You a perpetual,
    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
    copyright license to reproduce, prepare Derivative Works of,
    publicly display, publicly perform, sublicense, and distribute the
    Work and such Derivative Works in Source or Object form.

 3. Grant of Patent License. Subject to the terms and conditions of
    this License, each Contributor hereby grants to You a perpetual,
    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
    (except as stated in this section) patent license to make, have made,
    use, offer to sell, sell, import, and otherwise transfer the Work,
    where such license applies only to those patent claims licensable
    by such Contributor that are necessarily infringed by their
    Contribution(s) alone or by combination of their Contribution(s)
    with the Work to which such Contribution(s) was submitted. If You
    institute patent litigation against any entity (including a
    cross-claim or counterclaim in a lawsuit) alleging that the Work
    or a Contribution incorporated within the Work constitutes direct
    or contributory patent infringement, then any patent licenses
    granted to You under this License for that Work shall terminate
    as of the date such litigation is filed.

 4. Redistribution. You may reproduce and distribute copies of the
    Work or Derivative Works thereof in any medium, with or without
    modifications, and in Source or Object form, provided that You
    meet the following conditions:

    (a) You must give any other recipients of the Work or
        Derivative Works a copy of this License; and

    (b) You must cause any modified files to carry prominent notices
        stating that You changed the files; and

    (c) You must retain, in the Source form of any Derivative Works
        that You distribute, all copyright, patent, trademark, and
        attribution notices from the Source form of the Work,
        excluding those notices that do not pertain to any part of
        the Derivative Works; and

    (d) If the Work includes a "NOTICE" text file as part of its
        distribution, then any Derivative Works that You distribute must
        include a readable copy of the attribution notices contained
        within such NOTICE file, excluding those notices that do not
        pertain to any part of the Derivative Works, in at least one
        of the following places: within a NOTICE text file distributed
        as part of the Derivative Works; within the Source form or
        documentation, if provided along with the Derivative Works; or,
        within a display generated by the Derivative Works, if and
        wherever such third-party notices normally appear. The contents
        of the NOTICE file are for informational purposes only and
        do not modify the License. You may add Your own attribution
        notices within Derivative Works that You distribute, alongside
        or as an addendum to the NOTICE text from the Work, provided
        that such additional attribution notices cannot be construed
        as modifying the License.

    You may add Your own copyright statement to Your modifications and
    may provide additional or different license terms and conditions
    for use, reproduction, or distribution of Your modifications, or
    for any such Derivative Works as a whole, provided Your use,
    reproduction, and distribution of the Work otherwise complies with
    the conditions stated in this License.

 5. Submission of Contributions. Unless You explicitly state otherwise,
    any Contribution intentionally submitted for inclusion in the Work
    by You to the Licensor shall be under the terms and conditions of
    this License, without any additional terms or conditions.
    Notwithstanding the above, nothing herein shall supersede or modify
    the terms of any separate license agreement you may have executed
    with Licensor regarding such Contributions.

 6. Trademarks. This License does not grant permission to use the trade
    names, trademarks, service marks, or product names of the Licensor,
    except as required for reasonable and customary use in describing the
    origin of the Work and reproducing the content of the NOTICE file.

 7. Disclaimer of Warranty. Unless required by applicable law or
    agreed to in writing, Licensor provides the Work (and each
    Contributor provides its Contributions) on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
    implied, including, without limitation, any warranties or conditions
    of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
    PARTICULAR PURPOSE. You are solely responsible for determining the
    appropriateness of using or redistributing the Work and assume any
    risks associated with Your exercise of permissions under this License.

 8. Limitation of Liability. In no event and under no legal theory,
    whether in tort (including negligence), contract, or otherwise,
    unless required by applicable law (such as deliberate and grossly
    negligent acts) or agreed to in writing, shall any Contributor be
    liable to You for damages, including any direct, indirect, special,
    incidental, or consequential damages of any character arising as a
    result of this License or out of the use or inability to use the
    Work (including but not limited to damages for loss of goodwill,
    work stoppage, computer failure or malfunction, or any and all
    other commercial damages or losses), even if such Contributor
    has been advised of the possibility of such damages.

 9. Accepting Warranty or Additional Liability. While redistributing
    the Work or Derivative Works thereof, You may choose to offer,
    and charge a fee for, acceptance of support, warranty, indemnity,
    or other liability obligations and/or rights consistent with this
    License. However, in accepting such obligations, You may act only
    on Your own behalf and on Your sole responsibility, not on behalf
    of any other Contributor, and only if You agree to indemnify,
    defend, and hold each Contributor harmless for any liability
    incurred by, or claims asserted against, such Contributor by reason
    of your accepting any such warranty or additional liability.

 END OF TERMS AND CONDITIONS

 APPENDIX: How to apply the Apache License to your work.

    To apply the Apache License to your work, attach the following
    boilerplate notice, with the fields enclosed by brackets "[]"
    replaced with your own identifying information. (Don't include
    the brackets!)  The text should be enclosed in the appropriate
    comment syntax for the file format. We also recommend that a
    file or class name and description of purpose be included on the
    same "printed page" as the copyright notice for easier
    identification within third-party archives.

 Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 

 **/
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define('rxjs', ['exports'], factory) : factory(global.rxjs = {});
})(this, function (exports) {
  'use strict';

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise */
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }
  var __assign = function () {
    __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }
  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }
  function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  }
  function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
      next: function () {
        if (o && i >= o.length) o = void 0;
        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
      r,
      ar = [],
      e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = {
        error: error
      };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  }
  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }
  function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
  }
  function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
      return this;
    }, i;
    function verb(n) {
      if (g[n]) i[n] = function (v) {
        return new Promise(function (a, b) {
          q.push([n, v, a, b]) > 1 || resume(n, v);
        });
      };
    }
    function resume(n, v) {
      try {
        step(g[n](v));
      } catch (e) {
        settle(q[0][3], e);
      }
    }
    function step(r) {
      r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
      resume("next", value);
    }
    function reject(value) {
      resume("throw", value);
    }
    function settle(f, v) {
      if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
  }
  function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator],
      i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
      return this;
    }, i);
    function verb(n) {
      i[n] = o[n] && function (v) {
        return new Promise(function (resolve, reject) {
          v = o[n](v), settle(resolve, reject, v.done, v.value);
        });
      };
    }
    function settle(resolve, reject, d, v) {
      Promise.resolve(v).then(function (v) {
        resolve({
          value: v,
          done: d
        });
      }, reject);
    }
  }
  function isFunction(value) {
    return typeof value === 'function';
  }
  function createErrorClass(createImpl) {
    var _super = function (instance) {
      Error.call(instance);
      instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
  }
  var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
      _super(this);
      this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
        return i + 1 + ") " + err.toString();
      }).join('\n  ') : '';
      this.name = 'UnsubscriptionError';
      this.errors = errors;
    };
  });
  function arrRemove(arr, item) {
    if (arr) {
      var index = arr.indexOf(item);
      0 <= index && arr.splice(index, 1);
    }
  }
  var Subscription = function () {
    function Subscription(initialTeardown) {
      this.initialTeardown = initialTeardown;
      this.closed = false;
      this._parentage = null;
      this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
      var e_1, _a, e_2, _b;
      var errors;
      if (!this.closed) {
        this.closed = true;
        var _parentage = this._parentage;
        if (_parentage) {
          this._parentage = null;
          if (Array.isArray(_parentage)) {
            try {
              for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                var parent_1 = _parentage_1_1.value;
                parent_1.remove(this);
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          } else {
            _parentage.remove(this);
          }
        }
        var initialFinalizer = this.initialTeardown;
        if (isFunction(initialFinalizer)) {
          try {
            initialFinalizer();
          } catch (e) {
            errors = e instanceof UnsubscriptionError ? e.errors : [e];
          }
        }
        var _finalizers = this._finalizers;
        if (_finalizers) {
          this._finalizers = null;
          try {
            for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
              var finalizer = _finalizers_1_1.value;
              try {
                execFinalizer(finalizer);
              } catch (err) {
                errors = errors !== null && errors !== void 0 ? errors : [];
                if (err instanceof UnsubscriptionError) {
                  errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                } else {
                  errors.push(err);
                }
              }
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        }
        if (errors) {
          throw new UnsubscriptionError(errors);
        }
      }
    };
    Subscription.prototype.add = function (teardown) {
      var _a;
      if (teardown && teardown !== this) {
        if (this.closed) {
          execFinalizer(teardown);
        } else {
          if (teardown instanceof Subscription) {
            if (teardown.closed || teardown._hasParent(this)) {
              return;
            }
            teardown._addParent(this);
          }
          (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
        }
      }
    };
    Subscription.prototype._hasParent = function (parent) {
      var _parentage = this._parentage;
      return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function (parent) {
      var _parentage = this._parentage;
      this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
      var _parentage = this._parentage;
      if (_parentage === parent) {
        this._parentage = null;
      } else if (Array.isArray(_parentage)) {
        arrRemove(_parentage, parent);
      }
    };
    Subscription.prototype.remove = function (teardown) {
      var _finalizers = this._finalizers;
      _finalizers && arrRemove(_finalizers, teardown);
      if (teardown instanceof Subscription) {
        teardown._removeParent(this);
      }
    };
    Subscription.EMPTY = function () {
      var empty = new Subscription();
      empty.closed = true;
      return empty;
    }();
    return Subscription;
  }();
  var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
  function isSubscription(value) {
    return value instanceof Subscription || value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe);
  }
  function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
      finalizer();
    } else {
      finalizer.unsubscribe();
    }
  }
  var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
  };
  var timeoutProvider = {
    setTimeout: function (handler, timeout) {
      var args = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
      }
      var delegate = timeoutProvider.delegate;
      if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
        return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
      }
      return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
      var delegate = timeoutProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
  };
  function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
      var onUnhandledError = config.onUnhandledError;
      if (onUnhandledError) {
        onUnhandledError(err);
      } else {
        throw err;
      }
    });
  }
  function noop() {}
  var COMPLETE_NOTIFICATION = function () {
    return createNotification('C', undefined, undefined);
  }();
  function errorNotification(error) {
    return createNotification('E', undefined, error);
  }
  function nextNotification(value) {
    return createNotification('N', value, undefined);
  }
  function createNotification(kind, value, error) {
    return {
      kind: kind,
      value: value,
      error: error
    };
  }
  var context = null;
  function errorContext(cb) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      var isRoot = !context;
      if (isRoot) {
        context = {
          errorThrown: false,
          error: null
        };
      }
      cb();
      if (isRoot) {
        var _a = context,
          errorThrown = _a.errorThrown,
          error = _a.error;
        context = null;
        if (errorThrown) {
          throw error;
        }
      }
    } else {
      cb();
    }
  }
  function captureError(err) {
    if (config.useDeprecatedSynchronousErrorHandling && context) {
      context.errorThrown = true;
      context.error = err;
    }
  }
  var Subscriber = function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
      var _this = _super.call(this) || this;
      _this.isStopped = false;
      if (destination) {
        _this.destination = destination;
        if (isSubscription(destination)) {
          destination.add(_this);
        }
      } else {
        _this.destination = EMPTY_OBSERVER;
      }
      return _this;
    }
    Subscriber.create = function (next, error, complete) {
      return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
      if (this.isStopped) {
        handleStoppedNotification(nextNotification(value), this);
      } else {
        this._next(value);
      }
    };
    Subscriber.prototype.error = function (err) {
      if (this.isStopped) {
        handleStoppedNotification(errorNotification(err), this);
      } else {
        this.isStopped = true;
        this._error(err);
      }
    };
    Subscriber.prototype.complete = function () {
      if (this.isStopped) {
        handleStoppedNotification(COMPLETE_NOTIFICATION, this);
      } else {
        this.isStopped = true;
        this._complete();
      }
    };
    Subscriber.prototype.unsubscribe = function () {
      if (!this.closed) {
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
        this.destination = null;
      }
    };
    Subscriber.prototype._next = function (value) {
      this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
      try {
        this.destination.error(err);
      } finally {
        this.unsubscribe();
      }
    };
    Subscriber.prototype._complete = function () {
      try {
        this.destination.complete();
      } finally {
        this.unsubscribe();
      }
    };
    return Subscriber;
  }(Subscription);
  var _bind = Function.prototype.bind;
  function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
  }
  var ConsumerObserver = function () {
    function ConsumerObserver(partialObserver) {
      this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
      var partialObserver = this.partialObserver;
      if (partialObserver.next) {
        try {
          partialObserver.next(value);
        } catch (error) {
          handleUnhandledError(error);
        }
      }
    };
    ConsumerObserver.prototype.error = function (err) {
      var partialObserver = this.partialObserver;
      if (partialObserver.error) {
        try {
          partialObserver.error(err);
        } catch (error) {
          handleUnhandledError(error);
        }
      } else {
        handleUnhandledError(err);
      }
    };
    ConsumerObserver.prototype.complete = function () {
      var partialObserver = this.partialObserver;
      if (partialObserver.complete) {
        try {
          partialObserver.complete();
        } catch (error) {
          handleUnhandledError(error);
        }
      }
    };
    return ConsumerObserver;
  }();
  var SafeSubscriber = function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
      var _this = _super.call(this) || this;
      var partialObserver;
      if (isFunction(observerOrNext) || !observerOrNext) {
        partialObserver = {
          next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
          error: error !== null && error !== void 0 ? error : undefined,
          complete: complete !== null && complete !== void 0 ? complete : undefined
        };
      } else {
        var context_1;
        if (_this && config.useDeprecatedNextContext) {
          context_1 = Object.create(observerOrNext);
          context_1.unsubscribe = function () {
            return _this.unsubscribe();
          };
          partialObserver = {
            next: observerOrNext.next && bind(observerOrNext.next, context_1),
            error: observerOrNext.error && bind(observerOrNext.error, context_1),
            complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
          };
        } else {
          partialObserver = observerOrNext;
        }
      }
      _this.destination = new ConsumerObserver(partialObserver);
      return _this;
    }
    return SafeSubscriber;
  }(Subscriber);
  function handleUnhandledError(error) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      captureError(error);
    } else {
      reportUnhandledError(error);
    }
  }
  function defaultErrorHandler(err) {
    throw err;
  }
  function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = config.onStoppedNotification;
    onStoppedNotification && timeoutProvider.setTimeout(function () {
      return onStoppedNotification(notification, subscriber);
    });
  }
  var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop
  };
  var observable = function () {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
  }();
  function identity(x) {
    return x;
  }
  function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
  }
  function pipeFromArray(fns) {
    if (fns.length === 0) {
      return identity;
    }
    if (fns.length === 1) {
      return fns[0];
    }
    return function piped(input) {
      return fns.reduce(function (prev, fn) {
        return fn(prev);
      }, input);
    };
  }
  var Observable = function () {
    function Observable(subscribe) {
      if (subscribe) {
        this._subscribe = subscribe;
      }
    }
    Observable.prototype.lift = function (operator) {
      var observable$$1 = new Observable();
      observable$$1.source = this;
      observable$$1.operator = operator;
      return observable$$1;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
      var _this = this;
      var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
      errorContext(function () {
        var _a = _this,
          operator = _a.operator,
          source = _a.source;
        subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
      });
      return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
      try {
        return this._subscribe(sink);
      } catch (err) {
        sink.error(err);
      }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
      var _this = this;
      promiseCtor = getPromiseCtor(promiseCtor);
      return new promiseCtor(function (resolve, reject) {
        var subscriber = new SafeSubscriber({
          next: function (value) {
            try {
              next(value);
            } catch (err) {
              reject(err);
              subscriber.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
        _this.subscribe(subscriber);
      });
    };
    Observable.prototype._subscribe = function (subscriber) {
      var _a;
      return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
      return this;
    };
    Observable.prototype.pipe = function () {
      var operations = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        operations[_i] = arguments[_i];
      }
      return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
      var _this = this;
      promiseCtor = getPromiseCtor(promiseCtor);
      return new promiseCtor(function (resolve, reject) {
        var value;
        _this.subscribe(function (x) {
          return value = x;
        }, function (err) {
          return reject(err);
        }, function () {
          return resolve(value);
        });
      });
    };
    Observable.create = function (subscribe) {
      return new Observable(subscribe);
    };
    return Observable;
  }();
  function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
  }
  function isObserver(value) {
    return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
  }
  function isSubscriber(value) {
    return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
  }
  function hasLift(source) {
    return isFunction(source === null || source === void 0 ? void 0 : source.lift);
  }
  function operate(init) {
    return function (source) {
      if (hasLift(source)) {
        return source.lift(function (liftedSource) {
          try {
            return init(liftedSource, this);
          } catch (err) {
            this.error(err);
          }
        });
      }
      throw new TypeError('Unable to lift unknown Observable type');
    };
  }
  function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
  }
  var OperatorSubscriber = function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
      var _this = _super.call(this, destination) || this;
      _this.onFinalize = onFinalize;
      _this.shouldUnsubscribe = shouldUnsubscribe;
      _this._next = onNext ? function (value) {
        try {
          onNext(value);
        } catch (err) {
          destination.error(err);
        }
      } : _super.prototype._next;
      _this._error = onError ? function (err) {
        try {
          onError(err);
        } catch (err) {
          destination.error(err);
        } finally {
          this.unsubscribe();
        }
      } : _super.prototype._error;
      _this._complete = onComplete ? function () {
        try {
          onComplete();
        } catch (err) {
          destination.error(err);
        } finally {
          this.unsubscribe();
        }
      } : _super.prototype._complete;
      return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
      var _a;
      if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
        var closed_1 = this.closed;
        _super.prototype.unsubscribe.call(this);
        !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
      }
    };
    return OperatorSubscriber;
  }(Subscriber);
  function refCount() {
    return operate(function (source, subscriber) {
      var connection = null;
      source._refCount++;
      var refCounter = createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
        if (!source || source._refCount <= 0 || 0 < --source._refCount) {
          connection = null;
          return;
        }
        var sharedConnection = source._connection;
        var conn = connection;
        connection = null;
        if (sharedConnection && (!conn || sharedConnection === conn)) {
          sharedConnection.unsubscribe();
        }
        subscriber.unsubscribe();
      });
      source.subscribe(refCounter);
      if (!refCounter.closed) {
        connection = source.connect();
      }
    });
  }
  var ConnectableObservable = function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
      var _this = _super.call(this) || this;
      _this.source = source;
      _this.subjectFactory = subjectFactory;
      _this._subject = null;
      _this._refCount = 0;
      _this._connection = null;
      if (hasLift(source)) {
        _this.lift = source.lift;
      }
      return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
      return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
      var subject = this._subject;
      if (!subject || subject.isStopped) {
        this._subject = this.subjectFactory();
      }
      return this._subject;
    };
    ConnectableObservable.prototype._teardown = function () {
      this._refCount = 0;
      var _connection = this._connection;
      this._subject = this._connection = null;
      _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function () {
      var _this = this;
      var connection = this._connection;
      if (!connection) {
        connection = this._connection = new Subscription();
        var subject_1 = this.getSubject();
        connection.add(this.source.subscribe(createOperatorSubscriber(subject_1, undefined, function () {
          _this._teardown();
          subject_1.complete();
        }, function (err) {
          _this._teardown();
          subject_1.error(err);
        }, function () {
          return _this._teardown();
        })));
        if (connection.closed) {
          this._connection = null;
          connection = Subscription.EMPTY;
        }
      }
      return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
      return refCount()(this);
    };
    return ConnectableObservable;
  }(Observable);
  var performanceTimestampProvider = {
    now: function () {
      return (performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined
  };
  var animationFrameProvider = {
    schedule: function (callback) {
      var request = requestAnimationFrame;
      var cancel = cancelAnimationFrame;
      var delegate = animationFrameProvider.delegate;
      if (delegate) {
        request = delegate.requestAnimationFrame;
        cancel = delegate.cancelAnimationFrame;
      }
      var handle = request(function (timestamp) {
        cancel = undefined;
        callback(timestamp);
      });
      return new Subscription(function () {
        return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
      });
    },
    requestAnimationFrame: function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var delegate = animationFrameProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    cancelAnimationFrame: function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var delegate = animationFrameProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    delegate: undefined
  };
  function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
  }
  function animationFramesFactory(timestampProvider) {
    return new Observable(function (subscriber) {
      var provider = timestampProvider || performanceTimestampProvider;
      var start = provider.now();
      var id = 0;
      var run = function () {
        if (!subscriber.closed) {
          id = animationFrameProvider.requestAnimationFrame(function (timestamp) {
            id = 0;
            var now = provider.now();
            subscriber.next({
              timestamp: timestampProvider ? now : timestamp,
              elapsed: now - start
            });
            run();
          });
        }
      };
      run();
      return function () {
        if (id) {
          animationFrameProvider.cancelAnimationFrame(id);
        }
      };
    });
  }
  var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
  var ObjectUnsubscribedError = createErrorClass(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
      _super(this);
      this.name = 'ObjectUnsubscribedError';
      this.message = 'object unsubscribed';
    };
  });
  var Subject = function (_super) {
    __extends(Subject, _super);
    function Subject() {
      var _this = _super.call(this) || this;
      _this.closed = false;
      _this.currentObservers = null;
      _this.observers = [];
      _this.isStopped = false;
      _this.hasError = false;
      _this.thrownError = null;
      return _this;
    }
    Subject.prototype.lift = function (operator) {
      var subject = new AnonymousSubject(this, this);
      subject.operator = operator;
      return subject;
    };
    Subject.prototype._throwIfClosed = function () {
      if (this.closed) {
        throw new ObjectUnsubscribedError();
      }
    };
    Subject.prototype.next = function (value) {
      var _this = this;
      errorContext(function () {
        var e_1, _a;
        _this._throwIfClosed();
        if (!_this.isStopped) {
          if (!_this.currentObservers) {
            _this.currentObservers = Array.from(_this.observers);
          }
          try {
            for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
              var observer = _c.value;
              observer.next(value);
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }
      });
    };
    Subject.prototype.error = function (err) {
      var _this = this;
      errorContext(function () {
        _this._throwIfClosed();
        if (!_this.isStopped) {
          _this.hasError = _this.isStopped = true;
          _this.thrownError = err;
          var observers = _this.observers;
          while (observers.length) {
            observers.shift().error(err);
          }
        }
      });
    };
    Subject.prototype.complete = function () {
      var _this = this;
      errorContext(function () {
        _this._throwIfClosed();
        if (!_this.isStopped) {
          _this.isStopped = true;
          var observers = _this.observers;
          while (observers.length) {
            observers.shift().complete();
          }
        }
      });
    };
    Subject.prototype.unsubscribe = function () {
      this.isStopped = this.closed = true;
      this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
      get: function () {
        var _a;
        return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
      },
      enumerable: false,
      configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
      this._throwIfClosed();
      return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
      this._throwIfClosed();
      this._checkFinalizedStatuses(subscriber);
      return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
      var _this = this;
      var _a = this,
        hasError = _a.hasError,
        isStopped = _a.isStopped,
        observers = _a.observers;
      if (hasError || isStopped) {
        return EMPTY_SUBSCRIPTION;
      }
      this.currentObservers = null;
      observers.push(subscriber);
      return new Subscription(function () {
        _this.currentObservers = null;
        arrRemove(observers, subscriber);
      });
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
      var _a = this,
        hasError = _a.hasError,
        thrownError = _a.thrownError,
        isStopped = _a.isStopped;
      if (hasError) {
        subscriber.error(thrownError);
      } else if (isStopped) {
        subscriber.complete();
      }
    };
    Subject.prototype.asObservable = function () {
      var observable = new Observable();
      observable.source = this;
      return observable;
    };
    Subject.create = function (destination, source) {
      return new AnonymousSubject(destination, source);
    };
    return Subject;
  }(Observable);
  var AnonymousSubject = function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
      var _this = _super.call(this) || this;
      _this.destination = destination;
      _this.source = source;
      return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
      var _a, _b;
      (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
      var _a, _b;
      (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
      var _a, _b;
      (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
      var _a, _b;
      return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
    };
    return AnonymousSubject;
  }(Subject);
  var BehaviorSubject = function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
      var _this = _super.call(this) || this;
      _this._value = _value;
      return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
      get: function () {
        return this.getValue();
      },
      enumerable: false,
      configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
      var subscription = _super.prototype._subscribe.call(this, subscriber);
      !subscription.closed && subscriber.next(this._value);
      return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
      var _a = this,
        hasError = _a.hasError,
        thrownError = _a.thrownError,
        _value = _a._value;
      if (hasError) {
        throw thrownError;
      }
      this._throwIfClosed();
      return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
      _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
  }(Subject);
  var dateTimestampProvider = {
    now: function () {
      return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
  };
  var ReplaySubject = function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
      if (_bufferSize === void 0) {
        _bufferSize = Infinity;
      }
      if (_windowTime === void 0) {
        _windowTime = Infinity;
      }
      if (_timestampProvider === void 0) {
        _timestampProvider = dateTimestampProvider;
      }
      var _this = _super.call(this) || this;
      _this._bufferSize = _bufferSize;
      _this._windowTime = _windowTime;
      _this._timestampProvider = _timestampProvider;
      _this._buffer = [];
      _this._infiniteTimeWindow = true;
      _this._infiniteTimeWindow = _windowTime === Infinity;
      _this._bufferSize = Math.max(1, _bufferSize);
      _this._windowTime = Math.max(1, _windowTime);
      return _this;
    }
    ReplaySubject.prototype.next = function (value) {
      var _a = this,
        isStopped = _a.isStopped,
        _buffer = _a._buffer,
        _infiniteTimeWindow = _a._infiniteTimeWindow,
        _timestampProvider = _a._timestampProvider,
        _windowTime = _a._windowTime;
      if (!isStopped) {
        _buffer.push(value);
        !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
      }
      this._trimBuffer();
      _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
      this._throwIfClosed();
      this._trimBuffer();
      var subscription = this._innerSubscribe(subscriber);
      var _a = this,
        _infiniteTimeWindow = _a._infiniteTimeWindow,
        _buffer = _a._buffer;
      var copy = _buffer.slice();
      for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
        subscriber.next(copy[i]);
      }
      this._checkFinalizedStatuses(subscriber);
      return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
      var _a = this,
        _bufferSize = _a._bufferSize,
        _timestampProvider = _a._timestampProvider,
        _buffer = _a._buffer,
        _infiniteTimeWindow = _a._infiniteTimeWindow;
      var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
      _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
      if (!_infiniteTimeWindow) {
        var now = _timestampProvider.now();
        var last = 0;
        for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
          last = i;
        }
        last && _buffer.splice(0, last + 1);
      }
    };
    return ReplaySubject;
  }(Subject);
  var AsyncSubject = function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this._value = null;
      _this._hasValue = false;
      _this._isComplete = false;
      return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
      var _a = this,
        hasError = _a.hasError,
        _hasValue = _a._hasValue,
        _value = _a._value,
        thrownError = _a.thrownError,
        isStopped = _a.isStopped,
        _isComplete = _a._isComplete;
      if (hasError) {
        subscriber.error(thrownError);
      } else if (isStopped || _isComplete) {
        _hasValue && subscriber.next(_value);
        subscriber.complete();
      }
    };
    AsyncSubject.prototype.next = function (value) {
      if (!this.isStopped) {
        this._value = value;
        this._hasValue = true;
      }
    };
    AsyncSubject.prototype.complete = function () {
      var _a = this,
        _hasValue = _a._hasValue,
        _value = _a._value,
        _isComplete = _a._isComplete;
      if (!_isComplete) {
        this._isComplete = true;
        _hasValue && _super.prototype.next.call(this, _value);
        _super.prototype.complete.call(this);
      }
    };
    return AsyncSubject;
  }(Subject);
  var Action = function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
      return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return this;
    };
    return Action;
  }(Subscription);
  var intervalProvider = {
    setInterval: function (handler, timeout) {
      var args = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
      }
      var delegate = intervalProvider.delegate;
      if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
        return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
      }
      return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearInterval: function (handle) {
      var delegate = intervalProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
  };
  var AsyncAction = function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
      var _this = _super.call(this, scheduler, work) || this;
      _this.scheduler = scheduler;
      _this.work = work;
      _this.pending = false;
      return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
      var _a;
      if (delay === void 0) {
        delay = 0;
      }
      if (this.closed) {
        return this;
      }
      this.state = state;
      var id = this.id;
      var scheduler = this.scheduler;
      if (id != null) {
        this.id = this.recycleAsyncId(scheduler, id, delay);
      }
      this.pending = true;
      this.delay = delay;
      this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
      return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (delay != null && this.delay === delay && this.pending === false) {
        return id;
      }
      if (id != null) {
        intervalProvider.clearInterval(id);
      }
      return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
      if (this.closed) {
        return new Error('executing a cancelled action');
      }
      this.pending = false;
      var error = this._execute(state, delay);
      if (error) {
        return error;
      } else if (this.pending === false && this.id != null) {
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
      }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
      var errored = false;
      var errorValue;
      try {
        this.work(state);
      } catch (e) {
        errored = true;
        errorValue = e ? e : new Error('Scheduled action threw falsy error');
      }
      if (errored) {
        this.unsubscribe();
        return errorValue;
      }
    };
    AsyncAction.prototype.unsubscribe = function () {
      if (!this.closed) {
        var _a = this,
          id = _a.id,
          scheduler = _a.scheduler;
        var actions = scheduler.actions;
        this.work = this.state = this.scheduler = null;
        this.pending = false;
        arrRemove(actions, this);
        if (id != null) {
          this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
        _super.prototype.unsubscribe.call(this);
      }
    };
    return AsyncAction;
  }(Action);
  var nextHandle = 1;
  var resolved;
  var activeHandles = {};
  function findAndClearHandle(handle) {
    if (handle in activeHandles) {
      delete activeHandles[handle];
      return true;
    }
    return false;
  }
  var Immediate = {
    setImmediate: function (cb) {
      var handle = nextHandle++;
      activeHandles[handle] = true;
      if (!resolved) {
        resolved = Promise.resolve();
      }
      resolved.then(function () {
        return findAndClearHandle(handle) && cb();
      });
      return handle;
    },
    clearImmediate: function (handle) {
      findAndClearHandle(handle);
    }
  };
  var setImmediate = Immediate.setImmediate,
    clearImmediate = Immediate.clearImmediate;
  var immediateProvider = {
    setImmediate: function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var delegate = immediateProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
    },
    clearImmediate: function (handle) {
      var delegate = immediateProvider.delegate;
      return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined
  };
  var AsapAction = function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
      var _this = _super.call(this, scheduler, work) || this;
      _this.scheduler = scheduler;
      _this.work = work;
      return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (delay !== null && delay > 0) {
        return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
      }
      scheduler.actions.push(this);
      return scheduler._scheduled || (scheduler._scheduled = immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
      var _a;
      if (delay === void 0) {
        delay = 0;
      }
      if (delay != null ? delay > 0 : this.delay > 0) {
        return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
      }
      var actions = scheduler.actions;
      if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
        immediateProvider.clearImmediate(id);
        if (scheduler._scheduled === id) {
          scheduler._scheduled = undefined;
        }
      }
      return undefined;
    };
    return AsapAction;
  }(AsyncAction);
  var Scheduler = function () {
    function Scheduler(schedulerActionCtor, now) {
      if (now === void 0) {
        now = Scheduler.now;
      }
      this.schedulerActionCtor = schedulerActionCtor;
      this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
      if (delay === void 0) {
        delay = 0;
      }
      return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
  }();
  var AsyncScheduler = function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
      if (now === void 0) {
        now = Scheduler.now;
      }
      var _this = _super.call(this, SchedulerAction, now) || this;
      _this.actions = [];
      _this._active = false;
      return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
      var actions = this.actions;
      if (this._active) {
        actions.push(action);
        return;
      }
      var error;
      this._active = true;
      do {
        if (error = action.execute(action.state, action.delay)) {
          break;
        }
      } while (action = actions.shift());
      this._active = false;
      if (error) {
        while (action = actions.shift()) {
          action.unsubscribe();
        }
        throw error;
      }
    };
    return AsyncScheduler;
  }(Scheduler);
  var AsapScheduler = function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
      this._active = true;
      var flushId = this._scheduled;
      this._scheduled = undefined;
      var actions = this.actions;
      var error;
      action = action || actions.shift();
      do {
        if (error = action.execute(action.state, action.delay)) {
          break;
        }
      } while ((action = actions[0]) && action.id === flushId && actions.shift());
      this._active = false;
      if (error) {
        while ((action = actions[0]) && action.id === flushId && actions.shift()) {
          action.unsubscribe();
        }
        throw error;
      }
    };
    return AsapScheduler;
  }(AsyncScheduler);
  var asapScheduler = new AsapScheduler(AsapAction);
  var asap = asapScheduler;
  var asyncScheduler = new AsyncScheduler(AsyncAction);
  var async = asyncScheduler;
  var QueueAction = function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
      var _this = _super.call(this, scheduler, work) || this;
      _this.scheduler = scheduler;
      _this.work = work;
      return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (delay > 0) {
        return _super.prototype.schedule.call(this, state, delay);
      }
      this.delay = delay;
      this.state = state;
      this.scheduler.flush(this);
      return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
      return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (delay != null && delay > 0 || delay == null && this.delay > 0) {
        return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
      }
      scheduler.flush(this);
      return 0;
    };
    return QueueAction;
  }(AsyncAction);
  var QueueScheduler = function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
  }(AsyncScheduler);
  var queueScheduler = new QueueScheduler(QueueAction);
  var queue = queueScheduler;
  var AnimationFrameAction = function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
      var _this = _super.call(this, scheduler, work) || this;
      _this.scheduler = scheduler;
      _this.work = work;
      return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (delay !== null && delay > 0) {
        return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
      }
      scheduler.actions.push(this);
      return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider.requestAnimationFrame(function () {
        return scheduler.flush(undefined);
      }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
      var _a;
      if (delay === void 0) {
        delay = 0;
      }
      if (delay != null ? delay > 0 : this.delay > 0) {
        return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
      }
      var actions = scheduler.actions;
      if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
        animationFrameProvider.cancelAnimationFrame(id);
        scheduler._scheduled = undefined;
      }
      return undefined;
    };
    return AnimationFrameAction;
  }(AsyncAction);
  var AnimationFrameScheduler = function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
      this._active = true;
      var flushId = this._scheduled;
      this._scheduled = undefined;
      var actions = this.actions;
      var error;
      action = action || actions.shift();
      do {
        if (error = action.execute(action.state, action.delay)) {
          break;
        }
      } while ((action = actions[0]) && action.id === flushId && actions.shift());
      this._active = false;
      if (error) {
        while ((action = actions[0]) && action.id === flushId && actions.shift()) {
          action.unsubscribe();
        }
        throw error;
      }
    };
    return AnimationFrameScheduler;
  }(AsyncScheduler);
  var animationFrameScheduler = new AnimationFrameScheduler(AnimationFrameAction);
  var animationFrame = animationFrameScheduler;
  var VirtualTimeScheduler = function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
      if (schedulerActionCtor === void 0) {
        schedulerActionCtor = VirtualAction;
      }
      if (maxFrames === void 0) {
        maxFrames = Infinity;
      }
      var _this = _super.call(this, schedulerActionCtor, function () {
        return _this.frame;
      }) || this;
      _this.maxFrames = maxFrames;
      _this.frame = 0;
      _this.index = -1;
      return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
      var _a = this,
        actions = _a.actions,
        maxFrames = _a.maxFrames;
      var error;
      var action;
      while ((action = actions[0]) && action.delay <= maxFrames) {
        actions.shift();
        this.frame = action.delay;
        if (error = action.execute(action.state, action.delay)) {
          break;
        }
      }
      if (error) {
        while (action = actions.shift()) {
          action.unsubscribe();
        }
        throw error;
      }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
  }(AsyncScheduler);
  var VirtualAction = function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
      if (index === void 0) {
        index = scheduler.index += 1;
      }
      var _this = _super.call(this, scheduler, work) || this;
      _this.scheduler = scheduler;
      _this.work = work;
      _this.index = index;
      _this.active = true;
      _this.index = scheduler.index = index;
      return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      if (Number.isFinite(delay)) {
        if (!this.id) {
          return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
      } else {
        return Subscription.EMPTY;
      }
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      this.delay = scheduler.frame + delay;
      var actions = scheduler.actions;
      actions.push(this);
      actions.sort(VirtualAction.sortActions);
      return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
      if (this.active === true) {
        return _super.prototype._execute.call(this, state, delay);
      }
    };
    VirtualAction.sortActions = function (a, b) {
      if (a.delay === b.delay) {
        if (a.index === b.index) {
          return 0;
        } else if (a.index > b.index) {
          return 1;
        } else {
          return -1;
        }
      } else if (a.delay > b.delay) {
        return 1;
      } else {
        return -1;
      }
    };
    return VirtualAction;
  }(AsyncAction);
  var EMPTY = new Observable(function (subscriber) {
    return subscriber.complete();
  });
  function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
  }
  function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) {
      return scheduler.schedule(function () {
        return subscriber.complete();
      });
    });
  }
  function isScheduler(value) {
    return value && isFunction(value.schedule);
  }
  function last(arr) {
    return arr[arr.length - 1];
  }
  function popResultSelector(args) {
    return isFunction(last(args)) ? args.pop() : undefined;
  }
  function popScheduler(args) {
    return isScheduler(last(args)) ? args.pop() : undefined;
  }
  function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
  }
  var isArrayLike = function (x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
  };
  function isPromise(value) {
    return isFunction(value === null || value === void 0 ? void 0 : value.then);
  }
  function isInteropObservable(input) {
    return isFunction(input[observable]);
  }
  function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
  }
  function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
  }
  function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
      return '@@iterator';
    }
    return Symbol.iterator;
  }
  var iterator = getSymbolIterator();
  function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
  }
  function readableStreamLikeToAsyncGenerator(readableStream) {
    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
      var reader, _a, value, done;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            reader = readableStream.getReader();
            _b.label = 1;
          case 1:
            _b.trys.push([1,, 9, 10]);
            _b.label = 2;
          case 2:
            return [4, __await(reader.read())];
          case 3:
            _a = _b.sent(), value = _a.value, done = _a.done;
            if (!done) return [3, 5];
            return [4, __await(void 0)];
          case 4:
            return [2, _b.sent()];
          case 5:
            return [4, __await(value)];
          case 6:
            return [4, _b.sent()];
          case 7:
            _b.sent();
            return [3, 2];
          case 8:
            return [3, 10];
          case 9:
            reader.releaseLock();
            return [7];
          case 10:
            return [2];
        }
      });
    });
  }
  function isReadableStreamLike(obj) {
    return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
  }
  function innerFrom(input) {
    if (input instanceof Observable) {
      return input;
    }
    if (input != null) {
      if (isInteropObservable(input)) {
        return fromInteropObservable(input);
      }
      if (isArrayLike(input)) {
        return fromArrayLike(input);
      }
      if (isPromise(input)) {
        return fromPromise(input);
      }
      if (isAsyncIterable(input)) {
        return fromAsyncIterable(input);
      }
      if (isIterable(input)) {
        return fromIterable(input);
      }
      if (isReadableStreamLike(input)) {
        return fromReadableStreamLike(input);
      }
    }
    throw createInvalidObservableTypeError(input);
  }
  function fromInteropObservable(obj) {
    return new Observable(function (subscriber) {
      var obs = obj[observable]();
      if (isFunction(obs.subscribe)) {
        return obs.subscribe(subscriber);
      }
      throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
  }
  function fromArrayLike(array) {
    return new Observable(function (subscriber) {
      for (var i = 0; i < array.length && !subscriber.closed; i++) {
        subscriber.next(array[i]);
      }
      subscriber.complete();
    });
  }
  function fromPromise(promise) {
    return new Observable(function (subscriber) {
      promise.then(function (value) {
        if (!subscriber.closed) {
          subscriber.next(value);
          subscriber.complete();
        }
      }, function (err) {
        return subscriber.error(err);
      }).then(null, reportUnhandledError);
    });
  }
  function fromIterable(iterable) {
    return new Observable(function (subscriber) {
      var e_1, _a;
      try {
        for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
          var value = iterable_1_1.value;
          subscriber.next(value);
          if (subscriber.closed) {
            return;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      subscriber.complete();
    });
  }
  function fromAsyncIterable(asyncIterable) {
    return new Observable(function (subscriber) {
      process(asyncIterable, subscriber).catch(function (err) {
        return subscriber.error(err);
      });
    });
  }
  function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
  }
  function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function () {
      var value, e_2_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 5, 6, 11]);
            asyncIterable_1 = __asyncValues(asyncIterable);
            _b.label = 1;
          case 1:
            return [4, asyncIterable_1.next()];
          case 2:
            if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
            value = asyncIterable_1_1.value;
            subscriber.next(value);
            if (subscriber.closed) {
              return [2];
            }
            _b.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [3, 11];
          case 5:
            e_2_1 = _b.sent();
            e_2 = {
              error: e_2_1
            };
            return [3, 11];
          case 6:
            _b.trys.push([6,, 9, 10]);
            if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
            return [4, _a.call(asyncIterable_1)];
          case 7:
            _b.sent();
            _b.label = 8;
          case 8:
            return [3, 10];
          case 9:
            if (e_2) throw e_2.error;
            return [7];
          case 10:
            return [7];
          case 11:
            subscriber.complete();
            return [2];
        }
      });
    });
  }
  function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) {
      delay = 0;
    }
    if (repeat === void 0) {
      repeat = false;
    }
    var scheduleSubscription = scheduler.schedule(function () {
      work();
      if (repeat) {
        parentSubscription.add(this.schedule(null, delay));
      } else {
        this.unsubscribe();
      }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
      return scheduleSubscription;
    }
  }
  function observeOn(scheduler, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return operate(function (source, subscriber) {
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return executeSchedule(subscriber, scheduler, function () {
          return subscriber.next(value);
        }, delay);
      }, function () {
        return executeSchedule(subscriber, scheduler, function () {
          return subscriber.complete();
        }, delay);
      }, function (err) {
        return executeSchedule(subscriber, scheduler, function () {
          return subscriber.error(err);
        }, delay);
      }));
    });
  }
  function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return operate(function (source, subscriber) {
      subscriber.add(scheduler.schedule(function () {
        return source.subscribe(subscriber);
      }, delay));
    });
  }
  function scheduleObservable(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
  }
  function schedulePromise(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
  }
  function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
      var i = 0;
      return scheduler.schedule(function () {
        if (i === input.length) {
          subscriber.complete();
        } else {
          subscriber.next(input[i++]);
          if (!subscriber.closed) {
            this.schedule();
          }
        }
      });
    });
  }
  function scheduleIterable(input, scheduler) {
    return new Observable(function (subscriber) {
      var iterator$$1;
      executeSchedule(subscriber, scheduler, function () {
        iterator$$1 = input[iterator]();
        executeSchedule(subscriber, scheduler, function () {
          var _a;
          var value;
          var done;
          try {
            _a = iterator$$1.next(), value = _a.value, done = _a.done;
          } catch (err) {
            subscriber.error(err);
            return;
          }
          if (done) {
            subscriber.complete();
          } else {
            subscriber.next(value);
          }
        }, 0, true);
      });
      return function () {
        return isFunction(iterator$$1 === null || iterator$$1 === void 0 ? void 0 : iterator$$1.return) && iterator$$1.return();
      };
    });
  }
  function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
      throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
      executeSchedule(subscriber, scheduler, function () {
        var iterator = input[Symbol.asyncIterator]();
        executeSchedule(subscriber, scheduler, function () {
          iterator.next().then(function (result) {
            if (result.done) {
              subscriber.complete();
            } else {
              subscriber.next(result.value);
            }
          });
        }, 0, true);
      });
    });
  }
  function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
  }
  function scheduled(input, scheduler) {
    if (input != null) {
      if (isInteropObservable(input)) {
        return scheduleObservable(input, scheduler);
      }
      if (isArrayLike(input)) {
        return scheduleArray(input, scheduler);
      }
      if (isPromise(input)) {
        return schedulePromise(input, scheduler);
      }
      if (isAsyncIterable(input)) {
        return scheduleAsyncIterable(input, scheduler);
      }
      if (isIterable(input)) {
        return scheduleIterable(input, scheduler);
      }
      if (isReadableStreamLike(input)) {
        return scheduleReadableStreamLike(input, scheduler);
      }
    }
    throw createInvalidObservableTypeError(input);
  }
  function from(input, scheduler) {
    return scheduler ? scheduled(input, scheduler) : innerFrom(input);
  }
  function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return from(args, scheduler);
  }
  function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () {
      return errorOrErrorFactory;
    };
    var init = function (subscriber) {
      return subscriber.error(errorFactory());
    };
    return new Observable(scheduler ? function (subscriber) {
      return scheduler.schedule(init, 0, subscriber);
    } : init);
  }
  (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
  })(exports.NotificationKind || (exports.NotificationKind = {}));
  var Notification = function () {
    function Notification(kind, value, error) {
      this.kind = kind;
      this.value = value;
      this.error = error;
      this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
      return observeNotification(this, observer);
    };
    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
      var _a = this,
        kind = _a.kind,
        value = _a.value,
        error = _a.error;
      return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
      var _a;
      return isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function () {
      var _a = this,
        kind = _a.kind,
        value = _a.value,
        error = _a.error;
      var result = kind === 'N' ? of(value) : kind === 'E' ? throwError(function () {
        return error;
      }) : kind === 'C' ? EMPTY : 0;
      if (!result) {
        throw new TypeError("Unexpected notification kind " + kind);
      }
      return result;
    };
    Notification.createNext = function (value) {
      return new Notification('N', value);
    };
    Notification.createError = function (err) {
      return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
      return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
  }();
  function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification,
      kind = _d.kind,
      value = _d.value,
      error = _d.error;
    if (typeof kind !== 'string') {
      throw new TypeError('Invalid notification, missing "kind"');
    }
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
  }
  function isObservable(obj) {
    return !!obj && (obj instanceof Observable || isFunction(obj.lift) && isFunction(obj.subscribe));
  }
  var EmptyError = createErrorClass(function (_super) {
    return function EmptyErrorImpl() {
      _super(this);
      this.name = 'EmptyError';
      this.message = 'no elements in sequence';
    };
  });
  function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
      var _hasValue = false;
      var _value;
      source.subscribe({
        next: function (value) {
          _value = value;
          _hasValue = true;
        },
        error: reject,
        complete: function () {
          if (_hasValue) {
            resolve(_value);
          } else if (hasConfig) {
            resolve(config.defaultValue);
          } else {
            reject(new EmptyError());
          }
        }
      });
    });
  }
  function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
      var subscriber = new SafeSubscriber({
        next: function (value) {
          resolve(value);
          subscriber.unsubscribe();
        },
        error: reject,
        complete: function () {
          if (hasConfig) {
            resolve(config.defaultValue);
          } else {
            reject(new EmptyError());
          }
        }
      });
      source.subscribe(subscriber);
    });
  }
  var ArgumentOutOfRangeError = createErrorClass(function (_super) {
    return function ArgumentOutOfRangeErrorImpl() {
      _super(this);
      this.name = 'ArgumentOutOfRangeError';
      this.message = 'argument out of range';
    };
  });
  var NotFoundError = createErrorClass(function (_super) {
    return function NotFoundErrorImpl(message) {
      _super(this);
      this.name = 'NotFoundError';
      this.message = message;
    };
  });
  var SequenceError = createErrorClass(function (_super) {
    return function SequenceErrorImpl(message) {
      _super(this);
      this.name = 'SequenceError';
      this.message = message;
    };
  });
  function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
  }
  var TimeoutError = createErrorClass(function (_super) {
    return function TimeoutErrorImpl(info) {
      if (info === void 0) {
        info = null;
      }
      _super(this);
      this.message = 'Timeout has occurred';
      this.name = 'TimeoutError';
      this.info = info;
    };
  });
  function timeout(config, schedulerArg) {
    var _a = isValidDate(config) ? {
        first: config
      } : typeof config === 'number' ? {
        each: config
      } : config,
      first = _a.first,
      each = _a.each,
      _b = _a.with,
      _with = _b === void 0 ? timeoutErrorFactory : _b,
      _c = _a.scheduler,
      scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : asyncScheduler : _c,
      _d = _a.meta,
      meta = _d === void 0 ? null : _d;
    if (first == null && each == null) {
      throw new TypeError('No timeout provided.');
    }
    return operate(function (source, subscriber) {
      var originalSourceSubscription;
      var timerSubscription;
      var lastValue = null;
      var seen = 0;
      var startTimer = function (delay) {
        timerSubscription = executeSchedule(subscriber, scheduler, function () {
          try {
            originalSourceSubscription.unsubscribe();
            innerFrom(_with({
              meta: meta,
              lastValue: lastValue,
              seen: seen
            })).subscribe(subscriber);
          } catch (err) {
            subscriber.error(err);
          }
        }, delay);
      };
      originalSourceSubscription = source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
        seen++;
        subscriber.next(lastValue = value);
        each > 0 && startTimer(each);
      }, undefined, undefined, function () {
        if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
          timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
        }
        lastValue = null;
      }));
      !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
  }
  function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
  }
  function map(project, thisArg) {
    return operate(function (source, subscriber) {
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        subscriber.next(project.call(thisArg, value, index++));
      }));
    });
  }
  var isArray = Array.isArray;
  function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
  }
  function mapOneOrManyArgs(fn) {
    return map(function (args) {
      return callOrApply(fn, args);
    });
  }
  function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
      if (isScheduler(resultSelector)) {
        scheduler = resultSelector;
      } else {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler).apply(this, args).pipe(mapOneOrManyArgs(resultSelector));
        };
      }
    }
    if (scheduler) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return bindCallbackInternals(isNodeStyle, callbackFunc).apply(this, args).pipe(subscribeOn(scheduler), observeOn(scheduler));
      };
    }
    return function () {
      var _this = this;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var subject = new AsyncSubject();
      var uninitialized = true;
      return new Observable(function (subscriber) {
        var subs = subject.subscribe(subscriber);
        if (uninitialized) {
          uninitialized = false;
          var isAsync_1 = false;
          var isComplete_1 = false;
          callbackFunc.apply(_this, __spreadArray(__spreadArray([], __read(args)), [function () {
            var results = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              results[_i] = arguments[_i];
            }
            if (isNodeStyle) {
              var err = results.shift();
              if (err != null) {
                subject.error(err);
                return;
              }
            }
            subject.next(1 < results.length ? results : results[0]);
            isComplete_1 = true;
            if (isAsync_1) {
              subject.complete();
            }
          }]));
          if (isComplete_1) {
            subject.complete();
          }
          isAsync_1 = true;
        }
        return subs;
      });
    };
  }
  function bindCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
  }
  function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
  }
  var isArray$1 = Array.isArray;
  var getPrototypeOf = Object.getPrototypeOf,
    objectProto = Object.prototype,
    getKeys = Object.keys;
  function argsArgArrayOrObject(args) {
    if (args.length === 1) {
      var first_1 = args[0];
      if (isArray$1(first_1)) {
        return {
          args: first_1,
          keys: null
        };
      }
      if (isPOJO(first_1)) {
        var keys = getKeys(first_1);
        return {
          args: keys.map(function (key) {
            return first_1[key];
          }),
          keys: keys
        };
      }
    }
    return {
      args: args,
      keys: null
    };
  }
  function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
  }
  function createObject(keys, values) {
    return keys.reduce(function (result, key, i) {
      return result[key] = values[i], result;
    }, {});
  }
  function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var resultSelector = popResultSelector(args);
    var _a = argsArgArrayOrObject(args),
      observables = _a.args,
      keys = _a.keys;
    if (observables.length === 0) {
      return from([], scheduler);
    }
    var result = new Observable(combineLatestInit(observables, scheduler, keys ? function (values) {
      return createObject(keys, values);
    } : identity));
    return resultSelector ? result.pipe(mapOneOrManyArgs(resultSelector)) : result;
  }
  function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) {
      valueTransform = identity;
    }
    return function (subscriber) {
      maybeSchedule(scheduler, function () {
        var length = observables.length;
        var values = new Array(length);
        var active = length;
        var remainingFirstValues = length;
        var _loop_1 = function (i) {
          maybeSchedule(scheduler, function () {
            var source = from(observables[i], scheduler);
            var hasFirstValue = false;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
              values[i] = value;
              if (!hasFirstValue) {
                hasFirstValue = true;
                remainingFirstValues--;
              }
              if (!remainingFirstValues) {
                subscriber.next(valueTransform(values.slice()));
              }
            }, function () {
              if (! --active) {
                subscriber.complete();
              }
            }));
          }, subscriber);
        };
        for (var i = 0; i < length; i++) {
          _loop_1(i);
        }
      }, subscriber);
    };
  }
  function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) {
      executeSchedule(subscription, scheduler, execute);
    } else {
      execute();
    }
  }
  function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
      if (isComplete && !buffer.length && !active) {
        subscriber.complete();
      }
    };
    var outerNext = function (value) {
      return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function (value) {
      expand && subscriber.next(value);
      active++;
      var innerComplete = false;
      innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
        onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
        if (expand) {
          outerNext(innerValue);
        } else {
          subscriber.next(innerValue);
        }
      }, function () {
        innerComplete = true;
      }, undefined, function () {
        if (innerComplete) {
          try {
            active--;
            var _loop_1 = function () {
              var bufferedValue = buffer.shift();
              if (innerSubScheduler) {
                executeSchedule(subscriber, innerSubScheduler, function () {
                  return doInnerSub(bufferedValue);
                });
              } else {
                doInnerSub(bufferedValue);
              }
            };
            while (buffer.length && active < concurrent) {
              _loop_1();
            }
            checkComplete();
          } catch (err) {
            subscriber.error(err);
          }
        }
      }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
      isComplete = true;
      checkComplete();
    }));
    return function () {
      additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
  }
  function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
      concurrent = Infinity;
    }
    if (isFunction(resultSelector)) {
      return mergeMap(function (a, i) {
        return map(function (b, ii) {
          return resultSelector(a, b, i, ii);
        })(innerFrom(project(a, i)));
      }, concurrent);
    } else if (typeof resultSelector === 'number') {
      concurrent = resultSelector;
    }
    return operate(function (source, subscriber) {
      return mergeInternals(source, subscriber, project, concurrent);
    });
  }
  function mergeAll(concurrent) {
    if (concurrent === void 0) {
      concurrent = Infinity;
    }
    return mergeMap(identity, concurrent);
  }
  function concatAll() {
    return mergeAll(1);
  }
  function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return concatAll()(from(args, popScheduler(args)));
  }
  function defer(observableFactory) {
    return new Observable(function (subscriber) {
      innerFrom(observableFactory()).subscribe(subscriber);
    });
  }
  var DEFAULT_CONFIG = {
    connector: function () {
      return new Subject();
    },
    resetOnDisconnect: true
  };
  function connectable(source, config) {
    if (config === void 0) {
      config = DEFAULT_CONFIG;
    }
    var connection = null;
    var connector = config.connector,
      _a = config.resetOnDisconnect,
      resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new Observable(function (subscriber) {
      return subject.subscribe(subscriber);
    });
    result.connect = function () {
      if (!connection || connection.closed) {
        connection = defer(function () {
          return source;
        }).subscribe(subject);
        if (resetOnDisconnect) {
          connection.add(function () {
            return subject = connector();
          });
        }
      }
      return connection;
    };
    return result;
  }
  function forkJoin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    var _a = argsArgArrayOrObject(args),
      sources = _a.args,
      keys = _a.keys;
    var result = new Observable(function (subscriber) {
      var length = sources.length;
      if (!length) {
        subscriber.complete();
        return;
      }
      var values = new Array(length);
      var remainingCompletions = length;
      var remainingEmissions = length;
      var _loop_1 = function (sourceIndex) {
        var hasValue = false;
        innerFrom(sources[sourceIndex]).subscribe(createOperatorSubscriber(subscriber, function (value) {
          if (!hasValue) {
            hasValue = true;
            remainingEmissions--;
          }
          values[sourceIndex] = value;
        }, function () {
          return remainingCompletions--;
        }, undefined, function () {
          if (!remainingCompletions || !hasValue) {
            if (!remainingEmissions) {
              subscriber.next(keys ? createObject(keys, values) : values);
            }
            subscriber.complete();
          }
        }));
      };
      for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
        _loop_1(sourceIndex);
      }
    });
    return resultSelector ? result.pipe(mapOneOrManyArgs(resultSelector)) : result;
  }
  var nodeEventEmitterMethods = ['addListener', 'removeListener'];
  var eventTargetMethods = ['addEventListener', 'removeEventListener'];
  var jqueryMethods = ['on', 'off'];
  function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction(options)) {
      resultSelector = options;
      options = undefined;
    }
    if (resultSelector) {
      return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
    }
    var _a = __read(isEventTarget(target) ? eventTargetMethods.map(function (methodName) {
        return function (handler) {
          return target[methodName](eventName, handler, options);
        };
      }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2),
      add = _a[0],
      remove = _a[1];
    if (!add) {
      if (isArrayLike(target)) {
        return mergeMap(function (subTarget) {
          return fromEvent(subTarget, eventName, options);
        })(innerFrom(target));
      }
    }
    if (!add) {
      throw new TypeError('Invalid event target');
    }
    return new Observable(function (subscriber) {
      var handler = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return subscriber.next(1 < args.length ? args : args[0]);
      };
      add(handler);
      return function () {
        return remove(handler);
      };
    });
  }
  function toCommonHandlerRegistry(target, eventName) {
    return function (methodName) {
      return function (handler) {
        return target[methodName](eventName, handler);
      };
    };
  }
  function isNodeStyleEventEmitter(target) {
    return isFunction(target.addListener) && isFunction(target.removeListener);
  }
  function isJQueryStyleEventEmitter(target) {
    return isFunction(target.on) && isFunction(target.off);
  }
  function isEventTarget(target) {
    return isFunction(target.addEventListener) && isFunction(target.removeEventListener);
  }
  function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
      return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs(resultSelector));
    }
    return new Observable(function (subscriber) {
      var handler = function () {
        var e = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          e[_i] = arguments[_i];
        }
        return subscriber.next(e.length === 1 ? e[0] : e);
      };
      var retValue = addHandler(handler);
      return isFunction(removeHandler) ? function () {
        return removeHandler(handler, retValue);
      } : undefined;
    });
  }
  function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) {
      _a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity : _b, scheduler = _a.scheduler;
    } else {
      initialState = initialStateOrOptions;
      if (!resultSelectorOrScheduler || isScheduler(resultSelectorOrScheduler)) {
        resultSelector = identity;
        scheduler = resultSelectorOrScheduler;
      } else {
        resultSelector = resultSelectorOrScheduler;
      }
    }
    function gen() {
      var state;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            state = initialState;
            _a.label = 1;
          case 1:
            if (!(!condition || condition(state))) return [3, 4];
            return [4, resultSelector(state)];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            state = iterate(state);
            return [3, 1];
          case 4:
            return [2];
        }
      });
    }
    return defer(scheduler ? function () {
      return scheduleIterable(gen(), scheduler);
    } : gen);
  }
  function iif(condition, trueResult, falseResult) {
    return defer(function () {
      return condition() ? trueResult : falseResult;
    });
  }
  function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) {
      dueTime = 0;
    }
    if (scheduler === void 0) {
      scheduler = async;
    }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
      if (isScheduler(intervalOrScheduler)) {
        scheduler = intervalOrScheduler;
      } else {
        intervalDuration = intervalOrScheduler;
      }
    }
    return new Observable(function (subscriber) {
      var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
      if (due < 0) {
        due = 0;
      }
      var n = 0;
      return scheduler.schedule(function () {
        if (!subscriber.closed) {
          subscriber.next(n++);
          if (0 <= intervalDuration) {
            this.schedule(undefined, intervalDuration);
          } else {
            subscriber.complete();
          }
        }
      }, due);
    });
  }
  function interval(period, scheduler) {
    if (period === void 0) {
      period = 0;
    }
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    if (period < 0) {
      period = 0;
    }
    return timer(period, period, scheduler);
  }
  function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    var sources = args;
    return !sources.length ? EMPTY : sources.length === 1 ? innerFrom(sources[0]) : mergeAll(concurrent)(from(sources, scheduler));
  }
  var NEVER = new Observable(noop);
  function never() {
    return NEVER;
  }
  var isArray$2 = Array.isArray;
  function argsOrArgArray(args) {
    return args.length === 1 && isArray$2(args[0]) ? args[0] : args;
  }
  function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray(sources);
    return new Observable(function (subscriber) {
      var sourceIndex = 0;
      var subscribeNext = function () {
        if (sourceIndex < nextSources.length) {
          var nextSource = void 0;
          try {
            nextSource = innerFrom(nextSources[sourceIndex++]);
          } catch (err) {
            subscribeNext();
            return;
          }
          var innerSubscriber = new OperatorSubscriber(subscriber, undefined, noop, noop);
          nextSource.subscribe(innerSubscriber);
          innerSubscriber.add(subscribeNext);
        } else {
          subscriber.complete();
        }
      };
      subscribeNext();
    });
  }
  function pairs(obj, scheduler) {
    return from(Object.entries(obj), scheduler);
  }
  function not(pred, thisArg) {
    return function (value, index) {
      return !pred.call(thisArg, value, index);
    };
  }
  function filter(predicate, thisArg) {
    return operate(function (source, subscriber) {
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return predicate.call(thisArg, value, index++) && subscriber.next(value);
      }));
    });
  }
  function partition(source, predicate, thisArg) {
    return [filter(predicate, thisArg)(innerFrom(source)), filter(not(predicate, thisArg))(innerFrom(source))];
  }
  function race() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      sources[_i] = arguments[_i];
    }
    sources = argsOrArgArray(sources);
    return sources.length === 1 ? innerFrom(sources[0]) : new Observable(raceInit(sources));
  }
  function raceInit(sources) {
    return function (subscriber) {
      var subscriptions = [];
      var _loop_1 = function (i) {
        subscriptions.push(innerFrom(sources[i]).subscribe(createOperatorSubscriber(subscriber, function (value) {
          if (subscriptions) {
            for (var s = 0; s < subscriptions.length; s++) {
              s !== i && subscriptions[s].unsubscribe();
            }
            subscriptions = null;
          }
          subscriber.next(value);
        })));
      };
      for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
        _loop_1(i);
      }
    };
  }
  function range(start, count, scheduler) {
    if (count == null) {
      count = start;
      start = 0;
    }
    if (count <= 0) {
      return EMPTY;
    }
    var end = count + start;
    return new Observable(scheduler ? function (subscriber) {
      var n = start;
      return scheduler.schedule(function () {
        if (n < end) {
          subscriber.next(n++);
          this.schedule();
        } else {
          subscriber.complete();
        }
      });
    } : function (subscriber) {
      var n = start;
      while (n < end && !subscriber.closed) {
        subscriber.next(n++);
      }
      subscriber.complete();
    });
  }
  function using(resourceFactory, observableFactory) {
    return new Observable(function (subscriber) {
      var resource = resourceFactory();
      var result = observableFactory(resource);
      var source = result ? innerFrom(result) : EMPTY;
      source.subscribe(subscriber);
      return function () {
        if (resource) {
          resource.unsubscribe();
        }
      };
    });
  }
  function zip() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    var sources = argsOrArgArray(args);
    return sources.length ? new Observable(function (subscriber) {
      var buffers = sources.map(function () {
        return [];
      });
      var completed = sources.map(function () {
        return false;
      });
      subscriber.add(function () {
        buffers = completed = null;
      });
      var _loop_1 = function (sourceIndex) {
        innerFrom(sources[sourceIndex]).subscribe(createOperatorSubscriber(subscriber, function (value) {
          buffers[sourceIndex].push(value);
          if (buffers.every(function (buffer) {
            return buffer.length;
          })) {
            var result = buffers.map(function (buffer) {
              return buffer.shift();
            });
            subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray([], __read(result))) : result);
            if (buffers.some(function (buffer, i) {
              return !buffer.length && completed[i];
            })) {
              subscriber.complete();
            }
          }
        }, function () {
          completed[sourceIndex] = true;
          !buffers[sourceIndex].length && subscriber.complete();
        }));
      };
      for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
        _loop_1(sourceIndex);
      }
      return function () {
        buffers = completed = null;
      };
    }) : EMPTY;
  }
  function audit(durationSelector) {
    return operate(function (source, subscriber) {
      var hasValue = false;
      var lastValue = null;
      var durationSubscriber = null;
      var isComplete = false;
      var endDuration = function () {
        durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
        durationSubscriber = null;
        if (hasValue) {
          hasValue = false;
          var value = lastValue;
          lastValue = null;
          subscriber.next(value);
        }
        isComplete && subscriber.complete();
      };
      var cleanupDuration = function () {
        durationSubscriber = null;
        isComplete && subscriber.complete();
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        hasValue = true;
        lastValue = value;
        if (!durationSubscriber) {
          innerFrom(durationSelector(value)).subscribe(durationSubscriber = createOperatorSubscriber(subscriber, endDuration, cleanupDuration));
        }
      }, function () {
        isComplete = true;
        (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
      }));
    });
  }
  function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    return audit(function () {
      return timer(duration, scheduler);
    });
  }
  function buffer(closingNotifier) {
    return operate(function (source, subscriber) {
      var currentBuffer = [];
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return currentBuffer.push(value);
      }, function () {
        subscriber.next(currentBuffer);
        subscriber.complete();
      }));
      innerFrom(closingNotifier).subscribe(createOperatorSubscriber(subscriber, function () {
        var b = currentBuffer;
        currentBuffer = [];
        subscriber.next(b);
      }, noop));
      return function () {
        currentBuffer = null;
      };
    });
  }
  function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
      startBufferEvery = null;
    }
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return operate(function (source, subscriber) {
      var buffers = [];
      var count = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var e_1, _a, e_2, _b;
        var toEmit = null;
        if (count++ % startBufferEvery === 0) {
          buffers.push([]);
        }
        try {
          for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
            var buffer = buffers_1_1.value;
            buffer.push(value);
            if (bufferSize <= buffer.length) {
              toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
              toEmit.push(buffer);
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        if (toEmit) {
          try {
            for (var toEmit_1 = __values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
              var buffer = toEmit_1_1.value;
              arrRemove(buffers, buffer);
              subscriber.next(buffer);
            }
          } catch (e_2_1) {
            e_2 = {
              error: e_2_1
            };
          } finally {
            try {
              if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
            } finally {
              if (e_2) throw e_2.error;
            }
          }
        }
      }, function () {
        var e_3, _a;
        try {
          for (var buffers_2 = __values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
            var buffer = buffers_2_1.value;
            subscriber.next(buffer);
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
        subscriber.complete();
      }, undefined, function () {
        buffers = null;
      }));
    });
  }
  function bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : asyncScheduler;
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return operate(function (source, subscriber) {
      var bufferRecords = [];
      var restartOnEmit = false;
      var emit = function (record) {
        var buffer = record.buffer,
          subs = record.subs;
        subs.unsubscribe();
        arrRemove(bufferRecords, record);
        subscriber.next(buffer);
        restartOnEmit && startBuffer();
      };
      var startBuffer = function () {
        if (bufferRecords) {
          var subs = new Subscription();
          subscriber.add(subs);
          var buffer = [];
          var record_1 = {
            buffer: buffer,
            subs: subs
          };
          bufferRecords.push(record_1);
          executeSchedule(subs, scheduler, function () {
            return emit(record_1);
          }, bufferTimeSpan);
        }
      };
      if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
        executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
      } else {
        restartOnEmit = true;
      }
      startBuffer();
      var bufferTimeSubscriber = createOperatorSubscriber(subscriber, function (value) {
        var e_1, _a;
        var recordsCopy = bufferRecords.slice();
        try {
          for (var recordsCopy_1 = __values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
            var record = recordsCopy_1_1.value;
            var buffer = record.buffer;
            buffer.push(value);
            maxBufferSize <= buffer.length && emit(record);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }, function () {
        while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
          subscriber.next(bufferRecords.shift().buffer);
        }
        bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
        subscriber.complete();
        subscriber.unsubscribe();
      }, undefined, function () {
        return bufferRecords = null;
      });
      source.subscribe(bufferTimeSubscriber);
    });
  }
  function bufferToggle(openings, closingSelector) {
    return operate(function (source, subscriber) {
      var buffers = [];
      innerFrom(openings).subscribe(createOperatorSubscriber(subscriber, function (openValue) {
        var buffer = [];
        buffers.push(buffer);
        var closingSubscription = new Subscription();
        var emitBuffer = function () {
          arrRemove(buffers, buffer);
          subscriber.next(buffer);
          closingSubscription.unsubscribe();
        };
        closingSubscription.add(innerFrom(closingSelector(openValue)).subscribe(createOperatorSubscriber(subscriber, emitBuffer, noop)));
      }, noop));
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var e_1, _a;
        try {
          for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
            var buffer = buffers_1_1.value;
            buffer.push(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }, function () {
        while (buffers.length > 0) {
          subscriber.next(buffers.shift());
        }
        subscriber.complete();
      }));
    });
  }
  function bufferWhen(closingSelector) {
    return operate(function (source, subscriber) {
      var buffer = null;
      var closingSubscriber = null;
      var openBuffer = function () {
        closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
        var b = buffer;
        buffer = [];
        b && subscriber.next(b);
        innerFrom(closingSelector()).subscribe(closingSubscriber = createOperatorSubscriber(subscriber, openBuffer, noop));
      };
      openBuffer();
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return buffer === null || buffer === void 0 ? void 0 : buffer.push(value);
      }, function () {
        buffer && subscriber.next(buffer);
        subscriber.complete();
      }, undefined, function () {
        return buffer = closingSubscriber = null;
      }));
    });
  }
  function catchError(selector) {
    return operate(function (source, subscriber) {
      var innerSub = null;
      var syncUnsub = false;
      var handledResult;
      innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
        handledResult = innerFrom(selector(err, catchError(selector)(source)));
        if (innerSub) {
          innerSub.unsubscribe();
          innerSub = null;
          handledResult.subscribe(subscriber);
        } else {
          syncUnsub = true;
        }
      }));
      if (syncUnsub) {
        innerSub.unsubscribe();
        innerSub = null;
        handledResult.subscribe(subscriber);
      }
    });
  }
  function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function (source, subscriber) {
      var hasState = hasSeed;
      var state = seed;
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var i = index++;
        state = hasState ? accumulator(state, value, i) : (hasState = true, value);
        emitOnNext && subscriber.next(state);
      }, emitBeforeComplete && function () {
        hasState && subscriber.next(state);
        subscriber.complete();
      }));
    };
  }
  function reduce(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, false, true));
  }
  var arrReducer = function (arr, value) {
    return arr.push(value), arr;
  };
  function toArray() {
    return operate(function (source, subscriber) {
      reduce(arrReducer, [])(source).subscribe(subscriber);
    });
  }
  function joinAllInternals(joinFn, project) {
    return pipe(toArray(), mergeMap(function (sources) {
      return joinFn(sources);
    }), project ? mapOneOrManyArgs(project) : identity);
  }
  function combineLatestAll(project) {
    return joinAllInternals(combineLatest, project);
  }
  var combineAll = combineLatestAll;
  function combineLatest$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    return resultSelector ? pipe(combineLatest$1.apply(void 0, __spreadArray([], __read(args))), mapOneOrManyArgs(resultSelector)) : operate(function (source, subscriber) {
      combineLatestInit(__spreadArray([source], __read(argsOrArgArray(args))))(subscriber);
    });
  }
  function combineLatestWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      otherSources[_i] = arguments[_i];
    }
    return combineLatest$1.apply(void 0, __spreadArray([], __read(otherSources)));
  }
  function concatMap(project, resultSelector) {
    return isFunction(resultSelector) ? mergeMap(project, resultSelector, 1) : mergeMap(project, 1);
  }
  function concatMapTo(innerObservable, resultSelector) {
    return isFunction(resultSelector) ? concatMap(function () {
      return innerObservable;
    }, resultSelector) : concatMap(function () {
      return innerObservable;
    });
  }
  function concat$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return operate(function (source, subscriber) {
      concatAll()(from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
  }
  function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      otherSources[_i] = arguments[_i];
    }
    return concat$1.apply(void 0, __spreadArray([], __read(otherSources)));
  }
  function fromSubscribable(subscribable) {
    return new Observable(function (subscriber) {
      return subscribable.subscribe(subscriber);
    });
  }
  var DEFAULT_CONFIG$1 = {
    connector: function () {
      return new Subject();
    }
  };
  function connect(selector, config) {
    if (config === void 0) {
      config = DEFAULT_CONFIG$1;
    }
    var connector = config.connector;
    return operate(function (source, subscriber) {
      var subject = connector();
      innerFrom(selector(fromSubscribable(subject))).subscribe(subscriber);
      subscriber.add(source.subscribe(subject));
    });
  }
  function count(predicate) {
    return reduce(function (total, value, i) {
      return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
  }
  function debounce(durationSelector) {
    return operate(function (source, subscriber) {
      var hasValue = false;
      var lastValue = null;
      var durationSubscriber = null;
      var emit = function () {
        durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
        durationSubscriber = null;
        if (hasValue) {
          hasValue = false;
          var value = lastValue;
          lastValue = null;
          subscriber.next(value);
        }
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
        hasValue = true;
        lastValue = value;
        durationSubscriber = createOperatorSubscriber(subscriber, emit, noop);
        innerFrom(durationSelector(value)).subscribe(durationSubscriber);
      }, function () {
        emit();
        subscriber.complete();
      }, undefined, function () {
        lastValue = durationSubscriber = null;
      }));
    });
  }
  function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    return operate(function (source, subscriber) {
      var activeTask = null;
      var lastValue = null;
      var lastTime = null;
      var emit = function () {
        if (activeTask) {
          activeTask.unsubscribe();
          activeTask = null;
          var value = lastValue;
          lastValue = null;
          subscriber.next(value);
        }
      };
      function emitWhenIdle() {
        var targetTime = lastTime + dueTime;
        var now = scheduler.now();
        if (now < targetTime) {
          activeTask = this.schedule(undefined, targetTime - now);
          subscriber.add(activeTask);
          return;
        }
        emit();
      }
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        lastValue = value;
        lastTime = scheduler.now();
        if (!activeTask) {
          activeTask = scheduler.schedule(emitWhenIdle, dueTime);
          subscriber.add(activeTask);
        }
      }, function () {
        emit();
        subscriber.complete();
      }, undefined, function () {
        lastValue = activeTask = null;
      }));
    });
  }
  function defaultIfEmpty(defaultValue) {
    return operate(function (source, subscriber) {
      var hasValue = false;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        hasValue = true;
        subscriber.next(value);
      }, function () {
        if (!hasValue) {
          subscriber.next(defaultValue);
        }
        subscriber.complete();
      }));
    });
  }
  function take(count) {
    return count <= 0 ? function () {
      return EMPTY;
    } : operate(function (source, subscriber) {
      var seen = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        if (++seen <= count) {
          subscriber.next(value);
          if (count <= seen) {
            subscriber.complete();
          }
        }
      }));
    });
  }
  function ignoreElements() {
    return operate(function (source, subscriber) {
      source.subscribe(createOperatorSubscriber(subscriber, noop));
    });
  }
  function mapTo(value) {
    return map(function () {
      return value;
    });
  }
  function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
      return function (source) {
        return concat(subscriptionDelay.pipe(take(1), ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
      };
    }
    return mergeMap(function (value, index) {
      return innerFrom(delayDurationSelector(value, index)).pipe(take(1), mapTo(value));
    });
  }
  function delay(due, scheduler) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    var duration = timer(due, scheduler);
    return delayWhen(function () {
      return duration;
    });
  }
  function dematerialize() {
    return operate(function (source, subscriber) {
      source.subscribe(createOperatorSubscriber(subscriber, function (notification) {
        return observeNotification(notification, subscriber);
      }));
    });
  }
  function distinct(keySelector, flushes) {
    return operate(function (source, subscriber) {
      var distinctKeys = new Set();
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var key = keySelector ? keySelector(value) : value;
        if (!distinctKeys.has(key)) {
          distinctKeys.add(key);
          subscriber.next(value);
        }
      }));
      flushes && innerFrom(flushes).subscribe(createOperatorSubscriber(subscriber, function () {
        return distinctKeys.clear();
      }, noop));
    });
  }
  function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) {
      keySelector = identity;
    }
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return operate(function (source, subscriber) {
      var previousKey;
      var first = true;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var currentKey = keySelector(value);
        if (first || !comparator(previousKey, currentKey)) {
          first = false;
          previousKey = currentKey;
          subscriber.next(value);
        }
      }));
    });
  }
  function defaultCompare(a, b) {
    return a === b;
  }
  function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged(function (x, y) {
      return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
  }
  function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) {
      errorFactory = defaultErrorFactory;
    }
    return operate(function (source, subscriber) {
      var hasValue = false;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        hasValue = true;
        subscriber.next(value);
      }, function () {
        return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
      }));
    });
  }
  function defaultErrorFactory() {
    return new EmptyError();
  }
  function elementAt(index, defaultValue) {
    if (index < 0) {
      throw new ArgumentOutOfRangeError();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
      return source.pipe(filter(function (v, i) {
        return i === index;
      }), take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () {
        return new ArgumentOutOfRangeError();
      }));
    };
  }
  function endWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      values[_i] = arguments[_i];
    }
    return function (source) {
      return concat(source, of.apply(void 0, __spreadArray([], __read(values))));
    };
  }
  function every(predicate, thisArg) {
    return operate(function (source, subscriber) {
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        if (!predicate.call(thisArg, value, index++, source)) {
          subscriber.next(false);
          subscriber.complete();
        }
      }, function () {
        subscriber.next(true);
        subscriber.complete();
      }));
    });
  }
  function exhaustMap(project, resultSelector) {
    if (resultSelector) {
      return function (source) {
        return source.pipe(exhaustMap(function (a, i) {
          return innerFrom(project(a, i)).pipe(map(function (b, ii) {
            return resultSelector(a, b, i, ii);
          }));
        }));
      };
    }
    return operate(function (source, subscriber) {
      var index = 0;
      var innerSub = null;
      var isComplete = false;
      source.subscribe(createOperatorSubscriber(subscriber, function (outerValue) {
        if (!innerSub) {
          innerSub = createOperatorSubscriber(subscriber, undefined, function () {
            innerSub = null;
            isComplete && subscriber.complete();
          });
          innerFrom(project(outerValue, index++)).subscribe(innerSub);
        }
      }, function () {
        isComplete = true;
        !innerSub && subscriber.complete();
      }));
    });
  }
  function exhaustAll() {
    return exhaustMap(identity);
  }
  var exhaust = exhaustAll;
  function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
      concurrent = Infinity;
    }
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return operate(function (source, subscriber) {
      return mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
  }
  function finalize(callback) {
    return operate(function (source, subscriber) {
      try {
        source.subscribe(subscriber);
      } finally {
        subscriber.add(callback);
      }
    });
  }
  function find(predicate, thisArg) {
    return operate(createFind(predicate, thisArg, 'value'));
  }
  function createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function (source, subscriber) {
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var i = index++;
        if (predicate.call(thisArg, value, i, source)) {
          subscriber.next(findIndex ? i : value);
          subscriber.complete();
        }
      }, function () {
        subscriber.next(findIndex ? -1 : undefined);
        subscriber.complete();
      }));
    };
  }
  function findIndex(predicate, thisArg) {
    return operate(createFind(predicate, thisArg, 'index'));
  }
  function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
      return source.pipe(predicate ? filter(function (v, i) {
        return predicate(v, i, source);
      }) : identity, take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () {
        return new EmptyError();
      }));
    };
  }
  function groupBy(keySelector, elementOrOptions, duration, connector) {
    return operate(function (source, subscriber) {
      var element;
      if (!elementOrOptions || typeof elementOrOptions === 'function') {
        element = elementOrOptions;
      } else {
        duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
      }
      var groups = new Map();
      var notify = function (cb) {
        groups.forEach(cb);
        cb(subscriber);
      };
      var handleError = function (err) {
        return notify(function (consumer) {
          return consumer.error(err);
        });
      };
      var activeGroups = 0;
      var teardownAttempted = false;
      var groupBySourceSubscriber = new OperatorSubscriber(subscriber, function (value) {
        try {
          var key_1 = keySelector(value);
          var group_1 = groups.get(key_1);
          if (!group_1) {
            groups.set(key_1, group_1 = connector ? connector() : new Subject());
            var grouped = createGroupedObservable(key_1, group_1);
            subscriber.next(grouped);
            if (duration) {
              var durationSubscriber_1 = createOperatorSubscriber(group_1, function () {
                group_1.complete();
                durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
              }, undefined, undefined, function () {
                return groups.delete(key_1);
              });
              groupBySourceSubscriber.add(innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
            }
          }
          group_1.next(element ? element(value) : value);
        } catch (err) {
          handleError(err);
        }
      }, function () {
        return notify(function (consumer) {
          return consumer.complete();
        });
      }, handleError, function () {
        return groups.clear();
      }, function () {
        teardownAttempted = true;
        return activeGroups === 0;
      });
      source.subscribe(groupBySourceSubscriber);
      function createGroupedObservable(key, groupSubject) {
        var result = new Observable(function (groupSubscriber) {
          activeGroups++;
          var innerSub = groupSubject.subscribe(groupSubscriber);
          return function () {
            innerSub.unsubscribe();
            --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
          };
        });
        result.key = key;
        return result;
      }
    });
  }
  function isEmpty() {
    return operate(function (source, subscriber) {
      source.subscribe(createOperatorSubscriber(subscriber, function () {
        subscriber.next(false);
        subscriber.complete();
      }, function () {
        subscriber.next(true);
        subscriber.complete();
      }));
    });
  }
  function takeLast(count) {
    return count <= 0 ? function () {
      return EMPTY;
    } : operate(function (source, subscriber) {
      var buffer = [];
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        buffer.push(value);
        count < buffer.length && buffer.shift();
      }, function () {
        var e_1, _a;
        try {
          for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
            var value = buffer_1_1.value;
            subscriber.next(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        subscriber.complete();
      }, undefined, function () {
        buffer = null;
      }));
    });
  }
  function last$1(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
      return source.pipe(predicate ? filter(function (v, i) {
        return predicate(v, i, source);
      }) : identity, takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () {
        return new EmptyError();
      }));
    };
  }
  function materialize() {
    return operate(function (source, subscriber) {
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        subscriber.next(Notification.createNext(value));
      }, function () {
        subscriber.next(Notification.createComplete());
        subscriber.complete();
      }, function (err) {
        subscriber.next(Notification.createError(err));
        subscriber.complete();
      }));
    });
  }
  function max(comparer) {
    return reduce(isFunction(comparer) ? function (x, y) {
      return comparer(x, y) > 0 ? x : y;
    } : function (x, y) {
      return x > y ? x : y;
    });
  }
  var flatMap = mergeMap;
  function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
      concurrent = Infinity;
    }
    if (isFunction(resultSelector)) {
      return mergeMap(function () {
        return innerObservable;
      }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
      concurrent = resultSelector;
    }
    return mergeMap(function () {
      return innerObservable;
    }, concurrent);
  }
  function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
      concurrent = Infinity;
    }
    return operate(function (source, subscriber) {
      var state = seed;
      return mergeInternals(source, subscriber, function (value, index) {
        return accumulator(state, value, index);
      }, concurrent, function (value) {
        state = value;
      }, false, undefined, function () {
        return state = null;
      });
    });
  }
  function merge$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    args = argsOrArgArray(args);
    return operate(function (source, subscriber) {
      mergeAll(concurrent)(from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
  }
  function mergeWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      otherSources[_i] = arguments[_i];
    }
    return merge$1.apply(void 0, __spreadArray([], __read(otherSources)));
  }
  function min(comparer) {
    return reduce(isFunction(comparer) ? function (x, y) {
      return comparer(x, y) < 0 ? x : y;
    } : function (x, y) {
      return x < y ? x : y;
    });
  }
  function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () {
      return subjectOrSubjectFactory;
    };
    if (isFunction(selector)) {
      return connect(selector, {
        connector: subjectFactory
      });
    }
    return function (source) {
      return new ConnectableObservable(source, subjectFactory);
    };
  }
  function onErrorResumeNextWith() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray(sources);
    return function (source) {
      return onErrorResumeNext.apply(void 0, __spreadArray([source], __read(nextSources)));
    };
  }
  var onErrorResumeNext$1 = onErrorResumeNextWith;
  function pairwise() {
    return operate(function (source, subscriber) {
      var prev;
      var hasPrev = false;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var p = prev;
        prev = value;
        hasPrev && subscriber.next([p, value]);
        hasPrev = true;
      }));
    });
  }
  function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
      throw new Error('list of properties cannot be empty.');
    }
    return map(function (x) {
      var currentProp = x;
      for (var i = 0; i < length; i++) {
        var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
        if (typeof p !== 'undefined') {
          currentProp = p;
        } else {
          return undefined;
        }
      }
      return currentProp;
    });
  }
  function publish(selector) {
    return selector ? function (source) {
      return connect(selector)(source);
    } : function (source) {
      return multicast(new Subject())(source);
    };
  }
  function publishBehavior(initialValue) {
    return function (source) {
      var subject = new BehaviorSubject(initialValue);
      return new ConnectableObservable(source, function () {
        return subject;
      });
    };
  }
  function publishLast() {
    return function (source) {
      var subject = new AsyncSubject();
      return new ConnectableObservable(source, function () {
        return subject;
      });
    };
  }
  function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !isFunction(selectorOrScheduler)) {
      timestampProvider = selectorOrScheduler;
    }
    var selector = isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function (source) {
      return multicast(new ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source);
    };
  }
  function raceWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      otherSources[_i] = arguments[_i];
    }
    return !otherSources.length ? identity : operate(function (source, subscriber) {
      raceInit(__spreadArray([source], __read(otherSources)))(subscriber);
    });
  }
  function repeat(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
      if (typeof countOrConfig === 'object') {
        _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay;
      } else {
        count = countOrConfig;
      }
    }
    return count <= 0 ? function () {
      return EMPTY;
    } : operate(function (source, subscriber) {
      var soFar = 0;
      var sourceSub;
      var resubscribe = function () {
        sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
        sourceSub = null;
        if (delay != null) {
          var notifier = typeof delay === 'number' ? timer(delay) : innerFrom(delay(soFar));
          var notifierSubscriber_1 = createOperatorSubscriber(subscriber, function () {
            notifierSubscriber_1.unsubscribe();
            subscribeToSource();
          });
          notifier.subscribe(notifierSubscriber_1);
        } else {
          subscribeToSource();
        }
      };
      var subscribeToSource = function () {
        var syncUnsub = false;
        sourceSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, function () {
          if (++soFar < count) {
            if (sourceSub) {
              resubscribe();
            } else {
              syncUnsub = true;
            }
          } else {
            subscriber.complete();
          }
        }));
        if (syncUnsub) {
          resubscribe();
        }
      };
      subscribeToSource();
    });
  }
  function repeatWhen(notifier) {
    return operate(function (source, subscriber) {
      var innerSub;
      var syncResub = false;
      var completions$;
      var isNotifierComplete = false;
      var isMainComplete = false;
      var checkComplete = function () {
        return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
      };
      var getCompletionSubject = function () {
        if (!completions$) {
          completions$ = new Subject();
          innerFrom(notifier(completions$)).subscribe(createOperatorSubscriber(subscriber, function () {
            if (innerSub) {
              subscribeForRepeatWhen();
            } else {
              syncResub = true;
            }
          }, function () {
            isNotifierComplete = true;
            checkComplete();
          }));
        }
        return completions$;
      };
      var subscribeForRepeatWhen = function () {
        isMainComplete = false;
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, function () {
          isMainComplete = true;
          !checkComplete() && getCompletionSubject().next();
        }));
        if (syncResub) {
          innerSub.unsubscribe();
          innerSub = null;
          syncResub = false;
          subscribeForRepeatWhen();
        }
      };
      subscribeForRepeatWhen();
    });
  }
  function retry(configOrCount) {
    if (configOrCount === void 0) {
      configOrCount = Infinity;
    }
    var config;
    if (configOrCount && typeof configOrCount === 'object') {
      config = configOrCount;
    } else {
      config = {
        count: configOrCount
      };
    }
    var _a = config.count,
      count = _a === void 0 ? Infinity : _a,
      delay = config.delay,
      _b = config.resetOnSuccess,
      resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? identity : operate(function (source, subscriber) {
      var soFar = 0;
      var innerSub;
      var subscribeForRetry = function () {
        var syncUnsub = false;
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, function (value) {
          if (resetOnSuccess) {
            soFar = 0;
          }
          subscriber.next(value);
        }, undefined, function (err) {
          if (soFar++ < count) {
            var resub_1 = function () {
              if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
              } else {
                syncUnsub = true;
              }
            };
            if (delay != null) {
              var notifier = typeof delay === 'number' ? timer(delay) : innerFrom(delay(err, soFar));
              var notifierSubscriber_1 = createOperatorSubscriber(subscriber, function () {
                notifierSubscriber_1.unsubscribe();
                resub_1();
              }, function () {
                subscriber.complete();
              });
              notifier.subscribe(notifierSubscriber_1);
            } else {
              resub_1();
            }
          } else {
            subscriber.error(err);
          }
        }));
        if (syncUnsub) {
          innerSub.unsubscribe();
          innerSub = null;
          subscribeForRetry();
        }
      };
      subscribeForRetry();
    });
  }
  function retryWhen(notifier) {
    return operate(function (source, subscriber) {
      var innerSub;
      var syncResub = false;
      var errors$;
      var subscribeForRetryWhen = function () {
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
          if (!errors$) {
            errors$ = new Subject();
            innerFrom(notifier(errors$)).subscribe(createOperatorSubscriber(subscriber, function () {
              return innerSub ? subscribeForRetryWhen() : syncResub = true;
            }));
          }
          if (errors$) {
            errors$.next(err);
          }
        }));
        if (syncResub) {
          innerSub.unsubscribe();
          innerSub = null;
          syncResub = false;
          subscribeForRetryWhen();
        }
      };
      subscribeForRetryWhen();
    });
  }
  function sample(notifier) {
    return operate(function (source, subscriber) {
      var hasValue = false;
      var lastValue = null;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        hasValue = true;
        lastValue = value;
      }));
      innerFrom(notifier).subscribe(createOperatorSubscriber(subscriber, function () {
        if (hasValue) {
          hasValue = false;
          var value = lastValue;
          lastValue = null;
          subscriber.next(value);
        }
      }, noop));
    });
  }
  function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    return sample(interval(period, scheduler));
  }
  function scan(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, true));
  }
  function sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) {
      comparator = function (a, b) {
        return a === b;
      };
    }
    return operate(function (source, subscriber) {
      var aState = createState();
      var bState = createState();
      var emit = function (isEqual) {
        subscriber.next(isEqual);
        subscriber.complete();
      };
      var createSubscriber = function (selfState, otherState) {
        var sequenceEqualSubscriber = createOperatorSubscriber(subscriber, function (a) {
          var buffer = otherState.buffer,
            complete = otherState.complete;
          if (buffer.length === 0) {
            complete ? emit(false) : selfState.buffer.push(a);
          } else {
            !comparator(a, buffer.shift()) && emit(false);
          }
        }, function () {
          selfState.complete = true;
          var complete = otherState.complete,
            buffer = otherState.buffer;
          complete && emit(buffer.length === 0);
          sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
        });
        return sequenceEqualSubscriber;
      };
      source.subscribe(createSubscriber(aState, bState));
      innerFrom(compareTo).subscribe(createSubscriber(bState, aState));
    });
  }
  function createState() {
    return {
      buffer: [],
      complete: false
    };
  }
  function share(options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.connector,
      connector = _a === void 0 ? function () {
        return new Subject();
      } : _a,
      _b = options.resetOnError,
      resetOnError = _b === void 0 ? true : _b,
      _c = options.resetOnComplete,
      resetOnComplete = _c === void 0 ? true : _c,
      _d = options.resetOnRefCountZero,
      resetOnRefCountZero = _d === void 0 ? true : _d;
    return function (wrapperSource) {
      var connection;
      var resetConnection;
      var subject;
      var refCount = 0;
      var hasCompleted = false;
      var hasErrored = false;
      var cancelReset = function () {
        resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
        resetConnection = undefined;
      };
      var reset = function () {
        cancelReset();
        connection = subject = undefined;
        hasCompleted = hasErrored = false;
      };
      var resetAndUnsubscribe = function () {
        var conn = connection;
        reset();
        conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
      };
      return operate(function (source, subscriber) {
        refCount++;
        if (!hasErrored && !hasCompleted) {
          cancelReset();
        }
        var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
        subscriber.add(function () {
          refCount--;
          if (refCount === 0 && !hasErrored && !hasCompleted) {
            resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
          }
        });
        dest.subscribe(subscriber);
        if (!connection && refCount > 0) {
          connection = new SafeSubscriber({
            next: function (value) {
              return dest.next(value);
            },
            error: function (err) {
              hasErrored = true;
              cancelReset();
              resetConnection = handleReset(reset, resetOnError, err);
              dest.error(err);
            },
            complete: function () {
              hasCompleted = true;
              cancelReset();
              resetConnection = handleReset(reset, resetOnComplete);
              dest.complete();
            }
          });
          innerFrom(source).subscribe(connection);
        }
      })(wrapperSource);
    };
  }
  function handleReset(reset, on) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    if (on === true) {
      reset();
      return;
    }
    if (on === false) {
      return;
    }
    var onSubscriber = new SafeSubscriber({
      next: function () {
        onSubscriber.unsubscribe();
        reset();
      }
    });
    return innerFrom(on.apply(void 0, __spreadArray([], __read(args)))).subscribe(onSubscriber);
  }
  function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
      _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    } else {
      bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    }
    return share({
      connector: function () {
        return new ReplaySubject(bufferSize, windowTime, scheduler);
      },
      resetOnError: true,
      resetOnComplete: false,
      resetOnRefCountZero: refCount
    });
  }
  function single(predicate) {
    return operate(function (source, subscriber) {
      var hasValue = false;
      var singleValue;
      var seenValue = false;
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        seenValue = true;
        if (!predicate || predicate(value, index++, source)) {
          hasValue && subscriber.error(new SequenceError('Too many matching values'));
          hasValue = true;
          singleValue = value;
        }
      }, function () {
        if (hasValue) {
          subscriber.next(singleValue);
          subscriber.complete();
        } else {
          subscriber.error(seenValue ? new NotFoundError('No matching values') : new EmptyError());
        }
      }));
    });
  }
  function skip(count) {
    return filter(function (_, index) {
      return count <= index;
    });
  }
  function skipLast(skipCount) {
    return skipCount <= 0 ? identity : operate(function (source, subscriber) {
      var ring = new Array(skipCount);
      var seen = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var valueIndex = seen++;
        if (valueIndex < skipCount) {
          ring[valueIndex] = value;
        } else {
          var index = valueIndex % skipCount;
          var oldValue = ring[index];
          ring[index] = value;
          subscriber.next(oldValue);
        }
      }));
      return function () {
        ring = null;
      };
    });
  }
  function skipUntil(notifier) {
    return operate(function (source, subscriber) {
      var taking = false;
      var skipSubscriber = createOperatorSubscriber(subscriber, function () {
        skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
        taking = true;
      }, noop);
      innerFrom(notifier).subscribe(skipSubscriber);
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return taking && subscriber.next(value);
      }));
    });
  }
  function skipWhile(predicate) {
    return operate(function (source, subscriber) {
      var taking = false;
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return (taking || (taking = !predicate(value, index++))) && subscriber.next(value);
      }));
    });
  }
  function startWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      values[_i] = arguments[_i];
    }
    var scheduler = popScheduler(values);
    return operate(function (source, subscriber) {
      (scheduler ? concat(values, source, scheduler) : concat(values, source)).subscribe(subscriber);
    });
  }
  function switchMap(project, resultSelector) {
    return operate(function (source, subscriber) {
      var innerSubscriber = null;
      var index = 0;
      var isComplete = false;
      var checkComplete = function () {
        return isComplete && !innerSubscriber && subscriber.complete();
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
        var innerIndex = 0;
        var outerIndex = index++;
        innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = createOperatorSubscriber(subscriber, function (innerValue) {
          return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
        }, function () {
          innerSubscriber = null;
          checkComplete();
        }));
      }, function () {
        isComplete = true;
        checkComplete();
      }));
    });
  }
  function switchAll() {
    return switchMap(identity);
  }
  function switchMapTo(innerObservable, resultSelector) {
    return isFunction(resultSelector) ? switchMap(function () {
      return innerObservable;
    }, resultSelector) : switchMap(function () {
      return innerObservable;
    });
  }
  function switchScan(accumulator, seed) {
    return operate(function (source, subscriber) {
      var state = seed;
      switchMap(function (value, index) {
        return accumulator(state, value, index);
      }, function (_, innerValue) {
        return state = innerValue, innerValue;
      })(source).subscribe(subscriber);
      return function () {
        state = null;
      };
    });
  }
  function takeUntil(notifier) {
    return operate(function (source, subscriber) {
      innerFrom(notifier).subscribe(createOperatorSubscriber(subscriber, function () {
        return subscriber.complete();
      }, noop));
      !subscriber.closed && source.subscribe(subscriber);
    });
  }
  function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) {
      inclusive = false;
    }
    return operate(function (source, subscriber) {
      var index = 0;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var result = predicate(value, index++);
        (result || inclusive) && subscriber.next(value);
        !result && subscriber.complete();
      }));
    });
  }
  function tap(observerOrNext, error, complete) {
    var tapObserver = isFunction(observerOrNext) || error || complete ? {
      next: observerOrNext,
      error: error,
      complete: complete
    } : observerOrNext;
    return tapObserver ? operate(function (source, subscriber) {
      var _a;
      (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
      var isUnsub = true;
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var _a;
        (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
        subscriber.next(value);
      }, function () {
        var _a;
        isUnsub = false;
        (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
        subscriber.complete();
      }, function (err) {
        var _a;
        isUnsub = false;
        (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
        subscriber.error(err);
      }, function () {
        var _a, _b;
        if (isUnsub) {
          (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
        }
        (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
      }));
    }) : identity;
  }
  function throttle(durationSelector, config) {
    return operate(function (source, subscriber) {
      var _a = config !== null && config !== void 0 ? config : {},
        _b = _a.leading,
        leading = _b === void 0 ? true : _b,
        _c = _a.trailing,
        trailing = _c === void 0 ? false : _c;
      var hasValue = false;
      var sendValue = null;
      var throttled = null;
      var isComplete = false;
      var endThrottling = function () {
        throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
        throttled = null;
        if (trailing) {
          send();
          isComplete && subscriber.complete();
        }
      };
      var cleanupThrottling = function () {
        throttled = null;
        isComplete && subscriber.complete();
      };
      var startThrottle = function (value) {
        return throttled = innerFrom(durationSelector(value)).subscribe(createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling));
      };
      var send = function () {
        if (hasValue) {
          hasValue = false;
          var value = sendValue;
          sendValue = null;
          subscriber.next(value);
          !isComplete && startThrottle(value);
        }
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        hasValue = true;
        sendValue = value;
        !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
      }, function () {
        isComplete = true;
        !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
      }));
    });
  }
  function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    var duration$ = timer(duration, scheduler);
    return throttle(function () {
      return duration$;
    }, config);
  }
  function timeInterval(scheduler) {
    if (scheduler === void 0) {
      scheduler = asyncScheduler;
    }
    return operate(function (source, subscriber) {
      var last = scheduler.now();
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var now = scheduler.now();
        var interval = now - last;
        last = now;
        subscriber.next(new TimeInterval(value, interval));
      }));
    });
  }
  var TimeInterval = function () {
    function TimeInterval(value, interval) {
      this.value = value;
      this.interval = interval;
    }
    return TimeInterval;
  }();
  function timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async;
    if (isValidDate(due)) {
      first = due;
    } else if (typeof due === 'number') {
      each = due;
    }
    if (withObservable) {
      _with = function () {
        return withObservable;
      };
    } else {
      throw new TypeError('No observable provided to switch to');
    }
    if (first == null && each == null) {
      throw new TypeError('No timeout provided.');
    }
    return timeout({
      first: first,
      each: each,
      scheduler: scheduler,
      with: _with
    });
  }
  function timestamp(timestampProvider) {
    if (timestampProvider === void 0) {
      timestampProvider = dateTimestampProvider;
    }
    return map(function (value) {
      return {
        value: value,
        timestamp: timestampProvider.now()
      };
    });
  }
  function window(windowBoundaries) {
    return operate(function (source, subscriber) {
      var windowSubject = new Subject();
      subscriber.next(windowSubject.asObservable());
      var errorHandler = function (err) {
        windowSubject.error(err);
        subscriber.error(err);
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
      }, function () {
        windowSubject.complete();
        subscriber.complete();
      }, errorHandler));
      innerFrom(windowBoundaries).subscribe(createOperatorSubscriber(subscriber, function () {
        windowSubject.complete();
        subscriber.next(windowSubject = new Subject());
      }, noop, errorHandler));
      return function () {
        windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
        windowSubject = null;
      };
    });
  }
  function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
      startWindowEvery = 0;
    }
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return operate(function (source, subscriber) {
      var windows = [new Subject()];
      var count = 0;
      subscriber.next(windows[0].asObservable());
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var e_1, _a;
        try {
          for (var windows_1 = __values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
            var window_1 = windows_1_1.value;
            window_1.next(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        var c = count - windowSize + 1;
        if (c >= 0 && c % startEvery === 0) {
          windows.shift().complete();
        }
        if (++count % startEvery === 0) {
          var window_2 = new Subject();
          windows.push(window_2);
          subscriber.next(window_2.asObservable());
        }
      }, function () {
        while (windows.length > 0) {
          windows.shift().complete();
        }
        subscriber.complete();
      }, function (err) {
        while (windows.length > 0) {
          windows.shift().error(err);
        }
        subscriber.error(err);
      }, function () {
        windows = null;
      }));
    });
  }
  function windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : asyncScheduler;
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return operate(function (source, subscriber) {
      var windowRecords = [];
      var restartOnClose = false;
      var closeWindow = function (record) {
        var window = record.window,
          subs = record.subs;
        window.complete();
        subs.unsubscribe();
        arrRemove(windowRecords, record);
        restartOnClose && startWindow();
      };
      var startWindow = function () {
        if (windowRecords) {
          var subs = new Subscription();
          subscriber.add(subs);
          var window_1 = new Subject();
          var record_1 = {
            window: window_1,
            subs: subs,
            seen: 0
          };
          windowRecords.push(record_1);
          subscriber.next(window_1.asObservable());
          executeSchedule(subs, scheduler, function () {
            return closeWindow(record_1);
          }, windowTimeSpan);
        }
      };
      if (windowCreationInterval !== null && windowCreationInterval >= 0) {
        executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
      } else {
        restartOnClose = true;
      }
      startWindow();
      var loop = function (cb) {
        return windowRecords.slice().forEach(cb);
      };
      var terminate = function (cb) {
        loop(function (_a) {
          var window = _a.window;
          return cb(window);
        });
        cb(subscriber);
        subscriber.unsubscribe();
      };
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        loop(function (record) {
          record.window.next(value);
          maxWindowSize <= ++record.seen && closeWindow(record);
        });
      }, function () {
        return terminate(function (consumer) {
          return consumer.complete();
        });
      }, function (err) {
        return terminate(function (consumer) {
          return consumer.error(err);
        });
      }));
      return function () {
        windowRecords = null;
      };
    });
  }
  function windowToggle(openings, closingSelector) {
    return operate(function (source, subscriber) {
      var windows = [];
      var handleError = function (err) {
        while (0 < windows.length) {
          windows.shift().error(err);
        }
        subscriber.error(err);
      };
      innerFrom(openings).subscribe(createOperatorSubscriber(subscriber, function (openValue) {
        var window = new Subject();
        windows.push(window);
        var closingSubscription = new Subscription();
        var closeWindow = function () {
          arrRemove(windows, window);
          window.complete();
          closingSubscription.unsubscribe();
        };
        var closingNotifier;
        try {
          closingNotifier = innerFrom(closingSelector(openValue));
        } catch (err) {
          handleError(err);
          return;
        }
        subscriber.next(window.asObservable());
        closingSubscription.add(closingNotifier.subscribe(createOperatorSubscriber(subscriber, closeWindow, noop, handleError)));
      }, noop));
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        var e_1, _a;
        var windowsCopy = windows.slice();
        try {
          for (var windowsCopy_1 = __values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
            var window_1 = windowsCopy_1_1.value;
            window_1.next(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }, function () {
        while (0 < windows.length) {
          windows.shift().complete();
        }
        subscriber.complete();
      }, handleError, function () {
        while (0 < windows.length) {
          windows.shift().unsubscribe();
        }
      }));
    });
  }
  function windowWhen(closingSelector) {
    return operate(function (source, subscriber) {
      var window;
      var closingSubscriber;
      var handleError = function (err) {
        window.error(err);
        subscriber.error(err);
      };
      var openWindow = function () {
        closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
        window === null || window === void 0 ? void 0 : window.complete();
        window = new Subject();
        subscriber.next(window.asObservable());
        var closingNotifier;
        try {
          closingNotifier = innerFrom(closingSelector());
        } catch (err) {
          handleError(err);
          return;
        }
        closingNotifier.subscribe(closingSubscriber = createOperatorSubscriber(subscriber, openWindow, openWindow, handleError));
      };
      openWindow();
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        return window.next(value);
      }, function () {
        window.complete();
        subscriber.complete();
      }, handleError, function () {
        closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
        window = null;
      }));
    });
  }
  function withLatestFrom() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      inputs[_i] = arguments[_i];
    }
    var project = popResultSelector(inputs);
    return operate(function (source, subscriber) {
      var len = inputs.length;
      var otherValues = new Array(len);
      var hasValue = inputs.map(function () {
        return false;
      });
      var ready = false;
      var _loop_1 = function (i) {
        innerFrom(inputs[i]).subscribe(createOperatorSubscriber(subscriber, function (value) {
          otherValues[i] = value;
          if (!ready && !hasValue[i]) {
            hasValue[i] = true;
            (ready = hasValue.every(identity)) && (hasValue = null);
          }
        }, noop));
      };
      for (var i = 0; i < len; i++) {
        _loop_1(i);
      }
      source.subscribe(createOperatorSubscriber(subscriber, function (value) {
        if (ready) {
          var values = __spreadArray([value], __read(otherValues));
          subscriber.next(project ? project.apply(void 0, __spreadArray([], __read(values))) : values);
        }
      }));
    });
  }
  function zipAll(project) {
    return joinAllInternals(zip, project);
  }
  function zip$1() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      sources[_i] = arguments[_i];
    }
    return operate(function (source, subscriber) {
      zip.apply(void 0, __spreadArray([source], __read(sources))).subscribe(subscriber);
    });
  }
  function zipWith() {
    var otherInputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      otherInputs[_i] = arguments[_i];
    }
    return zip$1.apply(void 0, __spreadArray([], __read(otherInputs)));
  }
  function partition$1(predicate, thisArg) {
    return function (source) {
      return [filter(predicate, thisArg)(source), filter(not(predicate, thisArg))(source)];
    };
  }
  function race$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return raceWith.apply(void 0, __spreadArray([], __read(argsOrArgArray(args))));
  }
  var _operators = /*#__PURE__*/Object.freeze({
    audit: audit,
    auditTime: auditTime,
    buffer: buffer,
    bufferCount: bufferCount,
    bufferTime: bufferTime,
    bufferToggle: bufferToggle,
    bufferWhen: bufferWhen,
    catchError: catchError,
    combineAll: combineAll,
    combineLatestAll: combineLatestAll,
    combineLatest: combineLatest$1,
    combineLatestWith: combineLatestWith,
    concat: concat$1,
    concatAll: concatAll,
    concatMap: concatMap,
    concatMapTo: concatMapTo,
    concatWith: concatWith,
    connect: connect,
    count: count,
    debounce: debounce,
    debounceTime: debounceTime,
    defaultIfEmpty: defaultIfEmpty,
    delay: delay,
    delayWhen: delayWhen,
    dematerialize: dematerialize,
    distinct: distinct,
    distinctUntilChanged: distinctUntilChanged,
    distinctUntilKeyChanged: distinctUntilKeyChanged,
    elementAt: elementAt,
    endWith: endWith,
    every: every,
    exhaust: exhaust,
    exhaustAll: exhaustAll,
    exhaustMap: exhaustMap,
    expand: expand,
    filter: filter,
    finalize: finalize,
    find: find,
    findIndex: findIndex,
    first: first,
    groupBy: groupBy,
    ignoreElements: ignoreElements,
    isEmpty: isEmpty,
    last: last$1,
    map: map,
    mapTo: mapTo,
    materialize: materialize,
    max: max,
    merge: merge$1,
    mergeAll: mergeAll,
    flatMap: flatMap,
    mergeMap: mergeMap,
    mergeMapTo: mergeMapTo,
    mergeScan: mergeScan,
    mergeWith: mergeWith,
    min: min,
    multicast: multicast,
    observeOn: observeOn,
    onErrorResumeNext: onErrorResumeNext$1,
    pairwise: pairwise,
    partition: partition$1,
    pluck: pluck,
    publish: publish,
    publishBehavior: publishBehavior,
    publishLast: publishLast,
    publishReplay: publishReplay,
    race: race$1,
    raceWith: raceWith,
    reduce: reduce,
    repeat: repeat,
    repeatWhen: repeatWhen,
    retry: retry,
    retryWhen: retryWhen,
    refCount: refCount,
    sample: sample,
    sampleTime: sampleTime,
    scan: scan,
    sequenceEqual: sequenceEqual,
    share: share,
    shareReplay: shareReplay,
    single: single,
    skip: skip,
    skipLast: skipLast,
    skipUntil: skipUntil,
    skipWhile: skipWhile,
    startWith: startWith,
    subscribeOn: subscribeOn,
    switchAll: switchAll,
    switchMap: switchMap,
    switchMapTo: switchMapTo,
    switchScan: switchScan,
    take: take,
    takeLast: takeLast,
    takeUntil: takeUntil,
    takeWhile: takeWhile,
    tap: tap,
    throttle: throttle,
    throttleTime: throttleTime,
    throwIfEmpty: throwIfEmpty,
    timeInterval: timeInterval,
    timeout: timeout,
    timeoutWith: timeoutWith,
    timestamp: timestamp,
    toArray: toArray,
    window: window,
    windowCount: windowCount,
    windowTime: windowTime,
    windowToggle: windowToggle,
    windowWhen: windowWhen,
    withLatestFrom: withLatestFrom,
    zip: zip$1,
    zipAll: zipAll,
    zipWith: zipWith
  });
  var SubscriptionLog = function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
      if (unsubscribedFrame === void 0) {
        unsubscribedFrame = Infinity;
      }
      this.subscribedFrame = subscribedFrame;
      this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
  }();
  var SubscriptionLoggable = function () {
    function SubscriptionLoggable() {
      this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
      this.subscriptions.push(new SubscriptionLog(this.scheduler.now()));
      return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
      var subscriptionLogs = this.subscriptions;
      var oldSubscriptionLog = subscriptionLogs[index];
      subscriptionLogs[index] = new SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
  }();
  function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
      var baseCtor = baseCtors[i];
      var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
      for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
        var name_1 = propertyKeys[j];
        derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
      }
    }
  }
  var ColdObservable = function (_super) {
    __extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
      var _this = _super.call(this, function (subscriber) {
        var observable = this;
        var index = observable.logSubscribedFrame();
        var subscription = new Subscription();
        subscription.add(new Subscription(function () {
          observable.logUnsubscribedFrame(index);
        }));
        observable.scheduleMessages(subscriber);
        return subscription;
      }) || this;
      _this.messages = messages;
      _this.subscriptions = [];
      _this.scheduler = scheduler;
      return _this;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
      var messagesLength = this.messages.length;
      for (var i = 0; i < messagesLength; i++) {
        var message = this.messages[i];
        subscriber.add(this.scheduler.schedule(function (state) {
          var _a = state,
            notification = _a.message.notification,
            destination = _a.subscriber;
          observeNotification(notification, destination);
        }, message.frame, {
          message: message,
          subscriber: subscriber
        }));
      }
    };
    return ColdObservable;
  }(Observable);
  applyMixins(ColdObservable, [SubscriptionLoggable]);
  var HotObservable = function (_super) {
    __extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
      var _this = _super.call(this) || this;
      _this.messages = messages;
      _this.subscriptions = [];
      _this.scheduler = scheduler;
      return _this;
    }
    HotObservable.prototype._subscribe = function (subscriber) {
      var subject = this;
      var index = subject.logSubscribedFrame();
      var subscription = new Subscription();
      subscription.add(new Subscription(function () {
        subject.logUnsubscribedFrame(index);
      }));
      subscription.add(_super.prototype._subscribe.call(this, subscriber));
      return subscription;
    };
    HotObservable.prototype.setup = function () {
      var subject = this;
      var messagesLength = subject.messages.length;
      var _loop_1 = function (i) {
        (function () {
          var _a = subject.messages[i],
            notification = _a.notification,
            frame = _a.frame;
          subject.scheduler.schedule(function () {
            observeNotification(notification, subject);
          }, frame);
        })();
      };
      for (var i = 0; i < messagesLength; i++) {
        _loop_1(i);
      }
    };
    return HotObservable;
  }(Subject);
  applyMixins(HotObservable, [SubscriptionLoggable]);
  var defaultMaxFrame = 750;
  var TestScheduler = function (_super) {
    __extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
      var _this = _super.call(this, VirtualAction, defaultMaxFrame) || this;
      _this.assertDeepEqual = assertDeepEqual;
      _this.hotObservables = [];
      _this.coldObservables = [];
      _this.flushTests = [];
      _this.runMode = false;
      return _this;
    }
    TestScheduler.prototype.createTime = function (marbles) {
      var indexOf = this.runMode ? marbles.trim().indexOf('|') : marbles.indexOf('|');
      if (indexOf === -1) {
        throw new Error('marble diagram for time should have a completion marker "|"');
      }
      return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
      if (marbles.indexOf('^') !== -1) {
        throw new Error('cold observable cannot have subscription offset "^"');
      }
      if (marbles.indexOf('!') !== -1) {
        throw new Error('cold observable cannot have unsubscription marker "!"');
      }
      var messages = TestScheduler.parseMarbles(marbles, values, error, undefined, this.runMode);
      var cold = new ColdObservable(messages, this);
      this.coldObservables.push(cold);
      return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
      if (marbles.indexOf('!') !== -1) {
        throw new Error('hot observable cannot have unsubscription marker "!"');
      }
      var messages = TestScheduler.parseMarbles(marbles, values, error, undefined, this.runMode);
      var subject = new HotObservable(messages, this);
      this.hotObservables.push(subject);
      return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
      var _this = this;
      var messages = [];
      observable.subscribe({
        next: function (value) {
          messages.push({
            frame: _this.frame - outerFrame,
            notification: nextNotification(value)
          });
        },
        error: function (error) {
          messages.push({
            frame: _this.frame - outerFrame,
            notification: errorNotification(error)
          });
        },
        complete: function () {
          messages.push({
            frame: _this.frame - outerFrame,
            notification: COMPLETE_NOTIFICATION
          });
        }
      });
      return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, subscriptionMarbles) {
      var _this = this;
      if (subscriptionMarbles === void 0) {
        subscriptionMarbles = null;
      }
      var actual = [];
      var flushTest = {
        actual: actual,
        ready: false
      };
      var subscriptionParsed = TestScheduler.parseMarblesAsSubscriptions(subscriptionMarbles, this.runMode);
      var subscriptionFrame = subscriptionParsed.subscribedFrame === Infinity ? 0 : subscriptionParsed.subscribedFrame;
      var unsubscriptionFrame = subscriptionParsed.unsubscribedFrame;
      var subscription;
      this.schedule(function () {
        subscription = observable.subscribe({
          next: function (x) {
            var value = x instanceof Observable ? _this.materializeInnerObservable(x, _this.frame) : x;
            actual.push({
              frame: _this.frame,
              notification: nextNotification(value)
            });
          },
          error: function (error) {
            actual.push({
              frame: _this.frame,
              notification: errorNotification(error)
            });
          },
          complete: function () {
            actual.push({
              frame: _this.frame,
              notification: COMPLETE_NOTIFICATION
            });
          }
        });
      }, subscriptionFrame);
      if (unsubscriptionFrame !== Infinity) {
        this.schedule(function () {
          return subscription.unsubscribe();
        }, unsubscriptionFrame);
      }
      this.flushTests.push(flushTest);
      var runMode = this.runMode;
      return {
        toBe: function (marbles, values, errorValue) {
          flushTest.ready = true;
          flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true, runMode);
        },
        toEqual: function (other) {
          flushTest.ready = true;
          flushTest.expected = [];
          _this.schedule(function () {
            subscription = other.subscribe({
              next: function (x) {
                var value = x instanceof Observable ? _this.materializeInnerObservable(x, _this.frame) : x;
                flushTest.expected.push({
                  frame: _this.frame,
                  notification: nextNotification(value)
                });
              },
              error: function (error) {
                flushTest.expected.push({
                  frame: _this.frame,
                  notification: errorNotification(error)
                });
              },
              complete: function () {
                flushTest.expected.push({
                  frame: _this.frame,
                  notification: COMPLETE_NOTIFICATION
                });
              }
            });
          }, subscriptionFrame);
        }
      };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
      var flushTest = {
        actual: actualSubscriptionLogs,
        ready: false
      };
      this.flushTests.push(flushTest);
      var runMode = this.runMode;
      return {
        toBe: function (marblesOrMarblesArray) {
          var marblesArray = typeof marblesOrMarblesArray === 'string' ? [marblesOrMarblesArray] : marblesOrMarblesArray;
          flushTest.ready = true;
          flushTest.expected = marblesArray.map(function (marbles) {
            return TestScheduler.parseMarblesAsSubscriptions(marbles, runMode);
          }).filter(function (marbles) {
            return marbles.subscribedFrame !== Infinity;
          });
        }
      };
    };
    TestScheduler.prototype.flush = function () {
      var _this = this;
      var hotObservables = this.hotObservables;
      while (hotObservables.length > 0) {
        hotObservables.shift().setup();
      }
      _super.prototype.flush.call(this);
      this.flushTests = this.flushTests.filter(function (test) {
        if (test.ready) {
          _this.assertDeepEqual(test.actual, test.expected);
          return false;
        }
        return true;
      });
    };
    TestScheduler.parseMarblesAsSubscriptions = function (marbles, runMode) {
      var _this = this;
      if (runMode === void 0) {
        runMode = false;
      }
      if (typeof marbles !== 'string') {
        return new SubscriptionLog(Infinity);
      }
      var characters = __spreadArray([], __read(marbles));
      var len = characters.length;
      var groupStart = -1;
      var subscriptionFrame = Infinity;
      var unsubscriptionFrame = Infinity;
      var frame = 0;
      var _loop_1 = function (i) {
        var nextFrame = frame;
        var advanceFrameBy = function (count) {
          nextFrame += count * _this.frameTimeFactor;
        };
        var c = characters[i];
        switch (c) {
          case ' ':
            if (!runMode) {
              advanceFrameBy(1);
            }
            break;
          case '-':
            advanceFrameBy(1);
            break;
          case '(':
            groupStart = frame;
            advanceFrameBy(1);
            break;
          case ')':
            groupStart = -1;
            advanceFrameBy(1);
            break;
          case '^':
            if (subscriptionFrame !== Infinity) {
              throw new Error("found a second subscription point '^' in a " + 'subscription marble diagram. There can only be one.');
            }
            subscriptionFrame = groupStart > -1 ? groupStart : frame;
            advanceFrameBy(1);
            break;
          case '!':
            if (unsubscriptionFrame !== Infinity) {
              throw new Error("found a second unsubscription point '!' in a " + 'subscription marble diagram. There can only be one.');
            }
            unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
            break;
          default:
            if (runMode && c.match(/^[0-9]$/)) {
              if (i === 0 || characters[i - 1] === ' ') {
                var buffer = characters.slice(i).join('');
                var match = buffer.match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                if (match) {
                  i += match[0].length - 1;
                  var duration = parseFloat(match[1]);
                  var unit = match[2];
                  var durationInMs = void 0;
                  switch (unit) {
                    case 'ms':
                      durationInMs = duration;
                      break;
                    case 's':
                      durationInMs = duration * 1000;
                      break;
                    case 'm':
                      durationInMs = duration * 1000 * 60;
                      break;
                    default:
                      break;
                  }
                  advanceFrameBy(durationInMs / this_1.frameTimeFactor);
                  break;
                }
              }
            }
            throw new Error("there can only be '^' and '!' markers in a " + "subscription marble diagram. Found instead '" + c + "'.");
        }
        frame = nextFrame;
        out_i_1 = i;
      };
      var this_1 = this,
        out_i_1;
      for (var i = 0; i < len; i++) {
        _loop_1(i);
        i = out_i_1;
      }
      if (unsubscriptionFrame < 0) {
        return new SubscriptionLog(subscriptionFrame);
      } else {
        return new SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
      }
    };
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables, runMode) {
      var _this = this;
      if (materializeInnerObservables === void 0) {
        materializeInnerObservables = false;
      }
      if (runMode === void 0) {
        runMode = false;
      }
      if (marbles.indexOf('!') !== -1) {
        throw new Error('conventional marble diagrams cannot have the ' + 'unsubscription marker "!"');
      }
      var characters = __spreadArray([], __read(marbles));
      var len = characters.length;
      var testMessages = [];
      var subIndex = runMode ? marbles.replace(/^[ ]+/, '').indexOf('^') : marbles.indexOf('^');
      var frame = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
      var getValue = typeof values !== 'object' ? function (x) {
        return x;
      } : function (x) {
        if (materializeInnerObservables && values[x] instanceof ColdObservable) {
          return values[x].messages;
        }
        return values[x];
      };
      var groupStart = -1;
      var _loop_2 = function (i) {
        var nextFrame = frame;
        var advanceFrameBy = function (count) {
          nextFrame += count * _this.frameTimeFactor;
        };
        var notification = void 0;
        var c = characters[i];
        switch (c) {
          case ' ':
            if (!runMode) {
              advanceFrameBy(1);
            }
            break;
          case '-':
            advanceFrameBy(1);
            break;
          case '(':
            groupStart = frame;
            advanceFrameBy(1);
            break;
          case ')':
            groupStart = -1;
            advanceFrameBy(1);
            break;
          case '|':
            notification = COMPLETE_NOTIFICATION;
            advanceFrameBy(1);
            break;
          case '^':
            advanceFrameBy(1);
            break;
          case '#':
            notification = errorNotification(errorValue || 'error');
            advanceFrameBy(1);
            break;
          default:
            if (runMode && c.match(/^[0-9]$/)) {
              if (i === 0 || characters[i - 1] === ' ') {
                var buffer = characters.slice(i).join('');
                var match = buffer.match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                if (match) {
                  i += match[0].length - 1;
                  var duration = parseFloat(match[1]);
                  var unit = match[2];
                  var durationInMs = void 0;
                  switch (unit) {
                    case 'ms':
                      durationInMs = duration;
                      break;
                    case 's':
                      durationInMs = duration * 1000;
                      break;
                    case 'm':
                      durationInMs = duration * 1000 * 60;
                      break;
                    default:
                      break;
                  }
                  advanceFrameBy(durationInMs / this_2.frameTimeFactor);
                  break;
                }
              }
            }
            notification = nextNotification(getValue(c));
            advanceFrameBy(1);
            break;
        }
        if (notification) {
          testMessages.push({
            frame: groupStart > -1 ? groupStart : frame,
            notification: notification
          });
        }
        frame = nextFrame;
        out_i_2 = i;
      };
      var this_2 = this,
        out_i_2;
      for (var i = 0; i < len; i++) {
        _loop_2(i);
        i = out_i_2;
      }
      return testMessages;
    };
    TestScheduler.prototype.createAnimator = function () {
      var _this = this;
      if (!this.runMode) {
        throw new Error('animate() must only be used in run mode');
      }
      var lastHandle = 0;
      var map;
      var delegate = {
        requestAnimationFrame: function (callback) {
          if (!map) {
            throw new Error('animate() was not called within run()');
          }
          var handle = ++lastHandle;
          map.set(handle, callback);
          return handle;
        },
        cancelAnimationFrame: function (handle) {
          if (!map) {
            throw new Error('animate() was not called within run()');
          }
          map.delete(handle);
        }
      };
      var animate = function (marbles) {
        var e_1, _a;
        if (map) {
          throw new Error('animate() must not be called more than once within run()');
        }
        if (/[|#]/.test(marbles)) {
          throw new Error('animate() must not complete or error');
        }
        map = new Map();
        var messages = TestScheduler.parseMarbles(marbles, undefined, undefined, undefined, true);
        try {
          for (var messages_1 = __values(messages), messages_1_1 = messages_1.next(); !messages_1_1.done; messages_1_1 = messages_1.next()) {
            var message = messages_1_1.value;
            _this.schedule(function () {
              var e_2, _a;
              var now = _this.now();
              var callbacks = Array.from(map.values());
              map.clear();
              try {
                for (var callbacks_1 = (e_2 = void 0, __values(callbacks)), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
                  var callback = callbacks_1_1.value;
                  callback(now);
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
            }, message.frame);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (messages_1_1 && !messages_1_1.done && (_a = messages_1.return)) _a.call(messages_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      };
      return {
        animate: animate,
        delegate: delegate
      };
    };
    TestScheduler.prototype.createDelegates = function () {
      var _this = this;
      var lastHandle = 0;
      var scheduleLookup = new Map();
      var run = function () {
        var now = _this.now();
        var scheduledRecords = Array.from(scheduleLookup.values());
        var scheduledRecordsDue = scheduledRecords.filter(function (_a) {
          var due = _a.due;
          return due <= now;
        });
        var dueImmediates = scheduledRecordsDue.filter(function (_a) {
          var type = _a.type;
          return type === 'immediate';
        });
        if (dueImmediates.length > 0) {
          var _a = dueImmediates[0],
            handle = _a.handle,
            handler = _a.handler;
          scheduleLookup.delete(handle);
          handler();
          return;
        }
        var dueIntervals = scheduledRecordsDue.filter(function (_a) {
          var type = _a.type;
          return type === 'interval';
        });
        if (dueIntervals.length > 0) {
          var firstDueInterval = dueIntervals[0];
          var duration = firstDueInterval.duration,
            handler = firstDueInterval.handler;
          firstDueInterval.due = now + duration;
          firstDueInterval.subscription = _this.schedule(run, duration);
          handler();
          return;
        }
        var dueTimeouts = scheduledRecordsDue.filter(function (_a) {
          var type = _a.type;
          return type === 'timeout';
        });
        if (dueTimeouts.length > 0) {
          var _b = dueTimeouts[0],
            handle = _b.handle,
            handler = _b.handler;
          scheduleLookup.delete(handle);
          handler();
          return;
        }
        throw new Error('Expected a due immediate or interval');
      };
      var immediate = {
        setImmediate: function (handler) {
          var handle = ++lastHandle;
          scheduleLookup.set(handle, {
            due: _this.now(),
            duration: 0,
            handle: handle,
            handler: handler,
            subscription: _this.schedule(run, 0),
            type: 'immediate'
          });
          return handle;
        },
        clearImmediate: function (handle) {
          var value = scheduleLookup.get(handle);
          if (value) {
            value.subscription.unsubscribe();
            scheduleLookup.delete(handle);
          }
        }
      };
      var interval = {
        setInterval: function (handler, duration) {
          if (duration === void 0) {
            duration = 0;
          }
          var handle = ++lastHandle;
          scheduleLookup.set(handle, {
            due: _this.now() + duration,
            duration: duration,
            handle: handle,
            handler: handler,
            subscription: _this.schedule(run, duration),
            type: 'interval'
          });
          return handle;
        },
        clearInterval: function (handle) {
          var value = scheduleLookup.get(handle);
          if (value) {
            value.subscription.unsubscribe();
            scheduleLookup.delete(handle);
          }
        }
      };
      var timeout = {
        setTimeout: function (handler, duration) {
          if (duration === void 0) {
            duration = 0;
          }
          var handle = ++lastHandle;
          scheduleLookup.set(handle, {
            due: _this.now() + duration,
            duration: duration,
            handle: handle,
            handler: handler,
            subscription: _this.schedule(run, duration),
            type: 'timeout'
          });
          return handle;
        },
        clearTimeout: function (handle) {
          var value = scheduleLookup.get(handle);
          if (value) {
            value.subscription.unsubscribe();
            scheduleLookup.delete(handle);
          }
        }
      };
      return {
        immediate: immediate,
        interval: interval,
        timeout: timeout
      };
    };
    TestScheduler.prototype.run = function (callback) {
      var prevFrameTimeFactor = TestScheduler.frameTimeFactor;
      var prevMaxFrames = this.maxFrames;
      TestScheduler.frameTimeFactor = 1;
      this.maxFrames = Infinity;
      this.runMode = true;
      var animator = this.createAnimator();
      var delegates = this.createDelegates();
      animationFrameProvider.delegate = animator.delegate;
      dateTimestampProvider.delegate = this;
      immediateProvider.delegate = delegates.immediate;
      intervalProvider.delegate = delegates.interval;
      timeoutProvider.delegate = delegates.timeout;
      performanceTimestampProvider.delegate = this;
      var helpers = {
        cold: this.createColdObservable.bind(this),
        hot: this.createHotObservable.bind(this),
        flush: this.flush.bind(this),
        time: this.createTime.bind(this),
        expectObservable: this.expectObservable.bind(this),
        expectSubscriptions: this.expectSubscriptions.bind(this),
        animate: animator.animate
      };
      try {
        var ret = callback(helpers);
        this.flush();
        return ret;
      } finally {
        TestScheduler.frameTimeFactor = prevFrameTimeFactor;
        this.maxFrames = prevMaxFrames;
        this.runMode = false;
        animationFrameProvider.delegate = undefined;
        dateTimestampProvider.delegate = undefined;
        immediateProvider.delegate = undefined;
        intervalProvider.delegate = undefined;
        timeoutProvider.delegate = undefined;
        performanceTimestampProvider.delegate = undefined;
      }
    };
    TestScheduler.frameTimeFactor = 10;
    return TestScheduler;
  }(VirtualTimeScheduler);
  var _testing = /*#__PURE__*/Object.freeze({
    TestScheduler: TestScheduler
  });
  function getXHRResponse(xhr) {
    switch (xhr.responseType) {
      case 'json':
        {
          if ('response' in xhr) {
            return xhr.response;
          } else {
            var ieXHR = xhr;
            return JSON.parse(ieXHR.responseText);
          }
        }
      case 'document':
        return xhr.responseXML;
      case 'text':
      default:
        {
          if ('response' in xhr) {
            return xhr.response;
          } else {
            var ieXHR = xhr;
            return ieXHR.responseText;
          }
        }
    }
  }
  var AjaxResponse = function () {
    function AjaxResponse(originalEvent, xhr, request, type) {
      if (type === void 0) {
        type = 'download_load';
      }
      this.originalEvent = originalEvent;
      this.xhr = xhr;
      this.request = request;
      this.type = type;
      var status = xhr.status,
        responseType = xhr.responseType;
      this.status = status !== null && status !== void 0 ? status : 0;
      this.responseType = responseType !== null && responseType !== void 0 ? responseType : '';
      var allHeaders = xhr.getAllResponseHeaders();
      this.responseHeaders = allHeaders ? allHeaders.split('\n').reduce(function (headers, line) {
        var index = line.indexOf(': ');
        headers[line.slice(0, index)] = line.slice(index + 2);
        return headers;
      }, {}) : {};
      this.response = getXHRResponse(xhr);
      var loaded = originalEvent.loaded,
        total = originalEvent.total;
      this.loaded = loaded;
      this.total = total;
    }
    return AjaxResponse;
  }();
  var AjaxError = createErrorClass(function (_super) {
    return function AjaxErrorImpl(message, xhr, request) {
      this.message = message;
      this.name = 'AjaxError';
      this.xhr = xhr;
      this.request = request;
      this.status = xhr.status;
      this.responseType = xhr.responseType;
      var response;
      try {
        response = getXHRResponse(xhr);
      } catch (err) {
        response = xhr.responseText;
      }
      this.response = response;
    };
  });
  var AjaxTimeoutError = function () {
    function AjaxTimeoutErrorImpl(xhr, request) {
      AjaxError.call(this, 'ajax timeout', xhr, request);
      this.name = 'AjaxTimeoutError';
      return this;
    }
    AjaxTimeoutErrorImpl.prototype = Object.create(AjaxError.prototype);
    return AjaxTimeoutErrorImpl;
  }();
  function ajaxGet(url, headers) {
    return ajax({
      method: 'GET',
      url: url,
      headers: headers
    });
  }
  function ajaxPost(url, body, headers) {
    return ajax({
      method: 'POST',
      url: url,
      body: body,
      headers: headers
    });
  }
  function ajaxDelete(url, headers) {
    return ajax({
      method: 'DELETE',
      url: url,
      headers: headers
    });
  }
  function ajaxPut(url, body, headers) {
    return ajax({
      method: 'PUT',
      url: url,
      body: body,
      headers: headers
    });
  }
  function ajaxPatch(url, body, headers) {
    return ajax({
      method: 'PATCH',
      url: url,
      body: body,
      headers: headers
    });
  }
  var mapResponse = map(function (x) {
    return x.response;
  });
  function ajaxGetJSON(url, headers) {
    return mapResponse(ajax({
      method: 'GET',
      url: url,
      headers: headers
    }));
  }
  var ajax = function () {
    var create = function (urlOrConfig) {
      var config = typeof urlOrConfig === 'string' ? {
        url: urlOrConfig
      } : urlOrConfig;
      return fromAjax(config);
    };
    create.get = ajaxGet;
    create.post = ajaxPost;
    create.delete = ajaxDelete;
    create.put = ajaxPut;
    create.patch = ajaxPatch;
    create.getJSON = ajaxGetJSON;
    return create;
  }();
  var UPLOAD = 'upload';
  var DOWNLOAD = 'download';
  var LOADSTART = 'loadstart';
  var PROGRESS = 'progress';
  var LOAD = 'load';
  function fromAjax(init) {
    return new Observable(function (destination) {
      var _a, _b;
      var config = __assign({
        async: true,
        crossDomain: false,
        withCredentials: false,
        method: 'GET',
        timeout: 0,
        responseType: 'json'
      }, init);
      var queryParams = config.queryParams,
        configuredBody = config.body,
        configuredHeaders = config.headers;
      var url = config.url;
      if (!url) {
        throw new TypeError('url is required');
      }
      if (queryParams) {
        var searchParams_1;
        if (url.includes('?')) {
          var parts = url.split('?');
          if (2 < parts.length) {
            throw new TypeError('invalid url');
          }
          searchParams_1 = new URLSearchParams(parts[1]);
          new URLSearchParams(queryParams).forEach(function (value, key) {
            return searchParams_1.set(key, value);
          });
          url = parts[0] + '?' + searchParams_1;
        } else {
          searchParams_1 = new URLSearchParams(queryParams);
          url = url + '?' + searchParams_1;
        }
      }
      var headers = {};
      if (configuredHeaders) {
        for (var key in configuredHeaders) {
          if (configuredHeaders.hasOwnProperty(key)) {
            headers[key.toLowerCase()] = configuredHeaders[key];
          }
        }
      }
      var crossDomain = config.crossDomain;
      if (!crossDomain && !('x-requested-with' in headers)) {
        headers['x-requested-with'] = 'XMLHttpRequest';
      }
      var withCredentials = config.withCredentials,
        xsrfCookieName = config.xsrfCookieName,
        xsrfHeaderName = config.xsrfHeaderName;
      if ((withCredentials || !crossDomain) && xsrfCookieName && xsrfHeaderName) {
        var xsrfCookie = (_b = (_a = document === null || document === void 0 ? void 0 : document.cookie.match(new RegExp("(^|;\\s*)(" + xsrfCookieName + ")=([^;]*)"))) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : '';
        if (xsrfCookie) {
          headers[xsrfHeaderName] = xsrfCookie;
        }
      }
      var body = extractContentTypeAndMaybeSerializeBody(configuredBody, headers);
      var _request = __assign(__assign({}, config), {
        url: url,
        headers: headers,
        body: body
      });
      var xhr;
      xhr = init.createXHR ? init.createXHR() : new XMLHttpRequest();
      {
        var progressSubscriber_1 = init.progressSubscriber,
          _c = init.includeDownloadProgress,
          includeDownloadProgress = _c === void 0 ? false : _c,
          _d = init.includeUploadProgress,
          includeUploadProgress = _d === void 0 ? false : _d;
        var addErrorEvent = function (type, errorFactory) {
          xhr.addEventListener(type, function () {
            var _a;
            var error = errorFactory();
            (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _a === void 0 ? void 0 : _a.call(progressSubscriber_1, error);
            destination.error(error);
          });
        };
        addErrorEvent('timeout', function () {
          return new AjaxTimeoutError(xhr, _request);
        });
        addErrorEvent('abort', function () {
          return new AjaxError('aborted', xhr, _request);
        });
        var createResponse_1 = function (direction, event) {
          return new AjaxResponse(event, xhr, _request, direction + "_" + event.type);
        };
        var addProgressEvent_1 = function (target, type, direction) {
          target.addEventListener(type, function (event) {
            destination.next(createResponse_1(direction, event));
          });
        };
        if (includeUploadProgress) {
          [LOADSTART, PROGRESS, LOAD].forEach(function (type) {
            return addProgressEvent_1(xhr.upload, type, UPLOAD);
          });
        }
        if (progressSubscriber_1) {
          [LOADSTART, PROGRESS].forEach(function (type) {
            return xhr.upload.addEventListener(type, function (e) {
              var _a;
              return (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.next) === null || _a === void 0 ? void 0 : _a.call(progressSubscriber_1, e);
            });
          });
        }
        if (includeDownloadProgress) {
          [LOADSTART, PROGRESS].forEach(function (type) {
            return addProgressEvent_1(xhr, type, DOWNLOAD);
          });
        }
        var emitError_1 = function (status) {
          var msg = 'ajax error' + (status ? ' ' + status : '');
          destination.error(new AjaxError(msg, xhr, _request));
        };
        xhr.addEventListener('error', function (e) {
          var _a;
          (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _a === void 0 ? void 0 : _a.call(progressSubscriber_1, e);
          emitError_1();
        });
        xhr.addEventListener(LOAD, function (event) {
          var _a, _b;
          var status = xhr.status;
          if (status < 400) {
            (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.complete) === null || _a === void 0 ? void 0 : _a.call(progressSubscriber_1);
            var response = void 0;
            try {
              response = createResponse_1(DOWNLOAD, event);
            } catch (err) {
              destination.error(err);
              return;
            }
            destination.next(response);
            destination.complete();
          } else {
            (_b = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _b === void 0 ? void 0 : _b.call(progressSubscriber_1, event);
            emitError_1(status);
          }
        });
      }
      var user = _request.user,
        method = _request.method,
        async = _request.async;
      if (user) {
        xhr.open(method, url, async, user, _request.password);
      } else {
        xhr.open(method, url, async);
      }
      if (async) {
        xhr.timeout = _request.timeout;
        xhr.responseType = _request.responseType;
      }
      if ('withCredentials' in xhr) {
        xhr.withCredentials = _request.withCredentials;
      }
      for (var key in headers) {
        if (headers.hasOwnProperty(key)) {
          xhr.setRequestHeader(key, headers[key]);
        }
      }
      if (body) {
        xhr.send(body);
      } else {
        xhr.send();
      }
      return function () {
        if (xhr && xhr.readyState !== 4) {
          xhr.abort();
        }
      };
    });
  }
  function extractContentTypeAndMaybeSerializeBody(body, headers) {
    var _a;
    if (!body || typeof body === 'string' || isFormData(body) || isURLSearchParams(body) || isArrayBuffer(body) || isFile(body) || isBlob(body) || isReadableStream(body)) {
      return body;
    }
    if (isArrayBufferView(body)) {
      return body.buffer;
    }
    if (typeof body === 'object') {
      headers['content-type'] = (_a = headers['content-type']) !== null && _a !== void 0 ? _a : 'application/json;charset=utf-8';
      return JSON.stringify(body);
    }
    throw new TypeError('Unknown body type');
  }
  var _toString = Object.prototype.toString;
  function toStringCheck(obj, name) {
    return _toString.call(obj) === "[object " + name + "]";
  }
  function isArrayBuffer(body) {
    return toStringCheck(body, 'ArrayBuffer');
  }
  function isFile(body) {
    return toStringCheck(body, 'File');
  }
  function isBlob(body) {
    return toStringCheck(body, 'Blob');
  }
  function isArrayBufferView(body) {
    return typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView(body);
  }
  function isFormData(body) {
    return typeof FormData !== 'undefined' && body instanceof FormData;
  }
  function isURLSearchParams(body) {
    return typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams;
  }
  function isReadableStream(body) {
    return typeof ReadableStream !== 'undefined' && body instanceof ReadableStream;
  }
  var _ajax = /*#__PURE__*/Object.freeze({
    ajax: ajax,
    AjaxError: AjaxError,
    AjaxTimeoutError: AjaxTimeoutError,
    AjaxResponse: AjaxResponse
  });
  var DEFAULT_WEBSOCKET_CONFIG = {
    url: '',
    deserializer: function (e) {
      return JSON.parse(e.data);
    },
    serializer: function (value) {
      return JSON.stringify(value);
    }
  };
  var WEBSOCKETSUBJECT_INVALID_ERROR_OBJECT = 'WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }';
  var WebSocketSubject = function (_super) {
    __extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
      var _this = _super.call(this) || this;
      _this._socket = null;
      if (urlConfigOrSource instanceof Observable) {
        _this.destination = destination;
        _this.source = urlConfigOrSource;
      } else {
        var config = _this._config = __assign({}, DEFAULT_WEBSOCKET_CONFIG);
        _this._output = new Subject();
        if (typeof urlConfigOrSource === 'string') {
          config.url = urlConfigOrSource;
        } else {
          for (var key in urlConfigOrSource) {
            if (urlConfigOrSource.hasOwnProperty(key)) {
              config[key] = urlConfigOrSource[key];
            }
          }
        }
        if (!config.WebSocketCtor && WebSocket) {
          config.WebSocketCtor = WebSocket;
        } else if (!config.WebSocketCtor) {
          throw new Error('no WebSocket constructor can be found');
        }
        _this.destination = new ReplaySubject();
      }
      return _this;
    }
    WebSocketSubject.prototype.lift = function (operator) {
      var sock = new WebSocketSubject(this._config, this.destination);
      sock.operator = operator;
      sock.source = this;
      return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
      this._socket = null;
      if (!this.source) {
        this.destination = new ReplaySubject();
      }
      this._output = new Subject();
    };
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
      var self = this;
      return new Observable(function (observer) {
        try {
          self.next(subMsg());
        } catch (err) {
          observer.error(err);
        }
        var subscription = self.subscribe({
          next: function (x) {
            try {
              if (messageFilter(x)) {
                observer.next(x);
              }
            } catch (err) {
              observer.error(err);
            }
          },
          error: function (err) {
            return observer.error(err);
          },
          complete: function () {
            return observer.complete();
          }
        });
        return function () {
          try {
            self.next(unsubMsg());
          } catch (err) {
            observer.error(err);
          }
          subscription.unsubscribe();
        };
      });
    };
    WebSocketSubject.prototype._connectSocket = function () {
      var _this = this;
      var _a = this._config,
        WebSocketCtor = _a.WebSocketCtor,
        protocol = _a.protocol,
        url = _a.url,
        binaryType = _a.binaryType;
      var observer = this._output;
      var socket = null;
      try {
        socket = protocol ? new WebSocketCtor(url, protocol) : new WebSocketCtor(url);
        this._socket = socket;
        if (binaryType) {
          this._socket.binaryType = binaryType;
        }
      } catch (e) {
        observer.error(e);
        return;
      }
      var subscription = new Subscription(function () {
        _this._socket = null;
        if (socket && socket.readyState === 1) {
          socket.close();
        }
      });
      socket.onopen = function (evt) {
        var _socket = _this._socket;
        if (!_socket) {
          socket.close();
          _this._resetState();
          return;
        }
        var openObserver = _this._config.openObserver;
        if (openObserver) {
          openObserver.next(evt);
        }
        var queue = _this.destination;
        _this.destination = Subscriber.create(function (x) {
          if (socket.readyState === 1) {
            try {
              var serializer = _this._config.serializer;
              socket.send(serializer(x));
            } catch (e) {
              _this.destination.error(e);
            }
          }
        }, function (err) {
          var closingObserver = _this._config.closingObserver;
          if (closingObserver) {
            closingObserver.next(undefined);
          }
          if (err && err.code) {
            socket.close(err.code, err.reason);
          } else {
            observer.error(new TypeError(WEBSOCKETSUBJECT_INVALID_ERROR_OBJECT));
          }
          _this._resetState();
        }, function () {
          var closingObserver = _this._config.closingObserver;
          if (closingObserver) {
            closingObserver.next(undefined);
          }
          socket.close();
          _this._resetState();
        });
        if (queue && queue instanceof ReplaySubject) {
          subscription.add(queue.subscribe(_this.destination));
        }
      };
      socket.onerror = function (e) {
        _this._resetState();
        observer.error(e);
      };
      socket.onclose = function (e) {
        if (socket === _this._socket) {
          _this._resetState();
        }
        var closeObserver = _this._config.closeObserver;
        if (closeObserver) {
          closeObserver.next(e);
        }
        if (e.wasClean) {
          observer.complete();
        } else {
          observer.error(e);
        }
      };
      socket.onmessage = function (e) {
        try {
          var deserializer = _this._config.deserializer;
          observer.next(deserializer(e));
        } catch (err) {
          observer.error(err);
        }
      };
    };
    WebSocketSubject.prototype._subscribe = function (subscriber) {
      var _this = this;
      var source = this.source;
      if (source) {
        return source.subscribe(subscriber);
      }
      if (!this._socket) {
        this._connectSocket();
      }
      this._output.subscribe(subscriber);
      subscriber.add(function () {
        var _socket = _this._socket;
        if (_this._output.observers.length === 0) {
          if (_socket && (_socket.readyState === 1 || _socket.readyState === 0)) {
            _socket.close();
          }
          _this._resetState();
        }
      });
      return subscriber;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
      var _socket = this._socket;
      if (_socket && (_socket.readyState === 1 || _socket.readyState === 0)) {
        _socket.close();
      }
      this._resetState();
      _super.prototype.unsubscribe.call(this);
    };
    return WebSocketSubject;
  }(AnonymousSubject);
  function webSocket(urlConfigOrSource) {
    return new WebSocketSubject(urlConfigOrSource);
  }
  var _webSocket = /*#__PURE__*/Object.freeze({
    webSocket: webSocket,
    WebSocketSubject: WebSocketSubject
  });
  function fromFetch(input, initWithSelector) {
    if (initWithSelector === void 0) {
      initWithSelector = {};
    }
    var selector = initWithSelector.selector,
      init = __rest(initWithSelector, ["selector"]);
    return new Observable(function (subscriber) {
      var controller = new AbortController();
      var signal = controller.signal;
      var abortable = true;
      var outerSignal = init.signal;
      if (outerSignal) {
        if (outerSignal.aborted) {
          controller.abort();
        } else {
          var outerSignalHandler_1 = function () {
            if (!signal.aborted) {
              controller.abort();
            }
          };
          outerSignal.addEventListener('abort', outerSignalHandler_1);
          subscriber.add(function () {
            return outerSignal.removeEventListener('abort', outerSignalHandler_1);
          });
        }
      }
      var perSubscriberInit = __assign(__assign({}, init), {
        signal: signal
      });
      var handleError = function (err) {
        abortable = false;
        subscriber.error(err);
      };
      fetch(input, perSubscriberInit).then(function (response) {
        if (selector) {
          innerFrom(selector(response)).subscribe(createOperatorSubscriber(subscriber, undefined, function () {
            abortable = false;
            subscriber.complete();
          }, handleError));
        } else {
          abortable = false;
          subscriber.next(response);
          subscriber.complete();
        }
      }).catch(handleError);
      return function () {
        if (abortable) {
          controller.abort();
        }
      };
    });
  }
  var _fetch = /*#__PURE__*/Object.freeze({
    fromFetch: fromFetch
  });
  var operators = _operators;
  var testing = _testing;
  var ajax$1 = _ajax;
  var webSocket$1 = _webSocket;
  var fetch$1 = _fetch;
  exports.operators = operators;
  exports.testing = testing;
  exports.ajax = ajax$1;
  exports.webSocket = webSocket$1;
  exports.fetch = fetch$1;
  exports.Observable = Observable;
  exports.ConnectableObservable = ConnectableObservable;
  exports.observable = observable;
  exports.animationFrames = animationFrames;
  exports.Subject = Subject;
  exports.BehaviorSubject = BehaviorSubject;
  exports.ReplaySubject = ReplaySubject;
  exports.AsyncSubject = AsyncSubject;
  exports.asap = asap;
  exports.asapScheduler = asapScheduler;
  exports.async = async;
  exports.asyncScheduler = asyncScheduler;
  exports.queue = queue;
  exports.queueScheduler = queueScheduler;
  exports.animationFrame = animationFrame;
  exports.animationFrameScheduler = animationFrameScheduler;
  exports.VirtualTimeScheduler = VirtualTimeScheduler;
  exports.VirtualAction = VirtualAction;
  exports.Scheduler = Scheduler;
  exports.Subscription = Subscription;
  exports.Subscriber = Subscriber;
  exports.Notification = Notification;
  exports.pipe = pipe;
  exports.noop = noop;
  exports.identity = identity;
  exports.isObservable = isObservable;
  exports.lastValueFrom = lastValueFrom;
  exports.firstValueFrom = firstValueFrom;
  exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
  exports.EmptyError = EmptyError;
  exports.NotFoundError = NotFoundError;
  exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
  exports.SequenceError = SequenceError;
  exports.TimeoutError = TimeoutError;
  exports.UnsubscriptionError = UnsubscriptionError;
  exports.bindCallback = bindCallback;
  exports.bindNodeCallback = bindNodeCallback;
  exports.combineLatest = combineLatest;
  exports.concat = concat;
  exports.connectable = connectable;
  exports.defer = defer;
  exports.empty = empty;
  exports.forkJoin = forkJoin;
  exports.from = from;
  exports.fromEvent = fromEvent;
  exports.fromEventPattern = fromEventPattern;
  exports.generate = generate;
  exports.iif = iif;
  exports.interval = interval;
  exports.merge = merge;
  exports.never = never;
  exports.of = of;
  exports.onErrorResumeNext = onErrorResumeNext;
  exports.pairs = pairs;
  exports.partition = partition;
  exports.race = race;
  exports.range = range;
  exports.throwError = throwError;
  exports.timer = timer;
  exports.using = using;
  exports.zip = zip;
  exports.scheduled = scheduled;
  exports.EMPTY = EMPTY;
  exports.NEVER = NEVER;
  exports.config = config;
  exports.audit = audit;
  exports.auditTime = auditTime;
  exports.buffer = buffer;
  exports.bufferCount = bufferCount;
  exports.bufferTime = bufferTime;
  exports.bufferToggle = bufferToggle;
  exports.bufferWhen = bufferWhen;
  exports.catchError = catchError;
  exports.combineAll = combineAll;
  exports.combineLatestAll = combineLatestAll;
  exports.combineLatestWith = combineLatestWith;
  exports.concatAll = concatAll;
  exports.concatMap = concatMap;
  exports.concatMapTo = concatMapTo;
  exports.concatWith = concatWith;
  exports.connect = connect;
  exports.count = count;
  exports.debounce = debounce;
  exports.debounceTime = debounceTime;
  exports.defaultIfEmpty = defaultIfEmpty;
  exports.delay = delay;
  exports.delayWhen = delayWhen;
  exports.dematerialize = dematerialize;
  exports.distinct = distinct;
  exports.distinctUntilChanged = distinctUntilChanged;
  exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
  exports.elementAt = elementAt;
  exports.endWith = endWith;
  exports.every = every;
  exports.exhaust = exhaust;
  exports.exhaustAll = exhaustAll;
  exports.exhaustMap = exhaustMap;
  exports.expand = expand;
  exports.filter = filter;
  exports.finalize = finalize;
  exports.find = find;
  exports.findIndex = findIndex;
  exports.first = first;
  exports.groupBy = groupBy;
  exports.ignoreElements = ignoreElements;
  exports.isEmpty = isEmpty;
  exports.last = last$1;
  exports.map = map;
  exports.mapTo = mapTo;
  exports.materialize = materialize;
  exports.max = max;
  exports.mergeAll = mergeAll;
  exports.flatMap = flatMap;
  exports.mergeMap = mergeMap;
  exports.mergeMapTo = mergeMapTo;
  exports.mergeScan = mergeScan;
  exports.mergeWith = mergeWith;
  exports.min = min;
  exports.multicast = multicast;
  exports.observeOn = observeOn;
  exports.onErrorResumeNextWith = onErrorResumeNextWith;
  exports.pairwise = pairwise;
  exports.pluck = pluck;
  exports.publish = publish;
  exports.publishBehavior = publishBehavior;
  exports.publishLast = publishLast;
  exports.publishReplay = publishReplay;
  exports.raceWith = raceWith;
  exports.reduce = reduce;
  exports.repeat = repeat;
  exports.repeatWhen = repeatWhen;
  exports.retry = retry;
  exports.retryWhen = retryWhen;
  exports.refCount = refCount;
  exports.sample = sample;
  exports.sampleTime = sampleTime;
  exports.scan = scan;
  exports.sequenceEqual = sequenceEqual;
  exports.share = share;
  exports.shareReplay = shareReplay;
  exports.single = single;
  exports.skip = skip;
  exports.skipLast = skipLast;
  exports.skipUntil = skipUntil;
  exports.skipWhile = skipWhile;
  exports.startWith = startWith;
  exports.subscribeOn = subscribeOn;
  exports.switchAll = switchAll;
  exports.switchMap = switchMap;
  exports.switchMapTo = switchMapTo;
  exports.switchScan = switchScan;
  exports.take = take;
  exports.takeLast = takeLast;
  exports.takeUntil = takeUntil;
  exports.takeWhile = takeWhile;
  exports.tap = tap;
  exports.throttle = throttle;
  exports.throttleTime = throttleTime;
  exports.throwIfEmpty = throwIfEmpty;
  exports.timeInterval = timeInterval;
  exports.timeout = timeout;
  exports.timeoutWith = timeoutWith;
  exports.timestamp = timestamp;
  exports.toArray = toArray;
  exports.window = window;
  exports.windowCount = windowCount;
  exports.windowTime = windowTime;
  exports.windowToggle = windowToggle;
  exports.windowWhen = windowWhen;
  exports.withLatestFrom = withLatestFrom;
  exports.zipAll = zipAll;
  exports.zipWith = zipWith;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
/**
  @license
  Apache License 2.0 https://github.com/ReactiveX/RxJS/blob/master/LICENSE.txt
 **/
/**
  @license
  Apache License 2.0 https://github.com/ReactiveX/RxJS/blob/master/LICENSE.txt
 **/
/*
 *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
*****************************************************************************/
(function (g, y) {
  "object" === typeof exports && "undefined" !== typeof module ? y(exports) : "function" === typeof define && define.amd ? define("rxjs", ["exports"], y) : y(g.rxjs = {});
})(this, function (g) {
  function y(b, a) {
    function c() {
      this.constructor = b;
    }
    if ("function" !== typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    Ta(b, a);
    b.prototype = null === a ? Object.create(a) : (c.prototype = a.prototype, new c());
  }
  function Zd(b, a) {
    var c = {},
      d;
    for (d in b) Object.prototype.hasOwnProperty.call(b, d) && 0 > a.indexOf(d) && (c[d] = b[d]);
    if (null != b && "function" === typeof Object.getOwnPropertySymbols) {
      var e = 0;
      for (d = Object.getOwnPropertySymbols(b); e < d.length; e++) 0 > a.indexOf(d[e]) && Object.prototype.propertyIsEnumerable.call(b, d[e]) && (c[d[e]] = b[d[e]]);
    }
    return c;
  }
  function $d(b, a, c, d) {
    function e(a) {
      return a instanceof c ? a : new c(function (b) {
        b(a);
      });
    }
    return new (c || (c = Promise))(function (c, h) {
      function f(a) {
        try {
          z(d.next(a));
        } catch (v) {
          h(v);
        }
      }
      function k(a) {
        try {
          z(d["throw"](a));
        } catch (v) {
          h(v);
        }
      }
      function z(a) {
        a.done ? c(a.value) : e(a.value).then(f, k);
      }
      z((d = d.apply(b, a || [])).next());
    });
  }
  function Ua(b, a) {
    function c(a) {
      return function (b) {
        return d([a, b]);
      };
    }
    function d(c) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; e;) try {
        if (f = 1, h && (l = c[0] & 2 ? h["return"] : c[0] ? h["throw"] || ((l = h["return"]) && l.call(h), 0) : h.next) && !(l = l.call(h, c[1])).done) return l;
        if (h = 0, l) c = [c[0] & 2, l.value];
        switch (c[0]) {
          case 0:
          case 1:
            l = c;
            break;
          case 4:
            return e.label++, {
              value: c[1],
              done: !1
            };
          case 5:
            e.label++;
            h = c[1];
            c = [0];
            continue;
          case 7:
            c = e.ops.pop();
            e.trys.pop();
            continue;
          default:
            if (!(l = e.trys, l = 0 < l.length && l[l.length - 1]) && (6 === c[0] || 2 === c[0])) {
              e = 0;
              continue;
            }
            if (3 === c[0] && (!l || c[1] > l[0] && c[1] < l[3])) e.label = c[1];else if (6 === c[0] && e.label < l[1]) e.label = l[1], l = c;else if (l && e.label < l[2]) e.label = l[2], e.ops.push(c);else {
              l[2] && e.ops.pop();
              e.trys.pop();
              continue;
            }
        }
        c = a.call(b, e);
      } catch (p) {
        c = [6, p], h = 0;
      } finally {
        f = l = 0;
      }
      if (c[0] & 5) throw c[1];
      return {
        value: c[0] ? c[1] : void 0,
        done: !0
      };
    }
    var e = {
        label: 0,
        sent: function () {
          if (l[0] & 1) throw l[1];
          return l[1];
        },
        trys: [],
        ops: []
      },
      f,
      h,
      l,
      k;
    return k = {
      next: c(0),
      "throw": c(1),
      "return": c(2)
    }, "function" === typeof Symbol && (k[Symbol.iterator] = function () {
      return this;
    }), k;
  }
  function F(b) {
    var a = "function" === typeof Symbol && Symbol.iterator,
      c = a && b[a],
      d = 0;
    if (c) return c.call(b);
    if (b && "number" === typeof b.length) return {
      next: function () {
        b && d >= b.length && (b = void 0);
        return {
          value: b && b[d++],
          done: !b
        };
      }
    };
    throw new TypeError(a ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function w(b, a) {
    var c = "function" === typeof Symbol && b[Symbol.iterator];
    if (!c) return b;
    b = c.call(b);
    var d,
      e = [],
      f;
    try {
      for (; (void 0 === a || 0 < a--) && !(d = b.next()).done;) e.push(d.value);
    } catch (h) {
      f = {
        error: h
      };
    } finally {
      try {
        d && !d.done && (c = b["return"]) && c.call(b);
      } finally {
        if (f) throw f.error;
      }
    }
    return e;
  }
  function x(b, a, c) {
    if (c || 2 === arguments.length) for (var d = 0, e = a.length, f; d < e; d++) !f && d in a || (f || (f = Array.prototype.slice.call(a, 0, d)), f[d] = a[d]);
    return b.concat(f || Array.prototype.slice.call(a));
  }
  function ca(b) {
    return this instanceof ca ? (this.v = b, this) : new ca(b);
  }
  function ae(b, a, c) {
    function d(a) {
      k[a] && (z[a] = function (c) {
        return new Promise(function (b, d) {
          1 < p.push([a, c, b, d]) || e(a, c);
        });
      });
    }
    function e(a, c) {
      try {
        var b = k[a](c);
        b.value instanceof ca ? Promise.resolve(b.value.v).then(f, h) : l(p[0][2], b);
      } catch (u) {
        l(p[0][3], u);
      }
    }
    function f(a) {
      e("next", a);
    }
    function h(a) {
      e("throw", a);
    }
    function l(a, c) {
      (a(c), p.shift(), p.length) && e(p[0][0], p[0][1]);
    }
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var k = c.apply(b, a || []),
      z,
      p = [];
    return z = {}, d("next"), d("throw"), d("return"), z[Symbol.asyncIterator] = function () {
      return this;
    }, z;
  }
  function be(b) {
    function a(a) {
      e[a] = b[a] && function (d) {
        return new Promise(function (e, f) {
          d = b[a](d);
          c(e, f, d.done, d.value);
        });
      };
    }
    function c(a, c, b, d) {
      Promise.resolve(d).then(function (c) {
        a({
          value: c,
          done: b
        });
      }, c);
    }
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var d = b[Symbol.asyncIterator],
      e;
    return d ? d.call(b) : (b = "function" === typeof F ? F(b) : b[Symbol.iterator](), e = {}, a("next"), a("throw"), a("return"), e[Symbol.asyncIterator] = function () {
      return this;
    }, e);
  }
  function t(b) {
    return "function" === typeof b;
  }
  function R(b) {
    b = b(function (a) {
      Error.call(a);
      a.stack = Error().stack;
    });
    b.prototype = Object.create(Error.prototype);
    return b.prototype.constructor = b;
  }
  function M(b, a) {
    b && (a = b.indexOf(a), 0 <= a && b.splice(a, 1));
  }
  function Ib(b) {
    return b instanceof D || b && "closed" in b && t(b.remove) && t(b.add) && t(b.unsubscribe);
  }
  function Jb(b) {
    da.setTimeout(function () {
      var a = S.onUnhandledError;
      if (a) a(b);else throw b;
    });
  }
  function C() {}
  function J(b, a, c) {
    return {
      kind: b,
      value: a,
      error: c
    };
  }
  function Ba(b) {
    if (S.useDeprecatedSynchronousErrorHandling) {
      var a = !U;
      a && (U = {
        errorThrown: !1,
        error: null
      });
      b();
      if (a && (a = U, b = a.errorThrown, a = a.error, U = null, b)) throw a;
    } else b();
  }
  function Ca(b) {
    S.useDeprecatedSynchronousErrorHandling ? S.useDeprecatedSynchronousErrorHandling && U && (U.errorThrown = !0, U.error = b) : Jb(b);
  }
  function Wa(b, a) {
    var c = S.onStoppedNotification;
    c && da.setTimeout(function () {
      return c(b, a);
    });
  }
  function E(b) {
    return b;
  }
  function Xa() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return Kb(b);
  }
  function Kb(b) {
    return 0 === b.length ? E : 1 === b.length ? b[0] : function (a) {
      return b.reduce(function (a, b) {
        return b(a);
      }, a);
    };
  }
  function Lb(b) {
    var a;
    return null !== (a = null !== b && void 0 !== b ? b : S.Promise) && void 0 !== a ? a : Promise;
  }
  function ce(b) {
    var a;
    (a = b && b instanceof na) || (a = b && t(b.next) && t(b.error) && t(b.complete) && Ib(b));
    return a;
  }
  function n(b) {
    return function (a) {
      if (t(null === a || void 0 === a ? void 0 : a.lift)) return a.lift(function (a) {
        try {
          return b(a, this);
        } catch (d) {
          this.error(d);
        }
      });
      throw new TypeError("Unable to lift unknown Observable type");
    };
  }
  function m(b, a, c, d, e) {
    return new Ya(b, a, c, d, e);
  }
  function Za() {
    return n(function (b, a) {
      var c = null;
      b._refCount++;
      var d = m(a, void 0, void 0, void 0, function () {
        if (!b || 0 >= b._refCount || 0 < --b._refCount) c = null;else {
          var d = b._connection,
            f = c;
          c = null;
          !d || f && d !== f || d.unsubscribe();
          a.unsubscribe();
        }
      });
      b.subscribe(d);
      d.closed || (c = b.connect());
    });
  }
  function Mb(b) {
    return new r(function (a) {
      var c = b || Da,
        d = c.now(),
        e = 0,
        f = function () {
          a.closed || (e = N.requestAnimationFrame(function (h) {
            e = 0;
            var l = c.now();
            a.next({
              timestamp: b ? l : h,
              elapsed: l - d
            });
            f();
          }));
        };
      f();
      return function () {
        e && N.cancelAnimationFrame(e);
      };
    });
  }
  function Nb(b) {
    return b in $a ? (delete $a[b], !0) : !1;
  }
  function de(b) {
    return new r(function (a) {
      return b.schedule(function () {
        return a.complete();
      });
    });
  }
  function Ea(b) {
    return b && t(b.schedule);
  }
  function oa(b) {
    return t(b[b.length - 1]) ? b.pop() : void 0;
  }
  function O(b) {
    return Ea(b[b.length - 1]) ? b.pop() : void 0;
  }
  function Ob(b) {
    return Symbol.asyncIterator && t(null === b || void 0 === b ? void 0 : b[Symbol.asyncIterator]);
  }
  function Pb(b) {
    return new TypeError("You provided " + (null !== b && "object" === typeof b ? "an invalid object" : "'" + b + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
  }
  function Qb(b) {
    return t(null === b || void 0 === b ? void 0 : b[ab]);
  }
  function Rb(b) {
    return ae(this, arguments, function () {
      var a, c, d, e;
      return Ua(this, function (f) {
        switch (f.label) {
          case 0:
            a = b.getReader(), f.label = 1;
          case 1:
            f.trys.push([1,, 9, 10]), f.label = 2;
          case 2:
            return [4, ca(a.read())];
          case 3:
            return c = f.sent(), d = c.value, (e = c.done) ? [4, ca(void 0)] : [3, 5];
          case 4:
            return [2, f.sent()];
          case 5:
            return [4, ca(d)];
          case 6:
            return [4, f.sent()];
          case 7:
            return f.sent(), [3, 2];
          case 8:
            return [3, 10];
          case 9:
            return a.releaseLock(), [7];
          case 10:
            return [2];
        }
      });
    });
  }
  function q(b) {
    if (b instanceof r) return b;
    if (null != b) {
      if (t(b[pa])) return ee(b);
      if (bb(b)) return fe(b);
      if (t(null === b || void 0 === b ? void 0 : b.then)) return ge(b);
      if (Ob(b)) return Sb(b);
      if (Qb(b)) return he(b);
      if (t(null === b || void 0 === b ? void 0 : b.getReader)) return Sb(Rb(b));
    }
    throw Pb(b);
  }
  function ee(b) {
    return new r(function (a) {
      var c = b[pa]();
      if (t(c.subscribe)) return c.subscribe(a);
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
  }
  function fe(b) {
    return new r(function (a) {
      for (var c = 0; c < b.length && !a.closed; c++) a.next(b[c]);
      a.complete();
    });
  }
  function ge(b) {
    return new r(function (a) {
      b.then(function (c) {
        a.closed || (a.next(c), a.complete());
      }, function (c) {
        return a.error(c);
      }).then(null, Jb);
    });
  }
  function he(b) {
    return new r(function (a) {
      var c, d;
      try {
        for (var e = F(b), f = e.next(); !f.done; f = e.next()) if (a.next(f.value), a.closed) return;
      } catch (h) {
        c = {
          error: h
        };
      } finally {
        try {
          f && !f.done && (d = e.return) && d.call(e);
        } finally {
          if (c) throw c.error;
        }
      }
      a.complete();
    });
  }
  function Sb(b) {
    return new r(function (a) {
      ie(b, a).catch(function (c) {
        return a.error(c);
      });
    });
  }
  function ie(b, a) {
    var c, d, e, f;
    return $d(this, void 0, void 0, function () {
      var h, l;
      return Ua(this, function (k) {
        switch (k.label) {
          case 0:
            k.trys.push([0, 5, 6, 11]), c = be(b), k.label = 1;
          case 1:
            return [4, c.next()];
          case 2:
            if (d = k.sent(), d.done) return [3, 4];
            h = d.value;
            a.next(h);
            if (a.closed) return [2];
            k.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [3, 11];
          case 5:
            return l = k.sent(), e = {
              error: l
            }, [3, 11];
          case 6:
            return k.trys.push([6,, 9, 10]), d && !d.done && (f = c.return) ? [4, f.call(c)] : [3, 8];
          case 7:
            k.sent(), k.label = 8;
          case 8:
            return [3, 10];
          case 9:
            if (e) throw e.error;
            return [7];
          case 10:
            return [7];
          case 11:
            return a.complete(), [2];
        }
      });
    });
  }
  function G(b, a, c, d, e) {
    void 0 === d && (d = 0);
    void 0 === e && (e = !1);
    a = a.schedule(function () {
      c();
      e ? b.add(this.schedule(null, d)) : this.unsubscribe();
    }, d);
    b.add(a);
    if (!e) return a;
  }
  function qa(b, a) {
    void 0 === a && (a = 0);
    return n(function (c, d) {
      c.subscribe(m(d, function (c) {
        return G(d, b, function () {
          return d.next(c);
        }, a);
      }, function () {
        return G(d, b, function () {
          return d.complete();
        }, a);
      }, function (c) {
        return G(d, b, function () {
          return d.error(c);
        }, a);
      }));
    });
  }
  function ra(b, a) {
    void 0 === a && (a = 0);
    return n(function (c, d) {
      d.add(b.schedule(function () {
        return c.subscribe(d);
      }, a));
    });
  }
  function je(b, a) {
    return new r(function (c) {
      var d = 0;
      return a.schedule(function () {
        d === b.length ? c.complete() : (c.next(b[d++]), c.closed || this.schedule());
      });
    });
  }
  function Tb(b, a) {
    return new r(function (c) {
      var d;
      G(c, a, function () {
        d = b[ab]();
        G(c, a, function () {
          var a, b, h;
          try {
            a = d.next(), b = a.value, h = a.done;
          } catch (l) {
            c.error(l);
            return;
          }
          h ? c.complete() : c.next(b);
        }, 0, !0);
      });
      return function () {
        return t(null === d || void 0 === d ? void 0 : d.return) && d.return();
      };
    });
  }
  function Ub(b, a) {
    if (!b) throw Error("Iterable cannot be null");
    return new r(function (c) {
      G(c, a, function () {
        var d = b[Symbol.asyncIterator]();
        G(c, a, function () {
          d.next().then(function (a) {
            a.done ? c.complete() : c.next(a.value);
          });
        }, 0, !0);
      });
    });
  }
  function Vb(b, a) {
    if (null != b) {
      if (t(b[pa])) return q(b).pipe(ra(a), qa(a));
      if (bb(b)) return je(b, a);
      if (t(null === b || void 0 === b ? void 0 : b.then)) return q(b).pipe(ra(a), qa(a));
      if (Ob(b)) return Ub(b, a);
      if (Qb(b)) return Tb(b, a);
      if (t(null === b || void 0 === b ? void 0 : b.getReader)) return Ub(Rb(b), a);
    }
    throw Pb(b);
  }
  function P(b, a) {
    return a ? Vb(b, a) : q(b);
  }
  function cb() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    a = O(b);
    return P(b, a);
  }
  function Wb(b, a) {
    var c = t(b) ? b : function () {
        return b;
      },
      d = function (a) {
        return a.error(c());
      };
    return new r(a ? function (c) {
      return a.schedule(d, 0, c);
    } : d);
  }
  function Fa(b, a) {
    var c,
      d,
      e,
      f = b.kind,
      h = b.value;
    b = b.error;
    if ("string" !== typeof f) throw new TypeError('Invalid notification, missing "kind"');
    "N" === f ? null === (c = a.next) || void 0 === c ? void 0 : c.call(a, h) : "E" === f ? null === (d = a.error) || void 0 === d ? void 0 : d.call(a, b) : null === (e = a.complete) || void 0 === e ? void 0 : e.call(a);
  }
  function db(b) {
    return b instanceof Date && !isNaN(b);
  }
  function eb(b, a) {
    b = db(b) ? {
      first: b
    } : "number" === typeof b ? {
      each: b
    } : b;
    var c = b.first,
      d = b.each,
      e = b.with,
      f = void 0 === e ? ke : e,
      e = b.scheduler,
      h = void 0 === e ? null !== a && void 0 !== a ? a : I : e;
    a = b.meta;
    var l = void 0 === a ? null : a;
    if (null == c && null == d) throw new TypeError("No timeout provided.");
    return n(function (a, b) {
      var e,
        k,
        z = null,
        g = 0,
        u = function (a) {
          k = G(b, h, function () {
            try {
              e.unsubscribe(), q(f({
                meta: l,
                lastValue: z,
                seen: g
              })).subscribe(b);
            } catch (V) {
              b.error(V);
            }
          }, a);
        };
      e = a.subscribe(m(b, function (a) {
        null === k || void 0 === k ? void 0 : k.unsubscribe();
        g++;
        b.next(z = a);
        0 < d && u(d);
      }, void 0, void 0, function () {
        (null === k || void 0 === k ? 0 : k.closed) || (null === k || void 0 === k ? void 0 : k.unsubscribe());
        z = null;
      }));
      !g && u(null != c ? "number" === typeof c ? c : +c - h.now() : d);
    });
  }
  function ke(b) {
    throw new Xb(b);
  }
  function Q(b, a) {
    return n(function (c, d) {
      var e = 0;
      c.subscribe(m(d, function (c) {
        d.next(b.call(a, c, e++));
      }));
    });
  }
  function W(b) {
    return Q(function (a) {
      return le(a) ? b.apply(void 0, x([], w(a))) : b(a);
    });
  }
  function Ga(b, a, c, d) {
    if (c) if (Ea(c)) d = c;else return function () {
      for (var e = [], f = 0; f < arguments.length; f++) e[f] = arguments[f];
      return Ga(b, a, d).apply(this, e).pipe(W(c));
    };
    return d ? function () {
      for (var c = [], f = 0; f < arguments.length; f++) c[f] = arguments[f];
      return Ga(b, a).apply(this, c).pipe(ra(d), qa(d));
    } : function () {
      for (var c = this, d = [], h = 0; h < arguments.length; h++) d[h] = arguments[h];
      var l = new fb(),
        k = !0;
      return new r(function (e) {
        e = l.subscribe(e);
        if (k) {
          var f = k = !1,
            h = !1;
          a.apply(c, x(x([], w(d)), [function () {
            for (var a = [], c = 0; c < arguments.length; c++) a[c] = arguments[c];
            if (b && (c = a.shift(), null != c)) {
              l.error(c);
              return;
            }
            l.next(1 < a.length ? a : a[0]);
            h = !0;
            f && l.complete();
          }]));
          h && l.complete();
          f = !0;
        }
        return e;
      });
    };
  }
  function Yb(b) {
    if (1 === b.length) {
      var a = b[0];
      if (me(a)) return {
        args: a,
        keys: null
      };
      if (a && "object" === typeof a && ne(a) === oe) return b = pe(a), {
        args: b.map(function (c) {
          return a[c];
        }),
        keys: b
      };
    }
    return {
      args: b,
      keys: null
    };
  }
  function Zb(b, a) {
    return b.reduce(function (c, b, e) {
      return c[b] = a[e], c;
    }, {});
  }
  function $b() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = O(b),
      a = oa(b),
      b = Yb(b),
      d = b.args,
      e = b.keys;
    if (0 === d.length) return P([], c);
    c = new r(ac(d, c, e ? function (a) {
      return Zb(e, a);
    } : E));
    return a ? c.pipe(W(a)) : c;
  }
  function ac(b, a, c) {
    void 0 === c && (c = E);
    return function (d) {
      bc(a, function () {
        for (var e = b.length, f = Array(e), h = e, l = e, k = function (e) {
            bc(a, function () {
              var k = !1;
              P(b[e], a).subscribe(m(d, function (a) {
                f[e] = a;
                k || (k = !0, l--);
                l || d.next(c(f.slice()));
              }, function () {
                --h || d.complete();
              }));
            }, d);
          }, g = 0; g < e; g++) k(g);
      }, d);
    };
  }
  function bc(b, a, c) {
    b ? G(c, b, a) : a();
  }
  function gb(b, a, c, d, e, f, h, l) {
    var k = [],
      g = 0,
      p = 0,
      v = !1,
      B = function (a) {
        return g < d ? n(a) : k.push(a);
      },
      n = function (b) {
        f && a.next(b);
        g++;
        var l = !1;
        q(c(b, p++)).subscribe(m(a, function (c) {
          null === e || void 0 === e ? void 0 : e(c);
          f ? B(c) : a.next(c);
        }, function () {
          l = !0;
        }, void 0, function () {
          if (l) try {
            g--;
            for (var c = function () {
              var c = k.shift();
              h ? G(a, h, function () {
                return n(c);
              }) : n(c);
            }; k.length && g < d;) c();
            !v || k.length || g || a.complete();
          } catch (X) {
            a.error(X);
          }
        }));
      };
    b.subscribe(m(a, B, function () {
      v = !0;
      !v || k.length || g || a.complete();
    }));
    return function () {
      null === l || void 0 === l ? void 0 : l();
    };
  }
  function H(b, a, c) {
    void 0 === c && (c = Infinity);
    if (t(a)) return H(function (c, e) {
      return Q(function (b, d) {
        return a(c, b, e, d);
      })(q(b(c, e)));
    }, c);
    "number" === typeof a && (c = a);
    return n(function (a, e) {
      return gb(a, e, b, c);
    });
  }
  function sa(b) {
    void 0 === b && (b = Infinity);
    return H(E, b);
  }
  function Ha() {
    return sa(1);
  }
  function ta() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return Ha()(P(b, O(b)));
  }
  function Ia(b) {
    return new r(function (a) {
      q(b()).subscribe(a);
    });
  }
  function hb(b, a, c, d) {
    t(c) && (d = c, c = void 0);
    if (d) return hb(b, a, c).pipe(W(d));
    d = w(qe(b) ? re.map(function (d) {
      return function (e) {
        return b[d](a, e, c);
      };
    }) : se(b) ? te.map(cc(b, a)) : ue(b) ? ve.map(cc(b, a)) : [], 2);
    var e = d[0],
      f = d[1];
    if (!e && bb(b)) return H(function (b) {
      return hb(b, a, c);
    })(q(b));
    if (!e) throw new TypeError("Invalid event target");
    return new r(function (a) {
      var c = function () {
        for (var c = [], b = 0; b < arguments.length; b++) c[b] = arguments[b];
        return a.next(1 < c.length ? c : c[0]);
      };
      e(c);
      return function () {
        return f(c);
      };
    });
  }
  function cc(b, a) {
    return function (c) {
      return function (d) {
        return b[c](a, d);
      };
    };
  }
  function se(b) {
    return t(b.addListener) && t(b.removeListener);
  }
  function ue(b) {
    return t(b.on) && t(b.off);
  }
  function qe(b) {
    return t(b.addEventListener) && t(b.removeEventListener);
  }
  function dc(b, a, c) {
    return c ? dc(b, a).pipe(W(c)) : new r(function (c) {
      var d = function () {
          for (var a = [], b = 0; b < arguments.length; b++) a[b] = arguments[b];
          return c.next(1 === a.length ? a[0] : a);
        },
        f = b(d);
      return t(a) ? function () {
        return a(d, f);
      } : void 0;
    });
  }
  function Y(b, a, c) {
    void 0 === b && (b = 0);
    void 0 === c && (c = ib);
    var d = -1;
    null != a && (Ea(a) ? c = a : d = a);
    return new r(function (a) {
      var e = db(b) ? +b - c.now() : b;
      0 > e && (e = 0);
      var h = 0;
      return c.schedule(function () {
        a.closed || (a.next(h++), 0 <= d ? this.schedule(void 0, d) : a.complete());
      }, e);
    });
  }
  function ec(b, a) {
    void 0 === b && (b = 0);
    void 0 === a && (a = I);
    0 > b && (b = 0);
    return Y(b, b, a);
  }
  function Z(b) {
    return 1 === b.length && we(b[0]) ? b[0] : b;
  }
  function fc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = Z(b);
    return new r(function (a) {
      var b = 0,
        d = function () {
          if (b < c.length) {
            var e = void 0;
            try {
              e = q(c[b++]);
            } catch (k) {
              d();
              return;
            }
            var f = new Ya(a, void 0, C, C);
            e.subscribe(f);
            f.add(d);
          } else a.complete();
        };
      d();
    });
  }
  function gc(b, a) {
    return function (c, d) {
      return !b.call(a, c, d);
    };
  }
  function K(b, a) {
    return n(function (c, d) {
      var e = 0;
      c.subscribe(m(d, function (c) {
        return b.call(a, c, e++) && d.next(c);
      }));
    });
  }
  function hc(b) {
    return function (a) {
      for (var c = [], d = function (d) {
          c.push(q(b[d]).subscribe(m(a, function (b) {
            if (c) {
              for (var e = 0; e < c.length; e++) e !== d && c[e].unsubscribe();
              c = null;
            }
            a.next(b);
          })));
        }, e = 0; c && !a.closed && e < b.length; e++) d(e);
    };
  }
  function jb() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = oa(b),
      d = Z(b);
    return d.length ? new r(function (a) {
      var b = d.map(function () {
          return [];
        }),
        e = d.map(function () {
          return !1;
        });
      a.add(function () {
        b = e = null;
      });
      for (var l = function (f) {
          q(d[f]).subscribe(m(a, function (d) {
            b[f].push(d);
            b.every(function (a) {
              return a.length;
            }) && (d = b.map(function (a) {
              return a.shift();
            }), a.next(c ? c.apply(void 0, x([], w(d))) : d), b.some(function (a, c) {
              return !a.length && e[c];
            }) && a.complete());
          }, function () {
            e[f] = !0;
            !b[f].length && a.complete();
          }));
        }, k = 0; !a.closed && k < d.length; k++) l(k);
      return function () {
        b = e = null;
      };
    }) : L;
  }
  function kb(b) {
    return n(function (a, c) {
      var d = !1,
        e = null,
        f = null,
        h = !1,
        l = function () {
          null === f || void 0 === f ? void 0 : f.unsubscribe();
          f = null;
          if (d) {
            d = !1;
            var a = e;
            e = null;
            c.next(a);
          }
          h && c.complete();
        },
        k = function () {
          f = null;
          h && c.complete();
        };
      a.subscribe(m(c, function (a) {
        d = !0;
        e = a;
        f || q(b(a)).subscribe(f = m(c, l, k));
      }, function () {
        h = !0;
        d && f && !f.closed || c.complete();
      }));
    });
  }
  function ic(b, a) {
    void 0 === a && (a = I);
    return kb(function () {
      return Y(b, a);
    });
  }
  function jc(b) {
    return n(function (a, c) {
      var d = [];
      a.subscribe(m(c, function (a) {
        return d.push(a);
      }, function () {
        c.next(d);
        c.complete();
      }));
      q(b).subscribe(m(c, function () {
        var a = d;
        d = [];
        c.next(a);
      }, C));
      return function () {
        d = null;
      };
    });
  }
  function kc(b, a) {
    void 0 === a && (a = null);
    a = null !== a && void 0 !== a ? a : b;
    return n(function (c, d) {
      var e = [],
        f = 0;
      c.subscribe(m(d, function (c) {
        var h,
          k,
          g,
          p,
          v = null;
        0 === f++ % a && e.push([]);
        try {
          for (var m = F(e), n = m.next(); !n.done; n = m.next()) {
            var u = n.value;
            u.push(c);
            b <= u.length && (v = null !== v && void 0 !== v ? v : [], v.push(u));
          }
        } catch (X) {
          h = {
            error: X
          };
        } finally {
          try {
            n && !n.done && (k = m.return) && k.call(m);
          } finally {
            if (h) throw h.error;
          }
        }
        if (v) try {
          for (var ea = F(v), V = ea.next(); !V.done; V = ea.next()) u = V.value, M(e, u), d.next(u);
        } catch (X) {
          g = {
            error: X
          };
        } finally {
          try {
            V && !V.done && (p = ea.return) && p.call(ea);
          } finally {
            if (g) throw g.error;
          }
        }
      }, function () {
        var a, c;
        try {
          for (var b = F(e), f = b.next(); !f.done; f = b.next()) d.next(f.value);
        } catch (p) {
          a = {
            error: p
          };
        } finally {
          try {
            f && !f.done && (c = b.return) && c.call(b);
          } finally {
            if (a) throw a.error;
          }
        }
        d.complete();
      }, void 0, function () {
        e = null;
      }));
    });
  }
  function lc(b) {
    for (var a, c, d = [], e = 1; e < arguments.length; e++) d[e - 1] = arguments[e];
    var f = null !== (a = O(d)) && void 0 !== a ? a : I,
      h = null !== (c = d[0]) && void 0 !== c ? c : null,
      l = d[1] || Infinity;
    return n(function (a, c) {
      var d = [],
        e = !1,
        k = function (a) {
          var b = a.buffer;
          a.subs.unsubscribe();
          M(d, a);
          c.next(b);
          e && g();
        },
        g = function () {
          if (d) {
            var a = new D();
            c.add(a);
            var e = {
              buffer: [],
              subs: a
            };
            d.push(e);
            G(a, f, function () {
              return k(e);
            }, b);
          }
        };
      null !== h && 0 <= h ? G(c, f, g, h, !0) : e = !0;
      g();
      var z = m(c, function (a) {
        var c,
          b,
          e = d.slice();
        try {
          for (var f = F(e), h = f.next(); !h.done; h = f.next()) {
            var g = h.value,
              p = g.buffer;
            p.push(a);
            l <= p.length && k(g);
          }
        } catch (ze) {
          c = {
            error: ze
          };
        } finally {
          try {
            h && !h.done && (b = f.return) && b.call(f);
          } finally {
            if (c) throw c.error;
          }
        }
      }, function () {
        for (; null === d || void 0 === d ? 0 : d.length;) c.next(d.shift().buffer);
        null === z || void 0 === z ? void 0 : z.unsubscribe();
        c.complete();
        c.unsubscribe();
      }, void 0, function () {
        return d = null;
      });
      a.subscribe(z);
    });
  }
  function mc(b, a) {
    return n(function (c, d) {
      var e = [];
      q(b).subscribe(m(d, function (c) {
        var b = [];
        e.push(b);
        var f = new D();
        f.add(q(a(c)).subscribe(m(d, function () {
          M(e, b);
          d.next(b);
          f.unsubscribe();
        }, C)));
      }, C));
      c.subscribe(m(d, function (a) {
        var c, b;
        try {
          for (var d = F(e), f = d.next(); !f.done; f = d.next()) f.value.push(a);
        } catch (p) {
          c = {
            error: p
          };
        } finally {
          try {
            f && !f.done && (b = d.return) && b.call(d);
          } finally {
            if (c) throw c.error;
          }
        }
      }, function () {
        for (; 0 < e.length;) d.next(e.shift());
        d.complete();
      }));
    });
  }
  function nc(b) {
    return n(function (a, c) {
      var d = null,
        e = null,
        f = function () {
          null === e || void 0 === e ? void 0 : e.unsubscribe();
          var a = d;
          d = [];
          a && c.next(a);
          q(b()).subscribe(e = m(c, f, C));
        };
      f();
      a.subscribe(m(c, function (a) {
        return null === d || void 0 === d ? void 0 : d.push(a);
      }, function () {
        d && c.next(d);
        c.complete();
      }, void 0, function () {
        return d = e = null;
      }));
    });
  }
  function lb(b) {
    return n(function (a, c) {
      var d = null,
        e = !1,
        f,
        d = a.subscribe(m(c, void 0, void 0, function (h) {
          f = q(b(h, lb(b)(a)));
          d ? (d.unsubscribe(), d = null, f.subscribe(c)) : e = !0;
        }));
      e && (d.unsubscribe(), d = null, f.subscribe(c));
    });
  }
  function oc(b, a, c, d, e) {
    return function (f, h) {
      var l = c,
        k = a,
        g = 0;
      f.subscribe(m(h, function (a) {
        var c = g++;
        k = l ? b(k, a, c) : (l = !0, a);
        d && h.next(k);
      }, e && function () {
        l && h.next(k);
        h.complete();
      }));
    };
  }
  function fa(b, a) {
    return n(oc(b, a, 2 <= arguments.length, !1, !0));
  }
  function mb() {
    return n(function (b, a) {
      fa(Ae, [])(b).subscribe(a);
    });
  }
  function pc(b, a) {
    return Xa(mb(), H(function (a) {
      return b(a);
    }), a ? W(a) : E);
  }
  function Ja(b) {
    return pc($b, b);
  }
  function nb() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return (a = oa(b)) ? Xa(nb.apply(void 0, x([], w(b))), W(a)) : n(function (a, d) {
      ac(x([a], w(Z(b))))(d);
    });
  }
  function qc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return nb.apply(void 0, x([], w(b)));
  }
  function Ka(b, a) {
    return t(a) ? H(b, a, 1) : H(b, 1);
  }
  function rc(b, a) {
    return t(a) ? Ka(function () {
      return b;
    }, a) : Ka(function () {
      return b;
    });
  }
  function sc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = O(b);
    return n(function (a, e) {
      Ha()(P(x([a], w(b)), c)).subscribe(e);
    });
  }
  function tc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return sc.apply(void 0, x([], w(b)));
  }
  function Be(b) {
    return new r(function (a) {
      return b.subscribe(a);
    });
  }
  function La(b, a) {
    void 0 === a && (a = Ce);
    var c = a.connector;
    return n(function (a, e) {
      var d = c();
      q(b(Be(d))).subscribe(e);
      e.add(a.subscribe(d));
    });
  }
  function uc(b) {
    return fa(function (a, c, d) {
      return !b || b(c, d) ? a + 1 : a;
    }, 0);
  }
  function vc(b) {
    return n(function (a, c) {
      var d = !1,
        e = null,
        f = null,
        h = function () {
          null === f || void 0 === f ? void 0 : f.unsubscribe();
          f = null;
          if (d) {
            d = !1;
            var a = e;
            e = null;
            c.next(a);
          }
        };
      a.subscribe(m(c, function (a) {
        null === f || void 0 === f ? void 0 : f.unsubscribe();
        d = !0;
        e = a;
        f = m(c, h, C);
        q(b(a)).subscribe(f);
      }, function () {
        h();
        c.complete();
      }, void 0, function () {
        e = f = null;
      }));
    });
  }
  function wc(b, a) {
    void 0 === a && (a = I);
    return n(function (c, d) {
      function e() {
        var c = l + b,
          e = a.now();
        e < c ? (f = this.schedule(void 0, c - e), d.add(f)) : k();
      }
      var f = null,
        h = null,
        l = null,
        k = function () {
          if (f) {
            f.unsubscribe();
            f = null;
            var a = h;
            h = null;
            d.next(a);
          }
        };
      c.subscribe(m(d, function (c) {
        h = c;
        l = a.now();
        f || (f = a.schedule(e, b), d.add(f));
      }, function () {
        k();
        d.complete();
      }, void 0, function () {
        h = f = null;
      }));
    });
  }
  function ua(b) {
    return n(function (a, c) {
      var d = !1;
      a.subscribe(m(c, function (a) {
        d = !0;
        c.next(a);
      }, function () {
        d || c.next(b);
        c.complete();
      }));
    });
  }
  function ga(b) {
    return 0 >= b ? function () {
      return L;
    } : n(function (a, c) {
      var d = 0;
      a.subscribe(m(c, function (a) {
        ++d <= b && (c.next(a), b <= d && c.complete());
      }));
    });
  }
  function ob() {
    return n(function (b, a) {
      b.subscribe(m(a, C));
    });
  }
  function pb(b) {
    return Q(function () {
      return b;
    });
  }
  function Ma(b, a) {
    return a ? function (c) {
      return ta(a.pipe(ga(1), ob()), c.pipe(Ma(b)));
    } : H(function (a, d) {
      return q(b(a, d)).pipe(ga(1), pb(a));
    });
  }
  function xc(b, a) {
    void 0 === a && (a = I);
    var c = Y(b, a);
    return Ma(function () {
      return c;
    });
  }
  function yc() {
    return n(function (b, a) {
      b.subscribe(m(a, function (c) {
        return Fa(c, a);
      }));
    });
  }
  function zc(b, a) {
    return n(function (c, d) {
      var e = new Set();
      c.subscribe(m(d, function (a) {
        var c = b ? b(a) : a;
        e.has(c) || (e.add(c), d.next(a));
      }));
      a && q(a).subscribe(m(d, function () {
        return e.clear();
      }, C));
    });
  }
  function qb(b, a) {
    void 0 === a && (a = E);
    b = null !== b && void 0 !== b ? b : De;
    return n(function (c, d) {
      var e,
        f = !0;
      c.subscribe(m(d, function (c) {
        var h = a(c);
        if (f || !b(e, h)) f = !1, e = h, d.next(c);
      }));
    });
  }
  function De(b, a) {
    return b === a;
  }
  function Ac(b, a) {
    return qb(function (c, d) {
      return a ? a(c[b], d[b]) : c[b] === d[b];
    });
  }
  function va(b) {
    void 0 === b && (b = Ee);
    return n(function (a, c) {
      var d = !1;
      a.subscribe(m(c, function (a) {
        d = !0;
        c.next(a);
      }, function () {
        return d ? c.complete() : c.error(b());
      }));
    });
  }
  function Ee() {
    return new aa();
  }
  function Bc(b, a) {
    if (0 > b) throw new rb();
    var c = 2 <= arguments.length;
    return function (d) {
      return d.pipe(K(function (a, c) {
        return c === b;
      }), ga(1), c ? ua(a) : va(function () {
        return new rb();
      }));
    };
  }
  function Cc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return function (a) {
      return ta(a, cb.apply(void 0, x([], w(b))));
    };
  }
  function Dc(b, a) {
    return n(function (c, d) {
      var e = 0;
      c.subscribe(m(d, function (f) {
        b.call(a, f, e++, c) || (d.next(!1), d.complete());
      }, function () {
        d.next(!0);
        d.complete();
      }));
    });
  }
  function Na(b, a) {
    return a ? function (c) {
      return c.pipe(Na(function (c, e) {
        return q(b(c, e)).pipe(Q(function (b, d) {
          return a(c, b, e, d);
        }));
      }));
    } : n(function (a, d) {
      var c = 0,
        f = null,
        h = !1;
      a.subscribe(m(d, function (a) {
        f || (f = m(d, void 0, function () {
          f = null;
          h && d.complete();
        }), q(b(a, c++)).subscribe(f));
      }, function () {
        h = !0;
        !f && d.complete();
      }));
    });
  }
  function Oa() {
    return Na(E);
  }
  function Ec(b, a, c) {
    void 0 === a && (a = Infinity);
    a = 1 > (a || 0) ? Infinity : a;
    return n(function (d, e) {
      return gb(d, e, b, a, void 0, !0, c);
    });
  }
  function Fc(b) {
    return n(function (a, c) {
      try {
        a.subscribe(c);
      } finally {
        c.add(b);
      }
    });
  }
  function Gc(b, a) {
    return n(Hc(b, a, "value"));
  }
  function Hc(b, a, c) {
    var d = "index" === c;
    return function (c, f) {
      var e = 0;
      c.subscribe(m(f, function (h) {
        var l = e++;
        b.call(a, h, l, c) && (f.next(d ? l : h), f.complete());
      }, function () {
        f.next(d ? -1 : void 0);
        f.complete();
      }));
    };
  }
  function Ic(b, a) {
    return n(Hc(b, a, "index"));
  }
  function Jc(b, a) {
    var c = 2 <= arguments.length;
    return function (d) {
      return d.pipe(b ? K(function (a, c) {
        return b(a, c, d);
      }) : E, ga(1), c ? ua(a) : va(function () {
        return new aa();
      }));
    };
  }
  function Kc(b, a, c, d) {
    return n(function (e, f) {
      function h(a, c) {
        var b = new r(function (a) {
          v++;
          var b = c.subscribe(a);
          return function () {
            b.unsubscribe();
            0 === --v && n && Va.unsubscribe();
          };
        });
        b.key = a;
        return b;
      }
      var l;
      a && "function" !== typeof a ? (c = a.duration, l = a.element, d = a.connector) : l = a;
      var k = new Map(),
        g = function (a) {
          k.forEach(a);
          a(f);
        },
        p = function (a) {
          return g(function (c) {
            return c.error(a);
          });
        },
        v = 0,
        n = !1,
        Va = new Ya(f, function (a) {
          try {
            var e = b(a),
              g = k.get(e);
            if (!g) {
              k.set(e, g = d ? d() : new A());
              var z = h(e, g);
              f.next(z);
              if (c) {
                var v = m(g, function () {
                  g.complete();
                  null === v || void 0 === v ? void 0 : v.unsubscribe();
                }, void 0, void 0, function () {
                  return k.delete(e);
                });
                Va.add(q(c(z)).subscribe(v));
              }
            }
            g.next(l ? l(a) : a);
          } catch (xe) {
            p(xe);
          }
        }, function () {
          return g(function (a) {
            return a.complete();
          });
        }, p, function () {
          return k.clear();
        }, function () {
          n = !0;
          return 0 === v;
        });
      e.subscribe(Va);
    });
  }
  function Lc() {
    return n(function (b, a) {
      b.subscribe(m(a, function () {
        a.next(!1);
        a.complete();
      }, function () {
        a.next(!0);
        a.complete();
      }));
    });
  }
  function sb(b) {
    return 0 >= b ? function () {
      return L;
    } : n(function (a, c) {
      var d = [];
      a.subscribe(m(c, function (a) {
        d.push(a);
        b < d.length && d.shift();
      }, function () {
        var a, b;
        try {
          for (var h = F(d), l = h.next(); !l.done; l = h.next()) c.next(l.value);
        } catch (k) {
          a = {
            error: k
          };
        } finally {
          try {
            l && !l.done && (b = h.return) && b.call(h);
          } finally {
            if (a) throw a.error;
          }
        }
        c.complete();
      }, void 0, function () {
        d = null;
      }));
    });
  }
  function Mc(b, a) {
    var c = 2 <= arguments.length;
    return function (d) {
      return d.pipe(b ? K(function (a, c) {
        return b(a, c, d);
      }) : E, sb(1), c ? ua(a) : va(function () {
        return new aa();
      }));
    };
  }
  function Nc() {
    return n(function (b, a) {
      b.subscribe(m(a, function (c) {
        a.next(Pa.createNext(c));
      }, function () {
        a.next(Pa.createComplete());
        a.complete();
      }, function (c) {
        a.next(Pa.createError(c));
        a.complete();
      }));
    });
  }
  function Oc(b) {
    return fa(t(b) ? function (a, c) {
      return 0 < b(a, c) ? a : c;
    } : function (a, c) {
      return a > c ? a : c;
    });
  }
  function Pc(b, a, c) {
    void 0 === c && (c = Infinity);
    if (t(a)) return H(function () {
      return b;
    }, a, c);
    "number" === typeof a && (c = a);
    return H(function () {
      return b;
    }, c);
  }
  function Qc(b, a, c) {
    void 0 === c && (c = Infinity);
    return n(function (d, e) {
      var f = a;
      return gb(d, e, function (a, c) {
        return b(f, a, c);
      }, c, function (a) {
        f = a;
      }, !1, void 0, function () {
        return f = null;
      });
    });
  }
  function Rc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = O(b),
      d = "number" === typeof b[b.length - 1] ? b.pop() : Infinity,
      b = Z(b);
    return n(function (a, f) {
      sa(d)(P(x([a], w(b)), c)).subscribe(f);
    });
  }
  function Sc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return Rc.apply(void 0, x([], w(b)));
  }
  function Tc(b) {
    return fa(t(b) ? function (a, c) {
      return 0 > b(a, c) ? a : c;
    } : function (a, c) {
      return a < c ? a : c;
    });
  }
  function Qa(b, a) {
    var c = t(b) ? b : function () {
      return b;
    };
    return t(a) ? La(a, {
      connector: c
    }) : function (a) {
      return new Ra(a, c);
    };
  }
  function Uc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = Z(b);
    return function (a) {
      return fc.apply(void 0, x([a], w(c)));
    };
  }
  function Vc() {
    return n(function (b, a) {
      var c,
        d = !1;
      b.subscribe(m(a, function (b) {
        var e = c;
        c = b;
        d && a.next([e, b]);
        d = !0;
      }));
    });
  }
  function Wc() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = b.length;
    if (0 === c) throw Error("list of properties cannot be empty.");
    return Q(function (a) {
      var d = a;
      for (a = 0; a < c; a++) if (d = null === d || void 0 === d ? void 0 : d[b[a]], "undefined" === typeof d) return;
      return d;
    });
  }
  function Xc(b) {
    return b ? function (a) {
      return La(b)(a);
    } : function (a) {
      return Qa(new A())(a);
    };
  }
  function Yc(b) {
    return function (a) {
      var c = new Zc(b);
      return new Ra(a, function () {
        return c;
      });
    };
  }
  function $c() {
    return function (b) {
      var a = new fb();
      return new Ra(b, function () {
        return a;
      });
    };
  }
  function ad(b, a, c, d) {
    c && !t(c) && (d = c);
    var e = t(c) ? c : void 0;
    return function (c) {
      return Qa(new ha(b, a, d), e)(c);
    };
  }
  function tb() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return b.length ? n(function (a, d) {
      hc(x([a], w(b)))(d);
    }) : E;
  }
  function bd(b) {
    var a,
      c = Infinity,
      d;
    null != b && ("object" === typeof b ? (a = b.count, c = void 0 === a ? Infinity : a, d = b.delay) : c = b);
    return 0 >= c ? function () {
      return L;
    } : n(function (a, b) {
      var e = 0,
        f,
        k = function () {
          null === f || void 0 === f ? void 0 : f.unsubscribe();
          f = null;
          if (null != d) {
            var a = "number" === typeof d ? Y(d) : q(d(e)),
              c = m(b, function () {
                c.unsubscribe();
                g();
              });
            a.subscribe(c);
          } else g();
        },
        g = function () {
          var d = !1;
          f = a.subscribe(m(b, void 0, function () {
            ++e < c ? f ? k() : d = !0 : b.complete();
          }));
          d && k();
        };
      g();
    });
  }
  function cd(b) {
    return n(function (a, c) {
      var d,
        e = !1,
        f,
        h = !1,
        l = !1,
        k = function () {
          f || (f = new A(), q(b(f)).subscribe(m(c, function () {
            d ? g() : e = !0;
          }, function () {
            h = !0;
            l && h && c.complete();
          })));
          return f;
        },
        g = function () {
          l = !1;
          d = a.subscribe(m(c, void 0, function () {
            (l = !0, h) && (c.complete(), !0) || k().next();
          }));
          e && (d.unsubscribe(), d = null, e = !1, g());
        };
      g();
    });
  }
  function dd(b) {
    void 0 === b && (b = Infinity);
    b = b && "object" === typeof b ? b : {
      count: b
    };
    var a = b.count,
      c = void 0 === a ? Infinity : a,
      d = b.delay;
    b = b.resetOnSuccess;
    var e = void 0 === b ? !1 : b;
    return 0 >= c ? E : n(function (a, b) {
      var f = 0,
        h,
        g = function () {
          var l = !1;
          h = a.subscribe(m(b, function (a) {
            e && (f = 0);
            b.next(a);
          }, void 0, function (a) {
            if (f++ < c) {
              var e = function () {
                h ? (h.unsubscribe(), h = null, g()) : l = !0;
              };
              if (null != d) {
                a = "number" === typeof d ? Y(d) : q(d(a, f));
                var k = m(b, function () {
                  k.unsubscribe();
                  e();
                }, function () {
                  b.complete();
                });
                a.subscribe(k);
              } else e();
            } else b.error(a);
          }));
          l && (h.unsubscribe(), h = null, g());
        };
      g();
    });
  }
  function ed(b) {
    return n(function (a, c) {
      var d,
        e = !1,
        f,
        h = function () {
          d = a.subscribe(m(c, void 0, void 0, function (a) {
            f || (f = new A(), q(b(f)).subscribe(m(c, function () {
              return d ? h() : e = !0;
            })));
            f && f.next(a);
          }));
          e && (d.unsubscribe(), d = null, e = !1, h());
        };
      h();
    });
  }
  function ub(b) {
    return n(function (a, c) {
      var d = !1,
        e = null;
      a.subscribe(m(c, function (a) {
        d = !0;
        e = a;
      }));
      q(b).subscribe(m(c, function () {
        if (d) {
          d = !1;
          var a = e;
          e = null;
          c.next(a);
        }
      }, C));
    });
  }
  function fd(b, a) {
    void 0 === a && (a = I);
    return ub(ec(b, a));
  }
  function gd(b, a) {
    return n(oc(b, a, 2 <= arguments.length, !0));
  }
  function hd(b, a) {
    void 0 === a && (a = function (a, b) {
      return a === b;
    });
    return n(function (c, d) {
      var e = {
          buffer: [],
          complete: !1
        },
        f = {
          buffer: [],
          complete: !1
        },
        h = function (c, b) {
          var e = m(d, function (e) {
            var f = b.buffer,
              h = b.complete;
            0 === f.length ? h ? (d.next(!1), d.complete()) : c.buffer.push(e) : a(e, f.shift()) || (d.next(!1), d.complete());
          }, function () {
            c.complete = !0;
            var a = b.buffer;
            b.complete && (d.next(0 === a.length), d.complete());
            null === e || void 0 === e ? void 0 : e.unsubscribe();
          });
          return e;
        };
      c.subscribe(h(e, f));
      q(b).subscribe(h(f, e));
    });
  }
  function vb(b) {
    void 0 === b && (b = {});
    var a = b.connector,
      c = void 0 === a ? function () {
        return new A();
      } : a,
      a = b.resetOnError,
      d = void 0 === a ? !0 : a,
      a = b.resetOnComplete,
      e = void 0 === a ? !0 : a;
    b = b.resetOnRefCountZero;
    var f = void 0 === b ? !0 : b;
    return function (a) {
      var b,
        h,
        g,
        p = 0,
        v = !1,
        m = !1,
        t = function () {
          null === h || void 0 === h ? void 0 : h.unsubscribe();
          h = void 0;
        },
        u = function () {
          t();
          b = g = void 0;
          v = m = !1;
        },
        ea = function () {
          var a = b;
          u();
          null === a || void 0 === a ? void 0 : a.unsubscribe();
        };
      return n(function (a, l) {
        p++;
        m || v || t();
        var k = g = null !== g && void 0 !== g ? g : c();
        l.add(function () {
          p--;
          0 !== p || m || v || (h = wb(ea, f));
        });
        k.subscribe(l);
        !b && 0 < p && (b = new ia({
          next: function (a) {
            return k.next(a);
          },
          error: function (a) {
            m = !0;
            t();
            h = wb(u, d, a);
            k.error(a);
          },
          complete: function () {
            v = !0;
            t();
            h = wb(u, e);
            k.complete();
          }
        }), q(a).subscribe(b));
      })(a);
    };
  }
  function wb(b, a) {
    for (var c = [], d = 2; d < arguments.length; d++) c[d - 2] = arguments[d];
    if (!0 === a) b();else if (!1 !== a) {
      var e = new ia({
        next: function () {
          e.unsubscribe();
          b();
        }
      });
      return q(a.apply(void 0, x([], w(c)))).subscribe(e);
    }
  }
  function id(b, a, c) {
    var d, e;
    d = !1;
    b && "object" === typeof b ? (d = b.bufferSize, e = void 0 === d ? Infinity : d, d = b.windowTime, a = void 0 === d ? Infinity : d, d = b.refCount, d = void 0 === d ? !1 : d, c = b.scheduler) : e = null !== b && void 0 !== b ? b : Infinity;
    return vb({
      connector: function () {
        return new ha(e, a, c);
      },
      resetOnError: !0,
      resetOnComplete: !1,
      resetOnRefCountZero: d
    });
  }
  function jd(b) {
    return n(function (a, c) {
      var d = !1,
        e,
        f = !1,
        h = 0;
      a.subscribe(m(c, function (l) {
        f = !0;
        if (!b || b(l, h++, a)) d && c.error(new kd("Too many matching values")), d = !0, e = l;
      }, function () {
        d ? (c.next(e), c.complete()) : c.error(f ? new ld("No matching values") : new aa());
      }));
    });
  }
  function md(b) {
    return K(function (a, c) {
      return b <= c;
    });
  }
  function nd(b) {
    return 0 >= b ? E : n(function (a, c) {
      var d = Array(b),
        e = 0;
      a.subscribe(m(c, function (a) {
        var f = e++;
        if (f < b) d[f] = a;else {
          var f = f % b,
            l = d[f];
          d[f] = a;
          c.next(l);
        }
      }));
      return function () {
        d = null;
      };
    });
  }
  function od(b) {
    return n(function (a, c) {
      var d = !1,
        e = m(c, function () {
          null === e || void 0 === e ? void 0 : e.unsubscribe();
          d = !0;
        }, C);
      q(b).subscribe(e);
      a.subscribe(m(c, function (a) {
        return d && c.next(a);
      }));
    });
  }
  function pd(b) {
    return n(function (a, c) {
      var d = !1,
        e = 0;
      a.subscribe(m(c, function (a) {
        return (d || (d = !b(a, e++))) && c.next(a);
      }));
    });
  }
  function qd() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = O(b);
    return n(function (a, e) {
      (c ? ta(b, a, c) : ta(b, a)).subscribe(e);
    });
  }
  function ja(b, a) {
    return n(function (c, d) {
      var e = null,
        f = 0,
        h = !1;
      c.subscribe(m(d, function (c) {
        null === e || void 0 === e ? void 0 : e.unsubscribe();
        var l = 0,
          g = f++;
        q(b(c, g)).subscribe(e = m(d, function (b) {
          return d.next(a ? a(c, b, g, l++) : b);
        }, function () {
          e = null;
          h && !e && d.complete();
        }));
      }, function () {
        (h = !0, !e) && d.complete();
      }));
    });
  }
  function rd() {
    return ja(E);
  }
  function sd(b, a) {
    return t(a) ? ja(function () {
      return b;
    }, a) : ja(function () {
      return b;
    });
  }
  function td(b, a) {
    return n(function (c, d) {
      var e = a;
      ja(function (a, c) {
        return b(e, a, c);
      }, function (a, c) {
        return e = c, c;
      })(c).subscribe(d);
      return function () {
        e = null;
      };
    });
  }
  function ud(b) {
    return n(function (a, c) {
      q(b).subscribe(m(c, function () {
        return c.complete();
      }, C));
      !c.closed && a.subscribe(c);
    });
  }
  function vd(b, a) {
    void 0 === a && (a = !1);
    return n(function (c, d) {
      var e = 0;
      c.subscribe(m(d, function (c) {
        var f = b(c, e++);
        (f || a) && d.next(c);
        !f && d.complete();
      }));
    });
  }
  function wd(b, a, c) {
    var d = t(b) || a || c ? {
      next: b,
      error: a,
      complete: c
    } : b;
    return d ? n(function (a, c) {
      var b;
      null === (b = d.subscribe) || void 0 === b ? void 0 : b.call(d);
      var e = !0;
      a.subscribe(m(c, function (a) {
        var b;
        null === (b = d.next) || void 0 === b ? void 0 : b.call(d, a);
        c.next(a);
      }, function () {
        var a;
        e = !1;
        null === (a = d.complete) || void 0 === a ? void 0 : a.call(d);
        c.complete();
      }, function (a) {
        var b;
        e = !1;
        null === (b = d.error) || void 0 === b ? void 0 : b.call(d, a);
        c.error(a);
      }, function () {
        var a, c;
        e && (null === (a = d.unsubscribe) || void 0 === a ? void 0 : a.call(d));
        null === (c = d.finalize) || void 0 === c ? void 0 : c.call(d);
      }));
    }) : E;
  }
  function xb(b, a) {
    return n(function (c, d) {
      var e = null !== a && void 0 !== a ? a : {},
        f = e.leading,
        h = void 0 === f ? !0 : f,
        e = e.trailing,
        l = void 0 === e ? !1 : e,
        g = !1,
        z = null,
        p = null,
        v = !1,
        n = function () {
          null === p || void 0 === p ? void 0 : p.unsubscribe();
          p = null;
          l && (u(), v && d.complete());
        },
        t = function () {
          p = null;
          v && d.complete();
        },
        u = function () {
          if (g) {
            g = !1;
            var a = z;
            z = null;
            d.next(a);
            !v && (p = q(b(a)).subscribe(m(d, n, t)));
          }
        };
      c.subscribe(m(d, function (a) {
        g = !0;
        z = a;
        (!p || p.closed) && (h ? u() : p = q(b(a)).subscribe(m(d, n, t)));
      }, function () {
        v = !0;
        l && g && p && !p.closed || d.complete();
      }));
    });
  }
  function xd(b, a, c) {
    void 0 === a && (a = I);
    var d = Y(b, a);
    return xb(function () {
      return d;
    }, c);
  }
  function yd(b) {
    void 0 === b && (b = I);
    return n(function (a, c) {
      var d = b.now();
      a.subscribe(m(c, function (a) {
        var e = b.now(),
          h = e - d;
        d = e;
        c.next(new Fe(a, h));
      }));
    });
  }
  function zd(b, a, c) {
    var d, e;
    c = null !== c && void 0 !== c ? c : ib;
    db(b) ? d = b : "number" === typeof b && (e = b);
    if (a) b = function () {
      return a;
    };else throw new TypeError("No observable provided to switch to");
    if (null == d && null == e) throw new TypeError("No timeout provided.");
    return eb({
      first: d,
      each: e,
      scheduler: c,
      with: b
    });
  }
  function Ad(b) {
    void 0 === b && (b = ka);
    return Q(function (a) {
      return {
        value: a,
        timestamp: b.now()
      };
    });
  }
  function Bd(b) {
    return n(function (a, c) {
      var d = new A();
      c.next(d.asObservable());
      var e = function (a) {
        d.error(a);
        c.error(a);
      };
      a.subscribe(m(c, function (a) {
        return null === d || void 0 === d ? void 0 : d.next(a);
      }, function () {
        d.complete();
        c.complete();
      }, e));
      q(b).subscribe(m(c, function () {
        d.complete();
        c.next(d = new A());
      }, C, e));
      return function () {
        null === d || void 0 === d ? void 0 : d.unsubscribe();
        d = null;
      };
    });
  }
  function Cd(b, a) {
    void 0 === a && (a = 0);
    var c = 0 < a ? a : b;
    return n(function (a, e) {
      var d = [new A()],
        h = 0;
      e.next(d[0].asObservable());
      a.subscribe(m(e, function (a) {
        var f, l;
        try {
          for (var g = F(d), v = g.next(); !v.done; v = g.next()) v.value.next(a);
        } catch (B) {
          f = {
            error: B
          };
        } finally {
          try {
            v && !v.done && (l = g.return) && l.call(g);
          } finally {
            if (f) throw f.error;
          }
        }
        a = h - b + 1;
        0 <= a && 0 === a % c && d.shift().complete();
        0 === ++h % c && (a = new A(), d.push(a), e.next(a.asObservable()));
      }, function () {
        for (; 0 < d.length;) d.shift().complete();
        e.complete();
      }, function (a) {
        for (; 0 < d.length;) d.shift().error(a);
        e.error(a);
      }, function () {
        d = null;
      }));
    });
  }
  function Dd(b) {
    for (var a, c, d = [], e = 1; e < arguments.length; e++) d[e - 1] = arguments[e];
    var f = null !== (a = O(d)) && void 0 !== a ? a : I,
      h = null !== (c = d[0]) && void 0 !== c ? c : null,
      g = d[1] || Infinity;
    return n(function (a, c) {
      var d = [],
        e = !1,
        l = function (a) {
          var c = a.subs;
          a.window.complete();
          c.unsubscribe();
          M(d, a);
          e && k();
        },
        k = function () {
          if (d) {
            var a = new D();
            c.add(a);
            var e = new A(),
              h = {
                window: e,
                subs: a,
                seen: 0
              };
            d.push(h);
            c.next(e.asObservable());
            G(a, f, function () {
              return l(h);
            }, b);
          }
        };
      null !== h && 0 <= h ? G(c, f, k, h, !0) : e = !0;
      k();
      var n = function (a) {
        d.slice().forEach(function (c) {
          return a(c.window);
        });
        a(c);
        c.unsubscribe();
      };
      a.subscribe(m(c, function (a) {
        d.slice().forEach(function (c) {
          c.window.next(a);
          g <= ++c.seen && l(c);
        });
      }, function () {
        return n(function (a) {
          return a.complete();
        });
      }, function (a) {
        return n(function (c) {
          return c.error(a);
        });
      }));
      return function () {
        d = null;
      };
    });
  }
  function Ed(b, a) {
    return n(function (c, d) {
      var e = [],
        f = function (a) {
          for (; 0 < e.length;) e.shift().error(a);
          d.error(a);
        };
      q(b).subscribe(m(d, function (c) {
        var b = new A();
        e.push(b);
        var h = new D(),
          g;
        try {
          g = q(a(c));
        } catch (p) {
          f(p);
          return;
        }
        d.next(b.asObservable());
        h.add(g.subscribe(m(d, function () {
          M(e, b);
          b.complete();
          h.unsubscribe();
        }, C, f)));
      }, C));
      c.subscribe(m(d, function (a) {
        var c,
          b,
          d = e.slice();
        try {
          for (var f = F(d), h = f.next(); !h.done; h = f.next()) h.value.next(a);
        } catch (B) {
          c = {
            error: B
          };
        } finally {
          try {
            h && !h.done && (b = f.return) && b.call(f);
          } finally {
            if (c) throw c.error;
          }
        }
      }, function () {
        for (; 0 < e.length;) e.shift().complete();
        d.complete();
      }, f, function () {
        for (; 0 < e.length;) e.shift().unsubscribe();
      }));
    });
  }
  function Fd(b) {
    return n(function (a, c) {
      var d,
        e,
        f = function (a) {
          d.error(a);
          c.error(a);
        },
        h = function () {
          null === e || void 0 === e ? void 0 : e.unsubscribe();
          null === d || void 0 === d ? void 0 : d.complete();
          d = new A();
          c.next(d.asObservable());
          var a;
          try {
            a = q(b());
          } catch (k) {
            f(k);
            return;
          }
          a.subscribe(e = m(c, h, h, f));
        };
      h();
      a.subscribe(m(c, function (a) {
        return d.next(a);
      }, function () {
        d.complete();
        c.complete();
      }, f, function () {
        null === e || void 0 === e ? void 0 : e.unsubscribe();
        d = null;
      }));
    });
  }
  function Gd() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var c = oa(b);
    return n(function (a, e) {
      for (var d = b.length, h = Array(d), g = b.map(function () {
          return !1;
        }), k = !1, n = function (a) {
          q(b[a]).subscribe(m(e, function (c) {
            h[a] = c;
            k || g[a] || (g[a] = !0, (k = g.every(E)) && (g = null));
          }, C));
        }, p = 0; p < d; p++) n(p);
      a.subscribe(m(e, function (a) {
        k && (a = x([a], w(h)), e.next(c ? c.apply(void 0, x([], w(a))) : a));
      }));
    });
  }
  function Hd(b) {
    return pc(jb, b);
  }
  function Id() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return n(function (a, d) {
      jb.apply(void 0, x([a], w(b))).subscribe(d);
    });
  }
  function Jd() {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    return Id.apply(void 0, x([], w(b)));
  }
  function Kd(b, a) {
    for (var c = 0, d = a.length; c < d; c++) for (var e = a[c], f = Object.getOwnPropertyNames(e.prototype), h = 0, g = f.length; h < g; h++) {
      var k = f[h];
      b.prototype[k] = e.prototype[k];
    }
  }
  function Ld(b) {
    switch (b.responseType) {
      case "json":
        return "response" in b ? b.response : JSON.parse(b.responseText);
      case "document":
        return b.responseXML;
      default:
        return "response" in b ? b.response : b.responseText;
    }
  }
  function Ge(b, a) {
    return ba({
      method: "GET",
      url: b,
      headers: a
    });
  }
  function He(b, a, c) {
    return ba({
      method: "POST",
      url: b,
      body: a,
      headers: c
    });
  }
  function Ie(b, a) {
    return ba({
      method: "DELETE",
      url: b,
      headers: a
    });
  }
  function Je(b, a, c) {
    return ba({
      method: "PUT",
      url: b,
      body: a,
      headers: c
    });
  }
  function Ke(b, a, c) {
    return ba({
      method: "PATCH",
      url: b,
      body: a,
      headers: c
    });
  }
  function Le(b, a) {
    return Me(ba({
      method: "GET",
      url: b,
      headers: a
    }));
  }
  function Ne(b) {
    return new r(function (a) {
      var c,
        d,
        e = T({
          async: !0,
          crossDomain: !1,
          withCredentials: !1,
          method: "GET",
          timeout: 0,
          responseType: "json"
        }, b),
        f = e.queryParams,
        h = e.body,
        g = e.headers,
        k = e.url;
      if (!k) throw new TypeError("url is required");
      if (f) {
        var m;
        if (k.includes("?")) {
          k = k.split("?");
          if (2 < k.length) throw new TypeError("invalid url");
          m = new URLSearchParams(k[1]);
          new URLSearchParams(f).forEach(function (a, c) {
            return m.set(c, a);
          });
          k = k[0] + "?" + m;
        } else m = new URLSearchParams(f), k = k + "?" + m;
      }
      f = {};
      if (g) for (var p in g) g.hasOwnProperty(p) && (f[p.toLowerCase()] = g[p]);
      var n = e.crossDomain;
      n || "x-requested-with" in f || (f["x-requested-with"] = "XMLHttpRequest");
      var t = e.xsrfCookieName,
        g = e.xsrfHeaderName;
      (e.withCredentials || !n) && t && g && (n = null !== (d = null === (c = null === document || void 0 === document ? void 0 : document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")\x3d([^;]*)"))) || void 0 === c ? void 0 : c.pop()) && void 0 !== d ? d : "") && (f[g] = n);
      c = Oe(h, f);
      var q = T(T({}, e), {
          url: k,
          headers: f,
          body: c
        }),
        u;
      u = b.createXHR ? b.createXHR() : new XMLHttpRequest();
      var r = b.progressSubscriber,
        e = b.includeDownloadProgress,
        e = void 0 === e ? !1 : e;
      d = b.includeUploadProgress;
      d = void 0 === d ? !1 : d;
      h = function (c, b) {
        u.addEventListener(c, function () {
          var c,
            d = b();
          null === (c = null === r || void 0 === r ? void 0 : r.error) || void 0 === c ? void 0 : c.call(r, d);
          a.error(d);
        });
      };
      h("timeout", function () {
        return new Md(u, q);
      });
      h("abort", function () {
        return new wa("aborted", u, q);
      });
      var w = function (c, b, d) {
        c.addEventListener(b, function (c) {
          a.next(new yb(c, u, q, d + "_" + c.type));
        });
      };
      d && [zb, Ab, Nd].forEach(function (a) {
        return w(u.upload, a, Pe);
      });
      r && [zb, Ab].forEach(function (a) {
        return u.upload.addEventListener(a, function (a) {
          var c;
          return null === (c = null === r || void 0 === r ? void 0 : r.next) || void 0 === c ? void 0 : c.call(r, a);
        });
      });
      e && [zb, Ab].forEach(function (a) {
        return w(u, a, Od);
      });
      var x = function (c) {
        a.error(new wa("ajax error" + (c ? " " + c : ""), u, q));
      };
      u.addEventListener("error", function (a) {
        var c;
        null === (c = null === r || void 0 === r ? void 0 : r.error) || void 0 === c ? void 0 : c.call(r, a);
        x();
      });
      u.addEventListener(Nd, function (c) {
        var b,
          d,
          e = u.status;
        if (400 > e) {
          null === (b = null === r || void 0 === r ? void 0 : r.complete) || void 0 === b ? void 0 : b.call(r);
          b = void 0;
          try {
            b = new yb(c, u, q, Od + "_" + c.type);
          } catch (ye) {
            a.error(ye);
            return;
          }
          a.next(b);
          a.complete();
        } else null === (d = null === r || void 0 === r ? void 0 : r.error) || void 0 === d ? void 0 : d.call(r, c), x(e);
      });
      e = q.user;
      d = q.method;
      h = q.async;
      e ? u.open(d, k, h, e, q.password) : u.open(d, k, h);
      h && (u.timeout = q.timeout, u.responseType = q.responseType);
      "withCredentials" in u && (u.withCredentials = q.withCredentials);
      for (p in f) f.hasOwnProperty(p) && u.setRequestHeader(p, f[p]);
      c ? u.send(c) : u.send();
      return function () {
        u && 4 !== u.readyState && u.abort();
      };
    });
  }
  function Oe(b, a) {
    var c;
    if (!b || "string" === typeof b || "undefined" !== typeof FormData && b instanceof FormData || "undefined" !== typeof URLSearchParams && b instanceof URLSearchParams || Bb(b, "ArrayBuffer") || Bb(b, "File") || Bb(b, "Blob") || "undefined" !== typeof ReadableStream && b instanceof ReadableStream) return b;
    if ("undefined" !== typeof ArrayBuffer && ArrayBuffer.isView(b)) return b.buffer;
    if ("object" === typeof b) return a["content-type"] = null !== (c = a["content-type"]) && void 0 !== c ? c : "application/json;charset\x3dutf-8", JSON.stringify(b);
    throw new TypeError("Unknown body type");
  }
  function Bb(b, a) {
    return Qe.call(b) === "[object " + a + "]";
  }
  var Ta = function (b, a) {
      Ta = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (a, b) {
        a.__proto__ = b;
      } || function (a, b) {
        for (var c in b) Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
      };
      return Ta(b, a);
    },
    T = function () {
      T = Object.assign || function (b) {
        for (var a, c = 1, d = arguments.length; c < d; c++) {
          a = arguments[c];
          for (var e in a) Object.prototype.hasOwnProperty.call(a, e) && (b[e] = a[e]);
        }
        return b;
      };
      return T.apply(this, arguments);
    },
    Sa = R(function (b) {
      return function (a) {
        b(this);
        this.message = a ? a.length + " errors occurred during unsubscription:\n" + a.map(function (a, b) {
          return b + 1 + ") " + a.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = a;
      };
    }),
    D = function () {
      function b(a) {
        this.initialTeardown = a;
        this.closed = !1;
        this._finalizers = this._parentage = null;
      }
      b.prototype.unsubscribe = function () {
        var a, c, b, e, f;
        if (!this.closed) {
          this.closed = !0;
          var h = this._parentage;
          if (h) if (this._parentage = null, Array.isArray(h)) try {
            for (var g = F(h), k = g.next(); !k.done; k = g.next()) k.value.remove(this);
          } catch (B) {
            a = {
              error: B
            };
          } finally {
            try {
              k && !k.done && (c = g.return) && c.call(g);
            } finally {
              if (a) throw a.error;
            }
          } else h.remove(this);
          a = this.initialTeardown;
          if (t(a)) try {
            a();
          } catch (B) {
            f = B instanceof Sa ? B.errors : [B];
          }
          if (a = this._finalizers) {
            this._finalizers = null;
            try {
              for (var m = F(a), p = m.next(); !p.done; p = m.next()) {
                var n = p.value;
                try {
                  a = n, t(a) ? a() : a.unsubscribe();
                } catch (B) {
                  f = null !== f && void 0 !== f ? f : [], B instanceof Sa ? f = x(x([], w(f)), w(B.errors)) : f.push(B);
                }
              }
            } catch (B) {
              b = {
                error: B
              };
            } finally {
              try {
                p && !p.done && (e = m.return) && e.call(m);
              } finally {
                if (b) throw b.error;
              }
            }
          }
          if (f) throw new Sa(f);
        }
      };
      b.prototype.add = function (a) {
        var c;
        if (a && a !== this) if (this.closed) t(a) ? a() : a.unsubscribe();else {
          if (a instanceof b) {
            if (a.closed || a._hasParent(this)) return;
            a._addParent(this);
          }
          (this._finalizers = null !== (c = this._finalizers) && void 0 !== c ? c : []).push(a);
        }
      };
      b.prototype._hasParent = function (a) {
        var c = this._parentage;
        return c === a || Array.isArray(c) && c.includes(a);
      };
      b.prototype._addParent = function (a) {
        var c = this._parentage;
        this._parentage = Array.isArray(c) ? (c.push(a), c) : c ? [c, a] : a;
      };
      b.prototype._removeParent = function (a) {
        var c = this._parentage;
        c === a ? this._parentage = null : Array.isArray(c) && M(c, a);
      };
      b.prototype.remove = function (a) {
        var c = this._finalizers;
        c && M(c, a);
        a instanceof b && a._removeParent(this);
      };
      b.EMPTY = function () {
        var a = new b();
        a.closed = !0;
        return a;
      }();
      return b;
    }(),
    Pd = D.EMPTY,
    S = {
      onUnhandledError: null,
      onStoppedNotification: null,
      Promise: void 0,
      useDeprecatedSynchronousErrorHandling: !1,
      useDeprecatedNextContext: !1
    },
    da = {
      setTimeout: function (b, a) {
        for (var c = [], d = 2; d < arguments.length; d++) c[d - 2] = arguments[d];
        d = da.delegate;
        return (null === d || void 0 === d ? 0 : d.setTimeout) ? d.setTimeout.apply(d, x([b, a], w(c))) : setTimeout.apply(void 0, x([b, a], w(c)));
      },
      clearTimeout: function (b) {
        var a = da.delegate;
        return ((null === a || void 0 === a ? void 0 : a.clearTimeout) || clearTimeout)(b);
      },
      delegate: void 0
    },
    xa = J("C", void 0, void 0),
    U = null,
    na = function (b) {
      function a(a) {
        var c = b.call(this) || this;
        c.isStopped = !1;
        a ? (c.destination = a, Ib(a) && a.add(c)) : c.destination = Re;
        return c;
      }
      y(a, b);
      a.create = function (a, b, e) {
        return new ia(a, b, e);
      };
      a.prototype.next = function (a) {
        this.isStopped ? Wa(J("N", a, void 0), this) : this._next(a);
      };
      a.prototype.error = function (a) {
        this.isStopped ? Wa(J("E", void 0, a), this) : (this.isStopped = !0, this._error(a));
      };
      a.prototype.complete = function () {
        this.isStopped ? Wa(xa, this) : (this.isStopped = !0, this._complete());
      };
      a.prototype.unsubscribe = function () {
        this.closed || (this.isStopped = !0, b.prototype.unsubscribe.call(this), this.destination = null);
      };
      a.prototype._next = function (a) {
        this.destination.next(a);
      };
      a.prototype._error = function (a) {
        try {
          this.destination.error(a);
        } finally {
          this.unsubscribe();
        }
      };
      a.prototype._complete = function () {
        try {
          this.destination.complete();
        } finally {
          this.unsubscribe();
        }
      };
      return a;
    }(D),
    Cb = Function.prototype.bind,
    Se = function () {
      function b(a) {
        this.partialObserver = a;
      }
      b.prototype.next = function (a) {
        var c = this.partialObserver;
        if (c.next) try {
          c.next(a);
        } catch (d) {
          Ca(d);
        }
      };
      b.prototype.error = function (a) {
        var c = this.partialObserver;
        if (c.error) try {
          c.error(a);
        } catch (d) {
          Ca(d);
        } else Ca(a);
      };
      b.prototype.complete = function () {
        var a = this.partialObserver;
        if (a.complete) try {
          a.complete();
        } catch (c) {
          Ca(c);
        }
      };
      return b;
    }(),
    ia = function (b) {
      function a(a, d, e) {
        var c = b.call(this) || this;
        t(a) || !a ? a = {
          next: null !== a && void 0 !== a ? a : void 0,
          error: null !== d && void 0 !== d ? d : void 0,
          complete: null !== e && void 0 !== e ? e : void 0
        } : c && S.useDeprecatedNextContext && (d = Object.create(a), d.unsubscribe = function () {
          return c.unsubscribe();
        }, a = {
          next: a.next && Cb.call(a.next, d),
          error: a.error && Cb.call(a.error, d),
          complete: a.complete && Cb.call(a.complete, d)
        });
        c.destination = new Se(a);
        return c;
      }
      y(a, b);
      return a;
    }(na),
    Re = {
      closed: !0,
      next: C,
      error: function (b) {
        throw b;
      },
      complete: C
    },
    pa = "function" === typeof Symbol && Symbol.observable || "@@observable",
    r = function () {
      function b(a) {
        a && (this._subscribe = a);
      }
      b.prototype.lift = function (a) {
        var c = new b();
        c.source = this;
        c.operator = a;
        return c;
      };
      b.prototype.subscribe = function (a, c, b) {
        var d = this,
          f = ce(a) ? a : new ia(a, c, b);
        Ba(function () {
          var a = d.operator,
            c = d.source;
          f.add(a ? a.call(f, c) : c ? d._subscribe(f) : d._trySubscribe(f));
        });
        return f;
      };
      b.prototype._trySubscribe = function (a) {
        try {
          return this._subscribe(a);
        } catch (c) {
          a.error(c);
        }
      };
      b.prototype.forEach = function (a, c) {
        var b = this;
        c = Lb(c);
        return new c(function (c, d) {
          var e = new ia({
            next: function (c) {
              try {
                a(c);
              } catch (k) {
                d(k), e.unsubscribe();
              }
            },
            error: d,
            complete: c
          });
          b.subscribe(e);
        });
      };
      b.prototype._subscribe = function (a) {
        var c;
        return null === (c = this.source) || void 0 === c ? void 0 : c.subscribe(a);
      };
      b.prototype[pa] = function () {
        return this;
      };
      b.prototype.pipe = function () {
        for (var a = [], c = 0; c < arguments.length; c++) a[c] = arguments[c];
        return Kb(a)(this);
      };
      b.prototype.toPromise = function (a) {
        var c = this;
        a = Lb(a);
        return new a(function (a, b) {
          var d;
          c.subscribe(function (a) {
            return d = a;
          }, function (a) {
            return b(a);
          }, function () {
            return a(d);
          });
        });
      };
      b.create = function (a) {
        return new b(a);
      };
      return b;
    }(),
    Ya = function (b) {
      function a(a, d, e, f, h, g) {
        var c = b.call(this, a) || this;
        c.onFinalize = h;
        c.shouldUnsubscribe = g;
        c._next = d ? function (c) {
          try {
            d(c);
          } catch (p) {
            a.error(p);
          }
        } : b.prototype._next;
        c._error = f ? function (c) {
          try {
            f(c);
          } catch (p) {
            a.error(p);
          } finally {
            this.unsubscribe();
          }
        } : b.prototype._error;
        c._complete = e ? function () {
          try {
            e();
          } catch (z) {
            a.error(z);
          } finally {
            this.unsubscribe();
          }
        } : b.prototype._complete;
        return c;
      }
      y(a, b);
      a.prototype.unsubscribe = function () {
        var a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
          var d = this.closed;
          b.prototype.unsubscribe.call(this);
          !d && (null === (a = this.onFinalize) || void 0 === a ? void 0 : a.call(this));
        }
      };
      return a;
    }(na),
    Ra = function (b) {
      function a(a, d) {
        var c = b.call(this) || this;
        c.source = a;
        c.subjectFactory = d;
        c._subject = null;
        c._refCount = 0;
        c._connection = null;
        t(null === a || void 0 === a ? void 0 : a.lift) && (c.lift = a.lift);
        return c;
      }
      y(a, b);
      a.prototype._subscribe = function (a) {
        return this.getSubject().subscribe(a);
      };
      a.prototype.getSubject = function () {
        var a = this._subject;
        if (!a || a.isStopped) this._subject = this.subjectFactory();
        return this._subject;
      };
      a.prototype._teardown = function () {
        this._refCount = 0;
        var a = this._connection;
        this._subject = this._connection = null;
        null === a || void 0 === a ? void 0 : a.unsubscribe();
      };
      a.prototype.connect = function () {
        var a = this,
          b = this._connection;
        if (!b) {
          var b = this._connection = new D(),
            e = this.getSubject();
          b.add(this.source.subscribe(m(e, void 0, function () {
            a._teardown();
            e.complete();
          }, function (b) {
            a._teardown();
            e.error(b);
          }, function () {
            return a._teardown();
          })));
          b.closed && (this._connection = null, b = D.EMPTY);
        }
        return b;
      };
      a.prototype.refCount = function () {
        return Za()(this);
      };
      return a;
    }(r),
    Da = {
      now: function () {
        return (Da.delegate || performance).now();
      },
      delegate: void 0
    },
    N = {
      schedule: function (b) {
        var a = requestAnimationFrame,
          c = cancelAnimationFrame,
          d = N.delegate;
        d && (a = d.requestAnimationFrame, c = d.cancelAnimationFrame);
        var e = a(function (a) {
          c = void 0;
          b(a);
        });
        return new D(function () {
          return null === c || void 0 === c ? void 0 : c(e);
        });
      },
      requestAnimationFrame: function () {
        for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
        a = N.delegate;
        return ((null === a || void 0 === a ? void 0 : a.requestAnimationFrame) || requestAnimationFrame).apply(void 0, x([], w(b)));
      },
      cancelAnimationFrame: function () {
        for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
        a = N.delegate;
        return ((null === a || void 0 === a ? void 0 : a.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, x([], w(b)));
      },
      delegate: void 0
    },
    Te = Mb(),
    Qd = R(function (b) {
      return function () {
        b(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
      };
    }),
    A = function (b) {
      function a() {
        var a = b.call(this) || this;
        a.closed = !1;
        a.currentObservers = null;
        a.observers = [];
        a.isStopped = !1;
        a.hasError = !1;
        a.thrownError = null;
        return a;
      }
      y(a, b);
      a.prototype.lift = function (a) {
        var b = new Db(this, this);
        b.operator = a;
        return b;
      };
      a.prototype._throwIfClosed = function () {
        if (this.closed) throw new Qd();
      };
      a.prototype.next = function (a) {
        var b = this;
        Ba(function () {
          var c, d;
          b._throwIfClosed();
          if (!b.isStopped) {
            b.currentObservers || (b.currentObservers = Array.from(b.observers));
            try {
              for (var h = F(b.currentObservers), g = h.next(); !g.done; g = h.next()) g.value.next(a);
            } catch (k) {
              c = {
                error: k
              };
            } finally {
              try {
                g && !g.done && (d = h.return) && d.call(h);
              } finally {
                if (c) throw c.error;
              }
            }
          }
        });
      };
      a.prototype.error = function (a) {
        var b = this;
        Ba(function () {
          b._throwIfClosed();
          if (!b.isStopped) {
            b.hasError = b.isStopped = !0;
            b.thrownError = a;
            for (var c = b.observers; c.length;) c.shift().error(a);
          }
        });
      };
      a.prototype.complete = function () {
        var a = this;
        Ba(function () {
          a._throwIfClosed();
          if (!a.isStopped) {
            a.isStopped = !0;
            for (var b = a.observers; b.length;) b.shift().complete();
          }
        });
      };
      a.prototype.unsubscribe = function () {
        this.isStopped = this.closed = !0;
        this.observers = this.currentObservers = null;
      };
      Object.defineProperty(a.prototype, "observed", {
        get: function () {
          var a;
          return 0 < (null === (a = this.observers) || void 0 === a ? void 0 : a.length);
        },
        enumerable: !1,
        configurable: !0
      });
      a.prototype._trySubscribe = function (a) {
        this._throwIfClosed();
        return b.prototype._trySubscribe.call(this, a);
      };
      a.prototype._subscribe = function (a) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(a);
        return this._innerSubscribe(a);
      };
      a.prototype._innerSubscribe = function (a) {
        var b = this,
          c = this.isStopped,
          f = this.observers;
        if (this.hasError || c) return Pd;
        this.currentObservers = null;
        f.push(a);
        return new D(function () {
          b.currentObservers = null;
          M(f, a);
        });
      };
      a.prototype._checkFinalizedStatuses = function (a) {
        var b = this.thrownError,
          c = this.isStopped;
        this.hasError ? a.error(b) : c && a.complete();
      };
      a.prototype.asObservable = function () {
        var a = new r();
        a.source = this;
        return a;
      };
      a.create = function (a, b) {
        return new Db(a, b);
      };
      return a;
    }(r),
    Db = function (b) {
      function a(a, d) {
        var c = b.call(this) || this;
        c.destination = a;
        c.source = d;
        return c;
      }
      y(a, b);
      a.prototype.next = function (a) {
        var b, c;
        null === (c = null === (b = this.destination) || void 0 === b ? void 0 : b.next) || void 0 === c ? void 0 : c.call(b, a);
      };
      a.prototype.error = function (a) {
        var b, c;
        null === (c = null === (b = this.destination) || void 0 === b ? void 0 : b.error) || void 0 === c ? void 0 : c.call(b, a);
      };
      a.prototype.complete = function () {
        var a, b;
        null === (b = null === (a = this.destination) || void 0 === a ? void 0 : a.complete) || void 0 === b ? void 0 : b.call(a);
      };
      a.prototype._subscribe = function (a) {
        var b, c;
        return null !== (c = null === (b = this.source) || void 0 === b ? void 0 : b.subscribe(a)) && void 0 !== c ? c : Pd;
      };
      return a;
    }(A),
    Zc = function (b) {
      function a(a) {
        var c = b.call(this) || this;
        c._value = a;
        return c;
      }
      y(a, b);
      Object.defineProperty(a.prototype, "value", {
        get: function () {
          return this.getValue();
        },
        enumerable: !1,
        configurable: !0
      });
      a.prototype._subscribe = function (a) {
        var c = b.prototype._subscribe.call(this, a);
        !c.closed && a.next(this._value);
        return c;
      };
      a.prototype.getValue = function () {
        var a = this.thrownError,
          b = this._value;
        if (this.hasError) throw a;
        this._throwIfClosed();
        return b;
      };
      a.prototype.next = function (a) {
        b.prototype.next.call(this, this._value = a);
      };
      return a;
    }(A),
    ka = {
      now: function () {
        return (ka.delegate || Date).now();
      },
      delegate: void 0
    },
    ha = function (b) {
      function a(a, d, e) {
        void 0 === a && (a = Infinity);
        void 0 === d && (d = Infinity);
        void 0 === e && (e = ka);
        var c = b.call(this) || this;
        c._bufferSize = a;
        c._windowTime = d;
        c._timestampProvider = e;
        c._buffer = [];
        c._infiniteTimeWindow = Infinity === d;
        c._bufferSize = Math.max(1, a);
        c._windowTime = Math.max(1, d);
        return c;
      }
      y(a, b);
      a.prototype.next = function (a) {
        var c = this._buffer,
          e = this._infiniteTimeWindow,
          f = this._timestampProvider,
          h = this._windowTime;
        this.isStopped || (c.push(a), !e && c.push(f.now() + h));
        this._trimBuffer();
        b.prototype.next.call(this, a);
      };
      a.prototype._subscribe = function (a) {
        this._throwIfClosed();
        this._trimBuffer();
        for (var b = this._innerSubscribe(a), c = this._infiniteTimeWindow, f = this._buffer.slice(), h = 0; h < f.length && !a.closed; h += c ? 1 : 2) a.next(f[h]);
        this._checkFinalizedStatuses(a);
        return b;
      };
      a.prototype._trimBuffer = function () {
        var a = this._bufferSize,
          b = this._timestampProvider,
          e = this._buffer,
          f = this._infiniteTimeWindow,
          h = (f ? 1 : 2) * a;
        Infinity > a && h < e.length && e.splice(0, e.length - h);
        if (!f) {
          a = b.now();
          b = 0;
          for (f = 1; f < e.length && e[f] <= a; f += 2) b = f;
          b && e.splice(0, b + 1);
        }
      };
      return a;
    }(A),
    fb = function (b) {
      function a() {
        var a = null !== b && b.apply(this, arguments) || this;
        a._value = null;
        a._hasValue = !1;
        a._isComplete = !1;
        return a;
      }
      y(a, b);
      a.prototype._checkFinalizedStatuses = function (a) {
        var b = this._hasValue,
          c = this._value,
          f = this.thrownError,
          h = this.isStopped,
          g = this._isComplete;
        if (this.hasError) a.error(f);else if (h || g) b && a.next(c), a.complete();
      };
      a.prototype.next = function (a) {
        this.isStopped || (this._value = a, this._hasValue = !0);
      };
      a.prototype.complete = function () {
        var a = this._hasValue,
          d = this._value;
        this._isComplete || (this._isComplete = !0, a && b.prototype.next.call(this, d), b.prototype.complete.call(this));
      };
      return a;
    }(A),
    la = {
      setInterval: function (b, a) {
        for (var c = [], d = 2; d < arguments.length; d++) c[d - 2] = arguments[d];
        d = la.delegate;
        return (null === d || void 0 === d ? 0 : d.setInterval) ? d.setInterval.apply(d, x([b, a], w(c))) : setInterval.apply(void 0, x([b, a], w(c)));
      },
      clearInterval: function (b) {
        var a = la.delegate;
        return ((null === a || void 0 === a ? void 0 : a.clearInterval) || clearInterval)(b);
      },
      delegate: void 0
    },
    ya = function (b) {
      function a(a, d) {
        var c = b.call(this, a, d) || this;
        c.scheduler = a;
        c.work = d;
        c.pending = !1;
        return c;
      }
      y(a, b);
      a.prototype.schedule = function (a, b) {
        var c;
        void 0 === b && (b = 0);
        if (this.closed) return this;
        this.state = a;
        a = this.id;
        var d = this.scheduler;
        null != a && (this.id = this.recycleAsyncId(d, a, b));
        this.pending = !0;
        this.delay = b;
        this.id = null !== (c = this.id) && void 0 !== c ? c : this.requestAsyncId(d, this.id, b);
        return this;
      };
      a.prototype.requestAsyncId = function (a, b, e) {
        void 0 === e && (e = 0);
        return la.setInterval(a.flush.bind(a, this), e);
      };
      a.prototype.recycleAsyncId = function (a, b, e) {
        void 0 === e && (e = 0);
        if (null != e && this.delay === e && !1 === this.pending) return b;
        null != b && la.clearInterval(b);
      };
      a.prototype.execute = function (a, b) {
        if (this.closed) return Error("executing a cancelled action");
        this.pending = !1;
        if (a = this._execute(a, b)) return a;
        !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
      };
      a.prototype._execute = function (a, b) {
        b = !1;
        var c;
        try {
          this.work(a);
        } catch (f) {
          b = !0, c = f ? f : Error("Scheduled action threw falsy error");
        }
        if (b) return this.unsubscribe(), c;
      };
      a.prototype.unsubscribe = function () {
        if (!this.closed) {
          var a = this.id,
            d = this.scheduler,
            e = d.actions;
          this.work = this.state = this.scheduler = null;
          this.pending = !1;
          M(e, this);
          null != a && (this.id = this.recycleAsyncId(d, a, null));
          this.delay = null;
          b.prototype.unsubscribe.call(this);
        }
      };
      return a;
    }(function (b) {
      function a(a, d) {
        return b.call(this) || this;
      }
      y(a, b);
      a.prototype.schedule = function (a, b) {
        return this;
      };
      return a;
    }(D)),
    Ue = 1,
    Eb,
    $a = {},
    Ve = function (b) {
      var a = Ue++;
      $a[a] = !0;
      Eb || (Eb = Promise.resolve());
      Eb.then(function () {
        return Nb(a) && b();
      });
      return a;
    },
    We = function (b) {
      Nb(b);
    },
    ma = {
      setImmediate: function () {
        for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
        a = ma.delegate;
        return ((null === a || void 0 === a ? void 0 : a.setImmediate) || Ve).apply(void 0, x([], w(b)));
      },
      clearImmediate: function (b) {
        var a = ma.delegate;
        return ((null === a || void 0 === a ? void 0 : a.clearImmediate) || We)(b);
      },
      delegate: void 0
    },
    Xe = function (b) {
      function a(a, d) {
        var c = b.call(this, a, d) || this;
        c.scheduler = a;
        c.work = d;
        return c;
      }
      y(a, b);
      a.prototype.requestAsyncId = function (a, d, e) {
        void 0 === e && (e = 0);
        if (null !== e && 0 < e) return b.prototype.requestAsyncId.call(this, a, d, e);
        a.actions.push(this);
        return a._scheduled || (a._scheduled = ma.setImmediate(a.flush.bind(a, void 0)));
      };
      a.prototype.recycleAsyncId = function (a, d, e) {
        var c;
        void 0 === e && (e = 0);
        if (null != e ? 0 < e : 0 < this.delay) return b.prototype.recycleAsyncId.call(this, a, d, e);
        e = a.actions;
        null != d && (null === (c = e[e.length - 1]) || void 0 === c ? void 0 : c.id) !== d && (ma.clearImmediate(d), a._scheduled === d && (a._scheduled = void 0));
      };
      return a;
    }(ya),
    Fb = function () {
      function b(a, c) {
        void 0 === c && (c = b.now);
        this.schedulerActionCtor = a;
        this.now = c;
      }
      b.prototype.schedule = function (a, b, d) {
        void 0 === b && (b = 0);
        return new this.schedulerActionCtor(this, a).schedule(d, b);
      };
      b.now = ka.now;
      return b;
    }(),
    za = function (b) {
      function a(a, d) {
        void 0 === d && (d = Fb.now);
        a = b.call(this, a, d) || this;
        a.actions = [];
        a._active = !1;
        return a;
      }
      y(a, b);
      a.prototype.flush = function (a) {
        var b = this.actions;
        if (this._active) b.push(a);else {
          var c;
          this._active = !0;
          do if (c = a.execute(a.state, a.delay)) break; while (a = b.shift());
          this._active = !1;
          if (c) {
            for (; a = b.shift();) a.unsubscribe();
            throw c;
          }
        }
      };
      return a;
    }(Fb),
    Rd = new (function (b) {
      function a() {
        return null !== b && b.apply(this, arguments) || this;
      }
      y(a, b);
      a.prototype.flush = function (a) {
        this._active = !0;
        var b = this._scheduled;
        this._scheduled = void 0;
        var c = this.actions,
          f;
        a = a || c.shift();
        do if (f = a.execute(a.state, a.delay)) break; while ((a = c[0]) && a.id === b && c.shift());
        this._active = !1;
        if (f) {
          for (; (a = c[0]) && a.id === b && c.shift();) a.unsubscribe();
          throw f;
        }
      };
      return a;
    }(za))(Xe),
    I = new za(ya),
    ib = I,
    Ye = function (b) {
      function a(a, d) {
        var c = b.call(this, a, d) || this;
        c.scheduler = a;
        c.work = d;
        return c;
      }
      y(a, b);
      a.prototype.schedule = function (a, d) {
        void 0 === d && (d = 0);
        if (0 < d) return b.prototype.schedule.call(this, a, d);
        this.delay = d;
        this.state = a;
        this.scheduler.flush(this);
        return this;
      };
      a.prototype.execute = function (a, d) {
        return 0 < d || this.closed ? b.prototype.execute.call(this, a, d) : this._execute(a, d);
      };
      a.prototype.requestAsyncId = function (a, d, e) {
        void 0 === e && (e = 0);
        if (null != e && 0 < e || null == e && 0 < this.delay) return b.prototype.requestAsyncId.call(this, a, d, e);
        a.flush(this);
        return 0;
      };
      return a;
    }(ya),
    Sd = new (function (b) {
      function a() {
        return null !== b && b.apply(this, arguments) || this;
      }
      y(a, b);
      return a;
    }(za))(Ye),
    Ze = function (b) {
      function a(a, d) {
        var c = b.call(this, a, d) || this;
        c.scheduler = a;
        c.work = d;
        return c;
      }
      y(a, b);
      a.prototype.requestAsyncId = function (a, d, e) {
        void 0 === e && (e = 0);
        if (null !== e && 0 < e) return b.prototype.requestAsyncId.call(this, a, d, e);
        a.actions.push(this);
        return a._scheduled || (a._scheduled = N.requestAnimationFrame(function () {
          return a.flush(void 0);
        }));
      };
      a.prototype.recycleAsyncId = function (a, d, e) {
        var c;
        void 0 === e && (e = 0);
        if (null != e ? 0 < e : 0 < this.delay) return b.prototype.recycleAsyncId.call(this, a, d, e);
        e = a.actions;
        null != d && (null === (c = e[e.length - 1]) || void 0 === c ? void 0 : c.id) !== d && (N.cancelAnimationFrame(d), a._scheduled = void 0);
      };
      return a;
    }(ya),
    Td = new (function (b) {
      function a() {
        return null !== b && b.apply(this, arguments) || this;
      }
      y(a, b);
      a.prototype.flush = function (a) {
        this._active = !0;
        var b = this._scheduled;
        this._scheduled = void 0;
        var c = this.actions,
          f;
        a = a || c.shift();
        do if (f = a.execute(a.state, a.delay)) break; while ((a = c[0]) && a.id === b && c.shift());
        this._active = !1;
        if (f) {
          for (; (a = c[0]) && a.id === b && c.shift();) a.unsubscribe();
          throw f;
        }
      };
      return a;
    }(za))(Ze),
    Ud = function (b) {
      function a(a, d) {
        void 0 === a && (a = Gb);
        void 0 === d && (d = Infinity);
        var c = b.call(this, a, function () {
          return c.frame;
        }) || this;
        c.maxFrames = d;
        c.frame = 0;
        c.index = -1;
        return c;
      }
      y(a, b);
      a.prototype.flush = function () {
        for (var a = this.actions, b = this.maxFrames, e, f; (f = a[0]) && f.delay <= b && !(a.shift(), this.frame = f.delay, e = f.execute(f.state, f.delay)););
        if (e) {
          for (; f = a.shift();) f.unsubscribe();
          throw e;
        }
      };
      a.frameTimeFactor = 10;
      return a;
    }(za),
    Gb = function (b) {
      function a(a, d, e) {
        void 0 === e && (e = a.index += 1);
        var c = b.call(this, a, d) || this;
        c.scheduler = a;
        c.work = d;
        c.index = e;
        c.active = !0;
        c.index = a.index = e;
        return c;
      }
      y(a, b);
      a.prototype.schedule = function (c, d) {
        void 0 === d && (d = 0);
        if (Number.isFinite(d)) {
          if (!this.id) return b.prototype.schedule.call(this, c, d);
          this.active = !1;
          var e = new a(this.scheduler, this.work);
          this.add(e);
          return e.schedule(c, d);
        }
        return D.EMPTY;
      };
      a.prototype.requestAsyncId = function (b, d, e) {
        void 0 === e && (e = 0);
        this.delay = b.frame + e;
        b = b.actions;
        b.push(this);
        b.sort(a.sortActions);
        return 1;
      };
      a.prototype.recycleAsyncId = function (a, b, e) {};
      a.prototype._execute = function (a, d) {
        if (!0 === this.active) return b.prototype._execute.call(this, a, d);
      };
      a.sortActions = function (a, b) {
        return a.delay === b.delay ? a.index === b.index ? 0 : a.index > b.index ? 1 : -1 : a.delay > b.delay ? 1 : -1;
      };
      return a;
    }(ya),
    L = new r(function (b) {
      return b.complete();
    }),
    bb = function (b) {
      return b && "number" === typeof b.length && "function" !== typeof b;
    },
    ab;
  ab = "function" === typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
  (function (b) {
    b.NEXT = "N";
    b.ERROR = "E";
    b.COMPLETE = "C";
  })(g.NotificationKind || (g.NotificationKind = {}));
  var Pa = function () {
      function b(a, b, d) {
        this.kind = a;
        this.value = b;
        this.error = d;
        this.hasValue = "N" === a;
      }
      b.prototype.observe = function (a) {
        return Fa(this, a);
      };
      b.prototype.do = function (a, b, d) {
        var c = this.kind,
          f = this.value,
          h = this.error;
        return "N" === c ? null === a || void 0 === a ? void 0 : a(f) : "E" === c ? null === b || void 0 === b ? void 0 : b(h) : null === d || void 0 === d ? void 0 : d();
      };
      b.prototype.accept = function (a, b, d) {
        return t(null === a || void 0 === a ? void 0 : a.next) ? this.observe(a) : this.do(a, b, d);
      };
      b.prototype.toObservable = function () {
        var a = this.kind,
          b = this.value,
          d = this.error,
          b = "N" === a ? cb(b) : "E" === a ? Wb(function () {
            return d;
          }) : "C" === a ? L : 0;
        if (!b) throw new TypeError("Unexpected notification kind " + a);
        return b;
      };
      b.createNext = function (a) {
        return new b("N", a);
      };
      b.createError = function (a) {
        return new b("E", void 0, a);
      };
      b.createComplete = function () {
        return b.completeNotification;
      };
      b.completeNotification = new b("C");
      return b;
    }(),
    aa = R(function (b) {
      return function () {
        b(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
      };
    }),
    rb = R(function (b) {
      return function () {
        b(this);
        this.name = "ArgumentOutOfRangeError";
        this.message = "argument out of range";
      };
    }),
    ld = R(function (b) {
      return function (a) {
        b(this);
        this.name = "NotFoundError";
        this.message = a;
      };
    }),
    kd = R(function (b) {
      return function (a) {
        b(this);
        this.name = "SequenceError";
        this.message = a;
      };
    }),
    Xb = R(function (b) {
      return function (a) {
        void 0 === a && (a = null);
        b(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        this.info = a;
      };
    }),
    le = Array.isArray,
    me = Array.isArray,
    ne = Object.getPrototypeOf,
    oe = Object.prototype,
    pe = Object.keys,
    $e = {
      connector: function () {
        return new A();
      },
      resetOnDisconnect: !0
    },
    te = ["addListener", "removeListener"],
    re = ["addEventListener", "removeEventListener"],
    ve = ["on", "off"],
    Vd = new r(C),
    we = Array.isArray,
    Ae = function (b, a) {
      return b.push(a), b;
    },
    Ce = {
      connector: function () {
        return new A();
      }
    },
    Fe = function () {
      return function (b, a) {
        this.value = b;
        this.interval = a;
      };
    }(),
    af = Object.freeze({
      audit: kb,
      auditTime: ic,
      buffer: jc,
      bufferCount: kc,
      bufferTime: lc,
      bufferToggle: mc,
      bufferWhen: nc,
      catchError: lb,
      combineAll: Ja,
      combineLatestAll: Ja,
      combineLatest: nb,
      combineLatestWith: qc,
      concat: sc,
      concatAll: Ha,
      concatMap: Ka,
      concatMapTo: rc,
      concatWith: tc,
      connect: La,
      count: uc,
      debounce: vc,
      debounceTime: wc,
      defaultIfEmpty: ua,
      delay: xc,
      delayWhen: Ma,
      dematerialize: yc,
      distinct: zc,
      distinctUntilChanged: qb,
      distinctUntilKeyChanged: Ac,
      elementAt: Bc,
      endWith: Cc,
      every: Dc,
      exhaust: Oa,
      exhaustAll: Oa,
      exhaustMap: Na,
      expand: Ec,
      filter: K,
      finalize: Fc,
      find: Gc,
      findIndex: Ic,
      first: Jc,
      groupBy: Kc,
      ignoreElements: ob,
      isEmpty: Lc,
      last: Mc,
      map: Q,
      mapTo: pb,
      materialize: Nc,
      max: Oc,
      merge: Rc,
      mergeAll: sa,
      flatMap: H,
      mergeMap: H,
      mergeMapTo: Pc,
      mergeScan: Qc,
      mergeWith: Sc,
      min: Tc,
      multicast: Qa,
      observeOn: qa,
      onErrorResumeNext: Uc,
      pairwise: Vc,
      partition: function (b, a) {
        return function (c) {
          return [K(b, a)(c), K(gc(b, a))(c)];
        };
      },
      pluck: Wc,
      publish: Xc,
      publishBehavior: Yc,
      publishLast: $c,
      publishReplay: ad,
      race: function () {
        for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
        return tb.apply(void 0, x([], w(Z(b))));
      },
      raceWith: tb,
      reduce: fa,
      repeat: bd,
      repeatWhen: cd,
      retry: dd,
      retryWhen: ed,
      refCount: Za,
      sample: ub,
      sampleTime: fd,
      scan: gd,
      sequenceEqual: hd,
      share: vb,
      shareReplay: id,
      single: jd,
      skip: md,
      skipLast: nd,
      skipUntil: od,
      skipWhile: pd,
      startWith: qd,
      subscribeOn: ra,
      switchAll: rd,
      switchMap: ja,
      switchMapTo: sd,
      switchScan: td,
      take: ga,
      takeLast: sb,
      takeUntil: ud,
      takeWhile: vd,
      tap: wd,
      throttle: xb,
      throttleTime: xd,
      throwIfEmpty: va,
      timeInterval: yd,
      timeout: eb,
      timeoutWith: zd,
      timestamp: Ad,
      toArray: mb,
      window: Bd,
      windowCount: Cd,
      windowTime: Dd,
      windowToggle: Ed,
      windowWhen: Fd,
      withLatestFrom: Gd,
      zip: Id,
      zipAll: Hd,
      zipWith: Jd
    }),
    Aa = function () {
      return function (b, a) {
        void 0 === a && (a = Infinity);
        this.subscribedFrame = b;
        this.unsubscribedFrame = a;
      };
    }(),
    Wd = function () {
      function b() {
        this.subscriptions = [];
      }
      b.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new Aa(this.scheduler.now()));
        return this.subscriptions.length - 1;
      };
      b.prototype.logUnsubscribedFrame = function (a) {
        var b = this.subscriptions;
        b[a] = new Aa(b[a].subscribedFrame, this.scheduler.now());
      };
      return b;
    }(),
    Hb = function (b) {
      function a(a, d) {
        var c = b.call(this, function (a) {
          var b = this,
            c = b.logSubscribedFrame(),
            d = new D();
          d.add(new D(function () {
            b.logUnsubscribedFrame(c);
          }));
          b.scheduleMessages(a);
          return d;
        }) || this;
        c.messages = a;
        c.subscriptions = [];
        c.scheduler = d;
        return c;
      }
      y(a, b);
      a.prototype.scheduleMessages = function (a) {
        for (var b = this.messages.length, c = 0; c < b; c++) {
          var f = this.messages[c];
          a.add(this.scheduler.schedule(function (a) {
            Fa(a.message.notification, a.subscriber);
          }, f.frame, {
            message: f,
            subscriber: a
          }));
        }
      };
      return a;
    }(r);
  Kd(Hb, [Wd]);
  var Xd = function (b) {
    function a(a, d) {
      var c = b.call(this) || this;
      c.messages = a;
      c.subscriptions = [];
      c.scheduler = d;
      return c;
    }
    y(a, b);
    a.prototype._subscribe = function (a) {
      var c = this,
        e = c.logSubscribedFrame(),
        f = new D();
      f.add(new D(function () {
        c.logUnsubscribedFrame(e);
      }));
      f.add(b.prototype._subscribe.call(this, a));
      return f;
    };
    a.prototype.setup = function () {
      for (var a = this, b = a.messages.length, e = function (b) {
          (function () {
            var c = a.messages[b],
              d = c.notification;
            a.scheduler.schedule(function () {
              Fa(d, a);
            }, c.frame);
          })();
        }, f = 0; f < b; f++) e(f);
    };
    return a;
  }(A);
  Kd(Xd, [Wd]);
  var bf = function (b) {
      function a(a) {
        var c = b.call(this, Gb, 750) || this;
        c.assertDeepEqual = a;
        c.hotObservables = [];
        c.coldObservables = [];
        c.flushTests = [];
        c.runMode = !1;
        return c;
      }
      y(a, b);
      a.prototype.createTime = function (b) {
        b = this.runMode ? b.trim().indexOf("|") : b.indexOf("|");
        if (-1 === b) throw Error('marble diagram for time should have a completion marker "|"');
        return b * a.frameTimeFactor;
      };
      a.prototype.createColdObservable = function (b, d, e) {
        if (-1 !== b.indexOf("^")) throw Error('cold observable cannot have subscription offset "^"');
        if (-1 !== b.indexOf("!")) throw Error('cold observable cannot have unsubscription marker "!"');
        b = a.parseMarbles(b, d, e, void 0, this.runMode);
        b = new Hb(b, this);
        this.coldObservables.push(b);
        return b;
      };
      a.prototype.createHotObservable = function (b, d, e) {
        if (-1 !== b.indexOf("!")) throw Error('hot observable cannot have unsubscription marker "!"');
        b = a.parseMarbles(b, d, e, void 0, this.runMode);
        b = new Xd(b, this);
        this.hotObservables.push(b);
        return b;
      };
      a.prototype.materializeInnerObservable = function (a, b) {
        var c = this,
          d = [];
        a.subscribe({
          next: function (a) {
            d.push({
              frame: c.frame - b,
              notification: J("N", a, void 0)
            });
          },
          error: function (a) {
            d.push({
              frame: c.frame - b,
              notification: J("E", void 0, a)
            });
          },
          complete: function () {
            d.push({
              frame: c.frame - b,
              notification: xa
            });
          }
        });
        return d;
      };
      a.prototype.expectObservable = function (b, d) {
        var c = this;
        void 0 === d && (d = null);
        var f = [],
          g = {
            actual: f,
            ready: !1
          };
        d = a.parseMarblesAsSubscriptions(d, this.runMode);
        var l = Infinity === d.subscribedFrame ? 0 : d.subscribedFrame;
        d = d.unsubscribedFrame;
        var k;
        this.schedule(function () {
          k = b.subscribe({
            next: function (a) {
              a = a instanceof r ? c.materializeInnerObservable(a, c.frame) : a;
              f.push({
                frame: c.frame,
                notification: J("N", a, void 0)
              });
            },
            error: function (a) {
              f.push({
                frame: c.frame,
                notification: J("E", void 0, a)
              });
            },
            complete: function () {
              f.push({
                frame: c.frame,
                notification: xa
              });
            }
          });
        }, l);
        Infinity !== d && this.schedule(function () {
          return k.unsubscribe();
        }, d);
        this.flushTests.push(g);
        var m = this.runMode;
        return {
          toBe: function (b, c, d) {
            g.ready = !0;
            g.expected = a.parseMarbles(b, c, d, !0, m);
          },
          toEqual: function (a) {
            g.ready = !0;
            g.expected = [];
            c.schedule(function () {
              k = a.subscribe({
                next: function (a) {
                  a = a instanceof r ? c.materializeInnerObservable(a, c.frame) : a;
                  g.expected.push({
                    frame: c.frame,
                    notification: J("N", a, void 0)
                  });
                },
                error: function (a) {
                  g.expected.push({
                    frame: c.frame,
                    notification: J("E", void 0, a)
                  });
                },
                complete: function () {
                  g.expected.push({
                    frame: c.frame,
                    notification: xa
                  });
                }
              });
            }, l);
          }
        };
      };
      a.prototype.expectSubscriptions = function (b) {
        var c = {
          actual: b,
          ready: !1
        };
        this.flushTests.push(c);
        var e = this.runMode;
        return {
          toBe: function (b) {
            b = "string" === typeof b ? [b] : b;
            c.ready = !0;
            c.expected = b.map(function (b) {
              return a.parseMarblesAsSubscriptions(b, e);
            }).filter(function (a) {
              return Infinity !== a.subscribedFrame;
            });
          }
        };
      };
      a.prototype.flush = function () {
        for (var a = this, d = this.hotObservables; 0 < d.length;) d.shift().setup();
        b.prototype.flush.call(this);
        this.flushTests = this.flushTests.filter(function (b) {
          return b.ready ? (a.assertDeepEqual(b.actual, b.expected), !1) : !0;
        });
      };
      a.parseMarblesAsSubscriptions = function (a, b) {
        var c = this;
        void 0 === b && (b = !1);
        if ("string" !== typeof a) return new Aa(Infinity);
        var d = x([], w(a));
        a = d.length;
        for (var g = -1, l = Infinity, k = Infinity, m = 0, p = function (a) {
            var e = m,
              f = function (a) {
                e += a * c.frameTimeFactor;
              },
              h = d[a];
            switch (h) {
              case " ":
                b || f(1);
                break;
              case "-":
                f(1);
                break;
              case "(":
                g = m;
                f(1);
                break;
              case ")":
                g = -1;
                f(1);
                break;
              case "^":
                if (Infinity !== l) throw Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                l = -1 < g ? g : m;
                f(1);
                break;
              case "!":
                if (Infinity !== k) throw Error("found a second unsubscription point '!' in a subscription marble diagram. There can only be one.");
                k = -1 < g ? g : m;
                break;
              default:
                if (b && h.match(/^[0-9]$/) && (0 === a || " " === d[a - 1])) {
                  var p = d.slice(a).join("").match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                  if (p) {
                    a += p[0].length - 1;
                    var h = parseFloat(p[1]),
                      q = void 0;
                    switch (p[2]) {
                      case "ms":
                        q = h;
                        break;
                      case "s":
                        q = 1E3 * h;
                        break;
                      case "m":
                        q = 6E4 * h;
                    }
                    f(q / n.frameTimeFactor);
                    break;
                  }
                }
                throw Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '" + h + "'.");
            }
            m = e;
            r = a;
          }, n = this, r, q = 0; q < a; q++) p(q), q = r;
        return 0 > k ? new Aa(l) : new Aa(l, k);
      };
      a.parseMarbles = function (a, b, e, f, g) {
        var c = this;
        void 0 === f && (f = !1);
        void 0 === g && (g = !1);
        if (-1 !== a.indexOf("!")) throw Error('conventional marble diagrams cannot have the unsubscription marker "!"');
        var d = x([], w(a)),
          h = d.length,
          p = [];
        a = g ? a.replace(/^[ ]+/, "").indexOf("^") : a.indexOf("^");
        var m = -1 === a ? 0 : a * -this.frameTimeFactor,
          n = "object" !== typeof b ? function (a) {
            return a;
          } : function (a) {
            return f && b[a] instanceof Hb ? b[a].messages : b[a];
          },
          q = -1;
        a = function (a) {
          var b = m,
            f = function (a) {
              b += a * c.frameTimeFactor;
            },
            h = void 0,
            k = d[a];
          switch (k) {
            case " ":
              g || f(1);
              break;
            case "-":
              f(1);
              break;
            case "(":
              q = m;
              f(1);
              break;
            case ")":
              q = -1;
              f(1);
              break;
            case "|":
              h = xa;
              f(1);
              break;
            case "^":
              f(1);
              break;
            case "#":
              h = J("E", void 0, e || "error");
              f(1);
              break;
            default:
              if (g && k.match(/^[0-9]$/) && (0 === a || " " === d[a - 1])) {
                var l = d.slice(a).join("").match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                if (l) {
                  a += l[0].length - 1;
                  var k = parseFloat(l[1]),
                    v = void 0;
                  switch (l[2]) {
                    case "ms":
                      v = k;
                      break;
                    case "s":
                      v = 1E3 * k;
                      break;
                    case "m":
                      v = 6E4 * k;
                  }
                  f(v / r.frameTimeFactor);
                  break;
                }
              }
              h = J("N", n(k), void 0);
              f(1);
          }
          h && p.push({
            frame: -1 < q ? q : m,
            notification: h
          });
          m = b;
          t = a;
        };
        for (var r = this, t, y = 0; y < h; y++) a(y), y = t;
        return p;
      };
      a.prototype.createAnimator = function () {
        var b = this;
        if (!this.runMode) throw Error("animate() must only be used in run mode");
        var d = 0,
          e;
        return {
          animate: function (c) {
            var d, f;
            if (e) throw Error("animate() must not be called more than once within run()");
            if (/[|#]/.test(c)) throw Error("animate() must not complete or error");
            e = new Map();
            c = a.parseMarbles(c, void 0, void 0, void 0, !0);
            try {
              for (var g = F(c), m = g.next(); !m.done; m = g.next()) b.schedule(function () {
                var a,
                  c,
                  d = b.now(),
                  f = Array.from(e.values());
                e.clear();
                try {
                  for (var g = (a = void 0, F(f)), h = g.next(); !h.done; h = g.next()) {
                    var k = h.value;
                    k(d);
                  }
                } catch (X) {
                  a = {
                    error: X
                  };
                } finally {
                  try {
                    h && !h.done && (c = g.return) && c.call(g);
                  } finally {
                    if (a) throw a.error;
                  }
                }
              }, m.value.frame);
            } catch (p) {
              d = {
                error: p
              };
            } finally {
              try {
                m && !m.done && (f = g.return) && f.call(g);
              } finally {
                if (d) throw d.error;
              }
            }
          },
          delegate: {
            requestAnimationFrame: function (a) {
              if (!e) throw Error("animate() was not called within run()");
              var b = ++d;
              e.set(b, a);
              return b;
            },
            cancelAnimationFrame: function (a) {
              if (!e) throw Error("animate() was not called within run()");
              e.delete(a);
            }
          }
        };
      };
      a.prototype.createDelegates = function () {
        var a = this,
          b = 0,
          e = new Map(),
          f = function () {
            var b = a.now(),
              c = Array.from(e.values()).filter(function (a) {
                return a.due <= b;
              }),
              d = c.filter(function (a) {
                return "immediate" === a.type;
              });
            if (0 < d.length) d = d[0], c = d.handle, d = d.handler, e.delete(c), d();else if (d = c.filter(function (a) {
              return "interval" === a.type;
            }), 0 < d.length) {
              var c = d[0],
                g = c.duration,
                d = c.handler;
              c.due = b + g;
              c.subscription = a.schedule(f, g);
              d();
            } else if (c = c.filter(function (a) {
              return "timeout" === a.type;
            }), 0 < c.length) d = c[0], c = d.handle, d = d.handler, e.delete(c), d();else throw Error("Expected a due immediate or interval");
          };
        return {
          immediate: {
            setImmediate: function (c) {
              var d = ++b;
              e.set(d, {
                due: a.now(),
                duration: 0,
                handle: d,
                handler: c,
                subscription: a.schedule(f, 0),
                type: "immediate"
              });
              return d;
            },
            clearImmediate: function (a) {
              var b = e.get(a);
              b && (b.subscription.unsubscribe(), e.delete(a));
            }
          },
          interval: {
            setInterval: function (c, d) {
              void 0 === d && (d = 0);
              var g = ++b;
              e.set(g, {
                due: a.now() + d,
                duration: d,
                handle: g,
                handler: c,
                subscription: a.schedule(f, d),
                type: "interval"
              });
              return g;
            },
            clearInterval: function (a) {
              var b = e.get(a);
              b && (b.subscription.unsubscribe(), e.delete(a));
            }
          },
          timeout: {
            setTimeout: function (c, d) {
              void 0 === d && (d = 0);
              var g = ++b;
              e.set(g, {
                due: a.now() + d,
                duration: d,
                handle: g,
                handler: c,
                subscription: a.schedule(f, d),
                type: "timeout"
              });
              return g;
            },
            clearTimeout: function (a) {
              var b = e.get(a);
              b && (b.subscription.unsubscribe(), e.delete(a));
            }
          }
        };
      };
      a.prototype.run = function (b) {
        var c = a.frameTimeFactor,
          e = this.maxFrames;
        a.frameTimeFactor = 1;
        this.maxFrames = Infinity;
        this.runMode = !0;
        var f = this.createAnimator(),
          g = this.createDelegates();
        N.delegate = f.delegate;
        ka.delegate = this;
        ma.delegate = g.immediate;
        la.delegate = g.interval;
        da.delegate = g.timeout;
        Da.delegate = this;
        f = {
          cold: this.createColdObservable.bind(this),
          hot: this.createHotObservable.bind(this),
          flush: this.flush.bind(this),
          time: this.createTime.bind(this),
          expectObservable: this.expectObservable.bind(this),
          expectSubscriptions: this.expectSubscriptions.bind(this),
          animate: f.animate
        };
        try {
          var l = b(f);
          this.flush();
          return l;
        } finally {
          a.frameTimeFactor = c, this.maxFrames = e, this.runMode = !1, N.delegate = void 0, ka.delegate = void 0, ma.delegate = void 0, la.delegate = void 0, da.delegate = void 0, Da.delegate = void 0;
        }
      };
      a.frameTimeFactor = 10;
      return a;
    }(Ud),
    cf = Object.freeze({
      TestScheduler: bf
    }),
    yb = function () {
      return function (b, a, c, d) {
        void 0 === d && (d = "download_load");
        this.originalEvent = b;
        this.xhr = a;
        this.request = c;
        this.type = d;
        c = a.status;
        d = a.responseType;
        this.status = null !== c && void 0 !== c ? c : 0;
        this.responseType = null !== d && void 0 !== d ? d : "";
        this.responseHeaders = (c = a.getAllResponseHeaders()) ? c.split("\n").reduce(function (a, b) {
          var c = b.indexOf(": ");
          a[b.slice(0, c)] = b.slice(c + 2);
          return a;
        }, {}) : {};
        this.response = Ld(a);
        a = b.total;
        this.loaded = b.loaded;
        this.total = a;
      };
    }(),
    wa = R(function (b) {
      return function (a, b, d) {
        this.message = a;
        this.name = "AjaxError";
        this.xhr = b;
        this.request = d;
        this.status = b.status;
        this.responseType = b.responseType;
        var c;
        try {
          c = Ld(b);
        } catch (f) {
          c = b.responseText;
        }
        this.response = c;
      };
    }),
    Md = function () {
      function b(a, b) {
        wa.call(this, "ajax timeout", a, b);
        this.name = "AjaxTimeoutError";
        return this;
      }
      b.prototype = Object.create(wa.prototype);
      return b;
    }(),
    Me = Q(function (b) {
      return b.response;
    }),
    ba = function () {
      var b = function (a) {
        return Ne("string" === typeof a ? {
          url: a
        } : a);
      };
      b.get = Ge;
      b.post = He;
      b.delete = Ie;
      b.put = Je;
      b.patch = Ke;
      b.getJSON = Le;
      return b;
    }(),
    Pe = "upload",
    Od = "download",
    zb = "loadstart",
    Ab = "progress",
    Nd = "load",
    Qe = Object.prototype.toString,
    df = Object.freeze({
      ajax: ba,
      AjaxError: wa,
      AjaxTimeoutError: Md,
      AjaxResponse: yb
    }),
    ef = {
      url: "",
      deserializer: function (b) {
        return JSON.parse(b.data);
      },
      serializer: function (b) {
        return JSON.stringify(b);
      }
    },
    Yd = function (b) {
      function a(a, d) {
        var c = b.call(this) || this;
        c._socket = null;
        if (a instanceof r) c.destination = d, c.source = a;else {
          d = c._config = T({}, ef);
          c._output = new A();
          if ("string" === typeof a) d.url = a;else for (var f in a) a.hasOwnProperty(f) && (d[f] = a[f]);
          if (!d.WebSocketCtor && WebSocket) d.WebSocketCtor = WebSocket;else if (!d.WebSocketCtor) throw Error("no WebSocket constructor can be found");
          c.destination = new ha();
        }
        return c;
      }
      y(a, b);
      a.prototype.lift = function (b) {
        var c = new a(this._config, this.destination);
        c.operator = b;
        c.source = this;
        return c;
      };
      a.prototype._resetState = function () {
        this._socket = null;
        this.source || (this.destination = new ha());
        this._output = new A();
      };
      a.prototype.multiplex = function (a, b, e) {
        var c = this;
        return new r(function (d) {
          try {
            c.next(a());
          } catch (k) {
            d.error(k);
          }
          var f = c.subscribe({
            next: function (a) {
              try {
                e(a) && d.next(a);
              } catch (z) {
                d.error(z);
              }
            },
            error: function (a) {
              return d.error(a);
            },
            complete: function () {
              return d.complete();
            }
          });
          return function () {
            try {
              c.next(b());
            } catch (k) {
              d.error(k);
            }
            f.unsubscribe();
          };
        });
      };
      a.prototype._connectSocket = function () {
        var a = this,
          b = this._config,
          e = b.WebSocketCtor,
          f = b.protocol,
          g = b.url,
          b = b.binaryType,
          l = this._output,
          k = null;
        try {
          this._socket = k = f ? new e(g, f) : new e(g), b && (this._socket.binaryType = b);
        } catch (p) {
          l.error(p);
          return;
        }
        var m = new D(function () {
          a._socket = null;
          k && 1 === k.readyState && k.close();
        });
        k.onopen = function (b) {
          if (a._socket) {
            var c = a._config.openObserver;
            c && c.next(b);
            b = a.destination;
            a.destination = na.create(function (b) {
              if (1 === k.readyState) try {
                var c = a._config.serializer;
                k.send(c(b));
              } catch (u) {
                a.destination.error(u);
              }
            }, function (b) {
              var c = a._config.closingObserver;
              c && c.next(void 0);
              b && b.code ? k.close(b.code, b.reason) : l.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }"));
              a._resetState();
            }, function () {
              var b = a._config.closingObserver;
              b && b.next(void 0);
              k.close();
              a._resetState();
            });
            b && b instanceof ha && m.add(b.subscribe(a.destination));
          } else k.close(), a._resetState();
        };
        k.onerror = function (b) {
          a._resetState();
          l.error(b);
        };
        k.onclose = function (b) {
          k === a._socket && a._resetState();
          var c = a._config.closeObserver;
          c && c.next(b);
          b.wasClean ? l.complete() : l.error(b);
        };
        k.onmessage = function (b) {
          try {
            var c = a._config.deserializer;
            l.next(c(b));
          } catch (B) {
            l.error(B);
          }
        };
      };
      a.prototype._subscribe = function (a) {
        var b = this,
          c = this.source;
        if (c) return c.subscribe(a);
        this._socket || this._connectSocket();
        this._output.subscribe(a);
        a.add(function () {
          var a = b._socket;
          0 === b._output.observers.length && (!a || 1 !== a.readyState && 0 !== a.readyState || a.close(), b._resetState());
        });
        return a;
      };
      a.prototype.unsubscribe = function () {
        var a = this._socket;
        !a || 1 !== a.readyState && 0 !== a.readyState || a.close();
        this._resetState();
        b.prototype.unsubscribe.call(this);
      };
      return a;
    }(Db),
    ff = Object.freeze({
      webSocket: function (b) {
        return new Yd(b);
      },
      WebSocketSubject: Yd
    }),
    gf = Object.freeze({
      fromFetch: function (b, a) {
        void 0 === a && (a = {});
        var c = a.selector,
          d = Zd(a, ["selector"]);
        return new r(function (a) {
          var e = new AbortController(),
            g = e.signal,
            l = !0,
            k = d.signal;
          if (k) if (k.aborted) e.abort();else {
            var n = function () {
              g.aborted || e.abort();
            };
            k.addEventListener("abort", n);
            a.add(function () {
              return k.removeEventListener("abort", n);
            });
          }
          var p = T(T({}, d), {
              signal: g
            }),
            r = function (b) {
              l = !1;
              a.error(b);
            };
          fetch(b, p).then(function (b) {
            c ? q(c(b)).subscribe(m(a, void 0, function () {
              l = !1;
              a.complete();
            }, r)) : (l = !1, a.next(b), a.complete());
          }).catch(r);
          return function () {
            l && e.abort();
          };
        });
      }
    });
  g.operators = af;
  g.testing = cf;
  g.ajax = df;
  g.webSocket = ff;
  g.fetch = gf;
  g.Observable = r;
  g.ConnectableObservable = Ra;
  g.observable = pa;
  g.animationFrames = function (b) {
    return b ? Mb(b) : Te;
  };
  g.Subject = A;
  g.BehaviorSubject = Zc;
  g.ReplaySubject = ha;
  g.AsyncSubject = fb;
  g.asap = Rd;
  g.asapScheduler = Rd;
  g.async = ib;
  g.asyncScheduler = I;
  g.queue = Sd;
  g.queueScheduler = Sd;
  g.animationFrame = Td;
  g.animationFrameScheduler = Td;
  g.VirtualTimeScheduler = Ud;
  g.VirtualAction = Gb;
  g.Scheduler = Fb;
  g.Subscription = D;
  g.Subscriber = na;
  g.Notification = Pa;
  g.pipe = Xa;
  g.noop = C;
  g.identity = E;
  g.isObservable = function (b) {
    return !!b && (b instanceof r || t(b.lift) && t(b.subscribe));
  };
  g.lastValueFrom = function (b, a) {
    var c = "object" === typeof a;
    return new Promise(function (d, e) {
      var f = !1,
        g;
      b.subscribe({
        next: function (a) {
          g = a;
          f = !0;
        },
        error: e,
        complete: function () {
          f ? d(g) : c ? d(a.defaultValue) : e(new aa());
        }
      });
    });
  };
  g.firstValueFrom = function (b, a) {
    var c = "object" === typeof a;
    return new Promise(function (d, e) {
      var f = new ia({
        next: function (a) {
          d(a);
          f.unsubscribe();
        },
        error: e,
        complete: function () {
          c ? d(a.defaultValue) : e(new aa());
        }
      });
      b.subscribe(f);
    });
  };
  g.ArgumentOutOfRangeError = rb;
  g.EmptyError = aa;
  g.NotFoundError = ld;
  g.ObjectUnsubscribedError = Qd;
  g.SequenceError = kd;
  g.TimeoutError = Xb;
  g.UnsubscriptionError = Sa;
  g.bindCallback = function (b, a, c) {
    return Ga(!1, b, a, c);
  };
  g.bindNodeCallback = function (b, a, c) {
    return Ga(!0, b, a, c);
  };
  g.combineLatest = $b;
  g.concat = ta;
  g.connectable = function (b, a) {
    void 0 === a && (a = $e);
    var c = null,
      d = a.connector;
    a = a.resetOnDisconnect;
    var e = void 0 === a ? !0 : a,
      f = d();
    a = new r(function (a) {
      return f.subscribe(a);
    });
    a.connect = function () {
      if (!c || c.closed) c = Ia(function () {
        return b;
      }).subscribe(f), e && c.add(function () {
        return f = d();
      });
      return c;
    };
    return a;
  };
  g.defer = Ia;
  g.empty = function (b) {
    return b ? de(b) : L;
  };
  g.forkJoin = function () {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var a = oa(b),
      b = Yb(b),
      c = b.args,
      d = b.keys,
      b = new r(function (a) {
        var b = c.length;
        if (b) for (var e = Array(b), g = b, k = b, n = function (b) {
            var f = !1;
            q(c[b]).subscribe(m(a, function (a) {
              f || (f = !0, k--);
              e[b] = a;
            }, function () {
              return g--;
            }, void 0, function () {
              g && f || (k || a.next(d ? Zb(d, e) : e), a.complete());
            }));
          }, p = 0; p < b; p++) n(p);else a.complete();
      });
    return a ? b.pipe(W(a)) : b;
  };
  g.from = P;
  g.fromEvent = hb;
  g.fromEventPattern = dc;
  g.generate = function (b, a, c, d, e) {
    function f() {
      var b;
      return Ua(this, function (d) {
        switch (d.label) {
          case 0:
            b = k, d.label = 1;
          case 1:
            return a && !a(b) ? [3, 4] : [4, l(b)];
          case 2:
            d.sent(), d.label = 3;
          case 3:
            return b = c(b), [3, 1];
          case 4:
            return [2];
        }
      });
    }
    var g, l, k;
    1 === arguments.length ? (k = b.initialState, a = b.condition, c = b.iterate, g = b.resultSelector, l = void 0 === g ? E : g, e = b.scheduler) : (k = b, !d || Ea(d) ? (l = E, e = d) : l = d);
    return Ia(e ? function () {
      return Tb(f(), e);
    } : f);
  };
  g.iif = function (b, a, c) {
    return Ia(function () {
      return b() ? a : c;
    });
  };
  g.interval = ec;
  g.merge = function () {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    var a = O(b),
      c = "number" === typeof b[b.length - 1] ? b.pop() : Infinity;
    return b.length ? 1 === b.length ? q(b[0]) : sa(c)(P(b, a)) : L;
  };
  g.never = function () {
    return Vd;
  };
  g.of = cb;
  g.onErrorResumeNext = fc;
  g.pairs = function (b, a) {
    return P(Object.entries(b), a);
  };
  g.partition = function (b, a, c) {
    return [K(a, c)(q(b)), K(gc(a, c))(q(b))];
  };
  g.race = function () {
    for (var b = [], a = 0; a < arguments.length; a++) b[a] = arguments[a];
    b = Z(b);
    return 1 === b.length ? q(b[0]) : new r(hc(b));
  };
  g.range = function (b, a, c) {
    null == a && (a = b, b = 0);
    if (0 >= a) return L;
    var d = a + b;
    return new r(c ? function (a) {
      var e = b;
      return c.schedule(function () {
        e < d ? (a.next(e++), this.schedule()) : a.complete();
      });
    } : function (a) {
      for (var c = b; c < d && !a.closed;) a.next(c++);
      a.complete();
    });
  };
  g.throwError = Wb;
  g.timer = Y;
  g.using = function (b, a) {
    return new r(function (c) {
      var d = b(),
        e = a(d);
      (e ? q(e) : L).subscribe(c);
      return function () {
        d && d.unsubscribe();
      };
    });
  };
  g.zip = jb;
  g.scheduled = Vb;
  g.EMPTY = L;
  g.NEVER = Vd;
  g.config = S;
  g.audit = kb;
  g.auditTime = ic;
  g.buffer = jc;
  g.bufferCount = kc;
  g.bufferTime = lc;
  g.bufferToggle = mc;
  g.bufferWhen = nc;
  g.catchError = lb;
  g.combineAll = Ja;
  g.combineLatestAll = Ja;
  g.combineLatestWith = qc;
  g.concatAll = Ha;
  g.concatMap = Ka;
  g.concatMapTo = rc;
  g.concatWith = tc;
  g.connect = La;
  g.count = uc;
  g.debounce = vc;
  g.debounceTime = wc;
  g.defaultIfEmpty = ua;
  g.delay = xc;
  g.delayWhen = Ma;
  g.dematerialize = yc;
  g.distinct = zc;
  g.distinctUntilChanged = qb;
  g.distinctUntilKeyChanged = Ac;
  g.elementAt = Bc;
  g.endWith = Cc;
  g.every = Dc;
  g.exhaust = Oa;
  g.exhaustAll = Oa;
  g.exhaustMap = Na;
  g.expand = Ec;
  g.filter = K;
  g.finalize = Fc;
  g.find = Gc;
  g.findIndex = Ic;
  g.first = Jc;
  g.groupBy = Kc;
  g.ignoreElements = ob;
  g.isEmpty = Lc;
  g.last = Mc;
  g.map = Q;
  g.mapTo = pb;
  g.materialize = Nc;
  g.max = Oc;
  g.mergeAll = sa;
  g.flatMap = H;
  g.mergeMap = H;
  g.mergeMapTo = Pc;
  g.mergeScan = Qc;
  g.mergeWith = Sc;
  g.min = Tc;
  g.multicast = Qa;
  g.observeOn = qa;
  g.onErrorResumeNextWith = Uc;
  g.pairwise = Vc;
  g.pluck = Wc;
  g.publish = Xc;
  g.publishBehavior = Yc;
  g.publishLast = $c;
  g.publishReplay = ad;
  g.raceWith = tb;
  g.reduce = fa;
  g.repeat = bd;
  g.repeatWhen = cd;
  g.retry = dd;
  g.retryWhen = ed;
  g.refCount = Za;
  g.sample = ub;
  g.sampleTime = fd;
  g.scan = gd;
  g.sequenceEqual = hd;
  g.share = vb;
  g.shareReplay = id;
  g.single = jd;
  g.skip = md;
  g.skipLast = nd;
  g.skipUntil = od;
  g.skipWhile = pd;
  g.startWith = qd;
  g.subscribeOn = ra;
  g.switchAll = rd;
  g.switchMap = ja;
  g.switchMapTo = sd;
  g.switchScan = td;
  g.take = ga;
  g.takeLast = sb;
  g.takeUntil = ud;
  g.takeWhile = vd;
  g.tap = wd;
  g.throttle = xb;
  g.throttleTime = xd;
  g.throwIfEmpty = va;
  g.timeInterval = yd;
  g.timeout = eb;
  g.timeoutWith = zd;
  g.timestamp = Ad;
  g.toArray = mb;
  g.window = Bd;
  g.windowCount = Cd;
  g.windowTime = Dd;
  g.windowToggle = Ed;
  g.windowWhen = Fd;
  g.withLatestFrom = Gd;
  g.zipAll = Hd;
  g.zipWith = Jd;
  Object.defineProperty(g, "__esModule", {
    value: !0
  });
});
"use strict";function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}/**
 * vis-network
 * https://visjs.github.io/vis-network/
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 9.1.9
 * @date    2023-11-03T01:44:38.007Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */!function(t,e){"object"==(typeof exports==="undefined"?"undefined":_typeof(exports))&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).vis=t.vis||{});}(void 0,function(t){"use strict";var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function i(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t["default"]:t;}var n=function n(t){return t&&t.Math===Math&&t;},o=n("object"==(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))&&globalThis)||n("object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window)||n("object"==(typeof self==="undefined"?"undefined":_typeof(self))&&self)||n("object"==_typeof(e)&&e)||function(){return this;}()||e||Function("return this")(),r=function r(t){try{return!!t();}catch(t){return!0;}},s=!r(function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype");}),a=s,h=Function.prototype,l=h.apply,d=h.call,c="object"==(typeof Reflect==="undefined"?"undefined":_typeof(Reflect))&&Reflect.apply||(a?d.bind(l):function(){return d.apply(l,arguments);}),u=s,f=Function.prototype,p=f.call,v=u&&f.bind.bind(p,p),g=u?v:function(t){return function(){return p.apply(t,arguments);};},y=g,m=y({}.toString),b=y("".slice),w=function w(t){return b(m(t),8,-1);},k=w,_=g,x=function x(t){if("Function"===k(t))return _(t);},E="object"==(typeof document==="undefined"?"undefined":_typeof(document))&&document.all,O={all:E,IS_HTMLDDA:void 0===E&&void 0!==E},C=O.all,S=O.IS_HTMLDDA?function(t){return"function"==typeof t||t===C;}:function(t){return"function"==typeof t;},T={},M=!r(function(){return 7!==Object.defineProperty({},1,{get:function get(){return 7;}})[1];}),P=s,D=Function.prototype.call,I=P?D.bind(D):function(){return D.apply(D,arguments);},B={},N={}.propertyIsEnumerable,F=Object.getOwnPropertyDescriptor,z=F&&!N.call({1:2},1);B.f=z?function(t){var e=F(this,t);return!!e&&e.enumerable;}:N;var A,j,R=function R(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e};},L=r,H=w,W=Object,q=g("".split),V=L(function(){return!W("z").propertyIsEnumerable(0);})?function(t){return"String"===H(t)?q(t,""):W(t);}:W,U=function U(t){return null==t;},Y=U,X=TypeError,G=function G(t){if(Y(t))throw new X("Can't call method on "+t);return t;},K=V,$=G,Z=function Z(t){return K($(t));},Q=S,J=O.all,tt=O.IS_HTMLDDA?function(t){return"object"==_typeof(t)?null!==t:Q(t)||t===J;}:function(t){return"object"==_typeof(t)?null!==t:Q(t);},et={},it=et,nt=o,ot=S,rt=function rt(t){return ot(t)?t:void 0;},st=function st(t,e){return arguments.length<2?rt(it[t])||rt(nt[t]):it[t]&&it[t][e]||nt[t]&&nt[t][e];},at=g({}.isPrototypeOf),ht="undefined"!=typeof navigator&&String(navigator.userAgent)||"",lt=o,dt=ht,ct=lt.process,ut=lt.Deno,ft=ct&&ct.versions||ut&&ut.version,pt=ft&&ft.v8;pt&&(j=(A=pt.split("."))[0]>0&&A[0]<4?1:+(A[0]+A[1])),!j&&dt&&(!(A=dt.match(/Edge\/(\d+)/))||A[1]>=74)&&(A=dt.match(/Chrome\/(\d+)/))&&(j=+A[1]);var vt=j,gt=vt,yt=r,mt=o.String,bt=!!Object.getOwnPropertySymbols&&!yt(function(){var t=Symbol("symbol detection");return!mt(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&gt&&gt<41;}),wt=bt&&!Symbol.sham&&"symbol"==_typeof(Symbol.iterator),kt=st,_t=S,xt=at,Et=Object,Ot=wt?function(t){return"symbol"==_typeof(t);}:function(t){var e=kt("Symbol");return _t(e)&&xt(e.prototype,Et(t));},Ct=String,St=function St(t){try{return Ct(t);}catch(t){return"Object";}},Tt=S,Mt=St,Pt=TypeError,Dt=function Dt(t){if(Tt(t))return t;throw new Pt(Mt(t)+" is not a function");},It=Dt,Bt=U,Nt=function Nt(t,e){var i=t[e];return Bt(i)?void 0:It(i);},Ft=I,zt=S,At=tt,jt=TypeError,Rt={exports:{}},Lt=o,Ht=Object.defineProperty,Wt=function Wt(t,e){try{Ht(Lt,t,{value:e,configurable:!0,writable:!0});}catch(i){Lt[t]=e;}return e;},qt="__core-js_shared__",Vt=o[qt]||Wt(qt,{}),Ut=Vt;(Rt.exports=function(t,e){return Ut[t]||(Ut[t]=void 0!==e?e:{});})("versions",[]).push({version:"3.33.0",mode:"pure",copyright:"© 2014-2023 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",source:"https://github.com/zloirock/core-js"});var Yt=Rt.exports,Xt=G,Gt=Object,Kt=function Kt(t){return Gt(Xt(t));},$t=Kt,Zt=g({}.hasOwnProperty),Qt=Object.hasOwn||function(t,e){return Zt($t(t),e);},Jt=g,te=0,ee=Math.random(),ie=Jt(1..toString),ne=function ne(t){return"Symbol("+(void 0===t?"":t)+")_"+ie(++te+ee,36);},oe=Yt,re=Qt,se=ne,ae=bt,he=wt,le=o.Symbol,de=oe("wks"),ce=he?le["for"]||le:le&&le.withoutSetter||se,ue=function ue(t){return re(de,t)||(de[t]=ae&&re(le,t)?le[t]:ce("Symbol."+t)),de[t];},fe=I,pe=tt,ve=Ot,ge=Nt,ye=function ye(t,e){var i,n;if("string"===e&&zt(i=t.toString)&&!At(n=Ft(i,t)))return n;if(zt(i=t.valueOf)&&!At(n=Ft(i,t)))return n;if("string"!==e&&zt(i=t.toString)&&!At(n=Ft(i,t)))return n;throw new jt("Can't convert object to primitive value");},me=TypeError,be=ue("toPrimitive"),we=function we(t,e){if(!pe(t)||ve(t))return t;var i,n=ge(t,be);if(n){if(void 0===e&&(e="default"),i=fe(n,t,e),!pe(i)||ve(i))return i;throw new me("Can't convert object to primitive value");}return void 0===e&&(e="number"),ye(t,e);},ke=Ot,_e=function _e(t){var e=we(t,"string");return ke(e)?e:e+"";},xe=tt,Ee=o.document,Oe=xe(Ee)&&xe(Ee.createElement),Ce=function Ce(t){return Oe?Ee.createElement(t):{};},Se=Ce,Te=!M&&!r(function(){return 7!==Object.defineProperty(Se("div"),"a",{get:function get(){return 7;}}).a;}),Me=M,Pe=I,De=B,Ie=R,Be=Z,Ne=_e,Fe=Qt,ze=Te,Ae=Object.getOwnPropertyDescriptor;T.f=Me?Ae:function(t,e){if(t=Be(t),e=Ne(e),ze)try{return Ae(t,e);}catch(t){}if(Fe(t,e))return Ie(!Pe(De.f,t,e),t[e]);};var je=r,Re=S,Le=/#|\.prototype\./,He=function He(t,e){var i=qe[We(t)];return i===Ue||i!==Ve&&(Re(e)?je(e):!!e);},We=He.normalize=function(t){return String(t).replace(Le,".").toLowerCase();},qe=He.data={},Ve=He.NATIVE="N",Ue=He.POLYFILL="P",Ye=He,Xe=Dt,Ge=s,Ke=x(x.bind),$e=function $e(t,e){return Xe(t),void 0===e?t:Ge?Ke(t,e):function(){return t.apply(e,arguments);};},Ze={},Qe=M&&r(function(){return 42!==Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype;}),Je=tt,ti=String,ei=TypeError,ii=function ii(t){if(Je(t))return t;throw new ei(ti(t)+" is not an object");},ni=M,oi=Te,ri=Qe,si=ii,ai=_e,hi=TypeError,li=Object.defineProperty,di=Object.getOwnPropertyDescriptor,ci="enumerable",ui="configurable",fi="writable";Ze.f=ni?ri?function(t,e,i){if(si(t),e=ai(e),si(i),"function"==typeof t&&"prototype"===e&&"value"in i&&fi in i&&!i[fi]){var n=di(t,e);n&&n[fi]&&(t[e]=i.value,i={configurable:ui in i?i[ui]:n[ui],enumerable:ci in i?i[ci]:n[ci],writable:!1});}return li(t,e,i);}:li:function(t,e,i){if(si(t),e=ai(e),si(i),oi)try{return li(t,e,i);}catch(t){}if("get"in i||"set"in i)throw new hi("Accessors not supported");return"value"in i&&(t[e]=i.value),t;};var pi=Ze,vi=R,gi=M?function(t,e,i){return pi.f(t,e,vi(1,i));}:function(t,e,i){return t[e]=i,t;},yi=o,mi=c,bi=x,wi=S,ki=T.f,_i=Ye,xi=et,Ei=$e,Oi=gi,Ci=Qt,Si=function Si(t){var e=function e(i,n,o){if(this instanceof e){switch(arguments.length){case 0:return new t();case 1:return new t(i);case 2:return new t(i,n);}return new t(i,n,o);}return mi(t,this,arguments);};return e.prototype=t.prototype,e;},Ti=function Ti(t,e){var i,n,o,r,s,a,h,l,d,c=t.target,u=t.global,f=t.stat,p=t.proto,v=u?yi:f?yi[c]:(yi[c]||{}).prototype,g=u?xi:xi[c]||Oi(xi,c,{})[c],y=g.prototype;for(r in e)n=!(i=_i(u?r:c+(f?".":"#")+r,t.forced))&&v&&Ci(v,r),a=g[r],n&&(h=t.dontCallGetSet?(d=ki(v,r))&&d.value:v[r]),s=n&&h?h:e[r],n&&_typeof(a)==_typeof(s)||(l=t.bind&&n?Ei(s,yi):t.wrap&&n?Si(s):p&&wi(s)?bi(s):s,(t.sham||s&&s.sham||a&&a.sham)&&Oi(l,"sham",!0),Oi(g,r,l),p&&(Ci(xi,o=c+"Prototype")||Oi(xi,o,{}),Oi(xi[o],r,s),t.real&&y&&(i||!y[r])&&Oi(y,r,s)));},Mi=Math.ceil,Pi=Math.floor,Di=Math.trunc||function(t){var e=+t;return(e>0?Pi:Mi)(e);},Ii=function Ii(t){var e=+t;return e!=e||0===e?0:Di(e);},Bi=Ii,Ni=Math.max,Fi=Math.min,zi=function zi(t,e){var i=Bi(t);return i<0?Ni(i+e,0):Fi(i,e);},Ai=Ii,ji=Math.min,Ri=function Ri(t){return t>0?ji(Ai(t),9007199254740991):0;},Li=function Li(t){return Ri(t.length);},Hi=Z,Wi=zi,qi=Li,Vi=function Vi(t){return function(e,i,n){var o,r=Hi(e),s=qi(r),a=Wi(n,s);if(t&&i!=i){for(;s>a;)if((o=r[a++])!=o)return!0;}else for(;s>a;a++)if((t||a in r)&&r[a]===i)return t||a||0;return!t&&-1;};},Ui={includes:Vi(!0),indexOf:Vi(!1)},Yi={},Xi=Qt,Gi=Z,Ki=Ui.indexOf,$i=Yi,Zi=g([].push),Qi=function Qi(t,e){var i,n=Gi(t),o=0,r=[];for(i in n)!Xi($i,i)&&Xi(n,i)&&Zi(r,i);for(;e.length>o;)Xi(n,i=e[o++])&&(~Ki(r,i)||Zi(r,i));return r;},Ji=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],tn=Qi,en=Ji,nn=Object.keys||function(t){return tn(t,en);},on={};on.f=Object.getOwnPropertySymbols;var rn=M,sn=g,an=I,hn=r,ln=nn,dn=on,cn=B,un=Kt,fn=V,pn=Object.assign,vn=Object.defineProperty,gn=sn([].concat),yn=!pn||hn(function(){if(rn&&1!==pn({b:1},pn(vn({},"a",{enumerable:!0,get:function get(){vn(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return!0;var t={},e={},i=Symbol("assign detection"),n="abcdefghijklmnopqrst";return t[i]=7,n.split("").forEach(function(t){e[t]=t;}),7!==pn({},t)[i]||ln(pn({},e)).join("")!==n;})?function(t,e){for(var i=un(t),n=arguments.length,o=1,r=dn.f,s=cn.f;n>o;)for(var a,h=fn(arguments[o++]),l=r?gn(ln(h),r(h)):ln(h),d=l.length,c=0;d>c;)a=l[c++],rn&&!an(s,h,a)||(i[a]=h[a]);return i;}:pn,mn=yn;Ti({target:"Object",stat:!0,arity:2,forced:Object.assign!==mn},{assign:mn});var bn=i(et.Object.assign),wn=g([].slice),kn=g,_n=Dt,xn=tt,En=Qt,On=wn,Cn=s,Sn=Function,Tn=kn([].concat),Mn=kn([].join),Pn={},Dn=Cn?Sn.bind:function(t){var e=_n(this),i=e.prototype,n=On(arguments,1),o=function o(){var i=Tn(n,On(arguments));return this instanceof o?function(t,e,i){if(!En(Pn,e)){for(var n=[],o=0;o<e;o++)n[o]="a["+o+"]";Pn[e]=Sn("C,a","return new C("+Mn(n,",")+")");}return Pn[e](t,i);}(e,i.length,i):e.apply(t,i);};return xn(i)&&(o.prototype=i),o;},In=Dn;Ti({target:"Function",proto:!0,forced:Function.bind!==In},{bind:In});var Bn=et,Nn=function Nn(t){return Bn[t+"Prototype"];},Fn=Nn("Function").bind,zn=at,An=Fn,jn=Function.prototype,Rn=function Rn(t){var e=t.bind;return t===jn||zn(jn,t)&&e===jn.bind?An:e;},Ln=Rn,Hn=i(Ln);function Wn(t,e,i,n){t.beginPath(),t.arc(e,i,n,0,2*Math.PI,!1),t.closePath();}function qn(t,e,i,n,o,r){var s=Math.PI/180;n-2*r<0&&(r=n/2),o-2*r<0&&(r=o/2),t.beginPath(),t.moveTo(e+r,i),t.lineTo(e+n-r,i),t.arc(e+n-r,i+r,r,270*s,360*s,!1),t.lineTo(e+n,i+o-r),t.arc(e+n-r,i+o-r,r,0,90*s,!1),t.lineTo(e+r,i+o),t.arc(e+r,i+o-r,r,90*s,180*s,!1),t.lineTo(e,i+r),t.arc(e+r,i+r,r,180*s,270*s,!1),t.closePath();}function Vn(t,e,i,n,o){var r=.5522848,s=n/2*r,a=o/2*r,h=e+n,l=i+o,d=e+n/2,c=i+o/2;t.beginPath(),t.moveTo(e,c),t.bezierCurveTo(e,c-a,d-s,i,d,i),t.bezierCurveTo(d+s,i,h,c-a,h,c),t.bezierCurveTo(h,c+a,d+s,l,d,l),t.bezierCurveTo(d-s,l,e,c+a,e,c),t.closePath();}function Un(t,e,i,n,o){var r=o*(1/3),s=.5522848,a=n/2*s,h=r/2*s,l=e+n,d=i+r,c=e+n/2,u=i+r/2,f=i+(o-r/2),p=i+o;t.beginPath(),t.moveTo(l,u),t.bezierCurveTo(l,u+h,c+a,d,c,d),t.bezierCurveTo(c-a,d,e,u+h,e,u),t.bezierCurveTo(e,u-h,c-a,i,c,i),t.bezierCurveTo(c+a,i,l,u-h,l,u),t.lineTo(l,f),t.bezierCurveTo(l,f+h,c+a,p,c,p),t.bezierCurveTo(c-a,p,e,f+h,e,f),t.lineTo(e,u);}function Yn(t,e,i,n,o,r){t.beginPath(),t.moveTo(e,i);for(var s=r.length,a=n-e,h=o-i,l=h/a,d=Math.sqrt(a*a+h*h),c=0,u=!0,f=0,p=+r[0];d>=.1;)(p=+r[c++%s])>d&&(p=d),f=Math.sqrt(p*p/(1+l*l)),e+=f=a<0?-f:f,i+=l*f,!0===u?t.lineTo(e,i):t.moveTo(e,i),d-=p,u=!u;}var Xn={circle:Wn,dashedLine:Yn,database:Un,diamond:function diamond(t,e,i,n){t.beginPath(),t.lineTo(e,i+n),t.lineTo(e+n,i),t.lineTo(e,i-n),t.lineTo(e-n,i),t.closePath();},ellipse:Vn,ellipse_vis:Vn,hexagon:function hexagon(t,e,i,n){t.beginPath();var o=2*Math.PI/6;t.moveTo(e+n,i);for(var r=1;r<6;r++)t.lineTo(e+n*Math.cos(o*r),i+n*Math.sin(o*r));t.closePath();},roundRect:qn,square:function square(t,e,i,n){t.beginPath(),t.rect(e-n,i-n,2*n,2*n),t.closePath();},star:function star(t,e,i,n){t.beginPath(),i+=.1*(n*=.82);for(var o=0;o<10;o++){var r=o%2==0?1.3*n:.5*n;t.lineTo(e+r*Math.sin(2*o*Math.PI/10),i-r*Math.cos(2*o*Math.PI/10));}t.closePath();},triangle:function triangle(t,e,i,n){t.beginPath(),i+=.275*(n*=1.15);var o=2*n,r=o/2,s=Math.sqrt(3)/6*o,a=Math.sqrt(o*o-r*r);t.moveTo(e,i-(a-s)),t.lineTo(e+r,i+s),t.lineTo(e-r,i+s),t.lineTo(e,i-(a-s)),t.closePath();},triangleDown:function triangleDown(t,e,i,n){t.beginPath(),i-=.275*(n*=1.15);var o=2*n,r=o/2,s=Math.sqrt(3)/6*o,a=Math.sqrt(o*o-r*r);t.moveTo(e,i+(a-s)),t.lineTo(e+r,i-s),t.lineTo(e-r,i-s),t.lineTo(e,i+(a-s)),t.closePath();}};var Gn={exports:{}};!function(t){function e(t){if(t)return function(t){for(var i in e.prototype)t[i]=e.prototype[i];return t;}(t);}t.exports=e,e.prototype.on=e.prototype.addEventListener=function(t,e){return this._callbacks=this._callbacks||{},(this._callbacks["$"+t]=this._callbacks["$"+t]||[]).push(e),this;},e.prototype.once=function(t,e){function i(){this.off(t,i),e.apply(this,arguments);}return i.fn=e,this.on(t,i),this;},e.prototype.off=e.prototype.removeListener=e.prototype.removeAllListeners=e.prototype.removeEventListener=function(t,e){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var i,n=this._callbacks["$"+t];if(!n)return this;if(1==arguments.length)return delete this._callbacks["$"+t],this;for(var o=0;o<n.length;o++)if((i=n[o])===e||i.fn===e){n.splice(o,1);break;}return 0===n.length&&delete this._callbacks["$"+t],this;},e.prototype.emit=function(t){this._callbacks=this._callbacks||{};for(var e=new Array(arguments.length-1),i=this._callbacks["$"+t],n=1;n<arguments.length;n++)e[n-1]=arguments[n];if(i){n=0;for(var o=(i=i.slice(0)).length;n<o;++n)i[n].apply(this,e);}return this;},e.prototype.listeners=function(t){return this._callbacks=this._callbacks||{},this._callbacks["$"+t]||[];},e.prototype.hasListeners=function(t){return!!this.listeners(t).length;};}(Gn);var Kn=i(Gn.exports),$n={};$n[ue("toStringTag")]="z";var Zn,Qn,Jn,to="[object z]"===String($n),eo=to,io=S,no=w,oo=ue("toStringTag"),ro=Object,so="Arguments"===no(function(){return arguments;}()),ao=eo?no:function(t){var e,i,n;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(i=function(t,e){try{return t[e];}catch(t){}}(e=ro(t),oo))?i:so?no(e):"Object"===(n=no(e))&&io(e.callee)?"Arguments":n;},ho=ao,lo=String,co=function co(t){if("Symbol"===ho(t))throw new TypeError("Cannot convert a Symbol value to a string");return lo(t);},uo=g,fo=Ii,po=co,vo=G,go=uo("".charAt),yo=uo("".charCodeAt),mo=uo("".slice),bo=function bo(t){return function(e,i){var n,o,r=po(vo(e)),s=fo(i),a=r.length;return s<0||s>=a?t?"":void 0:(n=yo(r,s))<55296||n>56319||s+1===a||(o=yo(r,s+1))<56320||o>57343?t?go(r,s):n:t?mo(r,s,s+2):o-56320+(n-55296<<10)+65536;};},wo={codeAt:bo(!1),charAt:bo(!0)},ko=S,_o=o.WeakMap,xo=ko(_o)&&/native code/.test(String(_o)),Eo=ne,Oo=Yt("keys"),Co=function Co(t){return Oo[t]||(Oo[t]=Eo(t));},So=xo,To=o,Mo=tt,Po=gi,Do=Qt,Io=Vt,Bo=Co,No=Yi,Fo="Object already initialized",zo=To.TypeError,Ao=To.WeakMap;if(So||Io.state){var jo=Io.state||(Io.state=new Ao());jo.get=jo.get,jo.has=jo.has,jo.set=jo.set,Zn=function Zn(t,e){if(jo.has(t))throw new zo(Fo);return e.facade=t,jo.set(t,e),e;},Qn=function Qn(t){return jo.get(t)||{};},Jn=function Jn(t){return jo.has(t);};}else{var Ro=Bo("state");No[Ro]=!0,Zn=function Zn(t,e){if(Do(t,Ro))throw new zo(Fo);return e.facade=t,Po(t,Ro,e),e;},Qn=function Qn(t){return Do(t,Ro)?t[Ro]:{};},Jn=function Jn(t){return Do(t,Ro);};}var Lo={set:Zn,get:Qn,has:Jn,enforce:function enforce(t){return Jn(t)?Qn(t):Zn(t,{});},getterFor:function getterFor(t){return function(e){var i;if(!Mo(e)||(i=Qn(e)).type!==t)throw new zo("Incompatible receiver, "+t+" required");return i;};}},Ho=M,Wo=Qt,qo=Function.prototype,Vo=Ho&&Object.getOwnPropertyDescriptor,Uo=Wo(qo,"name"),Yo={EXISTS:Uo,PROPER:Uo&&"something"===function(){}.name,CONFIGURABLE:Uo&&(!Ho||Ho&&Vo(qo,"name").configurable)},Xo={},Go=M,Ko=Qe,$o=Ze,Zo=ii,Qo=Z,Jo=nn;Xo.f=Go&&!Ko?Object.defineProperties:function(t,e){Zo(t);for(var i,n=Qo(e),o=Jo(e),r=o.length,s=0;r>s;)$o.f(t,i=o[s++],n[i]);return t;};var tr,er=st("document","documentElement"),ir=ii,nr=Xo,or=Ji,rr=Yi,sr=er,ar=Ce,hr="prototype",lr="script",dr=Co("IE_PROTO"),cr=function cr(){},ur=function ur(t){return"<"+lr+">"+t+"</"+lr+">";},fr=function fr(t){t.write(ur("")),t.close();var e=t.parentWindow.Object;return t=null,e;},_pr=function pr(){try{tr=new ActiveXObject("htmlfile");}catch(t){}var t,e,i;_pr="undefined"!=typeof document?document.domain&&tr?fr(tr):(e=ar("iframe"),i="java"+lr+":",e.style.display="none",sr.appendChild(e),e.src=String(i),(t=e.contentWindow.document).open(),t.write(ur("document.F=Object")),t.close(),t.F):fr(tr);for(var n=or.length;n--;)delete _pr[hr][or[n]];return _pr();};rr[dr]=!0;var vr,gr,yr,mr=Object.create||function(t,e){var i;return null!==t?(cr[hr]=ir(t),i=new cr(),cr[hr]=null,i[dr]=t):i=_pr(),void 0===e?i:nr.f(i,e);},br=!r(function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t())!==t.prototype;}),wr=Qt,kr=S,_r=Kt,xr=br,Er=Co("IE_PROTO"),Or=Object,Cr=Or.prototype,Sr=xr?Or.getPrototypeOf:function(t){var e=_r(t);if(wr(e,Er))return e[Er];var i=e.constructor;return kr(i)&&e instanceof i?i.prototype:e instanceof Or?Cr:null;},Tr=gi,Mr=function Mr(t,e,i,n){return n&&n.enumerable?t[e]=i:Tr(t,e,i),t;},Pr=r,Dr=S,Ir=tt,Br=mr,Nr=Sr,Fr=Mr,zr=ue("iterator"),Ar=!1;[].keys&&("next"in(yr=[].keys())?(gr=Nr(Nr(yr)))!==Object.prototype&&(vr=gr):Ar=!0);var jr=!Ir(vr)||Pr(function(){var t={};return vr[zr].call(t)!==t;});Dr((vr=jr?{}:Br(vr))[zr])||Fr(vr,zr,function(){return this;});var Rr={IteratorPrototype:vr,BUGGY_SAFARI_ITERATORS:Ar},Lr=ao,Hr=to?{}.toString:function(){return"[object "+Lr(this)+"]";},Wr=to,qr=Ze.f,Vr=gi,Ur=Qt,Yr=Hr,Xr=ue("toStringTag"),Gr=function Gr(t,e,i,n){if(t){var o=i?t:t.prototype;Ur(o,Xr)||qr(o,Xr,{configurable:!0,value:e}),n&&!Wr&&Vr(o,"toString",Yr);}},Kr={},$r=Rr.IteratorPrototype,Zr=mr,Qr=R,Jr=Gr,ts=Kr,es=function es(){return this;},is=g,ns=Dt,os=S,rs=String,ss=TypeError,as=function as(t,e,i){try{return is(ns(Object.getOwnPropertyDescriptor(t,e)[i]));}catch(t){}},hs=ii,ls=function ls(t){if("object"==_typeof(t)||os(t))return t;throw new ss("Can't set "+rs(t)+" as a prototype");},ds=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,i={};try{(t=as(Object.prototype,"__proto__","set"))(i,[]),e=i instanceof Array;}catch(t){}return function(i,n){return hs(i),ls(n),e?t(i,n):i.__proto__=n,i;};}():void 0),cs=Ti,us=I,fs=Yo,ps=function ps(t,e,i,n){var o=e+" Iterator";return t.prototype=Zr($r,{next:Qr(+!n,i)}),Jr(t,o,!1,!0),ts[o]=es,t;},vs=Sr,gs=Gr,ys=Mr,ms=Kr,bs=Rr,ws=fs.PROPER,ks=bs.BUGGY_SAFARI_ITERATORS,_s=ue("iterator"),xs="keys",Es="values",Os="entries",Cs=function Cs(){return this;},Ss=function Ss(t,e,i,n,o,r,s){ps(i,e,n);var a,h,l,d=function d(t){if(t===o&&v)return v;if(!ks&&t&&t in f)return f[t];switch(t){case xs:case Es:case Os:return function(){return new i(this,t);};}return function(){return new i(this);};},c=e+" Iterator",u=!1,f=t.prototype,p=f[_s]||f["@@iterator"]||o&&f[o],v=!ks&&p||d(o),g="Array"===e&&f.entries||p;if(g&&(a=vs(g.call(new t())))!==Object.prototype&&a.next&&(gs(a,c,!0,!0),ms[c]=Cs),ws&&o===Es&&p&&p.name!==Es&&(u=!0,v=function v(){return us(p,this);}),o)if(h={values:d(Es),keys:r?v:d(xs),entries:d(Os)},s)for(l in h)(ks||u||!(l in f))&&ys(f,l,h[l]);else cs({target:e,proto:!0,forced:ks||u},h);return s&&f[_s]!==v&&ys(f,_s,v,{name:o}),ms[e]=v,h;},Ts=function Ts(t,e){return{value:t,done:e};},Ms=wo.charAt,Ps=co,Ds=Lo,Is=Ss,Bs=Ts,Ns="String Iterator",Fs=Ds.set,zs=Ds.getterFor(Ns);Is(String,"String",function(t){Fs(this,{type:Ns,string:Ps(t),index:0});},function(){var t,e=zs(this),i=e.string,n=e.index;return n>=i.length?Bs(void 0,!0):(t=Ms(i,n),e.index+=t.length,Bs(t,!1));});var As=I,js=ii,Rs=Nt,Ls=function Ls(t,e,i){var n,o;js(t);try{if(!(n=Rs(t,"return"))){if("throw"===e)throw i;return i;}n=As(n,t);}catch(t){o=!0,n=t;}if("throw"===e)throw i;if(o)throw n;return js(n),i;},Hs=ii,Ws=Ls,qs=Kr,Vs=ue("iterator"),Us=Array.prototype,Ys=function Ys(t){return void 0!==t&&(qs.Array===t||Us[Vs]===t);},Xs=S,Gs=Vt,Ks=g(Function.toString);Xs(Gs.inspectSource)||(Gs.inspectSource=function(t){return Ks(t);});var $s=Gs.inspectSource,Zs=g,Qs=r,Js=S,ta=ao,ea=$s,ia=function ia(){},na=[],oa=st("Reflect","construct"),ra=/^\s*(?:class|function)\b/,sa=Zs(ra.exec),aa=!ra.test(ia),ha=function ha(t){if(!Js(t))return!1;try{return oa(ia,na,t),!0;}catch(t){return!1;}},la=function la(t){if(!Js(t))return!1;switch(ta(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1;}try{return aa||!!sa(ra,ea(t));}catch(t){return!0;}};la.sham=!0;var da=!oa||Qs(function(){var t;return ha(ha.call)||!ha(Object)||!ha(function(){t=!0;})||t;})?la:ha,ca=_e,ua=Ze,fa=R,pa=function pa(t,e,i){var n=ca(e);n in t?ua.f(t,n,fa(0,i)):t[n]=i;},va=ao,ga=Nt,ya=U,ma=Kr,ba=ue("iterator"),wa=function wa(t){if(!ya(t))return ga(t,ba)||ga(t,"@@iterator")||ma[va(t)];},ka=I,_a=Dt,xa=ii,Ea=St,Oa=wa,Ca=TypeError,Sa=function Sa(t,e){var i=arguments.length<2?Oa(t):e;if(_a(i))return xa(ka(i,t));throw new Ca(Ea(t)+" is not iterable");},Ta=$e,Ma=I,Pa=Kt,Da=function Da(t,e,i,n){try{return n?e(Hs(i)[0],i[1]):e(i);}catch(e){Ws(t,"throw",e);}},Ia=Ys,Ba=da,Na=Li,Fa=pa,za=Sa,Aa=wa,ja=Array,Ra=ue("iterator"),La=!1;try{var Ha=0,Wa={next:function next(){return{done:!!Ha++};},"return":function _return(){La=!0;}};Wa[Ra]=function(){return this;},Array.from(Wa,function(){throw 2;});}catch(t){}var qa=function qa(t,e){try{if(!e&&!La)return!1;}catch(t){return!1;}var i=!1;try{var n={};n[Ra]=function(){return{next:function next(){return{done:i=!0};}};},t(n);}catch(t){}return i;},Va=function Va(t){var e=Pa(t),i=Ba(this),n=arguments.length,o=n>1?arguments[1]:void 0,r=void 0!==o;r&&(o=Ta(o,n>2?arguments[2]:void 0));var s,a,h,l,d,c,u=Aa(e),f=0;if(!u||this===ja&&Ia(u))for(s=Na(e),a=i?new this(s):ja(s);s>f;f++)c=r?o(e[f],f):e[f],Fa(a,f,c);else for(d=(l=za(e,u)).next,a=i?new this():[];!(h=Ma(d,l)).done;f++)c=r?Da(l,o,[h.value,f],!0):h.value,Fa(a,f,c);return a.length=f,a;};Ti({target:"Array",stat:!0,forced:!qa(function(t){Array.from(t);})},{from:Va});var Ua=et.Array.from,Ya=i(Ua),Xa=Z,Ga=Kr,Ka=Lo;Ze.f;var $a=Ss,Za=Ts,Qa="Array Iterator",Ja=Ka.set,th=Ka.getterFor(Qa);$a(Array,"Array",function(t,e){Ja(this,{type:Qa,target:Xa(t),index:0,kind:e});},function(){var t=th(this),e=t.target,i=t.kind,n=t.index++;if(!e||n>=e.length)return t.target=void 0,Za(void 0,!0);switch(i){case"keys":return Za(n,!1);case"values":return Za(e[n],!1);}return Za([n,e[n]],!1);},"values"),Ga.Arguments=Ga.Array;var eh=wa,ih={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},nh=o,oh=ao,rh=gi,sh=Kr,ah=ue("toStringTag");for(var hh in ih){var lh=nh[hh],dh=lh&&lh.prototype;dh&&oh(dh)!==ah&&rh(dh,ah,hh),sh[hh]=sh.Array;}var ch=eh,uh=i(ch),fh=i(ch);function ph(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function");}var vh={exports:{}},gh=Ti,yh=M,mh=Ze.f;gh({target:"Object",stat:!0,forced:Object.defineProperty!==mh,sham:!yh},{defineProperty:mh});var bh=et.Object,wh=vh.exports=function(t,e,i){return bh.defineProperty(t,e,i);};bh.defineProperty.sham&&(wh.sham=!0);var kh=vh.exports,_h=kh,xh=i(_h),Eh=w,Oh=Array.isArray||function(t){return"Array"===Eh(t);},Ch=TypeError,Sh=function Sh(t){if(t>9007199254740991)throw Ch("Maximum allowed index exceeded");return t;},Th=Oh,Mh=da,Ph=tt,Dh=ue("species"),Ih=Array,Bh=function Bh(t){var e;return Th(t)&&(e=t.constructor,(Mh(e)&&(e===Ih||Th(e.prototype))||Ph(e)&&null===(e=e[Dh]))&&(e=void 0)),void 0===e?Ih:e;},Nh=function Nh(t,e){return new(Bh(t))(0===e?0:e);},Fh=r,zh=vt,Ah=ue("species"),jh=function jh(t){return zh>=51||!Fh(function(){var e=[];return(e.constructor={})[Ah]=function(){return{foo:1};},1!==e[t](Boolean).foo;});},Rh=Ti,Lh=r,Hh=Oh,Wh=tt,qh=Kt,Vh=Li,Uh=Sh,Yh=pa,Xh=Nh,Gh=jh,Kh=vt,$h=ue("isConcatSpreadable"),Zh=Kh>=51||!Lh(function(){var t=[];return t[$h]=!1,t.concat()[0]!==t;}),Qh=function Qh(t){if(!Wh(t))return!1;var e=t[$h];return void 0!==e?!!e:Hh(t);};Rh({target:"Array",proto:!0,arity:1,forced:!Zh||!Gh("concat")},{concat:function concat(t){var e,i,n,o,r,s=qh(this),a=Xh(s,0),h=0;for(e=-1,n=arguments.length;e<n;e++)if(Qh(r=-1===e?s:arguments[e]))for(o=Vh(r),Uh(h+o),i=0;i<o;i++,h++)i in r&&Yh(a,h,r[i]);else Uh(h+1),Yh(a,h++,r);return a.length=h,a;}});var Jh={},tl=Qi,el=Ji.concat("length","prototype");Jh.f=Object.getOwnPropertyNames||function(t){return tl(t,el);};var il={},nl=zi,ol=Li,rl=pa,sl=Array,al=Math.max,hl=function hl(t,e,i){for(var n=ol(t),o=nl(e,n),r=nl(void 0===i?n:i,n),s=sl(al(r-o,0)),a=0;o<r;o++,a++)rl(s,a,t[o]);return s.length=a,s;},ll=w,dl=Z,cl=Jh.f,ul=hl,fl="object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];il.f=function(t){return fl&&"Window"===ll(t)?function(t){try{return cl(t);}catch(t){return ul(fl);}}(t):cl(dl(t));};var pl=Ze,vl=function vl(t,e,i){return pl.f(t,e,i);},gl={},yl=ue;gl.f=yl;var ml=et,bl=Qt,wl=gl,kl=Ze.f,_l=function _l(t){var e=ml.Symbol||(ml.Symbol={});bl(e,t)||kl(e,t,{value:wl.f(t)});},xl=I,El=st,Ol=ue,Cl=Mr,Sl=function Sl(){var t=El("Symbol"),e=t&&t.prototype,i=e&&e.valueOf,n=Ol("toPrimitive");e&&!e[n]&&Cl(e,n,function(t){return xl(i,this);},{arity:1});},Tl=$e,Ml=V,Pl=Kt,Dl=Li,Il=Nh,Bl=g([].push),Nl=function Nl(t){var e=1===t,i=2===t,n=3===t,o=4===t,r=6===t,s=7===t,a=5===t||r;return function(h,l,d,c){for(var u,f,p=Pl(h),v=Ml(p),g=Tl(l,d),y=Dl(v),m=0,b=c||Il,w=e?b(h,y):i||s?b(h,0):void 0;y>m;m++)if((a||m in v)&&(f=g(u=v[m],m,p),t))if(e)w[m]=f;else if(f)switch(t){case 3:return!0;case 5:return u;case 6:return m;case 2:Bl(w,u);}else switch(t){case 4:return!1;case 7:Bl(w,u);}return r?-1:n||o?o:w;};},Fl={forEach:Nl(0),map:Nl(1),filter:Nl(2),some:Nl(3),every:Nl(4),find:Nl(5),findIndex:Nl(6),filterReject:Nl(7)},zl=Ti,Al=o,jl=I,Rl=g,Ll=M,Hl=bt,Wl=r,ql=Qt,Vl=at,Ul=ii,Yl=Z,Xl=_e,Gl=co,Kl=R,$l=mr,Zl=nn,Ql=Jh,Jl=il,td=on,ed=T,id=Ze,nd=Xo,od=B,rd=Mr,sd=vl,ad=Yt,hd=Yi,ld=ne,dd=ue,cd=gl,ud=_l,fd=Sl,pd=Gr,vd=Lo,gd=Fl.forEach,yd=Co("hidden"),md="Symbol",bd="prototype",wd=vd.set,kd=vd.getterFor(md),_d=Object[bd],xd=Al.Symbol,Ed=xd&&xd[bd],Od=Al.RangeError,Cd=Al.TypeError,Sd=Al.QObject,Td=ed.f,Md=id.f,Pd=Jl.f,Dd=od.f,Id=Rl([].push),Bd=ad("symbols"),Nd=ad("op-symbols"),Fd=ad("wks"),zd=!Sd||!Sd[bd]||!Sd[bd].findChild,Ad=function Ad(t,e,i){var n=Td(_d,e);n&&delete _d[e],Md(t,e,i),n&&t!==_d&&Md(_d,e,n);},jd=Ll&&Wl(function(){return 7!==$l(Md({},"a",{get:function get(){return Md(this,"a",{value:7}).a;}})).a;})?Ad:Md,Rd=function Rd(t,e){var i=Bd[t]=$l(Ed);return wd(i,{type:md,tag:t,description:e}),Ll||(i.description=e),i;},Ld=function Ld(t,e,i){t===_d&&Ld(Nd,e,i),Ul(t);var n=Xl(e);return Ul(i),ql(Bd,n)?(i.enumerable?(ql(t,yd)&&t[yd][n]&&(t[yd][n]=!1),i=$l(i,{enumerable:Kl(0,!1)})):(ql(t,yd)||Md(t,yd,Kl(1,{})),t[yd][n]=!0),jd(t,n,i)):Md(t,n,i);},Hd=function Hd(t,e){Ul(t);var i=Yl(e),n=Zl(i).concat(Ud(i));return gd(n,function(e){Ll&&!jl(Wd,i,e)||Ld(t,e,i[e]);}),t;},Wd=function Wd(t){var e=Xl(t),i=jl(Dd,this,e);return!(this===_d&&ql(Bd,e)&&!ql(Nd,e))&&(!(i||!ql(this,e)||!ql(Bd,e)||ql(this,yd)&&this[yd][e])||i);},qd=function qd(t,e){var i=Yl(t),n=Xl(e);if(i!==_d||!ql(Bd,n)||ql(Nd,n)){var o=Td(i,n);return!o||!ql(Bd,n)||ql(i,yd)&&i[yd][n]||(o.enumerable=!0),o;}},Vd=function Vd(t){var e=Pd(Yl(t)),i=[];return gd(e,function(t){ql(Bd,t)||ql(hd,t)||Id(i,t);}),i;},Ud=function Ud(t){var e=t===_d,i=Pd(e?Nd:Yl(t)),n=[];return gd(i,function(t){!ql(Bd,t)||e&&!ql(_d,t)||Id(n,Bd[t]);}),n;};Hl||(xd=function xd(){if(Vl(Ed,this))throw new Cd("Symbol is not a constructor");var t=arguments.length&&void 0!==arguments[0]?Gl(arguments[0]):void 0,e=ld(t),i=function i(t){this===_d&&jl(i,Nd,t),ql(this,yd)&&ql(this[yd],e)&&(this[yd][e]=!1);var n=Kl(1,t);try{jd(this,e,n);}catch(t){if(!(t instanceof Od))throw t;Ad(this,e,n);}};return Ll&&zd&&jd(_d,e,{configurable:!0,set:i}),Rd(e,t);},rd(Ed=xd[bd],"toString",function(){return kd(this).tag;}),rd(xd,"withoutSetter",function(t){return Rd(ld(t),t);}),od.f=Wd,id.f=Ld,nd.f=Hd,ed.f=qd,Ql.f=Jl.f=Vd,td.f=Ud,cd.f=function(t){return Rd(dd(t),t);},Ll&&sd(Ed,"description",{configurable:!0,get:function get(){return kd(this).description;}})),zl({global:!0,constructor:!0,wrap:!0,forced:!Hl,sham:!Hl},{Symbol:xd}),gd(Zl(Fd),function(t){ud(t);}),zl({target:md,stat:!0,forced:!Hl},{useSetter:function useSetter(){zd=!0;},useSimple:function useSimple(){zd=!1;}}),zl({target:"Object",stat:!0,forced:!Hl,sham:!Ll},{create:function create(t,e){return void 0===e?$l(t):Hd($l(t),e);},defineProperty:Ld,defineProperties:Hd,getOwnPropertyDescriptor:qd}),zl({target:"Object",stat:!0,forced:!Hl},{getOwnPropertyNames:Vd}),fd(),pd(xd,md),hd[yd]=!0;var Yd=bt&&!!Symbol["for"]&&!!Symbol.keyFor,Xd=Ti,Gd=st,Kd=Qt,$d=co,Zd=Yt,Qd=Yd,Jd=Zd("string-to-symbol-registry"),tc=Zd("symbol-to-string-registry");Xd({target:"Symbol",stat:!0,forced:!Qd},{"for":function _for(t){var e=$d(t);if(Kd(Jd,e))return Jd[e];var i=Gd("Symbol")(e);return Jd[e]=i,tc[i]=e,i;}});var ec=Ti,ic=Qt,nc=Ot,oc=St,rc=Yd,sc=Yt("symbol-to-string-registry");ec({target:"Symbol",stat:!0,forced:!rc},{keyFor:function keyFor(t){if(!nc(t))throw new TypeError(oc(t)+" is not a symbol");if(ic(sc,t))return sc[t];}});var ac=Oh,hc=S,lc=w,dc=co,cc=g([].push),uc=Ti,fc=st,pc=c,vc=I,gc=g,yc=r,mc=S,bc=Ot,wc=wn,kc=function kc(t){if(hc(t))return t;if(ac(t)){for(var e=t.length,i=[],n=0;n<e;n++){var o=t[n];"string"==typeof o?cc(i,o):"number"!=typeof o&&"Number"!==lc(o)&&"String"!==lc(o)||cc(i,dc(o));}var r=i.length,s=!0;return function(t,e){if(s)return s=!1,e;if(ac(this))return e;for(var n=0;n<r;n++)if(i[n]===t)return e;};}},_c=bt,xc=String,Ec=fc("JSON","stringify"),Oc=gc(/./.exec),Cc=gc("".charAt),Sc=gc("".charCodeAt),Tc=gc("".replace),Mc=gc(1..toString),Pc=/[\uD800-\uDFFF]/g,Dc=/^[\uD800-\uDBFF]$/,Ic=/^[\uDC00-\uDFFF]$/,Bc=!_c||yc(function(){var t=fc("Symbol")("stringify detection");return"[null]"!==Ec([t])||"{}"!==Ec({a:t})||"{}"!==Ec(Object(t));}),Nc=yc(function(){return"\"\\udf06\\ud834\""!==Ec("\uDF06\uD834")||"\"\\udead\""!==Ec("\uDEAD");}),Fc=function Fc(t,e){var i=wc(arguments),n=kc(e);if(mc(n)||void 0!==t&&!bc(t))return i[1]=function(t,e){if(mc(n)&&(e=vc(n,this,xc(t),e)),!bc(e))return e;},pc(Ec,null,i);},zc=function zc(t,e,i){var n=Cc(i,e-1),o=Cc(i,e+1);return Oc(Dc,t)&&!Oc(Ic,o)||Oc(Ic,t)&&!Oc(Dc,n)?"\\u"+Mc(Sc(t,0),16):t;};Ec&&uc({target:"JSON",stat:!0,arity:3,forced:Bc||Nc},{stringify:function stringify(t,e,i){var n=wc(arguments),o=pc(Bc?Fc:Ec,null,n);return Nc&&"string"==typeof o?Tc(o,Pc,zc):o;}});var Ac=on,jc=Kt;Ti({target:"Object",stat:!0,forced:!bt||r(function(){Ac.f(1);})},{getOwnPropertySymbols:function getOwnPropertySymbols(t){var e=Ac.f;return e?e(jc(t)):[];}}),_l("asyncIterator"),_l("hasInstance"),_l("isConcatSpreadable"),_l("iterator"),_l("match"),_l("matchAll"),_l("replace"),_l("search"),_l("species"),_l("split");var Rc=Sl;_l("toPrimitive"),Rc();var Lc=st,Hc=Gr;_l("toStringTag"),Hc(Lc("Symbol"),"Symbol"),_l("unscopables"),Gr(o.JSON,"JSON",!0);var Wc=et.Symbol,qc=ue,Vc=Ze.f,Uc=qc("metadata"),Yc=Function.prototype;void 0===Yc[Uc]&&Vc(Yc,Uc,{value:null}),_l("asyncDispose"),_l("dispose"),_l("metadata");var Xc=Wc,Gc=g,Kc=st("Symbol"),$c=Kc.keyFor,Zc=Gc(Kc.prototype.valueOf),Qc=Kc.isRegisteredSymbol||function(t){try{return void 0!==$c(Zc(t));}catch(t){return!1;}};Ti({target:"Symbol",stat:!0},{isRegisteredSymbol:Qc});for(var Jc=Yt,tu=st,eu=g,iu=Ot,nu=ue,ou=tu("Symbol"),ru=ou.isWellKnownSymbol,su=tu("Object","getOwnPropertyNames"),au=eu(ou.prototype.valueOf),hu=Jc("wks"),lu=0,du=su(ou),cu=du.length;lu<cu;lu++)try{var uu=du[lu];iu(ou[uu])&&nu(uu);}catch(t){}var fu=function fu(t){if(ru&&ru(t))return!0;try{for(var e=au(t),i=0,n=su(hu),o=n.length;i<o;i++)if(hu[n[i]]==e)return!0;}catch(t){}return!1;};Ti({target:"Symbol",stat:!0,forced:!0},{isWellKnownSymbol:fu}),_l("matcher"),_l("observable"),Ti({target:"Symbol",stat:!0,name:"isRegisteredSymbol"},{isRegistered:Qc}),Ti({target:"Symbol",stat:!0,name:"isWellKnownSymbol",forced:!0},{isWellKnown:fu}),_l("metadataKey"),_l("patternMatch"),_l("replaceAll");var pu=Xc,vu=i(pu),gu=gl.f("iterator"),yu=gu,mu=i(yu);function bu(t){return bu="function"==typeof vu&&"symbol"==_typeof(mu)?function(t){return _typeof(t);}:function(t){return t&&"function"==typeof vu&&t.constructor===vu&&t!==vu.prototype?"symbol":_typeof(t);},bu(t);}var wu=i(gl.f("toPrimitive"));function ku(t){var e=function(t,e){if("object"!==bu(t)||null===t)return t;var i=t[wu];if(void 0!==i){var n=i.call(t,e||"default");if("object"!==bu(n))return n;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===e?String:Number)(t);}(t,"string");return"symbol"===bu(e)?e:String(e);}function _u(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),xh(t,ku(n.key),n);}}function xu(t,e,i){return e&&_u(t.prototype,e),i&&_u(t,i),xh(t,"prototype",{writable:!1}),t;}Ti({target:"Array",stat:!0},{isArray:Oh});var Eu=et.Array.isArray,Ou=i(Eu);var Cu=M,Su=Oh,Tu=TypeError,Mu=Object.getOwnPropertyDescriptor,Pu=Cu&&!function(){if(void 0!==this)return!0;try{Object.defineProperty([],"length",{writable:!1}).length=1;}catch(t){return t instanceof TypeError;}}()?function(t,e){if(Su(t)&&!Mu(t,"length").writable)throw new Tu("Cannot set read only .length");return t.length=e;}:function(t,e){return t.length=e;},Du=Kt,Iu=Li,Bu=Pu,Nu=Sh;Ti({target:"Array",proto:!0,arity:1,forced:r(function(){return 4294967297!==[].push.call({length:4294967296},1);})||!function(){try{Object.defineProperty([],"length",{writable:!1}).push();}catch(t){return t instanceof TypeError;}}()},{push:function push(t){var e=Du(this),i=Iu(e),n=arguments.length;Nu(i+n);for(var o=0;o<n;o++)e[i]=arguments[o],i++;return Bu(e,i),i;}});var Fu=Nn("Array").push,zu=at,Au=Fu,ju=Array.prototype,Ru=function Ru(t){var e=t.push;return t===ju||zu(ju,t)&&e===ju.push?Au:e;},Lu=Ru,Hu=i(Lu);var Wu=Ti,qu=Oh,Vu=da,Uu=tt,Yu=zi,Xu=Li,Gu=Z,Ku=pa,$u=ue,Zu=wn,Qu=jh("slice"),Ju=$u("species"),tf=Array,ef=Math.max;Wu({target:"Array",proto:!0,forced:!Qu},{slice:function slice(t,e){var i,n,o,r=Gu(this),s=Xu(r),a=Yu(t,s),h=Yu(void 0===e?s:e,s);if(qu(r)&&(i=r.constructor,(Vu(i)&&(i===tf||qu(i.prototype))||Uu(i)&&null===(i=i[Ju]))&&(i=void 0),i===tf||void 0===i))return Zu(r,a,h);for(n=new(void 0===i?tf:i)(ef(h-a,0)),o=0;a<h;a++,o++)a in r&&Ku(n,o,r[a]);return n.length=o,n;}});var nf=Nn("Array").slice,of=at,rf=nf,sf=Array.prototype,af=function af(t){var e=t.slice;return t===sf||of(sf,t)&&e===sf.slice?rf:e;},hf=af,lf=hf,df=i(lf),cf=i(Ua);function uf(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}function ff(t,e){var i;if(t){if("string"==typeof t)return uf(t,e);var n=df(i=Object.prototype.toString.call(t)).call(i,8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?cf(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?uf(t,e):void 0;}}function pf(t,e){return function(t){if(Ou(t))return t;}(t)||function(t,e){var i=null==t?null:void 0!==vu&&uh(t)||t["@@iterator"];if(null!=i){var n,o,r,s,a=[],h=!0,l=!1;try{if(r=(i=i.call(t)).next,0===e){if(Object(i)!==i)return;h=!1;}else for(;!(h=(n=r.call(i)).done)&&(Hu(a).call(a,n.value),a.length!==e);h=!0);}catch(t){l=!0,o=t;}finally{try{if(!h&&null!=i["return"]&&(s=i["return"](),Object(s)!==s))return;}finally{if(l)throw o;}}return a;}}(t,e)||ff(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}function vf(t){return function(t){if(Ou(t))return uf(t);}(t)||function(t){if(void 0!==vu&&null!=uh(t)||null!=t["@@iterator"])return cf(t);}(t)||ff(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}var gf=i(Wc),yf=Nn("Array").concat,mf=at,bf=yf,wf=Array.prototype,kf=function kf(t){var e=t.concat;return t===wf||mf(wf,t)&&e===wf.concat?bf:e;},_f=i(kf),xf=i(hf),Ef=st,Of=Jh,Cf=on,Sf=ii,Tf=g([].concat),Mf=Ef("Reflect","ownKeys")||function(t){var e=Of.f(Sf(t)),i=Cf.f;return i?Tf(e,i(t)):e;};Ti({target:"Reflect",stat:!0},{ownKeys:Mf});var Pf=i(et.Reflect.ownKeys),Df=i(Eu),If=Fl.map;Ti({target:"Array",proto:!0,forced:!jh("map")},{map:function map(t){return If(this,t,arguments.length>1?arguments[1]:void 0);}});var Bf=Nn("Array").map,Nf=at,Ff=Bf,zf=Array.prototype,Af=function Af(t){var e=t.map;return t===zf||Nf(zf,t)&&e===zf.map?Ff:e;},jf=i(Af),Rf=Kt,Lf=nn;Ti({target:"Object",stat:!0,forced:r(function(){Lf(1);})},{keys:function keys(t){return Lf(Rf(t));}});var Hf=i(et.Object.keys),Wf=Ti,qf=Date,Vf=g(qf.prototype.getTime);Wf({target:"Date",stat:!0},{now:function now(){return Vf(new qf());}});var Uf=i(et.Date.now),Yf=r,Xf=function Xf(t,e){var i=[][t];return!!i&&Yf(function(){i.call(null,e||function(){return 1;},1);});},Gf=Fl.forEach,Kf=Xf("forEach")?[].forEach:function(t){return Gf(this,t,arguments.length>1?arguments[1]:void 0);};Ti({target:"Array",proto:!0,forced:[].forEach!==Kf},{forEach:Kf});var $f=Nn("Array").forEach,Zf=ao,Qf=Qt,Jf=at,tp=$f,ep=Array.prototype,ip={DOMTokenList:!0,NodeList:!0},np=function np(t){var e=t.forEach;return t===ep||Jf(ep,t)&&e===ep.forEach||Qf(ip,Zf(t))?tp:e;},op=i(np),rp=Ti,sp=Oh,ap=g([].reverse),hp=[1,2];rp({target:"Array",proto:!0,forced:String(hp)===String(hp.reverse())},{reverse:function reverse(){return sp(this)&&(this.length=this.length),ap(this);}});var lp=Nn("Array").reverse,dp=at,cp=lp,up=Array.prototype,fp=function fp(t){var e=t.reverse;return t===up||dp(up,t)&&e===up.reverse?cp:e;},pp=fp,vp=i(pp),gp=St,yp=TypeError,mp=function mp(t,e){if(!delete t[e])throw new yp("Cannot delete property "+gp(e)+" of "+gp(t));},bp=Ti,wp=Kt,kp=zi,_p=Ii,xp=Li,Ep=Pu,Op=Sh,Cp=Nh,Sp=pa,Tp=mp,Mp=jh("splice"),Pp=Math.max,Dp=Math.min;bp({target:"Array",proto:!0,forced:!Mp},{splice:function splice(t,e){var i,n,o,r,s,a,h=wp(this),l=xp(h),d=kp(t,l),c=arguments.length;for(0===c?i=n=0:1===c?(i=0,n=l-d):(i=c-2,n=Dp(Pp(_p(e),0),l-d)),Op(l+i-n),o=Cp(h,n),r=0;r<n;r++)(s=d+r)in h&&Sp(o,r,h[s]);if(o.length=n,i<n){for(r=d;r<l-n;r++)a=r+i,(s=r+n)in h?h[a]=h[s]:Tp(h,a);for(r=l;r>l-n+i;r--)Tp(h,r-1);}else if(i>n)for(r=l-n;r>d;r--)a=r+i-1,(s=r+n-1)in h?h[a]=h[s]:Tp(h,a);for(r=0;r<i;r++)h[r+d]=arguments[r+2];return Ep(h,l-n+i),o;}});var Ip=Nn("Array").splice,Bp=at,Np=Ip,Fp=Array.prototype,zp=function zp(t){var e=t.splice;return t===Fp||Bp(Fp,t)&&e===Fp.splice?Np:e;},Ap=i(zp),jp=Ui.includes;Ti({target:"Array",proto:!0,forced:r(function(){return!Array(1).includes();})},{includes:function includes(t){return jp(this,t,arguments.length>1?arguments[1]:void 0);}});var Rp=Nn("Array").includes,Lp=tt,Hp=w,Wp=ue("match"),qp=function qp(t){var e;return Lp(t)&&(void 0!==(e=t[Wp])?!!e:"RegExp"===Hp(t));},Vp=TypeError,Up=ue("match"),Yp=Ti,Xp=function Xp(t){if(qp(t))throw new Vp("The method doesn't accept regular expressions");return t;},Gp=G,Kp=co,$p=function $p(t){var e=/./;try{"/./"[t](e);}catch(i){try{return e[Up]=!1,"/./"[t](e);}catch(t){}}return!1;},Zp=g("".indexOf);Yp({target:"String",proto:!0,forced:!$p("includes")},{includes:function includes(t){return!!~Zp(Kp(Gp(this)),Kp(Xp(t)),arguments.length>1?arguments[1]:void 0);}});var Qp=Nn("String").includes,Jp=at,tv=Rp,ev=Qp,iv=Array.prototype,nv=String.prototype,ov=function ov(t){var e=t.includes;return t===iv||Jp(iv,t)&&e===iv.includes?tv:"string"==typeof t||t===nv||Jp(nv,t)&&e===nv.includes?ev:e;},rv=i(ov),sv=Kt,av=Sr,hv=br;Ti({target:"Object",stat:!0,forced:r(function(){av(1);}),sham:!hv},{getPrototypeOf:function getPrototypeOf(t){return av(sv(t));}});var lv=et.Object.getPrototypeOf,dv=i(lv),cv=Fl.filter;Ti({target:"Array",proto:!0,forced:!jh("filter")},{filter:function filter(t){return cv(this,t,arguments.length>1?arguments[1]:void 0);}});var uv=Nn("Array").filter,fv=at,pv=uv,vv=Array.prototype,gv=function gv(t){var e=t.filter;return t===vv||fv(vv,t)&&e===vv.filter?pv:e;},yv=i(gv),mv=M,bv=r,wv=g,kv=Sr,_v=nn,xv=Z,Ev=wv(B.f),Ov=wv([].push),Cv=mv&&bv(function(){var t=Object.create(null);return t[2]=2,!Ev(t,2);}),Sv=function Sv(t){return function(e){for(var i,n=xv(e),o=_v(n),r=Cv&&null===kv(n),s=o.length,a=0,h=[];s>a;)i=o[a++],mv&&!(r?i in n:Ev(n,i))||Ov(h,t?[i,n[i]]:n[i]);return h;};},Tv={entries:Sv(!0),values:Sv(!1)},Mv=Tv.values;Ti({target:"Object",stat:!0},{values:function values(t){return Mv(t);}});var Pv=i(et.Object.values),Dv="\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",Iv=G,Bv=co,Nv=Dv,Fv=g("".replace),zv=RegExp("^["+Nv+"]+"),Av=RegExp("(^|[^"+Nv+"])["+Nv+"]+$"),jv=function jv(t){return function(e){var i=Bv(Iv(e));return 1&t&&(i=Fv(i,zv,"")),2&t&&(i=Fv(i,Av,"$1")),i;};},Rv={start:jv(1),end:jv(2),trim:jv(3)},Lv=o,Hv=r,Wv=g,qv=co,Vv=Rv.trim,Uv=Dv,Yv=Lv.parseInt,Xv=Lv.Symbol,Gv=Xv&&Xv.iterator,Kv=/^[+-]?0x/i,$v=Wv(Kv.exec),Zv=8!==Yv(Uv+"08")||22!==Yv(Uv+"0x16")||Gv&&!Hv(function(){Yv(Object(Gv));})?function(t,e){var i=Vv(qv(t));return Yv(i,e>>>0||($v(Kv,i)?16:10));}:Yv;Ti({global:!0,forced:parseInt!==Zv},{parseInt:Zv});var Qv=i(et.parseInt),Jv=Ti,tg=Ui.indexOf,eg=Xf,ig=x([].indexOf),ng=!!ig&&1/ig([1],1,-0)<0;Jv({target:"Array",proto:!0,forced:ng||!eg("indexOf")},{indexOf:function indexOf(t){var e=arguments.length>1?arguments[1]:void 0;return ng?ig(this,t,e)||0:tg(this,t,e);}});var og=Nn("Array").indexOf,rg=at,sg=og,ag=Array.prototype,hg=function hg(t){var e=t.indexOf;return t===ag||rg(ag,t)&&e===ag.indexOf?sg:e;},lg=i(hg),dg=Tv.entries;Ti({target:"Object",stat:!0},{entries:function entries(t){return dg(t);}});var cg=i(et.Object.entries);Ti({target:"Object",stat:!0,sham:!M},{create:mr});var ug=et.Object,fg=function fg(t,e){return ug.create(t,e);},pg=i(fg),vg=et,gg=c;vg.JSON||(vg.JSON={stringify:JSON.stringify});var yg=function yg(t,e,i){return gg(vg.JSON.stringify,null,arguments);},mg=i(yg),bg="function"==typeof Bun&&Bun&&"string"==typeof Bun.version,wg=TypeError,kg=function kg(t,e){if(t<e)throw new wg("Not enough arguments");return t;},_g=o,xg=c,Eg=S,Og=bg,Cg=ht,Sg=wn,Tg=kg,Mg=_g.Function,Pg=/MSIE .\./.test(Cg)||Og&&function(){var t=_g.Bun.version.split(".");return t.length<3||"0"===t[0]&&(t[1]<3||"3"===t[1]&&"0"===t[2]);}(),Dg=function Dg(t,e){var i=e?2:1;return Pg?function(n,o){var r=Tg(arguments.length,1)>i,s=Eg(n)?n:Mg(n),a=r?Sg(arguments,i):[],h=r?function(){xg(s,this,a);}:s;return e?t(h,o):t(h);}:t;},Ig=Ti,Bg=o,Ng=Dg(Bg.setInterval,!0);Ig({global:!0,bind:!0,forced:Bg.setInterval!==Ng},{setInterval:Ng});var Fg=Ti,zg=o,Ag=Dg(zg.setTimeout,!0);Fg({global:!0,bind:!0,forced:zg.setTimeout!==Ag},{setTimeout:Ag});var jg=i(et.setTimeout),Rg=Kt,Lg=zi,Hg=Li,Wg=function Wg(t){for(var e=Rg(this),i=Hg(e),n=arguments.length,o=Lg(n>1?arguments[1]:void 0,i),r=n>2?arguments[2]:void 0,s=void 0===r?i:Lg(r,i);s>o;)e[o++]=t;return e;};Ti({target:"Array",proto:!0},{fill:Wg});var qg,Vg=Nn("Array").fill,Ug=at,Yg=Vg,Xg=Array.prototype,Gg=function Gg(t){var e=t.fill;return t===Xg||Ug(Xg,t)&&e===Xg.fill?Yg:e;},Kg=i(Gg);function $g(){return $g=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(t[n]=i[n]);}return t;},$g.apply(this,arguments);}function Zg(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,t.__proto__=e;}function Qg(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;}qg="function"!=typeof Object.assign?function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),i=1;i<arguments.length;i++){var n=arguments[i];if(null!=n)for(var o in n)n.hasOwnProperty(o)&&(e[o]=n[o]);}return e;}:Object.assign;var Jg,ty=qg,ey=["","webkit","Moz","MS","ms","o"],iy="undefined"==typeof document?{style:{}}:document.createElement("div"),ny=Math.round,oy=Math.abs,ry=Date.now;function sy(t,e){for(var i,n,o=e[0].toUpperCase()+e.slice(1),r=0;r<ey.length;){if((n=(i=ey[r])?i+o:e)in t)return n;r++;}}Jg="undefined"==typeof window?{}:window;var ay=sy(iy.style,"touchAction"),hy=void 0!==ay;var ly="compute",dy="auto",cy="manipulation",uy="none",fy="pan-x",py="pan-y",vy=function(){if(!hy)return!1;var t={},e=Jg.CSS&&Jg.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(i){return t[i]=!e||Jg.CSS.supports("touch-action",i);}),t;}(),gy=("ontouchstart"in Jg),yy=void 0!==sy(Jg,"PointerEvent"),my=gy&&/mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),by="touch",wy="mouse",ky=25,_y=1,xy=4,Ey=8,Oy=1,Cy=2,Sy=4,Ty=8,My=16,Py=Cy|Sy,Dy=Ty|My,Iy=Py|Dy,By=["x","y"],Ny=["clientX","clientY"];function Fy(t,e,i){var n;if(t)if(t.forEach)t.forEach(e,i);else if(void 0!==t.length)for(n=0;n<t.length;)e.call(i,t[n],n,t),n++;else for(n in t)t.hasOwnProperty(n)&&e.call(i,t[n],n,t);}function zy(t,e){return"function"==typeof t?t.apply(e&&e[0]||void 0,e):t;}function Ay(t,e){return t.indexOf(e)>-1;}var jy=function(){function t(t,e){this.manager=t,this.set(e);}var e=t.prototype;return e.set=function(t){t===ly&&(t=this.compute()),hy&&this.manager.element.style&&vy[t]&&(this.manager.element.style[ay]=t),this.actions=t.toLowerCase().trim();},e.update=function(){this.set(this.manager.options.touchAction);},e.compute=function(){var t=[];return Fy(this.manager.recognizers,function(e){zy(e.options.enable,[e])&&(t=t.concat(e.getTouchAction()));}),function(t){if(Ay(t,uy))return uy;var e=Ay(t,fy),i=Ay(t,py);return e&&i?uy:e||i?e?fy:py:Ay(t,cy)?cy:dy;}(t.join(" "));},e.preventDefaults=function(t){var e=t.srcEvent,i=t.offsetDirection;if(this.manager.session.prevented)e.preventDefault();else{var n=this.actions,o=Ay(n,uy)&&!vy[uy],r=Ay(n,py)&&!vy[py],s=Ay(n,fy)&&!vy[fy];if(o){var a=1===t.pointers.length,h=t.distance<2,l=t.deltaTime<250;if(a&&h&&l)return;}if(!s||!r)return o||r&&i&Py||s&&i&Dy?this.preventSrc(e):void 0;}},e.preventSrc=function(t){this.manager.session.prevented=!0,t.preventDefault();},t;}();function Ry(t,e){for(;t;){if(t===e)return!0;t=t.parentNode;}return!1;}function Ly(t){var e=t.length;if(1===e)return{x:ny(t[0].clientX),y:ny(t[0].clientY)};for(var i=0,n=0,o=0;o<e;)i+=t[o].clientX,n+=t[o].clientY,o++;return{x:ny(i/e),y:ny(n/e)};}function Hy(t){for(var e=[],i=0;i<t.pointers.length;)e[i]={clientX:ny(t.pointers[i].clientX),clientY:ny(t.pointers[i].clientY)},i++;return{timeStamp:ry(),pointers:e,center:Ly(e),deltaX:t.deltaX,deltaY:t.deltaY};}function Wy(t,e,i){i||(i=By);var n=e[i[0]]-t[i[0]],o=e[i[1]]-t[i[1]];return Math.sqrt(n*n+o*o);}function qy(t,e,i){i||(i=By);var n=e[i[0]]-t[i[0]],o=e[i[1]]-t[i[1]];return 180*Math.atan2(o,n)/Math.PI;}function Vy(t,e){return t===e?Oy:oy(t)>=oy(e)?t<0?Cy:Sy:e<0?Ty:My;}function Uy(t,e,i){return{x:e/t||0,y:i/t||0};}function Yy(t,e){var i=t.session,n=e.pointers,o=n.length;i.firstInput||(i.firstInput=Hy(e)),o>1&&!i.firstMultiple?i.firstMultiple=Hy(e):1===o&&(i.firstMultiple=!1);var r=i.firstInput,s=i.firstMultiple,a=s?s.center:r.center,h=e.center=Ly(n);e.timeStamp=ry(),e.deltaTime=e.timeStamp-r.timeStamp,e.angle=qy(a,h),e.distance=Wy(a,h),function(t,e){var i=e.center,n=t.offsetDelta||{},o=t.prevDelta||{},r=t.prevInput||{};e.eventType!==_y&&r.eventType!==xy||(o=t.prevDelta={x:r.deltaX||0,y:r.deltaY||0},n=t.offsetDelta={x:i.x,y:i.y}),e.deltaX=o.x+(i.x-n.x),e.deltaY=o.y+(i.y-n.y);}(i,e),e.offsetDirection=Vy(e.deltaX,e.deltaY);var l,d,c=Uy(e.deltaTime,e.deltaX,e.deltaY);e.overallVelocityX=c.x,e.overallVelocityY=c.y,e.overallVelocity=oy(c.x)>oy(c.y)?c.x:c.y,e.scale=s?(l=s.pointers,Wy((d=n)[0],d[1],Ny)/Wy(l[0],l[1],Ny)):1,e.rotation=s?function(t,e){return qy(e[1],e[0],Ny)+qy(t[1],t[0],Ny);}(s.pointers,n):0,e.maxPointers=i.prevInput?e.pointers.length>i.prevInput.maxPointers?e.pointers.length:i.prevInput.maxPointers:e.pointers.length,function(t,e){var i,n,o,r,s=t.lastInterval||e,a=e.timeStamp-s.timeStamp;if(e.eventType!==Ey&&(a>ky||void 0===s.velocity)){var h=e.deltaX-s.deltaX,l=e.deltaY-s.deltaY,d=Uy(a,h,l);n=d.x,o=d.y,i=oy(d.x)>oy(d.y)?d.x:d.y,r=Vy(h,l),t.lastInterval=e;}else i=s.velocity,n=s.velocityX,o=s.velocityY,r=s.direction;e.velocity=i,e.velocityX=n,e.velocityY=o,e.direction=r;}(i,e);var u,f=t.element,p=e.srcEvent;Ry(u=p.composedPath?p.composedPath()[0]:p.path?p.path[0]:p.target,f)&&(f=u),e.target=f;}function Xy(t,e,i){var n=i.pointers.length,o=i.changedPointers.length,r=e&_y&&n-o==0,s=e&(xy|Ey)&&n-o==0;i.isFirst=!!r,i.isFinal=!!s,r&&(t.session={}),i.eventType=e,Yy(t,i),t.emit("hammer.input",i),t.recognize(i),t.session.prevInput=i;}function Gy(t){return t.trim().split(/\s+/g);}function Ky(t,e,i){Fy(Gy(e),function(e){t.addEventListener(e,i,!1);});}function $y(t,e,i){Fy(Gy(e),function(e){t.removeEventListener(e,i,!1);});}function Zy(t){var e=t.ownerDocument||t;return e.defaultView||e.parentWindow||window;}var Qy=function(){function t(t,e){var i=this;this.manager=t,this.callback=e,this.element=t.element,this.target=t.options.inputTarget,this.domHandler=function(e){zy(t.options.enable,[t])&&i.handler(e);},this.init();}var e=t.prototype;return e.handler=function(){},e.init=function(){this.evEl&&Ky(this.element,this.evEl,this.domHandler),this.evTarget&&Ky(this.target,this.evTarget,this.domHandler),this.evWin&&Ky(Zy(this.element),this.evWin,this.domHandler);},e.destroy=function(){this.evEl&&$y(this.element,this.evEl,this.domHandler),this.evTarget&&$y(this.target,this.evTarget,this.domHandler),this.evWin&&$y(Zy(this.element),this.evWin,this.domHandler);},t;}();function Jy(t,e,i){if(t.indexOf&&!i)return t.indexOf(e);for(var n=0;n<t.length;){if(i&&t[n][i]==e||!i&&t[n]===e)return n;n++;}return-1;}var tm={pointerdown:_y,pointermove:2,pointerup:xy,pointercancel:Ey,pointerout:Ey},em={2:by,3:"pen",4:wy,5:"kinect"},im="pointerdown",nm="pointermove pointerup pointercancel";Jg.MSPointerEvent&&!Jg.PointerEvent&&(im="MSPointerDown",nm="MSPointerMove MSPointerUp MSPointerCancel");var om=function(t){function e(){var i,n=e.prototype;return n.evEl=im,n.evWin=nm,(i=t.apply(this,arguments)||this).store=i.manager.session.pointerEvents=[],i;}return Zg(e,t),e.prototype.handler=function(t){var e=this.store,i=!1,n=t.type.toLowerCase().replace("ms",""),o=tm[n],r=em[t.pointerType]||t.pointerType,s=r===by,a=Jy(e,t.pointerId,"pointerId");o&_y&&(0===t.button||s)?a<0&&(e.push(t),a=e.length-1):o&(xy|Ey)&&(i=!0),a<0||(e[a]=t,this.callback(this.manager,o,{pointers:e,changedPointers:[t],pointerType:r,srcEvent:t}),i&&e.splice(a,1));},e;}(Qy);function rm(t){return Array.prototype.slice.call(t,0);}function sm(t,e,i){for(var n=[],o=[],r=0;r<t.length;){var s=e?t[r][e]:t[r];Jy(o,s)<0&&n.push(t[r]),o[r]=s,r++;}return i&&(n=e?n.sort(function(t,i){return t[e]>i[e];}):n.sort()),n;}var am={touchstart:_y,touchmove:2,touchend:xy,touchcancel:Ey},hm=function(t){function e(){var i;return e.prototype.evTarget="touchstart touchmove touchend touchcancel",(i=t.apply(this,arguments)||this).targetIds={},i;}return Zg(e,t),e.prototype.handler=function(t){var e=am[t.type],i=lm.call(this,t,e);i&&this.callback(this.manager,e,{pointers:i[0],changedPointers:i[1],pointerType:by,srcEvent:t});},e;}(Qy);function lm(t,e){var i,n,o=rm(t.touches),r=this.targetIds;if(e&(2|_y)&&1===o.length)return r[o[0].identifier]=!0,[o,o];var s=rm(t.changedTouches),a=[],h=this.target;if(n=o.filter(function(t){return Ry(t.target,h);}),e===_y)for(i=0;i<n.length;)r[n[i].identifier]=!0,i++;for(i=0;i<s.length;)r[s[i].identifier]&&a.push(s[i]),e&(xy|Ey)&&delete r[s[i].identifier],i++;return a.length?[sm(n.concat(a),"identifier",!0),a]:void 0;}var dm={mousedown:_y,mousemove:2,mouseup:xy},cm=function(t){function e(){var i,n=e.prototype;return n.evEl="mousedown",n.evWin="mousemove mouseup",(i=t.apply(this,arguments)||this).pressed=!1,i;}return Zg(e,t),e.prototype.handler=function(t){var e=dm[t.type];e&_y&&0===t.button&&(this.pressed=!0),2&e&&1!==t.which&&(e=xy),this.pressed&&(e&xy&&(this.pressed=!1),this.callback(this.manager,e,{pointers:[t],changedPointers:[t],pointerType:wy,srcEvent:t}));},e;}(Qy),um=2500;function fm(t){var e=t.changedPointers[0];if(e.identifier===this.primaryTouch){var i={x:e.clientX,y:e.clientY},n=this.lastTouches;this.lastTouches.push(i);setTimeout(function(){var t=n.indexOf(i);t>-1&&n.splice(t,1);},um);}}function pm(t,e){t&_y?(this.primaryTouch=e.changedPointers[0].identifier,fm.call(this,e)):t&(xy|Ey)&&fm.call(this,e);}function vm(t){for(var e=t.srcEvent.clientX,i=t.srcEvent.clientY,n=0;n<this.lastTouches.length;n++){var o=this.lastTouches[n],r=Math.abs(e-o.x),s=Math.abs(i-o.y);if(r<=25&&s<=25)return!0;}return!1;}var gm=function(){return function(t){function e(e,i){var n;return(n=t.call(this,e,i)||this).handler=function(t,e,i){var o=i.pointerType===by,r=i.pointerType===wy;if(!(r&&i.sourceCapabilities&&i.sourceCapabilities.firesTouchEvents)){if(o)pm.call(Qg(Qg(n)),e,i);else if(r&&vm.call(Qg(Qg(n)),i))return;n.callback(t,e,i);}},n.touch=new hm(n.manager,n.handler),n.mouse=new cm(n.manager,n.handler),n.primaryTouch=null,n.lastTouches=[],n;}return Zg(e,t),e.prototype.destroy=function(){this.touch.destroy(),this.mouse.destroy();},e;}(Qy);}();function ym(t,e,i){return!!Array.isArray(t)&&(Fy(t,i[e],i),!0);}var mm=32,bm=1;function wm(t,e){var i=e.manager;return i?i.get(t):t;}function km(t){return 16&t?"cancel":8&t?"end":4&t?"move":2&t?"start":"";}var _m=function(){function t(t){void 0===t&&(t={}),this.options=$g({enable:!0},t),this.id=bm++,this.manager=null,this.state=1,this.simultaneous={},this.requireFail=[];}var e=t.prototype;return e.set=function(t){return ty(this.options,t),this.manager&&this.manager.touchAction.update(),this;},e.recognizeWith=function(t){if(ym(t,"recognizeWith",this))return this;var e=this.simultaneous;return e[(t=wm(t,this)).id]||(e[t.id]=t,t.recognizeWith(this)),this;},e.dropRecognizeWith=function(t){return ym(t,"dropRecognizeWith",this)||(t=wm(t,this),delete this.simultaneous[t.id]),this;},e.requireFailure=function(t){if(ym(t,"requireFailure",this))return this;var e=this.requireFail;return-1===Jy(e,t=wm(t,this))&&(e.push(t),t.requireFailure(this)),this;},e.dropRequireFailure=function(t){if(ym(t,"dropRequireFailure",this))return this;t=wm(t,this);var e=Jy(this.requireFail,t);return e>-1&&this.requireFail.splice(e,1),this;},e.hasRequireFailures=function(){return this.requireFail.length>0;},e.canRecognizeWith=function(t){return!!this.simultaneous[t.id];},e.emit=function(t){var e=this,i=this.state;function n(i){e.manager.emit(i,t);}i<8&&n(e.options.event+km(i)),n(e.options.event),t.additionalEvent&&n(t.additionalEvent),i>=8&&n(e.options.event+km(i));},e.tryEmit=function(t){if(this.canEmit())return this.emit(t);this.state=mm;},e.canEmit=function(){for(var t=0;t<this.requireFail.length;){if(!(33&this.requireFail[t].state))return!1;t++;}return!0;},e.recognize=function(t){var e=ty({},t);if(!zy(this.options.enable,[this,e]))return this.reset(),void(this.state=mm);56&this.state&&(this.state=1),this.state=this.process(e),30&this.state&&this.tryEmit(e);},e.process=function(t){},e.getTouchAction=function(){},e.reset=function(){},t;}(),xm=function(t){function e(e){var i;return void 0===e&&(e={}),(i=t.call(this,$g({event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},e))||this).pTime=!1,i.pCenter=!1,i._timer=null,i._input=null,i.count=0,i;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){return[cy];},i.process=function(t){var e=this,i=this.options,n=t.pointers.length===i.pointers,o=t.distance<i.threshold,r=t.deltaTime<i.time;if(this.reset(),t.eventType&_y&&0===this.count)return this.failTimeout();if(o&&r&&n){if(t.eventType!==xy)return this.failTimeout();var s=!this.pTime||t.timeStamp-this.pTime<i.interval,a=!this.pCenter||Wy(this.pCenter,t.center)<i.posThreshold;if(this.pTime=t.timeStamp,this.pCenter=t.center,a&&s?this.count+=1:this.count=1,this._input=t,0===this.count%i.taps)return this.hasRequireFailures()?(this._timer=setTimeout(function(){e.state=8,e.tryEmit();},i.interval),2):8;}return mm;},i.failTimeout=function(){var t=this;return this._timer=setTimeout(function(){t.state=mm;},this.options.interval),mm;},i.reset=function(){clearTimeout(this._timer);},i.emit=function(){8===this.state&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input));},e;}(_m),Em=function(t){function e(e){return void 0===e&&(e={}),t.call(this,$g({pointers:1},e))||this;}Zg(e,t);var i=e.prototype;return i.attrTest=function(t){var e=this.options.pointers;return 0===e||t.pointers.length===e;},i.process=function(t){var e=this.state,i=t.eventType,n=6&e,o=this.attrTest(t);return n&&(i&Ey||!o)?16|e:n||o?i&xy?8|e:2&e?4|e:2:mm;},e;}(_m);function Om(t){return t===My?"down":t===Ty?"up":t===Cy?"left":t===Sy?"right":"";}var Cm=function(t){function e(e){var i;return void 0===e&&(e={}),(i=t.call(this,$g({event:"pan",threshold:10,pointers:1,direction:Iy},e))||this).pX=null,i.pY=null,i;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){var t=this.options.direction,e=[];return t&Py&&e.push(py),t&Dy&&e.push(fy),e;},i.directionTest=function(t){var e=this.options,i=!0,n=t.distance,o=t.direction,r=t.deltaX,s=t.deltaY;return o&e.direction||(e.direction&Py?(o=0===r?Oy:r<0?Cy:Sy,i=r!==this.pX,n=Math.abs(t.deltaX)):(o=0===s?Oy:s<0?Ty:My,i=s!==this.pY,n=Math.abs(t.deltaY))),t.direction=o,i&&n>e.threshold&&o&e.direction;},i.attrTest=function(t){return Em.prototype.attrTest.call(this,t)&&(2&this.state||!(2&this.state)&&this.directionTest(t));},i.emit=function(e){this.pX=e.deltaX,this.pY=e.deltaY;var i=Om(e.direction);i&&(e.additionalEvent=this.options.event+i),t.prototype.emit.call(this,e);},e;}(Em),Sm=function(t){function e(e){return void 0===e&&(e={}),t.call(this,$g({event:"swipe",threshold:10,velocity:.3,direction:Py|Dy,pointers:1},e))||this;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){return Cm.prototype.getTouchAction.call(this);},i.attrTest=function(e){var i,n=this.options.direction;return n&(Py|Dy)?i=e.overallVelocity:n&Py?i=e.overallVelocityX:n&Dy&&(i=e.overallVelocityY),t.prototype.attrTest.call(this,e)&&n&e.offsetDirection&&e.distance>this.options.threshold&&e.maxPointers===this.options.pointers&&oy(i)>this.options.velocity&&e.eventType&xy;},i.emit=function(t){var e=Om(t.offsetDirection);e&&this.manager.emit(this.options.event+e,t),this.manager.emit(this.options.event,t);},e;}(Em),Tm=function(t){function e(e){return void 0===e&&(e={}),t.call(this,$g({event:"pinch",threshold:0,pointers:2},e))||this;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){return[uy];},i.attrTest=function(e){return t.prototype.attrTest.call(this,e)&&(Math.abs(e.scale-1)>this.options.threshold||2&this.state);},i.emit=function(e){if(1!==e.scale){var i=e.scale<1?"in":"out";e.additionalEvent=this.options.event+i;}t.prototype.emit.call(this,e);},e;}(Em),Mm=function(t){function e(e){return void 0===e&&(e={}),t.call(this,$g({event:"rotate",threshold:0,pointers:2},e))||this;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){return[uy];},i.attrTest=function(e){return t.prototype.attrTest.call(this,e)&&(Math.abs(e.rotation)>this.options.threshold||2&this.state);},e;}(Em),Pm=function(t){function e(e){var i;return void 0===e&&(e={}),(i=t.call(this,$g({event:"press",pointers:1,time:251,threshold:9},e))||this)._timer=null,i._input=null,i;}Zg(e,t);var i=e.prototype;return i.getTouchAction=function(){return[dy];},i.process=function(t){var e=this,i=this.options,n=t.pointers.length===i.pointers,o=t.distance<i.threshold,r=t.deltaTime>i.time;if(this._input=t,!o||!n||t.eventType&(xy|Ey)&&!r)this.reset();else if(t.eventType&_y)this.reset(),this._timer=setTimeout(function(){e.state=8,e.tryEmit();},i.time);else if(t.eventType&xy)return 8;return mm;},i.reset=function(){clearTimeout(this._timer);},i.emit=function(t){8===this.state&&(t&&t.eventType&xy?this.manager.emit(this.options.event+"up",t):(this._input.timeStamp=ry(),this.manager.emit(this.options.event,this._input)));},e;}(_m),Dm={domEvents:!1,touchAction:ly,enable:!0,inputTarget:null,inputClass:null,cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}},Im=[[Mm,{enable:!1}],[Tm,{enable:!1},["rotate"]],[Sm,{direction:Py}],[Cm,{direction:Py},["swipe"]],[xm],[xm,{event:"doubletap",taps:2},["tap"]],[Pm]];function Bm(t,e){var i,n=t.element;n.style&&(Fy(t.options.cssProps,function(o,r){i=sy(n.style,r),e?(t.oldCssProps[i]=n.style[i],n.style[i]=o):n.style[i]=t.oldCssProps[i]||"";}),e||(t.oldCssProps={}));}var Nm=function(){function t(t,e){var i,n=this;this.options=ty({},Dm,e||{}),this.options.inputTarget=this.options.inputTarget||t,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=t,this.input=new((i=this).options.inputClass||(yy?om:my?hm:gy?gm:cm))(i,Xy),this.touchAction=new jy(this,this.options.touchAction),Bm(this,!0),Fy(this.options.recognizers,function(t){var e=n.add(new t[0](t[1]));t[2]&&e.recognizeWith(t[2]),t[3]&&e.requireFailure(t[3]);},this);}var e=t.prototype;return e.set=function(t){return ty(this.options,t),t.touchAction&&this.touchAction.update(),t.inputTarget&&(this.input.destroy(),this.input.target=t.inputTarget,this.input.init()),this;},e.stop=function(t){this.session.stopped=t?2:1;},e.recognize=function(t){var e=this.session;if(!e.stopped){var i;this.touchAction.preventDefaults(t);var n=this.recognizers,o=e.curRecognizer;(!o||o&&8&o.state)&&(e.curRecognizer=null,o=null);for(var r=0;r<n.length;)i=n[r],2===e.stopped||o&&i!==o&&!i.canRecognizeWith(o)?i.reset():i.recognize(t),!o&&14&i.state&&(e.curRecognizer=i,o=i),r++;}},e.get=function(t){if(t instanceof _m)return t;for(var e=this.recognizers,i=0;i<e.length;i++)if(e[i].options.event===t)return e[i];return null;},e.add=function(t){if(ym(t,"add",this))return this;var e=this.get(t.options.event);return e&&this.remove(e),this.recognizers.push(t),t.manager=this,this.touchAction.update(),t;},e.remove=function(t){if(ym(t,"remove",this))return this;var e=this.get(t);if(t){var i=this.recognizers,n=Jy(i,e);-1!==n&&(i.splice(n,1),this.touchAction.update());}return this;},e.on=function(t,e){if(void 0===t||void 0===e)return this;var i=this.handlers;return Fy(Gy(t),function(t){i[t]=i[t]||[],i[t].push(e);}),this;},e.off=function(t,e){if(void 0===t)return this;var i=this.handlers;return Fy(Gy(t),function(t){e?i[t]&&i[t].splice(Jy(i[t],e),1):delete i[t];}),this;},e.emit=function(t,e){this.options.domEvents&&function(t,e){var i=document.createEvent("Event");i.initEvent(t,!0,!0),i.gesture=e,e.target.dispatchEvent(i);}(t,e);var i=this.handlers[t]&&this.handlers[t].slice();if(i&&i.length){e.type=t,e.preventDefault=function(){e.srcEvent.preventDefault();};for(var n=0;n<i.length;)i[n](e),n++;}},e.destroy=function(){this.element&&Bm(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null;},t;}(),Fm={touchstart:_y,touchmove:2,touchend:xy,touchcancel:Ey},zm=function(t){function e(){var i,n=e.prototype;return n.evTarget="touchstart",n.evWin="touchstart touchmove touchend touchcancel",(i=t.apply(this,arguments)||this).started=!1,i;}return Zg(e,t),e.prototype.handler=function(t){var e=Fm[t.type];if(e===_y&&(this.started=!0),this.started){var i=Am.call(this,t,e);e&(xy|Ey)&&i[0].length-i[1].length==0&&(this.started=!1),this.callback(this.manager,e,{pointers:i[0],changedPointers:i[1],pointerType:by,srcEvent:t});}},e;}(Qy);function Am(t,e){var i=rm(t.touches),n=rm(t.changedTouches);return e&(xy|Ey)&&(i=sm(i.concat(n),"identifier",!0)),[i,n];}function jm(t,e,i){var n="DEPRECATED METHOD: "+e+"\n"+i+" AT \n";return function(){var e=new Error("get-stack-trace"),i=e&&e.stack?e.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",o=window.console&&(window.console.warn||window.console.log);return o&&o.call(window.console,n,i),t.apply(this,arguments);};}var Rm=jm(function(t,e,i){for(var n=Object.keys(e),o=0;o<n.length;)(!i||i&&void 0===t[n[o]])&&(t[n[o]]=e[n[o]]),o++;return t;},"extend","Use `assign`."),Lm=jm(function(t,e){return Rm(t,e,!0);},"merge","Use `assign`.");function Hm(t,e,i){var n,o=e.prototype;(n=t.prototype=Object.create(o)).constructor=t,n._super=o,i&&ty(n,i);}function Wm(t,e){return function(){return t.apply(e,arguments);};}var qm=function(){var t=function t(_t2,e){return void 0===e&&(e={}),new Nm(_t2,$g({recognizers:Im.concat()},e));};return t.VERSION="2.0.17-rc",t.DIRECTION_ALL=Iy,t.DIRECTION_DOWN=My,t.DIRECTION_LEFT=Cy,t.DIRECTION_RIGHT=Sy,t.DIRECTION_UP=Ty,t.DIRECTION_HORIZONTAL=Py,t.DIRECTION_VERTICAL=Dy,t.DIRECTION_NONE=Oy,t.DIRECTION_DOWN=My,t.INPUT_START=_y,t.INPUT_MOVE=2,t.INPUT_END=xy,t.INPUT_CANCEL=Ey,t.STATE_POSSIBLE=1,t.STATE_BEGAN=2,t.STATE_CHANGED=4,t.STATE_ENDED=8,t.STATE_RECOGNIZED=8,t.STATE_CANCELLED=16,t.STATE_FAILED=mm,t.Manager=Nm,t.Input=Qy,t.TouchAction=jy,t.TouchInput=hm,t.MouseInput=cm,t.PointerEventInput=om,t.TouchMouseInput=gm,t.SingleTouchInput=zm,t.Recognizer=_m,t.AttrRecognizer=Em,t.Tap=xm,t.Pan=Cm,t.Swipe=Sm,t.Pinch=Tm,t.Rotate=Mm,t.Press=Pm,t.on=Ky,t.off=$y,t.each=Fy,t.merge=Lm,t.extend=Rm,t.bindFn=Wm,t.assign=ty,t.inherit=Hm,t.bindFn=Wm,t.prefixed=sy,t.toArray=rm,t.inArray=Jy,t.uniqueArray=sm,t.splitStr=Gy,t.boolOrFn=zy,t.hasParent=Ry,t.addEventListeners=Ky,t.removeEventListeners=$y,t.defaults=ty({},Dm,{preset:Im}),t;}();qm.defaults;var Vm=qm;function Um(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return Ym(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Ym(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n2=0,o=function o(){};return{s:o,n:function n(){return _n2>=t.length?{done:!0}:{done:!1,value:t[_n2++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function Ym(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}var Xm=gf("DELETE");function Gm(t){for(var e,i=arguments.length,n=new Array(i>1?i-1:0),o=1;o<i;o++)n[o-1]=arguments[o];return Km.apply(void 0,_f(e=[{},t]).call(e,n));}function Km(){var t=$m.apply(void 0,arguments);return Qm(t),t;}function $m(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];if(e.length<2)return e[0];var n;if(e.length>2)return $m.apply(void 0,_f(n=[Km(e[0],e[1])]).call(n,vf(xf(e).call(e,2))));var o=e[0],r=e[1];if(o instanceof Date&&r instanceof Date)return o.setTime(r.getTime()),o;var s,a=Um(Pf(r));try{for(a.s();!(s=a.n()).done;){var h=s.value;Object.prototype.propertyIsEnumerable.call(r,h)&&(r[h]===Xm?delete o[h]:null===o[h]||null===r[h]||"object"!==bu(o[h])||"object"!==bu(r[h])||Df(o[h])||Df(r[h])?o[h]=Zm(r[h]):o[h]=$m(o[h],r[h]));}}catch(t){a.e(t);}finally{a.f();}return o;}function Zm(t){return Df(t)?jf(t).call(t,function(t){return Zm(t);}):"object"===bu(t)&&null!==t?t instanceof Date?new Date(t.getTime()):$m({},t):t;}function Qm(t){for(var e=0,i=Hf(t);e<i.length;e++){var n=i[e];t[n]===Xm?delete t[n]:"object"===bu(t[n])&&null!==t[n]&&Qm(t[n]);}}function Jm(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];return function(t){var e=function(){for(var t=function(){var t=4022871197;return function(e){for(var i=e.toString(),n=0;n<i.length;n++){var o=.02519603282416938*(t+=i.charCodeAt(n));o-=t=o>>>0,t=(o*=t)>>>0,t+=4294967296*(o-=t);}return 2.3283064365386963e-10*(t>>>0);};}(),e=t(" "),i=t(" "),n=t(" "),o=0;o<arguments.length;o++)(e-=t(o<0||arguments.length<=o?void 0:arguments[o]))<0&&(e+=1),(i-=t(o<0||arguments.length<=o?void 0:arguments[o]))<0&&(i+=1),(n-=t(o<0||arguments.length<=o?void 0:arguments[o]))<0&&(n+=1);return[e,i,n];}(t),i=pf(e,3),n=i[0],o=i[1],r=i[2],s=1,a=function a(){var t=2091639*n+2.3283064365386963e-10*s;return n=o,o=r,r=t-(s=0|t);};return a.uint32=function(){return 4294967296*a();},a.fract53=function(){return a()+11102230246251565e-32*(2097152*a()|0);},a.algorithm="Alea",a.seed=t,a.version="0.9",a;}(e.length?e:[Uf()]);}var tb="undefined"!=typeof window?window.Hammer||Vm:function(){return function(){var t=function t(){};return{on:t,off:t,destroy:t,emit:t,get:function get(){return{set:t};}};}();};function eb(t){var e,i=this;this._cleanupQueue=[],this.active=!1,this._dom={container:t,overlay:document.createElement("div")},this._dom.overlay.classList.add("vis-overlay"),this._dom.container.appendChild(this._dom.overlay),this._cleanupQueue.push(function(){i._dom.overlay.parentNode.removeChild(i._dom.overlay);});var n=tb(this._dom.overlay);n.on("tap",Hn(e=this._onTapOverlay).call(e,this)),this._cleanupQueue.push(function(){n.destroy();});var o=["tap","doubletap","press","pinch","pan","panstart","panmove","panend"];op(o).call(o,function(t){n.on(t,function(t){t.srcEvent.stopPropagation();});}),document&&document.body&&(this._onClick=function(e){(function(t,e){for(;t;){if(t===e)return!0;t=t.parentNode;}return!1;})(e.target,t)||i.deactivate();},document.body.addEventListener("click",this._onClick),this._cleanupQueue.push(function(){document.body.removeEventListener("click",i._onClick);})),this._escListener=function(t){("key"in t?"Escape"===t.key:27===t.keyCode)&&i.deactivate();};}Kn(eb.prototype),eb.current=null,eb.prototype.destroy=function(){var t,e;this.deactivate();var i,n=Um(vp(t=Ap(e=this._cleanupQueue).call(e,0)).call(t));try{for(n.s();!(i=n.n()).done;){(0,i.value)();}}catch(t){n.e(t);}finally{n.f();}},eb.prototype.activate=function(){eb.current&&eb.current.deactivate(),eb.current=this,this.active=!0,this._dom.overlay.style.display="none",this._dom.container.classList.add("vis-active"),this.emit("change"),this.emit("activate"),document.body.addEventListener("keydown",this._escListener);},eb.prototype.deactivate=function(){this.active=!1,this._dom.overlay.style.display="block",this._dom.container.classList.remove("vis-active"),document.body.removeEventListener("keydown",this._escListener),this.emit("change"),this.emit("deactivate");},eb.prototype._onTapOverlay=function(t){this.activate(),t.srcEvent.stopPropagation();};var ib=/^\/?Date\((-?\d+)/i,nb=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,ob=/^#?([a-f\d])([a-f\d])([a-f\d])$/i,rb=/^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i,sb=/^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;function ab(t){return t instanceof Number||"number"==typeof t;}function hb(t){if(t)for(;!0===t.hasChildNodes();){var e=t.firstChild;e&&(hb(e),t.removeChild(e));}}function lb(t){return t instanceof String||"string"==typeof t;}function db(t){return"object"===bu(t)&&null!==t;}function cb(t,e,i,n){var o=!1;!0===n&&(o=null===e[i]&&void 0!==t[i]),o?delete t[i]:t[i]=e[i];}function ub(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];for(var n in t)if(void 0!==e[n])if(null===e[n]||"object"!==bu(e[n]))cb(t,e,n,i);else{var o=t[n],r=e[n];db(o)&&db(r)&&ub(o,r,i);}}var fb=bn;function pb(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(Df(i))throw new TypeError("Arrays are not supported by deepExtend");for(var o=0;o<t.length;o++){var r=t[o];if(Object.prototype.hasOwnProperty.call(i,r))if(i[r]&&i[r].constructor===Object)void 0===e[r]&&(e[r]={}),e[r].constructor===Object?gb(e[r],i[r],!1,n):cb(e,i,r,n);else{if(Df(i[r]))throw new TypeError("Arrays are not supported by deepExtend");cb(e,i,r,n);}}return e;}function vb(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(Df(i))throw new TypeError("Arrays are not supported by deepExtend");for(var o in i)if(Object.prototype.hasOwnProperty.call(i,o)&&!rv(t).call(t,o))if(i[o]&&i[o].constructor===Object)void 0===e[o]&&(e[o]={}),e[o].constructor===Object?gb(e[o],i[o]):cb(e,i,o,n);else if(Df(i[o])){e[o]=[];for(var r=0;r<i[o].length;r++)e[o].push(i[o][r]);}else cb(e,i,o,n);return e;}function gb(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=arguments.length>3&&void 0!==arguments[3]&&arguments[3];for(var o in e)if(Object.prototype.hasOwnProperty.call(e,o)||!0===i)if("object"===bu(e[o])&&null!==e[o]&&dv(e[o])===Object.prototype)void 0===t[o]?t[o]=gb({},e[o],i):"object"===bu(t[o])&&null!==t[o]&&dv(t[o])===Object.prototype?gb(t[o],e[o],i):cb(t,e,o,n);else if(Df(e[o])){var r;t[o]=xf(r=e[o]).call(r);}else cb(t,e,o,n);return t;}function yb(t,e){var i;return _f(i=[]).call(i,vf(t),[e]);}function mb(t){return xf(t).call(t);}function bb(t){return t.getBoundingClientRect().left;}function wb(t){return t.getBoundingClientRect().top;}function kb(t,e){if(Df(t))for(var i=t.length,n=0;n<i;n++)e(t[n],n,t);else for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&e(t[o],o,t);}var _b=Pv;var xb={asBoolean:function asBoolean(t,e){return"function"==typeof t&&(t=t()),null!=t?0!=t:e||null;},asNumber:function asNumber(t,e){return"function"==typeof t&&(t=t()),null!=t?Number(t)||e||null:e||null;},asString:function asString(t,e){return"function"==typeof t&&(t=t()),null!=t?String(t):e||null;},asSize:function asSize(t,e){return"function"==typeof t&&(t=t()),lb(t)?t:ab(t)?t+"px":e||null;},asElement:function asElement(t,e){return"function"==typeof t&&(t=t()),t||e||null;}};function Eb(t){var e;switch(t.length){case 3:case 4:return(e=ob.exec(t))?{r:Qv(e[1]+e[1],16),g:Qv(e[2]+e[2],16),b:Qv(e[3]+e[3],16)}:null;case 6:case 7:return(e=nb.exec(t))?{r:Qv(e[1],16),g:Qv(e[2],16),b:Qv(e[3],16)}:null;default:return null;}}function Ob(t,e){if(rv(t).call(t,"rgba"))return t;if(rv(t).call(t,"rgb")){var i=t.substr(lg(t).call(t,"(")+1).replace(")","").split(",");return"rgba("+i[0]+","+i[1]+","+i[2]+","+e+")";}var n=Eb(t);return null==n?t:"rgba("+n.r+","+n.g+","+n.b+","+e+")";}function Cb(t,e,i){var n;return"#"+xf(n=((1<<24)+(t<<16)+(e<<8)+i).toString(16)).call(n,1);}function Sb(t,e){if(lb(t)){var i=t;if(Nb(i)){var n,o=jf(n=i.substr(4).substr(0,i.length-5).split(",")).call(n,function(t){return Qv(t);});i=Cb(o[0],o[1],o[2]);}if(!0===Bb(i)){var r=Ib(i),s={h:r.h,s:.8*r.s,v:Math.min(1,1.02*r.v)},a={h:r.h,s:Math.min(1,1.25*r.s),v:.8*r.v},h=Db(a.h,a.s,a.v),l=Db(s.h,s.s,s.v);return{background:i,border:h,highlight:{background:l,border:h},hover:{background:l,border:h}};}return{background:i,border:i,highlight:{background:i,border:i},hover:{background:i,border:i}};}return e?{background:t.background||e.background,border:t.border||e.border,highlight:lb(t.highlight)?{border:t.highlight,background:t.highlight}:{background:t.highlight&&t.highlight.background||e.highlight.background,border:t.highlight&&t.highlight.border||e.highlight.border},hover:lb(t.hover)?{border:t.hover,background:t.hover}:{border:t.hover&&t.hover.border||e.hover.border,background:t.hover&&t.hover.background||e.hover.background}}:{background:t.background||void 0,border:t.border||void 0,highlight:lb(t.highlight)?{border:t.highlight,background:t.highlight}:{background:t.highlight&&t.highlight.background||void 0,border:t.highlight&&t.highlight.border||void 0},hover:lb(t.hover)?{border:t.hover,background:t.hover}:{border:t.hover&&t.hover.border||void 0,background:t.hover&&t.hover.background||void 0}};}function Tb(t,e,i){t/=255,e/=255,i/=255;var n=Math.min(t,Math.min(e,i)),o=Math.max(t,Math.max(e,i));return n===o?{h:0,s:0,v:n}:{h:60*((t===n?3:i===n?1:5)-(t===n?e-i:i===n?t-e:i-t)/(o-n))/360,s:(o-n)/o,v:o};}function Mb(t){var e=document.createElement("div"),i={};e.style.cssText=t;for(var n=0;n<e.style.length;++n)i[e.style[n]]=e.style.getPropertyValue(e.style[n]);return i;}function Pb(t,e,i){var n,o,r,s=Math.floor(6*t),a=6*t-s,h=i*(1-e),l=i*(1-a*e),d=i*(1-(1-a)*e);switch(s%6){case 0:n=i,o=d,r=h;break;case 1:n=l,o=i,r=h;break;case 2:n=h,o=i,r=d;break;case 3:n=h,o=l,r=i;break;case 4:n=d,o=h,r=i;break;case 5:n=i,o=h,r=l;}return{r:Math.floor(255*n),g:Math.floor(255*o),b:Math.floor(255*r)};}function Db(t,e,i){var n=Pb(t,e,i);return Cb(n.r,n.g,n.b);}function Ib(t){var e=Eb(t);if(!e)throw new TypeError("'".concat(t,"' is not a valid color."));return Tb(e.r,e.g,e.b);}function Bb(t){return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);}function Nb(t){return rb.test(t);}function Fb(t){return sb.test(t);}function zb(t){if(null===t||"object"!==bu(t))return null;if(t instanceof Element)return t;var e=pg(t);for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&"object"==bu(t[i])&&(e[i]=zb(t[i]));return e;}function Ab(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},o=function o(t){return null!=t;},r=function r(t){return null!==t&&"object"===bu(t);};if(!r(t))throw new Error("Parameter mergeTarget must be an object");if(!r(e))throw new Error("Parameter options must be an object");if(!o(i))throw new Error("Parameter option must have a value");if(!r(n))throw new Error("Parameter globalOptions must be an object");var s=e[i],a=r(n)&&!function(t){for(var e in t)if(Object.prototype.hasOwnProperty.call(t,e))return!1;return!0;}(n)?n[i]:void 0,h=a?a.enabled:void 0;if(void 0!==s){if("boolean"==typeof s)return r(t[i])||(t[i]={}),void(t[i].enabled=s);if(null===s&&!r(t[i])){if(!o(a))return;t[i]=pg(a);}if(r(s)){var l=!0;void 0!==s.enabled?l=s.enabled:void 0!==h&&(l=a.enabled),function(t,e,i){r(t[i])||(t[i]={});var n=e[i],o=t[i];for(var s in n)Object.prototype.hasOwnProperty.call(n,s)&&(o[s]=n[s]);}(t,e,i),t[i].enabled=l;}}}var jb={linear:function linear(t){return t;},easeInQuad:function easeInQuad(t){return t*t;},easeOutQuad:function easeOutQuad(t){return t*(2-t);},easeInOutQuad:function easeInOutQuad(t){return t<.5?2*t*t:(4-2*t)*t-1;},easeInCubic:function easeInCubic(t){return t*t*t;},easeOutCubic:function easeOutCubic(t){return--t*t*t+1;},easeInOutCubic:function easeInOutCubic(t){return t<.5?4*t*t*t:(t-1)*(2*t-2)*(2*t-2)+1;},easeInQuart:function easeInQuart(t){return t*t*t*t;},easeOutQuart:function easeOutQuart(t){return 1- --t*t*t*t;},easeInOutQuart:function easeInOutQuart(t){return t<.5?8*t*t*t*t:1-8*--t*t*t*t;},easeInQuint:function easeInQuint(t){return t*t*t*t*t;},easeOutQuint:function easeOutQuint(t){return 1+--t*t*t*t*t;},easeInOutQuint:function easeInOutQuint(t){return t<.5?16*t*t*t*t*t:1+16*--t*t*t*t*t;}};function Rb(t,e){var i;Df(e)||(e=[e]);var n,o=Um(t);try{for(o.s();!(n=o.n()).done;){var r=n.value;if(r){i=r[e[0]];for(var s=1;s<e.length;s++)i&&(i=i[e[s]]);if(void 0!==i)break;}}}catch(t){o.e(t);}finally{o.f();}return i;}var Lb={black:"#000000",navy:"#000080",darkblue:"#00008B",mediumblue:"#0000CD",blue:"#0000FF",darkgreen:"#006400",green:"#008000",teal:"#008080",darkcyan:"#008B8B",deepskyblue:"#00BFFF",darkturquoise:"#00CED1",mediumspringgreen:"#00FA9A",lime:"#00FF00",springgreen:"#00FF7F",aqua:"#00FFFF",cyan:"#00FFFF",midnightblue:"#191970",dodgerblue:"#1E90FF",lightseagreen:"#20B2AA",forestgreen:"#228B22",seagreen:"#2E8B57",darkslategray:"#2F4F4F",limegreen:"#32CD32",mediumseagreen:"#3CB371",turquoise:"#40E0D0",royalblue:"#4169E1",steelblue:"#4682B4",darkslateblue:"#483D8B",mediumturquoise:"#48D1CC",indigo:"#4B0082",darkolivegreen:"#556B2F",cadetblue:"#5F9EA0",cornflowerblue:"#6495ED",mediumaquamarine:"#66CDAA",dimgray:"#696969",slateblue:"#6A5ACD",olivedrab:"#6B8E23",slategray:"#708090",lightslategray:"#778899",mediumslateblue:"#7B68EE",lawngreen:"#7CFC00",chartreuse:"#7FFF00",aquamarine:"#7FFFD4",maroon:"#800000",purple:"#800080",olive:"#808000",gray:"#808080",skyblue:"#87CEEB",lightskyblue:"#87CEFA",blueviolet:"#8A2BE2",darkred:"#8B0000",darkmagenta:"#8B008B",saddlebrown:"#8B4513",darkseagreen:"#8FBC8F",lightgreen:"#90EE90",mediumpurple:"#9370D8",darkviolet:"#9400D3",palegreen:"#98FB98",darkorchid:"#9932CC",yellowgreen:"#9ACD32",sienna:"#A0522D",brown:"#A52A2A",darkgray:"#A9A9A9",lightblue:"#ADD8E6",greenyellow:"#ADFF2F",paleturquoise:"#AFEEEE",lightsteelblue:"#B0C4DE",powderblue:"#B0E0E6",firebrick:"#B22222",darkgoldenrod:"#B8860B",mediumorchid:"#BA55D3",rosybrown:"#BC8F8F",darkkhaki:"#BDB76B",silver:"#C0C0C0",mediumvioletred:"#C71585",indianred:"#CD5C5C",peru:"#CD853F",chocolate:"#D2691E",tan:"#D2B48C",lightgrey:"#D3D3D3",palevioletred:"#D87093",thistle:"#D8BFD8",orchid:"#DA70D6",goldenrod:"#DAA520",crimson:"#DC143C",gainsboro:"#DCDCDC",plum:"#DDA0DD",burlywood:"#DEB887",lightcyan:"#E0FFFF",lavender:"#E6E6FA",darksalmon:"#E9967A",violet:"#EE82EE",palegoldenrod:"#EEE8AA",lightcoral:"#F08080",khaki:"#F0E68C",aliceblue:"#F0F8FF",honeydew:"#F0FFF0",azure:"#F0FFFF",sandybrown:"#F4A460",wheat:"#F5DEB3",beige:"#F5F5DC",whitesmoke:"#F5F5F5",mintcream:"#F5FFFA",ghostwhite:"#F8F8FF",salmon:"#FA8072",antiquewhite:"#FAEBD7",linen:"#FAF0E6",lightgoldenrodyellow:"#FAFAD2",oldlace:"#FDF5E6",red:"#FF0000",fuchsia:"#FF00FF",magenta:"#FF00FF",deeppink:"#FF1493",orangered:"#FF4500",tomato:"#FF6347",hotpink:"#FF69B4",coral:"#FF7F50",darkorange:"#FF8C00",lightsalmon:"#FFA07A",orange:"#FFA500",lightpink:"#FFB6C1",pink:"#FFC0CB",gold:"#FFD700",peachpuff:"#FFDAB9",navajowhite:"#FFDEAD",moccasin:"#FFE4B5",bisque:"#FFE4C4",mistyrose:"#FFE4E1",blanchedalmond:"#FFEBCD",papayawhip:"#FFEFD5",lavenderblush:"#FFF0F5",seashell:"#FFF5EE",cornsilk:"#FFF8DC",lemonchiffon:"#FFFACD",floralwhite:"#FFFAF0",snow:"#FFFAFA",yellow:"#FFFF00",lightyellow:"#FFFFE0",ivory:"#FFFFF0",white:"#FFFFFF"},Hb=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;ph(this,t),this.pixelRatio=e,this.generated=!1,this.centerCoordinates={x:144.5,y:144.5},this.r=289*.49,this.color={r:255,g:255,b:255,a:1},this.hueCircle=void 0,this.initialColor={r:255,g:255,b:255,a:1},this.previousColor=void 0,this.applied=!1,this.updateCallback=function(){},this.closeCallback=function(){},this._create();}return xu(t,[{key:"insertTo",value:function value(t){void 0!==this.hammer&&(this.hammer.destroy(),this.hammer=void 0),this.container=t,this.container.appendChild(this.frame),this._bindHammer(),this._setSize();}},{key:"setUpdateCallback",value:function value(t){if("function"!=typeof t)throw new Error("Function attempted to set as colorPicker update callback is not a function.");this.updateCallback=t;}},{key:"setCloseCallback",value:function value(t){if("function"!=typeof t)throw new Error("Function attempted to set as colorPicker closing callback is not a function.");this.closeCallback=t;}},{key:"_isColorString",value:function value(t){if("string"==typeof t)return Lb[t];}},{key:"setColor",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if("none"!==t){var i,n=this._isColorString(t);if(void 0!==n&&(t=n),!0===lb(t)){if(!0===Nb(t)){var o=t.substr(4).substr(0,t.length-5).split(",");i={r:o[0],g:o[1],b:o[2],a:1};}else if(!0===Fb(t)){var r=t.substr(5).substr(0,t.length-6).split(",");i={r:r[0],g:r[1],b:r[2],a:r[3]};}else if(!0===Bb(t)){var s=Eb(t);i={r:s.r,g:s.g,b:s.b,a:1};}}else if(t instanceof Object&&void 0!==t.r&&void 0!==t.g&&void 0!==t.b){var a=void 0!==t.a?t.a:"1.0";i={r:t.r,g:t.g,b:t.b,a:a};}if(void 0===i)throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: "+mg(t));this._setColor(i,e);}}},{key:"show",value:function value(){void 0!==this.closeCallback&&(this.closeCallback(),this.closeCallback=void 0),this.applied=!1,this.frame.style.display="block",this._generateHueCircle();}},{key:"_hide",value:function value(){var t=this;!0===(!(arguments.length>0&&void 0!==arguments[0])||arguments[0])&&(this.previousColor=bn({},this.color)),!0===this.applied&&this.updateCallback(this.initialColor),this.frame.style.display="none",jg(function(){void 0!==t.closeCallback&&(t.closeCallback(),t.closeCallback=void 0);},0);}},{key:"_save",value:function value(){this.updateCallback(this.color),this.applied=!1,this._hide();}},{key:"_apply",value:function value(){this.applied=!0,this.updateCallback(this.color),this._updatePicker(this.color);}},{key:"_loadLast",value:function value(){void 0!==this.previousColor?this.setColor(this.previousColor,!1):alert("There is no last color to load...");}},{key:"_setColor",value:function value(t){!0===(!(arguments.length>1&&void 0!==arguments[1])||arguments[1])&&(this.initialColor=bn({},t)),this.color=t;var e=Tb(t.r,t.g,t.b),i=2*Math.PI,n=this.r*e.s,o=this.centerCoordinates.x+n*Math.sin(i*e.h),r=this.centerCoordinates.y+n*Math.cos(i*e.h);this.colorPickerSelector.style.left=o-.5*this.colorPickerSelector.clientWidth+"px",this.colorPickerSelector.style.top=r-.5*this.colorPickerSelector.clientHeight+"px",this._updatePicker(t);}},{key:"_setOpacity",value:function value(t){this.color.a=t/100,this._updatePicker(this.color);}},{key:"_setBrightness",value:function value(t){var e=Tb(this.color.r,this.color.g,this.color.b);e.v=t/100;var i=Pb(e.h,e.s,e.v);i.a=this.color.a,this.color=i,this._updatePicker();}},{key:"_updatePicker",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.color,e=Tb(t.r,t.g,t.b),i=this.colorPickerCanvas.getContext("2d");void 0===this.pixelRation&&(this.pixelRatio=(window.devicePixelRatio||1)/(i.webkitBackingStorePixelRatio||i.mozBackingStorePixelRatio||i.msBackingStorePixelRatio||i.oBackingStorePixelRatio||i.backingStorePixelRatio||1)),i.setTransform(this.pixelRatio,0,0,this.pixelRatio,0,0);var n=this.colorPickerCanvas.clientWidth,o=this.colorPickerCanvas.clientHeight;i.clearRect(0,0,n,o),i.putImageData(this.hueCircle,0,0),i.fillStyle="rgba(0,0,0,"+(1-e.v)+")",i.circle(this.centerCoordinates.x,this.centerCoordinates.y,this.r),Kg(i).call(i),this.brightnessRange.value=100*e.v,this.opacityRange.value=100*t.a,this.initialColorDiv.style.backgroundColor="rgba("+this.initialColor.r+","+this.initialColor.g+","+this.initialColor.b+","+this.initialColor.a+")",this.newColorDiv.style.backgroundColor="rgba("+this.color.r+","+this.color.g+","+this.color.b+","+this.color.a+")";}},{key:"_setSize",value:function value(){this.colorPickerCanvas.style.width="100%",this.colorPickerCanvas.style.height="100%",this.colorPickerCanvas.width=289*this.pixelRatio,this.colorPickerCanvas.height=289*this.pixelRatio;}},{key:"_create",value:function value(){var t,e,i,n;if(this.frame=document.createElement("div"),this.frame.className="vis-color-picker",this.colorPickerDiv=document.createElement("div"),this.colorPickerSelector=document.createElement("div"),this.colorPickerSelector.className="vis-selector",this.colorPickerDiv.appendChild(this.colorPickerSelector),this.colorPickerCanvas=document.createElement("canvas"),this.colorPickerDiv.appendChild(this.colorPickerCanvas),this.colorPickerCanvas.getContext){var o=this.colorPickerCanvas.getContext("2d");this.pixelRatio=(window.devicePixelRatio||1)/(o.webkitBackingStorePixelRatio||o.mozBackingStorePixelRatio||o.msBackingStorePixelRatio||o.oBackingStorePixelRatio||o.backingStorePixelRatio||1),this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio,0,0,this.pixelRatio,0,0);}else{var r=document.createElement("DIV");r.style.color="red",r.style.fontWeight="bold",r.style.padding="10px",r.innerText="Error: your browser does not support HTML canvas",this.colorPickerCanvas.appendChild(r);}this.colorPickerDiv.className="vis-color",this.opacityDiv=document.createElement("div"),this.opacityDiv.className="vis-opacity",this.brightnessDiv=document.createElement("div"),this.brightnessDiv.className="vis-brightness",this.arrowDiv=document.createElement("div"),this.arrowDiv.className="vis-arrow",this.opacityRange=document.createElement("input");try{this.opacityRange.type="range",this.opacityRange.min="0",this.opacityRange.max="100";}catch(t){}this.opacityRange.value="100",this.opacityRange.className="vis-range",this.brightnessRange=document.createElement("input");try{this.brightnessRange.type="range",this.brightnessRange.min="0",this.brightnessRange.max="100";}catch(t){}this.brightnessRange.value="100",this.brightnessRange.className="vis-range",this.opacityDiv.appendChild(this.opacityRange),this.brightnessDiv.appendChild(this.brightnessRange);var s=this;this.opacityRange.onchange=function(){s._setOpacity(this.value);},this.opacityRange.oninput=function(){s._setOpacity(this.value);},this.brightnessRange.onchange=function(){s._setBrightness(this.value);},this.brightnessRange.oninput=function(){s._setBrightness(this.value);},this.brightnessLabel=document.createElement("div"),this.brightnessLabel.className="vis-label vis-brightness",this.brightnessLabel.innerText="brightness:",this.opacityLabel=document.createElement("div"),this.opacityLabel.className="vis-label vis-opacity",this.opacityLabel.innerText="opacity:",this.newColorDiv=document.createElement("div"),this.newColorDiv.className="vis-new-color",this.newColorDiv.innerText="new",this.initialColorDiv=document.createElement("div"),this.initialColorDiv.className="vis-initial-color",this.initialColorDiv.innerText="initial",this.cancelButton=document.createElement("div"),this.cancelButton.className="vis-button vis-cancel",this.cancelButton.innerText="cancel",this.cancelButton.onclick=Hn(t=this._hide).call(t,this,!1),this.applyButton=document.createElement("div"),this.applyButton.className="vis-button vis-apply",this.applyButton.innerText="apply",this.applyButton.onclick=Hn(e=this._apply).call(e,this),this.saveButton=document.createElement("div"),this.saveButton.className="vis-button vis-save",this.saveButton.innerText="save",this.saveButton.onclick=Hn(i=this._save).call(i,this),this.loadButton=document.createElement("div"),this.loadButton.className="vis-button vis-load",this.loadButton.innerText="load last",this.loadButton.onclick=Hn(n=this._loadLast).call(n,this),this.frame.appendChild(this.colorPickerDiv),this.frame.appendChild(this.arrowDiv),this.frame.appendChild(this.brightnessLabel),this.frame.appendChild(this.brightnessDiv),this.frame.appendChild(this.opacityLabel),this.frame.appendChild(this.opacityDiv),this.frame.appendChild(this.newColorDiv),this.frame.appendChild(this.initialColorDiv),this.frame.appendChild(this.cancelButton),this.frame.appendChild(this.applyButton),this.frame.appendChild(this.saveButton),this.frame.appendChild(this.loadButton);}},{key:"_bindHammer",value:function value(){var t=this;this.drag={},this.pinch={},this.hammer=new tb(this.colorPickerCanvas),this.hammer.get("pinch").set({enable:!0}),this.hammer.on("hammer.input",function(e){e.isFirst&&t._moveSelector(e);}),this.hammer.on("tap",function(e){t._moveSelector(e);}),this.hammer.on("panstart",function(e){t._moveSelector(e);}),this.hammer.on("panmove",function(e){t._moveSelector(e);}),this.hammer.on("panend",function(e){t._moveSelector(e);});}},{key:"_generateHueCircle",value:function value(){if(!1===this.generated){var t=this.colorPickerCanvas.getContext("2d");void 0===this.pixelRation&&(this.pixelRatio=(window.devicePixelRatio||1)/(t.webkitBackingStorePixelRatio||t.mozBackingStorePixelRatio||t.msBackingStorePixelRatio||t.oBackingStorePixelRatio||t.backingStorePixelRatio||1)),t.setTransform(this.pixelRatio,0,0,this.pixelRatio,0,0);var e,i,n,o,r=this.colorPickerCanvas.clientWidth,s=this.colorPickerCanvas.clientHeight;t.clearRect(0,0,r,s),this.centerCoordinates={x:.5*r,y:.5*s},this.r=.49*r;var a,h=2*Math.PI/360,l=1/this.r;for(n=0;n<360;n++)for(o=0;o<this.r;o++)e=this.centerCoordinates.x+o*Math.sin(h*n),i=this.centerCoordinates.y+o*Math.cos(h*n),a=Pb(.002777777777777778*n,o*l,1),t.fillStyle="rgb("+a.r+","+a.g+","+a.b+")",t.fillRect(e-.5,i-.5,2,2);t.strokeStyle="rgba(0,0,0,1)",t.circle(this.centerCoordinates.x,this.centerCoordinates.y,this.r),t.stroke(),this.hueCircle=t.getImageData(0,0,r,s);}this.generated=!0;}},{key:"_moveSelector",value:function value(t){var e=this.colorPickerDiv.getBoundingClientRect(),i=t.center.x-e.left,n=t.center.y-e.top,o=.5*this.colorPickerDiv.clientHeight,r=.5*this.colorPickerDiv.clientWidth,s=i-r,a=n-o,h=Math.atan2(s,a),l=.98*Math.min(Math.sqrt(s*s+a*a),r),d=Math.cos(h)*l+o,c=Math.sin(h)*l+r;this.colorPickerSelector.style.top=d-.5*this.colorPickerSelector.clientHeight+"px",this.colorPickerSelector.style.left=c-.5*this.colorPickerSelector.clientWidth+"px";var u=h/(2*Math.PI);u=u<0?u+1:u;var f=l/this.r,p=Tb(this.color.r,this.color.g,this.color.b);p.h=u,p.s=f;var v=Pb(p.h,p.s,p.v);v.a=this.color.a,this.color=v,this.initialColorDiv.style.backgroundColor="rgba("+this.initialColor.r+","+this.initialColor.g+","+this.initialColor.b+","+this.initialColor.a+")",this.newColorDiv.style.backgroundColor="rgba("+this.color.r+","+this.color.g+","+this.color.b+","+this.color.a+")";}}]),t;}();function Wb(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];if(e.length<1)throw new TypeError("Invalid arguments.");if(1===e.length)return document.createTextNode(e[0]);var n=document.createElement(e[0]);return n.appendChild(Wb.apply(void 0,vf(xf(e).call(e,1)))),n;}var qb,Vb=function(){function t(e,i,n){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:function(){return!1;};ph(this,t),this.parent=e,this.changedOptions=[],this.container=i,this.allowCreation=!1,this.hideOption=r,this.options={},this.initialized=!1,this.popupCounter=0,this.defaultOptions={enabled:!1,filter:!0,container:void 0,showButton:!0},bn(this.options,this.defaultOptions),this.configureOptions=n,this.moduleOptions={},this.domElements=[],this.popupDiv={},this.popupLimit=5,this.popupHistory={},this.colorPicker=new Hb(o),this.wrapper=void 0;}return xu(t,[{key:"setOptions",value:function value(t){if(void 0!==t){this.popupHistory={},this._removePopup();var e=!0;if("string"==typeof t)this.options.filter=t;else if(Df(t))this.options.filter=t.join();else if("object"===bu(t)){if(null==t)throw new TypeError("options cannot be null");void 0!==t.container&&(this.options.container=t.container),void 0!==yv(t)&&(this.options.filter=yv(t)),void 0!==t.showButton&&(this.options.showButton=t.showButton),void 0!==t.enabled&&(e=t.enabled);}else"boolean"==typeof t?(this.options.filter=!0,e=t):"function"==typeof t&&(this.options.filter=t,e=!0);!1===yv(this.options)&&(e=!1),this.options.enabled=e;}this._clean();}},{key:"setModuleOptions",value:function value(t){this.moduleOptions=t,!0===this.options.enabled&&(this._clean(),void 0!==this.options.container&&(this.container=this.options.container),this._create());}},{key:"_create",value:function value(){this._clean(),this.changedOptions=[];var t=yv(this.options),e=0,i=!1;for(var n in this.configureOptions)Object.prototype.hasOwnProperty.call(this.configureOptions,n)&&(this.allowCreation=!1,i=!1,"function"==typeof t?i=(i=t(n,[]))||this._handleObject(this.configureOptions[n],[n],!0):!0!==t&&-1===lg(t).call(t,n)||(i=!0),!1!==i&&(this.allowCreation=!0,e>0&&this._makeItem([]),this._makeHeader(n),this._handleObject(this.configureOptions[n],[n])),e++);this._makeButton(),this._push();}},{key:"_push",value:function value(){this.wrapper=document.createElement("div"),this.wrapper.className="vis-configuration-wrapper",this.container.appendChild(this.wrapper);for(var t=0;t<this.domElements.length;t++)this.wrapper.appendChild(this.domElements[t]);this._showPopupIfNeeded();}},{key:"_clean",value:function value(){for(var t=0;t<this.domElements.length;t++)this.wrapper.removeChild(this.domElements[t]);void 0!==this.wrapper&&(this.container.removeChild(this.wrapper),this.wrapper=void 0),this.domElements=[],this._removePopup();}},{key:"_getValue",value:function value(t){for(var e=this.moduleOptions,i=0;i<t.length;i++){if(void 0===e[t[i]]){e=void 0;break;}e=e[t[i]];}return e;}},{key:"_makeItem",value:function value(t){if(!0===this.allowCreation){var e=document.createElement("div");e.className="vis-configuration vis-config-item vis-config-s"+t.length;for(var i=arguments.length,n=new Array(i>1?i-1:0),o=1;o<i;o++)n[o-1]=arguments[o];return op(n).call(n,function(t){e.appendChild(t);}),this.domElements.push(e),this.domElements.length;}return 0;}},{key:"_makeHeader",value:function value(t){var e=document.createElement("div");e.className="vis-configuration vis-config-header",e.innerText=t,this._makeItem([],e);}},{key:"_makeLabel",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=document.createElement("div");if(n.className="vis-configuration vis-config-label vis-config-s"+e.length,!0===i){for(;n.firstChild;)n.removeChild(n.firstChild);n.appendChild(Wb("i","b",t));}else n.innerText=t+":";return n;}},{key:"_makeDropdown",value:function value(t,e,i){var n=document.createElement("select");n.className="vis-configuration vis-config-select";var o=0;void 0!==e&&-1!==lg(t).call(t,e)&&(o=lg(t).call(t,e));for(var r=0;r<t.length;r++){var s=document.createElement("option");s.value=t[r],r===o&&(s.selected="selected"),s.innerText=t[r],n.appendChild(s);}var a=this;n.onchange=function(){a._update(this.value,i);};var h=this._makeLabel(i[i.length-1],i);this._makeItem(i,h,n);}},{key:"_makeRange",value:function value(t,e,i){var n=t[0],o=t[1],r=t[2],s=t[3],a=document.createElement("input");a.className="vis-configuration vis-config-range";try{a.type="range",a.min=o,a.max=r;}catch(t){}a.step=s;var h="",l=0;if(void 0!==e){var d=1.2;e<0&&e*d<o?(a.min=Math.ceil(e*d),l=a.min,h="range increased"):e/d<o&&(a.min=Math.ceil(e/d),l=a.min,h="range increased"),e*d>r&&1!==r&&(a.max=Math.ceil(e*d),l=a.max,h="range increased"),a.value=e;}else a.value=n;var c=document.createElement("input");c.className="vis-configuration vis-config-rangeinput",c.value=a.value;var u=this;a.onchange=function(){c.value=this.value,u._update(Number(this.value),i);},a.oninput=function(){c.value=this.value;};var f=this._makeLabel(i[i.length-1],i),p=this._makeItem(i,f,a,c);""!==h&&this.popupHistory[p]!==l&&(this.popupHistory[p]=l,this._setupPopup(h,p));}},{key:"_makeButton",value:function value(){var t=this;if(!0===this.options.showButton){var e=document.createElement("div");e.className="vis-configuration vis-config-button",e.innerText="generate options",e.onclick=function(){t._printOptions();},e.onmouseover=function(){e.className="vis-configuration vis-config-button hover";},e.onmouseout=function(){e.className="vis-configuration vis-config-button";},this.optionsContainer=document.createElement("div"),this.optionsContainer.className="vis-configuration vis-config-option-container",this.domElements.push(this.optionsContainer),this.domElements.push(e);}}},{key:"_setupPopup",value:function value(t,e){var i=this;if(!0===this.initialized&&!0===this.allowCreation&&this.popupCounter<this.popupLimit){var n=document.createElement("div");n.id="vis-configuration-popup",n.className="vis-configuration-popup",n.innerText=t,n.onclick=function(){i._removePopup();},this.popupCounter+=1,this.popupDiv={html:n,index:e};}}},{key:"_removePopup",value:function value(){void 0!==this.popupDiv.html&&(this.popupDiv.html.parentNode.removeChild(this.popupDiv.html),clearTimeout(this.popupDiv.hideTimeout),clearTimeout(this.popupDiv.deleteTimeout),this.popupDiv={});}},{key:"_showPopupIfNeeded",value:function value(){var t=this;if(void 0!==this.popupDiv.html){var e=this.domElements[this.popupDiv.index].getBoundingClientRect();this.popupDiv.html.style.left=e.left+"px",this.popupDiv.html.style.top=e.top-30+"px",document.body.appendChild(this.popupDiv.html),this.popupDiv.hideTimeout=jg(function(){t.popupDiv.html.style.opacity=0;},1500),this.popupDiv.deleteTimeout=jg(function(){t._removePopup();},1800);}}},{key:"_makeCheckbox",value:function value(t,e,i){var n=document.createElement("input");n.type="checkbox",n.className="vis-configuration vis-config-checkbox",n.checked=t,void 0!==e&&(n.checked=e,e!==t&&("object"===bu(t)?e!==t.enabled&&this.changedOptions.push({path:i,value:e}):this.changedOptions.push({path:i,value:e})));var o=this;n.onchange=function(){o._update(this.checked,i);};var r=this._makeLabel(i[i.length-1],i);this._makeItem(i,r,n);}},{key:"_makeTextInput",value:function value(t,e,i){var n=document.createElement("input");n.type="text",n.className="vis-configuration vis-config-text",n.value=e,e!==t&&this.changedOptions.push({path:i,value:e});var o=this;n.onchange=function(){o._update(this.value,i);};var r=this._makeLabel(i[i.length-1],i);this._makeItem(i,r,n);}},{key:"_makeColorField",value:function value(t,e,i){var n=this,o=t[1],r=document.createElement("div");"none"!==(e=void 0===e?o:e)?(r.className="vis-configuration vis-config-colorBlock",r.style.backgroundColor=e):r.className="vis-configuration vis-config-colorBlock none",e=void 0===e?o:e,r.onclick=function(){n._showColorPicker(e,r,i);};var s=this._makeLabel(i[i.length-1],i);this._makeItem(i,s,r);}},{key:"_showColorPicker",value:function value(t,e,i){var n=this;e.onclick=function(){},this.colorPicker.insertTo(e),this.colorPicker.show(),this.colorPicker.setColor(t),this.colorPicker.setUpdateCallback(function(t){var o="rgba("+t.r+","+t.g+","+t.b+","+t.a+")";e.style.backgroundColor=o,n._update(o,i);}),this.colorPicker.setCloseCallback(function(){e.onclick=function(){n._showColorPicker(t,e,i);};});}},{key:"_handleObject",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=!1,o=yv(this.options),r=!1;for(var s in t)if(Object.prototype.hasOwnProperty.call(t,s)){n=!0;var a=t[s],h=yb(e,s);if("function"==typeof o&&!1===(n=o(s,e))&&!Df(a)&&"string"!=typeof a&&"boolean"!=typeof a&&a instanceof Object&&(this.allowCreation=!1,n=this._handleObject(a,h,!0),this.allowCreation=!1===i),!1!==n){r=!0;var l=this._getValue(h);if(Df(a))this._handleArray(a,l,h);else if("string"==typeof a)this._makeTextInput(a,l,h);else if("boolean"==typeof a)this._makeCheckbox(a,l,h);else if(a instanceof Object){if(!this.hideOption(e,s,this.moduleOptions))if(void 0!==a.enabled){var d=yb(h,"enabled"),c=this._getValue(d);if(!0===c){var u=this._makeLabel(s,h,!0);this._makeItem(h,u),r=this._handleObject(a,h)||r;}else this._makeCheckbox(a,c,h);}else{var f=this._makeLabel(s,h,!0);this._makeItem(h,f),r=this._handleObject(a,h)||r;}}else console.error("dont know how to handle",a,s,h);}}return r;}},{key:"_handleArray",value:function value(t,e,i){"string"==typeof t[0]&&"color"===t[0]?(this._makeColorField(t,e,i),t[1]!==e&&this.changedOptions.push({path:i,value:e})):"string"==typeof t[0]?(this._makeDropdown(t,e,i),t[0]!==e&&this.changedOptions.push({path:i,value:e})):"number"==typeof t[0]&&(this._makeRange(t,e,i),t[0]!==e&&this.changedOptions.push({path:i,value:Number(e)}));}},{key:"_update",value:function value(t,e){var i=this._constructOptions(t,e);this.parent.body&&this.parent.body.emitter&&this.parent.body.emitter.emit&&this.parent.body.emitter.emit("configChange",i),this.initialized=!0,this.parent.setOptions(i);}},{key:"_constructOptions",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=i;t="false"!==(t="true"===t||t)&&t;for(var o=0;o<e.length;o++)"global"!==e[o]&&(void 0===n[e[o]]&&(n[e[o]]={}),o!==e.length-1?n=n[e[o]]:n[e[o]]=t);return i;}},{key:"_printOptions",value:function value(){for(var t=this.getOptions();this.optionsContainer.firstChild;)this.optionsContainer.removeChild(this.optionsContainer.firstChild);this.optionsContainer.appendChild(Wb("pre","const options = "+mg(t,null,2)));}},{key:"getOptions",value:function value(){for(var t={},e=0;e<this.changedOptions.length;e++)this._constructOptions(this.changedOptions[e].value,this.changedOptions[e].path,t);return t;}}]),t;}(),Ub=function(){function t(e,i){ph(this,t),this.container=e,this.overflowMethod=i||"cap",this.x=0,this.y=0,this.padding=5,this.hidden=!1,this.frame=document.createElement("div"),this.frame.className="vis-tooltip",this.container.appendChild(this.frame);}return xu(t,[{key:"setPosition",value:function value(t,e){this.x=Qv(t),this.y=Qv(e);}},{key:"setText",value:function value(t){if(t instanceof Element){for(;this.frame.firstChild;)this.frame.removeChild(this.frame.firstChild);this.frame.appendChild(t);}else this.frame.innerText=t;}},{key:"show",value:function value(t){if(void 0===t&&(t=!0),!0===t){var e=this.frame.clientHeight,i=this.frame.clientWidth,n=this.frame.parentNode.clientHeight,o=this.frame.parentNode.clientWidth,r=0,s=0;if("flip"==this.overflowMethod){var a=!1,h=!0;this.y-e<this.padding&&(h=!1),this.x+i>o-this.padding&&(a=!0),r=a?this.x-i:this.x,s=h?this.y-e:this.y;}else(s=this.y-e)+e+this.padding>n&&(s=n-e-this.padding),s<this.padding&&(s=this.padding),(r=this.x)+i+this.padding>o&&(r=o-i-this.padding),r<this.padding&&(r=this.padding);this.frame.style.left=r+"px",this.frame.style.top=s+"px",this.frame.style.visibility="visible",this.hidden=!1;}else this.hide();}},{key:"hide",value:function value(){this.hidden=!0,this.frame.style.left="0",this.frame.style.top="0",this.frame.style.visibility="hidden";}},{key:"destroy",value:function value(){this.frame.parentNode.removeChild(this.frame);}}]),t;}(),Yb=!1,Xb="background: #FFeeee; color: #dd0000",Gb=function(){function t(){ph(this,t);}return xu(t,null,[{key:"validate",value:function value(e,i,n){Yb=!1,qb=i;var o=i;return void 0!==n&&(o=i[n]),t.parse(e,o,[]),Yb;}},{key:"parse",value:function value(e,i,n){for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.check(o,e,i,n);}},{key:"check",value:function value(e,i,n,o){if(void 0!==n[e]||void 0!==n.__any__){var r=e,s=!0;void 0===n[e]&&void 0!==n.__any__&&(r="__any__",s="object"===t.getType(i[e]));var a=n[r];s&&void 0!==a.__type__&&(a=a.__type__),t.checkFields(e,i,n,r,a,o);}else t.getSuggestion(e,n,o);}},{key:"checkFields",value:function value(e,i,n,o,r,s){var a=function a(i){console.error("%c"+i+t.printLocation(s,e),Xb);},h=t.getType(i[e]),l=r[h];void 0!==l?"array"===t.getType(l)&&-1===lg(l).call(l,i[e])?(a('Invalid option detected in "'+e+'". Allowed values are:'+t.print(l)+' not "'+i[e]+'". '),Yb=!0):"object"===h&&"__any__"!==o&&(s=yb(s,e),t.parse(i[e],n[o],s)):void 0===r.any&&(a('Invalid type received for "'+e+'". Expected: '+t.print(Hf(r))+". Received ["+h+'] "'+i[e]+'"'),Yb=!0);}},{key:"getType",value:function value(t){var e=bu(t);return"object"===e?null===t?"null":t instanceof Boolean?"boolean":t instanceof Number?"number":t instanceof String?"string":Df(t)?"array":t instanceof Date?"date":void 0!==t.nodeType?"dom":!0===t._isAMomentObject?"moment":"object":"number"===e?"number":"boolean"===e?"boolean":"string"===e?"string":void 0===e?"undefined":e;}},{key:"getSuggestion",value:function value(e,i,n){var o,r=t.findInOptions(e,i,n,!1),s=t.findInOptions(e,qb,[],!0);o=void 0!==r.indexMatch?" in "+t.printLocation(r.path,e,"")+'Perhaps it was incomplete? Did you mean: "'+r.indexMatch+'"?\n\n':s.distance<=4&&r.distance>s.distance?" in "+t.printLocation(r.path,e,"")+"Perhaps it was misplaced? Matching option found at: "+t.printLocation(s.path,s.closestMatch,""):r.distance<=8?'. Did you mean "'+r.closestMatch+'"?'+t.printLocation(r.path,e):". Did you mean one of these: "+t.print(Hf(i))+t.printLocation(n,e),console.error('%cUnknown option detected: "'+e+'"'+o,Xb),Yb=!0;}},{key:"findInOptions",value:function value(e,i,n){var o=arguments.length>3&&void 0!==arguments[3]&&arguments[3],r=1e9,s="",a=[],h=e.toLowerCase(),l=void 0;for(var d in i){var c=void 0;if(void 0!==i[d].__type__&&!0===o){var u=t.findInOptions(e,i[d],yb(n,d));r>u.distance&&(s=u.closestMatch,a=u.path,r=u.distance,l=u.indexMatch);}else{var f;-1!==lg(f=d.toLowerCase()).call(f,h)&&(l=d),r>(c=t.levenshteinDistance(e,d))&&(s=d,a=mb(n),r=c);}}return{closestMatch:s,path:a,distance:r,indexMatch:l};}},{key:"printLocation",value:function value(t,e){for(var i="\n\n"+(arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Problem value found at: \n")+"options = {\n",n=0;n<t.length;n++){for(var o=0;o<n+1;o++)i+="  ";i+=t[n]+": {\n";}for(var r=0;r<t.length+1;r++)i+="  ";i+=e+"\n";for(var s=0;s<t.length+1;s++){for(var a=0;a<t.length-s;a++)i+="  ";i+="}\n";}return i+"\n\n";}},{key:"print",value:function value(t){return mg(t).replace(/(")|(\[)|(\])|(,"__type__")/g,"").replace(/(,)/g,", ");}},{key:"levenshteinDistance",value:function value(t,e){if(0===t.length)return e.length;if(0===e.length)return t.length;var i,n,o=[];for(i=0;i<=e.length;i++)o[i]=[i];for(n=0;n<=t.length;n++)o[0][n]=n;for(i=1;i<=e.length;i++)for(n=1;n<=t.length;n++)e.charAt(i-1)==t.charAt(n-1)?o[i][n]=o[i-1][n-1]:o[i][n]=Math.min(o[i-1][n-1]+1,Math.min(o[i][n-1]+1,o[i-1][n]+1));return o[e.length][t.length];}}]),t;}(),Kb=eb,$b=Hb,Zb=Vb,Qb=tb,Jb=Ub,tw=Xb,ew=Gb,iw=Object.freeze({__proto__:null,Activator:Kb,Alea:Jm,ColorPicker:$b,Configurator:Zb,DELETE:Xm,HSVToHex:Db,HSVToRGB:Pb,Hammer:Qb,Popup:Jb,RGBToHSV:Tb,RGBToHex:Cb,VALIDATOR_PRINT_STYLE:tw,Validator:ew,addClassName:function addClassName(t,e){var i=t.className.split(" "),n=e.split(" ");i=_f(i).call(i,yv(n).call(n,function(t){return!rv(i).call(i,t);})),t.className=i.join(" ");},addCssText:function addCssText(t,e){for(var i=Mb(e),n=0,o=cg(i);n<o.length;n++){var r=pf(o[n],2),s=r[0],a=r[1];t.style.setProperty(s,a);}},addEventListener:function addEventListener(t,e,i,n){var o;t.addEventListener?(void 0===n&&(n=!1),"mousewheel"===e&&rv(o=navigator.userAgent).call(o,"Firefox")&&(e="DOMMouseScroll"),t.addEventListener(e,i,n)):t.attachEvent("on"+e,i);},binarySearchCustom:function binarySearchCustom(t,e,i,n){for(var o=0,r=0,s=t.length-1;r<=s&&o<1e4;){var a=Math.floor((r+s)/2),h=t[a],l=e(void 0===n?h[i]:h[i][n]);if(0==l)return a;-1==l?r=a+1:s=a-1,o++;}return-1;},binarySearchValue:function binarySearchValue(t,e,i,n,o){var r,s,a,h,l=0,d=0,c=t.length-1;for(o=null!=o?o:function(t,e){return t==e?0:t<e?-1:1;};d<=c&&l<1e4;){if(h=Math.floor(.5*(c+d)),r=t[Math.max(0,h-1)][i],s=t[h][i],a=t[Math.min(t.length-1,h+1)][i],0==o(s,e))return h;if(o(r,e)<0&&o(s,e)>0)return"before"==n?Math.max(0,h-1):h;if(o(s,e)<0&&o(a,e)>0)return"before"==n?h:Math.min(t.length-1,h+1);o(s,e)<0?d=h+1:c=h-1,l++;}return-1;},bridgeObject:zb,copyAndExtendArray:yb,copyArray:mb,deepExtend:gb,deepObjectAssign:Km,easingFunctions:jb,equalArray:function equalArray(t,e){if(t.length!==e.length)return!1;for(var i=0,n=t.length;i<n;i++)if(t[i]!=e[i])return!1;return!0;},extend:fb,fillIfDefined:ub,forEach:kb,getAbsoluteLeft:bb,getAbsoluteRight:function getAbsoluteRight(t){return t.getBoundingClientRect().right;},getAbsoluteTop:wb,getScrollBarWidth:function getScrollBarWidth(){var t=document.createElement("p");t.style.width="100%",t.style.height="200px";var e=document.createElement("div");e.style.position="absolute",e.style.top="0px",e.style.left="0px",e.style.visibility="hidden",e.style.width="200px",e.style.height="150px",e.style.overflow="hidden",e.appendChild(t),document.body.appendChild(e);var i=t.offsetWidth;e.style.overflow="scroll";var n=t.offsetWidth;return i==n&&(n=e.clientWidth),document.body.removeChild(e),i-n;},getTarget:function getTarget(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.event,e=null;return t&&(t.target?e=t.target:t.srcElement&&(e=t.srcElement)),e instanceof Element&&(null==e.nodeType||3!=e.nodeType||(e=e.parentNode)instanceof Element)?e:null;},getType:function getType(t){var e=bu(t);return"object"===e?null===t?"null":t instanceof Boolean?"Boolean":t instanceof Number?"Number":t instanceof String?"String":Df(t)?"Array":t instanceof Date?"Date":"Object":"number"===e?"Number":"boolean"===e?"Boolean":"string"===e?"String":void 0===e?"undefined":e;},hasParent:function hasParent(t,e){for(var i=t;i;){if(i===e)return!0;if(!i.parentNode)return!1;i=i.parentNode;}return!1;},hexToHSV:Ib,hexToRGB:Eb,insertSort:function insertSort(t,e){for(var i=0;i<t.length;i++){var n=t[i],o=void 0;for(o=i;o>0&&e(n,t[o-1])<0;o--)t[o]=t[o-1];t[o]=n;}return t;},isDate:function isDate(t){if(t instanceof Date)return!0;if(lb(t)){if(ib.exec(t))return!0;if(!isNaN(Date.parse(t)))return!0;}return!1;},isNumber:ab,isObject:db,isString:lb,isValidHex:Bb,isValidRGB:Nb,isValidRGBA:Fb,mergeOptions:Ab,option:xb,overrideOpacity:Ob,parseColor:Sb,preventDefault:function preventDefault(t){t||(t=window.event),t&&(t.preventDefault?t.preventDefault():t.returnValue=!1);},pureDeepObjectAssign:Gm,recursiveDOMDelete:hb,removeClassName:function removeClassName(t,e){var i=t.className.split(" "),n=e.split(" ");i=yv(i).call(i,function(t){return!rv(n).call(n,t);}),t.className=i.join(" ");},removeCssText:function removeCssText(t,e){for(var i=Mb(e),n=0,o=Hf(i);n<o.length;n++){var r=o[n];t.style.removeProperty(r);}},removeEventListener:function removeEventListener(t,e,i,n){var o;t.removeEventListener?(void 0===n&&(n=!1),"mousewheel"===e&&rv(o=navigator.userAgent).call(o,"Firefox")&&(e="DOMMouseScroll"),t.removeEventListener(e,i,n)):t.detachEvent("on"+e,i);},selectiveBridgeObject:function selectiveBridgeObject(t,e){if(null!==e&&"object"===bu(e)){for(var i=pg(e),n=0;n<t.length;n++)Object.prototype.hasOwnProperty.call(e,t[n])&&"object"==bu(e[t[n]])&&(i[t[n]]=zb(e[t[n]]));return i;}return null;},selectiveDeepExtend:pb,selectiveExtend:function selectiveExtend(t,e){if(!Df(t))throw new Error("Array with property names expected as first argument");for(var i=arguments.length,n=new Array(i>2?i-2:0),o=2;o<i;o++)n[o-2]=arguments[o];for(var r=0,s=n;r<s.length;r++)for(var a=s[r],h=0;h<t.length;h++){var l=t[h];a&&Object.prototype.hasOwnProperty.call(a,l)&&(e[l]=a[l]);}return e;},selectiveNotDeepExtend:vb,throttle:function throttle(t){var e=!1;return function(){e||(e=!0,requestAnimationFrame(function(){e=!1,t();}));};},toArray:_b,topMost:Rb,updateProperty:function updateProperty(t,e,i){return t[e]!==i&&(t[e]=i,!0);}});function nw(t){return hw=t,function(){var t={};lw=0,void(dw=hw.charAt(0)),kw(),"strict"===cw&&(t.strict=!0,kw());"graph"!==cw&&"digraph"!==cw||(t.type=cw,kw());uw===sw.IDENTIFIER&&(t.id=cw,kw());if("{"!=cw)throw Sw("Angle bracket { expected");if(kw(),_w(t),"}"!=cw)throw Sw("Angle bracket } expected");if(kw(),""!==cw)throw Sw("End of file expected");return kw(),delete t.node,delete t.edge,delete t.graph,t;}();}var ow={fontsize:"font.size",fontcolor:"font.color",labelfontcolor:"font.color",fontname:"font.face",color:["color.border","color.background"],fillcolor:"color.background",tooltip:"title",labeltooltip:"title"},rw=pg(ow);rw.color="color.color",rw.style="dashes";var sw={NULL:0,DELIMITER:1,IDENTIFIER:2,UNKNOWN:3},aw={"{":!0,"}":!0,"[":!0,"]":!0,";":!0,"=":!0,",":!0,"->":!0,"--":!0},hw="",lw=0,dw="",cw="",uw=sw.NULL;function fw(){lw++,dw=hw.charAt(lw);}function pw(){return hw.charAt(lw+1);}function vw(t){var e=t.charCodeAt(0);return e<47?35===e||46===e:e<59?e>47:e<91?e>64:e<96?95===e:e<123&&e>96;}function gw(t,e){if(t||(t={}),e)for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i]);return t;}function yw(t,e,i){for(var n=e.split("."),o=t;n.length;){var r=n.shift();n.length?(o[r]||(o[r]={}),o=o[r]):o[r]=i;}}function mw(t,e){for(var i,n,o=null,r=[t],s=t;s.parent;)r.push(s.parent),s=s.parent;if(s.nodes)for(i=0,n=s.nodes.length;i<n;i++)if(e.id===s.nodes[i].id){o=s.nodes[i];break;}for(o||(o={id:e.id},t.node&&(o.attr=gw(o.attr,t.node))),i=r.length-1;i>=0;i--){var a,h=r[i];h.nodes||(h.nodes=[]),-1===lg(a=h.nodes).call(a,o)&&h.nodes.push(o);}e.attr&&(o.attr=gw(o.attr,e.attr));}function bw(t,e){if(t.edges||(t.edges=[]),t.edges.push(e),t.edge){var i=gw({},t.edge);e.attr=gw(i,e.attr);}}function ww(t,e,i,n,o){var r={from:e,to:i,type:n};return t.edge&&(r.attr=gw({},t.edge)),r.attr=gw(r.attr||{},o),null!=o&&o.hasOwnProperty("arrows")&&null!=o.arrows&&(r.arrows={to:{enabled:!0,type:o.arrows.type}},o.arrows=null),r;}function kw(){for(uw=sw.NULL,cw="";" "===dw||"\t"===dw||"\n"===dw||"\r"===dw;)fw();do{var t=!1;if("#"===dw){for(var e=lw-1;" "===hw.charAt(e)||"\t"===hw.charAt(e);)e--;if("\n"===hw.charAt(e)||""===hw.charAt(e)){for(;""!=dw&&"\n"!=dw;)fw();t=!0;}}if("/"===dw&&"/"===pw()){for(;""!=dw&&"\n"!=dw;)fw();t=!0;}if("/"===dw&&"*"===pw()){for(;""!=dw;){if("*"===dw&&"/"===pw()){fw(),fw();break;}fw();}t=!0;}for(;" "===dw||"\t"===dw||"\n"===dw||"\r"===dw;)fw();}while(t);if(""!==dw){var i=dw+pw();if(aw[i])return uw=sw.DELIMITER,cw=i,fw(),void fw();if(aw[dw])return uw=sw.DELIMITER,cw=dw,void fw();if(vw(dw)||"-"===dw){for(cw+=dw,fw();vw(dw);)cw+=dw,fw();return"false"===cw?cw=!1:"true"===cw?cw=!0:isNaN(Number(cw))||(cw=Number(cw)),void(uw=sw.IDENTIFIER);}if('"'===dw){for(fw();""!=dw&&('"'!=dw||'"'===dw&&'"'===pw());)'"'===dw?(cw+=dw,fw()):"\\"===dw&&"n"===pw()?(cw+="\n",fw()):cw+=dw,fw();if('"'!=dw)throw Sw('End of string " expected');return fw(),void(uw=sw.IDENTIFIER);}for(uw=sw.UNKNOWN;""!=dw;)cw+=dw,fw();throw new SyntaxError('Syntax error in part "'+Tw(cw,30)+'"');}uw=sw.DELIMITER;}function _w(t){for(;""!==cw&&"}"!=cw;)xw(t),";"===cw&&kw();}function xw(t){var e=Ew(t);if(e)Ow(t,e);else{var i=function(t){if("node"===cw)return kw(),t.node=Cw(),"node";if("edge"===cw)return kw(),t.edge=Cw(),"edge";if("graph"===cw)return kw(),t.graph=Cw(),"graph";return null;}(t);if(!i){if(uw!=sw.IDENTIFIER)throw Sw("Identifier expected");var n=cw;if(kw(),"="===cw){if(kw(),uw!=sw.IDENTIFIER)throw Sw("Identifier expected");t[n]=cw,kw();}else!function(t,e){var i={id:e},n=Cw();n&&(i.attr=n);mw(t,i),Ow(t,e);}(t,n);}}}function Ew(t){var e=null;if("subgraph"===cw&&((e={}).type="subgraph",kw(),uw===sw.IDENTIFIER&&(e.id=cw,kw())),"{"===cw){if(kw(),e||(e={}),e.parent=t,e.node=t.node,e.edge=t.edge,e.graph=t.graph,_w(e),"}"!=cw)throw Sw("Angle bracket } expected");kw(),delete e.node,delete e.edge,delete e.graph,delete e.parent,t.subgraphs||(t.subgraphs=[]),t.subgraphs.push(e);}return e;}function Ow(t,e){for(;"->"===cw||"--"===cw;){var i,n=cw;kw();var o=Ew(t);if(o)i=o;else{if(uw!=sw.IDENTIFIER)throw Sw("Identifier or subgraph expected");mw(t,{id:i=cw}),kw();}bw(t,ww(t,e,i,n,Cw())),e=i;}}function Cw(){for(var t,e,i=null,n={dashed:!0,solid:!1,dotted:[1,5]},o={dot:"circle",box:"box",crow:"crow",curve:"curve",icurve:"inv_curve",normal:"triangle",inv:"inv_triangle",diamond:"diamond",tee:"bar",vee:"vee"},r=new Array(),s=new Array();"["===cw;){for(kw(),i={};""!==cw&&"]"!=cw;){if(uw!=sw.IDENTIFIER)throw Sw("Attribute name expected");var a=cw;if(kw(),"="!=cw)throw Sw("Equal sign = expected");if(kw(),uw!=sw.IDENTIFIER)throw Sw("Attribute value expected");var h=cw;"style"===a&&(h=n[h]),"arrowhead"===a&&(a="arrows",h={to:{enabled:!0,type:o[h]}}),"arrowtail"===a&&(a="arrows",h={from:{enabled:!0,type:o[h]}}),r.push({attr:i,name:a,value:h}),s.push(a),kw(),","==cw&&kw();}if("]"!=cw)throw Sw("Bracket ] expected");kw();}if(rv(s).call(s,"dir")){var l={arrows:{}};for(t=0;t<r.length;t++)if("arrows"===r[t].name){if(null!=r[t].value.to)l.arrows.to=t;else{if(null==r[t].value.from)throw Sw("Invalid value of arrows");l.arrows.from=t;}}else"dir"===r[t].name&&(l.dir=t);var d,c,u=r[l.dir].value;if(!rv(s).call(s,"arrows"))if("both"===u)r.push({attr:r[l.dir].attr,name:"arrows",value:{to:{enabled:!0}}}),l.arrows.to=r.length-1,r.push({attr:r[l.dir].attr,name:"arrows",value:{from:{enabled:!0}}}),l.arrows.from=r.length-1;else if("forward"===u)r.push({attr:r[l.dir].attr,name:"arrows",value:{to:{enabled:!0}}}),l.arrows.to=r.length-1;else if("back"===u)r.push({attr:r[l.dir].attr,name:"arrows",value:{from:{enabled:!0}}}),l.arrows.from=r.length-1;else{if("none"!==u)throw Sw('Invalid dir type "'+u+'"');r.push({attr:r[l.dir].attr,name:"arrows",value:""}),l.arrows.to=r.length-1;}if("both"===u)l.arrows.to&&l.arrows.from?(c=r[l.arrows.to].value.to.type,d=r[l.arrows.from].value.from.type,r[l.arrows.to]={attr:r[l.arrows.to].attr,name:r[l.arrows.to].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}},Ap(r).call(r,l.arrows.from,1)):l.arrows.to?(c=r[l.arrows.to].value.to.type,d="arrow",r[l.arrows.to]={attr:r[l.arrows.to].attr,name:r[l.arrows.to].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}):l.arrows.from&&(c="arrow",d=r[l.arrows.from].value.from.type,r[l.arrows.from]={attr:r[l.arrows.from].attr,name:r[l.arrows.from].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}});else if("back"===u)l.arrows.to&&l.arrows.from?(c="",d=r[l.arrows.from].value.from.type,r[l.arrows.from]={attr:r[l.arrows.from].attr,name:r[l.arrows.from].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}):l.arrows.to?(c="",d="arrow",l.arrows.from=l.arrows.to,r[l.arrows.from]={attr:r[l.arrows.from].attr,name:r[l.arrows.from].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}):l.arrows.from&&(c="",d=r[l.arrows.from].value.from.type,r[l.arrows.to]={attr:r[l.arrows.from].attr,name:r[l.arrows.from].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}),r[l.arrows.from]={attr:r[l.arrows.from].attr,name:r[l.arrows.from].name,value:{from:{enabled:!0,type:r[l.arrows.from].value.from.type}}};else if("none"===u){var f;r[f=l.arrows.to?l.arrows.to:l.arrows.from]={attr:r[f].attr,name:r[f].name,value:""};}else{if("forward"!==u)throw Sw('Invalid dir type "'+u+'"');l.arrows.to&&l.arrows.from||l.arrows.to?(c=r[l.arrows.to].value.to.type,d="",r[l.arrows.to]={attr:r[l.arrows.to].attr,name:r[l.arrows.to].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}):l.arrows.from&&(c="arrow",d="",l.arrows.to=l.arrows.from,r[l.arrows.to]={attr:r[l.arrows.to].attr,name:r[l.arrows.to].name,value:{to:{enabled:!0,type:c},from:{enabled:!0,type:d}}}),r[l.arrows.to]={attr:r[l.arrows.to].attr,name:r[l.arrows.to].name,value:{to:{enabled:!0,type:r[l.arrows.to].value.to.type}}};}Ap(r).call(r,l.dir,1);}if(rv(s).call(s,"penwidth")){var p=[];for(e=r.length,t=0;t<e;t++)"width"!==r[t].name&&("penwidth"===r[t].name&&(r[t].name="width"),p.push(r[t]));r=p;}for(e=r.length,t=0;t<e;t++)yw(r[t].attr,r[t].name,r[t].value);return i;}function Sw(t){return new SyntaxError(t+', got "'+Tw(cw,30)+'" (char '+lw+")");}function Tw(t,e){return t.length<=e?t:t.substr(0,27)+"...";}function Mw(t,e,i){for(var n=e.split("."),o=n.pop(),r=t,s=0;s<n.length;s++){var a=n[s];a in r||(r[a]={}),r=r[a];}return r[o]=i,t;}function Pw(t,e){var i={};for(var n in t)if(t.hasOwnProperty(n)){var o=e[n];Df(o)?op(o).call(o,function(e){Mw(i,e,t[n]);}):Mw(i,"string"==typeof o?o:n,t[n]);}return i;}function Dw(t){var e,i=nw(t),n={nodes:[],edges:[],options:{}};i.nodes&&op(e=i.nodes).call(e,function(t){var e={id:t.id,label:String(t.label||t.id)};gw(e,Pw(t.attr,ow)),e.image&&(e.shape="image"),n.nodes.push(e);});if(i.edges){var o,r=function r(t){var e={from:t.from,to:t.to};return gw(e,Pw(t.attr,rw)),null==e.arrows&&"->"===t.type&&(e.arrows="to"),e;};op(o=i.edges).call(o,function(t){var e,i,o,s,a,h,l;(e=t.from instanceof Object?t.from.nodes:{id:t.from},i=t.to instanceof Object?t.to.nodes:{id:t.to},t.from instanceof Object&&t.from.edges)&&op(o=t.from.edges).call(o,function(t){var e=r(t);n.edges.push(e);});(a=i,h=function h(e,i){var o=ww(n,e.id,i.id,t.type,t.attr),s=r(o);n.edges.push(s);},Df(s=e)?op(s).call(s,function(t){Df(a)?op(a).call(a,function(e){h(t,e);}):h(t,a);}):Df(a)?op(a).call(a,function(t){h(s,t);}):h(s,a),t.to instanceof Object&&t.to.edges)&&op(l=t.to.edges).call(l,function(t){var e=r(t);n.edges.push(e);});});}return i.attr&&(n.options=i.attr),n;}var Iw=Object.freeze({__proto__:null,DOTToGraph:Dw,parseDOT:nw});function Bw(t,e){var i,n={edges:{inheritColor:!1},nodes:{fixed:!1,parseColor:!1}};null!=e&&(null!=e.fixed&&(n.nodes.fixed=e.fixed),null!=e.parseColor&&(n.nodes.parseColor=e.parseColor),null!=e.inheritColor&&(n.edges.inheritColor=e.inheritColor));var o=t.edges,r=jf(o).call(o,function(t){var e={from:t.source,id:t.id,to:t.target};return null!=t.attributes&&(e.attributes=t.attributes),null!=t.label&&(e.label=t.label),null!=t.attributes&&null!=t.attributes.title&&(e.title=t.attributes.title),"Directed"===t.type&&(e.arrows="to"),t.color&&!1===n.edges.inheritColor&&(e.color=t.color),e;});return{nodes:jf(i=t.nodes).call(i,function(t){var e={id:t.id,fixed:n.nodes.fixed&&null!=t.x&&null!=t.y};return null!=t.attributes&&(e.attributes=t.attributes),null!=t.label&&(e.label=t.label),null!=t.size&&(e.size=t.size),null!=t.attributes&&null!=t.attributes.title&&(e.title=t.attributes.title),null!=t.title&&(e.title=t.title),null!=t.x&&(e.x=t.x),null!=t.y&&(e.y=t.y),null!=t.color&&(!0===n.nodes.parseColor?e.color=t.color:e.color={background:t.color,border:t.color,highlight:{background:t.color,border:t.color},hover:{background:t.color,border:t.color}}),e;}),edges:r};}var Nw=Object.freeze({__proto__:null,parseGephi:Bw}),Fw=Object.freeze({__proto__:null,cn:{addDescription:"单击空白处放置新节点。",addEdge:"添加连接线",addNode:"添加节点",back:"返回",close:"關閉",createEdgeError:"无法将连接线连接到群集。",del:"删除选定",deleteClusterError:"无法删除群集。",edgeDescription:"单击某个节点并将该连接线拖动到另一个节点以连接它们。",edit:"编辑",editClusterError:"无法编辑群集。",editEdge:"编辑连接线",editEdgeDescription:"单击控制节点并将它们拖到节点上连接。",editNode:"编辑节点"},cs:{addDescription:"Kluknutím do prázdného prostoru můžete přidat nový vrchol.",addEdge:"Přidat hranu",addNode:"Přidat vrchol",back:"Zpět",close:"Zavřít",createEdgeError:"Nelze připojit hranu ke shluku.",del:"Smazat výběr",deleteClusterError:"Nelze mazat shluky.",edgeDescription:"Přetažením z jednoho vrcholu do druhého můžete spojit tyto vrcholy novou hranou.",edit:"Upravit",editClusterError:"Nelze upravovat shluky.",editEdge:"Upravit hranu",editEdgeDescription:"Přetažením kontrolního vrcholu hrany ji můžete připojit k jinému vrcholu.",editNode:"Upravit vrchol"},de:{addDescription:"Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.",addEdge:"Kante hinzufügen",addNode:"Knoten hinzufügen",back:"Zurück",close:"Schließen",createEdgeError:"Es ist nicht möglich, Kanten mit Clustern zu verbinden.",del:"Lösche Auswahl",deleteClusterError:"Cluster können nicht gelöscht werden.",edgeDescription:"Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.",edit:"Editieren",editClusterError:"Cluster können nicht editiert werden.",editEdge:"Kante editieren",editEdgeDescription:"Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.",editNode:"Knoten editieren"},en:{addDescription:"Click in an empty space to place a new node.",addEdge:"Add Edge",addNode:"Add Node",back:"Back",close:"Close",createEdgeError:"Cannot link edges to a cluster.",del:"Delete selected",deleteClusterError:"Clusters cannot be deleted.",edgeDescription:"Click on a node and drag the edge to another node to connect them.",edit:"Edit",editClusterError:"Clusters cannot be edited.",editEdge:"Edit Edge",editEdgeDescription:"Click on the control points and drag them to a node to connect to it.",editNode:"Edit Node"},es:{addDescription:"Haga clic en un lugar vacío para colocar un nuevo nodo.",addEdge:"Añadir arista",addNode:"Añadir nodo",back:"Atrás",close:"Cerrar",createEdgeError:"No se puede conectar una arista a un grupo.",del:"Eliminar selección",deleteClusterError:"No es posible eliminar grupos.",edgeDescription:"Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.",edit:"Editar",editClusterError:"No es posible editar grupos.",editEdge:"Editar arista",editEdgeDescription:"Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.",editNode:"Editar nodo"},fr:{addDescription:"Cliquez dans un endroit vide pour placer un nœud.",addEdge:"Ajouter un lien",addNode:"Ajouter un nœud",back:"Retour",close:"Fermer",createEdgeError:"Impossible de créer un lien vers un cluster.",del:"Effacer la sélection",deleteClusterError:"Les clusters ne peuvent pas être effacés.",edgeDescription:"Cliquez sur un nœud et glissez le lien vers un autre nœud pour les connecter.",edit:"Éditer",editClusterError:"Les clusters ne peuvent pas être édités.",editEdge:"Éditer le lien",editEdgeDescription:"Cliquez sur les points de contrôle et glissez-les pour connecter un nœud.",editNode:"Éditer le nœud"},it:{addDescription:"Clicca per aggiungere un nuovo nodo",addEdge:"Aggiungi un vertice",addNode:"Aggiungi un nodo",back:"Indietro",close:"Chiudere",createEdgeError:"Non si possono collegare vertici ad un cluster",del:"Cancella la selezione",deleteClusterError:"I cluster non possono essere cancellati",edgeDescription:"Clicca su un nodo e trascinalo ad un altro nodo per connetterli.",edit:"Modifica",editClusterError:"I clusters non possono essere modificati.",editEdge:"Modifica il vertice",editEdgeDescription:"Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.",editNode:"Modifica il nodo"},nl:{addDescription:"Klik op een leeg gebied om een nieuwe node te maken.",addEdge:"Link toevoegen",addNode:"Node toevoegen",back:"Terug",close:"Sluiten",createEdgeError:"Kan geen link maken naar een cluster.",del:"Selectie verwijderen",deleteClusterError:"Clusters kunnen niet worden verwijderd.",edgeDescription:"Klik op een node en sleep de link naar een andere node om ze te verbinden.",edit:"Wijzigen",editClusterError:"Clusters kunnen niet worden aangepast.",editEdge:"Link wijzigen",editEdgeDescription:"Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.",editNode:"Node wijzigen"},pt:{addDescription:"Clique em um espaço em branco para adicionar um novo nó",addEdge:"Adicionar aresta",addNode:"Adicionar nó",back:"Voltar",close:"Fechar",createEdgeError:"Não foi possível linkar arestas a um cluster.",del:"Remover selecionado",deleteClusterError:"Clusters não puderam ser removidos.",edgeDescription:"Clique em um nó e arraste a aresta até outro nó para conectá-los",edit:"Editar",editClusterError:"Clusters não puderam ser editados.",editEdge:"Editar aresta",editEdgeDescription:"Clique nos pontos de controle e os arraste para um nó para conectá-los",editNode:"Editar nó"},ru:{addDescription:"Кликните в свободное место, чтобы добавить новый узел.",addEdge:"Добавить ребро",addNode:"Добавить узел",back:"Назад",close:"Закрывать",createEdgeError:"Невозможно соединить ребра в кластер.",del:"Удалить выбранное",deleteClusterError:"Кластеры не могут быть удалены",edgeDescription:"Кликните на узел и протяните ребро к другому узлу, чтобы соединить их.",edit:"Редактировать",editClusterError:"Кластеры недоступны для редактирования.",editEdge:"Редактировать ребро",editEdgeDescription:"Кликните на контрольные точки и перетащите их в узел, чтобы подключиться к нему.",editNode:"Редактировать узел"},uk:{addDescription:"Kлікніть на вільне місце, щоб додати новий вузол.",addEdge:"Додати край",addNode:"Додати вузол",back:"Назад",close:"Закрити",createEdgeError:"Не можливо об'єднати краї в групу.",del:"Видалити обране",deleteClusterError:"Групи не можуть бути видалені.",edgeDescription:"Клікніть на вузол і перетягніть край до іншого вузла, щоб їх з'єднати.",edit:"Редагувати",editClusterError:"Групи недоступні для редагування.",editEdge:"Редагувати край",editEdgeDescription:"Клікніть на контрольні точки і перетягніть їх у вузол, щоб підключитися до нього.",editNode:"Редагувати вузол"}});var zw=function(){function t(){ph(this,t),this.NUM_ITERATIONS=4,this.image=new Image(),this.canvas=document.createElement("canvas");}return xu(t,[{key:"init",value:function value(){if(!this.initialized()){this.src=this.image.src;var t=this.image.width,e=this.image.height;this.width=t,this.height=e;var i=Math.floor(e/2),n=Math.floor(e/4),o=Math.floor(e/8),r=Math.floor(e/16),s=Math.floor(t/2),a=Math.floor(t/4),h=Math.floor(t/8),l=Math.floor(t/16);this.canvas.width=3*a,this.canvas.height=i,this.coordinates=[[0,0,s,i],[s,0,a,n],[s,n,h,o],[5*h,n,l,r]],this._fillMipMap();}}},{key:"initialized",value:function value(){return void 0!==this.coordinates;}},{key:"_fillMipMap",value:function value(){var t=this.canvas.getContext("2d"),e=this.coordinates[0];t.drawImage(this.image,e[0],e[1],e[2],e[3]);for(var i=1;i<this.NUM_ITERATIONS;i++){var n=this.coordinates[i-1],o=this.coordinates[i];t.drawImage(this.canvas,n[0],n[1],n[2],n[3],o[0],o[1],o[2],o[3]);}}},{key:"drawImageAtPosition",value:function value(t,e,i,n,o,r){if(this.initialized())if(e>2){e*=.5;for(var s=0;e>2&&s<this.NUM_ITERATIONS;)e*=.5,s+=1;s>=this.NUM_ITERATIONS&&(s=this.NUM_ITERATIONS-1);var a=this.coordinates[s];t.drawImage(this.canvas,a[0],a[1],a[2],a[3],i,n,o,r);}else t.drawImage(this.image,i,n,o,r);}}]),t;}(),Aw=function(){function t(e){ph(this,t),this.images={},this.imageBroken={},this.callback=e;}return xu(t,[{key:"_tryloadBrokenUrl",value:function value(t,e,i){void 0!==t&&void 0!==i&&(void 0!==e?(i.image.onerror=function(){console.error("Could not load brokenImage:",e);},i.image.src=e):console.warn("No broken url image defined"));}},{key:"_redrawWithImage",value:function value(t){this.callback&&this.callback(t);}},{key:"load",value:function value(t,e){var i=this,n=this.images[t];if(n)return n;var o=new zw();return this.images[t]=o,o.image.onload=function(){i._fixImageCoordinates(o.image),o.init(),i._redrawWithImage(o);},o.image.onerror=function(){console.error("Could not load image:",t),i._tryloadBrokenUrl(t,e,o);},o.image.src=t,o;}},{key:"_fixImageCoordinates",value:function value(t){0===t.width&&(document.body.appendChild(t),t.width=t.offsetWidth,t.height=t.offsetHeight,document.body.removeChild(t));}}]),t;}(),jw={exports:{}},Rw=r(function(){if("function"==typeof ArrayBuffer){var t=new ArrayBuffer(8);Object.isExtensible(t)&&Object.defineProperty(t,"a",{value:8});}}),Lw=r,Hw=tt,Ww=w,qw=Rw,Vw=Object.isExtensible,Uw=Lw(function(){Vw(1);})||qw?function(t){return!!Hw(t)&&(!qw||"ArrayBuffer"!==Ww(t))&&(!Vw||Vw(t));}:Vw,Yw=!r(function(){return Object.isExtensible(Object.preventExtensions({}));}),Xw=Ti,Gw=g,Kw=Yi,$w=tt,Zw=Qt,Qw=Ze.f,Jw=Jh,tk=il,ek=Uw,ik=Yw,nk=!1,ok=ne("meta"),rk=0,sk=function sk(t){Qw(t,ok,{value:{objectID:"O"+rk++,weakData:{}}});},ak=jw.exports={enable:function enable(){ak.enable=function(){},nk=!0;var t=Jw.f,e=Gw([].splice),i={};i[ok]=1,t(i).length&&(Jw.f=function(i){for(var n=t(i),o=0,r=n.length;o<r;o++)if(n[o]===ok){e(n,o,1);break;}return n;},Xw({target:"Object",stat:!0,forced:!0},{getOwnPropertyNames:tk.f}));},fastKey:function fastKey(t,e){if(!$w(t))return"symbol"==_typeof(t)?t:("string"==typeof t?"S":"P")+t;if(!Zw(t,ok)){if(!ek(t))return"F";if(!e)return"E";sk(t);}return t[ok].objectID;},getWeakData:function getWeakData(t,e){if(!Zw(t,ok)){if(!ek(t))return!0;if(!e)return!1;sk(t);}return t[ok].weakData;},onFreeze:function onFreeze(t){return ik&&nk&&ek(t)&&!Zw(t,ok)&&sk(t),t;}};Kw[ok]=!0;var hk=jw.exports,lk=$e,dk=I,ck=ii,uk=St,fk=Ys,pk=Li,vk=at,gk=Sa,yk=wa,mk=Ls,bk=TypeError,wk=function wk(t,e){this.stopped=t,this.result=e;},kk=wk.prototype,_k=function _k(t,e,i){var n,o,r,s,a,h,l,d=i&&i.that,c=!(!i||!i.AS_ENTRIES),u=!(!i||!i.IS_RECORD),f=!(!i||!i.IS_ITERATOR),p=!(!i||!i.INTERRUPTED),v=lk(e,d),g=function g(t){return n&&mk(n,"normal",t),new wk(!0,t);},y=function y(t){return c?(ck(t),p?v(t[0],t[1],g):v(t[0],t[1])):p?v(t,g):v(t);};if(u)n=t.iterator;else if(f)n=t;else{if(!(o=yk(t)))throw new bk(uk(t)+" is not iterable");if(fk(o)){for(r=0,s=pk(t);s>r;r++)if((a=y(t[r]))&&vk(kk,a))return a;return new wk(!1);}n=gk(t,o);}for(h=u?t.next:n.next;!(l=dk(h,n)).done;){try{a=y(l.value);}catch(t){mk(n,"throw",t);}if("object"==_typeof(a)&&a&&vk(kk,a))return a;}return new wk(!1);},xk=at,Ek=TypeError,Ok=function Ok(t,e){if(xk(e,t))return t;throw new Ek("Incorrect invocation");},Ck=Ti,Sk=o,Tk=hk,Mk=r,Pk=gi,Dk=_k,Ik=Ok,Bk=S,Nk=tt,Fk=U,zk=Gr,Ak=Ze.f,jk=Fl.forEach,Rk=M,Lk=Lo.set,Hk=Lo.getterFor,Wk=function Wk(t,e,i){var n,o=-1!==t.indexOf("Map"),r=-1!==t.indexOf("Weak"),s=o?"set":"add",a=Sk[t],h=a&&a.prototype,l={};if(Rk&&Bk(a)&&(r||h.forEach&&!Mk(function(){new a().entries().next();}))){var d=(n=e(function(e,i){Lk(Ik(e,d),{type:t,collection:new a()}),Fk(i)||Dk(i,e[s],{that:e,AS_ENTRIES:o});})).prototype,c=Hk(t);jk(["add","clear","delete","forEach","get","has","set","keys","values","entries"],function(t){var e="add"===t||"set"===t;!(t in h)||r&&"clear"===t||Pk(d,t,function(i,n){var o=c(this).collection;if(!e&&r&&!Nk(i))return"get"===t&&void 0;var s=o[t](0===i?0:i,n);return e?this:s;});}),r||Ak(d,"size",{configurable:!0,get:function get(){return c(this).collection.size;}});}else n=i.getConstructor(e,t,o,s),Tk.enable();return zk(n,t,!1,!0),l[t]=n,Ck({global:!0,forced:!0},l),r||i.setStrong(n,t,o),n;},qk=Mr,Vk=function Vk(t,e,i){for(var n in e)i&&i.unsafe&&t[n]?t[n]=e[n]:qk(t,n,e[n],i);return t;},Uk=st,Yk=vl,Xk=M,Gk=ue("species"),Kk=function Kk(t){var e=Uk(t);Xk&&e&&!e[Gk]&&Yk(e,Gk,{configurable:!0,get:function get(){return this;}});},$k=mr,Zk=vl,Qk=Vk,Jk=$e,t_=Ok,e_=U,i_=_k,n_=Ss,o_=Ts,r_=Kk,s_=M,a_=hk.fastKey,h_=Lo.set,l_=Lo.getterFor,d_={getConstructor:function getConstructor(t,e,i,n){var o=t(function(t,o){t_(t,r),h_(t,{type:e,index:$k(null),first:void 0,last:void 0,size:0}),s_||(t.size=0),e_(o)||i_(o,t[n],{that:t,AS_ENTRIES:i});}),r=o.prototype,s=l_(e),a=function a(t,e,i){var n,o,r=s(t),a=h(t,e);return a?a.value=i:(r.last=a={index:o=a_(e,!0),key:e,value:i,previous:n=r.last,next:void 0,removed:!1},r.first||(r.first=a),n&&(n.next=a),s_?r.size++:t.size++,"F"!==o&&(r.index[o]=a)),t;},h=function h(t,e){var i,n=s(t),o=a_(e);if("F"!==o)return n.index[o];for(i=n.first;i;i=i.next)if(i.key===e)return i;};return Qk(r,{clear:function clear(){for(var t=s(this),e=t.index,i=t.first;i;)i.removed=!0,i.previous&&(i.previous=i.previous.next=void 0),delete e[i.index],i=i.next;t.first=t.last=void 0,s_?t.size=0:this.size=0;},"delete":function _delete(t){var e=this,i=s(e),n=h(e,t);if(n){var o=n.next,r=n.previous;delete i.index[n.index],n.removed=!0,r&&(r.next=o),o&&(o.previous=r),i.first===n&&(i.first=o),i.last===n&&(i.last=r),s_?i.size--:e.size--;}return!!n;},forEach:function forEach(t){for(var e,i=s(this),n=Jk(t,arguments.length>1?arguments[1]:void 0);e=e?e.next:i.first;)for(n(e.value,e.key,this);e&&e.removed;)e=e.previous;},has:function has(t){return!!h(this,t);}}),Qk(r,i?{get:function get(t){var e=h(this,t);return e&&e.value;},set:function set(t,e){return a(this,0===t?0:t,e);}}:{add:function add(t){return a(this,t=0===t?0:t,t);}}),s_&&Zk(r,"size",{configurable:!0,get:function get(){return s(this).size;}}),o;},setStrong:function setStrong(t,e,i){var n=e+" Iterator",o=l_(e),r=l_(n);n_(t,e,function(t,e){h_(this,{type:n,target:t,state:o(t),kind:e,last:void 0});},function(){for(var t=r(this),e=t.kind,i=t.last;i&&i.removed;)i=i.previous;return t.target&&(t.last=i=i?i.next:t.state.first)?o_("keys"===e?i.key:"values"===e?i.value:[i.key,i.value],!1):(t.target=void 0,o_(void 0,!0));},i?"entries":"values",!i,!0),r_(e);}};Wk("Map",function(t){return function(){return t(this,arguments.length?arguments[0]:void 0);};},d_);var c_=i(et.Map),u_=function(){function t(){ph(this,t),this.clear(),this._defaultIndex=0,this._groupIndex=0,this._defaultGroups=[{border:"#2B7CE9",background:"#97C2FC",highlight:{border:"#2B7CE9",background:"#D2E5FF"},hover:{border:"#2B7CE9",background:"#D2E5FF"}},{border:"#FFA500",background:"#FFFF00",highlight:{border:"#FFA500",background:"#FFFFA3"},hover:{border:"#FFA500",background:"#FFFFA3"}},{border:"#FA0A10",background:"#FB7E81",highlight:{border:"#FA0A10",background:"#FFAFB1"},hover:{border:"#FA0A10",background:"#FFAFB1"}},{border:"#41A906",background:"#7BE141",highlight:{border:"#41A906",background:"#A1EC76"},hover:{border:"#41A906",background:"#A1EC76"}},{border:"#E129F0",background:"#EB7DF4",highlight:{border:"#E129F0",background:"#F0B3F5"},hover:{border:"#E129F0",background:"#F0B3F5"}},{border:"#7C29F0",background:"#AD85E4",highlight:{border:"#7C29F0",background:"#D3BDF0"},hover:{border:"#7C29F0",background:"#D3BDF0"}},{border:"#C37F00",background:"#FFA807",highlight:{border:"#C37F00",background:"#FFCA66"},hover:{border:"#C37F00",background:"#FFCA66"}},{border:"#4220FB",background:"#6E6EFD",highlight:{border:"#4220FB",background:"#9B9BFD"},hover:{border:"#4220FB",background:"#9B9BFD"}},{border:"#FD5A77",background:"#FFC0CB",highlight:{border:"#FD5A77",background:"#FFD1D9"},hover:{border:"#FD5A77",background:"#FFD1D9"}},{border:"#4AD63A",background:"#C2FABC",highlight:{border:"#4AD63A",background:"#E6FFE3"},hover:{border:"#4AD63A",background:"#E6FFE3"}},{border:"#990000",background:"#EE0000",highlight:{border:"#BB0000",background:"#FF3333"},hover:{border:"#BB0000",background:"#FF3333"}},{border:"#FF6000",background:"#FF6000",highlight:{border:"#FF6000",background:"#FF6000"},hover:{border:"#FF6000",background:"#FF6000"}},{border:"#97C2FC",background:"#2B7CE9",highlight:{border:"#D2E5FF",background:"#2B7CE9"},hover:{border:"#D2E5FF",background:"#2B7CE9"}},{border:"#399605",background:"#255C03",highlight:{border:"#399605",background:"#255C03"},hover:{border:"#399605",background:"#255C03"}},{border:"#B70054",background:"#FF007E",highlight:{border:"#B70054",background:"#FF007E"},hover:{border:"#B70054",background:"#FF007E"}},{border:"#AD85E4",background:"#7C29F0",highlight:{border:"#D3BDF0",background:"#7C29F0"},hover:{border:"#D3BDF0",background:"#7C29F0"}},{border:"#4557FA",background:"#000EA1",highlight:{border:"#6E6EFD",background:"#000EA1"},hover:{border:"#6E6EFD",background:"#000EA1"}},{border:"#FFC0CB",background:"#FD5A77",highlight:{border:"#FFD1D9",background:"#FD5A77"},hover:{border:"#FFD1D9",background:"#FD5A77"}},{border:"#C2FABC",background:"#74D66A",highlight:{border:"#E6FFE3",background:"#74D66A"},hover:{border:"#E6FFE3",background:"#74D66A"}},{border:"#EE0000",background:"#990000",highlight:{border:"#FF3333",background:"#BB0000"},hover:{border:"#FF3333",background:"#BB0000"}}],this.options={},this.defaultOptions={useDefaultGroups:!0},bn(this.options,this.defaultOptions);}return xu(t,[{key:"setOptions",value:function value(t){var e=["useDefaultGroups"];if(void 0!==t)for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&-1===lg(e).call(e,i)){var n=t[i];this.add(i,n);}}},{key:"clear",value:function value(){this._groups=new c_(),this._groupNames=[];}},{key:"get",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this._groups.get(t);if(void 0===i&&e)if(!1===this.options.useDefaultGroups&&this._groupNames.length>0){var n=this._groupIndex%this._groupNames.length;++this._groupIndex,(i={}).color=this._groups.get(this._groupNames[n]),this._groups.set(t,i);}else{var o=this._defaultIndex%this._defaultGroups.length;this._defaultIndex++,(i={}).color=this._defaultGroups[o],this._groups.set(t,i);}return i;}},{key:"add",value:function value(t,e){return this._groups.has(t)||this._groupNames.push(t),this._groups.set(t,e),e;}}]),t;}();Ti({target:"Number",stat:!0},{isNaN:function isNaN(t){return t!=t;}});var f_=i(et.Number.isNaN),p_=o.isFinite,v_=Number.isFinite||function(t){return"number"==typeof t&&p_(t);};Ti({target:"Number",stat:!0},{isFinite:v_});var g_=i(et.Number.isFinite),y_=Fl.some;Ti({target:"Array",proto:!0,forced:!Xf("some")},{some:function some(t){return y_(this,t,arguments.length>1?arguments[1]:void 0);}});var m_=Nn("Array").some,b_=at,w_=m_,k_=Array.prototype,__=function __(t){var e=t.some;return t===k_||b_(k_,t)&&e===k_.some?w_:e;},x_=i(__);function E_(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t;}var O_=fg,C_=i(O_);Ti({target:"Object",stat:!0},{setPrototypeOf:ds});var S_=et.Object.setPrototypeOf,T_=i(S_),M_=i(Ln);function P_(t,e){var i;return P_=T_?M_(i=T_).call(i):function(t,e){return t.__proto__=e,t;},P_(t,e);}function D_(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=C_(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),xh(t,"prototype",{writable:!1}),e&&P_(t,e);}function I_(t,e){if(e&&("object"===bu(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return E_(t);}var B_=lv,N_=i(B_);function F_(t){var e;return F_=T_?M_(e=N_).call(e):function(t){return t.__proto__||N_(t);},F_(t);}function z_(t,e,i){return(e=ku(e))in t?xh(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t;}var A_={exports:{}},j_={exports:{}};!function(t){var e=pu,i=yu;function n(o){return t.exports=n="function"==typeof e&&"symbol"==_typeof(i)?function(t){return _typeof(t);}:function(t){return t&&"function"==typeof e&&t.constructor===e&&t!==e.prototype?"symbol":_typeof(t);},t.exports.__esModule=!0,t.exports["default"]=t.exports,n(o);}t.exports=n,t.exports.__esModule=!0,t.exports["default"]=t.exports;}(j_);var R_=j_.exports,L_=np,H_=Qt,W_=Mf,q_=T,V_=Ze,U_=tt,Y_=gi,X_=Error,G_=g("".replace),K_=String(new X_("zxcasd").stack),$_=/\n\s*at [^:]*:[^\n]*/,Z_=$_.test(K_),Q_=R,J_=!r(function(){var t=new Error("a");return!("stack"in t)||(Object.defineProperty(t,"stack",Q_(1,7)),7!==t.stack);}),tx=gi,ex=function ex(t,e){if(Z_&&"string"==typeof t&&!X_.prepareStackTrace)for(;e--;)t=G_(t,$_,"");return t;},ix=J_,nx=Error.captureStackTrace,ox=co,rx=Ti,sx=at,ax=Sr,hx=ds,lx=function lx(t,e,i){for(var n=W_(e),o=V_.f,r=q_.f,s=0;s<n.length;s++){var a=n[s];H_(t,a)||i&&H_(i,a)||o(t,a,r(e,a));}},dx=mr,cx=gi,ux=R,fx=function fx(t,e){U_(e)&&"cause"in e&&Y_(t,"cause",e.cause);},px=function px(t,e,i,n){ix&&(nx?nx(t,e):tx(t,"stack",ex(i,n)));},vx=_k,gx=function gx(t,e){return void 0===t?arguments.length<2?"":e:ox(t);},yx=ue("toStringTag"),mx=Error,bx=[].push,wx=function wx(t,e){var i,n=sx(kx,this);hx?i=hx(new mx(),n?ax(this):kx):(i=n?this:dx(kx),cx(i,yx,"Error")),void 0!==e&&cx(i,"message",gx(e)),px(i,wx,i.stack,1),arguments.length>2&&fx(i,arguments[2]);var o=[];return vx(t,bx,{that:o}),cx(i,"errors",o),i;};hx?hx(wx,mx):lx(wx,mx,{name:!0});var kx=wx.prototype=dx(mx.prototype,{constructor:ux(1,wx),message:ux(1,""),name:ux(1,"AggregateError")});rx({global:!0,constructor:!0,arity:2},{AggregateError:wx});var _x,xx,Ex,Ox,Cx="process"===w(o.process),Sx=da,Tx=St,Mx=TypeError,Px=function Px(t){if(Sx(t))return t;throw new Mx(Tx(t)+" is not a constructor");},Dx=ii,Ix=Px,Bx=U,Nx=ue("species"),Fx=function Fx(t,e){var i,n=Dx(t).constructor;return void 0===n||Bx(i=Dx(n)[Nx])?e:Ix(i);},zx=/(?:ipad|iphone|ipod).*applewebkit/i.test(ht),Ax=o,jx=c,Rx=$e,Lx=S,Hx=Qt,Wx=r,qx=er,Vx=wn,Ux=Ce,Yx=kg,Xx=zx,Gx=Cx,Kx=Ax.setImmediate,$x=Ax.clearImmediate,Zx=Ax.process,Qx=Ax.Dispatch,Jx=Ax.Function,tE=Ax.MessageChannel,eE=Ax.String,iE=0,nE={},oE="onreadystatechange";Wx(function(){_x=Ax.location;});var rE=function rE(t){if(Hx(nE,t)){var e=nE[t];delete nE[t],e();}},sE=function sE(t){return function(){rE(t);};},aE=function aE(t){rE(t.data);},hE=function hE(t){Ax.postMessage(eE(t),_x.protocol+"//"+_x.host);};Kx&&$x||(Kx=function Kx(t){Yx(arguments.length,1);var e=Lx(t)?t:Jx(t),i=Vx(arguments,1);return nE[++iE]=function(){jx(e,void 0,i);},xx(iE),iE;},$x=function $x(t){delete nE[t];},Gx?xx=function xx(t){Zx.nextTick(sE(t));}:Qx&&Qx.now?xx=function xx(t){Qx.now(sE(t));}:tE&&!Xx?(Ox=(Ex=new tE()).port2,Ex.port1.onmessage=aE,xx=Rx(Ox.postMessage,Ox)):Ax.addEventListener&&Lx(Ax.postMessage)&&!Ax.importScripts&&_x&&"file:"!==_x.protocol&&!Wx(hE)?(xx=hE,Ax.addEventListener("message",aE,!1)):xx=oE in Ux("script")?function(t){qx.appendChild(Ux("script"))[oE]=function(){qx.removeChild(this),rE(t);};}:function(t){setTimeout(sE(t),0);});var lE={set:Kx,clear:$x},dE=function dE(){this.head=null,this.tail=null;};dE.prototype={add:function add(t){var e={item:t,next:null},i=this.tail;i?i.next=e:this.head=e,this.tail=e;},get:function get(){var t=this.head;if(t)return null===(this.head=t.next)&&(this.tail=null),t.item;}};var cE,uE,fE,pE,vE,gE=dE,yE=/ipad|iphone|ipod/i.test(ht)&&"undefined"!=typeof Pebble,mE=/web0s(?!.*chrome)/i.test(ht),bE=o,wE=$e,kE=T.f,_E=lE.set,xE=gE,EE=zx,OE=yE,CE=mE,SE=Cx,TE=bE.MutationObserver||bE.WebKitMutationObserver,ME=bE.document,PE=bE.process,DE=bE.Promise,IE=kE(bE,"queueMicrotask"),BE=IE&&IE.value;if(!BE){var NE=new xE(),FE=function FE(){var t,e;for(SE&&(t=PE.domain)&&t.exit();e=NE.get();)try{e();}catch(t){throw NE.head&&cE(),t;}t&&t.enter();};EE||SE||CE||!TE||!ME?!OE&&DE&&DE.resolve?((pE=DE.resolve(void 0)).constructor=DE,vE=wE(pE.then,pE),cE=function cE(){vE(FE);}):SE?cE=function cE(){PE.nextTick(FE);}:(_E=wE(_E,bE),cE=function cE(){_E(FE);}):(uE=!0,fE=ME.createTextNode(""),new TE(FE).observe(fE,{characterData:!0}),cE=function cE(){fE.data=uE=!uE;}),BE=function BE(t){NE.head||cE(),NE.add(t);};}var zE=BE,AE=function AE(t){try{return{error:!1,value:t()};}catch(t){return{error:!0,value:t};}},jE=o.Promise,RE="object"==(typeof Deno==="undefined"?"undefined":_typeof(Deno))&&Deno&&"object"==_typeof(Deno.version),LE=!RE&&!Cx&&"object"==(typeof window==="undefined"?"undefined":_typeof(window))&&"object"==(typeof document==="undefined"?"undefined":_typeof(document)),HE=o,WE=jE,qE=S,VE=Ye,UE=$s,YE=ue,XE=LE,GE=RE,KE=vt,$E=WE&&WE.prototype,ZE=YE("species"),QE=!1,JE=qE(HE.PromiseRejectionEvent),tO=VE("Promise",function(){var t=UE(WE),e=t!==String(WE);if(!e&&66===KE)return!0;if(!$E["catch"]||!$E["finally"])return!0;if(!KE||KE<51||!/native code/.test(t)){var i=new WE(function(t){t(1);}),n=function n(t){t(function(){},function(){});};if((i.constructor={})[ZE]=n,!(QE=i.then(function(){})instanceof n))return!0;}return!e&&(XE||GE)&&!JE;}),eO={CONSTRUCTOR:tO,REJECTION_EVENT:JE,SUBCLASSING:QE},iO={},nO=Dt,oO=TypeError,rO=function rO(t){var e,i;this.promise=new t(function(t,n){if(void 0!==e||void 0!==i)throw new oO("Bad Promise constructor");e=t,i=n;}),this.resolve=nO(e),this.reject=nO(i);};iO.f=function(t){return new rO(t);};var sO,aO,hO=Ti,lO=Cx,dO=o,cO=I,uO=Mr,fO=Gr,pO=Kk,vO=Dt,gO=S,yO=tt,mO=Ok,bO=Fx,wO=lE.set,kO=zE,_O=function _O(t,e){try{1===arguments.length?console.error(t):console.error(t,e);}catch(t){}},xO=AE,EO=gE,OO=Lo,CO=jE,SO=eO,TO=iO,MO="Promise",PO=SO.CONSTRUCTOR,DO=SO.REJECTION_EVENT,IO=OO.getterFor(MO),BO=OO.set,NO=CO&&CO.prototype,FO=CO,zO=NO,AO=dO.TypeError,jO=dO.document,RO=dO.process,LO=TO.f,HO=LO,WO=!!(jO&&jO.createEvent&&dO.dispatchEvent),qO="unhandledrejection",VO=function VO(t){var e;return!(!yO(t)||!gO(e=t.then))&&e;},UO=function UO(t,e){var i,n,o,r=e.value,s=1===e.state,a=s?t.ok:t.fail,h=t.resolve,l=t.reject,d=t.domain;try{a?(s||(2===e.rejection&&$O(e),e.rejection=1),!0===a?i=r:(d&&d.enter(),i=a(r),d&&(d.exit(),o=!0)),i===t.promise?l(new AO("Promise-chain cycle")):(n=VO(i))?cO(n,i,h,l):h(i)):l(r);}catch(t){d&&!o&&d.exit(),l(t);}},YO=function YO(t,e){t.notified||(t.notified=!0,kO(function(){for(var i,n=t.reactions;i=n.get();)UO(i,t);t.notified=!1,e&&!t.rejection&&GO(t);}));},XO=function XO(t,e,i){var n,o;WO?((n=jO.createEvent("Event")).promise=e,n.reason=i,n.initEvent(t,!1,!0),dO.dispatchEvent(n)):n={promise:e,reason:i},!DO&&(o=dO["on"+t])?o(n):t===qO&&_O("Unhandled promise rejection",i);},GO=function GO(t){cO(wO,dO,function(){var e,i=t.facade,n=t.value;if(KO(t)&&(e=xO(function(){lO?RO.emit("unhandledRejection",n,i):XO(qO,i,n);}),t.rejection=lO||KO(t)?2:1,e.error))throw e.value;});},KO=function KO(t){return 1!==t.rejection&&!t.parent;},$O=function $O(t){cO(wO,dO,function(){var e=t.facade;lO?RO.emit("rejectionHandled",e):XO("rejectionhandled",e,t.value);});},ZO=function ZO(t,e,i){return function(n){t(e,n,i);};},QO=function QO(t,e,i){t.done||(t.done=!0,i&&(t=i),t.value=e,t.state=2,YO(t,!0));},JO=function JO(t,e,i){if(!t.done){t.done=!0,i&&(t=i);try{if(t.facade===e)throw new AO("Promise can't be resolved itself");var n=VO(e);n?kO(function(){var i={done:!1};try{cO(n,e,ZO(JO,i,t),ZO(QO,i,t));}catch(e){QO(i,e,t);}}):(t.value=e,t.state=1,YO(t,!1));}catch(e){QO({done:!1},e,t);}}};PO&&(zO=(FO=function FO(t){mO(this,zO),vO(t),cO(sO,this);var e=IO(this);try{t(ZO(JO,e),ZO(QO,e));}catch(t){QO(e,t);}}).prototype,(sO=function sO(t){BO(this,{type:MO,done:!1,notified:!1,parent:!1,reactions:new EO(),rejection:!1,state:0,value:void 0});}).prototype=uO(zO,"then",function(t,e){var i=IO(this),n=LO(bO(this,FO));return i.parent=!0,n.ok=!gO(t)||t,n.fail=gO(e)&&e,n.domain=lO?RO.domain:void 0,0===i.state?i.reactions.add(n):kO(function(){UO(n,i);}),n.promise;}),aO=function aO(){var t=new sO(),e=IO(t);this.promise=t,this.resolve=ZO(JO,e),this.reject=ZO(QO,e);},TO.f=LO=function LO(t){return t===FO||undefined===t?new aO(t):HO(t);}),hO({global:!0,constructor:!0,wrap:!0,forced:PO},{Promise:FO}),fO(FO,MO,!1,!0),pO(MO);var tC=jE,eC=eO.CONSTRUCTOR||!qa(function(t){tC.all(t).then(void 0,function(){});}),iC=I,nC=Dt,oC=iO,rC=AE,sC=_k;Ti({target:"Promise",stat:!0,forced:eC},{all:function all(t){var e=this,i=oC.f(e),n=i.resolve,o=i.reject,r=rC(function(){var i=nC(e.resolve),r=[],s=0,a=1;sC(t,function(t){var h=s++,l=!1;a++,iC(i,e,t).then(function(t){l||(l=!0,r[h]=t,--a||n(r));},o);}),--a||n(r);});return r.error&&o(r.value),i.promise;}});var aC=Ti,hC=eO.CONSTRUCTOR;jE&&jE.prototype,aC({target:"Promise",proto:!0,forced:hC,real:!0},{"catch":function _catch(t){return this.then(void 0,t);}});var lC=I,dC=Dt,cC=iO,uC=AE,fC=_k;Ti({target:"Promise",stat:!0,forced:eC},{race:function race(t){var e=this,i=cC.f(e),n=i.reject,o=uC(function(){var o=dC(e.resolve);fC(t,function(t){lC(o,e,t).then(i.resolve,n);});});return o.error&&n(o.value),i.promise;}});var pC=I,vC=iO;Ti({target:"Promise",stat:!0,forced:eO.CONSTRUCTOR},{reject:function reject(t){var e=vC.f(this);return pC(e.reject,void 0,t),e.promise;}});var gC=ii,yC=tt,mC=iO,bC=function bC(t,e){if(gC(t),yC(e)&&e.constructor===t)return e;var i=mC.f(t);return(0,i.resolve)(e),i.promise;},wC=Ti,kC=jE,_C=eO.CONSTRUCTOR,xC=bC,EC=st("Promise"),OC=!_C;wC({target:"Promise",stat:!0,forced:true},{resolve:function resolve(t){return xC(OC&&this===EC?kC:this,t);}});var CC=I,SC=Dt,TC=iO,MC=AE,PC=_k;Ti({target:"Promise",stat:!0,forced:eC},{allSettled:function allSettled(t){var e=this,i=TC.f(e),n=i.resolve,o=i.reject,r=MC(function(){var i=SC(e.resolve),o=[],r=0,s=1;PC(t,function(t){var a=r++,h=!1;s++,CC(i,e,t).then(function(t){h||(h=!0,o[a]={status:"fulfilled",value:t},--s||n(o));},function(t){h||(h=!0,o[a]={status:"rejected",reason:t},--s||n(o));});}),--s||n(o);});return r.error&&o(r.value),i.promise;}});var DC=I,IC=Dt,BC=st,NC=iO,FC=AE,zC=_k,AC="No one promise resolved";Ti({target:"Promise",stat:!0,forced:eC},{any:function any(t){var e=this,i=BC("AggregateError"),n=NC.f(e),o=n.resolve,r=n.reject,s=FC(function(){var n=IC(e.resolve),s=[],a=0,h=1,l=!1;zC(t,function(t){var d=a++,c=!1;h++,DC(n,e,t).then(function(t){c||l||(l=!0,o(t));},function(t){c||l||(c=!0,s[d]=t,--h||r(new i(s,AC)));});}),--h||r(new i(s,AC));});return s.error&&r(s.value),n.promise;}});var jC=Ti,RC=jE,LC=r,HC=st,WC=S,qC=Fx,VC=bC,UC=RC&&RC.prototype;jC({target:"Promise",proto:!0,real:!0,forced:!!RC&&LC(function(){UC["finally"].call({then:function then(){}},function(){});})},{"finally":function _finally(t){var e=qC(this,HC("Promise")),i=WC(t);return this.then(i?function(i){return VC(e,t()).then(function(){return i;});}:t,i?function(i){return VC(e,t()).then(function(){throw i;});}:t);}});var YC=et.Promise,XC=iO;Ti({target:"Promise",stat:!0},{withResolvers:function withResolvers(){var t=XC.f(this);return{promise:t.promise,resolve:t.resolve,reject:t.reject};}});var GC=YC,KC=iO,$C=AE;Ti({target:"Promise",stat:!0,forced:!0},{"try":function _try(t){var e=KC.f(this),i=$C(t);return(i.error?e.reject:e.resolve)(i.value),e.promise;}});var ZC=GC,QC=pp;!function(t){var e=R_["default"],i=_h,n=pu,o=O_,r=B_,s=L_,a=Lu,h=S_,l=ZC,d=QC,c=lf;function u(){t.exports=u=function u(){return p;},t.exports.__esModule=!0,t.exports["default"]=t.exports;var f,p={},v=Object.prototype,g=v.hasOwnProperty,y=i||function(t,e,i){t[e]=i.value;},m="function"==typeof n?n:{},b=m.iterator||"@@iterator",w=m.asyncIterator||"@@asyncIterator",k=m.toStringTag||"@@toStringTag";function _(t,e,n){return i(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e];}try{_({},"");}catch(f){_=function _(t,e,i){return t[e]=i;};}function x(t,e,i,n){var r=e&&e.prototype instanceof P?e:P,s=o(r.prototype),a=new W(n||[]);return y(s,"_invoke",{value:j(t,i,a)}),s;}function E(t,e,i){try{return{type:"normal",arg:t.call(e,i)};}catch(t){return{type:"throw",arg:t};}}p.wrap=x;var O="suspendedStart",C="suspendedYield",S="executing",T="completed",M={};function P(){}function D(){}function I(){}var B={};_(B,b,function(){return this;});var N=r&&r(r(q([])));N&&N!==v&&g.call(N,b)&&(B=N);var F=I.prototype=P.prototype=o(B);function z(t){var e;s(e=["next","throw","return"]).call(e,function(e){_(t,e,function(t){return this._invoke(e,t);});});}function A(t,i){function n(o,r,s,a){var h=E(t[o],t,r);if("throw"!==h.type){var l=h.arg,d=l.value;return d&&"object"==e(d)&&g.call(d,"__await")?i.resolve(d.__await).then(function(t){n("next",t,s,a);},function(t){n("throw",t,s,a);}):i.resolve(d).then(function(t){l.value=t,s(l);},function(t){return n("throw",t,s,a);});}a(h.arg);}var o;y(this,"_invoke",{value:function value(t,e){function r(){return new i(function(i,o){n(t,e,i,o);});}return o=o?o.then(r,r):r();}});}function j(t,e,i){var n=O;return function(o,r){if(n===S)throw new Error("Generator is already running");if(n===T){if("throw"===o)throw r;return{value:f,done:!0};}for(i.method=o,i.arg=r;;){var s=i.delegate;if(s){var a=R(s,i);if(a){if(a===M)continue;return a;}}if("next"===i.method)i.sent=i._sent=i.arg;else if("throw"===i.method){if(n===O)throw n=T,i.arg;i.dispatchException(i.arg);}else"return"===i.method&&i.abrupt("return",i.arg);n=S;var h=E(t,e,i);if("normal"===h.type){if(n=i.done?T:C,h.arg===M)continue;return{value:h.arg,done:i.done};}"throw"===h.type&&(n=T,i.method="throw",i.arg=h.arg);}};}function R(t,e){var i=e.method,n=t.iterator[i];if(n===f)return e.delegate=null,"throw"===i&&t.iterator["return"]&&(e.method="return",e.arg=f,R(t,e),"throw"===e.method)||"return"!==i&&(e.method="throw",e.arg=new TypeError("The iterator does not provide a '"+i+"' method")),M;var o=E(n,t.iterator,e.arg);if("throw"===o.type)return e.method="throw",e.arg=o.arg,e.delegate=null,M;var r=o.arg;return r?r.done?(e[t.resultName]=r.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=f),e.delegate=null,M):r:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,M);}function L(t){var e,i={tryLoc:t[0]};1 in t&&(i.catchLoc=t[1]),2 in t&&(i.finallyLoc=t[2],i.afterLoc=t[3]),a(e=this.tryEntries).call(e,i);}function H(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e;}function W(t){this.tryEntries=[{tryLoc:"root"}],s(t).call(t,L,this),this.reset(!0);}function q(t){if(t||""===t){var i=t[b];if(i)return i.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,o=function e(){for(;++n<t.length;)if(g.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=f,e.done=!0,e;};return o.next=o;}}throw new TypeError(e(t)+" is not iterable");}return D.prototype=I,y(F,"constructor",{value:I,configurable:!0}),y(I,"constructor",{value:D,configurable:!0}),D.displayName=_(I,k,"GeneratorFunction"),p.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===D||"GeneratorFunction"===(e.displayName||e.name));},p.mark=function(t){return h?h(t,I):(t.__proto__=I,_(t,k,"GeneratorFunction")),t.prototype=o(F),t;},p.awrap=function(t){return{__await:t};},z(A.prototype),_(A.prototype,w,function(){return this;}),p.AsyncIterator=A,p.async=function(t,e,i,n,o){void 0===o&&(o=l);var r=new A(x(t,e,i,n),o);return p.isGeneratorFunction(e)?r:r.next().then(function(t){return t.done?t.value:r.next();});},z(F),_(F,k,"Generator"),_(F,b,function(){return this;}),_(F,"toString",function(){return"[object Generator]";}),p.keys=function(t){var e=Object(t),i=[];for(var n in e)a(i).call(i,n);return d(i).call(i),function t(){for(;i.length;){var n=i.pop();if(n in e)return t.value=n,t.done=!1,t;}return t.done=!0,t;};},p.values=q,W.prototype={constructor:W,reset:function reset(t){var e;if(this.prev=0,this.next=0,this.sent=this._sent=f,this.done=!1,this.delegate=null,this.method="next",this.arg=f,s(e=this.tryEntries).call(e,H),!t)for(var i in this)"t"===i.charAt(0)&&g.call(this,i)&&!isNaN(+c(i).call(i,1))&&(this[i]=f);},stop:function stop(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval;},dispatchException:function dispatchException(t){if(this.done)throw t;var e=this;function i(i,n){return r.type="throw",r.arg=t,e.next=i,n&&(e.method="next",e.arg=f),!!n;}for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n],r=o.completion;if("root"===o.tryLoc)return i("end");if(o.tryLoc<=this.prev){var s=g.call(o,"catchLoc"),a=g.call(o,"finallyLoc");if(s&&a){if(this.prev<o.catchLoc)return i(o.catchLoc,!0);if(this.prev<o.finallyLoc)return i(o.finallyLoc);}else if(s){if(this.prev<o.catchLoc)return i(o.catchLoc,!0);}else{if(!a)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return i(o.finallyLoc);}}}},abrupt:function abrupt(t,e){for(var i=this.tryEntries.length-1;i>=0;--i){var n=this.tryEntries[i];if(n.tryLoc<=this.prev&&g.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break;}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var r=o?o.completion:{};return r.type=t,r.arg=e,o?(this.method="next",this.next=o.finallyLoc,M):this.complete(r);},complete:function complete(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),M;},finish:function finish(t){for(var e=this.tryEntries.length-1;e>=0;--e){var i=this.tryEntries[e];if(i.finallyLoc===t)return this.complete(i.completion,i.afterLoc),H(i),M;}},"catch":function _catch(t){for(var e=this.tryEntries.length-1;e>=0;--e){var i=this.tryEntries[e];if(i.tryLoc===t){var n=i.completion;if("throw"===n.type){var o=n.arg;H(i);}return o;}}throw new Error("illegal catch attempt");},delegateYield:function delegateYield(t,e,i){return this.delegate={iterator:q(t),resultName:e,nextLoc:i},"next"===this.method&&(this.arg=f),M;}},p;}t.exports=u,t.exports.__esModule=!0,t.exports["default"]=t.exports;}(A_);var JC=(0,A_.exports)(),tS=JC;try{regeneratorRuntime=JC;}catch(t){"object"==(typeof globalThis==="undefined"?"undefined":_typeof(globalThis))?globalThis.regeneratorRuntime=JC:Function("r","regeneratorRuntime = r")(JC);}var eS=i(tS),iS=Dt,nS=Kt,oS=V,rS=Li,sS=TypeError,aS=function aS(t){return function(e,i,n,o){iS(i);var r=nS(e),s=oS(r),a=rS(r),h=t?a-1:0,l=t?-1:1;if(n<2)for(;;){if(h in s){o=s[h],h+=l;break;}if(h+=l,t?h<0:a<=h)throw new sS("Reduce of empty array with no initial value");}for(;t?h>=0:a>h;h+=l)h in s&&(o=i(o,s[h],h,r));return o;};},hS={left:aS(!1),right:aS(!0)}.left;Ti({target:"Array",proto:!0,forced:!Cx&&vt>79&&vt<83||!Xf("reduce")},{reduce:function reduce(t){var e=arguments.length;return hS(this,t,e,e>1?arguments[1]:void 0);}});var lS=Nn("Array").reduce,dS=at,cS=lS,uS=Array.prototype,fS=function fS(t){var e=t.reduce;return t===uS||dS(uS,t)&&e===uS.reduce?cS:e;},pS=i(fS),vS=Oh,gS=Li,yS=Sh,mS=$e,bS=function bS(t,e,i,n,o,r,s,a){for(var h,l,d=o,c=0,u=!!s&&mS(s,a);c<n;)c in i&&(h=u?u(i[c],c,e):i[c],r>0&&vS(h)?(l=gS(h),d=bS(t,e,h,l,d,r-1)-1):(yS(d+1),t[d]=h),d++),c++;return d;},wS=bS,kS=Dt,_S=Kt,xS=Li,ES=Nh;Ti({target:"Array",proto:!0},{flatMap:function flatMap(t){var e,i=_S(this),n=xS(i);return kS(t),(e=ES(i,0)).length=wS(e,i,i,n,0,1,t,arguments.length>1?arguments[1]:void 0),e;}});var OS=Nn("Array").flatMap,CS=at,SS=OS,TS=Array.prototype,MS=function MS(t){var e=t.flatMap;return t===TS||CS(TS,t)&&e===TS.flatMap?SS:e;},PS=i(MS);Wk("Set",function(t){return function(){return t(this,arguments.length?arguments[0]:void 0);};},d_);var DS=i(et.Set),IS=i(gu),BS=i(Sa),NS=hl,FS=Math.floor,zS=function zS(t,e){var i=t.length,n=FS(i/2);return i<8?AS(t,e):jS(t,zS(NS(t,0,n),e),zS(NS(t,n),e),e);},AS=function AS(t,e){for(var i,n,o=t.length,r=1;r<o;){for(n=r,i=t[r];n&&e(t[n-1],i)>0;)t[n]=t[--n];n!==r++&&(t[n]=i);}return t;},jS=function jS(t,e,i,n){for(var o=e.length,r=i.length,s=0,a=0;s<o||a<r;)t[s+a]=s<o&&a<r?n(e[s],i[a])<=0?e[s++]:i[a++]:s<o?e[s++]:i[a++];return t;},RS=zS,LS=ht.match(/firefox\/(\d+)/i),HS=!!LS&&+LS[1],WS=/MSIE|Trident/.test(ht),qS=ht.match(/AppleWebKit\/(\d+)\./),VS=!!qS&&+qS[1],US=Ti,YS=g,XS=Dt,GS=Kt,KS=Li,$S=mp,ZS=co,QS=r,JS=RS,tT=Xf,eT=HS,iT=WS,nT=vt,oT=VS,rT=[],sT=YS(rT.sort),aT=YS(rT.push),hT=QS(function(){rT.sort(void 0);}),lT=QS(function(){rT.sort(null);}),dT=tT("sort"),cT=!QS(function(){if(nT)return nT<70;if(!(eT&&eT>3)){if(iT)return!0;if(oT)return oT<603;var t,e,i,n,o="";for(t=65;t<76;t++){switch(e=String.fromCharCode(t),t){case 66:case 69:case 70:case 72:i=3;break;case 68:case 71:i=4;break;default:i=2;}for(n=0;n<47;n++)rT.push({k:e+n,v:i});}for(rT.sort(function(t,e){return e.v-t.v;}),n=0;n<rT.length;n++)e=rT[n].k.charAt(0),o.charAt(o.length-1)!==e&&(o+=e);return"DGBEFHACIJK"!==o;}});US({target:"Array",proto:!0,forced:hT||!lT||!dT||!cT},{sort:function sort(t){void 0!==t&&XS(t);var e=GS(this);if(cT)return void 0===t?sT(e):sT(e,t);var i,n,o=[],r=KS(e);for(n=0;n<r;n++)n in e&&aT(o,e[n]);for(JS(o,function(t){return function(e,i){return void 0===i?-1:void 0===e?1:void 0!==t?+t(e,i)||0:ZS(e)>ZS(i)?1:-1;};}(t)),i=KS(o),n=0;n<i;)e[n]=o[n++];for(;n<r;)$S(e,n++);return e;}});var uT=Nn("Array").sort,fT=at,pT=uT,vT=Array.prototype,gT=function gT(t){var e=t.sort;return t===vT||fT(vT,t)&&e===vT.sort?pT:e;},yT=i(gT),mT=Nn("Array").keys,bT=ao,wT=Qt,kT=at,_T=mT,xT=Array.prototype,ET={DOMTokenList:!0,NodeList:!0},OT=function OT(t){var e=t.keys;return t===xT||kT(xT,t)&&e===xT.keys||wT(ET,bT(t))?_T:e;},CT=i(OT),ST=Nn("Array").values,TT=ao,MT=Qt,PT=at,DT=ST,IT=Array.prototype,BT={DOMTokenList:!0,NodeList:!0},NT=function NT(t){var e=t.values;return t===IT||PT(IT,t)&&e===IT.values||MT(BT,TT(t))?DT:e;},FT=i(NT),zT=Nn("Array").entries,AT=ao,jT=Qt,RT=at,LT=zT,HT=Array.prototype,WT={DOMTokenList:!0,NodeList:!0},qT=function qT(t){var e=t.entries;return t===HT||RT(HT,t)&&e===HT.entries||jT(WT,AT(t))?LT:e;},VT=i(qT),UT=i(kh),YT=Ti,XT=c,GT=Dn,KT=Px,$T=ii,ZT=tt,QT=mr,JT=r,tM=st("Reflect","construct"),eM=Object.prototype,iM=[].push,nM=JT(function(){function t(){}return!(tM(function(){},[],t)instanceof t);}),oM=!JT(function(){tM(function(){});}),rM=nM||oM;YT({target:"Reflect",stat:!0,forced:rM,sham:rM},{construct:function construct(t,e){KT(t),$T(e);var i=arguments.length<3?t:KT(arguments[2]);if(oM&&!nM)return tM(t,e,i);if(t===i){switch(e.length){case 0:return new t();case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3]);}var n=[null];return XT(iM,n,e),new(XT(GT,t,n))();}var o=i.prototype,r=QT(ZT(o)?o:eM),s=XT(t,r,e);return ZT(s)?s:r;}});var sM=i(et.Reflect.construct),aM=i(et.Object.getOwnPropertySymbols),hM={exports:{}},lM=Ti,dM=r,cM=Z,uM=T.f,fM=M;lM({target:"Object",stat:!0,forced:!fM||dM(function(){uM(1);}),sham:!fM},{getOwnPropertyDescriptor:function getOwnPropertyDescriptor(t,e){return uM(cM(t),e);}});var pM=et.Object,vM=hM.exports=function(t,e){return pM.getOwnPropertyDescriptor(t,e);};pM.getOwnPropertyDescriptor.sham&&(vM.sham=!0);var gM=hM.exports,yM=i(gM),mM=Mf,bM=Z,wM=T,kM=pa;Ti({target:"Object",stat:!0,sham:!M},{getOwnPropertyDescriptors:function getOwnPropertyDescriptors(t){for(var e,i,n=bM(t),o=wM.f,r=mM(n),s={},a=0;r.length>a;)void 0!==(i=o(n,e=r[a++]))&&kM(s,e,i);return s;}});var _M=i(et.Object.getOwnPropertyDescriptors),xM={exports:{}},EM=Ti,OM=M,CM=Xo.f;EM({target:"Object",stat:!0,forced:Object.defineProperties!==CM,sham:!OM},{defineProperties:CM});var SM=et.Object,TM=xM.exports=function(t,e){return SM.defineProperties(t,e);};SM.defineProperties.sham&&(TM.sham=!0);var MM=i(xM.exports);var PM;var DM=new Uint8Array(16);function IM(){if(!PM&&(PM="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!PM))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return PM(DM);}var BM=[];for(var _t3=0;_t3<256;++_t3)BM.push((_t3+256).toString(16).slice(1));var NM,FM={randomUUID:"undefined"!=typeof crypto&&crypto.randomUUID&&crypto.randomUUID.bind(crypto)};function zM(t,e,i){if(FM.randomUUID&&!e&&!t)return FM.randomUUID();var n=(t=t||{}).random||(t.rng||IM)();if(n[6]=15&n[6]|64,n[8]=63&n[8]|128,e){i=i||0;for(var _t4=0;_t4<16;++_t4)e[i+_t4]=n[_t4];return e;}return function(t){var e=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return BM[t[e+0]]+BM[t[e+1]]+BM[t[e+2]]+BM[t[e+3]]+"-"+BM[t[e+4]]+BM[t[e+5]]+"-"+BM[t[e+6]]+BM[t[e+7]]+"-"+BM[t[e+8]]+BM[t[e+9]]+"-"+BM[t[e+10]]+BM[t[e+11]]+BM[t[e+12]]+BM[t[e+13]]+BM[t[e+14]]+BM[t[e+15]];}(n);}function AM(t,e){var i=Hf(t);if(aM){var n=aM(t);e&&(n=yv(n).call(n,function(e){return yM(t,e).enumerable;})),i.push.apply(i,n);}return i;}function jM(t){for(var e=1;e<arguments.length;e++){var i,n,o=null!=arguments[e]?arguments[e]:{};e%2?op(i=AM(Object(o),!0)).call(i,function(e){z_(t,e,o[e]);}):_M?MM(t,_M(o)):op(n=AM(Object(o))).call(n,function(e){UT(t,e,yM(o,e));});}return t;}function RM(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}function LM(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return HM(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return HM(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n3=0,o=function o(){};return{s:o,n:function n(){return _n3>=t.length?{done:!0}:{done:!1,value:t[_n3++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function HM(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}var WM=function(){function t(e,i,n){var o,r,s;ph(this,t),z_(this,"_source",void 0),z_(this,"_transformers",void 0),z_(this,"_target",void 0),z_(this,"_listeners",{add:Hn(o=this._add).call(o,this),remove:Hn(r=this._remove).call(r,this),update:Hn(s=this._update).call(s,this)}),this._source=e,this._transformers=i,this._target=n;}return xu(t,[{key:"all",value:function value(){return this._target.update(this._transformItems(this._source.get())),this;}},{key:"start",value:function value(){return this._source.on("add",this._listeners.add),this._source.on("remove",this._listeners.remove),this._source.on("update",this._listeners.update),this;}},{key:"stop",value:function value(){return this._source.off("add",this._listeners.add),this._source.off("remove",this._listeners.remove),this._source.off("update",this._listeners.update),this;}},{key:"_transformItems",value:function value(t){var e;return pS(e=this._transformers).call(e,function(t,e){return e(t);},t);}},{key:"_add",value:function value(t,e){null!=e&&this._target.add(this._transformItems(this._source.get(e.items)));}},{key:"_update",value:function value(t,e){null!=e&&this._target.update(this._transformItems(this._source.get(e.items)));}},{key:"_remove",value:function value(t,e){null!=e&&this._target.remove(this._transformItems(e.oldData));}}]),t;}(),qM=function(){function t(e){ph(this,t),z_(this,"_source",void 0),z_(this,"_transformers",[]),this._source=e;}return xu(t,[{key:"filter",value:function value(t){return this._transformers.push(function(e){return yv(e).call(e,t);}),this;}},{key:"map",value:function value(t){return this._transformers.push(function(e){return jf(e).call(e,t);}),this;}},{key:"flatMap",value:function value(t){return this._transformers.push(function(e){return PS(e).call(e,t);}),this;}},{key:"to",value:function value(t){return new WM(this._source,this._transformers,t);}}]),t;}();function VM(t){return"string"==typeof t||"number"==typeof t;}var UM=function(){function t(e){ph(this,t),z_(this,"delay",void 0),z_(this,"max",void 0),z_(this,"_queue",[]),z_(this,"_timeout",null),z_(this,"_extended",null),this.delay=null,this.max=1/0,this.setOptions(e);}return xu(t,[{key:"setOptions",value:function value(t){t&&void 0!==t.delay&&(this.delay=t.delay),t&&void 0!==t.max&&(this.max=t.max),this._flushIfNeeded();}},{key:"destroy",value:function value(){if(this.flush(),this._extended){for(var t=this._extended.object,e=this._extended.methods,i=0;i<e.length;i++){var n=e[i];n.original?t[n.name]=n.original:delete t[n.name];}this._extended=null;}}},{key:"replace",value:function value(t,e){var i=this,n=t[e];if(!n)throw new Error("Method "+e+" undefined");t[e]=function(){for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];i.queue({args:e,fn:n,context:this});};}},{key:"queue",value:function value(t){"function"==typeof t?this._queue.push({fn:t}):this._queue.push(t),this._flushIfNeeded();}},{key:"_flushIfNeeded",value:function value(){var t=this;this._queue.length>this.max&&this.flush(),null!=this._timeout&&(clearTimeout(this._timeout),this._timeout=null),this.queue.length>0&&"number"==typeof this.delay&&(this._timeout=jg(function(){t.flush();},this.delay));}},{key:"flush",value:function value(){var t,e;op(t=Ap(e=this._queue).call(e,0)).call(t,function(t){t.fn.apply(t.context||t.fn,t.args||[]);});}}],[{key:"extend",value:function value(e,i){var n=new t(i);if(void 0!==e.flush)throw new Error("Target object already has a property flush");e.flush=function(){n.flush();};var o=[{name:"flush",original:void 0}];if(i&&i.replace)for(var r=0;r<i.replace.length;r++){var s=i.replace[r];o.push({name:s,original:e[s]}),n.replace(e,s);}return n._extended={object:e,methods:o},n;}}]),t;}(),YM=function(){function t(){ph(this,t),z_(this,"_subscribers",{"*":[],add:[],remove:[],update:[]}),z_(this,"subscribe",t.prototype.on),z_(this,"unsubscribe",t.prototype.off);}return xu(t,[{key:"_trigger",value:function value(t,e,i){var n,o;if("*"===t)throw new Error("Cannot trigger event *");op(n=_f(o=[]).call(o,vf(this._subscribers[t]),vf(this._subscribers["*"]))).call(n,function(n){n(t,e,null!=i?i:null);});}},{key:"on",value:function value(t,e){"function"==typeof e&&this._subscribers[t].push(e);}},{key:"off",value:function value(t,e){var i;this._subscribers[t]=yv(i=this._subscribers[t]).call(i,function(t){return t!==e;});}}]),t;}();NM=IS;var XM=function(){function t(e){ph(this,t),z_(this,"_pairs",void 0),this._pairs=e;}return xu(t,[{key:NM,value:eS.mark(function t(){var e,i,n,o,r;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:e=LM(this._pairs),t.prev=1,e.s();case 3:if((i=e.n()).done){t.next=9;break;}return n=pf(i.value,2),o=n[0],r=n[1],t.next=7,[o,r];case 7:t.next=3;break;case 9:t.next=14;break;case 11:t.prev=11,t.t0=t["catch"](1),e.e(t.t0);case 14:return t.prev=14,e.f(),t.finish(14);case 17:case"end":return t.stop();}},t,this,[[1,11,14,17]]);})},{key:"entries",value:eS.mark(function t(){var e,i,n,o,r;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:e=LM(this._pairs),t.prev=1,e.s();case 3:if((i=e.n()).done){t.next=9;break;}return n=pf(i.value,2),o=n[0],r=n[1],t.next=7,[o,r];case 7:t.next=3;break;case 9:t.next=14;break;case 11:t.prev=11,t.t0=t["catch"](1),e.e(t.t0);case 14:return t.prev=14,e.f(),t.finish(14);case 17:case"end":return t.stop();}},t,this,[[1,11,14,17]]);})},{key:"keys",value:eS.mark(function t(){var e,i,n,o;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:e=LM(this._pairs),t.prev=1,e.s();case 3:if((i=e.n()).done){t.next=9;break;}return n=pf(i.value,1),o=n[0],t.next=7,o;case 7:t.next=3;break;case 9:t.next=14;break;case 11:t.prev=11,t.t0=t["catch"](1),e.e(t.t0);case 14:return t.prev=14,e.f(),t.finish(14);case 17:case"end":return t.stop();}},t,this,[[1,11,14,17]]);})},{key:"values",value:eS.mark(function t(){var e,i,n,o;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:e=LM(this._pairs),t.prev=1,e.s();case 3:if((i=e.n()).done){t.next=9;break;}return n=pf(i.value,2),o=n[1],t.next=7,o;case 7:t.next=3;break;case 9:t.next=14;break;case 11:t.prev=11,t.t0=t["catch"](1),e.e(t.t0);case 14:return t.prev=14,e.f(),t.finish(14);case 17:case"end":return t.stop();}},t,this,[[1,11,14,17]]);})},{key:"toIdArray",value:function value(){var t;return jf(t=vf(this._pairs)).call(t,function(t){return t[0];});}},{key:"toItemArray",value:function value(){var t;return jf(t=vf(this._pairs)).call(t,function(t){return t[1];});}},{key:"toEntryArray",value:function value(){return vf(this._pairs);}},{key:"toObjectMap",value:function value(){var t,e=pg(null),i=LM(this._pairs);try{for(i.s();!(t=i.n()).done;){var n=pf(t.value,2),o=n[0],r=n[1];e[o]=r;}}catch(t){i.e(t);}finally{i.f();}return e;}},{key:"toMap",value:function value(){return new c_(this._pairs);}},{key:"toIdSet",value:function value(){return new DS(this.toIdArray());}},{key:"toItemSet",value:function value(){return new DS(this.toItemArray());}},{key:"cache",value:function value(){return new t(vf(this._pairs));}},{key:"distinct",value:function value(t){var e,i=new DS(),n=LM(this._pairs);try{for(n.s();!(e=n.n()).done;){var o=pf(e.value,2),r=o[0],s=o[1];i.add(t(s,r));}}catch(t){n.e(t);}finally{n.f();}return i;}},{key:"filter",value:function value(e){var i=this._pairs;return new t(z_({},IS,eS.mark(function t(){var n,o,r,s,a;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:n=LM(i),t.prev=1,n.s();case 3:if((o=n.n()).done){t.next=10;break;}if(r=pf(o.value,2),s=r[0],a=r[1],!e(a,s)){t.next=8;break;}return t.next=8,[s,a];case 8:t.next=3;break;case 10:t.next=15;break;case 12:t.prev=12,t.t0=t["catch"](1),n.e(t.t0);case 15:return t.prev=15,n.f(),t.finish(15);case 18:case"end":return t.stop();}},t,null,[[1,12,15,18]]);})));}},{key:"forEach",value:function value(t){var e,i=LM(this._pairs);try{for(i.s();!(e=i.n()).done;){var n=pf(e.value,2),o=n[0];t(n[1],o);}}catch(t){i.e(t);}finally{i.f();}}},{key:"map",value:function value(e){var i=this._pairs;return new t(z_({},IS,eS.mark(function t(){var n,o,r,s,a;return eS.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:n=LM(i),t.prev=1,n.s();case 3:if((o=n.n()).done){t.next=9;break;}return r=pf(o.value,2),s=r[0],a=r[1],t.next=7,[s,e(a,s)];case 7:t.next=3;break;case 9:t.next=14;break;case 11:t.prev=11,t.t0=t["catch"](1),n.e(t.t0);case 14:return t.prev=14,n.f(),t.finish(14);case 17:case"end":return t.stop();}},t,null,[[1,11,14,17]]);})));}},{key:"max",value:function value(t){var e=BS(this._pairs),i=e.next();if(i.done)return null;for(var n=i.value[1],o=t(i.value[1],i.value[0]);!(i=e.next()).done;){var r=pf(i.value,2),s=r[0],a=r[1],h=t(a,s);h>o&&(o=h,n=a);}return n;}},{key:"min",value:function value(t){var e=BS(this._pairs),i=e.next();if(i.done)return null;for(var n=i.value[1],o=t(i.value[1],i.value[0]);!(i=e.next()).done;){var r=pf(i.value,2),s=r[0],a=r[1],h=t(a,s);h<o&&(o=h,n=a);}return n;}},{key:"reduce",value:function value(t,e){var i,n=LM(this._pairs);try{for(n.s();!(i=n.n()).done;){var o=pf(i.value,2),r=o[0];e=t(e,o[1],r);}}catch(t){n.e(t);}finally{n.f();}return e;}},{key:"sort",value:function value(e){var i=this;return new t(z_({},IS,function(){var t;return BS(yT(t=vf(i._pairs)).call(t,function(t,i){var n=pf(t,2),o=n[0],r=n[1],s=pf(i,2),a=s[0],h=s[1];return e(r,h,o,a);}));}));}}]),t;}();var GM=function(t){D_(i,t);var e=RM(i);function i(t,n){var o;return ph(this,i),z_(E_(o=e.call(this)),"flush",void 0),z_(E_(o),"length",void 0),z_(E_(o),"_options",void 0),z_(E_(o),"_data",void 0),z_(E_(o),"_idProp",void 0),z_(E_(o),"_queue",null),t&&!Df(t)&&(n=t,t=[]),o._options=n||{},o._data=new c_(),o.length=0,o._idProp=o._options.fieldId||"id",t&&t.length&&o.add(t),o.setOptions(n),o;}return xu(i,[{key:"idProp",get:function get(){return this._idProp;}},{key:"setOptions",value:function value(t){t&&void 0!==t.queue&&(!1===t.queue?this._queue&&(this._queue.destroy(),this._queue=null):(this._queue||(this._queue=UM.extend(this,{replace:["add","update","remove"]})),t.queue&&"object"===bu(t.queue)&&this._queue.setOptions(t.queue)));}},{key:"add",value:function value(t,e){var i,n=this,o=[];if(Df(t)){var r=jf(t).call(t,function(t){return t[n._idProp];});if(x_(r).call(r,function(t){return n._data.has(t);}))throw new Error("A duplicate id was found in the parameter array.");for(var s=0,a=t.length;s<a;s++)i=this._addItem(t[s]),o.push(i);}else{if(!t||"object"!==bu(t))throw new Error("Unknown dataType");i=this._addItem(t),o.push(i);}return o.length&&this._trigger("add",{items:o},e),o;}},{key:"update",value:function value(t,e){var i=this,n=[],o=[],r=[],s=[],a=this._idProp,h=function h(t){var e=t[a];if(null!=e&&i._data.has(e)){var h=t,l=bn({},i._data.get(e)),d=i._updateItem(h);o.push(d),s.push(h),r.push(l);}else{var c=i._addItem(t);n.push(c);}};if(Df(t))for(var l=0,d=t.length;l<d;l++)t[l]&&"object"===bu(t[l])?h(t[l]):console.warn("Ignoring input item, which is not an object at index "+l);else{if(!t||"object"!==bu(t))throw new Error("Unknown dataType");h(t);}if(n.length&&this._trigger("add",{items:n},e),o.length){var c={items:o,oldData:r,data:s};this._trigger("update",c,e);}return _f(n).call(n,o);}},{key:"updateOnly",value:function value(t,e){var i,n=this;Df(t)||(t=[t]);var o=jf(i=jf(t).call(t,function(t){var e=n._data.get(t[n._idProp]);if(null==e)throw new Error("Updating non-existent items is not allowed.");return{oldData:e,update:t};})).call(i,function(t){var e=t.oldData,i=t.update,o=e[n._idProp],r=Gm(e,i);return n._data.set(o,r),{id:o,oldData:e,updatedData:r};});if(o.length){var r={items:jf(o).call(o,function(t){return t.id;}),oldData:jf(o).call(o,function(t){return t.oldData;}),data:jf(o).call(o,function(t){return t.updatedData;})};return this._trigger("update",r,e),r.items;}return[];}},{key:"get",value:function value(t,e){var i=void 0,n=void 0,o=void 0;VM(t)?(i=t,o=e):Df(t)?(n=t,o=e):o=t;var r,s=o&&"Object"===o.returnType?"Object":"Array",a=o&&yv(o),h=[],l=void 0,d=void 0,c=void 0;if(null!=i)(l=this._data.get(i))&&a&&!a(l)&&(l=void 0);else if(null!=n)for(var u=0,f=n.length;u<f;u++)null==(l=this._data.get(n[u]))||a&&!a(l)||h.push(l);else for(var p,v=0,g=(d=vf(CT(p=this._data).call(p))).length;v<g;v++)c=d[v],null==(l=this._data.get(c))||a&&!a(l)||h.push(l);if(o&&o.order&&null==i&&this._sort(h,o.order),o&&o.fields){var y=o.fields;if(null!=i&&null!=l)l=this._filterFields(l,y);else for(var m=0,b=h.length;m<b;m++)h[m]=this._filterFields(h[m],y);}if("Object"==s){for(var w={},k=0,_=h.length;k<_;k++){var x=h[k];w[x[this._idProp]]=x;}return w;}return null!=i?null!==(r=l)&&void 0!==r?r:null:h;}},{key:"getIds",value:function value(t){var e=this._data,i=t&&yv(t),n=t&&t.order,o=vf(CT(e).call(e)),r=[];if(i){if(n){for(var s=[],a=0,h=o.length;a<h;a++){var l=o[a],d=this._data.get(l);null!=d&&i(d)&&s.push(d);}this._sort(s,n);for(var c=0,u=s.length;c<u;c++)r.push(s[c][this._idProp]);}else for(var f=0,p=o.length;f<p;f++){var v=o[f],g=this._data.get(v);null!=g&&i(g)&&r.push(g[this._idProp]);}}else if(n){for(var y=[],m=0,b=o.length;m<b;m++){var w=o[m];y.push(e.get(w));}this._sort(y,n);for(var k=0,_=y.length;k<_;k++)r.push(y[k][this._idProp]);}else for(var x=0,E=o.length;x<E;x++){var O=o[x],C=e.get(O);null!=C&&r.push(C[this._idProp]);}return r;}},{key:"getDataSet",value:function value(){return this;}},{key:"forEach",value:function value(t,e){var i=e&&yv(e),n=this._data,o=vf(CT(n).call(n));if(e&&e.order)for(var r=this.get(e),s=0,a=r.length;s<a;s++){var h=r[s];t(h,h[this._idProp]);}else for(var l=0,d=o.length;l<d;l++){var c=o[l],u=this._data.get(c);null==u||i&&!i(u)||t(u,c);}}},{key:"map",value:function value(t,e){for(var i=e&&yv(e),n=[],o=this._data,r=vf(CT(o).call(o)),s=0,a=r.length;s<a;s++){var h=r[s],l=this._data.get(h);null==l||i&&!i(l)||n.push(t(l,h));}return e&&e.order&&this._sort(n,e.order),n;}},{key:"_filterFields",value:function value(t,e){var i;return t?pS(i=Df(e)?e:Hf(e)).call(i,function(e,i){return e[i]=t[i],e;},{}):t;}},{key:"_sort",value:function value(t,e){if("string"==typeof e){var i=e;yT(t).call(t,function(t,e){var n=t[i],o=e[i];return n>o?1:n<o?-1:0;});}else{if("function"!=typeof e)throw new TypeError("Order must be a function or a string");yT(t).call(t,e);}}},{key:"remove",value:function value(t,e){for(var i=[],n=[],o=Df(t)?t:[t],r=0,s=o.length;r<s;r++){var a=this._remove(o[r]);if(a){var h=a[this._idProp];null!=h&&(i.push(h),n.push(a));}}return i.length&&this._trigger("remove",{items:i,oldData:n},e),i;}},{key:"_remove",value:function value(t){var e;if(VM(t)?e=t:t&&"object"===bu(t)&&(e=t[this._idProp]),null!=e&&this._data.has(e)){var i=this._data.get(e)||null;return this._data["delete"](e),--this.length,i;}return null;}},{key:"clear",value:function value(t){for(var e,i=vf(CT(e=this._data).call(e)),n=[],o=0,r=i.length;o<r;o++)n.push(this._data.get(i[o]));return this._data.clear(),this.length=0,this._trigger("remove",{items:i,oldData:n},t),i;}},{key:"max",value:function value(t){var e,i,n=null,o=null,r=LM(FT(e=this._data).call(e));try{for(r.s();!(i=r.n()).done;){var s=i.value,a=s[t];"number"==typeof a&&(null==o||a>o)&&(n=s,o=a);}}catch(t){r.e(t);}finally{r.f();}return n||null;}},{key:"min",value:function value(t){var e,i,n=null,o=null,r=LM(FT(e=this._data).call(e));try{for(r.s();!(i=r.n()).done;){var s=i.value,a=s[t];"number"==typeof a&&(null==o||a<o)&&(n=s,o=a);}}catch(t){r.e(t);}finally{r.f();}return n||null;}},{key:"distinct",value:function value(t){for(var e=this._data,i=vf(CT(e).call(e)),n=[],o=0,r=0,s=i.length;r<s;r++){for(var a=i[r],h=e.get(a)[t],l=!1,d=0;d<o;d++)if(n[d]==h){l=!0;break;}l||void 0===h||(n[o]=h,o++);}return n;}},{key:"_addItem",value:function value(t){var e=function(t,e){return null==t[e]&&(t[e]=zM()),t;}(t,this._idProp),i=e[this._idProp];if(this._data.has(i))throw new Error("Cannot add item: item with id "+i+" already exists");return this._data.set(i,e),++this.length,i;}},{key:"_updateItem",value:function value(t){var e=t[this._idProp];if(null==e)throw new Error("Cannot update item: item has no id (item: "+mg(t)+")");var i=this._data.get(e);if(!i)throw new Error("Cannot update item: no item with id "+e+" found");return this._data.set(e,jM(jM({},i),t)),e;}},{key:"stream",value:function value(t){if(t){var e=this._data;return new XM(z_({},IS,eS.mark(function i(){var n,o,r,s;return eS.wrap(function(i){for(;;)switch(i.prev=i.next){case 0:n=LM(t),i.prev=1,n.s();case 3:if((o=n.n()).done){i.next=11;break;}if(r=o.value,null==(s=e.get(r))){i.next=9;break;}return i.next=9,[r,s];case 9:i.next=3;break;case 11:i.next=16;break;case 13:i.prev=13,i.t0=i["catch"](1),n.e(i.t0);case 16:return i.prev=16,n.f(),i.finish(16);case 19:case"end":return i.stop();}},i,null,[[1,13,16,19]]);})));}var i;return new XM(z_({},IS,Hn(i=VT(this._data)).call(i,this._data)));}}]),i;}(YM),KM=function(t){D_(i,t);var e=RM(i);function i(t,n){var o,r;return ph(this,i),z_(E_(r=e.call(this)),"length",0),z_(E_(r),"_listener",void 0),z_(E_(r),"_data",void 0),z_(E_(r),"_ids",new DS()),z_(E_(r),"_options",void 0),r._options=n||{},r._listener=Hn(o=r._onEvent).call(o,E_(r)),r.setData(t),r;}return xu(i,[{key:"idProp",get:function get(){return this.getDataSet().idProp;}},{key:"setData",value:function value(t){if(this._data){this._data.off&&this._data.off("*",this._listener);var e=this._data.getIds({filter:yv(this._options)}),i=this._data.get(e);this._ids.clear(),this.length=0,this._trigger("remove",{items:e,oldData:i});}if(null!=t){this._data=t;for(var n=this._data.getIds({filter:yv(this._options)}),o=0,r=n.length;o<r;o++){var s=n[o];this._ids.add(s);}this.length=n.length,this._trigger("add",{items:n});}else this._data=new GM();this._data.on&&this._data.on("*",this._listener);}},{key:"refresh",value:function value(){for(var t=this._data.getIds({filter:yv(this._options)}),e=vf(this._ids),i={},n=[],o=[],r=[],s=0,a=t.length;s<a;s++){var h=t[s];i[h]=!0,this._ids.has(h)||(n.push(h),this._ids.add(h));}for(var l=0,d=e.length;l<d;l++){var c=e[l],u=this._data.get(c);null==u?console.error("If you see this, report it please."):i[c]||(o.push(c),r.push(u),this._ids["delete"](c));}this.length+=n.length-o.length,n.length&&this._trigger("add",{items:n}),o.length&&this._trigger("remove",{items:o,oldData:r});}},{key:"get",value:function value(t,e){if(null==this._data)return null;var i,n=null;VM(t)||Df(t)?(n=t,i=e):i=t;var o=bn({},this._options,i),r=yv(this._options),s=i&&yv(i);return r&&s&&(o.filter=function(t){return r(t)&&s(t);}),null==n?this._data.get(o):this._data.get(n,o);}},{key:"getIds",value:function value(t){if(this._data.length){var e,i=yv(this._options),n=null!=t?yv(t):null;return e=n?i?function(t){return i(t)&&n(t);}:n:i,this._data.getIds({filter:e,order:t&&t.order});}return[];}},{key:"forEach",value:function value(t,e){if(this._data){var i,n,o=yv(this._options),r=e&&yv(e);n=r?o?function(t){return o(t)&&r(t);}:r:o,op(i=this._data).call(i,t,{filter:n,order:e&&e.order});}}},{key:"map",value:function value(t,e){if(this._data){var i,n,o=yv(this._options),r=e&&yv(e);return n=r?o?function(t){return o(t)&&r(t);}:r:o,jf(i=this._data).call(i,t,{filter:n,order:e&&e.order});}return[];}},{key:"getDataSet",value:function value(){return this._data.getDataSet();}},{key:"stream",value:function value(t){var e;return this._data.stream(t||z_({},IS,Hn(e=CT(this._ids)).call(e,this._ids)));}},{key:"dispose",value:function value(){var t;null!==(t=this._data)&&void 0!==t&&t.off&&this._data.off("*",this._listener);var e,n="This data view has already been disposed of.",o={get:function get(){throw new Error(n);},set:function set(){throw new Error(n);},configurable:!1},r=LM(Pf(i.prototype));try{for(r.s();!(e=r.n()).done;){var s=e.value;UT(this,s,o);}}catch(t){r.e(t);}finally{r.f();}}},{key:"_onEvent",value:function value(t,e,i){if(e&&e.items&&this._data){var n=e.items,o=[],r=[],s=[],a=[],h=[],l=[];switch(t){case"add":for(var d=0,c=n.length;d<c;d++){var u=n[d];this.get(u)&&(this._ids.add(u),o.push(u));}break;case"update":for(var f=0,p=n.length;f<p;f++){var v=n[f];this.get(v)?this._ids.has(v)?(r.push(v),h.push(e.data[f]),a.push(e.oldData[f])):(this._ids.add(v),o.push(v)):this._ids.has(v)&&(this._ids["delete"](v),s.push(v),l.push(e.oldData[f]));}break;case"remove":for(var g=0,y=n.length;g<y;g++){var m=n[g];this._ids.has(m)&&(this._ids["delete"](m),s.push(m),l.push(e.oldData[g]));}}this.length+=o.length-s.length,o.length&&this._trigger("add",{items:o},i),r.length&&this._trigger("update",{items:r,oldData:a,data:h},i),s.length&&this._trigger("remove",{items:s,oldData:l},i);}}}]),i;}(YM);function $M(t,e){return"object"===bu(e)&&null!==e&&t===e.idProp&&"function"==typeof e.add&&"function"==typeof e.clear&&"function"==typeof e.distinct&&"function"==typeof op(e)&&"function"==typeof e.get&&"function"==typeof e.getDataSet&&"function"==typeof e.getIds&&"number"==typeof e.length&&"function"==typeof jf(e)&&"function"==typeof e.max&&"function"==typeof e.min&&"function"==typeof e.off&&"function"==typeof e.on&&"function"==typeof e.remove&&"function"==typeof e.setOptions&&"function"==typeof e.stream&&"function"==typeof e.update&&"function"==typeof e.updateOnly;}function ZM(t,e){return"object"===bu(e)&&null!==e&&t===e.idProp&&"function"==typeof op(e)&&"function"==typeof e.get&&"function"==typeof e.getDataSet&&"function"==typeof e.getIds&&"number"==typeof e.length&&"function"==typeof jf(e)&&"function"==typeof e.off&&"function"==typeof e.on&&"function"==typeof e.stream&&$M(t,e.getDataSet());}var QM=Object.freeze({__proto__:null,DELETE:Xm,DataSet:GM,DataStream:XM,DataView:KM,Queue:UM,createNewDataPipeFrom:function createNewDataPipeFrom(t){return new qM(t);},isDataSetLike:$M,isDataViewLike:ZM}),JM=o,tP=r,eP=co,iP=Rv.trim,nP=Dv,oP=g("".charAt),rP=JM.parseFloat,sP=JM.Symbol,aP=sP&&sP.iterator,hP=1/rP(nP+"-0")!=-1/0||aP&&!tP(function(){rP(Object(aP));})?function(t){var e=iP(eP(t)),i=rP(e);return 0===i&&"-"===oP(e,0)?-0:i;}:rP;Ti({global:!0,forced:parseFloat!==hP},{parseFloat:hP});var lP=i(et.parseFloat),dP=Ti,cP=r,uP=il.f;dP({target:"Object",stat:!0,forced:cP(function(){return!Object.getOwnPropertyNames(1);})},{getOwnPropertyNames:uP});var fP=et.Object,pP=function pP(t){return fP.getOwnPropertyNames(t);},vP=i(pP);function gP(t,e){var i=["node","edge","label"],n=!0,o=Rb(e,"chosen");if("boolean"==typeof o)n=o;else if("object"===bu(o)){if(-1===lg(i).call(i,t))throw new Error("choosify: subOption '"+t+"' should be one of '"+i.join("', '")+"'");var r=Rb(e,["chosen",t]);"boolean"!=typeof r&&"function"!=typeof r||(n=r);}return n;}function yP(t,e,i){if(t.width<=0||t.height<=0)return!1;if(void 0!==i){var n={x:e.x-i.x,y:e.y-i.y};if(0!==i.angle){var o=-i.angle;e={x:Math.cos(o)*n.x-Math.sin(o)*n.y,y:Math.sin(o)*n.x+Math.cos(o)*n.y};}else e=n;}var r=t.x+t.width,s=t.y+t.width;return t.left<e.x&&r>e.x&&t.top<e.y&&s>e.y;}function mP(t){return"string"==typeof t&&""!==t;}function bP(t,e,i,n){var o=n.x,r=n.y;if("function"==typeof n.distanceToBorder){var s=n.distanceToBorder(t,e),a=Math.sin(e)*s,h=Math.cos(e)*s;h===s?(o+=s,r=n.y):a===s?(o=n.x,r-=s):(o+=h,r-=a);}else n.shape.width>n.shape.height?(o=n.x+.5*n.shape.width,r=n.y-i):(o=n.x+i,r=n.y-.5*n.shape.height);return{x:o,y:r};}var wP=function(){function t(e){ph(this,t),this.measureText=e,this.current=0,this.width=0,this.height=0,this.lines=[];}return xu(t,[{key:"_add",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"normal";void 0===this.lines[t]&&(this.lines[t]={width:0,height:0,blocks:[]});var n=e;void 0!==e&&""!==e||(n=" ");var o=this.measureText(n,i),r=bn({},FT(o));r.text=e,r.width=o.width,r.mod=i,void 0!==e&&""!==e||(r.width=0),this.lines[t].blocks.push(r),this.lines[t].width+=r.width;}},{key:"curWidth",value:function value(){var t=this.lines[this.current];return void 0===t?0:t.width;}},{key:"append",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"normal";this._add(this.current,t,e);}},{key:"newLine",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"normal";this._add(this.current,t,e),this.current++;}},{key:"determineLineHeights",value:function value(){for(var t=0;t<this.lines.length;t++){var e=this.lines[t],i=0;if(void 0!==e.blocks)for(var n=0;n<e.blocks.length;n++){var o=e.blocks[n];i<o.height&&(i=o.height);}e.height=i;}}},{key:"determineLabelSize",value:function value(){for(var t=0,e=0,i=0;i<this.lines.length;i++){var n=this.lines[i];n.width>t&&(t=n.width),e+=n.height;}this.width=t,this.height=e;}},{key:"removeEmptyBlocks",value:function value(){for(var t=[],e=0;e<this.lines.length;e++){var i=this.lines[e];if(0!==i.blocks.length&&(e!==this.lines.length-1||0!==i.width)){var n={};bn(n,i),n.blocks=[];for(var o=void 0,r=[],s=0;s<i.blocks.length;s++){var a=i.blocks[s];0!==a.width?r.push(a):void 0===o&&(o=a);}0===r.length&&void 0!==o&&r.push(o),n.blocks=r,t.push(n);}}return t;}},{key:"finalize",value:function value(){this.determineLineHeights(),this.determineLabelSize();var t=this.removeEmptyBlocks();return{width:this.width,height:this.height,lines:t};}}]),t;}(),kP={"<b>":/<b>/,"<i>":/<i>/,"<code>":/<code>/,"</b>":/<\/b>/,"</i>":/<\/i>/,"</code>":/<\/code>/,"*":/\*/,_:/_/,"`":/`/,afterBold:/[^*]/,afterItal:/[^_]/,afterMono:/[^`]/},_P=function(){function t(e){ph(this,t),this.text=e,this.bold=!1,this.ital=!1,this.mono=!1,this.spacing=!1,this.position=0,this.buffer="",this.modStack=[],this.blocks=[];}return xu(t,[{key:"mod",value:function value(){return 0===this.modStack.length?"normal":this.modStack[0];}},{key:"modName",value:function value(){return 0===this.modStack.length?"normal":"mono"===this.modStack[0]?"mono":this.bold&&this.ital?"boldital":this.bold?"bold":this.ital?"ital":void 0;}},{key:"emitBlock",value:function value(){this.spacing&&(this.add(" "),this.spacing=!1),this.buffer.length>0&&(this.blocks.push({text:this.buffer,mod:this.modName()}),this.buffer="");}},{key:"add",value:function value(t){" "===t&&(this.spacing=!0),this.spacing&&(this.buffer+=" ",this.spacing=!1)," "!=t&&(this.buffer+=t);}},{key:"parseWS",value:function value(t){return!!/[ \t]/.test(t)&&(this.mono?this.add(t):this.spacing=!0,!0);}},{key:"setTag",value:function value(t){this.emitBlock(),this[t]=!0,this.modStack.unshift(t);}},{key:"unsetTag",value:function value(t){this.emitBlock(),this[t]=!1,this.modStack.shift();}},{key:"parseStartTag",value:function value(t,e){return!(this.mono||this[t]||!this.match(e))&&(this.setTag(t),!0);}},{key:"match",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=pf(this.prepareRegExp(t),2),n=i[0],o=i[1],r=n.test(this.text.substr(this.position,o));return r&&e&&(this.position+=o-1),r;}},{key:"parseEndTag",value:function value(t,e,i){var n=this.mod()===t;return!(!(n="mono"===t?n&&this.mono:n&&!this.mono)||!this.match(e))&&(void 0!==i?(this.position===this.text.length-1||this.match(i,!1))&&this.unsetTag(t):this.unsetTag(t),!0);}},{key:"replace",value:function value(t,e){return!!this.match(t)&&(this.add(e),this.position+=length-1,!0);}},{key:"prepareRegExp",value:function value(t){var e,i;if(t instanceof RegExp)i=t,e=1;else{var n=kP[t];i=void 0!==n?n:new RegExp(t),e=t.length;}return[i,e];}}]),t;}(),xP=function(){function t(e,i,n,o){var r=this;ph(this,t),this.ctx=e,this.parent=i,this.selected=n,this.hover=o;this.lines=new wP(function(t,i){if(void 0===t)return 0;var s=r.parent.getFormattingValues(e,n,o,i),a=0;""!==t&&(a=r.ctx.measureText(t).width);return{width:a,values:s};});}return xu(t,[{key:"process",value:function value(t){if(!mP(t))return this.lines.finalize();var e=this.parent.fontOptions;t=(t=t.replace(/\r\n/g,"\n")).replace(/\r/g,"\n");var i=String(t).split("\n"),n=i.length;if(e.multi)for(var o=0;o<n;o++){var r=this.splitBlocks(i[o],e.multi);if(void 0!==r)if(0!==r.length){if(e.maxWdt>0)for(var s=0;s<r.length;s++){var a=r[s].mod,h=r[s].text;this.splitStringIntoLines(h,a,!0);}else for(var l=0;l<r.length;l++){var d=r[l].mod,c=r[l].text;this.lines.append(c,d);}this.lines.newLine();}else this.lines.newLine("");}else if(e.maxWdt>0)for(var u=0;u<n;u++)this.splitStringIntoLines(i[u]);else for(var f=0;f<n;f++)this.lines.newLine(i[f]);return this.lines.finalize();}},{key:"decodeMarkupSystem",value:function value(t){var e="none";return"markdown"===t||"md"===t?e="markdown":!0!==t&&"html"!==t||(e="html"),e;}},{key:"splitHtmlBlocks",value:function value(t){for(var e=new _P(t),i=function i(t){return!!/&/.test(t)&&(e.replace(e.text,"&lt;","<")||e.replace(e.text,"&amp;","&")||e.add("&"),!0);};e.position<e.text.length;){var n=e.text.charAt(e.position);e.parseWS(n)||/</.test(n)&&(e.parseStartTag("bold","<b>")||e.parseStartTag("ital","<i>")||e.parseStartTag("mono","<code>")||e.parseEndTag("bold","</b>")||e.parseEndTag("ital","</i>")||e.parseEndTag("mono","</code>"))||i(n)||e.add(n),e.position++;}return e.emitBlock(),e.blocks;}},{key:"splitMarkdownBlocks",value:function value(t){for(var e=this,i=new _P(t),n=!0,o=function o(t){return!!/\\/.test(t)&&(i.position<e.text.length+1&&(i.position++,t=e.text.charAt(i.position),/ \t/.test(t)?i.spacing=!0:(i.add(t),n=!1)),!0);};i.position<i.text.length;){var r=i.text.charAt(i.position);i.parseWS(r)||o(r)||(n||i.spacing)&&(i.parseStartTag("bold","*")||i.parseStartTag("ital","_")||i.parseStartTag("mono","`"))||i.parseEndTag("bold","*","afterBold")||i.parseEndTag("ital","_","afterItal")||i.parseEndTag("mono","`","afterMono")||(i.add(r),n=!1),i.position++;}return i.emitBlock(),i.blocks;}},{key:"splitBlocks",value:function value(t,e){var i=this.decodeMarkupSystem(e);return"none"===i?[{text:t,mod:"normal"}]:"markdown"===i?this.splitMarkdownBlocks(t):"html"===i?this.splitHtmlBlocks(t):void 0;}},{key:"overMaxWidth",value:function value(t){var e=this.ctx.measureText(t).width;return this.lines.curWidth()+e>this.parent.fontOptions.maxWdt;}},{key:"getLongestFit",value:function value(t){for(var e="",i=0;i<t.length;){var n=e+(""===e?"":" ")+t[i];if(this.overMaxWidth(n))break;e=n,i++;}return i;}},{key:"getLongestFitWord",value:function value(t){for(var e=0;e<t.length&&!this.overMaxWidth(xf(t).call(t,0,e));)e++;return e;}},{key:"splitStringIntoLines",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"normal",i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this.parent.getFormattingValues(this.ctx,this.selected,this.hover,e);for(var n=(t=(t=t.replace(/^( +)/g,"$1\r")).replace(/([^\r][^ ]*)( +)/g,"$1\r$2\r")).split("\r");n.length>0;){var o=this.getLongestFit(n);if(0===o){var r=n[0],s=this.getLongestFitWord(r);this.lines.newLine(xf(r).call(r,0,s),e),n[0]=xf(r).call(r,s);}else{var a=o;" "===n[o-1]?o--:" "===n[a]&&a++;var h=xf(n).call(n,0,o).join("");o==n.length&&i?this.lines.append(h,e):this.lines.newLine(h,e),n=xf(n).call(n,a);}}}}]),t;}(),EP=["bold","ital","boldital","mono"],OP=function(){function t(e,i){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];ph(this,t),this.body=e,this.pointToSelf=!1,this.baseSize=void 0,this.fontOptions={},this.setOptions(i),this.size={top:0,left:0,width:0,height:0,yLine:0},this.isEdgeLabel=n;}return xu(t,[{key:"setOptions",value:function value(t){if(this.elementOptions=t,this.initFontOptions(t.font),mP(t.label)?this.labelDirty=!0:t.label=void 0,void 0!==t.font&&null!==t.font)if("string"==typeof t.font)this.baseSize=this.fontOptions.size;else if("object"===bu(t.font)){var e=t.font.size;void 0!==e&&(this.baseSize=e);}}},{key:"initFontOptions",value:function value(e){var i=this;kb(EP,function(t){i.fontOptions[t]={};}),t.parseFontString(this.fontOptions,e)?this.fontOptions.vadjust=0:kb(e,function(t,e){null!=t&&"object"!==bu(t)&&(i.fontOptions[e]=t);});}},{key:"constrain",value:function value(t){var e={constrainWidth:!1,maxWdt:-1,minWdt:-1,constrainHeight:!1,minHgt:-1,valign:"middle"},i=Rb(t,"widthConstraint");if("number"==typeof i)e.maxWdt=Number(i),e.minWdt=Number(i);else if("object"===bu(i)){var n=Rb(t,["widthConstraint","maximum"]);"number"==typeof n&&(e.maxWdt=Number(n));var o=Rb(t,["widthConstraint","minimum"]);"number"==typeof o&&(e.minWdt=Number(o));}var r=Rb(t,"heightConstraint");if("number"==typeof r)e.minHgt=Number(r);else if("object"===bu(r)){var s=Rb(t,["heightConstraint","minimum"]);"number"==typeof s&&(e.minHgt=Number(s));var a=Rb(t,["heightConstraint","valign"]);"string"==typeof a&&("top"!==a&&"bottom"!==a||(e.valign=a));}return e;}},{key:"update",value:function value(t,e){this.setOptions(t,!0),this.propagateFonts(e),gb(this.fontOptions,this.constrain(e)),this.fontOptions.chooser=gP("label",e);}},{key:"adjustSizes",value:function value(t){var e=t?t.right+t.left:0;this.fontOptions.constrainWidth&&(this.fontOptions.maxWdt-=e,this.fontOptions.minWdt-=e);var i=t?t.top+t.bottom:0;this.fontOptions.constrainHeight&&(this.fontOptions.minHgt-=i);}},{key:"addFontOptionsToPile",value:function value(t,e){for(var i=0;i<e.length;++i)this.addFontToPile(t,e[i]);}},{key:"addFontToPile",value:function value(t,e){if(void 0!==e&&void 0!==e.font&&null!==e.font){var i=e.font;t.push(i);}}},{key:"getBasicOptions",value:function value(e){for(var i={},n=0;n<e.length;++n){var o=e[n],r={};t.parseFontString(r,o)&&(o=r),kb(o,function(t,e){void 0!==t&&(Object.prototype.hasOwnProperty.call(i,e)||(-1!==lg(EP).call(EP,e)?i[e]={}:i[e]=t));});}return i;}},{key:"getFontOption",value:function value(e,i,n){for(var o,r=0;r<e.length;++r){var s=e[r];if(Object.prototype.hasOwnProperty.call(s,i)){if(null==(o=s[i]))continue;var a={};if(t.parseFontString(a,o)&&(o=a),Object.prototype.hasOwnProperty.call(o,n))return o[n];}}if(Object.prototype.hasOwnProperty.call(this.fontOptions,n))return this.fontOptions[n];throw new Error("Did not find value for multi-font for property: '"+n+"'");}},{key:"getFontOptions",value:function value(t,e){for(var i={},n=["color","size","face","mod","vadjust"],o=0;o<n.length;++o){var r=n[o];i[r]=this.getFontOption(t,e,r);}return i;}},{key:"propagateFonts",value:function value(t){var e=this,i=[];this.addFontOptionsToPile(i,t),this.fontOptions=this.getBasicOptions(i);for(var n=function n(){var t=EP[o],n=e.fontOptions[t];kb(e.getFontOptions(i,t),function(t,e){n[e]=t;}),n.size=Number(n.size),n.vadjust=Number(n.vadjust);},o=0;o<EP.length;++o)n();}},{key:"draw",value:function value(t,e,i,n,o){var r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"middle";if(void 0!==this.elementOptions.label){var s=this.fontOptions.size*this.body.view.scale;this.elementOptions.label&&s<this.elementOptions.scaling.label.drawThreshold-1||(s>=this.elementOptions.scaling.label.maxVisible&&(s=Number(this.elementOptions.scaling.label.maxVisible)/this.body.view.scale),this.calculateLabelSize(t,n,o,e,i,r),this._drawBackground(t),this._drawText(t,e,this.size.yLine,r,s));}}},{key:"_drawBackground",value:function value(t){if(void 0!==this.fontOptions.background&&"none"!==this.fontOptions.background){t.fillStyle=this.fontOptions.background;var e=this.getSize();t.fillRect(e.left,e.top,e.width,e.height);}}},{key:"_drawText",value:function value(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"middle",o=arguments.length>4?arguments[4]:void 0,r=pf(this._setAlignment(t,e,i,n),2);e=r[0],i=r[1],t.textAlign="left",e-=this.size.width/2,this.fontOptions.valign&&this.size.height>this.size.labelHeight&&("top"===this.fontOptions.valign&&(i-=(this.size.height-this.size.labelHeight)/2),"bottom"===this.fontOptions.valign&&(i+=(this.size.height-this.size.labelHeight)/2));for(var s=0;s<this.lineCount;s++){var a=this.lines[s];if(a&&a.blocks){var h=0;this.isEdgeLabel||"center"===this.fontOptions.align?h+=(this.size.width-a.width)/2:"right"===this.fontOptions.align&&(h+=this.size.width-a.width);for(var l=0;l<a.blocks.length;l++){var d=a.blocks[l];t.font=d.font;var c=pf(this._getColor(d.color,o,d.strokeColor),2),u=c[0],f=c[1];d.strokeWidth>0&&(t.lineWidth=d.strokeWidth,t.strokeStyle=f,t.lineJoin="round"),t.fillStyle=u,d.strokeWidth>0&&t.strokeText(d.text,e+h,i+d.vadjust),t.fillText(d.text,e+h,i+d.vadjust),h+=d.width;}i+=a.height;}}}},{key:"_setAlignment",value:function value(t,e,i,n){if(this.isEdgeLabel&&"horizontal"!==this.fontOptions.align&&!1===this.pointToSelf){e=0,i=0;"top"===this.fontOptions.align?(t.textBaseline="alphabetic",i-=4):"bottom"===this.fontOptions.align?(t.textBaseline="hanging",i+=4):t.textBaseline="middle";}else t.textBaseline=n;return[e,i];}},{key:"_getColor",value:function value(t,e,i){var n=t||"#000000",o=i||"#ffffff";if(e<=this.elementOptions.scaling.label.drawThreshold){var r=Math.max(0,Math.min(1,1-(this.elementOptions.scaling.label.drawThreshold-e)));n=Ob(n,r),o=Ob(o,r);}return[n,o];}},{key:"getTextSize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return this._processLabel(t,e,i),{width:this.size.width,height:this.size.height,lineCount:this.lineCount};}},{key:"getSize",value:function value(){var t=this.size.left,e=this.size.top-1;if(this.isEdgeLabel){var i=.5*-this.size.width;switch(this.fontOptions.align){case"middle":t=i,e=.5*-this.size.height;break;case"top":t=i,e=-(this.size.height+2);break;case"bottom":t=i,e=2;}}return{left:t,top:e,width:this.size.width,height:this.size.height};}},{key:"calculateLabelSize",value:function value(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"middle";this._processLabel(t,e,i),this.size.left=n-.5*this.size.width,this.size.top=o-.5*this.size.height,this.size.yLine=o+.5*(1-this.lineCount)*this.fontOptions.size,"hanging"===r&&(this.size.top+=.5*this.fontOptions.size,this.size.top+=4,this.size.yLine+=4);}},{key:"getFormattingValues",value:function value(t,e,i,n){var o=function o(t,e,i){return"normal"===e?"mod"===i?"":t[i]:void 0!==t[e][i]?t[e][i]:t[i];},r={color:o(this.fontOptions,n,"color"),size:o(this.fontOptions,n,"size"),face:o(this.fontOptions,n,"face"),mod:o(this.fontOptions,n,"mod"),vadjust:o(this.fontOptions,n,"vadjust"),strokeWidth:this.fontOptions.strokeWidth,strokeColor:this.fontOptions.strokeColor};(e||i)&&("normal"===n&&!0===this.fontOptions.chooser&&this.elementOptions.labelHighlightBold?r.mod="bold":"function"==typeof this.fontOptions.chooser&&this.fontOptions.chooser(r,this.elementOptions.id,e,i));var s="";return void 0!==r.mod&&""!==r.mod&&(s+=r.mod+" "),s+=r.size+"px "+r.face,t.font=s.replace(/"/g,""),r.font=t.font,r.height=r.size,r;}},{key:"differentState",value:function value(t,e){return t!==this.selectedState||e!==this.hoverState;}},{key:"_processLabelText",value:function value(t,e,i,n){return new xP(t,this,e,i).process(n);}},{key:"_processLabel",value:function value(t,e,i){if(!1!==this.labelDirty||this.differentState(e,i)){var n=this._processLabelText(t,e,i,this.elementOptions.label);this.fontOptions.minWdt>0&&n.width<this.fontOptions.minWdt&&(n.width=this.fontOptions.minWdt),this.size.labelHeight=n.height,this.fontOptions.minHgt>0&&n.height<this.fontOptions.minHgt&&(n.height=this.fontOptions.minHgt),this.lines=n.lines,this.lineCount=n.lines.length,this.size.width=n.width,this.size.height=n.height,this.selectedState=e,this.hoverState=i,this.labelDirty=!1;}}},{key:"visible",value:function value(){return 0!==this.size.width&&0!==this.size.height&&void 0!==this.elementOptions.label&&!(this.fontOptions.size*this.body.view.scale<this.elementOptions.scaling.label.drawThreshold-1);}}],[{key:"parseFontString",value:function value(t,e){if(!e||"string"!=typeof e)return!1;var i=e.split(" ");return t.size=+i[0].replace("px",""),t.face=i[1],t.color=i[2],!0;}}]),t;}(),CP=function(){function t(e,i,n){ph(this,t),this.body=i,this.labelModule=n,this.setOptions(e),this.top=void 0,this.left=void 0,this.height=void 0,this.width=void 0,this.radius=void 0,this.margin=void 0,this.refreshNeeded=!0,this.boundingBox={top:0,left:0,right:0,bottom:0};}return xu(t,[{key:"setOptions",value:function value(t){this.options=t;}},{key:"_setMargins",value:function value(t){this.margin={},this.options.margin&&("object"==bu(this.options.margin)?(this.margin.top=this.options.margin.top,this.margin.right=this.options.margin.right,this.margin.bottom=this.options.margin.bottom,this.margin.left=this.options.margin.left):(this.margin.top=this.options.margin,this.margin.right=this.options.margin,this.margin.bottom=this.options.margin,this.margin.left=this.options.margin)),t.adjustSizes(this.margin);}},{key:"_distanceToBorder",value:function value(t,e){var i=this.options.borderWidth;return t&&this.resize(t),Math.min(Math.abs(this.width/2/Math.cos(e)),Math.abs(this.height/2/Math.sin(e)))+i;}},{key:"enableShadow",value:function value(t,e){e.shadow&&(t.shadowColor=e.shadowColor,t.shadowBlur=e.shadowSize,t.shadowOffsetX=e.shadowX,t.shadowOffsetY=e.shadowY);}},{key:"disableShadow",value:function value(t,e){e.shadow&&(t.shadowColor="rgba(0,0,0,0)",t.shadowBlur=0,t.shadowOffsetX=0,t.shadowOffsetY=0);}},{key:"enableBorderDashes",value:function value(t,e){if(!1!==e.borderDashes)if(void 0!==t.setLineDash){var i=e.borderDashes;!0===i&&(i=[5,15]),t.setLineDash(i);}else console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used."),this.options.shapeProperties.borderDashes=!1,e.borderDashes=!1;}},{key:"disableBorderDashes",value:function value(t,e){!1!==e.borderDashes&&(void 0!==t.setLineDash?t.setLineDash([0]):(console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used."),this.options.shapeProperties.borderDashes=!1,e.borderDashes=!1));}},{key:"needsRefresh",value:function value(t,e){return!0===this.refreshNeeded?(this.refreshNeeded=!1,!0):void 0===this.width||this.labelModule.differentState(t,e);}},{key:"initContextForDraw",value:function value(t,e){var i=e.borderWidth/this.body.view.scale;t.lineWidth=Math.min(this.width,i),t.strokeStyle=e.borderColor,t.fillStyle=e.color;}},{key:"performStroke",value:function value(t,e){var i=e.borderWidth/this.body.view.scale;t.save(),i>0&&(this.enableBorderDashes(t,e),t.stroke(),this.disableBorderDashes(t,e)),t.restore();}},{key:"performFill",value:function value(t,e){t.save(),t.fillStyle=e.color,this.enableShadow(t,e),Kg(t).call(t),this.disableShadow(t,e),t.restore(),this.performStroke(t,e);}},{key:"_addBoundingBoxMargin",value:function value(t){this.boundingBox.left-=t,this.boundingBox.top-=t,this.boundingBox.bottom+=t,this.boundingBox.right+=t;}},{key:"_updateBoundingBox",value:function value(t,e,i,n,o){void 0!==i&&this.resize(i,n,o),this.left=t-this.width/2,this.top=e-this.height/2,this.boundingBox.left=this.left,this.boundingBox.top=this.top,this.boundingBox.bottom=this.top+this.height,this.boundingBox.right=this.left+this.width;}},{key:"updateBoundingBox",value:function value(t,e,i,n,o){this._updateBoundingBox(t,e,i,n,o);}},{key:"getDimensionsFromLabel",value:function value(t,e,i){this.textSize=this.labelModule.getTextSize(t,e,i);var n=this.textSize.width,o=this.textSize.height;return 0===n&&(n=14,o=14),{width:n,height:o};}}]),t;}();function SP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var TP=function(t){D_(i,t);var e=SP(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._setMargins(o),r;}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover;if(this.needsRefresh(e,i)){var n=this.getDimensionsFromLabel(t,e,i);this.width=n.width+this.margin.right+this.margin.left,this.height=n.height+this.margin.top+this.margin.bottom,this.radius=this.width/2;}}},{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o),this.left=e-this.width/2,this.top=i-this.height/2,this.initContextForDraw(t,r),qn(t,this.left,this.top,this.width,this.height,r.borderRadius),this.performFill(t,r),this.updateBoundingBox(e,i,t,n,o),this.labelModule.draw(t,this.left+this.textSize.width/2+this.margin.left,this.top+this.textSize.height/2+this.margin.top,n,o);}},{key:"updateBoundingBox",value:function value(t,e,i,n,o){this._updateBoundingBox(t,e,i,n,o);var r=this.options.shapeProperties.borderRadius;this._addBoundingBoxMargin(r);}},{key:"distanceToBorder",value:function value(t,e){t&&this.resize(t);var i=this.options.borderWidth;return Math.min(Math.abs(this.width/2/Math.cos(e)),Math.abs(this.height/2/Math.sin(e)))+i;}}]),i;}(CP);function MP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var PP=function(t){D_(i,t);var e=MP(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o)).labelOffset=0,r.selected=!1,r;}return xu(i,[{key:"setOptions",value:function value(t,e,i){this.options=t,void 0===e&&void 0===i||this.setImages(e,i);}},{key:"setImages",value:function value(t,e){e&&this.selected?(this.imageObj=e,this.imageObjAlt=t):(this.imageObj=t,this.imageObjAlt=e);}},{key:"switchImages",value:function value(t){var e=t&&!this.selected||!t&&this.selected;if(this.selected=t,void 0!==this.imageObjAlt&&e){var i=this.imageObj;this.imageObj=this.imageObjAlt,this.imageObjAlt=i;}}},{key:"_getImagePadding",value:function value(){var t={top:0,right:0,bottom:0,left:0};if(this.options.imagePadding){var e=this.options.imagePadding;"object"==bu(e)?(t.top=e.top,t.right=e.right,t.bottom=e.bottom,t.left=e.left):(t.top=e,t.right=e,t.bottom=e,t.left=e);}return t;}},{key:"_resizeImage",value:function value(){var t,e;if(!1===this.options.shapeProperties.useImageSize){var i=1,n=1;this.imageObj.width&&this.imageObj.height&&(this.imageObj.width>this.imageObj.height?i=this.imageObj.width/this.imageObj.height:n=this.imageObj.height/this.imageObj.width),t=2*this.options.size*i,e=2*this.options.size*n;}else{var o=this._getImagePadding();t=this.imageObj.width+o.left+o.right,e=this.imageObj.height+o.top+o.bottom;}this.width=t,this.height=e,this.radius=.5*this.width;}},{key:"_drawRawCircle",value:function value(t,e,i,n){this.initContextForDraw(t,n),Wn(t,e,i,n.size),this.performFill(t,n);}},{key:"_drawImageAtPosition",value:function value(t,e){if(0!=this.imageObj.width){t.globalAlpha=void 0!==e.opacity?e.opacity:1,this.enableShadow(t,e);var i=1;!0===this.options.shapeProperties.interpolation&&(i=this.imageObj.width/this.width/this.body.view.scale);var n=this._getImagePadding(),o=this.left+n.left,r=this.top+n.top,s=this.width-n.left-n.right,a=this.height-n.top-n.bottom;this.imageObj.drawImageAtPosition(t,i,o,r,s,a),this.disableShadow(t,e);}}},{key:"_drawImageLabel",value:function value(t,e,i,n,o){var r=0;if(void 0!==this.height){r=.5*this.height;var s=this.labelModule.getTextSize(t,n,o);s.lineCount>=1&&(r+=s.height/2);}var a=i+r;this.options.label&&(this.labelOffset=r),this.labelModule.draw(t,e,a,n,o,"hanging");}}]),i;}(CP);function DP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var IP=function(t){D_(i,t);var e=DP(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._setMargins(o),r;}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover;if(this.needsRefresh(e,i)){var n=this.getDimensionsFromLabel(t,e,i),o=Math.max(n.width+this.margin.right+this.margin.left,n.height+this.margin.top+this.margin.bottom);this.options.size=o/2,this.width=o,this.height=o,this.radius=this.width/2;}}},{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o),this.left=e-this.width/2,this.top=i-this.height/2,this._drawRawCircle(t,e,i,r),this.updateBoundingBox(e,i),this.labelModule.draw(t,this.left+this.textSize.width/2+this.margin.left,i,n,o);}},{key:"updateBoundingBox",value:function value(t,e){this.boundingBox.top=e-this.options.size,this.boundingBox.left=t-this.options.size,this.boundingBox.right=t+this.options.size,this.boundingBox.bottom=e+this.options.size;}},{key:"distanceToBorder",value:function value(t){return t&&this.resize(t),.5*this.width;}}]),i;}(PP);function BP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var NP=function(t){D_(i,t);var e=BP(i);function i(t,n,o,r,s){var a;return ph(this,i),(a=e.call(this,t,n,o)).setImages(r,s),a;}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover;if(void 0===this.imageObj.src||void 0===this.imageObj.width||void 0===this.imageObj.height){var n=2*this.options.size;return this.width=n,this.height=n,void(this.radius=.5*this.width);}this.needsRefresh(e,i)&&this._resizeImage();}},{key:"draw",value:function value(t,e,i,n,o,r){this.switchImages(n),this.resize();var s=e,a=i;"top-left"===this.options.shapeProperties.coordinateOrigin?(this.left=e,this.top=i,s+=this.width/2,a+=this.height/2):(this.left=e-this.width/2,this.top=i-this.height/2),this._drawRawCircle(t,s,a,r),t.save(),t.clip(),this._drawImageAtPosition(t,r),t.restore(),this._drawImageLabel(t,s,a,n,o),this.updateBoundingBox(e,i);}},{key:"updateBoundingBox",value:function value(t,e){"top-left"===this.options.shapeProperties.coordinateOrigin?(this.boundingBox.top=e,this.boundingBox.left=t,this.boundingBox.right=t+2*this.options.size,this.boundingBox.bottom=e+2*this.options.size):(this.boundingBox.top=e-this.options.size,this.boundingBox.left=t-this.options.size,this.boundingBox.right=t+this.options.size,this.boundingBox.bottom=e+this.options.size),this.boundingBox.left=Math.min(this.boundingBox.left,this.labelModule.size.left),this.boundingBox.right=Math.max(this.boundingBox.right,this.labelModule.size.left+this.labelModule.size.width),this.boundingBox.bottom=Math.max(this.boundingBox.bottom,this.boundingBox.bottom+this.labelOffset);}},{key:"distanceToBorder",value:function value(t){return t&&this.resize(t),.5*this.width;}}]),i;}(PP);function FP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var zP=function(t){D_(i,t);var e=FP(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{size:this.options.size};if(this.needsRefresh(e,i)){var o,r;this.labelModule.getTextSize(t,e,i);var s=2*n.size;this.width=null!==(o=this.customSizeWidth)&&void 0!==o?o:s,this.height=null!==(r=this.customSizeHeight)&&void 0!==r?r:s,this.radius=.5*this.width;}}},{key:"_drawShape",value:function value(t,e,i,n,o,r,s,a){var h,l=this;return this.resize(t,r,s,a),this.left=n-this.width/2,this.top=o-this.height/2,this.initContextForDraw(t,a),(h=e,Object.prototype.hasOwnProperty.call(Xn,h)?Xn[h]:function(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),n=1;n<e;n++)i[n-1]=arguments[n];CanvasRenderingContext2D.prototype[h].call(t,i);})(t,n,o,a.size),this.performFill(t,a),void 0!==this.options.icon&&void 0!==this.options.icon.code&&(t.font=(r?"bold ":"")+this.height/2+"px "+(this.options.icon.face||"FontAwesome"),t.fillStyle=this.options.icon.color||"black",t.textAlign="center",t.textBaseline="middle",t.fillText(this.options.icon.code,n,o)),{drawExternalLabel:function drawExternalLabel(){if(void 0!==l.options.label){l.labelModule.calculateLabelSize(t,r,s,n,o,"hanging");var e=o+.5*l.height+.5*l.labelModule.size.height;l.labelModule.draw(t,n,e,r,s,"hanging");}l.updateBoundingBox(n,o);}};}},{key:"updateBoundingBox",value:function value(t,e){this.boundingBox.top=e-this.options.size,this.boundingBox.left=t-this.options.size,this.boundingBox.right=t+this.options.size,this.boundingBox.bottom=e+this.options.size,void 0!==this.options.label&&this.labelModule.size.width>0&&(this.boundingBox.left=Math.min(this.boundingBox.left,this.labelModule.size.left),this.boundingBox.right=Math.max(this.boundingBox.right,this.labelModule.size.left+this.labelModule.size.width),this.boundingBox.bottom=Math.max(this.boundingBox.bottom,this.boundingBox.bottom+this.labelModule.size.height));}}]),i;}(CP);function AP(t,e){var i=Hf(t);if(aM){var n=aM(t);e&&(n=yv(n).call(n,function(e){return yM(t,e).enumerable;})),i.push.apply(i,n);}return i;}function jP(t){for(var e=1;e<arguments.length;e++){var i,n,o=null!=arguments[e]?arguments[e]:{};e%2?op(i=AP(Object(o),!0)).call(i,function(e){z_(t,e,o[e]);}):_M?MM(t,_M(o)):op(n=AP(Object(o))).call(n,function(e){UT(t,e,yM(o,e));});}return t;}function RP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var LP=function(t){D_(i,t);var e=RP(i);function i(t,n,o,r){var s;return ph(this,i),(s=e.call(this,t,n,o,r)).ctxRenderer=r,s;}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o,r),this.left=e-this.width/2,this.top=i-this.height/2,t.save();var s=this.ctxRenderer({ctx:t,id:this.options.id,x:e,y:i,state:{selected:n,hover:o},style:jP({},r),label:this.options.label});if(null!=s.drawNode&&s.drawNode(),t.restore(),s.drawExternalLabel){var a=s.drawExternalLabel;s.drawExternalLabel=function(){t.save(),a(),t.restore();};}return s.nodeDimensions&&(this.customSizeWidth=s.nodeDimensions.width,this.customSizeHeight=s.nodeDimensions.height),s;}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function HP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var WP=function(t){D_(i,t);var e=HP(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._setMargins(o),r;}return xu(i,[{key:"resize",value:function value(t,e,i){if(this.needsRefresh(e,i)){var n=this.getDimensionsFromLabel(t,e,i).width+this.margin.right+this.margin.left;this.width=n,this.height=n,this.radius=this.width/2;}}},{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o),this.left=e-this.width/2,this.top=i-this.height/2,this.initContextForDraw(t,r),Un(t,e-this.width/2,i-this.height/2,this.width,this.height),this.performFill(t,r),this.updateBoundingBox(e,i,t,n,o),this.labelModule.draw(t,this.left+this.textSize.width/2+this.margin.left,this.top+this.textSize.height/2+this.margin.top,n,o);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(CP);function qP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var VP=function(t){D_(i,t);var e=qP(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"diamond",4,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function UP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var YP=function(t){D_(i,t);var e=UP(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"circle",2,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t){return t&&this.resize(t),this.options.size;}}]),i;}(zP);function XP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var GP=function(t){D_(i,t);var e=XP(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover;if(this.needsRefresh(e,i)){var n=this.getDimensionsFromLabel(t,e,i);this.height=2*n.height,this.width=n.width+n.height,this.radius=.5*this.width;}}},{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o),this.left=e-.5*this.width,this.top=i-.5*this.height,this.initContextForDraw(t,r),Vn(t,this.left,this.top,this.width,this.height),this.performFill(t,r),this.updateBoundingBox(e,i,t,n,o),this.labelModule.draw(t,e,i,n,o);}},{key:"distanceToBorder",value:function value(t,e){t&&this.resize(t);var i=.5*this.width,n=.5*this.height,o=Math.sin(e)*i,r=Math.cos(e)*n;return i*n/Math.sqrt(o*o+r*r);}}]),i;}(CP);function KP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var $P=function(t){D_(i,t);var e=KP(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._setMargins(o),r;}return xu(i,[{key:"resize",value:function value(t,e,i){this.needsRefresh(e,i)&&(this.iconSize={width:Number(this.options.icon.size),height:Number(this.options.icon.size)},this.width=this.iconSize.width+this.margin.right+this.margin.left,this.height=this.iconSize.height+this.margin.top+this.margin.bottom,this.radius=.5*this.width);}},{key:"draw",value:function value(t,e,i,n,o,r){var s=this;return this.resize(t,n,o),this.options.icon.size=this.options.icon.size||50,this.left=e-this.width/2,this.top=i-this.height/2,this._icon(t,e,i,n,o,r),{drawExternalLabel:function drawExternalLabel(){if(void 0!==s.options.label){s.labelModule.draw(t,s.left+s.iconSize.width/2+s.margin.left,i+s.height/2+5,n);}s.updateBoundingBox(e,i);}};}},{key:"updateBoundingBox",value:function value(t,e){if(this.boundingBox.top=e-.5*this.options.icon.size,this.boundingBox.left=t-.5*this.options.icon.size,this.boundingBox.right=t+.5*this.options.icon.size,this.boundingBox.bottom=e+.5*this.options.icon.size,void 0!==this.options.label&&this.labelModule.size.width>0){this.boundingBox.left=Math.min(this.boundingBox.left,this.labelModule.size.left),this.boundingBox.right=Math.max(this.boundingBox.right,this.labelModule.size.left+this.labelModule.size.width),this.boundingBox.bottom=Math.max(this.boundingBox.bottom,this.boundingBox.bottom+this.labelModule.size.height+5);}}},{key:"_icon",value:function value(t,e,i,n,o,r){var s=Number(this.options.icon.size);void 0!==this.options.icon.code?(t.font=[null!=this.options.icon.weight?this.options.icon.weight:n?"bold":"",(null!=this.options.icon.weight&&n?5:0)+s+"px",this.options.icon.face].join(" "),t.fillStyle=this.options.icon.color||"black",t.textAlign="center",t.textBaseline="middle",this.enableShadow(t,r),t.fillText(this.options.icon.code,e,i),this.disableShadow(t,r)):console.error("When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.");}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(CP);function ZP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var QP=function(t){D_(i,t);var e=ZP(i);function i(t,n,o,r,s){var a;return ph(this,i),(a=e.call(this,t,n,o)).setImages(r,s),a;}return xu(i,[{key:"resize",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.selected,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.hover;if(void 0===this.imageObj.src||void 0===this.imageObj.width||void 0===this.imageObj.height){var n=2*this.options.size;return this.width=n,void(this.height=n);}this.needsRefresh(e,i)&&this._resizeImage();}},{key:"draw",value:function value(t,e,i,n,o,r){t.save(),this.switchImages(n),this.resize();var s=e,a=i;if("top-left"===this.options.shapeProperties.coordinateOrigin?(this.left=e,this.top=i,s+=this.width/2,a+=this.height/2):(this.left=e-this.width/2,this.top=i-this.height/2),!0===this.options.shapeProperties.useBorderWithImage){var h=this.options.borderWidth,l=this.options.borderWidthSelected||2*this.options.borderWidth,d=(n?l:h)/this.body.view.scale;t.lineWidth=Math.min(this.width,d),t.beginPath();var c=n?this.options.color.highlight.border:o?this.options.color.hover.border:this.options.color.border,u=n?this.options.color.highlight.background:o?this.options.color.hover.background:this.options.color.background;void 0!==r.opacity&&(c=Ob(c,r.opacity),u=Ob(u,r.opacity)),t.strokeStyle=c,t.fillStyle=u,t.rect(this.left-.5*t.lineWidth,this.top-.5*t.lineWidth,this.width+t.lineWidth,this.height+t.lineWidth),Kg(t).call(t),this.performStroke(t,r),t.closePath();}this._drawImageAtPosition(t,r),this._drawImageLabel(t,s,a,n,o),this.updateBoundingBox(e,i),t.restore();}},{key:"updateBoundingBox",value:function value(t,e){this.resize(),"top-left"===this.options.shapeProperties.coordinateOrigin?(this.left=t,this.top=e):(this.left=t-this.width/2,this.top=e-this.height/2),this.boundingBox.left=this.left,this.boundingBox.top=this.top,this.boundingBox.bottom=this.top+this.height,this.boundingBox.right=this.left+this.width,void 0!==this.options.label&&this.labelModule.size.width>0&&(this.boundingBox.left=Math.min(this.boundingBox.left,this.labelModule.size.left),this.boundingBox.right=Math.max(this.boundingBox.right,this.labelModule.size.left+this.labelModule.size.width),this.boundingBox.bottom=Math.max(this.boundingBox.bottom,this.boundingBox.bottom+this.labelOffset));}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(PP);function JP(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var tD=function(t){D_(i,t);var e=JP(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"square",2,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function eD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var iD=function(t){D_(i,t);var e=eD(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"hexagon",4,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function nD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var oD=function(t){D_(i,t);var e=nD(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"star",4,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function rD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var sD=function(t){D_(i,t);var e=rD(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._setMargins(o),r;}return xu(i,[{key:"resize",value:function value(t,e,i){this.needsRefresh(e,i)&&(this.textSize=this.labelModule.getTextSize(t,e,i),this.width=this.textSize.width+this.margin.right+this.margin.left,this.height=this.textSize.height+this.margin.top+this.margin.bottom,this.radius=.5*this.width);}},{key:"draw",value:function value(t,e,i,n,o,r){this.resize(t,n,o),this.left=e-this.width/2,this.top=i-this.height/2,this.enableShadow(t,r),this.labelModule.draw(t,this.left+this.textSize.width/2+this.margin.left,this.top+this.textSize.height/2+this.margin.top,n,o),this.disableShadow(t,r),this.updateBoundingBox(e,i,t,n,o);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(CP);function aD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var hD=function(t){D_(i,t);var e=aD(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"triangle",3,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function lD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var dD=function(t){D_(i,t);var e=lD(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"draw",value:function value(t,e,i,n,o,r){return this._drawShape(t,"triangleDown",3,e,i,n,o,r);}},{key:"distanceToBorder",value:function value(t,e){return this._distanceToBorder(t,e);}}]),i;}(zP);function cD(t,e){var i=Hf(t);if(aM){var n=aM(t);e&&(n=yv(n).call(n,function(e){return yM(t,e).enumerable;})),i.push.apply(i,n);}return i;}function uD(t){for(var e=1;e<arguments.length;e++){var i,n,o=null!=arguments[e]?arguments[e]:{};e%2?op(i=cD(Object(o),!0)).call(i,function(e){z_(t,e,o[e]);}):_M?MM(t,_M(o)):op(n=cD(Object(o))).call(n,function(e){UT(t,e,yM(o,e));});}return t;}var fD=function(){function t(e,i,n,o,r,s){ph(this,t),this.options=zb(r),this.globalOptions=r,this.defaultOptions=s,this.body=i,this.edges=[],this.id=void 0,this.imagelist=n,this.grouplist=o,this.x=void 0,this.y=void 0,this.baseSize=this.options.size,this.baseFontSize=this.options.font.size,this.predefinedPosition=!1,this.selected=!1,this.hover=!1,this.labelModule=new OP(this.body,this.options,!1),this.setOptions(e);}return xu(t,[{key:"attachEdge",value:function value(t){var e;-1===lg(e=this.edges).call(e,t)&&this.edges.push(t);}},{key:"detachEdge",value:function value(t){var e,i,n=lg(e=this.edges).call(e,t);-1!=n&&Ap(i=this.edges).call(i,n,1);}},{key:"setOptions",value:function value(e){var i=this.options.shape;if(e){if(void 0!==e.color&&(this._localColor=e.color),void 0!==e.id&&(this.id=e.id),void 0===this.id)throw new Error("Node must have an id");t.checkMass(e,this.id),void 0!==e.x&&(null===e.x?(this.x=void 0,this.predefinedPosition=!1):(this.x=Qv(e.x),this.predefinedPosition=!0)),void 0!==e.y&&(null===e.y?(this.y=void 0,this.predefinedPosition=!1):(this.y=Qv(e.y),this.predefinedPosition=!0)),void 0!==e.size&&(this.baseSize=e.size),void 0!==e.value&&(e.value=lP(e.value)),t.parseOptions(this.options,e,!0,this.globalOptions,this.grouplist);var n=[e,this.options,this.defaultOptions];return this.chooser=gP("node",n),this._load_images(),this.updateLabelModule(e),void 0!==e.opacity&&t.checkOpacity(e.opacity)&&(this.options.opacity=e.opacity),this.updateShape(i),void 0!==e.hidden||void 0!==e.physics;}}},{key:"_load_images",value:function value(){if(("circularImage"===this.options.shape||"image"===this.options.shape)&&void 0===this.options.image)throw new Error("Option image must be defined for node type '"+this.options.shape+"'");if(void 0!==this.options.image){if(void 0===this.imagelist)throw new Error("Internal Error: No images provided");if("string"==typeof this.options.image)this.imageObj=this.imagelist.load(this.options.image,this.options.brokenImage,this.id);else{if(void 0===this.options.image.unselected)throw new Error("No unselected image provided");this.imageObj=this.imagelist.load(this.options.image.unselected,this.options.brokenImage,this.id),void 0!==this.options.image.selected?this.imageObjAlt=this.imagelist.load(this.options.image.selected,this.options.brokenImage,this.id):this.imageObjAlt=void 0;}}}},{key:"getFormattingValues",value:function value(){var t={color:this.options.color.background,opacity:this.options.opacity,borderWidth:this.options.borderWidth,borderColor:this.options.color.border,size:this.options.size,borderDashes:this.options.shapeProperties.borderDashes,borderRadius:this.options.shapeProperties.borderRadius,shadow:this.options.shadow.enabled,shadowColor:this.options.shadow.color,shadowSize:this.options.shadow.size,shadowX:this.options.shadow.x,shadowY:this.options.shadow.y};if(this.selected||this.hover?!0===this.chooser?this.selected?(null!=this.options.borderWidthSelected?t.borderWidth=this.options.borderWidthSelected:t.borderWidth*=2,t.color=this.options.color.highlight.background,t.borderColor=this.options.color.highlight.border,t.shadow=this.options.shadow.enabled):this.hover&&(t.color=this.options.color.hover.background,t.borderColor=this.options.color.hover.border,t.shadow=this.options.shadow.enabled):"function"==typeof this.chooser&&(this.chooser(t,this.options.id,this.selected,this.hover),!1===t.shadow&&(t.shadowColor===this.options.shadow.color&&t.shadowSize===this.options.shadow.size&&t.shadowX===this.options.shadow.x&&t.shadowY===this.options.shadow.y||(t.shadow=!0))):t.shadow=this.options.shadow.enabled,void 0!==this.options.opacity){var e=this.options.opacity;t.borderColor=Ob(t.borderColor,e),t.color=Ob(t.color,e),t.shadowColor=Ob(t.shadowColor,e);}return t;}},{key:"updateLabelModule",value:function value(e){void 0!==this.options.label&&null!==this.options.label||(this.options.label=""),t.updateGroupOptions(this.options,uD(uD({},e),{},{color:e&&e.color||this._localColor||void 0}),this.grouplist);var i=this.grouplist.get(this.options.group,!1),n=[e,this.options,i,this.globalOptions,this.defaultOptions];this.labelModule.update(this.options,n),void 0!==this.labelModule.baseSize&&(this.baseFontSize=this.labelModule.baseSize);}},{key:"updateShape",value:function value(t){if(t===this.options.shape&&this.shape)this.shape.setOptions(this.options,this.imageObj,this.imageObjAlt);else switch(this.options.shape){case"box":this.shape=new TP(this.options,this.body,this.labelModule);break;case"circle":this.shape=new IP(this.options,this.body,this.labelModule);break;case"circularImage":this.shape=new NP(this.options,this.body,this.labelModule,this.imageObj,this.imageObjAlt);break;case"custom":this.shape=new LP(this.options,this.body,this.labelModule,this.options.ctxRenderer);break;case"database":this.shape=new WP(this.options,this.body,this.labelModule);break;case"diamond":this.shape=new VP(this.options,this.body,this.labelModule);break;case"dot":this.shape=new YP(this.options,this.body,this.labelModule);break;case"ellipse":default:this.shape=new GP(this.options,this.body,this.labelModule);break;case"icon":this.shape=new $P(this.options,this.body,this.labelModule);break;case"image":this.shape=new QP(this.options,this.body,this.labelModule,this.imageObj,this.imageObjAlt);break;case"square":this.shape=new tD(this.options,this.body,this.labelModule);break;case"hexagon":this.shape=new iD(this.options,this.body,this.labelModule);break;case"star":this.shape=new oD(this.options,this.body,this.labelModule);break;case"text":this.shape=new sD(this.options,this.body,this.labelModule);break;case"triangle":this.shape=new hD(this.options,this.body,this.labelModule);break;case"triangleDown":this.shape=new dD(this.options,this.body,this.labelModule);}this.needsRefresh();}},{key:"select",value:function value(){this.selected=!0,this.needsRefresh();}},{key:"unselect",value:function value(){this.selected=!1,this.needsRefresh();}},{key:"needsRefresh",value:function value(){this.shape.refreshNeeded=!0;}},{key:"getTitle",value:function value(){return this.options.title;}},{key:"distanceToBorder",value:function value(t,e){return this.shape.distanceToBorder(t,e);}},{key:"isFixed",value:function value(){return this.options.fixed.x&&this.options.fixed.y;}},{key:"isSelected",value:function value(){return this.selected;}},{key:"getValue",value:function value(){return this.options.value;}},{key:"getLabelSize",value:function value(){return this.labelModule.size();}},{key:"setValueRange",value:function value(t,e,i){if(void 0!==this.options.value){var n=this.options.scaling.customScalingFunction(t,e,i,this.options.value),o=this.options.scaling.max-this.options.scaling.min;if(!0===this.options.scaling.label.enabled){var r=this.options.scaling.label.max-this.options.scaling.label.min;this.options.font.size=this.options.scaling.label.min+n*r;}this.options.size=this.options.scaling.min+n*o;}else this.options.size=this.baseSize,this.options.font.size=this.baseFontSize;this.updateLabelModule();}},{key:"draw",value:function value(t){var e=this.getFormattingValues();return this.shape.draw(t,this.x,this.y,this.selected,this.hover,e)||{};}},{key:"updateBoundingBox",value:function value(t){this.shape.updateBoundingBox(this.x,this.y,t);}},{key:"resize",value:function value(t){var e=this.getFormattingValues();this.shape.resize(t,this.selected,this.hover,e);}},{key:"getItemsOnPoint",value:function value(t){var e=[];return this.labelModule.visible()&&yP(this.labelModule.getSize(),t)&&e.push({nodeId:this.id,labelId:0}),yP(this.shape.boundingBox,t)&&e.push({nodeId:this.id}),e;}},{key:"isOverlappingWith",value:function value(t){return this.shape.left<t.right&&this.shape.left+this.shape.width>t.left&&this.shape.top<t.bottom&&this.shape.top+this.shape.height>t.top;}},{key:"isBoundingBoxOverlappingWith",value:function value(t){return this.shape.boundingBox.left<t.right&&this.shape.boundingBox.right>t.left&&this.shape.boundingBox.top<t.bottom&&this.shape.boundingBox.bottom>t.top;}}],[{key:"checkOpacity",value:function value(t){return 0<=t&&t<=1;}},{key:"checkCoordinateOrigin",value:function value(t){return void 0===t||"center"===t||"top-left"===t;}},{key:"updateGroupOptions",value:function value(e,i,n){var o;if(void 0!==n){var r=e.group;if(void 0!==i&&void 0!==i.group&&r!==i.group)throw new Error("updateGroupOptions: group values in options don't match.");if("number"==typeof r||"string"==typeof r&&""!=r){var s=n.get(r);void 0!==s.opacity&&void 0===i.opacity&&(t.checkOpacity(s.opacity)||(console.error("Invalid option for node opacity. Value must be between 0 and 1, found: "+s.opacity),s.opacity=void 0));var a=yv(o=vP(i)).call(o,function(t){return null!=i[t];});a.push("font"),vb(a,e,s),e.color=Sb(e.color);}}}},{key:"parseOptions",value:function value(e,i){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},r=arguments.length>4?arguments[4]:void 0;if(vb(["color","fixed","shadow"],e,i,n),t.checkMass(i),void 0!==e.opacity&&(t.checkOpacity(e.opacity)||(console.error("Invalid option for node opacity. Value must be between 0 and 1, found: "+e.opacity),e.opacity=void 0)),void 0!==i.opacity&&(t.checkOpacity(i.opacity)||(console.error("Invalid option for node opacity. Value must be between 0 and 1, found: "+i.opacity),i.opacity=void 0)),i.shapeProperties&&!t.checkCoordinateOrigin(i.shapeProperties.coordinateOrigin)&&console.error("Invalid option for node coordinateOrigin, found: "+i.shapeProperties.coordinateOrigin),Ab(e,i,"shadow",o),void 0!==i.color&&null!==i.color){var s=Sb(i.color);ub(e.color,s);}else!0===n&&null===i.color&&(e.color=zb(o.color));void 0!==i.fixed&&null!==i.fixed&&("boolean"==typeof i.fixed?(e.fixed.x=i.fixed,e.fixed.y=i.fixed):(void 0!==i.fixed.x&&"boolean"==typeof i.fixed.x&&(e.fixed.x=i.fixed.x),void 0!==i.fixed.y&&"boolean"==typeof i.fixed.y&&(e.fixed.y=i.fixed.y))),!0===n&&null===i.font&&(e.font=zb(o.font)),t.updateGroupOptions(e,i,r),void 0!==i.scaling&&Ab(e.scaling,i.scaling,"label",o.scaling);}},{key:"checkMass",value:function value(t,e){if(void 0!==t.mass&&t.mass<=0){var i="";void 0!==e&&(i=" in node id: "+e),console.error("%cNegative or zero mass disallowed"+i+", setting mass to 1.",tw),t.mass=1;}}}]),t;}();function pD(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return vD(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return vD(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n4=0,o=function o(){};return{s:o,n:function n(){return _n4>=t.length?{done:!0}:{done:!1,value:t[_n4++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function vD(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}var gD=function(){function t(e,i,n,o){var r,s=this;if(ph(this,t),this.body=e,this.images=i,this.groups=n,this.layoutEngine=o,this.body.functions.createNode=Hn(r=this.create).call(r,this),this.nodesListeners={add:function add(t,e){s.add(e.items);},update:function update(t,e){s.update(e.items,e.data,e.oldData);},remove:function remove(t,e){s.remove(e.items);}},this.defaultOptions={borderWidth:1,borderWidthSelected:void 0,brokenImage:void 0,color:{border:"#2B7CE9",background:"#97C2FC",highlight:{border:"#2B7CE9",background:"#D2E5FF"},hover:{border:"#2B7CE9",background:"#D2E5FF"}},opacity:void 0,fixed:{x:!1,y:!1},font:{color:"#343434",size:14,face:"arial",background:"none",strokeWidth:0,strokeColor:"#ffffff",align:"center",vadjust:0,multi:!1,bold:{mod:"bold"},boldital:{mod:"bold italic"},ital:{mod:"italic"},mono:{mod:"",size:15,face:"monospace",vadjust:2}},group:void 0,hidden:!1,icon:{face:"FontAwesome",code:void 0,size:50,color:"#2B7CE9"},image:void 0,imagePadding:{top:0,right:0,bottom:0,left:0},label:void 0,labelHighlightBold:!0,level:void 0,margin:{top:5,right:5,bottom:5,left:5},mass:1,physics:!0,scaling:{min:10,max:30,label:{enabled:!1,min:14,max:30,maxVisible:30,drawThreshold:5},customScalingFunction:function customScalingFunction(t,e,i,n){if(e===t)return .5;var o=1/(e-t);return Math.max(0,(n-t)*o);}},shadow:{enabled:!1,color:"rgba(0,0,0,0.5)",size:10,x:5,y:5},shape:"ellipse",shapeProperties:{borderDashes:!1,borderRadius:6,interpolation:!0,useImageSize:!1,useBorderWithImage:!1,coordinateOrigin:"center"},size:25,title:void 0,value:void 0,x:void 0,y:void 0},this.defaultOptions.mass<=0)throw"Internal error: mass in defaultOptions of NodesHandler may not be zero or negative";this.options=zb(this.defaultOptions),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t,e,i=this;this.body.emitter.on("refreshNodes",Hn(t=this.refresh).call(t,this)),this.body.emitter.on("refresh",Hn(e=this.refresh).call(e,this)),this.body.emitter.on("destroy",function(){kb(i.nodesListeners,function(t,e){i.body.data.nodes&&i.body.data.nodes.off(e,t);}),delete i.body.functions.createNode,delete i.nodesListeners.add,delete i.nodesListeners.update,delete i.nodesListeners.remove,delete i.nodesListeners;});}},{key:"setOptions",value:function value(t){if(void 0!==t){if(fD.parseOptions(this.options,t),void 0!==t.opacity&&(f_(t.opacity)||!g_(t.opacity)||t.opacity<0||t.opacity>1?console.error("Invalid option for node opacity. Value must be between 0 and 1, found: "+t.opacity):this.options.opacity=t.opacity),void 0!==t.shape)for(var e in this.body.nodes)Object.prototype.hasOwnProperty.call(this.body.nodes,e)&&this.body.nodes[e].updateShape();if(void 0!==t.font||void 0!==t.widthConstraint||void 0!==t.heightConstraint)for(var i=0,n=Hf(this.body.nodes);i<n.length;i++){var o=n[i];this.body.nodes[o].updateLabelModule(),this.body.nodes[o].needsRefresh();}if(void 0!==t.size)for(var r in this.body.nodes)Object.prototype.hasOwnProperty.call(this.body.nodes,r)&&this.body.nodes[r].needsRefresh();void 0===t.hidden&&void 0===t.physics||this.body.emitter.emit("_dataChanged");}}},{key:"setData",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.body.data.nodes;if(ZM("id",t))this.body.data.nodes=t;else if(Df(t))this.body.data.nodes=new GM(),this.body.data.nodes.add(t);else{if(t)throw new TypeError("Array or DataSet expected");this.body.data.nodes=new GM();}if(i&&kb(this.nodesListeners,function(t,e){i.off(e,t);}),this.body.nodes={},this.body.data.nodes){var n=this;kb(this.nodesListeners,function(t,e){n.body.data.nodes.on(e,t);});var o=this.body.data.nodes.getIds();this.add(o,!0);}!1===e&&this.body.emitter.emit("_dataChanged");}},{key:"add",value:function value(t){for(var e,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=[],o=0;o<t.length;o++){e=t[o];var r=this.body.data.nodes.get(e),s=this.create(r);n.push(s),this.body.nodes[e]=s;}this.layoutEngine.positionInitially(n),!1===i&&this.body.emitter.emit("_dataChanged");}},{key:"update",value:function value(t,e,i){for(var n=this.body.nodes,o=!1,r=0;r<t.length;r++){var s=t[r],a=n[s],h=e[r];void 0!==a?a.setOptions(h)&&(o=!0):(o=!0,a=this.create(h),n[s]=a);}o||void 0===i||(o=x_(e).call(e,function(t,e){var n=i[e];return n&&n.level!==t.level;})),!0===o?this.body.emitter.emit("_dataChanged"):this.body.emitter.emit("_dataUpdated");}},{key:"remove",value:function value(t){for(var e=this.body.nodes,i=0;i<t.length;i++){delete e[t[i]];}this.body.emitter.emit("_dataChanged");}},{key:"create",value:function value(t){return new(arguments.length>1&&void 0!==arguments[1]?arguments[1]:fD)(t,this.body,this.images,this.groups,this.options,this.defaultOptions);}},{key:"refresh",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];kb(this.body.nodes,function(i,n){var o=t.body.data.nodes.get(n);void 0!==o&&(!0===e&&i.setOptions({x:null,y:null}),i.setOptions({fixed:!1}),i.setOptions(o));});}},{key:"getPositions",value:function value(t){var e={};if(void 0!==t){if(!0===Df(t)){for(var i=0;i<t.length;i++)if(void 0!==this.body.nodes[t[i]]){var n=this.body.nodes[t[i]];e[t[i]]={x:Math.round(n.x),y:Math.round(n.y)};}}else if(void 0!==this.body.nodes[t]){var o=this.body.nodes[t];e[t]={x:Math.round(o.x),y:Math.round(o.y)};}}else for(var r=0;r<this.body.nodeIndices.length;r++){var s=this.body.nodes[this.body.nodeIndices[r]];e[this.body.nodeIndices[r]]={x:Math.round(s.x),y:Math.round(s.y)};}return e;}},{key:"getPosition",value:function value(t){if(null==t)throw new TypeError("No id was specified for getPosition method.");if(null==this.body.nodes[t])throw new ReferenceError("NodeId provided for getPosition does not exist. Provided: ".concat(t));return{x:Math.round(this.body.nodes[t].x),y:Math.round(this.body.nodes[t].y)};}},{key:"storePositions",value:function value(){var t,e=[],i=this.body.data.nodes.getDataSet(),n=pD(i.get());try{for(n.s();!(t=n.n()).done;){var o=t.value,r=o.id,s=this.body.nodes[r],a=Math.round(s.x),h=Math.round(s.y);o.x===a&&o.y===h||e.push({id:r,x:a,y:h});}}catch(t){n.e(t);}finally{n.f();}i.update(e);}},{key:"getBoundingBox",value:function value(t){if(void 0!==this.body.nodes[t])return this.body.nodes[t].shape.boundingBox;}},{key:"getConnectedNodes",value:function value(t,e){var i=[];if(void 0!==this.body.nodes[t])for(var n=this.body.nodes[t],o={},r=0;r<n.edges.length;r++){var s=n.edges[r];"to"!==e&&s.toId==n.id?void 0===o[s.fromId]&&(i.push(s.fromId),o[s.fromId]=!0):"from"!==e&&s.fromId==n.id&&void 0===o[s.toId]&&(i.push(s.toId),o[s.toId]=!0);}return i;}},{key:"getConnectedEdges",value:function value(t){var e=[];if(void 0!==this.body.nodes[t])for(var i=this.body.nodes[t],n=0;n<i.edges.length;n++)e.push(i.edges[n].id);else console.error("NodeId provided for getConnectedEdges does not exist. Provided: ",t);return e;}},{key:"moveNode",value:function value(t,e,i){var n=this;void 0!==this.body.nodes[t]?(this.body.nodes[t].x=Number(e),this.body.nodes[t].y=Number(i),jg(function(){n.body.emitter.emit("startSimulation");},0)):console.error("Node id supplied to moveNode does not exist. Provided: ",t);}}]),t;}(),yD=Qt,mD=I,bD=tt,wD=ii,kD=function kD(t){return void 0!==t&&(yD(t,"value")||yD(t,"writable"));},_D=T,xD=Sr;Ti({target:"Reflect",stat:!0},{get:function t(e,i){var n,o,r=arguments.length<3?e:arguments[2];return wD(e)===r?e[i]:(n=_D.f(e,i))?kD(n)?n.value:void 0===n.get?void 0:mD(n.get,r):bD(o=xD(e))?t(o,i,r):void 0;}});var ED=i(et.Reflect.get),OD=i(gM);function CD(){var t;"undefined"!=typeof Reflect&&ED?CD=M_(t=ED).call(t):CD=function CD(t,e,i){var n=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=F_(t)););return t;}(t,e);if(n){var o=OD(n,e);return o.get?o.get.call(arguments.length<3?t:i):o.value;}};return CD.apply(this,arguments);}var SD=Ti,TD=Math.hypot,MD=Math.abs,PD=Math.sqrt;SD({target:"Math",stat:!0,arity:2,forced:!!TD&&TD(1/0,NaN)!==1/0},{hypot:function hypot(t,e){for(var i,n,o=0,r=0,s=arguments.length,a=0;r<s;)a<(i=MD(arguments[r++]))?(o=o*(n=a/i)*n+1,a=i):o+=i>0?(n=i/a)*n:i;return a===1/0?1/0:a*PD(o);}});var DD=i(et.Math.hypot);function ID(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var BD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"transform",value:function value(t,e){Df(t)||(t=[t]);for(var i=e.point.x,n=e.point.y,o=e.angle,r=e.length,s=0;s<t.length;++s){var a=t[s],h=a.x*Math.cos(o)-a.y*Math.sin(o),l=a.x*Math.sin(o)+a.y*Math.cos(o);a.x=i+r*h,a.y=n+r*l;}}},{key:"drawPath",value:function value(t,e){t.beginPath(),t.moveTo(e[0].x,e[0].y);for(var i=1;i<e.length;++i)t.lineTo(e[i].x,e[i].y);t.closePath();}}]),t;}(),ND=function(t){D_(i,t);var e=ID(i);function i(){return ph(this,i),e.apply(this,arguments);}return xu(i,null,[{key:"draw",value:function value(t,e){if(e.image){t.save(),t.translate(e.point.x,e.point.y),t.rotate(Math.PI/2+e.angle);var i=null!=e.imageWidth?e.imageWidth:e.image.width,n=null!=e.imageHeight?e.imageHeight:e.image.height;e.image.drawImageAtPosition(t,1,-i/2,0,i,n),t.restore();}return!1;}}]),i;}(BD),FD=function(t){D_(i,t);var e=ID(i);function i(){return ph(this,i),e.apply(this,arguments);}return xu(i,null,[{key:"draw",value:function value(t,e){var i=[{x:0,y:0},{x:-1,y:.3},{x:-.9,y:0},{x:-1,y:-.3}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),i;}(BD),zD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:-1,y:0},{x:0,y:.3},{x:-.4,y:0},{x:0,y:-.3}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),AD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i={x:-.4,y:0};BD.transform(i,e),t.strokeStyle=t.fillStyle,t.fillStyle="rgba(0, 0, 0, 0)";var n=Math.PI,o=e.angle-n/2,r=e.angle+n/2;return t.beginPath(),t.arc(i.x,i.y,.4*e.length,o,r,!1),t.stroke(),!0;}}]),t;}(),jD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i={x:-.3,y:0};BD.transform(i,e),t.strokeStyle=t.fillStyle,t.fillStyle="rgba(0, 0, 0, 0)";var n=Math.PI,o=e.angle+n/2,r=e.angle+3*n/2;return t.beginPath(),t.arc(i.x,i.y,.4*e.length,o,r,!1),t.stroke(),!0;}}]),t;}(),RD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:.02,y:0},{x:-1,y:.3},{x:-1,y:-.3}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),LD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:0,y:.3},{x:0,y:-.3},{x:-1,y:0}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),HD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i={x:-.4,y:0};return BD.transform(i,e),Wn(t,i.x,i.y,.4*e.length),!0;}}]),t;}(),WD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:0,y:.5},{x:0,y:-.5},{x:-.15,y:-.5},{x:-.15,y:.5}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),qD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:0,y:.3},{x:0,y:-.3},{x:-.6,y:-.3},{x:-.6,y:.3}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),VD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:0,y:0},{x:-.5,y:-.3},{x:-1,y:0},{x:-.5,y:.3}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),UD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i=[{x:-1,y:.3},{x:-.5,y:0},{x:-1,y:-.3},{x:0,y:0}];return BD.transform(i,e),BD.drawPath(t,i),!0;}}]),t;}(),YD=function(){function t(){ph(this,t);}return xu(t,null,[{key:"draw",value:function value(t,e){var i;switch(e.type&&(i=e.type.toLowerCase()),i){case"image":return ND.draw(t,e);case"circle":return HD.draw(t,e);case"box":return qD.draw(t,e);case"crow":return zD.draw(t,e);case"curve":return AD.draw(t,e);case"diamond":return VD.draw(t,e);case"inv_curve":return jD.draw(t,e);case"triangle":return RD.draw(t,e);case"inv_triangle":return LD.draw(t,e);case"bar":return WD.draw(t,e);case"vee":return UD.draw(t,e);default:return FD.draw(t,e);}}}]),t;}();function XD(t,e){var i=Hf(t);if(aM){var n=aM(t);e&&(n=yv(n).call(n,function(e){return yM(t,e).enumerable;})),i.push.apply(i,n);}return i;}function GD(t){for(var e=1;e<arguments.length;e++){var i,n,o=null!=arguments[e]?arguments[e]:{};e%2?op(i=XD(Object(o),!0)).call(i,function(e){z_(t,e,o[e]);}):_M?MM(t,_M(o)):op(n=XD(Object(o))).call(n,function(e){UT(t,e,yM(o,e));});}return t;}var KD=function(){function t(e,i,n){ph(this,t),this._body=i,this._labelModule=n,this.color={},this.colorDirty=!0,this.hoverWidth=1.5,this.selectionWidth=2,this.setOptions(e),this.fromPoint=this.from,this.toPoint=this.to;}return xu(t,[{key:"connect",value:function value(){this.from=this._body.nodes[this.options.from],this.to=this._body.nodes[this.options.to];}},{key:"cleanup",value:function value(){return!1;}},{key:"setOptions",value:function value(t){this.options=t,this.from=this._body.nodes[this.options.from],this.to=this._body.nodes[this.options.to],this.id=this.options.id;}},{key:"drawLine",value:function value(t,e,i,n){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:this.getViaNode();t.strokeStyle=this.getColor(t,e),t.lineWidth=e.width,!1!==e.dashes?this._drawDashedLine(t,e,o):this._drawLine(t,e,o);}},{key:"_drawLine",value:function value(t,e,i,n,o){if(this.from!=this.to)this._line(t,e,i,n,o);else{var r=pf(this._getCircleData(t),3),s=r[0],a=r[1],h=r[2];this._circle(t,e,s,a,h);}}},{key:"_drawDashedLine",value:function value(t,e,i,n,o){t.lineCap="round";var r=Df(e.dashes)?e.dashes:[5,5];if(void 0!==t.setLineDash){if(t.save(),t.setLineDash(r),t.lineDashOffset=0,this.from!=this.to)this._line(t,e,i);else{var s=pf(this._getCircleData(t),3),a=s[0],h=s[1],l=s[2];this._circle(t,e,a,h,l);}t.setLineDash([0]),t.lineDashOffset=0,t.restore();}else{if(this.from!=this.to)Yn(t,this.from.x,this.from.y,this.to.x,this.to.y,r);else{var d=pf(this._getCircleData(t),3),c=d[0],u=d[1],f=d[2];this._circle(t,e,c,u,f);}this.enableShadow(t,e),t.stroke(),this.disableShadow(t,e);}}},{key:"findBorderPosition",value:function value(t,e,i){return this.from!=this.to?this._findBorderPosition(t,e,i):this._findBorderPositionCircle(t,e,i);}},{key:"findBorderPositions",value:function value(t){if(this.from!=this.to)return{from:this._findBorderPosition(this.from,t),to:this._findBorderPosition(this.to,t)};var e,i=pf(xf(e=this._getCircleData(t)).call(e,0,2),2),n=i[0],o=i[1];return{from:this._findBorderPositionCircle(this.from,t,{x:n,y:o,low:.25,high:.6,direction:-1}),to:this._findBorderPositionCircle(this.from,t,{x:n,y:o,low:.6,high:.8,direction:1})};}},{key:"_getCircleData",value:function value(t){var e=this.options.selfReference.size;void 0!==t&&void 0===this.from.shape.width&&this.from.shape.resize(t);var i=bP(t,this.options.selfReference.angle,e,this.from);return[i.x,i.y,e];}},{key:"_pointOnCircle",value:function value(t,e,i,n){var o=2*n*Math.PI;return{x:t+i*Math.cos(o),y:e-i*Math.sin(o)};}},{key:"_findBorderPositionCircle",value:function value(t,e,i){var n,o=i.x,r=i.y,s=i.low,a=i.high,h=i.direction,l=this.options.selfReference.size,d=.5*(s+a),c=0;!0===this.options.arrowStrikethrough&&(-1===h?c=this.options.endPointOffset.from:1===h&&(c=this.options.endPointOffset.to));var u=0;do{d=.5*(s+a),n=this._pointOnCircle(o,r,l,d);var f=Math.atan2(t.y-n.y,t.x-n.x),p=t.distanceToBorder(e,f)+c-Math.sqrt(Math.pow(n.x-t.x,2)+Math.pow(n.y-t.y,2));if(Math.abs(p)<.05)break;p>0?h>0?s=d:a=d:h>0?a=d:s=d,++u;}while(s<=a&&u<10);return GD(GD({},n),{},{t:d});}},{key:"getLineWidth",value:function value(t,e){return!0===t?Math.max(this.selectionWidth,.3/this._body.view.scale):!0===e?Math.max(this.hoverWidth,.3/this._body.view.scale):Math.max(this.options.width,.3/this._body.view.scale);}},{key:"getColor",value:function value(t,e){if(!1!==e.inheritsColor){if("both"===e.inheritsColor&&this.from.id!==this.to.id){var i=t.createLinearGradient(this.from.x,this.from.y,this.to.x,this.to.y),n=this.from.options.color.highlight.border,o=this.to.options.color.highlight.border;return!1===this.from.selected&&!1===this.to.selected?(n=Ob(this.from.options.color.border,e.opacity),o=Ob(this.to.options.color.border,e.opacity)):!0===this.from.selected&&!1===this.to.selected?o=this.to.options.color.border:!1===this.from.selected&&!0===this.to.selected&&(n=this.from.options.color.border),i.addColorStop(0,n),i.addColorStop(1,o),i;}return"to"===e.inheritsColor?Ob(this.to.options.color.border,e.opacity):Ob(this.from.options.color.border,e.opacity);}return Ob(e.color,e.opacity);}},{key:"_circle",value:function value(t,e,i,n,o){this.enableShadow(t,e);var r=0,s=2*Math.PI;if(!this.options.selfReference.renderBehindTheNode){var a=this.options.selfReference.angle,h=this.options.selfReference.angle+Math.PI,l=this._findBorderPositionCircle(this.from,t,{x:i,y:n,low:a,high:h,direction:-1}),d=this._findBorderPositionCircle(this.from,t,{x:i,y:n,low:a,high:h,direction:1});r=Math.atan2(l.y-n,l.x-i),s=Math.atan2(d.y-n,d.x-i);}t.beginPath(),t.arc(i,n,o,r,s,!1),t.stroke(),this.disableShadow(t,e);}},{key:"getDistanceToEdge",value:function value(t,e,i,n,o,r){if(this.from!=this.to)return this._getDistanceToEdge(t,e,i,n,o,r);var s=pf(this._getCircleData(void 0),3),a=s[0],h=s[1],l=s[2],d=a-o,c=h-r;return Math.abs(Math.sqrt(d*d+c*c)-l);}},{key:"_getDistanceToLine",value:function value(t,e,i,n,o,r){var s=i-t,a=n-e,h=((o-t)*s+(r-e)*a)/(s*s+a*a);h>1?h=1:h<0&&(h=0);var l=t+h*s-o,d=e+h*a-r;return Math.sqrt(l*l+d*d);}},{key:"getArrowData",value:function value(t,e,i,n,o,r){var s,a,h,l,d,c,u,f=r.width;"from"===e?(h=this.from,l=this.to,d=r.fromArrowScale<0,c=Math.abs(r.fromArrowScale),u=r.fromArrowType):"to"===e?(h=this.to,l=this.from,d=r.toArrowScale<0,c=Math.abs(r.toArrowScale),u=r.toArrowType):(h=this.to,l=this.from,d=r.middleArrowScale<0,c=Math.abs(r.middleArrowScale),u=r.middleArrowType);var p=15*c+3*f;if(h!=l){var v=p/DD(h.x-l.x,h.y-l.y);if("middle"!==e){if(!0===this.options.smooth.enabled){var g=this._findBorderPosition(h,t,{via:i}),y=this.getPoint(g.t+v*("from"===e?1:-1),i);s=Math.atan2(g.y-y.y,g.x-y.x),a=g;}else s=Math.atan2(h.y-l.y,h.x-l.x),a=this._findBorderPosition(h,t);}else{var m=(d?-v:v)/2,b=this.getPoint(.5+m,i),w=this.getPoint(.5-m,i);s=Math.atan2(b.y-w.y,b.x-w.x),a=this.getPoint(.5,i);}}else{var k=pf(this._getCircleData(t),3),_=k[0],x=k[1],E=k[2];if("from"===e){var O=this.options.selfReference.angle,C=this.options.selfReference.angle+Math.PI,S=this._findBorderPositionCircle(this.from,t,{x:_,y:x,low:O,high:C,direction:-1});s=-2*S.t*Math.PI+1.5*Math.PI+.1*Math.PI,a=S;}else if("to"===e){var T=this.options.selfReference.angle,M=this.options.selfReference.angle+Math.PI,P=this._findBorderPositionCircle(this.from,t,{x:_,y:x,low:T,high:M,direction:1});s=-2*P.t*Math.PI+1.5*Math.PI-1.1*Math.PI,a=P;}else{var D=this.options.selfReference.angle/(2*Math.PI);a=this._pointOnCircle(_,x,E,D),s=-2*D*Math.PI+1.5*Math.PI+.1*Math.PI;}}return{point:a,core:{x:a.x-.9*p*Math.cos(s),y:a.y-.9*p*Math.sin(s)},angle:s,length:p,type:u};}},{key:"drawArrowHead",value:function value(t,e,i,n,o){t.strokeStyle=this.getColor(t,e),t.fillStyle=t.strokeStyle,t.lineWidth=e.width,YD.draw(t,o)&&(this.enableShadow(t,e),Kg(t).call(t),this.disableShadow(t,e));}},{key:"enableShadow",value:function value(t,e){!0===e.shadow&&(t.shadowColor=e.shadowColor,t.shadowBlur=e.shadowSize,t.shadowOffsetX=e.shadowX,t.shadowOffsetY=e.shadowY);}},{key:"disableShadow",value:function value(t,e){!0===e.shadow&&(t.shadowColor="rgba(0,0,0,0)",t.shadowBlur=0,t.shadowOffsetX=0,t.shadowOffsetY=0);}},{key:"drawBackground",value:function value(t,e){if(!1!==e.background){var i={strokeStyle:t.strokeStyle,lineWidth:t.lineWidth,dashes:t.dashes};t.strokeStyle=e.backgroundColor,t.lineWidth=e.backgroundSize,this.setStrokeDashed(t,e.backgroundDashes),t.stroke(),t.strokeStyle=i.strokeStyle,t.lineWidth=i.lineWidth,t.dashes=i.dashes,this.setStrokeDashed(t,e.dashes);}}},{key:"setStrokeDashed",value:function value(t,e){if(!1!==e){if(void 0!==t.setLineDash){var i=Df(e)?e:[5,5];t.setLineDash(i);}else console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");}else void 0!==t.setLineDash?t.setLineDash([]):console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");}}]),t;}();function $D(t,e){var i=Hf(t);if(aM){var n=aM(t);e&&(n=yv(n).call(n,function(e){return yM(t,e).enumerable;})),i.push.apply(i,n);}return i;}function ZD(t){for(var e=1;e<arguments.length;e++){var i,n,o=null!=arguments[e]?arguments[e]:{};e%2?op(i=$D(Object(o),!0)).call(i,function(e){z_(t,e,o[e]);}):_M?MM(t,_M(o)):op(n=$D(Object(o))).call(n,function(e){UT(t,e,yM(o,e));});}return t;}function QD(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var JD=function(t){D_(i,t);var e=QD(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_findBorderPositionBezier",value:function value(t,e){var i,n,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this._getViaCoordinates(),r=!1,s=1,a=0,h=this.to,l=this.options.endPointOffset?this.options.endPointOffset.to:0;t.id===this.from.id&&(h=this.from,r=!0,l=this.options.endPointOffset?this.options.endPointOffset.from:0),!1===this.options.arrowStrikethrough&&(l=0);var d=0;do{n=.5*(a+s),i=this.getPoint(n,o);var c=Math.atan2(h.y-i.y,h.x-i.x),u=h.distanceToBorder(e,c)+l-Math.sqrt(Math.pow(i.x-h.x,2)+Math.pow(i.y-h.y,2));if(Math.abs(u)<.2)break;u<0?!1===r?a=n:s=n:!1===r?s=n:a=n,++d;}while(a<=s&&d<10);return ZD(ZD({},i),{},{t:n});}},{key:"_getDistanceToBezierEdge",value:function value(t,e,i,n,o,r,s){var a,h,l,d,c,u=1e9,f=t,p=e;for(h=1;h<10;h++)l=.1*h,d=Math.pow(1-l,2)*t+2*l*(1-l)*s.x+Math.pow(l,2)*i,c=Math.pow(1-l,2)*e+2*l*(1-l)*s.y+Math.pow(l,2)*n,h>0&&(u=(a=this._getDistanceToLine(f,p,d,c,o,r))<u?a:u),f=d,p=c;return u;}},{key:"_bezierCurve",value:function value(t,e,i,n){t.beginPath(),t.moveTo(this.fromPoint.x,this.fromPoint.y),null!=i&&null!=i.x?null!=n&&null!=n.x?t.bezierCurveTo(i.x,i.y,n.x,n.y,this.toPoint.x,this.toPoint.y):t.quadraticCurveTo(i.x,i.y,this.toPoint.x,this.toPoint.y):t.lineTo(this.toPoint.x,this.toPoint.y),this.drawBackground(t,e),this.enableShadow(t,e),t.stroke(),this.disableShadow(t,e);}},{key:"getViaNode",value:function value(){return this._getViaCoordinates();}}]),i;}(KD);function tI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var eI=function(t){D_(i,t);var e=tI(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o)).via=r.via,r._boundFunction=function(){r.positionBezierNode();},r._body.emitter.on("_repositionBezierNodes",r._boundFunction),r;}return xu(i,[{key:"setOptions",value:function value(t){CD(F_(i.prototype),"setOptions",this).call(this,t);var e=!1;this.options.physics!==t.physics&&(e=!0),this.options=t,this.id=this.options.id,this.from=this._body.nodes[this.options.from],this.to=this._body.nodes[this.options.to],this.setupSupportNode(),this.connect(),!0===e&&(this.via.setOptions({physics:this.options.physics}),this.positionBezierNode());}},{key:"connect",value:function value(){this.from=this._body.nodes[this.options.from],this.to=this._body.nodes[this.options.to],void 0===this.from||void 0===this.to||!1===this.options.physics||this.from.id===this.to.id?this.via.setOptions({physics:!1}):this.via.setOptions({physics:!0});}},{key:"cleanup",value:function value(){return this._body.emitter.off("_repositionBezierNodes",this._boundFunction),void 0!==this.via&&(delete this._body.nodes[this.via.id],this.via=void 0,!0);}},{key:"setupSupportNode",value:function value(){if(void 0===this.via){var t="edgeId:"+this.id,e=this._body.functions.createNode({id:t,shape:"circle",physics:!0,hidden:!0});this._body.nodes[t]=e,this.via=e,this.via.parentEdgeId=this.id,this.positionBezierNode();}}},{key:"positionBezierNode",value:function value(){void 0!==this.via&&void 0!==this.from&&void 0!==this.to?(this.via.x=.5*(this.from.x+this.to.x),this.via.y=.5*(this.from.y+this.to.y)):void 0!==this.via&&(this.via.x=0,this.via.y=0);}},{key:"_line",value:function value(t,e,i){this._bezierCurve(t,e,i);}},{key:"_getViaCoordinates",value:function value(){return this.via;}},{key:"getViaNode",value:function value(){return this.via;}},{key:"getPoint",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.via;if(this.from===this.to){var i=pf(this._getCircleData(),3),n=i[0],o=i[1],r=i[2],s=2*Math.PI*(1-t);return{x:n+r*Math.sin(s),y:o+r-r*(1-Math.cos(s))};}return{x:Math.pow(1-t,2)*this.fromPoint.x+2*t*(1-t)*e.x+Math.pow(t,2)*this.toPoint.x,y:Math.pow(1-t,2)*this.fromPoint.y+2*t*(1-t)*e.y+Math.pow(t,2)*this.toPoint.y};}},{key:"_findBorderPosition",value:function value(t,e){return this._findBorderPositionBezier(t,e,this.via);}},{key:"_getDistanceToEdge",value:function value(t,e,i,n,o,r){return this._getDistanceToBezierEdge(t,e,i,n,o,r,this.via);}}]),i;}(JD);function iI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var nI=function(t){D_(i,t);var e=iI(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_line",value:function value(t,e,i){this._bezierCurve(t,e,i);}},{key:"getViaNode",value:function value(){return this._getViaCoordinates();}},{key:"_getViaCoordinates",value:function value(){var t,e,i=this.options.smooth.roundness,n=this.options.smooth.type,o=Math.abs(this.from.x-this.to.x),r=Math.abs(this.from.y-this.to.y);if("discrete"===n||"diagonalCross"===n){var s,a;s=a=o<=r?i*r:i*o,this.from.x>this.to.x&&(s=-s),this.from.y>=this.to.y&&(a=-a);var h=this.from.x+s,l=this.from.y+a;return"discrete"===n&&(o<=r?h=o<i*r?this.from.x:h:l=r<i*o?this.from.y:l),{x:h,y:l};}if("straightCross"===n){var d=(1-i)*o,c=(1-i)*r;return o<=r?(d=0,this.from.y<this.to.y&&(c=-c)):(this.from.x<this.to.x&&(d=-d),c=0),{x:this.to.x+d,y:this.to.y+c};}if("horizontal"===n){var u=(1-i)*o;return this.from.x<this.to.x&&(u=-u),{x:this.to.x+u,y:this.from.y};}if("vertical"===n){var f=(1-i)*r;return this.from.y<this.to.y&&(f=-f),{x:this.from.x,y:this.to.y+f};}if("curvedCW"===n){o=this.to.x-this.from.x,r=this.from.y-this.to.y;var p=Math.sqrt(o*o+r*r),v=Math.PI,g=(Math.atan2(r,o)+(.5*i+.5)*v)%(2*v);return{x:this.from.x+(.5*i+.5)*p*Math.sin(g),y:this.from.y+(.5*i+.5)*p*Math.cos(g)};}if("curvedCCW"===n){o=this.to.x-this.from.x,r=this.from.y-this.to.y;var y=Math.sqrt(o*o+r*r),m=Math.PI,b=(Math.atan2(r,o)+(.5*-i+.5)*m)%(2*m);return{x:this.from.x+(.5*i+.5)*y*Math.sin(b),y:this.from.y+(.5*i+.5)*y*Math.cos(b)};}t=e=o<=r?i*r:i*o,this.from.x>this.to.x&&(t=-t),this.from.y>=this.to.y&&(e=-e);var w=this.from.x+t,k=this.from.y+e;return o<=r?w=this.from.x<=this.to.x?this.to.x<w?this.to.x:w:this.to.x>w?this.to.x:w:k=this.from.y>=this.to.y?this.to.y>k?this.to.y:k:this.to.y<k?this.to.y:k,{x:w,y:k};}},{key:"_findBorderPosition",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._findBorderPositionBezier(t,e,i.via);}},{key:"_getDistanceToEdge",value:function value(t,e,i,n,o,r){var s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:this._getViaCoordinates();return this._getDistanceToBezierEdge(t,e,i,n,o,r,s);}},{key:"getPoint",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._getViaCoordinates(),i=t;return{x:Math.pow(1-i,2)*this.fromPoint.x+2*i*(1-i)*e.x+Math.pow(i,2)*this.toPoint.x,y:Math.pow(1-i,2)*this.fromPoint.y+2*i*(1-i)*e.y+Math.pow(i,2)*this.toPoint.y};}}]),i;}(JD);function oI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var rI=function(t){D_(i,t);var e=oI(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_getDistanceToBezierEdge2",value:function value(t,e,i,n,o,r,s,a){for(var h=1e9,l=t,d=e,c=[0,0,0,0],u=1;u<10;u++){var f=.1*u;c[0]=Math.pow(1-f,3),c[1]=3*f*Math.pow(1-f,2),c[2]=3*Math.pow(f,2)*(1-f),c[3]=Math.pow(f,3);var p=c[0]*t+c[1]*s.x+c[2]*a.x+c[3]*i,v=c[0]*e+c[1]*s.y+c[2]*a.y+c[3]*n;if(u>0){var g=this._getDistanceToLine(l,d,p,v,o,r);h=g<h?g:h;}l=p,d=v;}return h;}}]),i;}(JD);function sI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var aI=function(t){D_(i,t);var e=sI(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_line",value:function value(t,e,i){var n=i[0],o=i[1];this._bezierCurve(t,e,n,o);}},{key:"_getViaCoordinates",value:function value(){var t,e,i,n,o=this.from.x-this.to.x,r=this.from.y-this.to.y,s=this.options.smooth.roundness;return(Math.abs(o)>Math.abs(r)||!0===this.options.smooth.forceDirection||"horizontal"===this.options.smooth.forceDirection)&&"vertical"!==this.options.smooth.forceDirection?(e=this.from.y,n=this.to.y,t=this.from.x-s*o,i=this.to.x+s*o):(e=this.from.y-s*r,n=this.to.y+s*r,t=this.from.x,i=this.to.x),[{x:t,y:e},{x:i,y:n}];}},{key:"getViaNode",value:function value(){return this._getViaCoordinates();}},{key:"_findBorderPosition",value:function value(t,e){return this._findBorderPositionBezier(t,e);}},{key:"_getDistanceToEdge",value:function value(t,e,i,n,o,r){var s=pf(arguments.length>6&&void 0!==arguments[6]?arguments[6]:this._getViaCoordinates(),2),a=s[0],h=s[1];return this._getDistanceToBezierEdge2(t,e,i,n,o,r,a,h);}},{key:"getPoint",value:function value(t){var e=pf(arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._getViaCoordinates(),2),i=e[0],n=e[1],o=t,r=[Math.pow(1-o,3),3*o*Math.pow(1-o,2),3*Math.pow(o,2)*(1-o),Math.pow(o,3)];return{x:r[0]*this.fromPoint.x+r[1]*i.x+r[2]*n.x+r[3]*this.toPoint.x,y:r[0]*this.fromPoint.y+r[1]*i.y+r[2]*n.y+r[3]*this.toPoint.y};}}]),i;}(rI);function hI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var lI=function(t){D_(i,t);var e=hI(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_line",value:function value(t,e){t.beginPath(),t.moveTo(this.fromPoint.x,this.fromPoint.y),t.lineTo(this.toPoint.x,this.toPoint.y),this.enableShadow(t,e),t.stroke(),this.disableShadow(t,e);}},{key:"getViaNode",value:function value(){}},{key:"getPoint",value:function value(t){return{x:(1-t)*this.fromPoint.x+t*this.toPoint.x,y:(1-t)*this.fromPoint.y+t*this.toPoint.y};}},{key:"_findBorderPosition",value:function value(t,e){var i=this.to,n=this.from;t.id===this.from.id&&(i=this.from,n=this.to);var o=Math.atan2(i.y-n.y,i.x-n.x),r=i.x-n.x,s=i.y-n.y,a=Math.sqrt(r*r+s*s),h=(a-t.distanceToBorder(e,o))/a;return{x:(1-h)*n.x+h*i.x,y:(1-h)*n.y+h*i.y,t:0};}},{key:"_getDistanceToEdge",value:function value(t,e,i,n,o,r){return this._getDistanceToLine(t,e,i,n,o,r);}}]),i;}(KD),dI=function(){function t(e,i,n,o,r){if(ph(this,t),void 0===i)throw new Error("No body provided");this.options=zb(o),this.globalOptions=o,this.defaultOptions=r,this.body=i,this.imagelist=n,this.id=void 0,this.fromId=void 0,this.toId=void 0,this.selected=!1,this.hover=!1,this.labelDirty=!0,this.baseWidth=this.options.width,this.baseFontSize=this.options.font.size,this.from=void 0,this.to=void 0,this.edgeType=void 0,this.connected=!1,this.labelModule=new OP(this.body,this.options,!0),this.setOptions(e);}return xu(t,[{key:"setOptions",value:function value(e){if(e){var i=void 0!==e.physics&&this.options.physics!==e.physics||void 0!==e.hidden&&(this.options.hidden||!1)!==(e.hidden||!1)||void 0!==e.from&&this.options.from!==e.from||void 0!==e.to&&this.options.to!==e.to;t.parseOptions(this.options,e,!0,this.globalOptions),void 0!==e.id&&(this.id=e.id),void 0!==e.from&&(this.fromId=e.from),void 0!==e.to&&(this.toId=e.to),void 0!==e.title&&(this.title=e.title),void 0!==e.value&&(e.value=lP(e.value));var n=[e,this.options,this.defaultOptions];return this.chooser=gP("edge",n),this.updateLabelModule(e),i=this.updateEdgeType()||i,this._setInteractionWidths(),this.connect(),i;}}},{key:"getFormattingValues",value:function value(){var t=!0===this.options.arrows.to||!0===this.options.arrows.to.enabled,e=!0===this.options.arrows.from||!0===this.options.arrows.from.enabled,i=!0===this.options.arrows.middle||!0===this.options.arrows.middle.enabled,n=this.options.color.inherit,o={toArrow:t,toArrowScale:this.options.arrows.to.scaleFactor,toArrowType:this.options.arrows.to.type,toArrowSrc:this.options.arrows.to.src,toArrowImageWidth:this.options.arrows.to.imageWidth,toArrowImageHeight:this.options.arrows.to.imageHeight,middleArrow:i,middleArrowScale:this.options.arrows.middle.scaleFactor,middleArrowType:this.options.arrows.middle.type,middleArrowSrc:this.options.arrows.middle.src,middleArrowImageWidth:this.options.arrows.middle.imageWidth,middleArrowImageHeight:this.options.arrows.middle.imageHeight,fromArrow:e,fromArrowScale:this.options.arrows.from.scaleFactor,fromArrowType:this.options.arrows.from.type,fromArrowSrc:this.options.arrows.from.src,fromArrowImageWidth:this.options.arrows.from.imageWidth,fromArrowImageHeight:this.options.arrows.from.imageHeight,arrowStrikethrough:this.options.arrowStrikethrough,color:n?void 0:this.options.color.color,inheritsColor:n,opacity:this.options.color.opacity,hidden:this.options.hidden,length:this.options.length,shadow:this.options.shadow.enabled,shadowColor:this.options.shadow.color,shadowSize:this.options.shadow.size,shadowX:this.options.shadow.x,shadowY:this.options.shadow.y,dashes:this.options.dashes,width:this.options.width,background:this.options.background.enabled,backgroundColor:this.options.background.color,backgroundSize:this.options.background.size,backgroundDashes:this.options.background.dashes};if(this.selected||this.hover){if(!0===this.chooser){if(this.selected){var r=this.options.selectionWidth;"function"==typeof r?o.width=r(o.width):"number"==typeof r&&(o.width+=r),o.width=Math.max(o.width,.3/this.body.view.scale),o.color=this.options.color.highlight,o.shadow=this.options.shadow.enabled;}else if(this.hover){var s=this.options.hoverWidth;"function"==typeof s?o.width=s(o.width):"number"==typeof s&&(o.width+=s),o.width=Math.max(o.width,.3/this.body.view.scale),o.color=this.options.color.hover,o.shadow=this.options.shadow.enabled;}}else"function"==typeof this.chooser&&(this.chooser(o,this.options.id,this.selected,this.hover),void 0!==o.color&&(o.inheritsColor=!1),!1===o.shadow&&(o.shadowColor===this.options.shadow.color&&o.shadowSize===this.options.shadow.size&&o.shadowX===this.options.shadow.x&&o.shadowY===this.options.shadow.y||(o.shadow=!0)));}else o.shadow=this.options.shadow.enabled,o.width=Math.max(o.width,.3/this.body.view.scale);return o;}},{key:"updateLabelModule",value:function value(t){var e=[t,this.options,this.globalOptions,this.defaultOptions];this.labelModule.update(this.options,e),void 0!==this.labelModule.baseSize&&(this.baseFontSize=this.labelModule.baseSize);}},{key:"updateEdgeType",value:function value(){var t=this.options.smooth,e=!1,i=!0;return void 0!==this.edgeType&&((this.edgeType instanceof eI&&!0===t.enabled&&"dynamic"===t.type||this.edgeType instanceof aI&&!0===t.enabled&&"cubicBezier"===t.type||this.edgeType instanceof nI&&!0===t.enabled&&"dynamic"!==t.type&&"cubicBezier"!==t.type||this.edgeType instanceof lI&&!1===t.type.enabled)&&(i=!1),!0===i&&(e=this.cleanup())),!0===i?!0===t.enabled?"dynamic"===t.type?(e=!0,this.edgeType=new eI(this.options,this.body,this.labelModule)):"cubicBezier"===t.type?this.edgeType=new aI(this.options,this.body,this.labelModule):this.edgeType=new nI(this.options,this.body,this.labelModule):this.edgeType=new lI(this.options,this.body,this.labelModule):this.edgeType.setOptions(this.options),e;}},{key:"connect",value:function value(){this.disconnect(),this.from=this.body.nodes[this.fromId]||void 0,this.to=this.body.nodes[this.toId]||void 0,this.connected=void 0!==this.from&&void 0!==this.to,!0===this.connected?(this.from.attachEdge(this),this.to.attachEdge(this)):(this.from&&this.from.detachEdge(this),this.to&&this.to.detachEdge(this)),this.edgeType.connect();}},{key:"disconnect",value:function value(){this.from&&(this.from.detachEdge(this),this.from=void 0),this.to&&(this.to.detachEdge(this),this.to=void 0),this.connected=!1;}},{key:"getTitle",value:function value(){return this.title;}},{key:"isSelected",value:function value(){return this.selected;}},{key:"getValue",value:function value(){return this.options.value;}},{key:"setValueRange",value:function value(t,e,i){if(void 0!==this.options.value){var n=this.options.scaling.customScalingFunction(t,e,i,this.options.value),o=this.options.scaling.max-this.options.scaling.min;if(!0===this.options.scaling.label.enabled){var r=this.options.scaling.label.max-this.options.scaling.label.min;this.options.font.size=this.options.scaling.label.min+n*r;}this.options.width=this.options.scaling.min+n*o;}else this.options.width=this.baseWidth,this.options.font.size=this.baseFontSize;this._setInteractionWidths(),this.updateLabelModule();}},{key:"_setInteractionWidths",value:function value(){"function"==typeof this.options.hoverWidth?this.edgeType.hoverWidth=this.options.hoverWidth(this.options.width):this.edgeType.hoverWidth=this.options.hoverWidth+this.options.width,"function"==typeof this.options.selectionWidth?this.edgeType.selectionWidth=this.options.selectionWidth(this.options.width):this.edgeType.selectionWidth=this.options.selectionWidth+this.options.width;}},{key:"draw",value:function value(t){var e=this.getFormattingValues();if(!e.hidden){var i=this.edgeType.getViaNode();this.edgeType.drawLine(t,e,this.selected,this.hover,i),this.drawLabel(t,i);}}},{key:"drawArrows",value:function value(t){var e=this.getFormattingValues();if(!e.hidden){var i=this.edgeType.getViaNode(),n={};this.edgeType.fromPoint=this.edgeType.from,this.edgeType.toPoint=this.edgeType.to,e.fromArrow&&(n.from=this.edgeType.getArrowData(t,"from",i,this.selected,this.hover,e),!1===e.arrowStrikethrough&&(this.edgeType.fromPoint=n.from.core),e.fromArrowSrc&&(n.from.image=this.imagelist.load(e.fromArrowSrc)),e.fromArrowImageWidth&&(n.from.imageWidth=e.fromArrowImageWidth),e.fromArrowImageHeight&&(n.from.imageHeight=e.fromArrowImageHeight)),e.toArrow&&(n.to=this.edgeType.getArrowData(t,"to",i,this.selected,this.hover,e),!1===e.arrowStrikethrough&&(this.edgeType.toPoint=n.to.core),e.toArrowSrc&&(n.to.image=this.imagelist.load(e.toArrowSrc)),e.toArrowImageWidth&&(n.to.imageWidth=e.toArrowImageWidth),e.toArrowImageHeight&&(n.to.imageHeight=e.toArrowImageHeight)),e.middleArrow&&(n.middle=this.edgeType.getArrowData(t,"middle",i,this.selected,this.hover,e),e.middleArrowSrc&&(n.middle.image=this.imagelist.load(e.middleArrowSrc)),e.middleArrowImageWidth&&(n.middle.imageWidth=e.middleArrowImageWidth),e.middleArrowImageHeight&&(n.middle.imageHeight=e.middleArrowImageHeight)),e.fromArrow&&this.edgeType.drawArrowHead(t,e,this.selected,this.hover,n.from),e.middleArrow&&this.edgeType.drawArrowHead(t,e,this.selected,this.hover,n.middle),e.toArrow&&this.edgeType.drawArrowHead(t,e,this.selected,this.hover,n.to);}}},{key:"drawLabel",value:function value(t,e){if(void 0!==this.options.label){var i,n=this.from,o=this.to;if(this.labelModule.differentState(this.selected,this.hover)&&this.labelModule.getTextSize(t,this.selected,this.hover),n.id!=o.id){this.labelModule.pointToSelf=!1,i=this.edgeType.getPoint(.5,e),t.save();var r=this._getRotation(t);0!=r.angle&&(t.translate(r.x,r.y),t.rotate(r.angle)),this.labelModule.draw(t,i.x,i.y,this.selected,this.hover),t.restore();}else{this.labelModule.pointToSelf=!0;var s=bP(t,this.options.selfReference.angle,this.options.selfReference.size,n);i=this._pointOnCircle(s.x,s.y,this.options.selfReference.size,this.options.selfReference.angle),this.labelModule.draw(t,i.x,i.y,this.selected,this.hover);}}}},{key:"getItemsOnPoint",value:function value(t){var e=[];if(this.labelModule.visible()){var i=this._getRotation();yP(this.labelModule.getSize(),t,i)&&e.push({edgeId:this.id,labelId:0});}var n={left:t.x,top:t.y};return this.isOverlappingWith(n)&&e.push({edgeId:this.id}),e;}},{key:"isOverlappingWith",value:function value(t){if(this.connected){var e=this.from.x,i=this.from.y,n=this.to.x,o=this.to.y,r=t.left,s=t.top;return this.edgeType.getDistanceToEdge(e,i,n,o,r,s)<10;}return!1;}},{key:"_getRotation",value:function value(t){var e=this.edgeType.getViaNode(),i=this.edgeType.getPoint(.5,e);void 0!==t&&this.labelModule.calculateLabelSize(t,this.selected,this.hover,i.x,i.y);var n={x:i.x,y:this.labelModule.size.yLine,angle:0};if(!this.labelModule.visible())return n;if("horizontal"===this.options.font.align)return n;var o=this.from.y-this.to.y,r=this.from.x-this.to.x,s=Math.atan2(o,r);return(s<-1&&r<0||s>0&&r<0)&&(s+=Math.PI),n.angle=s,n;}},{key:"_pointOnCircle",value:function value(t,e,i,n){return{x:t+i*Math.cos(n),y:e-i*Math.sin(n)};}},{key:"select",value:function value(){this.selected=!0;}},{key:"unselect",value:function value(){this.selected=!1;}},{key:"cleanup",value:function value(){return this.edgeType.cleanup();}},{key:"remove",value:function value(){this.cleanup(),this.disconnect(),delete this.body.edges[this.id];}},{key:"endPointsValid",value:function value(){return void 0!==this.body.nodes[this.fromId]&&void 0!==this.body.nodes[this.toId];}}],[{key:"parseOptions",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(pb(["endPointOffset","arrowStrikethrough","id","from","hidden","hoverWidth","labelHighlightBold","length","line","opacity","physics","scaling","selectionWidth","selfReferenceSize","selfReference","to","title","value","width","font","chosen","widthConstraint"],t,e,i),void 0!==e.endPointOffset&&void 0!==e.endPointOffset.from&&(g_(e.endPointOffset.from)?t.endPointOffset.from=e.endPointOffset.from:(t.endPointOffset.from=void 0!==n.endPointOffset.from?n.endPointOffset.from:0,console.error("endPointOffset.from is not a valid number"))),void 0!==e.endPointOffset&&void 0!==e.endPointOffset.to&&(g_(e.endPointOffset.to)?t.endPointOffset.to=e.endPointOffset.to:(t.endPointOffset.to=void 0!==n.endPointOffset.to?n.endPointOffset.to:0,console.error("endPointOffset.to is not a valid number"))),mP(e.label)?t.label=e.label:mP(t.label)||(t.label=void 0),Ab(t,e,"smooth",n),Ab(t,e,"shadow",n),Ab(t,e,"background",n),void 0!==e.dashes&&null!==e.dashes?t.dashes=e.dashes:!0===i&&null===e.dashes&&(t.dashes=pg(n.dashes)),void 0!==e.scaling&&null!==e.scaling?(void 0!==e.scaling.min&&(t.scaling.min=e.scaling.min),void 0!==e.scaling.max&&(t.scaling.max=e.scaling.max),Ab(t.scaling,e.scaling,"label",n.scaling)):!0===i&&null===e.scaling&&(t.scaling=pg(n.scaling)),void 0!==e.arrows&&null!==e.arrows){if("string"==typeof e.arrows){var r=e.arrows.toLowerCase();t.arrows.to.enabled=-1!=lg(r).call(r,"to"),t.arrows.middle.enabled=-1!=lg(r).call(r,"middle"),t.arrows.from.enabled=-1!=lg(r).call(r,"from");}else{if("object"!==bu(e.arrows))throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:"+mg(e.arrows));Ab(t.arrows,e.arrows,"to",n.arrows),Ab(t.arrows,e.arrows,"middle",n.arrows),Ab(t.arrows,e.arrows,"from",n.arrows);}}else!0===i&&null===e.arrows&&(t.arrows=pg(n.arrows));if(void 0!==e.color&&null!==e.color){var s=lb(e.color)?{color:e.color,highlight:e.color,hover:e.color,inherit:!1,opacity:1}:e.color,a=t.color;if(o)gb(a,n.color,!1,i);else for(var h in a)Object.prototype.hasOwnProperty.call(a,h)&&delete a[h];if(lb(a))a.color=a,a.highlight=a,a.hover=a,a.inherit=!1,void 0===s.opacity&&(a.opacity=1);else{var l=!1;void 0!==s.color&&(a.color=s.color,l=!0),void 0!==s.highlight&&(a.highlight=s.highlight,l=!0),void 0!==s.hover&&(a.hover=s.hover,l=!0),void 0!==s.inherit&&(a.inherit=s.inherit),void 0!==s.opacity&&(a.opacity=Math.min(1,Math.max(0,s.opacity))),!0===l?a.inherit=!1:void 0===a.inherit&&(a.inherit="from");}}else!0===i&&null===e.color&&(t.color=zb(n.color));!0===i&&null===e.font&&(t.font=zb(n.font)),Object.prototype.hasOwnProperty.call(e,"selfReferenceSize")&&(console.warn("The selfReferenceSize property has been deprecated. Please use selfReference property instead. The selfReference can be set like thise selfReference:{size:30, angle:Math.PI / 4}"),t.selfReference.size=e.selfReferenceSize);}}]),t;}(),cI=function(){function t(e,i,n){var o,r=this;ph(this,t),this.body=e,this.images=i,this.groups=n,this.body.functions.createEdge=Hn(o=this.create).call(o,this),this.edgesListeners={add:function add(t,e){r.add(e.items);},update:function update(t,e){r.update(e.items);},remove:function remove(t,e){r.remove(e.items);}},this.options={},this.defaultOptions={arrows:{to:{enabled:!1,scaleFactor:1,type:"arrow"},middle:{enabled:!1,scaleFactor:1,type:"arrow"},from:{enabled:!1,scaleFactor:1,type:"arrow"}},endPointOffset:{from:0,to:0},arrowStrikethrough:!0,color:{color:"#848484",highlight:"#848484",hover:"#848484",inherit:"from",opacity:1},dashes:!1,font:{color:"#343434",size:14,face:"arial",background:"none",strokeWidth:2,strokeColor:"#ffffff",align:"horizontal",multi:!1,vadjust:0,bold:{mod:"bold"},boldital:{mod:"bold italic"},ital:{mod:"italic"},mono:{mod:"",size:15,face:"courier new",vadjust:2}},hidden:!1,hoverWidth:1.5,label:void 0,labelHighlightBold:!0,length:void 0,physics:!0,scaling:{min:1,max:15,label:{enabled:!0,min:14,max:30,maxVisible:30,drawThreshold:5},customScalingFunction:function customScalingFunction(t,e,i,n){if(e===t)return .5;var o=1/(e-t);return Math.max(0,(n-t)*o);}},selectionWidth:1.5,selfReference:{size:20,angle:Math.PI/4,renderBehindTheNode:!0},shadow:{enabled:!1,color:"rgba(0,0,0,0.5)",size:10,x:5,y:5},background:{enabled:!1,color:"rgba(111,111,111,1)",size:10,dashes:!1},smooth:{enabled:!0,type:"dynamic",forceDirection:"none",roundness:.5},title:void 0,width:1,value:void 0},gb(this.options,this.defaultOptions),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t,e,i=this;this.body.emitter.on("_forceDisableDynamicCurves",function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];"dynamic"===t&&(t="continuous");var n=!1;for(var o in i.body.edges)if(Object.prototype.hasOwnProperty.call(i.body.edges,o)){var r=i.body.edges[o],s=i.body.data.edges.get(o);if(null!=s){var a=s.smooth;void 0!==a&&!0===a.enabled&&"dynamic"===a.type&&(void 0===t?r.setOptions({smooth:!1}):r.setOptions({smooth:{type:t}}),n=!0);}}!0===e&&!0===n&&i.body.emitter.emit("_dataChanged");}),this.body.emitter.on("_dataUpdated",function(){i.reconnectEdges();}),this.body.emitter.on("refreshEdges",Hn(t=this.refresh).call(t,this)),this.body.emitter.on("refresh",Hn(e=this.refresh).call(e,this)),this.body.emitter.on("destroy",function(){kb(i.edgesListeners,function(t,e){i.body.data.edges&&i.body.data.edges.off(e,t);}),delete i.body.functions.createEdge,delete i.edgesListeners.add,delete i.edgesListeners.update,delete i.edgesListeners.remove,delete i.edgesListeners;});}},{key:"setOptions",value:function value(t){if(void 0!==t){dI.parseOptions(this.options,t,!0,this.defaultOptions,!0);var e=!1;if(void 0!==t.smooth)for(var i in this.body.edges)Object.prototype.hasOwnProperty.call(this.body.edges,i)&&(e=this.body.edges[i].updateEdgeType()||e);if(void 0!==t.font)for(var n in this.body.edges)Object.prototype.hasOwnProperty.call(this.body.edges,n)&&this.body.edges[n].updateLabelModule();void 0===t.hidden&&void 0===t.physics&&!0!==e||this.body.emitter.emit("_dataChanged");}}},{key:"setData",value:function value(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.body.data.edges;if(ZM("id",t))this.body.data.edges=t;else if(Df(t))this.body.data.edges=new GM(),this.body.data.edges.add(t);else{if(t)throw new TypeError("Array or DataSet expected");this.body.data.edges=new GM();}if(n&&kb(this.edgesListeners,function(t,e){n.off(e,t);}),this.body.edges={},this.body.data.edges){kb(this.edgesListeners,function(t,i){e.body.data.edges.on(i,t);});var o=this.body.data.edges.getIds();this.add(o,!0);}this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"),!1===i&&this.body.emitter.emit("_dataChanged");}},{key:"add",value:function value(t){for(var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.body.edges,n=this.body.data.edges,o=0;o<t.length;o++){var r=t[o],s=i[r];s&&s.disconnect();var a=n.get(r,{showInternalIds:!0});i[r]=this.create(a);}this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"),!1===e&&this.body.emitter.emit("_dataChanged");}},{key:"update",value:function value(t){for(var e=this.body.edges,i=this.body.data.edges,n=!1,o=0;o<t.length;o++){var r=t[o],s=i.get(r),a=e[r];void 0!==a?(a.disconnect(),n=a.setOptions(s)||n,a.connect()):(this.body.edges[r]=this.create(s),n=!0);}!0===n?(this.body.emitter.emit("_adjustEdgesForHierarchicalLayout"),this.body.emitter.emit("_dataChanged")):this.body.emitter.emit("_dataUpdated");}},{key:"remove",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(0!==t.length){var i=this.body.edges;kb(t,function(t){var e=i[t];void 0!==e&&e.remove();}),e&&this.body.emitter.emit("_dataChanged");}}},{key:"refresh",value:function value(){var t=this;kb(this.body.edges,function(e,i){var n=t.body.data.edges.get(i);void 0!==n&&e.setOptions(n);});}},{key:"create",value:function value(t){return new dI(t,this.body,this.images,this.options,this.defaultOptions);}},{key:"reconnectEdges",value:function value(){var t,e=this.body.nodes,i=this.body.edges;for(t in e)Object.prototype.hasOwnProperty.call(e,t)&&(e[t].edges=[]);for(t in i)if(Object.prototype.hasOwnProperty.call(i,t)){var n=i[t];n.from=null,n.to=null,n.connect();}}},{key:"getConnectedNodes",value:function value(t){var e=[];if(void 0!==this.body.edges[t]){var i=this.body.edges[t];void 0!==i.fromId&&e.push(i.fromId),void 0!==i.toId&&e.push(i.toId);}return e;}},{key:"_updateState",value:function value(){this._addMissingEdges(),this._removeInvalidEdges();}},{key:"_removeInvalidEdges",value:function value(){var t=this,e=[];kb(this.body.edges,function(i,n){var o=t.body.nodes[i.toId],r=t.body.nodes[i.fromId];void 0!==o&&!0===o.isCluster||void 0!==r&&!0===r.isCluster||void 0!==o&&void 0!==r||e.push(n);}),this.remove(e,!1);}},{key:"_addMissingEdges",value:function value(){var t=this.body.data.edges;if(null!=t){var e=this.body.edges,i=[];op(t).call(t,function(t,n){void 0===e[n]&&i.push(n);}),this.add(i,!0);}}}]),t;}(),uI=function(){function t(e,i,n){ph(this,t),this.body=e,this.physicsBody=i,this.barnesHutTree,this.setOptions(n),this._rng=Jm("BARNES HUT SOLVER");}return xu(t,[{key:"setOptions",value:function value(t){this.options=t,this.thetaInversed=1/this.options.theta,this.overlapAvoidanceFactor=1-Math.max(0,Math.min(1,this.options.avoidOverlap));}},{key:"solve",value:function value(){if(0!==this.options.gravitationalConstant&&this.physicsBody.physicsNodeIndices.length>0){var t,e=this.body.nodes,i=this.physicsBody.physicsNodeIndices,n=i.length,o=this._formBarnesHutTree(e,i);this.barnesHutTree=o;for(var r=0;r<n;r++)(t=e[i[r]]).options.mass>0&&this._getForceContributions(o.root,t);}}},{key:"_getForceContributions",value:function value(t,e){this._getForceContribution(t.children.NW,e),this._getForceContribution(t.children.NE,e),this._getForceContribution(t.children.SW,e),this._getForceContribution(t.children.SE,e);}},{key:"_getForceContribution",value:function value(t,e){if(t.childrenCount>0){var i=t.centerOfMass.x-e.x,n=t.centerOfMass.y-e.y,o=Math.sqrt(i*i+n*n);o*t.calcSize>this.thetaInversed?this._calculateForces(o,i,n,e,t):4===t.childrenCount?this._getForceContributions(t,e):t.children.data.id!=e.id&&this._calculateForces(o,i,n,e,t);}}},{key:"_calculateForces",value:function value(t,e,i,n,o){0===t&&(e=t=.1),this.overlapAvoidanceFactor<1&&n.shape.radius&&(t=Math.max(.1+this.overlapAvoidanceFactor*n.shape.radius,t-n.shape.radius));var r=this.options.gravitationalConstant*o.mass*n.options.mass/Math.pow(t,3),s=e*r,a=i*r;this.physicsBody.forces[n.id].x+=s,this.physicsBody.forces[n.id].y+=a;}},{key:"_formBarnesHutTree",value:function value(t,e){for(var i,n=e.length,o=t[e[0]].x,r=t[e[0]].y,s=t[e[0]].x,a=t[e[0]].y,h=1;h<n;h++){var l=t[e[h]],d=l.x,c=l.y;l.options.mass>0&&(d<o&&(o=d),d>s&&(s=d),c<r&&(r=c),c>a&&(a=c));}var u=Math.abs(s-o)-Math.abs(a-r);u>0?(r-=.5*u,a+=.5*u):(o+=.5*u,s-=.5*u);var f=Math.max(1e-5,Math.abs(s-o)),p=.5*f,v=.5*(o+s),g=.5*(r+a),y={root:{centerOfMass:{x:0,y:0},mass:0,range:{minX:v-p,maxX:v+p,minY:g-p,maxY:g+p},size:f,calcSize:1/f,children:{data:null},maxWidth:0,level:0,childrenCount:4}};this._splitBranch(y.root);for(var m=0;m<n;m++)(i=t[e[m]]).options.mass>0&&this._placeInTree(y.root,i);return y;}},{key:"_updateBranchMass",value:function value(t,e){var i=t.centerOfMass,n=t.mass+e.options.mass,o=1/n;i.x=i.x*t.mass+e.x*e.options.mass,i.x*=o,i.y=i.y*t.mass+e.y*e.options.mass,i.y*=o,t.mass=n;var r=Math.max(Math.max(e.height,e.radius),e.width);t.maxWidth=t.maxWidth<r?r:t.maxWidth;}},{key:"_placeInTree",value:function value(t,e,i){1==i&&void 0!==i||this._updateBranchMass(t,e);var n,o=t.children.NW.range;n=o.maxX>e.x?o.maxY>e.y?"NW":"SW":o.maxY>e.y?"NE":"SE",this._placeInRegion(t,e,n);}},{key:"_placeInRegion",value:function value(t,e,i){var n=t.children[i];switch(n.childrenCount){case 0:n.children.data=e,n.childrenCount=1,this._updateBranchMass(n,e);break;case 1:n.children.data.x===e.x&&n.children.data.y===e.y?(e.x+=this._rng(),e.y+=this._rng()):(this._splitBranch(n),this._placeInTree(n,e));break;case 4:this._placeInTree(n,e);}}},{key:"_splitBranch",value:function value(t){var e=null;1===t.childrenCount&&(e=t.children.data,t.mass=0,t.centerOfMass.x=0,t.centerOfMass.y=0),t.childrenCount=4,t.children.data=null,this._insertRegion(t,"NW"),this._insertRegion(t,"NE"),this._insertRegion(t,"SW"),this._insertRegion(t,"SE"),null!=e&&this._placeInTree(t,e);}},{key:"_insertRegion",value:function value(t,e){var i,n,o,r,s=.5*t.size;switch(e){case"NW":i=t.range.minX,n=t.range.minX+s,o=t.range.minY,r=t.range.minY+s;break;case"NE":i=t.range.minX+s,n=t.range.maxX,o=t.range.minY,r=t.range.minY+s;break;case"SW":i=t.range.minX,n=t.range.minX+s,o=t.range.minY+s,r=t.range.maxY;break;case"SE":i=t.range.minX+s,n=t.range.maxX,o=t.range.minY+s,r=t.range.maxY;}t.children[e]={centerOfMass:{x:0,y:0},mass:0,range:{minX:i,maxX:n,minY:o,maxY:r},size:.5*t.size,calcSize:2*t.calcSize,children:{data:null},maxWidth:0,level:t.level+1,childrenCount:0};}},{key:"_debug",value:function value(t,e){void 0!==this.barnesHutTree&&(t.lineWidth=1,this._drawBranch(this.barnesHutTree.root,t,e));}},{key:"_drawBranch",value:function value(t,e,i){void 0===i&&(i="#FF0000"),4===t.childrenCount&&(this._drawBranch(t.children.NW,e),this._drawBranch(t.children.NE,e),this._drawBranch(t.children.SE,e),this._drawBranch(t.children.SW,e)),e.strokeStyle=i,e.beginPath(),e.moveTo(t.range.minX,t.range.minY),e.lineTo(t.range.maxX,t.range.minY),e.stroke(),e.beginPath(),e.moveTo(t.range.maxX,t.range.minY),e.lineTo(t.range.maxX,t.range.maxY),e.stroke(),e.beginPath(),e.moveTo(t.range.maxX,t.range.maxY),e.lineTo(t.range.minX,t.range.maxY),e.stroke(),e.beginPath(),e.moveTo(t.range.minX,t.range.maxY),e.lineTo(t.range.minX,t.range.minY),e.stroke();}}]),t;}(),fI=function(){function t(e,i,n){ph(this,t),this._rng=Jm("REPULSION SOLVER"),this.body=e,this.physicsBody=i,this.setOptions(n);}return xu(t,[{key:"setOptions",value:function value(t){this.options=t;}},{key:"solve",value:function value(){for(var t,e,i,n,o,r,s,a,h=this.body.nodes,l=this.physicsBody.physicsNodeIndices,d=this.physicsBody.forces,c=this.options.nodeDistance,u=-2/3/c,f=0;f<l.length-1;f++){s=h[l[f]];for(var p=f+1;p<l.length;p++)t=(a=h[l[p]]).x-s.x,e=a.y-s.y,0===(i=Math.sqrt(t*t+e*e))&&(t=i=.1*this._rng()),i<2*c&&(r=i<.5*c?1:u*i+1.3333333333333333,n=t*(r/=i),o=e*r,d[s.id].x-=n,d[s.id].y-=o,d[a.id].x+=n,d[a.id].y+=o);}}}]),t;}(),pI=function(){function t(e,i,n){ph(this,t),this.body=e,this.physicsBody=i,this.setOptions(n);}return xu(t,[{key:"setOptions",value:function value(t){this.options=t,this.overlapAvoidanceFactor=Math.max(0,Math.min(1,this.options.avoidOverlap||0));}},{key:"solve",value:function value(){for(var t=this.body.nodes,e=this.physicsBody.physicsNodeIndices,i=this.physicsBody.forces,n=this.options.nodeDistance,o=0;o<e.length-1;o++)for(var r=t[e[o]],s=o+1;s<e.length;s++){var a=t[e[s]];if(r.level===a.level){var h=n+this.overlapAvoidanceFactor*((r.shape.radius||0)/2+(a.shape.radius||0)/2),l=a.x-r.x,d=a.y-r.y,c=Math.sqrt(l*l+d*d),u=void 0;u=c<h?-Math.pow(.05*c,2)+Math.pow(.05*h,2):0,0!==c&&(u/=c);var f=l*u,p=d*u;i[r.id].x-=f,i[r.id].y-=p,i[a.id].x+=f,i[a.id].y+=p;}}}}]),t;}(),vI=function(){function t(e,i,n){ph(this,t),this.body=e,this.physicsBody=i,this.setOptions(n);}return xu(t,[{key:"setOptions",value:function value(t){this.options=t;}},{key:"solve",value:function value(){for(var t,e,i,n,o,r=this.physicsBody.physicsEdgeIndices,s=this.body.edges,a=0;a<r.length;a++)!0===(e=s[r[a]]).connected&&e.toId!==e.fromId&&void 0!==this.body.nodes[e.toId]&&void 0!==this.body.nodes[e.fromId]&&(void 0!==e.edgeType.via?(t=void 0===e.options.length?this.options.springLength:e.options.length,i=e.to,n=e.edgeType.via,o=e.from,this._calculateSpringForce(i,n,.5*t),this._calculateSpringForce(n,o,.5*t)):(t=void 0===e.options.length?1.5*this.options.springLength:e.options.length,this._calculateSpringForce(e.from,e.to,t)));}},{key:"_calculateSpringForce",value:function value(t,e,i){var n=t.x-e.x,o=t.y-e.y,r=Math.max(Math.sqrt(n*n+o*o),.01),s=this.options.springConstant*(i-r)/r,a=n*s,h=o*s;void 0!==this.physicsBody.forces[t.id]&&(this.physicsBody.forces[t.id].x+=a,this.physicsBody.forces[t.id].y+=h),void 0!==this.physicsBody.forces[e.id]&&(this.physicsBody.forces[e.id].x-=a,this.physicsBody.forces[e.id].y-=h);}}]),t;}(),gI=function(){function t(e,i,n){ph(this,t),this.body=e,this.physicsBody=i,this.setOptions(n);}return xu(t,[{key:"setOptions",value:function value(t){this.options=t;}},{key:"solve",value:function value(){for(var t,e,i,n,o,r,s,a,h,l,d=this.body.edges,c=.5,u=this.physicsBody.physicsEdgeIndices,f=this.physicsBody.physicsNodeIndices,p=this.physicsBody.forces,v=0;v<f.length;v++){var g=f[v];p[g].springFx=0,p[g].springFy=0;}for(var y=0;y<u.length;y++)!0===(e=d[u[y]]).connected&&(t=void 0===e.options.length?this.options.springLength:e.options.length,i=e.from.x-e.to.x,n=e.from.y-e.to.y,a=0===(a=Math.sqrt(i*i+n*n))?.01:a,o=i*(s=this.options.springConstant*(t-a)/a),r=n*s,e.to.level!=e.from.level?(void 0!==p[e.toId]&&(p[e.toId].springFx-=o,p[e.toId].springFy-=r),void 0!==p[e.fromId]&&(p[e.fromId].springFx+=o,p[e.fromId].springFy+=r)):(void 0!==p[e.toId]&&(p[e.toId].x-=c*o,p[e.toId].y-=c*r),void 0!==p[e.fromId]&&(p[e.fromId].x+=c*o,p[e.fromId].y+=c*r)));s=1;for(var m=0;m<f.length;m++){var b=f[m];h=Math.min(s,Math.max(-s,p[b].springFx)),l=Math.min(s,Math.max(-s,p[b].springFy)),p[b].x+=h,p[b].y+=l;}for(var w=0,k=0,_=0;_<f.length;_++){var x=f[_];w+=p[x].x,k+=p[x].y;}for(var E=w/f.length,O=k/f.length,C=0;C<f.length;C++){var S=f[C];p[S].x-=E,p[S].y-=O;}}}]),t;}(),yI=function(){function t(e,i,n){ph(this,t),this.body=e,this.physicsBody=i,this.setOptions(n);}return xu(t,[{key:"setOptions",value:function value(t){this.options=t;}},{key:"solve",value:function value(){for(var t,e,i,n,o=this.body.nodes,r=this.physicsBody.physicsNodeIndices,s=this.physicsBody.forces,a=0;a<r.length;a++){t=-(n=o[r[a]]).x,e=-n.y,i=Math.sqrt(t*t+e*e),this._calculateForces(i,t,e,s,n);}}},{key:"_calculateForces",value:function value(t,e,i,n,o){var r=0===t?0:this.options.centralGravity/t;n[o.id].x=e*r,n[o.id].y=i*r;}}]),t;}();function mI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var bI=function(t){D_(i,t);var e=mI(i);function i(t,n,o){var r;return ph(this,i),(r=e.call(this,t,n,o))._rng=Jm("FORCE ATLAS 2 BASED REPULSION SOLVER"),r;}return xu(i,[{key:"_calculateForces",value:function value(t,e,i,n,o){0===t&&(e=t=.1*this._rng()),this.overlapAvoidanceFactor<1&&n.shape.radius&&(t=Math.max(.1+this.overlapAvoidanceFactor*n.shape.radius,t-n.shape.radius));var r=n.edges.length+1,s=this.options.gravitationalConstant*o.mass*n.options.mass*r/Math.pow(t,2),a=e*s,h=i*s;this.physicsBody.forces[n.id].x+=a,this.physicsBody.forces[n.id].y+=h;}}]),i;}(uI);function wI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var kI=function(t){D_(i,t);var e=wI(i);function i(t,n,o){return ph(this,i),e.call(this,t,n,o);}return xu(i,[{key:"_calculateForces",value:function value(t,e,i,n,o){if(t>0){var r=o.edges.length+1,s=this.options.centralGravity*r*o.options.mass;n[o.id].x=e*s,n[o.id].y=i*s;}}}]),i;}(yI),_I=function(){function t(e){ph(this,t),this.body=e,this.physicsBody={physicsNodeIndices:[],physicsEdgeIndices:[],forces:{},velocities:{}},this.physicsEnabled=!0,this.simulationInterval=1e3/60,this.requiresTimeout=!0,this.previousStates={},this.referenceState={},this.freezeCache={},this.renderTimer=void 0,this.adaptiveTimestep=!1,this.adaptiveTimestepEnabled=!1,this.adaptiveCounter=0,this.adaptiveInterval=3,this.stabilized=!1,this.startedStabilization=!1,this.stabilizationIterations=0,this.ready=!1,this.options={},this.defaultOptions={enabled:!0,barnesHut:{theta:.5,gravitationalConstant:-2e3,centralGravity:.3,springLength:95,springConstant:.04,damping:.09,avoidOverlap:0},forceAtlas2Based:{theta:.5,gravitationalConstant:-50,centralGravity:.01,springConstant:.08,springLength:100,damping:.4,avoidOverlap:0},repulsion:{centralGravity:.2,springLength:200,springConstant:.05,nodeDistance:100,damping:.09,avoidOverlap:0},hierarchicalRepulsion:{centralGravity:0,springLength:100,springConstant:.01,nodeDistance:120,damping:.09},maxVelocity:50,minVelocity:.75,solver:"barnesHut",stabilization:{enabled:!0,iterations:1e3,updateInterval:50,onlyDynamicEdges:!1,fit:!0},timestep:.5,adaptiveTimestep:!0,wind:{x:0,y:0}},bn(this.options,this.defaultOptions),this.timestep=.5,this.layoutFailed=!1,this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t=this;this.body.emitter.on("initPhysics",function(){t.initPhysics();}),this.body.emitter.on("_layoutFailed",function(){t.layoutFailed=!0;}),this.body.emitter.on("resetPhysics",function(){t.stopSimulation(),t.ready=!1;}),this.body.emitter.on("disablePhysics",function(){t.physicsEnabled=!1,t.stopSimulation();}),this.body.emitter.on("restorePhysics",function(){t.setOptions(t.options),!0===t.ready&&t.startSimulation();}),this.body.emitter.on("startSimulation",function(){!0===t.ready&&t.startSimulation();}),this.body.emitter.on("stopSimulation",function(){t.stopSimulation();}),this.body.emitter.on("destroy",function(){t.stopSimulation(!1),t.body.emitter.off();}),this.body.emitter.on("_dataChanged",function(){t.updatePhysicsData();});}},{key:"setOptions",value:function value(t){if(void 0!==t)if(!1===t)this.options.enabled=!1,this.physicsEnabled=!1,this.stopSimulation();else if(!0===t)this.options.enabled=!0,this.physicsEnabled=!0,this.startSimulation();else{this.physicsEnabled=!0,vb(["stabilization"],this.options,t),Ab(this.options,t,"stabilization"),void 0===t.enabled&&(this.options.enabled=!0),!1===this.options.enabled&&(this.physicsEnabled=!1,this.stopSimulation());var e=this.options.wind;e&&(("number"!=typeof e.x||f_(e.x))&&(e.x=0),("number"!=typeof e.y||f_(e.y))&&(e.y=0)),this.timestep=this.options.timestep;}this.init();}},{key:"init",value:function value(){var t;"forceAtlas2Based"===this.options.solver?(t=this.options.forceAtlas2Based,this.nodesSolver=new bI(this.body,this.physicsBody,t),this.edgesSolver=new vI(this.body,this.physicsBody,t),this.gravitySolver=new kI(this.body,this.physicsBody,t)):"repulsion"===this.options.solver?(t=this.options.repulsion,this.nodesSolver=new fI(this.body,this.physicsBody,t),this.edgesSolver=new vI(this.body,this.physicsBody,t),this.gravitySolver=new yI(this.body,this.physicsBody,t)):"hierarchicalRepulsion"===this.options.solver?(t=this.options.hierarchicalRepulsion,this.nodesSolver=new pI(this.body,this.physicsBody,t),this.edgesSolver=new gI(this.body,this.physicsBody,t),this.gravitySolver=new yI(this.body,this.physicsBody,t)):(t=this.options.barnesHut,this.nodesSolver=new uI(this.body,this.physicsBody,t),this.edgesSolver=new vI(this.body,this.physicsBody,t),this.gravitySolver=new yI(this.body,this.physicsBody,t)),this.modelOptions=t;}},{key:"initPhysics",value:function value(){!0===this.physicsEnabled&&!0===this.options.enabled?!0===this.options.stabilization.enabled?this.stabilize():(this.stabilized=!1,this.ready=!0,this.body.emitter.emit("fit",{},this.layoutFailed),this.startSimulation()):(this.ready=!0,this.body.emitter.emit("fit"));}},{key:"startSimulation",value:function value(){var t;!0===this.physicsEnabled&&!0===this.options.enabled?(this.stabilized=!1,this.adaptiveTimestep=!1,this.body.emitter.emit("_resizeNodes"),void 0===this.viewFunction&&(this.viewFunction=Hn(t=this.simulationStep).call(t,this),this.body.emitter.on("initRedraw",this.viewFunction),this.body.emitter.emit("_startRendering"))):this.body.emitter.emit("_redraw");}},{key:"stopSimulation",value:function value(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.stabilized=!0,!0===t&&this._emitStabilized(),void 0!==this.viewFunction&&(this.body.emitter.off("initRedraw",this.viewFunction),this.viewFunction=void 0,!0===t&&this.body.emitter.emit("_stopRendering"));}},{key:"simulationStep",value:function value(){var t=Uf();this.physicsTick(),(Uf()-t<.4*this.simulationInterval||!0===this.runDoubleSpeed)&&!1===this.stabilized&&(this.physicsTick(),this.runDoubleSpeed=!0),!0===this.stabilized&&this.stopSimulation();}},{key:"_emitStabilized",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.stabilizationIterations;(this.stabilizationIterations>1||!0===this.startedStabilization)&&jg(function(){t.body.emitter.emit("stabilized",{iterations:e}),t.startedStabilization=!1,t.stabilizationIterations=0;},0);}},{key:"physicsStep",value:function value(){this.gravitySolver.solve(),this.nodesSolver.solve(),this.edgesSolver.solve(),this.moveNodes();}},{key:"adjustTimeStep",value:function value(){!0===this._evaluateStepQuality()?this.timestep=1.2*this.timestep:this.timestep/1.2<this.options.timestep?this.timestep=this.options.timestep:(this.adaptiveCounter=-1,this.timestep=Math.max(this.options.timestep,this.timestep/1.2));}},{key:"physicsTick",value:function value(){if(this._startStabilizing(),!0!==this.stabilized){if(!0===this.adaptiveTimestep&&!0===this.adaptiveTimestepEnabled)this.adaptiveCounter%this.adaptiveInterval==0?(this.timestep=2*this.timestep,this.physicsStep(),this.revert(),this.timestep=.5*this.timestep,this.physicsStep(),this.physicsStep(),this.adjustTimeStep()):this.physicsStep(),this.adaptiveCounter+=1;else this.timestep=this.options.timestep,this.physicsStep();!0===this.stabilized&&this.revert(),this.stabilizationIterations++;}}},{key:"updatePhysicsData",value:function value(){this.physicsBody.forces={},this.physicsBody.physicsNodeIndices=[],this.physicsBody.physicsEdgeIndices=[];var t=this.body.nodes,e=this.body.edges;for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&!0===t[i].options.physics&&this.physicsBody.physicsNodeIndices.push(t[i].id);for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&!0===e[n].options.physics&&this.physicsBody.physicsEdgeIndices.push(e[n].id);for(var o=0;o<this.physicsBody.physicsNodeIndices.length;o++){var r=this.physicsBody.physicsNodeIndices[o];this.physicsBody.forces[r]={x:0,y:0},void 0===this.physicsBody.velocities[r]&&(this.physicsBody.velocities[r]={x:0,y:0});}for(var s in this.physicsBody.velocities)void 0===t[s]&&delete this.physicsBody.velocities[s];}},{key:"revert",value:function value(){var t=Hf(this.previousStates),e=this.body.nodes,i=this.physicsBody.velocities;this.referenceState={};for(var n=0;n<t.length;n++){var o=t[n];void 0!==e[o]?!0===e[o].options.physics&&(this.referenceState[o]={positions:{x:e[o].x,y:e[o].y}},i[o].x=this.previousStates[o].vx,i[o].y=this.previousStates[o].vy,e[o].x=this.previousStates[o].x,e[o].y=this.previousStates[o].y):delete this.previousStates[o];}}},{key:"_evaluateStepQuality",value:function value(){var t,e,i=this.body.nodes,n=this.referenceState;for(var o in this.referenceState)if(Object.prototype.hasOwnProperty.call(this.referenceState,o)&&void 0!==i[o]&&(t=i[o].x-n[o].positions.x,e=i[o].y-n[o].positions.y,Math.sqrt(Math.pow(t,2)+Math.pow(e,2))>.3))return!1;return!0;}},{key:"moveNodes",value:function value(){for(var t=this.physicsBody.physicsNodeIndices,e=0,i=0,n=0;n<t.length;n++){var o=t[n],r=this._performStep(o);e=Math.max(e,r),i+=r;}this.adaptiveTimestepEnabled=i/t.length<5,this.stabilized=e<this.options.minVelocity;}},{key:"calculateComponentVelocity",value:function value(t,e,i){t+=(e-this.modelOptions.damping*t)/i*this.timestep;var n=this.options.maxVelocity||1e9;return Math.abs(t)>n&&(t=t>0?n:-n),t;}},{key:"_performStep",value:function value(t){var e=this.body.nodes[t],i=this.physicsBody.forces[t];this.options.wind&&(i.x+=this.options.wind.x,i.y+=this.options.wind.y);var n=this.physicsBody.velocities[t];return this.previousStates[t]={x:e.x,y:e.y,vx:n.x,vy:n.y},!1===e.options.fixed.x?(n.x=this.calculateComponentVelocity(n.x,i.x,e.options.mass),e.x+=n.x*this.timestep):(i.x=0,n.x=0),!1===e.options.fixed.y?(n.y=this.calculateComponentVelocity(n.y,i.y,e.options.mass),e.y+=n.y*this.timestep):(i.y=0,n.y=0),Math.sqrt(Math.pow(n.x,2)+Math.pow(n.y,2));}},{key:"_freezeNodes",value:function value(){var t=this.body.nodes;for(var e in t)if(Object.prototype.hasOwnProperty.call(t,e)&&t[e].x&&t[e].y){var i=t[e].options.fixed;this.freezeCache[e]={x:i.x,y:i.y},i.x=!0,i.y=!0;}}},{key:"_restoreFrozenNodes",value:function value(){var t=this.body.nodes;for(var e in t)Object.prototype.hasOwnProperty.call(t,e)&&void 0!==this.freezeCache[e]&&(t[e].options.fixed.x=this.freezeCache[e].x,t[e].options.fixed.y=this.freezeCache[e].y);this.freezeCache={};}},{key:"stabilize",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.options.stabilization.iterations;"number"!=typeof e&&(e=this.options.stabilization.iterations,console.error("The stabilize method needs a numeric amount of iterations. Switching to default: ",e)),0!==this.physicsBody.physicsNodeIndices.length?(this.adaptiveTimestep=this.options.adaptiveTimestep,this.body.emitter.emit("_resizeNodes"),this.stopSimulation(),this.stabilized=!1,this.body.emitter.emit("_blockRedraw"),this.targetIterations=e,!0===this.options.stabilization.onlyDynamicEdges&&this._freezeNodes(),this.stabilizationIterations=0,jg(function(){return t._stabilizationBatch();},0)):this.ready=!0;}},{key:"_startStabilizing",value:function value(){return!0!==this.startedStabilization&&(this.body.emitter.emit("startStabilizing"),this.startedStabilization=!0,!0);}},{key:"_stabilizationBatch",value:function value(){var t=this,e=function e(){return!1===t.stabilized&&t.stabilizationIterations<t.targetIterations;},i=function i(){t.body.emitter.emit("stabilizationProgress",{iterations:t.stabilizationIterations,total:t.targetIterations});};this._startStabilizing()&&i();for(var n,o=0;e()&&o<this.options.stabilization.updateInterval;)this.physicsTick(),o++;(i(),e())?jg(Hn(n=this._stabilizationBatch).call(n,this),0):this._finalizeStabilization();}},{key:"_finalizeStabilization",value:function value(){this.body.emitter.emit("_allowRedraw"),!0===this.options.stabilization.fit&&this.body.emitter.emit("fit"),!0===this.options.stabilization.onlyDynamicEdges&&this._restoreFrozenNodes(),this.body.emitter.emit("stabilizationIterationsDone"),this.body.emitter.emit("_requestRedraw"),!0===this.stabilized?this._emitStabilized():this.startSimulation(),this.ready=!0;}},{key:"_drawForces",value:function value(t){for(var e=0;e<this.physicsBody.physicsNodeIndices.length;e++){var i=this.physicsBody.physicsNodeIndices[e],n=this.body.nodes[i],o=this.physicsBody.forces[i],r=Math.sqrt(Math.pow(o.x,2)+Math.pow(o.x,2)),s=Math.min(Math.max(5,r),15),a=3*s,h=Db((180-180*Math.min(1,Math.max(0,.03*r)))/360,1,1),l={x:n.x+20*o.x,y:n.y+20*o.y};t.lineWidth=s,t.strokeStyle=h,t.beginPath(),t.moveTo(n.x,n.y),t.lineTo(l.x,l.y),t.stroke();var d=Math.atan2(o.y,o.x);t.fillStyle=h,YD.draw(t,{type:"arrow",point:l,angle:d,length:a}),Kg(t).call(t);}}}]),t;}(),xI=function(){function t(){ph(this,t);}return xu(t,null,[{key:"getRange",value:function value(t){var e,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=1e9,o=-1e9,r=1e9,s=-1e9;if(i.length>0)for(var a=0;a<i.length;a++)r>(e=t[i[a]]).shape.boundingBox.left&&(r=e.shape.boundingBox.left),s<e.shape.boundingBox.right&&(s=e.shape.boundingBox.right),n>e.shape.boundingBox.top&&(n=e.shape.boundingBox.top),o<e.shape.boundingBox.bottom&&(o=e.shape.boundingBox.bottom);return 1e9===r&&-1e9===s&&1e9===n&&-1e9===o&&(n=0,o=0,r=0,s=0),{minX:r,maxX:s,minY:n,maxY:o};}},{key:"getRangeCore",value:function value(t){var e,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=1e9,o=-1e9,r=1e9,s=-1e9;if(i.length>0)for(var a=0;a<i.length;a++)r>(e=t[i[a]]).x&&(r=e.x),s<e.x&&(s=e.x),n>e.y&&(n=e.y),o<e.y&&(o=e.y);return 1e9===r&&-1e9===s&&1e9===n&&-1e9===o&&(n=0,o=0,r=0,s=0),{minX:r,maxX:s,minY:n,maxY:o};}},{key:"findCenter",value:function value(t){return{x:.5*(t.maxX+t.minX),y:.5*(t.maxY+t.minY)};}},{key:"cloneOptions",value:function value(t,e){var i={};return void 0===e||"node"===e?(gb(i,t.options,!0),i.x=t.x,i.y=t.y,i.amountOfConnections=t.edges.length):gb(i,t.options,!0),i;}}]),t;}();function EI(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var OI=function(t){D_(i,t);var e=EI(i);function i(t,n,o,r,s,a){var h;return ph(this,i),(h=e.call(this,t,n,o,r,s,a)).isCluster=!0,h.containedNodes={},h.containedEdges={},h;}return xu(i,[{key:"_openChildCluster",value:function value(t){var e=this,i=this.body.nodes[t];if(void 0===this.containedNodes[t])throw new Error("node with id: "+t+" not in current cluster");if(!i.isCluster)throw new Error("node with id: "+t+" is not a cluster");delete this.containedNodes[t],kb(i.edges,function(t){delete e.containedEdges[t.id];}),kb(i.containedNodes,function(t,i){e.containedNodes[i]=t;}),i.containedNodes={},kb(i.containedEdges,function(t,i){e.containedEdges[i]=t;}),i.containedEdges={},kb(i.edges,function(t){kb(e.edges,function(i){var n,o,r=lg(n=i.clusteringEdgeReplacingIds).call(n,t.id);-1!==r&&(kb(t.clusteringEdgeReplacingIds,function(t){i.clusteringEdgeReplacingIds.push(t),e.body.edges[t].edgeReplacedById=i.id;}),Ap(o=i.clusteringEdgeReplacingIds).call(o,r,1));});}),i.edges=[];}}]),i;}(fD),CI=function(){function t(e){var i=this;ph(this,t),this.body=e,this.clusteredNodes={},this.clusteredEdges={},this.options={},this.defaultOptions={},bn(this.options,this.defaultOptions),this.body.emitter.on("_resetData",function(){i.clusteredNodes={},i.clusteredEdges={};});}return xu(t,[{key:"clusterByHubsize",value:function value(t,e){void 0===t?t=this._getHubSize():"object"===bu(t)&&(e=this._checkOptions(t),t=this._getHubSize());for(var i=[],n=0;n<this.body.nodeIndices.length;n++){var o=this.body.nodes[this.body.nodeIndices[n]];o.edges.length>=t&&i.push(o.id);}for(var r=0;r<i.length;r++)this.clusterByConnection(i[r],e,!0);this.body.emitter.emit("_dataChanged");}},{key:"cluster",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},i=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(void 0===e.joinCondition)throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");e=this._checkOptions(e);var n={},o={};kb(this.body.nodes,function(i,r){i.options&&!0===e.joinCondition(i.options)&&(n[r]=i,kb(i.edges,function(e){void 0===t.clusteredEdges[e.id]&&(o[e.id]=e);}));}),this._cluster(n,o,e,i);}},{key:"clusterByEdgeCount",value:function value(t,e){var i=this,n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];e=this._checkOptions(e);for(var o,r,s,a=[],h={},l=function l(){var n={},l={},c=i.body.nodeIndices[d],u=i.body.nodes[c];if(void 0===h[c]){s=0,r=[];for(var f=0;f<u.edges.length;f++)o=u.edges[f],void 0===i.clusteredEdges[o.id]&&(o.toId!==o.fromId&&s++,r.push(o));if(s===t){for(var p=function p(t){if(void 0===e.joinCondition||null===e.joinCondition)return!0;var i=xI.cloneOptions(t);return e.joinCondition(i);},v=!0,g=0;g<r.length;g++){o=r[g];var y=i._getConnectedId(o,c);if(!p(u)){v=!1;break;}l[o.id]=o,n[c]=u,n[y]=i.body.nodes[y],h[c]=!0;}if(Hf(n).length>0&&Hf(l).length>0&&!0===v){var m=function(){for(var t=0;t<a.length;++t)for(var e in n)if(void 0!==a[t].nodes[e])return a[t];}();if(void 0!==m){for(var b in n)void 0===m.nodes[b]&&(m.nodes[b]=n[b]);for(var w in l)void 0===m.edges[w]&&(m.edges[w]=l[w]);}else a.push({nodes:n,edges:l});}}}},d=0;d<this.body.nodeIndices.length;d++)l();for(var c=0;c<a.length;c++)this._cluster(a[c].nodes,a[c].edges,e,!1);!0===n&&this.body.emitter.emit("_dataChanged");}},{key:"clusterOutliers",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.clusterByEdgeCount(1,t,e);}},{key:"clusterBridges",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.clusterByEdgeCount(2,t,e);}},{key:"clusterByConnection",value:function value(t,e){var i,n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];if(void 0===t)throw new Error("No nodeId supplied to clusterByConnection!");if(void 0===this.body.nodes[t])throw new Error("The nodeId given to clusterByConnection does not exist!");var o=this.body.nodes[t];void 0===(e=this._checkOptions(e,o)).clusterNodeProperties.x&&(e.clusterNodeProperties.x=o.x),void 0===e.clusterNodeProperties.y&&(e.clusterNodeProperties.y=o.y),void 0===e.clusterNodeProperties.fixed&&(e.clusterNodeProperties.fixed={},e.clusterNodeProperties.fixed.x=o.options.fixed.x,e.clusterNodeProperties.fixed.y=o.options.fixed.y);var r={},s={},a=o.id,h=xI.cloneOptions(o);r[a]=o;for(var l=0;l<o.edges.length;l++){var d=o.edges[l];if(void 0===this.clusteredEdges[d.id]){var c=this._getConnectedId(d,a);if(void 0===this.clusteredNodes[c])if(c!==a){if(void 0===e.joinCondition)s[d.id]=d,r[c]=this.body.nodes[c];else{var u=xI.cloneOptions(this.body.nodes[c]);!0===e.joinCondition(h,u)&&(s[d.id]=d,r[c]=this.body.nodes[c]);}}else s[d.id]=d;}}var f=jf(i=Hf(r)).call(i,function(t){return r[t].id;});for(var p in r)if(Object.prototype.hasOwnProperty.call(r,p))for(var v=r[p],g=0;g<v.edges.length;g++){var y=v.edges[g];lg(f).call(f,this._getConnectedId(y,v.id))>-1&&(s[y.id]=y);}this._cluster(r,s,e,n);}},{key:"_createClusterEdges",value:function value(t,e,i,n){for(var o,r,s,a,h,l,d=Hf(t),c=[],u=0;u<d.length;u++){s=t[r=d[u]];for(var f=0;f<s.edges.length;f++)o=s.edges[f],void 0===this.clusteredEdges[o.id]&&(o.toId==o.fromId?e[o.id]=o:o.toId==r?(a=i.id,l=h=o.fromId):(a=o.toId,h=i.id,l=a),void 0===t[l]&&c.push({edge:o,fromId:h,toId:a}));}for(var p=[],v=function v(t){for(var e=0;e<p.length;e++){var i=p[e],n=t.fromId===i.fromId&&t.toId===i.toId,o=t.fromId===i.toId&&t.toId===i.fromId;if(n||o)return i;}return null;},g=0;g<c.length;g++){var y=c[g],m=y.edge,b=v(y);null===b?(b=this._createClusteredEdge(y.fromId,y.toId,m,n),p.push(b)):b.clusteringEdgeReplacingIds.push(m.id),this.body.edges[m.id].edgeReplacedById=b.id,this._backupEdgeOptions(m),m.setOptions({physics:!1});}}},{key:"_checkOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return void 0===t.clusterEdgeProperties&&(t.clusterEdgeProperties={}),void 0===t.clusterNodeProperties&&(t.clusterNodeProperties={}),t;}},{key:"_cluster",value:function value(t,e,i){var n=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&void 0!==this.clusteredNodes[r]&&o.push(r);for(var s=0;s<o.length;++s)delete t[o[s]];if(0!=Hf(t).length&&(1!=Hf(t).length||1==i.clusterNodeProperties.allowSingleNodeCluster)){var a=gb({},i.clusterNodeProperties);if(void 0!==i.processProperties){var h=[];for(var l in t)if(Object.prototype.hasOwnProperty.call(t,l)){var d=xI.cloneOptions(t[l]);h.push(d);}var c=[];for(var u in e)if(Object.prototype.hasOwnProperty.call(e,u)&&"clusterEdge:"!==u.substr(0,12)){var f=xI.cloneOptions(e[u],"edge");c.push(f);}if(!(a=i.processProperties(a,h,c)))throw new Error("The processProperties function does not return properties!");}void 0===a.id&&(a.id="cluster:"+zM());var p=a.id;void 0===a.label&&(a.label="cluster");var v=void 0;void 0===a.x&&(v=this._getClusterPosition(t),a.x=v.x),void 0===a.y&&(void 0===v&&(v=this._getClusterPosition(t)),a.y=v.y),a.id=p;var g=this.body.functions.createNode(a,OI);g.containedNodes=t,g.containedEdges=e,g.clusterEdgeProperties=i.clusterEdgeProperties,this.body.nodes[a.id]=g,this._clusterEdges(t,e,a,i.clusterEdgeProperties),a.id=void 0,!0===n&&this.body.emitter.emit("_dataChanged");}}},{key:"_backupEdgeOptions",value:function value(t){void 0===this.clusteredEdges[t.id]&&(this.clusteredEdges[t.id]={physics:t.options.physics});}},{key:"_restoreEdge",value:function value(t){var e=this.clusteredEdges[t.id];void 0!==e&&(t.setOptions({physics:e.physics}),delete this.clusteredEdges[t.id]);}},{key:"isCluster",value:function value(t){return void 0!==this.body.nodes[t]?!0===this.body.nodes[t].isCluster:(console.error("Node does not exist."),!1);}},{key:"_getClusterPosition",value:function value(t){for(var e,i=Hf(t),n=t[i[0]].x,o=t[i[0]].x,r=t[i[0]].y,s=t[i[0]].y,a=1;a<i.length;a++)n=(e=t[i[a]]).x<n?e.x:n,o=e.x>o?e.x:o,r=e.y<r?e.y:r,s=e.y>s?e.y:s;return{x:.5*(n+o),y:.5*(r+s)};}},{key:"openCluster",value:function value(t,e){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];if(void 0===t)throw new Error("No clusterNodeId supplied to openCluster.");var n=this.body.nodes[t];if(void 0===n)throw new Error("The clusterNodeId supplied to openCluster does not exist.");if(!0!==n.isCluster||void 0===n.containedNodes||void 0===n.containedEdges)throw new Error("The node:"+t+" is not a valid cluster.");var o=this.findNode(t),r=lg(o).call(o,t)-1;if(r>=0){var s=o[r];return this.body.nodes[s]._openChildCluster(t),delete this.body.nodes[t],void(!0===i&&this.body.emitter.emit("_dataChanged"));}var a=n.containedNodes,h=n.containedEdges;if(void 0!==e&&void 0!==e.releaseFunction&&"function"==typeof e.releaseFunction){var l={},d={x:n.x,y:n.y};for(var c in a)if(Object.prototype.hasOwnProperty.call(a,c)){var u=this.body.nodes[c];l[c]={x:u.x,y:u.y};}var f=e.releaseFunction(d,l);for(var p in a)if(Object.prototype.hasOwnProperty.call(a,p)){var v=this.body.nodes[p];void 0!==f[p]&&(v.x=void 0===f[p].x?n.x:f[p].x,v.y=void 0===f[p].y?n.y:f[p].y);}}else kb(a,function(t){!1===t.options.fixed.x&&(t.x=n.x),!1===t.options.fixed.y&&(t.y=n.y);});for(var g in a)if(Object.prototype.hasOwnProperty.call(a,g)){var y=this.body.nodes[g];y.vx=n.vx,y.vy=n.vy,y.setOptions({physics:!0}),delete this.clusteredNodes[g];}for(var m=[],b=0;b<n.edges.length;b++)m.push(n.edges[b]);for(var w=0;w<m.length;w++){for(var k=m[w],_=this._getConnectedId(k,t),x=this.clusteredNodes[_],E=0;E<k.clusteringEdgeReplacingIds.length;E++){var O=k.clusteringEdgeReplacingIds[E],C=this.body.edges[O];if(void 0!==C)if(void 0!==x){var S=this.body.nodes[x.clusterId];S.containedEdges[C.id]=C,delete h[C.id];var T=C.fromId,M=C.toId;C.toId==_?M=x.clusterId:T=x.clusterId,this._createClusteredEdge(T,M,C,S.clusterEdgeProperties,{hidden:!1,physics:!0});}else this._restoreEdge(C);}k.remove();}for(var P in h)Object.prototype.hasOwnProperty.call(h,P)&&this._restoreEdge(h[P]);delete this.body.nodes[t],!0===i&&this.body.emitter.emit("_dataChanged");}},{key:"getNodesInCluster",value:function value(t){var e=[];if(!0===this.isCluster(t)){var i=this.body.nodes[t].containedNodes;for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&e.push(this.body.nodes[n].id);}return e;}},{key:"findNode",value:function value(t){for(var e,i=[],n=0;void 0!==this.clusteredNodes[t]&&n<100;){if(void 0===(e=this.body.nodes[t]))return[];i.push(e.id),t=this.clusteredNodes[t].clusterId,n++;}return void 0===(e=this.body.nodes[t])?[]:(i.push(e.id),vp(i).call(i),i);}},{key:"updateClusteredNode",value:function value(t,e){if(void 0===t)throw new Error("No clusteredNodeId supplied to updateClusteredNode.");if(void 0===e)throw new Error("No newOptions supplied to updateClusteredNode.");if(void 0===this.body.nodes[t])throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");this.body.nodes[t].setOptions(e),this.body.emitter.emit("_dataChanged");}},{key:"updateEdge",value:function value(t,e){if(void 0===t)throw new Error("No startEdgeId supplied to updateEdge.");if(void 0===e)throw new Error("No newOptions supplied to updateEdge.");if(void 0===this.body.edges[t])throw new Error("The startEdgeId supplied to updateEdge does not exist.");for(var i=this.getClusteredEdges(t),n=0;n<i.length;n++){this.body.edges[i[n]].setOptions(e);}this.body.emitter.emit("_dataChanged");}},{key:"getClusteredEdges",value:function value(t){for(var e=[],i=0;void 0!==t&&void 0!==this.body.edges[t]&&i<100;)e.push(this.body.edges[t].id),t=this.body.edges[t].edgeReplacedById,i++;return vp(e).call(e),e;}},{key:"getBaseEdge",value:function value(t){return this.getBaseEdges(t)[0];}},{key:"getBaseEdges",value:function value(t){for(var e=[t],i=[],n=[],o=0;e.length>0&&o<100;){var r=e.pop();if(void 0!==r){var s=this.body.edges[r];if(void 0!==s){o++;var a=s.clusteringEdgeReplacingIds;if(void 0===a)n.push(r);else for(var h=0;h<a.length;++h){var l=a[h];-1===lg(e).call(e,a)&&-1===lg(i).call(i,a)&&e.push(l);}i.push(r);}}}return n;}},{key:"_getConnectedId",value:function value(t,e){return t.toId!=e?t.toId:(t.fromId,t.fromId);}},{key:"_getHubSize",value:function value(){for(var t=0,e=0,i=0,n=0,o=0;o<this.body.nodeIndices.length;o++){var r=this.body.nodes[this.body.nodeIndices[o]];r.edges.length>n&&(n=r.edges.length),t+=r.edges.length,e+=Math.pow(r.edges.length,2),i+=1;}t/=i;var s=(e/=i)-Math.pow(t,2),a=Math.sqrt(s),h=Math.floor(t+2*a);return h>n&&(h=n),h;}},{key:"_createClusteredEdge",value:function value(t,e,i,n,o){var r=xI.cloneOptions(i,"edge");gb(r,n),r.from=t,r.to=e,r.id="clusterEdge:"+zM(),void 0!==o&&gb(r,o);var s=this.body.functions.createEdge(r);return s.clusteringEdgeReplacingIds=[i.id],s.connect(),this.body.edges[s.id]=s,s;}},{key:"_clusterEdges",value:function value(t,e,i,n){if(e instanceof dI){var o=e,r={};r[o.id]=o,e=r;}if(t instanceof fD){var s=t,a={};a[s.id]=s,t=a;}if(null==i)throw new Error("_clusterEdges: parameter clusterNode required");for(var h in void 0===n&&(n=i.clusterEdgeProperties),this._createClusterEdges(t,e,i,n),e)if(Object.prototype.hasOwnProperty.call(e,h)&&void 0!==this.body.edges[h]){var l=this.body.edges[h];this._backupEdgeOptions(l),l.setOptions({physics:!1});}for(var d in t)Object.prototype.hasOwnProperty.call(t,d)&&(this.clusteredNodes[d]={clusterId:i.id,node:this.body.nodes[d]},this.body.nodes[d].setOptions({physics:!1}));}},{key:"_getClusterNodeForNode",value:function value(t){if(void 0!==t){var e=this.clusteredNodes[t];if(void 0!==e){var i=e.clusterId;if(void 0!==i)return this.body.nodes[i];}}}},{key:"_filter",value:function value(t,e){var i=[];return kb(t,function(t){e(t)&&i.push(t);}),i;}},{key:"_updateState",value:function value(){var t,e=this,i=[],n={},o=function o(t){kb(e.body.nodes,function(e){!0===e.isCluster&&t(e);});};for(t in this.clusteredNodes){if(Object.prototype.hasOwnProperty.call(this.clusteredNodes,t))void 0===this.body.nodes[t]&&i.push(t);}o(function(t){for(var e=0;e<i.length;e++)delete t.containedNodes[i[e]];});for(var r=0;r<i.length;r++)delete this.clusteredNodes[i[r]];kb(this.clusteredEdges,function(t){var i=e.body.edges[t];void 0!==i&&i.endPointsValid()||(n[t]=t);}),o(function(t){kb(t.containedEdges,function(t,e){t.endPointsValid()||n[e]||(n[e]=e);});}),kb(this.body.edges,function(t,i){var o=!0,r=t.clusteringEdgeReplacingIds;if(void 0!==r){var s=0;kb(r,function(t){var i=e.body.edges[t];void 0!==i&&i.endPointsValid()&&(s+=1);}),o=s>0;}t.endPointsValid()&&o||(n[i]=i);}),o(function(t){kb(n,function(i){delete t.containedEdges[i],kb(t.edges,function(o,r){o.id!==i?o.clusteringEdgeReplacingIds=e._filter(o.clusteringEdgeReplacingIds,function(t){return!n[t];}):t.edges[r]=null;}),t.edges=e._filter(t.edges,function(t){return null!==t;});});}),kb(n,function(t){delete e.clusteredEdges[t];}),kb(n,function(t){delete e.body.edges[t];}),kb(Hf(this.body.edges),function(t){var i=e.body.edges[t],n=e._isClusteredNode(i.fromId)||e._isClusteredNode(i.toId);if(n!==e._isClusteredEdge(i.id))if(n){var o=e._getClusterNodeForNode(i.fromId);void 0!==o&&e._clusterEdges(e.body.nodes[i.fromId],i,o);var r=e._getClusterNodeForNode(i.toId);void 0!==r&&e._clusterEdges(e.body.nodes[i.toId],i,r);}else delete e._clusterEdges[t],e._restoreEdge(i);});for(var s=!1,a=!0,h=function h(){var t=[];o(function(e){var i=Hf(e.containedNodes).length,n=!0===e.options.allowSingleNodeCluster;(n&&i<1||!n&&i<2)&&t.push(e.id);});for(var i=0;i<t.length;++i)e.openCluster(t[i],{},!1);a=t.length>0,s=s||a;};a;)h();s&&this._updateState();}},{key:"_isClusteredNode",value:function value(t){return void 0!==this.clusteredNodes[t];}},{key:"_isClusteredEdge",value:function value(t){return void 0!==this.clusteredEdges[t];}}]),t;}();var SI=function(){function t(e,i){var n;ph(this,t),void 0!==window&&(n=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame),window.requestAnimationFrame=void 0===n?function(t){t();}:n,this.body=e,this.canvas=i,this.redrawRequested=!1,this.renderTimer=void 0,this.requiresTimeout=!0,this.renderingActive=!1,this.renderRequests=0,this.allowRedraw=!0,this.dragging=!1,this.zooming=!1,this.options={},this.defaultOptions={hideEdgesOnDrag:!1,hideEdgesOnZoom:!1,hideNodesOnDrag:!1},bn(this.options,this.defaultOptions),this._determineBrowserMethod(),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t,e=this;this.body.emitter.on("dragStart",function(){e.dragging=!0;}),this.body.emitter.on("dragEnd",function(){e.dragging=!1;}),this.body.emitter.on("zoom",function(){e.zooming=!0,window.clearTimeout(e.zoomTimeoutId),e.zoomTimeoutId=jg(function(){var t;e.zooming=!1,Hn(t=e._requestRedraw).call(t,e)();},250);}),this.body.emitter.on("_resizeNodes",function(){e._resizeNodes();}),this.body.emitter.on("_redraw",function(){!1===e.renderingActive&&e._redraw();}),this.body.emitter.on("_blockRedraw",function(){e.allowRedraw=!1;}),this.body.emitter.on("_allowRedraw",function(){e.allowRedraw=!0,e.redrawRequested=!1;}),this.body.emitter.on("_requestRedraw",Hn(t=this._requestRedraw).call(t,this)),this.body.emitter.on("_startRendering",function(){e.renderRequests+=1,e.renderingActive=!0,e._startRendering();}),this.body.emitter.on("_stopRendering",function(){e.renderRequests-=1,e.renderingActive=e.renderRequests>0,e.renderTimer=void 0;}),this.body.emitter.on("destroy",function(){e.renderRequests=0,e.allowRedraw=!1,e.renderingActive=!1,!0===e.requiresTimeout?clearTimeout(e.renderTimer):window.cancelAnimationFrame(e.renderTimer),e.body.emitter.off();});}},{key:"setOptions",value:function value(t){if(void 0!==t){pb(["hideEdgesOnDrag","hideEdgesOnZoom","hideNodesOnDrag"],this.options,t);}}},{key:"_requestNextFrame",value:function value(t,e){if("undefined"!=typeof window){var i,n=window;return!0===this.requiresTimeout?i=jg(t,e):n.requestAnimationFrame&&(i=n.requestAnimationFrame(t)),i;}}},{key:"_startRendering",value:function value(){var t;!0===this.renderingActive&&void 0===this.renderTimer&&(this.renderTimer=this._requestNextFrame(Hn(t=this._renderStep).call(t,this),this.simulationInterval));}},{key:"_renderStep",value:function value(){!0===this.renderingActive&&(this.renderTimer=void 0,!0===this.requiresTimeout&&this._startRendering(),this._redraw(),!1===this.requiresTimeout&&this._startRendering());}},{key:"redraw",value:function value(){this.body.emitter.emit("setSize"),this._redraw();}},{key:"_requestRedraw",value:function value(){var t=this;!0!==this.redrawRequested&&!1===this.renderingActive&&!0===this.allowRedraw&&(this.redrawRequested=!0,this._requestNextFrame(function(){t._redraw(!1);},0));}},{key:"_redraw",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(!0===this.allowRedraw){this.body.emitter.emit("initRedraw"),this.redrawRequested=!1;var e={drawExternalLabels:null};0!==this.canvas.frame.canvas.width&&0!==this.canvas.frame.canvas.height||this.canvas.setSize(),this.canvas.setTransform();var i=this.canvas.getContext(),n=this.canvas.frame.canvas.clientWidth,o=this.canvas.frame.canvas.clientHeight;if(i.clearRect(0,0,n,o),0===this.canvas.frame.clientWidth)return;if(i.save(),i.translate(this.body.view.translation.x,this.body.view.translation.y),i.scale(this.body.view.scale,this.body.view.scale),i.beginPath(),this.body.emitter.emit("beforeDrawing",i),i.closePath(),!1===t&&(!1===this.dragging||!0===this.dragging&&!1===this.options.hideEdgesOnDrag)&&(!1===this.zooming||!0===this.zooming&&!1===this.options.hideEdgesOnZoom)&&this._drawEdges(i),!1===this.dragging||!0===this.dragging&&!1===this.options.hideNodesOnDrag){var r=this._drawNodes(i,t).drawExternalLabels;e.drawExternalLabels=r;}!1===t&&(!1===this.dragging||!0===this.dragging&&!1===this.options.hideEdgesOnDrag)&&(!1===this.zooming||!0===this.zooming&&!1===this.options.hideEdgesOnZoom)&&this._drawArrows(i),null!=e.drawExternalLabels&&e.drawExternalLabels(),!1===t&&this._drawSelectionBox(i),i.beginPath(),this.body.emitter.emit("afterDrawing",i),i.closePath(),i.restore(),!0===t&&i.clearRect(0,0,n,o);}}},{key:"_resizeNodes",value:function value(){this.canvas.setTransform();var t=this.canvas.getContext();t.save(),t.translate(this.body.view.translation.x,this.body.view.translation.y),t.scale(this.body.view.scale,this.body.view.scale);var e,i=this.body.nodes;for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&((e=i[n]).resize(t),e.updateBoundingBox(t,e.selected));t.restore();}},{key:"_drawNodes",value:function value(t){for(var e,i,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=this.body.nodes,r=this.body.nodeIndices,s=[],a=[],h=this.canvas.DOMtoCanvas({x:-20,y:-20}),l=this.canvas.DOMtoCanvas({x:this.canvas.frame.canvas.clientWidth+20,y:this.canvas.frame.canvas.clientHeight+20}),d={top:h.y,left:h.x,bottom:l.y,right:l.x},c=[],u=0;u<r.length;u++)if((e=o[r[u]]).hover)a.push(r[u]);else if(e.isSelected())s.push(r[u]);else if(!0===n){var f=e.draw(t);null!=f.drawExternalLabel&&c.push(f.drawExternalLabel);}else if(!0===e.isBoundingBoxOverlappingWith(d)){var p=e.draw(t);null!=p.drawExternalLabel&&c.push(p.drawExternalLabel);}else e.updateBoundingBox(t,e.selected);var v=s.length,g=a.length;for(i=0;i<v;i++){var y=(e=o[s[i]]).draw(t);null!=y.drawExternalLabel&&c.push(y.drawExternalLabel);}for(i=0;i<g;i++){var m=(e=o[a[i]]).draw(t);null!=m.drawExternalLabel&&c.push(m.drawExternalLabel);}return{drawExternalLabels:function drawExternalLabels(){for(var t=0,e=c;t<e.length;t++){(0,e[t])();}}};}},{key:"_drawEdges",value:function value(t){for(var e=this.body.edges,i=this.body.edgeIndices,n=0;n<i.length;n++){var o=e[i[n]];!0===o.connected&&o.draw(t);}}},{key:"_drawArrows",value:function value(t){for(var e=this.body.edges,i=this.body.edgeIndices,n=0;n<i.length;n++){var o=e[i[n]];!0===o.connected&&o.drawArrows(t);}}},{key:"_determineBrowserMethod",value:function value(){if("undefined"!=typeof window){var t=navigator.userAgent.toLowerCase();this.requiresTimeout=!1,(-1!=lg(t).call(t,"msie 9.0")||-1!=lg(t).call(t,"safari")&&lg(t).call(t,"chrome")<=-1)&&(this.requiresTimeout=!0);}else this.requiresTimeout=!0;}},{key:"_drawSelectionBox",value:function value(t){if(this.body.selectionBox.show){t.beginPath();var e=this.body.selectionBox.position.end.x-this.body.selectionBox.position.start.x,i=this.body.selectionBox.position.end.y-this.body.selectionBox.position.start.y;t.rect(this.body.selectionBox.position.start.x,this.body.selectionBox.position.start.y,e,i),t.fillStyle="rgba(151, 194, 252, 0.2)",t.fillRect(this.body.selectionBox.position.start.x,this.body.selectionBox.position.start.y,e,i),t.strokeStyle="rgba(151, 194, 252, 1)",t.stroke();}else t.closePath();}}]),t;}(),TI=i(et.setInterval);function MI(t,e){e.inputHandler=function(t){t.isFirst&&e(t);},t.on("hammer.input",e.inputHandler);}function PI(t,e){return e.inputHandler=function(t){t.isFinal&&e(t);},t.on("hammer.input",e.inputHandler);}var DI=function(){function t(e){ph(this,t),this.body=e,this.pixelRatio=1,this.cameraState={},this.initialized=!1,this.canvasViewCenter={},this._cleanupCallbacks=[],this.options={},this.defaultOptions={autoResize:!0,height:"100%",width:"100%"},bn(this.options,this.defaultOptions),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t,e=this;this.body.emitter.once("resize",function(t){0!==t.width&&(e.body.view.translation.x=.5*t.width),0!==t.height&&(e.body.view.translation.y=.5*t.height);}),this.body.emitter.on("setSize",Hn(t=this.setSize).call(t,this)),this.body.emitter.on("destroy",function(){e.hammerFrame.destroy(),e.hammer.destroy(),e._cleanUp();});}},{key:"setOptions",value:function value(t){var e=this;if(void 0!==t){pb(["width","height","autoResize"],this.options,t);}if(this._cleanUp(),!0===this.options.autoResize){var i;if(window.ResizeObserver){var n=new ResizeObserver(function(){!0===e.setSize()&&e.body.emitter.emit("_requestRedraw");}),o=this.frame;n.observe(o),this._cleanupCallbacks.push(function(){n.unobserve(o);});}else{var r=TI(function(){!0===e.setSize()&&e.body.emitter.emit("_requestRedraw");},1e3);this._cleanupCallbacks.push(function(){clearInterval(r);});}var s=Hn(i=this._onResize).call(i,this);window.addEventListener("resize",s),this._cleanupCallbacks.push(function(){window.removeEventListener("resize",s);});}}},{key:"_cleanUp",value:function value(){var t,e,i;op(t=vp(e=Ap(i=this._cleanupCallbacks).call(i,0)).call(e)).call(t,function(t){try{t();}catch(t){console.error(t);}});}},{key:"_onResize",value:function value(){this.setSize(),this.body.emitter.emit("_redraw");}},{key:"_getCameraState",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.pixelRatio;!0===this.initialized&&(this.cameraState.previousWidth=this.frame.canvas.width/t,this.cameraState.previousHeight=this.frame.canvas.height/t,this.cameraState.scale=this.body.view.scale,this.cameraState.position=this.DOMtoCanvas({x:.5*this.frame.canvas.width/t,y:.5*this.frame.canvas.height/t}));}},{key:"_setCameraState",value:function value(){if(void 0!==this.cameraState.scale&&0!==this.frame.canvas.clientWidth&&0!==this.frame.canvas.clientHeight&&0!==this.pixelRatio&&this.cameraState.previousWidth>0&&this.cameraState.previousHeight>0){var t=this.frame.canvas.width/this.pixelRatio/this.cameraState.previousWidth,e=this.frame.canvas.height/this.pixelRatio/this.cameraState.previousHeight,i=this.cameraState.scale;1!=t&&1!=e?i=.5*this.cameraState.scale*(t+e):1!=t?i=this.cameraState.scale*t:1!=e&&(i=this.cameraState.scale*e),this.body.view.scale=i;var n=this.DOMtoCanvas({x:.5*this.frame.canvas.clientWidth,y:.5*this.frame.canvas.clientHeight}),o={x:n.x-this.cameraState.position.x,y:n.y-this.cameraState.position.y};this.body.view.translation.x+=o.x*this.body.view.scale,this.body.view.translation.y+=o.y*this.body.view.scale;}}},{key:"_prepareValue",value:function value(t){if("number"==typeof t)return t+"px";if("string"==typeof t){if(-1!==lg(t).call(t,"%")||-1!==lg(t).call(t,"px"))return t;if(-1===lg(t).call(t,"%"))return t+"px";}throw new Error("Could not use the value supplied for width or height:"+t);}},{key:"_create",value:function value(){for(;this.body.container.hasChildNodes();)this.body.container.removeChild(this.body.container.firstChild);if(this.frame=document.createElement("div"),this.frame.className="vis-network",this.frame.style.position="relative",this.frame.style.overflow="hidden",this.frame.tabIndex=0,this.frame.canvas=document.createElement("canvas"),this.frame.canvas.style.position="relative",this.frame.appendChild(this.frame.canvas),this.frame.canvas.getContext)this._setPixelRatio(),this.setTransform();else{var t=document.createElement("DIV");t.style.color="red",t.style.fontWeight="bold",t.style.padding="10px",t.innerText="Error: your browser does not support HTML canvas",this.frame.canvas.appendChild(t);}this.body.container.appendChild(this.frame),this.body.view.scale=1,this.body.view.translation={x:.5*this.frame.canvas.clientWidth,y:.5*this.frame.canvas.clientHeight},this._bindHammer();}},{key:"_bindHammer",value:function value(){var t=this;void 0!==this.hammer&&this.hammer.destroy(),this.drag={},this.pinch={},this.hammer=new Qb(this.frame.canvas),this.hammer.get("pinch").set({enable:!0}),this.hammer.get("pan").set({threshold:5,direction:Qb.DIRECTION_ALL}),MI(this.hammer,function(e){t.body.eventListeners.onTouch(e);}),this.hammer.on("tap",function(e){t.body.eventListeners.onTap(e);}),this.hammer.on("doubletap",function(e){t.body.eventListeners.onDoubleTap(e);}),this.hammer.on("press",function(e){t.body.eventListeners.onHold(e);}),this.hammer.on("panstart",function(e){t.body.eventListeners.onDragStart(e);}),this.hammer.on("panmove",function(e){t.body.eventListeners.onDrag(e);}),this.hammer.on("panend",function(e){t.body.eventListeners.onDragEnd(e);}),this.hammer.on("pinch",function(e){t.body.eventListeners.onPinch(e);}),this.frame.canvas.addEventListener("wheel",function(e){t.body.eventListeners.onMouseWheel(e);}),this.frame.canvas.addEventListener("mousemove",function(e){t.body.eventListeners.onMouseMove(e);}),this.frame.canvas.addEventListener("contextmenu",function(e){t.body.eventListeners.onContext(e);}),this.hammerFrame=new Qb(this.frame),PI(this.hammerFrame,function(e){t.body.eventListeners.onRelease(e);});}},{key:"setSize",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.options.width,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.options.height;t=this._prepareValue(t),e=this._prepareValue(e);var i=!1,n=this.frame.canvas.width,o=this.frame.canvas.height,r=this.pixelRatio;if(this._setPixelRatio(),t!=this.options.width||e!=this.options.height||this.frame.style.width!=t||this.frame.style.height!=e)this._getCameraState(r),this.frame.style.width=t,this.frame.style.height=e,this.frame.canvas.style.width="100%",this.frame.canvas.style.height="100%",this.frame.canvas.width=Math.round(this.frame.canvas.clientWidth*this.pixelRatio),this.frame.canvas.height=Math.round(this.frame.canvas.clientHeight*this.pixelRatio),this.options.width=t,this.options.height=e,this.canvasViewCenter={x:.5*this.frame.clientWidth,y:.5*this.frame.clientHeight},i=!0;else{var s=Math.round(this.frame.canvas.clientWidth*this.pixelRatio),a=Math.round(this.frame.canvas.clientHeight*this.pixelRatio);this.frame.canvas.width===s&&this.frame.canvas.height===a||this._getCameraState(r),this.frame.canvas.width!==s&&(this.frame.canvas.width=s,i=!0),this.frame.canvas.height!==a&&(this.frame.canvas.height=a,i=!0);}return!0===i&&(this.body.emitter.emit("resize",{width:Math.round(this.frame.canvas.width/this.pixelRatio),height:Math.round(this.frame.canvas.height/this.pixelRatio),oldWidth:Math.round(n/this.pixelRatio),oldHeight:Math.round(o/this.pixelRatio)}),this._setCameraState()),this.initialized=!0,i;}},{key:"getContext",value:function value(){return this.frame.canvas.getContext("2d");}},{key:"_determinePixelRatio",value:function value(){var t=this.getContext();if(void 0===t)throw new Error("Could not get canvax context");var e=1;return"undefined"!=typeof window&&(e=window.devicePixelRatio||1),e/(t.webkitBackingStorePixelRatio||t.mozBackingStorePixelRatio||t.msBackingStorePixelRatio||t.oBackingStorePixelRatio||t.backingStorePixelRatio||1);}},{key:"_setPixelRatio",value:function value(){this.pixelRatio=this._determinePixelRatio();}},{key:"setTransform",value:function value(){var t=this.getContext();if(void 0===t)throw new Error("Could not get canvax context");t.setTransform(this.pixelRatio,0,0,this.pixelRatio,0,0);}},{key:"_XconvertDOMtoCanvas",value:function value(t){return(t-this.body.view.translation.x)/this.body.view.scale;}},{key:"_XconvertCanvasToDOM",value:function value(t){return t*this.body.view.scale+this.body.view.translation.x;}},{key:"_YconvertDOMtoCanvas",value:function value(t){return(t-this.body.view.translation.y)/this.body.view.scale;}},{key:"_YconvertCanvasToDOM",value:function value(t){return t*this.body.view.scale+this.body.view.translation.y;}},{key:"canvasToDOM",value:function value(t){return{x:this._XconvertCanvasToDOM(t.x),y:this._YconvertCanvasToDOM(t.y)};}},{key:"DOMtoCanvas",value:function value(t){return{x:this._XconvertDOMtoCanvas(t.x),y:this._YconvertDOMtoCanvas(t.y)};}}]),t;}();var II=function(){function t(e,i){var n,o,r=this;ph(this,t),this.body=e,this.canvas=i,this.animationSpeed=1/this.renderRefreshRate,this.animationEasingFunction="easeInOutQuint",this.easingTime=0,this.sourceScale=0,this.targetScale=0,this.sourceTranslation=0,this.targetTranslation=0,this.lockedOnNodeId=void 0,this.lockedOnNodeOffset=void 0,this.touchTime=0,this.viewFunction=void 0,this.body.emitter.on("fit",Hn(n=this.fit).call(n,this)),this.body.emitter.on("animationFinished",function(){r.body.emitter.emit("_stopRendering");}),this.body.emitter.on("unlockNode",Hn(o=this.releaseNode).call(o,this));}return xu(t,[{key:"setOptions",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.options=t;}},{key:"fit",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];t=function(t,e){var i=bn({nodes:e,minZoomLevel:Number.MIN_VALUE,maxZoomLevel:1},null!=t?t:{});if(!Df(i.nodes))throw new TypeError("Nodes has to be an array of ids.");if(0===i.nodes.length&&(i.nodes=e),!("number"==typeof i.minZoomLevel&&i.minZoomLevel>0))throw new TypeError("Min zoom level has to be a number higher than zero.");if(!("number"==typeof i.maxZoomLevel&&i.minZoomLevel<=i.maxZoomLevel))throw new TypeError("Max zoom level has to be a number higher than min zoom level.");return i;}(t,this.body.nodeIndices);var i,n,o=this.canvas.frame.canvas.clientWidth,r=this.canvas.frame.canvas.clientHeight;if(0===o||0===r)n=1,i=xI.getRange(this.body.nodes,t.nodes);else if(!0===e){var s=0;for(var a in this.body.nodes){if(Object.prototype.hasOwnProperty.call(this.body.nodes,a))!0===this.body.nodes[a].predefinedPosition&&(s+=1);}if(s>.5*this.body.nodeIndices.length)return void this.fit(t,!1);i=xI.getRange(this.body.nodes,t.nodes),n=12.662/(this.body.nodeIndices.length+7.4147)+.0964822,n*=Math.min(o/600,r/600);}else{this.body.emitter.emit("_resizeNodes"),i=xI.getRange(this.body.nodes,t.nodes);var h=o/(1.1*Math.abs(i.maxX-i.minX)),l=r/(1.1*Math.abs(i.maxY-i.minY));n=h<=l?h:l;}n>t.maxZoomLevel?n=t.maxZoomLevel:n<t.minZoomLevel&&(n=t.minZoomLevel);var d={position:xI.findCenter(i),scale:n,animation:t.animation};this.moveTo(d);}},{key:"focus",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(void 0!==this.body.nodes[t]){var i={x:this.body.nodes[t].x,y:this.body.nodes[t].y};e.position=i,e.lockedOnNode=t,this.moveTo(e);}else console.error("Node: "+t+" cannot be found.");}},{key:"moveTo",value:function value(t){if(void 0!==t){if(null!=t.offset){if(null!=t.offset.x){if(t.offset.x=+t.offset.x,!g_(t.offset.x))throw new TypeError('The option "offset.x" has to be a finite number.');}else t.offset.x=0;if(null!=t.offset.y){if(t.offset.y=+t.offset.y,!g_(t.offset.y))throw new TypeError('The option "offset.y" has to be a finite number.');}else t.offset.x=0;}else t.offset={x:0,y:0};if(null!=t.position){if(null!=t.position.x){if(t.position.x=+t.position.x,!g_(t.position.x))throw new TypeError('The option "position.x" has to be a finite number.');}else t.position.x=0;if(null!=t.position.y){if(t.position.y=+t.position.y,!g_(t.position.y))throw new TypeError('The option "position.y" has to be a finite number.');}else t.position.x=0;}else t.position=this.getViewPosition();if(null!=t.scale){if(t.scale=+t.scale,!(t.scale>0))throw new TypeError('The option "scale" has to be a number greater than zero.');}else t.scale=this.body.view.scale;void 0===t.animation&&(t.animation={duration:0}),!1===t.animation&&(t.animation={duration:0}),!0===t.animation&&(t.animation={}),void 0===t.animation.duration&&(t.animation.duration=1e3),void 0===t.animation.easingFunction&&(t.animation.easingFunction="easeInOutQuad"),this.animateView(t);}else t={};}},{key:"animateView",value:function value(t){if(void 0!==t){this.animationEasingFunction=t.animation.easingFunction,this.releaseNode(),!0===t.locked&&(this.lockedOnNodeId=t.lockedOnNode,this.lockedOnNodeOffset=t.offset),0!=this.easingTime&&this._transitionRedraw(!0),this.sourceScale=this.body.view.scale,this.sourceTranslation=this.body.view.translation,this.targetScale=t.scale,this.body.view.scale=this.targetScale;var e,i,n=this.canvas.DOMtoCanvas({x:.5*this.canvas.frame.canvas.clientWidth,y:.5*this.canvas.frame.canvas.clientHeight}),o=n.x-t.position.x,r=n.y-t.position.y;if(this.targetTranslation={x:this.sourceTranslation.x+o*this.targetScale+t.offset.x,y:this.sourceTranslation.y+r*this.targetScale+t.offset.y},0===t.animation.duration){if(null!=this.lockedOnNodeId)this.viewFunction=Hn(e=this._lockedRedraw).call(e,this),this.body.emitter.on("initRedraw",this.viewFunction);else this.body.view.scale=this.targetScale,this.body.view.translation=this.targetTranslation,this.body.emitter.emit("_requestRedraw");}else this.animationSpeed=1/(60*t.animation.duration*.001)||1/60,this.animationEasingFunction=t.animation.easingFunction,this.viewFunction=Hn(i=this._transitionRedraw).call(i,this),this.body.emitter.on("initRedraw",this.viewFunction),this.body.emitter.emit("_startRendering");}}},{key:"_lockedRedraw",value:function value(){var t=this.body.nodes[this.lockedOnNodeId].x,e=this.body.nodes[this.lockedOnNodeId].y,i=this.canvas.DOMtoCanvas({x:.5*this.canvas.frame.canvas.clientWidth,y:.5*this.canvas.frame.canvas.clientHeight}),n=i.x-t,o=i.y-e,r=this.body.view.translation,s={x:r.x+n*this.body.view.scale+this.lockedOnNodeOffset.x,y:r.y+o*this.body.view.scale+this.lockedOnNodeOffset.y};this.body.view.translation=s;}},{key:"releaseNode",value:function value(){void 0!==this.lockedOnNodeId&&void 0!==this.viewFunction&&(this.body.emitter.off("initRedraw",this.viewFunction),this.lockedOnNodeId=void 0,this.lockedOnNodeOffset=void 0);}},{key:"_transitionRedraw",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];this.easingTime+=this.animationSpeed,this.easingTime=!0===t?1:this.easingTime;var e=jb[this.animationEasingFunction](this.easingTime);if(this.body.view.scale=this.sourceScale+(this.targetScale-this.sourceScale)*e,this.body.view.translation={x:this.sourceTranslation.x+(this.targetTranslation.x-this.sourceTranslation.x)*e,y:this.sourceTranslation.y+(this.targetTranslation.y-this.sourceTranslation.y)*e},this.easingTime>=1){var i;if(this.body.emitter.off("initRedraw",this.viewFunction),this.easingTime=0,null!=this.lockedOnNodeId)this.viewFunction=Hn(i=this._lockedRedraw).call(i,this),this.body.emitter.on("initRedraw",this.viewFunction);this.body.emitter.emit("animationFinished");}}},{key:"getScale",value:function value(){return this.body.view.scale;}},{key:"getViewPosition",value:function value(){return this.canvas.DOMtoCanvas({x:.5*this.canvas.frame.canvas.clientWidth,y:.5*this.canvas.frame.canvas.clientHeight});}}]),t;}();function BI(t){var e,i=t&&t.preventDefault||!1,n=t&&t.container||window,o={},r={keydown:{},keyup:{}},s={};for(e=97;e<=122;e++)s[String.fromCharCode(e)]={code:e-97+65,shift:!1};for(e=65;e<=90;e++)s[String.fromCharCode(e)]={code:e,shift:!0};for(e=0;e<=9;e++)s[""+e]={code:48+e,shift:!1};for(e=1;e<=12;e++)s["F"+e]={code:111+e,shift:!1};for(e=0;e<=9;e++)s["num"+e]={code:96+e,shift:!1};s["num*"]={code:106,shift:!1},s["num+"]={code:107,shift:!1},s["num-"]={code:109,shift:!1},s["num/"]={code:111,shift:!1},s["num."]={code:110,shift:!1},s.left={code:37,shift:!1},s.up={code:38,shift:!1},s.right={code:39,shift:!1},s.down={code:40,shift:!1},s.space={code:32,shift:!1},s.enter={code:13,shift:!1},s.shift={code:16,shift:void 0},s.esc={code:27,shift:!1},s.backspace={code:8,shift:!1},s.tab={code:9,shift:!1},s.ctrl={code:17,shift:!1},s.alt={code:18,shift:!1},s["delete"]={code:46,shift:!1},s.pageup={code:33,shift:!1},s.pagedown={code:34,shift:!1},s["="]={code:187,shift:!1},s["-"]={code:189,shift:!1},s["]"]={code:221,shift:!1},s["["]={code:219,shift:!1};var a=function a(t){l(t,"keydown");},h=function h(t){l(t,"keyup");},l=function l(t,e){if(void 0!==r[e][t.keyCode]){for(var n=r[e][t.keyCode],o=0;o<n.length;o++)(void 0===n[o].shift||1==n[o].shift&&1==t.shiftKey||0==n[o].shift&&0==t.shiftKey)&&n[o].fn(t);1==i&&t.preventDefault();}};return o.bind=function(t,e,i){if(void 0===i&&(i="keydown"),void 0===s[t])throw new Error("unsupported key: "+t);void 0===r[i][s[t].code]&&(r[i][s[t].code]=[]),r[i][s[t].code].push({fn:e,shift:s[t].shift});},o.bindAll=function(t,e){for(var i in void 0===e&&(e="keydown"),s)s.hasOwnProperty(i)&&o.bind(i,t,e);},o.getKey=function(t){for(var e in s)if(s.hasOwnProperty(e)){if(1==t.shiftKey&&1==s[e].shift&&t.keyCode==s[e].code)return e;if(0==t.shiftKey&&0==s[e].shift&&t.keyCode==s[e].code)return e;if(t.keyCode==s[e].code&&"shift"==e)return e;}return"unknown key, currently not supported";},o.unbind=function(t,e,i){if(void 0===i&&(i="keydown"),void 0===s[t])throw new Error("unsupported key: "+t);if(void 0!==e){var n=[],o=r[i][s[t].code];if(void 0!==o)for(var a=0;a<o.length;a++)o[a].fn==e&&o[a].shift==s[t].shift||n.push(r[i][s[t].code][a]);r[i][s[t].code]=n;}else r[i][s[t].code]=[];},o.reset=function(){r={keydown:{},keyup:{}};},o.destroy=function(){r={keydown:{},keyup:{}},n.removeEventListener("keydown",a,!0),n.removeEventListener("keyup",h,!0);},n.addEventListener("keydown",a,!0),n.addEventListener("keyup",h,!0),o;}var NI=Object.freeze({__proto__:null,"default":BI}),FI=function(){function t(e,i){var n=this;ph(this,t),this.body=e,this.canvas=i,this.iconsCreated=!1,this.navigationHammers=[],this.boundFunctions={},this.touchTime=0,this.activated=!1,this.body.emitter.on("activate",function(){n.activated=!0,n.configureKeyboardBindings();}),this.body.emitter.on("deactivate",function(){n.activated=!1,n.configureKeyboardBindings();}),this.body.emitter.on("destroy",function(){void 0!==n.keycharm&&n.keycharm.destroy();}),this.options={};}return xu(t,[{key:"setOptions",value:function value(t){void 0!==t&&(this.options=t,this.create());}},{key:"create",value:function value(){!0===this.options.navigationButtons?!1===this.iconsCreated&&this.loadNavigationElements():!0===this.iconsCreated&&this.cleanNavigation(),this.configureKeyboardBindings();}},{key:"cleanNavigation",value:function value(){if(0!=this.navigationHammers.length){for(var t=0;t<this.navigationHammers.length;t++)this.navigationHammers[t].destroy();this.navigationHammers=[];}this.navigationDOM&&this.navigationDOM.wrapper&&this.navigationDOM.wrapper.parentNode&&this.navigationDOM.wrapper.parentNode.removeChild(this.navigationDOM.wrapper),this.iconsCreated=!1;}},{key:"loadNavigationElements",value:function value(){var t=this;this.cleanNavigation(),this.navigationDOM={};var e=["up","down","left","right","zoomIn","zoomOut","zoomExtends"],i=["_moveUp","_moveDown","_moveLeft","_moveRight","_zoomIn","_zoomOut","_fit"];this.navigationDOM.wrapper=document.createElement("div"),this.navigationDOM.wrapper.className="vis-navigation",this.canvas.frame.appendChild(this.navigationDOM.wrapper);for(var n=0;n<e.length;n++){this.navigationDOM[e[n]]=document.createElement("div"),this.navigationDOM[e[n]].className="vis-button vis-"+e[n],this.navigationDOM.wrapper.appendChild(this.navigationDOM[e[n]]);var o,r,s=new Qb(this.navigationDOM[e[n]]);if("_fit"===i[n])MI(s,Hn(o=this._fit).call(o,this));else MI(s,Hn(r=this.bindToRedraw).call(r,this,i[n]));this.navigationHammers.push(s);}var a=new Qb(this.canvas.frame);PI(a,function(){t._stopMovement();}),this.navigationHammers.push(a),this.iconsCreated=!0;}},{key:"bindToRedraw",value:function value(t){var e;void 0===this.boundFunctions[t]&&(this.boundFunctions[t]=Hn(e=this[t]).call(e,this),this.body.emitter.on("initRedraw",this.boundFunctions[t]),this.body.emitter.emit("_startRendering"));}},{key:"unbindFromRedraw",value:function value(t){void 0!==this.boundFunctions[t]&&(this.body.emitter.off("initRedraw",this.boundFunctions[t]),this.body.emitter.emit("_stopRendering"),delete this.boundFunctions[t]);}},{key:"_fit",value:function value(){new Date().valueOf()-this.touchTime>700&&(this.body.emitter.emit("fit",{duration:700}),this.touchTime=new Date().valueOf());}},{key:"_stopMovement",value:function value(){for(var t in this.boundFunctions)Object.prototype.hasOwnProperty.call(this.boundFunctions,t)&&(this.body.emitter.off("initRedraw",this.boundFunctions[t]),this.body.emitter.emit("_stopRendering"));this.boundFunctions={};}},{key:"_moveUp",value:function value(){this.body.view.translation.y+=this.options.keyboard.speed.y;}},{key:"_moveDown",value:function value(){this.body.view.translation.y-=this.options.keyboard.speed.y;}},{key:"_moveLeft",value:function value(){this.body.view.translation.x+=this.options.keyboard.speed.x;}},{key:"_moveRight",value:function value(){this.body.view.translation.x-=this.options.keyboard.speed.x;}},{key:"_zoomIn",value:function value(){var t=this.body.view.scale,e=this.body.view.scale*(1+this.options.keyboard.speed.zoom),i=this.body.view.translation,n=e/t,o=(1-n)*this.canvas.canvasViewCenter.x+i.x*n,r=(1-n)*this.canvas.canvasViewCenter.y+i.y*n;this.body.view.scale=e,this.body.view.translation={x:o,y:r},this.body.emitter.emit("zoom",{direction:"+",scale:this.body.view.scale,pointer:null});}},{key:"_zoomOut",value:function value(){var t=this.body.view.scale,e=this.body.view.scale/(1+this.options.keyboard.speed.zoom),i=this.body.view.translation,n=e/t,o=(1-n)*this.canvas.canvasViewCenter.x+i.x*n,r=(1-n)*this.canvas.canvasViewCenter.y+i.y*n;this.body.view.scale=e,this.body.view.translation={x:o,y:r},this.body.emitter.emit("zoom",{direction:"-",scale:this.body.view.scale,pointer:null});}},{key:"configureKeyboardBindings",value:function value(){var t,e,i,n,o,r,s,a,h,l,d,c,u,f,p,v,g,y,m,b,w,k,_,x,E=this;(void 0!==this.keycharm&&this.keycharm.destroy(),!0===this.options.keyboard.enabled)&&(!0===this.options.keyboard.bindToWindow?this.keycharm=BI({container:window,preventDefault:!0}):this.keycharm=BI({container:this.canvas.frame,preventDefault:!0}),this.keycharm.reset(),!0===this.activated&&(Hn(t=this.keycharm).call(t,"up",function(){E.bindToRedraw("_moveUp");},"keydown"),Hn(e=this.keycharm).call(e,"down",function(){E.bindToRedraw("_moveDown");},"keydown"),Hn(i=this.keycharm).call(i,"left",function(){E.bindToRedraw("_moveLeft");},"keydown"),Hn(n=this.keycharm).call(n,"right",function(){E.bindToRedraw("_moveRight");},"keydown"),Hn(o=this.keycharm).call(o,"=",function(){E.bindToRedraw("_zoomIn");},"keydown"),Hn(r=this.keycharm).call(r,"num+",function(){E.bindToRedraw("_zoomIn");},"keydown"),Hn(s=this.keycharm).call(s,"num-",function(){E.bindToRedraw("_zoomOut");},"keydown"),Hn(a=this.keycharm).call(a,"-",function(){E.bindToRedraw("_zoomOut");},"keydown"),Hn(h=this.keycharm).call(h,"[",function(){E.bindToRedraw("_zoomOut");},"keydown"),Hn(l=this.keycharm).call(l,"]",function(){E.bindToRedraw("_zoomIn");},"keydown"),Hn(d=this.keycharm).call(d,"pageup",function(){E.bindToRedraw("_zoomIn");},"keydown"),Hn(c=this.keycharm).call(c,"pagedown",function(){E.bindToRedraw("_zoomOut");},"keydown"),Hn(u=this.keycharm).call(u,"up",function(){E.unbindFromRedraw("_moveUp");},"keyup"),Hn(f=this.keycharm).call(f,"down",function(){E.unbindFromRedraw("_moveDown");},"keyup"),Hn(p=this.keycharm).call(p,"left",function(){E.unbindFromRedraw("_moveLeft");},"keyup"),Hn(v=this.keycharm).call(v,"right",function(){E.unbindFromRedraw("_moveRight");},"keyup"),Hn(g=this.keycharm).call(g,"=",function(){E.unbindFromRedraw("_zoomIn");},"keyup"),Hn(y=this.keycharm).call(y,"num+",function(){E.unbindFromRedraw("_zoomIn");},"keyup"),Hn(m=this.keycharm).call(m,"num-",function(){E.unbindFromRedraw("_zoomOut");},"keyup"),Hn(b=this.keycharm).call(b,"-",function(){E.unbindFromRedraw("_zoomOut");},"keyup"),Hn(w=this.keycharm).call(w,"[",function(){E.unbindFromRedraw("_zoomOut");},"keyup"),Hn(k=this.keycharm).call(k,"]",function(){E.unbindFromRedraw("_zoomIn");},"keyup"),Hn(_=this.keycharm).call(_,"pageup",function(){E.unbindFromRedraw("_zoomIn");},"keyup"),Hn(x=this.keycharm).call(x,"pagedown",function(){E.unbindFromRedraw("_zoomOut");},"keyup")));}}]),t;}();function zI(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return AI(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return AI(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n5=0,o=function o(){};return{s:o,n:function n(){return _n5>=t.length?{done:!0}:{done:!1,value:t[_n5++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function AI(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}var jI=function(){function t(e,i,n){var o,r,s,a,h,l,d,c,u,f,p,v,g;ph(this,t),this.body=e,this.canvas=i,this.selectionHandler=n,this.navigationHandler=new FI(e,i),this.body.eventListeners.onTap=Hn(o=this.onTap).call(o,this),this.body.eventListeners.onTouch=Hn(r=this.onTouch).call(r,this),this.body.eventListeners.onDoubleTap=Hn(s=this.onDoubleTap).call(s,this),this.body.eventListeners.onHold=Hn(a=this.onHold).call(a,this),this.body.eventListeners.onDragStart=Hn(h=this.onDragStart).call(h,this),this.body.eventListeners.onDrag=Hn(l=this.onDrag).call(l,this),this.body.eventListeners.onDragEnd=Hn(d=this.onDragEnd).call(d,this),this.body.eventListeners.onMouseWheel=Hn(c=this.onMouseWheel).call(c,this),this.body.eventListeners.onPinch=Hn(u=this.onPinch).call(u,this),this.body.eventListeners.onMouseMove=Hn(f=this.onMouseMove).call(f,this),this.body.eventListeners.onRelease=Hn(p=this.onRelease).call(p,this),this.body.eventListeners.onContext=Hn(v=this.onContext).call(v,this),this.touchTime=0,this.drag={},this.pinch={},this.popup=void 0,this.popupObj=void 0,this.popupTimer=void 0,this.body.functions.getPointer=Hn(g=this.getPointer).call(g,this),this.options={},this.defaultOptions={dragNodes:!0,dragView:!0,hover:!1,keyboard:{enabled:!1,speed:{x:10,y:10,zoom:.02},bindToWindow:!0,autoFocus:!0},navigationButtons:!1,tooltipDelay:300,zoomView:!0,zoomSpeed:1},bn(this.options,this.defaultOptions),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t=this;this.body.emitter.on("destroy",function(){clearTimeout(t.popupTimer),delete t.body.functions.getPointer;});}},{key:"setOptions",value:function value(t){if(void 0!==t){vb(["hideEdgesOnDrag","hideEdgesOnZoom","hideNodesOnDrag","keyboard","multiselect","selectable","selectConnectedEdges"],this.options,t),Ab(this.options,t,"keyboard"),t.tooltip&&(bn(this.options.tooltip,t.tooltip),t.tooltip.color&&(this.options.tooltip.color=Sb(t.tooltip.color)));}this.navigationHandler.setOptions(this.options);}},{key:"getPointer",value:function value(t){return{x:t.x-bb(this.canvas.frame.canvas),y:t.y-wb(this.canvas.frame.canvas)};}},{key:"onTouch",value:function value(t){new Date().valueOf()-this.touchTime>50&&(this.drag.pointer=this.getPointer(t.center),this.drag.pinched=!1,this.pinch.scale=this.body.view.scale,this.touchTime=new Date().valueOf());}},{key:"onTap",value:function value(t){var e=this.getPointer(t.center),i=this.selectionHandler.options.multiselect&&(t.changedPointers[0].ctrlKey||t.changedPointers[0].metaKey);this.checkSelectionChanges(e,i),this.selectionHandler.commitAndEmit(e,t),this.selectionHandler.generateClickEvent("click",t,e);}},{key:"onDoubleTap",value:function value(t){var e=this.getPointer(t.center);this.selectionHandler.generateClickEvent("doubleClick",t,e);}},{key:"onHold",value:function value(t){var e=this.getPointer(t.center),i=this.selectionHandler.options.multiselect;this.checkSelectionChanges(e,i),this.selectionHandler.commitAndEmit(e,t),this.selectionHandler.generateClickEvent("click",t,e),this.selectionHandler.generateClickEvent("hold",t,e);}},{key:"onRelease",value:function value(t){if(new Date().valueOf()-this.touchTime>10){var e=this.getPointer(t.center);this.selectionHandler.generateClickEvent("release",t,e),this.touchTime=new Date().valueOf();}}},{key:"onContext",value:function value(t){var e=this.getPointer({x:t.clientX,y:t.clientY});this.selectionHandler.generateClickEvent("oncontext",t,e);}},{key:"checkSelectionChanges",value:function value(t){!0===(arguments.length>1&&void 0!==arguments[1]&&arguments[1])?this.selectionHandler.selectAdditionalOnPoint(t):this.selectionHandler.selectOnPoint(t);}},{key:"_determineDifference",value:function value(t,e){var i=function i(t,e){for(var i=[],n=0;n<t.length;n++){var o=t[n];-1===lg(e).call(e,o)&&i.push(o);}return i;};return{nodes:i(t.nodes,e.nodes),edges:i(t.edges,e.edges)};}},{key:"onDragStart",value:function value(t){if(!this.drag.dragging){void 0===this.drag.pointer&&this.onTouch(t);var e=this.selectionHandler.getNodeAt(this.drag.pointer);if(this.drag.dragging=!0,this.drag.selection=[],this.drag.translation=bn({},this.body.view.translation),this.drag.nodeId=void 0,t.srcEvent.shiftKey){this.body.selectionBox.show=!0;var i=this.getPointer(t.center);this.body.selectionBox.position.start={x:this.canvas._XconvertDOMtoCanvas(i.x),y:this.canvas._YconvertDOMtoCanvas(i.y)},this.body.selectionBox.position.end={x:this.canvas._XconvertDOMtoCanvas(i.x),y:this.canvas._YconvertDOMtoCanvas(i.y)};}else if(void 0!==e&&!0===this.options.dragNodes){this.drag.nodeId=e.id,!1===e.isSelected()&&this.selectionHandler.setSelection({nodes:[e.id]}),this.selectionHandler.generateClickEvent("dragStart",t,this.drag.pointer);var n,o=zI(this.selectionHandler.getSelectedNodes());try{for(o.s();!(n=o.n()).done;){var r=n.value,s={id:r.id,node:r,x:r.x,y:r.y,xFixed:r.options.fixed.x,yFixed:r.options.fixed.y};r.options.fixed.x=!0,r.options.fixed.y=!0,this.drag.selection.push(s);}}catch(t){o.e(t);}finally{o.f();}}else this.selectionHandler.generateClickEvent("dragStart",t,this.drag.pointer,void 0,!0);}}},{key:"onDrag",value:function value(t){var e=this;if(!0!==this.drag.pinched){this.body.emitter.emit("unlockNode");var i=this.getPointer(t.center),n=this.drag.selection;if(n&&n.length&&!0===this.options.dragNodes){this.selectionHandler.generateClickEvent("dragging",t,i);var o=i.x-this.drag.pointer.x,r=i.y-this.drag.pointer.y;op(n).call(n,function(t){var i=t.node;!1===t.xFixed&&(i.x=e.canvas._XconvertDOMtoCanvas(e.canvas._XconvertCanvasToDOM(t.x)+o)),!1===t.yFixed&&(i.y=e.canvas._YconvertDOMtoCanvas(e.canvas._YconvertCanvasToDOM(t.y)+r));}),this.body.emitter.emit("startSimulation");}else{if(t.srcEvent.shiftKey){if(this.selectionHandler.generateClickEvent("dragging",t,i,void 0,!0),void 0===this.drag.pointer)return void this.onDragStart(t);this.body.selectionBox.position.end={x:this.canvas._XconvertDOMtoCanvas(i.x),y:this.canvas._YconvertDOMtoCanvas(i.y)},this.body.emitter.emit("_requestRedraw");}if(!0===this.options.dragView&&!t.srcEvent.shiftKey){if(this.selectionHandler.generateClickEvent("dragging",t,i,void 0,!0),void 0===this.drag.pointer)return void this.onDragStart(t);var s=i.x-this.drag.pointer.x,a=i.y-this.drag.pointer.y;this.body.view.translation={x:this.drag.translation.x+s,y:this.drag.translation.y+a},this.body.emitter.emit("_requestRedraw");}}}}},{key:"onDragEnd",value:function value(t){var e=this;if(this.drag.dragging=!1,this.body.selectionBox.show){var i;this.body.selectionBox.show=!1;var n=this.body.selectionBox.position,o={minX:Math.min(n.start.x,n.end.x),minY:Math.min(n.start.y,n.end.y),maxX:Math.max(n.start.x,n.end.x),maxY:Math.max(n.start.y,n.end.y)},r=yv(i=this.body.nodeIndices).call(i,function(t){var i=e.body.nodes[t];return i.x>=o.minX&&i.x<=o.maxX&&i.y>=o.minY&&i.y<=o.maxY;});op(r).call(r,function(t){return e.selectionHandler.selectObject(e.body.nodes[t]);});var s=this.getPointer(t.center);this.selectionHandler.commitAndEmit(s,t),this.selectionHandler.generateClickEvent("dragEnd",t,this.getPointer(t.center),void 0,!0),this.body.emitter.emit("_requestRedraw");}else{var a=this.drag.selection;a&&a.length?(op(a).call(a,function(t){t.node.options.fixed.x=t.xFixed,t.node.options.fixed.y=t.yFixed;}),this.selectionHandler.generateClickEvent("dragEnd",t,this.getPointer(t.center)),this.body.emitter.emit("startSimulation")):(this.selectionHandler.generateClickEvent("dragEnd",t,this.getPointer(t.center),void 0,!0),this.body.emitter.emit("_requestRedraw"));}}},{key:"onPinch",value:function value(t){var e=this.getPointer(t.center);this.drag.pinched=!0,void 0===this.pinch.scale&&(this.pinch.scale=1);var i=this.pinch.scale*t.scale;this.zoom(i,e);}},{key:"zoom",value:function value(t,e){if(!0===this.options.zoomView){var i=this.body.view.scale;t<1e-5&&(t=1e-5),t>10&&(t=10);var n=void 0;void 0!==this.drag&&!0===this.drag.dragging&&(n=this.canvas.DOMtoCanvas(this.drag.pointer));var o=this.body.view.translation,r=t/i,s=(1-r)*e.x+o.x*r,a=(1-r)*e.y+o.y*r;if(this.body.view.scale=t,this.body.view.translation={x:s,y:a},null!=n){var h=this.canvas.canvasToDOM(n);this.drag.pointer.x=h.x,this.drag.pointer.y=h.y;}this.body.emitter.emit("_requestRedraw"),i<t?this.body.emitter.emit("zoom",{direction:"+",scale:this.body.view.scale,pointer:e}):this.body.emitter.emit("zoom",{direction:"-",scale:this.body.view.scale,pointer:e});}}},{key:"onMouseWheel",value:function value(t){if(!0===this.options.zoomView){if(0!==t.deltaY){var e=this.body.view.scale;e*=1+(t.deltaY<0?1:-1)*(.1*this.options.zoomSpeed);var i=this.getPointer({x:t.clientX,y:t.clientY});this.zoom(e,i);}t.preventDefault();}}},{key:"onMouseMove",value:function value(t){var e=this,i=this.getPointer({x:t.clientX,y:t.clientY}),n=!1;void 0!==this.popup&&(!1===this.popup.hidden&&this._checkHidePopup(i),!1===this.popup.hidden&&(n=!0,this.popup.setPosition(i.x+3,i.y-5),this.popup.show())),this.options.keyboard.autoFocus&&!1===this.options.keyboard.bindToWindow&&!0===this.options.keyboard.enabled&&this.canvas.frame.focus(),!1===n&&(void 0!==this.popupTimer&&(clearInterval(this.popupTimer),this.popupTimer=void 0),this.drag.dragging||(this.popupTimer=jg(function(){return e._checkShowPopup(i);},this.options.tooltipDelay))),!0===this.options.hover&&this.selectionHandler.hoverObject(t,i);}},{key:"_checkShowPopup",value:function value(t){var e=this.canvas._XconvertDOMtoCanvas(t.x),i=this.canvas._YconvertDOMtoCanvas(t.y),n={left:e,top:i,right:e,bottom:i},o=void 0===this.popupObj?void 0:this.popupObj.id,r=!1,s="node";if(void 0===this.popupObj){for(var a,h=this.body.nodeIndices,l=this.body.nodes,d=[],c=0;c<h.length;c++)!0===(a=l[h[c]]).isOverlappingWith(n)&&(r=!0,void 0!==a.getTitle()&&d.push(h[c]));d.length>0&&(this.popupObj=l[d[d.length-1]],r=!0);}if(void 0===this.popupObj&&!1===r){for(var u,f=this.body.edgeIndices,p=this.body.edges,v=[],g=0;g<f.length;g++)!0===(u=p[f[g]]).isOverlappingWith(n)&&!0===u.connected&&void 0!==u.getTitle()&&v.push(f[g]);v.length>0&&(this.popupObj=p[v[v.length-1]],s="edge");}void 0!==this.popupObj?this.popupObj.id!==o&&(void 0===this.popup&&(this.popup=new Jb(this.canvas.frame)),this.popup.popupTargetType=s,this.popup.popupTargetId=this.popupObj.id,this.popup.setPosition(t.x+3,t.y-5),this.popup.setText(this.popupObj.getTitle()),this.popup.show(),this.body.emitter.emit("showPopup",this.popupObj.id)):void 0!==this.popup&&(this.popup.hide(),this.body.emitter.emit("hidePopup"));}},{key:"_checkHidePopup",value:function value(t){var e=this.selectionHandler._pointerToPositionObject(t),i=!1;if("node"===this.popup.popupTargetType){if(void 0!==this.body.nodes[this.popup.popupTargetId]&&!0===(i=this.body.nodes[this.popup.popupTargetId].isOverlappingWith(e))){var n=this.selectionHandler.getNodeAt(t);i=void 0!==n&&n.id===this.popup.popupTargetId;}}else void 0===this.selectionHandler.getNodeAt(t)&&void 0!==this.body.edges[this.popup.popupTargetId]&&(i=this.body.edges[this.popup.popupTargetId].isOverlappingWith(e));!1===i&&(this.popupObj=void 0,this.popup.hide(),this.body.emitter.emit("hidePopup"));}}]),t;}(),RI=g,LI=Vk,HI=hk.getWeakData,WI=Ok,qI=ii,VI=U,UI=tt,YI=_k,XI=Qt,GI=Lo.set,KI=Lo.getterFor,$I=Fl.find,ZI=Fl.findIndex,QI=RI([].splice),JI=0,tB=function tB(t){return t.frozen||(t.frozen=new eB());},eB=function eB(){this.entries=[];},iB=function iB(t,e){return $I(t.entries,function(t){return t[0]===e;});};eB.prototype={get:function get(t){var e=iB(this,t);if(e)return e[1];},has:function has(t){return!!iB(this,t);},set:function set(t,e){var i=iB(this,t);i?i[1]=e:this.entries.push([t,e]);},"delete":function _delete(t){var e=ZI(this.entries,function(e){return e[0]===t;});return~e&&QI(this.entries,e,1),!!~e;}};var nB,oB={getConstructor:function getConstructor(t,e,i,n){var o=t(function(t,o){WI(t,r),GI(t,{type:e,id:JI++,frozen:void 0}),VI(o)||YI(o,t[n],{that:t,AS_ENTRIES:i});}),r=o.prototype,s=KI(e),a=function a(t,e,i){var n=s(t),o=HI(qI(e),!0);return!0===o?tB(n).set(e,i):o[n.id]=i,t;};return LI(r,{"delete":function _delete(t){var e=s(this);if(!UI(t))return!1;var i=HI(t);return!0===i?tB(e)["delete"](t):i&&XI(i,e.id)&&delete i[e.id];},has:function has(t){var e=s(this);if(!UI(t))return!1;var i=HI(t);return!0===i?tB(e).has(t):i&&XI(i,e.id);}}),LI(r,i?{get:function get(t){var e=s(this);if(UI(t)){var i=HI(t);return!0===i?tB(e).get(t):i?i[e.id]:void 0;}},set:function set(t,e){return a(this,t,e);}}:{add:function add(t){return a(this,t,!0);}}),o;}},rB=Yw,sB=o,aB=g,hB=Vk,lB=hk,dB=Wk,cB=oB,uB=tt,fB=Lo.enforce,pB=r,vB=xo,gB=Object,yB=Array.isArray,mB=gB.isExtensible,bB=gB.isFrozen,wB=gB.isSealed,kB=gB.freeze,_B=gB.seal,xB={},EB={},OB=!sB.ActiveXObject&&"ActiveXObject"in sB,CB=function CB(t){return function(){return t(this,arguments.length?arguments[0]:void 0);};},SB=dB("WeakMap",CB,cB),TB=SB.prototype,MB=aB(TB.set);if(vB)if(OB){nB=cB.getConstructor(CB,"WeakMap",!0),lB.enable();var PB=aB(TB["delete"]),DB=aB(TB.has),IB=aB(TB.get);hB(TB,{"delete":function _delete(t){if(uB(t)&&!mB(t)){var e=fB(this);return e.frozen||(e.frozen=new nB()),PB(this,t)||e.frozen["delete"](t);}return PB(this,t);},has:function has(t){if(uB(t)&&!mB(t)){var e=fB(this);return e.frozen||(e.frozen=new nB()),DB(this,t)||e.frozen.has(t);}return DB(this,t);},get:function get(t){if(uB(t)&&!mB(t)){var e=fB(this);return e.frozen||(e.frozen=new nB()),DB(this,t)?IB(this,t):e.frozen.get(t);}return IB(this,t);},set:function set(t,e){if(uB(t)&&!mB(t)){var i=fB(this);i.frozen||(i.frozen=new nB()),DB(this,t)?MB(this,t,e):i.frozen.set(t,e);}else MB(this,t,e);return this;}});}else rB&&pB(function(){var t=kB([]);return MB(new SB(),t,1),!bB(t);})&&hB(TB,{set:function set(t,e){var i;return yB(t)&&(bB(t)?i=xB:wB(t)&&(i=EB)),MB(this,t,e),i===xB&&kB(t),i===EB&&_B(t),this;}});var BB,NB,FB,zB,AB,jB=i(et.WeakMap);function RB(t,e,i,n){if("a"===i&&!n)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof e?t!==e||!n:!e.has(t))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===i?n:"a"===i?n.call(t):n?n.value:e.get(t);}function LB(t,e,i,n,o){if("m"===n)throw new TypeError("Private method is not writable");if("a"===n&&!o)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof e?t!==e||!o:!e.has(t))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===n?o.call(t,i):o?o.value=i:e.set(t,i),i;}function HB(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return WB(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return WB(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n6=0,o=function o(){};return{s:o,n:function n(){return _n6>=t.length?{done:!0}:{done:!1,value:t[_n6++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function WB(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}function qB(t,e){var i,n=new DS(),o=HB(e);try{for(o.s();!(i=o.n()).done;){var r=i.value;t.has(r)||n.add(r);}}catch(t){o.e(t);}finally{o.f();}return n;}"function"==typeof SuppressedError&&SuppressedError;var VB=function(){function t(){ph(this,t),BB.set(this,new DS()),NB.set(this,new DS());}return xu(t,[{key:"size",get:function get(){return RB(this,NB,"f").size;}},{key:"add",value:function value(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];for(var n=0,o=e;n<o.length;n++){var r=o[n];RB(this,NB,"f").add(r);}}},{key:"delete",value:function value(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];for(var n=0,o=e;n<o.length;n++){var r=o[n];RB(this,NB,"f")["delete"](r);}}},{key:"clear",value:function value(){RB(this,NB,"f").clear();}},{key:"getSelection",value:function value(){return vf(RB(this,NB,"f"));}},{key:"getChanges",value:function value(){return{added:vf(qB(RB(this,BB,"f"),RB(this,NB,"f"))),deleted:vf(qB(RB(this,NB,"f"),RB(this,BB,"f"))),previous:vf(new DS(RB(this,BB,"f"))),current:vf(new DS(RB(this,NB,"f")))};}},{key:"commit",value:function value(){var t=this.getChanges();LB(this,BB,RB(this,NB,"f"),"f"),LB(this,NB,new DS(RB(this,BB,"f")),"f");var e,i=HB(t.added);try{for(i.s();!(e=i.n()).done;){e.value.select();}}catch(t){i.e(t);}finally{i.f();}var n,o=HB(t.deleted);try{for(o.s();!(n=o.n()).done;){n.value.unselect();}}catch(t){o.e(t);}finally{o.f();}return t;}}]),t;}();BB=new jB(),NB=new jB();var UB=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){};ph(this,t),FB.set(this,new VB()),zB.set(this,new VB()),AB.set(this,void 0),LB(this,AB,e,"f");}return xu(t,[{key:"sizeNodes",get:function get(){return RB(this,FB,"f").size;}},{key:"sizeEdges",get:function get(){return RB(this,zB,"f").size;}},{key:"getNodes",value:function value(){return RB(this,FB,"f").getSelection();}},{key:"getEdges",value:function value(){return RB(this,zB,"f").getSelection();}},{key:"addNodes",value:function value(){var t;(t=RB(this,FB,"f")).add.apply(t,arguments);}},{key:"addEdges",value:function value(){var t;(t=RB(this,zB,"f")).add.apply(t,arguments);}},{key:"deleteNodes",value:function value(t){RB(this,FB,"f")["delete"](t);}},{key:"deleteEdges",value:function value(t){RB(this,zB,"f")["delete"](t);}},{key:"clear",value:function value(){RB(this,FB,"f").clear(),RB(this,zB,"f").clear();}},{key:"commit",value:function value(){for(var t,e,i={nodes:RB(this,FB,"f").commit(),edges:RB(this,zB,"f").commit()},n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return(t=RB(this,AB,"f")).call.apply(t,_f(e=[this,i]).call(e,o)),i;}}]),t;}();function YB(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return XB(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return XB(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n7=0,o=function o(){};return{s:o,n:function n(){return _n7>=t.length?{done:!0}:{done:!1,value:t[_n7++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function XB(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}FB=new jB(),zB=new jB(),AB=new jB();var GB=function(){function t(e,i){var n=this;ph(this,t),this.body=e,this.canvas=i,this._selectionAccumulator=new UB(),this.hoverObj={nodes:{},edges:{}},this.options={},this.defaultOptions={multiselect:!1,selectable:!0,selectConnectedEdges:!0,hoverConnectedEdges:!0},bn(this.options,this.defaultOptions),this.body.emitter.on("_dataChanged",function(){n.updateSelection();});}return xu(t,[{key:"setOptions",value:function value(t){if(void 0!==t){pb(["multiselect","hoverConnectedEdges","selectable","selectConnectedEdges"],this.options,t);}}},{key:"selectOnPoint",value:function value(t){var e=!1;if(!0===this.options.selectable){var i=this.getNodeAt(t)||this.getEdgeAt(t);this.unselectAll(),void 0!==i&&(e=this.selectObject(i)),this.body.emitter.emit("_requestRedraw");}return e;}},{key:"selectAdditionalOnPoint",value:function value(t){var e=!1;if(!0===this.options.selectable){var i=this.getNodeAt(t)||this.getEdgeAt(t);void 0!==i&&(e=!0,!0===i.isSelected()?this.deselectObject(i):this.selectObject(i),this.body.emitter.emit("_requestRedraw"));}return e;}},{key:"_initBaseEvent",value:function value(t,e){var i={};return i.pointer={DOM:{x:e.x,y:e.y},canvas:this.canvas.DOMtoCanvas(e)},i.event=t,i;}},{key:"generateClickEvent",value:function value(t,e,i,n){var o=arguments.length>4&&void 0!==arguments[4]&&arguments[4],r=this._initBaseEvent(e,i);if(!0===o)r.nodes=[],r.edges=[];else{var s=this.getSelection();r.nodes=s.nodes,r.edges=s.edges;}void 0!==n&&(r.previousSelection=n),"click"==t&&(r.items=this.getClickedItems(i)),void 0!==e.controlEdge&&(r.controlEdge=e.controlEdge),this.body.emitter.emit(t,r);}},{key:"selectObject",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.options.selectConnectedEdges;if(void 0!==t){if(t instanceof fD){var i;if(!0===e)(i=this._selectionAccumulator).addEdges.apply(i,vf(t.edges));this._selectionAccumulator.addNodes(t);}else this._selectionAccumulator.addEdges(t);return!0;}return!1;}},{key:"deselectObject",value:function value(t){!0===t.isSelected()&&(t.selected=!1,this._removeFromSelection(t));}},{key:"_getAllNodesOverlappingWith",value:function value(t){for(var e=[],i=this.body.nodes,n=0;n<this.body.nodeIndices.length;n++){var o=this.body.nodeIndices[n];i[o].isOverlappingWith(t)&&e.push(o);}return e;}},{key:"_pointerToPositionObject",value:function value(t){var e=this.canvas.DOMtoCanvas(t);return{left:e.x-1,top:e.y+1,right:e.x+1,bottom:e.y-1};}},{key:"getNodeAt",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this._pointerToPositionObject(t),n=this._getAllNodesOverlappingWith(i);return n.length>0?!0===e?this.body.nodes[n[n.length-1]]:n[n.length-1]:void 0;}},{key:"_getEdgesOverlappingWith",value:function value(t,e){for(var i=this.body.edges,n=0;n<this.body.edgeIndices.length;n++){var o=this.body.edgeIndices[n];i[o].isOverlappingWith(t)&&e.push(o);}}},{key:"_getAllEdgesOverlappingWith",value:function value(t){var e=[];return this._getEdgesOverlappingWith(t,e),e;}},{key:"getEdgeAt",value:function value(t){for(var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this.canvas.DOMtoCanvas(t),n=10,o=null,r=this.body.edges,s=0;s<this.body.edgeIndices.length;s++){var a=this.body.edgeIndices[s],h=r[a];if(h.connected){var l=h.from.x,d=h.from.y,c=h.to.x,u=h.to.y,f=h.edgeType.getDistanceToEdge(l,d,c,u,i.x,i.y);f<n&&(o=a,n=f);}}return null!==o?!0===e?this.body.edges[o]:o:void 0;}},{key:"_addToHover",value:function value(t){t instanceof fD?this.hoverObj.nodes[t.id]=t:this.hoverObj.edges[t.id]=t;}},{key:"_removeFromSelection",value:function value(t){var e;t instanceof fD?(this._selectionAccumulator.deleteNodes(t),(e=this._selectionAccumulator).deleteEdges.apply(e,vf(t.edges))):this._selectionAccumulator.deleteEdges(t);}},{key:"unselectAll",value:function value(){this._selectionAccumulator.clear();}},{key:"getSelectedNodeCount",value:function value(){return this._selectionAccumulator.sizeNodes;}},{key:"getSelectedEdgeCount",value:function value(){return this._selectionAccumulator.sizeEdges;}},{key:"_hoverConnectedEdges",value:function value(t){for(var e=0;e<t.edges.length;e++){var i=t.edges[e];i.hover=!0,this._addToHover(i);}}},{key:"emitBlurEvent",value:function value(t,e,i){var n=this._initBaseEvent(t,e);!0===i.hover&&(i.hover=!1,i instanceof fD?(n.node=i.id,this.body.emitter.emit("blurNode",n)):(n.edge=i.id,this.body.emitter.emit("blurEdge",n)));}},{key:"emitHoverEvent",value:function value(t,e,i){var n=this._initBaseEvent(t,e),o=!1;return!1===i.hover&&(i.hover=!0,this._addToHover(i),o=!0,i instanceof fD?(n.node=i.id,this.body.emitter.emit("hoverNode",n)):(n.edge=i.id,this.body.emitter.emit("hoverEdge",n))),o;}},{key:"hoverObject",value:function value(t,e){var i=this.getNodeAt(e);void 0===i&&(i=this.getEdgeAt(e));var n=!1;for(var o in this.hoverObj.nodes)Object.prototype.hasOwnProperty.call(this.hoverObj.nodes,o)&&(void 0===i||i instanceof fD&&i.id!=o||i instanceof dI)&&(this.emitBlurEvent(t,e,this.hoverObj.nodes[o]),delete this.hoverObj.nodes[o],n=!0);for(var r in this.hoverObj.edges)Object.prototype.hasOwnProperty.call(this.hoverObj.edges,r)&&(!0===n?(this.hoverObj.edges[r].hover=!1,delete this.hoverObj.edges[r]):(void 0===i||i instanceof dI&&i.id!=r||i instanceof fD&&!i.hover)&&(this.emitBlurEvent(t,e,this.hoverObj.edges[r]),delete this.hoverObj.edges[r],n=!0));if(void 0!==i){var s=Hf(this.hoverObj.edges).length,a=Hf(this.hoverObj.nodes).length;(n||i instanceof dI&&0===s&&0===a||i instanceof fD&&0===s&&0===a)&&(n=this.emitHoverEvent(t,e,i)),i instanceof fD&&!0===this.options.hoverConnectedEdges&&this._hoverConnectedEdges(i);}!0===n&&this.body.emitter.emit("_requestRedraw");}},{key:"commitWithoutEmitting",value:function value(){this._selectionAccumulator.commit();}},{key:"commitAndEmit",value:function value(t,e){var i=!1,n=this._selectionAccumulator.commit(),o={nodes:n.nodes.previous,edges:n.edges.previous};n.edges.deleted.length>0&&(this.generateClickEvent("deselectEdge",e,t,o),i=!0),n.nodes.deleted.length>0&&(this.generateClickEvent("deselectNode",e,t,o),i=!0),n.nodes.added.length>0&&(this.generateClickEvent("selectNode",e,t),i=!0),n.edges.added.length>0&&(this.generateClickEvent("selectEdge",e,t),i=!0),!0===i&&this.generateClickEvent("select",e,t);}},{key:"getSelection",value:function value(){return{nodes:this.getSelectedNodeIds(),edges:this.getSelectedEdgeIds()};}},{key:"getSelectedNodes",value:function value(){return this._selectionAccumulator.getNodes();}},{key:"getSelectedEdges",value:function value(){return this._selectionAccumulator.getEdges();}},{key:"getSelectedNodeIds",value:function value(){var t;return jf(t=this._selectionAccumulator.getNodes()).call(t,function(t){return t.id;});}},{key:"getSelectedEdgeIds",value:function value(){var t;return jf(t=this._selectionAccumulator.getEdges()).call(t,function(t){return t.id;});}},{key:"setSelection",value:function value(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!t||!t.nodes&&!t.edges)throw new TypeError("Selection must be an object with nodes and/or edges properties");if((e.unselectAll||void 0===e.unselectAll)&&this.unselectAll(),t.nodes){var i,n=YB(t.nodes);try{for(n.s();!(i=n.n()).done;){var o=i.value,r=this.body.nodes[o];if(!r)throw new RangeError('Node with id "'+o+'" not found');this.selectObject(r,e.highlightEdges);}}catch(t){n.e(t);}finally{n.f();}}if(t.edges){var s,a=YB(t.edges);try{for(a.s();!(s=a.n()).done;){var h=s.value,l=this.body.edges[h];if(!l)throw new RangeError('Edge with id "'+h+'" not found');this.selectObject(l);}}catch(t){a.e(t);}finally{a.f();}}this.body.emitter.emit("_requestRedraw"),this._selectionAccumulator.commit();}},{key:"selectNodes",value:function value(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!t||void 0===t.length)throw"Selection must be an array with ids";this.setSelection({nodes:t},{highlightEdges:e});}},{key:"selectEdges",value:function value(t){if(!t||void 0===t.length)throw"Selection must be an array with ids";this.setSelection({edges:t});}},{key:"updateSelection",value:function value(){for(var t in this._selectionAccumulator.getNodes())Object.prototype.hasOwnProperty.call(this.body.nodes,t.id)||this._selectionAccumulator.deleteNodes(t);for(var e in this._selectionAccumulator.getEdges())Object.prototype.hasOwnProperty.call(this.body.edges,e.id)||this._selectionAccumulator.deleteEdges(e);}},{key:"getClickedItems",value:function value(t){for(var e=this.canvas.DOMtoCanvas(t),i=[],n=this.body.nodeIndices,o=this.body.nodes,r=n.length-1;r>=0;r--){var s=o[n[r]].getItemsOnPoint(e);i.push.apply(i,s);}for(var a=this.body.edgeIndices,h=this.body.edges,l=a.length-1;l>=0;l--){var d=h[a[l]].getItemsOnPoint(e);i.push.apply(i,d);}return i;}}]),t;}();function KB(t){var e=function(){if("undefined"==typeof Reflect||!sM)return!1;if(sM.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(sM(Boolean,[],function(){})),!0;}catch(t){return!1;}}();return function(){var i,n=F_(t);if(e){var o=F_(this).constructor;i=sM(n,arguments,o);}else i=n.apply(this,arguments);return I_(this,i);};}var $B=function(){function t(){ph(this,t);}return xu(t,[{key:"abstract",value:function value(){throw new Error("Can't instantiate abstract class!");}},{key:"fake_use",value:function value(){}},{key:"curveType",value:function value(){return this["abstract"]();}},{key:"getPosition",value:function value(t){return this.fake_use(t),this["abstract"]();}},{key:"setPosition",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;this.fake_use(t,e,i),this["abstract"]();}},{key:"getTreeSize",value:function value(t){return this.fake_use(t),this["abstract"]();}},{key:"sort",value:function value(t){this.fake_use(t),this["abstract"]();}},{key:"fix",value:function value(t,e){this.fake_use(t,e),this["abstract"]();}},{key:"shift",value:function value(t,e){this.fake_use(t,e),this["abstract"]();}}]),t;}(),ZB=function(t){D_(i,t);var e=KB(i);function i(t){var n;return ph(this,i),(n=e.call(this)).layout=t,n;}return xu(i,[{key:"curveType",value:function value(){return"horizontal";}},{key:"getPosition",value:function value(t){return t.x;}},{key:"setPosition",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;void 0!==i&&this.layout.hierarchical.addToOrdering(t,i),t.x=e;}},{key:"getTreeSize",value:function value(t){var e=this.layout.hierarchical.getTreeSize(this.layout.body.nodes,t);return{min:e.min_x,max:e.max_x};}},{key:"sort",value:function value(t){yT(t).call(t,function(t,e){return t.x-e.x;});}},{key:"fix",value:function value(t,e){t.y=this.layout.options.hierarchical.levelSeparation*e,t.options.fixed.y=!0;}},{key:"shift",value:function value(t,e){this.layout.body.nodes[t].x+=e;}}]),i;}($B),QB=function(t){D_(i,t);var e=KB(i);function i(t){var n;return ph(this,i),(n=e.call(this)).layout=t,n;}return xu(i,[{key:"curveType",value:function value(){return"vertical";}},{key:"getPosition",value:function value(t){return t.y;}},{key:"setPosition",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;void 0!==i&&this.layout.hierarchical.addToOrdering(t,i),t.y=e;}},{key:"getTreeSize",value:function value(t){var e=this.layout.hierarchical.getTreeSize(this.layout.body.nodes,t);return{min:e.min_y,max:e.max_y};}},{key:"sort",value:function value(t){yT(t).call(t,function(t,e){return t.y-e.y;});}},{key:"fix",value:function value(t,e){t.x=this.layout.options.hierarchical.levelSeparation*e,t.options.fixed.x=!0;}},{key:"shift",value:function value(t,e){this.layout.body.nodes[t].y+=e;}}]),i;}($B),JB=Fl.every;Ti({target:"Array",proto:!0,forced:!Xf("every")},{every:function every(t){return JB(this,t,arguments.length>1?arguments[1]:void 0);}});var tN=Nn("Array").every,eN=at,iN=tN,nN=Array.prototype,oN=function oN(t){var e=t.every;return t===nN||eN(nN,t)&&e===nN.every?iN:e;},rN=i(oN);function sN(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return aN(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return aN(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n8=0,o=function o(){};return{s:o,n:function n(){return _n8>=t.length?{done:!0}:{done:!1,value:t[_n8++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function aN(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}function hN(t,e){var i=new DS();return op(t).call(t,function(t){var e;op(e=t.edges).call(e,function(t){t.connected&&i.add(t);});}),op(i).call(i,function(t){var i=t.from.id,n=t.to.id;null==e[i]&&(e[i]=0),(null==e[n]||e[i]>=e[n])&&(e[n]=e[i]+1);}),e;}function lN(t,e,i,n){var o,r,s=pg(null),a=pS(o=vf(FT(n).call(n))).call(o,function(t,e){return t+1+e.edges.length;},0),h=i+"Id",l="to"===i?1:-1,d=sN(n);try{var c,u=function u(){var o=pf(r.value,2),d=o[0],c=o[1];if(!n.has(d)||!t(c))return 0;s[d]=0;for(var u,f,p=[c],v=0,g=function g(){var t,o;if(!n.has(d))return 0;var r=s[u.id]+l;if(op(t=yv(o=u.edges).call(o,function(t){return t.connected&&t.to!==t.from&&t[i]!==u&&n.has(t.toId)&&n.has(t.fromId);})).call(t,function(t){var n=t[h],o=s[n];(null==o||e(r,o))&&(s[n]=r,p.push(t[i]));}),v>a)return{v:{v:hN(n,s)}};++v;};u=p.pop();)if(0!==(f=g())&&f)return f.v;};for(d.s();!(r=d.n()).done;)if(0!==(c=u())&&c)return c.v;}catch(t){d.e(t);}finally{d.f();}return s;}var dN=function(){function t(){ph(this,t),this.childrenReference={},this.parentReference={},this.trees={},this.distributionOrdering={},this.levels={},this.distributionIndex={},this.isTree=!1,this.treeIndex=-1;}return xu(t,[{key:"addRelation",value:function value(t,e){void 0===this.childrenReference[t]&&(this.childrenReference[t]=[]),this.childrenReference[t].push(e),void 0===this.parentReference[e]&&(this.parentReference[e]=[]),this.parentReference[e].push(t);}},{key:"checkIfTree",value:function value(){for(var t in this.parentReference)if(this.parentReference[t].length>1)return void(this.isTree=!1);this.isTree=!0;}},{key:"numTrees",value:function value(){return this.treeIndex+1;}},{key:"setTreeIndex",value:function value(t,e){void 0!==e&&void 0===this.trees[t.id]&&(this.trees[t.id]=e,this.treeIndex=Math.max(e,this.treeIndex));}},{key:"ensureLevel",value:function value(t){void 0===this.levels[t]&&(this.levels[t]=0);}},{key:"getMaxLevel",value:function value(t){var e=this,i={};return function t(n){if(void 0!==i[n])return i[n];var o=e.levels[n];if(e.childrenReference[n]){var r=e.childrenReference[n];if(r.length>0)for(var s=0;s<r.length;s++)o=Math.max(o,t(r[s]));}return i[n]=o,o;}(t);}},{key:"levelDownstream",value:function value(t,e){void 0===this.levels[e.id]&&(void 0===this.levels[t.id]&&(this.levels[t.id]=0),this.levels[e.id]=this.levels[t.id]+1);}},{key:"setMinLevelToZero",value:function value(t){var e=1e9;for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&void 0!==this.levels[i]&&(e=Math.min(this.levels[i],e));for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&void 0!==this.levels[n]&&(this.levels[n]-=e);}},{key:"getTreeSize",value:function value(t,e){var i=1e9,n=-1e9,o=1e9,r=-1e9;for(var s in this.trees)if(Object.prototype.hasOwnProperty.call(this.trees,s)&&this.trees[s]===e){var a=t[s];i=Math.min(a.x,i),n=Math.max(a.x,n),o=Math.min(a.y,o),r=Math.max(a.y,r);}return{min_x:i,max_x:n,min_y:o,max_y:r};}},{key:"hasSameParent",value:function value(t,e){var i=this.parentReference[t.id],n=this.parentReference[e.id];if(void 0===i||void 0===n)return!1;for(var o=0;o<i.length;o++)for(var r=0;r<n.length;r++)if(i[o]==n[r])return!0;return!1;}},{key:"inSameSubNetwork",value:function value(t,e){return this.trees[t.id]===this.trees[e.id];}},{key:"getLevels",value:function value(){return Hf(this.distributionOrdering);}},{key:"addToOrdering",value:function value(t,e){void 0===this.distributionOrdering[e]&&(this.distributionOrdering[e]=[]);var i=!1,n=this.distributionOrdering[e];for(var o in n)if(n[o]===t){i=!0;break;}i||(this.distributionOrdering[e].push(t),this.distributionIndex[t.id]=this.distributionOrdering[e].length-1);}}]),t;}(),cN=function(){function t(e){ph(this,t),this.body=e,this._resetRNG(Math.random()+":"+Uf()),this.setPhysics=!1,this.options={},this.optionsBackup={physics:{}},this.defaultOptions={randomSeed:void 0,improvedLayout:!0,clusterThreshold:150,hierarchical:{enabled:!1,levelSeparation:150,nodeSpacing:100,treeSpacing:200,blockShifting:!0,edgeMinimization:!0,parentCentralization:!0,direction:"UD",sortMethod:"hubsize"}},bn(this.options,this.defaultOptions),this.bindEventListeners();}return xu(t,[{key:"bindEventListeners",value:function value(){var t=this;this.body.emitter.on("_dataChanged",function(){t.setupHierarchicalLayout();}),this.body.emitter.on("_dataLoaded",function(){t.layoutNetwork();}),this.body.emitter.on("_resetHierarchicalLayout",function(){t.setupHierarchicalLayout();}),this.body.emitter.on("_adjustEdgesForHierarchicalLayout",function(){if(!0===t.options.hierarchical.enabled){var e=t.direction.curveType();t.body.emitter.emit("_forceDisableDynamicCurves",e,!1);}});}},{key:"setOptions",value:function value(t,e){if(void 0!==t){var i=this.options.hierarchical,n=i.enabled;if(pb(["randomSeed","improvedLayout","clusterThreshold"],this.options,t),Ab(this.options,t,"hierarchical"),void 0!==t.randomSeed&&this._resetRNG(t.randomSeed),!0===i.enabled)return!0===n&&this.body.emitter.emit("refresh",!0),"RL"===i.direction||"DU"===i.direction?i.levelSeparation>0&&(i.levelSeparation*=-1):i.levelSeparation<0&&(i.levelSeparation*=-1),this.setDirectionStrategy(),this.body.emitter.emit("_resetHierarchicalLayout"),this.adaptAllOptionsForHierarchicalLayout(e);if(!0===n)return this.body.emitter.emit("refresh"),gb(e,this.optionsBackup);}return e;}},{key:"_resetRNG",value:function value(t){this.initialRandomSeed=t,this._rng=Jm(this.initialRandomSeed);}},{key:"adaptAllOptionsForHierarchicalLayout",value:function value(t){if(!0===this.options.hierarchical.enabled){var e=this.optionsBackup.physics;void 0===t.physics||!0===t.physics?(t.physics={enabled:void 0===e.enabled||e.enabled,solver:"hierarchicalRepulsion"},e.enabled=void 0===e.enabled||e.enabled,e.solver=e.solver||"barnesHut"):"object"===bu(t.physics)?(e.enabled=void 0===t.physics.enabled||t.physics.enabled,e.solver=t.physics.solver||"barnesHut",t.physics.solver="hierarchicalRepulsion"):!1!==t.physics&&(e.solver="barnesHut",t.physics={solver:"hierarchicalRepulsion"});var i=this.direction.curveType();if(void 0===t.edges)this.optionsBackup.edges={smooth:{enabled:!0,type:"dynamic"}},t.edges={smooth:!1};else if(void 0===t.edges.smooth)this.optionsBackup.edges={smooth:{enabled:!0,type:"dynamic"}},t.edges.smooth=!1;else if("boolean"==typeof t.edges.smooth)this.optionsBackup.edges={smooth:t.edges.smooth},t.edges.smooth={enabled:t.edges.smooth,type:i};else{var n=t.edges.smooth;void 0!==n.type&&"dynamic"!==n.type&&(i=n.type),this.optionsBackup.edges={smooth:{enabled:void 0===n.enabled||n.enabled,type:void 0===n.type?"dynamic":n.type,roundness:void 0===n.roundness?.5:n.roundness,forceDirection:void 0!==n.forceDirection&&n.forceDirection}},t.edges.smooth={enabled:void 0===n.enabled||n.enabled,type:i,roundness:void 0===n.roundness?.5:n.roundness,forceDirection:void 0!==n.forceDirection&&n.forceDirection};}this.body.emitter.emit("_forceDisableDynamicCurves",i);}return t;}},{key:"positionInitially",value:function value(t){if(!0!==this.options.hierarchical.enabled){this._resetRNG(this.initialRandomSeed);for(var e=t.length+50,i=0;i<t.length;i++){var n=t[i],o=2*Math.PI*this._rng();void 0===n.x&&(n.x=e*Math.cos(o)),void 0===n.y&&(n.y=e*Math.sin(o));}}}},{key:"layoutNetwork",value:function value(){if(!0!==this.options.hierarchical.enabled&&!0===this.options.improvedLayout){for(var t=this.body.nodeIndices,e=0,i=0;i<t.length;i++){!0===this.body.nodes[t[i]].predefinedPosition&&(e+=1);}if(e<.5*t.length){var n=0,o=this.options.clusterThreshold,r={clusterNodeProperties:{shape:"ellipse",label:"",group:"",font:{multi:!1}},clusterEdgeProperties:{label:"",font:{multi:!1},smooth:{enabled:!1}}};if(t.length>o){for(var s=t.length;t.length>o&&n<=10;){n+=1;var a=t.length;if(n%3==0?this.body.modules.clustering.clusterBridges(r):this.body.modules.clustering.clusterOutliers(r),a==t.length&&n%3!=0)return this._declusterAll(),this.body.emitter.emit("_layoutFailed"),void console.info("This network could not be positioned by this version of the improved layout algorithm. Please disable improvedLayout for better performance.");}this.body.modules.kamadaKawai.setOptions({springLength:Math.max(150,2*s)});}n>10&&console.info("The clustering didn't succeed within the amount of interations allowed, progressing with partial result."),this.body.modules.kamadaKawai.solve(t,this.body.edgeIndices,!0),this._shiftToCenter();for(var h=0;h<t.length;h++){var l=this.body.nodes[t[h]];!1===l.predefinedPosition&&(l.x+=70*(.5-this._rng()),l.y+=70*(.5-this._rng()));}this._declusterAll(),this.body.emitter.emit("_repositionBezierNodes");}}}},{key:"_shiftToCenter",value:function value(){for(var t=xI.getRangeCore(this.body.nodes,this.body.nodeIndices),e=xI.findCenter(t),i=0;i<this.body.nodeIndices.length;i++){var n=this.body.nodes[this.body.nodeIndices[i]];n.x-=e.x,n.y-=e.y;}}},{key:"_declusterAll",value:function value(){for(var t=!0;!0===t;){t=!1;for(var e=0;e<this.body.nodeIndices.length;e++)!0===this.body.nodes[this.body.nodeIndices[e]].isCluster&&(t=!0,this.body.modules.clustering.openCluster(this.body.nodeIndices[e],{},!1));!0===t&&this.body.emitter.emit("_dataChanged");}}},{key:"getSeed",value:function value(){return this.initialRandomSeed;}},{key:"setupHierarchicalLayout",value:function value(){if(!0===this.options.hierarchical.enabled&&this.body.nodeIndices.length>0){var t,e,i=!1,n=!1;for(e in this.lastNodeOnLevel={},this.hierarchical=new dN(),this.body.nodes)Object.prototype.hasOwnProperty.call(this.body.nodes,e)&&(void 0!==(t=this.body.nodes[e]).options.level?(i=!0,this.hierarchical.levels[e]=t.options.level):n=!0);if(!0===n&&!0===i)throw new Error("To use the hierarchical layout, nodes require either no predefined levels or levels have to be defined for all nodes.");if(!0===n){var o=this.options.hierarchical.sortMethod;"hubsize"===o?this._determineLevelsByHubsize():"directed"===o?this._determineLevelsDirected():"custom"===o&&this._determineLevelsCustomCallback();}for(var r in this.body.nodes)Object.prototype.hasOwnProperty.call(this.body.nodes,r)&&this.hierarchical.ensureLevel(r);var s=this._getDistribution();this._generateMap(),this._placeNodesByHierarchy(s),this._condenseHierarchy(),this._shiftToCenter();}}},{key:"_condenseHierarchy",value:function value(){var t=this,e=!1,i={},n=function n(e,i){var n=t.hierarchical.trees;for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&n[o]===e&&t.direction.shift(o,i);},o=function o(){for(var e=[],i=0;i<t.hierarchical.numTrees();i++)e.push(t.direction.getTreeSize(i));return e;},r=function e(i,n){if(!n[i.id]&&(n[i.id]=!0,t.hierarchical.childrenReference[i.id])){var o=t.hierarchical.childrenReference[i.id];if(o.length>0)for(var r=0;r<o.length;r++)e(t.body.nodes[o[r]],n);}},s=function s(e){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e9,n=1e9,o=1e9,r=1e9,s=-1e9;for(var a in e)if(Object.prototype.hasOwnProperty.call(e,a)){var h=t.body.nodes[a],l=t.hierarchical.levels[h.id],d=t.direction.getPosition(h),c=pf(t._getSpaceAroundNode(h,e),2),u=c[0],f=c[1];n=Math.min(u,n),o=Math.min(f,o),l<=i&&(r=Math.min(d,r),s=Math.max(d,s));}return[r,s,n,o];},a=function a(e,i,n){for(var o=t.hierarchical,r=0;r<i.length;r++){var s=i[r],a=o.distributionOrdering[s];if(a.length>1)for(var h=0;h<a.length-1;h++){var l=a[h],d=a[h+1];o.hasSameParent(l,d)&&o.inSameSubNetwork(l,d)&&e(l,d,n);}}},h=function h(i,n){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=t.direction.getPosition(i),h=t.direction.getPosition(n),l=Math.abs(h-a),d=t.options.hierarchical.nodeSpacing;if(l>d){var c={},u={};r(i,c),r(n,u);var f=function(e,i){var n=t.hierarchical.getMaxLevel(e.id),o=t.hierarchical.getMaxLevel(i.id);return Math.min(n,o);}(i,n),p=s(c,f),v=s(u,f),g=p[1],y=v[0],m=v[2];if(Math.abs(g-y)>d){var b=g-y+d;b<-m+d&&(b=-m+d),b<0&&(t._shiftBlock(n.id,b),e=!0,!0===o&&t._centerParent(n));}}},l=function l(n,o){for(var a=o.id,h=o.edges,l=t.hierarchical.levels[o.id],d=t.options.hierarchical.levelSeparation*t.options.hierarchical.levelSeparation,c={},u=[],f=0;f<h.length;f++){var p=h[f];if(p.toId!=p.fromId){var v=p.toId==a?p.from:p.to;c[h[f].id]=v,t.hierarchical.levels[v.id]<l&&u.push(p);}}var g=function g(e,i){for(var n=0,o=0;o<i.length;o++)if(void 0!==c[i[o].id]){var r=t.direction.getPosition(c[i[o].id])-e;n+=r/Math.sqrt(r*r+d);}return n;},y=function y(e,i){for(var n=0,o=0;o<i.length;o++)if(void 0!==c[i[o].id]){var r=t.direction.getPosition(c[i[o].id])-e;n-=d*Math.pow(r*r+d,-1.5);}return n;},m=function m(e,i){for(var n=t.direction.getPosition(o),r={},s=0;s<e;s++){var a=g(n,i),h=y(n,i);if(void 0!==r[n-=Math.max(-40,Math.min(40,Math.round(a/h)))])break;r[n]=s;}return n;},b=m(n,u);!function(n){var a=t.direction.getPosition(o);if(void 0===i[o.id]){var h={};r(o,h),i[o.id]=h;}var l=s(i[o.id]),d=l[2],c=l[3],u=n-a,f=0;u>0?f=Math.min(u,c-t.options.hierarchical.nodeSpacing):u<0&&(f=-Math.min(-u,d-t.options.hierarchical.nodeSpacing)),0!=f&&(t._shiftBlock(o.id,f),e=!0);}(b),function(i){var n=t.direction.getPosition(o),r=pf(t._getSpaceAroundNode(o),2),s=r[0],a=r[1],h=i-n,l=n;h>0?l=Math.min(n+(a-t.options.hierarchical.nodeSpacing),i):h<0&&(l=Math.max(n-(s-t.options.hierarchical.nodeSpacing),i)),l!==n&&(t.direction.setPosition(o,l),e=!0);}(b=m(n,h));};!0===this.options.hierarchical.blockShifting&&(function(i){var n=t.hierarchical.getLevels();n=vp(n).call(n);for(var o=0;o<i&&(e=!1,a(h,n,!0),!0===e);o++);}(5),function(){for(var e in t.body.nodes)Object.prototype.hasOwnProperty.call(t.body.nodes,e)&&t._centerParent(t.body.nodes[e]);}()),!0===this.options.hierarchical.edgeMinimization&&function(i){var n=t.hierarchical.getLevels();n=vp(n).call(n);for(var o=0;o<i;o++){e=!1;for(var r=0;r<n.length;r++)for(var s=n[r],a=t.hierarchical.distributionOrdering[s],h=0;h<a.length;h++)l(1e3,a[h]);if(!0!==e)break;}}(20),!0===this.options.hierarchical.parentCentralization&&function(){var e=t.hierarchical.getLevels();e=vp(e).call(e);for(var i=0;i<e.length;i++)for(var n=e[i],o=t.hierarchical.distributionOrdering[n],r=0;r<o.length;r++)t._centerParent(o[r]);}(),function(){for(var e=o(),i=0,r=0;r<e.length-1;r++){i+=e[r].max-e[r+1].min+t.options.hierarchical.treeSpacing,n(r+1,i);}}();}},{key:"_getSpaceAroundNode",value:function value(t,e){var i=!0;void 0===e&&(i=!1);var n=this.hierarchical.levels[t.id];if(void 0!==n){var o=this.hierarchical.distributionIndex[t.id],r=this.direction.getPosition(t),s=this.hierarchical.distributionOrdering[n],a=1e9,h=1e9;if(0!==o){var l=s[o-1];if(!0===i&&void 0===e[l.id]||!1===i)a=r-this.direction.getPosition(l);}if(o!=s.length-1){var d=s[o+1];if(!0===i&&void 0===e[d.id]||!1===i){var c=this.direction.getPosition(d);h=Math.min(h,c-r);}}return[a,h];}return[0,0];}},{key:"_centerParent",value:function value(t){if(this.hierarchical.parentReference[t.id])for(var e=this.hierarchical.parentReference[t.id],i=0;i<e.length;i++){var n=e[i],o=this.body.nodes[n],r=this.hierarchical.childrenReference[n];if(void 0!==r){var s=this._getCenterPosition(r),a=this.direction.getPosition(o),h=pf(this._getSpaceAroundNode(o),2),l=h[0],d=h[1],c=a-s;(c<0&&Math.abs(c)<d-this.options.hierarchical.nodeSpacing||c>0&&Math.abs(c)<l-this.options.hierarchical.nodeSpacing)&&this.direction.setPosition(o,s);}}}},{key:"_placeNodesByHierarchy",value:function value(t){for(var e in this.positionedNodes={},t)if(Object.prototype.hasOwnProperty.call(t,e)){var i,n=Hf(t[e]);n=this._indexArrayToNodes(n),yT(i=this.direction).call(i,n);for(var o=0,r=0;r<n.length;r++){var s=n[r];if(void 0===this.positionedNodes[s.id]){var a=this.options.hierarchical.nodeSpacing,h=a*o;o>0&&(h=this.direction.getPosition(n[r-1])+a),this.direction.setPosition(s,h,e),this._validatePositionAndContinue(s,e,h),o++;}}}}},{key:"_placeBranchNodes",value:function value(t,e){var i,n=this.hierarchical.childrenReference[t];if(void 0!==n){for(var o=[],r=0;r<n.length;r++)o.push(this.body.nodes[n[r]]);yT(i=this.direction).call(i,o);for(var s=0;s<o.length;s++){var a=o[s],h=this.hierarchical.levels[a.id];if(!(h>e&&void 0===this.positionedNodes[a.id]))return;var l=this.options.hierarchical.nodeSpacing,d=void 0;d=0===s?this.direction.getPosition(this.body.nodes[t]):this.direction.getPosition(o[s-1])+l,this.direction.setPosition(a,d,h),this._validatePositionAndContinue(a,h,d);}var c=this._getCenterPosition(o);this.direction.setPosition(this.body.nodes[t],c,e);}}},{key:"_validatePositionAndContinue",value:function value(t,e,i){if(this.hierarchical.isTree){if(void 0!==this.lastNodeOnLevel[e]){var n=this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[e]]);if(i-n<this.options.hierarchical.nodeSpacing){var o=n+this.options.hierarchical.nodeSpacing-i,r=this._findCommonParent(this.lastNodeOnLevel[e],t.id);this._shiftBlock(r.withChild,o);}}this.lastNodeOnLevel[e]=t.id,this.positionedNodes[t.id]=!0,this._placeBranchNodes(t.id,e);}}},{key:"_indexArrayToNodes",value:function value(t){for(var e=[],i=0;i<t.length;i++)e.push(this.body.nodes[t[i]]);return e;}},{key:"_getDistribution",value:function value(){var t,e,i={};for(t in this.body.nodes)if(Object.prototype.hasOwnProperty.call(this.body.nodes,t)){e=this.body.nodes[t];var n=void 0===this.hierarchical.levels[t]?0:this.hierarchical.levels[t];this.direction.fix(e,n),void 0===i[n]&&(i[n]={}),i[n][t]=e;}return i;}},{key:"_getActiveEdges",value:function value(t){var e=this,i=[];return kb(t.edges,function(t){var n;-1!==lg(n=e.body.edgeIndices).call(n,t.id)&&i.push(t);}),i;}},{key:"_getHubSizes",value:function value(){var t=this,e={};kb(this.body.nodeIndices,function(i){var n=t.body.nodes[i],o=t._getActiveEdges(n).length;e[o]=!0;});var i=[];return kb(e,function(t){i.push(Number(t));}),yT(i).call(i,function(t,e){return e-t;}),i;}},{key:"_determineLevelsByHubsize",value:function value(){for(var t=this,e=function e(_e2,i){t.hierarchical.levelDownstream(_e2,i);},i=this._getHubSizes(),n=function n(){var n=i[o];if(0===n)return 1;kb(t.body.nodeIndices,function(i){var o=t.body.nodes[i];n===t._getActiveEdges(o).length&&t._crawlNetwork(e,i);});},o=0;o<i.length&&!n();++o);}},{key:"_determineLevelsCustomCallback",value:function value(){var t=this;this._crawlNetwork(function(e,i,n){var o=t.hierarchical.levels[e.id];void 0===o&&(o=t.hierarchical.levels[e.id]=1e5);var r=(xI.cloneOptions(e,"node"),xI.cloneOptions(i,"node"),void xI.cloneOptions(n,"edge"));t.hierarchical.levels[i.id]=o+r;}),this.hierarchical.setMinLevelToZero(this.body.nodes);}},{key:"_determineLevelsDirected",value:function value(){var t,e=this,i=pS(t=this.body.nodeIndices).call(t,function(t,i){return t.set(i,e.body.nodes[i]),t;},new c_());"roots"===this.options.hierarchical.shakeTowards?this.hierarchical.levels=function(t){return lN(function(e){var i,n;return rN(i=yv(n=e.edges).call(n,function(e){return t.has(e.toId);})).call(i,function(t){return t.from===e;});},function(t,e){return e<t;},"to",t);}(i):this.hierarchical.levels=function(t){return lN(function(e){var i,n;return rN(i=yv(n=e.edges).call(n,function(e){return t.has(e.toId);})).call(i,function(t){return t.to===e;});},function(t,e){return e>t;},"from",t);}(i),this.hierarchical.setMinLevelToZero(this.body.nodes);}},{key:"_generateMap",value:function value(){var t=this;this._crawlNetwork(function(e,i){t.hierarchical.levels[i.id]>t.hierarchical.levels[e.id]&&t.hierarchical.addRelation(e.id,i.id);}),this.hierarchical.checkIfTree();}},{key:"_crawlNetwork",value:function value(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){},i=arguments.length>1?arguments[1]:void 0,n={},o=function i(o,r){if(void 0===n[o.id]){var s;t.hierarchical.setTreeIndex(o,r),n[o.id]=!0;for(var a=t._getActiveEdges(o),h=0;h<a.length;h++){var l=a[h];!0===l.connected&&(s=l.toId==o.id?l.from:l.to,o.id!=s.id&&(e(o,s,l),i(s,r)));}}};if(void 0===i)for(var r=0,s=0;s<this.body.nodeIndices.length;s++){var a=this.body.nodeIndices[s];if(void 0===n[a])o(this.body.nodes[a],r),r+=1;}else{var h=this.body.nodes[i];if(void 0===h)return void console.error("Node not found:",i);o(h);}}},{key:"_shiftBlock",value:function value(t,e){var i=this,n={};!function t(o){if(!n[o]){n[o]=!0,i.direction.shift(o,e);var r=i.hierarchical.childrenReference[o];if(void 0!==r)for(var s=0;s<r.length;s++)t(r[s]);}}(t);}},{key:"_findCommonParent",value:function value(t,e){var i=this,n={};return function t(e,n){var o=i.hierarchical.parentReference[n];if(void 0!==o)for(var r=0;r<o.length;r++){var s=o[r];e[s]=!0,t(e,s);}}(n,t),function t(e,n){var o=i.hierarchical.parentReference[n];if(void 0!==o)for(var r=0;r<o.length;r++){var s=o[r];if(void 0!==e[s])return{foundParent:s,withChild:n};var a=t(e,s);if(null!==a.foundParent)return a;}return{foundParent:null,withChild:n};}(n,e);}},{key:"setDirectionStrategy",value:function value(){var t="UD"===this.options.hierarchical.direction||"DU"===this.options.hierarchical.direction;this.direction=t?new ZB(this):new QB(this);}},{key:"_getCenterPosition",value:function value(t){for(var e=1e9,i=-1e9,n=0;n<t.length;n++){var o=void 0;if(void 0!==t[n].id)o=t[n];else{var r=t[n];o=this.body.nodes[r];}var s=this.direction.getPosition(o);e=Math.min(e,s),i=Math.max(i,s);}return .5*(e+i);}}]),t;}();function uN(t,e){var i=void 0!==gf&&fh(t)||t["@@iterator"];if(!i){if(Df(t)||(i=function(t,e){var i;if(!t)return;if("string"==typeof t)return fN(t,e);var n=xf(i=Object.prototype.toString.call(t)).call(i,8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Ya(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return fN(t,e);}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var _n9=0,o=function o(){};return{s:o,n:function n(){return _n9>=t.length?{done:!0}:{done:!1,value:t[_n9++]};},e:function e(t){throw t;},f:o};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var r,s=!0,a=!1;return{s:function s(){i=i.call(t);},n:function n(){var t=i.next();return s=t.done,t;},e:function e(t){a=!0,r=t;},f:function f(){try{s||null==i["return"]||i["return"]();}finally{if(a)throw r;}}};}function fN(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n;}var pN=function(){function t(e,i,n,o){var r,s,a=this;ph(this,t),this.body=e,this.canvas=i,this.selectionHandler=n,this.interactionHandler=o,this.editMode=!1,this.manipulationDiv=void 0,this.editModeDiv=void 0,this.closeDiv=void 0,this._domEventListenerCleanupQueue=[],this.temporaryUIFunctions={},this.temporaryEventFunctions=[],this.touchTime=0,this.temporaryIds={nodes:[],edges:[]},this.guiEnabled=!1,this.inMode=!1,this.selectedControlNode=void 0,this.options={},this.defaultOptions={enabled:!1,initiallyActive:!1,addNode:!0,addEdge:!0,editNode:void 0,editEdge:!0,deleteNode:!0,deleteEdge:!0,controlNodeStyle:{shape:"dot",size:6,color:{background:"#ff0000",border:"#3c3c3c",highlight:{background:"#07f968",border:"#3c3c3c"}},borderWidth:2,borderWidthSelected:2}},bn(this.options,this.defaultOptions),this.body.emitter.on("destroy",function(){a._clean();}),this.body.emitter.on("_dataChanged",Hn(r=this._restore).call(r,this)),this.body.emitter.on("_resetData",Hn(s=this._restore).call(s,this));}return xu(t,[{key:"_restore",value:function value(){!1!==this.inMode&&(!0===this.options.initiallyActive?this.enableEditMode():this.disableEditMode());}},{key:"setOptions",value:function value(t,e,i){void 0!==e&&(void 0!==e.locale?this.options.locale=e.locale:this.options.locale=i.locale,void 0!==e.locales?this.options.locales=e.locales:this.options.locales=i.locales),void 0!==t&&("boolean"==typeof t?this.options.enabled=t:(this.options.enabled=!0,gb(this.options,t)),!0===this.options.initiallyActive&&(this.editMode=!0),this._setup());}},{key:"toggleEditMode",value:function value(){!0===this.editMode?this.disableEditMode():this.enableEditMode();}},{key:"enableEditMode",value:function value(){this.editMode=!0,this._clean(),!0===this.guiEnabled&&(this.manipulationDiv.style.display="block",this.closeDiv.style.display="block",this.editModeDiv.style.display="none",this.showManipulatorToolbar());}},{key:"disableEditMode",value:function value(){this.editMode=!1,this._clean(),!0===this.guiEnabled&&(this.manipulationDiv.style.display="none",this.closeDiv.style.display="none",this.editModeDiv.style.display="block",this._createEditButton());}},{key:"showManipulatorToolbar",value:function value(){if(this._clean(),this.manipulationDOM={},!0===this.guiEnabled){var t,e;this.editMode=!0,this.manipulationDiv.style.display="block",this.closeDiv.style.display="block";var i=this.selectionHandler.getSelectedNodeCount(),n=this.selectionHandler.getSelectedEdgeCount(),o=i+n,r=this.options.locales[this.options.locale],s=!1;!1!==this.options.addNode&&(this._createAddNodeButton(r),s=!0),!1!==this.options.addEdge&&(!0===s?this._createSeperator(1):s=!0,this._createAddEdgeButton(r)),1===i&&"function"==typeof this.options.editNode?(!0===s?this._createSeperator(2):s=!0,this._createEditNodeButton(r)):1===n&&0===i&&!1!==this.options.editEdge&&(!0===s?this._createSeperator(3):s=!0,this._createEditEdgeButton(r)),0!==o&&(i>0&&!1!==this.options.deleteNode||0===i&&!1!==this.options.deleteEdge)&&(!0===s&&this._createSeperator(4),this._createDeleteButton(r)),this._bindElementEvents(this.closeDiv,Hn(t=this.toggleEditMode).call(t,this)),this._temporaryBindEvent("select",Hn(e=this.showManipulatorToolbar).call(e,this));}this.body.emitter.emit("_redraw");}},{key:"addNodeMode",value:function value(){var t;if(!0!==this.editMode&&this.enableEditMode(),this._clean(),this.inMode="addNode",!0===this.guiEnabled){var e,i=this.options.locales[this.options.locale];this.manipulationDOM={},this._createBackButton(i),this._createSeperator(),this._createDescription(i.addDescription||this.options.locales.en.addDescription),this._bindElementEvents(this.closeDiv,Hn(e=this.toggleEditMode).call(e,this));}this._temporaryBindEvent("click",Hn(t=this._performAddNode).call(t,this));}},{key:"editNode",value:function value(){var t=this;!0!==this.editMode&&this.enableEditMode(),this._clean();var e=this.selectionHandler.getSelectedNodes()[0];if(void 0!==e){if(this.inMode="editNode","function"!=typeof this.options.editNode)throw new Error("No function has been configured to handle the editing of nodes.");if(!0!==e.isCluster){var i=gb({},e.options,!1);if(i.x=e.x,i.y=e.y,2!==this.options.editNode.length)throw new Error("The function for edit does not support two arguments (data, callback)");this.options.editNode(i,function(e){null!=e&&"editNode"===t.inMode&&t.body.data.nodes.getDataSet().update(e),t.showManipulatorToolbar();});}else alert(this.options.locales[this.options.locale].editClusterError||this.options.locales.en.editClusterError);}else this.showManipulatorToolbar();}},{key:"addEdgeMode",value:function value(){var t,e,i,n,o;if(!0!==this.editMode&&this.enableEditMode(),this._clean(),this.inMode="addEdge",!0===this.guiEnabled){var r,s=this.options.locales[this.options.locale];this.manipulationDOM={},this._createBackButton(s),this._createSeperator(),this._createDescription(s.edgeDescription||this.options.locales.en.edgeDescription),this._bindElementEvents(this.closeDiv,Hn(r=this.toggleEditMode).call(r,this));}this._temporaryBindUI("onTouch",Hn(t=this._handleConnect).call(t,this)),this._temporaryBindUI("onDragEnd",Hn(e=this._finishConnect).call(e,this)),this._temporaryBindUI("onDrag",Hn(i=this._dragControlNode).call(i,this)),this._temporaryBindUI("onRelease",Hn(n=this._finishConnect).call(n,this)),this._temporaryBindUI("onDragStart",Hn(o=this._dragStartEdge).call(o,this)),this._temporaryBindUI("onHold",function(){});}},{key:"editEdgeMode",value:function value(){if(!0!==this.editMode&&this.enableEditMode(),this._clean(),this.inMode="editEdge","object"!==bu(this.options.editEdge)||"function"!=typeof this.options.editEdge.editWithoutDrag||(this.edgeBeingEditedId=this.selectionHandler.getSelectedEdgeIds()[0],void 0===this.edgeBeingEditedId)){if(!0===this.guiEnabled){var t,e=this.options.locales[this.options.locale];this.manipulationDOM={},this._createBackButton(e),this._createSeperator(),this._createDescription(e.editEdgeDescription||this.options.locales.en.editEdgeDescription),this._bindElementEvents(this.closeDiv,Hn(t=this.toggleEditMode).call(t,this));}if(this.edgeBeingEditedId=this.selectionHandler.getSelectedEdgeIds()[0],void 0!==this.edgeBeingEditedId){var i,n,o,r,s=this.body.edges[this.edgeBeingEditedId],a=this._getNewTargetNode(s.from.x,s.from.y),h=this._getNewTargetNode(s.to.x,s.to.y);this.temporaryIds.nodes.push(a.id),this.temporaryIds.nodes.push(h.id),this.body.nodes[a.id]=a,this.body.nodeIndices.push(a.id),this.body.nodes[h.id]=h,this.body.nodeIndices.push(h.id),this._temporaryBindUI("onTouch",Hn(i=this._controlNodeTouch).call(i,this)),this._temporaryBindUI("onTap",function(){}),this._temporaryBindUI("onHold",function(){}),this._temporaryBindUI("onDragStart",Hn(n=this._controlNodeDragStart).call(n,this)),this._temporaryBindUI("onDrag",Hn(o=this._controlNodeDrag).call(o,this)),this._temporaryBindUI("onDragEnd",Hn(r=this._controlNodeDragEnd).call(r,this)),this._temporaryBindUI("onMouseMove",function(){}),this._temporaryBindEvent("beforeDrawing",function(t){var e=s.edgeType.findBorderPositions(t);!1===a.selected&&(a.x=e.from.x,a.y=e.from.y),!1===h.selected&&(h.x=e.to.x,h.y=e.to.y);}),this.body.emitter.emit("_redraw");}else this.showManipulatorToolbar();}else{var l=this.body.edges[this.edgeBeingEditedId];this._performEditEdge(l.from.id,l.to.id);}}},{key:"deleteSelected",value:function value(){var t=this;!0!==this.editMode&&this.enableEditMode(),this._clean(),this.inMode="delete";var e=this.selectionHandler.getSelectedNodeIds(),i=this.selectionHandler.getSelectedEdgeIds(),n=void 0;if(e.length>0){for(var o=0;o<e.length;o++)if(!0===this.body.nodes[e[o]].isCluster)return void alert(this.options.locales[this.options.locale].deleteClusterError||this.options.locales.en.deleteClusterError);"function"==typeof this.options.deleteNode&&(n=this.options.deleteNode);}else i.length>0&&"function"==typeof this.options.deleteEdge&&(n=this.options.deleteEdge);if("function"==typeof n){var r={nodes:e,edges:i};if(2!==n.length)throw new Error("The function for delete does not support two arguments (data, callback)");n(r,function(e){null!=e&&"delete"===t.inMode?(t.body.data.edges.getDataSet().remove(e.edges),t.body.data.nodes.getDataSet().remove(e.nodes),t.body.emitter.emit("startSimulation"),t.showManipulatorToolbar()):(t.body.emitter.emit("startSimulation"),t.showManipulatorToolbar());});}else this.body.data.edges.getDataSet().remove(i),this.body.data.nodes.getDataSet().remove(e),this.body.emitter.emit("startSimulation"),this.showManipulatorToolbar();}},{key:"_setup",value:function value(){!0===this.options.enabled?(this.guiEnabled=!0,this._createWrappers(),!1===this.editMode?this._createEditButton():this.showManipulatorToolbar()):(this._removeManipulationDOM(),this.guiEnabled=!1);}},{key:"_createWrappers",value:function value(){var t,e;(void 0===this.manipulationDiv&&(this.manipulationDiv=document.createElement("div"),this.manipulationDiv.className="vis-manipulation",!0===this.editMode?this.manipulationDiv.style.display="block":this.manipulationDiv.style.display="none",this.canvas.frame.appendChild(this.manipulationDiv)),void 0===this.editModeDiv&&(this.editModeDiv=document.createElement("div"),this.editModeDiv.className="vis-edit-mode",!0===this.editMode?this.editModeDiv.style.display="none":this.editModeDiv.style.display="block",this.canvas.frame.appendChild(this.editModeDiv)),void 0===this.closeDiv)&&(this.closeDiv=document.createElement("button"),this.closeDiv.className="vis-close",this.closeDiv.setAttribute("aria-label",null!==(t=null===(e=this.options.locales[this.options.locale])||void 0===e?void 0:e.close)&&void 0!==t?t:this.options.locales.en.close),this.closeDiv.style.display=this.manipulationDiv.style.display,this.canvas.frame.appendChild(this.closeDiv));}},{key:"_getNewTargetNode",value:function value(t,e){var i=gb({},this.options.controlNodeStyle);i.id="targetNode"+zM(),i.hidden=!1,i.physics=!1,i.x=t,i.y=e;var n=this.body.functions.createNode(i);return n.shape.boundingBox={left:t,right:t,top:e,bottom:e},n;}},{key:"_createEditButton",value:function value(){var t;this._clean(),this.manipulationDOM={},hb(this.editModeDiv);var e=this.options.locales[this.options.locale],i=this._createButton("editMode","vis-edit vis-edit-mode",e.edit||this.options.locales.en.edit);this.editModeDiv.appendChild(i),this._bindElementEvents(i,Hn(t=this.toggleEditMode).call(t,this));}},{key:"_clean",value:function value(){this.inMode=!1,!0===this.guiEnabled&&(hb(this.editModeDiv),hb(this.manipulationDiv),this._cleanupDOMEventListeners()),this._cleanupTemporaryNodesAndEdges(),this._unbindTemporaryUIs(),this._unbindTemporaryEvents(),this.body.emitter.emit("restorePhysics");}},{key:"_cleanupDOMEventListeners",value:function value(){var t,e,i=uN(Ap(t=this._domEventListenerCleanupQueue).call(t,0));try{for(i.s();!(e=i.n()).done;){(0,e.value)();}}catch(t){i.e(t);}finally{i.f();}}},{key:"_removeManipulationDOM",value:function value(){this._clean(),hb(this.manipulationDiv),hb(this.editModeDiv),hb(this.closeDiv),this.manipulationDiv&&this.canvas.frame.removeChild(this.manipulationDiv),this.editModeDiv&&this.canvas.frame.removeChild(this.editModeDiv),this.closeDiv&&this.canvas.frame.removeChild(this.closeDiv),this.manipulationDiv=void 0,this.editModeDiv=void 0,this.closeDiv=void 0;}},{key:"_createSeperator",value:function value(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;this.manipulationDOM["seperatorLineDiv"+t]=document.createElement("div"),this.manipulationDOM["seperatorLineDiv"+t].className="vis-separator-line",this.manipulationDiv.appendChild(this.manipulationDOM["seperatorLineDiv"+t]);}},{key:"_createAddNodeButton",value:function value(t){var e,i=this._createButton("addNode","vis-add",t.addNode||this.options.locales.en.addNode);this.manipulationDiv.appendChild(i),this._bindElementEvents(i,Hn(e=this.addNodeMode).call(e,this));}},{key:"_createAddEdgeButton",value:function value(t){var e,i=this._createButton("addEdge","vis-connect",t.addEdge||this.options.locales.en.addEdge);this.manipulationDiv.appendChild(i),this._bindElementEvents(i,Hn(e=this.addEdgeMode).call(e,this));}},{key:"_createEditNodeButton",value:function value(t){var e,i=this._createButton("editNode","vis-edit",t.editNode||this.options.locales.en.editNode);this.manipulationDiv.appendChild(i),this._bindElementEvents(i,Hn(e=this.editNode).call(e,this));}},{key:"_createEditEdgeButton",value:function value(t){var e,i=this._createButton("editEdge","vis-edit",t.editEdge||this.options.locales.en.editEdge);this.manipulationDiv.appendChild(i),this._bindElementEvents(i,Hn(e=this.editEdgeMode).call(e,this));}},{key:"_createDeleteButton",value:function value(t){var e,i;i=this.options.rtl?"vis-delete-rtl":"vis-delete";var n=this._createButton("delete",i,t.del||this.options.locales.en.del);this.manipulationDiv.appendChild(n),this._bindElementEvents(n,Hn(e=this.deleteSelected).call(e,this));}},{key:"_createBackButton",value:function value(t){var e,i=this._createButton("back","vis-back",t.back||this.options.locales.en.back);this.manipulationDiv.appendChild(i),this._bindElementEvents(i,Hn(e=this.showManipulatorToolbar).call(e,this));}},{key:"_createButton",value:function value(t,e,i){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"vis-label";return this.manipulationDOM[t+"Div"]=document.createElement("button"),this.manipulationDOM[t+"Div"].className="vis-button "+e,this.manipulationDOM[t+"Label"]=document.createElement("div"),this.manipulationDOM[t+"Label"].className=n,this.manipulationDOM[t+"Label"].innerText=i,this.manipulationDOM[t+"Div"].appendChild(this.manipulationDOM[t+"Label"]),this.manipulationDOM[t+"Div"];}},{key:"_createDescription",value:function value(t){this.manipulationDOM.descriptionLabel=document.createElement("div"),this.manipulationDOM.descriptionLabel.className="vis-none",this.manipulationDOM.descriptionLabel.innerText=t,this.manipulationDiv.appendChild(this.manipulationDOM.descriptionLabel);}},{key:"_temporaryBindEvent",value:function value(t,e){this.temporaryEventFunctions.push({event:t,boundFunction:e}),this.body.emitter.on(t,e);}},{key:"_temporaryBindUI",value:function value(t,e){if(void 0===this.body.eventListeners[t])throw new Error("This UI function does not exist. Typo? You tried: "+t+" possible are: "+mg(Hf(this.body.eventListeners)));this.temporaryUIFunctions[t]=this.body.eventListeners[t],this.body.eventListeners[t]=e;}},{key:"_unbindTemporaryUIs",value:function value(){for(var t in this.temporaryUIFunctions)Object.prototype.hasOwnProperty.call(this.temporaryUIFunctions,t)&&(this.body.eventListeners[t]=this.temporaryUIFunctions[t],delete this.temporaryUIFunctions[t]);this.temporaryUIFunctions={};}},{key:"_unbindTemporaryEvents",value:function value(){for(var t=0;t<this.temporaryEventFunctions.length;t++){var e=this.temporaryEventFunctions[t].event,i=this.temporaryEventFunctions[t].boundFunction;this.body.emitter.off(e,i);}this.temporaryEventFunctions=[];}},{key:"_bindElementEvents",value:function value(t,e){var i=new Qb(t,{});MI(i,e),this._domEventListenerCleanupQueue.push(function(){i.destroy();});var n=function n(t){var i=t.keyCode,n=t.key;"Enter"!==n&&" "!==n&&13!==i&&32!==i||e();};t.addEventListener("keyup",n,!1),this._domEventListenerCleanupQueue.push(function(){t.removeEventListener("keyup",n,!1);});}},{key:"_cleanupTemporaryNodesAndEdges",value:function value(){for(var t=0;t<this.temporaryIds.edges.length;t++){var e;this.body.edges[this.temporaryIds.edges[t]].disconnect(),delete this.body.edges[this.temporaryIds.edges[t]];var i,n=lg(e=this.body.edgeIndices).call(e,this.temporaryIds.edges[t]);if(-1!==n)Ap(i=this.body.edgeIndices).call(i,n,1);}for(var o=0;o<this.temporaryIds.nodes.length;o++){var r;delete this.body.nodes[this.temporaryIds.nodes[o]];var s,a=lg(r=this.body.nodeIndices).call(r,this.temporaryIds.nodes[o]);if(-1!==a)Ap(s=this.body.nodeIndices).call(s,a,1);}this.temporaryIds={nodes:[],edges:[]};}},{key:"_controlNodeTouch",value:function value(t){this.selectionHandler.unselectAll(),this.lastTouch=this.body.functions.getPointer(t.center),this.lastTouch.translation=bn({},this.body.view.translation);}},{key:"_controlNodeDragStart",value:function value(){var t=this.lastTouch,e=this.selectionHandler._pointerToPositionObject(t),i=this.body.nodes[this.temporaryIds.nodes[0]],n=this.body.nodes[this.temporaryIds.nodes[1]],o=this.body.edges[this.edgeBeingEditedId];this.selectedControlNode=void 0;var r=i.isOverlappingWith(e),s=n.isOverlappingWith(e);!0===r?(this.selectedControlNode=i,o.edgeType.from=i):!0===s&&(this.selectedControlNode=n,o.edgeType.to=n),void 0!==this.selectedControlNode&&this.selectionHandler.selectObject(this.selectedControlNode),this.body.emitter.emit("_redraw");}},{key:"_controlNodeDrag",value:function value(t){this.body.emitter.emit("disablePhysics");var e=this.body.functions.getPointer(t.center),i=this.canvas.DOMtoCanvas(e);void 0!==this.selectedControlNode?(this.selectedControlNode.x=i.x,this.selectedControlNode.y=i.y):this.interactionHandler.onDrag(t),this.body.emitter.emit("_redraw");}},{key:"_controlNodeDragEnd",value:function value(t){var e=this.body.functions.getPointer(t.center),i=this.selectionHandler._pointerToPositionObject(e),n=this.body.edges[this.edgeBeingEditedId];if(void 0!==this.selectedControlNode){this.selectionHandler.unselectAll();for(var o=this.selectionHandler._getAllNodesOverlappingWith(i),r=void 0,s=o.length-1;s>=0;s--)if(o[s]!==this.selectedControlNode.id){r=this.body.nodes[o[s]];break;}if(void 0!==r&&void 0!==this.selectedControlNode){if(!0===r.isCluster)alert(this.options.locales[this.options.locale].createEdgeError||this.options.locales.en.createEdgeError);else{var a=this.body.nodes[this.temporaryIds.nodes[0]];this.selectedControlNode.id===a.id?this._performEditEdge(r.id,n.to.id):this._performEditEdge(n.from.id,r.id);}}else n.updateEdgeType(),this.body.emitter.emit("restorePhysics");this.body.emitter.emit("_redraw");}}},{key:"_handleConnect",value:function value(t){if(new Date().valueOf()-this.touchTime>100){this.lastTouch=this.body.functions.getPointer(t.center),this.lastTouch.translation=bn({},this.body.view.translation),this.interactionHandler.drag.pointer=this.lastTouch,this.interactionHandler.drag.translation=this.lastTouch.translation;var e=this.lastTouch,i=this.selectionHandler.getNodeAt(e);if(void 0!==i)if(!0===i.isCluster)alert(this.options.locales[this.options.locale].createEdgeError||this.options.locales.en.createEdgeError);else{var n=this._getNewTargetNode(i.x,i.y);this.body.nodes[n.id]=n,this.body.nodeIndices.push(n.id);var o=this.body.functions.createEdge({id:"connectionEdge"+zM(),from:i.id,to:n.id,physics:!1,smooth:{enabled:!0,type:"continuous",roundness:.5}});this.body.edges[o.id]=o,this.body.edgeIndices.push(o.id),this.temporaryIds.nodes.push(n.id),this.temporaryIds.edges.push(o.id);}this.touchTime=new Date().valueOf();}}},{key:"_dragControlNode",value:function value(t){var e=this.body.functions.getPointer(t.center),i=this.selectionHandler._pointerToPositionObject(e),n=void 0;void 0!==this.temporaryIds.edges[0]&&(n=this.body.edges[this.temporaryIds.edges[0]].fromId);for(var o=this.selectionHandler._getAllNodesOverlappingWith(i),r=void 0,s=o.length-1;s>=0;s--){var a;if(-1===lg(a=this.temporaryIds.nodes).call(a,o[s])){r=this.body.nodes[o[s]];break;}}if(t.controlEdge={from:n,to:r?r.id:void 0},this.selectionHandler.generateClickEvent("controlNodeDragging",t,e),void 0!==this.temporaryIds.nodes[0]){var h=this.body.nodes[this.temporaryIds.nodes[0]];h.x=this.canvas._XconvertDOMtoCanvas(e.x),h.y=this.canvas._YconvertDOMtoCanvas(e.y),this.body.emitter.emit("_redraw");}else this.interactionHandler.onDrag(t);}},{key:"_finishConnect",value:function value(t){var e=this.body.functions.getPointer(t.center),i=this.selectionHandler._pointerToPositionObject(e),n=void 0;void 0!==this.temporaryIds.edges[0]&&(n=this.body.edges[this.temporaryIds.edges[0]].fromId);for(var o=this.selectionHandler._getAllNodesOverlappingWith(i),r=void 0,s=o.length-1;s>=0;s--){var a;if(-1===lg(a=this.temporaryIds.nodes).call(a,o[s])){r=this.body.nodes[o[s]];break;}}this._cleanupTemporaryNodesAndEdges(),void 0!==r&&(!0===r.isCluster?alert(this.options.locales[this.options.locale].createEdgeError||this.options.locales.en.createEdgeError):void 0!==this.body.nodes[n]&&void 0!==this.body.nodes[r.id]&&this._performAddEdge(n,r.id)),t.controlEdge={from:n,to:r?r.id:void 0},this.selectionHandler.generateClickEvent("controlNodeDragEnd",t,e),this.body.emitter.emit("_redraw");}},{key:"_dragStartEdge",value:function value(t){var e=this.lastTouch;this.selectionHandler.generateClickEvent("dragStart",t,e,void 0,!0);}},{key:"_performAddNode",value:function value(t){var e=this,i={id:zM(),x:t.pointer.canvas.x,y:t.pointer.canvas.y,label:"new"};if("function"==typeof this.options.addNode){if(2!==this.options.addNode.length)throw this.showManipulatorToolbar(),new Error("The function for add does not support two arguments (data,callback)");this.options.addNode(i,function(t){null!=t&&"addNode"===e.inMode&&e.body.data.nodes.getDataSet().add(t),e.showManipulatorToolbar();});}else this.body.data.nodes.getDataSet().add(i),this.showManipulatorToolbar();}},{key:"_performAddEdge",value:function value(t,e){var i=this,n={from:t,to:e};if("function"==typeof this.options.addEdge){if(2!==this.options.addEdge.length)throw new Error("The function for connect does not support two arguments (data,callback)");this.options.addEdge(n,function(t){null!=t&&"addEdge"===i.inMode&&(i.body.data.edges.getDataSet().add(t),i.selectionHandler.unselectAll(),i.showManipulatorToolbar());});}else this.body.data.edges.getDataSet().add(n),this.selectionHandler.unselectAll(),this.showManipulatorToolbar();}},{key:"_performEditEdge",value:function value(t,e){var i=this,n={id:this.edgeBeingEditedId,from:t,to:e,label:this.body.data.edges.get(this.edgeBeingEditedId).label},o=this.options.editEdge;if("object"===bu(o)&&(o=o.editWithoutDrag),"function"==typeof o){if(2!==o.length)throw new Error("The function for edit does not support two arguments (data, callback)");o(n,function(t){null==t||"editEdge"!==i.inMode?(i.body.edges[n.id].updateEdgeType(),i.body.emitter.emit("_redraw"),i.showManipulatorToolbar()):(i.body.data.edges.getDataSet().update(t),i.selectionHandler.unselectAll(),i.showManipulatorToolbar());});}else this.body.data.edges.getDataSet().update(n),this.selectionHandler.unselectAll(),this.showManipulatorToolbar();}}]),t;}(),vN="string",gN="boolean",yN="number",mN="array",bN="object",wN=["arrow","bar","box","circle","crow","curve","diamond","image","inv_curve","inv_triangle","triangle","vee"],kN={borderWidth:{number:yN},borderWidthSelected:{number:yN,undefined:"undefined"},brokenImage:{string:vN,undefined:"undefined"},chosen:{label:{"boolean":gN,"function":"function"},node:{"boolean":gN,"function":"function"},__type__:{object:bN,"boolean":gN}},color:{border:{string:vN},background:{string:vN},highlight:{border:{string:vN},background:{string:vN},__type__:{object:bN,string:vN}},hover:{border:{string:vN},background:{string:vN},__type__:{object:bN,string:vN}},__type__:{object:bN,string:vN}},opacity:{number:yN,undefined:"undefined"},fixed:{x:{"boolean":gN},y:{"boolean":gN},__type__:{object:bN,"boolean":gN}},font:{align:{string:vN},color:{string:vN},size:{number:yN},face:{string:vN},background:{string:vN},strokeWidth:{number:yN},strokeColor:{string:vN},vadjust:{number:yN},multi:{"boolean":gN,string:vN},bold:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},boldital:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},ital:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},mono:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},__type__:{object:bN,string:vN}},group:{string:vN,number:yN,undefined:"undefined"},heightConstraint:{minimum:{number:yN},valign:{string:vN},__type__:{object:bN,"boolean":gN,number:yN}},hidden:{"boolean":gN},icon:{face:{string:vN},code:{string:vN},size:{number:yN},color:{string:vN},weight:{string:vN,number:yN},__type__:{object:bN}},id:{string:vN,number:yN},image:{selected:{string:vN,undefined:"undefined"},unselected:{string:vN,undefined:"undefined"},__type__:{object:bN,string:vN}},imagePadding:{top:{number:yN},right:{number:yN},bottom:{number:yN},left:{number:yN},__type__:{object:bN,number:yN}},label:{string:vN,undefined:"undefined"},labelHighlightBold:{"boolean":gN},level:{number:yN,undefined:"undefined"},margin:{top:{number:yN},right:{number:yN},bottom:{number:yN},left:{number:yN},__type__:{object:bN,number:yN}},mass:{number:yN},physics:{"boolean":gN},scaling:{min:{number:yN},max:{number:yN},label:{enabled:{"boolean":gN},min:{number:yN},max:{number:yN},maxVisible:{number:yN},drawThreshold:{number:yN},__type__:{object:bN,"boolean":gN}},customScalingFunction:{"function":"function"},__type__:{object:bN}},shadow:{enabled:{"boolean":gN},color:{string:vN},size:{number:yN},x:{number:yN},y:{number:yN},__type__:{object:bN,"boolean":gN}},shape:{string:["custom","ellipse","circle","database","box","text","image","circularImage","diamond","dot","star","triangle","triangleDown","square","icon","hexagon"]},ctxRenderer:{"function":"function"},shapeProperties:{borderDashes:{"boolean":gN,array:mN},borderRadius:{number:yN},interpolation:{"boolean":gN},useImageSize:{"boolean":gN},useBorderWithImage:{"boolean":gN},coordinateOrigin:{string:["center","top-left"]},__type__:{object:bN}},size:{number:yN},title:{string:vN,dom:"dom",undefined:"undefined"},value:{number:yN,undefined:"undefined"},widthConstraint:{minimum:{number:yN},maximum:{number:yN},__type__:{object:bN,"boolean":gN,number:yN}},x:{number:yN},y:{number:yN},__type__:{object:bN}},_N={configure:{enabled:{"boolean":gN},filter:{"boolean":gN,string:vN,array:mN,"function":"function"},container:{dom:"dom"},showButton:{"boolean":gN},__type__:{object:bN,"boolean":gN,string:vN,array:mN,"function":"function"}},edges:{arrows:{to:{enabled:{"boolean":gN},scaleFactor:{number:yN},type:{string:wN},imageHeight:{number:yN},imageWidth:{number:yN},src:{string:vN},__type__:{object:bN,"boolean":gN}},middle:{enabled:{"boolean":gN},scaleFactor:{number:yN},type:{string:wN},imageWidth:{number:yN},imageHeight:{number:yN},src:{string:vN},__type__:{object:bN,"boolean":gN}},from:{enabled:{"boolean":gN},scaleFactor:{number:yN},type:{string:wN},imageWidth:{number:yN},imageHeight:{number:yN},src:{string:vN},__type__:{object:bN,"boolean":gN}},__type__:{string:["from","to","middle"],object:bN}},endPointOffset:{from:{number:yN},to:{number:yN},__type__:{object:bN,number:yN}},arrowStrikethrough:{"boolean":gN},background:{enabled:{"boolean":gN},color:{string:vN},size:{number:yN},dashes:{"boolean":gN,array:mN},__type__:{object:bN,"boolean":gN}},chosen:{label:{"boolean":gN,"function":"function"},edge:{"boolean":gN,"function":"function"},__type__:{object:bN,"boolean":gN}},color:{color:{string:vN},highlight:{string:vN},hover:{string:vN},inherit:{string:["from","to","both"],"boolean":gN},opacity:{number:yN},__type__:{object:bN,string:vN}},dashes:{"boolean":gN,array:mN},font:{color:{string:vN},size:{number:yN},face:{string:vN},background:{string:vN},strokeWidth:{number:yN},strokeColor:{string:vN},align:{string:["horizontal","top","middle","bottom"]},vadjust:{number:yN},multi:{"boolean":gN,string:vN},bold:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},boldital:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},ital:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},mono:{color:{string:vN},size:{number:yN},face:{string:vN},mod:{string:vN},vadjust:{number:yN},__type__:{object:bN,string:vN}},__type__:{object:bN,string:vN}},hidden:{"boolean":gN},hoverWidth:{"function":"function",number:yN},label:{string:vN,undefined:"undefined"},labelHighlightBold:{"boolean":gN},length:{number:yN,undefined:"undefined"},physics:{"boolean":gN},scaling:{min:{number:yN},max:{number:yN},label:{enabled:{"boolean":gN},min:{number:yN},max:{number:yN},maxVisible:{number:yN},drawThreshold:{number:yN},__type__:{object:bN,"boolean":gN}},customScalingFunction:{"function":"function"},__type__:{object:bN}},selectionWidth:{"function":"function",number:yN},selfReferenceSize:{number:yN},selfReference:{size:{number:yN},angle:{number:yN},renderBehindTheNode:{"boolean":gN},__type__:{object:bN}},shadow:{enabled:{"boolean":gN},color:{string:vN},size:{number:yN},x:{number:yN},y:{number:yN},__type__:{object:bN,"boolean":gN}},smooth:{enabled:{"boolean":gN},type:{string:["dynamic","continuous","discrete","diagonalCross","straightCross","horizontal","vertical","curvedCW","curvedCCW","cubicBezier"]},roundness:{number:yN},forceDirection:{string:["horizontal","vertical","none"],"boolean":gN},__type__:{object:bN,"boolean":gN}},title:{string:vN,undefined:"undefined"},width:{number:yN},widthConstraint:{maximum:{number:yN},__type__:{object:bN,"boolean":gN,number:yN}},value:{number:yN,undefined:"undefined"},__type__:{object:bN}},groups:{useDefaultGroups:{"boolean":gN},__any__:kN,__type__:{object:bN}},interaction:{dragNodes:{"boolean":gN},dragView:{"boolean":gN},hideEdgesOnDrag:{"boolean":gN},hideEdgesOnZoom:{"boolean":gN},hideNodesOnDrag:{"boolean":gN},hover:{"boolean":gN},keyboard:{enabled:{"boolean":gN},speed:{x:{number:yN},y:{number:yN},zoom:{number:yN},__type__:{object:bN}},bindToWindow:{"boolean":gN},autoFocus:{"boolean":gN},__type__:{object:bN,"boolean":gN}},multiselect:{"boolean":gN},navigationButtons:{"boolean":gN},selectable:{"boolean":gN},selectConnectedEdges:{"boolean":gN},hoverConnectedEdges:{"boolean":gN},tooltipDelay:{number:yN},zoomView:{"boolean":gN},zoomSpeed:{number:yN},__type__:{object:bN}},layout:{randomSeed:{undefined:"undefined",number:yN,string:vN},improvedLayout:{"boolean":gN},clusterThreshold:{number:yN},hierarchical:{enabled:{"boolean":gN},levelSeparation:{number:yN},nodeSpacing:{number:yN},treeSpacing:{number:yN},blockShifting:{"boolean":gN},edgeMinimization:{"boolean":gN},parentCentralization:{"boolean":gN},direction:{string:["UD","DU","LR","RL"]},sortMethod:{string:["hubsize","directed"]},shakeTowards:{string:["leaves","roots"]},__type__:{object:bN,"boolean":gN}},__type__:{object:bN}},manipulation:{enabled:{"boolean":gN},initiallyActive:{"boolean":gN},addNode:{"boolean":gN,"function":"function"},addEdge:{"boolean":gN,"function":"function"},editNode:{"function":"function"},editEdge:{editWithoutDrag:{"function":"function"},__type__:{object:bN,"boolean":gN,"function":"function"}},deleteNode:{"boolean":gN,"function":"function"},deleteEdge:{"boolean":gN,"function":"function"},controlNodeStyle:kN,__type__:{object:bN,"boolean":gN}},nodes:kN,physics:{enabled:{"boolean":gN},barnesHut:{theta:{number:yN},gravitationalConstant:{number:yN},centralGravity:{number:yN},springLength:{number:yN},springConstant:{number:yN},damping:{number:yN},avoidOverlap:{number:yN},__type__:{object:bN}},forceAtlas2Based:{theta:{number:yN},gravitationalConstant:{number:yN},centralGravity:{number:yN},springLength:{number:yN},springConstant:{number:yN},damping:{number:yN},avoidOverlap:{number:yN},__type__:{object:bN}},repulsion:{centralGravity:{number:yN},springLength:{number:yN},springConstant:{number:yN},nodeDistance:{number:yN},damping:{number:yN},__type__:{object:bN}},hierarchicalRepulsion:{centralGravity:{number:yN},springLength:{number:yN},springConstant:{number:yN},nodeDistance:{number:yN},damping:{number:yN},avoidOverlap:{number:yN},__type__:{object:bN}},maxVelocity:{number:yN},minVelocity:{number:yN},solver:{string:["barnesHut","repulsion","hierarchicalRepulsion","forceAtlas2Based"]},stabilization:{enabled:{"boolean":gN},iterations:{number:yN},updateInterval:{number:yN},onlyDynamicEdges:{"boolean":gN},fit:{"boolean":gN},__type__:{object:bN,"boolean":gN}},timestep:{number:yN},adaptiveTimestep:{"boolean":gN},wind:{x:{number:yN},y:{number:yN},__type__:{object:bN}},__type__:{object:bN,"boolean":gN}},autoResize:{"boolean":gN},clickToUse:{"boolean":gN},locale:{string:vN},locales:{__any__:{any:"any"},__type__:{object:bN}},height:{string:vN},width:{string:vN},__type__:{object:bN}},xN={nodes:{borderWidth:[1,0,10,1],borderWidthSelected:[2,0,10,1],color:{border:["color","#2B7CE9"],background:["color","#97C2FC"],highlight:{border:["color","#2B7CE9"],background:["color","#D2E5FF"]},hover:{border:["color","#2B7CE9"],background:["color","#D2E5FF"]}},opacity:[0,0,1,.1],fixed:{x:!1,y:!1},font:{color:["color","#343434"],size:[14,0,100,1],face:["arial","verdana","tahoma"],background:["color","none"],strokeWidth:[0,0,50,1],strokeColor:["color","#ffffff"]},hidden:!1,labelHighlightBold:!0,physics:!0,scaling:{min:[10,0,200,1],max:[30,0,200,1],label:{enabled:!1,min:[14,0,200,1],max:[30,0,200,1],maxVisible:[30,0,200,1],drawThreshold:[5,0,20,1]}},shadow:{enabled:!1,color:"rgba(0,0,0,0.5)",size:[10,0,20,1],x:[5,-30,30,1],y:[5,-30,30,1]},shape:["ellipse","box","circle","database","diamond","dot","square","star","text","triangle","triangleDown","hexagon"],shapeProperties:{borderDashes:!1,borderRadius:[6,0,20,1],interpolation:!0,useImageSize:!1},size:[25,0,200,1]},edges:{arrows:{to:{enabled:!1,scaleFactor:[1,0,3,.05],type:"arrow"},middle:{enabled:!1,scaleFactor:[1,0,3,.05],type:"arrow"},from:{enabled:!1,scaleFactor:[1,0,3,.05],type:"arrow"}},endPointOffset:{from:[0,-10,10,1],to:[0,-10,10,1]},arrowStrikethrough:!0,color:{color:["color","#848484"],highlight:["color","#848484"],hover:["color","#848484"],inherit:["from","to","both",!0,!1],opacity:[1,0,1,.05]},dashes:!1,font:{color:["color","#343434"],size:[14,0,100,1],face:["arial","verdana","tahoma"],background:["color","none"],strokeWidth:[2,0,50,1],strokeColor:["color","#ffffff"],align:["horizontal","top","middle","bottom"]},hidden:!1,hoverWidth:[1.5,0,5,.1],labelHighlightBold:!0,physics:!0,scaling:{min:[1,0,100,1],max:[15,0,100,1],label:{enabled:!0,min:[14,0,200,1],max:[30,0,200,1],maxVisible:[30,0,200,1],drawThreshold:[5,0,20,1]}},selectionWidth:[1.5,0,5,.1],selfReferenceSize:[20,0,200,1],selfReference:{size:[20,0,200,1],angle:[Math.PI/2,-6*Math.PI,6*Math.PI,Math.PI/8],renderBehindTheNode:!0},shadow:{enabled:!1,color:"rgba(0,0,0,0.5)",size:[10,0,20,1],x:[5,-30,30,1],y:[5,-30,30,1]},smooth:{enabled:!0,type:["dynamic","continuous","discrete","diagonalCross","straightCross","horizontal","vertical","curvedCW","curvedCCW","cubicBezier"],forceDirection:["horizontal","vertical","none"],roundness:[.5,0,1,.05]},width:[1,0,30,1]},layout:{hierarchical:{enabled:!1,levelSeparation:[150,20,500,5],nodeSpacing:[100,20,500,5],treeSpacing:[200,20,500,5],blockShifting:!0,edgeMinimization:!0,parentCentralization:!0,direction:["UD","DU","LR","RL"],sortMethod:["hubsize","directed"],shakeTowards:["leaves","roots"]}},interaction:{dragNodes:!0,dragView:!0,hideEdgesOnDrag:!1,hideEdgesOnZoom:!1,hideNodesOnDrag:!1,hover:!1,keyboard:{enabled:!1,speed:{x:[10,0,40,1],y:[10,0,40,1],zoom:[.02,0,.1,.005]},bindToWindow:!0,autoFocus:!0},multiselect:!1,navigationButtons:!1,selectable:!0,selectConnectedEdges:!0,hoverConnectedEdges:!0,tooltipDelay:[300,0,1e3,25],zoomView:!0,zoomSpeed:[1,.1,2,.1]},manipulation:{enabled:!1,initiallyActive:!1},physics:{enabled:!0,barnesHut:{theta:[.5,.1,1,.05],gravitationalConstant:[-2e3,-3e4,0,50],centralGravity:[.3,0,10,.05],springLength:[95,0,500,5],springConstant:[.04,0,1.2,.005],damping:[.09,0,1,.01],avoidOverlap:[0,0,1,.01]},forceAtlas2Based:{theta:[.5,.1,1,.05],gravitationalConstant:[-50,-500,0,1],centralGravity:[.01,0,1,.005],springLength:[95,0,500,5],springConstant:[.08,0,1.2,.005],damping:[.4,0,1,.01],avoidOverlap:[0,0,1,.01]},repulsion:{centralGravity:[.2,0,10,.05],springLength:[200,0,500,5],springConstant:[.05,0,1.2,.005],nodeDistance:[100,0,500,5],damping:[.09,0,1,.01]},hierarchicalRepulsion:{centralGravity:[.2,0,10,.05],springLength:[100,0,500,5],springConstant:[.01,0,1.2,.005],nodeDistance:[120,0,500,5],damping:[.09,0,1,.01],avoidOverlap:[0,0,1,.01]},maxVelocity:[50,0,150,1],minVelocity:[.1,.01,.5,.01],solver:["barnesHut","forceAtlas2Based","repulsion","hierarchicalRepulsion"],timestep:[.5,.01,1,.01],wind:{x:[0,-10,10,.1],y:[0,-10,10,.1]}}},EN=function EN(t,e,i){var n;return!(!rv(t).call(t,"physics")||!rv(n=xN.physics.solver).call(n,e)||i.physics.solver===e||"wind"===e);},ON=Object.freeze({__proto__:null,allOptions:_N,configuratorHideOption:EN,configureOptions:xN}),CN=function(){function t(){ph(this,t);}return xu(t,[{key:"getDistances",value:function value(t,e,i){for(var n={},o=t.edges,r=0;r<e.length;r++){var s={};n[e[r]]=s;for(var a=0;a<e.length;a++)s[e[a]]=r==a?0:1e9;}for(var h=0;h<i.length;h++){var l=o[i[h]];!0===l.connected&&void 0!==n[l.fromId]&&void 0!==n[l.toId]&&(n[l.fromId][l.toId]=1,n[l.toId][l.fromId]=1);}for(var d=e.length,c=0;c<d;c++)for(var u=e[c],f=n[u],p=0;p<d-1;p++)for(var v=e[p],g=n[v],y=p+1;y<d;y++){var m=e[y],b=n[m],w=Math.min(g[m],g[u]+f[m]);g[m]=w,b[v]=w;}return n;}}]),t;}(),SN=function(){function t(e,i,n){ph(this,t),this.body=e,this.springLength=i,this.springConstant=n,this.distanceSolver=new CN();}return xu(t,[{key:"setOptions",value:function value(t){t&&(t.springLength&&(this.springLength=t.springLength),t.springConstant&&(this.springConstant=t.springConstant));}},{key:"solve",value:function value(t,e){var i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=this.distanceSolver.getDistances(this.body,t,e);this._createL_matrix(n),this._createK_matrix(n),this._createE_matrix();for(var o=0,r=Math.max(1e3,Math.min(10*this.body.nodeIndices.length,6e3)),s=1e9,a=0,h=0,l=0,d=0,c=0;s>.01&&o<r;){o+=1;var u=pf(this._getHighestEnergyNode(i),4);for(a=u[0],s=u[1],h=u[2],l=u[3],d=s,c=0;d>1&&c<5;){c+=1,this._moveNode(a,h,l);var f=pf(this._getEnergy(a),3);d=f[0],h=f[1],l=f[2];}}}},{key:"_getHighestEnergyNode",value:function value(t){for(var e=this.body.nodeIndices,i=this.body.nodes,n=0,o=e[0],r=0,s=0,a=0;a<e.length;a++){var h=e[a];if(!0!==i[h].predefinedPosition||!0===i[h].isCluster&&!0===t||!0!==i[h].options.fixed.x||!0!==i[h].options.fixed.y){var l=pf(this._getEnergy(h),3),d=l[0],c=l[1],u=l[2];n<d&&(n=d,o=h,r=c,s=u);}}return[o,n,r,s];}},{key:"_getEnergy",value:function value(t){var e=pf(this.E_sums[t],2),i=e[0],n=e[1];return[Math.sqrt(Math.pow(i,2)+Math.pow(n,2)),i,n];}},{key:"_moveNode",value:function value(t,e,i){for(var n=this.body.nodeIndices,o=this.body.nodes,r=0,s=0,a=0,h=o[t].x,l=o[t].y,d=this.K_matrix[t],c=this.L_matrix[t],u=0;u<n.length;u++){var f=n[u];if(f!==t){var p=o[f].x,v=o[f].y,g=d[f],y=c[f],m=1/Math.pow(Math.pow(h-p,2)+Math.pow(l-v,2),1.5);r+=g*(1-y*Math.pow(l-v,2)*m),s+=g*(y*(h-p)*(l-v)*m),a+=g*(1-y*Math.pow(h-p,2)*m);}}var b=(e/r+i/s)/(s/r-a/s),w=-(s*b+e)/r;o[t].x+=w,o[t].y+=b,this._updateE_matrix(t);}},{key:"_createL_matrix",value:function value(t){var e=this.body.nodeIndices,i=this.springLength;this.L_matrix=[];for(var n=0;n<e.length;n++){this.L_matrix[e[n]]={};for(var o=0;o<e.length;o++)this.L_matrix[e[n]][e[o]]=i*t[e[n]][e[o]];}}},{key:"_createK_matrix",value:function value(t){var e=this.body.nodeIndices,i=this.springConstant;this.K_matrix=[];for(var n=0;n<e.length;n++){this.K_matrix[e[n]]={};for(var o=0;o<e.length;o++)this.K_matrix[e[n]][e[o]]=i*Math.pow(t[e[n]][e[o]],-2);}}},{key:"_createE_matrix",value:function value(){var t=this.body.nodeIndices,e=this.body.nodes;this.E_matrix={},this.E_sums={};for(var i=0;i<t.length;i++)this.E_matrix[t[i]]=[];for(var n=0;n<t.length;n++){for(var o=t[n],r=e[o].x,s=e[o].y,a=0,h=0,l=n;l<t.length;l++){var d=t[l];if(d!==o){var c=e[d].x,u=e[d].y,f=1/Math.sqrt(Math.pow(r-c,2)+Math.pow(s-u,2));this.E_matrix[o][l]=[this.K_matrix[o][d]*(r-c-this.L_matrix[o][d]*(r-c)*f),this.K_matrix[o][d]*(s-u-this.L_matrix[o][d]*(s-u)*f)],this.E_matrix[d][n]=this.E_matrix[o][l],a+=this.E_matrix[o][l][0],h+=this.E_matrix[o][l][1];}}this.E_sums[o]=[a,h];}}},{key:"_updateE_matrix",value:function value(t){for(var e=this.body.nodeIndices,i=this.body.nodes,n=this.E_matrix[t],o=this.K_matrix[t],r=this.L_matrix[t],s=i[t].x,a=i[t].y,h=0,l=0,d=0;d<e.length;d++){var c=e[d];if(c!==t){var u=n[d],f=u[0],p=u[1],v=i[c].x,g=i[c].y,y=1/Math.sqrt(Math.pow(s-v,2)+Math.pow(a-g,2)),m=o[c]*(s-v-r[c]*(s-v)*y),b=o[c]*(a-g-r[c]*(a-g)*y);n[d]=[m,b],h+=m,l+=b;var w=this.E_sums[c];w[0]+=m-f,w[1]+=b-p;}}this.E_sums[t]=[h,l];}}]),t;}();function TN(t,e,i){var n,o,r,s,a=this;if(!(this instanceof TN))throw new SyntaxError("Constructor must be called with the new operator");this.options={},this.defaultOptions={locale:"en",locales:Fw,clickToUse:!1},bn(this.options,this.defaultOptions),this.body={container:t,nodes:{},nodeIndices:[],edges:{},edgeIndices:[],emitter:{on:Hn(n=this.on).call(n,this),off:Hn(o=this.off).call(o,this),emit:Hn(r=this.emit).call(r,this),once:Hn(s=this.once).call(s,this)},eventListeners:{onTap:function onTap(){},onTouch:function onTouch(){},onDoubleTap:function onDoubleTap(){},onHold:function onHold(){},onDragStart:function onDragStart(){},onDrag:function onDrag(){},onDragEnd:function onDragEnd(){},onMouseWheel:function onMouseWheel(){},onPinch:function onPinch(){},onMouseMove:function onMouseMove(){},onRelease:function onRelease(){},onContext:function onContext(){}},data:{nodes:null,edges:null},functions:{createNode:function createNode(){},createEdge:function createEdge(){},getPointer:function getPointer(){}},modules:{},view:{scale:1,translation:{x:0,y:0}},selectionBox:{show:!1,position:{start:{x:0,y:0},end:{x:0,y:0}}}},this.bindEventListeners(),this.images=new Aw(function(){return a.body.emitter.emit("_requestRedraw");}),this.groups=new u_(),this.canvas=new DI(this.body),this.selectionHandler=new GB(this.body,this.canvas),this.interactionHandler=new jI(this.body,this.canvas,this.selectionHandler),this.view=new II(this.body,this.canvas),this.renderer=new SI(this.body,this.canvas),this.physics=new _I(this.body),this.layoutEngine=new cN(this.body),this.clustering=new CI(this.body),this.manipulation=new pN(this.body,this.canvas,this.selectionHandler,this.interactionHandler),this.nodesHandler=new gD(this.body,this.images,this.groups,this.layoutEngine),this.edgesHandler=new cI(this.body,this.images,this.groups),this.body.modules.kamadaKawai=new SN(this.body,150,.05),this.body.modules.clustering=this.clustering,this.canvas._create(),this.setOptions(i),this.setData(e);}function MN(t){for(var e in t)Object.prototype.hasOwnProperty.call(t,e)&&(t[e].redundant=t[e].used,t[e].used=[]);}function PN(t){for(var e in t)if(Object.prototype.hasOwnProperty.call(t,e)&&t[e].redundant){for(var i=0;i<t[e].redundant.length;i++)t[e].redundant[i].parentNode.removeChild(t[e].redundant[i]);t[e].redundant=[];}}function DN(t,e,i){var n;return Object.prototype.hasOwnProperty.call(e,t)?e[t].redundant.length>0?(n=e[t].redundant[0],e[t].redundant.shift()):(n=document.createElementNS("http://www.w3.org/2000/svg",t),i.appendChild(n)):(n=document.createElementNS("http://www.w3.org/2000/svg",t),e[t]={used:[],redundant:[]},i.appendChild(n)),e[t].used.push(n),n;}Kn(TN.prototype),TN.prototype.setOptions=function(t){var e=this;if(null===t&&(t=void 0),void 0!==t){!0===ew.validate(t,_N)&&console.error("%cErrors have been found in the supplied options object.",tw);if(pb(["locale","locales","clickToUse"],this.options,t),void 0!==t.locale&&(t.locale=function(t,e){try{var i=pf(e.split(/[-_ /]/,2),2),n=i[0],o=i[1],r=null!=n?n.toLowerCase():null,s=null!=o?o.toUpperCase():null;if(r&&s){var a,h=r+"-"+s;if(Object.prototype.hasOwnProperty.call(t,h))return h;console.warn(_f(a="Unknown variant ".concat(s," of language ")).call(a,r,"."));}if(r){var l=r;if(Object.prototype.hasOwnProperty.call(t,l))return l;console.warn("Unknown language ".concat(r));}return console.warn("Unknown locale ".concat(e,", falling back to English.")),"en";}catch(t){return console.error(t),console.warn("Unexpected error while normalizing locale ".concat(e,", falling back to English.")),"en";}}(t.locales||this.options.locales,t.locale)),t=this.layoutEngine.setOptions(t.layout,t),this.canvas.setOptions(t),this.groups.setOptions(t.groups),this.nodesHandler.setOptions(t.nodes),this.edgesHandler.setOptions(t.edges),this.physics.setOptions(t.physics),this.manipulation.setOptions(t.manipulation,t,this.options),this.interactionHandler.setOptions(t.interaction),this.renderer.setOptions(t.interaction),this.selectionHandler.setOptions(t.interaction),void 0!==t.groups&&this.body.emitter.emit("refreshNodes"),"configure"in t&&(this.configurator||(this.configurator=new Zb(this,this.body.container,xN,this.canvas.pixelRatio,EN)),this.configurator.setOptions(t.configure)),this.configurator&&!0===this.configurator.options.enabled){var i={nodes:{},edges:{},layout:{},interaction:{},manipulation:{},physics:{},global:{}};gb(i.nodes,this.nodesHandler.options),gb(i.edges,this.edgesHandler.options),gb(i.layout,this.layoutEngine.options),gb(i.interaction,this.selectionHandler.options),gb(i.interaction,this.renderer.options),gb(i.interaction,this.interactionHandler.options),gb(i.manipulation,this.manipulation.options),gb(i.physics,this.physics.options),gb(i.global,this.canvas.options),gb(i.global,this.options),this.configurator.setModuleOptions(i);}void 0!==t.clickToUse?!0===t.clickToUse?void 0===this.activator&&(this.activator=new Kb(this.canvas.frame),this.activator.on("change",function(){e.body.emitter.emit("activate");})):(void 0!==this.activator&&(this.activator.destroy(),delete this.activator),this.body.emitter.emit("activate")):this.body.emitter.emit("activate"),this.canvas.setSize(),this.body.emitter.emit("startSimulation");}},TN.prototype._updateVisibleIndices=function(){var t=this.body.nodes,e=this.body.edges;for(var i in this.body.nodeIndices=[],this.body.edgeIndices=[],t)Object.prototype.hasOwnProperty.call(t,i)&&(this.clustering._isClusteredNode(i)||!1!==t[i].options.hidden||this.body.nodeIndices.push(t[i].id));for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var o=e[n],r=t[o.fromId],s=t[o.toId],a=void 0!==r&&void 0!==s;!this.clustering._isClusteredEdge(n)&&!1===o.options.hidden&&a&&!1===r.options.hidden&&!1===s.options.hidden&&this.body.edgeIndices.push(o.id);}},TN.prototype.bindEventListeners=function(){var t=this;this.body.emitter.on("_dataChanged",function(){t.edgesHandler._updateState(),t.body.emitter.emit("_dataUpdated");}),this.body.emitter.on("_dataUpdated",function(){t.clustering._updateState(),t._updateVisibleIndices(),t._updateValueRange(t.body.nodes),t._updateValueRange(t.body.edges),t.body.emitter.emit("startSimulation"),t.body.emitter.emit("_requestRedraw");});},TN.prototype.setData=function(t){if(this.body.emitter.emit("resetPhysics"),this.body.emitter.emit("_resetData"),this.selectionHandler.unselectAll(),t&&t.dot&&(t.nodes||t.edges))throw new SyntaxError('Data must contain either parameter "dot" or  parameter pair "nodes" and "edges", but not both.');if(this.setOptions(t&&t.options),t&&t.dot){console.warn("The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);");var e=Dw(t.dot);this.setData(e);}else if(t&&t.gephi){console.warn("The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);");var i=Bw(t.gephi);this.setData(i);}else this.nodesHandler.setData(t&&t.nodes,!0),this.edgesHandler.setData(t&&t.edges,!0),this.body.emitter.emit("_dataChanged"),this.body.emitter.emit("_dataLoaded"),this.body.emitter.emit("initPhysics");},TN.prototype.destroy=function(){for(var t in this.body.emitter.emit("destroy"),this.body.emitter.off(),this.off(),delete this.groups,delete this.canvas,delete this.selectionHandler,delete this.interactionHandler,delete this.view,delete this.renderer,delete this.physics,delete this.layoutEngine,delete this.clustering,delete this.manipulation,delete this.nodesHandler,delete this.edgesHandler,delete this.configurator,delete this.images,this.body.nodes)Object.prototype.hasOwnProperty.call(this.body.nodes,t)&&delete this.body.nodes[t];for(var e in this.body.edges)Object.prototype.hasOwnProperty.call(this.body.edges,e)&&delete this.body.edges[e];hb(this.body.container);},TN.prototype._updateValueRange=function(t){var e,i=void 0,n=void 0,o=0;for(e in t)if(Object.prototype.hasOwnProperty.call(t,e)){var r=t[e].getValue();void 0!==r&&(i=void 0===i?r:Math.min(r,i),n=void 0===n?r:Math.max(r,n),o+=r);}if(void 0!==i&&void 0!==n)for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&t[e].setValueRange(i,n,o);},TN.prototype.isActive=function(){return!this.activator||this.activator.active;},TN.prototype.setSize=function(){return this.canvas.setSize.apply(this.canvas,arguments);},TN.prototype.canvasToDOM=function(){return this.canvas.canvasToDOM.apply(this.canvas,arguments);},TN.prototype.DOMtoCanvas=function(){return this.canvas.DOMtoCanvas.apply(this.canvas,arguments);},TN.prototype.findNode=function(){return this.clustering.findNode.apply(this.clustering,arguments);},TN.prototype.isCluster=function(){return this.clustering.isCluster.apply(this.clustering,arguments);},TN.prototype.openCluster=function(){return this.clustering.openCluster.apply(this.clustering,arguments);},TN.prototype.cluster=function(){return this.clustering.cluster.apply(this.clustering,arguments);},TN.prototype.getNodesInCluster=function(){return this.clustering.getNodesInCluster.apply(this.clustering,arguments);},TN.prototype.clusterByConnection=function(){return this.clustering.clusterByConnection.apply(this.clustering,arguments);},TN.prototype.clusterByHubsize=function(){return this.clustering.clusterByHubsize.apply(this.clustering,arguments);},TN.prototype.updateClusteredNode=function(){return this.clustering.updateClusteredNode.apply(this.clustering,arguments);},TN.prototype.getClusteredEdges=function(){return this.clustering.getClusteredEdges.apply(this.clustering,arguments);},TN.prototype.getBaseEdge=function(){return this.clustering.getBaseEdge.apply(this.clustering,arguments);},TN.prototype.getBaseEdges=function(){return this.clustering.getBaseEdges.apply(this.clustering,arguments);},TN.prototype.updateEdge=function(){return this.clustering.updateEdge.apply(this.clustering,arguments);},TN.prototype.clusterOutliers=function(){return this.clustering.clusterOutliers.apply(this.clustering,arguments);},TN.prototype.getSeed=function(){return this.layoutEngine.getSeed.apply(this.layoutEngine,arguments);},TN.prototype.enableEditMode=function(){return this.manipulation.enableEditMode.apply(this.manipulation,arguments);},TN.prototype.disableEditMode=function(){return this.manipulation.disableEditMode.apply(this.manipulation,arguments);},TN.prototype.addNodeMode=function(){return this.manipulation.addNodeMode.apply(this.manipulation,arguments);},TN.prototype.editNode=function(){return this.manipulation.editNode.apply(this.manipulation,arguments);},TN.prototype.editNodeMode=function(){return console.warn("Deprecated: Please use editNode instead of editNodeMode."),this.manipulation.editNode.apply(this.manipulation,arguments);},TN.prototype.addEdgeMode=function(){return this.manipulation.addEdgeMode.apply(this.manipulation,arguments);},TN.prototype.editEdgeMode=function(){return this.manipulation.editEdgeMode.apply(this.manipulation,arguments);},TN.prototype.deleteSelected=function(){return this.manipulation.deleteSelected.apply(this.manipulation,arguments);},TN.prototype.getPositions=function(){return this.nodesHandler.getPositions.apply(this.nodesHandler,arguments);},TN.prototype.getPosition=function(){return this.nodesHandler.getPosition.apply(this.nodesHandler,arguments);},TN.prototype.storePositions=function(){return this.nodesHandler.storePositions.apply(this.nodesHandler,arguments);},TN.prototype.moveNode=function(){return this.nodesHandler.moveNode.apply(this.nodesHandler,arguments);},TN.prototype.getBoundingBox=function(){return this.nodesHandler.getBoundingBox.apply(this.nodesHandler,arguments);},TN.prototype.getConnectedNodes=function(t){return void 0!==this.body.nodes[t]?this.nodesHandler.getConnectedNodes.apply(this.nodesHandler,arguments):this.edgesHandler.getConnectedNodes.apply(this.edgesHandler,arguments);},TN.prototype.getConnectedEdges=function(){return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler,arguments);},TN.prototype.startSimulation=function(){return this.physics.startSimulation.apply(this.physics,arguments);},TN.prototype.stopSimulation=function(){return this.physics.stopSimulation.apply(this.physics,arguments);},TN.prototype.stabilize=function(){return this.physics.stabilize.apply(this.physics,arguments);},TN.prototype.getSelection=function(){return this.selectionHandler.getSelection.apply(this.selectionHandler,arguments);},TN.prototype.setSelection=function(){return this.selectionHandler.setSelection.apply(this.selectionHandler,arguments);},TN.prototype.getSelectedNodes=function(){return this.selectionHandler.getSelectedNodeIds.apply(this.selectionHandler,arguments);},TN.prototype.getSelectedEdges=function(){return this.selectionHandler.getSelectedEdgeIds.apply(this.selectionHandler,arguments);},TN.prototype.getNodeAt=function(){var t=this.selectionHandler.getNodeAt.apply(this.selectionHandler,arguments);return void 0!==t&&void 0!==t.id?t.id:t;},TN.prototype.getEdgeAt=function(){var t=this.selectionHandler.getEdgeAt.apply(this.selectionHandler,arguments);return void 0!==t&&void 0!==t.id?t.id:t;},TN.prototype.selectNodes=function(){return this.selectionHandler.selectNodes.apply(this.selectionHandler,arguments);},TN.prototype.selectEdges=function(){return this.selectionHandler.selectEdges.apply(this.selectionHandler,arguments);},TN.prototype.unselectAll=function(){this.selectionHandler.unselectAll.apply(this.selectionHandler,arguments),this.selectionHandler.commitWithoutEmitting.apply(this.selectionHandler),this.redraw();},TN.prototype.redraw=function(){return this.renderer.redraw.apply(this.renderer,arguments);},TN.prototype.getScale=function(){return this.view.getScale.apply(this.view,arguments);},TN.prototype.getViewPosition=function(){return this.view.getViewPosition.apply(this.view,arguments);},TN.prototype.fit=function(){return this.view.fit.apply(this.view,arguments);},TN.prototype.moveTo=function(){return this.view.moveTo.apply(this.view,arguments);},TN.prototype.focus=function(){return this.view.focus.apply(this.view,arguments);},TN.prototype.releaseNode=function(){return this.view.releaseNode.apply(this.view,arguments);},TN.prototype.getOptionsFromConfigurator=function(){var t={};return this.configurator&&(t=this.configurator.getOptions.apply(this.configurator)),t;};var IN=Object.freeze({__proto__:null,cleanupElements:PN,drawBar:function drawBar(t,e,i,n,o,r,s,a){if(0!=n){n<0&&(e-=n*=-1);var h=DN("rect",r,s);h.setAttributeNS(null,"x",t-.5*i),h.setAttributeNS(null,"y",e),h.setAttributeNS(null,"width",i),h.setAttributeNS(null,"height",n),h.setAttributeNS(null,"class",o),a&&h.setAttributeNS(null,"style",a);}},drawPoint:function drawPoint(t,e,i,n,o,r){var s;if("circle"==i.style?((s=DN("circle",n,o)).setAttributeNS(null,"cx",t),s.setAttributeNS(null,"cy",e),s.setAttributeNS(null,"r",.5*i.size)):((s=DN("rect",n,o)).setAttributeNS(null,"x",t-.5*i.size),s.setAttributeNS(null,"y",e-.5*i.size),s.setAttributeNS(null,"width",i.size),s.setAttributeNS(null,"height",i.size)),void 0!==i.styles&&s.setAttributeNS(null,"style",i.styles),s.setAttributeNS(null,"class",i.className+" vis-point"),r){var a=DN("text",n,o);r.xOffset&&(t+=r.xOffset),r.yOffset&&(e+=r.yOffset),r.content&&(a.textContent=r.content),r.className&&a.setAttributeNS(null,"class",r.className+" vis-label"),a.setAttributeNS(null,"x",t),a.setAttributeNS(null,"y",e);}return s;},getDOMElement:function getDOMElement(t,e,i,n){var o;return Object.prototype.hasOwnProperty.call(e,t)?e[t].redundant.length>0?(o=e[t].redundant[0],e[t].redundant.shift()):(o=document.createElement(t),void 0!==n?i.insertBefore(o,n):i.appendChild(o)):(o=document.createElement(t),e[t]={used:[],redundant:[]},void 0!==n?i.insertBefore(o,n):i.appendChild(o)),e[t].used.push(o),o;},getSVGElement:DN,prepareElements:MN,resetElements:function resetElements(t){MN(t),PN(t),MN(t);}}),BN={Images:Aw,dotparser:Iw,gephiParser:Nw,allOptions:ON,convertDot:Dw,convertGephi:Bw},NN=Object.freeze({__proto__:null,DOMutil:IN,DataSet:GM,DataView:KM,Hammer:Qb,Network:TN,Queue:UM,data:QM,keycharm:NI,network:BN,util:iw});t.DOMutil=IN,t.DataSet=GM,t.DataView=KM,t.Hammer=Qb,t.Network=TN,t.Queue=UM,t.data=QM,t["default"]=NN,t.keycharm=NI,t.network=BN,t.util=iw,Object.defineProperty(t,"__esModule",{value:!0});});
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.12.1 - 2015-02-20
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.bindHtml", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.dropdown", "ui.bootstrap.modal", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html", "template/accordion/accordion.html", "template/alert/alert.html", "template/carousel/carousel.html", "template/carousel/slide.html", "template/datepicker/datepicker.html", "template/datepicker/day.html", "template/datepicker/month.html", "template/datepicker/popup.html", "template/datepicker/year.html", "template/modal/backdrop.html", "template/modal/window.html", "template/pagination/pager.html", "template/pagination/pagination.html", "template/tooltip/tooltip-html-unsafe-popup.html", "template/tooltip/tooltip-popup.html", "template/popover/popover.html", "template/progressbar/bar.html", "template/progressbar/progress.html", "template/progressbar/progressbar.html", "template/rating/rating.html", "template/tabs/tab.html", "template/tabs/tabset.html", "template/timepicker/timepicker.html", "template/typeahead/typeahead-match.html", "template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.transition', [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */.factory('$transition', ['$q', '$timeout', '$rootScope', function ($q, $timeout, $rootScope) {
  var $transition = function (element, trigger, options) {
    options = options || {};
    var deferred = $q.defer();
    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];
    var transitionEndHandler = function (event) {
      $rootScope.$apply(function () {
        element.unbind(endEventName, transitionEndHandler);
        deferred.resolve(element);
      });
    };
    if (endEventName) {
      element.bind(endEventName, transitionEndHandler);
    }

    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
    $timeout(function () {
      if (angular.isString(trigger)) {
        element.addClass(trigger);
      } else if (angular.isFunction(trigger)) {
        trigger(element);
      } else if (angular.isObject(trigger)) {
        element.css(trigger);
      }
      //If browser does not support transitions, instantly resolve
      if (!endEventName) {
        deferred.resolve(element);
      }
    });

    // Add our custom cancel function to the promise that is returned
    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
    // i.e. it will therefore never raise a transitionEnd event for that transition
    deferred.promise.cancel = function () {
      if (endEventName) {
        element.unbind(endEventName, transitionEndHandler);
      }
      deferred.reject('Transition cancelled');
    };
    return deferred.promise;
  };

  // Work out the name of the transitionEnd event
  var transElement = document.createElement('trans');
  var transitionEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'transition': 'transitionend'
  };
  var animationEndEventNames = {
    'WebkitTransition': 'webkitAnimationEnd',
    'MozTransition': 'animationend',
    'OTransition': 'oAnimationEnd',
    'transition': 'animationend'
  };
  function findEndEventName(endEventNames) {
    for (var name in endEventNames) {
      if (transElement.style[name] !== undefined) {
        return endEventNames[name];
      }
    }
  }
  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
  return $transition;
}]);
angular.module('ui.bootstrap.collapse', ['ui.bootstrap.transition']).directive('collapse', ['$transition', function ($transition) {
  return {
    link: function (scope, element, attrs) {
      var initialAnimSkip = true;
      var currentTransition;
      function doTransition(change) {
        var newTransition = $transition(element, change);
        if (currentTransition) {
          currentTransition.cancel();
        }
        currentTransition = newTransition;
        newTransition.then(newTransitionDone, newTransitionDone);
        return newTransition;
        function newTransitionDone() {
          // Make sure it's this transition, otherwise, leave it alone.
          if (currentTransition === newTransition) {
            currentTransition = undefined;
          }
        }
      }
      function expand() {
        if (initialAnimSkip) {
          initialAnimSkip = false;
          expandDone();
        } else {
          element.removeClass('collapse').addClass('collapsing');
          doTransition({
            height: element[0].scrollHeight + 'px'
          }).then(expandDone);
        }
      }
      function expandDone() {
        element.removeClass('collapsing');
        element.addClass('collapse in');
        element.css({
          height: 'auto'
        });
      }
      function collapse() {
        if (initialAnimSkip) {
          initialAnimSkip = false;
          collapseDone();
          element.css({
            height: 0
          });
        } else {
          // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
          element.css({
            height: element[0].scrollHeight + 'px'
          });
          //trigger reflow so a browser realizes that height was updated from auto to a specific value
          var x = element[0].offsetWidth;
          element.removeClass('collapse in').addClass('collapsing');
          doTransition({
            height: 0
          }).then(collapseDone);
        }
      }
      function collapseDone() {
        element.removeClass('collapsing');
        element.addClass('collapse');
      }
      scope.$watch(attrs.collapse, function (shouldCollapse) {
        if (shouldCollapse) {
          collapse();
        } else {
          expand();
        }
      });
    }
  };
}]);
angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse']).constant('accordionConfig', {
  closeOthers: true
}).controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function ($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function (openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function (group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function (groupScope) {
    var that = this;
    this.groups.push(groupScope);
    groupScope.$on('$destroy', function (event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function (group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('accordion', function () {
  return {
    restrict: 'EA',
    controller: 'AccordionController',
    transclude: true,
    replace: false,
    templateUrl: 'template/accordion/accordion.html'
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('accordionGroup', function () {
  return {
    require: '^accordion',
    // We need this directive to be inside an accordion
    restrict: 'EA',
    transclude: true,
    // It transcludes the contents of the directive into the template
    replace: true,
    // The element containing the directive will be replaced with the template
    templateUrl: 'template/accordion/accordion-group.html',
    scope: {
      heading: '@',
      // Interpolate the heading attribute onto this scope
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function () {
      this.setHeading = function (element) {
        this.heading = element;
      };
    },
    link: function (scope, element, attrs, accordionCtrl) {
      accordionCtrl.addGroup(scope);
      scope.$watch('isOpen', function (value) {
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });
      scope.toggleOpen = function () {
        if (!scope.isDisabled) {
          scope.isOpen = !scope.isOpen;
        }
      };
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
.directive('accordionHeading', function () {
  return {
    restrict: 'EA',
    transclude: true,
    // Grab the contents to be used as the heading
    template: '',
    // In effect remove this element!
    replace: true,
    require: '^accordionGroup',
    link: function (scope, element, attr, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, function () {}));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
.directive('accordionTransclude', function () {
  return {
    require: '^accordionGroup',
    link: function (scope, element, attr, controller) {
      scope.$watch(function () {
        return controller[attr.accordionTransclude];
      }, function (heading) {
        if (heading) {
          element.html('');
          element.append(heading);
        }
      });
    }
  };
});
angular.module('ui.bootstrap.alert', []).controller('AlertController', ['$scope', '$attrs', function ($scope, $attrs) {
  $scope.closeable = 'close' in $attrs;
  this.close = $scope.close;
}]).directive('alert', function () {
  return {
    restrict: 'EA',
    controller: 'AlertController',
    templateUrl: 'template/alert/alert.html',
    transclude: true,
    replace: true,
    scope: {
      type: '@',
      close: '&'
    }
  };
}).directive('dismissOnTimeout', ['$timeout', function ($timeout) {
  return {
    require: 'alert',
    link: function (scope, element, attrs, alertCtrl) {
      $timeout(function () {
        alertCtrl.close();
      }, parseInt(attrs.dismissOnTimeout, 10));
    }
  };
}]);
angular.module('ui.bootstrap.bindHtml', []).directive('bindHtmlUnsafe', function () {
  return function (scope, element, attr) {
    element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
    scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
      element.html(value || '');
    });
  };
});
angular.module('ui.bootstrap.buttons', []).constant('buttonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
}).controller('ButtonsController', ['buttonConfig', function (buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}]).directive('btnRadio', function () {
  return {
    require: ['btnRadio', 'ngModel'],
    controller: 'ButtonsController',
    link: function (scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];

      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
      };

      //ui->model
      element.bind(buttonsCtrl.toggleEvent, function () {
        var isActive = element.hasClass(buttonsCtrl.activeClass);
        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function () {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
            ngModelCtrl.$render();
          });
        }
      });
    }
  };
}).directive('btnCheckbox', function () {
  return {
    require: ['btnCheckbox', 'ngModel'],
    controller: 'ButtonsController',
    link: function (scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }
      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }
      function getCheckboxValue(attributeValue, defaultValue) {
        var val = scope.$eval(attributeValue);
        return angular.isDefined(val) ? val : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.bind(buttonsCtrl.toggleEvent, function () {
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

/**
* @ngdoc overview
* @name ui.bootstrap.carousel
*
* @description
* AngularJS version of an image carousel.
*
*/
angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition']).controller('CarouselController', ['$scope', '$timeout', '$interval', '$transition', function ($scope, $timeout, $interval, $transition) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    currentIndex = -1,
    currentInterval,
    isPlaying;
  self.currentSlide = null;
  var destroyed = false;
  /* direction: "prev" or "next" */
  self.select = $scope.select = function (nextSlide, direction) {
    var nextIndex = slides.indexOf(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > currentIndex ? 'next' : 'prev';
    }
    if (nextSlide && nextSlide !== self.currentSlide) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition.cancel();
        //Timeout so ng-class in template has time to fix classes for finished slide
        $timeout(goNext);
      } else {
        goNext();
      }
    }
    function goNext() {
      // Scope has been destroyed, stop here.
      if (destroyed) {
        return;
      }
      //If we have a slide to transition from and we have a transition type and we're allowed, go
      if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
        //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
        nextSlide.$element.addClass(direction);
        var reflow = nextSlide.$element[0].offsetWidth; //force reflow

        //Set all other slides to stop doing their stuff for the new transition
        angular.forEach(slides, function (slide) {
          angular.extend(slide, {
            direction: '',
            entering: false,
            leaving: false,
            active: false
          });
        });
        angular.extend(nextSlide, {
          direction: direction,
          active: true,
          entering: true
        });
        angular.extend(self.currentSlide || {}, {
          direction: direction,
          leaving: true
        });
        $scope.$currentTransition = $transition(nextSlide.$element, {});
        //We have to create new pointers inside a closure since next & current will change
        (function (next, current) {
          $scope.$currentTransition.then(function () {
            transitionDone(next, current);
          }, function () {
            transitionDone(next, current);
          });
        })(nextSlide, self.currentSlide);
      } else {
        transitionDone(nextSlide, self.currentSlide);
      }
      self.currentSlide = nextSlide;
      currentIndex = nextIndex;
      //every time you change slides, reset the timer
      restartTimer();
    }
    function transitionDone(next, current) {
      angular.extend(next, {
        direction: '',
        active: true,
        leaving: false,
        entering: false
      });
      angular.extend(current || {}, {
        direction: '',
        active: false,
        leaving: false,
        entering: false
      });
      $scope.$currentTransition = null;
    }
  };
  $scope.$on('$destroy', function () {
    destroyed = true;
  });

  /* Allow outside people to call indexOf on slides array */
  self.indexOfSlide = function (slide) {
    return slides.indexOf(slide);
  };
  $scope.next = function () {
    var newIndex = (currentIndex + 1) % slides.length;

    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (!$scope.$currentTransition) {
      return self.select(slides[newIndex], 'next');
    }
  };
  $scope.prev = function () {
    var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;

    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (!$scope.$currentTransition) {
      return self.select(slides[newIndex], 'prev');
    }
  };
  $scope.isActive = function (slide) {
    return self.currentSlide === slide;
  };
  $scope.$watch('interval', restartTimer);
  $scope.$on('$destroy', resetTimer);
  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }
  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }
  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
  $scope.play = function () {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.pause = function () {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };
  self.addSlide = function (slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if (slides.length === 1 || slide.active) {
      self.select(slides[slides.length - 1]);
      if (slides.length == 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };
  self.removeSlide = function (slide) {
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    if (slides.length > 0 && slide.active) {
      if (index >= slides.length) {
        self.select(slides[index - 1]);
      } else {
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <carousel>
      <slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </slide>
      <slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </slide>
    </carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */.directive('carousel', [function () {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    controller: 'CarouselController',
    require: 'carousel',
    templateUrl: 'template/carousel/carousel.html',
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '='
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <carousel>
    <slide ng-repeat="slide in slides" active="slide.active">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </slide>
  </carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/.directive('slide', function () {
  return {
    require: '^carousel',
    restrict: 'EA',
    transclude: true,
    replace: true,
    templateUrl: 'template/carousel/slide.html',
    scope: {
      active: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function () {
        carouselCtrl.removeSlide(scope);
      });
      scope.$watch('active', function (active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
});
angular.module('ui.bootstrap.dateparser', []).service('dateParser', ['$locale', 'orderByFilter', function ($locale, orderByFilter) {
  this.parsers = {};
  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function (value) {
        this.year = +value;
      }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function (value) {
        this.year = +value + 2000;
      }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function (value) {
        this.year = +value;
      }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function (value) {
        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
      }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function (value) {
        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
      }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function (value) {
        this.month = value - 1;
      }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function (value) {
        this.month = value - 1;
      }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function (value) {
        this.date = +value;
      }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function (value) {
        this.date = +value;
      }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    }
  };
  function createParser(format) {
    var map = [],
      regex = format.split('');
    angular.forEach(formatCodeToRegex, function (data, code) {
      var index = format.indexOf(code);
      if (index > -1) {
        format = format.split('');
        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');
        map.push({
          index: index,
          apply: data.apply
        });
      }
    });
    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }
  this.parse = function (input, format) {
    if (!angular.isString(input) || !format) {
      return input;
    }
    format = $locale.DATETIME_FORMATS[format] || format;
    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format);
    }
    var parser = this.parsers[format],
      regex = parser.regex,
      map = parser.map,
      results = input.match(regex);
    if (results && results.length) {
      var fields = {
          year: 1900,
          month: 0,
          date: 1,
          hours: 0
        },
        dt;
      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }
      if (isValid(fields.year, fields.month, fields.date)) {
        dt = new Date(fields.year, fields.month, fields.date, fields.hours);
      }
      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }
    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }
    return true;
  }
}]);
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */.factory('$position', ['$document', '$window', function ($document, $window) {
  function getStyle(el, cssprop) {
    if (el.currentStyle) {
      //IE
      return el.currentStyle[cssprop];
    } else if ($window.getComputedStyle) {
      return $window.getComputedStyle(el)[cssprop];
    }
    // finally try and get inline style
    return el.style[cssprop];
  }

  /**
   * Checks if a given element is statically positioned
   * @param element - raw DOM element
   */
  function isStaticPositioned(element) {
    return (getStyle(element, 'position') || 'static') === 'static';
  }

  /**
   * returns the closest, non-statically positioned parentOffset of a given element
   * @param element
   */
  var parentOffsetEl = function (element) {
    var docDomEl = $document[0];
    var offsetParent = element.offsetParent || docDomEl;
    while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
      offsetParent = offsetParent.offsetParent;
    }
    return offsetParent || docDomEl;
  };
  return {
    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/
     */
    position: function (element) {
      var elBCR = this.offset(element);
      var offsetParentBCR = {
        top: 0,
        left: 0
      };
      var offsetParentEl = parentOffsetEl(element[0]);
      if (offsetParentEl != $document[0]) {
        offsetParentBCR = this.offset(angular.element(offsetParentEl));
        offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
        offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
      }
      var boundingClientRect = element[0].getBoundingClientRect();
      return {
        width: boundingClientRect.width || element.prop('offsetWidth'),
        height: boundingClientRect.height || element.prop('offsetHeight'),
        top: elBCR.top - offsetParentBCR.top,
        left: elBCR.left - offsetParentBCR.left
      };
    },
    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/
     */
    offset: function (element) {
      var boundingClientRect = element[0].getBoundingClientRect();
      return {
        width: boundingClientRect.width || element.prop('offsetWidth'),
        height: boundingClientRect.height || element.prop('offsetHeight'),
        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
      };
    },
    /**
     * Provides coordinates for the targetEl in relation to hostEl
     */
    positionElements: function (hostEl, targetEl, positionStr, appendToBody) {
      var positionStrParts = positionStr.split('-');
      var pos0 = positionStrParts[0],
        pos1 = positionStrParts[1] || 'center';
      var hostElPos, targetElWidth, targetElHeight, targetElPos;
      hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
      targetElWidth = targetEl.prop('offsetWidth');
      targetElHeight = targetEl.prop('offsetHeight');
      var shiftWidth = {
        center: function () {
          return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
        },
        left: function () {
          return hostElPos.left;
        },
        right: function () {
          return hostElPos.left + hostElPos.width;
        }
      };
      var shiftHeight = {
        center: function () {
          return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
        },
        top: function () {
          return hostElPos.top;
        },
        bottom: function () {
          return hostElPos.top + hostElPos.height;
        }
      };
      switch (pos0) {
        case 'right':
          targetElPos = {
            top: shiftHeight[pos1](),
            left: shiftWidth[pos0]()
          };
          break;
        case 'left':
          targetElPos = {
            top: shiftHeight[pos1](),
            left: hostElPos.left - targetElWidth
          };
          break;
        case 'bottom':
          targetElPos = {
            top: shiftHeight[pos0](),
            left: shiftWidth[pos1]()
          };
          break;
        default:
          targetElPos = {
            top: hostElPos.top - targetElHeight,
            left: shiftWidth[pos1]()
          };
          break;
      }
      return targetElPos;
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position']).constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null
}).controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', 'dateFilter', 'datepickerConfig', function ($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
  var self = this,
    ngModelCtrl = {
      $setViewValue: angular.noop
    }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle', 'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange'], function (key, index) {
    self[key] = angular.isDefined($attrs[key]) ? index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function (key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function (value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });
  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
  this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();
  $scope.isActive = function (dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };
  this.init = function (ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = function () {
      self.render();
    };
  };
  this.render = function () {
    if (ngModelCtrl.$modelValue) {
      var date = new Date(ngModelCtrl.$modelValue),
        isValid = !isNaN(date);
      if (isValid) {
        this.activeDate = date;
      } else {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
      ngModelCtrl.$setValidity('date', isValid);
    }
    this.refreshView();
  };
  this.refreshView = function () {
    if (this.element) {
      this._refreshView();
      var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
      ngModelCtrl.$setValidity('date-disabled', !date || this.element && !this.isDisabled(date));
    }
  };
  this.createDateObject = function (date, format) {
    var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0
    };
  };
  this.isDisabled = function (date) {
    return this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({
      date: date,
      mode: $scope.datepickerMode
    });
  };

  // Split array into smaller arrays
  this.split = function (arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };
  $scope.select = function (date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };
  $scope.move = function (direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
      month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };
  $scope.toggleMode = function (direction) {
    direction = direction || 1;
    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }
    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = {
    13: 'enter',
    32: 'space',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down'
  };
  var focusElement = function () {
    $timeout(function () {
      self.element[0].focus();
    }, 0, false);
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);
  $scope.keydown = function (evt) {
    var key = $scope.keys[evt.which];
    if (!key || evt.shiftKey || evt.altKey) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }

      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}]).directive('datepicker', function () {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/datepicker.html',
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&'
    },
    require: ['datepicker', '?^ngModel'],
    controller: 'DatepickerController',
    link: function (scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (ngModelCtrl) {
        datepickerCtrl.init(ngModelCtrl);
      }
    }
  };
}).directive('daypicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/day.html',
    require: '^datepicker',
    link: function (scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;
      ctrl.step = {
        months: 1
      };
      ctrl.element = element;
      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth(year, month) {
        return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
      }
      function getDates(startDate, n) {
        var dates = new Array(n),
          current = new Date(startDate),
          i = 0;
        current.setHours(12); // Prevent repeated dates because of timezone bug
        while (i < n) {
          dates[i++] = new Date(current);
          current.setDate(current.getDate() + 1);
        }
        return dates;
      }
      ctrl._refreshView = function () {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
          firstDate = new Date(firstDayOfMonth);
        if (numDisplayedFromPreviousMonth > 0) {
          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }
        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }
        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);
        if (scope.showWeeks) {
          scope.weekNumbers = [];
          var weekNumber = getISO8601WeekNumber(scope.rows[0][0].date),
            numWeeks = scope.rows.length;
          while (scope.weekNumbers.push(weekNumber++) < numWeeks) {}
        }
      };
      ctrl.compare = function (date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      };
      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }
      ctrl.handleKeyDown = function (key, evt) {
        var date = ctrl.activeDate.getDate();
        if (key === 'left') {
          date = date - 1; // up
        } else if (key === 'up') {
          date = date - 7; // down
        } else if (key === 'right') {
          date = date + 1; // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };
      ctrl.refreshView();
    }
  };
}]).directive('monthpicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/month.html',
    require: '^datepicker',
    link: function (scope, element, attrs, ctrl) {
      ctrl.step = {
        years: 1
      };
      ctrl.element = element;
      ctrl._refreshView = function () {
        var months = new Array(12),
          year = ctrl.activeDate.getFullYear();
        for (var i = 0; i < 12; i++) {
          months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }
        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };
      ctrl.compare = function (date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
      };
      ctrl.handleKeyDown = function (key, evt) {
        var date = ctrl.activeDate.getMonth();
        if (key === 'left') {
          date = date - 1; // up
        } else if (key === 'up') {
          date = date - 3; // down
        } else if (key === 'right') {
          date = date + 1; // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };
      ctrl.refreshView();
    }
  };
}]).directive('yearpicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/year.html',
    require: '^datepicker',
    link: function (scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;
      ctrl.step = {
        years: range
      };
      ctrl.element = element;
      function getStartingYear(year) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }
      ctrl._refreshView = function () {
        var years = new Array(range);
        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
          years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }
        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };
      ctrl.compare = function (date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };
      ctrl.handleKeyDown = function (key, evt) {
        var date = ctrl.activeDate.getFullYear();
        if (key === 'left') {
          date = date - 1; // up
        } else if (key === 'up') {
          date = date - 5; // down
        } else if (key === 'right') {
          date = date + 1; // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? -1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear(ctrl.activeDate.getFullYear());
        } else if (key === 'end') {
          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };
      ctrl.refreshView();
    }
  };
}]).constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true
}).directive('datepickerPopup', ['$compile', '$parse', '$document', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', function ($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&'
    },
    link: function (scope, element, attrs, ngModel) {
      var dateFormat,
        closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
        appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
      scope.getText = function (key) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };
      attrs.$observe('datepickerPopup', function (value) {
        dateFormat = value || datepickerPopupConfig.datepickerPopup;
        ngModel.$render();
      });

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection()'
      });
      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      if (attrs.datepickerOptions) {
        angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function (value, option) {
          datepickerEl.attr(cameltoDash(option), value);
        });
      }
      scope.watchData = {};
      angular.forEach(['minDate', 'maxDate', 'datepickerMode'], function (key) {
        if (attrs[key]) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function (value) {
            scope.watchData[key] = value;
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if (key === 'datepickerMode') {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function (value, oldvalue) {
              if (value !== oldvalue) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }
      function parseDate(viewValue) {
        if (!viewValue) {
          ngModel.$setValidity('date', true);
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          ngModel.$setValidity('date', true);
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat) || new Date(viewValue);
          if (isNaN(date)) {
            ngModel.$setValidity('date', false);
            return undefined;
          } else {
            ngModel.$setValidity('date', true);
            return date;
          }
        } else {
          ngModel.$setValidity('date', false);
          return undefined;
        }
      }
      ngModel.$parsers.unshift(parseDate);

      // Inner change
      scope.dateSelection = function (dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        ngModel.$setViewValue(scope.date);
        ngModel.$render();
        if (closeOnDateSelection) {
          scope.isOpen = false;
          element[0].focus();
        }
      };
      element.bind('input change keyup', function () {
        scope.$apply(function () {
          scope.date = ngModel.$modelValue;
        });
      });

      // Outter change
      ngModel.$render = function () {
        var date = ngModel.$viewValue ? dateFilter(ngModel.$viewValue, dateFormat) : '';
        element.val(date);
        scope.date = parseDate(ngModel.$modelValue);
      };
      var documentClickBind = function (event) {
        if (scope.isOpen && event.target !== element[0]) {
          scope.$apply(function () {
            scope.isOpen = false;
          });
        }
      };
      var keydown = function (evt, noApply) {
        scope.keydown(evt);
      };
      element.bind('keydown', keydown);
      scope.keydown = function (evt) {
        if (evt.which === 27) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.close();
        } else if (evt.which === 40 && !scope.isOpen) {
          scope.isOpen = true;
        }
      };
      scope.$watch('isOpen', function (value) {
        if (value) {
          scope.$broadcast('datepicker.focus');
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');
          $document.bind('click', documentClickBind);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });
      scope.select = function (date) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(ngModel.$modelValue)) {
            date = new Date(ngModel.$modelValue);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection(date);
      };
      scope.close = function () {
        scope.isOpen = false;
        element[0].focus();
      };
      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();
      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }
      scope.$on('$destroy', function () {
        $popup.remove();
        element.unbind('keydown', keydown);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}]).directive('datepickerPopupWrap', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    templateUrl: 'template/datepicker/popup.html',
    link: function (scope, element, attrs) {
      element.bind('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    }
  };
});
angular.module('ui.bootstrap.dropdown', []).constant('dropdownConfig', {
  openClass: 'open'
}).service('dropdownService', ['$document', function ($document) {
  var openScope = null;
  this.open = function (dropdownScope) {
    if (!openScope) {
      $document.bind('click', closeDropdown);
      $document.bind('keydown', escapeKeyBind);
    }
    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }
    openScope = dropdownScope;
  };
  this.close = function (dropdownScope) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.unbind('click', closeDropdown);
      $document.unbind('keydown', escapeKeyBind);
    }
  };
  var closeDropdown = function (evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) {
      return;
    }
    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }
    openScope.$apply(function () {
      openScope.isOpen = false;
    });
  };
  var escapeKeyBind = function (evt) {
    if (evt.which === 27) {
      openScope.focusToggleElement();
      closeDropdown();
    }
  };
}]).controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate) {
  var self = this,
    scope = $scope.$new(),
    // create a child scope so we are not polluting original one
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;
  this.init = function (element) {
    self.$element = element;
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;
      $scope.$watch(getIsOpen, function (value) {
        scope.isOpen = !!value;
      });
    }
  };
  this.toggle = function (open) {
    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function () {
    return scope.isOpen;
  };
  scope.getToggleElement = function () {
    return self.toggleElement;
  };
  scope.focusToggleElement = function () {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };
  scope.$watch('isOpen', function (isOpen, wasOpen) {
    $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);
    if (isOpen) {
      scope.focusToggleElement();
      dropdownService.open(scope);
    } else {
      dropdownService.close(scope);
    }
    setIsOpen($scope, isOpen);
    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
      toggleInvoker($scope, {
        open: !!isOpen
      });
    }
  });
  $scope.$on('$locationChangeSuccess', function () {
    scope.isOpen = false;
  });
  $scope.$on('$destroy', function () {
    scope.$destroy();
  });
}]).directive('dropdown', function () {
  return {
    controller: 'DropdownController',
    link: function (scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init(element);
    }
  };
}).directive('dropdownToggle', function () {
  return {
    require: '?^dropdown',
    link: function (scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }
      dropdownCtrl.toggleElement = element;
      var toggleDropdown = function (event) {
        event.preventDefault();
        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function () {
            dropdownCtrl.toggle();
          });
        }
      };
      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({
        'aria-haspopup': true,
        'aria-expanded': false
      });
      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });
      scope.$on('$destroy', function () {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});
angular.module('ui.bootstrap.modal', ['ui.bootstrap.transition'])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */.factory('$$stackedMap', function () {
  return {
    createNew: function () {
      var stack = [];
      return {
        add: function (key, value) {
          stack.push({
            key: key,
            value: value
          });
        },
        get: function (key) {
          for (var i = 0; i < stack.length; i++) {
            if (key == stack[i].key) {
              return stack[i];
            }
          }
        },
        keys: function () {
          var keys = [];
          for (var i = 0; i < stack.length; i++) {
            keys.push(stack[i].key);
          }
          return keys;
        },
        top: function () {
          return stack[stack.length - 1];
        },
        remove: function (key) {
          var idx = -1;
          for (var i = 0; i < stack.length; i++) {
            if (key == stack[i].key) {
              idx = i;
              break;
            }
          }
          return stack.splice(idx, 1)[0];
        },
        removeTop: function () {
          return stack.splice(stack.length - 1, 1)[0];
        },
        length: function () {
          return stack.length;
        }
      };
    }
  };
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */.directive('modalBackdrop', ['$timeout', function ($timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/modal/backdrop.html',
    link: function (scope, element, attrs) {
      scope.backdropClass = attrs.backdropClass || '';
      scope.animate = false;

      //trigger CSS transitions
      $timeout(function () {
        scope.animate = true;
      });
    }
  };
}]).directive('modalWindow', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
  return {
    restrict: 'EA',
    scope: {
      index: '@',
      animate: '='
    },
    replace: true,
    transclude: true,
    templateUrl: function (tElement, tAttrs) {
      return tAttrs.templateUrl || 'template/modal/window.html';
    },
    link: function (scope, element, attrs) {
      element.addClass(attrs.windowClass || '');
      scope.size = attrs.size;
      $timeout(function () {
        // trigger CSS transitions
        scope.animate = true;

        /**
         * Auto-focusing of a freshly-opened modal element causes any child elements
         * with the autofocus attribute to lose focus. This is an issue on touch
         * based devices which will show and then hide the onscreen keyboard.
         * Attempts to refocus the autofocus element via JavaScript will not reopen
         * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
         * the modal element if the modal does not contain an autofocus element.
         */
        if (!element[0].querySelectorAll('[autofocus]').length) {
          element[0].focus();
        }
      });
      scope.close = function (evt) {
        var modal = $modalStack.getTop();
        if (modal && modal.value.backdrop && modal.value.backdrop != 'static' && evt.target === evt.currentTarget) {
          evt.preventDefault();
          evt.stopPropagation();
          $modalStack.dismiss(modal.key, 'backdrop click');
        }
      };
    }
  };
}]).directive('modalTransclude', function () {
  return {
    link: function ($scope, $element, $attrs, controller, $transclude) {
      $transclude($scope.$parent, function (clone) {
        $element.empty();
        $element.append(clone);
      });
    }
  };
}).factory('$modalStack', ['$transition', '$timeout', '$document', '$compile', '$rootScope', '$$stackedMap', function ($transition, $timeout, $document, $compile, $rootScope, $$stackedMap) {
  var OPENED_MODAL_CLASS = 'modal-open';
  var backdropDomEl, backdropScope;
  var openedWindows = $$stackedMap.createNew();
  var $modalStack = {};
  function backdropIndex() {
    var topBackdropIndex = -1;
    var opened = openedWindows.keys();
    for (var i = 0; i < opened.length; i++) {
      if (openedWindows.get(opened[i]).value.backdrop) {
        topBackdropIndex = i;
      }
    }
    return topBackdropIndex;
  }
  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
    if (backdropScope) {
      backdropScope.index = newBackdropIndex;
    }
  });
  function removeModalWindow(modalInstance) {
    var body = $document.find('body').eq(0);
    var modalWindow = openedWindows.get(modalInstance).value;

    //clean up the stack
    openedWindows.remove(modalInstance);

    //remove window DOM element
    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function () {
      modalWindow.modalScope.$destroy();
      body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
      checkRemoveBackdrop();
    });
  }
  function checkRemoveBackdrop() {
    //remove backdrop if no longer needed
    if (backdropDomEl && backdropIndex() == -1) {
      var backdropScopeRef = backdropScope;
      removeAfterAnimate(backdropDomEl, backdropScope, 150, function () {
        backdropScopeRef.$destroy();
        backdropScopeRef = null;
      });
      backdropDomEl = undefined;
      backdropScope = undefined;
    }
  }
  function removeAfterAnimate(domEl, scope, emulateTime, done) {
    // Closing animation
    scope.animate = false;
    var transitionEndEventName = $transition.transitionEndEventName;
    if (transitionEndEventName) {
      // transition out
      var timeout = $timeout(afterAnimating, emulateTime);
      domEl.bind(transitionEndEventName, function () {
        $timeout.cancel(timeout);
        afterAnimating();
        scope.$apply();
      });
    } else {
      // Ensure this call is async
      $timeout(afterAnimating);
    }
    function afterAnimating() {
      if (afterAnimating.done) {
        return;
      }
      afterAnimating.done = true;
      domEl.remove();
      if (done) {
        done();
      }
    }
  }
  $document.bind('keydown', function (evt) {
    var modal;
    if (evt.which === 27) {
      modal = openedWindows.top();
      if (modal && modal.value.keyboard) {
        evt.preventDefault();
        $rootScope.$apply(function () {
          $modalStack.dismiss(modal.key, 'escape key press');
        });
      }
    }
  });
  $modalStack.open = function (modalInstance, modal) {
    openedWindows.add(modalInstance, {
      deferred: modal.deferred,
      modalScope: modal.scope,
      backdrop: modal.backdrop,
      keyboard: modal.keyboard
    });
    var body = $document.find('body').eq(0),
      currBackdropIndex = backdropIndex();
    if (currBackdropIndex >= 0 && !backdropDomEl) {
      backdropScope = $rootScope.$new(true);
      backdropScope.index = currBackdropIndex;
      var angularBackgroundDomEl = angular.element('<div modal-backdrop></div>');
      angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
      backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
      body.append(backdropDomEl);
    }
    var angularDomEl = angular.element('<div modal-window></div>');
    angularDomEl.attr({
      'template-url': modal.windowTemplateUrl,
      'window-class': modal.windowClass,
      'size': modal.size,
      'index': openedWindows.length() - 1,
      'animate': 'animate'
    }).html(modal.content);
    var modalDomEl = $compile(angularDomEl)(modal.scope);
    openedWindows.top().value.modalDomEl = modalDomEl;
    body.append(modalDomEl);
    body.addClass(OPENED_MODAL_CLASS);
  };
  $modalStack.close = function (modalInstance, result) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow) {
      modalWindow.value.deferred.resolve(result);
      removeModalWindow(modalInstance);
    }
  };
  $modalStack.dismiss = function (modalInstance, reason) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow) {
      modalWindow.value.deferred.reject(reason);
      removeModalWindow(modalInstance);
    }
  };
  $modalStack.dismissAll = function (reason) {
    var topModal = this.getTop();
    while (topModal) {
      this.dismiss(topModal.key, reason);
      topModal = this.getTop();
    }
  };
  $modalStack.getTop = function () {
    return openedWindows.top();
  };
  return $modalStack;
}]).provider('$modal', function () {
  var $modalProvider = {
    options: {
      backdrop: true,
      //can be also false or 'static'
      keyboard: true
    },
    $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack', function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {
      var $modal = {};
      function getTemplatePromise(options) {
        return options.template ? $q.when(options.template) : $http.get(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl, {
          cache: $templateCache
        }).then(function (result) {
          return result.data;
        });
      }
      function getResolvePromises(resolves) {
        var promisesArr = [];
        angular.forEach(resolves, function (value) {
          if (angular.isFunction(value) || angular.isArray(value)) {
            promisesArr.push($q.when($injector.invoke(value)));
          }
        });
        return promisesArr;
      }
      $modal.open = function (modalOptions) {
        var modalResultDeferred = $q.defer();
        var modalOpenedDeferred = $q.defer();

        //prepare an instance of a modal to be injected into controllers and returned to a caller
        var modalInstance = {
          result: modalResultDeferred.promise,
          opened: modalOpenedDeferred.promise,
          close: function (result) {
            $modalStack.close(modalInstance, result);
          },
          dismiss: function (reason) {
            $modalStack.dismiss(modalInstance, reason);
          }
        };

        //merge and clean up options
        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
        modalOptions.resolve = modalOptions.resolve || {};

        //verify options
        if (!modalOptions.template && !modalOptions.templateUrl) {
          throw new Error('One of template or templateUrl options is required.');
        }
        var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
        templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {
          var modalScope = (modalOptions.scope || $rootScope).$new();
          modalScope.$close = modalInstance.close;
          modalScope.$dismiss = modalInstance.dismiss;
          var ctrlInstance,
            ctrlLocals = {};
          var resolveIter = 1;

          //controllers
          if (modalOptions.controller) {
            ctrlLocals.$scope = modalScope;
            ctrlLocals.$modalInstance = modalInstance;
            angular.forEach(modalOptions.resolve, function (value, key) {
              ctrlLocals[key] = tplAndVars[resolveIter++];
            });
            ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
            if (modalOptions.controllerAs) {
              modalScope[modalOptions.controllerAs] = ctrlInstance;
            }
          }
          $modalStack.open(modalInstance, {
            scope: modalScope,
            deferred: modalResultDeferred,
            content: tplAndVars[0],
            backdrop: modalOptions.backdrop,
            keyboard: modalOptions.keyboard,
            backdropClass: modalOptions.backdropClass,
            windowClass: modalOptions.windowClass,
            windowTemplateUrl: modalOptions.windowTemplateUrl,
            size: modalOptions.size
          });
        }, function resolveError(reason) {
          modalResultDeferred.reject(reason);
        });
        templateAndResolvePromise.then(function () {
          modalOpenedDeferred.resolve(true);
        }, function () {
          modalOpenedDeferred.reject(false);
        });
        return modalInstance;
      };
      return $modal;
    }]
  };
  return $modalProvider;
});
angular.module('ui.bootstrap.pagination', []).controller('PaginationController', ['$scope', '$attrs', '$parse', function ($scope, $attrs, $parse) {
  var self = this,
    ngModelCtrl = {
      $setViewValue: angular.noop
    },
    // nullModelCtrl
    setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
  this.init = function (ngModelCtrl_, config) {
    ngModelCtrl = ngModelCtrl_;
    this.config = config;
    ngModelCtrl.$render = function () {
      self.render();
    };
    if ($attrs.itemsPerPage) {
      $scope.$parent.$watch($parse($attrs.itemsPerPage), function (value) {
        self.itemsPerPage = parseInt(value, 10);
        $scope.totalPages = self.calculateTotalPages();
      });
    } else {
      this.itemsPerPage = config.itemsPerPage;
    }
  };
  this.calculateTotalPages = function () {
    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
    return Math.max(totalPages || 0, 1);
  };
  this.render = function () {
    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
  };
  $scope.selectPage = function (page) {
    if ($scope.page !== page && page > 0 && page <= $scope.totalPages) {
      ngModelCtrl.$setViewValue(page);
      ngModelCtrl.$render();
    }
  };
  $scope.getText = function (key) {
    return $scope[key + 'Text'] || self.config[key + 'Text'];
  };
  $scope.noPrevious = function () {
    return $scope.page === 1;
  };
  $scope.noNext = function () {
    return $scope.page === $scope.totalPages;
  };
  $scope.$watch('totalItems', function () {
    $scope.totalPages = self.calculateTotalPages();
  });
  $scope.$watch('totalPages', function (value) {
    setNumPages($scope.$parent, value); // Readonly variable

    if ($scope.page > value) {
      $scope.selectPage(value);
    } else {
      ngModelCtrl.$render();
    }
  });
}]).constant('paginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true
}).directive('pagination', ['$parse', 'paginationConfig', function ($parse, paginationConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@'
    },
    require: ['pagination', '?ngModel'],
    controller: 'PaginationController',
    templateUrl: 'template/pagination/pagination.html',
    replace: true,
    link: function (scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      // Setup configuration parameters
      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
        rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
      paginationCtrl.init(ngModelCtrl, paginationConfig);
      if (attrs.maxSize) {
        scope.$parent.$watch($parse(attrs.maxSize), function (value) {
          maxSize = parseInt(value, 10);
          paginationCtrl.render();
        });
      }

      // Create page object used in template
      function makePage(number, text, isActive) {
        return {
          number: number,
          text: text,
          active: isActive
        };
      }
      function getPages(currentPage, totalPages) {
        var pages = [];

        // Default page limits
        var startPage = 1,
          endPage = totalPages;
        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

        // recompute if maxSize
        if (isMaxSized) {
          if (rotate) {
            // Current page is displayed in the middle of the visible ones
            startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
            endPage = startPage + maxSize - 1;

            // Adjust if limit is exceeded
            if (endPage > totalPages) {
              endPage = totalPages;
              startPage = endPage - maxSize + 1;
            }
          } else {
            // Visible pages are paginated with maxSize
            startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

            // Adjust last page if limit is exceeded
            endPage = Math.min(startPage + maxSize - 1, totalPages);
          }
        }

        // Add page number links
        for (var number = startPage; number <= endPage; number++) {
          var page = makePage(number, number, number === currentPage);
          pages.push(page);
        }

        // Add links to move between page sets
        if (isMaxSized && !rotate) {
          if (startPage > 1) {
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }
          if (endPage < totalPages) {
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
        }
        return pages;
      }
      var originalRender = paginationCtrl.render;
      paginationCtrl.render = function () {
        originalRender();
        if (scope.page > 0 && scope.page <= scope.totalPages) {
          scope.pages = getPages(scope.page, scope.totalPages);
        }
      };
    }
  };
}]).constant('pagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
}).directive('pager', ['pagerConfig', function (pagerConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@'
    },
    require: ['pager', '?ngModel'],
    controller: 'PaginationController',
    templateUrl: 'template/pagination/pager.html',
    replace: true,
    link: function (scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
      paginationCtrl.init(ngModelCtrl, pagerConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */.provider('$tooltip', function () {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    animation: true,
    popupDelay: 0
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'focus': 'blur'
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
  this.options = function (value) {
    angular.extend(globalOptions, value);
  };

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake-case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$position', '$interpolate', function ($window, $compile, $timeout, $document, $position, $interpolate) {
    return function $tooltip(type, prefix, defaultTriggerShow) {
      var options = angular.extend({}, defaultOptions, globalOptions);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = trigger || options.trigger || defaultTriggerShow;
        var hide = triggerMap[show] || show;
        return {
          show: show,
          hide: hide
        };
      }
      var directiveName = snake_case(type);
      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template = '<div ' + directiveName + '-popup ' + 'title="' + startSym + 'title' + endSym + '" ' + 'content="' + startSym + 'content' + endSym + '" ' + 'placement="' + startSym + 'placement' + endSym + '" ' + 'animation="animation" ' + 'is-open="isOpen"' + '>' + '</div>';
      return {
        restrict: 'EA',
        compile: function (tElem, tAttrs) {
          var tooltipLinker = $compile(template);
          return function link(scope, element, attrs) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var popupTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var positionTooltip = function () {
              var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
              ttPosition.top += 'px';
              ttPosition.left += 'px';

              // Now set the calculated positioning.
              tooltip.css(ttPosition);
            };

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;
            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }
              prepareTooltip();
              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!popupTimeout) {
                  popupTimeout = $timeout(show, ttScope.popupDelay, false);
                  popupTimeout.then(function (reposition) {
                    reposition();
                  });
                }
              } else {
                show()();
              }
            }
            function hideTooltipBind() {
              scope.$apply(function () {
                hide();
              });
            }

            // Show the tooltip popup element.
            function show() {
              popupTimeout = null;

              // If there is a pending remove transition, we must cancel it, lest the
              // tooltip be mysteriously removed.
              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }
              createTooltip();

              // Set the initial positioning.
              tooltip.css({
                top: 0,
                left: 0,
                display: 'block'
              });
              ttScope.$digest();
              positionTooltip();

              // And show the tooltip.
              ttScope.isOpen = true;
              ttScope.$digest(); // digest required as $apply is not called

              // Return positioning function as promise callback for correct
              // positioning after draw.
              return positionTooltip;
            }

            // Hide the tooltip popup element.
            function hide() {
              // First things first: we don't show it anymore.
              ttScope.isOpen = false;

              //if tooltip is going to be shown after delay, we must cancel this
              $timeout.cancel(popupTimeout);
              popupTimeout = null;

              // And now we remove it from the DOM. However, if we have animation, we
              // need to wait for it to expire beforehand.
              // FIXME: this is a placeholder for a port of the transitions library.
              if (ttScope.animation) {
                if (!transitionTimeout) {
                  transitionTimeout = $timeout(removeTooltip, 500);
                }
              } else {
                removeTooltip();
              }
            }
            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                removeTooltip();
              }
              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });
            }
            function removeTooltip() {
              transitionTimeout = null;
              if (tooltip) {
                tooltip.remove();
                tooltip = null;
              }
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }
            function prepareTooltip() {
              prepPlacement();
              prepPopupDelay();
            }

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe(type, function (val) {
              ttScope.content = val;
              if (!val && ttScope.isOpen) {
                hide();
              }
            });
            attrs.$observe(prefix + 'Title', function (val) {
              ttScope.title = val;
            });
            function prepPlacement() {
              var val = attrs[prefix + 'Placement'];
              ttScope.placement = angular.isDefined(val) ? val : options.placement;
            }
            function prepPopupDelay() {
              var val = attrs[prefix + 'PopupDelay'];
              var delay = parseInt(val, 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
            }
            var unregisterTriggers = function () {
              element.unbind(triggers.show, showTooltipBind);
              element.unbind(triggers.hide, hideTooltipBind);
            };
            function prepTriggers() {
              var val = attrs[prefix + 'Trigger'];
              unregisterTriggers();
              triggers = getTriggers(val);
              if (triggers.show === triggers.hide) {
                element.bind(triggers.show, toggleTooltipBind);
              } else {
                element.bind(triggers.show, showTooltipBind);
                element.bind(triggers.hide, hideTooltipBind);
              }
            }
            prepTriggers();
            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // if a tooltip is attached to <body> we need to remove it on
            // location change as its parent scope will probably not be destroyed
            // by the change.
            if (appendToBody) {
              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                if (ttScope.isOpen) {
                  hide();
                }
              });
            }

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              $timeout.cancel(transitionTimeout);
              $timeout.cancel(popupTimeout);
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
}).directive('tooltipPopup', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      content: '@',
      placement: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'template/tooltip/tooltip-popup.html'
  };
}).directive('tooltip', ['$tooltip', function ($tooltip) {
  return $tooltip('tooltip', 'tooltip', 'mouseenter');
}]).directive('tooltipHtmlUnsafePopup', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      content: '@',
      placement: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
  };
}).directive('tooltipHtmlUnsafe', ['$tooltip', function ($tooltip) {
  return $tooltip('tooltipHtmlUnsafe', 'tooltip', 'mouseenter');
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html popovers, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('popoverPopup', function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      title: '@',
      content: '@',
      placement: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'template/popover/popover.html'
  };
}).directive('popover', ['$tooltip', function ($tooltip) {
  return $tooltip('popover', 'popover', 'click');
}]);
angular.module('ui.bootstrap.progressbar', []).constant('progressConfig', {
  animate: true,
  max: 100
}).controller('ProgressController', ['$scope', '$attrs', 'progressConfig', function ($scope, $attrs, progressConfig) {
  var self = this,
    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
  this.bars = [];
  $scope.max = angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : progressConfig.max;
  this.addBar = function (bar, element) {
    if (!animate) {
      element.css({
        'transition': 'none'
      });
    }
    this.bars.push(bar);
    bar.$watch('value', function (value) {
      bar.percent = +(100 * value / $scope.max).toFixed(2);
    });
    bar.$on('$destroy', function () {
      element = null;
      self.removeBar(bar);
    });
  };
  this.removeBar = function (bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
  };
}]).directive('progress', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    controller: 'ProgressController',
    require: 'progress',
    scope: {},
    templateUrl: 'template/progressbar/progress.html'
  };
}).directive('bar', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    require: '^progress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'template/progressbar/bar.html',
    link: function (scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element);
    }
  };
}).directive('progressbar', function () {
  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    controller: 'ProgressController',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'template/progressbar/progressbar.html',
    link: function (scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]));
    }
  };
});
angular.module('ui.bootstrap.rating', []).constant('ratingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null
}).controller('RatingController', ['$scope', '$attrs', 'ratingConfig', function ($scope, $attrs, ratingConfig) {
  var ngModelCtrl = {
    $setViewValue: angular.noop
  };
  this.init = function (ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;
    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) : new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };
  this.buildTemplateObjects = function (states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({
        index: i
      }, {
        stateOn: this.stateOn,
        stateOff: this.stateOff
      }, states[i]);
    }
    return states;
  };
  $scope.rate = function (value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      ngModelCtrl.$setViewValue(value);
      ngModelCtrl.$render();
    }
  };
  $scope.enter = function (value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({
      value: value
    });
  };
  $scope.reset = function () {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };
  $scope.onKeydown = function (evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };
  this.render = function () {
    $scope.value = ngModelCtrl.$viewValue;
  };
}]).directive('rating', function () {
  return {
    restrict: 'EA',
    require: ['rating', 'ngModel'],
    scope: {
      readonly: '=?',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'RatingController',
    templateUrl: 'template/rating/rating.html',
    replace: true,
    link: function (scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (ngModelCtrl) {
        ratingCtrl.init(ngModelCtrl);
      }
    }
  };
});

/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */

angular.module('ui.bootstrap.tabs', []).controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
  var ctrl = this,
    tabs = ctrl.tabs = $scope.tabs = [];
  ctrl.select = function (selectedTab) {
    angular.forEach(tabs, function (tab) {
      if (tab.active && tab !== selectedTab) {
        tab.active = false;
        tab.onDeselect();
      }
    });
    selectedTab.active = true;
    selectedTab.onSelect();
  };
  ctrl.addTab = function addTab(tab) {
    tabs.push(tab);
    // we can't run the select function on the first tab
    // since that would select it twice
    if (tabs.length === 1) {
      tab.active = true;
    } else if (tab.active) {
      ctrl.select(tab);
    }
  };
  ctrl.removeTab = function removeTab(tab) {
    var index = tabs.indexOf(tab);
    //Select a new tab if the tab to be removed is selected and not destroyed
    if (tab.active && tabs.length > 1 && !destroyed) {
      //If this is the last tab, select the previous tab. else, the next tab.
      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
      ctrl.select(tabs[newActiveIndex]);
    }
    tabs.splice(index, 1);
  };
  var destroyed;
  $scope.$on('$destroy', function () {
    destroyed = true;
  });
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab heading="Tab 1"><b>First</b> Content!</tab>
      <tab heading="Tab 2"><i>Second</i> Content!</tab>
    </tabset>
    <hr />
    <tabset vertical="true">
      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
    </tabset>
    <tabset justified="true">
      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
    </tabset>
  </file>
</example>
 */.directive('tabset', function () {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    scope: {
      type: '@'
    },
    controller: 'TabsetController',
    templateUrl: 'template/tabs/tabset.html',
    link: function (scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <div ng-controller="TabsDemoCtrl">
      <button class="btn btn-small" ng-click="items[0].active = true">
        Select item 1, using active binding
      </button>
      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
        Enable/disable item 2, using disabled binding
      </button>
      <br />
      <tabset>
        <tab heading="Tab 1">First Tab</tab>
        <tab select="alertMe()">
          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
          Second Tab, with alert callback and html heading!
        </tab>
        <tab ng-repeat="item in items"
          heading="{{item.title}}"
          disabled="item.disabled"
          active="item.active">
          {{item.content}}
        </tab>
      </tabset>
    </div>
  </file>
  <file name="script.js">
    function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
  </file>
</example>
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab>
        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
        And some content, too!
      </tab>
      <tab>
        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
        That's right.
      </tab>
    </tabset>
  </file>
</example>
 */.directive('tab', ['$parse', function ($parse) {
  return {
    require: '^tabset',
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/tabs/tab.html',
    transclude: true,
    scope: {
      active: '=?',
      heading: '@',
      onSelect: '&select',
      //This callback is called in contentHeadingTransclude
      //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function () {
      //Empty controller so other directives can require being 'under' a tab
    },
    compile: function (elm, attrs, transclude) {
      return function postLink(scope, elm, attrs, tabsetCtrl) {
        scope.$watch('active', function (active) {
          if (active) {
            tabsetCtrl.select(scope);
          }
        });
        scope.disabled = false;
        if (attrs.disabled) {
          scope.$parent.$watch($parse(attrs.disabled), function (value) {
            scope.disabled = !!value;
          });
        }
        scope.select = function () {
          if (!scope.disabled) {
            scope.active = true;
          }
        };
        tabsetCtrl.addTab(scope);
        scope.$on('$destroy', function () {
          tabsetCtrl.removeTab(scope);
        });

        //We need to transclude later, once the content container is ready.
        //when this link happens, we're inside a tab heading.
        scope.$transcludeFn = transclude;
      };
    }
  };
}]).directive('tabHeadingTransclude', [function () {
  return {
    restrict: 'A',
    require: '^tab',
    link: function (scope, elm, attrs, tabCtrl) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
}]).directive('tabContentTransclude', function () {
  return {
    restrict: 'A',
    require: '^tabset',
    link: function (scope, elm, attrs) {
      var tab = scope.$eval(attrs.tabContentTransclude);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };
  function isTabHeading(node) {
    return node.tagName && (node.hasAttribute('tab-heading') || node.hasAttribute('data-tab-heading') || node.tagName.toLowerCase() === 'tab-heading' || node.tagName.toLowerCase() === 'data-tab-heading');
  }
});
angular.module('ui.bootstrap.timepicker', []).constant('timepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  showMeridian: true,
  meridians: null,
  readonlyInput: false,
  mousewheel: true
}).controller('TimepickerController', ['$scope', '$attrs', '$parse', '$log', '$locale', 'timepickerConfig', function ($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
  var selected = new Date(),
    ngModelCtrl = {
      $setViewValue: angular.noop
    },
    // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
  this.init = function (ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;
    var hoursInputEl = inputs.eq(0),
      minutesInputEl = inputs.eq(1);
    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
    }
    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl);
  };
  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    $scope.$parent.$watch($parse($attrs.hourStep), function (value) {
      hourStep = parseInt(value, 10);
    });
  }
  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    $scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
      minuteStep = parseInt(value, 10);
    });
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    $scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
      $scope.showMeridian = !!value;
      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(),
          minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    });
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = parseInt($scope.hours, 10);
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
    if (!valid) {
      return undefined;
    }
    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }
  function getMinutesFromTemplate() {
    var minutes = parseInt($scope.minutes, 10);
    return minutes >= 0 && minutes < 60 ? minutes : undefined;
  }
  function pad(value) {
    return angular.isDefined(value) && value.toString().length < 2 ? '0' + value : value;
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl) {
    var isScrollingUp = function (e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };
    hoursInputEl.bind('mousewheel wheel', function (e) {
      $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      e.preventDefault();
    });
    minutesInputEl.bind('mousewheel wheel', function (e) {
      $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      e.preventDefault();
    });
  };
  this.setupInputEvents = function (hoursInputEl, minutesInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      return;
    }
    var invalidate = function (invalidHours, invalidMinutes) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
      }
      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
      }
    };
    $scope.updateHours = function () {
      var hours = getHoursFromTemplate();
      if (angular.isDefined(hours)) {
        selected.setHours(hours);
        refresh('h');
      } else {
        invalidate(true);
      }
    };
    hoursInputEl.bind('blur', function (e) {
      if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function () {
          $scope.hours = pad($scope.hours);
        });
      }
    });
    $scope.updateMinutes = function () {
      var minutes = getMinutesFromTemplate();
      if (angular.isDefined(minutes)) {
        selected.setMinutes(minutes);
        refresh('m');
      } else {
        invalidate(undefined, true);
      }
    };
    minutesInputEl.bind('blur', function (e) {
      if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function () {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });
  };
  this.render = function () {
    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }
      makeValid();
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }
  function makeValid() {
    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
  }
  function updateTemplate(keyboardChange) {
    var hours = selected.getHours(),
      minutes = selected.getMinutes();
    if ($scope.showMeridian) {
      hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
    }

    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
    $scope.minutes = keyboardChange === 'm' ? minutes : pad(minutes);
    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
  }
  function addMinutes(minutes) {
    var dt = new Date(selected.getTime() + minutes * 60000);
    selected.setHours(dt.getHours(), dt.getMinutes());
    refresh();
  }
  $scope.incrementHours = function () {
    addMinutes(hourStep * 60);
  };
  $scope.decrementHours = function () {
    addMinutes(-hourStep * 60);
  };
  $scope.incrementMinutes = function () {
    addMinutes(minuteStep);
  };
  $scope.decrementMinutes = function () {
    addMinutes(-minuteStep);
  };
  $scope.toggleMeridian = function () {
    addMinutes(12 * 60 * (selected.getHours() < 12 ? 1 : -1));
  };
}]).directive('timepicker', function () {
  return {
    restrict: 'EA',
    require: ['timepicker', '?^ngModel'],
    controller: 'TimepickerController',
    replace: true,
    scope: {},
    templateUrl: 'template/timepicker/timepicker.html',
    link: function (scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
});
angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */.factory('typeaheadParser', ['$parse', function ($parse) {
  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function (input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' + ' but got "' + input + '".');
      }
      return {
        itemName: match[3],
        source: $parse(match[4]),
        viewMapper: $parse(match[2] || match[1]),
        modelMapper: $parse(match[1])
      };
    }
  };
}]).directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$position', 'typeaheadParser', function ($compile, $parse, $q, $timeout, $document, $position, typeaheadParser) {
  var HOT_KEYS = [9, 13, 27, 38, 40];
  return {
    require: 'ngModel',
    link: function (originalScope, element, attrs, modelCtrl) {
      //SUPPORTED ATTRIBUTES (OPTIONS)

      //minimal no of characters that needs to be entered before typeahead kicks-in
      var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;

      //minimal wait time after last character typed before typehead kicks-in
      var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

      //should it restrict model values to the ones selected from the popup only?
      var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

      //binding to a variable that indicates if matches are being retrieved asynchronously
      var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

      //a callback executed when a match is selected
      var onSelectCallback = $parse(attrs.typeaheadOnSelect);
      var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
      var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
      var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

      //INTERNAL VARIABLES

      //model setter executed upon match selection
      var $setModelValue = $parse(attrs.ngModel).assign;

      //expressions used by typeahead
      var parserResult = typeaheadParser.parse(attrs.typeahead);
      var hasFocus;

      //create a child scope for the typeahead directive so we are not polluting original scope
      //with typeahead-specific data (matches, query etc.)
      var scope = originalScope.$new();
      originalScope.$on('$destroy', function () {
        scope.$destroy();
      });

      // WAI-ARIA
      var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      element.attr({
        'aria-autocomplete': 'list',
        'aria-expanded': false,
        'aria-owns': popupId
      });

      //pop-up element used to display matches
      var popUpEl = angular.element('<div typeahead-popup></div>');
      popUpEl.attr({
        id: popupId,
        matches: 'matches',
        active: 'activeIdx',
        select: 'select(activeIdx)',
        query: 'query',
        position: 'position'
      });
      //custom item template
      if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
        popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
      }
      var resetMatches = function () {
        scope.matches = [];
        scope.activeIdx = -1;
        element.attr('aria-expanded', false);
      };
      var getMatchId = function (index) {
        return popupId + '-option-' + index;
      };

      // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
      // This attribute is added or removed automatically when the `activeIdx` changes.
      scope.$watch('activeIdx', function (index) {
        if (index < 0) {
          element.removeAttr('aria-activedescendant');
        } else {
          element.attr('aria-activedescendant', getMatchId(index));
        }
      });
      var getMatchesAsync = function (inputValue) {
        var locals = {
          $viewValue: inputValue
        };
        isLoadingSetter(originalScope, true);
        $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
          //it might happen that several async queries were in progress if a user were typing fast
          //but we are interested only in responses that correspond to the current view value
          var onCurrentRequest = inputValue === modelCtrl.$viewValue;
          if (onCurrentRequest && hasFocus) {
            if (matches.length > 0) {
              scope.activeIdx = focusFirst ? 0 : -1;
              scope.matches.length = 0;

              //transform labels
              for (var i = 0; i < matches.length; i++) {
                locals[parserResult.itemName] = matches[i];
                scope.matches.push({
                  id: getMatchId(i),
                  label: parserResult.viewMapper(scope, locals),
                  model: matches[i]
                });
              }
              scope.query = inputValue;
              //position pop-up with matches - we need to re-calculate its position each time we are opening a window
              //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
              //due to other elements being rendered
              scope.position = appendToBody ? $position.offset(element) : $position.position(element);
              scope.position.top = scope.position.top + element.prop('offsetHeight');
              element.attr('aria-expanded', true);
            } else {
              resetMatches();
            }
          }
          if (onCurrentRequest) {
            isLoadingSetter(originalScope, false);
          }
        }, function () {
          resetMatches();
          isLoadingSetter(originalScope, false);
        });
      };
      resetMatches();

      //we need to propagate user's query so we can higlight matches
      scope.query = undefined;

      //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later 
      var timeoutPromise;
      var scheduleSearchWithTimeout = function (inputValue) {
        timeoutPromise = $timeout(function () {
          getMatchesAsync(inputValue);
        }, waitTime);
      };
      var cancelPreviousTimeout = function () {
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }
      };

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function (inputValue) {
        hasFocus = true;
        if (inputValue && inputValue.length >= minSearch) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }
        if (isEditable) {
          return inputValue;
        } else {
          if (!inputValue) {
            // Reset in case user had typed something previously.
            modelCtrl.$setValidity('editable', true);
            return inputValue;
          } else {
            modelCtrl.$setValidity('editable', false);
            return undefined;
          }
        }
      });
      modelCtrl.$formatters.push(function (modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};
        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        } else {
          //it might happen that we don't have enough info to properly render input value
          //we need to check for this situation and simply return model value if we can't apply custom formatting
          locals[parserResult.itemName] = modelValue;
          candidateViewValue = parserResult.viewMapper(originalScope, locals);
          locals[parserResult.itemName] = undefined;
          emptyViewValue = parserResult.viewMapper(originalScope, locals);
          return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
        }
      });
      scope.select = function (activeIdx) {
        //called from within the $digest() cycle
        var locals = {};
        var model, item;
        locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
        model = parserResult.modelMapper(originalScope, locals);
        $setModelValue(originalScope, model);
        modelCtrl.$setValidity('editable', true);
        onSelectCallback(originalScope, {
          $item: item,
          $model: model,
          $label: parserResult.viewMapper(originalScope, locals)
        });
        resetMatches();

        //return focus to the input element if a match was selected via a mouse click event
        // use timeout to avoid $rootScope:inprog error
        $timeout(function () {
          element[0].focus();
        }, 0, false);
      };

      //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
      element.bind('keydown', function (evt) {
        //typeahead is open and an "interesting" key was pressed
        if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
          return;
        }

        // if there's nothing selected (i.e. focusFirst) and enter is hit, don't do anything
        if (scope.activeIdx == -1 && (evt.which === 13 || evt.which === 9)) {
          return;
        }
        evt.preventDefault();
        if (evt.which === 40) {
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
        } else if (evt.which === 38) {
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
        } else if (evt.which === 13 || evt.which === 9) {
          scope.$apply(function () {
            scope.select(scope.activeIdx);
          });
        } else if (evt.which === 27) {
          evt.stopPropagation();
          resetMatches();
          scope.$digest();
        }
      });
      element.bind('blur', function (evt) {
        hasFocus = false;
      });

      // Keep reference to click handler to unbind it.
      var dismissClickHandler = function (evt) {
        if (element[0] !== evt.target) {
          resetMatches();
          scope.$digest();
        }
      };
      $document.bind('click', dismissClickHandler);
      originalScope.$on('$destroy', function () {
        $document.unbind('click', dismissClickHandler);
        if (appendToBody) {
          $popup.remove();
        }
      });
      var $popup = $compile(popUpEl)(scope);
      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }
    }
  };
}]).directive('typeaheadPopup', function () {
  return {
    restrict: 'EA',
    scope: {
      matches: '=',
      query: '=',
      active: '=',
      position: '=',
      select: '&'
    },
    replace: true,
    templateUrl: 'template/typeahead/typeahead-popup.html',
    link: function (scope, element, attrs) {
      scope.templateUrl = attrs.templateUrl;
      scope.isOpen = function () {
        return scope.matches.length > 0;
      };
      scope.isActive = function (matchIdx) {
        return scope.active == matchIdx;
      };
      scope.selectActive = function (matchIdx) {
        scope.active = matchIdx;
      };
      scope.selectMatch = function (activeIdx) {
        scope.select({
          activeIdx: activeIdx
        });
      };
    }
  };
}).directive('typeaheadMatch', ['$http', '$templateCache', '$compile', '$parse', function ($http, $templateCache, $compile, $parse) {
  return {
    restrict: 'EA',
    scope: {
      index: '=',
      match: '=',
      query: '='
    },
    link: function (scope, element, attrs) {
      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
      $http.get(tplUrl, {
        cache: $templateCache
      }).success(function (tplContent) {
        element.replaceWith($compile(tplContent.trim())(scope));
      });
    }
  };
}]).filter('typeaheadHighlight', function () {
  function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }
  return function (matchItem, query) {
    return query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem;
  };
});
angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion-group.html", "<div class=\"panel panel-default\">\n" + "  <div class=\"panel-heading\">\n" + "    <h4 class=\"panel-title\">\n" + "      <a href class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "    </h4>\n" + "  </div>\n" + "  <div class=\"panel-collapse\" collapse=\"!isOpen\">\n" + "	  <div class=\"panel-body\" ng-transclude></div>\n" + "  </div>\n" + "</div>\n" + "");
}]);
angular.module("template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion.html", "<div class=\"panel-group\" ng-transclude></div>");
}]);
angular.module("template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/alert/alert.html", "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" + "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" + "        <span aria-hidden=\"true\">&times;</span>\n" + "        <span class=\"sr-only\">Close</span>\n" + "    </button>\n" + "    <div ng-transclude></div>\n" + "</div>\n" + "");
}]);
angular.module("template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/carousel/carousel.html", "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" + "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" + "        <li ng-repeat=\"slide in slides track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" + "    </ol>\n" + "    <div class=\"carousel-inner\" ng-transclude></div>\n" + "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" + "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" + "</div>\n" + "");
}]);
angular.module("template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/carousel/slide.html", "<div ng-class=\"{\n" + "    'active': leaving || (active && !entering),\n" + "    'prev': (next || active) && direction=='prev',\n" + "    'next': (next || active) && direction=='next',\n" + "    'right': direction=='prev',\n" + "    'left': direction=='next'\n" + "  }\" class=\"item text-center\" ng-transclude></div>\n" + "");
}]);
angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" + "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" + "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" + "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" + "</div>");
}]);
angular.module("template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"{{5 + showWeeks}}\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);
angular.module("template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);
angular.module("template/datepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/popup.html", "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" + "	<li ng-transclude></li>\n" + "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" + "		<span class=\"btn-group pull-left\">\n" + "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" + "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" + "		</span>\n" + "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" + "	</li>\n" + "</ul>\n" + "");
}]);
angular.module("template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" + "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr ng-repeat=\"row in rows track by $index\">\n" + "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" + "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);
angular.module("template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/backdrop.html", "<div class=\"modal-backdrop fade {{ backdropClass }}\"\n" + "     ng-class=\"{in: animate}\"\n" + "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" + "></div>\n" + "");
}]);
angular.module("template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/window.html", "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" + "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" + "</div>");
}]);
angular.module("template/pagination/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/pagination/pager.html", "<ul class=\"pager\">\n" + "  <li ng-class=\"{disabled: noPrevious(), previous: align}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" + "  <li ng-class=\"{disabled: noNext(), next: align}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" + "</ul>");
}]);
angular.module("template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/pagination/pagination.html", "<ul class=\"pagination\">\n" + "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\">{{getText('first')}}</a></li>\n" + "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" + "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" + "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" + "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\">{{getText('last')}}</a></li>\n" + "</ul>");
}]);
angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html", "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" + "</div>\n" + "");
}]);
angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tooltip/tooltip-popup.html", "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"tooltip-arrow\"></div>\n" + "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");
}]);
angular.module("template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/popover/popover.html", "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" + "  <div class=\"arrow\"></div>\n" + "\n" + "  <div class=\"popover-inner\">\n" + "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n" + "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "  </div>\n" + "</div>\n" + "");
}]);
angular.module("template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/bar.html", "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");
}]);
angular.module("template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/progress.html", "<div class=\"progress\" ng-transclude></div>");
}]);
angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/progressbar.html", "<div class=\"progress\">\n" + "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>\n" + "</div>");
}]);
angular.module("template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/rating/rating.html", "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" + "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\">\n" + "        <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" + "    </i>\n" + "</span>");
}]);
angular.module("template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tabs/tab.html", "<li ng-class=\"{active: active, disabled: disabled}\">\n" + "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
}]);
angular.module("template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\" \n" + "         ng-repeat=\"tab in tabs\" \n" + "         ng-class=\"{active: tab.active}\"\n" + "         tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
}]);
angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/timepicker/timepicker.html", "<table>\n" + "	<tbody>\n" + "		<tr class=\"text-center\">\n" + "			<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "			<td>&nbsp;</td>\n" + "			<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "			<td ng-show=\"showMeridian\"></td>\n" + "		</tr>\n" + "		<tr>\n" + "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" + "				<input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" + "			</td>\n" + "			<td>:</td>\n" + "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "				<input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" + "			</td>\n" + "			<td ng-show=\"showMeridian\"><button type=\"button\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" + "		</tr>\n" + "		<tr class=\"text-center\">\n" + "			<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "			<td>&nbsp;</td>\n" + "			<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "			<td ng-show=\"showMeridian\"></td>\n" + "		</tr>\n" + "	</tbody>\n" + "</table>\n" + "");
}]);
angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/typeahead/typeahead-match.html", "<a tabindex=\"-1\" bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
}]);
angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/typeahead/typeahead-popup.html", "<ul class=\"dropdown-menu\" ng-show=\"isOpen()\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" + "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{match.id}}\">\n" + "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" + "    </li>\n" + "</ul>\n" + "");
}]);
/**
 * Angular Dynamic Locale - 0.1.37
 * https://github.com/lgalfaso/angular-dynamic-locale
 * License: MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return factory();
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
})(this, function () {
  'use strict';

  angular.module('tmh.dynamicLocale', []).config(['$provide', function ($provide) {
    function makeStateful($delegate) {
      $delegate.$stateful = true;
      return $delegate;
    }
    $provide.decorator('dateFilter', ['$delegate', makeStateful]);
    $provide.decorator('numberFilter', ['$delegate', makeStateful]);
    $provide.decorator('currencyFilter', ['$delegate', makeStateful]);
  }]).constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale').provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function (STORAGE_KEY) {
    var defaultLocale,
      localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
      nodeToAppend,
      storageFactory = 'tmhDynamicLocaleStorageCache',
      storage,
      storageKey = STORAGE_KEY,
      storageGet = 'get',
      storagePut = 'put',
      promiseCache = {},
      activeLocale,
      extraProperties = {};

    /**
    * Loads a script asynchronously
    *
    * @param {string} url The url for the script
    @ @param {function} callback A function to be called once the script is loaded
    */
    function loadScript(url, callback, errorCallback, $timeout) {
      var script = document.createElement('script'),
        element = nodeToAppend ? nodeToAppend : document.getElementsByTagName('body')[0],
        removed = false;
      script.type = 'text/javascript';
      if (script.readyState) {
        // IE
        script.onreadystatechange = function () {
          if (script.readyState === 'complete' || script.readyState === 'loaded') {
            script.onreadystatechange = null;
            $timeout(function () {
              if (removed) return;
              removed = true;
              if (script.parentNode === element) {
                element.removeChild(script);
              }
              callback();
            }, 30, false);
          }
        };
      } else {
        // Others
        script.onload = function () {
          if (removed) return;
          removed = true;
          if (script.parentNode === element) {
            element.removeChild(script);
          }
          callback();
        };
        script.onerror = function () {
          if (removed) return;
          removed = true;
          if (script.parentNode === element) {
            element.removeChild(script);
          }
          errorCallback();
        };
      }
      script.src = url;
      script.async = true;
      element.appendChild(script);
    }

    /**
    * Loads a locale and replaces the properties from the current locale with the new locale information
    *
    * @param {string} localeUrl The path to the new locale
    * @param {Object} $locale The locale at the curent scope
    * @param {string} localeId The locale id to load
    * @param {Object} $rootScope The application $rootScope
    * @param {Object} $q The application $q
    * @param {Object} localeCache The current locale cache
    * @param {Object} $timeout The application $timeout
    */
    function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {
      function overrideValues(oldObject, newObject) {
        if (activeLocale !== localeId) {
          return;
        }
        angular.forEach(oldObject, function (value, key) {
          if (!newObject[key]) {
            delete oldObject[key];
          } else if (angular.isArray(newObject[key])) {
            oldObject[key].length = newObject[key].length;
          }
        });
        angular.forEach(newObject, function (value, key) {
          if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
            if (!oldObject[key]) {
              oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
            }
            overrideValues(oldObject[key], newObject[key]);
          } else {
            oldObject[key] = newObject[key];
          }
        });
      }
      if (promiseCache[localeId]) {
        activeLocale = localeId;
        return promiseCache[localeId];
      }
      var cachedLocale,
        deferred = $q.defer();
      if (localeId === activeLocale) {
        deferred.resolve($locale);
      } else if (cachedLocale = localeCache.get(localeId)) {
        activeLocale = localeId;
        $rootScope.$evalAsync(function () {
          overrideValues($locale, cachedLocale);
          storage[storagePut](storageKey, localeId);
          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
          deferred.resolve($locale);
        });
      } else {
        activeLocale = localeId;
        promiseCache[localeId] = deferred.promise;
        loadScript(localeUrl, function () {
          // Create a new injector with the new locale
          var localInjector = angular.injector(['ngLocale']),
            externalLocale = localInjector.get('$locale');
          overrideValues($locale, externalLocale);
          localeCache.put(localeId, externalLocale);
          delete promiseCache[localeId];
          $rootScope.$applyAsync(function () {
            storage[storagePut](storageKey, localeId);
            $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
            deferred.resolve($locale);
          });
        }, function () {
          delete promiseCache[localeId];
          $rootScope.$applyAsync(function () {
            if (activeLocale === localeId) {
              activeLocale = $locale.id;
            }
            $rootScope.$broadcast('$localeChangeError', localeId);
            deferred.reject(localeId);
          });
        }, $timeout);
      }
      return deferred.promise;
    }
    this.localeLocationPattern = function (value) {
      if (value) {
        localeLocationPattern = value;
        return this;
      } else {
        return localeLocationPattern;
      }
    };
    this.appendScriptTo = function (nodeElement) {
      nodeToAppend = nodeElement;
    };
    this.useStorage = function (storageName) {
      storageFactory = storageName;
      storageGet = 'get';
      storagePut = 'put';
    };
    this.useCookieStorage = function () {
      if (angular.version.minor < 7) {
        this.useStorage('$cookieStore');
      } else {
        this.useStorage('$cookies');
        storageGet = 'getObject';
        storagePut = 'putObject';
      }
    };
    this.defaultLocale = function (value) {
      defaultLocale = value;
    };
    this.storageKey = function (value) {
      if (value) {
        storageKey = value;
        return this;
      } else {
        return storageKey;
      }
    };
    this.addLocalePatternValue = function (key, value) {
      extraProperties[key] = value;
    };
    this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function ($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
      var localeLocation = interpolate(localeLocationPattern);
      storage = $injector.get(storageFactory);
      $rootScope.$evalAsync(function () {
        var initialLocale;
        if (initialLocale = storage[storageGet](storageKey) || defaultLocale) {
          loadLocaleFn(initialLocale);
        }
      });
      return {
        /**
        * @ngdoc method
        * @description
        * @param {string} value Sets the locale to the new locale. Changing the locale will trigger
        *    a background task that will retrieve the new locale and configure the current $locale
        *    instance with the information from the new locale
        */
        set: loadLocaleFn,
        /**
        * @ngdoc method
        * @description Returns the configured locale
        */
        get: function () {
          return activeLocale;
        }
      };
      function loadLocaleFn(localeId) {
        var baseProperties = {
          locale: localeId,
          angularVersion: angular.version.full
        };
        return loadLocale(localeLocation(angular.extend({}, extraProperties, baseProperties)), locale, localeId, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
      }
    }];
  }]).provider('tmhDynamicLocaleCache', function () {
    this.$get = ['$cacheFactory', function ($cacheFactory) {
      return $cacheFactory('tmh.dynamicLocales');
    }];
  }).provider('tmhDynamicLocaleStorageCache', function () {
    this.$get = ['$cacheFactory', function ($cacheFactory) {
      return $cacheFactory('tmh.dynamicLocales.store');
    }];
  }).run(['tmhDynamicLocale', angular.noop]);
  return 'tmh.dynamicLocale';
});
/*
 angular-file-upload v2.5.0
 https://github.com/nervgh/angular-file-upload
*/

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["angular-file-upload"] = t() : e["angular-file-upload"] = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    var r = n(1),
      i = o(r),
      s = n(2),
      a = o(s),
      u = n(3),
      l = o(u),
      p = n(4),
      c = o(p),
      f = n(5),
      d = o(f),
      h = n(6),
      y = o(h),
      v = n(7),
      m = o(v),
      _ = n(8),
      g = o(_),
      b = n(9),
      F = o(b),
      O = n(10),
      C = o(O),
      w = n(11),
      A = o(w),
      I = n(12),
      T = o(I),
      U = n(13),
      x = o(U);
    angular.module(i["default"].name, []).value("fileUploaderOptions", a["default"]).factory("FileUploader", l["default"]).factory("FileLikeObject", c["default"]).factory("FileItem", d["default"]).factory("FileDirective", y["default"]).factory("FileSelect", m["default"]).factory("FileDrop", F["default"]).factory("FileOver", C["default"]).factory("Pipeline", g["default"]).directive("nvFileSelect", A["default"]).directive("nvFileDrop", T["default"]).directive("nvFileOver", x["default"]).run(["FileUploader", "FileLikeObject", "FileItem", "FileDirective", "FileSelect", "FileDrop", "FileOver", "Pipeline", function (e, t, n, o, r, i, s, a) {
      e.FileLikeObject = t, e.FileItem = n, e.FileDirective = o, e.FileSelect = r, e.FileDrop = i, e.FileOver = s, e.Pipeline = a;
    }]);
  }, function (e, t) {
    e.exports = {
      name: "angularFileUpload"
    };
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = {
      url: "/",
      alias: "file",
      headers: {},
      queue: [],
      progress: 0,
      autoUpload: !1,
      removeAfterUpload: !1,
      method: "POST",
      filters: [],
      formData: [],
      queueLimit: Number.MAX_VALUE,
      withCredentials: !1,
      disableMultipart: !1
    };
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t, n, o, i, a, u, g) {
      var b = o.File,
        F = o.FormData,
        O = function () {
          function o(t) {
            r(this, o);
            var n = p(e);
            c(this, n, t, {
              isUploading: !1,
              _nextIndex: 0,
              _directives: {
                select: [],
                drop: [],
                over: []
              }
            }), this.filters.unshift({
              name: "queueLimit",
              fn: this._queueLimitFilter
            }), this.filters.unshift({
              name: "folder",
              fn: this._folderFilter
            });
          }
          return o.prototype.addToQueue = function (e, t, n) {
            var o = this,
              r = this.isArrayLikeObject(e) ? Array.prototype.slice.call(e) : [e],
              i = this._getFilters(n),
              l = this.queue.length,
              p = [],
              c = function d() {
                var e = r.shift();
                if (m(e)) return f();
                var n = o.isFile(e) ? e : new a(e),
                  l = o._convertFiltersToPipes(i),
                  c = new g(l),
                  h = function (e) {
                    var t = e.pipe.originalFilter,
                      n = s(e.args, 2),
                      r = n[0],
                      i = n[1];
                    o._onWhenAddingFileFailed(r, t, i), d();
                  },
                  y = function (e, t) {
                    var n = new u(o, e, t);
                    p.push(n), o.queue.push(n), o._onAfterAddingFile(n), d();
                  };
                c.onThrown = h, c.onSuccessful = y, c.exec(n, t);
              },
              f = function () {
                o.queue.length !== l && (o._onAfterAddingAll(p), o.progress = o._getTotalProgress()), o._render(), o.autoUpload && o.uploadAll();
              };
            c();
          }, o.prototype.removeFromQueue = function (e) {
            var t = this.getIndexOfItem(e),
              n = this.queue[t];
            n.isUploading && n.cancel(), this.queue.splice(t, 1), n._destroy(), this.progress = this._getTotalProgress();
          }, o.prototype.clearQueue = function () {
            for (; this.queue.length;) this.queue[0].remove();
            this.progress = 0;
          }, o.prototype.uploadItem = function (e) {
            var t = this.getIndexOfItem(e),
              n = this.queue[t],
              o = this.isHTML5 ? "_xhrTransport" : "_iframeTransport";
            n._prepareToUploading(), this.isUploading || (this._onBeforeUploadItem(n), n.isCancel || (n.isUploading = !0, this.isUploading = !0, this[o](n), this._render()));
          }, o.prototype.cancelItem = function (e) {
            var t = this,
              n = this.getIndexOfItem(e),
              o = this.queue[n],
              r = this.isHTML5 ? "_xhr" : "_form";
            o && (o.isCancel = !0, o.isUploading ? o[r].abort() : !function () {
              var e = [void 0, 0, {}],
                n = function () {
                  t._onCancelItem.apply(t, [o].concat(e)), t._onCompleteItem.apply(t, [o].concat(e));
                };
              i(n);
            }());
          }, o.prototype.uploadAll = function () {
            var e = this.getNotUploadedItems().filter(function (e) {
              return !e.isUploading;
            });
            e.length && (f(e, function (e) {
              return e._prepareToUploading();
            }), e[0].upload());
          }, o.prototype.cancelAll = function () {
            var e = this.getNotUploadedItems();
            f(e, function (e) {
              return e.cancel();
            });
          }, o.prototype.isFile = function (e) {
            return this.constructor.isFile(e);
          }, o.prototype.isFileLikeObject = function (e) {
            return this.constructor.isFileLikeObject(e);
          }, o.prototype.isArrayLikeObject = function (e) {
            return this.constructor.isArrayLikeObject(e);
          }, o.prototype.getIndexOfItem = function (e) {
            return h(e) ? e : this.queue.indexOf(e);
          }, o.prototype.getNotUploadedItems = function () {
            return this.queue.filter(function (e) {
              return !e.isUploaded;
            });
          }, o.prototype.getReadyItems = function () {
            return this.queue.filter(function (e) {
              return e.isReady && !e.isUploading;
            }).sort(function (e, t) {
              return e.index - t.index;
            });
          }, o.prototype.destroy = function () {
            var e = this;
            f(this._directives, function (t) {
              f(e._directives[t], function (e) {
                e.destroy();
              });
            });
          }, o.prototype.onAfterAddingAll = function (e) {}, o.prototype.onAfterAddingFile = function (e) {}, o.prototype.onWhenAddingFileFailed = function (e, t, n) {}, o.prototype.onBeforeUploadItem = function (e) {}, o.prototype.onProgressItem = function (e, t) {}, o.prototype.onProgressAll = function (e) {}, o.prototype.onSuccessItem = function (e, t, n, o) {}, o.prototype.onErrorItem = function (e, t, n, o) {}, o.prototype.onCancelItem = function (e, t, n, o) {}, o.prototype.onCompleteItem = function (e, t, n, o) {}, o.prototype.onCompleteAll = function () {}, o.prototype._getTotalProgress = function (e) {
            if (this.removeAfterUpload) return e || 0;
            var t = this.getNotUploadedItems().length,
              n = t ? this.queue.length - t : this.queue.length,
              o = 100 / this.queue.length,
              r = (e || 0) * o / 100;
            return Math.round(n * o + r);
          }, o.prototype._getFilters = function (e) {
            if (!e) return this.filters;
            if (v(e)) return e;
            var t = e.match(/[^\s,]+/g);
            return this.filters.filter(function (e) {
              return -1 !== t.indexOf(e.name);
            });
          }, o.prototype._convertFiltersToPipes = function (e) {
            var t = this;
            return e.map(function (e) {
              var n = l(t, e.fn);
              return n.isAsync = 3 === e.fn.length, n.originalFilter = e, n;
            });
          }, o.prototype._render = function () {
            t.$$phase || t.$apply();
          }, o.prototype._folderFilter = function (e) {
            return !(!e.size && !e.type);
          }, o.prototype._queueLimitFilter = function () {
            return this.queue.length < this.queueLimit;
          }, o.prototype._isSuccessCode = function (e) {
            return e >= 200 && 300 > e || 304 === e;
          }, o.prototype._transformResponse = function (e, t) {
            var o = this._headersGetter(t);
            return f(n.defaults.transformResponse, function (t) {
              e = t(e, o);
            }), e;
          }, o.prototype._parseHeaders = function (e) {
            var t,
              n,
              o,
              r = {};
            return e ? (f(e.split("\n"), function (e) {
              o = e.indexOf(":"), t = e.slice(0, o).trim().toLowerCase(), n = e.slice(o + 1).trim(), t && (r[t] = r[t] ? r[t] + ", " + n : n);
            }), r) : r;
          }, o.prototype._headersGetter = function (e) {
            return function (t) {
              return t ? e[t.toLowerCase()] || null : e;
            };
          }, o.prototype._xhrTransport = function (e) {
            var t,
              n = this,
              o = e._xhr = new XMLHttpRequest();
            if (e.disableMultipart ? t = e._file : (t = new F(), f(e.formData, function (e) {
              f(e, function (e, n) {
                t.append(n, e);
              });
            }), t.append(e.alias, e._file, e.file.name)), "number" != typeof e._file.size) throw new TypeError("The file specified is no longer valid");
            o.upload.onprogress = function (t) {
              var o = Math.round(t.lengthComputable ? 100 * t.loaded / t.total : 0);
              n._onProgressItem(e, o);
            }, o.onload = function () {
              var t = n._parseHeaders(o.getAllResponseHeaders()),
                r = n._transformResponse(o.response, t),
                i = n._isSuccessCode(o.status) ? "Success" : "Error",
                s = "_on" + i + "Item";
              n[s](e, r, o.status, t), n._onCompleteItem(e, r, o.status, t);
            }, o.onerror = function () {
              var t = n._parseHeaders(o.getAllResponseHeaders()),
                r = n._transformResponse(o.response, t);
              n._onErrorItem(e, r, o.status, t), n._onCompleteItem(e, r, o.status, t);
            }, o.onabort = function () {
              var t = n._parseHeaders(o.getAllResponseHeaders()),
                r = n._transformResponse(o.response, t);
              n._onCancelItem(e, r, o.status, t), n._onCompleteItem(e, r, o.status, t);
            }, o.open(e.method, e.url, !0), o.withCredentials = e.withCredentials, f(e.headers, function (e, t) {
              o.setRequestHeader(t, e);
            }), o.send(t);
          }, o.prototype._iframeTransport = function (e) {
            var t = this,
              n = _('<form style="display: none;" />'),
              o = _('<iframe name="iframeTransport' + Date.now() + '">'),
              r = e._input;
            e._form && e._form.replaceWith(r), e._form = n, r.prop("name", e.alias), f(e.formData, function (e) {
              f(e, function (e, t) {
                var o = _('<input type="hidden" name="' + t + '" />');
                o.val(e), n.append(o);
              });
            }), n.prop({
              action: e.url,
              method: "POST",
              target: o.prop("name"),
              enctype: "multipart/form-data",
              encoding: "multipart/form-data"
            }), o.bind("load", function () {
              var n = "",
                r = 200;
              try {
                n = o[0].contentDocument.body.innerHTML;
              } catch (i) {
                r = 500;
              }
              var s = {
                  response: n,
                  status: r,
                  dummy: !0
                },
                a = {},
                u = t._transformResponse(s.response, a);
              t._onSuccessItem(e, u, s.status, a), t._onCompleteItem(e, u, s.status, a);
            }), n.abort = function () {
              var i,
                s = {
                  status: 0,
                  dummy: !0
                },
                a = {};
              o.unbind("load").prop("src", "javascript:false;"), n.replaceWith(r), t._onCancelItem(e, i, s.status, a), t._onCompleteItem(e, i, s.status, a);
            }, r.after(n), n.append(r).append(o), n[0].submit();
          }, o.prototype._onWhenAddingFileFailed = function (e, t, n) {
            this.onWhenAddingFileFailed(e, t, n);
          }, o.prototype._onAfterAddingFile = function (e) {
            this.onAfterAddingFile(e);
          }, o.prototype._onAfterAddingAll = function (e) {
            this.onAfterAddingAll(e);
          }, o.prototype._onBeforeUploadItem = function (e) {
            e._onBeforeUpload(), this.onBeforeUploadItem(e);
          }, o.prototype._onProgressItem = function (e, t) {
            var n = this._getTotalProgress(t);
            this.progress = n, e._onProgress(t), this.onProgressItem(e, t), this.onProgressAll(n), this._render();
          }, o.prototype._onSuccessItem = function (e, t, n, o) {
            e._onSuccess(t, n, o), this.onSuccessItem(e, t, n, o);
          }, o.prototype._onErrorItem = function (e, t, n, o) {
            e._onError(t, n, o), this.onErrorItem(e, t, n, o);
          }, o.prototype._onCancelItem = function (e, t, n, o) {
            e._onCancel(t, n, o), this.onCancelItem(e, t, n, o);
          }, o.prototype._onCompleteItem = function (e, t, n, o) {
            e._onComplete(t, n, o), this.onCompleteItem(e, t, n, o);
            var r = this.getReadyItems()[0];
            return this.isUploading = !1, y(r) ? void r.upload() : (this.onCompleteAll(), this.progress = this._getTotalProgress(), void this._render());
          }, o.isFile = function (e) {
            return b && e instanceof b;
          }, o.isFileLikeObject = function (e) {
            return e instanceof a;
          }, o.isArrayLikeObject = function (e) {
            return d(e) && "length" in e;
          }, o.inherit = function (e, t) {
            e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.super_ = t;
          }, o;
        }();
      return O.prototype.isHTML5 = !(!b || !F), O.isHTML5 = O.prototype.isHTML5, O;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = function () {
      function e(e, t) {
        var n = [],
          o = !0,
          r = !1,
          i = void 0;
        try {
          for (var s, a = e[Symbol.iterator](); !(o = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); o = !0);
        } catch (u) {
          r = !0, i = u;
        } finally {
          try {
            !o && a["return"] && a["return"]();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }
      return function (t, n) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }();
    t["default"] = i;
    var a = n(1),
      u = (o(a), angular),
      l = u.bind,
      p = u.copy,
      c = u.extend,
      f = u.forEach,
      d = u.isObject,
      h = u.isNumber,
      y = u.isDefined,
      v = u.isArray,
      m = u.isUndefined,
      _ = u.element;
    i.$inject = ["fileUploaderOptions", "$rootScope", "$http", "$window", "$timeout", "FileLikeObject", "FileItem", "Pipeline"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i() {
      return function () {
        function e(t) {
          r(this, e);
          var n = l(t),
            o = n ? t.value : t,
            i = p(o) ? "FakePath" : "Object",
            s = "_createFrom" + i;
          this[s](o);
        }
        return e.prototype._createFromFakePath = function (e) {
          this.lastModifiedDate = null, this.size = null, this.type = "like/" + e.slice(e.lastIndexOf(".") + 1).toLowerCase(), this.name = e.slice(e.lastIndexOf("/") + e.lastIndexOf("\\") + 2);
        }, e.prototype._createFromObject = function (e) {
          this.lastModifiedDate = u(e.lastModifiedDate), this.size = e.size, this.type = e.type, this.name = e.name;
        }, e;
      }();
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = i;
    var s = n(1),
      a = (o(s), angular),
      u = a.copy,
      l = a.isElement,
      p = a.isString;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      return function () {
        function n(e, o, i) {
          r(this, n);
          var s = c(o),
            a = s ? p(o) : null,
            f = s ? null : o;
          l(this, {
            url: e.url,
            alias: e.alias,
            headers: u(e.headers),
            formData: u(e.formData),
            removeAfterUpload: e.removeAfterUpload,
            withCredentials: e.withCredentials,
            disableMultipart: e.disableMultipart,
            method: e.method
          }, i, {
            uploader: e,
            file: new t(o),
            isReady: !1,
            isUploading: !1,
            isUploaded: !1,
            isSuccess: !1,
            isCancel: !1,
            isError: !1,
            progress: 0,
            index: null,
            _file: f,
            _input: a
          }), a && this._replaceNode(a);
        }
        return n.prototype.upload = function () {
          try {
            this.uploader.uploadItem(this);
          } catch (e) {
            var t = e.name + ":" + e.message;
            this.uploader._onCompleteItem(this, t, e.code, []), this.uploader._onErrorItem(this, t, e.code, []);
          }
        }, n.prototype.cancel = function () {
          this.uploader.cancelItem(this);
        }, n.prototype.remove = function () {
          this.uploader.removeFromQueue(this);
        }, n.prototype.onBeforeUpload = function () {}, n.prototype.onProgress = function (e) {}, n.prototype.onSuccess = function (e, t, n) {}, n.prototype.onError = function (e, t, n) {}, n.prototype.onCancel = function (e, t, n) {}, n.prototype.onComplete = function (e, t, n) {}, n.prototype._onBeforeUpload = function () {
          this.isReady = !0, this.isUploading = !1, this.isUploaded = !1, this.isSuccess = !1, this.isCancel = !1, this.isError = !1, this.progress = 0, this.onBeforeUpload();
        }, n.prototype._onProgress = function (e) {
          this.progress = e, this.onProgress(e);
        }, n.prototype._onSuccess = function (e, t, n) {
          this.isReady = !1, this.isUploading = !1, this.isUploaded = !0, this.isSuccess = !0, this.isCancel = !1, this.isError = !1, this.progress = 100, this.index = null, this.onSuccess(e, t, n);
        }, n.prototype._onError = function (e, t, n) {
          this.isReady = !1, this.isUploading = !1, this.isUploaded = !0, this.isSuccess = !1, this.isCancel = !1, this.isError = !0, this.progress = 0, this.index = null, this.onError(e, t, n);
        }, n.prototype._onCancel = function (e, t, n) {
          this.isReady = !1, this.isUploading = !1, this.isUploaded = !1, this.isSuccess = !1, this.isCancel = !0, this.isError = !1, this.progress = 0, this.index = null, this.onCancel(e, t, n);
        }, n.prototype._onComplete = function (e, t, n) {
          this.onComplete(e, t, n), this.removeAfterUpload && this.remove();
        }, n.prototype._destroy = function () {
          this._input && this._input.remove(), this._form && this._form.remove(), delete this._form, delete this._input;
        }, n.prototype._prepareToUploading = function () {
          this.index = this.index || ++this.uploader._nextIndex, this.isReady = !0;
        }, n.prototype._replaceNode = function (t) {
          var n = e(t.clone())(t.scope());
          n.prop("value", null), t.css("display", "none"), t.after(n);
        }, n;
      }();
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = i;
    var s = n(1),
      a = (o(s), angular),
      u = a.copy,
      l = a.extend,
      p = a.element,
      c = a.isElement;
    i.$inject = ["$compile", "FileLikeObject"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i() {
      var e = function () {
        function e(t) {
          r(this, e), u(this, t), this.uploader._directives[this.prop].push(this), this._saveLinks(), this.bind();
        }
        return e.prototype.bind = function () {
          for (var e in this.events) {
            var t = this.events[e];
            this.element.bind(e, this[t]);
          }
        }, e.prototype.unbind = function () {
          for (var e in this.events) this.element.unbind(e, this.events[e]);
        }, e.prototype.destroy = function () {
          var e = this.uploader._directives[this.prop].indexOf(this);
          this.uploader._directives[this.prop].splice(e, 1), this.unbind();
        }, e.prototype._saveLinks = function () {
          for (var e in this.events) {
            var t = this.events[e];
            this[t] = this[t].bind(this);
          }
        }, e;
      }();
      return e.prototype.events = {}, e;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = i;
    var s = n(1),
      a = (o(s), angular),
      u = a.extend;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function a(e, t) {
      return function (t) {
        function n(e) {
          r(this, n);
          var o = p(e, {
              events: {
                $destroy: "destroy",
                change: "onChange"
              },
              prop: "select"
            }),
            s = i(this, t.call(this, o));
          return s.uploader.isHTML5 || s.element.removeAttr("multiple"), s.element.prop("value", null), s;
        }
        return s(n, t), n.prototype.getOptions = function () {}, n.prototype.getFilters = function () {}, n.prototype.isEmptyAfterSelection = function () {
          return !!this.element.attr("multiple");
        }, n.prototype.onChange = function () {
          var t = this.uploader.isHTML5 ? this.element[0].files : this.element[0],
            n = this.getOptions(),
            o = this.getFilters();
          this.uploader.isHTML5 || this.destroy(), this.uploader.addToQueue(t, n, o), this.isEmptyAfterSelection() && (this.element.prop("value", null), this.element.replaceWith(e(this.element.clone())(this.scope)));
        }, n;
      }(t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = a;
    var u = n(1),
      l = (o(u), angular),
      p = l.extend;
    a.$inject = ["$compile", "FileDirective"];
  }, function (e, t) {
    "use strict";

    function n(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function r(e) {
      return function () {
        function t() {
          var e = arguments.length <= 0 || void 0 === arguments[0] ? [] : arguments[0];
          o(this, t), this.pipes = e;
        }
        return t.prototype.next = function (t) {
          var o = this.pipes.shift();
          if (a(o)) return void this.onSuccessful.apply(this, n(t));
          var r = new Error("The filter has not passed");
          if (r.pipe = o, r.args = t, o.isAsync) {
            var i = e.defer(),
              u = s(this, this.next, t),
              l = s(this, this.onThrown, r);
            i.promise.then(u, l), o.apply(void 0, n(t).concat([i]));
          } else {
            var p = Boolean(o.apply(void 0, n(t)));
            p ? this.next(t) : this.onThrown(r);
          }
        }, t.prototype.exec = function () {
          for (var e = arguments.length, t = Array(e), n = 0; e > n; n++) t[n] = arguments[n];
          this.next(t);
        }, t.prototype.onThrown = function (e) {}, t.prototype.onSuccessful = function () {}, t;
      }();
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = r;
    var i = angular,
      s = i.bind,
      a = i.isUndefined;
    r.$inject = ["$q"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function a(e) {
      return function (e) {
        function t(n) {
          r(this, t);
          var o = p(n, {
            events: {
              $destroy: "destroy",
              drop: "onDrop",
              dragover: "onDragOver",
              dragleave: "onDragLeave"
            },
            prop: "drop"
          });
          return i(this, e.call(this, o));
        }
        return s(t, e), t.prototype.getOptions = function () {}, t.prototype.getFilters = function () {}, t.prototype.onDrop = function (e) {
          var t = this._getTransfer(e);
          if (t) {
            var n = this.getOptions(),
              o = this.getFilters();
            this._preventAndStop(e), c(this.uploader._directives.over, this._removeOverClass, this), this.uploader.addToQueue(t.files, n, o);
          }
        }, t.prototype.onDragOver = function (e) {
          var t = this._getTransfer(e);
          this._haveFiles(t.types) && (t.dropEffect = "copy", this._preventAndStop(e), c(this.uploader._directives.over, this._addOverClass, this));
        }, t.prototype.onDragLeave = function (e) {
          e.currentTarget !== this.element[0] && (this._preventAndStop(e), c(this.uploader._directives.over, this._removeOverClass, this));
        }, t.prototype._getTransfer = function (e) {
          return e.dataTransfer ? e.dataTransfer : e.originalEvent.dataTransfer;
        }, t.prototype._preventAndStop = function (e) {
          e.preventDefault(), e.stopPropagation();
        }, t.prototype._haveFiles = function (e) {
          return e ? e.indexOf ? -1 !== e.indexOf("Files") : e.contains ? e.contains("Files") : !1 : !1;
        }, t.prototype._addOverClass = function (e) {
          e.addOverClass();
        }, t.prototype._removeOverClass = function (e) {
          e.removeOverClass();
        }, t;
      }(e);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = a;
    var u = n(1),
      l = (o(u), angular),
      p = l.extend,
      c = l.forEach;
    a.$inject = ["FileDirective"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    function a(e) {
      return function (e) {
        function t(n) {
          r(this, t);
          var o = p(n, {
            events: {
              $destroy: "destroy"
            },
            prop: "over",
            overClass: "nv-file-over"
          });
          return i(this, e.call(this, o));
        }
        return s(t, e), t.prototype.addOverClass = function () {
          this.element.addClass(this.getOverClass());
        }, t.prototype.removeOverClass = function () {
          this.element.removeClass(this.getOverClass());
        }, t.prototype.getOverClass = function () {
          return this.overClass;
        }, t;
      }(e);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = a;
    var u = n(1),
      l = (o(u), angular),
      p = l.extend;
    a.$inject = ["FileDirective"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t, n) {
      return {
        link: function (o, r, i) {
          var s = o.$eval(i.uploader);
          if (!(s instanceof t)) throw new TypeError('"Uploader" must be an instance of FileUploader');
          var a = new n({
            uploader: s,
            element: r,
            scope: o
          });
          a.getOptions = e(i.options).bind(a, o), a.getFilters = function () {
            return i.filters;
          };
        }
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = r;
    var i = n(1);
    o(i);
    r.$inject = ["$parse", "FileUploader", "FileSelect"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t, n) {
      return {
        link: function (o, r, i) {
          var s = o.$eval(i.uploader);
          if (!(s instanceof t)) throw new TypeError('"Uploader" must be an instance of FileUploader');
          if (s.isHTML5) {
            var a = new n({
              uploader: s,
              element: r
            });
            a.getOptions = e(i.options).bind(a, o), a.getFilters = function () {
              return i.filters;
            };
          }
        }
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = r;
    var i = n(1);
    o(i);
    r.$inject = ["$parse", "FileUploader", "FileDrop"];
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    function r(e, t) {
      return {
        link: function (n, o, r) {
          var i = n.$eval(r.uploader);
          if (!(i instanceof e)) throw new TypeError('"Uploader" must be an instance of FileUploader');
          var s = new t({
            uploader: i,
            element: o
          });
          s.getOverClass = function () {
            return r.overClass || s.overClass;
          };
        }
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = r;
    var i = n(1);
    o(i);
    r.$inject = ["FileUploader", "FileOver"];
  }]);
});
/**
 * @license AngularJS v1.4.14
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular, undefined) {
  'use strict';

  /**
   * @ngdoc object
   * @name angular.mock
   * @description
   *
   * Namespace from 'angular-mocks.js' which contains testing related code.
   */
  angular.mock = {};

  /**
   * ! This is a private undocumented service !
   *
   * @name $browser
   *
   * @description
   * This service is a mock implementation of {@link ng.$browser}. It provides fake
   * implementation for commonly used browser apis that are hard to test, e.g. setTimeout, xhr,
   * cookies, etc...
   *
   * The api of this service is the same as that of the real {@link ng.$browser $browser}, except
   * that there are several helper methods available which can be used in tests.
   */
  angular.mock.$BrowserProvider = function () {
    this.$get = function () {
      return new angular.mock.$Browser();
    };
  };
  angular.mock.$Browser = function () {
    var self = this;
    this.isMock = true;
    self.$$url = "http://server/";
    self.$$lastUrl = self.$$url; // used by url polling fn
    self.pollFns = [];

    // TODO(vojta): remove this temporary api
    self.$$completeOutstandingRequest = angular.noop;
    self.$$incOutstandingRequestCount = angular.noop;

    // register url polling fn

    self.onUrlChange = function (listener) {
      self.pollFns.push(function () {
        if (self.$$lastUrl !== self.$$url || self.$$state !== self.$$lastState) {
          self.$$lastUrl = self.$$url;
          self.$$lastState = self.$$state;
          listener(self.$$url, self.$$state);
        }
      });
      return listener;
    };
    self.$$applicationDestroyed = angular.noop;
    self.$$checkUrlChange = angular.noop;
    self.deferredFns = [];
    self.deferredNextId = 0;
    self.defer = function (fn, delay) {
      delay = delay || 0;
      self.deferredFns.push({
        time: self.defer.now + delay,
        fn: fn,
        id: self.deferredNextId
      });
      self.deferredFns.sort(function (a, b) {
        return a.time - b.time;
      });
      return self.deferredNextId++;
    };

    /**
     * @name $browser#defer.now
     *
     * @description
     * Current milliseconds mock time.
     */
    self.defer.now = 0;
    self.defer.cancel = function (deferId) {
      var fnIndex;
      angular.forEach(self.deferredFns, function (fn, index) {
        if (fn.id === deferId) fnIndex = index;
      });
      if (angular.isDefined(fnIndex)) {
        self.deferredFns.splice(fnIndex, 1);
        return true;
      }
      return false;
    };

    /**
     * @name $browser#defer.flush
     *
     * @description
     * Flushes all pending requests and executes the defer callbacks.
     *
     * @param {number=} number of milliseconds to flush. See {@link #defer.now}
     */
    self.defer.flush = function (delay) {
      if (angular.isDefined(delay)) {
        self.defer.now += delay;
      } else {
        if (self.deferredFns.length) {
          self.defer.now = self.deferredFns[self.deferredFns.length - 1].time;
        } else {
          throw new Error('No deferred tasks to be flushed');
        }
      }
      while (self.deferredFns.length && self.deferredFns[0].time <= self.defer.now) {
        self.deferredFns.shift().fn();
      }
    };
    self.$$baseHref = '/';
    self.baseHref = function () {
      return this.$$baseHref;
    };
  };
  angular.mock.$Browser.prototype = {
    /**
      * @name $browser#poll
      *
      * @description
      * run all fns in pollFns
      */
    poll: function poll() {
      angular.forEach(this.pollFns, function (pollFn) {
        pollFn();
      });
    },
    url: function (url, replace, state) {
      if (angular.isUndefined(state)) {
        state = null;
      }
      if (url) {
        this.$$url = url;
        // Native pushState serializes & copies the object; simulate it.
        this.$$state = angular.copy(state);
        return this;
      }
      return this.$$url;
    },
    state: function () {
      return this.$$state;
    },
    notifyWhenNoOutstandingRequests: function (fn) {
      fn();
    }
  };

  /**
   * @ngdoc provider
   * @name $exceptionHandlerProvider
   *
   * @description
   * Configures the mock implementation of {@link ng.$exceptionHandler} to rethrow or to log errors
   * passed to the `$exceptionHandler`.
   */

  /**
   * @ngdoc service
   * @name $exceptionHandler
   *
   * @description
   * Mock implementation of {@link ng.$exceptionHandler} that rethrows or logs errors passed
   * to it. See {@link ngMock.$exceptionHandlerProvider $exceptionHandlerProvider} for configuration
   * information.
   *
   *
   * ```js
   *   describe('$exceptionHandlerProvider', function() {
   *
   *     it('should capture log messages and exceptions', function() {
   *
   *       module(function($exceptionHandlerProvider) {
   *         $exceptionHandlerProvider.mode('log');
   *       });
   *
   *       inject(function($log, $exceptionHandler, $timeout) {
   *         $timeout(function() { $log.log(1); });
   *         $timeout(function() { $log.log(2); throw 'banana peel'; });
   *         $timeout(function() { $log.log(3); });
   *         expect($exceptionHandler.errors).toEqual([]);
   *         expect($log.assertEmpty());
   *         $timeout.flush();
   *         expect($exceptionHandler.errors).toEqual(['banana peel']);
   *         expect($log.log.logs).toEqual([[1], [2], [3]]);
   *       });
   *     });
   *   });
   * ```
   */

  angular.mock.$ExceptionHandlerProvider = function () {
    var handler;

    /**
     * @ngdoc method
     * @name $exceptionHandlerProvider#mode
     *
     * @description
     * Sets the logging mode.
     *
     * @param {string} mode Mode of operation, defaults to `rethrow`.
     *
     *   - `log`: Sometimes it is desirable to test that an error is thrown, for this case the `log`
     *            mode stores an array of errors in `$exceptionHandler.errors`, to allow later
     *            assertion of them. See {@link ngMock.$log#assertEmpty assertEmpty()} and
     *            {@link ngMock.$log#reset reset()}
     *   - `rethrow`: If any errors are passed to the handler in tests, it typically means that there
     *                is a bug in the application or test, so this mock will make these tests fail.
     *                For any implementations that expect exceptions to be thrown, the `rethrow` mode
     *                will also maintain a log of thrown errors.
     */
    this.mode = function (mode) {
      switch (mode) {
        case 'log':
        case 'rethrow':
          var errors = [];
          handler = function (e) {
            if (arguments.length == 1) {
              errors.push(e);
            } else {
              errors.push([].slice.call(arguments, 0));
            }
            if (mode === "rethrow") {
              throw e;
            }
          };
          handler.errors = errors;
          break;
        default:
          throw new Error("Unknown mode '" + mode + "', only 'log'/'rethrow' modes are allowed!");
      }
    };
    this.$get = function () {
      return handler;
    };
    this.mode('rethrow');
  };

  /**
   * @ngdoc service
   * @name $log
   *
   * @description
   * Mock implementation of {@link ng.$log} that gathers all logged messages in arrays
   * (one array per logging level). These arrays are exposed as `logs` property of each of the
   * level-specific log function, e.g. for level `error` the array is exposed as `$log.error.logs`.
   *
   */
  angular.mock.$LogProvider = function () {
    var debug = true;
    function concat(array1, array2, index) {
      return array1.concat(Array.prototype.slice.call(array2, index));
    }
    this.debugEnabled = function (flag) {
      if (angular.isDefined(flag)) {
        debug = flag;
        return this;
      } else {
        return debug;
      }
    };
    this.$get = function () {
      var $log = {
        log: function () {
          $log.log.logs.push(concat([], arguments, 0));
        },
        warn: function () {
          $log.warn.logs.push(concat([], arguments, 0));
        },
        info: function () {
          $log.info.logs.push(concat([], arguments, 0));
        },
        error: function () {
          $log.error.logs.push(concat([], arguments, 0));
        },
        debug: function () {
          if (debug) {
            $log.debug.logs.push(concat([], arguments, 0));
          }
        }
      };

      /**
       * @ngdoc method
       * @name $log#reset
       *
       * @description
       * Reset all of the logging arrays to empty.
       */
      $log.reset = function () {
        /**
         * @ngdoc property
         * @name $log#log.logs
         *
         * @description
         * Array of messages logged using {@link ng.$log#log `log()`}.
         *
         * @example
         * ```js
         * $log.log('Some Log');
         * var first = $log.log.logs.unshift();
         * ```
         */
        $log.log.logs = [];
        /**
         * @ngdoc property
         * @name $log#info.logs
         *
         * @description
         * Array of messages logged using {@link ng.$log#info `info()`}.
         *
         * @example
         * ```js
         * $log.info('Some Info');
         * var first = $log.info.logs.unshift();
         * ```
         */
        $log.info.logs = [];
        /**
         * @ngdoc property
         * @name $log#warn.logs
         *
         * @description
         * Array of messages logged using {@link ng.$log#warn `warn()`}.
         *
         * @example
         * ```js
         * $log.warn('Some Warning');
         * var first = $log.warn.logs.unshift();
         * ```
         */
        $log.warn.logs = [];
        /**
         * @ngdoc property
         * @name $log#error.logs
         *
         * @description
         * Array of messages logged using {@link ng.$log#error `error()`}.
         *
         * @example
         * ```js
         * $log.error('Some Error');
         * var first = $log.error.logs.unshift();
         * ```
         */
        $log.error.logs = [];
        /**
        * @ngdoc property
        * @name $log#debug.logs
        *
        * @description
        * Array of messages logged using {@link ng.$log#debug `debug()`}.
        *
        * @example
        * ```js
        * $log.debug('Some Error');
        * var first = $log.debug.logs.unshift();
        * ```
        */
        $log.debug.logs = [];
      };

      /**
       * @ngdoc method
       * @name $log#assertEmpty
       *
       * @description
       * Assert that all of the logging methods have no logged messages. If any messages are present,
       * an exception is thrown.
       */
      $log.assertEmpty = function () {
        var errors = [];
        angular.forEach(['error', 'warn', 'info', 'log', 'debug'], function (logLevel) {
          angular.forEach($log[logLevel].logs, function (log) {
            angular.forEach(log, function (logItem) {
              errors.push('MOCK $log (' + logLevel + '): ' + String(logItem) + '\n' + (logItem.stack || ''));
            });
          });
        });
        if (errors.length) {
          errors.unshift("Expected $log to be empty! Either a message was logged unexpectedly, or " + "an expected log message was not checked and removed:");
          errors.push('');
          throw new Error(errors.join('\n---------\n'));
        }
      };
      $log.reset();
      return $log;
    };
  };

  /**
   * @ngdoc service
   * @name $interval
   *
   * @description
   * Mock implementation of the $interval service.
   *
   * Use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
   * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
   * time.
   *
   * @param {function()} fn A function that should be called repeatedly.
   * @param {number} delay Number of milliseconds between each function call.
   * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
   *   indefinitely.
   * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
   *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
   * @param {...*=} Pass additional parameters to the executed function.
   * @returns {promise} A promise which will be notified on each iteration.
   */
  angular.mock.$IntervalProvider = function () {
    this.$get = ['$browser', '$rootScope', '$q', '$$q', function ($browser, $rootScope, $q, $$q) {
      var repeatFns = [],
        nextRepeatId = 0,
        now = 0;
      var $interval = function (fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
          args = hasParams ? Array.prototype.slice.call(arguments, 4) : [],
          iteration = 0,
          skipApply = angular.isDefined(invokeApply) && !invokeApply,
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;
        count = angular.isDefined(count) ? count : 0;
        promise.then(null, null, !hasParams ? fn : function () {
          fn.apply(null, args);
        });
        promise.$$intervalId = nextRepeatId;
        function tick() {
          deferred.notify(iteration++);
          if (count > 0 && iteration >= count) {
            var fnIndex;
            deferred.resolve(iteration);
            angular.forEach(repeatFns, function (fn, index) {
              if (fn.id === promise.$$intervalId) fnIndex = index;
            });
            if (angular.isDefined(fnIndex)) {
              repeatFns.splice(fnIndex, 1);
            }
          }
          if (skipApply) {
            $browser.defer.flush();
          } else {
            $rootScope.$apply();
          }
        }
        repeatFns.push({
          nextTime: now + delay,
          delay: delay,
          fn: tick,
          id: nextRepeatId,
          deferred: deferred
        });
        repeatFns.sort(function (a, b) {
          return a.nextTime - b.nextTime;
        });
        nextRepeatId++;
        return promise;
      };
      /**
       * @ngdoc method
       * @name $interval#cancel
       *
       * @description
       * Cancels a task associated with the `promise`.
       *
       * @param {promise} promise A promise from calling the `$interval` function.
       * @returns {boolean} Returns `true` if the task was successfully cancelled.
       */
      $interval.cancel = function (promise) {
        if (!promise) return false;
        var fnIndex;
        angular.forEach(repeatFns, function (fn, index) {
          if (fn.id === promise.$$intervalId) fnIndex = index;
        });
        if (angular.isDefined(fnIndex)) {
          repeatFns[fnIndex].deferred.reject('canceled');
          repeatFns.splice(fnIndex, 1);
          return true;
        }
        return false;
      };

      /**
       * @ngdoc method
       * @name $interval#flush
       * @description
       *
       * Runs interval tasks scheduled to be run in the next `millis` milliseconds.
       *
       * @param {number=} millis maximum timeout amount to flush up until.
       *
       * @return {number} The amount of time moved forward.
       */
      $interval.flush = function (millis) {
        now += millis;
        while (repeatFns.length && repeatFns[0].nextTime <= now) {
          var task = repeatFns[0];
          task.fn();
          task.nextTime += task.delay;
          repeatFns.sort(function (a, b) {
            return a.nextTime - b.nextTime;
          });
        }
        return millis;
      };
      return $interval;
    }];
  };

  /* jshint -W101 */
  /* The R_ISO8061_STR regex is never going to fit into the 100 char limit!
   * This directive should go inside the anonymous function but a bug in JSHint means that it would
   * not be enacted early enough to prevent the warning.
   */
  var R_ISO8061_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?:\:?(\d\d)(?:\:?(\d\d)(?:\.(\d{3}))?)?)?(Z|([+-])(\d\d):?(\d\d)))?$/;
  function jsonStringToDate(string) {
    var match;
    if (match = string.match(R_ISO8061_STR)) {
      var date = new Date(0),
        tzHour = 0,
        tzMin = 0;
      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      date.setUTCFullYear(toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      date.setUTCHours(toInt(match[4] || 0) - tzHour, toInt(match[5] || 0) - tzMin, toInt(match[6] || 0), toInt(match[7] || 0));
      return date;
    }
    return string;
  }
  function toInt(str) {
    return parseInt(str, 10);
  }
  function padNumber(num, digits, trim) {
    var neg = '';
    if (num < 0) {
      neg = '-';
      num = -num;
    }
    num = '' + num;
    while (num.length < digits) num = '0' + num;
    if (trim) {
      num = num.substr(num.length - digits);
    }
    return neg + num;
  }

  /**
   * @ngdoc type
   * @name angular.mock.TzDate
   * @description
   *
   * *NOTE*: this is not an injectable instance, just a globally available mock class of `Date`.
   *
   * Mock of the Date type which has its timezone specified via constructor arg.
   *
   * The main purpose is to create Date-like instances with timezone fixed to the specified timezone
   * offset, so that we can test code that depends on local timezone settings without dependency on
   * the time zone settings of the machine where the code is running.
   *
   * @param {number} offset Offset of the *desired* timezone in hours (fractions will be honored)
   * @param {(number|string)} timestamp Timestamp representing the desired time in *UTC*
   *
   * @example
   * !!!! WARNING !!!!!
   * This is not a complete Date object so only methods that were implemented can be called safely.
   * To make matters worse, TzDate instances inherit stuff from Date via a prototype.
   *
   * We do our best to intercept calls to "unimplemented" methods, but since the list of methods is
   * incomplete we might be missing some non-standard methods. This can result in errors like:
   * "Date.prototype.foo called on incompatible Object".
   *
   * ```js
   * var newYearInBratislava = new TzDate(-1, '2009-12-31T23:00:00Z');
   * newYearInBratislava.getTimezoneOffset() => -60;
   * newYearInBratislava.getFullYear() => 2010;
   * newYearInBratislava.getMonth() => 0;
   * newYearInBratislava.getDate() => 1;
   * newYearInBratislava.getHours() => 0;
   * newYearInBratislava.getMinutes() => 0;
   * newYearInBratislava.getSeconds() => 0;
   * ```
   *
   */
  angular.mock.TzDate = function (offset, timestamp) {
    var self = new Date(0);
    if (angular.isString(timestamp)) {
      var tsStr = timestamp;
      self.origDate = jsonStringToDate(timestamp);
      timestamp = self.origDate.getTime();
      if (isNaN(timestamp)) {
        throw {
          name: "Illegal Argument",
          message: "Arg '" + tsStr + "' passed into TzDate constructor is not a valid date string"
        };
      }
    } else {
      self.origDate = new Date(timestamp);
    }
    var localOffset = new Date(timestamp).getTimezoneOffset();
    self.offsetDiff = localOffset * 60 * 1000 - offset * 1000 * 60 * 60;
    self.date = new Date(timestamp + self.offsetDiff);
    self.getTime = function () {
      return self.date.getTime() - self.offsetDiff;
    };
    self.toLocaleDateString = function () {
      return self.date.toLocaleDateString();
    };
    self.getFullYear = function () {
      return self.date.getFullYear();
    };
    self.getMonth = function () {
      return self.date.getMonth();
    };
    self.getDate = function () {
      return self.date.getDate();
    };
    self.getHours = function () {
      return self.date.getHours();
    };
    self.getMinutes = function () {
      return self.date.getMinutes();
    };
    self.getSeconds = function () {
      return self.date.getSeconds();
    };
    self.getMilliseconds = function () {
      return self.date.getMilliseconds();
    };
    self.getTimezoneOffset = function () {
      return offset * 60;
    };
    self.getUTCFullYear = function () {
      return self.origDate.getUTCFullYear();
    };
    self.getUTCMonth = function () {
      return self.origDate.getUTCMonth();
    };
    self.getUTCDate = function () {
      return self.origDate.getUTCDate();
    };
    self.getUTCHours = function () {
      return self.origDate.getUTCHours();
    };
    self.getUTCMinutes = function () {
      return self.origDate.getUTCMinutes();
    };
    self.getUTCSeconds = function () {
      return self.origDate.getUTCSeconds();
    };
    self.getUTCMilliseconds = function () {
      return self.origDate.getUTCMilliseconds();
    };
    self.getDay = function () {
      return self.date.getDay();
    };

    // provide this method only on browsers that already have it
    if (self.toISOString) {
      self.toISOString = function () {
        return padNumber(self.origDate.getUTCFullYear(), 4) + '-' + padNumber(self.origDate.getUTCMonth() + 1, 2) + '-' + padNumber(self.origDate.getUTCDate(), 2) + 'T' + padNumber(self.origDate.getUTCHours(), 2) + ':' + padNumber(self.origDate.getUTCMinutes(), 2) + ':' + padNumber(self.origDate.getUTCSeconds(), 2) + '.' + padNumber(self.origDate.getUTCMilliseconds(), 3) + 'Z';
      };
    }

    //hide all methods not implemented in this mock that the Date prototype exposes
    var unimplementedMethods = ['getUTCDay', 'getYear', 'setDate', 'setFullYear', 'setHours', 'setMilliseconds', 'setMinutes', 'setMonth', 'setSeconds', 'setTime', 'setUTCDate', 'setUTCFullYear', 'setUTCHours', 'setUTCMilliseconds', 'setUTCMinutes', 'setUTCMonth', 'setUTCSeconds', 'setYear', 'toDateString', 'toGMTString', 'toJSON', 'toLocaleFormat', 'toLocaleString', 'toLocaleTimeString', 'toSource', 'toString', 'toTimeString', 'toUTCString', 'valueOf'];
    angular.forEach(unimplementedMethods, function (methodName) {
      self[methodName] = function () {
        throw new Error("Method '" + methodName + "' is not implemented in the TzDate mock");
      };
    });
    return self;
  };

  //make "tzDateInstance instanceof Date" return true
  angular.mock.TzDate.prototype = Date.prototype;
  /* jshint +W101 */

  /**
   * @ngdoc service
   * @name $animate
   *
   * @description
   * Mock implementation of the {@link ng.$animate `$animate`} service. Exposes two additional methods
   * for testing animations.
   */
  angular.mock.animate = angular.module('ngAnimateMock', ['ng']).config(['$provide', function ($provide) {
    $provide.factory('$$forceReflow', function () {
      function reflowFn() {
        reflowFn.totalReflows++;
      }
      reflowFn.totalReflows = 0;
      return reflowFn;
    });
    $provide.factory('$$animateAsyncRun', function () {
      var queue = [];
      var queueFn = function () {
        return function (fn) {
          queue.push(fn);
        };
      };
      queueFn.flush = function () {
        if (queue.length === 0) return false;
        for (var i = 0; i < queue.length; i++) {
          queue[i]();
        }
        queue = [];
        return true;
      };
      return queueFn;
    });
    $provide.decorator('$$animateJs', ['$delegate', function ($delegate) {
      var runners = [];
      var animateJsConstructor = function () {
        var animator = $delegate.apply($delegate, arguments);
        // If no javascript animation is found, animator is undefined
        if (animator) {
          runners.push(animator);
        }
        return animator;
      };
      animateJsConstructor.$closeAndFlush = function () {
        runners.forEach(function (runner) {
          runner.end();
        });
        runners = [];
      };
      return animateJsConstructor;
    }]);
    $provide.decorator('$animateCss', ['$delegate', function ($delegate) {
      var runners = [];
      var animateCssConstructor = function (element, options) {
        var animator = $delegate(element, options);
        runners.push(animator);
        return animator;
      };
      animateCssConstructor.$closeAndFlush = function () {
        runners.forEach(function (runner) {
          runner.end();
        });
        runners = [];
      };
      return animateCssConstructor;
    }]);
    $provide.decorator('$animate', ['$delegate', '$timeout', '$browser', '$$rAF', '$animateCss', '$$animateJs', '$$forceReflow', '$$animateAsyncRun', '$rootScope', function ($delegate, $timeout, $browser, $$rAF, $animateCss, $$animateJs, $$forceReflow, $$animateAsyncRun, $rootScope) {
      var animate = {
        queue: [],
        cancel: $delegate.cancel,
        on: $delegate.on,
        off: $delegate.off,
        pin: $delegate.pin,
        get reflows() {
          return $$forceReflow.totalReflows;
        },
        enabled: $delegate.enabled,
        /**
         * @ngdoc method
         * @name $animate#closeAndFlush
         * @description
         *
         * This method will close all pending animations (both {@link ngAnimate#javascript-based-animations Javascript}
         * and {@link ngAnimate.$animateCss CSS}) and it will also flush any remaining animation frames and/or callbacks.
         */
        closeAndFlush: function () {
          // we allow the flush command to swallow the errors
          // because depending on whether CSS or JS animations are
          // used, there may not be a RAF flush. The primary flush
          // at the end of this function must throw an exception
          // because it will track if there were pending animations
          this.flush(true);
          $animateCss.$closeAndFlush();
          $$animateJs.$closeAndFlush();
          this.flush();
        },
        /**
         * @ngdoc method
         * @name $animate#flush
         * @description
         *
         * This method is used to flush the pending callbacks and animation frames to either start
         * an animation or conclude an animation. Note that this will not actually close an
         * actively running animation (see {@link ngMock.$animate#closeAndFlush `closeAndFlush()`} for that).
         */
        flush: function (hideErrors) {
          $rootScope.$digest();
          var doNextRun,
            somethingFlushed = false;
          do {
            doNextRun = false;
            if ($$rAF.queue.length) {
              $$rAF.flush();
              doNextRun = somethingFlushed = true;
            }
            if ($$animateAsyncRun.flush()) {
              doNextRun = somethingFlushed = true;
            }
          } while (doNextRun);
          if (!somethingFlushed && !hideErrors) {
            throw new Error('No pending animations ready to be closed or flushed');
          }
          $rootScope.$digest();
        }
      };
      angular.forEach(['animate', 'enter', 'leave', 'move', 'addClass', 'removeClass', 'setClass'], function (method) {
        animate[method] = function () {
          animate.queue.push({
            event: method,
            element: arguments[0],
            options: arguments[arguments.length - 1],
            args: arguments
          });
          return $delegate[method].apply($delegate, arguments);
        };
      });
      return animate;
    }]);
  }]);

  /**
   * @ngdoc function
   * @name angular.mock.dump
   * @description
   *
   * *NOTE*: this is not an injectable instance, just a globally available function.
   *
   * Method for serializing common angular objects (scope, elements, etc..) into strings, useful for
   * debugging.
   *
   * This method is also available on window, where it can be used to display objects on debug
   * console.
   *
   * @param {*} object - any object to turn into string.
   * @return {string} a serialized string of the argument
   */
  angular.mock.dump = function (object) {
    return serialize(object);
    function serialize(object) {
      var out;
      if (angular.isElement(object)) {
        object = angular.element(object);
        out = angular.element('<div></div>');
        angular.forEach(object, function (element) {
          out.append(angular.element(element).clone());
        });
        out = out.html();
      } else if (angular.isArray(object)) {
        out = [];
        angular.forEach(object, function (o) {
          out.push(serialize(o));
        });
        out = '[ ' + out.join(', ') + ' ]';
      } else if (angular.isObject(object)) {
        if (angular.isFunction(object.$eval) && angular.isFunction(object.$apply)) {
          out = serializeScope(object);
        } else if (object instanceof Error) {
          out = object.stack || '' + object.name + ': ' + object.message;
        } else {
          // TODO(i): this prevents methods being logged,
          // we should have a better way to serialize objects
          out = angular.toJson(object, true);
        }
      } else {
        out = String(object);
      }
      return out;
    }
    function serializeScope(scope, offset) {
      offset = offset || '  ';
      var log = [offset + 'Scope(' + scope.$id + '): {'];
      for (var key in scope) {
        if (Object.prototype.hasOwnProperty.call(scope, key) && !key.match(/^(\$|this)/)) {
          log.push('  ' + key + ': ' + angular.toJson(scope[key]));
        }
      }
      var child = scope.$$childHead;
      while (child) {
        log.push(serializeScope(child, offset + '  '));
        child = child.$$nextSibling;
      }
      log.push('}');
      return log.join('\n' + offset);
    }
  };

  /**
   * @ngdoc service
   * @name $httpBackend
   * @description
   * Fake HTTP backend implementation suitable for unit testing applications that use the
   * {@link ng.$http $http service}.
   *
   * *Note*: For fake HTTP backend implementation suitable for end-to-end testing or backend-less
   * development please see {@link ngMockE2E.$httpBackend e2e $httpBackend mock}.
   *
   * During unit testing, we want our unit tests to run quickly and have no external dependencies so
   * we don’t want to send [XHR](https://developer.mozilla.org/en/xmlhttprequest) or
   * [JSONP](http://en.wikipedia.org/wiki/JSONP) requests to a real server. All we really need is
   * to verify whether a certain request has been sent or not, or alternatively just let the
   * application make requests, respond with pre-trained responses and assert that the end result is
   * what we expect it to be.
   *
   * This mock implementation can be used to respond with static or dynamic responses via the
   * `expect` and `when` apis and their shortcuts (`expectGET`, `whenPOST`, etc).
   *
   * When an Angular application needs some data from a server, it calls the $http service, which
   * sends the request to a real server using $httpBackend service. With dependency injection, it is
   * easy to inject $httpBackend mock (which has the same API as $httpBackend) and use it to verify
   * the requests and respond with some testing data without sending a request to a real server.
   *
   * There are two ways to specify what test data should be returned as http responses by the mock
   * backend when the code under test makes http requests:
   *
   * - `$httpBackend.expect` - specifies a request expectation
   * - `$httpBackend.when` - specifies a backend definition
   *
   *
   * # Request Expectations vs Backend Definitions
   *
   * Request expectations provide a way to make assertions about requests made by the application and
   * to define responses for those requests. The test will fail if the expected requests are not made
   * or they are made in the wrong order.
   *
   * Backend definitions allow you to define a fake backend for your application which doesn't assert
   * if a particular request was made or not, it just returns a trained response if a request is made.
   * The test will pass whether or not the request gets made during testing.
   *
   *
   * <table class="table">
   *   <tr><th width="220px"></th><th>Request expectations</th><th>Backend definitions</th></tr>
   *   <tr>
   *     <th>Syntax</th>
   *     <td>.expect(...).respond(...)</td>
   *     <td>.when(...).respond(...)</td>
   *   </tr>
   *   <tr>
   *     <th>Typical usage</th>
   *     <td>strict unit tests</td>
   *     <td>loose (black-box) unit testing</td>
   *   </tr>
   *   <tr>
   *     <th>Fulfills multiple requests</th>
   *     <td>NO</td>
   *     <td>YES</td>
   *   </tr>
   *   <tr>
   *     <th>Order of requests matters</th>
   *     <td>YES</td>
   *     <td>NO</td>
   *   </tr>
   *   <tr>
   *     <th>Request required</th>
   *     <td>YES</td>
   *     <td>NO</td>
   *   </tr>
   *   <tr>
   *     <th>Response required</th>
   *     <td>optional (see below)</td>
   *     <td>YES</td>
   *   </tr>
   * </table>
   *
   * In cases where both backend definitions and request expectations are specified during unit
   * testing, the request expectations are evaluated first.
   *
   * If a request expectation has no response specified, the algorithm will search your backend
   * definitions for an appropriate response.
   *
   * If a request didn't match any expectation or if the expectation doesn't have the response
   * defined, the backend definitions are evaluated in sequential order to see if any of them match
   * the request. The response from the first matched definition is returned.
   *
   *
   * # Flushing HTTP requests
   *
   * The $httpBackend used in production always responds to requests asynchronously. If we preserved
   * this behavior in unit testing, we'd have to create async unit tests, which are hard to write,
   * to follow and to maintain. But neither can the testing mock respond synchronously; that would
   * change the execution of the code under test. For this reason, the mock $httpBackend has a
   * `flush()` method, which allows the test to explicitly flush pending requests. This preserves
   * the async api of the backend, while allowing the test to execute synchronously.
   *
   *
   * # Unit testing with mock $httpBackend
   * The following code shows how to setup and use the mock backend when unit testing a controller.
   * First we create the controller under test:
   *
    ```js
    // The module code
    angular
      .module('MyApp', [])
      .controller('MyController', MyController);
  
    // The controller code
    function MyController($scope, $http) {
      var authToken;
  
      $http.get('/auth.py').success(function(data, status, headers) {
        authToken = headers('A-Token');
        $scope.user = data;
      });
  
      $scope.saveMessage = function(message) {
        var headers = { 'Authorization': authToken };
        $scope.status = 'Saving...';
  
        $http.post('/add-msg.py', message, { headers: headers } ).success(function(response) {
          $scope.status = '';
        }).error(function() {
          $scope.status = 'Failed...';
        });
      };
    }
    ```
   *
   * Now we setup the mock backend and create the test specs:
   *
    ```js
      // testing controller
      describe('MyController', function() {
         var $httpBackend, $rootScope, createController, authRequestHandler;
  
         // Set up the module
         beforeEach(module('MyApp'));
  
         beforeEach(inject(function($injector) {
           // Set up the mock http service responses
           $httpBackend = $injector.get('$httpBackend');
           // backend definition common for all tests
           authRequestHandler = $httpBackend.when('GET', '/auth.py')
                                  .respond({userId: 'userX'}, {'A-Token': 'xxx'});
  
           // Get hold of a scope (i.e. the root scope)
           $rootScope = $injector.get('$rootScope');
           // The $controller service is used to create instances of controllers
           var $controller = $injector.get('$controller');
  
           createController = function() {
             return $controller('MyController', {'$scope' : $rootScope });
           };
         }));
  
  
         afterEach(function() {
           $httpBackend.verifyNoOutstandingExpectation();
           $httpBackend.verifyNoOutstandingRequest();
         });
  
  
         it('should fetch authentication token', function() {
           $httpBackend.expectGET('/auth.py');
           var controller = createController();
           $httpBackend.flush();
         });
  
  
         it('should fail authentication', function() {
  
           // Notice how you can change the response even after it was set
           authRequestHandler.respond(401, '');
  
           $httpBackend.expectGET('/auth.py');
           var controller = createController();
           $httpBackend.flush();
           expect($rootScope.status).toBe('Failed...');
         });
  
  
         it('should send msg to server', function() {
           var controller = createController();
           $httpBackend.flush();
  
           // now you don’t care about the authentication, but
           // the controller will still send the request and
           // $httpBackend will respond without you having to
           // specify the expectation and response for this request
  
           $httpBackend.expectPOST('/add-msg.py', 'message content').respond(201, '');
           $rootScope.saveMessage('message content');
           expect($rootScope.status).toBe('Saving...');
           $httpBackend.flush();
           expect($rootScope.status).toBe('');
         });
  
  
         it('should send auth header', function() {
           var controller = createController();
           $httpBackend.flush();
  
           $httpBackend.expectPOST('/add-msg.py', undefined, function(headers) {
             // check if the header was sent, if it wasn't the expectation won't
             // match the request and the test will fail
             return headers['Authorization'] == 'xxx';
           }).respond(201, '');
  
           $rootScope.saveMessage('whatever');
           $httpBackend.flush();
         });
      });
     ```
   */
  angular.mock.$HttpBackendProvider = function () {
    this.$get = ['$rootScope', '$timeout', createHttpBackendMock];
  };

  /**
   * General factory function for $httpBackend mock.
   * Returns instance for unit testing (when no arguments specified):
   *   - passing through is disabled
   *   - auto flushing is disabled
   *
   * Returns instance for e2e testing (when `$delegate` and `$browser` specified):
   *   - passing through (delegating request to real backend) is enabled
   *   - auto flushing is enabled
   *
   * @param {Object=} $delegate Real $httpBackend instance (allow passing through if specified)
   * @param {Object=} $browser Auto-flushing enabled if specified
   * @return {Object} Instance of $httpBackend mock
   */
  function createHttpBackendMock($rootScope, $timeout, $delegate, $browser) {
    var definitions = [],
      expectations = [],
      responses = [],
      responsesPush = angular.bind(responses, responses.push),
      copy = angular.copy;
    function createResponse(status, data, headers, statusText) {
      if (angular.isFunction(status)) return status;
      return function () {
        return angular.isNumber(status) ? [status, data, headers, statusText] : [200, status, data, headers];
      };
    }

    // TODO(vojta): change params to: method, url, data, headers, callback
    function $httpBackend(method, url, data, callback, headers, timeout, withCredentials, responseType) {
      var xhr = new MockXhr(),
        expectation = expectations[0],
        wasExpected = false;
      function prettyPrint(data) {
        return angular.isString(data) || angular.isFunction(data) || data instanceof RegExp ? data : angular.toJson(data);
      }
      function wrapResponse(wrapped) {
        if (!$browser && timeout) {
          timeout.then ? timeout.then(handleTimeout) : $timeout(handleTimeout, timeout);
        }
        return handleResponse;
        function handleResponse() {
          var response = wrapped.response(method, url, data, headers);
          xhr.$$respHeaders = response[2];
          callback(copy(response[0]), copy(response[1]), xhr.getAllResponseHeaders(), copy(response[3] || ''));
        }
        function handleTimeout() {
          for (var i = 0, ii = responses.length; i < ii; i++) {
            if (responses[i] === handleResponse) {
              responses.splice(i, 1);
              callback(-1, undefined, '');
              break;
            }
          }
        }
      }
      if (expectation && expectation.match(method, url)) {
        if (!expectation.matchData(data)) {
          throw new Error('Expected ' + expectation + ' with different data\n' + 'EXPECTED: ' + prettyPrint(expectation.data) + '\nGOT:      ' + data);
        }
        if (!expectation.matchHeaders(headers)) {
          throw new Error('Expected ' + expectation + ' with different headers\n' + 'EXPECTED: ' + prettyPrint(expectation.headers) + '\nGOT:      ' + prettyPrint(headers));
        }
        expectations.shift();
        if (expectation.response) {
          responses.push(wrapResponse(expectation));
          return;
        }
        wasExpected = true;
      }
      var i = -1,
        definition;
      while (definition = definitions[++i]) {
        if (definition.match(method, url, data, headers || {})) {
          if (definition.response) {
            // if $browser specified, we do auto flush all requests
            ($browser ? $browser.defer : responsesPush)(wrapResponse(definition));
          } else if (definition.passThrough) {
            $delegate(method, url, data, callback, headers, timeout, withCredentials, responseType);
          } else throw new Error('No response defined !');
          return;
        }
      }
      throw wasExpected ? new Error('No response defined !') : new Error('Unexpected request: ' + method + ' ' + url + '\n' + (expectation ? 'Expected ' + expectation : 'No more request expected'));
    }

    /**
     * @ngdoc method
     * @name $httpBackend#when
     * @description
     * Creates a new backend definition.
     *
     * @param {string} method HTTP method.
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string))=} data HTTP request body or function that receives
     *   data string and returns true if the data is as expected.
     * @param {(Object|function(Object))=} headers HTTP headers or function that receives http header
     *   object and returns true if the headers match the current definition.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     *
     *  - respond –
     *      `{function([status,] data[, headers, statusText])
     *      | function(function(method, url, data, headers)}`
     *    – The respond method takes a set of static data to be returned or a function that can
     *    return an array containing response status (number), response data (string), response
     *    headers (Object), and the text for the status (string). The respond method returns the
     *    `requestHandler` object for possible overrides.
     */
    $httpBackend.when = function (method, url, data, headers) {
      var definition = new MockHttpExpectation(method, url, data, headers),
        chain = {
          respond: function (status, data, headers, statusText) {
            definition.passThrough = undefined;
            definition.response = createResponse(status, data, headers, statusText);
            return chain;
          }
        };
      if ($browser) {
        chain.passThrough = function () {
          definition.response = undefined;
          definition.passThrough = true;
          return chain;
        };
      }
      definitions.push(definition);
      return chain;
    };

    /**
     * @ngdoc method
     * @name $httpBackend#whenGET
     * @description
     * Creates a new backend definition for GET requests. For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(Object|function(Object))=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#whenHEAD
     * @description
     * Creates a new backend definition for HEAD requests. For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(Object|function(Object))=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#whenDELETE
     * @description
     * Creates a new backend definition for DELETE requests. For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(Object|function(Object))=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#whenPOST
     * @description
     * Creates a new backend definition for POST requests. For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string))=} data HTTP request body or function that receives
     *   data string and returns true if the data is as expected.
     * @param {(Object|function(Object))=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#whenPUT
     * @description
     * Creates a new backend definition for PUT requests.  For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string))=} data HTTP request body or function that receives
     *   data string and returns true if the data is as expected.
     * @param {(Object|function(Object))=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#whenJSONP
     * @description
     * Creates a new backend definition for JSONP requests. For more info see `when()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled.
     */
    createShortMethods('when');

    /**
     * @ngdoc method
     * @name $httpBackend#expect
     * @description
     * Creates a new request expectation.
     *
     * @param {string} method HTTP method.
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string)|Object)=} data HTTP request body or function that
     *  receives data string and returns true if the data is as expected, or Object if request body
     *  is in JSON format.
     * @param {(Object|function(Object))=} headers HTTP headers or function that receives http header
     *   object and returns true if the headers match the current expectation.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *  request is handled. You can save this object for later use and invoke `respond` again in
     *  order to change how a matched request is handled.
     *
     *  - respond –
     *    `{function([status,] data[, headers, statusText])
     *    | function(function(method, url, data, headers)}`
     *    – The respond method takes a set of static data to be returned or a function that can
     *    return an array containing response status (number), response data (string), response
     *    headers (Object), and the text for the status (string). The respond method returns the
     *    `requestHandler` object for possible overrides.
     */
    $httpBackend.expect = function (method, url, data, headers) {
      var expectation = new MockHttpExpectation(method, url, data, headers),
        chain = {
          respond: function (status, data, headers, statusText) {
            expectation.response = createResponse(status, data, headers, statusText);
            return chain;
          }
        };
      expectations.push(expectation);
      return chain;
    };

    /**
     * @ngdoc method
     * @name $httpBackend#expectGET
     * @description
     * Creates a new request expectation for GET requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     * request is handled. You can save this object for later use and invoke `respond` again in
     * order to change how a matched request is handled. See #expect for more info.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectHEAD
     * @description
     * Creates a new request expectation for HEAD requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectDELETE
     * @description
     * Creates a new request expectation for DELETE requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectPOST
     * @description
     * Creates a new request expectation for POST requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string)|Object)=} data HTTP request body or function that
     *  receives data string and returns true if the data is as expected, or Object if request body
     *  is in JSON format.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectPUT
     * @description
     * Creates a new request expectation for PUT requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string)|Object)=} data HTTP request body or function that
     *  receives data string and returns true if the data is as expected, or Object if request body
     *  is in JSON format.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectPATCH
     * @description
     * Creates a new request expectation for PATCH requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
     *   and returns true if the url matches the current definition.
     * @param {(string|RegExp|function(string)|Object)=} data HTTP request body or function that
     *  receives data string and returns true if the data is as expected, or Object if request body
     *  is in JSON format.
     * @param {Object=} headers HTTP headers.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */

    /**
     * @ngdoc method
     * @name $httpBackend#expectJSONP
     * @description
     * Creates a new request expectation for JSONP requests. For more info see `expect()`.
     *
     * @param {string|RegExp|function(string)} url HTTP url or function that receives an url
     *   and returns true if the url matches the current definition.
     * @returns {requestHandler} Returns an object with `respond` method that controls how a matched
     *   request is handled. You can save this object for later use and invoke `respond` again in
     *   order to change how a matched request is handled.
     */
    createShortMethods('expect');

    /**
     * @ngdoc method
     * @name $httpBackend#flush
     * @description
     * Flushes all pending requests using the trained responses.
     *
     * @param {number=} count Number of responses to flush (in the order they arrived). If undefined,
     *   all pending requests will be flushed. If there are no pending requests when the flush method
     *   is called an exception is thrown (as this typically a sign of programming error).
     */
    $httpBackend.flush = function (count, digest) {
      if (digest !== false) $rootScope.$digest();
      if (!responses.length) throw new Error('No pending request to flush !');
      if (angular.isDefined(count) && count !== null) {
        while (count--) {
          if (!responses.length) throw new Error('No more pending request to flush !');
          responses.shift()();
        }
      } else {
        while (responses.length) {
          responses.shift()();
        }
      }
      $httpBackend.verifyNoOutstandingExpectation(digest);
    };

    /**
     * @ngdoc method
     * @name $httpBackend#verifyNoOutstandingExpectation
     * @description
     * Verifies that all of the requests defined via the `expect` api were made. If any of the
     * requests were not made, verifyNoOutstandingExpectation throws an exception.
     *
     * Typically, you would call this method following each test case that asserts requests using an
     * "afterEach" clause.
     *
     * ```js
     *   afterEach($httpBackend.verifyNoOutstandingExpectation);
     * ```
     */
    $httpBackend.verifyNoOutstandingExpectation = function (digest) {
      if (digest !== false) $rootScope.$digest();
      if (expectations.length) {
        throw new Error('Unsatisfied requests: ' + expectations.join(', '));
      }
    };

    /**
     * @ngdoc method
     * @name $httpBackend#verifyNoOutstandingRequest
     * @description
     * Verifies that there are no outstanding requests that need to be flushed.
     *
     * Typically, you would call this method following each test case that asserts requests using an
     * "afterEach" clause.
     *
     * ```js
     *   afterEach($httpBackend.verifyNoOutstandingRequest);
     * ```
     */
    $httpBackend.verifyNoOutstandingRequest = function () {
      if (responses.length) {
        throw new Error('Unflushed requests: ' + responses.length);
      }
    };

    /**
     * @ngdoc method
     * @name $httpBackend#resetExpectations
     * @description
     * Resets all request expectations, but preserves all backend definitions. Typically, you would
     * call resetExpectations during a multiple-phase test when you want to reuse the same instance of
     * $httpBackend mock.
     */
    $httpBackend.resetExpectations = function () {
      expectations.length = 0;
      responses.length = 0;
    };
    return $httpBackend;
    function createShortMethods(prefix) {
      angular.forEach(['GET', 'DELETE', 'JSONP', 'HEAD'], function (method) {
        $httpBackend[prefix + method] = function (url, headers) {
          return $httpBackend[prefix](method, url, undefined, headers);
        };
      });
      angular.forEach(['PUT', 'POST', 'PATCH'], function (method) {
        $httpBackend[prefix + method] = function (url, data, headers) {
          return $httpBackend[prefix](method, url, data, headers);
        };
      });
    }
  }
  function MockHttpExpectation(method, url, data, headers) {
    this.data = data;
    this.headers = headers;
    this.match = function (m, u, d, h) {
      if (method != m) return false;
      if (!this.matchUrl(u)) return false;
      if (angular.isDefined(d) && !this.matchData(d)) return false;
      if (angular.isDefined(h) && !this.matchHeaders(h)) return false;
      return true;
    };
    this.matchUrl = function (u) {
      if (!url) return true;
      if (angular.isFunction(url.test)) return url.test(u);
      if (angular.isFunction(url)) return url(u);
      return url == u;
    };
    this.matchHeaders = function (h) {
      if (angular.isUndefined(headers)) return true;
      if (angular.isFunction(headers)) return headers(h);
      return angular.equals(headers, h);
    };
    this.matchData = function (d) {
      if (angular.isUndefined(data)) return true;
      if (data && angular.isFunction(data.test)) return data.test(d);
      if (data && angular.isFunction(data)) return data(d);
      if (data && !angular.isString(data)) {
        return angular.equals(angular.fromJson(angular.toJson(data)), angular.fromJson(d));
      }
      return data == d;
    };
    this.toString = function () {
      return method + ' ' + url;
    };
  }
  function createMockXhr() {
    return new MockXhr();
  }
  function MockXhr() {
    // hack for testing $http, $httpBackend
    MockXhr.$$lastInstance = this;
    this.open = function (method, url, async) {
      this.$$method = method;
      this.$$url = url;
      this.$$async = async;
      this.$$reqHeaders = {};
      this.$$respHeaders = {};
    };
    this.send = function (data) {
      this.$$data = data;
    };
    this.setRequestHeader = function (key, value) {
      this.$$reqHeaders[key] = value;
    };
    this.getResponseHeader = function (name) {
      // the lookup must be case insensitive,
      // that's why we try two quick lookups first and full scan last
      var header = this.$$respHeaders[name];
      if (header) return header;
      name = angular.lowercase(name);
      header = this.$$respHeaders[name];
      if (header) return header;
      header = undefined;
      angular.forEach(this.$$respHeaders, function (headerVal, headerName) {
        if (!header && angular.lowercase(headerName) == name) header = headerVal;
      });
      return header;
    };
    this.getAllResponseHeaders = function () {
      var lines = [];
      angular.forEach(this.$$respHeaders, function (value, key) {
        lines.push(key + ': ' + value);
      });
      return lines.join('\n');
    };
    this.abort = angular.noop;
  }

  /**
   * @ngdoc service
   * @name $timeout
   * @description
   *
   * This service is just a simple decorator for {@link ng.$timeout $timeout} service
   * that adds a "flush" and "verifyNoPendingTasks" methods.
   */

  angular.mock.$TimeoutDecorator = ['$delegate', '$browser', function ($delegate, $browser) {
    /**
     * @ngdoc method
     * @name $timeout#flush
     * @description
     *
     * Flushes the queue of pending tasks.
     *
     * @param {number=} delay maximum timeout amount to flush up until
     */
    $delegate.flush = function (delay) {
      $browser.defer.flush(delay);
    };

    /**
     * @ngdoc method
     * @name $timeout#verifyNoPendingTasks
     * @description
     *
     * Verifies that there are no pending tasks that need to be flushed.
     */
    $delegate.verifyNoPendingTasks = function () {
      if ($browser.deferredFns.length) {
        throw new Error('Deferred tasks to flush (' + $browser.deferredFns.length + '): ' + formatPendingTasksAsString($browser.deferredFns));
      }
    };
    function formatPendingTasksAsString(tasks) {
      var result = [];
      angular.forEach(tasks, function (task) {
        result.push('{id: ' + task.id + ', ' + 'time: ' + task.time + '}');
      });
      return result.join(', ');
    }
    return $delegate;
  }];
  angular.mock.$RAFDecorator = ['$delegate', function ($delegate) {
    var rafFn = function (fn) {
      var index = rafFn.queue.length;
      rafFn.queue.push(fn);
      return function () {
        rafFn.queue.splice(index, 1);
      };
    };
    rafFn.queue = [];
    rafFn.supported = $delegate.supported;
    rafFn.flush = function () {
      if (rafFn.queue.length === 0) {
        throw new Error('No rAF callbacks present');
      }
      var length = rafFn.queue.length;
      for (var i = 0; i < length; i++) {
        rafFn.queue[i]();
      }
      rafFn.queue = rafFn.queue.slice(i);
    };
    return rafFn;
  }];

  /**
   *
   */
  angular.mock.$RootElementProvider = function () {
    this.$get = function () {
      return angular.element('<div ng-app></div>');
    };
  };

  /**
   * @ngdoc service
   * @name $controller
   * @description
   * A decorator for {@link ng.$controller} with additional `bindings` parameter, useful when testing
   * controllers of directives that use {@link $compile#-bindtocontroller- `bindToController`}.
   *
   *
   * ## Example
   *
   * ```js
   *
   * // Directive definition ...
   *
   * myMod.directive('myDirective', {
   *   controller: 'MyDirectiveController',
   *   bindToController: {
   *     name: '@'
   *   }
   * });
   *
   *
   * // Controller definition ...
   *
   * myMod.controller('MyDirectiveController', ['$log', function($log) {
   *   $log.info(this.name);
   * }]);
   *
   *
   * // In a test ...
   *
   * describe('myDirectiveController', function() {
   *   it('should write the bound name to the log', inject(function($controller, $log) {
   *     var ctrl = $controller('MyDirectiveController', { /* no locals &#42;/ }, { name: 'Clark Kent' });
   *     expect(ctrl.name).toEqual('Clark Kent');
   *     expect($log.info.logs).toEqual(['Clark Kent']);
   *   }));
   * });
   *
   * ```
   *
   * @param {Function|string} constructor If called with a function then it's considered to be the
   *    controller constructor function. Otherwise it's considered to be a string which is used
   *    to retrieve the controller constructor using the following steps:
   *
   *    * check if a controller with given name is registered via `$controllerProvider`
   *    * check if evaluating the string on the current scope returns a constructor
   *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
   *      `window` object (not recommended)
   *
   *    The string can use the `controller as property` syntax, where the controller instance is published
   *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
   *    to work correctly.
   *
   * @param {Object} locals Injection locals for Controller.
   * @param {Object=} bindings Properties to add to the controller before invoking the constructor. This is used
   *                           to simulate the `bindToController` feature and simplify certain kinds of tests.
   * @return {Object} Instance of given controller.
   */
  angular.mock.$ControllerDecorator = ['$delegate', function ($delegate) {
    return function (expression, locals, later, ident) {
      if (later && typeof later === 'object') {
        var create = $delegate(expression, locals, true, ident);
        angular.extend(create.instance, later);
        return create();
      }
      return $delegate(expression, locals, later, ident);
    };
  }];

  /**
   * @ngdoc module
   * @name ngMock
   * @packageName angular-mocks
   * @description
   *
   * # ngMock
   *
   * The `ngMock` module provides support to inject and mock Angular services into unit tests.
   * In addition, ngMock also extends various core ng services such that they can be
   * inspected and controlled in a synchronous manner within test code.
   *
   *
   * <div doc-module-components="ngMock"></div>
   *
   */
  angular.module('ngMock', ['ng']).provider({
    $browser: angular.mock.$BrowserProvider,
    $exceptionHandler: angular.mock.$ExceptionHandlerProvider,
    $log: angular.mock.$LogProvider,
    $interval: angular.mock.$IntervalProvider,
    $httpBackend: angular.mock.$HttpBackendProvider,
    $rootElement: angular.mock.$RootElementProvider
  }).config(['$provide', function ($provide) {
    $provide.decorator('$timeout', angular.mock.$TimeoutDecorator);
    $provide.decorator('$$rAF', angular.mock.$RAFDecorator);
    $provide.decorator('$rootScope', angular.mock.$RootScopeDecorator);
    $provide.decorator('$controller', angular.mock.$ControllerDecorator);
  }]);

  /**
   * @ngdoc module
   * @name ngMockE2E
   * @module ngMockE2E
   * @packageName angular-mocks
   * @description
   *
   * The `ngMockE2E` is an angular module which contains mocks suitable for end-to-end testing.
   * Currently there is only one mock present in this module -
   * the {@link ngMockE2E.$httpBackend e2e $httpBackend} mock.
   */
  angular.module('ngMockE2E', ['ng']).config(['$provide', function ($provide) {
    $provide.decorator('$httpBackend', angular.mock.e2e.$httpBackendDecorator);
  }]);

  /**
   * @ngdoc service
   * @name $httpBackend
   * @module ngMockE2E
   * @description
   * Fake HTTP backend implementation suitable for end-to-end testing or backend-less development of
   * applications that use the {@link ng.$http $http service}.
   *
   * *Note*: For fake http backend implementation suitable for unit testing please see
   * {@link ngMock.$httpBackend unit-testing $httpBackend mock}.
   *
   * This implementation can be used to respond with static or dynamic responses via the `when` api
   * and its shortcuts (`whenGET`, `whenPOST`, etc) and optionally pass through requests to the
   * real $httpBackend for specific requests (e.g. to interact with certain remote apis or to fetch
   * templates from a webserver).
   *
   * As opposed to unit-testing, in an end-to-end testing scenario or in scenario when an application
   * is being developed with the real backend api replaced with a mock, it is often desirable for
   * certain category of requests to bypass the mock and issue a real http request (e.g. to fetch
   * templates or static files from the webserver). To configure the backend with this behavior
   * use the `passThrough` request handler of `when` instead of `respond`.
   *
   * Additionally, we don't want to manually have to flush mocked out requests like we do during unit
   * testing. For this reason the e2e $httpBackend flushes mocked out requests
   * automatically, closely simulating the behavior of the XMLHttpRequest object.
   *
   * To setup the application to run with this http backend, you have to create a module that depends
   * on the `ngMockE2E` and your application modules and defines the fake backend:
   *
   * ```js
   *   myAppDev = angular.module('myAppDev', ['myApp', 'ngMockE2E']);
   *   myAppDev.run(function($httpBackend) {
   *     phones = [{name: 'phone1'}, {name: 'phone2'}];
   *
   *     // returns the current list of phones
   *     $httpBackend.whenGET('/phones').respond(phones);
   *
   *     // adds a new phone to the phones array
   *     $httpBackend.whenPOST('/phones').respond(function(method, url, data) {
   *       var phone = angular.fromJson(data);
   *       phones.push(phone);
   *       return [200, phone, {}];
   *     });
   *     $httpBackend.whenGET(/^\/templates\//).passThrough();
   *     //...
   *   });
   * ```
   *
   * Afterwards, bootstrap your app with this new module.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#when
   * @module ngMockE2E
   * @description
   * Creates a new backend definition.
   *
   * @param {string} method HTTP method.
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(string|RegExp)=} data HTTP request body.
   * @param {(Object|function(Object))=} headers HTTP headers or function that receives http header
   *   object and returns true if the headers match the current definition.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   *
   *  - respond –
   *    `{function([status,] data[, headers, statusText])
   *    | function(function(method, url, data, headers)}`
   *    – The respond method takes a set of static data to be returned or a function that can return
   *    an array containing response status (number), response data (string), response headers
   *    (Object), and the text for the status (string).
   *  - passThrough – `{function()}` – Any request matching a backend definition with
   *    `passThrough` handler will be passed through to the real backend (an XHR request will be made
   *    to the server.)
   *  - Both methods return the `requestHandler` object for possible overrides.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenGET
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for GET requests. For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenHEAD
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for HEAD requests. For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenDELETE
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for DELETE requests. For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenPOST
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for POST requests. For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(string|RegExp)=} data HTTP request body.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenPUT
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for PUT requests.  For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(string|RegExp)=} data HTTP request body.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenPATCH
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for PATCH requests.  For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @param {(string|RegExp)=} data HTTP request body.
   * @param {(Object|function(Object))=} headers HTTP headers.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */

  /**
   * @ngdoc method
   * @name $httpBackend#whenJSONP
   * @module ngMockE2E
   * @description
   * Creates a new backend definition for JSONP requests. For more info see `when()`.
   *
   * @param {string|RegExp|function(string)} url HTTP url or function that receives a url
   *   and returns true if the url matches the current definition.
   * @returns {requestHandler} Returns an object with `respond` and `passThrough` methods that
   *   control how a matched request is handled. You can save this object for later use and invoke
   *   `respond` or `passThrough` again in order to change how a matched request is handled.
   */
  angular.mock.e2e = {};
  angular.mock.e2e.$httpBackendDecorator = ['$rootScope', '$timeout', '$delegate', '$browser', createHttpBackendMock];

  /**
   * @ngdoc type
   * @name $rootScope.Scope
   * @module ngMock
   * @description
   * {@link ng.$rootScope.Scope Scope} type decorated with helper methods useful for testing. These
   * methods are automatically available on any {@link ng.$rootScope.Scope Scope} instance when
   * `ngMock` module is loaded.
   *
   * In addition to all the regular `Scope` methods, the following helper methods are available:
   */
  angular.mock.$RootScopeDecorator = ['$delegate', function ($delegate) {
    var $rootScopePrototype = Object.getPrototypeOf($delegate);
    $rootScopePrototype.$countChildScopes = countChildScopes;
    $rootScopePrototype.$countWatchers = countWatchers;
    return $delegate;

    // ------------------------------------------------------------------------------------------ //

    /**
     * @ngdoc method
     * @name $rootScope.Scope#$countChildScopes
     * @module ngMock
     * @description
     * Counts all the direct and indirect child scopes of the current scope.
     *
     * The current scope is excluded from the count. The count includes all isolate child scopes.
     *
     * @returns {number} Total number of child scopes.
     */
    function countChildScopes() {
      // jshint validthis: true
      var count = 0; // exclude the current scope
      var pendingChildHeads = [this.$$childHead];
      var currentScope;
      while (pendingChildHeads.length) {
        currentScope = pendingChildHeads.shift();
        while (currentScope) {
          count += 1;
          pendingChildHeads.push(currentScope.$$childHead);
          currentScope = currentScope.$$nextSibling;
        }
      }
      return count;
    }

    /**
     * @ngdoc method
     * @name $rootScope.Scope#$countWatchers
     * @module ngMock
     * @description
     * Counts all the watchers of direct and indirect child scopes of the current scope.
     *
     * The watchers of the current scope are included in the count and so are all the watchers of
     * isolate child scopes.
     *
     * @returns {number} Total number of watchers.
     */
    function countWatchers() {
      // jshint validthis: true
      var count = this.$$watchers ? this.$$watchers.length : 0; // include the current scope
      var pendingChildHeads = [this.$$childHead];
      var currentScope;
      while (pendingChildHeads.length) {
        currentScope = pendingChildHeads.shift();
        while (currentScope) {
          count += currentScope.$$watchers ? currentScope.$$watchers.length : 0;
          pendingChildHeads.push(currentScope.$$childHead);
          currentScope = currentScope.$$nextSibling;
        }
      }
      return count;
    }
  }];
  if (window.jasmine || window.mocha) {
    var currentSpec = null,
      annotatedFunctions = [],
      isSpecRunning = function () {
        return !!currentSpec;
      };
    angular.mock.$$annotate = angular.injector.$$annotate;
    angular.injector.$$annotate = function (fn) {
      if (typeof fn === 'function' && !fn.$inject) {
        annotatedFunctions.push(fn);
      }
      return angular.mock.$$annotate.apply(this, arguments);
    };
    (window.beforeEach || window.setup)(function () {
      annotatedFunctions = [];
      currentSpec = this;
    });
    (window.afterEach || window.teardown)(function () {
      var injector = currentSpec.$injector;
      annotatedFunctions.forEach(function (fn) {
        delete fn.$inject;
      });
      angular.forEach(currentSpec.$modules, function (module) {
        if (module && module.$$hashKey) {
          module.$$hashKey = undefined;
        }
      });
      currentSpec.$injector = null;
      currentSpec.$modules = null;
      currentSpec = null;
      if (injector) {
        injector.get('$rootElement').off();
      }

      // clean up jquery's fragment cache
      angular.forEach(angular.element.fragments, function (val, key) {
        delete angular.element.fragments[key];
      });
      MockXhr.$$lastInstance = null;
      angular.forEach(angular.callbacks, function (val, key) {
        delete angular.callbacks[key];
      });
      angular.callbacks.counter = 0;
    });

    /**
     * @ngdoc function
     * @name angular.mock.module
     * @description
     *
     * *NOTE*: This function is also published on window for easy access.<br>
     * *NOTE*: This function is declared ONLY WHEN running tests with jasmine or mocha
     *
     * This function registers a module configuration code. It collects the configuration information
     * which will be used when the injector is created by {@link angular.mock.inject inject}.
     *
     * See {@link angular.mock.inject inject} for usage example
     *
     * @param {...(string|Function|Object)} fns any number of modules which are represented as string
     *        aliases or as anonymous module initialization functions. The modules are used to
     *        configure the injector. The 'ng' and 'ngMock' modules are automatically loaded. If an
     *        object literal is passed each key-value pair will be registered on the module via
     *        {@link auto.$provide $provide}.value, the key being the string name (or token) to associate
     *        with the value on the injector.
     */
    window.module = angular.mock.module = function () {
      var moduleFns = Array.prototype.slice.call(arguments, 0);
      return isSpecRunning() ? workFn() : workFn;
      /////////////////////
      function workFn() {
        if (currentSpec.$injector) {
          throw new Error('Injector already created, can not register a module!');
        } else {
          var modules = currentSpec.$modules || (currentSpec.$modules = []);
          angular.forEach(moduleFns, function (module) {
            if (angular.isObject(module) && !angular.isArray(module)) {
              modules.push(function ($provide) {
                angular.forEach(module, function (value, key) {
                  $provide.value(key, value);
                });
              });
            } else {
              modules.push(module);
            }
          });
        }
      }
    };

    /**
     * @ngdoc function
     * @name angular.mock.inject
     * @description
     *
     * *NOTE*: This function is also published on window for easy access.<br>
     * *NOTE*: This function is declared ONLY WHEN running tests with jasmine or mocha
     *
     * The inject function wraps a function into an injectable function. The inject() creates new
     * instance of {@link auto.$injector $injector} per test, which is then used for
     * resolving references.
     *
     *
     * ## Resolving References (Underscore Wrapping)
     * Often, we would like to inject a reference once, in a `beforeEach()` block and reuse this
     * in multiple `it()` clauses. To be able to do this we must assign the reference to a variable
     * that is declared in the scope of the `describe()` block. Since we would, most likely, want
     * the variable to have the same name of the reference we have a problem, since the parameter
     * to the `inject()` function would hide the outer variable.
     *
     * To help with this, the injected parameters can, optionally, be enclosed with underscores.
     * These are ignored by the injector when the reference name is resolved.
     *
     * For example, the parameter `_myService_` would be resolved as the reference `myService`.
     * Since it is available in the function body as _myService_, we can then assign it to a variable
     * defined in an outer scope.
     *
     * ```
     * // Defined out reference variable outside
     * var myService;
     *
     * // Wrap the parameter in underscores
     * beforeEach( inject( function(_myService_){
     *   myService = _myService_;
     * }));
     *
     * // Use myService in a series of tests.
     * it('makes use of myService', function() {
     *   myService.doStuff();
     * });
     *
     * ```
     *
     * See also {@link angular.mock.module angular.mock.module}
     *
     * ## Example
     * Example of what a typical jasmine tests looks like with the inject method.
     * ```js
     *
     *   angular.module('myApplicationModule', [])
     *       .value('mode', 'app')
     *       .value('version', 'v1.0.1');
     *
     *
     *   describe('MyApp', function() {
     *
     *     // You need to load modules that you want to test,
     *     // it loads only the "ng" module by default.
     *     beforeEach(module('myApplicationModule'));
     *
     *
     *     // inject() is used to inject arguments of all given functions
     *     it('should provide a version', inject(function(mode, version) {
     *       expect(version).toEqual('v1.0.1');
     *       expect(mode).toEqual('app');
     *     }));
     *
     *
     *     // The inject and module method can also be used inside of the it or beforeEach
     *     it('should override a version and test the new version is injected', function() {
     *       // module() takes functions or strings (module aliases)
     *       module(function($provide) {
     *         $provide.value('version', 'overridden'); // override version here
     *       });
     *
     *       inject(function(version) {
     *         expect(version).toEqual('overridden');
     *       });
     *     });
     *   });
     *
     * ```
     *
     * @param {...Function} fns any number of functions which will be injected using the injector.
     */

    var ErrorAddingDeclarationLocationStack = function (e, errorForStack) {
      this.message = e.message;
      this.name = e.name;
      if (e.line) this.line = e.line;
      if (e.sourceId) this.sourceId = e.sourceId;
      if (e.stack && errorForStack) this.stack = e.stack + '\n' + errorForStack.stack;
      if (e.stackArray) this.stackArray = e.stackArray;
    };
    ErrorAddingDeclarationLocationStack.prototype.toString = Error.prototype.toString;
    window.inject = angular.mock.inject = function () {
      var blockFns = Array.prototype.slice.call(arguments, 0);
      var errorForStack = new Error('Declaration Location');
      // IE10+ and PhanthomJS do not set stack trace information, until the error is thrown
      if (!errorForStack.stack) {
        try {
          throw errorForStack;
        } catch (e) {}
      }
      return isSpecRunning() ? workFn.call(currentSpec) : workFn;
      /////////////////////
      function workFn() {
        var modules = currentSpec.$modules || [];
        var strictDi = !!currentSpec.$injectorStrict;
        modules.unshift('ngMock');
        modules.unshift('ng');
        var injector = currentSpec.$injector;
        if (!injector) {
          if (strictDi) {
            // If strictDi is enabled, annotate the providerInjector blocks
            angular.forEach(modules, function (moduleFn) {
              if (typeof moduleFn === "function") {
                angular.injector.$$annotate(moduleFn);
              }
            });
          }
          injector = currentSpec.$injector = angular.injector(modules, strictDi);
          currentSpec.$injectorStrict = strictDi;
        }
        for (var i = 0, ii = blockFns.length; i < ii; i++) {
          if (currentSpec.$injectorStrict) {
            // If the injector is strict / strictDi, and the spec wants to inject using automatic
            // annotation, then annotate the function here.
            injector.annotate(blockFns[i]);
          }
          try {
            /* jshint -W040 */ /* Jasmine explicitly provides a `this` object when calling functions */
            injector.invoke(blockFns[i] || angular.noop, this);
            /* jshint +W040 */
          } catch (e) {
            if (e.stack && errorForStack) {
              throw new ErrorAddingDeclarationLocationStack(e, errorForStack);
            }
            throw e;
          } finally {
            errorForStack = null;
          }
        }
      }
    };
    angular.mock.inject.strictDi = function (value) {
      value = arguments.length ? !!value : true;
      return isSpecRunning() ? workFn() : workFn;
      function workFn() {
        if (value !== currentSpec.$injectorStrict) {
          if (currentSpec.$injector) {
            throw new Error('Injector already created, can not modify strict annotations');
          } else {
            currentSpec.$injectorStrict = value;
          }
        }
      }
    };
  }
})(window, window.angular);
/**
 * angular-growl-v2 - v0.7.8 - 2015-10-25
 * http://janstevens.github.io/angular-growl-2
 * Copyright (c) 2015 Marco Rinck,Jan Stevens,Silvan van Leeuwen; Licensed MIT
 */
angular.module('angular-growl', []);
angular.module('angular-growl').directive('growl', [function () {
  'use strict';

  return {
    restrict: 'A',
    templateUrl: 'templates/growl/growl.html',
    replace: false,
    scope: {
      reference: '@',
      inline: '=',
      limitMessages: '='
    },
    controller: ['$scope', '$interval', 'growl', 'growlMessages', function ($scope, $interval, growl, growlMessages) {
      $scope.referenceId = $scope.reference || 0;
      growlMessages.initDirective($scope.referenceId, $scope.limitMessages);
      $scope.growlMessages = growlMessages;
      $scope.inlineMessage = angular.isDefined($scope.inline) ? $scope.inline : growl.inlineMessages();
      $scope.$watch('limitMessages', function (limitMessages) {
        var directive = growlMessages.directives[$scope.referenceId];
        if (!angular.isUndefined(limitMessages) && !angular.isUndefined(directive)) {
          directive.limitMessages = limitMessages;
        }
      });
      $scope.stopTimeoutClose = function (message) {
        if (!message.clickToClose) {
          angular.forEach(message.promises, function (promise) {
            $interval.cancel(promise);
          });
          if (message.close) {
            growlMessages.deleteMessage(message);
          } else {
            message.close = true;
          }
        }
      };
      $scope.alertClasses = function (message) {
        return {
          'alert-success': message.severity === 'success',
          'alert-error': message.severity === 'error',
          'alert-danger': message.severity === 'error',
          'alert-info': message.severity === 'info',
          'alert-warning': message.severity === 'warning',
          'icon': message.disableIcons === false,
          'alert-dismissable': !message.disableCloseButton
        };
      };
      $scope.showCountDown = function (message) {
        return !message.disableCountDown && message.ttl > 0;
      };
      $scope.wrapperClasses = function () {
        var classes = {};
        classes['growl-fixed'] = !$scope.inlineMessage;
        classes[growl.position()] = true;
        return classes;
      };
      $scope.computeTitle = function (message) {
        var ret = {
          'success': 'Success',
          'error': 'Error',
          'info': 'Information',
          'warn': 'Warning'
        };
        return ret[message.severity];
      };
    }]
  };
}]);
angular.module('angular-growl').run(['$templateCache', function ($templateCache) {
  'use strict';

  if ($templateCache.get('templates/growl/growl.html') === undefined) {
    $templateCache.put('templates/growl/growl.html', '<div class="growl-container" ng-class="wrapperClasses()">' + '<div class="growl-item alert" ng-repeat="message in growlMessages.directives[referenceId].messages" ng-class="alertClasses(message)" ng-click="stopTimeoutClose(message)">' + '<button type="button" class="close" data-dismiss="alert" aria-hidden="true" ng-click="growlMessages.deleteMessage(message)" ng-show="!message.disableCloseButton">&times;</button>' + '<button type="button" class="close" aria-hidden="true" ng-show="showCountDown(message)">{{message.countdown}}</button>' + '<h4 class="growl-title" ng-show="message.title" ng-bind="message.title"></h4>' + '<div class="growl-message" ng-bind-html="message.text"></div>' + '</div>' + '</div>');
  }
}]);
angular.module('angular-growl').provider('growl', function () {
  'use strict';

  var _ttl = {
      success: null,
      error: null,
      warning: null,
      info: null
    },
    _messagesKey = 'messages',
    _messageTextKey = 'text',
    _messageTitleKey = 'title',
    _messageSeverityKey = 'severity',
    _messageTTLKey = 'ttl',
    _onlyUniqueMessages = true,
    _messageVariableKey = 'variables',
    _referenceId = 0,
    _inline = false,
    _position = 'top-right',
    _disableCloseButton = false,
    _disableIcons = false,
    _reverseOrder = false,
    _disableCountDown = false,
    _translateMessages = true;
  this.globalTimeToLive = function (ttl) {
    if (typeof ttl === 'object') {
      for (var k in ttl) {
        if (ttl.hasOwnProperty(k)) {
          _ttl[k] = ttl[k];
        }
      }
    } else {
      for (var severity in _ttl) {
        if (_ttl.hasOwnProperty(severity)) {
          _ttl[severity] = ttl;
        }
      }
    }
    return this;
  };
  this.globalTranslateMessages = function (translateMessages) {
    _translateMessages = translateMessages;
    return this;
  };
  this.globalDisableCloseButton = function (disableCloseButton) {
    _disableCloseButton = disableCloseButton;
    return this;
  };
  this.globalDisableIcons = function (disableIcons) {
    _disableIcons = disableIcons;
    return this;
  };
  this.globalReversedOrder = function (reverseOrder) {
    _reverseOrder = reverseOrder;
    return this;
  };
  this.globalDisableCountDown = function (countDown) {
    _disableCountDown = countDown;
    return this;
  };
  this.messageVariableKey = function (messageVariableKey) {
    _messageVariableKey = messageVariableKey;
    return this;
  };
  this.globalInlineMessages = function (inline) {
    _inline = inline;
    return this;
  };
  this.globalPosition = function (position) {
    _position = position;
    return this;
  };
  this.messagesKey = function (messagesKey) {
    _messagesKey = messagesKey;
    return this;
  };
  this.messageTextKey = function (messageTextKey) {
    _messageTextKey = messageTextKey;
    return this;
  };
  this.messageTitleKey = function (messageTitleKey) {
    _messageTitleKey = messageTitleKey;
    return this;
  };
  this.messageSeverityKey = function (messageSeverityKey) {
    _messageSeverityKey = messageSeverityKey;
    return this;
  };
  this.messageTTLKey = function (messageTTLKey) {
    _messageTTLKey = messageTTLKey;
    return this;
  };
  this.onlyUniqueMessages = function (onlyUniqueMessages) {
    _onlyUniqueMessages = onlyUniqueMessages;
    return this;
  };
  this.serverMessagesInterceptor = ['$q', 'growl', function ($q, growl) {
    function checkResponse(response) {
      if (response !== undefined && response.data && response.data[_messagesKey] && response.data[_messagesKey].length > 0) {
        growl.addServerMessages(response.data[_messagesKey]);
      }
    }
    return {
      'response': function (response) {
        checkResponse(response);
        return response;
      },
      'responseError': function (rejection) {
        checkResponse(rejection);
        return $q.reject(rejection);
      }
    };
  }];
  this.$get = ['$rootScope', '$interpolate', '$sce', '$filter', '$interval', 'growlMessages', function ($rootScope, $interpolate, $sce, $filter, $interval, growlMessages) {
    var translate;
    growlMessages.onlyUnique = _onlyUniqueMessages;
    growlMessages.reverseOrder = _reverseOrder;
    try {
      translate = $filter('translate');
    } catch (e) {}
    function broadcastMessage(message) {
      if (translate && message.translateMessage) {
        message.text = translate(message.text, message.variables) || message.text;
        message.title = translate(message.title) || message.title;
      } else {
        var polation = $interpolate(message.text);
        message.text = polation(message.variables);
      }
      var addedMessage = growlMessages.addMessage(message);
      $rootScope.$broadcast('growlMessage', message);
      $interval(function () {}, 0, 1);
      return addedMessage;
    }
    function sendMessage(text, config, severity) {
      var _config = config || {},
        message;
      message = {
        text: text,
        title: _config.title,
        severity: severity,
        ttl: _config.ttl || _ttl[severity],
        variables: _config.variables || {},
        disableCloseButton: _config.disableCloseButton === undefined ? _disableCloseButton : _config.disableCloseButton,
        disableIcons: _config.disableIcons === undefined ? _disableIcons : _config.disableIcons,
        disableCountDown: _config.disableCountDown === undefined ? _disableCountDown : _config.disableCountDown,
        position: _config.position || _position,
        referenceId: _config.referenceId || _referenceId,
        translateMessage: _config.translateMessage === undefined ? _translateMessages : _config.translateMessage,
        destroy: function () {
          growlMessages.deleteMessage(message);
        },
        setText: function (newText) {
          message.text = $sce.trustAsHtml(String(newText));
        },
        onclose: _config.onclose,
        onopen: _config.onopen
      };
      return broadcastMessage(message);
    }
    function warning(text, config) {
      return sendMessage(text, config, 'warning');
    }
    function error(text, config) {
      return sendMessage(text, config, 'error');
    }
    function info(text, config) {
      return sendMessage(text, config, 'info');
    }
    function success(text, config) {
      return sendMessage(text, config, 'success');
    }
    function general(text, config, severity) {
      severity = (severity || 'error').toLowerCase();
      return sendMessage(text, config, severity);
    }
    function addServerMessages(messages) {
      if (!messages || !messages.length) {
        return;
      }
      var i, message, severity, length;
      length = messages.length;
      for (i = 0; i < length; i++) {
        message = messages[i];
        if (message[_messageTextKey]) {
          severity = (message[_messageSeverityKey] || 'error').toLowerCase();
          var config = {};
          config.variables = message[_messageVariableKey] || {};
          config.title = message[_messageTitleKey];
          if (message[_messageTTLKey]) {
            config.ttl = message[_messageTTLKey];
          }
          sendMessage(message[_messageTextKey], config, severity);
        }
      }
    }
    function onlyUnique() {
      return _onlyUniqueMessages;
    }
    function reverseOrder() {
      return _reverseOrder;
    }
    function inlineMessages() {
      return _inline;
    }
    function position() {
      return _position;
    }
    return {
      warning: warning,
      error: error,
      info: info,
      success: success,
      general: general,
      addServerMessages: addServerMessages,
      onlyUnique: onlyUnique,
      reverseOrder: reverseOrder,
      inlineMessages: inlineMessages,
      position: position
    };
  }];
});
angular.module('angular-growl').service('growlMessages', ['$sce', '$interval', function ($sce, $interval) {
  'use strict';

  var self = this;
  this.directives = {};
  var preloadDirectives = {};
  function preLoad(referenceId) {
    var directive;
    if (preloadDirectives[referenceId]) {
      directive = preloadDirectives[referenceId];
    } else {
      directive = preloadDirectives[referenceId] = {
        messages: []
      };
    }
    return directive;
  }
  function directiveForRefId(referenceId) {
    var refId = referenceId || 0;
    return self.directives[refId] || preloadDirectives[refId];
  }
  this.initDirective = function (referenceId, limitMessages) {
    if (preloadDirectives[referenceId]) {
      this.directives[referenceId] = preloadDirectives[referenceId];
      this.directives[referenceId].limitMessages = limitMessages;
    } else {
      this.directives[referenceId] = {
        messages: [],
        limitMessages: limitMessages
      };
    }
    return this.directives[referenceId];
  };
  this.getAllMessages = function (referenceId) {
    referenceId = referenceId || 0;
    var messages;
    if (directiveForRefId(referenceId)) {
      messages = directiveForRefId(referenceId).messages;
    } else {
      messages = [];
    }
    return messages;
  };
  this.destroyAllMessages = function (referenceId) {
    var messages = this.getAllMessages(referenceId);
    for (var i = messages.length - 1; i >= 0; i--) {
      messages[i].destroy();
    }
    var directive = directiveForRefId(referenceId);
    if (directive) {
      directive.messages = [];
    }
  };
  this.addMessage = function (message) {
    var directive, messages, found, msgText;
    if (this.directives[message.referenceId]) {
      directive = this.directives[message.referenceId];
    } else {
      directive = preLoad(message.referenceId);
    }
    messages = directive.messages;
    if (this.onlyUnique) {
      angular.forEach(messages, function (msg) {
        msgText = $sce.getTrustedHtml(msg.text);
        if (message.text === msgText && message.severity === msg.severity && message.title === msg.title) {
          found = true;
        }
      });
      if (found) {
        return;
      }
    }
    message.text = $sce.trustAsHtml(String(message.text));
    if (message.ttl && message.ttl !== -1) {
      message.countdown = message.ttl / 1000;
      message.promises = [];
      message.close = false;
      message.countdownFunction = function () {
        if (message.countdown > 1) {
          message.countdown--;
          message.promises.push($interval(message.countdownFunction, 1000, 1, 1));
        } else {
          message.countdown--;
        }
      };
    }
    if (angular.isDefined(directive.limitMessages)) {
      var diff = messages.length - (directive.limitMessages - 1);
      if (diff > 0) {
        messages.splice(directive.limitMessages - 1, diff);
      }
    }
    if (this.reverseOrder) {
      messages.unshift(message);
    } else {
      messages.push(message);
    }
    if (typeof message.onopen === 'function') {
      message.onopen();
    }
    if (message.ttl && message.ttl !== -1) {
      var self = this;
      message.promises.push($interval(angular.bind(this, function () {
        self.deleteMessage(message);
      }), message.ttl, 1, 1));
      message.promises.push($interval(message.countdownFunction, 1000, 1, 1));
    }
    return message;
  };
  this.deleteMessage = function (message) {
    var messages = this.getAllMessages(message.referenceId),
      index = -1;
    for (var i in messages) {
      if (messages.hasOwnProperty(i)) {
        index = messages[i] === message ? i : index;
      }
    }
    if (index > -1) {
      messages[index].close = true;
      messages.splice(index, 1);
    }
    if (typeof message.onclose === 'function') {
      message.onclose();
    }
  };
}]);
/*! angular-shims-placeholder - v0.4.8 - 2016-12-06
* https://github.com/cvn/angular-shims-placeholder
* Copyright (c) 2016 Chad von Nau; Licensed MIT */
(function (angular, document, undefined) {
  'use strict';

  angular.module('ng.shims.placeholder', []).service('placeholderSniffer', ['$document', function ($document) {
    this.emptyClassName = 'empty', this.hasPlaceholder = function () {
      // test for native placeholder support
      var test = $document[0].createElement('input');
      return test.placeholder !== void 0;
    };
  }]).directive('placeholder', ['$timeout', '$document', '$interpolate', '$injector', 'placeholderSniffer', function ($timeout, $document, $interpolate, $injector, placeholderSniffer) {
    if (placeholderSniffer.hasPlaceholder()) return {};
    var documentListenersApplied = false,
      angularVersion = parseFloat(angular.version.full);

    // load $animate if available, to coordinate with other directives that use it
    try {
      var $animate = $injector.get('$animate');
    } catch (e) {}

    // No native support for attribute placeholder
    return {
      restrict: 'A',
      require: '?ngModel',
      // run after ngModel (0) and BOOLEAN_ATTR (100) directives.
      // priority order was reversed in Angular 1.2, so we must account for this
      priority: angularVersion >= 1.2 ? 110 : -10,
      link: function (scope, elem, attrs, ngModel) {
        var orig_val = getValue(),
          domElem = elem[0],
          elemType = domElem.nodeName.toLowerCase(),
          isInput = elemType === 'input' || elemType === 'textarea',
          is_pwd = attrs.type === 'password',
          text = attrs.placeholder || '',
          emptyClassName = placeholderSniffer.emptyClassName,
          hiddenClassName = 'ng-hide',
          clone;
        if (!isInput) {
          return;
        }
        attrs.$observe('placeholder', function (newValue) {
          changePlaceholder(newValue);
        });
        if (is_pwd) {
          setupPasswordPlaceholder();
        }

        // init
        setValue(orig_val);

        // on focus, replace auto-label with empty field
        elem.bind('focus', function () {
          if (elem.hasClass(emptyClassName)) {
            elem.val('');
            elem.removeClass(emptyClassName);
            domElem.select(); // IE8/9 show text cursor after tabbing in
          }
        });

        // on blur, show placeholder if necessary
        elem.bind('blur', updateValue);

        // handler for model-less inputs to interact with non-angular code
        if (!ngModel) {
          elem.bind('change', function (event) {
            changePlaceholder($interpolate(elem.attr('placeholder') || '')(scope), event);
          });
        }

        // model -> view
        if (ngModel) {
          ngModel.$render = function () {
            setValue(ngModel.$viewValue);
            // IE8/9: show text cursor after updating value while
            // focused, this happens when tabbing into a field, and the
            // deferred keydown handler from the previous field fires
            //
            // TODO: remove when tab key behavior is fixed in
            // angular core
            if (isActiveElement(domElem) && !elem.val()) {
              domElem.select();
            }
          };
        }
        if (!documentListenersApplied) {
          // cancel selection of placeholder text on disabled elements
          // disabled elements do not emit selectstart events in IE8/IE9,
          // so bind to $document and catch the event as it bubbles
          $document.bind('selectstart', function (e) {
            var elmn = angular.element(e.target);
            if (elmn.hasClass(emptyClassName) && elmn.prop('disabled')) {
              e.preventDefault();
            }
          });
          documentListenersApplied = true;
        }
        function updateValue(event) {
          var val = elem.val();

          // don't update from placeholder, helps debounce
          if (elem.hasClass(emptyClassName) && val && val === text) {
            return;
          }
          conditionalDefer(function () {
            setValue(val);
          }, event);
        }
        function conditionalDefer(callback, event) {
          // IE8/9: ngModel uses a keydown handler with deferrered
          // execution to check for changes to the input. this $timeout 
          // prevents callback from firing before the keydown handler,
          // which is an issue when tabbing out of an input.
          // the conditional tests IE version, matches $sniffer.
          //
          // TODO: remove this function when tab key behavior is fixed in
          // angular core
          if (document.documentMode <= 11 && event) {
            $timeout(callback, 0);
          } else {
            callback();
          }
        }
        function setValue(val) {
          if (!val && val !== 0 && !isActiveElement(domElem)) {
            // show placeholder when necessary
            elem.addClass(emptyClassName);
            elem.val(!is_pwd ? text : '');
          } else {
            // otherwise set input to actual value
            elem.removeClass(emptyClassName);
            elem.val(val);
          }
          if (is_pwd) {
            updatePasswordPlaceholder();
            if ($animate) {
              asyncUpdatePasswordPlaceholder();
            }
          }
        }
        function getValue() {
          if (ngModel) {
            // use eval because $viewValue isn't ready during init
            // TODO: this might not to work during unit tests, investigate
            return scope.$eval(attrs.ngModel) || '';
          }
          return getDomValue() || '';
        }

        // IE8/9: elem.val() on an empty field sometimes returns the
        // placeholder value, so return an empty string instead
        // http://stackoverflow.com/q/11208417/490592
        // I believe IE is persisting the field value across refreshes
        // TODO: vs `elem.attr('value')`
        function getDomValue() {
          var val = elem.val();
          if (val === attrs.placeholder) {
            val = '';
          }
          return val;
        }
        function changePlaceholder(value, event) {
          if (elem.hasClass(emptyClassName) && elem.val() === text) {
            elem.val('');
          }
          text = value;
          updateValue(event);
        }

        // IE9: getting activeElement in an iframe raises error
        // http://tjvantoll.com/2013/08/30/bugs-with-document-activeelement-in-internet-explorer/
        function isActiveElement(elmn) {
          var result = false;
          try {
            result = elmn === document.activeElement;
          } catch (error) {}
          return result;
        }
        function setAttrConditional(elmn, attr, enable, value) {
          if (enable) {
            elmn.attr(attr, value);
          } else {
            elmn.removeAttr(attr);
          }
        }

        // IE8: password inputs cannot display text, and inputs cannot
        // change type, so create a new element to display placeholder
        function setupPasswordPlaceholder() {
          clone = angular.element('<input type="text" value="' + text + '"/>');
          stylePasswordPlaceholder();
          hideElement(clone);
          clone.addClass(emptyClassName).bind('focus', hidePasswordPlaceholderAndFocus);
          domElem.parentNode.insertBefore(clone[0], domElem);

          // keep password placeholder in sync with original element.
          // update element after $watches
          var watchAttrs = [attrs.ngDisabled, attrs.ngReadonly, attrs.ngRequired, attrs.ngShow, attrs.ngHide];
          for (var i = 0; i < watchAttrs.length; i++) {
            if (watchAttrs[i]) {
              scope.$watch(watchAttrs[i], flexibleUpdatePasswordPlaceholder);
            }
          }
        }
        function updatePasswordPlaceholder() {
          stylePasswordPlaceholder();
          if (isNgHidden()) {
            // force hide the placeholder when element is hidden by
            // ngShow/ngHide. we cannot rely on stylePasswordPlaceholder
            // above to copy the ng-hide class, because the ngShow/ngHide
            // $watch functions apply the ng-hide class with $animate, 
            // so the class is not applied when our $watch executes
            hideElement(clone);
          } else if (elem.hasClass(emptyClassName) && domElem !== document.activeElement) {
            showPasswordPlaceholder();
          } else {
            hidePasswordPlaceholder();
          }
        }
        // update element after animation and animation-aware directives
        function asyncUpdatePasswordPlaceholder() {
          if (angularVersion >= 1.3) {
            $animate.addClass(elem, '').then(updatePasswordPlaceholder);
          } else {
            $animate.addClass(elem, '', updatePasswordPlaceholder);
          }
        }
        function flexibleUpdatePasswordPlaceholder() {
          if ($animate) {
            asyncUpdatePasswordPlaceholder();
          } else {
            updatePasswordPlaceholder();
          }
        }
        function stylePasswordPlaceholder() {
          clone.val(text);
          // chaining was failing in v1.0.8
          clone.attr('class', elem.attr('class') || '').attr('style', elem.attr('style') || '').prop('disabled', elem.prop('disabled')).prop('readOnly', elem.prop('readOnly')).prop('required', elem.prop('required'));
          setAttrConditional(clone, 'unselectable', elem.attr('unselectable') === 'on', 'on');
          setAttrConditional(clone, 'tabindex', elem.attr('tabindex') !== undefined, elem.attr('tabindex'));
        }
        function showElement(elmn) {
          if (angularVersion >= 1.2) {
            elmn.removeClass(hiddenClassName);
          } else {
            elmn.css('display', '');
          }
        }
        function hideElement(elmn) {
          if (angularVersion >= 1.2) {
            elmn.addClass(hiddenClassName);
          } else {
            elmn.css('display', 'none');
          }
        }
        function showPasswordPlaceholder() {
          hideElement(elem);
          showElement(clone);
        }
        function hidePasswordPlaceholder() {
          hideElement(clone);
          showElement(elem);
        }
        function hidePasswordPlaceholderAndFocus() {
          hidePasswordPlaceholder();
          domElem.focus();
        }
        function isNgHidden() {
          var hasNgShow = typeof attrs.ngShow !== 'undefined',
            hasNgHide = typeof attrs.ngHide !== 'undefined';
          if (hasNgShow || hasNgHide) {
            return hasNgShow && !scope.$eval(attrs.ngShow) || hasNgHide && scope.$eval(attrs.ngHide);
          } else {
            return false;
          }
        }
      }
    };
  }]);
})(window.angular, window.document);
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

angular.module('ui.dashboard', ['ui.bootstrap', 'ui.sortable']);
angular.module('ui.dashboard').directive('dashboard', ['WidgetModel', 'WidgetDefCollection', '$modal', 'DashboardState', '$log', function (WidgetModel, WidgetDefCollection, $modal, DashboardState, $log) {
  return {
    restrict: 'A',
    templateUrl: function (element, attr) {
      return attr.templateUrl ? attr.templateUrl : 'template/dashboard.html';
    },
    scope: true,
    controller: ['$scope', '$attrs', function (scope, attrs) {
      // default options
      var defaults = {
        stringifyStorage: true,
        hideWidgetSettings: false,
        hideWidgetClose: false,
        settingsModalOptions: {
          templateUrl: 'template/widget-settings-template.html',
          controller: 'WidgetSettingsCtrl'
        },
        onSettingsClose: function (result, widget) {
          // NOTE: dashboard scope is also passed as 3rd argument
          jQuery.extend(true, widget, result);
        },
        onSettingsDismiss: function (reason) {
          // NOTE: dashboard scope is also passed as 2nd argument
          $log.info('widget settings were dismissed. Reason: ', reason);
        }
      };

      // from dashboard="options"
      // scope.options = scope.$eval(attrs.dashboard);

      // extend default settingsModalOptions
      // scope.options.settingsModalOptions = scope.options.settingsModalOptions || {};

      // extend options with defaults
      // angular.extend(defaults.settingsModalOptions, scope.options.settingsModalOptions);
      // angular.extend(scope.options.settingsModalOptions, defaults.settingsModalOptions);
      // angular.extend(defaults, scope.options);
      // angular.extend(scope.options, defaults);

      // from dashboard="options"
      scope.options = scope.$eval(attrs.dashboard);

      // Deep options
      scope.options.settingsModalOptions = scope.options.settingsModalOptions || {};
      _.each(['settingsModalOptions'], function (key) {
        // Ensure it exists on scope.options
        scope.options[key] = scope.options[key] || {};
        // Set defaults
        _.defaults(scope.options[key], defaults[key]);
      });

      // Shallow options
      _.defaults(scope.options, defaults);

      // jQuery.extend(true, defaults, scope.options);
      // jQuery.extend(scope.options, defaults);

      var sortableDefaults = {
        stop: function () {
          scope.saveDashboard();
        },
        handle: '.widget-header'
      };
      scope.sortableOptions = angular.extend({}, sortableDefaults, scope.options.sortableOptions || {});
    }],
    link: function (scope) {
      // Save default widget config for reset
      scope.defaultWidgets = scope.options.defaultWidgets;

      //scope.widgetDefs = scope.options.widgetDefinitions;
      scope.widgetDefs = new WidgetDefCollection(scope.options.widgetDefinitions);
      var count = 1;

      // Instantiate new instance of dashboard state
      scope.dashboardState = new DashboardState(scope.options.storage, scope.options.storageId, scope.options.storageHash, scope.widgetDefs, scope.options.stringifyStorage);

      /**
       * Instantiates a new widget on the dashboard
       * @param {Object} widgetToInstantiate The definition object of the widget to be instantiated
       */
      scope.addWidget = function (widgetToInstantiate, doNotSave) {
        var defaultWidgetDefinition = scope.widgetDefs.getByName(widgetToInstantiate.name);
        if (!defaultWidgetDefinition) {
          throw 'Widget ' + widgetToInstantiate.name + ' is not found.';
        }

        // Determine the title for the new widget
        var title;
        if (widgetToInstantiate.title) {
          title = widgetToInstantiate.title;
        } else if (defaultWidgetDefinition.title) {
          title = defaultWidgetDefinition.title;
        } else {
          title = 'Widget ' + count++;
        }

        // Deep extend a new object for instantiation
        widgetToInstantiate = jQuery.extend(true, {}, defaultWidgetDefinition, widgetToInstantiate);

        // Instantiation
        var widget = new WidgetModel(widgetToInstantiate, {
          title: title
        });
        scope.widgets.push(widget);
        if (!doNotSave) {
          scope.saveDashboard();
        }
      };

      /**
       * Removes a widget instance from the dashboard
       * @param  {Object} widget The widget instance object (not a definition object)
       */
      scope.removeWidget = function (widget) {
        scope.widgets.splice(_.indexOf(scope.widgets, widget), 1);
        scope.saveDashboard();
      };

      /**
       * Opens a dialog for setting and changing widget properties
       * @param  {Object} widget The widget instance object
       */
      scope.openWidgetSettings = function (widget) {
        // Set up $modal options 
        var options = _.defaults({
          scope: scope
        }, widget.settingsModalOptions, scope.options.settingsModalOptions);

        // Ensure widget is resolved
        options.resolve = {
          widget: function () {
            return widget;
          }
        };

        // Create the modal
        var modalInstance = $modal.open(options);
        var onClose = widget.onSettingsClose || scope.options.onSettingsClose;
        var onDismiss = widget.onSettingsDismiss || scope.options.onSettingsDismiss;

        // Set resolve and reject callbacks for the result promise
        modalInstance.result.then(function (result) {
          // Call the close callback
          onClose(result, widget, scope);

          //AW Persist title change from options editor
          scope.$emit('widgetChanged', widget);
        }, function (reason) {
          // Call the dismiss callback
          onDismiss(reason, scope);
        });
      };

      /**
       * Remove all widget instances from dashboard
       */
      scope.clear = function (doNotSave) {
        scope.widgets = [];
        if (doNotSave === true) {
          return;
        }
        scope.saveDashboard();
      };

      /**
       * Used for preventing default on click event
       * @param {Object} event     A click event
       * @param {Object} widgetDef A widget definition object
       */
      scope.addWidgetInternal = function (event, widgetDef) {
        event.preventDefault();
        scope.addWidget(widgetDef);
      };

      /**
       * Uses dashboardState service to save state
       */
      scope.saveDashboard = function (force) {
        if (!scope.options.explicitSave) {
          scope.dashboardState.save(scope.widgets);
        } else {
          if (!angular.isNumber(scope.options.unsavedChangeCount)) {
            scope.options.unsavedChangeCount = 0;
          }
          if (force) {
            scope.options.unsavedChangeCount = 0;
            scope.dashboardState.save(scope.widgets);
          } else {
            ++scope.options.unsavedChangeCount;
          }
        }
      };

      /**
       * Wraps saveDashboard for external use.
       */
      scope.externalSaveDashboard = function () {
        scope.saveDashboard(true);
      };

      /**
       * Clears current dash and instantiates widget definitions
       * @param  {Array} widgets Array of definition objects
       */
      scope.loadWidgets = function (widgets) {
        // AW dashboards are continuously saved today (no "save" button).
        //scope.defaultWidgets = widgets;
        scope.savedWidgetDefs = widgets;
        scope.clear(true);
        _.each(widgets, function (widgetDef) {
          scope.addWidget(widgetDef, true);
        });
      };

      /**
       * Resets widget instances to default config
       * @return {[type]} [description]
       */
      scope.resetWidgetsToDefault = function () {
        scope.loadWidgets(scope.defaultWidgets);
        scope.saveDashboard();
      };

      // Set default widgets array
      var savedWidgetDefs = scope.dashboardState.load();

      // Success handler
      function handleStateLoad(saved) {
        scope.options.unsavedChangeCount = 0;
        if (saved && saved.length) {
          scope.loadWidgets(saved);
        } else if (scope.defaultWidgets) {
          scope.loadWidgets(scope.defaultWidgets);
        } else {
          scope.clear(true);
        }
      }
      if (angular.isArray(savedWidgetDefs)) {
        handleStateLoad(savedWidgetDefs);
      } else if (savedWidgetDefs && angular.isObject(savedWidgetDefs) && angular.isFunction(savedWidgetDefs.then)) {
        savedWidgetDefs.then(handleStateLoad, handleStateLoad);
      } else {
        handleStateLoad();
      }

      // expose functionality externally
      // functions are appended to the provided dashboard options
      scope.options.addWidget = scope.addWidget;
      scope.options.loadWidgets = scope.loadWidgets;
      scope.options.saveDashboard = scope.externalSaveDashboard;

      // save state
      scope.$on('widgetChanged', function (event) {
        event.stopPropagation();
        scope.saveDashboard();
      });
    }
  };
}]);

/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').directive('dashboardLayouts', ['LayoutStorage', '$timeout', '$modal', function (LayoutStorage, $timeout, $modal) {
  return {
    scope: true,
    templateUrl: function (element, attr) {
      return attr.templateUrl ? attr.templateUrl : 'template/dashboard-layouts.html';
    },
    link: function (scope, element, attrs) {
      scope.options = scope.$eval(attrs.dashboardLayouts);
      var layoutStorage = new LayoutStorage(scope.options);
      scope.layouts = layoutStorage.layouts;
      scope.createNewLayout = function () {
        var newLayout = {
          title: 'Custom',
          defaultWidgets: scope.options.defaultWidgets || []
        };
        layoutStorage.add(newLayout);
        scope.makeLayoutActive(newLayout);
        layoutStorage.save();
        return newLayout;
      };
      scope.removeLayout = function (layout) {
        layoutStorage.remove(layout);
        layoutStorage.save();
      };
      scope.makeLayoutActive = function (layout) {
        var current = layoutStorage.getActiveLayout();
        if (current && current.dashboard.unsavedChangeCount) {
          var modalInstance = $modal.open({
            templateUrl: 'template/save-changes-modal.html',
            resolve: {
              layout: function () {
                return layout;
              }
            },
            controller: 'SaveChangesModalCtrl'
          });

          // Set resolve and reject callbacks for the result promise
          modalInstance.result.then(function () {
            current.dashboard.saveDashboard();
            scope._makeLayoutActive(layout);
          }, function () {
            scope._makeLayoutActive(layout);
          });
        } else {
          scope._makeLayoutActive(layout);
        }
      };
      scope._makeLayoutActive = function (layout) {
        angular.forEach(scope.layouts, function (l) {
          if (l !== layout) {
            l.active = false;
          } else {
            l.active = true;
          }
        });
        layoutStorage.save();
      };
      scope.isActive = function (layout) {
        return !!layout.active;
      };
      scope.editTitle = function (layout) {
        if (layout.locked) {
          return;
        }
        var input = element.find('input[data-layout="' + layout.id + '"]');
        layout.editingTitle = true;
        $timeout(function () {
          input.focus()[0].setSelectionRange(0, 9999);
        });
      };

      // saves whatever is in the title input as the new title
      scope.saveTitleEdit = function (layout) {
        layout.editingTitle = false;
        layoutStorage.save();
      };
      scope.options.saveLayouts = function () {
        layoutStorage.save(true);
      };
      scope.options.addWidget = function () {
        var layout = layoutStorage.getActiveLayout();
        if (layout) {
          layout.dashboard.addWidget.apply(layout.dashboard, arguments);
        }
      };
      scope.options.loadWidgets = function () {
        var layout = layoutStorage.getActiveLayout();
        if (layout) {
          layout.dashboard.loadWidgets.apply(layout.dashboard, arguments);
        }
      };
      scope.options.saveDashboard = function () {
        var layout = layoutStorage.getActiveLayout();
        if (layout) {
          layout.dashboard.saveDashboard.apply(layout.dashboard, arguments);
        }
      };
      var sortableDefaults = {
        stop: function () {
          scope.options.saveLayouts();
        }
      };
      scope.sortableOptions = angular.extend({}, sortableDefaults, scope.options.sortableOptions || {});
    }
  };
}]);
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').directive('widget', ['$injector', function ($injector) {
  return {
    controller: 'DashboardWidgetCtrl',
    link: function (scope) {
      var widget = scope.widget;
      var dataModelType = widget.dataModelType;

      // set up data source
      if (dataModelType) {
        var DataModelConstructor; // data model constructor function

        if (angular.isFunction(dataModelType)) {
          DataModelConstructor = dataModelType;
        } else if (angular.isString(dataModelType)) {
          $injector.invoke([dataModelType, function (DataModelType) {
            DataModelConstructor = DataModelType;
          }]);
        } else {
          throw new Error('widget dataModelType should be function or string');
        }
        var ds;
        if (widget.dataModelArgs) {
          ds = new DataModelConstructor(widget.dataModelArgs);
        } else {
          ds = new DataModelConstructor();
        }
        widget.dataModel = ds;
        ds.setup(widget, scope);
        ds.init();
        scope.$on('$destroy', _.bind(ds.destroy, ds));
      }

      // Compile the widget template, emit add event
      scope.compileTemplate();
      scope.$emit('widgetAdded', widget);
    }
  };
}]);

/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').factory('LayoutStorage', function () {
  var noopStorage = {
    setItem: function () {},
    getItem: function () {},
    removeItem: function () {}
  };
  function LayoutStorage(options) {
    var defaults = {
      storage: noopStorage,
      storageHash: '',
      stringifyStorage: true
    };
    angular.extend(defaults, options);
    angular.extend(options, defaults);
    this.id = options.storageId;
    this.storage = options.storage;
    this.storageHash = options.storageHash;
    this.stringifyStorage = options.stringifyStorage;
    this.widgetDefinitions = options.widgetDefinitions;
    this.defaultLayouts = options.defaultLayouts;
    this.lockDefaultLayouts = options.lockDefaultLayouts;
    this.widgetButtons = options.widgetButtons;
    this.explicitSave = options.explicitSave;
    this.defaultWidgets = options.defaultWidgets;
    this.settingsModalOptions = options.settingsModalOptions;
    this.onSettingsClose = options.onSettingsClose;
    this.onSettingsDismiss = options.onSettingsDismiss;
    this.options = options;
    this.options.unsavedChangeCount = 0;
    this.layouts = [];
    this.states = {};
    this.load();
    this._ensureActiveLayout();
  }
  LayoutStorage.prototype = {
    add: function (layouts) {
      if (!angular.isArray(layouts)) {
        layouts = [layouts];
      }
      var self = this;
      angular.forEach(layouts, function (layout) {
        layout.dashboard = layout.dashboard || {};
        layout.dashboard.storage = self;
        layout.dashboard.storageId = layout.id = self._getLayoutId.call(self, layout);
        layout.dashboard.widgetDefinitions = self.widgetDefinitions;
        layout.dashboard.stringifyStorage = false;
        layout.dashboard.defaultWidgets = layout.defaultWidgets || self.defaultWidgets;
        layout.dashboard.widgetButtons = self.widgetButtons;
        layout.dashboard.explicitSave = self.explicitSave;
        layout.dashboard.settingsModalOptions = self.settingsModalOptions;
        layout.dashboard.onSettingsClose = self.onSettingsClose;
        layout.dashboard.onSettingsDismiss = self.onSettingsDismiss;
        self.layouts.push(layout);
      });
    },
    remove: function (layout) {
      var index = this.layouts.indexOf(layout);
      if (index >= 0) {
        this.layouts.splice(index, 1);
        delete this.states[layout.id];

        // check for active
        if (layout.active && this.layouts.length) {
          var nextActive = index > 0 ? index - 1 : 0;
          this.layouts[nextActive].active = true;
        }
      }
    },
    save: function () {
      var state = {
        layouts: this._serializeLayouts(),
        states: this.states,
        storageHash: this.storageHash
      };
      if (this.stringifyStorage) {
        state = JSON.stringify(state);
      }
      this.storage.setItem(this.id, state);
      this.options.unsavedChangeCount = 0;
    },
    load: function () {
      var serialized = this.storage.getItem(this.id);
      this.clear();
      if (serialized) {
        // check for promise
        if (angular.isObject(serialized) && angular.isFunction(serialized.then)) {
          this._handleAsyncLoad(serialized);
        } else {
          this._handleSyncLoad(serialized);
        }
      } else {
        this._addDefaultLayouts();
      }
    },
    clear: function () {
      this.layouts = [];
      this.states = {};
    },
    setItem: function (id, value) {
      this.states[id] = value;
      this.save();
    },
    getItem: function (id) {
      return this.states[id];
    },
    removeItem: function (id) {
      delete this.states[id];
      this.save();
    },
    getActiveLayout: function () {
      var len = this.layouts.length;
      for (var i = 0; i < len; i++) {
        var layout = this.layouts[i];
        if (layout.active) {
          return layout;
        }
      }
      return false;
    },
    _addDefaultLayouts: function () {
      var self = this;
      var defaults = this.lockDefaultLayouts ? {
        locked: true
      } : {};
      angular.forEach(this.defaultLayouts, function (layout) {
        self.add(angular.extend(_.clone(defaults), layout));
      });
    },
    _serializeLayouts: function () {
      var result = [];
      angular.forEach(this.layouts, function (l) {
        result.push({
          title: l.title,
          id: l.id,
          active: l.active,
          locked: l.locked,
          defaultWidgets: l.dashboard.defaultWidgets
        });
      });
      return result;
    },
    _handleSyncLoad: function (serialized) {
      var deserialized;
      if (this.stringifyStorage) {
        try {
          deserialized = JSON.parse(serialized);
        } catch (e) {
          this._addDefaultLayouts();
          return;
        }
      } else {
        deserialized = serialized;
      }
      if (this.storageHash !== deserialized.storageHash) {
        this._addDefaultLayouts();
        return;
      }
      this.states = deserialized.states;
      this.add(deserialized.layouts);
    },
    _handleAsyncLoad: function (promise) {
      var self = this;
      promise.then(angular.bind(self, this._handleSyncLoad), angular.bind(self, this._addDefaultLayouts));
    },
    _ensureActiveLayout: function () {
      for (var i = 0; i < this.layouts.length; i++) {
        var layout = this.layouts[i];
        if (layout.active) {
          return;
        }
      }
      if (this.layouts[0]) {
        this.layouts[0].active = true;
      }
    },
    _getLayoutId: function (layout) {
      if (layout.id) {
        return layout.id;
      }
      var max = 0;
      for (var i = 0; i < this.layouts.length; i++) {
        var id = this.layouts[i].id;
        max = Math.max(max, id * 1);
      }
      return max + 1;
    }
  };
  return LayoutStorage;
});
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').factory('DashboardState', ['$log', '$q', function ($log, $q) {
  function DashboardState(storage, id, hash, widgetDefinitions, stringify) {
    this.storage = storage;
    this.id = id;
    this.hash = hash;
    this.widgetDefinitions = widgetDefinitions;
    this.stringify = stringify;
  }
  DashboardState.prototype = {
    /**
     * Takes array of widget instance objects, serializes, 
     * and saves state.
     * 
     * @param  {Array} widgets  scope.widgets from dashboard directive
     * @return {Boolean}        true on success, false on failure
     */
    save: function (widgets) {
      if (!this.storage) {
        return true;
      }
      var serialized = _.map(widgets, function (widget) {
        var widgetObject = {
          title: widget.title,
          name: widget.name,
          style: widget.style,
          size: widget.size,
          dataModelOptions: widget.dataModelOptions,
          storageHash: widget.storageHash,
          attrs: widget.attrs
        };
        return widgetObject;
      });
      var item = {
        widgets: serialized,
        hash: this.hash
      };
      if (this.stringify) {
        item = JSON.stringify(item);
      }
      this.storage.setItem(this.id, item);
      return true;
    },
    /**
     * Loads dashboard state from the storage object.
     * Can handle a synchronous response or a promise.
     * 
     * @return {Array|Promise} Array of widget definitions or a promise
     */
    load: function () {
      if (!this.storage) {
        return null;
      }
      var serialized;

      // try loading storage item
      serialized = this.storage.getItem(this.id);
      if (serialized) {
        // check for promise
        if (angular.isObject(serialized) && angular.isFunction(serialized.then)) {
          return this._handleAsyncLoad(serialized);
        }
        // otherwise handle synchronous load
        return this._handleSyncLoad(serialized);
      } else {
        return null;
      }
    },
    _handleSyncLoad: function (serialized) {
      var deserialized,
        result = [];
      if (!serialized) {
        return null;
      }
      if (this.stringify) {
        try {
          // to deserialize the string

          deserialized = JSON.parse(serialized);
        } catch (e) {
          // bad JSON, log a warning and return
          $log.warn('Serialized dashboard state was malformed and could not be parsed: ', serialized);
          return null;
        }
      } else {
        deserialized = serialized;
      }

      // check hash against current hash
      if (deserialized.hash !== this.hash) {
        $log.info('Serialized dashboard from storage was stale (old hash: ' + deserialized.hash + ', new hash: ' + this.hash + ')');
        this.storage.removeItem(this.id);
        return null;
      }

      // Cache widgets
      var savedWidgetDefs = deserialized.widgets;

      // instantiate widgets from stored data
      for (var i = 0; i < savedWidgetDefs.length; i++) {
        // deserialized object
        var savedWidgetDef = savedWidgetDefs[i];

        // widget definition to use
        var widgetDefinition = this.widgetDefinitions.getByName(savedWidgetDef.name);

        // check for no widget
        if (!widgetDefinition) {
          // no widget definition found, remove and return false
          $log.warn('Widget with name "' + savedWidgetDef.name + '" was not found in given widget definition objects');
          continue;
        }

        // check widget-specific storageHash
        if (widgetDefinition.hasOwnProperty('storageHash') && widgetDefinition.storageHash !== savedWidgetDef.storageHash) {
          // widget definition was found, but storageHash was stale, removing storage
          $log.info('Widget Definition Object with name "' + savedWidgetDef.name + '" was found ' + 'but the storageHash property on the widget definition is different from that on the ' + 'serialized widget loaded from storage. hash from storage: "' + savedWidgetDef.storageHash + '"' + ', hash from WDO: "' + widgetDefinition.storageHash + '"');
          continue;
        }

        // push instantiated widget to result array
        result.push(savedWidgetDef);
      }
      return result;
    },
    _handleAsyncLoad: function (promise) {
      var self = this;
      var deferred = $q.defer();
      promise.then(
      // success
      function (res) {
        var result = self._handleSyncLoad(res);
        if (result) {
          deferred.resolve(result);
        } else {
          deferred.reject(result);
        }
      },
      // failure
      function (res) {
        deferred.reject(res);
      });
      return deferred.promise;
    }
  };
  return DashboardState;
}]);
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').factory('WidgetDataModel', function () {
  function WidgetDataModel() {}
  WidgetDataModel.prototype = {
    setup: function (widget, scope) {
      this.dataAttrName = widget.dataAttrName;
      this.dataModelOptions = widget.dataModelOptions;
      this.widgetScope = scope;
    },
    updateScope: function (data) {
      this.widgetScope.widgetData = data;
    },
    init: function () {
      // to be overridden by subclasses
    },
    destroy: function () {
      // to be overridden by subclasses
    }
  };
  return WidgetDataModel;
});
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').factory('WidgetDefCollection', function () {
  function WidgetDefCollection(widgetDefs) {
    this.push.apply(this, widgetDefs);

    // build (name -> widget definition) map for widget lookup by name
    var map = {};
    _.each(widgetDefs, function (widgetDef) {
      map[widgetDef.name] = widgetDef;
    });
    this.map = map;
  }
  WidgetDefCollection.prototype = Object.create(Array.prototype);
  WidgetDefCollection.prototype.getByName = function (name) {
    return this.map[name];
  };
  return WidgetDefCollection;
});
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').factory('WidgetModel', function () {
  // constructor for widget model instances
  function WidgetModel(Class, overrides) {
    var defaults = {
      title: 'Widget',
      name: Class.name,
      attrs: Class.attrs,
      dataAttrName: Class.dataAttrName,
      dataModelType: Class.dataModelType,
      dataModelArgs: Class.dataModelArgs,
      // used in data model constructor, not serialized
      //AW Need deep copy of options to support widget options editing
      dataModelOptions: Class.dataModelOptions,
      settingsModalOptions: Class.settingsModalOptions,
      onSettingsClose: Class.onSettingsClose,
      onSettingsDismiss: Class.onSettingsDismiss,
      style: Class.style || {},
      size: Class.size || {},
      enableVerticalResize: Class.enableVerticalResize === false ? false : true
    };
    overrides = overrides || {};
    angular.extend(this, angular.copy(defaults), overrides);
    this.containerStyle = {
      width: '33%'
    }; // default width
    this.contentStyle = {};
    this.updateContainerStyle(this.style);
    if (Class.templateUrl) {
      this.templateUrl = Class.templateUrl;
    } else if (Class.template) {
      this.template = Class.template;
    } else {
      var directive = Class.directive || Class.name;
      this.directive = directive;
    }
    if (this.size && _.has(this.size, 'height')) {
      this.setHeight(this.size.height);
    }
    if (this.style && _.has(this.style, 'width')) {
      //TODO deprecate style attribute
      this.setWidth(this.style.width);
    }
    if (this.size && _.has(this.size, 'width')) {
      this.setWidth(this.size.width);
    }
  }
  WidgetModel.prototype = {
    // sets the width (and widthUnits)
    setWidth: function (width, units) {
      width = width.toString();
      units = units || width.replace(/^[-\.\d]+/, '') || '%';
      this.widthUnits = units;
      width = parseFloat(width);
      if (width < 0) {
        return false;
      }
      if (units === '%') {
        width = Math.min(100, width);
        width = Math.max(0, width);
      }
      this.containerStyle.width = width + '' + units;
      this.updateSize(this.containerStyle);
      return true;
    },
    setHeight: function (height) {
      this.contentStyle.height = height;
      this.updateSize(this.contentStyle);
    },
    setStyle: function (style) {
      this.style = style;
      this.updateContainerStyle(style);
    },
    updateSize: function (size) {
      angular.extend(this.size, size);
    },
    updateContainerStyle: function (style) {
      angular.extend(this.containerStyle, style);
    }
  };
  return WidgetModel;
});
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').controller('SaveChangesModalCtrl', ['$scope', '$modalInstance', 'layout', function ($scope, $modalInstance, layout) {
  // add layout to scope
  $scope.layout = layout;
  $scope.ok = function () {
    $modalInstance.close();
  };
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
}]);
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').controller('DashboardWidgetCtrl', ['$scope', '$element', '$compile', '$window', '$timeout', function ($scope, $element, $compile, $window, $timeout) {
  $scope.status = {
    isopen: false
  };

  // Fills "container" with compiled view
  $scope.makeTemplateString = function () {
    var widget = $scope.widget;

    // First, build template string
    var templateString = '';
    if (widget.templateUrl) {
      // Use ng-include for templateUrl
      templateString = '<div ng-include="\'' + widget.templateUrl + '\'"></div>';
    } else if (widget.template) {
      // Direct string template
      templateString = widget.template;
    } else {
      // Assume attribute directive
      templateString = '<div ' + widget.directive;

      // Check if data attribute was specified
      if (widget.dataAttrName) {
        widget.attrs = widget.attrs || {};
        widget.attrs[widget.dataAttrName] = 'widgetData';
      }

      // Check for specified attributes
      if (widget.attrs) {
        // First check directive name attr
        if (widget.attrs[widget.directive]) {
          templateString += '="' + widget.attrs[widget.directive] + '"';
        }

        // Add attributes
        _.each(widget.attrs, function (value, attr) {
          // make sure we aren't reusing directive attr
          if (attr !== widget.directive) {
            templateString += ' ' + attr + '="' + value + '"';
          }
        });
      }
      templateString += '></div>';
    }
    return templateString;
  };
  $scope.grabResizer = function (e) {
    var widget = $scope.widget;
    var widgetElm = $element.find('.widget');

    // ignore middle- and right-click
    if (e.which !== 1) {
      return;
    }
    e.stopPropagation();
    e.originalEvent.preventDefault();

    // get the starting horizontal position
    var initX = e.clientX;
    // console.log('initX', initX);

    // Get the current width of the widget and dashboard
    var pixelWidth = widgetElm.width();
    var pixelHeight = widgetElm.height();
    var widgetStyleWidth = widget.containerStyle.width;
    var widthUnits = widget.widthUnits;
    var unitWidth = parseFloat(widgetStyleWidth);

    // create marquee element for resize action
    var $marquee = angular.element('<div class="widget-resizer-marquee" style="height: ' + pixelHeight + 'px; width: ' + pixelWidth + 'px;"></div>');
    widgetElm.append($marquee);

    // determine the unit/pixel ratio
    var transformMultiplier = unitWidth / pixelWidth;

    // updates marquee with preview of new width
    var mousemove = function (e) {
      var curX = e.clientX;
      var pixelChange = curX - initX;
      var newWidth = pixelWidth + pixelChange;
      $marquee.css('width', newWidth + 'px');
    };

    // sets new widget width on mouseup
    var mouseup = function (e) {
      // remove listener and marquee
      jQuery($window).off('mousemove', mousemove);
      $marquee.remove();

      // calculate change in units
      var curX = e.clientX;
      var pixelChange = curX - initX;
      var unitChange = Math.round(pixelChange * transformMultiplier * 100) / 100;

      // add to initial unit width
      var newWidth = unitWidth * 1 + unitChange;
      widget.setWidth(newWidth + widthUnits);
      $scope.$emit('widgetChanged', widget);
      $scope.$apply();
      $scope.$broadcast('widgetResized', {
        width: newWidth
      });
    };
    jQuery($window).on('mousemove', mousemove).one('mouseup', mouseup);
  };

  //TODO refactor
  $scope.grabSouthResizer = function (e) {
    var widgetElm = $element.find('.widget');

    // ignore middle- and right-click
    if (e.which !== 1) {
      return;
    }
    e.stopPropagation();
    e.originalEvent.preventDefault();

    // get the starting horizontal position
    var initY = e.clientY;
    // console.log('initX', initX);

    // Get the current width of the widget and dashboard
    var pixelWidth = widgetElm.width();
    var pixelHeight = widgetElm.height();

    // create marquee element for resize action
    var $marquee = angular.element('<div class="widget-resizer-marquee" style="height: ' + pixelHeight + 'px; width: ' + pixelWidth + 'px;"></div>');
    widgetElm.append($marquee);

    // updates marquee with preview of new height
    var mousemove = function (e) {
      var curY = e.clientY;
      var pixelChange = curY - initY;
      var newHeight = pixelHeight + pixelChange;
      $marquee.css('height', newHeight + 'px');
    };

    // sets new widget width on mouseup
    var mouseup = function (e) {
      // remove listener and marquee
      jQuery($window).off('mousemove', mousemove);
      $marquee.remove();

      // calculate height change
      var curY = e.clientY;
      var pixelChange = curY - initY;

      //var widgetContainer = widgetElm.parent(); // widget container responsible for holding widget width and height
      var widgetContainer = widgetElm.find('.widget-content');
      var diff = pixelChange;
      var height = parseInt(widgetContainer.css('height'), 10);
      var newHeight = height + diff;

      //$scope.widget.style.height = newHeight + 'px';

      $scope.widget.setHeight(newHeight + 'px');
      $scope.$emit('widgetChanged', $scope.widget);
      $scope.$apply(); // make AngularJS to apply style changes

      $scope.$broadcast('widgetResized', {
        height: newHeight
      });
    };
    jQuery($window).on('mousemove', mousemove).one('mouseup', mouseup);
  };

  // replaces widget title with input
  $scope.editTitle = function (widget) {
    var widgetElm = $element.find('.widget');
    widget.editingTitle = true;
    // HACK: get the input to focus after being displayed.
    $timeout(function () {
      widgetElm.find('form.widget-title input:eq(0)').focus()[0].setSelectionRange(0, 9999);
    });
  };

  // saves whatever is in the title input as the new title
  $scope.saveTitleEdit = function (widget) {
    widget.editingTitle = false;
    $scope.$emit('widgetChanged', widget);
  };
  $scope.compileTemplate = function () {
    var container = $scope.findWidgetContainer($element);
    var templateString = $scope.makeTemplateString();
    var widgetElement = angular.element(templateString);
    container.empty();
    container.append(widgetElement);
    $compile(widgetElement)($scope);
  };
  $scope.findWidgetContainer = function (element) {
    // widget placeholder is the first (and only) child of .widget-content
    return element.find('.widget-content');
  };
}]);
/*
 * Copyright (c) 2014 DataTorrent, Inc. ALL Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
angular.module('ui.dashboard').controller('WidgetSettingsCtrl', ['$scope', '$modalInstance', 'widget', function ($scope, $modalInstance, widget) {
  // add widget to scope
  $scope.widget = widget;

  // set up result object
  $scope.result = jQuery.extend(true, {}, widget);
  $scope.ok = function () {
    $modalInstance.close($scope.result);
  };
  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };
}]);
angular.module("ui.dashboard").run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/alt-dashboard.html", "<div>\n" + "    <div class=\"btn-toolbar\" ng-if=\"!options.hideToolbar\">\n" + "        <div class=\"btn-group\" ng-if=\"!options.widgetButtons\">\n" + "            <span class=\"dropdown\" on-toggle=\"toggled(open)\">\n" + "              <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-disabled=\"disabled\">\n" + "                Button dropdown <span class=\"caret\"></span>\n" + "              </button>\n" + "              <ul class=\"dropdown-menu\" role=\"menu\">\n" + "                <li ng-repeat=\"widget in widgetDefs\">\n" + "                  <a href=\"#\" ng-click=\"addWidgetInternal($event, widget);\" class=\"dropdown-toggle\">{{widget.name}}</a>\n" + "                </li>\n" + "              </ul>\n" + "            </span>\n" + "        </div>\n" + "\n" + "        <div class=\"btn-group\" ng-if=\"options.widgetButtons\">\n" + "            <button ng-repeat=\"widget in widgetDefs\"\n" + "                    ng-click=\"addWidgetInternal($event, widget);\" type=\"button\" class=\"btn btn-primary\">\n" + "                {{widget.name}}\n" + "            </button>\n" + "        </div>\n" + "\n" + "        <button class=\"btn btn-warning\" ng-click=\"resetWidgetsToDefault()\">Default Widgets</button>\n" + "\n" + "        <button ng-if=\"options.storage && options.explicitSave\" ng-click=\"options.saveDashboard()\" class=\"btn btn-success\" ng-hide=\"!options.unsavedChangeCount\">{{ !options.unsavedChangeCount ? \"Alternative - No Changes\" : \"Save\" }}</button>\n" + "\n" + "        <button ng-click=\"clear();\" ng-hide=\"!widgets.length\" type=\"button\" class=\"btn btn-info\">Clear</button>\n" + "    </div>\n" + "\n" + "    <div ui-sortable=\"sortableOptions\" ng-model=\"widgets\" class=\"dashboard-widget-area\">\n" + "        <div ng-repeat=\"widget in widgets\" ng-style=\"widget.style\" class=\"widget-container\" widget>\n" + "            <div class=\"widget panel panel-default\">\n" + "                <div class=\"widget-header panel-heading\">\n" + "                    <h3 class=\"panel-title\">\n" + "                        <span class=\"widget-title\" ng-dblclick=\"editTitle(widget)\" ng-hide=\"widget.editingTitle\">{{widget.title}}</span>\n" + "                        <form action=\"\" class=\"widget-title\" ng-show=\"widget.editingTitle\" ng-submit=\"saveTitleEdit(widget)\">\n" + "                            <input type=\"text\" ng-model=\"widget.title\" class=\"form-control\">\n" + "                        </form>\n" + "                        <span class=\"label label-primary\" ng-if=\"!options.hideWidgetName\">{{widget.name}}</span>\n" + "                        <span ng-click=\"removeWidget(widget);\" class=\"glyphicon glyphicon-remove\" ng-if=\"!options.hideWidgetClose\"></span>\n" + "                        <span ng-click=\"openWidgetSettings(widget);\" class=\"glyphicon glyphicon-cog\" ng-if=\"!options.hideWidgetSettings\"></span>\n" + "                    </h3>\n" + "                </div>\n" + "                <div class=\"panel-body widget-content\"></div>\n" + "                <div class=\"widget-ew-resizer\" ng-mousedown=\"grabResizer($event)\"></div>\n" + "            </div>\n" + "        </div>\n" + "    </div>\n" + "</div>\n");
  $templateCache.put("template/dashboard-layouts.html", "<ul ui-sortable=\"sortableOptions\" ng-model=\"layouts\" class=\"nav nav-tabs layout-tabs\">\n" + "    <li ng-repeat=\"layout in layouts\" ng-class=\"{ active: layout.active }\">\n" + "        <a ng-click=\"makeLayoutActive(layout)\">\n" + "            <span ng-dblclick=\"editTitle(layout)\" ng-show=\"!layout.editingTitle\">{{layout.title}}</span>\n" + "            <form action=\"\" class=\"layout-title\" ng-show=\"layout.editingTitle\" ng-submit=\"saveTitleEdit(layout)\">\n" + "                <input type=\"text\" ng-model=\"layout.title\" class=\"form-control\" data-layout=\"{{layout.id}}\">\n" + "            </form>\n" + "            <span ng-if=\"!layout.locked\" ng-click=\"removeLayout(layout)\" class=\"glyphicon glyphicon-remove remove-layout-icon\"></span>\n" + "            <!-- <span class=\"glyphicon glyphicon-pencil\"></span> -->\n" + "            <!-- <span class=\"glyphicon glyphicon-remove\"></span> -->\n" + "        </a>\n" + "    </li>\n" + "    <li>\n" + "        <a ng-click=\"createNewLayout()\">\n" + "            <span class=\"glyphicon glyphicon-plus\"></span>\n" + "        </a>\n" + "    </li>\n" + "</ul>\n" + "<div ng-repeat=\"layout in layouts | filter:isActive\" dashboard=\"layout.dashboard\" template-url=\"template/dashboard.html\"></div>");
  $templateCache.put("template/dashboard.html", "<div>\n" + "    <div class=\"btn-toolbar\" ng-if=\"!options.hideToolbar\">\n" + "        <div class=\"btn-group\" ng-if=\"!options.widgetButtons\">\n" + "            <span class=\"dropdown\" on-toggle=\"toggled(open)\">\n" + "              <button type=\"button\" class=\"btn btn-primary dropdown-toggle\" ng-disabled=\"disabled\">\n" + "                Button dropdown <span class=\"caret\"></span>\n" + "              </button>\n" + "              <ul class=\"dropdown-menu\" role=\"menu\">\n" + "                <li ng-repeat=\"widget in widgetDefs\">\n" + "                  <a href=\"#\" ng-click=\"addWidgetInternal($event, widget);\" class=\"dropdown-toggle\"><span class=\"label label-primary\">{{widget.name}}</span></a>\n" + "                </li>\n" + "              </ul>\n" + "            </span>\n" + "    </div>\n" + "        <div class=\"btn-group\" ng-if=\"options.widgetButtons\">\n" + "            <button ng-repeat=\"widget in widgetDefs\"\n" + "                    ng-click=\"addWidgetInternal($event, widget);\" type=\"button\" class=\"btn btn-primary\">\n" + "                {{widget.name}}\n" + "            </button>\n" + "        </div>\n" + "\n" + "        <button class=\"btn btn-warning\" ng-click=\"resetWidgetsToDefault()\">Default Widgets</button>\n" + "\n" + "        <button ng-if=\"options.storage && options.explicitSave\" ng-click=\"options.saveDashboard()\" class=\"btn btn-success\" ng-disabled=\"!options.unsavedChangeCount\">{{ !options.unsavedChangeCount ? \"all saved\" : \"save changes (\" + options.unsavedChangeCount + \")\" }}</button>\n" + "\n" + "        <button ng-click=\"clear();\" type=\"button\" class=\"btn btn-info\">Clear</button>\n" + "    </div>\n" + "\n" + "    <div ui-sortable=\"sortableOptions\" ng-model=\"widgets\" class=\"dashboard-widget-area\">\n" + "        <div ng-repeat=\"widget in widgets\" ng-style=\"widget.containerStyle\" class=\"widget-container\" widget>\n" + "            <div class=\"widget panel panel-default\">\n" + "                <div class=\"widget-header panel-heading\">\n" + "                    <h3 class=\"panel-title\">\n" + "                        <span class=\"widget-title\" ng-dblclick=\"editTitle(widget)\" ng-hide=\"widget.editingTitle\">{{widget.title}}</span>\n" + "                        <form action=\"\" class=\"widget-title\" ng-show=\"widget.editingTitle\" ng-submit=\"saveTitleEdit(widget)\">\n" + "                            <input type=\"text\" ng-model=\"widget.title\" class=\"form-control\">\n" + "                        </form>\n" + "                        <span class=\"label label-primary\" ng-if=\"!options.hideWidgetName\">{{widget.name}}</span>\n" + "                        <span ng-click=\"removeWidget(widget);\" class=\"glyphicon glyphicon-remove\" ng-if=\"!options.hideWidgetClose\"></span>\n" + "                        <span ng-click=\"openWidgetSettings(widget);\" class=\"glyphicon glyphicon-cog\" ng-if=\"!options.hideWidgetSettings\"></span>\n" + "                    </h3>\n" + "                </div>\n" + "                <div class=\"panel-body widget-content\" ng-style=\"widget.contentStyle\"></div>\n" + "                <div class=\"widget-ew-resizer\" ng-mousedown=\"grabResizer($event)\"></div>\n" + "                <div ng-if=\"widget.enableVerticalResize\" class=\"widget-s-resizer\" ng-mousedown=\"grabSouthResizer($event)\"></div>\n" + "            </div>\n" + "        </div>\n" + "    </div>\n" + "</div>");
  $templateCache.put("template/save-changes-modal.html", "<div class=\"modal-header\">\n" + "    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n" + "  <h3>Unsaved Changes to \"{{layout.title}}\"</h3>\n" + "</div>\n" + "\n" + "<div class=\"modal-body\">\n" + "    <p>You have {{layout.dashboard.unsavedChangeCount}} unsaved changes on this dashboard. Would you like to save them?</p>\n" + "</div>\n" + "\n" + "<div class=\"modal-footer\">\n" + "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">Don't Save</button>\n" + "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">Save</button>\n" + "</div>");
  $templateCache.put("template/widget-default-content.html", "");
  $templateCache.put("template/widget-settings-template.html", "<div class=\"modal-header\">\n" + "    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n" + "  <h3>Widget Options <small>{{widget.title}}</small></h3>\n" + "</div>\n" + "\n" + "<div class=\"modal-body\">\n" + "    <form name=\"form\" novalidate class=\"form-horizontal\">\n" + "        <div class=\"form-group\">\n" + "            <label for=\"widgetTitle\" class=\"col-sm-2 control-label\">Title</label>\n" + "            <div class=\"col-sm-10\">\n" + "                <input type=\"text\" class=\"form-control\" name=\"widgetTitle\" ng-model=\"result.title\">\n" + "            </div>\n" + "        </div>\n" + "        <div ng-if=\"widget.settingsModalOptions.partialTemplateUrl\"\n" + "             ng-include=\"widget.settingsModalOptions.partialTemplateUrl\"></div>\n" + "    </form>\n" + "</div>\n" + "\n" + "<div class=\"modal-footer\">\n" + "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button>\n" + "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">OK</button>\n" + "</div>");
}]);
/*!
 * angular-translate - v2.13.1 - 2016-12-06
 * 
 * Copyright (c) 2016 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["messageformat"], function (a0) {
      return factory(a0);
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("messageformat"));
  } else {
    factory(root["MessageFormat"]);
  }
})(this, function (MessageFormat) {
  angular.module('pascalprecht.translate')

  /**
   * @ngdoc property
   * @name pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
   * @requires TRANSLATE_MF_INTERPOLATION_CACHE
   *
   * @description
   * Uses MessageFormat.js to interpolate strings against some values.
   */.constant('TRANSLATE_MF_INTERPOLATION_CACHE', '$translateMessageFormatInterpolation')

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider
   *
   * @description
   * Configurations for $translateMessageFormatInterpolation
   */.provider('$translateMessageFormatInterpolation', $translateMessageFormatInterpolationProvider);
  function $translateMessageFormatInterpolationProvider() {
    'use strict';

    var configurer;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider#messageFormatConfigurer
     * @methodOf pascalprecht.translate.$translateMessageFormatInterpolationProvider
     *
     * @description
     * Defines an optional configurer for the MessageFormat instance.
     *
     * Note: This hook will be called whenever a new instance of MessageFormat will be created.
     *
     * @param {function} fn callback with the instance as argument
     */
    this.messageFormatConfigurer = function (fn) {
      configurer = fn;
    };

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateMessageFormatInterpolation
     * @requires pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
     *
     * @description
     * Uses MessageFormat.js to interpolate strings against some values.
     *
     * Be aware to configure a proper sanitization strategy.
     *
     * See also:
     * * {@link pascalprecht.translate.$translateSanitization}
     * * {@link https://github.com/SlexAxton/messageformat.js}
     *
     * @return {object} $translateMessageFormatInterpolation Interpolator service
     */
    this.$get = ['$translateSanitization', '$cacheFactory', 'TRANSLATE_MF_INTERPOLATION_CACHE', function ($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE) {
      return $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, configurer);
    }];
  }
  function $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, messageFormatConfigurer) {
    'use strict';

    var $translateInterpolator = {},
      $cache = $cacheFactory.get(TRANSLATE_MF_INTERPOLATION_CACHE),
      // instantiate with default locale (which is 'en')
      $mf = new MessageFormat('en'),
      $identifier = 'messageformat';
    if (angular.isFunction(messageFormatConfigurer)) {
      messageFormatConfigurer($mf);
    }
    if (!$cache) {
      // create cache if it doesn't exist already
      $cache = $cacheFactory(TRANSLATE_MF_INTERPOLATION_CACHE);
    }
    $cache.put('en', $mf);

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateMessageFormatInterpolation#setLocale
     * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
     *
     * @description
     * Sets current locale (this is currently not use in this interpolation).
     *
     * @param {string} locale Language key or locale.
     */
    $translateInterpolator.setLocale = function (locale) {
      $mf = $cache.get(locale);
      if (!$mf) {
        $mf = new MessageFormat(locale);
        if (angular.isFunction(messageFormatConfigurer)) {
          messageFormatConfigurer($mf);
        }
        $cache.put(locale, $mf);
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateMessageFormatInterpolation#getInterpolationIdentifier
     * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
     *
     * @description
     * Returns an identifier for this interpolation service.
     *
     * @returns {string} $identifier
     */
    $translateInterpolator.getInterpolationIdentifier = function () {
      return $identifier;
    };

    /**
     * @deprecated will be removed in 3.0
     * @see {@link pascalprecht.translate.$translateSanitization}
     */
    $translateInterpolator.useSanitizeValueStrategy = function (value) {
      $translateSanitization.useStrategy(value);
      return this;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateMessageFormatInterpolation#interpolate
     * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
     *
     * @description
     * Interpolates given string against given interpolate params using MessageFormat.js.
     *
     * @returns {string} interpolated string.
     */
    $translateInterpolator.interpolate = function (string, interpolationParams, context, sanitizeStrategy) {
      interpolationParams = interpolationParams || {};
      interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy);
      var compiledFunction = $cache.get('mf:' + string);

      // if given string wasn't compiled yet, we do so now and never have to do it again
      if (!compiledFunction) {
        // Ensure explicit type if possible
        // MessageFormat checks the actual type (i.e. for amount based conditions)
        for (var key in interpolationParams) {
          if (interpolationParams.hasOwnProperty(key)) {
            // ensure number
            var number = parseInt(interpolationParams[key], 10);
            if (angular.isNumber(number) && '' + number === interpolationParams[key]) {
              interpolationParams[key] = number;
            }
          }
        }
        compiledFunction = $mf.compile(string);
        $cache.put('mf:' + string, compiledFunction);
      }
      var interpolatedText = compiledFunction(interpolationParams);
      return $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy);
    };
    return $translateInterpolator;
  }
  $translateMessageFormatInterpolation.displayName = '$translateMessageFormatInterpolation';
  return 'pascalprecht.translate';
});
/*!
 * ui-grid - v4.12.7 - 2024-04-12
* http://ui-grid.info/
 * Copyright (c) 2024 ; License: MIT 
 */(function(){'use strict';angular.module('ui.grid.i18n',[]);angular.module('ui.grid',['ui.grid.i18n']);})();(function(){'use strict';/**
   *  @ngdoc overview
   *  @name ui.grid.autoResize
   *
   *  @description
   *
   *  #ui.grid.autoResize
   *
   *  <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
   *
   *  This module provides auto-resizing functionality to UI-Grid.
   */var module=angular.module('ui.grid.autoResize',['ui.grid']);/**
   *  @ngdoc directive
   *  @name ui.grid.autoResize.directive:uiGridAutoResize
   *  @element div
   *  @restrict A
   *
   *  @description Stacks on top of the ui-grid directive and
   *  adds the a watch to the grid's height and width which refreshes
   *  the grid content whenever its dimensions change.
   *
   */module.directive('uiGridAutoResize',['gridUtil',function(gridUtil){return{require:'uiGrid',scope:false,link:function($scope,$elm,$attrs,uiGridCtrl){var debouncedRefresh;function getDimensions(){return{width:gridUtil.elementWidth($elm),height:gridUtil.elementHeight($elm)};}function refreshGrid(prevWidth,prevHeight,width,height){if($elm[0].offsetParent!==null){uiGridCtrl.grid.gridWidth=width;uiGridCtrl.grid.gridHeight=height;uiGridCtrl.grid.queueGridRefresh().then(function(){uiGridCtrl.grid.api.core.raise.gridDimensionChanged(prevHeight,prevWidth,height,width);});}}debouncedRefresh=gridUtil.debounce(refreshGrid,400);$scope.$watchCollection(getDimensions,function(newValues,oldValues){if(!angular.equals(newValues,oldValues)){debouncedRefresh(oldValues.width,oldValues.height,newValues.width,newValues.height);}});}};}]);})();(function(){'use strict';/**
   *  @ngdoc overview
   *  @name ui.grid.cellNav
   *
   *  @description

      #ui.grid.cellNav

      <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>

      This module provides cell navigation functionality to UI-Grid.
   */var module=angular.module('ui.grid.cellNav',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.cellNav.constant:uiGridCellNavConstants
   *
   *  @description constants available in cellNav
   */module.constant('uiGridCellNavConstants',{FEATURE_NAME:'gridCellNav',CELL_NAV_EVENT:'cellNav',direction:{LEFT:0,RIGHT:1,UP:2,DOWN:3,PG_UP:4,PG_DOWN:5},EVENT_TYPE:{KEYDOWN:0,CLICK:1,CLEAR:2}});module.factory('uiGridCellNavFactory',['uiGridCellNavConstants','GridRowColumn',function(uiGridCellNavConstants,GridRowColumn){/**
       *  @ngdoc object
       *  @name ui.grid.cellNav.object:CellNav
       *  @description returns a CellNav prototype function
       *  @param {object} rowContainer container for rows
       *  @param {object} colContainer parent column container
       *  @param {object} leftColContainer column container to the left of parent
       *  @param {object} rightColContainer column container to the right of parent
       */var UiGridCellNav=function UiGridCellNav(rowContainer,colContainer,leftColContainer,rightColContainer){this.rows=rowContainer.visibleRowCache;this.columns=colContainer.visibleColumnCache;this.leftColumns=leftColContainer?leftColContainer.visibleColumnCache:[];this.rightColumns=rightColContainer?rightColContainer.visibleColumnCache:[];this.bodyContainer=rowContainer;};/** returns focusable columns of all containers */UiGridCellNav.prototype.getFocusableCols=function(){var allColumns=this.leftColumns.concat(this.columns,this.rightColumns);return allColumns.filter(function(col){return col.colDef.allowCellFocus;});};/**
       *  @ngdoc object
       *  @name ui.grid.cellNav.api:GridRow
       *
       *  @description GridRow settings for cellNav feature, these are available to be
       *  set only internally (for example, by other features)
       */ /**
       *  @ngdoc object
       *  @name allowCellFocus
       *  @propertyOf  ui.grid.cellNav.api:GridRow
       *  @description Enable focus on a cell within this row.  If set to false then no cells
       *  in this row can be focused - group header rows as an example would set this to false.
       *  <br/>Defaults to true
       */ /** returns focusable rows */UiGridCellNav.prototype.getFocusableRows=function(){return this.rows.filter(function(row){return row.allowCellFocus!==false;});};UiGridCellNav.prototype.getNextRowCol=function(direction,curRow,curCol){switch(direction){case uiGridCellNavConstants.direction.LEFT:return this.getRowColLeft(curRow,curCol);case uiGridCellNavConstants.direction.RIGHT:return this.getRowColRight(curRow,curCol);case uiGridCellNavConstants.direction.UP:return this.getRowColUp(curRow,curCol);case uiGridCellNavConstants.direction.DOWN:return this.getRowColDown(curRow,curCol);case uiGridCellNavConstants.direction.PG_UP:return this.getRowColPageUp(curRow,curCol);case uiGridCellNavConstants.direction.PG_DOWN:return this.getRowColPageDown(curRow,curCol);}};UiGridCellNav.prototype.initializeSelection=function(){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();if(focusableCols.length===0||focusableRows.length===0){return null;}return new GridRowColumn(focusableRows[0],focusableCols[0]);// return same row
};UiGridCellNav.prototype.getRowColLeft=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 1
if(curColIndex===-1){curColIndex=1;}var nextColIndex=curColIndex===0?focusableCols.length-1:curColIndex-1;// get column to left
if(nextColIndex>=curColIndex){// On the first row
// if (curRowIndex === 0 && curColIndex === 0) {
//   return null;
// }
if(curRowIndex===0){return new GridRowColumn(curRow,focusableCols[nextColIndex]);// return same row
}else{// up one row and far right column
return new GridRowColumn(focusableRows[curRowIndex-1],focusableCols[nextColIndex]);}}else{return new GridRowColumn(curRow,focusableCols[nextColIndex]);}};UiGridCellNav.prototype.getRowColRight=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 0
if(curColIndex===-1){curColIndex=0;}var nextColIndex=curColIndex===focusableCols.length-1?0:curColIndex+1;if(nextColIndex<=curColIndex){if(curRowIndex===focusableRows.length-1){return new GridRowColumn(curRow,focusableCols[nextColIndex]);// return same row
}else{// down one row and far left column
return new GridRowColumn(focusableRows[curRowIndex+1],focusableCols[nextColIndex]);}}else{return new GridRowColumn(curRow,focusableCols[nextColIndex]);}};UiGridCellNav.prototype.getRowColDown=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 0
if(curColIndex===-1){curColIndex=0;}if(curRowIndex===focusableRows.length-1){return new GridRowColumn(curRow,focusableCols[curColIndex]);// return same row
}else{// down one row
return new GridRowColumn(focusableRows[curRowIndex+1],focusableCols[curColIndex]);}};UiGridCellNav.prototype.getRowColPageDown=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 0
if(curColIndex===-1){curColIndex=0;}var pageSize=this.bodyContainer.minRowsToRender();if(curRowIndex>=focusableRows.length-pageSize){return new GridRowColumn(focusableRows[focusableRows.length-1],focusableCols[curColIndex]);// return last row
}else{// down one page
return new GridRowColumn(focusableRows[curRowIndex+pageSize],focusableCols[curColIndex]);}};UiGridCellNav.prototype.getRowColUp=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 0
if(curColIndex===-1){curColIndex=0;}if(curRowIndex===0){return new GridRowColumn(curRow,focusableCols[curColIndex]);// return same row
}else{// up one row
return new GridRowColumn(focusableRows[curRowIndex-1],focusableCols[curColIndex]);}};UiGridCellNav.prototype.getRowColPageUp=function(curRow,curCol){var focusableCols=this.getFocusableCols();var focusableRows=this.getFocusableRows();var curColIndex=focusableCols.indexOf(curCol);var curRowIndex=focusableRows.indexOf(curRow);// could not find column in focusable Columns so set it to 0
if(curColIndex===-1){curColIndex=0;}var pageSize=this.bodyContainer.minRowsToRender();if(curRowIndex-pageSize<0){return new GridRowColumn(focusableRows[0],focusableCols[curColIndex]);// return first row
}else{// up one page
return new GridRowColumn(focusableRows[curRowIndex-pageSize],focusableCols[curColIndex]);}};return UiGridCellNav;}]);/**
   *  @ngdoc service
   *  @name ui.grid.cellNav.service:uiGridCellNavService
   *
   *  @description Services for cell navigation features. If you don't like the key maps we use,
   *  or the direction cells navigation, override with a service decorator (see angular docs)
   */module.service('uiGridCellNavService',['uiGridConstants','uiGridCellNavConstants','$q','uiGridCellNavFactory',function(uiGridConstants,uiGridCellNavConstants,$q,UiGridCellNav){var service={initializeGrid:function(grid){grid.registerColumnBuilder(service.cellNavColumnBuilder);/**
           * @ngdoc object
           * @name ui.grid.cellNav.Grid:cellNav
           * @description cellNav properties added to grid class
           */grid.cellNav={};grid.cellNav.lastRowCol=null;grid.cellNav.focusedCells=[];service.defaultGridOptions(grid.options);/**
           *  @ngdoc object
           *  @name ui.grid.cellNav.api:PublicApi
           *
           *  @description Public Api for cellNav feature
           */var publicApi={events:{cellNav:{/**
                 * @ngdoc event
                 * @name navigate
                 * @eventOf  ui.grid.cellNav.api:PublicApi
                 * @description raised when the active cell is changed
                 * <pre>
                 *      gridApi.cellNav.on.navigate(scope,function(newRowcol, oldRowCol) {})
                 * </pre>
                 * @param {object} newRowCol new position
                 * @param {object} oldRowCol old position
                 */navigate:function(newRowCol,oldRowCol){},/**
                 * @ngdoc event
                 * @name viewPortKeyDown
                 * @eventOf  ui.grid.cellNav.api:PublicApi
                 * @description  is raised when the viewPort receives a keyDown event. Cells never get focus in uiGrid
                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
                 * event whenever you need a keydown event on a cell
                 * <br/>
                 * @param {object} event keydown event
                 * @param {object} rowCol current rowCol position
                 */viewPortKeyDown:function(event,rowCol){},/**
                 * @ngdoc event
                 * @name viewPortKeyPress
                 * @eventOf  ui.grid.cellNav.api:PublicApi
                 * @description  is raised when the viewPort receives a keyPress event. Cells never get focus in uiGrid
                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
                 * event whenever you need a keypress event on a cell
                 * <br/>
                 * @param {object} event keypress event
                 * @param {object} rowCol current rowCol position
                 */viewPortKeyPress:function(event,rowCol){}}},methods:{cellNav:{/**
                 * @ngdoc function
                 * @name scrollToFocus
                 * @methodOf  ui.grid.cellNav.api:PublicApi
                 * @description brings the specified row and column into view, and sets focus
                 * to that cell
                 * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus
                 * @param {object} colDef to make visible and set focus
                 * @returns {promise} a promise that is resolved after any scrolling is finished
                 */scrollToFocus:function(rowEntity,colDef){return service.scrollToFocus(grid,rowEntity,colDef);},/**
                 * @ngdoc function
                 * @name getFocusedCell
                 * @methodOf  ui.grid.cellNav.api:PublicApi
                 * @description returns the current (or last if Grid does not have focus) focused row and column
                 * <br> value is null if no selection has occurred
                 */getFocusedCell:function(){return grid.cellNav.lastRowCol;},/**
                 * @ngdoc function
                 * @name getCurrentSelection
                 * @methodOf  ui.grid.cellNav.api:PublicApi
                 * @description returns an array containing the current selection
                 * <br> array is empty if no selection has occurred
                 */getCurrentSelection:function(){return grid.cellNav.focusedCells;},/**
                 * @ngdoc function
                 * @name rowColSelectIndex
                 * @methodOf  ui.grid.cellNav.api:PublicApi
                 * @description returns the index in the order in which the GridRowColumn was selected, returns -1 if the GridRowColumn
                 * isn't selected
                 * @param {object} rowCol the rowCol to evaluate
                 */rowColSelectIndex:function(rowCol){// return gridUtil.arrayContainsObjectWithProperty(grid.cellNav.focusedCells, 'col.uid', rowCol.col.uid) &&
var index=-1;for(var i=0;i<grid.cellNav.focusedCells.length;i++){if(grid.cellNav.focusedCells[i].col.uid===rowCol.col.uid&&grid.cellNav.focusedCells[i].row.uid===rowCol.row.uid){index=i;break;}}return index;}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){/**
           *  @ngdoc object
           *  @name ui.grid.cellNav.api:GridOptions
           *
           *  @description GridOptions for cellNav feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           *  @ngdoc object
           *  @name modifierKeysToMultiSelectCells
           *  @propertyOf  ui.grid.cellNav.api:GridOptions
           *  @description Enable multiple cell selection only when using the ctrlKey or shiftKey.
           *  <br/>Defaults to false
           */gridOptions.modifierKeysToMultiSelectCells=gridOptions.modifierKeysToMultiSelectCells===true;/**
           *  @ngdoc array
           *  @name keyDownOverrides
           *  @propertyOf  ui.grid.cellNav.api:GridOptions
           *  @description An array of event objects to override on keydown. If an event is overridden, the viewPortKeyDown event will
           *               be raised with the overridden events, allowing custom keydown behavior.
           *  <br/>Defaults to []
           */gridOptions.keyDownOverrides=gridOptions.keyDownOverrides||[];},/**
         * @ngdoc service
         * @name decorateRenderContainers
         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
         * @description  decorates grid renderContainers with cellNav functions
         */decorateRenderContainers:function(grid){var rightContainer=grid.hasRightContainer()?grid.renderContainers.right:null;var leftContainer=grid.hasLeftContainer()?grid.renderContainers.left:null;if(leftContainer!==null){grid.renderContainers.left.cellNav=new UiGridCellNav(grid.renderContainers.body,leftContainer,rightContainer,grid.renderContainers.body);}if(rightContainer!==null){grid.renderContainers.right.cellNav=new UiGridCellNav(grid.renderContainers.body,rightContainer,grid.renderContainers.body,leftContainer);}grid.renderContainers.body.cellNav=new UiGridCellNav(grid.renderContainers.body,grid.renderContainers.body,leftContainer,rightContainer);},/**
         * @ngdoc service
         * @name getDirection
         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
         * @description  determines which direction to for a given keyDown event
         * @returns {uiGridCellNavConstants.direction} direction
         */getDirection:function(evt){if(evt.keyCode===uiGridConstants.keymap.LEFT||evt.keyCode===uiGridConstants.keymap.TAB&&evt.shiftKey){return uiGridCellNavConstants.direction.LEFT;}if(evt.keyCode===uiGridConstants.keymap.RIGHT||evt.keyCode===uiGridConstants.keymap.TAB){return uiGridCellNavConstants.direction.RIGHT;}if(evt.keyCode===uiGridConstants.keymap.UP||evt.keyCode===uiGridConstants.keymap.ENTER&&evt.shiftKey){return uiGridCellNavConstants.direction.UP;}if(evt.keyCode===uiGridConstants.keymap.PG_UP){return uiGridCellNavConstants.direction.PG_UP;}if(evt.keyCode===uiGridConstants.keymap.DOWN||evt.keyCode===uiGridConstants.keymap.ENTER&&!(evt.ctrlKey||evt.altKey)){return uiGridCellNavConstants.direction.DOWN;}if(evt.keyCode===uiGridConstants.keymap.PG_DOWN){return uiGridCellNavConstants.direction.PG_DOWN;}return null;},/**
         * @ngdoc service
         * @name cellNavColumnBuilder
         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
         * @description columnBuilder function that adds cell navigation properties to grid column
         * @returns {promise} promise that will load any needed templates when resolved
         */cellNavColumnBuilder:function(colDef,col,gridOptions){var promises=[];/**
           *  @ngdoc object
           *  @name ui.grid.cellNav.api:ColumnDef
           *
           *  @description Column Definitions for cellNav feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
           */ /**
           *  @ngdoc object
           *  @name allowCellFocus
           *  @propertyOf  ui.grid.cellNav.api:ColumnDef
           *  @description Enable focus on a cell within this column.
           *  <br/>Defaults to true
           */colDef.allowCellFocus=colDef.allowCellFocus===undefined?true:colDef.allowCellFocus;return $q.all(promises);},/**
         * @ngdoc method
         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
         * @name scrollToFocus
         * @description Scroll the grid such that the specified
         * row and column is in view, and set focus to the cell in that row and column
         * @param {Grid} grid the grid you'd like to act upon, usually available
         * from gridApi.grid
         * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus to
         * @param {object} colDef to make visible and set focus to
         * @returns {promise} a promise that is resolved after any scrolling is finished
         */scrollToFocus:function(grid,rowEntity,colDef){var gridRow=null,gridCol=null;if(typeof rowEntity!=='undefined'&&rowEntity!==null){gridRow=grid.getRow(rowEntity);}if(typeof colDef!=='undefined'&&colDef!==null){gridCol=grid.getColumn(colDef.name?colDef.name:colDef.field);}return grid.api.core.scrollToIfNecessary(gridRow,gridCol).then(function(){var rowCol={row:gridRow,col:gridCol};// Broadcast the navigation
if(gridRow!==null&&gridCol!==null){grid.cellNav.broadcastCellNav(rowCol,null,null);}});},/**
         * @ngdoc method
         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
         * @name getLeftWidth
         * @description Get the current drawn width of the columns in the
         * grid up to the numbered column, and add an apportionment for the
         * column that we're on.  So if we are on column 0, we want to scroll
         * 0% (i.e. exclude this column from calc).  If we're on the last column
         * we want to scroll to 100% (i.e. include this column in the calc). So
         * we include (thisColIndex / totalNumberCols) % of this column width
         * @param {Grid} grid the grid you'd like to act upon, usually available
         * from gridApi.grid
         * @param {GridColumn} upToCol the column to total up to and including
         */getLeftWidth:function(grid,upToCol){var width=0;if(!upToCol){return width;}var lastIndex=grid.renderContainers.body.visibleColumnCache.indexOf(upToCol);// total column widths up-to but not including the passed in column
grid.renderContainers.body.visibleColumnCache.forEach(function(col,index){if(index<lastIndex){width+=col.drawnWidth;}});// pro-rata the final column based on % of total columns.
var percentage=lastIndex===0?0:(lastIndex+1)/grid.renderContainers.body.visibleColumnCache.length;width+=upToCol.drawnWidth*percentage;return width;}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.cellNav.directive:uiCellNav
   *  @element div
   *  @restrict EA
   *
   *  @description Adds cell navigation features to the grid columns
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.cellNav']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name'},
        {name: 'title'}
      ];
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-cellnav></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridCellnav',['uiGridCellNavService','uiGridCellNavConstants','uiGridConstants','GridRowColumn','$compile','i18nService',function(uiGridCellNavService,uiGridCellNavConstants,uiGridConstants,GridRowColumn,$compile,i18nService){return{replace:true,priority:-150,require:'^uiGrid',scope:false,controller:function(){},compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){var _scope=$scope;var grid=uiGridCtrl.grid;uiGridCellNavService.initializeGrid(grid);uiGridCtrl.cellNav={};// Ensure that the object has all of the methods we expect it to
uiGridCtrl.cellNav.makeRowCol=function(obj){if(!(obj instanceof GridRowColumn)){obj=new GridRowColumn(obj.row,obj.col);}return obj;};uiGridCtrl.cellNav.getActiveCell=function(){var elms=$elm[0].getElementsByClassName('ui-grid-cell-focus');if(elms.length>0){return elms[0];}return undefined;};uiGridCtrl.cellNav.broadcastCellNav=grid.cellNav.broadcastCellNav=function(newRowCol,modifierDown,originEvt){modifierDown=!(modifierDown===undefined||!modifierDown);newRowCol=uiGridCtrl.cellNav.makeRowCol(newRowCol);uiGridCtrl.cellNav.broadcastFocus(newRowCol,modifierDown,originEvt);_scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT,newRowCol,modifierDown,originEvt);};uiGridCtrl.cellNav.clearFocus=grid.cellNav.clearFocus=function(){grid.cellNav.focusedCells=[];_scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT);};uiGridCtrl.cellNav.broadcastFocus=function(rowCol,modifierDown,originEvt){modifierDown=!(modifierDown===undefined||!modifierDown);rowCol=uiGridCtrl.cellNav.makeRowCol(rowCol);var row=rowCol.row,col=rowCol.col;var rowColSelectIndex=uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);if(grid.cellNav.lastRowCol===null||rowColSelectIndex===-1||grid.cellNav.lastRowCol.col===col&&grid.cellNav.lastRowCol.row===row){var newRowCol=new GridRowColumn(row,col);if(grid.cellNav.lastRowCol===null||grid.cellNav.lastRowCol.row!==newRowCol.row||grid.cellNav.lastRowCol.col!==newRowCol.col||grid.options.enableCellEditOnFocus){grid.api.cellNav.raise.navigate(newRowCol,grid.cellNav.lastRowCol,originEvt);grid.cellNav.lastRowCol=newRowCol;}if(uiGridCtrl.grid.options.modifierKeysToMultiSelectCells&&modifierDown){grid.cellNav.focusedCells.push(rowCol);}else{grid.cellNav.focusedCells=[rowCol];}}else if(grid.options.modifierKeysToMultiSelectCells&&modifierDown&&rowColSelectIndex>=0){grid.cellNav.focusedCells.splice(rowColSelectIndex,1);}};uiGridCtrl.cellNav.handleKeyDown=function(evt){var direction=uiGridCellNavService.getDirection(evt);if(direction===null){return null;}var containerId='body';if(evt.uiGridTargetRenderContainerId){containerId=evt.uiGridTargetRenderContainerId;}// Get the last-focused row+col combo
var lastRowCol=uiGridCtrl.grid.api.cellNav.getFocusedCell();if(lastRowCol){// Figure out which new row+combo we're navigating to
var rowCol=uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(direction,lastRowCol.row,lastRowCol.col);var focusableCols=uiGridCtrl.grid.renderContainers[containerId].cellNav.getFocusableCols();var rowColSelectIndex=uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);// Shift+tab on top-left cell should exit cellnav on render container
if(// Navigating left
direction===uiGridCellNavConstants.direction.LEFT&&// New col is last col (i.e. wrap around)
rowCol.col===focusableCols[focusableCols.length-1]&&// Staying on same row, which means we're at first row
rowCol.row===lastRowCol.row&&evt.keyCode===uiGridConstants.keymap.TAB&&evt.shiftKey){grid.cellNav.focusedCells.splice(rowColSelectIndex,1);uiGridCtrl.cellNav.clearFocus();return true;}// Tab on bottom-right cell should exit cellnav on render container
else if(direction===uiGridCellNavConstants.direction.RIGHT&&// New col is first col (i.e. wrap around)
rowCol.col===focusableCols[0]&&// Staying on same row, which means we're at first row
rowCol.row===lastRowCol.row&&evt.keyCode===uiGridConstants.keymap.TAB&&!evt.shiftKey){grid.cellNav.focusedCells.splice(rowColSelectIndex,1);uiGridCtrl.cellNav.clearFocus();return true;}// Scroll to the new cell, if it's not completely visible within the render container's viewport
grid.scrollToIfNecessary(rowCol.row,rowCol.col).then(function(){uiGridCtrl.cellNav.broadcastCellNav(rowCol,null,evt);});evt.stopPropagation();evt.preventDefault();return false;}};},post:function($scope,$elm,$attrs,uiGridCtrl){var grid=uiGridCtrl.grid;var usesAria=true;// Detect whether we are using ngAria
// (if ngAria module is not used then the stuff inside addAriaLiveRegion
// is not used and provides extra fluff)
try{angular.module('ngAria');}catch(err){usesAria=false;}function addAriaLiveRegion(){// Thanks to google docs for the inspiration behind how to do this
// XXX: Why is this entire mess nessasary?
// Because browsers take a lot of coercing to get them to read out live regions
// http://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
var ariaNotifierDomElt='<div '+'id="'+grid.id+'-aria-speakable" '+'class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" '+'aria-live="assertive" '+'role="alert" '+'aria-atomic="true" '+'aria-hidden="false" '+'aria-relevant="additions" '+'>'+'&nbsp;'+'</div>';var ariaNotifier=$compile(ariaNotifierDomElt)($scope);$elm.prepend(ariaNotifier);$scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT,function(evt,rowCol,modifierDown,originEvt){/*
                   * If the cell nav event was because of a focus event then we don't want to
                   * change the notifier text.
                   * Reasoning: Voice Over fires a focus events when moving arround the grid.
                   * If the screen reader is handing the grid nav properly then we don't need to
                   * use the alert to notify the user of the movement.
                   * In all other cases we do want a notification event.
                   */if(originEvt&&originEvt.type==='focus'){return;}function setNotifyText(text){if(text===ariaNotifier.text().trim()){return;}ariaNotifier[0].style.clip='rect(0px,0px,0px,0px)';/*
                     * This is how google docs handles clearing the div. Seems to work better than setting the text of the div to ''
                     */ariaNotifier[0].innerHTML="";ariaNotifier[0].style.visibility='hidden';ariaNotifier[0].style.visibility='visible';if(text!==''){ariaNotifier[0].style.clip='auto';/*
                       * The space after the text is something that google docs does.
                       */ariaNotifier[0].appendChild(document.createTextNode(text+" "));ariaNotifier[0].style.visibility='hidden';ariaNotifier[0].style.visibility='visible';}}function getAppendedColumnHeaderText(col){return', '+i18nService.getSafeText('headerCell.aria.column')+' '+col.displayName;}function getCellDisplayValue(currentRowColumn){var prefix='';if(currentRowColumn.col.field==='selectionRowHeaderCol'){// This is the case when the 'selection' feature is used in the grid and the user has moved
// to or inside of the left grid container which holds the checkboxes for selecting rows.
// This is necessary for Accessibility. Without this a screen reader cannot determine if the row
// is or is not currently selected.
prefix=(currentRowColumn.row.isSelected?i18nService.getSafeText('search.aria.selected'):i18nService.getSafeText('search.aria.notSelected'))+', ';}return prefix+grid.getCellDisplayValue(currentRowColumn.row,currentRowColumn.col);}var values=[];var currentSelection=grid.api.cellNav.getCurrentSelection();for(var i=0;i<currentSelection.length;i++){var cellDisplayValue=getCellDisplayValue(currentSelection[i])+getAppendedColumnHeaderText(currentSelection[i].col);values.push(cellDisplayValue);}setNotifyText(values.toString());});}// Only add the ngAria stuff it will be used
if(usesAria){addAriaLiveRegion();}}};}};}]);module.directive('uiGridRenderContainer',['$timeout','gridUtil','uiGridCellNavService','$compile','uiGridCellNavConstants',function($timeout,gridUtil,uiGridCellNavService,$compile,uiGridCellNavConstants){return{replace:true,priority:-99999,// this needs to run very last
require:['^uiGrid','uiGridRenderContainer','?^uiGridCellnav'],scope:false,compile:function(){return{post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0],renderContainerCtrl=controllers[1],uiGridCellnavCtrl=controllers[2];// Skip attaching cell-nav specific logic if the directive is not attached above us
if(!uiGridCtrl.grid.api.cellNav){return;}var containerId=renderContainerCtrl.containerId;var grid=uiGridCtrl.grid;// run each time a render container is created
uiGridCellNavService.decorateRenderContainers(grid);// focusser only created for body
if(containerId!=='body'){return;}if(uiGridCtrl.grid.options.modifierKeysToMultiSelectCells){$elm.attr('aria-multiselectable',true);}else{$elm.attr('aria-multiselectable',false);}// add an element with no dimensions that can be used to set focus and capture keystrokes
var focuser=$compile('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="'+grid.id+'-aria-speakable '+grid.id+'-grid-container'+'" aria-owns="'+grid.id+'-grid-container'+'"></div>')($scope);$elm.append(focuser);focuser.on('focus',function(evt){evt.uiGridTargetRenderContainerId=containerId;var rowCol=uiGridCtrl.grid.api.cellNav.getFocusedCell();if(rowCol===null){rowCol=uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(uiGridCellNavConstants.direction.DOWN,null,null);if(rowCol.row&&rowCol.col){uiGridCtrl.cellNav.broadcastCellNav(rowCol);}}});uiGridCellnavCtrl.setAriaActivedescendant=function(id){$elm.attr('aria-activedescendant',id);};uiGridCellnavCtrl.removeAriaActivedescendant=function(id){if($elm.attr('aria-activedescendant')===id){$elm.attr('aria-activedescendant','');}};uiGridCtrl.focus=function(){gridUtil.focus.byElement(focuser[0]);// allow for first time grid focus
};var viewPortKeyDownWasRaisedForRowCol=null;// Bind to keydown events in the render container
focuser.on('keydown',function(evt){evt.uiGridTargetRenderContainerId=containerId;var rowCol=uiGridCtrl.grid.api.cellNav.getFocusedCell();var raiseViewPortKeyDown=uiGridCtrl.grid.options.keyDownOverrides.some(function(override){return Object.keys(override).every(function(property){return override[property]===evt[property];});});var result=raiseViewPortKeyDown?null:uiGridCtrl.cellNav.handleKeyDown(evt);if(result===null){uiGridCtrl.grid.api.cellNav.raise.viewPortKeyDown(evt,rowCol,uiGridCtrl.cellNav.handleKeyDown);viewPortKeyDownWasRaisedForRowCol=rowCol;}});// Bind to keypress events in the render container
// keypress events are needed by edit function so the key press
// that initiated an edit is not lost
// must fire the event in a timeout so the editor can
// initialize and subscribe to the event on another event loop
focuser.on('keypress',function(evt){if(viewPortKeyDownWasRaisedForRowCol){$timeout(function(){uiGridCtrl.grid.api.cellNav.raise.viewPortKeyPress(evt,viewPortKeyDownWasRaisedForRowCol);},4);viewPortKeyDownWasRaisedForRowCol=null;}});$scope.$on('$destroy',function(){// Remove all event handlers associated with this focuser.
focuser.off();});}};}};}]);module.directive('uiGridViewport',function(){return{replace:true,priority:-99999,// this needs to run very last
require:['^uiGrid','^uiGridRenderContainer','?^uiGridCellnav'],scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0],renderContainerCtrl=controllers[1];// Skip attaching cell-nav specific logic if the directive is not attached above us
if(!uiGridCtrl.grid.api.cellNav){return;}var containerId=renderContainerCtrl.containerId;// no need to process for other containers
if(containerId!=='body'){return;}var grid=uiGridCtrl.grid;grid.api.core.on.scrollBegin($scope,function(){// Skip if there's no currently-focused cell
var lastRowCol=uiGridCtrl.grid.api.cellNav.getFocusedCell();if(lastRowCol===null){return;}// if not in my container, move on
// todo: worry about horiz scroll
if(!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)){return;}uiGridCtrl.cellNav.clearFocus();});grid.api.core.on.scrollEnd($scope,function(args){// Skip if there's no currently-focused cell
var lastRowCol=uiGridCtrl.grid.api.cellNav.getFocusedCell();if(lastRowCol===null){return;}// if not in my container, move on
// todo: worry about horiz scroll
if(!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)){return;}uiGridCtrl.cellNav.broadcastCellNav(lastRowCol);});grid.api.cellNav.on.navigate($scope,function(){// focus again because it can be lost
uiGridCtrl.focus();});}};}};});/**
   *  @ngdoc directive
   *  @name ui.grid.cellNav.directive:uiGridCell
   *  @element div
   *  @restrict A
   *  @description Stacks on top of ui.grid.uiGridCell to provide cell navigation
   */module.directive('uiGridCell',['uiGridCellNavConstants','uiGridConstants','GridRowColumn',function(uiGridCellNavConstants,uiGridConstants,GridRowColumn){return{priority:-150,// run after default uiGridCell directive and ui.grid.edit uiGridCell
restrict:'A',require:['^uiGrid','?^uiGridCellnav'],scope:false,link:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0],uiGridCellnavCtrl=controllers[1];// Skip attaching cell-nav specific logic if the directive is not attached above us
if(!uiGridCtrl.grid.api.cellNav){return;}if(!$scope.col.colDef.allowCellFocus){return;}// Convinience local variables
var grid=uiGridCtrl.grid;$scope.focused=false;// Make this cell focusable but only with javascript/a mouse click
$elm.attr('tabindex',-1);// When a cell is clicked, broadcast a cellNav event saying that this row+col combo is now focused
$elm.find('div').on('click',function(evt){uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row,$scope.col),evt.ctrlKey||evt.metaKey,evt);evt.stopPropagation();$scope.$apply();});/*
           * XXX Hack for screen readers.
           * This allows the grid to focus using only the screen reader cursor.
           * Since the focus event doesn't include key press information we can't use it
           * as our primary source of the event.
           */$elm.on('mousedown',preventMouseDown);// turn on and off for edit events
if(uiGridCtrl.grid.api.edit){uiGridCtrl.grid.api.edit.on.beginCellEdit($scope,function(){$elm.off('mousedown',preventMouseDown);});uiGridCtrl.grid.api.edit.on.afterCellEdit($scope,function(){$elm.on('mousedown',preventMouseDown);});uiGridCtrl.grid.api.edit.on.cancelCellEdit($scope,function(){$elm.on('mousedown',preventMouseDown);});}// In case we created a new row, and we are the new created row by ngRepeat
// then this cell content might have been selected previously
refreshCellFocus();function preventMouseDown(evt){// Prevents the foucus event from firing if the click event is already going to fire.
// If both events fire it will cause bouncing behavior.
evt.preventDefault();}// You can only focus on elements with a tabindex value
$elm.on('focus',function(evt){uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row,$scope.col),false,evt);evt.stopPropagation();$scope.$apply();});// This event is fired for all cells.  If the cell matches, then focus is set
$scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT,refreshCellFocus);// Refresh cell focus when a new row id added to the grid
var dataChangeDereg=uiGridCtrl.grid.registerDataChangeCallback(function(grid){// Clear the focus if it's set to avoid the wrong cell getting focused during
// a short period of time (from now until $timeout function executed)
clearFocus();$scope.$applyAsync(refreshCellFocus);},[uiGridConstants.dataChange.ROW]);function refreshCellFocus(){var isFocused=grid.cellNav.focusedCells.some(function(focusedRowCol,index){return focusedRowCol.row===$scope.row&&focusedRowCol.col===$scope.col;});if(isFocused){setFocused();}else{clearFocus();}}function setFocused(){if(!$scope.focused){var div=$elm.find('div');div.addClass('ui-grid-cell-focus');$elm.attr('aria-selected',true);uiGridCellnavCtrl.setAriaActivedescendant($elm.attr('id'));$scope.focused=true;}}function clearFocus(){if($scope.focused){var div=$elm.find('div');div.removeClass('ui-grid-cell-focus');$elm.attr('aria-selected',false);uiGridCellnavCtrl.removeAriaActivedescendant($elm.attr('id'));$scope.focused=false;}}$scope.$on('$destroy',function(){dataChangeDereg();// .off withouth paramaters removes all handlers
$elm.find('div').off();$elm.off();});}};}]);})();(function(){'use strict';/**
   * @ngdoc object
   * @name ui.grid.service:uiGridConstants
   * @description Constants for use across many grid features
   *
   */angular.module('ui.grid').constant('uiGridConstants',{LOG_DEBUG_MESSAGES:true,LOG_WARN_MESSAGES:true,LOG_ERROR_MESSAGES:true,CUSTOM_FILTERS:/CUSTOM_FILTERS/g,COL_FIELD:/COL_FIELD/g,MODEL_COL_FIELD:/MODEL_COL_FIELD/g,TOOLTIP:/title=\"TOOLTIP\"/g,DISPLAY_CELL_TEMPLATE:/DISPLAY_CELL_TEMPLATE/g,TEMPLATE_REGEXP:/<.+>/,FUNC_REGEXP:/(\([^)]*\))?$/,DOT_REGEXP:/\./g,APOS_REGEXP:/'/g,BRACKET_REGEXP:/^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,COL_CLASS_PREFIX:'ui-grid-col',ENTITY_BINDING:'$$this',events:{GRID_SCROLL:'uiGridScroll',COLUMN_MENU_SHOWN:'uiGridColMenuShown',ITEM_DRAGGING:'uiGridItemDragStart',// For any item being dragged
COLUMN_HEADER_CLICK:'uiGridColumnHeaderClick'},// copied from http://www.lsauer.com/2011/08/javascript-keymap-keycodes-in-json.html
keymap:{TAB:9,STRG:17,CAPSLOCK:20,CTRL:17,CTRLRIGHT:18,CTRLR:18,SHIFT:16,RETURN:13,ENTER:13,BACKSPACE:8,BCKSP:8,ALT:18,ALTR:17,ALTRIGHT:17,SPACE:32,WIN:91,MAC:91,FN:null,PG_UP:33,PG_DOWN:34,UP:38,DOWN:40,LEFT:37,RIGHT:39,ESC:27,DEL:46,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123},/**
     * @ngdoc object
     * @name ASC
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
     * to configure the sorting direction of the column
     */ASC:'asc',/**
     * @ngdoc object
     * @name DESC
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
     * to configure the sorting direction of the column
     */DESC:'desc',/**
     * @ngdoc object
     * @name filter
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_filter columnDef.filter}
     * to configure filtering on the column
     *
     * `SELECT` and `INPUT` are used with the `type` property of the filter, the rest are used to specify
     * one of the built-in conditions.
     *
     * Available `condition` options are:
     * - `uiGridConstants.filter.STARTS_WITH`
     * - `uiGridConstants.filter.ENDS_WITH`
     * - `uiGridConstants.filter.CONTAINS`
     * - `uiGridConstants.filter.GREATER_THAN`
     * - `uiGridConstants.filter.GREATER_THAN_OR_EQUAL`
     * - `uiGridConstants.filter.LESS_THAN`
     * - `uiGridConstants.filter.LESS_THAN_OR_EQUAL`
     * - `uiGridConstants.filter.NOT_EQUAL`
     *
     *
     * Available `type` options are:
     * - `uiGridConstants.filter.SELECT` - use a dropdown box for the cell header filter field
     * - `uiGridConstants.filter.INPUT` - use a text box for the cell header filter field
     */filter:{STARTS_WITH:2,ENDS_WITH:4,EXACT:8,CONTAINS:16,GREATER_THAN:32,GREATER_THAN_OR_EQUAL:64,LESS_THAN:128,LESS_THAN_OR_EQUAL:256,NOT_EQUAL:512,SELECT:'select',INPUT:'input'},/**
     * @ngdoc object
     * @name aggregationTypes
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_aggregationType columnDef.aggregationType}
     * to specify the type of built-in aggregation the column should use.
     *
     * Available options are:
     * - `uiGridConstants.aggregationTypes.sum` - add the values in this column to produce the aggregated value
     * - `uiGridConstants.aggregationTypes.count` - count the number of rows to produce the aggregated value
     * - `uiGridConstants.aggregationTypes.avg` - average the values in this column to produce the aggregated value
     * - `uiGridConstants.aggregationTypes.min` - use the minimum value in this column as the aggregated value
     * - `uiGridConstants.aggregationTypes.max` - use the maximum value in this column as the aggregated value
     */aggregationTypes:{sum:2,count:4,avg:8,min:16,max:32},/**
     * @ngdoc array
     * @name CURRENCY_SYMBOLS
     * @propertyOf ui.grid.service:uiGridConstants
     * @description A list of all presently circulating currency symbols that was copied from
     * https://en.wikipedia.org/wiki/Currency_symbol#List_of_presently-circulating_currency_symbols
     *
     * Can be used on {@link ui.grid.class:rowSorter} to create a number string regex that ignores currency symbols.
     */CURRENCY_SYMBOLS:['¤','؋','Ar','Ƀ','฿','B/.','Br','Bs.','Bs.F.','GH₵','¢','c','Ch.','₡','C$','D','ден','دج','.د.ب','د.ع','JD','د.ك','ل.د','дин','د.ت','د.م.','د.إ','Db','$','₫','Esc','€','ƒ','Ft','FBu','FCFA','CFA','Fr','FRw','G','gr','₲','h','₴','₭','Kč','kr','kn','MK','ZK','Kz','K','L','Le','лв','E','lp','M','KM','MT','₥','Nfk','₦','Nu.','UM','T$','MOP$','₱','Pt.','£','ج.م.','LL','LS','P','Q','q','R','R$','ر.ع.','ر.ق','ر.س','៛','RM','p','Rf.','₹','₨','SRe','Rp','₪','Ksh','Sh.So.','USh','S/','SDR','сом','৳	','WS$','₮','VT','₩','¥','zł'],/**
     * @ngdoc object
     * @name scrollDirection
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Set on {@link ui.grid.class:Grid#properties_scrollDirection Grid.scrollDirection},
     * to indicate the direction the grid is currently scrolling in
     *
     * Available options are:
     * - `uiGridConstants.scrollDirection.UP` - set when the grid is scrolling up
     * - `uiGridConstants.scrollDirection.DOWN` - set when the grid is scrolling down
     * - `uiGridConstants.scrollDirection.LEFT` - set when the grid is scrolling left
     * - `uiGridConstants.scrollDirection.RIGHT` - set when the grid is scrolling right
     * - `uiGridConstants.scrollDirection.NONE` - set when the grid is not scrolling, this is the default
     */scrollDirection:{UP:'up',DOWN:'down',LEFT:'left',RIGHT:'right',NONE:'none'},/**
     * @ngdoc object
     * @name dataChange
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used with {@link ui.grid.api:PublicApi#methods_notifyDataChange PublicApi.notifyDataChange},
     * {@link ui.grid.class:Grid#methods_callDataChangeCallbacks Grid.callDataChangeCallbacks},
     * and {@link ui.grid.class:Grid#methods_registerDataChangeCallback Grid.registerDataChangeCallback}
     * to specify the type of the event(s).
     *
     * Available options are:
     * - `uiGridConstants.dataChange.ALL` - listeners fired on any of these events, fires listeners on all events.
     * - `uiGridConstants.dataChange.EDIT` - fired when the data in a cell is edited
     * - `uiGridConstants.dataChange.ROW` - fired when a row is added or removed
     * - `uiGridConstants.dataChange.COLUMN` - fired when the column definitions are modified
     * - `uiGridConstants.dataChange.OPTIONS` - fired when the grid options are modified
     */dataChange:{ALL:'all',EDIT:'edit',ROW:'row',COLUMN:'column',OPTIONS:'options'},/**
     * @ngdoc object
     * @name scrollbars
     * @propertyOf ui.grid.service:uiGridConstants
     * @description Used with {@link ui.grid.class:GridOptions#properties_enableHorizontalScrollbar GridOptions.enableHorizontalScrollbar}
     * and {@link ui.grid.class:GridOptions#properties_enableVerticalScrollbar GridOptions.enableVerticalScrollbar}
     * to specify the scrollbar policy for that direction.
     *
     * Available options are:
     * - `uiGridConstants.scrollbars.NEVER` - never show scrollbars in this direction
     * - `uiGridConstants.scrollbars.ALWAYS` - always show scrollbars in this direction
     * - `uiGridConstants.scrollbars.WHEN_NEEDED` - shows scrollbars in this direction when needed
     */scrollbars:{NEVER:0,ALWAYS:1,WHEN_NEEDED:2}});})();angular.module('ui.grid').directive('uiGridCell',['$compile','$parse','gridUtil','uiGridConstants',function($compile,$parse,gridUtil,uiGridConstants){return{priority:0,scope:false,require:'?^uiGrid',compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){function compileTemplate(){var compiledElementFn=$scope.col.compiledElementFn;compiledElementFn($scope,function(clonedElement,scope){$elm.append(clonedElement);});}// If the grid controller is present, use it to get the compiled cell template function
if(uiGridCtrl&&$scope.col.compiledElementFn){compileTemplate();}// No controller, compile the element manually (for unit tests)
else{if(uiGridCtrl&&!$scope.col.compiledElementFn){$scope.col.getCompiledElementFn().then(function(compiledElementFn){compiledElementFn($scope,function(clonedElement,scope){$elm.append(clonedElement);});}).catch(angular.noop);}else{var html=$scope.col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD,'row.entity.'+gridUtil.preEval($scope.col.field)).replace(uiGridConstants.COL_FIELD,'grid.getCellValue(row, col)');var cellElement=$compile(html)($scope);$elm.append(cellElement);}}},post:function($scope,$elm){var initColClass=$scope.col.getColClass(false),classAdded;$elm.addClass(initColClass);function updateClass(grid){var contents=$elm;if(classAdded){contents.removeClass(classAdded);classAdded=null;}if(angular.isFunction($scope.col.cellClass)){classAdded=$scope.col.cellClass($scope.grid,$scope.row,$scope.col,$scope.rowRenderIndex,$scope.colRenderIndex);}else{classAdded=$scope.col.cellClass;}contents.addClass(classAdded);}if($scope.col.cellClass){updateClass();}// Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
var dataChangeDereg=$scope.grid.registerDataChangeCallback(updateClass,[uiGridConstants.dataChange.COLUMN,uiGridConstants.dataChange.EDIT]);// watch the col and row to see if they change - which would indicate that we've scrolled or sorted or otherwise
// changed the row/col that this cell relates to, and we need to re-evaluate cell classes and maybe other things
function cellChangeFunction(n,o){if(n!==o){if(classAdded||$scope.col.cellClass){updateClass();}// See if the column's internal class has changed
var newColClass=$scope.col.getColClass(false);if(newColClass!==initColClass){$elm.removeClass(initColClass);$elm.addClass(newColClass);initColClass=newColClass;}}}// TODO(c0bra): Turn this into a deep array watch
var rowWatchDereg=$scope.$watch('row',cellChangeFunction);function deregisterFunction(){dataChangeDereg();rowWatchDereg();}$scope.$on('$destroy',deregisterFunction);$elm.on('$destroy',deregisterFunction);}};}};}]);(function(){angular.module('ui.grid').service('uiGridColumnMenuService',['i18nService','uiGridConstants','gridUtil',function(i18nService,uiGridConstants,gridUtil){/**
 *  @ngdoc service
 *  @name ui.grid.service:uiGridColumnMenuService
 *
 *  @description Services for working with column menus, factored out
 *  to make the code easier to understand
 */var service={/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name initialize
     * @description  Sets defaults, puts a reference to the $scope on
     * the uiGridController
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     * @param {controller} uiGridCtrl the uiGridController for the grid
     * we're on
     *
     */initialize:function($scope,uiGridCtrl){$scope.grid=uiGridCtrl.grid;// Store a reference to this link/controller in the main uiGrid controller
// to allow showMenu later
uiGridCtrl.columnMenuScope=$scope;// Save whether we're shown or not so the columns can check
$scope.menuShown=false;},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name setColMenuItemWatch
     * @description  Setup a watch on $scope.col.menuItems, and update
     * menuItems based on this.  $scope.col needs to be set by the column
     * before calling the menu.
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     */setColMenuItemWatch:function($scope){var deregFunction=$scope.$watch('col.menuItems',function(n){if(typeof n!=='undefined'&&n&&angular.isArray(n)){n.forEach(function(item){if(typeof item.context==='undefined'||!item.context){item.context={};}item.context.col=$scope.col;});$scope.menuItems=$scope.defaultMenuItems.concat(n);}else{$scope.menuItems=$scope.defaultMenuItems;}});$scope.$on('$destroy',deregFunction);},getGridOption:function($scope,option){return typeof $scope.grid!=='undefined'&&$scope.grid&&$scope.grid.options&&$scope.grid.options[option];},/**
     * @ngdoc boolean
     * @name enableSorting
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) True by default. When enabled, this setting adds sort
     * widgets to the column header, allowing sorting of the data in the individual column.
     */ /**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name sortable
     * @description  determines whether this column is sortable
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     *
     */sortable:function($scope){return Boolean(this.getGridOption($scope,'enableSorting')&&typeof $scope.col!=='undefined'&&$scope.col&&$scope.col.enableSorting);},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name isActiveSort
     * @description  determines whether the requested sort direction is current active, to
     * allow highlighting in the menu
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     * @param {string} direction the direction that we'd have selected for us to be active
     *
     */isActiveSort:function($scope,direction){return Boolean(typeof $scope.col!=='undefined'&&typeof $scope.col.sort!=='undefined'&&typeof $scope.col.sort.direction!=='undefined'&&$scope.col.sort.direction===direction);},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name suppressRemoveSort
     * @description  determines whether we should suppress the removeSort option
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     *
     */suppressRemoveSort:function($scope){return Boolean($scope.col&&$scope.col.suppressRemoveSort);},/**
     * @ngdoc boolean
     * @name enableHiding
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) True by default. When set to false, this setting prevents a user from hiding the column
     * using the column menu or the grid menu.
     */ /**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name hideable
     * @description  determines whether a column can be hidden, by checking the enableHiding columnDef option
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     *
     */hideable:function($scope){return Boolean(this.getGridOption($scope,'enableHiding')&&typeof $scope.col!=='undefined'&&$scope.col&&($scope.col.colDef&&$scope.col.colDef.enableHiding!==false||!$scope.col.colDef)||!this.getGridOption($scope,'enableHiding')&&$scope.col&&$scope.col.colDef&&$scope.col.colDef.enableHiding);},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name getDefaultMenuItems
     * @description  returns the default menu items for a column menu
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     *
     */getDefaultMenuItems:function($scope){return[{title:function(){return i18nService.getSafeText('sort.ascending');},icon:'ui-grid-icon-sort-alt-up',action:function($event){$event.stopPropagation();$scope.sortColumn($event,uiGridConstants.ASC);},shown:function(){return service.sortable($scope);},active:function(){return service.isActiveSort($scope,uiGridConstants.ASC);}},{title:function(){return i18nService.getSafeText('sort.descending');},icon:'ui-grid-icon-sort-alt-down',action:function($event){$event.stopPropagation();$scope.sortColumn($event,uiGridConstants.DESC);},shown:function(){return service.sortable($scope);},active:function(){return service.isActiveSort($scope,uiGridConstants.DESC);}},{title:function(){return i18nService.getSafeText('sort.remove');},icon:'ui-grid-icon-cancel',action:function($event){$event.stopPropagation();$scope.unsortColumn();},shown:function(){return service.sortable($scope)&&typeof $scope.col!=='undefined'&&typeof $scope.col.sort!=='undefined'&&typeof $scope.col.sort.direction!=='undefined'&&$scope.col.sort.direction!==null&&!service.suppressRemoveSort($scope);}},{title:function(){return i18nService.getSafeText('column.hide');},icon:'ui-grid-icon-cancel',shown:function(){return service.hideable($scope);},action:function($event){$event.stopPropagation();$scope.hideColumn();}}];},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name getColumnElementPosition
     * @description  gets the position information needed to place the column
     * menu below the column header
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     * @param {GridColumn} column the column we want to position below
     * @param {element} $columnElement the column element we want to position below
     * @returns {hash} containing left, top, offset, height, width
     *
     */getColumnElementPosition:function($scope,column,$columnElement){var positionData={};positionData.left=$columnElement[0].offsetLeft;positionData.top=$columnElement[0].offsetTop;positionData.parentLeft=$columnElement[0].offsetParent.offsetLeft;// Get the grid scrollLeft
positionData.offset=0;if(column.grid.options.offsetLeft){positionData.offset=column.grid.options.offsetLeft;}positionData.height=gridUtil.elementHeight($columnElement,true);positionData.width=gridUtil.elementWidth($columnElement,true);return positionData;},/**
     * @ngdoc method
     * @methodOf ui.grid.service:uiGridColumnMenuService
     * @name repositionMenu
     * @description  Reposition the menu below the new column.  If the menu has no child nodes
     * (i.e. it's not currently visible) then we guess it's width at 100, we'll be called again
     * later to fix it
     * @param {$scope} $scope the $scope from the uiGridColumnMenu
     * @param {GridColumn} column the column we want to position below
     * @param {hash} positionData a hash containing left, top, offset, height, width
     * @param {element} $elm the column menu element that we want to reposition
     * @param {element} $columnElement the column element that we want to reposition underneath
     *
     */repositionMenu:function($scope,column,positionData,$elm,$columnElement){var menu=$elm[0].querySelectorAll('.ui-grid-menu');// It's possible that the render container of the column we're attaching to is
// offset from the grid (i.e. pinned containers), we need to get the difference in the offsetLeft
// between the render container and the grid
var renderContainerElm=gridUtil.closestElm($columnElement,'.ui-grid-render-container'),renderContainerOffset=renderContainerElm.getBoundingClientRect().left-$scope.grid.element[0].getBoundingClientRect().left,containerScrollLeft=renderContainerElm.querySelectorAll('.ui-grid-viewport')[0].scrollLeft;// repositionMenu is now always called after it's visible in the DOM,
// allowing us to simply get the width every time the menu is opened
var myWidth=gridUtil.elementWidth(menu,true),paddingRight=column.lastMenuPaddingRight?column.lastMenuPaddingRight:$scope.lastMenuPaddingRight?$scope.lastMenuPaddingRight:10;if(menu.length!==0){var mid=menu[0].querySelectorAll('.ui-grid-menu-mid');if(mid.length!==0){// TODO(c0bra): use padding-left/padding-right based on document direction (ltr/rtl), place menu on proper side
// Get the column menu right padding
paddingRight=parseInt(gridUtil.getStyles(angular.element(menu)[0])['paddingRight'],10);$scope.lastMenuPaddingRight=paddingRight;column.lastMenuPaddingRight=paddingRight;}}var left=positionData.left+renderContainerOffset-containerScrollLeft+positionData.parentLeft+positionData.width+paddingRight;if(left<positionData.offset+myWidth){left=Math.max(positionData.left-containerScrollLeft+positionData.parentLeft-paddingRight+myWidth,positionData.offset+myWidth);}$elm.css('left',left+'px');$elm.css('top',positionData.top+positionData.height+'px');}};return service;}]).directive('uiGridColumnMenu',['$timeout','gridUtil','uiGridConstants','uiGridColumnMenuService','$document',function($timeout,gridUtil,uiGridConstants,uiGridColumnMenuService,$document){/**
 * @ngdoc directive
 * @name ui.grid.directive:uiGridColumnMenu
 * @description  Provides the column menu framework, leverages uiGridMenu underneath
 *
 */return{priority:0,scope:true,require:'^uiGrid',templateUrl:'ui-grid/uiGridColumnMenu',replace:true,link:function($scope,$elm,$attrs,uiGridCtrl){uiGridColumnMenuService.initialize($scope,uiGridCtrl);$scope.defaultMenuItems=uiGridColumnMenuService.getDefaultMenuItems($scope);// Set the menu items for use with the column menu. The user can later add additional items via the watch
$scope.menuItems=$scope.defaultMenuItems;uiGridColumnMenuService.setColMenuItemWatch($scope);function updateCurrentColStatus(menuShown){if($scope.col){$scope.col.menuShown=menuShown;}}/**
       * @ngdoc method
       * @methodOf ui.grid.directive:uiGridColumnMenu
       * @name showMenu
       * @description Shows the column menu.  If the menu is already displayed it
       * calls the menu to ask it to hide (it will animate), then it repositions the menu
       * to the right place whilst hidden (it will make an assumption on menu width),
       * then it asks the menu to show (it will animate), then it repositions the menu again
       * once we can calculate it's size.
       * @param {GridColumn} column the column we want to position below
       * @param {element} $columnElement the column element we want to position below
       */$scope.showMenu=function(column,$columnElement,event){// Update the menu status for the current column
updateCurrentColStatus(false);// Swap to this column
$scope.col=column;updateCurrentColStatus(true);// Get the position information for the column element
var colElementPosition=uiGridColumnMenuService.getColumnElementPosition($scope,column,$columnElement);if($scope.menuShown){// we want to hide, then reposition, then show, but we want to wait for animations
// we set a variable, and then rely on the menu-hidden event to call the reposition and show
$scope.colElement=$columnElement;$scope.colElementPosition=colElementPosition;$scope.hideThenShow=true;$scope.$broadcast('hide-menu',{originalEvent:event});}else{$scope.menuShown=true;$scope.colElement=$columnElement;$scope.colElementPosition=colElementPosition;$scope.$broadcast('show-menu',{originalEvent:event});}};/**
       * @ngdoc method
       * @methodOf ui.grid.directive:uiGridColumnMenu
       * @name hideMenu
       * @description Hides the column menu.
       * @param {boolean} broadcastTrigger true if we were triggered by a broadcast
       * from the menu itself - in which case don't broadcast again as we'll get
       * an infinite loop
       */$scope.hideMenu=function(broadcastTrigger){$scope.menuShown=false;updateCurrentColStatus(false);if(!broadcastTrigger){$scope.$broadcast('hide-menu');}};$scope.$on('menu-hidden',function(){var menuItems=angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0];$elm[0].removeAttribute('style');if($scope.hideThenShow){delete $scope.hideThenShow;$scope.$broadcast('show-menu');$scope.menuShown=true;}else{$scope.hideMenu(true);if($scope.col&&$scope.col.visible){// Focus on the menu button
gridUtil.focus.bySelector($document,'.ui-grid-header-cell.'+$scope.col.getColClass()+' .ui-grid-column-menu-button',$scope.col.grid,false).catch(angular.noop);}}if(menuItems){menuItems.onkeydown=null;angular.forEach(menuItems.children,function removeHandlers(item){item.onkeydown=null;});}});$scope.$on('menu-shown',function(){$timeout(function(){uiGridColumnMenuService.repositionMenu($scope,$scope.col,$scope.colElementPosition,$elm,$scope.colElement);var hasVisibleMenuItems=$scope.menuItems.some(function(menuItem){return menuItem.shown();});// automatically set the focus to the first button element in the now open menu.
if(hasVisibleMenuItems){gridUtil.focus.bySelector($document,'.ui-grid-menu-items .ui-grid-menu-item:not(.ng-hide)',true).catch(angular.noop);}delete $scope.colElementPosition;delete $scope.columnElement;addKeydownHandlersToMenu();});});/* Column methods */$scope.sortColumn=function(event,dir){event.stopPropagation();$scope.grid.sortColumn($scope.col,dir,true).then(function(){$scope.grid.refresh();$scope.hideMenu();}).catch(angular.noop);};$scope.unsortColumn=function(){$scope.col.unsort();$scope.grid.refresh();$scope.hideMenu();};function addKeydownHandlersToMenu(){var menu=angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0],menuItems,visibleMenuItems=[];if(menu){menu.onkeydown=function closeMenu(event){if(event.keyCode===uiGridConstants.keymap.ESC){event.preventDefault();$scope.hideMenu();}};menuItems=menu.querySelectorAll('.ui-grid-menu-item:not(.ng-hide)');angular.forEach(menuItems,function filterVisibleItems(item){if(item.offsetParent!==null){this.push(item);}},visibleMenuItems);if(visibleMenuItems.length){if(visibleMenuItems.length===1){visibleMenuItems[0].onkeydown=function singleItemHandler(event){circularFocusHandler(event,true);};}else{visibleMenuItems[0].onkeydown=function firstItemHandler(event){circularFocusHandler(event,false,event.shiftKey,visibleMenuItems.length-1);};visibleMenuItems[visibleMenuItems.length-1].onkeydown=function lastItemHandler(event){circularFocusHandler(event,false,!event.shiftKey,0);};}}}function circularFocusHandler(event,isSingleItem,shiftKeyStatus,index){if(event.keyCode===uiGridConstants.keymap.TAB){if(isSingleItem){event.preventDefault();}else if(shiftKeyStatus){event.preventDefault();visibleMenuItems[index].focus();}}}}// Since we are hiding this column the default hide action will fail so we need to focus somewhere else.
var setFocusOnHideColumn=function(){$timeout(function(){// Get the UID of the first
var focusToGridMenu=function(){return gridUtil.focus.byId('grid-menu',$scope.grid);};var thisIndex;$scope.grid.columns.some(function(element,index){if(angular.equals(element,$scope.col)){thisIndex=index;return true;}});var previousVisibleCol;// Try and find the next lower or nearest column to focus on
$scope.grid.columns.some(function(element,index){if(!element.visible){return false;}// This columns index is below the current column index
else if(index<thisIndex){previousVisibleCol=element;}// This elements index is above this column index and we haven't found one that is lower
else if(index>thisIndex&&!previousVisibleCol){// This is the next best thing
previousVisibleCol=element;// We've found one so use it.
return true;}// We've reached an element with an index above this column and the previousVisibleCol variable has been set
else if(index>thisIndex&&previousVisibleCol){// We are done.
return true;}});// If found then focus on it
if(previousVisibleCol){var colClass=previousVisibleCol.getColClass();gridUtil.focus.bySelector($document,'.ui-grid-header-cell.'+colClass+' .ui-grid-header-cell-primary-focus',true).then(angular.noop,function(reason){if(reason!=='canceled'){// If this is canceled then don't perform the action
// The fallback action is to focus on the grid menu
return focusToGridMenu();}}).catch(angular.noop);}else{// Fallback action to focus on the grid menu
focusToGridMenu();}});};$scope.hideColumn=function(){$scope.col.colDef.visible=false;$scope.col.visible=false;$scope.grid.queueGridRefresh();$scope.hideMenu();$scope.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);$scope.grid.api.core.raise.columnVisibilityChanged($scope.col);// We are hiding so the default action of focusing on the button that opened this menu will fail.
setFocusOnHideColumn();};},controller:['$scope',function($scope){var self=this;$scope.$watch('menuItems',function(n){self.menuItems=n;});}]};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridFilter',['$compile','$templateCache','i18nService','gridUtil',function($compile,$templateCache,i18nService,gridUtil){return{compile:function(){return{pre:function($scope,$elm){$scope.col.updateFilters=function(filterable){$elm.children().remove();if(filterable){var template=$scope.col.filterHeaderTemplate;if(template===undefined&&$scope.col.providedFilterHeaderTemplate!==''){if($scope.col.filterHeaderTemplatePromise){$scope.col.filterHeaderTemplatePromise.then(function(){template=$scope.col.filterHeaderTemplate;$elm.append($compile(template)($scope));});}}else{$elm.append($compile(template)($scope));}}};$scope.$on('$destroy',function(){delete $scope.col.filterable;delete $scope.col.updateFilters;});},post:function($scope,$elm){$scope.aria=i18nService.getSafeText('headerCell.aria');$scope.removeFilter=function(colFilter,index){colFilter.term=null;// Set the focus to the filter input after the action disables the button
gridUtil.focus.bySelector($elm,'.ui-grid-filter-input-'+index);};}};}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridFooterCell',['$timeout','gridUtil','uiGridConstants','$compile',function($timeout,gridUtil,uiGridConstants,$compile){return{priority:0,scope:{col:'=',row:'=',renderIndex:'='},replace:true,require:'^uiGrid',compile:function compile(){return{pre:function($scope,$elm){var template=$scope.col.footerCellTemplate;if(template===undefined&&$scope.col.providedFooterCellTemplate!==''){if($scope.col.footerCellTemplatePromise){$scope.col.footerCellTemplatePromise.then(function(){template=$scope.col.footerCellTemplate;$elm.append($compile(template)($scope));});}}else{$elm.append($compile(template)($scope));}},post:function($scope,$elm,$attrs,uiGridCtrl){// $elm.addClass($scope.col.getColClass(false));
$scope.grid=uiGridCtrl.grid;var initColClass=$scope.col.getColClass(false);$elm.addClass(initColClass);// apply any footerCellClass
var classAdded;var updateClass=function(){var contents=$elm;if(classAdded){contents.removeClass(classAdded);classAdded=null;}if(angular.isFunction($scope.col.footerCellClass)){classAdded=$scope.col.footerCellClass($scope.grid,$scope.row,$scope.col,$scope.rowRenderIndex,$scope.colRenderIndex);}else{classAdded=$scope.col.footerCellClass;}contents.addClass(classAdded);};if($scope.col.footerCellClass){updateClass();}$scope.col.updateAggregationValue();// Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
var dataChangeDereg=$scope.grid.registerDataChangeCallback(updateClass,[uiGridConstants.dataChange.COLUMN]);// listen for visible rows change and update aggregation values
$scope.grid.api.core.on.rowsRendered($scope,$scope.col.updateAggregationValue);$scope.grid.api.core.on.rowsRendered($scope,updateClass);$scope.$on('$destroy',dataChangeDereg);}};}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridFooter',['$templateCache','$compile','uiGridConstants','gridUtil','$timeout',function($templateCache,$compile,uiGridConstants,gridUtil,$timeout){return{restrict:'EA',replace:true,// priority: 1000,
require:['^uiGrid','^uiGridRenderContainer'],scope:true,compile:function($elm,$attrs){return{pre:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var containerCtrl=controllers[1];$scope.grid=uiGridCtrl.grid;$scope.colContainer=containerCtrl.colContainer;containerCtrl.footer=$elm;var footerTemplate=$scope.grid.options.footerTemplate;gridUtil.getTemplate(footerTemplate).then(function(contents){var template=angular.element(contents);var newElm=$compile(template)($scope);$elm.append(newElm);if(containerCtrl){// Inject a reference to the footer viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
var footerViewport=$elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];if(footerViewport){containerCtrl.footerViewport=footerViewport;}}}).catch(angular.noop);},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var containerCtrl=controllers[1];// gridUtil.logDebug('ui-grid-footer link');
var grid=uiGridCtrl.grid;// Don't animate footer cells
gridUtil.disableAnimations($elm);containerCtrl.footer=$elm;var footerViewport=$elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];if(footerViewport){containerCtrl.footerViewport=footerViewport;}}};}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridGridFooter',['$templateCache','$compile','uiGridConstants','gridUtil',function($templateCache,$compile,uiGridConstants,gridUtil){return{restrict:'EA',replace:true,require:'^uiGrid',scope:true,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){$scope.grid=uiGridCtrl.grid;var footerTemplate=$scope.grid.options.gridFooterTemplate;gridUtil.getTemplate(footerTemplate).then(function(contents){var template=angular.element(contents),newElm=$compile(template)($scope);$elm.append(newElm);}).catch(angular.noop);}};}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridHeaderCell',['$compile','$timeout','$window','$document','gridUtil','uiGridConstants','ScrollEvent','i18nService','$rootScope',function($compile,$timeout,$window,$document,gridUtil,uiGridConstants,ScrollEvent,i18nService,$rootScope){// Do stuff after mouse has been down this many ms on the header cell
var mousedownTimeout=500,changeModeTimeout=500;// length of time between a touch event and a mouse event being recognised again, and vice versa
return{priority:0,scope:{col:'=',row:'=',renderIndex:'='},require:['^uiGrid','^uiGridRenderContainer'],replace:true,compile:function(){return{pre:function($scope,$elm){var template=$scope.col.headerCellTemplate;if(template===undefined&&$scope.col.providedHeaderCellTemplate!==''){if($scope.col.headerCellTemplatePromise){$scope.col.headerCellTemplatePromise.then(function(){template=$scope.col.headerCellTemplate;$elm.append($compile(template)($scope));});}}else{$elm.append($compile(template)($scope));}},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var renderContainerCtrl=controllers[1];$scope.i18n={headerCell:i18nService.getSafeText('headerCell'),sort:i18nService.getSafeText('sort')};$scope.isSortPriorityVisible=function(){// show sort priority if column is sorted and there is at least one other sorted column
return $scope.col&&$scope.col.sort&&angular.isNumber($scope.col.sort.priority)&&$scope.grid.columns.some(function(element,index){return angular.isNumber(element.sort.priority)&&element!==$scope.col;});};$scope.getSortDirectionAriaLabel=function(){var col=$scope.col;// Trying to recreate this sort of thing but it was getting messy having it in the template.
// Sort direction {{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending': 'none')}}.
// {{col.sort.priority ? {{columnPriorityText}} {{col.sort.priority}} : ''}
var label=col.sort&&col.sort.direction===uiGridConstants.ASC?$scope.i18n.sort.ascending:col.sort&&col.sort.direction===uiGridConstants.DESC?$scope.i18n.sort.descending:$scope.i18n.sort.none;if($scope.isSortPriorityVisible()){label=label+'. '+$scope.i18n.headerCell.priority+' '+(col.sort.priority+1);}return label;};$scope.grid=uiGridCtrl.grid;$scope.renderContainer=uiGridCtrl.grid.renderContainers[renderContainerCtrl.containerId];var initColClass=$scope.col.getColClass(false);$elm.addClass(initColClass);// Hide the menu by default
$scope.menuShown=false;$scope.col.menuShown=false;// Put asc and desc sort directions in scope
$scope.asc=uiGridConstants.ASC;$scope.desc=uiGridConstants.DESC;// Store a reference to menu element
var $contentsElm=angular.element($elm[0].querySelectorAll('.ui-grid-cell-contents'));// apply any headerCellClass
var classAdded,previousMouseX;// filter watchers
var filterDeregisters=[];/*
             * Our basic approach here for event handlers is that we listen for a down event (mousedown or touchstart).
             * Once we have a down event, we need to work out whether we have a click, a drag, or a
             * hold.  A click would sort the grid (if sortable).  A drag would be used by moveable, so
             * we ignore it.  A hold would open the menu.
             *
             * So, on down event, we put in place handlers for move and up events, and a timer.  If the
             * timer expires before we see a move or up, then we have a long press and hence a column menu open.
             * If the up happens before the timer, then we have a click, and we sort if the column is sortable.
             * If a move happens before the timer, then we are doing column move, so we do nothing, the moveable feature
             * will handle it.
             *
             * To deal with touch enabled devices that also have mice, we only create our handlers when
             * we get the down event, and we create the corresponding handlers - if we're touchstart then
             * we get touchmove and touchend, if we're mousedown then we get mousemove and mouseup.
             *
             * We also suppress the click action whilst this is happening - otherwise after the mouseup there
             * will be a click event and that can cause the column menu to close
             *
             */$scope.downFn=function(event){event.stopPropagation();if(typeof event.originalEvent!=='undefined'&&event.originalEvent!==undefined){event=event.originalEvent;}// Don't show the menu if it's not the left button
if(event.button&&event.button!==0){return;}previousMouseX=event.pageX;$scope.mousedownStartTime=new Date().getTime();$scope.mousedownTimeout=$timeout(function(){},mousedownTimeout);$scope.mousedownTimeout.then(function(){if($scope.colMenu){uiGridCtrl.columnMenuScope.showMenu($scope.col,$elm,event);}}).catch(angular.noop);uiGridCtrl.fireEvent(uiGridConstants.events.COLUMN_HEADER_CLICK,{event:event,columnName:$scope.col.colDef.name});$scope.offAllEvents();if(event.type==='touchstart'){$document.on('touchend',$scope.upFn);$document.on('touchmove',$scope.moveFn);}else if(event.type==='mousedown'){$document.on('mouseup',$scope.upFn);$document.on('mousemove',$scope.moveFn);}};$scope.upFn=function(event){event.stopPropagation();$timeout.cancel($scope.mousedownTimeout);$scope.offAllEvents();$scope.onDownEvents(event.type);var mousedownEndTime=new Date().getTime();var mousedownTime=mousedownEndTime-$scope.mousedownStartTime;if(mousedownTime>mousedownTimeout){// long click, handled above with mousedown
}else{// short click
if($scope.sortable){$scope.handleClick(event);}}};$scope.handleKeyDown=function(event){if(event.keyCode===32||event.keyCode===13){event.preventDefault();$scope.handleClick(event);}};$scope.moveFn=function(event){// Chrome is known to fire some bogus move events.
var changeValue=event.pageX-previousMouseX;if(changeValue===0){return;}// we're a move, so do nothing and leave for column move (if enabled) to take over
$timeout.cancel($scope.mousedownTimeout);$scope.offAllEvents();$scope.onDownEvents(event.type);};$scope.clickFn=function(event){event.stopPropagation();$contentsElm.off('click',$scope.clickFn);};$scope.offAllEvents=function(){$contentsElm.off('touchstart',$scope.downFn);$contentsElm.off('mousedown',$scope.downFn);$document.off('touchend',$scope.upFn);$document.off('mouseup',$scope.upFn);$document.off('touchmove',$scope.moveFn);$document.off('mousemove',$scope.moveFn);$contentsElm.off('click',$scope.clickFn);};$scope.onDownEvents=function(type){// If there is a previous event, then wait a while before
// activating the other mode - i.e. if the last event was a touch event then
// don't enable mouse events for a wee while (500ms or so)
// Avoids problems with devices that emulate mouse events when you have touch events
switch(type){case'touchmove':case'touchend':$contentsElm.on('click',$scope.clickFn);$contentsElm.on('touchstart',$scope.downFn);$timeout(function(){$contentsElm.on('mousedown',$scope.downFn);},changeModeTimeout);break;case'mousemove':case'mouseup':$contentsElm.on('click',$scope.clickFn);$contentsElm.on('mousedown',$scope.downFn);$timeout(function(){$contentsElm.on('touchstart',$scope.downFn);},changeModeTimeout);break;default:$contentsElm.on('click',$scope.clickFn);$contentsElm.on('touchstart',$scope.downFn);$contentsElm.on('mousedown',$scope.downFn);}};var setFilter=function(updateFilters){if(updateFilters){if(typeof $scope.col.updateFilters!=='undefined'){$scope.col.updateFilters($scope.col.filterable);}// if column is filterable add a filter watcher
if($scope.col.filterable){$scope.col.filters.forEach(function(filter,i){filterDeregisters.push($scope.$watch('col.filters['+i+'].term',function(n,o){if(n!==o){uiGridCtrl.grid.api.core.raise.filterChanged($scope.col);uiGridCtrl.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);uiGridCtrl.grid.queueGridRefresh();}}));});$scope.$on('$destroy',function(){filterDeregisters.forEach(function(filterDeregister){filterDeregister();});});}else{filterDeregisters.forEach(function(filterDeregister){filterDeregister();});}}};var updateHeaderOptions=function(){var contents=$elm;if(classAdded){contents.removeClass(classAdded);classAdded=null;}if(angular.isFunction($scope.col.headerCellClass)){classAdded=$scope.col.headerCellClass($scope.grid,$scope.row,$scope.col,$scope.rowRenderIndex,$scope.colRenderIndex);}else{classAdded=$scope.col.headerCellClass;}contents.addClass(classAdded);$scope.$applyAsync(function(){var rightMostContainer=$scope.grid.renderContainers['right']&&$scope.grid.renderContainers['right'].visibleColumnCache.length?$scope.grid.renderContainers['right']:$scope.grid.renderContainers['body'];$scope.isLastCol=uiGridCtrl.grid.options&&uiGridCtrl.grid.options.enableGridMenu&&$scope.col===rightMostContainer.visibleColumnCache[rightMostContainer.visibleColumnCache.length-1];});// Figure out whether this column is sortable or not
$scope.sortable=Boolean($scope.col.enableSorting);// Figure out whether this column is filterable or not
var oldFilterable=$scope.col.filterable;$scope.col.filterable=Boolean(uiGridCtrl.grid.options.enableFiltering&&$scope.col.enableFiltering);setFilter(oldFilterable!==$scope.col.filterable);// figure out whether we support column menus
$scope.colMenu=$scope.col.grid.options&&$scope.col.grid.options.enableColumnMenus!==false&&$scope.col.colDef&&$scope.col.colDef.enableColumnMenu!==false;/**
               * @ngdoc property
               * @name enableColumnMenu
               * @propertyOf ui.grid.class:GridOptions.columnDef
               * @description if column menus are enabled, controls the column menus for this specific
               * column (i.e. if gridOptions.enableColumnMenus, then you can control column menus
               * using this option. If gridOptions.enableColumnMenus === false then you get no column
               * menus irrespective of the value of this option ).  Defaults to true.
               *
               * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
               *
               * <pre>
               *  .ui-grid-column-menu-button {
               *    display: block;
               *  }
               * </pre>
               */ /**
              * @ngdoc property
              * @name enableColumnMenus
              * @propertyOf ui.grid.class:GridOptions.columnDef
              * @description Override for column menus everywhere - if set to false then you get no
              * column menus.  Defaults to true.
              *
              */$scope.offAllEvents();if($scope.sortable||$scope.colMenu){$scope.onDownEvents();$scope.$on('$destroy',function(){$scope.offAllEvents();});}};updateHeaderOptions();if($scope.col.filterContainer==='columnMenu'&&$scope.col.filterable){$rootScope.$on('menu-shown',function(){$scope.$applyAsync(function(){setFilter($scope.col.filterable);});});}// Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
var dataChangeDereg=$scope.grid.registerDataChangeCallback(updateHeaderOptions,[uiGridConstants.dataChange.COLUMN]);$scope.$on('$destroy',dataChangeDereg);$scope.handleClick=function(event){// If the shift key is being held down, add this column to the sort
// Sort this column then rebuild the grid's rows
uiGridCtrl.grid.sortColumn($scope.col,event.shiftKey).then(function(){if(uiGridCtrl.columnMenuScope){uiGridCtrl.columnMenuScope.hideMenu();}uiGridCtrl.grid.refresh();}).catch(angular.noop);};$scope.headerCellArrowKeyDown=function(event){if(event.keyCode===uiGridConstants.keymap.SPACE||event.keyCode===uiGridConstants.keymap.ENTER){event.preventDefault();$scope.toggleMenu(event);}};$scope.toggleMenu=function(event){event.stopPropagation();// If the menu is already showing and we're the column the menu is on
if(uiGridCtrl.columnMenuScope.menuShown&&uiGridCtrl.columnMenuScope.col===$scope.col){// ... hide it
uiGridCtrl.columnMenuScope.hideMenu();}// If the menu is NOT showing or is showing in a different column
else{// ... show it on our column
uiGridCtrl.columnMenuScope.showMenu($scope.col,$elm);}};}};}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridHeader',['$templateCache','$compile','uiGridConstants','gridUtil','$timeout','ScrollEvent',function($templateCache,$compile,uiGridConstants,gridUtil,$timeout,ScrollEvent){var defaultTemplate='ui-grid/ui-grid-header',emptyTemplate='ui-grid/ui-grid-no-header';return{restrict:'EA',replace:true,require:['^uiGrid','^uiGridRenderContainer'],scope:true,compile:function(){return{pre:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0],containerCtrl=controllers[1];$scope.grid=uiGridCtrl.grid;$scope.colContainer=containerCtrl.colContainer;updateHeaderReferences();var headerTemplate;if(!$scope.grid.options.showHeader){headerTemplate=emptyTemplate;}else{headerTemplate=$scope.grid.options.headerTemplate?$scope.grid.options.headerTemplate:defaultTemplate;}gridUtil.getTemplate(headerTemplate).then(function(contents){var template=angular.element(contents);var newElm=$compile(template)($scope);$elm.replaceWith(newElm);// And update $elm to be the new element
$elm=newElm;updateHeaderReferences();if(containerCtrl){// Inject a reference to the header viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
var headerViewport=$elm[0].getElementsByClassName('ui-grid-header-viewport')[0];if(headerViewport){containerCtrl.headerViewport=headerViewport;angular.element(headerViewport).on('scroll',scrollHandler);$scope.$on('$destroy',function(){angular.element(headerViewport).off('scroll',scrollHandler);});}}$scope.grid.queueRefresh();}).catch(angular.noop);function updateHeaderReferences(){containerCtrl.header=containerCtrl.colContainer.header=$elm;var headerCanvases=$elm[0].getElementsByClassName('ui-grid-header-canvas');if(headerCanvases.length>0){containerCtrl.headerCanvas=containerCtrl.colContainer.headerCanvas=headerCanvases[0];}else{containerCtrl.headerCanvas=null;}}function scrollHandler(){if(uiGridCtrl.grid.isScrollingHorizontally){return;}var newScrollLeft=gridUtil.normalizeScrollLeft(containerCtrl.headerViewport,uiGridCtrl.grid);var horizScrollPercentage=containerCtrl.colContainer.scrollHorizontal(newScrollLeft);var scrollEvent=new ScrollEvent(uiGridCtrl.grid,null,containerCtrl.colContainer,ScrollEvent.Sources.ViewPortScroll);scrollEvent.newScrollLeft=newScrollLeft;if(horizScrollPercentage>-1){scrollEvent.x={percentage:horizScrollPercentage};}uiGridCtrl.grid.scrollContainers(null,scrollEvent);}},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var containerCtrl=controllers[1];// gridUtil.logDebug('ui-grid-header link');
var grid=uiGridCtrl.grid;// Don't animate header cells
gridUtil.disableAnimations($elm);function updateColumnWidths(){// this styleBuilder always runs after the renderContainer, so we can rely on the column widths
// already being populated correctly
var columnCache=containerCtrl.colContainer.visibleColumnCache;// Build the CSS
// uiGridCtrl.grid.columns.forEach(function (column) {
var ret='';var canvasWidth=0;columnCache.forEach(function(column){ret=ret+column.getColClassDefinition();canvasWidth+=column.drawnWidth;});containerCtrl.colContainer.canvasWidth=canvasWidth;// Return the styles back to buildStyles which pops them into the `customStyles` scope variable
return ret;}containerCtrl.header=$elm;var headerViewport=$elm[0].getElementsByClassName('ui-grid-header-viewport')[0];if(headerViewport){containerCtrl.headerViewport=headerViewport;}// todo: remove this if by injecting gridCtrl into unit tests
if(uiGridCtrl){uiGridCtrl.grid.registerStyleComputation({priority:15,func:updateColumnWidths});}}};}};}]);})();(function(){angular.module('ui.grid').service('uiGridGridMenuService',['gridUtil','i18nService','uiGridConstants',function(gridUtil,i18nService,uiGridConstants){/**
   *  @ngdoc service
   *  @name ui.grid.uiGridGridMenuService
   *
   *  @description Methods for working with the grid menu
   */var service={/**
     * @ngdoc method
     * @methodOf ui.grid.uiGridGridMenuService
     * @name initialize
     * @description Sets up the gridMenu. Most importantly, sets our
     * scope onto the grid object as grid.gridMenuScope, allowing us
     * to operate when passed only the grid.  Second most importantly,
     * we register the 'addToGridMenu' and 'removeFromGridMenu' methods
     * on the core api.
     * @param {$scope} $scope the scope of this gridMenu
     * @param {Grid} grid the grid to which this gridMenu is associated
     */initialize:function($scope,grid){grid.gridMenuScope=$scope;$scope.grid=grid;$scope.registeredMenuItems=[];// not certain this is needed, but would be bad to create a memory leak
$scope.$on('$destroy',function(){if($scope.grid&&$scope.grid.gridMenuScope){$scope.grid.gridMenuScope=null;}if($scope.grid){$scope.grid=null;}if($scope.registeredMenuItems){$scope.registeredMenuItems=null;}});$scope.registeredMenuItems=[];/**
       * @ngdoc function
       * @name addToGridMenu
       * @methodOf ui.grid.api:PublicApi
       * @description add items to the grid menu.  Used by features
       * to add their menu items if they are enabled, can also be used by
       * end users to add menu items.  This method has the advantage of allowing
       * remove again, which can simplify management of which items are included
       * in the menu when.  (Noting that in most cases the shown and active functions
       * provide a better way to handle visibility of menu items)
       * @param {Grid} grid the grid on which we are acting
       * @param {array} items menu items in the format as described in the tutorial, with
       * the added note that if you want to use remove you must also specify an `id` field,
       * which is provided when you want to remove an item.  The id should be unique.
       *
       */grid.api.registerMethod('core','addToGridMenu',service.addToGridMenu);/**
       * @ngdoc function
       * @name removeFromGridMenu
       * @methodOf ui.grid.api:PublicApi
       * @description Remove an item from the grid menu based on a provided id. Assumes
       * that the id is unique, removes only the last instance of that id. Does nothing if
       * the specified id is not found
       * @param {Grid} grid the grid on which we are acting
       * @param {string} id the id we'd like to remove from the menu
       *
       */grid.api.registerMethod('core','removeFromGridMenu',service.removeFromGridMenu);},/**
     * @ngdoc function
     * @name addToGridMenu
     * @propertyOf ui.grid.uiGridGridMenuService
     * @description add items to the grid menu.  Used by features
     * to add their menu items if they are enabled, can also be used by
     * end users to add menu items.  This method has the advantage of allowing
     * remove again, which can simplify management of which items are included
     * in the menu when.  (Noting that in most cases the shown and active functions
     * provide a better way to handle visibility of menu items)
     * @param {Grid} grid the grid on which we are acting
     * @param {array} menuItems menu items in the format as described in the tutorial, with
     * the added note that if you want to use remove you must also specify an `id` field,
     * which is provided when you want to remove an item.  The id should be unique.
     *
     */addToGridMenu:function(grid,menuItems){if(!angular.isArray(menuItems)){gridUtil.logError('addToGridMenu: menuItems must be an array, and is not, not adding any items');}else{if(grid.gridMenuScope){grid.gridMenuScope.registeredMenuItems=grid.gridMenuScope.registeredMenuItems?grid.gridMenuScope.registeredMenuItems:[];grid.gridMenuScope.registeredMenuItems=grid.gridMenuScope.registeredMenuItems.concat(menuItems);}else{gridUtil.logError('Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid');}}},/**
     * @ngdoc function
     * @name removeFromGridMenu
     * @methodOf ui.grid.uiGridGridMenuService
     * @description Remove an item from the grid menu based on a provided id.  Assumes
     * that the id is unique, removes only the last instance of that id.  Does nothing if
     * the specified id is not found.  If there is no gridMenuScope or registeredMenuItems
     * then do nothing silently - the desired result is those menu items not be present and they
     * aren't.
     * @param {Grid} grid the grid on which we are acting
     * @param {string} id the id we'd like to remove from the menu
     *
     */removeFromGridMenu:function(grid,id){var foundIndex=-1;if(grid&&grid.gridMenuScope){grid.gridMenuScope.registeredMenuItems.forEach(function(value,index){if(value.id===id){if(foundIndex>-1){gridUtil.logError('removeFromGridMenu: found multiple items with the same id, removing only the last');}else{foundIndex=index;}}});}if(foundIndex>-1){grid.gridMenuScope.registeredMenuItems.splice(foundIndex,1);}},/**
     * @ngdoc array
     * @name gridMenuCustomItems
     * @propertyOf ui.grid.class:GridOptions
     * @description (optional) An array of menu items that should be added to
     * the gridMenu.  Follow the format documented in the tutorial for column
     * menu customisation.  The context provided to the action function will
     * include context.grid.  An alternative if working with dynamic menus is to use the
     * provided api - core.addToGridMenu and core.removeFromGridMenu, which handles
     * some of the management of items for you.
     *
     */ /**
     * @ngdoc boolean
     * @name gridMenuShowHideColumns
     * @propertyOf ui.grid.class:GridOptions
     * @description true by default, whether the grid menu should allow hide/show
     * of columns
     *
     */ /**
     * @ngdoc method
     * @methodOf ui.grid.uiGridGridMenuService
     * @name getMenuItems
     * @description Decides the menu items to show in the menu.  This is a
     * combination of:
     *
     * - the default menu items that are always included,
     * - any menu items that have been provided through the addMenuItem api. These
     *   are typically added by features within the grid
     * - any menu items included in grid.options.gridMenuCustomItems.  These can be
     *   changed dynamically, as they're always recalculated whenever we show the
     *   menu
     * @param {$scope} $scope the scope of this gridMenu, from which we can find all
     * the information that we need
     * @returns {Array} an array of menu items that can be shown
     */getMenuItems:function($scope){var menuItems=[// this is where we add any menu items we want to always include
];if($scope.grid.options.gridMenuCustomItems){if(!angular.isArray($scope.grid.options.gridMenuCustomItems)){gridUtil.logError('gridOptions.gridMenuCustomItems must be an array, and is not');}else{menuItems=menuItems.concat($scope.grid.options.gridMenuCustomItems);}}var clearFilters=[{title:i18nService.getSafeText('gridMenu.clearAllFilters'),action:function($event){$scope.grid.clearAllFilters();},shown:function(){return $scope.grid.options.enableFiltering;},order:100}];menuItems=menuItems.concat(clearFilters);menuItems=menuItems.concat($scope.registeredMenuItems);if($scope.grid.options.gridMenuShowHideColumns!==false){menuItems=menuItems.concat(service.showHideColumns($scope));}menuItems.sort(function(a,b){return a.order-b.order;});return menuItems;},/**
     * @ngdoc array
     * @name gridMenuTitleFilter
     * @propertyOf ui.grid.class:GridOptions
     * @description (optional) A function that takes a title string
     * (usually the col.displayName), and converts it into a display value.  The function
     * must return either a string or a promise.
     *
     * Used for internationalization of the grid menu column names - for angular-translate
     * you can pass $translate as the function, for i18nService you can pass getSafeText as the
     * function
     * @example
     * <pre>
     *   gridOptions = {
     *     gridMenuTitleFilter: $translate
     *   }
     * </pre>
     */ /**
     * @ngdoc method
     * @methodOf ui.grid.uiGridGridMenuService
     * @name showHideColumns
     * @description Adds two menu items for each of the columns in columnDefs.  One
     * menu item for hide, one menu item for show.  Each is visible when appropriate
     * (show when column is not visible, hide when column is visible).  Each toggles
     * the visible property on the columnDef using toggleColumnVisibility
     * @param {$scope} $scope of a gridMenu, which contains a reference to the grid
     */showHideColumns:function($scope){var showHideColumns=[];if(!$scope.grid.options.columnDefs||$scope.grid.options.columnDefs.length===0||$scope.grid.columns.length===0){return showHideColumns;}function isColumnVisible(colDef){return colDef.visible===true||colDef.visible===undefined;}function getColumnIcon(colDef){return isColumnVisible(colDef)?'ui-grid-icon-ok':'ui-grid-icon-cancel';}$scope.grid.options.gridMenuTitleFilter=$scope.grid.options.gridMenuTitleFilter?$scope.grid.options.gridMenuTitleFilter:function(title){return title;};$scope.grid.options.columnDefs.forEach(function(colDef,index){if($scope.grid.options.enableHiding!==false&&colDef.enableHiding!==false||colDef.enableHiding){// add hide menu item - shows an OK icon as we only show when column is already visible
var menuItem={icon:getColumnIcon(colDef),action:function($event){$event.stopPropagation();service.toggleColumnVisibility(this.context.gridCol);if($event.target&&$event.target.firstChild){if(angular.element($event.target)[0].nodeName==='I'){$event.target.className=getColumnIcon(this.context.gridCol.colDef);}else{$event.target.firstChild.className=getColumnIcon(this.context.gridCol.colDef);}}},shown:function(){return this.context.gridCol.colDef.enableHiding!==false;},context:{gridCol:$scope.grid.getColumn(colDef.name||colDef.field)},leaveOpen:true,order:301+index};service.setMenuItemTitle(menuItem,colDef,$scope.grid);showHideColumns.push(menuItem);}});// add header for columns
if(showHideColumns.length){showHideColumns.unshift({title:i18nService.getSafeText('gridMenu.columns'),order:300,templateUrl:'ui-grid/ui-grid-menu-header-item'});}return showHideColumns;},/**
     * @ngdoc method
     * @methodOf ui.grid.uiGridGridMenuService
     * @name setMenuItemTitle
     * @description Handles the response from gridMenuTitleFilter, adding it directly to the menu
     * item if it returns a string, otherwise waiting for the promise to resolve or reject then
     * putting the result into the title
     * @param {object} menuItem the menuItem we want to put the title on
     * @param {object} colDef the colDef from which we can get displayName, name or field
     * @param {Grid} grid the grid, from which we can get the options.gridMenuTitleFilter
     *
     */setMenuItemTitle:function(menuItem,colDef,grid){var title=grid.options.gridMenuTitleFilter(colDef.displayName||gridUtil.readableColumnName(colDef.name)||colDef.field);if(typeof title==='string'){menuItem.title=title;}else if(title.then){// must be a promise
menuItem.title="";title.then(function(successValue){menuItem.title=successValue;},function(errorValue){menuItem.title=errorValue;}).catch(angular.noop);}else{gridUtil.logError('Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config');menuItem.title='badconfig';}},/**
     * @ngdoc method
     * @methodOf ui.grid.uiGridGridMenuService
     * @name toggleColumnVisibility
     * @description Toggles the visibility of an individual column.  Expects to be
     * provided a context that has on it a gridColumn, which is the column that
     * we'll operate upon.  We change the visibility, and refresh the grid as appropriate
     * @param {GridColumn} gridCol the column that we want to toggle
     *
     */toggleColumnVisibility:function(gridCol){gridCol.colDef.visible=!(gridCol.colDef.visible===true||gridCol.colDef.visible===undefined);gridCol.grid.refresh();gridCol.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);gridCol.grid.api.core.raise.columnVisibilityChanged(gridCol);}};return service;}]).directive('uiGridMenuButton',['gridUtil','uiGridConstants','uiGridGridMenuService','i18nService',function(gridUtil,uiGridConstants,uiGridGridMenuService,i18nService){return{priority:0,scope:true,require:['^uiGrid'],templateUrl:'ui-grid/ui-grid-menu-button',replace:true,link:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];// For the aria label
$scope.i18n={aria:i18nService.getSafeText('gridMenu.aria')};uiGridGridMenuService.initialize($scope,uiGridCtrl.grid);$scope.shown=false;$scope.toggleOnKeydown=function(event){if(event.keyCode===uiGridConstants.keymap.ENTER||event.keyCode===uiGridConstants.keymap.SPACE||event.keyCode===uiGridConstants.keymap.ESC&&$scope.shown){$scope.toggleMenu();}};$scope.toggleMenu=function(){if($scope.shown){$scope.$broadcast('hide-menu');$scope.shown=false;}else{$scope.menuItems=uiGridGridMenuService.getMenuItems($scope);$scope.$broadcast('show-menu');$scope.shown=true;}};$scope.$on('menu-hidden',function(){$scope.shown=false;gridUtil.focus.bySelector($elm,'.ui-grid-icon-container');});}};}]);})();(function(){/**
 * @ngdoc directive
 * @name ui.grid.directive:uiGridMenu
 * @element style
 * @restrict A
 *
 * @description
 * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
 *
 * @example
 <doc:example module="app">
 <doc:source>
 <script>
 var app = angular.module('app', ['ui.grid']);

 app.controller('MainCtrl', ['$scope', function ($scope) {

 }]);
 </script>

 <div ng-controller="MainCtrl">
   <div ui-grid-menu shown="true"  ></div>
 </div>
 </doc:source>
 <doc:scenario>
 </doc:scenario>
 </doc:example>
 */angular.module('ui.grid').directive('uiGridMenu',['$compile','$timeout','$window','$document','gridUtil','uiGridConstants','i18nService',function($compile,$timeout,$window,$document,gridUtil,uiGridConstants,i18nService){return{priority:0,scope:{// shown: '&',
menuItems:'=',autoHide:'=?',col:'=?'},require:'?^uiGrid',templateUrl:'ui-grid/uiGridMenu',replace:false,link:function($scope,$elm,$attrs,uiGridCtrl){$scope.dynamicStyles='';if(uiGridCtrl&&uiGridCtrl.grid&&uiGridCtrl.grid.options&&uiGridCtrl.grid.options.gridMenuTemplate){var gridMenuTemplate=uiGridCtrl.grid.options.gridMenuTemplate;gridUtil.getTemplate(gridMenuTemplate).then(function(contents){var template=angular.element(contents);var newElm=$compile(template)($scope);$elm.replaceWith(newElm);}).catch(angular.noop);}var setupHeightStyle=function(gridHeight){// menu appears under header row, so substract that height from it's total
// additional 20px for general padding
var gridMenuMaxHeight=gridHeight-uiGridCtrl.grid.headerHeight-20;$scope.dynamicStyles=['.grid'+uiGridCtrl.grid.id+' .ui-grid-menu-mid {','max-height: '+gridMenuMaxHeight+'px;','}'].join(' ');};if(uiGridCtrl){setupHeightStyle(uiGridCtrl.grid.gridHeight);uiGridCtrl.grid.api.core.on.gridDimensionChanged($scope,function(oldGridHeight,oldGridWidth,newGridHeight,newGridWidth){setupHeightStyle(newGridHeight);});}$scope.i18n={close:i18nService.getSafeText('columnMenu.close')};// *** Show/Hide functions ******
$scope.showMenu=function(event,args){if(!$scope.shown){/*
           * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
           * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
           * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
           * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
           * on scroll events.
           *
           * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
           * like they do, but angular has a default $animate provider that is just a stub, and that's what's
           * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
           * angular-translate.js, it's not using it.  You need to test animations in an external application.
           */$scope.shown=true;// Must be a timeout in order to work properly in Firefox. Issue #6533
$timeout(function(){$scope.shownMid=true;$scope.$emit('menu-shown');});}else if(!$scope.shownMid){// we're probably doing a hide then show, so we don't need to wait for ng-if
$scope.shownMid=true;$scope.$emit('menu-shown');}var docEventType='click';if(args&&args.originalEvent&&args.originalEvent.type&&args.originalEvent.type==='touchstart'){docEventType=args.originalEvent.type;}// Turn off an existing document click handler
angular.element(document).off('click touchstart',applyHideMenu);// Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
$timeout(function(){angular.element(document).on(docEventType,applyHideMenu);});};$scope.hideMenu=function(event){if($scope.shown){/*
           * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
           * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
           * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
           *
           * The user may have clicked on the menu again whilst
           * we're waiting, so we check that the mid isn't shown before applying the ng-if.
           */$scope.shownMid=false;$timeout(function(){if(!$scope.shownMid){$scope.shown=false;$scope.$emit('menu-hidden');}},40);}angular.element(document).off('click touchstart',applyHideMenu);};$scope.$on('hide-menu',function(event,args){$scope.hideMenu(event,args);});$scope.$on('show-menu',function(event,args){$scope.showMenu(event,args);});// *** Auto hide when click elsewhere ******
var applyHideMenu=function(event){if($scope.shown){var disableGridMenuHideOnScroll=uiGridCtrl&&uiGridCtrl.grid&&uiGridCtrl.grid.options?uiGridCtrl.grid.options.disableGridMenuHideOnScroll:null;if(event.type!=='scroll'||!disableGridMenuHideOnScroll){if($scope.col&&$scope.col.filterContainer==='columnMenu'){var elm=document.querySelector('.ui-grid-column-menu').querySelector('[ui-grid-filter]');if(elm&&elm.contains(event.target)){return false;}}$scope.$apply(function(){$scope.hideMenu();});}}};$scope.checkKeyDown=function(event){var setFocus=function(elm){elm.focus();event.preventDefault();};if(event.keyCode===uiGridConstants.keymap.ESC){$scope.hideMenu();}else if(event.keyCode===uiGridConstants.keymap.TAB){var firstMenuItem,lastMenuItem;var menuItemButtons=$elm[0].querySelectorAll('button:not(.ng-hide)');if(menuItemButtons.length>0){firstMenuItem=menuItemButtons[0];lastMenuItem=menuItemButtons[menuItemButtons.length-1];if(event.target.parentElement.id===lastMenuItem.parentElement.id&&!event.shiftKey){setFocus(firstMenuItem);}else if(event.target.parentElement.id===firstMenuItem.parentElement.id&&event.shiftKey){setFocus(lastMenuItem);}}}};if(typeof $scope.autoHide==='undefined'||$scope.autoHide===undefined){$scope.autoHide=true;}if($scope.autoHide){angular.element($window).on('resize',applyHideMenu);}$scope.$on('$destroy',function unbindEvents(){angular.element($window).off('resize',applyHideMenu);angular.element(document).off('click touchstart',applyHideMenu);});if(uiGridCtrl){$scope.$on('$destroy',uiGridCtrl.grid.api.core.on.scrollBegin($scope,applyHideMenu));}$scope.$on('$destroy',$scope.$on(uiGridConstants.events.ITEM_DRAGGING,applyHideMenu));}};}]).directive('uiGridMenuItem',['gridUtil','$compile','i18nService',function(gridUtil,$compile,i18nService){return{priority:0,scope:{name:'=',active:'=',action:'=',icon:'=',shown:'=',context:'=',templateUrl:'=',leaveOpen:'=',screenReaderOnly:'='},require:['?^uiGrid'],templateUrl:'ui-grid/uiGridMenuItem',replace:false,compile:function(){return{pre:function($scope,$elm){if($scope.templateUrl){gridUtil.getTemplate($scope.templateUrl).then(function(contents){var template=angular.element(contents);var newElm=$compile(template)($scope);$elm.replaceWith(newElm);}).catch(angular.noop);}},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];// TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
// if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
//   throw new TypeError("$scope.shown is defined but not a function");
// }
if(typeof $scope.shown==='undefined'||$scope.shown===null){$scope.shown=function(){return true;};}$scope.itemShown=function(){var context={};if($scope.context){context.context=$scope.context;}if(typeof uiGridCtrl!=='undefined'&&uiGridCtrl){context.grid=uiGridCtrl.grid;}return $scope.shown.call(context);};$scope.itemAction=function($event,title){$event.stopPropagation();if(typeof $scope.action==='function'){var context={};if($scope.context){context.context=$scope.context;}// Add the grid to the function call context if the uiGrid controller is present
if(typeof uiGridCtrl!=='undefined'&&uiGridCtrl){context.grid=uiGridCtrl.grid;}$scope.action.call(context,$event,title);if(!$scope.leaveOpen){$scope.$emit('hide-menu');}else{// Maintain focus on the selected item
var correctParent=$event.target.parentElement;// nodeName of 'I' means target is i element, need the next parent
if(angular.element($event.target)[0].nodeName==='I'){correctParent=correctParent.parentElement;}gridUtil.focus.bySelector(correctParent,'button[type=button]',true);}}};$scope.label=function(){var toBeDisplayed=$scope.name;if(typeof $scope.name==='function'){toBeDisplayed=$scope.name.call();}return toBeDisplayed;};$scope.i18n=i18nService.get();}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.directive:uiGridOneBind
   * @summary A group of directives that provide a one time bind to a dom element.
   * @description A group of directives that provide a one time bind to a dom element.
   * As one time bindings are not supported in Angular 1.2.* this directive provdes this capability.
   * This is done to reduce the number of watchers on the dom.
   * <br/>
   * <h2>Short Example ({@link ui.grid.directive:uiGridOneBindSrc ui-grid-one-bind-src})</h2>
   * <pre>
        <div ng-init="imageName = 'myImageDir.jpg'">
          <img ui-grid-one-bind-src="imageName"></img>
        </div>
     </pre>
   * Will become:
   * <pre>
       <div ng-init="imageName = 'myImageDir.jpg'">
         <img ui-grid-one-bind-src="imageName" src="myImageDir.jpg"></img>
       </div>
     </pre>
     </br>
     <h2>Short Example ({@link ui.grid.directive:uiGridOneBindText ui-grid-one-bind-text})</h2>
   * <pre>
        <div ng-init="text='Add this text'" ui-grid-one-bind-text="text"></div>
     </pre>
   * Will become:
   * <pre>
   <div ng-init="text='Add this text'" ui-grid-one-bind-text="text">Add this text</div>
     </pre>
     </br>
   * <b>Note:</b> This behavior is slightly different for the {@link ui.grid.directive:uiGridOneBindIdGrid uiGridOneBindIdGrid}
   * and {@link ui.grid.directive:uiGridOneBindAriaLabelledbyGrid uiGridOneBindAriaLabelledbyGrid} directives.
   *
   */ // https://github.com/joshkurz/Black-Belt-AngularJS-Directives/blob/master/directives/Optimization/oneBind.js
var oneBinders=angular.module('ui.grid');angular.forEach([/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindSrc
       * @memberof ui.grid.directive:uiGridOneBind
       * @element img
       * @restrict A
       * @param {String} uiGridOneBindSrc The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the src dom tag.
       *
       */{tag:'Src',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindText
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindText The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the text dom tag.
       */{tag:'Text',method:'text'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindHref
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindHref The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the href dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Href',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindClass
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindClass The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @param {Object} uiGridOneBindClass The object that you want to bind. At least one of the values in the object must be something other than null or undefined for the watcher to be removed.
       *                                    this is to prevent the watcher from being removed before the scope is initialized.
       * @param {Array} uiGridOneBindClass An array of classes to bind to this element.
       * @description One time binding for the class dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Class',method:'addClass'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindHtml
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindHtml The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the html method on a dom element. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Html',method:'html'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAlt
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindAlt The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the alt dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Alt',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindStyle
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindStyle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the style dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Style',method:'css'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindValue
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindValue The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Value',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindId
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindId The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Id',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindIdGrid
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindIdGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the id dom tag.
       * <h1>Important Note!</h1>
       * If the id tag passed as a parameter does <b>not</b> contain the grid id as a substring
       * then the directive will search the scope and the parent controller (if it is a uiGridController) for the grid.id value.
       * If this value is found then it is appended to the begining of the id tag. If the grid is not found then the directive throws an error.
       * This is done in order to ensure uniqueness of id tags across the grid.
       * This is to prevent two grids in the same document having duplicate id tags.
       */{tag:'Id',directiveName:'IdGrid',method:'attr',appendGridId:true},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindTitle
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindTitle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the title dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       */{tag:'Title',method:'attr'},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAriaLabel
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindAriaLabel The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the aria-label dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       *<br/>
       * <pre>
            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text"></div>
         </pre>
       * Will become:
       * <pre>
            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text" aria-label="Add this text"></div>
         </pre>
       */{tag:'Label',method:'attr',aria:true},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAriaLabelledby
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindAriaLabelledby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       *<br/>
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId"></div>
         </pre>
       * Will become:
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId" aria-labelledby="gridID32"></div>
         </pre>
       */{tag:'Labelledby',method:'attr',aria:true},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAriaLabelledbyGrid
       * @element div
       * @restrict A
       * @param {String} uiGridOneBindAriaLabelledbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
       * grid id to each one.
       *<br/>
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId"></div>
         </pre>
       * Will become ([grid.id] will be replaced by the actual grid id):
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId" aria-labelledby-Grid="[grid.id]-gridID32"></div>
         </pre>
       */{tag:'Labelledby',directiveName:'LabelledbyGrid',appendGridId:true,method:'attr',aria:true},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAriaDescribedby
       * @element ANY
       * @restrict A
       * @param {String} uiGridOneBindAriaDescribedby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the aria-describedby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       *<br/>
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId"></div>
         </pre>
       * Will become:
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId" aria-describedby="gridID32"></div>
         </pre>
       */{tag:'Describedby',method:'attr',aria:true},/**
       * @ngdoc directive
       * @name ui.grid.directive:uiGridOneBindAriaDescribedbyGrid
       * @element ANY
       * @restrict A
       * @param {String} uiGridOneBindAriaDescribedbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
       * grid id to each one.
       *<br/>
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId"></div>
         </pre>
       * Will become ([grid.id] will be replaced by the actual grid id):
       * <pre>
            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId" aria-describedby="[grid.id]-gridID32"></div>
         </pre>
       */{tag:'Describedby',directiveName:'DescribedbyGrid',appendGridId:true,method:'attr',aria:true}],function(v){var baseDirectiveName='uiGridOneBind';// If it is an aria tag then append the aria label seperately
// This is done because the aria tags are formatted aria-* and the directive name can't have a '-' character in it.
// If the diretiveName has to be overridden then it does so here. This is because the tag being modified and the directive sometimes don't
// match up.
var directiveName=(v.aria?baseDirectiveName+'Aria':baseDirectiveName)+(v.directiveName?v.directiveName:v.tag);oneBinders.directive(directiveName,['gridUtil',function(gridUtil){return{restrict:'A',require:['?uiGrid','?^uiGrid'],link:function(scope,iElement,iAttrs,controllers){/* Appends the grid id to the beginning of the value. */var appendGridId=function(val){var grid;// Get an instance of the grid if its available
// If its available in the scope then we don't need to try to find it elsewhere
if(scope.grid){grid=scope.grid;}// Another possible location to try to find the grid
else if(scope.col&&scope.col.grid){grid=scope.col.grid;}// Last ditch effort: Search through the provided controllers.
else if(!controllers.some(// Go through the controllers till one has the element we need
function(controller){if(controller&&controller.grid){grid=controller.grid;return true;// We've found the grid
}})){// We tried our best to find it for you
gridUtil.logError("["+directiveName+"] A valid grid could not be found to bind id. Are you using this directive "+"within the correct scope? Trying to generate id: [gridID]-"+val);throw new Error("No valid grid could be found");}if(grid){var idRegex=new RegExp(grid.id.toString());// If the grid id hasn't been appended already in the template declaration
if(!idRegex.test(val)){val=grid.id.toString()+'-'+val;}}return val;};// The watch returns a function to remove itself.
var rmWatcher=scope.$watch(iAttrs[directiveName],function(newV){if(newV){// If we are trying to add an id element then we also apply the grid id if it isn't already there
if(v.appendGridId){var newIdString=null;// Append the id to all of the new ids.
angular.forEach(newV.split(' '),function(s){newIdString=(newIdString?newIdString+' ':'')+appendGridId(s);});newV=newIdString;}// Append this newValue to the dom element.
switch(v.method){case'attr':// The attr method takes two paraams the tag and the value
if(v.aria){// If it is an aria element then append the aria prefix
iElement[v.method]('aria-'+v.tag.toLowerCase(),newV);}else{iElement[v.method](v.tag.toLowerCase(),newV);}break;case'addClass':// Pulled from https://github.com/Pasvaz/bindonce/blob/master/bindonce.js
if(angular.isObject(newV)&&!angular.isArray(newV)){var results=[],nonNullFound=false;// We don't want to remove the binding unless the key is actually defined
angular.forEach(newV,function(value,index){if(value!==null&&typeof value!=="undefined"){nonNullFound=true;// A non null value for a key was found so the object must have been initialized
if(value){results.push(index);}}});// A non null value for a key wasn't found so assume that the scope values haven't been fully initialized
if(!nonNullFound){return;// If not initialized then the watcher should not be removed yet.
}newV=results;}if(newV){iElement.addClass(angular.isArray(newV)?newV.join(' '):newV);}else{return;}break;default:iElement[v.method](newV);break;}// Removes the watcher on itself after the bind
rmWatcher();}// True ensures that equality is determined using angular.equals instead of ===
},true);// End rm watchers
}// End compile function
};// End directive return
}// End directive function
]);// End directive
});// End angular foreach
})();(function(){'use strict';var module=angular.module('ui.grid');module.directive('uiGridRenderContainer',['$timeout','$document','uiGridConstants','gridUtil','ScrollEvent',function($timeout,$document,uiGridConstants,gridUtil,ScrollEvent){return{replace:true,transclude:true,templateUrl:'ui-grid/uiGridRenderContainer',require:['^uiGrid','uiGridRenderContainer'],scope:{containerId:'=',rowContainerName:'=',colContainerName:'=',bindScrollHorizontal:'=',bindScrollVertical:'=',enableVerticalScrollbar:'=',enableHorizontalScrollbar:'='},controller:'uiGridRenderContainer as RenderContainer',compile:function(){return{pre:function prelink($scope,$elm,$attrs,controllers){var rowContainer,colContainer,uiGridCtrl=controllers[0],containerCtrl=controllers[1],grid=$scope.grid=uiGridCtrl.grid;// Verify that the render container for this element exists
if(!$scope.rowContainerName){throw new Error('No row render container name specified');}if(!$scope.colContainerName){throw new Error('No column render container name specified');}if(!grid.renderContainers[$scope.rowContainerName]){throw new Error('Row render container "'+$scope.rowContainerName+'" is not registered.');}if(!grid.renderContainers[$scope.colContainerName]){throw new Error('Column render container "'+$scope.colContainerName+'" is not registered.');}rowContainer=$scope.rowContainer=grid.renderContainers[$scope.rowContainerName];colContainer=$scope.colContainer=grid.renderContainers[$scope.colContainerName];containerCtrl.containerId=$scope.containerId;containerCtrl.rowContainer=rowContainer;containerCtrl.colContainer=colContainer;},post:function postlink($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0],containerCtrl=controllers[1],grid=uiGridCtrl.grid,rowContainer=containerCtrl.rowContainer,colContainer=containerCtrl.colContainer,scrollTop=null,scrollLeft=null,renderContainer=grid.renderContainers[$scope.containerId];// Put the container name on this element as a class
$elm.addClass('ui-grid-render-container-'+$scope.containerId);// Scroll the render container viewport when the mousewheel is used
gridUtil.on.mousewheel($elm,function(event){var scrollEvent=new ScrollEvent(grid,rowContainer,colContainer,ScrollEvent.Sources.RenderContainerMouseWheel);if(event.deltaY!==0){var scrollYAmount=event.deltaY*-1*event.deltaFactor;scrollTop=containerCtrl.viewport[0].scrollTop;// Get the scroll percentage
scrollEvent.verticalScrollLength=rowContainer.getVerticalScrollLength();var scrollYPercentage=(scrollTop+scrollYAmount)/scrollEvent.verticalScrollLength;// If we should be scrolled 100%, make sure the scrollTop matches the maximum scroll length
//   Viewports that have "overflow: hidden" don't let the mousewheel scroll all the way to the bottom without this check
if(scrollYPercentage>=1&&scrollTop<scrollEvent.verticalScrollLength){containerCtrl.viewport[0].scrollTop=scrollEvent.verticalScrollLength;}// Keep scrollPercentage within the range 0-1.
if(scrollYPercentage<0){scrollYPercentage=0;}else if(scrollYPercentage>1){scrollYPercentage=1;}scrollEvent.y={percentage:scrollYPercentage,pixels:scrollYAmount};}if(event.deltaX!==0){var scrollXAmount=event.deltaX*event.deltaFactor;// Get the scroll percentage
scrollLeft=gridUtil.normalizeScrollLeft(containerCtrl.viewport,grid);scrollEvent.horizontalScrollLength=colContainer.getCanvasWidth()-colContainer.getViewportWidth();var scrollXPercentage=(scrollLeft+scrollXAmount)/scrollEvent.horizontalScrollLength;// Keep scrollPercentage within the range 0-1.
if(scrollXPercentage<0){scrollXPercentage=0;}else if(scrollXPercentage>1){scrollXPercentage=1;}scrollEvent.x={percentage:scrollXPercentage,pixels:scrollXAmount};}// Let the parent container scroll if the grid is already at the top/bottom
if(!(event.deltaY!==0&&(scrollEvent.atTop(scrollTop)||scrollEvent.atBottom(scrollTop))||event.deltaX!==0&&(scrollEvent.atLeft(scrollLeft)||scrollEvent.atRight(scrollLeft)))){event.preventDefault();event.stopPropagation();scrollEvent.fireThrottledScrollingEvent('',scrollEvent);}});$elm.bind('$destroy',function(){$elm.unbind('keydown');['touchstart','touchmove','touchend','keydown','wheel','mousewheel','DomMouseScroll','MozMousePixelScroll'].forEach(function(eventName){$elm.unbind(eventName);});});// TODO(c0bra): Handle resizing the inner canvas based on the number of elements
function update(){var ret='';var canvasWidth=colContainer.canvasWidth;var viewportWidth=colContainer.getViewportWidth();var canvasHeight=rowContainer.getCanvasHeight();var viewportHeight=rowContainer.getViewportHeight();// shorten the height to make room for a scrollbar placeholder
if(colContainer.needsHScrollbarPlaceholder()){viewportHeight-=grid.scrollbarHeight;}var headerViewportWidth,footerViewportWidth;headerViewportWidth=footerViewportWidth=colContainer.getHeaderViewportWidth();// Set canvas dimensions
ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-canvas { width: '+canvasWidth+'px; height: '+canvasHeight+'px; }';ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-header-canvas { width: '+(canvasWidth+grid.scrollbarWidth)+'px; }';if(renderContainer.explicitHeaderCanvasHeight){// get height from body container
var reHCHeight=document.querySelector('.grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-body .ui-grid-header-canvas');if(reHCHeight){renderContainer.explicitHeaderCanvasHeight=reHCHeight.offsetHeight;}ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-header-canvas { height: '+renderContainer.explicitHeaderCanvasHeight+'px; }';}else{ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-header-canvas { height: inherit; }';}ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-viewport { width: '+viewportWidth+'px; height: '+viewportHeight+'px; }';ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-header-viewport { width: '+headerViewportWidth+'px; }';ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-footer-canvas { width: '+(canvasWidth+grid.scrollbarWidth)+'px; }';ret+='\n .grid'+uiGridCtrl.grid.id+' .ui-grid-render-container-'+$scope.containerId+' .ui-grid-footer-viewport { width: '+footerViewportWidth+'px; }';return ret;}uiGridCtrl.grid.registerStyleComputation({priority:6,func:update});}};}};}]);module.controller('uiGridRenderContainer',['$scope','gridUtil',function($scope,gridUtil){}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridRow',function(){return{replace:true,require:['^uiGrid','^uiGridRenderContainer'],scope:{row:'=uiGridRow',// rowRenderIndex is added to scope to give the true visual index of the row to any directives that need it
rowRenderIndex:'='},compile:function(){return{pre:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var containerCtrl=controllers[1];$scope.grid=uiGridCtrl.grid;$scope.colContainer=containerCtrl.colContainer;// Function for attaching the template to this scope
var clonedElement,cloneScope;function compileTemplate(){$scope.row.getRowTemplateFn.then(function(compiledElementFn){// var compiledElementFn = $scope.row.compiledElementFn;
// Create a new scope for the contents of this row, so we can destroy it later if need be
var newScope=$scope.$new();compiledElementFn(newScope,function(newElm,scope){// If we already have a cloned element, we need to remove it and destroy its scope
if(clonedElement){clonedElement.remove();cloneScope.$destroy();}// Empty the row and append the new element
$elm.empty().append(newElm);// Save the new cloned element and scope
clonedElement=newElm;cloneScope=newScope;});}).catch(angular.noop);}// Initially attach the compiled template to this scope
compileTemplate();// If the row's compiled element function changes, we need to replace this element's contents with the new compiled template
$scope.$watch('row.getRowTemplateFn',function(newFunc,oldFunc){if(newFunc!==oldFunc){compileTemplate();}});},post:function($scope,$elm){$scope.row.element=$elm;}};}};});})();(function(){// 'use strict';
/**
   * @ngdoc directive
   * @name ui.grid.directive:uiGridStyle
   * @element style
   * @restrict A
   *
   * @description
   * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
   *
   * @example
   <doc:example module="app">
   <doc:source>
   <script>
   var app = angular.module('app', ['ui.grid']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
          $scope.myStyle = '.blah { border: 1px solid }';
        }]);
   </script>

   <div ng-controller="MainCtrl">
   <style ui-grid-style>{{ myStyle }}</style>
   <span class="blah">I am in a box.</span>
   </div>
   </doc:source>
   <doc:scenario>
      xit('should apply the right class to the element', function () {
        element(by.css('.blah')).getCssValue('border-top-width')
          .then(function(c) {
            expect(c).toContain('1px');
          });
      });
   </doc:scenario>
   </doc:example>
   */angular.module('ui.grid').directive('uiGridStyle',['gridUtil','$interpolate',function(gridUtil,$interpolate){return{link:function($scope,$elm){var interpolateFn=$interpolate($elm.text(),true);if(interpolateFn){$scope.$watch(interpolateFn,function(value){for(var i=0;i<$elm.length;i++){$elm[i].textContent=value;}});}}};}]);})();(function(){'use strict';angular.module('ui.grid').directive('uiGridViewport',['gridUtil','ScrollEvent',function(gridUtil,ScrollEvent){return{replace:true,scope:{},controllerAs:'Viewport',templateUrl:'ui-grid/uiGridViewport',require:['^uiGrid','^uiGridRenderContainer'],link:function($scope,$elm,$attrs,controllers){// gridUtil.logDebug('viewport post-link');
var uiGridCtrl=controllers[0];var containerCtrl=controllers[1];$scope.containerCtrl=containerCtrl;var rowContainer=containerCtrl.rowContainer;var colContainer=containerCtrl.colContainer;var grid=uiGridCtrl.grid;$scope.grid=uiGridCtrl.grid;// Put the containers in scope so we can get rows and columns from them
$scope.rowContainer=containerCtrl.rowContainer;$scope.colContainer=containerCtrl.colContainer;// Register this viewport with its container
containerCtrl.viewport=$elm;/**
           * @ngdoc function
           * @name customScroller
           * @methodOf ui.grid.class:GridOptions
           * @description (optional) uiGridViewport.on('scroll', scrollHandler) by default.
           * A function that allows you to provide your own scroller function. It is particularly helpful if you want to use third party scrollers
           * as this allows you to do that.
           *
           * <div class="alert alert-info" role="alert"> <strong>NOTE:</strong> It is important to remember to always pass in an event object to
           * the scrollHandler as the grid scrolling behavior will break without it.</div>
           * <h5>Example</h5>
           * <pre>
           *   $scope.gridOptions = {
           *       customScroller: function myScrolling(uiGridViewport, scrollHandler) {
           *           uiGridViewport.on('scroll', function myScrollingOverride(event) {
           *               // Do something here
           *
           *               scrollHandler(event);
           *           });
           *       }
           *   };
           * </pre>
           * @param {object} uiGridViewport Element being scrolled. (this gets passed in by the grid).
           * @param {function} scrollHandler Function that needs to be called when scrolling happens. (this gets passed in by the grid).
           */if(grid&&grid.options&&grid.options.customScroller){grid.options.customScroller($elm,scrollHandler);}else{$elm.on('scroll',scrollHandler);}var ignoreScroll=false;function scrollHandler(){var newScrollTop=$elm[0].scrollTop;var newScrollLeft=gridUtil.normalizeScrollLeft($elm,grid);var vertScrollPercentage=rowContainer.scrollVertical(newScrollTop);var horizScrollPercentage=colContainer.scrollHorizontal(newScrollLeft);var scrollEvent=new ScrollEvent(grid,rowContainer,colContainer,ScrollEvent.Sources.ViewPortScroll);scrollEvent.newScrollLeft=newScrollLeft;scrollEvent.newScrollTop=newScrollTop;if(horizScrollPercentage>-1){scrollEvent.x={percentage:horizScrollPercentage};}if(vertScrollPercentage>-1){scrollEvent.y={percentage:vertScrollPercentage};}grid.scrollContainers($scope.$parent.containerId,scrollEvent);}if($scope.$parent.bindScrollVertical){grid.addVerticalScrollSync($scope.$parent.containerId,syncVerticalScroll);}if($scope.$parent.bindScrollHorizontal){grid.addHorizontalScrollSync($scope.$parent.containerId,syncHorizontalScroll);grid.addHorizontalScrollSync($scope.$parent.containerId+'header',syncHorizontalHeader);grid.addHorizontalScrollSync($scope.$parent.containerId+'footer',syncHorizontalFooter);}function syncVerticalScroll(scrollEvent){containerCtrl.prevScrollArgs=scrollEvent;$elm[0].scrollTop=scrollEvent.getNewScrollTop(rowContainer,containerCtrl.viewport);}function syncHorizontalScroll(scrollEvent){containerCtrl.prevScrollArgs=scrollEvent;var newScrollLeft=scrollEvent.getNewScrollLeft(colContainer,containerCtrl.viewport);$elm[0].scrollLeft=gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft,grid);}function syncHorizontalHeader(scrollEvent){var newScrollLeft=scrollEvent.getNewScrollLeft(colContainer,containerCtrl.viewport);if(containerCtrl.headerViewport){containerCtrl.headerViewport.scrollLeft=gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft,grid);}}function syncHorizontalFooter(scrollEvent){var newScrollLeft=scrollEvent.getNewScrollLeft(colContainer,containerCtrl.viewport);if(containerCtrl.footerViewport){containerCtrl.footerViewport.scrollLeft=gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft,grid);}}$scope.$on('$destroy',function unbindEvents(){$elm.off();});},controller:['$scope',function($scope){this.rowStyle=function(){var rowContainer=$scope.rowContainer;var colContainer=$scope.colContainer;var styles={};if(rowContainer.currentTopRow!==0){// top offset based on hidden rows count
var translateY="translateY("+rowContainer.currentTopRow*rowContainer.grid.options.rowHeight+"px)";styles['transform']=translateY;styles['-webkit-transform']=translateY;styles['-ms-transform']=translateY;}if(colContainer.currentFirstColumn!==0){if(colContainer.grid.isRTL()){styles['margin-right']=colContainer.columnOffset+'px';}else{styles['margin-left']=colContainer.columnOffset+'px';}}return styles;};}]};}]);})();(function(){angular.module('ui.grid').directive('uiGridVisible',function uiGridVisibleAction(){return function($scope,$elm,$attr){$scope.$watch($attr.uiGridVisible,function(visible){$elm[visible?'removeClass':'addClass']('ui-grid-invisible');});};});})();(function(){'use strict';angular.module('ui.grid').controller('uiGridController',['$scope','$element','$attrs','gridUtil','$q','uiGridConstants','gridClassFactory','$parse','$compile',function($scope,$elm,$attrs,gridUtil,$q,uiGridConstants,gridClassFactory,$parse,$compile){// gridUtil.logDebug('ui-grid controller');
var self=this;var deregFunctions=[];self.grid=gridClassFactory.createGrid($scope.uiGrid);// assign $scope.$parent if appScope not already assigned
self.grid.appScope=self.grid.appScope||$scope.$parent;$elm.addClass('grid'+self.grid.id);self.grid.rtl=gridUtil.getStyles($elm[0])['direction']==='rtl';// angular.extend(self.grid.options, );
// all properties of grid are available on scope
$scope.grid=self.grid;if($attrs.uiGridColumns){deregFunctions.push($attrs.$observe('uiGridColumns',function(value){self.grid.options.columnDefs=angular.isString(value)?angular.fromJson(value):value;self.grid.buildColumns().then(function(){self.grid.preCompileCellTemplates();self.grid.refreshCanvas(true);}).catch(angular.noop);}));}// prevents an error from being thrown when the array is not defined yet and fastWatch is on
function getSize(array){return array?array.length:0;}// if fastWatch is set we watch only the length and the reference, not every individual object
if(self.grid.options.fastWatch){self.uiGrid=$scope.uiGrid;if(angular.isString($scope.uiGrid.data)){deregFunctions.push($scope.$parent.$watch($scope.uiGrid.data,dataWatchFunction));deregFunctions.push($scope.$parent.$watch(function(){if(self.grid.appScope[$scope.uiGrid.data]){return self.grid.appScope[$scope.uiGrid.data].length;}else{return undefined;}},dataWatchFunction));}else{deregFunctions.push($scope.$parent.$watch(function(){return $scope.uiGrid.data;},dataWatchFunction));deregFunctions.push($scope.$parent.$watch(function(){return getSize($scope.uiGrid.data);},function(){dataWatchFunction($scope.uiGrid.data);}));}deregFunctions.push($scope.$parent.$watch(function(){return $scope.uiGrid.columnDefs;},columnDefsWatchFunction));deregFunctions.push($scope.$parent.$watch(function(){return getSize($scope.uiGrid.columnDefs);},function(){columnDefsWatchFunction($scope.uiGrid.columnDefs);}));}else{if(angular.isString($scope.uiGrid.data)){deregFunctions.push($scope.$parent.$watchCollection($scope.uiGrid.data,dataWatchFunction));}else{deregFunctions.push($scope.$parent.$watchCollection(function(){return $scope.uiGrid.data;},dataWatchFunction));}deregFunctions.push($scope.$parent.$watchCollection(function(){return $scope.uiGrid.columnDefs;},columnDefsWatchFunction));}function columnDefsWatchFunction(n,o){if(n&&n!==o){self.grid.options.columnDefs=$scope.uiGrid.columnDefs;self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.COLUMN,{orderByColumnDefs:true,preCompileCellTemplates:true});}}var mostRecentData;function dataWatchFunction(newData){// gridUtil.logDebug('dataWatch fired');
var promises=[];if(self.grid.options.fastWatch){if(angular.isString($scope.uiGrid.data)){newData=self.grid.appScope.$eval($scope.uiGrid.data);}else{newData=$scope.uiGrid.data;}}mostRecentData=newData;if(newData){// columns length is greater than the number of row header columns, which don't count because they're created automatically
var hasColumns=self.grid.columns.length>(self.grid.rowHeaderColumns?self.grid.rowHeaderColumns.length:0);if(// If we have no columns
!hasColumns&&// ... and we don't have a ui-grid-columns attribute, which would define columns for us
!$attrs.uiGridColumns&&// ... and we have no pre-defined columns
self.grid.options.columnDefs.length===0&&// ... but we DO have data
newData.length>0){// ... then build the column definitions from the data that we have
self.grid.buildColumnDefsFromData(newData);}// If we haven't built columns before and either have some columns defined or some data defined
if(!hasColumns&&(self.grid.options.columnDefs.length>0||newData.length>0)){// Build the column set, then pre-compile the column cell templates
promises.push(self.grid.buildColumns().then(function(){self.grid.preCompileCellTemplates();}).catch(angular.noop));}$q.all(promises).then(function(){// use most recent data, rather than the potentially outdated data passed into watcher handler
self.grid.modifyRows(mostRecentData).then(function(){// if (self.viewport) {
self.grid.redrawInPlace(true);// }
$scope.$evalAsync(function(){self.grid.refreshCanvas(true);self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);});}).catch(angular.noop);}).catch(angular.noop);}}var styleWatchDereg=$scope.$watch(function(){return self.grid.styleComputations;},function(){self.grid.refreshCanvas(true);});$scope.$on('$destroy',function(){deregFunctions.forEach(function(deregFn){deregFn();});styleWatchDereg();});self.fireEvent=function(eventName,args){args=args||{};// Add the grid to the event arguments if it's not there
if(angular.isUndefined(args.grid)){args.grid=self.grid;}$scope.$broadcast(eventName,args);};self.innerCompile=function innerCompile(elm){$compile(elm)($scope);};}]);/**
 *  @ngdoc directive
 *  @name ui.grid.directive:uiGrid
 *  @element div
 *  @restrict EA
 *  @param {Object} uiGrid Options for the grid to use
 *
 *  @description Create a very basic grid.
 *
 *  @example
    <example module="app">
      <file name="app.js">
        var app = angular.module('app', ['ui.grid']);

        app.controller('MainCtrl', ['$scope', function ($scope) {
          $scope.data = [
            { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
          ];
        }]);
      </file>
      <file name="index.html">
        <div ng-controller="MainCtrl">
          <div ui-grid="{ data: data }"></div>
        </div>
      </file>
    </example>
 */angular.module('ui.grid').directive('uiGrid',uiGridDirective);uiGridDirective.$inject=['$window','gridUtil','uiGridConstants'];function uiGridDirective($window,gridUtil,uiGridConstants){return{templateUrl:'ui-grid/ui-grid',scope:{uiGrid:'='},replace:true,transclude:true,controller:'uiGridController',compile:function(){return{post:function($scope,$elm,$attrs,uiGridCtrl){var grid=uiGridCtrl.grid;// Initialize scrollbars (TODO: move to controller??)
uiGridCtrl.scrollbars=[];grid.element=$elm;// See if the grid has a rendered width, if not, wait a bit and try again
var sizeCheckInterval=100;// ms
var maxSizeChecks=20;// 2 seconds total
var sizeChecks=0;// Setup (event listeners) the grid
setup();// And initialize it
init();// Mark rendering complete so API events can happen
grid.renderingComplete();// If the grid doesn't have size currently, wait for a bit to see if it gets size
checkSize();/*-- Methods --*/function checkSize(){// If the grid has no width and we haven't checked more than <maxSizeChecks> times, check again in <sizeCheckInterval> milliseconds
if($elm[0].offsetWidth<=0&&sizeChecks<maxSizeChecks){setTimeout(checkSize,sizeCheckInterval);sizeChecks++;}else{$scope.$applyAsync(init);}}// Setup event listeners and watchers
function setup(){var deregisterLeftWatcher,deregisterRightWatcher;// Bind to window resize events
angular.element($window).on('resize',gridResize);// Unbind from window resize events when the grid is destroyed
$elm.on('$destroy',function(){angular.element($window).off('resize',gridResize);deregisterLeftWatcher();deregisterRightWatcher();});// If we add a left container after render, we need to watch and react
deregisterLeftWatcher=$scope.$watch(function(){return grid.hasLeftContainer();},function(newValue,oldValue){if(newValue===oldValue){return;}grid.refreshCanvas(true);});// If we add a right container after render, we need to watch and react
deregisterRightWatcher=$scope.$watch(function(){return grid.hasRightContainer();},function(newValue,oldValue){if(newValue===oldValue){return;}grid.refreshCanvas(true);});}// Initialize the directive
function init(){grid.gridWidth=$scope.gridWidth=gridUtil.elementWidth($elm);// Default canvasWidth to the grid width, in case we don't get any column definitions to calculate it from
grid.canvasWidth=uiGridCtrl.grid.gridWidth;grid.gridHeight=$scope.gridHeight=gridUtil.elementHeight($elm);// If the grid isn't tall enough to fit a single row, it's kind of useless. Resize it to fit a minimum number of rows
if(grid.gridHeight-grid.scrollbarHeight<=grid.options.rowHeight&&grid.options.enableMinHeightCheck){autoAdjustHeight();}// Run initial canvas refresh
grid.refreshCanvas(true);}// Set the grid's height ourselves in the case that its height would be unusably small
function autoAdjustHeight(){// Figure out the new height
var contentHeight=grid.options.minRowsToShow*grid.options.rowHeight;var headerHeight=grid.options.showHeader?grid.options.headerRowHeight:0;var footerHeight=grid.calcFooterHeight();var scrollbarHeight=0;if(grid.options.enableHorizontalScrollbar===uiGridConstants.scrollbars.ALWAYS){scrollbarHeight=gridUtil.getScrollbarWidth();}var maxNumberOfFilters=0;// Calculates the maximum number of filters in the columns
angular.forEach(grid.options.columnDefs,function(col){if(col.hasOwnProperty('filter')){if(maxNumberOfFilters<1){maxNumberOfFilters=1;}}else if(col.hasOwnProperty('filters')){if(maxNumberOfFilters<col.filters.length){maxNumberOfFilters=col.filters.length;}}});if(grid.options.enableFiltering&&!maxNumberOfFilters){var allColumnsHaveFilteringTurnedOff=grid.options.columnDefs.length&&grid.options.columnDefs.every(function(col){return col.enableFiltering===false;});if(!allColumnsHaveFilteringTurnedOff){maxNumberOfFilters=1;}}var filterHeight=maxNumberOfFilters*headerHeight;var newHeight=headerHeight+contentHeight+footerHeight+scrollbarHeight+filterHeight;$elm.css('height',newHeight+'px');grid.gridHeight=$scope.gridHeight=gridUtil.elementHeight($elm);}// Resize the grid on window resize events
function gridResize(){if(!gridUtil.isVisible($elm)){return;}grid.gridWidth=$scope.gridWidth=gridUtil.elementWidth($elm);grid.gridHeight=$scope.gridHeight=gridUtil.elementHeight($elm);grid.refreshCanvas(true);}}};}};}})();(function(){'use strict';angular.module('ui.grid').directive('uiGridPinnedContainer',['gridUtil',function(gridUtil){return{restrict:'EA',replace:true,template:'<div class="ui-grid-pinned-container">'+'<div ui-grid-render-container container-id="side"'+' row-container-name="\'body\'" col-container-name="side"'+' bind-scroll-vertical="true"'+' class="{{ side }} ui-grid-render-container-{{ side }}"></div>'+'</div>',scope:{side:'=uiGridPinnedContainer'},require:'^uiGrid',compile:function compile(){return{post:function($scope,$elm,$attrs,uiGridCtrl){// gridUtil.logDebug('ui-grid-pinned-container ' + $scope.side + ' link');
var grid=uiGridCtrl.grid;var myWidth=0;$elm.addClass('ui-grid-pinned-container-'+$scope.side);// Monkey-patch the viewport width function
if($scope.side==='left'||$scope.side==='right'){grid.renderContainers[$scope.side].getViewportWidth=monkeyPatchedGetViewportWidth;}function monkeyPatchedGetViewportWidth(){/*jshint validthis: true */var self=this;var viewportWidth=0;self.visibleColumnCache.forEach(function(column){viewportWidth+=column.drawnWidth;});var adjustment=self.getViewportAdjustment();viewportWidth=viewportWidth+adjustment.width;return viewportWidth;}function updateContainerWidth(){if($scope.side==='left'||$scope.side==='right'){var cols=grid.renderContainers[$scope.side].visibleColumnCache;var width=0;for(var i=0;i<cols.length;i++){var col=cols[i];width+=col.drawnWidth||col.width||0;}return width;}}function updateContainerDimensions(){var ret='';// Column containers
if($scope.side==='left'||$scope.side==='right'){myWidth=updateContainerWidth();// gridUtil.logDebug('myWidth', myWidth);
// TODO(c0bra): Subtract sum of col widths from grid viewport width and update it
$elm.attr('style',null);//   var myHeight = grid.renderContainers.body.getViewportHeight(); // + grid.horizontalScrollbarHeight;
ret+='.grid'+grid.id+' .ui-grid-pinned-container-'+$scope.side+', .grid'+grid.id+' .ui-grid-pinned-container-'+$scope.side+' .ui-grid-render-container-'+$scope.side+' .ui-grid-viewport { width: '+myWidth+'px; } ';}return ret;}grid.renderContainers.body.registerViewportAdjuster(function(adjustment){myWidth=updateContainerWidth();// Subtract our own width
adjustment.width-=myWidth;adjustment.side=$scope.side;return adjustment;});// Register style computation to adjust for columns in `side`'s render container
grid.registerStyleComputation({priority:15,func:updateContainerDimensions});}};}};}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('en',{headerCell:{aria:{defaultFilterLabel:'Filter for column',removeFilter:'Remove Filter',columnMenuButtonLabel:'Column Menu',column:'Column'},priority:'Priority:',filterLabel:"Filter for column: "},aggregate:{label:'items'},groupPanel:{description:'Drag a column header here and drop it to group by that column.'},search:{aria:{selected:'Row selected',notSelected:'Row not selected'},placeholder:'Search...',showingItems:'Showing Items:',selectedItems:'Selected Items:',totalItems:'Total Items:',size:'Page Size:',first:'First Page',next:'Next Page',previous:'Previous Page',last:'Last Page'},selection:{aria:{row:'Row'},selectAll:'Select All',displayName:'Row Selection Checkbox'},menu:{text:'Choose Columns:'},sort:{ascending:'Sort Ascending',descending:'Sort Descending',none:'Sort None',remove:'Remove Sort'},column:{hide:'Hide Column'},aggregation:{count:'total rows: ',sum:'total: ',avg:'avg: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Pin Left',pinRight:'Pin Right',unpin:'Unpin'},columnMenu:{close:'Close'},gridMenu:{aria:{buttonLabel:'Grid Menu'},columns:'Columns:',importerTitle:'Import file',exporterAllAsCsv:'Export all data as csv',exporterVisibleAsCsv:'Export visible data as csv',exporterSelectedAsCsv:'Export selected data as csv',exporterAllAsPdf:'Export all data as pdf',exporterVisibleAsPdf:'Export visible data as pdf',exporterSelectedAsPdf:'Export selected data as pdf',exporterAllAsExcel:'Export all data as excel',exporterVisibleAsExcel:'Export visible data as excel',exporterSelectedAsExcel:'Export selected data as excel',clearAllFilters:'Clear all filters'},importer:{noHeaders:'Column names were unable to be derived, does the file have a header?',noObjects:'Objects were not able to be derived, was there data in the file other than headers?',invalidCsv:'File was unable to be processed, is it valid CSV?',invalidJson:'File was unable to be processed, is it valid Json?',jsonNotArray:'Imported json file must contain an array, aborting.'},pagination:{aria:{pageToFirst:'Page to first',pageBack:'Page back',pageSelected:'Selected page',pageForward:'Page forward',pageToLast:'Page to last'},sizes:'items per page',totalItems:'items',through:'through',of:'of'},grouping:{group:'Group',ungroup:'Ungroup',aggregate_count:'Agg: Count',aggregate_sum:'Agg: Sum',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Avg',aggregate_remove:'Agg: Remove'},validate:{error:'Error:',minLength:'Value should be at least THRESHOLD characters long.',maxLength:'Value should be at most THRESHOLD characters long.',required:'A value is needed.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').factory('Grid',['$q','$compile','$parse','gridUtil','uiGridConstants','GridOptions','GridColumn','GridRow','GridApi','rowSorter','rowSearcher','GridRenderContainer','$timeout','ScrollEvent',function($q,$compile,$parse,gridUtil,uiGridConstants,GridOptions,GridColumn,GridRow,GridApi,rowSorter,rowSearcher,GridRenderContainer,$timeout,ScrollEvent){/**
   * @ngdoc object
   * @name ui.grid.api:PublicApi
   * @description Public Api for the core grid features
   *
   */ /**
   * @ngdoc function
   * @name ui.grid.class:Grid
   * @description Grid is the main viewModel.  Any properties or methods needed to maintain state are defined in
   * this prototype.  One instance of Grid is created per Grid directive instance.
   * @param {object} options Object map of options to pass into the grid. An 'id' property is expected.
   */var Grid=function Grid(options){var self=this;// Get the id out of the options, then remove it
if(options!==undefined&&typeof options.id!=='undefined'&&options.id){if(!/^[_a-zA-Z0-9-]+$/.test(options.id)){throw new Error("Grid id '"+options.id+'" is invalid. It must follow CSS selector syntax rules.');}}else{throw new Error('No ID provided. An ID must be given when creating a grid.');}self.id=options.id;delete options.id;// Get default options
self.options=GridOptions.initialize(options);/**
     * @ngdoc object
     * @name appScope
     * @propertyOf ui.grid.class:Grid
     * @description reference to the application scope (the parent scope of the ui-grid element).  Assigned in ui-grid controller
     * <br/>
     * use gridOptions.appScopeProvider to override the default assignment of $scope.$parent with any reference
     */self.appScope=self.options.appScopeProvider;self.headerHeight=self.options.headerRowHeight;/**
     * @ngdoc object
     * @name footerHeight
     * @propertyOf ui.grid.class:Grid
     * @description returns the total footer height gridFooter + columnFooter
     */self.footerHeight=self.calcFooterHeight();/**
     * @ngdoc object
     * @name columnFooterHeight
     * @propertyOf ui.grid.class:Grid
     * @description returns the total column footer height
     */self.columnFooterHeight=self.calcColumnFooterHeight();self.rtl=false;self.gridHeight=0;self.gridWidth=0;self.columnBuilders=[];self.rowBuilders=[];self.rowsProcessors=[];self.columnsProcessors=[];self.styleComputations=[];self.viewportAdjusters=[];self.rowHeaderColumns=[];self.dataChangeCallbacks={};self.verticalScrollSyncCallBackFns={};self.horizontalScrollSyncCallBackFns={};// self.visibleRowCache = [];
// Set of 'render' containers for self grid, which can render sets of rows
self.renderContainers={};// Create a
self.renderContainers.body=new GridRenderContainer('body',self);self.cellValueGetterCache={};// Cached function to use with custom row templates
self.getRowTemplateFn=null;// representation of the rows on the grid.
// these are wrapped references to the actual data rows (options.data)
self.rows=[];// represents the columns on the grid
self.columns=[];/**
     * @ngdoc boolean
     * @name isScrollingVertically
     * @propertyOf ui.grid.class:Grid
     * @description set to true when Grid is scrolling vertically. Set to false via debounced method
     */self.isScrollingVertically=false;/**
     * @ngdoc boolean
     * @name isScrollingHorizontally
     * @propertyOf ui.grid.class:Grid
     * @description set to true when Grid is scrolling horizontally. Set to false via debounced method
     */self.isScrollingHorizontally=false;/**
     * @ngdoc property
     * @name scrollDirection
     * @propertyOf ui.grid.class:Grid
     * @description set one of the {@link ui.grid.service:uiGridConstants#properties_scrollDirection uiGridConstants.scrollDirection}
     *  values (UP, DOWN, LEFT, RIGHT, NONE), which tells us which direction we are scrolling.
     * Set to NONE via debounced method
     */self.scrollDirection=uiGridConstants.scrollDirection.NONE;// if true, grid will not respond to any scroll events
self.disableScrolling=false;function vertical(scrollEvent){self.isScrollingVertically=false;self.api.core.raise.scrollEnd(scrollEvent);self.scrollDirection=uiGridConstants.scrollDirection.NONE;}var debouncedVertical=gridUtil.debounce(vertical,self.options.scrollDebounce);var debouncedVerticalMinDelay=gridUtil.debounce(vertical,0);function horizontal(scrollEvent){self.isScrollingHorizontally=false;self.api.core.raise.scrollEnd(scrollEvent);self.scrollDirection=uiGridConstants.scrollDirection.NONE;}var debouncedHorizontal=gridUtil.debounce(horizontal,self.options.scrollDebounce);var debouncedHorizontalMinDelay=gridUtil.debounce(horizontal,0);/**
     * @ngdoc function
     * @name flagScrollingVertically
     * @methodOf ui.grid.class:Grid
     * @description sets isScrollingVertically to true and sets it to false in a debounced function
     */self.flagScrollingVertically=function(scrollEvent){if(!self.isScrollingVertically&&!self.isScrollingHorizontally){self.api.core.raise.scrollBegin(scrollEvent);}self.isScrollingVertically=true;if(self.options.scrollDebounce===0||!scrollEvent.withDelay){debouncedVerticalMinDelay(scrollEvent);}else{debouncedVertical(scrollEvent);}};/**
     * @ngdoc function
     * @name flagScrollingHorizontally
     * @methodOf ui.grid.class:Grid
     * @description sets isScrollingHorizontally to true and sets it to false in a debounced function
     */self.flagScrollingHorizontally=function(scrollEvent){if(!self.isScrollingVertically&&!self.isScrollingHorizontally){self.api.core.raise.scrollBegin(scrollEvent);}self.isScrollingHorizontally=true;if(self.options.scrollDebounce===0||!scrollEvent.withDelay){debouncedHorizontalMinDelay(scrollEvent);}else{debouncedHorizontal(scrollEvent);}};self.scrollbarHeight=0;self.scrollbarWidth=0;if(self.options.enableHorizontalScrollbar!==uiGridConstants.scrollbars.NEVER){self.scrollbarHeight=gridUtil.getScrollbarWidth();}if(self.options.enableVerticalScrollbar!==uiGridConstants.scrollbars.NEVER){self.scrollbarWidth=gridUtil.getScrollbarWidth();}self.api=new GridApi(self);/**
     * @ngdoc function
     * @name refresh
     * @methodOf ui.grid.api:PublicApi
     * @description Refresh the rendered grid on screen.
     * The refresh method re-runs both the columnProcessors and the
     * rowProcessors, as well as calling refreshCanvas to update all
     * the grid sizing.  In general you should prefer to use queueGridRefresh
     * instead, which is basically a debounced version of refresh.
     *
     * If you only want to resize the grid, not regenerate all the rows
     * and columns, you should consider directly calling refreshCanvas instead.
     *
     * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed
     */self.api.registerMethod('core','refresh',this.refresh);/**
     * @ngdoc function
     * @name queueGridRefresh
     * @methodOf ui.grid.api:PublicApi
     * @description Request a refresh of the rendered grid on screen, if multiple
     * calls to queueGridRefresh are made within a digest cycle only one will execute.
     * The refresh method re-runs both the columnProcessors and the
     * rowProcessors, as well as calling refreshCanvas to update all
     * the grid sizing.  In general you should prefer to use queueGridRefresh
     * instead, which is basically a debounced version of refresh.
     *
     */self.api.registerMethod('core','queueGridRefresh',this.queueGridRefresh);/**
     * @ngdoc function
     * @name refreshRows
     * @methodOf ui.grid.api:PublicApi
     * @description Runs only the rowProcessors, columns remain as they were.
     * It then calls redrawInPlace and refreshCanvas, which adjust the grid sizing.
     * @returns {promise} promise that is resolved when render completes?
     *
     */self.api.registerMethod('core','refreshRows',this.refreshRows);/**
     * @ngdoc function
     * @name queueRefresh
     * @methodOf ui.grid.api:PublicApi
     * @description Requests execution of refreshCanvas, if multiple requests are made
     * during a digest cycle only one will run.  RefreshCanvas updates the grid sizing.
     * @returns {promise} promise that is resolved when render completes?
     *
     */self.api.registerMethod('core','queueRefresh',this.queueRefresh);/**
     * @ngdoc function
     * @name handleWindowResize
     * @methodOf ui.grid.api:PublicApi
     * @description Trigger a grid resize, normally this would be picked
     * up by a watch on window size, but in some circumstances it is necessary
     * to call this manually
     * @returns {promise} promise that is resolved when render completes?
     *
     */self.api.registerMethod('core','handleWindowResize',this.handleWindowResize);/**
     * @ngdoc function
     * @name addRowHeaderColumn
     * @methodOf ui.grid.api:PublicApi
     * @description adds a row header column to the grid
     * @param {object} column def
     * @param {number} order Determines order of header column on grid.  Lower order means header
     * is positioned to the left of higher order headers
     *
     */self.api.registerMethod('core','addRowHeaderColumn',this.addRowHeaderColumn);/**
     * @ngdoc function
     * @name scrollToIfNecessary
     * @methodOf ui.grid.api:PublicApi
     * @description Scrolls the grid to make a certain row and column combo visible,
     *   in the case that it is not completely visible on the screen already.
     * @param {GridRow} gridRow row to make visible
     * @param {GridColumn} gridCol column to make visible
     * @returns {promise} a promise that is resolved when scrolling is complete
     *
     */self.api.registerMethod('core','scrollToIfNecessary',function(gridRow,gridCol){return self.scrollToIfNecessary(gridRow,gridCol);});/**
     * @ngdoc function
     * @name scrollTo
     * @methodOf ui.grid.api:PublicApi
     * @description Scroll the grid such that the specified
     * row and column is in view
     * @param {object} rowEntity gridOptions.data[] array instance to make visible
     * @param {object} colDef to make visible
     * @returns {promise} a promise that is resolved after any scrolling is finished
     */self.api.registerMethod('core','scrollTo',function(rowEntity,colDef){return self.scrollTo(rowEntity,colDef);});/**
     * @ngdoc function
     * @name registerRowsProcessor
     * @methodOf ui.grid.api:PublicApi
     * @description
     * Register a "rows processor" function. When the rows are updated,
     * the grid calls each registered "rows processor", which has a chance
     * to alter the set of rows (sorting, etc) as long as the count is not
     * modified.
     *
     * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
     * is run in the context of the grid (i.e. this for the function will be the grid), and must
     * return the updated rows list, which is passed to the next processor in the chain
     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
     * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
     *
     * At present allRowsVisible is running at 50, sort manipulations running at 60-65, filter is running at 100,
     * sort is at 200, grouping and treeview at 400-410, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
     */self.api.registerMethod('core','registerRowsProcessor',this.registerRowsProcessor);/**
     * @ngdoc function
     * @name registerColumnsProcessor
     * @methodOf ui.grid.api:PublicApi
     * @description
     * Register a "columns processor" function. When the columns are updated,
     * the grid calls each registered "columns processor", which has a chance
     * to alter the set of columns as long as the count is not
     * modified.
     *
     * @param {function(renderedColumnsToProcess, rows )} processorFunction columns processor function, which
     * is run in the context of the grid (i.e. this for the function will be the grid), and must
     * return the updated columns list, which is passed to the next processor in the chain
     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
     * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
     *
     * At present allRowsVisible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
     */self.api.registerMethod('core','registerColumnsProcessor',this.registerColumnsProcessor);/**
     * @ngdoc function
     * @name sortHandleNulls
     * @methodOf ui.grid.api:PublicApi
     * @description A null handling method that can be used when building custom sort
     * functions
     * @example
     * <pre>
     *   mySortFn = function(a, b) {
     *   var nulls = $scope.gridApi.core.sortHandleNulls(a, b);
     *   if ( nulls !== null ) {
     *     return nulls;
     *   } else {
     *     // your code for sorting here
     *   };
     * </pre>
     * @param {object} a sort value a
     * @param {object} b sort value b
     * @returns {number} null if there were no nulls/undefineds, otherwise returns
     * a sort value that should be passed back from the sort function
     *
     */self.api.registerMethod('core','sortHandleNulls',rowSorter.handleNulls);/**
     * @ngdoc function
     * @name sortChanged
     * @methodOf  ui.grid.api:PublicApi
     * @description The sort criteria on one or more columns has
     * changed.  Provides as parameters the grid and the output of
     * getColumnSorting, which is an array of gridColumns
     * that have sorting on them, sorted in priority order.
     *
     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
     * @param {Function} callBack Will be called when the event is emited. The function passes back the grid and an array of
     * columns with sorts on them, in priority order.
     *
     * @example
     * <pre>
     *      gridApi.core.on.sortChanged( $scope, function(grid, sortColumns) {
     *        // do something
     *      });
     * </pre>
     */self.api.registerEvent('core','sortChanged');/**
     * @ngdoc function
     * @name columnVisibilityChanged
     * @methodOf  ui.grid.api:PublicApi
     * @description The visibility of a column has changed,
     * the column itself is passed out as a parameter of the event.
     *
     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
     * @param {Function} callBack Will be called when the event is emited. The function passes back the GridCol that has changed.
     *
     * @example
     * <pre>
     *      gridApi.core.on.columnVisibilityChanged( $scope, function (column) {
     *        // do something
     *      } );
     * </pre>
     */self.api.registerEvent('core','columnVisibilityChanged');/**
     * @ngdoc method
     * @name notifyDataChange
     * @methodOf ui.grid.api:PublicApi
     * @description Notify the grid that a data or config change has occurred,
     * where that change isn't something the grid was otherwise noticing.  This
     * might be particularly relevant where you've changed values within the data
     * and you'd like cell classes to be re-evaluated, or changed config within
     * the columnDef and you'd like headerCellClasses to be re-evaluated.
     * @param {string} type one of the
     * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
     * values (ALL, ROW, EDIT, COLUMN, OPTIONS), which tells us which refreshes to fire.
     *
     * - ALL: listeners fired on any of these events, fires listeners on all events.
     * - ROW: fired when a row is added or removed.
     * - EDIT: fired when the data in a cell is edited.
     * - COLUMN: fired when the column definitions are modified.
     * - OPTIONS: fired when the grid options are modified.
     */self.api.registerMethod('core','notifyDataChange',this.notifyDataChange);/**
     * @ngdoc method
     * @name clearAllFilters
     * @methodOf ui.grid.api:PublicApi
     * @description Clears all filters and optionally refreshes the visible rows.
     * @param {object} refreshRows Defaults to true.
     * @param {object} clearConditions Defaults to false.
     * @param {object} clearFlags Defaults to false.
     * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
     */self.api.registerMethod('core','clearAllFilters',this.clearAllFilters);self.registerDataChangeCallback(self.columnRefreshCallback,[uiGridConstants.dataChange.COLUMN]);self.registerDataChangeCallback(self.processRowsCallback,[uiGridConstants.dataChange.EDIT]);self.registerDataChangeCallback(self.updateFooterHeightCallback,[uiGridConstants.dataChange.OPTIONS]);self.registerStyleComputation({priority:10,func:self.getFooterStyles});};Grid.prototype.calcFooterHeight=function(){if(!this.hasFooter()){return 0;}var height=0;if(this.options.showGridFooter){height+=this.options.gridFooterHeight;}height+=this.calcColumnFooterHeight();return height;};Grid.prototype.calcColumnFooterHeight=function(){var height=0;if(this.options.showColumnFooter){height+=this.options.columnFooterHeight;}return height;};Grid.prototype.getFooterStyles=function(){var style='.grid'+this.id+' .ui-grid-footer-aggregates-row { height: '+this.options.columnFooterHeight+'px; }';style+=' .grid'+this.id+' .ui-grid-footer-info { height: '+this.options.gridFooterHeight+'px; }';return style;};Grid.prototype.hasFooter=function(){return this.options.showGridFooter||this.options.showColumnFooter;};/**
   * @ngdoc function
   * @name isRTL
   * @methodOf ui.grid.class:Grid
   * @description Returns true if grid is RightToLeft
   */Grid.prototype.isRTL=function(){return this.rtl;};/**
   * @ngdoc function
   * @name registerColumnBuilder
   * @methodOf ui.grid.class:Grid
   * @description When the build creates columns from column definitions, the columnbuilders will be called to add
   * additional properties to the column.
   * @param {function(colDef, col, gridOptions)} columnBuilder function to be called
   */Grid.prototype.registerColumnBuilder=function registerColumnBuilder(columnBuilder){this.columnBuilders.push(columnBuilder);};/**
   * @ngdoc function
   * @name buildColumnDefsFromData
   * @methodOf ui.grid.class:Grid
   * @description Populates columnDefs from the provided data
   * @param {function(colDef, col, gridOptions)} rowBuilder function to be called
   */Grid.prototype.buildColumnDefsFromData=function(dataRows){this.options.columnDefs=gridUtil.getColumnsFromData(dataRows,this.options.excludeProperties);};/**
   * @ngdoc function
   * @name registerRowBuilder
   * @methodOf ui.grid.class:Grid
   * @description When the build creates rows from gridOptions.data, the rowBuilders will be called to add
   * additional properties to the row.
   * @param {function(row, gridOptions)} rowBuilder function to be called
   */Grid.prototype.registerRowBuilder=function registerRowBuilder(rowBuilder){this.rowBuilders.push(rowBuilder);};/**
   * @ngdoc function
   * @name registerDataChangeCallback
   * @methodOf ui.grid.class:Grid
   * @description When a data change occurs, the data change callbacks of the specified type
   * will be called.  The rules are:
   *
   * - when the data watch fires, that is considered a ROW change (the data watch only notices
   *   added or removed rows)
   * - when the api is called to inform us of a change, the declared type of that change is used
   * - when a cell edit completes, the EDIT callbacks are triggered
   * - when the columnDef watch fires, the COLUMN callbacks are triggered
   * - when the options watch fires, the OPTIONS callbacks are triggered
   *
   * For a given event:
   * - ALL calls ROW, EDIT, COLUMN, OPTIONS and ALL callbacks
   * - ROW calls ROW and ALL callbacks
   * - EDIT calls EDIT and ALL callbacks
   * - COLUMN calls COLUMN and ALL callbacks
   * - OPTIONS calls OPTIONS and ALL callbacks
   *
   * @param {function(grid)} callback function to be called
   * @param {array} types the types of data change you want to be informed of.  Values from
   * the {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
   *  values ( ALL, EDIT, ROW, COLUMN, OPTIONS ).  Optional and defaults to ALL
   * @returns {function} deregister function - a function that can be called to deregister this callback
   */Grid.prototype.registerDataChangeCallback=function registerDataChangeCallback(callback,types,_this){var self=this,uid=gridUtil.nextUid();if(!types){types=[uiGridConstants.dataChange.ALL];}if(!Array.isArray(types)){gridUtil.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: "+types);}this.dataChangeCallbacks[uid]={callback:callback,types:types,_this:_this};return function(){delete self.dataChangeCallbacks[uid];};};/**
   * @ngdoc function
   * @name callDataChangeCallbacks
   * @methodOf ui.grid.class:Grid
   * @description Calls the callbacks based on the type of data change that
   * has occurred. Always calls the ALL callbacks, calls the ROW, EDIT, COLUMN and OPTIONS callbacks if the
   * event type is matching, or if the type is ALL.
   * @param {string} type the type of event that occurred - one of the
   * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
   *  values (ALL, ROW, EDIT, COLUMN, OPTIONS)
   */Grid.prototype.callDataChangeCallbacks=function callDataChangeCallbacks(type,options){angular.forEach(this.dataChangeCallbacks,function(callback,uid){if(callback.types.indexOf(uiGridConstants.dataChange.ALL)!==-1||callback.types.indexOf(type)!==-1||type===uiGridConstants.dataChange.ALL){if(callback._this){callback.callback.apply(callback._this,this,options);}else{callback.callback(this,options);}}},this);};/**
   * @ngdoc function
   * @name notifyDataChange
   * @methodOf ui.grid.class:Grid
   * @description Notifies us that a data change has occurred, used in the public
   * api for users to tell us when they've changed data or some other event that
   * our watches cannot pick up
   * @param {string} type the type of event that occurred - one of the
   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN, OPTIONS)
   *
   * - ALL: listeners fired on any of these events, fires listeners on all events.
   * - ROW: fired when a row is added or removed.
   * - EDIT: fired when the data in a cell is edited.
   * - COLUMN: fired when the column definitions are modified.
   * - OPTIONS: fired when the grid options are modified.
   */Grid.prototype.notifyDataChange=function notifyDataChange(type){var constants=uiGridConstants.dataChange;if(type===constants.ALL||type===constants.COLUMN||type===constants.EDIT||type===constants.ROW||type===constants.OPTIONS){this.callDataChangeCallbacks(type);}else{gridUtil.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: "+type);}};/**
   * @ngdoc function
   * @name columnRefreshCallback
   * @methodOf ui.grid.class:Grid
   * @description refreshes the grid when a column refresh
   * is notified, which triggers handling of the visible flag.
   * This is called on uiGridConstants.dataChange.COLUMN, and is
   * registered as a dataChangeCallback in grid.js
   * @param {object} grid The grid object.
   * @param {object} options Any options passed into the callback.
   */Grid.prototype.columnRefreshCallback=function columnRefreshCallback(grid,options){grid.buildColumns(options);grid.queueGridRefresh();};/**
   * @ngdoc function
   * @name processRowsCallback
   * @methodOf ui.grid.class:Grid
   * @description calls the row processors, specifically
   * intended to reset the sorting when an edit is called,
   * registered as a dataChangeCallback on uiGridConstants.dataChange.EDIT
   * @param {object} grid The grid object.
   */Grid.prototype.processRowsCallback=function processRowsCallback(grid){grid.queueGridRefresh();};/**
   * @ngdoc function
   * @name updateFooterHeightCallback
   * @methodOf ui.grid.class:Grid
   * @description recalculates the footer height,
   * registered as a dataChangeCallback on uiGridConstants.dataChange.OPTIONS
   * @param {object} grid The grid object.
   */Grid.prototype.updateFooterHeightCallback=function updateFooterHeightCallback(grid){grid.footerHeight=grid.calcFooterHeight();grid.columnFooterHeight=grid.calcColumnFooterHeight();};/**
   * @ngdoc function
   * @name getColumn
   * @methodOf ui.grid.class:Grid
   * @description returns a grid column for the column name
   * @param {string} name column name
   */Grid.prototype.getColumn=function getColumn(name){return rowColumnFinder(this.columns,function(column){return column.colDef.name===name;});};/**
   * @ngdoc function
   * @name getColDef
   * @methodOf ui.grid.class:Grid
   * @description returns a grid colDef for the column name
   * @param {string} name column.field
   */Grid.prototype.getColDef=function getColDef(name){return rowColumnFinder(this.options.columnDefs,function(colDef){return colDef.name===name;});};/**
   * @ngdoc function
   * @name assignTypes
   * @methodOf ui.grid.class:Grid
   * @description uses the first row of data to assign colDef.type for any types not defined.
   */ /**
   * @ngdoc property
   * @name type
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description the type of the column, used in sorting.  If not provided then the
   * grid will guess the type.  Add this only if the grid guessing is not to your
   * satisfaction.  One of:
   * - 'string'
   * - 'boolean'
   * - 'number'
   * - 'date'
   * - 'object'
   * - 'numberStr'
   * Note that if you choose date, your dates should be in a javascript date type
   *
   */Grid.prototype.assignTypes=function(){var self=this;self.options.columnDefs.forEach(function(colDef,index){// Assign colDef type if not specified
if(!colDef.type){var col=new GridColumn(colDef,index,self);var firstRow=self.rows.length>0?self.rows[0]:null;if(firstRow){colDef.type=gridUtil.guessType(self.getCellValue(firstRow,col));}else{colDef.type='string';}}});};/**
   * @ngdoc function
   * @name isRowHeaderColumn
   * @methodOf ui.grid.class:Grid
   * @description returns true if the column is a row Header
   * @param {object} column column
   */Grid.prototype.isRowHeaderColumn=function isRowHeaderColumn(column){return this.rowHeaderColumns.indexOf(column)!==-1;};/**
  * @ngdoc function
  * @name addRowHeaderColumn
  * @methodOf ui.grid.class:Grid
  * @description adds a row header column to the grid
  * @param {object} colDef Column definition object.
  * @param {float} order Number that indicates where the column should be placed in the grid.
  * @param {boolean} stopColumnBuild Prevents the buildColumn callback from being triggered. This is useful to improve
  * performance of the grid during initial load.
  */Grid.prototype.addRowHeaderColumn=function addRowHeaderColumn(colDef,order,stopColumnBuild){var self=this;// default order
if(order===undefined){order=0;}var rowHeaderCol=new GridColumn(colDef,gridUtil.nextUid(),self);rowHeaderCol.isRowHeader=true;if(self.isRTL()){self.createRightContainer();rowHeaderCol.renderContainer='right';}else{self.createLeftContainer();rowHeaderCol.renderContainer='left';}// relies on the default column builder being first in array, as it is instantiated
// as part of grid creation
self.columnBuilders[0](colDef,rowHeaderCol,self.options).then(function(){rowHeaderCol.enableFiltering=false;rowHeaderCol.enableSorting=false;rowHeaderCol.enableHiding=false;rowHeaderCol.headerPriority=order;self.rowHeaderColumns.push(rowHeaderCol);self.rowHeaderColumns=self.rowHeaderColumns.sort(function(a,b){return a.headerPriority-b.headerPriority;});if(!stopColumnBuild){self.buildColumns().then(function(){self.preCompileCellTemplates();self.queueGridRefresh();}).catch(angular.noop);}}).catch(angular.noop);};/**
   * @ngdoc function
   * @name getOnlyDataColumns
   * @methodOf ui.grid.class:Grid
   * @description returns all columns except for rowHeader columns
   */Grid.prototype.getOnlyDataColumns=function getOnlyDataColumns(){var self=this,cols=[];self.columns.forEach(function(col){if(self.rowHeaderColumns.indexOf(col)===-1){cols.push(col);}});return cols;};/**
   * @ngdoc function
   * @name buildColumns
   * @methodOf ui.grid.class:Grid
   * @description creates GridColumn objects from the columnDefinition.  Calls each registered
   * columnBuilder to further process the column
   * @param {object} opts An object contains options to use when building columns
   *
   * * **orderByColumnDefs**: defaults to **false**. When true, `buildColumns` will reorder existing columns according to the order within the column definitions.
   *
   * @returns {Promise} a promise to load any needed column resources
   */Grid.prototype.buildColumns=function buildColumns(opts){var options={orderByColumnDefs:false};angular.extend(options,opts);// gridUtil.logDebug('buildColumns');
var self=this;var builderPromises=[];var headerOffset=self.rowHeaderColumns.length;var i;// Remove any columns for which a columnDef cannot be found
// Deliberately don't use forEach, as it doesn't like splice being called in the middle
// Also don't cache columns.length, as it will change during this operation
for(i=0;i<self.columns.length;i++){if(!self.getColDef(self.columns[i].name)){self.columns.splice(i,1);i--;}}// add row header columns to the grid columns array _after_ columns without columnDefs have been removed
// rowHeaderColumns is ordered by priority so insert in reverse
for(var j=self.rowHeaderColumns.length-1;j>=0;j--){self.columns.unshift(self.rowHeaderColumns[j]);}// look at each column def, and update column properties to match.  If the column def
// doesn't have a column, then splice in a new gridCol
self.options.columnDefs.forEach(function(colDef,index){self.preprocessColDef(colDef);var col=self.getColumn(colDef.name);if(!col){col=new GridColumn(colDef,gridUtil.nextUid(),self);self.columns.splice(index+headerOffset,0,col);}else{// tell updateColumnDef that the column was pre-existing
col.updateColumnDef(colDef,false);}self.columnBuilders.forEach(function(builder){builderPromises.push(builder.call(self,colDef,col,self.options));});});/*** Reorder columns if necessary ***/if(!!options.orderByColumnDefs){// Create a shallow copy of the columns as a cache
var columnCache=self.columns.slice(0);// We need to allow for the "row headers" when mapping from the column defs array to the columns array
//   If we have a row header in columns[0] and don't account for it   we'll overwrite it with the column in columnDefs[0]
// Go through all the column defs, use the shorter of columns length and colDefs.length because if a user has given two columns the same name then
// columns will be shorter than columnDefs.  In this situation we'll avoid an error, but the user will still get an unexpected result
var len=Math.min(self.options.columnDefs.length,self.columns.length);for(i=0;i<len;i++){// If the column at this index has a different name than the column at the same index in the column defs...
if(self.columns[i+headerOffset].name!==self.options.columnDefs[i].name){// Replace the one in the cache with the appropriate column
columnCache[i+headerOffset]=self.getColumn(self.options.columnDefs[i].name);}else{// Otherwise just copy over the one from the initial columns
columnCache[i+headerOffset]=self.columns[i+headerOffset];}}// Empty out the columns array, non-destructively
self.columns.length=0;// And splice in the updated, ordered columns from the cache
Array.prototype.splice.apply(self.columns,[0,0].concat(columnCache));}return $q.all(builderPromises).then(function(){if(self.rows.length>0){self.assignTypes();}if(options.preCompileCellTemplates){self.preCompileCellTemplates();}}).catch(angular.noop);};Grid.prototype.preCompileCellTemplate=function(col){var self=this;var html=col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD,self.getQualifiedColField(col));html=html.replace(uiGridConstants.COL_FIELD,'grid.getCellValue(row, col)');col.compiledElementFn=$compile(html);if(col.compiledElementFnDefer){col.compiledElementFnDefer.resolve(col.compiledElementFn);}};/**
 * @ngdoc function
 * @name preCompileCellTemplates
 * @methodOf ui.grid.class:Grid
 * @description precompiles all cell templates
 */Grid.prototype.preCompileCellTemplates=function(){var self=this;self.columns.forEach(function(col){if(col.cellTemplate){self.preCompileCellTemplate(col);}else if(col.cellTemplatePromise){col.cellTemplatePromise.then(function(){self.preCompileCellTemplate(col);}).catch(angular.noop);}});};/**
   * @ngdoc function
   * @name getGridQualifiedColField
   * @methodOf ui.grid.class:Grid
   * @description Returns the $parse-able accessor for a column within its $scope
   * @param {GridColumn} col col object
   */Grid.prototype.getQualifiedColField=function(col){var base='row.entity';if(col.field===uiGridConstants.ENTITY_BINDING){return base;}return gridUtil.preEval(base+'.'+col.field);};/**
   * @ngdoc function
   * @name createLeftContainer
   * @methodOf ui.grid.class:Grid
   * @description creates the left render container if it doesn't already exist
   */Grid.prototype.createLeftContainer=function(){if(!this.hasLeftContainer()){this.renderContainers.left=new GridRenderContainer('left',this,{disableColumnOffset:true});}};/**
   * @ngdoc function
   * @name createRightContainer
   * @methodOf ui.grid.class:Grid
   * @description creates the right render container if it doesn't already exist
   */Grid.prototype.createRightContainer=function(){if(!this.hasRightContainer()){this.renderContainers.right=new GridRenderContainer('right',this,{disableColumnOffset:true});}};/**
   * @ngdoc function
   * @name hasLeftContainer
   * @methodOf ui.grid.class:Grid
   * @description returns true if leftContainer exists
   */Grid.prototype.hasLeftContainer=function(){return this.renderContainers.left!==undefined;};/**
   * @ngdoc function
   * @name hasRightContainer
   * @methodOf ui.grid.class:Grid
   * @description returns true if rightContainer exists
   */Grid.prototype.hasRightContainer=function(){return this.renderContainers.right!==undefined;};/**
   * undocumented function
   * @name preprocessColDef
   * @methodOf ui.grid.class:Grid
   * @description defaults the name property from field to maintain backwards compatibility with 2.x
   * validates that name or field is present
   */Grid.prototype.preprocessColDef=function preprocessColDef(colDef){var self=this;if(!colDef.field&&!colDef.name){throw new Error('colDef.name or colDef.field property is required');}// maintain backwards compatibility with 2.x
// field was required in 2.x.  now name is required
if(colDef.name===undefined&&colDef.field!==undefined){// See if the column name already exists:
var newName=colDef.field,counter=2;while(self.getColumn(newName)){newName=colDef.field+counter.toString();counter++;}colDef.name=newName;}};// Return a list of items that exist in the `n` array but not the `o` array. Uses optional property accessors passed as third & fourth parameters
Grid.prototype.newInN=function newInN(o,n,oAccessor,nAccessor){var self=this;var t=[];for(var i=0;i<n.length;i++){var nV=nAccessor?n[i][nAccessor]:n[i];var found=false;for(var j=0;j<o.length;j++){var oV=oAccessor?o[j][oAccessor]:o[j];if(self.options.rowEquality(nV,oV)){found=true;break;}}if(!found){t.push(nV);}}return t;};var rowColumnFinder=function(array,func){if(array&&array.length){if(angular.isFunction(array.find)){return array.find(func)||null;}var result=null;array.every(function(entry){if(func(entry)){result=entry;return false;}return true;});return result;}return null;};/**
   * @ngdoc function
   * @name getRow
   * @methodOf ui.grid.class:Grid
   * @description returns the GridRow that contains the rowEntity
   * @param {object} rowEntity the gridOptions.data array element instance
   * @param {array} lookInRows [optional] the rows to look in - if not provided then
   * looks in grid.rows
   */Grid.prototype.getRow=function getRow(rowEntity,lookInRows){var self=this;lookInRows=lookInRows==void 0?this.rows:lookInRows;return rowColumnFinder(lookInRows,function(row){return self.options.rowEquality(row.entity,rowEntity);});};/**
   * @ngdoc function
   * @name getRowsByKey
   * @methodOf ui.grid.class:Grid
   * @description returns all GridRows who have an key that is equal to comparator
   * so for Example if isInEntity == false then it does this check: row[key] === comparator
   * if isInEntity == true then it does this check: row.entity[key] === comparator
   * @param {boolean} isInEntity if true then key is in entity else it's directly in row
   * @param {(string|number)} key the key to look for
   * @param {any} comparator the value that key should have
   * @param {array} lookInRows [optional] the rows to look in - if not provided then
   * looks in grid.rows
   */Grid.prototype.getRowsByKey=function getRowsByKey(isInEntity,key,comparator,lookInRows){if(key==void 0){return null;}lookInRows=lookInRows==void 0?this.rows:lookInRows;var func=isInEntity?function(row){return row.entity!=void 0&&row.entity.hasOwnProperty(key)&&row.entity[key]===comparator;}:function(row){return row.hasOwnProperty(key)&&row[key]===comparator;};return lookInRows.filter(func);};/**
   * @ngdoc function
   * @name findRowByKey
   * @methodOf ui.grid.class:Grid
   * @description returns the first GridRow who has an key that is equal to comparator
   * so for Example if isInEntity == false then it does this check: row[key] === comparator
   * if isInEntity == true then it does this check: row.entity[key] === comparator
   * @param {boolean} isInEntity if true then key is in entity else it's directly in row
   * @param {(string|number)} key the key to look for
   * @param {any} comparator the value that key should have
   * @param {array} lookInRows [optional] the rows to look in - if not provided then
   * looks in grid.rows
   */Grid.prototype.findRowByKey=function findRowByKey(isInEntity,key,comparator,lookInRows){var result=null;if(key!=void 0){lookInRows=lookInRows==void 0?this.rows:lookInRows;var func=isInEntity?function(row){if(row.entity!=void 0&&row.entity.hasOwnProperty(key)&&row.entity[key]===comparator){result=row;return false;}return true;}:function(row){if(row.hasOwnProperty(key)&&row[key]===comparator){result=row;return false;}return true;};lookInRows.every(func);}return result;};/**
   * @ngdoc function
   * @name modifyRows
   * @methodOf ui.grid.class:Grid
   * @description creates or removes GridRow objects from the newRawData array.  Calls each registered
   * rowBuilder to further process the row
   * @param {array} newRawData Modified set of data
   *
   * This method aims to achieve three things:
   * 1. the resulting rows array is in the same order as the newRawData, we'll call
   * rowsProcessors immediately after to sort the data anyway
   * 2. if we have row hashing available, we try to use the rowHash to find the row
   * 3. no memory leaks - rows that are no longer in newRawData need to be garbage collected
   *
   * The basic logic flow makes use of the newRawData, oldRows and oldHash, and creates
   * the newRows and newHash
   *
   * ```
   * newRawData.forEach newEntity
   *   if (hashing enabled)
   *     check oldHash for newEntity
   *   else
   *     look for old row directly in oldRows
   *   if !oldRowFound     // must be a new row
   *     create newRow
   *   append to the newRows and add to newHash
   *   run the processors
   * ```
   *
   * Rows are identified using the hashKey if configured.  If not configured, then rows
   * are identified using the gridOptions.rowEquality function
   *
   * This method is useful when trying to select rows immediately after loading data without
   * using a $timeout/$interval, e.g.:
   *
   *   $scope.gridOptions.data =  someData;
   *   $scope.gridApi.grid.modifyRows($scope.gridOptions.data);
   *   $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
   *
   * OR to persist row selection after data update (e.g. rows selected, new data loaded, want
   * originally selected rows to be re-selected))
   */Grid.prototype.modifyRows=function modifyRows(newRawData){var self=this;var oldRows=self.rows.slice(0);var oldRowHash=self.rowHashMap||self.createRowHashMap();var allRowsSelected=true;self.rowHashMap=self.createRowHashMap();self.rows.length=0;newRawData.forEach(function(newEntity,i){var newRow,oldRow;if(self.options.enableRowHashing){// if hashing is enabled, then this row will be in the hash if we already know about it
oldRow=oldRowHash.get(newEntity);}else{// otherwise, manually search the oldRows to see if we can find this row
oldRow=self.getRow(newEntity,oldRows);}// update newRow to have an entity
if(oldRow){newRow=oldRow;newRow.entity=newEntity;if(newRow.index!==i){newRow.index=i;}}// if we didn't find the row, it must be new, so create it
if(!newRow){newRow=self.processRowBuilders(new GridRow(newEntity,i,self));}self.rows.push(newRow);self.rowHashMap.put(newEntity,newRow);if(!newRow.isSelected){allRowsSelected=false;}});if(self.selection&&self.rows.length){self.selection.selectAll=allRowsSelected;}self.assignTypes();var p1=$q.when(self.processRowsProcessors(self.rows)).then(function(renderableRows){return self.setVisibleRows(renderableRows);}).catch(angular.noop);var p2=$q.when(self.processColumnsProcessors(self.columns)).then(function(renderableColumns){return self.setVisibleColumns(renderableColumns);}).catch(angular.noop);return $q.all([p1,p2]);};/**
   * Private Undocumented Method
   * @name addRows
   * @methodOf ui.grid.class:Grid
   * @description adds the newRawData array of rows to the grid and calls all registered
   * rowBuilders. this keyword will reference the grid
   */Grid.prototype.addRows=function addRows(newRawData){var self=this,existingRowCount=self.rows.length;for(var i=0;i<newRawData.length;i++){var newRow=self.processRowBuilders(new GridRow(newRawData[i],i+existingRowCount,self));if(self.options.enableRowHashing){var found=self.rowHashMap.get(newRow.entity);if(found){found.row=newRow;}}self.rows.push(newRow);}};/**
   * @ngdoc function
   * @name processRowBuilders
   * @methodOf ui.grid.class:Grid
   * @description processes all RowBuilders for the gridRow
   * @param {GridRow} gridRow reference to gridRow
   * @returns {GridRow} the gridRow with all additional behavior added
   */Grid.prototype.processRowBuilders=function processRowBuilders(gridRow){var self=this;self.rowBuilders.forEach(function(builder){builder.call(self,gridRow,self.options);});return gridRow;};/**
   * @ngdoc function
   * @name registerStyleComputation
   * @methodOf ui.grid.class:Grid
   * @description registered a styleComputation function
   *
   * If the function returns a value it will be appended into the grid's `<style>` block
   * @param {function($scope)} styleComputationInfo function
   */Grid.prototype.registerStyleComputation=function registerStyleComputation(styleComputationInfo){this.styleComputations.push(styleComputationInfo);};/**
   * @ngdoc function
   * @name registerRowsProcessor
   * @methodOf ui.grid.class:Grid
   * @description
   *
   * Register a "rows processor" function. When the rows are updated,
   * the grid calls each registered "rows processor", which has a chance
   * to alter the set of rows (sorting, etc) as long as the count is not
   * modified.
   *
   * @param {function(renderedRowsToProcess, columns )} processor rows processor function, which
   * is run in the context of the grid (i.e. this for the function will be the grid), and must
   * return the updated rows list, which is passed to the next processor in the chain
   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
   * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
   *
   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
   *
   */Grid.prototype.registerRowsProcessor=function registerRowsProcessor(processor,priority){if(!angular.isFunction(processor)){throw'Attempt to register non-function rows processor: '+processor;}this.rowsProcessors.push({processor:processor,priority:priority});this.rowsProcessors.sort(function sortByPriority(a,b){return a.priority-b.priority;});};/**
   * @ngdoc function
   * @name removeRowsProcessor
   * @methodOf ui.grid.class:Grid
   * @param {function(renderableRows)} processor processor function
   * @description Remove a registered rows processor
   */Grid.prototype.removeRowsProcessor=function removeRowsProcessor(processor){var idx=-1;this.rowsProcessors.forEach(function(rowsProcessor,index){if(rowsProcessor.processor===processor){idx=index;}});if(idx!==-1){this.rowsProcessors.splice(idx,1);}};/**
   * Private Undocumented Method
   * @name processRowsProcessors
   * @methodOf ui.grid.class:Grid
   * @param {Array[GridRow]} renderableRows The array of "renderable" rows
   * @description Run all the registered rows processors on the array of renderable rows
   */Grid.prototype.processRowsProcessors=function processRowsProcessors(renderableRows){var self=this;// Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
var myRenderableRows=renderableRows.slice(0);// Return myRenderableRows with no processing if we have no rows processors
if(self.rowsProcessors.length===0){return $q.when(myRenderableRows);}// Counter for iterating through rows processors
var i=0;// Promise for when we're done with all the processors
var finished=$q.defer();// This function will call the processor in self.rowsProcessors at index 'i', and then
//   when done will call the next processor in the list, using the output from the processor
//   at i as the argument for 'renderedRowsToProcess' on the next iteration.
//
//   If we're at the end of the list of processors, we resolve our 'finished' callback with
//   the result.
function startProcessor(i,renderedRowsToProcess){// Get the processor at 'i'
var processor=self.rowsProcessors[i].processor;// Call the processor, passing in the rows to process and the current columns
//   (note: it's wrapped in $q.when() in case the processor does not return a promise)
return $q.when(processor.call(self,renderedRowsToProcess,self.columns)).then(function handleProcessedRows(processedRows){// Check for errors
if(!processedRows){throw"Processor at index "+i+" did not return a set of renderable rows";}if(!angular.isArray(processedRows)){throw"Processor at index "+i+" did not return an array";}// Processor is done, increment the counter
i++;// If we're not done with the processors, call the next one
if(i<=self.rowsProcessors.length-1){return startProcessor(i,processedRows);}// We're done! Resolve the 'finished' promise
else{finished.resolve(processedRows);}}).catch(function(error){throw error;});}// Start on the first processor
startProcessor(0,myRenderableRows);return finished.promise;};Grid.prototype.setVisibleRows=function setVisibleRows(rows){var self=this;// Reset all the render container row caches
for(var i in self.renderContainers){var container=self.renderContainers[i];container.canvasHeightShouldUpdate=true;if(typeof container.visibleRowCache==='undefined'){container.visibleRowCache=[];}else{container.visibleRowCache.length=0;}}// rows.forEach(function (row) {
for(var ri=0;ri<rows.length;ri++){var row=rows[ri];var targetContainer=typeof row.renderContainer!=='undefined'&&row.renderContainer?row.renderContainer:'body';// If the row is visible
if(row.visible){self.renderContainers[targetContainer].visibleRowCache.push(row);}}self.api.core.raise.rowsVisibleChanged(this.api);self.api.core.raise.rowsRendered(this.api);};/**
   * @ngdoc function
   * @name registerColumnsProcessor
   * @methodOf ui.grid.class:Grid
   * @param {function(renderedColumnsToProcess, rows)} processor column processor function, which
   * is run in the context of the grid (i.e. this for the function will be the grid), and
   * which must return an updated renderedColumnsToProcess which can be passed to the next processor
   * in the chain
   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
   * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
   *
   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
   * @description

     Register a "columns processor" function. When the columns are updated,
     the grid calls each registered "columns processor", which has a chance
     to alter the set of columns, as long as the count is not modified.
   */Grid.prototype.registerColumnsProcessor=function registerColumnsProcessor(processor,priority){if(!angular.isFunction(processor)){throw'Attempt to register non-function rows processor: '+processor;}this.columnsProcessors.push({processor:processor,priority:priority});this.columnsProcessors.sort(function sortByPriority(a,b){return a.priority-b.priority;});};Grid.prototype.removeColumnsProcessor=function removeColumnsProcessor(processor){var idx=this.columnsProcessors.indexOf(processor);if(typeof idx!=='undefined'&&idx!==undefined){this.columnsProcessors.splice(idx,1);}};Grid.prototype.processColumnsProcessors=function processColumnsProcessors(renderableColumns){var self=this;// Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
var myRenderableColumns=renderableColumns.slice(0);// Return myRenderableRows with no processing if we have no rows processors
if(self.columnsProcessors.length===0){return $q.when(myRenderableColumns);}// Promise for when we're done with all the processors
var finished=$q.defer();// This function will call the processor in self.rowsProcessors at index 'i', and then
//   when done will call the next processor in the list, using the output from the processor
//   at i as the argument for 'renderedRowsToProcess' on the next iteration.
//
//   If we're at the end of the list of processors, we resolve our 'finished' callback with
//   the result.
function startProcessor(i,renderedColumnsToProcess){// Get the processor at 'i'
var processor=self.columnsProcessors[i].processor;// Call the processor, passing in the rows to process and the current columns
//   (note: it's wrapped in $q.when() in case the processor does not return a promise)
return $q.when(processor.call(self,renderedColumnsToProcess,self.rows)).then(function handleProcessedRows(processedColumns){// Check for errors
if(!processedColumns){throw"Processor at index "+i+" did not return a set of renderable rows";}if(!angular.isArray(processedColumns)){throw"Processor at index "+i+" did not return an array";}// Processor is done, increment the counter
i++;// If we're not done with the processors, call the next one
if(i<=self.columnsProcessors.length-1){return startProcessor(i,myRenderableColumns);}// We're done! Resolve the 'finished' promise
else{finished.resolve(myRenderableColumns);}}).catch(angular.noop);}// Start on the first processor
startProcessor(0,myRenderableColumns);return finished.promise;};Grid.prototype.setVisibleColumns=function setVisibleColumns(columns){// gridUtil.logDebug('setVisibleColumns');
var self=this;// Reset all the render container row caches
for(var i in self.renderContainers){var container=self.renderContainers[i];container.visibleColumnCache.length=0;}for(var ci=0;ci<columns.length;ci++){var column=columns[ci];// If the column is visible
if(column.visible){// If the column has a container specified
if(typeof column.renderContainer!=='undefined'&&column.renderContainer){self.renderContainers[column.renderContainer].visibleColumnCache.push(column);}// If not, put it into the body container
else{self.renderContainers.body.visibleColumnCache.push(column);}}}};/**
   * @ngdoc function
   * @name handleWindowResize
   * @methodOf ui.grid.class:Grid
   * @description Triggered when the browser window resizes; automatically resizes the grid
   * @returns {Promise} A resolved promise once the window resize has completed.
   */Grid.prototype.handleWindowResize=function handleWindowResize($event){var self=this;self.gridWidth=gridUtil.elementWidth(self.element);self.gridHeight=gridUtil.elementHeight(self.element);return self.queueRefresh();};/**
   * @ngdoc function
   * @name queueRefresh
   * @methodOf ui.grid.class:Grid
   * @description queues a grid refreshCanvas, a way of debouncing all the refreshes we might otherwise issue
   */Grid.prototype.queueRefresh=function queueRefresh(){var self=this;if(self.refreshCanceller){$timeout.cancel(self.refreshCanceller);}self.refreshCanceller=$timeout(function(){self.refreshCanvas(true);});self.refreshCanceller.then(function(){self.refreshCanceller=null;}).catch(angular.noop);return self.refreshCanceller;};/**
   * @ngdoc function
   * @name queueGridRefresh
   * @methodOf ui.grid.class:Grid
   * @description queues a grid refresh, a way of debouncing all the refreshes we might otherwise issue
   */Grid.prototype.queueGridRefresh=function queueGridRefresh(){var self=this;if(self.gridRefreshCanceller){$timeout.cancel(self.gridRefreshCanceller);}self.gridRefreshCanceller=$timeout(function(){self.refresh(true);});self.gridRefreshCanceller.then(function(){self.gridRefreshCanceller=null;}).catch(angular.noop);return self.gridRefreshCanceller;};/**
   * @ngdoc function
   * @name updateCanvasHeight
   * @methodOf ui.grid.class:Grid
   * @description flags all render containers to update their canvas height
   */Grid.prototype.updateCanvasHeight=function updateCanvasHeight(){var self=this;for(var containerId in self.renderContainers){if(self.renderContainers.hasOwnProperty(containerId)){var container=self.renderContainers[containerId];container.canvasHeightShouldUpdate=true;}}};/**
   * @ngdoc function
   * @name buildStyles
   * @methodOf ui.grid.class:Grid
   * @description calls each styleComputation function
   */Grid.prototype.buildStyles=function buildStyles(){var self=this;// gridUtil.logDebug('buildStyles');
self.customStyles='';self.styleComputations.sort(function(a,b){if(a.priority===null){return 1;}if(b.priority===null){return-1;}if(a.priority===null&&b.priority===null){return 0;}return a.priority-b.priority;}).forEach(function(compInfo){// this used to provide $scope as a second parameter, but I couldn't find any
// style builders that used it, so removed it as part of moving to grid from controller
var ret=compInfo.func.call(self);if(angular.isString(ret)){self.customStyles+='\n'+ret;}});};Grid.prototype.minColumnsToRender=function minColumnsToRender(){var self=this;var viewport=this.getViewportWidth();var min=0;var totalWidth=0;self.columns.forEach(function(col,i){if(totalWidth<viewport){totalWidth+=col.drawnWidth;min++;}else{var currWidth=0;for(var j=i;j>=i-min;j--){currWidth+=self.columns[j].drawnWidth;}if(currWidth<viewport){min++;}}});return min;};Grid.prototype.getBodyHeight=function getBodyHeight(){return this.getViewportHeight();};// NOTE: viewport drawable height is the height of the grid minus the header row height (including any border)
// TODO(c0bra): account for footer height
Grid.prototype.getViewportHeight=function getViewportHeight(){var self=this;var viewPortHeight=this.gridHeight-this.headerHeight-this.footerHeight;// Account for native horizontal scrollbar, if present
// if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
//   viewPortHeight = viewPortHeight - this.horizontalScrollbarHeight;
// }
var adjustment=self.getViewportAdjustment();viewPortHeight=viewPortHeight+adjustment.height;// gridUtil.logDebug('viewPortHeight', viewPortHeight);
return viewPortHeight>0?viewPortHeight:0;};Grid.prototype.getViewportWidth=function getViewportWidth(){var self=this;var viewPortWidth=this.gridWidth;// if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
//   viewPortWidth = viewPortWidth - this.verticalScrollbarWidth;
// }
var adjustment=self.getViewportAdjustment();viewPortWidth=viewPortWidth+adjustment.width;// gridUtil.logDebug('getviewPortWidth', viewPortWidth);
return viewPortWidth;};Grid.prototype.getHeaderViewportWidth=function getHeaderViewportWidth(){return this.getViewportWidth();};Grid.prototype.addVerticalScrollSync=function(containerId,callBackFn){this.verticalScrollSyncCallBackFns[containerId]=callBackFn;};Grid.prototype.addHorizontalScrollSync=function(containerId,callBackFn){this.horizontalScrollSyncCallBackFns[containerId]=callBackFn;};/**
 * Scroll needed containers by calling their ScrollSyncs
 * @param sourceContainerId the containerId that has already set it's top/left.
 *         can be empty string which means all containers need to set top/left
 * @param scrollEvent
 */Grid.prototype.scrollContainers=function(sourceContainerId,scrollEvent){if(scrollEvent.y){// default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
var verts=['body','left','right'];this.flagScrollingVertically(scrollEvent);if(sourceContainerId==='body'){verts=['left','right'];}else if(sourceContainerId==='left'){verts=['body','right'];}else if(sourceContainerId==='right'){verts=['body','left'];}for(var i=0;i<verts.length;i++){var id=verts[i];if(this.verticalScrollSyncCallBackFns[id]){this.verticalScrollSyncCallBackFns[id](scrollEvent);}}}if(scrollEvent.x){// default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
var horizs=['body','bodyheader','bodyfooter'];this.flagScrollingHorizontally(scrollEvent);if(sourceContainerId==='body'){horizs=['bodyheader','bodyfooter'];}for(var j=0;j<horizs.length;j++){var idh=horizs[j];if(this.horizontalScrollSyncCallBackFns[idh]){this.horizontalScrollSyncCallBackFns[idh](scrollEvent);}}}};Grid.prototype.registerViewportAdjuster=function registerViewportAdjuster(func){this.viewportAdjusters.push(func);};Grid.prototype.removeViewportAdjuster=function registerViewportAdjuster(func){var idx=this.viewportAdjusters.indexOf(func);if(typeof idx!=='undefined'&&idx!==undefined){this.viewportAdjusters.splice(idx,1);}};Grid.prototype.getViewportAdjustment=function getViewportAdjustment(){var self=this;var adjustment={height:0,width:0};self.viewportAdjusters.forEach(function(func){adjustment=func.call(this,adjustment);});return adjustment;};Grid.prototype.getVisibleRowCount=function getVisibleRowCount(){// return this.visibleRowCache.length;
return this.renderContainers.body.visibleRowCache.length;};Grid.prototype.getVisibleRows=function getVisibleRows(){return this.renderContainers.body.visibleRowCache;};Grid.prototype.getVisibleColumnCount=function getVisibleColumnCount(){// return this.visibleRowCache.length;
return this.renderContainers.body.visibleColumnCache.length;};Grid.prototype.searchRows=function searchRows(renderableRows){return rowSearcher.search(this,renderableRows,this.columns);};Grid.prototype.sortByColumn=function sortByColumn(renderableRows){return rowSorter.sort(this,renderableRows,this.columns);};/**
   * @ngdoc function
   * @name getCellValue
   * @methodOf ui.grid.class:Grid
   * @description Gets the value of a cell for a particular row and column
   * @param {GridRow} row Row to access
   * @param {GridColumn} col Column to access
   */Grid.prototype.getCellValue=function getCellValue(row,col){if(typeof row.entity['$$'+col.uid]!=='undefined'){return row.entity['$$'+col.uid].rendered;}else if(this.options.flatEntityAccess&&typeof col.field!=='undefined'){return row.entity[col.field];}else{if(!col.cellValueGetterCache){col.cellValueGetterCache=$parse(row.getEntityQualifiedColField(col));}return col.cellValueGetterCache(row);}};/**
   * @ngdoc function
   * @name getCellDisplayValue
   * @methodOf ui.grid.class:Grid
   * @description Gets the displayed value of a cell after applying any the `cellFilter`
   * @param {GridRow} row Row to access
   * @param {GridColumn} col Column to access
   */Grid.prototype.getCellDisplayValue=function getCellDisplayValue(row,col){if(!col.cellDisplayGetterCache){var custom_filter=col.cellFilter?" | "+col.cellFilter:"";if(typeof row.entity['$$'+col.uid]!=='undefined'){col.cellDisplayGetterCache=$parse(row.entity['$$'+col.uid].rendered+custom_filter);}else if(this.options.flatEntityAccess&&typeof col.field!=='undefined'){var colField=col.field.replace(/(')|(\\)/g,"\\$&");col.cellDisplayGetterCache=$parse('entity[\''+colField+'\']'+custom_filter);}else{col.cellDisplayGetterCache=$parse(row.getEntityQualifiedColField(col)+custom_filter);}}var rowWithCol=angular.extend({},row,{col:col});return col.cellDisplayGetterCache(rowWithCol);};Grid.prototype.getNextColumnSortPriority=function getNextColumnSortPriority(){var self=this,p=0;self.columns.forEach(function(col){if(col.sort&&col.sort.priority!==undefined&&col.sort.priority>=p){p=col.sort.priority+1;}});return p;};/**
   * @ngdoc function
   * @name resetColumnSorting
   * @methodOf ui.grid.class:Grid
   * @description Return the columns that the grid is currently being sorted by
   * @param {GridColumn} [excludedColumn] Optional GridColumn to exclude from having its sorting reset
   */Grid.prototype.resetColumnSorting=function resetColumnSorting(excludeCol){var self=this;self.columns.forEach(function(col){if(col!==excludeCol&&!col.suppressRemoveSort){col.sort={};}});};/**
   * @ngdoc function
   * @name getColumnSorting
   * @methodOf ui.grid.class:Grid
   * @description Return the columns that the grid is currently being sorted by
   * @returns {Array[GridColumn]} An array of GridColumn objects
   */Grid.prototype.getColumnSorting=function getColumnSorting(){var self=this;var sortedCols=[],myCols;// Iterate through all the columns, sorted by priority
// Make local copy of column list, because sorting is in-place and we do not want to
// change the original sequence of columns
myCols=self.columns.slice(0);myCols.sort(rowSorter.prioritySort).forEach(function(col){if(col.sort&&typeof col.sort.direction!=='undefined'&&col.sort.direction&&(col.sort.direction===uiGridConstants.ASC||col.sort.direction===uiGridConstants.DESC)){sortedCols.push(col);}});return sortedCols;};/**
   * @ngdoc function
   * @name sortColumn
   * @methodOf ui.grid.class:Grid
   * @description Set the sorting on a given column, optionally resetting any existing sorting on the Grid.
   * Emits the sortChanged event whenever the sort criteria are changed.
   * @param {GridColumn} column Column to set the sorting on
   * @param {uiGridConstants.ASC|uiGridConstants.DESC} [direction] Direction to sort by, either descending or ascending.
   *   If not provided, the column will iterate through the sort directions
   *   specified in the {@link ui.grid.class:GridOptions.columnDef#sortDirectionCycle sortDirectionCycle} attribute.
   * @param {boolean} [add] Add this column to the sorting. If not provided or set to `false`, the Grid will reset any existing sorting and sort
   *   by this column only
   * @returns {Promise} A resolved promise that supplies the column.
   */Grid.prototype.sortColumn=function sortColumn(column,directionOrAdd,add){var self=this,direction=null;if(typeof column==='undefined'||!column){throw new Error('No column parameter provided');}// Second argument can either be a direction or whether to add this column to the existing sort.
//   If it's a boolean, it's an add, otherwise, it's a direction
if(typeof directionOrAdd==='boolean'){add=directionOrAdd;}else{direction=directionOrAdd;}if(!add||self.options&&self.options.suppressMultiSort){self.resetColumnSorting(column);column.sort.priority=undefined;// Get the actual priority since there may be columns which have suppressRemoveSort set
column.sort.priority=self.getNextColumnSortPriority();}else if(column.sort.priority===undefined){column.sort.priority=self.getNextColumnSortPriority();}if(!direction){// Find the current position in the cycle (or -1).
var i=column.sortDirectionCycle.indexOf(column.sort&&column.sort.direction?column.sort.direction:null);// Proceed to the next position in the cycle (or start at the beginning).
i=(i+1)%column.sortDirectionCycle.length;// If suppressRemoveSort is set, and the next position in the cycle would
// remove the sort, skip it.
if(column.colDef&&column.suppressRemoveSort&&!column.sortDirectionCycle[i]){i=(i+1)%column.sortDirectionCycle.length;}if(column.sortDirectionCycle[i]){column.sort.direction=column.sortDirectionCycle[i];}else{removeSortOfColumn(column,self);}}else{column.sort.direction=direction;}self.api.core.raise.sortChanged(self,self.getColumnSorting());return $q.when(column);};var removeSortOfColumn=function removeSortOfColumn(column,grid){// Decrease priority for every col where priority is higher than the removed sort's priority.
grid.columns.forEach(function(col){if(col.sort&&col.sort.priority!==undefined&&col.sort.priority>column.sort.priority){col.sort.priority-=1;}});// Remove sort
column.sort={};};/**
   * communicate to outside world that we are done with initial rendering
   */Grid.prototype.renderingComplete=function(){if(angular.isFunction(this.options.onRegisterApi)){this.options.onRegisterApi(this.api);}this.api.core.raise.renderingComplete(this.api);};Grid.prototype.createRowHashMap=function createRowHashMap(){var self=this;var hashMap=new RowHashMap();hashMap.grid=self;return hashMap;};/**
   * @ngdoc function
   * @name refresh
   * @methodOf ui.grid.class:Grid
   * @description Refresh the rendered grid on screen.
   * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed.
   */Grid.prototype.refresh=function refresh(rowsAltered){var self=this;var p1=self.processRowsProcessors(self.rows).then(function(renderableRows){self.setVisibleRows(renderableRows);}).catch(angular.noop);var p2=self.processColumnsProcessors(self.columns).then(function(renderableColumns){self.setVisibleColumns(renderableColumns);}).catch(angular.noop);return $q.all([p1,p2]).then(function(){self.refreshCanvas(true);self.redrawInPlace(rowsAltered);}).catch(angular.noop);};/**
   * @ngdoc function
   * @name refreshRows
   * @methodOf ui.grid.class:Grid
   * @description Refresh the rendered rows on screen?  Note: not functional at present
   * @returns {promise} promise that is resolved when render completes?
   *
   */Grid.prototype.refreshRows=function refreshRows(){var self=this;return self.processRowsProcessors(self.rows).then(function(renderableRows){self.setVisibleRows(renderableRows);self.redrawInPlace();self.refreshCanvas(true);}).catch(angular.noop);};/**
   * @ngdoc function
   * @name refreshCanvas
   * @methodOf ui.grid.class:Grid
   * @description Builds all styles and recalculates much of the grid sizing
   * @param {object} buildStyles optional parameter.  Use TBD
   * @returns {promise} promise that is resolved when the canvas
   * has been refreshed
   *
   */Grid.prototype.refreshCanvas=function(buildStyles){var self=this;// gridUtil.logDebug('refreshCanvas');
var p=$q.defer();// Get all the header heights
var containerHeadersToRecalc=[];for(var containerId in self.renderContainers){if(self.renderContainers.hasOwnProperty(containerId)){var container=self.renderContainers[containerId];// Skip containers that have no canvasWidth set yet
if(container.canvasWidth===null||isNaN(container.canvasWidth)){continue;}if(container.header||container.headerCanvas){container.explicitHeaderHeight=container.explicitHeaderHeight||null;container.explicitHeaderCanvasHeight=container.explicitHeaderCanvasHeight||null;containerHeadersToRecalc.push(container);}}}// Build the styles without the explicit header heights
if(buildStyles){self.buildStyles();}/*
     *
     * Here we loop through the headers, measuring each element as well as any header "canvas" it has within it.
     *
     * If any header is less than the largest header height, it will be resized to that so that we don't have headers
     * with different heights, which looks like a rendering problem
     *
     * We'll do the same thing with the header canvases, and give the header CELLS an explicit height if their canvas
     * is smaller than the largest canvas height. That was header cells without extra controls like filtering don't
     * appear shorter than other cells.
     *
     */if(containerHeadersToRecalc.length>0){// Putting in a timeout as it's not calculating after the grid element is rendered and filled out
$timeout(function(){// var oldHeaderHeight = self.grid.headerHeight;
// self.grid.headerHeight = gridUtil.outerElementHeight(self.header);
var rebuildStyles=false;// Get all the header heights
var maxHeaderHeight=0;var maxHeaderCanvasHeight=0;var i,container;var getHeight=function(oldVal,newVal){if(oldVal!==newVal){rebuildStyles=true;}return newVal;};for(i=0;i<containerHeadersToRecalc.length;i++){container=containerHeadersToRecalc[i];// Skip containers that have no canvasWidth set yet
if(container.canvasWidth===null||isNaN(container.canvasWidth)){continue;}if(container.header){var headerHeight=container.headerHeight=getHeight(container.headerHeight,gridUtil.outerElementHeight(container.header));// Get the "inner" header height, that is the height minus the top and bottom borders, if present. We'll use it to make sure all the headers have a consistent height
var topBorder=gridUtil.getBorderSize(container.header,'top');var bottomBorder=gridUtil.getBorderSize(container.header,'bottom');var innerHeaderHeight=parseInt(headerHeight-topBorder-bottomBorder,10);innerHeaderHeight=innerHeaderHeight<0?0:innerHeaderHeight;container.innerHeaderHeight=innerHeaderHeight;// If the header doesn't have an explicit height set, save the largest header height for use later
//   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
if(!container.explicitHeaderHeight&&innerHeaderHeight>maxHeaderHeight){maxHeaderHeight=innerHeaderHeight;}}if(container.headerCanvas){var headerCanvasHeight=container.headerCanvasHeight=getHeight(container.headerCanvasHeight,parseInt(gridUtil.outerElementHeight(container.headerCanvas),10));// If the header doesn't have an explicit canvas height, save the largest header canvas height for use later
//   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
if(!container.explicitHeaderCanvasHeight&&headerCanvasHeight>maxHeaderCanvasHeight){maxHeaderCanvasHeight=headerCanvasHeight;}}}// Go through all the headers
for(i=0;i<containerHeadersToRecalc.length;i++){container=containerHeadersToRecalc[i];/* If:
              1. We have a max header height
              2. This container has a header height defined
              3. And either this container has an explicit header height set, OR its header height is less than the max

              then:

              Give this container's header an explicit height so it will line up with the tallest header
          */if(maxHeaderHeight>0&&typeof container.headerHeight!=='undefined'&&container.headerHeight!==null&&(container.explicitHeaderHeight||container.headerHeight<maxHeaderHeight)){container.explicitHeaderHeight=getHeight(container.explicitHeaderHeight,maxHeaderHeight);}// Do the same as above except for the header canvas
if(maxHeaderCanvasHeight>0&&typeof container.headerCanvasHeight!=='undefined'&&container.headerCanvasHeight!==null&&(container.explicitHeaderCanvasHeight||container.headerCanvasHeight<maxHeaderCanvasHeight)){container.explicitHeaderCanvasHeight=getHeight(container.explicitHeaderCanvasHeight,maxHeaderCanvasHeight);}}// Rebuild styles if the header height has changed
//   The header height is used in body/viewport calculations and those are then used in other styles so we need it to be available
if(buildStyles&&rebuildStyles){self.buildStyles();}p.resolve();});}else{// Timeout still needs to be here to trigger digest after styles have been rebuilt
$timeout(function(){p.resolve();});}return p.promise;};function getPrevScrollValue(rowsAdded,prevScrollVal){return rowsAdded||prevScrollVal>0?prevScrollVal:null;}/**
   * @ngdoc function
   * @name redrawInPlace
   * @methodOf ui.grid.class:Grid
   * @description Redraw the rows and columns based on our current scroll position
   * @param {boolean} [rowsAdded] Optional to indicate rows are added and the scroll percentage must be recalculated
   *
   */Grid.prototype.redrawInPlace=function redrawInPlace(rowsAdded){// gridUtil.logDebug('redrawInPlace');
var self=this;for(var i in self.renderContainers){var container=self.renderContainers[i],prevScrollTop=getPrevScrollValue(rowsAdded,container.prevScrollTop),prevScrollLeft=getPrevScrollValue(rowsAdded,container.prevScrollLeft),prevScrolltopPercentage=rowsAdded||prevScrollTop>0?null:container.prevScrolltopPercentage;// gridUtil.logDebug('redrawing container', i);
container.adjustRows(prevScrollTop,prevScrolltopPercentage);container.adjustColumns(prevScrollLeft);}};/**
     * @ngdoc function
     * @name hasLeftContainerColumns
     * @methodOf ui.grid.class:Grid
     * @description returns true if leftContainer has columns
     */Grid.prototype.hasLeftContainerColumns=function(){return this.hasLeftContainer()&&this.renderContainers.left.renderedColumns.length>0;};/**
     * @ngdoc function
     * @name hasRightContainerColumns
     * @methodOf ui.grid.class:Grid
     * @description returns true if rightContainer has columns
     */Grid.prototype.hasRightContainerColumns=function(){return this.hasRightContainer()&&this.renderContainers.right.renderedColumns.length>0;};// Turn the scroll position into a percentage and make it an argument for a scroll event
function getScrollPercentage(scrollPixels,scrollLength){var percentage=scrollPixels/scrollLength;// if the percentage is greater than 1, set it to 1
return percentage<=1?percentage:1;}// Only returns the scroll Y position if the percentage is different from the previous
function getScrollY(scrollPixels,scrollLength,prevScrolltopPercentage){var scrollPercentage=getScrollPercentage(scrollPixels,scrollLength);if(scrollPercentage!==prevScrolltopPercentage){return{percentage:getScrollPercentage(scrollPixels,scrollLength)};}return undefined;}// Only returns the scroll X position if the percentage is different from the previous
function getScrollX(horizScrollPixels,horizScrollLength,prevScrollleftPercentage){var horizPercentage=horizScrollPixels/horizScrollLength;horizPercentage=horizPercentage>1?1:horizPercentage;if(horizPercentage!==prevScrollleftPercentage){return{percentage:horizPercentage};}return undefined;}/**
     * @ngdoc method
     * @methodOf  ui.grid.class:Grid
     * @name scrollToIfNecessary
     * @description Scrolls the grid to make a certain row and column combo visible,
     *   in the case that it is not completely visible on the screen already.
     * @param {GridRow} gridRow row to make visible
     * @param {GridColumn} gridCol column to make visible
     * @returns {promise} a promise that is resolved when scrolling is complete
     */Grid.prototype.scrollToIfNecessary=function(gridRow,gridCol){var self=this;var scrollEvent=new ScrollEvent(self,'uiGrid.scrollToIfNecessary');// Alias the visible row and column caches
var visRowCache=self.renderContainers.body.visibleRowCache;var visColCache=self.renderContainers.body.visibleColumnCache;/*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/ // The top boundary is the current Y scroll position
var topBound=self.renderContainers.body.prevScrollTop;// Don't the let top boundary be less than 0
topBound=topBound<0?0:topBound;// The left boundary is the current X scroll position
var leftBound=self.renderContainers.body.prevScrollLeft;// The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
//   Basically this is the viewport height added on to the scroll position
var bottomBound=self.renderContainers.body.prevScrollTop+self.gridHeight-self.renderContainers.body.headerHeight-self.footerHeight-self.scrollbarHeight;// If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
// if (self.horizontalScrollbarHeight) {
//   bottomBound = bottomBound - self.horizontalScrollbarHeight;
// }
// The right position is the current X scroll position minus the grid width
var rightBound=self.renderContainers.body.prevScrollLeft+Math.ceil(self.renderContainers.body.getViewportWidth());// If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
// if (self.verticalScrollbarWidth) {
//   rightBound = rightBound - self.verticalScrollbarWidth;
// }
// We were given a row to scroll to
if(gridRow!==null){// This is the index of the row we want to scroll to, within the list of rows that can be visible
var seekRowIndex=visRowCache.indexOf(gridRow);// Total vertical scroll length of the grid
var scrollLength=self.renderContainers.body.getCanvasHeight()-self.renderContainers.body.getViewportHeight();// Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
// if (self.horizontalScrollbarHeight && self.horizontalScrollbarHeight > 0) {
//   scrollLength = scrollLength + self.horizontalScrollbarHeight;
// }
// This is the minimum amount of pixels we need to scroll vertical in order to see this row.
var pixelsToSeeRow=seekRowIndex*self.options.rowHeight;// Don't let the pixels required to see the row be less than zero
pixelsToSeeRow=pixelsToSeeRow<0?0:pixelsToSeeRow;var scrollPixels;// If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
if(pixelsToSeeRow<Math.floor(topBound)){// Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
//   to get the full position we need
scrollPixels=self.renderContainers.body.prevScrollTop-(topBound-pixelsToSeeRow);// Since scrollIfNecessary is called multiple times when enableCellEditOnFocus is true we need to make sure the scrollbarWidth and
// footerHeight is accounted for to not cause a loop.
if(gridCol&&gridCol.colDef&&gridCol.colDef.enableCellEditOnFocus){scrollPixels=scrollPixels-self.footerHeight-self.scrollbarHeight;}scrollEvent.y=getScrollY(scrollPixels,scrollLength,self.renderContainers.body.prevScrolltopPercentage);}// Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
// add the height of one row since scrollPixels points to the top pixel of the row
else if(pixelsToSeeRow+self.options.rowHeight>Math.ceil(bottomBound)){// Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
// plus the height of one row since scrollPixels points to the top pixel of the row
// to get the full position we need
scrollPixels=pixelsToSeeRow+self.options.rowHeight-bottomBound+self.renderContainers.body.prevScrollTop;// Scroll to full position
scrollEvent.y=getScrollY(scrollPixels,scrollLength,self.renderContainers.body.prevScrolltopPercentage);}}// We were given a column to scroll to
if(gridCol!==null){// This is the index of the column we want to scroll to, within the list of columns that can be visible
var seekColumnIndex=visColCache.indexOf(gridCol);// Total horizontal scroll length of the grid
var horizScrollLength=self.renderContainers.body.getCanvasWidth()-self.renderContainers.body.getViewportWidth();// This is the minimum amount of pixels we need to scroll horizontal in order to see this column
var columnLeftEdge=0;for(var i=0;i<seekColumnIndex;i++){var col=visColCache[i];columnLeftEdge+=col.drawnWidth;}columnLeftEdge=columnLeftEdge<0?0:columnLeftEdge;var columnRightEdge=columnLeftEdge+gridCol.drawnWidth;// Don't let the pixels required to see the column be less than zero
columnRightEdge=columnRightEdge<0?0:columnRightEdge;var horizScrollPixels;// If the scroll position we need to see the column is LESS than the left boundary, i.e. obscured before the left of the self...
if(columnLeftEdge<leftBound){// Get the different between the left boundary and the required scroll position and subtract it from the current scroll position\
//   to get the full position we need
horizScrollPixels=self.renderContainers.body.prevScrollLeft-(leftBound-columnLeftEdge);// Turn the scroll position into a percentage and make it an argument for a scroll event
scrollEvent.x=getScrollX(horizScrollPixels,horizScrollLength,self.renderContainers.body.prevScrollleftPercentage);}// Otherwise if the scroll position we need to see the column is MORE than the right boundary, i.e. obscured after the right of the self...
else if(columnRightEdge>rightBound){// Get the different between the right boundary and the required scroll position and add it to the current scroll position
//   to get the full position we need
horizScrollPixels=columnRightEdge-rightBound+self.renderContainers.body.prevScrollLeft;// Turn the scroll position into a percentage and make it an argument for a scroll event
scrollEvent.x=getScrollX(horizScrollPixels,horizScrollLength,self.renderContainers.body.prevScrollleftPercentage);}}var deferred=$q.defer();// If we need to scroll on either the x or y axes, fire a scroll event
if(scrollEvent.y||scrollEvent.x){scrollEvent.withDelay=false;self.scrollContainers('',scrollEvent);var dereg=self.api.core.on.scrollEnd(null,function(){deferred.resolve(scrollEvent);dereg();});}else{deferred.resolve();}return deferred.promise;};/**
     * @ngdoc method
     * @methodOf ui.grid.class:Grid
     * @name scrollTo
     * @description Scroll the grid such that the specified
     * row and column is in view
     * @param {object} rowEntity gridOptions.data[] array instance to make visible
     * @param {object} colDef to make visible
     * @returns {promise} a promise that is resolved after any scrolling is finished
     */Grid.prototype.scrollTo=function(rowEntity,colDef){var gridRow=null,gridCol=null;if(rowEntity!==null&&typeof rowEntity!=='undefined'){gridRow=this.getRow(rowEntity);}if(colDef!==null&&typeof colDef!=='undefined'){gridCol=this.getColumn(colDef.name?colDef.name:colDef.field);}return this.scrollToIfNecessary(gridRow,gridCol);};/**
   * @ngdoc function
   * @name clearAllFilters
   * @methodOf ui.grid.class:Grid
   * @description Clears all filters and optionally refreshes the visible rows.
   * @param {object} refreshRows Defaults to true.
   * @param {object} clearConditions Defaults to false.
   * @param {object} clearFlags Defaults to false.
   * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
   */Grid.prototype.clearAllFilters=function clearAllFilters(refreshRows,clearConditions,clearFlags){// Default `refreshRows` to true because it will be the most commonly desired behaviour.
if(refreshRows===undefined){refreshRows=true;}if(clearConditions===undefined){clearConditions=false;}if(clearFlags===undefined){clearFlags=false;}this.columns.forEach(function(column){column.filters.forEach(function(filter){filter.term=undefined;if(clearConditions){filter.condition=undefined;}if(clearFlags){filter.flags=undefined;}});});if(refreshRows){return this.refreshRows();}};// Blatantly stolen from Angular as it isn't exposed (yet? 2.0?)
function RowHashMap(){}RowHashMap.prototype={/**
     * Store key value pair
     * @param key key to store can be any type
     * @param value value to store can be any type
     */put:function(key,value){this[this.grid.options.rowIdentity(key)]=value;},/**
     * @param key
     * @returns {Object} the value for the key
     */get:function(key){return this[this.grid.options.rowIdentity(key)];},/**
     * Remove the key/value pair
     * @param key
     */remove:function(key){var value=this[key=this.grid.options.rowIdentity(key)];delete this[key];return value;}};return Grid;}]);})();(function(){angular.module('ui.grid').factory('GridApi',['$q','$rootScope','gridUtil','uiGridConstants','GridRow',function($q,$rootScope,gridUtil,uiGridConstants,GridRow){/**
         * @ngdoc function
         * @name ui.grid.class:GridApi
         * @description GridApi provides the ability to register public methods events inside the grid and allow
         * for other components to use the api via featureName.raise.methodName and featureName.on.eventName(function(args) {}.
         * <br/>
         * To listen to events, you must add a callback to gridOptions.onRegisterApi
         * <pre>
         *   $scope.gridOptions.onRegisterApi = function(gridApi) {
         *      gridApi.cellNav.on.navigate($scope,function(newRowCol, oldRowCol) {
         *          $log.log('navigation event');
         *      });
         *   };
         * </pre>
         * @param {object} grid grid that owns api
         */var GridApi=function GridApi(grid){this.grid=grid;this.listeners=[];/**
           * @ngdoc function
           * @name renderingComplete
           * @methodOf  ui.grid.api:PublicApi
           * @description Rendering is complete, called at the same
           * time as `onRegisterApi`, but provides a way to obtain
           * that same event within features without stopping end
           * users from getting at the onRegisterApi method.
           *
           * Included in gridApi so that it's always there - otherwise
           * there is still a timing problem with when a feature can
           * call this.
           *
           * @param {GridApi} gridApi the grid api, as normally
           * returned in the onRegisterApi method
           *
           * @example
           * <pre>
           *      gridApi.core.on.renderingComplete( grid );
           * </pre>
           */this.registerEvent('core','renderingComplete');/**
           * @ngdoc event
           * @name filterChanged
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised after the filter is changed.  The nature
           * of the watch expression doesn't allow notification of what changed,
           * so the receiver of this event will need to re-extract the filter
           * conditions from the columns.
           *
           */this.registerEvent('core','filterChanged');/**
           * @ngdoc function
           * @name setRowInvisible
           * @methodOf  ui.grid.api:PublicApi
           * @description Sets an override on the row to make it always invisible,
           * which will override any filtering or other visibility calculations.
           * If the row is currently visible then sets it to invisible and calls
           * both grid refresh and emits the rowsVisibleChanged event
           * @param {GridRow} row the row we want to make invisible
           */this.registerMethod('core','setRowInvisible',GridRow.prototype.setRowInvisible);/**
           * @ngdoc function
           * @name clearRowInvisible
           * @methodOf  ui.grid.api:PublicApi
           * @description Clears any override on visibility for the row so that it returns to
           * using normal filtering and other visibility calculations.
           * If the row is currently invisible then sets it to visible and calls
           * both grid refresh and emits the rowsVisibleChanged event
           * TODO: if a filter is active then we can't just set it to visible?
           * @param {GridRow} row the row we want to make visible
           */this.registerMethod('core','clearRowInvisible',GridRow.prototype.clearRowInvisible);/**
           * @ngdoc function
           * @name getVisibleRows
           * @methodOf  ui.grid.api:PublicApi
           * @description Returns all visible rows
           * @param {Grid} grid the grid you want to get visible rows from
           * @returns {array} an array of gridRow
           */this.registerMethod('core','getVisibleRows',this.grid.getVisibleRows);/**
           * @ngdoc event
           * @name rowsVisibleChanged
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised after the rows that are visible
           * change.  The filtering is zero-based, so it isn't possible
           * to say which rows changed (unlike in the selection feature).
           * We can plausibly know which row was changed when setRowInvisible
           * is called, but in that situation the user already knows which row
           * they changed.  When a filter runs we don't know what changed,
           * and that is the one that would have been useful.
           *
           */this.registerEvent('core','rowsVisibleChanged');/**
           * @ngdoc event
           * @name rowsRendered
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised after the cache of visible rows is changed.
           */this.registerEvent('core','rowsRendered');/**
           * @ngdoc event
           * @name scrollBegin
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised when scroll begins.  Is throttled, so won't be raised too frequently
           */this.registerEvent('core','scrollBegin');/**
           * @ngdoc event
           * @name scrollEnd
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised when scroll has finished.  Is throttled, so won't be raised too frequently
           */this.registerEvent('core','scrollEnd');/**
           * @ngdoc event
           * @name canvasHeightChanged
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised when the canvas height has changed
           * <br/>
           * arguments: oldHeight, newHeight
           */this.registerEvent('core','canvasHeightChanged');/**
           * @ngdoc event
           * @name gridDimensionChanged
           * @eventOf  ui.grid.api:PublicApi
           * @description  is raised when the grid dimensions have changed (when autoResize is on)
           * <br/>
           * arguments: oldGridHeight, oldGridWidth, newGridHeight, newGridWidth
           */this.registerEvent('core','gridDimensionChanged');};/**
         * @ngdoc function
         * @name ui.grid.class:suppressEvents
         * @methodOf ui.grid.class:GridApi
         * @description Used to execute a function while disabling the specified event listeners.
         * Disables the listenerFunctions, executes the callbackFn, and then enables
         * the listenerFunctions again
         * @param {object} listenerFuncs listenerFunc or array of listenerFuncs to suppress. These must be the same
         * functions that were used in the .on.eventName method
         * @param {object} callBackFn function to execute
         * @example
         * <pre>
         *    var navigate = function (newRowCol, oldRowCol) {
         *       //do something on navigate
         *    }
         *
         *    gridApi.cellNav.on.navigate(scope,navigate);
         *
         *
         *    //call the scrollTo event and suppress our navigate listener
         *    //scrollTo will still raise the event for other listeners
         *    gridApi.suppressEvents(navigate, function() {
         *       gridApi.cellNav.scrollTo(aRow, aCol);
         *    });
         *
         * </pre>
         */GridApi.prototype.suppressEvents=function(listenerFuncs,callBackFn){var self=this,listeners=angular.isArray(listenerFuncs)?listenerFuncs:[listenerFuncs];// find all registered listeners
var foundListeners=self.listeners.filter(function(listener){return listeners.some(function(l){return listener.handler===l;});});// deregister all the listeners
foundListeners.forEach(function(l){l.dereg();});callBackFn();// reregister all the listeners
foundListeners.forEach(function(l){l.dereg=registerEventWithAngular(l.eventId,l.handler,self.grid,l._this);});};/**
         * @ngdoc function
         * @name registerEvent
         * @methodOf ui.grid.class:GridApi
         * @description Registers a new event for the given feature.  The event will get a
         * .raise and .on prepended to it
         * <br>
         * .raise.eventName() - takes no arguments
         * <br/>
         * <br/>
         * .on.eventName(scope, callBackFn, _this)
         * <br/>
         * scope - a scope reference to add a deregister call to the scopes .$on('destroy').  Scope is optional and can be a null value,
         * but in this case you must deregister it yourself via the returned deregister function
         * <br/>
         * callBackFn - The function to call
         * <br/>
         * _this - optional this context variable for callbackFn. If omitted, grid.api will be used for the context
         * <br/>
         * .on.eventName returns a dereg funtion that will remove the listener.  It's not necessary to use it as the listener
         * will be removed when the scope is destroyed.
         * @param {string} featureName name of the feature that raises the event
         * @param {string} eventName  name of the event
         */GridApi.prototype.registerEvent=function(featureName,eventName){var self=this;if(!self[featureName]){self[featureName]={};}var feature=self[featureName];if(!feature.on){feature.on={};feature.raise={};}var eventId=self.grid.id+featureName+eventName;// gridUtil.logDebug('Creating raise event method ' + featureName + '.raise.' + eventName);
feature.raise[eventName]=function(){$rootScope.$emit.apply($rootScope,[eventId].concat(Array.prototype.slice.call(arguments)));};// gridUtil.logDebug('Creating on event method ' + featureName + '.on.' + eventName);
feature.on[eventName]=function(scope,handler,_this){if(scope!==null&&typeof scope.$on==='undefined'){gridUtil.logError('asked to listen on '+featureName+'.on.'+eventName+' but scope wasn\'t passed in the input parameters.  It is legitimate to pass null, but you\'ve passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering');return;}var deregAngularOn=registerEventWithAngular(eventId,handler,self.grid,_this);// track our listener so we can turn off and on
var listener={handler:handler,dereg:deregAngularOn,eventId:eventId,scope:scope,_this:_this};self.listeners.push(listener);var removeListener=function(){listener.dereg();var index=self.listeners.indexOf(listener);self.listeners.splice(index,1);};// destroy tracking when scope is destroyed
if(scope){scope.$on('$destroy',function(){removeListener();});}return removeListener;};};function registerEventWithAngular(eventId,handler,grid,_this){return $rootScope.$on(eventId,function(event){var args=Array.prototype.slice.call(arguments);args.splice(0,1);// remove evt argument
handler.apply(_this?_this:grid.api,args);});}/**
         * @ngdoc function
         * @name registerEventsFromObject
         * @methodOf ui.grid.class:GridApi
         * @description Registers features and events from a simple objectMap.
         * eventObjectMap must be in this format (multiple features allowed)
         * <pre>
         * {featureName:
         *        {
         *          eventNameOne:function(args) {},
         *          eventNameTwo:function(args) {}
         *        }
         *  }
         * </pre>
         * @param {object} eventObjectMap map of feature/event names
         */GridApi.prototype.registerEventsFromObject=function(eventObjectMap){var self=this,features=[];angular.forEach(eventObjectMap,function(featProp,featPropName){var feature={name:featPropName,events:[]};angular.forEach(featProp,function(prop,propName){feature.events.push(propName);});features.push(feature);});features.forEach(function(feature){feature.events.forEach(function(event){self.registerEvent(feature.name,event);});});};/**
         * @ngdoc function
         * @name registerMethod
         * @methodOf ui.grid.class:GridApi
         * @description Registers a new event for the given feature
         * @param {string} featureName name of the feature
         * @param {string} methodName  name of the method
         * @param {object} callBackFn function to execute
         * @param {object} _this binds callBackFn 'this' to _this.  Defaults to gridApi.grid
         */GridApi.prototype.registerMethod=function(featureName,methodName,callBackFn,_this){if(!this[featureName]){this[featureName]={};}var feature=this[featureName];feature[methodName]=gridUtil.createBoundedWrapper(_this||this.grid,callBackFn);};/**
         * @ngdoc function
         * @name registerMethodsFromObject
         * @methodOf ui.grid.class:GridApi
         * @description Registers features and methods from a simple objectMap.
         * eventObjectMap must be in this format (multiple features allowed)
         * <br>
         * {featureName:
         *        {
         *          methodNameOne:function(args) {},
         *          methodNameTwo:function(args) {}
         *        }
         * @param {object} methodMap map of feature/event names
         * @param {object} _this binds this to _this for all functions.  Defaults to gridApi.grid
         */GridApi.prototype.registerMethodsFromObject=function(methodMap,_this){var self=this;var features=[];angular.forEach(methodMap,function(featProp,featPropName){var feature={name:featPropName,methods:[]};angular.forEach(featProp,function(prop,propName){feature.methods.push({name:propName,fn:prop});});features.push(feature);});features.forEach(function(feature){feature.methods.forEach(function(method){self.registerMethod(feature.name,method.name,method.fn,_this);});});};return GridApi;}]);})();(function(){angular.module('ui.grid').factory('GridColumn',['gridUtil','uiGridConstants','i18nService',function(gridUtil,uiGridConstants,i18nService){/**
   * ******************************************************************************************
   * PaulL1: Ugly hack here in documentation.  These properties are clearly properties of GridColumn,
   * and need to be noted as such for those extending and building ui-grid itself.
   * However, from an end-developer perspective, they interact with all these through columnDefs,
   * and they really need to be documented there.  I feel like they're relatively static, and
   * I can't find an elegant way for ngDoc to reference to both....so I've duplicated each
   * comment block.  Ugh.
   *
   */ /**
   * @ngdoc property
   * @name name
   * @propertyOf ui.grid.class:GridColumn
   * @description (mandatory) Each column should have a name, although for backward
   * compatibility with 2.x name can be omitted if field is present.
   *
   * Important - This must be unique to each column on a web page since it can
   * be used as a key for retrieving information such as custom sort algorithms.
   *
   */ /**
   * @ngdoc property
   * @name name
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description (mandatory) Each column should have a name, although for backward
   * compatibility with 2.x name can be omitted if field is present.
   *
   * Important - This must be unique to each column on a web page since it can
   * be used as a key for retrieving information such as custom sort algorithms.
   *
   */ /**
   * @ngdoc property
   * @name displayName
   * @propertyOf ui.grid.class:GridColumn
   * @description Column name that will be shown in the header. If displayName is not
   * provided then one is generated using the name.
   *
   */ /**
   * @ngdoc property
   * @name displayName
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description Column name that will be shown in the header. If displayName is not
   * provided then one is generated using the name.
   *
   */ /**
   * @ngdoc property
   * @name field
   * @propertyOf ui.grid.class:GridColumn
   * @description field must be provided if you wish to bind to a
   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.
   * See the angular docs on binding expressions.
   *
   */ /**
   * @ngdoc property
   * @name field
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description field must be provided if you wish to bind to a
   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.    * See the angular docs on binding expressions.    *
   */ /**
   * @ngdoc property
   * @name filter
   * @propertyOf ui.grid.class:GridColumn
   * @description Filter on this column.
   *
   * Available built-in conditions and types are listed under {@link jui.grid.service:uiGridConstants#properties_filter uiGridOptions.filter}
   * @example
   * <pre>{ term: 'text', condition: uiGridConstants.filter.STARTS_WITH, placeholder: 'type to filter...', ariaLabel: 'Filter for text', flags: { caseSensitive: false }, type: uiGridConstants.filter.SELECT, [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ] }</pre>
   *
   */ /**
   * @ngdoc property
   * @name extraStyle
   * @propertyOf ui.grid.class:GridColumn
   * @description additional on this column.
   * @example
   * <pre>{extraStyle: {display: 'table-cell'}}</pre>
   *
   */ /**
   * @ngdoc object
   * @name ui.grid.class:GridColumn
   * @description Represents the viewModel for each column.  Any state or methods needed for a Grid Column
   * are defined on this prototype
   * @param {ColumnDef} colDef the column def to associate with this column
   * @param {number} uid the unique and immutable uid we'd like to allocate to this column
   * @param {Grid} grid the grid we'd like to create this column in
   */function GridColumn(colDef,uid,grid){var self=this;self.grid=grid;self.uid=uid;self.updateColumnDef(colDef,true);self.aggregationValue=undefined;// The footer cell registers to listen for the rowsRendered event, and calls this.  Needed to be
// in something with a scope so that the dereg would get called
self.updateAggregationValue=function(){// gridUtil.logDebug('getAggregationValue for Column ' + self.colDef.name);
/**
       * @ngdoc property
       * @name aggregationType
       * @propertyOf ui.grid.class:GridOptions.columnDef
       * @description The aggregation that you'd like to show in the columnFooter for this
       * column.  Valid values are in
       * {@link ui.grid.service:uiGridConstants#properties_aggregationTypes uiGridConstants.aggregationTypes},
       * and currently include `uiGridConstants.aggregationTypes.count`,
       * `uiGridConstants.aggregationTypes.sum`, `uiGridConstants.aggregationTypes.avg`, `uiGridConstants.aggregationTypes.min`,
       * `uiGridConstants.aggregationTypes.max`.
       *
       * You can also provide a function as the aggregation type, in this case your function needs to accept the full
       * set of visible rows, and return a value that should be shown
       */if(!self.aggregationType){self.aggregationValue=undefined;return;}var result=0;var visibleRows=self.grid.getVisibleRows();var cellValues=function(){var values=[];visibleRows.forEach(function(row){var cellValue=self.grid.getCellValue(row,self);var cellNumber=Number(cellValue);if(!isNaN(cellNumber)){values.push(cellNumber);}});return values;};if(angular.isFunction(self.aggregationType)){self.aggregationValue=self.aggregationType(visibleRows,self);}else if(self.aggregationType===uiGridConstants.aggregationTypes.count){self.aggregationValue=self.grid.getVisibleRowCount();}else if(self.aggregationType===uiGridConstants.aggregationTypes.sum){cellValues().forEach(function(value){result+=value;});self.aggregationValue=result;}else if(self.aggregationType===uiGridConstants.aggregationTypes.avg){cellValues().forEach(function(value){result+=value;});result=result/cellValues().length;self.aggregationValue=result;}else if(self.aggregationType===uiGridConstants.aggregationTypes.min){self.aggregationValue=Math.min.apply(null,cellValues());}else if(self.aggregationType===uiGridConstants.aggregationTypes.max){self.aggregationValue=Math.max.apply(null,cellValues());}else{self.aggregationValue='\u00A0';}};//     var throttledUpdateAggregationValue = gridUtil.throttle(updateAggregationValue, self.grid.options.aggregationCalcThrottle, { trailing: true, context: self.name });
/**
     * @ngdoc function
     * @name getAggregationValue
     * @methodOf ui.grid.class:GridColumn
     * @description gets the aggregation value based on the aggregation type for this column.
     * Debounced using scrollDebounce option setting
     */this.getAggregationValue=function(){//      if (!self.grid.isScrollingVertically && !self.grid.isScrollingHorizontally) {
//        throttledUpdateAggregationValue();
//      }
return self.aggregationValue;};}/**
   * @ngdoc function
   * @name hideColumn
   * @methodOf ui.grid.class:GridColumn
   * @description Hides the column by setting colDef.visible = false
   */GridColumn.prototype.hideColumn=function(){this.colDef.visible=false;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:GridColumn
   * @name setPropertyOrDefault
   * @description Sets a property on the column using the passed in columnDef, and
   * setting the defaultValue if the value cannot be found on the colDef
   * @param {GridColumn} colDef the column def to look in for the property value
   * @param {string} propName the property name we'd like to set
   * @param {object} defaultValue the value to use if the colDef doesn't provide the setting
   */GridColumn.prototype.setPropertyOrDefault=function(colDef,propName,defaultValue){var self=this;// Use the column definition filter if we were passed it
if(typeof colDef[propName]!=='undefined'&&colDef[propName]){self[propName]=colDef[propName];}// Otherwise use our own if it's set
else if(typeof self[propName]!=='undefined'){self[propName]=self[propName];}// Default to empty object for the filter
else{self[propName]=defaultValue?defaultValue:{};}};/**
   * @ngdoc property
   * @name width
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description sets the column width.  Can be either
   * a number or a percentage, or an * for auto.
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 100},
   *                                          { field: 'field2', width: '20%'},
   *                                          { field: 'field3', width: '*' }]; </pre>
   *
   */ /**
   * @ngdoc property
   * @name allowFloatWidth
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description Allows float number in column width calculation
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 50.5, allowFloatWidth: true},
   *                                          { field: 'field2', width: '20%', allowFloatWidth: true},
   *                                          { field: 'field3', width: '*', allowFloatWidth: true }]; </pre>
   *
   */ /**
   * @ngdoc property
   * @name minWidth
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description Sets the minimum column width.  Should be a number.
   * Defaults to gridOptions.minimumColumnSize if minWidth is not provided.
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', minWidth: 100}]; </pre>
   *
   */ /**
   * @ngdoc property
   * @name maxWidth
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description sets the maximum column width.  Should be a number.
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', maxWidth: 100}]; </pre>
   *
   */ /**
   * @ngdoc property
   * @name visible
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description sets whether or not the column is visible
   * </br>Default is true
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [
   *     { field: 'field1', visible: true},
   *     { field: 'field2', visible: false }
   *   ]; </pre>
   *
   */ /**
  * @ngdoc property
  * @name sort
  * @propertyOf ui.grid.class:GridOptions.columnDef
  * @description An object of sort information, attributes are:
  *
  * - direction: values are {@link ui.grid.service:uiGridConstants#properties_ASC uiGridConstants.ASC}
  *  or {@link ui.grid.service:uiGridConstants#properties_DESC uiGridConstants.DESC}
  * - ignoreSort: if set to true this sort is ignored (used by tree to manipulate the sort functionality)
  * - priority: says what order to sort the columns in (lower priority gets sorted first). Starts from 0.
  * @example
  * <pre>
  *   $scope.gridOptions.columnDefs = [{
  *     field: 'field1',
  *     sort: {
  *       direction: uiGridConstants.ASC,
  *       ignoreSort: true,
  *       priority: 0
  *      }
  *   }];
  * </pre>
  */ /**
   * @ngdoc property
   * @name sortingAlgorithm
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description Algorithm to use for sorting this column. Takes 'a' and 'b' parameters
   * like any normal sorting function with additional 'rowA', 'rowB', and 'direction' parameters
   * that are the row objects and the current direction of the sort respectively.
   *
   */ /**
    * @ngdoc property
    * @name defaultSort
    * @propertyOf ui.grid.class:GridOptions.columnDef
    * @description An object of sort information, provides a hidden default ordering of the data
    * when no user sorts are applied, or when a user-provided sort deems two rows to be equal.
    *
    * May be combined with a regular {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}
    * to explicitly sort by that column by default.
    *
    * Shares the same object format as {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}.
    *
    * Note that a defaultSort can never take priority over an explicit sort.
    * @example
    * <pre>
    *   $scope.gridOptions.columnDefs = [{
    *     field: 'field1',
    *     defaultSort: {
    *       direction: uiGridConstants.ASC,
    *       priority: 0
    *      }
    *   }];
    * </pre>
    */ /**
   * @ngdoc array
   * @name filters
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description Specify multiple filter fields.
   * @example
   * <pre>$scope.gridOptions.columnDefs = [
   *   {
   *     field: 'field1', filters: [
   *       {
   *         term: 'aa',
   *         condition: uiGridConstants.filter.STARTS_WITH,
   *         placeholder: 'starts with...',
   *         ariaLabel: 'Filter for field1',
   *         flags: { caseSensitive: false },
   *         type: uiGridConstants.filter.SELECT,
   *         selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
   *       },
   *       {
   *         condition: uiGridConstants.filter.ENDS_WITH,
   *         placeholder: 'ends with...'
   *       }
   *     ]
   *   }
   * ]; </pre>
   *
   *
   */ /**
   * @ngdoc array
   * @name filters
   * @propertyOf ui.grid.class:GridColumn
   * @description Filters for this column. Includes 'term' property bound to filter input elements.
   * @example
   * <pre>[
   *   {
   *     term: 'foo', // ngModel for <input>
   *     condition: uiGridConstants.filter.STARTS_WITH,
   *     placeholder: 'starts with...',
   *     ariaLabel: 'Filter for foo',
   *     flags: { caseSensitive: false },
   *     type: uiGridConstants.filter.SELECT,
   *     selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
   *   },
   *   {
   *     term: 'baz',
   *     condition: uiGridConstants.filter.ENDS_WITH,
   *     placeholder: 'ends with...'
   *   }
   * ] </pre>
   *
   *
   */ /**
   * @ngdoc array
   * @name menuItems
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description used to add menu items to a column.  Refer to the tutorial on this
   * functionality.  A number of settings are supported:
   *
   * - title: controls the title that is displayed in the menu
   * - icon: the icon shown alongside that title
   * - action: the method to call when the menu is clicked
   * - shown: a function to evaluate to determine whether or not to show the item
   * - active: a function to evaluate to determine whether or not the item is currently selected
   * - context: context to pass to the action function, available in this.context in your handler
   * - leaveOpen: if set to true, the menu should stay open after the action, defaults to false
   * @example
   * <pre>  $scope.gridOptions.columnDefs = [
   *   { field: 'field1', menuItems: [
   *     {
   *       title: 'Outer Scope Alert',
   *       icon: 'ui-grid-icon-info-circled',
   *       action: function($event) {
   *         this.context.blargh(); // $scope.blargh() would work too, this is just an example
   *       },
   *       shown: function() { return true; },
   *       active: function() { return true; },
   *       context: $scope
   *     },
   *     {
   *       title: 'Grid ID',
   *       action: function() {
   *         alert('Grid ID: ' + this.grid.id);
   *       }
   *     }
   *   ] }]; </pre>
   *
   */ // Use colDef.displayName as long as it's not undefined, otherwise default to the field name
function getDisplayName(colDef){return colDef.displayName===undefined?gridUtil.readableColumnName(colDef.name):colDef.displayName;}/**
   * @ngdoc method
   * @methodOf ui.grid.class:GridColumn
   * @name updateColumnDef
   * @description Moves settings from the columnDef down onto the column,
   * and sets properties as appropriate
   * @param {GridColumn} colDef the column def to look in for the property value
   * @param {boolean} isNew whether the column is being newly created, if not
   * we're updating an existing column, and some items such as the sort shouldn't
   * be copied down
   */GridColumn.prototype.updateColumnDef=function(colDef,isNew){var self=this;self.colDef=colDef;if(colDef.name===undefined){throw new Error('colDef.name is required for column at index '+self.grid.options.columnDefs.indexOf(colDef));}self.displayName=getDisplayName(colDef);if(!angular.isNumber(self.width)||!self.hasCustomWidth||colDef.allowCustomWidthOverride){var colDefWidth=colDef.width;var parseErrorMsg="Cannot parse column width '"+colDefWidth+"' for column named '"+colDef.name+"'";self.hasCustomWidth=false;if(!angular.isString(colDefWidth)&&!angular.isNumber(colDefWidth)){self.width='*';}else if(angular.isString(colDefWidth)){// See if it ends with a percent
if(gridUtil.endsWith(colDefWidth,'%')){// If so we should be able to parse the non-percent-sign part to a number
var percentStr=colDefWidth.replace(/%/g,'');var percent=parseInt(percentStr,10);if(isNaN(percent)){throw new Error(parseErrorMsg);}self.width=colDefWidth;}// And see if it's a number string
else if(colDefWidth.match(/^(\d+)$/)){self.width=parseInt(colDefWidth.match(/^(\d+)$/)[1],10);}// Otherwise it should be a string of asterisks
else if(colDefWidth.match(/^\*+$/)){self.width=colDefWidth;}// No idea, throw an Error
else{throw new Error(parseErrorMsg);}}// Is a number, use it as the width
else{self.width=colDefWidth;}}function isValidWidthValue(value){return angular.isString(value)||angular.isNumber(value);}['minWidth','maxWidth'].forEach(function(name){var minOrMaxWidth=colDef[name];var parseErrorMsg="Cannot parse column "+name+" '"+minOrMaxWidth+"' for column named '"+colDef.name+"'";// default minWidth to the minimumColumnSize
if(name==='minWidth'&&!isValidWidthValue(minOrMaxWidth)&&angular.isDefined(self.grid.options.minimumColumnSize)){minOrMaxWidth=self.grid.options.minimumColumnSize;}if(!isValidWidthValue(minOrMaxWidth)){// Sets default minWidth and maxWidth values
self[name]=name==='minWidth'?30:9000;}else if(angular.isString(minOrMaxWidth)){if(minOrMaxWidth.match(/^(\d+)$/)){self[name]=parseInt(minOrMaxWidth.match(/^(\d+)$/)[1],10);}else{throw new Error(parseErrorMsg);}}else{self[name]=minOrMaxWidth;}});// use field if it is defined; name if it is not
self.field=colDef.field===undefined?colDef.name:colDef.field;if(typeof self.field!=='string'){gridUtil.logError('Field is not a string, this is likely to break the code, Field is: '+self.field);}self.name=colDef.name;self.displayName=getDisplayName(colDef);// self.originalIndex = index;
self.aggregationType=angular.isDefined(colDef.aggregationType)?colDef.aggregationType:null;self.footerCellTemplate=angular.isDefined(colDef.footerCellTemplate)?colDef.footerCellTemplate:null;/**
     * @ngdoc property
     * @name cellTooltip
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description Whether or not to show a tooltip when a user hovers over the cell.
     * If set to false, no tooltip.  If true, the cell value is shown in the tooltip (useful
     * if you have long values in your cells), if a function then that function is called
     * passing in the row and the col `cellTooltip( row, col )`, and the return value is shown in the tooltip,
     * if it is a static string then displays that static string.
     *
     * Defaults to false
     *
     */if(typeof colDef.cellTooltip==='undefined'||colDef.cellTooltip===false){self.cellTooltip=false;}else if(colDef.cellTooltip===true){self.cellTooltip=function(row,col){return self.grid.getCellValue(row,col);};}else if(typeof colDef.cellTooltip==='function'){self.cellTooltip=colDef.cellTooltip;}else{self.cellTooltip=function(row,col){return col.colDef.cellTooltip;};}/**
     * @ngdoc property
     * @name headerTooltip
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description Whether or not to show a tooltip when a user hovers over the header cell.
     * If set to false, no tooltip.  If true, the displayName is shown in the tooltip (useful
     * if you have long values in your headers), if a function then that function is called
     * passing in the row and the col `headerTooltip( col )`, and the return value is shown in the tooltip,
     * if a static string then shows that static string.
     *
     * Defaults to false
     *
     */if(typeof colDef.headerTooltip==='undefined'||colDef.headerTooltip===false){self.headerTooltip=false;}else if(colDef.headerTooltip===true){self.headerTooltip=function(col){return col.displayName;};}else if(typeof colDef.headerTooltip==='function'){self.headerTooltip=colDef.headerTooltip;}else{self.headerTooltip=function(col){return col.colDef.headerTooltip;};}/**
     * @ngdoc property
     * @name footerCellClass
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description footerCellClass can be a string specifying the class to append to a cell
     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
     *
     */self.footerCellClass=colDef.footerCellClass;/**
     * @ngdoc property
     * @name cellClass
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description cellClass can be a string specifying the class to append to a cell
     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
     *
     */self.cellClass=colDef.cellClass;/**
     * @ngdoc property
     * @name headerCellClass
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description headerCellClass can be a string specifying the class to append to a cell
     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
     *
     */self.headerCellClass=colDef.headerCellClass;/**
     * @ngdoc property
     * @name cellFilter
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description cellFilter is a filter to apply to the content of each cell
     * @example
     * <pre>
     *   gridOptions.columnDefs[0].cellFilter = 'date'
     *
     */self.cellFilter=colDef.cellFilter?colDef.cellFilter:"";/**
     * @ngdoc boolean
     * @name sortCellFiltered
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
     * sorting the data. Note that when using this option uiGrid will assume that the displayed value is
     * a string, and use the {@link ui.grid.class:RowSorter#sortAlpha sortAlpha} `sortFn`. It is possible
     * to return a non-string value from an angularjs filter, in which case you should define a {@link ui.grid.class:GridOptions.columnDef#sortingAlgorithm sortingAlgorithm}
     * for the column which hanldes the returned type. You may specify one of the `sortingAlgorithms`
     * found in the {@link ui.grid.RowSorter rowSorter} service.
     */self.sortCellFiltered=colDef.sortCellFiltered?true:false;/**
     * @ngdoc boolean
     * @name filterCellFiltered
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
     * applying "search" `filters`.
     */self.filterCellFiltered=colDef.filterCellFiltered?true:false;/**
     * @ngdoc property
     * @name headerCellFilter
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description headerCellFilter is a filter to apply to the content of the column header
     * @example
     * <pre>
     *   gridOptions.columnDefs[0].headerCellFilter = 'translate'
     *
     */self.headerCellFilter=colDef.headerCellFilter?colDef.headerCellFilter:"";/**
     * @ngdoc property
     * @name footerCellFilter
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description footerCellFilter is a filter to apply to the content of the column footer
     * @example
     * <pre>
     *   gridOptions.columnDefs[0].footerCellFilter = 'date'
     *
     */self.footerCellFilter=colDef.footerCellFilter?colDef.footerCellFilter:"";self.visible=gridUtil.isNullOrUndefined(colDef.visible)||colDef.visible;self.headerClass=colDef.headerClass;// self.cursor = self.sortable ? 'pointer' : 'default';
// Turn on sorting by default
self.enableSorting=typeof colDef.enableSorting!=='undefined'?colDef.enableSorting:self.grid.options.enableSorting;self.sortingAlgorithm=colDef.sortingAlgorithm;/**
     * @ngdoc property
     * @name sortDirectionCycle
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) An array of {@link ui.grid.service:uiGridConstants#properties_ASC sort directions},
     * specifying the order that they should cycle through as the user repeatedly clicks on the column heading.
     * The default is `[null, uiGridConstants.ASC, uiGridConstants.DESC]`. Null
     * refers to the unsorted state. This does not affect the initial sort
     * direction; use the {@link ui.grid.class:GridOptions.columnDef#sort sort}
     * property for that. If
     * {@link ui.grid.class:GridOptions.columnDef#suppressRemoveSort suppressRemoveSort}
     * is also set, the unsorted state will be skipped even if it is listed here.
     * Each direction may not appear in the list more than once (e.g. `[ASC,
     * DESC, DESC]` is not allowed), and the list may not be empty.
     */self.sortDirectionCycle=typeof colDef.sortDirectionCycle!=='undefined'?colDef.sortDirectionCycle:[null,uiGridConstants.ASC,uiGridConstants.DESC];/**
     * @ngdoc boolean
     * @name suppressRemoveSort
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description (optional) False by default. When enabled, this setting hides the removeSort option
     * in the menu, and prevents users from manually removing the sort
     */if(typeof self.suppressRemoveSort==='undefined'){self.suppressRemoveSort=typeof colDef.suppressRemoveSort!=='undefined'?colDef.suppressRemoveSort:false;}/**
     * @ngdoc property
     * @name enableFiltering
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description turn off filtering for an individual column, where
     * you've turned on filtering for the overall grid
     * @example
     * <pre>
     *   gridOptions.columnDefs[0].enableFiltering = false;
     *
     */ // Turn on filtering by default (it's disabled by default at the Grid level)
self.enableFiltering=typeof colDef.enableFiltering!=='undefined'?colDef.enableFiltering:true;// Place the filter in the header cell by default
self.filterContainer=typeof colDef.filterContainer!=='undefined'?colDef.filterContainer:self.grid.options.filterContainer;// self.menuItems = colDef.menuItems;
self.setPropertyOrDefault(colDef,'menuItems',[]);// Use the column definition sort if we were passed it, but only if this is a newly added column
if(isNew){self.setPropertyOrDefault(colDef,'sort');}// Use the column definition defaultSort always, unlike normal sort
self.setPropertyOrDefault(colDef,'defaultSort');// Set up default filters array for when one is not provided.
//   In other words, this (in column def):
//
//       filter: { term: 'something', flags: {}, condition: [CONDITION] }
//
//   is just shorthand for this:
//
//       filters: [{ term: 'something', flags: {}, condition: [CONDITION] }]
//
var defaultFilters=[];if(colDef.filter){defaultFilters.push(colDef.filter);}else if(colDef.filters){defaultFilters=colDef.filters;}else{// Add an empty filter definition object, which will
// translate to a guessed condition and no pre-populated
// value for the filter <input>.
defaultFilters.push({});}/**
     * @ngdoc property
     * @name filter
     * @propertyOf ui.grid.class:GridOptions.columnDef
     * @description Specify a single filter field on this column.
     *
     * A filter consists of a condition, a term, and a placeholder:
     *
     * - condition defines how rows are chosen as matching the filter term. This can be set to
     * one of the constants in {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter},
     * or you can supply a custom filter function
     * that gets passed the following arguments: [searchTerm, cellValue, row, column].
     * - term: If set, the filter field will be pre-populated
     * with this value.
     * - placeholder: String that will be set to the `<input>.placeholder` attribute.
     * - ariaLabel: String that will be set to the `<input>.ariaLabel` attribute. This is what is read as a label to screen reader users.
     * - noTerm: set this to true if you have defined a custom function in condition, and
     * your custom function doesn't require a term (so it can run even when the term is null)
     * - rawTerm: set this to true if you have defined a custom function in condition, and
     * your custom function requires access to the raw unmodified search term that was entered
     * - flags: only flag currently available is `caseSensitive`, set to false if you don't want
     * case sensitive matching
     * - type: defaults to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.INPUT},
     * which gives a text box.  If set to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.SELECT}
     * then a select box will be shown with options selectOptions
     * - selectOptions: options in the format `[ { value: 1, label: 'male' }]`.  No i18n filter is provided, you need
     * to perform the i18n on the values before you provide them
     * - disableCancelFilterButton: defaults to false. If set to true then the 'x' button that cancels/clears the filter
     * will not be shown.
     * @example
     * <pre>$scope.gridOptions.columnDefs = [
     *   {
     *     field: 'field1',
     *     filter: {
     *       term: 'xx',
     *       condition: uiGridConstants.filter.STARTS_WITH,
     *       placeholder: 'starts with...',
     *       ariaLabel: 'Starts with filter for field1',
     *       flags: { caseSensitive: false },
     *       type: uiGridConstants.filter.SELECT,
     *       selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ],
     *       disableCancelFilterButton: true
     *     }
     *   }
     * ]; </pre>
     *
     */ // Only set filter if this is a newly added column, if we're updating an existing
// column then we don't want to put the default filter back if the user may have already
// removed it.
// However, we do want to keep the settings if they change, just not the term
if(isNew){self.setPropertyOrDefault(colDef,'filter');self.setPropertyOrDefault(colDef,'extraStyle');self.setPropertyOrDefault(colDef,'filters',defaultFilters);}else if(self.filters.length===defaultFilters.length){self.filters.forEach(function(filter,index){if(typeof defaultFilters[index].placeholder!=='undefined'){filter.placeholder=defaultFilters[index].placeholder;}if(typeof defaultFilters[index].ariaLabel!=='undefined'){filter.ariaLabel=defaultFilters[index].ariaLabel;}if(typeof defaultFilters[index].flags!=='undefined'){filter.flags=defaultFilters[index].flags;}if(typeof defaultFilters[index].type!=='undefined'){filter.type=defaultFilters[index].type;}if(typeof defaultFilters[index].selectOptions!=='undefined'){filter.selectOptions=defaultFilters[index].selectOptions;}});}};/**
   * @ngdoc function
   * @name unsort
   * @methodOf ui.grid.class:GridColumn
   * @description Removes column from the grid sorting
   */GridColumn.prototype.unsort=function(){// Decrease priority for every col where priority is higher than the removed sort's priority.
var thisPriority=this.sort.priority;this.grid.columns.forEach(function(col){if(col.sort&&col.sort.priority!==undefined&&col.sort.priority>thisPriority){col.sort.priority-=1;}});this.sort={};this.grid.api.core.raise.sortChanged(this.grid,this.grid.getColumnSorting());};/**
   * @ngdoc function
   * @name getColClass
   * @methodOf ui.grid.class:GridColumn
   * @description Returns the class name for the column
   * @param {bool} prefixDot  if true, will return .className instead of className
   */GridColumn.prototype.getColClass=function(prefixDot){var cls=uiGridConstants.COL_CLASS_PREFIX+this.uid;return prefixDot?'.'+cls:cls;};/**
     * @ngdoc function
     * @name isPinnedLeft
     * @methodOf ui.grid.class:GridColumn
     * @description Returns true if column is in the left render container
     */GridColumn.prototype.isPinnedLeft=function(){return this.renderContainer==='left';};/**
     * @ngdoc function
     * @name isPinnedRight
     * @methodOf ui.grid.class:GridColumn
     * @description Returns true if column is in the right render container
     */GridColumn.prototype.isPinnedRight=function(){return this.renderContainer==='right';};/**
   * @ngdoc function
   * @name getColClassDefinition
   * @methodOf ui.grid.class:GridColumn
   * @description Returns the class definition for th column
   */GridColumn.prototype.getColClassDefinition=function(){return' .grid'+this.grid.id+' '+this.getColClass(true)+' { min-width: '+this.drawnWidth+'px; max-width: '+this.drawnWidth+'px; }';};/**
   * @ngdoc function
   * @name getRenderContainer
   * @methodOf ui.grid.class:GridColumn
   * @description Returns the render container object that this column belongs to.
   *
   * Columns will be default be in the `body` render container if they aren't allocated to one specifically.
   */GridColumn.prototype.getRenderContainer=function getRenderContainer(){var self=this;var containerId=self.renderContainer;if(containerId===null||containerId===''||containerId===undefined){containerId='body';}return self.grid.renderContainers[containerId];};/**
   * @ngdoc function
   * @name showColumn
   * @methodOf ui.grid.class:GridColumn
   * @description Makes the column visible by setting colDef.visible = true
   */GridColumn.prototype.showColumn=function(){this.colDef.visible=true;};/**
   * @ngdoc property
   * @name aggregationHideLabel
   * @propertyOf ui.grid.class:GridOptions.columnDef
   * @description defaults to false, if set to true hides the label text
   * in the aggregation footer, so only the value is displayed.
   *
   */ /**
   * @ngdoc function
   * @name getAggregationText
   * @methodOf ui.grid.class:GridColumn
   * @description Gets the aggregation label from colDef.aggregationLabel if
   * specified or by using i18n, including deciding whether or not to display
   * based on colDef.aggregationHideLabel.
   *
   * @param {string} label the i18n lookup value to use for the column label
   *
   */GridColumn.prototype.getAggregationText=function(){var self=this;if(self.colDef.aggregationHideLabel){return'';}else if(self.colDef.aggregationLabel){return self.colDef.aggregationLabel;}else{switch(self.colDef.aggregationType){case uiGridConstants.aggregationTypes.count:return i18nService.getSafeText('aggregation.count');case uiGridConstants.aggregationTypes.sum:return i18nService.getSafeText('aggregation.sum');case uiGridConstants.aggregationTypes.avg:return i18nService.getSafeText('aggregation.avg');case uiGridConstants.aggregationTypes.min:return i18nService.getSafeText('aggregation.min');case uiGridConstants.aggregationTypes.max:return i18nService.getSafeText('aggregation.max');default:return'';}}};GridColumn.prototype.getCellTemplate=function(){var self=this;return self.cellTemplatePromise;};GridColumn.prototype.getCompiledElementFn=function(){var self=this;return self.compiledElementFnDefer.promise;};return GridColumn;}]);})();(function(){angular.module('ui.grid').factory('GridOptions',['gridUtil','uiGridConstants',function(gridUtil,uiGridConstants){/**
   * @ngdoc function
   * @name ui.grid.class:GridOptions
   * @description Default GridOptions class.  GridOptions are defined by the application developer and overlaid
   * over this object.  Setting gridOptions within your controller is the most common method for an application
   * developer to configure the behaviour of their ui-grid
   *
   * @example To define your gridOptions within your controller:
   * <pre>$scope.gridOptions = {
   *   data: $scope.myData,
   *   columnDefs: [
   *     { name: 'field1', displayName: 'pretty display name' },
   *     { name: 'field2', visible: false }
   *  ]
   * };</pre>
   *
   * You can then use this within your html template, when you define your grid:
   * <pre>&lt;div ui-grid="gridOptions"&gt;&lt;/div&gt;</pre>
   *
   * To provide default options for all of the grids within your application, use an angular
   * decorator to modify the GridOptions factory.
   * <pre>
   * app.config(function($provide) {
   *   $provide.decorator('GridOptions',function($delegate) {
   *     var gridOptions;
   *     gridOptions = angular.copy($delegate);
   *     gridOptions.initialize = function(options) {
   *       var initOptions;
   *       initOptions = $delegate.initialize(options);
   *       initOptions.enableColumnMenus = false;
   *       return initOptions;
   *     };
   *     return gridOptions;
   *   });
   * });
   * </pre>
   */return{initialize:function(baseOptions){/**
       * @ngdoc function
       * @name onRegisterApi
       * @propertyOf ui.grid.class:GridOptions
       * @description A callback that returns the gridApi once the grid is instantiated, which is
       * then used to interact with the grid programatically.
       *
       * Note that the gridApi.core.renderingComplete event is identical to this
       * callback, but has the advantage that it can be called from multiple places
       * if needed
       *
       * @example
       * <pre>
       *   $scope.gridOptions.onRegisterApi = function ( gridApi ) {
       *     $scope.gridApi = gridApi;
       *     $scope.gridApi.selection.selectAllRows( $scope.gridApi.grid );
       *   };
       * </pre>
       *
       */baseOptions.onRegisterApi=baseOptions.onRegisterApi||angular.noop();/**
       * @ngdoc object
       * @name data
       * @propertyOf ui.grid.class:GridOptions
       * @description (mandatory) Array of data to be rendered into the grid, providing the data source or data binding for
       * the grid.
       *
       * Most commonly the data is an array of objects, where each object has a number of attributes.
       * Each attribute automatically becomes a column in your grid.  This array could, for example, be sourced from
       * an angularJS $resource query request.  The array can also contain complex objects, refer the binding tutorial
       * for examples of that.
       *
       * The most flexible usage is to set your data on $scope:
       *
       * `$scope.data = data;`
       *
       * And then direct the grid to resolve whatever is in $scope.data:
       *
       * `$scope.gridOptions.data = 'data';`
       *
       * This is the most flexible approach as it allows you to replace $scope.data whenever you feel like it without
       * getting pointer issues.
       *
       * Alternatively you can directly set the data array:
       *
       * `$scope.gridOptions.data = [ ];`
       * or
       *
       * `$http.get('/data/100.json')
       * .success(function(data) {
       *   $scope.myData = data;
       *   $scope.gridOptions.data = $scope.myData;
       *  });`
       *
       * Where you do this, you need to take care in updating the data - you can't just update `$scope.myData` to some other
       * array, you need to update $scope.gridOptions.data to point to that new array as well.
       *
       */baseOptions.data=baseOptions.data||[];/**
       * @ngdoc array
       * @name columnDefs
       * @propertyOf  ui.grid.class:GridOptions
       * @description Array of columnDef objects.  Only required property is name.
       * The individual options available in columnDefs are documented in the
       * {@link ui.grid.class:GridOptions.columnDef columnDef} section
       * </br>_field property can be used in place of name for backwards compatibility with 2.x_
       *  @example
       *
       * <pre>var columnDefs = [{name: 'field1'}, {name: 'field2'}];</pre>
       *
       */baseOptions.columnDefs=baseOptions.columnDefs||[];/**
       * @ngdoc object
       * @name ui.grid.class:GridOptions.columnDef
       * @description Definition / configuration of an individual column, which would typically be
       * one of many column definitions within the gridOptions.columnDefs array
       * @example
       * <pre>{name: 'field1', field: 'field1', filter: { term: 'xxx' }}</pre>
       *
       */ /**
       * @ngdoc object
       * @name enableGridMenu
       * @propertyOf ui.grid.class:GridOptions
       * @description Takes a boolean that adds a settings icon in the top right of the grid, which floats above
       * the column header, when true. The menu by default gives access to show/hide columns, but can be
       * customised to show additional actions.
       *
       * See the {@link #!/tutorial/121_grid_menu Grid Menu tutorial} for more detailed information.
       */ /**
       * @ngdoc array
       * @name excludeProperties
       * @propertyOf ui.grid.class:GridOptions
       * @description Array of property names in data to ignore when auto-generating column names.  Provides the
       * inverse of columnDefs - columnDefs is a list of columns to include, excludeProperties is a list of columns
       * to exclude.
       *
       * If columnDefs is defined, this will be ignored.
       *
       * Defaults to ['$$hashKey']
       */baseOptions.excludeProperties=baseOptions.excludeProperties||['$$hashKey'];/**
       * @ngdoc boolean
       * @name enableRowHashing
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When enabled, this setting allows uiGrid to add
       * `$$hashKey`-type properties (similar to Angular) to elements in the `data` array. This allows
       * the grid to maintain state while vastly speeding up the process of altering `data` by adding/moving/removing rows.
       *
       * Note that this DOES add properties to your data that you may not want, but they are stripped out when using `angular.toJson()`. IF
       * you do not want this at all you can disable this setting but you will take a performance hit if you are using large numbers of rows
       * and are altering the data set often.
       */baseOptions.enableRowHashing=baseOptions.enableRowHashing!==false;/**
       * @ngdoc function
       * @name rowIdentity
       * @methodOf ui.grid.class:GridOptions
       * @description This function is used to get and, if necessary, set the value uniquely identifying this row (i.e. if an identity is not present it will set one).
       *
       * By default it returns the `$$hashKey` property if it exists. If it doesn't it uses gridUtil.nextUid() to generate one
       */baseOptions.rowIdentity=baseOptions.rowIdentity||function rowIdentity(row){return gridUtil.hashKey(row);};/**
       * @ngdoc function
       * @name getRowIdentity
       * @methodOf ui.grid.class:GridOptions
       * @description This function returns the identity value uniquely identifying this row, if one is not present it does not set it.
       *
       * By default it returns the `$$hashKey` property but can be overridden to use any property or set of properties you want.
       */baseOptions.getRowIdentity=baseOptions.getRowIdentity||function getRowIdentity(row){return row.$$hashKey;};/**
       * @ngdoc property
       * @name flatEntityAccess
       * @propertyOf ui.grid.class:GridOptions
       * @description Set to true if your columns are all related directly to fields in a flat object structure - i.e.
       * each of your columns associate directly with a property on each of the entities in your data array.
       *
       * In that situation we can avoid all the logic associated with complex binding to functions or to properties of sub-objects,
       * which can provide a significant speed improvement with large data sets when filtering or sorting.
       *
       * By default false
       */baseOptions.flatEntityAccess=baseOptions.flatEntityAccess===true;/**
       * @ngdoc property
       * @name showHeader
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When set to false, this setting will replace the
       * standard header template with '<div></div>', resulting in no header being shown.
       */baseOptions.showHeader=typeof baseOptions.showHeader!=="undefined"?baseOptions.showHeader:true;/**
       * @ngdoc property
       * @name headerRowHeight
       * @propertyOf ui.grid.class:GridOptions
       * @description The height of the header in pixels, defaults to 30.
       * Although, we recommend that you alter header height with CSS rather than using this option:
       *
       * <pre>
       *     .grid .ui-grid-header-cell {
       *         height: 60px;
       *     }
       * </pre>
       **/if(!baseOptions.showHeader){baseOptions.headerRowHeight=0;}else{baseOptions.headerRowHeight=typeof baseOptions.headerRowHeight!=="undefined"?baseOptions.headerRowHeight:30;}/**
       * @ngdoc property
       * @name rowHeight
       * @propertyOf ui.grid.class:GridOptions
       * @description The height of the row in pixels,  Can be passed as integer or string. defaults to 30.
       *
       */if(typeof baseOptions.rowHeight==="string"){baseOptions.rowHeight=parseInt(baseOptions.rowHeight)||30;}else{baseOptions.rowHeight=baseOptions.rowHeight||30;}/**
       * @ngdoc integer
       * @name minRowsToShow
       * @propertyOf ui.grid.class:GridOptions
       * @description Minimum number of rows to show when the grid doesn't have a defined height. Defaults to "10".
       */baseOptions.minRowsToShow=typeof baseOptions.minRowsToShow!=="undefined"?baseOptions.minRowsToShow:10;/**
       * @ngdoc property
       * @name showGridFooter
       * @propertyOf ui.grid.class:GridOptions
       * @description Whether or not to show the footer, defaults to false
       * The footer display Total Rows and Visible Rows (filtered rows)
       */baseOptions.showGridFooter=baseOptions.showGridFooter===true;/**
       * @ngdoc property
       * @name showColumnFooter
       * @propertyOf ui.grid.class:GridOptions
       * @description Whether or not to show the column footer, defaults to false
       * The column footer displays column aggregates
       */baseOptions.showColumnFooter=baseOptions.showColumnFooter===true;/**
       * @ngdoc property
       * @name columnFooterHeight
       * @propertyOf ui.grid.class:GridOptions
       * @description The height of the footer rows (column footer and grid footer) in pixels
       *
       */baseOptions.columnFooterHeight=typeof baseOptions.columnFooterHeight!=="undefined"?baseOptions.columnFooterHeight:30;baseOptions.gridFooterHeight=typeof baseOptions.gridFooterHeight!=="undefined"?baseOptions.gridFooterHeight:30;baseOptions.columnWidth=typeof baseOptions.columnWidth!=="undefined"?baseOptions.columnWidth:50;/**
       * @ngdoc property
       * @name maxVisibleColumnCount
       * @propertyOf ui.grid.class:GridOptions
       * @description Defaults to 200
       *
       */baseOptions.maxVisibleColumnCount=typeof baseOptions.maxVisibleColumnCount!=="undefined"?baseOptions.maxVisibleColumnCount:200;/**
       * @ngdoc property
       * @name virtualizationThreshold
       * @propertyOf ui.grid.class:GridOptions
       * @description Turn virtualization on when number of data elements goes over this number, defaults to 20
       */baseOptions.virtualizationThreshold=typeof baseOptions.virtualizationThreshold!=="undefined"?baseOptions.virtualizationThreshold:20;/**
       * @ngdoc property
       * @name columnVirtualizationThreshold
       * @propertyOf ui.grid.class:GridOptions
       * @description Turn virtualization on when number of columns goes over this number, defaults to 10
       */baseOptions.columnVirtualizationThreshold=typeof baseOptions.columnVirtualizationThreshold!=="undefined"?baseOptions.columnVirtualizationThreshold:10;/**
       * @ngdoc property
       * @name excessRows
       * @propertyOf ui.grid.class:GridOptions
       * @description Extra rows to to render outside of the viewport, which helps with smoothness of scrolling.
       * Defaults to 4
       */baseOptions.excessRows=typeof baseOptions.excessRows!=="undefined"?baseOptions.excessRows:4;/**
       * @ngdoc property
       * @name scrollThreshold
       * @propertyOf ui.grid.class:GridOptions
       * @description Throttles the grid scrolling by the amount of rows set, which helps with smoothness of scrolling.
       * Defaults to 4.
       */baseOptions.scrollThreshold=typeof baseOptions.scrollThreshold!=="undefined"?baseOptions.scrollThreshold:4;/**
       * @ngdoc property
       * @name excessColumns
       * @propertyOf ui.grid.class:GridOptions
       * @description Extra columns to to render outside of the viewport, which helps with smoothness of scrolling.
       * Defaults to 4
       */baseOptions.excessColumns=typeof baseOptions.excessColumns!=="undefined"?baseOptions.excessColumns:4;/**
       * @ngdoc property
       * @name aggregationCalcThrottle
       * @propertyOf ui.grid.class:GridOptions
       * @description Default time in milliseconds to throttle aggregation calcuations, defaults to 500ms
       */baseOptions.aggregationCalcThrottle=typeof baseOptions.aggregationCalcThrottle!=="undefined"?baseOptions.aggregationCalcThrottle:500;/**
       * @ngdoc property
       * @name wheelScrollThrottle
       * @propertyOf ui.grid.class:GridOptions
       * @description Default time in milliseconds to throttle scroll events to, defaults to 70ms
       */baseOptions.wheelScrollThrottle=typeof baseOptions.wheelScrollThrottle!=="undefined"?baseOptions.wheelScrollThrottle:70;/**
       * @ngdoc property
       * @name scrollDebounce
       * @propertyOf ui.grid.class:GridOptions
       * @description Default time in milliseconds to debounce scroll events, defaults to 300ms
       */baseOptions.scrollDebounce=typeof baseOptions.scrollDebounce!=="undefined"?baseOptions.scrollDebounce:300;/**
       * @ngdoc boolean
       * @name enableHiding
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When enabled, this setting adds ability to hide
       * the column headers, allowing hiding of the column from the grid.
       * Column hiding can then be disabled / enabled on individual columns using the columnDefs,
       * if it set, it will override GridOptions enableHiding setting.
       */baseOptions.enableHiding=baseOptions.enableHiding!==false;/**
       * @ngdoc boolean
       * @name enableSorting
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When enabled, this setting adds sort
       * widgets to the column headers, allowing sorting of the data for the entire grid.
       * Sorting can then be disabled / enabled on individual columns using the columnDefs,
       * if it set, it will override GridOptions enableSorting setting.
       */baseOptions.enableSorting=baseOptions.enableSorting!==false;/**
       * @ngdoc boolean
       * @name suppressMultiSort
       * @propertyOf ui.grid.class:GridOptions
       * @description False by default. When enabled, this setting disables the ability
       * to sort multiple columns by using the shift key or interacting with the column
       * menu. Instead, each column sort will remove all other sorting.
       */baseOptions.suppressMultiSort=baseOptions.suppressMultiSort===true;/**
       * @ngdoc boolean
       * @name enableFiltering
       * @propertyOf ui.grid.class:GridOptions
       * @description False by default. When enabled, this setting adds filter
       * boxes to each column header, allowing filtering within the column for the entire grid.
       * Filtering can then be disabled on individual columns using the columnDefs.
       */baseOptions.enableFiltering=baseOptions.enableFiltering===true;/**
       * @ngdoc string
       * @name filterContainer
       * @propertyOf ui.grid.class:GridOptions
       * @description Sets the parent element for the column filter. `headerCell` places
       * it in the header cell. `columnMenu` places it in the column menu.
       * Can be changed for individual columns using the columnDefs.
       * Defaults to `headerCell`
       */baseOptions.filterContainer=typeof baseOptions.filterContainer!=="undefined"?baseOptions.filterContainer:"headerCell";/**
       * @ngdoc boolean
       * @name enableColumnMenus
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When enabled, this setting displays a column
       * menu within each column.
       * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
       *
       * <pre>
       *  .ui-grid-column-menu-button {
       *    display: block;
       *  }
       * </pre>
       */baseOptions.enableColumnMenus=baseOptions.enableColumnMenus!==false;/**
       * @ngdoc boolean
       * @name enableVerticalScrollbar
       * @propertyOf ui.grid.class:GridOptions
       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
       * This settings controls the vertical scrollbar for the grid.
       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
       */baseOptions.enableVerticalScrollbar=typeof baseOptions.enableVerticalScrollbar!=="undefined"?baseOptions.enableVerticalScrollbar:uiGridConstants.scrollbars.ALWAYS;/**
       * @ngdoc boolean
       * @name enableHorizontalScrollbar
       * @propertyOf ui.grid.class:GridOptions
       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
       * This settings controls the horizontal scrollbar for the grid.
       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
       */baseOptions.enableHorizontalScrollbar=typeof baseOptions.enableHorizontalScrollbar!=="undefined"?baseOptions.enableHorizontalScrollbar:uiGridConstants.scrollbars.ALWAYS;/**
       * @ngdoc boolean
       * @name enableMinHeightCheck
       * @propertyOf ui.grid.class:GridOptions
       * @description True by default. When enabled, a newly initialized grid will check to see if it is tall enough to display
       * at least one row of data.  If the grid is not tall enough, it will resize the DOM element to display minRowsToShow number
       * of rows.
       */baseOptions.enableMinHeightCheck=baseOptions.enableMinHeightCheck!==false;/**
       * @ngdoc boolean
       * @name minimumColumnSize
       * @propertyOf ui.grid.class:GridOptions
       * @description Sets the default minimum column width, in other words,
       * it defines the default value for a column minWidth attribute if that is not otherwise specified.
       * Should be a number. Defaults to 30 pixels.
       */baseOptions.minimumColumnSize=typeof baseOptions.minimumColumnSize!=="undefined"?baseOptions.minimumColumnSize:30;/**
       * @ngdoc function
       * @name rowEquality
       * @methodOf ui.grid.class:GridOptions
       * @description By default, rows are compared using object equality.  This option can be overridden
       * to compare on any data item property or function
       * @param {object} entityA First Data Item to compare
       * @param {object} entityB Second Data Item to compare
       */baseOptions.rowEquality=baseOptions.rowEquality||function(entityA,entityB){return entityA===entityB;};/**
       * @ngdoc string
       * @name headerTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description Null by default. When provided, this setting uses a custom header
       * template, rather than the default template. Can be set to either the name of a template file:
       * <pre>  $scope.gridOptions.headerTemplate = 'header_template.html';</pre>
       * inline html
       * <pre>  $scope.gridOptions.headerTemplate = '<div class="ui-grid-top-panel" style="text-align: center">I am a Custom Grid Header</div>'</pre>
       * or the id of a precompiled template (TBD how to use this).
       * </br>Refer to the custom header tutorial for more information.
       * If you want no header at all, you can set to an empty div:
       * <pre>  $scope.gridOptions.headerTemplate = '<div></div>';</pre>
       *
       * If you want to only have a static header, then you can set to static content.  If
       * you want to tailor the existing column headers, then you should look at the
       * current 'ui-grid-header.html' template in github as your starting point.
       *
       */baseOptions.headerTemplate=baseOptions.headerTemplate||null;/**
       * @ngdoc string
       * @name footerTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description (optional) ui-grid/ui-grid-footer by default.  This footer shows the per-column
       * aggregation totals.
       * When provided, this setting uses a custom footer template. Can be set to either the name of a template file 'footer_template.html', inline html
       * <pre>'<div class="ui-grid-bottom-panel" style="text-align: center">I am a Custom Grid Footer</div>'</pre>, or the id
       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
       */baseOptions.footerTemplate=baseOptions.footerTemplate||'ui-grid/ui-grid-footer';/**
       * @ngdoc string
       * @name gridFooterTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description (optional) ui-grid/ui-grid-grid-footer by default. This template by default shows the
       * total items at the bottom of the grid, and the selected items if selection is enabled.
       */baseOptions.gridFooterTemplate=baseOptions.gridFooterTemplate||'ui-grid/ui-grid-grid-footer';/**
       * @ngdoc string
       * @name rowTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description 'ui-grid/ui-grid-row' by default. When provided, this setting uses a
       * custom row template.  Can be set to either the name of a template file:
       * <pre> $scope.gridOptions.rowTemplate = 'row_template.html';</pre>
       * inline html
       * <pre>  $scope.gridOptions.rowTemplate = '<div style="background-color: aquamarine" ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';</pre>
       * or the id of a precompiled template (TBD how to use this) can be provided.
       * </br>Refer to the custom row template tutorial for more information.
       */baseOptions.rowTemplate=baseOptions.rowTemplate||'ui-grid/ui-grid-row';/**
      * @ngdoc string
      * @name gridMenuTemplate
      * @propertyOf ui.grid.class:GridOptions
      * @description 'ui-grid/uiGridMenu' by default. When provided, this setting uses a
      * custom grid menu template.
      */baseOptions.gridMenuTemplate=baseOptions.gridMenuTemplate||'ui-grid/uiGridMenu';/**
       * @ngdoc string
       * @name disableGridMenuHideOnScroll
       * @propertyOf ui.grid.class:GridOptions
       * @description 'false' by default. When provided, this setting disables Grid Menu Hide On Scroll
       */baseOptions.disableGridMenuHideOnScroll=baseOptions.disableGridMenuHideOnScroll||false;/**
       * @ngdoc string
       * @name menuButtonTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description 'ui-grid/ui-grid-menu-button' by default. When provided, this setting uses a custom grid menu button
       * template. Can be set to either the name of a template file 'menuButton_template.html', inline html
       * <pre>'<div class="ui-grid-menu-button" ng-click="customToggleMenu()"><div class="ui-grid-icon-container"><i class="ui-grid-icon=menu">&nbsp;</i></div></div><div ui-grid-menu menu-items="menuItems"></div>'</pre>, or the id
       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
       */baseOptions.menuButtonTemplate=baseOptions.menuButtonTemplate||'ui-grid/ui-grid-menu-button';/**
       * @ngdoc string
       * @name menuItemTemplate
       * @propertyOf ui.grid.class:GridOptions
       * @description 'ui-grid/uiGridMenuItem' by default. When provided, this setting uses a custom grid menu item
       * template. Can be set to either the name of a template file 'menuItem_template.html', inline html
       * <pre>'<li class="ui-grid-menu-item"><label>{{name}}</label></li>'</pre>, or the id
       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
       */baseOptions.menuItemTemplate=baseOptions.menuItemTemplate||'ui-grid/uiGridMenuItem';/**
       * @ngdoc object
       * @name appScopeProvider
       * @propertyOf ui.grid.class:GridOptions
       * @description by default, the parent scope of the ui-grid element will be assigned to grid.appScope
       * this property allows you to assign any reference you want to grid.appScope
       */baseOptions.appScopeProvider=baseOptions.appScopeProvider||null;return baseOptions;}};}]);})();(function(){angular.module('ui.grid')/**
   * @ngdoc function
   * @name ui.grid.class:GridRenderContainer
   * @description The grid has render containers, allowing the ability to have pinned columns.  If the grid
   * is right-to-left then there may be a right render container, if left-to-right then there may
   * be a left render container.  There is always a body render container.
   * @param {string} name The name of the render container ('body', 'left', or 'right')
   * @param {Grid} grid the grid the render container is in
   * @param {object} options the render container options
   */.factory('GridRenderContainer',['gridUtil','uiGridConstants',function(gridUtil,uiGridConstants){function GridRenderContainer(name,grid,options){var self=this;// if (gridUtil.type(grid) !== 'Grid') {
//   throw new Error('Grid argument is not a Grid object');
// }
self.name=name;self.grid=grid;// self.rowCache = [];
// self.columnCache = [];
self.visibleRowCache=[];self.visibleColumnCache=[];self.renderedRows=[];self.renderedColumns=[];self.prevScrollTop=0;self.prevScrolltopPercentage=0;self.prevRowScrollIndex=0;self.prevScrollLeft=0;self.prevScrollleftPercentage=0;self.prevColumnScrollIndex=0;self.columnStyles='';self.viewportAdjusters=[];/**
     *  @ngdoc boolean
     *  @name hasHScrollbar
     *  @propertyOf  ui.grid.class:GridRenderContainer
     *  @description flag to signal that container has a horizontal scrollbar
     */self.hasHScrollbar=false;/**
     *  @ngdoc boolean
     *  @name hasVScrollbar
     *  @propertyOf  ui.grid.class:GridRenderContainer
     *  @description flag to signal that container has a vertical scrollbar
     */self.hasVScrollbar=false;/**
     *  @ngdoc boolean
     *  @name canvasHeightShouldUpdate
     *  @propertyOf  ui.grid.class:GridRenderContainer
     *  @description flag to signal that container should recalculate the canvas size
     */self.canvasHeightShouldUpdate=true;/**
     *  @ngdoc boolean
     *  @name canvasHeight
     *  @propertyOf  ui.grid.class:GridRenderContainer
     *  @description last calculated canvas height value
     */self.$$canvasHeight=0;if(options&&angular.isObject(options)){angular.extend(self,options);}grid.registerStyleComputation({priority:5,func:function(){self.updateColumnWidths();return self.columnStyles;}});}GridRenderContainer.prototype.reset=function reset(){// this.rowCache.length = 0;
// this.columnCache.length = 0;
this.visibleColumnCache.length=0;this.visibleRowCache.length=0;this.renderedRows.length=0;this.renderedColumns.length=0;};// TODO(c0bra): calculate size?? Should this be in a stackable directive?
GridRenderContainer.prototype.containsColumn=function(col){return this.visibleColumnCache.indexOf(col)!==-1;};GridRenderContainer.prototype.minRowsToRender=function minRowsToRender(){var self=this;var minRows=0;var rowAddedHeight=0;var viewPortHeight=self.getViewportHeight();for(var i=self.visibleRowCache.length-1;rowAddedHeight<viewPortHeight&&i>=0;i--){rowAddedHeight+=self.visibleRowCache[i].height;minRows++;}return minRows;};GridRenderContainer.prototype.minColumnsToRender=function minColumnsToRender(){var self=this;var viewportWidth=this.getViewportWidth();var min=0;var totalWidth=0;for(var i=0;i<self.visibleColumnCache.length;i++){var col=self.visibleColumnCache[i];if(totalWidth<viewportWidth){totalWidth+=col.drawnWidth?col.drawnWidth:0;min++;}else{var currWidth=0;for(var j=i;j>=i-min;j--){currWidth+=self.visibleColumnCache[j].drawnWidth?self.visibleColumnCache[j].drawnWidth:0;}if(currWidth<viewportWidth){min++;}}}return min;};GridRenderContainer.prototype.getVisibleRowCount=function getVisibleRowCount(){return this.visibleRowCache.length;};/**
   * @ngdoc function
   * @name registerViewportAdjuster
   * @methodOf ui.grid.class:GridRenderContainer
   * @description Registers an adjuster to the render container's available width or height.  Adjusters are used
   * to tell the render container that there is something else consuming space, and to adjust it's size
   * appropriately.
   * @param {function} func the adjuster function we want to register
   */GridRenderContainer.prototype.registerViewportAdjuster=function registerViewportAdjuster(func){this.viewportAdjusters.push(func);};/**
   * @ngdoc function
   * @name removeViewportAdjuster
   * @methodOf ui.grid.class:GridRenderContainer
   * @description Removes an adjuster, should be used when your element is destroyed
   * @param {function} func the adjuster function we want to remove
   */GridRenderContainer.prototype.removeViewportAdjuster=function removeViewportAdjuster(func){var idx=this.viewportAdjusters.indexOf(func);if(idx>-1){this.viewportAdjusters.splice(idx,1);}};/**
   * @ngdoc function
   * @name getViewportAdjustment
   * @methodOf ui.grid.class:GridRenderContainer
   * @description Gets the adjustment based on the viewportAdjusters.
   * @returns {object} a hash of { height: x, width: y }.  Usually the values will be negative
   */GridRenderContainer.prototype.getViewportAdjustment=function getViewportAdjustment(){var self=this;var adjustment={height:0,width:0};self.viewportAdjusters.forEach(function(func){adjustment=func.call(this,adjustment);});return adjustment;};GridRenderContainer.prototype.getMargin=function getMargin(side){var self=this;var amount=0;self.viewportAdjusters.forEach(function(func){var adjustment=func.call(this,{height:0,width:0});if(adjustment.side&&adjustment.side===side){amount+=adjustment.width*-1;}});return amount;};GridRenderContainer.prototype.getViewportHeight=function getViewportHeight(){var self=this;var headerHeight=self.headerHeight?self.headerHeight:self.grid.headerHeight;var viewPortHeight=self.grid.gridHeight-headerHeight-self.grid.footerHeight;var adjustment=self.getViewportAdjustment();viewPortHeight=viewPortHeight+adjustment.height;return viewPortHeight>0?viewPortHeight:0;};GridRenderContainer.prototype.getViewportWidth=function getViewportWidth(){var self=this;var viewportWidth=self.grid.gridWidth;// if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined &&
//  self.grid.verticalScrollbarWidth > 0) {
//   viewPortWidth = viewPortWidth - self.grid.verticalScrollbarWidth;
// }
// var viewportWidth = 0;\
// self.visibleColumnCache.forEach(function (column) {
//   viewportWidth += column.drawnWidth;
// });
var adjustment=self.getViewportAdjustment();viewportWidth=viewportWidth+adjustment.width;return viewportWidth;};GridRenderContainer.prototype.getHeaderViewportWidth=function getHeaderViewportWidth(){return this.getViewportWidth();};/**
   * @ngdoc function
   * @name getCanvasHeight
   * @methodOf ui.grid.class:GridRenderContainer
   * @description Returns the total canvas height.   Only recalculates if canvasHeightShouldUpdate = false
   * @returns {number} total height of all the visible rows in the container
   */GridRenderContainer.prototype.getCanvasHeight=function getCanvasHeight(){var self=this;if(!self.canvasHeightShouldUpdate){return self.$$canvasHeight;}var oldCanvasHeight=self.$$canvasHeight;self.$$canvasHeight=0;self.visibleRowCache.forEach(function(row){self.$$canvasHeight+=row.height;});self.canvasHeightShouldUpdate=false;self.grid.api.core.raise.canvasHeightChanged(oldCanvasHeight,self.$$canvasHeight);return self.$$canvasHeight;};GridRenderContainer.prototype.getVerticalScrollLength=function getVerticalScrollLength(){return this.getCanvasHeight()-this.getViewportHeight()+this.grid.scrollbarHeight!==0?this.getCanvasHeight()-this.getViewportHeight()+this.grid.scrollbarHeight:-1;};GridRenderContainer.prototype.getHorizontalScrollLength=function getHorizontalScrollLength(){return this.getCanvasWidth()-this.getViewportWidth()+this.grid.scrollbarWidth!==0?this.getCanvasWidth()-this.getViewportWidth()+this.grid.scrollbarWidth:-1;};GridRenderContainer.prototype.getCanvasWidth=function getCanvasWidth(){var self=this;return self.canvasWidth;};GridRenderContainer.prototype.setRenderedRows=function setRenderedRows(newRows){this.renderedRows.length=newRows.length;for(var i=0;i<newRows.length;i++){this.renderedRows[i]=newRows[i];}};GridRenderContainer.prototype.setRenderedColumns=function setRenderedColumns(newColumns){// OLD:
this.renderedColumns.length=newColumns.length;for(var i=0;i<newColumns.length;i++){this.renderedColumns[i]=newColumns[i];}this.updateColumnOffset();};GridRenderContainer.prototype.updateColumnOffset=function updateColumnOffset(){// Calculate the width of the columns on the left side that are no longer rendered.
//  That will be the offset for the columns as we scroll horizontally.
var hiddenColumnsWidth=0;for(var i=0;i<this.currentFirstColumn;i++){hiddenColumnsWidth+=this.visibleColumnCache[i].drawnWidth;}this.columnOffset=hiddenColumnsWidth;};GridRenderContainer.prototype.scrollVertical=function(newScrollTop){var vertScrollPercentage=-1;if(newScrollTop!==this.prevScrollTop){var yDiff=newScrollTop-this.prevScrollTop;if(yDiff>0){this.grid.scrollDirection=uiGridConstants.scrollDirection.DOWN;}if(yDiff<0){this.grid.scrollDirection=uiGridConstants.scrollDirection.UP;}var vertScrollLength=this.getVerticalScrollLength();vertScrollPercentage=newScrollTop/vertScrollLength;if(vertScrollPercentage>1){vertScrollPercentage=1;}if(vertScrollPercentage<0){vertScrollPercentage=0;}this.adjustScrollVertical(newScrollTop,vertScrollPercentage);return vertScrollPercentage;}};GridRenderContainer.prototype.scrollHorizontal=function(newScrollLeft){var horizScrollPercentage=-1;// Handle RTL here
if(newScrollLeft!==this.prevScrollLeft){var xDiff=newScrollLeft-this.prevScrollLeft;if(xDiff>0){this.grid.scrollDirection=uiGridConstants.scrollDirection.RIGHT;}if(xDiff<0){this.grid.scrollDirection=uiGridConstants.scrollDirection.LEFT;}var horizScrollLength=this.getHorizontalScrollLength();if(horizScrollLength!==0){horizScrollPercentage=newScrollLeft/horizScrollLength;}else{horizScrollPercentage=0;}this.adjustScrollHorizontal(newScrollLeft,horizScrollPercentage);return horizScrollPercentage;}};GridRenderContainer.prototype.adjustScrollVertical=function adjustScrollVertical(scrollTop,scrollPercentage,force){if(this.prevScrollTop===scrollTop&&!force){return;}if(typeof scrollTop==='undefined'||scrollTop===undefined||scrollTop===null){scrollTop=(this.getCanvasHeight()-this.getViewportHeight())*scrollPercentage;}this.adjustRows(scrollTop,scrollPercentage,false);this.prevScrollTop=scrollTop;this.prevScrolltopPercentage=scrollPercentage;this.grid.queueRefresh();};GridRenderContainer.prototype.adjustScrollHorizontal=function adjustScrollHorizontal(scrollLeft,scrollPercentage,force){if(this.prevScrollLeft===scrollLeft&&!force){return;}if(typeof scrollLeft==='undefined'||scrollLeft===undefined||scrollLeft===null){scrollLeft=(this.getCanvasWidth()-this.getViewportWidth())*scrollPercentage;}this.adjustColumns(scrollLeft);this.prevScrollLeft=scrollLeft;this.prevScrollleftPercentage=scrollPercentage;this.grid.queueRefresh();};GridRenderContainer.prototype.adjustRows=function adjustRows(scrollTop,scrollPercentage,postDataLoaded){var self=this;var minRows=self.minRowsToRender();var rowCache=self.visibleRowCache;var maxRowIndex=rowCache.length-minRows;// Calculate the scroll percentage according to the scrollTop location, if no percentage was provided
if((typeof scrollPercentage==='undefined'||scrollPercentage===null)&&scrollTop){scrollPercentage=scrollTop/self.getVerticalScrollLength();}var rowIndex=Math.ceil(Math.min(maxRowIndex,maxRowIndex*scrollPercentage));// Define a max row index that we can't scroll past
if(rowIndex>maxRowIndex){rowIndex=maxRowIndex;}var newRange=[];if(rowCache.length>self.grid.options.virtualizationThreshold){if(!(typeof scrollTop==='undefined'||scrollTop===null)){// Have we hit the threshold going down?
if(!self.grid.suppressParentScrollDown&&self.prevScrollTop<scrollTop&&rowIndex<self.prevRowScrollIndex+self.grid.options.scrollThreshold&&rowIndex<maxRowIndex){return;}// Have we hit the threshold going up?
if(!self.grid.suppressParentScrollUp&&self.prevScrollTop>scrollTop&&rowIndex>self.prevRowScrollIndex-self.grid.options.scrollThreshold&&rowIndex<maxRowIndex){return;}}var rangeStart=Math.max(0,rowIndex-self.grid.options.excessRows);var rangeEnd=Math.min(rowCache.length,rowIndex+minRows+self.grid.options.excessRows);newRange=[rangeStart,rangeEnd];}else{var maxLen=self.visibleRowCache.length;newRange=[0,Math.max(maxLen,minRows+self.grid.options.excessRows)];}self.updateViewableRowRange(newRange);self.prevRowScrollIndex=rowIndex;};GridRenderContainer.prototype.adjustColumns=function adjustColumns(scrollLeft){var self=this;var minCols=self.minColumnsToRender();var columnCache=self.visibleColumnCache;var maxColumnIndex=columnCache.length-minCols;var colIndex=Math.min(maxColumnIndex,self.getLeftIndex(scrollLeft));var newRange=[];if(columnCache.length>self.grid.options.columnVirtualizationThreshold&&self.getCanvasWidth()>self.getViewportWidth()){var rangeStart=Math.max(0,colIndex-self.grid.options.excessColumns);var rangeEnd=Math.min(columnCache.length,colIndex+minCols+self.grid.options.excessColumns);newRange=[rangeStart,rangeEnd];}else{var maxLen=self.visibleColumnCache.length;newRange=[0,Math.max(maxLen,minCols+self.grid.options.excessColumns)];}self.updateViewableColumnRange(newRange);self.prevColumnScrollIndex=colIndex;};GridRenderContainer.prototype.getLeftIndex=function getLeftIndex(scrollLeft){var wholeLeftWidth=0;var index=0;for(index;index<this.visibleColumnCache.length;index++){if(this.visibleColumnCache[index]&&this.visibleColumnCache[index].visible){// accumulate the whole width of columns on the left side, till the point of visibility is surpassed, this is our wanted index
wholeLeftWidth+=this.visibleColumnCache[index].drawnWidth;if(wholeLeftWidth>=scrollLeft){break;}}}return index;};// Method for updating the visible rows
GridRenderContainer.prototype.updateViewableRowRange=function updateViewableRowRange(renderedRange){// Slice out the range of rows from the data
// var rowArr = uiGridCtrl.grid.rows.slice(renderedRange[0], renderedRange[1]);
var rowArr=this.visibleRowCache.slice(renderedRange[0],renderedRange[1]);// Define the top-most rendered row
this.currentTopRow=renderedRange[0];this.setRenderedRows(rowArr);};// Method for updating the visible columns
GridRenderContainer.prototype.updateViewableColumnRange=function updateViewableColumnRange(renderedRange){// Slice out the range of rows from the data
// var columnArr = uiGridCtrl.grid.columns.slice(renderedRange[0], renderedRange[1]);
var columnArr=this.visibleColumnCache.slice(renderedRange[0],renderedRange[1]);// Define the left-most rendered columns
this.currentFirstColumn=renderedRange[0];this.setRenderedColumns(columnArr);};GridRenderContainer.prototype.headerCellWrapperStyle=function(){var self=this;if(self.currentFirstColumn!==0){var offset=self.columnOffset;if(self.grid.isRTL()){return{'margin-right':offset+'px'};}else{return{'margin-left':offset+'px'};}}return null;};/**
     *  @ngdoc boolean
     *  @name updateColumnWidths
     *  @propertyOf  ui.grid.class:GridRenderContainer
     *  @description Determine the appropriate column width of each column across all render containers.
     *
     *  Column width is easy when each column has a specified width.  When columns are variable width (i.e.
     *  have an * or % of the viewport) then we try to calculate so that things fit in.  The problem is that
     *  we have multiple render containers, and we don't want one render container to just take the whole viewport
     *  when it doesn't need to - we want things to balance out across the render containers.
     *
     *  To do this, we use this method to calculate all the renderContainers, recognising that in a given render
     *  cycle it'll get called once per render container, so it needs to return the same values each time.
     *
     *  The constraints on this method are therefore:
     *  - must return the same value when called multiple times, to do this it needs to rely on properties of the
     *    columns, but not properties that change when this is called (so it shouldn't rely on drawnWidth)
     *
     *  The general logic of this method is:
     *  - calculate our total available width
     *  - look at all the columns across all render containers, and work out which have widths and which have
     *    constraints such as % or * or something else
     *  - for those with *, count the total number of * we see and add it onto a running total, add this column to an * array
     *  - for those with a %, allocate the % as a percentage of the viewport, having consideration of min and max
     *  - for those with manual width (in pixels) we set the drawnWidth to the specified width
     *  - we end up with an asterisks array still to process
     *  - we look at our remaining width.  If it's greater than zero, we divide it up among the asterisk columns, then process
     *    them for min and max width constraints
     *  - if it's zero or less, we set the asterisk columns to their minimum widths
     *  - we use parseInt quite a bit, as we try to make all our column widths integers
     */GridRenderContainer.prototype.updateColumnWidths=function(){var self=this;var asterisksArray=[],asteriskNum=0,usedWidthSum=0,ret='',pinRightColumn=false,fixedNumberArray=[],percentageArray=[],totalPercentage=0;// Get the width of the viewport
var availableWidth=self.grid.getViewportWidth()-self.grid.scrollbarWidth;// get all the columns across all render containers, we have to calculate them all or one render container
// could consume the whole viewport
var columnCache=[];angular.forEach(self.grid.renderContainers,function(container){columnCache=columnCache.concat(container.visibleColumnCache);});// look at each column, process any manual values or %, put the * into an array to look at later
columnCache.forEach(function(column){var width=0;// Skip hidden columns
if(!column.visible){return;}if(!pinRightColumn&&column.colDef.pinnedRight){pinRightColumn=true;}if(pinRightColumn){availableWidth+=self.grid.scrollbarWidth;}if(angular.isNumber(column.width)){// pixel width, set to this value
if(column.colDef.allowFloatWidth){width=parseFloat(column.width);}else{width=parseInt(column.width,10);}usedWidthSum=usedWidthSum+width;column.drawnWidth=width;fixedNumberArray.push(column);}else if(gridUtil.endsWith(column.width,'%')){// percentage width, set to percentage of the viewport
// round down to int - some browsers don't play nice with float maxWidth
var percentageIntegerValue=parseInt(column.width.replace(/%/g,''),10);if(column.colDef.allowFloatWidth){width=parseFloat(percentageIntegerValue/100*availableWidth);}else{width=parseInt(percentageIntegerValue/100*availableWidth,10);}if(width>column.maxWidth){width=column.maxWidth;}if(width<column.minWidth){width=column.minWidth;}usedWidthSum=usedWidthSum+width;column.drawnWidth=width;totalPercentage=totalPercentage+percentageIntegerValue;percentageArray.push(column);}else if(angular.isString(column.width)&&column.width.indexOf('*')!==-1){// is an asterisk column, the gridColumn already checked the string consists only of '****'
asteriskNum=asteriskNum+column.width.length;asterisksArray.push(column);}});// Get the remaining width (available width subtracted by the used widths sum)
var remainingWidth=availableWidth-usedWidthSum;if(asterisksArray.length>0){// the width that each asterisk value would be assigned (this can be negative)
var asteriskVal=remainingWidth/asteriskNum;asterisksArray.forEach(function(column){var width=parseInt(column.width.length*asteriskVal,10);if(column.colDef.allowFloatWidth){width=parseFloat(column.width.length*asteriskVal);}if(width>column.maxWidth){width=column.maxWidth;}if(width<column.minWidth){width=column.minWidth;}usedWidthSum=usedWidthSum+width;column.drawnWidth=width;});}// If there are no columns with asterisk widths then check if there are any with % widths and
// use them as a fallback for adjusting column widths up or down if we have remaining grid width
// or need to claw some width back
var variableWidthColumnArray;if(asterisksArray.length>0){variableWidthColumnArray=asterisksArray;}else if(percentageArray.length>0&&fixedNumberArray.length===0&&totalPercentage===100){variableWidthColumnArray=percentageArray;}if(!angular.isUndefined(variableWidthColumnArray)){// If the grid width didn't divide evenly into the column widths and we have pixels left over, or our
// calculated widths would have the grid narrower than the available space,
// dole the remainder out one by one to make everything fit
var processColumnUpwards=function(column){if(column.drawnWidth<column.maxWidth&&leftoverWidth>0){column.drawnWidth++;usedWidthSum++;leftoverWidth--;columnsToChange=true;}};var leftoverWidth=availableWidth-usedWidthSum;var columnsToChange=true;while(leftoverWidth>0&&columnsToChange){columnsToChange=false;variableWidthColumnArray.forEach(processColumnUpwards);}// We can end up with too much width even though some columns aren't at their max width, in this situation
// we can trim the columns a little
var processColumnDownwards=function(column){if(column.drawnWidth>column.minWidth&&excessWidth>0){column.drawnWidth--;usedWidthSum--;excessWidth--;columnsToChange=true;}};var excessWidth=usedWidthSum-availableWidth;columnsToChange=true;while(excessWidth>0&&columnsToChange){columnsToChange=false;variableWidthColumnArray.forEach(processColumnDownwards);}}// all that was across all the renderContainers, now we need to work out what that calculation decided for
// our renderContainer
var canvasWidth=0;self.visibleColumnCache.forEach(function(column){if(column.visible){canvasWidth=canvasWidth+column.drawnWidth;}});// Build the CSS
columnCache.forEach(function(column){ret=ret+column.getColClassDefinition();});self.canvasWidth=canvasWidth;// Return the styles back to buildStyles which pops them into the `customStyles` scope variable
// return ret;
// Set this render container's column styles so they can be used in style computation
this.columnStyles=ret;};GridRenderContainer.prototype.needsHScrollbarPlaceholder=function(){var self=this,containerBody;if(self.name==='left'||self.name==='right'&&!this.hasHScrollbar&&!this.grid.disableScrolling){if(self.grid.options.enableHorizontalScrollbar===uiGridConstants.scrollbars.ALWAYS){return true;}containerBody=this.grid.element[0].querySelector('.ui-grid-render-container-body .ui-grid-viewport');return containerBody.scrollWidth>containerBody.offsetWidth;}return false;};GridRenderContainer.prototype.getViewportStyle=function(){var self=this;var styles={};var scrollbarVisibility={};scrollbarVisibility[uiGridConstants.scrollbars.ALWAYS]='scroll';scrollbarVisibility[uiGridConstants.scrollbars.WHEN_NEEDED]='auto';self.hasHScrollbar=false;self.hasVScrollbar=false;if(self.grid.disableScrolling){styles['overflow-x']='hidden';styles['overflow-y']='hidden';return styles;}if(self.name==='body'){self.hasHScrollbar=self.grid.options.enableHorizontalScrollbar!==uiGridConstants.scrollbars.NEVER;if(!self.grid.isRTL()){if(!self.grid.hasRightContainerColumns()){self.hasVScrollbar=self.grid.options.enableVerticalScrollbar!==uiGridConstants.scrollbars.NEVER;}}else{if(!self.grid.hasLeftContainerColumns()){self.hasVScrollbar=self.grid.options.enableVerticalScrollbar!==uiGridConstants.scrollbars.NEVER;}}}else if(self.name==='left'){self.hasVScrollbar=self.grid.isRTL()?self.grid.options.enableVerticalScrollbar!==uiGridConstants.scrollbars.NEVER:false;}else{self.hasVScrollbar=!self.grid.isRTL()?self.grid.options.enableVerticalScrollbar!==uiGridConstants.scrollbars.NEVER:false;}styles['overflow-x']=self.hasHScrollbar?scrollbarVisibility[self.grid.options.enableHorizontalScrollbar]:'hidden';styles['overflow-y']=self.hasVScrollbar?scrollbarVisibility[self.grid.options.enableVerticalScrollbar]:'hidden';return styles;};return GridRenderContainer;}]);})();(function(){angular.module('ui.grid').factory('GridRow',['gridUtil','uiGridConstants',function(gridUtil,uiGridConstants){/**
   * @class GridRow
   * @ngdoc function
   * @name ui.grid.class:GridRow
   * @description GridRow is the viewModel for one logical row on the grid.  A grid Row is not necessarily a one-to-one
   * relation to gridOptions.data.
   * @param {object} entity the array item from GridOptions.data
   * @param {number} index the current position of the row in the array
   * @param {Grid} grid reference to the parent grid
   */function GridRow(entity,index,grid){/**
      *  @ngdoc object
      *  @name grid
      *  @propertyOf  ui.grid.class:GridRow
      *  @description A reference back to the grid
      */this.grid=grid;/**
      *  @ngdoc object
      *  @name entity
      *  @propertyOf  ui.grid.class:GridRow
      *  @description A reference to an item in gridOptions.data[]
      */this.entity=entity;/**
      *  @ngdoc object
      *  @name index
      *  @propertyOf  ui.grid.class:GridRow
      *  @description The current position of the row in the array
      */this.index=index;/**
      *  @ngdoc object
      *  @name uid
      *  @propertyOf  ui.grid.class:GridRow
      *  @description  UniqueId of row
      */this.uid=gridUtil.nextUid();/**
      *  @ngdoc object
      *  @name visible
      *  @propertyOf  ui.grid.class:GridRow
      *  @description If true, the row will be rendered
      */ // Default to true
this.visible=true;/**
      *  @ngdoc object
      *  @name isSelected
      *  @propertyOf  ui.grid.class:GridRow
      *  @description Marks if the row has been selected
      */ // Default to false
this.isSelected=false;this.$$height=grid.options.rowHeight;}/**
     *  @ngdoc object
     *  @name height
     *  @propertyOf ui.grid.class:GridRow
     *  @description height of each individual row. changing the height will flag all
     *  row renderContainers to recalculate their canvas height
     */Object.defineProperty(GridRow.prototype,'height',{get:function(){return this.$$height;},set:function(height){if(height!==this.$$height){this.grid.updateCanvasHeight();this.$$height=height;}}});/**
   * @ngdoc function
   * @name getQualifiedColField
   * @methodOf ui.grid.class:GridRow
   * @description returns the qualified field name as it exists on scope
   * ie: row.entity.fieldA
   * @param {GridColumn} col column instance
   * @returns {string} resulting name that can be evaluated on scope
   */GridRow.prototype.getQualifiedColField=function(col){return'row.'+this.getEntityQualifiedColField(col);};/**
     * @ngdoc function
     * @name getEntityQualifiedColField
     * @methodOf ui.grid.class:GridRow
     * @description returns the qualified field name minus the row path
     * ie: entity.fieldA
     * @param {GridColumn} col column instance
     * @returns {string} resulting name that can be evaluated against a row
     */GridRow.prototype.getEntityQualifiedColField=function(col){var base='entity';if(col.field===uiGridConstants.ENTITY_BINDING){return base;}return gridUtil.preEval(base+'.'+col.field);};/**
   * @ngdoc function
   * @name setRowInvisible
   * @methodOf  ui.grid.class:GridRow
   * @description Sets an override on the row that forces it to always
   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
   *
   * This method can be called from the api, passing in the gridRow we want
   * altered.  It should really work by calling gridRow.setRowInvisible, but that's
   * not the way I coded it, and too late to change now.  Changed to just call
   * the internal function row.setThisRowInvisible().
   *
   * @param {GridRow} row the row we want to set to invisible
   *
   */GridRow.prototype.setRowInvisible=function(row){if(row&&row.setThisRowInvisible){row.setThisRowInvisible('user');}};/**
   * @ngdoc function
   * @name clearRowInvisible
   * @methodOf  ui.grid.class:GridRow
   * @description Clears an override on the row that forces it to always
   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
   *
   * This method can be called from the api, passing in the gridRow we want
   * altered.  It should really work by calling gridRow.clearRowInvisible, but that's
   * not the way I coded it, and too late to change now.  Changed to just call
   * the internal function row.clearThisRowInvisible().
   *
   * @param {GridRow} row the row we want to clear the invisible flag
   *
   */GridRow.prototype.clearRowInvisible=function(row){if(row&&row.clearThisRowInvisible){row.clearThisRowInvisible('user');}};/**
   * @ngdoc function
   * @name setThisRowInvisible
   * @methodOf  ui.grid.class:GridRow
   * @description Sets an override on the row that forces it to always
   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility
   *
   * @param {string} reason the reason (usually the module) for the row to be invisible.
   * E.g. grouping, user, filter
   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
   */GridRow.prototype.setThisRowInvisible=function(reason,fromRowsProcessor){if(!this.invisibleReason){this.invisibleReason={};}this.invisibleReason[reason]=true;this.evaluateRowVisibility(fromRowsProcessor);};/**
   * @ngdoc function
   * @name clearRowInvisible
   * @methodOf ui.grid.class:GridRow
   * @description Clears any override on the row visibility, returning it
   * to normal visibility calculations.  Emits the rowsVisibleChanged
   * event
   *
   * @param {string} reason the reason (usually the module) for the row to be invisible.
   * E.g. grouping, user, filter
   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
   */GridRow.prototype.clearThisRowInvisible=function(reason,fromRowsProcessor){if(typeof this.invisibleReason!=='undefined'){delete this.invisibleReason[reason];}this.evaluateRowVisibility(fromRowsProcessor);};/**
   * @ngdoc function
   * @name evaluateRowVisibility
   * @methodOf ui.grid.class:GridRow
   * @description Determines whether the row should be visible based on invisibleReason,
   * and if it changes the row visibility, then emits the rowsVisibleChanged event.
   *
   * Queues a grid refresh, but doesn't call it directly to avoid hitting lots of grid refreshes.
   * @param {boolean} fromRowProcessor if true, then it won't raise events or queue the refresh, the
   * row processor does that already
   */GridRow.prototype.evaluateRowVisibility=function(fromRowProcessor){var newVisibility=true;if(typeof this.invisibleReason!=='undefined'){angular.forEach(this.invisibleReason,function(value,key){if(value){newVisibility=false;}});}if(typeof this.visible==='undefined'||this.visible!==newVisibility){this.visible=newVisibility;if(!fromRowProcessor){this.grid.queueGridRefresh();this.grid.api.core.raise.rowsVisibleChanged(this);}}};return GridRow;}]);})();(function(){'use strict';/**
   * @ngdoc object
   * @name ui.grid.class:GridRowColumn
   * @param {GridRow} row The row for this pair
   * @param {GridColumn} column The column for this pair
   * @description A row and column pair that represents the intersection of these two entities.
   * Must be instantiated as a constructor using the `new` keyword.
   */angular.module('ui.grid').factory('GridRowColumn',['$parse','$filter',function GridRowColumnFactory($parse,$filter){var GridRowColumn=function GridRowColumn(row,col){if(!(this instanceof GridRowColumn)){throw"Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";}/**
         * @ngdoc object
         * @name row
         * @propertyOf ui.grid.class:GridRowColumn
         * @description {@link ui.grid.class:GridRow }
         */this.row=row;/**
         * @ngdoc object
         * @name col
         * @propertyOf ui.grid.class:GridRowColumn
         * @description {@link ui.grid.class:GridColumn }
         */this.col=col;};/**
       * @ngdoc function
       * @name getIntersectionValueRaw
       * @methodOf ui.grid.class:GridRowColumn
       * @description Gets the intersection of where the row and column meet.
       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
       *          If the column has a cellFilter this will NOT return the filtered value.
       */GridRowColumn.prototype.getIntersectionValueRaw=function(){var getter=$parse(this.row.getEntityQualifiedColField(this.col));var context=this.row;return getter(context);};return GridRowColumn;}]);})();(function(){angular.module('ui.grid').factory('ScrollEvent',['gridUtil',function(gridUtil){/**
       * @ngdoc function
       * @name ui.grid.class:ScrollEvent
       * @description Model for all scrollEvents
       * @param {Grid} grid that owns the scroll event
       * @param {GridRenderContainer} sourceRowContainer that owns the scroll event. Can be null
       * @param {GridRenderContainer} sourceColContainer that owns the scroll event. Can be null
       * @param {string} source the source of the event - from uiGridConstants.scrollEventSources or a string value of directive/service/factory.functionName
       */function ScrollEvent(grid,sourceRowContainer,sourceColContainer,source){var self=this;if(!grid){throw new Error("grid argument is required");}/**
         *  @ngdoc object
         *  @name grid
         *  @propertyOf  ui.grid.class:ScrollEvent
         *  @description A reference back to the grid
         */self.grid=grid;/**
         *  @ngdoc object
         *  @name source
         *  @propertyOf  ui.grid.class:ScrollEvent
         *  @description the source of the scroll event. limited to values from uiGridConstants.scrollEventSources
         */self.source=source;/**
         *  @ngdoc object
         *  @name noDelay
         *  @propertyOf  ui.grid.class:ScrollEvent
         *  @description most scroll events from the mouse or trackpad require delay to operate properly
         *  set to false to eliminate delay.  Useful for scroll events that the grid causes, such as scrolling to make a row visible.
         */self.withDelay=true;self.sourceRowContainer=sourceRowContainer;self.sourceColContainer=sourceColContainer;self.newScrollLeft=null;self.newScrollTop=null;self.x=null;self.y=null;self.verticalScrollLength=-9999999;self.horizontalScrollLength=-999999;self.type='scroll';/**
         *  @ngdoc function
         *  @name fireThrottledScrollingEvent
         *  @methodOf  ui.grid.class:ScrollEvent
         *  @description fires a throttled event using grid.api.core.raise.scrollEvent
         */self.fireThrottledScrollingEvent=gridUtil.throttle(function(sourceContainerId){self.grid.scrollContainers(sourceContainerId,self);},self.grid.options.wheelScrollThrottle,{trailing:true});}/**
       *  @ngdoc function
       *  @name getNewScrollLeft
       *  @methodOf  ui.grid.class:ScrollEvent
       *  @description returns newScrollLeft property if available; calculates a new value if it isn't
       */ScrollEvent.prototype.getNewScrollLeft=function(colContainer,viewport){var self=this;if(!self.newScrollLeft){var scrollWidth=colContainer.getCanvasWidth()-colContainer.getViewportWidth();var oldScrollLeft=gridUtil.normalizeScrollLeft(viewport,self.grid);var scrollXPercentage;if(typeof self.x.percentage!=='undefined'&&self.x.percentage!==undefined){scrollXPercentage=self.x.percentage;}else if(typeof self.x.pixels!=='undefined'&&self.x.pixels!==undefined){scrollXPercentage=self.x.percentage=(oldScrollLeft+self.x.pixels)/scrollWidth;}else{throw new Error("No percentage or pixel value provided for scroll event X axis");}return Math.max(0,scrollXPercentage*scrollWidth);}return self.newScrollLeft;};/**
       *  @ngdoc function
       *  @name getNewScrollTop
       *  @methodOf  ui.grid.class:ScrollEvent
       *  @description returns newScrollTop property if available; calculates a new value if it isn't
       */ScrollEvent.prototype.getNewScrollTop=function(rowContainer,viewport){var self=this;if(!self.newScrollTop){var scrollLength=rowContainer.getVerticalScrollLength();var oldScrollTop=viewport[0].scrollTop;var scrollYPercentage;if(typeof self.y.percentage!=='undefined'&&self.y.percentage!==undefined){scrollYPercentage=self.y.percentage;}else if(typeof self.y.pixels!=='undefined'&&self.y.pixels!==undefined){scrollYPercentage=self.y.percentage=(oldScrollTop+self.y.pixels)/scrollLength;}else{throw new Error("No percentage or pixel value provided for scroll event Y axis");}return Math.max(0,scrollYPercentage*scrollLength);}return self.newScrollTop;};ScrollEvent.prototype.atTop=function(scrollTop){return this.y&&(this.y.percentage===0||this.verticalScrollLength<0)&&scrollTop===0;};ScrollEvent.prototype.atBottom=function(scrollTop){return this.y&&(this.y.percentage===1||this.verticalScrollLength===0)&&scrollTop>0;};ScrollEvent.prototype.atLeft=function(scrollLeft){return this.x&&(this.x.percentage===0||this.horizontalScrollLength<0)&&scrollLeft===0;};ScrollEvent.prototype.atRight=function(scrollLeft){return this.x&&(this.x.percentage===1||this.horizontalScrollLength===0)&&scrollLeft>0;};ScrollEvent.Sources={ViewPortScroll:'ViewPortScroll',RenderContainerMouseWheel:'RenderContainerMouseWheel',RenderContainerTouchMove:'RenderContainerTouchMove',Other:99};return ScrollEvent;}]);})();(function(){'use strict';/**
   *  @ngdoc object
   *  @name ui.grid.service:gridClassFactory
   *
   *  @description factory to return dom specific instances of a grid
   *
   */angular.module('ui.grid').service('gridClassFactory',['gridUtil','$q','$compile','$templateCache','uiGridConstants','Grid','GridColumn','GridRow',function(gridUtil,$q,$compile,$templateCache,uiGridConstants,Grid,GridColumn,GridRow){var service={/**
         * @ngdoc method
         * @name createGrid
         * @methodOf ui.grid.service:gridClassFactory
         * @description Creates a new grid instance. Each instance will have a unique id
         * @param {object} options An object map of options to pass into the created grid instance.
         * @returns {Grid} grid
         */createGrid:function(options){options=typeof options!=='undefined'?options:{};options.id=gridUtil.newId();var grid=new Grid(options);// NOTE/TODO: rowTemplate should always be defined...
if(grid.options.rowTemplate){var rowTemplateFnPromise=$q.defer();grid.getRowTemplateFn=rowTemplateFnPromise.promise;gridUtil.getTemplate(grid.options.rowTemplate).then(function(template){var rowTemplateFn=$compile(template);rowTemplateFnPromise.resolve(rowTemplateFn);},function(){// Todo handle response error here?
throw new Error("Couldn't fetch/use row template '"+grid.options.rowTemplate+"'");}).catch(angular.noop);}grid.registerColumnBuilder(service.defaultColumnBuilder);// Row builder for custom row templates
grid.registerRowBuilder(service.rowTemplateAssigner);// Reset all rows to visible initially
grid.registerRowsProcessor(function allRowsVisible(rows){rows.forEach(function(row){row.evaluateRowVisibility(true);});return rows;},50);grid.registerColumnsProcessor(function applyColumnVisibility(columns){columns.forEach(function(column){column.visible=angular.isDefined(column.colDef.visible)?column.colDef.visible:true;});return columns;},50);grid.registerRowsProcessor(grid.searchRows,100);// Register the default row processor, it sorts rows by selected columns
if(grid.options.externalSort&&angular.isFunction(grid.options.externalSort)){grid.registerRowsProcessor(grid.options.externalSort,200);}else{grid.registerRowsProcessor(grid.sortByColumn,200);}return grid;},/**
         * @ngdoc function
         * @name defaultColumnBuilder
         * @methodOf ui.grid.service:gridClassFactory
         * @description Processes designTime column definitions and applies them to col for the
         *              core grid features
         * @param {object} colDef reference to column definition
         * @param {GridColumn} col reference to gridCol
         * @param {object} gridOptions reference to grid options
         */defaultColumnBuilder:function(colDef,col,gridOptions){var templateGetPromises=[];// Abstracts the standard template processing we do for every template type.
var processTemplate=function(templateType,providedType,defaultTemplate,filterType,tooltipType){if(!colDef[templateType]){col[providedType]=defaultTemplate;}else{col[providedType]=colDef[templateType];}var templatePromise=gridUtil.getTemplate(col[providedType]).then(function(template){if(angular.isFunction(template)){template=template();}var tooltipCall=tooltipType==='cellTooltip'?'col.cellTooltip(row,col)':'col.headerTooltip(col)';if(tooltipType&&col[tooltipType]===false){template=template.replace(uiGridConstants.TOOLTIP,'');}else if(tooltipType&&col[tooltipType]){template=template.replace(uiGridConstants.TOOLTIP,'title="{{'+tooltipCall+' CUSTOM_FILTERS }}"');}if(filterType){template=template.replace(uiGridConstants.CUSTOM_FILTERS,function(){return col[filterType]?"|"+col[filterType]:"";});}return gridUtil.postProcessTemplate(template).then(function(template){col[templateType]=template;});},function(){throw new Error("Couldn't fetch/use colDef."+templateType+" '"+colDef[templateType]+"'");}).catch(angular.noop);templateGetPromises.push(templatePromise);return templatePromise;};/**
           * @ngdoc property
           * @name cellTemplate
           * @propertyOf ui.grid.class:GridOptions.columnDef
           * @description a custom template for each cell in this column.  The default
           * is ui-grid/uiGridCell.  If you are using the cellNav feature, this template
           * must contain a div that can receive focus.
           *
           */col.cellTemplatePromise=processTemplate('cellTemplate','providedCellTemplate','ui-grid/uiGridCell','cellFilter','cellTooltip');/**
           * @ngdoc property
           * @name headerCellTemplate
           * @propertyOf ui.grid.class:GridOptions.columnDef
           * @description a custom template for the header for this column.  The default
           * is ui-grid/uiGridHeaderCell
           *
           */col.headerCellTemplatePromise=processTemplate('headerCellTemplate','providedHeaderCellTemplate','ui-grid/uiGridHeaderCell','headerCellFilter','headerTooltip');/**
           * @ngdoc property
           * @name footerCellTemplate
           * @propertyOf ui.grid.class:GridOptions.columnDef
           * @description a custom template for the footer for this column.  The default
           * is ui-grid/uiGridFooterCell
           *
           */col.footerCellTemplatePromise=processTemplate('footerCellTemplate','providedFooterCellTemplate','ui-grid/uiGridFooterCell','footerCellFilter');/**
           * @ngdoc property
           * @name filterHeaderTemplate
           * @propertyOf ui.grid.class:GridOptions.columnDef
           * @description a custom template for the filter input.  The default is ui-grid/ui-grid-filter
           *
           */col.filterHeaderTemplatePromise=processTemplate('filterHeaderTemplate','providedFilterHeaderTemplate','ui-grid/ui-grid-filter');// Create a promise for the compiled element function
col.compiledElementFnDefer=$q.defer();return $q.all(templateGetPromises);},rowTemplateAssigner:function rowTemplateAssigner(row){var grid=this;// Row has no template assigned to it
if(!row.rowTemplate){// Use the default row template from the grid
row.rowTemplate=grid.options.rowTemplate;// Use the grid's function for fetching the compiled row template function
row.getRowTemplateFn=grid.getRowTemplateFn;}// Row has its own template assigned
else{// Create a promise for the compiled row template function
var perRowTemplateFnPromise=$q.defer();row.getRowTemplateFn=perRowTemplateFnPromise.promise;// Get the row template
gridUtil.getTemplate(row.rowTemplate).then(function(template){// Compile the template
var rowTemplateFn=$compile(template);// Resolve the compiled template function promise
perRowTemplateFnPromise.resolve(rowTemplateFn);},function(){// Todo handle response error here?
throw new Error("Couldn't fetch/use row template '"+row.rowTemplate+"'");});}return row.getRowTemplateFn;}};// class definitions (moved to separate factories)
return service;}]);})();(function(){var module=angular.module('ui.grid');function escapeRegExp(str){// based on https://github.com/sindresorhus/escape-string-regexp
// Escape characters with special meaning either inside or outside character sets.
// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
return str.replace(/[|\\{}()[\]^$+?*.]/g,'\\$&').replace(/-/g,'\\x2d');}/**
 *  @ngdoc service
 *  @name ui.grid.service:rowSearcher
 *
 *  @description Service for searching/filtering rows based on column value conditions.
 */module.service('rowSearcher',['gridUtil','uiGridConstants',function(gridUtil,uiGridConstants){var defaultCondition=uiGridConstants.filter.CONTAINS;var rowSearcher={};/**
   * @ngdoc function
   * @name getTerm
   * @methodOf ui.grid.service:rowSearcher
   * @description Get the term from a filter
   * Trims leading and trailing whitespace
   * @param {object} filter object to use
   * @returns {object} Parsed term
   */rowSearcher.getTerm=function getTerm(filter){if(typeof filter.term==='undefined'){return filter.term;}var term=filter.term;// Strip leading and trailing whitespace if the term is a string
if(typeof term==='string'){term=term.trim();}return term;};/**
   * @ngdoc function
   * @name stripTerm
   * @methodOf ui.grid.service:rowSearcher
   * @description Remove leading and trailing asterisk (*) from the filter's term
   * @param {object} filter object to use
   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
   */rowSearcher.stripTerm=function stripTerm(filter){var term=rowSearcher.getTerm(filter);if(typeof term==='string'){return escapeRegExp(term.replace(/(^\*|\*$)/g,''));}else{return term;}};/**
   * @ngdoc function
   * @name guessCondition
   * @methodOf ui.grid.service:rowSearcher
   * @description Guess the condition for a filter based on its term
   * <br>
   * Defaults to STARTS_WITH. Uses CONTAINS for strings beginning and ending with *s (*bob*).
   * Uses STARTS_WITH for strings ending with * (bo*). Uses ENDS_WITH for strings starting with * (*ob).
   * @param {object} filter object to use
   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
   */rowSearcher.guessCondition=function guessCondition(filter){if(typeof filter.term==='undefined'||!filter.term){return defaultCondition;}var term=rowSearcher.getTerm(filter);if(/\*/.test(term)){// this would check only start and end -> /^\*|\*$/
var regexpFlags=!filter.flags||!filter.flags.caseSensitive?'i':'';term=escapeRegExp(term);var reText=term.replace(/\\\*/g,'.*?');// this would check only start and end -> /^\\\*|\\\*$/g
return new RegExp('^'+reText+'$',regexpFlags);}// Otherwise default to default condition
else{return defaultCondition;}};/**
   * @ngdoc function
   * @name setupFilters
   * @methodOf ui.grid.service:rowSearcher
   * @description For a given columns filters (either col.filters, or [col.filter] can be passed in),
   * do all the parsing and pre-processing and store that data into a new filters object.  The object
   * has the condition, the flags, the stripped term, and a parsed reg exp if there was one.
   *
   * We could use a forEach in here, since it's much less performance sensitive, but since we're using
   * for loops everywhere else in this module...
   *
   * @param {array} filters the filters from the column (col.filters or [col.filter])
   * @returns {array} An array of parsed/preprocessed filters
   */rowSearcher.setupFilters=function setupFilters(filters){var newFilters=[];for(var i=0;i<filters.length;i++){var filter=filters[i];if(filter.noTerm||!gridUtil.isNullOrUndefined(filter.term)){var newFilter={};var regexpFlags='';if(!filter.flags||!filter.flags.caseSensitive){regexpFlags+='i';}if(!gridUtil.isNullOrUndefined(filter.term)){// it is possible to have noTerm.
if(filter.rawTerm){newFilter.term=filter.term;}else{newFilter.term=rowSearcher.stripTerm(filter);}}newFilter.noTerm=filter.noTerm;newFilter.condition=filter.condition||rowSearcher.guessCondition(filter);newFilter.flags=angular.extend({caseSensitive:false,date:false},filter.flags);switch(newFilter.condition){case uiGridConstants.filter.STARTS_WITH:newFilter.startswithRE=new RegExp('^'+newFilter.term,regexpFlags);break;case uiGridConstants.filter.ENDS_WITH:newFilter.endswithRE=new RegExp(newFilter.term+'$',regexpFlags);break;case uiGridConstants.filter.EXACT:newFilter.exactRE=new RegExp('^'+newFilter.term+'$',regexpFlags);break;case uiGridConstants.filter.CONTAINS:newFilter.containsRE=new RegExp(newFilter.term,regexpFlags);break;}newFilters.push(newFilter);}}return newFilters;};/**
   * @ngdoc function
   * @name runColumnFilter
   * @methodOf ui.grid.service:rowSearcher
   * @description Runs a single pre-parsed filter against a cell, returning true
   * if the cell matches that one filter.
   *
   * @param {Grid} grid the grid we're working against
   * @param {GridRow} row the row we're matching against
   * @param {GridColumn} column the column that we're working against
   * @param {object} filter the specific, preparsed, filter that we want to test
   * @returns {boolean} true if we match (row stays visible)
   */rowSearcher.runColumnFilter=function runColumnFilter(grid,row,column,filter){// Cache typeof condition
var conditionType=typeof filter.condition;// Term to search for.
var term=filter.term;// Get the column value for this row
var value=column.filterCellFiltered?grid.getCellDisplayValue(row,column):grid.getCellValue(row,column);if(value==void 0){value="";}// If the filter's condition is a RegExp, then use it
if(filter.condition instanceof RegExp){return filter.condition.test(value);}// If the filter's condition is a function, run it
if(conditionType==='function'){return filter.condition(term,value,row,column);}if(filter.startswithRE){return filter.startswithRE.test(value);}if(filter.endswithRE){return filter.endswithRE.test(value);}if(filter.containsRE){return filter.containsRE.test(value);}if(filter.exactRE){return filter.exactRE.test(value);}if(filter.condition===uiGridConstants.filter.NOT_EQUAL){return!new RegExp('^'+term+'$').test(value);}if(typeof value==='number'&&typeof term==='string'){// if the term has a decimal in it, it comes through as '9\.4', we need to take out the \
// the same for negative numbers
// TODO: I suspect the right answer is to look at escapeRegExp at the top of this code file, maybe it's not needed?
var tempFloat=parseFloat(term.replace(/\\\./,'.').replace(/\\\-/,'-'));if(!isNaN(tempFloat)){term=tempFloat;}}if(filter.flags.date===true){value=new Date(value);// If the term has a dash in it, it comes through as '\-' -- we need to take out the '\'.
term=new Date(term.replace(/\\/g,''));}switch(filter.condition){case uiGridConstants.filter.GREATER_THAN:return value>term;case uiGridConstants.filter.GREATER_THAN_OR_EQUAL:return value>=term;case uiGridConstants.filter.LESS_THAN:return value<term;case uiGridConstants.filter.LESS_THAN_OR_EQUAL:return value<=term;}return true;};/**
   * @ngdoc boolean
   * @name useExternalFiltering
   * @propertyOf ui.grid.class:GridOptions
   * @description False by default. When enabled, this setting suppresses the internal filtering.
   * All UI logic will still operate, allowing filter conditions to be set and modified.
   *
   * The external filter logic can listen for the `filterChange` event, which fires whenever
   * a filter has been adjusted.
   */ /**
   * @ngdoc function
   * @name searchColumn
   * @methodOf ui.grid.service:rowSearcher
   * @description Process provided filters on provided column against a given row. If the row meets
   * the conditions on all the filters, return true.
   * @param {Grid} grid Grid to search in
   * @param {GridRow} row Row to search on
   * @param {GridColumn} column Column with the filters to use
   * @param {array} filters array of pre-parsed/preprocessed filters to apply
   * @returns {boolean} Whether the column matches or not.
   */rowSearcher.searchColumn=function searchColumn(grid,row,column,filters){if(grid.options.useExternalFiltering){return true;}for(var i=0;i<filters.length;i++){var filter=filters[i];if(!gridUtil.isNullOrUndefined(filter.term)&&filter.term!==''||filter.noTerm){if(!rowSearcher.runColumnFilter(grid,row,column,filter)){return false;}}}return true;};/**
   * @ngdoc function
   * @name search
   * @methodOf ui.grid.service:rowSearcher
   * @description Run a search across the given rows and columns, marking any rows that don't
   * match the stored col.filters or col.filter as invisible.
   * @param {Grid} grid Grid instance to search inside
   * @param {Array[GridRow]} rows GridRows to filter
   * @param {Array[GridColumn]} columns GridColumns with filters to process
   */rowSearcher.search=function search(grid,rows,columns){/*
     * Added performance optimisations into this code base, as this logic creates deeply nested
     * loops and is therefore very performance sensitive.  In particular, avoiding forEach as
     * this impacts some browser optimisers (particularly Chrome), using iterators instead
     */ // Don't do anything if we weren't passed any rows
if(!rows){return;}// don't filter if filtering currently disabled
if(!grid.options.enableFiltering){return rows;}// Build list of filters to apply
var filterData=[];var hasTerm=function(filters){var hasTerm=false;filters.forEach(function(filter){if(!gridUtil.isNullOrUndefined(filter.term)&&filter.term!==''||filter.noTerm){hasTerm=true;}});return hasTerm;};for(var i=0;i<columns.length;i++){var col=columns[i];if(typeof col.filters!=='undefined'&&hasTerm(col.filters)){filterData.push({col:col,filters:rowSearcher.setupFilters(col.filters)});}}if(filterData.length>0){// define functions outside the loop, performance optimisation
var foreachRow=function(grid,row,col,filters){if(row.visible&&!rowSearcher.searchColumn(grid,row,col,filters)){row.visible=false;}};var foreachFilterCol=function(grid,filterData){for(var i=0;i<rows.length;i++){foreachRow(grid,rows[i],filterData.col,filterData.filters);}};// nested loop itself - foreachFilterCol, which in turn calls foreachRow
for(var j=0;j<filterData.length;j++){foreachFilterCol(grid,filterData[j]);}if(grid.api.core.raise.rowsVisibleChanged){grid.api.core.raise.rowsVisibleChanged();}// drop any invisible rows
// keeping these, as needed with filtering for trees - we have to come back and make parent nodes visible if child nodes are selected in the filter
// rows = rows.filter(function(row) { return row.visible; });
}return rows;};return rowSearcher;}]);})();(function(){var module=angular.module('ui.grid');/**
 * @ngdoc object
 * @name ui.grid.class:rowSorter
 * @description rowSorter provides the default sorting mechanisms,
 * including guessing column types and applying appropriate sort
 * algorithms
 *
 */module.service('rowSorter',['uiGridConstants',function(uiGridConstants){var rowSorter={// Cache of sorting functions. Once we create them, we don't want to keep re-doing it
//   this takes a piece of data from the cell and tries to determine its type and what sorting
//   function to use for it
colSortFnCache:{}};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name guessSortFn
   * @description Assigns a sort function to use based on the itemType in the column
   * @param {string} itemType one of 'number', 'boolean', 'string', 'date', 'object'.  And
   * error will be thrown for any other type.
   * @returns {function} a sort function that will sort that type
   */rowSorter.guessSortFn=function guessSortFn(itemType){switch(itemType){case"number":return rowSorter.sortNumber;case"numberStr":return rowSorter.sortNumberStr;case"boolean":return rowSorter.sortBool;case"string":return rowSorter.sortAlpha;case"date":return rowSorter.sortDate;case"object":return rowSorter.basicSort;default:throw new Error('No sorting function found for type: '+itemType);}};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name handleNulls
   * @description Sorts nulls and undefined to the bottom (top when
   * descending).  Called by each of the internal sorters before
   * attempting to sort.  Note that this method is available on the core api
   * via gridApi.core.sortHandleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} null if there were no nulls/undefineds, otherwise returns
   * a sort value that should be passed back from the sort function
   */rowSorter.handleNulls=function handleNulls(a,b){// We want to allow zero values and false values to be evaluated in the sort function
if(a==void 0||b==void 0){// We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
if(a==void 0&&b==void 0){return 0;}if(a==void 0){return 1;}return-1;// b == void 0
}return null;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name basicSort
   * @description Sorts any values that provide the < method, including strings
   * or numbers.  Handles nulls and undefined through calling handleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.basicSort=function basicSort(a,b){var nulls=rowSorter.handleNulls(a,b);if(nulls!==null){return nulls;}if(a===b){return 0;}if(a<b){return-1;}return 1;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sortNumber
   * @description Sorts numerical values.  Handles nulls and undefined through calling handleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.sortNumber=function sortNumber(a,b){var nulls=rowSorter.handleNulls(a,b);return nulls!==null?nulls:a-b;};function parseNumStr(numStr){if(/^\s*-?Infinity\s*$/.test(numStr)){// check for positive or negative Infinity and return that
return parseFloat(numStr);}return parseFloat(numStr.replace(/[^0-9.eE-]/g,''));}/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sortNumberStr
   * @description Sorts numerical values that are stored in a string (i.e. parses them to numbers first).
   * Handles nulls and undefined through calling handleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.sortNumberStr=function sortNumberStr(a,b){var nulls=rowSorter.handleNulls(a,b);if(nulls!==null){return nulls;}var numA=parseNumStr(a),// The parsed number form of 'a'
numB=parseNumStr(b);// The parsed number form of 'b'
// If 'a' couldn't be parsed to float, flag it as bad
var badA=isNaN(numA),badB=isNaN(numB);// We want bad ones to get pushed to the bottom... which effectively is "greater than"
if(badA||badB){return badA&&badB?0:badA?1:-1;}return numA-numB;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sortAlpha
   * @description Sorts string values. Handles nulls and undefined through calling handleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.sortAlpha=function sortAlpha(a,b){var nulls=rowSorter.handleNulls(a,b);if(nulls!==null){return nulls;}var strA=a.toString().toLowerCase(),strB=b.toString().toLowerCase();return strA===strB?0:strA.localeCompare(strB);};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sortDate
   * @description Sorts date values. Handles nulls and undefined through calling handleNulls.
   * Handles date strings by converting to Date object if not already an instance of Date
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.sortDate=function sortDate(a,b){var nulls=rowSorter.handleNulls(a,b);if(nulls!==null){return nulls;}var timeA=a instanceof Date?a.getTime():new Date(a).getTime();var timeB=b instanceof Date?b.getTime():new Date(b).getTime();return timeA===timeB?0:timeA<timeB?-1:1;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sortBool
   * @description Sorts boolean values, true is considered larger than false.
   * Handles nulls and undefined through calling handleNulls
   * @param {object} a sort value a
   * @param {object} b sort value b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.sortBool=function sortBool(a,b){var nulls=rowSorter.handleNulls(a,b);if(nulls!==null){return nulls;}if(a&&b||!a&&!b){return 0;}return a?1:-1;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name getSortFn
   * @description Get the sort function for the column.  Looks first in
   * rowSorter.colSortFnCache using the column name, failing that it
   * looks at col.sortingAlgorithm (and puts it in the cache), failing that
   * it guesses the sort algorithm based on the data type.
   *
   * The cache currently seems a bit pointless, as none of the work we do is
   * processor intensive enough to need caching.  Presumably in future we might
   * inspect the row data itself to guess the sort function, and in that case
   * it would make sense to have a cache, the infrastructure is in place to allow
   * that.
   *
   * @param {Grid} grid the grid to consider
   * @param {GridColumn} col the column to find a function for
   * @param {array} rows an array of grid rows.  Currently unused, but presumably in future
   * we might inspect the rows themselves to decide what sort of data might be there
   * @returns {function} the sort function chosen for the column
   */rowSorter.getSortFn=function getSortFn(col){// See if we already figured out what to use to sort the column and have it in the cache
if(rowSorter.colSortFnCache[col.colDef.name]){return rowSorter.colSortFnCache[col.colDef.name];}// If the column has its OWN sorting algorithm, use that
if(col.sortingAlgorithm!=void 0){rowSorter.colSortFnCache[col.colDef.name]=col.sortingAlgorithm;return col.sortingAlgorithm;}// Always default to sortAlpha when sorting after a cellFilter
if(col.sortCellFiltered&&col.cellFilter){rowSorter.colSortFnCache[col.colDef.name]=rowSorter.sortAlpha;return rowSorter.sortAlpha;}// Try and guess what sort function to use
// Guess the sort function
var sortFn=rowSorter.guessSortFn(col.colDef.type);// If we found a sort function, cache it
if(sortFn){rowSorter.colSortFnCache[col.colDef.name]=sortFn;return sortFn;}// We assign the alpha sort because anything that is null/undefined will never get passed to
// the actual sorting function. It will get caught in our null check and returned to be sorted
// down to the bottom
return rowSorter.sortAlpha;};/**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name prioritySort
   * @description Used where multiple columns are present in the sort criteria,
   * we determine which column should take precedence in the sort by sorting
   * the columns based on their sort.priority
   *
   * @param {gridColumn} a column a
   * @param {gridColumn} b column b
   * @returns {number} normal sort function, returns -ve, 0, +ve
   */rowSorter.prioritySort=function(a,b){// Both columns have a sort priority
if(a.sort&&a.sort.priority!==undefined&&b.sort&&b.sort.priority!==undefined){// A is higher priority
if(a.sort.priority<b.sort.priority){return-1;}// Equal
if(a.sort.priority===b.sort.priority){return 0;}// B is higher
return 1;}// Only A has a priority
if(a.sort&&a.sort.priority!==undefined){return-1;}// Only B has a priority
if(b.sort&&b.sort.priority!==undefined){return 1;}// Neither has a priority
return 0;};/**
   * @ngdoc object
   * @name useExternalSorting
   * @propertyOf ui.grid.class:GridOptions
   * @description Prevents the internal sorting from executing.  Events will
   * still be fired when the sort changes, and the sort information on
   * the columns will be updated, allowing an external sorter (for example,
   * server sorting) to be implemented.  Defaults to false.
   *
   */ /**
   * @ngdoc method
   * @methodOf ui.grid.class:rowSorter
   * @name sort
   * @description sorts the grid
   * @param {Object} grid the grid itself
   * @param {array} rows the rows to be sorted
   * @param {array} columns the columns in which to look
   * for sort criteria
   * @returns {array} sorted rows
   */rowSorter.sort=function rowSorterSort(grid,rows,columns){// first make sure we are even supposed to do work
if(!rows){return;}if(grid.options.useExternalSorting){return rows;}// Build the list of columns to sort by
var sortCols=[];var defaultSortCols=[];columns.forEach(function(col){if(col.sort&&!col.sort.ignoreSort&&col.sort.direction&&(col.sort.direction===uiGridConstants.ASC||col.sort.direction===uiGridConstants.DESC)){sortCols.push({col:col,sort:col.sort});}else if(col.defaultSort&&col.defaultSort.direction&&(col.defaultSort.direction===uiGridConstants.ASC||col.defaultSort.direction===uiGridConstants.DESC)){defaultSortCols.push({col:col,sort:col.defaultSort});}});// Sort the "sort columns" by their sort priority
sortCols=sortCols.sort(rowSorter.prioritySort);defaultSortCols=defaultSortCols.sort(rowSorter.prioritySort);sortCols=sortCols.concat(defaultSortCols);// Now rows to sort by, maintain original order
if(sortCols.length===0){return rows;}// Re-usable variables
var col,direction;// put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
rows.forEach(function(row,idx){row.entity.$$uiGridIndex=idx;});// Now actually sort the data
var rowSortFn=function(rowA,rowB){var tem=0,idx=0,sortFn;while(tem===0&&idx<sortCols.length){// grab the metadata for the rest of the logic
col=sortCols[idx].col;direction=sortCols[idx].sort.direction;sortFn=rowSorter.getSortFn(col);// Webpack's compress will hoist and combine propA, propB into one var and break sorting functionality
// Wrapping in function prevents that unexpected behavior
var props=getCellValues(grid,rowA,rowB,col);tem=sortFn(props[0],props[1],rowA,rowB,direction,col);idx++;}// Chrome doesn't implement a stable sort function.  If our sort returns 0
// (i.e. the items are equal), and we're at the last sort column in the list,
// then return the previous order using our custom
// index variable
if(tem===0){return rowA.entity.$$uiGridIndex-rowB.entity.$$uiGridIndex;}// Made it this far, we don't have to worry about null & undefined
return direction===uiGridConstants.ASC?tem:0-tem;};var newRows=rows.sort(rowSortFn);// remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
rows.forEach(function(row,idx){delete row.entity.$$uiGridIndex;});return newRows;};function getCellValues(grid,rowA,rowB,col){var propA,propB;if(col.sortCellFiltered){propA=grid.getCellDisplayValue(rowA,col);propB=grid.getCellDisplayValue(rowB,col);}else{propA=grid.getCellValue(rowA,col);propB=grid.getCellValue(rowB,col);}return[propA,propB];}return rowSorter;}]);})();(function(){var module=angular.module('ui.grid');var bindPolyfill;if(typeof Function.prototype.bind!=="function"){bindPolyfill=function(){var slice=Array.prototype.slice;return function(context){var fn=this,args=slice.call(arguments,1);if(args.length){return function(){return arguments.length?fn.apply(context,args.concat(slice.call(arguments))):fn.apply(context,args);};}return function(){return arguments.length?fn.apply(context,arguments):fn.call(context);};};};}function getStyles(elem){var e=elem;if(typeof e.length!=='undefined'&&e.length){e=elem[0];}return e.ownerDocument.defaultView.getComputedStyle(e,null);}var rnumnonpx=new RegExp("^("+/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source+")(?!px)[a-z%]+$","i"),// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
rdisplayswap=/^(block|none|table(?!-c[ea]).+)/,cssShow={position:"absolute",visibility:"hidden",display:"block"};function augmentWidthOrHeight(elem,name,extra,isBorderBox,styles){var i=extra===(isBorderBox?'border':'content')?// If we already have the right measurement, avoid augmentation
4:// Otherwise initialize for horizontal or vertical properties
name==='width'?1:0,val=0;var sides=['Top','Right','Bottom','Left'];for(;i<4;i+=2){var side=sides[i];// dump('side', side);
// both box models exclude margin, so add it if we want it
if(extra==='margin'){var marg=parseFloat(styles[extra+side]);if(!isNaN(marg)){val+=marg;}}// dump('val1', val);
if(isBorderBox){// border-box includes padding, so remove it if we want content
if(extra==='content'){var padd=parseFloat(styles['padding'+side]);if(!isNaN(padd)){val-=padd;// dump('val2', val);
}}// at this point, extra isn't border nor margin, so remove border
if(extra!=='margin'){var bordermarg=parseFloat(styles['border'+side+'Width']);if(!isNaN(bordermarg)){val-=bordermarg;// dump('val3', val);
}}}else{// at this point, extra isn't content, so add padding
var nocontentPad=parseFloat(styles['padding'+side]);if(!isNaN(nocontentPad)){val+=nocontentPad;// dump('val4', val);
}// at this point, extra isn't content nor padding, so add border
if(extra!=='padding'){var nocontentnopad=parseFloat(styles['border'+side+'Width']);if(!isNaN(nocontentnopad)){val+=nocontentnopad;// dump('val5', val);
}}}}// dump('augVal', val);
return val;}function getWidthOrHeight(elem,name,extra){// Start with offset property, which is equivalent to the border-box value
var valueIsBorderBox=true,val,// = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
styles=getStyles(elem),isBorderBox=styles['boxSizing']==='border-box';// some non-html elements return undefined for offsetWidth, so check for null/undefined
// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
if(val<=0||val==null){// Fall back to computed then uncomputed css if necessary
val=styles[name];if(val<0||val==null){val=elem.style[name];}// Computed unit is not pixels. Stop here and return.
if(rnumnonpx.test(val)){return val;}// we need the check for style in case a browser which returns unreliable values
// for getComputedStyle silently falls back to the reliable elem.style
valueIsBorderBox=isBorderBox&&(true||val===elem.style[name]);// use 'true' instead of 'support.boxSizingReliable()'
// Normalize "", auto, and prepare for extra
val=parseFloat(val)||0;}// use the active box-sizing model to add/subtract irrelevant styles
var ret=val+augmentWidthOrHeight(elem,name,extra||(isBorderBox?"border":"content"),valueIsBorderBox,styles);// dump('ret', ret, val);
return ret;}function getLineHeight(elm){elm=angular.element(elm)[0];var parent=elm.parentElement;if(!parent){parent=document.getElementsByTagName('body')[0];}return parseInt(getStyles(parent).fontSize)||parseInt(getStyles(elm).fontSize)||16;}var uid=['0','0','0','0'];var uidPrefix='uiGrid-';/**
 *  @ngdoc service
 *  @name ui.grid.service:GridUtil
 *
 *  @description Grid utility functions
 */module.service('gridUtil',['$log','$window','$document','$http','$templateCache','$timeout','$interval','$injector','$q','$interpolate','uiGridConstants',function($log,$window,$document,$http,$templateCache,$timeout,$interval,$injector,$q,$interpolate,uiGridConstants){var s={augmentWidthOrHeight:augmentWidthOrHeight,getStyles:getStyles,/**
     * @ngdoc method
     * @name createBoundedWrapper
     * @methodOf ui.grid.service:GridUtil
     *
     * @param {object} object to bind 'this' to
     * @param {method} method to bind
     * @returns {Function} The wrapper that performs the binding
     *
     * @description
     * Binds given method to given object.
     *
     * By means of a wrapper, ensures that ``method`` is always bound to
     * ``object`` regardless of its calling environment.
     * Iow, inside ``method``, ``this`` always points to ``object``.
     *
     * See http://alistapart.com/article/getoutbindingsituations
     *
     */createBoundedWrapper:function(object,method){return function(){return method.apply(object,arguments);};},/**
     * @ngdoc method
     * @name readableColumnName
     * @methodOf ui.grid.service:GridUtil
     *
     * @param {string} columnName Column name as a string
     * @returns {string} Column name appropriately capitalized and split apart
     *
       @example
       <example module="app">
        <file name="app.js">
          var app = angular.module('app', ['ui.grid']);

          app.controller('MainCtrl', ['$scope', 'gridUtil', function ($scope, gridUtil) {
            $scope.name = 'firstName';
            $scope.columnName = function(name) {
              return gridUtil.readableColumnName(name);
            };
          }]);
        </file>
        <file name="index.html">
          <div ng-controller="MainCtrl">
            <strong>Column name:</strong> <input ng-model="name" />
            <br>
            <strong>Output:</strong> <span ng-bind="columnName(name)"></span>
          </div>
        </file>
      </example>
     */readableColumnName:function(columnName){// Convert underscores to spaces
if(typeof columnName==='undefined'||columnName===undefined||columnName===null){return columnName;}if(typeof columnName!=='string'){columnName=String(columnName);}return columnName.replace(/_+/g,' ')// Replace a completely all-capsed word with a first-letter-capitalized version
.replace(/^[A-Z]+$/,function(match){return match.toLowerCase();})// Capitalize the first letter of words
.replace(/([\w\u00C0-\u017F]+)/g,function(match){return match.charAt(0).toUpperCase()+match.slice(1);})// Put a space in between words that have partial capilizations (i.e. 'firstName' becomes 'First Name')
// .replace(/([A-Z]|[A-Z]\w+)([A-Z])/g, "$1 $2");
// .replace(/(\w+?|\w)([A-Z])/g, "$1 $2");
.replace(/(\w+?(?=[A-Z]))/g,'$1 ');},/**
     * @ngdoc method
     * @name getColumnsFromData
     * @methodOf ui.grid.service:GridUtil
     * @description Return a list of column names, given a data set
     *
     * @param {string} data Data array for grid
     * @returns {Object} Column definitions with field accessor and column name
     *
     * @example
       <pre>
         var data = [
           { firstName: 'Bob', lastName: 'Jones' },
           { firstName: 'Frank', lastName: 'Smith' }
         ];

         var columnDefs = GridUtil.getColumnsFromData(data, excludeProperties);

         columnDefs == [
          {
            field: 'firstName',
            name: 'First Name'
          },
          {
            field: 'lastName',
            name: 'Last Name'
          }
         ];
       </pre>
     */getColumnsFromData:function(data,excludeProperties){var columnDefs=[];if(!data||typeof data[0]==='undefined'||data[0]===undefined){return[];}if(angular.isUndefined(excludeProperties)){excludeProperties=[];}var item=data[0];angular.forEach(item,function(prop,propName){if(excludeProperties.indexOf(propName)===-1){columnDefs.push({name:propName});}});return columnDefs;},/**
     * @ngdoc method
     * @name newId
     * @methodOf ui.grid.service:GridUtil
     * @description Return a unique ID string
     *
     * @returns {string} Unique string
     *
     * @example
       <pre>
        var id = GridUtil.newId();

        # 1387305700482;
       </pre>
     */newId:function(){var seedId=new Date().getTime();return function(){return seedId+=1;};}(),/**
     * @ngdoc method
     * @name getTemplate
     * @methodOf ui.grid.service:GridUtil
     * @description Get's template from cache / element / url
     *
     * @param {string|element|promise} template Either a string representing the template id, a string representing the template url,
     *   an jQuery/Angualr element, or a promise that returns the template contents to use.
     * @returns {object} a promise resolving to template contents
     *
     * @example
     <pre>
     GridUtil.getTemplate(url).then(function (contents) {
          alert(contents);
        })
     </pre>
     */getTemplate:function(template){// Try to fetch the template out of the templateCache
if($templateCache.get(template)){return s.postProcessTemplate($templateCache.get(template));}// See if the template is itself a promise
if(angular.isFunction(template.then)){return template.then(s.postProcessTemplate).catch(angular.noop);}// If the template is an element, return the element
try{if(angular.element(template).length>0){return $q.when(template).then(s.postProcessTemplate).catch(angular.noop);}}catch(err){// do nothing; not valid html
}// s.logDebug('fetching url', template);
// Default to trying to fetch the template as a url with $http
return $http({method:'GET',url:template}).then(function(result){var templateHtml=result.data.trim();// put in templateCache for next call
$templateCache.put(template,templateHtml);return templateHtml;},function(err){throw new Error("Could not get template "+template+": "+err);}).then(s.postProcessTemplate).catch(angular.noop);},//
postProcessTemplate:function(template){var startSym=$interpolate.startSymbol(),endSym=$interpolate.endSymbol();// If either of the interpolation symbols have been changed, we need to alter this template
if(startSym!=='{{'||endSym!=='}}'){template=template.replace(/\{\{/g,startSym);template=template.replace(/\}\}/g,endSym);}return $q.when(template);},/**
     * @ngdoc method
     * @name guessType
     * @methodOf ui.grid.service:GridUtil
     * @description guesses the type of an argument
     *
     * @param {string/number/bool/object} item variable to examine
     * @returns {string} one of the following
     * - 'string'
     * - 'boolean'
     * - 'number'
     * - 'date'
     * - 'object'
     */guessType:function(item){var itemType=typeof item;// Check for numbers and booleans
switch(itemType){case"number":case"boolean":case"string":return itemType;default:if(angular.isDate(item)){return"date";}return"object";}},/**
    * @ngdoc method
    * @name elementWidth
    * @methodOf ui.grid.service:GridUtil
    *
    * @param {element} elem DOM element
    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
    *
    * @returns {number} Element width in pixels, accounting for any borders, etc.
    */elementWidth:function(elem){},/**
    * @ngdoc method
    * @name elementHeight
    * @methodOf ui.grid.service:GridUtil
    *
    * @param {element} elem DOM element
    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
    *
    * @returns {number} Element height in pixels, accounting for any borders, etc.
    */elementHeight:function(elem){},isVisible:function(elem){return!!(elem[0].offsetWidth||elem[0].offsetHeight||elem[0].getClientRects().length);},// Thanks to http://stackoverflow.com/a/13382873/888165
getScrollbarWidth:function(){var outer=document.createElement("div");outer.style.visibility="hidden";outer.style.width="100px";outer.style.msOverflowStyle="scrollbar";// needed for WinJS apps
document.body.appendChild(outer);var widthNoScroll=outer.offsetWidth;// force scrollbars
outer.style.overflow="scroll";outer.style.position="absolute";// force Firefox to draw a scrollbar
// add innerdiv
var inner=document.createElement("div");inner.style.width="100%";outer.appendChild(inner);var widthWithScroll=inner.offsetWidth;// remove divs
outer.parentNode.removeChild(outer);return widthNoScroll-widthWithScroll;},swap:function(elem,options,callback,args){var ret,name,old={};// Remember the old values, and insert the new ones
for(name in options){old[name]=elem.style[name];elem.style[name]=options[name];}ret=callback.apply(elem,args||[]);// Revert the old values
for(name in options){elem.style[name]=old[name];}return ret;},fakeElement:function(elem,options,callback,args){var ret,name,newElement=angular.element(elem).clone()[0];for(name in options){newElement.style[name]=options[name];}angular.element(document.body).append(newElement);ret=callback.call(newElement,newElement);angular.element(newElement).remove();return ret;},/**
    * @ngdoc method
    * @name normalizeWheelEvent
    * @methodOf ui.grid.service:GridUtil
    *
    * @param {event} event A mouse wheel event
    *
    * @returns {event} A normalized event
    *
    * @description
    * Given an event from this list:
    *
    * `wheel, mousewheel, DomMouseScroll, MozMousePixelScroll`
    *
    * "normalize" it
    * so that it stays consistent no matter what browser it comes from (i.e. scale it correctly and make sure the direction is right.)
    */normalizeWheelEvent:function(event){// var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
// var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
var lowestDelta,lowestDeltaXY;var orgEvent=event||window.event,args=[].slice.call(arguments,1),delta=0,deltaX=0,deltaY=0,absDelta=0,absDeltaXY=0,fn;// event = $.event.fix(orgEvent);
// event.type = 'mousewheel';
// NOTE: jQuery masks the event and stores it in the event as originalEvent
if(orgEvent.originalEvent){orgEvent=orgEvent.originalEvent;}// Old school scrollwheel delta
if(orgEvent.wheelDelta){delta=orgEvent.wheelDelta;}if(orgEvent.detail){delta=orgEvent.detail*-1;}// At a minimum, setup the deltaY to be delta
deltaY=delta;// Firefox < 17 related to DOMMouseScroll event
if(orgEvent.axis!==undefined&&orgEvent.axis===orgEvent.HORIZONTAL_AXIS){deltaY=0;deltaX=delta*-1;}// New school wheel delta (wheel event)
if(orgEvent.deltaY){deltaY=orgEvent.deltaY*-1;delta=deltaY;}if(orgEvent.deltaX){deltaX=orgEvent.deltaX;delta=deltaX*-1;}// Webkit
if(orgEvent.wheelDeltaY!==undefined){deltaY=orgEvent.wheelDeltaY;}if(orgEvent.wheelDeltaX!==undefined){deltaX=orgEvent.wheelDeltaX;}// Look for lowest delta to normalize the delta values
absDelta=Math.abs(delta);if(!lowestDelta||absDelta<lowestDelta){lowestDelta=absDelta;}absDeltaXY=Math.max(Math.abs(deltaY),Math.abs(deltaX));if(!lowestDeltaXY||absDeltaXY<lowestDeltaXY){lowestDeltaXY=absDeltaXY;}// Get a whole value for the deltas
fn=delta>0?'floor':'ceil';delta=Math[fn](delta/lowestDelta);deltaX=Math[fn](deltaX/lowestDeltaXY);deltaY=Math[fn](deltaY/lowestDeltaXY);return{delta:delta,deltaX:deltaX,deltaY:deltaY};},// Stolen from Modernizr
// TODO: make this, and everythign that flows from it, robust
// http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
isTouchEnabled:function(){var bool;if('ontouchstart'in $window||$window.DocumentTouch&&$document instanceof DocumentTouch){bool=true;}return bool;},isNullOrUndefined:function(obj){return obj===undefined||obj===null;},endsWith:function(str,suffix){if(!str||!suffix||typeof str!=="string"){return false;}return str.indexOf(suffix,str.length-suffix.length)!==-1;},arrayContainsObjectWithProperty:function(array,propertyName,propertyValue){var found=false;angular.forEach(array,function(object){if(object[propertyName]===propertyValue){found=true;}});return found;},numericAndNullSort:function(a,b){if(a===null){return 1;}if(b===null){return-1;}if(a===null&&b===null){return 0;}return a-b;},// Disable ngAnimate animations on an element
disableAnimations:function(element){var $animate;try{$animate=$injector.get('$animate');// See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
if(angular.version.major>1||angular.version.major===1&&angular.version.minor>=4){$animate.enabled(element,false);}else{$animate.enabled(false,element);}}catch(e){}},enableAnimations:function(element){var $animate;try{$animate=$injector.get('$animate');// See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
if(angular.version.major>1||angular.version.major===1&&angular.version.minor>=4){$animate.enabled(element,true);}else{$animate.enabled(true,element);}return $animate;}catch(e){}},// Blatantly stolen from Angular as it isn't exposed (yet)
nextUid:function nextUid(){var index=uid.length;var digit;while(index){index--;digit=uid[index].charCodeAt(0);if(digit===57/*'9'*/){uid[index]='A';return uidPrefix+uid.join('');}if(digit===90/*'Z'*/){uid[index]='0';}else{uid[index]=String.fromCharCode(digit+1);return uidPrefix+uid.join('');}}uid.unshift('0');return uidPrefix+uid.join('');},// Blatantly stolen from Angular as it isn't exposed (yet)
hashKey:function hashKey(obj){var objType=typeof obj,key;if(objType==='object'&&obj!==null){if(typeof(key=obj.$$hashKey)==='function'){// must invoke on object to keep the right this
key=obj.$$hashKey();}else if(typeof obj.$$hashKey!=='undefined'&&obj.$$hashKey){key=obj.$$hashKey;}else if(key===undefined){key=obj.$$hashKey=s.nextUid();}}else{key=obj;}return objType+': '+key;},resetUids:function(){uid=['0','0','0'];},/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil
     * @name logError
     * @description wraps the $log method, allowing us to choose different
     * treatment within ui-grid if we so desired.  At present we only log
     * error messages if uiGridConstants.LOG_ERROR_MESSAGES is set to true
     * @param {string} logMessage message to be logged to the console
     *
     */logError:function(logMessage){if(uiGridConstants.LOG_ERROR_MESSAGES){$log.error(logMessage);}},/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil
     * @name logWarn
     * @description wraps the $log method, allowing us to choose different
     * treatment within ui-grid if we so desired.  At present we only log
     * warning messages if uiGridConstants.LOG_WARN_MESSAGES is set to true
     * @param {string} logMessage message to be logged to the console
     *
     */logWarn:function(logMessage){if(uiGridConstants.LOG_WARN_MESSAGES){$log.warn(logMessage);}},/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil
     * @name logDebug
     * @description wraps the $log method, allowing us to choose different
     * treatment within ui-grid if we so desired.  At present we only log
     * debug messages if uiGridConstants.LOG_DEBUG_MESSAGES is set to true
     *
     */logDebug:function(){if(uiGridConstants.LOG_DEBUG_MESSAGES){$log.debug.apply($log,arguments);}}};/**
   * @ngdoc object
   * @name focus
   * @propertyOf ui.grid.service:GridUtil
   * @description Provides a set of methods to set the document focus inside the grid.
   * See {@link ui.grid.service:GridUtil.focus} for more information.
   */ /**
   * @ngdoc object
   * @name ui.grid.service:GridUtil.focus
   * @description Provides a set of methods to set the document focus inside the grid.
   * Timeouts are utilized to ensure that the focus is invoked after any other event has been triggered.
   * e.g. click events that need to run before the focus or
   * inputs elements that are in a disabled state but are enabled when those events
   * are triggered.
   */s.focus={queue:[],// http://stackoverflow.com/questions/25596399/set-element-focus-in-angular-way
/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil.focus
     * @name byId
     * @description Sets the focus of the document to the given id value.
     * If provided with the grid object it will automatically append the grid id.
     * This is done to encourage unique dom id's as it allows for multiple grids on a
     * page.
     * @param {String} id the id of the dom element to set the focus on
     * @param {Object=} Grid the grid object for this grid instance. See: {@link ui.grid.class:Grid}
     * @param {Number} Grid.id the unique id for this grid. Already set on an initialized grid object.
     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
     * then the promise will fail with the `'canceled'` reason.
     */byId:function(id,Grid){this._purgeQueue();var promise=$timeout(function(){var elementID=(Grid&&Grid.id?Grid.id+'-':'')+id;var element=$window.document.getElementById(elementID);if(element){element.focus();}else{s.logWarn('[focus.byId] Element id '+elementID+' was not found.');}},0,false);this.queue.push(promise);return promise;},/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil.focus
     * @name byElement
     * @description Sets the focus of the document to the given dom element.
     * @param {(element|angular.element)} element the DOM element to set the focus on
     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
     * then the promise will fail with the `'canceled'` reason.
     */byElement:function(element){if(!angular.isElement(element)){s.logWarn("Trying to focus on an element that isn\'t an element.");return $q.reject('not-element');}element=angular.element(element);this._purgeQueue();var promise=$timeout(function(){if(element){element[0].focus();}},0,false);this.queue.push(promise);return promise;},/**
     * @ngdoc method
     * @methodOf ui.grid.service:GridUtil.focus
     * @name bySelector
     * @description Sets the focus of the document to the given dom element.
     * @param {(element|angular.element)} parentElement the parent/ancestor of the dom element that you are selecting using the query selector
     * @param {String} querySelector finds the dom element using the {@link http://www.w3schools.com/jsref/met_document_queryselector.asp querySelector}
     * @param {boolean} [aSync=false] If true then the selector will be querried inside of a timeout. Otherwise the selector will be querried imidately
     * then the focus will be called.
     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
     * then the promise will fail with the `'canceled'` reason.
     */bySelector:function(parentElement,querySelector,aSync){var self=this;if(!angular.isElement(parentElement)){throw new Error("The parent element is not an element.");}// Ensure that this is an angular element.
// It is fine if this is already an angular element.
parentElement=angular.element(parentElement);var focusBySelector=function(){var element=parentElement[0].querySelector(querySelector);return self.byElement(element);};this._purgeQueue();if(aSync){// Do this asynchronysly
var promise=$timeout(focusBySelector,0,false);this.queue.push(promise);return promise;}else{return focusBySelector();}},_purgeQueue:function(){this.queue.forEach(function(element){$timeout.cancel(element);});this.queue=[];}};['width','height'].forEach(function(name){var capsName=name.charAt(0).toUpperCase()+name.substr(1);s['element'+capsName]=function(elem,extra){var e=elem;if(e&&typeof e.length!=='undefined'&&e.length){e=elem[0];}if(e&&e!==null){var styles=getStyles(e);return e.offsetWidth===0&&rdisplayswap.test(styles.display)?s.swap(e,cssShow,function(){return getWidthOrHeight(e,name,extra);}):getWidthOrHeight(e,name,extra);}else{return null;}};s['outerElement'+capsName]=function(elem,margin){return elem?s['element'+capsName].call(this,elem,margin?'margin':'border'):null;};});// http://stackoverflow.com/a/24107550/888165
s.closestElm=function closestElm(el,selector){if(typeof el.length!=='undefined'&&el.length){el=el[0];}var matchesFn;// find vendor prefix
['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn){if(typeof document.body[fn]==='function'){matchesFn=fn;return true;}return false;});// traverse parents
var parent;while(el!==null){parent=el.parentElement;if(parent!==null&&parent[matchesFn](selector)){return parent;}el=parent;}return null;};s.type=function(obj){var text=Function.prototype.toString.call(obj.constructor);return text.match(/function (.*?)\(/)[1];};s.getBorderSize=function getBorderSize(elem,borderType){if(typeof elem.length!=='undefined'&&elem.length){elem=elem[0];}var styles=getStyles(elem);// If a specific border is supplied, like 'top', read the 'borderTop' style property
if(borderType){borderType='border'+borderType.charAt(0).toUpperCase()+borderType.slice(1);}else{borderType='border';}borderType+='Width';var val=parseInt(styles[borderType],10);if(isNaN(val)){return 0;}else{return val;}};// http://stackoverflow.com/a/22948274/888165
// TODO: Opera? Mobile?
s.detectBrowser=function detectBrowser(){var userAgent=$window.navigator.userAgent;var browsers={chrome:/chrome/i,safari:/safari/i,firefox:/firefox/i,ie:/internet explorer|trident\//i};for(var key in browsers){if(browsers[key].test(userAgent)){return key;}}return'unknown';};// Borrowed from https://github.com/othree/jquery.rtl-scroll-type
// Determine the scroll "type" this browser is using for RTL
s.rtlScrollType=function rtlScrollType(){if(rtlScrollType.type){return rtlScrollType.type;}var definer=angular.element('<div dir="rtl" style="width: 1px; height: 1px; position: fixed; top: 0px; left: 0px; overflow: hidden"><div style="width: 2px"><span style="display: inline-block; width: 1px"></span><span style="display: inline-block; width: 1px"></span></div></div>')[0],type='reverse';document.body.appendChild(definer);if(definer.scrollLeft>0){type='default';}else{if(typeof Element!=='undefined'&&Element.prototype.scrollIntoView){definer.children[0].children[1].scrollIntoView();if(definer.scrollLeft<0){type='negative';}}else{definer.scrollLeft=1;if(definer.scrollLeft===0){type='negative';}}}angular.element(definer).remove();rtlScrollType.type=type;return type;};/**
     * @ngdoc method
     * @name normalizeScrollLeft
     * @methodOf ui.grid.service:GridUtil
     *
     * @param {element} element The element to get the `scrollLeft` from.
     * @param {grid} grid -  grid used to normalize (uses the rtl property)
     *
     * @returns {number} A normalized scrollLeft value for the current browser.
     *
     * @description
     * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method normalizes them
     */s.normalizeScrollLeft=function normalizeScrollLeft(element,grid){if(typeof element.length!=='undefined'&&element.length){element=element[0];}var scrollLeft=element.scrollLeft;if(grid.isRTL()){switch(s.rtlScrollType()){case'default':return element.scrollWidth-scrollLeft-element.clientWidth;case'negative':return Math.abs(scrollLeft);case'reverse':return scrollLeft;}}return scrollLeft;};/**
  * @ngdoc method
  * @name denormalizeScrollLeft
  * @methodOf ui.grid.service:GridUtil
  *
  * @param {element} element The element to normalize the `scrollLeft` value for
  * @param {number} scrollLeft The `scrollLeft` value to denormalize.
  * @param {grid} grid The grid that owns the scroll event.
  *
  * @returns {number} A normalized scrollLeft value for the current browser.
  *
  * @description
  * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method denormalizes a value for the current browser.
  */s.denormalizeScrollLeft=function denormalizeScrollLeft(element,scrollLeft,grid){if(typeof element.length!=='undefined'&&element.length){element=element[0];}if(grid.isRTL()){switch(s.rtlScrollType()){case'default':// Get the max scroll for the element
var maxScrollLeft=element.scrollWidth-element.clientWidth;// Subtract the current scroll amount from the max scroll
return maxScrollLeft-scrollLeft;case'negative':return scrollLeft*-1;case'reverse':return scrollLeft;}}return scrollLeft;};/**
     * @ngdoc method
     * @name preEval
     * @methodOf ui.grid.service:GridUtil
     *
     * @param {string} path Path to evaluate
     *
     * @returns {string} A path that is normalized.
     *
     * @description
     * Takes a field path and converts it to bracket notation to allow for special characters in path
     * @example
     * <pre>
     * gridUtil.preEval('property') == 'property'
     * gridUtil.preEval('nested.deep.prop-erty') = "nested['deep']['prop-erty']"
     * </pre>
     */s.preEval=function(path){var m=uiGridConstants.BRACKET_REGEXP.exec(path);if(m){return(m[1]?s.preEval(m[1]):m[1])+m[2]+(m[3]?s.preEval(m[3]):m[3]);}else{path=path.replace(uiGridConstants.APOS_REGEXP,'\\\'');var parts=path.split(uiGridConstants.DOT_REGEXP);var preparsed=[parts.shift()];// first item must be var notation, thus skip
angular.forEach(parts,function(part){preparsed.push(part.replace(uiGridConstants.FUNC_REGEXP,'\']$1'));});return preparsed.join('[\'');}};/**
   * @ngdoc method
   * @name debounce
   * @methodOf ui.grid.service:GridUtil
   *
   * @param {function} func function to debounce
   * @param {number} wait milliseconds to delay
   * @param {boolean} immediate execute before delay
   *
   * @returns {function} A function that can be executed as debounced function
   *
   * @description
   * Copied from https://github.com/shahata/angular-debounce
   * Takes a function, decorates it to execute only 1 time after multiple calls, and returns the decorated function
   * @example
   * <pre>
   * var debouncedFunc =  gridUtil.debounce(function() {alert('debounced');}, 500);
   * debouncedFunc();
   * debouncedFunc();
   * debouncedFunc();
   * </pre>
   */s.debounce=function(func,wait,immediate){var timeout,args,context,result;function debounce(){/* jshint validthis: true */context=this;args=arguments;var later=function(){timeout=null;if(!immediate){result=func.apply(context,args);}};var callNow=immediate&&!timeout;if(timeout){$timeout.cancel(timeout);}timeout=$timeout(later,wait,false);if(callNow){result=func.apply(context,args);}return result;}debounce.cancel=function(){$timeout.cancel(timeout);timeout=null;};return debounce;};/**
   * @ngdoc method
   * @name throttle
   * @methodOf ui.grid.service:GridUtil
   *
   * @param {function} func function to throttle
   * @param {number} wait milliseconds to delay after first trigger
   * @param {Object} options to use in throttle.
   *
   * @returns {function} A function that can be executed as throttled function
   *
   * @description
   * Adapted from debounce function (above)
   * Potential keys for Params Object are:
   *    trailing (bool) - whether to trigger after throttle time ends if called multiple times
   * Updated to use $interval rather than $timeout, as protractor (e2e tests) is able to work with $interval,
   * but not with $timeout
   *
   * Note that when using throttle, you need to use throttle to create a new function upfront, then use the function
   * return from that call each time you need to call throttle.  If you call throttle itself repeatedly, the lastCall
   * variable will get overwritten and the throttling won't work
   *
   * @example
   * <pre>
   * var throttledFunc =  gridUtil.throttle(function() {console.log('throttled');}, 500, {trailing: true});
   * throttledFunc(); //=> logs throttled
   * throttledFunc(); //=> queues attempt to log throttled for ~500ms (since trailing param is truthy)
   * throttledFunc(); //=> updates arguments to keep most-recent request, but does not do anything else.
   * </pre>
   */s.throttle=function(func,wait,options){options=options||{};var lastCall=0,queued=null,context,args;function runFunc(endDate){lastCall=+new Date();func.apply(context,args);$interval(function(){queued=null;},0,1,false);}return function(){/* jshint validthis: true */context=this;args=arguments;if(queued===null){var sinceLast=+new Date()-lastCall;if(sinceLast>wait){runFunc();}else if(options.trailing){queued=$interval(runFunc,wait-sinceLast,1,false);}}};};s.on={};s.off={};s._events={};s.addOff=function(eventName){s.off[eventName]=function(elm,fn){var idx=s._events[eventName].indexOf(fn);if(idx>0){s._events[eventName].removeAt(idx);}};};var mouseWheeltoBind='onwheel'in document||document.documentMode>=9?['wheel']:['mousewheel','DomMouseScroll','MozMousePixelScroll'],nullLowestDeltaTimeout,lowestDelta;s.on.mousewheel=function(elm,fn){if(!elm||!fn){return;}var $elm=angular.element(elm);// Store the line height and page height for this particular element
$elm.data('mousewheel-line-height',getLineHeight($elm));$elm.data('mousewheel-page-height',s.elementHeight($elm));if(!$elm.data('mousewheel-callbacks')){$elm.data('mousewheel-callbacks',{});}var cbs=$elm.data('mousewheel-callbacks');cbs[fn]=(Function.prototype.bind||bindPolyfill).call(mousewheelHandler,$elm[0],fn);// Bind all the mousew heel events
for(var i=mouseWheeltoBind.length;i;){$elm.on(mouseWheeltoBind[--i],cbs[fn]);}$elm.on('$destroy',function unbindEvents(){for(var i=mouseWheeltoBind.length;i;){$elm.off(mouseWheeltoBind[--i],cbs[fn]);}});};s.off.mousewheel=function(elm,fn){var $elm=angular.element(elm);var cbs=$elm.data('mousewheel-callbacks');var handler=cbs[fn];if(handler){for(var i=mouseWheeltoBind.length;i;){$elm.off(mouseWheeltoBind[--i],handler);}}delete cbs[fn];if(Object.keys(cbs).length===0){$elm.removeData('mousewheel-line-height');$elm.removeData('mousewheel-page-height');$elm.removeData('mousewheel-callbacks');}};function mousewheelHandler(fn,event){var $elm=angular.element(this);var delta=0,deltaX=0,deltaY=0,absDelta=0,offsetX=0,offsetY=0;// jQuery masks events
if(event.originalEvent){event=event.originalEvent;}if('detail'in event){deltaY=event.detail*-1;}if('wheelDelta'in event){deltaY=event.wheelDelta;}if('wheelDeltaY'in event){deltaY=event.wheelDeltaY;}if('wheelDeltaX'in event){deltaX=event.wheelDeltaX*-1;}// Firefox < 17 horizontal scrolling related to DOMMouseScroll event
if('axis'in event&&event.axis===event.HORIZONTAL_AXIS){deltaX=deltaY*-1;deltaY=0;}// Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
delta=deltaY===0?deltaX:deltaY;// New school wheel delta (wheel event)
if('deltaY'in event){deltaY=event.deltaY*-1;delta=deltaY;}if('deltaX'in event){deltaX=event.deltaX;if(deltaY===0){delta=deltaX*-1;}}// No change actually happened, no reason to go any further
if(deltaY===0&&deltaX===0){return;}// Need to convert lines and pages to pixels if we aren't already in pixels
// There are three delta modes:
//   * deltaMode 0 is by pixels, nothing to do
//   * deltaMode 1 is by lines
//   * deltaMode 2 is by pages
if(event.deltaMode===1){var lineHeight=$elm.data('mousewheel-line-height');delta*=lineHeight;deltaY*=lineHeight;deltaX*=lineHeight;}else if(event.deltaMode===2){var pageHeight=$elm.data('mousewheel-page-height');delta*=pageHeight;deltaY*=pageHeight;deltaX*=pageHeight;}// Store lowest absolute delta to normalize the delta values
absDelta=Math.max(Math.abs(deltaY),Math.abs(deltaX));if(!lowestDelta||absDelta<lowestDelta){lowestDelta=absDelta;// Adjust older deltas if necessary
if(shouldAdjustOldDeltas(event,absDelta)){lowestDelta/=40;}}// Get a whole, normalized value for the deltas
delta=Math[delta>=1?'floor':'ceil'](delta/lowestDelta);deltaX=Math[deltaX>=1?'floor':'ceil'](deltaX/lowestDelta);deltaY=Math[deltaY>=1?'floor':'ceil'](deltaY/lowestDelta);var newEvent={originalEvent:event,deltaX:deltaX,deltaY:deltaY,deltaFactor:lowestDelta,preventDefault:function(){event.preventDefault();},stopPropagation:function(){event.stopPropagation();}};// Clearout lowestDelta after sometime to better
// handle multiple device types that give
// a different lowestDelta
// Ex: trackpad = 3 and mouse wheel = 120
if(nullLowestDeltaTimeout){clearTimeout(nullLowestDeltaTimeout);}nullLowestDeltaTimeout=setTimeout(nullLowestDelta,200);fn.call($elm[0],newEvent);}function nullLowestDelta(){lowestDelta=null;}function shouldAdjustOldDeltas(orgEvent,absDelta){// If this is an older event and the delta is divisable by 120,
// then we are assuming that the browser is treating this as an
// older mouse wheel event and that we should divide the deltas
// by 40 to try and get a more usable deltaFactor.
// Side note, this actually impacts the reported scroll distance
// in older browsers and can cause scrolling to be slower than native.
// Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
return orgEvent.type==='mousewheel'&&absDelta%120===0;}return s;}]);// Add 'px' to the end of a number string if it doesn't have it already
module.filter('px',function(){return function(str){if(str.match(/^[\d\.]+$/)){return str+'px';}else{return str;}};});})();/**
 * @ngdoc overview
 * @name ui.grid.i18n
 * @description
 *
 *  # ui.grid.i18n
 * This module provides i18n functions to ui.grid and any application that wants to use it

 *
 * <div doc-module-components="ui.grid.i18n"></div>
 */(function(){var DIRECTIVE_ALIASES=['uiT','uiTranslate'];var FILTER_ALIASES=['t','uiTranslate'];var module=angular.module('ui.grid.i18n');/**
   *  @ngdoc object
   *  @name ui.grid.i18n.constant:i18nConstants
   *
   *  @description constants available in i18n module
   */module.constant('i18nConstants',{MISSING:'[MISSING]',UPDATE_EVENT:'$uiI18n',LOCALE_DIRECTIVE_ALIAS:'uiI18n',// default to english
DEFAULT_LANG:'en'});//    module.config(['$provide', function($provide) {
//        $provide.decorator('i18nService', ['$delegate', function($delegate) {}])}]);
/**
   *  @ngdoc service
   *  @name ui.grid.i18n.service:i18nService
   *
   *  @description Services for i18n
   */module.service('i18nService',['$log','$parse','i18nConstants','$rootScope',function($log,$parse,i18nConstants,$rootScope){var langCache={_langs:{},current:null,fallback:i18nConstants.DEFAULT_LANG,get:function(lang){var self=this,fallbackLang=self.getFallbackLang();if(lang!==self.fallback){return angular.extend({},self._langs[fallbackLang],self._langs[lang.toLowerCase()]);}return self._langs[lang.toLowerCase()];},add:function(lang,strings){var lower=lang.toLowerCase();if(!this._langs[lower]){this._langs[lower]={};}angular.merge(this._langs[lower],strings);},getAllLangs:function(){var langs=[];if(!this._langs){return langs;}for(var key in this._langs){langs.push(key);}return langs;},setCurrent:function(lang){this.current=lang.toLowerCase();},setFallback:function(lang){this.fallback=lang.toLowerCase();},getCurrentLang:function(){return this.current;},getFallbackLang:function(){return this.fallback.toLowerCase();}};function getMissingText(path){$log.warn(i18nConstants.MISSING+path);return'';}var service={/**
         * @ngdoc service
         * @name add
         * @methodOf ui.grid.i18n.service:i18nService
         * @description  Adds the languages and strings to the cache. Decorate this service to
         * add more translation strings
         * @param {string} langs languages to add
         * @param {object} stringMaps of strings to add grouped by property names
         * @example
         * <pre>
         *      i18nService.add('en', {
         *         aggregate: {
         *                 label1: 'items',
         *                 label2: 'some more items'
         *                 }
         *         },
         *         groupPanel: {
         *              description: 'Drag a column header here and drop it to group by that column.'
         *           }
         *      }
         * </pre>
         */add:function(langs,stringMaps){if(typeof langs==='object'){angular.forEach(langs,function(lang){if(lang){langCache.add(lang,stringMaps);}});}else{langCache.add(langs,stringMaps);}},/**
         * @ngdoc service
         * @name getAllLangs
         * @methodOf ui.grid.i18n.service:i18nService
         * @description  return all currently loaded languages
         * @returns {array} string
         */getAllLangs:function(){return langCache.getAllLangs();},/**
         * @ngdoc service
         * @name get
         * @methodOf ui.grid.i18n.service:i18nService
         * @description  return all currently loaded languages
         * @param {string} lang to return.  If not specified, returns current language
         * @returns {object} the translation string maps for the language
         */get:function(lang){var language=lang?lang:service.getCurrentLang();return langCache.get(language);},/**
         * @ngdoc service
         * @name getSafeText
         * @methodOf ui.grid.i18n.service:i18nService
         * @description  returns the text specified in the path or a Missing text if text is not found
         * @param {String} path property path to use for retrieving text from string map
         * @param {String} [lang] to return.  If not specified, returns current language
         * @returns {object} the translation for the path
         * @example
         * <pre>
         * i18nService.getSafeText('sort.ascending')
         * </pre>
         */getSafeText:function(path,lang){var language=lang||service.getCurrentLang(),trans=langCache.get(language),getter=$parse(path);if(!trans){return getMissingText(path);}return getter(trans)||getMissingText(path);},/**
         * @ngdoc service
         * @name setCurrentLang
         * @methodOf ui.grid.i18n.service:i18nService
         * @description sets the current language to use in the application
         * $broadcasts the i18nConstants.UPDATE_EVENT on the $rootScope
         * @param {string} lang to set
         * @example
         * <pre>
         * i18nService.setCurrentLang('fr');
         * </pre>
         */setCurrentLang:function(lang){if(lang){langCache.setCurrent(lang);$rootScope.$broadcast(i18nConstants.UPDATE_EVENT);}},/**
         * @ngdoc service
         * @name setFallbackLang
         * @methodOf ui.grid.i18n.service:i18nService
         * @description sets the fallback language to use in the application.
         * The default fallback language is english.
         * @param {string} lang to set
         * @example
         * <pre>
         * i18nService.setFallbackLang('en');
         * </pre>
         */setFallbackLang:function(lang){if(lang){langCache.setFallback(lang);}},/**
         * @ngdoc service
         * @name getCurrentLang
         * @methodOf ui.grid.i18n.service:i18nService
         * @description returns the current language used in the application
         */getCurrentLang:function(){var lang=langCache.getCurrentLang();if(!lang){lang=i18nConstants.DEFAULT_LANG;langCache.setCurrent(lang);}return lang;},/**
         * @ngdoc service
         * @name getFallbackLang
         * @methodOf ui.grid.i18n.service:i18nService
         * @description returns the fallback language used in the application
         */getFallbackLang:function(){return langCache.getFallbackLang();}};return service;}]);function localeDirective(i18nService,i18nConstants){return{compile:function(){return{pre:function($scope,$elm,$attrs){var alias=i18nConstants.LOCALE_DIRECTIVE_ALIAS;// check for watchable property
var lang=$scope.$eval($attrs[alias]);if(lang){$scope.$watch($attrs[alias],function(){i18nService.setCurrentLang(lang);});}else if($attrs.$$observers){$attrs.$observe(alias,function(){i18nService.setCurrentLang($attrs[alias]||i18nConstants.DEFAULT_LANG);});}}};}};}module.directive('uiI18n',['i18nService','i18nConstants',localeDirective]);// directive syntax
function uitDirective(i18nService,i18nConstants){return{restrict:'EA',compile:function(){return{pre:function($scope,$elm,$attrs){var listener,observer,prop,alias1=DIRECTIVE_ALIASES[0],alias2=DIRECTIVE_ALIASES[1],token=$attrs[alias1]||$attrs[alias2]||$elm.html();function translateToken(property){var safeText=i18nService.getSafeText(property);$elm.html(safeText);}if($attrs.$$observers){prop=$attrs[alias1]?alias1:alias2;observer=$attrs.$observe(prop,function(result){if(result){translateToken(result);}});}listener=$scope.$on(i18nConstants.UPDATE_EVENT,function(){if(observer){observer($attrs[alias1]||$attrs[alias2]);}else{// set text based on i18n current language
translateToken(token);}});$scope.$on('$destroy',listener);translateToken(token);}};}};}angular.forEach(DIRECTIVE_ALIASES,function(alias){module.directive(alias,['i18nService','i18nConstants',uitDirective]);});// optional filter syntax
function uitFilter(i18nService){return function(data,lang){// set text based on i18n current language
return i18nService.getSafeText(data,lang);};}angular.forEach(FILTER_ALIASES,function(alias){module.filter(alias,['i18nService',uitFilter]);});})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.edit
   * @description
   *
   * # ui.grid.edit
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module provides cell editing capability to ui.grid. The goal was to emulate keying data in a spreadsheet via
   * a keyboard.
   * <br/>
   * <br/>
   * To really get the full spreadsheet-like data entry, the ui.grid.cellNav module should be used. This will allow the
   * user to key data and then tab, arrow, or enter to the cells beside or below.
   *
   * <div doc-module-components="ui.grid.edit"></div>
   */var module=angular.module('ui.grid.edit',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.edit.constant:uiGridEditConstants
   *
   *  @description constants available in edit module
   */module.constant('uiGridEditConstants',{EDITABLE_CELL_TEMPLATE:/EDITABLE_CELL_TEMPLATE/g,// must be lowercase because template bulder converts to lower
EDITABLE_CELL_DIRECTIVE:/editable_cell_directive/g,events:{BEGIN_CELL_EDIT:'uiGridEventBeginCellEdit',END_CELL_EDIT:'uiGridEventEndCellEdit',CANCEL_CELL_EDIT:'uiGridEventCancelCellEdit'}});/**
   *  @ngdoc service
   *  @name ui.grid.edit.service:uiGridEditService
   *
   *  @description Services for editing features
   */module.service('uiGridEditService',['$q','uiGridConstants','gridUtil',function($q,uiGridConstants,gridUtil){var service={initializeGrid:function(grid){service.defaultGridOptions(grid.options);grid.registerColumnBuilder(service.editColumnBuilder);grid.edit={};/**
           *  @ngdoc object
           *  @name ui.grid.edit.api:PublicApi
           *
           *  @description Public Api for edit feature
           */var publicApi={events:{edit:{/**
                 * @ngdoc event
                 * @name afterCellEdit
                 * @eventOf  ui.grid.edit.api:PublicApi
                 * @description raised when cell editing is complete
                 * <pre>
                 *      gridApi.edit.on.afterCellEdit(scope,function(rowEntity, colDef) {})
                 * </pre>
                 * @param {object} rowEntity the options.data element that was edited
                 * @param {object} colDef the column that was edited
                 * @param {object} newValue new value
                 * @param {object} oldValue old value
                 */afterCellEdit:function(rowEntity,colDef,newValue,oldValue){},/**
                 * @ngdoc event
                 * @name beginCellEdit
                 * @eventOf  ui.grid.edit.api:PublicApi
                 * @description raised when cell editing starts on a cell
                 * <pre>
                 *      gridApi.edit.on.beginCellEdit(scope,function(rowEntity, colDef) {})
                 * </pre>
                 * @param {object} rowEntity the options.data element that was edited
                 * @param {object} colDef the column that was edited
                 * @param {object} triggerEvent the event that triggered the edit.  Useful to prevent losing keystrokes on some
                 *                 complex editors
                 */beginCellEdit:function(rowEntity,colDef,triggerEvent){},/**
                 * @ngdoc event
                 * @name cancelCellEdit
                 * @eventOf  ui.grid.edit.api:PublicApi
                 * @description raised when cell editing is cancelled on a cell
                 * <pre>
                 *      gridApi.edit.on.cancelCellEdit(scope,function(rowEntity, colDef) {})
                 * </pre>
                 * @param {object} rowEntity the options.data element that was edited
                 * @param {object} colDef the column that was edited
                 */cancelCellEdit:function(rowEntity,colDef){}}},methods:{edit:{}}};grid.api.registerEventsFromObject(publicApi.events);// grid.api.registerMethodsFromObject(publicApi.methods);
},defaultGridOptions:function(gridOptions){/**
           *  @ngdoc object
           *  @name ui.grid.edit.api:GridOptions
           *
           *  @description Options for configuring the edit feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           *  @ngdoc object
           *  @name enableCellEdit
           *  @propertyOf  ui.grid.edit.api:GridOptions
           *  @description If defined, sets the default value for the editable flag on each individual colDefs
           *  if their individual enableCellEdit configuration is not defined. Defaults to undefined.
           */ /**
           *  @ngdoc object
           *  @name cellEditableCondition
           *  @propertyOf  ui.grid.edit.api:GridOptions
           *  @description If specified, either a value or function to be used by all columns before editing.
           *  If false, then editing of cell is not allowed.
           *  @example
           *  <pre>
           *  function($scope, triggerEvent) {
           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
           *    return true;
           *  }
           *  </pre>
           */gridOptions.cellEditableCondition=gridOptions.cellEditableCondition===undefined?true:gridOptions.cellEditableCondition;/**
           *  @ngdoc object
           *  @name editableCellTemplate
           *  @propertyOf  ui.grid.edit.api:GridOptions
           *  @description If specified, cellTemplate to use as the editor for all columns.
           *  <br/> defaults to 'ui-grid/cellTextEditor'
           */ /**
           *  @ngdoc object
           *  @name enableCellEditOnFocus
           *  @propertyOf  ui.grid.edit.api:GridOptions
           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
           *  <br/>_requires cellNav feature and the edit feature to be enabled_
           */ // enableCellEditOnFocus can only be used if cellnav module is used
gridOptions.enableCellEditOnFocus=gridOptions.enableCellEditOnFocus===undefined?false:gridOptions.enableCellEditOnFocus;},/**
         * @ngdoc service
         * @name editColumnBuilder
         * @methodOf ui.grid.edit.service:uiGridEditService
         * @description columnBuilder function that adds edit properties to grid column
         * @returns {promise} promise that will load any needed templates when resolved
         */editColumnBuilder:function(colDef,col,gridOptions){var promises=[];/**
           *  @ngdoc object
           *  @name ui.grid.edit.api:ColumnDef
           *
           *  @description Column Definition for edit feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
           */ /**
           *  @ngdoc object
           *  @name enableCellEdit
           *  @propertyOf  ui.grid.edit.api:ColumnDef
           *  @description enable editing on column
           */colDef.enableCellEdit=colDef.enableCellEdit===undefined?gridOptions.enableCellEdit===undefined?colDef.type!=='object':gridOptions.enableCellEdit:colDef.enableCellEdit;/**
           *  @ngdoc object
           *  @name cellEditableCondition
           *  @propertyOf  ui.grid.edit.api:ColumnDef
           *  @description If specified, either a value or function evaluated before editing cell.  If falsy, then editing of cell is not allowed.
           *  @example
           *  <pre>
           *  function($scope, triggerEvent) {
           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
           *    return true;
           *  }
           *  </pre>
           */colDef.cellEditableCondition=colDef.cellEditableCondition===undefined?gridOptions.cellEditableCondition:colDef.cellEditableCondition;/**
           *  @ngdoc object
           *  @name editableCellTemplate
           *  @propertyOf  ui.grid.edit.api:ColumnDef
           *  @description cell template to be used when editing this column. Can be Url or text template
           *  <br/>Defaults to gridOptions.editableCellTemplate
           */if(colDef.enableCellEdit){colDef.editableCellTemplate=colDef.editableCellTemplate||gridOptions.editableCellTemplate||'ui-grid/cellEditor';promises.push(gridUtil.getTemplate(colDef.editableCellTemplate).then(function(template){col.editableCellTemplate=template;},function(res){// Todo handle response error here?
throw new Error("Couldn't fetch/use colDef.editableCellTemplate '"+colDef.editableCellTemplate+"'");}));}/**
           *  @ngdoc object
           *  @name enableCellEditOnFocus
           *  @propertyOf  ui.grid.edit.api:ColumnDef
           *  @requires ui.grid.cellNav
           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
           *  <br>_requires both the cellNav feature and the edit feature to be enabled_
           */ // enableCellEditOnFocus can only be used if cellnav module is used
colDef.enableCellEditOnFocus=colDef.enableCellEditOnFocus===undefined?gridOptions.enableCellEditOnFocus:colDef.enableCellEditOnFocus;/**
           *  @ngdoc string
           *  @name editModelField
           *  @propertyOf  ui.grid.edit.api:ColumnDef
           *  @description a bindable string value that is used when binding to edit controls instead of colDef.field
           *  <br/> example: You have a complex property on and object like state:{abbrev: 'MS',name: 'Mississippi'}.  The
           *  grid should display state.name in the cell and sort/filter based on the state.name property but the editor
           *  requires the full state object.
           *  <br/>colDef.field = 'state.name'
           *  <br/>colDef.editModelField = 'state'
           */ // colDef.editModelField
return $q.all(promises);},/**
         * @ngdoc service
         * @name isStartEditKey
         * @methodOf ui.grid.edit.service:uiGridEditService
         * @description  Determines if a keypress should start editing.  Decorate this service to override with your
         * own key events.  See service decorator in angular docs.
         * @param {Event} evt keydown event
         * @returns {boolean} true if an edit should start
         */isStartEditKey:function(evt){return!(evt.metaKey||evt.keyCode===uiGridConstants.keymap.ESC||evt.keyCode===uiGridConstants.keymap.SHIFT||evt.keyCode===uiGridConstants.keymap.CTRL||evt.keyCode===uiGridConstants.keymap.ALT||evt.keyCode===uiGridConstants.keymap.WIN||evt.keyCode===uiGridConstants.keymap.CAPSLOCK||evt.keyCode===uiGridConstants.keymap.LEFT||evt.keyCode===uiGridConstants.keymap.TAB&&evt.shiftKey||evt.keyCode===uiGridConstants.keymap.RIGHT||evt.keyCode===uiGridConstants.keymap.TAB||evt.keyCode===uiGridConstants.keymap.UP||evt.keyCode===uiGridConstants.keymap.ENTER&&evt.shiftKey||evt.keyCode===uiGridConstants.keymap.DOWN||evt.keyCode===uiGridConstants.keymap.ENTER);}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridEdit
   *  @element div
   *  @restrict A
   *
   *  @description Adds editing features to the ui-grid directive.
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.edit']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name', enableCellEdit: true},
        {name: 'title', enableCellEdit: true}
      ];
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridEdit',['gridUtil','uiGridEditService',function(gridUtil,uiGridEditService){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridEditService.initializeGrid(uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridRenderContainer
   *  @element div
   *  @restrict A
   *
   *  @description Adds keydown listeners to renderContainer element so we can capture when to begin edits
   *
   */module.directive('uiGridViewport',['uiGridEditConstants',function(uiGridEditConstants){return{replace:true,priority:-99998,// run before cellNav
require:['^uiGrid','^uiGridRenderContainer'],scope:false,compile:function(){return{post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];// Skip attaching if edit and cellNav is not enabled
if(!uiGridCtrl.grid.api.edit||!uiGridCtrl.grid.api.cellNav){return;}var containerId=controllers[1].containerId;// no need to process for other containers
if(containerId!=='body'){return;}// refocus on the grid
$scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT,function(){uiGridCtrl.focus();});$scope.$on(uiGridEditConstants.events.END_CELL_EDIT,function(){uiGridCtrl.focus();});}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridCell
   *  @element div
   *  @restrict A
   *
   *  @description Stacks on top of ui.grid.uiGridCell to provide in-line editing capabilities to the cell
   *  Editing Actions.
   *
   *  Binds edit start events to the uiGridCell element.  When the events fire, the gridCell element is appended
   *  with the columnDef.editableCellTemplate element ('cellEditor.html' by default).
   *
   *  The editableCellTemplate should respond to uiGridEditConstants.events.BEGIN\_CELL\_EDIT angular event
   *  and do the initial steps needed to edit the cell (setfocus on input element, etc).
   *
   *  When the editableCellTemplate recognizes that the editing is ended (blur event, Enter key, etc.)
   *  it should emit the uiGridEditConstants.events.END\_CELL\_EDIT event.
   *
   *  If editableCellTemplate recognizes that the editing has been cancelled (esc key)
   *  it should emit the uiGridEditConstants.events.CANCEL\_CELL\_EDIT event.  The original value
   *  will be set back on the model by the uiGridCell directive.
   *
   *  Events that invoke editing:
   *    - dblclick
   *    - F2 keydown (when using cell selection)
   *
   *  Events that end editing:
   *    - Dependent on the specific editableCellTemplate
   *    - Standards should be blur and enter keydown
   *
   *  Events that cancel editing:
   *    - Dependent on the specific editableCellTemplate
   *    - Standards should be Esc keydown
   *
   *  Grid Events that end editing:
   *    - uiGridConstants.events.GRID_SCROLL
   *
   */ /**
   *  @ngdoc object
   *  @name ui.grid.edit.api:GridRow
   *
   *  @description GridRow options for edit feature, these are available to be
   *  set internally only, by other features
   */ /**
   *  @ngdoc object
   *  @name enableCellEdit
   *  @propertyOf  ui.grid.edit.api:GridRow
   *  @description enable editing on row, grouping for example might disable editing on group header rows
   */module.directive('uiGridCell',['$compile','$injector','$timeout','uiGridConstants','uiGridEditConstants','gridUtil','$parse','uiGridEditService','$rootScope','$q',function($compile,$injector,$timeout,uiGridConstants,uiGridEditConstants,gridUtil,$parse,uiGridEditService,$rootScope,$q){var touchstartTimeout=500;if($injector.has('uiGridCellNavService')){var uiGridCellNavService=$injector.get('uiGridCellNavService');}return{priority:-100,// run after default uiGridCell directive
restrict:'A',scope:false,require:'?^uiGrid',link:function($scope,$elm,$attrs,uiGridCtrl){var html,origCellValue,cellModel,cancelTouchstartTimeout,inEdit=false;var editCellScope;if(!$scope.col.colDef.enableCellEdit){return;}var cellNavNavigateDereg=function(){};var viewPortKeyDownDereg=function(){};var setEditable=function(){if($scope.col.colDef.enableCellEdit&&$scope.row.enableCellEdit!==false){if(!$scope.beginEditEventsWired){// prevent multiple attachments
registerBeginEditEvents();}}else{if($scope.beginEditEventsWired){cancelBeginEditEvents();}}};setEditable();var rowWatchDereg=$scope.$watch('row',function(n,o){if(n!==o){setEditable();}});$scope.$on('$destroy',function destroyEvents(){rowWatchDereg();// unbind all jquery events in order to avoid memory leaks
$elm.off();});function registerBeginEditEvents(){$elm.on('dblclick',beginEdit);// Add touchstart handling. If the users starts a touch and it doesn't end after X milliseconds, then start the edit
$elm.on('touchstart',touchStart);if(uiGridCtrl&&uiGridCtrl.grid.api.cellNav){viewPortKeyDownDereg=uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope,function(evt,rowCol){if(rowCol===null){return;}if(rowCol.row===$scope.row&&rowCol.col===$scope.col&&!$scope.col.colDef.enableCellEditOnFocus){// important to do this before scrollToIfNecessary
beginEditKeyDown(evt);}});cellNavNavigateDereg=uiGridCtrl.grid.api.cellNav.on.navigate($scope,function(newRowCol,oldRowCol,evt){if($scope.col.colDef.enableCellEditOnFocus){// Don't begin edit if the cell hasn't changed
if(newRowCol.row===$scope.row&&newRowCol.col===$scope.col&&(evt===null||evt&&(evt.type==='click'||evt.type==='keydown'))){$timeout(function(){beginEdit(evt);});}}});}$scope.beginEditEventsWired=true;}function touchStart(event){// jQuery masks events
if(typeof event.originalEvent!=='undefined'&&event.originalEvent!==undefined){event=event.originalEvent;}// Bind touchend handler
$elm.on('touchend',touchEnd);// Start a timeout
cancelTouchstartTimeout=$timeout(function(){},touchstartTimeout);// Timeout's done! Start the edit
cancelTouchstartTimeout.then(function(){// Use setTimeout to start the edit because beginEdit expects to be outside of $digest
setTimeout(beginEdit,0);// Undbind the touchend handler, we don't need it anymore
$elm.off('touchend',touchEnd);}).catch(angular.noop);}// Cancel any touchstart timeout
function touchEnd(){$timeout.cancel(cancelTouchstartTimeout);$elm.off('touchend',touchEnd);}function cancelBeginEditEvents(){$elm.off('dblclick',beginEdit);$elm.off('keydown',beginEditKeyDown);$elm.off('touchstart',touchStart);cellNavNavigateDereg();viewPortKeyDownDereg();$scope.beginEditEventsWired=false;}function beginEditKeyDown(evt){if(uiGridEditService.isStartEditKey(evt)){beginEdit(evt);}}function shouldEdit(col,row,triggerEvent){return!row.isSaving&&(angular.isFunction(col.colDef.cellEditableCondition)?col.colDef.cellEditableCondition($scope,triggerEvent):col.colDef.cellEditableCondition);}function beginEdit(triggerEvent){// we need to scroll the cell into focus before invoking the editor
$scope.grid.api.core.scrollToIfNecessary($scope.row,$scope.col).then(function(){beginEditAfterScroll(triggerEvent);});}/**
             *  @ngdoc property
             *  @name editDropdownOptionsArray
             *  @propertyOf ui.grid.edit.api:ColumnDef
             *  @description an array of values in the format
             *  [ {id: xxx, value: xxx} ], which is populated
             *  into the edit dropdown
             *
             */ /**
             *  @ngdoc property
             *  @name editDropdownIdLabel
             *  @propertyOf ui.grid.edit.api:ColumnDef
             *  @description the label for the "id" field
             *  in the editDropdownOptionsArray.  Defaults
             *  to 'id'
             *  @example
             *  <pre>
             *    $scope.gridOptions = {
             *      columnDefs: [
             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
             *      ],
             *  </pre>
             *
             */ /**
             *  @ngdoc property
             *  @name editDropdownRowEntityOptionsArrayPath
             *  @propertyOf ui.grid.edit.api:ColumnDef
             *  @description a path to a property on row.entity containing an
             *  array of values in the format
             *  [ {id: xxx, value: xxx} ], which will be used to populate
             *  the edit dropdown.  This can be used when the dropdown values are dependent on
             *  the backing row entity.
             *  If this property is set then editDropdownOptionsArray will be ignored.
             *  @example
             *  <pre>
             *    $scope.gridOptions = {
             *      columnDefs: [
             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
             *          editDropdownRowEntityOptionsArrayPath: 'foo.bars[0].baz',
             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
             *      ],
             *  </pre>
             *
             */ /**
             *  @ngdoc service
             *  @name editDropdownOptionsFunction
             *  @methodOf ui.grid.edit.api:ColumnDef
             *  @description a function returning an array of values in the format
             *  [ {id: xxx, value: xxx} ], which will be used to populate
             *  the edit dropdown.  This can be used when the dropdown values are dependent on
             *  the backing row entity with some kind of algorithm.
             *  If this property is set then both editDropdownOptionsArray and
             *  editDropdownRowEntityOptionsArrayPath will be ignored.
             *  @param {object} rowEntity the options.data element that the returned array refers to
             *  @param {object} colDef the column that implements this dropdown
             *  @returns {object} an array of values in the format
             *  [ {id: xxx, value: xxx} ] used to populate the edit dropdown
             *  @example
             *  <pre>
             *    $scope.gridOptions = {
             *      columnDefs: [
             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
             *          editDropdownOptionsFunction: function(rowEntity, colDef) {
             *            if (rowEntity.foo === 'bar') {
             *              return [{id: 'bar1', value: 'BAR 1'},
             *                      {id: 'bar2', value: 'BAR 2'},
             *                      {id: 'bar3', value: 'BAR 3'}];
             *            } else {
             *              return [{id: 'foo1', value: 'FOO 1'},
             *                      {id: 'foo2', value: 'FOO 2'}];
             *            }
             *          },
             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
             *      ],
             *  </pre>
             *
             */ /**
             *  @ngdoc property
             *  @name editDropdownValueLabel
             *  @propertyOf ui.grid.edit.api:ColumnDef
             *  @description the label for the "value" field
             *  in the editDropdownOptionsArray.  Defaults
             *  to 'value'
             *  @example
             *  <pre>
             *    $scope.gridOptions = {
             *      columnDefs: [
             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
             *      ],
             *  </pre>
             *
             */ /**
             *  @ngdoc property
             *  @name editDropdownFilter
             *  @propertyOf ui.grid.edit.api:ColumnDef
             *  @description A filter that you would like to apply to the values in the options list
             *  of the dropdown.  For example if you were using angular-translate you might set this
             *  to `'translate'`
             *  @example
             *  <pre>
             *    $scope.gridOptions = {
             *      columnDefs: [
             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status', editDropdownFilter: 'translate' }
             *      ],
             *  </pre>
             *
             */function beginEditAfterScroll(triggerEvent){// If we are already editing, then just skip this so we don't try editing twice...
if(inEdit){return;}if(!shouldEdit($scope.col,$scope.row,triggerEvent)){return;}var modelField=$scope.row.getQualifiedColField($scope.col);if($scope.col.colDef.editModelField){modelField=gridUtil.preEval('row.entity.'+$scope.col.colDef.editModelField);}cellModel=$parse(modelField);// get original value from the cell
origCellValue=cellModel($scope);html=$scope.col.editableCellTemplate;html=html.replace(uiGridConstants.MODEL_COL_FIELD,modelField);html=html.replace(uiGridConstants.COL_FIELD,'grid.getCellValue(row, col)');var optionFilter=$scope.col.colDef.editDropdownFilter?'|'+$scope.col.colDef.editDropdownFilter:'';html=html.replace(uiGridConstants.CUSTOM_FILTERS,optionFilter);var inputType='text';switch($scope.col.colDef.type){case'boolean':inputType='checkbox';break;case'number':inputType='number';break;case'date':inputType='date';break;}html=html.replace('INPUT_TYPE',inputType);// In order to fill dropdown options we use:
// - A function/promise or
// - An array inside of row entity if no function exists or
// - A single array for the whole column if none of the previous exists.
var editDropdownOptionsFunction=$scope.col.colDef.editDropdownOptionsFunction;if(editDropdownOptionsFunction){$q.when(editDropdownOptionsFunction($scope.row.entity,$scope.col.colDef)).then(function(result){$scope.editDropdownOptionsArray=result;});}else{var editDropdownRowEntityOptionsArrayPath=$scope.col.colDef.editDropdownRowEntityOptionsArrayPath;if(editDropdownRowEntityOptionsArrayPath){$scope.editDropdownOptionsArray=resolveObjectFromPath($scope.row.entity,editDropdownRowEntityOptionsArrayPath);}else{$scope.editDropdownOptionsArray=$scope.col.colDef.editDropdownOptionsArray;}}$scope.editDropdownIdLabel=$scope.col.colDef.editDropdownIdLabel?$scope.col.colDef.editDropdownIdLabel:'id';$scope.editDropdownValueLabel=$scope.col.colDef.editDropdownValueLabel?$scope.col.colDef.editDropdownValueLabel:'value';var createEditor=function(){inEdit=true;cancelBeginEditEvents();var cellElement=angular.element(html);$elm.append(cellElement);editCellScope=$scope.$new();$compile(cellElement)(editCellScope);var gridCellContentsEl=angular.element($elm.children()[0]);gridCellContentsEl.addClass('ui-grid-cell-contents-hidden');};if(!$rootScope.$$phase){$scope.$apply(createEditor);}else{createEditor();}// stop editing when grid is scrolled
var deregOnGridScroll=$scope.col.grid.api.core.on.scrollBegin($scope,function(){if($scope.grid.disableScrolling){return;}endEdit();$scope.grid.api.edit.raise.afterCellEdit($scope.row.entity,$scope.col.colDef,cellModel($scope),origCellValue);deregOnGridScroll();deregOnEndCellEdit();deregOnCancelCellEdit();});// end editing
var deregOnEndCellEdit=$scope.$on(uiGridEditConstants.events.END_CELL_EDIT,function(){endEdit();$scope.grid.api.edit.raise.afterCellEdit($scope.row.entity,$scope.col.colDef,cellModel($scope),origCellValue);deregOnEndCellEdit();deregOnGridScroll();deregOnCancelCellEdit();});// cancel editing
var deregOnCancelCellEdit=$scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT,function(){cancelEdit();deregOnCancelCellEdit();deregOnGridScroll();deregOnEndCellEdit();});$scope.$broadcast(uiGridEditConstants.events.BEGIN_CELL_EDIT,triggerEvent);$timeout(function(){// execute in a timeout to give any complex editor templates a cycle to completely render
$scope.grid.api.edit.raise.beginCellEdit($scope.row.entity,$scope.col.colDef,triggerEvent);});}function endEdit(){$scope.grid.disableScrolling=false;if(!inEdit){return;}// sometimes the events can't keep up with the keyboard and grid focus is lost, so always focus
// back to grid here. The focus call needs to be before the $destroy and removal of the control,
// otherwise ng-model-options of UpdateOn: 'blur' will not work.
if(uiGridCtrl&&uiGridCtrl.grid.api.cellNav){uiGridCtrl.focus();}var gridCellContentsEl=angular.element($elm.children()[0]);// remove edit element
editCellScope.$destroy();var children=$elm.children();for(var i=1;i<children.length;i++){angular.element(children[i]).remove();}gridCellContentsEl.removeClass('ui-grid-cell-contents-hidden');inEdit=false;registerBeginEditEvents();$scope.grid.api.core.notifyDataChange(uiGridConstants.dataChange.EDIT);}function cancelEdit(){$scope.grid.disableScrolling=false;if(!inEdit){return;}cellModel.assign($scope,origCellValue);$scope.$apply();$scope.grid.api.edit.raise.cancelCellEdit($scope.row.entity,$scope.col.colDef);endEdit();}// resolves a string path against the given object
// shamelessly borrowed from
// http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
function resolveObjectFromPath(object,path){path=path.replace(/\[(\w+)\]/g,'.$1');// convert indexes to properties
path=path.replace(/^\./,'');// strip a leading dot
var a=path.split('.');while(a.length){var n=a.shift();if(n in object){object=object[n];}else{return;}}return object;}}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridEditor
   *  @element div
   *  @restrict A
   *
   *  @description input editor directive for editable fields.
   *  Provides EndEdit and CancelEdit events
   *
   *  Events that end editing:
   *     blur and enter keydown
   *
   *  Events that cancel editing:
   *    - Esc keydown
   *
   */module.directive('uiGridEditor',['gridUtil','uiGridConstants','uiGridEditConstants','$timeout','uiGridEditService',function(gridUtil,uiGridConstants,uiGridEditConstants,$timeout,uiGridEditService){return{scope:true,require:['?^uiGrid','?^uiGridRenderContainer','ngModel'],compile:function(){return{pre:function($scope,$elm,$attrs){},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl,renderContainerCtrl,ngModel;if(controllers[0]){uiGridCtrl=controllers[0];}if(controllers[1]){renderContainerCtrl=controllers[1];}if(controllers[2]){ngModel=controllers[2];}// set focus at start of edit
$scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT,function(){// must be in a timeout since it requires a new digest cycle
$timeout(function(){$elm[0].focus();// only select text if it is not being replaced below in the cellNav viewPortKeyPress
if($elm[0].select&&($scope.col.colDef.enableCellEditOnFocus||!(uiGridCtrl&&uiGridCtrl.grid.api.cellNav))){$elm[0].select();}else{// some browsers (Chrome) stupidly, imo, support the w3 standard that number, email, ...
// fields should not allow setSelectionRange.  We ignore the error for those browsers
// https://www.w3.org/Bugs/Public/show_bug.cgi?id=24796
try{$elm[0].setSelectionRange($elm[0].value.length,$elm[0].value.length);}catch(ex){// ignore
}}});// set the keystroke that started the edit event
// we must do this because the BeginEdit is done in a different event loop than the intitial
// keydown event
// fire this event for the keypress that is received
if(uiGridCtrl&&uiGridCtrl.grid.api.cellNav){var viewPortKeyDownUnregister=uiGridCtrl.grid.api.cellNav.on.viewPortKeyPress($scope,function(evt,rowCol){if(uiGridEditService.isStartEditKey(evt)){var code=typeof evt.which==='number'?evt.which:evt.keyCode;if(code>0){ngModel.$setViewValue(String.fromCharCode(code),evt);ngModel.$render();}}viewPortKeyDownUnregister();});}// macOS will blur the checkbox when clicked in Safari and Firefox,
// to get around this, we disable the blur handler on mousedown,
// and then focus the checkbox and re-enable the blur handler after $timeout
$elm.on('mousedown',function(evt){if($elm[0].type==='checkbox'){$elm.off('blur',$scope.stopEdit);$timeout(function(){$elm[0].focus();$elm.on('blur',$scope.stopEdit);});}});if($elm[0]){$elm[0].focus();}$elm.on('blur',$scope.stopEdit);});$scope.deepEdit=false;$scope.stopEdit=function(evt){if($scope.inputForm&&!$scope.inputForm.$valid){evt.stopPropagation();$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);}else{$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);}$scope.deepEdit=false;};$elm.on('click',function(evt){if($elm[0].type!=='checkbox'){$scope.deepEdit=true;$scope.$applyAsync(function(){$scope.grid.disableScrolling=true;});}});$elm.on('keydown',function(evt){switch(evt.keyCode){case uiGridConstants.keymap.ESC:evt.stopPropagation();$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);break;}if($scope.deepEdit&&(evt.keyCode===uiGridConstants.keymap.LEFT||evt.keyCode===uiGridConstants.keymap.RIGHT||evt.keyCode===uiGridConstants.keymap.UP||evt.keyCode===uiGridConstants.keymap.DOWN)){evt.stopPropagation();}// Pass the keydown event off to the cellNav service, if it exists
else if(uiGridCtrl&&uiGridCtrl.grid.api.cellNav){evt.uiGridTargetRenderContainerId=renderContainerCtrl.containerId;if(uiGridCtrl.cellNav.handleKeyDown(evt)!==null){$scope.stopEdit(evt);}}else{// handle enter and tab for editing not using cellNav
switch(evt.keyCode){case uiGridConstants.keymap.ENTER:// Enter (Leave Field)
case uiGridConstants.keymap.TAB:evt.stopPropagation();evt.preventDefault();$scope.stopEdit(evt);break;}}return true;});$scope.$on('$destroy',function unbindEvents(){// unbind all jquery events in order to avoid memory leaks
$elm.off();});}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:input
   *  @element input
   *  @restrict E
   *
   *  @description directive to provide binding between input[date] value and ng-model for angular 1.2
   *  It is similar to input[date] directive of angular 1.3
   *
   *  Supported date format for input is 'yyyy-MM-dd'
   *  The directive will set the $valid property of input element and the enclosing form to false if
   *  model is invalid date or value of input is entered wrong.
   *
   */module.directive('uiGridEditor',['$filter',function($filter){function parseDateString(dateString){if(typeof dateString==='undefined'||dateString===''){return null;}var parts=dateString.split('-');if(parts.length!==3){return null;}var year=parseInt(parts[0],10);var month=parseInt(parts[1],10);var day=parseInt(parts[2],10);if(month<1||year<1||day<1){return null;}return new Date(year,month-1,day);}return{priority:-100,// run after default uiGridEditor directive
require:'?ngModel',link:function(scope,element,attrs,ngModel){if(angular.version.minor===2&&attrs.type&&attrs.type==='date'&&ngModel){ngModel.$formatters.push(function(modelValue){ngModel.$setValidity(null,!modelValue||!isNaN(modelValue.getTime()));return $filter('date')(modelValue,'yyyy-MM-dd');});ngModel.$parsers.push(function(viewValue){if(viewValue&&viewValue.length>0){var dateValue=parseDateString(viewValue);ngModel.$setValidity(null,dateValue&&!isNaN(dateValue.getTime()));return dateValue;}else{ngModel.$setValidity(null,true);return null;}});}}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridEditDropdown
   *  @element div
   *  @restrict A
   *
   *  @description dropdown editor for editable fields.
   *  Provides EndEdit and CancelEdit events
   *
   *  Events that end editing:
   *     blur and enter keydown, and any left/right nav
   *
   *  Events that cancel editing:
   *    - Esc keydown
   *
   */module.directive('uiGridEditDropdown',['uiGridConstants','uiGridEditConstants','$timeout',function(uiGridConstants,uiGridEditConstants,$timeout){return{require:['?^uiGrid','?^uiGridRenderContainer'],scope:true,compile:function(){return{pre:function($scope,$elm,$attrs){},post:function($scope,$elm,$attrs,controllers){var uiGridCtrl=controllers[0];var renderContainerCtrl=controllers[1];// set focus at start of edit
$scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT,function(){$timeout(function(){$elm[0].focus();});$elm[0].style.width=$elm[0].parentElement.offsetWidth-1+'px';$elm.on('blur',function(evt){$scope.stopEdit(evt);});});$scope.stopEdit=function(evt){// no need to validate a dropdown - invalid values shouldn't be
// available in the list
$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);};$elm.on('keydown',function(evt){switch(evt.keyCode){case uiGridConstants.keymap.ESC:evt.stopPropagation();$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);break;}if(uiGridCtrl&&uiGridCtrl.grid.api.cellNav){evt.uiGridTargetRenderContainerId=renderContainerCtrl.containerId;if(uiGridCtrl.cellNav.handleKeyDown(evt)!==null){$scope.stopEdit(evt);}}else{// handle enter and tab for editing not using cellNav
switch(evt.keyCode){case uiGridConstants.keymap.ENTER:// Enter (Leave Field)
case uiGridConstants.keymap.TAB:evt.stopPropagation();evt.preventDefault();$scope.stopEdit(evt);break;}}return true;});$scope.$on('$destroy',function unbindEvents(){// unbind jquery events to prevent memory leaks
$elm.off();});}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.edit.directive:uiGridEditFileChooser
   *  @element div
   *  @restrict A
   *
   *  @description input editor directive for editable fields.
   *  Provides EndEdit and CancelEdit events
   *
   *  Events that end editing:
   *     blur and enter keydown
   *
   *  Events that cancel editing:
   *    - Esc keydown
   *
   */module.directive('uiGridEditFileChooser',['gridUtil','uiGridConstants','uiGridEditConstants',function(gridUtil,uiGridConstants,uiGridEditConstants){return{scope:true,require:['?^uiGrid','?^uiGridRenderContainer'],compile:function(){return{pre:function($scope,$elm,$attrs){},post:function($scope,$elm){function handleFileSelect(event){var target=event.srcElement||event.target;if(target&&target.files&&target.files.length>0){/**
                     *  @ngdoc property
                     *  @name editFileChooserCallback
                     *  @propertyOf  ui.grid.edit.api:ColumnDef
                     *  @description A function that should be called when any files have been chosen
                     *  by the user.  You should use this to process the files appropriately for your
                     *  application.
                     *
                     *  It passes the gridCol, the gridRow (from which you can get gridRow.entity),
                     *  and the files.  The files are in the format as returned from the file chooser,
                     *  an array of files, with each having useful information such as:
                     *  - `files[0].lastModifiedDate`
                     *  - `files[0].name`
                     *  - `files[0].size`  (appears to be in bytes)
                     *  - `files[0].type`  (MIME type by the looks)
                     *
                     *  Typically you would do something with these files - most commonly you would
                     *  use the filename or read the file itself in.  The example function does both.
                     *
                     *  @example
                     *  <pre>
                     *  editFileChooserCallBack: function(gridRow, gridCol, files ) {
                     *    // ignore all but the first file, it can only choose one anyway
                     *    // set the filename into this column
                     *    gridRow.entity.filename = file[0].name;
                     *
                     *    // read the file and set it into a hidden column, which we may do stuff with later
                     *    var setFile = function(fileContent) {
                     *      gridRow.entity.file = fileContent.currentTarget.result;
                     *    };
                     *    var reader = new FileReader();
                     *    reader.onload = setFile;
                     *    reader.readAsText( files[0] );
                     *  }
                     *  </pre>
                     */if(typeof $scope.col.colDef.editFileChooserCallback==='function'){$scope.col.colDef.editFileChooserCallback($scope.row,$scope.col,target.files);}else{gridUtil.logError('You need to set colDef.editFileChooserCallback to use the file chooser');}target.form.reset();$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);}else{$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);}$elm[0].removeEventListener('change',handleFileSelect,false);}$elm[0].addEventListener('change',handleFileSelect,false);$scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT,function(){$elm[0].focus();$elm[0].select();$elm.on('blur',function(){$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);$elm.off();});});}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.emptyBaseLayer
   * @description
   *
   * # ui.grid.emptyBaseLayer
   *
   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
   *
   * This module provides the ability to have the background of the ui-grid be empty rows, this would be displayed in the case were
   * the grid height is greater then the amount of rows displayed.
   *
   * <div doc-module-components="ui.grid.emptyBaseLayer"></div>
   */var module=angular.module('ui.grid.emptyBaseLayer',['ui.grid']);/**
   *  @ngdoc service
   *  @name ui.grid.emptyBaseLayer.service:uiGridBaseLayerService
   *
   *  @description Services for the empty base layer grid
   */module.service('uiGridBaseLayerService',['gridUtil','$compile',function(gridUtil,$compile){return{initializeGrid:function(grid,disableEmptyBaseLayer){/**
         *  @ngdoc object
         *  @name ui.grid.emptyBaseLayer.api:GridOptions
         *
         *  @description GridOptions for emptyBaseLayer feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */grid.baseLayer={emptyRows:[]};/**
         *  @ngdoc object
         *  @name enableEmptyGridBaseLayer
         *  @propertyOf  ui.grid.emptyBaseLayer.api:GridOptions
         *  @description Enable empty base layer, which shows empty rows as background on the entire grid
         *  <br/>Defaults to true, if the directive is used.
         *  <br/>Set to false either by setting this attribute or passing false to the directive.
         */ // default option to true unless it was explicitly set to false
if(grid.options.enableEmptyGridBaseLayer!==false){grid.options.enableEmptyGridBaseLayer=!disableEmptyBaseLayer;}},setNumberOfEmptyRows:function(viewportHeight,grid){var rowHeight=grid.options.rowHeight,rows=Math.ceil(viewportHeight/rowHeight);if(rows>0){grid.baseLayer.emptyRows=[];for(var i=0;i<rows;i++){grid.baseLayer.emptyRows.push({});}}}};}]);/**
   *  @ngdoc object
   *  @name ui.grid.emptyBaseLayer.directive:uiGridEmptyBaseLayer
   *  @description Shows empty rows in the background of the ui-grid, these span
   *  the full height of the ui-grid, so that there won't be blank space below the shown rows.
   *  @example
   *  <pre>
   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer></div>
   *  </pre>
   *  Or you can enable/disable it dynamically by passing in true or false. It doesn't
   *  the value, so it would only be set on initial render.
   *  <pre>
   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer="false"></div>
   *  </pre>
   */module.directive('uiGridEmptyBaseLayer',['gridUtil','uiGridBaseLayerService','$parse',function(gridUtil,uiGridBaseLayerService,$parse){return{require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){var disableEmptyBaseLayer=$parse($attrs.uiGridEmptyBaseLayer)($scope)===false;uiGridBaseLayerService.initializeGrid(uiGridCtrl.grid,disableEmptyBaseLayer);},post:function($scope,$elm,$attrs,uiGridCtrl){if(!uiGridCtrl.grid.options.enableEmptyGridBaseLayer){return;}var renderBodyContainer=uiGridCtrl.grid.renderContainers.body,viewportHeight=renderBodyContainer.getViewportHeight();function heightHasChanged(){var newViewPortHeight=renderBodyContainer.getViewportHeight();if(newViewPortHeight!==viewportHeight){viewportHeight=newViewPortHeight;return true;}return false;}function getEmptyBaseLayerCss(viewportHeight){// Set ui-grid-empty-base-layer height
return'.grid'+uiGridCtrl.grid.id+' .ui-grid-render-container '+'.ui-grid-empty-base-layer-container.ui-grid-canvas '+'{ height: '+viewportHeight+'px; }';}uiGridCtrl.grid.registerStyleComputation({func:function(){if(heightHasChanged()){uiGridBaseLayerService.setNumberOfEmptyRows(viewportHeight,uiGridCtrl.grid);}return getEmptyBaseLayerCss(viewportHeight);}});}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.emptyBaseLayer.directive:uiGridViewport
   *  @description stacks on the uiGridViewport directive to append the empty grid base layer html elements to the
   *  default gridRow template
   */module.directive('uiGridViewport',['$compile','gridUtil','$templateCache',function($compile,gridUtil,$templateCache){return{priority:-200,scope:false,compile:function($elm){var emptyBaseLayerContainer=$templateCache.get('ui-grid/emptyBaseLayerContainer');$elm.prepend(emptyBaseLayerContainer);return{pre:function($scope,$elm,$attrs,controllers){},post:function($scope,$elm,$attrs,controllers){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.expandable
   * @description
   *
   * # ui.grid.expandable
   *
   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
   *
   * This module provides the ability to create subgrids with the ability to expand a row
   * to show the subgrid.
   *
   * <div doc-module-components="ui.grid.expandable"></div>
   */var module=angular.module('ui.grid.expandable',['ui.grid']);/**
   *  @ngdoc service
   *  @name ui.grid.expandable.service:uiGridExpandableService
   *
   *  @description Services for the expandable grid
   */module.service('uiGridExpandableService',['gridUtil',function(gridUtil){var service={initializeGrid:function(grid){grid.expandable={};grid.expandable.expandedAll=false;/**
         *  @ngdoc boolean
         *  @name enableOnDblClickExpand
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Defaults to true.
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      onDblClickExpand: false
         *    }
         *  </pre>
         */grid.options.enableOnDblClickExpand=grid.options.enableOnDblClickExpand!==false;/**
         *  @ngdoc boolean
         *  @name enableExpandable
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Whether or not to use expandable feature, allows you to turn off expandable on specific grids
         *  within your application, or in specific modes on _this_ grid. Defaults to true.
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      enableExpandable: false
         *    }
         *  </pre>
         */grid.options.enableExpandable=grid.options.enableExpandable!==false;/**
         *  @ngdoc object
         *  @name showExpandAllButton
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Whether or not to display the expand all button, allows you to hide expand all button on specific grids
         *  within your application, or in specific modes on _this_ grid. Defaults to true.
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      showExpandAllButton: false
         *    }
         *  </pre>
         */grid.options.showExpandAllButton=grid.options.showExpandAllButton!==false;/**
         *  @ngdoc object
         *  @name expandableRowHeight
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Height in pixels of the expanded subgrid.  Defaults to
         *  150
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      expandableRowHeight: 150
         *    }
         *  </pre>
         */grid.options.expandableRowHeight=grid.options.expandableRowHeight||150;/**
         *  @ngdoc object
         *  @name expandableRowHeaderWidth
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Width in pixels of the expandable column. Defaults to 40
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      expandableRowHeaderWidth: 40
         *    }
         *  </pre>
         */grid.options.expandableRowHeaderWidth=grid.options.expandableRowHeaderWidth||40;/**
         *  @ngdoc object
         *  @name expandableRowTemplate
         *  @propertyOf  ui.grid.expandable.api:GridOptions
         *  @description Mandatory. The template for your expanded row
         *  @example
         *  <pre>
         *    $scope.gridOptions = {
         *      expandableRowTemplate: 'expandableRowTemplate.html'
         *    }
         *  </pre>
         */if(grid.options.enableExpandable&&!grid.options.expandableRowTemplate){gridUtil.logError('You have not set the expandableRowTemplate, disabling expandable module');grid.options.enableExpandable=false;}/**
         *  @ngdoc object
         *  @name ui.grid.expandable.api:PublicApi
         *
         *  @description Public Api for expandable feature
         */ /**
         *  @ngdoc object
         *  @name ui.grid.expandable.api:GridRow
         *
         *  @description Additional properties added to GridRow when using the expandable module
         */ /**
         *  @ngdoc object
         *  @name ui.grid.expandable.api:GridOptions
         *
         *  @description Options for configuring the expandable feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */var publicApi={events:{expandable:{/**
               * @ngdoc event
               * @name rowExpandedBeforeStateChanged
               * @eventOf  ui.grid.expandable.api:PublicApi
               * @description raised when row is expanding or collapsing
               * <pre>
               *      gridApi.expandable.on.rowExpandedBeforeStateChanged(scope,function(row, event) {})
               * </pre>
               * @param {scope} scope the application scope
               * @param {GridRow} row the row that was expanded
               * @param {Event} evt object if raised from an event
               */rowExpandedBeforeStateChanged:function(scope,row,evt){},/**
               * @ngdoc event
               * @name rowExpandedStateChanged
               * @eventOf  ui.grid.expandable.api:PublicApi
               * @description raised when row expanded or collapsed
               * <pre>
               *      gridApi.expandable.on.rowExpandedStateChanged(scope,function(row, event) {})
               * </pre>
               * @param {scope} scope the application scope
               * @param {GridRow} row the row that was expanded
               * @param {Event} evt object if raised from an event
               */rowExpandedStateChanged:function(scope,row,evt){},/**
               * @ngdoc event
               * @name rowExpandedRendered
               * @eventOf  ui.grid.expandable.api:PublicApi
               * @description raised when expanded row is rendered
               * <pre>
               *      gridApi.expandable.on.rowExpandedRendered(scope,function(row, event) {})
               * </pre>
               * @param {scope} scope the application scope
               * @param {GridRow} row the row that was expanded
               * @param {Event} evt object if raised from an event
               */rowExpandedRendered:function(scope,row,evt){}}},methods:{expandable:{/**
               * @ngdoc method
               * @name toggleRowExpansion
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Toggle a specific row
               * <pre>
               *      gridApi.expandable.toggleRowExpansion(rowEntity, event);
               * </pre>
               * @param {object} rowEntity the data entity for the row you want to expand
               * @param {Event} [e] event (if exist)
               */toggleRowExpansion:function(rowEntity,e){var row=grid.getRow(rowEntity);if(row!==null){service.toggleRowExpansion(grid,row,e);}},/**
               * @ngdoc method
               * @name expandAllRows
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Expand all subgrids.
               * <pre>
               *      gridApi.expandable.expandAllRows();
               * </pre>
               */expandAllRows:function(){service.expandAllRows(grid);},/**
               * @ngdoc method
               * @name collapseAllRows
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Collapse all subgrids.
               * <pre>
               *      gridApi.expandable.collapseAllRows();
               * </pre>
               */collapseAllRows:function(){service.collapseAllRows(grid);},/**
               * @ngdoc method
               * @name toggleAllRows
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Toggle all subgrids.
               * <pre>
               *      gridApi.expandable.toggleAllRows();
               * </pre>
               */toggleAllRows:function(){service.toggleAllRows(grid);},/**
               * @ngdoc function
               * @name expandRow
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Expand the data row
               * @param {object} rowEntity gridOptions.data[] array instance
               */expandRow:function(rowEntity){var row=grid.getRow(rowEntity);if(row!==null&&!row.isExpanded){service.toggleRowExpansion(grid,row);}},/**
               * @ngdoc function
               * @name collapseRow
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description Collapse the data row
               * @param {object} rowEntity gridOptions.data[] array instance
               */collapseRow:function(rowEntity){var row=grid.getRow(rowEntity);if(row!==null&&row.isExpanded){service.toggleRowExpansion(grid,row);}},/**
               * @ngdoc function
               * @name getExpandedRows
               * @methodOf  ui.grid.expandable.api:PublicApi
               * @description returns all expandedRow's entity references
               */getExpandedRows:function(){return service.getExpandedRows(grid).map(function(gridRow){return gridRow.entity;});}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},/**
       *
       * @param grid
       * @param row
       * @param {Event} [e] event (if exist)
       */toggleRowExpansion:function(grid,row,e){// trigger the "before change" event. Can change row height dynamically this way.
grid.api.expandable.raise.rowExpandedBeforeStateChanged(row);/**
         *  @ngdoc object
         *  @name isExpanded
         *  @propertyOf  ui.grid.expandable.api:GridRow
         *  @description Whether or not the row is currently expanded.
         *  @example
         *  <pre>
         *    $scope.api.expandable.on.rowExpandedStateChanged($scope, function (row) {
         *      if (row.isExpanded) {
         *        //...
         *      }
         *    });
         *  </pre>
         */row.isExpanded=!row.isExpanded;if(angular.isUndefined(row.expandedRowHeight)){row.expandedRowHeight=grid.options.expandableRowHeight;}if(row.isExpanded){row.height=row.grid.options.rowHeight+row.expandedRowHeight;grid.expandable.expandedAll=service.getExpandedRows(grid).length===grid.rows.length;}else{row.height=row.grid.options.rowHeight;grid.expandable.expandedAll=false;}grid.api.expandable.raise.rowExpandedStateChanged(row,e);// fire event on render complete
function _tWatcher(){if(row.expandedRendered){grid.api.expandable.raise.rowExpandedRendered(row,e);}else{window.setTimeout(_tWatcher,1e2);}}_tWatcher();},expandAllRows:function(grid){grid.renderContainers.body.visibleRowCache.forEach(function(row){if(!row.isExpanded&&!(row.entity.subGridOptions&&row.entity.subGridOptions.disableRowExpandable)){service.toggleRowExpansion(grid,row);}});grid.expandable.expandedAll=true;grid.queueGridRefresh();},collapseAllRows:function(grid){grid.renderContainers.body.visibleRowCache.forEach(function(row){if(row.isExpanded){service.toggleRowExpansion(grid,row);}});grid.expandable.expandedAll=false;grid.queueGridRefresh();},toggleAllRows:function(grid){if(grid.expandable.expandedAll){service.collapseAllRows(grid);}else{service.expandAllRows(grid);}},getExpandedRows:function(grid){return grid.rows.filter(function(row){return row.isExpanded;});}};return service;}]);/**
   *  @ngdoc object
   *  @name enableExpandableRowHeader
   *  @propertyOf  ui.grid.expandable.api:GridOptions
   *  @description Show a rowHeader to provide the expandable buttons.  If set to false then implies
   *  you're going to use a custom method for expanding and collapsing the subgrids. Defaults to true.
   *  @example
   *  <pre>
   *    $scope.gridOptions = {
   *      enableExpandableRowHeader: false
   *    }
   *  </pre>
   */module.directive('uiGridExpandable',['uiGridExpandableService','$templateCache',function(uiGridExpandableService,$templateCache){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridExpandableService.initializeGrid(uiGridCtrl.grid);if(!uiGridCtrl.grid.options.enableExpandable){return;}if(uiGridCtrl.grid.options.enableExpandableRowHeader!==false){var expandableRowHeaderColDef={name:'expandableButtons',displayName:'',exporterSuppressExport:true,enableColumnResizing:false,enableColumnMenu:false,width:uiGridCtrl.grid.options.expandableRowHeaderWidth||30};expandableRowHeaderColDef.cellTemplate=$templateCache.get('ui-grid/expandableRowHeader');expandableRowHeaderColDef.headerCellTemplate=$templateCache.get('ui-grid/expandableTopRowHeader');uiGridCtrl.grid.addRowHeaderColumn(expandableRowHeaderColDef,-90);}},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.expandable.directive:uiGrid
   *  @description stacks on the uiGrid directive to register child grid with parent row when child is created
   */module.directive('uiGrid',function(){return{replace:true,priority:599,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridCtrl.grid.api.core.on.renderingComplete($scope,function(){// if a parent grid row is on the scope, then add the parentRow property to this childGrid
if($scope.row&&$scope.row.grid&&$scope.row.grid.options&&$scope.row.grid.options.enableExpandable){/**
                   *  @ngdoc directive
                   *  @name ui.grid.expandable.class:Grid
                   *  @description Additional Grid properties added by expandable module
                   */ /**
                   *  @ngdoc object
                   *  @name parentRow
                   *  @propertyOf ui.grid.expandable.class:Grid
                   *  @description reference to the expanded parent row that owns this grid
                   */uiGridCtrl.grid.parentRow=$scope.row;// todo: adjust height on parent row when child grid height changes. we need some sort of gridHeightChanged event
// uiGridCtrl.grid.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
//   uiGridCtrl.grid.parentRow = newHeight;
// });
}});},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};});/**
   *  @ngdoc directive
   *  @name ui.grid.expandable.directive:uiGridExpandableRow
   *  @description directive to render the Row template on Expand
   */module.directive('uiGridExpandableRow',['uiGridExpandableService','$compile','uiGridConstants','gridUtil',function(uiGridExpandableService,$compile,uiGridConstants,gridUtil){return{replace:false,priority:0,scope:false,compile:function(){return{pre:function($scope,$elm){gridUtil.getTemplate($scope.grid.options.expandableRowTemplate).then(function(template){if($scope.grid.options.expandableRowScope){/**
                     *  @ngdoc object
                     *  @name expandableRowScope
                     *  @propertyOf  ui.grid.expandable.api:GridOptions
                     *  @description  Variables of object expandableScope will be available in the scope of the expanded subgrid
                     *  @example
                     *  <pre>
                     *    $scope.gridOptions = {
                     *      expandableRowScope: expandableScope
                     *    }
                     *  </pre>
                     */var expandableRowScope=$scope.grid.options.expandableRowScope;for(var property in expandableRowScope){if(expandableRowScope.hasOwnProperty(property)){$scope[property]=expandableRowScope[property];}}}var expandedRowElement=angular.element(template);expandedRowElement=$compile(expandedRowElement)($scope);$elm.append(expandedRowElement);$scope.row.element=$elm;$scope.row.expandedRendered=true;});},post:function($scope,$elm){$scope.row.element=$elm;$scope.$on('$destroy',function(){$scope.row.expandedRendered=false;});}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.expandable.directive:uiGridRow
   *  @description stacks on the uiGridRow directive to add support for expandable rows
   */module.directive('uiGridRow',function(){return{priority:-200,scope:false,compile:function(){return{pre:function($scope,$elm){if(!$scope.grid.options.enableExpandable){return;}$scope.expandableRow={};$scope.expandableRow.shouldRenderExpand=function(){return $scope.colContainer.name==='body'&&$scope.grid.options.enableExpandable!==false&&$scope.row.isExpanded&&(!$scope.grid.isScrollingVertically||$scope.row.expandedRendered);};$scope.expandableRow.shouldRenderFiller=function(){return $scope.row.isExpanded&&($scope.colContainer.name!=='body'||$scope.grid.isScrollingVertically&&!$scope.row.expandedRendered);};if($scope.grid.options.enableOnDblClickExpand){$elm.on('dblclick',function(event){// if necessary, it is possible for everyone to stop the processing of a single click OR
// Inside the Config in the output agent to enter a line:
// event.stopPropagation()
$scope.grid.api.expandable.toggleRowExpansion($scope.row.entity,event);});}},post:function($scope,$elm,$attrs,controllers){}};}};});/**
   *  @ngdoc directive
   *  @name ui.grid.expandable.directive:uiGridViewport
   *  @description stacks on the uiGridViewport directive to append the expandable row html elements to the
   *  default gridRow template
   */module.directive('uiGridViewport',['$compile','gridUtil','$templateCache',function($compile,gridUtil,$templateCache){return{priority:-200,scope:false,compile:function($elm){// todo: this adds ng-if watchers to each row even if the grid is not using expandable directive
//      or options.enableExpandable == false
//      The alternative is to compile the template and append to each row in a uiGridRow directive
var rowRepeatDiv=angular.element($elm.children().children()[0]),expandedRowFillerElement=$templateCache.get('ui-grid/expandableScrollFiller'),expandedRowElement=$templateCache.get('ui-grid/expandableRow');rowRepeatDiv.append(expandedRowElement);rowRepeatDiv.append(expandedRowFillerElement);return{pre:function($scope,$elm,$attrs,controllers){},post:function($scope,$elm,$attrs,controllers){}};}};}]);})();/* global ExcelBuilder */ /* global console */(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.exporter
   * @description
   *
   * # ui.grid.exporter
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module provides the ability to export data from the grid.
   *
   * Data can be exported in a range of formats, and all data, visible
   * data, or selected rows can be exported, with all columns or visible
   * columns.
   *
   * No UI is provided, the caller should provide their own UI/buttons
   * as appropriate, or enable the gridMenu
   *
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.exporter"></div>
   */var module=angular.module('ui.grid.exporter',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.exporter.constant:uiGridExporterConstants
   *
   *  @description constants available in exporter module
   */ /**
   * @ngdoc property
   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
   * @name ALL
   * @description export all data, including data not visible.  Can
   * be set for either rowTypes or colTypes
   */ /**
   * @ngdoc property
   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
   * @name VISIBLE
   * @description export only visible data, including data not visible.  Can
   * be set for either rowTypes or colTypes
   */ /**
   * @ngdoc property
   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
   * @name SELECTED
   * @description export all data, including data not visible.  Can
   * be set only for rowTypes, selection of only some columns is
   * not supported
   */module.constant('uiGridExporterConstants',{featureName:'exporter',rowHeaderColName:'treeBaseRowHeaderCol',selectionRowHeaderColName:'selectionRowHeaderCol',ALL:'all',VISIBLE:'visible',SELECTED:'selected',CSV_CONTENT:'CSV_CONTENT',BUTTON_LABEL:'BUTTON_LABEL',FILE_NAME:'FILE_NAME'});/**
   *  @ngdoc service
   *  @name ui.grid.exporter.service:uiGridExporterService
   *
   *  @description Services for exporter feature
   */module.service('uiGridExporterService',['$filter','$q','uiGridExporterConstants','gridUtil','$compile','$interval','i18nService',function($filter,$q,uiGridExporterConstants,gridUtil,$compile,$interval,i18nService){var service={delay:100,type:null,initializeGrid:function(grid){// add feature namespace and any properties to grid for needed state
grid.exporter={};this.defaultGridOptions(grid.options);/**
           *  @ngdoc object
           *  @name ui.grid.exporter.api:PublicApi
           *
           *  @description Public Api for exporter feature
           */var publicApi={events:{exporter:{}},methods:{exporter:{/**
                 * @ngdoc function
                 * @name csvExport
                 * @methodOf  ui.grid.exporter.api:PublicApi
                 * @description Exports rows from the grid in csv format,
                 * the data exported is selected based on the provided options
                 * @param {string} rowTypes which rows to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
                 * uiGridExporterConstants.SELECTED
                 * @param {string} colTypes which columns to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
                 */csvExport:function(rowTypes,colTypes){service.csvExport(grid,rowTypes,colTypes);},/**
                 * @ngdoc function
                 * @name pdfExport
                 * @methodOf  ui.grid.exporter.api:PublicApi
                 * @description Exports rows from the grid in pdf format,
                 * the data exported is selected based on the provided options
                 * Note that this function has a dependency on pdfMake, all
                 * going well this has been installed for you.
                 * The resulting pdf opens in a new browser window.
                 * @param {string} rowTypes which rows to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
                 * uiGridExporterConstants.SELECTED
                 * @param {string} colTypes which columns to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
                 */pdfExport:function(rowTypes,colTypes){service.pdfExport(grid,rowTypes,colTypes);},/**
                 * @ngdoc function
                 * @name excelExport
                 * @methodOf  ui.grid.exporter.api:PublicApi
                 * @description Exports rows from the grid in excel format,
                 * the data exported is selected based on the provided options
                 * @param {string} rowTypes which rows to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
                 * uiGridExporterConstants.SELECTED
                 * @param {string} colTypes which columns to export, valid values are
                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
                 */excelExport:function(rowTypes,colTypes){service.excelExport(grid,rowTypes,colTypes);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);if(grid.api.core.addToGridMenu){service.addToMenu(grid);}else{// order of registration is not guaranteed, register in a little while
$interval(function(){if(grid.api.core.addToGridMenu){service.addToMenu(grid);}},this.delay,1);}},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
           * @ngdoc object
           * @name ui.grid.exporter.api:GridOptions
           *
           * @description GridOptions for exporter feature, these are available to be
           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           * @ngdoc object
           * @name ui.grid.exporter.api:ColumnDef
           * @description ColumnDef settings for exporter
           */ /**
           * @ngdoc object
           * @name exporterSuppressMenu
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Don't show the export menu button, implying the user
           * will roll their own UI for calling the exporter
           * <br/>Defaults to false
           */gridOptions.exporterSuppressMenu=gridOptions.exporterSuppressMenu===true;/**
           * @ngdoc object
           * @name exporterMenuLabel
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The text to show on the exporter menu button
           * link
           * <br/>Defaults to 'Export'
           */gridOptions.exporterMenuLabel=gridOptions.exporterMenuLabel?gridOptions.exporterMenuLabel:'Export';/**
           * @ngdoc object
           * @name exporterSuppressColumns
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Columns that should not be exported.  The selectionRowHeader is already automatically
           * suppressed, but if you had a button column or some other "system" column that shouldn't be shown in the
           * output then add it in this list.  You should provide an array of column names.
           * <br/>Defaults to: []
           * <pre>
           *   gridOptions.exporterSuppressColumns = [ 'buttons' ];
           * </pre>
           */gridOptions.exporterSuppressColumns=gridOptions.exporterSuppressColumns?gridOptions.exporterSuppressColumns:[];/**
           * @ngdoc object
           * @name exporterCsvColumnSeparator
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The character to use as column separator
           * link
           * <br/>Defaults to ','
           */gridOptions.exporterCsvColumnSeparator=gridOptions.exporterCsvColumnSeparator?gridOptions.exporterCsvColumnSeparator:',';/**
           * @ngdoc object
           * @name exporterCsvFilename
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The default filename to use when saving the downloaded csv.
           * This will only work in some browsers.
           * <br/>Defaults to 'download.csv'
           * <pre>
           *   gridOptions.exporterCsvFilename = "rows.csv"
           * </pre>
           * <br/>Or a function returning a string:
           * <pre>
           *   gridOptions.exporterCsvFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".csv" };
           * </pre>
           */gridOptions.exporterCsvFilename=gridOptions.exporterCsvFilename?gridOptions.exporterCsvFilename:'download.csv';/**
           * @ngdoc object
           * @name exporterPdfFilename
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The default filename to use when saving the downloaded pdf, only used in IE (other browsers open pdfs in a new window)
           * <br/>Defaults to 'download.pdf'
           * <pre>
           *   gridOptions.exporterPdfFilename = "rows.pdf"
           * </pre>
           * <br/>Or a function returning a string:
           * <pre>
           *   gridOptions.exporterPdfFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".pdf" };
           * </pre>
           */gridOptions.exporterPdfFilename=gridOptions.exporterPdfFilename?gridOptions.exporterPdfFilename:'download.pdf';/**
           * @ngdoc object
           * @name exporterExcelFilename
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The default filename to use when saving the downloaded excel, only used in IE (other browsers open excels in a new window)
           * <br/>Defaults to 'download.xlsx'
           * <pre>
           *   gridOptions.exporterExcelFilename = "rows.xlsx"
           * </pre>
           * <br/>Or a function returning a string:
           * <pre>
           *   gridOptions.exporterExcelFilename = function(grid, rowTypes, colTypes) { return "rows" + rowTypes + ".xlsx" };
           * </pre>
           */gridOptions.exporterExcelFilename=gridOptions.exporterExcelFilename?gridOptions.exporterExcelFilename:'download.xlsx';/**
           * @ngdoc object
           * @name exporterExcelSheetName
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The default sheetname to use when saving the downloaded to excel
           * <br/>Defaults to 'Sheet1'
           * <pre>
           *   gridOptions.exporterExcelSheetName = "HitListSheet"
           * </pre>
           * <br/>Or a function returning a string:
           * <pre>
           *   gridOptions.exporterExcelSheetName = function(grid, rowTypes, colTypes) { return "HitListSheet" + rowTypes };
           * </pre>
           */gridOptions.exporterExcelSheetName=gridOptions.exporterExcelSheetName?gridOptions.exporterExcelSheetName:'Sheet1';/**
           * @ngdoc object
           * @name exporterOlderExcelCompatibility
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Some versions of excel don't like the utf-16 BOM on the front, and it comes
           * through as ï»¿ in the first column header.  Setting this option to false will suppress this, at the
           * expense of proper utf-16 handling in applications that do recognise the BOM
           * <br/>Defaults to false
           */gridOptions.exporterOlderExcelCompatibility=gridOptions.exporterOlderExcelCompatibility===true;/**
           * @ngdoc object
           * @name exporterIsExcelCompatible
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Separator header, used to set a custom column separator in a csv file, only works on MS Excel.
           * Used it on other programs will make csv content display unproperly. Setting this option to false won't add this header.
           * <br/>Defaults to false
           */gridOptions.exporterIsExcelCompatible=gridOptions.exporterIsExcelCompatible===true;/**
           * @ngdoc object
           * @name exporterMenuItemOrder
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description An option to determine the starting point for the menu items created by the exporter
           * <br/>Defaults to 200
           */gridOptions.exporterMenuItemOrder=gridOptions.exporterMenuItemOrder?gridOptions.exporterMenuItemOrder:200;/**
           * @ngdoc object
           * @name exporterPdfDefaultStyle
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The default style in pdfMake format
           * <br/>Defaults to:
           * <pre>
           *   {
           *     fontSize: 11
           *   }
           * </pre>
           */gridOptions.exporterPdfDefaultStyle=gridOptions.exporterPdfDefaultStyle?gridOptions.exporterPdfDefaultStyle:{fontSize:11};/**
           * @ngdoc object
           * @name exporterPdfTableStyle
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The table style in pdfMake format
           * <br/>Defaults to:
           * <pre>
           *   {
           *     margin: [0, 5, 0, 15]
           *   }
           * </pre>
           */gridOptions.exporterPdfTableStyle=gridOptions.exporterPdfTableStyle?gridOptions.exporterPdfTableStyle:{margin:[0,5,0,15]};/**
           * @ngdoc object
           * @name exporterPdfTableHeaderStyle
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The tableHeader style in pdfMake format
           * <br/>Defaults to:
           * <pre>
           *   {
           *     bold: true,
           *     fontSize: 12,
           *     color: 'black'
           *   }
           * </pre>
           */gridOptions.exporterPdfTableHeaderStyle=gridOptions.exporterPdfTableHeaderStyle?gridOptions.exporterPdfTableHeaderStyle:{bold:true,fontSize:12,color:'black'};/**
           * @ngdoc object
           * @name exporterPdfHeader
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The header section for pdf exports.  Can be
           * simple text:
           * <pre>
           *   gridOptions.exporterPdfHeader = 'My Header';
           * </pre>
           * Can be a more complex object in pdfMake format:
           * <pre>
           *   gridOptions.exporterPdfHeader = {
           *     columns: [
           *       'Left part',
           *       { text: 'Right part', alignment: 'right' }
           *     ]
           *   };
           * </pre>
           * Or can be a function, allowing page numbers and the like
           * <pre>
           *   gridOptions.exporterPdfHeader: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
           * </pre>
           */gridOptions.exporterPdfHeader=gridOptions.exporterPdfHeader?gridOptions.exporterPdfHeader:null;/**
           * @ngdoc object
           * @name exporterPdfFooter
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The header section for pdf exports.  Can be
           * simple text:
           * <pre>
           *   gridOptions.exporterPdfFooter = 'My Footer';
           * </pre>
           * Can be a more complex object in pdfMake format:
           * <pre>
           *   gridOptions.exporterPdfFooter = {
           *     columns: [
           *       'Left part',
           *       { text: 'Right part', alignment: 'right' }
           *     ]
           *   };
           * </pre>
           * Or can be a function, allowing page numbers and the like
           * <pre>
           *   gridOptions.exporterPdfFooter: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
           * </pre>
           */gridOptions.exporterPdfFooter=gridOptions.exporterPdfFooter?gridOptions.exporterPdfFooter:null;/**
           * @ngdoc object
           * @name exporterPdfOrientation
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The orientation, should be a valid pdfMake value,
           * 'landscape' or 'portrait'
           * <br/>Defaults to landscape
           */gridOptions.exporterPdfOrientation=gridOptions.exporterPdfOrientation?gridOptions.exporterPdfOrientation:'landscape';/**
           * @ngdoc object
           * @name exporterPdfPageSize
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The orientation, should be a valid pdfMake
           * paper size, usually 'A4' or 'LETTER'
           * {@link https://github.com/bpampuch/pdfmake/blob/master/src/standardPageSizes.js pdfMake page sizes}
           * <br/>Defaults to A4
           */gridOptions.exporterPdfPageSize=gridOptions.exporterPdfPageSize?gridOptions.exporterPdfPageSize:'A4';/**
           * @ngdoc object
           * @name exporterPdfMaxGridWidth
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description The maxium grid width - the current grid width
           * will be scaled to match this, with any fixed width columns
           * being adjusted accordingly.
           * <br/>Defaults to 720 (for A4 landscape), use 670 for LETTER
           */gridOptions.exporterPdfMaxGridWidth=gridOptions.exporterPdfMaxGridWidth?gridOptions.exporterPdfMaxGridWidth:720;/**
           * @ngdoc object
           * @name exporterPdfTableLayout
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A tableLayout in pdfMake format,
           * controls gridlines and the like.  We use the default
           * layout usually.
           * <br/>Defaults to null, which means no layout
           */ /**
           * @ngdoc object
           * @name exporterMenuAllData
           * @propertyOf ui.grid.exporter.api:GridOptions
           * @description Add export all data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuAllData=gridOptions.exporterMenuAllData!==undefined?gridOptions.exporterMenuAllData:true;/**
           * @ngdoc object
           * @name exporterMenuVisibleData
           * @propertyOf ui.grid.exporter.api:GridOptions
           * @description Add export visible data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuVisibleData=gridOptions.exporterMenuVisibleData!==undefined?gridOptions.exporterMenuVisibleData:true;/**
           * @ngdoc object
           * @name exporterMenuSelectedData
           * @propertyOf ui.grid.exporter.api:GridOptions
           * @description Add export selected data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuSelectedData=gridOptions.exporterMenuSelectedData!==undefined?gridOptions.exporterMenuSelectedData:true;/**
           * @ngdoc object
           * @name exporterMenuCsv
           * @propertyOf ui.grid.exporter.api:GridOptions
           * @description Add csv export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuCsv=gridOptions.exporterMenuCsv!==undefined?gridOptions.exporterMenuCsv:true;/**
           * @ngdoc object
           * @name exporterMenuPdf
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Add pdf export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuPdf=gridOptions.exporterMenuPdf!==undefined?gridOptions.exporterMenuPdf:true;/**
           * @ngdoc object
           * @name exporterMenuExcel
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Add excel export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
           */gridOptions.exporterMenuExcel=gridOptions.exporterMenuExcel!==undefined?gridOptions.exporterMenuExcel:true;/**
           * @ngdoc object
           * @name exporterPdfCustomFormatter
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A custom callback routine that changes the pdf document, adding any
           * custom styling or content that is supported by pdfMake.  Takes in the complete docDefinition, and
           * must return an updated docDefinition ready for pdfMake.
           * @example
           * In this example we add a style to the style array, so that we can use it in our
           * footer definition.
           * <pre>
           *   gridOptions.exporterPdfCustomFormatter = function ( docDefinition ) {
           *     docDefinition.styles.footerStyle = { bold: true, fontSize: 10 };
           *     return docDefinition;
           *   }
           *
           *   gridOptions.exporterPdfFooter = { text: 'My footer', style: 'footerStyle' }
           * </pre>
           */gridOptions.exporterPdfCustomFormatter=gridOptions.exporterPdfCustomFormatter&&typeof gridOptions.exporterPdfCustomFormatter==='function'?gridOptions.exporterPdfCustomFormatter:function(docDef){return docDef;};/**
           * @ngdoc object
           * @name exporterHeaderFilterUseName
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Defaults to false, which leads to `displayName` being passed into the headerFilter.
           * If set to true, then will pass `name` instead.
           *
           *
           * @example
           * <pre>
           *   gridOptions.exporterHeaderFilterUseName = true;
           * </pre>
           */gridOptions.exporterHeaderFilterUseName=gridOptions.exporterHeaderFilterUseName===true;/**
           * @ngdoc object
           * @name exporterHeaderFilter
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A function to apply to the header displayNames before exporting.  Useful for internationalisation,
           * for example if you were using angular-translate you'd set this to `$translate.instant`.  Note that this
           * call must be synchronous, it cannot be a call that returns a promise.
           *
           * Behaviour can be changed to pass in `name` instead of `displayName` through use of `exporterHeaderFilterUseName: true`.
           *
           * @example
           * <pre>
           *   gridOptions.exporterHeaderFilter = function( displayName ) { return 'col: ' + name; };
           * </pre>
           * OR
           * <pre>
           *   gridOptions.exporterHeaderFilter = $translate.instant;
           * </pre>
           */ /**
           * @ngdoc function
           * @name exporterFieldCallback
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A function to call for each field before exporting it.  Allows
           * massaging of raw data into a display format, for example if you have applied
           * filters to convert codes into decodes, or you require
           * a specific date format in the exported content.
           *
           * The method is called once for each field exported, and provides the grid, the
           * gridCol and the GridRow for you to use as context in massaging the data.
           *
           * @param {Grid} grid provides the grid in case you have need of it
           * @param {GridRow} row the row from which the data comes
           * @param {GridColumn} col the column from which the data comes
           * @param {object} value the value for your massaging
           * @returns {object} you must return the massaged value ready for exporting
           *
           * @example
           * <pre>
           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
           *     if ( col.name === 'status' ) {
           *       value = decodeStatus( value );
           *     }
           *     return value;
           *   }
           * </pre>
           */gridOptions.exporterFieldCallback=gridOptions.exporterFieldCallback?gridOptions.exporterFieldCallback:defaultExporterFieldCallback;/**
           * @ngdoc function
           * @name exporterFieldFormatCallback
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A function to call for each field before exporting it.  Allows
           * general object to be return to modify the format of a cell in the case of
           * excel exports
           *
           * The method is called once for each field exported, and provides the grid, the
           * gridCol and the GridRow for you to use as context in massaging the data.
           *
           * @param {Grid} grid provides the grid in case you have need of it
           * @param {GridRow} row the row from which the data comes
           * @param {GridColumn} col the column from which the data comes
           * @param {object} value the value for your massaging
           * @returns {object} you must return the massaged value ready for exporting
           *
           * @example
           * <pre>
           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ) {
           *     if ( col.name === 'status' ) {
           *       value = decodeStatus( value );
           *     }
           *     return value;
           *   }
           * </pre>
           */gridOptions.exporterFieldFormatCallback=gridOptions.exporterFieldFormatCallback?gridOptions.exporterFieldFormatCallback:function(grid,row,col,value){return null;};/**
           * @ngdoc function
           * @name exporterExcelCustomFormatters
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A function to call to setup formatters and store on docDefinition.
           *
           * The method is called at the start and can setup all the formatters to export to excel
           *
           * @param {Grid} grid provides the grid in case you have need of it
           * @param {Workbook} row the row from which the data comes
           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
           * @returns {docDefinition} Updated docDefinition with formatter styles
           *
           * @example
           * <pre>
           *   gridOptions.exporterExcelCustomFormatters = function(grid, workbook, docDefinition) {
           *     const formatters = {};
           *     const stylesheet = workbook.getStyleSheet();
           *     const headerFormatDefn = {
           *       'font': { 'size': 11, 'fontName': 'Calibri', 'bold': true },
           *       'alignment': { 'wrapText': false }
           *     };
           *
           *     formatters['header'] = headerFormatter;
           *     Object.assign(docDefinition.styles , formatters);
           *     grid.docDefinition = docDefinition;
           *     return docDefinition;
           *   }
           * </pre>
           */gridOptions.exporterExcelCustomFormatters=gridOptions.exporterExcelCustomFormatters?gridOptions.exporterExcelCustomFormatters:function(grid,workbook,docDefinition){return docDefinition;};/**
           * @ngdoc function
           * @name exporterExcelHeader
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A function to write formatted header data to sheet.
           *
           * The method is called to provide custom header building for Excel. This data comes before the grid header
           *
           * @param {grid} grid provides the grid in case you have need of it
           * @param {Workbook} row the row from which the data comes
           * @param {Sheet} the sheet to insert data
           * @param {docDefinition} The docDefinition that will have styles as a object to store formatters
           * @returns {docDefinition} Updated docDefinition with formatter styles
           *
           * @example
           * <pre>
           *   gridOptions.exporterExcelCustomFormatters = function (grid, workbook, sheet, docDefinition) {
           *      const headerFormatter = docDefinition.styles['header'];
           *      let cols = [];
           *      // push data in A1 cell with metadata formatter
           *      cols.push({ value: 'Summary Report', metadata: {style: headerFormatter.id} });
           *      sheet.data.push(cols);
           *   }
           * </pre>
           */gridOptions.exporterExcelHeader=gridOptions.exporterExcelHeader?gridOptions.exporterExcelHeader:function(grid,workbook,sheet,docDefinition){return null;};/**
           * @ngdoc object
           * @name exporterColumnScaleFactor
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description A scaling factor to divide the drawnwidth of a column to convert to target excel column
           * format size
           * @example
           * In this example we add a number to divide the drawnwidth of a column to get the excel width.
           * <br/>Defaults to 3.5
           */gridOptions.exporterColumnScaleFactor=gridOptions.exporterColumnScaleFactor?gridOptions.exporterColumnScaleFactor:3.5;/**
           * @ngdoc object
           * @name exporterFieldApplyFilters
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description Defaults to false, which leads to filters being evaluated on export           *
           *
           * @example
           * <pre>
           *   gridOptions.exporterFieldApplyFilters = true;
           * </pre>
           */gridOptions.exporterFieldApplyFilters=gridOptions.exporterFieldApplyFilters===true;/**
           * @ngdoc function
           * @name exporterAllDataFn
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description This promise is needed when exporting all rows,
           * and the data need to be provided by server side. Default is null.
           * @returns {Promise} a promise to load all data from server
           *
           * @example
           * <pre>
           *   gridOptions.exporterAllDataFn = function () {
           *     return $http.get('/data/100.json')
           *   }
           * </pre>
           */gridOptions.exporterAllDataFn=gridOptions.exporterAllDataFn?gridOptions.exporterAllDataFn:null;/**
           * @ngdoc function
           * @name exporterAllDataPromise
           * @propertyOf  ui.grid.exporter.api:GridOptions
           * @description DEPRECATED - exporterAllDataFn used to be
           * called this, but it wasn't a promise, it was a function that returned
           * a promise.  Deprecated, but supported for backward compatibility, use
           * exporterAllDataFn instead.
           * @returns {Promise} a promise to load all data from server
           *
           * @example
           * <pre>
           *   gridOptions.exporterAllDataFn = function () {
           *     return $http.get('/data/100.json')
           *   }
           * </pre>
           */if(gridOptions.exporterAllDataFn===null&&gridOptions.exporterAllDataPromise){gridOptions.exporterAllDataFn=gridOptions.exporterAllDataPromise;}},/**
         * @ngdoc function
         * @name addToMenu
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Adds export items to the grid menu,
         * allowing the user to select export options
         * @param {Grid} grid the grid from which data should be exported
         */addToMenu:function(grid){grid.api.core.addToGridMenu(grid,[{title:i18nService.getSafeText('gridMenu.exporterAllAsCsv'),action:function(){grid.api.exporter.csvExport(uiGridExporterConstants.ALL,uiGridExporterConstants.ALL);},shown:function(){return grid.options.exporterMenuCsv&&grid.options.exporterMenuAllData;},order:grid.options.exporterMenuItemOrder},{title:i18nService.getSafeText('gridMenu.exporterVisibleAsCsv'),action:function(){grid.api.exporter.csvExport(uiGridExporterConstants.VISIBLE,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuCsv&&grid.options.exporterMenuVisibleData;},order:grid.options.exporterMenuItemOrder+1},{title:i18nService.getSafeText('gridMenu.exporterSelectedAsCsv'),action:function(){grid.api.exporter.csvExport(uiGridExporterConstants.SELECTED,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuCsv&&grid.options.exporterMenuSelectedData&&grid.api.selection&&grid.api.selection.getSelectedRows().length>0;},order:grid.options.exporterMenuItemOrder+2},{title:i18nService.getSafeText('gridMenu.exporterAllAsPdf'),action:function(){grid.api.exporter.pdfExport(uiGridExporterConstants.ALL,uiGridExporterConstants.ALL);},shown:function(){return grid.options.exporterMenuPdf&&grid.options.exporterMenuAllData;},order:grid.options.exporterMenuItemOrder+3},{title:i18nService.getSafeText('gridMenu.exporterVisibleAsPdf'),action:function(){grid.api.exporter.pdfExport(uiGridExporterConstants.VISIBLE,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuPdf&&grid.options.exporterMenuVisibleData;},order:grid.options.exporterMenuItemOrder+4},{title:i18nService.getSafeText('gridMenu.exporterSelectedAsPdf'),action:function(){grid.api.exporter.pdfExport(uiGridExporterConstants.SELECTED,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuPdf&&grid.options.exporterMenuSelectedData&&grid.api.selection&&grid.api.selection.getSelectedRows().length>0;},order:grid.options.exporterMenuItemOrder+5},{title:i18nService.getSafeText('gridMenu.exporterAllAsExcel'),action:function(){grid.api.exporter.excelExport(uiGridExporterConstants.ALL,uiGridExporterConstants.ALL);},shown:function(){return grid.options.exporterMenuExcel&&grid.options.exporterMenuAllData;},order:grid.options.exporterMenuItemOrder+6},{title:i18nService.getSafeText('gridMenu.exporterVisibleAsExcel'),action:function(){grid.api.exporter.excelExport(uiGridExporterConstants.VISIBLE,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuExcel&&grid.options.exporterMenuVisibleData;},order:grid.options.exporterMenuItemOrder+7},{title:i18nService.getSafeText('gridMenu.exporterSelectedAsExcel'),action:function(){grid.api.exporter.excelExport(uiGridExporterConstants.SELECTED,uiGridExporterConstants.VISIBLE);},shown:function(){return grid.options.exporterMenuExcel&&grid.options.exporterMenuSelectedData&&grid.api.selection&&grid.api.selection.getSelectedRows().length>0;},order:grid.options.exporterMenuItemOrder+8}]);},/**
         * @ngdoc function
         * @name csvExport
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Exports rows from the grid in csv format,
         * the data exported is selected based on the provided options
         * @param {Grid} grid the grid from which data should be exported
         * @param {string} rowTypes which rows to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         * @param {string} colTypes which columns to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         */csvExport:function(grid,rowTypes,colTypes){var self=this;self.type='csv';this.loadAllDataIfNeeded(grid,rowTypes,colTypes).then(function(){var exportColumnHeaders=grid.options.showHeader?self.getColumnHeaders(grid,colTypes):[];var exportData=self.getData(grid,rowTypes,colTypes);var csvContent=self.formatAsCsv(exportColumnHeaders,exportData,grid.options.exporterCsvColumnSeparator);var fileName=angular.isFunction(grid.options.exporterCsvFilename)?grid.options.exporterCsvFilename(grid,rowTypes,colTypes):grid.options.exporterCsvFilename;self.downloadFile(fileName,csvContent,grid.options.exporterCsvColumnSeparator,grid.options.exporterOlderExcelCompatibility,grid.options.exporterIsExcelCompatible);});},/**
         * @ngdoc function
         * @name loadAllDataIfNeeded
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description When using server side pagination, use exporterAllDataFn to
         * load all data before continuing processing.
         * When using client side pagination, return a resolved promise so processing
         * continues immediately
         * @param {Grid} grid the grid from which data should be exported
         * @param {string} rowTypes which rows to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         * @param {string} colTypes which columns to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         */loadAllDataIfNeeded:function(grid,rowTypes,colTypes){if(rowTypes===uiGridExporterConstants.ALL&&grid.rows.length!==grid.options.totalItems&&grid.options.exporterAllDataFn){return grid.options.exporterAllDataFn().then(function(allData){grid.modifyRows(allData);});}else{var deferred=$q.defer();deferred.resolve();return deferred.promise;}},/**
         * @ngdoc property
         * @propertyOf ui.grid.exporter.api:ColumnDef
         * @name exporterSuppressExport
         * @description Suppresses export for this column.  Used by selection and expandable.
         */ /**
         * @ngdoc function
         * @name getColumnHeaders
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Gets the column headers from the grid to use
         * as a title row for the exported file, all headers have
         * headerCellFilters applied as appropriate.
         *
         * Column headers are an array of objects, each object has
         * name, displayName, width and align attributes.  Only name is
         * used for csv, all attributes are used for pdf.
         *
         * @param {Grid} grid the grid from which data should be exported
         * @param {string} colTypes which columns to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         */getColumnHeaders:function(grid,colTypes){var headers=[],columns;if(colTypes===uiGridExporterConstants.ALL){columns=grid.columns;}else{var leftColumns=grid.renderContainers.left?grid.renderContainers.left.visibleColumnCache.filter(function(column){return column.visible;}):[],bodyColumns=grid.renderContainers.body?grid.renderContainers.body.visibleColumnCache.filter(function(column){return column.visible;}):[],rightColumns=grid.renderContainers.right?grid.renderContainers.right.visibleColumnCache.filter(function(column){return column.visible;}):[];columns=leftColumns.concat(bodyColumns,rightColumns);}columns.forEach(function(gridCol){// $$hashKey check since when grouping and sorting pragmatically this ends up in export. Filtering it out
if(gridCol.colDef.exporterSuppressExport!==true&&gridCol.field!=='$$hashKey'&&grid.options.exporterSuppressColumns.indexOf(gridCol.name)===-1){var headerEntry={name:gridCol.field,displayName:getDisplayName(grid,gridCol),width:gridCol.drawnWidth?gridCol.drawnWidth:gridCol.width,align:gridCol.colDef.align?gridCol.colDef.align:gridCol.colDef.type==='number'?'right':'left'};headers.push(headerEntry);}});return headers;},/**
         * @ngdoc property
         * @propertyOf ui.grid.exporter.api:ColumnDef
         * @name exporterPdfAlign
         * @description the alignment you'd like for this specific column when
         * exported into a pdf.  Can be 'left', 'right', 'center' or any other
         * valid pdfMake alignment option.
         */ /**
         * @ngdoc object
         * @name ui.grid.exporter.api:GridRow
         * @description GridRow settings for exporter
         */ /**
         * @ngdoc object
         * @name exporterEnableExporting
         * @propertyOf  ui.grid.exporter.api:GridRow
         * @description If set to false, then don't export this row, notwithstanding visible or
         * other settings
         * <br/>Defaults to true
         */ /**
         * @ngdoc function
         * @name getRowsFromNode
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Gets rows from a node. If the node is grouped it will
         * recurse down into the children to get to the raw data element
         * which is a row without children (a leaf).
         * @param {Node} aNode the tree node on the grid
         * @returns {Array} an array with all child nodes from aNode
         */getRowsFromNode:function(aNode){var rows=[];// Push parent node if it is not undefined and has values other than 'children'
var nodeKeys=aNode?Object.keys(aNode):['children'];if(nodeKeys.length>1||nodeKeys[0]!='children'){rows.push(aNode);}if(aNode&&aNode.children&&aNode.children.length>0){for(var i=0;i<aNode.children.length;i++){rows=rows.concat(this.getRowsFromNode(aNode.children[i]));}}return rows;},/**
         * @ngdoc function
         * @name getDataSorted
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Gets rows from a node. If the node is grouped it will
         * recurse down into the children to get to the raw data element
         * which is a row without children (a leaf). If the grid is not
         * grouped this will return just the raw rows
         * @param {Grid} grid the grid from which data should be exported
         * @returns {Array} an array of leaf nodes
         */getDataSorted:function(grid){if(!grid.treeBase||grid.treeBase.numberLevels===0){return grid.rows;}var rows=[];for(var i=0;i<grid.treeBase.tree.length;i++){var nodeRows=this.getRowsFromNode(grid.treeBase.tree[i]);for(var j=0;j<nodeRows.length;j++){rows.push(nodeRows[j].row);}}return rows;},/**
         * @ngdoc function
         * @name getData
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Gets data from the grid based on the provided options,
         * all cells have cellFilters applied as appropriate.  Any rows marked
         * `exporterEnableExporting: false` will not be exported
         * @param {Grid} grid the grid from which data should be exported
         * @param {string} rowTypes which rows to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         * @param {string} colTypes which columns to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         * @param {boolean} applyCellFilters whether or not to get the display value or the raw value of the data
         */getData:function(grid,rowTypes,colTypes,applyCellFilters){var data=[],rows,columns;switch(rowTypes){case uiGridExporterConstants.ALL:rows=this.getDataSorted(grid,rowTypes,colTypes,applyCellFilters);break;case uiGridExporterConstants.VISIBLE:rows=grid.getVisibleRows();break;case uiGridExporterConstants.SELECTED:if(grid.api.selection){rows=grid.api.selection.getSelectedGridRows();}else{gridUtil.logError('selection feature must be enabled to allow selected rows to be exported');}break;}if(colTypes===uiGridExporterConstants.ALL){columns=grid.columns;}else{var leftColumns=grid.renderContainers.left?grid.renderContainers.left.visibleColumnCache.filter(function(column){return column.visible;}):[];var bodyColumns=grid.renderContainers.body?grid.renderContainers.body.visibleColumnCache.filter(function(column){return column.visible;}):[];var rightColumns=grid.renderContainers.right?grid.renderContainers.right.visibleColumnCache.filter(function(column){return column.visible;}):[];columns=leftColumns.concat(bodyColumns,rightColumns);}rows.forEach(function(row){if(row.exporterEnableExporting!==false){var extractedRow=[];columns.forEach(function(gridCol){// $$hashKey check since when grouping and sorting programmatically this ends up in export. Filtering it out
if((gridCol.visible||colTypes===uiGridExporterConstants.ALL)&&gridCol.colDef.exporterSuppressExport!==true&&gridCol.field!=='$$hashKey'&&grid.options.exporterSuppressColumns.indexOf(gridCol.name)===-1){var cellValue=applyCellFilters?grid.getCellDisplayValue(row,gridCol):grid.getCellValue(row,gridCol),extractedField={value:grid.options.exporterFieldCallback(grid,row,gridCol,cellValue,service.type)},extension=grid.options.exporterFieldFormatCallback(grid,row,gridCol,cellValue,service.type);if(extension){Object.assign(extractedField,extension);}if(gridCol.colDef.exporterPdfAlign){extractedField.alignment=gridCol.colDef.exporterPdfAlign;}extractedRow.push(extractedField);}});data.push(extractedRow);}});return data;},/**
         * @ngdoc function
         * @name formatAsCsv
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Formats the column headers and data as a CSV,
         * and sends that data to the user
         * @param {array} exportColumnHeaders an array of column headers,
         * where each header is an object with name, width and maybe alignment
         * @param {array} exportData an array of rows, where each row is
         * an array of column data
         * @param {string} separator a string that represents the separator to be used in the csv file
         * @returns {string} csv the formatted csv as a string
         */formatAsCsv:function(exportColumnHeaders,exportData,separator){var self=this,bareHeaders=exportColumnHeaders.map(function(header){return{value:header.displayName};}),csv=bareHeaders.length>0?self.formatRowAsCsv(this,separator)(bareHeaders)+'\n':'';csv+=exportData.map(this.formatRowAsCsv(this,separator)).join('\n');return csv;},/**
         * @ngdoc function
         * @name formatRowAsCsv
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a single field as a csv field, including
         * quotes around the value
         * @param {exporterService} exporter pass in exporter
         * @param {string} separator the string to be used to join the row data
         * @returns {function} A function that returns a csv-ified version of the row
         */formatRowAsCsv:function(exporter,separator){return function(row){return row.map(exporter.formatFieldAsCsv).join(separator);};},/**
         * @ngdoc function
         * @name formatFieldAsCsv
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a single field as a csv field, including
         * quotes around the value
         * @param {field} field the field to be turned into a csv string,
         * may be of any type
         * @returns {string} a csv-ified version of the field
         */formatFieldAsCsv:function(field){if(field.value==null){// we want to catch anything null-ish, hence just == not ===
return'';}if(typeof field.value==='number'){return field.value;}if(typeof field.value==='boolean'){return field.value?'TRUE':'FALSE';}if(typeof field.value==='string'){return'"'+field.value.replace(/"/g,'""')+'"';}if(typeof field.value==='object'&&!(field.value instanceof Date)){return'"'+JSON.stringify(field.value).replace(/"/g,'""')+'"';}// if field type is date, numberStr
return JSON.stringify(field.value);},/**
         * @ngdoc function
         * @name isIE
         * @methodOf ui.grid.exporter.service:uiGridExporterService
         * @description Checks whether current browser is IE and returns it's version if it is
        */isIE:function(){var match=navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);var isIE=false;if(match!==-1){isIE=true;}return isIE;},/**
         * @ngdoc function
         * @name downloadFile
         * @methodOf ui.grid.exporter.service:uiGridExporterService
         * @description Triggers download of a csv file.  Logic provided
         * by @cssensei (from his colleagues at https://github.com/ifeelgoods) in issue #2391
         * @param {string} fileName the filename we'd like our file to be
         * given
         * @param {string} csvContent the csv content that we'd like to
         * download as a file
         * @param {string} columnSeparator The separator to be used by the columns
         * @param {boolean} exporterOlderExcelCompatibility whether or not we put a utf-16 BOM on the from (\uFEFF)
          * @param {boolean} exporterIsExcelCompatible whether or not we add separator header ('sep=X')
         */downloadFile:function(fileName,csvContent,columnSeparator,exporterOlderExcelCompatibility,exporterIsExcelCompatible){var D=document,a=D.createElement('a'),strMimeType='application/octet-stream;charset=utf-8',rawFile,ieVersion=this.isIE();if(exporterIsExcelCompatible){csvContent='sep='+columnSeparator+'\r\n'+csvContent;}// IE10+
if(navigator.msSaveBlob){return navigator.msSaveOrOpenBlob(new Blob([exporterOlderExcelCompatibility?"\uFEFF":'',csvContent],{type:strMimeType}),fileName);}if(ieVersion){var frame=D.createElement('iframe');document.body.appendChild(frame);frame.contentWindow.document.open('text/html','replace');frame.contentWindow.document.write(csvContent);frame.contentWindow.document.close();frame.contentWindow.focus();frame.contentWindow.document.execCommand('SaveAs',true,fileName);document.body.removeChild(frame);return true;}// html5 A[download]
if('download'in a){var blob=new Blob([exporterOlderExcelCompatibility?"\uFEFF":'',csvContent],{type:strMimeType});rawFile=URL.createObjectURL(blob);a.setAttribute('download',fileName);}else{rawFile='data: '+strMimeType+','+encodeURIComponent(csvContent);a.setAttribute('target','_blank');}a.href=rawFile;a.setAttribute('style','display:none;');D.body.appendChild(a);setTimeout(function(){if(a.click){a.click();// Workaround for Safari 5
}else if(document.createEvent){var eventObj=document.createEvent('MouseEvents');eventObj.initEvent('click',true,true);a.dispatchEvent(eventObj);}D.body.removeChild(a);},this.delay);},/**
         * @ngdoc function
         * @name pdfExport
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Exports rows from the grid in pdf format,
         * the data exported is selected based on the provided options.
         * Note that this function has a dependency on pdfMake, which must
         * be installed.  The resulting pdf opens in a new
         * browser window.
         * @param {Grid} grid the grid from which data should be exported
         * @param {string} rowTypes which rows to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         * @param {string} colTypes which columns to export, valid values are
         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
         * uiGridExporterConstants.SELECTED
         */pdfExport:function(grid,rowTypes,colTypes){var self=this;self.type='pdf';this.loadAllDataIfNeeded(grid,rowTypes,colTypes).then(function(){var exportColumnHeaders=self.getColumnHeaders(grid,colTypes),exportData=self.getData(grid,rowTypes,colTypes),docDefinition=self.prepareAsPdf(grid,exportColumnHeaders,exportData);if(self.isIE()||navigator.appVersion.indexOf('Edge')!==-1){var fileName=angular.isFunction(grid.options.exporterPdfFilename)?grid.options.exporterPdfFilename(grid,rowTypes,colTypes):grid.options.exporterPdfFilename;self.downloadPDF(fileName,docDefinition);}else{pdfMake.createPdf(docDefinition).open();}});},/**
         * @ngdoc function
         * @name downloadPdf
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Generates and retrieves the pdf as a blob, then downloads
         * it as a file.  Only used in IE, in all other browsers we use the native
         * pdfMake.open function to just open the PDF
         * @param {string} fileName the filename to give to the pdf, can be set
         * through exporterPdfFilename
         * @param {object} docDefinition a pdf docDefinition that we can generate
         * and get a blob from
         */downloadPDF:function(fileName,docDefinition){var D=document,a=D.createElement('a'),ieVersion;ieVersion=this.isIE();// This is now a boolean value
var doc=pdfMake.createPdf(docDefinition);var blob;doc.getBuffer(function(buffer){blob=new Blob([buffer]);// IE10+
if(navigator.msSaveBlob){return navigator.msSaveBlob(blob,fileName);}// Previously:  && ieVersion < 10
// ieVersion now returns a boolean for the
// sake of sanity. We just check `msSaveBlob` first.
if(ieVersion){var frame=D.createElement('iframe');document.body.appendChild(frame);frame.contentWindow.document.open('text/html','replace');frame.contentWindow.document.write(blob);frame.contentWindow.document.close();frame.contentWindow.focus();frame.contentWindow.document.execCommand('SaveAs',true,fileName);document.body.removeChild(frame);return true;}});},/**
         * @ngdoc function
         * @name renderAsPdf
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders the data into a pdf, and opens that pdf.
         *
         * @param {Grid} grid the grid from which data should be exported
         * @param {array} exportColumnHeaders an array of column headers,
         * where each header is an object with name, width and maybe alignment
         * @param {array} exportData an array of rows, where each row is
         * an array of column data
         * @returns {object} a pdfMake format document definition, ready
         * for generation
         */prepareAsPdf:function(grid,exportColumnHeaders,exportData){var headerWidths=this.calculatePdfHeaderWidths(grid,exportColumnHeaders);var headerColumns=exportColumnHeaders.map(function(header){return{text:header.displayName,style:'tableHeader'};});var stringData=exportData.map(this.formatRowAsPdf(this));var allData=[headerColumns].concat(stringData);var docDefinition={pageOrientation:grid.options.exporterPdfOrientation,pageSize:grid.options.exporterPdfPageSize,content:[{style:'tableStyle',table:{headerRows:1,widths:headerWidths,body:allData}}],styles:{tableStyle:grid.options.exporterPdfTableStyle,tableHeader:grid.options.exporterPdfTableHeaderStyle},defaultStyle:grid.options.exporterPdfDefaultStyle};if(grid.options.exporterPdfLayout){docDefinition.layout=grid.options.exporterPdfLayout;}if(grid.options.exporterPdfHeader){docDefinition.header=grid.options.exporterPdfHeader;}if(grid.options.exporterPdfFooter){docDefinition.footer=grid.options.exporterPdfFooter;}if(grid.options.exporterPdfCustomFormatter){docDefinition=grid.options.exporterPdfCustomFormatter(docDefinition);}return docDefinition;},/**
         * @ngdoc function
         * @name calculatePdfHeaderWidths
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Determines the column widths base on the
         * widths we got from the grid.  If the column is drawn
         * then we have a drawnWidth.  If the column is not visible
         * then we have '*', 'x%' or a width.  When columns are
         * not visible they don't contribute to the overall gridWidth,
         * so we need to adjust to allow for extra columns
         *
         * Our basic heuristic is to take the current gridWidth, plus
         * numeric columns and call this the base gridwidth.
         *
         * To that we add 100 for any '*' column, and x% of the base gridWidth
         * for any column that is a %
         *
         * @param {Grid} grid the grid from which data should be exported
         * @param {array} exportHeaders array of header information
         * @returns {object} an array of header widths
         */calculatePdfHeaderWidths:function(grid,exportHeaders){var baseGridWidth=0;exportHeaders.forEach(function(value){if(typeof value.width==='number'){baseGridWidth+=value.width;}});var extraColumns=0;exportHeaders.forEach(function(value){if(value.width==='*'){extraColumns+=100;}if(typeof value.width==='string'&&value.width.match(/(\d)*%/)){var percent=parseInt(value.width.match(/(\d)*%/)[0]);value.width=baseGridWidth*percent/100;extraColumns+=value.width;}});var gridWidth=baseGridWidth+extraColumns;return exportHeaders.map(function(header){return header.width==='*'?header.width:header.width*grid.options.exporterPdfMaxGridWidth/gridWidth;});},/**
         * @ngdoc function
         * @name formatRowAsPdf
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a row in a format consumable by PDF,
         * mainly meaning casting everything to a string
         * @param {exporterService} exporter pass in exporter
         * @param {array} row the row to be turned into a csv string
         * @returns {string} a csv-ified version of the row
         */formatRowAsPdf:function(exporter){return function(row){return row.map(exporter.formatFieldAsPdfString);};},/**
         * @ngdoc function
         * @name formatFieldAsCsv
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a single field as a pdf-able field, which
         * is different from a csv field only in that strings don't have quotes
         * around them
         * @param {field} field the field to be turned into a pdf string,
         * may be of any type
         * @returns {string} a string-ified version of the field
         */formatFieldAsPdfString:function(field){var returnVal;if(field.value==null){// we want to catch anything null-ish, hence just == not ===
returnVal='';}else if(typeof field.value==='number'){returnVal=field.value.toString();}else if(typeof field.value==='boolean'){returnVal=field.value?'TRUE':'FALSE';}else if(typeof field.value==='string'){returnVal=field.value.replace(/"/g,'""');}else if(field.value instanceof Date){returnVal=JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');}else if(typeof field.value==='object'){returnVal=field.value;}else{returnVal=JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');}if(field.alignment&&typeof field.alignment==='string'){returnVal={text:returnVal,alignment:field.alignment};}return returnVal;},/**
         * @ngdoc function
         * @name formatAsExcel
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Formats the column headers and data as a excel,
         * and sends that data to the user
         * @param {array} exportColumnHeaders an array of column headers,
         * where each header is an object with name, width and maybe alignment
         * @param {array} exportData an array of rows, where each row is
         * an array of column data
         * @param {string} separator a string that represents the separator to be used in the csv file
         * @returns {string} csv the formatted excel as a string
         */formatAsExcel:function(exportColumnHeaders,exportData,workbook,sheet,docDefinition){var bareHeaders=exportColumnHeaders.map(function(header){return{value:header.displayName};});var sheetData=[];var headerData=[];for(var i=0;i<bareHeaders.length;i++){// TODO - probably need callback to determine header value and header styling
var exportStyle='header';switch(exportColumnHeaders[i].align){case'center':exportStyle='headerCenter';break;case'right':exportStyle='headerRight';break;}var metadata=docDefinition.styles&&docDefinition.styles[exportStyle]?{style:docDefinition.styles[exportStyle].id}:null;headerData.push({value:bareHeaders[i].value,metadata:metadata});}sheetData.push(headerData);var result=exportData.map(this.formatRowAsExcel(this,workbook,sheet));for(var j=0;j<result.length;j++){sheetData.push(result[j]);}return sheetData;},/**
         * @ngdoc function
         * @name formatRowAsExcel
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a single field as a csv field, including
         * quotes around the value
         * @param {exporterService} exporter pass in exporter
         * @param {array} row the row to be turned into a excel string
         * @returns {array} array of cell objects (i.e. {value: x, metadata: y})
         */formatRowAsExcel:function(exporter,workbook,sheet){return function(row){var values=[];for(var i=0;i<row.length;i++){var value=exporter.formatFieldAsExcel(row[i],workbook,sheet);values.push({value:value,metadata:row[i].metadata});}return values;};},/**
         * @ngdoc function
         * @name formatFieldAsExcel
         * @methodOf  ui.grid.exporter.service:uiGridExporterService
         * @description Renders a single field as a excel-ified field
         * @param {field} field the field to be excel-ified,
         * may be of any type
         * @returns {string} a excel-ified version of the field
         */formatFieldAsExcel:function(field,workbook,sheet,formatters){if(field.value==null){// we want to catch anything null-ish, hence just == not ===
return'';}if(typeof field.value==='number'||typeof field.value==='string'){return field.value;}if(typeof field.value==='boolean'){return field.value?'TRUE':'FALSE';}return JSON.stringify(field.value);},prepareAsExcel:function(grid,workbook,sheet){var docDefinition={styles:{}};if(grid.options.exporterExcelCustomFormatters){docDefinition=grid.options.exporterExcelCustomFormatters(grid,workbook,docDefinition);}if(grid.options.exporterExcelHeader){if(angular.isFunction(grid.options.exporterExcelHeader)){grid.options.exporterExcelHeader(grid,workbook,sheet,docDefinition);}else{var headerText=grid.options.exporterExcelHeader.text;var style=grid.options.exporterExcelHeader.style;sheet.data.push([{value:headerText,metadata:{style:docDefinition.styles[style].id}}]);}}return docDefinition;},excelExport:function(grid,rowTypes,colTypes){var self=this;self.type='excel';this.loadAllDataIfNeeded(grid,rowTypes,colTypes).then(function(){var exportColumnHeaders=grid.options.showHeader?self.getColumnHeaders(grid,colTypes):[];var aName='Sheet1';if(grid.options.exporterExcelSheetName){aName=angular.isFunction(grid.options.exporterExcelSheetName)?grid.options.exporterExcelSheetName(grid,rowTypes,colTypes):grid.options.exporterExcelSheetName;}var sheet=new ExcelBuilder.Worksheet({name:aName});var workbook=new ExcelBuilder.Workbook();workbook.addWorksheet(sheet);var docDefinition=self.prepareAsExcel(grid,workbook,sheet);// The standard column width in Microsoft Excel 2000 is 8.43 characters based on fixed-width Courier font
// Width of 10 in excel is 75 pixels
var colWidths=[];var startDataIndex=grid.treeBase?grid.treeBase.numberLevels:grid.enableRowSelection?1:0;for(var i=startDataIndex;i<grid.columns.length;i++){if(grid.columns[i].field!==uiGridExporterConstants.rowHeaderColName&&grid.columns[i].field!==uiGridExporterConstants.selectionRowHeaderColName){colWidths.push({width:grid.columns[i].drawnWidth/grid.options.exporterColumnScaleFactor});}}sheet.setColumns(colWidths);var exportData=self.getData(grid,rowTypes,colTypes,grid.options.exporterFieldApplyFilters);var excelContent=self.formatAsExcel(exportColumnHeaders,exportData,workbook,sheet,docDefinition);sheet.setData(sheet.data.concat(excelContent));ExcelBuilder.Builder.createFile(workbook,{type:'blob'}).then(function(result){var fileName=angular.isFunction(grid.options.exporterExcelFilename)?grid.options.exporterExcelFilename(grid,rowTypes,colTypes):grid.options.exporterExcelFilename;self.downloadFile(fileName,result,grid.options.exporterCsvColumnSeparator,grid.options.exporterOlderExcelCompatibility);});});}};function getDisplayName(grid,gridCol){if(grid.options.exporterHeaderFilter){return grid.options.exporterHeaderFilterUseName?grid.options.exporterHeaderFilter(gridCol.name):grid.options.exporterHeaderFilter(gridCol.displayName);}return gridCol.headerCellFilter?$filter(gridCol.headerCellFilter)(gridCol.displayName):gridCol.displayName;}function defaultExporterFieldCallback(grid,row,col,value){// fix to handle cases with 'number : 1' or 'date:"MM-dd-YYYY HH:mm"', etc.. We needed to split the string
if(col.cellFilter){var args,filter,arg1,arg2;// Split on ':' except when in double quotes.
args=col.cellFilter.match(/(?:[^:"]+|"[^"]*")+/g);// remove space, single/double to maintain retro-compatibility, but keep spaces in second argument (arg[1])
filter=args[0]?args[0].replace(/[\'\"\s]/g,""):null;arg1=args[1]?args[1].replace(/[\'\"]/g,"").trim():null;arg2=args[2]?args[2].replace(/[\'\"\s]/g,""):null;return $filter(filter)(value,arg1,arg2);}else{return value;}}return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.exporter.directive:uiGridExporter
   *  @element div
   *  @restrict A
   *
   *  @description Adds exporter features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.exporter']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.gridOptions = {
        enableGridMenu: true,
        exporterMenuCsv: false,
        columnDefs: [
          {name: 'name', enableCellEdit: true},
          {name: 'title', enableCellEdit: true}
        ],
        data: $scope.data
      };
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="gridOptions" ui-grid-exporter></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridExporter',['uiGridExporterConstants','uiGridExporterService','gridUtil','$compile',function(uiGridExporterConstants,uiGridExporterService,gridUtil,$compile){return{replace:true,priority:0,require:'^uiGrid',scope:false,link:function($scope,$elm,$attrs,uiGridCtrl){uiGridExporterService.initializeGrid(uiGridCtrl.grid);uiGridCtrl.grid.exporter.$scope=$scope;}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.grouping
   * @description
   *
   * # ui.grid.grouping
   *
   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
   *
   * This module provides grouping of rows based on the data in them, similar
   * in concept to excel grouping.  You can group multiple columns, resulting in
   * nested grouping.
   *
   * In concept this feature is similar to sorting + grid footer/aggregation, it
   * sorts the data based on the grouped columns, then creates group rows that
   * reflect a break in the data.  Each of those group rows can have aggregations for
   * the data within that group.
   *
   * This feature leverages treeBase to provide the tree functionality itself,
   * the key thing this feature does therefore is to set treeLevels on the rows
   * and insert the group headers.
   *
   * Design information:
   * -------------------
   *
   * Each column will get new menu items - group by, and aggregate by.  Group by
   * will cause this column to be sorted (if not already), and will move this column
   * to the front of the sorted columns (i.e. grouped columns take precedence over
   * sorted columns).  It will respect the sort order already set if there is one,
   * and it will allow the sorting logic to change that sort order, it just forces
   * the column to the front of the sorting.  You can group by multiple columns, the
   * logic will add this column to the sorting after any already grouped columns.
   *
   * Once a grouping is defined, grouping logic is added to the rowsProcessors.  This
   * will process the rows, identifying a break in the data value, and inserting a grouping row.
   * Grouping rows have specific attributes on them:
   *
   *  - internalRow = true: tells us that this isn't a real row, so we can ignore it
   *    from any processing that it looking at core data rows.  This is used by the core
   *    logic (or will be one day), as it's not grouping specific
   *  - groupHeader = true: tells us this is a groupHeader.  This is used by the grouping logic
   *    to know if this is a groupHeader row or not
   *
   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
   * row order or filtering or anything like that is changed.  In order to avoid the row instantiation
   * time, and to preserve state across invocations, we hold a cache of the rows that we created
   * last time, and we use them again this time if we can.
   *
   * By default rows are collapsed, which means all data rows have their visible property
   * set to false, and only level 0 group rows are set to visible.
   *
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.grouping"></div>
   */var module=angular.module('ui.grid.grouping',['ui.grid','ui.grid.treeBase']);/**
   *  @ngdoc object
   *  @name ui.grid.grouping.constant:uiGridGroupingConstants
   *
   *  @description constants available in grouping module, this includes
   *  all the constants declared in the treeBase module (these are manually copied
   *  as there isn't an easy way to include constants in another constants file, and
   *  we don't want to make users include treeBase)
   *
   */module.constant('uiGridGroupingConstants',{featureName:"grouping",rowHeaderColName:'treeBaseRowHeaderCol',EXPANDED:'expanded',COLLAPSED:'collapsed',aggregation:{COUNT:'count',SUM:'sum',MAX:'max',MIN:'min',AVG:'avg'}});/**
   *  @ngdoc service
   *  @name ui.grid.grouping.service:uiGridGroupingService
   *
   *  @description Services for grouping features
   */module.service('uiGridGroupingService',['$q','uiGridGroupingConstants','gridUtil','rowSorter','GridRow','gridClassFactory','i18nService','uiGridConstants','uiGridTreeBaseService',function($q,uiGridGroupingConstants,gridUtil,rowSorter,GridRow,gridClassFactory,i18nService,uiGridConstants,uiGridTreeBaseService){var service={initializeGrid:function(grid,$scope){uiGridTreeBaseService.initializeGrid(grid,$scope);// add feature namespace and any properties to grid for needed
/**
         *  @ngdoc object
         *  @name ui.grid.grouping.grid:grouping
         *
         *  @description Grid properties and functions added for grouping
         */grid.grouping={};/**
         *  @ngdoc property
         *  @propertyOf ui.grid.grouping.grid:grouping
         *  @name groupHeaderCache
         *
         *  @description Cache that holds the group header rows we created last time, we'll
         *  reuse these next time, not least because they hold our expanded states.
         *
         *  We need to take care with these that they don't become a memory leak, we
         *  create a new cache each time using the values from the old cache.  This works
         *  so long as we're creating group rows for invisible rows as well.
         *
         *  The cache is a nested hash, indexed on the value we grouped by.  So if we
         *  grouped by gender then age, we'd maybe have something like:
         *  ```
         *    {
         *      male: {
         *        row: <pointer to the old row>,
         *        children: {
         *          22: { row: <pointer to the old row> },
         *          31: { row: <pointer to the old row> }
         *      },
         *      female: {
         *        row: <pointer to the old row>,
         *        children: {
         *          28: { row: <pointer to the old row> },
         *          55: { row: <pointer to the old row> }
         *      }
         *    }
         *  ```
         *
         *  We create new rows for any missing rows, this means that they come in as collapsed.
         *
         */grid.grouping.groupHeaderCache={};service.defaultGridOptions(grid.options);grid.registerRowsProcessor(service.groupRows,400);grid.registerColumnBuilder(service.groupingColumnBuilder);grid.registerColumnsProcessor(service.groupingColumnProcessor,400);/**
         *  @ngdoc object
         *  @name ui.grid.grouping.api:PublicApi
         *
         *  @description Public Api for grouping feature
         */var publicApi={events:{grouping:{/**
               * @ngdoc event
               * @eventOf ui.grid.grouping.api:PublicApi
               * @name aggregationChanged
               * @description raised whenever aggregation is changed, added or removed from a column
               *
               * <pre>
               *      gridApi.grouping.on.aggregationChanged(scope,function(col) {})
               * </pre>
               * @param {GridColumn} col the column on which aggregation changed. The aggregation
               * type is available as `col.treeAggregation.type`
               */aggregationChanged:{},/**
               * @ngdoc event
               * @eventOf ui.grid.grouping.api:PublicApi
               * @name groupingChanged
               * @description raised whenever the grouped columns changes
               *
               * <pre>
               *      gridApi.grouping.on.groupingChanged(scope,function(col) {})
               * </pre>
               * @param {GridColumn} col the column on which grouping changed. The new grouping is
               * available as `col.grouping`
               */groupingChanged:{}}},methods:{grouping:{/**
               * @ngdoc function
               * @name getGrouping
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Get the grouping configuration for this grid,
               * used by the saveState feature.  Adds expandedState to the information
               * provided by the internal getGrouping, and removes any aggregations that have a source
               * of grouping (i.e. will be automatically reapplied when we regroup the column)
               * Returned grouping is an object
               *   `{ grouping: groupArray, treeAggregations: aggregateArray, expandedState: hash }`
               * where grouping contains an array of objects:
               *   `{ field: column.field, colName: column.name, groupPriority: column.grouping.groupPriority }`
               * and aggregations contains an array of objects:
               *   `{ field: column.field, colName: column.name, aggregation: column.grouping.aggregation }`
               * and expandedState is a hash of the currently expanded nodes
               *
               * The groupArray will be sorted by groupPriority.
               *
               * @param {boolean} getExpanded whether or not to return the expanded state
               * @returns {object} grouping configuration
               */getGrouping:function(getExpanded){var grouping=service.getGrouping(grid);grouping.grouping.forEach(function(group){group.colName=group.col.name;delete group.col;});grouping.aggregations.forEach(function(aggregation){aggregation.colName=aggregation.col.name;delete aggregation.col;});grouping.aggregations=grouping.aggregations.filter(function(aggregation){return!aggregation.aggregation.source||aggregation.aggregation.source!=='grouping';});if(getExpanded){grouping.rowExpandedStates=service.getRowExpandedStates(grid.grouping.groupingHeaderCache);}return grouping;},/**
               * @ngdoc function
               * @name setGrouping
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Set the grouping configuration for this grid,
               * used by the saveState feature, but can also be used by any
               * user to specify a combined grouping and aggregation configuration
               * @param {object} config the config you want to apply, in the format
               * provided out by getGrouping
               */setGrouping:function(config){service.setGrouping(grid,config);},/**
               * @ngdoc function
               * @name groupColumn
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Adds this column to the existing grouping, at the end of the priority order.
               * If the column doesn't have a sort, adds one, by default ASC
               *
               * This column will move to the left of any non-group columns, the
               * move is handled in a columnProcessor, so gets called as part of refresh
               *
               * @param {string} columnName the name of the column we want to group
               */groupColumn:function(columnName){var column=grid.getColumn(columnName);service.groupColumn(grid,column);},/**
               * @ngdoc function
               * @name ungroupColumn
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Removes the groupPriority from this column.  If the
               * column was previously aggregated the aggregation will come back.
               * The sort will remain.
               *
               * This column will move to the right of any other group columns, the
               * move is handled in a columnProcessor, so gets called as part of refresh
               *
               * @param {string} columnName the name of the column we want to ungroup
               */ungroupColumn:function(columnName){var column=grid.getColumn(columnName);service.ungroupColumn(grid,column);},/**
               * @ngdoc function
               * @name clearGrouping
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
               * as we don't know whether that sorting was added by grouping or was there beforehand
               *
               */clearGrouping:function(){service.clearGrouping(grid);},/**
               * @ngdoc function
               * @name aggregateColumn
               * @methodOf  ui.grid.grouping.api:PublicApi
               * @description Sets the aggregation type on a column, if the
               * column is currently grouped then it removes the grouping first.
               * If the aggregationDef is null then will result in the aggregation
               * being removed
               *
               * @param {string} columnName the column we want to aggregate
               * @param {string|function} aggregationDef one of the recognised types
               * from uiGridGroupingConstants or a custom aggregation function.
               * @param {string} aggregationLabel (optional) The label to use for this aggregation.
               */aggregateColumn:function(columnName,aggregationDef,aggregationLabel){var column=grid.getColumn(columnName);service.aggregateColumn(grid,column,aggregationDef,aggregationLabel);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);grid.api.core.on.sortChanged($scope,service.tidyPriorities);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
         *  @ngdoc object
         *  @name ui.grid.grouping.api:GridOptions
         *
         *  @description GridOptions for grouping feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */ /**
         *  @ngdoc object
         *  @name enableGrouping
         *  @propertyOf  ui.grid.grouping.api:GridOptions
         *  @description Enable row grouping for entire grid.
         *  <br/>Defaults to true
         */gridOptions.enableGrouping=gridOptions.enableGrouping!==false;/**
         *  @ngdoc object
         *  @name groupingShowCounts
         *  @propertyOf  ui.grid.grouping.api:GridOptions
         *  @description shows counts on the groupHeader rows. Not that if you are using a cellFilter or a
         *  sortingAlgorithm which relies on a specific format or data type, showing counts may cause that
         *  to break, since the group header rows will always be a string with groupingShowCounts enabled.
         *  <br/>Defaults to true except on columns of types 'date' and 'object'
         */gridOptions.groupingShowCounts=gridOptions.groupingShowCounts!==false;/**
         *  @ngdoc object
         *  @name groupingNullLabel
         *  @propertyOf  ui.grid.grouping.api:GridOptions
         *  @description The string to use for the grouping header row label on rows which contain a null or undefined value in the grouped column.
         *  <br/>Defaults to "Null"
         */gridOptions.groupingNullLabel=typeof gridOptions.groupingNullLabel==='undefined'?'Null':gridOptions.groupingNullLabel;/**
         *  @ngdoc object
         *  @name enableGroupHeaderSelection
         *  @propertyOf  ui.grid.grouping.api:GridOptions
         *  @description Allows group header rows to be selected.
         *  <br/>Defaults to false
         */gridOptions.enableGroupHeaderSelection=gridOptions.enableGroupHeaderSelection===true;},/**
       * @ngdoc function
       * @name groupingColumnBuilder
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Sets the grouping defaults based on the columnDefs
       *
       * @param {object} colDef columnDef we're basing on
       * @param {GridColumn} col the column we're to update
       * @param {object} gridOptions the options we should use
       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
       */groupingColumnBuilder:function(colDef,col,gridOptions){/**
         *  @ngdoc object
         *  @name ui.grid.grouping.api:ColumnDef
         *
         *  @description ColumnDef for grouping feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
         */ /**
         *  @ngdoc object
         *  @name enableGrouping
         *  @propertyOf  ui.grid.grouping.api:ColumnDef
         *  @description Enable grouping on this column
         *  <br/>Defaults to true.
         */if(colDef.enableGrouping===false){return;}/**
         *  @ngdoc object
         *  @name grouping
         *  @propertyOf  ui.grid.grouping.api:ColumnDef
         *  @description Set the grouping for a column.  Format is:
         *  ```
         *    {
         *      groupPriority: <number, starts at 0, if less than 0 or undefined then we're aggregating in this column>
         *    }
         *  ```
         *
         *  **Note that aggregation used to be included in grouping, but is now separately set on the column via treeAggregation
         *  setting in treeBase**
         *
         *  We group in the priority order given, this will also put these columns to the high order of the sort irrespective
         *  of the sort priority given them.  If there is no sort defined then we sort ascending, if there is a sort defined then
         *  we use that sort.
         *
         *  If the groupPriority is undefined or less than 0, then we expect to be aggregating, and we look at the
         *  aggregation types to determine what sort of aggregation we can do.  Values are in the constants file, but
         *  include SUM, COUNT, MAX, MIN
         *
         *  groupPriorities should generally be sequential, if they're not then the next time getGrouping is called
         *  we'll renumber them to be sequential.
         *  <br/>Defaults to undefined.
         */if(typeof col.grouping==='undefined'&&typeof colDef.grouping!=='undefined'){col.grouping=angular.copy(colDef.grouping);if(typeof col.grouping.groupPriority!=='undefined'&&col.grouping.groupPriority>-1){col.treeAggregationFn=uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;col.treeAggregationFinalizerFn=service.groupedFinalizerFn;}}else if(typeof col.grouping==='undefined'){col.grouping={};}if(typeof col.grouping!=='undefined'&&typeof col.grouping.groupPriority!=='undefined'&&col.grouping.groupPriority>=0){col.suppressRemoveSort=true;}var groupColumn={name:'ui.grid.grouping.group',title:i18nService.get().grouping.group,icon:'ui-grid-icon-indent-right',shown:function(){return typeof this.context.col.grouping==='undefined'||typeof this.context.col.grouping.groupPriority==='undefined'||this.context.col.grouping.groupPriority<0;},action:function(){service.groupColumn(this.context.col.grid,this.context.col);}};var ungroupColumn={name:'ui.grid.grouping.ungroup',title:i18nService.get().grouping.ungroup,icon:'ui-grid-icon-indent-left',shown:function(){return typeof this.context.col.grouping!=='undefined'&&typeof this.context.col.grouping.groupPriority!=='undefined'&&this.context.col.grouping.groupPriority>=0;},action:function(){service.ungroupColumn(this.context.col.grid,this.context.col);}};var aggregateRemove={name:'ui.grid.grouping.aggregateRemove',title:i18nService.get().grouping.aggregate_remove,shown:function(){return typeof this.context.col.treeAggregationFn!=='undefined';},action:function(){service.aggregateColumn(this.context.col.grid,this.context.col,null);}};// generic adder for the aggregation menus, which follow a pattern
var addAggregationMenu=function(type,title){title=title||i18nService.get().grouping['aggregate_'+type]||type;var menuItem={name:'ui.grid.grouping.aggregate'+type,title:title,shown:function(){return typeof this.context.col.treeAggregation==='undefined'||typeof this.context.col.treeAggregation.type==='undefined'||this.context.col.treeAggregation.type!==type;},action:function(){service.aggregateColumn(this.context.col.grid,this.context.col,type);}};if(!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.grouping.aggregate'+type)){col.menuItems.push(menuItem);}};/**
         *  @ngdoc object
         *  @name groupingShowGroupingMenu
         *  @propertyOf  ui.grid.grouping.api:ColumnDef
         *  @description Show the grouping (group and ungroup items) menu on this column
         *  <br/>Defaults to true.
         */if(col.colDef.groupingShowGroupingMenu!==false){if(!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.grouping.group')){col.menuItems.push(groupColumn);}if(!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.grouping.ungroup')){col.menuItems.push(ungroupColumn);}}/**
         *  @ngdoc object
         *  @name groupingShowAggregationMenu
         *  @propertyOf  ui.grid.grouping.api:ColumnDef
         *  @description Show the aggregation menu on this column
         *  <br/>Defaults to true.
         */if(col.colDef.groupingShowAggregationMenu!==false){angular.forEach(uiGridTreeBaseService.nativeAggregations(),function(aggregationDef,name){addAggregationMenu(name);});angular.forEach(gridOptions.treeCustomAggregations,function(aggregationDef,name){addAggregationMenu(name,aggregationDef.menuTitle);});if(!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.grouping.aggregateRemove')){col.menuItems.push(aggregateRemove);}}},/**
       * @ngdoc function
       * @name groupingColumnProcessor
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Moves the columns around based on which are grouped
       *
       * @param {array} columns the columns to consider rendering
       * @param {array} rows the grid rows, which we don't use but are passed to us
       * @returns {array} updated columns array
       */groupingColumnProcessor:function(columns,rows){columns=service.moveGroupColumns(this,columns,rows);return columns;},/**
       * @ngdoc function
       * @name groupedFinalizerFn
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Used on group columns to display the rendered value and optionally
       * display the count of rows.
       *
       * @param {aggregation} aggregation The aggregation entity for a grouped column
       */groupedFinalizerFn:function(aggregation){var col=this;if(typeof aggregation.groupVal!=='undefined'){aggregation.rendered=aggregation.groupVal;if(col.grid.options.groupingShowCounts&&col.colDef.type!=='date'&&col.colDef.type!=='object'){aggregation.rendered+=' ('+aggregation.value+')';}}else{aggregation.rendered=null;}},/**
       * @ngdoc function
       * @name moveGroupColumns
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Moves the column order so that the grouped columns are lined up
       * to the left (well, unless you're RTL, then it's the right).  By doing this in
       * the columnsProcessor, we make it transient - when the column is ungrouped it'll
       * go back to where it was.
       *
       * Does nothing if the option `moveGroupColumns` is set to false.
       *
       * @param {Grid} grid grid object
       * @param {array} columns the columns that we should process/move
       * @returns {array} updated columns
       */moveGroupColumns:function(grid,columns){if(grid.options.moveGroupColumns===false){return columns;}columns.forEach(function(column,index){// position used to make stable sort in moveGroupColumns
column.groupingPosition=index;});columns.sort(function(a,b){var a_group,b_group;if(a.isRowHeader){a_group=a.headerPriority;}else if(typeof a.grouping==='undefined'||typeof a.grouping.groupPriority==='undefined'||a.grouping.groupPriority<0){a_group=null;}else{a_group=a.grouping.groupPriority;}if(b.isRowHeader){b_group=b.headerPriority;}else if(typeof b.grouping==='undefined'||typeof b.grouping.groupPriority==='undefined'||b.grouping.groupPriority<0){b_group=null;}else{b_group=b.grouping.groupPriority;}// groups get sorted to the top
if(a_group!==null&&b_group===null){return-1;}if(b_group!==null&&a_group===null){return 1;}if(a_group!==null&&b_group!==null){return a_group-b_group;}return a.groupingPosition-b.groupingPosition;});columns.forEach(function(column){delete column.groupingPosition;});return columns;},/**
       * @ngdoc function
       * @name groupColumn
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Adds this column to the existing grouping, at the end of the priority order.
       * If the column doesn't have a sort, adds one, by default ASC
       *
       * This column will move to the left of any non-group columns, the
       * move is handled in a columnProcessor, so gets called as part of refresh
       *
       * @param {Grid} grid grid object
       * @param {GridColumn} column the column we want to group
       */groupColumn:function(grid,column){if(typeof column.grouping==='undefined'){column.grouping={};}// set the group priority to the next number in the hierarchy
var existingGrouping=service.getGrouping(grid);column.grouping.groupPriority=existingGrouping.grouping.length;// save sort in order to restore it when column is ungrouped
column.previousSort=angular.copy(column.sort);// add sort if not present
if(!column.sort){column.sort={direction:uiGridConstants.ASC};}else if(typeof column.sort.direction==='undefined'||column.sort.direction===null){column.sort.direction=uiGridConstants.ASC;}column.treeAggregation={type:uiGridGroupingConstants.aggregation.COUNT,source:'grouping'};if(column.colDef&&angular.isFunction(column.colDef.customTreeAggregationFn)){column.treeAggregationFn=column.colDef.customTreeAggregationFn;}else{column.treeAggregationFn=uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;}column.treeAggregationFinalizerFn=service.groupedFinalizerFn;grid.api.grouping.raise.groupingChanged(column);// This indirectly calls service.tidyPriorities( grid );
grid.api.core.raise.sortChanged(grid,grid.getColumnSorting());grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name ungroupColumn
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Removes the groupPriority from this column.  If the
       * column was previously aggregated the aggregation will come back.
       * The sort will remain.
       *
       * This column will move to the right of any other group columns, the
       * move is handled in a columnProcessor, so gets called as part of refresh
       *
       * @param {Grid} grid grid object
       * @param {GridColumn} column the column we want to ungroup
       */ungroupColumn:function(grid,column){if(typeof column.grouping==='undefined'){return;}delete column.grouping.groupPriority;delete column.treeAggregation;delete column.customTreeAggregationFinalizer;if(column.previousSort){column.sort=column.previousSort;delete column.previousSort;}service.tidyPriorities(grid);grid.api.grouping.raise.groupingChanged(column);grid.api.core.raise.sortChanged(grid,grid.getColumnSorting());grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name aggregateColumn
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Sets the aggregation type on a column, if the
       * column is currently grouped then it removes the grouping first.
       *
       * @param {Grid} grid grid object
       * @param {GridColumn} column the column we want to aggregate
       * @param {string} aggregationType of the recognised types from uiGridGroupingConstants or one of the custom aggregations from gridOptions
       * @param {string} aggregationLabel to be used instead of the default label. If empty string is passed, label is omitted
       */aggregateColumn:function(grid,column,aggregationType,aggregationLabel){if(typeof column.grouping!=='undefined'&&typeof column.grouping.groupPriority!=='undefined'&&column.grouping.groupPriority>=0){service.ungroupColumn(grid,column);}var aggregationDef={};if(typeof grid.options.treeCustomAggregations[aggregationType]!=='undefined'){aggregationDef=grid.options.treeCustomAggregations[aggregationType];}else if(typeof uiGridTreeBaseService.nativeAggregations()[aggregationType]!=='undefined'){aggregationDef=uiGridTreeBaseService.nativeAggregations()[aggregationType];}column.treeAggregation={type:aggregationType,label:typeof aggregationLabel==='string'?aggregationLabel:i18nService.get().aggregation[aggregationDef.label]||aggregationDef.label};column.treeAggregationFn=aggregationDef.aggregationFn;column.treeAggregationFinalizerFn=aggregationDef.finalizerFn;grid.api.grouping.raise.aggregationChanged(column);grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name setGrouping
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Set the grouping based on a config object, used by the save state feature
       * (more specifically, by the restore function in that feature )
       *
       * @param {Grid} grid grid object
       * @param {object} config the config we want to set, same format as that returned by getGrouping
       */setGrouping:function(grid,config){if(typeof config==='undefined'){return;}// first remove any existing grouping
service.clearGrouping(grid);if(config.grouping&&config.grouping.length&&config.grouping.length>0){config.grouping.forEach(function(group){var col=grid.getColumn(group.colName);if(col){service.groupColumn(grid,col);}});}if(config.aggregations&&config.aggregations.length){config.aggregations.forEach(function(aggregation){var col=grid.getColumn(aggregation.colName);if(col){service.aggregateColumn(grid,col,aggregation.aggregation.type);}});}if(config.rowExpandedStates){service.applyRowExpandedStates(grid.grouping.groupingHeaderCache,config.rowExpandedStates);}},/**
       * @ngdoc function
       * @name clearGrouping
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
       * as we don't know whether that sorting was added by grouping or was there beforehand
       *
       * @param {Grid} grid grid object
       */clearGrouping:function(grid){var currentGrouping=service.getGrouping(grid);if(currentGrouping.grouping.length>0){currentGrouping.grouping.forEach(function(group){if(!group.col){// should have a group.colName if there's no col
group.col=grid.getColumn(group.colName);}service.ungroupColumn(grid,group.col);});}if(currentGrouping.aggregations.length>0){currentGrouping.aggregations.forEach(function(aggregation){if(!aggregation.col){// should have a group.colName if there's no col
aggregation.col=grid.getColumn(aggregation.colName);}service.aggregateColumn(grid,aggregation.col,null);});}},/**
       * @ngdoc function
       * @name tidyPriorities
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Renumbers groupPriority and sortPriority such that
       * groupPriority is contiguous, and sortPriority either matches
       * groupPriority (for group columns), and otherwise is contiguous and
       * higher than groupPriority.
       *
       * @param {Grid} grid grid object
       */tidyPriorities:function(grid){// if we're called from sortChanged, grid is in this, not passed as param, the param can be a column or undefined
if((typeof grid==='undefined'||typeof grid.grid!=='undefined')&&typeof this.grid!=='undefined'){grid=this.grid;}var groupArray=[],sortArray=[];grid.columns.forEach(function(column,index){if(typeof column.grouping!=='undefined'&&typeof column.grouping.groupPriority!=='undefined'&&column.grouping.groupPriority>=0){groupArray.push(column);}else if(typeof column.sort!=='undefined'&&typeof column.sort.priority!=='undefined'&&column.sort.priority>=0){sortArray.push(column);}});groupArray.sort(function(a,b){return a.grouping.groupPriority-b.grouping.groupPriority;});groupArray.forEach(function(column,index){column.grouping.groupPriority=index;column.suppressRemoveSort=true;if(typeof column.sort==='undefined'){column.sort={};}column.sort.priority=index;});var i=groupArray.length;sortArray.sort(function(a,b){return a.sort.priority-b.sort.priority;});sortArray.forEach(function(column){column.sort.priority=i;column.suppressRemoveSort=column.colDef.suppressRemoveSort;i++;});},/**
       * @ngdoc function
       * @name groupRows
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description The rowProcessor that creates the groupHeaders (i.e. does
       * the actual grouping).
       *
       * Assumes it is always called after the sorting processor, guaranteed by the priority setting
       *
       * Processes all the rows in order, inserting a groupHeader row whenever there is a change
       * in value of a grouped row, based on the sortAlgorithm used for the column.  The group header row
       * is looked up in the groupHeaderCache, and used from there if there is one. The entity is reset
       * to {} if one is found.
       *
       * As it processes it maintains a `processingState` array. This records, for each level of grouping we're
       * working with, the following information:
       * ```
       *   {
       *     fieldName: name,
       *     col: col,
       *     initialised: boolean,
       *     currentValue: value,
       *     currentRow: gridRow,
       *   }
       * ```
       * We look for changes in the currentValue at any of the levels.  Where we find a change we:
       *
       * - create a new groupHeader row in the array
       *
       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
       * @returns {array} the updated rows, including our new group rows
       */groupRows:function(renderableRows){if(renderableRows.length===0){return renderableRows;}var grid=this;grid.grouping.oldGroupingHeaderCache=grid.grouping.groupingHeaderCache||{};grid.grouping.groupingHeaderCache={};var processingState=service.initialiseProcessingState(grid);// processes each of the fields we are grouping by, checks if the value has changed and inserts a groupHeader
// Broken out as shouldn't create functions in a loop.
var updateProcessingState=function(groupFieldState,stateIndex){var fieldValue=grid.getCellValue(row,groupFieldState.col);// look for change of value - and insert a header
if(!groupFieldState.initialised||rowSorter.getSortFn(groupFieldState.col)(fieldValue,groupFieldState.currentValue)!==0){service.insertGroupHeader(grid,renderableRows,i,processingState,stateIndex);i++;}};// use a for loop because it's tolerant of the array length changing whilst we go - we can
// manipulate the iterator when we insert groupHeader rows
for(var i=0;i<renderableRows.length;i++){var row=renderableRows[i];if(row.visible){processingState.forEach(updateProcessingState);}}delete grid.grouping.oldGroupingHeaderCache;return renderableRows;},/**
       * @ngdoc function
       * @name initialiseProcessingState
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Creates the processing state array that is used
       * for groupRows.
       *
       * @param {Grid} grid grid object
       * @returns {array} an array in the format described in the groupRows method,
       * initialised with blank values
       */initialiseProcessingState:function(grid){var processingState=[];var columnSettings=service.getGrouping(grid);columnSettings.grouping.forEach(function(groupItem,index){processingState.push({fieldName:groupItem.field,col:groupItem.col,initialised:false,currentValue:null,currentRow:null});});return processingState;},/**
       * @ngdoc function
       * @name getGrouping
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Get the grouping settings from the columns.  As a side effect
       * this always renumbers the grouping starting at 0
       * @param {Grid} grid grid object
       * @returns {array} an array of the group fields, in order of priority
       */getGrouping:function(grid){var groupArray=[],aggregateArray=[];// get all the grouping
grid.columns.forEach(function(column){if(column.grouping){if(typeof column.grouping.groupPriority!=='undefined'&&column.grouping.groupPriority>=0){groupArray.push({field:column.field,col:column,groupPriority:column.grouping.groupPriority,grouping:column.grouping});}}if(column.treeAggregation&&column.treeAggregation.type){aggregateArray.push({field:column.field,col:column,aggregation:column.treeAggregation});}});// sort grouping into priority order
groupArray.sort(function(a,b){return a.groupPriority-b.groupPriority;});// renumber the priority in case it was somewhat messed up, then remove the grouping reference
groupArray.forEach(function(group,index){group.grouping.groupPriority=index;group.groupPriority=index;delete group.grouping;});return{grouping:groupArray,aggregations:aggregateArray};},/**
       * @ngdoc function
       * @name insertGroupHeader
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Create a group header row, and link it to the various configuration
       * items that we use.
       *
       * Look for the row in the oldGroupingHeaderCache, write the row into the new groupingHeaderCache.
       *
       * @param {Grid} grid grid object
       * @param {array} renderableRows the rows that we are processing
       * @param {number} rowIndex the row we were up to processing
       * @param {array} processingState the current processing state
       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header -
       * i.e. the column that we want to create a header for
       */insertGroupHeader:function(grid,renderableRows,rowIndex,processingState,stateIndex){// set the value that caused the end of a group into the header row and the processing state
var col=processingState[stateIndex].col,newValue=grid.getCellValue(renderableRows[rowIndex],col),newDisplayValue=newValue;if(typeof newValue==='undefined'||newValue===null){newDisplayValue=grid.options.groupingNullLabel;}function getKeyAsValueForCacheMap(key){return angular.isObject(key)?JSON.stringify(key):key;}var cacheItem=grid.grouping.oldGroupingHeaderCache;for(var i=0;i<stateIndex;i++){if(cacheItem&&cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)]){cacheItem=cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;}}var headerRow;if(cacheItem&&cacheItem[getKeyAsValueForCacheMap(newValue)]){headerRow=cacheItem[getKeyAsValueForCacheMap(newValue)].row;headerRow.entity={};}else{headerRow=new GridRow({},null,grid);gridClassFactory.rowTemplateAssigner.call(grid,headerRow);}headerRow.entity['$$'+processingState[stateIndex].col.uid]={groupVal:newDisplayValue};headerRow.treeLevel=stateIndex;headerRow.groupHeader=true;headerRow.internalRow=true;headerRow.enableCellEdit=false;headerRow.enableSelection=grid.options.enableGroupHeaderSelection;processingState[stateIndex].initialised=true;processingState[stateIndex].currentValue=newValue;processingState[stateIndex].currentRow=headerRow;// set all processing states below this one to not be initialised - change of this state
// means all those need to start again
service.finaliseProcessingState(processingState,stateIndex+1);// insert our new header row
renderableRows.splice(rowIndex,0,headerRow);// add our new header row to the cache
cacheItem=grid.grouping.groupingHeaderCache;for(i=0;i<stateIndex;i++){cacheItem=cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;}cacheItem[getKeyAsValueForCacheMap(newValue)]={row:headerRow,children:{}};},/**
       * @ngdoc function
       * @name finaliseProcessingState
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Set all processing states lower than the one that had a break in value to
       * no longer be initialised.  Render the counts into the entity ready for display.
       *
       * @param {array} processingState the current processing state
       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header, all
       * processing states after this need to be finalised
       */finaliseProcessingState:function(processingState,stateIndex){for(var i=stateIndex;i<processingState.length;i++){processingState[i].initialised=false;processingState[i].currentRow=null;processingState[i].currentValue=null;}},/**
       * @ngdoc function
       * @name getRowExpandedStates
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Extract the groupHeaderCache hash, pulling out only the states.
       *
       * The example below shows a grid that is grouped by gender then age
       *
       * <pre>
       *   {
       *     male: {
       *       state: 'expanded',
       *       children: {
       *         22: { state: 'expanded' },
       *         30: { state: 'collapsed' }
       *       }
       *     },
       *     female: {
       *       state: 'expanded',
       *       children: {
       *         28: { state: 'expanded' },
       *         55: { state: 'collapsed' }
       *       }
       *     }
       *   }
       * </pre>
       *
       * @param {object} treeChildren The tree children elements object
       * @returns {object} the expanded states as an object
       */getRowExpandedStates:function(treeChildren){if(typeof treeChildren==='undefined'){return{};}var newChildren={};angular.forEach(treeChildren,function(value,key){newChildren[key]={state:value.row.treeNode.state};if(value.children){newChildren[key].children=service.getRowExpandedStates(value.children);}else{newChildren[key].children={};}});return newChildren;},/**
       * @ngdoc function
       * @name applyRowExpandedStates
       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
       * @description Take a hash in the format as created by getRowExpandedStates,
       * and apply it to the grid.grouping.groupHeaderCache.
       *
       * Takes a treeSubset, and applies to a treeSubset - so can be called
       * recursively.
       *
       * @param {object} currentNode can be grid.grouping.groupHeaderCache, or any of
       * the children of that hash
       * @param {object} expandedStates can be the full expanded states, or children
       * of that expanded states (which hopefully matches the subset of the groupHeaderCache)
       */applyRowExpandedStates:function(currentNode,expandedStates){if(typeof expandedStates==='undefined'){return;}angular.forEach(expandedStates,function(value,key){if(currentNode[key]){currentNode[key].row.treeNode.state=value.state;if(value.children&&currentNode[key].children){service.applyRowExpandedStates(currentNode[key].children,value.children);}}});}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.grouping.directive:uiGridGrouping
   *  @element div
   *  @restrict A
   *
   *  @description Adds grouping features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.grouping']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name', enableCellEdit: true},
        {name: 'title', enableCellEdit: true}
      ];

      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="gridOptions" ui-grid-grouping></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridGrouping',['uiGridGroupingConstants','uiGridGroupingService',function(uiGridGroupingConstants,uiGridGroupingService){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){if(uiGridCtrl.grid.options.enableGrouping!==false){uiGridGroupingService.initializeGrid(uiGridCtrl.grid,$scope);}},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ar',{"headerCell":{"aria":{"defaultFilterLabel":"التصفيه بالعمود","removeFilter":"محو التصفيه","columnMenuButtonLabel":"قاءمه الاعمده"},"priority":"أولويه : ","filterLabel":"تصفيه بالاعمده :"},"aggregate":{"label":"العناصر"},"groupPanel":{"description":"اسحب رأس العمود هنا وأسقطه لإنشاء مجموعه"},"search":{"placeholder":"بحث  ...","showingItems":"العناصر الظاهره :","selectedItems":"العناصر المحدده :","totalItems":"عدد العناصر :","size":"حجم الصفحه :","first":"اول صفحه","next":"الصفحه التاليه","previous":"الصفحه الصابقه","last":"الصفحه الاخيره"},"menu":{"text":"اختيار العمود :"},"sort":{"ascending":"ترتيب تصاعدى","descending":"ترتيب تنازلى","none":"عدم التحديد","remove":"حذف الترتيب"},"column":{"hide":"إخفاء عمود"},"aggregation":{"count":"عدد الصفوف: ","sum":"جمع: ","avg":"المتوسط الحسابى: ","min":"الادنى: ","max":"الاقصى: "},"pinning":{"pinLeft":"تثبيت لليسار","pinRight":"تثبيت لليمين","unpin":"فك التثبيت"},"columnMenu":{"close":"غلق"},"gridMenu":{"aria":{"buttonLabel":"قائمه الجدول"},"columns":"الاعمده:","importerTitle":"إدخال ملف","exporterAllAsCsv":"إخراج كل البيانات ك(csv)","exporterVisibleAsCsv":"إخراج كل البيانات الواضحه ك (csv)","exporterSelectedAsCsv":"إخراج كل البيانات المحدده ك (csv)","exporterAllAsPdf":"إخراج كل البيانات ك(pdf)","exporterVisibleAsPdf":"إخراج كل البيانات الواضحه ك (pdf)","exporterSelectedAsPdf":"إخراج كل البيانات المحدده ك (pdf)","clearAllFilters":"محو كل الترشيح"},"importer":{"noHeaders":"اسماء هؤلاء الاعمده غير واضحه، هل يوجد رأس للملف؟","noObjects":"Objects were not able to be derived, was there data in the file other than headers?","invalidCsv":"الملف غير قادر على الاتمام ، هل ال (CSV) صحيح؟","invalidJson":"الملف غير قادر على الاتمام ، هل ال (JSON) صحيح؟","jsonNotArray":"Imported json file must contain an array, aborting."},"pagination":{"aria":{"pageToFirst":"الصفحه الاولى","pageBack":"الصفه السابقه","pageSelected":"الصفحه المحدده","pageForward":"الصفحه التاليه","pageToLast":"الصفحه الاخيره"},"sizes":"عدد العناصر فى الصفحه","totalItems":"عناصر","through":"إلى","of":"من"},"grouping":{"group":"جمع","ungroup":"فك الجمع","aggregate_count":"جمله : العدد","aggregate_sum":"جمله : الحاصل","aggregate_max":"جمله : الاقصى","aggregate_min":"جمله : الاقل","aggregate_avg":"جمله :المتوسط ","aggregate_remove":"جمله : حذف"},"validate":{"error":"خطأ :","minLength":"القيمه لابد ان لا تقل عن THRESHOLD حرف.","maxLength":"القيمه لابد ان لا تزيد عن THRESHOLD حرف.","required":"مطلوب قيمه"}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('bg',{headerCell:{aria:{defaultFilterLabel:'Филттър за колоната',removeFilter:'Премахни филтър',columnMenuButtonLabel:'Меню на колоната'},priority:'Приоритет:',filterLabel:"Филтър за колоната: "},aggregate:{label:'обекти'},search:{placeholder:'Търсене...',showingItems:'Показани обекти:',selectedItems:'избрани обекти:',totalItems:'Общо:',size:'Размер на страницата:',first:'Първа страница',next:'Следваща страница',previous:'Предишна страница',last:'Последна страница'},menu:{text:'Избери колони:'},sort:{ascending:'Сортиране по възходящ ред',descending:'Сортиране по низходящ ред',none:'Без сортиране',remove:'Премахни сортирането'},column:{hide:'Скрий колоната'},aggregation:{count:'Общо редове: ',sum:'общо: ',avg:'средно: ',min:'най-малко: ',max:'най-много: '},pinning:{pinLeft:'Прикрепи вляво',pinRight:'Прикрепи вдясно',unpin:'Премахване'},columnMenu:{close:'Затвори'},gridMenu:{aria:{buttonLabel:'Меню на таблицата'},columns:'Колони:',importerTitle:'Импортиране на файл',exporterAllAsCsv:'Експортиране на данните като csv',exporterVisibleAsCsv:'Експортиране на видимите данни като csv',exporterSelectedAsCsv:'Експортиране на избраните данни като csv',exporterAllAsPdf:'Експортиране на данните като pdf',exporterVisibleAsPdf:'Експортиране на видимите данни като pdf',exporterSelectedAsPdf:'Експортиране на избраните данни като pdf',clearAllFilters:'Премахни всички филтри'},importer:{noHeaders:'Имената на колоните не успяха да бъдат извлечени, файлът има ли хедър?',noObjects:'Обектите не успяха да бъдат извлечени, файлът съдържа ли данни, различни от хедър?',invalidCsv:'Файлът не може да бъде обработеб, уверете се, че е валиден CSV файл',invalidJson:'Файлът не може да бъде обработеб, уверете се, че е валиден JSON файл',jsonNotArray:'Импортираният JSON файл трябва да съдържа масив, прекратяване.'},pagination:{aria:{pageToFirst:'Към първа страница',pageBack:'Страница назад',pageSelected:'Избрана страница',pageForward:'Страница напред',pageToLast:'Към последна страница'},sizes:'обекта на страница',totalItems:'обекта',through:'до',of:'от'},grouping:{group:'Групиране',ungroup:'Премахване на групирането',aggregate_count:'Сбор: Брой',aggregate_sum:'Сбор: Сума',aggregate_max:'Сбор: Максимум',aggregate_min:'Сбор: Минимум',aggregate_avg:'Сбор: Средно',aggregate_remove:'Сбор: Премахване'},validate:{error:'Грешка:',minLength:'Стойността трябва да съдържа поне THRESHOLD символа.',maxLength:'Стойността не трябва да съдържа повече от THRESHOLD символа.',required:'Необходима е стойност.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){var lang={aggregate:{label:'položky'},groupPanel:{description:'Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce.'},search:{placeholder:'Hledat...',showingItems:'Zobrazuji položky:',selectedItems:'Vybrané položky:',totalItems:'Celkem položek:',size:'Velikost strany:',first:'První strana',next:'Další strana',previous:'Předchozí strana',last:'Poslední strana'},menu:{text:'Vyberte sloupec:'},sort:{ascending:'Seřadit od A-Z',descending:'Seřadit od Z-A',remove:'Odebrat seřazení'},column:{hide:'Schovat sloupec'},aggregation:{count:'celkem řádků: ',sum:'celkem: ',avg:'avg: ',min:'min.: ',max:'max.: '},pinning:{pinLeft:'Zamknout vlevo',pinRight:'Zamknout vpravo',unpin:'Odemknout'},gridMenu:{columns:'Sloupce:',importerTitle:'Importovat soubor',exporterAllAsCsv:'Exportovat všechna data do csv',exporterVisibleAsCsv:'Exportovat viditelná data do csv',exporterSelectedAsCsv:'Exportovat vybraná data do csv',exporterAllAsPdf:'Exportovat všechna data do pdf',exporterVisibleAsPdf:'Exportovat viditelná data do pdf',exporterSelectedAsPdf:'Exportovat vybraná data do pdf',exporterAllAsExcel:'Exportovat všechna data do excel',exporterVisibleAsExcel:'Exportovat viditelná data do excel',exporterSelectedAsExcel:'Exportovat vybraná data do excel',clearAllFilters:'Odstranit všechny filtry'},importer:{noHeaders:'Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?',noObjects:'Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?',invalidCsv:'Soubor nelze zpracovat, jedná se o CSV?',invalidJson:'Soubor nelze zpracovat, je to JSON?',jsonNotArray:'Soubor musí obsahovat json. Ukončuji..'},pagination:{sizes:'položek na stránku',totalItems:'položek'},grouping:{group:'Seskupit',ungroup:'Odebrat seskupení',aggregate_count:'Agregace: Count',aggregate_sum:'Agregace: Sum',aggregate_max:'Agregace: Max',aggregate_min:'Agregace: Min',aggregate_avg:'Agregace: Avg',aggregate_remove:'Agregace: Odebrat'}};// support varianty of different czech keys.
$delegate.add('cs',lang);$delegate.add('cz',lang);$delegate.add('cs-cz',lang);$delegate.add('cs-CZ',lang);return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('da',{aggregate:{label:'artikler'},groupPanel:{description:'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.'},search:{placeholder:'Søg...',showingItems:'Viste rækker:',selectedItems:'Valgte rækker:',totalItems:'Rækker totalt:',size:'Side størrelse:',first:'Første side',next:'Næste side',previous:'Forrige side',last:'Sidste side'},menu:{text:'Vælg kolonner:'},sort:{ascending:'Sorter stigende',descending:'Sorter faldende',none:'Sorter ingen',remove:'Fjern sortering'},column:{hide:'Skjul kolonne'},aggregation:{count:'antal rækker: ',sum:'sum: ',avg:'gns: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Fastgør til venstre',pinRight:'Fastgør til højre',unpin:'Frigør'},gridMenu:{columns:'Kolonner:',importerTitle:'Importer fil',exporterAllAsCsv:'Eksporter alle data som csv',exporterVisibleAsCsv:'Eksporter synlige data som csv',exporterSelectedAsCsv:'Eksporter markerede data som csv',exporterAllAsPdf:'Eksporter alle data som pdf',exporterVisibleAsPdf:'Eksporter synlige data som pdf',exporterSelectedAsPdf:'Eksporter markerede data som pdf',exporterAllAsExcel:'Eksporter alle data som excel',exporterVisibleAsExcel:'Eksporter synlige data som excel',exporterSelectedAsExcel:'Eksporter markerede data som excel',clearAllFilters:'Clear all filters'},importer:{noHeaders:'Column names were unable to be derived, does the file have a header?',noObjects:'Objects were not able to be derived, was there data in the file other than headers?',invalidCsv:'File was unable to be processed, is it valid CSV?',invalidJson:'File was unable to be processed, is it valid Json?',jsonNotArray:'Imported json file must contain an array, aborting.'},pagination:{aria:{pageToFirst:'Gå til første',pageBack:'Gå tilbage',pageSelected:'Valgte side',pageForward:'Gå frem',pageToLast:'Gå til sidste'},sizes:'genstande per side',totalItems:'genstande',through:'gennem',of:'af'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('de',{headerCell:{aria:{defaultFilterLabel:'Filter für Spalte',removeFilter:'Filter löschen',columnMenuButtonLabel:'Spaltenmenü',column:'Spalte'},priority:'Priorität:',filterLabel:"Filter für Spalte: "},aggregate:{label:'Eintrag'},groupPanel:{description:'Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren.'},search:{aria:{selected:'Zeile markiert',notSelected:'Zeile nicht markiert'},placeholder:'Suche...',showingItems:'Zeige Einträge:',selectedItems:'Ausgewählte Einträge:',totalItems:'Einträge gesamt:',size:'Einträge pro Seite:',first:'Erste Seite',next:'Nächste Seite',previous:'Vorherige Seite',last:'Letzte Seite'},selection:{aria:{row:'Zeile'},selectAll:'Alle auswählen',displayName:'Zeilenauswahlkasten'},menu:{text:'Spalten auswählen:'},sort:{ascending:'aufsteigend sortieren',descending:'absteigend sortieren',none:'keine Sortierung',remove:'Sortierung zurücksetzen'},column:{hide:'Spalte ausblenden'},aggregation:{count:'Zeilen insgesamt: ',sum:'gesamt: ',avg:'Durchschnitt: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Links anheften',pinRight:'Rechts anheften',unpin:'Lösen'},columnMenu:{close:'Schließen'},gridMenu:{aria:{buttonLabel:'Tabellenmenü'},columns:'Spalten:',importerTitle:'Datei importieren',exporterAllAsCsv:'Alle Daten als CSV exportieren',exporterVisibleAsCsv:'Sichtbare Daten als CSV exportieren',exporterSelectedAsCsv:'Markierte Daten als CSV exportieren',exporterAllAsPdf:'Alle Daten als PDF exportieren',exporterVisibleAsPdf:'Sichtbare Daten als PDF exportieren',exporterSelectedAsPdf:'Markierte Daten als PDF exportieren',exporterAllAsExcel:'Alle Daten als Excel exportieren',exporterVisibleAsExcel:'Sichtbare Daten als Excel exportieren',exporterSelectedAsExcel:'Markierte Daten als Excel exportieren',clearAllFilters:'Alle Filter zurücksetzen'},importer:{noHeaders:'Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?',noObjects:'Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?',invalidCsv:'Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?',invalidJson:'Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?',jsonNotArray:'Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab.'},pagination:{aria:{pageToFirst:'Zum Anfang',pageBack:'Seite zurück',pageSelected:'Ausgewählte Seite',pageForward:'Seite vor',pageToLast:'Zum Ende'},sizes:'Einträge pro Seite',totalItems:'Einträgen',through:'bis',of:'von'},grouping:{group:'Gruppieren',ungroup:'Gruppierung aufheben',aggregate_count:'Agg: Anzahl',aggregate_sum:'Agg: Summe',aggregate_max:'Agg: Maximum',aggregate_min:'Agg: Minimum',aggregate_avg:'Agg: Mittelwert',aggregate_remove:'Aggregation entfernen'},validate:{error:'Fehler:',minLength:'Der Wert sollte mindestens THRESHOLD Zeichen lang sein.',maxLength:'Der Wert sollte maximal THRESHOLD Zeichen lang sein.',required:'Ein Wert wird benötigt.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('es-ct',{headerCell:{aria:{defaultFilterLabel:'Filtre per columna',removeFilter:'Elimina el filtre',columnMenuButtonLabel:'Menú de Columna',column:'Columna'},priority:'Priority:',filterLabel:'Filtre per columna: '},aggregate:{label:'items'},groupPanel:{description:'Arrossegueu una capçalera de columna aquí i deixeu-lo anar per agrupar per aquesta columna.'},search:{aria:{selected:'Fila seleccionada',notSelected:'Fila no seleccionada'},placeholder:'Cerca...',showingItems:'Ítems Mostrats:',selectedItems:'Ítems Seleccionats:',totalItems:'Ítems Totals:',size:'Mida de la pàgina:',first:'Primera Pàgina',next:'Propera Pàgina',previous:'Pàgina Anterior',last:'Última Pàgina'},selection:{aria:{row:'Fila'},selectAll:'Seleccionar Todo',displayName:'Seleccionar Fila'},menu:{text:'Triar Columnes:'},sort:{ascending:'Ordena Ascendent',descending:'Ordena Descendent',none:'Sense Ordre',remove:'Eliminar Ordre'},column:{hide:'Amaga la Columna'},aggregation:{count:'Files Totals: ',sum:'total: ',avg:'mitjà: ',min:'mín: ',max:'màx: '},pinning:{pinLeft:"Fixar a l'Esquerra",pinRight:'Fixar a la Dreta',unpin:'Treure Fixació'},columnMenu:{close:'Tanca'},gridMenu:{aria:{buttonLabel:'Menú de Quadrícula'},columns:'Columnes:',importerTitle:'Importa el fitxer',exporterAllAsCsv:'Exporta tot com CSV',exporterVisibleAsCsv:'Exporta les dades visibles com a CSV',exporterSelectedAsCsv:'Exporta les dades seleccionades com a CSV',exporterAllAsPdf:'Exporta tot com PDF',exporterVisibleAsPdf:'Exporta les dades visibles com a PDF',exporterSelectedAsPdf:'Exporta les dades seleccionades com a PDF',exporterAllAsExcel:'Exporta tot com Excel',exporterVisibleAsExcel:'Exporta les dades visibles com Excel',exporterSelectedAsExcel:'Exporta les dades seleccionades com Excel',clearAllFilters:'Netejar tots els filtres'},importer:{noHeaders:"No va ser possible derivar els noms de les columnes, té encapçalats l'arxiu?",noObjects:"No va ser possible obtenir registres, conté dades l'arxiu, a part de les capçaleres?",invalidCsv:"No va ser possible processar l'arxiu, ¿és un CSV vàlid?",invalidJson:"No va ser possible processar l'arxiu, ¿és un JSON vàlid?",jsonNotArray:'El fitxer json importat ha de contenir una matriu, avortant.'},pagination:{aria:{pageToFirst:'Page to first',pageBack:'Page back',pageSelected:'Selected page',pageForward:'Page forward',pageToLast:'Page to last'},sizes:'ítems per pàgina',totalItems:'ítems',through:'a',of:'de'},grouping:{group:'Agrupar',ungroup:'Desagrupar',aggregate_count:'Agr: Compte',aggregate_sum:'Agr: Sum',aggregate_max:'Agr: Máx',aggregate_min:'Agr: Mín',aggregate_avg:'Agr: Mitjà',aggregate_remove:'Agr: Treure'},validate:{error:'Error:',minLength:'El valor ha de tenir almenys caràcters THRESHOLD.',maxLength:'El valor ha de tenir com a màxim caràcters THRESHOLD.',required:'Un valor és necessari.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('es',{aggregate:{label:'Artículos'},groupPanel:{description:'Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna.'},search:{placeholder:'Buscar...',showingItems:'Artículos Mostrados:',selectedItems:'Artículos Seleccionados:',totalItems:'Artículos Totales:',size:'Tamaño de Página:',first:'Primera Página',next:'Página Siguiente',previous:'Página Anterior',last:'Última Página'},selection:{aria:{row:'Fila'},selectAll:'Seleccionar Todo',displayName:'Seleccionar Fila'},menu:{text:'Elegir columnas:'},sort:{ascending:'Orden Ascendente',descending:'Orden Descendente',remove:'Sin Ordenar'},column:{hide:'Ocultar la columna'},aggregation:{count:'filas totales: ',sum:'total: ',avg:'media: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Fijar a la Izquierda',pinRight:'Fijar a la Derecha',unpin:'Quitar Fijación'},gridMenu:{columns:'Columnas:',importerTitle:'Importar archivo',exporterAllAsCsv:'Exportar todo como csv',exporterVisibleAsCsv:'Exportar vista como csv',exporterSelectedAsCsv:'Exportar selección como csv',exporterAllAsPdf:'Exportar todo como pdf',exporterVisibleAsPdf:'Exportar vista como pdf',exporterSelectedAsPdf:'Exportar selección como pdf',exporterAllAsExcel:'Exportar todo como excel',exporterVisibleAsExcel:'Exportar vista como excel',exporterSelectedAsExcel:'Exportar selección como excel',clearAllFilters:'Limpiar todos los filtros'},importer:{noHeaders:'No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?',noObjects:'No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?',invalidCsv:'No fue posible procesar el archivo, ¿es un CSV válido?',invalidJson:'No fue posible procesar el archivo, ¿es un Json válido?',jsonNotArray:'El archivo json importado debe contener un array, abortando.'},pagination:{aria:{pageToFirst:'Página para primero',pageBack:'Página atrás',pageSelected:'Página seleccionada',pageForward:'Avance de página',pageToLast:'Página para durar'},through:'mediante',sizes:'registros por página',totalItems:'registros',of:'de'},grouping:{group:'Agrupar',ungroup:'Desagrupar',aggregate_count:'Agr: Cont',aggregate_sum:'Agr: Sum',aggregate_max:'Agr: Máx',aggregate_min:'Agr: Min',aggregate_avg:'Agr: Prom',aggregate_remove:'Agr: Quitar'}});return $delegate;}]);}]);})();/**
 * Translated by: R. Salarmehr
 *                M. Hosseynzade
 *                Using Vajje.com online dictionary.
 */(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('fa',{aggregate:{label:'قلم'},groupPanel:{description:'عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن.'},search:{placeholder:'جستجو...',showingItems:'نمایش اقلام:',selectedItems:'قلم\u200cهای انتخاب شده:',totalItems:'مجموع اقلام:',size:'اندازه\u200cی صفحه:',first:'اولین صفحه',next:'صفحه\u200cی\u200cبعدی',previous:'صفحه\u200cی\u200c قبلی',last:'آخرین صفحه'},menu:{text:'ستون\u200cهای انتخابی:'},sort:{ascending:'ترتیب صعودی',descending:'ترتیب نزولی',remove:'حذف مرتب کردن'},column:{hide:'پنهان\u200cکردن ستون'},aggregation:{count:'تعداد: ',sum:'مجموع: ',avg:'میانگین: ',min:'کمترین: ',max:'بیشترین: '},pinning:{pinLeft:'پین کردن سمت چپ',pinRight:'پین کردن سمت راست',unpin:'حذف پین'},gridMenu:{columns:'ستون\u200cها:',importerTitle:'وارد کردن فایل',exporterAllAsCsv:'خروجی تمام داده\u200cها در فایل csv',exporterVisibleAsCsv:'خروجی داده\u200cهای قابل مشاهده در فایل csv',exporterSelectedAsCsv:'خروجی داده\u200cهای انتخاب\u200cشده در فایل csv',exporterAllAsPdf:'خروجی تمام داده\u200cها در فایل pdf',exporterVisibleAsPdf:'خروجی داده\u200cهای قابل مشاهده در فایل pdf',exporterSelectedAsPdf:'خروجی داده\u200cهای انتخاب\u200cشده در فایل pdf',clearAllFilters:'پاک کردن تمام فیلتر'},importer:{noHeaders:'نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟',noObjects:'اشیا قابل استخراج نیستند. آیا به جز عنوان\u200cها در فایل داده وجود دارد؟',invalidCsv:'فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟',invalidJson:'فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟',jsonNotArray:'فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد.'},pagination:{sizes:'اقلام در هر صفحه',totalItems:'اقلام',of:'از'},grouping:{group:'گروه\u200cبندی',ungroup:'حذف گروه\u200cبندی',aggregate_count:'Agg: تعداد',aggregate_sum:'Agg: جمع',aggregate_max:'Agg: بیشینه',aggregate_min:'Agg: کمینه',aggregate_avg:'Agg: میانگین',aggregate_remove:'Agg: حذف'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('fi',{aggregate:{label:'rivit'},groupPanel:{description:'Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan.'},search:{placeholder:'Hae...',showingItems:'Näytetään rivejä:',selectedItems:'Valitut rivit:',totalItems:'Rivejä yht.:',size:'Näytä:',first:'Ensimmäinen sivu',next:'Seuraava sivu',previous:'Edellinen sivu',last:'Viimeinen sivu'},menu:{text:'Valitse sarakkeet:'},sort:{ascending:'Järjestä nouseva',descending:'Järjestä laskeva',remove:'Poista järjestys'},column:{hide:'Piilota sarake'},aggregation:{count:'Rivejä yht.: ',sum:'Summa: ',avg:'K.a.: ',min:'Min: ',max:'Max: '},pinning:{pinLeft:'Lukitse vasemmalle',pinRight:'Lukitse oikealle',unpin:'Poista lukitus'},gridMenu:{columns:'Sarakkeet:',importerTitle:'Tuo tiedosto',exporterAllAsCsv:'Vie tiedot csv-muodossa',exporterVisibleAsCsv:'Vie näkyvä tieto csv-muodossa',exporterSelectedAsCsv:'Vie valittu tieto csv-muodossa',exporterAllAsPdf:'Vie tiedot pdf-muodossa',exporterVisibleAsPdf:'Vie näkyvä tieto pdf-muodossa',exporterSelectedAsPdf:'Vie valittu tieto pdf-muodossa',exporterAllAsExcel:'Vie tiedot excel-muodossa',exporterVisibleAsExcel:'Vie näkyvä tieto excel-muodossa',exporterSelectedAsExcel:'Vie valittu tieto excel-muodossa',clearAllFilters:'Puhdista kaikki suodattimet'},importer:{noHeaders:'Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?',noObjects:'Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?',invalidCsv:'Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?',invalidJson:'Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?',jsonNotArray:'Tiedosto ei sisältänyt taulukkoa, lopetetaan.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('fr',{headerCell:{aria:{defaultFilterLabel:'Filtre de la colonne',removeFilter:'Supprimer le filtre',columnMenuButtonLabel:'Menu de la colonne'},priority:'Priorité:',filterLabel:"Filtre de la colonne: "},aggregate:{label:'éléments'},groupPanel:{description:'Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes.'},search:{placeholder:'Recherche...',showingItems:'Affichage des éléments :',selectedItems:'Éléments sélectionnés :',totalItems:'Nombre total d\'éléments:',size:'Taille de page:',first:'Première page',next:'Page Suivante',previous:'Page précédente',last:'Dernière page'},selection:{aria:{row:'Ligne'},selectAll:'Tout Sélectionner',displayName:'Sélectionnez la ligne'},menu:{text:'Choisir des colonnes :'},sort:{ascending:'Trier par ordre croissant',descending:'Trier par ordre décroissant',none:'Aucun tri',remove:'Enlever le tri'},column:{hide:'Cacher la colonne'},aggregation:{count:'lignes totales: ',sum:'total: ',avg:'moy: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Épingler à gauche',pinRight:'Épingler à droite',unpin:'Détacher'},columnMenu:{close:'Fermer'},gridMenu:{aria:{buttonLabel:'Menu du tableau'},columns:'Colonnes:',importerTitle:'Importer un fichier',exporterAllAsCsv:'Exporter toutes les données en CSV',exporterVisibleAsCsv:'Exporter les données visibles en CSV',exporterSelectedAsCsv:'Exporter les données sélectionnées en CSV',exporterAllAsPdf:'Exporter toutes les données en PDF',exporterVisibleAsPdf:'Exporter les données visibles en PDF',exporterSelectedAsPdf:'Exporter les données sélectionnées en PDF',exporterAllAsExcel:'Exporter toutes les données en Excel',exporterVisibleAsExcel:'Exporter les données visibles en Excel',exporterSelectedAsExcel:'Exporter les données sélectionnées en Excel',clearAllFilters:'Nettoyez tous les filtres'},importer:{noHeaders:'Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?',noObjects:'Aucun objet trouvé, le fichier possède-t-il des données autres que l\'en-tête ?',invalidCsv:'Le fichier n\'a pas pu être traité, le CSV est-il valide ?',invalidJson:'Le fichier n\'a pas pu être traité, le JSON est-il valide ?',jsonNotArray:'Le fichier JSON importé doit contenir un tableau, abandon.'},pagination:{aria:{pageToFirst:'Aller à la première page',pageBack:'Page précédente',pageSelected:'Page sélectionnée',pageForward:'Page suivante',pageToLast:'Aller à la dernière page'},sizes:'éléments par page',totalItems:'éléments',through:'à',of:'sur'},grouping:{group:'Grouper',ungroup:'Dégrouper',aggregate_count:'Agg: Compter',aggregate_sum:'Agg: Somme',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Moy',aggregate_remove:'Agg: Retirer'},validate:{error:'Erreur:',minLength:'La valeur doit être supérieure ou égale à THRESHOLD caractères.',maxLength:'La valeur doit être inférieure ou égale à THRESHOLD caractères.',required:'Une valeur est nécéssaire.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('he',{aggregate:{label:'items'},groupPanel:{description:'גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו.'},search:{placeholder:'חפש...',showingItems:'מציג:',selectedItems:'סה"כ נבחרו:',totalItems:'סה"כ רשומות:',size:'תוצאות בדף:',first:'דף ראשון',next:'דף הבא',previous:'דף קודם',last:'דף אחרון'},menu:{text:'בחר עמודות:'},sort:{ascending:'סדר עולה',descending:'סדר יורד',remove:'בטל'},column:{hide:'טור הסתר'},aggregation:{count:'total rows: ',sum:'total: ',avg:'avg: ',min:'min: ',max:'max: '},gridMenu:{columns:'Columns:',importerTitle:'Import file',exporterAllAsCsv:'Export all data as csv',exporterVisibleAsCsv:'Export visible data as csv',exporterSelectedAsCsv:'Export selected data as csv',exporterAllAsPdf:'Export all data as pdf',exporterVisibleAsPdf:'Export visible data as pdf',exporterSelectedAsPdf:'Export selected data as pdf',exporterAllAsExcel:'Export all data as excel',exporterVisibleAsExcel:'Export visible data as excel',exporterSelectedAsExcel:'Export selected data as excel',clearAllFilters:'Clean all filters'},importer:{noHeaders:'Column names were unable to be derived, does the file have a header?',noObjects:'Objects were not able to be derived, was there data in the file other than headers?',invalidCsv:'File was unable to be processed, is it valid CSV?',invalidJson:'File was unable to be processed, is it valid Json?',jsonNotArray:'Imported json file must contain an array, aborting.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('hy',{aggregate:{label:'տվյալներ'},groupPanel:{description:'Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։'},search:{placeholder:'Փնտրում...',showingItems:'Ցուցադրված տվյալներ՝',selectedItems:'Ընտրված:',totalItems:'Ընդամենը՝',size:'Տողերի քանակը էջում՝',first:'Առաջին էջ',next:'Հաջորդ էջ',previous:'Նախորդ էջ',last:'Վերջին էջ'},menu:{text:'Ընտրել սյուները:'},sort:{ascending:'Աճման կարգով',descending:'Նվազման կարգով',remove:'Հանել '},column:{hide:'Թաքցնել սյունը'},aggregation:{count:'ընդամենը տող՝ ',sum:'ընդամենը՝ ',avg:'միջին՝ ',min:'մին՝ ',max:'մաքս՝ '},pinning:{pinLeft:'Կպցնել ձախ կողմում',pinRight:'Կպցնել աջ կողմում',unpin:'Արձակել'},gridMenu:{columns:'Սյուներ:',importerTitle:'Ներմուծել ֆայլ',exporterAllAsCsv:'Արտահանել ամբողջը CSV',exporterVisibleAsCsv:'Արտահանել երևացող տվյալները CSV',exporterSelectedAsCsv:'Արտահանել ընտրված տվյալները CSV',exporterAllAsPdf:'Արտահանել PDF',exporterVisibleAsPdf:'Արտահանել երևացող տվյալները PDF',exporterSelectedAsPdf:'Արտահանել ընտրված տվյալները PDF',exporterAllAsExcel:'Արտահանել excel',exporterVisibleAsExcel:'Արտահանել երևացող տվյալները excel',exporterSelectedAsExcel:'Արտահանել ընտրված տվյալները excel',clearAllFilters:'Մաքրել բոլոր ֆիլտրերը'},importer:{noHeaders:'Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։',noObjects:'Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։',invalidCsv:'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։',invalidJson:'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։',jsonNotArray:'Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('is',{headerCell:{aria:{defaultFilterLabel:'Sía fyrir dálk',removeFilter:'Fjarlægja síu',columnMenuButtonLabel:'Dálkavalmynd'},priority:'Forgangsröðun:',filterLabel:"Sía fyrir dálka: "},aggregate:{label:'hlutir'},groupPanel:{description:'Dragðu dálkhaus hingað til að flokka saman eftir þeim dálki.'},search:{placeholder:'Leita...',showingItems:'Sýni hluti:',selectedItems:'Valdir hlutir:',totalItems:'Hlutir alls:',size:'Stærð síðu:',first:'Fyrsta síða',next:'Næsta síða',previous:'Fyrri síða',last:'Síðasta síða'},menu:{text:'Veldu dálka:'},sort:{ascending:'Raða hækkandi',descending:'Raða lækkandi',none:'Engin röðun',remove:'Fjarlægja röðun'},column:{hide:'Fela dálk'},aggregation:{count:'fjöldi raða: ',sum:'summa: ',avg:'meðaltal: ',min:'lágmark: ',max:'hámark: '},pinning:{pinLeft:'Festa til vinstri',pinRight:'Festa til hægri',unpin:'Losa'},columnMenu:{close:'Loka'},gridMenu:{aria:{buttonLabel:'Töflu valmynd'},columns:'Dálkar:',importerTitle:'Flytja inn skjal',exporterAllAsCsv:'Flytja út gögn sem csv',exporterVisibleAsCsv:'Flytja út sýnileg gögn sem csv',exporterSelectedAsCsv:'Flytja út valin gögn sem csv',exporterAllAsPdf:'Flytja út öll gögn sem pdf',exporterVisibleAsPdf:'Flytja út sýnileg gögn sem pdf',exporterSelectedAsPdf:'Flytja út valin gögn sem pdf',clearAllFilters:'Hreinsa allar síur'},importer:{noHeaders:'Ekki hægt að vinna dálkanöfn úr skjalinu, er skjalið örugglega með haus?',noObjects:'Ekki hægt að vinna hluti úr skjalinu, voru örugglega gögn í skjalinu önnur en hausinn?',invalidCsv:'Tókst ekki að vinna skjal, er það örggulega gilt CSV?',invalidJson:'Tókst ekki að vinna skjal, er það örugglega gilt Json?',jsonNotArray:'Innflutt json skjal verður að innihalda fylki, hætti við.'},pagination:{aria:{pageToFirst:'Fletta að fyrstu',pageBack:'Fletta til baka',pageSelected:'Valin síða',pageForward:'Fletta áfram',pageToLast:'Fletta að síðustu'},sizes:'hlutir á síðu',totalItems:'hlutir',through:'gegnum',of:'af'},grouping:{group:'Flokka',ungroup:'Sundurliða',aggregate_count:'Fjöldi: ',aggregate_sum:'Summa: ',aggregate_max:'Hámark: ',aggregate_min:'Lágmark: ',aggregate_avg:'Meðaltal: ',aggregate_remove:'Fjarlægja: '},validate:{error:'Villa:',minLength:'Gildi ætti að vera a.m.k. THRESHOLD stafa langt.',maxLength:'Gildi ætti að vera í mesta lagi THRESHOLD stafa langt.',required:'Þarf að hafa gildi.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('it',{aggregate:{label:'elementi'},groupPanel:{description:'Trascina un\'intestazione all\'interno del gruppo della colonna.'},search:{placeholder:'Ricerca...',showingItems:'Mostra:',selectedItems:'Selezionati:',totalItems:'Totali:',size:'Tot Pagine:',first:'Prima',next:'Prossima',previous:'Precedente',last:'Ultima'},selection:{aria:{row:'Riga'},selectAll:'Seleccionar Todo',displayName:'Seleziona Riga'},menu:{text:'Scegli le colonne:'},sort:{ascending:'Asc.',descending:'Desc.',remove:'Annulla ordinamento'},column:{hide:'Nascondi'},aggregation:{count:'righe totali: ',sum:'tot: ',avg:'media: ',min:'minimo: ',max:'massimo: '},pinning:{pinLeft:'Blocca a sx',pinRight:'Blocca a dx',unpin:'Blocca in alto'},gridMenu:{columns:'Colonne:',importerTitle:'Importa',exporterAllAsCsv:'Esporta tutti i dati in CSV',exporterVisibleAsCsv:'Esporta i dati visibili in CSV',exporterSelectedAsCsv:'Esporta i dati selezionati in CSV',exporterAllAsPdf:'Esporta tutti i dati in PDF',exporterVisibleAsPdf:'Esporta i dati visibili in PDF',exporterSelectedAsPdf:'Esporta i dati selezionati in PDF',exporterAllAsExcel:'Esporta tutti i dati in excel',exporterVisibleAsExcel:'Esporta i dati visibili in excel',exporterSelectedAsExcel:'Esporta i dati selezionati in excel',clearAllFilters:'Pulire tutti i filtri'},importer:{noHeaders:'Impossibile reperire i nomi delle colonne, sicuro che siano indicati all\'interno del file?',noObjects:'Impossibile reperire gli oggetti, sicuro che siano indicati all\'interno del file?',invalidCsv:'Impossibile elaborare il file, sicuro che sia un CSV?',invalidJson:'Impossibile elaborare il file, sicuro che sia un JSON valido?',jsonNotArray:'Errore! Il file JSON da importare deve contenere un array.'},pagination:{aria:{pageToFirst:'Prima',pageBack:'Indietro',pageSelected:'Pagina selezionata',pageForward:'Avanti',pageToLast:'Ultima'},sizes:'elementi per pagina',totalItems:'elementi',through:'a',of:'di'},grouping:{group:'Raggruppa',ungroup:'Separa',aggregate_count:'Agg: N. Elem.',aggregate_sum:'Agg: Somma',aggregate_max:'Agg: Massimo',aggregate_min:'Agg: Minimo',aggregate_avg:'Agg: Media',aggregate_remove:'Agg: Rimuovi'},validate:{error:'Errore:',minLength:'Lunghezza minima pari a THRESHOLD caratteri.',maxLength:'Lunghezza massima pari a THRESHOLD caratteri.',required:'Necessario inserire un valore.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ja',{headerCell:{aria:{defaultFilterLabel:'列のフィルター',removeFilter:'フィルターの解除',columnMenuButtonLabel:'列のメニュー'},priority:'優先度:',filterLabel:"列フィルター: "},aggregate:{label:'項目'},groupPanel:{description:'ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。'},search:{placeholder:'検索...',showingItems:'表示中の項目:',selectedItems:'選択した項目:',totalItems:'項目の総数:',size:'ページサイズ:',first:'最初のページ',next:'次のページ',previous:'前のページ',last:'前のページ'},menu:{text:'列の選択:'},sort:{ascending:'昇順に並べ替え',descending:'降順に並べ替え',none:'並べ替え無し',remove:'並べ替えの解除'},column:{hide:'列の非表示'},aggregation:{count:'行数: ',sum:'合計: ',avg:'平均: ',min:'最小: ',max:'最大: '},pinning:{pinLeft:'左に固定',pinRight:'右に固定',unpin:'固定解除'},columnMenu:{close:'閉じる'},gridMenu:{aria:{buttonLabel:'グリッドメニュー'},columns:'列の表示/非表示:',importerTitle:'ファイルのインポート',exporterAllAsCsv:'すべてのデータをCSV形式でエクスポート',exporterVisibleAsCsv:'表示中のデータをCSV形式でエクスポート',exporterSelectedAsCsv:'選択したデータをCSV形式でエクスポート',exporterAllAsPdf:'すべてのデータをPDF形式でエクスポート',exporterVisibleAsPdf:'表示中のデータをPDF形式でエクスポート',exporterSelectedAsPdf:'選択したデータをPDF形式でエクスポート',clearAllFilters:'すべてのフィルタをクリア'},importer:{noHeaders:'列名を取得できません。ファイルにヘッダが含まれていることを確認してください。',noObjects:'オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。',invalidCsv:'ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。',invalidJson:'ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。',jsonNotArray:'インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。'},pagination:{aria:{pageToFirst:'最初のページ',pageBack:'前のページ',pageSelected:'現在のページ',pageForward:'次のページ',pageToLast:'最後のページ'},sizes:'件/ページ',totalItems:'件',through:'から',of:'件/全'},grouping:{group:'グループ化',ungroup:'グループ化の解除',aggregate_count:'集計表示: 行数',aggregate_sum:'集計表示: 合計',aggregate_max:'集計表示: 最大',aggregate_min:'集計表示: 最小',aggregate_avg:'集計表示: 平均',aggregate_remove:'集計表示: 解除'},validate:{error:'Error:',minLength:'THRESHOLD 文字以上で入力してください。',maxLength:'THRESHOLD 文字以下で入力してください。',required:'値が必要です。'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ko',{aggregate:{label:'아이템'},groupPanel:{description:'컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요.'},search:{placeholder:'검색...',showingItems:'항목 보여주기:',selectedItems:'선택 항목:',totalItems:'전체 항목:',size:'페이지 크기:',first:'첫번째 페이지',next:'다음 페이지',previous:'이전 페이지',last:'마지막 페이지'},menu:{text:'컬럼을 선택하세요:'},sort:{ascending:'오름차순 정렬',descending:'내림차순 정렬',remove:'소팅 제거'},column:{hide:'컬럼 제거'},aggregation:{count:'전체 갯수: ',sum:'전체: ',avg:'평균: ',min:'최소: ',max:'최대: '},pinning:{pinLeft:'왼쪽 핀',pinRight:'오른쪽 핀',unpin:'핀 제거'},gridMenu:{columns:'컬럼:',importerTitle:'파일 가져오기',exporterAllAsCsv:'csv로 모든 데이터 내보내기',exporterVisibleAsCsv:'csv로 보이는 데이터 내보내기',exporterSelectedAsCsv:'csv로 선택된 데이터 내보내기',exporterAllAsPdf:'pdf로 모든 데이터 내보내기',exporterVisibleAsPdf:'pdf로 보이는 데이터 내보내기',exporterSelectedAsPdf:'pdf로 선택 데이터 내보내기',clearAllFilters:'모든 필터를 청소'},importer:{noHeaders:'컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.',noObjects:'데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.',invalidCsv:'파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.',invalidJson:'파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.',jsonNotArray:'json 파일은 배열을 포함해야 합니다.'},pagination:{sizes:'페이지당 항목',totalItems:'전체 항목'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('nl',{aggregate:{label:'items'},groupPanel:{description:'Sleep hier een kolomnaam heen om op te groeperen.'},search:{placeholder:'Zoeken...',showingItems:'Getoonde items:',selectedItems:'Geselecteerde items:',totalItems:'Totaal aantal items:',size:'Items per pagina:',first:'Eerste pagina',next:'Volgende pagina',previous:'Vorige pagina',last:'Laatste pagina'},menu:{text:'Kies kolommen:'},sort:{ascending:'Sorteer oplopend',descending:'Sorteer aflopend',remove:'Verwijder sortering'},column:{hide:'Verberg kolom'},aggregation:{count:'Aantal rijen: ',sum:'Som: ',avg:'Gemiddelde: ',min:'Min: ',max:'Max: '},pinning:{pinLeft:'Zet links vast',pinRight:'Zet rechts vast',unpin:'Maak los'},gridMenu:{columns:'Kolommen:',importerTitle:'Importeer bestand',exporterAllAsCsv:'Exporteer alle data als csv',exporterVisibleAsCsv:'Exporteer zichtbare data als csv',exporterSelectedAsCsv:'Exporteer geselecteerde data als csv',exporterAllAsPdf:'Exporteer alle data als pdf',exporterVisibleAsPdf:'Exporteer zichtbare data als pdf',exporterSelectedAsPdf:'Exporteer geselecteerde data als pdf',exporterAllAsExcel:'Exporteer alle data als excel',exporterVisibleAsExcel:'Exporteer zichtbare data als excel',exporterSelectedAsExcel:'Exporteer alle data als excel',clearAllFilters:'Alle filters wissen'},importer:{noHeaders:'Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?',noObjects:'Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?',invalidCsv:'Het bestand kan niet verwerkt worden. Is het een valide csv bestand?',invalidJson:'Het bestand kan niet verwerkt worden. Is het valide json?',jsonNotArray:'Het json bestand moet een array bevatten. De actie wordt geannuleerd.'},pagination:{sizes:'items per pagina',totalItems:'items',of:'van de'},grouping:{group:'Groepeer',ungroup:'Groepering opheffen',aggregate_count:'Agg: Aantal',aggregate_sum:'Agg: Som',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Gem',aggregate_remove:'Agg: Verwijder'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('no',{headerCell:{aria:{defaultFilterLabel:'Filter for kolonne',removeFilter:'Fjern filter',columnMenuButtonLabel:'Kolonnemeny'},priority:'Prioritet:',filterLabel:"Filter for kolonne: "},aggregate:{label:'elementer'},groupPanel:{description:'Trekk en kolonneoverskrift hit og slipp den for å gruppere etter den kolonnen.'},search:{placeholder:'Søk...',showingItems:'Viste elementer:',selectedItems:'Valgte elementer:',totalItems:'Antall elementer:',size:'Sidestørrelse:',first:'Første side',next:'Neste side',previous:'Forrige side',last:'Siste side'},menu:{text:'Velg kolonner:'},sort:{ascending:'Sortere stigende',descending:'Sortere fallende',none:'Ingen sortering',remove:'Fjern sortering'},column:{hide:'Skjul kolonne'},aggregation:{count:'antall rader: ',sum:'total: ',avg:'gjennomsnitt: ',min:'minimum: ',max:'maksimum: '},pinning:{pinLeft:'Fest til venstre',pinRight:'Fest til høyre',unpin:'Løsne'},columnMenu:{close:'Lukk'},gridMenu:{aria:{buttonLabel:'Grid Menu'},columns:'Kolonner:',importerTitle:'Importer fil',exporterAllAsCsv:'Eksporter alle data som csv',exporterVisibleAsCsv:'Eksporter synlige data som csv',exporterSelectedAsCsv:'Eksporter utvalgte data som csv',exporterAllAsPdf:'Eksporter alle data som pdf',exporterVisibleAsPdf:'Eksporter synlige data som pdf',exporterSelectedAsPdf:'Eksporter utvalgte data som pdf',exporterAllAsExcel:'Eksporter alle data som excel',exporterVisibleAsExcel:'Eksporter synlige data som excel',exporterSelectedAsExcel:'Eksporter utvalgte data som excel',clearAllFilters:'Clear all filters'},importer:{noHeaders:'Kolonnenavn kunne ikke avledes. Har filen en overskrift?',noObjects:'Objekter kunne ikke avledes. Er der andre data i filen enn overskriften?',invalidCsv:'Filen kunne ikke behandles. Er den gyldig CSV?',invalidJson:'Filen kunne ikke behandles. Er den gyldig JSON?',jsonNotArray:'Importert JSON-fil må inneholde en liste. Avbryter.'},pagination:{aria:{pageToFirst:'Gå til første side',pageBack:'Gå til forrige side',pageSelected:'Valgte side',pageForward:'Gå til neste side',pageToLast:'Gå til siste side'},sizes:'elementer per side',totalItems:'elementer',through:'til',of:'av'},grouping:{group:'Gruppere',ungroup:'Fjerne gruppering',aggregate_count:'Agr: Antall',aggregate_sum:'Agr: Sum',aggregate_max:'Agr: Maksimum',aggregate_min:'Agr: Minimum',aggregate_avg:'Agr: Gjennomsnitt',aggregate_remove:'Agr: Fjern'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('pl',{headerCell:{aria:{defaultFilterLabel:'Filtr dla kolumny',removeFilter:'Usuń filtr',columnMenuButtonLabel:'Opcje kolumny',column:'Kolumna'},priority:'Priorytet:',filterLabel:"Filtr dla kolumny: "},aggregate:{label:'pozycji'},groupPanel:{description:'Przeciągnij nagłówek kolumny tutaj, aby pogrupować według niej.'},search:{aria:{selected:'Wiersz zaznaczony',notSelected:'Wiersz niezaznaczony'},placeholder:'Szukaj...',showingItems:'Widoczne pozycje:',selectedItems:'Zaznaczone pozycje:',totalItems:'Wszystkich pozycji:',size:'Rozmiar strony:',first:'Pierwsza strona',next:'Następna strona',previous:'Poprzednia strona',last:'Ostatnia strona'},menu:{text:'Wybierz kolumny:'},sort:{ascending:'Sortuj rosnąco',descending:'Sortuj malejąco',none:'Brak sortowania',remove:'Wyłącz sortowanie'},column:{hide:'Ukryj kolumnę'},aggregation:{count:'Razem pozycji: ',sum:'Razem: ',avg:'Średnia: ',min:'Min: ',max:'Max: '},pinning:{pinLeft:'Przypnij do lewej',pinRight:'Przypnij do prawej',unpin:'Odepnij'},columnMenu:{close:'Zamknij'},gridMenu:{aria:{buttonLabel:'Opcje tabeli'},columns:'Kolumny:',importerTitle:'Importuj plik',exporterAllAsCsv:'Eksportuj wszystkie dane do csv',exporterVisibleAsCsv:'Eksportuj widoczne dane do csv',exporterSelectedAsCsv:'Eksportuj zaznaczone dane do csv',exporterAllAsPdf:'Eksportuj wszystkie dane do pdf',exporterVisibleAsPdf:'Eksportuj widoczne dane do pdf',exporterSelectedAsPdf:'Eksportuj zaznaczone dane do pdf',exporterAllAsExcel:'Eksportuj wszystkie dane do excel',exporterVisibleAsExcel:'Eksportuj widoczne dane do excel',exporterSelectedAsExcel:'Eksportuj zaznaczone dane do excel',clearAllFilters:'Wyczyść filtry'},importer:{noHeaders:'Nie udało się wczytać nazw kolumn. Czy plik posiada nagłówek?',noObjects:'Nie udalo się wczytać pozycji. Czy plik zawiera dane?',invalidCsv:'Nie udało się przetworzyć pliku. Czy to prawidłowy plik CSV?',invalidJson:'Nie udało się przetworzyć pliku. Czy to prawidłowy plik JSON?',jsonNotArray:'Importowany plik JSON musi zawierać tablicę. Importowanie przerwane.'},pagination:{aria:{pageToFirst:'Pierwsza strona',pageBack:'Poprzednia strona',pageSelected:'Wybrana strona',pageForward:'Następna strona',pageToLast:'Ostatnia strona'},sizes:'pozycji na stronę',totalItems:'pozycji',through:'do',of:'z'},grouping:{group:'Grupuj',ungroup:'Rozgrupuj',aggregate_count:'Zbiorczo: Razem',aggregate_sum:'Zbiorczo: Suma',aggregate_max:'Zbiorczo: Max',aggregate_min:'Zbiorczo: Min',aggregate_avg:'Zbiorczo: Średnia',aggregate_remove:'Zbiorczo: Usuń'},validate:{error:'Błąd:',minLength:'Wartość powinna składać się z co najmniej THRESHOLD znaków.',maxLength:'Wartość powinna składać się z przynajmniej THRESHOLD znaków.',required:'Wartość jest wymagana.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('pt-br',{headerCell:{aria:{defaultFilterLabel:'Filtro por coluna',removeFilter:'Remover filtro',columnMenuButtonLabel:'Menu coluna',column:'Coluna'},priority:'Prioridade:',filterLabel:"Filtro por coluna: "},aggregate:{label:'itens'},groupPanel:{description:'Arraste e solte uma coluna aqui para agrupar por essa coluna'},search:{aria:{selected:'Linha selecionada',notSelected:'Linha não está selecionada'},placeholder:'Procurar...',showingItems:'Mostrando os Itens:',selectedItems:'Items Selecionados:',totalItems:'Total de Itens:',size:'Tamanho da Página:',first:'Primeira Página',next:'Próxima Página',previous:'Página Anterior',last:'Última Página'},selection:{aria:{row:'Linha'},selectAll:'Selecionar Tudo',displayName:'Caixa de Seleção da Linha'},menu:{text:'Selecione as colunas:'},sort:{ascending:'Ordenar Ascendente',descending:'Ordenar Descendente',none:'Nenhuma Ordem',remove:'Remover Ordenação'},column:{hide:'Esconder coluna'},aggregation:{count:'total de linhas: ',sum:'total: ',avg:'med: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Fixar Esquerda',pinRight:'Fixar Direita',unpin:'Desprender'},columnMenu:{close:'Fechar'},gridMenu:{aria:{buttonLabel:'Menu Grid'},columns:'Colunas:',importerTitle:'Importar arquivo',exporterAllAsCsv:'Exportar todos os dados como csv',exporterVisibleAsCsv:'Exportar dados visíveis como csv',exporterSelectedAsCsv:'Exportar dados selecionados como csv',exporterAllAsPdf:'Exportar todos os dados como pdf',exporterVisibleAsPdf:'Exportar dados visíveis como pdf',exporterSelectedAsPdf:'Exportar dados selecionados como pdf',exporterAllAsExcel:'Exportar todos os dados como excel',exporterVisibleAsExcel:'Exportar dados visíveis como excel',exporterSelectedAsExcel:'Exportar dados selecionados como excel',clearAllFilters:'Limpar todos os filtros'},importer:{noHeaders:'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',noObjects:'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',invalidCsv:'Arquivo não pode ser processado. É um CSV válido?',invalidJson:'Arquivo não pode ser processado. É um Json válido?',jsonNotArray:'Arquivo json importado tem que conter um array. Abortando.'},pagination:{aria:{pageToFirst:'Primeira página',pageBack:'Página anterior',pageSelected:'Página Selecionada',pageForward:'Proxima',pageToLast:'Anterior'},sizes:'itens por página',totalItems:'itens',through:'através dos',of:'de'},grouping:{group:'Agrupar',ungroup:'Desagrupar',aggregate_count:'Agr: Contar',aggregate_sum:'Agr: Soma',aggregate_max:'Agr: Max',aggregate_min:'Agr: Min',aggregate_avg:'Agr: Med',aggregate_remove:'Agr: Remover'},validate:{error:'Erro:',minLength:'O valor deve ter, no minimo, THRESHOLD caracteres.',maxLength:'O valor deve ter, no máximo, THRESHOLD caracteres.',required:'Um valor é necessário.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('pt',{headerCell:{aria:{defaultFilterLabel:'Filtro por coluna',removeFilter:'Remover filtro',columnMenuButtonLabel:'Menu coluna',column:'Coluna'},priority:'Prioridade:',filterLabel:"Filtro por coluna: "},aggregate:{label:'itens'},groupPanel:{description:'Arraste e solte uma coluna aqui para agrupar por essa coluna'},search:{aria:{selected:'Linha selecionada',notSelected:'Linha não está selecionada'},placeholder:'Procurar...',showingItems:'Mostrando os Itens:',selectedItems:'Itens Selecionados:',totalItems:'Total de Itens:',size:'Tamanho da Página:',first:'Primeira Página',next:'Próxima Página',previous:'Página Anterior',last:'Última Página'},selection:{aria:{row:'Linha'},selectAll:'Selecionar Tudo',displayName:'Caixa de Seleção da Linha'},menu:{text:'Selecione as colunas:'},sort:{ascending:'Ordenar Ascendente',descending:'Ordenar Descendente',none:'Nenhuma Ordem',remove:'Remover Ordenação'},column:{hide:'Esconder coluna'},aggregation:{count:'total de linhas: ',sum:'total: ',avg:'med: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Fixar Esquerda',pinRight:'Fixar Direita',unpin:'Desprender'},columnMenu:{close:'Fechar'},gridMenu:{aria:{buttonLabel:'Menu Grid'},columns:'Colunas:',importerTitle:'Importar ficheiro',exporterAllAsCsv:'Exportar todos os dados como csv',exporterVisibleAsCsv:'Exportar dados visíveis como csv',exporterSelectedAsCsv:'Exportar dados selecionados como csv',exporterAllAsPdf:'Exportar todos os dados como pdf',exporterVisibleAsPdf:'Exportar dados visíveis como pdf',exporterSelectedAsPdf:'Exportar dados selecionados como pdf',exporterAllAsExcel:'Exportar todos os dados como excel',exporterVisibleAsExcel:'Exportar dados visíveis como excel',exporterSelectedAsExcel:'Exportar dados selecionados como excel',clearAllFilters:'Limpar todos os filtros'},importer:{noHeaders:'Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?',noObjects:'Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?',invalidCsv:'Ficheiro não pode ser processado. É um CSV válido?',invalidJson:'Ficheiro não pode ser processado. É um Json válido?',jsonNotArray:'Ficheiro json importado tem que conter um array. Interrompendo.'},pagination:{aria:{pageToFirst:'Primeira página',pageBack:'Página anterior',pageSelected:'Página Selecionada',pageForward:'Próxima',pageToLast:'Anterior'},sizes:'itens por página',totalItems:'itens',through:'a',of:'de'},grouping:{group:'Agrupar',ungroup:'Desagrupar',aggregate_count:'Agr: Contar',aggregate_sum:'Agr: Soma',aggregate_max:'Agr: Max',aggregate_min:'Agr: Min',aggregate_avg:'Agr: Med',aggregate_remove:'Agr: Remover'},validate:{error:'Erro:',minLength:'O valor deve ter, no minimo, THRESHOLD caracteres.',maxLength:'O valor deve ter, no máximo, THRESHOLD caracteres.',required:'Um valor é necessário.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ro',{headerCell:{aria:{defaultFilterLabel:'Filtru pentru coloana',removeFilter:'Sterge filtru',columnMenuButtonLabel:'Column Menu'},priority:'Prioritate:',filterLabel:"Filtru pentru coloana:"},aggregate:{label:'Elemente'},groupPanel:{description:'Trage un cap de coloana aici pentru a grupa elementele dupa coloana respectiva'},search:{placeholder:'Cauta...',showingItems:'Arata elementele:',selectedItems:'Elementele selectate:',totalItems:'Total elemente:',size:'Marime pagina:',first:'Prima pagina',next:'Pagina urmatoare',previous:'Pagina anterioara',last:'Ultima pagina'},menu:{text:'Alege coloane:'},sort:{ascending:'Ordoneaza crescator',descending:'Ordoneaza descrescator',none:'Fara ordonare',remove:'Sterge ordonarea'},column:{hide:'Ascunde coloana'},aggregation:{count:'total linii: ',sum:'total: ',avg:'medie: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Pin la stanga',pinRight:'Pin la dreapta',unpin:'Sterge pinul'},columnMenu:{close:'Inchide'},gridMenu:{aria:{buttonLabel:'Grid Menu'},columns:'Coloane:',importerTitle:'Incarca fisier',exporterAllAsCsv:'Exporta toate datele ca csv',exporterVisibleAsCsv:'Exporta datele vizibile ca csv',exporterSelectedAsCsv:'Exporta datele selectate ca csv',exporterAllAsPdf:'Exporta toate datele ca pdf',exporterVisibleAsPdf:'Exporta datele vizibile ca pdf',exporterSelectedAsPdf:'Exporta datele selectate ca csv pdf',clearAllFilters:'Sterge toate filtrele'},importer:{noHeaders:'Numele coloanelor nu a putut fi incarcat, acest fisier are un header?',noObjects:'Datele nu au putut fi incarcate, exista date in fisier in afara numelor de coloane?',invalidCsv:'Fisierul nu a putut fi procesat, ati incarcat un CSV valid ?',invalidJson:'Fisierul nu a putut fi procesat, ati incarcat un Json valid?',jsonNotArray:'Json-ul incarcat trebuie sa contina un array, inchidere.'},pagination:{aria:{pageToFirst:'Prima pagina',pageBack:'O pagina inapoi',pageSelected:'Pagina selectata',pageForward:'O pagina inainte',pageToLast:'Ultima pagina'},sizes:'Elemente per pagina',totalItems:'elemente',through:'prin',of:'of'},grouping:{group:'Grupeaza',ungroup:'Opreste gruparea',aggregate_count:'Agg: Count',aggregate_sum:'Agg: Sum',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Avg',aggregate_remove:'Agg: Remove'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('rs-lat',{headerCell:{aria:{defaultFilterLabel:'Filter za kolonu',removeFilter:'Ukloni Filter',columnMenuButtonLabel:'Meni Kolone',column:'Kolona'},priority:'Prioritet:',filterLabel:"Filter za kolonu: "},aggregate:{label:'stavke'},groupPanel:{description:'Ovde prevuci zaglavlje kolone i spusti do grupe pored te kolone.'},search:{aria:{selected:'Red odabran',notSelected:'Red nije odabran'},placeholder:'Pretraga...',showingItems:'Prikazane Stavke:',selectedItems:'Odabrane Stavke:',totalItems:'Ukupno Stavki:',size:'Veličina Stranice:',first:'Prva Stranica',next:'Sledeća Stranica',previous:'Prethodna Stranica',last:'Poslednja Stranica'},menu:{text:'Odaberite kolonu:'},sort:{ascending:'Sortiraj po rastućem redosledu',descending:'Sortiraj po opadajućem redosledu',none:'Bez Sortiranja',remove:'Ukloni Sortiranje'},column:{hide:'Sakrij Kolonu'},aggregation:{count:'ukupno redova: ',sum:'ukupno: ',avg:'prosecno: ',min:'minimum: ',max:'maksimum: '},pinning:{pinLeft:'Zakači Levo',pinRight:'Zakači Desno',unpin:'Otkači'},columnMenu:{close:'Zatvori'},gridMenu:{aria:{buttonLabel:'Rešetkasti Meni'},columns:'Kolone:',importerTitle:'Importuj fajl',exporterAllAsCsv:'Eksportuj sve podatke kao csv',exporterVisibleAsCsv:'Eksportuj vidljive podatke kao csv',exporterSelectedAsCsv:'Eksportuj obeležene podatke kao csv',exporterAllAsPdf:'Eksportuj sve podatke kao pdf',exporterVisibleAsPdf:'Eksportuj vidljive podake kao pdf',exporterSelectedAsPdf:'Eksportuj odabrane podatke kao pdf',exporterAllAsExcel:'Eksportuj sve podatke kao excel',exporterVisibleAsExcel:'Eksportuj vidljive podatke kao excel',exporterSelectedAsExcel:'Eksportuj odabrane podatke kao excel',clearAllFilters:'Obriši sve filtere'},importer:{noHeaders:'Kolone se nisu mogle podeliti, da li fajl poseduje heder?',noObjects:'Objecti nisu mogli biti podeljeni, da li je bilo i drugih podataka sem hedera?',invalidCsv:'Fajl nije bilo moguće procesirati, da li je ispravni CSV?',invalidJson:'Fajl nije bilo moguće procesirati, da li je ispravni JSON',jsonNotArray:'Importovani json fajl mora da sadrži niz, prekidam operaciju.'},pagination:{aria:{pageToFirst:'Prva stranica',pageBack:'Stranica pre',pageSelected:'Odabrana stranica',pageForward:'Sledeća stranica',pageToLast:'Poslednja stranica'},sizes:'stavki po stranici',totalItems:'stavke',through:'kroz',of:'od'},grouping:{group:'Grupiši',ungroup:'Odrupiši',aggregate_count:'Agg: Broj',aggregate_sum:'Agg: Suma',aggregate_max:'Agg: Maksimum',aggregate_min:'Agg: Minimum',aggregate_avg:'Agg: Prosečna',aggregate_remove:'Agg: Ukloni'},validate:{error:'Greška:',minLength:'Vrednost bi trebala da bude duga bar THRESHOLD karaktera.',maxLength:'Vrednost bi trebalo da bude najviše duga THRESHOLD karaktera.',required:'Portreba je vrednost.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ru',{headerCell:{aria:{defaultFilterLabel:'Фильтр столбца',removeFilter:'Удалить фильтр',columnMenuButtonLabel:'Меню столбца'},priority:'Приоритет:',filterLabel:"Фильтр столбца: "},aggregate:{label:'элементы'},groupPanel:{description:'Для группировки по столбцу перетащите сюда его название.'},search:{placeholder:'Поиск...',showingItems:'Показать элементы:',selectedItems:'Выбранные элементы:',totalItems:'Всего элементов:',size:'Размер страницы:',first:'Первая страница',next:'Следующая страница',previous:'Предыдущая страница',last:'Последняя страница'},menu:{text:'Выбрать столбцы:'},sort:{ascending:'По возрастанию',descending:'По убыванию',none:'Без сортировки',remove:'Убрать сортировку'},column:{hide:'Спрятать столбец'},aggregation:{count:'всего строк: ',sum:'итого: ',avg:'среднее: ',min:'мин: ',max:'макс: '},pinning:{pinLeft:'Закрепить слева',pinRight:'Закрепить справа',unpin:'Открепить'},columnMenu:{close:'Закрыть'},gridMenu:{aria:{buttonLabel:'Меню'},columns:'Столбцы:',importerTitle:'Импортировать файл',exporterAllAsCsv:'Экспортировать всё в CSV',exporterVisibleAsCsv:'Экспортировать видимые данные в CSV',exporterSelectedAsCsv:'Экспортировать выбранные данные в CSV',exporterAllAsPdf:'Экспортировать всё в PDF',exporterVisibleAsPdf:'Экспортировать видимые данные в PDF',exporterSelectedAsPdf:'Экспортировать выбранные данные в PDF',exporterAllAsExcel:'Экспортировать всё в Excel',exporterVisibleAsExcel:'Экспортировать видимые данные в Excel',exporterSelectedAsExcel:'Экспортировать выбранные данные в Excel',clearAllFilters:'Очистить все фильтры'},importer:{noHeaders:'Не удалось получить названия столбцов, есть ли в файле заголовок?',noObjects:'Не удалось получить данные, есть ли в файле строки кроме заголовка?',invalidCsv:'Не удалось обработать файл, это правильный CSV-файл?',invalidJson:'Не удалось обработать файл, это правильный JSON?',jsonNotArray:'Импортируемый JSON-файл должен содержать массив, операция отменена.'},pagination:{aria:{pageToFirst:'Первая страница',pageBack:'Предыдущая страница',pageSelected:'Выбранная страница',pageForward:'Следующая страница',pageToLast:'Последняя страница'},sizes:'строк на страницу',totalItems:'строк',through:'по',of:'из'},grouping:{group:'Группировать',ungroup:'Разгруппировать',aggregate_count:'Группировать: Количество',aggregate_sum:'Для группы: Сумма',aggregate_max:'Для группы: Максимум',aggregate_min:'Для группы: Минимум',aggregate_avg:'Для группы: Среднее',aggregate_remove:'Для группы: Пусто'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('sk',{headerCell:{aria:{defaultFilterLabel:'Filter pre stĺpec',removeFilter:'Odstrániť filter',columnMenuButtonLabel:'Menu pre stĺpec',column:'Stĺpec'},priority:'Priorita:',filterLabel:"Filter pre stĺpec: "},aggregate:{label:'položky'},groupPanel:{description:'Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca.'},search:{aria:{selected:'Označený riadok',notSelected:'Neoznačený riadok'},placeholder:'Hľadaj...',showingItems:'Zobrazujem položky:',selectedItems:'Vybraté položky:',totalItems:'Počet položiek:',size:'Počet:',first:'Prvá strana',next:'Ďalšia strana',previous:'Predchádzajúca strana',last:'Posledná strana'},menu:{text:'Vyberte stĺpce:'},sort:{ascending:'Zotriediť vzostupne',descending:'Zotriediť zostupne',none:'Nezotriediť',remove:'Vymazať triedenie'},column:{hide:'Skryť stĺpec'},aggregation:{count:'počet riadkov: ',sum:'spolu: ',avg:'avg: ',min:'min: ',max:'max: '},pinning:{pinLeft:'Pripnúť vľavo',pinRight:'Pripnúť vpravo',unpin:'Odopnúť'},columnMenu:{close:'Zavrieť'},gridMenu:{aria:{buttonLabel:'Grid Menu'},columns:'Stĺpce:',importerTitle:'Importovať súbor',exporterAllAsCsv:'Exportovať všetky údaje ako CSV',exporterVisibleAsCsv:'Exportovť viditeľné údaje ako CSV',exporterSelectedAsCsv:'Exportovať označené údaje ako CSV',exporterAllAsPdf:'Exportovať všetky údaje ako pdf',exporterVisibleAsPdf:'Exportovať viditeľné údaje ako pdf',exporterSelectedAsPdf:'Exportovať označené údaje ako pdf',exporterAllAsExcel:'Exportovať všetky údaje ako excel',exporterVisibleAsExcel:'Exportovať viditeľné údaje ako excel',exporterSelectedAsExcel:'Exportovať označené údaje ako excel',clearAllFilters:'Zrušiť všetky filtre'},importer:{noHeaders:'Názvy stĺpcov sa nedali odvodiť, má súbor hlavičku?',noObjects:'Objekty nebolo možné odvodiť, existovali iné údaje v súbore ako hlavičky?',invalidCsv:'Súbor sa nepodarilo spracovať, je to platný súbor CSV?',invalidJson:'Súbor nebolo možné spracovať, je to platný súbor typu Json?',jsonNotArray:'Importovaný súbor json musí obsahovať pole, ukončujem.'},pagination:{aria:{pageToFirst:'Strana na začiatok',pageBack:'Strana dozadu',pageSelected:'Označená strana',pageForward:'Strana dopredu',pageToLast:'Strana na koniec'},sizes:'položky na stranu',totalItems:'položky spolu',through:'do konca',of:'z'},grouping:{group:'Zoskupiť',ungroup:'Zrušiť zoskupenie',aggregate_count:'Agg: Počet',aggregate_sum:'Agg: Suma',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Avg',aggregate_remove:'Agg: Zrušiť'},validate:{error:'Chyba:',minLength:'Hodnota by mala mať aspoň THRESHOLD znakov dlhá.',maxLength:'Hodnota by mala byť maximálne THRESHOLD znakov dlhá.',required:'Vyžaduje sa hodnota.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('sv',{headerCell:{aria:{defaultFilterLabel:'Kolumnfilter',removeFilter:'Ta bort filter',columnMenuButtonLabel:'Kolumnmeny',column:'Kolumn'},priority:'Prioritet:',filterLabel:"Filter för kolumn: "},aggregate:{label:'Poster'},groupPanel:{description:'Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen.'},search:{aria:{selected:'Rad är vald',notSelected:'Rad är inte vald'},placeholder:'Sök...',showingItems:'Visar:',selectedItems:'Valda:',totalItems:'Antal:',size:'Sidstorlek:',first:'Första sidan',next:'Nästa sida',previous:'Föregående sida',last:'Sista sidan'},menu:{text:'Välj kolumner:'},sort:{ascending:'Sortera stigande',descending:'Sortera fallande',none:'Ingen sortering',remove:'Inaktivera sortering'},column:{hide:'Göm kolumn'},aggregation:{count:'Antal rader: ',sum:'Summa: ',avg:'Genomsnitt: ',min:'Min: ',max:'Max: '},pinning:{pinLeft:'Fäst vänster',pinRight:'Fäst höger',unpin:'Lösgör'},columnMenu:{close:'Stäng'},gridMenu:{aria:{buttonLabel:'Meny'},columns:'Kolumner:',importerTitle:'Importera fil',exporterAllAsCsv:'Exportera all data som CSV',exporterVisibleAsCsv:'Exportera synlig data som CSV',exporterSelectedAsCsv:'Exportera markerad data som CSV',exporterAllAsPdf:'Exportera all data som PDF',exporterVisibleAsPdf:'Exportera synlig data som PDF',exporterSelectedAsPdf:'Exportera markerad data som PDF',exporterAllAsExcel:'Exportera all data till Excel',exporterVisibleAsExcel:'Exportera synlig data till Excel',exporterSelectedAsExcel:'Exportera markerad data till Excel',clearAllFilters:'Nollställ alla filter'},importer:{noHeaders:'Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?',noObjects:'Objekt kunde inte härledas. Har filen data undantaget sidhuvud?',invalidCsv:'Filen kunde inte behandlas, är den en giltig CSV?',invalidJson:'Filen kunde inte behandlas, är den en giltig JSON?',jsonNotArray:'Importerad JSON-fil måste innehålla ett fält. Import avbruten.'},pagination:{aria:{pageToFirst:'Gå till första sidan',pageBack:'Gå en sida bakåt',pageSelected:'Vald sida',pageForward:'Gå en sida framåt',pageToLast:'Gå till sista sidan'},sizes:'Poster per sida',totalItems:'Poster',through:'genom',of:'av'},grouping:{group:'Gruppera',ungroup:'Dela upp',aggregate_count:'Agg: Antal',aggregate_sum:'Agg: Summa',aggregate_max:'Agg: Max',aggregate_min:'Agg: Min',aggregate_avg:'Agg: Genomsnitt',aggregate_remove:'Agg: Ta bort'},validate:{error:'Error:',minLength:'Värdet borde vara minst THRESHOLD tecken långt.',maxLength:'Värdet borde vara max THRESHOLD tecken långt.',required:'Ett värde krävs.'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ta',{aggregate:{label:'உருப்படிகள்'},groupPanel:{description:'ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் '},search:{placeholder:'தேடல் ...',showingItems:'உருப்படிகளை காண்பித்தல்:',selectedItems:'தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:',totalItems:'மொத்த உருப்படிகள்:',size:'பக்க அளவு: ',first:'முதல் பக்கம்',next:'அடுத்த பக்கம்',previous:'முந்தைய பக்கம் ',last:'இறுதி பக்கம்'},menu:{text:'பத்திகளை தேர்ந்தெடு:'},sort:{ascending:'மேலிருந்து கீழாக',descending:'கீழிருந்து மேலாக',remove:'வரிசையை நீக்கு'},column:{hide:'பத்தியை மறைத்து வை '},aggregation:{count:'மொத்த வரிகள்:',sum:'மொத்தம்: ',avg:'சராசரி: ',min:'குறைந்தபட்ச: ',max:'அதிகபட்ச: '},pinning:{pinLeft:'இடதுபுறமாக தைக்க ',pinRight:'வலதுபுறமாக தைக்க',unpin:'பிரி'},gridMenu:{columns:'பத்திகள்:',importerTitle:'கோப்பு : படித்தல்',exporterAllAsCsv:'எல்லா தரவுகளையும் கோப்பாக்கு: csv',exporterVisibleAsCsv:'இருக்கும் தரவுகளை கோப்பாக்கு: csv',exporterSelectedAsCsv:'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv',exporterAllAsPdf:'எல்லா தரவுகளையும் கோப்பாக்கு: pdf',exporterVisibleAsPdf:'இருக்கும் தரவுகளை கோப்பாக்கு: pdf',exporterSelectedAsPdf:'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf',clearAllFilters:'Clear all filters'},importer:{noHeaders:'பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?',noObjects:'இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ',invalidCsv:'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv',invalidJson:'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json',jsonNotArray:'படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json'},pagination:{sizes:'உருப்படிகள் / பக்கம்',totalItems:'உருப்படிகள் '},grouping:{group:'குழு',ungroup:'பிரி',aggregate_count:'மதிப்பீட்டு : எண்ணு',aggregate_sum:'மதிப்பீட்டு : கூட்டல்',aggregate_max:'மதிப்பீட்டு : அதிகபட்சம்',aggregate_min:'மதிப்பீட்டு : குறைந்தபட்சம்',aggregate_avg:'மதிப்பீட்டு : சராசரி',aggregate_remove:'மதிப்பீட்டு : நீக்கு'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('tr',{headerCell:{aria:{defaultFilterLabel:'Sütun için filtre',removeFilter:'Filtreyi Kaldır',columnMenuButtonLabel:'Sütun Menüsü'},priority:'Öncelik:',filterLabel:"Sütun için filtre: "},aggregate:{label:'kayıtlar'},groupPanel:{description:'Sütuna göre gruplamak için sütun başlığını buraya sürükleyin ve bırakın.'},search:{placeholder:'Arama...',showingItems:'Gösterilen Kayıt:',selectedItems:'Seçili Kayıt:',totalItems:'Toplam Kayıt:',size:'Sayfa Boyutu:',first:'İlk Sayfa',next:'Sonraki Sayfa',previous:'Önceki Sayfa',last:'Son Sayfa'},menu:{text:'Sütunları Seç:'},sort:{ascending:'Artan Sırada Sırala',descending:'Azalan Sırada Sırala',none:'Sıralama Yapma',remove:'Sıralamayı Kaldır'},column:{hide:'Sütunu Gizle'},aggregation:{count:'toplam satır: ',sum:'toplam: ',avg:'ort: ',min:'min: ',max:'maks: '},pinning:{pinLeft:'Sola Sabitle',pinRight:'Sağa Sabitle',unpin:'Sabitlemeyi Kaldır'},columnMenu:{close:'Kapat'},gridMenu:{aria:{buttonLabel:'Tablo Menü'},columns:'Sütunlar:',importerTitle:'Dosya içeri aktar',exporterAllAsCsv:'Bütün veriyi CSV olarak dışarı aktar',exporterVisibleAsCsv:'Görünen veriyi CSV olarak dışarı aktar',exporterSelectedAsCsv:'Seçili veriyi CSV olarak dışarı aktar',exporterAllAsPdf:'Bütün veriyi PDF olarak dışarı aktar',exporterVisibleAsPdf:'Görünen veriyi PDF olarak dışarı aktar',exporterSelectedAsPdf:'Seçili veriyi PDF olarak dışarı aktar',clearAllFilters:'Bütün filtreleri kaldır'},importer:{noHeaders:'Sütun isimleri üretilemiyor, dosyanın bir başlığı var mı?',noObjects:'Nesneler üretilemiyor, dosyada başlıktan başka bir veri var mı?',invalidCsv:'Dosya işlenemedi, geçerli bir CSV dosyası mı?',invalidJson:'Dosya işlenemedi, geçerli bir Json dosyası mı?',jsonNotArray:'Alınan Json dosyasında bir dizi bulunmalıdır, işlem iptal ediliyor.'},pagination:{aria:{pageToFirst:'İlk sayfaya',pageBack:'Geri git',pageSelected:'Seçili sayfa',pageForward:'İleri git',pageToLast:'Sona git'},sizes:'Sayfadaki nesne sayısı',totalItems:'kayıtlar',through:'',// note(fsw) : turkish dont have this preposition
of:''// note(fsw) : turkish dont have this preposition
},grouping:{group:'Grupla',ungroup:'Gruplama',aggregate_count:'Yekun: Sayı',aggregate_sum:'Yekun: Toplam',aggregate_max:'Yekun: Maks',aggregate_min:'Yekun: Min',aggregate_avg:'Yekun: Ort',aggregate_remove:'Yekun: Sil'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('ua',{headerCell:{aria:{defaultFilterLabel:'Фільтр стовпчика',removeFilter:'Видалити фільтр',columnMenuButtonLabel:'Меню ствпчика'},priority:'Пріоритет:',filterLabel:"Фільтр стовпчика: "},aggregate:{label:'елементи'},groupPanel:{description:'Для групування за стовпчиком перетягніть сюди його назву.'},search:{placeholder:'Пошук...',showingItems:'Показати елементи:',selectedItems:'Обрані елементи:',totalItems:'Усього елементів:',size:'Розмір сторінки:',first:'Перша сторінка',next:'Наступна сторінка',previous:'Попередня сторінка',last:'Остання сторінка'},menu:{text:'Обрати ствпчики:'},sort:{ascending:'За зростанням',descending:'За спаданням',none:'Без сортування',remove:'Прибрати сортування'},column:{hide:'Приховати стовпчик'},aggregation:{count:'усього рядків: ',sum:'ітого: ',avg:'середнє: ',min:'мін: ',max:'макс: '},pinning:{pinLeft:'Закріпити ліворуч',pinRight:'Закріпити праворуч',unpin:'Відкріпити'},columnMenu:{close:'Закрити'},gridMenu:{aria:{buttonLabel:'Меню'},columns:'Стовпчики:',importerTitle:'Імпортувати файл',exporterAllAsCsv:'Експортувати все в CSV',exporterVisibleAsCsv:'Експортувати видимі дані в CSV',exporterSelectedAsCsv:'Експортувати обрані дані в CSV',exporterAllAsPdf:'Експортувати все в PDF',exporterVisibleAsPdf:'Експортувати видимі дані в PDF',exporterSelectedAsPdf:'Експортувати обрані дані в PDF',clearAllFilters:'Очистити всі фільтри'},importer:{noHeaders:'Не вдалося отримати назви стовпчиків, чи є в файлі заголовок?',noObjects:'Не вдалося отримати дані, чи є в файлі рядки окрім заголовка?',invalidCsv:'Не вдалося обробити файл, чи це коректний CSV-файл?',invalidJson:'Не вдалося обробити файл, чи це коректний JSON?',jsonNotArray:'JSON-файл що імпортується повинен містити масив, операцію скасовано.'},pagination:{aria:{pageToFirst:'Перша сторінка',pageBack:'Попередня сторінка',pageSelected:'Обрана сторінка',pageForward:'Наступна сторінка',pageToLast:'Остання сторінка'},sizes:'рядків на сторінку',totalItems:'рядків',through:'по',of:'з'},grouping:{group:'Групувати',ungroup:'Розгрупувати',aggregate_count:'Групувати: Кількість',aggregate_sum:'Для групи: Сума',aggregate_max:'Для групи: Максимум',aggregate_min:'Для групи: Мінімум',aggregate_avg:'Для групи: Серднє',aggregate_remove:'Для групи: Пусто'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('zh-cn',{headerCell:{aria:{defaultFilterLabel:'列过滤器',removeFilter:'移除过滤器',columnMenuButtonLabel:'列菜单'},priority:'优先级:',filterLabel:"列过滤器: "},aggregate:{label:'行'},groupPanel:{description:'拖曳表头到此处进行分组'},search:{placeholder:'查找',showingItems:'已显示行数：',selectedItems:'已选择行数：',totalItems:'总行数：',size:'每页显示行数：',first:'首页',next:'下一页',previous:'上一页',last:'末页'},menu:{text:'选择列：'},sort:{ascending:'升序',descending:'降序',none:'无序',remove:'取消排序'},column:{hide:'隐藏列'},aggregation:{count:'计数：',sum:'求和：',avg:'均值：',min:'最小值：',max:'最大值：'},pinning:{pinLeft:'左侧固定',pinRight:'右侧固定',unpin:'取消固定'},columnMenu:{close:'关闭'},gridMenu:{aria:{buttonLabel:'表格菜单'},columns:'列：',importerTitle:'导入文件',exporterAllAsCsv:'导出全部数据到CSV',exporterVisibleAsCsv:'导出可见数据到CSV',exporterSelectedAsCsv:'导出已选数据到CSV',exporterAllAsPdf:'导出全部数据到PDF',exporterVisibleAsPdf:'导出可见数据到PDF',exporterSelectedAsPdf:'导出已选数据到PDF',clearAllFilters:'清除所有过滤器'},importer:{noHeaders:'无法获取列名，确定文件包含表头？',noObjects:'无法获取数据，确定文件包含数据？',invalidCsv:'无法处理文件，确定是合法的CSV文件？',invalidJson:'无法处理文件，确定是合法的JSON文件？',jsonNotArray:'导入的文件不是JSON数组！'},pagination:{aria:{pageToFirst:'第一页',pageBack:'上一页',pageSelected:'当前页',pageForward:'下一页',pageToLast:'最后一页'},sizes:'行每页',totalItems:'行',through:'至',of:'共'},grouping:{group:'分组',ungroup:'取消分组',aggregate_count:'合计: 计数',aggregate_sum:'合计: 求和',aggregate_max:'合计: 最大',aggregate_min:'合计: 最小',aggregate_avg:'合计: 平均',aggregate_remove:'合计: 移除'}});return $delegate;}]);}]);})();(function(){angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('i18nService',['$delegate',function($delegate){$delegate.add('zh-tw',{aggregate:{label:'行'},groupPanel:{description:'拖曳表頭到此處進行分組'},search:{placeholder:'查找',showingItems:'已顯示行數：',selectedItems:'已選擇行數：',totalItems:'總行數：',size:'每頁顯示行數：',first:'首頁',next:'下壹頁',previous:'上壹頁',last:'末頁'},menu:{text:'選擇列：'},sort:{ascending:'升序',descending:'降序',remove:'取消排序'},column:{hide:'隱藏列'},aggregation:{count:'計數：',sum:'求和：',avg:'均值：',min:'最小值：',max:'最大值：'},pinning:{pinLeft:'左側固定',pinRight:'右側固定',unpin:'取消固定'},gridMenu:{columns:'列：',importerTitle:'導入文件',exporterAllAsCsv:'導出全部數據到CSV',exporterVisibleAsCsv:'導出可見數據到CSV',exporterSelectedAsCsv:'導出已選數據到CSV',exporterAllAsPdf:'導出全部數據到PDF',exporterVisibleAsPdf:'導出可見數據到PDF',exporterSelectedAsPdf:'導出已選數據到PDF',clearAllFilters:'清除所有过滤器'},importer:{noHeaders:'無法獲取列名，確定文件包含表頭？',noObjects:'無法獲取數據，確定文件包含數據？',invalidCsv:'無法處理文件，確定是合法的CSV文件？',invalidJson:'無法處理文件，確定是合法的JSON文件？',jsonNotArray:'導入的文件不是JSON數組！'},pagination:{sizes:'行每頁',totalItems:'行'}});return $delegate;}]);}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.importer
   * @description
   *
   * # ui.grid.importer
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module provides the ability to import data into the grid. It
   * uses the column defs to work out which data belongs in which column,
   * and creates entities from a configured class (typically a $resource).
   *
   * If the rowEdit feature is enabled, it also calls save on those newly
   * created objects, and then displays any errors in the imported data.
   *
   * Currently the importer imports only CSV and json files, although provision has been
   * made to process other file formats, and these can be added over time.
   *
   * For json files, the properties within each object in the json must match the column names
   * (to put it another way, the importer doesn't process the json, it just copies the objects
   * within the json into a new instance of the specified object type)
   *
   * For CSV import, the default column identification relies on each column in the
   * header row matching a column.name or column.displayName. Optionally, a column identification
   * callback can be used.  This allows matching using other attributes, which is particularly
   * useful if your application has internationalised column headings (i.e. the headings that
   * the user sees don't match the column names).
   *
   * The importer makes use of the grid menu as the UI for requesting an
   * import.
   *
   * <div ui-grid-importer></div>
   */var module=angular.module('ui.grid.importer',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.importer.constant:uiGridImporterConstants
   *
   *  @description constants available in importer module
   */module.constant('uiGridImporterConstants',{featureName:'importer'});/**
   *  @ngdoc service
   *  @name ui.grid.importer.service:uiGridImporterService
   *
   *  @description Services for importer feature
   */module.service('uiGridImporterService',['$q','uiGridConstants','uiGridImporterConstants','gridUtil','$compile','$interval','i18nService','$window',function($q,uiGridConstants,uiGridImporterConstants,gridUtil,$compile,$interval,i18nService,$window){var service={initializeGrid:function($scope,grid){// add feature namespace and any properties to grid for needed state
grid.importer={$scope:$scope};this.defaultGridOptions(grid.options);/**
           *  @ngdoc object
           *  @name ui.grid.importer.api:PublicApi
           *
           *  @description Public Api for importer feature
           */var publicApi={events:{importer:{}},methods:{importer:{/**
                 * @ngdoc function
                 * @name importFile
                 * @methodOf  ui.grid.importer.api:PublicApi
                 * @description Imports a file into the grid using the file object
                 * provided.  Bypasses the grid menu
                 * @param {File} fileObject the file we want to import, as a javascript
                 * File object
                 */importFile:function(fileObject){service.importThisFile(grid,fileObject);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);if(grid.options.enableImporter&&grid.options.importerShowMenu){if(grid.api.core.addToGridMenu){service.addToMenu(grid);}else{// order of registration is not guaranteed, register in a little while
$interval(function(){if(grid.api.core.addToGridMenu){service.addToMenu(grid);}},100,1);}}},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
           * @ngdoc object
           * @name ui.grid.importer.api:GridOptions
           *
           * @description GridOptions for importer feature, these are available to be
           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           * @ngdoc property
           * @propertyOf ui.grid.importer.api:GridOptions
           * @name enableImporter
           * @description Whether or not importer is enabled.  Automatically set
           * to false if the user's browser does not support the required fileApi.
           * Otherwise defaults to true.
           *
           */if(gridOptions.enableImporter||gridOptions.enableImporter===undefined){if(!($window.hasOwnProperty('File')&&$window.hasOwnProperty('FileReader')&&$window.hasOwnProperty('FileList')&&$window.hasOwnProperty('Blob'))){gridUtil.logError('The File APIs are not fully supported in this browser, grid importer cannot be used.');gridOptions.enableImporter=false;}else{gridOptions.enableImporter=true;}}else{gridOptions.enableImporter=false;}/**
           * @ngdoc method
           * @name importerProcessHeaders
           * @methodOf ui.grid.importer.api:GridOptions
           * @description A callback function that will process headers using custom
           * logic.  Set this callback function if the headers that your user will provide in their
           * import file don't necessarily match the grid header or field names.  This might commonly
           * occur where your application is internationalised, and therefore the field names
           * that the user recognises are in a different language than the field names that
           * ui-grid knows about.
           *
           * Defaults to the internal `processHeaders` method, which seeks to match using both
           * displayName and column.name.  Any non-matching columns are discarded.
           *
           * Your callback routine should respond by processing the header array, and returning an array
           * of matching column names.  A null value in any given position means "don't import this column"
           *
           * <pre>
           *      gridOptions.importerProcessHeaders: function( grid, headerArray ) {
           *        var myHeaderColumns = [];
           *        var thisCol;
           *        headerArray.forEach( function( value, index ) {
           *          thisCol = mySpecialLookupFunction( value );
           *          myHeaderColumns.push( thisCol.name );
           *        });
           *
           *        return myHeaderCols;
           *      })
           * </pre>
           * @param {Grid} grid the grid we're importing into
           * @param {array} headerArray an array of the text from the first row of the csv file,
           * which you need to match to column.names
           * @returns {array} array of matching column names, in the same order as the headerArray
           *
           */gridOptions.importerProcessHeaders=gridOptions.importerProcessHeaders||service.processHeaders;/**
           * @ngdoc method
           * @name importerHeaderFilter
           * @methodOf ui.grid.importer.api:GridOptions
           * @description A callback function that will filter (usually translate) a single
           * header.  Used when you want to match the passed in column names to the column
           * displayName after the header filter.
           *
           * Your callback routine needs to return the filtered header value.
           * <pre>
           *      gridOptions.importerHeaderFilter: function( displayName ) {
           *        return $translate.instant( displayName );
           *      })
           * </pre>
           *
           * or:
           * <pre>
           *      gridOptions.importerHeaderFilter: $translate.instant
           * </pre>
           * @param {string} displayName the displayName that we'd like to translate
           * @returns {string} the translated name
           *
           */gridOptions.importerHeaderFilter=gridOptions.importerHeaderFilter||function(displayName){return displayName;};/**
           * @ngdoc method
           * @name importerErrorCallback
           * @methodOf ui.grid.importer.api:GridOptions
           * @description A callback function that provides custom error handling, rather
           * than the standard grid behaviour of an alert box and a console message.  You
           * might use this to internationalise the console log messages, or to write to a
           * custom logging routine that returned errors to the server.
           *
           * <pre>
           *      gridOptions.importerErrorCallback: function( grid, errorKey, consoleMessage, context ) {
           *        myUserDisplayRoutine( errorKey );
           *        myLoggingRoutine( consoleMessage, context );
           *      })
           * </pre>
           * @param {Grid} grid the grid we're importing into, may be useful if you're positioning messages
           * in some way
           * @param {string} errorKey one of the i18n keys the importer can return - importer.noHeaders,
           * importer.noObjects, importer.invalidCsv, importer.invalidJson, importer.jsonNotArray
           * @param {string} consoleMessage the English console message that importer would have written
           * @param {object} context the context data that importer would have appended to that console message,
           * often the file content itself or the element that is in error
           *
           */if(!gridOptions.importerErrorCallback||typeof gridOptions.importerErrorCallback!=='function'){delete gridOptions.importerErrorCallback;}/**
           * @ngdoc method
           * @name importerDataAddCallback
           * @methodOf ui.grid.importer.api:GridOptions
           * @description A mandatory callback function that adds data to the source data array.  The grid
           * generally doesn't add rows to the source data array, it is tidier to handle this through a user
           * callback.
           *
           * <pre>
           *      gridOptions.importerDataAddCallback: function( grid, newObjects ) {
           *        $scope.myData = $scope.myData.concat( newObjects );
           *      })
           * </pre>
           * @param {Grid} grid the grid we're importing into, may be useful in some way
           * @param {array} newObjects an array of new objects that you should add to your data
           *
           */if(gridOptions.enableImporter===true&&!gridOptions.importerDataAddCallback){gridUtil.logError("You have not set an importerDataAddCallback, importer is disabled");gridOptions.enableImporter=false;}/**
           * @ngdoc object
           * @name importerNewObject
           * @propertyOf  ui.grid.importer.api:GridOptions
           * @description An object on which we call `new` to create each new row before inserting it into
           * the data array.  Typically this would be a $resource entity, which means that if you're using
           * the rowEdit feature, you can directly call save on this entity when the save event is triggered.
           *
           * Defaults to a vanilla javascript object
           *
           * @example
           * <pre>
           *   gridOptions.importerNewObject = MyRes;
           * </pre>
           *
           */ /**
           * @ngdoc property
           * @propertyOf ui.grid.importer.api:GridOptions
           * @name importerShowMenu
           * @description Whether or not to show an item in the grid menu.  Defaults to true.
           *
           */gridOptions.importerShowMenu=gridOptions.importerShowMenu!==false;/**
           * @ngdoc method
           * @methodOf ui.grid.importer.api:GridOptions
           * @name importerObjectCallback
           * @description A callback that massages the data for each object.  For example,
           * you might have data stored as a code value, but display the decode.  This callback
           * can be used to change the decoded value back into a code.  Defaults to doing nothing.
           * @param {Grid} grid in case you need it
           * @param {object} newObject the new object as importer has created it, modify it
           * then return the modified version
           * @returns {object} the modified object
           * @example
           * <pre>
           *   gridOptions.importerObjectCallback = function ( grid, newObject ) {
           *     switch newObject.status {
           *       case 'Active':
           *         newObject.status = 1;
           *         break;
           *       case 'Inactive':
           *         newObject.status = 2;
           *         break;
           *     }
           *     return newObject;
           *   };
           * </pre>
           */gridOptions.importerObjectCallback=gridOptions.importerObjectCallback||function(grid,newObject){return newObject;};},/**
         * @ngdoc function
         * @name addToMenu
         * @methodOf  ui.grid.importer.service:uiGridImporterService
         * @description Adds import menu item to the grid menu,
         * allowing the user to request import of a file
         * @param {Grid} grid the grid into which data should be imported
         */addToMenu:function(grid){grid.api.core.addToGridMenu(grid,[{title:i18nService.getSafeText('gridMenu.importerTitle'),order:150},{templateUrl:'ui-grid/importerMenuItemContainer',action:function(){this.grid.api.importer.importAFile(grid);},order:151}]);},/**
         * @ngdoc function
         * @name importThisFile
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Imports the provided file into the grid using the file object
         * provided.  Bypasses the grid menu
         * @param {Grid} grid the grid we're importing into
         * @param {File} fileObject the file we want to import, as returned from the File
         * javascript object
         */importThisFile:function(grid,fileObject){if(!fileObject){gridUtil.logError('No file object provided to importThisFile, should be impossible, aborting');return;}var reader=new FileReader();switch(fileObject.type){case'application/json':reader.onload=service.importJsonClosure(grid);break;default:reader.onload=service.importCsvClosure(grid);break;}reader.readAsText(fileObject);},/**
         * @ngdoc function
         * @name importJson
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Creates a function that imports a json file into the grid.
         * The json data is imported into new objects of type `gridOptions.importerNewObject`,
         * and if the rowEdit feature is enabled the rows are marked as dirty
         * @param {Grid} grid the grid we want to import into
         * @return {function} Function that receives the file that we want to import, as
         * a FileObject as an argument
         */importJsonClosure:function(grid){return function(importFile){var newObjects=[],newObject,importArray=service.parseJson(grid,importFile);if(importArray===null){return;}importArray.forEach(function(value){newObject=service.newObject(grid);angular.extend(newObject,value);newObject=grid.options.importerObjectCallback(grid,newObject);newObjects.push(newObject);});service.addObjects(grid,newObjects);};},/**
         * @ngdoc function
         * @name parseJson
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Parses a json file, returns the parsed data.
         * Displays an error if file doesn't parse
         * @param {Grid} grid the grid that we want to import into
         * @param {FileObject} importFile the file that we want to import, as
         * a FileObject
         * @returns {array} array of objects from the imported json
         */parseJson:function(grid,importFile){var loadedObjects;try{loadedObjects=JSON.parse(importFile.target.result);}catch(e){service.alertError(grid,'importer.invalidJson','File could not be processed, is it valid json? Content was: ',importFile.target.result);return;}if(!Array.isArray(loadedObjects)){service.alertError(grid,'importer.jsonNotarray','Import failed, file is not an array, file was: ',importFile.target.result);return[];}else{return loadedObjects;}},/**
         * @ngdoc function
         * @name importCsvClosure
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Creates a function that imports a csv file into the grid
         * (allowing it to be used in the reader.onload event)
         * @param {Grid} grid the grid that we want to import into
         * @return {function} Function that receives the file that we want to import, as
         * a file object
         */importCsvClosure:function(grid){return function(importFile){var importArray=service.parseCsv(importFile);if(!importArray||importArray.length<1){service.alertError(grid,'importer.invalidCsv','File could not be processed, is it valid csv? Content was: ',importFile.target.result);return;}var newObjects=service.createCsvObjects(grid,importArray);if(!newObjects||newObjects.length===0){service.alertError(grid,'importer.noObjects','Objects were not able to be derived, content was: ',importFile.target.result);return;}service.addObjects(grid,newObjects);};},/**
         * @ngdoc function
         * @name parseCsv
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Parses a csv file into an array of arrays, with the first
         * array being the headers, and the remaining arrays being the data.
         * The logic for this comes from https://github.com/thetalecrafter/excel.js/blob/master/src/csv.js,
         * which is noted as being under the MIT license.  The code is modified to pass the jscs yoda condition
         * checker
         * @param {FileObject} importFile the file that we want to import, as a
         * file object
         */parseCsv:function(importFile){var csv=importFile.target.result;// use the CSV-JS library to parse
return CSV.parse(csv);},/**
         * @ngdoc function
         * @name createCsvObjects
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Converts an array of arrays (representing the csv file)
         * into a set of objects.  Uses the provided `gridOptions.importerNewObject`
         * to create the objects, and maps the header row into the individual columns
         * using either `gridOptions.importerProcessHeaders`, or by using a native method
         * of matching to either the displayName, column name or column field of
         * the columns in the column defs.  The resulting objects will have attributes
         * that are named based on the column.field or column.name, in that order.
         * @param {Grid} grid the grid that we want to import into
         * @param {Array} importArray the data that we want to import, as an array
         */createCsvObjects:function(grid,importArray){// pull off header row and turn into headers
var headerMapping=grid.options.importerProcessHeaders(grid,importArray.shift());if(!headerMapping||headerMapping.length===0){service.alertError(grid,'importer.noHeaders','Column names could not be derived, content was: ',importArray);return[];}var newObjects=[],newObject;importArray.forEach(function(row){newObject=service.newObject(grid);if(row!==null){row.forEach(function(field,index){if(headerMapping[index]!==null){newObject[headerMapping[index]]=field;}});}newObject=grid.options.importerObjectCallback(grid,newObject);newObjects.push(newObject);});return newObjects;},/**
         * @ngdoc function
         * @name processHeaders
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Determines the columns that the header row from
         * a csv (or other) file represents.
         * @param {Grid} grid the grid we're importing into
         * @param {array} headerRow the header row that we wish to match against
         * the column definitions
         * @returns {array} an array of the attribute names that should be used
         * for that column, based on matching the headers or creating the headers
         *
         */processHeaders:function(grid,headerRow){var headers=[];if(!grid.options.columnDefs||grid.options.columnDefs.length===0){// we are going to create new columnDefs for all these columns, so just remove
// spaces from the names to create fields
headerRow.forEach(function(value){headers.push(value.replace(/[^0-9a-zA-Z\-_]/g,'_'));});return headers;}else{var lookupHash=service.flattenColumnDefs(grid,grid.options.columnDefs);headerRow.forEach(function(value){if(lookupHash[value]){headers.push(lookupHash[value]);}else if(lookupHash[value.toLowerCase()]){headers.push(lookupHash[value.toLowerCase()]);}else{headers.push(null);}});return headers;}},/**
         * @name flattenColumnDefs
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Runs through the column defs and creates a hash of
         * the displayName, name and field, and of each of those values forced to lower case,
         * with each pointing to the field or name
         * (whichever is present).  Used to lookup column headers and decide what
         * attribute name to give to the resulting field.
         * @param {Grid} grid the grid we're importing into
         * @param {array} columnDefs the columnDefs that we should flatten
         * @returns {hash} the flattened version of the column def information, allowing
         * us to look up a value by `flattenedHash[ headerValue ]`
         */flattenColumnDefs:function(grid,columnDefs){var flattenedHash={};columnDefs.forEach(function(columnDef){if(columnDef.name){flattenedHash[columnDef.name]=columnDef.field||columnDef.name;flattenedHash[columnDef.name.toLowerCase()]=columnDef.field||columnDef.name;}if(columnDef.field){flattenedHash[columnDef.field]=columnDef.field||columnDef.name;flattenedHash[columnDef.field.toLowerCase()]=columnDef.field||columnDef.name;}if(columnDef.displayName){flattenedHash[columnDef.displayName]=columnDef.field||columnDef.name;flattenedHash[columnDef.displayName.toLowerCase()]=columnDef.field||columnDef.name;}if(columnDef.displayName&&grid.options.importerHeaderFilter){flattenedHash[grid.options.importerHeaderFilter(columnDef.displayName)]=columnDef.field||columnDef.name;flattenedHash[grid.options.importerHeaderFilter(columnDef.displayName).toLowerCase()]=columnDef.field||columnDef.name;}});return flattenedHash;},/**
         * @ngdoc function
         * @name addObjects
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Inserts our new objects into the grid data, and
         * sets the rows to dirty if the rowEdit feature is being used
         *
         * Does this by registering a watch on dataChanges, which essentially
         * is waiting on the result of the grid data watch, and downstream processing.
         *
         * When the callback is called, it deregisters itself - we don't want to run
         * again next time data is added.
         *
         * If we never get called, we deregister on destroy.
         *
         * @param {Grid} grid the grid we're importing into
         * @param {array} newObjects the objects we want to insert into the grid data
         * @returns {object} the new object
         */addObjects:function(grid,newObjects){if(grid.api.rowEdit){var dataChangeDereg=grid.registerDataChangeCallback(function(){grid.api.rowEdit.setRowsDirty(newObjects);dataChangeDereg();},[uiGridConstants.dataChange.ROW]);grid.importer.$scope.$on('$destroy',dataChangeDereg);}grid.importer.$scope.$apply(grid.options.importerDataAddCallback(grid,newObjects));},/**
         * @ngdoc function
         * @name newObject
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Makes a new object based on `gridOptions.importerNewObject`,
         * or based on an empty object if not present
         * @param {Grid} grid the grid we're importing into
         * @returns {object} the new object
         */newObject:function(grid){if(typeof grid.options!=="undefined"&&typeof grid.options.importerNewObject!=="undefined"){return new grid.options.importerNewObject();}else{return{};}},/**
         * @ngdoc function
         * @name alertError
         * @methodOf ui.grid.importer.service:uiGridImporterService
         * @description Provides an internationalised user alert for the failure,
         * and logs a console message including diagnostic content.
         * Optionally, if the the `gridOptions.importerErrorCallback` routine
         * is defined, then calls that instead, allowing user specified error routines
         * @param {Grid} grid the grid we're importing into
         * @param {array} headerRow the header row that we wish to match against
         * the column definitions
         */alertError:function(grid,alertI18nToken,consoleMessage,context){if(grid.options.importerErrorCallback){grid.options.importerErrorCallback(grid,alertI18nToken,consoleMessage,context);}else{$window.alert(i18nService.getSafeText(alertI18nToken));gridUtil.logError(consoleMessage+context);}}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.importer.directive:uiGridImporter
   *  @element div
   *  @restrict A
   *
   *  @description Adds importer features to grid
   *
   */module.directive('uiGridImporter',['uiGridImporterConstants','uiGridImporterService','gridUtil','$compile',function(uiGridImporterConstants,uiGridImporterService,gridUtil,$compile){return{replace:true,priority:0,require:'^uiGrid',scope:false,link:function($scope,$elm,$attrs,uiGridCtrl){uiGridImporterService.initializeGrid($scope,uiGridCtrl.grid);}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.importer.directive:uiGridImporterMenuItem
   *  @element div
   *  @restrict A
   *
   *  @description Handles the processing from the importer menu item - once a file is
   *  selected
   *
   */module.directive('uiGridImporterMenuItem',['uiGridImporterConstants','uiGridImporterService','gridUtil','$compile',function(uiGridImporterConstants,uiGridImporterService,gridUtil,$compile){return{replace:true,priority:0,require:'?^uiGrid',scope:false,templateUrl:'ui-grid/importerMenuItem',link:function($scope,$elm,$attrs,uiGridCtrl){var grid;function handleFileSelect(event){var target=event.srcElement||event.target;if(target&&target.files&&target.files.length===1){var fileObject=target.files[0];// Define grid if the uiGrid controller is present
if(typeof uiGridCtrl!=='undefined'&&uiGridCtrl){grid=uiGridCtrl.grid;uiGridImporterService.importThisFile(grid,fileObject);target.form.reset();}else{gridUtil.logError('Could not import file because UI Grid was not found.');}}}var fileChooser=$elm[0].querySelectorAll('.ui-grid-importer-file-chooser');if(fileChooser.length!==1){gridUtil.logError('Found > 1 or < 1 file choosers within the menu item, error, cannot continue');}else{fileChooser[0].addEventListener('change',handleFileSelect,false);}}};}]);})();(function(){'use strict';/**
   *  @ngdoc overview
   *  @name ui.grid.infiniteScroll
   *
   *  @description
   *
   * #ui.grid.infiniteScroll
   *
   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
   *
   * This module provides infinite scroll functionality to ui-grid
   *
   */var module=angular.module('ui.grid.infiniteScroll',['ui.grid']);/**
   *  @ngdoc service
   *  @name ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
   *
   *  @description Service for infinite scroll features
   */module.service('uiGridInfiniteScrollService',['gridUtil','$compile','$rootScope','uiGridConstants','ScrollEvent','$q',function(gridUtil,$compile,$rootScope,uiGridConstants,ScrollEvent,$q){var service={/**
       * @ngdoc function
       * @name initializeGrid
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description This method register events and methods into grid public API
       */initializeGrid:function(grid,$scope){service.defaultGridOptions(grid.options);if(!grid.options.enableInfiniteScroll){return;}grid.infiniteScroll={dataLoading:false};service.setScrollDirections(grid,grid.options.infiniteScrollUp,grid.options.infiniteScrollDown);grid.api.core.on.scrollEnd($scope,service.handleScroll);/**
         *  @ngdoc object
         *  @name ui.grid.infiniteScroll.api:PublicAPI
         *
         *  @description Public API for infinite scroll feature
         */var publicApi={events:{infiniteScroll:{/**
               * @ngdoc event
               * @name needLoadMoreData
               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
               * @description This event fires when scroll reaches bottom percentage of grid
               * and needs to load data
               */needLoadMoreData:function($scope,fn){},/**
               * @ngdoc event
               * @name needLoadMoreDataTop
               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
               * @description This event fires when scroll reaches top percentage of grid
               * and needs to load data
               */needLoadMoreDataTop:function($scope,fn){}}},methods:{infiniteScroll:{/**
               * @ngdoc function
               * @name dataLoaded
               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
               * @description Call this function when you have loaded the additional data
               * requested.  You should set scrollUp and scrollDown to indicate
               * whether there are still more pages in each direction.
               *
               * If you call dataLoaded without first calling `saveScrollPercentage` then we will
               * scroll the user to the start of the newly loaded data, which usually gives a smooth scroll
               * experience, but can give a jumpy experience with large `infiniteScrollRowsFromEnd` values, and
               * on variable speed internet connections.  Using `saveScrollPercentage` as demonstrated in the tutorial
               * should give a smoother scrolling experience for users.
               *
               * See infinite_scroll tutorial for example of usage
               * @param {boolean} scrollUp if set to false flags that there are no more pages upwards, so don't fire
               * any more infinite scroll events upward
               * @param {boolean} scrollDown if set to false flags that there are no more pages downwards, so don't
               * fire any more infinite scroll events downward
               * @returns {promise} a promise that is resolved when the grid scrolling is fully adjusted.  If you're
               * planning to remove pages, you should wait on this promise first, or you'll break the scroll positioning
               */dataLoaded:function(scrollUp,scrollDown){service.setScrollDirections(grid,scrollUp,scrollDown);return service.adjustScroll(grid).then(function(){grid.infiniteScroll.dataLoading=false;});},/**
               * @ngdoc function
               * @name resetScroll
               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
               * @description Call this function when you have taken some action that makes the current
               * scroll position invalid.  For example, if you're using external sorting and you've resorted
               * then you might reset the scroll, or if you've otherwise substantially changed the data, perhaps
               * you've reused an existing grid for a new data set
               *
               * You must tell us whether there is data upwards or downwards after the reset
               *
               * @param {boolean} scrollUp flag that there are pages upwards, fire
               * infinite scroll events upward
               * @param {boolean} scrollDown flag that there are pages downwards, so
               * fire infinite scroll events downward
               */resetScroll:function(scrollUp,scrollDown){service.setScrollDirections(grid,scrollUp,scrollDown);service.adjustInfiniteScrollPosition(grid,0);},/**
               * @ngdoc function
               * @name saveScrollPercentage
               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
               * @description Saves the scroll percentage and number of visible rows before you adjust the data,
               * used if you're subsequently going to call `dataRemovedTop` or `dataRemovedBottom`
               */saveScrollPercentage:function(){grid.infiniteScroll.prevScrollTop=grid.renderContainers.body.prevScrollTop;grid.infiniteScroll.previousVisibleRows=grid.getVisibleRowCount();},/**
               * @ngdoc function
               * @name dataRemovedTop
               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
               * @description Adjusts the scroll position after you've removed data at the top
               * @param {boolean} scrollUp flag that there are pages upwards, fire
               * infinite scroll events upward
               * @param {boolean} scrollDown flag that there are pages downwards, so
               * fire infinite scroll events downward
               */dataRemovedTop:function(scrollUp,scrollDown){service.dataRemovedTop(grid,scrollUp,scrollDown);},/**
               * @ngdoc function
               * @name dataRemovedBottom
               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
               * @description Adjusts the scroll position after you've removed data at the bottom
               * @param {boolean} scrollUp flag that there are pages upwards, fire
               * infinite scroll events upward
               * @param {boolean} scrollDown flag that there are pages downwards, so
               * fire infinite scroll events downward
               */dataRemovedBottom:function(scrollUp,scrollDown){service.dataRemovedBottom(grid,scrollUp,scrollDown);},/**
               * @ngdoc function
               * @name setScrollDirections
               * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
               * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
               * and also sets the grid.suppressParentScroll
               * @param {boolean} scrollUp whether there are pages available up - defaults to false
               * @param {boolean} scrollDown whether there are pages available down - defaults to true
               */setScrollDirections:function(scrollUp,scrollDown){service.setScrollDirections(grid,scrollUp,scrollDown);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
         *  @ngdoc object
         *  @name ui.grid.infiniteScroll.api:GridOptions
         *
         *  @description GridOptions for infinite scroll feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */ /**
         *  @ngdoc object
         *  @name enableInfiniteScroll
         *  @propertyOf  ui.grid.infiniteScroll.api:GridOptions
         *  @description Enable infinite scrolling for this grid
         *  <br/>Defaults to true
         */gridOptions.enableInfiniteScroll=gridOptions.enableInfiniteScroll!==false;/**
         * @ngdoc property
         * @name infiniteScrollRowsFromEnd
         * @propertyOf ui.grid.class:GridOptions
         * @description This setting controls how close to the end of the dataset a user gets before
         * more data is requested by the infinite scroll, whether scrolling up or down.  This allows you to
         * 'prefetch' rows before the user actually runs out of scrolling.
         *
         * Note that if you set this value too high it may give jumpy scrolling behaviour, if you're getting
         * this behaviour you could use the `saveScrollPercentageMethod` right before loading your data, and we'll
         * preserve that scroll position
         *
         * <br> Defaults to 20
         */gridOptions.infiniteScrollRowsFromEnd=gridOptions.infiniteScrollRowsFromEnd||20;/**
         * @ngdoc property
         * @name infiniteScrollUp
         * @propertyOf ui.grid.class:GridOptions
         * @description Whether you allow infinite scroll up, implying that the first page of data
         * you have displayed is in the middle of your data set.  If set to true then we trigger the
         * needMoreDataTop event when the user hits the top of the scrollbar.
         * <br> Defaults to false
         */gridOptions.infiniteScrollUp=gridOptions.infiniteScrollUp===true;/**
         * @ngdoc property
         * @name infiniteScrollDown
         * @propertyOf ui.grid.class:GridOptions
         * @description Whether you allow infinite scroll down, implying that the first page of data
         * you have displayed is in the middle of your data set.  If set to true then we trigger the
         * needMoreData event when the user hits the bottom of the scrollbar.
         * <br> Defaults to true
         */gridOptions.infiniteScrollDown=gridOptions.infiniteScrollDown!==false;},/**
       * @ngdoc function
       * @name setScrollDirections
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
       * and also sets the grid.suppressParentScroll
       * @param {grid} grid the grid we're operating on
       * @param {boolean} scrollUp whether there are pages available up - defaults to false
       * @param {boolean} scrollDown whether there are pages available down - defaults to true
       */setScrollDirections:function(grid,scrollUp,scrollDown){grid.infiniteScroll.scrollUp=scrollUp===true;grid.suppressParentScrollUp=scrollUp===true;grid.infiniteScroll.scrollDown=scrollDown!==false;grid.suppressParentScrollDown=scrollDown!==false;},/**
       * @ngdoc function
       * @name handleScroll
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description Called whenever the grid scrolls, determines whether the scroll should
       * trigger an infinite scroll request for more data
       * @param {object} args the args from the event
       */handleScroll:function(args){// don't request data if already waiting for data, or if source is coming from ui.grid.adjustInfiniteScrollPosition() function
if(args.grid.infiniteScroll&&args.grid.infiniteScroll.dataLoading||args.source==='ui.grid.adjustInfiniteScrollPosition'){return;}if(args.y){// If the user is scrolling very quickly all the way to the top/bottom, the scroll handler can get confused
// about the direction. First we check if they've gone all the way, and data always is loaded in this case.
if(args.y.percentage===0){args.grid.scrollDirection=uiGridConstants.scrollDirection.UP;service.loadData(args.grid);}else if(args.y.percentage===1){args.grid.scrollDirection=uiGridConstants.scrollDirection.DOWN;service.loadData(args.grid);}else{// Scroll position is somewhere in between top/bottom, so determine whether it's far enough to load more data.
var percentage,targetPercentage=args.grid.options.infiniteScrollRowsFromEnd/args.grid.renderContainers.body.visibleRowCache.length;if(args.grid.scrollDirection===uiGridConstants.scrollDirection.UP){percentage=args.y.percentage;if(percentage<=targetPercentage){service.loadData(args.grid);}}else if(args.grid.scrollDirection===uiGridConstants.scrollDirection.DOWN){percentage=1-args.y.percentage;if(percentage<=targetPercentage){service.loadData(args.grid);}}}}},/**
       * @ngdoc function
       * @name loadData
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
       * and whether there are more pages upwards or downwards.  It also stores the number of rows that we had previously,
       * and clears out any saved scroll position so that we know whether or not the user calls `saveScrollPercentage`
       * @param {Grid} grid the grid we're working on
       */loadData:function(grid){// save number of currently visible rows to calculate new scroll position later - we know that we want
// to be at approximately the row we're currently at
grid.infiniteScroll.previousVisibleRows=grid.renderContainers.body.visibleRowCache.length;grid.infiniteScroll.direction=grid.scrollDirection;delete grid.infiniteScroll.prevScrollTop;if(grid.scrollDirection===uiGridConstants.scrollDirection.UP&&grid.infiniteScroll.scrollUp){grid.infiniteScroll.dataLoading=true;grid.api.infiniteScroll.raise.needLoadMoreDataTop();}else if(grid.scrollDirection===uiGridConstants.scrollDirection.DOWN&&grid.infiniteScroll.scrollDown){if(grid.cellNav&&grid.cellNav.lastRowCol&&grid.cellNav.lastRowCol.row.index===grid.infiniteScroll.previousVisibleRows-1){return;}grid.infiniteScroll.dataLoading=true;grid.api.infiniteScroll.raise.needLoadMoreData();}},/**
       * @ngdoc function
       * @name adjustScroll
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description Once we are informed that data has been loaded, adjust the scroll position to account for that
       * addition and to make things look clean.
       *
       * If we're scrolling up we scroll to the first row of the old data set -
       * so we're assuming that you would have gotten to the top of the grid (from the 20% need more data trigger) by
       * the time the data comes back.  If we're scrolling down we scroll to the last row of the old data set - so we're
       * assuming that you would have gotten to the bottom of the grid (from the 80% need more data trigger) by the time
       * the data comes back.
       *
       * Neither of these are good assumptions, but making this a smoother experience really requires
       * that trigger to not be a percentage, and to be much closer to the end of the data (say, 5 rows off the end).  Even then
       * it'd be better still to actually run into the end.  But if the data takes a while to come back, they may have scrolled
       * somewhere else in the mean-time, in which case they'll get a jump back to the new data.  Anyway, this will do for
       * now, until someone wants to do better.
       * @param {Grid} grid the grid we're working on
       * @returns {promise} a promise that is resolved when scrolling has finished
       */adjustScroll:function(grid){var promise=$q.defer();$rootScope.$applyAsync(function(){var viewportHeight,rowHeight,newVisibleRows,oldTop,newTop;viewportHeight=grid.getViewportHeight()+grid.headerHeight-grid.renderContainers.body.headerHeight-grid.scrollbarHeight;rowHeight=grid.options.rowHeight;if(grid.infiniteScroll.direction===undefined){// called from initialize, tweak our scroll up a little
service.adjustInfiniteScrollPosition(grid,0);}newVisibleRows=grid.getVisibleRowCount();// in case not enough data is loaded to enable scroller - load more data
var canvasHeight=rowHeight*newVisibleRows;if(grid.infiniteScroll.scrollDown&&viewportHeight>canvasHeight){grid.api.infiniteScroll.raise.needLoadMoreData();}if(grid.infiniteScroll.direction===uiGridConstants.scrollDirection.UP){oldTop=grid.infiniteScroll.prevScrollTop||0;newTop=oldTop+(newVisibleRows-grid.infiniteScroll.previousVisibleRows)*rowHeight;service.adjustInfiniteScrollPosition(grid,newTop);$rootScope.$applyAsync(function(){promise.resolve();});}if(grid.infiniteScroll.direction===uiGridConstants.scrollDirection.DOWN){newTop=grid.infiniteScroll.prevScrollTop||grid.infiniteScroll.previousVisibleRows*rowHeight-viewportHeight;service.adjustInfiniteScrollPosition(grid,newTop);$rootScope.$applyAsync(function(){promise.resolve();});}},0);return promise.promise;},/**
       * @ngdoc function
       * @name adjustInfiniteScrollPosition
       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
       * @param {Grid} grid the grid we're working on
       * @param {number} scrollTop the position through the grid that we want to scroll to
       */adjustInfiniteScrollPosition:function(grid,scrollTop){var scrollEvent=new ScrollEvent(grid,null,null,'ui.grid.adjustInfiniteScrollPosition'),visibleRows=grid.getVisibleRowCount(),viewportHeight=grid.getViewportHeight()+grid.headerHeight-grid.renderContainers.body.headerHeight-grid.scrollbarHeight,rowHeight=grid.options.rowHeight,scrollHeight=visibleRows*rowHeight-viewportHeight;// for infinite scroll, if there are pages upwards then never allow it to be at the zero position so the up button can be active
if(scrollTop===0&&grid.infiniteScroll.scrollUp){// using pixels results in a relative scroll, hence we have to use percentage
scrollEvent.y={pixels:1};}else{scrollEvent.y={percentage:scrollTop/scrollHeight};}grid.scrollContainers('',scrollEvent);},/**
       * @ngdoc function
       * @name dataRemovedTop
       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
       * @description Adjusts the scroll position after you've removed data at the top. You should
       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
       * before you start removing data
       * @param {Grid} grid the grid we're working on
       * @param {boolean} scrollUp flag that there are pages upwards, fire
       * infinite scroll events upward
       * @param {boolean} scrollDown flag that there are pages downwards, so
       * fire infinite scroll events downward
       */dataRemovedTop:function(grid,scrollUp,scrollDown){var newVisibleRows,oldTop,newTop,rowHeight;service.setScrollDirections(grid,scrollUp,scrollDown);newVisibleRows=grid.renderContainers.body.visibleRowCache.length;oldTop=grid.infiniteScroll.prevScrollTop;rowHeight=grid.options.rowHeight;// since we removed from the top, our new scroll row will be the old scroll row less the number
// of rows removed
newTop=oldTop-(grid.infiniteScroll.previousVisibleRows-newVisibleRows)*rowHeight;service.adjustInfiniteScrollPosition(grid,newTop);},/**
       * @ngdoc function
       * @name dataRemovedBottom
       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
       * @description Adjusts the scroll position after you've removed data at the bottom.  You should
       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
       * before you start removing data
       * @param {Grid} grid the grid we're working on
       * @param {boolean} scrollUp flag that there are pages upwards, fire
       * infinite scroll events upward
       * @param {boolean} scrollDown flag that there are pages downwards, so
       * fire infinite scroll events downward
       */dataRemovedBottom:function(grid,scrollUp,scrollDown){var newTop;service.setScrollDirections(grid,scrollUp,scrollDown);newTop=grid.infiniteScroll.prevScrollTop;service.adjustInfiniteScrollPosition(grid,newTop);}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.infiniteScroll.directive:uiGridInfiniteScroll
   *  @element div
   *  @restrict A
   *
   *  @description Adds infinite scroll features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.infiniteScroll']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Alex', car: 'Toyota' },
            { name: 'Sam', car: 'Lexus' }
      ];

      $scope.columnDefs = [
        {name: 'name'},
        {name: 'car'}
      ];
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-infinite-scroll="20"></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridInfiniteScroll',['uiGridInfiniteScrollService',function(uiGridInfiniteScrollService){return{priority:-200,scope:false,require:'^uiGrid',compile:function(){return{pre:function($scope,$elm,$attr,uiGridCtrl){uiGridInfiniteScrollService.initializeGrid(uiGridCtrl.grid,$scope);},post:function($scope,$elm,$attr){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.moveColumns
   * @description
   *
   * # ui.grid.moveColumns
   *
   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
   *
   * This module provides column moving capability to ui.grid. It enables to change the position of columns.
   * <div doc-module-components="ui.grid.moveColumns"></div>
   */var module=angular.module('ui.grid.moveColumns',['ui.grid']);/**
   *  @ngdoc service
   *  @name ui.grid.moveColumns.service:uiGridMoveColumnService
   *  @description Service for column moving feature.
   */module.service('uiGridMoveColumnService',['$q','$rootScope','$log','ScrollEvent','uiGridConstants','gridUtil',function($q,$rootScope,$log,ScrollEvent,uiGridConstants,gridUtil){var service={initializeGrid:function(grid){var self=this;this.registerPublicApi(grid);this.defaultGridOptions(grid.options);grid.moveColumns={orderCache:[]};// Used to cache the order before columns are rebuilt
grid.registerColumnBuilder(self.movableColumnBuilder);grid.registerDataChangeCallback(self.verifyColumnOrder,[uiGridConstants.dataChange.COLUMN]);},registerPublicApi:function(grid){var self=this;/**
         *  @ngdoc object
         *  @name ui.grid.moveColumns.api:PublicApi
         *  @description Public Api for column moving feature.
         */var publicApi={events:{/**
             * @ngdoc event
             * @name columnPositionChanged
             * @eventOf  ui.grid.moveColumns.api:PublicApi
             * @description raised when column is moved
             * <pre>
             *      gridApi.colMovable.on.columnPositionChanged(scope,function(colDef, originalPosition, newPosition) {})
             * </pre>
             * @param {object} colDef the column that was moved
             * @param {integer} originalPosition of the column
             * @param {integer} finalPosition of the column
             */colMovable:{columnPositionChanged:function(colDef,originalPosition,newPosition){}}},methods:{/**
             * @ngdoc method
             * @name moveColumn
             * @methodOf  ui.grid.moveColumns.api:PublicApi
             * @description Method can be used to change column position.
             * <pre>
             *      gridApi.colMovable.moveColumn(oldPosition, newPosition)
             * </pre>
             * @param {integer} originalPosition of the column
             * @param {integer} finalPosition of the column
             */colMovable:{moveColumn:function(originalPosition,finalPosition){var columns=grid.columns;if(!angular.isNumber(originalPosition)||!angular.isNumber(finalPosition)){gridUtil.logError('MoveColumn: Please provide valid values for originalPosition and finalPosition');return;}var nonMovableColumns=0;for(var i=0;i<columns.length;i++){if(angular.isDefined(columns[i].colDef.visible)&&columns[i].colDef.visible===false||columns[i].isRowHeader===true){nonMovableColumns++;}}if(originalPosition>=columns.length-nonMovableColumns||finalPosition>=columns.length-nonMovableColumns){gridUtil.logError('MoveColumn: Invalid values for originalPosition, finalPosition');return;}var findPositionForRenderIndex=function(index){var position=index;for(var i=0;i<=position;i++){if(angular.isDefined(columns[i])&&(angular.isDefined(columns[i].colDef.visible)&&columns[i].colDef.visible===false||columns[i].isRowHeader===true)){position++;}}return position;};self.redrawColumnAtPosition(grid,findPositionForRenderIndex(originalPosition),findPositionForRenderIndex(finalPosition));}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){/**
         *  @ngdoc object
         *  @name ui.grid.moveColumns.api:GridOptions
         *
         *  @description Options for configuring the move column feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */ /**
         *  @ngdoc object
         *  @name enableColumnMoving
         *  @propertyOf  ui.grid.moveColumns.api:GridOptions
         *  @description If defined, sets the default value for the colMovable flag on each individual colDefs
         *  if their individual enableColumnMoving configuration is not defined. Defaults to true.
         */gridOptions.enableColumnMoving=gridOptions.enableColumnMoving!==false;},movableColumnBuilder:function(colDef,col,gridOptions){var promises=[];/**
         *  @ngdoc object
         *  @name ui.grid.moveColumns.api:ColumnDef
         *
         *  @description Column Definition for move column feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
         */ /**
         *  @ngdoc object
         *  @name enableColumnMoving
         *  @propertyOf  ui.grid.moveColumns.api:ColumnDef
         *  @description Enable column moving for the column.
         */colDef.enableColumnMoving=colDef.enableColumnMoving===undefined?gridOptions.enableColumnMoving:colDef.enableColumnMoving;return $q.all(promises);},/**
       * @ngdoc method
       * @name updateColumnCache
       * @methodOf  ui.grid.moveColumns
       * @description Cache the current order of columns, so we can restore them after new columnDefs are defined
       */updateColumnCache:function(grid){grid.moveColumns.orderCache=grid.getOnlyDataColumns();},/**
       * @ngdoc method
       * @name verifyColumnOrder
       * @methodOf  ui.grid.moveColumns
       * @description dataChangeCallback which uses the cached column order to restore the column order
       * when it is reset by altering the columnDefs array.
       */verifyColumnOrder:function(grid){var headerRowOffset=grid.rowHeaderColumns.length;var newIndex;angular.forEach(grid.moveColumns.orderCache,function(cacheCol,cacheIndex){newIndex=grid.columns.indexOf(cacheCol);if(newIndex!==-1&&newIndex-headerRowOffset!==cacheIndex){var column=grid.columns.splice(newIndex,1)[0];grid.columns.splice(cacheIndex+headerRowOffset,0,column);}});},redrawColumnAtPosition:function(grid,originalPosition,newPosition){var columns=grid.columns;if(originalPosition===newPosition){return;}// check columns in between move-range to make sure they are visible columns
var pos=originalPosition<newPosition?originalPosition+1:originalPosition-1;var i0=Math.min(pos,newPosition);for(i0;i0<=Math.max(pos,newPosition);i0++){if(columns[i0].visible){break;}}if(i0>Math.max(pos,newPosition)){// no visible column found, column did not visibly move
return;}var originalColumn=columns[originalPosition];if(originalColumn.colDef.enableColumnMoving){if(originalPosition>newPosition){for(var i1=originalPosition;i1>newPosition;i1--){columns[i1]=columns[i1-1];}}else if(newPosition>originalPosition){for(var i2=originalPosition;i2<newPosition;i2++){columns[i2]=columns[i2+1];}}columns[newPosition]=originalColumn;service.updateColumnCache(grid);grid.queueGridRefresh();$rootScope.$applyAsync(function(){grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);grid.api.colMovable.raise.columnPositionChanged(originalColumn.colDef,originalPosition,newPosition);});}}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.moveColumns.directive:uiGridMoveColumns
   *  @element div
   *  @restrict A
   *  @description Adds column moving features to the ui-grid directive.
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.moveColumns']);
   app.controller('MainCtrl', ['$scope', function ($scope) {
        $scope.data = [
          { name: 'Bob', title: 'CEO', age: 45 },
          { name: 'Frank', title: 'Lowly Developer', age: 25 },
          { name: 'Jenny', title: 'Highly Developer', age: 35 }
        ];
        $scope.columnDefs = [
          {name: 'name'},
          {name: 'title'},
          {name: 'age'}
        ];
      }]);
   </file>
   <file name="main.css">
   .grid {
      width: 100%;
      height: 150px;
    }
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div class="grid" ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-move-columns></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridMoveColumns',['uiGridMoveColumnService',function(uiGridMoveColumnService){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridMoveColumnService.initializeGrid(uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.moveColumns.directive:uiGridHeaderCell
   *  @element div
   *  @restrict A
   *
   *  @description Stacks on top of ui.grid.uiGridHeaderCell to provide capability to be able to move it to reposition column.
   *
   *  On receiving mouseDown event headerCell is cloned, now as the mouse moves the cloned header cell also moved in the grid.
   *  In case the moving cloned header cell reaches the left or right extreme of grid, grid scrolling is triggered (if horizontal scroll exists).
   *  On mouseUp event column is repositioned at position where mouse is released and cloned header cell is removed.
   *
   *  Events that invoke cloning of header cell:
   *    - mousedown
   *
   *  Events that invoke movement of cloned header cell:
   *    - mousemove
   *
   *  Events that invoke repositioning of column:
   *    - mouseup
   */module.directive('uiGridHeaderCell',['$q','gridUtil','uiGridMoveColumnService','$document','$log','uiGridConstants','ScrollEvent',function($q,gridUtil,uiGridMoveColumnService,$document,$log,uiGridConstants,ScrollEvent){return{priority:-10,require:'^uiGrid',compile:function(){return{post:function($scope,$elm,$attrs,uiGridCtrl){if($scope.col.colDef.enableColumnMoving){/*
                 * Our general approach to column move is that we listen to a touchstart or mousedown
                 * event over the column header.  When we hear one, then we wait for a move of the same type
                 * - if we are a touchstart then we listen for a touchmove, if we are a mousedown we listen for
                 * a mousemove (i.e. a drag) before we decide that there's a move underway.  If there's never a move,
                 * and we instead get a mouseup or a touchend, then we just drop out again and do nothing.
                 *
                 */var $contentsElm=angular.element($elm[0].querySelectorAll('.ui-grid-cell-contents'));var gridLeft;var previousMouseX;var totalMouseMovement;var rightMoveLimit;var elmCloned=false;var movingElm;var reducedWidth;var moveOccurred=false;var downFn=function(event){// Setting some variables required for calculations.
gridLeft=$scope.grid.element[0].getBoundingClientRect().left;if($scope.grid.hasLeftContainer()){gridLeft+=$scope.grid.renderContainers.left.header[0].getBoundingClientRect().width;}previousMouseX=event.pageX||(event.originalEvent?event.originalEvent.pageX:0);totalMouseMovement=0;rightMoveLimit=gridLeft+$scope.grid.getViewportWidth();if(event.type==='mousedown'){$document.on('mousemove',moveFn);$document.on('mouseup',upFn);}else if(event.type==='touchstart'){$document.on('touchmove',moveFn);$document.on('touchend',upFn);}};var moveFn=function(event){var pageX=event.pageX||(event.originalEvent?event.originalEvent.pageX:0);var changeValue=pageX-previousMouseX;if(changeValue===0){return;}// Disable text selection in Chrome during column move
document.onselectstart=function(){return false;};moveOccurred=true;if(!elmCloned){cloneElement();}else if(elmCloned){moveElement(changeValue);previousMouseX=pageX;}};var upFn=function(event){// Re-enable text selection after column move
document.onselectstart=null;// Remove the cloned element on mouse up.
if(movingElm){movingElm.remove();elmCloned=false;}offAllEvents();onDownEvents();if(!moveOccurred){return;}var columns=$scope.grid.columns;var columnIndex=0;for(var i=0;i<columns.length;i++){if(columns[i].colDef.name!==$scope.col.colDef.name){columnIndex++;}else{break;}}var targetIndex;// Case where column should be moved to a position on its left
if(totalMouseMovement<0){var totalColumnsLeftWidth=0;var il;if($scope.grid.isRTL()){for(il=columnIndex+1;il<columns.length;il++){if(angular.isUndefined(columns[il].colDef.visible)||columns[il].colDef.visible===true){totalColumnsLeftWidth+=columns[il].drawnWidth||columns[il].width||columns[il].colDef.width;if(totalColumnsLeftWidth>Math.abs(totalMouseMovement)){uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,il-1);break;}}}}else{for(il=columnIndex-1;il>=0;il--){if(angular.isUndefined(columns[il].colDef.visible)||columns[il].colDef.visible===true){totalColumnsLeftWidth+=columns[il].drawnWidth||columns[il].width||columns[il].colDef.width;if(totalColumnsLeftWidth>Math.abs(totalMouseMovement)){uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,il+1);break;}}}}// Case where column should be moved to beginning (or end in RTL) of the grid.
if(totalColumnsLeftWidth<Math.abs(totalMouseMovement)){targetIndex=0;if($scope.grid.isRTL()){targetIndex=columns.length-1;}uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,targetIndex);}}// Case where column should be moved to a position on its right
else if(totalMouseMovement>0){var totalColumnsRightWidth=0;var ir;if($scope.grid.isRTL()){for(ir=columnIndex-1;ir>0;ir--){if(angular.isUndefined(columns[ir].colDef.visible)||columns[ir].colDef.visible===true){totalColumnsRightWidth+=columns[ir].drawnWidth||columns[ir].width||columns[ir].colDef.width;if(totalColumnsRightWidth>totalMouseMovement){uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,ir);break;}}}}else{for(ir=columnIndex+1;ir<columns.length;ir++){if(angular.isUndefined(columns[ir].colDef.visible)||columns[ir].colDef.visible===true){totalColumnsRightWidth+=columns[ir].drawnWidth||columns[ir].width||columns[ir].colDef.width;if(totalColumnsRightWidth>totalMouseMovement){uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,ir-1);break;}}}}// Case where column should be moved to end (or beginning in RTL) of the grid.
if(totalColumnsRightWidth<totalMouseMovement){targetIndex=columns.length-1;if($scope.grid.isRTL()){targetIndex=0;}uiGridMoveColumnService.redrawColumnAtPosition($scope.grid,columnIndex,targetIndex);}}};var onDownEvents=function(){$contentsElm.on('touchstart',downFn);$contentsElm.on('mousedown',downFn);};var offAllEvents=function(){$contentsElm.off('touchstart',downFn);$contentsElm.off('mousedown',downFn);$document.off('mousemove',moveFn);$document.off('touchmove',moveFn);$document.off('mouseup',upFn);$document.off('touchend',upFn);};onDownEvents();var cloneElement=function(){elmCloned=true;// Cloning header cell and appending to current header cell.
movingElm=$elm.clone();$elm.parent().append(movingElm);// Left of cloned element should be aligned to original header cell.
movingElm.addClass('movingColumn');var movingElementStyles={};movingElementStyles.left=$elm[0].offsetLeft+'px';var gridRight=$scope.grid.element[0].getBoundingClientRect().right;var elmRight=$elm[0].getBoundingClientRect().right;if(elmRight>gridRight){reducedWidth=$scope.col.drawnWidth+(gridRight-elmRight);movingElementStyles.width=reducedWidth+'px';}movingElm.css(movingElementStyles);};var moveElement=function(changeValue){// Calculate total column width
var columns=$scope.grid.columns;var totalColumnWidth=0;for(var i=0;i<columns.length;i++){if(angular.isUndefined(columns[i].colDef.visible)||columns[i].colDef.visible===true){totalColumnWidth+=columns[i].drawnWidth||columns[i].width||columns[i].colDef.width;}}// Calculate new position of left of column
var currentElmLeft=movingElm[0].getBoundingClientRect().left-1;var currentElmRight=movingElm[0].getBoundingClientRect().right;var newElementLeft;newElementLeft=currentElmLeft-gridLeft+changeValue;newElementLeft=newElementLeft<rightMoveLimit?newElementLeft:rightMoveLimit;// Update css of moving column to adjust to new left value or fire scroll in case column has reached edge of grid
if((currentElmLeft>=gridLeft||changeValue>0)&&(currentElmRight<=rightMoveLimit||changeValue<0)){movingElm.css({visibility:'visible','left':movingElm[0].offsetLeft+(newElementLeft<rightMoveLimit?changeValue:rightMoveLimit-currentElmLeft)+'px'});}else if(totalColumnWidth>Math.ceil(uiGridCtrl.grid.gridWidth)){changeValue*=8;var scrollEvent=new ScrollEvent($scope.col.grid,null,null,'uiGridHeaderCell.moveElement');scrollEvent.x={pixels:changeValue};scrollEvent.grid.scrollContainers('',scrollEvent);}// Calculate total width of columns on the left of the moving column and the mouse movement
var totalColumnsLeftWidth=0;for(var il=0;il<columns.length;il++){if(angular.isUndefined(columns[il].colDef.visible)||columns[il].colDef.visible===true){if(columns[il].colDef.name!==$scope.col.colDef.name){totalColumnsLeftWidth+=columns[il].drawnWidth||columns[il].width||columns[il].colDef.width;}else{break;}}}if($scope.newScrollLeft===undefined){totalMouseMovement+=changeValue;}else{totalMouseMovement=$scope.newScrollLeft+newElementLeft-totalColumnsLeftWidth;}// Increase width of moving column, in case the rightmost column was moved and its width was
// decreased because of overflow
if(reducedWidth<$scope.col.drawnWidth){reducedWidth+=Math.abs(changeValue);movingElm.css({'width':reducedWidth+'px'});}};$scope.$on('$destroy',offAllEvents);}}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.pagination
   *
   * @description
   *
   * # ui.grid.pagination
   *
   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
   *
   * This module provides pagination support to ui-grid
   */var module=angular.module('ui.grid.pagination',['ng','ui.grid']);/**
   * @ngdoc service
   * @name ui.grid.pagination.service:uiGridPaginationService
   *
   * @description Service for the pagination feature
   */module.service('uiGridPaginationService',['gridUtil',function(gridUtil){var service={/**
         * @ngdoc method
         * @name initializeGrid
         * @methodOf ui.grid.pagination.service:uiGridPaginationService
         * @description Attaches the service to a certain grid
         * @param {Grid} grid The grid we want to work with
         */initializeGrid:function(grid){service.defaultGridOptions(grid.options);/**
          * @ngdoc object
          * @name ui.grid.pagination.api:PublicAPI
          *
          * @description Public API for the pagination feature
          */var publicApi={events:{pagination:{/**
               * @ngdoc event
               * @name paginationChanged
               * @eventOf ui.grid.pagination.api:PublicAPI
               * @description This event fires when the pageSize or currentPage changes
               * @param {int} currentPage requested page number
               * @param {int} pageSize requested page size
               */paginationChanged:function(currentPage,pageSize){}}},methods:{pagination:{/**
                 * @ngdoc method
                 * @name getPage
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Returns the number of the current page
                 */getPage:function(){return grid.options.enablePagination?grid.options.paginationCurrentPage:null;},/**
                 * @ngdoc method
                 * @name getFirstRowIndex
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Returns the index of the first row of the current page.
                 */getFirstRowIndex:function(){if(grid.options.useCustomPagination){return grid.options.paginationPageSizes.reduce(function(result,size,index){return index<grid.options.paginationCurrentPage-1?result+size:result;},0);}return(grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize;},/**
                 * @ngdoc method
                 * @name getLastRowIndex
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Returns the index of the last row of the current page.
                 */getLastRowIndex:function(){if(grid.options.useCustomPagination){return publicApi.methods.pagination.getFirstRowIndex()+grid.options.paginationPageSizes[grid.options.paginationCurrentPage-1]-1;}return Math.min(grid.options.paginationCurrentPage*grid.options.paginationPageSize,grid.options.totalItems)-1;},/**
                 * @ngdoc method
                 * @name getTotalPages
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Returns the total number of pages
                 */getTotalPages:function(){if(!grid.options.enablePagination){return null;}if(grid.options.useCustomPagination){return grid.options.paginationPageSizes.length;}return grid.options.totalItems===0?1:Math.ceil(grid.options.totalItems/grid.options.paginationPageSize);},/**
                 * @ngdoc method
                 * @name nextPage
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Moves to the next page, if possible
                 */nextPage:function(){if(!grid.options.enablePagination){return;}if(grid.options.totalItems>0){grid.options.paginationCurrentPage=Math.min(grid.options.paginationCurrentPage+1,publicApi.methods.pagination.getTotalPages());}else{grid.options.paginationCurrentPage++;}},/**
                 * @ngdoc method
                 * @name previousPage
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Moves to the previous page, if we're not on the first page
                 */previousPage:function(){if(!grid.options.enablePagination){return;}grid.options.paginationCurrentPage=Math.max(grid.options.paginationCurrentPage-1,1);},/**
                 * @ngdoc method
                 * @name seek
                 * @methodOf ui.grid.pagination.api:PublicAPI
                 * @description Moves to the requested page
                 * @param {int} page The number of the page that should be displayed
                 */seek:function(page){if(!grid.options.enablePagination){return;}if(!angular.isNumber(page)||page<1){throw'Invalid page number: '+page;}grid.options.paginationCurrentPage=Math.min(page,publicApi.methods.pagination.getTotalPages());}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);var processPagination=function(renderableRows){if(grid.options.useExternalPagination||!grid.options.enablePagination){return renderableRows;}// client side pagination
var pageSize=parseInt(grid.options.paginationPageSize,10);var currentPage=parseInt(grid.options.paginationCurrentPage,10);var visibleRows=renderableRows.filter(function(row){return row.visible;});grid.options.totalItems=visibleRows.length;var firstRow=publicApi.methods.pagination.getFirstRowIndex();var lastRow=publicApi.methods.pagination.getLastRowIndex();if(firstRow>visibleRows.length){currentPage=grid.options.paginationCurrentPage=1;firstRow=(currentPage-1)*pageSize;}return visibleRows.slice(firstRow,lastRow+1);};grid.registerRowsProcessor(processPagination,900);},defaultGridOptions:function(gridOptions){/**
           * @ngdoc object
           * @name ui.grid.pagination.api:GridOptions
           *
           * @description GridOptions for the pagination feature, these are available to be
           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           * @ngdoc property
           * @name enablePagination
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Enables pagination.  Defaults to true.
           */gridOptions.enablePagination=gridOptions.enablePagination!==false;/**
           * @ngdoc property
           * @name enablePaginationControls
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Enables the paginator at the bottom of the grid. Turn this off if you want to implement your
           *              own controls outside the grid.
           */gridOptions.enablePaginationControls=gridOptions.enablePaginationControls!==false;/**
           * @ngdoc property
           * @name useExternalPagination
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Disables client side pagination. When true, handle the paginationChanged event and set data
           *              and totalItems.  Defaults to `false`
           */gridOptions.useExternalPagination=gridOptions.useExternalPagination===true;/**
           * @ngdoc property
           * @name useCustomPagination
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Disables client-side pagination. When true, handle the `paginationChanged` event and set `data`,
           *              `firstRowIndex`, `lastRowIndex`, and `totalItems`.  Defaults to `false`.
           */gridOptions.useCustomPagination=gridOptions.useCustomPagination===true;/**
           * @ngdoc property
           * @name totalItems
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Total number of items, set automatically when using client side pagination, but needs set by user
           *              for server side pagination
           */if(gridUtil.isNullOrUndefined(gridOptions.totalItems)){gridOptions.totalItems=0;}/**
           * @ngdoc property
           * @name paginationPageSizes
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Array of page sizes, defaults to `[250, 500, 1000]`
           */if(gridUtil.isNullOrUndefined(gridOptions.paginationPageSizes)){gridOptions.paginationPageSizes=[250,500,1000];}/**
           * @ngdoc property
           * @name paginationPageSize
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Page size, defaults to the first item in paginationPageSizes, or 0 if paginationPageSizes is empty
           */if(gridUtil.isNullOrUndefined(gridOptions.paginationPageSize)){if(gridOptions.paginationPageSizes.length>0){gridOptions.paginationPageSize=gridOptions.paginationPageSizes[0];}else{gridOptions.paginationPageSize=0;}}/**
           * @ngdoc property
           * @name paginationCurrentPage
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description Current page number, defaults to 1
           */if(gridUtil.isNullOrUndefined(gridOptions.paginationCurrentPage)){gridOptions.paginationCurrentPage=1;}/**
           * @ngdoc property
           * @name paginationTemplate
           * @propertyOf ui.grid.pagination.api:GridOptions
           * @description A custom template for the pager, defaults to `ui-grid/pagination`
           */if(gridUtil.isNullOrUndefined(gridOptions.paginationTemplate)){gridOptions.paginationTemplate='ui-grid/pagination';}},/**
         * @ngdoc method
         * @methodOf ui.grid.pagination.service:uiGridPaginationService
         * @name uiGridPaginationService
         * @description  Raises paginationChanged and calls refresh for client side pagination
         * @param {Grid} grid the grid for which the pagination changed
         * @param {int} currentPage requested page number
         * @param {int} pageSize requested page size
         */onPaginationChanged:function(grid,currentPage,pageSize){grid.api.pagination.raise.paginationChanged(currentPage,pageSize);if(!grid.options.useExternalPagination){grid.queueGridRefresh();// client side pagination
}}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.pagination.directive:uiGridPagination
   *  @element div
   *  @restrict A
   *
   *  @description Adds pagination features to grid
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.pagination']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Alex', car: 'Toyota' },
        { name: 'Sam', car: 'Lexus' },
        { name: 'Joe', car: 'Dodge' },
        { name: 'Bob', car: 'Buick' },
        { name: 'Cindy', car: 'Ford' },
        { name: 'Brian', car: 'Audi' },
        { name: 'Malcom', car: 'Mercedes Benz' },
        { name: 'Dave', car: 'Ford' },
        { name: 'Stacey', car: 'Audi' },
        { name: 'Amy', car: 'Acura' },
        { name: 'Scott', car: 'Toyota' },
        { name: 'Ryan', car: 'BMW' },
      ];

      $scope.gridOptions = {
        data: 'data',
        paginationPageSizes: [5, 10, 25],
        paginationPageSize: 5,
        columnDefs: [
          {name: 'name'},
          {name: 'car'}
        ]
       }
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="gridOptions" ui-grid-pagination></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridPagination',['gridUtil','uiGridPaginationService',function(gridUtil,uiGridPaginationService){return{priority:-200,scope:false,require:'uiGrid',link:{pre:function($scope,$elm,$attr,uiGridCtrl){uiGridPaginationService.initializeGrid(uiGridCtrl.grid);gridUtil.getTemplate(uiGridCtrl.grid.options.paginationTemplate).then(function(contents){var template=angular.element(contents);$elm.append(template);uiGridCtrl.innerCompile(template);});}}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.pagination.directive:uiGridPager
   *  @element div
   *
   *  @description Panel for handling pagination
   */module.directive('uiGridPager',['uiGridPaginationService','uiGridConstants','gridUtil','i18nService','i18nConstants',function(uiGridPaginationService,uiGridConstants,gridUtil,i18nService,i18nConstants){return{priority:-200,scope:true,require:'^uiGrid',link:function($scope,$elm,$attr,uiGridCtrl){var defaultFocusElementSelector='.ui-grid-pager-control-input';$scope.aria=i18nService.getSafeText('pagination.aria');// Returns an object with all of the aria labels
var updateLabels=function(){$scope.paginationApi=uiGridCtrl.grid.api.pagination;$scope.sizesLabel=i18nService.getSafeText('pagination.sizes');$scope.totalItemsLabel=i18nService.getSafeText('pagination.totalItems');$scope.paginationOf=i18nService.getSafeText('pagination.of');$scope.paginationThrough=i18nService.getSafeText('pagination.through');};updateLabels();$scope.$on(i18nConstants.UPDATE_EVENT,updateLabels);var options=uiGridCtrl.grid.options;uiGridCtrl.grid.renderContainers.body.registerViewportAdjuster(function(adjustment){if(options.enablePaginationControls){adjustment.height=adjustment.height-gridUtil.elementHeight($elm,"padding");}return adjustment;});var dataChangeDereg=uiGridCtrl.grid.registerDataChangeCallback(function(grid){if(!grid.options.useExternalPagination){grid.options.totalItems=grid.rows.length;}},[uiGridConstants.dataChange.ROW]);$scope.$on('$destroy',dataChangeDereg);var deregP=$scope.$watch('grid.options.paginationCurrentPage + grid.options.paginationPageSize',function(newValues,oldValues){if(newValues===oldValues||oldValues===undefined){return;}if(!angular.isNumber(options.paginationCurrentPage)||options.paginationCurrentPage<1){options.paginationCurrentPage=1;return;}if(options.totalItems>0&&options.paginationCurrentPage>$scope.paginationApi.getTotalPages()){options.paginationCurrentPage=$scope.paginationApi.getTotalPages();return;}uiGridPaginationService.onPaginationChanged($scope.grid,options.paginationCurrentPage,options.paginationPageSize);});$scope.$on('$destroy',function(){deregP();});$scope.cantPageForward=function(){if($scope.paginationApi.getTotalPages()){return $scope.cantPageToLast();}else{return options.data.length<1;}};$scope.cantPageToLast=function(){var totalPages=$scope.paginationApi.getTotalPages();return!totalPages||options.paginationCurrentPage>=totalPages;};$scope.cantPageBackward=function(){return options.paginationCurrentPage<=1;};var focusToInputIf=function(condition){if(condition){gridUtil.focus.bySelector($elm,defaultFocusElementSelector);}};// Takes care of setting focus to the middle element when focus is lost
$scope.pageFirstPageClick=function(){$scope.paginationApi.seek(1);focusToInputIf($scope.cantPageBackward());};$scope.pagePreviousPageClick=function(){$scope.paginationApi.previousPage();focusToInputIf($scope.cantPageBackward());};$scope.pageNextPageClick=function(){$scope.paginationApi.nextPage();focusToInputIf($scope.cantPageForward());};$scope.pageLastPageClick=function(){$scope.paginationApi.seek($scope.paginationApi.getTotalPages());focusToInputIf($scope.cantPageToLast());};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.pinning
   * @description
   *
   * # ui.grid.pinning
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module provides column pinning to the end user via menu options in the column header
   *
   * <div doc-module-components="ui.grid.pinning"></div>
   */var module=angular.module('ui.grid.pinning',['ui.grid']);module.constant('uiGridPinningConstants',{container:{LEFT:'left',RIGHT:'right',NONE:''}});module.service('uiGridPinningService',['gridUtil','GridRenderContainer','i18nService','uiGridPinningConstants',function(gridUtil,GridRenderContainer,i18nService,uiGridPinningConstants){var service={initializeGrid:function(grid){service.defaultGridOptions(grid.options);// Register a column builder to add new menu items for pinning left and right
grid.registerColumnBuilder(service.pinningColumnBuilder);/**
         *  @ngdoc object
         *  @name ui.grid.pinning.api:PublicApi
         *
         *  @description Public Api for pinning feature
         */var publicApi={events:{pinning:{/**
               * @ngdoc event
               * @name columnPinned
               * @eventOf ui.grid.pinning.api:PublicApi
               * @description raised when column pin state has changed
               * <pre>
               *   gridApi.pinning.on.columnPinned(scope, function(colDef){})
               * </pre>
               * @param {object} colDef the column that was changed
               * @param {string} container the render container the column is in ('left', 'right', '')
               */columnPinned:function(colDef,container){}}},methods:{pinning:{/**
               * @ngdoc function
               * @name pinColumn
               * @methodOf ui.grid.pinning.api:PublicApi
               * @description pin column left, right, or none
               * <pre>
               *   gridApi.pinning.pinColumn(col, uiGridPinningConstants.container.LEFT)
               * </pre>
               * @param {gridColumn} col the column being pinned
               * @param {string} container one of the recognised types
               * from uiGridPinningConstants
               */pinColumn:function(col,container){service.pinColumn(grid,col,container);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
         *  @ngdoc object
         *  @name ui.grid.pinning.api:GridOptions
         *
         *  @description GridOptions for pinning feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */ /**
         *  @ngdoc object
         *  @name enablePinning
         *  @propertyOf  ui.grid.pinning.api:GridOptions
         *  @description Enable pinning for the entire grid.
         *  <br/>Defaults to true
         */gridOptions.enablePinning=gridOptions.enablePinning!==false;/**
         *  @ngdoc object
         *  @name hidePinLeft
         *  @propertyOf  ui.grid.pinning.api:GridOptions
         *  @description Hide Pin Left for the entire grid.
         *  <br/>Defaults to false
         */gridOptions.hidePinLeft=gridOptions.enablePinning&&gridOptions.hidePinLeft;/**
         *  @ngdoc object
         *  @name hidePinRight
         *  @propertyOf  ui.grid.pinning.api:GridOptions
         *  @description Hide Pin Right pinning for the entire grid.
         *  <br/>Defaults to false
         */gridOptions.hidePinRight=gridOptions.enablePinning&&gridOptions.hidePinRight;},pinningColumnBuilder:function(colDef,col,gridOptions){// default to true unless gridOptions or colDef is explicitly false
/**
         *  @ngdoc object
         *  @name ui.grid.pinning.api:ColumnDef
         *
         *  @description ColumnDef for pinning feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
         */ /**
         *  @ngdoc object
         *  @name enablePinning
         *  @propertyOf  ui.grid.pinning.api:ColumnDef
         *  @description Enable pinning for the individual column.
         *  <br/>Defaults to true
         */colDef.enablePinning=colDef.enablePinning===undefined?gridOptions.enablePinning:colDef.enablePinning;/**
         *  @ngdoc object
         *  @name hidePinLeft
         *  @propertyOf  ui.grid.pinning.api:ColumnDef
         *  @description Hide Pin Left for the individual column.
         *  <br/>Defaults to false
         */colDef.hidePinLeft=colDef.hidePinLeft===undefined?gridOptions.hidePinLeft:colDef.hidePinLeft;/**
         *  @ngdoc object
         *  @name hidePinRight
         *  @propertyOf  ui.grid.pinning.api:ColumnDef
         *  @description Hide Pin Right for the individual column.
         *  <br/>Defaults to false
         */colDef.hidePinRight=colDef.hidePinRight===undefined?gridOptions.hidePinRight:colDef.hidePinRight;/**
         *  @ngdoc object
         *  @name pinnedLeft
         *  @propertyOf  ui.grid.pinning.api:ColumnDef
         *  @description Column is pinned left when grid is rendered
         *  <br/>Defaults to false
         */ /**
         *  @ngdoc object
         *  @name pinnedRight
         *  @propertyOf  ui.grid.pinning.api:ColumnDef
         *  @description Column is pinned right when grid is rendered
         *  <br/>Defaults to false
         */if(colDef.pinnedLeft){col.renderContainer='left';col.grid.createLeftContainer();}else if(colDef.pinnedRight){col.renderContainer='right';col.grid.createRightContainer();}if(!colDef.enablePinning){return;}var pinColumnLeftAction={name:'ui.grid.pinning.pinLeft',title:i18nService.get().pinning.pinLeft,icon:'ui-grid-icon-left-open',shown:function(){return typeof this.context.col.renderContainer==='undefined'||!this.context.col.renderContainer||this.context.col.renderContainer!=='left';},action:function(){service.pinColumn(this.context.col.grid,this.context.col,uiGridPinningConstants.container.LEFT);}};var pinColumnRightAction={name:'ui.grid.pinning.pinRight',title:i18nService.get().pinning.pinRight,icon:'ui-grid-icon-right-open',shown:function(){return typeof this.context.col.renderContainer==='undefined'||!this.context.col.renderContainer||this.context.col.renderContainer!=='right';},action:function(){service.pinColumn(this.context.col.grid,this.context.col,uiGridPinningConstants.container.RIGHT);}};var removePinAction={name:'ui.grid.pinning.unpin',title:i18nService.get().pinning.unpin,icon:'ui-grid-icon-cancel',shown:function(){return typeof this.context.col.renderContainer!=='undefined'&&this.context.col.renderContainer!==null&&this.context.col.renderContainer!=='body';},action:function(){service.pinColumn(this.context.col.grid,this.context.col,uiGridPinningConstants.container.NONE);}};// Skip from menu if hidePinLeft or hidePinRight is true
if(!colDef.hidePinLeft&&!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.pinning.pinLeft')){col.menuItems.push(pinColumnLeftAction);}if(!colDef.hidePinRight&&!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.pinning.pinRight')){col.menuItems.push(pinColumnRightAction);}if(!gridUtil.arrayContainsObjectWithProperty(col.menuItems,'name','ui.grid.pinning.unpin')){col.menuItems.push(removePinAction);}},pinColumn:function(grid,col,container){if(container===uiGridPinningConstants.container.NONE){col.renderContainer=null;col.colDef.pinnedLeft=col.colDef.pinnedRight=false;}else{col.renderContainer=container;if(container===uiGridPinningConstants.container.LEFT){grid.createLeftContainer();}else if(container===uiGridPinningConstants.container.RIGHT){grid.createRightContainer();}}grid.refresh().then(function(){grid.api.pinning.raise.columnPinned(col.colDef,container);});}};return service;}]);module.directive('uiGridPinning',['gridUtil','uiGridPinningService',function(gridUtil,uiGridPinningService){return{require:'uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridPinningService.initializeGrid(uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.resizeColumns
   * @description
   *
   * # ui.grid.resizeColumns
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module allows columns to be resized.
   */var module=angular.module('ui.grid.resizeColumns',['ui.grid']);module.service('uiGridResizeColumnsService',['gridUtil','$q','$rootScope',function(gridUtil,$q,$rootScope){return{defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
           *  @ngdoc object
           *  @name ui.grid.resizeColumns.api:GridOptions
           *
           *  @description GridOptions for resizeColumns feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           *  @ngdoc object
           *  @name enableColumnResizing
           *  @propertyOf  ui.grid.resizeColumns.api:GridOptions
           *  @description Enable column resizing on the entire grid
           *  <br/>Defaults to true
           */gridOptions.enableColumnResizing=gridOptions.enableColumnResizing!==false;// legacy support
// use old name if it is explicitly false
if(gridOptions.enableColumnResize===false){gridOptions.enableColumnResizing=false;}},colResizerColumnBuilder:function(colDef,col,gridOptions){var promises=[];/**
           *  @ngdoc object
           *  @name ui.grid.resizeColumns.api:ColumnDef
           *
           *  @description ColumnDef for resizeColumns feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
           */ /**
           *  @ngdoc object
           *  @name enableColumnResizing
           *  @propertyOf  ui.grid.resizeColumns.api:ColumnDef
           *  @description Enable column resizing on an individual column
           *  <br/>Defaults to GridOptions.enableColumnResizing
           */ // default to true unless gridOptions or colDef is explicitly false
colDef.enableColumnResizing=colDef.enableColumnResizing===undefined?gridOptions.enableColumnResizing:colDef.enableColumnResizing;// legacy support of old option name
if(colDef.enableColumnResize===false){colDef.enableColumnResizing=false;}return $q.all(promises);},registerPublicApi:function(grid){/**
             *  @ngdoc object
             *  @name ui.grid.resizeColumns.api:PublicApi
             *  @description Public Api for column resize feature.
             */var publicApi={events:{/**
                 * @ngdoc event
                 * @name columnSizeChanged
                 * @eventOf  ui.grid.resizeColumns.api:PublicApi
                 * @description raised when column is resized
                 * <pre>
                 *      gridApi.colResizable.on.columnSizeChanged(scope,function(colDef, deltaChange) {})
                 * </pre>
                 * @param {object} colDef the column that was resized
                 * @param {integer} delta of the column size change
                 */colResizable:{columnSizeChanged:function(colDef,deltaChange){}}}};grid.api.registerEventsFromObject(publicApi.events);},fireColumnSizeChanged:function(grid,colDef,deltaChange){$rootScope.$applyAsync(function(){if(grid.api.colResizable){grid.api.colResizable.raise.columnSizeChanged(colDef,deltaChange);}else{gridUtil.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.");}});},// get either this column, or the column next to this column, to resize,
// returns the column we're going to resize
findTargetCol:function(col,position,rtlMultiplier){var renderContainer=col.getRenderContainer();if(position==='left'){// Get the column to the left of this one
var colIndex=renderContainer.visibleColumnCache.indexOf(col);if(colIndex===0){return renderContainer.visibleColumnCache[0];}return renderContainer.visibleColumnCache[colIndex-1*rtlMultiplier];}else{return col;}}};}]);/**
   * @ngdoc directive
   * @name ui.grid.resizeColumns.directive:uiGridResizeColumns
   * @element div
   * @restrict A
   * @description
   * Enables resizing for all columns on the grid. If, for some reason, you want to use the ui-grid-resize-columns directive, but not allow column resizing, you can explicitly set the
   * option to false. This prevents resizing for the entire grid, regardless of individual columnDef options.
   *
   * @example
   <doc:example module="app">
   <doc:source>
   <script>
   var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
          $scope.gridOpts = {
            data: [
              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
            ]
          };
        }]);
   </script>

   <div ng-controller="MainCtrl">
   <div class="testGrid" ui-grid="gridOpts" ui-grid-resize-columns ></div>
   </div>
   </doc:source>
   <doc:scenario>

   </doc:scenario>
   </doc:example>
   */module.directive('uiGridResizeColumns',['gridUtil','uiGridResizeColumnsService',function(gridUtil,uiGridResizeColumnsService){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridResizeColumnsService.defaultGridOptions(uiGridCtrl.grid.options);uiGridCtrl.grid.registerColumnBuilder(uiGridResizeColumnsService.colResizerColumnBuilder);uiGridResizeColumnsService.registerPublicApi(uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);// Extend the uiGridHeaderCell directive
module.directive('uiGridHeaderCell',['gridUtil','$templateCache','$compile','$q','uiGridResizeColumnsService','uiGridConstants',function(gridUtil,$templateCache,$compile,$q,uiGridResizeColumnsService,uiGridConstants){return{// Run after the original uiGridHeaderCell
priority:-10,require:'^uiGrid',// scope: false,
compile:function(){return{post:function($scope,$elm,$attrs,uiGridCtrl){var grid=uiGridCtrl.grid;if(grid.options.enableColumnResizing){var columnResizerElm=$templateCache.get('ui-grid/columnResizer');var rtlMultiplier=1;// when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
if(grid.isRTL()){$scope.position='left';rtlMultiplier=-1;}var displayResizers=function(){// remove any existing resizers.
var resizers=$elm[0].getElementsByClassName('ui-grid-column-resizer');for(var i=0;i<resizers.length;i++){angular.element(resizers[i]).remove();}// get the target column for the left resizer
var otherCol=uiGridResizeColumnsService.findTargetCol($scope.col,'left',rtlMultiplier);var renderContainer=$scope.col.getRenderContainer();// Don't append the left resizer if this is the first column or the column to the left of this one has resizing disabled
if(otherCol&&renderContainer.visibleColumnCache.indexOf($scope.col)!==0&&otherCol.colDef.enableColumnResizing!==false){var resizerLeft=angular.element(columnResizerElm).clone();resizerLeft.attr('position','left');$elm.prepend(resizerLeft);$compile(resizerLeft)($scope);}// Don't append the right resizer if this column has resizing disabled
if($scope.col.colDef.enableColumnResizing!==false){var resizerRight=angular.element(columnResizerElm).clone();resizerRight.attr('position','right');$elm.append(resizerRight);$compile(resizerRight)($scope);}};displayResizers();var waitDisplay=function(){$scope.$applyAsync(displayResizers);};var dataChangeDereg=grid.registerDataChangeCallback(waitDisplay,[uiGridConstants.dataChange.COLUMN]);$scope.$on('$destroy',dataChangeDereg);}}};}};}]);/**
   * @ngdoc directive
   * @name ui.grid.resizeColumns.directive:uiGridColumnResizer
   * @element div
   * @restrict A
   *
   * @description
   * Draggable handle that controls column resizing.
   *
   * @example
   <doc:example module="app">
     <doc:source>
       <script>
        var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);

        app.controller('MainCtrl', ['$scope', function ($scope) {
          $scope.gridOpts = {
            enableColumnResizing: true,
            data: [
              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
            ]
          };
        }]);
       </script>

       <div ng-controller="MainCtrl">
        <div class="testGrid" ui-grid="gridOpts"></div>
       </div>
     </doc:source>
     <doc:scenario>
      // TODO: e2e specs?

      // TODO: post-resize a horizontal scroll event should be fired
     </doc:scenario>
   </doc:example>
   */module.directive('uiGridColumnResizer',['$document','gridUtil','uiGridConstants','uiGridResizeColumnsService',function($document,gridUtil,uiGridConstants,uiGridResizeColumnsService){var resizeOverlay=angular.element('<div class="ui-grid-resize-overlay"></div>');return{priority:0,scope:{col:'=',position:'@',renderIndex:'='},require:'?^uiGrid',link:function($scope,$elm,$attrs,uiGridCtrl){var startX=0,x=0,gridLeft=0,rtlMultiplier=1;// when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
if(uiGridCtrl.grid.isRTL()){$scope.position='left';rtlMultiplier=-1;}if($scope.position==='left'){$elm.addClass('left');}else if($scope.position==='right'){$elm.addClass('right');}// Refresh the grid canvas
//   takes an argument representing the diff along the X-axis that the resize had
function refreshCanvas(xDiff){// Then refresh the grid canvas, rebuilding the styles so that the scrollbar updates its size
uiGridCtrl.grid.refreshCanvas(true).then(function(){uiGridCtrl.grid.queueGridRefresh();});}// Check that the requested width isn't wider than the maxWidth, or narrower than the minWidth
// Returns the new recommended with, after constraints applied
function constrainWidth(col,width){var newWidth=width;// If the new width would be less than the column's allowably minimum width, don't allow it
if(col.minWidth&&newWidth<col.minWidth){newWidth=col.minWidth;}else if(col.maxWidth&&newWidth>col.maxWidth){newWidth=col.maxWidth;}return newWidth;}/*
         * Our approach to event handling aims to deal with both touch devices and mouse devices
         * We register down handlers on both touch and mouse.  When a touchstart or mousedown event
         * occurs, we register the corresponding touchmove/touchend, or mousemove/mouseend events.
         *
         * This way we can listen for both without worrying about the fact many touch devices also emulate
         * mouse events - basically whichever one we hear first is what we'll go with.
         */function moveFunction(event,args){if(event.originalEvent){event=event.originalEvent;}event.preventDefault();x=(event.targetTouches?event.targetTouches[0]:event).clientX-gridLeft;if(x<0){x=0;}else if(x>uiGridCtrl.grid.gridWidth){x=uiGridCtrl.grid.gridWidth;}var col=uiGridResizeColumnsService.findTargetCol($scope.col,$scope.position,rtlMultiplier);// Don't resize if it's disabled on this column
if(col.colDef.enableColumnResizing===false){return;}if(!uiGridCtrl.grid.element.hasClass('column-resizing')){uiGridCtrl.grid.element.addClass('column-resizing');}// Get the diff along the X axis
var xDiff=x-startX;// Get the width that this mouse would give the column
var newWidth=parseInt(col.drawnWidth+xDiff*rtlMultiplier,10);// check we're not outside the allowable bounds for this column
x=x+(constrainWidth(col,newWidth)-newWidth)*rtlMultiplier;resizeOverlay.css({left:x+'px'});uiGridCtrl.fireEvent(uiGridConstants.events.ITEM_DRAGGING);}function upFunction(event){if(event.originalEvent){event=event.originalEvent;}event.preventDefault();uiGridCtrl.grid.element.removeClass('column-resizing');resizeOverlay.remove();// Resize the column
x=(event.changedTouches?event.changedTouches[0]:event).clientX-gridLeft;var xDiff=x-startX;if(xDiff===0){// no movement, so just reset event handlers, including turning back on both
// down events - we turned one off when this event started
offAllEvents();onDownEvents();return;}var col=uiGridResizeColumnsService.findTargetCol($scope.col,$scope.position,rtlMultiplier);// Don't resize if it's disabled on this column
if(col.colDef.enableColumnResizing===false){return;}// Get the new width
var newWidth=parseInt(col.drawnWidth+xDiff*rtlMultiplier,10);// check we're not outside the allowable bounds for this column
col.width=constrainWidth(col,newWidth);col.hasCustomWidth=true;refreshCanvas(xDiff);uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid,col.colDef,xDiff);// stop listening of up and move events - wait for next down
// reset the down events - we will have turned one off when this event started
offAllEvents();onDownEvents();}var downFunction=function(event,args){if(event.originalEvent){event=event.originalEvent;}event.stopPropagation();// Get the left offset of the grid
// gridLeft = uiGridCtrl.grid.element[0].offsetLeft;
gridLeft=uiGridCtrl.grid.element[0].getBoundingClientRect().left;// Get the starting X position, which is the X coordinate of the click minus the grid's offset
startX=(event.targetTouches?event.targetTouches[0]:event).clientX-gridLeft;// Append the resizer overlay
uiGridCtrl.grid.element.append(resizeOverlay);// Place the resizer overlay at the start position
resizeOverlay.css({left:startX});// Add handlers for move and up events - if we were mousedown then we listen for mousemove and mouseup, if
// we were touchdown then we listen for touchmove and touchup.  Also remove the handler for the equivalent
// down event - so if we're touchdown, then remove the mousedown handler until this event is over, if we're
// mousedown then remove the touchdown handler until this event is over, this avoids processing duplicate events
if(event.type==='touchstart'){$document.on('touchend',upFunction);$document.on('touchmove',moveFunction);$elm.off('mousedown',downFunction);}else{$document.on('mouseup',upFunction);$document.on('mousemove',moveFunction);$elm.off('touchstart',downFunction);}};var onDownEvents=function(){$elm.on('mousedown',downFunction);$elm.on('touchstart',downFunction);};var offAllEvents=function(){$document.off('mouseup',upFunction);$document.off('touchend',upFunction);$document.off('mousemove',moveFunction);$document.off('touchmove',moveFunction);$elm.off('mousedown',downFunction);$elm.off('touchstart',downFunction);};onDownEvents();// On doubleclick, resize to fit all rendered cells
var dblClickFn=function(event,args){event.stopPropagation();var col=uiGridResizeColumnsService.findTargetCol($scope.col,$scope.position,rtlMultiplier);// Don't resize if it's disabled on this column
if(col.colDef.enableColumnResizing===false){return;}// Go through the rendered rows and find out the max size for the data in this column
var maxWidth=0;// Get the parent render container element
var renderContainerElm=gridUtil.closestElm($elm,'.ui-grid-render-container');// Get the cell contents so we measure correctly. For the header cell we have to account for the sort icon and the menu buttons, if present
var cells=renderContainerElm.querySelectorAll('.'+uiGridConstants.COL_CLASS_PREFIX+col.uid+' .ui-grid-cell-contents');Array.prototype.forEach.call(cells,function(cell){// Get the cell width
// gridUtil.logDebug('width', gridUtil.elementWidth(cell));
// Account for the menu button if it exists
var menuButton;if(angular.element(cell).parent().hasClass('ui-grid-header-cell')){menuButton=angular.element(cell).parent()[0].querySelectorAll('.ui-grid-column-menu-button');}gridUtil.fakeElement(cell,{},function(newElm){// Make the element float since it's a div and can expand to fill its container
var e=angular.element(newElm);e.attr('style','float: left');var width=gridUtil.elementWidth(e)+2;if(menuButton){var menuButtonWidth=gridUtil.elementWidth(menuButton);width=width+menuButtonWidth;}if(width>maxWidth){maxWidth=width;}});});// check we're not outside the allowable bounds for this column
var newWidth=constrainWidth(col,maxWidth);var xDiff=newWidth-col.drawnWidth;col.width=newWidth;col.hasCustomWidth=true;refreshCanvas(xDiff);uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid,col.colDef,xDiff);};$elm.on('dblclick',dblClickFn);$elm.on('$destroy',function(){$elm.off('dblclick',dblClickFn);offAllEvents();});}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.rowEdit
   * @description
   *
   * # ui.grid.rowEdit
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module extends the edit feature to provide tracking and saving of rows
   * of data.  The tutorial provides more information on how this feature is best
   * used {@link tutorial/205_row_editable here}.
   * <br/>
   * This feature depends on usage of the ui-grid-edit feature, and also benefits
   * from use of ui-grid-cellNav to provide the full spreadsheet-like editing
   * experience
   *
   */var module=angular.module('ui.grid.rowEdit',['ui.grid','ui.grid.edit','ui.grid.cellNav']);/**
   *  @ngdoc object
   *  @name ui.grid.rowEdit.constant:uiGridRowEditConstants
   *
   *  @description constants available in row edit module
   */module.constant('uiGridRowEditConstants',{});/**
   *  @ngdoc service
   *  @name ui.grid.rowEdit.service:uiGridRowEditService
   *
   *  @description Services for row editing features
   */module.service('uiGridRowEditService',['$interval','$q','uiGridConstants','uiGridRowEditConstants','gridUtil',function($interval,$q,uiGridConstants,uiGridRowEditConstants,gridUtil){var service={initializeGrid:function(scope,grid){/**
           *  @ngdoc object
           *  @name ui.grid.rowEdit.api:PublicApi
           *
           *  @description Public Api for rowEdit feature
           */grid.rowEdit={};var publicApi={events:{rowEdit:{/**
                 * @ngdoc event
                 * @eventOf ui.grid.rowEdit.api:PublicApi
                 * @name saveRow
                 * @description raised when a row is ready for saving.  Once your
                 * row has saved you may need to use angular.extend to update the
                 * data entity with any changed data from your save (for example,
                 * lock version information if you're using optimistic locking,
                 * or last update time/user information).
                 *
                 * Your method should call setSavePromise somewhere in the body before
                 * returning control.  The feature will then wait, with the gridRow greyed out
                 * whilst this promise is being resolved.
                 *
                 * <pre>
                 *      gridApi.rowEdit.on.saveRow(scope,function(rowEntity) {})
                 * </pre>
                 * and somewhere within the event handler:
                 * <pre>
                 *      gridApi.rowEdit.setSavePromise( rowEntity, savePromise)
                 * </pre>
                 * @param {object} rowEntity the options.data element that was edited
                 * @returns {promise} Your saveRow method should return a promise, the
                 * promise should either be resolved (implying successful save), or
                 * rejected (implying an error).
                 */saveRow:function(rowEntity){}}},methods:{rowEdit:{/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name setSavePromise
                 * @description Sets the promise associated with the row save, mandatory that
                 * the saveRow event handler calls this method somewhere before returning.
                 * <pre>
                 *      gridApi.rowEdit.setSavePromise(rowEntity, savePromise)
                 * </pre>
                 * @param {object} rowEntity a data row from the grid for which a save has
                 * been initiated
                 * @param {promise} savePromise the promise that will be resolved when the
                 * save is successful, or rejected if the save fails
                 *
                 */setSavePromise:function(rowEntity,savePromise){service.setSavePromise(grid,rowEntity,savePromise);},/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name getDirtyRows
                 * @description Returns all currently dirty rows
                 * <pre>
                 *      gridApi.rowEdit.getDirtyRows(grid)
                 * </pre>
                 * @returns {array} An array of gridRows that are currently dirty
                 *
                 */getDirtyRows:function(){return grid.rowEdit.dirtyRows?grid.rowEdit.dirtyRows:[];},/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name getErrorRows
                 * @description Returns all currently errored rows
                 * <pre>
                 *      gridApi.rowEdit.getErrorRows(grid)
                 * </pre>
                 * @returns {array} An array of gridRows that are currently in error
                 *
                 */getErrorRows:function(){return grid.rowEdit.errorRows?grid.rowEdit.errorRows:[];},/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name flushDirtyRows
                 * @description Triggers a save event for all currently dirty rows, could
                 * be used where user presses a save button or navigates away from the page
                 * <pre>
                 *      gridApi.rowEdit.flushDirtyRows(grid)
                 * </pre>
                 * @returns {promise} a promise that represents the aggregate of all
                 * of the individual save promises - i.e. it will be resolved when all
                 * the individual save promises have been resolved.
                 *
                 */flushDirtyRows:function(){return service.flushDirtyRows(grid);},/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name setRowsDirty
                 * @description Sets each of the rows passed in dataRows
                 * to be dirty. Note that if you have only just inserted the
                 * rows into your data you will need to wait for a $digest cycle
                 * before the gridRows are present - so often you would wrap this
                 * call in a $interval or $timeout. Also, you must pass row.entity
                 * into this function rather than row objects themselves.
                 * <pre>
                 *      $interval( function() {
                 *        gridApi.rowEdit.setRowsDirty(myDataRows);
                 *      }, 0, 1);
                 * </pre>
                 * @param {array} dataRows the data entities for which the gridRows
                 * should be set dirty.
                 *
                 */setRowsDirty:function(dataRows){service.setRowsDirty(grid,dataRows);},/**
                 * @ngdoc method
                 * @methodOf ui.grid.rowEdit.api:PublicApi
                 * @name setRowsClean
                 * @description Sets each of the rows passed in dataRows
                 * to be clean, removing them from the dirty cache and the error cache,
                 * and clearing the error flag and the dirty flag
                 * <pre>
                 *      var gridRows = $scope.gridApi.rowEdit.getDirtyRows();
                 *      var dataRows = gridRows.map( function( gridRow ) { return gridRow.entity; });
                 *      $scope.gridApi.rowEdit.setRowsClean( dataRows );
                 * </pre>
                 * @param {array} dataRows the data entities for which the gridRows
                 * should be set clean.
                 *
                 */setRowsClean:function(dataRows){service.setRowsClean(grid,dataRows);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);grid.api.core.on.renderingComplete(scope,function(gridApi){grid.api.edit.on.afterCellEdit(scope,service.endEditCell);grid.api.edit.on.beginCellEdit(scope,service.beginEditCell);grid.api.edit.on.cancelCellEdit(scope,service.cancelEditCell);if(grid.api.cellNav){grid.api.cellNav.on.navigate(scope,service.navigate);}});},defaultGridOptions:function(gridOptions){/**
           *  @ngdoc object
           *  @name ui.grid.rowEdit.api:GridOptions
           *
           *  @description Options for configuring the rowEdit feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name saveRow
         * @description  Returns a function that saves the specified row from the grid,
         * and returns a promise
         * @param {object} grid the grid for which dirty rows should be flushed
         * @param {GridRow} gridRow the row that should be saved
         * @returns {function} the saveRow function returns a function.  That function
         * in turn, when called, returns a promise relating to the save callback
         */saveRow:function(grid,gridRow){var self=this;return function(){gridRow.isSaving=true;if(gridRow.rowEditSavePromise){// don't save the row again if it's already saving - that causes stale object exceptions
return gridRow.rowEditSavePromise;}var promise=grid.api.rowEdit.raise.saveRow(gridRow.entity);if(gridRow.rowEditSavePromise){gridRow.rowEditSavePromise.then(self.processSuccessPromise(grid,gridRow),self.processErrorPromise(grid,gridRow));}else{gridUtil.logError('A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise');}return promise;};},/**
         * @ngdoc method
         * @methodOf  ui.grid.rowEdit.service:uiGridRowEditService
         * @name setSavePromise
         * @description Sets the promise associated with the row save, mandatory that
         * the saveRow event handler calls this method somewhere before returning.
         * <pre>
         *      gridApi.rowEdit.setSavePromise(grid, rowEntity)
         * </pre>
         * @param {object} grid the grid for which dirty rows should be returned
         * @param {object} rowEntity a data row from the grid for which a save has
         * been initiated
         * @param {promise} savePromise the promise that will be resolved when the
         * save is successful, or rejected if the save fails
         *
         */setSavePromise:function(grid,rowEntity,savePromise){var gridRow=grid.getRow(rowEntity);gridRow.rowEditSavePromise=savePromise;},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name processSuccessPromise
         * @description  Returns a function that processes the successful
         * resolution of a save promise
         * @param {object} grid the grid for which the promise should be processed
         * @param {GridRow} gridRow the row that has been saved
         * @returns {function} the success handling function
         */processSuccessPromise:function(grid,gridRow){var self=this;return function(){delete gridRow.isSaving;delete gridRow.isDirty;delete gridRow.isError;delete gridRow.rowEditSaveTimer;delete gridRow.rowEditSavePromise;self.removeRow(grid.rowEdit.errorRows,gridRow);self.removeRow(grid.rowEdit.dirtyRows,gridRow);};},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name processErrorPromise
         * @description  Returns a function that processes the failed
         * resolution of a save promise
         * @param {object} grid the grid for which the promise should be processed
         * @param {GridRow} gridRow the row that is now in error
         * @returns {function} the error handling function
         */processErrorPromise:function(grid,gridRow){return function(){delete gridRow.isSaving;delete gridRow.rowEditSaveTimer;delete gridRow.rowEditSavePromise;gridRow.isError=true;if(!grid.rowEdit.errorRows){grid.rowEdit.errorRows=[];}if(!service.isRowPresent(grid.rowEdit.errorRows,gridRow)){grid.rowEdit.errorRows.push(gridRow);}};},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name removeRow
         * @description  Removes a row from a cache of rows - either
         * grid.rowEdit.errorRows or grid.rowEdit.dirtyRows.  If the row
         * is not present silently does nothing.
         * @param {array} rowArray the array from which to remove the row
         * @param {GridRow} gridRow the row that should be removed
         */removeRow:function(rowArray,removeGridRow){if(typeof rowArray==='undefined'||rowArray===null){return;}rowArray.forEach(function(gridRow,index){if(gridRow.uid===removeGridRow.uid){rowArray.splice(index,1);}});},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name isRowPresent
         * @description  Checks whether a row is already present
         * in the given array
         * @param {array} rowArray the array in which to look for the row
         * @param {GridRow} gridRow the row that should be looked for
         */isRowPresent:function(rowArray,removeGridRow){var present=false;rowArray.forEach(function(gridRow,index){if(gridRow.uid===removeGridRow.uid){present=true;}});return present;},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name flushDirtyRows
         * @description Triggers a save event for all currently dirty rows, could
         * be used where user presses a save button or navigates away from the page
         * <pre>
         *      gridApi.rowEdit.flushDirtyRows(grid)
         * </pre>
         * @param {object} grid the grid for which dirty rows should be flushed
         * @returns {promise} a promise that represents the aggregate of all
         * of the individual save promises - i.e. it will be resolved when all
         * the individual save promises have been resolved.
         *
         */flushDirtyRows:function(grid){var promises=[];grid.api.rowEdit.getDirtyRows().forEach(function(gridRow){service.cancelTimer(grid,gridRow);service.saveRow(grid,gridRow)();promises.push(gridRow.rowEditSavePromise);});return $q.all(promises);},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name endEditCell
         * @description Receives an afterCellEdit event from the edit function,
         * and sets flags as appropriate.  Only the rowEntity parameter
         * is processed, although other params are available.  Grid
         * is automatically provided by the gridApi.
         * @param {object} rowEntity the data entity for which the cell
         * was edited
         */endEditCell:function(rowEntity,colDef,newValue,previousValue){var grid=this.grid;var gridRow=grid.getRow(rowEntity);if(!gridRow){gridUtil.logError('Unable to find rowEntity in grid data, dirty flag cannot be set');return;}if(newValue!==previousValue||gridRow.isDirty){if(!grid.rowEdit.dirtyRows){grid.rowEdit.dirtyRows=[];}if(!gridRow.isDirty){gridRow.isDirty=true;grid.rowEdit.dirtyRows.push(gridRow);}delete gridRow.isError;service.considerSetTimer(grid,gridRow);}},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name beginEditCell
         * @description Receives a beginCellEdit event from the edit function,
         * and cancels any rowEditSaveTimers if present, as the user is still editing
         * this row.  Only the rowEntity parameter
         * is processed, although other params are available.  Grid
         * is automatically provided by the gridApi.
         * @param {object} rowEntity the data entity for which the cell
         * editing has commenced
         */beginEditCell:function(rowEntity,colDef){var grid=this.grid;var gridRow=grid.getRow(rowEntity);if(!gridRow){gridUtil.logError('Unable to find rowEntity in grid data, timer cannot be cancelled');return;}service.cancelTimer(grid,gridRow);},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name cancelEditCell
         * @description Receives a cancelCellEdit event from the edit function,
         * and if the row was already dirty, restarts the save timer.  If the row
         * was not already dirty, then it's not dirty now either and does nothing.
         *
         * Only the rowEntity parameter
         * is processed, although other params are available.  Grid
         * is automatically provided by the gridApi.
         *
         * @param {object} rowEntity the data entity for which the cell
         * editing was cancelled
         */cancelEditCell:function(rowEntity,colDef){var grid=this.grid;var gridRow=grid.getRow(rowEntity);if(!gridRow){gridUtil.logError('Unable to find rowEntity in grid data, timer cannot be set');return;}service.considerSetTimer(grid,gridRow);},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name navigate
         * @description cellNav tells us that the selected cell has changed.  If
         * the new row had a timer running, then stop it similar to in a beginCellEdit
         * call.  If the old row is dirty and not the same as the new row, then
         * start a timer on it.
         * @param {object} newRowCol the row and column that were selected
         * @param {object} oldRowCol the row and column that was left
         *
         */navigate:function(newRowCol,oldRowCol){var grid=this.grid;if(newRowCol.row.rowEditSaveTimer){service.cancelTimer(grid,newRowCol.row);}if(oldRowCol&&oldRowCol.row&&oldRowCol.row!==newRowCol.row){service.considerSetTimer(grid,oldRowCol.row);}},/**
         * @ngdoc property
         * @propertyOf ui.grid.rowEdit.api:GridOptions
         * @name rowEditWaitInterval
         * @description How long the grid should wait for another change on this row
         * before triggering a save (in milliseconds).  If set to -1, then saves are
         * never triggered by timer (implying that the user will call flushDirtyRows()
         * manually)
         *
         * @example
         * Setting the wait interval to 4 seconds
         * <pre>
         *   $scope.gridOptions = { rowEditWaitInterval: 4000 }
         * </pre>
         *
         */ /**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name considerSetTimer
         * @description Consider setting a timer on this row (if it is dirty).  if there is a timer running
         * on the row and the row isn't currently saving, cancel it, using cancelTimer, then if the row is
         * dirty and not currently saving then set a new timer
         * @param {object} grid the grid for which we are processing
         * @param {GridRow} gridRow the row for which the timer should be adjusted
         *
         */considerSetTimer:function(grid,gridRow){service.cancelTimer(grid,gridRow);if(gridRow.isDirty&&!gridRow.isSaving){if(grid.options.rowEditWaitInterval!==-1){var waitTime=grid.options.rowEditWaitInterval?grid.options.rowEditWaitInterval:2000;gridRow.rowEditSaveTimer=$interval(service.saveRow(grid,gridRow),waitTime,1);}}},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name cancelTimer
         * @description cancel the $interval for any timer running on this row
         * then delete the timer itself
         * @param {object} grid the grid for which we are processing
         * @param {GridRow} gridRow the row for which the timer should be adjusted
         *
         */cancelTimer:function(grid,gridRow){if(gridRow.rowEditSaveTimer&&!gridRow.isSaving){$interval.cancel(gridRow.rowEditSaveTimer);delete gridRow.rowEditSaveTimer;}},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name setRowsDirty
         * @description Sets each of the rows passed in dataRows
         * to be dirty.  note that if you have only just inserted the
         * rows into your data you will need to wait for a $digest cycle
         * before the gridRows are present - so often you would wrap this
         * call in a $interval or $timeout
         * <pre>
         *      $interval( function() {
         *        gridApi.rowEdit.setRowsDirty( myDataRows);
         *      }, 0, 1);
         * </pre>
         * @param {object} grid the grid for which rows should be set dirty
         * @param {array} dataRows the data entities for which the gridRows
         * should be set dirty.
         *
         */setRowsDirty:function(grid,myDataRows){var gridRow;myDataRows.forEach(function(value,index){gridRow=grid.getRow(value);if(gridRow){if(!grid.rowEdit.dirtyRows){grid.rowEdit.dirtyRows=[];}if(!gridRow.isDirty){gridRow.isDirty=true;grid.rowEdit.dirtyRows.push(gridRow);}delete gridRow.isError;service.considerSetTimer(grid,gridRow);}else{gridUtil.logError("requested row not found in rowEdit.setRowsDirty, row was: "+value);}});},/**
         * @ngdoc method
         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
         * @name setRowsClean
         * @description Sets each of the rows passed in dataRows
         * to be clean, clearing the dirty flag and the error flag, and removing
         * the rows from the dirty and error caches.
         * @param {object} grid the grid for which rows should be set clean
         * @param {array} dataRows the data entities for which the gridRows
         * should be set clean.
         *
         */setRowsClean:function(grid,myDataRows){var gridRow;myDataRows.forEach(function(value,index){gridRow=grid.getRow(value);if(gridRow){delete gridRow.isDirty;service.removeRow(grid.rowEdit.dirtyRows,gridRow);service.cancelTimer(grid,gridRow);delete gridRow.isError;service.removeRow(grid.rowEdit.errorRows,gridRow);}else{gridUtil.logError("requested row not found in rowEdit.setRowsClean, row was: "+value);}});}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.rowEdit.directive:uiGridEdit
   *  @element div
   *  @restrict A
   *
   *  @description Adds row editing features to the ui-grid-edit directive.
   *
   */module.directive('uiGridRowEdit',['gridUtil','uiGridRowEditService','uiGridEditConstants',function(gridUtil,uiGridRowEditService,uiGridEditConstants){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridRowEditService.initializeGrid($scope,uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.rowEdit.directive:uiGridViewport
   *  @element div
   *
   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
   *  for the grid row to allow coloring of saving and error rows
   */module.directive('uiGridViewport',['$compile','uiGridConstants','gridUtil','$parse',function($compile,uiGridConstants,gridUtil,$parse){return{priority:-200,// run after default  directive
scope:false,compile:function($elm,$attrs){var rowRepeatDiv=angular.element($elm.children().children()[0]);var existingNgClass=rowRepeatDiv.attr("ng-class");var newNgClass='';if(existingNgClass){newNgClass=existingNgClass.slice(0,-1)+", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";}else{newNgClass="{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";}rowRepeatDiv.attr("ng-class",newNgClass);return{pre:function($scope,$elm,$attrs,controllers){},post:function($scope,$elm,$attrs,controllers){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.saveState
   * @description
   *
   * # ui.grid.saveState
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * This module provides the ability to save the grid state, and restore
   * it when the user returns to the page.
   *
   * No UI is provided, the caller should provide their own UI/buttons
   * as appropriate. Usually the navigate events would be used to save
   * the grid state and restore it.
   *
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.save-state"></div>
   */var module=angular.module('ui.grid.saveState',['ui.grid','ui.grid.selection','ui.grid.cellNav','ui.grid.grouping','ui.grid.pinning','ui.grid.treeView']);/**
   *  @ngdoc object
   *  @name ui.grid.saveState.constant:uiGridSaveStateConstants
   *
   *  @description constants available in save state module
   */module.constant('uiGridSaveStateConstants',{featureName:'saveState'});/**
   *  @ngdoc service
   *  @name ui.grid.saveState.service:uiGridSaveStateService
   *
   *  @description Services for saveState feature
   */module.service('uiGridSaveStateService',function(){var service={initializeGrid:function(grid){// add feature namespace and any properties to grid for needed state
grid.saveState={};this.defaultGridOptions(grid.options);/**
           *  @ngdoc object
           *  @name ui.grid.saveState.api:PublicApi
           *
           *  @description Public Api for saveState feature
           */var publicApi={events:{saveState:{}},methods:{saveState:{/**
                 * @ngdoc function
                 * @name save
                 * @methodOf  ui.grid.saveState.api:PublicApi
                 * @description Packages the current state of the grid into
                 * an object, and provides it to the user for saving
                 * @returns {object} the state as a javascript object that can be saved
                 */save:function(){return service.save(grid);},/**
                 * @ngdoc function
                 * @name restore
                 * @methodOf  ui.grid.saveState.api:PublicApi
                 * @description Restores the provided state into the grid
                 * @param {scope} $scope a scope that we can broadcast on
                 * @param {object} state the state that should be restored into the grid
                 * @returns {object} the promise created by refresh
                 */restore:function($scope,state){return service.restore(grid,$scope,state);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
           * @ngdoc object
           * @name ui.grid.saveState.api:GridOptions
           *
           * @description GridOptions for saveState feature, these are available to be
           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           * @ngdoc object
           * @name saveWidths
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the current column widths.  Note that unless
           * you've provided the user with some way to resize their columns (say
           * the resize columns feature), then this makes little sense.
           * <br/>Defaults to true
           */gridOptions.saveWidths=gridOptions.saveWidths!==false;/**
           * @ngdoc object
           * @name saveOrder
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Restore the current column order.  Note that unless
           * you've provided the user with some way to reorder their columns (for
           * example the move columns feature), this makes little sense.
           * <br/>Defaults to true
           */gridOptions.saveOrder=gridOptions.saveOrder!==false;/**
           * @ngdoc object
           * @name saveScroll
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the current scroll position.  Note that this
           * is saved as the percentage of the grid scrolled - so if your
           * user returns to a grid with a significantly different number of
           * rows (perhaps some data has been deleted) then the scroll won't
           * actually show the same rows as before.  If you want to scroll to
           * a specific row then you should instead use the saveFocus option, which
           * is the default.
           *
           * Note that this element will only be saved if the cellNav feature is
           * enabled
           * <br/>Defaults to false
           */gridOptions.saveScroll=gridOptions.saveScroll===true;/**
           * @ngdoc object
           * @name saveFocus
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the current focused cell.  On returning
           * to this focused cell we'll also scroll.  This option is
           * preferred to the saveScroll option, so is set to true by
           * default.  If saveScroll is set to true then this option will
           * be disabled.
           *
           * By default this option saves the current row number and column
           * number, and returns to that row and column.  However, if you define
           * a saveRowIdentity function, then it will return you to the currently
           * selected column within that row (in a business sense - so if some
           * rows have been deleted, it will still find the same data, presuming it
           * still exists in the list.  If it isn't in the list then it will instead
           * return to the same row number - i.e. scroll percentage)
           *
           * Note that this option will do nothing if the cellNav
           * feature is not enabled.
           *
           * <br/>Defaults to true (unless saveScroll is true)
           */gridOptions.saveFocus=gridOptions.saveScroll!==true&&gridOptions.saveFocus!==false;/**
           * @ngdoc object
           * @name saveRowIdentity
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description A function that can be called, passing in a rowEntity,
           * and that will return a unique id for that row.  This might simply
           * return the `id` field from that row (if you have one), or it might
           * concatenate some fields within the row to make a unique value.
           *
           * This value will be used to find the same row again and set the focus
           * to it, if it exists when we return.
           *
           * <br/>Defaults to undefined
           */ /**
           * @ngdoc object
           * @name saveVisible
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save whether or not columns are visible.
           *
           * <br/>Defaults to true
           */gridOptions.saveVisible=gridOptions.saveVisible!==false;/**
           * @ngdoc object
           * @name saveSort
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the current sort state for each column
           *
           * <br/>Defaults to true
           */gridOptions.saveSort=gridOptions.saveSort!==false;/**
           * @ngdoc object
           * @name saveFilter
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the current filter state for each column
           *
           * <br/>Defaults to true
           */gridOptions.saveFilter=gridOptions.saveFilter!==false;/**
           * @ngdoc object
           * @name saveSelection
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the currently selected rows.  If the `saveRowIdentity` callback
           * is defined, then it will save the id of the row and select that.  If not, then
           * it will attempt to select the rows by row number, which will give the wrong results
           * if the data set has changed in the mean-time.
           *
           * Note that this option only does anything
           * if the selection feature is enabled.
           *
           * <br/>Defaults to true
           */gridOptions.saveSelection=gridOptions.saveSelection!==false;/**
           * @ngdoc object
           * @name saveGrouping
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the grouping configuration.  If set to true and the
           * grouping feature is not enabled then does nothing.
           *
           * <br/>Defaults to true
           */gridOptions.saveGrouping=gridOptions.saveGrouping!==false;/**
           * @ngdoc object
           * @name saveGroupingExpandedStates
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the grouping row expanded states.  If set to true and the
           * grouping feature is not enabled then does nothing.
           *
           * This can be quite a bit of data, in many cases you wouldn't want to save this
           * information.
           *
           * <br/>Defaults to false
           */gridOptions.saveGroupingExpandedStates=gridOptions.saveGroupingExpandedStates===true;/**
           * @ngdoc object
           * @name savePinning
           * @propertyOf ui.grid.saveState.api:GridOptions
           * @description Save pinning state for columns.
           *
           * <br/>Defaults to true
           */gridOptions.savePinning=gridOptions.savePinning!==false;/**
           * @ngdoc object
           * @name saveTreeView
           * @propertyOf  ui.grid.saveState.api:GridOptions
           * @description Save the treeView configuration.  If set to true and the
           * treeView feature is not enabled then does nothing.
           *
           * <br/>Defaults to true
           */gridOptions.saveTreeView=gridOptions.saveTreeView!==false;},/**
         * @ngdoc function
         * @name save
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the current grid state into an object, and
         * passes that object back to the caller
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {object} the state ready to be saved
         */save:function(grid){var savedState={};savedState.columns=service.saveColumns(grid);savedState.scrollFocus=service.saveScrollFocus(grid);savedState.selection=service.saveSelection(grid);savedState.grouping=service.saveGrouping(grid);savedState.treeView=service.saveTreeView(grid);savedState.pagination=service.savePagination(grid);return savedState;},/**
         * @ngdoc function
         * @name restore
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Applies the provided state to the grid
         *
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {scope} $scope a scope that we can broadcast on
         * @param {object} state the state we'd like to restore
         * @returns {object} the promise created by refresh
         */restore:function(grid,$scope,state){if(state.columns){service.restoreColumns(grid,state.columns);}if(state.scrollFocus){service.restoreScrollFocus(grid,$scope,state.scrollFocus);}if(state.selection){service.restoreSelection(grid,state.selection);}if(state.grouping){service.restoreGrouping(grid,state.grouping);}if(state.treeView){service.restoreTreeView(grid,state.treeView);}if(state.pagination){service.restorePagination(grid,state.pagination);}return grid.refresh();},/**
         * @ngdoc function
         * @name saveColumns
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the column setup, including sort, filters, ordering,
         * pinning and column widths.
         *
         * Works through the current columns, storing them in order.  Stores the
         * column name, then the visible flag, width, sort and filters for each column.
         *
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {array} the columns state ready to be saved
         */saveColumns:function(grid){var columns=[];grid.getOnlyDataColumns().forEach(function(column){var savedColumn={};savedColumn.name=column.name;if(grid.options.saveVisible){savedColumn.visible=column.visible;}if(grid.options.saveWidths){savedColumn.width=column.width;}// these two must be copied, not just pointed too - otherwise our saved state is pointing to the same object as current state
if(grid.options.saveSort){savedColumn.sort=angular.copy(column.sort);}if(grid.options.saveFilter){savedColumn.filters=[];column.filters.forEach(function(filter){var copiedFilter={};angular.forEach(filter,function(value,key){if(key!=='condition'&&key!=='$$hashKey'&&key!=='placeholder'){copiedFilter[key]=value;}});savedColumn.filters.push(copiedFilter);});}if(!!grid.api.pinning&&grid.options.savePinning){savedColumn.pinned=column.renderContainer?column.renderContainer:'';}columns.push(savedColumn);});return columns;},/**
         * @ngdoc function
         * @name saveScrollFocus
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the currently scroll or focus.
         *
         * If cellNav isn't present then does nothing - we can't return
         * to the scroll position without cellNav anyway.
         *
         * If the cellNav module is present, and saveFocus is true, then
         * it saves the currently focused cell.  If rowIdentity is present
         * then saves using rowIdentity, otherwise saves visibleRowNum.
         *
         * If the cellNav module is not present, and saveScroll is true, then
         * it approximates the current scroll row and column, and saves that.
         *
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {object} the selection state ready to be saved
         */saveScrollFocus:function(grid){if(!grid.api.cellNav){return{};}var scrollFocus={};if(grid.options.saveFocus){scrollFocus.focus=true;var rowCol=grid.api.cellNav.getFocusedCell();if(rowCol!==null){if(rowCol.col!==null){scrollFocus.colName=rowCol.col.colDef.name;}if(rowCol.row!==null){scrollFocus.rowVal=service.getRowVal(grid,rowCol.row);}}}if(grid.options.saveScroll||grid.options.saveFocus&&!scrollFocus.colName&&!scrollFocus.rowVal){scrollFocus.focus=false;if(grid.renderContainers.body.prevRowScrollIndex){scrollFocus.rowVal=service.getRowVal(grid,grid.renderContainers.body.visibleRowCache[grid.renderContainers.body.prevRowScrollIndex]);}if(grid.renderContainers.body.prevColScrollIndex){scrollFocus.colName=grid.renderContainers.body.visibleColumnCache[grid.renderContainers.body.prevColScrollIndex].name;}}return scrollFocus;},/**
         * @ngdoc function
         * @name saveSelection
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the currently selected rows, if the selection feature is enabled
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {array} the selection state ready to be saved
         */saveSelection:function(grid){if(!grid.api.selection||!grid.options.saveSelection){return[];}return grid.api.selection.getSelectedGridRows().map(function(gridRow){return service.getRowVal(grid,gridRow);});},/**
         * @ngdoc function
         * @name saveGrouping
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the grouping state, if the grouping feature is enabled
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {object} the grouping state ready to be saved
         */saveGrouping:function(grid){if(!grid.api.grouping||!grid.options.saveGrouping){return{};}return grid.api.grouping.getGrouping(grid.options.saveGroupingExpandedStates);},/**
         * @ngdoc function
         * @name savePagination
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the pagination state, if the pagination feature is enabled
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {object} the pagination state ready to be saved
         */savePagination:function(grid){if(!grid.api.pagination||!grid.options.paginationPageSize){return{};}return{paginationCurrentPage:grid.options.paginationCurrentPage,paginationPageSize:grid.options.paginationPageSize};},/**
         * @ngdoc function
         * @name saveTreeView
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Saves the tree view state, if the tree feature is enabled
         * @param {Grid} grid the grid whose state we'd like to save
         * @returns {object} the tree view state ready to be saved
         */saveTreeView:function(grid){if(!grid.api.treeView||!grid.options.saveTreeView){return{};}return grid.api.treeView.getTreeView();},/**
         * @ngdoc function
         * @name getRowVal
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Helper function that gets either the rowNum or
         * the saveRowIdentity, given a gridRow
         * @param {Grid} grid the grid the row is in
         * @param {GridRow} gridRow the row we want the rowNum for
         * @returns {object} an object containing { identity: true/false, row: rowNumber/rowIdentity }
         *
         */getRowVal:function(grid,gridRow){if(!gridRow){return null;}var rowVal={};if(grid.options.saveRowIdentity){rowVal.identity=true;rowVal.row=grid.options.saveRowIdentity(gridRow.entity);}else{rowVal.identity=false;rowVal.row=grid.renderContainers.body.visibleRowCache.indexOf(gridRow);}return rowVal;},/**
         * @ngdoc function
         * @name restoreColumns
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Restores the columns, including order, visible, width,
         * pinning, sort and filters.
         *
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} columnsState the list of columns we had before, with their state
         */restoreColumns:function(grid,columnsState){var isSortChanged=false;columnsState.forEach(function(columnState,index){var currentCol=grid.getColumn(columnState.name);if(currentCol&&!grid.isRowHeaderColumn(currentCol)){if(grid.options.saveVisible&&(currentCol.visible!==columnState.visible||currentCol.colDef.visible!==columnState.visible)){currentCol.visible=columnState.visible;currentCol.colDef.visible=columnState.visible;grid.api.core.raise.columnVisibilityChanged(currentCol);}if(grid.options.saveWidths&&currentCol.width!==columnState.width){currentCol.width=columnState.width;currentCol.hasCustomWidth=true;}if(grid.options.saveSort&&!angular.equals(currentCol.sort,columnState.sort)&&!(currentCol.sort===undefined&&angular.isEmpty(columnState.sort))){currentCol.sort=angular.copy(columnState.sort);isSortChanged=true;}if(grid.options.saveFilter&&!angular.equals(currentCol.filters,columnState.filters)){columnState.filters.forEach(function(filter,index){angular.extend(currentCol.filters[index],filter);if(typeof filter.term==='undefined'||filter.term===null){delete currentCol.filters[index].term;}});grid.api.core.raise.filterChanged(currentCol);}if(!!grid.api.pinning&&grid.options.savePinning&&currentCol.renderContainer!==columnState.pinned){grid.api.pinning.pinColumn(currentCol,columnState.pinned);}var currentIndex=grid.getOnlyDataColumns().indexOf(currentCol);if(currentIndex!==-1){if(grid.options.saveOrder&&currentIndex!==index){var column=grid.columns.splice(currentIndex+grid.rowHeaderColumns.length,1)[0];grid.columns.splice(index+grid.rowHeaderColumns.length,0,column);}}}});if(isSortChanged){grid.api.core.raise.sortChanged(grid,grid.getColumnSorting());}},/**
         * @ngdoc function
         * @name restoreScrollFocus
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Scrolls to the position that was saved.  If focus is true, then
         * sets focus to the specified row/col.  If focus is false, then scrolls to the
         * specified row/col.
         *
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {scope} $scope a scope that we can broadcast on
         * @param {object} scrollFocusState the scroll/focus state ready to be restored
         */restoreScrollFocus:function(grid,$scope,scrollFocusState){if(!grid.api.cellNav){return;}var colDef,row;if(scrollFocusState.colName){var colDefs=grid.options.columnDefs.filter(function(colDef){return colDef.name===scrollFocusState.colName;});if(colDefs.length>0){colDef=colDefs[0];}}if(scrollFocusState.rowVal&&scrollFocusState.rowVal.row){if(scrollFocusState.rowVal.identity){row=service.findRowByIdentity(grid,scrollFocusState.rowVal);}else{row=grid.renderContainers.body.visibleRowCache[scrollFocusState.rowVal.row];}}var entity=row&&row.entity?row.entity:null;if(colDef||entity){if(scrollFocusState.focus){grid.api.cellNav.scrollToFocus(entity,colDef);}else{grid.scrollTo(entity,colDef);}}},/**
         * @ngdoc function
         * @name restoreSelection
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Selects the rows that are provided in the selection
         * state.  If you are using `saveRowIdentity` and more than one row matches the identity
         * function then only the first is selected.
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} selectionState the selection state ready to be restored
         */restoreSelection:function(grid,selectionState){if(!grid.api.selection){return;}grid.api.selection.clearSelectedRows();selectionState.forEach(function(rowVal){if(rowVal.identity){var foundRow=service.findRowByIdentity(grid,rowVal);if(foundRow){grid.api.selection.selectRow(foundRow.entity);}}else{grid.api.selection.selectRowByVisibleIndex(rowVal.row);}});},/**
         * @ngdoc function
         * @name restoreGrouping
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Restores the grouping configuration, if the grouping feature
         * is enabled.
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} groupingState the grouping state ready to be restored
         */restoreGrouping:function(grid,groupingState){if(!grid.api.grouping||typeof groupingState==='undefined'||groupingState===null||angular.equals(groupingState,{})){return;}grid.api.grouping.setGrouping(groupingState);},/**
         * @ngdoc function
         * @name restoreTreeView
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Restores the tree view configuration, if the tree view feature
         * is enabled.
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} treeViewState the tree view state ready to be restored
         */restoreTreeView:function(grid,treeViewState){if(!grid.api.treeView||typeof treeViewState==='undefined'||treeViewState===null||angular.equals(treeViewState,{})){return;}grid.api.treeView.setTreeView(treeViewState);},/**
         * @ngdoc function
         * @name restorePagination
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Restores the pagination information, if pagination is enabled.
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} pagination the pagination object to be restored
         * @param {number} pagination.paginationCurrentPage the page number to restore
         * @param {number} pagination.paginationPageSize the number of items displayed per page
         */restorePagination:function(grid,pagination){if(!grid.api.pagination||!grid.options.paginationPageSize){return;}grid.options.paginationCurrentPage=pagination.paginationCurrentPage;grid.options.paginationPageSize=pagination.paginationPageSize;},/**
         * @ngdoc function
         * @name findRowByIdentity
         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
         * @description Finds a row given it's identity value, returns the first found row
         * if any are found, otherwise returns null if no rows are found.
         * @param {Grid} grid the grid whose state we'd like to restore
         * @param {object} rowVal the row we'd like to find
         * @returns {gridRow} the found row, or null if none found
         */findRowByIdentity:function(grid,rowVal){if(!grid.options.saveRowIdentity){return null;}var filteredRows=grid.rows.filter(function(gridRow){return grid.options.saveRowIdentity(gridRow.entity)===rowVal.row;});if(filteredRows.length>0){return filteredRows[0];}else{return null;}}};return service;});/**
   *  @ngdoc directive
   *  @name ui.grid.saveState.directive:uiGridSaveState
   *  @element div
   *  @restrict A
   *
   *  @description Adds saveState features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.saveState']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
        { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.gridOptions = {
        columnDefs: [
          {name: 'name'},
          {name: 'title', enableCellEdit: true}
        ],
        data: $scope.data
      };
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="gridOptions" ui-grid-save-state></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridSaveState',['uiGridSaveStateConstants','uiGridSaveStateService','gridUtil','$compile',function(uiGridSaveStateConstants,uiGridSaveStateService,gridUtil,$compile){return{replace:true,priority:0,require:'^uiGrid',scope:false,link:function($scope,$elm,$attrs,uiGridCtrl){uiGridSaveStateService.initializeGrid(uiGridCtrl.grid);}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.selection
   * @description
   *
   * # ui.grid.selection
   * This module provides row selection
   *
   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
   *
   * <div doc-module-components="ui.grid.selection"></div>
   */var module=angular.module('ui.grid.selection',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.selection.constant:uiGridSelectionConstants
   *
   *  @description constants available in selection module
   */module.constant('uiGridSelectionConstants',{featureName:'selection',selectionRowHeaderColName:'selectionRowHeaderCol'});// add methods to GridRow
angular.module('ui.grid').config(['$provide',function($provide){$provide.decorator('GridRow',['$delegate',function($delegate){/**
       *  @ngdoc object
       *  @name ui.grid.selection.api:GridRow
       *
       *  @description GridRow prototype functions added for selection
       */ /**
       *  @ngdoc object
       *  @name enableSelection
       *  @propertyOf  ui.grid.selection.api:GridRow
       *  @description Enable row selection for this row, only settable by internal code.
       *
       *  The grouping feature, for example, might set group header rows to not be selectable.
       *  <br/>Defaults to true
       */ /**
       *  @ngdoc object
       *  @name isSelected
       *  @propertyOf  ui.grid.selection.api:GridRow
       *  @description Selected state of row. Should be readonly. Make any changes to selected state using setSelected().
       *  <br/>Defaults to false
       */ /**
       *  @ngdoc object
       *  @name isFocused
       *  @propertyOf  ui.grid.selection.api:GridRow
       *  @description Focused state of row. Should be readonly. Make any changes to focused state using setFocused().
       *  <br/>Defaults to false
       */ /**
       * @ngdoc function
       * @name setSelected
       * @methodOf ui.grid.selection.api:GridRow
       * @description Sets the isSelected property and updates the selectedCount
       * Changes to isSelected state should only be made via this function
       * @param {Boolean} selected value to set
       */$delegate.prototype.setSelected=function(selected){if(selected!==this.isSelected){this.isSelected=selected;this.grid.selection.selectedCount+=selected?1:-1;}};/**
       * @ngdoc function
       * @name setFocused
       * @methodOf ui.grid.selection.api:GridRow
       * @description Sets the isFocused property
       * Changes to isFocused state should only be made via this function
       * @param {Boolean} val value to set
       */$delegate.prototype.setFocused=function(val){if(val!==this.isFocused){this.grid.selection.focusedRow&&(this.grid.selection.focusedRow.isFocused=false);this.grid.selection.focusedRow=val?this:null;this.isFocused=val;}};return $delegate;}]);}]);/**
   *  @ngdoc service
   *  @name ui.grid.selection.service:uiGridSelectionService
   *
   *  @description Services for selection features
   */module.service('uiGridSelectionService',function(){var service={initializeGrid:function(grid){// add feature namespace and any properties to grid for needed
/**
           *  @ngdoc object
           *  @name ui.grid.selection.grid:selection
           *
           *  @description Grid properties and functions added for selection
           */grid.selection={lastSelectedRow:null,/**
             *  @ngdoc object
             *  @name focusedRow
             *  @propertyOf  ui.grid.selection.grid:selection
             *  @description Focused row.
             */focusedRow:null,selectAll:false};/**
           *  @ngdoc object
           *  @name selectedCount
           *  @propertyOf  ui.grid.selection.grid:selection
           *  @description Current count of selected rows
           *  @example
           *  var count = grid.selection.selectedCount
           */grid.selection.selectedCount=0;service.defaultGridOptions(grid.options);/**
           *  @ngdoc object
           *  @name ui.grid.selection.api:PublicApi
           *
           *  @description Public Api for selection feature
           */var publicApi={events:{selection:{/**
                 * @ngdoc event
                 * @name rowFocusChanged
                 * @eventOf  ui.grid.selection.api:PublicApi
                 * @description  is raised after the row.isFocused state is changed
                 * @param {object} scope the scope associated with the grid
                 * @param {GridRow} row the row that was focused/unfocused
                 * @param {Event} evt object if raised from an event
                 */rowFocusChanged:function(scope,row,evt){},/**
                 * @ngdoc event
                 * @name rowSelectionChanged
                 * @eventOf  ui.grid.selection.api:PublicApi
                 * @description  is raised after the row.isSelected state is changed
                 * @param {object} scope the scope associated with the grid
                 * @param {GridRow} row the row that was selected/deselected
                 * @param {Event} evt object if raised from an event
                 */rowSelectionChanged:function(scope,row,evt){},/**
                 * @ngdoc event
                 * @name rowSelectionChangedBatch
                 * @eventOf  ui.grid.selection.api:PublicApi
                 * @description  is raised after the row.isSelected state is changed
                 * in bulk, if the `enableSelectionBatchEvent` option is set to true
                 * (which it is by default).  This allows more efficient processing
                 * of bulk events.
                 * @param {object} scope the scope associated with the grid
                 * @param {array} rows the rows that were selected/deselected
                 * @param {Event} evt object if raised from an event
                 */rowSelectionChangedBatch:function(scope,rows,evt){}}},methods:{selection:{/**
                 * @ngdoc function
                 * @name toggleRowSelection
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Toggles data row as selected or unselected
                 * @param {object} rowEntity gridOptions.data[] array instance
                 * @param {Event} evt object if raised from an event
                 */toggleRowSelection:function(rowEntity,evt){var row=grid.getRow(rowEntity);if(row!=void 0&&row!==null){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,true);}},/**
                 * @ngdoc function
                 * @name selectRow
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Select the data row
                 * @param {object} rowEntity gridOptions.data[] array instance
                 * @param {Event} evt object if raised from an event
                 */selectRow:function(rowEntity,evt){var row=grid.getRow(rowEntity);if(row!=void 0&&row!==null&&!row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,true);}},/**
                 * @ngdoc function
                 * @name selectRowByVisibleIndex
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Select the specified row by visible index (i.e. if you
                 * specify row 0 you'll get the first visible row selected).  In this context
                 * visible means of those rows that are theoretically visible (i.e. not filtered),
                 * rather than rows currently rendered on the screen.
                 * @param {number} rowNum index within the rowsVisible array
                 * @param {Event} evt object if raised from an event
                 */selectRowByVisibleIndex:function(rowNum,evt){var row=grid.renderContainers.body.visibleRowCache[rowNum];if(row!=void 0&&row!==null&&typeof row!=='undefined'&&!row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,false);}},/**
                 * @ngdoc function
                 * @name selectRowByKey
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description selects all GridRows who have an key that is equal to comparator
                 * so for Example if isInEntity == false then it does this check: row[key] === comparator
                 * if isInEntity == true then it does this check: row.entity[key] === comparator
                 * @param {boolean} isInEntity if true then key is in entity else it's directly in row
                 * @param {string | number} key the key to look for
                 * @param {any} comparator the value that key should have
                 * @param {Event} evt [optional] object if raised from an event
                 * @param {array} lookInRows [optional] the rows to look in - if not provided then looks in grid.rows
                */selectRowByKey:function(isInEntity,key,comparator,evt,lookInRows){var row=grid.findRowByKey(isInEntity,key,comparator,lookInRows);if(row!=void 0&&row!==null&&typeof row!=='undefined'&&!row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,false);}},/**
                 * @ngdoc function
                 * @name unSelectRow
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description UnSelect the data row
                 * @param {object} rowEntity gridOptions.data[] array instance
                 * @param {Event} evt object if raised from an event
                 */unSelectRow:function(rowEntity,evt){var row=grid.getRow(rowEntity);if(row!=void 0&&row!==null&&row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,true);}},/**
                 * @ngdoc function
                 * @name unSelectRowByVisibleIndex
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Unselect the specified row by visible index (i.e. if you
                 * specify row 0 you'll get the first visible row unselected).  In this context
                 * visible means of those rows that are theoretically visible (i.e. not filtered),
                 * rather than rows currently rendered on the screen.
                 * @param {number} rowNum index within the rowsVisible array
                 * @param {Event} evt object if raised from an event
                 */unSelectRowByVisibleIndex:function(rowNum,evt){var row=grid.renderContainers.body.visibleRowCache[rowNum];if(row!=void 0&&row!==null&&typeof row!=='undefined'&&row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,false);}},/**
                 * @ngdoc function
                 * @name unSelectRowByKey
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description unselects the GridRows who have an key that is equal to comparator
                 * so for Example if isInEntity == false then it does this check: row[key] === comparator
                 * if isInEntity == true then it does this check: row.entity[key] === comparator
                 * @param {boolean} isInEntity if true then key is in entity else it's directly in row
                 * @param {string | number} key the key to look for
                 * @param {any} comparator the value that key should have
                 * @param {Event} evt [optional] object if raised from an event
                 * @param {array} lookInRows [optional] the rows to look in - if not provided then looks in grid.rows
                */unSelectRowByKey:function(isInEntity,key,comparator,evt,lookInRows){var row=grid.findRowByKey(isInEntity,key,comparator,lookInRows);if(row!=void 0&&row!==null&&typeof row!=='undefined'&&row.isSelected){service.toggleRowSelection(grid,row,evt,grid.options.multiSelect,grid.options.noUnselect,false);}},/**
                 * @ngdoc function
                 * @name selectAllRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Selects all rows.  Does nothing if multiSelect = false
                 * @param {Event} evt object if raised from an event
                 */selectAllRows:function(evt){if(grid.options.multiSelect!==false){var changedRows=[];grid.rows.forEach(function(row){if(!row.isSelected&&row.enableSelection!==false&&grid.options.isRowSelectable(row)!==false){row.setSelected(true);service.decideRaiseSelectionEvent(grid,row,changedRows,evt);}});grid.selection.selectAll=true;service.decideRaiseSelectionBatchEvent(grid,changedRows,evt);}},/**
                 * @ngdoc function
                 * @name selectAllVisibleRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Selects all visible rows.  Does nothing if multiSelect = false
                 * @param {Event} evt object if raised from an event
                 */selectAllVisibleRows:function(evt){if(grid.options.multiSelect!==false){var changedRows=[];grid.rows.forEach(function(row){if(row.visible){if(!row.isSelected&&row.enableSelection!==false&&grid.options.isRowSelectable(row)!==false){row.setSelected(true);service.decideRaiseSelectionEvent(grid,row,changedRows,evt);}}else if(row.isSelected){row.setSelected(false);service.decideRaiseSelectionEvent(grid,row,changedRows,evt);}});grid.selection.selectAll=true;service.decideRaiseSelectionBatchEvent(grid,changedRows,evt);}},/**
                 * @ngdoc function
                 * @name clearSelectedRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Unselects all rows
                 * @param {Event} evt object if raised from an event
                 */clearSelectedRows:function(evt){service.clearSelectedRows(grid,evt);},/**
                 * @ngdoc function
                 * @name getSelectedRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description returns all selected Row's entity references
                 */getSelectedRows:function(){return service.mapAndFilterRowsByEntity(service.getSelectedRows(grid));},/**
                 * @ngdoc function
                 * @name getUnSelectedRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description returns all unselected Row's entity references
                 */getUnSelectedRows:function(){return service.mapAndFilterRowsByEntity(service.getUnSelectedRows(grid));},/**
                 * @ngdoc function
                 * @name getSelectedGridRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description returns all selectedRow's as gridRows
                 */getSelectedGridRows:function(){return service.getSelectedRows(grid);},/**
                 * @ngdoc function
                 * @name getSelectedGridRows
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description returns all unselected Row's as gridRows
                 */getUnSelectedGridRows:function(){return service.getUnSelectedRows(grid);},/**
                 * @ngdoc function
                 * @name getSelectedCount
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description returns the number of rows selected
                 */getSelectedCount:function(){return grid.selection.selectedCount;},/**
                 * @ngdoc function
                 * @name setMultiSelect
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Sets the current gridOption.multiSelect to true or false
                 * @param {bool} multiSelect true to allow multiple rows
                 */setMultiSelect:function(multiSelect){grid.options.multiSelect=multiSelect;},/**
                 * @ngdoc function
                 * @name setModifierKeysToMultiSelect
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Sets the current gridOption.modifierKeysToMultiSelect to true or false
                 * @param {bool} modifierKeysToMultiSelect true to only allow multiple rows when using ctrlKey or shiftKey is used
                 */setModifierKeysToMultiSelect:function(modifierKeysToMultiSelect){grid.options.modifierKeysToMultiSelect=modifierKeysToMultiSelect;},/**
                 * @ngdoc function
                 * @name getSelectAllState
                 * @methodOf  ui.grid.selection.api:PublicApi
                 * @description Returns whether or not the selectAll checkbox is currently ticked.  The
                 * grid doesn't automatically select rows when you add extra data - so when you add data
                 * you need to explicitly check whether the selectAll is set, and then call setVisible rows
                 * if it is
                 */getSelectAllState:function(){return grid.selection.selectAll;}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
           *  @ngdoc object
           *  @name ui.grid.selection.api:GridOptions
           *
           *  @description GridOptions for selection feature, these are available to be
           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
           */ /**
           *  @ngdoc object
           *  @name enableRowSelection
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable row selection for entire grid.
           *  <br/>Defaults to true
           */gridOptions.enableRowSelection=gridOptions.enableRowSelection!==false;/**
           *  @ngdoc object
           *  @name multiSelect
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable multiple row selection for entire grid
           *  <br/>Defaults to true
           */gridOptions.multiSelect=gridOptions.multiSelect!==false;/**
           *  @ngdoc object
           *  @name noUnselect
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Prevent a row from being unselected.  Works in conjunction
           *  with `multiselect = false` and `gridApi.selection.selectRow()` to allow
           *  you to create a single selection only grid - a row is always selected, you
           *  can only select different rows, you can't unselect the row.
           *  <br/>Defaults to false
           */gridOptions.noUnselect=gridOptions.noUnselect===true;/**
           *  @ngdoc object
           *  @name modifierKeysToMultiSelect
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable multiple row selection only when using the ctrlKey or shiftKey. Requires multiSelect to be true.
           *  <br/>Defaults to false
           */gridOptions.modifierKeysToMultiSelect=gridOptions.modifierKeysToMultiSelect===true;/**
           *  @ngdoc object
           *  @name enableRowHeaderSelection
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable a row header to be used for selection
           *  <br/>Defaults to true
           */gridOptions.enableRowHeaderSelection=gridOptions.enableRowHeaderSelection!==false;/**
           *  @ngdoc object
           *  @name enableFullRowSelection
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable selection by clicking anywhere on the row.  Defaults to
           *  false if `enableRowHeaderSelection` is true, otherwise defaults to true.
           */if(typeof gridOptions.enableFullRowSelection==='undefined'){gridOptions.enableFullRowSelection=!gridOptions.enableRowHeaderSelection;}/**
           *  @ngdoc object
           *  @name enableFocusRowOnRowHeaderClick
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable focuse row by clicking on the row header.  Defaults to
           *  true if `enableRowHeaderSelection` is true, otherwise defaults to false.
           */gridOptions.enableFocusRowOnRowHeaderClick=gridOptions.enableFocusRowOnRowHeaderClick!==false||!gridOptions.enableRowHeaderSelection;/**
           *  @ngdoc object
           *  @name enableSelectRowOnFocus
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable focuse row by clicking on the row anywhere.  Defaults true.
           */gridOptions.enableSelectRowOnFocus=gridOptions.enableSelectRowOnFocus!==false;/**
           *  @ngdoc object
           *  @name enableSelectAll
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Enable the select all checkbox at the top of the selectionRowHeader
           *  <br/>Defaults to true
           */gridOptions.enableSelectAll=gridOptions.enableSelectAll!==false;/**
           *  @ngdoc object
           *  @name enableSelectionBatchEvent
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description If selected rows are changed in bulk, either via the API or
           *  via the selectAll checkbox, then a separate event is fired.  Setting this
           *  option to false will cause the rowSelectionChanged event to be called multiple times
           *  instead
           *  <br/>Defaults to true
           */gridOptions.enableSelectionBatchEvent=gridOptions.enableSelectionBatchEvent!==false;/**
           *  @ngdoc object
           *  @name selectionRowHeaderWidth
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description can be used to set a custom width for the row header selection column
           *  <br/>Defaults to 30px
           */gridOptions.selectionRowHeaderWidth=angular.isDefined(gridOptions.selectionRowHeaderWidth)?gridOptions.selectionRowHeaderWidth:30;/**
           *  @ngdoc object
           *  @name enableFooterTotalSelected
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Shows the total number of selected items in footer if true.
           *  <br/>Defaults to true.
           *  <br/>GridOptions.showGridFooter must also be set to true.
           */gridOptions.enableFooterTotalSelected=gridOptions.enableFooterTotalSelected!==false;/**
           *  @ngdoc object
           *  @name isRowSelectable
           *  @propertyOf  ui.grid.selection.api:GridOptions
           *  @description Makes it possible to specify a method that evaluates for each row and sets its "enableSelection" property.
           */gridOptions.isRowSelectable=angular.isDefined(gridOptions.isRowSelectable)?gridOptions.isRowSelectable:angular.noop;},/**
         * @ngdoc function
         * @name toggleRowSelection
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Toggles row as selected or unselected
         * @param {Grid} grid grid object
         * @param {GridRow} row row to select or deselect
         * @param {Event} evt object if resulting from event
         * @param {bool} multiSelect if false, only one row at time can be selected
         * @param {bool} noUnselect if true then rows cannot be unselected
         * @param {bool} [canBeInvisible=true] if false, row can only be selected when it's (theoretically) visible
         */toggleRowSelection:function(grid,row,evt,multiSelect,noUnselect,canBeInvisible){if(row.enableSelection===false){return;}if(canBeInvisible===void 0){canBeInvisible=true;}var selected=row.isSelected;if(!multiSelect){if(!selected){service.clearSelectedRows(grid,evt);}else if(service.getSelectedRows(grid).length>1){selected=false;// Enable reselect of the row
service.clearSelectedRows(grid,evt);}}// only select row in this case
if(!(selected&&noUnselect)&&(canBeInvisible||row.visible)){row.setSelected(!selected);if(row.isSelected===true){grid.selection.lastSelectedRow=row;}grid.selection.selectAll=grid.rows.length===service.getSelectedRows(grid).length;grid.api.selection.raise.rowSelectionChanged(row,evt);}},/**
         * @ngdoc function
         * @name shiftSelect
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description selects a group of rows from the last selected row using the shift key
         * @param {Grid} grid grid object
         * @param {GridRow} row clicked row
         * @param {Event} evt object if raised from an event
         * @param {bool} multiSelect if false, does nothing this is for multiSelect only
         */shiftSelect:function(grid,row,evt,multiSelect){if(!multiSelect){return;}var selectedRows=service.getSelectedRows(grid);var fromRow=selectedRows.length>0?grid.renderContainers.body.visibleRowCache.indexOf(grid.selection.lastSelectedRow):0;var toRow=grid.renderContainers.body.visibleRowCache.indexOf(row);// reverse select direction
if(fromRow>toRow){var tmp=fromRow;fromRow=toRow;toRow=tmp;}var changedRows=[];for(var i=fromRow;i<=toRow;i++){var rowToSelect=grid.renderContainers.body.visibleRowCache[i];if(rowToSelect){if(!rowToSelect.isSelected&&rowToSelect.enableSelection!==false){rowToSelect.setSelected(true);grid.selection.lastSelectedRow=rowToSelect;service.decideRaiseSelectionEvent(grid,rowToSelect,changedRows,evt);}}}service.decideRaiseSelectionBatchEvent(grid,changedRows,evt);},/**
         * @ngdoc function
         * @name getSelectedRows
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Returns all the selected rows
         * @param {Grid} grid grid object
         */getSelectedRows:function(grid){return grid.rows.filter(function(row){return row.isSelected;});},/**
         * @ngdoc function
         * @name getUnSelectedRows
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Returns all the unselected rows
         * @param {Grid} grid grid object
         */getUnSelectedRows:function(grid){return grid.rows.filter(function(row){return!row.isSelected;});},/**
         * @ngdoc function
         * @name mapAndFilterRowsByEntity
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Filters all rows by entity and then maps them to Array.
         */mapAndFilterRowsByEntity:function(gridRows){if(typeof gridRows.reduce==='function'){// If reduce is available it will be taken, due to better performance
return gridRows.reduce(function(previousVal,currentRow){if(currentRow.entity.hasOwnProperty('$$hashKey')||!angular.isObject(currentRow.entity)){previousVal.push(currentRow.entity);}return previousVal;},[]);}return gridRows.filter(function(gridRow){// stays as polyfill
return gridRow.entity.hasOwnProperty('$$hashKey')||!angular.isObject(gridRow.entity);}).map(function(gridRow){return gridRow.entity;});},/**
         * @ngdoc function
         * @name clearSelectedRows
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Clears all selected rows
         * @param {Grid} grid grid object
         * @param {Event} evt object if raised from an event
         */clearSelectedRows:function(grid,evt){var changedRows=[];service.getSelectedRows(grid).forEach(function(row){if(row.isSelected&&row.enableSelection!==false){row.setSelected(false);service.decideRaiseSelectionEvent(grid,row,changedRows,evt);}});grid.selection.selectAll=false;grid.selection.selectedCount=0;service.decideRaiseSelectionBatchEvent(grid,changedRows,evt);},/**
         * @ngdoc function
         * @name decideRaiseSelectionEvent
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Decides whether to raise a single event or a batch event
         * @param {Grid} grid grid object
         * @param {GridRow} row row that has changed
         * @param {array} changedRows an array to which we can append the changed
         * @param {Event} evt object if raised from an event
         * row if we're doing batch events
         */decideRaiseSelectionEvent:function(grid,row,changedRows,evt){if(!grid.options.enableSelectionBatchEvent){grid.api.selection.raise.rowSelectionChanged(row,evt);}else{changedRows.push(row);}},/**
         * @ngdoc function
         * @name raiseSelectionEvent
         * @methodOf  ui.grid.selection.service:uiGridSelectionService
         * @description Decides whether we need to raise a batch event, and
         * raises it if we do.
         * @param {Grid} grid grid object
         * @param {array} changedRows an array of changed rows, only populated
         * @param {Event} evt object if raised from an event
         * if we're doing batch events
         */decideRaiseSelectionBatchEvent:function(grid,changedRows,evt){if(changedRows.length>0){grid.api.selection.raise.rowSelectionChangedBatch(changedRows,evt);}}};return service;});/**
   *  @ngdoc directive
   *  @name ui.grid.selection.directive:uiGridSelection
   *  @element div
   *  @restrict A
   *
   *  @description Adds selection features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.selection']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name', enableCellEdit: true},
        {name: 'title', enableCellEdit: true}
      ];
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-selection></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridSelection',['i18nService','uiGridSelectionConstants','uiGridSelectionService','uiGridConstants',function(i18nService,uiGridSelectionConstants,uiGridSelectionService,uiGridConstants){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridSelectionService.initializeGrid(uiGridCtrl.grid);if(uiGridCtrl.grid.options.enableRowHeaderSelection){var selectionRowHeaderDef={name:uiGridSelectionConstants.selectionRowHeaderColName,displayName:i18nService.getSafeText('selection.displayName'),width:uiGridCtrl.grid.options.selectionRowHeaderWidth,minWidth:10,cellTemplate:'ui-grid/selectionRowHeader',headerCellTemplate:'ui-grid/selectionHeaderCell',enableColumnResizing:false,enableColumnMenu:false,exporterSuppressExport:true,allowCellFocus:true};uiGridCtrl.grid.addRowHeaderColumn(selectionRowHeaderDef,0);}var processorSet=false;var processSelectableRows=function(rows){rows.forEach(function(row){row.enableSelection=uiGridCtrl.grid.options.isRowSelectable(row);});return rows;};var updateOptions=function(){if(uiGridCtrl.grid.options.isRowSelectable!==angular.noop&&processorSet!==true){uiGridCtrl.grid.registerRowsProcessor(processSelectableRows,500);processorSet=true;}};updateOptions();var dataChangeDereg=uiGridCtrl.grid.registerDataChangeCallback(updateOptions,[uiGridConstants.dataChange.OPTIONS]);$scope.$on('$destroy',dataChangeDereg);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);module.directive('uiGridSelectionRowHeaderButtons',['$templateCache','uiGridSelectionService','gridUtil',function($templateCache,uiGridSelectionService,gridUtil){return{replace:true,restrict:'E',template:$templateCache.get('ui-grid/selectionRowHeaderButtons'),scope:true,require:'^uiGrid',link:function($scope,$elm,$attrs,uiGridCtrl){var self=uiGridCtrl.grid;$scope.selectButtonClick=selectButtonClick;$scope.selectButtonKeyDown=selectButtonKeyDown;// On IE, prevent mousedowns on the select button from starting a selection.
// If this is not done and you shift+click on another row, the browser will select a big chunk of text
if(gridUtil.detectBrowser()==='ie'){$elm.on('mousedown',selectButtonMouseDown);}function selectButtonKeyDown(row,evt){if(evt.keyCode===32||evt.keyCode===13){evt.preventDefault();selectButtonClick(row,evt);}}function selectButtonClick(row,evt){evt.stopPropagation();if(evt.shiftKey){uiGridSelectionService.shiftSelect(self,row,evt,self.options.multiSelect);}else if(evt.ctrlKey||evt.metaKey){uiGridSelectionService.toggleRowSelection(self,row,evt,self.options.multiSelect,self.options.noUnselect,false);}else if(row.groupHeader){uiGridSelectionService.toggleRowSelection(self,row,evt,self.options.multiSelect,self.options.noUnselect,false);for(var i=0;i<row.treeNode.children.length;i++){uiGridSelectionService.toggleRowSelection(self,row.treeNode.children[i].row,evt,self.options.multiSelect,self.options.noUnselect,false);}}else{uiGridSelectionService.toggleRowSelection(self,row,evt,self.options.multiSelect&&!self.options.modifierKeysToMultiSelect,self.options.noUnselect,false);}self.options.enableFocusRowOnRowHeaderClick&&row.setFocused(!row.isFocused)&&self.api.selection.raise.rowFocusChanged(row,evt);}function selectButtonMouseDown(evt){if(evt.ctrlKey||evt.shiftKey){evt.target.onselectstart=function(){return false;};window.setTimeout(function(){evt.target.onselectstart=null;},0);}}$scope.$on('$destroy',function unbindEvents(){$elm.off();});}};}]);module.directive('uiGridSelectionSelectAllButtons',['$templateCache','uiGridSelectionService',function($templateCache,uiGridSelectionService){return{replace:true,restrict:'E',template:$templateCache.get('ui-grid/selectionSelectAllButtons'),scope:false,link:function($scope){var self=$scope.col.grid;$scope.headerButtonKeyDown=function(evt){if(evt.keyCode===32||evt.keyCode===13){evt.preventDefault();$scope.headerButtonClick(evt);}};$scope.headerButtonClick=function(evt){if(self.selection.selectAll){uiGridSelectionService.clearSelectedRows(self,evt);if(self.options.noUnselect){self.api.selection.selectRowByVisibleIndex(0,evt);}self.selection.selectAll=false;}else if(self.options.multiSelect){self.api.selection.selectAllVisibleRows(evt);self.selection.selectAll=true;}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.selection.directive:uiGridViewport
   *  @element div
   *
   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
   *  for the grid row
   */module.directive('uiGridViewport',function(){return{priority:-200,// run after default  directive
scope:false,compile:function($elm){var rowRepeatDiv=angular.element($elm[0].querySelector('.ui-grid-canvas:not(.ui-grid-empty-base-layer-container)').children[0]),newNgClass="'ui-grid-row-selected': row.isSelected, 'ui-grid-row-focused': row.isFocused}",existingNgClass=rowRepeatDiv.attr('ng-class');if(existingNgClass){newNgClass=existingNgClass.slice(0,-1)+','+newNgClass;}else{newNgClass='{'+newNgClass;}rowRepeatDiv.attr('ng-class',newNgClass);return{pre:function($scope,$elm,$attrs,controllers){},post:function($scope,$elm,$attrs,controllers){}};}};});/**
   *  @ngdoc directive
   *  @name ui.grid.selection.directive:uiGridCell
   *  @element div
   *  @restrict A
   *
   *  @description Stacks on top of ui.grid.uiGridCell to provide selection feature
   */module.directive('uiGridCell',['uiGridConstants','uiGridSelectionService',function(uiGridConstants,uiGridSelectionService){return{priority:-200,// run after default uiGridCell directive
restrict:'A',require:'?^uiGrid',scope:false,link:function($scope,$elm,$attrs,uiGridCtrl){var touchStartTime=0,touchStartPos={},touchTimeout=300,touchPosDiff=100;// Bind to keydown events in the render container
if(uiGridCtrl.grid.api.cellNav){uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope,function(evt,rowCol){if(rowCol===null||rowCol.row!==$scope.row||rowCol.col!==$scope.col){return;}if(evt.keyCode===uiGridConstants.keymap.SPACE&&$scope.col.colDef.name==='selectionRowHeaderCol'){evt.preventDefault();uiGridSelectionService.toggleRowSelection($scope.grid,$scope.row,evt,$scope.grid.options.multiSelect&&!$scope.grid.options.modifierKeysToMultiSelect,$scope.grid.options.noUnselect,false);$scope.$apply();}});}var selectCells=function(evt){// if you click on expandable icon doesn't trigger selection
if(evt.target.className==="ui-grid-icon-minus-squared"||evt.target.className==="ui-grid-icon-plus-squared"){return;}// if we get a click, then stop listening for touchend
$elm.off('touchend',touchEnd);if(evt.shiftKey){uiGridSelectionService.shiftSelect($scope.grid,$scope.row,evt,$scope.grid.options.multiSelect);}else if(evt.ctrlKey||evt.metaKey){uiGridSelectionService.toggleRowSelection($scope.grid,$scope.row,evt,$scope.grid.options.multiSelect,$scope.grid.options.noUnselect,false);}else if($scope.grid.options.enableSelectRowOnFocus){uiGridSelectionService.toggleRowSelection($scope.grid,$scope.row,evt,$scope.grid.options.multiSelect&&!$scope.grid.options.modifierKeysToMultiSelect,$scope.grid.options.noUnselect,false);}$scope.row.setFocused(!$scope.row.isFocused);$scope.grid.api.selection.raise.rowFocusChanged($scope.row,evt);$scope.$apply();// don't re-enable the touchend handler for a little while - some devices generate both, and it will
// take a little while to move your hand from the mouse to the screen if you have both modes of input
window.setTimeout(function(){$elm.on('touchend',touchEnd);},touchTimeout);};var touchStart=function(evt){touchStartTime=new Date().getTime();touchStartPos=evt.changedTouches[0];// if we get a touch event, then stop listening for click
$elm.off('click',selectCells);};var touchEnd=function(evt){var touchEndTime=new Date().getTime();var touchEndPos=evt.changedTouches[0];var touchTime=touchEndTime-touchStartTime;var touchXDiff=Math.abs(touchStartPos.clientX-touchEndPos.clientX);var touchYDiff=Math.abs(touchStartPos.clientY-touchEndPos.clientY);if(touchXDiff<touchPosDiff&&touchYDiff<touchPosDiff){if(touchTime<touchTimeout){// short touch
selectCells(evt);}}// don't re-enable the click handler for a little while - some devices generate both, and it will
// take a little while to move your hand from the screen to the mouse if you have both modes of input
window.setTimeout(function(){$elm.on('click',selectCells);},touchTimeout);};function registerRowSelectionEvents(){if($scope.grid.options.enableRowSelection&&$scope.grid.options.enableFullRowSelection&&$scope.col.colDef.name!=='selectionRowHeaderCol'){$elm.addClass('ui-grid-disable-selection');$elm.on('touchstart',touchStart);$elm.on('touchend',touchEnd);$elm.on('click',selectCells);$scope.registered=true;}}function unregisterRowSelectionEvents(){if($scope.registered){$elm.removeClass('ui-grid-disable-selection');$elm.off('touchstart',touchStart);$elm.off('touchend',touchEnd);$elm.off('click',selectCells);$scope.registered=false;}}registerRowSelectionEvents();// register a dataChange callback so that we can change the selection configuration dynamically
// if the user changes the options
var dataChangeUnreg=$scope.grid.registerDataChangeCallback(function(){if($scope.grid.options.enableRowSelection&&$scope.grid.options.enableFullRowSelection&&!$scope.registered){registerRowSelectionEvents();}else if((!$scope.grid.options.enableRowSelection||!$scope.grid.options.enableFullRowSelection)&&$scope.registered){unregisterRowSelectionEvents();}},[uiGridConstants.dataChange.OPTIONS]);$elm.on('$destroy',dataChangeUnreg);}};}]);module.directive('uiGridGridFooter',['$compile','gridUtil',function($compile,gridUtil){return{restrict:'EA',replace:true,priority:-1000,require:'^uiGrid',scope:true,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){if(!uiGridCtrl.grid.options.showGridFooter){return;}gridUtil.getTemplate('ui-grid/gridFooterSelectedItems').then(function(contents){var template=angular.element(contents);var newElm=$compile(template)($scope);angular.element($elm[0].getElementsByClassName('ui-grid-grid-footer')[0]).append(newElm);});},post:function($scope,$elm,$attrs,controllers){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.treeBase
   * @description
   *
   * # ui.grid.treeBase
   *
   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
   *
   * This module provides base tree handling functions that are shared by other features, notably grouping
   * and treeView.  It provides a tree view of the data, with nodes in that
   * tree and leaves.
   *
   * Design information:
   * -------------------
   *
   * The raw data that is provided must come with a $$treeLevel on any non-leaf node.  Grouping will create
   * these on all the group header rows, treeView will expect these to be set in the raw data by the user.
   * TreeBase will run a rowsProcessor that:
   *  - builds `treeBase.tree` out of the provided rows
   *  - permits a recursive sort of the tree
   *  - maintains the expand/collapse state of each node
   *  - provides the expand/collapse all button and the expand/collapse buttons
   *  - maintains the count of children for each node
   *
   * Each row is updated with a link to the tree node that represents it.  Refer {@link ui.grid.treeBase.grid:treeBase.tree tree documentation}
   * for information.
   *
   *  TreeBase adds information to the rows
   *  - treeLevel: if present and > -1 tells us the level (level 0 is the top level)
   *  - treeNode: pointer to the node in the grid.treeBase.tree that refers
   *    to this row, allowing us to manipulate the state
   *
   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
   * row order or filtering or anything like that is changed.  We recall the expanded state
   * across invocations of the rowsProcessors by the reference to the treeNode on the individual
   * rows.  We rebuild the tree itself quite frequently, when we do this we use the saved treeNodes to
   * get the state, but we overwrite the other data in that treeNode.
   *
   * By default rows are collapsed, which means all data rows have their visible property
   * set to false, and only level 0 group rows are set to visible.
   *
   * We rely on the rowsProcessors to do the actual expanding and collapsing, so we set the flags we want into
   * grid.treeBase.tree, then call refresh.  This is because we can't easily change the visible
   * row cache without calling the processors, and once we've built the logic into the rowProcessors we may as
   * well use it all the time.
   *
   * Tree base provides sorting (on non-grouped columns).
   *
   * Sorting works in two passes.  The standard sorting is performed for any columns that are important to building
   * the tree (for example, any grouped columns).  Then after the tree is built, a recursive tree sort is performed
   * for the remaining sort columns (including the original sort) - these columns are sorted within each tree level
   * (so all the level 1 nodes are sorted, then all the level 2 nodes within each level 1 node etc).
   *
   * To achieve this we make use of the `ignoreSort` property on the sort configuration.  The parent feature (treeView or grouping)
   * must provide a rowsProcessor that runs with very low priority (typically in the 60-65 range), and that sets
   * the `ignoreSort`on any sort that it wants to run on the tree.  TreeBase will clear the ignoreSort on all sorts - so it
   * will turn on any sorts that haven't run.  It will then call a recursive sort on the tree.
   *
   * Tree base provides treeAggregation.  It checks the treeAggregation configuration on each column, and aggregates based on
   * the logic provided as it builds the tree. Footer aggregation from the uiGrid core should not be used with treeBase aggregation,
   * since it operates on all visible rows, as opposed to to leaf nodes only. Setting `showColumnFooter: true` will show the
   * treeAggregations in the column footer.  Aggregation information will be collected in the format:
   *
   * ```
   *   {
   *     type: 'count',
   *     value: 4,
   *     label: 'count: ',
   *     rendered: 'count: 4'
   *   }
   * ```
   *
   * A callback is provided to format the value once it is finalised (aka a valueFilter).
   *
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.treeBase"></div>
   */var module=angular.module('ui.grid.treeBase',['ui.grid']);/**
   *  @ngdoc object
   *  @name ui.grid.treeBase.constant:uiGridTreeBaseConstants
   *
   *  @description constants available in treeBase module.
   *
   *  These constants are manually copied into grouping and treeView,
   *  as I haven't found a way to simply include them, and it's not worth
   *  investing time in for something that changes very infrequently.
   *
   */module.constant('uiGridTreeBaseConstants',{featureName:"treeBase",rowHeaderColName:'treeBaseRowHeaderCol',EXPANDED:'expanded',COLLAPSED:'collapsed',aggregation:{COUNT:'count',SUM:'sum',MAX:'max',MIN:'min',AVG:'avg'}});/**
   *  @ngdoc service
   *  @name ui.grid.treeBase.service:uiGridTreeBaseService
   *
   *  @description Services for treeBase feature
   */ /**
   *  @ngdoc object
   *  @name ui.grid.treeBase.api:ColumnDef
   *
   *  @description ColumnDef for tree feature, these are available to be
   *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
   */module.service('uiGridTreeBaseService',['$q','uiGridTreeBaseConstants','gridUtil','GridRow','gridClassFactory','i18nService','uiGridConstants','rowSorter',function($q,uiGridTreeBaseConstants,gridUtil,GridRow,gridClassFactory,i18nService,uiGridConstants,rowSorter){var service={initializeGrid:function(grid){// add feature namespace and any properties to grid for needed
/**
         *  @ngdoc object
         *  @name ui.grid.treeBase.grid:treeBase
         *
         *  @description Grid properties and functions added for treeBase
         */grid.treeBase={};/**
         *  @ngdoc property
         *  @propertyOf ui.grid.treeBase.grid:treeBase
         *  @name numberLevels
         *
         *  @description Total number of tree levels currently used, calculated by the rowsProcessor by
         *  retaining the highest tree level it sees
         */grid.treeBase.numberLevels=0;/**
         *  @ngdoc property
         *  @propertyOf ui.grid.treeBase.grid:treeBase
         *  @name expandAll
         *
         *  @description Whether or not the expandAll box is selected
         */grid.treeBase.expandAll=false;/**
         *  @ngdoc property
         *  @propertyOf ui.grid.treeBase.grid:treeBase
         *  @name tree
         *
         *  @description Tree represented as a nested array that holds the state of each node, along with a
         *  pointer to the row.  The array order is material - we will display the children in the order
         *  they are stored in the array
         *
         *  Each node stores:
         *
         *    - the state of this node
         *    - an array of children of this node
         *    - a pointer to the parent of this node (reverse pointer, allowing us to walk up the tree)
         *    - the number of children of this node
         *    - aggregation information calculated from the nodes
         *
         *  ```
         *    [{
         *      state: 'expanded',
         *      row: <reference to row>,
         *      parentRow: null,
         *      aggregations: [{
         *        type: 'count',
         *        col: <gridCol>,
         *        value: 2,
         *        label: 'count: ',
         *        rendered: 'count: 2'
         *      }],
         *      children: [
         *        {
         *          state: 'expanded',
         *          row: <reference to row>,
         *          parentRow: <reference to row>,
         *          aggregations: [{
         *            type: 'count',
         *            col: '<gridCol>,
         *            value: 4,
         *            label: 'count: ',
         *            rendered: 'count: 4'
         *          }],
         *          children: [
         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> }
         *          ]
         *        },
         *        {
         *          state: 'collapsed',
         *          row: <reference to row>,
         *          parentRow: <reference to row>,
         *          aggregations: [{
         *            type: 'count',
         *            col: <gridCol>,
         *            value: 3,
         *            label: 'count: ',
         *            rendered: 'count: 3'
         *          }],
         *          children: [
         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> }
         *          ]
         *        }
         *      ]
         *    }, {<another level 0 node maybe>} ]
         *  ```
         *  Missing state values are false - meaning they aren't expanded.
         *
         *  This is used because the rowProcessors run every time the grid is refreshed, so
         *  we'd lose the expanded state every time the grid was refreshed.  This instead gives
         *  us a reliable lookup that persists across rowProcessors.
         *
         *  This tree is rebuilt every time we run the rowsProcessors.  Since each row holds a pointer
         *  to it's tree node we can persist expand/collapse state across calls to rowsProcessor, we discard
         *  all transient information on the tree (children, childCount) and recalculate it
         *
         */grid.treeBase.tree=[];service.defaultGridOptions(grid.options);grid.registerRowsProcessor(service.treeRows,410);grid.registerColumnBuilder(service.treeBaseColumnBuilder);service.createRowHeader(grid);/**
         *  @ngdoc object
         *  @name ui.grid.treeBase.api:PublicApi
         *
         *  @description Public Api for treeBase feature
         */var publicApi={events:{treeBase:{/**
               * @ngdoc event
               * @eventOf ui.grid.treeBase.api:PublicApi
               * @name rowExpanded
               * @description raised whenever a row is expanded.  If you are dynamically
               * rendering your tree you can listen to this event, and then retrieve
               * the children of this row and load them into the grid data.
               *
               * When the data is loaded the grid will automatically refresh to show these new rows
               *
               * <pre>
               *      gridApi.treeBase.on.rowExpanded(scope,function(row) {})
               * </pre>
               * @param {gridRow} row the row that was expanded.  You can also
               * retrieve the grid from this row with row.grid
               */rowExpanded:{},/**
               * @ngdoc event
               * @eventOf ui.grid.treeBase.api:PublicApi
               * @name rowCollapsed
               * @description raised whenever a row is collapsed.  Doesn't really have
               * a purpose at the moment, included for symmetry
               *
               * <pre>
               *      gridApi.treeBase.on.rowCollapsed(scope,function(row) {})
               * </pre>
               * @param {gridRow} row the row that was collapsed.  You can also
               * retrieve the grid from this row with row.grid
               */rowCollapsed:{}}},methods:{treeBase:{/**
               * @ngdoc function
               * @name expandAllRows
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description Expands all tree rows
               */expandAllRows:function(){service.expandAllRows(grid);},/**
               * @ngdoc function
               * @name collapseAllRows
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description collapse all tree rows
               */collapseAllRows:function(){service.collapseAllRows(grid);},/**
               * @ngdoc function
               * @name toggleRowTreeState
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description  call expand if the row is collapsed, collapse if it is expanded
               * @param {gridRow} row the row you wish to toggle
               */toggleRowTreeState:function(row){service.toggleRowTreeState(grid,row);},/**
               * @ngdoc function
               * @name expandRow
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description expand the immediate children of the specified row
               * @param {gridRow} row the row you wish to expand
               * @param {boolean} recursive true if you wish to expand the row's ancients
               */expandRow:function(row,recursive){service.expandRow(grid,row,recursive);},/**
               * @ngdoc function
               * @name expandRowChildren
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description expand all children of the specified row
               * @param {gridRow} row the row you wish to expand
               */expandRowChildren:function(row){service.expandRowChildren(grid,row);},/**
               * @ngdoc function
               * @name collapseRow
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description collapse  the specified row.  When
               * you expand the row again, all grandchildren will retain their state
               * @param {gridRow} row the row you wish to collapse
               */collapseRow:function(row){service.collapseRow(grid,row);},/**
               * @ngdoc function
               * @name collapseRowChildren
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description collapse all children of the specified row.  When
               * you expand the row again, all grandchildren will be collapsed
               * @param {gridRow} row the row you wish to collapse children for
               */collapseRowChildren:function(row){service.collapseRowChildren(grid,row);},/**
               * @ngdoc function
               * @name getTreeState
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description Get the tree state for this grid,
               * used by the saveState feature
               * Returned treeState as an object
               *   `{ expandedState: { uid: 'expanded', uid: 'collapsed' } }`
               * where expandedState is a hash of row uid and the current expanded state
               *
               * @returns {object} tree state
               *
               * TODO - this needs work - we need an identifier that persists across instantiations,
               * not uid.  This really means we need a row identity defined, but that won't work for
               * grouping.  Perhaps this needs to be moved up to treeView and grouping, rather than
               * being in base.
               */getTreeExpandedState:function(){return{expandedState:service.getTreeState(grid)};},/**
               * @ngdoc function
               * @name setTreeState
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description Set the expanded states of the tree
               * @param {object} config the config you want to apply, in the format
               * provided by getTreeState
               */setTreeState:function(config){service.setTreeState(grid,config);},/**
               * @ngdoc function
               * @name getRowChildren
               * @methodOf  ui.grid.treeBase.api:PublicApi
               * @description Get the children of the specified row
               * @param {GridRow} row the row you want the children of
               * @returns {Array} array of children of this row, the children
               * are all gridRows
               */getRowChildren:function(row){return row.treeNode.children.map(function(childNode){return childNode.row;});}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
         *  @ngdoc object
         *  @name ui.grid.treeBase.api:GridOptions
         *
         *  @description GridOptions for treeBase feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         */ /**
         *  @ngdoc object
         *  @name treeRowHeaderBaseWidth
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description Base width of the tree header, provides for a single level of tree.  This
         *  is incremented by `treeIndent` for each extra level
         *  <br/>Defaults to 30
         */gridOptions.treeRowHeaderBaseWidth=gridOptions.treeRowHeaderBaseWidth||30;/**
         *  @ngdoc object
         *  @name treeIndent
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description Number of pixels of indent for the icon at each tree level, wider indents are visually more pleasing,
         *  but will make the tree row header wider
         *  <br/>Defaults to 10
         */gridOptions.treeIndent=gridOptions.treeIndent!=null?gridOptions.treeIndent:10;/**
         *  @ngdoc object
         *  @name showTreeRowHeader
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description If set to false, don't create the row header.  You'll need to programmatically control the expand
         *  states
         *  <br/>Defaults to true
         */gridOptions.showTreeRowHeader=gridOptions.showTreeRowHeader!==false;/**
         *  @ngdoc object
         *  @name showTreeExpandNoChildren
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description If set to true, show the expand/collapse button even if there are no
         *  children of a node.  You'd use this if you're planning to dynamically load the children
         *
         *  <br/>Defaults to true, grouping overrides to false
         */gridOptions.showTreeExpandNoChildren=gridOptions.showTreeExpandNoChildren!==false;/**
         *  @ngdoc object
         *  @name treeRowHeaderAlwaysVisible
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description If set to true, row header even if there are no tree nodes
         *
         *  <br/>Defaults to true
         */gridOptions.treeRowHeaderAlwaysVisible=gridOptions.treeRowHeaderAlwaysVisible!==false;/**
         *  @ngdoc object
         *  @name treeCustomAggregations
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description Define custom aggregation functions. The properties of this object will be
         *  aggregation types available for use on columnDef with {@link ui.grid.treeBase.api:ColumnDef treeAggregationType} or through the column menu.
         *  If a function defined here uses the same name as one of the native aggregations, this one will take precedence.
         *  The object format is:
         *
         *  <pre>
         *    {
         *      aggregationName: {
         *        label: (optional) string,
         *        aggregationFn: function( aggregation, fieldValue, numValue, row ) {...},
         *        finalizerFn: (optional) function( aggregation ) {...}
         *      },
         *      mean: {
         *        label: 'mean',
         *        aggregationFn: function( aggregation, fieldValue, numValue ) {
         *          aggregation.count = (aggregation.count || 1) + 1;
         *          aggregation.sum = (aggregation.sum || 0) + numValue;
         *        },
         *        finalizerFn: function( aggregation ) {
         *          aggregation.value = aggregation.sum / aggregation.count
         *        }
         *      }
         *    }
         *  </pre>
         *
         *  <br/>The `finalizerFn` may be used to manipulate the value before rendering, or to
         *  apply a custom rendered value. If `aggregation.rendered` is left undefined, the value will be
         *  rendered. Note that the native aggregation functions use an `finalizerFn` to concatenate
         *  the label and the value.
         *
         *  <br/>Defaults to {}
         */gridOptions.treeCustomAggregations=gridOptions.treeCustomAggregations||{};/**
         *  @ngdoc object
         *  @name enableExpandAll
         *  @propertyOf  ui.grid.treeBase.api:GridOptions
         *  @description Enable the expand all button at the top of the row header
         *
         *  <br/>Defaults to true
         */gridOptions.enableExpandAll=gridOptions.enableExpandAll!==false;},/**
       * @ngdoc function
       * @name treeBaseColumnBuilder
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Sets the tree defaults based on the columnDefs
       *
       * @param {object} colDef columnDef we're basing on
       * @param {GridColumn} col the column we're to update
       * @param {object} gridOptions the options we should use
       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
       */treeBaseColumnBuilder:function(colDef,col,gridOptions){/**
         *  @ngdoc object
         *  @name customTreeAggregationFn
         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
         *  @description A custom function that aggregates rows into some form of
         *  total.  Aggregations run row-by-row, the function needs to be capable of
         *  creating a running total.
         *
         *  The function will be provided the aggregation item (in which you can store running
         *  totals), the row value that is to be aggregated, and that same row value converted to
         *  a number (most aggregations work on numbers)
         *  @example
         *  <pre>
         *    customTreeAggregationFn = function ( aggregation, fieldValue, numValue, row ) {
         *      // calculates the average of the squares of the values
         *      if ( typeof(aggregation.count) === 'undefined' ) {
         *        aggregation.count = 0;
         *      }
         *      aggregation.count++;
         *
         *      if ( !isNaN(numValue) ) {
         *        if ( typeof(aggregation.total) === 'undefined' ) {
         *          aggregation.total = 0;
         *        }
         *        aggregation.total = aggregation.total + numValue * numValue;
         *      }
         *
         *      aggregation.value = aggregation.total / aggregation.count;
         *    }
         *  </pre>
         *  <br/>Defaults to undefined. May be overwritten by treeAggregationType, the two options should not be used together.
         */if(typeof colDef.customTreeAggregationFn!=='undefined'){col.treeAggregationFn=colDef.customTreeAggregationFn;}/**
         *  @ngdoc object
         *  @name treeAggregationType
         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
         *  @description Use one of the native or grid-level aggregation methods for calculating aggregations on this column.
         *  Native method are in the constants file and include: SUM, COUNT, MIN, MAX, AVG. This may also be the property the
         *  name of an aggregation function defined with {@link ui.grid.treeBase.api:GridOptions treeCustomAggregations}.
         *
         *  <pre>
         *      treeAggregationType = uiGridTreeBaseConstants.aggregation.SUM,
         *    }
         *  </pre>
         *
         *  If you are using aggregations you should either:
         *
         *   - also use grouping, in which case the aggregations are displayed in the group header, OR
         *   - use treeView, in which case you can set `treeAggregationUpdateEntity: true` in the colDef, and
         *     treeBase will store the aggregation information in the entity, or you can set `treeAggregationUpdateEntity: false`
         *     in the colDef, and you need to manual retrieve the calculated aggregations from the row.treeNode.aggregations
         *
         *  <br/>Takes precendence over a treeAggregationFn, the two options should not be used together.
         *  <br/>Defaults to undefined.
         */if(typeof colDef.treeAggregationType!=='undefined'){col.treeAggregation={type:colDef.treeAggregationType};if(typeof gridOptions.treeCustomAggregations[colDef.treeAggregationType]!=='undefined'){col.treeAggregationFn=gridOptions.treeCustomAggregations[colDef.treeAggregationType].aggregationFn;col.treeAggregationFinalizerFn=gridOptions.treeCustomAggregations[colDef.treeAggregationType].finalizerFn;col.treeAggregation.label=gridOptions.treeCustomAggregations[colDef.treeAggregationType].label;}else if(typeof service.nativeAggregations()[colDef.treeAggregationType]!=='undefined'){col.treeAggregationFn=service.nativeAggregations()[colDef.treeAggregationType].aggregationFn;col.treeAggregation.label=service.nativeAggregations()[colDef.treeAggregationType].label;}}/**
         *  @ngdoc object
         *  @name treeAggregationLabel
         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
         *  @description A custom label to use for this aggregation. If provided we don't use native i18n.
         */if(typeof colDef.treeAggregationLabel!=='undefined'){if(typeof col.treeAggregation==='undefined'){col.treeAggregation={};}col.treeAggregation.label=colDef.treeAggregationLabel;}/**
         *  @ngdoc object
         *  @name treeAggregationUpdateEntity
         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
         *  @description Store calculated aggregations into the entity, allowing them
         *  to be displayed in the grid using a standard cellTemplate.  This defaults to true,
         *  if you are using grouping then you shouldn't set it to false, as then the aggregations won't
         *  display.
         *
         *  If you are using treeView in most cases you'll want to set this to true.  This will result in
         *  getCellValue returning the aggregation rather than whatever was stored in the cell attribute on
         *  the entity.  If you want to render the underlying entity value (and do something else with the aggregation)
         *  then you could use a custom cellTemplate to display `row.entity.myAttribute`, rather than using getCellValue.
         *
         *  <br/>Defaults to true
         *
         *  @example
         *  <pre>
         *    gridOptions.columns = [{
         *      name: 'myCol',
         *      treeAggregation: { type: uiGridTreeBaseConstants.aggregation.SUM },
         *      treeAggregationUpdateEntity: true
         *      cellTemplate: '<div>{{row.entity.myCol + " " + row.treeNode.aggregations[0].rendered}}</div>'
         *    }];
         * </pre>
         */col.treeAggregationUpdateEntity=colDef.treeAggregationUpdateEntity!==false;/**
         *  @ngdoc object
         *  @name customTreeAggregationFinalizerFn
         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
         *  @description A custom function that populates aggregation.rendered, this is called when
         *  a particular aggregation has been fully calculated, and we want to render the value.
         *
         *  With the native aggregation options we just concatenate `aggregation.label` and
         *  `aggregation.value`, but if you wanted to apply a filter or otherwise manipulate the label
         *  or the value, you can do so with this function. This function will be called after the
         *  the default `finalizerFn`.
         *
         *  @example
         *  <pre>
         *    customTreeAggregationFinalizerFn = function ( aggregation ) {
         *      aggregation.rendered = aggregation.label + aggregation.value / 100 + '%';
         *    }
         *  </pre>
         *  <br/>Defaults to undefined.
         */if(typeof col.customTreeAggregationFinalizerFn==='undefined'){col.customTreeAggregationFinalizerFn=colDef.customTreeAggregationFinalizerFn;}},/**
       * @ngdoc function
       * @name createRowHeader
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Create the rowHeader.  If treeRowHeaderAlwaysVisible then
       * set it to visible, otherwise set it to invisible
       *
       * @param {Grid} grid grid object
       */createRowHeader:function(grid){var rowHeaderColumnDef={name:uiGridTreeBaseConstants.rowHeaderColName,displayName:'',width:grid.options.treeRowHeaderBaseWidth,minWidth:10,cellTemplate:'ui-grid/treeBaseRowHeader',headerCellTemplate:'ui-grid/treeBaseHeaderCell',enableColumnResizing:false,enableColumnMenu:false,exporterSuppressExport:true,allowCellFocus:true};rowHeaderColumnDef.visible=grid.options.treeRowHeaderAlwaysVisible;grid.addRowHeaderColumn(rowHeaderColumnDef,-100);},/**
       * @ngdoc function
       * @name expandAllRows
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Expands all nodes in the tree
       *
       * @param {Grid} grid grid object
       */expandAllRows:function(grid){grid.treeBase.tree.forEach(function(node){service.setAllNodes(grid,node,uiGridTreeBaseConstants.EXPANDED);});grid.treeBase.expandAll=true;grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name collapseAllRows
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Collapses all nodes in the tree
       *
       * @param {Grid} grid grid object
       */collapseAllRows:function(grid){grid.treeBase.tree.forEach(function(node){service.setAllNodes(grid,node,uiGridTreeBaseConstants.COLLAPSED);});grid.treeBase.expandAll=false;grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name setAllNodes
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Works through a subset of grid.treeBase.rowExpandedStates, setting
       * all child nodes (and their descendents) of the provided node to the given state.
       *
       * Calls itself recursively on all nodes so as to achieve this.
       *
       * @param {Grid} grid the grid we're operating on (so we can raise events)
       * @param {object} treeNode a node in the tree that we want to update
       * @param {string} targetState the state we want to set it to
       */setAllNodes:function(grid,treeNode,targetState){if(typeof treeNode.state!=='undefined'&&treeNode.state!==targetState){treeNode.state=targetState;if(targetState===uiGridTreeBaseConstants.EXPANDED){grid.api.treeBase.raise.rowExpanded(treeNode.row);}else{grid.api.treeBase.raise.rowCollapsed(treeNode.row);}}// set all child nodes
if(treeNode.children){treeNode.children.forEach(function(childNode){service.setAllNodes(grid,childNode,targetState);});}},/**
       * @ngdoc function
       * @name toggleRowTreeState
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Toggles the expand or collapse state of this grouped row, if
       * it's a parent row
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to toggle
       */toggleRowTreeState:function(grid,row){if(typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0){return;}if(row.treeNode.state===uiGridTreeBaseConstants.EXPANDED){service.collapseRow(grid,row);}else{service.expandRow(grid,row,false);}grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name expandRow
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Expands this specific row, showing only immediate children.
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to expand
       * @param {boolean} recursive true if you wish to expand the row's ancients
       */expandRow:function(grid,row,recursive){if(recursive){var parents=[];while(row&&typeof row.treeLevel!=='undefined'&&row.treeLevel!==null&&row.treeLevel>=0&&row.treeNode.state!==uiGridTreeBaseConstants.EXPANDED){parents.push(row);row=row.treeNode.parentRow;}if(parents.length>0){row=parents.pop();while(row){row.treeNode.state=uiGridTreeBaseConstants.EXPANDED;grid.api.treeBase.raise.rowExpanded(row);row=parents.pop();}grid.treeBase.expandAll=service.allExpanded(grid.treeBase.tree);grid.queueGridRefresh();}}else{if(typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0){return;}if(row.treeNode.state!==uiGridTreeBaseConstants.EXPANDED){row.treeNode.state=uiGridTreeBaseConstants.EXPANDED;grid.api.treeBase.raise.rowExpanded(row);grid.treeBase.expandAll=service.allExpanded(grid.treeBase.tree);grid.queueGridRefresh();}}},/**
       * @ngdoc function
       * @name expandRowChildren
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Expands this specific row, showing all children.
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to expand
       */expandRowChildren:function(grid,row){if(typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0){return;}service.setAllNodes(grid,row.treeNode,uiGridTreeBaseConstants.EXPANDED);grid.treeBase.expandAll=service.allExpanded(grid.treeBase.tree);grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name collapseRow
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Collapses this specific row
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to collapse
       */collapseRow:function(grid,row){if(typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0){return;}if(row.treeNode.state!==uiGridTreeBaseConstants.COLLAPSED){row.treeNode.state=uiGridTreeBaseConstants.COLLAPSED;grid.treeBase.expandAll=false;grid.api.treeBase.raise.rowCollapsed(row);grid.queueGridRefresh();}},/**
       * @ngdoc function
       * @name collapseRowChildren
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Collapses this specific row and all children
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to collapse
       */collapseRowChildren:function(grid,row){if(typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0){return;}service.setAllNodes(grid,row.treeNode,uiGridTreeBaseConstants.COLLAPSED);grid.treeBase.expandAll=false;grid.queueGridRefresh();},/**
       * @ngdoc function
       * @name allExpanded
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Returns true if all rows are expanded, false
       * if they're not.  Walks the tree to determine this.  Used
       * to set the expandAll state.
       *
       * If the node has no children, then return true (it's immaterial
       * whether it is expanded).  If the node has children, then return
       * false if this node is collapsed, or if any child node is not all expanded
       *
       * @param {object} tree the grid to check
       * @returns {boolean} whether or not the tree is all expanded
       */allExpanded:function(tree){var allExpanded=true;tree.forEach(function(node){if(!service.allExpandedInternal(node)){allExpanded=false;}});return allExpanded;},allExpandedInternal:function(treeNode){if(treeNode.children&&treeNode.children.length>0){if(treeNode.state===uiGridTreeBaseConstants.COLLAPSED){return false;}var allExpanded=true;treeNode.children.forEach(function(node){if(!service.allExpandedInternal(node)){allExpanded=false;}});return allExpanded;}else{return true;}},/**
       * @ngdoc function
       * @name treeRows
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description The rowProcessor that adds the nodes to the tree, and sets the visible
       * state of each row based on it's parent state
       *
       * Assumes it is always called after the sorting processor, and the grouping processor if there is one.
       * Performs any tree sorts itself after having built the tree
       *
       * Processes all the rows in order, setting the group level based on the $$treeLevel in the associated
       * entity, and setting the visible state based on the parent's state.
       *
       * Calculates the deepest level of tree whilst it goes, and updates that so that the header column can be correctly
       * sized.
       *
       * Aggregates if necessary along the way.
       *
       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
       * @returns {array} the updated rows
       */treeRows:function(renderableRows){var grid=this;if(renderableRows.length===0){service.updateRowHeaderWidth(grid);return renderableRows;}grid.treeBase.tree=service.createTree(grid,renderableRows);service.updateRowHeaderWidth(grid);service.sortTree(grid);service.fixFilter(grid);return service.renderTree(grid.treeBase.tree);},/**
       * @ngdoc function
       * @name createOrUpdateRowHeaderWidth
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Calculates the rowHeader width.
       *
       * If rowHeader is always present, updates the width.
       *
       * If rowHeader is only sometimes present (`treeRowHeaderAlwaysVisible: false`), determines whether there
       * should be one, then creates or removes it as appropriate, with the created rowHeader having the
       * right width.
       *
       * If there's never a rowHeader then never creates one: `showTreeRowHeader: false`
       *
       * @param {Grid} grid the grid we want to set the row header on
       */updateRowHeaderWidth:function(grid){var rowHeader=grid.getColumn(uiGridTreeBaseConstants.rowHeaderColName),newWidth=grid.options.treeRowHeaderBaseWidth+grid.options.treeIndent*Math.max(grid.treeBase.numberLevels-1,0);if(rowHeader&&newWidth!==rowHeader.width){rowHeader.width=newWidth;grid.queueRefresh();}var newVisibility=true;if(grid.options.showTreeRowHeader===false){newVisibility=false;}if(grid.options.treeRowHeaderAlwaysVisible===false&&grid.treeBase.numberLevels<=0){newVisibility=false;}if(rowHeader&&rowHeader.visible!==newVisibility){rowHeader.visible=newVisibility;rowHeader.colDef.visible=newVisibility;grid.queueGridRefresh();}},/**
       * @ngdoc function
       * @name renderTree
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Creates an array of rows based on the tree, exporting only
       * the visible nodes and leaves
       *
       * @param {array} nodeList The list of nodes - can be grid.treeBase.tree, or can be node.children when
       * we're calling recursively
       * @returns {array} renderable rows
       */renderTree:function(nodeList){var renderableRows=[];nodeList.forEach(function(node){if(node.row.visible){renderableRows.push(node.row);}if(node.state===uiGridTreeBaseConstants.EXPANDED&&node.children&&node.children.length>0){renderableRows=renderableRows.concat(service.renderTree(node.children));}});return renderableRows;},/**
       * @ngdoc function
       * @name createTree
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Creates a tree from the renderableRows
       *
       * @param {Grid} grid The grid
       * @param {array} renderableRows The rows we want to create a tree from
       * @returns {object} The tree we've build
       */createTree:function(grid,renderableRows){var currentLevel=-1,parentsCache={},parents=[],currentState;grid.treeBase.tree=[];grid.treeBase.numberLevels=0;var aggregations=service.getAggregations(grid);function createNode(row){if(!row.internalRow&&row.treeLevel!==row.entity.$$treeLevel){row.treeLevel=row.entity.$$treeLevel;}if(row.treeLevel<=currentLevel){// pop any levels that aren't parents of this level, formatting the aggregation at the same time
while(row.treeLevel<=currentLevel){var lastParent=parents.pop();service.finaliseAggregations(lastParent);currentLevel--;}// reset our current state based on the new parent, set to expanded if this is a level 0 node
if(parents.length>0){currentState=service.setCurrentState(parents);}else{currentState=uiGridTreeBaseConstants.EXPANDED;}}// If row header as parent exists in parentsCache
if(typeof row.treeLevel!=='undefined'&&row.treeLevel!==null&&row.treeLevel>=0&&parentsCache.hasOwnProperty(row.uid)){parents.push(parentsCache[row.uid]);}// aggregate if this is a leaf node
if((typeof row.treeLevel==='undefined'||row.treeLevel===null||row.treeLevel<0)&&row.visible){service.aggregate(grid,row,parents);}// add this node to the tree
if(!parentsCache.hasOwnProperty(row.uid)){service.addOrUseNode(grid,row,parents,aggregations);}if(typeof row.treeLevel!=='undefined'&&row.treeLevel!==null&&row.treeLevel>=0){if(!parentsCache.hasOwnProperty(row.uid)){parentsCache[row.uid]=row;parents.push(row);}currentLevel++;currentState=service.setCurrentState(parents);}// update the tree number of levels, so we can set header width if we need to
if(grid.treeBase.numberLevels<row.treeLevel+1){grid.treeBase.numberLevels=row.treeLevel+1;}}renderableRows.forEach(createNode);// finalize remaining aggregations
while(parents.length>0){var lastParent=parents.pop();service.finaliseAggregations(lastParent);}return grid.treeBase.tree;},/**
       * @ngdoc function
       * @name addOrUseNode
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Creates a tree node for this row.  If this row already has a treeNode
       * recorded against it, preserves the state, but otherwise overwrites the data.
       *
       * @param {grid} grid The grid we're operating on
       * @param {gridRow} row The row we want to set
       * @param {array} parents An array of the parents this row should have
       * @param {array} aggregationBase Empty aggregation information
       * @returns {undefined} Updates the parents array, updates the row to have a treeNode, and updates the
       * grid.treeBase.tree
       */addOrUseNode:function(grid,row,parents,aggregationBase){var newAggregations=[];aggregationBase.forEach(function(aggregation){newAggregations.push(service.buildAggregationObject(aggregation.col));});var newNode={state:uiGridTreeBaseConstants.COLLAPSED,row:row,parentRow:null,aggregations:newAggregations,children:[]};if(row.treeNode){newNode.state=row.treeNode.state;}if(parents.length>0){newNode.parentRow=parents[parents.length-1];}row.treeNode=newNode;if(parents.length===0){grid.treeBase.tree.push(newNode);}else{parents[parents.length-1].treeNode.children.push(newNode);}},/**
       * @ngdoc function
       * @name setCurrentState
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Looks at the parents array to determine our current state.
       * If any node in the hierarchy is collapsed, then return collapsed, otherwise return
       * expanded.
       *
       * @param {array} parents An array of the parents this row should have
       * @returns {string} The state we should be setting to any nodes we see
       */setCurrentState:function(parents){var currentState=uiGridTreeBaseConstants.EXPANDED;parents.forEach(function(parent){if(parent.treeNode.state===uiGridTreeBaseConstants.COLLAPSED){currentState=uiGridTreeBaseConstants.COLLAPSED;}});return currentState;},/**
       * @ngdoc function
       * @name sortTree
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Performs a recursive sort on the tree nodes, sorting the
       * children of each node and putting them back into the children array.
       *
       * Before doing this it turns back on all the sortIgnore - things that were previously
       * ignored we process now.  Since we're sorting within the nodes, presumably anything
       * that was already sorted is how we derived the nodes, we can keep those sorts too.
       *
       * We only sort tree nodes that are expanded - no point in wasting effort sorting collapsed
       * nodes
       *
       * @param {Grid} grid The grid to get the aggregation information from
       * @returns {array} The aggregation information
       */sortTree:function(grid){grid.columns.forEach(function(column){if(column.sort&&column.sort.ignoreSort){delete column.sort.ignoreSort;}});grid.treeBase.tree=service.sortInternal(grid,grid.treeBase.tree);},sortInternal:function(grid,treeList){var rows=treeList.map(function(node){return node.row;});rows=rowSorter.sort(grid,rows,grid.columns);var treeNodes=rows.map(function(row){return row.treeNode;});treeNodes.forEach(function(node){if(node.state===uiGridTreeBaseConstants.EXPANDED&&node.children&&node.children.length>0){node.children=service.sortInternal(grid,node.children);}});return treeNodes;},/**
       * @ngdoc function
       * @name fixFilter
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description After filtering has run, we need to go back through the tree
       * and make sure the parent rows are always visible if any of the child rows
       * are visible (filtering may make a child visible, but the parent may not
       * match the filter criteria)
       *
       * This has a risk of being computationally expensive, we do it by walking
       * the tree and remembering whether there are any invisible nodes on the
       * way down.
       *
       * @param {Grid} grid the grid to fix filters on
       */fixFilter:function(grid){var parentsVisible;grid.treeBase.tree.forEach(function(node){if(node.children&&node.children.length>0){parentsVisible=node.row.visible;service.fixFilterInternal(node.children,parentsVisible);}});},fixFilterInternal:function(nodes,parentsVisible){nodes.forEach(function(node){if(node.row.visible&&!parentsVisible){service.setParentsVisible(node);parentsVisible=true;}if(node.children&&node.children.length>0){if(service.fixFilterInternal(node.children,parentsVisible&&node.row.visible)){parentsVisible=true;}}});return parentsVisible;},setParentsVisible:function(node){while(node.parentRow){node.parentRow.visible=true;node=node.parentRow.treeNode;}},/**
       * @ngdoc function
       * @name buildAggregationObject
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Build the object which is stored on the column for holding meta-data about the aggregation.
       * This method should only be called with columns which have an aggregation.
       *
       * @param {GridColumn} column The column which this object relates to
       * @returns {object} {col: GridColumn object, label: string, type: string (optional)}
       */buildAggregationObject:function(column){var newAggregation={col:column};if(column.treeAggregation&&column.treeAggregation.type){newAggregation.type=column.treeAggregation.type;}if(column.treeAggregation&&column.treeAggregation.label){newAggregation.label=column.treeAggregation.label;}return newAggregation;},/**
       * @ngdoc function
       * @name getAggregations
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Looks through the grid columns to find those with aggregations,
       * and collates the aggregation information into an array, returns that array
       *
       * @param {Grid} grid the grid to get the aggregation information from
       * @returns {array} the aggregation information
       */getAggregations:function(grid){var aggregateArray=[];grid.columns.forEach(function(column){if(typeof column.treeAggregationFn!=='undefined'){aggregateArray.push(service.buildAggregationObject(column));if(grid.options.showColumnFooter&&typeof column.colDef.aggregationType==='undefined'&&column.treeAggregation){// Add aggregation object for footer
column.treeFooterAggregation=service.buildAggregationObject(column);column.aggregationType=service.treeFooterAggregationType;}}});return aggregateArray;},/**
       * @ngdoc function
       * @name aggregate
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Accumulate the data from this row onto the aggregations for each parent
       *
       * Iterate over the parents, then iterate over the aggregations for each of those parents,
       * and perform the aggregation for each individual aggregation
       *
       * @param {Grid} grid grid object
       * @param {GridRow} row the row we want to set grouping visibility on
       * @param {array} parents the parents that we would want to aggregate onto
       */aggregate:function(grid,row,parents){if(parents.length===0&&row.treeNode&&row.treeNode.aggregations){row.treeNode.aggregations.forEach(function(aggregation){// Calculate aggregations for footer even if there are no grouped rows
if(typeof aggregation.col.treeFooterAggregation!=='undefined'){var fieldValue=grid.getCellValue(row,aggregation.col);var numValue=Number(fieldValue);if(aggregation.col.treeAggregationFn){aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation,fieldValue,numValue,row);}else{aggregation.col.treeFooterAggregation.value=undefined;}}});}parents.forEach(function(parent,index){if(parent.treeNode.aggregations){parent.treeNode.aggregations.forEach(function(aggregation){var fieldValue=grid.getCellValue(row,aggregation.col);var numValue=Number(fieldValue);aggregation.col.treeAggregationFn(aggregation,fieldValue,numValue,row);if(index===0&&typeof aggregation.col.treeFooterAggregation!=='undefined'){if(aggregation.col.treeAggregationFn){aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation,fieldValue,numValue,row);}else{aggregation.col.treeFooterAggregation.value=undefined;}}});}});},// Aggregation routines - no doco needed as self evident
nativeAggregations:function(){return{count:{label:i18nService.get().aggregation.count,menuTitle:i18nService.get().grouping.aggregate_count,aggregationFn:function(aggregation,fieldValue,numValue){if(typeof aggregation.value==='undefined'){aggregation.value=1;}else{aggregation.value++;}}},sum:{label:i18nService.get().aggregation.sum,menuTitle:i18nService.get().grouping.aggregate_sum,aggregationFn:function(aggregation,fieldValue,numValue){if(!isNaN(numValue)){if(typeof aggregation.value==='undefined'){aggregation.value=numValue;}else{aggregation.value+=numValue;}}}},min:{label:i18nService.get().aggregation.min,menuTitle:i18nService.get().grouping.aggregate_min,aggregationFn:function(aggregation,fieldValue,numValue){if(typeof aggregation.value==='undefined'){aggregation.value=fieldValue;}else{if(typeof fieldValue!=='undefined'&&fieldValue!==null&&(fieldValue<aggregation.value||aggregation.value===null)){aggregation.value=fieldValue;}}}},max:{label:i18nService.get().aggregation.max,menuTitle:i18nService.get().grouping.aggregate_max,aggregationFn:function(aggregation,fieldValue,numValue){if(typeof aggregation.value==='undefined'){aggregation.value=fieldValue;}else{if(typeof fieldValue!=='undefined'&&fieldValue!==null&&(fieldValue>aggregation.value||aggregation.value===null)){aggregation.value=fieldValue;}}}},avg:{label:i18nService.get().aggregation.avg,menuTitle:i18nService.get().grouping.aggregate_avg,aggregationFn:function(aggregation,fieldValue,numValue){if(typeof aggregation.count==='undefined'){aggregation.count=1;}else{aggregation.count++;}if(isNaN(numValue)){return;}if(typeof aggregation.value==='undefined'||typeof aggregation.sum==='undefined'){aggregation.value=numValue;aggregation.sum=numValue;}else{aggregation.sum+=numValue;aggregation.value=aggregation.sum/aggregation.count;}}}};},/**
       * @ngdoc function
       * @name finaliseAggregation
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Helper function used to finalize aggregation nodes and footer cells
       *
       * @param {gridRow} row The parent we're finalising
       * @param {aggregation} aggregation The aggregation object manipulated by the aggregationFn
       */finaliseAggregation:function(row,aggregation){if(aggregation.col.treeAggregationUpdateEntity&&typeof row!=='undefined'&&typeof row.entity['$$'+aggregation.col.uid]!=='undefined'){angular.extend(aggregation,row.entity['$$'+aggregation.col.uid]);}if(typeof aggregation.col.treeAggregationFinalizerFn==='function'){aggregation.col.treeAggregationFinalizerFn(aggregation);}if(typeof aggregation.col.customTreeAggregationFinalizerFn==='function'){aggregation.col.customTreeAggregationFinalizerFn(aggregation);}if(typeof aggregation.rendered==='undefined'){aggregation.rendered=aggregation.label?aggregation.label+aggregation.value:aggregation.value;}},/**
       * @ngdoc function
       * @name finaliseAggregations
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Format the data from the aggregation into the rendered text
       * e.g. if we had label: 'sum: ' and value: 25, we'd create 'sum: 25'.
       *
       * As part of this we call any formatting callback routines we've been provided.
       *
       * We write our aggregation out to the row.entity if treeAggregationUpdateEntity is
       * set on the column - we don't overwrite any information that's already there, we append
       * to it so that grouping can have set the groupVal beforehand without us overwriting it.
       *
       * We need to copy the data from the row.entity first before we finalise the aggregation,
       * we need that information for the finaliserFn
       *
       * @param {gridRow} row the parent we're finalising
       */finaliseAggregations:function(row){if(row==null||typeof row.treeNode.aggregations==='undefined'){return;}row.treeNode.aggregations.forEach(function(aggregation){service.finaliseAggregation(row,aggregation);if(aggregation.col.treeAggregationUpdateEntity){var aggregationCopy={};angular.forEach(aggregation,function(value,key){if(aggregation.hasOwnProperty(key)&&key!=='col'){aggregationCopy[key]=value;}});row.entity['$$'+aggregation.col.uid]=aggregationCopy;}});},/**
       * @ngdoc function
       * @name treeFooterAggregationType
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Uses the tree aggregation functions and finalizers to set the
       * column footer aggregations.
       *
       * @param {rows} rows The visible rows. not used, but accepted to match signature of GridColumn.aggregationType
       * @param {GridColumn} column The column we are finalizing
       */treeFooterAggregationType:function(rows,column){service.finaliseAggregation(undefined,column.treeFooterAggregation);if(typeof column.treeFooterAggregation.value==='undefined'||column.treeFooterAggregation.rendered===null){// The was apparently no aggregation performed (perhaps this is a grouped column
return'';}return column.treeFooterAggregation.rendered;}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.treeBase.directive:uiGridTreeRowHeaderButtons
   *  @element div
   *
   *  @description Provides the expand/collapse button on rows
   */module.directive('uiGridTreeBaseRowHeaderButtons',['$templateCache','uiGridTreeBaseService',function($templateCache,uiGridTreeBaseService){return{replace:true,restrict:'E',template:$templateCache.get('ui-grid/treeBaseRowHeaderButtons'),scope:true,require:'^uiGrid',link:function($scope,$elm,$attrs,uiGridCtrl){var self=uiGridCtrl.grid;$scope.treeButtonClass=function(row){if(self.options.showTreeExpandNoChildren&&row.treeLevel>-1||row.treeNode.children&&row.treeNode.children.length>0){if(row.treeNode.state==='expanded'){return'ui-grid-icon-minus-squared';}if(row.treeNode.state==='collapsed'){return'ui-grid-icon-plus-squared';}}};$scope.treeButtonClick=function(row,evt){evt.stopPropagation();uiGridTreeBaseService.toggleRowTreeState(self,row,evt);};$scope.treeButtonKeyDown=function(row,evt){if(evt.keyCode===32||evt.keyCode===13){$scope.treeButtonClick(row,evt);}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.treeBase.directive:uiGridTreeBaseExpandAllButtons
   *  @element div
   *
   *  @description Provides the expand/collapse all button
   */module.directive('uiGridTreeBaseExpandAllButtons',['$templateCache','uiGridTreeBaseService',function($templateCache,uiGridTreeBaseService){return{replace:true,restrict:'E',template:$templateCache.get('ui-grid/treeBaseExpandAllButtons'),scope:false,link:function($scope){var self=$scope.col.grid;$scope.headerButtonClass=function(){if(self.treeBase.numberLevels>0&&self.treeBase.expandAll){return'ui-grid-icon-minus-squared';}if(self.treeBase.numberLevels>0&&!self.treeBase.expandAll){return'ui-grid-icon-plus-squared';}};$scope.headerButtonClick=function(row,evt){if(self.treeBase.expandAll){uiGridTreeBaseService.collapseAllRows(self,evt);}else{uiGridTreeBaseService.expandAllRows(self,evt);}};$scope.headerButtonKeyDown=function(evt){if(evt.keyCode===32||evt.keyCode===13){$scope.headerButtonClick(self,evt);}};}};}]);/**
   *  @ngdoc directive
   *  @name ui.grid.treeBase.directive:uiGridViewport
   *  @element div
   *
   *  @description Stacks on top of ui.grid.uiGridViewport to set formatting on a tree header row
   */module.directive('uiGridViewport',function(){return{priority:-200,// run after default  directive
scope:false,compile:function($elm){var rowRepeatDiv=angular.element($elm.children().children()[0]);var existingNgClass=rowRepeatDiv.attr("ng-class");var newNgClass='';if(existingNgClass){newNgClass=existingNgClass.slice(0,-1)+",'ui-grid-tree-header-row': row.treeLevel > -1}";}else{newNgClass="{'ui-grid-tree-header-row': row.treeLevel > -1}";}rowRepeatDiv.attr("ng-class",newNgClass);return{pre:function($scope,$elm,$attrs,controllers){},post:function($scope,$elm,$attrs,controllers){}};}};});})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.treeView
   * @description
   *
   * # ui.grid.treeView
   *
   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
   *
   * This module provides a tree view of the data that it is provided, with nodes in that
   * tree and leaves.  Unlike grouping, the tree is an inherent property of the data and must
   * be provided with your data array.
   *
   * Design information:
   * -------------------
   *
   * TreeView uses treeBase for the underlying functionality, and is a very thin wrapper around
   * that logic.  Most of the design information has now moved to treebase.
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.treeView"></div>
   */var module=angular.module('ui.grid.treeView',['ui.grid','ui.grid.treeBase']);/**
   *  @ngdoc object
   *  @name ui.grid.treeView.constant:uiGridTreeViewConstants
   *
   *  @description constants available in treeView module, this includes
   *  all the constants declared in the treeBase module (these are manually copied
   *  as there isn't an easy way to include constants in another constants file, and
   *  we don't want to make users include treeBase)
   *
   */module.constant('uiGridTreeViewConstants',{featureName:"treeView",rowHeaderColName:'treeBaseRowHeaderCol',EXPANDED:'expanded',COLLAPSED:'collapsed',aggregation:{COUNT:'count',SUM:'sum',MAX:'max',MIN:'min',AVG:'avg'}});/**
   *  @ngdoc service
   *  @name ui.grid.treeView.service:uiGridTreeViewService
   *
   *  @description Services for treeView features
   */module.service('uiGridTreeViewService',['$q','uiGridTreeViewConstants','uiGridTreeBaseConstants','uiGridTreeBaseService','gridUtil','GridRow','gridClassFactory','i18nService','uiGridConstants',function($q,uiGridTreeViewConstants,uiGridTreeBaseConstants,uiGridTreeBaseService,gridUtil,GridRow,gridClassFactory,i18nService,uiGridConstants){var service={initializeGrid:function(grid,$scope){uiGridTreeBaseService.initializeGrid(grid,$scope);/**
         *  @ngdoc object
         *  @name ui.grid.treeView.grid:treeView
         *
         *  @description Grid properties and functions added for treeView
         */grid.treeView={};grid.registerRowsProcessor(service.adjustSorting,60);/**
         *  @ngdoc object
         *  @name ui.grid.treeView.api:PublicApi
         *
         *  @description Public Api for treeView feature
         */var publicApi={events:{treeView:{}},methods:{treeView:{}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);},defaultGridOptions:function(gridOptions){// default option to true unless it was explicitly set to false
/**
         *  @ngdoc object
         *  @name ui.grid.treeView.api:GridOptions
         *
         *  @description GridOptions for treeView feature, these are available to be
         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
         *
         *  Many tree options are set on treeBase, make sure to look at that feature in
         *  conjunction with these options.
         */ /**
         *  @ngdoc object
         *  @name enableTreeView
         *  @propertyOf  ui.grid.treeView.api:GridOptions
         *  @description Enable row tree view for entire grid.
         *  <br/>Defaults to true
         */gridOptions.enableTreeView=gridOptions.enableTreeView!==false;},/**
       * @ngdoc function
       * @name adjustSorting
       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
       * @description Trees cannot be sorted the same as flat lists of rows -
       * trees are sorted recursively within each level - so the children of each
       * node are sorted, but not the full set of rows.
       *
       * To achieve this, we suppress the normal sorting by setting ignoreSort on
       * each of the sort columns.  When the treeBase rowsProcessor runs it will then
       * unignore these, and will perform a recursive sort against the tree that it builds.
       *
       * @param {array} renderableRows the rows that we need to pass on through
       * @returns {array} renderableRows that we passed on through
       */adjustSorting:function(renderableRows){var grid=this;grid.columns.forEach(function(column){if(column.sort){column.sort.ignoreSort=true;}});return renderableRows;}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.treeView.directive:uiGridTreeView
   *  @element div
   *  @restrict A
   *
   *  @description Adds treeView features to grid
   *
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.treeView']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name', enableCellEdit: true},
        {name: 'title', enableCellEdit: true}
      ];

      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="gridOptions" ui-grid-tree-view></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridTreeView',['uiGridTreeViewConstants','uiGridTreeViewService','$templateCache',function(uiGridTreeViewConstants,uiGridTreeViewService,$templateCache){return{replace:true,priority:0,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){if(uiGridCtrl.grid.options.enableTreeView!==false){uiGridTreeViewService.initializeGrid(uiGridCtrl.grid,$scope);}},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);})();(function(){'use strict';/**
   * @ngdoc overview
   * @name ui.grid.validate
   * @description
   *
   * # ui.grid.validate
   *
   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
   *
   * This module provides the ability to validate cells upon change.
   *
   * Design information:
   * -------------------
   *
   * Validation is not based on angularjs validation, since it would work only when editing the field.
   *
   * Instead it adds custom properties to any field considered as invalid.
   *
   * <br/>
   * <br/>
   *
   * <div doc-module-components="ui.grid.expandable"></div>
   */var module=angular.module('ui.grid.validate',['ui.grid']);/**
   *  @ngdoc service
   *  @name ui.grid.validate.service:uiGridValidateService
   *
   *  @description Services for validation features
   */module.service('uiGridValidateService',['$sce','$q','$http','i18nService','uiGridConstants',function($sce,$q,$http,i18nService,uiGridConstants){var service={/**
       *  @ngdoc object
       *  @name validatorFactories
       *  @propertyOf ui.grid.validate.service:uiGridValidateService
       *  @description object containing all the factories used to validate data.<br/>
       *  These factories will be in the form <br/>
       *  ```
       *  {
       *    validatorFactory: function(argument) {
       *                        return function(newValue, oldValue, rowEntity, colDef) {
       *                          return true || false || promise
       *                        }
       *                      },
       *    messageFunction: function(argument) {
       *                       return string
       *                     }
       *  }
       *  ```
       *
       * Promises should return true or false as result according to the result of validation.
       */validatorFactories:{},/**
       * @ngdoc service
       * @name setExternalFactoryFunction
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Adds a way to retrieve validators from an external service
       * <p>Validators from this external service have a higher priority than default
       * ones
       * @param {function} externalFactoryFunction a function that accepts name and argument to pass to a
       * validator factory and that returns an object with the same properties as
       * you can see in {@link ui.grid.validate.service:uiGridValidateService#properties_validatorFactories validatorFactories}
       */setExternalFactoryFunction:function(externalFactoryFunction){service.externalFactoryFunction=externalFactoryFunction;},/**
       * @ngdoc service
       * @name clearExternalFactory
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Removes any link to external factory from this service
       */clearExternalFactory:function(){delete service.externalFactoryFunction;},/**
       * @ngdoc service
       * @name getValidatorFromExternalFactory
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Retrieves a validator by executing a validatorFactory
       * stored in an external service.
       * @param {string} name the name of the validator to retrieve
       * @param {object} argument an argument to pass to the validator factory
       */getValidatorFromExternalFactory:function(name,argument){return service.externalFactoryFunction(name,argument).validatorFactory(argument);},/**
       * @ngdoc service
       * @name getMessageFromExternalFactory
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Retrieves a message stored in an external service.
       * @param {string} name the name of the validator
       * @param {object} argument an argument to pass to the message function
       */getMessageFromExternalFactory:function(name,argument){return service.externalFactoryFunction(name,argument).messageFunction(argument);},/**
       * @ngdoc service
       * @name setValidator
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description  Adds a new validator to the service
       * @param {string} name the name of the validator, must be unique
       * @param {function} validatorFactory a factory that return a validatorFunction
       * @param {function} messageFunction a function that return the error message
       */setValidator:function(name,validatorFactory,messageFunction){service.validatorFactories[name]={validatorFactory:validatorFactory,messageFunction:messageFunction};},/**
       * @ngdoc service
       * @name getValidator
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Returns a validator registered to the service
       * or retrieved from the external factory
       * @param {string} name the name of the validator to retrieve
       * @param {object} argument an argument to pass to the validator factory
       * @returns {object} the validator function
       */getValidator:function(name,argument){if(service.externalFactoryFunction){var validator=service.getValidatorFromExternalFactory(name,argument);if(validator){return validator;}}if(!service.validatorFactories[name]){throw"Invalid validator name: "+name;}return service.validatorFactories[name].validatorFactory(argument);},/**
       * @ngdoc service
       * @name getMessage
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Returns the error message related to the validator
       * @param {string} name the name of the validator
       * @param {object} argument an argument to pass to the message function
       * @returns {string} the error message related to the validator
       */getMessage:function(name,argument){if(service.externalFactoryFunction){var message=service.getMessageFromExternalFactory(name,argument);if(message){return message;}}return service.validatorFactories[name].messageFunction(argument);},/**
       * @ngdoc service
       * @name isInvalid
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Returns true if the cell (identified by rowEntity, colDef) is invalid
       * @param {object} rowEntity the row entity of the cell
       * @param {object} colDef the colDef of the cell
       * @returns {boolean} true if the cell is invalid
       */isInvalid:function(rowEntity,colDef){return rowEntity['$$invalid'+colDef.name];},/**
       * @ngdoc service
       * @name setInvalid
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Makes the cell invalid by adding the proper field to the entity
       * @param {object} rowEntity the row entity of the cell
       * @param {object} colDef the colDef of the cell
       */setInvalid:function(rowEntity,colDef){rowEntity['$$invalid'+colDef.name]=true;},/**
       * @ngdoc service
       * @name setValid
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Makes the cell valid by removing the proper error field from the entity
       * @param {object} rowEntity the row entity of the cell
       * @param {object} colDef the colDef of the cell
       */setValid:function(rowEntity,colDef){delete rowEntity['$$invalid'+colDef.name];},/**
       * @ngdoc service
       * @name setError
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Adds the proper error to the entity errors field
       * @param {object} rowEntity the row entity of the cell
       * @param {object} colDef the colDef of the cell
       * @param {string} validatorName the name of the validator that is failing
       */setError:function(rowEntity,colDef,validatorName){if(!rowEntity['$$errors'+colDef.name]){rowEntity['$$errors'+colDef.name]={};}rowEntity['$$errors'+colDef.name][validatorName]=true;},/**
       * @ngdoc service
       * @name clearError
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Removes the proper error from the entity errors field
       * @param {object} rowEntity the row entity of the cell
       * @param {object} colDef the colDef of the cell
       * @param {string} validatorName the name of the validator that is failing
       */clearError:function(rowEntity,colDef,validatorName){if(!rowEntity['$$errors'+colDef.name]){return;}if(validatorName in rowEntity['$$errors'+colDef.name]){delete rowEntity['$$errors'+colDef.name][validatorName];}},/**
       * @ngdoc function
       * @name getErrorMessages
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description returns an array of i18n-ed error messages.
       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
       * @param {object} colDef the column whose errors we are looking for
       * @returns {array} An array of strings containing all the error messages for the cell
       */getErrorMessages:function(rowEntity,colDef){var errors=[];if(!rowEntity['$$errors'+colDef.name]||Object.keys(rowEntity['$$errors'+colDef.name]).length===0){return errors;}Object.keys(rowEntity['$$errors'+colDef.name]).sort().forEach(function(validatorName){errors.push(service.getMessage(validatorName,colDef.validators[validatorName]));});return errors;},/**
       * @ngdoc function
       * @name getFormattedErrors
       * @methodOf  ui.grid.validate.service:uiGridValidateService
       * @description returns the error i18n-ed and formatted in html to be shown inside the page.
       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
       * @param {object} colDef the column whose errors we are looking for
       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
       * message inside the page (i.e. inside a div)
       */getFormattedErrors:function(rowEntity,colDef){var msgString="",errors=service.getErrorMessages(rowEntity,colDef);if(!errors.length){return;}errors.forEach(function(errorMsg){msgString+=errorMsg+"<br/>";});return $sce.trustAsHtml('<p><b>'+i18nService.getSafeText('validate.error')+'</b></p>'+msgString);},/**
       * @ngdoc function
       * @name getTitleFormattedErrors
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
       * title attribute.
       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
       * @param {object} colDef the column whose errors we are looking for
       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
       * message inside an html title attribute
       */getTitleFormattedErrors:function(rowEntity,colDef){var newLine="\n",msgString="",errors=service.getErrorMessages(rowEntity,colDef);if(!errors.length){return;}errors.forEach(function(errorMsg){msgString+=errorMsg+newLine;});return $sce.trustAsHtml(i18nService.getSafeText('validate.error')+newLine+msgString);},/**
       * @ngdoc function
       * @name getTitleFormattedErrors
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description Executes all validators on a cell (identified by row entity and column definition) and sets or clears errors
       * @param {object} rowEntity the row entity of the cell we want to run the validators on
       * @param {object} colDef the column definition of the cell we want to run the validators on
       * @param {object} newValue the value the user just entered
       * @param {object} oldValue the value the field had before
       */runValidators:function(rowEntity,colDef,newValue,oldValue,grid){if(newValue===oldValue){// If the value has not changed we perform no validation
return;}if(typeof colDef.name==='undefined'||!colDef.name){throw new Error('colDef.name is required to perform validation');}service.setValid(rowEntity,colDef);var validateClosureFactory=function(rowEntity,colDef,validatorName){return function(value){if(!value){service.setInvalid(rowEntity,colDef);service.setError(rowEntity,colDef,validatorName);if(grid){grid.api.validate.raise.validationFailed(rowEntity,colDef,newValue,oldValue);}}};};var promises=[];for(var validatorName in colDef.validators){service.clearError(rowEntity,colDef,validatorName);var validatorFunction=service.getValidator(validatorName,colDef.validators[validatorName]);// We pass the arguments as oldValue, newValue so they are in the same order
// as ng-model validators (modelValue, viewValue)
var promise=$q.when(validatorFunction(oldValue,newValue,rowEntity,colDef)).then(validateClosureFactory(rowEntity,colDef,validatorName));promises.push(promise);}return $q.all(promises);},/**
       * @ngdoc function
       * @name createDefaultValidators
       * @methodOf ui.grid.validate.service:uiGridValidateService
       * @description adds the basic validators to the list of service validators
       */createDefaultValidators:function(){service.setValidator('minLength',function(argument){return function(oldValue,newValue){if(newValue===undefined||newValue===null||newValue===''){return true;}return newValue.length>=argument;};},function(argument){return i18nService.getSafeText('validate.minLength').replace('THRESHOLD',argument);});service.setValidator('maxLength',function(argument){return function(oldValue,newValue){if(newValue===undefined||newValue===null||newValue===''){return true;}return newValue.length<=argument;};},function(threshold){return i18nService.getSafeText('validate.maxLength').replace('THRESHOLD',threshold);});service.setValidator('required',function(argument){return function(oldValue,newValue){if(argument){return!(newValue===undefined||newValue===null||newValue==='');}return true;};},function(){return i18nService.getSafeText('validate.required');});},initializeGrid:function(scope,grid){grid.validate={isInvalid:service.isInvalid,getErrorMessages:service.getErrorMessages,getFormattedErrors:service.getFormattedErrors,getTitleFormattedErrors:service.getTitleFormattedErrors,runValidators:service.runValidators};/**
         *  @ngdoc object
         *  @name ui.grid.validate.api:PublicApi
         *
         *  @description Public Api for validation feature
         */var publicApi={events:{validate:{/**
               * @ngdoc event
               * @name validationFailed
               * @eventOf ui.grid.validate.api:PublicApi
               * @description raised when one or more failure happened during validation
               * <pre>
               *      gridApi.validate.on.validationFailed(scope, function(rowEntity, colDef, newValue, oldValue){...})
               * </pre>
               * @param {object} rowEntity the options.data element whose validation failed
               * @param {object} colDef the column whose validation failed
               * @param {object} newValue new value
               * @param {object} oldValue old value
               */validationFailed:function(rowEntity,colDef,newValue,oldValue){}}},methods:{validate:{/**
               * @ngdoc function
               * @name isInvalid
               * @methodOf ui.grid.validate.api:PublicApi
               * @description checks if a cell (identified by rowEntity, colDef) is invalid
               * @param {object} rowEntity gridOptions.data[] array instance we want to check
               * @param {object} colDef the column whose errors we want to check
               * @returns {boolean} true if the cell value is not valid
               */isInvalid:function(rowEntity,colDef){return grid.validate.isInvalid(rowEntity,colDef);},/**
               * @ngdoc function
               * @name getErrorMessages
               * @methodOf ui.grid.validate.api:PublicApi
               * @description returns an array of i18n-ed error messages.
               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
               * @param {object} colDef the column whose errors we are looking for
               * @returns {array} An array of strings containing all the error messages for the cell
               */getErrorMessages:function(rowEntity,colDef){return grid.validate.getErrorMessages(rowEntity,colDef);},/**
               * @ngdoc function
               * @name getFormattedErrors
               * @methodOf ui.grid.validate.api:PublicApi
               * @description returns the error i18n-ed and formatted in html to be shown inside the page.
               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
               * @param {object} colDef the column whose errors we are looking for
               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
               * message inside the page (i.e. inside a div)
               */getFormattedErrors:function(rowEntity,colDef){return grid.validate.getFormattedErrors(rowEntity,colDef);},/**
               * @ngdoc function
               * @name getTitleFormattedErrors
               * @methodOf ui.grid.validate.api:PublicApi
               * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html
               * title attribute.
               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
               * @param {object} colDef the column whose errors we are looking for
               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
               * message inside an html title attribute
               */getTitleFormattedErrors:function(rowEntity,colDef){return grid.validate.getTitleFormattedErrors(rowEntity,colDef);}}}};grid.api.registerEventsFromObject(publicApi.events);grid.api.registerMethodsFromObject(publicApi.methods);if(grid.edit){grid.api.edit.on.afterCellEdit(scope,function(rowEntity,colDef,newValue,oldValue){grid.validate.runValidators(rowEntity,colDef,newValue,oldValue,grid);});}service.createDefaultValidators();}};return service;}]);/**
   *  @ngdoc directive
   *  @name ui.grid.validate.directive:uiGridValidate
   *  @element div
   *  @restrict A
   *  @description Adds validating features to the ui-grid directive.
   *  @example
   <example module="app">
   <file name="app.js">
   var app = angular.module('app', ['ui.grid', 'ui.grid.edit', 'ui.grid.validate']);

   app.controller('MainCtrl', ['$scope', function ($scope) {
      $scope.data = [
        { name: 'Bob', title: 'CEO' },
            { name: 'Frank', title: 'Lowly Developer' }
      ];

      $scope.columnDefs = [
        {name: 'name', enableCellEdit: true, validators: {minLength: 3, maxLength: 9}, cellTemplate: 'ui-grid/cellTitleValidator'},
        {name: 'title', enableCellEdit: true, validators: {required: true}, cellTemplate: 'ui-grid/cellTitleValidator'}
      ];
    }]);
   </file>
   <file name="index.html">
   <div ng-controller="MainCtrl">
   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit ui-grid-validate></div>
   </div>
   </file>
   </example>
   */module.directive('uiGridValidate',['gridUtil','uiGridValidateService',function(gridUtil,uiGridValidateService){return{priority:0,replace:true,require:'^uiGrid',scope:false,compile:function(){return{pre:function($scope,$elm,$attrs,uiGridCtrl){uiGridValidateService.initializeGrid($scope,uiGridCtrl.grid);},post:function($scope,$elm,$attrs,uiGridCtrl){}};}};}]);})();angular.module('ui.grid').run(['$templateCache',function($templateCache){'use strict';$templateCache.put('ui-grid/ui-grid-filter',"<div class=\"ui-grid-filter-container\" ng-style=\"col.extraStyle\" ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input type=\"text\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\"><div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-show=\"colFilter.selectOptions.length > 0\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div></div>");$templateCache.put('ui-grid/ui-grid-footer',"<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\"><!-- tfooter --><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=\"ui-grid-footer-canvas\"><div class=\"ui-grid-footer-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-footer-cell-row\"><div ui-grid-footer-cell role=\"gridcell\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" col=\"col\" render-index=\"$index\" class=\"ui-grid-footer-cell ui-grid-clearfix\"></div></div></div></div></div></div>");$templateCache.put('ui-grid/ui-grid-grid-footer',"<div class=\"ui-grid-footer-info ui-grid-grid-footer\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>");$templateCache.put('ui-grid/ui-grid-header',"<div role=\"rowgroup\" class=\"ui-grid-header\"><!-- theader --><div class=\"ui-grid-top-panel\"><div class=\"ui-grid-header-viewport\"><div class=\"ui-grid-header-canvas\"><div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-header-cell-row\"><div role=\"columnheader\" class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\"></div></div></div></div></div></div></div>");$templateCache.put('ui-grid/ui-grid-menu-button',"<div class=\"ui-grid-menu-button\"><div role=\"button\" ui-grid-one-bind-id-grid=\"'grid-menu'\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\" tabindex=\"0\" class=\"ui-grid-icon-container\" ng-click=\"toggleMenu()\" ng-keydown=\"toggleOnKeydown($event)\" aria-expanded=\"{{shown}}\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-menu\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\">&nbsp;</i></div><div ui-grid-menu menu-items=\"menuItems\"></div></div>");$templateCache.put('ui-grid/ui-grid-menu-header-item',"<li role=\"menuitem\"><div class=\"ui-grid-menu-item\" role=\"heading\" aria-level=\"2\" ng-show=\"itemShown()\"><i aria-hidden=\"true\">&nbsp; </i><span ng-bind=\"label()\"></span></div></li>");$templateCache.put('ui-grid/ui-grid-no-header',"<div class=\"ui-grid-top-panel\"></div>");$templateCache.put('ui-grid/ui-grid-row',"<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>");$templateCache.put('ui-grid/ui-grid',"<div ui-i18n=\"en\" class=\"ui-grid\"><!-- TODO (c0bra): add \"scoped\" attr here, eventually? --><style ui-grid-style>.grid{{ grid.id }} {\n"+"      /* Styles for the grid */\n"+"    }\n"+"\n"+"    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n"+"      height: {{ grid.options.rowHeight }}px;\n"+"    }\n"+"\n"+"    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n"+"      border-bottom-width: {{ (((grid.getVisibleRowCount() * grid.options.rowHeight) < grid.getViewportHeight()) && '1') || '0' }}px;\n"+"    }\n"+"\n"+"    {{ grid.verticalScrollbarStyles }}\n"+"    {{ grid.horizontalScrollbarStyles }}\n"+"\n"+"    /*\n"+"    .ui-grid[dir=rtl] .ui-grid-viewport {\n"+"      padding-left: {{ grid.verticalScrollbarWidth }}px;\n"+"    }\n"+"    */\n"+"\n"+"    {{ grid.customStyles }}</style><div class=\"ui-grid-contents-wrapper\" role=\"grid\"><div ui-grid-menu-button ng-if=\"grid.options.enableGridMenu\"></div><div ng-if=\"grid.hasLeftContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'left'\"></div><div ui-grid-render-container container-id=\"'body'\" col-container-name=\"'body'\" row-container-name=\"'body'\" bind-scroll-horizontal=\"true\" bind-scroll-vertical=\"true\" enable-horizontal-scrollbar=\"grid.options.enableHorizontalScrollbar\" enable-vertical-scrollbar=\"grid.options.enableVerticalScrollbar\"></div><div ng-if=\"grid.hasRightContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'right'\"></div><div ui-grid-grid-footer ng-if=\"grid.options.showGridFooter\"></div><div ui-grid-column-menu ng-if=\"grid.options.enableColumnMenus\"></div><div ng-transclude></div></div></div>");$templateCache.put('ui-grid/uiGridCell',"<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>");$templateCache.put('ui-grid/uiGridColumnMenu',"<div class=\"ui-grid-column-menu\"><div ui-grid-menu menu-items=\"menuItems\" col=\"col\"><!-- <div class=\"ui-grid-column-menu\">\n"+"    <div class=\"inner\" ng-show=\"menuShown\">\n"+"      <ul>\n"+"        <div ng-show=\"grid.options.enableSorting\">\n"+"          <li ng-click=\"sortColumn($event, asc)\" ng-class=\"{ 'selected' : col.sort.direction == asc }\"><i class=\"ui-grid-icon-sort-alt-up\"></i> Sort Ascending</li>\n"+"          <li ng-click=\"sortColumn($event, desc)\" ng-class=\"{ 'selected' : col.sort.direction == desc }\"><i class=\"ui-grid-icon-sort-alt-down\"></i> Sort Descending</li>\n"+"          <li ng-show=\"col.sort.direction\" ng-click=\"unsortColumn()\"><i class=\"ui-grid-icon-cancel\"></i> Remove Sort</li>\n"+"        </div>\n"+"      </ul>\n"+"    </div>\n"+"  </div> --></div></div>");$templateCache.put('ui-grid/uiGridFooterCell',"<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>");$templateCache.put('ui-grid/uiGridHeaderCell',"<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable, 'ui-grid-header-cell-last-col': isLastCol }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" ng-keydown=\"handleKeyDown($event)\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}\" aria-hidden=\"true\"></i> <sub ui-grid-visible=\"isSortPriorityVisible()\" class=\"ui-grid-sort-priority-number\">{{col.sort.priority + 1}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-keydown=\"headerCellArrowKeyDown($event)\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-expanded=\"{{col.menuShown}}\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter ng-hide=\"col.filterContainer === 'columnMenu'\"></div></div>");$templateCache.put('ui-grid/uiGridMenu',"<div class=\"ui-grid-menu\" ng-keydown=\"checkKeyDown($event)\" ng-show=\"shown\"><style ui-grid-style>{{dynamicStyles}}</style><div class=\"ui-grid-menu-mid\" ng-show=\"shownMid\"><div class=\"ui-grid-menu-inner\" ng-if=\"shown\"><ul role=\"menu\" class=\"ui-grid-menu-items\"><li ng-repeat=\"item in menuItems\" role=\"menuitem\" ui-grid-menu-item ui-grid-one-bind-id=\"'menuitem-'+$index\" action=\"item.action\" name=\"item.title\" active=\"item.active\" icon=\"item.icon\" shown=\"item.shown\" context=\"item.context\" template-url=\"item.templateUrl\" leave-open=\"item.leaveOpen\" screen-reader-only=\"item.screenReaderOnly\"></li><li ng-if=\"col.filterable && col.filterContainer === 'columnMenu'\"><div ui-grid-filter></div></li></ul></div></div></div>");$templateCache.put('ui-grid/uiGridMenuItem',"<button type=\"button\" class=\"ui-grid-menu-item\" ng-click=\"itemAction($event, title)\" ng-show=\"itemShown()\" ng-class=\"{ 'ui-grid-menu-item-active': active(), 'ui-grid-sr-only': (!focus && screenReaderOnly) }\" aria-pressed=\"{{active()}}\" tabindex=\"0\" ng-focus=\"focus=true\" ng-blur=\"focus=false\"><i ng-class=\"icon\" aria-hidden=\"true\">&nbsp; </i>{{ label() }}</button>");$templateCache.put('ui-grid/uiGridRenderContainer',"<div role=\"presentation\" ui-grid-one-bind-id-grid=\"containerId + '-grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\"><!-- All of these dom elements are replaced in place --><div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height: colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>");$templateCache.put('ui-grid/uiGridViewport',"<div role=\"rowgroup\" class=\"ui-grid-viewport\" ng-style=\"colContainer.getViewportStyle()\"><!-- tbody --><div class=\"ui-grid-canvas\"><div ng-repeat=\"(rowRenderIndex, row) in rowContainer.renderedRows track by $index\" class=\"ui-grid-row\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div role=\"row\" ui-grid-row=\"row\" row-render-index=\"rowRenderIndex\"></div></div></div></div>");$templateCache.put('ui-grid/cellEditor',"<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>");$templateCache.put('ui-grid/dropdownEditor',"<div><form name=\"inputForm\"><select ng-class=\"'colt' + col.uid\" ui-grid-edit-dropdown ng-model=\"MODEL_COL_FIELD\" ng-options=\"field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray\"></select></form></div>");$templateCache.put('ui-grid/fileChooserEditor',"<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" ui-grid-edit-file-chooser type=\"file\" id=\"files\" name=\"files[]\" ng-model=\"MODEL_COL_FIELD\"></form></div>");$templateCache.put('ui-grid/emptyBaseLayerContainer',"<div class=\"ui-grid-empty-base-layer-container ui-grid-canvas\"><div class=\"ui-grid-row\" ng-repeat=\"(rowRenderIndex, row) in grid.baseLayer.emptyRows track by $index\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div><div><div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" class=\"ui-grid-cell {{ col.getColClass(false) }}\"></div></div></div></div></div>");$templateCache.put('ui-grid/expandableRow',"<div ui-grid-expandable-row ng-if=\"expandableRow.shouldRenderExpand()\" class=\"expandableRow\" style=\"float:left; margin-top: 1px; margin-bottom: 1px\" ng-style=\"{width: (grid.renderContainers.body.getCanvasWidth()) + 'px', height: row.expandedRowHeight + 'px'}\"></div>");$templateCache.put('ui-grid/expandableRowHeader',"<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i class=\"clickable\" ng-if=\"!(row.groupHeader==true || row.entity.subGridOptions.disableRowExpandable)\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !row.isExpanded, 'ui-grid-icon-minus-squared' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity, $event)\" aria-expanded=\"{{!!row.isExpanded}}\"></i></div></div>");$templateCache.put('ui-grid/expandableScrollFiller',"<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller: true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\">&nbsp;</div>");$templateCache.put('ui-grid/expandableTopRowHeader',"<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><span class=\"ui-grid-cell-empty\" ng-if=\"!grid.options.showExpandAllButton\"></span> <button type=\"button\" class=\"ui-grid-icon-button clickable\" ng-if=\"grid.options.showExpandAllButton\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !grid.expandable.expandedAll, 'ui-grid-icon-minus-squared' : grid.expandable.expandedAll }\" ng-click=\"grid.api.expandable.toggleAllRows()\" aria-expanded=\"{{grid.expandable.expandedAll}}\"></button></div></div>");$templateCache.put('ui-grid/csvLink',"<span class=\"ui-grid-exporter-csv-link-span\"><a href=\"data:text/csv;charset=UTF-8,CSV_CONTENT\" download=\"FILE_NAME\">LINK_LABEL</a></span>");$templateCache.put('ui-grid/importerMenuItem',"<li class=\"ui-grid-menu-item\"><form><input class=\"ui-grid-importer-file-chooser\" type=\"file\" id=\"files\" name=\"files[]\"></form></li>");$templateCache.put('ui-grid/importerMenuItemContainer',"<div ui-grid-importer-menu-item></div>");$templateCache.put('ui-grid/pagination',"<div class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div class=\"ui-grid-pager-control\"><button type=\"button\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle' : 'first-triangle'\"><div ng-class=\"grid.isRTL() ? 'last-bar-rtl' : 'first-bar'\"></div></div></button> <button type=\"button\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle prev-triangle' : 'first-triangle prev-triangle'\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" step=\"1\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/ </abbr>{{ paginationApi.getTotalPages() }} </span><button type=\"button\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div ng-class=\"grid.isRTL() ? 'first-triangle next-triangle' : 'last-triangle next-triangle'\"></div></button> <button type=\"button\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div ng-class=\"grid.isRTL() ? 'first-triangle' : 'last-triangle'\"><div ng-class=\"grid.isRTL() ? 'first-bar-rtl' : 'last-bar'\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1 && !grid.options.useCustomPagination\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select> <span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{ 1 + paginationApi.getFirstRowIndex() }} <abbr ui-grid-one-bind-title=\"paginationThrough\">- </abbr>{{ 1 + paginationApi.getLastRowIndex() }} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>");$templateCache.put('ui-grid/columnResizer',"<div ui-grid-column-resizer ng-if=\"grid.options.enableColumnResizing\" class=\"ui-grid-column-resizer\" col=\"col\" position=\"right\" render-index=\"renderIndex\" unselectable=\"on\"></div>");$templateCache.put('ui-grid/gridFooterSelectedItems',"<span ng-if=\"grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected\">({{\"search.selectedItems\" | t}} {{grid.selection.selectedCount}})</span>");$templateCache.put('ui-grid/selectionHeaderCell',"<div><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-selection-select-all-buttons ng-if=\"grid.options.enableSelectAll\" role=\"checkbox\" ng-model=\"grid.selection.selectAll\"></ui-grid-selection-select-all-buttons></div></div>");$templateCache.put('ui-grid/selectionRowHeader',"<div class=\"ui-grid-cell-contents ui-grid-disable-selection clickable\"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div>");$templateCache.put('ui-grid/selectionRowHeaderButtons',"<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok clickable\" ng-class=\"{'ui-grid-row-selected': row.isSelected}\" tabindex=\"0\" ng-click=\"selectButtonClick(row, $event)\" ng-keydown=\"selectButtonKeyDown(row, $event)\" ng-attr-aria-label=\"{{('selection.aria.row' | t) + ' ' + (row.index + 1) + ', ' + col.displayName}}\" aria-checked=\"{{row.isSelected}}\" role=\"checkbox\" ng-model=\"row.isSelected\">&nbsp;</div>");$templateCache.put('ui-grid/selectionSelectAllButtons',"<div role=\"checkbox\" tabindex=\"0\" class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ui-grid-one-bind-aria-label=\"'selection.selectAll' | t\" aria-checked=\"{{grid.selection.selectAll}}\" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>");$templateCache.put('ui-grid/treeBaseExpandAllButtons',"<div class=\"ui-grid-tree-base-row-header-buttons\" tabindex=\"0\" ng-class=\"headerButtonClass()\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>");$templateCache.put('ui-grid/treeBaseHeaderCell',"<div><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-tree-base-expand-all-buttons ng-if=\"grid.options.enableExpandAll\"></ui-grid-tree-base-expand-all-buttons></div></div>");$templateCache.put('ui-grid/treeBaseRowHeader',"<div class=\"ui-grid-cell-contents\"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>");$templateCache.put('ui-grid/treeBaseRowHeaderButtons',"<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-tree-base-header': row.treeLevel > -1 }\" tabindex=\"0\" ng-keydown=\"treeButtonKeyDown(row, $event)\" ng-click=\"treeButtonClick(row, $event)\"><i ng-class=\"treeButtonClass(row)\" ng-style=\"{'padding-left': grid.options.treeIndent * row.treeLevel + 'px'}\"></i> &nbsp;</div>");$templateCache.put('ui-grid/cellTitleValidator',"<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" title=\"{{grid.validate.getTitleFormattedErrors(row.entity,col.colDef)}}\">{{COL_FIELD CUSTOM_FILTERS}}</div>");$templateCache.put('ui-grid/cellTooltipValidator',"<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" tooltip-html-unsafe=\"{{grid.validate.getFormattedErrors(row.entity,col.colDef)}}\" tooltip-enable=\"grid.validate.isInvalid(row.entity,col.colDef)\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>");}]);
'use strict';

/**
 * Binds a CodeMirror widget to a <textarea> element.
 */
angular.module('ui.codemirror', []).constant('uiCodemirrorConfig', {}).directive('uiCodemirror', uiCodemirrorDirective);

/**
 * @ngInject
 */
function uiCodemirrorDirective($timeout, uiCodemirrorConfig) {
  return {
    restrict: 'EA',
    require: '?ngModel',
    compile: function compile() {
      // Require CodeMirror
      if (angular.isUndefined(window.CodeMirror)) {
        throw new Error('ui-codemirror needs CodeMirror to work... (o rly?)');
      }
      return postLink;
    }
  };
  function postLink(scope, iElement, iAttrs, ngModel) {
    var codemirrorOptions = angular.extend({
      value: iElement.text()
    }, uiCodemirrorConfig.codemirror || {}, scope.$eval(iAttrs.uiCodemirror), scope.$eval(iAttrs.uiCodemirrorOpts));
    var codemirror = newCodemirrorEditor(iElement, codemirrorOptions);
    configOptionsWatcher(codemirror, iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts, scope);
    configNgModelLink(codemirror, ngModel, scope);
    configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);

    // Allow access to the CodeMirror instance through a broadcasted event
    // eg: $broadcast('CodeMirror', function(cm){...});
    scope.$on('CodeMirror', function (event, callback) {
      if (angular.isFunction(callback)) {
        callback(codemirror);
      } else {
        throw new Error('the CodeMirror event requires a callback function');
      }
    });

    // onLoad callback
    if (angular.isFunction(codemirrorOptions.onLoad)) {
      codemirrorOptions.onLoad(codemirror);
    }
  }
  function newCodemirrorEditor(iElement, codemirrorOptions) {
    var codemirrot;
    if (iElement[0].tagName === 'TEXTAREA') {
      // Might bug but still ...
      codemirrot = window.CodeMirror.fromTextArea(iElement[0], codemirrorOptions);
    } else {
      iElement.html('');
      codemirrot = new window.CodeMirror(function (cm_el) {
        iElement.append(cm_el);
      }, codemirrorOptions);
    }
    return codemirrot;
  }
  function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
    if (!uiCodemirrorAttr) {
      return;
    }
    var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
    scope.$watch(uiCodemirrorAttr, updateOptions, true);
    function updateOptions(newValues, oldValue) {
      if (!angular.isObject(newValues)) {
        return;
      }
      codemirrorDefaultsKeys.forEach(function (key) {
        if (newValues.hasOwnProperty(key)) {
          if (oldValue && newValues[key] === oldValue[key]) {
            return;
          }
          codemirrot.setOption(key, newValues[key]);
        }
      });
    }
  }
  function configNgModelLink(codemirror, ngModel, scope) {
    if (!ngModel) {
      return;
    }
    // CodeMirror expects a string, so make sure it gets one.
    // This does not change the model.
    ngModel.$formatters.push(function (value) {
      if (angular.isUndefined(value) || value === null) {
        return '';
      } else if (angular.isObject(value) || angular.isArray(value)) {
        throw new Error('ui-codemirror cannot use an object or an array as a model');
      }
      return value;
    });

    // Override the ngModelController $render method, which is what gets called when the model is updated.
    // This takes care of the synchronizing the codeMirror element with the underlying model, in the case that it is changed by something else.
    ngModel.$render = function () {
      //Code mirror expects a string so make sure it gets one
      //Although the formatter have already done this, it can be possible that another formatter returns undefined (for example the required directive)
      var safeViewValue = ngModel.$viewValue || '';
      codemirror.setValue(safeViewValue);
    };

    // Keep the ngModel in sync with changes from CodeMirror
    codemirror.on('change', function (instance) {
      var newValue = instance.getValue();
      if (newValue !== ngModel.$viewValue) {
        scope.$evalAsync(function () {
          ngModel.$setViewValue(newValue);
        });
      }
    });
  }
  function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
    if (!uiRefreshAttr) {
      return;
    }
    scope.$watch(uiRefreshAttr, function (newVal, oldVal) {
      // Skip the initial watch firing
      if (newVal !== oldVal) {
        $timeout(function () {
          codeMirror.refresh();
        });
      }
    });
  }
}
uiCodemirrorDirective.$inject = ["$timeout", "uiCodemirrorConfig"];
/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.19.7 - 2017-04-15T14:28:36.649Z
 * License: MIT
 */

(function () {
  "use strict";

  var KEY = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    HOME: 36,
    END: 35,
    BACKSPACE: 8,
    DELETE: 46,
    COMMAND: 91,
    MAP: {
      91: "COMMAND",
      8: "BACKSPACE",
      9: "TAB",
      13: "ENTER",
      16: "SHIFT",
      17: "CTRL",
      18: "ALT",
      19: "PAUSEBREAK",
      20: "CAPSLOCK",
      27: "ESC",
      32: "SPACE",
      33: "PAGE_UP",
      34: "PAGE_DOWN",
      35: "END",
      36: "HOME",
      37: "LEFT",
      38: "UP",
      39: "RIGHT",
      40: "DOWN",
      43: "+",
      44: "PRINTSCREEN",
      45: "INSERT",
      46: "DELETE",
      48: "0",
      49: "1",
      50: "2",
      51: "3",
      52: "4",
      53: "5",
      54: "6",
      55: "7",
      56: "8",
      57: "9",
      59: ";",
      61: "=",
      65: "A",
      66: "B",
      67: "C",
      68: "D",
      69: "E",
      70: "F",
      71: "G",
      72: "H",
      73: "I",
      74: "J",
      75: "K",
      76: "L",
      77: "M",
      78: "N",
      79: "O",
      80: "P",
      81: "Q",
      82: "R",
      83: "S",
      84: "T",
      85: "U",
      86: "V",
      87: "W",
      88: "X",
      89: "Y",
      90: "Z",
      96: "0",
      97: "1",
      98: "2",
      99: "3",
      100: "4",
      101: "5",
      102: "6",
      103: "7",
      104: "8",
      105: "9",
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NUMLOCK",
      145: "SCROLLLOCK",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    },
    isControl: function (e) {
      var k = e.which;
      switch (k) {
        case KEY.COMMAND:
        case KEY.SHIFT:
        case KEY.CTRL:
        case KEY.ALT:
          return true;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return true;
      return false;
    },
    isFunctionKey: function (k) {
      k = k.which ? k.which : k;
      return k >= 112 && k <= 123;
    },
    isVerticalMovement: function (k) {
      return ~[KEY.UP, KEY.DOWN].indexOf(k);
    },
    isHorizontalMovement: function (k) {
      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
    },
    toSeparator: function (k) {
      var sep = {
        ENTER: "\n",
        TAB: "\t",
        SPACE: " "
      }[k];
      if (sep) return sep;
      // return undefined for special keys other than enter, tab or space.
      // no way to use them to cut strings.
      return KEY[k] ? undefined : k;
    }
  };
  function isNil(value) {
    return angular.isUndefined(value) || value === null;
  }

  /**
   * Add querySelectorAll() to jqLite.
   *
   * jqLite find() is limited to lookups by tag name.
   * TODO This will change with future versions of AngularJS, to be removed when this happens
   *
   * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
   * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
   */
  if (angular.element.prototype.querySelectorAll === undefined) {
    angular.element.prototype.querySelectorAll = function (selector) {
      return angular.element(this[0].querySelectorAll(selector));
    };
  }

  /**
   * Add closest() to jqLite.
   */
  if (angular.element.prototype.closest === undefined) {
    angular.element.prototype.closest = function (selector) {
      var elem = this[0];
      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
      while (elem) {
        if (matchesSelector.bind(elem)(selector)) {
          return elem;
        } else {
          elem = elem.parentElement;
        }
      }
      return false;
    };
  }
  var latestId = 0;
  var uis = angular.module('ui.select', []).constant('uiSelectConfig', {
    theme: 'bootstrap',
    searchEnabled: true,
    sortable: false,
    placeholder: '',
    // Empty by default, like HTML tag <select>
    refreshDelay: 1000,
    // In milliseconds
    closeOnSelect: true,
    skipFocusser: false,
    dropdownPosition: 'auto',
    removeSelected: true,
    resetSearchInput: true,
    generateId: function () {
      return latestId++;
    },
    appendToBody: false,
    spinnerEnabled: false,
    spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
    backspaceReset: true
  })

  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
  .service('uiSelectMinErr', function () {
    var minErr = angular.$$minErr('ui.select');
    return function () {
      var error = minErr.apply(this, arguments);
      var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
      return new Error(message);
    };
  })

  // Recreates old behavior of ng-transclude. Used internally.
  .directive('uisTranscludeAppend', function () {
    return {
      link: function (scope, element, attrs, ctrl, transclude) {
        transclude(scope, function (clone) {
          element.append(clone);
        });
      }
    };
  })

  /**
   * Highlights text that matches $select.search.
   *
   * Taken from AngularUI Bootstrap Typeahead
   * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
   */.filter('highlight', function () {
    function escapeRegexp(queryToEscape) {
      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }
    return function (matchItem, query) {
      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
    };
  })

  /**
   * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
   *
   * Taken from AngularUI Bootstrap Position:
   * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
   */.factory('uisOffset', ['$document', '$window', function ($document, $window) {
    return function (element) {
      var boundingClientRect = element[0].getBoundingClientRect();
      return {
        width: boundingClientRect.width || element.prop('offsetWidth'),
        height: boundingClientRect.height || element.prop('offsetHeight'),
        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
      };
    };
  }]);

  /**
   * Debounces functions
   *
   * Taken from UI Bootstrap $$debounce source code
   * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
   *
   */
  uis.factory('$$uisDebounce', ['$timeout', function ($timeout) {
    return function (callback, debounceTime) {
      var timeoutPromise;
      return function () {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }
        timeoutPromise = $timeout(function () {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);
  uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window', function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
    return {
      restrict: 'EA',
      require: '^uiSelect',
      replace: true,
      transclude: true,
      templateUrl: function (tElement) {
        // Needed so the uiSelect can detect the transcluded content
        tElement.addClass('ui-select-choices');

        // Gets theme attribute from parent (ui-select)
        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
        return theme + '/choices.tpl.html';
      },
      compile: function (tElement, tAttrs) {
        if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");

        // var repeat = RepeatParser.parse(attrs.repeat);
        var groupByExp = tAttrs.groupBy;
        var groupFilterExp = tAttrs.groupFilter;
        if (groupByExp) {
          var groups = tElement.querySelectorAll('.ui-select-choices-group');
          if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
          groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
        }
        var parserResult = RepeatParser.parse(tAttrs.repeat);
        var choices = tElement.querySelectorAll('.ui-select-choices-row');
        if (choices.length !== 1) {
          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
        }
        choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp)).attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed

        var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
        if (rowsInner.length !== 1) {
          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
        }
        rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat

        // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
        var clickTarget = $window.document.addEventListener ? choices : rowsInner;
        clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
        return function link(scope, element, attrs, $select) {
          $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
          $select.disableChoiceExpression = attrs.uiDisableChoice;
          $select.onHighlightCallback = attrs.onHighlight;
          $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
          $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
          scope.$watch('$select.search', function (newValue) {
            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
              $select.refresh(attrs.refresh);
            } else {
              $select.items = [];
            }
          });
          attrs.$observe('refreshDelay', function () {
            // $eval() is needed otherwise we get a string instead of a number
            var refreshDelay = scope.$eval(attrs.refreshDelay);
            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
          });
          scope.$watch('$select.open', function (open) {
            if (open) {
              tElement.attr('role', 'listbox');
              $select.refresh(attrs.refresh);
            } else {
              element.removeAttr('role');
            }
          });
        };
      }
    };
  }]);

  /**
   * Contains ui-select "intelligence".
   *
   * The goal is to limit dependency on the DOM whenever possible and
   * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
   */
  uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window', function ($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
    var ctrl = this;
    var EMPTY_SEARCH = '';
    ctrl.placeholder = uiSelectConfig.placeholder;
    ctrl.searchEnabled = uiSelectConfig.searchEnabled;
    ctrl.sortable = uiSelectConfig.sortable;
    ctrl.refreshDelay = uiSelectConfig.refreshDelay;
    ctrl.paste = uiSelectConfig.paste;
    ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
    ctrl.refreshing = false;
    ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
    ctrl.spinnerClass = uiSelectConfig.spinnerClass;
    ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
    ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
    ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
    ctrl.search = EMPTY_SEARCH;
    ctrl.activeIndex = 0; //Dropdown of choices
    ctrl.items = []; //All available choices

    ctrl.open = false;
    ctrl.focus = false;
    ctrl.disabled = false;
    ctrl.selected = undefined;
    ctrl.dropdownPosition = 'auto';
    ctrl.focusser = undefined; //Reference to input element used to handle focus events
    ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
    ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
    ctrl.tagging = {
      isActivated: false,
      fct: undefined
    };
    ctrl.taggingTokens = {
      isActivated: false,
      tokens: undefined
    };
    ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
    ctrl.clickTriggeredSelect = false;
    ctrl.$filter = $filter;
    ctrl.$element = $element;

    // Use $injector to check for $animate and store a reference to it
    ctrl.$animate = function () {
      try {
        return $injector.get('$animate');
      } catch (err) {
        // $animate does not exist
        return null;
      }
    }();
    ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
    if (ctrl.searchInput.length !== 1) {
      throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
    }
    ctrl.isEmpty = function () {
      return isNil(ctrl.selected) || ctrl.selected === '' || ctrl.multiple && ctrl.selected.length === 0;
    };
    function _findIndex(collection, predicate, thisArg) {
      if (collection.findIndex) {
        return collection.findIndex(predicate, thisArg);
      } else {
        var list = Object(collection);
        var length = list.length >>> 0;
        var value;
        for (var i = 0; i < length; i++) {
          value = list[i];
          if (predicate.call(thisArg, value, i, list)) {
            return i;
          }
        }
        return -1;
      }
    }

    // Most of the time the user does not want to empty the search input when in typeahead mode
    function _resetSearchInput() {
      if (ctrl.resetSearchInput) {
        ctrl.search = EMPTY_SEARCH;
        //reset activeIndex
        if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
          ctrl.activeIndex = _findIndex(ctrl.items, function (item) {
            return angular.equals(this, item);
          }, ctrl.selected);
        }
      }
    }
    function _groupsFilter(groups, groupNames) {
      var i,
        j,
        result = [];
      for (i = 0; i < groupNames.length; i++) {
        for (j = 0; j < groups.length; j++) {
          if (groups[j].name == [groupNames[i]]) {
            result.push(groups[j]);
          }
        }
      }
      return result;
    }

    // When the user clicks on ui-select, displays the dropdown list
    ctrl.activate = function (initSearchValue, avoidReset) {
      if (!ctrl.disabled && !ctrl.open) {
        if (!avoidReset) _resetSearchInput();
        $scope.$broadcast('uis:activate');
        ctrl.open = true;
        ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
        // ensure that the index is set to zero for tagging variants
        // that where first option is auto-selected
        if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
          ctrl.activeIndex = 0;
        }
        var container = $element.querySelectorAll('.ui-select-choices-content');
        var searchInput = $element.querySelectorAll('.ui-select-search');
        if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
          var animateHandler = function (elem, phase) {
            if (phase === 'start' && ctrl.items.length === 0) {
              // Only focus input after the animation has finished
              ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
              $timeout(function () {
                ctrl.focusSearchInput(initSearchValue);
              });
            } else if (phase === 'close') {
              // Only focus input after the animation has finished
              ctrl.$animate.off('enter', container[0], animateHandler);
              $timeout(function () {
                ctrl.focusSearchInput(initSearchValue);
              });
            }
          };
          if (ctrl.items.length > 0) {
            ctrl.$animate.on('enter', container[0], animateHandler);
          } else {
            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
          }
        } else {
          $timeout(function () {
            ctrl.focusSearchInput(initSearchValue);
            if (!ctrl.tagging.isActivated && ctrl.items.length > 1) {
              _ensureHighlightVisible();
            }
          });
        }
      } else if (ctrl.open && !ctrl.searchEnabled) {
        // Close the selection if we don't have search enabled, and we click on the select again
        ctrl.close();
      }
    };
    ctrl.focusSearchInput = function (initSearchValue) {
      ctrl.search = initSearchValue || ctrl.search;
      ctrl.searchInput[0].focus();
    };
    ctrl.findGroupByName = function (name) {
      return ctrl.groups && ctrl.groups.filter(function (group) {
        return group.name === name;
      })[0];
    };
    ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
      function updateGroups(items) {
        var groupFn = $scope.$eval(groupByExp);
        ctrl.groups = [];
        angular.forEach(items, function (item) {
          var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
          var group = ctrl.findGroupByName(groupName);
          if (group) {
            group.items.push(item);
          } else {
            ctrl.groups.push({
              name: groupName,
              items: [item]
            });
          }
        });
        if (groupFilterExp) {
          var groupFilterFn = $scope.$eval(groupFilterExp);
          if (angular.isFunction(groupFilterFn)) {
            ctrl.groups = groupFilterFn(ctrl.groups);
          } else if (angular.isArray(groupFilterFn)) {
            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
          }
        }
        ctrl.items = [];
        ctrl.groups.forEach(function (group) {
          ctrl.items = ctrl.items.concat(group.items);
        });
      }
      function setPlainItems(items) {
        ctrl.items = items || [];
      }
      ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
      ctrl.parserResult = RepeatParser.parse(repeatAttr);
      ctrl.isGrouped = !!groupByExp;
      ctrl.itemProperty = ctrl.parserResult.itemName;

      //If collection is an Object, convert it to Array

      var originalSource = ctrl.parserResult.source;

      //When an object is used as source, we better create an array and use it as 'source'
      var createArrayFromObject = function () {
        var origSrc = originalSource($scope);
        $scope.$uisSource = Object.keys(origSrc).map(function (v) {
          var result = {};
          result[ctrl.parserResult.keyName] = v;
          result.value = origSrc[v];
          return result;
        });
      };
      if (ctrl.parserResult.keyName) {
        // Check for (key,value) syntax
        createArrayFromObject();
        ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
        $scope.$watch(originalSource, function (newVal, oldVal) {
          if (newVal !== oldVal) createArrayFromObject();
        }, true);
      }
      ctrl.refreshItems = function (data) {
        data = data || ctrl.parserResult.source($scope);
        var selectedItems = ctrl.selected;
        //TODO should implement for single mode removeSelected
        if (ctrl.isEmpty() || angular.isArray(selectedItems) && !selectedItems.length || !ctrl.multiple || !ctrl.removeSelected) {
          ctrl.setItemsFn(data);
        } else {
          if (data !== undefined && data !== null) {
            var filteredItems = data.filter(function (i) {
              return angular.isArray(selectedItems) ? selectedItems.every(function (selectedItem) {
                return !angular.equals(i, selectedItem);
              }) : !angular.equals(i, selectedItems);
            });
            ctrl.setItemsFn(filteredItems);
          }
        }
        if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
          $scope.calculateDropdownPos();
        }
        $scope.$broadcast('uis:refresh');
      };

      // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
      $scope.$watchCollection(ctrl.parserResult.source, function (items) {
        if (items === undefined || items === null) {
          // If the user specifies undefined or null => reset the collection
          // Special case: items can be undefined if the user did not initialized the collection on the scope
          // i.e $scope.addresses = [] is missing
          ctrl.items = [];
        } else {
          if (!angular.isArray(items)) {
            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
          } else {
            //Remove already selected items (ex: while searching)
            //TODO Should add a test
            ctrl.refreshItems(items);

            //update the view value with fresh data from items, if there is a valid model value
            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
              ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
            }
          }
        }
      });
    };

    var _refreshDelayPromise;

    /**
     * Typeahead mode: lets the user refresh the collection using his own function.
     *
     * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
     */
    ctrl.refresh = function (refreshAttr) {
      if (refreshAttr !== undefined) {
        // Debounce
        // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
        // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
        if (_refreshDelayPromise) {
          $timeout.cancel(_refreshDelayPromise);
        }
        _refreshDelayPromise = $timeout(function () {
          if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
            var refreshPromise = $scope.$eval(refreshAttr);
            if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
              ctrl.refreshing = true;
              refreshPromise.finally(function () {
                ctrl.refreshing = false;
              });
            }
          }
        }, ctrl.refreshDelay);
      }
    };
    ctrl.isActive = function (itemScope) {
      if (!ctrl.open) {
        return false;
      }
      var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
      var isActive = itemIndex == ctrl.activeIndex;
      if (!isActive || itemIndex < 0) {
        return false;
      }
      if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
        itemScope.$eval(ctrl.onHighlightCallback);
      }
      return isActive;
    };
    var _isItemSelected = function (item) {
      return ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
        return angular.equals(selection, item);
      }).length > 0;
    };
    var disabledItems = [];
    function _updateItemDisabled(item, isDisabled) {
      var disabledItemIndex = disabledItems.indexOf(item);
      if (isDisabled && disabledItemIndex === -1) {
        disabledItems.push(item);
      }
      if (!isDisabled && disabledItemIndex > -1) {
        disabledItems.splice(disabledItemIndex, 1);
      }
    }
    function _isItemDisabled(item) {
      return disabledItems.indexOf(item) > -1;
    }
    ctrl.isDisabled = function (itemScope) {
      if (!ctrl.open) return;
      var item = itemScope[ctrl.itemProperty];
      var itemIndex = ctrl.items.indexOf(item);
      var isDisabled = false;
      if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
        if (item.isTag) return false;
        if (ctrl.multiple) {
          isDisabled = _isItemSelected(item);
        }
        if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
          isDisabled = !!itemScope.$eval(ctrl.disableChoiceExpression);
        }
        _updateItemDisabled(item, isDisabled);
      }
      return isDisabled;
    };

    // When the user selects an item with ENTER or clicks the dropdown
    ctrl.select = function (item, skipFocusser, $event) {
      if (isNil(item) || !_isItemDisabled(item)) {
        if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
        if (!item || !_isItemDisabled(item)) {
          // if click is made on existing item, prevent from tagging, ctrl.search does not matter
          ctrl.clickTriggeredSelect = false;
          if ($event && ($event.type === 'click' || $event.type === 'touchend') && item) ctrl.clickTriggeredSelect = true;
          if (ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
            if (ctrl.taggingLabel === false) {
              if (ctrl.activeIndex < 0) {
                if (item === undefined) {
                  item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
                }
                if (!item || angular.equals(ctrl.items[0], item)) {
                  return;
                }
              } else {
                // keyboard nav happened first, user selected from dropdown
                item = ctrl.items[ctrl.activeIndex];
              }
            } else {
              // tagging always operates at index zero, taggingLabel === false pushes
              // the ctrl.search value without having it injected
              if (ctrl.activeIndex === 0) {
                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
                // for `item` if it is a detected duplicate
                if (item === undefined) return;

                // create new item on the fly if we don't already have one;
                // use tagging function if we have one
                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
                  item = ctrl.tagging.fct(item);
                  if (!item) return;
                  // if item type is 'string', apply the tagging label
                } else if (typeof item === 'string') {
                  // trim the trailing space
                  item = item.replace(ctrl.taggingLabel, '').trim();
                }
              }
            }
            // search ctrl.selected for dupes potentially caused by tagging and return early if found
            if (_isItemSelected(item)) {
              ctrl.close(skipFocusser);
              return;
            }
          }
          _resetSearchInput();
          $scope.$broadcast('uis:select', item);
          if (ctrl.closeOnSelect) {
            ctrl.close(skipFocusser);
          }
        }
      }
    };

    // Closes the dropdown
    ctrl.close = function (skipFocusser) {
      if (!ctrl.open) return;
      if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
      ctrl.open = false;
      _resetSearchInput();
      $scope.$broadcast('uis:close', skipFocusser);
    };
    ctrl.setFocus = function () {
      if (!ctrl.focus) ctrl.focusInput[0].focus();
    };
    ctrl.clear = function ($event) {
      ctrl.select(null);
      $event.stopPropagation();
      $timeout(function () {
        ctrl.focusser[0].focus();
      }, 0, false);
    };

    // Toggle dropdown
    ctrl.toggle = function (e) {
      if (ctrl.open) {
        ctrl.close();
        e.preventDefault();
        e.stopPropagation();
      } else {
        ctrl.activate();
      }
    };

    // Set default function for locked choices - avoids unnecessary
    // logic if functionality is not being used
    ctrl.isLocked = function () {
      return false;
    };
    $scope.$watch(function () {
      return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
    }, _initaliseLockedChoices);
    function _initaliseLockedChoices(doInitalise) {
      if (!doInitalise) return;
      var lockedItems = [];
      function _updateItemLocked(item, isLocked) {
        var lockedItemIndex = lockedItems.indexOf(item);
        if (isLocked && lockedItemIndex === -1) {
          lockedItems.push(item);
        }
        if (!isLocked && lockedItemIndex > -1) {
          lockedItems.splice(lockedItemIndex, 1);
        }
      }
      function _isItemlocked(item) {
        return lockedItems.indexOf(item) > -1;
      }
      ctrl.isLocked = function (itemScope, itemIndex) {
        var isLocked = false,
          item = ctrl.selected[itemIndex];
        if (item) {
          if (itemScope) {
            isLocked = !!itemScope.$eval(ctrl.lockChoiceExpression);
            _updateItemLocked(item, isLocked);
          } else {
            isLocked = _isItemlocked(item);
          }
        }
        return isLocked;
      };
    }
    var sizeWatch = null;
    var updaterScheduled = false;
    ctrl.sizeSearchInput = function () {
      var input = ctrl.searchInput[0],
        container = ctrl.$element[0],
        calculateContainerWidth = function () {
          // Return the container width only if the search input is visible
          return container.clientWidth * !!input.offsetParent;
        },
        updateIfVisible = function (containerWidth) {
          if (containerWidth === 0) {
            return false;
          }
          var inputWidth = containerWidth - input.offsetLeft;
          if (inputWidth < 50) inputWidth = containerWidth;
          ctrl.searchInput.css('width', inputWidth + 'px');
          return true;
        };
      ctrl.searchInput.css('width', '10px');
      $timeout(function () {
        //Give tags time to render correctly
        if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
          sizeWatch = $scope.$watch(function () {
            if (!updaterScheduled) {
              updaterScheduled = true;
              $scope.$$postDigest(function () {
                updaterScheduled = false;
                if (updateIfVisible(calculateContainerWidth())) {
                  sizeWatch();
                  sizeWatch = null;
                }
              });
            }
          }, angular.noop);
        }
      });
    };
    function _handleDropDownSelection(key) {
      var processed = true;
      switch (key) {
        case KEY.DOWN:
          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
          else if (ctrl.activeIndex < ctrl.items.length - 1) {
            var idx = ++ctrl.activeIndex;
            while (_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
              ctrl.activeIndex = ++idx;
            }
          }
          break;
        case KEY.UP:
          var minActiveIndex = ctrl.search.length === 0 && ctrl.tagging.isActivated ? -1 : 0;
          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
          else if (ctrl.activeIndex > minActiveIndex) {
            var idxmin = --ctrl.activeIndex;
            while (_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
              ctrl.activeIndex = --idxmin;
            }
          }
          break;
        case KEY.TAB:
          if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
          break;
        case KEY.ENTER:
          if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
          } else {
            ctrl.activate(false, true); //In case its the search input in 'multiple' mode
          }

          break;
        case KEY.ESC:
          ctrl.close();
          break;
        default:
          processed = false;
      }
      return processed;
    }

    // Bind to keyboard shortcuts
    ctrl.searchInput.on('keydown', function (e) {
      var key = e.which;
      if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
        e.preventDefault();
        e.stopPropagation();
      }
      $scope.$apply(function () {
        var tagged = false;
        if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
          if (!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
            e.preventDefault();
            e.stopPropagation();
          }
          if (ctrl.taggingTokens.isActivated) {
            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
              if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
                // make sure there is a new value to push via tagging
                if (ctrl.search.length > 0) {
                  tagged = true;
                }
              }
            }
            if (tagged) {
              $timeout(function () {
                ctrl.searchInput.triggerHandler('tagged');
                var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
                if (ctrl.tagging.fct) {
                  newItem = ctrl.tagging.fct(newItem);
                }
                if (newItem) ctrl.select(newItem, true);
              });
            }
          }
        }
      });
      if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
        _ensureHighlightVisible();
      }
      if (key === KEY.ENTER || key === KEY.ESC) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
    ctrl.searchInput.on('paste', function (e) {
      var data;
      if (window.clipboardData && window.clipboardData.getData) {
        // IE
        data = window.clipboardData.getData('Text');
      } else {
        data = (e.originalEvent || e).clipboardData.getData('text/plain');
      }

      // Prepend the current input field text to the paste buffer.
      data = ctrl.search + data;
      if (data && data.length > 0) {
        // If tagging try to split by tokens and add items
        if (ctrl.taggingTokens.isActivated) {
          var items = [];
          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
            // split by first token that is contained in data
            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
            if (data.indexOf(separator) > -1) {
              items = data.split(separator);
              break; // only split by one token
            }
          }

          if (items.length === 0) {
            items = [data];
          }
          var oldsearch = ctrl.search;
          angular.forEach(items, function (item) {
            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
            if (newItem) {
              ctrl.select(newItem, true);
            }
          });
          ctrl.search = oldsearch || EMPTY_SEARCH;
          e.preventDefault();
          e.stopPropagation();
        } else if (ctrl.paste) {
          ctrl.paste(data);
          ctrl.search = EMPTY_SEARCH;
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
    ctrl.searchInput.on('tagged', function () {
      $timeout(function () {
        _resetSearchInput();
      });
    });

    // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
    function _ensureHighlightVisible() {
      var container = $element.querySelectorAll('.ui-select-choices-content');
      var choices = container.querySelectorAll('.ui-select-choices-row');
      if (choices.length < 1) {
        throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
      }
      if (ctrl.activeIndex < 0) {
        return;
      }
      var highlighted = choices[ctrl.activeIndex];
      var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
      var height = container[0].offsetHeight;
      if (posY > height) {
        container[0].scrollTop += posY - height;
      } else if (posY < highlighted.clientHeight) {
        if (ctrl.isGrouped && ctrl.activeIndex === 0) container[0].scrollTop = 0; //To make group header visible when going all the way up
        else container[0].scrollTop -= highlighted.clientHeight - posY;
      }
    }
    var onResize = $$uisDebounce(function () {
      ctrl.sizeSearchInput();
    }, 50);
    angular.element($window).bind('resize', onResize);
    $scope.$on('$destroy', function () {
      ctrl.searchInput.off('keyup keydown tagged blur paste');
      angular.element($window).off('resize', onResize);
    });
    $scope.$watch('$select.activeIndex', function (activeIndex) {
      if (activeIndex) $element.find('input').attr('aria-activedescendant', 'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
    });
    $scope.$watch('$select.open', function (open) {
      if (!open) $element.find('input').removeAttr('aria-activedescendant');
    });
  }]);
  uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout', function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
    return {
      restrict: 'EA',
      templateUrl: function (tElement, tAttrs) {
        var theme = tAttrs.theme || uiSelectConfig.theme;
        return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
      },
      replace: true,
      transclude: true,
      require: ['uiSelect', '^ngModel'],
      scope: true,
      controller: 'uiSelectCtrl',
      controllerAs: '$select',
      compile: function (tElement, tAttrs) {
        // Allow setting ngClass on uiSelect
        var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
        if (match) {
          var combined = '{' + match[1] + ', ' + match[2] + '}';
          tAttrs.ngClass = combined;
          tElement.attr('ng-class', combined);
        }

        //Multiple or Single depending if multiple attribute presence
        if (angular.isDefined(tAttrs.multiple)) tElement.append('<ui-select-multiple/>').removeAttr('multiple');else tElement.append('<ui-select-single/>');
        if (tAttrs.inputId) tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
        return function (scope, element, attrs, ctrls, transcludeFn) {
          var $select = ctrls[0];
          var ngModel = ctrls[1];
          $select.generatedId = uiSelectConfig.generateId();
          $select.baseTitle = attrs.title || 'Select box';
          $select.focusserTitle = $select.baseTitle + ' focus';
          $select.focusserId = 'focusser-' + $select.generatedId;
          $select.closeOnSelect = function () {
            if (angular.isDefined(attrs.closeOnSelect)) {
              return $parse(attrs.closeOnSelect)();
            } else {
              return uiSelectConfig.closeOnSelect;
            }
          }();
          scope.$watch('skipFocusser', function () {
            var skipFocusser = scope.$eval(attrs.skipFocusser);
            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
          });
          $select.onSelectCallback = $parse(attrs.onSelect);
          $select.onRemoveCallback = $parse(attrs.onRemove);

          //Set reference to ngModel from uiSelectCtrl
          $select.ngModel = ngModel;
          $select.choiceGrouped = function (group) {
            return $select.isGrouped && group && group.name;
          };
          if (attrs.tabindex) {
            attrs.$observe('tabindex', function (value) {
              $select.focusInput.attr('tabindex', value);
              element.removeAttr('tabindex');
            });
          }
          scope.$watch(function () {
            return scope.$eval(attrs.searchEnabled);
          }, function (newVal) {
            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
          });
          scope.$watch('sortable', function () {
            var sortable = scope.$eval(attrs.sortable);
            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
          });
          attrs.$observe('backspaceReset', function () {
            // $eval() is needed otherwise we get a string instead of a boolean
            var backspaceReset = scope.$eval(attrs.backspaceReset);
            $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
          });
          attrs.$observe('limit', function () {
            //Limit the number of selections allowed
            $select.limit = angular.isDefined(attrs.limit) ? parseInt(attrs.limit, 10) : undefined;
          });
          scope.$watch('removeSelected', function () {
            var removeSelected = scope.$eval(attrs.removeSelected);
            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
          });
          attrs.$observe('disabled', function () {
            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
          });
          attrs.$observe('resetSearchInput', function () {
            // $eval() is needed otherwise we get a string instead of a boolean
            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
          });
          attrs.$observe('paste', function () {
            $select.paste = scope.$eval(attrs.paste);
          });
          attrs.$observe('tagging', function () {
            if (attrs.tagging !== undefined) {
              // $eval() is needed otherwise we get a string instead of a boolean
              var taggingEval = scope.$eval(attrs.tagging);
              $select.tagging = {
                isActivated: true,
                fct: taggingEval !== true ? taggingEval : undefined
              };
            } else {
              $select.tagging = {
                isActivated: false,
                fct: undefined
              };
            }
          });
          attrs.$observe('taggingLabel', function () {
            if (attrs.tagging !== undefined) {
              // check eval for FALSE, in this case, we disable the labels
              // associated with tagging
              if (attrs.taggingLabel === 'false') {
                $select.taggingLabel = false;
              } else {
                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
              }
            }
          });
          attrs.$observe('taggingTokens', function () {
            if (attrs.tagging !== undefined) {
              var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
              $select.taggingTokens = {
                isActivated: true,
                tokens: tokens
              };
            }
          });
          attrs.$observe('spinnerEnabled', function () {
            // $eval() is needed otherwise we get a string instead of a boolean
            var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
            $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
          });
          attrs.$observe('spinnerClass', function () {
            var spinnerClass = attrs.spinnerClass;
            $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
          });

          //Automatically gets focus when loaded
          if (angular.isDefined(attrs.autofocus)) {
            $timeout(function () {
              $select.setFocus();
            });
          }

          //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
          if (angular.isDefined(attrs.focusOn)) {
            scope.$on(attrs.focusOn, function () {
              $timeout(function () {
                $select.setFocus();
              });
            });
          }
          function onDocumentClick(e) {
            if (!$select.open) return; //Skip it if dropdown is close

            var contains = false;
            if (window.jQuery) {
              // Firefox 3.6 does not support element.contains()
              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
              contains = window.jQuery.contains(element[0], e.target);
            } else {
              contains = element[0].contains(e.target);
            }
            if (!contains && !$select.clickTriggeredSelect) {
              var skipFocusser;
              if (!$select.skipFocusser) {
                //Will lose focus only with certain targets
                var focusableControls = ['input', 'button', 'textarea', 'select'];
                var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
                skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
                if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
              } else {
                skipFocusser = true;
              }
              $select.close(skipFocusser);
              scope.$digest();
            }
            $select.clickTriggeredSelect = false;
          }

          // See Click everywhere but here event http://stackoverflow.com/questions/12931369
          $document.on('click', onDocumentClick);
          scope.$on('$destroy', function () {
            $document.off('click', onDocumentClick);
          });

          // Move transcluded elements to their correct position in main template
          transcludeFn(scope, function (clone) {
            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

            // One day jqLite will be replaced by jQuery and we will be able to write:
            // var transcludedElement = clone.filter('.my-class')
            // instead of creating a hackish DOM element:
            var transcluded = angular.element('<div>').append(clone);
            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
            if (transcludedMatch.length !== 1) {
              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
            }
            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
            if (transcludedChoices.length !== 1) {
              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
            }
            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
            if (transcludedNoChoice.length == 1) {
              element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
            }
          });

          // Support for appending the select field to the body when its open
          var appendToBody = scope.$eval(attrs.appendToBody);
          if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
            scope.$watch('$select.open', function (isOpen) {
              if (isOpen) {
                positionDropdown();
              } else {
                resetDropdown();
              }
            });

            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
            // it might stick around when the user routes away or the select field is otherwise removed
            scope.$on('$destroy', function () {
              resetDropdown();
            });
          }

          // Hold on to a reference to the .ui-select-container element for appendToBody support
          var placeholder = null,
            originalWidth = '';
          function positionDropdown() {
            // Remember the absolute position of the element
            var offset = uisOffset(element);

            // Clone the element into a placeholder element to take its original place in the DOM
            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
            placeholder[0].style.width = offset.width + 'px';
            placeholder[0].style.height = offset.height + 'px';
            element.after(placeholder);

            // Remember the original value of the element width inline style, so it can be restored
            // when the dropdown is closed
            originalWidth = element[0].style.width;

            // Now move the actual dropdown element to the end of the body
            $document.find('body').append(element);
            element[0].style.position = 'absolute';
            element[0].style.left = offset.left + 'px';
            element[0].style.top = offset.top + 'px';
            element[0].style.width = offset.width + 'px';
          }
          function resetDropdown() {
            if (placeholder === null) {
              // The dropdown has not actually been display yet, so there's nothing to reset
              return;
            }

            // Move the dropdown element back to its original location in the DOM
            placeholder.replaceWith(element);
            placeholder = null;
            element[0].style.position = '';
            element[0].style.left = '';
            element[0].style.top = '';
            element[0].style.width = originalWidth;

            // Set focus back on to the moved element
            $select.setFocus();
          }

          // Hold on to a reference to the .ui-select-dropdown element for direction support.
          var dropdown = null,
            directionUpClassName = 'direction-up';

          // Support changing the direction of the dropdown if there isn't enough space to render it.
          scope.$watch('$select.open', function () {
            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
              scope.calculateDropdownPos();
            }
          });
          var setDropdownPosUp = function (offset, offsetDropdown) {
            offset = offset || uisOffset(element);
            offsetDropdown = offsetDropdown || uisOffset(dropdown);
            dropdown[0].style.position = 'absolute';
            dropdown[0].style.top = offsetDropdown.height * -1 + 'px';
            element.addClass(directionUpClassName);
          };
          var setDropdownPosDown = function (offset, offsetDropdown) {
            element.removeClass(directionUpClassName);
            offset = offset || uisOffset(element);
            offsetDropdown = offsetDropdown || uisOffset(dropdown);
            dropdown[0].style.position = '';
            dropdown[0].style.top = '';
          };
          var calculateDropdownPosAfterAnimation = function () {
            // Delay positioning the dropdown until all choices have been added so its height is correct.
            $timeout(function () {
              if ($select.dropdownPosition === 'up') {
                //Go UP
                setDropdownPosUp();
              } else {
                //AUTO
                element.removeClass(directionUpClassName);
                var offset = uisOffset(element);
                var offsetDropdown = uisOffset(dropdown);

                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).

                // Determine if the direction of the dropdown needs to be changed.
                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
                  //Go UP
                  setDropdownPosUp(offset, offsetDropdown);
                } else {
                  //Go DOWN
                  setDropdownPosDown(offset, offsetDropdown);
                }
              }

              // Display the dropdown once it has been positioned.
              dropdown[0].style.opacity = 1;
            });
          };
          var opened = false;
          scope.calculateDropdownPos = function () {
            if ($select.open) {
              dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
              if (dropdown.length === 0) {
                return;
              }

              // Hide the dropdown so there is no flicker until $timeout is done executing.
              if ($select.search === '' && !opened) {
                dropdown[0].style.opacity = 0;
                opened = true;
              }
              if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
                var needsCalculated = true;
                $select.$animate.on('enter', dropdown, function (elem, phase) {
                  if (phase === 'close' && needsCalculated) {
                    calculateDropdownPosAfterAnimation();
                    needsCalculated = false;
                  }
                });
              } else {
                calculateDropdownPosAfterAnimation();
              }
            } else {
              if (dropdown === null || dropdown.length === 0) {
                return;
              }

              // Reset the position of the dropdown.
              dropdown[0].style.opacity = 0;
              dropdown[0].style.position = '';
              dropdown[0].style.top = '';
              element.removeClass(directionUpClassName);
            }
          };
        };
      }
    };
  }]);
  uis.directive('uiSelectMatch', ['uiSelectConfig', function (uiSelectConfig) {
    return {
      restrict: 'EA',
      require: '^uiSelect',
      replace: true,
      transclude: true,
      templateUrl: function (tElement) {
        // Needed so the uiSelect can detect the transcluded content
        tElement.addClass('ui-select-match');
        var parent = tElement.parent();
        // Gets theme attribute from parent (ui-select)
        var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
        var multi = angular.isDefined(getAttribute(parent, 'multiple'));
        return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
      },
      link: function (scope, element, attrs, $select) {
        $select.lockChoiceExpression = attrs.uiLockChoice;
        attrs.$observe('placeholder', function (placeholder) {
          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
        });
        function setAllowClear(allow) {
          $select.allowClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : false;
        }
        attrs.$observe('allowClear', setAllowClear);
        setAllowClear(attrs.allowClear);
        if ($select.multiple) {
          $select.sizeSearchInput();
        }
      }
    };
    function getAttribute(elem, attribute) {
      if (elem[0].hasAttribute(attribute)) return elem.attr(attribute);
      if (elem[0].hasAttribute('data-' + attribute)) return elem.attr('data-' + attribute);
      if (elem[0].hasAttribute('x-' + attribute)) return elem.attr('x-' + attribute);
    }
  }]);
  uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function (uiSelectMinErr, $timeout) {
    return {
      restrict: 'EA',
      require: ['^uiSelect', '^ngModel'],
      controller: ['$scope', '$timeout', function ($scope, $timeout) {
        var ctrl = this,
          $select = $scope.$select,
          ngModel;
        if (angular.isUndefined($select.selected)) $select.selected = [];

        //Wait for link fn to inject it
        $scope.$evalAsync(function () {
          ngModel = $scope.ngModel;
        });
        ctrl.activeMatchIndex = -1;
        ctrl.updateModel = function () {
          ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
          ctrl.refreshComponent();
        };
        ctrl.refreshComponent = function () {
          //Remove already selected items
          //e.g. When user clicks on a selection, the selected array changes and
          //the dropdown should remove that item
          if ($select.refreshItems) {
            $select.refreshItems();
          }
          if ($select.sizeSearchInput) {
            $select.sizeSearchInput();
          }
        };

        // Remove item from multiple select
        ctrl.removeChoice = function (index) {
          // if the choice is locked, don't remove it
          if ($select.isLocked(null, index)) return false;
          var removedChoice = $select.selected[index];
          var locals = {};
          locals[$select.parserResult.itemName] = removedChoice;
          $select.selected.splice(index, 1);
          ctrl.activeMatchIndex = -1;
          $select.sizeSearchInput();

          // Give some time for scope propagation.
          $timeout(function () {
            $select.onRemoveCallback($scope, {
              $item: removedChoice,
              $model: $select.parserResult.modelMapper($scope, locals)
            });
          });
          ctrl.updateModel();
          return true;
        };
        ctrl.getPlaceholder = function () {
          //Refactor single?
          if ($select.selected && $select.selected.length) return;
          return $select.placeholder;
        };
      }],
      controllerAs: '$selectMultiple',
      link: function (scope, element, attrs, ctrls) {
        var $select = ctrls[0];
        var ngModel = scope.ngModel = ctrls[1];
        var $selectMultiple = scope.$selectMultiple;

        //$select.selected = raw selected objects (ignoring any property binding)

        $select.multiple = true;

        //Input that will handle focus
        $select.focusInput = $select.searchInput;

        //Properly check for empty if set to multiple
        ngModel.$isEmpty = function (value) {
          return !value || value.length === 0;
        };

        //From view --> model
        ngModel.$parsers.unshift(function () {
          var locals = {},
            result,
            resultMultiple = [];
          for (var j = $select.selected.length - 1; j >= 0; j--) {
            locals = {};
            locals[$select.parserResult.itemName] = $select.selected[j];
            result = $select.parserResult.modelMapper(scope, locals);
            resultMultiple.unshift(result);
          }
          return resultMultiple;
        });

        // From model --> view
        ngModel.$formatters.unshift(function (inputValue) {
          var data = $select.parserResult && $select.parserResult.source(scope, {
              $select: {
                search: ''
              }
            }),
            //Overwrite $search
            locals = {},
            result;
          if (!data) return inputValue;
          var resultMultiple = [];
          var checkFnMultiple = function (list, value) {
            if (!list || !list.length) return;
            for (var p = list.length - 1; p >= 0; p--) {
              locals[$select.parserResult.itemName] = list[p];
              result = $select.parserResult.modelMapper(scope, locals);
              if ($select.parserResult.trackByExp) {
                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
                  if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
                    resultMultiple.unshift(list[p]);
                    return true;
                  }
                }
              }
              if (angular.equals(result, value)) {
                resultMultiple.unshift(list[p]);
                return true;
              }
            }
            return false;
          };
          if (!inputValue) return resultMultiple; //If ngModel was undefined
          for (var k = inputValue.length - 1; k >= 0; k--) {
            //Check model array of currently selected items
            if (!checkFnMultiple($select.selected, inputValue[k])) {
              //Check model array of all items available
              if (!checkFnMultiple(data, inputValue[k])) {
                //If not found on previous lists, just add it directly to resultMultiple
                resultMultiple.unshift(inputValue[k]);
              }
            }
          }
          return resultMultiple;
        });

        //Watch for external model changes
        scope.$watchCollection(function () {
          return ngModel.$modelValue;
        }, function (newValue, oldValue) {
          if (oldValue != newValue) {
            //update the view value with fresh data from items, if there is a valid model value
            if (angular.isDefined(ngModel.$modelValue)) {
              ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
            }

            $selectMultiple.refreshComponent();
          }
        });
        ngModel.$render = function () {
          // Make sure that model value is array
          if (!angular.isArray(ngModel.$viewValue)) {
            // Have tolerance for null or undefined values
            if (isNil(ngModel.$viewValue)) {
              ngModel.$viewValue = [];
            } else {
              throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
            }
          }
          $select.selected = ngModel.$viewValue;
          $selectMultiple.refreshComponent();
          scope.$evalAsync(); //To force $digest
        };

        scope.$on('uis:select', function (event, item) {
          if ($select.selected.length >= $select.limit) {
            return;
          }
          $select.selected.push(item);
          var locals = {};
          locals[$select.parserResult.itemName] = item;
          $timeout(function () {
            $select.onSelectCallback(scope, {
              $item: item,
              $model: $select.parserResult.modelMapper(scope, locals)
            });
          });
          $selectMultiple.updateModel();
        });
        scope.$on('uis:activate', function () {
          $selectMultiple.activeMatchIndex = -1;
        });
        scope.$watch('$select.disabled', function (newValue, oldValue) {
          // As the search input field may now become visible, it may be necessary to recompute its size
          if (oldValue && !newValue) $select.sizeSearchInput();
        });
        $select.searchInput.on('keydown', function (e) {
          var key = e.which;
          scope.$apply(function () {
            var processed = false;
            // var tagged = false; //Checkme
            if (KEY.isHorizontalMovement(key)) {
              processed = _handleMatchSelection(key);
            }
            if (processed && key != KEY.TAB) {
              //TODO Check si el tab selecciona aun correctamente
              //Crear test
              e.preventDefault();
              e.stopPropagation();
            }
          });
        });
        function _getCaretPosition(el) {
          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
          else return el.value.length;
        }
        // Handles selected options in "multiple" mode
        function _handleMatchSelection(key) {
          var caretPosition = _getCaretPosition($select.searchInput[0]),
            length = $select.selected.length,
            // none  = -1,
            first = 0,
            last = length - 1,
            curr = $selectMultiple.activeMatchIndex,
            next = $selectMultiple.activeMatchIndex + 1,
            prev = $selectMultiple.activeMatchIndex - 1,
            newIndex = curr;
          if (caretPosition > 0 || $select.search.length && key == KEY.RIGHT) return false;
          $select.close();
          function getNewActiveMatchIndex() {
            switch (key) {
              case KEY.LEFT:
                // Select previous/first item
                if (~$selectMultiple.activeMatchIndex) return prev;
                // Select last item
                else return last;
                break;
              case KEY.RIGHT:
                // Open drop-down
                if (!~$selectMultiple.activeMatchIndex || curr === last) {
                  $select.activate();
                  return false;
                }
                // Select next/last item
                else return next;
                break;
              case KEY.BACKSPACE:
                // Remove selected item and select previous/first
                if (~$selectMultiple.activeMatchIndex) {
                  if ($selectMultiple.removeChoice(curr)) {
                    return prev;
                  } else {
                    return curr;
                  }
                } else {
                  // If nothing yet selected, select last item
                  return last;
                }
                break;
              case KEY.DELETE:
                // Remove selected item and select next item
                if (~$selectMultiple.activeMatchIndex) {
                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
                  return curr;
                } else return false;
            }
          }
          newIndex = getNewActiveMatchIndex();
          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
          return true;
        }
        $select.searchInput.on('keyup', function (e) {
          if (!KEY.isVerticalMovement(e.which)) {
            scope.$evalAsync(function () {
              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
            });
          }
          // Push a "create new" item into array if there is a search string
          if ($select.tagging.isActivated && $select.search.length > 0) {
            // return early with these keys
            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
              return;
            }
            // always reset the activeIndex to the first item when tagging
            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
            // taggingLabel === false bypasses all of this
            if ($select.taggingLabel === false) return;
            var items = angular.copy($select.items);
            var stashArr = angular.copy($select.items);
            var newItem;
            var item;
            var hasTag = false;
            var dupeIndex = -1;
            var tagItems;
            var tagItem;

            // case for object tagging via transform `$select.tagging.fct` function
            if ($select.tagging.fct !== undefined) {
              tagItems = $select.$filter('filter')(items, {
                'isTag': true
              });
              if (tagItems.length > 0) {
                tagItem = tagItems[0];
              }
              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
              if (items.length > 0 && tagItem) {
                hasTag = true;
                items = items.slice(1, items.length);
                stashArr = stashArr.slice(1, stashArr.length);
              }
              newItem = $select.tagging.fct($select.search);
              // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
              if (stashArr.some(function (origItem) {
                return angular.equals(origItem, newItem);
              }) || $select.selected.some(function (origItem) {
                return angular.equals(origItem, newItem);
              })) {
                scope.$evalAsync(function () {
                  $select.activeIndex = 0;
                  $select.items = items;
                });
                return;
              }
              if (newItem) newItem.isTag = true;
              // handle newItem string and stripping dupes in tagging string context
            } else {
              // find any tagging items already in the $select.items array and store them
              tagItems = $select.$filter('filter')(items, function (item) {
                return item.match($select.taggingLabel);
              });
              if (tagItems.length > 0) {
                tagItem = tagItems[0];
              }
              item = items[0];
              // remove existing tag item if found (should only ever be one tag item)
              if (item !== undefined && items.length > 0 && tagItem) {
                hasTag = true;
                items = items.slice(1, items.length);
                stashArr = stashArr.slice(1, stashArr.length);
              }
              newItem = $select.search + ' ' + $select.taggingLabel;
              if (_findApproxDupe($select.selected, $select.search) > -1) {
                return;
              }
              // verify the the tag doesn't match the value of an existing item from
              // the searched data set or the items already selected
              if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
                // if there is a tag from prev iteration, strip it / queue the change
                // and return early
                if (hasTag) {
                  items = stashArr;
                  scope.$evalAsync(function () {
                    $select.activeIndex = 0;
                    $select.items = items;
                  });
                }
                return;
              }
              if (_findCaseInsensitiveDupe(stashArr)) {
                // if there is a tag from prev iteration, strip it
                if (hasTag) {
                  $select.items = stashArr.slice(1, stashArr.length);
                }
                return;
              }
            }
            if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
            // dupe found, shave the first item
            if (dupeIndex > -1) {
              items = items.slice(dupeIndex + 1, items.length - 1);
            } else {
              items = [];
              if (newItem) items.push(newItem);
              items = items.concat(stashArr);
            }
            scope.$evalAsync(function () {
              $select.activeIndex = 0;
              $select.items = items;
              if ($select.isGrouped) {
                // update item references in groups, so that indexOf will work after angular.copy
                var itemsWithoutTag = newItem ? items.slice(1) : items;
                $select.setItemsFn(itemsWithoutTag);
                if (newItem) {
                  // add tag item as a new group
                  $select.items.unshift(newItem);
                  $select.groups.unshift({
                    name: '',
                    items: [newItem],
                    tagging: true
                  });
                }
              }
            });
          }
        });
        function _findCaseInsensitiveDupe(arr) {
          if (arr === undefined || $select.search === undefined) {
            return false;
          }
          var hasDupe = arr.filter(function (origItem) {
            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
              return false;
            }
            return origItem.toUpperCase() === $select.search.toUpperCase();
          }).length > 0;
          return hasDupe;
        }
        function _findApproxDupe(haystack, needle) {
          var dupeIndex = -1;
          if (angular.isArray(haystack)) {
            var tempArr = angular.copy(haystack);
            for (var i = 0; i < tempArr.length; i++) {
              // handle the simple string version of tagging
              if ($select.tagging.fct === undefined) {
                // search the array for the match
                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
                  dupeIndex = i;
                }
                // handle the object tagging implementation
              } else {
                var mockObj = tempArr[i];
                if (angular.isObject(mockObj)) {
                  mockObj.isTag = true;
                }
                if (angular.equals(mockObj, needle)) {
                  dupeIndex = i;
                }
              }
            }
          }
          return dupeIndex;
        }
        $select.searchInput.on('blur', function () {
          $timeout(function () {
            $selectMultiple.activeMatchIndex = -1;
          });
        });
      }
    };
  }]);
  uis.directive('uiSelectNoChoice', ['uiSelectConfig', function (uiSelectConfig) {
    return {
      restrict: 'EA',
      require: '^uiSelect',
      replace: true,
      transclude: true,
      templateUrl: function (tElement) {
        // Needed so the uiSelect can detect the transcluded content
        tElement.addClass('ui-select-no-choice');

        // Gets theme attribute from parent (ui-select)
        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
        return theme + '/no-choice.tpl.html';
      }
    };
  }]);
  uis.directive('uiSelectSingle', ['$timeout', '$compile', function ($timeout, $compile) {
    return {
      restrict: 'EA',
      require: ['^uiSelect', '^ngModel'],
      link: function (scope, element, attrs, ctrls) {
        var $select = ctrls[0];
        var ngModel = ctrls[1];

        //From view --> model
        ngModel.$parsers.unshift(function (inputValue) {
          // Keep original value for undefined and null
          if (isNil(inputValue)) {
            return inputValue;
          }
          var locals = {},
            result;
          locals[$select.parserResult.itemName] = inputValue;
          result = $select.parserResult.modelMapper(scope, locals);
          return result;
        });

        //From model --> view
        ngModel.$formatters.unshift(function (inputValue) {
          // Keep original value for undefined and null
          if (isNil(inputValue)) {
            return inputValue;
          }
          var data = $select.parserResult && $select.parserResult.source(scope, {
              $select: {
                search: ''
              }
            }),
            //Overwrite $search
            locals = {},
            result;
          if (data) {
            var checkFnSingle = function (d) {
              locals[$select.parserResult.itemName] = d;
              result = $select.parserResult.modelMapper(scope, locals);
              return result === inputValue;
            };
            //If possible pass same object stored in $select.selected
            if ($select.selected && checkFnSingle($select.selected)) {
              return $select.selected;
            }
            for (var i = data.length - 1; i >= 0; i--) {
              if (checkFnSingle(data[i])) return data[i];
            }
          }
          return inputValue;
        });

        //Update viewValue if model change
        scope.$watch('$select.selected', function (newValue) {
          if (ngModel.$viewValue !== newValue) {
            ngModel.$setViewValue(newValue);
          }
        });
        ngModel.$render = function () {
          $select.selected = ngModel.$viewValue;
        };
        scope.$on('uis:select', function (event, item) {
          $select.selected = item;
          var locals = {};
          locals[$select.parserResult.itemName] = item;
          $timeout(function () {
            $select.onSelectCallback(scope, {
              $item: item,
              $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
            });
          });
        });
        scope.$on('uis:close', function (event, skipFocusser) {
          $timeout(function () {
            $select.focusser.prop('disabled', false);
            if (!skipFocusser) $select.focusser[0].focus();
          }, 0, false);
        });
        scope.$on('uis:activate', function () {
          focusser.prop('disabled', true); //Will reactivate it on .close()
        });

        //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
        $compile(focusser)(scope);
        $select.focusser = focusser;

        //Input that will handle focus
        $select.focusInput = focusser;
        element.parent().append(focusser);
        focusser.bind("focus", function () {
          scope.$evalAsync(function () {
            $select.focus = true;
          });
        });
        focusser.bind("blur", function () {
          scope.$evalAsync(function () {
            $select.focus = false;
          });
        });
        focusser.bind("keydown", function (e) {
          if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
            e.preventDefault();
            e.stopPropagation();
            $select.select(undefined);
            scope.$apply();
            return;
          }
          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
            return;
          }
          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
            e.preventDefault();
            e.stopPropagation();
            $select.activate();
          }
          scope.$digest();
        });
        focusser.bind("keyup input", function (e) {
          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
            return;
          }
          $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
          focusser.val('');
          scope.$digest();
        });
      }
    };
  }]);

  // Make multiple matches sortable
  uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function ($timeout, uiSelectConfig, uiSelectMinErr) {
    return {
      require: ['^^uiSelect', '^ngModel'],
      link: function (scope, element, attrs, ctrls) {
        if (scope[attrs.uiSelectSort] === null) {
          throw uiSelectMinErr('sort', 'Expected a list to sort');
        }
        var $select = ctrls[0];
        var $ngModel = ctrls[1];
        var options = angular.extend({
          axis: 'horizontal'
        }, scope.$eval(attrs.uiSelectSortOptions));
        var axis = options.axis;
        var draggingClassName = 'dragging';
        var droppingClassName = 'dropping';
        var droppingBeforeClassName = 'dropping-before';
        var droppingAfterClassName = 'dropping-after';
        scope.$watch(function () {
          return $select.sortable;
        }, function (newValue) {
          if (newValue) {
            element.attr('draggable', true);
          } else {
            element.removeAttr('draggable');
          }
        });
        element.on('dragstart', function (event) {
          element.addClass(draggingClassName);
          (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
        });
        element.on('dragend', function () {
          removeClass(draggingClassName);
        });
        var move = function (from, to) {
          /*jshint validthis: true */
          this.splice(to, 0, this.splice(from, 1)[0]);
        };
        var removeClass = function (className) {
          angular.forEach($select.$element.querySelectorAll('.' + className), function (el) {
            angular.element(el).removeClass(className);
          });
        };
        var dragOverHandler = function (event) {
          event.preventDefault();
          var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
          if (offset < this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2) {
            removeClass(droppingAfterClassName);
            element.addClass(droppingBeforeClassName);
          } else {
            removeClass(droppingBeforeClassName);
            element.addClass(droppingAfterClassName);
          }
        };
        var dropTimeout;
        var dropHandler = function (event) {
          event.preventDefault();
          var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);

          // prevent event firing multiple times in firefox
          $timeout.cancel(dropTimeout);
          dropTimeout = $timeout(function () {
            _dropHandler(droppedItemIndex);
          }, 20);
        };
        var _dropHandler = function (droppedItemIndex) {
          var theList = scope.$eval(attrs.uiSelectSort);
          var itemToMove = theList[droppedItemIndex];
          var newIndex = null;
          if (element.hasClass(droppingBeforeClassName)) {
            if (droppedItemIndex < scope.$index) {
              newIndex = scope.$index - 1;
            } else {
              newIndex = scope.$index;
            }
          } else {
            if (droppedItemIndex < scope.$index) {
              newIndex = scope.$index;
            } else {
              newIndex = scope.$index + 1;
            }
          }
          move.apply(theList, [droppedItemIndex, newIndex]);
          $ngModel.$setViewValue(Date.now());
          scope.$apply(function () {
            scope.$emit('uiSelectSort:change', {
              array: theList,
              item: itemToMove,
              from: droppedItemIndex,
              to: newIndex
            });
          });
          removeClass(droppingClassName);
          removeClass(droppingBeforeClassName);
          removeClass(droppingAfterClassName);
          element.off('drop', dropHandler);
        };
        element.on('dragenter', function () {
          if (element.hasClass(draggingClassName)) {
            return;
          }
          element.addClass(droppingClassName);
          element.on('dragover', dragOverHandler);
          element.on('drop', dropHandler);
        });
        element.on('dragleave', function (event) {
          if (event.target != element) {
            return;
          }
          removeClass(droppingClassName);
          removeClass(droppingBeforeClassName);
          removeClass(droppingAfterClassName);
          element.off('dragover', dragOverHandler);
          element.off('drop', dropHandler);
        });
      }
    };
  }]);
  uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
    return {
      restrict: 'A',
      require: 'uiSelect',
      link: function (scope, element, attrs, $select) {
        $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
        scope.$watch('$select.open', function (isOpen, previousState) {
          if (isOpen !== previousState) {
            $timeout(function () {
              $select.onOpenCloseCallback(scope, {
                isOpen: isOpen
              });
            });
          }
        });
      }
    };
  }]);

  /**
   * Parses "repeat" attribute.
   *
   * Taken from AngularJS ngRepeat source code
   * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
   *
   * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
   * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
   */

  uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function (uiSelectMinErr, $parse) {
    var self = this;

    /**
     * Example:
     * expression = "address in addresses | filter: {street: $select.search} track by $index"
     * itemName = "address",
     * source = "addresses | filter: {street: $select.search}",
     * trackByExp = "$index",
     */
    self.parse = function (expression) {
      var match;
      //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
      // If an array is used as collection

      // if (isObjectCollection){
      // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
      match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      // 1 Alias
      // 2 Item
      // 3 Key on (key,value)
      // 4 Value on (key,value)
      // 5 Source expression (including filters)
      // 6 Track by

      if (!match) {
        throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
      }
      var source = match[5],
        filters = '';

      // When using (key,value) ui-select requires filters to be extracted, since the object
      // is converted to an array for $select.items 
      // (in which case the filters need to be reapplied)
      if (match[3]) {
        // Remove any enclosing parenthesis
        source = match[5].replace(/(^\()|(\)$)/g, '');
        // match all after | but not after ||
        var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
        if (filterMatch && filterMatch[1].trim()) {
          filters = filterMatch[1];
          source = source.replace(filters, '');
        }
      }
      return {
        itemName: match[4] || match[2],
        // (lhs) Left-hand side,
        keyName: match[3],
        //for (key, value) syntax
        source: $parse(source),
        filters: filters,
        trackByExp: match[6],
        modelMapper: $parse(match[1] || match[4] || match[2]),
        repeatExpression: function (grouped) {
          var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
          if (this.trackByExp) {
            expression += ' track by ' + this.trackByExp;
          }
          return expression;
        }
      };
    };
    self.getGroupNgRepeatExpression = function () {
      return '$group in $select.groups track by $group.name';
    };
  }]);
})();
angular.module("ui.select").run(["$templateCache", function ($templateCache) {
  $templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
  $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
  $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
  $templateCache.put("bootstrap/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
  $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
  $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
  $templateCache.put("select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
  $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
  $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
  $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
  $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
  $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
  $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
  $templateCache.put("selectize/match-multiple.tpl.html", "<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
  $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
  $templateCache.put("selectize/no-choice.tpl.html", "<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
  $templateCache.put("selectize/select-multiple.tpl.html", "<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
  $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
}]);
/**
 * @license Angular UI Tree v2.14.0
 * (c) 2010-2015. https://github.com/angular-ui-tree/angular-ui-tree
 * License: MIT
 */
(function () {
  'use strict';

  angular.module('ui.tree', []).constant('treeConfig', {
    treeClass: 'angular-ui-tree',
    emptyTreeClass: 'angular-ui-tree-empty',
    hiddenClass: 'angular-ui-tree-hidden',
    nodesClass: 'angular-ui-tree-nodes',
    nodeClass: 'angular-ui-tree-node',
    handleClass: 'angular-ui-tree-handle',
    placeholderClass: 'angular-ui-tree-placeholder',
    dragClass: 'angular-ui-tree-drag',
    dragThreshold: 3,
    levelThreshold: 30,
    defaultCollapsed: false
  });
})();
(function () {
  'use strict';

  angular.module('ui.tree').controller('TreeHandleController', ['$scope', '$element', function ($scope, $element) {
    this.scope = $scope;
    $scope.$element = $element;
    $scope.$nodeScope = null;
    $scope.$type = 'uiTreeHandle';
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').controller('TreeNodeController', ['$scope', '$element', function ($scope, $element) {
    this.scope = $scope;
    $scope.$element = $element;
    $scope.$modelValue = null; // Model value for node;
    $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
    $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
    $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
    $scope.$treeScope = null; // uiTree scope
    $scope.$handleScope = null; // it's handle scope
    $scope.$type = 'uiTreeNode';
    $scope.$$allowNodeDrop = false;
    $scope.collapsed = false;
    $scope.init = function (controllersArr) {
      var treeNodesCtrl = controllersArr[0];
      $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;

      // find the scope of it's parent node
      $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;
      // modelValue for current node
      $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
      $scope.$parentNodesScope = treeNodesCtrl.scope;
      treeNodesCtrl.scope.initSubNode($scope); // init sub nodes

      $element.on('$destroy', function () {
        treeNodesCtrl.scope.destroySubNode($scope); // destroy sub nodes
      });
    };

    $scope.index = function () {
      return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
    };
    $scope.dragEnabled = function () {
      return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
    };
    $scope.isSibling = function (targetNode) {
      return $scope.$parentNodesScope == targetNode.$parentNodesScope;
    };
    $scope.isChild = function (targetNode) {
      var nodes = $scope.childNodes();
      return nodes && nodes.indexOf(targetNode) > -1;
    };
    $scope.prev = function () {
      var index = $scope.index();
      if (index > 0) {
        return $scope.siblings()[index - 1];
      }
      return null;
    };
    $scope.siblings = function () {
      return $scope.$parentNodesScope.childNodes();
    };
    $scope.childNodesCount = function () {
      return $scope.childNodes() ? $scope.childNodes().length : 0;
    };
    $scope.hasChild = function () {
      return $scope.childNodesCount() > 0;
    };
    $scope.childNodes = function () {
      return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ? $scope.$childNodesScope.childNodes() : null;
    };
    $scope.accept = function (sourceNode, destIndex) {
      return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue && $scope.$childNodesScope.accept(sourceNode, destIndex);
    };
    $scope.remove = function () {
      return $scope.$parentNodesScope.removeNode($scope);
    };
    $scope.toggle = function () {
      $scope.collapsed = !$scope.collapsed;
    };
    $scope.collapse = function () {
      $scope.collapsed = true;
    };
    $scope.expand = function () {
      $scope.collapsed = false;
    };
    $scope.depth = function () {
      var parentNode = $scope.$parentNodeScope;
      if (parentNode) {
        return parentNode.depth() + 1;
      }
      return 1;
    };

    /**
    * Returns the depth of the deepest subtree under this node
    * @param scope a TreeNodesController scope object
    * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
    *   result is 0 (it has no subtree).
    */
    function countSubTreeDepth(scope) {
      var thisLevelDepth = 0,
        childNodes = scope.childNodes(),
        childNode,
        childDepth,
        i;
      if (!childNodes || childNodes.length === 0) {
        return 0;
      }
      for (i = childNodes.length - 1; i >= 0; i--) {
        childNode = childNodes[i], childDepth = 1 + countSubTreeDepth(childNode);
        thisLevelDepth = Math.max(thisLevelDepth, childDepth);
      }
      return thisLevelDepth;
    }
    $scope.maxSubDepth = function () {
      return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').controller('TreeNodesController', ['$scope', '$element', function ($scope, $element) {
    this.scope = $scope;
    $scope.$element = $element;
    $scope.$modelValue = null;
    $scope.$nodeScope = null; // the scope of node which the nodes belongs to
    $scope.$treeScope = null;
    $scope.$type = 'uiTreeNodes';
    $scope.$nodesMap = {};
    $scope.nodropEnabled = false;
    $scope.maxDepth = 0;
    $scope.cloneEnabled = false;
    $scope.initSubNode = function (subNode) {
      if (!subNode.$modelValue) {
        return null;
      }
      $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
    };
    $scope.destroySubNode = function (subNode) {
      if (!subNode.$modelValue) {
        return null;
      }
      $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
    };
    $scope.accept = function (sourceNode, destIndex) {
      return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
    };
    $scope.beforeDrag = function (sourceNode) {
      return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
    };
    $scope.isParent = function (node) {
      return node.$parentNodesScope == $scope;
    };
    $scope.hasChild = function () {
      return $scope.$modelValue.length > 0;
    };
    $scope.safeApply = function (fn) {
      var phase = this.$root.$$phase;
      if (phase == '$apply' || phase == '$digest') {
        if (fn && typeof fn === 'function') {
          fn();
        }
      } else {
        this.$apply(fn);
      }
    };
    $scope.removeNode = function (node) {
      var index = $scope.$modelValue.indexOf(node.$modelValue);
      if (index > -1) {
        $scope.safeApply(function () {
          $scope.$modelValue.splice(index, 1)[0];
        });
        return $scope.$treeScope.$callbacks.removed(node);
      }
      return null;
    };
    $scope.insertNode = function (index, nodeData) {
      $scope.safeApply(function () {
        $scope.$modelValue.splice(index, 0, nodeData);
      });
    };
    $scope.childNodes = function () {
      var i,
        nodes = [];
      if ($scope.$modelValue) {
        for (i = 0; i < $scope.$modelValue.length; i++) {
          nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
        }
      }
      return nodes;
    };
    $scope.depth = function () {
      if ($scope.$nodeScope) {
        return $scope.$nodeScope.depth();
      }
      return 0; // if it has no $nodeScope, it's root
    };

    // check if depth limit has reached
    $scope.outOfDepth = function (sourceNode) {
      var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
      if (maxDepth > 0) {
        return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
      }
      return false;
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').controller('TreeController', ['$scope', '$element', function ($scope, $element) {
    this.scope = $scope;
    $scope.$element = $element;
    $scope.$nodesScope = null; // root nodes
    $scope.$type = 'uiTree';
    $scope.$emptyElm = null;
    $scope.$callbacks = null;
    $scope.dragEnabled = true;
    $scope.emptyPlaceholderEnabled = true;
    $scope.maxDepth = 0;
    $scope.dragDelay = 0;
    $scope.cloneEnabled = false;
    $scope.nodropEnabled = false;

    // Check if it's a empty tree
    $scope.isEmpty = function () {
      return $scope.$nodesScope && $scope.$nodesScope.$modelValue && $scope.$nodesScope.$modelValue.length === 0;
    };

    // add placeholder to empty tree
    $scope.place = function (placeElm) {
      $scope.$nodesScope.$element.append(placeElm);
      $scope.$emptyElm.remove();
    };
    this.resetEmptyElement = function () {
      if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) && $scope.emptyPlaceholderEnabled) {
        $element.append($scope.$emptyElm);
      } else {
        $scope.$emptyElm.remove();
      }
    };
    $scope.resetEmptyElement = this.resetEmptyElement;
    var collapseOrExpand = function (scope, collapsed) {
      var i,
        subScope,
        nodes = scope.childNodes();
      for (i = 0; i < nodes.length; i++) {
        collapsed ? nodes[i].collapse() : nodes[i].expand();
        subScope = nodes[i].$childNodesScope;
        if (subScope) {
          collapseOrExpand(subScope, collapsed);
        }
      }
    };
    $scope.collapseAll = function () {
      collapseOrExpand($scope.$nodesScope, true);
    };
    $scope.expandAll = function () {
      collapseOrExpand($scope.$nodesScope, false);
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').directive('uiTree', ['treeConfig', '$window', function (treeConfig, $window) {
    return {
      restrict: 'A',
      scope: true,
      controller: 'TreeController',
      link: function (scope, element, attrs, ctrl) {
        var callbacks = {
            accept: null,
            beforeDrag: null
          },
          config = {},
          tdElm,
          $trElm,
          emptyElmColspan;
        angular.extend(config, treeConfig);
        if (config.treeClass) {
          element.addClass(config.treeClass);
        }
        if (element.prop('tagName').toLowerCase() === 'table') {
          scope.$emptyElm = angular.element($window.document.createElement('tr'));
          $trElm = element.find('tr');
          // If we can find a tr, then we can use its td children as the empty element colspan.
          if ($trElm.length > 0) {
            emptyElmColspan = angular.element($trElm).children().length;
          } else {
            // If not, by setting a huge colspan we make sure it takes full width.
            emptyElmColspan = 1000000;
          }
          tdElm = angular.element($window.document.createElement('td')).attr('colspan', emptyElmColspan);
          scope.$emptyElm.append(tdElm);
        } else {
          scope.$emptyElm = angular.element($window.document.createElement('div'));
        }
        if (config.emptyTreeClass) {
          scope.$emptyElm.addClass(config.emptyTreeClass);
        }
        scope.$watch('$nodesScope.$modelValue.length', function (val) {
          if (!angular.isNumber(val)) {
            return;
          }
          ctrl.resetEmptyElement();
        }, true);
        scope.$watch(attrs.dragEnabled, function (val) {
          if (typeof val == 'boolean') {
            scope.dragEnabled = val;
          }
        });
        scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
          if (typeof val == 'boolean') {
            scope.emptyPlaceholderEnabled = val;
            ctrl.resetEmptyElement();
          }
        });
        scope.$watch(attrs.nodropEnabled, function (val) {
          if (typeof val == 'boolean') {
            scope.nodropEnabled = val;
          }
        });
        scope.$watch(attrs.cloneEnabled, function (val) {
          if (typeof val == 'boolean') {
            scope.cloneEnabled = val;
          }
        });
        scope.$watch(attrs.maxDepth, function (val) {
          if (typeof val == 'number') {
            scope.maxDepth = val;
          }
        });
        scope.$watch(attrs.dragDelay, function (val) {
          if (typeof val == 'number') {
            scope.dragDelay = val;
          }
        });

        /**
         * Callback checks if the destination node can accept the dragged node.
         * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
         * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
         * if it is set on the ui-tree or ui-tree-nodes.
         * This callback can be overridden, but callers must manually enforce nodrop and max-depth
         * themselves if they need those to be enforced.
         * @param sourceNodeScope Scope of the ui-tree-node being dragged
         * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
         * @param destIndex Index in the destination nodes array where the source node will drop
         * @returns {boolean} True if the node is permitted to be dropped here
         */
        callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
          return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
        };
        callbacks.beforeDrag = function (sourceNodeScope) {
          return true;
        };
        callbacks.removed = function (node) {};

        /**
         * Callback is fired when a node is successfully dropped in a new location
         * @param event
         */
        callbacks.dropped = function (event) {};

        /**
         * Callback is fired each time the user starts dragging a node
         * @param event
         */
        callbacks.dragStart = function (event) {};

        /**
         * Callback is fired each time a dragged node is moved with the mouse/touch.
         * @param event
         */
        callbacks.dragMove = function (event) {};

        /**
         * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
         * accepted or reverted.
         * @param event
         */
        callbacks.dragStop = function (event) {};

        /**
         * Callback is fired when a user drops a node (but prior to processing the drop action)
         * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
         * If it returns falsy, or a resolve Promise, the node move is accepted
         * If it returns truthy, or a rejected Promise, the node move is reverted
         * @param event
         * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
         */
        callbacks.beforeDrop = function (event) {};
        scope.$watch(attrs.uiTree, function (newVal, oldVal) {
          angular.forEach(newVal, function (value, key) {
            if (callbacks[key]) {
              if (typeof value === 'function') {
                callbacks[key] = value;
              }
            }
          });
          scope.$callbacks = callbacks;
        }, true);
      }
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').directive('uiTreeHandle', ['treeConfig', function (treeConfig) {
    return {
      require: '^uiTreeNode',
      restrict: 'A',
      scope: true,
      controller: 'TreeHandleController',
      link: function (scope, element, attrs, treeNodeCtrl) {
        var config = {};
        angular.extend(config, treeConfig);
        if (config.handleClass) {
          element.addClass(config.handleClass);
        }
        // connect with the tree node.
        if (scope != treeNodeCtrl.scope) {
          scope.$nodeScope = treeNodeCtrl.scope;
          treeNodeCtrl.scope.$handleScope = scope;
        }
      }
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').directive('uiTreeNode', ['treeConfig', 'UiTreeHelper', '$window', '$document', '$timeout', '$q', '$rootElement', function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q, $rootElement) {
    return {
      require: ['^uiTreeNodes', '^uiTree'],
      restrict: 'A',
      controller: 'TreeNodeController',
      link: function (scope, element, attrs, controllersArr) {
        // todo startPos is unused
        var config = {},
          hasTouch = ('ontouchstart' in window),
          startPos,
          firstMoving,
          dragInfo,
          pos,
          placeElm,
          hiddenPlaceElm,
          dragElm,
          treeScope = null,
          elements,
          // As a parameter for callbacks
          dragDelaying = true,
          dragStarted = false,
          dragTimer = null,
          body = document.body,
          html = document.documentElement,
          document_height,
          document_width,
          dragStart,
          tagName,
          dragMove,
          dragEnd,
          dragStartEvent,
          dragMoveEvent,
          dragEndEvent,
          dragCancelEvent,
          dragDelay,
          bindDragStartEvents,
          bindDragMoveEvents,
          unbindDragMoveEvents,
          keydownHandler,
          outOfBounds;
        angular.extend(config, treeConfig);
        if (config.nodeClass) {
          element.addClass(config.nodeClass);
        }
        scope.init(controllersArr);
        scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
        scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;
        scope.$watch(attrs.collapsed, function (val) {
          if (typeof val == 'boolean') {
            scope.collapsed = val;
          }
        });
        scope.$watch('collapsed', function (val) {
          UiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
          attrs.$set('collapsed', val);
        });

        /**
         * Called when the user has grabbed a node and started dragging it
         * @param e
         */
        dragStart = function (e) {
          if (!hasTouch && (e.button == 2 || e.which == 3)) {
            // disable right click
            return;
          }
          if (e.uiTreeDragging || e.originalEvent && e.originalEvent.uiTreeDragging) {
            // event has already fired in other scope.
            return;
          }

          // the node being dragged
          var eventElm = angular.element(e.target),
            eventScope = eventElm.scope(),
            cloneElm = element.clone(),
            eventElmTagName,
            tagName,
            eventObj,
            tdElm,
            hStyle;
          if (!eventScope || !eventScope.$type) {
            return;
          }
          if (eventScope.$type != 'uiTreeNode' && eventScope.$type != 'uiTreeHandle') {
            // Check if it is a node or a handle
            return;
          }
          if (eventScope.$type == 'uiTreeNode' && eventScope.$handleScope) {
            // If the node has a handle, then it should be clicked by the handle
            return;
          }
          eventElmTagName = eventElm.prop('tagName').toLowerCase();
          if (eventElmTagName == 'input' || eventElmTagName == 'textarea' || eventElmTagName == 'button' || eventElmTagName == 'select') {
            // if it's a input or button, ignore it
            return;
          }

          // check if it or it's parents has a 'data-nodrag' attribute
          while (eventElm && eventElm[0] && eventElm[0] != element) {
            if (UiTreeHelper.nodrag(eventElm)) {
              // if the node mark as `nodrag`, DONOT drag it.
              return;
            }
            eventElm = eventElm.parent();
          }
          if (!scope.beforeDrag(scope)) {
            return;
          }
          e.uiTreeDragging = true; // stop event bubbling
          if (e.originalEvent) {
            e.originalEvent.uiTreeDragging = true;
          }
          e.preventDefault();
          eventObj = UiTreeHelper.eventObj(e);
          firstMoving = true;
          dragInfo = UiTreeHelper.dragInfo(scope);
          tagName = element.prop('tagName');
          if (tagName.toLowerCase() === 'tr') {
            placeElm = angular.element($window.document.createElement(tagName));
            tdElm = angular.element($window.document.createElement('td')).addClass(config.placeholderClass).attr('colspan', element[0].children.length);
            placeElm.append(tdElm);
          } else {
            placeElm = angular.element($window.document.createElement(tagName)).addClass(config.placeholderClass);
          }
          hiddenPlaceElm = angular.element($window.document.createElement(tagName));
          if (config.hiddenClass) {
            hiddenPlaceElm.addClass(config.hiddenClass);
          }
          pos = UiTreeHelper.positionStarted(eventObj, element);
          placeElm.css('height', UiTreeHelper.height(element) + 'px');
          dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop('tagName'))).addClass(scope.$parentNodesScope.$element.attr('class')).addClass(config.dragClass);
          dragElm.css('width', UiTreeHelper.width(element) + 'px');
          dragElm.css('z-index', 9999);

          // Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element
          hStyle = (element[0].querySelector('.angular-ui-tree-handle') || element[0]).currentStyle;
          if (hStyle) {
            document.body.setAttribute('ui-tree-cursor', $document.find('body').css('cursor') || '');
            $document.find('body').css({
              'cursor': hStyle.cursor + '!important'
            });
          }
          if (scope.sourceOnly) {
            placeElm.css('display', 'none');
          }
          element.after(placeElm);
          element.after(hiddenPlaceElm);
          if (dragInfo.isClone() && scope.sourceOnly) {
            dragElm.append(cloneElm);
          } else {
            dragElm.append(element);
          }
          $rootElement.append(dragElm);
          dragElm.css({
            'left': eventObj.pageX - pos.offsetX + 'px',
            'top': eventObj.pageY - pos.offsetY + 'px'
          });
          elements = {
            placeholder: placeElm,
            dragging: dragElm
          };
          bindDragMoveEvents();
          // Fire dragStart callback
          scope.$apply(function () {
            scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
          });
          document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
          document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
        };
        dragMove = function (e) {
          var eventObj = UiTreeHelper.eventObj(e),
            prev,
            next,
            leftElmPos,
            topElmPos,
            top_scroll,
            bottom_scroll,
            target,
            decrease,
            targetX,
            targetY,
            displayElm,
            targetNode,
            targetElm,
            isEmpty,
            targetOffset,
            targetBefore;
          if (dragElm) {
            e.preventDefault();
            if ($window.getSelection) {
              $window.getSelection().removeAllRanges();
            } else if ($window.document.selection) {
              $window.document.selection.empty();
            }
            leftElmPos = eventObj.pageX - pos.offsetX;
            topElmPos = eventObj.pageY - pos.offsetY;

            //dragElm can't leave the screen on the left
            if (leftElmPos < 0) {
              leftElmPos = 0;
            }

            //dragElm can't leave the screen on the top
            if (topElmPos < 0) {
              topElmPos = 0;
            }

            //dragElm can't leave the screen on the bottom
            if (topElmPos + 10 > document_height) {
              topElmPos = document_height - 10;
            }

            //dragElm can't leave the screen on the right
            if (leftElmPos + 10 > document_width) {
              leftElmPos = document_width - 10;
            }
            dragElm.css({
              'left': leftElmPos + 'px',
              'top': topElmPos + 'px'
            });
            top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
            bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);

            // to scroll down if cursor y-position is greater than the bottom position the vertical scroll
            if (bottom_scroll < eventObj.pageY && bottom_scroll <= document_height) {
              window.scrollBy(0, 10);
            }

            // to scroll top if cursor y-position is less than the top position the vertical scroll
            if (top_scroll > eventObj.pageY) {
              window.scrollBy(0, -10);
            }
            UiTreeHelper.positionMoved(e, pos, firstMoving);
            if (firstMoving) {
              firstMoving = false;
              return;
            }

            // check if add it as a child node first
            // todo decrease is unused
            decrease = UiTreeHelper.offset(dragElm).left - UiTreeHelper.offset(placeElm).left >= config.threshold;
            targetX = eventObj.pageX - ($window.pageXOffset || $window.document.body.scrollLeft || $window.document.documentElement.scrollLeft) - ($window.document.documentElement.clientLeft || 0);
            targetY = eventObj.pageY - ($window.pageYOffset || $window.document.body.scrollTop || $window.document.documentElement.scrollTop) - ($window.document.documentElement.clientTop || 0);

            // Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
            // pick the drag element itself as the target. To prevent this, we hide the drag element while
            // selecting the target.
            if (angular.isFunction(dragElm.hide)) {
              dragElm.hide();
            } else {
              displayElm = dragElm[0].style.display;
              dragElm[0].style.display = 'none';
            }

            // when using elementFromPoint() inside an iframe, you have to call
            // elementFromPoint() twice to make sure IE8 returns the correct value
            $window.document.elementFromPoint(targetX, targetY);
            targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));
            if (angular.isFunction(dragElm.show)) {
              dragElm.show();
            } else {
              dragElm[0].style.display = displayElm;
            }
            outOfBounds = !targetElm.scope() || !targetElm.scope().$type;

            // Detect out of bounds condition, update drop target display, and prevent drop
            if (outOfBounds) {
              // Remove the placeholder
              placeElm.remove();

              // If the target was an empty tree, replace the empty element placeholder
              if (treeScope) {
                treeScope.resetEmptyElement();
                treeScope = null;
              }
            }

            // move horizontal
            if (pos.dirAx && pos.distAxX >= config.levelThreshold) {
              pos.distAxX = 0;

              // increase horizontal level if previous sibling exists and is not collapsed
              if (pos.distX > 0) {
                prev = dragInfo.prev();
                if (prev && !prev.collapsed && prev.accept(scope, prev.childNodesCount())) {
                  prev.$childNodesScope.$element.append(placeElm);
                  dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
                }
              }

              // decrease horizontal level
              if (pos.distX < 0) {
                // we can't decrease a level if an item preceeds the current one
                next = dragInfo.next();
                if (!next) {
                  target = dragInfo.parentNode(); // As a sibling of it's parent node
                  if (target && target.$parentNodesScope.accept(scope, target.index() + 1)) {
                    target.$element.after(placeElm);
                    dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                  }
                }
              }
            }

            // move vertical
            if (!pos.dirAx) {
              // check it's new position
              targetNode = targetElm.scope();
              isEmpty = false;
              if (!targetNode) {
                return;
              }

              // Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
              if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
                placeElm.css('display', '');
              }
              if (targetNode.$type == 'uiTree' && targetNode.dragEnabled) {
                isEmpty = targetNode.isEmpty(); // Check if it's empty tree
              }

              if (targetNode.$type == 'uiTreeHandle') {
                targetNode = targetNode.$nodeScope;
              }
              if (targetNode.$type != 'uiTreeNode' && !isEmpty) {
                // Check if it is a uiTreeNode or it's an empty tree
                return;
              }

              // if placeholder move from empty tree, reset it.
              if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
                treeScope.resetEmptyElement();
                treeScope = null;
              }
              if (isEmpty) {
                // it's an empty tree
                treeScope = targetNode;
                if (targetNode.$nodesScope.accept(scope, 0)) {
                  targetNode.place(placeElm);
                  dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
                }
              } else if (targetNode.dragEnabled()) {
                // drag enabled
                targetElm = targetNode.$element; // Get the element of ui-tree-node
                targetOffset = UiTreeHelper.offset(targetElm);
                targetBefore = targetNode.horizontal ? eventObj.pageX < targetOffset.left + UiTreeHelper.width(targetElm) / 2 : eventObj.pageY < targetOffset.top + UiTreeHelper.height(targetElm) / 2;
                if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
                  if (targetBefore) {
                    targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
                    dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
                  } else {
                    targetElm.after(placeElm);
                    dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
                  }
                } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) {
                  // we have to check if it can add the dragging node as a child
                  targetNode.$childNodesScope.$element.append(placeElm);
                  dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
                } else {
                  outOfBounds = true;
                }
              }
            }
            scope.$apply(function () {
              scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
            });
          }
        };
        dragEnd = function (e) {
          var dragEventArgs = dragInfo.eventArgs(elements, pos);
          e.preventDefault();
          unbindDragMoveEvents();
          scope.$treeScope.$apply(function () {
            $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))
            // promise resolved (or callback didn't return false)
            .then(function (allowDrop) {
              if (allowDrop !== false && scope.$$allowNodeDrop && !outOfBounds) {
                // node drop accepted)
                dragInfo.apply();
                // fire the dropped callback only if the move was successful
                scope.$treeScope.$callbacks.dropped(dragEventArgs);
              } else {
                // drop canceled - revert the node to its original position
                bindDragStartEvents();
              }
            })
            // promise rejected - revert the node to its original position
            .catch(function () {
              bindDragStartEvents();
            }).finally(function () {
              hiddenPlaceElm.replaceWith(scope.$element);
              placeElm.remove();
              if (dragElm) {
                // drag element is attached to the mouse pointer
                dragElm.remove();
                dragElm = null;
              }
              scope.$treeScope.$callbacks.dragStop(dragEventArgs);
              scope.$$allowNodeDrop = false;
              dragInfo = null;

              // Restore cursor in Opera 12.16 and IE
              var oldCur = document.body.getAttribute('ui-tree-cursor');
              if (oldCur !== null) {
                $document.find('body').css({
                  'cursor': oldCur
                });
                document.body.removeAttribute('ui-tree-cursor');
              }
            });
          });
        };
        dragStartEvent = function (e) {
          if (scope.dragEnabled()) {
            dragStart(e);
          }
        };
        dragMoveEvent = function (e) {
          dragMove(e);
        };
        dragEndEvent = function (e) {
          scope.$$allowNodeDrop = true;
          dragEnd(e);
        };
        dragCancelEvent = function (e) {
          dragEnd(e);
        };
        dragDelay = function () {
          var to;
          return {
            exec: function (fn, ms) {
              if (!ms) {
                ms = 0;
              }
              this.cancel();
              to = $timeout(fn, ms);
            },
            cancel: function () {
              $timeout.cancel(to);
            }
          };
        }();

        /**
         * Binds the mouse/touch events to enable drag start for this node
         */
        bindDragStartEvents = function () {
          element.bind('touchstart mousedown', function (e) {
            dragDelay.exec(function () {
              dragStartEvent(e);
            }, scope.dragDelay || 0);
          });
          element.bind('touchend touchcancel mouseup', function () {
            dragDelay.cancel();
          });
        };
        bindDragStartEvents();

        /**
         * Binds mouse/touch events that handle moving/dropping this dragged node
         */
        bindDragMoveEvents = function () {
          angular.element($document).bind('touchend', dragEndEvent);
          angular.element($document).bind('touchcancel', dragEndEvent);
          angular.element($document).bind('touchmove', dragMoveEvent);
          angular.element($document).bind('mouseup', dragEndEvent);
          angular.element($document).bind('mousemove', dragMoveEvent);
          angular.element($document).bind('mouseleave', dragCancelEvent);
        };

        /**
         * Unbinds mouse/touch events that handle moving/dropping this dragged node
         */
        unbindDragMoveEvents = function () {
          angular.element($document).unbind('touchend', dragEndEvent);
          angular.element($document).unbind('touchcancel', dragEndEvent);
          angular.element($document).unbind('touchmove', dragMoveEvent);
          angular.element($document).unbind('mouseup', dragEndEvent);
          angular.element($document).unbind('mousemove', dragMoveEvent);
          angular.element($document).unbind('mouseleave', dragCancelEvent);
        };
        keydownHandler = function (e) {
          if (e.keyCode == 27) {
            scope.$$allowNodeDrop = false;
            dragEnd(e);
          }
        };
        angular.element($window.document).bind('keydown', keydownHandler);

        //unbind handler that retains scope
        scope.$on('$destroy', function () {
          angular.element($window.document).unbind('keydown', keydownHandler);
        });
      }
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree').directive('uiTreeNodes', ['treeConfig', '$window', function (treeConfig) {
    return {
      require: ['ngModel', '?^uiTreeNode', '^uiTree'],
      restrict: 'A',
      scope: true,
      controller: 'TreeNodesController',
      link: function (scope, element, attrs, controllersArr) {
        var config = {},
          ngModel = controllersArr[0],
          treeNodeCtrl = controllersArr[1],
          treeCtrl = controllersArr[2];
        angular.extend(config, treeConfig);
        if (config.nodesClass) {
          element.addClass(config.nodesClass);
        }
        if (treeNodeCtrl) {
          treeNodeCtrl.scope.$childNodesScope = scope;
          scope.$nodeScope = treeNodeCtrl.scope;
        } else {
          // find the root nodes if there is no parent node and have a parent ui-tree
          treeCtrl.scope.$nodesScope = scope;
        }
        scope.$treeScope = treeCtrl.scope;
        if (ngModel) {
          ngModel.$render = function () {
            scope.$modelValue = ngModel.$modelValue;
          };
        }
        scope.$watch(function () {
          return attrs.maxDepth;
        }, function (val) {
          if (typeof val == 'number') {
            scope.maxDepth = val;
          }
        });
        scope.$watch(function () {
          return attrs.nodropEnabled;
        }, function (newVal) {
          if (typeof newVal != 'undefined') {
            scope.nodropEnabled = true;
          }
        }, true);
        attrs.$observe('horizontal', function (val) {
          scope.horizontal = typeof val != 'undefined';
        });
      }
    };
  }]);
})();
(function () {
  'use strict';

  angular.module('ui.tree')

  /**
   * @ngdoc service
   * @name ui.tree.service:UiTreeHelper
   * @requires ng.$document
   * @requires ng.$window
   *
   * @description
   * angular-ui-tree.
   */.factory('UiTreeHelper', ['$document', '$window', function ($document, $window) {
    return {
      /**
       * A hashtable used to storage data of nodes
       * @type {Object}
       */
      nodesData: {},
      setNodeAttribute: function (scope, attrName, val) {
        if (!scope.$modelValue) {
          return null;
        }
        var data = this.nodesData[scope.$modelValue.$$hashKey];
        if (!data) {
          data = {};
          this.nodesData[scope.$modelValue.$$hashKey] = data;
        }
        data[attrName] = val;
      },
      getNodeAttribute: function (scope, attrName) {
        if (!scope.$modelValue) {
          return null;
        }
        var data = this.nodesData[scope.$modelValue.$$hashKey];
        if (data) {
          return data[attrName];
        }
        return null;
      },
      /**
       * @ngdoc method
       * @methodOf ui.tree.service:$nodrag
       * @param  {Object} targetElm angular element
       * @return {Bool} check if the node can be dragged.
       */
      nodrag: function (targetElm) {
        if (typeof targetElm.attr('data-nodrag') != 'undefined') {
          return targetElm.attr('data-nodrag') !== 'false';
        }
        return false;
      },
      /**
       * get the event object for touches
       * @param  {[type]} e [description]
       * @return {[type]}   [description]
       */
      eventObj: function (e) {
        var obj = e;
        if (e.targetTouches !== undefined) {
          obj = e.targetTouches.item(0);
        } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
          obj = e.originalEvent.targetTouches.item(0);
        }
        return obj;
      },
      dragInfo: function (node) {
        return {
          source: node,
          sourceInfo: {
            cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
            nodeScope: node,
            index: node.index(),
            nodesScope: node.$parentNodesScope
          },
          index: node.index(),
          siblings: node.siblings().slice(0),
          parent: node.$parentNodesScope,
          // Move the node to a new position
          moveTo: function (parent, siblings, index) {
            this.parent = parent;
            this.siblings = siblings.slice(0);

            // If source node is in the target nodes
            var i = this.siblings.indexOf(this.source);
            if (i > -1) {
              this.siblings.splice(i, 1);
              if (this.source.index() < index) {
                index--;
              }
            }
            this.siblings.splice(index, 0, this.source);
            this.index = index;
          },
          parentNode: function () {
            return this.parent.$nodeScope;
          },
          prev: function () {
            if (this.index > 0) {
              return this.siblings[this.index - 1];
            }
            return null;
          },
          next: function () {
            if (this.index < this.siblings.length - 1) {
              return this.siblings[this.index + 1];
            }
            return null;
          },
          isClone: function () {
            return this.source.$treeScope.cloneEnabled === true;
          },
          clonedNode: function (node) {
            return angular.copy(node);
          },
          isDirty: function () {
            return this.source.$parentNodesScope != this.parent || this.source.index() != this.index;
          },
          isForeign: function () {
            return this.source.$treeScope !== this.parent.$treeScope;
          },
          eventArgs: function (elements, pos) {
            return {
              source: this.sourceInfo,
              dest: {
                index: this.index,
                nodesScope: this.parent
              },
              elements: elements,
              pos: pos
            };
          },
          apply: function () {
            var nodeData = this.source.$modelValue;

            // nodrop enabled on tree or parent
            if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
              return;
            }

            // node was dropped in the same place - do nothing
            if (!this.isDirty()) {
              return;
            }

            // cloneEnabled and cross-tree so copy and do not remove from source
            if (this.isClone() && this.isForeign()) {
              this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
            } else {
              // Any other case, remove and reinsert
              this.source.remove();
              this.parent.insertNode(this.index, nodeData);
            }
          }
        };
      },
      /**
       * @ngdoc method
       * @name ui.tree#height
       * @methodOf ui.tree.service:UiTreeHelper
       *
       * @description
       * Get the height of an element.
       *
       * @param {Object} element Angular element.
       * @returns {String} Height
       */
      height: function (element) {
        return element.prop('scrollHeight');
      },
      /**
       * @ngdoc method
       * @name ui.tree#width
       * @methodOf ui.tree.service:UiTreeHelper
       *
       * @description
       * Get the width of an element.
       *
       * @param {Object} element Angular element.
       * @returns {String} Width
       */
      width: function (element) {
        return element.prop('scrollWidth');
      },
      /**
       * @ngdoc method
       * @name ui.tree#offset
       * @methodOf ui.nestedSortable.service:UiTreeHelper
       *
       * @description
       * Get the offset values of an element.
       *
       * @param {Object} element Angular element.
       * @returns {Object} Object with properties width, height, top and left
       */
      offset: function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: element.prop('offsetWidth'),
          height: element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
        };
      },
      /**
       * @ngdoc method
       * @name ui.tree#positionStarted
       * @methodOf ui.tree.service:UiTreeHelper
       *
       * @description
       * Get the start position of the target element according to the provided event properties.
       *
       * @param {Object} e Event
       * @param {Object} target Target element
       * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
       */
      positionStarted: function (e, target) {
        var pos = {},
          pageX = e.pageX,
          pageY = e.pageY;
        if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
          pageX = e.originalEvent.touches[0].pageX;
          pageY = e.originalEvent.touches[0].pageY;
        }
        pos.offsetX = pageX - this.offset(target).left;
        pos.offsetY = pageY - this.offset(target).top;
        pos.startX = pos.lastX = pageX;
        pos.startY = pos.lastY = pageY;
        pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
        pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
        return pos;
      },
      positionMoved: function (e, pos, firstMoving) {
        var pageX = e.pageX,
          pageY = e.pageY,
          newAx;
        if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
          pageX = e.originalEvent.touches[0].pageX;
          pageY = e.originalEvent.touches[0].pageY;
        }
        // mouse position last events
        pos.lastX = pos.nowX;
        pos.lastY = pos.nowY;

        // mouse position this events
        pos.nowX = pageX;
        pos.nowY = pageY;

        // distance mouse moved between events
        pos.distX = pos.nowX - pos.lastX;
        pos.distY = pos.nowY - pos.lastY;

        // direction mouse was moving
        pos.lastDirX = pos.dirX;
        pos.lastDirY = pos.dirY;

        // direction mouse is now moving (on both axis)
        pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
        pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

        // axis mouse is now moving on
        newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

        // do nothing on first move
        if (firstMoving) {
          pos.dirAx = newAx;
          pos.moving = true;
          return;
        }

        // calc distance moved on this axis (and direction)
        if (pos.dirAx !== newAx) {
          pos.distAxX = 0;
          pos.distAxY = 0;
        } else {
          pos.distAxX += Math.abs(pos.distX);
          if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
            pos.distAxX = 0;
          }
          pos.distAxY += Math.abs(pos.distY);
          if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
            pos.distAxY = 0;
          }
        }
        pos.dirAx = newAx;
      }
    };
  }]);
})();
(function (angular) {
  'use strict';

  angular.module('ui.tree-filter', [])
  /**
   * @ngdoc object
   * @name ui.tree-filter.provider:uiTreeFilterSettings
   */.provider('uiTreeFilterSettings', function () {
    var uiTreeFilterSettings = this;
    this.addresses = ['title'];
    this.regexFlags = 'gi';
    this.descendantCollection = 'items';
    this.$get = function () {
      return {
        addresses: uiTreeFilterSettings.addresses,
        regexFlags: uiTreeFilterSettings.regexFlags,
        descendantCollection: uiTreeFilterSettings.descendantCollection
      };
    };
  })
  /**
   * @ngdoc function
   * @name ui.tree-filter.factory:uiTreeFilter
   */.filter('uiTreeFilter', ["uiTreeFilterSettings", function (uiTreeFilterSettings) {
    /**
     * Iterates through given collection if flag is not true and sets a flag to true on first match.
     *
     * @param {Array}   collection
     * @param {string}  pattern
     * @param {string}  address
     *
     * @returns {boolean}
     */
    function visit(collection, pattern, address) {
      collection = collection || [];
      var foundSoFar = false;
      collection.forEach(function (collectionItem) {
        foundSoFar = foundSoFar || testForField(collectionItem, pattern, address);
      });
      return foundSoFar;
    }

    /**
     * Resolves object value from dot-delimited address.
     *
     * @param object
     * @param path
     * @returns {*}
     */
    function resolveAddress(object, path) {
      var parts = path.split('.');
      if (object === undefined) {
        return;
      }
      return parts.length < 2 ? object[parts[0]] : resolveAddress(object[parts[0]], parts.slice(1).join('.'));
    }

    /**
     * Checks if object or its children matches a pattern on a given field
     *
     * First it resolves the property address and gets the value.
     * If the value is a string it matches it against provided pattern.
     * If item matches because its property matches it's children are not checked.
     * Otherwise all item descendants are checked as well
     *
     * @param {Object} item
     * @param {string} pattern
     * @param {string} address property name or dot-delimited path to property.
     *
     * @returns {boolean}
     */
    function testForField(item, pattern, address) {
      var value = resolveAddress(item, address);
      var found = typeof value === 'string' ? !!value.match(new RegExp(pattern, uiTreeFilterSettings.regexFlags)) : false;
      return found || visit(item[uiTreeFilterSettings.descendantCollection], pattern, address);
    }

    /**
     * Checks if pattern matches any of addresses
     *
     * @param {object} item
     * @param {string} pattern
     *
     * @returns {boolean}
     */
    return function (item, pattern, addresses) {
      addresses = addresses || uiTreeFilterSettings.addresses;
      return pattern === undefined || addresses.reduce(function (foundSoFar, fieldName) {
        return foundSoFar || testForField(item, pattern, fieldName);
      }, false);
    };
  }]);
})(angular);
!function (a, b) {
  "use strict";

  b.module("ui.sortable", []).value("uiSortableConfig", {}).directive("uiSortable", ["uiSortableConfig", "$timeout", "$log", function (a, c, d) {
    return {
      require: "?ngModel",
      link: function (e, f, g, h) {
        function i(a, b) {
          return b && "function" == typeof b ? function (c, d) {
            a(c, d), b(c, d);
          } : a;
        }
        function j(a, b) {
          var c = a.sortable("option", "helper");
          return "clone" === c || "function" == typeof c && b.item.sortable.isCustomHelperUsed();
        }
        var k,
          l = {},
          m = {
            receive: null,
            remove: null,
            start: null,
            stop: null,
            update: null
          },
          n = {
            helper: null
          };
        return b.extend(l, a, e.$eval(g.uiSortable)), b.element.fn && b.element.fn.jquery ? (h ? (e.$watch(g.ngModel + ".length", function () {
          c(function () {
            f.data("ui-sortable") && f.sortable("refresh");
          });
        }), m.start = function (a, b) {
          b.item.sortable = {
            index: b.item.index(),
            cancel: function () {
              b.item.sortable._isCanceled = !0;
            },
            isCanceled: function () {
              return b.item.sortable._isCanceled;
            },
            isCustomHelperUsed: function () {
              return !!b.item.sortable._isCustomHelperUsed;
            },
            _isCanceled: !1,
            _isCustomHelperUsed: b.item.sortable._isCustomHelperUsed
          };
        }, m.activate = function () {
          k = f.contents();
          var a = f.sortable("option", "placeholder");
          if (a && a.element && "function" == typeof a.element) {
            var c = a.element();
            c = b.element(c);
            var d = f.find('[class="' + c.attr("class") + '"]');
            k = k.not(d);
          }
        }, m.update = function (a, b) {
          b.item.sortable.received || (b.item.sortable.dropindex = b.item.index(), b.item.sortable.droptarget = b.item.parent(), f.sortable("cancel")), j(f, b) && !b.item.sortable.received && "parent" === f.sortable("option", "appendTo") && (k = k.not(k.last())), k.appendTo(f), b.item.sortable.received && (k = null), b.item.sortable.received && !b.item.sortable.isCanceled() && e.$apply(function () {
            h.$modelValue.splice(b.item.sortable.dropindex, 0, b.item.sortable.moved);
          });
        }, m.stop = function (a, b) {
          !b.item.sortable.received && "dropindex" in b.item.sortable && !b.item.sortable.isCanceled() ? e.$apply(function () {
            h.$modelValue.splice(b.item.sortable.dropindex, 0, h.$modelValue.splice(b.item.sortable.index, 1)[0]);
          }) : "dropindex" in b.item.sortable && !b.item.sortable.isCanceled() || j(f, b) || k.appendTo(f), k = null;
        }, m.receive = function (a, b) {
          b.item.sortable.received = !0;
        }, m.remove = function (a, b) {
          "dropindex" in b.item.sortable || (f.sortable("cancel"), b.item.sortable.cancel()), b.item.sortable.isCanceled() || e.$apply(function () {
            b.item.sortable.moved = h.$modelValue.splice(b.item.sortable.index, 1)[0];
          });
        }, n.helper = function (a) {
          return a && "function" == typeof a ? function (b, c) {
            var d = a(b, c);
            return c.sortable._isCustomHelperUsed = c !== d, d;
          } : a;
        }, e.$watch(g.uiSortable, function (a) {
          f.data("ui-sortable") && b.forEach(a, function (a, b) {
            m[b] ? ("stop" === b && (a = i(a, function () {
              e.$apply();
            })), a = i(m[b], a)) : n[b] && (a = n[b](a)), f.sortable("option", b, a);
          });
        }, !0), b.forEach(m, function (a, b) {
          l[b] = i(a, l[b]);
        })) : d.info("ui.sortable: ngModel not provided!", f), void f.sortable(l)) : void d.error("ui.sortable: jQuery should be included before AngularJS!");
      }
    };
  }]);
}(window, window.angular);
(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.angularDragula = f();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }
        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  }({
    1: [function (require, module, exports) {
      'use strict';

      var dragulaService = require('./service');
      var dragulaDirective = require('./directive');
      function register(angular) {
        var app = angular.module('dragula', ['ng']);
        app.factory('dragulaService', dragulaService(angular));
        app.directive('dragula', dragulaDirective(angular));
        return 'dragula';
      }
      module.exports = register;
    }, {
      "./directive": 2,
      "./service": 13
    }],
    2: [function (require, module, exports) {
      'use strict';

      var dragula = require('dragula');

      /*jshint unused: false*/
      function register(angular) {
        return ['dragulaService', function angularDragula(dragulaService) {
          return {
            restrict: 'A',
            scope: {
              dragulaScope: '=',
              dragulaModel: '='
            },
            link: link
          };
          function link(scope, elem, attrs) {
            var dragulaScope = scope.dragulaScope || scope.$parent;
            var container = elem[0];
            var name = scope.$eval(attrs.dragula);
            var drake;
            var bag = dragulaService.find(dragulaScope, name);
            if (bag) {
              drake = bag.drake;
              drake.containers.push(container);
            } else {
              drake = dragula({
                containers: [container]
              });
              dragulaService.add(dragulaScope, name, drake);
            }
            scope.$watch('dragulaModel', function (newValue, oldValue) {
              if (!newValue) {
                return;
              }
              if (drake.models) {
                var modelIndex = oldValue ? drake.models.indexOf(oldValue) : -1;
                if (modelIndex >= 0) {
                  drake.models.splice(modelIndex, 1, newValue);
                } else {
                  drake.models.push(newValue);
                }
              } else {
                drake.models = [newValue];
              }
              dragulaService.handleModels(dragulaScope, drake);
            });
          }
        }];
      }
      module.exports = register;
    }, {
      "dragula": 10
    }],
    3: [function (require, module, exports) {
      module.exports = function atoa(a, n) {
        return Array.prototype.slice.call(a, n);
      };
    }, {}],
    4: [function (require, module, exports) {
      'use strict';

      var ticky = require('ticky');
      module.exports = function debounce(fn, args, ctx) {
        if (!fn) {
          return;
        }
        ticky(function run() {
          fn.apply(ctx || null, args || []);
        });
      };
    }, {
      "ticky": 11
    }],
    5: [function (require, module, exports) {
      'use strict';

      var atoa = require('atoa');
      var debounce = require('./debounce');
      module.exports = function emitter(thing, options) {
        var opts = options || {};
        var evt = {};
        if (thing === undefined) {
          thing = {};
        }
        thing.on = function (type, fn) {
          if (!evt[type]) {
            evt[type] = [fn];
          } else {
            evt[type].push(fn);
          }
          return thing;
        };
        thing.once = function (type, fn) {
          fn._once = true; // thing.off(fn) still works!
          thing.on(type, fn);
          return thing;
        };
        thing.off = function (type, fn) {
          var c = arguments.length;
          if (c === 1) {
            delete evt[type];
          } else if (c === 0) {
            evt = {};
          } else {
            var et = evt[type];
            if (!et) {
              return thing;
            }
            et.splice(et.indexOf(fn), 1);
          }
          return thing;
        };
        thing.emit = function () {
          var args = atoa(arguments);
          return thing.emitterSnapshot(args.shift()).apply(this, args);
        };
        thing.emitterSnapshot = function (type) {
          var et = (evt[type] || []).slice(0);
          return function () {
            var args = atoa(arguments);
            var ctx = this || thing;
            if (type === 'error' && opts.throws !== false && !et.length) {
              throw args.length === 1 ? args[0] : args;
            }
            et.forEach(function emitter(listen) {
              if (opts.async) {
                debounce(listen, args, ctx);
              } else {
                listen.apply(ctx, args);
              }
              if (listen._once) {
                thing.off(type, listen);
              }
            });
            return thing;
          };
        };
        return thing;
      };
    }, {
      "./debounce": 4,
      "atoa": 3
    }],
    6: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var customEvent = require('custom-event');
        var eventmap = require('./eventmap');
        var doc = global.document;
        var addEvent = addEventEasy;
        var removeEvent = removeEventEasy;
        var hardCache = [];
        if (!global.addEventListener) {
          addEvent = addEventHard;
          removeEvent = removeEventHard;
        }
        module.exports = {
          add: addEvent,
          remove: removeEvent,
          fabricate: fabricateEvent
        };
        function addEventEasy(el, type, fn, capturing) {
          return el.addEventListener(type, fn, capturing);
        }
        function addEventHard(el, type, fn) {
          return el.attachEvent('on' + type, wrap(el, type, fn));
        }
        function removeEventEasy(el, type, fn, capturing) {
          return el.removeEventListener(type, fn, capturing);
        }
        function removeEventHard(el, type, fn) {
          var listener = unwrap(el, type, fn);
          if (listener) {
            return el.detachEvent('on' + type, listener);
          }
        }
        function fabricateEvent(el, type, model) {
          var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
          if (el.dispatchEvent) {
            el.dispatchEvent(e);
          } else {
            el.fireEvent('on' + type, e);
          }
          function makeClassicEvent() {
            var e;
            if (doc.createEvent) {
              e = doc.createEvent('Event');
              e.initEvent(type, true, true);
            } else if (doc.createEventObject) {
              e = doc.createEventObject();
            }
            return e;
          }
          function makeCustomEvent() {
            return new customEvent(type, {
              detail: model
            });
          }
        }
        function wrapperFactory(el, type, fn) {
          return function wrapper(originalEvent) {
            var e = originalEvent || global.event;
            e.target = e.target || e.srcElement;
            e.preventDefault = e.preventDefault || function preventDefault() {
              e.returnValue = false;
            };
            e.stopPropagation = e.stopPropagation || function stopPropagation() {
              e.cancelBubble = true;
            };
            e.which = e.which || e.keyCode;
            fn.call(el, e);
          };
        }
        function wrap(el, type, fn) {
          var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
          hardCache.push({
            wrapper: wrapper,
            element: el,
            type: type,
            fn: fn
          });
          return wrapper;
        }
        function unwrap(el, type, fn) {
          var i = find(el, type, fn);
          if (i) {
            var wrapper = hardCache[i].wrapper;
            hardCache.splice(i, 1); // free up a tad of memory
            return wrapper;
          }
        }
        function find(el, type, fn) {
          var i, item;
          for (i = 0; i < hardCache.length; i++) {
            item = hardCache[i];
            if (item.element === el && item.type === type && item.fn === fn) {
              return i;
            }
          }
        }
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {
      "./eventmap": 7,
      "custom-event": 8
    }],
    7: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var eventmap = [];
        var eventname = '';
        var ron = /^on/;
        for (eventname in global) {
          if (ron.test(eventname)) {
            eventmap.push(eventname.slice(2));
          }
        }
        module.exports = eventmap;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}],
    8: [function (require, module, exports) {
      (function (global) {
        var NativeCustomEvent = global.CustomEvent;
        function useNative() {
          try {
            var p = new NativeCustomEvent('cat', {
              detail: {
                foo: 'bar'
              }
            });
            return 'cat' === p.type && 'bar' === p.detail.foo;
          } catch (e) {}
          return false;
        }

        /**
         * Cross-browser `CustomEvent` constructor.
         *
         * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
         *
         * @public
         */

        module.exports = useNative() ? NativeCustomEvent :
        // IE >= 9
        'function' === typeof document.createEvent ? function CustomEvent(type, params) {
          var e = document.createEvent('CustomEvent');
          if (params) {
            e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
          } else {
            e.initCustomEvent(type, false, false, void 0);
          }
          return e;
        } :
        // IE <= 8
        function CustomEvent(type, params) {
          var e = document.createEventObject();
          e.type = type;
          if (params) {
            e.bubbles = Boolean(params.bubbles);
            e.cancelable = Boolean(params.cancelable);
            e.detail = params.detail;
          } else {
            e.bubbles = false;
            e.cancelable = false;
            e.detail = void 0;
          }
          return e;
        };
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}],
    9: [function (require, module, exports) {
      'use strict';

      var cache = {};
      var start = '(?:^|\\s)';
      var end = '(?:\\s|$)';
      function lookupClass(className) {
        var cached = cache[className];
        if (cached) {
          cached.lastIndex = 0;
        } else {
          cache[className] = cached = new RegExp(start + className + end, 'g');
        }
        return cached;
      }
      function addClass(el, className) {
        var current = el.className;
        if (!current.length) {
          el.className = className;
        } else if (!lookupClass(className).test(current)) {
          el.className += ' ' + className;
        }
      }
      function rmClass(el, className) {
        el.className = el.className.replace(lookupClass(className), ' ').trim();
      }
      module.exports = {
        add: addClass,
        rm: rmClass
      };
    }, {}],
    10: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var emitter = require('contra/emitter');
        var crossvent = require('crossvent');
        var classes = require('./classes');
        var doc = document;
        var documentElement = doc.documentElement;
        function dragula(initialContainers, options) {
          var len = arguments.length;
          if (len === 1 && Array.isArray(initialContainers) === false) {
            options = initialContainers;
            initialContainers = [];
          }
          var _mirror; // mirror image
          var _source; // source container
          var _item; // item being dragged
          var _offsetX; // reference x
          var _offsetY; // reference y
          var _moveX; // reference move x
          var _moveY; // reference move y
          var _initialSibling; // reference sibling when grabbed
          var _currentSibling; // reference sibling now
          var _copy; // item used for copying
          var _renderTimer; // timer for setTimeout renderMirrorImage
          var _lastDropTarget = null; // last container item was over
          var _grabbed; // holds mousedown context until first mousemove

          var o = options || {};
          if (o.moves === void 0) {
            o.moves = always;
          }
          if (o.accepts === void 0) {
            o.accepts = always;
          }
          if (o.invalid === void 0) {
            o.invalid = invalidTarget;
          }
          if (o.containers === void 0) {
            o.containers = initialContainers || [];
          }
          if (o.isContainer === void 0) {
            o.isContainer = never;
          }
          if (o.copy === void 0) {
            o.copy = false;
          }
          if (o.copySortSource === void 0) {
            o.copySortSource = false;
          }
          if (o.revertOnSpill === void 0) {
            o.revertOnSpill = false;
          }
          if (o.removeOnSpill === void 0) {
            o.removeOnSpill = false;
          }
          if (o.direction === void 0) {
            o.direction = 'vertical';
          }
          if (o.ignoreInputTextSelection === void 0) {
            o.ignoreInputTextSelection = true;
          }
          if (o.mirrorContainer === void 0) {
            o.mirrorContainer = doc.body;
          }
          var drake = emitter({
            containers: o.containers,
            start: manualStart,
            end: end,
            cancel: cancel,
            remove: remove,
            destroy: destroy,
            canMove: canMove,
            dragging: false
          });
          if (o.removeOnSpill === true) {
            drake.on('over', spillOver).on('out', spillOut);
          }
          events();
          return drake;
          function isContainer(el) {
            return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
          }
          function events(remove) {
            var op = remove ? 'remove' : 'add';
            touchy(documentElement, op, 'mousedown', grab);
            touchy(documentElement, op, 'mouseup', release);
          }
          function eventualMovements(remove) {
            var op = remove ? 'remove' : 'add';
            touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
          }
          function movements(remove) {
            var op = remove ? 'remove' : 'add';
            crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
            crossvent[op](documentElement, 'click', preventGrabbed);
          }
          function destroy() {
            events(true);
            release({});
          }
          function preventGrabbed(e) {
            if (_grabbed) {
              e.preventDefault();
            }
          }
          function grab(e) {
            _moveX = e.clientX;
            _moveY = e.clientY;
            var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
            if (ignore) {
              return; // we only care about honest-to-god left clicks and touch events
            }

            var item = e.target;
            var context = canStart(item);
            if (!context) {
              return;
            }
            _grabbed = context;
            eventualMovements();
            if (e.type === 'mousedown') {
              if (isInput(item)) {
                // see also: https://github.com/bevacqua/dragula/issues/208
                item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
              } else {
                e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
              }
            }
          }

          function startBecauseMouseMoved(e) {
            if (!_grabbed) {
              return;
            }
            if (whichMouseButton(e) === 0) {
              release({});
              return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
            }
            // truthy check fixes #239, equality fixes #207
            if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
              return;
            }
            if (o.ignoreInputTextSelection) {
              var clientX = getCoord('clientX', e);
              var clientY = getCoord('clientY', e);
              var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
              if (isInput(elementBehindCursor)) {
                return;
              }
            }
            var grabbed = _grabbed; // call to end() unsets _grabbed
            eventualMovements(true);
            movements();
            end();
            start(grabbed);
            var offset = getOffset(_item);
            _offsetX = getCoord('pageX', e) - offset.left;
            _offsetY = getCoord('pageY', e) - offset.top;
            classes.add(_copy || _item, 'gu-transit');
            renderMirrorImage();
            drag(e);
          }
          function canStart(item) {
            if (drake.dragging && _mirror) {
              return;
            }
            if (isContainer(item)) {
              return; // don't drag container itself
            }

            var handle = item;
            while (getParent(item) && isContainer(getParent(item)) === false) {
              if (o.invalid(item, handle)) {
                return;
              }
              item = getParent(item); // drag target should be a top element
              if (!item) {
                return;
              }
            }
            var source = getParent(item);
            if (!source) {
              return;
            }
            if (o.invalid(item, handle)) {
              return;
            }
            var movable = o.moves(item, source, handle, nextEl(item));
            if (!movable) {
              return;
            }
            return {
              item: item,
              source: source
            };
          }
          function canMove(item) {
            return !!canStart(item);
          }
          function manualStart(item) {
            var context = canStart(item);
            if (context) {
              start(context);
            }
          }
          function start(context) {
            if (isCopy(context.item, context.source)) {
              _copy = context.item.cloneNode(true);
              drake.emit('cloned', _copy, context.item, 'copy');
            }
            _source = context.source;
            _item = context.item;
            _initialSibling = _currentSibling = nextEl(context.item);
            drake.dragging = true;
            drake.emit('drag', _item, _source);
          }
          function invalidTarget() {
            return false;
          }
          function end() {
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            drop(item, getParent(item));
          }
          function ungrab() {
            _grabbed = false;
            eventualMovements(true);
            movements(true);
          }
          function release(e) {
            ungrab();
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            var clientX = getCoord('clientX', e);
            var clientY = getCoord('clientY', e);
            var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
            var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
            if (dropTarget && (_copy && o.copySortSource || !_copy || dropTarget !== _source)) {
              drop(item, dropTarget);
            } else if (o.removeOnSpill) {
              remove();
            } else {
              cancel();
            }
          }
          function drop(item, target) {
            var parent = getParent(item);
            if (_copy && o.copySortSource && target === _source) {
              parent.removeChild(_item);
            }
            if (isInitialPlacement(target)) {
              drake.emit('cancel', item, _source, _source);
            } else {
              drake.emit('drop', item, target, _source, _currentSibling);
            }
            cleanup();
          }
          function remove() {
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            var parent = getParent(item);
            if (parent) {
              parent.removeChild(item);
            }
            drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
            cleanup();
          }
          function cancel(revert) {
            if (!drake.dragging) {
              return;
            }
            var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
            var item = _copy || _item;
            var parent = getParent(item);
            var initial = isInitialPlacement(parent);
            if (initial === false && reverts) {
              if (_copy) {
                if (parent) {
                  parent.removeChild(_copy);
                }
              } else {
                _source.insertBefore(item, _initialSibling);
              }
            }
            if (initial || reverts) {
              drake.emit('cancel', item, _source, _source);
            } else {
              drake.emit('drop', item, parent, _source, _currentSibling);
            }
            cleanup();
          }
          function cleanup() {
            var item = _copy || _item;
            ungrab();
            removeMirrorImage();
            if (item) {
              classes.rm(item, 'gu-transit');
            }
            if (_renderTimer) {
              clearTimeout(_renderTimer);
            }
            drake.dragging = false;
            if (_lastDropTarget) {
              drake.emit('out', item, _lastDropTarget, _source);
            }
            drake.emit('dragend', item);
            _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
          }
          function isInitialPlacement(target, s) {
            var sibling;
            if (s !== void 0) {
              sibling = s;
            } else if (_mirror) {
              sibling = _currentSibling;
            } else {
              sibling = nextEl(_copy || _item);
            }
            return target === _source && sibling === _initialSibling;
          }
          function findDropTarget(elementBehindCursor, clientX, clientY) {
            var target = elementBehindCursor;
            while (target && !accepted()) {
              target = getParent(target);
            }
            return target;
            function accepted() {
              var droppable = isContainer(target);
              if (droppable === false) {
                return false;
              }
              var immediate = getImmediateChild(target, elementBehindCursor);
              var reference = getReference(target, immediate, clientX, clientY);
              var initial = isInitialPlacement(target, reference);
              if (initial) {
                return true; // should always be able to drop it right back where it was
              }

              return o.accepts(_item, target, _source, reference);
            }
          }
          function drag(e) {
            if (!_mirror) {
              return;
            }
            e.preventDefault();
            var clientX = getCoord('clientX', e);
            var clientY = getCoord('clientY', e);
            var x = clientX - _offsetX;
            var y = clientY - _offsetY;
            _mirror.style.left = x + 'px';
            _mirror.style.top = y + 'px';
            var item = _copy || _item;
            var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
            var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
            var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
            if (changed || dropTarget === null) {
              out();
              _lastDropTarget = dropTarget;
              over();
            }
            var parent = getParent(item);
            if (dropTarget === _source && _copy && !o.copySortSource) {
              if (parent) {
                parent.removeChild(item);
              }
              return;
            }
            var reference;
            var immediate = getImmediateChild(dropTarget, elementBehindCursor);
            if (immediate !== null) {
              reference = getReference(dropTarget, immediate, clientX, clientY);
            } else if (o.revertOnSpill === true && !_copy) {
              reference = _initialSibling;
              dropTarget = _source;
            } else {
              if (_copy && parent) {
                parent.removeChild(item);
              }
              return;
            }
            if (reference === null && changed || reference !== item && reference !== nextEl(item)) {
              _currentSibling = reference;
              dropTarget.insertBefore(item, reference);
              drake.emit('shadow', item, dropTarget, _source);
            }
            function moved(type) {
              drake.emit(type, item, _lastDropTarget, _source);
            }
            function over() {
              if (changed) {
                moved('over');
              }
            }
            function out() {
              if (_lastDropTarget) {
                moved('out');
              }
            }
          }
          function spillOver(el) {
            classes.rm(el, 'gu-hide');
          }
          function spillOut(el) {
            if (drake.dragging) {
              classes.add(el, 'gu-hide');
            }
          }
          function renderMirrorImage() {
            if (_mirror) {
              return;
            }
            var rect = _item.getBoundingClientRect();
            _mirror = _item.cloneNode(true);
            _mirror.style.width = getRectWidth(rect) + 'px';
            _mirror.style.height = getRectHeight(rect) + 'px';
            classes.rm(_mirror, 'gu-transit');
            classes.add(_mirror, 'gu-mirror');
            o.mirrorContainer.appendChild(_mirror);
            touchy(documentElement, 'add', 'mousemove', drag);
            classes.add(o.mirrorContainer, 'gu-unselectable');
            drake.emit('cloned', _mirror, _item, 'mirror');
          }
          function removeMirrorImage() {
            if (_mirror) {
              classes.rm(o.mirrorContainer, 'gu-unselectable');
              touchy(documentElement, 'remove', 'mousemove', drag);
              getParent(_mirror).removeChild(_mirror);
              _mirror = null;
            }
          }
          function getImmediateChild(dropTarget, target) {
            var immediate = target;
            while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
              immediate = getParent(immediate);
            }
            if (immediate === documentElement) {
              return null;
            }
            return immediate;
          }
          function getReference(dropTarget, target, x, y) {
            var horizontal = o.direction === 'horizontal';
            var reference = target !== dropTarget ? inside() : outside();
            return reference;
            function outside() {
              // slower, but able to figure out any position
              var len = dropTarget.children.length;
              var i;
              var el;
              var rect;
              for (i = 0; i < len; i++) {
                el = dropTarget.children[i];
                rect = el.getBoundingClientRect();
                if (horizontal && rect.left + rect.width / 2 > x) {
                  return el;
                }
                if (!horizontal && rect.top + rect.height / 2 > y) {
                  return el;
                }
              }
              return null;
            }
            function inside() {
              // faster, but only available if dropped inside a child element
              var rect = target.getBoundingClientRect();
              if (horizontal) {
                return resolve(x > rect.left + getRectWidth(rect) / 2);
              }
              return resolve(y > rect.top + getRectHeight(rect) / 2);
            }
            function resolve(after) {
              return after ? nextEl(target) : target;
            }
          }
          function isCopy(item, container) {
            return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
          }
        }
        function touchy(el, op, type, fn) {
          var touch = {
            mouseup: 'touchend',
            mousedown: 'touchstart',
            mousemove: 'touchmove'
          };
          var pointers = {
            mouseup: 'pointerup',
            mousedown: 'pointerdown',
            mousemove: 'pointermove'
          };
          var microsoft = {
            mouseup: 'MSPointerUp',
            mousedown: 'MSPointerDown',
            mousemove: 'MSPointerMove'
          };
          if (global.navigator.pointerEnabled) {
            crossvent[op](el, pointers[type], fn);
          } else if (global.navigator.msPointerEnabled) {
            crossvent[op](el, microsoft[type], fn);
          } else {
            crossvent[op](el, touch[type], fn);
            crossvent[op](el, type, fn);
          }
        }
        function whichMouseButton(e) {
          if (e.touches !== void 0) {
            return e.touches.length;
          }
          if (e.which !== void 0 && e.which !== 0) {
            return e.which;
          } // see https://github.com/bevacqua/dragula/issues/261
          if (e.buttons !== void 0) {
            return e.buttons;
          }
          var button = e.button;
          if (button !== void 0) {
            // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
            return button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
          }
        }
        function getOffset(el) {
          var rect = el.getBoundingClientRect();
          return {
            left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
            top: rect.top + getScroll('scrollTop', 'pageYOffset')
          };
        }
        function getScroll(scrollProp, offsetProp) {
          if (typeof global[offsetProp] !== 'undefined') {
            return global[offsetProp];
          }
          if (documentElement.clientHeight) {
            return documentElement[scrollProp];
          }
          return doc.body[scrollProp];
        }
        function getElementBehindPoint(point, x, y) {
          var p = point || {};
          var state = p.className;
          var el;
          p.className += ' gu-hide';
          el = doc.elementFromPoint(x, y);
          p.className = state;
          return el;
        }
        function never() {
          return false;
        }
        function always() {
          return true;
        }
        function getRectWidth(rect) {
          return rect.width || rect.right - rect.left;
        }
        function getRectHeight(rect) {
          return rect.height || rect.bottom - rect.top;
        }
        function getParent(el) {
          return el.parentNode === doc ? null : el.parentNode;
        }
        function isInput(el) {
          return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el);
        }
        function isEditable(el) {
          if (!el) {
            return false;
          } // no parents were editable
          if (el.contentEditable === 'false') {
            return false;
          } // stop the lookup
          if (el.contentEditable === 'true') {
            return true;
          } // found a contentEditable element in the chain
          return isEditable(getParent(el)); // contentEditable is set to 'inherit'
        }

        function nextEl(el) {
          return el.nextElementSibling || manually();
          function manually() {
            var sibling = el;
            do {
              sibling = sibling.nextSibling;
            } while (sibling && sibling.nodeType !== 1);
            return sibling;
          }
        }
        function getEventHost(e) {
          // on touchend event, we have to use `e.changedTouches`
          // see http://stackoverflow.com/questions/7192563/touchend-event-properties
          // see https://github.com/bevacqua/dragula/issues/34
          if (e.targetTouches && e.targetTouches.length) {
            return e.targetTouches[0];
          }
          if (e.changedTouches && e.changedTouches.length) {
            return e.changedTouches[0];
          }
          return e;
        }
        function getCoord(coord, e) {
          var host = getEventHost(e);
          var missMap = {
            pageX: 'clientX',
            // IE8
            pageY: 'clientY' // IE8
          };

          if (coord in missMap && !(coord in host) && missMap[coord] in host) {
            coord = missMap[coord];
          }
          return host[coord];
        }
        module.exports = dragula;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {
      "./classes": 9,
      "contra/emitter": 5,
      "crossvent": 6
    }],
    11: [function (require, module, exports) {
      var si = typeof setImmediate === 'function',
        tick;
      if (si) {
        tick = function (fn) {
          setImmediate(fn);
        };
      } else {
        tick = function (fn) {
          setTimeout(fn, 0);
        };
      }
      module.exports = tick;
    }, {}],
    12: [function (require, module, exports) {
      'use strict';

      var atoa = require('atoa');
      var events = ['cancel', 'cloned', 'drag', 'dragend', 'drop', 'out', 'over', 'remove', 'shadow', 'drop-model', 'remove-model'];
      function replicateEvents(angular, bag, scope) {
        events.forEach(replicator);
        function replicator(type) {
          bag.drake.on(type, replicate);
          function replicate() {
            var args = atoa(arguments).map(angularize);
            args.unshift(bag.name + '.' + type);
            scope.$emit.apply(scope, args);
          }
        }
        function angularize(value) {
          if (angular.isElement(value)) {
            return angular.element(value);
          }
          return value;
        }
      }
      module.exports = replicateEvents;
    }, {
      "atoa": 3
    }],
    13: [function (require, module, exports) {
      'use strict';

      var dragula = require('dragula');
      var dragulaKey = '$$dragula';
      var replicateEvents = require('./replicate-events');
      function register(angular) {
        return [function dragulaService() {
          return {
            add: add,
            find: find,
            options: setOptions,
            destroy: destroy,
            handleModels: handleModels
          };
          function handleModels(scope, drake) {
            if (drake.registered) {
              // do not register events twice
              return;
            }
            var dragElm;
            var dragIndex;
            var dropIndex;
            var sourceModel;
            drake.on('remove', function removeModel(el, source) {
              if (!drake.models) {
                return;
              }
              sourceModel = drake.models[drake.containers.indexOf(source)];
              scope.$applyAsync(function applyRemove() {
                sourceModel.splice(dragIndex, 1);
                drake.emit('remove-model', el, source);
              });
            });
            drake.on('drag', function dragModel(el, source) {
              dragElm = el;
              dragIndex = domIndexOf(el, source);
            });
            drake.on('drop', function dropModel(dropElm, target, source) {
              if (!drake.models) {
                return;
              }
              dropIndex = domIndexOf(dropElm, target);
              scope.$applyAsync(function applyDrop() {
                sourceModel = drake.models[drake.containers.indexOf(source)];
                if (target === source) {
                  sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
                } else {
                  var notCopy = dragElm === dropElm;
                  var targetModel = drake.models[drake.containers.indexOf(target)];
                  var dropElmModel = notCopy ? sourceModel[dragIndex] : angular.copy(sourceModel[dragIndex]);
                  if (notCopy) {
                    sourceModel.splice(dragIndex, 1);
                  }
                  targetModel.splice(dropIndex, 0, dropElmModel);
                  target.removeChild(dropElm); // element must be removed for ngRepeat to apply correctly
                }

                drake.emit('drop-model', dropElm, target, source);
              });
            });
            drake.registered = true;
          }
          function getOrCreateCtx(scope) {
            var ctx = scope[dragulaKey];
            if (!ctx) {
              ctx = scope[dragulaKey] = {
                bags: []
              };
            }
            return ctx;
          }
          function domIndexOf(child, parent) {
            return Array.prototype.indexOf.call(angular.element(parent).children(), child);
          }
          function add(scope, name, drake) {
            var bag = find(scope, name);
            if (bag) {
              throw new Error('Bag named: "' + name + '" already exists in same angular scope.');
            }
            var ctx = getOrCreateCtx(scope);
            bag = {
              name: name,
              drake: drake
            };
            ctx.bags.push(bag);
            replicateEvents(angular, bag, scope);
            if (drake.models) {
              // models to sync with (must have same structure as containers)
              handleModels(scope, drake);
            }
            return bag;
          }
          function find(scope, name) {
            var bags = getOrCreateCtx(scope).bags;
            for (var i = 0; i < bags.length; i++) {
              if (bags[i].name === name) {
                return bags[i];
              }
            }
          }
          function destroy(scope, name) {
            var bags = getOrCreateCtx(scope).bags;
            var bag = find(scope, name);
            var i = bags.indexOf(bag);
            bags.splice(i, 1);
            bag.drake.destroy();
          }
          function setOptions(scope, name, options) {
            var bag = add(scope, name, dragula(options));
            handleModels(scope, bag.drake);
          }
        }];
      }
      module.exports = register;
    }, {
      "./replicate-events": 12,
      "dragula": 10
    }]
  }, {}, [1])(1);
});
/*! ========================================================================
 * Bootstrap Toggle: bootstrap-toggle.js v2.2.0
 * http://www.bootstraptoggle.com
 * ========================================================================
 * Copyright 2014 Min Hur, The New York Times Company
 * Licensed under MIT
 * ======================================================================== */
+function (a) {
  "use strict";

  function b(b) {
    return this.each(function () {
      var d = a(this),
        e = d.data("bs.toggle"),
        f = "object" == typeof b && b;
      e || d.data("bs.toggle", e = new c(this, f)), "string" == typeof b && e[b] && e[b]();
    });
  }
  var c = function (b, c) {
    this.$element = a(b), this.options = a.extend({}, this.defaults(), c), this.render();
  };
  c.VERSION = "2.2.0", c.DEFAULTS = {
    on: "On",
    off: "Off",
    onstyle: "primary",
    offstyle: "default",
    size: "normal",
    style: "",
    width: null,
    height: null
  }, c.prototype.defaults = function () {
    return {
      on: this.$element.attr("data-on") || c.DEFAULTS.on,
      off: this.$element.attr("data-off") || c.DEFAULTS.off,
      onstyle: this.$element.attr("data-onstyle") || c.DEFAULTS.onstyle,
      offstyle: this.$element.attr("data-offstyle") || c.DEFAULTS.offstyle,
      size: this.$element.attr("data-size") || c.DEFAULTS.size,
      style: this.$element.attr("data-style") || c.DEFAULTS.style,
      width: this.$element.attr("data-width") || c.DEFAULTS.width,
      height: this.$element.attr("data-height") || c.DEFAULTS.height
    };
  }, c.prototype.render = function () {
    this._onstyle = "btn-" + this.options.onstyle, this._offstyle = "btn-" + this.options.offstyle;
    var b = "large" === this.options.size ? "btn-lg" : "small" === this.options.size ? "btn-sm" : "mini" === this.options.size ? "btn-xs" : "",
      c = a('<label class="btn">').html(this.options.on).addClass(this._onstyle + " " + b),
      d = a('<label class="btn">').html(this.options.off).addClass(this._offstyle + " " + b + " active"),
      e = a('<span class="toggle-handle btn btn-default">').addClass(b),
      f = a('<div class="toggle-group">').append(c, d, e),
      g = a('<div class="toggle btn" data-toggle="toggle">').addClass(this.$element.prop("checked") ? this._onstyle : this._offstyle + " off").addClass(b).addClass(this.options.style);
    this.$element.wrap(g), a.extend(this, {
      $toggle: this.$element.parent(),
      $toggleOn: c,
      $toggleOff: d,
      $toggleGroup: f
    }), this.$toggle.append(f);
    var h = this.options.width || Math.max(c.outerWidth(), d.outerWidth()) + e.outerWidth() / 2,
      i = this.options.height || Math.max(c.outerHeight(), d.outerHeight());
    c.addClass("toggle-on"), d.addClass("toggle-off"), this.$toggle.css({
      width: h,
      height: i
    }), this.options.height && (c.css("line-height", c.height() + "px"), d.css("line-height", d.height() + "px")), this.update(!0), this.trigger(!0);
  }, c.prototype.toggle = function () {
    this.$element.prop("checked") ? this.off() : this.on();
  }, c.prototype.on = function (a) {
    return this.$element.prop("disabled") ? !1 : (this.$toggle.removeClass(this._offstyle + " off").addClass(this._onstyle), this.$element.prop("checked", !0), void (a || this.trigger()));
  }, c.prototype.off = function (a) {
    return this.$element.prop("disabled") ? !1 : (this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + " off"), this.$element.prop("checked", !1), void (a || this.trigger()));
  }, c.prototype.enable = function () {
    this.$toggle.removeAttr("disabled"), this.$element.prop("disabled", !1);
  }, c.prototype.disable = function () {
    this.$toggle.attr("disabled", "disabled"), this.$element.prop("disabled", !0);
  }, c.prototype.update = function (a) {
    this.$element.prop("disabled") ? this.disable() : this.enable(), this.$element.prop("checked") ? this.on(a) : this.off(a);
  }, c.prototype.trigger = function (b) {
    this.$element.off("change.bs.toggle"), b || this.$element.change(), this.$element.on("change.bs.toggle", a.proxy(function () {
      this.update();
    }, this));
  }, c.prototype.destroy = function () {
    this.$element.off("change.bs.toggle"), this.$toggleGroup.remove(), this.$element.removeData("bs.toggle"), this.$element.unwrap();
  };
  var d = a.fn.bootstrapToggle;
  a.fn.bootstrapToggle = b, a.fn.bootstrapToggle.Constructor = c, a.fn.toggle.noConflict = function () {
    return a.fn.bootstrapToggle = d, this;
  }, a(function () {
    a("input[type=checkbox][data-toggle^=toggle]").bootstrapToggle();
  }), a(document).on("click.bs.toggle", "div[data-toggle^=toggle]", function (b) {
    var c = a(this).find("input[type=checkbox]");
    c.bootstrapToggle("toggle"), b.preventDefault();
  });
}(jQuery);
// https://github.com/Gillardo/bootstrap-ui-datetime-picker
// Version: 1.1.7
// Released: 2015-08-22 
angular.module("ui.bootstrap.datetimepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.position"]).constant("uiDatetimePickerConfig", {
  dateFormat: "yyyy-MM-dd HH:mm",
  enableDate: !0,
  enableTime: !0,
  todayText: "Today",
  nowText: "Now",
  clearText: "Clear",
  closeText: "Done",
  dateText: "Date",
  timeText: "Time",
  closeOnDateSelection: !0,
  appendToBody: !1,
  showButtonBar: !0
}).directive("datetimePicker", ["$compile", "$parse", "$document", "$timeout", "$position", "dateFilter", "dateParser", "uiDatetimePickerConfig", function (a, b, c, d, e, f, g, h) {
  return {
    restrict: "A",
    require: "ngModel",
    scope: {
      isOpen: "=?",
      enableDate: "=?",
      enableTime: "=?",
      todayText: "@",
      nowText: "@",
      dateText: "@",
      timeText: "@",
      clearText: "@",
      closeText: "@",
      dateDisabled: "&"
    },
    link: function (i, j, k, l) {
      function m(a) {
        return a.replace(/([A-Z])/g, function (a) {
          return "-" + a.toLowerCase();
        });
      }
      function n(a) {
        return k.dateDisabled && angular.isDefined(a) && i.dateDisabled({
          date: a,
          mode: i.watchData.datepickerMode
        });
      }
      function o(a) {
        if (a) {
          if (angular.isDate(a) && !isNaN(a)) return l.$setValidity("date", !0), a;
          if (angular.isString(a)) {
            var b = g.parse(a, q) || new Date(a);
            return isNaN(b) ? void l.$setValidity("date", !1) : (l.$setValidity("date", !0), b);
          }
          return void l.$setValidity("date", !1);
        }
        return l.$setValidity("date", !0), null;
      }
      var p,
        q = h.dateFormat,
        r = angular.isDefined(k.closeOnDateSelection) ? i.$parent.$eval(k.closeOnDateSelection) : h.closeOnDateSelection,
        s = angular.isDefined(k.datepickerAppendToBody) ? i.$parent.$eval(k.datepickerAppendToBody) : h.appendToBody;
      i.showButtonBar = angular.isDefined(k.showButtonBar) ? i.$parent.$eval(k.showButtonBar) : h.showButtonBar, i.enableDate = angular.isDefined(i.enableDate) ? i.enableDate : h.enableDate, i.enableTime = angular.isDefined(i.enableTime) ? i.enableTime : h.enableTime, i.showPicker = i.enableDate ? "date" : "time", i.getText = function (a) {
        return i[a + "Text"] || h[a + "Text"];
      }, k.$observe("datetimePicker", function (a) {
        q = a || h.dateFormat, l.$render();
      });
      var t = angular.element('<div date-picker-wrap ng-show="showPicker == \'date\'"><div datepicker></div></div><div time-picker-wrap ng-show="showPicker == \'time\'"><div timepicker style="margin:0 auto"></div></div>');
      t.attr({
        "ng-model": "date",
        "ng-change": "dateSelection(date)"
      });
      var u = angular.element(t.children()[0]);
      k.datepickerOptions && angular.forEach(i.$parent.$eval(k.datepickerOptions), function (a, b) {
        u.attr(m(b), a);
      });
      var v = angular.element(t.children()[1]);
      k.timepickerOptions && angular.forEach(i.$parent.$eval(k.timepickerOptions), function (a, b) {
        v.attr(m(b), a);
      }), angular.isDefined(k.datepickerMode) || (k.datepickerMode = "day"), i.watchData = {}, angular.forEach(["minDate", "maxDate", "datepickerMode"], function (a) {
        if (k[a]) {
          var c = b(k[a]);
          if (i.$parent.$watch(c, function (b) {
            i.watchData[a] = b;
          }), u.attr(m(a), "watchData." + a), "datepickerMode" === a) {
            var d = c.assign;
            i.$watch("watchData." + a, function (a, b) {
              angular.isFunction(d) && a !== b && d(i.$parent, a);
            });
          }
        }
      }), k.dateDisabled && u.attr("date-disabled", "dateDisabled({ date: date, mode: mode })"), l.$parsers.unshift(o), i.dateSelection = function (a) {
        i.enableDate && i.enableTime && "time" === i.showPicker && p && null !== p && (null !== i.date || a || null != a) && (a && null != a ? (p.setHours(a.getHours()), p.setMinutes(a.getMinutes()), p.setSeconds(a.getSeconds()), p.setMilliseconds(a.getMilliseconds()), a = new Date(p)) : (p.setHours(i.date.getHours()), p.setMinutes(i.date.getMinutes()), p.setSeconds(i.date.getSeconds()), p.setMilliseconds(i.date.getMilliseconds()))), angular.isDefined(a) && (i.date = a), p = i.date, l.$setViewValue(i.date), l.$render(), null === a ? i.close() : r && "time" != i.showPicker && (i.enableTime ? i.showPicker = "time" : i.close());
      }, j.bind("input change keyup", function () {
        i.$apply(function () {
          i.date = l.$modelValue;
        });
      }), l.$render = function () {
        var a = l.$viewValue ? o(l.$viewValue) : null,
          b = a ? f(a, q) : "";
        j.val(b), i.date = a;
      };
      var w = function (a) {
          i.isOpen && a.target !== j[0] && i.$apply(function () {
            i.isOpen = !1;
          });
        },
        x = function (a) {
          i.keydown(a);
        };
      j.bind("keydown", x), i.keydown = function (a) {
        27 === a.which ? (a.preventDefault(), i.isOpen && a.stopPropagation(), i.close()) : 40 !== a.which || i.isOpen || (i.isOpen = !0);
      };
      var y = i.$watch("isOpen", function (a) {
        if (i.dropdownStyle = {
          display: a ? "block" : "none"
        }, a) {
          var b = s ? e.offset(j) : e.position(j);
          i.dropdownStyle.top = s ? b.top + j.prop("offsetHeight") + "px" : void 0, i.dropdownStyle.left = b.left + "px", d(function () {
            i.$broadcast("datepicker.focus"), c.bind("click", w);
          }, 0, !1);
        } else c.unbind("click", w);
      });
      i.isTodayDisabled = function () {
        return n(new Date());
      }, i.select = function (a) {
        if ("today" === a || "now" == a) {
          var b = new Date();
          angular.isDate(l.$modelValue) ? (a = new Date(l.$modelValue), a.setFullYear(b.getFullYear(), b.getMonth(), b.getDate()), a.setHours(b.getHours(), b.getMinutes(), b.getSeconds(), b.getMilliseconds())) : a = b;
        }
        i.dateSelection(a);
      }, i.close = function () {
        i.isOpen = !1, j[0].focus();
      }, i.changePicker = function (a, b) {
        a.preventDefault(), a.stopPropagation(), i.showPicker = b;
      };
      var z = a(t)(i);
      t.remove(), s ? c.find("body").append(z) : j.after(z), i.$on("$destroy", function () {
        i.isOpen === !0 && i.$apply(function () {
          i.isOpen = !1;
        }), y(), z.remove(), j.unbind("keydown", x), c.unbind("click", w);
      });
    }
  };
}]).directive("datePickerWrap", function () {
  return {
    restrict: "EA",
    replace: !0,
    transclude: !0,
    templateUrl: "template/datetime-picker.html",
    link: function (a, b) {
      b.bind("click", function (a) {
        a.preventDefault(), a.stopPropagation();
      });
    }
  };
}).directive("timePickerWrap", function () {
  return {
    restrict: "EA",
    replace: !0,
    transclude: !0,
    templateUrl: "template/datetime-picker.html",
    link: function (a, b) {
      b.bind("click", function (a) {
        a.preventDefault(), a.stopPropagation();
      });
    }
  };
}), angular.module("ui.bootstrap.datetimepicker").run(["$templateCache", function (a) {
  "use strict";

  a.put("template/datetime-picker.html", '<ul class="dropdown-menu dropdown-menu-left datetime-picker-dropdown" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event)><li style="padding:0 5px 5px 5px" ng-class="{\'date-picker-menu\': showPicker == \'date\', \'time-picker-menu\' : showPicker == \'time\'}"><div ng-transclude></div></li><li ng-if=showButtonBar style=padding:5px><span class="btn-group pull-left" style=margin-right:10px><button ng-if="showPicker == \'date\'" type=button class="btn btn-sm btn-info" ng-click="select(\'today\')" ng-disabled=isTodayDisabled()>{{ getText(\'today\') }}</button> <button ng-if="showPicker == \'time\'" type=button class="btn btn-sm btn-info" ng-click="select(\'now\')" ng-disabled=isTodayDisabled()>{{ getText(\'now\') }}</button> <button type=button class="btn btn-sm btn-danger" ng-click=select(null)>{{ getText(\'clear\') }}</button></span> <span class="btn-group pull-right"><button ng-if="showPicker == \'date\' && enableTime" type=button class="btn btn-sm btn-default" ng-click="changePicker($event, \'time\')">{{ getText(\'time\')}}</button> <button ng-if="showPicker == \'time\' && enableDate" type=button class="btn btn-sm btn-default" ng-click="changePicker($event, \'date\')">{{ getText(\'date\')}}</button> <button type=button class="btn btn-sm btn-success" ng-click=close()>{{ getText(\'close\') }}</button></span></li></ul>');
}]);
/**
 * @license Angulartics v0.17.2
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * Universal Analytics update contributed by http://github.com/willmcclellan
 * License: MIT
 */
!function (a) {
  "use strict";

  a.module("angulartics.google.analytics", ["angulartics"]).config(["$analyticsProvider", function (b) {
    b.settings.trackRelativePath = !0, b.settings.ga = {
      additionalAccountNames: void 0
    }, b.registerPageTrack(function (c) {
      window._gaq && _gaq.push(["_trackPageview", c]), window.ga && (ga("send", "pageview", c), a.forEach(b.settings.ga.additionalAccountNames, function (a) {
        ga(a + ".send", "pageview", c);
      }));
    }), b.registerEventTrack(function (c, d) {
      if (d && d.category) {
        if (d.value) {
          var e = parseInt(d.value, 10);
          d.value = isNaN(e) ? 0 : e;
        }
        if (window.ga) {
          for (var f = {
              eventCategory: d.category || null,
              eventAction: c || null,
              eventLabel: d.label || null,
              eventValue: d.value || null,
              nonInteraction: d.noninteraction || null
            }, g = 1; 20 >= g; g++) d["dimension" + g.toString()] && (f["dimension" + g.toString()] = d["dimension" + g.toString()]), d["metric" + g.toString()] && (f["metric" + g.toString()] = d["metric" + g.toString()]);
          ga("send", "event", f), a.forEach(b.settings.ga.additionalAccountNames, function (a) {
            ga(a + ".send", "event", f);
          });
        } else window._gaq && _gaq.push(["_trackEvent", d.category, c, d.label, d.value, d.noninteraction]);
      }
    });
  }]);
}(angular);
/**
 * @license Angulartics v0.17.2
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * License: MIT
 */
!function (a) {
  "use strict";

  var b = window.angulartics || (window.angulartics = {});
  b.waitForVendorCount = 0, b.waitForVendorApi = function (a, c, d, e, f) {
    f || b.waitForVendorCount++, e || (e = d, d = void 0), !Object.prototype.hasOwnProperty.call(window, a) || void 0 !== d && void 0 === window[a][d] ? setTimeout(function () {
      b.waitForVendorApi(a, c, d, e, !0);
    }, c) : (b.waitForVendorCount--, e(window[a]));
  }, a.module("angulartics", []).provider("$analytics", function () {
    var c = {
        pageTracking: {
          autoTrackFirstPage: !0,
          autoTrackVirtualPages: !0,
          trackRelativePath: !1,
          autoBasePath: !1,
          basePath: ""
        },
        eventTracking: {},
        bufferFlushDelay: 1e3,
        developerMode: !1
      },
      d = ["pageTrack", "eventTrack", "setAlias", "setUsername", "setAlias", "setUserProperties", "setUserPropertiesOnce", "setSuperProperties", "setSuperPropertiesOnce"],
      e = {},
      f = {},
      g = function (a) {
        return function () {
          b.waitForVendorCount && (e[a] || (e[a] = []), e[a].push(arguments));
        };
      },
      h = function (b, c) {
        return f[b] || (f[b] = []), f[b].push(c), function () {
          var c = arguments;
          a.forEach(f[b], function (a) {
            a.apply(this, c);
          }, this);
        };
      },
      i = {
        settings: c
      },
      j = function (a, b) {
        b ? setTimeout(a, b) : a();
      },
      k = {
        $get: function () {
          return i;
        },
        api: i,
        settings: c,
        virtualPageviews: function (a) {
          this.settings.pageTracking.autoTrackVirtualPages = a;
        },
        firstPageview: function (a) {
          this.settings.pageTracking.autoTrackFirstPage = a;
        },
        withBase: function (b) {
          this.settings.pageTracking.basePath = b ? a.element("base").attr("href").slice(0, -1) : "";
        },
        withAutoBase: function (a) {
          this.settings.pageTracking.autoBasePath = a;
        },
        developerMode: function (a) {
          this.settings.developerMode = a;
        }
      },
      l = function (b, d) {
        i[b] = h(b, d);
        var f = c[b],
          g = f ? f.bufferFlushDelay : null,
          k = null !== g ? g : c.bufferFlushDelay;
        a.forEach(e[b], function (a, b) {
          j(function () {
            d.apply(this, a);
          }, b * k);
        });
      },
      m = function (a) {
        return a.replace(/^./, function (a) {
          return a.toUpperCase();
        });
      },
      n = function (a) {
        var b = "register" + m(a);
        k[b] = function (b) {
          l(a, b);
        }, i[a] = h(a, g(a));
      };
    return a.forEach(d, n), k;
  }).run(["$rootScope", "$window", "$analytics", "$injector", function (b, c, d, e) {
    d.settings.pageTracking.autoTrackFirstPage && e.invoke(["$location", function (a) {
      var b = !0;
      if (e.has("$route")) {
        var f = e.get("$route");
        for (var g in f.routes) {
          b = !1;
          break;
        }
      } else if (e.has("$state")) {
        var h = e.get("$state");
        for (var i in h.get()) {
          b = !1;
          break;
        }
      }
      if (b) if (d.settings.pageTracking.autoBasePath && (d.settings.pageTracking.basePath = c.location.pathname), d.settings.trackRelativePath) {
        var j = d.settings.pageTracking.basePath + a.url();
        d.pageTrack(j, a);
      } else d.pageTrack(a.absUrl(), a);
    }]), d.settings.pageTracking.autoTrackVirtualPages && e.invoke(["$location", function (a) {
      d.settings.pageTracking.autoBasePath && (d.settings.pageTracking.basePath = c.location.pathname + "#"), e.has("$route") && b.$on("$routeChangeSuccess", function (b, c) {
        if (!c || !(c.$$route || c).redirectTo) {
          var e = d.settings.pageTracking.basePath + a.url();
          d.pageTrack(e, a);
        }
      }), e.has("$state") && b.$on("$stateChangeSuccess", function () {
        var b = d.settings.pageTracking.basePath + a.url();
        d.pageTrack(b, a);
      });
    }]), d.settings.developerMode && a.forEach(d, function (a, b) {
      "function" == typeof a && (d[b] = function () {});
    });
  }]).directive("analyticsOn", ["$analytics", function (b) {
    function c(a) {
      return ["a:", "button:", "button:button", "button:submit", "input:button", "input:submit"].indexOf(a.tagName.toLowerCase() + ":" + (a.type || "")) >= 0;
    }
    function d(a) {
      return c(a) ? "click" : "click";
    }
    function e(a) {
      return c(a) ? a.innerText || a.value : a.id || a.name || a.tagName;
    }
    function f(a) {
      return "analytics" === a.substr(0, 9) && -1 === ["On", "Event", "If", "Properties", "EventType"].indexOf(a.substr(9));
    }
    function g(a) {
      var b = a.slice(9);
      return "undefined" != typeof b && null !== b && b.length > 0 ? b.substring(0, 1).toLowerCase() + b.substring(1) : b;
    }
    return {
      restrict: "A",
      link: function (c, h, i) {
        var j = i.analyticsOn || d(h[0]),
          k = {};
        a.forEach(i.$attr, function (a, b) {
          f(b) && (k[g(b)] = i[b], i.$observe(b, function (a) {
            k[g(b)] = a;
          }));
        }), a.element(h[0]).bind(j, function (d) {
          var f = i.analyticsEvent || e(h[0]);
          k.eventType = d.type, (!i.analyticsIf || c.$eval(i.analyticsIf)) && (i.analyticsProperties && a.extend(k, c.$eval(i.analyticsProperties)), b.eventTrack(f, k));
        });
      }
    };
  }]);
}(angular);
(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.dragula = f();
  }
})(function () {
  var define, module, exports;
  return function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof require && require;
            if (!f && c) return c(i, !0);
            if (u) return u(i, !0);
            var a = new Error("Cannot find module '" + i + "'");
            throw a.code = "MODULE_NOT_FOUND", a;
          }
          var p = n[i] = {
            exports: {}
          };
          e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];
            return o(n || r);
          }, p, p.exports, r, e, n, t);
        }
        return n[i].exports;
      }
      for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
      return o;
    }
    return r;
  }()({
    1: [function (require, module, exports) {
      'use strict';

      var cache = {};
      var start = '(?:^|\\s)';
      var end = '(?:\\s|$)';
      function lookupClass(className) {
        var cached = cache[className];
        if (cached) {
          cached.lastIndex = 0;
        } else {
          cache[className] = cached = new RegExp(start + className + end, 'g');
        }
        return cached;
      }
      function addClass(el, className) {
        var current = el.className;
        if (!current.length) {
          el.className = className;
        } else if (!lookupClass(className).test(current)) {
          el.className += ' ' + className;
        }
      }
      function rmClass(el, className) {
        el.className = el.className.replace(lookupClass(className), ' ').trim();
      }
      module.exports = {
        add: addClass,
        rm: rmClass
      };
    }, {}],
    2: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var emitter = require('contra/emitter');
        var crossvent = require('crossvent');
        var classes = require('./classes');
        var doc = document;
        var documentElement = doc.documentElement;
        function dragula(initialContainers, options) {
          var len = arguments.length;
          if (len === 1 && Array.isArray(initialContainers) === false) {
            options = initialContainers;
            initialContainers = [];
          }
          var _mirror; // mirror image
          var _source; // source container
          var _item; // item being dragged
          var _offsetX; // reference x
          var _offsetY; // reference y
          var _moveX; // reference move x
          var _moveY; // reference move y
          var _initialSibling; // reference sibling when grabbed
          var _currentSibling; // reference sibling now
          var _copy; // item used for copying
          var _renderTimer; // timer for setTimeout renderMirrorImage
          var _lastDropTarget = null; // last container item was over
          var _grabbed; // holds mousedown context until first mousemove

          var o = options || {};
          if (o.moves === void 0) {
            o.moves = always;
          }
          if (o.accepts === void 0) {
            o.accepts = always;
          }
          if (o.invalid === void 0) {
            o.invalid = invalidTarget;
          }
          if (o.containers === void 0) {
            o.containers = initialContainers || [];
          }
          if (o.isContainer === void 0) {
            o.isContainer = never;
          }
          if (o.copy === void 0) {
            o.copy = false;
          }
          if (o.copySortSource === void 0) {
            o.copySortSource = false;
          }
          if (o.revertOnSpill === void 0) {
            o.revertOnSpill = false;
          }
          if (o.removeOnSpill === void 0) {
            o.removeOnSpill = false;
          }
          if (o.direction === void 0) {
            o.direction = 'vertical';
          }
          if (o.ignoreInputTextSelection === void 0) {
            o.ignoreInputTextSelection = true;
          }
          if (o.mirrorContainer === void 0) {
            o.mirrorContainer = doc.body;
          }
          var drake = emitter({
            containers: o.containers,
            start: manualStart,
            end: end,
            cancel: cancel,
            remove: remove,
            destroy: destroy,
            canMove: canMove,
            dragging: false
          });
          if (o.removeOnSpill === true) {
            drake.on('over', spillOver).on('out', spillOut);
          }
          events();
          return drake;
          function isContainer(el) {
            return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
          }
          function events(remove) {
            var op = remove ? 'remove' : 'add';
            touchy(documentElement, op, 'mousedown', grab);
            touchy(documentElement, op, 'mouseup', release);
          }
          function eventualMovements(remove) {
            var op = remove ? 'remove' : 'add';
            touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
          }
          function movements(remove) {
            var op = remove ? 'remove' : 'add';
            crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
            crossvent[op](documentElement, 'click', preventGrabbed);
          }
          function destroy() {
            events(true);
            release({});
          }
          function preventGrabbed(e) {
            if (_grabbed) {
              e.preventDefault();
            }
          }
          function grab(e) {
            _moveX = e.clientX;
            _moveY = e.clientY;
            var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
            if (ignore) {
              return; // we only care about honest-to-god left clicks and touch events
            }

            var item = e.target;
            var context = canStart(item);
            if (!context) {
              return;
            }
            _grabbed = context;
            eventualMovements();
            if (e.type === 'mousedown') {
              if (isInput(item)) {
                // see also: https://github.com/bevacqua/dragula/issues/208
                item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
              } else {
                e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
              }
            }
          }

          function startBecauseMouseMoved(e) {
            if (!_grabbed) {
              return;
            }
            if (whichMouseButton(e) === 0) {
              release({});
              return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
            }

            // truthy check fixes #239, equality fixes #207, fixes #501
            if (e.clientX !== void 0 && Math.abs(e.clientX - _moveX) <= (o.slideFactorX || 0) && e.clientY !== void 0 && Math.abs(e.clientY - _moveY) <= (o.slideFactorY || 0)) {
              return;
            }
            if (o.ignoreInputTextSelection) {
              var clientX = getCoord('clientX', e) || 0;
              var clientY = getCoord('clientY', e) || 0;
              var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
              if (isInput(elementBehindCursor)) {
                return;
              }
            }
            var grabbed = _grabbed; // call to end() unsets _grabbed
            eventualMovements(true);
            movements();
            end();
            start(grabbed);
            var offset = getOffset(_item);
            _offsetX = getCoord('pageX', e) - offset.left;
            _offsetY = getCoord('pageY', e) - offset.top;
            classes.add(_copy || _item, 'gu-transit');
            renderMirrorImage();
            drag(e);
          }
          function canStart(item) {
            if (drake.dragging && _mirror) {
              return;
            }
            if (isContainer(item)) {
              return; // don't drag container itself
            }

            var handle = item;
            while (getParent(item) && isContainer(getParent(item)) === false) {
              if (o.invalid(item, handle)) {
                return;
              }
              item = getParent(item); // drag target should be a top element
              if (!item) {
                return;
              }
            }
            var source = getParent(item);
            if (!source) {
              return;
            }
            if (o.invalid(item, handle)) {
              return;
            }
            var movable = o.moves(item, source, handle, nextEl(item));
            if (!movable) {
              return;
            }
            return {
              item: item,
              source: source
            };
          }
          function canMove(item) {
            return !!canStart(item);
          }
          function manualStart(item) {
            var context = canStart(item);
            if (context) {
              start(context);
            }
          }
          function start(context) {
            if (isCopy(context.item, context.source)) {
              _copy = context.item.cloneNode(true);
              drake.emit('cloned', _copy, context.item, 'copy');
            }
            _source = context.source;
            _item = context.item;
            _initialSibling = _currentSibling = nextEl(context.item);
            drake.dragging = true;
            drake.emit('drag', _item, _source);
          }
          function invalidTarget() {
            return false;
          }
          function end() {
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            drop(item, getParent(item));
          }
          function ungrab() {
            _grabbed = false;
            eventualMovements(true);
            movements(true);
          }
          function release(e) {
            ungrab();
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            var clientX = getCoord('clientX', e) || 0;
            var clientY = getCoord('clientY', e) || 0;
            var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
            var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
            if (dropTarget && (_copy && o.copySortSource || !_copy || dropTarget !== _source)) {
              drop(item, dropTarget);
            } else if (o.removeOnSpill) {
              remove();
            } else {
              cancel();
            }
          }
          function drop(item, target) {
            var parent = getParent(item);
            if (_copy && o.copySortSource && target === _source) {
              parent.removeChild(_item);
            }
            if (isInitialPlacement(target)) {
              drake.emit('cancel', item, _source, _source);
            } else {
              drake.emit('drop', item, target, _source, _currentSibling);
            }
            cleanup();
          }
          function remove() {
            if (!drake.dragging) {
              return;
            }
            var item = _copy || _item;
            var parent = getParent(item);
            if (parent) {
              parent.removeChild(item);
            }
            drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
            cleanup();
          }
          function cancel(revert) {
            if (!drake.dragging) {
              return;
            }
            var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
            var item = _copy || _item;
            var parent = getParent(item);
            var initial = isInitialPlacement(parent);
            if (initial === false && reverts) {
              if (_copy) {
                if (parent) {
                  parent.removeChild(_copy);
                }
              } else {
                _source.insertBefore(item, _initialSibling);
              }
            }
            if (initial || reverts) {
              drake.emit('cancel', item, _source, _source);
            } else {
              drake.emit('drop', item, parent, _source, _currentSibling);
            }
            cleanup();
          }
          function cleanup() {
            var item = _copy || _item;
            ungrab();
            removeMirrorImage();
            if (item) {
              classes.rm(item, 'gu-transit');
            }
            if (_renderTimer) {
              clearTimeout(_renderTimer);
            }
            drake.dragging = false;
            if (_lastDropTarget) {
              drake.emit('out', item, _lastDropTarget, _source);
            }
            drake.emit('dragend', item);
            _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
          }
          function isInitialPlacement(target, s) {
            var sibling;
            if (s !== void 0) {
              sibling = s;
            } else if (_mirror) {
              sibling = _currentSibling;
            } else {
              sibling = nextEl(_copy || _item);
            }
            return target === _source && sibling === _initialSibling;
          }
          function findDropTarget(elementBehindCursor, clientX, clientY) {
            var target = elementBehindCursor;
            while (target && !accepted()) {
              target = getParent(target);
            }
            return target;
            function accepted() {
              var droppable = isContainer(target);
              if (droppable === false) {
                return false;
              }
              var immediate = getImmediateChild(target, elementBehindCursor);
              var reference = getReference(target, immediate, clientX, clientY);
              var initial = isInitialPlacement(target, reference);
              if (initial) {
                return true; // should always be able to drop it right back where it was
              }

              return o.accepts(_item, target, _source, reference);
            }
          }
          function drag(e) {
            if (!_mirror) {
              return;
            }
            e.preventDefault();
            var clientX = getCoord('clientX', e) || 0;
            var clientY = getCoord('clientY', e) || 0;
            var x = clientX - _offsetX;
            var y = clientY - _offsetY;
            _mirror.style.left = x + 'px';
            _mirror.style.top = y + 'px';
            var item = _copy || _item;
            var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
            var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
            var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
            if (changed || dropTarget === null) {
              out();
              _lastDropTarget = dropTarget;
              over();
            }
            var parent = getParent(item);
            if (dropTarget === _source && _copy && !o.copySortSource) {
              if (parent) {
                parent.removeChild(item);
              }
              return;
            }
            var reference;
            var immediate = getImmediateChild(dropTarget, elementBehindCursor);
            if (immediate !== null) {
              reference = getReference(dropTarget, immediate, clientX, clientY);
            } else if (o.revertOnSpill === true && !_copy) {
              reference = _initialSibling;
              dropTarget = _source;
            } else {
              if (_copy && parent) {
                parent.removeChild(item);
              }
              return;
            }
            if (reference === null && changed || reference !== item && reference !== nextEl(item)) {
              _currentSibling = reference;
              dropTarget.insertBefore(item, reference);
              drake.emit('shadow', item, dropTarget, _source);
            }
            function moved(type) {
              drake.emit(type, item, _lastDropTarget, _source);
            }
            function over() {
              if (changed) {
                moved('over');
              }
            }
            function out() {
              if (_lastDropTarget) {
                moved('out');
              }
            }
          }
          function spillOver(el) {
            classes.rm(el, 'gu-hide');
          }
          function spillOut(el) {
            if (drake.dragging) {
              classes.add(el, 'gu-hide');
            }
          }
          function renderMirrorImage() {
            if (_mirror) {
              return;
            }
            var rect = _item.getBoundingClientRect();
            _mirror = _item.cloneNode(true);
            _mirror.style.width = getRectWidth(rect) + 'px';
            _mirror.style.height = getRectHeight(rect) + 'px';
            classes.rm(_mirror, 'gu-transit');
            classes.add(_mirror, 'gu-mirror');
            o.mirrorContainer.appendChild(_mirror);
            touchy(documentElement, 'add', 'mousemove', drag);
            classes.add(o.mirrorContainer, 'gu-unselectable');
            drake.emit('cloned', _mirror, _item, 'mirror');
          }
          function removeMirrorImage() {
            if (_mirror) {
              classes.rm(o.mirrorContainer, 'gu-unselectable');
              touchy(documentElement, 'remove', 'mousemove', drag);
              getParent(_mirror).removeChild(_mirror);
              _mirror = null;
            }
          }
          function getImmediateChild(dropTarget, target) {
            var immediate = target;
            while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
              immediate = getParent(immediate);
            }
            if (immediate === documentElement) {
              return null;
            }
            return immediate;
          }
          function getReference(dropTarget, target, x, y) {
            var horizontal = o.direction === 'horizontal';
            var reference = target !== dropTarget ? inside() : outside();
            return reference;
            function outside() {
              // slower, but able to figure out any position
              var len = dropTarget.children.length;
              var i;
              var el;
              var rect;
              for (i = 0; i < len; i++) {
                el = dropTarget.children[i];
                rect = el.getBoundingClientRect();
                if (horizontal && rect.left + rect.width / 2 > x) {
                  return el;
                }
                if (!horizontal && rect.top + rect.height / 2 > y) {
                  return el;
                }
              }
              return null;
            }
            function inside() {
              // faster, but only available if dropped inside a child element
              var rect = target.getBoundingClientRect();
              if (horizontal) {
                return resolve(x > rect.left + getRectWidth(rect) / 2);
              }
              return resolve(y > rect.top + getRectHeight(rect) / 2);
            }
            function resolve(after) {
              return after ? nextEl(target) : target;
            }
          }
          function isCopy(item, container) {
            return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
          }
        }
        function touchy(el, op, type, fn) {
          var touch = {
            mouseup: 'touchend',
            mousedown: 'touchstart',
            mousemove: 'touchmove'
          };
          var pointers = {
            mouseup: 'pointerup',
            mousedown: 'pointerdown',
            mousemove: 'pointermove'
          };
          var microsoft = {
            mouseup: 'MSPointerUp',
            mousedown: 'MSPointerDown',
            mousemove: 'MSPointerMove'
          };
          if (global.navigator.pointerEnabled) {
            crossvent[op](el, pointers[type], fn);
          } else if (global.navigator.msPointerEnabled) {
            crossvent[op](el, microsoft[type], fn);
          } else {
            crossvent[op](el, touch[type], fn);
            crossvent[op](el, type, fn);
          }
        }
        function whichMouseButton(e) {
          if (e.touches !== void 0) {
            return e.touches.length;
          }
          if (e.which !== void 0 && e.which !== 0) {
            return e.which;
          } // see https://github.com/bevacqua/dragula/issues/261
          if (e.buttons !== void 0) {
            return e.buttons;
          }
          var button = e.button;
          if (button !== void 0) {
            // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
            return button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
          }
        }
        function getOffset(el) {
          var rect = el.getBoundingClientRect();
          return {
            left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
            top: rect.top + getScroll('scrollTop', 'pageYOffset')
          };
        }
        function getScroll(scrollProp, offsetProp) {
          if (typeof global[offsetProp] !== 'undefined') {
            return global[offsetProp];
          }
          if (documentElement.clientHeight) {
            return documentElement[scrollProp];
          }
          return doc.body[scrollProp];
        }
        function getElementBehindPoint(point, x, y) {
          point = point || {};
          var state = point.className || '';
          var el;
          point.className += ' gu-hide';
          el = doc.elementFromPoint(x, y);
          point.className = state;
          return el;
        }
        function never() {
          return false;
        }
        function always() {
          return true;
        }
        function getRectWidth(rect) {
          return rect.width || rect.right - rect.left;
        }
        function getRectHeight(rect) {
          return rect.height || rect.bottom - rect.top;
        }
        function getParent(el) {
          return el.parentNode === doc ? null : el.parentNode;
        }
        function isInput(el) {
          return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el);
        }
        function isEditable(el) {
          if (!el) {
            return false;
          } // no parents were editable
          if (el.contentEditable === 'false') {
            return false;
          } // stop the lookup
          if (el.contentEditable === 'true') {
            return true;
          } // found a contentEditable element in the chain
          return isEditable(getParent(el)); // contentEditable is set to 'inherit'
        }

        function nextEl(el) {
          return el.nextElementSibling || manually();
          function manually() {
            var sibling = el;
            do {
              sibling = sibling.nextSibling;
            } while (sibling && sibling.nodeType !== 1);
            return sibling;
          }
        }
        function getEventHost(e) {
          // on touchend event, we have to use `e.changedTouches`
          // see http://stackoverflow.com/questions/7192563/touchend-event-properties
          // see https://github.com/bevacqua/dragula/issues/34
          if (e.targetTouches && e.targetTouches.length) {
            return e.targetTouches[0];
          }
          if (e.changedTouches && e.changedTouches.length) {
            return e.changedTouches[0];
          }
          return e;
        }
        function getCoord(coord, e) {
          var host = getEventHost(e);
          var missMap = {
            pageX: 'clientX',
            // IE8
            pageY: 'clientY' // IE8
          };

          if (coord in missMap && !(coord in host) && missMap[coord] in host) {
            coord = missMap[coord];
          }
          return host[coord];
        }
        module.exports = dragula;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {
      "./classes": 1,
      "contra/emitter": 5,
      "crossvent": 6
    }],
    3: [function (require, module, exports) {
      module.exports = function atoa(a, n) {
        return Array.prototype.slice.call(a, n);
      };
    }, {}],
    4: [function (require, module, exports) {
      'use strict';

      var ticky = require('ticky');
      module.exports = function debounce(fn, args, ctx) {
        if (!fn) {
          return;
        }
        ticky(function run() {
          fn.apply(ctx || null, args || []);
        });
      };
    }, {
      "ticky": 10
    }],
    5: [function (require, module, exports) {
      'use strict';

      var atoa = require('atoa');
      var debounce = require('./debounce');
      module.exports = function emitter(thing, options) {
        var opts = options || {};
        var evt = {};
        if (thing === undefined) {
          thing = {};
        }
        thing.on = function (type, fn) {
          if (!evt[type]) {
            evt[type] = [fn];
          } else {
            evt[type].push(fn);
          }
          return thing;
        };
        thing.once = function (type, fn) {
          fn._once = true; // thing.off(fn) still works!
          thing.on(type, fn);
          return thing;
        };
        thing.off = function (type, fn) {
          var c = arguments.length;
          if (c === 1) {
            delete evt[type];
          } else if (c === 0) {
            evt = {};
          } else {
            var et = evt[type];
            if (!et) {
              return thing;
            }
            et.splice(et.indexOf(fn), 1);
          }
          return thing;
        };
        thing.emit = function () {
          var args = atoa(arguments);
          return thing.emitterSnapshot(args.shift()).apply(this, args);
        };
        thing.emitterSnapshot = function (type) {
          var et = (evt[type] || []).slice(0);
          return function () {
            var args = atoa(arguments);
            var ctx = this || thing;
            if (type === 'error' && opts.throws !== false && !et.length) {
              throw args.length === 1 ? args[0] : args;
            }
            et.forEach(function emitter(listen) {
              if (opts.async) {
                debounce(listen, args, ctx);
              } else {
                listen.apply(ctx, args);
              }
              if (listen._once) {
                thing.off(type, listen);
              }
            });
            return thing;
          };
        };
        return thing;
      };
    }, {
      "./debounce": 4,
      "atoa": 3
    }],
    6: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var customEvent = require('custom-event');
        var eventmap = require('./eventmap');
        var doc = global.document;
        var addEvent = addEventEasy;
        var removeEvent = removeEventEasy;
        var hardCache = [];
        if (!global.addEventListener) {
          addEvent = addEventHard;
          removeEvent = removeEventHard;
        }
        module.exports = {
          add: addEvent,
          remove: removeEvent,
          fabricate: fabricateEvent
        };
        function addEventEasy(el, type, fn, capturing) {
          return el.addEventListener(type, fn, capturing);
        }
        function addEventHard(el, type, fn) {
          return el.attachEvent('on' + type, wrap(el, type, fn));
        }
        function removeEventEasy(el, type, fn, capturing) {
          return el.removeEventListener(type, fn, capturing);
        }
        function removeEventHard(el, type, fn) {
          var listener = unwrap(el, type, fn);
          if (listener) {
            return el.detachEvent('on' + type, listener);
          }
        }
        function fabricateEvent(el, type, model) {
          var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
          if (el.dispatchEvent) {
            el.dispatchEvent(e);
          } else {
            el.fireEvent('on' + type, e);
          }
          function makeClassicEvent() {
            var e;
            if (doc.createEvent) {
              e = doc.createEvent('Event');
              e.initEvent(type, true, true);
            } else if (doc.createEventObject) {
              e = doc.createEventObject();
            }
            return e;
          }
          function makeCustomEvent() {
            return new customEvent(type, {
              detail: model
            });
          }
        }
        function wrapperFactory(el, type, fn) {
          return function wrapper(originalEvent) {
            var e = originalEvent || global.event;
            e.target = e.target || e.srcElement;
            e.preventDefault = e.preventDefault || function preventDefault() {
              e.returnValue = false;
            };
            e.stopPropagation = e.stopPropagation || function stopPropagation() {
              e.cancelBubble = true;
            };
            e.which = e.which || e.keyCode;
            fn.call(el, e);
          };
        }
        function wrap(el, type, fn) {
          var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
          hardCache.push({
            wrapper: wrapper,
            element: el,
            type: type,
            fn: fn
          });
          return wrapper;
        }
        function unwrap(el, type, fn) {
          var i = find(el, type, fn);
          if (i) {
            var wrapper = hardCache[i].wrapper;
            hardCache.splice(i, 1); // free up a tad of memory
            return wrapper;
          }
        }
        function find(el, type, fn) {
          var i, item;
          for (i = 0; i < hardCache.length; i++) {
            item = hardCache[i];
            if (item.element === el && item.type === type && item.fn === fn) {
              return i;
            }
          }
        }
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {
      "./eventmap": 7,
      "custom-event": 8
    }],
    7: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var eventmap = [];
        var eventname = '';
        var ron = /^on/;
        for (eventname in global) {
          if (ron.test(eventname)) {
            eventmap.push(eventname.slice(2));
          }
        }
        module.exports = eventmap;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}],
    8: [function (require, module, exports) {
      (function (global) {
        var NativeCustomEvent = global.CustomEvent;
        function useNative() {
          try {
            var p = new NativeCustomEvent('cat', {
              detail: {
                foo: 'bar'
              }
            });
            return 'cat' === p.type && 'bar' === p.detail.foo;
          } catch (e) {}
          return false;
        }

        /**
         * Cross-browser `CustomEvent` constructor.
         *
         * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
         *
         * @public
         */

        module.exports = useNative() ? NativeCustomEvent :
        // IE >= 9
        'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent(type, params) {
          var e = document.createEvent('CustomEvent');
          if (params) {
            e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
          } else {
            e.initCustomEvent(type, false, false, void 0);
          }
          return e;
        } :
        // IE <= 8
        function CustomEvent(type, params) {
          var e = document.createEventObject();
          e.type = type;
          if (params) {
            e.bubbles = Boolean(params.bubbles);
            e.cancelable = Boolean(params.cancelable);
            e.detail = params.detail;
          } else {
            e.bubbles = false;
            e.cancelable = false;
            e.detail = void 0;
          }
          return e;
        };
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}],
    9: [function (require, module, exports) {
      // shim for using process in browser
      var process = module.exports = {};

      // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;
      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }
      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }
      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }
        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;
      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }
      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }
      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      };

      // v8 likes predictible objects
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };
      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues
      process.versions = {};
      function noop() {}
      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;
      process.listeners = function (name) {
        return [];
      };
      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };
      process.cwd = function () {
        return '/';
      };
      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };
      process.umask = function () {
        return 0;
      };
    }, {}],
    10: [function (require, module, exports) {
      (function (setImmediate) {
        var si = typeof setImmediate === 'function',
          tick;
        if (si) {
          tick = function (fn) {
            setImmediate(fn);
          };
        } else {
          tick = function (fn) {
            setTimeout(fn, 0);
          };
        }
        module.exports = tick;
      }).call(this, require("timers").setImmediate);
    }, {
      "timers": 11
    }],
    11: [function (require, module, exports) {
      (function (setImmediate, clearImmediate) {
        var nextTick = require('process/browser.js').nextTick;
        var apply = Function.prototype.apply;
        var slice = Array.prototype.slice;
        var immediateIds = {};
        var nextImmediateId = 0;

        // DOM APIs, for completeness

        exports.setTimeout = function () {
          return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
        };
        exports.setInterval = function () {
          return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
        };
        exports.clearTimeout = exports.clearInterval = function (timeout) {
          timeout.close();
        };
        function Timeout(id, clearFn) {
          this._id = id;
          this._clearFn = clearFn;
        }
        Timeout.prototype.unref = Timeout.prototype.ref = function () {};
        Timeout.prototype.close = function () {
          this._clearFn.call(window, this._id);
        };

        // Does not start the time, just sets up the members needed.
        exports.enroll = function (item, msecs) {
          clearTimeout(item._idleTimeoutId);
          item._idleTimeout = msecs;
        };
        exports.unenroll = function (item) {
          clearTimeout(item._idleTimeoutId);
          item._idleTimeout = -1;
        };
        exports._unrefActive = exports.active = function (item) {
          clearTimeout(item._idleTimeoutId);
          var msecs = item._idleTimeout;
          if (msecs >= 0) {
            item._idleTimeoutId = setTimeout(function onTimeout() {
              if (item._onTimeout) item._onTimeout();
            }, msecs);
          }
        };

        // That's not how node.js implements it but the exposed api is the same.
        exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
          var id = nextImmediateId++;
          var args = arguments.length < 2 ? false : slice.call(arguments, 1);
          immediateIds[id] = true;
          nextTick(function onNextTick() {
            if (immediateIds[id]) {
              // fn.call() is faster so we optimize for the common use-case
              // @see http://jsperf.com/call-apply-segu
              if (args) {
                fn.apply(null, args);
              } else {
                fn.call(null);
              }
              // Prevent ids from leaking
              exports.clearImmediate(id);
            }
          });
          return id;
        };
        exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
          delete immediateIds[id];
        };
      }).call(this, require("timers").setImmediate, require("timers").clearImmediate);
    }, {
      "process/browser.js": 9,
      "timers": 11
    }]
  }, {}, [2])(2);
});
/* Javascript plotting library for jQuery, version 0.8.3.

Copyright (c) 2007-2014 IOLA and Ole Laursen.
Licensed under the MIT license.

*/

// first an inline dependency, jquery.colorhelpers.js, we inline it here
// for convenience

/* Plugin for jQuery for working with colors.
 *
 * Version 1.1.
 *
 * Inspiration from jQuery color animation plugin by John Resig.
 *
 * Released under the MIT license by Ole Laursen, October 2009.
 *
 * Examples:
 *
 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
 *   var c = $.color.extract($("#mydiv"), 'background-color');
 *   console.log(c.r, c.g, c.b, c.a);
 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
 *
 * Note that .scale() and .add() return the same modified object
 * instead of making a new one.
 *
 * V. 1.1: Fix error handling so e.g. parsing an empty string does
 * produce a color rather than just crashing.
 */
(function ($) {
  $.color = {};
  $.color.make = function (r, g, b, a) {
    var o = {};
    o.r = r || 0;
    o.g = g || 0;
    o.b = b || 0;
    o.a = a != null ? a : 1;
    o.add = function (c, d) {
      for (var i = 0; i < c.length; ++i) o[c.charAt(i)] += d;
      return o.normalize();
    };
    o.scale = function (c, f) {
      for (var i = 0; i < c.length; ++i) o[c.charAt(i)] *= f;
      return o.normalize();
    };
    o.toString = function () {
      if (o.a >= 1) {
        return "rgb(" + [o.r, o.g, o.b].join(",") + ")";
      } else {
        return "rgba(" + [o.r, o.g, o.b, o.a].join(",") + ")";
      }
    };
    o.normalize = function () {
      function clamp(min, value, max) {
        return value < min ? min : value > max ? max : value;
      }
      o.r = clamp(0, parseInt(o.r), 255);
      o.g = clamp(0, parseInt(o.g), 255);
      o.b = clamp(0, parseInt(o.b), 255);
      o.a = clamp(0, o.a, 1);
      return o;
    };
    o.clone = function () {
      return $.color.make(o.r, o.b, o.g, o.a);
    };
    return o.normalize();
  };
  $.color.extract = function (elem, css) {
    var c;
    do {
      c = elem.css(css).toLowerCase();
      if (c != "" && c != "transparent") break;
      elem = elem.parent();
    } while (elem.length && !$.nodeName(elem.get(0), "body"));
    if (c == "rgba(0, 0, 0, 0)") c = "transparent";
    return $.color.parse(c);
  };
  $.color.parse = function (str) {
    var res,
      m = $.color.make;
    if (res = /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(str)) return m(parseInt(res[1], 10), parseInt(res[2], 10), parseInt(res[3], 10));
    if (res = /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str)) return m(parseInt(res[1], 10), parseInt(res[2], 10), parseInt(res[3], 10), parseFloat(res[4]));
    if (res = /rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(str)) return m(parseFloat(res[1]) * 2.55, parseFloat(res[2]) * 2.55, parseFloat(res[3]) * 2.55);
    if (res = /rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str)) return m(parseFloat(res[1]) * 2.55, parseFloat(res[2]) * 2.55, parseFloat(res[3]) * 2.55, parseFloat(res[4]));
    if (res = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(str)) return m(parseInt(res[1], 16), parseInt(res[2], 16), parseInt(res[3], 16));
    if (res = /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(str)) return m(parseInt(res[1] + res[1], 16), parseInt(res[2] + res[2], 16), parseInt(res[3] + res[3], 16));
    var name = $.trim(str).toLowerCase();
    if (name == "transparent") return m(255, 255, 255, 0);else {
      res = lookupColors[name] || [0, 0, 0];
      return m(res[0], res[1], res[2]);
    }
  };
  var lookupColors = {
    aqua: [0, 255, 255],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    black: [0, 0, 0],
    blue: [0, 0, 255],
    brown: [165, 42, 42],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgrey: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkviolet: [148, 0, 211],
    fuchsia: [255, 0, 255],
    gold: [255, 215, 0],
    green: [0, 128, 0],
    indigo: [75, 0, 130],
    khaki: [240, 230, 140],
    lightblue: [173, 216, 230],
    lightcyan: [224, 255, 255],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    navy: [0, 0, 128],
    olive: [128, 128, 0],
    orange: [255, 165, 0],
    pink: [255, 192, 203],
    purple: [128, 0, 128],
    violet: [128, 0, 128],
    red: [255, 0, 0],
    silver: [192, 192, 192],
    white: [255, 255, 255],
    yellow: [255, 255, 0]
  };
})(jQuery);

// the actual Flot code
(function ($) {
  // Cache the prototype hasOwnProperty for faster access

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  // A shim to provide 'detach' to jQuery versions prior to 1.4.  Using a DOM
  // operation produces the same effect as detach, i.e. removing the element
  // without touching its jQuery data.

  // Do not merge this into Flot 0.9, since it requires jQuery 1.4.4+.

  if (!$.fn.detach) {
    $.fn.detach = function () {
      return this.each(function () {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      });
    };
  }

  ///////////////////////////////////////////////////////////////////////////
  // The Canvas object is a wrapper around an HTML5 <canvas> tag.
  //
  // @constructor
  // @param {string} cls List of classes to apply to the canvas.
  // @param {element} container Element onto which to append the canvas.
  //
  // Requiring a container is a little iffy, but unfortunately canvas
  // operations don't work unless the canvas is attached to the DOM.

  function Canvas(cls, container) {
    var element = container.children("." + cls)[0];
    if (element == null) {
      element = document.createElement("canvas");
      element.className = cls;
      $(element).css({
        direction: "ltr",
        position: "absolute",
        left: 0,
        top: 0
      }).appendTo(container);

      // If HTML5 Canvas isn't available, fall back to [Ex|Flash]canvas

      if (!element.getContext) {
        if (window.G_vmlCanvasManager) {
          element = window.G_vmlCanvasManager.initElement(element);
        } else {
          throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
        }
      }
    }
    this.element = element;
    var context = this.context = element.getContext("2d");

    // Determine the screen's ratio of physical to device-independent
    // pixels.  This is the ratio between the canvas width that the browser
    // advertises and the number of pixels actually present in that space.

    // The iPhone 4, for example, has a device-independent width of 320px,
    // but its screen is actually 640px wide.  It therefore has a pixel
    // ratio of 2, while most normal devices have a ratio of 1.

    var devicePixelRatio = window.devicePixelRatio || 1,
      backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
    this.pixelRatio = devicePixelRatio / backingStoreRatio;

    // Size the canvas to match the internal dimensions of its container

    this.resize(container.width(), container.height());

    // Collection of HTML div layers for text overlaid onto the canvas

    this.textContainer = null;
    this.text = {};

    // Cache of text fragments and metrics, so we can avoid expensively
    // re-calculating them when the plot is re-rendered in a loop.

    this._textCache = {};
  }

  // Resizes the canvas to the given dimensions.
  //
  // @param {number} width New width of the canvas, in pixels.
  // @param {number} width New height of the canvas, in pixels.

  Canvas.prototype.resize = function (width, height) {
    if (width <= 0 || height <= 0) {
      throw new Error("Invalid dimensions for plot, width = " + width + ", height = " + height);
    }
    var element = this.element,
      context = this.context,
      pixelRatio = this.pixelRatio;

    // Resize the canvas, increasing its density based on the display's
    // pixel ratio; basically giving it more pixels without increasing the
    // size of its element, to take advantage of the fact that retina
    // displays have that many more pixels in the same advertised space.

    // Resizing should reset the state (excanvas seems to be buggy though)

    if (this.width != width) {
      element.width = width * pixelRatio;
      element.style.width = width + "px";
      this.width = width;
    }
    if (this.height != height) {
      element.height = height * pixelRatio;
      element.style.height = height + "px";
      this.height = height;
    }

    // Save the context, so we can reset in case we get replotted.  The
    // restore ensure that we're really back at the initial state, and
    // should be safe even if we haven't saved the initial state yet.

    context.restore();
    context.save();

    // Scale the coordinate space to match the display density; so even though we
    // may have twice as many pixels, we still want lines and other drawing to
    // appear at the same size; the extra pixels will just make them crisper.

    context.scale(pixelRatio, pixelRatio);
  };

  // Clears the entire canvas area, not including any overlaid HTML text

  Canvas.prototype.clear = function () {
    this.context.clearRect(0, 0, this.width, this.height);
  };

  // Finishes rendering the canvas, including managing the text overlay.

  Canvas.prototype.render = function () {
    var cache = this._textCache;

    // For each text layer, add elements marked as active that haven't
    // already been rendered, and remove those that are no longer active.

    for (var layerKey in cache) {
      if (hasOwnProperty.call(cache, layerKey)) {
        var layer = this.getTextLayer(layerKey),
          layerCache = cache[layerKey];
        layer.hide();
        for (var styleKey in layerCache) {
          if (hasOwnProperty.call(layerCache, styleKey)) {
            var styleCache = layerCache[styleKey];
            for (var key in styleCache) {
              if (hasOwnProperty.call(styleCache, key)) {
                var positions = styleCache[key].positions;
                for (var i = 0, position; position = positions[i]; i++) {
                  if (position.active) {
                    if (!position.rendered) {
                      layer.append(position.element);
                      position.rendered = true;
                    }
                  } else {
                    positions.splice(i--, 1);
                    if (position.rendered) {
                      position.element.detach();
                    }
                  }
                }
                if (positions.length == 0) {
                  delete styleCache[key];
                }
              }
            }
          }
        }
        layer.show();
      }
    }
  };

  // Creates (if necessary) and returns the text overlay container.
  //
  // @param {string} classes String of space-separated CSS classes used to
  //     uniquely identify the text layer.
  // @return {object} The jQuery-wrapped text-layer div.

  Canvas.prototype.getTextLayer = function (classes) {
    var layer = this.text[classes];

    // Create the text layer if it doesn't exist

    if (layer == null) {
      // Create the text layer container, if it doesn't exist

      if (this.textContainer == null) {
        this.textContainer = $("<div class='flot-text'></div>").css({
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          'font-size': "smaller",
          color: "#545454"
        }).insertAfter(this.element);
      }
      layer = this.text[classes] = $("<div></div>").addClass(classes).css({
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      }).appendTo(this.textContainer);
    }
    return layer;
  };

  // Creates (if necessary) and returns a text info object.
  //
  // The object looks like this:
  //
  // {
  //     width: Width of the text's wrapper div.
  //     height: Height of the text's wrapper div.
  //     element: The jQuery-wrapped HTML div containing the text.
  //     positions: Array of positions at which this text is drawn.
  // }
  //
  // The positions array contains objects that look like this:
  //
  // {
  //     active: Flag indicating whether the text should be visible.
  //     rendered: Flag indicating whether the text is currently visible.
  //     element: The jQuery-wrapped HTML div containing the text.
  //     x: X coordinate at which to draw the text.
  //     y: Y coordinate at which to draw the text.
  // }
  //
  // Each position after the first receives a clone of the original element.
  //
  // The idea is that that the width, height, and general 'identity' of the
  // text is constant no matter where it is placed; the placements are a
  // secondary property.
  //
  // Canvas maintains a cache of recently-used text info objects; getTextInfo
  // either returns the cached element or creates a new entry.
  //
  // @param {string} layer A string of space-separated CSS classes uniquely
  //     identifying the layer containing this text.
  // @param {string} text Text string to retrieve info for.
  // @param {(string|object)=} font Either a string of space-separated CSS
  //     classes or a font-spec object, defining the text's font and style.
  // @param {number=} angle Angle at which to rotate the text, in degrees.
  //     Angle is currently unused, it will be implemented in the future.
  // @param {number=} width Maximum width of the text before it wraps.
  // @return {object} a text info object.

  Canvas.prototype.getTextInfo = function (layer, text, font, angle, width) {
    var textStyle, layerCache, styleCache, info;

    // Cast the value to a string, in case we were given a number or such

    text = "" + text;

    // If the font is a font-spec object, generate a CSS font definition

    if (typeof font === "object") {
      textStyle = font.style + " " + font.variant + " " + font.weight + " " + font.size + "px/" + font.lineHeight + "px " + font.family;
    } else {
      textStyle = font;
    }

    // Retrieve (or create) the cache for the text's layer and styles

    layerCache = this._textCache[layer];
    if (layerCache == null) {
      layerCache = this._textCache[layer] = {};
    }
    styleCache = layerCache[textStyle];
    if (styleCache == null) {
      styleCache = layerCache[textStyle] = {};
    }
    info = styleCache[text];

    // If we can't find a matching element in our cache, create a new one

    if (info == null) {
      var element = $("<div></div>").html(text).css({
        position: "absolute",
        'max-width': width,
        top: -9999
      }).appendTo(this.getTextLayer(layer));
      if (typeof font === "object") {
        element.css({
          font: textStyle,
          color: font.color
        });
      } else if (typeof font === "string") {
        element.addClass(font);
      }
      info = styleCache[text] = {
        width: element.outerWidth(true),
        height: element.outerHeight(true),
        element: element,
        positions: []
      };
      element.detach();
    }
    return info;
  };

  // Adds a text string to the canvas text overlay.
  //
  // The text isn't drawn immediately; it is marked as rendering, which will
  // result in its addition to the canvas on the next render pass.
  //
  // @param {string} layer A string of space-separated CSS classes uniquely
  //     identifying the layer containing this text.
  // @param {number} x X coordinate at which to draw the text.
  // @param {number} y Y coordinate at which to draw the text.
  // @param {string} text Text string to draw.
  // @param {(string|object)=} font Either a string of space-separated CSS
  //     classes or a font-spec object, defining the text's font and style.
  // @param {number=} angle Angle at which to rotate the text, in degrees.
  //     Angle is currently unused, it will be implemented in the future.
  // @param {number=} width Maximum width of the text before it wraps.
  // @param {string=} halign Horizontal alignment of the text; either "left",
  //     "center" or "right".
  // @param {string=} valign Vertical alignment of the text; either "top",
  //     "middle" or "bottom".

  Canvas.prototype.addText = function (layer, x, y, text, font, angle, width, halign, valign) {
    var info = this.getTextInfo(layer, text, font, angle, width),
      positions = info.positions;

    // Tweak the div's position to match the text's alignment

    if (halign == "center") {
      x -= info.width / 2;
    } else if (halign == "right") {
      x -= info.width;
    }
    if (valign == "middle") {
      y -= info.height / 2;
    } else if (valign == "bottom") {
      y -= info.height;
    }

    // Determine whether this text already exists at this position.
    // If so, mark it for inclusion in the next render pass.

    for (var i = 0, position; position = positions[i]; i++) {
      if (position.x == x && position.y == y) {
        position.active = true;
        return;
      }
    }

    // If the text doesn't exist at this position, create a new entry

    // For the very first position we'll re-use the original element,
    // while for subsequent ones we'll clone it.

    position = {
      active: true,
      rendered: false,
      element: positions.length ? info.element.clone() : info.element,
      x: x,
      y: y
    };
    positions.push(position);

    // Move the element to its final position within the container

    position.element.css({
      top: Math.round(y),
      left: Math.round(x),
      'text-align': halign // In case the text wraps
    });
  };

  // Removes one or more text strings from the canvas text overlay.
  //
  // If no parameters are given, all text within the layer is removed.
  //
  // Note that the text is not immediately removed; it is simply marked as
  // inactive, which will result in its removal on the next render pass.
  // This avoids the performance penalty for 'clear and redraw' behavior,
  // where we potentially get rid of all text on a layer, but will likely
  // add back most or all of it later, as when redrawing axes, for example.
  //
  // @param {string} layer A string of space-separated CSS classes uniquely
  //     identifying the layer containing this text.
  // @param {number=} x X coordinate of the text.
  // @param {number=} y Y coordinate of the text.
  // @param {string=} text Text string to remove.
  // @param {(string|object)=} font Either a string of space-separated CSS
  //     classes or a font-spec object, defining the text's font and style.
  // @param {number=} angle Angle at which the text is rotated, in degrees.
  //     Angle is currently unused, it will be implemented in the future.

  Canvas.prototype.removeText = function (layer, x, y, text, font, angle) {
    if (text == null) {
      var layerCache = this._textCache[layer];
      if (layerCache != null) {
        for (var styleKey in layerCache) {
          if (hasOwnProperty.call(layerCache, styleKey)) {
            var styleCache = layerCache[styleKey];
            for (var key in styleCache) {
              if (hasOwnProperty.call(styleCache, key)) {
                var positions = styleCache[key].positions;
                for (var i = 0, position; position = positions[i]; i++) {
                  position.active = false;
                }
              }
            }
          }
        }
      }
    } else {
      var positions = this.getTextInfo(layer, text, font, angle).positions;
      for (var i = 0, position; position = positions[i]; i++) {
        if (position.x == x && position.y == y) {
          position.active = false;
        }
      }
    }
  };

  ///////////////////////////////////////////////////////////////////////////
  // The top-level container for the entire plot.

  function Plot(placeholder, data_, options_, plugins) {
    // data is on the form:
    //   [ series1, series2 ... ]
    // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
    // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }

    var series = [],
      options = {
        // the color theme used for graphs
        colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
        legend: {
          show: true,
          noColumns: 1,
          // number of colums in legend table
          labelFormatter: null,
          // fn: string -> string
          labelBoxBorderColor: "#ccc",
          // border color for the little label boxes
          container: null,
          // container (as jQuery object) to put legend in, null means default on top of graph
          position: "ne",
          // position of default legend container within plot
          margin: 5,
          // distance from grid edge to default legend container within plot
          backgroundColor: null,
          // null means auto-detect
          backgroundOpacity: 0.85,
          // set to 0 to avoid background
          sorted: null // default to no legend sorting
        },

        xaxis: {
          show: null,
          // null = auto-detect, true = always, false = never
          position: "bottom",
          // or "top"
          mode: null,
          // null or "time"
          font: null,
          // null (derived from CSS in placeholder) or object like { size: 11, lineHeight: 13, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
          color: null,
          // base color, labels, ticks
          tickColor: null,
          // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
          transform: null,
          // null or f: number -> number to transform axis
          inverseTransform: null,
          // if transform is set, this should be the inverse function
          min: null,
          // min. value to show, null means set automatically
          max: null,
          // max. value to show, null means set automatically
          autoscaleMargin: null,
          // margin in % to add if auto-setting min/max
          ticks: null,
          // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
          tickFormatter: null,
          // fn: number -> string
          labelWidth: null,
          // size of tick labels in pixels
          labelHeight: null,
          reserveSpace: null,
          // whether to reserve space even if axis isn't shown
          tickLength: null,
          // size in pixels of ticks, or "full" for whole line
          alignTicksWithAxis: null,
          // axis number or null for no sync
          tickDecimals: null,
          // no. of decimals, null means auto
          tickSize: null,
          // number or [number, "unit"]
          minTickSize: null // number or [number, "unit"]
        },

        yaxis: {
          autoscaleMargin: 0.02,
          position: "left" // or "right"
        },

        xaxes: [],
        yaxes: [],
        series: {
          points: {
            show: false,
            radius: 3,
            lineWidth: 2,
            // in pixels
            fill: true,
            fillColor: "#ffffff",
            symbol: "circle" // or callback
          },

          lines: {
            // we don't put in show: false so we can see
            // whether lines were actively disabled
            lineWidth: 2,
            // in pixels
            fill: false,
            fillColor: null,
            steps: false
            // Omit 'zero', so we can later default its value to
            // match that of the 'fill' option.
          },

          bars: {
            show: false,
            lineWidth: 2,
            // in pixels
            barWidth: 1,
            // in units of the x axis
            fill: true,
            fillColor: null,
            align: "left",
            // "left", "right", or "center"
            horizontal: false,
            zero: true
          },
          shadowSize: 3,
          highlightColor: null
        },
        grid: {
          show: true,
          aboveData: false,
          color: "#545454",
          // primary color used for outline and labels
          backgroundColor: null,
          // null for transparent, else color
          borderColor: null,
          // set if different from the grid color
          tickColor: null,
          // color for the ticks, e.g. "rgba(0,0,0,0.15)"
          margin: 0,
          // distance from the canvas edge to the grid
          labelMargin: 5,
          // in pixels
          axisMargin: 8,
          // in pixels
          borderWidth: 2,
          // in pixels
          minBorderMargin: null,
          // in pixels, null means taken from points radius
          markings: null,
          // array of ranges or fn: axes -> array of ranges
          markingsColor: "#f4f4f4",
          markingsLineWidth: 2,
          // interactive stuff
          clickable: false,
          hoverable: false,
          autoHighlight: true,
          // highlight in case mouse is near
          mouseActiveRadius: 10 // how far the mouse can be away to activate an item
        },

        interaction: {
          redrawOverlayInterval: 1000 / 60 // time between updates, -1 means in same flow
        },

        hooks: {}
      },
      surface = null,
      // the canvas for the plot itself
      overlay = null,
      // canvas for interactive stuff on top of plot
      eventHolder = null,
      // jQuery object that events should be bound to
      ctx = null,
      octx = null,
      xaxes = [],
      yaxes = [],
      plotOffset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
      plotWidth = 0,
      plotHeight = 0,
      hooks = {
        processOptions: [],
        processRawData: [],
        processDatapoints: [],
        processOffset: [],
        drawBackground: [],
        drawSeries: [],
        draw: [],
        bindEvents: [],
        drawOverlay: [],
        shutdown: []
      },
      plot = this;

    // public functions
    plot.setData = setData;
    plot.setupGrid = setupGrid;
    plot.draw = draw;
    plot.getPlaceholder = function () {
      return placeholder;
    };
    plot.getCanvas = function () {
      return surface.element;
    };
    plot.getPlotOffset = function () {
      return plotOffset;
    };
    plot.width = function () {
      return plotWidth;
    };
    plot.height = function () {
      return plotHeight;
    };
    plot.offset = function () {
      var o = eventHolder.offset();
      o.left += plotOffset.left;
      o.top += plotOffset.top;
      return o;
    };
    plot.getData = function () {
      return series;
    };
    plot.getAxes = function () {
      var res = {},
        i;
      $.each(xaxes.concat(yaxes), function (_, axis) {
        if (axis) res[axis.direction + (axis.n != 1 ? axis.n : "") + "axis"] = axis;
      });
      return res;
    };
    plot.getXAxes = function () {
      return xaxes;
    };
    plot.getYAxes = function () {
      return yaxes;
    };
    plot.c2p = canvasToAxisCoords;
    plot.p2c = axisToCanvasCoords;
    plot.getOptions = function () {
      return options;
    };
    plot.highlight = highlight;
    plot.unhighlight = unhighlight;
    plot.triggerRedrawOverlay = triggerRedrawOverlay;
    plot.pointOffset = function (point) {
      return {
        left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
        top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
      };
    };
    plot.shutdown = shutdown;
    plot.destroy = function () {
      shutdown();
      placeholder.removeData("plot").empty();
      series = [];
      options = null;
      surface = null;
      overlay = null;
      eventHolder = null;
      ctx = null;
      octx = null;
      xaxes = [];
      yaxes = [];
      hooks = null;
      highlights = [];
      plot = null;
    };
    plot.resize = function () {
      var width = placeholder.width(),
        height = placeholder.height();
      surface.resize(width, height);
      overlay.resize(width, height);
    };

    // public attributes
    plot.hooks = hooks;

    // initialize
    initPlugins(plot);
    parseOptions(options_);
    setupCanvases();
    setData(data_);
    setupGrid();
    draw();
    bindEvents();
    function executeHooks(hook, args) {
      args = [plot].concat(args);
      for (var i = 0; i < hook.length; ++i) hook[i].apply(this, args);
    }
    function initPlugins() {
      // References to key classes, allowing plugins to modify them

      var classes = {
        Canvas: Canvas
      };
      for (var i = 0; i < plugins.length; ++i) {
        var p = plugins[i];
        p.init(plot, classes);
        if (p.options) $.extend(true, options, p.options);
      }
    }
    function parseOptions(opts) {
      $.extend(true, options, opts);

      // $.extend merges arrays, rather than replacing them.  When less
      // colors are provided than the size of the default palette, we
      // end up with those colors plus the remaining defaults, which is
      // not expected behavior; avoid it by replacing them here.

      if (opts && opts.colors) {
        options.colors = opts.colors;
      }
      if (options.xaxis.color == null) options.xaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
      if (options.yaxis.color == null) options.yaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
      if (options.xaxis.tickColor == null)
        // grid.tickColor for back-compatibility
        options.xaxis.tickColor = options.grid.tickColor || options.xaxis.color;
      if (options.yaxis.tickColor == null)
        // grid.tickColor for back-compatibility
        options.yaxis.tickColor = options.grid.tickColor || options.yaxis.color;
      if (options.grid.borderColor == null) options.grid.borderColor = options.grid.color;
      if (options.grid.tickColor == null) options.grid.tickColor = $.color.parse(options.grid.color).scale('a', 0.22).toString();

      // Fill in defaults for axis options, including any unspecified
      // font-spec fields, if a font-spec was provided.

      // If no x/y axis options were provided, create one of each anyway,
      // since the rest of the code assumes that they exist.

      var i,
        axisOptions,
        axisCount,
        fontSize = placeholder.css("font-size"),
        fontSizeDefault = fontSize ? +fontSize.replace("px", "") : 13,
        fontDefaults = {
          style: placeholder.css("font-style"),
          size: Math.round(0.8 * fontSizeDefault),
          variant: placeholder.css("font-variant"),
          weight: placeholder.css("font-weight"),
          family: placeholder.css("font-family")
        };
      axisCount = options.xaxes.length || 1;
      for (i = 0; i < axisCount; ++i) {
        axisOptions = options.xaxes[i];
        if (axisOptions && !axisOptions.tickColor) {
          axisOptions.tickColor = axisOptions.color;
        }
        axisOptions = $.extend(true, {}, options.xaxis, axisOptions);
        options.xaxes[i] = axisOptions;
        if (axisOptions.font) {
          axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
          if (!axisOptions.font.color) {
            axisOptions.font.color = axisOptions.color;
          }
          if (!axisOptions.font.lineHeight) {
            axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
          }
        }
      }
      axisCount = options.yaxes.length || 1;
      for (i = 0; i < axisCount; ++i) {
        axisOptions = options.yaxes[i];
        if (axisOptions && !axisOptions.tickColor) {
          axisOptions.tickColor = axisOptions.color;
        }
        axisOptions = $.extend(true, {}, options.yaxis, axisOptions);
        options.yaxes[i] = axisOptions;
        if (axisOptions.font) {
          axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
          if (!axisOptions.font.color) {
            axisOptions.font.color = axisOptions.color;
          }
          if (!axisOptions.font.lineHeight) {
            axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
          }
        }
      }

      // backwards compatibility, to be removed in future
      if (options.xaxis.noTicks && options.xaxis.ticks == null) options.xaxis.ticks = options.xaxis.noTicks;
      if (options.yaxis.noTicks && options.yaxis.ticks == null) options.yaxis.ticks = options.yaxis.noTicks;
      if (options.x2axis) {
        options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
        options.xaxes[1].position = "top";
        // Override the inherit to allow the axis to auto-scale
        if (options.x2axis.min == null) {
          options.xaxes[1].min = null;
        }
        if (options.x2axis.max == null) {
          options.xaxes[1].max = null;
        }
      }
      if (options.y2axis) {
        options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
        options.yaxes[1].position = "right";
        // Override the inherit to allow the axis to auto-scale
        if (options.y2axis.min == null) {
          options.yaxes[1].min = null;
        }
        if (options.y2axis.max == null) {
          options.yaxes[1].max = null;
        }
      }
      if (options.grid.coloredAreas) options.grid.markings = options.grid.coloredAreas;
      if (options.grid.coloredAreasColor) options.grid.markingsColor = options.grid.coloredAreasColor;
      if (options.lines) $.extend(true, options.series.lines, options.lines);
      if (options.points) $.extend(true, options.series.points, options.points);
      if (options.bars) $.extend(true, options.series.bars, options.bars);
      if (options.shadowSize != null) options.series.shadowSize = options.shadowSize;
      if (options.highlightColor != null) options.series.highlightColor = options.highlightColor;

      // save options on axes for future reference
      for (i = 0; i < options.xaxes.length; ++i) getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
      for (i = 0; i < options.yaxes.length; ++i) getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];

      // add hooks from options
      for (var n in hooks) if (options.hooks[n] && options.hooks[n].length) hooks[n] = hooks[n].concat(options.hooks[n]);
      executeHooks(hooks.processOptions, [options]);
    }
    function setData(d) {
      series = parseData(d);
      fillInSeriesOptions();
      processData();
    }
    function parseData(d) {
      var res = [];
      for (var i = 0; i < d.length; ++i) {
        var s = $.extend(true, {}, options.series);
        if (d[i].data != null) {
          s.data = d[i].data; // move the data instead of deep-copy
          delete d[i].data;
          $.extend(true, s, d[i]);
          d[i].data = s.data;
        } else s.data = d[i];
        res.push(s);
      }
      return res;
    }
    function axisNumber(obj, coord) {
      var a = obj[coord + "axis"];
      if (typeof a == "object")
        // if we got a real axis, extract number
        a = a.n;
      if (typeof a != "number") a = 1; // default to first axis
      return a;
    }
    function allAxes() {
      // return flat array without annoying null entries
      return $.grep(xaxes.concat(yaxes), function (a) {
        return a;
      });
    }
    function canvasToAxisCoords(pos) {
      // return an object with x/y corresponding to all used axes
      var res = {},
        i,
        axis;
      for (i = 0; i < xaxes.length; ++i) {
        axis = xaxes[i];
        if (axis && axis.used) res["x" + axis.n] = axis.c2p(pos.left);
      }
      for (i = 0; i < yaxes.length; ++i) {
        axis = yaxes[i];
        if (axis && axis.used) res["y" + axis.n] = axis.c2p(pos.top);
      }
      if (res.x1 !== undefined) res.x = res.x1;
      if (res.y1 !== undefined) res.y = res.y1;
      return res;
    }
    function axisToCanvasCoords(pos) {
      // get canvas coords from the first pair of x/y found in pos
      var res = {},
        i,
        axis,
        key;
      for (i = 0; i < xaxes.length; ++i) {
        axis = xaxes[i];
        if (axis && axis.used) {
          key = "x" + axis.n;
          if (pos[key] == null && axis.n == 1) key = "x";
          if (pos[key] != null) {
            res.left = axis.p2c(pos[key]);
            break;
          }
        }
      }
      for (i = 0; i < yaxes.length; ++i) {
        axis = yaxes[i];
        if (axis && axis.used) {
          key = "y" + axis.n;
          if (pos[key] == null && axis.n == 1) key = "y";
          if (pos[key] != null) {
            res.top = axis.p2c(pos[key]);
            break;
          }
        }
      }
      return res;
    }
    function getOrCreateAxis(axes, number) {
      if (!axes[number - 1]) axes[number - 1] = {
        n: number,
        // save the number for future reference
        direction: axes == xaxes ? "x" : "y",
        options: $.extend(true, {}, axes == xaxes ? options.xaxis : options.yaxis)
      };
      return axes[number - 1];
    }
    function fillInSeriesOptions() {
      var neededColors = series.length,
        maxIndex = -1,
        i;

      // Subtract the number of series that already have fixed colors or
      // color indexes from the number that we still need to generate.

      for (i = 0; i < series.length; ++i) {
        var sc = series[i].color;
        if (sc != null) {
          neededColors--;
          if (typeof sc == "number" && sc > maxIndex) {
            maxIndex = sc;
          }
        }
      }

      // If any of the series have fixed color indexes, then we need to
      // generate at least as many colors as the highest index.

      if (neededColors <= maxIndex) {
        neededColors = maxIndex + 1;
      }

      // Generate all the colors, using first the option colors and then
      // variations on those colors once they're exhausted.

      var c,
        colors = [],
        colorPool = options.colors,
        colorPoolSize = colorPool.length,
        variation = 0;
      for (i = 0; i < neededColors; i++) {
        c = $.color.parse(colorPool[i % colorPoolSize] || "#666");

        // Each time we exhaust the colors in the pool we adjust
        // a scaling factor used to produce more variations on
        // those colors. The factor alternates negative/positive
        // to produce lighter/darker colors.

        // Reset the variation after every few cycles, or else
        // it will end up producing only white or black colors.

        if (i % colorPoolSize == 0 && i) {
          if (variation >= 0) {
            if (variation < 0.5) {
              variation = -variation - 0.2;
            } else variation = 0;
          } else variation = -variation;
        }
        colors[i] = c.scale('rgb', 1 + variation);
      }

      // Finalize the series options, filling in their colors

      var colori = 0,
        s;
      for (i = 0; i < series.length; ++i) {
        s = series[i];

        // assign colors
        if (s.color == null) {
          s.color = colors[colori].toString();
          ++colori;
        } else if (typeof s.color == "number") s.color = colors[s.color].toString();

        // turn on lines automatically in case nothing is set
        if (s.lines.show == null) {
          var v,
            show = true;
          for (v in s) if (s[v] && s[v].show) {
            show = false;
            break;
          }
          if (show) s.lines.show = true;
        }

        // If nothing was provided for lines.zero, default it to match
        // lines.fill, since areas by default should extend to zero.

        if (s.lines.zero == null) {
          s.lines.zero = !!s.lines.fill;
        }

        // setup axes
        s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
        s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
      }
    }
    function processData() {
      var topSentry = Number.POSITIVE_INFINITY,
        bottomSentry = Number.NEGATIVE_INFINITY,
        fakeInfinity = Number.MAX_VALUE,
        i,
        j,
        k,
        m,
        length,
        s,
        points,
        ps,
        x,
        y,
        axis,
        val,
        f,
        p,
        data,
        format;
      function updateAxis(axis, min, max) {
        if (min < axis.datamin && min != -fakeInfinity) axis.datamin = min;
        if (max > axis.datamax && max != fakeInfinity) axis.datamax = max;
      }
      $.each(allAxes(), function (_, axis) {
        // init axis
        axis.datamin = topSentry;
        axis.datamax = bottomSentry;
        axis.used = false;
      });
      for (i = 0; i < series.length; ++i) {
        s = series[i];
        s.datapoints = {
          points: []
        };
        executeHooks(hooks.processRawData, [s, s.data, s.datapoints]);
      }

      // first pass: clean and copy data
      for (i = 0; i < series.length; ++i) {
        s = series[i];
        data = s.data;
        format = s.datapoints.format;
        if (!format) {
          format = [];
          // find out how to copy
          format.push({
            x: true,
            number: true,
            required: true
          });
          format.push({
            y: true,
            number: true,
            required: true
          });
          if (s.bars.show || s.lines.show && s.lines.fill) {
            var autoscale = !!(s.bars.show && s.bars.zero || s.lines.show && s.lines.zero);
            format.push({
              y: true,
              number: true,
              required: false,
              defaultValue: 0,
              autoscale: autoscale
            });
            if (s.bars.horizontal) {
              delete format[format.length - 1].y;
              format[format.length - 1].x = true;
            }
          }
          s.datapoints.format = format;
        }
        if (s.datapoints.pointsize != null) continue; // already filled in

        s.datapoints.pointsize = format.length;
        ps = s.datapoints.pointsize;
        points = s.datapoints.points;
        var insertSteps = s.lines.show && s.lines.steps;
        s.xaxis.used = s.yaxis.used = true;
        for (j = k = 0; j < data.length; ++j, k += ps) {
          p = data[j];
          var nullify = p == null;
          if (!nullify) {
            for (m = 0; m < ps; ++m) {
              val = p[m];
              f = format[m];
              if (f) {
                if (f.number && val != null) {
                  val = +val; // convert to number
                  if (isNaN(val)) val = null;else if (val == Infinity) val = fakeInfinity;else if (val == -Infinity) val = -fakeInfinity;
                }
                if (val == null) {
                  if (f.required) nullify = true;
                  if (f.defaultValue != null) val = f.defaultValue;
                }
              }
              points[k + m] = val;
            }
          }
          if (nullify) {
            for (m = 0; m < ps; ++m) {
              val = points[k + m];
              if (val != null) {
                f = format[m];
                // extract min/max info
                if (f.autoscale !== false) {
                  if (f.x) {
                    updateAxis(s.xaxis, val, val);
                  }
                  if (f.y) {
                    updateAxis(s.yaxis, val, val);
                  }
                }
              }
              points[k + m] = null;
            }
          } else {
            // a little bit of line specific stuff that
            // perhaps shouldn't be here, but lacking
            // better means...
            if (insertSteps && k > 0 && points[k - ps] != null && points[k - ps] != points[k] && points[k - ps + 1] != points[k + 1]) {
              // copy the point to make room for a middle point
              for (m = 0; m < ps; ++m) points[k + ps + m] = points[k + m];

              // middle point has same y
              points[k + 1] = points[k - ps + 1];

              // we've added a point, better reflect that
              k += ps;
            }
          }
        }
      }

      // give the hooks a chance to run
      for (i = 0; i < series.length; ++i) {
        s = series[i];
        executeHooks(hooks.processDatapoints, [s, s.datapoints]);
      }

      // second pass: find datamax/datamin for auto-scaling
      for (i = 0; i < series.length; ++i) {
        s = series[i];
        points = s.datapoints.points;
        ps = s.datapoints.pointsize;
        format = s.datapoints.format;
        var xmin = topSentry,
          ymin = topSentry,
          xmax = bottomSentry,
          ymax = bottomSentry;
        for (j = 0; j < points.length; j += ps) {
          if (points[j] == null) continue;
          for (m = 0; m < ps; ++m) {
            val = points[j + m];
            f = format[m];
            if (!f || f.autoscale === false || val == fakeInfinity || val == -fakeInfinity) continue;
            if (f.x) {
              if (val < xmin) xmin = val;
              if (val > xmax) xmax = val;
            }
            if (f.y) {
              if (val < ymin) ymin = val;
              if (val > ymax) ymax = val;
            }
          }
        }
        if (s.bars.show) {
          // make sure we got room for the bar on the dancing floor
          var delta;
          switch (s.bars.align) {
            case "left":
              delta = 0;
              break;
            case "right":
              delta = -s.bars.barWidth;
              break;
            default:
              delta = -s.bars.barWidth / 2;
          }
          if (s.bars.horizontal) {
            ymin += delta;
            ymax += delta + s.bars.barWidth;
          } else {
            xmin += delta;
            xmax += delta + s.bars.barWidth;
          }
        }
        updateAxis(s.xaxis, xmin, xmax);
        updateAxis(s.yaxis, ymin, ymax);
      }
      $.each(allAxes(), function (_, axis) {
        if (axis.datamin == topSentry) axis.datamin = null;
        if (axis.datamax == bottomSentry) axis.datamax = null;
      });
    }
    function setupCanvases() {
      // Make sure the placeholder is clear of everything except canvases
      // from a previous plot in this container that we'll try to re-use.

      placeholder.css("padding", 0) // padding messes up the positioning
      .children().filter(function () {
        return !$(this).hasClass("flot-overlay") && !$(this).hasClass('flot-base');
      }).remove();
      if (placeholder.css("position") == 'static') placeholder.css("position", "relative"); // for positioning labels and overlay

      surface = new Canvas("flot-base", placeholder);
      overlay = new Canvas("flot-overlay", placeholder); // overlay canvas for interactive features

      ctx = surface.context;
      octx = overlay.context;

      // define which element we're listening for events on
      eventHolder = $(overlay.element).unbind();

      // If we're re-using a plot object, shut down the old one

      var existing = placeholder.data("plot");
      if (existing) {
        existing.shutdown();
        overlay.clear();
      }

      // save in case we get replotted
      placeholder.data("plot", plot);
    }
    function bindEvents() {
      // bind events
      if (options.grid.hoverable) {
        eventHolder.mousemove(onMouseMove);

        // Use bind, rather than .mouseleave, because we officially
        // still support jQuery 1.2.6, which doesn't define a shortcut
        // for mouseenter or mouseleave.  This was a bug/oversight that
        // was fixed somewhere around 1.3.x.  We can return to using
        // .mouseleave when we drop support for 1.2.6.

        eventHolder.bind("mouseleave", onMouseLeave);
      }
      if (options.grid.clickable) eventHolder.click(onClick);
      executeHooks(hooks.bindEvents, [eventHolder]);
    }
    function shutdown() {
      if (redrawTimeout) clearTimeout(redrawTimeout);
      eventHolder.unbind("mousemove", onMouseMove);
      eventHolder.unbind("mouseleave", onMouseLeave);
      eventHolder.unbind("click", onClick);
      executeHooks(hooks.shutdown, [eventHolder]);
    }
    function setTransformationHelpers(axis) {
      // set helper functions on the axis, assumes plot area
      // has been computed already

      function identity(x) {
        return x;
      }
      var s,
        m,
        t = axis.options.transform || identity,
        it = axis.options.inverseTransform;

      // precompute how much the axis is scaling a point
      // in canvas space
      if (axis.direction == "x") {
        s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
        m = Math.min(t(axis.max), t(axis.min));
      } else {
        s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
        s = -s;
        m = Math.max(t(axis.max), t(axis.min));
      }

      // data point to canvas coordinate
      if (t == identity)
        // slight optimization
        axis.p2c = function (p) {
          return (p - m) * s;
        };else axis.p2c = function (p) {
        return (t(p) - m) * s;
      };
      // canvas coordinate to data point
      if (!it) axis.c2p = function (c) {
        return m + c / s;
      };else axis.c2p = function (c) {
        return it(m + c / s);
      };
    }
    function measureTickLabels(axis) {
      var opts = axis.options,
        ticks = axis.ticks || [],
        labelWidth = opts.labelWidth || 0,
        labelHeight = opts.labelHeight || 0,
        maxWidth = labelWidth || (axis.direction == "x" ? Math.floor(surface.width / (ticks.length || 1)) : null),
        legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
        layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
        font = opts.font || "flot-tick-label tickLabel";
      for (var i = 0; i < ticks.length; ++i) {
        var t = ticks[i];
        if (!t.label) continue;
        var info = surface.getTextInfo(layer, t.label, font, null, maxWidth);
        labelWidth = Math.max(labelWidth, info.width);
        labelHeight = Math.max(labelHeight, info.height);
      }
      axis.labelWidth = opts.labelWidth || labelWidth;
      axis.labelHeight = opts.labelHeight || labelHeight;
    }
    function allocateAxisBoxFirstPhase(axis) {
      // find the bounding box of the axis by looking at label
      // widths/heights and ticks, make room by diminishing the
      // plotOffset; this first phase only looks at one
      // dimension per axis, the other dimension depends on the
      // other axes so will have to wait

      var lw = axis.labelWidth,
        lh = axis.labelHeight,
        pos = axis.options.position,
        isXAxis = axis.direction === "x",
        tickLength = axis.options.tickLength,
        axisMargin = options.grid.axisMargin,
        padding = options.grid.labelMargin,
        innermost = true,
        outermost = true,
        first = true,
        found = false;

      // Determine the axis's position in its direction and on its side

      $.each(isXAxis ? xaxes : yaxes, function (i, a) {
        if (a && (a.show || a.reserveSpace)) {
          if (a === axis) {
            found = true;
          } else if (a.options.position === pos) {
            if (found) {
              outermost = false;
            } else {
              innermost = false;
            }
          }
          if (!found) {
            first = false;
          }
        }
      });

      // The outermost axis on each side has no margin

      if (outermost) {
        axisMargin = 0;
      }

      // The ticks for the first axis in each direction stretch across

      if (tickLength == null) {
        tickLength = first ? "full" : 5;
      }
      if (!isNaN(+tickLength)) padding += +tickLength;
      if (isXAxis) {
        lh += padding;
        if (pos == "bottom") {
          plotOffset.bottom += lh + axisMargin;
          axis.box = {
            top: surface.height - plotOffset.bottom,
            height: lh
          };
        } else {
          axis.box = {
            top: plotOffset.top + axisMargin,
            height: lh
          };
          plotOffset.top += lh + axisMargin;
        }
      } else {
        lw += padding;
        if (pos == "left") {
          axis.box = {
            left: plotOffset.left + axisMargin,
            width: lw
          };
          plotOffset.left += lw + axisMargin;
        } else {
          plotOffset.right += lw + axisMargin;
          axis.box = {
            left: surface.width - plotOffset.right,
            width: lw
          };
        }
      }

      // save for future reference
      axis.position = pos;
      axis.tickLength = tickLength;
      axis.box.padding = padding;
      axis.innermost = innermost;
    }
    function allocateAxisBoxSecondPhase(axis) {
      // now that all axis boxes have been placed in one
      // dimension, we can set the remaining dimension coordinates
      if (axis.direction == "x") {
        axis.box.left = plotOffset.left - axis.labelWidth / 2;
        axis.box.width = surface.width - plotOffset.left - plotOffset.right + axis.labelWidth;
      } else {
        axis.box.top = plotOffset.top - axis.labelHeight / 2;
        axis.box.height = surface.height - plotOffset.bottom - plotOffset.top + axis.labelHeight;
      }
    }
    function adjustLayoutForThingsStickingOut() {
      // possibly adjust plot offset to ensure everything stays
      // inside the canvas and isn't clipped off

      var minMargin = options.grid.minBorderMargin,
        axis,
        i;

      // check stuff from the plot (FIXME: this should just read
      // a value from the series, otherwise it's impossible to
      // customize)
      if (minMargin == null) {
        minMargin = 0;
        for (i = 0; i < series.length; ++i) minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth / 2));
      }
      var margins = {
        left: minMargin,
        right: minMargin,
        top: minMargin,
        bottom: minMargin
      };

      // check axis labels, note we don't check the actual
      // labels but instead use the overall width/height to not
      // jump as much around with replots
      $.each(allAxes(), function (_, axis) {
        if (axis.reserveSpace && axis.ticks && axis.ticks.length) {
          if (axis.direction === "x") {
            margins.left = Math.max(margins.left, axis.labelWidth / 2);
            margins.right = Math.max(margins.right, axis.labelWidth / 2);
          } else {
            margins.bottom = Math.max(margins.bottom, axis.labelHeight / 2);
            margins.top = Math.max(margins.top, axis.labelHeight / 2);
          }
        }
      });
      plotOffset.left = Math.ceil(Math.max(margins.left, plotOffset.left));
      plotOffset.right = Math.ceil(Math.max(margins.right, plotOffset.right));
      plotOffset.top = Math.ceil(Math.max(margins.top, plotOffset.top));
      plotOffset.bottom = Math.ceil(Math.max(margins.bottom, plotOffset.bottom));
    }
    function setupGrid() {
      var i,
        axes = allAxes(),
        showGrid = options.grid.show;

      // Initialize the plot's offset from the edge of the canvas

      for (var a in plotOffset) {
        var margin = options.grid.margin || 0;
        plotOffset[a] = typeof margin == "number" ? margin : margin[a] || 0;
      }
      executeHooks(hooks.processOffset, [plotOffset]);

      // If the grid is visible, add its border width to the offset

      for (var a in plotOffset) {
        if (typeof options.grid.borderWidth == "object") {
          plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
        } else {
          plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
        }
      }
      $.each(axes, function (_, axis) {
        var axisOpts = axis.options;
        axis.show = axisOpts.show == null ? axis.used : axisOpts.show;
        axis.reserveSpace = axisOpts.reserveSpace == null ? axis.show : axisOpts.reserveSpace;
        setRange(axis);
      });
      if (showGrid) {
        var allocatedAxes = $.grep(axes, function (axis) {
          return axis.show || axis.reserveSpace;
        });
        $.each(allocatedAxes, function (_, axis) {
          // make the ticks
          setupTickGeneration(axis);
          setTicks(axis);
          snapRangeToTicks(axis, axis.ticks);
          // find labelWidth/Height for axis
          measureTickLabels(axis);
        });

        // with all dimensions calculated, we can compute the
        // axis bounding boxes, start from the outside
        // (reverse order)
        for (i = allocatedAxes.length - 1; i >= 0; --i) allocateAxisBoxFirstPhase(allocatedAxes[i]);

        // make sure we've got enough space for things that
        // might stick out
        adjustLayoutForThingsStickingOut();
        $.each(allocatedAxes, function (_, axis) {
          allocateAxisBoxSecondPhase(axis);
        });
      }
      plotWidth = surface.width - plotOffset.left - plotOffset.right;
      plotHeight = surface.height - plotOffset.bottom - plotOffset.top;

      // now we got the proper plot dimensions, we can compute the scaling
      $.each(axes, function (_, axis) {
        setTransformationHelpers(axis);
      });
      if (showGrid) {
        drawAxisLabels();
      }
      insertLegend();
    }
    function setRange(axis) {
      var opts = axis.options,
        min = +(opts.min != null ? opts.min : axis.datamin),
        max = +(opts.max != null ? opts.max : axis.datamax),
        delta = max - min;
      if (delta == 0.0) {
        // degenerate case
        var widen = max == 0 ? 1 : 0.01;
        if (opts.min == null) min -= widen;
        // always widen max if we couldn't widen min to ensure we
        // don't fall into min == max which doesn't work
        if (opts.max == null || opts.min != null) max += widen;
      } else {
        // consider autoscaling
        var margin = opts.autoscaleMargin;
        if (margin != null) {
          if (opts.min == null) {
            min -= delta * margin;
            // make sure we don't go below zero if all values
            // are positive
            if (min < 0 && axis.datamin != null && axis.datamin >= 0) min = 0;
          }
          if (opts.max == null) {
            max += delta * margin;
            if (max > 0 && axis.datamax != null && axis.datamax <= 0) max = 0;
          }
        }
      }
      axis.min = min;
      axis.max = max;
    }
    function setupTickGeneration(axis) {
      var opts = axis.options;

      // estimate number of ticks
      var noTicks;
      if (typeof opts.ticks == "number" && opts.ticks > 0) noTicks = opts.ticks;else
        // heuristic based on the model a*sqrt(x) fitted to
        // some data points that seemed reasonable
        noTicks = 0.3 * Math.sqrt(axis.direction == "x" ? surface.width : surface.height);
      var delta = (axis.max - axis.min) / noTicks,
        dec = -Math.floor(Math.log(delta) / Math.LN10),
        maxDec = opts.tickDecimals;
      if (maxDec != null && dec > maxDec) {
        dec = maxDec;
      }
      var magn = Math.pow(10, -dec),
        norm = delta / magn,
        // norm is between 1.0 and 10.0
        size;
      if (norm < 1.5) {
        size = 1;
      } else if (norm < 3) {
        size = 2;
        // special case for 2.5, requires an extra decimal
        if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
          size = 2.5;
          ++dec;
        }
      } else if (norm < 7.5) {
        size = 5;
      } else {
        size = 10;
      }
      size *= magn;
      if (opts.minTickSize != null && size < opts.minTickSize) {
        size = opts.minTickSize;
      }
      axis.delta = delta;
      axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
      axis.tickSize = opts.tickSize || size;

      // Time mode was moved to a plug-in in 0.8, and since so many people use it
      // we'll add an especially friendly reminder to make sure they included it.

      if (opts.mode == "time" && !axis.tickGenerator) {
        throw new Error("Time mode requires the flot.time plugin.");
      }

      // Flot supports base-10 axes; any other mode else is handled by a plug-in,
      // like flot.time.js.

      if (!axis.tickGenerator) {
        axis.tickGenerator = function (axis) {
          var ticks = [],
            start = floorInBase(axis.min, axis.tickSize),
            i = 0,
            v = Number.NaN,
            prev;
          do {
            prev = v;
            v = start + i * axis.tickSize;
            ticks.push(v);
            ++i;
          } while (v < axis.max && v != prev);
          return ticks;
        };
        axis.tickFormatter = function (value, axis) {
          var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1;
          var formatted = "" + Math.round(value * factor) / factor;

          // If tickDecimals was specified, ensure that we have exactly that
          // much precision; otherwise default to the value's own precision.

          if (axis.tickDecimals != null) {
            var decimal = formatted.indexOf(".");
            var precision = decimal == -1 ? 0 : formatted.length - decimal - 1;
            if (precision < axis.tickDecimals) {
              return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
            }
          }
          return formatted;
        };
      }
      if ($.isFunction(opts.tickFormatter)) axis.tickFormatter = function (v, axis) {
        return "" + opts.tickFormatter(v, axis);
      };
      if (opts.alignTicksWithAxis != null) {
        var otherAxis = (axis.direction == "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
        if (otherAxis && otherAxis.used && otherAxis != axis) {
          // consider snapping min/max to outermost nice ticks
          var niceTicks = axis.tickGenerator(axis);
          if (niceTicks.length > 0) {
            if (opts.min == null) axis.min = Math.min(axis.min, niceTicks[0]);
            if (opts.max == null && niceTicks.length > 1) axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
          }
          axis.tickGenerator = function (axis) {
            // copy ticks, scaled to this axis
            var ticks = [],
              v,
              i;
            for (i = 0; i < otherAxis.ticks.length; ++i) {
              v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
              v = axis.min + v * (axis.max - axis.min);
              ticks.push(v);
            }
            return ticks;
          };

          // we might need an extra decimal since forced
          // ticks don't necessarily fit naturally
          if (!axis.mode && opts.tickDecimals == null) {
            var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
              ts = axis.tickGenerator(axis);

            // only proceed if the tick interval rounded
            // with an extra decimal doesn't give us a
            // zero at end
            if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec)))) axis.tickDecimals = extraDec;
          }
        }
      }
    }
    function setTicks(axis) {
      var oticks = axis.options.ticks,
        ticks = [];
      if (oticks == null || typeof oticks == "number" && oticks > 0) ticks = axis.tickGenerator(axis);else if (oticks) {
        if ($.isFunction(oticks))
          // generate the ticks
          ticks = oticks(axis);else ticks = oticks;
      }

      // clean up/labelify the supplied ticks, copy them over
      var i, v;
      axis.ticks = [];
      for (i = 0; i < ticks.length; ++i) {
        var label = null;
        var t = ticks[i];
        if (typeof t == "object") {
          v = +t[0];
          if (t.length > 1) label = t[1];
        } else v = +t;
        if (label == null) label = axis.tickFormatter(v, axis);
        if (!isNaN(v)) axis.ticks.push({
          v: v,
          label: label
        });
      }
    }
    function snapRangeToTicks(axis, ticks) {
      if (axis.options.autoscaleMargin && ticks.length > 0) {
        // snap to ticks
        if (axis.options.min == null) axis.min = Math.min(axis.min, ticks[0].v);
        if (axis.options.max == null && ticks.length > 1) axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
      }
    }
    function draw() {
      surface.clear();
      executeHooks(hooks.drawBackground, [ctx]);
      var grid = options.grid;

      // draw background, if any
      if (grid.show && grid.backgroundColor) drawBackground();
      if (grid.show && !grid.aboveData) {
        drawGrid();
      }
      for (var i = 0; i < series.length; ++i) {
        executeHooks(hooks.drawSeries, [ctx, series[i]]);
        drawSeries(series[i]);
      }
      executeHooks(hooks.draw, [ctx]);
      if (grid.show && grid.aboveData) {
        drawGrid();
      }
      surface.render();

      // A draw implies that either the axes or data have changed, so we
      // should probably update the overlay highlights as well.

      triggerRedrawOverlay();
    }
    function extractRange(ranges, coord) {
      var axis,
        from,
        to,
        key,
        axes = allAxes();
      for (var i = 0; i < axes.length; ++i) {
        axis = axes[i];
        if (axis.direction == coord) {
          key = coord + axis.n + "axis";
          if (!ranges[key] && axis.n == 1) key = coord + "axis"; // support x1axis as xaxis
          if (ranges[key]) {
            from = ranges[key].from;
            to = ranges[key].to;
            break;
          }
        }
      }

      // backwards-compat stuff - to be removed in future
      if (!ranges[key]) {
        axis = coord == "x" ? xaxes[0] : yaxes[0];
        from = ranges[coord + "1"];
        to = ranges[coord + "2"];
      }

      // auto-reverse as an added bonus
      if (from != null && to != null && from > to) {
        var tmp = from;
        from = to;
        to = tmp;
      }
      return {
        from: from,
        to: to,
        axis: axis
      };
    }
    function drawBackground() {
      ctx.save();
      ctx.translate(plotOffset.left, plotOffset.top);
      ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
      ctx.fillRect(0, 0, plotWidth, plotHeight);
      ctx.restore();
    }
    function drawGrid() {
      var i, axes, bw, bc;
      ctx.save();
      ctx.translate(plotOffset.left, plotOffset.top);

      // draw markings
      var markings = options.grid.markings;
      if (markings) {
        if ($.isFunction(markings)) {
          axes = plot.getAxes();
          // xmin etc. is backwards compatibility, to be
          // removed in the future
          axes.xmin = axes.xaxis.min;
          axes.xmax = axes.xaxis.max;
          axes.ymin = axes.yaxis.min;
          axes.ymax = axes.yaxis.max;
          markings = markings(axes);
        }
        for (i = 0; i < markings.length; ++i) {
          var m = markings[i],
            xrange = extractRange(m, "x"),
            yrange = extractRange(m, "y");

          // fill in missing
          if (xrange.from == null) xrange.from = xrange.axis.min;
          if (xrange.to == null) xrange.to = xrange.axis.max;
          if (yrange.from == null) yrange.from = yrange.axis.min;
          if (yrange.to == null) yrange.to = yrange.axis.max;

          // clip
          if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max || yrange.to < yrange.axis.min || yrange.from > yrange.axis.max) continue;
          xrange.from = Math.max(xrange.from, xrange.axis.min);
          xrange.to = Math.min(xrange.to, xrange.axis.max);
          yrange.from = Math.max(yrange.from, yrange.axis.min);
          yrange.to = Math.min(yrange.to, yrange.axis.max);
          var xequal = xrange.from === xrange.to,
            yequal = yrange.from === yrange.to;
          if (xequal && yequal) {
            continue;
          }

          // then draw
          xrange.from = Math.floor(xrange.axis.p2c(xrange.from));
          xrange.to = Math.floor(xrange.axis.p2c(xrange.to));
          yrange.from = Math.floor(yrange.axis.p2c(yrange.from));
          yrange.to = Math.floor(yrange.axis.p2c(yrange.to));
          if (xequal || yequal) {
            var lineWidth = m.lineWidth || options.grid.markingsLineWidth,
              subPixel = lineWidth % 2 ? 0.5 : 0;
            ctx.beginPath();
            ctx.strokeStyle = m.color || options.grid.markingsColor;
            ctx.lineWidth = lineWidth;
            if (xequal) {
              ctx.moveTo(xrange.to + subPixel, yrange.from);
              ctx.lineTo(xrange.to + subPixel, yrange.to);
            } else {
              ctx.moveTo(xrange.from, yrange.to + subPixel);
              ctx.lineTo(xrange.to, yrange.to + subPixel);
            }
            ctx.stroke();
          } else {
            ctx.fillStyle = m.color || options.grid.markingsColor;
            ctx.fillRect(xrange.from, yrange.to, xrange.to - xrange.from, yrange.from - yrange.to);
          }
        }
      }

      // draw the ticks
      axes = allAxes();
      bw = options.grid.borderWidth;
      for (var j = 0; j < axes.length; ++j) {
        var axis = axes[j],
          box = axis.box,
          t = axis.tickLength,
          x,
          y,
          xoff,
          yoff;
        if (!axis.show || axis.ticks.length == 0) continue;
        ctx.lineWidth = 1;

        // find the edges
        if (axis.direction == "x") {
          x = 0;
          if (t == "full") y = axis.position == "top" ? 0 : plotHeight;else y = box.top - plotOffset.top + (axis.position == "top" ? box.height : 0);
        } else {
          y = 0;
          if (t == "full") x = axis.position == "left" ? 0 : plotWidth;else x = box.left - plotOffset.left + (axis.position == "left" ? box.width : 0);
        }

        // draw tick bar
        if (!axis.innermost) {
          ctx.strokeStyle = axis.options.color;
          ctx.beginPath();
          xoff = yoff = 0;
          if (axis.direction == "x") xoff = plotWidth + 1;else yoff = plotHeight + 1;
          if (ctx.lineWidth == 1) {
            if (axis.direction == "x") {
              y = Math.floor(y) + 0.5;
            } else {
              x = Math.floor(x) + 0.5;
            }
          }
          ctx.moveTo(x, y);
          ctx.lineTo(x + xoff, y + yoff);
          ctx.stroke();
        }

        // draw ticks

        ctx.strokeStyle = axis.options.tickColor;
        ctx.beginPath();
        for (i = 0; i < axis.ticks.length; ++i) {
          var v = axis.ticks[i].v;
          xoff = yoff = 0;
          if (isNaN(v) || v < axis.min || v > axis.max
          // skip those lying on the axes if we got a border
          || t == "full" && (typeof bw == "object" && bw[axis.position] > 0 || bw > 0) && (v == axis.min || v == axis.max)) continue;
          if (axis.direction == "x") {
            x = axis.p2c(v);
            yoff = t == "full" ? -plotHeight : t;
            if (axis.position == "top") yoff = -yoff;
          } else {
            y = axis.p2c(v);
            xoff = t == "full" ? -plotWidth : t;
            if (axis.position == "left") xoff = -xoff;
          }
          if (ctx.lineWidth == 1) {
            if (axis.direction == "x") x = Math.floor(x) + 0.5;else y = Math.floor(y) + 0.5;
          }
          ctx.moveTo(x, y);
          ctx.lineTo(x + xoff, y + yoff);
        }
        ctx.stroke();
      }

      // draw border
      if (bw) {
        // If either borderWidth or borderColor is an object, then draw the border
        // line by line instead of as one rectangle
        bc = options.grid.borderColor;
        if (typeof bw == "object" || typeof bc == "object") {
          if (typeof bw !== "object") {
            bw = {
              top: bw,
              right: bw,
              bottom: bw,
              left: bw
            };
          }
          if (typeof bc !== "object") {
            bc = {
              top: bc,
              right: bc,
              bottom: bc,
              left: bc
            };
          }
          if (bw.top > 0) {
            ctx.strokeStyle = bc.top;
            ctx.lineWidth = bw.top;
            ctx.beginPath();
            ctx.moveTo(0 - bw.left, 0 - bw.top / 2);
            ctx.lineTo(plotWidth, 0 - bw.top / 2);
            ctx.stroke();
          }
          if (bw.right > 0) {
            ctx.strokeStyle = bc.right;
            ctx.lineWidth = bw.right;
            ctx.beginPath();
            ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
            ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
            ctx.stroke();
          }
          if (bw.bottom > 0) {
            ctx.strokeStyle = bc.bottom;
            ctx.lineWidth = bw.bottom;
            ctx.beginPath();
            ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
            ctx.lineTo(0, plotHeight + bw.bottom / 2);
            ctx.stroke();
          }
          if (bw.left > 0) {
            ctx.strokeStyle = bc.left;
            ctx.lineWidth = bw.left;
            ctx.beginPath();
            ctx.moveTo(0 - bw.left / 2, plotHeight + bw.bottom);
            ctx.lineTo(0 - bw.left / 2, 0);
            ctx.stroke();
          }
        } else {
          ctx.lineWidth = bw;
          ctx.strokeStyle = options.grid.borderColor;
          ctx.strokeRect(-bw / 2, -bw / 2, plotWidth + bw, plotHeight + bw);
        }
      }
      ctx.restore();
    }
    function drawAxisLabels() {
      $.each(allAxes(), function (_, axis) {
        var box = axis.box,
          legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
          layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
          font = axis.options.font || "flot-tick-label tickLabel",
          tick,
          x,
          y,
          halign,
          valign;

        // Remove text before checking for axis.show and ticks.length;
        // otherwise plugins, like flot-tickrotor, that draw their own
        // tick labels will end up with both theirs and the defaults.

        surface.removeText(layer);
        if (!axis.show || axis.ticks.length == 0) return;
        for (var i = 0; i < axis.ticks.length; ++i) {
          tick = axis.ticks[i];
          if (!tick.label || tick.v < axis.min || tick.v > axis.max) continue;
          if (axis.direction == "x") {
            halign = "center";
            x = plotOffset.left + axis.p2c(tick.v);
            if (axis.position == "bottom") {
              y = box.top + box.padding;
            } else {
              y = box.top + box.height - box.padding;
              valign = "bottom";
            }
          } else {
            valign = "middle";
            y = plotOffset.top + axis.p2c(tick.v);
            if (axis.position == "left") {
              x = box.left + box.width - box.padding;
              halign = "right";
            } else {
              x = box.left + box.padding;
            }
          }
          surface.addText(layer, x, y, tick.label, font, null, null, halign, valign);
        }
      });
    }
    function drawSeries(series) {
      if (series.lines.show) drawSeriesLines(series);
      if (series.bars.show) drawSeriesBars(series);
      if (series.points.show) drawSeriesPoints(series);
    }
    function drawSeriesLines(series) {
      function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
        var points = datapoints.points,
          ps = datapoints.pointsize,
          prevx = null,
          prevy = null;
        ctx.beginPath();
        for (var i = ps; i < points.length; i += ps) {
          var x1 = points[i - ps],
            y1 = points[i - ps + 1],
            x2 = points[i],
            y2 = points[i + 1];
          if (x1 == null || x2 == null) continue;

          // clip with ymin
          if (y1 <= y2 && y1 < axisy.min) {
            if (y2 < axisy.min) continue; // line segment is outside
            // compute new intersection point
            x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
            y1 = axisy.min;
          } else if (y2 <= y1 && y2 < axisy.min) {
            if (y1 < axisy.min) continue;
            x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
            y2 = axisy.min;
          }

          // clip with ymax
          if (y1 >= y2 && y1 > axisy.max) {
            if (y2 > axisy.max) continue;
            x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
            y1 = axisy.max;
          } else if (y2 >= y1 && y2 > axisy.max) {
            if (y1 > axisy.max) continue;
            x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
            y2 = axisy.max;
          }

          // clip with xmin
          if (x1 <= x2 && x1 < axisx.min) {
            if (x2 < axisx.min) continue;
            y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
            x1 = axisx.min;
          } else if (x2 <= x1 && x2 < axisx.min) {
            if (x1 < axisx.min) continue;
            y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
            x2 = axisx.min;
          }

          // clip with xmax
          if (x1 >= x2 && x1 > axisx.max) {
            if (x2 > axisx.max) continue;
            y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
            x1 = axisx.max;
          } else if (x2 >= x1 && x2 > axisx.max) {
            if (x1 > axisx.max) continue;
            y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
            x2 = axisx.max;
          }
          if (x1 != prevx || y1 != prevy) ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);
          prevx = x2;
          prevy = y2;
          ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
        }
        ctx.stroke();
      }
      function plotLineArea(datapoints, axisx, axisy) {
        var points = datapoints.points,
          ps = datapoints.pointsize,
          bottom = Math.min(Math.max(0, axisy.min), axisy.max),
          i = 0,
          top,
          areaOpen = false,
          ypos = 1,
          segmentStart = 0,
          segmentEnd = 0;

        // we process each segment in two turns, first forward
        // direction to sketch out top, then once we hit the
        // end we go backwards to sketch the bottom
        while (true) {
          if (ps > 0 && i > points.length + ps) break;
          i += ps; // ps is negative if going backwards

          var x1 = points[i - ps],
            y1 = points[i - ps + ypos],
            x2 = points[i],
            y2 = points[i + ypos];
          if (areaOpen) {
            if (ps > 0 && x1 != null && x2 == null) {
              // at turning point
              segmentEnd = i;
              ps = -ps;
              ypos = 2;
              continue;
            }
            if (ps < 0 && i == segmentStart + ps) {
              // done with the reverse sweep
              ctx.fill();
              areaOpen = false;
              ps = -ps;
              ypos = 1;
              i = segmentStart = segmentEnd + ps;
              continue;
            }
          }
          if (x1 == null || x2 == null) continue;

          // clip x values

          // clip with xmin
          if (x1 <= x2 && x1 < axisx.min) {
            if (x2 < axisx.min) continue;
            y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
            x1 = axisx.min;
          } else if (x2 <= x1 && x2 < axisx.min) {
            if (x1 < axisx.min) continue;
            y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
            x2 = axisx.min;
          }

          // clip with xmax
          if (x1 >= x2 && x1 > axisx.max) {
            if (x2 > axisx.max) continue;
            y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
            x1 = axisx.max;
          } else if (x2 >= x1 && x2 > axisx.max) {
            if (x1 > axisx.max) continue;
            y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
            x2 = axisx.max;
          }
          if (!areaOpen) {
            // open area
            ctx.beginPath();
            ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
            areaOpen = true;
          }

          // now first check the case where both is outside
          if (y1 >= axisy.max && y2 >= axisy.max) {
            ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
            ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
            continue;
          } else if (y1 <= axisy.min && y2 <= axisy.min) {
            ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
            ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
            continue;
          }

          // else it's a bit more complicated, there might
          // be a flat maxed out rectangle first, then a
          // triangular cutout or reverse; to find these
          // keep track of the current x values
          var x1old = x1,
            x2old = x2;

          // clip the y values, without shortcutting, we
          // go through all cases in turn

          // clip with ymin
          if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
            x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
            y1 = axisy.min;
          } else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
            x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
            y2 = axisy.min;
          }

          // clip with ymax
          if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
            x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
            y1 = axisy.max;
          } else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
            x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
            y2 = axisy.max;
          }

          // if the x value was changed we got a rectangle
          // to fill
          if (x1 != x1old) {
            ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
            // it goes to (x1, y1), but we fill that below
          }

          // fill triangular section, this sometimes result
          // in redundant points if (x1, y1) hasn't changed
          // from previous line to, but we just ignore that
          ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
          ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));

          // fill the other rectangle if it's there
          if (x2 != x2old) {
            ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
            ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
          }
        }
      }
      ctx.save();
      ctx.translate(plotOffset.left, plotOffset.top);
      ctx.lineJoin = "round";
      var lw = series.lines.lineWidth,
        sw = series.shadowSize;
      // FIXME: consider another form of shadow when filling is turned on
      if (lw > 0 && sw > 0) {
        // draw shadow as a thick and thin line with transparency
        ctx.lineWidth = sw;
        ctx.strokeStyle = "rgba(0,0,0,0.1)";
        // position shadow at angle from the mid of line
        var angle = Math.PI / 18;
        plotLine(series.datapoints, Math.sin(angle) * (lw / 2 + sw / 2), Math.cos(angle) * (lw / 2 + sw / 2), series.xaxis, series.yaxis);
        ctx.lineWidth = sw / 2;
        plotLine(series.datapoints, Math.sin(angle) * (lw / 2 + sw / 4), Math.cos(angle) * (lw / 2 + sw / 4), series.xaxis, series.yaxis);
      }
      ctx.lineWidth = lw;
      ctx.strokeStyle = series.color;
      var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
      if (fillStyle) {
        ctx.fillStyle = fillStyle;
        plotLineArea(series.datapoints, series.xaxis, series.yaxis);
      }
      if (lw > 0) plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
      ctx.restore();
    }
    function drawSeriesPoints(series) {
      function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
        var points = datapoints.points,
          ps = datapoints.pointsize;
        for (var i = 0; i < points.length; i += ps) {
          var x = points[i],
            y = points[i + 1];
          if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max) continue;
          ctx.beginPath();
          x = axisx.p2c(x);
          y = axisy.p2c(y) + offset;
          if (symbol == "circle") ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);else symbol(ctx, x, y, radius, shadow);
          ctx.closePath();
          if (fillStyle) {
            ctx.fillStyle = fillStyle;
            ctx.fill();
          }
          ctx.stroke();
        }
      }
      ctx.save();
      ctx.translate(plotOffset.left, plotOffset.top);
      var lw = series.points.lineWidth,
        sw = series.shadowSize,
        radius = series.points.radius,
        symbol = series.points.symbol;

      // If the user sets the line width to 0, we change it to a very 
      // small value. A line width of 0 seems to force the default of 1.
      // Doing the conditional here allows the shadow setting to still be 
      // optional even with a lineWidth of 0.

      if (lw == 0) lw = 0.0001;
      if (lw > 0 && sw > 0) {
        // draw shadow in two steps
        var w = sw / 2;
        ctx.lineWidth = w;
        ctx.strokeStyle = "rgba(0,0,0,0.1)";
        plotPoints(series.datapoints, radius, null, w + w / 2, true, series.xaxis, series.yaxis, symbol);
        ctx.strokeStyle = "rgba(0,0,0,0.2)";
        plotPoints(series.datapoints, radius, null, w / 2, true, series.xaxis, series.yaxis, symbol);
      }
      ctx.lineWidth = lw;
      ctx.strokeStyle = series.color;
      plotPoints(series.datapoints, radius, getFillStyle(series.points, series.color), 0, false, series.xaxis, series.yaxis, symbol);
      ctx.restore();
    }
    function drawBar(x, y, b, barLeft, barRight, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
      var left, right, bottom, top, drawLeft, drawRight, drawTop, drawBottom, tmp;

      // in horizontal mode, we start the bar from the left
      // instead of from the bottom so it appears to be
      // horizontal rather than vertical
      if (horizontal) {
        drawBottom = drawRight = drawTop = true;
        drawLeft = false;
        left = b;
        right = x;
        top = y + barLeft;
        bottom = y + barRight;

        // account for negative bars
        if (right < left) {
          tmp = right;
          right = left;
          left = tmp;
          drawLeft = true;
          drawRight = false;
        }
      } else {
        drawLeft = drawRight = drawTop = true;
        drawBottom = false;
        left = x + barLeft;
        right = x + barRight;
        bottom = b;
        top = y;

        // account for negative bars
        if (top < bottom) {
          tmp = top;
          top = bottom;
          bottom = tmp;
          drawBottom = true;
          drawTop = false;
        }
      }

      // clip
      if (right < axisx.min || left > axisx.max || top < axisy.min || bottom > axisy.max) return;
      if (left < axisx.min) {
        left = axisx.min;
        drawLeft = false;
      }
      if (right > axisx.max) {
        right = axisx.max;
        drawRight = false;
      }
      if (bottom < axisy.min) {
        bottom = axisy.min;
        drawBottom = false;
      }
      if (top > axisy.max) {
        top = axisy.max;
        drawTop = false;
      }
      left = axisx.p2c(left);
      bottom = axisy.p2c(bottom);
      right = axisx.p2c(right);
      top = axisy.p2c(top);

      // fill the bar
      if (fillStyleCallback) {
        c.fillStyle = fillStyleCallback(bottom, top);
        c.fillRect(left, top, right - left, bottom - top);
      }

      // draw outline
      if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
        c.beginPath();

        // FIXME: inline moveTo is buggy with excanvas
        c.moveTo(left, bottom);
        if (drawLeft) c.lineTo(left, top);else c.moveTo(left, top);
        if (drawTop) c.lineTo(right, top);else c.moveTo(right, top);
        if (drawRight) c.lineTo(right, bottom);else c.moveTo(right, bottom);
        if (drawBottom) c.lineTo(left, bottom);else c.moveTo(left, bottom);
        c.stroke();
      }
    }
    function drawSeriesBars(series) {
      function plotBars(datapoints, barLeft, barRight, fillStyleCallback, axisx, axisy) {
        var points = datapoints.points,
          ps = datapoints.pointsize;
        for (var i = 0; i < points.length; i += ps) {
          if (points[i] == null) continue;
          drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
        }
      }
      ctx.save();
      ctx.translate(plotOffset.left, plotOffset.top);

      // FIXME: figure out a way to add shadows (for instance along the right edge)
      ctx.lineWidth = series.bars.lineWidth;
      ctx.strokeStyle = series.color;
      var barLeft;
      switch (series.bars.align) {
        case "left":
          barLeft = 0;
          break;
        case "right":
          barLeft = -series.bars.barWidth;
          break;
        default:
          barLeft = -series.bars.barWidth / 2;
      }
      var fillStyleCallback = series.bars.fill ? function (bottom, top) {
        return getFillStyle(series.bars, series.color, bottom, top);
      } : null;
      plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, fillStyleCallback, series.xaxis, series.yaxis);
      ctx.restore();
    }
    function getFillStyle(filloptions, seriesColor, bottom, top) {
      var fill = filloptions.fill;
      if (!fill) return null;
      if (filloptions.fillColor) return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);
      var c = $.color.parse(seriesColor);
      c.a = typeof fill == "number" ? fill : 0.4;
      c.normalize();
      return c.toString();
    }
    function insertLegend() {
      if (options.legend.container != null) {
        $(options.legend.container).html("");
      } else {
        placeholder.find(".legend").remove();
      }
      if (!options.legend.show) {
        return;
      }
      var fragments = [],
        entries = [],
        rowStarted = false,
        lf = options.legend.labelFormatter,
        s,
        label;

      // Build a list of legend entries, with each having a label and a color

      for (var i = 0; i < series.length; ++i) {
        s = series[i];
        if (s.label) {
          label = lf ? lf(s.label, s) : s.label;
          if (label) {
            entries.push({
              label: label,
              color: s.color
            });
          }
        }
      }

      // Sort the legend using either the default or a custom comparator

      if (options.legend.sorted) {
        if ($.isFunction(options.legend.sorted)) {
          entries.sort(options.legend.sorted);
        } else if (options.legend.sorted == "reverse") {
          entries.reverse();
        } else {
          var ascending = options.legend.sorted != "descending";
          entries.sort(function (a, b) {
            return a.label == b.label ? 0 : a.label < b.label != ascending ? 1 : -1 // Logical XOR
            ;
          });
        }
      }

      // Generate markup for the list of entries, in their final order

      for (var i = 0; i < entries.length; ++i) {
        var entry = entries[i];
        if (i % options.legend.noColumns == 0) {
          if (rowStarted) fragments.push('</tr>');
          fragments.push('<tr>');
          rowStarted = true;
        }
        fragments.push('<td class="legendColorBox"><div style="border:1px solid ' + options.legend.labelBoxBorderColor + ';padding:1px"><div style="width:4px;height:0;border:5px solid ' + entry.color + ';overflow:hidden"></div></div></td>' + '<td class="legendLabel">' + entry.label + '</td>');
      }
      if (rowStarted) fragments.push('</tr>');
      if (fragments.length == 0) return;
      var table = '<table style="font-size:smaller;color:' + options.grid.color + '">' + fragments.join("") + '</table>';
      if (options.legend.container != null) $(options.legend.container).html(table);else {
        var pos = "",
          p = options.legend.position,
          m = options.legend.margin;
        if (m[0] == null) m = [m, m];
        if (p.charAt(0) == "n") pos += 'top:' + (m[1] + plotOffset.top) + 'px;';else if (p.charAt(0) == "s") pos += 'bottom:' + (m[1] + plotOffset.bottom) + 'px;';
        if (p.charAt(1) == "e") pos += 'right:' + (m[0] + plotOffset.right) + 'px;';else if (p.charAt(1) == "w") pos += 'left:' + (m[0] + plotOffset.left) + 'px;';
        var legend = $('<div class="legend">' + table.replace('style="', 'style="position:absolute;' + pos + ';') + '</div>').appendTo(placeholder);
        if (options.legend.backgroundOpacity != 0.0) {
          // put in the transparent background
          // separately to avoid blended labels and
          // label boxes
          var c = options.legend.backgroundColor;
          if (c == null) {
            c = options.grid.backgroundColor;
            if (c && typeof c == "string") c = $.color.parse(c);else c = $.color.extract(legend, 'background-color');
            c.a = 1;
            c = c.toString();
          }
          var div = legend.children();
          $('<div style="position:absolute;width:' + div.width() + 'px;height:' + div.height() + 'px;' + pos + 'background-color:' + c + ';"> </div>').prependTo(legend).css('opacity', options.legend.backgroundOpacity);
        }
      }
    }

    // interactive features

    var highlights = [],
      redrawTimeout = null;

    // returns the data item the mouse is over, or null if none is found
    function findNearbyItem(mouseX, mouseY, seriesFilter) {
      var maxDistance = options.grid.mouseActiveRadius,
        smallestDistance = maxDistance * maxDistance + 1,
        item = null,
        foundPoint = false,
        i,
        j,
        ps;
      for (i = series.length - 1; i >= 0; --i) {
        if (!seriesFilter(series[i])) continue;
        var s = series[i],
          axisx = s.xaxis,
          axisy = s.yaxis,
          points = s.datapoints.points,
          mx = axisx.c2p(mouseX),
          // precompute some stuff to make the loop faster
          my = axisy.c2p(mouseY),
          maxx = maxDistance / axisx.scale,
          maxy = maxDistance / axisy.scale;
        ps = s.datapoints.pointsize;
        // with inverse transforms, we can't use the maxx/maxy
        // optimization, sadly
        if (axisx.options.inverseTransform) maxx = Number.MAX_VALUE;
        if (axisy.options.inverseTransform) maxy = Number.MAX_VALUE;
        if (s.lines.show || s.points.show) {
          for (j = 0; j < points.length; j += ps) {
            var x = points[j],
              y = points[j + 1];
            if (x == null) continue;

            // For points and lines, the cursor must be within a
            // certain distance to the data point
            if (x - mx > maxx || x - mx < -maxx || y - my > maxy || y - my < -maxy) continue;

            // We have to calculate distances in pixels, not in
            // data units, because the scales of the axes may be different
            var dx = Math.abs(axisx.p2c(x) - mouseX),
              dy = Math.abs(axisy.p2c(y) - mouseY),
              dist = dx * dx + dy * dy; // we save the sqrt

            // use <= to ensure last point takes precedence
            // (last generally means on top of)
            if (dist < smallestDistance) {
              smallestDistance = dist;
              item = [i, j / ps];
            }
          }
        }
        if (s.bars.show && !item) {
          // no other point can be nearby

          var barLeft, barRight;
          switch (s.bars.align) {
            case "left":
              barLeft = 0;
              break;
            case "right":
              barLeft = -s.bars.barWidth;
              break;
            default:
              barLeft = -s.bars.barWidth / 2;
          }
          barRight = barLeft + s.bars.barWidth;
          for (j = 0; j < points.length; j += ps) {
            var x = points[j],
              y = points[j + 1],
              b = points[j + 2];
            if (x == null) continue;

            // for a bar graph, the cursor must be inside the bar
            if (series[i].bars.horizontal ? mx <= Math.max(b, x) && mx >= Math.min(b, x) && my >= y + barLeft && my <= y + barRight : mx >= x + barLeft && mx <= x + barRight && my >= Math.min(b, y) && my <= Math.max(b, y)) item = [i, j / ps];
          }
        }
      }
      if (item) {
        i = item[0];
        j = item[1];
        ps = series[i].datapoints.pointsize;
        return {
          datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
          dataIndex: j,
          series: series[i],
          seriesIndex: i
        };
      }
      return null;
    }
    function onMouseMove(e) {
      if (options.grid.hoverable) triggerClickHoverEvent("plothover", e, function (s) {
        return s["hoverable"] != false;
      });
    }
    function onMouseLeave(e) {
      if (options.grid.hoverable) triggerClickHoverEvent("plothover", e, function (s) {
        return false;
      });
    }
    function onClick(e) {
      triggerClickHoverEvent("plotclick", e, function (s) {
        return s["clickable"] != false;
      });
    }

    // trigger click or hover event (they send the same parameters
    // so we share their code)
    function triggerClickHoverEvent(eventname, event, seriesFilter) {
      var offset = eventHolder.offset(),
        canvasX = event.pageX - offset.left - plotOffset.left,
        canvasY = event.pageY - offset.top - plotOffset.top,
        pos = canvasToAxisCoords({
          left: canvasX,
          top: canvasY
        });
      pos.pageX = event.pageX;
      pos.pageY = event.pageY;
      var item = findNearbyItem(canvasX, canvasY, seriesFilter);
      if (item) {
        // fill in mouse pos for any listeners out there
        item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
        item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
      }
      if (options.grid.autoHighlight) {
        // clear auto-highlights
        for (var i = 0; i < highlights.length; ++i) {
          var h = highlights[i];
          if (h.auto == eventname && !(item && h.series == item.series && h.point[0] == item.datapoint[0] && h.point[1] == item.datapoint[1])) unhighlight(h.series, h.point);
        }
        if (item) highlight(item.series, item.datapoint, eventname);
      }
      placeholder.trigger(eventname, [pos, item]);
    }
    function triggerRedrawOverlay() {
      var t = options.interaction.redrawOverlayInterval;
      if (t == -1) {
        // skip event queue
        drawOverlay();
        return;
      }
      if (!redrawTimeout) redrawTimeout = setTimeout(drawOverlay, t);
    }
    function drawOverlay() {
      redrawTimeout = null;

      // draw highlights
      octx.save();
      overlay.clear();
      octx.translate(plotOffset.left, plotOffset.top);
      var i, hi;
      for (i = 0; i < highlights.length; ++i) {
        hi = highlights[i];
        if (hi.series.bars.show) drawBarHighlight(hi.series, hi.point);else drawPointHighlight(hi.series, hi.point);
      }
      octx.restore();
      executeHooks(hooks.drawOverlay, [octx]);
    }
    function highlight(s, point, auto) {
      if (typeof s == "number") s = series[s];
      if (typeof point == "number") {
        var ps = s.datapoints.pointsize;
        point = s.datapoints.points.slice(ps * point, ps * (point + 1));
      }
      var i = indexOfHighlight(s, point);
      if (i == -1) {
        highlights.push({
          series: s,
          point: point,
          auto: auto
        });
        triggerRedrawOverlay();
      } else if (!auto) highlights[i].auto = false;
    }
    function unhighlight(s, point) {
      if (s == null && point == null) {
        highlights = [];
        triggerRedrawOverlay();
        return;
      }
      if (typeof s == "number") s = series[s];
      if (typeof point == "number") {
        var ps = s.datapoints.pointsize;
        point = s.datapoints.points.slice(ps * point, ps * (point + 1));
      }
      var i = indexOfHighlight(s, point);
      if (i != -1) {
        highlights.splice(i, 1);
        triggerRedrawOverlay();
      }
    }
    function indexOfHighlight(s, p) {
      for (var i = 0; i < highlights.length; ++i) {
        var h = highlights[i];
        if (h.series == s && h.point[0] == p[0] && h.point[1] == p[1]) return i;
      }
      return -1;
    }
    function drawPointHighlight(series, point) {
      var x = point[0],
        y = point[1],
        axisx = series.xaxis,
        axisy = series.yaxis,
        highlightColor = typeof series.highlightColor === "string" ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString();
      if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max) return;
      var pointRadius = series.points.radius + series.points.lineWidth / 2;
      octx.lineWidth = pointRadius;
      octx.strokeStyle = highlightColor;
      var radius = 1.5 * pointRadius;
      x = axisx.p2c(x);
      y = axisy.p2c(y);
      octx.beginPath();
      if (series.points.symbol == "circle") octx.arc(x, y, radius, 0, 2 * Math.PI, false);else series.points.symbol(octx, x, y, radius, false);
      octx.closePath();
      octx.stroke();
    }
    function drawBarHighlight(series, point) {
      var highlightColor = typeof series.highlightColor === "string" ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString(),
        fillStyle = highlightColor,
        barLeft;
      switch (series.bars.align) {
        case "left":
          barLeft = 0;
          break;
        case "right":
          barLeft = -series.bars.barWidth;
          break;
        default:
          barLeft = -series.bars.barWidth / 2;
      }
      octx.lineWidth = series.bars.lineWidth;
      octx.strokeStyle = highlightColor;
      drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth, function () {
        return fillStyle;
      }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
    }
    function getColorOrGradient(spec, bottom, top, defaultColor) {
      if (typeof spec == "string") return spec;else {
        // assume this is a gradient spec; IE currently only
        // supports a simple vertical gradient properly, so that's
        // what we support too
        var gradient = ctx.createLinearGradient(0, top, 0, bottom);
        for (var i = 0, l = spec.colors.length; i < l; ++i) {
          var c = spec.colors[i];
          if (typeof c != "string") {
            var co = $.color.parse(defaultColor);
            if (c.brightness != null) co = co.scale('rgb', c.brightness);
            if (c.opacity != null) co.a *= c.opacity;
            c = co.toString();
          }
          gradient.addColorStop(i / (l - 1), c);
        }
        return gradient;
      }
    }
  }

  // Add the plot function to the top level of the jQuery object

  $.plot = function (placeholder, data, options) {
    //var t0 = new Date();
    var plot = new Plot($(placeholder), data, options, $.plot.plugins);
    //(window.console ? console.log : alert)("time used (msecs): " + ((new Date()).getTime() - t0.getTime()));
    return plot;
  };
  $.plot.version = "0.8.3";
  $.plot.plugins = [];

  // Also add the plot function as a chainable property

  $.fn.plot = function (data, options) {
    return this.each(function () {
      $.plot(this, data, options);
    });
  };

  // round to nearby lower multiple of base
  function floorInBase(n, base) {
    return base * Math.floor(n / base);
  }
})(jQuery);
/* Flot plugin for rendering pie charts.

Copyright (c) 2007-2014 IOLA and Ole Laursen.
Licensed under the MIT license.

The plugin assumes that each series has a single data value, and that each
value is a positive integer or zero.  Negative numbers don't make sense for a
pie chart, and have unpredictable results.  The values do NOT need to be
passed in as percentages; the plugin will calculate the total and per-slice
percentages internally.

* Created by Brian Medendorp

* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars

The plugin supports these options:

	series: {
		pie: {
			show: true/false
			radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
			innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
			startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
			tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
			offset: {
				top: integer value to move the pie up or down
				left: integer value to move the pie left or right, or 'auto'
			},
			stroke: {
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
				width: integer pixel width of the stroke
			},
			label: {
				show: true/false, or 'auto'
				formatter:  a user-defined function that modifies the text/style of the label text
				radius: 0-1 for percentage of fullsize, or a specified pixel length
				background: {
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
					opacity: 0-1
				},
				threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
			},
			combine: {
				threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
				label: any text value of what the combined slice should be labeled
			}
			highlight: {
				opacity: 0-1
			}
		}
	}

More detail and specific examples can be found in the included HTML file.

*/

(function ($) {
  // Maximum redraw attempts when fitting labels within the plot

  var REDRAW_ATTEMPTS = 10;

  // Factor by which to shrink the pie when fitting labels within the plot

  var REDRAW_SHRINK = 0.95;
  function init(plot) {
    var canvas = null,
      target = null,
      options = null,
      maxRadius = null,
      centerLeft = null,
      centerTop = null,
      processed = false,
      ctx = null;

    // interactive variables

    var highlights = [];

    // add hook to determine if pie plugin in enabled, and then perform necessary operations

    plot.hooks.processOptions.push(function (plot, options) {
      if (options.series.pie.show) {
        options.grid.show = false;

        // set labels.show

        if (options.series.pie.label.show == "auto") {
          if (options.legend.show) {
            options.series.pie.label.show = false;
          } else {
            options.series.pie.label.show = true;
          }
        }

        // set radius

        if (options.series.pie.radius == "auto") {
          if (options.series.pie.label.show) {
            options.series.pie.radius = 3 / 4;
          } else {
            options.series.pie.radius = 1;
          }
        }

        // ensure sane tilt

        if (options.series.pie.tilt > 1) {
          options.series.pie.tilt = 1;
        } else if (options.series.pie.tilt < 0) {
          options.series.pie.tilt = 0;
        }
      }
    });
    plot.hooks.bindEvents.push(function (plot, eventHolder) {
      var options = plot.getOptions();
      if (options.series.pie.show) {
        if (options.grid.hoverable) {
          eventHolder.unbind("mousemove").mousemove(onMouseMove);
        }
        if (options.grid.clickable) {
          eventHolder.unbind("click").click(onClick);
        }
      }
    });
    plot.hooks.processDatapoints.push(function (plot, series, data, datapoints) {
      var options = plot.getOptions();
      if (options.series.pie.show) {
        processDatapoints(plot, series, data, datapoints);
      }
    });
    plot.hooks.drawOverlay.push(function (plot, octx) {
      var options = plot.getOptions();
      if (options.series.pie.show) {
        drawOverlay(plot, octx);
      }
    });
    plot.hooks.draw.push(function (plot, newCtx) {
      var options = plot.getOptions();
      if (options.series.pie.show) {
        draw(plot, newCtx);
      }
    });
    function processDatapoints(plot, series, datapoints) {
      if (!processed) {
        processed = true;
        canvas = plot.getCanvas();
        target = $(canvas).parent();
        options = plot.getOptions();
        plot.setData(combine(plot.getData()));
      }
    }
    function combine(data) {
      var total = 0,
        combined = 0,
        numCombined = 0,
        color = options.series.pie.combine.color,
        newdata = [];

      // Fix up the raw data from Flot, ensuring the data is numeric

      for (var i = 0; i < data.length; ++i) {
        var value = data[i].data;

        // If the data is an array, we'll assume that it's a standard
        // Flot x-y pair, and are concerned only with the second value.

        // Note how we use the original array, rather than creating a
        // new one; this is more efficient and preserves any extra data
        // that the user may have stored in higher indexes.

        if ($.isArray(value) && value.length == 1) {
          value = value[0];
        }
        if ($.isArray(value)) {
          // Equivalent to $.isNumeric() but compatible with jQuery < 1.7
          if (!isNaN(parseFloat(value[1])) && isFinite(value[1])) {
            value[1] = +value[1];
          } else {
            value[1] = 0;
          }
        } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
          value = [1, +value];
        } else {
          value = [1, 0];
        }
        data[i].data = [value];
      }

      // Sum up all the slices, so we can calculate percentages for each

      for (var i = 0; i < data.length; ++i) {
        total += data[i].data[0][1];
      }

      // Count the number of slices with percentages below the combine
      // threshold; if it turns out to be just one, we won't combine.

      for (var i = 0; i < data.length; ++i) {
        var value = data[i].data[0][1];
        if (value / total <= options.series.pie.combine.threshold) {
          combined += value;
          numCombined++;
          if (!color) {
            color = data[i].color;
          }
        }
      }
      for (var i = 0; i < data.length; ++i) {
        var value = data[i].data[0][1];
        if (numCombined < 2 || value / total > options.series.pie.combine.threshold) {
          newdata.push($.extend(data[i], {
            /* extend to allow keeping all other original data values
               and using them e.g. in labelFormatter. */
            data: [[1, value]],
            color: data[i].color,
            label: data[i].label,
            angle: value * Math.PI * 2 / total,
            percent: value / (total / 100)
          }));
        }
      }
      if (numCombined > 1) {
        newdata.push({
          data: [[1, combined]],
          color: color,
          label: options.series.pie.combine.label,
          angle: combined * Math.PI * 2 / total,
          percent: combined / (total / 100)
        });
      }
      return newdata;
    }
    function draw(plot, newCtx) {
      if (!target) {
        return; // if no series were passed
      }

      var canvasWidth = plot.getPlaceholder().width(),
        canvasHeight = plot.getPlaceholder().height(),
        legendWidth = target.children().filter(".legend").children().width() || 0;
      ctx = newCtx;

      // WARNING: HACK! REWRITE THIS CODE AS SOON AS POSSIBLE!

      // When combining smaller slices into an 'other' slice, we need to
      // add a new series.  Since Flot gives plugins no way to modify the
      // list of series, the pie plugin uses a hack where the first call
      // to processDatapoints results in a call to setData with the new
      // list of series, then subsequent processDatapoints do nothing.

      // The plugin-global 'processed' flag is used to control this hack;
      // it starts out false, and is set to true after the first call to
      // processDatapoints.

      // Unfortunately this turns future setData calls into no-ops; they
      // call processDatapoints, the flag is true, and nothing happens.

      // To fix this we'll set the flag back to false here in draw, when
      // all series have been processed, so the next sequence of calls to
      // processDatapoints once again starts out with a slice-combine.
      // This is really a hack; in 0.9 we need to give plugins a proper
      // way to modify series before any processing begins.

      processed = false;

      // calculate maximum radius and center point

      maxRadius = Math.min(canvasWidth, canvasHeight / options.series.pie.tilt) / 2;
      centerTop = canvasHeight / 2 + options.series.pie.offset.top;
      centerLeft = canvasWidth / 2;
      if (options.series.pie.offset.left == "auto") {
        if (options.legend.position.match("w")) {
          centerLeft += legendWidth / 2;
        } else {
          centerLeft -= legendWidth / 2;
        }
        if (centerLeft < maxRadius) {
          centerLeft = maxRadius;
        } else if (centerLeft > canvasWidth - maxRadius) {
          centerLeft = canvasWidth - maxRadius;
        }
      } else {
        centerLeft += options.series.pie.offset.left;
      }
      var slices = plot.getData(),
        attempts = 0;

      // Keep shrinking the pie's radius until drawPie returns true,
      // indicating that all the labels fit, or we try too many times.

      do {
        if (attempts > 0) {
          maxRadius *= REDRAW_SHRINK;
        }
        attempts += 1;
        clear();
        if (options.series.pie.tilt <= 0.8) {
          drawShadow();
        }
      } while (!drawPie() && attempts < REDRAW_ATTEMPTS);
      if (attempts >= REDRAW_ATTEMPTS) {
        clear();
        target.prepend("<div class='error'>Could not draw pie with labels contained inside canvas</div>");
      }
      if (plot.setSeries && plot.insertLegend) {
        plot.setSeries(slices);
        plot.insertLegend();
      }

      // we're actually done at this point, just defining internal functions at this point

      function clear() {
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        target.children().filter(".pieLabel, .pieLabelBackground").remove();
      }
      function drawShadow() {
        var shadowLeft = options.series.pie.shadow.left;
        var shadowTop = options.series.pie.shadow.top;
        var edge = 10;
        var alpha = options.series.pie.shadow.alpha;
        var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
        if (radius >= canvasWidth / 2 - shadowLeft || radius * options.series.pie.tilt >= canvasHeight / 2 - shadowTop || radius <= edge) {
          return; // shadow would be outside canvas, so don't draw it
        }

        ctx.save();
        ctx.translate(shadowLeft, shadowTop);
        ctx.globalAlpha = alpha;
        ctx.fillStyle = "#000";

        // center and rotate to starting position

        ctx.translate(centerLeft, centerTop);
        ctx.scale(1, options.series.pie.tilt);

        //radius -= edge;

        for (var i = 1; i <= edge; i++) {
          ctx.beginPath();
          ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
          ctx.fill();
          radius -= i;
        }
        ctx.restore();
      }
      function drawPie() {
        var startAngle = Math.PI * options.series.pie.startAngle;
        var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;

        // center and rotate to starting position

        ctx.save();
        ctx.translate(centerLeft, centerTop);
        ctx.scale(1, options.series.pie.tilt);
        //ctx.rotate(startAngle); // start at top; -- This doesn't work properly in Opera

        // draw slices

        ctx.save();
        var currentAngle = startAngle;
        for (var i = 0; i < slices.length; ++i) {
          slices[i].startAngle = currentAngle;
          drawSlice(slices[i].angle, slices[i].color, true);
        }
        ctx.restore();

        // draw slice outlines

        if (options.series.pie.stroke.width > 0) {
          ctx.save();
          ctx.lineWidth = options.series.pie.stroke.width;
          currentAngle = startAngle;
          for (var i = 0; i < slices.length; ++i) {
            drawSlice(slices[i].angle, options.series.pie.stroke.color, false);
          }
          ctx.restore();
        }

        // draw donut hole

        drawDonutHole(ctx);
        ctx.restore();

        // Draw the labels, returning true if they fit within the plot

        if (options.series.pie.label.show) {
          return drawLabels();
        } else return true;
        function drawSlice(angle, color, fill) {
          if (angle <= 0 || isNaN(angle)) {
            return;
          }
          if (fill) {
            ctx.fillStyle = color;
          } else {
            ctx.strokeStyle = color;
            ctx.lineJoin = "round";
          }
          ctx.beginPath();
          if (Math.abs(angle - Math.PI * 2) > 0.000000001) {
            ctx.moveTo(0, 0); // Center of the pie
          }

          //ctx.arc(0, 0, radius, 0, angle, false); // This doesn't work properly in Opera
          ctx.arc(0, 0, radius, currentAngle, currentAngle + angle / 2, false);
          ctx.arc(0, 0, radius, currentAngle + angle / 2, currentAngle + angle, false);
          ctx.closePath();
          //ctx.rotate(angle); // This doesn't work properly in Opera
          currentAngle += angle;
          if (fill) {
            ctx.fill();
          } else {
            ctx.stroke();
          }
        }
        function drawLabels() {
          var currentAngle = startAngle;
          var radius = options.series.pie.label.radius > 1 ? options.series.pie.label.radius : maxRadius * options.series.pie.label.radius;
          for (var i = 0; i < slices.length; ++i) {
            if (slices[i].percent >= options.series.pie.label.threshold * 100) {
              if (!drawLabel(slices[i], currentAngle, i)) {
                return false;
              }
            }
            currentAngle += slices[i].angle;
          }
          return true;
          function drawLabel(slice, startAngle, index) {
            if (slice.data[0][1] == 0) {
              return true;
            }

            // format label text

            var lf = options.legend.labelFormatter,
              text,
              plf = options.series.pie.label.formatter;
            if (lf) {
              text = lf(slice.label, slice);
            } else {
              text = slice.label;
            }
            if (plf) {
              text = plf(text, slice);
            }
            var halfAngle = (startAngle + slice.angle + startAngle) / 2;
            var x = centerLeft + Math.round(Math.cos(halfAngle) * radius);
            var y = centerTop + Math.round(Math.sin(halfAngle) * radius) * options.series.pie.tilt;
            var html = "<span class='pieLabel' id='pieLabel" + index + "' style='position:absolute;top:" + y + "px;left:" + x + "px;'>" + text + "</span>";
            target.append(html);
            var label = target.children("#pieLabel" + index);
            var labelTop = y - label.height() / 2;
            var labelLeft = x - label.width() / 2;
            label.css("top", labelTop);
            label.css("left", labelLeft);

            // check to make sure that the label is not outside the canvas

            if (0 - labelTop > 0 || 0 - labelLeft > 0 || canvasHeight - (labelTop + label.height()) < 0 || canvasWidth - (labelLeft + label.width()) < 0) {
              return false;
            }
            if (options.series.pie.label.background.opacity != 0) {
              // put in the transparent background separately to avoid blended labels and label boxes

              var c = options.series.pie.label.background.color;
              if (c == null) {
                c = slice.color;
              }
              var pos = "top:" + labelTop + "px;left:" + labelLeft + "px;";
              $("<div class='pieLabelBackground' style='position:absolute;width:" + label.width() + "px;height:" + label.height() + "px;" + pos + "background-color:" + c + ";'></div>").css("opacity", options.series.pie.label.background.opacity).insertBefore(label);
            }
            return true;
          } // end individual label function
        } // end drawLabels function
      } // end drawPie function
    } // end draw function

    // Placed here because it needs to be accessed from multiple locations

    function drawDonutHole(layer) {
      if (options.series.pie.innerRadius > 0) {
        // subtract the center

        layer.save();
        var innerRadius = options.series.pie.innerRadius > 1 ? options.series.pie.innerRadius : maxRadius * options.series.pie.innerRadius;
        layer.globalCompositeOperation = "destination-out"; // this does not work with excanvas, but it will fall back to using the stroke color
        layer.beginPath();
        layer.fillStyle = options.series.pie.stroke.color;
        layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
        layer.fill();
        layer.closePath();
        layer.restore();

        // add inner stroke

        layer.save();
        layer.beginPath();
        layer.strokeStyle = options.series.pie.stroke.color;
        layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
        layer.stroke();
        layer.closePath();
        layer.restore();

        // TODO: add extra shadow inside hole (with a mask) if the pie is tilted.
      }
    }

    //-- Additional Interactive related functions --

    function isPointInPoly(poly, pt) {
      for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i) (poly[i][1] <= pt[1] && pt[1] < poly[j][1] || poly[j][1] <= pt[1] && pt[1] < poly[i][1]) && pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0] && (c = !c);
      return c;
    }
    function findNearbySlice(mouseX, mouseY) {
      var slices = plot.getData(),
        options = plot.getOptions(),
        radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
        x,
        y;
      for (var i = 0; i < slices.length; ++i) {
        var s = slices[i];
        if (s.pie.show) {
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(0, 0); // Center of the pie
          //ctx.scale(1, options.series.pie.tilt);	// this actually seems to break everything when here.
          ctx.arc(0, 0, radius, s.startAngle, s.startAngle + s.angle / 2, false);
          ctx.arc(0, 0, radius, s.startAngle + s.angle / 2, s.startAngle + s.angle, false);
          ctx.closePath();
          x = mouseX - centerLeft;
          y = mouseY - centerTop;
          if (ctx.isPointInPath) {
            if (ctx.isPointInPath(mouseX - centerLeft, mouseY - centerTop)) {
              ctx.restore();
              return {
                datapoint: [s.percent, s.data],
                dataIndex: 0,
                series: s,
                seriesIndex: i
              };
            }
          } else {
            // excanvas for IE doesn;t support isPointInPath, this is a workaround.

            var p1X = radius * Math.cos(s.startAngle),
              p1Y = radius * Math.sin(s.startAngle),
              p2X = radius * Math.cos(s.startAngle + s.angle / 4),
              p2Y = radius * Math.sin(s.startAngle + s.angle / 4),
              p3X = radius * Math.cos(s.startAngle + s.angle / 2),
              p3Y = radius * Math.sin(s.startAngle + s.angle / 2),
              p4X = radius * Math.cos(s.startAngle + s.angle / 1.5),
              p4Y = radius * Math.sin(s.startAngle + s.angle / 1.5),
              p5X = radius * Math.cos(s.startAngle + s.angle),
              p5Y = radius * Math.sin(s.startAngle + s.angle),
              arrPoly = [[0, 0], [p1X, p1Y], [p2X, p2Y], [p3X, p3Y], [p4X, p4Y], [p5X, p5Y]],
              arrPoint = [x, y];

            // TODO: perhaps do some mathmatical trickery here with the Y-coordinate to compensate for pie tilt?

            if (isPointInPoly(arrPoly, arrPoint)) {
              ctx.restore();
              return {
                datapoint: [s.percent, s.data],
                dataIndex: 0,
                series: s,
                seriesIndex: i
              };
            }
          }
          ctx.restore();
        }
      }
      return null;
    }
    function onMouseMove(e) {
      triggerClickHoverEvent("plothover", e);
    }
    function onClick(e) {
      triggerClickHoverEvent("plotclick", e);
    }

    // trigger click or hover event (they send the same parameters so we share their code)

    function triggerClickHoverEvent(eventname, e) {
      var offset = plot.offset();
      var canvasX = parseInt(e.pageX - offset.left);
      var canvasY = parseInt(e.pageY - offset.top);
      var item = findNearbySlice(canvasX, canvasY);
      if (options.grid.autoHighlight) {
        // clear auto-highlights

        for (var i = 0; i < highlights.length; ++i) {
          var h = highlights[i];
          if (h.auto == eventname && !(item && h.series == item.series)) {
            unhighlight(h.series);
          }
        }
      }

      // highlight the slice

      if (item) {
        highlight(item.series, eventname);
      }

      // trigger any hover bind events

      var pos = {
        pageX: e.pageX,
        pageY: e.pageY
      };
      target.trigger(eventname, [pos, item]);
    }
    function highlight(s, auto) {
      //if (typeof s == "number") {
      //	s = series[s];
      //}

      var i = indexOfHighlight(s);
      if (i == -1) {
        highlights.push({
          series: s,
          auto: auto
        });
        plot.triggerRedrawOverlay();
      } else if (!auto) {
        highlights[i].auto = false;
      }
    }
    function unhighlight(s) {
      if (s == null) {
        highlights = [];
        plot.triggerRedrawOverlay();
      }

      //if (typeof s == "number") {
      //	s = series[s];
      //}

      var i = indexOfHighlight(s);
      if (i != -1) {
        highlights.splice(i, 1);
        plot.triggerRedrawOverlay();
      }
    }
    function indexOfHighlight(s) {
      for (var i = 0; i < highlights.length; ++i) {
        var h = highlights[i];
        if (h.series == s) return i;
      }
      return -1;
    }
    function drawOverlay(plot, octx) {
      var options = plot.getOptions();
      var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
      octx.save();
      octx.translate(centerLeft, centerTop);
      octx.scale(1, options.series.pie.tilt);
      for (var i = 0; i < highlights.length; ++i) {
        drawHighlight(highlights[i].series);
      }
      drawDonutHole(octx);
      octx.restore();
      function drawHighlight(series) {
        if (series.angle <= 0 || isNaN(series.angle)) {
          return;
        }

        //octx.fillStyle = parseColor(options.series.pie.highlight.color).scale(null, null, null, options.series.pie.highlight.opacity).toString();
        octx.fillStyle = "rgba(255, 255, 255, " + options.series.pie.highlight.opacity + ")"; // this is temporary until we have access to parseColor
        octx.beginPath();
        if (Math.abs(series.angle - Math.PI * 2) > 0.000000001) {
          octx.moveTo(0, 0); // Center of the pie
        }

        octx.arc(0, 0, radius, series.startAngle, series.startAngle + series.angle / 2, false);
        octx.arc(0, 0, radius, series.startAngle + series.angle / 2, series.startAngle + series.angle, false);
        octx.closePath();
        octx.fill();
      }
    }
  } // end init (plugin body)

  // define pie specific options and their default values

  var options = {
    series: {
      pie: {
        show: false,
        radius: "auto",
        // actual radius of the visible pie (based on full calculated radius if <=1, or hard pixel value)
        innerRadius: 0,
        /* for donut */
        startAngle: 3 / 2,
        tilt: 1,
        shadow: {
          left: 5,
          // shadow left offset
          top: 15,
          // shadow top offset
          alpha: 0.02 // shadow alpha
        },

        offset: {
          top: 0,
          left: "auto"
        },
        stroke: {
          color: "#fff",
          width: 1
        },
        label: {
          show: "auto",
          formatter: function (label, slice) {
            return "<div style='font-size:x-small;text-align:center;padding:2px;color:" + slice.color + ";'>" + label + "<br/>" + Math.round(slice.percent) + "%</div>";
          },
          // formatter function
          radius: 1,
          // radius at which to place the labels (based on full calculated radius if <=1, or hard pixel value)
          background: {
            color: null,
            opacity: 0
          },
          threshold: 0 // percentage at which to hide the label (i.e. the slice is too narrow)
        },

        combine: {
          threshold: -1,
          // percentage at which to combine little slices into one larger slice
          color: null,
          // color to give the new slice (auto-generated if null)
          label: "Other" // label to give the new slice
        },

        highlight: {
          //color: "#fff",		// will add this functionality once parseColor is available
          opacity: 0.5
        }
      }
    }
  };
  $.plot.plugins.push({
    init: init,
    options: options,
    name: "pie",
    version: "1.1"
  });
})(jQuery);
/*

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/
(function (e) {
  if ("object" == typeof exports && "undefined" != typeof module && "undefined" == typeof DO_NOT_EXPORT_JSZIP) module.exports = e();else if ("function" == typeof define && define.amd && "undefined" == typeof DO_NOT_EXPORT_JSZIP) {
    JSZipSync = e();
    define('j', [], e);
  } else {
    var f;
    "undefined" != typeof globalThis ? f = globalThis : "undefined" != typeof window ? f = window : "undefined" != typeof global ? f = global : "undefined" != typeof $ && $.global ? f = $.global : "undefined" != typeof self && (f = self), f.JSZipSync = e();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          throw new Error("Cannot find module '" + o + "'");
        }
        var f = n[o] = {
          exports: {}
        };
        t[o][0].call(f.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, f, f.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  }({
    1: [function (_dereq_, module, exports) {
      'use strict';

      // private property
      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

      // public method for encoding
      exports.encode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = (chr1 & 3) << 4 | chr2 >> 4;
          enc3 = (chr2 & 15) << 2 | chr3 >> 6;
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
      };

      // public method for decoding
      exports.decode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = enc1 << 2 | enc2 >> 4;
          chr2 = (enc2 & 15) << 4 | enc3 >> 2;
          chr3 = (enc3 & 3) << 6 | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        return output;
      };
    }, {}],
    2: [function (_dereq_, module, exports) {
      'use strict';

      function CompressedObject() {
        this.compressedSize = 0;
        this.uncompressedSize = 0;
        this.crc32 = 0;
        this.compressionMethod = null;
        this.compressedContent = null;
      }
      CompressedObject.prototype = {
        /**
         * Return the decompressed content in an unspecified format.
         * The format will depend on the decompressor.
         * @return {Object} the decompressed content.
         */
        getContent: function () {
          return null; // see implementation
        },

        /**
         * Return the compressed content in an unspecified format.
         * The format will depend on the compressed conten source.
         * @return {Object} the compressed content.
         */
        getCompressedContent: function () {
          return null; // see implementation
        }
      };

      module.exports = CompressedObject;
    }, {}],
    3: [function (_dereq_, module, exports) {
      'use strict';

      exports.STORE = {
        magic: "\x00\x00",
        compress: function (content) {
          return content; // no compression
        },

        uncompress: function (content) {
          return content; // no compression
        },

        compressInputType: null,
        uncompressInputType: null
      };
      exports.DEFLATE = _dereq_('./flate');
    }, {
      "./flate": 8
    }],
    4: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');
      var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];

      /**
       *
       *  Javascript crc32
       *  http://www.webtoolkit.info/
       *
       */
      module.exports = function crc32(input, crc) {
        if (typeof input === "undefined" || !input.length) {
          return 0;
        }
        var isArray = utils.getTypeOf(input) !== "string";
        if (typeof crc == "undefined") {
          crc = 0;
        }
        var x = 0;
        var y = 0;
        var b = 0;
        crc = crc ^ -1;
        for (var i = 0, iTop = input.length; i < iTop; i++) {
          b = isArray ? input[i] : input.charCodeAt(i);
          y = (crc ^ b) & 0xFF;
          x = table[y];
          crc = crc >>> 8 ^ x;
        }
        return crc ^ -1;
      };
      // vim: set shiftwidth=4 softtabstop=4:
    }, {
      "./utils": 21
    }],
    5: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');
      function DataReader(data) {
        this.data = null; // type : see implementation
        this.length = 0;
        this.index = 0;
      }
      DataReader.prototype = {
        /**
         * Check that the offset will not go too far.
         * @param {string} offset the additional offset to check.
         * @throws {Error} an Error if the offset is out of bounds.
         */
        checkOffset: function (offset) {
          this.checkIndex(this.index + offset);
        },
        /**
         * Check that the specifed index will not be too far.
         * @param {string} newIndex the index to check.
         * @throws {Error} an Error if the index is out of bounds.
         */
        checkIndex: function (newIndex) {
          if (this.length < newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
          }
        },
        /**
         * Change the index.
         * @param {number} newIndex The new index.
         * @throws {Error} if the new index is out of the data.
         */
        setIndex: function (newIndex) {
          this.checkIndex(newIndex);
          this.index = newIndex;
        },
        /**
         * Skip the next n bytes.
         * @param {number} n the number of bytes to skip.
         * @throws {Error} if the new index is out of the data.
         */
        skip: function (n) {
          this.setIndex(this.index + n);
        },
        /**
         * Get the byte at the specified index.
         * @param {number} i the index to use.
         * @return {number} a byte.
         */
        byteAt: function (i) {
          // see implementations
        },
        /**
         * Get the next number with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {number} the corresponding number.
         */
        readInt: function (size) {
          var result = 0,
            i;
          this.checkOffset(size);
          for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
          }
          this.index += size;
          return result;
        },
        /**
         * Get the next string with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {string} the corresponding string.
         */
        readString: function (size) {
          return utils.transformTo("string", this.readData(size));
        },
        /**
         * Get raw data without conversion, <size> bytes.
         * @param {number} size the number of bytes to read.
         * @return {Object} the raw data, implementation specific.
         */
        readData: function (size) {
          // see implementations
        },
        /**
         * Find the last occurrence of a zip signature (4 bytes).
         * @param {string} sig the signature to find.
         * @return {number} the index of the last occurrence, -1 if not found.
         */
        lastIndexOfSignature: function (sig) {
          // see implementations
        },
        /**
         * Get the next date.
         * @return {Date} the date.
         */
        readDate: function () {
          var dostime = this.readInt(4);
          return new Date((dostime >> 25 & 0x7f) + 1980,
          // year
          (dostime >> 21 & 0x0f) - 1,
          // month
          dostime >> 16 & 0x1f,
          // day
          dostime >> 11 & 0x1f,
          // hour
          dostime >> 5 & 0x3f,
          // minute
          (dostime & 0x1f) << 1); // second
        }
      };

      module.exports = DataReader;
    }, {
      "./utils": 21
    }],
    6: [function (_dereq_, module, exports) {
      'use strict';

      exports.base64 = false;
      exports.binary = false;
      exports.dir = false;
      exports.createFolders = false;
      exports.date = null;
      exports.compression = null;
      exports.comment = null;
    }, {}],
    7: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2binary = function (str) {
        return utils.string2binary(str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2Uint8Array = function (str) {
        return utils.transformTo("uint8array", str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.uint8Array2String = function (array) {
        return utils.transformTo("string", array);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2Blob = function (str) {
        var buffer = utils.transformTo("arraybuffer", str);
        return utils.arrayBuffer2Blob(buffer);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.arrayBuffer2Blob = function (buffer) {
        return utils.arrayBuffer2Blob(buffer);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.transformTo = function (outputType, input) {
        return utils.transformTo(outputType, input);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.getTypeOf = function (input) {
        return utils.getTypeOf(input);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.checkSupport = function (type) {
        return utils.checkSupport(type);
      };

      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */
      exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */
      exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.pretty = function (str) {
        return utils.pretty(str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.findCompression = function (compressionMethod) {
        return utils.findCompression(compressionMethod);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.isRegExp = function (object) {
        return utils.isRegExp(object);
      };
    }, {
      "./utils": 21
    }],
    8: [function (_dereq_, module, exports) {
      'use strict';

      var USE_TYPEDARRAY = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Uint32Array !== 'undefined';
      var pako = _dereq_("pako");
      exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.magic = "\x08\x00";
      exports.compress = function (input) {
        return pako.deflateRaw(input);
      };
      exports.uncompress = function (input) {
        return pako.inflateRaw(input);
      };
    }, {
      "pako": 24
    }],
    9: [function (_dereq_, module, exports) {
      'use strict';

      var base64 = _dereq_('./base64');

      /**
      Usage:
         zip = new JSZip();
         zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
         zip.folder("images").file("smile.gif", base64Data, {base64: true});
         zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
         zip.remove("tempfile");
      
         base64zip = zip.generate();
      
      **/

      /**
       * Representation a of zip file in js
       * @constructor
       * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
       * @param {Object=} options the options for creating this objects (optional).
       */
      function JSZipSync(data, options) {
        // if this constructor is used without `new`, it adds `new` before itself:
        if (!(this instanceof JSZipSync)) return new JSZipSync(data, options);

        // object containing the files :
        // {
        //   "folder/" : {...},
        //   "folder/data.txt" : {...}
        // }
        this.files = {};
        this.comment = null;

        // Where we are in the hierarchy
        this.root = "";
        if (data) {
          this.load(data, options);
        }
        this.clone = function () {
          var newObj = new JSZipSync();
          for (var i in this) {
            if (typeof this[i] !== "function") {
              newObj[i] = this[i];
            }
          }
          return newObj;
        };
      }
      JSZipSync.prototype = _dereq_('./object');
      JSZipSync.prototype.load = _dereq_('./load');
      JSZipSync.support = _dereq_('./support');
      JSZipSync.defaults = _dereq_('./defaults');

      /**
       * @deprecated
       * This namespace will be removed in a future version without replacement.
       */
      JSZipSync.utils = _dereq_('./deprecatedPublicUtils');
      JSZipSync.base64 = {
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        encode: function (input) {
          return base64.encode(input);
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        decode: function (input) {
          return base64.decode(input);
        }
      };
      JSZipSync.compressions = _dereq_('./compressions');
      module.exports = JSZipSync;
    }, {
      "./base64": 1,
      "./compressions": 3,
      "./defaults": 6,
      "./deprecatedPublicUtils": 7,
      "./load": 10,
      "./object": 13,
      "./support": 17
    }],
    10: [function (_dereq_, module, exports) {
      'use strict';

      var base64 = _dereq_('./base64');
      var ZipEntries = _dereq_('./zipEntries');
      module.exports = function (data, options) {
        var files, zipEntries, i, input;
        options = options || {};
        if (options.base64) {
          data = base64.decode(data);
        }
        zipEntries = new ZipEntries(data, options);
        files = zipEntries.files;
        for (i = 0; i < files.length; i++) {
          input = files[i];
          this.file(input.fileName, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment: input.fileComment.length ? input.fileComment : null,
            createFolders: options.createFolders
          });
        }
        if (zipEntries.zipComment.length) {
          this.comment = zipEntries.zipComment;
        }
        return this;
      };
    }, {
      "./base64": 1,
      "./zipEntries": 22
    }],
    11: [function (_dereq_, module, exports) {
      (function (Buffer) {
        'use strict';

        var Buffer_from = /*::(*/function () {} /*:: :any)*/;
        if (typeof Buffer !== 'undefined') {
          var nbfs = !Buffer.from;
          if (!nbfs) try {
            Buffer.from("foo", "utf8");
          } catch (e) {
            nbfs = true;
          }
          Buffer_from = nbfs ? function (buf, enc) {
            return enc ? new Buffer(buf, enc) : new Buffer(buf);
          } : Buffer.from.bind(Buffer);
          // $FlowIgnore
          if (!Buffer.alloc) Buffer.alloc = function (n) {
            return new Buffer(n);
          };
        }
        module.exports = function (data, encoding) {
          return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
        };
        module.exports.test = function (b) {
          return Buffer.isBuffer(b);
        };
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    12: [function (_dereq_, module, exports) {
      'use strict';

      var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
      function NodeBufferReader(data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
      }
      NodeBufferReader.prototype = new Uint8ArrayReader();

      /**
       * @see DataReader.readData
       */
      NodeBufferReader.prototype.readData = function (size) {
        this.checkOffset(size);
        var result = this.data.slice(this.index, this.index + size);
        this.index += size;
        return result;
      };
      module.exports = NodeBufferReader;
    }, {
      "./uint8ArrayReader": 18
    }],
    13: [function (_dereq_, module, exports) {
      'use strict';

      var support = _dereq_('./support');
      var utils = _dereq_('./utils');
      var crc32 = _dereq_('./crc32');
      var signature = _dereq_('./signature');
      var defaults = _dereq_('./defaults');
      var base64 = _dereq_('./base64');
      var compressions = _dereq_('./compressions');
      var CompressedObject = _dereq_('./compressedObject');
      var nodeBuffer = _dereq_('./nodeBuffer');
      var utf8 = _dereq_('./utf8');
      var StringWriter = _dereq_('./stringWriter');
      var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');

      /**
       * Returns the raw data of a ZipObject, decompress the content if necessary.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */
      var getRawData = function (file) {
        if (file._data instanceof CompressedObject) {
          file._data = file._data.getContent();
          file.options.binary = true;
          file.options.base64 = false;
          if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data;
            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
            file._data = new Uint8Array(copy.length);
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            if (copy.length !== 0) {
              file._data.set(copy, 0);
            }
          }
        }
        return file._data;
      };

      /**
       * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */
      var getBinaryData = function (file) {
        var result = getRawData(file),
          type = utils.getTypeOf(result);
        if (type === "string") {
          if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
              return nodeBuffer(result, "utf-8");
            }
          }
          return file.asBinary();
        }
        return result;
      };

      /**
       * Transform this._data into a string.
       * @param {function} filter a function String -> String, applied if not null on the result.
       * @return {String} the string representing this._data.
       */
      var dataToString = function (asUTF8) {
        var result = getRawData(this);
        if (result === null || typeof result === "undefined") {
          return "";
        }
        // if the data is a base64 string, we decode it before checking the encoding !
        if (this.options.base64) {
          result = base64.decode(result);
        }
        if (asUTF8 && this.options.binary) {
          // JSZip.prototype.utf8decode supports arrays as input
          // skip to array => string step, utf8decode will do it.
          result = out.utf8decode(result);
        } else {
          // no utf8 transformation, do the array => string step.
          result = utils.transformTo("string", result);
        }
        if (!asUTF8 && !this.options.binary) {
          result = utils.transformTo("string", out.utf8encode(result));
        }
        return result;
      };
      /**
       * A simple object representing a file in the zip file.
       * @constructor
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
       * @param {Object} options the options of the file
       */
      var ZipObject = function (name, data, options) {
        this.name = name;
        this.dir = options.dir;
        this.date = options.date;
        this.comment = options.comment;
        this._data = data;
        this.options = options;

        /*
         * This object contains initial values for dir and date.
         * With them, we can check if the user changed the deprecated metadata in
         * `ZipObject#options` or not.
         */
        this._initialMetadata = {
          dir: options.dir,
          date: options.date
        };
      };
      ZipObject.prototype = {
        /**
         * Return the content as UTF8 string.
         * @return {string} the UTF8 string.
         */
        asText: function () {
          return dataToString.call(this, true);
        },
        /**
         * Returns the binary content.
         * @return {string} the content as binary.
         */
        asBinary: function () {
          return dataToString.call(this, false);
        },
        /**
         * Returns the content as a nodejs Buffer.
         * @return {Buffer} the content as a Buffer.
         */
        asNodeBuffer: function () {
          var result = getBinaryData(this);
          return utils.transformTo("nodebuffer", result);
        },
        /**
         * Returns the content as an Uint8Array.
         * @return {Uint8Array} the content as an Uint8Array.
         */
        asUint8Array: function () {
          var result = getBinaryData(this);
          return utils.transformTo("uint8array", result);
        },
        /**
         * Returns the content as an ArrayBuffer.
         * @return {ArrayBuffer} the content as an ArrayBufer.
         */
        asArrayBuffer: function () {
          return this.asUint8Array().buffer;
        }
      };

      /**
       * Transform an integer into a string in hexadecimal.
       * @private
       * @param {number} dec the number to convert.
       * @param {number} bytes the number of bytes to generate.
       * @returns {string} the result.
       */
      var decToHex = function (dec, bytes) {
        var hex = "",
          i;
        for (i = 0; i < bytes; i++) {
          hex += String.fromCharCode(dec & 0xff);
          dec = dec >>> 8;
        }
        return hex;
      };

      /**
       * Merge the objects passed as parameters into a new one.
       * @private
       * @param {...Object} var_args All objects to merge.
       * @return {Object} a new object with the data of the others.
       */
      var extend = function () {
        var result = {},
          i,
          attr;
        for (i = 0; i < arguments.length; i++) {
          // arguments is not enumerable in some browsers
          for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
              result[attr] = arguments[i][attr];
            }
          }
        }
        return result;
      };

      /**
       * Transforms the (incomplete) options from the user into the complete
       * set of options to create a file.
       * @private
       * @param {Object} o the options from the user.
       * @return {Object} the complete set of options.
       */
      var prepareFileAttrs = function (o) {
        o = o || {};
        if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
          o.binary = true;
        }
        o = extend(o, defaults);
        o.date = o.date || new Date();
        if (o.compression !== null) o.compression = o.compression.toUpperCase();
        return o;
      };

      /**
       * Add a file in the current folder.
       * @private
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
       * @param {Object} o the options of the file
       * @return {Object} the new file.
       */
      var fileAdd = function (name, data, o) {
        // be sure sub folders exist
        var dataType = utils.getTypeOf(data),
          parent;
        o = prepareFileAttrs(o);
        if (o.createFolders && (parent = parentFolder(name))) {
          folderAdd.call(this, parent, true);
        }
        if (o.dir || data === null || typeof data === "undefined") {
          o.base64 = false;
          o.binary = false;
          data = null;
        } else if (dataType === "string") {
          if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
              // this is a string, not in a base64 format.
              // Be sure that this is a correct "binary string"
              data = utils.string2binary(data);
            }
          }
        } else {
          // arraybuffer, uint8array, ...
          o.base64 = false;
          o.binary = true;
          if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
          }

          // special case : it's way easier to work with Uint8Array than with ArrayBuffer
          if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
          }
        }
        var object = new ZipObject(name, data, o);
        this.files[name] = object;
        return object;
      };

      /**
       * Find the parent folder of the path.
       * @private
       * @param {string} path the path to use
       * @return {string} the parent folder, or ""
       */
      var parentFolder = function (path) {
        if (path.slice(-1) == '/') {
          path = path.substring(0, path.length - 1);
        }
        var lastSlash = path.lastIndexOf('/');
        return lastSlash > 0 ? path.substring(0, lastSlash) : "";
      };

      /**
       * Add a (sub) folder in the current folder.
       * @private
       * @param {string} name the folder's name
       * @param {boolean=} [createFolders] If true, automatically create sub
       *  folders. Defaults to false.
       * @return {Object} the new folder.
       */
      var folderAdd = function (name, createFolders) {
        // Check the name ends with a /
        if (name.slice(-1) != "/") {
          name += "/"; // IE doesn't like substr(-1)
        }

        createFolders = typeof createFolders !== 'undefined' ? createFolders : false;

        // Does this folder already exist?
        if (!this.files[name]) {
          fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
          });
        }
        return this.files[name];
      };

      /**
       * Generate a JSZip.CompressedObject for a given zipOject.
       * @param {ZipObject} file the object to read.
       * @param {JSZip.compression} compression the compression to use.
       * @return {JSZip.CompressedObject} the compressed result.
       */
      var generateCompressedObjectFrom = function (file, compression) {
        var result = new CompressedObject(),
          content;

        // the data has not been decompressed, we might reuse things !
        if (file._data instanceof CompressedObject) {
          result.uncompressedSize = file._data.uncompressedSize;
          result.crc32 = file._data.crc32;
          if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
          } else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
          } else {
            content = file._data.getContent();
            // need to decompress / recompress
            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
          }
        } else {
          // have uncompressed data
          content = getBinaryData(file);
          if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
          }
          result.uncompressedSize = content.length;
          result.crc32 = crc32(content);
          result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
        }
        result.compressedSize = result.compressedContent.length;
        result.compressionMethod = compression.magic;
        return result;
      };

      /**
       * Generate the various parts used in the construction of the final zip file.
       * @param {string} name the file name.
       * @param {ZipObject} file the file content.
       * @param {JSZip.CompressedObject} compressedObject the compressed object.
       * @param {number} offset the current offset from the start of the zip file.
       * @return {object} the zip parts.
       */
      var generateZipParts = function (name, file, compressedObject, offset) {
        var data = compressedObject.compressedContent,
          utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
          comment = file.comment || "",
          utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
          useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
          useUTF8ForComment = utfEncodedComment.length !== comment.length,
          o = file.options,
          dosTime,
          dosDate,
          extraFields = "",
          unicodePathExtraField = "",
          unicodeCommentExtraField = "",
          dir,
          date;

        // handle the deprecated options.dir
        if (file._initialMetadata.dir !== file.dir) {
          dir = file.dir;
        } else {
          dir = o.dir;
        }

        // handle the deprecated options.date
        if (file._initialMetadata.date !== file.date) {
          date = file.date;
        } else {
          date = o.date;
        }
        dosTime = date.getHours();
        dosTime = dosTime << 6;
        dosTime = dosTime | date.getMinutes();
        dosTime = dosTime << 5;
        dosTime = dosTime | date.getSeconds() / 2;
        dosDate = date.getFullYear() - 1980;
        dosDate = dosDate << 4;
        dosDate = dosDate | date.getMonth() + 1;
        dosDate = dosDate << 5;
        dosDate = dosDate | date.getDate();
        if (useUTF8ForFileName) {
          // set the unicode path extra field. unzip needs at least one extra
          // field to correctly handle unicode path, so using the path is as good
          // as any other information. This could improve the situation with
          // other archive managers too.
          // This field is usually used without the utf8 flag, with a non
          // unicode path in the header (winrar, winzip). This helps (a bit)
          // with the messy Windows' default compressed folders feature but
          // breaks on p7zip which doesn't seek the unicode path extra field.
          // So for now, UTF-8 everywhere !
          unicodePathExtraField =
          // Version
          decToHex(1, 1) +
          // NameCRC32
          decToHex(crc32(utfEncodedFileName), 4) +
          // UnicodeName
          utfEncodedFileName;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x70" +
          // size
          decToHex(unicodePathExtraField.length, 2) +
          // content
          unicodePathExtraField;
        }
        if (useUTF8ForComment) {
          unicodeCommentExtraField =
          // Version
          decToHex(1, 1) +
          // CommentCRC32
          decToHex(this.crc32(utfEncodedComment), 4) +
          // UnicodeName
          utfEncodedComment;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x63" +
          // size
          decToHex(unicodeCommentExtraField.length, 2) +
          // content
          unicodeCommentExtraField;
        }
        var header = "";

        // version needed to extract
        header += "\x0A\x00";
        // general purpose bit flag
        // set bit 11 if utf8
        header += useUTF8ForFileName || useUTF8ForComment ? "\x00\x08" : "\x00\x00";
        // compression method
        header += compressedObject.compressionMethod;
        // last mod file time
        header += decToHex(dosTime, 2);
        // last mod file date
        header += decToHex(dosDate, 2);
        // crc-32
        header += decToHex(compressedObject.crc32, 4);
        // compressed size
        header += decToHex(compressedObject.compressedSize, 4);
        // uncompressed size
        header += decToHex(compressedObject.uncompressedSize, 4);
        // file name length
        header += decToHex(utfEncodedFileName.length, 2);
        // extra field length
        header += decToHex(extraFields.length, 2);
        var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
        var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        "\x14\x00" +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(utfEncodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" + (
        // external file attributes
        dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        utfEncodedFileName +
        // extra field
        extraFields +
        // file comment
        utfEncodedComment;
        return {
          fileRecord: fileRecord,
          dirRecord: dirRecord,
          compressedObject: compressedObject
        };
      };

      // return the actual prototype of JSZip
      var out = {
        /**
         * Read an existing zip and merge the data in the current JSZip object.
         * The implementation is in jszip-load.js, don't forget to include it.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
         * @param {Object} options Options for loading the stream.
         *  options.base64 : is the stream in base64 ? default : false
         * @return {JSZip} the current JSZip object
         */
        load: function (stream, options) {
          throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
        },
        /**
         * Filter nested files/folders with the specified function.
         * @param {Function} search the predicate to use :
         * function (relativePath, file) {...}
         * It takes 2 arguments : the relative path and the file.
         * @return {Array} An array of matching elements.
         */
        filter: function (search) {
          var result = [],
            filename,
            relativePath,
            file,
            fileClone;
          for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
              continue;
            }
            file = this.files[filename];
            // return a new object, don't let the user mess with our internal objects :)
            fileClone = new ZipObject(file.name, file._data, extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);
            if (filename.slice(0, this.root.length) === this.root &&
            // the file is in the current root
            search(relativePath, fileClone)) {
              // and the file matches the function
              result.push(fileClone);
            }
          }
          return result;
        },
        /**
         * Add a file to the zip file, or search a file.
         * @param   {string|RegExp} name The name of the file to add (if data is defined),
         * the name of the file to find (if no data) or a regex to match files.
         * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
         * @param   {Object} o     File options
         * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
         * a file (when searching by string) or an array of files (when searching by regex).
         */
        file: function (name, data, o) {
          if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
              var regexp = name;
              return this.filter(function (relativePath, file) {
                return !file.dir && regexp.test(relativePath);
              });
            } else {
              // text
              return this.filter(function (relativePath, file) {
                return !file.dir && relativePath === name;
              })[0] || null;
            }
          } else {
            // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
          }
          return this;
        },
        /**
         * Add a directory to the zip file, or search.
         * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
         * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
         */
        folder: function (arg) {
          if (!arg) {
            return this;
          }
          if (utils.isRegExp(arg)) {
            return this.filter(function (relativePath, file) {
              return file.dir && arg.test(relativePath);
            });
          }

          // else, name is a new folder
          var name = this.root + arg;
          var newFolder = folderAdd.call(this, name);

          // Allow chaining by returning a new object with this folder as the root
          var ret = this.clone();
          ret.root = newFolder.name;
          return ret;
        },
        /**
         * Delete a file, or a directory and all sub-files, from the zip
         * @param {string} name the name of the file to delete
         * @return {JSZip} this JSZip object
         */
        remove: function (name) {
          name = this.root + name;
          var file = this.files[name];
          if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
              name += "/";
            }
            file = this.files[name];
          }
          if (file && !file.dir) {
            // file
            delete this.files[name];
          } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function (relativePath, file) {
              return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
              delete this.files[kids[i].name];
            }
          }
          return this;
        },
        /**
         * Generate the complete zip file
         * @param {Object} options the options to generate the zip file :
         * - base64, (deprecated, use type instead) true to generate base64.
         * - compression, "STORE" by default.
         * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
         * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
         */
        generate: function (options) {
          options = extend(options || {}, {
            base64: true,
            compression: "STORE",
            type: "base64",
            comment: null
          });
          utils.checkSupport(options.type);
          var zipData = [],
            localDirLength = 0,
            centralDirLength = 0,
            writer,
            i,
            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));

          // first, generate all the zip parts.
          for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
              continue;
            }
            var file = this.files[name];
            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];
            if (!compression) {
              throw new Error(compressionName + " is not a valid compression method !");
            }
            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
          }
          var dirEnd = "";

          // end of central dir signature
          dirEnd = signature.CENTRAL_DIRECTORY_END +
          // number of this disk
          "\x00\x00" +
          // number of the disk with the start of the central directory
          "\x00\x00" +
          // total number of entries in the central directory on this disk
          decToHex(zipData.length, 2) +
          // total number of entries in the central directory
          decToHex(zipData.length, 2) +
          // size of the central directory   4 bytes
          decToHex(centralDirLength, 4) +
          // offset of start of central directory with respect to the starting disk number
          decToHex(localDirLength, 4) +
          // .ZIP file comment length
          decToHex(utfEncodedComment.length, 2) +
          // .ZIP file comment
          utfEncodedComment;

          // we have all the parts (and the total length)
          // time to create a writer !
          var typeName = options.type.toLowerCase();
          if (typeName === "uint8array" || typeName === "arraybuffer" || typeName === "blob" || typeName === "nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
          } else {
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
          }
          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
          }
          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
          }
          writer.append(dirEnd);
          var zip = writer.finalize();
          switch (options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array":
            case "arraybuffer":
            case "nodebuffer":
              return utils.transformTo(options.type.toLowerCase(), zip);
            case "blob":
              return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
            // case "zip is a string"
            case "base64":
              return options.base64 ? base64.encode(zip) : zip;
            default:
              // case "string" :
              return zip;
          }
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        crc32: function (input, crc) {
          return crc32(input, crc);
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8encode: function (string) {
          return utils.transformTo("string", utf8.utf8encode(string));
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8decode: function (input) {
          return utf8.utf8decode(input);
        }
      };
      module.exports = out;
    }, {
      "./base64": 1,
      "./compressedObject": 2,
      "./compressions": 3,
      "./crc32": 4,
      "./defaults": 6,
      "./nodeBuffer": 11,
      "./signature": 14,
      "./stringWriter": 16,
      "./support": 17,
      "./uint8ArrayWriter": 19,
      "./utf8": 20,
      "./utils": 21
    }],
    14: [function (_dereq_, module, exports) {
      'use strict';

      exports.LOCAL_FILE_HEADER = "PK\x03\x04";
      exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
      exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
      exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
      exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
      exports.DATA_DESCRIPTOR = "PK\x07\x08";
    }, {}],
    15: [function (_dereq_, module, exports) {
      'use strict';

      var DataReader = _dereq_('./dataReader');
      var utils = _dereq_('./utils');
      function StringReader(data, optimizedBinaryString) {
        this.data = data;
        if (!optimizedBinaryString) {
          this.data = utils.string2binary(this.data);
        }
        this.length = this.data.length;
        this.index = 0;
      }
      StringReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */
      StringReader.prototype.byteAt = function (i) {
        return this.data.charCodeAt(i);
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      StringReader.prototype.lastIndexOfSignature = function (sig) {
        return this.data.lastIndexOf(sig);
      };
      /**
       * @see DataReader.readData
       */
      StringReader.prototype.readData = function (size) {
        this.checkOffset(size);
        // this will work because the constructor applied the "& 0xff" mask.
        var result = this.data.slice(this.index, this.index + size);
        this.index += size;
        return result;
      };
      module.exports = StringReader;
    }, {
      "./dataReader": 5,
      "./utils": 21
    }],
    16: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');

      /**
       * An object to write any content to a string.
       * @constructor
       */
      var StringWriter = function () {
        this.data = [];
      };
      StringWriter.prototype = {
        /**
         * Append any content to the current string.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          input = utils.transformTo("string", input);
          this.data.push(input);
        },
        /**
         * Finalize the construction an return the result.
         * @return {string} the generated string.
         */
        finalize: function () {
          return this.data.join("");
        }
      };
      module.exports = StringWriter;
    }, {
      "./utils": 21
    }],
    17: [function (_dereq_, module, exports) {
      (function (Buffer) {
        'use strict';

        exports.base64 = true;
        exports.array = true;
        exports.string = true;
        exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
        // contains true if JSZip can read/generate nodejs Buffer, false otherwise.
        // Browserify will provide a Buffer implementation for browsers, which is
        // an augmented Uint8Array (i.e., can be used as either Buffer or U8).
        exports.nodebuffer = typeof Buffer !== "undefined";
        // contains true if JSZip can read/generate Uint8Array, false otherwise.
        exports.uint8array = typeof Uint8Array !== "undefined";
        if (typeof ArrayBuffer === "undefined") {
          exports.blob = false;
        } else {
          var buffer = new ArrayBuffer(0);
          try {
            exports.blob = new Blob([buffer], {
              type: "application/zip"
            }).size === 0;
          } catch (e) {
            try {
              var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
              var builder = new Builder();
              builder.append(buffer);
              exports.blob = builder.getBlob('application/zip').size === 0;
            } catch (e) {
              exports.blob = false;
            }
          }
        }
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    18: [function (_dereq_, module, exports) {
      'use strict';

      var DataReader = _dereq_('./dataReader');
      function Uint8ArrayReader(data) {
        if (data) {
          this.data = data;
          this.length = this.data.length;
          this.index = 0;
        }
      }
      Uint8ArrayReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */
      Uint8ArrayReader.prototype.byteAt = function (i) {
        return this.data[i];
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      Uint8ArrayReader.prototype.lastIndexOfSignature = function (sig) {
        var sig0 = sig.charCodeAt(0),
          sig1 = sig.charCodeAt(1),
          sig2 = sig.charCodeAt(2),
          sig3 = sig.charCodeAt(3);
        for (var i = this.length - 4; i >= 0; --i) {
          if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i;
          }
        }
        return -1;
      };
      /**
       * @see DataReader.readData
       */
      Uint8ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);
        if (size === 0) {
          // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
          return new Uint8Array(0);
        }
        var result = this.data.subarray(this.index, this.index + size);
        this.index += size;
        return result;
      };
      module.exports = Uint8ArrayReader;
    }, {
      "./dataReader": 5
    }],
    19: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');

      /**
       * An object to write any content to an Uint8Array.
       * @constructor
       * @param {number} length The length of the array.
       */
      var Uint8ArrayWriter = function (length) {
        this.data = new Uint8Array(length);
        this.index = 0;
      };
      Uint8ArrayWriter.prototype = {
        /**
         * Append any content to the current array.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
          }
        },
        /**
         * Finalize the construction an return the result.
         * @return {Uint8Array} the generated array.
         */
        finalize: function () {
          return this.data;
        }
      };
      module.exports = Uint8ArrayWriter;
    }, {
      "./utils": 21
    }],
    20: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('./utils');
      var support = _dereq_('./support');
      var nodeBuffer = _dereq_('./nodeBuffer');

      /**
       * The following functions come from pako, from pako/lib/utils/strings
       * released under the MIT license, see pako https://github.com/nodeca/pako/
       */

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new Array(256);
      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      var string2buf = function (str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        if (support.uint8array) {
          buf = new Uint8Array(buf_len);
        } else {
          buf = new Array(buf_len);
        }

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      var utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };

      // convert array to string
      var buf2string = function (buf) {
        var str, i, out, c, c_len;
        var len = buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }

        // shrinkBuf(utf16buf, out)
        if (utf16buf.length !== out) {
          if (utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
          } else {
            utf16buf.length = out;
          }
        }

        // return String.fromCharCode.apply(null, utf16buf);
        return utils.applyFromCharCode(utf16buf);
      };

      // That's all for the pako functions.

      /**
       * Transform a javascript string into an array (typed if possible) of bytes,
       * UTF-8 encoded.
       * @param {String} str the string to encode
       * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
       */
      exports.utf8encode = function utf8encode(str) {
        if (support.nodebuffer) {
          return nodeBuffer(str, "utf-8");
        }
        return string2buf(str);
      };

      /**
       * Transform a bytes array (or a representation) representing an UTF-8 encoded
       * string into a javascript string.
       * @param {Array|Uint8Array|Buffer} buf the data de decode
       * @return {String} the decoded string.
       */
      exports.utf8decode = function utf8decode(buf) {
        if (support.nodebuffer) {
          return utils.transformTo("nodebuffer", buf).toString("utf-8");
        }
        buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

        // return buf2string(buf);
        // Chrome prefers to work with "small" chunks of data
        // for the method buf2string.
        // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
        var result = [],
          k = 0,
          len = buf.length,
          chunk = 65536;
        while (k < len) {
          var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
          if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
          } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
          }
          k = nextBoundary;
        }
        return result.join("");
      };
      // vim: set shiftwidth=4 softtabstop=4:
    }, {
      "./nodeBuffer": 11,
      "./support": 17,
      "./utils": 21
    }],
    21: [function (_dereq_, module, exports) {
      'use strict';

      var support = _dereq_('./support');
      var compressions = _dereq_('./compressions');
      var nodeBuffer = _dereq_('./nodeBuffer');
      /**
       * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
       * @param {string} str the string to transform.
       * @return {String} the binary string.
       */
      exports.string2binary = function (str) {
        var result = "";
        for (var i = 0; i < str.length; i++) {
          result += String.fromCharCode(str.charCodeAt(i) & 0xff);
        }
        return result;
      };
      exports.arrayBuffer2Blob = function (buffer) {
        exports.checkSupport("blob");
        try {
          // Blob constructor
          return new Blob([buffer], {
            type: "application/zip"
          });
        } catch (e) {
          try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob('application/zip');
          } catch (e) {
            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      /**
       * The identity function.
       * @param {Object} input the input.
       * @return {Object} the same input.
       */
      function identity(input) {
        return input;
      }

      /**
       * Fill in an array with a string.
       * @param {String} str the string to use.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
       */
      function stringToArrayLike(str, array) {
        for (var i = 0; i < str.length; ++i) {
          array[i] = str.charCodeAt(i) & 0xFF;
        }
        return array;
      }

      /**
       * Transform an array-like object to a string.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
       * @return {String} the result.
       */
      function arrayLikeToString(array) {
        // Performances notes :
        // --------------------
        // String.fromCharCode.apply(null, array) is the fastest, see
        // see http://jsperf.com/converting-a-uint8array-to-a-string/2
        // but the stack is limited (and we can get huge arrays !).
        //
        // result += String.fromCharCode(array[i]); generate too many strings !
        //
        // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
        var chunk = 65536;
        var result = [],
          len = array.length,
          type = exports.getTypeOf(array),
          k = 0,
          canUseApply = true;
        try {
          switch (type) {
            case "uint8array":
              String.fromCharCode.apply(null, new Uint8Array(0));
              break;
            case "nodebuffer":
              String.fromCharCode.apply(null, nodeBuffer(0));
              break;
          }
        } catch (e) {
          canUseApply = false;
        }

        // no apply : slow and painful algorithm
        // default browser on android 4.*
        if (!canUseApply) {
          var resultStr = "";
          for (var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
          }
          return resultStr;
        }
        while (k < len && chunk > 1) {
          try {
            if (type === "array" || type === "nodebuffer") {
              result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            } else {
              result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
          } catch (e) {
            chunk = Math.floor(chunk / 2);
          }
        }
        return result.join("");
      }
      exports.applyFromCharCode = arrayLikeToString;

      /**
       * Copy the data from an array-like to an other array-like.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
       */
      function arrayLikeToArrayLike(arrayFrom, arrayTo) {
        for (var i = 0; i < arrayFrom.length; i++) {
          arrayTo[i] = arrayFrom[i];
        }
        return arrayTo;
      }

      // a matrix containing functions to transform everything into everything.
      var transform = {};

      // string to ?
      transform["string"] = {
        "string": identity,
        "array": function (input) {
          return stringToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["string"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return stringToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": function (input) {
          return stringToArrayLike(input, nodeBuffer(input.length));
        }
      };

      // array to ?
      transform["array"] = {
        "string": arrayLikeToString,
        "array": identity,
        "arraybuffer": function (input) {
          return new Uint8Array(input).buffer;
        },
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      };

      // arraybuffer to ?
      transform["arraybuffer"] = {
        "string": function (input) {
          return arrayLikeToString(new Uint8Array(input));
        },
        "array": function (input) {
          return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
        },
        "arraybuffer": identity,
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(new Uint8Array(input));
        }
      };

      // uint8array to ?
      transform["uint8array"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return input.buffer;
        },
        "uint8array": identity,
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      };

      // nodebuffer to ?
      transform["nodebuffer"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["nodebuffer"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return arrayLikeToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": identity
      };

      /**
       * Transform an input into any type.
       * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
       * If no output type is specified, the unmodified input will be returned.
       * @param {String} outputType the output type.
       * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
       * @throws {Error} an Error if the browser doesn't support the requested output type.
       */
      exports.transformTo = function (outputType, input) {
        if (!input) {
          // undefined, null, etc
          // an empty string won't harm.
          input = "";
        }
        if (!outputType) {
          return input;
        }
        exports.checkSupport(outputType);
        var inputType = exports.getTypeOf(input);
        var result = transform[inputType][outputType](input);
        return result;
      };

      /**
       * Return the type of the input.
       * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
       * @param {Object} input the input to identify.
       * @return {String} the (lowercase) type of the input.
       */
      exports.getTypeOf = function (input) {
        if (typeof input === "string") {
          return "string";
        }
        if (Object.prototype.toString.call(input) === "[object Array]") {
          return "array";
        }
        if (support.nodebuffer && nodeBuffer.test(input)) {
          return "nodebuffer";
        }
        if (support.uint8array && input instanceof Uint8Array) {
          return "uint8array";
        }
        if (support.arraybuffer && input instanceof ArrayBuffer) {
          return "arraybuffer";
        }
      };

      /**
       * Throw an exception if the type is not supported.
       * @param {String} type the type to check.
       * @throws {Error} an Error if the browser doesn't support the requested type.
       */
      exports.checkSupport = function (type) {
        var supported = support[type.toLowerCase()];
        if (!supported) {
          throw new Error(type + " is not supported by this browser");
        }
      };
      exports.MAX_VALUE_16BITS = 65535;
      exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

      /**
       * Prettify a string read as binary.
       * @param {string} str the string to prettify.
       * @return {string} a pretty string.
       */
      exports.pretty = function (str) {
        var res = '',
          code,
          i;
        for (i = 0; i < (str || "").length; i++) {
          code = str.charCodeAt(i);
          res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
        }
        return res;
      };

      /**
       * Find a compression registered in JSZip.
       * @param {string} compressionMethod the method magic to find.
       * @return {Object|null} the JSZip compression object, null if none found.
       */
      exports.findCompression = function (compressionMethod) {
        for (var method in compressions) {
          if (!compressions.hasOwnProperty(method)) {
            continue;
          }
          if (compressions[method].magic === compressionMethod) {
            return compressions[method];
          }
        }
        return null;
      };
      /**
      * Cross-window, cross-Node-context regular expression detection
      * @param  {Object}  object Anything
      * @return {Boolean}        true if the object is a regular expression,
      * false otherwise
      */
      exports.isRegExp = function (object) {
        return Object.prototype.toString.call(object) === "[object RegExp]";
      };
    }, {
      "./compressions": 3,
      "./nodeBuffer": 11,
      "./support": 17
    }],
    22: [function (_dereq_, module, exports) {
      'use strict';

      var StringReader = _dereq_('./stringReader');
      var NodeBufferReader = _dereq_('./nodeBufferReader');
      var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
      var utils = _dereq_('./utils');
      var sig = _dereq_('./signature');
      var ZipEntry = _dereq_('./zipEntry');
      var support = _dereq_('./support');
      var jszipProto = _dereq_('./object');
      //  class ZipEntries {{{
      /**
       * All the entries in the zip file.
       * @constructor
       * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntries(data, loadOptions) {
        this.files = [];
        this.loadOptions = loadOptions;
        if (data) {
          this.load(data);
        }
      }
      ZipEntries.prototype = {
        /**
         * Check that the reader is on the speficied signature.
         * @param {string} expectedSignature the expected signature.
         * @throws {Error} if it is an other signature.
         */
        checkSignature: function (expectedSignature) {
          var signature = this.reader.readString(4);
          if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
          }
        },
        /**
         * Read the end of the central directory.
         */
        readBlockEndOfCentral: function () {
          this.diskNumber = this.reader.readInt(2);
          this.diskWithCentralDirStart = this.reader.readInt(2);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
          this.centralDirRecords = this.reader.readInt(2);
          this.centralDirSize = this.reader.readInt(4);
          this.centralDirOffset = this.reader.readInt(4);
          this.zipCommentLength = this.reader.readInt(2);
          // warning : the encoding depends of the system locale
          // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
          // On a windows machine, this field is encoded with the localized windows code page.
          this.zipComment = this.reader.readString(this.zipCommentLength);
          // To get consistent behavior with the generation part, we will assume that
          // this is utf8 encoded.
          this.zipComment = jszipProto.utf8decode(this.zipComment);
        },
        /**
         * Read the end of the Zip 64 central directory.
         * Not merged with the method readEndOfCentral :
         * The end of central can coexist with its Zip64 brother,
         * I don't want to read the wrong number of bytes !
         */
        readBlockZip64EndOfCentral: function () {
          this.zip64EndOfCentralSize = this.reader.readInt(8);
          this.versionMadeBy = this.reader.readString(2);
          this.versionNeeded = this.reader.readInt(2);
          this.diskNumber = this.reader.readInt(4);
          this.diskWithCentralDirStart = this.reader.readInt(4);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
          this.centralDirRecords = this.reader.readInt(8);
          this.centralDirSize = this.reader.readInt(8);
          this.centralDirOffset = this.reader.readInt(8);
          this.zip64ExtensibleData = {};
          var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },
        /**
         * Read the end of the Zip 64 central directory locator.
         */
        readBlockZip64EndOfCentralLocator: function () {
          this.diskWithZip64CentralDirStart = this.reader.readInt(4);
          this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
          this.disksCount = this.reader.readInt(4);
          if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
          }
        },
        /**
         * Read the local files, based on the offset read in the central part.
         */
        readLocalFiles: function () {
          var i, file;
          for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
          }
        },
        /**
         * Read the central directory.
         */
        readCentralDir: function () {
          var file;
          this.reader.setIndex(this.centralDirOffset);
          while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
              zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
          }
        },
        /**
         * Read the end of central directory.
         */
        readEndOfCentral: function () {
          var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
          if (offset === -1) {
            throw new Error("Corrupted zip : can't find end of central directory");
          }
          this.reader.setIndex(offset);
          this.checkSignature(sig.CENTRAL_DIRECTORY_END);
          this.readBlockEndOfCentral();

          /* extract from the zip spec :
              4)  If one of the fields in the end of central directory
                  record is too small to hold required data, the field
                  should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                  ZIP64 format record should be created.
              5)  The end of central directory record and the
                  Zip64 end of central directory locator record must
                  reside on the same disk when splitting or spanning
                  an archive.
           */
          if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset === -1) {
              throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
          }
        },
        prepareReader: function (data) {
          var type = utils.getTypeOf(data);
          if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
          } else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
          } else {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
          }
        },
        /**
         * Read a zip file and create ZipEntries.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
         */
        load: function (data) {
          this.prepareReader(data);
          this.readEndOfCentral();
          this.readCentralDir();
          this.readLocalFiles();
        }
      };
      // }}} end of ZipEntries
      module.exports = ZipEntries;
    }, {
      "./nodeBufferReader": 12,
      "./object": 13,
      "./signature": 14,
      "./stringReader": 15,
      "./support": 17,
      "./uint8ArrayReader": 18,
      "./utils": 21,
      "./zipEntry": 23
    }],
    23: [function (_dereq_, module, exports) {
      'use strict';

      var StringReader = _dereq_('./stringReader');
      var utils = _dereq_('./utils');
      var CompressedObject = _dereq_('./compressedObject');
      var jszipProto = _dereq_('./object');
      // class ZipEntry {{{
      /**
       * An entry in the zip file.
       * @constructor
       * @param {Object} options Options of the current file.
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntry(options, loadOptions) {
        this.options = options;
        this.loadOptions = loadOptions;
      }
      ZipEntry.prototype = {
        /**
         * say if the file is encrypted.
         * @return {boolean} true if the file is encrypted, false otherwise.
         */
        isEncrypted: function () {
          // bit 1 is set
          return (this.bitFlag & 0x0001) === 0x0001;
        },
        /**
         * say if the file has utf-8 filename/comment.
         * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
         */
        useUTF8: function () {
          // bit 11 is set
          return (this.bitFlag & 0x0800) === 0x0800;
        },
        /**
         * Prepare the function used to generate the compressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
         */
        prepareCompressedContent: function (reader, from, length) {
          return function () {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);
            return compressedFileData;
          };
        },
        /**
         * Prepare the function used to generate the uncompressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @param {JSZip.compression} compression the compression used on this file.
         * @param {number} uncompressedSize the uncompressed size to expect.
         * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
         */
        prepareContent: function (reader, from, length, compression, uncompressedSize) {
          return function () {
            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);
            if (uncompressedFileData.length !== uncompressedSize) {
              throw new Error("Bug : uncompressed data size mismatch");
            }
            return uncompressedFileData;
          };
        },
        /**
         * Read the local part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readLocalPart: function (reader) {
          var compression, localExtraFieldsLength;

          // we already know everything from the central dir !
          // If the central dir data are false, we are doomed.
          // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
          // The less data we get here, the more reliable this should be.
          // Let's skip the whole header and dash to the data !
          reader.skip(22);
          // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
          // Strangely, the filename here is OK.
          // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
          // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
          // Search "unzip mismatching "local" filename continuing with "central" filename version" on
          // the internet.
          //
          // I think I see the logic here : the central directory is used to display
          // content and the local directory is used to extract the files. Mixing / and \
          // may be used to display \ to windows users and use / when extracting the files.
          // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
          this.fileNameLength = reader.readInt(2);
          localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
          this.fileName = reader.readString(this.fileNameLength);
          reader.skip(localExtraFieldsLength);
          if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
          }
          compression = utils.findCompression(this.compressionMethod);
          if (compression === null) {
            // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
          }
          this.decompressed = new CompressedObject();
          this.decompressed.compressedSize = this.compressedSize;
          this.decompressed.uncompressedSize = this.uncompressedSize;
          this.decompressed.crc32 = this.crc32;
          this.decompressed.compressionMethod = this.compressionMethod;
          this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
          this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

          // we need to compute the crc32...
          if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
              throw new Error("Corrupted zip : CRC32 mismatch");
            }
          }
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readCentralPart: function (reader) {
          this.versionMadeBy = reader.readString(2);
          this.versionNeeded = reader.readInt(2);
          this.bitFlag = reader.readInt(2);
          this.compressionMethod = reader.readString(2);
          this.date = reader.readDate();
          this.crc32 = reader.readInt(4);
          this.compressedSize = reader.readInt(4);
          this.uncompressedSize = reader.readInt(4);
          this.fileNameLength = reader.readInt(2);
          this.extraFieldsLength = reader.readInt(2);
          this.fileCommentLength = reader.readInt(2);
          this.diskNumberStart = reader.readInt(2);
          this.internalFileAttributes = reader.readInt(2);
          this.externalFileAttributes = reader.readInt(4);
          this.localHeaderOffset = reader.readInt(4);
          if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
          }
          this.fileName = reader.readString(this.fileNameLength);
          this.readExtraFields(reader);
          this.parseZIP64ExtraField(reader);
          this.fileComment = reader.readString(this.fileCommentLength);

          // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
          this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
        },
        /**
         * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
         * @param {DataReader} reader the reader to use.
         */
        parseZIP64ExtraField: function (reader) {
          if (!this.extraFields[0x0001]) {
            return;
          }

          // should be something, preparing the extra reader
          var extraReader = new StringReader(this.extraFields[0x0001].value);

          // I really hope that these 64bits integer can fit in 32 bits integer, because js
          // won't let us have more.
          if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
          }
          if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
          }
          if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
          }
          if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
          }
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readExtraFields: function (reader) {
          var start = reader.index,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          this.extraFields = this.extraFields || {};
          while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);
            this.extraFields[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },
        /**
         * Apply an UTF8 transformation if needed.
         */
        handleUTF8: function () {
          if (this.useUTF8()) {
            this.fileName = jszipProto.utf8decode(this.fileName);
            this.fileComment = jszipProto.utf8decode(this.fileComment);
          } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
              this.fileName = upath;
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
              this.fileComment = ucomment;
            }
          }
        },
        /**
         * Find the unicode path declared in the extra field, if any.
         * @return {String} the unicode path, null otherwise.
         */
        findExtraFieldUnicodePath: function () {
          var upathField = this.extraFields[0x7075];
          if (upathField) {
            var extraReader = new StringReader(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
              return null;
            }
            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
          }
          return null;
        },
        /**
         * Find the unicode comment declared in the extra field, if any.
         * @return {String} the unicode comment, null otherwise.
         */
        findExtraFieldUnicodeComment: function () {
          var ucommentField = this.extraFields[0x6375];
          if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
              return null;
            }
            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
          }
          return null;
        }
      };
      module.exports = ZipEntry;
    }, {
      "./compressedObject": 2,
      "./object": 13,
      "./stringReader": 15,
      "./utils": 21
    }],
    24: [function (_dereq_, module, exports) {
      // Top level file is just a mixin of submodules & constants
      'use strict';

      var assign = _dereq_('./lib/utils/common').assign;
      var deflate = _dereq_('./lib/deflate');
      var inflate = _dereq_('./lib/inflate');
      var constants = _dereq_('./lib/zlib/constants');
      var pako = {};
      assign(pako, deflate, inflate, constants);
      module.exports = pako;
    }, {
      "./lib/deflate": 25,
      "./lib/inflate": 26,
      "./lib/utils/common": 27,
      "./lib/zlib/constants": 30
    }],
    25: [function (_dereq_, module, exports) {
      'use strict';

      var zlib_deflate = _dereq_('./zlib/deflate.js');
      var utils = _dereq_('./utils/common');
      var strings = _dereq_('./utils/strings');
      var msg = _dereq_('./zlib/messages');
      var zstream = _dereq_('./zlib/zstream');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      var Z_NO_FLUSH = 0;
      var Z_FINISH = 4;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_DEFLATED = 8;

      /* ===========================================================================*/

      /**
       * class Deflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[deflate]],
       * [[deflateRaw]] and [[gzip]].
       **/

      /* internal
       * Deflate.chunks -> Array
       *
       * Chunks of output data, if [[Deflate#onData]] not overriden.
       **/

      /**
       * Deflate.result -> Uint8Array|Array
       *
       * Compressed result, generated by default [[Deflate#onData]]
       * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
       **/

      /**
       * Deflate.err -> Number
       *
       * Error code after deflate finished. 0 (Z_OK) on success.
       * You will not need it in real life, because deflate errors
       * are possible only on wrong options or bad `onData` / `onEnd`
       * custom handlers.
       **/

      /**
       * Deflate.msg -> String
       *
       * Error message, if [[Deflate.err]] != 0
       **/

      /**
       * new Deflate(options)
       * - options (Object): zlib deflate options.
       *
       * Creates new deflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `level`
       * - `windowBits`
       * - `memLevel`
       * - `strategy`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw deflate
       * - `gzip` (Boolean) - create gzip wrapper
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       * - `header` (Object) - custom header for gzip
       *   - `text` (Boolean) - true if compressed data believed to be text
       *   - `time` (Number) - modification time, unix timestamp
       *   - `os` (Number) - operation system code
       *   - `extra` (Array) - array of bytes with extra data (max 65536)
       *   - `name` (String) - file name (binary string)
       *   - `comment` (String) - comment (binary string)
       *   - `hcrc` (Boolean) - true if header crc should be added
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var deflate = new pako.Deflate({ level: 3});
       *
       * deflate.push(chunk1, false);
       * deflate.push(chunk2, true);  // true -> last chunk
       *
       * if (deflate.err) { throw new Error(deflate.err); }
       *
       * console.log(deflate.result);
       * ```
       **/
      var Deflate = function (options) {
        this.options = utils.assign({
          level: Z_DEFAULT_COMPRESSION,
          method: Z_DEFLATED,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: Z_DEFAULT_STRATEGY,
          to: ''
        }, options || {});
        var opt = this.options;
        if (opt.raw && opt.windowBits > 0) {
          opt.windowBits = -opt.windowBits;
        } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
          opt.windowBits += 16;
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new zstream();
        this.strm.avail_out = 0;
        var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
        if (status !== Z_OK) {
          throw new Error(msg[status]);
        }
        if (opt.header) {
          zlib_deflate.deflateSetHeader(this.strm, opt.header);
        }
      };

      /**
       * Deflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|String): input data. Strings will be converted to
       *   utf8 byte sequence.
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
       * new compressed chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That flush internal pending buffers and call
       * [[Deflate#onEnd]].
       *
       * On fail call [[Deflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * array format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Deflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var status, _mode;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // If we need to compress text, change encoding to utf8.
          strm.input = strings.string2buf(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_deflate.deflate(strm, _mode); /* no bad return value */

          if (status !== Z_STREAM_END && status !== Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.avail_out === 0 || strm.avail_in === 0 && _mode === Z_FINISH) {
            if (this.options.to === 'string') {
              this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
            } else {
              this.onData(utils.shrinkBuf(strm.output, strm.next_out));
            }
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

        // Finalize on the last chunk.
        if (_mode === Z_FINISH) {
          status = zlib_deflate.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK;
        }
        return true;
      };

      /**
       * Deflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Deflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Deflate#onEnd(status) -> Void
       * - status (Number): deflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell deflate that input stream complete
       * or error happenned. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Deflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === Z_OK) {
          if (this.options.to === 'string') {
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * deflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * Compress `data` with deflate alrorythm and `options`.
       *
       * Supported options are:
       *
       * - level
       * - windowBits
       * - memLevel
       * - strategy
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
       *
       * console.log(pako.deflate(data));
       * ```
       **/
      function deflate(input, options) {
        var deflator = new Deflate(options);
        deflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (deflator.err) {
          throw deflator.msg;
        }
        return deflator.result;
      }

      /**
       * deflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function deflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return deflate(input, options);
      }

      /**
       * gzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but create gzip wrapper instead of
       * deflate one.
       **/
      function gzip(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate(input, options);
      }
      exports.Deflate = Deflate;
      exports.deflate = deflate;
      exports.deflateRaw = deflateRaw;
      exports.gzip = gzip;
    }, {
      "./utils/common": 27,
      "./utils/strings": 28,
      "./zlib/deflate.js": 32,
      "./zlib/messages": 37,
      "./zlib/zstream": 39
    }],
    26: [function (_dereq_, module, exports) {
      'use strict';

      var zlib_inflate = _dereq_('./zlib/inflate.js');
      var utils = _dereq_('./utils/common');
      var strings = _dereq_('./utils/strings');
      var c = _dereq_('./zlib/constants');
      var msg = _dereq_('./zlib/messages');
      var zstream = _dereq_('./zlib/zstream');
      var gzheader = _dereq_('./zlib/gzheader');

      /**
       * class Inflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[inflate]]
       * and [[inflateRaw]].
       **/

      /* internal
       * inflate.chunks -> Array
       *
       * Chunks of output data, if [[Inflate#onData]] not overriden.
       **/

      /**
       * Inflate.result -> Uint8Array|Array|String
       *
       * Uncompressed result, generated by default [[Inflate#onData]]
       * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
       **/

      /**
       * Inflate.err -> Number
       *
       * Error code after inflate finished. 0 (Z_OK) on success.
       * Should be checked if broken data possible.
       **/

      /**
       * Inflate.msg -> String
       *
       * Error message, if [[Inflate.err]] != 0
       **/

      /**
       * new Inflate(options)
       * - options (Object): zlib inflate options.
       *
       * Creates new inflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `windowBits`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw inflate
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       * By default, when no options set, autodetect deflate/gzip data format via
       * wrapper header.
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var inflate = new pako.Inflate({ level: 3});
       *
       * inflate.push(chunk1, false);
       * inflate.push(chunk2, true);  // true -> last chunk
       *
       * if (inflate.err) { throw new Error(inflate.err); }
       *
       * console.log(inflate.result);
       * ```
       **/
      var Inflate = function (options) {
        this.options = utils.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ''
        }, options || {});
        var opt = this.options;

        // Force window size for `raw` data, if not set directly,
        // because we have no header for autodetect.
        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;
          if (opt.windowBits === 0) {
            opt.windowBits = -15;
          }
        }

        // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
        if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
          opt.windowBits += 32;
        }

        // Gzip header has no info about windows size, we can do autodetect only
        // for deflate. So, if window size not set, force it to max when gzip possible
        if (opt.windowBits > 15 && opt.windowBits < 48) {
          // bit 3 (16) -> gzipped data
          // bit 4 (32) -> autodetect gzip/deflate
          if ((opt.windowBits & 15) === 0) {
            opt.windowBits |= 15;
          }
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new zstream();
        this.strm.avail_out = 0;
        var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
        if (status !== c.Z_OK) {
          throw new Error(msg[status]);
        }
        this.header = new gzheader();
        zlib_inflate.inflateGetHeader(this.strm, this.header);
      };

      /**
       * Inflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|String): input data
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
       * new output chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That flush internal pending buffers and call
       * [[Inflate#onEnd]].
       *
       * On fail call [[Inflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Inflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var status, _mode;
        var next_out_utf8, tail, utf8str;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // Only binary strings can be decompressed on practice
          strm.input = strings.binstring2buf(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH); /* no bad return value */

          if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.next_out) {
            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && _mode === c.Z_FINISH) {
              if (this.options.to === 'string') {
                next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                tail = strm.next_out - next_out_utf8;
                utf8str = strings.buf2string(strm.output, next_out_utf8);

                // move tail
                strm.next_out = tail;
                strm.avail_out = chunkSize - tail;
                if (tail) {
                  utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                }
                this.onData(utf8str);
              } else {
                this.onData(utils.shrinkBuf(strm.output, strm.next_out));
              }
            }
          }
        } while (strm.avail_in > 0 && status !== c.Z_STREAM_END);
        if (status === c.Z_STREAM_END) {
          _mode = c.Z_FINISH;
        }
        // Finalize on the last chunk.
        if (_mode === c.Z_FINISH) {
          status = zlib_inflate.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === c.Z_OK;
        }
        return true;
      };

      /**
       * Inflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Inflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Inflate#onEnd(status) -> Void
       * - status (Number): inflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell inflate that input stream complete
       * or error happenned. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Inflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === c.Z_OK) {
          if (this.options.to === 'string') {
            // Glue & convert here, until we teach pako to send
            // utf8 alligned strings to onData
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * inflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Decompress `data` with inflate/ungzip and `options`. Autodetect
       * format via wrapper header by default. That's why we don't provide
       * separate `ungzip` method.
       *
       * Supported options are:
       *
       * - windowBits
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
       *   , output;
       *
       * try {
       *   output = pako.inflate(input);
       * } catch (err)
       *   console.log(err);
       * }
       * ```
       **/
      function inflate(input, options) {
        var inflator = new Inflate(options);
        inflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (inflator.err) {
          throw inflator.msg;
        }
        return inflator.result;
      }

      /**
       * inflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * The same as [[inflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function inflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return inflate(input, options);
      }

      /**
       * ungzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Just shortcut to [[inflate]], because it autodetects format
       * by header.content. Done for convenience.
       **/

      exports.Inflate = Inflate;
      exports.inflate = inflate;
      exports.inflateRaw = inflateRaw;
      exports.ungzip = inflate;
    }, {
      "./utils/common": 27,
      "./utils/strings": 28,
      "./zlib/constants": 30,
      "./zlib/gzheader": 33,
      "./zlib/inflate.js": 35,
      "./zlib/messages": 37,
      "./zlib/zstream": 39
    }],
    27: [function (_dereq_, module, exports) {
      'use strict';

      var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
      exports.assign = function (obj /*from1, from2, from3, ...*/) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while (sources.length) {
          var source = sources.shift();
          if (!source) {
            continue;
          }
          if (typeof source !== 'object') {
            throw new TypeError(source + 'must be non-object');
          }
          for (var p in source) {
            if (source.hasOwnProperty(p)) {
              obj[p] = source[p];
            }
          }
        }
        return obj;
      };

      // reduce buffer size, avoiding mem copy
      exports.shrinkBuf = function (buf, size) {
        if (buf.length === size) {
          return buf;
        }
        if (buf.subarray) {
          return buf.subarray(0, size);
        }
        buf.length = size;
        return buf;
      };
      var fnTyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
          }
          // Fallback to ordinary array
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          var i, l, len, pos, chunk, result;

          // calculate data length
          len = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            len += chunks[i].length;
          }

          // join chunks
          result = new Uint8Array(len);
          pos = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
          }
          return result;
        }
      };
      var fnUntyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          return [].concat.apply([], chunks);
        }
      };

      // Enable/Disable typed arrays use, for testing
      //
      exports.setTyped = function (on) {
        if (on) {
          exports.Buf8 = Uint8Array;
          exports.Buf16 = Uint16Array;
          exports.Buf32 = Int32Array;
          exports.assign(exports, fnTyped);
        } else {
          exports.Buf8 = Array;
          exports.Buf16 = Array;
          exports.Buf32 = Array;
          exports.assign(exports, fnUntyped);
        }
      };
      exports.setTyped(TYPED_OK);
    }, {}],
    28: [function (_dereq_, module, exports) {
      // String encode/decode helpers
      'use strict';

      var utils = _dereq_('./common');

      // Quick check if we can use fast array to bin string conversion
      //
      // - apply(Array) can fail on Android 2.2
      // - apply(Uint8Array) can fail on iOS 5.1 Safary
      //
      var STR_APPLY_OK = true;
      var STR_APPLY_UIA_OK = true;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch (__) {
        STR_APPLY_OK = false;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (__) {
        STR_APPLY_UIA_OK = false;
      }

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new utils.Buf8(256);
      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      exports.string2buf = function (str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        buf = new utils.Buf8(buf_len);

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Helper (used in 2 places)
      function buf2binstring(buf, len) {
        // use fallback for big arrays to avoid stack overflow
        if (len < 65537) {
          if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
            return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
          }
        }
        var result = '';
        for (var i = 0; i < len; i++) {
          result += String.fromCharCode(buf[i]);
        }
        return result;
      }

      // Convert byte array to binary string
      exports.buf2binstring = function (buf) {
        return buf2binstring(buf, buf.length);
      };

      // Convert binary string (typed, when possible)
      exports.binstring2buf = function (str) {
        var buf = new utils.Buf8(str.length);
        for (var i = 0, len = buf.length; i < len; i++) {
          buf[i] = str.charCodeAt(i);
        }
        return buf;
      };

      // convert array to string
      exports.buf2string = function (buf, max) {
        var i, out, c, c_len;
        var len = max || buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }
        return buf2binstring(utf16buf, out);
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      exports.utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };
    }, {
      "./common": 27
    }],
    29: [function (_dereq_, module, exports) {
      'use strict';

      // Note: adler32 takes 12% for level 0 and 2% for level 6.
      // It doesn't worth to make additional optimizationa as in original.
      // Small size is preferable.
      function adler32(adler, buf, len, pos) {
        var s1 = adler & 0xffff | 0,
          s2 = adler >>> 16 & 0xffff | 0,
          n = 0;
        while (len !== 0) {
          // Set limit ~ twice less than 5552, to keep
          // s2 in 31-bits, because we force signed ints.
          // in other case %= will fail.
          n = len > 2000 ? 2000 : len;
          len -= n;
          do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
          } while (--n);
          s1 %= 65521;
          s2 %= 65521;
        }
        return s1 | s2 << 16 | 0;
      }
      module.exports = adler32;
    }, {}],
    30: [function (_dereq_, module, exports) {
      module.exports = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        /* Return codes for the compression/decompression functions. Negative values
        * are errors, positive values are used for special but normal events.
        */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        //Z_MEM_ERROR:     -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,

        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,
        /* The deflate compression method */
        Z_DEFLATED: 8
        //Z_NULL:                 null // Use -1 or null inline, depending on var type
      };
    }, {}],
    31: [function (_dereq_, module, exports) {
      'use strict';

      // Note: we can't get significant speed boost here.
      // So write code to minimize size - no pregenerated tables
      // and array tools dependencies.

      // Use ordinary array, since untyped makes no boost here
      function makeTable() {
        var c,
          table = [];
        for (var n = 0; n < 256; n++) {
          c = n;
          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
          }
          table[n] = c;
        }
        return table;
      }

      // Create table on load. Just 255 signed longs. Not a problem.
      var crcTable = makeTable();
      function crc32(crc, buf, len, pos) {
        var t = crcTable,
          end = pos + len;
        crc = crc ^ -1;
        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
        }
        return crc ^ -1; // >>> 0;
      }

      module.exports = crc32;
    }, {}],
    32: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('../utils/common');
      var trees = _dereq_('./trees');
      var adler32 = _dereq_('./adler32');
      var crc32 = _dereq_('./crc32');
      var msg = _dereq_('./messages');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      var Z_NO_FLUSH = 0;
      var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      var Z_FULL_FLUSH = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      //var Z_TREES         = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      //var Z_NEED_DICT     = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      //var Z_MEM_ERROR     = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* compression levels */
      //var Z_NO_COMPRESSION      = 0;
      //var Z_BEST_SPEED          = 1;
      //var Z_BEST_COMPRESSION    = 9;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_FILTERED = 1;
      var Z_HUFFMAN_ONLY = 2;
      var Z_RLE = 3;
      var Z_FIXED = 4;
      var Z_DEFAULT_STRATEGY = 0;

      /* Possible values of the data_type field (though see inflate()) */
      //var Z_BINARY              = 0;
      //var Z_TEXT                = 1;
      //var Z_ASCII               = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /*============================================================================*/

      var MAX_MEM_LEVEL = 9;
      /* Maximum value for memLevel in deflateInit2 */
      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_MEM_LEVEL = 8;
      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */
      var LITERALS = 256;
      /* number of literal bytes 0..255 */
      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */
      var D_CODES = 30;
      /* number of distance codes */
      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */
      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */
      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
      var PRESET_DICT = 0x20;
      var INIT_STATE = 42;
      var EXTRA_STATE = 69;
      var NAME_STATE = 73;
      var COMMENT_STATE = 91;
      var HCRC_STATE = 103;
      var BUSY_STATE = 113;
      var FINISH_STATE = 666;
      var BS_NEED_MORE = 1; /* block not completed, need more input or more output */
      var BS_BLOCK_DONE = 2; /* block flush performed */
      var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
      var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */

      var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

      function err(strm, errorCode) {
        strm.msg = msg[errorCode];
        return errorCode;
      }
      function rank(f) {
        return (f << 1) - (f > 4 ? 9 : 0);
      }
      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      /* =========================================================================
       * Flush as much pending output as possible. All deflate() output goes
       * through this function so some applications may wish to modify it
       * to avoid allocating a large strm->output buffer and copying into it.
       * (See also read_buf()).
       */
      function flush_pending(strm) {
        var s = strm.state;

        //_tr_flush_bits(s);
        var len = s.pending;
        if (len > strm.avail_out) {
          len = strm.avail_out;
        }
        if (len === 0) {
          return;
        }
        utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
        strm.next_out += len;
        s.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s.pending -= len;
        if (s.pending === 0) {
          s.pending_out = 0;
        }
      }
      function flush_block_only(s, last) {
        trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
        s.block_start = s.strstart;
        flush_pending(s.strm);
      }
      function put_byte(s, b) {
        s.pending_buf[s.pending++] = b;
      }

      /* =========================================================================
       * Put a short in the pending buffer. The 16-bit value is put in MSB order.
       * IN assertion: the stream state is correct and there is enough room in
       * pending_buf.
       */
      function putShortMSB(s, b) {
        //  put_byte(s, (Byte)(b >> 8));
        //  put_byte(s, (Byte)(b & 0xff));
        s.pending_buf[s.pending++] = b >>> 8 & 0xff;
        s.pending_buf[s.pending++] = b & 0xff;
      }

      /* ===========================================================================
       * Read a new buffer from the current input stream, update the adler32
       * and total number of bytes read.  All deflate() input goes through
       * this function so some applications may wish to modify it to avoid
       * allocating a large strm->input buffer and copying from it.
       * (See also flush_pending()).
       */
      function read_buf(strm, buf, start, size) {
        var len = strm.avail_in;
        if (len > size) {
          len = size;
        }
        if (len === 0) {
          return 0;
        }
        strm.avail_in -= len;
        utils.arraySet(buf, strm.input, strm.next_in, len, start);
        if (strm.state.wrap === 1) {
          strm.adler = adler32(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
          strm.adler = crc32(strm.adler, buf, len, start);
        }
        strm.next_in += len;
        strm.total_in += len;
        return len;
      }

      /* ===========================================================================
       * Set match_start to the longest match starting at the given string and
       * return its length. Matches shorter or equal to prev_length are discarded,
       * in which case the result is equal to prev_length and match_start is
       * garbage.
       * IN assertions: cur_match is the head of the hash chain for the current
       *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
       * OUT assertion: the match length is not greater than s->lookahead.
       */
      function longest_match(s, cur_match) {
        var chain_length = s.max_chain_length; /* max hash chain length */
        var scan = s.strstart; /* current string */
        var match; /* matched string */
        var len; /* length of current match */
        var best_len = s.prev_length; /* best match length so far */
        var nice_match = s.nice_match; /* stop if match long enough */
        var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/;

        var _win = s.window; // shortcut

        var wmask = s.w_mask;
        var prev = s.prev;

        /* Stop when cur_match becomes <= limit. To simplify the code,
         * we prevent matches with the string of window index 0.
         */

        var strend = s.strstart + MAX_MATCH;
        var scan_end1 = _win[scan + best_len - 1];
        var scan_end = _win[scan + best_len];

        /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
         * It is easy to get rid of this optimization if necessary.
         */
        // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

        /* Do not waste too much time if we already have a good match: */
        if (s.prev_length >= s.good_match) {
          chain_length >>= 2;
        }
        /* Do not look for matches beyond the end of the input. This is necessary
         * to make deflate deterministic.
         */
        if (nice_match > s.lookahead) {
          nice_match = s.lookahead;
        }

        // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

        do {
          // Assert(cur_match < s->strstart, "no future");
          match = cur_match;

          /* Skip to next match if the match length cannot increase
           * or if the match length is less than 2.  Note that the checks below
           * for insufficient lookahead only occur occasionally for performance
           * reasons.  Therefore uninitialized memory will be accessed, and
           * conditional jumps will be made that depend on those values.
           * However the length of the match is limited to the lookahead, so
           * the output of deflate is not affected by the uninitialized values.
           */

          if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
            continue;
          }

          /* The check at best_len-1 can be removed because it will be made
           * again later. (This heuristic is not always a win.)
           * It is not necessary to compare scan[2] and match[2] since they
           * are always equal when the other bytes match, given that
           * the hash keys are equal and that HASH_BITS >= 8.
           */
          scan += 2;
          match++;
          // Assert(*scan == *match, "match[2]?");

          /* We check for insufficient lookahead only every 8th comparison;
           * the 256th check will be made at strstart+258.
           */
          do {
            /*jshint noempty:false*/
          } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);

          // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

          len = MAX_MATCH - (strend - scan);
          scan = strend - MAX_MATCH;
          if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) {
              break;
            }
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
          }
        } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
        if (best_len <= s.lookahead) {
          return best_len;
        }
        return s.lookahead;
      }

      /* ===========================================================================
       * Fill the window when the lookahead becomes insufficient.
       * Updates strstart and lookahead.
       *
       * IN assertion: lookahead < MIN_LOOKAHEAD
       * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
       *    At least one byte has been read, or avail_in == 0; reads are
       *    performed for at least two bytes (required for the zip translate_eol
       *    option -- not supported here).
       */
      function fill_window(s) {
        var _w_size = s.w_size;
        var p, n, m, more, str;

        //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

        do {
          more = s.window_size - s.lookahead - s.strstart;

          // JS ints have 32 bit, block below not needed
          /* Deal with !@#$% 64K limit: */
          //if (sizeof(int) <= 2) {
          //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
          //        more = wsize;
          //
          //  } else if (more == (unsigned)(-1)) {
          //        /* Very unlikely, but possible on 16 bit machine if
          //         * strstart == 0 && lookahead == 1 (input done a byte at time)
          //         */
          //        more--;
          //    }
          //}

          /* If the window is almost full and there is insufficient lookahead,
           * move the upper half to the lower one to make room in the upper half.
           */
          if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */
            s.block_start -= _w_size;

            /* Slide the hash table (could be avoided with 32 bit values
             at the expense of memory usage). We slide even when level == 0
             to keep the hash table consistent if we switch back to level > 0
             later. (Using level 0 permanently is not an optimal usage of
             zlib, so we don't care about this pathological case.)
             */

            n = s.hash_size;
            p = n;
            do {
              m = s.head[--p];
              s.head[p] = m >= _w_size ? m - _w_size : 0;
            } while (--n);
            n = _w_size;
            p = n;
            do {
              m = s.prev[--p];
              s.prev[p] = m >= _w_size ? m - _w_size : 0;
              /* If n is not on any hash chain, prev[n] is garbage but
               * its value will never be used.
               */
            } while (--n);
            more += _w_size;
          }
          if (s.strm.avail_in === 0) {
            break;
          }

          /* If there was no sliding:
           *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
           *    more == window_size - lookahead - strstart
           * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
           * => more >= window_size - 2*WSIZE + 2
           * In the BIG_MEM or MMAP case (not yet supported),
           *   window_size == input_size + MIN_LOOKAHEAD  &&
           *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
           * Otherwise, window_size == 2*WSIZE so more >= 2.
           * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
           */
          //Assert(more >= 2, "more < 2");
          n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
          s.lookahead += n;

          /* Initialize the hash value now that we have some input: */
          if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];

            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while (s.insert) {
              /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
              s.prev[str & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = str;
              str++;
              s.insert--;
              if (s.lookahead + s.insert < MIN_MATCH) {
                break;
              }
            }
          }
          /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
           * but this is not important since only literal bytes will be emitted.
           */
        } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

        /* If the WIN_INIT bytes after the end of the current data have never been
         * written, then zero those bytes in order to avoid memory check reports of
         * the use of uninitialized (or uninitialised as Julian writes) bytes by
         * the longest match routines.  Update the high water mark for the next
         * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
         * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
         */
        //  if (s.high_water < s.window_size) {
        //    var curr = s.strstart + s.lookahead;
        //    var init = 0;
        //
        //    if (s.high_water < curr) {
        //      /* Previous high water mark below current data -- zero WIN_INIT
        //       * bytes or up to end of window, whichever is less.
        //       */
        //      init = s.window_size - curr;
        //      if (init > WIN_INIT)
        //        init = WIN_INIT;
        //      zmemzero(s->window + curr, (unsigned)init);
        //      s->high_water = curr + init;
        //    }
        //    else if (s->high_water < (ulg)curr + WIN_INIT) {
        //      /* High water mark at or above current data, but below current data
        //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
        //       * to end of window, whichever is less.
        //       */
        //      init = (ulg)curr + WIN_INIT - s->high_water;
        //      if (init > s->window_size - s->high_water)
        //        init = s->window_size - s->high_water;
        //      zmemzero(s->window + s->high_water, (unsigned)init);
        //      s->high_water += init;
        //    }
        //  }
        //
        //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
        //    "not enough room for search");
      }

      /* ===========================================================================
       * Copy without compression as much as possible from the input stream, return
       * the current block state.
       * This function does not insert new strings in the dictionary since
       * uncompressible data is probably not useful. This function is used
       * only for the level=0 compression option.
       * NOTE: this function should be optimized to avoid extra copying from
       * window to pending_buf.
       */
      function deflate_stored(s, flush) {
        /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
         * to pending_buf_size, and each stored block has a 5 byte header:
         */
        var max_block_size = 0xffff;
        if (max_block_size > s.pending_buf_size - 5) {
          max_block_size = s.pending_buf_size - 5;
        }

        /* Copy as much as possible from input to output: */
        for (;;) {
          /* Fill the window as much as possible: */
          if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }

            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */
          }
          //Assert(s->block_start >= 0L, "block gone");
          //    if (s.block_start < 0) throw new Error("block gone");

          s.strstart += s.lookahead;
          s.lookahead = 0;

          /* Emit a stored block if pending_buf will be full: */
          var max_start = s.block_start + max_block_size;
          if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */
            s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          /* Flush if we may have to slide, otherwise block_start may become
           * negative and the data will be gone:
           */
          if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.strstart > s.block_start) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_NEED_MORE;
      }

      /* ===========================================================================
       * Compress as much as possible from the input stream, return the current
       * block state.
       * This function does not perform lazy evaluation of matches and inserts
       * new strings in the dictionary only for unmatched strings or for short
       * matches. It is used only for the fast compression options.
       */
      function deflate_fast(s, flush) {
        var hash_head; /* head of the hash chain */
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break; /* flush the current block */
            }
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           * At this point we have always match_length < MIN_MATCH
           */
          if (hash_head !== 0 /*NIL*/ && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */
          }

          if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                           s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;

            /* Insert new strings in the hash table only if the match length
             * is not too large. This saves time but degrades compression.
             */
            if (s.match_length <= s.max_lazy_match /*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
              s.match_length--; /* string at strstart already in table */
              do {
                s.strstart++;
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                 * always MIN_MATCH bytes ahead.
                 */
              } while (--s.match_length !== 0);
              s.strstart++;
            } else {
              s.strstart += s.match_length;
              s.match_length = 0;
              s.ins_h = s.window[s.strstart];
              /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;

              //#if MIN_MATCH != 3
              //                Call UPDATE_HASH() MIN_MATCH-3 more times
              //#endif
              /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
               * matter since it will be recomputed at next deflate call.
               */
            }
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * Same as above, but achieves better compression. We use a lazy
       * evaluation for matches: a match is finally adopted only if there is
       * no better match at the next window position.
       */
      function deflate_slow(s, flush) {
        var hash_head; /* head of hash chain */
        var bflush; /* set if current block must be flushed */

        var max_insert;

        /* Process the input block. */
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           */
          s.prev_length = s.match_length;
          s.prev_match = s.match_start;
          s.match_length = MIN_MATCH - 1;
          if (hash_head !== 0 /*NIL*/ && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */

            if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/)) {
              /* If prev_match is also MIN_MATCH, match_start is garbage
               * but we will ignore the current match anyway.
               */
              s.match_length = MIN_MATCH - 1;
            }
          }
          /* If there was a match at the previous step and the current
           * match is not better, output the previous match:
           */
          if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */

            //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                           s.prev_length - MIN_MATCH, bflush);***/
            bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
             * strstart-1 and strstart are already inserted. If there is not
             * enough lookahead, the last two strings are not inserted in
             * the hash table.
             */
            s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do {
              if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
              }
            } while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
              /*** FLUSH_BLOCK(s, 0); ***/
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          } else if (s.match_available) {
            /* If there was no match at the previous position, output a
             * single literal. If there was a match but the current match
             * is longer, truncate the previous match to a single literal.
             */
            //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) {
              /*** FLUSH_BLOCK_ONLY(s, 0) ***/
              flush_block_only(s, false);
              /***/
            }

            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          } else {
            /* There is no previous match to compare with, wait for
             * the next step to decide.
             */
            s.match_available = 1;
            s.strstart++;
            s.lookahead--;
          }
        }
        //Assert (flush != Z_NO_FLUSH, "no flush?");
        if (s.match_available) {
          //Tracevv((stderr,"%c", s->window[s->strstart-1]));
          /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
          s.match_available = 0;
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_RLE, simply look for runs of bytes, generate matches only of distance
       * one.  Do not maintain a hash table.  (It will be regenerated if this run of
       * deflate switches away from Z_RLE.)
       */
      function deflate_rle(s, flush) {
        var bflush; /* set if current block must be flushed */
        var prev; /* byte at distance one to match */
        var scan, strend; /* scan goes up to strend for length of run */

        var _win = s.window;
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the longest run, plus one for the unrolled loop.
           */
          if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* See how many times the previous byte repeats */
          s.match_length = 0;
          if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
              strend = s.strstart + MAX_MATCH;
              do {
                /*jshint noempty:false*/
              } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
              s.match_length = MAX_MATCH - (strend - scan);
              if (s.match_length > s.lookahead) {
                s.match_length = s.lookahead;
              }
            }
            //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
          }

          /* Emit match if have run of MIN_MATCH or longer, else emit literal */
          if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);

            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
       * (It will be regenerated if this run of deflate switches away from Huffman.)
       */
      function deflate_huff(s, flush) {
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we have a literal to write. */
          if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
              if (flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              break; /* flush the current block */
            }
          }

          /* Output a literal byte */
          s.match_length = 0;
          //Tracevv((stderr,"%c", s->window[s->strstart]));
          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* Values for max_lazy_match, good_match and max_chain_length, depending on
       * the desired pack level (0..9). The values given below have been tuned to
       * exclude worst case performance for pathological files. Better values may be
       * found for specific files.
       */
      var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      };
      var configuration_table;
      configuration_table = [/*      good lazy nice chain */
      new Config(0, 0, 0, 0, deflate_stored), /* 0 store only */
      new Config(4, 4, 8, 4, deflate_fast), /* 1 max speed, no lazy matches */
      new Config(4, 5, 16, 8, deflate_fast), /* 2 */
      new Config(4, 6, 32, 32, deflate_fast), /* 3 */

      new Config(4, 4, 16, 16, deflate_slow), /* 4 lazy matches */
      new Config(8, 16, 32, 32, deflate_slow), /* 5 */
      new Config(8, 16, 128, 128, deflate_slow), /* 6 */
      new Config(8, 32, 128, 256, deflate_slow), /* 7 */
      new Config(32, 128, 258, 1024, deflate_slow), /* 8 */
      new Config(32, 258, 258, 4096, deflate_slow) /* 9 max compression */];

      /* ===========================================================================
       * Initialize the "longest match" routines for a new zlib stream
       */
      function lm_init(s) {
        s.window_size = 2 * s.w_size;

        /*** CLEAR_HASH(s); ***/
        zero(s.head); // Fill with NIL (= 0);

        /* Set the default configuration parameters:
         */
        s.max_lazy_match = configuration_table[s.level].max_lazy;
        s.good_match = configuration_table[s.level].good_length;
        s.nice_match = configuration_table[s.level].nice_length;
        s.max_chain_length = configuration_table[s.level].max_chain;
        s.strstart = 0;
        s.block_start = 0;
        s.lookahead = 0;
        s.insert = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        s.ins_h = 0;
      }
      function DeflateState() {
        this.strm = null; /* pointer back to this zlib stream */
        this.status = 0; /* as the name implies */
        this.pending_buf = null; /* output still pending */
        this.pending_buf_size = 0; /* size of pending_buf */
        this.pending_out = 0; /* next pending byte to output to the stream */
        this.pending = 0; /* nb of bytes in the pending buffer */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.gzhead = null; /* gzip header information to write */
        this.gzindex = 0; /* where in extra, name, or comment */
        this.method = Z_DEFLATED; /* can only be DEFLATED */
        this.last_flush = -1; /* value of flush param for previous deflate call */

        this.w_size = 0; /* LZ77 window size (32K by default) */
        this.w_bits = 0; /* log2(w_size)  (8..16) */
        this.w_mask = 0; /* w_size - 1 */

        this.window = null;
        /* Sliding window. Input bytes are read into the second half of the window,
         * and move to the first half later to keep a dictionary of at least wSize
         * bytes. With this organization, matches are limited to a distance of
         * wSize-MAX_MATCH bytes, but this ensures that IO is always
         * performed with a length multiple of the block size.
         */

        this.window_size = 0;
        /* Actual size of window: 2*wSize, except when the user input buffer
         * is directly used as sliding window.
         */

        this.prev = null;
        /* Link to older string with same hash index. To limit the size of this
         * array to 64K, this link is maintained only for the last 32K strings.
         * An index in this array is thus a window index modulo 32K.
         */

        this.head = null; /* Heads of the hash chains or NIL. */

        this.ins_h = 0; /* hash index of string to be inserted */
        this.hash_size = 0; /* number of elements in hash table */
        this.hash_bits = 0; /* log2(hash_size) */
        this.hash_mask = 0; /* hash_size-1 */

        this.hash_shift = 0;
        /* Number of bits by which ins_h must be shifted at each input
         * step. It must be such that after MIN_MATCH steps, the oldest
         * byte no longer takes part in the hash key, that is:
         *   hash_shift * MIN_MATCH >= hash_bits
         */

        this.block_start = 0;
        /* Window position at the beginning of the current output block. Gets
         * negative when the window is moved backwards.
         */

        this.match_length = 0; /* length of best match */
        this.prev_match = 0; /* previous match */
        this.match_available = 0; /* set if previous match exists */
        this.strstart = 0; /* start of string to insert */
        this.match_start = 0; /* start of matching string */
        this.lookahead = 0; /* number of valid bytes ahead in window */

        this.prev_length = 0;
        /* Length of the best match at previous step. Matches not greater than this
         * are discarded. This is used in the lazy match evaluation.
         */

        this.max_chain_length = 0;
        /* To speed up deflation, hash chains are never searched beyond this
         * length.  A higher limit improves compression ratio but degrades the
         * speed.
         */

        this.max_lazy_match = 0;
        /* Attempt to find a better match only when the current match is strictly
         * smaller than this value. This mechanism is used only for compression
         * levels >= 4.
         */
        // That's alias to max_lazy_match, don't use directly
        //this.max_insert_length = 0;
        /* Insert new strings in the hash table only if the match length is not
         * greater than this length. This saves time but degrades compression.
         * max_insert_length is used only for compression levels <= 3.
         */

        this.level = 0; /* compression level (1..9) */
        this.strategy = 0; /* favor or force Huffman coding*/

        this.good_match = 0;
        /* Use a faster search when the previous match is longer than this */

        this.nice_match = 0; /* Stop searching when current match exceeds this */

        /* used by trees.c: */

        /* Didn't use ct_data typedef below to suppress compiler warning */

        // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
        // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
        // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

        // Use flat array of DOUBLE size, with interleaved fata,
        // because JS does not support effective
        this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
        this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
        this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null; /* desc. for literal tree */
        this.d_desc = null; /* desc. for distance tree */
        this.bl_desc = null; /* desc. for bit length tree */

        //ush bl_count[MAX_BITS+1];
        this.bl_count = new utils.Buf16(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
        this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */
        zero(this.heap);
        this.heap_len = 0; /* number of elements in the heap */
        this.heap_max = 0; /* element of largest frequency */
        /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
         * The same heap array is used to build all trees.
         */

        this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
        zero(this.depth);
        /* Depth of each subtree used as tie breaker for trees of equal frequency
         */

        this.l_buf = 0; /* buffer index for literals or lengths */

        this.lit_bufsize = 0;
        /* Size of match buffer for literals/lengths.  There are 4 reasons for
         * limiting lit_bufsize to 64K:
         *   - frequencies can be kept in 16 bit counters
         *   - if compression is not successful for the first block, all input
         *     data is still in the window so we can still emit a stored block even
         *     when input comes from standard input.  (This can also be done for
         *     all blocks if lit_bufsize is not greater than 32K.)
         *   - if compression is not successful for a file smaller than 64K, we can
         *     even emit a stored file instead of a stored block (saving 5 bytes).
         *     This is applicable only for zip (not gzip or zlib).
         *   - creating new Huffman trees less frequently may not provide fast
         *     adaptation to changes in the input data statistics. (Take for
         *     example a binary file with poorly compressible code followed by
         *     a highly compressible string table.) Smaller buffer sizes give
         *     fast adaptation but have of course the overhead of transmitting
         *     trees more frequently.
         *   - I can't count above 4
         */

        this.last_lit = 0; /* running index in l_buf */

        this.d_buf = 0;
        /* Buffer index for distances. To simplify the code, d_buf and l_buf have
         * the same number of elements. To use different lengths, an extra flag
         * array would be necessary.
         */

        this.opt_len = 0; /* bit length of current block with optimal trees */
        this.static_len = 0; /* bit length of current block with static trees */
        this.matches = 0; /* number of string matches in current block */
        this.insert = 0; /* bytes at end of window left to insert */

        this.bi_buf = 0;
        /* Output buffer. bits are inserted starting at the bottom (least
         * significant bits).
         */
        this.bi_valid = 0;
        /* Number of valid bits in bi_buf.  All bits above the last valid bit
         * are always zero.
         */

        // Used for window memory init. We safely ignore it for JS. That makes
        // sense only for pointers and memory check tools.
        //this.high_water = 0;
        /* High water mark offset in window for initialized bytes -- bytes above
         * this are set to zero in order to avoid memory check warnings when
         * longest match routines access bytes past the input.  This is then
         * updated to the new high water mark.
         */
      }

      function deflateResetKeep(strm) {
        var s;
        if (!strm || !strm.state) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;
        s = strm.state;
        s.pending = 0;
        s.pending_out = 0;
        if (s.wrap < 0) {
          s.wrap = -s.wrap;
          /* was made negative by deflate(..., Z_FINISH); */
        }

        s.status = s.wrap ? INIT_STATE : BUSY_STATE;
        strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
        : 1; // adler32(0, Z_NULL, 0)
        s.last_flush = Z_NO_FLUSH;
        trees._tr_init(s);
        return Z_OK;
      }
      function deflateReset(strm) {
        var ret = deflateResetKeep(strm);
        if (ret === Z_OK) {
          lm_init(strm.state);
        }
        return ret;
      }
      function deflateSetHeader(strm, head) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        if (strm.state.wrap !== 2) {
          return Z_STREAM_ERROR;
        }
        strm.state.gzhead = head;
        return Z_OK;
      }
      function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
        if (!strm) {
          // === Z_NULL
          return Z_STREAM_ERROR;
        }
        var wrap = 1;
        if (level === Z_DEFAULT_COMPRESSION) {
          level = 6;
        }
        if (windowBits < 0) {
          /* suppress zlib wrapper */
          wrap = 0;
          windowBits = -windowBits;
        } else if (windowBits > 15) {
          wrap = 2; /* write gzip wrapper instead */
          windowBits -= 16;
        }
        if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
          return err(strm, Z_STREAM_ERROR);
        }
        if (windowBits === 8) {
          windowBits = 9;
        }
        /* until 256-byte window bug fixed */

        var s = new DeflateState();
        strm.state = s;
        s.strm = strm;
        s.wrap = wrap;
        s.gzhead = null;
        s.w_bits = windowBits;
        s.w_size = 1 << s.w_bits;
        s.w_mask = s.w_size - 1;
        s.hash_bits = memLevel + 7;
        s.hash_size = 1 << s.hash_bits;
        s.hash_mask = s.hash_size - 1;
        s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
        s.window = new utils.Buf8(s.w_size * 2);
        s.head = new utils.Buf16(s.hash_size);
        s.prev = new utils.Buf16(s.w_size);

        // Don't need mem init magic for JS.
        //s.high_water = 0;  /* nothing written to s->window yet */

        s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */

        s.pending_buf_size = s.lit_bufsize * 4;
        s.pending_buf = new utils.Buf8(s.pending_buf_size);
        s.d_buf = s.lit_bufsize >> 1;
        s.l_buf = (1 + 2) * s.lit_bufsize;
        s.level = level;
        s.strategy = strategy;
        s.method = method;
        return deflateReset(strm);
      }
      function deflateInit(strm, level) {
        return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
      }
      function deflate(strm, flush) {
        var old_flush, s;
        var beg, val; // for gzip header write only

        if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
          return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
        }
        s = strm.state;
        if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
          return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
        }
        s.strm = strm; /* just in case */
        old_flush = s.last_flush;
        s.last_flush = flush;

        /* Write the header */
        if (s.status === INIT_STATE) {
          if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
              // s->gzhead == Z_NULL
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, OS_CODE);
              s.status = BUSY_STATE;
            } else {
              put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
              put_byte(s, s.gzhead.time & 0xff);
              put_byte(s, s.gzhead.time >> 8 & 0xff);
              put_byte(s, s.gzhead.time >> 16 & 0xff);
              put_byte(s, s.gzhead.time >> 24 & 0xff);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, s.gzhead.os & 0xff);
              if (s.gzhead.extra && s.gzhead.extra.length) {
                put_byte(s, s.gzhead.extra.length & 0xff);
                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
              }
              if (s.gzhead.hcrc) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
              }
              s.gzindex = 0;
              s.status = EXTRA_STATE;
            }
          } else
            // DEFLATE header
            {
              var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
              var level_flags = -1;
              if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
              } else if (s.level < 6) {
                level_flags = 1;
              } else if (s.level === 6) {
                level_flags = 2;
              } else {
                level_flags = 3;
              }
              header |= level_flags << 6;
              if (s.strstart !== 0) {
                header |= PRESET_DICT;
              }
              header += 31 - header % 31;
              s.status = BUSY_STATE;
              putShortMSB(s, header);

              /* Save the adler32 of the preset dictionary: */
              if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }
              strm.adler = 1; // adler32(0L, Z_NULL, 0);
            }
        }

        //#ifdef GZIP
        if (s.status === EXTRA_STATE) {
          if (s.gzhead.extra /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */

            while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  break;
                }
              }
              put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
              s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (s.gzindex === s.gzhead.extra.length) {
              s.gzindex = 0;
              s.status = NAME_STATE;
            }
          } else {
            s.status = NAME_STATE;
          }
        }
        if (s.status === NAME_STATE) {
          if (s.gzhead.name /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.name.length) {
                val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.gzindex = 0;
              s.status = COMMENT_STATE;
            }
          } else {
            s.status = COMMENT_STATE;
          }
        }
        if (s.status === COMMENT_STATE) {
          if (s.gzhead.comment /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.comment.length) {
                val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.status = HCRC_STATE;
            }
          } else {
            s.status = HCRC_STATE;
          }
        }
        if (s.status === HCRC_STATE) {
          if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
              flush_pending(strm);
            }
            if (s.pending + 2 <= s.pending_buf_size) {
              put_byte(s, strm.adler & 0xff);
              put_byte(s, strm.adler >> 8 & 0xff);
              strm.adler = 0; //crc32(0L, Z_NULL, 0);
              s.status = BUSY_STATE;
            }
          } else {
            s.status = BUSY_STATE;
          }
        }
        //#endif

        /* Flush as much pending output as possible */
        if (s.pending !== 0) {
          flush_pending(strm);
          if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
             * more output space, but possibly with both pending and
             * avail_in equal to zero. There won't be anything to do,
             * but this is not an error situation so make sure we
             * return OK instead of BUF_ERROR at next call of deflate:
             */
            s.last_flush = -1;
            return Z_OK;
          }

          /* Make sure there is something to do and avoid duplicate consecutive
           * flushes. For repeated and useless calls with Z_FINISH, we keep
           * returning Z_STREAM_END instead of Z_BUF_ERROR.
           */
        } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
          return err(strm, Z_BUF_ERROR);
        }

        /* User must not provide more input after the first FINISH: */
        if (s.status === FINISH_STATE && strm.avail_in !== 0) {
          return err(strm, Z_BUF_ERROR);
        }

        /* Start a new block or continue the current one.
         */
        if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
          var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
          if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
            s.status = FINISH_STATE;
          }
          if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) {
              s.last_flush = -1;
              /* avoid BUF_ERROR next call, see above */
            }

            return Z_OK;
            /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
             * of deflate should use the same flush parameter to make sure
             * that the flush is complete. So we don't have to output an
             * empty block here, this will be done at next call. This also
             * ensures that for a very small output buffer, we emit at most
             * one empty block.
             */
          }

          if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) {
              trees._tr_align(s);
            } else if (flush !== Z_BLOCK) {
              /* FULL_FLUSH or SYNC_FLUSH */

              trees._tr_stored_block(s, 0, 0, false);
              /* For a full flush, this empty block will be recognized
               * as a special marker by inflate_sync().
               */
              if (flush === Z_FULL_FLUSH) {
                /*** CLEAR_HASH(s); ***/ /* forget history */
                zero(s.head); // Fill with NIL (= 0);

                if (s.lookahead === 0) {
                  s.strstart = 0;
                  s.block_start = 0;
                  s.insert = 0;
                }
              }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
              s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
              return Z_OK;
            }
          }
        }
        //Assert(strm->avail_out > 0, "bug2");
        //if (strm.avail_out <= 0) { throw new Error("bug2");}

        if (flush !== Z_FINISH) {
          return Z_OK;
        }
        if (s.wrap <= 0) {
          return Z_STREAM_END;
        }

        /* Write the trailer */
        if (s.wrap === 2) {
          put_byte(s, strm.adler & 0xff);
          put_byte(s, strm.adler >> 8 & 0xff);
          put_byte(s, strm.adler >> 16 & 0xff);
          put_byte(s, strm.adler >> 24 & 0xff);
          put_byte(s, strm.total_in & 0xff);
          put_byte(s, strm.total_in >> 8 & 0xff);
          put_byte(s, strm.total_in >> 16 & 0xff);
          put_byte(s, strm.total_in >> 24 & 0xff);
        } else {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }
        flush_pending(strm);
        /* If avail_out is zero, the application will call deflate again
         * to flush the rest.
         */
        if (s.wrap > 0) {
          s.wrap = -s.wrap;
        }
        /* write the trailer only once! */
        return s.pending !== 0 ? Z_OK : Z_STREAM_END;
      }
      function deflateEnd(strm) {
        var status;
        if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
          return Z_STREAM_ERROR;
        }
        status = strm.state.status;
        if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.state = null;
        return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
      }

      /* =========================================================================
       * Copy the source state to the destination state
       */
      //function deflateCopy(dest, source) {
      //
      //}

      exports.deflateInit = deflateInit;
      exports.deflateInit2 = deflateInit2;
      exports.deflateReset = deflateReset;
      exports.deflateResetKeep = deflateResetKeep;
      exports.deflateSetHeader = deflateSetHeader;
      exports.deflate = deflate;
      exports.deflateEnd = deflateEnd;
      exports.deflateInfo = 'pako deflate (from Nodeca project)';

      /* Not implemented
      exports.deflateBound = deflateBound;
      exports.deflateCopy = deflateCopy;
      exports.deflateSetDictionary = deflateSetDictionary;
      exports.deflateParams = deflateParams;
      exports.deflatePending = deflatePending;
      exports.deflatePrime = deflatePrime;
      exports.deflateTune = deflateTune;
      */
    }, {
      "../utils/common": 27,
      "./adler32": 29,
      "./crc32": 31,
      "./messages": 37,
      "./trees": 38
    }],
    33: [function (_dereq_, module, exports) {
      'use strict';

      function GZheader() {
        /* true if compressed data believed to be text */
        this.text = 0;
        /* modification time */
        this.time = 0;
        /* extra flags (not used when writing a gzip file) */
        this.xflags = 0;
        /* operating system */
        this.os = 0;
        /* pointer to extra field or Z_NULL if none */
        this.extra = null;
        /* extra field length (valid if extra != Z_NULL) */
        this.extra_len = 0; // Actually, we don't need it in JS,
        // but leave for few code modifications

        //
        // Setup limits is not necessary because in js we should not preallocate memory
        // for inflate use constant limit in 65536 bytes
        //

        /* space at extra (only when reading header) */
        // this.extra_max  = 0;
        /* pointer to zero-terminated file name or Z_NULL */
        this.name = '';
        /* space at name (only when reading header) */
        // this.name_max   = 0;
        /* pointer to zero-terminated comment or Z_NULL */
        this.comment = '';
        /* space at comment (only when reading header) */
        // this.comm_max   = 0;
        /* true if there was or will be a header crc */
        this.hcrc = 0;
        /* true when done reading gzip header (not used when writing a gzip file) */
        this.done = false;
      }
      module.exports = GZheader;
    }, {}],
    34: [function (_dereq_, module, exports) {
      'use strict';

      // See state defs from inflate.js
      var BAD = 30; /* got a data error -- remain here until reset */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */

      /*
         Decode literal, length, and distance codes and write out the resulting
         literal and match bytes until either not enough input or output is
         available, an end-of-block is encountered, or a data error is encountered.
         When large enough input and output buffers are supplied to inflate(), for
         example, a 16K input buffer and a 64K output buffer, more than 95% of the
         inflate execution time is spent in this routine.
      
         Entry assumptions:
      
              state.mode === LEN
              strm.avail_in >= 6
              strm.avail_out >= 258
              start >= strm.avail_out
              state.bits < 8
      
         On return, state.mode is one of:
      
              LEN -- ran out of enough output space or enough available input
              TYPE -- reached end of block code, inflate() to interpret next block
              BAD -- error in block data
      
         Notes:
      
          - The maximum input bits used by a length/distance pair is 15 bits for the
            length code, 5 bits for the length extra, 15 bits for the distance code,
            and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
            Therefore if strm.avail_in >= 6, then there is enough input to avoid
            checking for available input while decoding.
      
          - The maximum bytes that a single length/distance pair can output is 258
            bytes, which is the maximum length that can be coded.  inflate_fast()
            requires strm.avail_out >= 258 for each loop to avoid checking for
            output space.
       */
      module.exports = function inflate_fast(strm, start) {
        var state;
        var _in; /* local strm.input */
        var last; /* have enough input while in < last */
        var _out; /* local strm.output */
        var beg; /* inflate()'s initial strm.output */
        var end; /* while out < end, enough space available */
        //#ifdef INFLATE_STRICT
        var dmax; /* maximum distance from zlib header */
        //#endif
        var wsize; /* window size or zero if not using window */
        var whave; /* valid bytes in the window */
        var wnext; /* window write index */
        var window; /* allocated sliding window, if wsize != 0 */
        var hold; /* local strm.hold */
        var bits; /* local strm.bits */
        var lcode; /* local strm.lencode */
        var dcode; /* local strm.distcode */
        var lmask; /* mask for first level of length codes */
        var dmask; /* mask for first level of distance codes */
        var here; /* retrieved table entry */
        var op; /* code bits, operation, extra bits, or */
        /*  window position, window bytes to copy */
        var len; /* match length, unused bytes */
        var dist; /* match distance */
        var from; /* where to copy match from */
        var from_source;
        var input, output; // JS specific, because we have no pointers

        /* copy state to local variables */
        state = strm.state;
        //here = state.here;
        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257);
        //#ifdef INFLATE_STRICT
        dmax = state.dmax;
        //#endif
        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        window = state.window;
        hold = state.hold;
        bits = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;

        /* decode literals and length/distances until end-of-block or not enough
           input data or output space */

        top: do {
          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }
          here = lcode[hold & lmask];
          dolen: for (;;) {
            // Goto emulation
            op = here >>> 24 /*here.bits*/;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/;
            if (op === 0) {
              /* literal */
              //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
              //        "inflate:         literal '%c'\n" :
              //        "inflate:         literal 0x%02x\n", here.val));
              output[_out++] = here & 0xffff /*here.val*/;
            } else if (op & 16) {
              /* length base */
              len = here & 0xffff /*here.val*/;
              op &= 15; /* number of extra bits */
              if (op) {
                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                }
                len += hold & (1 << op) - 1;
                hold >>>= op;
                bits -= op;
              }
              //Tracevv((stderr, "inflate:         length %u\n", len));
              if (bits < 15) {
                hold += input[_in++] << bits;
                bits += 8;
                hold += input[_in++] << bits;
                bits += 8;
              }
              here = dcode[hold & dmask];
              dodist: for (;;) {
                // goto emulation
                op = here >>> 24 /*here.bits*/;
                hold >>>= op;
                bits -= op;
                op = here >>> 16 & 0xff /*here.op*/;

                if (op & 16) {
                  /* distance base */
                  dist = here & 0xffff /*here.val*/;
                  op &= 15; /* number of extra bits */
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    if (bits < op) {
                      hold += input[_in++] << bits;
                      bits += 8;
                    }
                  }
                  dist += hold & (1 << op) - 1;
                  //#ifdef INFLATE_STRICT
                  if (dist > dmax) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break top;
                  }
                  //#endif
                  hold >>>= op;
                  bits -= op;
                  //Tracevv((stderr, "inflate:         distance %u\n", dist));
                  op = _out - beg; /* max distance in output */
                  if (dist > op) {
                    /* see if copy from window */
                    op = dist - op; /* distance back in window */
                    if (op > whave) {
                      if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break top;
                      }

                      // (!) This block is disabled in zlib defailts,
                      // don't enable it for binary compatibility
                      //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                      //                if (len <= op - whave) {
                      //                  do {
                      //                    output[_out++] = 0;
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //                len -= op - whave;
                      //                do {
                      //                  output[_out++] = 0;
                      //                } while (--op > whave);
                      //                if (op === 0) {
                      //                  from = _out - dist;
                      //                  do {
                      //                    output[_out++] = output[from++];
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //#endif
                    }

                    from = 0; // window index
                    from_source = window;
                    if (wnext === 0) {
                      /* very common case */
                      from += wsize - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    } else if (wnext < op) {
                      /* wrap around window */
                      from += wsize + wnext - op;
                      op -= wnext;
                      if (op < len) {
                        /* some from end of window */
                        len -= op;
                        do {
                          output[_out++] = window[from++];
                        } while (--op);
                        from = 0;
                        if (wnext < len) {
                          /* some from start of window */
                          op = wnext;
                          len -= op;
                          do {
                            output[_out++] = window[from++];
                          } while (--op);
                          from = _out - dist; /* rest from output */
                          from_source = output;
                        }
                      }
                    } else {
                      /* contiguous in window */
                      from += wnext - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    }
                    while (len > 2) {
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      len -= 3;
                    }
                    if (len) {
                      output[_out++] = from_source[from++];
                      if (len > 1) {
                        output[_out++] = from_source[from++];
                      }
                    }
                  } else {
                    from = _out - dist; /* copy direct from output */
                    do {
                      /* minimum length is three */
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      len -= 3;
                    } while (len > 2);
                    if (len) {
                      output[_out++] = output[from++];
                      if (len > 1) {
                        output[_out++] = output[from++];
                      }
                    }
                  }
                } else if ((op & 64) === 0) {
                  /* 2nd level distance code */
                  here = dcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
                  continue dodist;
                } else {
                  strm.msg = 'invalid distance code';
                  state.mode = BAD;
                  break top;
                }
                break; // need to emulate goto via "continue"
              }
            } else if ((op & 64) === 0) {
              /* 2nd level length code */
              here = lcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
              continue dolen;
            } else if (op & 32) {
              /* end-of-block */
              //Tracevv((stderr, "inflate:         end of block\n"));
              state.mode = TYPE;
              break top;
            } else {
              strm.msg = 'invalid literal/length code';
              state.mode = BAD;
              break top;
            }
            break; // need to emulate goto via "continue"
          }
        } while (_in < last && _out < end);

        /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
        len = bits >> 3;
        _in -= len;
        bits -= len << 3;
        hold &= (1 << bits) - 1;

        /* update state and return */
        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits;
        return;
      };
    }, {}],
    35: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('../utils/common');
      var adler32 = _dereq_('./adler32');
      var crc32 = _dereq_('./crc32');
      var inflate_fast = _dereq_('./inffast');
      var inflate_table = _dereq_('./inftrees');
      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      //var Z_NO_FLUSH      = 0;
      //var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      //var Z_FULL_FLUSH    = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_TREES = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_NEED_DICT = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_MEM_ERROR = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /* STATES ====================================================================*/
      /* ===========================================================================*/

      var HEAD = 1; /* i: waiting for magic header */
      var FLAGS = 2; /* i: waiting for method and flags (gzip) */
      var TIME = 3; /* i: waiting for modification time (gzip) */
      var OS = 4; /* i: waiting for extra flags and operating system (gzip) */
      var EXLEN = 5; /* i: waiting for extra length (gzip) */
      var EXTRA = 6; /* i: waiting for extra bytes (gzip) */
      var NAME = 7; /* i: waiting for end of file name (gzip) */
      var COMMENT = 8; /* i: waiting for end of comment (gzip) */
      var HCRC = 9; /* i: waiting for header crc (gzip) */
      var DICTID = 10; /* i: waiting for dictionary check value */
      var DICT = 11; /* waiting for inflateSetDictionary() call */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */
      var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */
      var STORED = 14; /* i: waiting for stored size (length and complement) */
      var COPY_ = 15; /* i/o: same as COPY below, but only first time in */
      var COPY = 16; /* i/o: waiting for input or output to copy stored block */
      var TABLE = 17; /* i: waiting for dynamic block table lengths */
      var LENLENS = 18; /* i: waiting for code length code lengths */
      var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */
      var LEN_ = 20; /* i: same as LEN below, but only first time in */
      var LEN = 21; /* i: waiting for length/lit/eob code */
      var LENEXT = 22; /* i: waiting for length extra bits */
      var DIST = 23; /* i: waiting for distance code */
      var DISTEXT = 24; /* i: waiting for distance extra bits */
      var MATCH = 25; /* o: waiting for output space to copy string */
      var LIT = 26; /* o: waiting for output space to write literal */
      var CHECK = 27; /* i: waiting for 32-bit check value */
      var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */
      var DONE = 29; /* finished check, done -- remain here until reset */
      var BAD = 30; /* got a data error -- remain here until reset */
      var MEM = 31; /* got an inflate() memory error -- remain here until reset */
      var SYNC = 32; /* looking for synchronization bytes to restart inflate() */

      /* ===========================================================================*/

      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_WBITS = MAX_WBITS;
      function ZSWAP32(q) {
        return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
      }
      function InflateState() {
        this.mode = 0; /* current inflate mode */
        this.last = false; /* true if processing last block */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.havedict = false; /* true if dictionary provided */
        this.flags = 0; /* gzip header method and flags (0 if zlib) */
        this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
        this.check = 0; /* protected copy of check value */
        this.total = 0; /* protected copy of output count */
        // TODO: may be {}
        this.head = null; /* where to save gzip header information */

        /* sliding window */
        this.wbits = 0; /* log base 2 of requested window size */
        this.wsize = 0; /* window size or zero if not using window */
        this.whave = 0; /* valid bytes in the window */
        this.wnext = 0; /* window write index */
        this.window = null; /* allocated sliding window, if needed */

        /* bit accumulator */
        this.hold = 0; /* input bit accumulator */
        this.bits = 0; /* number of bits in "in" */

        /* for string and stored block copying */
        this.length = 0; /* literal or length of data to copy */
        this.offset = 0; /* distance back to copy string from */

        /* for table and code decoding */
        this.extra = 0; /* extra bits needed */

        /* fixed and dynamic code tables */
        this.lencode = null; /* starting table for length/literal codes */
        this.distcode = null; /* starting table for distance codes */
        this.lenbits = 0; /* index bits for lencode */
        this.distbits = 0; /* index bits for distcode */

        /* dynamic table building */
        this.ncode = 0; /* number of code length code lengths */
        this.nlen = 0; /* number of length code lengths */
        this.ndist = 0; /* number of distance code lengths */
        this.have = 0; /* number of code lengths in lens[] */
        this.next = null; /* next available space in codes[] */

        this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
        this.work = new utils.Buf16(288); /* work area for code table building */

        /*
         because we don't have pointers in js, we use lencode and distcode directly
         as buffers so we don't need codes
        */
        //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
        this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */
        this.distdyn = null; /* dynamic table for distance codes (JS specific) */
        this.sane = 0; /* if false, allow invalid distance too far */
        this.back = 0; /* bits back of last unprocessed length/lit */
        this.was = 0; /* initial length of match */
      }

      function inflateResetKeep(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = ''; /*Z_NULL*/
        if (state.wrap) {
          /* to support ill-conceived Java test suite */
          strm.adler = state.wrap & 1;
        }
        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.dmax = 32768;
        state.head = null /*Z_NULL*/;
        state.hold = 0;
        state.bits = 0;
        //state.lencode = state.distcode = state.next = state.codes;
        state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
        state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
        state.sane = 1;
        state.back = -1;
        //Tracev((stderr, "inflate: reset\n"));
        return Z_OK;
      }
      function inflateReset(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
      }
      function inflateReset2(strm, windowBits) {
        var wrap;
        var state;

        /* get the state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;

        /* extract wrap request from windowBits parameter */
        if (windowBits < 0) {
          wrap = 0;
          windowBits = -windowBits;
        } else {
          wrap = (windowBits >> 4) + 1;
          if (windowBits < 48) {
            windowBits &= 15;
          }
        }

        /* set number of window bits, free window if different */
        if (windowBits && (windowBits < 8 || windowBits > 15)) {
          return Z_STREAM_ERROR;
        }
        if (state.window !== null && state.wbits !== windowBits) {
          state.window = null;
        }

        /* update state and reset the rest of it */
        state.wrap = wrap;
        state.wbits = windowBits;
        return inflateReset(strm);
      }
      function inflateInit2(strm, windowBits) {
        var ret;
        var state;
        if (!strm) {
          return Z_STREAM_ERROR;
        }
        //strm.msg = Z_NULL;                 /* in case we return an error */

        state = new InflateState();

        //if (state === Z_NULL) return Z_MEM_ERROR;
        //Tracev((stderr, "inflate: allocated\n"));
        strm.state = state;
        state.window = null /*Z_NULL*/;
        ret = inflateReset2(strm, windowBits);
        if (ret !== Z_OK) {
          strm.state = null /*Z_NULL*/;
        }

        return ret;
      }
      function inflateInit(strm) {
        return inflateInit2(strm, DEF_WBITS);
      }

      /*
       Return state with length and distance decoding tables and index sizes set to
       fixed code decoding.  Normally this returns fixed tables from inffixed.h.
       If BUILDFIXED is defined, then instead this routine builds the tables the
       first time it's called, and returns those tables the first time and
       thereafter.  This reduces the size of the code by about 2K bytes, in
       exchange for a little execution time.  However, BUILDFIXED should not be
       used for threaded applications, since the rewriting of the tables and virgin
       may not be thread-safe.
       */
      var virgin = true;
      var lenfix, distfix; // We have no pointers in JS, so keep tables separate

      function fixedtables(state) {
        /* build fixed huffman tables if first call (may not be thread safe) */
        if (virgin) {
          var sym;
          lenfix = new utils.Buf32(512);
          distfix = new utils.Buf32(32);

          /* literal/length table */
          sym = 0;
          while (sym < 144) {
            state.lens[sym++] = 8;
          }
          while (sym < 256) {
            state.lens[sym++] = 9;
          }
          while (sym < 280) {
            state.lens[sym++] = 7;
          }
          while (sym < 288) {
            state.lens[sym++] = 8;
          }
          inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
          });

          /* distance table */
          sym = 0;
          while (sym < 32) {
            state.lens[sym++] = 5;
          }
          inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
          });

          /* do this just once */
          virgin = false;
        }
        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
      }

      /*
       Update the window with the last wsize (normally 32K) bytes written before
       returning.  If window does not exist yet, create it.  This is only called
       when a window is already in use, or when output has been written during this
       inflate call, but the end of the deflate stream has not been reached yet.
       It is also called to create a window for dictionary data when a dictionary
       is loaded.
      
       Providing output buffers larger than 32K to inflate() should provide a speed
       advantage, since only the last 32K of output is copied to the sliding window
       upon return from inflate(), and since all distances after the first 32K of
       output will fall in the output data, making match copies simpler and faster.
       The advantage may be dependent on the size of the processor's data caches.
       */
      function updatewindow(strm, src, end, copy) {
        var dist;
        var state = strm.state;

        /* if it hasn't been done already, allocate space for the window */
        if (state.window === null) {
          state.wsize = 1 << state.wbits;
          state.wnext = 0;
          state.whave = 0;
          state.window = new utils.Buf8(state.wsize);
        }

        /* copy state->wsize or less output bytes into the circular window */
        if (copy >= state.wsize) {
          utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
          state.wnext = 0;
          state.whave = state.wsize;
        } else {
          dist = state.wsize - state.wnext;
          if (dist > copy) {
            dist = copy;
          }
          //zmemcpy(state->window + state->wnext, end - copy, dist);
          utils.arraySet(state.window, src, end - copy, dist, state.wnext);
          copy -= dist;
          if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
          } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) {
              state.wnext = 0;
            }
            if (state.whave < state.wsize) {
              state.whave += dist;
            }
          }
        }
        return 0;
      }
      function inflate(strm, flush) {
        var state;
        var input, output; // input/output buffers
        var next; /* next input INDEX */
        var put; /* next output INDEX */
        var have, left; /* available input and output */
        var hold; /* bit buffer */
        var bits; /* bits in bit buffer */
        var _in, _out; /* save starting available input and output */
        var copy; /* number of stored or match bytes to copy */
        var from; /* where to copy match bytes from */
        var from_source;
        var here = 0; /* current decoding table entry */
        var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
        //var last;                   /* parent table entry */
        var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
        var len; /* length to copy for repeats, bits to drop */
        var ret; /* return code */
        var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */
        var opts;
        var n; // temporary var for NEED_BITS

        var order = /* permutation of code lengths */
        [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.mode === TYPE) {
          state.mode = TYPEDO;
        } /* skip check */

        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        _in = have;
        _out = left;
        ret = Z_OK;
        inf_leave:
        // goto emulation
        for (;;) {
          switch (state.mode) {
            case HEAD:
              if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
              }
              //=== NEEDBITS(16);
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//

                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
              }
              state.flags = 0; /* expect zlib header */
              if (state.head) {
                state.head.done = false;
              }
              if (!(state.wrap & 1) || /* check if zlib header allowed */
              (((hold & 0xff /*BITS(8)*/) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
              }
              if ((hold & 0x0f /*BITS(4)*/) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              len = (hold & 0x0f /*BITS(4)*/) + 8;
              if (state.wbits === 0) {
                state.wbits = len;
              } else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
              }
              state.dmax = 1 << len;
              //Tracev((stderr, "inflate:   zlib header ok\n"));
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = hold & 0x200 ? DICTID : TYPE;
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              break;
            case FLAGS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.flags = hold;
              if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
              }
              if (state.head) {
                state.head.text = hold >> 8 & 1;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = TIME;
            /* falls through */
            case TIME:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.time = hold;
              }
              if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
                //===
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = OS;
            /* falls through */
            case OS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = EXLEN;
            /* falls through */
            case EXLEN:
              if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) {
                  state.head.extra_len = hold;
                }
                if (state.flags & 0x0200) {
                  //=== CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = hold >>> 8 & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              } else if (state.head) {
                state.head.extra = null /*Z_NULL*/;
              }

              state.mode = EXTRA;
            /* falls through */
            case EXTRA:
              if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) {
                  copy = have;
                }
                if (copy) {
                  if (state.head) {
                    len = state.head.extra_len - state.length;
                    if (!state.head.extra) {
                      // Use untyped array for more conveniend processing later
                      state.head.extra = new Array(state.head.extra_len);
                    }
                    utils.arraySet(state.head.extra, input, next,
                    // extra field is limited to 65536 bytes
                    // - no need for additional size check
                    copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                  }

                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  state.length -= copy;
                }
                if (state.length) {
                  break inf_leave;
                }
              }
              state.length = 0;
              state.mode = NAME;
            /* falls through */
            case NAME:
              if (state.flags & 0x0800) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  // TODO: 2 or 1 bytes?
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.name_max*/) {
                    state.head.name += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.name = null;
              }
              state.length = 0;
              state.mode = COMMENT;
            /* falls through */
            case COMMENT:
              if (state.flags & 0x1000) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.comm_max*/) {
                    state.head.comment += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.comment = null;
              }
              state.mode = HCRC;
            /* falls through */
            case HCRC:
              if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                  strm.msg = 'header crc mismatch';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              }

              if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
              }
              strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
              state.mode = TYPE;
              break;
            case DICTID:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              strm.adler = state.check = ZSWAP32(hold);
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = DICT;
            /* falls through */
            case DICT:
              if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
              }
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = TYPE;
            /* falls through */
            case TYPE:
              if (flush === Z_BLOCK || flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case TYPEDO:
              if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
              }
              //=== NEEDBITS(3); */
              while (bits < 3) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.last = hold & 0x01 /*BITS(1)*/;
              //--- DROPBITS(1) ---//
              hold >>>= 1;
              bits -= 1;
              //---//

              switch (hold & 0x03 /*BITS(2)*/) {
                case 0:
                  /* stored block */
                  //Tracev((stderr, "inflate:     stored block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = STORED;
                  break;
                case 1:
                  /* fixed block */
                  fixedtables(state);
                  //Tracev((stderr, "inflate:     fixed codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = LEN_; /* decode codes */
                  if (flush === Z_TREES) {
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                    break inf_leave;
                  }
                  break;
                case 2:
                  /* dynamic block */
                  //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = TABLE;
                  break;
                case 3:
                  strm.msg = 'invalid block type';
                  state.mode = BAD;
              }
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break;
            case STORED:
              //--- BYTEBITS() ---// /* go to byte boundary */
              hold >>>= bits & 7;
              bits -= bits & 7;
              //---//
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
              }
              state.length = hold & 0xffff;
              //Tracev((stderr, "inflate:       stored length %u\n",
              //        state.length));
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = COPY_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case COPY_:
              state.mode = COPY;
            /* falls through */
            case COPY:
              copy = state.length;
              if (copy) {
                if (copy > have) {
                  copy = have;
                }
                if (copy > left) {
                  copy = left;
                }
                if (copy === 0) {
                  break inf_leave;
                }
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
              }
              //Tracev((stderr, "inflate:       stored end\n"));
              state.mode = TYPE;
              break;
            case TABLE:
              //=== NEEDBITS(14); */
              while (bits < 14) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.nlen = (hold & 0x1f /*BITS(5)*/) + 257;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ndist = (hold & 0x1f /*BITS(5)*/) + 1;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ncode = (hold & 0x0f /*BITS(4)*/) + 4;
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              //#ifndef PKZIP_BUG_WORKAROUND
              if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracev((stderr, "inflate:       table sizes ok\n"));
              state.have = 0;
              state.mode = LENLENS;
            /* falls through */
            case LENLENS:
              while (state.have < state.ncode) {
                //=== NEEDBITS(3);
                while (bits < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
                //---//
              }

              while (state.have < 19) {
                state.lens[order[state.have++]] = 0;
              }
              // We have separate tables & no pointers. 2 commented lines below not needed.
              //state.next = state.codes;
              //state.lencode = state.next;
              // Switch to use dynamic table
              state.lencode = state.lendyn;
              state.lenbits = 7;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;
              if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, "inflate:       code lengths ok\n"));
              state.have = 0;
              state.mode = CODELENS;
            /* falls through */
            case CODELENS:
              while (state.have < state.nlen + state.ndist) {
                for (;;) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }

                if (here_val < 16) {
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  state.lens[state.have++] = here_val;
                } else {
                  if (here_val === 16) {
                    //=== NEEDBITS(here.bits + 2);
                    n = here_bits + 2;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    if (state.have === 0) {
                      strm.msg = 'invalid bit length repeat';
                      state.mode = BAD;
                      break;
                    }
                    len = state.lens[state.have - 1];
                    copy = 3 + (hold & 0x03); //BITS(2);
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                  } else if (here_val === 17) {
                    //=== NEEDBITS(here.bits + 3);
                    n = here_bits + 3;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 3 + (hold & 0x07); //BITS(3);
                    //--- DROPBITS(3) ---//
                    hold >>>= 3;
                    bits -= 3;
                    //---//
                  } else {
                    //=== NEEDBITS(here.bits + 7);
                    n = here_bits + 7;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 11 + (hold & 0x7f); //BITS(7);
                    //--- DROPBITS(7) ---//
                    hold >>>= 7;
                    bits -= 7;
                    //---//
                  }

                  if (state.have + copy > state.nlen + state.ndist) {
                    strm.msg = 'invalid bit length repeat';
                    state.mode = BAD;
                    break;
                  }
                  while (copy--) {
                    state.lens[state.have++] = len;
                  }
                }
              }

              /* handle error breaks in while */
              if (state.mode === BAD) {
                break;
              }

              /* check for end-of-block code (better have one) */
              if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
              }

              /* build code tables -- note: do not change the lenbits or distbits
                 values here (9 and 6) without reading the comments in inftrees.h
                 concerning the ENOUGH constants, which depend on those values */
              state.lenbits = 9;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.lenbits = opts.bits;
              // state.lencode = state.next;

              if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
              }
              state.distbits = 6;
              //state.distcode.copy(state.codes);
              // Switch to use dynamic table
              state.distcode = state.distdyn;
              opts = {
                bits: state.distbits
              };
              ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.distbits = opts.bits;
              // state.distcode = state.next;

              if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, 'inflate:       codes ok\n'));
              state.mode = LEN_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case LEN_:
              state.mode = LEN;
            /* falls through */
            case LEN:
              if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---

                if (state.mode === TYPE) {
                  state.back = -1;
                }
                break;
              }
              state.back = 0;
              for (;;) {
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }

              if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              state.length = here_val;
              if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
              }
              if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
              }
              if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
              }
              state.extra = here_op & 15;
              state.mode = LENEXT;
            /* falls through */
            case LENEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //Tracevv((stderr, "inflate:         length %u\n", state.length));
              state.was = state.length;
              state.mode = DIST;
            /* falls through */
            case DIST:
              for (;;) {
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }

              if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
              }
              state.offset = here_val;
              state.extra = here_op & 15;
              state.mode = DISTEXT;
            /* falls through */
            case DISTEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //#ifdef INFLATE_STRICT
              if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
              state.mode = MATCH;
            /* falls through */
            case MATCH:
              if (left === 0) {
                break inf_leave;
              }
              copy = _out - left;
              if (state.offset > copy) {
                /* copy from window */
                copy = state.offset - copy;
                if (copy > state.whave) {
                  if (state.sane) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break;
                  }
                  // (!) This block is disabled in zlib defailts,
                  // don't enable it for binary compatibility
                  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                  //          Trace((stderr, "inflate.c too far\n"));
                  //          copy -= state.whave;
                  //          if (copy > state.length) { copy = state.length; }
                  //          if (copy > left) { copy = left; }
                  //          left -= copy;
                  //          state.length -= copy;
                  //          do {
                  //            output[put++] = 0;
                  //          } while (--copy);
                  //          if (state.length === 0) { state.mode = LEN; }
                  //          break;
                  //#endif
                }

                if (copy > state.wnext) {
                  copy -= state.wnext;
                  from = state.wsize - copy;
                } else {
                  from = state.wnext - copy;
                }
                if (copy > state.length) {
                  copy = state.length;
                }
                from_source = state.window;
              } else {
                /* copy from output */
                from_source = output;
                from = put - state.offset;
                copy = state.length;
              }
              if (copy > left) {
                copy = left;
              }
              left -= copy;
              state.length -= copy;
              do {
                output[put++] = from_source[from++];
              } while (--copy);
              if (state.length === 0) {
                state.mode = LEN;
              }
              break;
            case LIT:
              if (left === 0) {
                break inf_leave;
              }
              output[put++] = state.length;
              left--;
              state.mode = LEN;
              break;
            case CHECK:
              if (state.wrap) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  // Use '|' insdead of '+' to make sure that result is signed
                  hold |= input[next++] << bits;
                  bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) {
                  strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/
                  state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                }
                _out = left;
                // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
                if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
                  strm.msg = 'incorrect data check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   check matches trailer\n"));
              }

              state.mode = LENGTH;
            /* falls through */
            case LENGTH:
              if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                  strm.msg = 'incorrect length check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   length matches trailer\n"));
              }

              state.mode = DONE;
            /* falls through */
            case DONE:
              ret = Z_STREAM_END;
              break inf_leave;
            case BAD:
              ret = Z_DATA_ERROR;
              break inf_leave;
            case MEM:
              return Z_MEM_ERROR;
            case SYNC:
            /* falls through */
            default:
              return Z_STREAM_ERROR;
          }
        }

        // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

        /*
           Return from inflate(), updating the total counts and the check value.
           If there was no progress during the inflate() call, return a buffer
           error.  Call updatewindow() to create and/or update the window state.
           Note: a memory error from inflate() is non-recoverable.
         */

        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---

        if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
          if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
          }
        }
        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;
        if (state.wrap && _out) {
          strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
          state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
        }
        strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
        if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
          ret = Z_BUF_ERROR;
        }
        return ret;
      }
      function inflateEnd(strm) {
        if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
          return Z_STREAM_ERROR;
        }
        var state = strm.state;
        if (state.window) {
          state.window = null;
        }
        strm.state = null;
        return Z_OK;
      }
      function inflateGetHeader(strm, head) {
        var state;

        /* check state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if ((state.wrap & 2) === 0) {
          return Z_STREAM_ERROR;
        }

        /* save header structure */
        state.head = head;
        head.done = false;
        return Z_OK;
      }
      exports.inflateReset = inflateReset;
      exports.inflateReset2 = inflateReset2;
      exports.inflateResetKeep = inflateResetKeep;
      exports.inflateInit = inflateInit;
      exports.inflateInit2 = inflateInit2;
      exports.inflate = inflate;
      exports.inflateEnd = inflateEnd;
      exports.inflateGetHeader = inflateGetHeader;
      exports.inflateInfo = 'pako inflate (from Nodeca project)';

      /* Not implemented
      exports.inflateCopy = inflateCopy;
      exports.inflateGetDictionary = inflateGetDictionary;
      exports.inflateMark = inflateMark;
      exports.inflatePrime = inflatePrime;
      exports.inflateSetDictionary = inflateSetDictionary;
      exports.inflateSync = inflateSync;
      exports.inflateSyncPoint = inflateSyncPoint;
      exports.inflateUndermine = inflateUndermine;
      */
    }, {
      "../utils/common": 27,
      "./adler32": 29,
      "./crc32": 31,
      "./inffast": 34,
      "./inftrees": 36
    }],
    36: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('../utils/common');
      var MAXBITS = 15;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var lbase = [/* Length codes 257..285 base */
      3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
      var lext = [/* Length codes 257..285 extra */
      16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
      var dbase = [/* Distance codes 0..29 base */
      1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
      var dext = [/* Distance codes 0..29 extra */
      16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
        var bits = opts.bits;
        //here = opts.here; /* table entry for duplication */

        var len = 0; /* a code's length in bits */
        var sym = 0; /* index of code symbols */
        var min = 0,
          max = 0; /* minimum and maximum code lengths */
        var root = 0; /* number of index bits for root table */
        var curr = 0; /* number of index bits for current table */
        var drop = 0; /* code bits to drop for sub-table */
        var left = 0; /* number of prefix codes available */
        var used = 0; /* code entries in table used */
        var huff = 0; /* Huffman code */
        var incr; /* for incrementing code, index */
        var fill; /* index for replicating entries */
        var low; /* low bits for current root entry */
        var mask; /* mask for low root bits */
        var next; /* next available space in table */
        var base = null; /* base value table to use */
        var base_index = 0;
        //  var shoextra;    /* extra bits table to use */
        var end; /* use base and extra for symbol > end */
        var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
        var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
        var extra = null;
        var extra_index = 0;
        var here_bits, here_op, here_val;

        /*
         Process a set of code lengths to create a canonical Huffman code.  The
         code lengths are lens[0..codes-1].  Each length corresponds to the
         symbols 0..codes-1.  The Huffman code is generated by first sorting the
         symbols by length from short to long, and retaining the symbol order
         for codes with equal lengths.  Then the code starts with all zero bits
         for the first code of the shortest length, and the codes are integer
         increments for the same length, and zeros are appended as the length
         increases.  For the deflate format, these bits are stored backwards
         from their more natural integer increment ordering, and so when the
         decoding tables are built in the large loop below, the integer codes
         are incremented backwards.
          This routine assumes, but does not check, that all of the entries in
         lens[] are in the range 0..MAXBITS.  The caller must assure this.
         1..MAXBITS is interpreted as that code length.  zero means that that
         symbol does not occur in this code.
          The codes are sorted by computing a count of codes for each length,
         creating from that a table of starting indices for each length in the
         sorted table, and then entering the symbols in order in the sorted
         table.  The sorted table is work[], with that space being provided by
         the caller.
          The length counts are used for other purposes as well, i.e. finding
         the minimum and maximum length codes, determining if there are any
         codes at all, checking for a valid set of lengths, and looking ahead
         at length counts to determine sub-table sizes when building the
         decoding tables.
         */

        /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
        for (len = 0; len <= MAXBITS; len++) {
          count[len] = 0;
        }
        for (sym = 0; sym < codes; sym++) {
          count[lens[lens_index + sym]]++;
        }

        /* bound code lengths, force root to be within code lengths */
        root = bits;
        for (max = MAXBITS; max >= 1; max--) {
          if (count[max] !== 0) {
            break;
          }
        }
        if (root > max) {
          root = max;
        }
        if (max === 0) {
          /* no symbols to code at all */
          //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
          //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
          //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;

          //table.op[opts.table_index] = 64;
          //table.bits[opts.table_index] = 1;
          //table.val[opts.table_index++] = 0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          opts.bits = 1;
          return 0; /* no symbols, but wait for decoding to report error */
        }

        for (min = 1; min < max; min++) {
          if (count[min] !== 0) {
            break;
          }
        }
        if (root < min) {
          root = min;
        }

        /* check for an over-subscribed or incomplete set of lengths */
        left = 1;
        for (len = 1; len <= MAXBITS; len++) {
          left <<= 1;
          left -= count[len];
          if (left < 0) {
            return -1;
          } /* over-subscribed */
        }

        if (left > 0 && (type === CODES || max !== 1)) {
          return -1; /* incomplete set */
        }

        /* generate offsets into symbol table for each length for sorting */
        offs[1] = 0;
        for (len = 1; len < MAXBITS; len++) {
          offs[len + 1] = offs[len] + count[len];
        }

        /* sort symbols by length, by symbol order within each length */
        for (sym = 0; sym < codes; sym++) {
          if (lens[lens_index + sym] !== 0) {
            work[offs[lens[lens_index + sym]]++] = sym;
          }
        }

        /*
         Create and fill in decoding tables.  In this loop, the table being
         filled is at next and has curr index bits.  The code being used is huff
         with length len.  That code is converted to an index by dropping drop
         bits off of the bottom.  For codes where len is less than drop + curr,
         those top drop + curr - len bits are incremented through all values to
         fill the table with replicated entries.
          root is the number of index bits for the root table.  When len exceeds
         root, sub-tables are created pointed to by the root entry with an index
         of the low root bits of huff.  This is saved in low to check for when a
         new sub-table should be started.  drop is zero when the root table is
         being filled, and drop is root when sub-tables are being filled.
          When a new sub-table is needed, it is necessary to look ahead in the
         code lengths to determine what size sub-table is needed.  The length
         counts are used for this, and so count[] is decremented as codes are
         entered in the tables.
          used keeps track of how many table entries have been allocated from the
         provided *table space.  It is checked for LENS and DIST tables against
         the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
         the initial root table size constants.  See the comments in inftrees.h
         for more information.
          sym increments through all symbols, and the loop terminates when
         all codes of length max, i.e. all codes, have been processed.  This
         routine permits incomplete codes, so another loop after this one fills
         in the rest of the decoding tables with invalid code markers.
         */

        /* set up for code type */
        // poor man optimization - use if-else instead of switch,
        // to avoid deopts in old v8
        if (type === CODES) {
          base = extra = work; /* dummy value--not used */
          end = 19;
        } else if (type === LENS) {
          base = lbase;
          base_index -= 257;
          extra = lext;
          extra_index -= 257;
          end = 256;
        } else {
          /* DISTS */
          base = dbase;
          extra = dext;
          end = -1;
        }

        /* initialize opts for loop */
        huff = 0; /* starting code */
        sym = 0; /* starting code symbol */
        len = min; /* starting code length */
        next = table_index; /* current table to fill in */
        curr = root; /* current table index bits */
        drop = 0; /* current bits to drop from code for index */
        low = -1; /* trigger new sub-table when len > root */
        used = 1 << root; /* use root table entries */
        mask = used - 1; /* mask for comparing low */

        /* check available table space */
        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }
        var i = 0;
        /* process all codes and make table entries */
        for (;;) {
          i++;
          /* create table entry */
          here_bits = len - drop;
          if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
          } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
          } else {
            here_op = 32 + 64; /* end of block */
            here_val = 0;
          }

          /* replicate for those indices with low len bits equal to huff */
          incr = 1 << len - drop;
          fill = 1 << curr;
          min = fill; /* save offset to next table */
          do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
          } while (fill !== 0);

          /* backwards increment the len-bit code huff */
          incr = 1 << len - 1;
          while (huff & incr) {
            incr >>= 1;
          }
          if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
          } else {
            huff = 0;
          }

          /* go to next symbol, update count, len */
          sym++;
          if (--count[len] === 0) {
            if (len === max) {
              break;
            }
            len = lens[lens_index + work[sym]];
          }

          /* create new sub-table if needed */
          if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */
            if (drop === 0) {
              drop = root;
            }

            /* increment past last table */
            next += min; /* here min is 1 << curr */

            /* determine length of next table */
            curr = len - drop;
            left = 1 << curr;
            while (curr + drop < max) {
              left -= count[curr + drop];
              if (left <= 0) {
                break;
              }
              curr++;
              left <<= 1;
            }

            /* check for enough space */
            used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
              return 1;
            }

            /* point entry in root table to sub-table */
            low = huff & mask;
            /*table.op[low] = curr;
            table.bits[low] = root;
            table.val[low] = next - opts.table_index;*/
            table[low] = root << 24 | curr << 16 | next - table_index | 0;
          }
        }

        /* fill in remaining table entry if code is incomplete (guaranteed to have
         at most one remaining entry, since if the code is incomplete, the
         maximum code length that was allowed to get this far is one bit) */
        if (huff !== 0) {
          //table.op[next + huff] = 64;            /* invalid code marker */
          //table.bits[next + huff] = len - drop;
          //table.val[next + huff] = 0;
          table[next + huff] = len - drop << 24 | 64 << 16 | 0;
        }

        /* set return parameters */
        //opts.table_index += used;
        opts.bits = root;
        return 0;
      };
    }, {
      "../utils/common": 27
    }],
    37: [function (_dereq_, module, exports) {
      'use strict';

      module.exports = {
        '2': 'need dictionary',
        /* Z_NEED_DICT       2  */
        '1': 'stream end',
        /* Z_STREAM_END      1  */
        '0': '',
        /* Z_OK              0  */
        '-1': 'file error',
        /* Z_ERRNO         (-1) */
        '-2': 'stream error',
        /* Z_STREAM_ERROR  (-2) */
        '-3': 'data error',
        /* Z_DATA_ERROR    (-3) */
        '-4': 'insufficient memory',
        /* Z_MEM_ERROR     (-4) */
        '-5': 'buffer error',
        /* Z_BUF_ERROR     (-5) */
        '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */
      };
    }, {}],
    38: [function (_dereq_, module, exports) {
      'use strict';

      var utils = _dereq_('../utils/common');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      //var Z_FILTERED          = 1;
      //var Z_HUFFMAN_ONLY      = 2;
      //var Z_RLE               = 3;
      var Z_FIXED = 4;
      //var Z_DEFAULT_STRATEGY  = 0;

      /* Possible values of the data_type field (though see inflate()) */
      var Z_BINARY = 0;
      var Z_TEXT = 1;
      //var Z_ASCII             = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /*============================================================================*/

      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      // From zutil.h

      var STORED_BLOCK = 0;
      var STATIC_TREES = 1;
      var DYN_TREES = 2;
      /* The three kinds of block type */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      /* The minimum and maximum match lengths */

      // From deflate.h
      /* ===========================================================================
       * Internal compression state.
       */

      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */

      var LITERALS = 256;
      /* number of literal bytes 0..255 */

      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */

      var D_CODES = 30;
      /* number of distance codes */

      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */

      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */

      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var Buf_size = 16;
      /* size of bit buffer in bi_buf */

      /* ===========================================================================
       * Constants
       */

      var MAX_BL_BITS = 7;
      /* Bit length codes must not exceed MAX_BL_BITS bits */

      var END_BLOCK = 256;
      /* end of block literal code */

      var REP_3_6 = 16;
      /* repeat previous bit length 3-6 times (2 bits of repeat count) */

      var REPZ_3_10 = 17;
      /* repeat a zero length 3-10 times  (3 bits of repeat count) */

      var REPZ_11_138 = 18;
      /* repeat a zero length 11-138 times  (7 bits of repeat count) */

      var extra_lbits = /* extra bits for each length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
      var extra_dbits = /* extra bits for each distance code */
      [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
      var extra_blbits = /* extra bits for each bit length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
      var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      /* The lengths of the bit length codes are sent in order of decreasing
       * probability, to avoid transmitting the lengths for unused bit length codes.
       */

      /* ===========================================================================
       * Local data. These are initialized only once.
       */

      // We pre-fill arrays with 0 to avoid uninitialized gaps

      var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

      // !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
      var static_ltree = new Array((L_CODES + 2) * 2);
      zero(static_ltree);
      /* The static literal tree. Since the bit lengths are imposed, there is no
       * need for the L_CODES extra codes used during heap construction. However
       * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
       * below).
       */

      var static_dtree = new Array(D_CODES * 2);
      zero(static_dtree);
      /* The static distance tree. (Actually a trivial tree since all codes use
       * 5 bits.)
       */

      var _dist_code = new Array(DIST_CODE_LEN);
      zero(_dist_code);
      /* Distance codes. The first 256 values correspond to the distances
       * 3 .. 258, the last 256 values correspond to the top 8 bits of
       * the 15 bit distances.
       */

      var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
      zero(_length_code);
      /* length code for each normalized match length (0 == MIN_MATCH) */

      var base_length = new Array(LENGTH_CODES);
      zero(base_length);
      /* First normalized length for each code (0 = MIN_MATCH) */

      var base_dist = new Array(D_CODES);
      zero(base_dist);
      /* First normalized distance for each code (0 = distance of 1) */

      var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree; /* static tree or NULL */
        this.extra_bits = extra_bits; /* extra bits for each code or NULL */
        this.extra_base = extra_base; /* base index for extra_bits */
        this.elems = elems; /* max number of elements in the tree */
        this.max_length = max_length; /* max bit length for the codes */

        // show if `static_tree` has data or dummy - needed for monomorphic objects
        this.has_stree = static_tree && static_tree.length;
      };
      var static_l_desc;
      var static_d_desc;
      var static_bl_desc;
      var TreeDesc = function (dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree; /* the dynamic tree */
        this.max_code = 0; /* largest code with non zero frequency */
        this.stat_desc = stat_desc; /* the corresponding static tree */
      };

      function d_code(dist) {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
      }

      /* ===========================================================================
       * Output a short LSB first on the stream.
       * IN assertion: there is enough room in pendingBuf.
       */
      function put_short(s, w) {
        //    put_byte(s, (uch)((w) & 0xff));
        //    put_byte(s, (uch)((ush)(w) >> 8));
        s.pending_buf[s.pending++] = w & 0xff;
        s.pending_buf[s.pending++] = w >>> 8 & 0xff;
      }

      /* ===========================================================================
       * Send a value on a given number of bits.
       * IN assertion: length <= 16 and value fits in length bits.
       */
      function send_bits(s, value, length) {
        if (s.bi_valid > Buf_size - length) {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          put_short(s, s.bi_buf);
          s.bi_buf = value >> Buf_size - s.bi_valid;
          s.bi_valid += length - Buf_size;
        } else {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          s.bi_valid += length;
        }
      }
      function send_code(s, c, tree) {
        send_bits(s, tree[c * 2] /*.Code*/, tree[c * 2 + 1] /*.Len*/);
      }

      /* ===========================================================================
       * Reverse the first len bits of a code, using straightforward code (a faster
       * method would use a table)
       * IN assertion: 1 <= len <= 15
       */
      function bi_reverse(code, len) {
        var res = 0;
        do {
          res |= code & 1;
          code >>>= 1;
          res <<= 1;
        } while (--len > 0);
        return res >>> 1;
      }

      /* ===========================================================================
       * Flush the bit buffer, keeping at most 7 bits in it.
       */
      function bi_flush(s) {
        if (s.bi_valid === 16) {
          put_short(s, s.bi_buf);
          s.bi_buf = 0;
          s.bi_valid = 0;
        } else if (s.bi_valid >= 8) {
          s.pending_buf[s.pending++] = s.bi_buf & 0xff;
          s.bi_buf >>= 8;
          s.bi_valid -= 8;
        }
      }

      /* ===========================================================================
       * Compute the optimal bit lengths for a tree and update the total bit length
       * for the current block.
       * IN assertion: the fields freq and dad are set, heap[heap_max] and
       *    above are the tree nodes sorted by increasing frequency.
       * OUT assertions: the field len is set to the optimal bit length, the
       *     array bl_count contains the frequencies for each bit length.
       *     The length opt_len is updated; static_len is also updated if stree is
       *     not null.
       */
      function gen_bitlen(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc;    /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var max_code = desc.max_code;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var extra = desc.stat_desc.extra_bits;
        var base = desc.stat_desc.extra_base;
        var max_length = desc.stat_desc.max_length;
        var h; /* heap index */
        var n, m; /* iterate over the tree elements */
        var bits; /* bit length */
        var xbits; /* extra bits */
        var f; /* frequency */
        var overflow = 0; /* number of elements with bit length too large */

        for (bits = 0; bits <= MAX_BITS; bits++) {
          s.bl_count[bits] = 0;
        }

        /* In a first pass, compute the optimal bit lengths (which may
         * overflow in the case of the bit length tree).
         */
        tree[s.heap[s.heap_max] * 2 + 1] /*.Len*/ = 0; /* root of the heap */

        for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
          n = s.heap[h];
          bits = tree[tree[n * 2 + 1] /*.Dad*/ * 2 + 1] /*.Len*/ + 1;
          if (bits > max_length) {
            bits = max_length;
            overflow++;
          }
          tree[n * 2 + 1] /*.Len*/ = bits;
          /* We overwrite tree[n].Dad which is no longer needed */

          if (n > max_code) {
            continue;
          } /* not a leaf node */

          s.bl_count[bits]++;
          xbits = 0;
          if (n >= base) {
            xbits = extra[n - base];
          }
          f = tree[n * 2] /*.Freq*/;
          s.opt_len += f * (bits + xbits);
          if (has_stree) {
            s.static_len += f * (stree[n * 2 + 1] /*.Len*/ + xbits);
          }
        }
        if (overflow === 0) {
          return;
        }

        // Trace((stderr,"\nbit length overflow\n"));
        /* This happens for example on obj2 and pic of the Calgary corpus */

        /* Find the first bit length which could increase: */
        do {
          bits = max_length - 1;
          while (s.bl_count[bits] === 0) {
            bits--;
          }
          s.bl_count[bits]--; /* move one leaf down the tree */
          s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
          s.bl_count[max_length]--;
          /* The brother of the overflow item also moves one step up,
           * but this does not affect bl_count[max_length]
           */
          overflow -= 2;
        } while (overflow > 0);

        /* Now recompute all bit lengths, scanning in increasing frequency.
         * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
         * lengths instead of fixing only the wrong ones. This idea is taken
         * from 'ar' written by Haruhiko Okumura.)
         */
        for (bits = max_length; bits !== 0; bits--) {
          n = s.bl_count[bits];
          while (n !== 0) {
            m = s.heap[--h];
            if (m > max_code) {
              continue;
            }
            if (tree[m * 2 + 1] /*.Len*/ !== bits) {
              // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
              s.opt_len += (bits - tree[m * 2 + 1] /*.Len*/) * tree[m * 2] /*.Freq*/;
              tree[m * 2 + 1] /*.Len*/ = bits;
            }
            n--;
          }
        }
      }

      /* ===========================================================================
       * Generate the codes for a given tree and bit counts (which need not be
       * optimal).
       * IN assertion: the array bl_count contains the bit length statistics for
       * the given tree and the field len is set for all tree elements.
       * OUT assertion: the field code is set for all tree elements of non
       *     zero code length.
       */
      function gen_codes(tree, max_code, bl_count)
      //    ct_data *tree;             /* the tree to decorate */
      //    int max_code;              /* largest code with non zero frequency */
      //    ushf *bl_count;            /* number of codes at each bit length */
      {
        var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
        var code = 0; /* running code value */
        var bits; /* bit index */
        var n; /* code index */

        /* The distribution counts are first used to generate the code values
         * without bit reversal.
         */
        for (bits = 1; bits <= MAX_BITS; bits++) {
          next_code[bits] = code = code + bl_count[bits - 1] << 1;
        }
        /* Check that the bit counts in bl_count are consistent. The last code
         * must be all ones.
         */
        //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        //        "inconsistent bit counts");
        //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

        for (n = 0; n <= max_code; n++) {
          var len = tree[n * 2 + 1] /*.Len*/;
          if (len === 0) {
            continue;
          }
          /* Now reverse the bits */
          tree[n * 2] /*.Code*/ = bi_reverse(next_code[len]++, len);

          //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
          //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
        }
      }

      /* ===========================================================================
       * Initialize the various 'constant' tables.
       */
      function tr_static_init() {
        var n; /* iterates over tree elements */
        var bits; /* bit counter */
        var length; /* length value */
        var code; /* code value */
        var dist; /* distance index */
        var bl_count = new Array(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        // do check in _tr_init()
        //if (static_init_done) return;

        /* For some embedded targets, global variables are not initialized: */
        /*#ifdef NO_INIT_GLOBAL_POINTERS
          static_l_desc.static_tree = static_ltree;
          static_l_desc.extra_bits = extra_lbits;
          static_d_desc.static_tree = static_dtree;
          static_d_desc.extra_bits = extra_dbits;
          static_bl_desc.extra_bits = extra_blbits;
        #endif*/

        /* Initialize the mapping length (0..255) -> length code (0..28) */
        length = 0;
        for (code = 0; code < LENGTH_CODES - 1; code++) {
          base_length[code] = length;
          for (n = 0; n < 1 << extra_lbits[code]; n++) {
            _length_code[length++] = code;
          }
        }
        //Assert (length == 256, "tr_static_init: length != 256");
        /* Note that the length 255 (match length 258) can be represented
         * in two different ways: code 284 + 5 bits or code 285, so we
         * overwrite length_code[255] to use the best encoding:
         */
        _length_code[length - 1] = code;

        /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
        dist = 0;
        for (code = 0; code < 16; code++) {
          base_dist[code] = dist;
          for (n = 0; n < 1 << extra_dbits[code]; n++) {
            _dist_code[dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: dist != 256");
        dist >>= 7; /* from now on, all distances are divided by 128 */
        for (; code < D_CODES; code++) {
          base_dist[code] = dist << 7;
          for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
            _dist_code[256 + dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: 256+dist != 512");

        /* Construct the codes of the static literal tree */
        for (bits = 0; bits <= MAX_BITS; bits++) {
          bl_count[bits] = 0;
        }
        n = 0;
        while (n <= 143) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        while (n <= 255) {
          static_ltree[n * 2 + 1] /*.Len*/ = 9;
          n++;
          bl_count[9]++;
        }
        while (n <= 279) {
          static_ltree[n * 2 + 1] /*.Len*/ = 7;
          n++;
          bl_count[7]++;
        }
        while (n <= 287) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        /* Codes 286 and 287 do not exist, but we must include them in the
         * tree construction to get a canonical Huffman tree (longest code
         * all ones)
         */
        gen_codes(static_ltree, L_CODES + 1, bl_count);

        /* The static distance tree is trivial: */
        for (n = 0; n < D_CODES; n++) {
          static_dtree[n * 2 + 1] /*.Len*/ = 5;
          static_dtree[n * 2] /*.Code*/ = bi_reverse(n, 5);
        }

        // Now data ready and we can init static trees
        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
        static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
        static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);

        //static_init_done = true;
      }

      /* ===========================================================================
       * Initialize a new block.
       */
      function init_block(s) {
        var n; /* iterates over tree elements */

        /* Initialize the trees. */
        for (n = 0; n < L_CODES; n++) {
          s.dyn_ltree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < D_CODES; n++) {
          s.dyn_dtree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < BL_CODES; n++) {
          s.bl_tree[n * 2] /*.Freq*/ = 0;
        }
        s.dyn_ltree[END_BLOCK * 2] /*.Freq*/ = 1;
        s.opt_len = s.static_len = 0;
        s.last_lit = s.matches = 0;
      }

      /* ===========================================================================
       * Flush the bit buffer and align the output on a byte boundary
       */
      function bi_windup(s) {
        if (s.bi_valid > 8) {
          put_short(s, s.bi_buf);
        } else if (s.bi_valid > 0) {
          //put_byte(s, (Byte)s->bi_buf);
          s.pending_buf[s.pending++] = s.bi_buf;
        }
        s.bi_buf = 0;
        s.bi_valid = 0;
      }

      /* ===========================================================================
       * Copy a stored block, storing first the length and its
       * one's complement if requested.
       */
      function copy_block(s, buf, len, header)
      //DeflateState *s;
      //charf    *buf;    /* the input data */
      //unsigned len;     /* its length */
      //int      header;  /* true if block header must be written */
      {
        bi_windup(s); /* align on byte boundary */

        if (header) {
          put_short(s, len);
          put_short(s, ~len);
        }
        //  while (len--) {
        //    put_byte(s, *buf++);
        //  }
        utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
        s.pending += len;
      }

      /* ===========================================================================
       * Compares to subtrees, using the tree depth as tie breaker when
       * the subtrees have equal frequency. This minimizes the worst case length.
       */
      function smaller(tree, n, m, depth) {
        var _n2 = n * 2;
        var _m2 = m * 2;
        return tree[_n2] /*.Freq*/ < tree[_m2] /*.Freq*/ || tree[_n2] /*.Freq*/ === tree[_m2] /*.Freq*/ && depth[n] <= depth[m];
      }

      /* ===========================================================================
       * Restore the heap property by moving down the tree starting at node k,
       * exchanging a node with the smallest of its two sons if necessary, stopping
       * when the heap property is re-established (each father smaller than its
       * two sons).
       */
      function pqdownheap(s, tree, k)
      //    deflate_state *s;
      //    ct_data *tree;  /* the tree to restore */
      //    int k;               /* node to move down */
      {
        var v = s.heap[k];
        var j = k << 1; /* left son of k */
        while (j <= s.heap_len) {
          /* Set j to the smallest of the two sons: */
          if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
            j++;
          }
          /* Exit if v is smaller than both sons */
          if (smaller(tree, v, s.heap[j], s.depth)) {
            break;
          }

          /* Exchange v with the smallest son */
          s.heap[k] = s.heap[j];
          k = j;

          /* And continue down the tree, setting j to the left son of k */
          j <<= 1;
        }
        s.heap[k] = v;
      }

      // inlined manually
      // var SMALLEST = 1;

      /* ===========================================================================
       * Send the block data compressed using the given Huffman trees
       */
      function compress_block(s, ltree, dtree)
      //    deflate_state *s;
      //    const ct_data *ltree; /* literal tree */
      //    const ct_data *dtree; /* distance tree */
      {
        var dist; /* distance of matched string */
        var lc; /* match length or unmatched char (if dist == 0) */
        var lx = 0; /* running index in l_buf */
        var code; /* the code to send */
        var extra; /* number of extra bits to send */

        if (s.last_lit !== 0) {
          do {
            dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
            lc = s.pending_buf[s.l_buf + lx];
            lx++;
            if (dist === 0) {
              send_code(s, lc, ltree); /* send a literal byte */
              //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
            } else {
              /* Here, lc is the match length - MIN_MATCH */
              code = _length_code[lc];
              send_code(s, code + LITERALS + 1, ltree); /* send the length code */
              extra = extra_lbits[code];
              if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */
              }

              dist--; /* dist is now the match distance - 1 */
              code = d_code(dist);
              //Assert (code < D_CODES, "bad d_code");

              send_code(s, code, dtree); /* send the distance code */
              extra = extra_dbits[code];
              if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */
              }
            } /* literal or match pair ? */

            /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
            //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
            //       "pendingBuf overflow");
          } while (lx < s.last_lit);
        }
        send_code(s, END_BLOCK, ltree);
      }

      /* ===========================================================================
       * Construct one Huffman tree and assigns the code bit strings and lengths.
       * Update the total bit length for the current block.
       * IN assertion: the field freq is set for all tree elements.
       * OUT assertions: the fields len and code are set to the optimal bit length
       *     and corresponding code. The length opt_len is updated; static_len is
       *     also updated if stree is not null. The field max_code is set.
       */
      function build_tree(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc; /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var elems = desc.stat_desc.elems;
        var n, m; /* iterate over heap elements */
        var max_code = -1; /* largest code with non zero frequency */
        var node; /* new node being created */

        /* Construct the initial heap, with least frequent element in
         * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
         * heap[0] is not used.
         */
        s.heap_len = 0;
        s.heap_max = HEAP_SIZE;
        for (n = 0; n < elems; n++) {
          if (tree[n * 2] /*.Freq*/ !== 0) {
            s.heap[++s.heap_len] = max_code = n;
            s.depth[n] = 0;
          } else {
            tree[n * 2 + 1] /*.Len*/ = 0;
          }
        }

        /* The pkzip format requires that at least one distance code exists,
         * and that at least one bit should be sent even if there is only one
         * possible code. So to avoid special checks later on we force at least
         * two codes of non zero frequency.
         */
        while (s.heap_len < 2) {
          node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
          tree[node * 2] /*.Freq*/ = 1;
          s.depth[node] = 0;
          s.opt_len--;
          if (has_stree) {
            s.static_len -= stree[node * 2 + 1] /*.Len*/;
          }
          /* node is 0 or 1 so it does not have extra bits */
        }

        desc.max_code = max_code;

        /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
         * establish sub-heaps of increasing lengths:
         */
        for (n = s.heap_len >> 1 /*int /2*/; n >= 1; n--) {
          pqdownheap(s, tree, n);
        }

        /* Construct the Huffman tree by repeatedly combining the least two
         * frequent nodes.
         */
        node = elems; /* next internal node of the tree */
        do {
          //pqremove(s, tree, n);  /* n = node of least frequency */
          /*** pqremove ***/
          n = s.heap[1 /*SMALLEST*/];
          s.heap[1 /*SMALLEST*/] = s.heap[s.heap_len--];
          pqdownheap(s, tree, 1 /*SMALLEST*/);
          /***/

          m = s.heap[1 /*SMALLEST*/]; /* m = node of next least frequency */

          s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
          s.heap[--s.heap_max] = m;

          /* Create a new node father of n and m */
          tree[node * 2] /*.Freq*/ = tree[n * 2] /*.Freq*/ + tree[m * 2] /*.Freq*/;
          s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
          tree[n * 2 + 1] /*.Dad*/ = tree[m * 2 + 1] /*.Dad*/ = node;

          /* and insert the new node in the heap */
          s.heap[1 /*SMALLEST*/] = node++;
          pqdownheap(s, tree, 1 /*SMALLEST*/);
        } while (s.heap_len >= 2);
        s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/];

        /* At this point, the fields freq and dad are set. We can now
         * generate the bit lengths.
         */
        gen_bitlen(s, desc);

        /* The field len is now set, we can generate the bit codes */
        gen_codes(tree, max_code, s.bl_count);
      }

      /* ===========================================================================
       * Scan a literal or distance tree to determine the frequencies of the codes
       * in the bit length tree.
       */
      function scan_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree;   /* the tree to be scanned */
      //    int max_code;    /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] /*.Len*/ = 0xffff; /* guard */

        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            s.bl_tree[curlen * 2] /*.Freq*/ += count;
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              s.bl_tree[curlen * 2] /*.Freq*/++;
            }
            s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
          } else if (count <= 10) {
            s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
          } else {
            s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
          }

          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Send a literal or distance tree in compressed form, using the codes in
       * bl_tree.
       */
      function send_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree; /* the tree to be scanned */
      //    int max_code;       /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        /* tree[max_code+1].Len = -1; */ /* guard already set */
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            do {
              send_code(s, curlen, s.bl_tree);
            } while (--count !== 0);
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              send_code(s, curlen, s.bl_tree);
              count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
          } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
          } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Construct the Huffman tree for the bit lengths and return the index in
       * bl_order of the last bit length code to send.
       */
      function build_bl_tree(s) {
        var max_blindex; /* index of last bit length code of non zero freq */

        /* Determine the bit length frequencies for literal and distance trees */
        scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
        scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

        /* Build the bit length tree: */
        build_tree(s, s.bl_desc);
        /* opt_len now includes the length of the tree representations, except
         * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
         */

        /* Determine the number of bit length codes to send. The pkzip format
         * requires that at least 4 bit length codes be sent. (appnote.txt says
         * 3 but the actual value used is 4.)
         */
        for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
          if (s.bl_tree[bl_order[max_blindex] * 2 + 1] /*.Len*/ !== 0) {
            break;
          }
        }
        /* Update opt_len to include the bit length tree and counts */
        s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
        //        s->opt_len, s->static_len));

        return max_blindex;
      }

      /* ===========================================================================
       * Send the header for a block using dynamic Huffman trees: the counts, the
       * lengths of the bit length codes, the literal tree and the distance tree.
       * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
       */
      function send_all_trees(s, lcodes, dcodes, blcodes)
      //    deflate_state *s;
      //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
      {
        var rank; /* index in bl_order */

        //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
        //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
        //        "too many codes");
        //Tracev((stderr, "\nbl counts: "));
        send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
        send_bits(s, dcodes - 1, 5);
        send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
        for (rank = 0; rank < blcodes; rank++) {
          //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
          send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1] /*.Len*/, 3);
        }
        //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
        //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
        //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
      }

      /* ===========================================================================
       * Check if the data type is TEXT or BINARY, using the following algorithm:
       * - TEXT if the two conditions below are satisfied:
       *    a) There are no non-portable control characters belonging to the
       *       "black list" (0..6, 14..25, 28..31).
       *    b) There is at least one printable character belonging to the
       *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
       * - BINARY otherwise.
       * - The following partially-portable control characters form a
       *   "gray list" that is ignored in this detection algorithm:
       *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
       * IN assertion: the fields Freq of dyn_ltree are set.
       */
      function detect_data_type(s) {
        /* black_mask is the bit mask of black-listed bytes
         * set bits 0..6, 14..25, and 28..31
         * 0xf3ffc07f = binary 11110011111111111100000001111111
         */
        var black_mask = 0xf3ffc07f;
        var n;

        /* Check for non-textual ("black-listed") bytes. */
        for (n = 0; n <= 31; n++, black_mask >>>= 1) {
          if (black_mask & 1 && s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_BINARY;
          }
        }

        /* Check for textual ("white-listed") bytes. */
        if (s.dyn_ltree[9 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[10 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[13 * 2] /*.Freq*/ !== 0) {
          return Z_TEXT;
        }
        for (n = 32; n < LITERALS; n++) {
          if (s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_TEXT;
          }
        }

        /* There are no "black-listed" or "white-listed" bytes:
         * this stream either is empty or has tolerated ("gray-listed") bytes only.
         */
        return Z_BINARY;
      }
      var static_init_done = false;

      /* ===========================================================================
       * Initialize the tree data structures for a new zlib stream.
       */
      function _tr_init(s) {
        if (!static_init_done) {
          tr_static_init();
          static_init_done = true;
        }
        s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
        s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
        s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
        s.bi_buf = 0;
        s.bi_valid = 0;

        /* Initialize the first block of the first file: */
        init_block(s);
      }

      /* ===========================================================================
       * Send a stored block
       */
      function _tr_stored_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */
        copy_block(s, buf, stored_len, true); /* with header */
      }

      /* ===========================================================================
       * Send one empty static block to give enough lookahead for inflate.
       * This takes 10 bits, of which 7 may remain in the bit buffer.
       */
      function _tr_align(s) {
        send_bits(s, STATIC_TREES << 1, 3);
        send_code(s, END_BLOCK, static_ltree);
        bi_flush(s);
      }

      /* ===========================================================================
       * Determine the best encoding for the current block: dynamic trees, static
       * trees or store, and output the encoded block to the zip file.
       */
      function _tr_flush_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block, or NULL if too old */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        var opt_lenb, static_lenb; /* opt_len and static_len in bytes */
        var max_blindex = 0; /* index of last bit length code of non zero freq */

        /* Build the Huffman trees unless a stored block is forced */
        if (s.level > 0) {
          /* Check if the file is binary or text */
          if (s.strm.data_type === Z_UNKNOWN) {
            s.strm.data_type = detect_data_type(s);
          }

          /* Construct the literal and distance trees */
          build_tree(s, s.l_desc);
          // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));

          build_tree(s, s.d_desc);
          // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));
          /* At this point, opt_len and static_len are the total bit lengths of
           * the compressed block data, excluding the tree representations.
           */

          /* Build the bit length tree for the above two trees, and get the index
           * in bl_order of the last bit length code to send.
           */
          max_blindex = build_bl_tree(s);

          /* Determine the best encoding. Compute the block lengths in bytes. */
          opt_lenb = s.opt_len + 3 + 7 >>> 3;
          static_lenb = s.static_len + 3 + 7 >>> 3;

          // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
          //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
          //        s->last_lit));

          if (static_lenb <= opt_lenb) {
            opt_lenb = static_lenb;
          }
        } else {
          // Assert(buf != (char*)0, "lost buf");
          opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
        }

        if (stored_len + 4 <= opt_lenb && buf !== -1) {
          /* 4: two words for the lengths */

          /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
           * Otherwise we can't have processed more than WSIZE input bytes since
           * the last block flush, because compression would have been
           * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
           * transform a block into a stored block.
           */
          _tr_stored_block(s, buf, stored_len, last);
        } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
          send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
          compress_block(s, static_ltree, static_dtree);
        } else {
          send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
          send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
          compress_block(s, s.dyn_ltree, s.dyn_dtree);
        }
        // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
        /* The above check is made mod 2^32, for files larger than 512 MB
         * and uLong implemented on 32 bits.
         */
        init_block(s);
        if (last) {
          bi_windup(s);
        }
        // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
        //       s->compressed_len-7*last));
      }

      /* ===========================================================================
       * Save the match info and tally the frequency counts. Return true if
       * the current block must be flushed.
       */
      function _tr_tally(s, dist, lc)
      //    deflate_state *s;
      //    unsigned dist;  /* distance of matched string */
      //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
      {
        //var out_length, in_length, dcode;

        s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
        s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
        s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
        s.last_lit++;
        if (dist === 0) {
          /* lc is the unmatched char */
          s.dyn_ltree[lc * 2] /*.Freq*/++;
        } else {
          s.matches++;
          /* Here, lc is the match length - MIN_MATCH */
          dist--; /* dist = match distance - 1 */
          //Assert((ush)dist < (ush)MAX_DIST(s) &&
          //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
          //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

          s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
          s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
        }

        // (!) This block is disabled in zlib defailts,
        // don't enable it for binary compatibility

        //#ifdef TRUNCATE_BLOCK
        //  /* Try to guess if it is profitable to stop the current block here */
        //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
        //    /* Compute an upper bound for the compressed length */
        //    out_length = s.last_lit*8;
        //    in_length = s.strstart - s.block_start;
        //
        //    for (dcode = 0; dcode < D_CODES; dcode++) {
        //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
        //    }
        //    out_length >>>= 3;
        //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
        //    //       s->last_lit, in_length, out_length,
        //    //       100L - out_length*100L/in_length));
        //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
        //      return true;
        //    }
        //  }
        //#endif

        return s.last_lit === s.lit_bufsize - 1;
        /* We avoid equality with lit_bufsize because of wraparound at 64K
         * on 16 bit machines and because stored blocks are restricted to
         * 64K-1 bytes.
         */
      }

      exports._tr_init = _tr_init;
      exports._tr_stored_block = _tr_stored_block;
      exports._tr_flush_block = _tr_flush_block;
      exports._tr_tally = _tr_tally;
      exports._tr_align = _tr_align;
    }, {
      "../utils/common": 27
    }],
    39: [function (_dereq_, module, exports) {
      'use strict';

      function ZStream() {
        /* next input byte */
        this.input = null; // JS specific, because we have no pointers
        this.next_in = 0;
        /* number of bytes available at input */
        this.avail_in = 0;
        /* total number of input bytes read so far */
        this.total_in = 0;
        /* next output byte should be put there */
        this.output = null; // JS specific, because we have no pointers
        this.next_out = 0;
        /* remaining free space at output */
        this.avail_out = 0;
        /* total number of bytes output so far */
        this.total_out = 0;
        /* last error message, NULL if no error */
        this.msg = '' /*Z_NULL*/;
        /* not visible by applications */
        this.state = null;
        /* best guess about the data type: binary or text */
        this.data_type = 2 /*Z_UNKNOWN*/;
        /* adler32 value of the uncompressed data */
        this.adler = 0;
      }
      module.exports = ZStream;
    }, {}]
  }, {}, [9])(9);
});
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */var XLSX={};function make_xlsx_lib(XLSX){XLSX.version='0.17.5';var current_codepage=1200,current_ansi=1252;/*global cptable:true, window */if(typeof module!=="undefined"&&typeof require!=='undefined'){if(typeof cptable==='undefined'){if(typeof global!=='undefined')global.cptable=require('./dist/cpexcel.js');else if(typeof window!=='undefined')window.cptable=require('./dist/cpexcel.js');}}var VALID_ANSI=[874,932,936,949,950];for(var i=0;i<=8;++i)VALID_ANSI.push(1250+i);/* ECMA-376 Part I 18.4.1 charset to codepage mapping */var CS2CP={0:1252,/* ANSI */1:65001,/* DEFAULT */2:65001,/* SYMBOL */77:10000,/* MAC */128:932,/* SHIFTJIS */129:949,/* HANGUL */130:1361,/* JOHAB */134:936,/* GB2312 */136:950,/* CHINESEBIG5 */161:1253,/* GREEK */162:1254,/* TURKISH */163:1258,/* VIETNAMESE */177:1255,/* HEBREW */178:1256,/* ARABIC */186:1257,/* BALTIC */204:1251,/* RUSSIAN */222:874,/* THAI */238:1250,/* EASTEUROPE */255:1252,/* OEM */69:6969/* MISC */};var set_ansi=function(cp){if(VALID_ANSI.indexOf(cp)==-1)return;current_ansi=CS2CP[0]=cp;};function reset_ansi(){set_ansi(1252);}var set_cp=function(cp){current_codepage=cp;set_ansi(cp);};function reset_cp(){set_cp(1200);reset_ansi();}function char_codes(data){var o=[];for(var i=0,len=data.length;i<len;++i)o[i]=data.charCodeAt(i);return o;}function utf16leread(data){var o=[];for(var i=0;i<data.length>>1;++i)o[i]=String.fromCharCode(data.charCodeAt(2*i)+(data.charCodeAt(2*i+1)<<8));return o.join("");}function utf16beread(data){var o=[];for(var i=0;i<data.length>>1;++i)o[i]=String.fromCharCode(data.charCodeAt(2*i+1)+(data.charCodeAt(2*i)<<8));return o.join("");}var debom=function(data){var c1=data.charCodeAt(0),c2=data.charCodeAt(1);if(c1==0xFF&&c2==0xFE)return utf16leread(data.slice(2));if(c1==0xFE&&c2==0xFF)return utf16beread(data.slice(2));if(c1==0xFEFF)return data.slice(1);return data;};var _getchar=function _gc1(x){return String.fromCharCode(x);};var _getansi=function _ga1(x){return String.fromCharCode(x);};if(typeof cptable!=='undefined'){set_cp=function(cp){current_codepage=cp;set_ansi(cp);};debom=function(data){if(data.charCodeAt(0)===0xFF&&data.charCodeAt(1)===0xFE){return cptable.utils.decode(1200,char_codes(data.slice(2)));}return data;};_getchar=function _gc2(x){if(current_codepage===1200)return String.fromCharCode(x);return cptable.utils.decode(current_codepage,[x&255,x>>8])[0];};_getansi=function _ga2(x){return cptable.utils.decode(current_ansi,[x])[0];};}var DENSE=null;var DIF_XL=true;var Base64=function make_b64(){var map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;for(var i=0;i<input.length;){c1=input.charCodeAt(i++);e1=c1>>2;c2=input.charCodeAt(i++);e2=(c1&3)<<4|c2>>4;c3=input.charCodeAt(i++);e3=(c2&15)<<2|c3>>6;e4=c3&63;if(isNaN(c2)){e3=e4=64;}else if(isNaN(c3)){e4=64;}o+=map.charAt(e1)+map.charAt(e2)+map.charAt(e3)+map.charAt(e4);}return o;},decode:function b64_decode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;input=input.replace(/[^\w\+\/\=]/g,"");for(var i=0;i<input.length;){e1=map.indexOf(input.charAt(i++));e2=map.indexOf(input.charAt(i++));c1=e1<<2|e2>>4;o+=String.fromCharCode(c1);e3=map.indexOf(input.charAt(i++));c2=(e2&15)<<4|e3>>2;if(e3!==64){o+=String.fromCharCode(c2);}e4=map.indexOf(input.charAt(i++));c3=(e3&3)<<6|e4;if(e4!==64){o+=String.fromCharCode(c3);}}return o;}};}();var has_buf=typeof Buffer!=='undefined'&&typeof process!=='undefined'&&typeof process.versions!=='undefined'&&!!process.versions.node;var Buffer_from=function(){};if(typeof Buffer!=='undefined'){var nbfs=!Buffer.from;if(!nbfs)try{Buffer.from("foo","utf8");}catch(e){nbfs=true;}Buffer_from=nbfs?function(buf,enc){return enc?new Buffer(buf,enc):new Buffer(buf);}:Buffer.from.bind(Buffer);// $FlowIgnore
if(!Buffer.alloc)Buffer.alloc=function(n){return new Buffer(n);};// $FlowIgnore
if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(n){return new Buffer(n);};}function new_raw_buf(len){/* jshint -W056 */return has_buf?Buffer.alloc(len):new Array(len);/* jshint +W056 */}function new_unsafe_buf(len){/* jshint -W056 */return has_buf?Buffer.allocUnsafe(len):new Array(len);/* jshint +W056 */}var s2a=function s2a(s){if(has_buf)return Buffer_from(s,"binary");return s.split("").map(function(x){return x.charCodeAt(0)&0xff;});};function s2ab(s){if(typeof ArrayBuffer==='undefined')return s2a(s);var buf=new ArrayBuffer(s.length),view=new Uint8Array(buf);for(var i=0;i!=s.length;++i)view[i]=s.charCodeAt(i)&0xFF;return buf;}function a2s(data){if(Array.isArray(data))return data.map(function(c){return String.fromCharCode(c);}).join("");var o=[];for(var i=0;i<data.length;++i)o[i]=String.fromCharCode(data[i]);return o.join("");}function a2u(data){if(typeof Uint8Array==='undefined')throw new Error("Unsupported");return new Uint8Array(data);}function ab2a(data){if(typeof ArrayBuffer=='undefined')throw new Error("Unsupported");if(data instanceof ArrayBuffer)return ab2a(new Uint8Array(data));var o=new Array(data.length);for(var i=0;i<data.length;++i)o[i]=data[i];return o;}var bconcat=function(bufs){return[].concat.apply([],bufs);};var chr0=/\u0000/g,chr1=/[\u0001-\u0006]/g;/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */var SSF={};var make_ssf=function make_ssf(SSF){SSF.version='0.11.2';function _strrev(x){var o="",i=x.length-1;while(i>=0)o+=x.charAt(i--);return o;}function fill(c,l){var o="";while(o.length<l)o+=c;return o;}function pad0(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}function rpad_(v,d){var t=""+v;return t.length>=d?t:t+fill(' ',d-t.length);}function pad0r1(v,d){var t=""+Math.round(v);return t.length>=d?t:fill('0',d-t.length)+t;}function pad0r2(v,d){var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}var p2_32=Math.pow(2,32);function pad0r(v,d){if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d);}function isgeneral(s,i){i=i||0;return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108;}var days=[['Sun','Sunday'],['Mon','Monday'],['Tue','Tuesday'],['Wed','Wednesday'],['Thu','Thursday'],['Fri','Friday'],['Sat','Saturday']];var months=[['J','Jan','January'],['F','Feb','February'],['M','Mar','March'],['A','Apr','April'],['M','May','May'],['J','Jun','June'],['J','Jul','July'],['A','Aug','August'],['S','Sep','September'],['O','Oct','October'],['N','Nov','November'],['D','Dec','December']];function init_table(t){t[0]='General';t[1]='0';t[2]='0.00';t[3]='#,##0';t[4]='#,##0.00';t[9]='0%';t[10]='0.00%';t[11]='0.00E+00';t[12]='# ?/?';t[13]='# ??/??';t[14]='m/d/yy';t[15]='d-mmm-yy';t[16]='d-mmm';t[17]='mmm-yy';t[18]='h:mm AM/PM';t[19]='h:mm:ss AM/PM';t[20]='h:mm';t[21]='h:mm:ss';t[22]='m/d/yy h:mm';t[37]='#,##0 ;(#,##0)';t[38]='#,##0 ;[Red](#,##0)';t[39]='#,##0.00;(#,##0.00)';t[40]='#,##0.00;[Red](#,##0.00)';t[45]='mm:ss';t[46]='[h]:mm:ss';t[47]='mmss.0';t[48]='##0.0E+0';t[49]='@';t[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';}var table_fmt={};init_table(table_fmt);/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */var default_map=[];var defi=0;//  5 -> 37 ...  8 -> 40
for(defi=5;defi<=8;++defi)default_map[defi]=32+defi;// 23 ->  0 ... 26 ->  0
for(defi=23;defi<=26;++defi)default_map[defi]=0;// 27 -> 14 ... 31 -> 14
for(defi=27;defi<=31;++defi)default_map[defi]=14;// 50 -> 14 ... 58 -> 14
for(defi=50;defi<=58;++defi)default_map[defi]=14;// 59 ->  1 ... 62 ->  4
for(defi=59;defi<=62;++defi)default_map[defi]=defi-58;// 67 ->  9 ... 68 -> 10
for(defi=67;defi<=68;++defi)default_map[defi]=defi-58;// 72 -> 14 ... 75 -> 17
for(defi=72;defi<=75;++defi)default_map[defi]=defi-58;// 69 -> 12 ... 71 -> 14
for(defi=67;defi<=68;++defi)default_map[defi]=defi-57;// 76 -> 20 ... 78 -> 22
for(defi=76;defi<=78;++defi)default_map[defi]=defi-56;// 79 -> 45 ... 81 -> 47
for(defi=79;defi<=81;++defi)default_map[defi]=defi-34;// 82 ->  0 ... 65536 -> 0 (omitted)
/* These formats technically refer to Accounting formats with no equivalent */var default_str=[];//  5 -- Currency,   0 decimal, black negative
default_str[5]=default_str[63]='"$"#,##0_);\\("$"#,##0\\)';//  6 -- Currency,   0 decimal, red   negative
default_str[6]=default_str[64]='"$"#,##0_);[Red]\\("$"#,##0\\)';//  7 -- Currency,   2 decimal, black negative
default_str[7]=default_str[65]='"$"#,##0.00_);\\("$"#,##0.00\\)';//  8 -- Currency,   2 decimal, red   negative
default_str[8]=default_str[66]='"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';// 41 -- Accounting, 0 decimal, No Symbol
default_str[41]='_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';// 42 -- Accounting, 0 decimal, $  Symbol
default_str[42]='_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';// 43 -- Accounting, 2 decimal, No Symbol
default_str[43]='_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';// 44 -- Accounting, 2 decimal, $  Symbol
default_str[44]='_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';function frac(x,D,mixed){var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<0.00000005)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q;}if(Q>D){if(Q_1>D){Q=Q_2;P=P_2;}else{Q=Q_1;P=P_1;}}if(!mixed)return[0,sgn*P,Q];var q=Math.floor(sgn*P/Q);return[q,sgn*P-q*Q,Q];}function parse_date_code(v,opts,b2){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;if(opts&&opts.date1904)date+=1462;if(out.u>0.9999){out.u=0;if(++time==86400){out.T=time=0;++date;++out.D;}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3;}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6;}else{if(date>60)--date;/* 1 = Jan 1 1900 in Gregorian */var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=fix_hijri(d,dout);}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out;}SSF.parse_date_code=parse_date_code;var basedate=new Date(1899,11,31,0,0,0);var dnthresh=basedate.getTime();var base1904=new Date(1900,2,1,0,0,0);function datenum_local(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1461*24*60*60*1000;else if(v>=base1904)epoch+=24*60*60*1000;return(epoch-(dnthresh+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000))/(24*60*60*1000);}/* The longest 32-bit integer text is "-4294967296", exactly 11 chars */function general_fmt_int(v){return v.toString(10);}SSF._general_int=general_fmt_int;/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */var general_fmt_num=function make_general_fmt_num(){var trailing_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)$/;function strip_decimal(o){return o.indexOf(".")==-1?o:o.replace(trailing_zeroes_and_decimal,"$1");}/* General Exponential always shows 2 digits exp and trims the mantissa */var mantissa_zeroes_and_decimal=/(?:\.0*|(\.\d*[1-9])0+)[Ee]/;var exp_with_single_digit=/(E[+-])(\d)$/;function normalize_exp(o){if(o.indexOf("E")==-1)return o;return o.replace(mantissa_zeroes_and_decimal,"$1E").replace(exp_with_single_digit,"$10$2");}/* exponent >= -9 and <= 9 */function small_exp(v){var w=v<0?12:11;var o=strip_decimal(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return v.toExponential(5);}/* exponent >= 11 or <= -10 likely exponential */function large_exp(v){var o=strip_decimal(v.toFixed(11));return o.length>(v<0?12:11)||o==="0"||o==="-0"?v.toPrecision(6):o;}function general_fmt_num_base(v){var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=small_exp(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=large_exp(v);return strip_decimal(normalize_exp(o.toUpperCase()));}return general_fmt_num_base;}();SSF._general_num=general_fmt_num;/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	TODO: technically the display depends on the width of the cell
*/function general_fmt(v,opts){switch(typeof v){case'string':return v;case'boolean':return v?"TRUE":"FALSE";case'number':return(v|0)===v?v.toString(10):general_fmt_num(v);case'undefined':return"";case'object':if(v==null)return"";if(v instanceof Date)return format(14,datenum_local(v,opts&&opts.date1904),opts);}throw new Error("unsupported value in General format: "+v);}SSF._general=general_fmt;function fix_hijri(date,o){/* TODO: properly adjust y/m/d and  */o[0]-=581;var dow=date.getDay();if(date<60)dow=(dow+6)%7;return dow;}//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
/*jshint -W086 */function write_date(type,fmt,val,ss0){var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:/* 'b' buddhist year */y=val.y+543;/* falls through */case 121:/* 'y' year */switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%10000;outl=4;break;}break;case 109:/* 'm' month */switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2];}break;case 100:/* 'd' day */switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1];}break;case 104:/* 'h' 12-hour */switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 72:/* 'H' 24-hour */switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 77:/* 'M' minutes */switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw'bad minute format: '+fmt;}break;case 115:/* 's' seconds */if(fmt!='s'&&fmt!='ss'&&fmt!='.0'&&fmt!='.00'&&fmt!='.000')throw'bad second format: '+fmt;if(val.u===0&&(fmt=="s"||fmt=="ss"))return pad0(val.S,fmt.length);if(ss0>=2)tt=ss0===3?1000:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==='s')return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==='ss')return o.substr(0,2);return"."+o.substr(2,fmt.length-1);case 90:/* 'Z' absolute time */switch(fmt){case'[h]':case'[hh]':out=val.D*24+val.H;break;case'[m]':case'[mm]':out=(val.D*24+val.H)*60+val.M;break;case'[s]':case'[ss]':out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw'bad abstime format: '+fmt;}outl=fmt.length===3?1:2;break;case 101:/* 'e' era */out=y;outl=1;break;}var outstr=outl>0?pad0(out,outl):"";return outstr;}/*jshint +W086 */function commaify(s){var w=3;if(s.length<=w)return s;var j=s.length%w,o=s.substr(0,j);for(;j!=s.length;j+=w)o+=(o.length>0?",":"")+s.substr(j,w);return o;}var write_num=function make_write_num(){var pct1=/%/g;function write_num_pct(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_cm(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_exp(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o.charAt(0)+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");}o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r,aval,sign){var den=parseInt(r[4],10),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length));}function write_num_f2(r,aval,sign){return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length);}var dec1=/^#*0*\.([0#]+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str){var o="",cc;for(var i=0;i!=str.length;++i)switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc);}return o;}function rnd(val,d){var dd=Math.pow(10,d);return""+Math.round(val*dd)/dd;}function dec(val,d){var _frac=val-Math.floor(val),dd=Math.pow(10,d);if(d<(''+Math.round(_frac*dd)).length)return 0;return Math.round(_frac*dd);}function carry(val,d){if(d<(''+Math.round((val-Math.floor(val))*Math.pow(10,d))).length){return 1;}return 0;}function flr(val){if(val<2147483647&&val>-2147483648)return""+(val>=0?val|0:val-1|0);return""+Math.floor(val);}function write_num_flt(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt('n',ffmt,val);return'('+write_num_flt('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(pad0r(aval,0));if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+(Math.floor(val)+carry(val,r[1].length)))+"."+pad0(dec(val,r[1].length),r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_flt(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0?]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(ri,r[1].length);}switch(fmt){case"###,##0.00":return write_num_flt(type,"#,##0.00",val);case"###,###":case"##,###":case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";case"###,###.00":return write_num_flt(type,"###,##0.00",val).replace(/^0\./,".");case"#,###.00":return write_num_flt(type,"#,##0.00",val).replace(/^0\./,".");default:}throw new Error("unsupported format |"+fmt+"|");}function write_num_cm2(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_pct2(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_exp2(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp2(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}function write_num_int(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int('n',ffmt,val);return'('+write_num_int('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=(""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));o=o.replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(""+aval);if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill('0',r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_int(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(0,r[1].length);}switch(fmt){case"###,###":case"##,###":case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:if(fmt.match(/\.[0#?]*$/))return write_num_int(type,fmt.slice(0,fmt.lastIndexOf(".")),val)+hashq(fmt.slice(fmt.lastIndexOf(".")));}throw new Error("unsupported format |"+fmt+"|");}return function write_num(type,fmt,val){return(val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val);};}();function split_fmt(fmt){var out=[];var in_str=false/*, cc*/;for(var i=0,j=0;i<fmt.length;++i)switch(/*cc=*/fmt.charCodeAt(i)){case 34:/* '"' */in_str=!in_str;break;case 95:case 42:case 92:/* '_' '*' '\\' */++i;break;case 59:/* ';' */out[out.length]=fmt.substr(j,i-j);j=i+1;}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out;}SSF._split=split_fmt;var abstime=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function fmt_is_date(fmt){var i=0,/*cc = 0,*/c="",o="";while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':if(isgeneral(fmt,i))i+=6;i++;break;case'"':for(;/*cc=*/fmt.charCodeAt(++i)!==34&&i<fmt.length;){/*empty*/}++i;break;case'\\':i+=2;break;case'_':i+=2;break;case'@':++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2")return true;/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':return true;case'A':case'a':case'上':if(fmt.substr(i,3).toUpperCase()==="A/P")return true;if(fmt.substr(i,5).toUpperCase()==="AM/PM")return true;if(fmt.substr(i,5).toUpperCase()==="上午/下午")return true;++i;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length)o+=fmt.charAt(i);if(o.match(abstime))return true;break;case'.':/* falls through */case'0':case'#':while(i<fmt.length&&("0#?.,E+-%".indexOf(c=fmt.charAt(++i))>-1||c=='\\'&&fmt.charAt(i+1)=="-"&&"0#".indexOf(fmt.charAt(i+2))>-1)){/* empty */}break;case'?':while(fmt.charAt(++i)===c){/* empty */}break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;case'(':case')':++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){/* empty */}break;case' ':++i;break;default:++i;break;}}return false;}SSF.is_date=fmt_is_date;function eval_fmt(fmt,v,opts,flen){var out=[],o="",i=0,c="",lst='t',dt,j,cc;var hr='H';/* Tokenize */while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':/* General */if(!isgeneral(fmt,i))throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'G',v:'General'};i+=7;break;case'"':/* Literal text */for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;)o+=String.fromCharCode(cc);out[out.length]={t:'t',v:o};++i;break;case'\\':var w=fmt.charAt(++i),t=w==="("||w===")"?w:'t';out[out.length]={t:t,v:w};++i;break;case'_':out[out.length]={t:'t',v:" "};i+=2;break;case'@':/* Text Placeholder */out[out.length]={t:'T',v:v};++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2"){if(dt==null){dt=parse_date_code(v,opts,fmt.charAt(i+1)==="2");if(dt==null)return"";}out[out.length]={t:'X',v:fmt.substr(i,2)};lst=c;i+=2;break;}/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':c=c.toLowerCase();/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':if(v<0)return"";if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return"";}o=c;while(++i<fmt.length&&fmt.charAt(i).toLowerCase()===c)o+=c;if(c==='m'&&lst.toLowerCase()==='h')c='M';if(c==='h')c=hr;out[out.length]={t:c,v:o};lst=c;break;case'A':case'a':case'上':var q={t:c,v:c};if(dt==null)dt=parse_date_code(v,opts);if(fmt.substr(i,3).toUpperCase()==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t='T';hr='h';i+=3;}else if(fmt.substr(i,5).toUpperCase()==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t='T';i+=5;hr='h';}else if(fmt.substr(i,5).toUpperCase()==="上午/下午"){if(dt!=null)q.v=dt.H>=12?"下午":"上午";q.t='T';i+=5;hr='h';}else{q.t="t";++i;}if(dt==null&&q.t==='T')return"";out[out.length]=q;lst=c;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length)o+=fmt.charAt(i);if(o.slice(-1)!==']')throw'unterminated "[" block: |'+o+'|';if(o.match(abstime)){if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return"";}out[out.length]={t:'Z',v:o.toLowerCase()};lst=o.charAt(1);}else if(o.indexOf("$")>-1){o=(o.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!fmt_is_date(fmt))out[out.length]={t:'t',v:o};}break;/* Numbers */case'.':if(dt!=null){o=c;while(++i<fmt.length&&(c=fmt.charAt(i))==="0")o+=c;out[out.length]={t:'s',v:o};break;}/* falls through */case'0':case'#':o=c;while(++i<fmt.length&&"0#?.,E+-%".indexOf(c=fmt.charAt(i))>-1)o+=c;out[out.length]={t:'n',v:o};break;case'?':o=c;while(fmt.charAt(++i)===c)o+=c;out[out.length]={t:c,v:o};lst=c;break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;// **
case'(':case')':out[out.length]={t:flen===1?'t':c,v:c};++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':o=c;while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1)o+=fmt.charAt(i);out[out.length]={t:'D',v:o};break;case' ':out[out.length]={t:c,v:c};++i;break;case'$':out[out.length]={t:'t',v:'$'};++i;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c)===-1)throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'t',v:c};++i;break;}}/* Scan for date/time parts */var bt=0,ss0=0,ssm;for(i=out.length-1,lst='t';i>=0;--i){switch(out[i].t){case'h':case'H':out[i].t=hr;lst='h';if(bt<1)bt=1;break;case's':if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;/* falls through */case'd':case'y':case'M':case'e':lst=out[i].t;break;case'm':if(lst==='s'){out[i].t='M';if(bt<2)bt=2;}break;case'X':/*if(out[i].v === "B2");*/break;case'Z':if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3;}}/* time rounding depends on presence of minute / second / usec fields */switch(bt){case 0:break;case 1:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}if(dt.M>=60){dt.M=0;++dt.H;}break;case 2:if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}break;}/* replace fields */var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case't':case'T':case' ':case'D':break;case'X':out[i].v="";out[i].t=";";break;case'd':case'm':case'y':case'h':case'H':case'M':case's':case'e':case'b':case'Z':out[i].v=write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t='t';break;case'n':case'?':jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==='?'||out[jj+1].t==="t"&&out[jj+1].v==='/')||out[i].t==='('&&(c===' '||c==='n'||c===')')||c==='t'&&(out[jj].v==='/'||out[jj].v===' '&&out[jj+1]!=null&&out[jj+1].t=='?'))){out[i].v+=out[jj].v;out[jj]={v:"",t:";"};++jj;}nstr+=out[i].v;i=jj-1;break;case'G':out[i].t='t';out[i].v=general_fmt(v,opts);break;}}var vv="",myv,ostr;if(nstr.length>0){if(nstr.charCodeAt(0)==40)/* '(' */{myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num('n',nstr,myv);}else{myv=v<0&&flen>1?-v:v;ostr=write_num('n',nstr,myv);if(myv<0&&out[0]&&out[0].t=='t'){ostr=ostr.substr(1);out[0].v="-"+out[0].v;}}jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i)if(out[i]!=null&&out[i].t!='t'&&out[i].v.indexOf(".")>-1){decpt=i;break;}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length);}else if(jj<0)out[i].v="";else{out[i].v=ostr.substr(0,jj+1);jj=-1;}out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v.charAt(j)==="0"||out[i].v.charAt(j)==="#"))vv=ostr.charAt(jj--)+vv;}out[i].v=vv;out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||'n?('.indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr.charAt(jj++);}out[i].v=vv;out[i].t='t';lasti=i;}}}for(i=0;i<out.length;++i)if(out[i]!=null&&'n?'.indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t='t';}var retval="";for(i=0;i!==out.length;++i)if(out[i]!=null)retval+=out[i].v;return retval;}SSF._eval=eval_fmt;var cfregex=/\[[=<>]/;var cfregex2=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break;}return false;}function choose_fmt(f,v){var fmt=split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw new Error("cannot find right format for |"+fmt.join("|")+"|");if(typeof v!=="number")return[4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;case 4:break;}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return[l,ff];if(fmt[0].match(cfregex)!=null||fmt[1].match(cfregex)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]];}return[l,ff];}function format(fmt,v,o){if(o==null)o={};var sfmt="";switch(typeof fmt){case"string":if(fmt=="m/d/yy"&&o.dateNF)sfmt=o.dateNF;else sfmt=fmt;break;case"number":if(fmt==14&&o.dateNF)sfmt=o.dateNF;else sfmt=(o.table!=null?o.table:table_fmt)[fmt];if(sfmt==null)sfmt=o.table&&o.table[default_map[fmt]]||table_fmt[default_map[fmt]];if(sfmt==null)sfmt=default_str[fmt]||"General";break;}if(isgeneral(sfmt,0))return general_fmt(v,o);if(v instanceof Date)v=datenum_local(v,o.date1904);var f=choose_fmt(sfmt,v);if(isgeneral(f[1]))return general_fmt(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return"";return eval_fmt(f[1],v,o,f[0]);}function load_entry(fmt,idx){if(typeof idx!='number'){idx=+idx||-1;for(var i=0;i<0x0188;++i){if(table_fmt[i]==undefined){if(idx<0)idx=i;continue;}if(table_fmt[i]==fmt){idx=i;break;}}if(idx<0)idx=0x187;}table_fmt[idx]=fmt;return idx;}SSF.load=load_entry;SSF._table=table_fmt;SSF.get_table=function get_table(){return table_fmt;};SSF.load_table=function load_table(tbl){for(var i=0;i!=0x0188;++i)if(tbl[i]!==undefined)load_entry(tbl[i],i);};SSF.init_table=init_table;SSF.format=format;};make_ssf(SSF);/* map from xlml named formats to SSF TODO: localize */var XLMLFormatMap/*{[string]:string}*/={"General Number":"General","General Date":SSF._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":SSF._table[15],"Short Date":SSF._table[14],"Long Time":SSF._table[19],"Medium Time":SSF._table[18],"Short Time":SSF._table[20],"Currency":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"Fixed":SSF._table[2],"Standard":SSF._table[4],"Percent":SSF._table[10],"Scientific":SSF._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var SSFImplicit/*{[number]:string}*/={"5":'"$"#,##0_);\\("$"#,##0\\)',"6":'"$"#,##0_);[Red]\\("$"#,##0\\)',"7":'"$"#,##0.00_);\\("$"#,##0.00\\)',"8":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"23":'General',"24":'General',"25":'General',"26":'General',"27":'m/d/yy',"28":'m/d/yy',"29":'m/d/yy',"30":'m/d/yy',"31":'m/d/yy',"32":'h:mm:ss',"33":'h:mm:ss',"34":'h:mm:ss',"35":'h:mm:ss',"36":'m/d/yy',"41":'_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',"42":'_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',"43":'_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',"44":'_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',"50":'m/d/yy',"51":'m/d/yy',"52":'m/d/yy',"53":'m/d/yy',"54":'m/d/yy',"55":'m/d/yy',"56":'m/d/yy',"57":'m/d/yy',"58":'m/d/yy',"59":'0',"60":'0.00',"61":'#,##0',"62":'#,##0.00',"63":'"$"#,##0_);\\("$"#,##0\\)',"64":'"$"#,##0_);[Red]\\("$"#,##0\\)',"65":'"$"#,##0.00_);\\("$"#,##0.00\\)',"66":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"67":'0%',"68":'0.00%',"69":'# ?/?',"70":'# ??/??',"71":'m/d/yy',"72":'m/d/yy',"73":'d-mmm-yy',"74":'d-mmm',"75":'mmm-yy',"76":'h:mm',"77":'h:mm:ss',"78":'m/d/yy h:mm',"79":'mm:ss',"80":'[h]:mm:ss',"81":'mmss.0'};/* dateNF parse TODO: move to SSF */var dateNFregex=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function dateNF_regex(dateNF){var fmt=typeof dateNF=="number"?SSF._table[dateNF]:dateNF;fmt=fmt.replace(dateNFregex,"(\\d+)");return new RegExp("^"+fmt+"$");}function dateNF_fix(str,dateNF,match){var Y=-1,m=-1,d=-1,H=-1,M=-1,S=-1;(dateNF.match(dateNFregex)||[]).forEach(function(n,i){var v=parseInt(match[i+1],10);switch(n.toLowerCase().charAt(0)){case'y':Y=v;break;case'd':d=v;break;case'h':H=v;break;case's':S=v;break;case'm':if(H>=0)M=v;else m=v;break;}});if(S>=0&&M==-1&&m>=0){M=m;m=-1;}var datestr=(""+(Y>=0?Y:new Date().getFullYear())).slice(-4)+"-"+("00"+(m>=1?m:1)).slice(-2)+"-"+("00"+(d>=1?d:1)).slice(-2);if(datestr.length==7)datestr="0"+datestr;if(datestr.length==8)datestr="20"+datestr;var timestr=("00"+(H>=0?H:0)).slice(-2)+":"+("00"+(M>=0?M:0)).slice(-2)+":"+("00"+(S>=0?S:0)).slice(-2);if(H==-1&&M==-1&&S==-1)return datestr;if(Y==-1&&m==-1&&d==-1)return timestr;return datestr+"T"+timestr;}var DO_NOT_EXPORT_CFB=true;/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */var CRC32;(function(factory){/*jshint ignore:start */ /*eslint-disable */factory(CRC32={});/*eslint-enable */ /*jshint ignore:end */})(function(CRC32){CRC32.version='1.2.0';/* see perf/crc32table.js */ /*global Int32Array */function signed_crc_table(){var c=0,table=new Array(256);for(var n=0;n!=256;++n){c=n;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;table[n]=c;}return typeof Int32Array!=='undefined'?new Int32Array(table):table;}var T=signed_crc_table();function crc32_bstr(bstr,seed){var C=seed^-1,L=bstr.length-1;for(var i=0;i<L;){C=C>>>8^T[(C^bstr.charCodeAt(i++))&0xFF];C=C>>>8^T[(C^bstr.charCodeAt(i++))&0xFF];}if(i===L)C=C>>>8^T[(C^bstr.charCodeAt(i))&0xFF];return C^-1;}function crc32_buf(buf,seed){if(buf.length>10000)return crc32_buf_8(buf,seed);var C=seed^-1,L=buf.length-3;for(var i=0;i<L;){C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];}while(i<L+3)C=C>>>8^T[(C^buf[i++])&0xFF];return C^-1;}function crc32_buf_8(buf,seed){var C=seed^-1,L=buf.length-7;for(var i=0;i<L;){C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];C=C>>>8^T[(C^buf[i++])&0xFF];}while(i<L+7)C=C>>>8^T[(C^buf[i++])&0xFF];return C^-1;}function crc32_str(str,seed){var C=seed^-1;for(var i=0,L=str.length,c,d;i<L;){c=str.charCodeAt(i++);if(c<0x80){C=C>>>8^T[(C^c)&0xFF];}else if(c<0x800){C=C>>>8^T[(C^(192|c>>6&31))&0xFF];C=C>>>8^T[(C^(128|c&63))&0xFF];}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;d=str.charCodeAt(i++)&1023;C=C>>>8^T[(C^(240|c>>8&7))&0xFF];C=C>>>8^T[(C^(128|c>>2&63))&0xFF];C=C>>>8^T[(C^(128|d>>6&15|(c&3)<<4))&0xFF];C=C>>>8^T[(C^(128|d&63))&0xFF];}else{C=C>>>8^T[(C^(224|c>>12&15))&0xFF];C=C>>>8^T[(C^(128|c>>6&63))&0xFF];C=C>>>8^T[(C^(128|c&63))&0xFF];}}return C^-1;}CRC32.table=T;CRC32.bstr=crc32_bstr;CRC32.buf=crc32_buf;CRC32.str=crc32_str;});/* [MS-CFB] v20171201 */var CFB=function _CFB(){var exports={};exports.version='1.1.4';/* [MS-CFB] 2.6.4 */function namecmp(l,r){var L=l.split("/"),R=r.split("/");for(var i=0,c=0,Z=Math.min(L.length,R.length);i<Z;++i){if(c=L[i].length-R[i].length)return c;if(L[i]!=R[i])return L[i]<R[i]?-1:1;}return L.length-R.length;}function dirname(p){if(p.charAt(p.length-1)=="/")return p.slice(0,-1).indexOf("/")===-1?p:dirname(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(0,c+1);}function filename(p){if(p.charAt(p.length-1)=="/")return filename(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(c+1);}/* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */function write_dos_date(buf,date){if(typeof date==="string")date=new Date(date);var hms=date.getHours();hms=hms<<6|date.getMinutes();hms=hms<<5|date.getSeconds()>>>1;buf.write_shift(2,hms);var ymd=date.getFullYear()-1980;ymd=ymd<<4|date.getMonth()+1;ymd=ymd<<5|date.getDate();buf.write_shift(2,ymd);}/* read four bytes from buf and interpret as a DOS date */function parse_dos_date(buf){var hms=buf.read_shift(2)&0xFFFF;var ymd=buf.read_shift(2)&0xFFFF;var val=new Date();var d=ymd&0x1F;ymd>>>=5;var m=ymd&0x0F;ymd>>>=4;val.setMilliseconds(0);val.setFullYear(ymd+1980);val.setMonth(m-1);val.setDate(d);var S=hms&0x1F;hms>>>=5;var M=hms&0x3F;hms>>>=6;val.setHours(hms);val.setMinutes(M);val.setSeconds(S<<1);return val;}function parse_extra_field(blob){prep_blob(blob,0);var o={};var flags=0;while(blob.l<=blob.length-4){var type=blob.read_shift(2);var sz=blob.read_shift(2),tgt=blob.l+sz;var p={};switch(type){/* UNIX-style Timestamps */case 0x5455:{flags=blob.read_shift(1);if(flags&1)p.mtime=blob.read_shift(4);/* for some reason, CD flag corresponds to LFH */if(sz>5){if(flags&2)p.atime=blob.read_shift(4);if(flags&4)p.ctime=blob.read_shift(4);}if(p.mtime)p.mt=new Date(p.mtime*1000);}break;}blob.l=tgt;o[type]=p;}return o;}var fs;function get_fs(){return fs||(fs=require('fs'));}function parse(file,options){if(file[0]==0x50&&file[1]==0x4b)return parse_zip(file,options);if(file.length<512)throw new Error("CFB file size "+file.length+" < 512");var mver=3;var ssz=512;var nmfs=0;// number of mini FAT sectors
var difat_sec_cnt=0;var dir_start=0;var minifat_start=0;var difat_start=0;var fat_addrs=[];// locations of FAT sectors
/* [MS-CFB] 2.2 Compound File Header */var blob=file.slice(0,512);prep_blob(blob,0);/* major version */var mv=check_get_mver(blob);mver=mv[0];switch(mver){case 3:ssz=512;break;case 4:ssz=4096;break;case 0:if(mv[1]==0)return parse_zip(file,options);/* falls through */default:throw new Error("Major Version: Expected 3 or 4 saw "+mver);}/* reprocess header */if(ssz!==512){blob=file.slice(0,ssz);prep_blob(blob,28/* blob.l */);}/* Save header for final object */var header=file.slice(0,ssz);check_shifts(blob,mver);// Number of Directory Sectors
var dir_cnt=blob.read_shift(4,'i');if(mver===3&&dir_cnt!==0)throw new Error('# Directory Sectors: Expected 0 saw '+dir_cnt);// Number of FAT Sectors
blob.l+=4;// First Directory Sector Location
dir_start=blob.read_shift(4,'i');// Transaction Signature
blob.l+=4;// Mini Stream Cutoff Size
blob.chk('00100000','Mini Stream Cutoff Size: ');// First Mini FAT Sector Location
minifat_start=blob.read_shift(4,'i');// Number of Mini FAT Sectors
nmfs=blob.read_shift(4,'i');// First DIFAT sector location
difat_start=blob.read_shift(4,'i');// Number of DIFAT Sectors
difat_sec_cnt=blob.read_shift(4,'i');// Grab FAT Sector Locations
for(var q=-1,j=0;j<109;++j){/* 109 = (512 - blob.l)>>>2; */q=blob.read_shift(4,'i');if(q<0)break;fat_addrs[j]=q;}/** Break the file up into sectors */var sectors=sectorify(file,ssz);sleuth_fat(difat_start,difat_sec_cnt,sectors,ssz,fat_addrs);/** Chains */var sector_list=make_sector_list(sectors,dir_start,fat_addrs,ssz);sector_list[dir_start].name="!Directory";if(nmfs>0&&minifat_start!==ENDOFCHAIN)sector_list[minifat_start].name="!MiniFAT";sector_list[fat_addrs[0]].name="!FAT";sector_list.fat_addrs=fat_addrs;sector_list.ssz=ssz;/* [MS-CFB] 2.6.1 Compound File Directory Entry */var files={},Paths=[],FileIndex=[],FullPaths=[];read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,minifat_start);build_full_paths(FileIndex,FullPaths,Paths);Paths.shift();var o={FileIndex:FileIndex,FullPaths:FullPaths};// $FlowIgnore
if(options&&options.raw)o.raw={header:header,sectors:sectors};return o;}// parse
/* [MS-CFB] 2.2 Compound File Header -- read up to major version */function check_get_mver(blob){if(blob[blob.l]==0x50&&blob[blob.l+1]==0x4b)return[0,0];// header signature 8
blob.chk(HEADER_SIGNATURE,'Header Signature: ');// clsid 16
//blob.chk(HEADER_CLSID, 'CLSID: ');
blob.l+=16;// minor version 2
var mver=blob.read_shift(2,'u');return[blob.read_shift(2,'u'),mver];}function check_shifts(blob,mver){var shift=0x09;// Byte Order
//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
blob.l+=2;// Sector Shift
switch(shift=blob.read_shift(2)){case 0x09:if(mver!=3)throw new Error('Sector Shift: Expected 9 saw '+shift);break;case 0x0c:if(mver!=4)throw new Error('Sector Shift: Expected 12 saw '+shift);break;default:throw new Error('Sector Shift: Expected 9 or 12 saw '+shift);}// Mini Sector Shift
blob.chk('0600','Mini Sector Shift: ');// Reserved
blob.chk('000000000000','Reserved: ');}/** Break the file up into sectors */function sectorify(file,ssz){var nsectors=Math.ceil(file.length/ssz)-1;var sectors=[];for(var i=1;i<nsectors;++i)sectors[i-1]=file.slice(i*ssz,(i+1)*ssz);sectors[nsectors-1]=file.slice(nsectors*ssz);return sectors;}/* [MS-CFB] 2.6.4 Red-Black Tree */function build_full_paths(FI,FP,Paths){var i=0,L=0,R=0,C=0,j=0,pl=Paths.length;var dad=[],q=[];for(;i<pl;++i){dad[i]=q[i]=i;FP[i]=Paths[i];}for(;j<q.length;++j){i=q[j];L=FI[i].L;R=FI[i].R;C=FI[i].C;if(dad[i]===i){if(L!==-1/*NOSTREAM*/&&dad[L]!==L)dad[i]=dad[L];if(R!==-1&&dad[R]!==R)dad[i]=dad[R];}if(C!==-1/*NOSTREAM*/)dad[C]=i;if(L!==-1&&i!=dad[i]){dad[L]=dad[i];if(q.lastIndexOf(L)<j)q.push(L);}if(R!==-1&&i!=dad[i]){dad[R]=dad[i];if(q.lastIndexOf(R)<j)q.push(R);}}for(i=1;i<pl;++i)if(dad[i]===i){if(R!==-1/*NOSTREAM*/&&dad[R]!==R)dad[i]=dad[R];else if(L!==-1&&dad[L]!==L)dad[i]=dad[L];}for(i=1;i<pl;++i){if(FI[i].type===0/* unknown */)continue;j=i;if(j!=dad[j])do{j=dad[j];FP[i]=FP[j]+"/"+FP[i];}while(j!==0&&-1!==dad[j]&&j!=dad[j]);dad[i]=-1;}FP[0]+="/";for(i=1;i<pl;++i){if(FI[i].type!==2/* stream */)FP[i]+="/";}}function get_mfat_entry(entry,payload,mini){var start=entry.start,size=entry.size;//return (payload.slice(start*MSSZ, start*MSSZ + size));
var o=[];var idx=start;while(mini&&size>0&&idx>=0){o.push(payload.slice(idx*MSSZ,idx*MSSZ+MSSZ));size-=MSSZ;idx=__readInt32LE(mini,idx*4);}if(o.length===0)return new_buf(0);return bconcat(o).slice(0,entry.size);}/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */function sleuth_fat(idx,cnt,sectors,ssz,fat_addrs){var q=ENDOFCHAIN;if(idx===ENDOFCHAIN){if(cnt!==0)throw new Error("DIFAT chain shorter than expected");}else if(idx!==-1/*FREESECT*/){var sector=sectors[idx],m=(ssz>>>2)-1;if(!sector)return;for(var i=0;i<m;++i){if((q=__readInt32LE(sector,i*4))===ENDOFCHAIN)break;fat_addrs.push(q);}if(cnt>=1)sleuth_fat(__readInt32LE(sector,ssz-4),cnt-1,sectors,ssz,fat_addrs);}}/** Follow the linked list of sectors for a given starting point */function get_sector_list(sectors,start,fat_addrs,ssz,chkd){var buf=[],buf_chain=[];if(!chkd)chkd=[];var modulus=ssz-1,j=0,jj=0;for(j=start;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);}return{nodes:buf,data:__toBuffer([buf_chain])};}/** Chase down the sector linked lists */function make_sector_list(sectors,dir_start,fat_addrs,ssz){var sl=sectors.length,sector_list=[];var chkd=[],buf=[],buf_chain=[];var modulus=ssz-1,i=0,j=0,k=0,jj=0;for(i=0;i<sl;++i){buf=[];k=i+dir_start;if(k>=sl)k-=sl;if(chkd[k])continue;buf_chain=[];var seen=[];for(j=k;j>=0;){seen[j]=true;chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);if(seen[j])break;}sector_list[k]={nodes:buf,data:__toBuffer([buf_chain])};}return sector_list;}/* [MS-CFB] 2.6.1 Compound File Directory Entry */function read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,mini){var minifat_store=0,pl=Paths.length?2:0;var sector=sector_list[dir_start].data;var i=0,namelen=0,name;for(;i<sector.length;i+=128){var blob=sector.slice(i,i+128);prep_blob(blob,64);namelen=blob.read_shift(2);name=__utf16le(blob,0,namelen-pl);Paths.push(name);var o={name:name,type:blob.read_shift(1),color:blob.read_shift(1),L:blob.read_shift(4,'i'),R:blob.read_shift(4,'i'),C:blob.read_shift(4,'i'),clsid:blob.read_shift(16),state:blob.read_shift(4,'i'),start:0,size:0};var ctime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(ctime!==0)o.ct=read_date(blob,blob.l-8);var mtime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(mtime!==0)o.mt=read_date(blob,blob.l-8);o.start=blob.read_shift(4,'i');o.size=blob.read_shift(4,'i');if(o.size<0&&o.start<0){o.size=o.type=0;o.start=ENDOFCHAIN;o.name="";}if(o.type===5){/* root */minifat_store=o.start;if(nmfs>0&&minifat_store!==ENDOFCHAIN)sector_list[minifat_store].name="!StreamData";/*minifat_size = o.size;*/}else if(o.size>=4096/* MSCSZ */){o.storage='fat';if(sector_list[o.start]===undefined)sector_list[o.start]=get_sector_list(sectors,o.start,sector_list.fat_addrs,sector_list.ssz);sector_list[o.start].name=o.name;o.content=sector_list[o.start].data.slice(0,o.size);}else{o.storage='minifat';if(o.size<0)o.size=0;else if(minifat_store!==ENDOFCHAIN&&o.start!==ENDOFCHAIN&&sector_list[minifat_store]){o.content=get_mfat_entry(o,sector_list[minifat_store].data,(sector_list[mini]||{}).data);}}if(o.content)prep_blob(o.content,0);files[name]=o;FileIndex.push(o);}}function read_date(blob,offset){return new Date((__readUInt32LE(blob,offset+4)/1e7*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7-11644473600)*1000);}function read_file(filename,options){get_fs();return parse(fs.readFileSync(filename),options);}function read(blob,options){switch(options&&options.type||"base64"){case"file":return read_file(blob,options);case"base64":return parse(s2a(Base64.decode(blob)),options);case"binary":return parse(s2a(blob),options);}return parse(blob,options);}function init_cfb(cfb,opts){var o=opts||{},root=o.root||"Root Entry";if(!cfb.FullPaths)cfb.FullPaths=[];if(!cfb.FileIndex)cfb.FileIndex=[];if(cfb.FullPaths.length!==cfb.FileIndex.length)throw new Error("inconsistent CFB structure");if(cfb.FullPaths.length===0){cfb.FullPaths[0]=root+"/";cfb.FileIndex[0]={name:root,type:5};}if(o.CLSID)cfb.FileIndex[0].clsid=o.CLSID;seed_cfb(cfb);}function seed_cfb(cfb){var nm="\u0001Sh33tJ5";if(CFB.find(cfb,"/"+nm))return;var p=new_buf(4);p[0]=55;p[1]=p[3]=50;p[2]=54;cfb.FileIndex.push({name:nm,type:2,content:p,size:4,L:69,R:69,C:69});cfb.FullPaths.push(cfb.FullPaths[0]+nm);rebuild_cfb(cfb);}function rebuild_cfb(cfb,f){init_cfb(cfb);var gc=false,s=false;for(var i=cfb.FullPaths.length-1;i>=0;--i){var _file=cfb.FileIndex[i];switch(_file.type){case 0:if(s)gc=true;else{cfb.FileIndex.pop();cfb.FullPaths.pop();}break;case 1:case 2:case 5:s=true;if(isNaN(_file.R*_file.L*_file.C))gc=true;if(_file.R>-1&&_file.L>-1&&_file.R==_file.L)gc=true;break;default:gc=true;break;}}if(!gc&&!f)return;var now=new Date(1987,1,19),j=0;var data=[];for(i=0;i<cfb.FullPaths.length;++i){if(cfb.FileIndex[i].type===0)continue;data.push([cfb.FullPaths[i],cfb.FileIndex[i]]);}for(i=0;i<data.length;++i){var dad=dirname(data[i][0]);s=false;for(j=0;j<data.length;++j)if(data[j][0]===dad)s=true;if(!s)data.push([dad,{name:filename(dad).replace("/",""),type:1,clsid:HEADER_CLSID,ct:now,mt:now,content:null}]);}data.sort(function(x,y){return namecmp(x[0],y[0]);});cfb.FullPaths=[];cfb.FileIndex=[];for(i=0;i<data.length;++i){cfb.FullPaths[i]=data[i][0];cfb.FileIndex[i]=data[i][1];}for(i=0;i<data.length;++i){var elt=cfb.FileIndex[i];var nm=cfb.FullPaths[i];elt.name=filename(nm).replace("/","");elt.L=elt.R=elt.C=-(elt.color=1);elt.size=elt.content?elt.content.length:0;elt.start=0;elt.clsid=elt.clsid||HEADER_CLSID;if(i===0){elt.C=data.length>1?1:-1;elt.size=0;elt.type=5;}else if(nm.slice(-1)=="/"){for(j=i+1;j<data.length;++j)if(dirname(cfb.FullPaths[j])==nm)break;elt.C=j>=data.length?-1:j;for(j=i+1;j<data.length;++j)if(dirname(cfb.FullPaths[j])==dirname(nm))break;elt.R=j>=data.length?-1:j;elt.type=1;}else{if(dirname(cfb.FullPaths[i+1]||"")==dirname(nm))elt.R=i+1;elt.type=2;}}}function _write(cfb,options){var _opts=options||{};rebuild_cfb(cfb);if(_opts.fileType=='zip')return write_zip(cfb,_opts);var L=function(cfb){var mini_size=0,fat_size=0;for(var i=0;i<cfb.FileIndex.length;++i){var file=cfb.FileIndex[i];if(!file.content)continue;var flen=file.content.length;if(flen>0){if(flen<0x1000)mini_size+=flen+0x3F>>6;else fat_size+=flen+0x01FF>>9;}}var dir_cnt=cfb.FullPaths.length+3>>2;var mini_cnt=mini_size+7>>3;var mfat_cnt=mini_size+0x7F>>7;var fat_base=mini_cnt+fat_size+dir_cnt+mfat_cnt;var fat_cnt=fat_base+0x7F>>7;var difat_cnt=fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);while(fat_base+fat_cnt+difat_cnt+0x7F>>7>fat_cnt)difat_cnt=++fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);var L=[1,difat_cnt,fat_cnt,mfat_cnt,dir_cnt,fat_size,mini_size,0];cfb.FileIndex[0].size=mini_size<<6;L[7]=(cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+(L[6]+7>>3);return L;}(cfb);var o=new_buf(L[7]<<9);var i=0,T=0;{for(i=0;i<8;++i)o.write_shift(1,HEADER_SIG[i]);for(i=0;i<8;++i)o.write_shift(2,0);o.write_shift(2,0x003E);o.write_shift(2,0x0003);o.write_shift(2,0xFFFE);o.write_shift(2,0x0009);o.write_shift(2,0x0006);for(i=0;i<3;++i)o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,L[2]);o.write_shift(4,L[0]+L[1]+L[2]+L[3]-1);o.write_shift(4,0);o.write_shift(4,1<<12);o.write_shift(4,L[3]?L[0]+L[1]+L[2]-1:ENDOFCHAIN);o.write_shift(4,L[3]);o.write_shift(-4,L[1]?L[0]-1:ENDOFCHAIN);o.write_shift(4,L[1]);for(i=0;i<109;++i)o.write_shift(-4,i<L[2]?L[1]+i:-1);}if(L[1]){for(T=0;T<L[1];++T){for(;i<236+T*127;++i)o.write_shift(-4,i<L[2]?L[1]+i:-1);o.write_shift(-4,T===L[1]-1?ENDOFCHAIN:T+1);}}var chainit=function(w){for(T+=w;i<T-1;++i)o.write_shift(-4,i+1);if(w){++i;o.write_shift(-4,ENDOFCHAIN);}};T=i=0;for(T+=L[1];i<T;++i)o.write_shift(-4,consts.DIFSECT);for(T+=L[2];i<T;++i)o.write_shift(-4,consts.FATSECT);chainit(L[3]);chainit(L[4]);var j=0,flen=0;var file=cfb.FileIndex[0];for(;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(flen<0x1000)continue;file.start=T;chainit(flen+0x01FF>>9);}chainit(L[6]+7>>3);while(o.l&0x1FF)o.write_shift(-4,consts.ENDOFCHAIN);T=i=0;for(j=0;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;flen=file.content.length;if(!flen||flen>=0x1000)continue;file.start=T;chainit(flen+0x3F>>6);}while(o.l&0x1FF)o.write_shift(-4,consts.ENDOFCHAIN);for(i=0;i<L[4]<<2;++i){var nm=cfb.FullPaths[i];if(!nm||nm.length===0){for(j=0;j<17;++j)o.write_shift(4,0);for(j=0;j<3;++j)o.write_shift(4,-1);for(j=0;j<12;++j)o.write_shift(4,0);continue;}file=cfb.FileIndex[i];if(i===0)file.start=file.size?file.start-1:ENDOFCHAIN;var _nm=i===0&&_opts.root||file.name;flen=2*(_nm.length+1);o.write_shift(64,_nm,"utf16le");o.write_shift(2,flen);o.write_shift(1,file.type);o.write_shift(1,file.color);o.write_shift(-4,file.L);o.write_shift(-4,file.R);o.write_shift(-4,file.C);if(!file.clsid)for(j=0;j<4;++j)o.write_shift(4,0);else o.write_shift(16,file.clsid,"hex");o.write_shift(4,file.state||0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,file.start);o.write_shift(4,file.size);o.write_shift(4,0);}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>=0x1000){o.l=file.start+1<<9;for(j=0;j<file.size;++j)o.write_shift(1,file.content[j]);for(;j&0x1FF;++j)o.write_shift(1,0);}}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];if(file.size>0&&file.size<0x1000){for(j=0;j<file.size;++j)o.write_shift(1,file.content[j]);for(;j&0x3F;++j)o.write_shift(1,0);}}while(o.l<o.length)o.write_shift(1,0);return o;}/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */function find(cfb,path){var UCFullPaths=cfb.FullPaths.map(function(x){return x.toUpperCase();});var UCPaths=UCFullPaths.map(function(x){var y=x.split("/");return y[y.length-(x.slice(-1)=="/"?2:1)];});var k=false;if(path.charCodeAt(0)===47/* "/" */){k=true;path=UCFullPaths[0].slice(0,-1)+path;}else k=path.indexOf("/")!==-1;var UCPath=path.toUpperCase();var w=k===true?UCFullPaths.indexOf(UCPath):UCPaths.indexOf(UCPath);if(w!==-1)return cfb.FileIndex[w];var m=!UCPath.match(chr1);UCPath=UCPath.replace(chr0,'');if(m)UCPath=UCPath.replace(chr1,'!');for(w=0;w<UCFullPaths.length;++w){if((m?UCFullPaths[w].replace(chr1,'!'):UCFullPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];if((m?UCPaths[w].replace(chr1,'!'):UCPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];}return null;}/** CFB Constants */var MSSZ=64;/* Mini Sector Size = 1<<6 */ //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */var ENDOFCHAIN=-2;/* 2.2 Compound File Header */var HEADER_SIGNATURE='d0cf11e0a1b11ae1';var HEADER_SIG=[0xD0,0xCF,0x11,0xE0,0xA1,0xB1,0x1A,0xE1];var HEADER_CLSID='00000000000000000000000000000000';var consts={/* 2.1 Compund File Sector Numbers and Types */MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:ENDOFCHAIN,FREESECT:-1,/* 2.2 Compound File Header */HEADER_SIGNATURE:HEADER_SIGNATURE,HEADER_MINOR_VERSION:'3e00',MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:HEADER_CLSID,/* 2.6.1 Compound File Directory Entry */EntryTypes:['unknown','storage','stream','lockbytes','property','root']};function write_file(cfb,filename,options){get_fs();var o=_write(cfb,options);fs.writeFileSync(filename,o);}function a2s(o){var out=new Array(o.length);for(var i=0;i<o.length;++i)out[i]=String.fromCharCode(o[i]);return out.join("");}function write(cfb,options){var o=_write(cfb,options);switch(options&&options.type){case"file":get_fs();fs.writeFileSync(options.filename,o);return o;case"binary":return a2s(o);case"base64":return Base64.encode(a2s(o));}return o;}/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */var _zlib;function use_zlib(zlib){try{var InflateRaw=zlib.InflateRaw;var InflRaw=new InflateRaw();InflRaw._processChunk(new Uint8Array([3,0]),InflRaw._finishFlushFlag);if(InflRaw.bytesRead)_zlib=zlib;else throw new Error("zlib does not expose bytesRead");}catch(e){console.error("cannot use native zlib: "+(e.message||e));}}function _inflateRawSync(payload,usz){if(!_zlib)return _inflate(payload,usz);var InflateRaw=_zlib.InflateRaw;var InflRaw=new InflateRaw();var out=InflRaw._processChunk(payload.slice(payload.l),InflRaw._finishFlushFlag);payload.l+=InflRaw.bytesRead;return out;}function _deflateRawSync(payload){return _zlib?_zlib.deflateRawSync(payload):_deflate(payload);}var CLEN_ORDER=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */var LEN_LN=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */var DST_LN=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function bit_swap_8(n){var t=(n<<1|n<<11)&0x22110|(n<<5|n<<15)&0x88440;return(t>>16|t>>8|t)&0xFF;}var use_typed_arrays=typeof Uint8Array!=='undefined';var bitswap8=use_typed_arrays?new Uint8Array(1<<8):[];for(var q=0;q<1<<8;++q)bitswap8[q]=bit_swap_8(q);function bit_swap_n(n,b){var rev=bitswap8[n&0xFF];if(b<=8)return rev>>>8-b;rev=rev<<8|bitswap8[n>>8&0xFF];if(b<=16)return rev>>>16-b;rev=rev<<8|bitswap8[n>>16&0xFF];return rev>>>24-b;}/* helpers for unaligned bit reads */function read_bits_2(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=6?0:buf[h+1]<<8))>>>w&0x03;}function read_bits_3(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=5?0:buf[h+1]<<8))>>>w&0x07;}function read_bits_4(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=4?0:buf[h+1]<<8))>>>w&0x0F;}function read_bits_5(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=3?0:buf[h+1]<<8))>>>w&0x1F;}function read_bits_7(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=1?0:buf[h+1]<<8))>>>w&0x7F;}/* works up to n = 3 * 8 + 1 = 25 */function read_bits_n(buf,bl,n){var w=bl&7,h=bl>>>3,f=(1<<n)-1;var v=buf[h]>>>w;if(n<8-w)return v&f;v|=buf[h+1]<<8-w;if(n<16-w)return v&f;v|=buf[h+2]<<16-w;if(n<24-w)return v&f;v|=buf[h+3]<<24-w;return v&f;}/* until ArrayBuffer#realloc is a thing, fake a realloc */function realloc(b,sz){var L=b.length,M=2*L>sz?2*L:sz+5,i=0;if(L>=sz)return b;if(has_buf){var o=new_unsafe_buf(M);// $FlowIgnore
if(b.copy)b.copy(o);else for(;i<b.length;++i)o[i]=b[i];return o;}else if(use_typed_arrays){var a=new Uint8Array(M);if(a.set)a.set(b);else for(;i<b.length;++i)a[i]=b[i];return a;}b.length=M;return b;}/* zero-filled arrays for older browsers */function zero_fill_array(n){var o=new Array(n);for(var i=0;i<n;++i)o[i]=0;return o;}var _deflate=function(){var _deflateRaw=function(){return function deflateRaw(data,out){var boff=0;while(boff<data.length){var L=Math.min(0xFFFF,data.length-boff);var h=boff+L==data.length;/* TODO: this is only type 0 stored */out.write_shift(1,+h);out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0)out[out.l++]=data[boff++];}return out.l;};}();return function(data){var buf=new_buf(50+Math.floor(data.length*1.1));var off=_deflateRaw(data,buf);return buf.slice(0,off);};}();/* modified inflate function also moves original read head */ /* build tree (used for literals and lengths) */function build_tree(clens,cmap,MAX){var maxlen=1,w=0,i=0,j=0,ccode=0,L=clens.length;var bl_count=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);for(i=0;i<32;++i)bl_count[i]=0;for(i=L;i<MAX;++i)clens[i]=0;L=clens.length;var ctree=use_typed_arrays?new Uint16Array(L):zero_fill_array(L);// []
/* build code tree */for(i=0;i<L;++i){bl_count[w=clens[i]]++;if(maxlen<w)maxlen=w;ctree[i]=0;}bl_count[0]=0;for(i=1;i<=maxlen;++i)bl_count[i+16]=ccode=ccode+bl_count[i-1]<<1;for(i=0;i<L;++i){ccode=clens[i];if(ccode!=0)ctree[i]=bl_count[ccode+16]++;}/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bit_swap_n(ctree[i],maxlen)>>maxlen-cleni;for(j=(1<<maxlen+4-cleni)-1;j>=0;--j)cmap[ccode|j<<cleni]=cleni&15|i<<4;}}return maxlen;}var fix_lmap=use_typed_arrays?new Uint16Array(512):zero_fill_array(512);var fix_dmap=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);if(!use_typed_arrays){for(var i=0;i<512;++i)fix_lmap[i]=0;for(i=0;i<32;++i)fix_dmap[i]=0;}(function(){var dlens=[];var i=0;for(;i<32;i++)dlens.push(5);build_tree(dlens,fix_dmap,32);var clens=[];i=0;for(;i<=143;i++)clens.push(8);for(;i<=255;i++)clens.push(9);for(;i<=279;i++)clens.push(7);for(;i<=287;i++)clens.push(8);build_tree(clens,fix_lmap,288);})();var dyn_lmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_dmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_cmap=use_typed_arrays?new Uint16Array(128):zero_fill_array(128);var dyn_len_1=1,dyn_len_2=1;/* 5.5.3 Expanding Huffman Codes */function dyn(data,boff){/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */var _HLIT=read_bits_5(data,boff)+257;boff+=5;var _HDIST=read_bits_5(data,boff)+1;boff+=5;var _HCLEN=read_bits_4(data,boff)+4;boff+=4;var w=0;/* grab and store code lengths */var clens=use_typed_arrays?new Uint8Array(19):zero_fill_array(19);var ctree=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var maxlen=1;var bl_count=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var next_code=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var L=clens.length;/* 19 */for(var i=0;i<_HCLEN;++i){clens[CLEN_ORDER[i]]=w=read_bits_3(data,boff);if(maxlen<w)maxlen=w;bl_count[w]++;boff+=3;}/* build code tree */var ccode=0;bl_count[0]=0;for(i=1;i<=maxlen;++i)next_code[i]=ccode=ccode+bl_count[i-1]<<1;for(i=0;i<L;++i)if((ccode=clens[i])!=0)ctree[i]=next_code[ccode]++;/* cmap[7 bits from stream] = (off&7) + (lit<<3) */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bitswap8[ctree[i]]>>8-cleni;for(var j=(1<<7-cleni)-1;j>=0;--j)dyn_cmap[ccode|j<<cleni]=cleni&7|i<<3;}}/* read literal and dist codes at once */var hcodes=[];maxlen=1;for(;hcodes.length<_HLIT+_HDIST;){ccode=dyn_cmap[read_bits_7(data,boff)];boff+=ccode&7;switch(ccode>>>=3){case 16:w=3+read_bits_2(data,boff);boff+=2;ccode=hcodes[hcodes.length-1];while(w-->0)hcodes.push(ccode);break;case 17:w=3+read_bits_3(data,boff);boff+=3;while(w-->0)hcodes.push(0);break;case 18:w=11+read_bits_7(data,boff);boff+=7;while(w-->0)hcodes.push(0);break;default:hcodes.push(ccode);if(maxlen<ccode)maxlen=ccode;break;}}/* build literal / length trees */var h1=hcodes.slice(0,_HLIT),h2=hcodes.slice(_HLIT);for(i=_HLIT;i<286;++i)h1[i]=0;for(i=_HDIST;i<30;++i)h2[i]=0;dyn_len_1=build_tree(h1,dyn_lmap,286);dyn_len_2=build_tree(h2,dyn_dmap,30);return boff;}/* return [ data, bytesRead ] */function inflate(data,usz){/* shortcircuit for empty buffer [0x03, 0x00] */if(data[0]==3&&!(data[1]&0x3)){return[new_raw_buf(usz),2];}/* bit offset */var boff=0;/* header includes final bit and type bits */var header=0;var outbuf=new_unsafe_buf(usz?usz:1<<18);var woff=0;var OL=outbuf.length>>>0;var max_len_1=0,max_len_2=0;while((header&1)==0){header=read_bits_3(data,boff);boff+=3;if(header>>>1==0){/* Stored block */if(boff&7)boff+=8-(boff&7);/* 2 bytes sz, 2 bytes bit inverse */var sz=data[boff>>>3]|data[(boff>>>3)+1]<<8;boff+=32;/* push sz bytes */if(!usz&&OL<woff+sz){outbuf=realloc(outbuf,woff+sz);OL=outbuf.length;}if(typeof data.copy==='function'){// $FlowIgnore
data.copy(outbuf,woff,boff>>>3,(boff>>>3)+sz);woff+=sz;boff+=8*sz;}else while(sz-->0){outbuf[woff++]=data[boff>>>3];boff+=8;}continue;}else if(header>>>1==1){/* Fixed Huffman */max_len_1=9;max_len_2=5;}else{/* Dynamic Huffman */boff=dyn(data,boff);max_len_1=dyn_len_1;max_len_2=dyn_len_2;}if(!usz&&OL<woff+32767){outbuf=realloc(outbuf,woff+32767);OL=outbuf.length;}for(;;){// while(true) is apparently out of vogue in modern JS circles
/* ingest code and move read head */var bits=read_bits_n(data,boff,max_len_1);var code=header>>>1==1?fix_lmap[bits]:dyn_lmap[bits];boff+=code&15;code>>>=4;/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */if((code>>>8&0xFF)===0)outbuf[woff++]=code;else if(code==256)break;else{code-=257;var len_eb=code<8?0:code-4>>2;if(len_eb>5)len_eb=0;var tgt=woff+LEN_LN[code];/* length extra bits */if(len_eb>0){tgt+=read_bits_n(data,boff,len_eb);boff+=len_eb;}/* dist code */bits=read_bits_n(data,boff,max_len_2);code=header>>>1==1?fix_dmap[bits]:dyn_dmap[bits];boff+=code&15;code>>>=4;var dst_eb=code<4?0:code-2>>1;var dst=DST_LN[code];/* dist extra bits */if(dst_eb>0){dst+=read_bits_n(data,boff,dst_eb);boff+=dst_eb;}/* in the common case, manual byte copy is faster than TA set / Buffer copy */if(!usz&&OL<tgt){outbuf=realloc(outbuf,tgt);OL=outbuf.length;}while(woff<tgt){outbuf[woff]=outbuf[woff-dst];++woff;}}}}return[usz?outbuf:outbuf.slice(0,woff),boff+7>>>3];}function _inflate(payload,usz){var data=payload.slice(payload.l||0);var out=inflate(data,usz);payload.l+=out[1];return out[0];}function warn_or_throw(wrn,msg){if(wrn){if(typeof console!=='undefined')console.error(msg);}else throw new Error(msg);}function parse_zip(file,options){var blob=file;prep_blob(blob,0);var FileIndex=[],FullPaths=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o,{root:options.root});/* find end of central directory, start just after signature */var i=blob.length-4;while((blob[i]!=0x50||blob[i+1]!=0x4b||blob[i+2]!=0x05||blob[i+3]!=0x06)&&i>=0)--i;blob.l=i+4;/* parse end of central directory */blob.l+=4;var fcnt=blob.read_shift(2);blob.l+=6;var start_cd=blob.read_shift(4);/* parse central directory */blob.l=start_cd;for(i=0;i<fcnt;++i){/* trust local file header instead of CD entry */blob.l+=20;var csz=blob.read_shift(4);var usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);var fcsz=blob.read_shift(2);blob.l+=8;var offset=blob.read_shift(4);var EF=parse_extra_field(blob.slice(blob.l+namelen,blob.l+namelen+efsz));blob.l+=namelen+efsz+fcsz;var L=blob.l;blob.l=offset+4;parse_local_file(blob,csz,usz,o,EF);blob.l=L;}return o;}/* head starts just after local file header signature */function parse_local_file(blob,csz,usz,o,EF){/* [local file header] */blob.l+=2;var flags=blob.read_shift(2);var meth=blob.read_shift(2);var date=parse_dos_date(blob);if(flags&0x2041)throw new Error("Unsupported ZIP encryption");var crc32=blob.read_shift(4);var _csz=blob.read_shift(4);var _usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);// TODO: flags & (1<<11) // UTF8
var name="";for(var i=0;i<namelen;++i)name+=String.fromCharCode(blob[blob.l++]);if(efsz){var ef=parse_extra_field(blob.slice(blob.l,blob.l+efsz));if((ef[0x5455]||{}).mt)date=ef[0x5455].mt;if(((EF||{})[0x5455]||{}).mt)date=EF[0x5455].mt;}blob.l+=efsz;/* [encryption header] */ /* [file data] */var data=blob.slice(blob.l,blob.l+_csz);switch(meth){case 8:data=_inflateRawSync(blob,_usz);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+meth);}/* [data descriptor] */var wrn=false;if(flags&8){crc32=blob.read_shift(4);if(crc32==0x08074b50){crc32=blob.read_shift(4);wrn=true;}_csz=blob.read_shift(4);_usz=blob.read_shift(4);}if(_csz!=csz)warn_or_throw(wrn,"Bad compressed size: "+csz+" != "+_csz);if(_usz!=usz)warn_or_throw(wrn,"Bad uncompressed size: "+usz+" != "+_usz);var _crc32=CRC32.buf(data,0);if(crc32>>0!=_crc32>>0)warn_or_throw(wrn,"Bad CRC32 checksum: "+crc32+" != "+_crc32);cfb_add(o,name,data,{unsafe:true,mt:date});}function write_zip(cfb,options){var _opts=options||{};var out=[],cdirs=[];var o=new_buf(1);var method=_opts.compression?8:0,flags=0;var desc=false;if(desc)flags|=8;var i=0,j=0;var start_cd=0,fcnt=0;var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];var crcs=[];var sz_cd=0;for(i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\u0001Sh33tJ5")continue;var start=start_cd;/* TODO: CP437 filename */var namebuf=new_buf(fp.length);for(j=0;j<fp.length;++j)namebuf.write_shift(1,fp.charCodeAt(j)&0x7F);namebuf=namebuf.slice(0,namebuf.l);crcs[fcnt]=CRC32.buf(fi.content,0);var outbuf=fi.content;if(method==8)outbuf=_deflateRawSync(outbuf);/* local file header */o=new_buf(30);o.write_shift(4,0x04034b50);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);/* TODO: last mod file time/date */if(fi.mt)write_dos_date(o,fi.mt);else o.write_shift(4,0);o.write_shift(-4,flags&8?0:crcs[fcnt]);o.write_shift(4,flags&8?0:outbuf.length);o.write_shift(4,flags&8?0:fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);start_cd+=o.length;out.push(o);start_cd+=namebuf.length;out.push(namebuf);/* TODO: encryption header ? */start_cd+=outbuf.length;out.push(outbuf);/* data descriptor */if(flags&8){o=new_buf(12);o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);start_cd+=o.l;out.push(o);}/* central directory */o=new_buf(46);o.write_shift(4,0x02014b50);o.write_shift(2,0);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);o.write_shift(4,0);/* TODO: last mod file time/date */o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,fi.content.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,start);sz_cd+=o.l;cdirs.push(o);sz_cd+=namebuf.length;cdirs.push(namebuf);++fcnt;}/* end of central directory */o=new_buf(22);o.write_shift(4,0x06054b50);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,fcnt);o.write_shift(2,fcnt);o.write_shift(4,sz_cd);o.write_shift(4,start_cd);o.write_shift(2,0);return bconcat([bconcat(out),bconcat(cdirs),o]);}function cfb_new(opts){var o={};init_cfb(o,opts);return o;}function cfb_add(cfb,name,content,opts){var unsafe=opts&&opts.unsafe;if(!unsafe)init_cfb(cfb);var file=!unsafe&&CFB.find(cfb,name);if(!file){var fpath=cfb.FullPaths[0];if(name.slice(0,fpath.length)==fpath)fpath=name;else{if(fpath.slice(-1)!="/")fpath+="/";fpath=(fpath+name).replace("//","/");}file={name:filename(name),type:2};cfb.FileIndex.push(file);cfb.FullPaths.push(fpath);if(!unsafe)CFB.utils.cfb_gc(cfb);}file.content=content;file.size=content?content.length:0;if(opts){if(opts.CLSID)file.clsid=opts.CLSID;if(opts.mt)file.mt=opts.mt;if(opts.ct)file.ct=opts.ct;}return file;}function cfb_del(cfb,name){init_cfb(cfb);var file=CFB.find(cfb,name);if(file)for(var j=0;j<cfb.FileIndex.length;++j)if(cfb.FileIndex[j]==file){cfb.FileIndex.splice(j,1);cfb.FullPaths.splice(j,1);return true;}return false;}function cfb_mov(cfb,old_name,new_name){init_cfb(cfb);var file=CFB.find(cfb,old_name);if(file)for(var j=0;j<cfb.FileIndex.length;++j)if(cfb.FileIndex[j]==file){cfb.FileIndex[j].name=filename(new_name);cfb.FullPaths[j]=new_name;return true;}return false;}function cfb_gc(cfb){rebuild_cfb(cfb,true);}exports.find=find;exports.read=read;exports.parse=parse;exports.write=write;exports.writeFile=write_file;exports.utils={cfb_new:cfb_new,cfb_add:cfb_add,cfb_del:cfb_del,cfb_mov:cfb_mov,cfb_gc:cfb_gc,ReadShift:ReadShift,CheckField:CheckField,prep_blob:prep_blob,bconcat:bconcat,use_zlib:use_zlib,_deflateRaw:_deflate,_inflateRaw:_inflate,consts:consts};return exports;}();if(typeof require!=='undefined'&&typeof module!=='undefined'&&typeof DO_NOT_EXPORT_CFB==='undefined'){module.exports=CFB;}var _fs;if(typeof require!=='undefined')try{_fs=require('fs');}catch(e){}/* normalize data for blob ctor */function blobify(data){if(typeof data==="string")return s2ab(data);if(Array.isArray(data))return a2u(data);return data;}/* write or download file */function write_dl(fname,payload,enc){/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */if(typeof _fs!=='undefined'&&_fs.writeFileSync)return enc?_fs.writeFileSync(fname,payload,enc):_fs.writeFileSync(fname,payload);var data=enc=="utf8"?utf8write(payload):payload;if(typeof IE_SaveFile!=='undefined')return IE_SaveFile(data,fname);if(typeof Blob!=='undefined'){var blob=new Blob([blobify(data)],{type:"application/octet-stream"});if(typeof navigator!=='undefined'&&navigator.msSaveBlob)return navigator.msSaveBlob(blob,fname);if(typeof saveAs!=='undefined')return saveAs(blob,fname);if(typeof URL!=='undefined'&&typeof document!=='undefined'&&document.createElement&&URL.createObjectURL){var url=URL.createObjectURL(blob);if(typeof chrome==='object'&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return chrome.downloads.download({url:url,filename:fname,saveAs:true});}var a=document.createElement("a");if(a.download!=null){a.download=fname;a.href=url;document.body.appendChild(a);a.click();document.body.removeChild(a);if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return url;}}}// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var out=File(fname);out.open("w");out.encoding="binary";if(Array.isArray(payload))payload=a2s(payload);out.write(payload);out.close();return payload;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("cannot save file "+fname);}/* read binary data from file */function read_binary(path){if(typeof _fs!=='undefined')return _fs.readFileSync(path);// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var infile=File(path);infile.open("r");infile.encoding="binary";var data=infile.read();infile.close();return data;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("Cannot access file "+path);}function keys(o){var ks=Object.keys(o),o2=[];for(var i=0;i<ks.length;++i)if(Object.prototype.hasOwnProperty.call(o,ks[i]))o2.push(ks[i]);return o2;}function evert_key(obj,key){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)if(o[obj[K[i]][key]]==null)o[obj[K[i]][key]]=K[i];return o;}function evert(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=K[i];return o;}function evert_num(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=parseInt(K[i],10);return o;}function evert_arr(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]]]==null)o[obj[K[i]]]=[];o[obj[K[i]]].push(K[i]);}return o;}var basedate=new Date(1899,11,30,0,0,0);// 2209161600000
function datenum(v,date1904){var epoch=v.getTime();if(date1904)epoch-=1462*24*60*60*1000;var dnthresh=basedate.getTime()+(v.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;return(epoch-dnthresh)/(24*60*60*1000);}var refdate=new Date();var dnthresh=basedate.getTime()+(refdate.getTimezoneOffset()-basedate.getTimezoneOffset())*60000;var refoffset=refdate.getTimezoneOffset();function numdate(v){var out=new Date();out.setTime(v*24*60*60*1000+dnthresh);if(out.getTimezoneOffset()!==refoffset){out.setTime(out.getTime()+(out.getTimezoneOffset()-refoffset)*60000);}return out;}/* ISO 8601 Duration */function parse_isodur(s){var sec=0,mt=0,time=false;var m=s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!m)throw new Error("|"+s+"| is not an ISO8601 Duration");for(var i=1;i!=m.length;++i){if(!m[i])continue;mt=1;if(i>3)time=true;switch(m[i].slice(m[i].length-1)){case'Y':throw new Error("Unsupported ISO Duration Field: "+m[i].slice(m[i].length-1));case'D':mt*=24;/* falls through */case'H':mt*=60;/* falls through */case'M':if(!time)throw new Error("Unsupported ISO Duration Field: M");else mt*=60;/* falls through */case'S':break;}sec+=mt*parseInt(m[i],10);}return sec;}var good_pd_date=new Date('2017-02-19T19:06:09.000Z');if(isNaN(good_pd_date.getFullYear()))good_pd_date=new Date('2/19/17');var good_pd=good_pd_date.getFullYear()==2017;/* parses a date as a local date */function parseDate(str,fixdate){var d=new Date(str);if(good_pd){if(fixdate>0)d.setTime(d.getTime()+d.getTimezoneOffset()*60*1000);else if(fixdate<0)d.setTime(d.getTime()-d.getTimezoneOffset()*60*1000);return d;}if(str instanceof Date)return str;if(good_pd_date.getFullYear()==1917&&!isNaN(d.getFullYear())){var s=d.getFullYear();if(str.indexOf(""+s)>-1)return d;d.setFullYear(d.getFullYear()+100);return d;}var n=str.match(/\d+/g)||["2017","2","19","0","0","0"];var out=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(str.indexOf("Z")>-1)out=new Date(out.getTime()-out.getTimezoneOffset()*60*1000);return out;}function cc2str(arr){var o="";for(var i=0;i!=arr.length;++i)o+=String.fromCharCode(arr[i]);return o;}function dup(o){if(typeof JSON!='undefined'&&!Array.isArray(o))return JSON.parse(JSON.stringify(o));if(typeof o!='object'||o==null)return o;if(o instanceof Date)return new Date(o.getTime());var out={};for(var k in o)if(Object.prototype.hasOwnProperty.call(o,k))out[k]=dup(o[k]);return out;}function fill(c,l){var o="";while(o.length<l)o+=c;return o;}/* TODO: stress test */function fuzzynum(s){var v=Number(s);if(isFinite(v))return v;if(!isNaN(v))return NaN;if(!/\d/.test(s))return v;var wt=1;var ss=s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){wt*=100;return"";});if(!isNaN(v=Number(ss)))return v/wt;ss=ss.replace(/[(](.*)[)]/,function($$,$1){wt=-wt;return $1;});if(!isNaN(v=Number(ss)))return v/wt;return v;}function fuzzydate(s){var o=new Date(s),n=new Date(NaN);var y=o.getYear(),m=o.getMonth(),d=o.getDate();if(isNaN(d))return n;if(y<0||y>8099)return n;if((m>0||d>1)&&y!=101)return o;if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return o;if(s.match(/[^-0-9:,\/\\]/))return n;return o;}var safe_split_regex="abacaba".split(/(:?b)/i).length==5;function split_regex(str,re,def){if(safe_split_regex||typeof re=="string")return str.split(re);var p=str.split(re),o=[p[0]];for(var i=1;i<p.length;++i){o.push(def);o.push(p[i]);}return o;}function getdatastr(data){if(!data)return null;if(data.data)return debom(data.data);if(data.asNodeBuffer&&has_buf)return debom(data.asNodeBuffer().toString('binary'));if(data.asBinary)return debom(data.asBinary());if(data._data&&data._data.getContent)return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));if(data.content&&data.type)return debom(cc2str(data.content));return null;}function getdatabin(data){if(!data)return null;if(data.data)return char_codes(data.data);if(data.asNodeBuffer&&has_buf)return data.asNodeBuffer();if(data._data&&data._data.getContent){var o=data._data.getContent();if(typeof o=="string")return char_codes(o);return Array.prototype.slice.call(o);}if(data.content&&data.type)return data.content;return null;}function getdata(data){return data&&data.name.slice(-4)===".bin"?getdatabin(data):getdatastr(data);}/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */function safegetzipfile(zip,file){var k=zip.FullPaths||keys(zip.files);var f=file.toLowerCase().replace(/[\/]/g,'\\'),g=f.replace(/\\/g,'\/');for(var i=0;i<k.length;++i){var n=k[i].replace(/^Root Entry[\/]/,"").toLowerCase();if(f==n||g==n)return zip.files?zip.files[k[i]]:zip.FileIndex[i];}return null;}function getzipfile(zip,file){var o=safegetzipfile(zip,file);if(o==null)throw new Error("Cannot find file "+file+" in zip");return o;}function getzipdata(zip,file,safe){if(!safe)return getdata(getzipfile(zip,file));if(!file)return null;try{return getzipdata(zip,file);}catch(e){return null;}}function getzipstr(zip,file,safe){if(!safe)return getdatastr(getzipfile(zip,file));if(!file)return null;try{return getzipstr(zip,file);}catch(e){return null;}}function zipentries(zip){var k=zip.FullPaths||keys(zip.files),o=[];for(var i=0;i<k.length;++i)if(k[i].slice(-1)!='/')o.push(k[i]);return o.sort();}function zip_add_file(zip,path,content){if(zip.FullPaths)CFB.utils.cfb_add(zip,path,content);else zip.file(path,content);}var jszip;/*global JSZipSync:true */if(typeof JSZipSync!=='undefined')jszip=JSZipSync;if(typeof exports!=='undefined'){if(typeof module!=='undefined'&&module.exports){if(typeof jszip==='undefined')jszip=require('./jszip.js');}}function zip_new(){if(!jszip)return CFB.utils.cfb_new();return new jszip();}function zip_read(d,o){var zip;if(jszip)switch(o.type){case"base64":zip=new jszip(d,{base64:true});break;case"binary":case"array":zip=new jszip(d,{base64:false});break;case"buffer":zip=new jszip(d);break;default:throw new Error("Unrecognized type "+o.type);}else switch(o.type){case"base64":zip=CFB.read(d,{type:"base64"});break;case"binary":zip=CFB.read(d,{type:"binary"});break;case"buffer":case"array":zip=CFB.read(d,{type:"buffer"});break;default:throw new Error("Unrecognized type "+o.type);}return zip;}function resolve_path(path,base){if(path.charAt(0)=="/")return path.slice(1);var result=base.split('/');if(base.slice(-1)!="/")result.pop();// folder path
var target=path.split('/');while(target.length!==0){var step=target.shift();if(step==='..')result.pop();else if(step!=='.')result.push(step);}return result.join('/');}var XML_HEADER='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var tagregex=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg;if(!XML_HEADER.match(tagregex))tagregex=/<[^>]*>/g;var nsregex=/<\w*:/,nsregex2=/<(\/?)\w+:/;function parsexmltag(tag,skip_root,skip_LC){var z={};var eq=0,c=0;for(;eq!==tag.length;++eq)if((c=tag.charCodeAt(eq))===32||c===10||c===13)break;if(!skip_root)z[0]=tag.slice(0,eq);if(eq===tag.length)return z;var m=tag.match(attregexg),j=0,v="",i=0,q="",cc="",quot=1;if(m)for(i=0;i!=m.length;++i){cc=m[i];for(c=0;c!=cc.length;++c)if(cc.charCodeAt(c)===61)break;q=cc.slice(0,c).trim();while(cc.charCodeAt(c+1)==32)++c;quot=(eq=cc.charCodeAt(c+1))==34||eq==39?1:0;v=cc.slice(c+1+quot,cc.length-quot);for(j=0;j!=q.length;++j)if(q.charCodeAt(j)===58)break;if(j===q.length){if(q.indexOf("_")>0)q=q.slice(0,q.indexOf("_"));// from ods
z[q]=v;if(!skip_LC)z[q.toLowerCase()]=v;}else{var k=(j===5&&q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);if(z[k]&&q.slice(j-3,j)=="ext")continue;// from ods
z[k]=v;if(!skip_LC)z[k.toLowerCase()]=v;}}return z;}function strip_ns(x){return x.replace(nsregex2,"<$1");}var encodings={'&quot;':'"','&apos;':"'",'&gt;':'>','&lt;':'<','&amp;':'&'};var rencoding=evert(encodings);//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var unescapexml=function(){/* 22.4.2.4 bstr (Basic String) */var encregex=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig,coderegex=/_x([\da-fA-F]{4})_/ig;return function unescapexml(text){var s=text+'',i=s.indexOf("<![CDATA[");if(i==-1)return s.replace(encregex,function($$,$1){return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$;}).replace(coderegex,function(m,c){return String.fromCharCode(parseInt(c,16));});var j=s.indexOf("]]>");return unescapexml(s.slice(0,i))+s.slice(i+9,j)+unescapexml(s.slice(j+3));};}();var decregex=/[&<>'"]/g,charegex=/[\u0000-\u0008\u000b-\u001f]/g;function escapexml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(charegex,function(s){return"_x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+"_";});}function escapexmltag(text){return escapexml(text).replace(/ /g,"_x0020_");}var htmlcharegex=/[\u0000-\u001f]/g;function escapehtml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(/\n/g,"<br/>").replace(htmlcharegex,function(s){return"&#x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+";";});}function escapexlml(text){var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(htmlcharegex,function(s){return"&#x"+s.charCodeAt(0).toString(16).toUpperCase()+";";});}/* TODO: handle codepages */var xlml_fixstr=function(){var entregex=/&#(\d+);/g;function entrepl($$,$1){return String.fromCharCode(parseInt($1,10));}return function xlml_fixstr(str){return str.replace(entregex,entrepl);};}();var xlml_unfixstr=function(){return function xlml_unfixstr(str){return str.replace(/(\r\n|[\r\n])/g,"\&#10;");};}();function parsexmlbool(value){switch(value){case 1:case true:case'1':case'true':case'TRUE':return true;/* case '0': case 'false': case 'FALSE':*/default:return false;}}var utf8read=function utf8reada(orig){var out="",i=0,c=0,d=0,e=0,f=0,w=0;while(i<orig.length){c=orig.charCodeAt(i++);if(c<128){out+=String.fromCharCode(c);continue;}d=orig.charCodeAt(i++);if(c>191&&c<224){f=(c&31)<<6;f|=d&63;out+=String.fromCharCode(f);continue;}e=orig.charCodeAt(i++);if(c<240){out+=String.fromCharCode((c&15)<<12|(d&63)<<6|e&63);continue;}f=orig.charCodeAt(i++);w=((c&7)<<18|(d&63)<<12|(e&63)<<6|f&63)-65536;out+=String.fromCharCode(0xD800+(w>>>10&1023));out+=String.fromCharCode(0xDC00+(w&1023));}return out;};var utf8write=function(orig){var out=[],i=0,c=0,d=0;while(i<orig.length){c=orig.charCodeAt(i++);switch(true){case c<128:out.push(String.fromCharCode(c));break;case c<2048:out.push(String.fromCharCode(192+(c>>6)));out.push(String.fromCharCode(128+(c&63)));break;case c>=55296&&c<57344:c-=55296;d=orig.charCodeAt(i++)-56320+(c<<10);out.push(String.fromCharCode(240+(d>>18&7)));out.push(String.fromCharCode(144+(d>>12&63)));out.push(String.fromCharCode(128+(d>>6&63)));out.push(String.fromCharCode(128+(d&63)));break;default:out.push(String.fromCharCode(224+(c>>12)));out.push(String.fromCharCode(128+(c>>6&63)));out.push(String.fromCharCode(128+(c&63)));}}return out.join("");};if(has_buf){var utf8readb=function utf8readb(data){var out=Buffer.alloc(2*data.length),w,i,j=1,k=0,ww=0,c;for(i=0;i<data.length;i+=j){j=1;if((c=data.charCodeAt(i))<128)w=c;else if(c<224){w=(c&31)*64+(data.charCodeAt(i+1)&63);j=2;}else if(c<240){w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63);j=3;}else{j=4;w=(c&7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);w-=65536;ww=0xD800+(w>>>10&1023);w=0xDC00+(w&1023);}if(ww!==0){out[k++]=ww&255;out[k++]=ww>>>8;ww=0;}out[k++]=w%256;out[k++]=w>>>8;}return out.slice(0,k).toString('ucs2');};var corpus="foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";if(utf8read(corpus)==utf8readb(corpus))utf8read=utf8readb;var utf8readc=function utf8readc(data){return Buffer_from(data,'binary').toString('utf8');};if(utf8read(corpus)==utf8readc(corpus))utf8read=utf8readc;utf8write=function(data){return Buffer_from(data,'utf8').toString("binary");};}// matches <foo>...</foo> extracts content
var matchtag=function(){var mtcache={};return function matchtag(f,g){var t=f+"|"+(g||"");if(mtcache[t])return mtcache[t];return mtcache[t]=new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',g||"");};}();var htmldecode=function(){var entities=[['nbsp',' '],['middot','·'],['quot','"'],['apos',"'"],['gt','>'],['lt','<'],['amp','&']].map(function(x){return[new RegExp('&'+x[0]+';',"ig"),x[1]];});return function htmldecode(str){var o=str// Remove new lines and spaces from start of content
.replace(/^[\t\n\r ]+/,"")// Remove new lines and spaces from end of content
.replace(/[\t\n\r ]+$/,"")// Added line which removes any white space characters after and before html tags
.replace(/>\s+/g,">").replace(/\s+</g,"<")// Replace remaining new lines and spaces with space
.replace(/[\t\n\r ]+/g," ")// Replace <br> tags with new lines
.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")// Strip HTML elements
.replace(/<[^>]*>/g,"");for(var i=0;i<entities.length;++i)o=o.replace(entities[i][0],entities[i][1]);return o;};}();var vtregex=function(){var vt_cache={};return function vt_regex(bt){if(vt_cache[bt]!==undefined)return vt_cache[bt];return vt_cache[bt]=new RegExp("<(?:vt:)?"+bt+">([\\s\\S]*?)</(?:vt:)?"+bt+">",'g');};}();var vtvregex=/<\/?(?:vt:)?variant>/g,vtmregex=/<(?:vt:)([^>]*)>([\s\S]*)</;function parseVector(data,opts){var h=parsexmltag(data);var matches=data.match(vtregex(h.baseType))||[];var res=[];if(matches.length!=h.size){if(opts.WTF)throw new Error("unexpected vector length "+matches.length+" != "+h.size);return res;}matches.forEach(function(x){var v=x.replace(vtvregex,"").match(vtmregex);if(v)res.push({v:utf8read(v[2]),t:v[1]});});return res;}var wtregex=/(^\s|\s$|\n)/;function writetag(f,g){return'<'+f+(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f+'>';}function wxt_helper(h){return keys(h).map(function(k){return" "+k+'="'+h[k]+'"';}).join("");}function writextag(f,g,h){return'<'+f+(h!=null?wxt_helper(h):"")+(g!=null?(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f:"/")+'>';}function write_w3cdtf(d,t){try{return d.toISOString().replace(/\.\d*/,"");}catch(e){if(t)throw e;}return"";}function write_vt(s,xlsx){switch(typeof s){case'string':var o=writextag('vt:lpwstr',escapexml(s));if(xlsx)o=o.replace(/&quot;/g,"_x0022_");return o;case'number':return writextag((s|0)==s?'vt:i4':'vt:r8',escapexml(String(s)));case'boolean':return writextag('vt:bool',s?'true':'false');}if(s instanceof Date)return writextag('vt:filetime',write_w3cdtf(s));throw new Error("Unable to serialize "+s);}var XMLNS={'dc':'http://purl.org/dc/elements/1.1/','dcterms':'http://purl.org/dc/terms/','dcmitype':'http://purl.org/dc/dcmitype/','mx':'http://schemas.microsoft.com/office/mac/excel/2008/main','r':'http://schemas.openxmlformats.org/officeDocument/2006/relationships','sjs':'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties','vt':'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes','xsi':'http://www.w3.org/2001/XMLSchema-instance','xsd':'http://www.w3.org/2001/XMLSchema'};XMLNS.main=['http://schemas.openxmlformats.org/spreadsheetml/2006/main','http://purl.oclc.org/ooxml/spreadsheetml/main','http://schemas.microsoft.com/office/excel/2006/main','http://schemas.microsoft.com/office/excel/2006/2'];var XLMLNS={'o':'urn:schemas-microsoft-com:office:office','x':'urn:schemas-microsoft-com:office:excel','ss':'urn:schemas-microsoft-com:office:spreadsheet','dt':'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882','mv':'http://macVmlSchemaUri','v':'urn:schemas-microsoft-com:vml','html':'http://www.w3.org/TR/REC-html40'};function read_double_le(b,idx){var s=1-2*(b[idx+7]>>>7);var e=((b[idx+7]&0x7f)<<4)+(b[idx+6]>>>4&0x0f);var m=b[idx+6]&0x0f;for(var i=5;i>=0;--i)m=m*256+b[idx+i];if(e==0x7ff)return m==0?s*Infinity:NaN;if(e==0)e=-1022;else{e-=1023;m+=Math.pow(2,52);}return s*Math.pow(2,e-52)*m;}function write_double_le(b,v,idx){var bs=(v<0||1/v==-Infinity?1:0)<<7,e=0,m=0;var av=bs?-v:v;if(!isFinite(av)){e=0x7ff;m=isNaN(v)?0x6969:0;}else if(av==0)e=m=0;else{e=Math.floor(Math.log(av)/Math.LN2);m=av*Math.pow(2,52-e);if(e<=-1023&&(!isFinite(m)||m<Math.pow(2,52))){e=-1022;}else{m-=Math.pow(2,52);e+=1023;}}for(var i=0;i<=5;++i,m/=256)b[idx+i]=m&0xff;b[idx+6]=(e&0x0f)<<4|m&0xf;b[idx+7]=e>>4|bs;}var __toBuffer=function(bufs){var x=[],w=10240;for(var i=0;i<bufs[0].length;++i)if(bufs[0][i])for(var j=0,L=bufs[0][i].length;j<L;j+=w)x.push.apply(x,bufs[0][i].slice(j,j+w));return x;};var ___toBuffer=__toBuffer;var __utf16le=function(b,s,e){var ss=[];for(var i=s;i<e;i+=2)ss.push(String.fromCharCode(__readUInt16LE(b,i)));return ss.join("").replace(chr0,'');};var ___utf16le=__utf16le;var __hexlify=function(b,s,l){var ss=[];for(var i=s;i<s+l;++i)ss.push(("0"+b[i].toString(16)).slice(-2));return ss.join("");};var ___hexlify=__hexlify;var __utf8=function(b,s,e){var ss=[];for(var i=s;i<e;i++)ss.push(String.fromCharCode(__readUInt8(b,i)));return ss.join("");};var ___utf8=__utf8;var __lpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___lpstr=__lpstr;var __cpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___cpstr=__cpstr;var __lpwstr=function(b,i){var len=2*__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var ___lpwstr=__lpwstr;var __lpp4,___lpp4;__lpp4=___lpp4=function lpp4_(b,i){var len=__readUInt32LE(b,i);return len>0?__utf16le(b,i+4,i+4+len):"";};var __8lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len):"";};var ___8lpp4=__8lpp4;var __double,___double;__double=___double=function(b,idx){return read_double_le(b,idx);};var is_buf=function is_buf_a(a){return Array.isArray(a);};if(has_buf){__utf16le=function(b,s,e){if(!Buffer.isBuffer(b))return ___utf16le(b,s,e);return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/;};__hexlify=function(b,s,l){return Buffer.isBuffer(b)?b.toString('hex',s,s+l):___hexlify(b,s,l);};__lpstr=function lpstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__cpstr=function cpstr_b(b,i){if(!Buffer.isBuffer(b))return ___cpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__lpwstr=function lpwstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpwstr(b,i);var len=2*b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len-1);};__lpp4=function lpp4_b(b,i){if(!Buffer.isBuffer(b))return ___lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len);};__8lpp4=function lpp4_8b(b,i){if(!Buffer.isBuffer(b))return ___8lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf8',i+4,i+4+len);};__utf8=function utf8_b(b,s,e){return Buffer.isBuffer(b)?b.toString('utf8',s,e):___utf8(b,s,e);};__toBuffer=function(bufs){return bufs[0].length>0&&Buffer.isBuffer(bufs[0][0])?Buffer.concat(bufs[0]):___toBuffer(bufs);};bconcat=function(bufs){return Buffer.isBuffer(bufs[0])?Buffer.concat(bufs):[].concat.apply([],bufs);};__double=function double_(b,i){if(Buffer.isBuffer(b))return b.readDoubleLE(i);return ___double(b,i);};is_buf=function is_buf_b(a){return Buffer.isBuffer(a)||Array.isArray(a);};}/* from js-xls */if(typeof cptable!=='undefined'){__utf16le=function(b,s,e){return cptable.utils.decode(1200,b.slice(s,e)).replace(chr0,'');};__utf8=function(b,s,e){return cptable.utils.decode(65001,b.slice(s,e));};__lpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(current_ansi,b.slice(i+4,i+4+len-1)):"";};__cpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(current_codepage,b.slice(i+4,i+4+len-1)):"";};__lpwstr=function(b,i){var len=2*__readUInt32LE(b,i);return len>0?cptable.utils.decode(1200,b.slice(i+4,i+4+len-1)):"";};__lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(1200,b.slice(i+4,i+4+len)):"";};__8lpp4=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(65001,b.slice(i+4,i+4+len)):"";};}var __readUInt8=function(b,idx){return b[idx];};var __readUInt16LE=function(b,idx){return b[idx+1]*(1<<8)+b[idx];};var __readInt16LE=function(b,idx){var u=b[idx+1]*(1<<8)+b[idx];return u<0x8000?u:(0xffff-u+1)*-1;};var __readUInt32LE=function(b,idx){return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx];};var __readInt32LE=function(b,idx){return b[idx+3]<<24|b[idx+2]<<16|b[idx+1]<<8|b[idx];};var __readInt32BE=function(b,idx){return b[idx]<<24|b[idx+1]<<16|b[idx+2]<<8|b[idx+3];};function ReadShift(size,t){var o="",oI,oR,oo=[],w,vv,i,loc;switch(t){case'dbcs':loc=this.l;if(has_buf&&Buffer.isBuffer(this))o=this.slice(this.l,this.l+2*size).toString("utf16le");else for(i=0;i<size;++i){o+=String.fromCharCode(__readUInt16LE(this,loc));loc+=2;}size*=2;break;case'utf8':o=__utf8(this,this.l,this.l+size);break;case'utf16le':size*=2;o=__utf16le(this,this.l,this.l+size);break;case'wstr':if(typeof cptable!=='undefined')o=cptable.utils.decode(current_codepage,this.slice(this.l,this.l+2*size));else return ReadShift.call(this,size,'dbcs');size=2*size;break;/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */case'lpstr-ansi':o=__lpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;case'lpstr-cp':o=__cpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */case'lpwstr':o=__lpwstr(this,this.l);size=4+2*__readUInt32LE(this,this.l);break;/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */case'lpp4':size=4+__readUInt32LE(this,this.l);o=__lpp4(this,this.l);if(size&0x02)size+=2;break;/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */case'8lpp4':size=4+__readUInt32LE(this,this.l);o=__8lpp4(this,this.l);if(size&0x03)size+=4-(size&0x03);break;case'cstr':size=0;o="";while((w=__readUInt8(this,this.l+size++))!==0)oo.push(_getchar(w));o=oo.join("");break;case'_wstr':size=0;o="";while((w=__readUInt16LE(this,this.l+size))!==0){oo.push(_getchar(w));size+=2;}size+=2;o=oo.join("");break;/* sbcs and dbcs support continue records in the SST way TODO codepages */case'dbcs-cont':o="";loc=this.l;for(i=0;i<size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt16LE(this,loc)));loc+=2;}o=oo.join("");size*=2;break;case'cpstr':if(typeof cptable!=='undefined'){o=cptable.utils.decode(current_codepage,this.slice(this.l,this.l+size));break;}/* falls through */case'sbcs-cont':o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt8(this,loc)));loc+=1;}o=oo.join("");break;default:switch(size){case 1:oI=__readUInt8(this,this.l);this.l++;return oI;case 2:oI=(t==='i'?__readInt16LE:__readUInt16LE)(this,this.l);this.l+=2;return oI;case 4:case-4:if(t==='i'||(this[this.l+3]&0x80)===0){oI=(size>0?__readInt32LE:__readInt32BE)(this,this.l);this.l+=4;return oI;}else{oR=__readUInt32LE(this,this.l);this.l+=4;}return oR;case 8:case-8:if(t==='f'){if(size==8)oR=__double(this,this.l);else oR=__double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return oR;}else size=8;/* falls through */case 16:o=__hexlify(this,this.l,size);break;}}this.l+=size;return o;}var __writeUInt32LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;b[idx+2]=val>>>16&0xFF;b[idx+3]=val>>>24&0xFF;};var __writeInt32LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>8&0xFF;b[idx+2]=val>>16&0xFF;b[idx+3]=val>>24&0xFF;};var __writeUInt16LE=function(b,val,idx){b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;};function WriteShift(t,val,f){var size=0,i=0;if(f==='dbcs'){for(i=0;i!=val.length;++i)__writeUInt16LE(this,val.charCodeAt(i),this.l+2*i);size=2*val.length;}else if(f==='sbcs'){if(typeof cptable!=='undefined'&&current_ansi==874){/* TODO: use tables directly, don't encode */for(i=0;i!=val.length;++i){var cppayload=cptable.utils.encode(current_ansi,val.charAt(i));this[this.l+i]=cppayload[0];}}else{val=val.replace(/[^\x00-\x7F]/g,"_");for(i=0;i!=val.length;++i)this[this.l+i]=val.charCodeAt(i)&0xFF;}size=val.length;}else if(f==='hex'){for(;i<t;++i){this[this.l++]=parseInt(val.slice(2*i,2*i+2),16)||0;}return this;}else if(f==='utf16le'){var end=Math.min(this.l+t,this.length);for(i=0;i<Math.min(val.length,t);++i){var cc=val.charCodeAt(i);this[this.l++]=cc&0xff;this[this.l++]=cc>>8;}while(this.l<end)this[this.l++]=0;return this;}else switch(t){case 1:size=1;this[this.l]=val&0xFF;break;case 2:size=2;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;break;case 3:size=3;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;val>>>=8;this[this.l+2]=val&0xFF;break;case 4:size=4;__writeUInt32LE(this,val,this.l);break;case 8:size=8;if(f==='f'){write_double_le(this,val,this.l);break;}/* falls through */case 16:break;case-4:size=4;__writeInt32LE(this,val,this.l);break;}this.l+=size;return this;}function CheckField(hexstr,fld){var m=__hexlify(this,this.l,hexstr.length>>1);if(m!==hexstr)throw new Error(fld+'Expected '+hexstr+' saw '+m);this.l+=hexstr.length>>1;}function prep_blob(blob,pos){blob.l=pos;blob.read_shift=ReadShift;blob.chk=CheckField;blob.write_shift=WriteShift;}function parsenoop(blob,length){blob.l+=length;}function new_buf(sz){var o=new_raw_buf(sz);prep_blob(o,0);return o;}/* [MS-XLSB] 2.1.4 Record */function recordhopper(data,cb,opts){if(!data)return;var tmpbyte,cntbyte,length;prep_blob(data,data.l||0);var L=data.length,RT=0,tgt=0;while(data.l<L){RT=data.read_shift(1);if(RT&0x80)RT=(RT&0x7F)+((data.read_shift(1)&0x7F)<<7);var R=XLSBRecordEnum[RT]||XLSBRecordEnum[0xFFFF];tmpbyte=data.read_shift(1);length=tmpbyte&0x7F;for(cntbyte=1;cntbyte<4&&tmpbyte&0x80;++cntbyte)length+=((tmpbyte=data.read_shift(1))&0x7F)<<7*cntbyte;tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R.n,RT))return;}}/* control buffer usage for fixed-length buffers */function buf_array(){var bufs=[],blksz=has_buf?256:2048;var newblk=function ba_newblk(sz){var o=new_buf(sz);prep_blob(o,0);return o;};var curbuf=newblk(blksz);var endbuf=function ba_endbuf(){if(!curbuf)return;if(curbuf.length>curbuf.l){curbuf=curbuf.slice(0,curbuf.l);curbuf.l=curbuf.length;}if(curbuf.length>0)bufs.push(curbuf);curbuf=null;};var next=function ba_next(sz){if(curbuf&&sz<curbuf.length-curbuf.l)return curbuf;endbuf();return curbuf=newblk(Math.max(sz+1,blksz));};var end=function ba_end(){endbuf();return __toBuffer([bufs]);};var push=function ba_push(buf){endbuf();curbuf=buf;if(curbuf.l==null)curbuf.l=curbuf.length;next(blksz);};return{next:next,push:push,end:end,_bufs:bufs};}function write_record(ba,type,payload,length){var t=+XLSBRE[type],l;if(isNaN(t))return;// TODO: throw something here?
if(!length)length=XLSBRecordEnum[t].p||(payload||[]).length||0;l=1+(t>=0x80?1:0)+1/* + length*/;if(length>=0x80)++l;if(length>=0x4000)++l;if(length>=0x200000)++l;var o=ba.next(l);if(t<=0x7F)o.write_shift(1,t);else{o.write_shift(1,(t&0x7F)+0x80);o.write_shift(1,t>>7);}for(var i=0;i!=4;++i){if(length>=0x80){o.write_shift(1,(length&0x7F)+0x80);length>>=7;}else{o.write_shift(1,length);break;}}if(length>0&&is_buf(payload))ba.push(payload);}/* XLS ranges enforced */function shift_cell_xls(cell,tgt,opts){var out=dup(cell);if(tgt.s){if(out.cRel)out.c+=tgt.s.c;if(out.rRel)out.r+=tgt.s.r;}else{if(out.cRel)out.c+=tgt.c;if(out.rRel)out.r+=tgt.r;}if(!opts||opts.biff<12){while(out.c>=0x100)out.c-=0x100;while(out.r>=0x10000)out.r-=0x10000;}return out;}function shift_range_xls(cell,range,opts){var out=dup(cell);out.s=shift_cell_xls(out.s,range.s,opts);out.e=shift_cell_xls(out.e,range.s,opts);return out;}function encode_cell_xls(c,biff){if(c.cRel&&c.c<0){c=dup(c);while(c.c<0)c.c+=biff>8?0x4000:0x100;}if(c.rRel&&c.r<0){c=dup(c);while(c.r<0)c.r+=biff>8?0x100000:biff>5?0x10000:0x4000;}var s=encode_cell(c);if(!c.cRel&&c.cRel!=null)s=fix_col(s);if(!c.rRel&&c.rRel!=null)s=fix_row(s);return s;}function encode_range_xls(r,opts){if(r.s.r==0&&!r.s.rRel){if(r.e.r==(opts.biff>=12?0xFFFFF:opts.biff>=8?0x10000:0x4000)&&!r.e.rRel){return(r.s.cRel?"":"$")+encode_col(r.s.c)+":"+(r.e.cRel?"":"$")+encode_col(r.e.c);}}if(r.s.c==0&&!r.s.cRel){if(r.e.c==(opts.biff>=12?0x3FFF:0xFF)&&!r.e.cRel){return(r.s.rRel?"":"$")+encode_row(r.s.r)+":"+(r.e.rRel?"":"$")+encode_row(r.e.r);}}return encode_cell_xls(r.s,opts.biff)+":"+encode_cell_xls(r.e,opts.biff);}var OFFCRYPTO={};var make_offcrypto=function(O,_crypto){var crypto;if(typeof _crypto!=='undefined')crypto=_crypto;else if(typeof require!=='undefined'){try{crypto=require('crypto');}catch(e){crypto=null;}}O.rc4=function(key,data){var S=new Array(256);var c=0,i=0,j=0,t=0;for(i=0;i!=256;++i)S[i]=i;for(i=0;i!=256;++i){j=j+S[i]+key[i%key.length].charCodeAt(0)&255;t=S[i];S[i]=S[j];S[j]=t;}// $FlowIgnore
i=j=0;var out=new_raw_buf(data.length);for(c=0;c!=data.length;++c){i=i+1&255;j=(j+S[i])%256;t=S[i];S[i]=S[j];S[j]=t;out[c]=data[c]^S[S[i]+S[j]&255];}return out;};O.md5=function(hex){if(!crypto)throw new Error("Unsupported crypto");return crypto.createHash('md5').update(hex).digest('hex');};};/*global crypto:true */make_offcrypto(OFFCRYPTO,typeof crypto!=="undefined"?crypto:undefined);function decode_row(rowstr){return parseInt(unfix_row(rowstr),10)-1;}function encode_row(row){return""+(row+1);}function fix_row(cstr){return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2");}function unfix_row(cstr){return cstr.replace(/\$(\d+)$/,"$1");}function decode_col(colstr){var c=unfix_col(colstr),d=0,i=0;for(;i!==c.length;++i)d=26*d+c.charCodeAt(i)-64;return d-1;}function encode_col(col){if(col<0)throw new Error("invalid column "+col);var s="";for(++col;col;col=Math.floor((col-1)/26))s=String.fromCharCode((col-1)%26+65)+s;return s;}function fix_col(cstr){return cstr.replace(/^([A-Z])/,"$$$1");}function unfix_col(cstr){return cstr.replace(/^\$([A-Z])/,"$1");}function split_cell(cstr){return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",");}//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr){var R=0,C=0;for(var i=0;i<cstr.length;++i){var cc=cstr.charCodeAt(i);if(cc>=48&&cc<=57)R=10*R+(cc-48);else if(cc>=65&&cc<=90)C=26*C+(cc-64);}return{c:C-1,r:R-1};}//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell){var col=cell.c+1;var s="";for(;col;col=(col-1)/26|0)s=String.fromCharCode((col-1)%26+65)+s;return s+(cell.r+1);}function decode_range(range){var idx=range.indexOf(":");if(idx==-1)return{s:decode_cell(range),e:decode_cell(range)};return{s:decode_cell(range.slice(0,idx)),e:decode_cell(range.slice(idx+1))};}function encode_range(cs,ce){if(typeof ce==='undefined'||typeof ce==='number'){return encode_range(cs.s,cs.e);}if(typeof cs!=='string')cs=encode_cell(cs);if(typeof ce!=='string')ce=encode_cell(ce);return cs==ce?cs:cs+":"+ce;}function safe_decode_range(range){var o={s:{c:0,r:0},e:{c:0,r:0}};var idx=0,i=0,cc=0;var len=range.length;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.s.c=--idx;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.s.r=--idx;if(i===len||cc!=10){o.e.c=o.s.c;o.e.r=o.s.r;return o;}++i;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.e.c=--idx;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.e.r=--idx;return o;}function safe_format_cell(cell,v){var q=cell.t=='d'&&v instanceof Date;if(cell.z!=null)try{return cell.w=SSF.format(cell.z,q?datenum(v):v);}catch(e){}try{return cell.w=SSF.format((cell.XF||{}).numFmtId||(q?14:0),q?datenum(v):v);}catch(e){return''+v;}}function format_cell(cell,v,o){if(cell==null||cell.t==null||cell.t=='z')return"";if(cell.w!==undefined)return cell.w;if(cell.t=='d'&&!cell.z&&o&&o.dateNF)cell.z=o.dateNF;if(cell.t=="e")return BErr[cell.v]||cell.v;if(v==undefined)return safe_format_cell(cell,cell.v);return safe_format_cell(cell,v);}function sheet_to_workbook(sheet,opts){var n=opts&&opts.sheet?opts.sheet:"Sheet1";var sheets={};sheets[n]=sheet;return{SheetNames:[n],Sheets:sheets};}function sheet_add_aoa(_ws,data,opts){var o=opts||{};var dense=_ws?Array.isArray(_ws):o.dense;if(DENSE!=null&&dense==null)dense=DENSE;var ws=_ws||(dense?[]:{});var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}if(!ws["!ref"])ws["!ref"]="A1:A1";}var range={s:{c:10000000,r:10000000},e:{c:0,r:0}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.s.c=_range.s.c;range.s.r=_range.s.r;range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1)range.e.r=_R=_range.e.r+1;}for(var R=0;R!=data.length;++R){if(!data[R])continue;if(!Array.isArray(data[R]))throw new Error("aoa_to_sheet expects an array of arrays");for(var C=0;C!=data[R].length;++C){if(typeof data[R][C]==='undefined')continue;var cell={v:data[R][C]};var __R=_R+R,__C=_C+C;if(range.s.r>__R)range.s.r=__R;if(range.s.c>__C)range.s.c=__C;if(range.e.r<__R)range.e.r=__R;if(range.e.c<__C)range.e.c=__C;if(data[R][C]&&typeof data[R][C]==='object'&&!Array.isArray(data[R][C])&&!(data[R][C]instanceof Date))cell=data[R][C];else{if(Array.isArray(cell.v)){cell.f=data[R][C][1];cell.v=cell.v[0];}if(cell.v===null){if(cell.f)cell.t='n';else if(o.nullError){cell.t='e';cell.v=0;}else if(!o.sheetStubs)continue;else cell.t='z';}else if(typeof cell.v==='number')cell.t='n';else if(typeof cell.v==='boolean')cell.t='b';else if(cell.v instanceof Date){cell.z=o.dateNF||SSF._table[14];if(o.cellDates){cell.t='d';cell.w=SSF.format(cell.z,datenum(cell.v));}else{cell.t='n';cell.v=datenum(cell.v);cell.w=SSF.format(cell.z,cell.v);}}else cell.t='s';}if(dense){if(!ws[__R])ws[__R]=[];if(ws[__R][__C]&&ws[__R][__C].z)cell.z=ws[__R][__C].z;ws[__R][__C]=cell;}else{var cell_ref=encode_cell({c:__C,r:__R});if(ws[cell_ref]&&ws[cell_ref].z)cell.z=ws[cell_ref].z;ws[cell_ref]=cell;}}}if(range.s.c<10000000)ws['!ref']=encode_range(range);return ws;}function aoa_to_sheet(data,opts){return sheet_add_aoa(null,data,opts);}function write_UInt32LE(x,o){if(!o)o=new_buf(4);o.write_shift(4,x);return o;}/* [MS-XLSB] 2.5.168 */function parse_XLWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0?"":data.read_shift(cchCharacters,'dbcs');}function write_XLWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(4+2*data.length);}o.write_shift(4,data.length);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data) {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */function parse_StrRun(data){return{ich:data.read_shift(2),ifnt:data.read_shift(2)};}function write_StrRun(run,o){if(!o)o=new_buf(4);o.write_shift(2,run.ich||0);o.write_shift(2,run.ifnt||0);return o;}/* [MS-XLSB] 2.5.121 */function parse_RichStr(data,length){var start=data.l;var flags=data.read_shift(1);var str=parse_XLWideString(data);var rgsStrRun=[];var z={t:str,h:str};if((flags&1)!==0){/* fRichStr */ /* TODO: formatted string */var dwSizeStrRun=data.read_shift(4);for(var i=0;i!=dwSizeStrRun;++i)rgsStrRun.push(parse_StrRun(data));z.r=rgsStrRun;}else z.r=[{ich:0,ifnt:0}];//if((flags & 2) !== 0) { /* fExtStr */
//	/* TODO: phonetic string */
//}
data.l=start+length;return z;}function write_RichStr(str,o){/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(15+4*str.t.length);}o.write_shift(1,0);write_XLWideString(str.t,o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */var parse_BrtCommentText=parse_RichStr;function write_BrtCommentText(str,o){/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(23+4*str.t.length);}o.write_shift(1,1);write_XLWideString(str.t,o);o.write_shift(4,1);write_StrRun({ich:0,ifnt:0},o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.9 */function parse_XLSBCell(data){var col=data.read_shift(4);var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return{c:col,iStyleRef:iStyleRef};}function write_XLSBCell(cell,o){if(o==null)o=new_buf(8);o.write_shift(-4,cell.c);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* Short XLSB Cell does not include column */function parse_XLSBShortCell(data){var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return{c:-1,iStyleRef:iStyleRef};}function write_XLSBShortCell(cell,o){if(o==null)o=new_buf(4);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* [MS-XLSB] 2.5.21 */var parse_XLSBCodeName=parse_XLWideString;var write_XLSBCodeName=write_XLWideString;/* [MS-XLSB] 2.5.166 */function parse_XLNullableWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0||cchCharacters===0xFFFFFFFF?"":data.read_shift(cchCharacters,'dbcs');}function write_XLNullableWideString(data,o){var _null=false;if(o==null){_null=true;o=new_buf(127);}o.write_shift(4,data.length>0?data.length:0xFFFFFFFF);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.165 */var parse_XLNameWideString=parse_XLWideString;//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */var parse_RelID=parse_XLNullableWideString;var write_RelID=write_XLNullableWideString;/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */function parse_RkNumber(data){var b=data.slice(data.l,data.l+4);var fX100=b[0]&1,fInt=b[0]&2;data.l+=4;b[0]&=0xFC;// b[0] &= ~3;
var RK=fInt===0?__double([0,0,0,0,b[0],b[1],b[2],b[3]],0):__readInt32LE(b,0)>>2;return fX100?RK/100:RK;}function write_RkNumber(data,o){if(o==null)o=new_buf(4);var fX100=0,fInt=0,d100=data*100;if(data==(data|0)&&data>=-(1<<29)&&data<1<<29){fInt=1;}else if(d100==(d100|0)&&d100>=-(1<<29)&&d100<1<<29){fInt=1;fX100=1;}if(fInt)o.write_shift(-4,((fX100?d100:data)<<2)+(fX100+2));else throw new Error("unsupported RkNumber "+data);// TODO
}/* [MS-XLSB] 2.5.117 RfX */function parse_RfX(data){var cell={s:{},e:{}};cell.s.r=data.read_shift(4);cell.e.r=data.read_shift(4);cell.s.c=data.read_shift(4);cell.e.c=data.read_shift(4);return cell;}function write_RfX(r,o){if(!o)o=new_buf(16);o.write_shift(4,r.s.r);o.write_shift(4,r.e.r);o.write_shift(4,r.s.c);o.write_shift(4,r.e.c);return o;}/* [MS-XLSB] 2.5.153 UncheckedRfX */var parse_UncheckedRfX=parse_RfX;var write_UncheckedRfX=write_RfX;/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */function parse_Xnum(data){if(data.length-data.l<8)throw"XLS Xnum Buffer underflow";return data.read_shift(8,'f');}function write_Xnum(data,o){return(o||new_buf(8)).write_shift(8,data,'f');}/* [MS-XLSB] 2.4.324 BrtColor */function parse_BrtColor(data){var out={};var d=data.read_shift(1);//var fValidRGB = d & 1;
var xColorType=d>>>1;var index=data.read_shift(1);var nTS=data.read_shift(2,'i');var bR=data.read_shift(1);var bG=data.read_shift(1);var bB=data.read_shift(1);data.l++;//var bAlpha = data.read_shift(1);
switch(xColorType){case 0:out.auto=1;break;case 1:out.index=index;var icv=XLSIcv[index];/* automatic pseudo index 81 */if(icv)out.rgb=rgb2Hex(icv);break;case 2:/* if(!fValidRGB) throw new Error("invalid"); */out.rgb=rgb2Hex([bR,bG,bB]);break;case 3:out.theme=index;break;}if(nTS!=0)out.tint=nTS>0?nTS/32767:nTS/32768;return out;}function write_BrtColor(color,o){if(!o)o=new_buf(8);if(!color||color.auto){o.write_shift(4,0);o.write_shift(4,0);return o;}if(color.index!=null){o.write_shift(1,0x02);o.write_shift(1,color.index);}else if(color.theme!=null){o.write_shift(1,0x06);o.write_shift(1,color.theme);}else{o.write_shift(1,0x05);o.write_shift(1,0);}var nTS=color.tint||0;if(nTS>0)nTS*=32767;else if(nTS<0)nTS*=32768;o.write_shift(2,nTS);if(!color.rgb||color.theme!=null){o.write_shift(2,0);o.write_shift(1,0);o.write_shift(1,0);}else{var rgb=color.rgb||'FFFFFF';if(typeof rgb=='number')rgb=("000000"+rgb.toString(16)).slice(-6);o.write_shift(1,parseInt(rgb.slice(0,2),16));o.write_shift(1,parseInt(rgb.slice(2,4),16));o.write_shift(1,parseInt(rgb.slice(4,6),16));o.write_shift(1,0xFF);}return o;}/* [MS-XLSB] 2.5.52 */function parse_FontFlags(data){var d=data.read_shift(1);data.l++;var out={fBold:d&0x01,fItalic:d&0x02,fUnderline:d&0x04,fStrikeout:d&0x08,fOutline:d&0x10,fShadow:d&0x20,fCondense:d&0x40,fExtend:d&0x80};return out;}function write_FontFlags(font,o){if(!o)o=new_buf(2);var grbit=(font.italic?0x02:0)|(font.strike?0x08:0)|(font.outline?0x10:0)|(font.shadow?0x20:0)|(font.condense?0x40:0)|(font.extend?0x80:0);o.write_shift(1,grbit);o.write_shift(1,0);return o;}/* [MS-OLEDS] 2.3.1 and 2.3.2 */function parse_ClipboardFormatOrString(o,w){// $FlowIgnore
var ClipFmt={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var m=o.read_shift(4);switch(m){case 0x00000000:return"";case 0xffffffff:case 0xfffffffe:return ClipFmt[o.read_shift(4)]||"";}if(m>0x190)throw new Error("Unsupported Clipboard: "+m.toString(16));o.l-=4;return o.read_shift(0,w==1?"lpstr":"lpwstr");}function parse_ClipboardFormatOrAnsiString(o){return parse_ClipboardFormatOrString(o,1);}function parse_ClipboardFormatOrUnicodeString(o){return parse_ClipboardFormatOrString(o,2);}/* [MS-OLEPS] 2.2 PropertyType */ //var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2=0x0002;var VT_I4=0x0003;//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL=0x000B;var VT_VARIANT=0x000C;//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4=0x0013;//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR=0x001E;//var VT_LPWSTR   = 0x001F;
var VT_FILETIME=0x0040;var VT_BLOB=0x0041;//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF=0x0047;//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR=0x1000;//var VT_ARRAY    = 0x2000;
var VT_STRING=0x0050;// 2.3.3.1.11 VtString
var VT_USTR=0x0051;// 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM=[VT_STRING,VT_USTR];/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */var DocSummaryPIDDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Category',t:VT_STRING},0x03:{n:'PresentationFormat',t:VT_STRING},0x04:{n:'ByteCount',t:VT_I4},0x05:{n:'LineCount',t:VT_I4},0x06:{n:'ParagraphCount',t:VT_I4},0x07:{n:'SlideCount',t:VT_I4},0x08:{n:'NoteCount',t:VT_I4},0x09:{n:'HiddenCount',t:VT_I4},0x0a:{n:'MultimediaClipCount',t:VT_I4},0x0b:{n:'ScaleCrop',t:VT_BOOL},0x0c:{n:'HeadingPairs',t:VT_VECTOR|VT_VARIANT},0x0d:{n:'TitlesOfParts',t:VT_VECTOR|VT_LPSTR},0x0e:{n:'Manager',t:VT_STRING},0x0f:{n:'Company',t:VT_STRING},0x10:{n:'LinksUpToDate',t:VT_BOOL},0x11:{n:'CharacterCount',t:VT_I4},0x13:{n:'SharedDoc',t:VT_BOOL},0x16:{n:'HyperlinksChanged',t:VT_BOOL},0x17:{n:'AppVersion',t:VT_I4,p:'version'},0x18:{n:'DigSig',t:VT_BLOB},0x1A:{n:'ContentType',t:VT_STRING},0x1B:{n:'ContentStatus',t:VT_STRING},0x1C:{n:'Language',t:VT_STRING},0x1D:{n:'Version',t:VT_STRING},0xFF:{},/* [MS-OLEPS] 2.18 */0x80000000:{n:'Locale',t:VT_UI4},0x80000003:{n:'Behavior',t:VT_UI4},0x72627262:{}};/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */var SummaryPIDSI={0x01:{n:'CodePage',t:VT_I2},0x02:{n:'Title',t:VT_STRING},0x03:{n:'Subject',t:VT_STRING},0x04:{n:'Author',t:VT_STRING},0x05:{n:'Keywords',t:VT_STRING},0x06:{n:'Comments',t:VT_STRING},0x07:{n:'Template',t:VT_STRING},0x08:{n:'LastAuthor',t:VT_STRING},0x09:{n:'RevNumber',t:VT_STRING},0x0A:{n:'EditTime',t:VT_FILETIME},0x0B:{n:'LastPrinted',t:VT_FILETIME},0x0C:{n:'CreatedDate',t:VT_FILETIME},0x0D:{n:'ModifiedDate',t:VT_FILETIME},0x0E:{n:'PageCount',t:VT_I4},0x0F:{n:'WordCount',t:VT_I4},0x10:{n:'CharCount',t:VT_I4},0x11:{n:'Thumbnail',t:VT_CF},0x12:{n:'Application',t:VT_STRING},0x13:{n:'DocSecurity',t:VT_I4},0xFF:{},/* [MS-OLEPS] 2.18 */0x80000000:{n:'Locale',t:VT_UI4},0x80000003:{n:'Behavior',t:VT_UI4},0x72627262:{}};var DocSummaryRE=evert_key(DocSummaryPIDDSI,"n");var SummaryRE=evert_key(SummaryPIDSI,"n");/* [MS-XLS] 2.4.63 Country/Region codes */var CountryEnum={0x0001:"US",// United States
0x0002:"CA",// Canada
0x0003:"",// Latin America (except Brazil)
0x0007:"RU",// Russia
0x0014:"EG",// Egypt
0x001E:"GR",// Greece
0x001F:"NL",// Netherlands
0x0020:"BE",// Belgium
0x0021:"FR",// France
0x0022:"ES",// Spain
0x0024:"HU",// Hungary
0x0027:"IT",// Italy
0x0029:"CH",// Switzerland
0x002B:"AT",// Austria
0x002C:"GB",// United Kingdom
0x002D:"DK",// Denmark
0x002E:"SE",// Sweden
0x002F:"NO",// Norway
0x0030:"PL",// Poland
0x0031:"DE",// Germany
0x0034:"MX",// Mexico
0x0037:"BR",// Brazil
0x003d:"AU",// Australia
0x0040:"NZ",// New Zealand
0x0042:"TH",// Thailand
0x0051:"JP",// Japan
0x0052:"KR",// Korea
0x0054:"VN",// Viet Nam
0x0056:"CN",// China
0x005A:"TR",// Turkey
0x0069:"JS",// Ramastan
0x00D5:"DZ",// Algeria
0x00D8:"MA",// Morocco
0x00DA:"LY",// Libya
0x015F:"PT",// Portugal
0x0162:"IS",// Iceland
0x0166:"FI",// Finland
0x01A4:"CZ",// Czech Republic
0x0376:"TW",// Taiwan
0x03C1:"LB",// Lebanon
0x03C2:"JO",// Jordan
0x03C3:"SY",// Syria
0x03C4:"IQ",// Iraq
0x03C5:"KW",// Kuwait
0x03C6:"SA",// Saudi Arabia
0x03CB:"AE",// United Arab Emirates
0x03CC:"IL",// Israel
0x03CE:"QA",// Qatar
0x03D5:"IR",// Iran
0xFFFF:"US"// United States
};/* [MS-XLS] 2.5.127 */var XLSFillPattern=[null,'solid','mediumGray','darkGray','lightGray','darkHorizontal','darkVertical','darkDown','darkUp','darkGrid','darkTrellis','lightHorizontal','lightVertical','lightDown','lightUp','lightGrid','lightTrellis','gray125','gray0625'];function rgbify(arr){return arr.map(function(x){return[x>>16&255,x>>8&255,x&255];});}/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */var _XLSIcv=rgbify([/* Color Constants */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,/* Overridable Defaults */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0x800000,0x008000,0x000080,0x808000,0x800080,0x008080,0xC0C0C0,0x808080,0x9999FF,0x993366,0xFFFFCC,0xCCFFFF,0x660066,0xFF8080,0x0066CC,0xCCCCFF,0x000080,0xFF00FF,0xFFFF00,0x00FFFF,0x800080,0x800000,0x008080,0x0000FF,0x00CCFF,0xCCFFFF,0xCCFFCC,0xFFFF99,0x99CCFF,0xFF99CC,0xCC99FF,0xFFCC99,0x3366FF,0x33CCCC,0x99CC00,0xFFCC00,0xFF9900,0xFF6600,0x666699,0x969696,0x003366,0x339966,0x003300,0x333300,0x993300,0x993366,0x333399,0x333333,/* Other entries to appease BIFF8/12 */0xFFFFFF,/* 0x40 icvForeground ?? */0x000000,/* 0x41 icvBackground ?? */0x000000,/* 0x42 icvFrame ?? */0x000000,/* 0x43 icv3D ?? */0x000000,/* 0x44 icv3DText ?? */0x000000,/* 0x45 icv3DHilite ?? */0x000000,/* 0x46 icv3DShadow ?? */0x000000,/* 0x47 icvHilite ?? */0x000000,/* 0x48 icvCtlText ?? */0x000000,/* 0x49 icvCtlScrl ?? */0x000000,/* 0x4A icvCtlInv ?? */0x000000,/* 0x4B icvCtlBody ?? */0x000000,/* 0x4C icvCtlFrame ?? */0x000000,/* 0x4D icvCtlFore ?? */0x000000,/* 0x4E icvCtlBack ?? */0x000000,/* 0x4F icvCtlNeutral */0x000000,/* 0x50 icvInfoBk ?? */0x000000/* 0x51 icvInfoText ?? */]);var XLSIcv=dup(_XLSIcv);/* [MS-XLSB] 2.5.97.2 */var BErr={0x00:"#NULL!",0x07:"#DIV/0!",0x0F:"#VALUE!",0x17:"#REF!",0x1D:"#NAME?",0x24:"#NUM!",0x2A:"#N/A",0x2B:"#GETTING_DATA",0xFF:"#WTF?"};var RBErr=evert_num(BErr);/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */var ct2type/*{[string]:string}*/={/* Workbook */"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks",/* Worksheet */"application/vnd.ms-excel.binIndexWs":"TODO",/* Binary Index */ /* Macrosheet */"application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO",/* Binary Index */ /* File Properties */"application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops",/* Custom Data Properties */"application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO",/* PivotTable */"application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO",/* Chart Objects */"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO",/* Chart Colors */"application/vnd.ms-office.chartcolorstyle+xml":"TODO",/* Chart Style */"application/vnd.ms-office.chartstyle+xml":"TODO",/* Chart Advanced */"application/vnd.ms-office.chartex+xml":"TODO",/* Calculation Chain */"application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains",/* Printer Settings */"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO",/* ActiveX */"application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO",/* Custom Toolbars */"application/vnd.ms-excel.attachedToolbars":"TODO",/* External Data Connections */"application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO",/* External Links */"application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links",/* Metadata */"application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO",/* PivotCache */"application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO",/* Query Table */"application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO",/* Shared Workbook */"application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO",/* Single Cell Table */"application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO",/* Slicer */"application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO",/* Sort Map */"application/vnd.ms-excel.wsSortMap":"TODO",/* Table */"application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO",/* Themes */"application/vnd.openxmlformats-officedocument.theme+xml":"themes",/* Theme Override */"application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO",/* Timeline */"application/vnd.ms-excel.Timeline+xml":"TODO",/* verify */"application/vnd.ms-excel.TimelineCache+xml":"TODO",/* verify */ /* VBA */"application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba",/* Volatile Dependencies */"application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO",/* Control Properties */"application/vnd.ms-excel.controlproperties+xml":"TODO",/* Data Model */"application/vnd.openxmlformats-officedocument.model+data":"TODO",/* Survey */"application/vnd.ms-excel.Survey+xml":"TODO",/* Drawing */"application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO",/* VML */"application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO",/* Image */"image/png":"TODO","sheet":"js"};var CT_LIST=function(){var o={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{/* Shared Strings */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{/* Comments */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{/* Worksheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{/* Chartsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{/* Dialogsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{/* Macrosheet (Excel 4.0 Macros) */xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{/* Styles */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};keys(o).forEach(function(k){["xlsm","xlam"].forEach(function(v){if(!o[k][v])o[k][v]=o[k].xlsx;});});keys(o).forEach(function(k){keys(o[k]).forEach(function(v){ct2type[o[k][v]]=k;});});return o;}();var type2ct/*{[string]:Array<string>}*/=evert_arr(ct2type);XMLNS.CT='http://schemas.openxmlformats.org/package/2006/content-types';function new_ct(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""};}function parse_ct(data){var ct=new_ct();if(!data||!data.match)return ct;var ctext={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0].replace(nsregex,"<")){case'<?xml':break;case'<Types':ct.xmlns=y['xmlns'+(y[0].match(/<(\w+):/)||["",""])[1]];break;case'<Default':ctext[y.Extension]=y.ContentType;break;case'<Override':if(ct[ct2type[y.ContentType]]!==undefined)ct[ct2type[y.ContentType]].push(y.PartName);break;}});if(ct.xmlns!==XMLNS.CT)throw new Error("Unknown Namespace: "+ct.xmlns);ct.calcchain=ct.calcchains.length>0?ct.calcchains[0]:"";ct.sst=ct.strs.length>0?ct.strs[0]:"";ct.style=ct.styles.length>0?ct.styles[0]:"";ct.defaults=ctext;delete ct.calcchains;return ct;}var CTYPE_XML_ROOT=writextag('Types',null,{'xmlns':XMLNS.CT,'xmlns:xsd':XMLNS.xsd,'xmlns:xsi':XMLNS.xsi});var CTYPE_DEFAULTS=[['xml','application/xml'],['bin','application/vnd.ms-excel.sheet.binary.macroEnabled.main'],['vml','application/vnd.openxmlformats-officedocument.vmlDrawing'],['data','application/vnd.openxmlformats-officedocument.model+data'],/* from test files */['bmp','image/bmp'],['png','image/png'],['gif','image/gif'],['emf','image/x-emf'],['wmf','image/x-wmf'],['jpg','image/jpeg'],['jpeg','image/jpeg'],['tif','image/tiff'],['tiff','image/tiff'],['pdf','application/pdf'],['rels',type2ct.rels[0]]].map(function(x){return writextag('Default',null,{'Extension':x[0],'ContentType':x[1]});});function write_ct(ct,opts){var o=[],v;o[o.length]=XML_HEADER;o[o.length]=CTYPE_XML_ROOT;o=o.concat(CTYPE_DEFAULTS);/* only write first instance */var f1=function(w){if(ct[w]&&ct[w].length>0){v=ct[w][0];o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType||'xlsx']});}};/* book type-specific */var f2=function(w){(ct[w]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType||'xlsx']});});};/* standard type */var f3=function(t){(ct[t]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':type2ct[t][0]});});};f1('workbooks');f2('sheets');f2('charts');f3('themes');['strs','styles'].forEach(f1);['coreprops','extprops','custprops'].forEach(f3);f3('vba');f3('comments');f3('drawings');if(o.length>2){o[o.length]='</Types>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 9.3 Relationships */var RELS={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};/* 9.3.3 Representing Relationships */function get_rels_path(file){var n=file.lastIndexOf("/");return file.slice(0,n+1)+'_rels/'+file.slice(n+1)+".rels";}function parse_rels(data,currentFilePath){var rels={"!id":{}};if(!data)return rels;if(currentFilePath.charAt(0)!=='/'){currentFilePath='/'+currentFilePath;}var hash={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);/* 9.3.2.2 OPC_Relationships */if(y[0]==='<Relationship'){var rel={};rel.Type=y.Type;rel.Target=y.Target;rel.Id=y.Id;if(y.TargetMode)rel.TargetMode=y.TargetMode;var canonictarget=y.TargetMode==='External'?y.Target:resolve_path(y.Target,currentFilePath);rels[canonictarget]=rel;hash[y.Id]=rel;}});rels["!id"]=hash;return rels;}XMLNS.RELS='http://schemas.openxmlformats.org/package/2006/relationships';var RELS_ROOT=writextag('Relationships',null,{//'xmlns:ns0': XMLNS.RELS,
'xmlns':XMLNS.RELS});/* TODO */function write_rels(rels){var o=[XML_HEADER,RELS_ROOT];keys(rels['!id']).forEach(function(rid){o[o.length]=writextag('Relationship',null,rels['!id'][rid]);});if(o.length>2){o[o.length]='</Relationships>';o[1]=o[1].replace("/>",">");}return o.join("");}var RELS_EXTERN=[RELS.HLINK,RELS.XPATH,RELS.XMISS];function add_rels(rels,rId,f,type,relobj,targetmode){if(!relobj)relobj={};if(!rels['!id'])rels['!id']={};if(rId<0)for(rId=1;rels['!id']['rId'+rId];++rId){/* empty */}relobj.Id='rId'+rId;relobj.Type=type;relobj.Target=f;if(targetmode)relobj.TargetMode=targetmode;else if(RELS_EXTERN.indexOf(relobj.Type)>-1)relobj.TargetMode="External";if(rels['!id'][relobj.Id])throw new Error("Cannot rewrite rId "+rId);rels['!id'][relobj.Id]=relobj;rels[('/'+relobj.Target).replace("//","/")]=relobj;return rId;}/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */var CT_ODS="application/vnd.oasis.opendocument.spreadsheet";function parse_manifest(d,opts){var str=xlml_normalize(d);var Rn;var FEtag;while(Rn=xlmlregex.exec(str))switch(Rn[3]){case'manifest':break;// 4.2 <manifest:manifest>
case'file-entry':// 4.3 <manifest:file-entry>
FEtag=parsexmltag(Rn[0],false);if(FEtag.path=='/'&&FEtag.type!==CT_ODS)throw new Error("This OpenDocument is not a spreadsheet");break;case'encryption-data':// 4.4 <manifest:encryption-data>
case'algorithm':// 4.5 <manifest:algorithm>
case'start-key-generation':// 4.6 <manifest:start-key-generation>
case'key-derivation':// 4.7 <manifest:key-derivation>
throw new Error("Unsupported ODS Encryption");default:if(opts&&opts.WTF)throw Rn;}}function write_manifest(manifest){var o=[XML_HEADER];o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var i=0;i<manifest.length;++i)o.push('  <manifest:file-entry manifest:full-path="'+manifest[i][0]+'" manifest:media-type="'+manifest[i][1]+'"/>\n');o.push('</manifest:manifest>');return o.join("");}/* Part 3 Section 6 Metadata Manifest File */function write_rdf_type(file,res,tag){return['  <rdf:Description rdf:about="'+file+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(tag||"odf")+'#'+res+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf_has(base,file){return['  <rdf:Description rdf:about="'+base+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+file+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf(rdf){var o=[XML_HEADER];o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var i=0;i!=rdf.length;++i){o.push(write_rdf_type(rdf[i][0],rdf[i][1]));o.push(write_rdf_has("",rdf[i][0]));}o.push(write_rdf_type("","Document","pkg"));o.push('</rdf:RDF>');return o.join("");}/* TODO: pull properties */var write_meta_ods=function(){var payload='<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+'JS '+XLSX.version+'</meta:generator></office:meta></office:document-meta>';return function wmo(){return payload;};}();/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var CORE_PROPS=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate",'date'],["dcterms:modified","ModifiedDate",'date']];XMLNS.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";RELS.CORE_PROPS='http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';var CORE_PROPS_REGEX=function(){var r=new Array(CORE_PROPS.length);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i];var g="(?:"+f[0].slice(0,f[0].indexOf(":"))+":)"+f[0].slice(f[0].indexOf(":")+1);r[i]=new RegExp("<"+g+"[^>]*>([\\s\\S]*?)<\/"+g+">");}return r;}();function parse_core_props(data){var p={};data=utf8read(data);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i],cur=data.match(CORE_PROPS_REGEX[i]);if(cur!=null&&cur.length>0)p[f[1]]=unescapexml(cur[1]);if(f[2]==='date'&&p[f[1]])p[f[1]]=parseDate(p[f[1]]);}return p;}var CORE_PROPS_XML_ROOT=writextag('cp:coreProperties',null,{//'xmlns': XMLNS.CORE_PROPS,
'xmlns:cp':XMLNS.CORE_PROPS,'xmlns:dc':XMLNS.dc,'xmlns:dcterms':XMLNS.dcterms,'xmlns:dcmitype':XMLNS.dcmitype,'xmlns:xsi':XMLNS.xsi});function cp_doit(f,g,h,o,p){if(p[f]!=null||g==null||g==="")return;p[f]=g;g=escapexml(g);o[o.length]=h?writextag(f,g,h):writetag(f,g);}function write_core_props(cp,_opts){var opts=_opts||{};var o=[XML_HEADER,CORE_PROPS_XML_ROOT],p={};if(!cp&&!opts.Props)return o.join("");if(cp){if(cp.CreatedDate!=null)cp_doit("dcterms:created",typeof cp.CreatedDate==="string"?cp.CreatedDate:write_w3cdtf(cp.CreatedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);if(cp.ModifiedDate!=null)cp_doit("dcterms:modified",typeof cp.ModifiedDate==="string"?cp.ModifiedDate:write_w3cdtf(cp.ModifiedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);}for(var i=0;i!=CORE_PROPS.length;++i){var f=CORE_PROPS[i];var v=opts.Props&&opts.Props[f[1]]!=null?opts.Props[f[1]]:cp?cp[f[1]]:null;if(v===true)v="1";else if(v===false)v="0";else if(typeof v=="number")v=String(v);if(v!=null)cp_doit(f[0],v,null,o,p);}if(o.length>2){o[o.length]='</cp:coreProperties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var EXT_PROPS=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];XMLNS.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";RELS.EXT_PROPS='http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';var PseudoPropsPairs=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function load_props_pairs(HP,TOP,props,opts){var v=[];if(typeof HP=="string")v=parseVector(HP,opts);else for(var j=0;j<HP.length;++j)v=v.concat(HP[j].map(function(hp){return{v:hp};}));var parts=typeof TOP=="string"?parseVector(TOP,opts).map(function(x){return x.v;}):TOP;var idx=0,len=0;if(parts.length>0)for(var i=0;i!==v.length;i+=2){len=+v[i+1].v;switch(v[i].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":props.Worksheets=len;props.SheetNames=parts.slice(idx,idx+len);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":props.NamedRanges=len;props.DefinedNames=parts.slice(idx,idx+len);break;case"Charts":case"Diagramme":props.Chartsheets=len;props.ChartNames=parts.slice(idx,idx+len);break;}idx+=len;}}function parse_ext_props(data,p,opts){var q={};if(!p)p={};data=utf8read(data);EXT_PROPS.forEach(function(f){var xml=(data.match(matchtag(f[0]))||[])[1];switch(f[2]){case"string":if(xml)p[f[1]]=unescapexml(xml);break;case"bool":p[f[1]]=xml==="true";break;case"raw":var cur=data.match(new RegExp("<"+f[0]+"[^>]*>([\\s\\S]*?)<\/"+f[0]+">"));if(cur&&cur.length>0)q[f[1]]=cur[1];break;}});if(q.HeadingPairs&&q.TitlesOfParts)load_props_pairs(q.HeadingPairs,q.TitlesOfParts,p,opts);return p;}var EXT_PROPS_XML_ROOT=writextag('Properties',null,{'xmlns':XMLNS.EXT_PROPS,'xmlns:vt':XMLNS.vt});function write_ext_props(cp){var o=[],W=writextag;if(!cp)cp={};cp.Application="SheetJS";o[o.length]=XML_HEADER;o[o.length]=EXT_PROPS_XML_ROOT;EXT_PROPS.forEach(function(f){if(cp[f[1]]===undefined)return;var v;switch(f[2]){case'string':v=escapexml(String(cp[f[1]]));break;case'bool':v=cp[f[1]]?'true':'false';break;}if(v!==undefined)o[o.length]=W(f[0],v);});/* TODO: HeadingPairs, TitlesOfParts */o[o.length]=W('HeadingPairs',W('vt:vector',W('vt:variant','<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant',W('vt:i4',String(cp.Worksheets))),{size:2,baseType:"variant"}));o[o.length]=W('TitlesOfParts',W('vt:vector',cp.SheetNames.map(function(s){return"<vt:lpstr>"+escapexml(s)+"</vt:lpstr>";}).join(""),{size:cp.Worksheets,baseType:"lpstr"}));if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.2 Custom File Properties Part */XMLNS.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";RELS.CUST_PROPS='http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';var custregex=/<[^>]+>[^<]*/g;function parse_cust_props(data,opts){var p={},name="";var m=data.match(custregex);if(m)for(var i=0;i!=m.length;++i){var x=m[i],y=parsexmltag(x);switch(y[0]){case'<?xml':break;case'<Properties':break;case'<property':name=unescapexml(y.name);break;case'</property>':name=null;break;default:if(x.indexOf('<vt:')===0){var toks=x.split('>');var type=toks[0].slice(4),text=toks[1];/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */switch(type){case'lpstr':case'bstr':case'lpwstr':p[name]=unescapexml(text);break;case'bool':p[name]=parsexmlbool(text);break;case'i1':case'i2':case'i4':case'i8':case'int':case'uint':p[name]=parseInt(text,10);break;case'r4':case'r8':case'decimal':p[name]=parseFloat(text);break;case'filetime':case'date':p[name]=parseDate(text);break;case'cy':case'error':p[name]=unescapexml(text);break;default:if(type.slice(-1)=='/')break;if(opts.WTF&&typeof console!=='undefined')console.warn('Unexpected',x,type,toks);}}else if(x.slice(0,2)==="</"){/* empty */}else if(opts.WTF)throw new Error(x);}}return p;}var CUST_PROPS_XML_ROOT=writextag('Properties',null,{'xmlns':XMLNS.CUST_PROPS,'xmlns:vt':XMLNS.vt});function write_cust_props(cp){var o=[XML_HEADER,CUST_PROPS_XML_ROOT];if(!cp)return o.join("");var pid=1;keys(cp).forEach(function custprop(k){++pid;o[o.length]=writextag('property',write_vt(cp[k],true),{'fmtid':'{D5CDD505-2E9C-101B-9397-08002B2CF9AE}','pid':pid,'name':escapexml(k)});});if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* Common Name -> XLML Name */var XLMLDocPropsMap={Title:'Title',Subject:'Subject',Author:'Author',Keywords:'Keywords',Comments:'Description',LastAuthor:'LastAuthor',RevNumber:'Revision',Application:'AppName',/* TotalTime: 'TotalTime', */LastPrinted:'LastPrinted',CreatedDate:'Created',ModifiedDate:'LastSaved',/* Pages */ /* Words */ /* Characters */Category:'Category',/* PresentationFormat */Manager:'Manager',Company:'Company',/* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */AppVersion:'Version',ContentStatus:'ContentStatus',/* NOTE: missing from schema */Identifier:'Identifier',/* NOTE: missing from schema */Language:'Language'/* NOTE: missing from schema */};var evert_XLMLDPM=evert(XLMLDocPropsMap);function xlml_set_prop(Props,tag,val){tag=evert_XLMLDPM[tag]||tag;Props[tag]=val;}function xlml_write_docprops(Props,opts){var o=[];keys(XLMLDocPropsMap).map(function(m){for(var i=0;i<CORE_PROPS.length;++i)if(CORE_PROPS[i][1]==m)return CORE_PROPS[i];for(i=0;i<EXT_PROPS.length;++i)if(EXT_PROPS[i][1]==m)return EXT_PROPS[i];throw m;}).forEach(function(p){if(Props[p[1]]==null)return;var m=opts&&opts.Props&&opts.Props[p[1]]!=null?opts.Props[p[1]]:Props[p[1]];switch(p[2]){case'date':m=new Date(m).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof m=='number')m=String(m);else if(m===true||m===false){m=m?"1":"0";}else if(m instanceof Date)m=new Date(m).toISOString().replace(/\.\d*Z/,"");o.push(writetag(XLMLDocPropsMap[p[1]]||p[1],m));});return writextag('DocumentProperties',o.join(""),{xmlns:XLMLNS.o});}function xlml_write_custprops(Props,Custprops){var BLACKLIST=["Worksheets","SheetNames"];var T='CustomDocumentProperties';var o=[];if(Props)keys(Props).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Props,k))return;for(var i=0;i<CORE_PROPS.length;++i)if(k==CORE_PROPS[i][1])return;for(i=0;i<EXT_PROPS.length;++i)if(k==EXT_PROPS[i][1])return;for(i=0;i<BLACKLIST.length;++i)if(k==BLACKLIST[i])return;var m=Props[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});if(Custprops)keys(Custprops).forEach(function(k){if(!Object.prototype.hasOwnProperty.call(Custprops,k))return;if(Props&&Object.prototype.hasOwnProperty.call(Props,k))return;var m=Custprops[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else if(m instanceof Date){t="dateTime.tz";m=m.toISOString();}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});return'<'+T+' xmlns="'+XLMLNS.o+'">'+o.join("")+'</'+T+'>';}/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */function parse_FILETIME(blob){var dwLowDateTime=blob.read_shift(4),dwHighDateTime=blob.read_shift(4);return new Date((dwHighDateTime/1e7*Math.pow(2,32)+dwLowDateTime/1e7-11644473600)*1000).toISOString().replace(/\.000/,"");}function write_FILETIME(time){var date=typeof time=="string"?new Date(Date.parse(time)):time;var t=date.getTime()/1000+11644473600;var l=t%Math.pow(2,32),h=(t-l)/Math.pow(2,32);l*=1e7;h*=1e7;var w=l/Math.pow(2,32)|0;if(w>0){l=l%Math.pow(2,32);h+=w;}var o=new_buf(8);o.write_shift(4,l);o.write_shift(4,h);return o;}/* [MS-OSHARED] 2.3.3.1.4 Lpstr */function parse_lpstr(blob,type,pad){var start=blob.l;var str=blob.read_shift(0,'lpstr-cp');if(pad)while(blob.l-start&3)++blob.l;return str;}/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */function parse_lpwstr(blob,type,pad){var str=blob.read_shift(0,'lpwstr');if(pad)blob.l+=4-(str.length+1&3)&3;return str;}/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */function parse_VtStringBase(blob,stringType,pad){if(stringType===0x1F/*VT_LPWSTR*/)return parse_lpwstr(blob);return parse_lpstr(blob,stringType,pad);}function parse_VtString(blob,t,pad){return parse_VtStringBase(blob,t,pad===false?0:4);}function parse_VtUnalignedString(blob,t){if(!t)throw new Error("VtUnalignedString must have positive length");return parse_VtStringBase(blob,t,0);}/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */function parse_VtVecLpwstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i){var start=blob.l;ret[i]=blob.read_shift(0,'lpwstr').replace(chr0,'');if(blob.l-start&0x02)blob.l+=2;}return ret;}/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */function parse_VtVecUnalignedLpstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i)ret[i]=blob.read_shift(0,'lpstr-cp').replace(chr0,'');return ret;}/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */function parse_VtHeadingPair(blob){var start=blob.l;var headingString=parse_TypedPropertyValue(blob,VT_USTR);if(blob[blob.l]==0x00&&blob[blob.l+1]==0x00&&blob.l-start&0x02)blob.l+=2;var headerParts=parse_TypedPropertyValue(blob,VT_I4);return[headingString,headerParts];}/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */function parse_VtVecHeadingPairValue(blob){var cElements=blob.read_shift(4);var out=[];for(var i=0;i<cElements/2;++i)out.push(parse_VtHeadingPair(blob));return out;}/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */function parse_dictionary(blob,CodePage){var cnt=blob.read_shift(4);var dict={};for(var j=0;j!=cnt;++j){var pid=blob.read_shift(4);var len=blob.read_shift(4);dict[pid]=blob.read_shift(len,CodePage===0x4B0?'utf16le':'utf8').replace(chr0,'').replace(chr1,'!');if(CodePage===0x4B0&&len%2)blob.l+=2;}if(blob.l&3)blob.l=blob.l>>2+1<<2;return dict;}/* [MS-OLEPS] 2.9 BLOB */function parse_BLOB(blob){var size=blob.read_shift(4);var bytes=blob.slice(blob.l,blob.l+size);blob.l+=size;if((size&3)>0)blob.l+=4-(size&3)&3;return bytes;}/* [MS-OLEPS] 2.11 ClipboardData */function parse_ClipboardData(blob){// TODO
var o={};o.Size=blob.read_shift(4);//o.Format = blob.read_shift(4);
blob.l+=o.Size+3-(o.Size-1)%4;return o;}/* [MS-OLEPS] 2.15 TypedPropertyValue */function parse_TypedPropertyValue(blob,type,_opts){var t=blob.read_shift(2),ret,opts=_opts||{};blob.l+=2;if(type!==VT_VARIANT)if(t!==type&&VT_CUSTOM.indexOf(type)===-1&&!((type&0xFFFE)==0x101E&&(t&0xFFFE)==0x101E))throw new Error('Expected type '+type+' saw '+t);switch(type===VT_VARIANT?t:type){case 0x02/*VT_I2*/:ret=blob.read_shift(2,'i');if(!opts.raw)blob.l+=2;return ret;case 0x03/*VT_I4*/:ret=blob.read_shift(4,'i');return ret;case 0x0B/*VT_BOOL*/:return blob.read_shift(4)!==0x0;case 0x13/*VT_UI4*/:ret=blob.read_shift(4);return ret;case 0x1E/*VT_LPSTR*/:return parse_lpstr(blob,t,4).replace(chr0,'');case 0x1F/*VT_LPWSTR*/:return parse_lpwstr(blob);case 0x40/*VT_FILETIME*/:return parse_FILETIME(blob);case 0x41/*VT_BLOB*/:return parse_BLOB(blob);case 0x47/*VT_CF*/:return parse_ClipboardData(blob);case 0x50/*VT_STRING*/:return parse_VtString(blob,t,!opts.raw).replace(chr0,'');case 0x51/*VT_USTR*/:return parse_VtUnalignedString(blob,t/*, 4*/).replace(chr0,'');case 0x100C/*VT_VECTOR|VT_VARIANT*/:return parse_VtVecHeadingPairValue(blob);case 0x101E/*VT_VECTOR|VT_LPSTR*/:case 0x101F/*VT_VECTOR|VT_LPWSTR*/:return t==0x101F?parse_VtVecLpwstrValue(blob):parse_VtVecUnalignedLpstrValue(blob);default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+t);}}function write_TypedPropertyValue(type,value){var o=new_buf(4),p=new_buf(4);o.write_shift(4,type==0x50?0x1F:type);switch(type){case 0x03/*VT_I4*/:p.write_shift(-4,value);break;case 0x05/*VT_I4*/:p=new_buf(8);p.write_shift(8,value,'f');break;case 0x0B/*VT_BOOL*/:p.write_shift(4,value?0x01:0x00);break;case 0x40/*VT_FILETIME*/:p=write_FILETIME(value);break;case 0x1F/*VT_LPWSTR*/:case 0x50/*VT_STRING*/:p=new_buf(4+2*(value.length+1)+(value.length%2?0:2));p.write_shift(4,value.length+1);p.write_shift(0,value,"dbcs");while(p.l!=p.length)p.write_shift(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+value);}return bconcat([o,p]);}/* [MS-OLEPS] 2.20 PropertySet */function parse_PropertySet(blob,PIDSI){var start_addr=blob.l;var size=blob.read_shift(4);var NumProps=blob.read_shift(4);var Props=[],i=0;var CodePage=0;var Dictionary=-1,DictObj={};for(i=0;i!=NumProps;++i){var PropID=blob.read_shift(4);var Offset=blob.read_shift(4);Props[i]=[PropID,Offset+start_addr];}Props.sort(function(x,y){return x[1]-y[1];});var PropH={};for(i=0;i!=NumProps;++i){if(blob.l!==Props[i][1]){var fail=true;if(i>0&&PIDSI)switch(PIDSI[Props[i-1][0]].t){case 0x02/*VT_I2*/:if(blob.l+2===Props[i][1]){blob.l+=2;fail=false;}break;case 0x50/*VT_STRING*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;case 0x100C/*VT_VECTOR|VT_VARIANT*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;}if((!PIDSI||i==0)&&blob.l<=Props[i][1]){fail=false;blob.l=Props[i][1];}if(fail)throw new Error("Read Error: Expected address "+Props[i][1]+' at '+blob.l+' :'+i);}if(PIDSI){var piddsi=PIDSI[Props[i][0]];PropH[piddsi.n]=parse_TypedPropertyValue(blob,piddsi.t,{raw:true});if(piddsi.p==='version')PropH[piddsi.n]=String(PropH[piddsi.n]>>16)+"."+("0000"+String(PropH[piddsi.n]&0xFFFF)).slice(-4);if(piddsi.n=="CodePage")switch(PropH[piddsi.n]){case 0:PropH[piddsi.n]=1252;/* falls through */case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 10000:case 1200:case 1201:case 1252:case 65000:case-536:case 65001:case-535:set_cp(CodePage=PropH[piddsi.n]>>>0&0xFFFF);break;default:throw new Error("Unsupported CodePage: "+PropH[piddsi.n]);}}else{if(Props[i][0]===0x1){CodePage=PropH.CodePage=parse_TypedPropertyValue(blob,VT_I2);set_cp(CodePage);if(Dictionary!==-1){var oldpos=blob.l;blob.l=Props[Dictionary][1];DictObj=parse_dictionary(blob,CodePage);blob.l=oldpos;}}else if(Props[i][0]===0){if(CodePage===0){Dictionary=i;blob.l=Props[i+1][1];continue;}DictObj=parse_dictionary(blob,CodePage);}else{var name=DictObj[Props[i][0]];var val;/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */switch(blob[blob.l]){case 0x41/*VT_BLOB*/:blob.l+=4;val=parse_BLOB(blob);break;case 0x1E/*VT_LPSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x1F/*VT_LPWSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x03/*VT_I4*/:blob.l+=4;val=blob.read_shift(4,'i');break;case 0x13/*VT_UI4*/:blob.l+=4;val=blob.read_shift(4);break;case 0x05/*VT_R8*/:blob.l+=4;val=blob.read_shift(8,'f');break;case 0x0B/*VT_BOOL*/:blob.l+=4;val=parsebool(blob,4);break;case 0x40/*VT_FILETIME*/:blob.l+=4;val=parseDate(parse_FILETIME(blob));break;default:throw new Error("unparsed value: "+blob[blob.l]);}PropH[name]=val;}}}blob.l=start_addr+size;/* step ahead to skip padding */return PropH;}var XLSPSSkip=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"].concat(PseudoPropsPairs);function guess_property_type(val){switch(typeof val){case"boolean":return 0x0B;case"number":return(val|0)==val?0x03:0x05;case"string":return 0x1F;case"object":if(val instanceof Date)return 0x40;break;}return-1;}function write_PropertySet(entries,RE,PIDSI){var hdr=new_buf(8),piao=[],prop=[];var sz=8,i=0;var pr=new_buf(8),pio=new_buf(8);pr.write_shift(4,0x0002);pr.write_shift(4,0x04B0);pio.write_shift(4,0x0001);prop.push(pr);piao.push(pio);sz+=8+pr.length;if(!RE){pio=new_buf(8);pio.write_shift(4,0);piao.unshift(pio);var bufs=[new_buf(4)];bufs[0].write_shift(4,entries.length);for(i=0;i<entries.length;++i){var value=entries[i][0];pr=new_buf(4+4+2*(value.length+1)+(value.length%2?0:2));pr.write_shift(4,i+2);pr.write_shift(4,value.length+1);pr.write_shift(0,value,"dbcs");while(pr.l!=pr.length)pr.write_shift(1,0);bufs.push(pr);}pr=bconcat(bufs);prop.unshift(pr);sz+=8+pr.length;}for(i=0;i<entries.length;++i){if(RE&&!RE[entries[i][0]])continue;if(XLSPSSkip.indexOf(entries[i][0])>-1)continue;if(entries[i][1]==null)continue;var val=entries[i][1],idx=0;if(RE){idx=+RE[entries[i][0]];var pinfo=PIDSI[idx];if(pinfo.p=="version"&&typeof val=="string"){var arr=val.split(".");val=(+arr[0]<<16)+(+arr[1]||0);}pr=write_TypedPropertyValue(pinfo.t,val);}else{var T=guess_property_type(val);if(T==-1){T=0x1F;val=String(val);}pr=write_TypedPropertyValue(T,val);}prop.push(pr);pio=new_buf(8);pio.write_shift(4,!RE?2+i:idx);piao.push(pio);sz+=8+pr.length;}var w=8*(prop.length+1);for(i=0;i<prop.length;++i){piao[i].write_shift(4,w);w+=prop[i].length;}hdr.write_shift(4,sz);hdr.write_shift(4,prop.length);return bconcat([hdr].concat(piao).concat(prop));}/* [MS-OLEPS] 2.21 PropertySetStream */function parse_PropertySetStream(file,PIDSI,clsid){var blob=file.content;if(!blob)return{};prep_blob(blob,0);var NumSets,FMTID0,FMTID1,Offset0,Offset1=0;blob.chk('feff','Byte Order: ');/*var vers = */blob.read_shift(2);// TODO: check version
var SystemIdentifier=blob.read_shift(4);var CLSID=blob.read_shift(16);if(CLSID!==CFB.utils.consts.HEADER_CLSID&&CLSID!==clsid)throw new Error("Bad PropertySet CLSID "+CLSID);NumSets=blob.read_shift(4);if(NumSets!==1&&NumSets!==2)throw new Error("Unrecognized #Sets: "+NumSets);FMTID0=blob.read_shift(16);Offset0=blob.read_shift(4);if(NumSets===1&&Offset0!==blob.l)throw new Error("Length mismatch: "+Offset0+" !== "+blob.l);else if(NumSets===2){FMTID1=blob.read_shift(16);Offset1=blob.read_shift(4);}var PSet0=parse_PropertySet(blob,PIDSI);var rval={SystemIdentifier:SystemIdentifier};for(var y in PSet0)rval[y]=PSet0[y];//rval.blob = blob;
rval.FMTID=FMTID0;//rval.PSet0 = PSet0;
if(NumSets===1)return rval;if(Offset1-blob.l==2)blob.l+=2;if(blob.l!==Offset1)throw new Error("Length mismatch 2: "+blob.l+" !== "+Offset1);var PSet1;try{PSet1=parse_PropertySet(blob,null);}catch(e){/* empty */}for(y in PSet1)rval[y]=PSet1[y];rval.FMTID=[FMTID0,FMTID1];// TODO: verify FMTID0/1
return rval;}function write_PropertySetStream(entries,clsid,RE,PIDSI,entries2,clsid2){var hdr=new_buf(entries2?68:48);var bufs=[hdr];hdr.write_shift(2,0xFFFE);hdr.write_shift(2,0x0000);/* TODO: type 1 props */hdr.write_shift(4,0x32363237);hdr.write_shift(16,CFB.utils.consts.HEADER_CLSID,"hex");hdr.write_shift(4,entries2?2:1);hdr.write_shift(16,clsid,"hex");hdr.write_shift(4,entries2?68:48);var ps0=write_PropertySet(entries,RE,PIDSI);bufs.push(ps0);if(entries2){var ps1=write_PropertySet(entries2,null,null);hdr.write_shift(16,clsid2,"hex");hdr.write_shift(4,68+ps0.length);bufs.push(ps1);}return bconcat(bufs);}function parsenoop2(blob,length){blob.read_shift(length);return null;}function writezeroes(n,o){if(!o)o=new_buf(n);for(var j=0;j<n;++j)o.write_shift(1,0);return o;}function parslurp(blob,length,cb){var arr=[],target=blob.l+length;while(blob.l<target)arr.push(cb(blob,target-blob.l));if(target!==blob.l)throw new Error("Slurp error");return arr;}function parsebool(blob,length){return blob.read_shift(length)===0x1;}function writebool(v,o){if(!o)o=new_buf(2);o.write_shift(2,+!!v);return o;}function parseuint16(blob){return blob.read_shift(2,'u');}function writeuint16(v,o){if(!o)o=new_buf(2);o.write_shift(2,v);return o;}function parseuint16a(blob,length){return parslurp(blob,length,parseuint16);}/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */function parse_Bes(blob){var v=blob.read_shift(1),t=blob.read_shift(1);return t===0x01?v:v===0x01;}function write_Bes(v,t,o){if(!o)o=new_buf(2);o.write_shift(1,t=='e'?+v:+!!v);o.write_shift(1,t=='e'?1:0);return o;}/* [MS-XLS] 2.5.240 ShortXLUnicodeString */function parse_ShortXLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff>=12?2:1);var encoding='sbcs-cont';var cp=current_codepage;if(opts&&opts.biff>=8)current_codepage=1200;if(!opts||opts.biff==8){var fHighByte=blob.read_shift(1);if(fHighByte){encoding='dbcs-cont';}}else if(opts.biff==12){encoding='wstr';}if(opts.biff>=2&&opts.biff<=5)encoding='cpstr';var o=cch?blob.read_shift(cch,encoding):"";current_codepage=cp;return o;}/* 2.5.293 XLUnicodeRichExtendedString */function parse_XLUnicodeRichExtendedString(blob){var cp=current_codepage;current_codepage=1200;var cch=blob.read_shift(2),flags=blob.read_shift(1);var/*fHighByte = flags & 0x1,*/fExtSt=flags&0x4,fRichSt=flags&0x8;var width=1+(flags&0x1);// 0x0 -> utf8, 0x1 -> dbcs
var cRun=0,cbExtRst;var z={};if(fRichSt)cRun=blob.read_shift(2);if(fExtSt)cbExtRst=blob.read_shift(4);var encoding=width==2?'dbcs-cont':'sbcs-cont';var msg=cch===0?"":blob.read_shift(cch,encoding);if(fRichSt)blob.l+=4*cRun;//TODO: parse this
if(fExtSt)blob.l+=cbExtRst;//TODO: parse this
z.t=msg;if(!fRichSt){z.raw="<t>"+z.t+"</t>";z.r=z.t;}current_codepage=cp;return z;}function write_XLUnicodeRichExtendedString(xlstr){var str=xlstr.t||"",nfmts=1;var hdr=new_buf(3+(nfmts>1?2:0));hdr.write_shift(2,str.length);hdr.write_shift(1,(nfmts>1?0x08:0x00)|0x01);if(nfmts>1)hdr.write_shift(2,nfmts);var otext=new_buf(2*str.length);otext.write_shift(2*str.length,str,'utf16le');var out=[hdr,otext];return bconcat(out);}/* 2.5.296 XLUnicodeStringNoCch */function parse_XLUnicodeStringNoCch(blob,cch,opts){var retval;if(opts){if(opts.biff>=2&&opts.biff<=5)return blob.read_shift(cch,'cpstr');if(opts.biff>=12)return blob.read_shift(cch,'dbcs-cont');}var fHighByte=blob.read_shift(1);if(fHighByte===0){retval=blob.read_shift(cch,'sbcs-cont');}else{retval=blob.read_shift(cch,'dbcs-cont');}return retval;}/* 2.5.294 XLUnicodeString */function parse_XLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff==2?1:2);if(cch===0){blob.l++;return"";}return parse_XLUnicodeStringNoCch(blob,cch,opts);}/* BIFF5 override */function parse_XLUnicodeString2(blob,length,opts){if(opts.biff>5)return parse_XLUnicodeString(blob,length,opts);var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,opts.biff<=4||!blob.lens?'cpstr':'sbcs-cont');}/* TODO: BIFF5 and lower, codepage awareness */function write_XLUnicodeString(str,opts,o){if(!o)o=new_buf(3+2*str.length);o.write_shift(2,str.length);o.write_shift(1,1);o.write_shift(31,str,'utf16le');return o;}/* [MS-XLS] 2.5.61 ControlInfo */function parse_ControlInfo(blob){var flags=blob.read_shift(1);blob.l++;var accel=blob.read_shift(2);blob.l+=2;return[flags,accel];}/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */function parse_URLMoniker(blob){var len=blob.read_shift(4),start=blob.l;var extra=false;if(len>24){/* look ahead */blob.l+=len-24;if(blob.read_shift(16)==="795881f43b1d7f48af2c825dc4852763")extra=true;blob.l=start;}var url=blob.read_shift((extra?len-24:len)>>1,'utf16le').replace(chr0,"");if(extra)blob.l+=24;return url;}/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */function parse_FileMoniker(blob){var cAnti=blob.read_shift(2);var preamble="";while(cAnti-->0)preamble+="../";var ansiPath=blob.read_shift(0,'lpstr-ansi');blob.l+=2;//var endServer = blob.read_shift(2);
if(blob.read_shift(2)!=0xDEAD)throw new Error("Bad FileMoniker");var sz=blob.read_shift(4);if(sz===0)return preamble+ansiPath.replace(/\\/g,"/");var bytes=blob.read_shift(4);if(blob.read_shift(2)!=3)throw new Error("Bad FileMoniker");var unicodePath=blob.read_shift(bytes>>1,'utf16le').replace(chr0,"");return preamble+unicodePath;}/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */function parse_HyperlinkMoniker(blob,length){var clsid=blob.read_shift(16);length-=16;switch(clsid){case"e0c9ea79f9bace118c8200aa004ba90b":return parse_URLMoniker(blob,length);case"0303000000000000c000000000000046":return parse_FileMoniker(blob,length);default:throw new Error("Unsupported Moniker "+clsid);}}/* [MS-OSHARED] 2.3.7.9 HyperlinkString */function parse_HyperlinkString(blob){var len=blob.read_shift(4);var o=len>0?blob.read_shift(len,'utf16le').replace(chr0,""):"";return o;}function write_HyperlinkString(str,o){if(!o)o=new_buf(6+str.length*2);o.write_shift(4,1+str.length);for(var i=0;i<str.length;++i)o.write_shift(2,str.charCodeAt(i));o.write_shift(2,0);return o;}/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */function parse_Hyperlink(blob,length){var end=blob.l+length;var sVer=blob.read_shift(4);if(sVer!==2)throw new Error("Unrecognized streamVersion: "+sVer);var flags=blob.read_shift(2);blob.l+=2;var displayName,targetFrameName,moniker,oleMoniker,Loc="",guid,fileTime;if(flags&0x0010)displayName=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0080)targetFrameName=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0101)moniker=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0001)oleMoniker=parse_HyperlinkMoniker(blob,end-blob.l);if(flags&0x0008)Loc=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0020)guid=blob.read_shift(16);if(flags&0x0040)fileTime=parse_FILETIME(blob/*, 8*/);blob.l=end;var target=targetFrameName||moniker||oleMoniker||"";if(target&&Loc)target+="#"+Loc;if(!target)target="#"+Loc;if(flags&0x0002&&target.charAt(0)=="/"&&target.charAt(1)!="/")target="file://"+target;var out={Target:target};if(guid)out.guid=guid;if(fileTime)out.time=fileTime;if(displayName)out.Tooltip=displayName;return out;}function write_Hyperlink(hl){var out=new_buf(512),i=0;var Target=hl.Target;if(Target.slice(0,7)=="file://")Target=Target.slice(7);var hashidx=Target.indexOf("#");var F=hashidx>-1?0x1f:0x17;switch(Target.charAt(0)){case"#":F=0x1c;break;case".":F&=~2;break;}out.write_shift(4,2);out.write_shift(4,F);var data=[8,6815827,6619237,4849780,83];for(i=0;i<data.length;++i)out.write_shift(4,data[i]);if(F==0x1C){Target=Target.slice(1);write_HyperlinkString(Target,out);}else if(F&0x02){data="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(i=0;i<data.length;++i)out.write_shift(1,parseInt(data[i],16));var Pretarget=hashidx>-1?Target.slice(0,hashidx):Target;out.write_shift(4,2*(Pretarget.length+1));for(i=0;i<Pretarget.length;++i)out.write_shift(2,Pretarget.charCodeAt(i));out.write_shift(2,0);if(F&0x08)write_HyperlinkString(hashidx>-1?Target.slice(hashidx+1):"",out);}else{data="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(i=0;i<data.length;++i)out.write_shift(1,parseInt(data[i],16));var P=0;while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\")++P;out.write_shift(2,P);out.write_shift(4,Target.length-3*P+1);for(i=0;i<Target.length-3*P;++i)out.write_shift(1,Target.charCodeAt(i+3*P)&0xFF);out.write_shift(1,0);out.write_shift(2,0xFFFF);out.write_shift(2,0xDEAD);for(i=0;i<6;++i)out.write_shift(4,0);}return out.slice(0,out.l);}/* 2.5.178 LongRGBA */function parse_LongRGBA(blob){var r=blob.read_shift(1),g=blob.read_shift(1),b=blob.read_shift(1),a=blob.read_shift(1);return[r,g,b,a];}/* 2.5.177 LongRGB */function parse_LongRGB(blob,length){var x=parse_LongRGBA(blob,length);x[3]=0;return x;}/* [MS-XLS] 2.5.19 */function parse_XLSCell(blob){var rw=blob.read_shift(2);// 0-indexed
var col=blob.read_shift(2);var ixfe=blob.read_shift(2);return{r:rw,c:col,ixfe:ixfe};}function write_XLSCell(R,C,ixfe,o){if(!o)o=new_buf(6);o.write_shift(2,R);o.write_shift(2,C);o.write_shift(2,ixfe||0);return o;}/* [MS-XLS] 2.5.134 */function parse_frtHeader(blob){var rt=blob.read_shift(2);var flags=blob.read_shift(2);// TODO: parse these flags
blob.l+=8;return{type:rt,flags:flags};}function parse_OptXLUnicodeString(blob,length,opts){return length===0?"":parse_XLUnicodeString2(blob,length,opts);}/* [MS-XLS] 2.5.344 */function parse_XTI(blob,length,opts){var w=opts.biff>8?4:2;var iSupBook=blob.read_shift(w),itabFirst=blob.read_shift(w,'i'),itabLast=blob.read_shift(w,'i');return[iSupBook,itabFirst,itabLast];}/* [MS-XLS] 2.5.218 */function parse_RkRec(blob){var ixfe=blob.read_shift(2);var RK=parse_RkNumber(blob);return[ixfe,RK];}/* [MS-XLS] 2.5.1 */function parse_AddinUdf(blob,length,opts){blob.l+=4;length-=4;var l=blob.l+length;var udfName=parse_ShortXLUnicodeString(blob,length,opts);var cb=blob.read_shift(2);l-=blob.l;if(cb!==l)throw new Error("Malformed AddinUdf: padding = "+l+" != "+cb);blob.l+=cb;return udfName;}/* [MS-XLS] 2.5.209 TODO: Check sizes */function parse_Ref8U(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(2);var colLast=blob.read_shift(2);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}function write_Ref8U(r,o){if(!o)o=new_buf(8);o.write_shift(2,r.s.r);o.write_shift(2,r.e.r);o.write_shift(2,r.s.c);o.write_shift(2,r.e.c);return o;}/* [MS-XLS] 2.5.211 */function parse_RefU(blob){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(1);var colLast=blob.read_shift(1);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}/* [MS-XLS] 2.5.207 */var parse_Ref=parse_RefU;/* [MS-XLS] 2.5.143 */function parse_FtCmo(blob){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=12;return[id,ot,flags];}/* [MS-XLS] 2.5.149 */function parse_FtNts(blob){var out={};blob.l+=4;blob.l+=16;// GUID TODO
out.fSharedNote=blob.read_shift(2);blob.l+=4;return out;}/* [MS-XLS] 2.5.142 */function parse_FtCf(blob){var out={};blob.l+=4;blob.cf=blob.read_shift(2);return out;}/* [MS-XLS] 2.5.140 - 2.5.154 and friends */function parse_FtSkip(blob){blob.l+=2;blob.l+=blob.read_shift(2);}var FtTab={0x00:parse_FtSkip,/* FtEnd */0x04:parse_FtSkip,/* FtMacro */0x05:parse_FtSkip,/* FtButton */0x06:parse_FtSkip,/* FtGmo */0x07:parse_FtCf,/* FtCf */0x08:parse_FtSkip,/* FtPioGrbit */0x09:parse_FtSkip,/* FtPictFmla */0x0A:parse_FtSkip,/* FtCbls */0x0B:parse_FtSkip,/* FtRbo */0x0C:parse_FtSkip,/* FtSbs */0x0D:parse_FtNts,/* FtNts */0x0E:parse_FtSkip,/* FtSbsFmla */0x0F:parse_FtSkip,/* FtGboData */0x10:parse_FtSkip,/* FtEdoData */0x11:parse_FtSkip,/* FtRboData */0x12:parse_FtSkip,/* FtCblsData */0x13:parse_FtSkip,/* FtLbsData */0x14:parse_FtSkip,/* FtCblsFmla */0x15:parse_FtCmo};function parse_FtArray(blob,length){var tgt=blob.l+length;var fts=[];while(blob.l<tgt){var ft=blob.read_shift(2);blob.l-=2;try{fts.push(FtTab[ft](blob,tgt-blob.l));}catch(e){blob.l=tgt;return fts;}}if(blob.l!=tgt)blob.l=tgt;//throw new Error("bad Object Ft-sequence");
return fts;}/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */function parse_BOF(blob,length){var o={BIFFVer:0,dt:0};o.BIFFVer=blob.read_shift(2);length-=2;if(length>=2){o.dt=blob.read_shift(2);blob.l-=2;}switch(o.BIFFVer){case 0x0600:/* BIFF8 */case 0x0500:/* BIFF5 */case 0x0400:/* BIFF4 */case 0x0300:/* BIFF3 */case 0x0200:/* BIFF2 */case 0x0002:case 0x0007:/* BIFF2 */break;default:if(length>6)throw new Error("Unexpected BIFF Ver "+o.BIFFVer);}blob.read_shift(length);return o;}function write_BOF(wb,t,o){var h=0x0600,w=16;switch(o.bookType){case'biff8':break;case'biff5':h=0x0500;w=8;break;case'biff4':h=0x0004;w=6;break;case'biff3':h=0x0003;w=6;break;case'biff2':h=0x0002;w=4;break;case'xla':break;default:throw new Error("unsupported BIFF version");}var out=new_buf(w);out.write_shift(2,h);out.write_shift(2,t);if(w>4)out.write_shift(2,0x7262);if(w>6)out.write_shift(2,0x07CD);if(w>8){out.write_shift(2,0xC009);out.write_shift(2,0x0001);out.write_shift(2,0x0706);out.write_shift(2,0x0000);}return out;}/* [MS-XLS] 2.4.146 */function parse_InterfaceHdr(blob,length){if(length===0)return 0x04b0;if(blob.read_shift(2)!==0x04b0){/* empty */}return 0x04b0;}/* [MS-XLS] 2.4.349 */function parse_WriteAccess(blob,length,opts){if(opts.enc){blob.l+=length;return"";}var l=blob.l;// TODO: make sure XLUnicodeString doesnt overrun
var UserName=parse_XLUnicodeString2(blob,0,opts);blob.read_shift(length+l-blob.l);return UserName;}function write_WriteAccess(s,opts){var b8=!opts||opts.biff==8;var o=new_buf(b8?112:54);o.write_shift(opts.biff==8?2:1,7);if(b8)o.write_shift(1,0);o.write_shift(4,0x33336853);o.write_shift(4,0x00534A74|(b8?0:0x20000000));while(o.l<o.length)o.write_shift(1,b8?0:32);return o;}/* [MS-XLS] 2.4.351 */function parse_WsBool(blob,length,opts){var flags=opts&&opts.biff==8||length==2?blob.read_shift(2):(blob.l+=length,0);return{fDialog:flags&0x10,fBelow:flags&0x40,fRight:flags&0x80};}/* [MS-XLS] 2.4.28 */function parse_BoundSheet8(blob,length,opts){var pos=blob.read_shift(4);var hidden=blob.read_shift(1)&0x03;var dt=blob.read_shift(1);switch(dt){case 0:dt='Worksheet';break;case 1:dt='Macrosheet';break;case 2:dt='Chartsheet';break;case 6:dt='VBAModule';break;}var name=parse_ShortXLUnicodeString(blob,0,opts);if(name.length===0)name="Sheet1";return{pos:pos,hs:hidden,dt:dt,name:name};}function write_BoundSheet8(data,opts){var w=!opts||opts.biff>=8?2:1;var o=new_buf(8+w*data.name.length);o.write_shift(4,data.pos);o.write_shift(1,data.hs||0);o.write_shift(1,data.dt);o.write_shift(1,data.name.length);if(opts.biff>=8)o.write_shift(1,1);o.write_shift(w*data.name.length,data.name,opts.biff<8?'sbcs':'utf16le');var out=o.slice(0,o.l);out.l=o.l;return out;}/* [MS-XLS] 2.4.265 TODO */function parse_SST(blob,length){var end=blob.l+length;var cnt=blob.read_shift(4);var ucnt=blob.read_shift(4);var strs=[];for(var i=0;i!=ucnt&&blob.l<end;++i){strs.push(parse_XLUnicodeRichExtendedString(blob));}strs.Count=cnt;strs.Unique=ucnt;return strs;}function write_SST(sst,opts){var header=new_buf(8);header.write_shift(4,sst.Count);header.write_shift(4,sst.Unique);var strs=[];for(var j=0;j<sst.length;++j)strs[j]=write_XLUnicodeRichExtendedString(sst[j],opts);var o=bconcat([header].concat(strs));o.parts=[header.length].concat(strs.map(function(str){return str.length;}));return o;}/* [MS-XLS] 2.4.107 */function parse_ExtSST(blob,length){var extsst={};extsst.dsst=blob.read_shift(2);blob.l+=length-2;return extsst;}/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */function parse_Row(blob){var z={};z.r=blob.read_shift(2);z.c=blob.read_shift(2);z.cnt=blob.read_shift(2)-z.c;var miyRw=blob.read_shift(2);blob.l+=4;// reserved(2), unused(2)
var flags=blob.read_shift(1);// various flags
blob.l+=3;// reserved(8), ixfe(12), flags(4)
if(flags&0x07)z.level=flags&0x07;// collapsed: flags & 0x10
if(flags&0x20)z.hidden=true;if(flags&0x40)z.hpt=miyRw/20;return z;}/* [MS-XLS] 2.4.125 */function parse_ForceFullCalculation(blob){var header=parse_frtHeader(blob);if(header.type!=0x08A3)throw new Error("Invalid Future Record "+header.type);var fullcalc=blob.read_shift(4);return fullcalc!==0x0;}/* [MS-XLS] 2.4.215 rt */function parse_RecalcId(blob){blob.read_shift(2);return blob.read_shift(4);}/* [MS-XLS] 2.4.87 */function parse_DefaultRowHeight(blob,length,opts){var f=0;if(!(opts&&opts.biff==2)){f=blob.read_shift(2);}var miyRw=blob.read_shift(2);if(opts&&opts.biff==2){f=1-(miyRw>>15);miyRw&=0x7fff;}var fl={Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};return[fl,miyRw];}/* [MS-XLS] 2.4.345 TODO */function parse_Window1(blob){var xWn=blob.read_shift(2),yWn=blob.read_shift(2),dxWn=blob.read_shift(2),dyWn=blob.read_shift(2);var flags=blob.read_shift(2),iTabCur=blob.read_shift(2),iTabFirst=blob.read_shift(2);var ctabSel=blob.read_shift(2),wTabRatio=blob.read_shift(2);return{Pos:[xWn,yWn],Dim:[dxWn,dyWn],Flags:flags,CurTab:iTabCur,FirstTab:iTabFirst,Selected:ctabSel,TabRatio:wTabRatio};}function write_Window1(){var o=new_buf(18);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0x7260);o.write_shift(2,0x44c0);o.write_shift(2,0x38);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,1);o.write_shift(2,0x01f4);return o;}/* [MS-XLS] 2.4.346 TODO */function parse_Window2(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<5)return{};var f=blob.read_shift(2);return{RTL:f&0x40};}function write_Window2(view){var o=new_buf(18),f=0x6b6;if(view&&view.RTL)f|=0x40;o.write_shift(2,f);o.write_shift(4,0);o.write_shift(4,64);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLS] 2.4.189 TODO */function parse_Pane(/*blob, length, opts*/){}/* [MS-XLS] 2.4.122 TODO */function parse_Font(blob,length,opts){var o={dyHeight:blob.read_shift(2),fl:blob.read_shift(2)};switch(opts&&opts.biff||8){case 2:break;case 3:case 4:blob.l+=2;break;default:blob.l+=10;break;}o.name=parse_ShortXLUnicodeString(blob,0,opts);return o;}function write_Font(data,opts){var name=data.name||"Arial";var b5=opts&&opts.biff==5,w=b5?15+name.length:16+2*name.length;var o=new_buf(w);o.write_shift(2,(data.sz||12)*20);o.write_shift(4,0);o.write_shift(2,400);o.write_shift(4,0);o.write_shift(2,0);o.write_shift(1,name.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*name.length,name,b5?"sbcs":"utf16le");return o;}/* [MS-XLS] 2.4.149 */function parse_LabelSst(blob){var cell=parse_XLSCell(blob);cell.isst=blob.read_shift(4);return cell;}function write_LabelSst(R,C,v,os){var o=new_buf(10);write_XLSCell(R,C,os,o);o.write_shift(4,v);return o;}/* [MS-XLS] 2.4.148 */function parse_Label(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var target=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)blob.l++;var str=parse_XLUnicodeString(blob,target-blob.l,opts);cell.val=str;return cell;}function write_Label(R,C,v,os,opts){var b8=!opts||opts.biff==8;var o=new_buf(6+2+ +b8+(1+b8)*v.length);write_XLSCell(R,C,os,o);o.write_shift(2,v.length);if(b8)o.write_shift(1,1);o.write_shift((1+b8)*v.length,v,b8?'utf16le':'sbcs');return o;}/* [MS-XLS] 2.4.126 Number Formats */function parse_Format(blob,length,opts){var numFmtId=blob.read_shift(2);var fmtstr=parse_XLUnicodeString2(blob,0,opts);return[numFmtId,fmtstr];}function write_Format(i,f,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?3+f.length:5+2*f.length);o.write_shift(2,i);o.write_shift(b5?1:2,f.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*f.length,f,b5?'sbcs':'utf16le');var out=o.length>o.l?o.slice(0,o.l):o;if(out.l==null)out.l=out.length;return out;}var parse_BIFF2Format=parse_XLUnicodeString2;/* [MS-XLS] 2.4.90 */function parse_Dimensions(blob,length,opts){var end=blob.l+length;var w=opts.biff==8||!opts.biff?4:2;var r=blob.read_shift(w),R=blob.read_shift(w);var c=blob.read_shift(2),C=blob.read_shift(2);blob.l=end;return{s:{r:r,c:c},e:{r:R,c:C}};}function write_Dimensions(range,opts){var w=opts.biff==8||!opts.biff?4:2;var o=new_buf(2*w+6);o.write_shift(w,range.s.r);o.write_shift(w,range.e.r+1);o.write_shift(2,range.s.c);o.write_shift(2,range.e.c+1);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.220 */function parse_RK(blob){var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrec=parse_RkRec(blob);return{r:rw,c:col,ixfe:rkrec[0],rknum:rkrec[1]};}/* [MS-XLS] 2.4.175 */function parse_MulRk(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrecs=[];while(blob.l<target)rkrecs.push(parse_RkRec(blob));if(blob.l!==target)throw new Error("MulRK read error");var lastcol=blob.read_shift(2);if(rkrecs.length!=lastcol-col+1)throw new Error("MulRK length mismatch");return{r:rw,c:col,C:lastcol,rkrec:rkrecs};}/* [MS-XLS] 2.4.174 */function parse_MulBlank(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var ixfes=[];while(blob.l<target)ixfes.push(blob.read_shift(2));if(blob.l!==target)throw new Error("MulBlank read error");var lastcol=blob.read_shift(2);if(ixfes.length!=lastcol-col+1)throw new Error("MulBlank length mismatch");return{r:rw,c:col,C:lastcol,ixfe:ixfes};}/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */function parse_CellStyleXF(blob,length,style,opts){var o={};var a=blob.read_shift(4),b=blob.read_shift(4);var c=blob.read_shift(4),d=blob.read_shift(2);o.patternType=XLSFillPattern[c>>26];if(!opts.cellStyles)return o;o.alc=a&0x07;o.fWrap=a>>3&0x01;o.alcV=a>>4&0x07;o.fJustLast=a>>7&0x01;o.trot=a>>8&0xFF;o.cIndent=a>>16&0x0F;o.fShrinkToFit=a>>20&0x01;o.iReadOrder=a>>22&0x02;o.fAtrNum=a>>26&0x01;o.fAtrFnt=a>>27&0x01;o.fAtrAlc=a>>28&0x01;o.fAtrBdr=a>>29&0x01;o.fAtrPat=a>>30&0x01;o.fAtrProt=a>>31&0x01;o.dgLeft=b&0x0F;o.dgRight=b>>4&0x0F;o.dgTop=b>>8&0x0F;o.dgBottom=b>>12&0x0F;o.icvLeft=b>>16&0x7F;o.icvRight=b>>23&0x7F;o.grbitDiag=b>>30&0x03;o.icvTop=c&0x7F;o.icvBottom=c>>7&0x7F;o.icvDiag=c>>14&0x7F;o.dgDiag=c>>21&0x0F;o.icvFore=d&0x7F;o.icvBack=d>>7&0x7F;o.fsxButton=d>>14&0x01;return o;}//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */function parse_XF(blob,length,opts){var o={};o.ifnt=blob.read_shift(2);o.numFmtId=blob.read_shift(2);o.flags=blob.read_shift(2);o.fStyle=o.flags>>2&0x01;length-=6;o.data=parse_CellStyleXF(blob,length,o.fStyle,opts);return o;}function write_XF(data,ixfeP,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?16:20);o.write_shift(2,0);if(data.style){o.write_shift(2,data.numFmtId||0);o.write_shift(2,0xFFF4);}else{o.write_shift(2,data.numFmtId||0);o.write_shift(2,ixfeP<<4);}var f=0;if(data.numFmtId>0&&b5)f|=0x0400;o.write_shift(4,f);o.write_shift(4,0);if(!b5)o.write_shift(4,0);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.134 */function parse_Guts(blob){blob.l+=4;var out=[blob.read_shift(2),blob.read_shift(2)];if(out[0]!==0)out[0]--;if(out[1]!==0)out[1]--;if(out[0]>7||out[1]>7)throw new Error("Bad Gutters: "+out.join("|"));return out;}function write_Guts(guts){var o=new_buf(8);o.write_shift(4,0);o.write_shift(2,guts[0]?guts[0]+1:0);o.write_shift(2,guts[1]?guts[1]+1:0);return o;}/* [MS-XLS] 2.4.24 */function parse_BoolErr(blob,length,opts){var cell=parse_XLSCell(blob,6);if(opts.biff==2||length==9)++blob.l;var val=parse_Bes(blob,2);cell.val=val;cell.t=val===true||val===false?'b':'e';return cell;}function write_BoolErr(R,C,v,os,opts,t){var o=new_buf(8);write_XLSCell(R,C,os,o);write_Bes(v,t,o);return o;}/* [MS-XLS] 2.4.180 Number */function parse_Number(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var cell=parse_XLSCell(blob,6);var xnum=parse_Xnum(blob,8);cell.val=xnum;return cell;}function write_Number(R,C,v,os){var o=new_buf(14);write_XLSCell(R,C,os,o);write_Xnum(v,o);return o;}var parse_XLHeaderFooter=parse_OptXLUnicodeString;// TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */function parse_SupBook(blob,length,opts){var end=blob.l+length;var ctab=blob.read_shift(2);var cch=blob.read_shift(2);opts.sbcch=cch;if(cch==0x0401||cch==0x3A01)return[cch,ctab];if(cch<0x01||cch>0xff)throw new Error("Unexpected SupBook type: "+cch);var virtPath=parse_XLUnicodeStringNoCch(blob,cch);/* TODO: 2.5.277 Virtual Path */var rgst=[];while(end>blob.l)rgst.push(parse_XLUnicodeString(blob));return[cch,ctab,virtPath,rgst];}/* [MS-XLS] 2.4.105 TODO */function parse_ExternName(blob,length,opts){var flags=blob.read_shift(2);var body;var o={fBuiltIn:flags&0x01,fWantAdvise:flags>>>1&0x01,fWantPict:flags>>>2&0x01,fOle:flags>>>3&0x01,fOleLink:flags>>>4&0x01,cf:flags>>>5&0x3FF,fIcon:flags>>>15&0x01};if(opts.sbcch===0x3A01)body=parse_AddinUdf(blob,length-2,opts);//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
o.body=body||blob.read_shift(length-2);if(typeof body==="string")o.Name=body;return o;}/* [MS-XLS] 2.4.150 TODO */var XLSLblBuiltIn=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function parse_Lbl(blob,length,opts){var target=blob.l+length;var flags=blob.read_shift(2);var chKey=blob.read_shift(1);var cch=blob.read_shift(1);var cce=blob.read_shift(opts&&opts.biff==2?1:2);var itab=0;if(!opts||opts.biff>=5){if(opts.biff!=5)blob.l+=2;itab=blob.read_shift(2);if(opts.biff==5)blob.l+=2;blob.l+=4;}var name=parse_XLUnicodeStringNoCch(blob,cch,opts);if(flags&0x20)name=XLSLblBuiltIn[name.charCodeAt(0)];var npflen=target-blob.l;if(opts&&opts.biff==2)--npflen;/*jshint -W018 */var rgce=target==blob.l||cce===0||!(npflen>0)?[]:parse_NameParsedFormula(blob,npflen,opts,cce);/*jshint +W018 */return{chKey:chKey,Name:name,itab:itab,rgce:rgce};}/* [MS-XLS] 2.4.106 TODO: verify filename encoding */function parse_ExternSheet(blob,length,opts){if(opts.biff<8)return parse_BIFF5ExternSheet(blob,length,opts);var o=[],target=blob.l+length,len=blob.read_shift(opts.biff>8?4:2);while(len--!==0)o.push(parse_XTI(blob,opts.biff>8?12:6,opts));// [iSupBook, itabFirst, itabLast];
if(blob.l!=target)throw new Error("Bad ExternSheet: "+blob.l+" != "+target);return o;}function parse_BIFF5ExternSheet(blob,length,opts){if(blob[blob.l+1]==0x03)blob[blob.l]++;var o=parse_ShortXLUnicodeString(blob,length,opts);return o.charCodeAt(0)==0x03?o.slice(1):o;}/* [MS-XLS] 2.4.176 TODO: check older biff */function parse_NameCmt(blob,length,opts){if(opts.biff<8){blob.l+=length;return;}var cchName=blob.read_shift(2);var cchComment=blob.read_shift(2);var name=parse_XLUnicodeStringNoCch(blob,cchName,opts);var comment=parse_XLUnicodeStringNoCch(blob,cchComment,opts);return[name,comment];}/* [MS-XLS] 2.4.260 */function parse_ShrFmla(blob,length,opts){var ref=parse_RefU(blob,6);blob.l++;var cUse=blob.read_shift(1);length-=8;return[parse_SharedParsedFormula(blob,length,opts),cUse,ref];}/* [MS-XLS] 2.4.4 TODO */function parse_Array(blob,length,opts){var ref=parse_Ref(blob,6);/* TODO: fAlwaysCalc */switch(opts.biff){case 2:blob.l++;length-=7;break;case 3:case 4:blob.l+=2;length-=8;break;default:blob.l+=6;length-=12;}return[ref,parse_ArrayParsedFormula(blob,length,opts,ref)];}/* [MS-XLS] 2.4.173 */function parse_MTRSettings(blob){var fMTREnabled=blob.read_shift(4)!==0x00;var fUserSetThreadCount=blob.read_shift(4)!==0x00;var cUserThreadCount=blob.read_shift(4);return[fMTREnabled,fUserSetThreadCount,cUserThreadCount];}/* [MS-XLS] 2.5.186 TODO: BIFF5 */function parse_NoteSh(blob,length,opts){if(opts.biff<8)return;var row=blob.read_shift(2),col=blob.read_shift(2);var flags=blob.read_shift(2),idObj=blob.read_shift(2);var stAuthor=parse_XLUnicodeString2(blob,0,opts);if(opts.biff<8)blob.read_shift(1);return[{r:row,c:col},stAuthor,idObj,flags];}/* [MS-XLS] 2.4.179 */function parse_Note(blob,length,opts){/* TODO: Support revisions */return parse_NoteSh(blob,length,opts);}/* [MS-XLS] 2.4.168 */function parse_MergeCells(blob,length){var merges=[];var cmcs=blob.read_shift(2);while(cmcs--)merges.push(parse_Ref8U(blob,length));return merges;}function write_MergeCells(merges){var o=new_buf(2+merges.length*8);o.write_shift(2,merges.length);for(var i=0;i<merges.length;++i)write_Ref8U(merges[i],o);return o;}/* [MS-XLS] 2.4.181 TODO: parse all the things! */function parse_Obj(blob,length,opts){if(opts&&opts.biff<8)return parse_BIFF5Obj(blob,length,opts);var cmo=parse_FtCmo(blob,22);// id, ot, flags
var fts=parse_FtArray(blob,length-22,cmo[1]);return{cmo:cmo,ft:fts};}/* from older spec */var parse_BIFF5OT=[];parse_BIFF5OT[0x08]=function(blob,length){var tgt=blob.l+length;blob.l+=10;// todo
var cf=blob.read_shift(2);blob.l+=4;blob.l+=2;//var cbPictFmla = blob.read_shift(2);
blob.l+=2;blob.l+=2;//var grbit = blob.read_shift(2);
blob.l+=4;var cchName=blob.read_shift(1);blob.l+=cchName;// TODO: stName
blob.l=tgt;// TODO: fmla
return{fmt:cf};};function parse_BIFF5Obj(blob,length,opts){blob.l+=4;//var cnt = blob.read_shift(4);
var ot=blob.read_shift(2);var id=blob.read_shift(2);var grbit=blob.read_shift(2);blob.l+=2;//var colL = blob.read_shift(2);
blob.l+=2;//var dxL = blob.read_shift(2);
blob.l+=2;//var rwT = blob.read_shift(2);
blob.l+=2;//var dyT = blob.read_shift(2);
blob.l+=2;//var colR = blob.read_shift(2);
blob.l+=2;//var dxR = blob.read_shift(2);
blob.l+=2;//var rwB = blob.read_shift(2);
blob.l+=2;//var dyB = blob.read_shift(2);
blob.l+=2;//var cbMacro = blob.read_shift(2);
blob.l+=6;length-=36;var fts=[];fts.push((parse_BIFF5OT[ot]||parsenoop)(blob,length,opts));return{cmo:[id,ot,grbit],ft:fts};}/* [MS-XLS] 2.4.329 TODO: parse properly */function parse_TxO(blob,length,opts){var s=blob.l;var texts="";try{blob.l+=4;var ot=(opts.lastobj||{cmo:[0,0]}).cmo[1];var controlInfo;// eslint-disable-line no-unused-vars
if([0,5,7,11,12,14].indexOf(ot)==-1)blob.l+=6;else controlInfo=parse_ControlInfo(blob,6,opts);var cchText=blob.read_shift(2);/*var cbRuns = */blob.read_shift(2);/*var ifntEmpty = */parseuint16(blob,2);var len=blob.read_shift(2);blob.l+=len;//var fmla = parse_ObjFmla(blob, s + length - blob.l);
for(var i=1;i<blob.lens.length-1;++i){if(blob.l-s!=blob.lens[i])throw new Error("TxO: bad continue record");var hdr=blob[blob.l];var t=parse_XLUnicodeStringNoCch(blob,blob.lens[i+1]-blob.lens[i]-1);texts+=t;if(texts.length>=(hdr?cchText:2*cchText))break;}if(texts.length!==cchText&&texts.length!==cchText*2){throw new Error("cchText: "+cchText+" != "+texts.length);}blob.l=s+length;/* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
return{t:texts};}catch(e){blob.l=s+length;return{t:texts};}}/* [MS-XLS] 2.4.140 */function parse_HLink(blob,length){var ref=parse_Ref8U(blob,8);blob.l+=16;/* CLSID */var hlink=parse_Hyperlink(blob,length-24);return[ref,hlink];}function write_HLink(hl){var O=new_buf(24);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);var clsid="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var i=0;i<16;++i)O.write_shift(1,parseInt(clsid[i],16));return bconcat([O,write_Hyperlink(hl[1])]);}/* [MS-XLS] 2.4.141 */function parse_HLinkTooltip(blob,length){blob.read_shift(2);var ref=parse_Ref8U(blob,8);var wzTooltip=blob.read_shift((length-10)/2,'dbcs-cont');wzTooltip=wzTooltip.replace(chr0,"");return[ref,wzTooltip];}function write_HLinkTooltip(hl){var TT=hl[1].Tooltip;var O=new_buf(10+2*(TT.length+1));O.write_shift(2,0x0800);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);for(var i=0;i<TT.length;++i)O.write_shift(2,TT.charCodeAt(i));O.write_shift(2,0);return O;}/* [MS-XLS] 2.4.63 */function parse_Country(blob){var o=[0,0],d;d=blob.read_shift(2);o[0]=CountryEnum[d]||d;d=blob.read_shift(2);o[1]=CountryEnum[d]||d;return o;}function write_Country(o){if(!o)o=new_buf(4);o.write_shift(2,0x01);o.write_shift(2,0x01);return o;}/* [MS-XLS] 2.4.50 ClrtClient */function parse_ClrtClient(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob,8));return o;}/* [MS-XLS] 2.4.188 */function parse_Palette(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob,8));return o;}/* [MS-XLS] 2.4.354 */function parse_XFCRC(blob){blob.l+=2;var o={cxfs:0,crc:0};o.cxfs=blob.read_shift(2);o.crc=blob.read_shift(4);return o;}/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */function parse_ColInfo(blob,length,opts){if(!opts.cellStyles)return parsenoop(blob,length);var w=opts&&opts.biff>=12?4:2;var colFirst=blob.read_shift(w);var colLast=blob.read_shift(w);var coldx=blob.read_shift(w);var ixfe=blob.read_shift(w);var flags=blob.read_shift(2);if(w==2)blob.l+=2;var o={s:colFirst,e:colLast,w:coldx,ixfe:ixfe,flags:flags};if(opts.biff>=5||!opts.biff)o.level=flags>>8&0x7;return o;}function write_ColInfo(col,idx){var o=new_buf(12);o.write_shift(2,idx);o.write_shift(2,idx);o.write_shift(2,col.width*256);o.write_shift(2,0);var f=0;if(col.hidden)f|=1;o.write_shift(1,f);f=col.level||0;o.write_shift(1,f);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.257 */function parse_Setup(blob,length){var o={};if(length<32)return o;blob.l+=16;o.header=parse_Xnum(blob,8);o.footer=parse_Xnum(blob,8);blob.l+=2;return o;}/* [MS-XLS] 2.4.261 */function parse_ShtProps(blob,length,opts){var def={area:false};if(opts.biff!=5){blob.l+=length;return def;}var d=blob.read_shift(1);blob.l+=3;if(d&0x10)def.area=true;return def;}/* [MS-XLS] 2.4.241 */function write_RRTabId(n){var out=new_buf(2*n);for(var i=0;i<n;++i)out.write_shift(2,i+1);return out;}var parse_Blank=parse_XLSCell;/* [MS-XLS] 2.4.20 Just the cell */var parse_Scl=parseuint16a;/* [MS-XLS] 2.4.247 num, den */var parse_String=parse_XLUnicodeString;/* [MS-XLS] 2.4.268 */ /* --- Specific to versions before BIFF8 --- */function parse_ImData(blob){var cf=blob.read_shift(2);var env=blob.read_shift(2);var lcb=blob.read_shift(4);var o={fmt:cf,env:env,len:lcb,data:blob.slice(blob.l,blob.l+lcb)};blob.l+=lcb;return o;}/* BIFF2_??? where ??? is the name from [XLS] */function parse_BIFF2STR(blob,length,opts){if(opts.biffguess&&opts.biff==5)opts.biff=2;var cell=parse_XLSCell(blob,6);++blob.l;var str=parse_XLUnicodeString2(blob,length-7,opts);cell.t='str';cell.val=str;return cell;}function parse_BIFF2NUM(blob){var cell=parse_XLSCell(blob,6);++blob.l;var num=parse_Xnum(blob,8);cell.t='n';cell.val=num;return cell;}function write_BIFF2NUM(r,c,val){var out=new_buf(15);write_BIFF2Cell(out,r,c);out.write_shift(8,val,'f');return out;}function parse_BIFF2INT(blob){var cell=parse_XLSCell(blob,6);++blob.l;var num=blob.read_shift(2);cell.t='n';cell.val=num;return cell;}function write_BIFF2INT(r,c,val){var out=new_buf(9);write_BIFF2Cell(out,r,c);out.write_shift(2,val);return out;}function parse_BIFF2STRING(blob){var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,'sbcs-cont');}/* TODO: convert to BIFF8 font struct */function parse_BIFF2FONTXTRA(blob,length){blob.l+=6;// unknown
blob.l+=2;// font weight "bls"
blob.l+=1;// charset
blob.l+=3;// unknown
blob.l+=1;// font family
blob.l+=length-13;}/* TODO: parse rich text runs */function parse_RString(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);var cch=blob.read_shift(2);var str=parse_XLUnicodeStringNoCch(blob,cch,opts);blob.l=end;cell.t='str';cell.val=str;return cell;}/* from js-harb (C) 2014-present  SheetJS */var DBF=function(){var dbf_codepage_map={/* Code Pages Supported by Visual FoxPro */0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,/* shapefile DBF extension */0x00:20127,0x08:865,0x09:437,0x0A:850,0x0B:437,0x0D:437,0x0E:850,0x0F:437,0x10:850,0x11:437,0x12:850,0x13:932,0x14:850,0x15:437,0x16:850,0x17:865,0x18:437,0x19:437,0x1A:850,0x1B:437,0x1C:863,0x1D:850,0x1F:852,0x22:852,0x23:852,0x24:860,0x25:850,0x26:866,0x37:850,0x40:852,0x4D:936,0x4E:949,0x4F:950,0x50:874,0x57:1252,0x58:1252,0x59:1252,0x6C:863,0x86:737,0x87:852,0x88:857,0xCC:1257,0xFF:16969};var dbf_reverse_map=evert({0x01:437,0x02:850,0x03:1252,0x04:10000,0x64:852,0x65:866,0x66:865,0x67:861,0x68:895,0x69:620,0x6A:737,0x6B:857,0x78:950,0x79:949,0x7A:936,0x7B:932,0x7C:874,0x7D:1255,0x7E:1256,0x96:10007,0x97:10029,0x98:10006,0xC8:1250,0xC9:1251,0xCA:1254,0xCB:1253,0x00:20127});var DBF_SUPPORTED_VERSIONS=[0x02,0x03,0x30,0x31,0x83,0x8B,0x8C,0xF5];/* TODO: find an actual specification */function dbf_to_aoa(buf,opts){var out=[];var d=new_raw_buf(1);switch(opts.type){case'base64':d=s2a(Base64.decode(buf));break;case'binary':d=s2a(buf);break;case'buffer':case'array':d=buf;break;}prep_blob(d,0);/* header */var ft=d.read_shift(1);var memo=!!(ft&0x88);var vfp=false,l7=false;switch(ft){case 0x02:break;// dBASE II
case 0x03:break;// dBASE III
case 0x30:vfp=true;memo=true;break;// VFP
case 0x31:vfp=true;memo=true;break;// VFP with autoincrement
// 0x43 dBASE IV SQL table files
// 0x63 dBASE IV SQL system files
case 0x83:break;// dBASE III with memo
case 0x8B:break;// dBASE IV with memo
case 0x8C:l7=true;break;// dBASE Level 7 with memo
// case 0xCB dBASE IV SQL table files with memo
case 0xF5:break;// FoxPro 2.x with memo
// case 0xFB FoxBASE
default:throw new Error("DBF Unsupported Version: "+ft.toString(16));}var nrow=0,fpos=0x0209;if(ft==0x02)nrow=d.read_shift(2);d.l+=3;// dBASE II stores DDMMYY date, others use YYMMDD
if(ft!=0x02)nrow=d.read_shift(4);if(nrow>1048576)nrow=1e6;if(ft!=0x02)fpos=d.read_shift(2);// header length
var rlen=d.read_shift(2);// record length
var/*flags = 0,*/current_cp=opts.codepage||1252;if(ft!=0x02){// 20 reserved bytes
d.l+=16;/*flags = */d.read_shift(1);//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
/* codepage present in FoxPro and dBASE Level 7 */if(d[d.l]!==0)current_cp=dbf_codepage_map[d[d.l]];d.l+=1;d.l+=2;}if(l7)d.l+=36;// Level 7: 32 byte "Language driver name", 4 byte reserved
var fields=[],field={};var hend=Math.min(d.length,ft==0x02?0x209:fpos-10-(vfp?264:0));var ww=l7?32:11;while(d.l<hend&&d[d.l]!=0x0d){field={};field.name=cptable.utils.decode(current_cp,d.slice(d.l,d.l+ww)).replace(/[\u0000\r\n].*$/g,"");d.l+=ww;field.type=String.fromCharCode(d.read_shift(1));if(ft!=0x02&&!l7)field.offset=d.read_shift(4);field.len=d.read_shift(1);if(ft==0x02)field.offset=d.read_shift(2);field.dec=d.read_shift(1);if(field.name.length)fields.push(field);if(ft!=0x02)d.l+=l7?13:14;switch(field.type){case'B':// Double (VFP) / Binary (dBASE L7)
if((!vfp||field.len!=8)&&opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'G':// General (FoxPro and dBASE L7)
case'P':// Picture (FoxPro and dBASE L7)
if(opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'+':// Autoincrement (dBASE L7 only)
case'0':// _NullFlags (VFP only)
case'@':// Timestamp (dBASE L7 only)
case'C':// Character (dBASE II)
case'D':// Date (dBASE III)
case'F':// Float (dBASE IV)
case'I':// Long (VFP and dBASE L7)
case'L':// Logical (dBASE II)
case'M':// Memo (dBASE III)
case'N':// Number (dBASE II)
case'O':// Double (dBASE L7 only)
case'T':// Datetime (VFP only)
case'Y':// Currency (VFP only)
break;default:throw new Error('Unknown Field Type: '+field.type);}}if(d[d.l]!==0x0D)d.l=fpos-1;if(d.read_shift(1)!==0x0D)throw new Error("DBF Terminator not found "+d.l+" "+d[d.l]);d.l=fpos;/* data */var R=0,C=0;out[0]=[];for(C=0;C!=fields.length;++C)out[0][C]=fields[C].name;while(nrow-->0){if(d[d.l]===0x2A){// TODO: record marked as deleted -- create a hidden row?
d.l+=rlen;continue;}++d.l;out[++R]=[];C=0;for(C=0;C!=fields.length;++C){var dd=d.slice(d.l,d.l+fields[C].len);d.l+=fields[C].len;prep_blob(dd,0);var s=cptable.utils.decode(current_cp,dd);switch(fields[C].type){case'C':// NOTE: it is conventional to write '  /  /  ' for empty dates
if(s.trim().length)out[R][C]=s.replace(/\s+$/,"");break;case'D':if(s.length===8)out[R][C]=new Date(+s.slice(0,4),+s.slice(4,6)-1,+s.slice(6,8));else out[R][C]=s;break;case'F':out[R][C]=parseFloat(s.trim());break;case'+':case'I':out[R][C]=l7?dd.read_shift(-4,'i')^0x80000000:dd.read_shift(4,'i');break;case'L':switch(s.trim().toUpperCase()){case'Y':case'T':out[R][C]=true;break;case'N':case'F':out[R][C]=false;break;case'':case'?':break;default:throw new Error("DBF Unrecognized L:|"+s+"|");}break;case'M':/* TODO: handle memo files */if(!memo)throw new Error("DBF Unexpected MEMO for type "+ft.toString(16));out[R][C]="##MEMO##"+(l7?parseInt(s.trim(),10):dd.read_shift(4));break;case'N':s=s.replace(/\u0000/g,"").trim();// NOTE: dBASE II interprets "  .  " as 0
if(s&&s!=".")out[R][C]=+s||0;break;case'@':// NOTE: dBASE specs appear to be incorrect
out[R][C]=new Date(dd.read_shift(-8,'f')-0x388317533400);break;case'T':out[R][C]=new Date((dd.read_shift(4)-0x253D8C)*0x5265C00+dd.read_shift(4));break;case'Y':out[R][C]=dd.read_shift(4,'i')/1e4;break;case'O':out[R][C]=-dd.read_shift(-8,'f');break;case'B':if(vfp&&fields[C].len==8){out[R][C]=dd.read_shift(8,'f');break;}/* falls through */case'G':case'P':dd.l+=fields[C].len;break;case'0':if(fields[C].name==='_NullFlags')break;/* falls through */default:throw new Error("DBF Unsupported data type "+fields[C].type);}}}if(ft!=0x02)if(d.l<d.length&&d[d.l++]!=0x1A)throw new Error("DBF EOF Marker missing "+(d.l-1)+" of "+d.length+" "+d[d.l-1].toString(16));if(opts&&opts.sheetRows)out=out.slice(0,opts.sheetRows);return out;}function dbf_to_sheet(buf,opts){var o=opts||{};if(!o.dateNF)o.dateNF="yyyymmdd";return aoa_to_sheet(dbf_to_aoa(buf,o),o);}function dbf_to_workbook(buf,opts){try{return sheet_to_workbook(dbf_to_sheet(buf,opts),opts);}catch(e){if(opts&&opts.WTF)throw e;}return{SheetNames:[],Sheets:{}};}var _RLEN={'B':8,'C':250,'L':1,'D':8,'?':0,'':0};function sheet_to_dbf(ws,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write DBF to JS string");var ba=buf_array();var aoa=sheet_to_json(ws,{header:1,raw:true,cellDates:true});var headers=aoa[0],data=aoa.slice(1);var i=0,j=0,hcnt=0,rlen=1;for(i=0;i<headers.length;++i){if(i==null)continue;++hcnt;if(typeof headers[i]==='number')headers[i]=headers[i].toString(10);if(typeof headers[i]!=='string')throw new Error("DBF Invalid column name "+headers[i]+" |"+typeof headers[i]+"|");if(headers.indexOf(headers[i])!==i)for(j=0;j<1024;++j)if(headers.indexOf(headers[i]+"_"+j)==-1){headers[i]+="_"+j;break;}}var range=safe_decode_range(ws['!ref']);var coltypes=[];for(i=0;i<=range.e.c-range.s.c;++i){var col=[];for(j=0;j<data.length;++j){if(data[j][i]!=null)col.push(data[j][i]);}if(col.length==0||headers[i]==null){coltypes[i]='?';continue;}var guess='',_guess='';for(j=0;j<col.length;++j){switch(typeof col[j]){/* TODO: check if L2 compat is desired */case'number':_guess='B';break;case'string':_guess='C';break;case'boolean':_guess='L';break;case'object':_guess=col[j]instanceof Date?'D':'C';break;default:_guess='C';}guess=guess&&guess!=_guess?'C':_guess;if(guess=='C')break;}rlen+=_RLEN[guess]||0;coltypes[i]=guess;}var h=ba.next(32);h.write_shift(4,0x13021130);h.write_shift(4,data.length);h.write_shift(2,296+32*hcnt);h.write_shift(2,rlen);for(i=0;i<4;++i)h.write_shift(4,0);h.write_shift(4,0x00000000|(+dbf_reverse_map[current_ansi]||0x03)<<8);for(i=0,j=0;i<headers.length;++i){if(headers[i]==null)continue;var hf=ba.next(32);var _f=(headers[i].slice(-10)+"\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0,11);hf.write_shift(1,_f,"sbcs");hf.write_shift(1,coltypes[i]=='?'?'C':coltypes[i],"sbcs");hf.write_shift(4,j);hf.write_shift(1,_RLEN[coltypes[i]]||0);hf.write_shift(1,0);hf.write_shift(1,0x02);hf.write_shift(4,0);hf.write_shift(1,0);hf.write_shift(4,0);hf.write_shift(4,0);j+=_RLEN[coltypes[i]]||0;}var hb=ba.next(264);hb.write_shift(4,0x0000000D);for(i=0;i<65;++i)hb.write_shift(4,0x00000000);for(i=0;i<data.length;++i){var rout=ba.next(rlen);rout.write_shift(1,0);for(j=0;j<headers.length;++j){if(headers[j]==null)continue;switch(coltypes[j]){case'L':rout.write_shift(1,data[i][j]==null?0x3F:data[i][j]?0x54:0x46);break;case'B':rout.write_shift(8,data[i][j]||0,'f');break;case'D':if(!data[i][j])rout.write_shift(8,"00000000","sbcs");else{rout.write_shift(4,("0000"+data[i][j].getFullYear()).slice(-4),"sbcs");rout.write_shift(2,("00"+(data[i][j].getMonth()+1)).slice(-2),"sbcs");rout.write_shift(2,("00"+data[i][j].getDate()).slice(-2),"sbcs");}break;case'C':var _s=String(data[i][j]||"");rout.write_shift(1,_s,"sbcs");for(hcnt=0;hcnt<250-_s.length;++hcnt)rout.write_shift(1,0x20);break;}}// data
}ba.next(1).write_shift(1,0x1A);return ba.end();}return{versions:DBF_SUPPORTED_VERSIONS,to_workbook:dbf_to_workbook,to_sheet:dbf_to_sheet,from_sheet:sheet_to_dbf};}();var SYLK=function(){/* TODO: stress test sequences */var sylk_escapes={AA:'À',BA:'Á',CA:'Â',DA:195,HA:'Ä',JA:197,AE:'È',BE:'É',CE:'Ê',HE:'Ë',AI:'Ì',BI:'Í',CI:'Î',HI:'Ï',AO:'Ò',BO:'Ó',CO:'Ô',DO:213,HO:'Ö',AU:'Ù',BU:'Ú',CU:'Û',HU:'Ü',Aa:'à',Ba:'á',Ca:'â',Da:227,Ha:'ä',Ja:229,Ae:'è',Be:'é',Ce:'ê',He:'ë',Ai:'ì',Bi:'í',Ci:'î',Hi:'ï',Ao:'ò',Bo:'ó',Co:'ô',Do:245,Ho:'ö',Au:'ù',Bu:'ú',Cu:'û',Hu:'ü',KC:'Ç',Kc:'ç',q:'æ',z:'œ',a:'Æ',j:'Œ',DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223};var sylk_char_regex=new RegExp("\u001BN("+keys(sylk_escapes).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var sylk_char_fn=function(_,$1){var o=sylk_escapes[$1];return typeof o=="number"?_getansi(o):o;};var decode_sylk_char=function($$,$1,$2){var newcc=$1.charCodeAt(0)-0x20<<4|$2.charCodeAt(0)-0x30;return newcc==59?$$:_getansi(newcc);};sylk_escapes["|"]=254;/* TODO: find an actual specification */function sylk_to_aoa(d,opts){switch(opts.type){case'base64':return sylk_to_aoa_str(Base64.decode(d),opts);case'binary':return sylk_to_aoa_str(d,opts);case'buffer':return sylk_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return sylk_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function sylk_to_aoa_str(str,opts){var records=str.split(/[\n\r]+/),R=-1,C=-1,ri=0,rj=0,arr=[];var formats=[];var next_cell_format=null;var sht={},rowinfo=[],colinfo=[],cw=[];var Mval=0,j;if(+opts.codepage>=0)set_cp(+opts.codepage);for(;ri!==records.length;++ri){Mval=0;var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,decode_sylk_char).replace(sylk_char_regex,sylk_char_fn);var record=rstr.replace(/;;/g,"\u0000").split(";").map(function(x){return x.replace(/\u0000/g,";");});var RT=record[0],val;if(rstr.length>0)switch(RT){case'ID':break;/* header */case'E':break;/* EOF */case'B':break;/* dimensions */case'O':break;/* options? */case'W':break;/* window? */case'P':if(record[1].charAt(0)=='P')formats.push(rstr.slice(3).replace(/;;/g,";"));break;case'C':var C_seen_K=false,C_seen_X=false,C_seen_S=false,C_seen_E=false,_R=-1,_C=-1;for(rj=1;rj<record.length;++rj)switch(record[rj].charAt(0)){case'A':break;// TODO: comment
case'X':C=parseInt(record[rj].slice(1))-1;C_seen_X=true;break;case'Y':R=parseInt(record[rj].slice(1))-1;if(!C_seen_X)C=0;for(j=arr.length;j<=R;++j)arr[j]=[];break;case'K':val=record[rj].slice(1);if(val.charAt(0)==='"')val=val.slice(1,val.length-1);else if(val==='TRUE')val=true;else if(val==='FALSE')val=false;else if(!isNaN(fuzzynum(val))){val=fuzzynum(val);if(next_cell_format!==null&&SSF.is_date(next_cell_format))val=numdate(val);}else if(!isNaN(fuzzydate(val).getDate())){val=parseDate(val);}if(typeof cptable!=='undefined'&&typeof val=="string"&&(opts||{}).type!="string"&&(opts||{}).codepage)val=cptable.utils.decode(opts.codepage,val);C_seen_K=true;break;case'E':C_seen_E=true;var formula=rc_to_a1(record[rj].slice(1),{r:R,c:C});arr[R][C]=[arr[R][C],formula];break;case'S':C_seen_S=true;arr[R][C]=[arr[R][C],"S5S"];break;case'G':break;// unknown
case'R':_R=parseInt(record[rj].slice(1))-1;break;case'C':_C=parseInt(record[rj].slice(1))-1;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}if(C_seen_K){if(arr[R][C]&&arr[R][C].length==2)arr[R][C][0]=val;else arr[R][C]=val;next_cell_format=null;}if(C_seen_S){if(C_seen_E)throw new Error("SYLK shared formula cannot have own formula");var shrbase=_R>-1&&arr[_R][_C];if(!shrbase||!shrbase[1])throw new Error("SYLK shared formula cannot find base");arr[R][C][1]=shift_formula_str(shrbase[1],{r:R-_R,c:C-_C});}break;case'F':var F_seen=0;for(rj=1;rj<record.length;++rj)switch(record[rj].charAt(0)){case'X':C=parseInt(record[rj].slice(1))-1;++F_seen;break;case'Y':R=parseInt(record[rj].slice(1))-1;/*C = 0;*/for(j=arr.length;j<=R;++j)arr[j]=[];break;case'M':Mval=parseInt(record[rj].slice(1))/20;break;case'F':break;/* ??? */case'G':break;/* hide grid */case'P':next_cell_format=formats[parseInt(record[rj].slice(1))];break;case'S':break;/* cell style */case'D':break;/* column */case'N':break;/* font */case'W':cw=record[rj].slice(1).split(" ");for(j=parseInt(cw[0],10);j<=parseInt(cw[1],10);++j){Mval=parseInt(cw[2],10);colinfo[j-1]=Mval===0?{hidden:true}:{wch:Mval};process_col(colinfo[j-1]);}break;case'C':/* default column format */C=parseInt(record[rj].slice(1))-1;if(!colinfo[C])colinfo[C]={};break;case'R':/* row properties */R=parseInt(record[rj].slice(1))-1;if(!rowinfo[R])rowinfo[R]={};if(Mval>0){rowinfo[R].hpt=Mval;rowinfo[R].hpx=pt2px(Mval);}else if(Mval===0)rowinfo[R].hidden=true;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}if(F_seen<1)next_cell_format=null;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(rowinfo.length>0)sht['!rows']=rowinfo;if(colinfo.length>0)sht['!cols']=colinfo;if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return[arr,sht];}function sylk_to_sheet(d,opts){var aoasht=sylk_to_aoa(d,opts);var aoa=aoasht[0],ws=aoasht[1];var o=aoa_to_sheet(aoa,opts);keys(ws).forEach(function(k){o[k]=ws[k];});return o;}function sylk_to_workbook(d,opts){return sheet_to_workbook(sylk_to_sheet(d,opts),opts);}function write_ws_cell_sylk(cell,ws,R,C){var o="C;Y"+(R+1)+";X"+(C+1)+";K";switch(cell.t){case'n':o+=cell.v||0;if(cell.f&&!cell.F)o+=";E"+a1_to_rc(cell.f,{r:R,c:C});break;case'b':o+=cell.v?"TRUE":"FALSE";break;case'e':o+=cell.w||cell.v;break;case'd':o+='"'+(cell.w||cell.v)+'"';break;case's':o+='"'+cell.v.replace(/"/g,"")+'"';break;}return o;}function write_ws_cols_sylk(out,cols){cols.forEach(function(col,i){var rec="F;W"+(i+1)+" "+(i+1)+" ";if(col.hidden)rec+="0";else{if(typeof col.width=='number'&&!col.wpx)col.wpx=width2px(col.width);if(typeof col.wpx=='number'&&!col.wch)col.wch=px2char(col.wpx);if(typeof col.wch=='number')rec+=Math.round(col.wch);}if(rec.charAt(rec.length-1)!=" ")out.push(rec);});}function write_ws_rows_sylk(out,rows){rows.forEach(function(row,i){var rec="F;";if(row.hidden)rec+="M0;";else if(row.hpt)rec+="M"+20*row.hpt+";";else if(row.hpx)rec+="M"+20*px2pt(row.hpx)+";";if(rec.length>2)out.push(rec+"R"+(i+1));});}function sheet_to_sylk(ws,opts){var preamble=["ID;PWXL;N;E"],o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);var RS="\r\n";preamble.push("P;PGeneral");preamble.push("F;P0;DG0G8;M255");if(ws['!cols'])write_ws_cols_sylk(preamble,ws['!cols']);if(ws['!rows'])write_ws_rows_sylk(preamble,ws['!rows']);preamble.push("B;Y"+(r.e.r-r.s.r+1)+";X"+(r.e.c-r.s.c+1)+";D"+[r.s.c,r.s.r,r.e.c,r.e.r].join(" "));for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(write_ws_cell_sylk(cell,ws,R,C,opts));}}return preamble.join(RS)+RS+o.join(RS)+RS+"E"+RS;}return{to_workbook:sylk_to_workbook,to_sheet:sylk_to_sheet,from_sheet:sheet_to_sylk};}();var DIF=function(){function dif_to_aoa(d,opts){switch(opts.type){case'base64':return dif_to_aoa_str(Base64.decode(d),opts);case'binary':return dif_to_aoa_str(d,opts);case'buffer':return dif_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return dif_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function dif_to_aoa_str(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){if(records[ri].trim()==='BOT'){arr[++R]=[];C=0;continue;}if(R<0)continue;var metadata=records[ri].trim().split(",");var type=metadata[0],value=metadata[1];++ri;var data=records[ri]||"";while((data.match(/["]/g)||[]).length&1&&ri<records.length-1)data+="\n"+records[++ri];data=data.trim();switch(+type){case-1:if(data==='BOT'){arr[++R]=[];C=0;continue;}else if(data!=='EOD')throw new Error("Unrecognized DIF special command "+data);break;case 0:if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(value)))arr[R][C]=fuzzynum(value);else if(!isNaN(fuzzydate(value).getDate()))arr[R][C]=parseDate(value);else arr[R][C]=value;++C;break;case 1:data=data.slice(1,data.length-1);data=data.replace(/""/g,'"');if(DIF_XL&&data&&data.match(/^=".*"$/))data=data.slice(2,-1);arr[R][C++]=data!==''?data:null;break;}if(data==='EOD')break;}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function dif_to_sheet(str,opts){return aoa_to_sheet(dif_to_aoa(str,opts),opts);}function dif_to_workbook(str,opts){return sheet_to_workbook(dif_to_sheet(str,opts),opts);}var sheet_to_dif=function(){var push_field=function pf(o,topic,v,n,s){o.push(topic);o.push(v+","+n);o.push('"'+s.replace(/"/g,'""')+'"');};var push_value=function po(o,type,v,s){o.push(type+","+v);o.push(type==1?'"'+s.replace(/"/g,'""')+'"':s);};return function sheet_to_dif(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);push_field(o,"TABLE",0,1,"sheetjs");push_field(o,"VECTORS",0,r.e.r-r.s.r+1,"");push_field(o,"TUPLES",0,r.e.c-r.s.c+1,"");push_field(o,"DATA",0,0,"");for(var R=r.s.r;R<=r.e.r;++R){push_value(o,-1,0,"BOT");for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell){push_value(o,1,0,"");continue;}switch(cell.t){case'n':var val=DIF_XL?cell.w:cell.v;if(!val&&cell.v!=null)val=cell.v;if(val==null){if(DIF_XL&&cell.f&&!cell.F)push_value(o,1,0,"="+cell.f);else push_value(o,1,0,"");}else push_value(o,0,val,"V");break;case'b':push_value(o,0,cell.v?1:0,cell.v?"TRUE":"FALSE");break;case's':push_value(o,1,0,!DIF_XL||isNaN(cell.v)?cell.v:'="'+cell.v+'"');break;case'd':if(!cell.w)cell.w=SSF.format(cell.z||SSF._table[14],datenum(parseDate(cell.v)));if(DIF_XL)push_value(o,0,cell.w,"V");else push_value(o,1,0,cell.w);break;default:push_value(o,1,0,"");}}}push_value(o,-1,0,"EOD");var RS="\r\n";var oo=o.join(RS);//while((oo.length & 0x7F) != 0) oo += "\0";
return oo;};}();return{to_workbook:dif_to_workbook,to_sheet:dif_to_sheet,from_sheet:sheet_to_dif};}();var ETH=function(){function decode(s){return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");}function encode(s){return s.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n");}function eth_to_aoa(str,opts){var records=str.split('\n'),R=-1,C=-1,ri=0,arr=[];for(;ri!==records.length;++ri){var record=records[ri].trim().split(":");if(record[0]!=='cell')continue;var addr=decode_cell(record[1]);if(arr.length<=addr.r)for(R=arr.length;R<=addr.r;++R)if(!arr[R])arr[R]=[];R=addr.r;C=addr.c;switch(record[2]){case't':arr[R][C]=decode(record[3]);break;case'v':arr[R][C]=+record[3];break;case'vtf':var _f=record[record.length-1];/* falls through */case'vtc':switch(record[3]){case'nl':arr[R][C]=+record[4]?true:false;break;default:arr[R][C]=+record[4];break;}if(record[2]=='vtf')arr[R][C]=[arr[R][C],_f];}}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function eth_to_sheet(d,opts){return aoa_to_sheet(eth_to_aoa(d,opts),opts);}function eth_to_workbook(d,opts){return sheet_to_workbook(eth_to_sheet(d,opts),opts);}var header=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var sep=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";/* TODO: the other parts */var meta=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var end="--SocialCalcSpreadsheetControlSave--";function sheet_to_eth_data(ws){if(!ws||!ws['!ref'])return"";var o=[],oo=[],cell,coord="";var r=decode_range(ws['!ref']);var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null||cell.t==='z')continue;oo=["cell",coord,'t'];switch(cell.t){case's':case'str':oo.push(encode(cell.v));break;case'n':if(!cell.f){oo[2]='v';oo[3]=cell.v;}else{oo[2]='vtf';oo[3]='n';oo[4]=cell.v;oo[5]=encode(cell.f);}break;case'b':oo[2]='vt'+(cell.f?'f':'c');oo[3]='nl';oo[4]=cell.v?"1":"0";oo[5]=encode(cell.f||(cell.v?'TRUE':'FALSE'));break;case'd':var t=datenum(parseDate(cell.v));oo[2]='vtc';oo[3]='nd';oo[4]=""+t;oo[5]=cell.w||SSF.format(cell.z||SSF._table[14],t);break;case'e':continue;}o.push(oo.join(":"));}}o.push("sheet:c:"+(r.e.c-r.s.c+1)+":r:"+(r.e.r-r.s.r+1)+":tvf:1");o.push("valueformat:1:text-wiki");//o.push("copiedfrom:" + ws['!ref']); // clipboard only
return o.join("\n");}function sheet_to_eth(ws){return[header,sep,meta,sep,sheet_to_eth_data(ws),end].join("\n");// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
}return{to_workbook:eth_to_workbook,to_sheet:eth_to_sheet,from_sheet:sheet_to_eth};}();var PRN=function(){function set_text_arr(data,arr,R,C,o){if(o.raw)arr[R][C]=data;else if(data===""){/* empty */}else if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(data)))arr[R][C]=fuzzynum(data);else if(!isNaN(fuzzydate(data).getDate()))arr[R][C]=parseDate(data);else arr[R][C]=data;}function prn_to_aoa_str(f,opts){var o=opts||{};var arr=[];if(!f||f.length===0)return arr;var lines=f.split(/[\r\n]/);var L=lines.length-1;while(L>=0&&lines[L].length===0)--L;var start=10,idx=0;var R=0;for(;R<=L;++R){idx=lines[R].indexOf(" ");if(idx==-1)idx=lines[R].length;else idx++;start=Math.max(start,idx);}for(R=0;R<=L;++R){arr[R]=[];/* TODO: confirm that widths are always 10 */var C=0;set_text_arr(lines[R].slice(0,start).trim(),arr,R,C,o);for(C=1;C<=(lines[R].length-start)/10+1;++C)set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);}if(o.sheetRows)arr=arr.slice(0,o.sheetRows);return arr;}// List of accepted CSV separators
var guess_seps={0x2C:',',0x09:"\t",0x3B:';',0x7C:'|'};// CSV separator weights to be used in case of equal numbers
var guess_sep_weights={0x2C:3,0x09:2,0x3B:1,0x7C:0};function guess_sep(str){var cnt={},instr=false,end=0,cc=0;for(;end<str.length;++end){if((cc=str.charCodeAt(end))==0x22)instr=!instr;else if(!instr&&cc in guess_seps)cnt[cc]=(cnt[cc]||0)+1;}cc=[];for(end in cnt)if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}if(!cc.length){cnt=guess_sep_weights;for(end in cnt)if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}cc.sort(function(a,b){return a[0]-b[0]||guess_sep_weights[a[1]]-guess_sep_weights[b[1]];});return guess_seps[cc.pop()[1]]||0x2C;}function dsv_to_sheet_str(str,opts){var o=opts||{};var sep="";if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ws=o.dense?[]:{};var range={s:{c:0,r:0},e:{c:0,r:0}};if(str.slice(0,4)=="sep="){// If the line ends in \r\n
if(str.charCodeAt(5)==13&&str.charCodeAt(6)==10){sep=str.charAt(4);str=str.slice(7);}// If line ends in \r OR \n
else if(str.charCodeAt(5)==13||str.charCodeAt(5)==10){sep=str.charAt(4);str=str.slice(6);}else sep=guess_sep(str.slice(0,1024));}else if(o&&o.FS)sep=o.FS;else sep=guess_sep(str.slice(0,1024));var R=0,C=0,v=0;var start=0,end=0,sepcc=sep.charCodeAt(0),instr=false,cc=0,startcc=str.charCodeAt(0);str=str.replace(/\r\n/mg,"\n");var _re=o.dateNF!=null?dateNF_regex(o.dateNF):null;function finish_cell(){var s=str.slice(start,end);var cell={};if(s.charAt(0)=='"'&&s.charAt(s.length-1)=='"')s=s.slice(1,-1).replace(/""/g,'"');if(s.length===0)cell.t='z';else if(o.raw){cell.t='s';cell.v=s;}else if(s.trim().length===0){cell.t='s';cell.v=s;}else if(s.charCodeAt(0)==0x3D){if(s.charCodeAt(1)==0x22&&s.charCodeAt(s.length-1)==0x22){cell.t='s';cell.v=s.slice(2,-1).replace(/""/g,'"');}else if(fuzzyfmla(s)){cell.t='n';cell.f=s.slice(1);}else{cell.t='s';cell.v=s;}}else if(s=="TRUE"){cell.t='b';cell.v=true;}else if(s=="FALSE"){cell.t='b';cell.v=false;}else if(!isNaN(v=fuzzynum(s))){cell.t='n';if(o.cellText!==false)cell.w=s;cell.v=v;}else if(!isNaN(fuzzydate(s).getDate())||_re&&s.match(_re)){cell.z=o.dateNF||SSF._table[14];var k=0;if(_re&&s.match(_re)){s=dateNF_fix(s,o.dateNF,s.match(_re)||[]);k=1;}if(o.cellDates){cell.t='d';cell.v=parseDate(s,k);}else{cell.t='n';cell.v=datenum(parseDate(s,k));}if(o.cellText!==false)cell.w=SSF.format(cell.z,cell.v instanceof Date?datenum(cell.v):cell.v);if(!o.cellNF)delete cell.z;}else{cell.t='s';cell.v=s;}if(cell.t=='z'){}else if(o.dense){if(!ws[R])ws[R]=[];ws[R][C]=cell;}else ws[encode_cell({c:C,r:R})]=cell;start=end+1;startcc=str.charCodeAt(start);if(range.e.c<C)range.e.c=C;if(range.e.r<R)range.e.r=R;if(cc==sepcc)++C;else{C=0;++R;if(o.sheetRows&&o.sheetRows<=R)return true;}}outer:for(;end<str.length;++end)switch(cc=str.charCodeAt(end)){case 0x22:if(startcc===0x22)instr=!instr;break;case sepcc:case 0x0a:case 0x0d:if(!instr&&finish_cell())break outer;break;default:break;}if(end-start>0)finish_cell();ws['!ref']=encode_range(range);return ws;}function prn_to_sheet_str(str,opts){if(!(opts&&opts.PRN))return dsv_to_sheet_str(str,opts);if(opts.FS)return dsv_to_sheet_str(str,opts);if(str.slice(0,4)=="sep=")return dsv_to_sheet_str(str,opts);if(str.indexOf("\t")>=0||str.indexOf(",")>=0||str.indexOf(";")>=0)return dsv_to_sheet_str(str,opts);return aoa_to_sheet(prn_to_aoa_str(str,opts),opts);}function prn_to_sheet(d,opts){var str="",bytes=opts.type=='string'?[0,0,0,0]:firstbyte(d,opts);switch(opts.type){case'base64':str=Base64.decode(d);break;case'binary':str=d;break;case'buffer':if(opts.codepage==65001)str=d.toString('utf8');// TODO: test if buf
else if(opts.codepage&&typeof cptable!=='undefined')str=cptable.utils.decode(opts.codepage,d);else str=has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d);break;case'array':str=cc2str(d);break;case'string':str=d;break;default:throw new Error("Unrecognized type "+opts.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str.slice(3));else if(opts.type!='string'&&opts.codepage==65001)str=utf8read(str);else if(opts.type=='binary'&&typeof cptable!=='undefined'&&opts.codepage)str=cptable.utils.decode(opts.codepage,cptable.utils.encode(28591,str));if(str.slice(0,19)=="socialcalc:version:")return ETH.to_sheet(opts.type=='string'?str:utf8read(str),opts);return prn_to_sheet_str(str,opts);}function prn_to_workbook(d,opts){return sheet_to_workbook(prn_to_sheet(d,opts),opts);}function sheet_to_prn(ws){var o=[];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null){oo.push("          ");continue;}var w=(cell.w||(format_cell(cell),cell.w)||"").slice(0,10);while(w.length<10)w+=" ";oo.push(w+(C===0?" ":""));}o.push(oo.join(""));}return o.join("\n");}return{to_workbook:prn_to_workbook,to_sheet:prn_to_sheet,from_sheet:sheet_to_prn};}();/* Excel defaults to SYLK but warns if data is not valid */function read_wb_ID(d,opts){var o=opts||{},OLD_WTF=!!o.WTF;o.WTF=true;try{var out=SYLK.to_workbook(d,o);o.WTF=OLD_WTF;return out;}catch(e){o.WTF=OLD_WTF;if(!e.message.match(/SYLK bad record ID/)&&OLD_WTF)throw e;return PRN.to_workbook(d,opts);}}var WK_=function(){function lotushopper(data,cb,opts){if(!data)return;prep_blob(data,data.l||0);var Enum=opts.Enum||WK1Enum;while(data.l<data.length){var RT=data.read_shift(2);var R=Enum[RT]||Enum[0xFFFF];var length=data.read_shift(2);var tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R,RT))return;}}function lotus_to_workbook(d,opts){switch(opts.type){case'base64':return lotus_to_workbook_buf(s2a(Base64.decode(d)),opts);case'binary':return lotus_to_workbook_buf(s2a(d),opts);case'buffer':case'array':return lotus_to_workbook_buf(d,opts);}throw"Unsupported type "+opts.type;}function lotus_to_workbook_buf(d,opts){if(!d)return d;var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var s=o.dense?[]:{},n="Sheet1",next_n="",sidx=0;var sheets={},snames=[],realnames=[];var refguess={s:{r:0,c:0},e:{r:0,c:0}};var sheetRows=o.sheetRows||0;if(d[2]==0x00){if(d[3]==0x08||d[3]==0x09){if(d.length>=16&&d[14]==0x05&&d[15]===0x6c)throw new Error("Unsupported Works 3 for Mac file");}}if(d[2]==0x02){o.Enum=WK1Enum;lotushopper(d,function(val,R,RT){switch(RT){case 0x00:/* BOF */o.vers=val;if(val>=0x1000)o.qpro=true;break;case 0x06:refguess=val;break;/* RANGE */case 0xCC:if(val)next_n=val;break;/* SHEETNAMECS */case 0xDE:next_n=val;break;/* SHEETNAMELP */case 0x0F:/* LABEL */case 0x33:/* STRING */if(!o.qpro)val[1].v=val[1].v.slice(1);/* falls through */case 0x0D:/* INTEGER */case 0x0E:/* NUMBER */case 0x10:/* FORMULA */ /* TODO: actual translation of the format code */if(RT==0x0E&&(val[2]&0x70)==0x70&&(val[2]&0x0F)>1&&(val[2]&0x0F)<15){val[1].z=o.dateNF||SSF._table[14];if(o.cellDates){val[1].t='d';val[1].v=numdate(val[1].v);}}if(o.qpro){if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n=next_n||"Sheet"+(sidx+1);next_n="";}}var tmpcell=o.dense?(s[val[0].r]||[])[val[0].c]:s[encode_cell(val[0])];if(tmpcell){tmpcell.t=val[1].t;tmpcell.v=val[1].v;if(val[1].z!=null)tmpcell.z=val[1].z;if(val[1].f!=null)tmpcell.f=val[1].f;break;}if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];break;default:}},o);}else if(d[2]==0x1A||d[2]==0x0E){o.Enum=WK3Enum;if(d[2]==0x0E){o.qpro=true;d.l=0;}lotushopper(d,function(val,R,RT){switch(RT){case 0xCC:n=val;break;/* SHEETNAMECS */case 0x16:/* LABEL16 */val[1].v=val[1].v.slice(1);/* falls through */case 0x17:/* NUMBER17 */case 0x18:/* NUMBER18 */case 0x19:/* FORMULA19 */case 0x25:/* NUMBER25 */case 0x27:/* NUMBER27 */case 0x28:/* FORMULA28 */if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n="Sheet"+(sidx+1);}if(sheetRows>0&&val[0].r>=sheetRows)break;if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];if(refguess.e.c<val[0].c)refguess.e.c=val[0].c;if(refguess.e.r<val[0].r)refguess.e.r=val[0].r;break;case 0x1B:/* XFORMAT */if(val[0x36b0])realnames[val[0x36b0][0]]=val[0x36b0][1];break;case 0x0601:/* SHEETINFOQP */realnames[val[0]]=val[1];if(val[0]==sidx)n=val[1];break;default:break;}},o);}else throw new Error("Unrecognized LOTUS BOF "+d[2]);s["!ref"]=encode_range(refguess);sheets[next_n||n]=s;snames.push(next_n||n);if(!realnames.length)return{SheetNames:snames,Sheets:sheets};var osheets={},rnames=[];/* TODO: verify no collisions */for(var i=0;i<realnames.length;++i)if(sheets[snames[i]]){rnames.push(realnames[i]||snames[i]);osheets[realnames[i]]=sheets[realnames[i]]||sheets[snames[i]];}else{rnames.push(realnames[i]);osheets[realnames[i]]={"!ref":"A1"};}return{SheetNames:rnames,Sheets:osheets};}function sheet_to_wk1(ws,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK1 to JS string");var ba=buf_array();var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];write_biff_rec(ba,0x00,write_BOF_WK1(0x0406));write_biff_rec(ba,0x06,write_RANGE(range));var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;/* TODO: formula records */if(cell.t=="n"){if((cell.v|0)==cell.v&&cell.v>=-32768&&cell.v<=32767)write_biff_rec(ba,0x0d,write_INTEGER(R,C,cell.v));else write_biff_rec(ba,0x0e,write_NUMBER(R,C,cell.v));}else{var str=format_cell(cell);write_biff_rec(ba,0x0F,write_LABEL(R,C,str.slice(0,239)));}}}write_biff_rec(ba,0x01);return ba.end();}function book_to_wk3(wb,opts){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK3 to JS string");var ba=buf_array();write_biff_rec(ba,0x00,write_BOF_WK3(wb));for(var i=0,cnt=0;i<wb.SheetNames.length;++i)if((wb.Sheets[wb.SheetNames[i]]||{})["!ref"])write_biff_rec(ba,0x1b,write_XFORMAT_SHEETNAME(wb.SheetNames[i],cnt++));var wsidx=0;for(i=0;i<wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;/* TODO: FORMULA19 NUMBER18 records */if(cell.t=="n"){write_biff_rec(ba,0x17,write_NUMBER_17(R,C,wsidx,cell.v));}else{var str=format_cell(cell);/* TODO: max len? */write_biff_rec(ba,0x16,write_LABEL_16(R,C,wsidx,str.slice(0,239)));}}}++wsidx;}write_biff_rec(ba,0x01);return ba.end();}function write_BOF_WK1(v){var out=new_buf(2);out.write_shift(2,v);return out;}function write_BOF_WK3(wb){var out=new_buf(26);out.write_shift(2,0x1000);out.write_shift(2,0x0004);out.write_shift(4,0x0000);var rows=0,cols=0,wscnt=0;for(var i=0;i<wb.SheetNames.length;++i){var name=wb.SheetNames[i];var ws=wb.Sheets[name];if(!ws||!ws["!ref"])continue;++wscnt;var range=decode_range(ws["!ref"]);if(rows<range.e.r)rows=range.e.r;if(cols<range.e.c)cols=range.e.c;}if(rows>8191)rows=8191;out.write_shift(2,rows);out.write_shift(1,wscnt);out.write_shift(1,cols);out.write_shift(2,0x00);out.write_shift(2,0x00);out.write_shift(1,0x01);out.write_shift(1,0x02);out.write_shift(4,0);out.write_shift(4,0);return out;}function parse_RANGE(blob,length,opts){var o={s:{c:0,r:0},e:{c:0,r:0}};if(length==8&&opts.qpro){o.s.c=blob.read_shift(1);blob.l++;o.s.r=blob.read_shift(2);o.e.c=blob.read_shift(1);blob.l++;o.e.r=blob.read_shift(2);return o;}o.s.c=blob.read_shift(2);o.s.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;o.e.c=blob.read_shift(2);o.e.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;if(o.s.c==0xFFFF)o.s.c=o.e.c=o.s.r=o.e.r=0;return o;}function write_RANGE(range){var out=new_buf(8);out.write_shift(2,range.s.c);out.write_shift(2,range.s.r);out.write_shift(2,range.e.c);out.write_shift(2,range.e.r);return out;}function parse_cell(blob,length,opts){var o=[{c:0,r:0},{t:'n',v:0},0,0];if(opts.qpro&&opts.vers!=0x5120){o[0].c=blob.read_shift(1);o[3]=blob.read_shift(1);o[0].r=blob.read_shift(2);blob.l+=2;}else{o[2]=blob.read_shift(1);o[0].c=blob.read_shift(2);o[0].r=blob.read_shift(2);}return o;}function parse_LABEL(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);o[1].t='s';if(opts.vers==0x5120){blob.l++;var len=blob.read_shift(1);o[1].v=blob.read_shift(len,'utf8');return o;}if(opts.qpro)blob.l++;o[1].v=blob.read_shift(tgt-blob.l,'cstr');return o;}function write_LABEL(R,C,s){/* TODO: encoding */var o=new_buf(7+s.length);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(1,0x27);// ??
for(var i=0;i<o.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_INTEGER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(2,'i');return o;}function write_INTEGER(R,C,v){var o=new_buf(7);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(2,v,'i');return o;}function parse_NUMBER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(8,'f');return o;}function write_NUMBER(R,C,v){var o=new_buf(13);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(8,v,'f');return o;}function parse_FORMULA(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);/* TODO: formula */o[1].v=blob.read_shift(8,'f');if(opts.qpro)blob.l=tgt;else{var flen=blob.read_shift(2);wk1_fmla_to_csf(blob.slice(blob.l,blob.l+flen),o);blob.l+=flen;}return o;}function wk1_parse_rc(B,V,col){var rel=V&0x8000;V&=~0x8000;V=(rel?B:0)+(V>=0x2000?V-0x4000:V);return(rel?"":"$")+(col?encode_col(V):encode_row(V));}var oprec=[8,8,8,8,8,8,8,8,6,4,4,5,5,7,3,3,3,3,3,3,1,1,2,6,8,8,8,8,8,8,8,8];/* TODO: flesh out */var FuncTab={0x33:["FALSE",0],0x34:["TRUE",0],0x46:["LEN",1],0x50:["SUM",69],0x51:["AVERAGEA",69],0x52:["COUNTA",69],0x53:["MINA",69],0x54:["MAXA",69],0x6F:["T",1]};var BinOpTab=["","","","","","","","","","+","-","*","/","^","=","<>","<=",">=","<",">","","","","","&","","","","","","",""];function wk1_fmla_to_csf(blob,o){prep_blob(blob,0);var out=[],argc=0,R="",C="",argL="",argR="";while(blob.l<blob.length){var cc=blob[blob.l++];switch(cc){case 0x00:out.push(blob.read_shift(8,'f'));break;case 0x01:{C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(C+R);}break;case 0x02:{var c=wk1_parse_rc(o[0].c,blob.read_shift(2),true);var r=wk1_parse_rc(o[0].r,blob.read_shift(2),false);C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(c+r+":"+C+R);}break;case 0x03:if(blob.l<blob.length){console.error("WK1 premature formula end");return;}break;case 0x04:out.push("("+out.pop()+")");break;case 0x05:out.push(blob.read_shift(2));break;case 0x06:{/* TODO: text encoding */var Z="";while(cc=blob[blob.l++])Z+=String.fromCharCode(cc);out.push('"'+Z.replace(/"/g,'""')+'"');break;}break;case 0x08:out.push("-"+out.pop());break;case 0x17:out.push("+"+out.pop());break;case 0x16:out.push("NOT("+out.pop()+")");break;case 0x14:case 0x15:{argR=out.pop();argL=out.pop();out.push(["AND","OR"][cc-0x14]+"("+argL+","+argR+")");}break;default:if(cc<0x20&&BinOpTab[cc]){argR=out.pop();argL=out.pop();out.push(argL+BinOpTab[cc]+argR);}else if(FuncTab[cc]){argc=FuncTab[cc][1];if(argc==69)argc=blob[blob.l++];if(argc>out.length){console.error("WK1 bad formula parse 0x"+cc.toString(16)+":|"+out.join("|")+"|");return;}var args=out.slice(-argc);out.length-=argc;out.push(FuncTab[cc][0]+"("+args.join(",")+")");}else if(cc<=0x07)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x18)return console.error("WK1 unsupported op "+cc.toString(16));else if(cc<=0x1E)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x73)return console.error("WK1 unsupported function opcode "+cc.toString(16));// possible future functions ??
else return console.error("WK1 unrecognized opcode "+cc.toString(16));}}if(out.length==1)o[1].f=""+out[0];else console.error("WK1 bad formula parse |"+out.join("|")+"|");}function parse_cell_3(blob){var o=[{c:0,r:0},{t:'n',v:0},0];o[0].r=blob.read_shift(2);o[3]=blob[blob.l++];o[0].c=blob[blob.l++];return o;}function parse_LABEL_16(blob,length){var o=parse_cell_3(blob,length);o[1].t='s';o[1].v=blob.read_shift(length-4,'cstr');return o;}function write_LABEL_16(R,C,wsidx,s){/* TODO: encoding */var o=new_buf(6+s.length);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);o.write_shift(1,0x27);for(var i=0;i<s.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_NUMBER_18(blob,length){var o=parse_cell_3(blob,length);o[1].v=blob.read_shift(2);var v=o[1].v>>1;if(o[1].v&0x1){switch(v&0x07){case 0:v=(v>>3)*5000;break;case 1:v=(v>>3)*500;break;case 2:v=(v>>3)/20;break;case 3:v=(v>>3)/200;break;case 4:v=(v>>3)/2000;break;case 5:v=(v>>3)/20000;break;case 6:v=(v>>3)/16;break;case 7:v=(v>>3)/64;break;}}o[1].v=v;return o;}function parse_NUMBER_17(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);var v2=blob.read_shift(4);var e=blob.read_shift(2);if(e==0xFFFF){if(v1===0&&v2===0xC0000000){o[1].t="e";o[1].v=0x0F;}// ERR -> #VALUE!
else if(v1===0&&v2===0xD0000000){o[1].t="e";o[1].v=0x2A;}// NA -> #N/A
else o[1].v=0;return o;}var s=e&0x8000;e=(e&0x7FFF)-16446;o[1].v=(1-s*2)*(v2*Math.pow(2,e+32)+v1*Math.pow(2,e));return o;}function write_NUMBER_17(R,C,wsidx,v){var o=new_buf(14);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);if(v==0){o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,0xFFFF);return o;}var s=0,e=0,v1=0,v2=0;if(v<0){s=1;v=-v;}e=Math.log2(v)|0;v/=Math.pow(2,e-31);v2=v>>>0;if((v2&0x80000000)==0){v/=2;++e;v2=v>>>0;}v-=v2;v2|=0x80000000;v2>>>=0;v*=Math.pow(2,32);v1=v>>>0;o.write_shift(4,v1);o.write_shift(4,v2);e+=0x3FFF+(s?0x8000:0);o.write_shift(2,e);return o;}function parse_FORMULA_19(blob,length){var o=parse_NUMBER_17(blob,14);blob.l+=length-14;/* TODO: WK3 formula */return o;}function parse_NUMBER_25(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);o[1].v=v1>>6;return o;}function parse_NUMBER_27(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(8,'f');o[1].v=v1;return o;}function parse_FORMULA_28(blob,length){var o=parse_NUMBER_27(blob,14);blob.l+=length-10;/* TODO: formula */return o;}function parse_SHEETNAMECS(blob,length){return blob[blob.l+length-1]==0?blob.read_shift(length,'cstr'):"";}function parse_SHEETNAMELP(blob,length){var len=blob[blob.l++];if(len>length-1)len=length-1;var o="";while(o.length<len)o+=String.fromCharCode(blob[blob.l++]);return o;}function parse_SHEETINFOQP(blob,length,opts){if(!opts.qpro||length<21)return;var id=blob.read_shift(1);blob.l+=17;var len=blob.read_shift(1);blob.l+=2;var nm=blob.read_shift(length-21,'cstr');return[id,nm];}function parse_XFORMAT(blob,length){var o={},tgt=blob.l+length;while(blob.l<tgt){var dt=blob.read_shift(2);if(dt==0x36b0){o[dt]=[0,""];o[dt][0]=blob.read_shift(2);while(blob[blob.l]){o[dt][1]+=String.fromCharCode(blob[blob.l]);blob.l++;}blob.l++;}// TODO: 0x3a99 ??
}return o;}function write_XFORMAT_SHEETNAME(name,wsidx){var out=new_buf(5+name.length);out.write_shift(2,0x36b0);out.write_shift(2,wsidx);for(var i=0;i<name.length;++i){var cc=name.charCodeAt(i);out[out.l++]=cc>0x7F?0x5F:cc;}out[out.l++]=0;return out;}var WK1Enum={0x0000:{n:"BOF",f:parseuint16},0x0001:{n:"EOF"},0x0002:{n:"CALCMODE"},0x0003:{n:"CALCORDER"},0x0004:{n:"SPLIT"},0x0005:{n:"SYNC"},0x0006:{n:"RANGE",f:parse_RANGE},0x0007:{n:"WINDOW1"},0x0008:{n:"COLW1"},0x0009:{n:"WINTWO"},0x000A:{n:"COLW2"},0x000B:{n:"NAME"},0x000C:{n:"BLANK"},0x000D:{n:"INTEGER",f:parse_INTEGER},0x000E:{n:"NUMBER",f:parse_NUMBER},0x000F:{n:"LABEL",f:parse_LABEL},0x0010:{n:"FORMULA",f:parse_FORMULA},0x0018:{n:"TABLE"},0x0019:{n:"ORANGE"},0x001A:{n:"PRANGE"},0x001B:{n:"SRANGE"},0x001C:{n:"FRANGE"},0x001D:{n:"KRANGE1"},0x0020:{n:"HRANGE"},0x0023:{n:"KRANGE2"},0x0024:{n:"PROTEC"},0x0025:{n:"FOOTER"},0x0026:{n:"HEADER"},0x0027:{n:"SETUP"},0x0028:{n:"MARGINS"},0x0029:{n:"LABELFMT"},0x002A:{n:"TITLES"},0x002B:{n:"SHEETJS"},0x002D:{n:"GRAPH"},0x002E:{n:"NGRAPH"},0x002F:{n:"CALCCOUNT"},0x0030:{n:"UNFORMATTED"},0x0031:{n:"CURSORW12"},0x0032:{n:"WINDOW"},0x0033:{n:"STRING",f:parse_LABEL},0x0037:{n:"PASSWORD"},0x0038:{n:"LOCKED"},0x003C:{n:"QUERY"},0x003D:{n:"QUERYNAME"},0x003E:{n:"PRINT"},0x003F:{n:"PRINTNAME"},0x0040:{n:"GRAPH2"},0x0041:{n:"GRAPHNAME"},0x0042:{n:"ZOOM"},0x0043:{n:"SYMSPLIT"},0x0044:{n:"NSROWS"},0x0045:{n:"NSCOLS"},0x0046:{n:"RULER"},0x0047:{n:"NNAME"},0x0048:{n:"ACOMM"},0x0049:{n:"AMACRO"},0x004A:{n:"PARSE"},0x0066:{n:"PRANGES??"},0x0067:{n:"RRANGES??"},0x0068:{n:"FNAME??"},0x0069:{n:"MRANGES??"},0x00CC:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},0x00DE:{n:"SHEETNAMELP",f:parse_SHEETNAMELP},0xFFFF:{n:""}};var WK3Enum={0x0000:{n:"BOF"},0x0001:{n:"EOF"},0x0002:{n:"PASSWORD"},0x0003:{n:"CALCSET"},0x0004:{n:"WINDOWSET"},0x0005:{n:"SHEETCELLPTR"},0x0006:{n:"SHEETLAYOUT"},0x0007:{n:"COLUMNWIDTH"},0x0008:{n:"HIDDENCOLUMN"},0x0009:{n:"USERRANGE"},0x000A:{n:"SYSTEMRANGE"},0x000B:{n:"ZEROFORCE"},0x000C:{n:"SORTKEYDIR"},0x000D:{n:"FILESEAL"},0x000E:{n:"DATAFILLNUMS"},0x000F:{n:"PRINTMAIN"},0x0010:{n:"PRINTSTRING"},0x0011:{n:"GRAPHMAIN"},0x0012:{n:"GRAPHSTRING"},0x0013:{n:"??"},0x0014:{n:"ERRCELL"},0x0015:{n:"NACELL"},0x0016:{n:"LABEL16",f:parse_LABEL_16},0x0017:{n:"NUMBER17",f:parse_NUMBER_17},0x0018:{n:"NUMBER18",f:parse_NUMBER_18},0x0019:{n:"FORMULA19",f:parse_FORMULA_19},0x001A:{n:"FORMULA1A"},0x001B:{n:"XFORMAT",f:parse_XFORMAT},0x001C:{n:"DTLABELMISC"},0x001D:{n:"DTLABELCELL"},0x001E:{n:"GRAPHWINDOW"},0x001F:{n:"CPA"},0x0020:{n:"LPLAUTO"},0x0021:{n:"QUERY"},0x0022:{n:"HIDDENSHEET"},0x0023:{n:"??"},0x0025:{n:"NUMBER25",f:parse_NUMBER_25},0x0026:{n:"??"},0x0027:{n:"NUMBER27",f:parse_NUMBER_27},0x0028:{n:"FORMULA28",f:parse_FORMULA_28},0x008E:{n:"??"},0x0093:{n:"??"},0x0096:{n:"??"},0x0097:{n:"??"},0x0098:{n:"??"},0x0099:{n:"??"},0x009A:{n:"??"},0x009B:{n:"??"},0x009C:{n:"??"},0x00A3:{n:"??"},0x00AE:{n:"??"},0x00AF:{n:"??"},0x00B0:{n:"??"},0x00B1:{n:"??"},0x00B8:{n:"??"},0x00B9:{n:"??"},0x00BA:{n:"??"},0x00BB:{n:"??"},0x00BC:{n:"??"},0x00C3:{n:"??"},0x00C9:{n:"??"},0x00CC:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},0x00CD:{n:"??"},0x00CE:{n:"??"},0x00CF:{n:"??"},0x00D0:{n:"??"},0x0100:{n:"??"},0x0103:{n:"??"},0x0104:{n:"??"},0x0105:{n:"??"},0x0106:{n:"??"},0x0107:{n:"??"},0x0109:{n:"??"},0x010A:{n:"??"},0x010B:{n:"??"},0x010C:{n:"??"},0x010E:{n:"??"},0x010F:{n:"??"},0x0180:{n:"??"},0x0185:{n:"??"},0x0186:{n:"??"},0x0189:{n:"??"},0x018C:{n:"??"},0x0200:{n:"??"},0x0202:{n:"??"},0x0201:{n:"??"},0x0204:{n:"??"},0x0205:{n:"??"},0x0280:{n:"??"},0x0281:{n:"??"},0x0282:{n:"??"},0x0283:{n:"??"},0x0284:{n:"??"},0x0285:{n:"??"},0x0286:{n:"??"},0x0287:{n:"??"},0x0288:{n:"??"},0x0292:{n:"??"},0x0293:{n:"??"},0x0294:{n:"??"},0x0295:{n:"??"},0x0296:{n:"??"},0x0299:{n:"??"},0x029A:{n:"??"},0x0300:{n:"??"},0x0304:{n:"??"},0x0601:{n:"SHEETINFOQP",f:parse_SHEETINFOQP},0x0640:{n:"??"},0x0642:{n:"??"},0x0701:{n:"??"},0x0702:{n:"??"},0x0703:{n:"??"},0x0704:{n:"??"},0x0780:{n:"??"},0x0800:{n:"??"},0x0801:{n:"??"},0x0804:{n:"??"},0x0A80:{n:"??"},0x2AF6:{n:"??"},0x3231:{n:"??"},0x6E49:{n:"??"},0x6F44:{n:"??"},0xFFFF:{n:""}};return{sheet_to_wk1:sheet_to_wk1,book_to_wk3:book_to_wk3,to_workbook:lotus_to_workbook};}();/* 18.4.7 rPr CT_RPrElt */function parse_rpr(rpr){var font={},m=rpr.match(tagregex),i=0;var pass=false;if(m)for(;i!=m.length;++i){var y=parsexmltag(m[i]);switch(y[0].replace(/\w*:/g,"")){/* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */case'<condense':break;/* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */case'<extend':break;/* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */case'<shadow':if(!y.val)break;/* falls through */case'<shadow>':case'<shadow/>':font.shadow=1;break;case'</shadow>':break;/* 18.4.1 charset CT_IntProperty TODO */case'<charset':if(y.val=='1')break;font.cp=CS2CP[parseInt(y.val,10)];break;/* 18.4.2 outline CT_BooleanProperty TODO */case'<outline':if(!y.val)break;/* falls through */case'<outline>':case'<outline/>':font.outline=1;break;case'</outline>':break;/* 18.4.5 rFont CT_FontName */case'<rFont':font.name=y.val;break;/* 18.4.11 sz CT_FontSize */case'<sz':font.sz=y.val;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':if(!y.val)break;/* falls through */case'<strike>':case'<strike/>':font.strike=1;break;case'</strike>':break;/* 18.4.13 u CT_UnderlineProperty */case'<u':if(!y.val)break;switch(y.val){case'double':font.uval="double";break;case'singleAccounting':font.uval="single-accounting";break;case'doubleAccounting':font.uval="double-accounting";break;}/* falls through */case'<u>':case'<u/>':font.u=1;break;case'</u>':break;/* 18.8.2 b */case'<b':if(y.val=='0')break;/* falls through */case'<b>':case'<b/>':font.b=1;break;case'</b>':break;/* 18.8.26 i */case'<i':if(y.val=='0')break;/* falls through */case'<i>':case'<i/>':font.i=1;break;case'</i>':break;/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */case'<color':if(y.rgb)font.color=y.rgb.slice(2,8);break;/* 18.8.18 family ST_FontFamily */case'<family':font.family=y.val;break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */case'<vertAlign':font.valign=y.val;break;/* 18.8.35 scheme CT_FontScheme TODO */case'<scheme':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(y[0].charCodeAt(1)!==47&&!pass)throw new Error('Unrecognized rich format '+y[0]);}}return font;}var parse_rs=function(){var tregex=matchtag("t"),rpregex=matchtag("rPr");/* 18.4.4 r CT_RElt */function parse_r(r){/* 18.4.12 t ST_Xstring */var t=r.match(tregex)/*, cp = 65001*/;if(!t)return{t:"s",v:""};var o={t:'s',v:unescapexml(t[1])};var rpr=r.match(rpregex);if(rpr)o.s=parse_rpr(rpr[1]);return o;}var rregex=/<(?:\w+:)?r>/g,rend=/<\/(?:\w+:)?r>/;return function parse_rs(rs){return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r){return r.v;});};}();/* Parse a list of <r> tags */var rs_to_html=function parse_rs_factory(){var nlregex=/(\r\n|\n)/g;function parse_rpr2(font,intro,outro){var style=[];if(font.u)style.push("text-decoration: underline;");if(font.uval)style.push("text-underline-style:"+font.uval+";");if(font.sz)style.push("font-size:"+font.sz+"pt;");if(font.outline)style.push("text-effect: outline;");if(font.shadow)style.push("text-shadow: auto;");intro.push('<span style="'+style.join("")+'">');if(font.b){intro.push("<b>");outro.push("</b>");}if(font.i){intro.push("<i>");outro.push("</i>");}if(font.strike){intro.push("<s>");outro.push("</s>");}var align=font.valign||"";if(align=="superscript"||align=="super")align="sup";else if(align=="subscript")align="sub";if(align!=""){intro.push("<"+align+">");outro.push("</"+align+">");}outro.push("</span>");return font;}/* 18.4.4 r CT_RElt */function r_to_html(r){var terms=[[],r.v,[]];if(!r.v)return"";if(r.s)parse_rpr2(r.s,terms[0],terms[2]);return terms[0].join("")+terms[1].replace(nlregex,'<br/>')+terms[2].join("");}return function parse_rs(rs){return rs.map(r_to_html).join("");};}();/* 18.4.8 si CT_Rst */var sitregex=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,sirregex=/<(?:\w+:)?r>/;var sirphregex=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function parse_si(x,opts){var html=opts?opts.cellHTML:true;var z={};if(!x)return{t:""};//var y;
/* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)){z.t=unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));z.r=utf8read(x);if(html)z.h=escapehtml(z.t);}/* 18.4.4 r CT_RElt (Rich Text Run) */else if(/*y = */x.match(sirregex)){z.r=utf8read(x);z.t=unescapexml(utf8read((x.replace(sirphregex,'').match(sitregex)||[]).join("").replace(tagregex,"")));if(html)z.h=rs_to_html(parse_rs(z.r));}/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */return z;}/* 18.4 Shared String Table */var sstr0=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var sstr1=/<(?:\w+:)?(?:si|sstItem)>/g;var sstr2=/<\/(?:\w+:)?(?:si|sstItem)>/;function parse_sst_xml(data,opts){var s=[],ss="";if(!data)return s;/* 18.4.9 sst CT_Sst */var sst=data.match(sstr0);if(sst){ss=sst[2].replace(sstr1,"").split(sstr2);for(var i=0;i!=ss.length;++i){var o=parse_si(ss[i].trim(),opts);if(o!=null)s[s.length]=o;}sst=parsexmltag(sst[1]);s.Count=sst.count;s.Unique=sst.uniqueCount;}return s;}RELS.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var straywsregex=/^\s|\s$|[\t\n\r]/;function write_sst_xml(sst,opts){if(!opts.bookSST)return"";var o=[XML_HEADER];o[o.length]=writextag('sst',null,{xmlns:XMLNS.main[0],count:sst.Count,uniqueCount:sst.Unique});for(var i=0;i!=sst.length;++i){if(sst[i]==null)continue;var s=sst[i];var sitag="<si>";if(s.r)sitag+=s.r;else{sitag+="<t";if(!s.t)s.t="";if(s.t.match(straywsregex))sitag+=' xml:space="preserve"';sitag+=">"+escapexml(s.t)+"</t>";}sitag+="</si>";o[o.length]=sitag;}if(o.length>2){o[o.length]='</sst>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.221 BrtBeginSst */function parse_BrtBeginSst(data){return[data.read_shift(4),data.read_shift(4)];}/* [MS-XLSB] 2.1.7.45 Shared Strings */function parse_sst_bin(data,opts){var s=[];var pass=false;recordhopper(data,function hopper_sst(val,R_n,RT){switch(RT){case 0x009F:/* 'BrtBeginSst' */s.Count=val[0];s.Unique=val[1];break;case 0x0013:/* 'BrtSSTItem' */s.push(val);break;case 0x00A0:/* 'BrtEndSst' */return true;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;default:if(R_n.indexOf("Begin")>0){/* empty */}else if(R_n.indexOf("End")>0){/* empty */}if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}});return s;}function write_BrtBeginSst(sst,o){if(!o)o=new_buf(8);o.write_shift(4,sst.Count);o.write_shift(4,sst.Unique);return o;}var write_BrtSSTItem=write_RichStr;function write_sst_bin(sst){var ba=buf_array();write_record(ba,"BrtBeginSst",write_BrtBeginSst(sst));for(var i=0;i<sst.length;++i)write_record(ba,"BrtSSTItem",write_BrtSSTItem(sst[i]));/* FRTSST */write_record(ba,"BrtEndSst");return ba.end();}function _JS2ANSI(str){if(typeof cptable!=='undefined')return cptable.utils.encode(current_ansi,str);var o=[],oo=str.split("");for(var i=0;i<oo.length;++i)o[i]=oo[i].charCodeAt(0);return o;}/* [MS-OFFCRYPTO] 2.1.4 Version */function parse_CRYPTOVersion(blob,length){var o={};o.Major=blob.read_shift(2);o.Minor=blob.read_shift(2);if(length>=4)blob.l+=length-4;return o;}/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */function parse_DataSpaceVersionInfo(blob){var o={};o.id=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */function parse_DataSpaceMapEntry(blob){var len=blob.read_shift(4);var end=blob.l+len-4;var o={};var cnt=blob.read_shift(4);var comps=[];/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */while(cnt-->0)comps.push({t:blob.read_shift(4),v:blob.read_shift(0,'lpp4')});o.name=blob.read_shift(0,'lpp4');o.comps=comps;if(blob.l!=end)throw new Error("Bad DataSpaceMapEntry: "+blob.l+" != "+end);return o;}/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */function parse_DataSpaceMap(blob){var o=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0)o.push(parse_DataSpaceMapEntry(blob));return o;}/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */function parse_DataSpaceDefinition(blob){var o=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0)o.push(blob.read_shift(0,'lpp4'));return o;}/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */function parse_TransformInfoHeader(blob){var o={};/*var len = */blob.read_shift(4);blob.l+=4;// must be 0x1
o.id=blob.read_shift(0,'lpp4');o.name=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}function parse_Primary(blob){/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */var hdr=parse_TransformInfoHeader(blob);/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */hdr.ename=blob.read_shift(0,'8lpp4');hdr.blksz=blob.read_shift(4);hdr.cmode=blob.read_shift(4);if(blob.read_shift(4)!=0x04)throw new Error("Bad !Primary record");return hdr;}/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */function parse_EncryptionHeader(blob,length){var tgt=blob.l+length;var o={};o.Flags=blob.read_shift(4)&0x3F;blob.l+=4;o.AlgID=blob.read_shift(4);var valid=false;switch(o.AlgID){case 0x660E:case 0x660F:case 0x6610:valid=o.Flags==0x24;break;case 0x6801:valid=o.Flags==0x04;break;case 0:valid=o.Flags==0x10||o.Flags==0x04||o.Flags==0x24;break;default:throw'Unrecognized encryption algorithm: '+o.AlgID;}if(!valid)throw new Error("Encryption Flags/AlgID mismatch");o.AlgIDHash=blob.read_shift(4);o.KeySize=blob.read_shift(4);o.ProviderType=blob.read_shift(4);blob.l+=8;o.CSPName=blob.read_shift(tgt-blob.l>>1,'utf16le');blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */function parse_EncryptionVerifier(blob,length){var o={},tgt=blob.l+length;blob.l+=4;// SaltSize must be 0x10
o.Salt=blob.slice(blob.l,blob.l+16);blob.l+=16;o.Verifier=blob.slice(blob.l,blob.l+16);blob.l+=16;/*var sz = */blob.read_shift(4);o.VerifierHash=blob.slice(blob.l,tgt);blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */function parse_EncryptionInfo(blob){var vers=parse_CRYPTOVersion(blob);switch(vers.Minor){case 0x02:return[vers.Minor,parse_EncInfoStd(blob,vers)];case 0x03:return[vers.Minor,parse_EncInfoExt(blob,vers)];case 0x04:return[vers.Minor,parse_EncInfoAgl(blob,vers)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+vers.Minor);}/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */function parse_EncInfoStd(blob){var flags=blob.read_shift(4);if((flags&0x3F)!=0x24)throw new Error("EncryptionInfo mismatch");var sz=blob.read_shift(4);//var tgt = blob.l + sz;
var hdr=parse_EncryptionHeader(blob,sz);var verifier=parse_EncryptionVerifier(blob,blob.length-blob.l);return{t:"Std",h:hdr,v:verifier};}/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */function parse_EncInfoExt(){throw new Error("File is password-protected: ECMA-376 Extensible");}/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */function parse_EncInfoAgl(blob){var KeyData=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];blob.l+=4;var xml=blob.read_shift(blob.length-blob.l,'utf8');var o={};xml.replace(tagregex,function xml_agile(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<encryption':case'</encryption>':break;case'<keyData':KeyData.forEach(function(k){o[k]=y[k];});break;case'<dataIntegrity':o.encryptedHmacKey=y.encryptedHmacKey;o.encryptedHmacValue=y.encryptedHmacValue;break;case'<keyEncryptors>':case'<keyEncryptors':o.encs=[];break;case'</keyEncryptors>':break;case'<keyEncryptor':o.uri=y.uri;break;case'</keyEncryptor>':break;case'<encryptedKey':o.encs.push(y);break;default:throw y[0];}});return o;}/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */function parse_RC4CryptoHeader(blob,length){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);length-=4;if(vers.Minor!=2)throw new Error('unrecognized minor version code: '+vers.Minor);if(vers.Major>4||vers.Major<2)throw new Error('unrecognized major version code: '+vers.Major);o.Flags=blob.read_shift(4);length-=4;var sz=blob.read_shift(4);length-=4;o.EncryptionHeader=parse_EncryptionHeader(blob,sz);length-=sz;o.EncryptionVerifier=parse_EncryptionVerifier(blob,length);return o;}/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */function parse_RC4Header(blob){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);if(vers.Major!=1||vers.Minor!=1)throw'unrecognized version code '+vers.Major+' : '+vers.Minor;o.Salt=blob.read_shift(16);o.EncryptedVerifier=blob.read_shift(16);o.EncryptedVerifierHash=blob.read_shift(16);return o;}/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */function crypto_CreatePasswordVerifier_Method1(Password){var Verifier=0x0000,PasswordArray;var PasswordDecoded=_JS2ANSI(Password);var len=PasswordDecoded.length+1,i,PasswordByte;var Intermediate1,Intermediate2,Intermediate3;PasswordArray=new_raw_buf(len);PasswordArray[0]=PasswordDecoded.length;for(i=1;i!=len;++i)PasswordArray[i]=PasswordDecoded[i-1];for(i=len-1;i>=0;--i){PasswordByte=PasswordArray[i];Intermediate1=(Verifier&0x4000)===0x0000?0:1;Intermediate2=Verifier<<1&0x7FFF;Intermediate3=Intermediate1|Intermediate2;Verifier=Intermediate3^PasswordByte;}return Verifier^0xCE4B;}/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */var crypto_CreateXorArray_Method1=function(){var PadArray=[0xBB,0xFF,0xFF,0xBA,0xFF,0xFF,0xB9,0x80,0x00,0xBE,0x0F,0x00,0xBF,0x0F,0x00];var InitialCode=[0xE1F0,0x1D0F,0xCC9C,0x84C0,0x110C,0x0E10,0xF1CE,0x313E,0x1872,0xE139,0xD40F,0x84F9,0x280C,0xA96A,0x4EC3];var XorMatrix=[0xAEFC,0x4DD9,0x9BB2,0x2745,0x4E8A,0x9D14,0x2A09,0x7B61,0xF6C2,0xFDA5,0xEB6B,0xC6F7,0x9DCF,0x2BBF,0x4563,0x8AC6,0x05AD,0x0B5A,0x16B4,0x2D68,0x5AD0,0x0375,0x06EA,0x0DD4,0x1BA8,0x3750,0x6EA0,0xDD40,0xD849,0xA0B3,0x5147,0xA28E,0x553D,0xAA7A,0x44D5,0x6F45,0xDE8A,0xAD35,0x4A4B,0x9496,0x390D,0x721A,0xEB23,0xC667,0x9CEF,0x29FF,0x53FE,0xA7FC,0x5FD9,0x47D3,0x8FA6,0x0F6D,0x1EDA,0x3DB4,0x7B68,0xF6D0,0xB861,0x60E3,0xC1C6,0x93AD,0x377B,0x6EF6,0xDDEC,0x45A0,0x8B40,0x06A1,0x0D42,0x1A84,0x3508,0x6A10,0xAA51,0x4483,0x8906,0x022D,0x045A,0x08B4,0x1168,0x76B4,0xED68,0xCAF1,0x85C3,0x1BA7,0x374E,0x6E9C,0x3730,0x6E60,0xDCC0,0xA9A1,0x4363,0x86C6,0x1DAD,0x3331,0x6662,0xCCC4,0x89A9,0x0373,0x06E6,0x0DCC,0x1021,0x2042,0x4084,0x8108,0x1231,0x2462,0x48C4];var Ror=function(Byte){return(Byte/2|Byte*128)&0xFF;};var XorRor=function(byte1,byte2){return Ror(byte1^byte2);};var CreateXorKey_Method1=function(Password){var XorKey=InitialCode[Password.length-1];var CurrentElement=0x68;for(var i=Password.length-1;i>=0;--i){var Char=Password[i];for(var j=0;j!=7;++j){if(Char&0x40)XorKey^=XorMatrix[CurrentElement];Char*=2;--CurrentElement;}}return XorKey;};return function(password){var Password=_JS2ANSI(password);var XorKey=CreateXorKey_Method1(Password);var Index=Password.length;var ObfuscationArray=new_raw_buf(16);for(var i=0;i!=16;++i)ObfuscationArray[i]=0x00;var Temp,PasswordLastChar,PadIndex;if((Index&1)===1){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[0],Temp);--Index;Temp=XorKey&0xFF;PasswordLastChar=Password[Password.length-1];ObfuscationArray[Index]=XorRor(PasswordLastChar,Temp);}while(Index>0){--Index;Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);}Index=15;PadIndex=15-Password.length;while(PadIndex>0){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[PadIndex],Temp);--Index;--PadIndex;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;--PadIndex;}return ObfuscationArray;};}();/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */var crypto_DecryptData_Method1=function(password,Data,XorArrayIndex,XorArray,O){/* If XorArray is set, use it; if O is not set, make changes in-place */if(!O)O=Data;if(!XorArray)XorArray=crypto_CreateXorArray_Method1(password);var Index,Value;for(Index=0;Index!=Data.length;++Index){Value=Data[Index];Value^=XorArray[XorArrayIndex];Value=(Value>>5|Value<<3)&0xFF;O[Index]=Value;++XorArrayIndex;}return[O,XorArrayIndex,XorArray];};var crypto_MakeXorDecryptor=function(password){var XorArrayIndex=0,XorArray=crypto_CreateXorArray_Method1(password);return function(Data){var O=crypto_DecryptData_Method1("",Data,XorArrayIndex,XorArray);XorArrayIndex=O[1];return O[0];};};/* 2.5.343 */function parse_XORObfuscation(blob,length,opts,out){var o={key:parseuint16(blob),verificationBytes:parseuint16(blob)};if(opts.password)o.verifier=crypto_CreatePasswordVerifier_Method1(opts.password);out.valid=o.verificationBytes===o.verifier;if(out.valid)out.insitu=crypto_MakeXorDecryptor(opts.password);return o;}/* 2.4.117 */function parse_FilePassHeader(blob,length,oo){var o=oo||{};o.Info=blob.read_shift(2);blob.l-=2;if(o.Info===1)o.Data=parse_RC4Header(blob,length);else o.Data=parse_RC4CryptoHeader(blob,length);return o;}function parse_FilePass(blob,length,opts){var o={Type:opts.biff>=8?blob.read_shift(2):0};/* wEncryptionType */if(o.Type)parse_FilePassHeader(blob,length-2,o);else parse_XORObfuscation(blob,opts.biff>=8?length:length-2,opts,o);return o;}var RTF=function(){function rtf_to_sheet(d,opts){switch(opts.type){case'base64':return rtf_to_sheet_str(Base64.decode(d),opts);case'binary':return rtf_to_sheet_str(d,opts);case'buffer':return rtf_to_sheet_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return rtf_to_sheet_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}/* TODO: this is a stub */function rtf_to_sheet_str(str,opts){var o=opts||{};var ws=o.dense?[]:{};var rows=str.match(/\\trowd.*?\\row\b/g);if(!rows.length)throw new Error("RTF missing table");var range={s:{c:0,r:0},e:{c:0,r:rows.length-1}};rows.forEach(function(rowtf,R){if(Array.isArray(ws))ws[R]=[];var rtfre=/\\\w+\b/g;var last_index=0;var res;var C=-1;while(res=rtfre.exec(rowtf)){switch(res[0]){case"\\cell":var data=rowtf.slice(last_index,rtfre.lastIndex-res[0].length);if(data[0]==" ")data=data.slice(1);++C;if(data.length){// TODO: value parsing, including codepage adjustments
var cell={v:data,t:"s"};if(Array.isArray(ws))ws[R][C]=cell;else ws[encode_cell({r:R,c:C})]=cell;}break;}last_index=rtfre.lastIndex;}if(C>range.e.c)range.e.c=C;});ws['!ref']=encode_range(range);return ws;}function rtf_to_workbook(d,opts){return sheet_to_workbook(rtf_to_sheet(d,opts),opts);}/* TODO: this is a stub */function sheet_to_rtf(ws){var o=["{\\rtf1\\ansi"];var r=safe_decode_range(ws['!ref']),cell;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){o.push("\\trowd\\trautofit1");for(var C=r.s.c;C<=r.e.c;++C)o.push("\\cellx"+(C+1));o.push("\\pard\\intbl");for(C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(" "+(cell.w||(format_cell(cell),cell.w)));o.push("\\cell");}o.push("\\pard\\intbl\\row");}return o.join("")+"}";}return{to_workbook:rtf_to_workbook,to_sheet:rtf_to_sheet,from_sheet:sheet_to_rtf};}();function hex2RGB(h){var o=h.slice(h[0]==="#"?1:0).slice(0,6);return[parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];}function rgb2Hex(rgb){for(var i=0,o=1;i!=3;++i)o=o*256+(rgb[i]>255?255:rgb[i]<0?0:rgb[i]);return o.toString(16).toUpperCase().slice(1);}function rgb2HSL(rgb){var R=rgb[0]/255,G=rgb[1]/255,B=rgb[2]/255;var M=Math.max(R,G,B),m=Math.min(R,G,B),C=M-m;if(C===0)return[0,0,R];var H6=0,S=0,L2=M+m;S=C/(L2>1?2-L2:L2);switch(M){case R:H6=((G-B)/C+6)%6;break;case G:H6=(B-R)/C+2;break;case B:H6=(R-G)/C+4;break;}return[H6/6,S,L2/2];}function hsl2RGB(hsl){var H=hsl[0],S=hsl[1],L=hsl[2];var C=S*2*(L<0.5?L:1-L),m=L-C/2;var rgb=[m,m,m],h6=6*H;var X;if(S!==0)switch(h6|0){case 0:case 6:X=C*h6;rgb[0]+=C;rgb[1]+=X;break;case 1:X=C*(2-h6);rgb[0]+=X;rgb[1]+=C;break;case 2:X=C*(h6-2);rgb[1]+=C;rgb[2]+=X;break;case 3:X=C*(4-h6);rgb[1]+=X;rgb[2]+=C;break;case 4:X=C*(h6-4);rgb[2]+=C;rgb[0]+=X;break;case 5:X=C*(6-h6);rgb[2]+=X;rgb[0]+=C;break;}for(var i=0;i!=3;++i)rgb[i]=Math.round(rgb[i]*255);return rgb;}/* 18.8.3 bgColor tint algorithm */function rgb_tint(hex,tint){if(tint===0)return hex;var hsl=rgb2HSL(hex2RGB(hex));if(tint<0)hsl[2]=hsl[2]*(1+tint);else hsl[2]=1-(1-hsl[2])*(1-tint);return rgb2Hex(hsl2RGB(hsl));}/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */var DEF_MDW=6,MAX_MDW=15,MIN_MDW=1,MDW=DEF_MDW;function width2px(width){return Math.floor((width+Math.round(128/MDW)/256)*MDW);}function px2char(px){return Math.floor((px-5)/MDW*100+0.5)/100;}function char2width(chr){return Math.round((chr*MDW+5)/MDW*256)/256;}//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw){return char2width(px2char(width2px(collw)));}/* XLSX/XLSB/XLS specify width in units of MDW */function find_mdw_colw(collw){var delta=Math.abs(collw-cycle_width(collw)),_MDW=MDW;if(delta>0.005)for(MDW=MIN_MDW;MDW<MAX_MDW;++MDW)if(Math.abs(collw-cycle_width(collw))<=delta){delta=Math.abs(collw-cycle_width(collw));_MDW=MDW;}MDW=_MDW;}/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/function process_col(coll){if(coll.width){coll.wpx=width2px(coll.width);coll.wch=px2char(coll.wpx);coll.MDW=MDW;}else if(coll.wpx){coll.wch=px2char(coll.wpx);coll.width=char2width(coll.wch);coll.MDW=MDW;}else if(typeof coll.wch=='number'){coll.width=char2width(coll.wch);coll.wpx=width2px(coll.width);coll.MDW=MDW;}if(coll.customWidth)delete coll.customWidth;}var DEF_PPI=96,PPI=DEF_PPI;function px2pt(px){return px*96/PPI;}function pt2px(pt){return pt*PPI/96;}/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */var XLMLPatternTypeMap={"None":"none","Solid":"solid","Gray50":"mediumGray","Gray75":"darkGray","Gray25":"lightGray","HorzStripe":"darkHorizontal","VertStripe":"darkVertical","ReverseDiagStripe":"darkDown","DiagStripe":"darkUp","DiagCross":"darkGrid","ThickDiagCross":"darkTrellis","ThinHorzStripe":"lightHorizontal","ThinVertStripe":"lightVertical","ThinReverseDiagStripe":"lightDown","ThinHorzCross":"lightGrid"};/* 18.8.5 borders CT_Borders */function parse_borders(t,styles,themes,opts){styles.Borders=[];var border={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<borders':case'<borders>':case'</borders>':break;/* 18.8.4 border CT_Border */case'<border':case'<border>':case'<border/>':border={};if(y.diagonalUp)border.diagonalUp=parsexmlbool(y.diagonalUp);if(y.diagonalDown)border.diagonalDown=parsexmlbool(y.diagonalDown);styles.Borders.push(border);break;case'</border>':break;/* note: not in spec, appears to be CT_BorderPr */case'<left/>':break;case'<left':case'<left>':break;case'</left>':break;/* note: not in spec, appears to be CT_BorderPr */case'<right/>':break;case'<right':case'<right>':break;case'</right>':break;/* 18.8.43 top CT_BorderPr */case'<top/>':break;case'<top':case'<top>':break;case'</top>':break;/* 18.8.6 bottom CT_BorderPr */case'<bottom/>':break;case'<bottom':case'<bottom>':break;case'</bottom>':break;/* 18.8.13 diagonal CT_BorderPr */case'<diagonal':case'<diagonal>':case'<diagonal/>':break;case'</diagonal>':break;/* 18.8.25 horizontal CT_BorderPr */case'<horizontal':case'<horizontal>':case'<horizontal/>':break;case'</horizontal>':break;/* 18.8.44 vertical CT_BorderPr */case'<vertical':case'<vertical>':case'<vertical/>':break;case'</vertical>':break;/* 18.8.37 start CT_BorderPr */case'<start':case'<start>':case'<start/>':break;case'</start>':break;/* 18.8.16 end CT_BorderPr */case'<end':case'<end>':case'<end/>':break;case'</end>':break;/* 18.8.? color CT_Color */case'<color':case'<color>':break;case'<color/>':case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in borders');}}});}/* 18.8.21 fills CT_Fills */function parse_fills(t,styles,themes,opts){styles.Fills=[];var fill={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fills':case'<fills>':case'</fills>':break;/* 18.8.20 fill CT_Fill */case'<fill>':case'<fill':case'<fill/>':fill={};styles.Fills.push(fill);break;case'</fill>':break;/* 18.8.24 gradientFill CT_GradientFill */case'<gradientFill>':break;case'<gradientFill':case'</gradientFill>':styles.Fills.push(fill);fill={};break;/* 18.8.32 patternFill CT_PatternFill */case'<patternFill':case'<patternFill>':if(y.patternType)fill.patternType=y.patternType;break;case'<patternFill/>':case'</patternFill>':break;/* 18.8.3 bgColor CT_Color */case'<bgColor':if(!fill.bgColor)fill.bgColor={};if(y.indexed)fill.bgColor.indexed=parseInt(y.indexed,10);if(y.theme)fill.bgColor.theme=parseInt(y.theme,10);if(y.tint)fill.bgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb)fill.bgColor.rgb=y.rgb.slice(-6);break;case'<bgColor/>':case'</bgColor>':break;/* 18.8.19 fgColor CT_Color */case'<fgColor':if(!fill.fgColor)fill.fgColor={};if(y.theme)fill.fgColor.theme=parseInt(y.theme,10);if(y.tint)fill.fgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb!=null)fill.fgColor.rgb=y.rgb.slice(-6);break;case'<fgColor/>':case'</fgColor>':break;/* 18.8.38 stop CT_GradientStop */case'<stop':case'<stop/>':break;case'</stop>':break;/* 18.8.? color CT_Color */case'<color':case'<color/>':break;case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fills');}}});}/* 18.8.23 fonts CT_Fonts */function parse_fonts(t,styles,themes,opts){styles.Fonts=[];var font={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fonts':case'<fonts>':case'</fonts>':break;/* 18.8.22 font CT_Font */case'<font':case'<font>':break;case'</font>':case'<font/>':styles.Fonts.push(font);font={};break;/* 18.8.29 name CT_FontName */case'<name':if(y.val)font.name=utf8read(y.val);break;case'<name/>':case'</name>':break;/* 18.8.2  b CT_BooleanProperty */case'<b':font.bold=y.val?parsexmlbool(y.val):1;break;case'<b/>':font.bold=1;break;/* 18.8.26 i CT_BooleanProperty */case'<i':font.italic=y.val?parsexmlbool(y.val):1;break;case'<i/>':font.italic=1;break;/* 18.4.13 u CT_UnderlineProperty */case'<u':switch(y.val){case"none":font.underline=0x00;break;case"single":font.underline=0x01;break;case"double":font.underline=0x02;break;case"singleAccounting":font.underline=0x21;break;case"doubleAccounting":font.underline=0x22;break;}break;case'<u/>':font.underline=1;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':font.strike=y.val?parsexmlbool(y.val):1;break;case'<strike/>':font.strike=1;break;/* 18.4.2  outline CT_BooleanProperty */case'<outline':font.outline=y.val?parsexmlbool(y.val):1;break;case'<outline/>':font.outline=1;break;/* 18.8.36 shadow CT_BooleanProperty */case'<shadow':font.shadow=y.val?parsexmlbool(y.val):1;break;case'<shadow/>':font.shadow=1;break;/* 18.8.12 condense CT_BooleanProperty */case'<condense':font.condense=y.val?parsexmlbool(y.val):1;break;case'<condense/>':font.condense=1;break;/* 18.8.17 extend CT_BooleanProperty */case'<extend':font.extend=y.val?parsexmlbool(y.val):1;break;case'<extend/>':font.extend=1;break;/* 18.4.11 sz CT_FontSize */case'<sz':if(y.val)font.sz=+y.val;break;case'<sz/>':case'</sz>':break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */case'<vertAlign':if(y.val)font.vertAlign=y.val;break;case'<vertAlign/>':case'</vertAlign>':break;/* 18.8.18 family CT_FontFamily */case'<family':if(y.val)font.family=parseInt(y.val,10);break;case'<family/>':case'</family>':break;/* 18.8.35 scheme CT_FontScheme */case'<scheme':if(y.val)font.scheme=y.val;break;case'<scheme/>':case'</scheme>':break;/* 18.4.1 charset CT_IntProperty */case'<charset':if(y.val=='1')break;y.codepage=CS2CP[parseInt(y.val,10)];break;/* 18.?.? color CT_Color */case'<color':if(!font.color)font.color={};if(y.auto)font.color.auto=parsexmlbool(y.auto);if(y.rgb)font.color.rgb=y.rgb.slice(-6);else if(y.indexed){font.color.index=parseInt(y.indexed,10);var icv=XLSIcv[font.color.index];if(font.color.index==81)icv=XLSIcv[1];if(!icv)icv=XLSIcv[1];//throw new Error(x); // note: 206 is valid
font.color.rgb=icv[0].toString(16)+icv[1].toString(16)+icv[2].toString(16);}else if(y.theme){font.color.theme=parseInt(y.theme,10);if(y.tint)font.color.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){font.color.rgb=rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb,font.color.tint||0);}}break;case'<color/>':case'</color>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fonts');}}});}/* 18.8.31 numFmts CT_NumFmts */function parse_numFmts(t,styles,opts){styles.NumberFmt=[];var k/*Array<number>*/=keys(SSF._table);for(var i=0;i<k.length;++i)styles.NumberFmt[k[i]]=SSF._table[k[i]];var m=t[0].match(tagregex);if(!m)return;for(i=0;i<m.length;++i){var y=parsexmltag(m[i]);switch(strip_ns(y[0])){case'<numFmts':case'</numFmts>':case'<numFmts/>':case'<numFmts>':break;case'<numFmt':{var f=unescapexml(utf8read(y.formatCode)),j=parseInt(y.numFmtId,10);styles.NumberFmt[j]=f;if(j>0){if(j>0x188){for(j=0x188;j>0x3c;--j)if(styles.NumberFmt[j]==null)break;styles.NumberFmt[j]=f;}SSF.load(f,j);}}break;case'</numFmt>':break;default:if(opts.WTF)throw new Error('unrecognized '+y[0]+' in numFmts');}}}function write_numFmts(NF){var o=["<numFmts>"];[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)o[o.length]=writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])});});if(o.length===1)return"";o[o.length]="</numFmts>";o[0]=writextag('numFmts',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8.10 cellXfs CT_CellXfs */var cellXF_uint=["numFmtId","fillId","fontId","borderId","xfId"];var cellXF_bool=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function parse_cellXfs(t,styles,opts){styles.CellXf=[];var xf;var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x),i=0;switch(strip_ns(y[0])){case'<cellXfs':case'<cellXfs>':case'<cellXfs/>':case'</cellXfs>':break;/* 18.8.45 xf CT_Xf */case'<xf':case'<xf/>':xf=y;delete xf[0];for(i=0;i<cellXF_uint.length;++i)if(xf[cellXF_uint[i]])xf[cellXF_uint[i]]=parseInt(xf[cellXF_uint[i]],10);for(i=0;i<cellXF_bool.length;++i)if(xf[cellXF_bool[i]])xf[cellXF_bool[i]]=parsexmlbool(xf[cellXF_bool[i]]);if(styles.NumberFmt&&xf.numFmtId>0x188){for(i=0x188;i>0x3c;--i)if(styles.NumberFmt[xf.numFmtId]==styles.NumberFmt[i]){xf.numFmtId=i;break;}}styles.CellXf.push(xf);break;case'</xf>':break;/* 18.8.1 alignment CT_CellAlignment */case'<alignment':case'<alignment/>':var alignment={};if(y.vertical)alignment.vertical=y.vertical;if(y.horizontal)alignment.horizontal=y.horizontal;if(y.textRotation!=null)alignment.textRotation=y.textRotation;if(y.indent)alignment.indent=y.indent;if(y.wrapText)alignment.wrapText=parsexmlbool(y.wrapText);xf.alignment=alignment;break;case'</alignment>':break;/* 18.8.33 protection CT_CellProtection */case'<protection':break;case'</protection>':case'<protection/>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in cellXfs');}}});}function write_cellXfs(cellXfs){var o=[];o[o.length]=writextag('cellXfs',null);cellXfs.forEach(function(c){o[o.length]=writextag('xf',null,c);});o[o.length]="</cellXfs>";if(o.length===2)return"";o[0]=writextag('cellXfs',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8 Styles CT_Stylesheet*/var parse_sty_xml=function make_pstyx(){var numFmtRegex=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var cellXfRegex=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var fillsRegex=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var fontsRegex=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var bordersRegex=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function parse_sty_xml(data,themes,opts){var styles={};if(!data)return styles;data=data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");/* 18.8.39 styleSheet CT_Stylesheet */var t;/* 18.8.31 numFmts CT_NumFmts ? */if(t=data.match(numFmtRegex))parse_numFmts(t,styles,opts);/* 18.8.23 fonts CT_Fonts ? */if(t=data.match(fontsRegex))parse_fonts(t,styles,themes,opts);/* 18.8.21 fills CT_Fills ? */if(t=data.match(fillsRegex))parse_fills(t,styles,themes,opts);/* 18.8.5  borders CT_Borders ? */if(t=data.match(bordersRegex))parse_borders(t,styles,themes,opts);/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */if(t=data.match(cellXfRegex))parse_cellXfs(t,styles,opts);/* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */return styles;};}();var STYLES_XML_ROOT=writextag('styleSheet',null,{'xmlns':XMLNS.main[0],'xmlns:vt':XMLNS.vt});RELS.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function write_sty_xml(wb,opts){var o=[XML_HEADER,STYLES_XML_ROOT],w;if(wb.SSF&&(w=write_numFmts(wb.SSF))!=null)o[o.length]=w;o[o.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';o[o.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';o[o.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';o[o.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(w=write_cellXfs(opts.cellXfs))o[o.length]=w;o[o.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';o[o.length]='<dxfs count="0"/>';o[o.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(o.length>2){o[o.length]='</styleSheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.657 BrtFmt */function parse_BrtFmt(data,length){var numFmtId=data.read_shift(2);var stFmtCode=parse_XLWideString(data,length-2);return[numFmtId,stFmtCode];}function write_BrtFmt(i,f,o){if(!o)o=new_buf(6+4*f.length);o.write_shift(2,i);write_XLWideString(f,o);var out=o.length>o.l?o.slice(0,o.l):o;if(o.l==null)o.l=o.length;return out;}/* [MS-XLSB] 2.4.659 BrtFont TODO */function parse_BrtFont(data,length,opts){var out={};out.sz=data.read_shift(2)/20;var grbit=parse_FontFlags(data,2,opts);if(grbit.fItalic)out.italic=1;if(grbit.fCondense)out.condense=1;if(grbit.fExtend)out.extend=1;if(grbit.fShadow)out.shadow=1;if(grbit.fOutline)out.outline=1;if(grbit.fStrikeout)out.strike=1;var bls=data.read_shift(2);if(bls===0x02BC)out.bold=1;switch(data.read_shift(2)){/* case 0: out.vertAlign = "baseline"; break; */case 1:out.vertAlign="superscript";break;case 2:out.vertAlign="subscript";break;}var underline=data.read_shift(1);if(underline!=0)out.underline=underline;var family=data.read_shift(1);if(family>0)out.family=family;var bCharSet=data.read_shift(1);if(bCharSet>0)out.charset=bCharSet;data.l++;out.color=parse_BrtColor(data,8);switch(data.read_shift(1)){/* case 0: out.scheme = "none": break; */case 1:out.scheme="major";break;case 2:out.scheme="minor";break;}out.name=parse_XLWideString(data,length-21);return out;}function write_BrtFont(font,o){if(!o)o=new_buf(25+4*32);o.write_shift(2,font.sz*20);write_FontFlags(font,o);o.write_shift(2,font.bold?0x02BC:0x0190);var sss=0;if(font.vertAlign=="superscript")sss=1;else if(font.vertAlign=="subscript")sss=2;o.write_shift(2,sss);o.write_shift(1,font.underline||0);o.write_shift(1,font.family||0);o.write_shift(1,font.charset||0);o.write_shift(1,0);write_BrtColor(font.color,o);var scheme=0;if(font.scheme=="major")scheme=1;if(font.scheme=="minor")scheme=2;o.write_shift(1,scheme);write_XLWideString(font.name,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.650 BrtFill */var XLSBFillPTNames=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var rev_XLSBFillPTNames=evert(XLSBFillPTNames);/* TODO: gradient fill representation */var parse_BrtFill=parsenoop;function write_BrtFill(fill,o){if(!o)o=new_buf(4*3+8*7+16*1);var fls=rev_XLSBFillPTNames[fill.patternType];if(fls==null)fls=0x28;o.write_shift(4,fls);var j=0;if(fls!=0x28){/* TODO: custom FG Color */write_BrtColor({auto:1},o);/* TODO: custom BG Color */write_BrtColor({auto:1},o);for(;j<12;++j)o.write_shift(4,0);}else{for(;j<4;++j)o.write_shift(4,0);for(;j<12;++j)o.write_shift(4,0);/* TODO */ /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */}return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.824 BrtXF */function parse_BrtXF(data,length){var tgt=data.l+length;var ixfeParent=data.read_shift(2);var ifmt=data.read_shift(2);data.l=tgt;return{ixfe:ixfeParent,numFmtId:ifmt};}function write_BrtXF(data,ixfeP,o){if(!o)o=new_buf(16);o.write_shift(2,ixfeP||0);o.write_shift(2,data.numFmtId||0);o.write_shift(2,0);/* iFont */o.write_shift(2,0);/* iFill */o.write_shift(2,0);/* ixBorder */o.write_shift(1,0);/* trot */o.write_shift(1,0);/* indent */var flow=0;o.write_shift(1,flow);/* flags */o.write_shift(1,0);/* flags */o.write_shift(1,0);/* xfGrbitAtr */o.write_shift(1,0);return o;}/* [MS-XLSB] 2.5.4 Blxf TODO */function write_Blxf(data,o){if(!o)o=new_buf(10);o.write_shift(1,0);/* dg */o.write_shift(1,0);o.write_shift(4,0);/* color */o.write_shift(4,0);/* color */return o;}/* [MS-XLSB] 2.4.302 BrtBorder TODO */var parse_BrtBorder=parsenoop;function write_BrtBorder(border,o){if(!o)o=new_buf(51);o.write_shift(1,0);/* diagonal */write_Blxf(null,o);/* top */write_Blxf(null,o);/* bottom */write_Blxf(null,o);/* left */write_Blxf(null,o);/* right */write_Blxf(null,o);/* diag */return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.763 BrtStyle TODO */function write_BrtStyle(style,o){if(!o)o=new_buf(12+4*10);o.write_shift(4,style.xfId);o.write_shift(2,1);o.write_shift(1,+style.builtinId);o.write_shift(1,0);/* iLevel */write_XLNullableWideString(style.name||"",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */function write_BrtBeginTableStyles(cnt,defTableStyle,defPivotStyle){var o=new_buf(4+256*2*4);o.write_shift(4,cnt);write_XLNullableWideString(defTableStyle,o);write_XLNullableWideString(defPivotStyle,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.1.7.50 Styles */function parse_sty_bin(data,themes,opts){var styles={};styles.NumberFmt=[];for(var y in SSF._table)styles.NumberFmt[y]=SSF._table[y];styles.CellXf=[];styles.Fonts=[];var state=[];var pass=false;recordhopper(data,function hopper_sty(val,R_n,RT){switch(RT){case 0x002C:/* 'BrtFmt' */styles.NumberFmt[val[0]]=val[1];SSF.load(val[1],val[0]);break;case 0x002B:/* 'BrtFont' */styles.Fonts.push(val);if(val.color.theme!=null&&themes&&themes.themeElements&&themes.themeElements.clrScheme){val.color.rgb=rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb,val.color.tint||0);}break;case 0x0401:/* 'BrtKnownFonts' */break;case 0x002D:/* 'BrtFill' */break;case 0x002E:/* 'BrtBorder' */break;case 0x002F:/* 'BrtXF' */if(state[state.length-1]=="BrtBeginCellXFs"){styles.CellXf.push(val);}break;case 0x0030:/* 'BrtStyle' */case 0x01FB:/* 'BrtDXF' */case 0x023C:/* 'BrtMRUColor' */case 0x01DB:/* 'BrtIndexedColor': */break;case 0x0493:/* 'BrtDXF14' */case 0x0836:/* 'BrtDXF15' */case 0x046A:/* 'BrtSlicerStyleElement' */case 0x0200:/* 'BrtTableStyleElement' */case 0x082F:/* 'BrtTimelineStyleElement' */case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;default:if((R_n||"").indexOf("Begin")>0)state.push(R_n);else if((R_n||"").indexOf("End")>0)state.pop();else if(!pass||opts.WTF&&state[state.length-1]!="BrtACBegin")throw new Error("Unexpected record "+RT+" "+R_n);}});return styles;}function write_FMTS_bin(ba,NF){if(!NF)return;var cnt=0;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)++cnt;});if(cnt==0)return;write_record(ba,"BrtBeginFmts",write_UInt32LE(cnt));[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)write_record(ba,"BrtFmt",write_BrtFmt(i,NF[i]));});write_record(ba,"BrtEndFmts");}function write_FONTS_bin(ba){var cnt=1;if(cnt==0)return;write_record(ba,"BrtBeginFonts",write_UInt32LE(cnt));write_record(ba,"BrtFont",write_BrtFont({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));/* 1*65491BrtFont [ACFONTS] */write_record(ba,"BrtEndFonts");}function write_FILLS_bin(ba){var cnt=2;if(cnt==0)return;write_record(ba,"BrtBeginFills",write_UInt32LE(cnt));write_record(ba,"BrtFill",write_BrtFill({patternType:"none"}));write_record(ba,"BrtFill",write_BrtFill({patternType:"gray125"}));/* 1*65431BrtFill */write_record(ba,"BrtEndFills");}function write_BORDERS_bin(ba){var cnt=1;if(cnt==0)return;write_record(ba,"BrtBeginBorders",write_UInt32LE(cnt));write_record(ba,"BrtBorder",write_BrtBorder({}));/* 1*65430BrtBorder */write_record(ba,"BrtEndBorders");}function write_CELLSTYLEXFS_bin(ba){var cnt=1;write_record(ba,"BrtBeginCellStyleXFs",write_UInt32LE(cnt));write_record(ba,"BrtXF",write_BrtXF({numFmtId:0,fontId:0,fillId:0,borderId:0},0xFFFF));/* 1*65430(BrtXF *FRT) */write_record(ba,"BrtEndCellStyleXFs");}function write_CELLXFS_bin(ba,data){write_record(ba,"BrtBeginCellXFs",write_UInt32LE(data.length));data.forEach(function(c){write_record(ba,"BrtXF",write_BrtXF(c,0));});/* 1*65430(BrtXF *FRT) */write_record(ba,"BrtEndCellXFs");}function write_STYLES_bin(ba){var cnt=1;write_record(ba,"BrtBeginStyles",write_UInt32LE(cnt));write_record(ba,"BrtStyle",write_BrtStyle({xfId:0,builtinId:0,name:"Normal"}));/* 1*65430(BrtStyle *FRT) */write_record(ba,"BrtEndStyles");}function write_DXFS_bin(ba){var cnt=0;write_record(ba,"BrtBeginDXFs",write_UInt32LE(cnt));/* *2147483647(BrtDXF *FRT) */write_record(ba,"BrtEndDXFs");}function write_TABLESTYLES_bin(ba){var cnt=0;write_record(ba,"BrtBeginTableStyles",write_BrtBeginTableStyles(cnt,"TableStyleMedium9","PivotStyleMedium4"));/* *TABLESTYLE */write_record(ba,"BrtEndTableStyles");}function write_COLORPALETTE_bin(){return;/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */}/* [MS-XLSB] 2.1.7.50 Styles */function write_sty_bin(wb,opts){var ba=buf_array();write_record(ba,"BrtBeginStyleSheet");write_FMTS_bin(ba,wb.SSF);write_FONTS_bin(ba,wb);write_FILLS_bin(ba,wb);write_BORDERS_bin(ba,wb);write_CELLSTYLEXFS_bin(ba,wb);write_CELLXFS_bin(ba,opts.cellXfs);write_STYLES_bin(ba,wb);write_DXFS_bin(ba,wb);write_TABLESTYLES_bin(ba,wb);write_COLORPALETTE_bin(ba,wb);/* FRTSTYLESHEET*/write_record(ba,"BrtEndStyleSheet");return ba.end();}RELS.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */var XLSXThemeClrScheme=['</a:lt1>','</a:dk1>','</a:lt2>','</a:dk2>','</a:accent1>','</a:accent2>','</a:accent3>','</a:accent4>','</a:accent5>','</a:accent6>','</a:hlink>','</a:folHlink>'];/* 20.1.6.2 clrScheme CT_ColorScheme */function parse_clrScheme(t,themes,opts){themes.themeElements.clrScheme=[];var color={};(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */case'<a:clrScheme':case'</a:clrScheme>':break;/* 20.1.2.3.32 srgbClr CT_SRgbColor */case'<a:srgbClr':color.rgb=y.val;break;/* 20.1.2.3.33 sysClr CT_SystemColor */case'<a:sysClr':color.rgb=y.lastClr;break;/* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */case'<a:dk1>':case'</a:dk1>':case'<a:lt1>':case'</a:lt1>':case'<a:dk2>':case'</a:dk2>':case'<a:lt2>':case'</a:lt2>':case'<a:accent1>':case'</a:accent1>':case'<a:accent2>':case'</a:accent2>':case'<a:accent3>':case'</a:accent3>':case'<a:accent4>':case'</a:accent4>':case'<a:accent5>':case'</a:accent5>':case'<a:accent6>':case'</a:accent6>':case'<a:hlink>':case'</a:hlink>':case'<a:folHlink>':case'</a:folHlink>':if(y[0].charAt(1)==='/'){themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])]=color;color={};}else{color.name=y[0].slice(3,y[0].length-1);}break;default:if(opts&&opts.WTF)throw new Error('Unrecognized '+y[0]+' in clrScheme');}});}/* 20.1.4.1.18 fontScheme CT_FontScheme */function parse_fontScheme(){}/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */function parse_fmtScheme(){}var clrsregex=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var fntsregex=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var fmtsregex=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;/* 20.1.6.10 themeElements CT_BaseStyles */function parse_themeElements(data,themes,opts){themes.themeElements={};var t;[/* clrScheme CT_ColorScheme */['clrScheme',clrsregex,parse_clrScheme],/* fontScheme CT_FontScheme */['fontScheme',fntsregex,parse_fontScheme],/* fmtScheme CT_StyleMatrix */['fmtScheme',fmtsregex,parse_fmtScheme]].forEach(function(m){if(!(t=data.match(m[1])))throw new Error(m[0]+' not found in themeElements');m[2](t,themes,opts);});}var themeltregex=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;/* 14.2.7 Theme Part */function parse_theme_xml(data,opts){/* 20.1.6.9 theme CT_OfficeStyleSheet */if(!data||data.length===0)return parse_theme_xml(write_theme());var t;var themes={};/* themeElements CT_BaseStyles */if(!(t=data.match(themeltregex)))throw new Error('themeElements not found in theme');parse_themeElements(t[0],themes,opts);themes.raw=data;return themes;}function write_theme(Themes,opts){if(opts&&opts.themeXLSX)return opts.themeXLSX;if(Themes&&typeof Themes.raw=="string")return Themes.raw;var o=[XML_HEADER];o[o.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';o[o.length]='<a:themeElements>';o[o.length]='<a:clrScheme name="Office">';o[o.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';o[o.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';o[o.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';o[o.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';o[o.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';o[o.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';o[o.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';o[o.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';o[o.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';o[o.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';o[o.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';o[o.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';o[o.length]='</a:clrScheme>';o[o.length]='<a:fontScheme name="Office">';o[o.length]='<a:majorFont>';o[o.length]='<a:latin typeface="Cambria"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Times New Roman"/>';o[o.length]='<a:font script="Hebr" typeface="Times New Roman"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="MoolBoran"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Times New Roman"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:majorFont>';o[o.length]='<a:minorFont>';o[o.length]='<a:latin typeface="Calibri"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Arial"/>';o[o.length]='<a:font script="Hebr" typeface="Arial"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="DaunPenh"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Arial"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:minorFont>';o[o.length]='</a:fontScheme>';o[o.length]='<a:fmtScheme name="Office">';o[o.length]='<a:fillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="1"/>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="0"/>';o[o.length]='</a:gradFill>';o[o.length]='</a:fillStyleLst>';o[o.length]='<a:lnStyleLst>';o[o.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='</a:lnStyleLst>';o[o.length]='<a:effectStyleLst>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';o[o.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';o[o.length]='</a:effectStyle>';o[o.length]='</a:effectStyleLst>';o[o.length]='<a:bgFillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='</a:bgFillStyleLst>';o[o.length]='</a:fmtScheme>';o[o.length]='</a:themeElements>';o[o.length]='<a:objectDefaults>';o[o.length]='<a:spDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';o[o.length]='</a:spDef>';o[o.length]='<a:lnDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';o[o.length]='</a:lnDef>';o[o.length]='</a:objectDefaults>';o[o.length]='<a:extraClrSchemeLst/>';o[o.length]='</a:theme>';return o.join("");}/* [MS-XLS] 2.4.326 TODO: payload is a zip file */function parse_Theme(blob,length,opts){var end=blob.l+length;var dwThemeVersion=blob.read_shift(4);if(dwThemeVersion===124226)return;if(!opts.cellStyles){blob.l=end;return;}var data=blob.slice(blob.l);blob.l=end;var zip;try{zip=zip_read(data,{type:"array"});}catch(e){return;}var themeXML=getzipstr(zip,"theme/theme/theme1.xml",true);if(!themeXML)return;return parse_theme_xml(themeXML,opts);}/* 2.5.49 */function parse_ColorTheme(blob){return blob.read_shift(4);}/* 2.5.155 */function parse_FullColorExt(blob){var o={};o.xclrType=blob.read_shift(2);o.nTintShade=blob.read_shift(2);switch(o.xclrType){case 0:blob.l+=4;break;case 1:o.xclrValue=parse_IcvXF(blob,4);break;case 2:o.xclrValue=parse_LongRGBA(blob,4);break;case 3:o.xclrValue=parse_ColorTheme(blob,4);break;case 4:blob.l+=4;break;}blob.l+=8;return o;}/* 2.5.164 TODO: read 7 bits*/function parse_IcvXF(blob,length){return parsenoop(blob,length);}/* 2.5.280 */function parse_XFExtGradient(blob,length){return parsenoop(blob,length);}/* [MS-XLS] 2.5.108 */function parse_ExtProp(blob){var extType=blob.read_shift(2);var cb=blob.read_shift(2)-4;var o=[extType];switch(extType){case 0x04:case 0x05:case 0x07:case 0x08:case 0x09:case 0x0A:case 0x0B:case 0x0D:o[1]=parse_FullColorExt(blob,cb);break;case 0x06:o[1]=parse_XFExtGradient(blob,cb);break;case 0x0E:case 0x0F:o[1]=blob.read_shift(cb===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+extType+" "+cb);}return o;}/* 2.4.355 */function parse_XFExt(blob,length){var end=blob.l+length;blob.l+=2;var ixfe=blob.read_shift(2);blob.l+=2;var cexts=blob.read_shift(2);var ext=[];while(cexts-->0)ext.push(parse_ExtProp(blob,end-blob.l));return{ixfe:ixfe,ext:ext};}/* xf is an XF, see parse_XFExt for xfext */function update_xfext(xf,xfext){xfext.forEach(function(xfe){switch(xfe[0]){/* 2.5.108 extPropData */case 0x04:break;/* foreground color */case 0x05:break;/* background color */case 0x06:break;/* gradient fill */case 0x07:break;/* top cell border color */case 0x08:break;/* bottom cell border color */case 0x09:break;/* left cell border color */case 0x0a:break;/* right cell border color */case 0x0b:break;/* diagonal cell border color */case 0x0d:/* text color */break;case 0x0e:break;/* font scheme */case 0x0f:break;/* indentation level */}});}/* 18.6 Calculation Chain */function parse_cc_xml(data){var d=[];if(!data)return d;var i=1;(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case'<?xml':break;/* 18.6.2  calcChain CT_CalcChain 1 */case'<calcChain':case'<calcChain>':case'</calcChain>':break;/* 18.6.1  c CT_CalcCell 1 */case'<c':delete y[0];if(y.i)i=y.i;else y.i=i;d.push(y);break;}});return d;}//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */function parse_BrtCalcChainItem$(data){var out={};out.i=data.read_shift(4);var cell={};cell.r=data.read_shift(4);cell.c=data.read_shift(4);out.r=encode_cell(cell);var flags=data.read_shift(1);if(flags&0x2)out.l='1';if(flags&0x8)out.a='1';return out;}/* 18.6 Calculation Chain */function parse_cc_bin(data,name,opts){var out=[];var pass=false;recordhopper(data,function hopper_cc(val,R_n,RT){switch(RT){case 0x003F:/* 'BrtCalcChainItem$' */out.push(val);break;default:if((R_n||"").indexOf("Begin")>0){/* empty */}else if((R_n||"").indexOf("End")>0){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}});return out;}//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */function parse_xlink_xml(){//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}/* [MS-XLSB] 2.1.7.25 External Link */function parse_xlink_bin(data,rel,name,_opts){if(!data)return data;var opts=_opts||{};var pass=false,end=false;recordhopper(data,function xlink_parse(val,R_n,RT){if(end)return;switch(RT){case 0x0167:/* 'BrtSupTabs' */case 0x016B:/* 'BrtExternTableStart' */case 0x016C:/* 'BrtExternTableEnd' */case 0x016E:/* 'BrtExternRowHdr' */case 0x016F:/* 'BrtExternCellBlank' */case 0x0170:/* 'BrtExternCellReal' */case 0x0171:/* 'BrtExternCellBool' */case 0x0172:/* 'BrtExternCellError' */case 0x0173:/* 'BrtExternCellString' */case 0x01D8:/* 'BrtExternValueMeta' */case 0x0241:/* 'BrtSupNameStart' */case 0x0242:/* 'BrtSupNameValueStart' */case 0x0243:/* 'BrtSupNameValueEnd' */case 0x0244:/* 'BrtSupNameNum' */case 0x0245:/* 'BrtSupNameErr' */case 0x0246:/* 'BrtSupNameSt' */case 0x0247:/* 'BrtSupNameNil' */case 0x0248:/* 'BrtSupNameBool' */case 0x0249:/* 'BrtSupNameFmla' */case 0x024A:/* 'BrtSupNameBits' */case 0x024B:/* 'BrtSupNameEnd' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;default:if((R_n||"").indexOf("Begin")>0){/* empty */}else if((R_n||"").indexOf("End")>0){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT.toString(16)+" "+R_n);}},opts);}/* 20.5 DrawingML - SpreadsheetML Drawing */RELS.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";RELS.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";/* 20.5.2.35 wsDr CT_Drawing */function parse_drawing(data,rels){if(!data)return"??";/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/var id=(data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return rels['!id'][id].Target;}/* L.5.5.2 SpreadsheetML Comments + VML Schema */var _shapeid=1024;function write_comments_vml(rId,comments){var csize=[21600,21600];/* L.5.2.1.2 Path Attribute */var bbox=["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");var o=[writextag("xml",null,{'xmlns:v':XLMLNS.v,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:mv':XLMLNS.mv}).replace(/\/>/,">"),writextag("o:shapelayout",writextag("o:idmap",null,{'v:ext':"edit",'data':rId}),{'v:ext':"edit"}),writextag("v:shapetype",[writextag("v:stroke",null,{joinstyle:"miter"}),writextag("v:path",null,{gradientshapeok:"t",'o:connecttype':"rect"})].join(""),{id:"_x0000_t202",'o:spt':202,coordsize:csize.join(","),path:bbox})];while(_shapeid<rId*1000)_shapeid+=1000;comments.forEach(function(x){var c=decode_cell(x[0]);var fillopts={'color2':"#BEFF82",'type':"gradient"};if(fillopts.type=="gradient")fillopts.angle="-180";var fillparm=fillopts.type=="gradient"?writextag("o:fill",null,{type:"gradientUnscaled",'v:ext':"view"}):null;var fillxml=writextag('v:fill',fillparm,fillopts);var shadata={on:"t",'obscured':"t"};++_shapeid;o=o.concat(['<v:shape'+wxt_helper({id:'_x0000_s'+_shapeid,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(x[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+'>',fillxml,writextag("v:shadow",null,shadata),writextag("v:path",null,{'o:connecttype':"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">','<x:MoveWithCells/>','<x:SizeWithCells/>',/* Part 4 19.4.2.3 Anchor (Anchor) */writetag('x:Anchor',[c.c+1,0,c.r+1,0,c.c+3,20,c.r+5,20].join(",")),writetag('x:AutoFill',"False"),writetag('x:Row',String(c.r)),writetag('x:Column',String(c.c)),x[1].hidden?'':'<x:Visible/>','</x:ClientData>','</v:shape>']);});o.push('</xml>');return o.join("");}RELS.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function sheet_insert_comments(sheet,comments){var dense=Array.isArray(sheet);var cell;comments.forEach(function(comment){var r=decode_cell(comment.ref);if(dense){if(!sheet[r.r])sheet[r.r]=[];cell=sheet[r.r][r.c];}else cell=sheet[comment.ref];if(!cell){cell={t:"z"};if(dense)sheet[r.r][r.c]=cell;else sheet[comment.ref]=cell;var range=safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");if(range.s.r>r.r)range.s.r=r.r;if(range.e.r<r.r)range.e.r=r.r;if(range.s.c>r.c)range.s.c=r.c;if(range.e.c<r.c)range.e.c=r.c;var encoded=encode_range(range);if(encoded!==sheet["!ref"])sheet["!ref"]=encoded;}if(!cell.c)cell.c=[];var o={a:comment.author,t:comment.t,r:comment.r};if(comment.h)o.h=comment.h;cell.c.push(o);});}/* 18.7 Comments */function parse_comments_xml(data,opts){/* 18.7.6 CT_Comments */if(data.match(/<(?:\w+:)?comments *\/>/))return[];var authors=[];var commentList=[];var authtag=data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(authtag&&authtag[1])authtag[1].split(/<\/\w*:?author>/).forEach(function(x){if(x===""||x.trim()==="")return;var a=x.match(/<(?:\w+:)?author[^>]*>(.*)/);if(a)authors.push(a[1]);});var cmnttag=data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(cmnttag&&cmnttag[1])cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x){if(x===""||x.trim()==="")return;var cm=x.match(/<(?:\w+:)?comment[^>]*>/);if(!cm)return;var y=parsexmltag(cm[0]);var comment={author:y.authorId&&authors[y.authorId]||"sheetjsghost",ref:y.ref,guid:y.guid};var cell=decode_cell(y.ref);if(opts.sheetRows&&opts.sheetRows<=cell.r)return;var textMatch=x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var rt=!!textMatch&&!!textMatch[1]&&parse_si(textMatch[1])||{r:"",t:"",h:""};comment.r=rt.r;if(rt.r=="<t></t>")rt.t=rt.h="";comment.t=(rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(opts.cellHTML)comment.h=rt.h;commentList.push(comment);});return commentList;}var CMNT_XML_ROOT=writextag('comments',null,{'xmlns':XMLNS.main[0]});function write_comments_xml(data){var o=[XML_HEADER,CMNT_XML_ROOT];var iauthor=[];o.push("<authors>");data.forEach(function(x){x[1].forEach(function(w){var a=escapexml(w.a);if(iauthor.indexOf(a)>-1)return;iauthor.push(a);o.push("<author>"+a+"</author>");});});o.push("</authors>");o.push("<commentList>");data.forEach(function(d){d[1].forEach(function(c){/* 18.7.3 CT_Comment */o.push('<comment ref="'+d[0]+'" authorId="'+iauthor.indexOf(escapexml(c.a))+'"><text>');o.push(writetag("t",c.t==null?"":escapexml(c.t)));o.push('</text></comment>');});});o.push("</commentList>");if(o.length>2){o[o.length]='</comments>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.28 BrtBeginComment */function parse_BrtBeginComment(data){var out={};out.iauthor=data.read_shift(4);var rfx=parse_UncheckedRfX(data,16);out.rfx=rfx.s;out.ref=encode_cell(rfx.s);data.l+=16;/*var guid = parse_GUID(data); */return out;}function write_BrtBeginComment(data,o){if(o==null)o=new_buf(36);o.write_shift(4,data[1].iauthor);write_UncheckedRfX(data[0],o);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLSB] 2.4.327 BrtCommentAuthor */var parse_BrtCommentAuthor=parse_XLWideString;function write_BrtCommentAuthor(data){return write_XLWideString(data.slice(0,54));}/* [MS-XLSB] 2.1.7.8 Comments */function parse_comments_bin(data,opts){var out=[];var authors=[];var c={};var pass=false;recordhopper(data,function hopper_cmnt(val,R_n,RT){switch(RT){case 0x0278:/* 'BrtCommentAuthor' */authors.push(val);break;case 0x027B:/* 'BrtBeginComment' */c=val;break;case 0x027D:/* 'BrtCommentText' */c.t=val.t;c.h=val.h;c.r=val.r;break;case 0x027C:/* 'BrtEndComment' */c.author=authors[c.iauthor];delete c.iauthor;if(opts.sheetRows&&c.rfx&&opts.sheetRows<=c.rfx.r)break;if(!c.t)c.t="";delete c.rfx;out.push(c);break;case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */break;case 0x0026:/* 'BrtACEnd' */break;default:if((R_n||"").indexOf("Begin")>0){/* empty */}else if((R_n||"").indexOf("End")>0){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}});return out;}function write_comments_bin(data){var ba=buf_array();var iauthor=[];write_record(ba,"BrtBeginComments");write_record(ba,"BrtBeginCommentAuthors");data.forEach(function(comment){comment[1].forEach(function(c){if(iauthor.indexOf(c.a)>-1)return;iauthor.push(c.a.slice(0,54));write_record(ba,"BrtCommentAuthor",write_BrtCommentAuthor(c.a));});});write_record(ba,"BrtEndCommentAuthors");write_record(ba,"BrtBeginCommentList");data.forEach(function(comment){comment[1].forEach(function(c){c.iauthor=iauthor.indexOf(c.a);var range={s:decode_cell(comment[0]),e:decode_cell(comment[0])};write_record(ba,"BrtBeginComment",write_BrtBeginComment([range,c]));if(c.t&&c.t.length>0)write_record(ba,"BrtCommentText",write_BrtCommentText(c));write_record(ba,"BrtEndComment");delete c.iauthor;});});write_record(ba,"BrtEndCommentList");write_record(ba,"BrtEndComments");return ba.end();}var CT_VBA="application/vnd.ms-office.vbaProject";function make_vba_xls(cfb){var newcfb=CFB.utils.cfb_new({root:"R"});cfb.FullPaths.forEach(function(p,i){if(p.slice(-1)==="/"||!p.match(/_VBA_PROJECT_CUR/))return;var newpath=p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");CFB.utils.cfb_add(newcfb,newpath,cfb.FileIndex[i].content);});return CFB.write(newcfb);}function fill_vba_xls(cfb,vba){vba.FullPaths.forEach(function(p,i){if(i==0)return;var newpath=p.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(newpath.slice(-1)!=="/")CFB.utils.cfb_add(cfb,newpath,vba.FileIndex[i].content);});}var VBAFMTS=["xlsb","xlsm","xlam","biff8","xla"];RELS.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";RELS.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";/* macro and dialog sheet stubs */function parse_ds_bin(){return{'!type':'dialog'};}function parse_ds_xml(){return{'!type':'dialog'};}function parse_ms_bin(){return{'!type':'macro'};}function parse_ms_xml(){return{'!type':'macro'};}/* TODO: it will be useful to parse the function str */var rc_to_a1=function(){var rcregex=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var rcbase={r:0,c:0};function rcfunc($$,$1,$2,$3){var cRel=false,rRel=false;if($2.length==0)rRel=true;else if($2.charAt(0)=="["){rRel=true;$2=$2.slice(1,-1);}if($3.length==0)cRel=true;else if($3.charAt(0)=="["){cRel=true;$3=$3.slice(1,-1);}var R=$2.length>0?parseInt($2,10)|0:0,C=$3.length>0?parseInt($3,10)|0:0;if(cRel)C+=rcbase.c;else--C;if(rRel)R+=rcbase.r;else--R;return $1+(cRel?"":"$")+encode_col(C)+(rRel?"":"$")+encode_row(R);}return function rc_to_a1(fstr,base){rcbase=base;return fstr.replace(rcregex,rcfunc);};}();var crefregex=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var a1_to_rc=function(){return function a1_to_rc(fstr,base){return fstr.replace(crefregex,function($0,$1,$2,$3,$4,$5){var c=decode_col($3)-($2?0:base.c);var r=decode_row($5)-($4?0:base.r);var R=r==0?"":!$4?"["+r+"]":r+1;var C=c==0?"":!$2?"["+c+"]":c+1;return $1+"R"+R+"C"+C;});};}();/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */function shift_formula_str(f,delta){return f.replace(crefregex,function($0,$1,$2,$3,$4,$5){return $1+($2=="$"?$2+$3:encode_col(decode_col($3)+delta.c))+($4=="$"?$4+$5:encode_row(decode_row($5)+delta.r));});}function shift_formula_xlsx(f,range,cell){var r=decode_range(range),s=r.s,c=decode_cell(cell);var delta={r:c.r-s.r,c:c.c-s.c};return shift_formula_str(f,delta);}/* TODO: parse formula */function fuzzyfmla(f){if(f.length==1)return false;return true;}function _xlfn(f){return f.replace(/_xlfn\./g,"");}function parseread1(blob){blob.l+=1;return;}/* [MS-XLS] 2.5.51 */function parse_ColRelU(blob,length){var c=blob.read_shift(length==1?1:2);return[c&0x3FFF,c>>14&1,c>>15&1];}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */function parse_RgceArea(blob,length,opts){var w=2;if(opts){if(opts.biff>=2&&opts.biff<=5)return parse_RgceArea_BIFF2(blob,length,opts);else if(opts.biff==12)w=4;}var r=blob.read_shift(w),R=blob.read_shift(w);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* BIFF 2-5 encodes flags in the row field */function parse_RgceArea_BIFF2(blob){var r=parse_ColRelU(blob,2),R=parse_ColRelU(blob,2);var c=blob.read_shift(1);var C=blob.read_shift(1);return{s:{r:r[0],c:c,cRel:r[1],rRel:r[2]},e:{r:R[0],c:C,cRel:R[1],rRel:R[2]}};}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */function parse_RgceAreaRel(blob,length,opts){if(opts.biff<8)return parse_RgceArea_BIFF2(blob,length,opts);var r=blob.read_shift(opts.biff==12?4:2),R=blob.read_shift(opts.biff==12?4:2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */function parse_RgceLoc(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<=5)return parse_RgceLoc_BIFF2(blob,length,opts);var r=blob.read_shift(opts&&opts.biff==12?4:2);var c=parse_ColRelU(blob,2);return{r:r,c:c[0],cRel:c[1],rRel:c[2]};}function parse_RgceLoc_BIFF2(blob){var r=parse_ColRelU(blob,2);var c=blob.read_shift(1);return{r:r[0],c:c,cRel:r[1],rRel:r[2]};}/* [MS-XLS] 2.5.198.107, 2.5.47 */function parse_RgceElfLoc(blob){var r=blob.read_shift(2);var c=blob.read_shift(2);return{r:r,c:c&0xFF,fQuoted:!!(c&0x4000),cRel:c>>15,rRel:c>>15};}/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */function parse_RgceLocRel(blob,length,opts){var biff=opts&&opts.biff?opts.biff:8;if(biff>=2&&biff<=5)return parse_RgceLocRel_BIFF2(blob,length,opts);var r=blob.read_shift(biff>=12?4:2);var cl=blob.read_shift(2);var cRel=(cl&0x4000)>>14,rRel=(cl&0x8000)>>15;cl&=0x3FFF;if(rRel==1)while(r>0x7FFFF)r-=0x100000;if(cRel==1)while(cl>0x1FFF)cl=cl-0x4000;return{r:r,c:cl,cRel:cRel,rRel:rRel};}function parse_RgceLocRel_BIFF2(blob){var rl=blob.read_shift(2);var c=blob.read_shift(1);var rRel=(rl&0x8000)>>15,cRel=(rl&0x4000)>>14;rl&=0x3FFF;if(rRel==1&&rl>=0x2000)rl=rl-0x4000;if(cRel==1&&c>=0x80)c=c-0x100;return{r:rl,c:c,cRel:cRel,rRel:rRel};}/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */function parse_PtgArea(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceArea(blob,opts.biff>=2&&opts.biff<=5?6:8,opts);return[type,area];}/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */function parse_PtgArea3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2,'i');var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}var area=parse_RgceArea(blob,w,opts);return[type,ixti,area];}/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */function parse_PtgAreaErr(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts&&opts.biff>8?12:opts.biff<8?6:8;return[type];}/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */function parse_PtgAreaErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}blob.l+=w;return[type,ixti];}/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */function parse_PtgAreaN(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceAreaRel(blob,length-1,opts);return[type,area];}/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */function parse_PtgArray(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts.biff==2?6:opts.biff==12?14:7;return[type];}/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */function parse_PtgAttrBaxcel(blob){var bitSemi=blob[blob.l+1]&0x01;/* 1 = volatile */var bitBaxcel=1;blob.l+=4;return[bitSemi,bitBaxcel];}/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */function parse_PtgAttrChoose(blob,length,opts){blob.l+=2;var offset=blob.read_shift(opts&&opts.biff==2?1:2);var o=[];/* offset is 1 less than the number of elements */for(var i=0;i<=offset;++i)o.push(blob.read_shift(opts&&opts.biff==2?1:2));return o;}/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */function parse_PtgAttrGoto(blob,length,opts){var bitGoto=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitGoto,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */function parse_PtgAttrIf(blob,length,opts){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLSB] 2.5.97.28 */function parse_PtgAttrIfError(blob){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(2)];}/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */function parse_PtgAttrSemi(blob,length,opts){var bitSemi=blob[blob.l+1]&0xFF?1:0;blob.l+=opts&&opts.biff==2?3:4;return[bitSemi];}/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */function parse_PtgAttrSpaceType(blob){var type=blob.read_shift(1),cch=blob.read_shift(1);return[type,cch];}/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */function parse_PtgAttrSpace(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */function parse_PtgAttrSpaceSemi(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */function parse_PtgRef(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLoc(blob,0,opts);return[type,loc];}/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */function parse_PtgRefN(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLocRel(blob,0,opts);return[type,loc];}/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */function parse_PtgRef3d(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var ixti=blob.read_shift(2);// XtiIndex
if(opts&&opts.biff==5)blob.l+=12;var loc=parse_RgceLoc(blob,0,opts);// TODO: or RgceLocRel
return[type,ixti,loc];}/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */function parse_PtgFunc(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var iftab=blob.read_shift(opts&&opts.biff<=3?1:2);return[FtabArgc[iftab],Ftab[iftab],type];}/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */function parse_PtgFuncVar(blob,length,opts){var type=blob[blob.l++];var cparams=blob.read_shift(1),tab=opts&&opts.biff<=3?[type==0x58?-1:0,blob.read_shift(1)]:parsetab(blob);return[cparams,(tab[0]===0?Ftab:Cetab)[tab[1]]];}function parsetab(blob){return[blob[blob.l+1]>>7,blob.read_shift(2)&0x7FFF];}/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */function parse_PtgAttrSum(blob,length,opts){blob.l+=opts&&opts.biff==2?3:4;return;}/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */function parse_PtgExp(blob,length,opts){blob.l++;if(opts&&opts.biff==12)return[blob.read_shift(4,'i'),0];var row=blob.read_shift(2);var col=blob.read_shift(opts&&opts.biff==2?1:2);return[row,col];}/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */function parse_PtgErr(blob){blob.l++;return BErr[blob.read_shift(1)];}/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */function parse_PtgInt(blob){blob.l++;return blob.read_shift(2);}/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */function parse_PtgBool(blob){blob.l++;return blob.read_shift(1)!==0;}/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */function parse_PtgNum(blob){blob.l++;return parse_Xnum(blob,8);}/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */function parse_PtgStr(blob,length,opts){blob.l++;return parse_ShortXLUnicodeString(blob,length-1,opts);}/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */function parse_SerAr(blob,biff){var val=[blob.read_shift(1)];if(biff==12)switch(val[0]){case 0x02:val[0]=0x04;break;/* SerBool */case 0x04:val[0]=0x10;break;/* SerErr */case 0x00:val[0]=0x01;break;/* SerNum */case 0x01:val[0]=0x02;break;/* SerStr */}switch(val[0]){case 0x04:/* SerBool -- boolean */val[1]=parsebool(blob,1)?'TRUE':'FALSE';if(biff!=12)blob.l+=7;break;case 0x25:/* appears to be an alias */case 0x10:/* SerErr -- error */val[1]=BErr[blob[blob.l]];blob.l+=biff==12?4:8;break;case 0x00:/* SerNil -- honestly, I'm not sure how to reproduce this */blob.l+=8;break;case 0x01:/* SerNum -- Xnum */val[1]=parse_Xnum(blob,8);break;case 0x02:/* SerStr -- XLUnicodeString (<256 chars) */val[1]=parse_XLUnicodeString2(blob,0,{biff:biff>0&&biff<8?2:biff});break;default:throw new Error("Bad SerAr: "+val[0]);/* Unreachable */}return val;}/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */function parse_PtgExtraMem(blob,cce,opts){var count=blob.read_shift(opts.biff==12?4:2);var out=[];for(var i=0;i!=count;++i)out.push((opts.biff==12?parse_UncheckedRfX:parse_Ref8U)(blob,8));return out;}/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */function parse_PtgExtraArray(blob,length,opts){var rows=0,cols=0;if(opts.biff==12){rows=blob.read_shift(4);// DRw
cols=blob.read_shift(4);// DCol
}else{cols=1+blob.read_shift(1);//DColByteU
rows=1+blob.read_shift(2);//DRw
}if(opts.biff>=2&&opts.biff<8){--rows;if(--cols==0)cols=0x100;}// $FlowIgnore
for(var i=0,o=[];i!=rows&&(o[i]=[]);++i)for(var j=0;j!=cols;++j)o[i][j]=parse_SerAr(blob,opts.biff);return o;}/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */function parse_PtgName(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var w=!opts||opts.biff>=8?4:2;var nameindex=blob.read_shift(w);switch(opts.biff){case 2:blob.l+=5;break;case 3:case 4:blob.l+=8;break;case 5:blob.l+=12;break;}return[type,0,nameindex];}/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */function parse_PtgNameX(blob,length,opts){if(opts.biff==5)return parse_PtgNameX_BIFF5(blob,length,opts);var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2);// XtiIndex
var nameindex=blob.read_shift(4);return[type,ixti,nameindex];}function parse_PtgNameX_BIFF5(blob){var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2,'i');// XtiIndex
blob.l+=8;var nameindex=blob.read_shift(2);blob.l+=12;return[type,ixti,nameindex];}/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */function parse_PtgMemArea(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=opts&&opts.biff==2?3:4;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */function parse_PtgMemFunc(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */function parse_PtgRefErr(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=4;if(opts.biff<8)blob.l--;if(opts.biff==12)blob.l+=2;return[type];}/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */function parse_PtgRefErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=4;if(opts)switch(opts.biff){case 5:w=15;break;case 12:w=6;break;}blob.l+=w;return[type,ixti];}/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */var parse_PtgMemErr=parsenoop;/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */var parse_PtgMemNoMem=parsenoop;/* [MS-XLS] 2.5.198.92 */var parse_PtgTbl=parsenoop;function parse_PtgElfLoc(blob,length,opts){blob.l+=2;return[parse_RgceElfLoc(blob,4,opts)];}function parse_PtgElfNoop(blob){blob.l+=6;return[];}/* [MS-XLS] 2.5.198.46 */var parse_PtgElfCol=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.47 */var parse_PtgElfColS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.48 */var parse_PtgElfColSV=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.49 */var parse_PtgElfColV=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.50 */function parse_PtgElfLel(blob){blob.l+=2;return[parseuint16(blob),blob.read_shift(2)&0x01];}/* [MS-XLS] 2.5.198.51 */var parse_PtgElfRadical=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.52 */var parse_PtgElfRadicalLel=parse_PtgElfLel;/* [MS-XLS] 2.5.198.53 */var parse_PtgElfRadicalS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.54 */var parse_PtgElfRw=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.55 */var parse_PtgElfRwV=parse_PtgElfLoc;/* [MS-XLSB] 2.5.97.52 TODO */var PtgListRT=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function parse_PtgList(blob){blob.l+=2;var ixti=blob.read_shift(2);var flags=blob.read_shift(2);var idx=blob.read_shift(4);var c=blob.read_shift(2);var C=blob.read_shift(2);var rt=PtgListRT[flags>>2&0x1F];return{ixti:ixti,coltype:flags&0x3,rt:rt,idx:idx,c:c,C:C};}/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */function parse_PtgSxName(blob){blob.l+=2;return[blob.read_shift(4)];}/* [XLS] old spec */function parse_PtgSheet(blob,length,opts){blob.l+=5;blob.l+=2;blob.l+=opts.biff==2?1:4;return["PTGSHEET"];}function parse_PtgEndSheet(blob,length,opts){blob.l+=opts.biff==2?4:5;return["PTGENDSHEET"];}function parse_PtgMemAreaN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgMemNoMemN(blob){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgAttrNoop(blob){blob.l+=4;return[0,0];}/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */var PtgTypes={0x01:{n:'PtgExp',f:parse_PtgExp},0x02:{n:'PtgTbl',f:parse_PtgTbl},0x03:{n:'PtgAdd',f:parseread1},0x04:{n:'PtgSub',f:parseread1},0x05:{n:'PtgMul',f:parseread1},0x06:{n:'PtgDiv',f:parseread1},0x07:{n:'PtgPower',f:parseread1},0x08:{n:'PtgConcat',f:parseread1},0x09:{n:'PtgLt',f:parseread1},0x0A:{n:'PtgLe',f:parseread1},0x0B:{n:'PtgEq',f:parseread1},0x0C:{n:'PtgGe',f:parseread1},0x0D:{n:'PtgGt',f:parseread1},0x0E:{n:'PtgNe',f:parseread1},0x0F:{n:'PtgIsect',f:parseread1},0x10:{n:'PtgUnion',f:parseread1},0x11:{n:'PtgRange',f:parseread1},0x12:{n:'PtgUplus',f:parseread1},0x13:{n:'PtgUminus',f:parseread1},0x14:{n:'PtgPercent',f:parseread1},0x15:{n:'PtgParen',f:parseread1},0x16:{n:'PtgMissArg',f:parseread1},0x17:{n:'PtgStr',f:parse_PtgStr},0x1A:{n:'PtgSheet',f:parse_PtgSheet},0x1B:{n:'PtgEndSheet',f:parse_PtgEndSheet},0x1C:{n:'PtgErr',f:parse_PtgErr},0x1D:{n:'PtgBool',f:parse_PtgBool},0x1E:{n:'PtgInt',f:parse_PtgInt},0x1F:{n:'PtgNum',f:parse_PtgNum},0x20:{n:'PtgArray',f:parse_PtgArray},0x21:{n:'PtgFunc',f:parse_PtgFunc},0x22:{n:'PtgFuncVar',f:parse_PtgFuncVar},0x23:{n:'PtgName',f:parse_PtgName},0x24:{n:'PtgRef',f:parse_PtgRef},0x25:{n:'PtgArea',f:parse_PtgArea},0x26:{n:'PtgMemArea',f:parse_PtgMemArea},0x27:{n:'PtgMemErr',f:parse_PtgMemErr},0x28:{n:'PtgMemNoMem',f:parse_PtgMemNoMem},0x29:{n:'PtgMemFunc',f:parse_PtgMemFunc},0x2A:{n:'PtgRefErr',f:parse_PtgRefErr},0x2B:{n:'PtgAreaErr',f:parse_PtgAreaErr},0x2C:{n:'PtgRefN',f:parse_PtgRefN},0x2D:{n:'PtgAreaN',f:parse_PtgAreaN},0x2E:{n:'PtgMemAreaN',f:parse_PtgMemAreaN},0x2F:{n:'PtgMemNoMemN',f:parse_PtgMemNoMemN},0x39:{n:'PtgNameX',f:parse_PtgNameX},0x3A:{n:'PtgRef3d',f:parse_PtgRef3d},0x3B:{n:'PtgArea3d',f:parse_PtgArea3d},0x3C:{n:'PtgRefErr3d',f:parse_PtgRefErr3d},0x3D:{n:'PtgAreaErr3d',f:parse_PtgAreaErr3d},0xFF:{}};/* These are duplicated in the PtgTypes table */var PtgDupes={0x40:0x20,0x60:0x20,0x41:0x21,0x61:0x21,0x42:0x22,0x62:0x22,0x43:0x23,0x63:0x23,0x44:0x24,0x64:0x24,0x45:0x25,0x65:0x25,0x46:0x26,0x66:0x26,0x47:0x27,0x67:0x27,0x48:0x28,0x68:0x28,0x49:0x29,0x69:0x29,0x4A:0x2A,0x6A:0x2A,0x4B:0x2B,0x6B:0x2B,0x4C:0x2C,0x6C:0x2C,0x4D:0x2D,0x6D:0x2D,0x4E:0x2E,0x6E:0x2E,0x4F:0x2F,0x6F:0x2F,0x58:0x22,0x78:0x22,0x59:0x39,0x79:0x39,0x5A:0x3A,0x7A:0x3A,0x5B:0x3B,0x7B:0x3B,0x5C:0x3C,0x7C:0x3C,0x5D:0x3D,0x7D:0x3D};(function(){for(var y in PtgDupes)PtgTypes[y]=PtgTypes[PtgDupes[y]];})();var Ptg18={0x01:{n:'PtgElfLel',f:parse_PtgElfLel},0x02:{n:'PtgElfRw',f:parse_PtgElfRw},0x03:{n:'PtgElfCol',f:parse_PtgElfCol},0x06:{n:'PtgElfRwV',f:parse_PtgElfRwV},0x07:{n:'PtgElfColV',f:parse_PtgElfColV},0x0A:{n:'PtgElfRadical',f:parse_PtgElfRadical},0x0B:{n:'PtgElfRadicalS',f:parse_PtgElfRadicalS},0x0D:{n:'PtgElfColS',f:parse_PtgElfColS},0x0F:{n:'PtgElfColSV',f:parse_PtgElfColSV},0x10:{n:'PtgElfRadicalLel',f:parse_PtgElfRadicalLel},0x19:{n:'PtgList',f:parse_PtgList},0x1D:{n:'PtgSxName',f:parse_PtgSxName},0xFF:{}};var Ptg19={0x00:{n:'PtgAttrNoop',f:parse_PtgAttrNoop},0x01:{n:'PtgAttrSemi',f:parse_PtgAttrSemi},0x02:{n:'PtgAttrIf',f:parse_PtgAttrIf},0x04:{n:'PtgAttrChoose',f:parse_PtgAttrChoose},0x08:{n:'PtgAttrGoto',f:parse_PtgAttrGoto},0x10:{n:'PtgAttrSum',f:parse_PtgAttrSum},0x20:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},0x40:{n:'PtgAttrSpace',f:parse_PtgAttrSpace},0x41:{n:'PtgAttrSpaceSemi',f:parse_PtgAttrSpaceSemi},0x80:{n:'PtgAttrIfError',f:parse_PtgAttrIfError},0xFF:{}};Ptg19[0x21]=Ptg19[0x20];/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */function parse_RgbExtra(blob,length,rgce,opts){if(opts.biff<8)return parsenoop(blob,length);var target=blob.l+length;var o=[];for(var i=0;i!==rgce.length;++i){switch(rgce[i][0]){case'PtgArray':/* PtgArray -> PtgExtraArray */rgce[i][1]=parse_PtgExtraArray(blob,0,opts);o.push(rgce[i][1]);break;case'PtgMemArea':/* PtgMemArea -> PtgExtraMem */rgce[i][2]=parse_PtgExtraMem(blob,rgce[i][1],opts);o.push(rgce[i][2]);break;case'PtgExp':/* PtgExp -> PtgExtraCol */if(opts&&opts.biff==12){rgce[i][1][1]=blob.read_shift(4);o.push(rgce[i][1]);}break;case'PtgList':/* TODO: PtgList -> PtgExtraList */case'PtgElfRadicalS':/* TODO: PtgElfRadicalS -> PtgExtraElf */case'PtgElfColS':/* TODO: PtgElfColS -> PtgExtraElf */case'PtgElfColSV':/* TODO: PtgElfColSV -> PtgExtraElf */throw"Unsupported "+rgce[i][0];default:break;}}length=target-blob.l;/* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
if(length!==0)o.push(parsenoop(blob,length));return o;}/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */function parse_Rgce(blob,length,opts){var target=blob.l+length;var R,id,ptgs=[];while(target!=blob.l){length=target-blob.l;id=blob[blob.l];R=PtgTypes[id];if(id===0x18||id===0x19)R=(id===0x18?Ptg18:Ptg19)[blob[blob.l+1]];if(!R||!R.f){/*ptgs.push*/parsenoop(blob,length);}else{ptgs.push([R.n,R.f(blob,length,opts)]);}}return ptgs;}function stringify_array(f){var o=[];for(var i=0;i<f.length;++i){var x=f[i],r=[];for(var j=0;j<x.length;++j){var y=x[j];if(y)switch(y[0]){// TODO: handle embedded quotes
case 0x02:r.push('"'+y[1].replace(/"/g,'""')+'"');break;default:r.push(y[1]);}else r.push("");}o.push(r.join(","));}return o.join(";");}/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */var PtgBinOp={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};// List of invalid characters needs to be tested further
var quoteCharacters=new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);function formula_quote_sheet_name(sname,opts){if(!sname&&!(opts&&opts.biff<=5&&opts.biff>=2))throw new Error("empty sheet name");if(quoteCharacters.test(sname))return"'"+sname+"'";return sname;}function get_ixti_raw(supbooks,ixti,opts){if(!supbooks)return"SH33TJSERR0";if(opts.biff>8&&(!supbooks.XTI||!supbooks.XTI[ixti]))return supbooks.SheetNames[ixti];if(!supbooks.XTI)return"SH33TJSERR6";var XTI=supbooks.XTI[ixti];if(opts.biff<8){if(ixti>10000)ixti-=65536;if(ixti<0)ixti=-ixti;return ixti==0?"":supbooks.XTI[ixti-1];}if(!XTI)return"SH33TJSERR1";var o="";if(opts.biff>8)switch(supbooks[XTI[0]][0]){case 0x0165:/* 'BrtSupSelf' */o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]];return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x0166:/* 'BrtSupSame' */if(opts.SID!=null)return supbooks.SheetNames[opts.SID];return"SH33TJSSAME"+supbooks[XTI[0]][0];case 0x0163:/* 'BrtSupBookSrc' */ /* falls through */default:return"SH33TJSSRC"+supbooks[XTI[0]][0];}switch(supbooks[XTI[0]][0][0]){case 0x0401:o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]]||"SH33TJSERR3";return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x3A01:return supbooks[XTI[0]].slice(1).map(function(name){return name.Name;}).join(";;");//return "SH33TJSERR8";
default:if(!supbooks[XTI[0]][0][3])return"SH33TJSERR2";o=XTI[1]==-1?"#REF":supbooks[XTI[0]][0][3][XTI[1]]||"SH33TJSERR4";return XTI[1]==XTI[2]?o:o+":"+supbooks[XTI[0]][0][3][XTI[2]];}}function get_ixti(supbooks,ixti,opts){var ixtiraw=get_ixti_raw(supbooks,ixti,opts);return ixtiraw=="#REF"?ixtiraw:formula_quote_sheet_name(ixtiraw,opts);}function stringify_formula(formula/*Array<any>*/,range,cell,supbooks,opts){var biff=opts&&opts.biff||8;var _range=/*range != null ? range :*/{s:{c:0,r:0},e:{c:0,r:0}};var stack=[],e1,e2,c,ixti=0,nameidx=0,r,sname="";if(!formula[0]||!formula[0][0])return"";var last_sp=-1,sp="";for(var ff=0,fflen=formula[0].length;ff<fflen;++ff){var f=formula[0][ff];switch(f[0]){case'PtgUminus':/* [MS-XLS] 2.5.198.93 */stack.push("-"+stack.pop());break;case'PtgUplus':/* [MS-XLS] 2.5.198.95 */stack.push("+"+stack.pop());break;case'PtgPercent':/* [MS-XLS] 2.5.198.81 */stack.push(stack.pop()+"%");break;case'PtgAdd':/* [MS-XLS] 2.5.198.26 */case'PtgConcat':/* [MS-XLS] 2.5.198.43 */case'PtgDiv':/* [MS-XLS] 2.5.198.45 */case'PtgEq':/* [MS-XLS] 2.5.198.56 */case'PtgGe':/* [MS-XLS] 2.5.198.64 */case'PtgGt':/* [MS-XLS] 2.5.198.65 */case'PtgLe':/* [MS-XLS] 2.5.198.68 */case'PtgLt':/* [MS-XLS] 2.5.198.69 */case'PtgMul':/* [MS-XLS] 2.5.198.75 */case'PtgNe':/* [MS-XLS] 2.5.198.78 */case'PtgPower':/* [MS-XLS] 2.5.198.82 */case'PtgSub':/* [MS-XLS] 2.5.198.90 */e1=stack.pop();e2=stack.pop();if(last_sp>=0){switch(formula[0][last_sp][1][0]){case 0:// $FlowIgnore
sp=fill(" ",formula[0][last_sp][1][1]);break;case 1:// $FlowIgnore
sp=fill("\r",formula[0][last_sp][1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}e2=e2+sp;last_sp=-1;}stack.push(e2+PtgBinOp[f[0]]+e1);break;case'PtgIsect':/* [MS-XLS] 2.5.198.67 */e1=stack.pop();e2=stack.pop();stack.push(e2+" "+e1);break;case'PtgUnion':/* [MS-XLS] 2.5.198.94 */e1=stack.pop();e2=stack.pop();stack.push(e2+","+e1);break;case'PtgRange':/* [MS-XLS] 2.5.198.83 */e1=stack.pop();e2=stack.pop();stack.push(e2+":"+e1);break;case'PtgAttrChoose':/* [MS-XLS] 2.5.198.34 */break;case'PtgAttrGoto':/* [MS-XLS] 2.5.198.35 */break;case'PtgAttrIf':/* [MS-XLS] 2.5.198.36 */break;case'PtgAttrIfError':/* [MS-XLSB] 2.5.97.28 */break;case'PtgRef':/* [MS-XLS] 2.5.198.84 */c=shift_cell_xls(f[1][1],_range,opts);stack.push(encode_cell_xls(c,biff));break;case'PtgRefN':/* [MS-XLS] 2.5.198.88 */c=cell?shift_cell_xls(f[1][1],cell,opts):f[1][1];stack.push(encode_cell_xls(c,biff));break;case'PtgRef3d':/* [MS-XLS] 2.5.198.85 */ixti=f[1][1];c=shift_cell_xls(f[1][2],_range,opts);sname=get_ixti(supbooks,ixti,opts);var w=sname;/* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
stack.push(sname+"!"+encode_cell_xls(c,biff));break;case'PtgFunc':/* [MS-XLS] 2.5.198.62 */case'PtgFuncVar':/* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */var argc=f[1][0],func=f[1][1];if(!argc)argc=0;argc&=0x7F;var args=argc==0?[]:stack.slice(-argc);stack.length-=argc;if(func==='User')func=args.shift();stack.push(func+"("+args.join(",")+")");break;case'PtgBool':/* [MS-XLS] 2.5.198.42 */stack.push(f[1]?"TRUE":"FALSE");break;case'PtgInt':/* [MS-XLS] 2.5.198.66 */stack.push(f[1]);break;case'PtgNum':/* [MS-XLS] 2.5.198.79 TODO: precision? */stack.push(String(f[1]));break;case'PtgStr':/* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
stack.push('"'+f[1].replace(/"/g,'""')+'"');break;case'PtgErr':/* [MS-XLS] 2.5.198.57 */stack.push(f[1]);break;case'PtgAreaN':/* [MS-XLS] 2.5.198.31 TODO */r=shift_range_xls(f[1][1],cell?{s:cell}:_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea':/* [MS-XLS] 2.5.198.27 TODO: fixed points */r=shift_range_xls(f[1][1],_range,opts);stack.push(encode_range_xls(r,opts));break;case'PtgArea3d':/* [MS-XLS] 2.5.198.28 TODO */ixti=f[1][1];r=f[1][2];sname=get_ixti(supbooks,ixti,opts);stack.push(sname+"!"+encode_range_xls(r,opts));break;case'PtgAttrSum':/* [MS-XLS] 2.5.198.41 */stack.push("SUM("+stack.pop()+")");break;case'PtgAttrBaxcel':/* [MS-XLS] 2.5.198.33 */case'PtgAttrSemi':/* [MS-XLS] 2.5.198.37 */break;case'PtgName':/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */nameidx=f[1][2];var lbl=(supbooks.names||[])[nameidx-1]||(supbooks[0]||[])[nameidx];var name=lbl?lbl.Name:"SH33TJSNAME"+String(nameidx);if(name in XLSXFutureFunctions)name=XLSXFutureFunctions[name];stack.push(name);break;case'PtgNameX':/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */var bookidx=f[1][1];nameidx=f[1][2];var externbook;/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */if(opts.biff<=5){if(bookidx<0)bookidx=-bookidx;if(supbooks[bookidx])externbook=supbooks[bookidx][nameidx];}else{var o="";if(((supbooks[bookidx]||[])[0]||[])[0]==0x3A01){/* empty */}else if(((supbooks[bookidx]||[])[0]||[])[0]==0x0401){if(supbooks[bookidx][nameidx]&&supbooks[bookidx][nameidx].itab>0){o=supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1]+"!";}}else o=supbooks.SheetNames[nameidx-1]+"!";if(supbooks[bookidx]&&supbooks[bookidx][nameidx])o+=supbooks[bookidx][nameidx].Name;else if(supbooks[0]&&supbooks[0][nameidx])o+=supbooks[0][nameidx].Name;else{var ixtidata=(get_ixti_raw(supbooks,bookidx,opts)||"").split(";;");if(ixtidata[nameidx-1])o=ixtidata[nameidx-1];// TODO: confirm this is correct
else o+="SH33TJSERRX";}stack.push(o);break;}if(!externbook)externbook={Name:"SH33TJSERRY"};stack.push(externbook.Name);break;case'PtgParen':/* [MS-XLS] 2.5.198.80 */var lp='(',rp=')';if(last_sp>=0){sp="";switch(formula[0][last_sp][1][0]){// $FlowIgnore
case 2:lp=fill(" ",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 3:lp=fill("\r",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 4:rp=fill(" ",formula[0][last_sp][1][1])+rp;break;// $FlowIgnore
case 5:rp=fill("\r",formula[0][last_sp][1][1])+rp;break;default:// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}last_sp=-1;}stack.push(lp+stack.pop()+rp);break;case'PtgRefErr':/* [MS-XLS] 2.5.198.86 */stack.push('#REF!');break;case'PtgRefErr3d':/* [MS-XLS] 2.5.198.87 */stack.push('#REF!');break;case'PtgExp':/* [MS-XLS] 2.5.198.58 TODO */c={c:f[1][1],r:f[1][0]};var q={c:cell.c,r:cell.r};if(supbooks.sharedf[encode_cell(c)]){var parsedf=supbooks.sharedf[encode_cell(c)];stack.push(stringify_formula(parsedf,_range,q,supbooks,opts));}else{var fnd=false;for(e1=0;e1!=supbooks.arrayf.length;++e1){/* TODO: should be something like range_has */e2=supbooks.arrayf[e1];if(c.c<e2[0].s.c||c.c>e2[0].e.c)continue;if(c.r<e2[0].s.r||c.r>e2[0].e.r)continue;stack.push(stringify_formula(e2[1],_range,q,supbooks,opts));fnd=true;break;}if(!fnd)stack.push(f[1]);}break;case'PtgArray':/* [MS-XLS] 2.5.198.32 TODO */stack.push("{"+stringify_array(f[1])+"}");break;case'PtgMemArea':/* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */ //stack.push("(" + f[2].map(encode_range).join(",") + ")");
break;case'PtgAttrSpace':/* [MS-XLS] 2.5.198.38 */case'PtgAttrSpaceSemi':/* [MS-XLS] 2.5.198.39 */last_sp=ff;break;case'PtgTbl':/* [MS-XLS] 2.5.198.92 TODO */break;case'PtgMemErr':/* [MS-XLS] 2.5.198.71 */break;case'PtgMissArg':/* [MS-XLS] 2.5.198.74 */stack.push("");break;case'PtgAreaErr':/* [MS-XLS] 2.5.198.29 */stack.push("#REF!");break;case'PtgAreaErr3d':/* [MS-XLS] 2.5.198.30 */stack.push("#REF!");break;case'PtgList':/* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
stack.push("Table"+f[1].idx+"[#"+f[1].rt+"]");break;case'PtgMemAreaN':case'PtgMemNoMemN':case'PtgAttrNoop':case'PtgSheet':case'PtgEndSheet':break;case'PtgMemFunc':/* [MS-XLS] 2.5.198.72 TODO */break;case'PtgMemNoMem':/* [MS-XLS] 2.5.198.73 TODO */break;case'PtgElfCol':/* [MS-XLS] 2.5.198.46 */case'PtgElfColS':/* [MS-XLS] 2.5.198.47 */case'PtgElfColSV':/* [MS-XLS] 2.5.198.48 */case'PtgElfColV':/* [MS-XLS] 2.5.198.49 */case'PtgElfLel':/* [MS-XLS] 2.5.198.50 */case'PtgElfRadical':/* [MS-XLS] 2.5.198.51 */case'PtgElfRadicalLel':/* [MS-XLS] 2.5.198.52 */case'PtgElfRadicalS':/* [MS-XLS] 2.5.198.53 */case'PtgElfRw':/* [MS-XLS] 2.5.198.54 */case'PtgElfRwV':/* [MS-XLS] 2.5.198.55 */throw new Error("Unsupported ELFs");case'PtgSxName':/* [MS-XLS] 2.5.198.91 TODO -- find a test case */throw new Error('Unrecognized Formula Token: '+String(f));default:throw new Error('Unrecognized Formula Token: '+String(f));}var PtgNonDisp=['PtgAttrSpace','PtgAttrSpaceSemi','PtgAttrGoto'];if(opts.biff!=3)if(last_sp>=0&&PtgNonDisp.indexOf(formula[0][ff][0])==-1){f=formula[0][last_sp];var _left=true;switch(f[1][0]){/* note: some bad XLSB files omit the PtgParen */case 4:_left=false;/* falls through */case 0:// $FlowIgnore
sp=fill(" ",f[1][1]);break;case 5:_left=false;/* falls through */case 1:// $FlowIgnore
sp=fill("\r",f[1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+f[1][0]);}stack.push((_left?sp:"")+stack.pop()+(_left?"":sp));last_sp=-1;}}if(stack.length>1&&opts.WTF)throw new Error("bad formula stack");return stack[0];}/* [MS-XLS] 2.5.198.1 TODO */function parse_ArrayParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}/* [MS-XLS] 2.5.198.3 TODO */function parse_XLSCellParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}/* [MS-XLS] 2.5.198.21 */function parse_NameParsedFormula(blob,length,opts,cce){var target=blob.l+length;var rgce=parse_Rgce(blob,cce,opts);var rgcb;if(target!==blob.l)rgcb=parse_RgbExtra(blob,target-blob.l,rgce,opts);return[rgce,rgcb];}/* [MS-XLS] 2.5.198.118 TODO */function parse_SharedParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);// length of rgce
var rgce=parse_Rgce(blob,cce,opts);if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return[rgce,rgcb];}/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */function parse_FormulaValue(blob){var b;if(__readUInt16LE(blob,blob.l+6)!==0xFFFF)return[parse_Xnum(blob),'n'];switch(blob[blob.l]){case 0x00:blob.l+=8;return["String",'s'];case 0x01:b=blob[blob.l+2]===0x1;blob.l+=8;return[b,'b'];case 0x02:b=blob[blob.l+2];blob.l+=8;return[b,'e'];case 0x03:blob.l+=8;return["",'s'];}return[];}function write_FormulaValue(value){if(value==null){// Blank String Value
var o=new_buf(8);o.write_shift(1,0x03);o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0xFFFF);return o;}else if(typeof value=="number")return write_Xnum(value);return write_Xnum(0);}/* [MS-XLS] 2.4.127 TODO */function parse_Formula(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)++blob.l;var val=parse_FormulaValue(blob,8);var flags=blob.read_shift(1);if(opts.biff!=2){blob.read_shift(1);if(opts.biff>=5){/*var chn = */blob.read_shift(4);}}var cbf=parse_XLSCellParsedFormula(blob,end-blob.l,opts);return{cell:cell,val:val[0],formula:cbf,shared:flags>>3&1,tt:val[1]};}function write_Formula(cell,R,C,opts,os){// Cell
var o1=write_XLSCell(R,C,os);// FormulaValue
var o2=write_FormulaValue(cell.v);// flags + cache
var o3=new_buf(6);var flags=0x01|0x20;o3.write_shift(2,flags);o3.write_shift(4,0);// CellParsedFormula
var bf=new_buf(cell.bf.length);for(var i=0;i<cell.bf.length;++i)bf[i]=cell.bf[i];var out=bconcat([o1,o2,o3,bf]);return out;}/* XLSB Parsed Formula records have the same shape */function parse_XLSBParsedFormula(data,length,opts){var cce=data.read_shift(4);var rgce=parse_Rgce(data,cce,opts);var cb=data.read_shift(4);var rgcb=cb>0?parse_RgbExtra(data,cb,rgce,opts):null;return[rgce,rgcb];}/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */var parse_XLSBArrayParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.4 CellParsedFormula */var parse_XLSBCellParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */var parse_XLSBNameParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */var parse_XLSBSharedParsedFormula=parse_XLSBParsedFormula;/* [MS-XLS] 2.5.198.4 */var Cetab={0x0000:'BEEP',0x0001:'OPEN',0x0002:'OPEN.LINKS',0x0003:'CLOSE.ALL',0x0004:'SAVE',0x0005:'SAVE.AS',0x0006:'FILE.DELETE',0x0007:'PAGE.SETUP',0x0008:'PRINT',0x0009:'PRINTER.SETUP',0x000A:'QUIT',0x000B:'NEW.WINDOW',0x000C:'ARRANGE.ALL',0x000D:'WINDOW.SIZE',0x000E:'WINDOW.MOVE',0x000F:'FULL',0x0010:'CLOSE',0x0011:'RUN',0x0016:'SET.PRINT.AREA',0x0017:'SET.PRINT.TITLES',0x0018:'SET.PAGE.BREAK',0x0019:'REMOVE.PAGE.BREAK',0x001A:'FONT',0x001B:'DISPLAY',0x001C:'PROTECT.DOCUMENT',0x001D:'PRECISION',0x001E:'A1.R1C1',0x001F:'CALCULATE.NOW',0x0020:'CALCULATION',0x0022:'DATA.FIND',0x0023:'EXTRACT',0x0024:'DATA.DELETE',0x0025:'SET.DATABASE',0x0026:'SET.CRITERIA',0x0027:'SORT',0x0028:'DATA.SERIES',0x0029:'TABLE',0x002A:'FORMAT.NUMBER',0x002B:'ALIGNMENT',0x002C:'STYLE',0x002D:'BORDER',0x002E:'CELL.PROTECTION',0x002F:'COLUMN.WIDTH',0x0030:'UNDO',0x0031:'CUT',0x0032:'COPY',0x0033:'PASTE',0x0034:'CLEAR',0x0035:'PASTE.SPECIAL',0x0036:'EDIT.DELETE',0x0037:'INSERT',0x0038:'FILL.RIGHT',0x0039:'FILL.DOWN',0x003D:'DEFINE.NAME',0x003E:'CREATE.NAMES',0x003F:'FORMULA.GOTO',0x0040:'FORMULA.FIND',0x0041:'SELECT.LAST.CELL',0x0042:'SHOW.ACTIVE.CELL',0x0043:'GALLERY.AREA',0x0044:'GALLERY.BAR',0x0045:'GALLERY.COLUMN',0x0046:'GALLERY.LINE',0x0047:'GALLERY.PIE',0x0048:'GALLERY.SCATTER',0x0049:'COMBINATION',0x004A:'PREFERRED',0x004B:'ADD.OVERLAY',0x004C:'GRIDLINES',0x004D:'SET.PREFERRED',0x004E:'AXES',0x004F:'LEGEND',0x0050:'ATTACH.TEXT',0x0051:'ADD.ARROW',0x0052:'SELECT.CHART',0x0053:'SELECT.PLOT.AREA',0x0054:'PATTERNS',0x0055:'MAIN.CHART',0x0056:'OVERLAY',0x0057:'SCALE',0x0058:'FORMAT.LEGEND',0x0059:'FORMAT.TEXT',0x005A:'EDIT.REPEAT',0x005B:'PARSE',0x005C:'JUSTIFY',0x005D:'HIDE',0x005E:'UNHIDE',0x005F:'WORKSPACE',0x0060:'FORMULA',0x0061:'FORMULA.FILL',0x0062:'FORMULA.ARRAY',0x0063:'DATA.FIND.NEXT',0x0064:'DATA.FIND.PREV',0x0065:'FORMULA.FIND.NEXT',0x0066:'FORMULA.FIND.PREV',0x0067:'ACTIVATE',0x0068:'ACTIVATE.NEXT',0x0069:'ACTIVATE.PREV',0x006A:'UNLOCKED.NEXT',0x006B:'UNLOCKED.PREV',0x006C:'COPY.PICTURE',0x006D:'SELECT',0x006E:'DELETE.NAME',0x006F:'DELETE.FORMAT',0x0070:'VLINE',0x0071:'HLINE',0x0072:'VPAGE',0x0073:'HPAGE',0x0074:'VSCROLL',0x0075:'HSCROLL',0x0076:'ALERT',0x0077:'NEW',0x0078:'CANCEL.COPY',0x0079:'SHOW.CLIPBOARD',0x007A:'MESSAGE',0x007C:'PASTE.LINK',0x007D:'APP.ACTIVATE',0x007E:'DELETE.ARROW',0x007F:'ROW.HEIGHT',0x0080:'FORMAT.MOVE',0x0081:'FORMAT.SIZE',0x0082:'FORMULA.REPLACE',0x0083:'SEND.KEYS',0x0084:'SELECT.SPECIAL',0x0085:'APPLY.NAMES',0x0086:'REPLACE.FONT',0x0087:'FREEZE.PANES',0x0088:'SHOW.INFO',0x0089:'SPLIT',0x008A:'ON.WINDOW',0x008B:'ON.DATA',0x008C:'DISABLE.INPUT',0x008E:'OUTLINE',0x008F:'LIST.NAMES',0x0090:'FILE.CLOSE',0x0091:'SAVE.WORKBOOK',0x0092:'DATA.FORM',0x0093:'COPY.CHART',0x0094:'ON.TIME',0x0095:'WAIT',0x0096:'FORMAT.FONT',0x0097:'FILL.UP',0x0098:'FILL.LEFT',0x0099:'DELETE.OVERLAY',0x009B:'SHORT.MENUS',0x009F:'SET.UPDATE.STATUS',0x00A1:'COLOR.PALETTE',0x00A2:'DELETE.STYLE',0x00A3:'WINDOW.RESTORE',0x00A4:'WINDOW.MAXIMIZE',0x00A6:'CHANGE.LINK',0x00A7:'CALCULATE.DOCUMENT',0x00A8:'ON.KEY',0x00A9:'APP.RESTORE',0x00AA:'APP.MOVE',0x00AB:'APP.SIZE',0x00AC:'APP.MINIMIZE',0x00AD:'APP.MAXIMIZE',0x00AE:'BRING.TO.FRONT',0x00AF:'SEND.TO.BACK',0x00B9:'MAIN.CHART.TYPE',0x00BA:'OVERLAY.CHART.TYPE',0x00BB:'SELECT.END',0x00BC:'OPEN.MAIL',0x00BD:'SEND.MAIL',0x00BE:'STANDARD.FONT',0x00BF:'CONSOLIDATE',0x00C0:'SORT.SPECIAL',0x00C1:'GALLERY.3D.AREA',0x00C2:'GALLERY.3D.COLUMN',0x00C3:'GALLERY.3D.LINE',0x00C4:'GALLERY.3D.PIE',0x00C5:'VIEW.3D',0x00C6:'GOAL.SEEK',0x00C7:'WORKGROUP',0x00C8:'FILL.GROUP',0x00C9:'UPDATE.LINK',0x00CA:'PROMOTE',0x00CB:'DEMOTE',0x00CC:'SHOW.DETAIL',0x00CE:'UNGROUP',0x00CF:'OBJECT.PROPERTIES',0x00D0:'SAVE.NEW.OBJECT',0x00D1:'SHARE',0x00D2:'SHARE.NAME',0x00D3:'DUPLICATE',0x00D4:'APPLY.STYLE',0x00D5:'ASSIGN.TO.OBJECT',0x00D6:'OBJECT.PROTECTION',0x00D7:'HIDE.OBJECT',0x00D8:'SET.EXTRACT',0x00D9:'CREATE.PUBLISHER',0x00DA:'SUBSCRIBE.TO',0x00DB:'ATTRIBUTES',0x00DC:'SHOW.TOOLBAR',0x00DE:'PRINT.PREVIEW',0x00DF:'EDIT.COLOR',0x00E0:'SHOW.LEVELS',0x00E1:'FORMAT.MAIN',0x00E2:'FORMAT.OVERLAY',0x00E3:'ON.RECALC',0x00E4:'EDIT.SERIES',0x00E5:'DEFINE.STYLE',0x00F0:'LINE.PRINT',0x00F3:'ENTER.DATA',0x00F9:'GALLERY.RADAR',0x00FA:'MERGE.STYLES',0x00FB:'EDITION.OPTIONS',0x00FC:'PASTE.PICTURE',0x00FD:'PASTE.PICTURE.LINK',0x00FE:'SPELLING',0x0100:'ZOOM',0x0103:'INSERT.OBJECT',0x0104:'WINDOW.MINIMIZE',0x0109:'SOUND.NOTE',0x010A:'SOUND.PLAY',0x010B:'FORMAT.SHAPE',0x010C:'EXTEND.POLYGON',0x010D:'FORMAT.AUTO',0x0110:'GALLERY.3D.BAR',0x0111:'GALLERY.3D.SURFACE',0x0112:'FILL.AUTO',0x0114:'CUSTOMIZE.TOOLBAR',0x0115:'ADD.TOOL',0x0116:'EDIT.OBJECT',0x0117:'ON.DOUBLECLICK',0x0118:'ON.ENTRY',0x0119:'WORKBOOK.ADD',0x011A:'WORKBOOK.MOVE',0x011B:'WORKBOOK.COPY',0x011C:'WORKBOOK.OPTIONS',0x011D:'SAVE.WORKSPACE',0x0120:'CHART.WIZARD',0x0121:'DELETE.TOOL',0x0122:'MOVE.TOOL',0x0123:'WORKBOOK.SELECT',0x0124:'WORKBOOK.ACTIVATE',0x0125:'ASSIGN.TO.TOOL',0x0127:'COPY.TOOL',0x0128:'RESET.TOOL',0x0129:'CONSTRAIN.NUMERIC',0x012A:'PASTE.TOOL',0x012E:'WORKBOOK.NEW',0x0131:'SCENARIO.CELLS',0x0132:'SCENARIO.DELETE',0x0133:'SCENARIO.ADD',0x0134:'SCENARIO.EDIT',0x0135:'SCENARIO.SHOW',0x0136:'SCENARIO.SHOW.NEXT',0x0137:'SCENARIO.SUMMARY',0x0138:'PIVOT.TABLE.WIZARD',0x0139:'PIVOT.FIELD.PROPERTIES',0x013A:'PIVOT.FIELD',0x013B:'PIVOT.ITEM',0x013C:'PIVOT.ADD.FIELDS',0x013E:'OPTIONS.CALCULATION',0x013F:'OPTIONS.EDIT',0x0140:'OPTIONS.VIEW',0x0141:'ADDIN.MANAGER',0x0142:'MENU.EDITOR',0x0143:'ATTACH.TOOLBARS',0x0144:'VBAActivate',0x0145:'OPTIONS.CHART',0x0148:'VBA.INSERT.FILE',0x014A:'VBA.PROCEDURE.DEFINITION',0x0150:'ROUTING.SLIP',0x0152:'ROUTE.DOCUMENT',0x0153:'MAIL.LOGON',0x0156:'INSERT.PICTURE',0x0157:'EDIT.TOOL',0x0158:'GALLERY.DOUGHNUT',0x015E:'CHART.TREND',0x0160:'PIVOT.ITEM.PROPERTIES',0x0162:'WORKBOOK.INSERT',0x0163:'OPTIONS.TRANSITION',0x0164:'OPTIONS.GENERAL',0x0172:'FILTER.ADVANCED',0x0175:'MAIL.ADD.MAILER',0x0176:'MAIL.DELETE.MAILER',0x0177:'MAIL.REPLY',0x0178:'MAIL.REPLY.ALL',0x0179:'MAIL.FORWARD',0x017A:'MAIL.NEXT.LETTER',0x017B:'DATA.LABEL',0x017C:'INSERT.TITLE',0x017D:'FONT.PROPERTIES',0x017E:'MACRO.OPTIONS',0x017F:'WORKBOOK.HIDE',0x0180:'WORKBOOK.UNHIDE',0x0181:'WORKBOOK.DELETE',0x0182:'WORKBOOK.NAME',0x0184:'GALLERY.CUSTOM',0x0186:'ADD.CHART.AUTOFORMAT',0x0187:'DELETE.CHART.AUTOFORMAT',0x0188:'CHART.ADD.DATA',0x0189:'AUTO.OUTLINE',0x018A:'TAB.ORDER',0x018B:'SHOW.DIALOG',0x018C:'SELECT.ALL',0x018D:'UNGROUP.SHEETS',0x018E:'SUBTOTAL.CREATE',0x018F:'SUBTOTAL.REMOVE',0x0190:'RENAME.OBJECT',0x019C:'WORKBOOK.SCROLL',0x019D:'WORKBOOK.NEXT',0x019E:'WORKBOOK.PREV',0x019F:'WORKBOOK.TAB.SPLIT',0x01A0:'FULL.SCREEN',0x01A1:'WORKBOOK.PROTECT',0x01A4:'SCROLLBAR.PROPERTIES',0x01A5:'PIVOT.SHOW.PAGES',0x01A6:'TEXT.TO.COLUMNS',0x01A7:'FORMAT.CHARTTYPE',0x01A8:'LINK.FORMAT',0x01A9:'TRACER.DISPLAY',0x01AE:'TRACER.NAVIGATE',0x01AF:'TRACER.CLEAR',0x01B0:'TRACER.ERROR',0x01B1:'PIVOT.FIELD.GROUP',0x01B2:'PIVOT.FIELD.UNGROUP',0x01B3:'CHECKBOX.PROPERTIES',0x01B4:'LABEL.PROPERTIES',0x01B5:'LISTBOX.PROPERTIES',0x01B6:'EDITBOX.PROPERTIES',0x01B7:'PIVOT.REFRESH',0x01B8:'LINK.COMBO',0x01B9:'OPEN.TEXT',0x01BA:'HIDE.DIALOG',0x01BB:'SET.DIALOG.FOCUS',0x01BC:'ENABLE.OBJECT',0x01BD:'PUSHBUTTON.PROPERTIES',0x01BE:'SET.DIALOG.DEFAULT',0x01BF:'FILTER',0x01C0:'FILTER.SHOW.ALL',0x01C1:'CLEAR.OUTLINE',0x01C2:'FUNCTION.WIZARD',0x01C3:'ADD.LIST.ITEM',0x01C4:'SET.LIST.ITEM',0x01C5:'REMOVE.LIST.ITEM',0x01C6:'SELECT.LIST.ITEM',0x01C7:'SET.CONTROL.VALUE',0x01C8:'SAVE.COPY.AS',0x01CA:'OPTIONS.LISTS.ADD',0x01CB:'OPTIONS.LISTS.DELETE',0x01CC:'SERIES.AXES',0x01CD:'SERIES.X',0x01CE:'SERIES.Y',0x01CF:'ERRORBAR.X',0x01D0:'ERRORBAR.Y',0x01D1:'FORMAT.CHART',0x01D2:'SERIES.ORDER',0x01D3:'MAIL.LOGOFF',0x01D4:'CLEAR.ROUTING.SLIP',0x01D5:'APP.ACTIVATE.MICROSOFT',0x01D6:'MAIL.EDIT.MAILER',0x01D7:'ON.SHEET',0x01D8:'STANDARD.WIDTH',0x01D9:'SCENARIO.MERGE',0x01DA:'SUMMARY.INFO',0x01DB:'FIND.FILE',0x01DC:'ACTIVE.CELL.FONT',0x01DD:'ENABLE.TIPWIZARD',0x01DE:'VBA.MAKE.ADDIN',0x01E0:'INSERTDATATABLE',0x01E1:'WORKGROUP.OPTIONS',0x01E2:'MAIL.SEND.MAILER',0x01E5:'AUTOCORRECT',0x01E9:'POST.DOCUMENT',0x01EB:'PICKLIST',0x01ED:'VIEW.SHOW',0x01EE:'VIEW.DEFINE',0x01EF:'VIEW.DELETE',0x01FD:'SHEET.BACKGROUND',0x01FE:'INSERT.MAP.OBJECT',0x01FF:'OPTIONS.MENONO',0x0205:'MSOCHECKS',0x0206:'NORMAL',0x0207:'LAYOUT',0x0208:'RM.PRINT.AREA',0x0209:'CLEAR.PRINT.AREA',0x020A:'ADD.PRINT.AREA',0x020B:'MOVE.BRK',0x0221:'HIDECURR.NOTE',0x0222:'HIDEALL.NOTES',0x0223:'DELETE.NOTE',0x0224:'TRAVERSE.NOTES',0x0225:'ACTIVATE.NOTES',0x026C:'PROTECT.REVISIONS',0x026D:'UNPROTECT.REVISIONS',0x0287:'OPTIONS.ME',0x028D:'WEB.PUBLISH',0x029B:'NEWWEBQUERY',0x02A1:'PIVOT.TABLE.CHART',0x02F1:'OPTIONS.SAVE',0x02F3:'OPTIONS.SPELL',0x0328:'HIDEALL.INKANNOTS'};/* [MS-XLS] 2.5.198.17 */ /* [MS-XLSB] 2.5.97.10 */var Ftab={0x0000:'COUNT',0x0001:'IF',0x0002:'ISNA',0x0003:'ISERROR',0x0004:'SUM',0x0005:'AVERAGE',0x0006:'MIN',0x0007:'MAX',0x0008:'ROW',0x0009:'COLUMN',0x000A:'NA',0x000B:'NPV',0x000C:'STDEV',0x000D:'DOLLAR',0x000E:'FIXED',0x000F:'SIN',0x0010:'COS',0x0011:'TAN',0x0012:'ATAN',0x0013:'PI',0x0014:'SQRT',0x0015:'EXP',0x0016:'LN',0x0017:'LOG10',0x0018:'ABS',0x0019:'INT',0x001A:'SIGN',0x001B:'ROUND',0x001C:'LOOKUP',0x001D:'INDEX',0x001E:'REPT',0x001F:'MID',0x0020:'LEN',0x0021:'VALUE',0x0022:'TRUE',0x0023:'FALSE',0x0024:'AND',0x0025:'OR',0x0026:'NOT',0x0027:'MOD',0x0028:'DCOUNT',0x0029:'DSUM',0x002A:'DAVERAGE',0x002B:'DMIN',0x002C:'DMAX',0x002D:'DSTDEV',0x002E:'VAR',0x002F:'DVAR',0x0030:'TEXT',0x0031:'LINEST',0x0032:'TREND',0x0033:'LOGEST',0x0034:'GROWTH',0x0035:'GOTO',0x0036:'HALT',0x0037:'RETURN',0x0038:'PV',0x0039:'FV',0x003A:'NPER',0x003B:'PMT',0x003C:'RATE',0x003D:'MIRR',0x003E:'IRR',0x003F:'RAND',0x0040:'MATCH',0x0041:'DATE',0x0042:'TIME',0x0043:'DAY',0x0044:'MONTH',0x0045:'YEAR',0x0046:'WEEKDAY',0x0047:'HOUR',0x0048:'MINUTE',0x0049:'SECOND',0x004A:'NOW',0x004B:'AREAS',0x004C:'ROWS',0x004D:'COLUMNS',0x004E:'OFFSET',0x004F:'ABSREF',0x0050:'RELREF',0x0051:'ARGUMENT',0x0052:'SEARCH',0x0053:'TRANSPOSE',0x0054:'ERROR',0x0055:'STEP',0x0056:'TYPE',0x0057:'ECHO',0x0058:'SET.NAME',0x0059:'CALLER',0x005A:'DEREF',0x005B:'WINDOWS',0x005C:'SERIES',0x005D:'DOCUMENTS',0x005E:'ACTIVE.CELL',0x005F:'SELECTION',0x0060:'RESULT',0x0061:'ATAN2',0x0062:'ASIN',0x0063:'ACOS',0x0064:'CHOOSE',0x0065:'HLOOKUP',0x0066:'VLOOKUP',0x0067:'LINKS',0x0068:'INPUT',0x0069:'ISREF',0x006A:'GET.FORMULA',0x006B:'GET.NAME',0x006C:'SET.VALUE',0x006D:'LOG',0x006E:'EXEC',0x006F:'CHAR',0x0070:'LOWER',0x0071:'UPPER',0x0072:'PROPER',0x0073:'LEFT',0x0074:'RIGHT',0x0075:'EXACT',0x0076:'TRIM',0x0077:'REPLACE',0x0078:'SUBSTITUTE',0x0079:'CODE',0x007A:'NAMES',0x007B:'DIRECTORY',0x007C:'FIND',0x007D:'CELL',0x007E:'ISERR',0x007F:'ISTEXT',0x0080:'ISNUMBER',0x0081:'ISBLANK',0x0082:'T',0x0083:'N',0x0084:'FOPEN',0x0085:'FCLOSE',0x0086:'FSIZE',0x0087:'FREADLN',0x0088:'FREAD',0x0089:'FWRITELN',0x008A:'FWRITE',0x008B:'FPOS',0x008C:'DATEVALUE',0x008D:'TIMEVALUE',0x008E:'SLN',0x008F:'SYD',0x0090:'DDB',0x0091:'GET.DEF',0x0092:'REFTEXT',0x0093:'TEXTREF',0x0094:'INDIRECT',0x0095:'REGISTER',0x0096:'CALL',0x0097:'ADD.BAR',0x0098:'ADD.MENU',0x0099:'ADD.COMMAND',0x009A:'ENABLE.COMMAND',0x009B:'CHECK.COMMAND',0x009C:'RENAME.COMMAND',0x009D:'SHOW.BAR',0x009E:'DELETE.MENU',0x009F:'DELETE.COMMAND',0x00A0:'GET.CHART.ITEM',0x00A1:'DIALOG.BOX',0x00A2:'CLEAN',0x00A3:'MDETERM',0x00A4:'MINVERSE',0x00A5:'MMULT',0x00A6:'FILES',0x00A7:'IPMT',0x00A8:'PPMT',0x00A9:'COUNTA',0x00AA:'CANCEL.KEY',0x00AB:'FOR',0x00AC:'WHILE',0x00AD:'BREAK',0x00AE:'NEXT',0x00AF:'INITIATE',0x00B0:'REQUEST',0x00B1:'POKE',0x00B2:'EXECUTE',0x00B3:'TERMINATE',0x00B4:'RESTART',0x00B5:'HELP',0x00B6:'GET.BAR',0x00B7:'PRODUCT',0x00B8:'FACT',0x00B9:'GET.CELL',0x00BA:'GET.WORKSPACE',0x00BB:'GET.WINDOW',0x00BC:'GET.DOCUMENT',0x00BD:'DPRODUCT',0x00BE:'ISNONTEXT',0x00BF:'GET.NOTE',0x00C0:'NOTE',0x00C1:'STDEVP',0x00C2:'VARP',0x00C3:'DSTDEVP',0x00C4:'DVARP',0x00C5:'TRUNC',0x00C6:'ISLOGICAL',0x00C7:'DCOUNTA',0x00C8:'DELETE.BAR',0x00C9:'UNREGISTER',0x00CC:'USDOLLAR',0x00CD:'FINDB',0x00CE:'SEARCHB',0x00CF:'REPLACEB',0x00D0:'LEFTB',0x00D1:'RIGHTB',0x00D2:'MIDB',0x00D3:'LENB',0x00D4:'ROUNDUP',0x00D5:'ROUNDDOWN',0x00D6:'ASC',0x00D7:'DBCS',0x00D8:'RANK',0x00DB:'ADDRESS',0x00DC:'DAYS360',0x00DD:'TODAY',0x00DE:'VDB',0x00DF:'ELSE',0x00E0:'ELSE.IF',0x00E1:'END.IF',0x00E2:'FOR.CELL',0x00E3:'MEDIAN',0x00E4:'SUMPRODUCT',0x00E5:'SINH',0x00E6:'COSH',0x00E7:'TANH',0x00E8:'ASINH',0x00E9:'ACOSH',0x00EA:'ATANH',0x00EB:'DGET',0x00EC:'CREATE.OBJECT',0x00ED:'VOLATILE',0x00EE:'LAST.ERROR',0x00EF:'CUSTOM.UNDO',0x00F0:'CUSTOM.REPEAT',0x00F1:'FORMULA.CONVERT',0x00F2:'GET.LINK.INFO',0x00F3:'TEXT.BOX',0x00F4:'INFO',0x00F5:'GROUP',0x00F6:'GET.OBJECT',0x00F7:'DB',0x00F8:'PAUSE',0x00FB:'RESUME',0x00FC:'FREQUENCY',0x00FD:'ADD.TOOLBAR',0x00FE:'DELETE.TOOLBAR',0x00FF:'User',0x0100:'RESET.TOOLBAR',0x0101:'EVALUATE',0x0102:'GET.TOOLBAR',0x0103:'GET.TOOL',0x0104:'SPELLING.CHECK',0x0105:'ERROR.TYPE',0x0106:'APP.TITLE',0x0107:'WINDOW.TITLE',0x0108:'SAVE.TOOLBAR',0x0109:'ENABLE.TOOL',0x010A:'PRESS.TOOL',0x010B:'REGISTER.ID',0x010C:'GET.WORKBOOK',0x010D:'AVEDEV',0x010E:'BETADIST',0x010F:'GAMMALN',0x0110:'BETAINV',0x0111:'BINOMDIST',0x0112:'CHIDIST',0x0113:'CHIINV',0x0114:'COMBIN',0x0115:'CONFIDENCE',0x0116:'CRITBINOM',0x0117:'EVEN',0x0118:'EXPONDIST',0x0119:'FDIST',0x011A:'FINV',0x011B:'FISHER',0x011C:'FISHERINV',0x011D:'FLOOR',0x011E:'GAMMADIST',0x011F:'GAMMAINV',0x0120:'CEILING',0x0121:'HYPGEOMDIST',0x0122:'LOGNORMDIST',0x0123:'LOGINV',0x0124:'NEGBINOMDIST',0x0125:'NORMDIST',0x0126:'NORMSDIST',0x0127:'NORMINV',0x0128:'NORMSINV',0x0129:'STANDARDIZE',0x012A:'ODD',0x012B:'PERMUT',0x012C:'POISSON',0x012D:'TDIST',0x012E:'WEIBULL',0x012F:'SUMXMY2',0x0130:'SUMX2MY2',0x0131:'SUMX2PY2',0x0132:'CHITEST',0x0133:'CORREL',0x0134:'COVAR',0x0135:'FORECAST',0x0136:'FTEST',0x0137:'INTERCEPT',0x0138:'PEARSON',0x0139:'RSQ',0x013A:'STEYX',0x013B:'SLOPE',0x013C:'TTEST',0x013D:'PROB',0x013E:'DEVSQ',0x013F:'GEOMEAN',0x0140:'HARMEAN',0x0141:'SUMSQ',0x0142:'KURT',0x0143:'SKEW',0x0144:'ZTEST',0x0145:'LARGE',0x0146:'SMALL',0x0147:'QUARTILE',0x0148:'PERCENTILE',0x0149:'PERCENTRANK',0x014A:'MODE',0x014B:'TRIMMEAN',0x014C:'TINV',0x014E:'MOVIE.COMMAND',0x014F:'GET.MOVIE',0x0150:'CONCATENATE',0x0151:'POWER',0x0152:'PIVOT.ADD.DATA',0x0153:'GET.PIVOT.TABLE',0x0154:'GET.PIVOT.FIELD',0x0155:'GET.PIVOT.ITEM',0x0156:'RADIANS',0x0157:'DEGREES',0x0158:'SUBTOTAL',0x0159:'SUMIF',0x015A:'COUNTIF',0x015B:'COUNTBLANK',0x015C:'SCENARIO.GET',0x015D:'OPTIONS.LISTS.GET',0x015E:'ISPMT',0x015F:'DATEDIF',0x0160:'DATESTRING',0x0161:'NUMBERSTRING',0x0162:'ROMAN',0x0163:'OPEN.DIALOG',0x0164:'SAVE.DIALOG',0x0165:'VIEW.GET',0x0166:'GETPIVOTDATA',0x0167:'HYPERLINK',0x0168:'PHONETIC',0x0169:'AVERAGEA',0x016A:'MAXA',0x016B:'MINA',0x016C:'STDEVPA',0x016D:'VARPA',0x016E:'STDEVA',0x016F:'VARA',0x0170:'BAHTTEXT',0x0171:'THAIDAYOFWEEK',0x0172:'THAIDIGIT',0x0173:'THAIMONTHOFYEAR',0x0174:'THAINUMSOUND',0x0175:'THAINUMSTRING',0x0176:'THAISTRINGLENGTH',0x0177:'ISTHAIDIGIT',0x0178:'ROUNDBAHTDOWN',0x0179:'ROUNDBAHTUP',0x017A:'THAIYEAR',0x017B:'RTD',0x017C:'CUBEVALUE',0x017D:'CUBEMEMBER',0x017E:'CUBEMEMBERPROPERTY',0x017F:'CUBERANKEDMEMBER',0x0180:'HEX2BIN',0x0181:'HEX2DEC',0x0182:'HEX2OCT',0x0183:'DEC2BIN',0x0184:'DEC2HEX',0x0185:'DEC2OCT',0x0186:'OCT2BIN',0x0187:'OCT2HEX',0x0188:'OCT2DEC',0x0189:'BIN2DEC',0x018A:'BIN2OCT',0x018B:'BIN2HEX',0x018C:'IMSUB',0x018D:'IMDIV',0x018E:'IMPOWER',0x018F:'IMABS',0x0190:'IMSQRT',0x0191:'IMLN',0x0192:'IMLOG2',0x0193:'IMLOG10',0x0194:'IMSIN',0x0195:'IMCOS',0x0196:'IMEXP',0x0197:'IMARGUMENT',0x0198:'IMCONJUGATE',0x0199:'IMAGINARY',0x019A:'IMREAL',0x019B:'COMPLEX',0x019C:'IMSUM',0x019D:'IMPRODUCT',0x019E:'SERIESSUM',0x019F:'FACTDOUBLE',0x01A0:'SQRTPI',0x01A1:'QUOTIENT',0x01A2:'DELTA',0x01A3:'GESTEP',0x01A4:'ISEVEN',0x01A5:'ISODD',0x01A6:'MROUND',0x01A7:'ERF',0x01A8:'ERFC',0x01A9:'BESSELJ',0x01AA:'BESSELK',0x01AB:'BESSELY',0x01AC:'BESSELI',0x01AD:'XIRR',0x01AE:'XNPV',0x01AF:'PRICEMAT',0x01B0:'YIELDMAT',0x01B1:'INTRATE',0x01B2:'RECEIVED',0x01B3:'DISC',0x01B4:'PRICEDISC',0x01B5:'YIELDDISC',0x01B6:'TBILLEQ',0x01B7:'TBILLPRICE',0x01B8:'TBILLYIELD',0x01B9:'PRICE',0x01BA:'YIELD',0x01BB:'DOLLARDE',0x01BC:'DOLLARFR',0x01BD:'NOMINAL',0x01BE:'EFFECT',0x01BF:'CUMPRINC',0x01C0:'CUMIPMT',0x01C1:'EDATE',0x01C2:'EOMONTH',0x01C3:'YEARFRAC',0x01C4:'COUPDAYBS',0x01C5:'COUPDAYS',0x01C6:'COUPDAYSNC',0x01C7:'COUPNCD',0x01C8:'COUPNUM',0x01C9:'COUPPCD',0x01CA:'DURATION',0x01CB:'MDURATION',0x01CC:'ODDLPRICE',0x01CD:'ODDLYIELD',0x01CE:'ODDFPRICE',0x01CF:'ODDFYIELD',0x01D0:'RANDBETWEEN',0x01D1:'WEEKNUM',0x01D2:'AMORDEGRC',0x01D3:'AMORLINC',0x01D4:'CONVERT',0x02D4:'SHEETJS',0x01D5:'ACCRINT',0x01D6:'ACCRINTM',0x01D7:'WORKDAY',0x01D8:'NETWORKDAYS',0x01D9:'GCD',0x01DA:'MULTINOMIAL',0x01DB:'LCM',0x01DC:'FVSCHEDULE',0x01DD:'CUBEKPIMEMBER',0x01DE:'CUBESET',0x01DF:'CUBESETCOUNT',0x01E0:'IFERROR',0x01E1:'COUNTIFS',0x01E2:'SUMIFS',0x01E3:'AVERAGEIF',0x01E4:'AVERAGEIFS'};var FtabArgc={0x0002:1,/* ISNA */0x0003:1,/* ISERROR */0x000A:0,/* NA */0x000F:1,/* SIN */0x0010:1,/* COS */0x0011:1,/* TAN */0x0012:1,/* ATAN */0x0013:0,/* PI */0x0014:1,/* SQRT */0x0015:1,/* EXP */0x0016:1,/* LN */0x0017:1,/* LOG10 */0x0018:1,/* ABS */0x0019:1,/* INT */0x001A:1,/* SIGN */0x001B:2,/* ROUND */0x001E:2,/* REPT */0x001F:3,/* MID */0x0020:1,/* LEN */0x0021:1,/* VALUE */0x0022:0,/* TRUE */0x0023:0,/* FALSE */0x0026:1,/* NOT */0x0027:2,/* MOD */0x0028:3,/* DCOUNT */0x0029:3,/* DSUM */0x002A:3,/* DAVERAGE */0x002B:3,/* DMIN */0x002C:3,/* DMAX */0x002D:3,/* DSTDEV */0x002F:3,/* DVAR */0x0030:2,/* TEXT */0x0035:1,/* GOTO */0x003D:3,/* MIRR */0x003F:0,/* RAND */0x0041:3,/* DATE */0x0042:3,/* TIME */0x0043:1,/* DAY */0x0044:1,/* MONTH */0x0045:1,/* YEAR */0x0046:1,/* WEEKDAY */0x0047:1,/* HOUR */0x0048:1,/* MINUTE */0x0049:1,/* SECOND */0x004A:0,/* NOW */0x004B:1,/* AREAS */0x004C:1,/* ROWS */0x004D:1,/* COLUMNS */0x004F:2,/* ABSREF */0x0050:2,/* RELREF */0x0053:1,/* TRANSPOSE */0x0055:0,/* STEP */0x0056:1,/* TYPE */0x0059:0,/* CALLER */0x005A:1,/* DEREF */0x005E:0,/* ACTIVE.CELL */0x005F:0,/* SELECTION */0x0061:2,/* ATAN2 */0x0062:1,/* ASIN */0x0063:1,/* ACOS */0x0065:3,/* HLOOKUP */0x0066:3,/* VLOOKUP */0x0069:1,/* ISREF */0x006A:1,/* GET.FORMULA */0x006C:2,/* SET.VALUE */0x006F:1,/* CHAR */0x0070:1,/* LOWER */0x0071:1,/* UPPER */0x0072:1,/* PROPER */0x0075:2,/* EXACT */0x0076:1,/* TRIM */0x0077:4,/* REPLACE */0x0079:1,/* CODE */0x007E:1,/* ISERR */0x007F:1,/* ISTEXT */0x0080:1,/* ISNUMBER */0x0081:1,/* ISBLANK */0x0082:1,/* T */0x0083:1,/* N */0x0085:1,/* FCLOSE */0x0086:1,/* FSIZE */0x0087:1,/* FREADLN */0x0088:2,/* FREAD */0x0089:2,/* FWRITELN */0x008A:2,/* FWRITE */0x008C:1,/* DATEVALUE */0x008D:1,/* TIMEVALUE */0x008E:3,/* SLN */0x008F:4,/* SYD */0x0090:4,/* DDB */0x00A1:1,/* DIALOG.BOX */0x00A2:1,/* CLEAN */0x00A3:1,/* MDETERM */0x00A4:1,/* MINVERSE */0x00A5:2,/* MMULT */0x00AC:1,/* WHILE */0x00AF:2,/* INITIATE */0x00B0:2,/* REQUEST */0x00B1:3,/* POKE */0x00B2:2,/* EXECUTE */0x00B3:1,/* TERMINATE */0x00B8:1,/* FACT */0x00BA:1,/* GET.WORKSPACE */0x00BD:3,/* DPRODUCT */0x00BE:1,/* ISNONTEXT */0x00C3:3,/* DSTDEVP */0x00C4:3,/* DVARP */0x00C5:1,/* TRUNC */0x00C6:1,/* ISLOGICAL */0x00C7:3,/* DCOUNTA */0x00C9:1,/* UNREGISTER */0x00CF:4,/* REPLACEB */0x00D2:3,/* MIDB */0x00D3:1,/* LENB */0x00D4:2,/* ROUNDUP */0x00D5:2,/* ROUNDDOWN */0x00D6:1,/* ASC */0x00D7:1,/* DBCS */0x00E1:0,/* END.IF */0x00E5:1,/* SINH */0x00E6:1,/* COSH */0x00E7:1,/* TANH */0x00E8:1,/* ASINH */0x00E9:1,/* ACOSH */0x00EA:1,/* ATANH */0x00EB:3,/* DGET */0x00F4:1,/* INFO */0x00F7:4,/* DB */0x00FC:2,/* FREQUENCY */0x0101:1,/* EVALUATE */0x0105:1,/* ERROR.TYPE */0x010F:1,/* GAMMALN */0x0111:4,/* BINOMDIST */0x0112:2,/* CHIDIST */0x0113:2,/* CHIINV */0x0114:2,/* COMBIN */0x0115:3,/* CONFIDENCE */0x0116:3,/* CRITBINOM */0x0117:1,/* EVEN */0x0118:3,/* EXPONDIST */0x0119:3,/* FDIST */0x011A:3,/* FINV */0x011B:1,/* FISHER */0x011C:1,/* FISHERINV */0x011D:2,/* FLOOR */0x011E:4,/* GAMMADIST */0x011F:3,/* GAMMAINV */0x0120:2,/* CEILING */0x0121:4,/* HYPGEOMDIST */0x0122:3,/* LOGNORMDIST */0x0123:3,/* LOGINV */0x0124:3,/* NEGBINOMDIST */0x0125:4,/* NORMDIST */0x0126:1,/* NORMSDIST */0x0127:3,/* NORMINV */0x0128:1,/* NORMSINV */0x0129:3,/* STANDARDIZE */0x012A:1,/* ODD */0x012B:2,/* PERMUT */0x012C:3,/* POISSON */0x012D:3,/* TDIST */0x012E:4,/* WEIBULL */0x012F:2,/* SUMXMY2 */0x0130:2,/* SUMX2MY2 */0x0131:2,/* SUMX2PY2 */0x0132:2,/* CHITEST */0x0133:2,/* CORREL */0x0134:2,/* COVAR */0x0135:3,/* FORECAST */0x0136:2,/* FTEST */0x0137:2,/* INTERCEPT */0x0138:2,/* PEARSON */0x0139:2,/* RSQ */0x013A:2,/* STEYX */0x013B:2,/* SLOPE */0x013C:4,/* TTEST */0x0145:2,/* LARGE */0x0146:2,/* SMALL */0x0147:2,/* QUARTILE */0x0148:2,/* PERCENTILE */0x014B:2,/* TRIMMEAN */0x014C:2,/* TINV */0x0151:2,/* POWER */0x0156:1,/* RADIANS */0x0157:1,/* DEGREES */0x015A:2,/* COUNTIF */0x015B:1,/* COUNTBLANK */0x015E:4,/* ISPMT */0x015F:3,/* DATEDIF */0x0160:1,/* DATESTRING */0x0161:2,/* NUMBERSTRING */0x0168:1,/* PHONETIC */0x0170:1,/* BAHTTEXT */0x0171:1,/* THAIDAYOFWEEK */0x0172:1,/* THAIDIGIT */0x0173:1,/* THAIMONTHOFYEAR */0x0174:1,/* THAINUMSOUND */0x0175:1,/* THAINUMSTRING */0x0176:1,/* THAISTRINGLENGTH */0x0177:1,/* ISTHAIDIGIT */0x0178:1,/* ROUNDBAHTDOWN */0x0179:1,/* ROUNDBAHTUP */0x017A:1,/* THAIYEAR */0x017E:3,/* CUBEMEMBERPROPERTY */0x0181:1,/* HEX2DEC */0x0188:1,/* OCT2DEC */0x0189:1,/* BIN2DEC */0x018C:2,/* IMSUB */0x018D:2,/* IMDIV */0x018E:2,/* IMPOWER */0x018F:1,/* IMABS */0x0190:1,/* IMSQRT */0x0191:1,/* IMLN */0x0192:1,/* IMLOG2 */0x0193:1,/* IMLOG10 */0x0194:1,/* IMSIN */0x0195:1,/* IMCOS */0x0196:1,/* IMEXP */0x0197:1,/* IMARGUMENT */0x0198:1,/* IMCONJUGATE */0x0199:1,/* IMAGINARY */0x019A:1,/* IMREAL */0x019E:4,/* SERIESSUM */0x019F:1,/* FACTDOUBLE */0x01A0:1,/* SQRTPI */0x01A1:2,/* QUOTIENT */0x01A4:1,/* ISEVEN */0x01A5:1,/* ISODD */0x01A6:2,/* MROUND */0x01A8:1,/* ERFC */0x01A9:2,/* BESSELJ */0x01AA:2,/* BESSELK */0x01AB:2,/* BESSELY */0x01AC:2,/* BESSELI */0x01AE:3,/* XNPV */0x01B6:3,/* TBILLEQ */0x01B7:3,/* TBILLPRICE */0x01B8:3,/* TBILLYIELD */0x01BB:2,/* DOLLARDE */0x01BC:2,/* DOLLARFR */0x01BD:2,/* NOMINAL */0x01BE:2,/* EFFECT */0x01BF:6,/* CUMPRINC */0x01C0:6,/* CUMIPMT */0x01C1:2,/* EDATE */0x01C2:2,/* EOMONTH */0x01D0:2,/* RANDBETWEEN */0x01D4:3,/* CONVERT */0x01DC:2,/* FVSCHEDULE */0x01DF:1,/* CUBESETCOUNT */0x01E0:2,/* IFERROR */0xFFFF:0};/* [MS-XLSX] 2.2.3 Functions */ /* [MS-XLSB] 2.5.97.10 Ftab */var XLSXFutureFunctions={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONCAT":"CONCAT","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORECAST.ETS":"FORECAST.ETS","_xlfn.FORECAST.ETS.CONFINT":"FORECAST.ETS.CONFINT","_xlfn.FORECAST.ETS.SEASONALITY":"FORECAST.ETS.SEASONALITY","_xlfn.FORECAST.ETS.STAT":"FORECAST.ETS.STAT","_xlfn.FORECAST.LINEAR":"FORECAST.LINEAR","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFERROR":"IFERROR","_xlfn.IFNA":"IFNA","_xlfn.IFS":"IFS","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MAXIFS":"MAXIFS","_xlfn.MINIFS":"MINIFS","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.SWITCH":"SWITCH","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.TEXTJOIN":"TEXTJOIN","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};/* Part 3 TODO: actually parse formulae */function ods_to_csf_formula(f){if(f.slice(0,3)=="of:")f=f.slice(3);/* 5.2 Basic Expressions */if(f.charCodeAt(0)==61){f=f.slice(1);if(f.charCodeAt(0)==61)f=f.slice(1);}f=f.replace(/COM\.MICROSOFT\./g,"");/* Part 3 Section 5.8 References */f=f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function($$,$1){return $1.replace(/\./g,"");});/* TODO: something other than this */f=f.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return f.replace(/[;~]/g,",").replace(/\|/g,";");}function csf_to_ods_formula(f){var o="of:="+f.replace(crefregex,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");/* TODO: something other than this */return o.replace(/;/g,"|").replace(/,/g,";");}function ods_to_csf_3D(r){var a=r.split(":");var s=a[0].split(".")[0];return[s,a[0].split(".")[1]+(a.length>1?":"+(a[1].split(".")[1]||a[1].split(".")[0]):"")];}function csf_to_ods_3D(r){return r.replace(/\./,"!");}var strs={};// shared strings
var _ssfopts={};// spreadsheet formatting options
RELS.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];/*global Map */var browser_has_Map=typeof Map!=='undefined';function get_sst_id(sst,str,rev){var i=0,len=sst.length;if(rev){if(browser_has_Map?rev.has(str):Object.prototype.hasOwnProperty.call(rev,str)){var revarr=browser_has_Map?rev.get(str):rev[str];for(;i<revarr.length;++i){if(sst[revarr[i]].t===str){sst.Count++;return revarr[i];}}}}else for(;i<len;++i){if(sst[i].t===str){sst.Count++;return i;}}sst[len]={t:str};sst.Count++;sst.Unique++;if(rev){if(browser_has_Map){if(!rev.has(str))rev.set(str,[]);rev.get(str).push(len);}else{if(!Object.prototype.hasOwnProperty.call(rev,str))rev[str]=[];rev[str].push(len);}}return len;}function col_obj_w(C,col){var p={min:C+1,max:C+1};/* wch (chars), wpx (pixels) */var wch=-1;if(col.MDW)MDW=col.MDW;if(col.width!=null)p.customWidth=1;else if(col.wpx!=null)wch=px2char(col.wpx);else if(col.wch!=null)wch=col.wch;if(wch>-1){p.width=char2width(wch);p.customWidth=1;}else if(col.width!=null)p.width=col.width;if(col.hidden)p.hidden=true;if(col.level!=null){p.outlineLevel=p.level=col.level;}return p;}function default_margins(margins,mode){if(!margins)return;var defs=[0.7,0.7,0.75,0.75,0.3,0.3];if(mode=='xlml')defs=[1,1,1,1,0.5,0.5];if(margins.left==null)margins.left=defs[0];if(margins.right==null)margins.right=defs[1];if(margins.top==null)margins.top=defs[2];if(margins.bottom==null)margins.bottom=defs[3];if(margins.header==null)margins.header=defs[4];if(margins.footer==null)margins.footer=defs[5];}function get_cell_style(styles,cell,opts){var z=opts.revssf[cell.z!=null?cell.z:"General"];var i=0x3c,len=styles.length;if(z==null&&opts.ssf){for(;i<0x188;++i)if(opts.ssf[i]==null){SSF.load(cell.z,i);// $FlowIgnore
opts.ssf[i]=cell.z;opts.revssf[cell.z]=z=i;break;}}for(i=0;i!=len;++i)if(styles[i].numFmtId===z)return i;styles[len]={numFmtId:z,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return len;}function safe_format(p,fmtid,fillid,opts,themes,styles){try{if(opts.cellNF)p.z=SSF._table[fmtid];}catch(e){if(opts.WTF)throw e;}if(p.t==='z'&&!opts.cellStyles)return;if(p.t==='d'&&typeof p.v==='string')p.v=parseDate(p.v);if((!opts||opts.cellText!==false)&&p.t!=='z')try{if(SSF._table[fmtid]==null)SSF.load(SSFImplicit[fmtid]||"General",fmtid);if(p.t==='e')p.w=p.w||BErr[p.v];else if(fmtid===0){if(p.t==='n'){if((p.v|0)===p.v)p.w=SSF._general_int(p.v);else p.w=SSF._general_num(p.v);}else if(p.t==='d'){var dd=datenum(p.v);if((dd|0)===dd)p.w=SSF._general_int(dd);else p.w=SSF._general_num(dd);}else if(p.v===undefined)return"";else p.w=SSF._general(p.v,_ssfopts);}else if(p.t==='d')p.w=SSF.format(fmtid,datenum(p.v),_ssfopts);else p.w=SSF.format(fmtid,p.v,_ssfopts);}catch(e){if(opts.WTF)throw e;}if(!opts.cellStyles)return;if(fillid!=null)try{p.s=styles.Fills[fillid];if(p.s.fgColor&&p.s.fgColor.theme&&!p.s.fgColor.rgb){p.s.fgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb,p.s.fgColor.tint||0);if(opts.WTF)p.s.fgColor.raw_rgb=themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;}if(p.s.bgColor&&p.s.bgColor.theme){p.s.bgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb,p.s.bgColor.tint||0);if(opts.WTF)p.s.bgColor.raw_rgb=themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;}}catch(e){if(opts.WTF&&styles.Fills)throw e;}}function check_ws(ws,sname,i){if(ws&&ws['!ref']){var range=safe_decode_range(ws['!ref']);if(range.e.c<range.s.c||range.e.r<range.s.r)throw new Error("Bad range ("+i+"): "+ws['!ref']);}}function parse_ws_xml_dim(ws,s){var d=safe_decode_range(s);if(d.s.r<=d.e.r&&d.s.c<=d.e.c&&d.s.r>=0&&d.s.c>=0)ws["!ref"]=encode_range(d);}var mergecregex=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var sheetdataregex=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var hlinkregex=/<(?:\w:)?hyperlink [^>]*>/mg;var dimregex=/"(\w*:\w*)"/;var colregex=/<(?:\w:)?col\b[^>]*[\/]?>/g;var afregex=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var marginregex=/<(?:\w:)?pageMargins[^>]*\/>/g;var sheetprregex=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var sheetprregex2=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;var svsregex=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;/* 18.3 Worksheets */function parse_ws_xml(data,opts,idx,rels,wb,themes,styles){if(!data)return data;if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;/* 18.3.1.99 worksheet CT_Worksheet */var s=opts.dense?[]:{};var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var data1="",data2="";var mtch=data.match(sheetdataregex);if(mtch){data1=data.slice(0,mtch.index);data2=data.slice(mtch.index+mtch[0].length);}else data1=data2=data;/* 18.3.1.82 sheetPr CT_SheetPr */var sheetPr=data1.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);else if(sheetPr=data1.match(sheetprregex2))parse_ws_xml_sheetpr2(sheetPr[0],sheetPr[1]||"",s,wb,idx,styles,themes);/* 18.3.1.35 dimension CT_SheetDimension */var ridx=(data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(ridx>0){var ref=data1.slice(ridx,ridx+50).match(dimregex);if(ref)parse_ws_xml_dim(s,ref[1]);}/* 18.3.1.88 sheetViews CT_SheetViews */var svs=data1.match(svsregex);if(svs&&svs[1])parse_ws_xml_sheetviews(svs[1],wb);/* 18.3.1.17 cols CT_Cols */var columns=[];if(opts.cellStyles){/* 18.3.1.13 col CT_Col */var cols=data1.match(colregex);if(cols)parse_ws_xml_cols(columns,cols);}/* 18.3.1.80 sheetData CT_SheetData ? */if(mtch)parse_ws_xml_data(mtch[1],s,opts,refguess,themes,styles);/* 18.3.1.2  autoFilter CT_AutoFilter */var afilter=data2.match(afregex);if(afilter)s['!autofilter']=parse_ws_xml_autofilter(afilter[0]);/* 18.3.1.55 mergeCells CT_MergeCells */var merges=[];var _merge=data2.match(mergecregex);if(_merge)for(ridx=0;ridx!=_merge.length;++ridx)merges[ridx]=safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));/* 18.3.1.48 hyperlinks CT_Hyperlinks */var hlink=data2.match(hlinkregex);if(hlink)parse_ws_xml_hlinks(s,hlink,rels);/* 18.3.1.62 pageMargins CT_PageMargins */var margins=data2.match(marginregex);if(margins)s['!margins']=parse_ws_xml_margins(parsexmltag(margins[0]));if(!s["!ref"]&&refguess.e.c>=refguess.s.c&&refguess.e.r>=refguess.s.r)s["!ref"]=encode_range(refguess);if(opts.sheetRows>0&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(columns.length>0)s["!cols"]=columns;if(merges.length>0)s["!merges"]=merges;return s;}function write_ws_xml_merges(merges){if(merges.length===0)return"";var o='<mergeCells count="'+merges.length+'">';for(var i=0;i!=merges.length;++i)o+='<mergeCell ref="'+encode_range(merges[i])+'"/>';return o+'</mergeCells>';}/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */function parse_ws_xml_sheetpr(sheetPr,s,wb,idx){var data=parsexmltag(sheetPr);if(!wb.Sheets[idx])wb.Sheets[idx]={};if(data.codeName)wb.Sheets[idx].CodeName=unescapexml(utf8read(data.codeName));}function parse_ws_xml_sheetpr2(sheetPr,body,s,wb,idx,styles,themes){parse_ws_xml_sheetpr(sheetPr.slice(0,sheetPr.indexOf(">")),s,wb,idx);}function write_ws_xml_sheetpr(ws,wb,idx,opts,o){var needed=false;var props={},payload=null;if(opts.bookType!=='xlsx'&&wb.vbaraw){var cname=wb.SheetNames[idx];try{if(wb.Workbook)cname=wb.Workbook.Sheets[idx].CodeName||cname;}catch(e){}needed=true;props.codeName=utf8write(escapexml(cname));}if(ws&&ws["!outline"]){var outlineprops={summaryBelow:1,summaryRight:1};if(ws["!outline"].above)outlineprops.summaryBelow=0;if(ws["!outline"].left)outlineprops.summaryRight=0;payload=(payload||"")+writextag('outlinePr',null,outlineprops);}if(!needed&&!payload)return;o[o.length]=writextag('sheetPr',payload,props);}/* 18.3.1.85 sheetProtection CT_SheetProtection */var sheetprot_deffalse=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var sheetprot_deftrue=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function write_ws_xml_protection(sp){// algorithmName, hashValue, saltValue, spinCount
var o={sheet:1};sheetprot_deffalse.forEach(function(n){if(sp[n]!=null&&sp[n])o[n]="1";});sheetprot_deftrue.forEach(function(n){if(sp[n]!=null&&!sp[n])o[n]="0";});/* TODO: algorithm */if(sp.password)o.password=crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();return writextag('sheetProtection',null,o);}function parse_ws_xml_hlinks(s,data,rels){var dense=Array.isArray(s);for(var i=0;i!=data.length;++i){var val=parsexmltag(utf8read(data[i]),true);if(!val.ref)return;var rel=((rels||{})['!id']||[])[val.id];if(rel){val.Target=rel.Target;if(val.location)val.Target+="#"+unescapexml(val.location);}else{val.Target="#"+unescapexml(val.location);rel={Target:val.Target,TargetMode:'Internal'};}val.Rel=rel;if(val.tooltip){val.Tooltip=val.tooltip;delete val.tooltip;}var rng=safe_decode_range(val.ref);for(var R=rng.s.r;R<=rng.e.r;++R)for(var C=rng.s.c;C<=rng.e.c;++C){var addr=encode_cell({c:C,r:R});if(dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:"z",v:undefined};s[R][C].l=val;}else{if(!s[addr])s[addr]={t:"z",v:undefined};s[addr].l=val;}}}}function parse_ws_xml_margins(margin){var o={};["left","right","top","bottom","header","footer"].forEach(function(k){if(margin[k])o[k]=parseFloat(margin[k]);});return o;}function write_ws_xml_margins(margin){default_margins(margin);return writextag('pageMargins',null,margin);}function parse_ws_xml_cols(columns,cols){var seencol=false;for(var coli=0;coli!=cols.length;++coli){var coll=parsexmltag(cols[coli],true);if(coll.hidden)coll.hidden=parsexmlbool(coll.hidden);var colm=parseInt(coll.min,10)-1,colM=parseInt(coll.max,10)-1;if(coll.outlineLevel)coll.level=+coll.outlineLevel||0;delete coll.min;delete coll.max;coll.width=+coll.width;if(!seencol&&coll.width){seencol=true;find_mdw_colw(coll.width);}process_col(coll);while(colm<=colM)columns[colm++]=dup(coll);}}function write_ws_xml_cols(ws,cols){var o=["<cols>"],col;for(var i=0;i!=cols.length;++i){if(!(col=cols[i]))continue;o[o.length]=writextag('col',null,col_obj_w(i,col));}o[o.length]="</cols>";return o.join("");}function parse_ws_xml_autofilter(data){var o={ref:(data.match(/ref="([^"]*)"/)||[])[1]};return o;}function write_ws_xml_autofilter(data,ws,wb,idx){var ref=typeof data.ref=="string"?data.ref:encode_range(data.ref);if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});return writextag("autoFilter",null,{ref:ref});}/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */var sviewregex=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function parse_ws_xml_sheetviews(data,wb){if(!wb.Views)wb.Views=[{}];(data.match(sviewregex)||[]).forEach(function(r,i){var tag=parsexmltag(r);// $FlowIgnore
if(!wb.Views[i])wb.Views[i]={};// $FlowIgnore
if(+tag.zoomScale)wb.Views[i].zoom=+tag.zoomScale;// $FlowIgnore
if(parsexmlbool(tag.rightToLeft))wb.Views[i].RTL=true;});}function write_ws_xml_sheetviews(ws,opts,idx,wb){var sview={workbookViewId:"0"};// $FlowIgnore
if((((wb||{}).Workbook||{}).Views||[])[0])sview.rightToLeft=wb.Workbook.Views[0].RTL?"1":"0";return writextag("sheetViews",writextag("sheetView",null,sview),{});}function write_ws_xml_cell(cell,ref,ws,opts){if(cell.v===undefined&&typeof cell.f!=="string"||cell.t==='z')return"";var vv="";var oldt=cell.t,oldv=cell.v;if(cell.t!=="z")switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'n':vv=''+cell.v;break;case'e':vv=BErr[cell.v];break;case'd':if(opts&&opts.cellDates)vv=parseDate(cell.v,-1).toISOString();else{cell=dup(cell);cell.t='n';vv=''+(cell.v=datenum(parseDate(cell.v)));}if(typeof cell.z==='undefined')cell.z=SSF._table[14];break;default:vv=cell.v;break;}var v=writetag('v',escapexml(vv)),o={r:ref};/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);if(os!==0)o.s=os;switch(cell.t){case'n':break;case'd':o.t="d";break;case'b':o.t="b";break;case'e':o.t="e";break;case'z':break;default:if(cell.v==null){delete cell.t;break;}if(cell.v.length>32767)throw new Error("Text length must not exceed 32767 characters");if(opts&&opts.bookSST){v=writetag('v',''+get_sst_id(opts.Strings,cell.v,opts.revStrings));o.t="s";break;}o.t="str";break;}if(cell.t!=oldt){cell.t=oldt;cell.v=oldv;}if(typeof cell.f=="string"&&cell.f){var ff=cell.F&&cell.F.slice(0,ref.length)==ref?{t:"array",ref:cell.F}:null;v=writextag('f',escapexml(cell.f),ff)+(cell.v!=null?v:"");}if(cell.l)ws['!links'].push([ref,cell.l]);if(cell.c)ws['!comments'].push([ref,cell.c]);return writextag('c',v,o);}var parse_ws_xml_data=function(){var cellregex=/<(?:\w+:)?c[ \/>]/,rowregex=/<\/(?:\w+:)?row>/;var rregex=/r=["']([^"']*)["']/,isregex=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var refregex=/ref=["']([^"']*)["']/;var match_v=matchtag("v"),match_f=matchtag("f");return function parse_ws_xml_data(sdata,s,opts,guess,themes,styles){var ri=0,x="",cells=[],cref=[],idx=0,i=0,cc=0,d="",p;var tag,tagr=0,tagc=0;var sstr,ftag;var fmtid=0,fillid=0;var do_format=Array.isArray(styles.CellXf),cf;var arrayf=[];var sharedf=[];var dense=Array.isArray(s);var rows=[],rowobj={},rowrite=false;var sheetStubs=!!opts.sheetStubs;for(var marr=sdata.split(rowregex),mt=0,marrlen=marr.length;mt!=marrlen;++mt){x=marr[mt].trim();var xlen=x.length;if(xlen===0)continue;/* 18.3.1.73 row CT_Row */var rstarti=0;outa:for(ri=0;ri<xlen;++ri)switch(/*x.charCodeAt(ri)*/x[ri]){case">"/*62*/:if(/*x.charCodeAt(ri-1) != 47*/x[ri-1]!="/"){++ri;break outa;}if(opts&&opts.cellStyles){// TODO: avoid duplication
tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}break;case"<"/*60*/:rstarti=ri;break;}if(rstarti>=ri)break;tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;if(guess.s.r>tagr-1)guess.s.r=tagr-1;if(guess.e.r<tagr-1)guess.e.r=tagr-1;if(opts&&opts.cellStyles){rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}/* 18.3.1.4 c CT_Cell */cells=x.slice(ri).split(cellregex);for(var rslice=0;rslice!=cells.length;++rslice)if(cells[rslice].trim().charAt(0)!="<")break;cells=cells.slice(rslice);for(ri=0;ri!=cells.length;++ri){x=cells[ri].trim();if(x.length===0)continue;cref=x.match(rregex);idx=ri;i=0;cc=0;x="<c "+(x.slice(0,1)=="<"?">":"")+x;if(cref!=null&&cref.length===2){idx=0;d=cref[1];for(i=0;i!=d.length;++i){if((cc=d.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}--idx;tagc=idx;}else++tagc;for(i=0;i!=x.length;++i)if(x.charCodeAt(i)===62)break;++i;tag=parsexmltag(x.slice(0,i),true);if(!tag.r)tag.r=encode_cell({r:tagr-1,c:tagc});d=x.slice(i);p={t:""};if((cref=d.match(match_v))!=null&&cref[1]!=='')p.v=unescapexml(cref[1]);if(opts.cellFormula){if((cref=d.match(match_f))!=null&&cref[1]!==''){/* TODO: match against XLSXFutureFunctions */p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g,"\n");if(!opts.xlfn)p.f=_xlfn(p.f);if(cref[0].indexOf('t="array"')>-1){p.F=(d.match(refregex)||[])[1];if(p.F.indexOf(":")>-1)arrayf.push([safe_decode_range(p.F),p.F]);}else if(cref[0].indexOf('t="shared"')>-1){// TODO: parse formula
ftag=parsexmltag(cref[0]);var ___f=unescapexml(utf8read(cref[1]));if(!opts.xlfn)___f=_xlfn(___f);sharedf[parseInt(ftag.si,10)]=[ftag,___f,tag.r];}}else if(cref=d.match(/<f[^>]*\/>/)){ftag=parsexmltag(cref[0]);if(sharedf[ftag.si])p.f=shift_formula_xlsx(sharedf[ftag.si][1],sharedf[ftag.si][2]/*[0].ref*/,tag.r);}/* TODO: factor out contains logic */var _tag=decode_cell(tag.r);for(i=0;i<arrayf.length;++i)if(_tag.r>=arrayf[i][0].s.r&&_tag.r<=arrayf[i][0].e.r)if(_tag.c>=arrayf[i][0].s.c&&_tag.c<=arrayf[i][0].e.c)p.F=arrayf[i][1];}if(tag.t==null&&p.v===undefined){if(p.f||p.F){p.v=0;p.t="n";}else if(!sheetStubs)continue;else p.t="z";}else p.t=tag.t||"n";if(guess.s.c>tagc)guess.s.c=tagc;if(guess.e.c<tagc)guess.e.c=tagc;/* 18.18.11 t ST_CellType */switch(p.t){case'n':if(p.v==""||p.v==null){if(!sheetStubs)continue;p.t='z';}else p.v=parseFloat(p.v);break;case's':if(typeof p.v=='undefined'){if(!sheetStubs)continue;p.t='z';}else{sstr=strs[parseInt(p.v,10)];p.v=sstr.t;p.r=sstr.r;if(opts.cellHTML)p.h=sstr.h;}break;case'str':p.t="s";p.v=p.v!=null?utf8read(p.v):'';if(opts.cellHTML)p.h=escapehtml(p.v);break;case'inlineStr':cref=d.match(isregex);p.t='s';if(cref!=null&&(sstr=parse_si(cref[1]))){p.v=sstr.t;if(opts.cellHTML)p.h=sstr.h;}else p.v="";break;case'b':p.v=parsexmlbool(p.v);break;case'd':if(opts.cellDates)p.v=parseDate(p.v,1);else{p.v=datenum(parseDate(p.v,1));p.t='n';}break;/* error string in .w, number in .v */case'e':if(!opts||opts.cellText!==false)p.w=p.v;p.v=RBErr[p.v];break;}/* formatting */fmtid=fillid=0;cf=null;if(do_format&&tag.s!==undefined){cf=styles.CellXf[tag.s];if(cf!=null){if(cf.numFmtId!=null)fmtid=cf.numFmtId;if(opts.cellStyles){if(cf.fillId!=null)fillid=cf.fillId;}}}safe_format(p,fmtid,fillid,opts,themes,styles);if(opts.cellDates&&do_format&&p.t=='n'&&SSF.is_date(SSF._table[fmtid])){p.t='d';p.v=numdate(p.v);}if(dense){var _r=decode_cell(tag.r);if(!s[_r.r])s[_r.r]=[];s[_r.r][_r.c]=p;}else s[tag.r]=p;}}if(rows.length>0)s['!rows']=rows;};}();function write_ws_xml_data(ws,opts,idx,wb){var o=[],r=[],range=safe_decode_range(ws['!ref']),cell="",ref,rr="",cols=[],R=0,C=0,rows=ws['!rows'];var dense=Array.isArray(ws);var params={r:rr},row,height=-1;for(C=range.s.c;C<=range.e.c;++C)cols[C]=encode_col(C);for(R=range.s.r;R<=range.e.r;++R){r=[];rr=encode_row(R);for(C=range.s.c;C<=range.e.c;++C){ref=cols[C]+rr;var _cell=dense?(ws[R]||[])[C]:ws[ref];if(_cell===undefined)continue;if((cell=write_ws_xml_cell(_cell,ref,ws,opts,idx,wb))!=null)r.push(cell);}if(r.length>0||rows&&rows[R]){params={r:rr};if(rows&&rows[R]){row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}}o[o.length]=writextag('row',r.join(""),params);}}if(rows)for(;R<rows.length;++R){if(rows&&rows[R]){params={r:R+1};row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}o[o.length]=writextag('row',"",params);}}return o.join("");}var WS_XML_ROOT=writextag('worksheet',null,{'xmlns':XMLNS.main[0],'xmlns:r':XMLNS.r});function write_ws_xml(idx,opts,wb,rels){var o=[XML_HEADER,WS_XML_ROOT];var s=wb.SheetNames[idx],sidx=0,rdata="";var ws=wb.Sheets[s];if(ws==null)ws={};var ref=ws['!ref']||'A1';var range=safe_decode_range(ref);if(range.e.c>0x3FFF||range.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+ref+" exceeds format limit A1:XFD1048576");range.e.c=Math.min(range.e.c,0x3FFF);range.e.r=Math.min(range.e.c,0xFFFFF);ref=encode_range(range);}if(!rels)rels={};ws['!comments']=[];var _drawing=[];write_ws_xml_sheetpr(ws,wb,idx,opts,o);o[o.length]=writextag('dimension',null,{'ref':ref});o[o.length]=write_ws_xml_sheetviews(ws,opts,idx,wb);/* TODO: store in WB, process styles */if(opts.sheetFormat)o[o.length]=writextag('sheetFormatPr',null,{defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',baseColWidth:opts.sheetFormat.baseColWidth||'10',outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'});if(ws['!cols']!=null&&ws['!cols'].length>0)o[o.length]=write_ws_xml_cols(ws,ws['!cols']);o[sidx=o.length]='<sheetData/>';ws['!links']=[];if(ws['!ref']!=null){rdata=write_ws_xml_data(ws,opts,idx,wb,rels);if(rdata.length>0)o[o.length]=rdata;}if(o.length>sidx+1){o[o.length]='</sheetData>';o[sidx]=o[sidx].replace("/>",">");}/* sheetCalcPr */if(ws['!protect'])o[o.length]=write_ws_xml_protection(ws['!protect']);/* protectedRanges */ /* scenarios */if(ws['!autofilter']!=null)o[o.length]=write_ws_xml_autofilter(ws['!autofilter'],ws,wb,idx);/* sortState */ /* dataConsolidate */ /* customSheetViews */if(ws['!merges']!=null&&ws['!merges'].length>0)o[o.length]=write_ws_xml_merges(ws['!merges']);/* phoneticPr */ /* conditionalFormatting */ /* dataValidations */var relc=-1,rel,rId=-1;if(ws['!links'].length>0){o[o.length]="<hyperlinks>";ws['!links'].forEach(function(l){if(!l[1].Target)return;rel={"ref":l[0]};if(l[1].Target.charAt(0)!="#"){rId=add_rels(rels,-1,escapexml(l[1].Target).replace(/#.*$/,""),RELS.HLINK);rel["r:id"]="rId"+rId;}if((relc=l[1].Target.indexOf("#"))>-1)rel.location=escapexml(l[1].Target.slice(relc+1));if(l[1].Tooltip)rel.tooltip=escapexml(l[1].Tooltip);o[o.length]=writextag("hyperlink",null,rel);});o[o.length]="</hyperlinks>";}delete ws['!links'];/* printOptions */if(ws['!margins']!=null)o[o.length]=write_ws_xml_margins(ws['!margins']);/* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)o[o.length]=writetag("ignoredErrors",writextag("ignoredError",null,{numberStoredAsText:1,sqref:ref}));/* smartTags */if(_drawing.length>0){rId=add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);o[o.length]=writextag("drawing",null,{"r:id":"rId"+rId});ws['!drawing']=_drawing;}if(ws['!comments'].length>0){rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);o[o.length]=writextag("legacyDrawing",null,{"r:id":"rId"+rId});ws['!legacy']=rId;}/* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */if(o.length>1){o[o.length]='</worksheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.726 BrtRowHdr */function parse_BrtRowHdr(data,length){var z={};var tgt=data.l+length;z.r=data.read_shift(4);data.l+=4;// TODO: ixfe
var miyRw=data.read_shift(2);data.l+=1;// TODO: top/bot padding
var flags=data.read_shift(1);data.l=tgt;if(flags&0x07)z.level=flags&0x07;if(flags&0x10)z.hidden=true;if(flags&0x20)z.hpt=miyRw/20;return z;}function write_BrtRowHdr(R,range,ws){var o=new_buf(17+8*16);var row=(ws['!rows']||[])[R]||{};o.write_shift(4,R);o.write_shift(4,0);/* TODO: ixfe */var miyRw=0x0140;if(row.hpx)miyRw=px2pt(row.hpx)*20;else if(row.hpt)miyRw=row.hpt*20;o.write_shift(2,miyRw);o.write_shift(1,0);/* top/bot padding */var flags=0x0;if(row.level)flags|=row.level;if(row.hidden)flags|=0x10;if(row.hpx||row.hpt)flags|=0x20;o.write_shift(1,flags);o.write_shift(1,0);/* phonetic guide */ /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */var ncolspan=0,lcs=o.l;o.l+=4;var caddr={r:R,c:0};for(var i=0;i<16;++i){if(range.s.c>i+1<<10||range.e.c<i<<10)continue;var first=-1,last=-1;for(var j=i<<10;j<i+1<<10;++j){caddr.c=j;var cell=Array.isArray(ws)?(ws[caddr.r]||[])[caddr.c]:ws[encode_cell(caddr)];if(cell){if(first<0)first=j;last=j;}}if(first<0)continue;++ncolspan;o.write_shift(4,first);o.write_shift(4,last);}var l=o.l;o.l=lcs;o.write_shift(4,ncolspan);o.l=l;return o.length>o.l?o.slice(0,o.l):o;}function write_row_header(ba,ws,range,R){var o=write_BrtRowHdr(R,range,ws);if(o.length>17||(ws['!rows']||[])[R])write_record(ba,'BrtRowHdr',o);}/* [MS-XLSB] 2.4.820 BrtWsDim */var parse_BrtWsDim=parse_UncheckedRfX;var write_BrtWsDim=write_UncheckedRfX;/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */function parse_BrtWsFmtInfo(){}//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */function parse_BrtWsProp(data,length){var z={};var f=data[data.l];++data.l;z.above=!(f&0x40);z.left=!(f&0x80);/* TODO: pull flags */data.l+=18;z.name=parse_XLSBCodeName(data,length-19);return z;}function write_BrtWsProp(str,outl,o){if(o==null)o=new_buf(84+4*str.length);var f=0xC0;if(outl){if(outl.above)f&=~0x40;if(outl.left)f&=~0x80;}o.write_shift(1,f);for(var i=1;i<3;++i)o.write_shift(1,0);write_BrtColor({auto:1},o);o.write_shift(-4,-1);o.write_shift(-4,-1);write_XLSBCodeName(str,o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.306 BrtCellBlank */function parse_BrtCellBlank(data){var cell=parse_XLSBCell(data);return[cell];}function write_BrtCellBlank(cell,ncell,o){if(o==null)o=new_buf(8);return write_XLSBCell(ncell,o);}function parse_BrtShortBlank(data){var cell=parse_XLSBShortCell(data);return[cell];}function write_BrtShortBlank(cell,ncell,o){if(o==null)o=new_buf(4);return write_XLSBShortCell(ncell,o);}/* [MS-XLSB] 2.4.307 BrtCellBool */function parse_BrtCellBool(data){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtCellBool(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}function parse_BrtShortBool(data){var cell=parse_XLSBShortCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtShortBool(cell,ncell,o){if(o==null)o=new_buf(5);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}/* [MS-XLSB] 2.4.308 BrtCellError */function parse_BrtCellError(data){var cell=parse_XLSBCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtCellError(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v);return o;}function parse_BrtShortError(data){var cell=parse_XLSBShortCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtShortError(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v);o.write_shift(2,0);o.write_shift(1,0);return o;}/* [MS-XLSB] 2.4.311 BrtCellIsst */function parse_BrtCellIsst(data){var cell=parse_XLSBCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtCellIsst(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);o.write_shift(4,ncell.v);return o;}function parse_BrtShortIsst(data){var cell=parse_XLSBShortCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtShortIsst(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(4,ncell.v);return o;}/* [MS-XLSB] 2.4.313 BrtCellReal */function parse_BrtCellReal(data){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtCellReal(cell,ncell,o){if(o==null)o=new_buf(16);write_XLSBCell(ncell,o);write_Xnum(cell.v,o);return o;}function parse_BrtShortReal(data){var cell=parse_XLSBShortCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtShortReal(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBShortCell(ncell,o);write_Xnum(cell.v,o);return o;}/* [MS-XLSB] 2.4.314 BrtCellRk */function parse_BrtCellRk(data){var cell=parse_XLSBCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtCellRk(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);write_RkNumber(cell.v,o);return o;}function parse_BrtShortRk(data){var cell=parse_XLSBShortCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtShortRk(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);write_RkNumber(cell.v,o);return o;}/* [MS-XLSB] 2.4.317 BrtCellSt */function parse_BrtCellSt(data){var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtCellSt(cell,ncell,o){if(o==null)o=new_buf(12+4*cell.v.length);write_XLSBCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtShortSt(data){var cell=parse_XLSBShortCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtShortSt(cell,ncell,o){if(o==null)o=new_buf(8+4*cell.v.length);write_XLSBShortCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.653 BrtFmlaBool */function parse_BrtFmlaBool(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'b'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.654 BrtFmlaError */function parse_BrtFmlaError(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'e'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.655 BrtFmlaNum */function parse_BrtFmlaNum(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_Xnum(data);var o=[cell,value,'n'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.656 BrtFmlaString */function parse_BrtFmlaString(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_XLWideString(data);var o=[cell,value,'str'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.682 BrtMergeCell */var parse_BrtMergeCell=parse_UncheckedRfX;var write_BrtMergeCell=write_UncheckedRfX;/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */function write_BrtBeginMergeCells(cnt,o){if(o==null)o=new_buf(4);o.write_shift(4,cnt);return o;}/* [MS-XLSB] 2.4.662 BrtHLink */function parse_BrtHLink(data,length){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var relId=parse_XLNullableWideString(data);var loc=parse_XLWideString(data);var tooltip=parse_XLWideString(data);var display=parse_XLWideString(data);data.l=end;var o={rfx:rfx,relId:relId,loc:loc,display:display};if(tooltip)o.Tooltip=tooltip;return o;}function write_BrtHLink(l,rId){var o=new_buf(50+4*(l[1].Target.length+(l[1].Tooltip||"").length));write_UncheckedRfX({s:decode_cell(l[0]),e:decode_cell(l[0])},o);write_RelID("rId"+rId,o);var locidx=l[1].Target.indexOf("#");var loc=locidx==-1?"":l[1].Target.slice(locidx+1);write_XLWideString(loc||"",o);write_XLWideString(l[1].Tooltip||"",o);write_XLWideString("",o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.692 BrtPane */function parse_BrtPane(/*data, length, opts*/){}/* [MS-XLSB] 2.4.6 BrtArrFmla */function parse_BrtArrFmla(data,length,opts){var end=data.l+length;var rfx=parse_RfX(data,16);var fAlwaysCalc=data.read_shift(1);var o=[rfx];o[2]=fAlwaysCalc;if(opts.cellFormula){var formula=parse_XLSBArrayParsedFormula(data,end-data.l,opts);o[1]=formula;}else data.l=end;return o;}/* [MS-XLSB] 2.4.750 BrtShrFmla */function parse_BrtShrFmla(data,length,opts){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var o=[rfx];if(opts.cellFormula){var formula=parse_XLSBSharedParsedFormula(data,end-data.l,opts);o[1]=formula;data.l=end;}else data.l=end;return o;}/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */function write_BrtColInfo(C,col,o){if(o==null)o=new_buf(18);var p=col_obj_w(C,col);o.write_shift(-4,C);o.write_shift(-4,C);o.write_shift(4,(p.width||10)*256);o.write_shift(4,0/*ixfe*/);// style
var flags=0;if(col.hidden)flags|=0x01;if(typeof p.width=='number')flags|=0x02;if(col.level)flags|=col.level<<8;o.write_shift(2,flags);// bit flag
return o;}/* [MS-XLSB] 2.4.678 BrtMargins */var BrtMarginKeys=["left","right","top","bottom","header","footer"];function parse_BrtMargins(data){var margins={};BrtMarginKeys.forEach(function(k){margins[k]=parse_Xnum(data,8);});return margins;}function write_BrtMargins(margins,o){if(o==null)o=new_buf(6*8);default_margins(margins);BrtMarginKeys.forEach(function(k){write_Xnum(margins[k],o);});return o;}/* [MS-XLSB] 2.4.299 BrtBeginWsView */function parse_BrtBeginWsView(data){var f=data.read_shift(2);data.l+=28;return{RTL:f&0x20};}function write_BrtBeginWsView(ws,Workbook,o){if(o==null)o=new_buf(30);var f=0x39c;if((((Workbook||{}).Views||[])[0]||{}).RTL)f|=0x20;o.write_shift(2,f);// bit flag
o.write_shift(4,0);o.write_shift(4,0);// view first row
o.write_shift(4,0);// view first col
o.write_shift(1,0);// gridline color ICV
o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,100);// zoom scale
o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);// workbook view id
return o;}/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */function write_BrtCellIgnoreEC(ref){var o=new_buf(24);o.write_shift(4,4);o.write_shift(4,1);write_UncheckedRfX(ref,o);return o;}/* [MS-XLSB] 2.4.748 BrtSheetProtection */function write_BrtSheetProtection(sp,o){if(o==null)o=new_buf(16*4+2);o.write_shift(2,sp.password?crypto_CreatePasswordVerifier_Method1(sp.password):0);o.write_shift(4,1);// this record should not be written if no protection
[["objects",false],// fObjects
["scenarios",false],// fScenarios
["formatCells",true],// fFormatCells
["formatColumns",true],// fFormatColumns
["formatRows",true],// fFormatRows
["insertColumns",true],// fInsertColumns
["insertRows",true],// fInsertRows
["insertHyperlinks",true],// fInsertHyperlinks
["deleteColumns",true],// fDeleteColumns
["deleteRows",true],// fDeleteRows
["selectLockedCells",false],// fSelLockedCells
["sort",true],// fSort
["autoFilter",true],// fAutoFilter
["pivotTables",true],// fPivotTables
["selectUnlockedCells",false]// fSelUnlockedCells
].forEach(function(n){if(n[1])o.write_shift(4,sp[n[0]]!=null&&!sp[n[0]]?1:0);else o.write_shift(4,sp[n[0]]!=null&&sp[n[0]]?0:1);});return o;}function parse_BrtDVal(/*data, length, opts*/){}function parse_BrtDVal14(/*data, length, opts*/){}/* [MS-XLSB] 2.1.7.61 Worksheet */function parse_ws_bin(data,_opts,idx,rels,wb,themes,styles){if(!data)return data;var opts=_opts||{};if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var s=opts.dense?[]:{};var ref;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var state=[];var pass=false,end=false;var row,p,cf,R,C,addr,sstr,rr,cell;var merges=[];opts.biff=12;opts['!row']=0;var ai=0,af=false;var arrayf=[];var sharedf={};var supbooks=opts.supbooks||wb.supbooks||[[]];supbooks.sharedf=sharedf;supbooks.arrayf=arrayf;supbooks.SheetNames=wb.SheetNames||wb.Sheets.map(function(x){return x.name;});if(!opts.supbooks){opts.supbooks=supbooks;if(wb.Names)for(var i=0;i<wb.Names.length;++i)supbooks[0][i+1]=wb.Names[i];}var colinfo=[],rowinfo=[];var seencol=false;XLSBRecordEnum[0x0010]={n:"BrtShortReal",f:parse_BrtShortReal};recordhopper(data,function ws_parse(val,R_n,RT){if(end)return;switch(RT){case 0x0094:/* 'BrtWsDim' */ref=val;break;case 0x0000:/* 'BrtRowHdr' */row=val;if(opts.sheetRows&&opts.sheetRows<=row.r)end=true;rr=encode_row(R=row.r);opts['!row']=row.r;if(val.hidden||val.hpt||val.level!=null){if(val.hpt)val.hpx=pt2px(val.hpt);rowinfo[val.r]=val;}break;case 0x0002:/* 'BrtCellRk' */case 0x0003:/* 'BrtCellError' */case 0x0004:/* 'BrtCellBool' */case 0x0005:/* 'BrtCellReal' */case 0x0006:/* 'BrtCellSt' */case 0x0007:/* 'BrtCellIsst' */case 0x0008:/* 'BrtFmlaString' */case 0x0009:/* 'BrtFmlaNum' */case 0x000A:/* 'BrtFmlaBool' */case 0x000B:/* 'BrtFmlaError' */case 0x000D:/* 'BrtShortRk' */case 0x000E:/* 'BrtShortError' */case 0x000F:/* 'BrtShortBool' */case 0x0010:/* 'BrtShortReal' */case 0x0011:/* 'BrtShortSt' */case 0x0012:/* 'BrtShortIsst' */p={t:val[2]};switch(val[2]){case'n':p.v=val[1];break;case's':sstr=strs[val[1]];p.v=sstr.t;p.r=sstr.r;break;case'b':p.v=val[1]?true:false;break;case'e':p.v=val[1];if(opts.cellText!==false)p.w=BErr[p.v];break;case'str':p.t='s';p.v=val[1];break;}if(cf=styles.CellXf[val[0].iStyleRef])safe_format(p,cf.numFmtId,null,opts,themes,styles);C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(opts.cellFormula){af=false;for(ai=0;ai<arrayf.length;++ai){var aii=arrayf[ai];if(row.r>=aii[0].s.r&&row.r<=aii[0].e.r)if(C>=aii[0].s.c&&C<=aii[0].e.c){p.F=encode_range(aii[0]);af=true;}}if(!af&&val.length>3)p.f=val[3];}if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(opts.cellDates&&cf&&p.t=='n'&&SSF.is_date(SSF._table[cf.numFmtId])){var _d=SSF.parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}break;case 0x0001:/* 'BrtCellBlank' */case 0x000C:/* 'BrtShortBlank' */if(!opts.sheetStubs||pass)break;p={t:'z',v:undefined};C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;break;case 0x00B0:/* 'BrtMergeCell' */merges.push(val);break;case 0x01EE:/* 'BrtHLink' */var rel=rels['!id'][val.relId];if(rel){val.Target=rel.Target;if(val.loc)val.Target+="#"+val.loc;val.Rel=rel;}else if(val.relId==''){val.Target="#"+val.loc;}for(R=val.rfx.s.r;R<=val.rfx.e.r;++R)for(C=val.rfx.s.c;C<=val.rfx.e.c;++C){if(opts.dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:'z',v:undefined};s[R][C].l=val;}else{addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:'z',v:undefined};s[addr].l=val;}}break;case 0x01AA:/* 'BrtArrFmla' */if(!opts.cellFormula)break;arrayf.push(val);cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);cell.F=encode_range(val[0]);break;case 0x01AB:/* 'BrtShrFmla' */if(!opts.cellFormula)break;sharedf[encode_cell(val[0].s)]=val[1];cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);break;/* identical to 'ColInfo' in XLS */case 0x003C:/* 'BrtColInfo' */if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,hidden:!!(val.flags&0x01),level:val.level};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}break;case 0x00A1:/* 'BrtBeginAFilter' */s['!autofilter']={ref:encode_range(val)};break;case 0x01DC:/* 'BrtMargins' */s['!margins']=val;break;case 0x0093:/* 'BrtWsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;if(val.above||val.left)s['!outline']={above:val.above,left:val.left};break;case 0x0089:/* 'BrtBeginWsView' */if(!wb.Views)wb.Views=[{}];if(!wb.Views[0])wb.Views[0]={};if(val.RTL)wb.Views[0].RTL=true;break;case 0x01E5:/* 'BrtWsFmtInfo' */break;case 0x0040:/* 'BrtDVal' */case 0x041D:/* 'BrtDVal14' */break;case 0x0097:/* 'BrtPane' */break;case 0x0098:/* 'BrtSel' */case 0x00AF:/* 'BrtAFilterDateGroupItem' */case 0x0284:/* 'BrtActiveX' */case 0x0271:/* 'BrtBigName' */case 0x0232:/* 'BrtBkHim' */case 0x018C:/* 'BrtBrk' */case 0x0458:/* 'BrtCFIcon' */case 0x047A:/* 'BrtCFRuleExt' */case 0x01D7:/* 'BrtCFVO' */case 0x041A:/* 'BrtCFVO14' */case 0x0289:/* 'BrtCellIgnoreEC' */case 0x0451:/* 'BrtCellIgnoreEC14' */case 0x0031:/* 'BrtCellMeta' */case 0x024D:/* 'BrtCellSmartTagProperty' */case 0x025F:/* 'BrtCellWatch' */case 0x0234:/* 'BrtColor' */case 0x041F:/* 'BrtColor14' */case 0x00A8:/* 'BrtColorFilter' */case 0x00AE:/* 'BrtCustomFilter' */case 0x049C:/* 'BrtCustomFilter14' */case 0x01F3:/* 'BrtDRef' */case 0x01FB:/* 'BrtDXF' */case 0x0226:/* 'BrtDrawing' */case 0x00AB:/* 'BrtDynamicFilter' */case 0x00A7:/* 'BrtFilter' */case 0x0499:/* 'BrtFilter14' */case 0x00A9:/* 'BrtIconFilter' */case 0x049D:/* 'BrtIconFilter14' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x0295:/* 'BrtListPart' */case 0x027F:/* 'BrtOleObject' */case 0x01DE:/* 'BrtPageSetup' */case 0x0219:/* 'BrtPhoneticInfo' */case 0x01DD:/* 'BrtPrintOptions' */case 0x0218:/* 'BrtRangeProtection' */case 0x044F:/* 'BrtRangeProtection14' */case 0x02A8:/* 'BrtRangeProtectionIso' */case 0x0450:/* 'BrtRangeProtectionIso14' */case 0x0400:/* 'BrtRwDescent' */case 0x0297:/* 'BrtSheetCalcProp' */case 0x0217:/* 'BrtSheetProtection' */case 0x02A6:/* 'BrtSheetProtectionIso' */case 0x01F8:/* 'BrtSlc' */case 0x0413:/* 'BrtSparkline' */case 0x01AC:/* 'BrtTable' */case 0x00AA:/* 'BrtTop10Filter' */case 0x0C00:/* 'BrtUid' */case 0x0032:/* 'BrtValueMeta' */case 0x0816:/* 'BrtWebExtension' */case 0x0415:/* 'BrtWsFmtInfoEx14' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;default:if((R_n||"").indexOf("Begin")>0){/* empty */}else if((R_n||"").indexOf("End")>0){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}},opts);delete opts.supbooks;delete opts['!row'];if(!s["!ref"]&&(refguess.s.r<2000000||ref&&(ref.e.r>0||ref.e.c>0||ref.s.r>0||ref.s.c>0)))s["!ref"]=encode_range(ref||refguess);if(opts.sheetRows&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(merges.length>0)s["!merges"]=merges;if(colinfo.length>0)s["!cols"]=colinfo;if(rowinfo.length>0)s["!rows"]=rowinfo;return s;}/* TODO: something useful -- this is a stub */function write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen){if(cell.v===undefined)return false;var vv="";switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'd':// no BrtCellDate :(
cell=dup(cell);cell.z=cell.z||SSF._table[14];cell.v=datenum(parseDate(cell.v));cell.t='n';break;/* falls through */case'n':case'e':vv=''+cell.v;break;default:vv=cell.v;break;}var o={r:R,c:C};/* TODO: cell style */o.s=get_cell_style(opts.cellXfs,cell,opts);if(cell.l)ws['!links'].push([encode_cell(o),cell.l]);if(cell.c)ws['!comments'].push([encode_cell(o),cell.c]);switch(cell.t){case's':case'str':if(opts.bookSST){vv=get_sst_id(opts.Strings,cell.v,opts.revStrings);o.t="s";o.v=vv;if(last_seen)write_record(ba,"BrtShortIsst",write_BrtShortIsst(cell,o));else write_record(ba,"BrtCellIsst",write_BrtCellIsst(cell,o));}else{o.t="str";if(last_seen)write_record(ba,"BrtShortSt",write_BrtShortSt(cell,o));else write_record(ba,"BrtCellSt",write_BrtCellSt(cell,o));}return true;case'n':/* TODO: determine threshold for Real vs RK */if(cell.v==(cell.v|0)&&cell.v>-1000&&cell.v<1000){if(last_seen)write_record(ba,"BrtShortRk",write_BrtShortRk(cell,o));else write_record(ba,"BrtCellRk",write_BrtCellRk(cell,o));}else{if(last_seen)write_record(ba,"BrtShortReal",write_BrtShortReal(cell,o));else write_record(ba,"BrtCellReal",write_BrtCellReal(cell,o));}return true;case'b':o.t="b";if(last_seen)write_record(ba,"BrtShortBool",write_BrtShortBool(cell,o));else write_record(ba,"BrtCellBool",write_BrtCellBool(cell,o));return true;case'e':o.t="e";if(last_seen)write_record(ba,"BrtShortError",write_BrtShortError(cell,o));else write_record(ba,"BrtCellError",write_BrtCellError(cell,o));return true;}if(last_seen)write_record(ba,"BrtShortBlank",write_BrtShortBlank(cell,o));else write_record(ba,"BrtCellBlank",write_BrtCellBlank(cell,o));return true;}function write_CELLTABLE(ba,ws,idx,opts){var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];write_record(ba,'BrtBeginSheetData');var dense=Array.isArray(ws);var cap=range.e.r;if(ws['!rows'])cap=Math.max(range.e.r,ws['!rows'].length-1);for(var R=range.s.r;R<=cap;++R){rr=encode_row(R);/* [ACCELLTABLE] */ /* BrtRowHdr */write_row_header(ba,ws,range,R);var last_seen=false;if(R<=range.e.r)for(var C=range.s.c;C<=range.e.c;++C){/* *16384CELL */if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell){last_seen=false;continue;}/* write cell */last_seen=write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen);}}write_record(ba,'BrtEndSheetData');}function write_MERGECELLS(ba,ws){if(!ws||!ws['!merges'])return;write_record(ba,'BrtBeginMergeCells',write_BrtBeginMergeCells(ws['!merges'].length));ws['!merges'].forEach(function(m){write_record(ba,'BrtMergeCell',write_BrtMergeCell(m));});write_record(ba,'BrtEndMergeCells');}function write_COLINFOS(ba,ws){if(!ws||!ws['!cols'])return;write_record(ba,'BrtBeginColInfos');ws['!cols'].forEach(function(m,i){if(m)write_record(ba,'BrtColInfo',write_BrtColInfo(i,m));});write_record(ba,'BrtEndColInfos');}function write_IGNOREECS(ba,ws){if(!ws||!ws['!ref'])return;write_record(ba,'BrtBeginCellIgnoreECs');write_record(ba,'BrtCellIgnoreEC',write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));write_record(ba,'BrtEndCellIgnoreECs');}function write_HLINKS(ba,ws,rels){/* *BrtHLink */ws['!links'].forEach(function(l){if(!l[1].Target)return;var rId=add_rels(rels,-1,l[1].Target.replace(/#.*$/,""),RELS.HLINK);write_record(ba,"BrtHLink",write_BrtHLink(l,rId));});delete ws['!links'];}function write_LEGACYDRAWING(ba,ws,idx,rels){/* [BrtLegacyDrawing] */if(ws['!comments'].length>0){var rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);write_record(ba,"BrtLegacyDrawing",write_RelID("rId"+rId));ws['!legacy']=rId;}}function write_AUTOFILTER(ba,ws,wb,idx){if(!ws['!autofilter'])return;var data=ws['!autofilter'];var ref=typeof data.ref==="string"?data.ref:encode_range(data.ref);/* Update FilterDatabase defined name for the worksheet */if(!wb.Workbook)wb.Workbook={Sheets:[]};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});write_record(ba,"BrtBeginAFilter",write_UncheckedRfX(safe_decode_range(ref)));/* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */write_record(ba,"BrtEndAFilter");}function write_WSVIEWS2(ba,ws,Workbook){write_record(ba,"BrtBeginWsViews");{/* 1*WSVIEW2 */ /* [ACUID] */write_record(ba,"BrtBeginWsView",write_BrtBeginWsView(ws,Workbook));/* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */write_record(ba,"BrtEndWsView");}/* *FRT */write_record(ba,"BrtEndWsViews");}function write_WSFMTINFO(){/* [ACWSFMTINFO] */ //write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
}function write_SHEETPROTECT(ba,ws){if(!ws['!protect'])return;/* [BrtSheetProtectionIso] */write_record(ba,"BrtSheetProtection",write_BrtSheetProtection(ws['!protect']));}function write_ws_bin(idx,opts,wb,rels){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var c=s;try{if(wb&&wb.Workbook)c=wb.Workbook.Sheets[idx].CodeName||c;}catch(e){}var r=safe_decode_range(ws['!ref']||"A1");if(r.e.c>0x3FFF||r.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:XFD1048576");r.e.c=Math.min(r.e.c,0x3FFF);r.e.r=Math.min(r.e.c,0xFFFFF);}ws['!links']=[];/* passed back to write_zip and removed there */ws['!comments']=[];write_record(ba,"BrtBeginSheet");if(wb.vbaraw||ws['!outline'])write_record(ba,"BrtWsProp",write_BrtWsProp(c,ws['!outline']));write_record(ba,"BrtWsDim",write_BrtWsDim(r));write_WSVIEWS2(ba,ws,wb.Workbook);write_WSFMTINFO(ba,ws);write_COLINFOS(ba,ws,idx,opts,wb);write_CELLTABLE(ba,ws,idx,opts,wb);/* [BrtSheetCalcProp] */write_SHEETPROTECT(ba,ws);/* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */write_AUTOFILTER(ba,ws,wb,idx);/* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */write_MERGECELLS(ba,ws);/* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */write_HLINKS(ba,ws,rels);/* [BrtPrintOptions] */if(ws['!margins'])write_record(ba,"BrtMargins",write_BrtMargins(ws['!margins']));/* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)write_IGNOREECS(ba,ws);/* [SMARTTAGS] */ /* [BrtDrawing] */write_LEGACYDRAWING(ba,ws,idx,rels);/* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */write_record(ba,"BrtEndSheet");return ba.end();}RELS.CHART="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";RELS.CHARTEX="http://schemas.microsoft.com/office/2014/relationships/chartEx";function parse_Cache(data){var col=[];var num=data.match(/^<c:numCache>/);var f;/* 21.2.2.150 pt CT_NumVal */(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt){var q=pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!q)return;col[+q[1]]=num?+q[2]:q[2];});/* 21.2.2.71 formatCode CT_Xstring */var nf=unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F){f=F.replace(/<.*?>/g,"");});return[col,nf,f];}/* 21.2 DrawingML - Charts */function parse_chart(data,name,opts,rels,wb,csheet){var cs=csheet||{"!type":"chart"};if(!data)return csheet;/* 21.2.2.27 chart CT_Chart */var C=0,R=0,col="A";var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};/* 21.2.2.120 numCache CT_NumData */(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc){var cache=parse_Cache(nc);refguess.s.r=refguess.s.c=0;refguess.e.c=C;col=encode_col(C);cache[0].forEach(function(n,i){cs[col+encode_row(i)]={t:'n',v:n,z:cache[1]};R=i;});if(refguess.e.r<R)refguess.e.r=R;++C;});if(C>0)cs["!ref"]=encode_range(refguess);return cs;}RELS.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var CS_XML_ROOT=writextag('chartsheet',null,{'xmlns':XMLNS.main[0],'xmlns:r':XMLNS.r});/* 18.3 Worksheets also covers Chartsheets */function parse_cs_xml(data,opts,idx,rels,wb){if(!data)return data;/* 18.3.1.12 chartsheet CT_ChartSheet */if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var m;/* 18.3.1.83 sheetPr CT_ChartsheetPr */var sheetPr=data.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);/* 18.3.1.36 drawing CT_Drawing */if(m=data.match(/drawing r:id="(.*?)"/))s['!rel']=m[1];if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_xml(idx,opts,wb,rels){var o=[XML_HEADER,CS_XML_ROOT];o[o.length]=writextag("drawing",null,{"r:id":"rId1"});add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);if(o.length>2){o[o.length]='</chartsheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.331 BrtCsProp */function parse_BrtCsProp(data,length){data.l+=10;var name=parse_XLWideString(data,length-10);return{name:name};}/* [MS-XLSB] 2.1.7.7 Chart Sheet */function parse_cs_bin(data,opts,idx,rels,wb){if(!data)return data;if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var state=[];var pass=false;recordhopper(data,function cs_parse(val,R_n,RT){switch(RT){case 0x0226:/* 'BrtDrawing' */s['!rel']=val;break;case 0x028B:/* 'BrtCsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;break;case 0x0232:/* 'BrtBkHim' */case 0x028C:/* 'BrtCsPageSetup' */case 0x029D:/* 'BrtCsProtection' */case 0x02A7:/* 'BrtCsProtectionIso' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x01DC:/* 'BrtMargins' */case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);break;case 0x0026:/* 'BrtACEnd' */state.pop();break;default:if((R_n||"").indexOf("Begin")>0)state.push(R_n);else if((R_n||"").indexOf("End")>0)state.pop();else if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R_n);}},opts);if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_bin(){var ba=buf_array();write_record(ba,"BrtBeginSheet");/* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */write_record(ba,"BrtEndSheet");return ba.end();}/* 18.2.28 (CT_WorkbookProtection) Defaults */var WBPropsDef=[['allowRefreshQuery',false,"bool"],['autoCompressPictures',true,"bool"],['backupFile',false,"bool"],['checkCompatibility',false,"bool"],['CodeName',''],['date1904',false,"bool"],['defaultThemeVersion',0,"int"],['filterPrivacy',false,"bool"],['hidePivotFieldList',false,"bool"],['promptedSolutions',false,"bool"],['publishItems',false,"bool"],['refreshAllConnections',false,"bool"],['saveExternalLinkValues',true,"bool"],['showBorderUnselectedTables',true,"bool"],['showInkAnnotation',true,"bool"],['showObjects','all'],['showPivotChartFilter',false,"bool"],['updateLinks','userSet']];/* 18.2.30 (CT_BookView) Defaults */var WBViewDef=[['activeTab',0,"int"],['autoFilterDateGrouping',true,"bool"],['firstSheet',0,"int"],['minimized',false,"bool"],['showHorizontalScroll',true,"bool"],['showSheetTabs',true,"bool"],['showVerticalScroll',true,"bool"],['tabRatio',600,"int"],['visibility','visible']//window{Height,Width}, {x,y}Window
];/* 18.2.19 (CT_Sheet) Defaults */var SheetDef=[//['state', 'visible']
];/* 18.2.2  (CT_CalcPr) Defaults */var CalcPrDef=[['calcCompleted','true'],['calcMode','auto'],['calcOnSave','true'],['concurrentCalc','true'],['fullCalcOnLoad','false'],['fullPrecision','true'],['iterate','false'],['iterateCount','100'],['iterateDelta','0.001'],['refMode','A1']];/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/function push_defaults_array(target,defaults){for(var j=0;j!=target.length;++j){var w=target[j];for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(w[z[0]]==null)w[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof w[z[0]]=="string")w[z[0]]=parsexmlbool(w[z[0]]);break;case"int":if(typeof w[z[0]]=="string")w[z[0]]=parseInt(w[z[0]],10);break;}}}}function push_defaults(target,defaults){for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(target[z[0]]==null)target[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof target[z[0]]=="string")target[z[0]]=parsexmlbool(target[z[0]]);break;case"int":if(typeof target[z[0]]=="string")target[z[0]]=parseInt(target[z[0]],10);break;}}}function parse_wb_defaults(wb){push_defaults(wb.WBProps,WBPropsDef);push_defaults(wb.CalcPr,CalcPrDef);push_defaults_array(wb.WBView,WBViewDef);push_defaults_array(wb.Sheets,SheetDef);_ssfopts.date1904=parsexmlbool(wb.WBProps.date1904);}function safe1904(wb){/* TODO: store date1904 somewhere else */if(!wb.Workbook)return"false";if(!wb.Workbook.WBProps)return"false";return parsexmlbool(wb.Workbook.WBProps.date1904)?"true":"false";}var badchars="][*?\/\\".split("");function check_ws_name(n,safe){if(n.length>31){if(safe)return false;throw new Error("Sheet names cannot exceed 31 chars");}var _good=true;badchars.forEach(function(c){if(n.indexOf(c)==-1)return;if(!safe)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");_good=false;});return _good;}function check_wb_names(N,S,codes){N.forEach(function(n,i){check_ws_name(n);for(var j=0;j<i;++j)if(n==N[j])throw new Error("Duplicate Sheet Name: "+n);if(codes){var cn=S&&S[i]&&S[i].CodeName||n;if(cn.charCodeAt(0)==95&&cn.length>22)throw new Error("Bad Code Name: Worksheet"+cn);}});}function check_wb(wb){if(!wb||!wb.SheetNames||!wb.Sheets)throw new Error("Invalid Workbook");if(!wb.SheetNames.length)throw new Error("Workbook is empty");var Sheets=wb.Workbook&&wb.Workbook.Sheets||[];check_wb_names(wb.SheetNames,Sheets,!!wb.vbaraw);for(var i=0;i<wb.SheetNames.length;++i)check_ws(wb.Sheets[wb.SheetNames[i]],wb.SheetNames[i],i);/* TODO: validate workbook */}/* 18.2 Workbook */var wbnsregex=/<\w+:workbook/;function parse_wb_xml(data,opts){if(!data)throw new Error("Could not find file");var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var pass=false,xmlns="xmlns";var dname={},dnstart=0;data.replace(tagregex,function xml_wb(x,idx){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;/* 18.2.27 workbook CT_Workbook 1 */case'<workbook':if(x.match(wbnsregex))xmlns="xmlns"+x.match(/<(\w+):/)[1];wb.xmlns=y[xmlns];break;case'</workbook>':break;/* 18.2.13 fileVersion CT_FileVersion ? */case'<fileVersion':delete y[0];wb.AppVersion=y;break;case'<fileVersion/>':case'</fileVersion>':break;/* 18.2.12 fileSharing CT_FileSharing ? */case'<fileSharing':break;case'<fileSharing/>':break;/* 18.2.28 workbookPr CT_WorkbookPr ? */case'<workbookPr':case'<workbookPr/>':WBPropsDef.forEach(function(w){if(y[w[0]]==null)return;switch(w[2]){case"bool":wb.WBProps[w[0]]=parsexmlbool(y[w[0]]);break;case"int":wb.WBProps[w[0]]=parseInt(y[w[0]],10);break;default:wb.WBProps[w[0]]=y[w[0]];}});if(y.codeName)wb.WBProps.CodeName=utf8read(y.codeName);break;case'</workbookPr>':break;/* 18.2.29 workbookProtection CT_WorkbookProtection ? */case'<workbookProtection':break;case'<workbookProtection/>':break;/* 18.2.1  bookViews CT_BookViews ? */case'<bookViews':case'<bookViews>':case'</bookViews>':break;/* 18.2.30   workbookView CT_BookView + */case'<workbookView':case'<workbookView/>':delete y[0];wb.WBView.push(y);break;case'</workbookView>':break;/* 18.2.20 sheets CT_Sheets 1 */case'<sheets':case'<sheets>':case'</sheets>':break;// aggregate sheet
/* 18.2.19   sheet CT_Sheet + */case'<sheet':switch(y.state){case"hidden":y.Hidden=1;break;case"veryHidden":y.Hidden=2;break;default:y.Hidden=0;}delete y.state;y.name=unescapexml(utf8read(y.name));delete y[0];wb.Sheets.push(y);break;case'</sheet>':break;/* 18.2.15 functionGroups CT_FunctionGroups ? */case'<functionGroups':case'<functionGroups/>':break;/* 18.2.14   functionGroup CT_FunctionGroup + */case'<functionGroup':break;/* 18.2.9  externalReferences CT_ExternalReferences ? */case'<externalReferences':case'</externalReferences>':case'<externalReferences>':break;/* 18.2.8    externalReference CT_ExternalReference + */case'<externalReference':break;/* 18.2.6  definedNames CT_DefinedNames ? */case'<definedNames/>':break;case'<definedNames>':case'<definedNames':pass=true;break;case'</definedNames>':pass=false;break;/* 18.2.5    definedName CT_DefinedName + */case'<definedName':{dname={};dname.Name=utf8read(y.name);if(y.comment)dname.Comment=y.comment;if(y.localSheetId)dname.Sheet=+y.localSheetId;if(parsexmlbool(y.hidden||"0"))dname.Hidden=true;dnstart=idx+x.length;}break;case'</definedName>':{dname.Ref=unescapexml(utf8read(data.slice(dnstart,idx)));wb.Names.push(dname);}break;case'<definedName/>':break;/* 18.2.2  calcPr CT_CalcPr ? */case'<calcPr':delete y[0];wb.CalcPr=y;break;case'<calcPr/>':delete y[0];wb.CalcPr=y;break;case'</calcPr>':break;/* 18.2.16 oleSize CT_OleSize ? (ref required) */case'<oleSize':break;/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */case'<customWorkbookViews>':case'</customWorkbookViews>':case'<customWorkbookViews':break;/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */case'<customWorkbookView':case'</customWorkbookView>':break;/* 18.2.18 pivotCaches CT_PivotCaches ? */case'<pivotCaches>':case'</pivotCaches>':case'<pivotCaches':break;/* 18.2.17 pivotCache CT_PivotCache ? */case'<pivotCache':break;/* 18.2.21 smartTagPr CT_SmartTagPr ? */case'<smartTagPr':case'<smartTagPr/>':break;/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */case'<smartTagTypes':case'<smartTagTypes>':case'</smartTagTypes>':break;/* 18.2.22 smartTagType CT_SmartTagType ? */case'<smartTagType':break;/* 18.2.24 webPublishing CT_WebPublishing ? */case'<webPublishing':case'<webPublishing/>':break;/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */case'<fileRecoveryPr':case'<fileRecoveryPr/>':break;/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */case'<webPublishObjects>':case'<webPublishObjects':case'</webPublishObjects>':break;/* 18.2.25 webPublishObject CT_WebPublishObject ? */case'<webPublishObject':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;/* 18.2.7  ext CT_Extension + */case'<ext':pass=true;break;//TODO: check with versions of excel
case'</ext>':pass=false;break;/* Others */case'<ArchID':break;case'<AlternateContent':case'<AlternateContent>':pass=true;break;case'</AlternateContent>':pass=false;break;/* TODO */case'<revisionPtr':break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in workbook');}return x;});if(XMLNS.main.indexOf(wb.xmlns)===-1)throw new Error("Unknown Namespace: "+wb.xmlns);parse_wb_defaults(wb);return wb;}var WB_XML_ROOT=writextag('workbook',null,{'xmlns':XMLNS.main[0],//'xmlns:mx': XMLNS.mx,
//'xmlns:s': XMLNS.main[0],
'xmlns:r':XMLNS.r});function write_wb_xml(wb){var o=[XML_HEADER];o[o.length]=WB_XML_ROOT;var write_names=wb.Workbook&&(wb.Workbook.Names||[]).length>0;/* fileVersion */ /* fileSharing */var workbookPr={codeName:"ThisWorkbook"};if(wb.Workbook&&wb.Workbook.WBProps){WBPropsDef.forEach(function(x){if(wb.Workbook.WBProps[x[0]]==null)return;if(wb.Workbook.WBProps[x[0]]==x[1])return;workbookPr[x[0]]=wb.Workbook.WBProps[x[0]];});if(wb.Workbook.WBProps.CodeName){workbookPr.codeName=wb.Workbook.WBProps.CodeName;delete workbookPr.CodeName;}}o[o.length]=writextag('workbookPr',null,workbookPr);/* workbookProtection */var sheets=wb.Workbook&&wb.Workbook.Sheets||[];var i=0;/* bookViews only written if first worksheet is hidden */if(sheets&&sheets[0]&&!!sheets[0].Hidden){o[o.length]="<bookViews>";for(i=0;i!=wb.SheetNames.length;++i){if(!sheets[i])break;if(!sheets[i].Hidden)break;}if(i==wb.SheetNames.length)i=0;o[o.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';o[o.length]="</bookViews>";}o[o.length]="<sheets>";for(i=0;i!=wb.SheetNames.length;++i){var sht={name:escapexml(wb.SheetNames[i].slice(0,31))};sht.sheetId=""+(i+1);sht["r:id"]="rId"+(i+1);if(sheets[i])switch(sheets[i].Hidden){case 1:sht.state="hidden";break;case 2:sht.state="veryHidden";break;}o[o.length]=writextag('sheet',null,sht);}o[o.length]="</sheets>";/* functionGroups */ /* externalReferences */if(write_names){o[o.length]="<definedNames>";if(wb.Workbook&&wb.Workbook.Names)wb.Workbook.Names.forEach(function(n){var d={name:n.Name};if(n.Comment)d.comment=n.Comment;if(n.Sheet!=null)d.localSheetId=""+n.Sheet;if(n.Hidden)d.hidden="1";if(!n.Ref)return;o[o.length]=writextag('definedName',escapexml(n.Ref),d);});o[o.length]="</definedNames>";}/* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */if(o.length>2){o[o.length]='</workbook>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.304 BrtBundleSh */function parse_BrtBundleSh(data,length){var z={};z.Hidden=data.read_shift(4);//hsState ST_SheetState
z.iTabID=data.read_shift(4);z.strRelID=parse_RelID(data,length-8);z.name=parse_XLWideString(data);return z;}function write_BrtBundleSh(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.Hidden);o.write_shift(4,data.iTabID);write_RelID(data.strRelID,o);write_XLWideString(data.name.slice(0,31),o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.815 BrtWbProp */function parse_BrtWbProp(data,length){var o={};var flags=data.read_shift(4);o.defaultThemeVersion=data.read_shift(4);var strName=length>8?parse_XLWideString(data):"";if(strName.length>0)o.CodeName=strName;o.autoCompressPictures=!!(flags&0x10000);o.backupFile=!!(flags&0x40);o.checkCompatibility=!!(flags&0x1000);o.date1904=!!(flags&0x01);o.filterPrivacy=!!(flags&0x08);o.hidePivotFieldList=!!(flags&0x400);o.promptedSolutions=!!(flags&0x10);o.publishItems=!!(flags&0x800);o.refreshAllConnections=!!(flags&0x40000);o.saveExternalLinkValues=!!(flags&0x80);o.showBorderUnselectedTables=!!(flags&0x04);o.showInkAnnotation=!!(flags&0x20);o.showObjects=["all","placeholders","none"][flags>>13&0x03];o.showPivotChartFilter=!!(flags&0x8000);o.updateLinks=["userSet","never","always"][flags>>8&0x03];return o;}function write_BrtWbProp(data,o){if(!o)o=new_buf(72);var flags=0;if(data){/* TODO: mirror parse_BrtWbProp fields */if(data.filterPrivacy)flags|=0x08;}o.write_shift(4,flags);o.write_shift(4,0);write_XLSBCodeName(data&&data.CodeName||"ThisWorkbook",o);return o.slice(0,o.l);}function parse_BrtFRTArchID$(data,length){var o={};data.read_shift(4);o.ArchID=data.read_shift(4);data.l+=length-8;return o;}/* [MS-XLSB] 2.4.687 BrtName */function parse_BrtName(data,length,opts){var end=data.l+length;data.l+=4;//var flags = data.read_shift(4);
data.l+=1;//var chKey = data.read_shift(1);
var itab=data.read_shift(4);var name=parse_XLNameWideString(data);var formula=parse_XLSBNameParsedFormula(data,0,opts);var comment=parse_XLNullableWideString(data);//if(0 /* fProc */) {
// unusedstring1: XLNullableWideString
// description: XLNullableWideString
// helpTopic: XLNullableWideString
// unusedstring2: XLNullableWideString
//}
data.l=end;var out={Name:name,Ptg:formula};if(itab<0xFFFFFFF)out.Sheet=itab;if(comment)out.Comment=comment;return out;}/* [MS-XLSB] 2.1.7.61 Workbook */function parse_wb_bin(data,opts){var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var state=[];var pass=false;if(!opts)opts={};opts.biff=12;var Names=[];var supbooks=[[]];supbooks.SheetNames=[];supbooks.XTI=[];XLSBRecordEnum[0x0010]={n:"BrtFRTArchID$",f:parse_BrtFRTArchID$};recordhopper(data,function hopper_wb(val,R_n,RT){switch(RT){case 0x009C:/* 'BrtBundleSh' */supbooks.SheetNames.push(val.name);wb.Sheets.push(val);break;case 0x0099:/* 'BrtWbProp' */wb.WBProps=val;break;case 0x0027:/* 'BrtName' */if(val.Sheet!=null)opts.SID=val.Sheet;val.Ref=stringify_formula(val.Ptg,null,null,supbooks,opts);delete opts.SID;delete val.Ptg;Names.push(val);break;case 0x040C:/* 'BrtNameExt' */break;case 0x0165:/* 'BrtSupSelf' */case 0x0166:/* 'BrtSupSame' */case 0x0163:/* 'BrtSupBookSrc' */case 0x029B:/* 'BrtSupAddin' */if(!supbooks[0].length)supbooks[0]=[RT,val];else supbooks.push([RT,val]);supbooks[supbooks.length-1].XTI=[];break;case 0x016A:/* 'BrtExternSheet' */if(supbooks.length===0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0169:/* 'BrtPlaceholderName' */break;case 0x0817:/* 'BrtAbsPath15' */case 0x009E:/* 'BrtBookView' */case 0x008F:/* 'BrtBeginBundleShs' */case 0x0298:/* 'BrtBeginFnGroup' */case 0x0161:/* 'BrtBeginExternals' */break;/* case 'BrtModelTimeGroupingCalcCol' */case 0x0C00:/* 'BrtUid' */case 0x0C01:/* 'BrtRevisionPtr' */case 0x0216:/* 'BrtBookProtection' */case 0x02A5:/* 'BrtBookProtectionIso' */case 0x009D:/* 'BrtCalcProp' */case 0x0262:/* 'BrtCrashRecErr' */case 0x0802:/* 'BrtDecoupledPivotCacheID' */case 0x009B:/* 'BrtFileRecover' */case 0x0224:/* 'BrtFileSharing' */case 0x02A4:/* 'BrtFileSharingIso' */case 0x0080:/* 'BrtFileVersion' */case 0x0299:/* 'BrtFnGroup' */case 0x0850:/* 'BrtModelRelationship' */case 0x084D:/* 'BrtModelTable' */case 0x0225:/* 'BrtOleSize' */case 0x0805:/* 'BrtPivotTableRef' */case 0x0254:/* 'BrtSmartTagType' */case 0x081C:/* 'BrtTableSlicerCacheID' */case 0x081B:/* 'BrtTableSlicerCacheIDs' */case 0x0822:/* 'BrtTimelineCachePivotCacheID' */case 0x018D:/* 'BrtUserBookView' */case 0x009A:/* 'BrtWbFactoid' */case 0x045D:/* 'BrtWbProp14' */case 0x0229:/* 'BrtWebOpt' */case 0x082B:/* 'BrtWorkBookPr15' */break;case 0x0023:/* 'BrtFRTBegin' */state.push(R_n);pass=true;break;case 0x0024:/* 'BrtFRTEnd' */state.pop();pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(R_n);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;case 0x0010:/* 'BrtFRTArchID$' */break;default:if((R_n||"").indexOf("Begin")>0){/* empty */}else if((R_n||"").indexOf("End")>0){/* empty */}else if(!pass||opts.WTF&&state[state.length-1]!="BrtACBegin"&&state[state.length-1]!="BrtFRTBegin")throw new Error("Unexpected record "+RT+" "+R_n);}},opts);parse_wb_defaults(wb);// $FlowIgnore
wb.Names=Names;wb.supbooks=supbooks;return wb;}function write_BUNDLESHS(ba,wb){write_record(ba,"BrtBeginBundleShs");for(var idx=0;idx!=wb.SheetNames.length;++idx){var viz=wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]&&wb.Workbook.Sheets[idx].Hidden||0;var d={Hidden:viz,iTabID:idx+1,strRelID:'rId'+(idx+1),name:wb.SheetNames[idx]};write_record(ba,"BrtBundleSh",write_BrtBundleSh(d));}write_record(ba,"BrtEndBundleShs");}/* [MS-XLSB] 2.4.649 BrtFileVersion */function write_BrtFileVersion(data,o){if(!o)o=new_buf(127);for(var i=0;i!=4;++i)o.write_shift(4,0);write_XLWideString("SheetJS",o);write_XLWideString(XLSX.version,o);write_XLWideString(XLSX.version,o);write_XLWideString("7262",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.301 BrtBookView */function write_BrtBookView(idx,o){if(!o)o=new_buf(29);o.write_shift(-4,0);o.write_shift(-4,460);o.write_shift(4,28800);o.write_shift(4,17600);o.write_shift(4,500);o.write_shift(4,idx);o.write_shift(4,idx);var flags=0x78;o.write_shift(1,flags);return o.length>o.l?o.slice(0,o.l):o;}function write_BOOKVIEWS(ba,wb){/* required if hidden tab appears before visible tab */if(!wb.Workbook||!wb.Workbook.Sheets)return;var sheets=wb.Workbook.Sheets;var i=0,vistab=-1,hidden=-1;for(;i<sheets.length;++i){if(!sheets[i]||!sheets[i].Hidden&&vistab==-1)vistab=i;else if(sheets[i].Hidden==1&&hidden==-1)hidden=i;}if(hidden>vistab)return;write_record(ba,"BrtBeginBookViews");write_record(ba,"BrtBookView",write_BrtBookView(vistab));/* 1*(BrtBookView *FRT) */write_record(ba,"BrtEndBookViews");}/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */function write_wb_bin(wb,opts){var ba=buf_array();write_record(ba,"BrtBeginBook");write_record(ba,"BrtFileVersion",write_BrtFileVersion());/* [[BrtFileSharingIso] BrtFileSharing] */write_record(ba,"BrtWbProp",write_BrtWbProp(wb.Workbook&&wb.Workbook.WBProps||null));/* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */write_BOOKVIEWS(ba,wb,opts);write_BUNDLESHS(ba,wb,opts);/* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */write_record(ba,"BrtEndBook");return ba.end();}function parse_wb(data,name,opts){if(name.slice(-4)===".bin")return parse_wb_bin(data,opts);return parse_wb_xml(data,opts);}function parse_ws(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ws_bin(data,opts,idx,rels,wb,themes,styles);return parse_ws_xml(data,opts,idx,rels,wb,themes,styles);}function parse_cs(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_cs_bin(data,opts,idx,rels,wb,themes,styles);return parse_cs_xml(data,opts,idx,rels,wb,themes,styles);}function parse_ms(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ms_bin(data,opts,idx,rels,wb,themes,styles);return parse_ms_xml(data,opts,idx,rels,wb,themes,styles);}function parse_ds(data,name,idx,opts,rels,wb,themes,styles){if(name.slice(-4)===".bin")return parse_ds_bin(data,opts,idx,rels,wb,themes,styles);return parse_ds_xml(data,opts,idx,rels,wb,themes,styles);}function parse_sty(data,name,themes,opts){if(name.slice(-4)===".bin")return parse_sty_bin(data,themes,opts);return parse_sty_xml(data,themes,opts);}function parse_theme(data,name,opts){return parse_theme_xml(data,opts);}function parse_sst(data,name,opts){if(name.slice(-4)===".bin")return parse_sst_bin(data,opts);return parse_sst_xml(data,opts);}function parse_cmnt(data,name,opts){if(name.slice(-4)===".bin")return parse_comments_bin(data,opts);return parse_comments_xml(data,opts);}function parse_cc(data,name,opts){if(name.slice(-4)===".bin")return parse_cc_bin(data,name,opts);return parse_cc_xml(data,name,opts);}function parse_xlink(data,rel,name,opts){if(name.slice(-4)===".bin")return parse_xlink_bin(data,rel,name,opts);return parse_xlink_xml(data,rel,name,opts);}function write_wb(wb,name,opts){return(name.slice(-4)===".bin"?write_wb_bin:write_wb_xml)(wb,opts);}function write_ws(data,name,opts,wb,rels){return(name.slice(-4)===".bin"?write_ws_bin:write_ws_xml)(data,opts,wb,rels);}// eslint-disable-next-line no-unused-vars
function write_cs(data,name,opts,wb,rels){return(name.slice(-4)===".bin"?write_cs_bin:write_cs_xml)(data,opts,wb,rels);}function write_sty(data,name,opts){return(name.slice(-4)===".bin"?write_sty_bin:write_sty_xml)(data,opts);}function write_sst(data,name,opts){return(name.slice(-4)===".bin"?write_sst_bin:write_sst_xml)(data,opts);}function write_cmnt(data,name,opts){return(name.slice(-4)===".bin"?write_comments_bin:write_comments_xml)(data,opts);}/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function xlml_parsexmltag(tag,skip_root){var words=tag.split(/\s+/);var z=[];if(!skip_root)z[0]=words[0];if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}function xlml_parsexmltagobj(tag){var words=tag.split(/\s+/);var z={};if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}// ----
function xlml_format(format,value){var fmt=XLMLFormatMap[format]||unescapexml(format);if(fmt==="General")return SSF._general(value);return SSF.format(fmt,value);}function xlml_set_custprop(Custprops,key,cp,val){var oval=val;switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":oval=parsexmlbool(val);break;case"i2":case"int":oval=parseInt(val,10);break;case"r4":case"float":oval=parseFloat(val);break;case"date":case"dateTime.tz":oval=parseDate(val);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+cp[0]);}Custprops[unescapexml(key)]=oval;}function safe_format_xlml(cell,nf,o){if(cell.t==='z')return;if(!o||o.cellText!==false)try{if(cell.t==='e'){cell.w=cell.w||BErr[cell.v];}else if(nf==="General"){if(cell.t==='n'){if((cell.v|0)===cell.v)cell.w=SSF._general_int(cell.v);else cell.w=SSF._general_num(cell.v);}else cell.w=SSF._general(cell.v);}else cell.w=xlml_format(nf||"General",cell.v);}catch(e){if(o.WTF)throw e;}try{var z=XLMLFormatMap[nf]||nf||"General";if(o.cellNF)cell.z=z;if(o.cellDates&&cell.t=='n'&&SSF.is_date(z)){var _d=SSF.parse_date_code(cell.v);if(_d){cell.t='d';cell.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}catch(e){if(o.WTF)throw e;}}function process_style_xlml(styles,stag,opts){if(opts.cellStyles){if(stag.Interior){var I=stag.Interior;if(I.Pattern)I.patternType=XLMLPatternTypeMap[I.Pattern]||I.Pattern;}}styles[stag.ID]=stag;}/* TODO: there must exist some form of OSP-blessed spec */function parse_xlml_data(xml,ss,data,cell,base,styles,csty,row,arrayf,o){var nf="General",sid=cell.StyleID,S={};o=o||{};var interiors=[];var i=0;if(sid===undefined&&row)sid=row.StyleID;if(sid===undefined&&csty)sid=csty.StyleID;while(styles[sid]!==undefined){if(styles[sid].nf)nf=styles[sid].nf;if(styles[sid].Interior)interiors.push(styles[sid].Interior);if(!styles[sid].Parent)break;sid=styles[sid].Parent;}switch(data.Type){case'Boolean':cell.t='b';cell.v=parsexmlbool(xml);break;case'String':cell.t='s';cell.r=xlml_fixstr(unescapexml(xml));cell.v=xml.indexOf("<")>-1?unescapexml(ss||xml).replace(/<.*?>/g,""):cell.r;// todo: BR etc
break;case'DateTime':if(xml.slice(-1)!="Z")xml+="Z";cell.v=(parseDate(xml)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1000);if(cell.v!==cell.v)cell.v=unescapexml(xml);else if(cell.v<60)cell.v=cell.v-1;if(!nf||nf=="General")nf="yyyy-mm-dd";/* falls through */case'Number':if(cell.v===undefined)cell.v=+xml;if(!cell.t)cell.t='n';break;case'Error':cell.t='e';cell.v=RBErr[xml];if(o.cellText!==false)cell.w=xml;break;default:if(xml==""&&ss==""){cell.t='z';}else{cell.t='s';cell.v=xlml_fixstr(ss||xml);}break;}safe_format_xlml(cell,nf,o);if(o.cellFormula!==false){if(cell.Formula){var fstr=unescapexml(cell.Formula);/* strictly speaking, the leading = is required but some writers omit */if(fstr.charCodeAt(0)==61/* = */)fstr=fstr.slice(1);cell.f=rc_to_a1(fstr,base);delete cell.Formula;if(cell.ArrayRange=="RC")cell.F=rc_to_a1("RC:RC",base);else if(cell.ArrayRange){cell.F=rc_to_a1(cell.ArrayRange,base);arrayf.push([safe_decode_range(cell.F),cell.F]);}}else{for(i=0;i<arrayf.length;++i)if(base.r>=arrayf[i][0].s.r&&base.r<=arrayf[i][0].e.r)if(base.c>=arrayf[i][0].s.c&&base.c<=arrayf[i][0].e.c)cell.F=arrayf[i][1];}}if(o.cellStyles){interiors.forEach(function(x){if(!S.patternType&&x.patternType)S.patternType=x.patternType;});cell.s=S;}if(cell.StyleID!==undefined)cell.ixfe=cell.StyleID;}function xlml_clean_comment(comment){comment.t=comment.v||"";comment.t=comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");comment.v=comment.w=comment.ixfe=undefined;}function xlml_normalize(d){if(has_buf&&Buffer.isBuffer(d))return d.toString('utf8');if(typeof d==='string')return d;/* duktape */if(typeof Uint8Array!=='undefined'&&d instanceof Uint8Array)return utf8read(a2s(ab2a(d)));throw new Error("Bad input format: expected Buffer or string");}/* TODO: Everything */ /* UOS uses CJK in tags */var xlmlregex=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d,_opts){var opts=_opts||{};make_ssf(SSF);var str=debom(xlml_normalize(d));if(opts.type=='binary'||opts.type=='array'||opts.type=='base64'){if(typeof cptable!=='undefined')str=cptable.utils.decode(65001,char_codes(str));else str=utf8read(str);}var opening=str.slice(0,1024).toLowerCase(),ishtml=false;opening=opening.replace(/".*?"/g,"");if((opening.indexOf(">")&1023)>Math.min(opening.indexOf(",")&1023,opening.indexOf(";")&1023)){var _o=dup(opts);_o.type="string";return PRN.to_workbook(str,_o);}if(opening.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(tag){if(opening.indexOf("<"+tag)>=0)ishtml=true;});if(ishtml)return HTML_.to_workbook(str,opts);var Rn;var state=[],tmp;if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var sheets={},sheetnames=[],cursheet=opts.dense?[]:{},sheetname="";var table={},cell={},row={};// eslint-disable-line no-unused-vars
var dtag=xlml_parsexmltag('<Data ss:Type="String">'),didx=0;var c=0,r=0;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var styles={},stag={};var ss="",fidx=0;var merges=[];var Props={},Custprops={},pidx=0,cp=[];var comments=[],comment={};var cstys=[],csty,seencol=false;var arrayf=[];var rowinfo=[],rowobj={},cc=0,rr=0;var Workbook={Sheets:[],WBProps:{date1904:false}},wsprops={};xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"");var raw_Rn3="";while(Rn=xlmlregex.exec(str))switch(Rn[3]=(raw_Rn3=Rn[3]).toLowerCase()){case'data'/*case 'Data'*/:if(raw_Rn3=="data"){if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;}if(state[state.length-1][1])break;if(Rn[1]==='/')parse_xlml_data(str.slice(didx,Rn.index),ss,dtag,state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell,{c:c,r:r},styles,cstys[c],row,arrayf,opts);else{ss="";dtag=xlml_parsexmltag(Rn[0]);didx=Rn.index+Rn[0].length;}break;case'cell'/*case 'Cell'*/:if(Rn[1]==='/'){if(comments.length>0)cell.c=comments;if((!opts.sheetRows||opts.sheetRows>r)&&cell.v!==undefined){if(opts.dense){if(!cursheet[r])cursheet[r]=[];cursheet[r][c]=cell;}else cursheet[encode_col(c)+encode_row(r)]=cell;}if(cell.HRef){cell.l={Target:unescapexml(cell.HRef)};if(cell.HRefScreenTip)cell.l.Tooltip=cell.HRefScreenTip;delete cell.HRef;delete cell.HRefScreenTip;}if(cell.MergeAcross||cell.MergeDown){cc=c+(parseInt(cell.MergeAcross,10)|0);rr=r+(parseInt(cell.MergeDown,10)|0);merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});}if(!opts.sheetStubs){if(cell.MergeAcross)c=cc+1;else++c;}else if(cell.MergeAcross||cell.MergeDown){for(var cma=c;cma<=cc;++cma){for(var cmd=r;cmd<=rr;++cmd){if(cma>c||cmd>r){if(opts.dense){if(!cursheet[cmd])cursheet[cmd]=[];cursheet[cmd][cma]={t:'z'};}else cursheet[encode_col(cma)+encode_row(cmd)]={t:'z'};}}}c=cc+1;}else++c;}else{cell=xlml_parsexmltagobj(Rn[0]);if(cell.Index)c=+cell.Index-1;if(c<refguess.s.c)refguess.s.c=c;if(c>refguess.e.c)refguess.e.c=c;if(Rn[0].slice(-2)==="/>")++c;comments=[];}break;case'row'/*case 'Row'*/:if(Rn[1]==='/'||Rn[0].slice(-2)==="/>"){if(r<refguess.s.r)refguess.s.r=r;if(r>refguess.e.r)refguess.e.r=r;if(Rn[0].slice(-2)==="/>"){row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;}c=0;++r;}else{row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;rowobj={};if(row.AutoFitHeight=="0"||row.Height){rowobj.hpx=parseInt(row.Height,10);rowobj.hpt=px2pt(rowobj.hpx);rowinfo[r]=rowobj;}if(row.Hidden=="1"){rowobj.hidden=true;rowinfo[r]=rowobj;}}break;case'worksheet'/*case 'Worksheet'*/:/* TODO: read range from FullRows/FullColumns */if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));sheetnames.push(sheetname);if(refguess.s.r<=refguess.e.r&&refguess.s.c<=refguess.e.c){cursheet["!ref"]=encode_range(refguess);if(opts.sheetRows&&opts.sheetRows<=refguess.e.r){cursheet["!fullref"]=cursheet["!ref"];refguess.e.r=opts.sheetRows-1;cursheet["!ref"]=encode_range(refguess);}}if(merges.length)cursheet["!merges"]=merges;if(cstys.length>0)cursheet["!cols"]=cstys;if(rowinfo.length>0)cursheet["!rows"]=rowinfo;sheets[sheetname]=cursheet;}else{refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};r=c=0;state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);sheetname=unescapexml(tmp.Name);cursheet=opts.dense?[]:{};merges=[];arrayf=[];rowinfo=[];wsprops={name:sheetname,Hidden:0};Workbook.Sheets.push(wsprops);}break;case'table'/*case 'Table'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].slice(-2)=="/>")break;else{table=xlml_parsexmltag(Rn[0]);state.push([Rn[3],false]);cstys=[];seencol=false;}break;case'style'/*case 'Style'*/:if(Rn[1]==='/')process_style_xlml(styles,stag,opts);else stag=xlml_parsexmltag(Rn[0]);break;case'numberformat'/*case 'NumberFormat'*/:stag.nf=unescapexml(xlml_parsexmltag(Rn[0]).Format||"General");if(XLMLFormatMap[stag.nf])stag.nf=XLMLFormatMap[stag.nf];for(var ssfidx=0;ssfidx!=0x188;++ssfidx)if(SSF._table[ssfidx]==stag.nf)break;if(ssfidx==0x188)for(ssfidx=0x39;ssfidx!=0x188;++ssfidx)if(SSF._table[ssfidx]==null){SSF.load(stag.nf,ssfidx);break;}break;case'column'/*case 'Column'*/:if(state[state.length-1][0]!==/*'Table'*/'table')break;csty=xlml_parsexmltag(Rn[0]);if(csty.Hidden){csty.hidden=true;delete csty.Hidden;}if(csty.Width)csty.wpx=parseInt(csty.Width,10);if(!seencol&&csty.wpx>10){seencol=true;MDW=DEF_MDW;//find_mdw_wpx(csty.wpx);
for(var _col=0;_col<cstys.length;++_col)if(cstys[_col])process_col(cstys[_col]);}if(seencol)process_col(csty);cstys[csty.Index-1||cstys.length]=csty;for(var i=0;i<+csty.Span;++i)cstys[cstys.length]=dup(csty);break;case'namedrange'/*case 'NamedRange'*/:if(Rn[1]==='/')break;if(!Workbook.Names)Workbook.Names=[];var _NamedRange=parsexmltag(Rn[0]);var _DefinedName={Name:_NamedRange.Name,Ref:rc_to_a1(_NamedRange.RefersTo.slice(1),{r:0,c:0})};if(Workbook.Sheets.length>0)_DefinedName.Sheet=Workbook.Sheets.length-1;Workbook.Names.push(_DefinedName);break;case'namedcell'/*case 'NamedCell'*/:break;case'b'/*case 'B'*/:break;case'i'/*case 'I'*/:break;case'u'/*case 'U'*/:break;case's'/*case 'S'*/:break;case'em'/*case 'EM'*/:break;case'h2'/*case 'H2'*/:break;case'h3'/*case 'H3'*/:break;case'sub'/*case 'Sub'*/:break;case'sup'/*case 'Sup'*/:break;case'span'/*case 'Span'*/:break;case'alignment'/*case 'Alignment'*/:break;case'borders'/*case 'Borders'*/:break;case'border'/*case 'Border'*/:break;case'font'/*case 'Font'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")ss+=str.slice(fidx,Rn.index);else fidx=Rn.index+Rn[0].length;break;case'interior'/*case 'Interior'*/:if(!opts.cellStyles)break;stag.Interior=xlml_parsexmltag(Rn[0]);break;case'protection'/*case 'Protection'*/:break;case'author'/*case 'Author'*/:case'title'/*case 'Title'*/:case'description'/*case 'Description'*/:case'created'/*case 'Created'*/:case'keywords'/*case 'Keywords'*/:case'subject'/*case 'Subject'*/:case'category'/*case 'Category'*/:case'company'/*case 'Company'*/:case'lastauthor'/*case 'LastAuthor'*/:case'lastsaved'/*case 'LastSaved'*/:case'lastprinted'/*case 'LastPrinted'*/:case'version'/*case 'Version'*/:case'revision'/*case 'Revision'*/:case'totaltime'/*case 'TotalTime'*/:case'hyperlinkbase'/*case 'HyperlinkBase'*/:case'manager'/*case 'Manager'*/:case'contentstatus'/*case 'ContentStatus'*/:case'identifier'/*case 'Identifier'*/:case'language'/*case 'Language'*/:case'appname'/*case 'AppName'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_prop(Props,raw_Rn3,str.slice(pidx,Rn.index));else pidx=Rn.index+Rn[0].length;break;case'paragraphs'/*case 'Paragraphs'*/:break;case'styles'/*case 'Styles'*/:case'workbook'/*case 'Workbook'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else state.push([Rn[3],false]);break;case'comment'/*case 'Comment'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));xlml_clean_comment(comment);comments.push(comment);}else{state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);comment={a:tmp.Author};}break;case'autofilter'/*case 'AutoFilter'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){var AutoFilter=xlml_parsexmltag(Rn[0]);cursheet['!autofilter']={ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"")};state.push([Rn[3],true]);}break;case'name'/*case 'Name'*/:break;case'datavalidation'/*case 'DataValidation'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else{if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);}break;case'pixelsperinch'/*case 'PixelsPerInch'*/:break;case'componentoptions'/*case 'ComponentOptions'*/:case'documentproperties'/*case 'DocumentProperties'*/:case'customdocumentproperties'/*case 'CustomDocumentProperties'*/:case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:case'names'/*case 'Names'*/:case'mapinfo'/*case 'MapInfo'*/:case'pagebreaks'/*case 'PageBreaks'*/:case'querytable'/*case 'QueryTable'*/:case'sorting'/*case 'Sorting'*/:case'schema'/*case 'Schema'*/://case 'data' /*case 'data'*/:
case'conditionalformatting'/*case 'ConditionalFormatting'*/:case'smarttagtype'/*case 'SmartTagType'*/:case'smarttags'/*case 'SmartTags'*/:case'excelworkbook'/*case 'ExcelWorkbook'*/:case'workbookoptions'/*case 'WorkbookOptions'*/:case'worksheetoptions'/*case 'WorksheetOptions'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'null'/*case 'Null'*/:break;default:/* FODS file root is <office:document> */if(state.length==0&&Rn[3]=="document")return parse_fods(str,opts);/* UOS file root is <uof:UOF> */if(state.length==0&&Rn[3]=="uof"/*"UOF"*/)return parse_fods(str,opts);var seen=true;switch(state[state.length-1][0]){/* OfficeDocumentSettings */case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:switch(Rn[3]){case'allowpng'/*case 'AllowPNG'*/:break;case'removepersonalinformation'/*case 'RemovePersonalInformation'*/:break;case'downloadcomponents'/*case 'DownloadComponents'*/:break;case'locationofcomponents'/*case 'LocationOfComponents'*/:break;case'colors'/*case 'Colors'*/:break;case'color'/*case 'Color'*/:break;case'index'/*case 'Index'*/:break;case'rgb'/*case 'RGB'*/:break;case'targetscreensize'/*case 'TargetScreenSize'*/:break;case'readonlyrecommended'/*case 'ReadOnlyRecommended'*/:break;default:seen=false;}break;/* ComponentOptions */case'componentoptions'/*case 'ComponentOptions'*/:switch(Rn[3]){case'toolbar'/*case 'Toolbar'*/:break;case'hideofficelogo'/*case 'HideOfficeLogo'*/:break;case'spreadsheetautofit'/*case 'SpreadsheetAutoFit'*/:break;case'label'/*case 'Label'*/:break;case'caption'/*case 'Caption'*/:break;case'maxheight'/*case 'MaxHeight'*/:break;case'maxwidth'/*case 'MaxWidth'*/:break;case'nextsheetnumber'/*case 'NextSheetNumber'*/:break;default:seen=false;}break;/* ExcelWorkbook */case'excelworkbook'/*case 'ExcelWorkbook'*/:switch(Rn[3]){case'date1904'/*case 'Date1904'*/:Workbook.WBProps.date1904=true;break;case'windowheight'/*case 'WindowHeight'*/:break;case'windowwidth'/*case 'WindowWidth'*/:break;case'windowtopx'/*case 'WindowTopX'*/:break;case'windowtopy'/*case 'WindowTopY'*/:break;case'tabratio'/*case 'TabRatio'*/:break;case'protectstructure'/*case 'ProtectStructure'*/:break;case'protectwindow'/*case 'ProtectWindow'*/:break;case'protectwindows'/*case 'ProtectWindows'*/:break;case'activesheet'/*case 'ActiveSheet'*/:break;case'displayinknotes'/*case 'DisplayInkNotes'*/:break;case'firstvisiblesheet'/*case 'FirstVisibleSheet'*/:break;case'supbook'/*case 'SupBook'*/:break;case'sheetname'/*case 'SheetName'*/:break;case'sheetindex'/*case 'SheetIndex'*/:break;case'sheetindexfirst'/*case 'SheetIndexFirst'*/:break;case'sheetindexlast'/*case 'SheetIndexLast'*/:break;case'dll'/*case 'Dll'*/:break;case'acceptlabelsinformulas'/*case 'AcceptLabelsInFormulas'*/:break;case'donotsavelinkvalues'/*case 'DoNotSaveLinkValues'*/:break;case'iteration'/*case 'Iteration'*/:break;case'maxiterations'/*case 'MaxIterations'*/:break;case'maxchange'/*case 'MaxChange'*/:break;case'path'/*case 'Path'*/:break;case'xct'/*case 'Xct'*/:break;case'count'/*case 'Count'*/:break;case'selectedsheets'/*case 'SelectedSheets'*/:break;case'calculation'/*case 'Calculation'*/:break;case'uncalced'/*case 'Uncalced'*/:break;case'startupprompt'/*case 'StartupPrompt'*/:break;case'crn'/*case 'Crn'*/:break;case'externname'/*case 'ExternName'*/:break;case'formula'/*case 'Formula'*/:break;case'colfirst'/*case 'ColFirst'*/:break;case'collast'/*case 'ColLast'*/:break;case'wantadvise'/*case 'WantAdvise'*/:break;case'boolean'/*case 'Boolean'*/:break;case'error'/*case 'Error'*/:break;case'text'/*case 'Text'*/:break;case'ole'/*case 'OLE'*/:break;case'noautorecover'/*case 'NoAutoRecover'*/:break;case'publishobjects'/*case 'PublishObjects'*/:break;case'donotcalculatebeforesave'/*case 'DoNotCalculateBeforeSave'*/:break;case'number'/*case 'Number'*/:break;case'refmoder1c1'/*case 'RefModeR1C1'*/:break;case'embedsavesmarttags'/*case 'EmbedSaveSmartTags'*/:break;default:seen=false;}break;/* WorkbookOptions */case'workbookoptions'/*case 'WorkbookOptions'*/:switch(Rn[3]){case'owcversion'/*case 'OWCVersion'*/:break;case'height'/*case 'Height'*/:break;case'width'/*case 'Width'*/:break;default:seen=false;}break;/* WorksheetOptions */case'worksheetoptions'/*case 'WorksheetOptions'*/:switch(Rn[3]){case'visible'/*case 'Visible'*/:if(Rn[0].slice(-2)==="/>"){/* empty */}else if(Rn[1]==="/")switch(str.slice(pidx,Rn.index)){case"SheetHidden":wsprops.Hidden=1;break;case"SheetVeryHidden":wsprops.Hidden=2;break;}else pidx=Rn.index+Rn[0].length;break;case'header'/*case 'Header'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');cursheet['!margins'].header=parsexmltag(Rn[0]).Margin;break;case'footer'/*case 'Footer'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');cursheet['!margins'].footer=parsexmltag(Rn[0]).Margin;break;case'pagemargins'/*case 'PageMargins'*/:var pagemargins=parsexmltag(Rn[0]);if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(pagemargins.Top)cursheet['!margins'].top=pagemargins.Top;if(pagemargins.Left)cursheet['!margins'].left=pagemargins.Left;if(pagemargins.Right)cursheet['!margins'].right=pagemargins.Right;if(pagemargins.Bottom)cursheet['!margins'].bottom=pagemargins.Bottom;break;case'displayrighttoleft'/*case 'DisplayRightToLeft'*/:if(!Workbook.Views)Workbook.Views=[];if(!Workbook.Views[0])Workbook.Views[0]={};Workbook.Views[0].RTL=true;break;case'freezepanes'/*case 'FreezePanes'*/:break;case'frozennosplit'/*case 'FrozenNoSplit'*/:break;case'splithorizontal'/*case 'SplitHorizontal'*/:case'splitvertical'/*case 'SplitVertical'*/:break;case'donotdisplaygridlines'/*case 'DoNotDisplayGridlines'*/:break;case'activerow'/*case 'ActiveRow'*/:break;case'activecol'/*case 'ActiveCol'*/:break;case'toprowbottompane'/*case 'TopRowBottomPane'*/:break;case'leftcolumnrightpane'/*case 'LeftColumnRightPane'*/:break;case'unsynced'/*case 'Unsynced'*/:break;case'print'/*case 'Print'*/:break;case'printerrors'/*case 'PrintErrors'*/:break;case'panes'/*case 'Panes'*/:break;case'scale'/*case 'Scale'*/:break;case'pane'/*case 'Pane'*/:break;case'number'/*case 'Number'*/:break;case'layout'/*case 'Layout'*/:break;case'pagesetup'/*case 'PageSetup'*/:break;case'selected'/*case 'Selected'*/:break;case'protectobjects'/*case 'ProtectObjects'*/:break;case'enableselection'/*case 'EnableSelection'*/:break;case'protectscenarios'/*case 'ProtectScenarios'*/:break;case'validprinterinfo'/*case 'ValidPrinterInfo'*/:break;case'horizontalresolution'/*case 'HorizontalResolution'*/:break;case'verticalresolution'/*case 'VerticalResolution'*/:break;case'numberofcopies'/*case 'NumberofCopies'*/:break;case'activepane'/*case 'ActivePane'*/:break;case'toprowvisible'/*case 'TopRowVisible'*/:break;case'leftcolumnvisible'/*case 'LeftColumnVisible'*/:break;case'fittopage'/*case 'FitToPage'*/:break;case'rangeselection'/*case 'RangeSelection'*/:break;case'papersizeindex'/*case 'PaperSizeIndex'*/:break;case'pagelayoutzoom'/*case 'PageLayoutZoom'*/:break;case'pagebreakzoom'/*case 'PageBreakZoom'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'fitwidth'/*case 'FitWidth'*/:break;case'fitheight'/*case 'FitHeight'*/:break;case'commentslayout'/*case 'CommentsLayout'*/:break;case'zoom'/*case 'Zoom'*/:break;case'lefttoright'/*case 'LeftToRight'*/:break;case'gridlines'/*case 'Gridlines'*/:break;case'allowsort'/*case 'AllowSort'*/:break;case'allowfilter'/*case 'AllowFilter'*/:break;case'allowinsertrows'/*case 'AllowInsertRows'*/:break;case'allowdeleterows'/*case 'AllowDeleteRows'*/:break;case'allowinsertcols'/*case 'AllowInsertCols'*/:break;case'allowdeletecols'/*case 'AllowDeleteCols'*/:break;case'allowinserthyperlinks'/*case 'AllowInsertHyperlinks'*/:break;case'allowformatcells'/*case 'AllowFormatCells'*/:break;case'allowsizecols'/*case 'AllowSizeCols'*/:break;case'allowsizerows'/*case 'AllowSizeRows'*/:break;case'nosummaryrowsbelowdetail'/*case 'NoSummaryRowsBelowDetail'*/:if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].above=true;break;case'tabcolorindex'/*case 'TabColorIndex'*/:break;case'donotdisplayheadings'/*case 'DoNotDisplayHeadings'*/:break;case'showpagelayoutzoom'/*case 'ShowPageLayoutZoom'*/:break;case'nosummarycolumnsrightdetail'/*case 'NoSummaryColumnsRightDetail'*/:if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].left=true;break;case'blackandwhite'/*case 'BlackAndWhite'*/:break;case'donotdisplayzeros'/*case 'DoNotDisplayZeros'*/:break;case'displaypagebreak'/*case 'DisplayPageBreak'*/:break;case'rowcolheadings'/*case 'RowColHeadings'*/:break;case'donotdisplayoutline'/*case 'DoNotDisplayOutline'*/:break;case'noorientation'/*case 'NoOrientation'*/:break;case'allowusepivottables'/*case 'AllowUsePivotTables'*/:break;case'zeroheight'/*case 'ZeroHeight'*/:break;case'viewablerange'/*case 'ViewableRange'*/:break;case'selection'/*case 'Selection'*/:break;case'protectcontents'/*case 'ProtectContents'*/:break;default:seen=false;}break;/* PivotTable */case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:switch(Rn[3]){case'immediateitemsondrop'/*case 'ImmediateItemsOnDrop'*/:break;case'showpagemultipleitemlabel'/*case 'ShowPageMultipleItemLabel'*/:break;case'compactrowindent'/*case 'CompactRowIndent'*/:break;case'location'/*case 'Location'*/:break;case'pivotfield'/*case 'PivotField'*/:break;case'orientation'/*case 'Orientation'*/:break;case'layoutform'/*case 'LayoutForm'*/:break;case'layoutsubtotallocation'/*case 'LayoutSubtotalLocation'*/:break;case'layoutcompactrow'/*case 'LayoutCompactRow'*/:break;case'position'/*case 'Position'*/:break;case'pivotitem'/*case 'PivotItem'*/:break;case'datatype'/*case 'DataType'*/:break;case'datafield'/*case 'DataField'*/:break;case'sourcename'/*case 'SourceName'*/:break;case'parentfield'/*case 'ParentField'*/:break;case'ptlineitems'/*case 'PTLineItems'*/:break;case'ptlineitem'/*case 'PTLineItem'*/:break;case'countofsameitems'/*case 'CountOfSameItems'*/:break;case'item'/*case 'Item'*/:break;case'itemtype'/*case 'ItemType'*/:break;case'ptsource'/*case 'PTSource'*/:break;case'cacheindex'/*case 'CacheIndex'*/:break;case'consolidationreference'/*case 'ConsolidationReference'*/:break;case'filename'/*case 'FileName'*/:break;case'reference'/*case 'Reference'*/:break;case'nocolumngrand'/*case 'NoColumnGrand'*/:break;case'norowgrand'/*case 'NoRowGrand'*/:break;case'blanklineafteritems'/*case 'BlankLineAfterItems'*/:break;case'hidden'/*case 'Hidden'*/:break;case'subtotal'/*case 'Subtotal'*/:break;case'basefield'/*case 'BaseField'*/:break;case'mapchilditems'/*case 'MapChildItems'*/:break;case'function'/*case 'Function'*/:break;case'refreshonfileopen'/*case 'RefreshOnFileOpen'*/:break;case'printsettitles'/*case 'PrintSetTitles'*/:break;case'mergelabels'/*case 'MergeLabels'*/:break;case'defaultversion'/*case 'DefaultVersion'*/:break;case'refreshname'/*case 'RefreshName'*/:break;case'refreshdate'/*case 'RefreshDate'*/:break;case'refreshdatecopy'/*case 'RefreshDateCopy'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;case'versionlastupdate'/*case 'VersionLastUpdate'*/:break;case'versionupdateablemin'/*case 'VersionUpdateableMin'*/:break;case'versionrefreshablemin'/*case 'VersionRefreshableMin'*/:break;case'calculation'/*case 'Calculation'*/:break;default:seen=false;}break;/* PageBreaks */case'pagebreaks'/*case 'PageBreaks'*/:switch(Rn[3]){case'colbreaks'/*case 'ColBreaks'*/:break;case'colbreak'/*case 'ColBreak'*/:break;case'rowbreaks'/*case 'RowBreaks'*/:break;case'rowbreak'/*case 'RowBreak'*/:break;case'colstart'/*case 'ColStart'*/:break;case'colend'/*case 'ColEnd'*/:break;case'rowend'/*case 'RowEnd'*/:break;default:seen=false;}break;/* AutoFilter */case'autofilter'/*case 'AutoFilter'*/:switch(Rn[3]){case'autofiltercolumn'/*case 'AutoFilterColumn'*/:break;case'autofiltercondition'/*case 'AutoFilterCondition'*/:break;case'autofilterand'/*case 'AutoFilterAnd'*/:break;case'autofilteror'/*case 'AutoFilterOr'*/:break;default:seen=false;}break;/* QueryTable */case'querytable'/*case 'QueryTable'*/:switch(Rn[3]){case'id'/*case 'Id'*/:break;case'autoformatfont'/*case 'AutoFormatFont'*/:break;case'autoformatpattern'/*case 'AutoFormatPattern'*/:break;case'querysource'/*case 'QuerySource'*/:break;case'querytype'/*case 'QueryType'*/:break;case'enableredirections'/*case 'EnableRedirections'*/:break;case'refreshedinxl9'/*case 'RefreshedInXl9'*/:break;case'urlstring'/*case 'URLString'*/:break;case'htmltables'/*case 'HTMLTables'*/:break;case'connection'/*case 'Connection'*/:break;case'commandtext'/*case 'CommandText'*/:break;case'refreshinfo'/*case 'RefreshInfo'*/:break;case'notitles'/*case 'NoTitles'*/:break;case'nextid'/*case 'NextId'*/:break;case'columninfo'/*case 'ColumnInfo'*/:break;case'overwritecells'/*case 'OverwriteCells'*/:break;case'donotpromptforfile'/*case 'DoNotPromptForFile'*/:break;case'textwizardsettings'/*case 'TextWizardSettings'*/:break;case'source'/*case 'Source'*/:break;case'number'/*case 'Number'*/:break;case'decimal'/*case 'Decimal'*/:break;case'thousandseparator'/*case 'ThousandSeparator'*/:break;case'trailingminusnumbers'/*case 'TrailingMinusNumbers'*/:break;case'formatsettings'/*case 'FormatSettings'*/:break;case'fieldtype'/*case 'FieldType'*/:break;case'delimiters'/*case 'Delimiters'*/:break;case'tab'/*case 'Tab'*/:break;case'comma'/*case 'Comma'*/:break;case'autoformatname'/*case 'AutoFormatName'*/:break;case'versionlastedit'/*case 'VersionLastEdit'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;default:seen=false;}break;case'datavalidation'/*case 'DataValidation'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;default:seen=false;}break;case'sorting'/*case 'Sorting'*/:case'conditionalformatting'/*case 'ConditionalFormatting'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;default:seen=false;}break;/* MapInfo (schema) */case'mapinfo'/*case 'MapInfo'*/:case'schema'/*case 'Schema'*/:case'data'/*case 'data'*/:switch(Rn[3]){case'map'/*case 'Map'*/:break;case'entry'/*case 'Entry'*/:break;case'range'/*case 'Range'*/:break;case'xpath'/*case 'XPath'*/:break;case'field'/*case 'Field'*/:break;case'xsdtype'/*case 'XSDType'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'aggregate'/*case 'Aggregate'*/:break;case'elementtype'/*case 'ElementType'*/:break;case'attributetype'/*case 'AttributeType'*/:break;/* These are from xsd (XML Schema Definition) */case'schema'/*case 'schema'*/:case'element'/*case 'element'*/:case'complextype'/*case 'complexType'*/:case'datatype'/*case 'datatype'*/:case'all'/*case 'all'*/:case'attribute'/*case 'attribute'*/:case'extends'/*case 'extends'*/:break;case'row'/*case 'row'*/:break;default:seen=false;}break;/* SmartTags (can be anything) */case'smarttags'/*case 'SmartTags'*/:break;default:seen=false;break;}if(seen)break;/* CustomDocumentProperties */if(Rn[3].match(/!\[CDATA/))break;if(!state[state.length-1][1])throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties'){if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_custprop(Custprops,raw_Rn3,cp,str.slice(pidx,Rn.index));else{cp=Rn;pidx=Rn.index+Rn[0].length;}break;}if(opts.WTF)throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");}var out={};if(!opts.bookSheets&&!opts.bookProps)out.Sheets=sheets;out.SheetNames=sheetnames;out.Workbook=Workbook;out.SSF=SSF.get_table();out.Props=Props;out.Custprops=Custprops;return out;}function parse_xlml(data,opts){fix_read_opts(opts=opts||{});switch(opts.type||"base64"){case"base64":return parse_xlml_xml(Base64.decode(data),opts);case"binary":case"buffer":case"file":return parse_xlml_xml(data,opts);case"array":return parse_xlml_xml(a2s(data),opts);}}/* TODO */function write_props_xlml(wb,opts){var o=[];/* DocumentProperties */if(wb.Props)o.push(xlml_write_docprops(wb.Props,opts));/* CustomDocumentProperties */if(wb.Custprops)o.push(xlml_write_custprops(wb.Props,wb.Custprops,opts));return o.join("");}/* TODO */function write_wb_xlml(){/* OfficeDocumentSettings */ /* ExcelWorkbook */return"";}/* TODO */function write_sty_xlml(wb,opts){/* Styles */var styles=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];opts.cellXfs.forEach(function(xf,id){var payload=[];payload.push(writextag('NumberFormat',null,{"ss:Format":escapexml(SSF._table[xf.numFmtId])}));var o={"ss:ID":"s"+(21+id)};styles.push(writextag('Style',payload.join(""),o));});return writextag("Styles",styles.join(""));}function write_name_xlml(n){return writextag("NamedRange",null,{"ss:Name":n.Name,"ss:RefersTo":"="+a1_to_rc(n.Ref,{r:0,c:0})});}function write_names_xlml(wb){if(!((wb||{}).Workbook||{}).Names)return"";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return writextag("Names",out.join(""));}function write_ws_xlml_names(ws,opts,idx,wb){if(!ws)return"";if(!((wb||{}).Workbook||{}).Names)return"";var names=wb.Workbook.Names;var out=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=idx)continue;/*switch(n.Name) {
			case "_": continue;
		}*/if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return out.join("");}/* WorksheetOptions */function write_ws_xlml_wsopts(ws,opts,idx,wb){if(!ws)return"";var o=[];/* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */if(ws['!margins']){o.push("<PageSetup>");if(ws['!margins'].header)o.push(writextag("Header",null,{'x:Margin':ws['!margins'].header}));if(ws['!margins'].footer)o.push(writextag("Footer",null,{'x:Margin':ws['!margins'].footer}));o.push(writextag("PageMargins",null,{'x:Bottom':ws['!margins'].bottom||"0.75",'x:Left':ws['!margins'].left||"0.7",'x:Right':ws['!margins'].right||"0.7",'x:Top':ws['!margins'].top||"0.75"}));o.push("</PageSetup>");}/* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */if(wb&&wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]){/* Visible */if(wb.Workbook.Sheets[idx].Hidden)o.push(writextag("Visible",wb.Workbook.Sheets[idx].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{/* Selected */for(var i=0;i<idx;++i)if(wb.Workbook.Sheets[i]&&!wb.Workbook.Sheets[i].Hidden)break;if(i==idx)o.push("<Selected/>");}}/* LeftColumnVisible */if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL)o.push("<DisplayRightToLeft/>");/* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */if(ws['!protect']){o.push(writetag("ProtectContents","True"));if(ws['!protect'].objects)o.push(writetag("ProtectObjects","True"));if(ws['!protect'].scenarios)o.push(writetag("ProtectScenarios","True"));if(ws['!protect'].selectLockedCells!=null&&!ws['!protect'].selectLockedCells)o.push(writetag("EnableSelection","NoSelection"));else if(ws['!protect'].selectUnlockedCells!=null&&!ws['!protect'].selectUnlockedCells)o.push(writetag("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(x){if(ws['!protect'][x[0]])o.push("<"+x[1]+"/>");});}if(o.length==0)return"";return writextag("WorksheetOptions",o.join(""),{xmlns:XLMLNS.x});}function write_ws_xlml_comment(comments){return comments.map(function(c){// TODO: formatted text
var t=xlml_unfixstr(c.t||"");var d=writextag("ss:Data",t,{"xmlns":"http://www.w3.org/TR/REC-html40"});return writextag("Comment",d,{"ss:Author":c.a});}).join("");}function write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr){if(!cell||cell.v==undefined&&cell.f==undefined)return"";var attr={};if(cell.f)attr["ss:Formula"]="="+escapexml(a1_to_rc(cell.f,addr));if(cell.F&&cell.F.slice(0,ref.length)==ref){var end=decode_cell(cell.F.slice(ref.length+1));attr["ss:ArrayRange"]="RC:R"+(end.r==addr.r?"":"["+(end.r-addr.r)+"]")+"C"+(end.c==addr.c?"":"["+(end.c-addr.c)+"]");}if(cell.l&&cell.l.Target){attr["ss:HRef"]=escapexml(cell.l.Target);if(cell.l.Tooltip)attr["x:HRefScreenTip"]=escapexml(cell.l.Tooltip);}if(ws['!merges']){var marr=ws['!merges'];for(var mi=0;mi!=marr.length;++mi){if(marr[mi].s.c!=addr.c||marr[mi].s.r!=addr.r)continue;if(marr[mi].e.c>marr[mi].s.c)attr['ss:MergeAcross']=marr[mi].e.c-marr[mi].s.c;if(marr[mi].e.r>marr[mi].s.r)attr['ss:MergeDown']=marr[mi].e.r-marr[mi].s.r;}}var t="",p="";switch(cell.t){case'z':if(!opts.sheetStubs)return"";break;case'n':t='Number';p=String(cell.v);break;case'b':t='Boolean';p=cell.v?"1":"0";break;case'e':t='Error';p=BErr[cell.v];break;case'd':t='DateTime';p=new Date(cell.v).toISOString();if(cell.z==null)cell.z=cell.z||SSF._table[14];break;case's':t='String';p=escapexlml(cell.v||"");break;}/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);attr["ss:StyleID"]="s"+(21+os);attr["ss:Index"]=addr.c+1;var _v=cell.v!=null?p:"";var m=cell.t=='z'?"":'<Data ss:Type="'+t+'">'+_v+'</Data>';if((cell.c||[]).length>0)m+=write_ws_xlml_comment(cell.c);return writextag("Cell",m,attr);}function write_ws_xlml_row(R,row){var o='<Row ss:Index="'+(R+1)+'"';if(row){if(row.hpt&&!row.hpx)row.hpx=pt2px(row.hpt);if(row.hpx)o+=' ss:AutoFitHeight="0" ss:Height="'+row.hpx+'"';if(row.hidden)o+=' ss:Hidden="1"';}return o+'>';}/* TODO */function write_ws_xlml_table(ws,opts,idx,wb){if(!ws['!ref'])return"";var range=safe_decode_range(ws['!ref']);var marr=ws['!merges']||[],mi=0;var o=[];if(ws['!cols'])ws['!cols'].forEach(function(n,i){process_col(n);var w=!!n.width;var p=col_obj_w(i,n);var k={"ss:Index":i+1};if(w)k['ss:Width']=width2px(p.width);if(n.hidden)k['ss:Hidden']="1";o.push(writextag("Column",null,k));});var dense=Array.isArray(ws);for(var R=range.s.r;R<=range.e.r;++R){var row=[write_ws_xlml_row(R,(ws['!rows']||[])[R])];for(var C=range.s.c;C<=range.e.c;++C){var skip=false;for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;break;}if(skip)continue;var addr={r:R,c:C};var ref=encode_cell(addr),cell=dense?(ws[R]||[])[C]:ws[ref];row.push(write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr));}row.push("</Row>");if(row.length>2)o.push(row.join(""));}return o.join("");}function write_ws_xlml(idx,opts,wb){var o=[];var s=wb.SheetNames[idx];var ws=wb.Sheets[s];var t=ws?write_ws_xlml_names(ws,opts,idx,wb):"";if(t.length>0)o.push("<Names>"+t+"</Names>");/* Table */t=ws?write_ws_xlml_table(ws,opts,idx,wb):"";if(t.length>0)o.push("<Table>"+t+"</Table>");/* WorksheetOptions */o.push(write_ws_xlml_wsopts(ws,opts,idx,wb));return o.join("");}function write_xlml(wb,opts){if(!opts)opts={};if(!wb.SSF)wb.SSF=SSF.get_table();if(wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});}var d=[];d.push(write_props_xlml(wb,opts));d.push(write_wb_xlml(wb,opts));d.push("");d.push("");for(var i=0;i<wb.SheetNames.length;++i)d.push(writextag("Worksheet",write_ws_xlml(i,opts,wb),{"ss:Name":escapexml(wb.SheetNames[i])}));d[2]=write_sty_xlml(wb,opts);d[3]=write_names_xlml(wb,opts);return XML_HEADER+writextag("Workbook",d.join(""),{'xmlns':XLMLNS.ss,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:ss':XLMLNS.ss,'xmlns:dt':XLMLNS.dt,'xmlns:html':XLMLNS.html});}/* [MS-OLEDS] 2.3.8 CompObjStream */function parse_compobj(obj){var v={};var o=obj.content;/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */o.l=28;v.AnsiUserType=o.read_shift(0,"lpstr-ansi");v.AnsiClipboardFormat=parse_ClipboardFormatOrAnsiString(o);if(o.length-o.l<=4)return v;var m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved1=o.read_shift(0,"lpstr-ansi");if(o.length-o.l<=4)return v;m=o.read_shift(4);if(m!==0x71b239f4)return v;v.UnicodeClipboardFormat=parse_ClipboardFormatOrUnicodeString(o);m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved2=o.read_shift(0,"lpwstr");}/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/function slurp(R,blob,length,opts){var l=length;var bufs=[];var d=blob.slice(blob.l,blob.l+l);if(opts&&opts.enc&&opts.enc.insitu&&d.length>0)switch(R.n){case'BOF':case'FilePass':case'FileLock':case'InterfaceHdr':case'RRDInfo':case'RRDHead':case'UsrExcl':case'EOF':break;case'BoundSheet8':break;default:opts.enc.insitu(d);}bufs.push(d);blob.l+=l;var next=XLSRecordEnum[__readUInt16LE(blob,blob.l)];var start=0;while(next!=null&&next.n.slice(0,8)==='Continue'){l=__readUInt16LE(blob,blob.l+2);start=blob.l+4;if(next.n=='ContinueFrt')start+=4;else if(next.n.slice(0,11)=='ContinueFrt'){start+=12;}d=blob.slice(start,blob.l+4+l);bufs.push(d);blob.l+=4+l;next=XLSRecordEnum[__readUInt16LE(blob,blob.l)];}var b=bconcat(bufs);prep_blob(b,0);var ll=0;b.lens=[];for(var j=0;j<bufs.length;++j){b.lens.push(ll);ll+=bufs[j].length;}if(b.length<length)throw"XLS Record "+(R&&R.n||"??")+" Truncated: "+b.length+" < "+length;return R.f(b,b.length,opts);}function safe_format_xf(p,opts,date1904){if(p.t==='z')return;if(!p.XF)return;var fmtid=0;try{fmtid=p.z||p.XF.numFmtId||0;if(opts.cellNF)p.z=SSF._table[fmtid];}catch(e){if(opts.WTF)throw e;}if(!opts||opts.cellText!==false)try{if(p.t==='e'){p.w=p.w||BErr[p.v];}else if(fmtid===0||fmtid=="General"){if(p.t==='n'){if((p.v|0)===p.v)p.w=SSF._general_int(p.v);else p.w=SSF._general_num(p.v);}else p.w=SSF._general(p.v);}else p.w=SSF.format(fmtid,p.v,{date1904:!!date1904,dateNF:opts&&opts.dateNF});}catch(e){if(opts.WTF)throw e;}if(opts.cellDates&&fmtid&&p.t=='n'&&SSF.is_date(SSF._table[fmtid]||String(fmtid))){var _d=SSF.parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}function make_cell(val,ixfe,t){return{v:val,ixfe:ixfe,t:t};}// 2.3.2
function parse_workbook(blob,options){var wb={opts:{}};var Sheets={};if(DENSE!=null&&options.dense==null)options.dense=DENSE;var out=options.dense?[]:{};var Directory={};var range={};var last_formula=null;var sst=[];var cur_sheet="";var Preamble={};var lastcell,last_cell="",cc,cmnt,rngC,rngR;var sharedf={};var arrayf=[];var temp_val;var country;var XFs=[];/* XF records */var palette=[];var Workbook={Sheets:[],WBProps:{date1904:false},Views:[{}]},wsprops={};var get_rgb=function getrgb(icv){if(icv<8)return XLSIcv[icv];if(icv<64)return palette[icv-8]||XLSIcv[icv];return XLSIcv[icv];};var process_cell_style=function pcs(cell,line,options){var xfd=line.XF.data;if(!xfd||!xfd.patternType||!options||!options.cellStyles)return;line.s={};line.s.patternType=xfd.patternType;var t;if(t=rgb2Hex(get_rgb(xfd.icvFore))){line.s.fgColor={rgb:t};}if(t=rgb2Hex(get_rgb(xfd.icvBack))){line.s.bgColor={rgb:t};}};var addcell=function addcell(cell,line,options){if(file_depth>1)return;if(options.sheetRows&&cell.r>=options.sheetRows)return;if(options.cellStyles&&line.XF&&line.XF.data)process_cell_style(cell,line,options);delete line.ixfe;delete line.XF;lastcell=cell;last_cell=encode_cell(cell);if(!range||!range.s||!range.e)range={s:{r:0,c:0},e:{r:0,c:0}};if(cell.r<range.s.r)range.s.r=cell.r;if(cell.c<range.s.c)range.s.c=cell.c;if(cell.r+1>range.e.r)range.e.r=cell.r+1;if(cell.c+1>range.e.c)range.e.c=cell.c+1;if(options.cellFormula&&line.f){for(var afi=0;afi<arrayf.length;++afi){if(arrayf[afi][0].s.c>cell.c||arrayf[afi][0].s.r>cell.r)continue;if(arrayf[afi][0].e.c<cell.c||arrayf[afi][0].e.r<cell.r)continue;line.F=encode_range(arrayf[afi][0]);if(arrayf[afi][0].s.c!=cell.c||arrayf[afi][0].s.r!=cell.r)delete line.f;if(line.f)line.f=""+stringify_formula(arrayf[afi][1],range,cell,supbooks,opts);break;}}{if(options.dense){if(!out[cell.r])out[cell.r]=[];out[cell.r][cell.c]=line;}else out[last_cell]=line;}};var opts={enc:false,// encrypted
sbcch:0,// cch in the preceding SupBook
snames:[],// sheetnames
sharedf:sharedf,// shared formulae by address
arrayf:arrayf,// array formulae array
rrtabid:[],// RRTabId
lastuser:"",// Last User from WriteAccess
biff:8,// BIFF version
codepage:0,// CP from CodePage record
winlocked:0,// fLockWn from WinProtect
cellStyles:!!options&&!!options.cellStyles,WTF:!!options&&!!options.wtf};if(options.password)opts.password=options.password;var themes;var merges=[];var objects=[];var colinfo=[],rowinfo=[];// eslint-disable-next-line no-unused-vars
var defwidth=0,defheight=0;// twips / MDW respectively
var seencol=false;var supbooks=[];// 1-indexed, will hold extern names
supbooks.SheetNames=opts.snames;supbooks.sharedf=opts.sharedf;supbooks.arrayf=opts.arrayf;supbooks.names=[];supbooks.XTI=[];var last_Rn='';var file_depth=0;/* TODO: make a real stack */var BIFF2Fmt=0,BIFF2FmtTable=[];var FilterDatabases=[];/* TODO: sort out supbooks and process elsewhere */var last_lbl;/* explicit override for some broken writers */opts.codepage=1200;set_cp(1200);var seen_codepage=false;while(blob.l<blob.length-1){var s=blob.l;var RecordType=blob.read_shift(2);if(RecordType===0&&last_Rn==='EOF')break;var length=blob.l===blob.length?0:blob.read_shift(2);var R=XLSRecordEnum[RecordType];//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
//if(!R) console.log(blob.slice(blob.l, blob.l + length));
if(R&&R.f){if(options.bookSheets){if(last_Rn==='BoundSheet8'&&R.n!=='BoundSheet8')break;}last_Rn=R.n;if(R.r===2||R.r==12){var rt=blob.read_shift(2);length-=2;if(!opts.enc&&rt!==RecordType&&((rt&0xFF)<<8|rt>>8)!==RecordType)throw new Error("rt mismatch: "+rt+"!="+RecordType);if(R.r==12){blob.l+=10;length-=10;}// skip FRT
}//console.error(R,blob.l,length,blob.length);
var val={};if(R.n==='EOF')val=R.f(blob,length,opts);else val=slurp(R,blob,length,opts);var Rn=R.n;if(file_depth==0&&Rn!='BOF')continue;/* nested switch statements to workaround V8 128 limit */switch(Rn){/* Workbook Options */case'Date1904':wb.opts.Date1904=Workbook.WBProps.date1904=val;break;case'WriteProtect':wb.opts.WriteProtect=true;break;case'FilePass':if(!opts.enc)blob.l=0;opts.enc=val;if(!options.password)throw new Error("File is password-protected");if(val.valid==null)throw new Error("Encryption scheme unsupported");if(!val.valid)throw new Error("Password is incorrect");break;case'WriteAccess':opts.lastuser=val;break;case'FileSharing':break;//TODO
case'CodePage':var cpval=Number(val);/* overrides based on test cases */switch(cpval){case 0x5212:cpval=1200;break;case 0x8000:cpval=10000;break;case 0x8001:cpval=1252;break;}set_cp(opts.codepage=cpval);seen_codepage=true;break;case'RRTabId':opts.rrtabid=val;break;case'WinProtect':opts.winlocked=val;break;case'Template':break;// TODO
case'BookBool':break;// TODO
case'UsesELFs':break;case'MTRSettings':break;case'RefreshAll':case'CalcCount':case'CalcDelta':case'CalcIter':case'CalcMode':case'CalcPrecision':case'CalcSaveRecalc':wb.opts[Rn]=val;break;case'CalcRefMode':opts.CalcRefMode=val;break;// TODO: implement R1C1
case'Uncalced':break;case'ForceFullCalculation':wb.opts.FullCalc=val;break;case'WsBool':if(val.fDialog)out["!type"]="dialog";if(!val.fBelow)(out["!outline"]||(out["!outline"]={})).above=true;if(!val.fRight)(out["!outline"]||(out["!outline"]={})).left=true;break;// TODO
case'XF':XFs.push(val);break;case'ExtSST':break;// TODO
case'BookExt':break;// TODO
case'RichTextStream':break;case'BkHim':break;case'SupBook':supbooks.push([val]);supbooks[supbooks.length-1].XTI=[];break;case'ExternName':supbooks[supbooks.length-1].push(val);break;case'Index':break;// TODO
case'Lbl':last_lbl={Name:val.Name,Ref:stringify_formula(val.rgce,range,null,supbooks,opts)};if(val.itab>0)last_lbl.Sheet=val.itab-1;supbooks.names.push(last_lbl);if(!supbooks[0]){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].push(val);if(val.Name=="_xlnm._FilterDatabase"&&val.itab>0)if(val.rgce&&val.rgce[0]&&val.rgce[0][0]&&val.rgce[0][0][0]=='PtgArea3d')FilterDatabases[val.itab-1]={ref:encode_range(val.rgce[0][0][1][2])};break;case'ExternCount':opts.ExternCount=val;break;case'ExternSheet':if(supbooks.length==0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case'NameCmt':/* TODO: search for correct name */if(opts.biff<8)break;if(last_lbl!=null)last_lbl.Comment=val[1];break;case'Protect':out["!protect"]=val;break;/* for sheet or book */case'Password':if(val!==0&&opts.WTF)console.error("Password verifier: "+val);break;case'Prot4Rev':case'Prot4RevPass':break;/*TODO: Revision Control*/case'BoundSheet8':{Directory[val.pos]=val;opts.snames.push(val.name);}break;case'EOF':{if(--file_depth)break;if(range.e){if(range.e.r>0&&range.e.c>0){range.e.r--;range.e.c--;out["!ref"]=encode_range(range);if(options.sheetRows&&options.sheetRows<=range.e.r){var tmpri=range.e.r;range.e.r=options.sheetRows-1;out["!fullref"]=out["!ref"];out["!ref"]=encode_range(range);range.e.r=tmpri;}range.e.r++;range.e.c++;}if(merges.length>0)out["!merges"]=merges;if(objects.length>0)out["!objects"]=objects;if(colinfo.length>0)out["!cols"]=colinfo;if(rowinfo.length>0)out["!rows"]=rowinfo;Workbook.Sheets.push(wsprops);}if(cur_sheet==="")Preamble=out;else Sheets[cur_sheet]=out;out=options.dense?[]:{};}break;case'BOF':{if(opts.biff===8)opts.biff={0x0009:2,0x0209:3,0x0409:4}[RecordType]||{0x0200:2,0x0300:3,0x0400:4,0x0500:5,0x0600:8,0x0002:2,0x0007:2}[val.BIFFVer]||8;opts.biffguess=val.BIFFVer==0;if(val.BIFFVer==0&&val.dt==0x1000){opts.biff=5;seen_codepage=true;set_cp(opts.codepage=28591);}if(opts.biff==8&&val.BIFFVer==0&&val.dt==16)opts.biff=2;if(file_depth++)break;out=options.dense?[]:{};if(opts.biff<8&&!seen_codepage){seen_codepage=true;set_cp(opts.codepage=options.codepage||1252);}if(opts.biff<5||val.BIFFVer==0&&val.dt==0x1000){if(cur_sheet==="")cur_sheet="Sheet1";range={s:{r:0,c:0},e:{r:0,c:0}};/* fake BoundSheet8 */var fakebs8={pos:blob.l-length,name:cur_sheet};Directory[fakebs8.pos]=fakebs8;opts.snames.push(cur_sheet);}else cur_sheet=(Directory[s]||{name:""}).name;if(val.dt==0x20)out["!type"]="chart";if(val.dt==0x40)out["!type"]="macro";merges=[];objects=[];opts.arrayf=arrayf=[];colinfo=[];rowinfo=[];defwidth=defheight=0;seencol=false;wsprops={Hidden:(Directory[s]||{hs:0}).hs,name:cur_sheet};}break;case'Number':case'BIFF2NUM':case'BIFF2INT':{if(out["!type"]=="chart")if(options.dense?(out[val.r]||[])[val.c]:out[encode_cell({c:val.c,r:val.r})])++val.c;temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe]||{},v:val.val,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'BoolErr':{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:val.t};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'RK':{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.rknum,t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'MulRk':{for(var j=val.c;j<=val.C;++j){var ixfe=val.rkrec[j-val.c][0];temp_val={ixfe:ixfe,XF:XFs[ixfe],v:val.rkrec[j-val.c][1],t:'n'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:j,r:val.r},temp_val,options);}}break;case'Formula':{if(val.val=='String'){last_formula=val;break;}temp_val=make_cell(val.val,val.cell.ixfe,val.tt);temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){var _f=val.formula;if(_f&&_f[0]&&_f[0][0]&&_f[0][0][0]=='PtgExp'){var _fr=_f[0][0][1][0],_fc=_f[0][0][1][1];var _fe=encode_cell({r:_fr,c:_fc});if(sharedf[_fe])temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);else temp_val.F=((options.dense?(out[_fr]||[])[_fc]:out[_fe])||{}).F;}else temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(val.cell,temp_val,options);last_formula=val;}break;case'String':{if(last_formula){/* technically always true */last_formula.val=val;temp_val=make_cell(val,last_formula.cell.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){temp_val.f=""+stringify_formula(last_formula.formula,range,last_formula.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(last_formula.cell,temp_val,options);last_formula=null;}else throw new Error("String record expects Formula");}break;case'Array':{arrayf.push(val);var _arraystart=encode_cell(val[0].s);cc=options.dense?(out[val[0].s.r]||[])[val[0].s.c]:out[_arraystart];if(options.cellFormula&&cc){if(!last_formula)break;/* technically unreachable */if(!_arraystart||!cc)break;cc.f=""+stringify_formula(val[1],range,val[0],supbooks,opts);cc.F=encode_range(val[0]);}}break;case'ShrFmla':{if(!options.cellFormula)break;if(last_cell){/* TODO: capture range */if(!last_formula)break;/* technically unreachable */sharedf[encode_cell(last_formula.cell)]=val[0];cc=options.dense?(out[last_formula.cell.r]||[])[last_formula.cell.c]:out[encode_cell(last_formula.cell)];(cc||{}).f=""+stringify_formula(val[0],range,lastcell,supbooks,opts);}}break;case'LabelSst':temp_val=make_cell(sst[val.isst].t,val.ixfe,'s');if(sst[val.isst].h)temp_val.h=sst[val.isst].h;temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case'Blank':if(options.sheetStubs){temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case'MulBlank':if(options.sheetStubs){for(var _j=val.c;_j<=val.C;++_j){var _ixfe=val.ixfe[_j-val.c];temp_val={ixfe:_ixfe,XF:XFs[_ixfe],t:'z'};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:_j,r:val.r},temp_val,options);}}break;case'RString':case'Label':case'BIFF2STR':temp_val=make_cell(val.val,val.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case'Dimensions':{if(file_depth===1)range=val;/* TODO: stack */}break;case'SST':{sst=val;}break;case'Format':{/* val = [id, fmt] */if(opts.biff==4){BIFF2FmtTable[BIFF2Fmt++]=val[1];for(var b4idx=0;b4idx<BIFF2Fmt+163;++b4idx)if(SSF._table[b4idx]==val[1])break;if(b4idx>=163)SSF.load(val[1],BIFF2Fmt+163);}else SSF.load(val[1],val[0]);}break;case'BIFF2FORMAT':{BIFF2FmtTable[BIFF2Fmt++]=val;for(var b2idx=0;b2idx<BIFF2Fmt+163;++b2idx)if(SSF._table[b2idx]==val)break;if(b2idx>=163)SSF.load(val,BIFF2Fmt+163);}break;case'MergeCells':merges=merges.concat(val);break;case'Obj':objects[val.cmo[0]]=opts.lastobj=val;break;case'TxO':opts.lastobj.TxO=val;break;case'ImData':opts.lastobj.ImData=val;break;case'HLink':{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc)cc.l=val[1];}}break;case'HLinkTooltip':{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc&&cc.l)cc.l.Tooltip=val[1];}}break;/* Comments */case'Note':{if(opts.biff<=5&&opts.biff>=2)break;/* TODO: BIFF5 */cc=options.dense?(out[val[0].r]||[])[val[0].c]:out[encode_cell(val[0])];var noteobj=objects[val[2]];if(!cc){if(options.dense){if(!out[val[0].r])out[val[0].r]=[];cc=out[val[0].r][val[0].c]={t:"z"};}else{cc=out[encode_cell(val[0])]={t:"z"};}range.e.r=Math.max(range.e.r,val[0].r);range.s.r=Math.min(range.s.r,val[0].r);range.e.c=Math.max(range.e.c,val[0].c);range.s.c=Math.min(range.s.c,val[0].c);}if(!cc.c)cc.c=[];cmnt={a:val[1],t:noteobj.TxO.t};cc.c.push(cmnt);}break;default:switch(R.n){/* nested */case'ClrtClient':break;case'XFExt':update_xfext(XFs[val.ixfe],val.ext);break;case'DefColWidth':defwidth=val;break;case'DefaultRowHeight':defheight=val[1];break;// TODO: flags
case'ColInfo':{if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,level:val.level||0,hidden:!!(val.flags&1)};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}}break;case'Row':{var rowobj={};if(val.level!=null){rowinfo[val.r]=rowobj;rowobj.level=val.level;}if(val.hidden){rowinfo[val.r]=rowobj;rowobj.hidden=true;}if(val.hpt){rowinfo[val.r]=rowobj;rowobj.hpt=val.hpt;rowobj.hpx=pt2px(val.hpt);}}break;case'LeftMargin':case'RightMargin':case'TopMargin':case'BottomMargin':if(!out['!margins'])default_margins(out['!margins']={});out['!margins'][Rn.slice(0,-6).toLowerCase()]=val;break;case'Selection':break;case'Setup':// TODO
if(!out['!margins'])default_margins(out['!margins']={});out['!margins'].header=val.header;out['!margins'].footer=val.footer;break;case'Window2':// TODO
// $FlowIgnore
if(val.RTL)Workbook.Views[0].RTL=true;break;case'Header':break;// TODO
case'Footer':break;// TODO
case'HCenter':break;// TODO
case'VCenter':break;// TODO
case'Pls':break;// TODO
case'GCW':break;case'LHRecord':break;case'DBCell':break;// TODO
case'EntExU2':break;// TODO
case'SxView':break;// TODO
case'Sxvd':break;// TODO
case'SXVI':break;// TODO
case'SXVDEx':break;// TODO
case'SxIvd':break;// TODO
case'SXString':break;// TODO
case'Sync':break;case'Addin':break;case'SXDI':break;// TODO
case'SXLI':break;// TODO
case'SXEx':break;// TODO
case'QsiSXTag':break;// TODO
case'Feat':break;case'FeatHdr':case'FeatHdr11':break;case'Feature11':case'Feature12':case'List12':break;case'Country':country=val;break;case'RecalcId':break;case'DxGCol':break;// TODO: htmlify
case'Fbi':case'Fbi2':case'GelFrame':break;case'Font':break;// TODO
case'XFCRC':break;// TODO
case'Style':break;// TODO
case'StyleExt':break;// TODO
case'Palette':palette=val;break;case'Theme':themes=val;break;/* Protection */case'ScenarioProtect':break;case'ObjProtect':break;/* Conditional Formatting */case'CondFmt12':break;/* Table */case'Table':break;// TODO
case'TableStyles':break;// TODO
case'TableStyle':break;// TODO
case'TableStyleElement':break;// TODO
/* PivotTable */case'SXStreamID':break;// TODO
case'SXVS':break;// TODO
case'DConRef':break;// TODO
case'SXAddl':break;// TODO
case'DConBin':break;// TODO
case'DConName':break;// TODO
case'SXPI':break;// TODO
case'SxFormat':break;// TODO
case'SxSelect':break;// TODO
case'SxRule':break;// TODO
case'SxFilt':break;// TODO
case'SxItm':break;// TODO
case'SxDXF':break;// TODO
/* Scenario Manager */case'ScenMan':break;/* Data Consolidation */case'DCon':break;/* Watched Cell */case'CellWatch':break;/* Print Settings */case'PrintRowCol':break;case'PrintGrid':break;case'PrintSize':break;case'XCT':break;case'CRN':break;case'Scl':{//console.log("Zoom Level:", val[0]/val[1],val);
}break;case'SheetExt':{/* empty */}break;case'SheetExtOptional':{/* empty */}break;/* VBA */case'ObNoMacros':{/* empty */}break;case'ObProj':{/* empty */}break;case'CodeName':{if(!cur_sheet)Workbook.WBProps.CodeName=val||"ThisWorkbook";else wsprops.CodeName=val||wsprops.name;}break;case'GUIDTypeLib':{/* empty */}break;case'WOpt':break;// TODO: WTF?
case'PhoneticInfo':break;case'OleObjectSize':break;/* Differential Formatting */case'DXF':case'DXFN':case'DXFN12':case'DXFN12List':case'DXFN12NoCB':break;/* Data Validation */case'Dv':case'DVal':break;/* Data Series */case'BRAI':case'Series':case'SeriesText':break;/* Data Connection */case'DConn':break;case'DbOrParamQry':break;case'DBQueryExt':break;case'OleDbConn':break;case'ExtString':break;/* Formatting */case'IFmtRecord':break;case'CondFmt':case'CF':case'CF12':case'CFEx':break;/* Explicitly Ignored */case'Excel9File':break;case'Units':break;case'InterfaceHdr':case'Mms':case'InterfaceEnd':case'DSF':break;case'BuiltInFnGroupCount':/* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */break;/* View Stuff */case'Window1':case'HideObj':case'GridSet':case'Guts':case'UserBView':case'UserSViewBegin':case'UserSViewEnd':break;case'Pane':break;default:switch(R.n){/* nested */ /* Chart */case'Dat':case'Begin':case'End':case'StartBlock':case'EndBlock':case'Frame':case'Area':case'Axis':case'AxisLine':case'Tick':break;case'AxesUsed':case'CrtLayout12':case'CrtLayout12A':case'CrtLink':case'CrtLine':case'CrtMlFrt':case'CrtMlFrtContinue':break;case'LineFormat':case'AreaFormat':case'Chart':case'Chart3d':case'Chart3DBarShape':case'ChartFormat':case'ChartFrtInfo':break;case'PlotArea':case'PlotGrowth':break;case'SeriesList':case'SerParent':case'SerAuxTrend':break;case'DataFormat':case'SerToCrt':case'FontX':break;case'CatSerRange':case'AxcExt':case'SerFmt':break;case'ShtProps':break;case'DefaultText':case'Text':case'CatLab':break;case'DataLabExtContents':break;case'Legend':case'LegendException':break;case'Pie':case'Scatter':break;case'PieFormat':case'MarkerFormat':break;case'StartObject':case'EndObject':break;case'AlRuns':case'ObjectLink':break;case'SIIndex':break;case'AttachedLabel':case'YMult':break;/* Chart Group */case'Line':case'Bar':break;case'Surf':break;/* Axis Group */case'AxisParent':break;case'Pos':break;case'ValueRange':break;/* Pivot Chart */case'SXViewEx9':break;// TODO
case'SXViewLink':break;case'PivotChartBits':break;case'SBaseRef':break;case'TextPropsStream':break;/* Chart Misc */case'LnExt':break;case'MkrExt':break;case'CrtCoopt':break;/* Query Table */case'Qsi':case'Qsif':case'Qsir':case'QsiSXTag':break;case'TxtQry':break;/* Filter */case'FilterMode':break;case'AutoFilter':case'AutoFilterInfo':break;case'AutoFilter12':break;case'DropDownObjIds':break;case'Sort':break;case'SortData':break;/* Drawing */case'ShapePropsStream':break;case'MsoDrawing':case'MsoDrawingGroup':case'MsoDrawingSelection':break;/* Pub Stuff */case'WebPub':case'AutoWebPub':break;/* Print Stuff */case'HeaderFooter':case'HFPicture':case'PLV':case'HorizontalPageBreaks':case'VerticalPageBreaks':break;/* Behavioral */case'Backup':case'CompressPictures':case'Compat12':break;/* Should not Happen */case'Continue':case'ContinueFrt12':break;/* Future Records */case'FrtFontList':case'FrtWrapper':break;default:switch(R.n){/* nested */ /* BIFF5 records */case'TabIdConf':case'Radar':case'RadarArea':case'DropBar':case'Intl':case'CoordList':case'SerAuxErrBar':break;/* BIFF2-4 records */case'BIFF2FONTCLR':case'BIFF2FMTCNT':case'BIFF2FONTXTRA':break;case'BIFF2XF':case'BIFF3XF':case'BIFF4XF':break;case'BIFF2XFINDEX':break;case'BIFF4FMTCNT':case'BIFF2ROW':case'BIFF2WINDOW2':break;/* Miscellaneous */case'SCENARIO':case'DConBin':case'PicF':case'DataLabExt':case'Lel':case'BopPop':case'BopPopCustom':case'RealTimeData':case'Name':break;case'LHNGraph':case'FnGroupName':case'AddMenu':case'LPr':break;case'ListObj':case'ListField':break;case'RRSort':break;case'BigName':break;case'ToolbarHdr':case'ToolbarEnd':break;case'DDEObjName':break;case'FRTArchId$':break;default:if(options.WTF)throw'Unrecognized Record '+R.n;}}}}}else blob.l+=length;}wb.SheetNames=keys(Directory).sort(function(a,b){return Number(a)-Number(b);}).map(function(x){return Directory[x].name;});if(!options.bookSheets)wb.Sheets=Sheets;if(!wb.SheetNames.length&&Preamble["!ref"]){wb.SheetNames.push("Sheet1");/*jshint -W069 */if(wb.Sheets)wb.Sheets["Sheet1"]=Preamble;/*jshint +W069 */}else wb.Preamble=Preamble;if(wb.Sheets)FilterDatabases.forEach(function(r,i){wb.Sheets[wb.SheetNames[i]]['!autofilter']=r;});wb.Strings=sst;wb.SSF=SSF.get_table();if(opts.enc)wb.Encryption=opts.enc;if(themes)wb.Themes=themes;wb.Metadata={};if(country!==undefined)wb.Metadata.Country=country;if(supbooks.names.length>0)Workbook.Names=supbooks.names;wb.Workbook=Workbook;return wb;}/* TODO: split props*/var PSCLSID={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function parse_xls_props(cfb,props,o){/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */var DSI=CFB.find(cfb,'!DocumentSummaryInformation');if(DSI&&DSI.size>0)try{var DocSummary=parse_PropertySetStream(DSI,DocSummaryPIDDSI,PSCLSID.DSI);for(var d in DocSummary)props[d]=DocSummary[d];}catch(e){if(o.WTF)throw e;/* empty */}/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/var SI=CFB.find(cfb,'!SummaryInformation');if(SI&&SI.size>0)try{var Summary=parse_PropertySetStream(SI,SummaryPIDSI,PSCLSID.SI);for(var s in Summary)if(props[s]==null)props[s]=Summary[s];}catch(e){if(o.WTF)throw e;/* empty */}if(props.HeadingPairs&&props.TitlesOfParts){load_props_pairs(props.HeadingPairs,props.TitlesOfParts,props,o);delete props.HeadingPairs;delete props.TitlesOfParts;}}function write_xls_props(wb,cfb){var DSEntries=[],SEntries=[],CEntries=[];var i=0,Keys;if(wb.Props){Keys=keys(wb.Props);// $FlowIgnore
for(i=0;i<Keys.length;++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Props[Keys[i]]]);}if(wb.Custprops){Keys=keys(wb.Custprops);// $FlowIgnore
for(i=0;i<Keys.length;++i)if(!Object.prototype.hasOwnProperty.call(wb.Props||{},Keys[i]))(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Custprops[Keys[i]]]);}var CEntries2=[];for(i=0;i<CEntries.length;++i){if(XLSPSSkip.indexOf(CEntries[i][0])>-1)continue;if(CEntries[i][1]==null)continue;CEntries2.push(CEntries[i]);}if(SEntries.length)CFB.utils.cfb_add(cfb,"/\u0005SummaryInformation",write_PropertySetStream(SEntries,PSCLSID.SI,SummaryRE,SummaryPIDSI));if(DSEntries.length||CEntries2.length)CFB.utils.cfb_add(cfb,"/\u0005DocumentSummaryInformation",write_PropertySetStream(DSEntries,PSCLSID.DSI,DocSummaryRE,DocSummaryPIDDSI,CEntries2.length?CEntries2:null,PSCLSID.UDI));}function parse_xlscfb(cfb,options){if(!options)options={};fix_read_opts(options);reset_cp();if(options.codepage)set_ansi(options.codepage);var CompObj,WB;if(cfb.FullPaths){if(CFB.find(cfb,'/encryption'))throw new Error("File is password-protected");CompObj=CFB.find(cfb,'!CompObj');WB=CFB.find(cfb,'/Workbook')||CFB.find(cfb,'/Book');}else{switch(options.type){case'base64':cfb=s2a(Base64.decode(cfb));break;case'binary':cfb=s2a(cfb);break;case'buffer':break;case'array':if(!Array.isArray(cfb))cfb=Array.prototype.slice.call(cfb);break;}prep_blob(cfb,0);WB={content:cfb};}var WorkbookP;var _data;if(CompObj)parse_compobj(CompObj);if(options.bookProps&&!options.bookSheets)WorkbookP={};else{var T=has_buf?'buffer':'array';if(WB&&WB.content)WorkbookP=parse_workbook(WB.content,options);/* Quattro Pro 7-8 */else if((_data=CFB.find(cfb,'PerfectOffice_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));/* Quattro Pro 9 */else if((_data=CFB.find(cfb,'NativeContent_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));/* Works 4 for Mac */else if((_data=CFB.find(cfb,'MN0'))&&_data.content)throw new Error("Unsupported Works 4 for Mac file");else throw new Error("Cannot find Workbook stream");if(options.bookVBA&&cfb.FullPaths&&CFB.find(cfb,'/_VBA_PROJECT_CUR/VBA/dir'))WorkbookP.vbaraw=make_vba_xls(cfb);}var props={};if(cfb.FullPaths)parse_xls_props(cfb,props,options);WorkbookP.Props=WorkbookP.Custprops=props;/* TODO: split up properties */if(options.bookFiles)WorkbookP.cfb=cfb;/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */return WorkbookP;}function write_xlscfb(wb,opts){var o=opts||{};var cfb=CFB.utils.cfb_new({root:"R"});var wbpath="/Workbook";switch(o.bookType||"xls"){case"xls":o.bookType="biff8";/* falls through */case"xla":if(!o.bookType)o.bookType="xla";/* falls through */case"biff8":wbpath="/Workbook";o.biff=8;break;case"biff5":wbpath="/Book";o.biff=5;break;default:throw new Error("invalid type "+o.bookType+" for XLS CFB");}CFB.utils.cfb_add(cfb,wbpath,write_biff_buf(wb,o));if(o.biff==8&&(wb.Props||wb.Custprops))write_xls_props(wb,cfb);// TODO: SI, DSI, CO
if(o.biff==8&&wb.vbaraw)fill_vba_xls(cfb,CFB.read(wb.vbaraw,{type:typeof wb.vbaraw=="string"?"binary":"buffer"}));return cfb;}/* [MS-XLSB] 2.3 Record Enumeration */var XLSBRecordEnum={0x0000:{n:"BrtRowHdr",f:parse_BrtRowHdr},0x0001:{n:"BrtCellBlank",f:parse_BrtCellBlank},0x0002:{n:"BrtCellRk",f:parse_BrtCellRk},0x0003:{n:"BrtCellError",f:parse_BrtCellError},0x0004:{n:"BrtCellBool",f:parse_BrtCellBool},0x0005:{n:"BrtCellReal",f:parse_BrtCellReal},0x0006:{n:"BrtCellSt",f:parse_BrtCellSt},0x0007:{n:"BrtCellIsst",f:parse_BrtCellIsst},0x0008:{n:"BrtFmlaString",f:parse_BrtFmlaString},0x0009:{n:"BrtFmlaNum",f:parse_BrtFmlaNum},0x000A:{n:"BrtFmlaBool",f:parse_BrtFmlaBool},0x000B:{n:"BrtFmlaError",f:parse_BrtFmlaError},0x000C:{n:"BrtShortBlank",f:parse_BrtShortBlank},0x000D:{n:"BrtShortRk",f:parse_BrtShortRk},0x000E:{n:"BrtShortError",f:parse_BrtShortError},0x000F:{n:"BrtShortBool",f:parse_BrtShortBool},0x0010:{n:"BrtShortReal",f:parse_BrtShortReal},0x0011:{n:"BrtShortSt",f:parse_BrtShortSt},0x0012:{n:"BrtShortIsst",f:parse_BrtShortIsst},0x0013:{n:"BrtSSTItem",f:parse_RichStr},0x0014:{n:"BrtPCDIMissing"},0x0015:{n:"BrtPCDINumber"},0x0016:{n:"BrtPCDIBoolean"},0x0017:{n:"BrtPCDIError"},0x0018:{n:"BrtPCDIString"},0x0019:{n:"BrtPCDIDatetime"},0x001A:{n:"BrtPCDIIndex"},0x001B:{n:"BrtPCDIAMissing"},0x001C:{n:"BrtPCDIANumber"},0x001D:{n:"BrtPCDIABoolean"},0x001E:{n:"BrtPCDIAError"},0x001F:{n:"BrtPCDIAString"},0x0020:{n:"BrtPCDIADatetime"},0x0021:{n:"BrtPCRRecord"},0x0022:{n:"BrtPCRRecordDt"},0x0023:{n:"BrtFRTBegin"},0x0024:{n:"BrtFRTEnd"},0x0025:{n:"BrtACBegin"},0x0026:{n:"BrtACEnd"},0x0027:{n:"BrtName",f:parse_BrtName},0x0028:{n:"BrtIndexRowBlock"},0x002A:{n:"BrtIndexBlock"},0x002B:{n:"BrtFont",f:parse_BrtFont},0x002C:{n:"BrtFmt",f:parse_BrtFmt},0x002D:{n:"BrtFill",f:parse_BrtFill},0x002E:{n:"BrtBorder",f:parse_BrtBorder},0x002F:{n:"BrtXF",f:parse_BrtXF},0x0030:{n:"BrtStyle"},0x0031:{n:"BrtCellMeta"},0x0032:{n:"BrtValueMeta"},0x0033:{n:"BrtMdb"},0x0034:{n:"BrtBeginFmd"},0x0035:{n:"BrtEndFmd"},0x0036:{n:"BrtBeginMdx"},0x0037:{n:"BrtEndMdx"},0x0038:{n:"BrtBeginMdxTuple"},0x0039:{n:"BrtEndMdxTuple"},0x003A:{n:"BrtMdxMbrIstr"},0x003B:{n:"BrtStr"},0x003C:{n:"BrtColInfo",f:parse_ColInfo},0x003E:{n:"BrtCellRString"},0x003F:{n:"BrtCalcChainItem$",f:parse_BrtCalcChainItem$},0x0040:{n:"BrtDVal",f:parse_BrtDVal},0x0041:{n:"BrtSxvcellNum"},0x0042:{n:"BrtSxvcellStr"},0x0043:{n:"BrtSxvcellBool"},0x0044:{n:"BrtSxvcellErr"},0x0045:{n:"BrtSxvcellDate"},0x0046:{n:"BrtSxvcellNil"},0x0080:{n:"BrtFileVersion"},0x0081:{n:"BrtBeginSheet"},0x0082:{n:"BrtEndSheet"},0x0083:{n:"BrtBeginBook",f:parsenoop,p:0},0x0084:{n:"BrtEndBook"},0x0085:{n:"BrtBeginWsViews"},0x0086:{n:"BrtEndWsViews"},0x0087:{n:"BrtBeginBookViews"},0x0088:{n:"BrtEndBookViews"},0x0089:{n:"BrtBeginWsView",f:parse_BrtBeginWsView},0x008A:{n:"BrtEndWsView"},0x008B:{n:"BrtBeginCsViews"},0x008C:{n:"BrtEndCsViews"},0x008D:{n:"BrtBeginCsView"},0x008E:{n:"BrtEndCsView"},0x008F:{n:"BrtBeginBundleShs"},0x0090:{n:"BrtEndBundleShs"},0x0091:{n:"BrtBeginSheetData"},0x0092:{n:"BrtEndSheetData"},0x0093:{n:"BrtWsProp",f:parse_BrtWsProp},0x0094:{n:"BrtWsDim",f:parse_BrtWsDim,p:16},0x0097:{n:"BrtPane",f:parse_BrtPane},0x0098:{n:"BrtSel"},0x0099:{n:"BrtWbProp",f:parse_BrtWbProp},0x009A:{n:"BrtWbFactoid"},0x009B:{n:"BrtFileRecover"},0x009C:{n:"BrtBundleSh",f:parse_BrtBundleSh},0x009D:{n:"BrtCalcProp"},0x009E:{n:"BrtBookView"},0x009F:{n:"BrtBeginSst",f:parse_BrtBeginSst},0x00A0:{n:"BrtEndSst"},0x00A1:{n:"BrtBeginAFilter",f:parse_UncheckedRfX},0x00A2:{n:"BrtEndAFilter"},0x00A3:{n:"BrtBeginFilterColumn"},0x00A4:{n:"BrtEndFilterColumn"},0x00A5:{n:"BrtBeginFilters"},0x00A6:{n:"BrtEndFilters"},0x00A7:{n:"BrtFilter"},0x00A8:{n:"BrtColorFilter"},0x00A9:{n:"BrtIconFilter"},0x00AA:{n:"BrtTop10Filter"},0x00AB:{n:"BrtDynamicFilter"},0x00AC:{n:"BrtBeginCustomFilters"},0x00AD:{n:"BrtEndCustomFilters"},0x00AE:{n:"BrtCustomFilter"},0x00AF:{n:"BrtAFilterDateGroupItem"},0x00B0:{n:"BrtMergeCell",f:parse_BrtMergeCell},0x00B1:{n:"BrtBeginMergeCells"},0x00B2:{n:"BrtEndMergeCells"},0x00B3:{n:"BrtBeginPivotCacheDef"},0x00B4:{n:"BrtEndPivotCacheDef"},0x00B5:{n:"BrtBeginPCDFields"},0x00B6:{n:"BrtEndPCDFields"},0x00B7:{n:"BrtBeginPCDField"},0x00B8:{n:"BrtEndPCDField"},0x00B9:{n:"BrtBeginPCDSource"},0x00BA:{n:"BrtEndPCDSource"},0x00BB:{n:"BrtBeginPCDSRange"},0x00BC:{n:"BrtEndPCDSRange"},0x00BD:{n:"BrtBeginPCDFAtbl"},0x00BE:{n:"BrtEndPCDFAtbl"},0x00BF:{n:"BrtBeginPCDIRun"},0x00C0:{n:"BrtEndPCDIRun"},0x00C1:{n:"BrtBeginPivotCacheRecords"},0x00C2:{n:"BrtEndPivotCacheRecords"},0x00C3:{n:"BrtBeginPCDHierarchies"},0x00C4:{n:"BrtEndPCDHierarchies"},0x00C5:{n:"BrtBeginPCDHierarchy"},0x00C6:{n:"BrtEndPCDHierarchy"},0x00C7:{n:"BrtBeginPCDHFieldsUsage"},0x00C8:{n:"BrtEndPCDHFieldsUsage"},0x00C9:{n:"BrtBeginExtConnection"},0x00CA:{n:"BrtEndExtConnection"},0x00CB:{n:"BrtBeginECDbProps"},0x00CC:{n:"BrtEndECDbProps"},0x00CD:{n:"BrtBeginECOlapProps"},0x00CE:{n:"BrtEndECOlapProps"},0x00CF:{n:"BrtBeginPCDSConsol"},0x00D0:{n:"BrtEndPCDSConsol"},0x00D1:{n:"BrtBeginPCDSCPages"},0x00D2:{n:"BrtEndPCDSCPages"},0x00D3:{n:"BrtBeginPCDSCPage"},0x00D4:{n:"BrtEndPCDSCPage"},0x00D5:{n:"BrtBeginPCDSCPItem"},0x00D6:{n:"BrtEndPCDSCPItem"},0x00D7:{n:"BrtBeginPCDSCSets"},0x00D8:{n:"BrtEndPCDSCSets"},0x00D9:{n:"BrtBeginPCDSCSet"},0x00DA:{n:"BrtEndPCDSCSet"},0x00DB:{n:"BrtBeginPCDFGroup"},0x00DC:{n:"BrtEndPCDFGroup"},0x00DD:{n:"BrtBeginPCDFGItems"},0x00DE:{n:"BrtEndPCDFGItems"},0x00DF:{n:"BrtBeginPCDFGRange"},0x00E0:{n:"BrtEndPCDFGRange"},0x00E1:{n:"BrtBeginPCDFGDiscrete"},0x00E2:{n:"BrtEndPCDFGDiscrete"},0x00E3:{n:"BrtBeginPCDSDTupleCache"},0x00E4:{n:"BrtEndPCDSDTupleCache"},0x00E5:{n:"BrtBeginPCDSDTCEntries"},0x00E6:{n:"BrtEndPCDSDTCEntries"},0x00E7:{n:"BrtBeginPCDSDTCEMembers"},0x00E8:{n:"BrtEndPCDSDTCEMembers"},0x00E9:{n:"BrtBeginPCDSDTCEMember"},0x00EA:{n:"BrtEndPCDSDTCEMember"},0x00EB:{n:"BrtBeginPCDSDTCQueries"},0x00EC:{n:"BrtEndPCDSDTCQueries"},0x00ED:{n:"BrtBeginPCDSDTCQuery"},0x00EE:{n:"BrtEndPCDSDTCQuery"},0x00EF:{n:"BrtBeginPCDSDTCSets"},0x00F0:{n:"BrtEndPCDSDTCSets"},0x00F1:{n:"BrtBeginPCDSDTCSet"},0x00F2:{n:"BrtEndPCDSDTCSet"},0x00F3:{n:"BrtBeginPCDCalcItems"},0x00F4:{n:"BrtEndPCDCalcItems"},0x00F5:{n:"BrtBeginPCDCalcItem"},0x00F6:{n:"BrtEndPCDCalcItem"},0x00F7:{n:"BrtBeginPRule"},0x00F8:{n:"BrtEndPRule"},0x00F9:{n:"BrtBeginPRFilters"},0x00FA:{n:"BrtEndPRFilters"},0x00FB:{n:"BrtBeginPRFilter"},0x00FC:{n:"BrtEndPRFilter"},0x00FD:{n:"BrtBeginPNames"},0x00FE:{n:"BrtEndPNames"},0x00FF:{n:"BrtBeginPName"},0x0100:{n:"BrtEndPName"},0x0101:{n:"BrtBeginPNPairs"},0x0102:{n:"BrtEndPNPairs"},0x0103:{n:"BrtBeginPNPair"},0x0104:{n:"BrtEndPNPair"},0x0105:{n:"BrtBeginECWebProps"},0x0106:{n:"BrtEndECWebProps"},0x0107:{n:"BrtBeginEcWpTables"},0x0108:{n:"BrtEndECWPTables"},0x0109:{n:"BrtBeginECParams"},0x010A:{n:"BrtEndECParams"},0x010B:{n:"BrtBeginECParam"},0x010C:{n:"BrtEndECParam"},0x010D:{n:"BrtBeginPCDKPIs"},0x010E:{n:"BrtEndPCDKPIs"},0x010F:{n:"BrtBeginPCDKPI"},0x0110:{n:"BrtEndPCDKPI"},0x0111:{n:"BrtBeginDims"},0x0112:{n:"BrtEndDims"},0x0113:{n:"BrtBeginDim"},0x0114:{n:"BrtEndDim"},0x0115:{n:"BrtIndexPartEnd"},0x0116:{n:"BrtBeginStyleSheet"},0x0117:{n:"BrtEndStyleSheet"},0x0118:{n:"BrtBeginSXView"},0x0119:{n:"BrtEndSXVI"},0x011A:{n:"BrtBeginSXVI"},0x011B:{n:"BrtBeginSXVIs"},0x011C:{n:"BrtEndSXVIs"},0x011D:{n:"BrtBeginSXVD"},0x011E:{n:"BrtEndSXVD"},0x011F:{n:"BrtBeginSXVDs"},0x0120:{n:"BrtEndSXVDs"},0x0121:{n:"BrtBeginSXPI"},0x0122:{n:"BrtEndSXPI"},0x0123:{n:"BrtBeginSXPIs"},0x0124:{n:"BrtEndSXPIs"},0x0125:{n:"BrtBeginSXDI"},0x0126:{n:"BrtEndSXDI"},0x0127:{n:"BrtBeginSXDIs"},0x0128:{n:"BrtEndSXDIs"},0x0129:{n:"BrtBeginSXLI"},0x012A:{n:"BrtEndSXLI"},0x012B:{n:"BrtBeginSXLIRws"},0x012C:{n:"BrtEndSXLIRws"},0x012D:{n:"BrtBeginSXLICols"},0x012E:{n:"BrtEndSXLICols"},0x012F:{n:"BrtBeginSXFormat"},0x0130:{n:"BrtEndSXFormat"},0x0131:{n:"BrtBeginSXFormats"},0x0132:{n:"BrtEndSxFormats"},0x0133:{n:"BrtBeginSxSelect"},0x0134:{n:"BrtEndSxSelect"},0x0135:{n:"BrtBeginISXVDRws"},0x0136:{n:"BrtEndISXVDRws"},0x0137:{n:"BrtBeginISXVDCols"},0x0138:{n:"BrtEndISXVDCols"},0x0139:{n:"BrtEndSXLocation"},0x013A:{n:"BrtBeginSXLocation"},0x013B:{n:"BrtEndSXView"},0x013C:{n:"BrtBeginSXTHs"},0x013D:{n:"BrtEndSXTHs"},0x013E:{n:"BrtBeginSXTH"},0x013F:{n:"BrtEndSXTH"},0x0140:{n:"BrtBeginISXTHRws"},0x0141:{n:"BrtEndISXTHRws"},0x0142:{n:"BrtBeginISXTHCols"},0x0143:{n:"BrtEndISXTHCols"},0x0144:{n:"BrtBeginSXTDMPS"},0x0145:{n:"BrtEndSXTDMPs"},0x0146:{n:"BrtBeginSXTDMP"},0x0147:{n:"BrtEndSXTDMP"},0x0148:{n:"BrtBeginSXTHItems"},0x0149:{n:"BrtEndSXTHItems"},0x014A:{n:"BrtBeginSXTHItem"},0x014B:{n:"BrtEndSXTHItem"},0x014C:{n:"BrtBeginMetadata"},0x014D:{n:"BrtEndMetadata"},0x014E:{n:"BrtBeginEsmdtinfo"},0x014F:{n:"BrtMdtinfo"},0x0150:{n:"BrtEndEsmdtinfo"},0x0151:{n:"BrtBeginEsmdb"},0x0152:{n:"BrtEndEsmdb"},0x0153:{n:"BrtBeginEsfmd"},0x0154:{n:"BrtEndEsfmd"},0x0155:{n:"BrtBeginSingleCells"},0x0156:{n:"BrtEndSingleCells"},0x0157:{n:"BrtBeginList"},0x0158:{n:"BrtEndList"},0x0159:{n:"BrtBeginListCols"},0x015A:{n:"BrtEndListCols"},0x015B:{n:"BrtBeginListCol"},0x015C:{n:"BrtEndListCol"},0x015D:{n:"BrtBeginListXmlCPr"},0x015E:{n:"BrtEndListXmlCPr"},0x015F:{n:"BrtListCCFmla"},0x0160:{n:"BrtListTrFmla"},0x0161:{n:"BrtBeginExternals"},0x0162:{n:"BrtEndExternals"},0x0163:{n:"BrtSupBookSrc",f:parse_RelID},0x0165:{n:"BrtSupSelf"},0x0166:{n:"BrtSupSame"},0x0167:{n:"BrtSupTabs"},0x0168:{n:"BrtBeginSupBook"},0x0169:{n:"BrtPlaceholderName"},0x016A:{n:"BrtExternSheet",f:parse_ExternSheet},0x016B:{n:"BrtExternTableStart"},0x016C:{n:"BrtExternTableEnd"},0x016E:{n:"BrtExternRowHdr"},0x016F:{n:"BrtExternCellBlank"},0x0170:{n:"BrtExternCellReal"},0x0171:{n:"BrtExternCellBool"},0x0172:{n:"BrtExternCellError"},0x0173:{n:"BrtExternCellString"},0x0174:{n:"BrtBeginEsmdx"},0x0175:{n:"BrtEndEsmdx"},0x0176:{n:"BrtBeginMdxSet"},0x0177:{n:"BrtEndMdxSet"},0x0178:{n:"BrtBeginMdxMbrProp"},0x0179:{n:"BrtEndMdxMbrProp"},0x017A:{n:"BrtBeginMdxKPI"},0x017B:{n:"BrtEndMdxKPI"},0x017C:{n:"BrtBeginEsstr"},0x017D:{n:"BrtEndEsstr"},0x017E:{n:"BrtBeginPRFItem"},0x017F:{n:"BrtEndPRFItem"},0x0180:{n:"BrtBeginPivotCacheIDs"},0x0181:{n:"BrtEndPivotCacheIDs"},0x0182:{n:"BrtBeginPivotCacheID"},0x0183:{n:"BrtEndPivotCacheID"},0x0184:{n:"BrtBeginISXVIs"},0x0185:{n:"BrtEndISXVIs"},0x0186:{n:"BrtBeginColInfos"},0x0187:{n:"BrtEndColInfos"},0x0188:{n:"BrtBeginRwBrk"},0x0189:{n:"BrtEndRwBrk"},0x018A:{n:"BrtBeginColBrk"},0x018B:{n:"BrtEndColBrk"},0x018C:{n:"BrtBrk"},0x018D:{n:"BrtUserBookView"},0x018E:{n:"BrtInfo"},0x018F:{n:"BrtCUsr"},0x0190:{n:"BrtUsr"},0x0191:{n:"BrtBeginUsers"},0x0193:{n:"BrtEOF"},0x0194:{n:"BrtUCR"},0x0195:{n:"BrtRRInsDel"},0x0196:{n:"BrtRREndInsDel"},0x0197:{n:"BrtRRMove"},0x0198:{n:"BrtRREndMove"},0x0199:{n:"BrtRRChgCell"},0x019A:{n:"BrtRREndChgCell"},0x019B:{n:"BrtRRHeader"},0x019C:{n:"BrtRRUserView"},0x019D:{n:"BrtRRRenSheet"},0x019E:{n:"BrtRRInsertSh"},0x019F:{n:"BrtRRDefName"},0x01A0:{n:"BrtRRNote"},0x01A1:{n:"BrtRRConflict"},0x01A2:{n:"BrtRRTQSIF"},0x01A3:{n:"BrtRRFormat"},0x01A4:{n:"BrtRREndFormat"},0x01A5:{n:"BrtRRAutoFmt"},0x01A6:{n:"BrtBeginUserShViews"},0x01A7:{n:"BrtBeginUserShView"},0x01A8:{n:"BrtEndUserShView"},0x01A9:{n:"BrtEndUserShViews"},0x01AA:{n:"BrtArrFmla",f:parse_BrtArrFmla},0x01AB:{n:"BrtShrFmla",f:parse_BrtShrFmla},0x01AC:{n:"BrtTable"},0x01AD:{n:"BrtBeginExtConnections"},0x01AE:{n:"BrtEndExtConnections"},0x01AF:{n:"BrtBeginPCDCalcMems"},0x01B0:{n:"BrtEndPCDCalcMems"},0x01B1:{n:"BrtBeginPCDCalcMem"},0x01B2:{n:"BrtEndPCDCalcMem"},0x01B3:{n:"BrtBeginPCDHGLevels"},0x01B4:{n:"BrtEndPCDHGLevels"},0x01B5:{n:"BrtBeginPCDHGLevel"},0x01B6:{n:"BrtEndPCDHGLevel"},0x01B7:{n:"BrtBeginPCDHGLGroups"},0x01B8:{n:"BrtEndPCDHGLGroups"},0x01B9:{n:"BrtBeginPCDHGLGroup"},0x01BA:{n:"BrtEndPCDHGLGroup"},0x01BB:{n:"BrtBeginPCDHGLGMembers"},0x01BC:{n:"BrtEndPCDHGLGMembers"},0x01BD:{n:"BrtBeginPCDHGLGMember"},0x01BE:{n:"BrtEndPCDHGLGMember"},0x01BF:{n:"BrtBeginQSI"},0x01C0:{n:"BrtEndQSI"},0x01C1:{n:"BrtBeginQSIR"},0x01C2:{n:"BrtEndQSIR"},0x01C3:{n:"BrtBeginDeletedNames"},0x01C4:{n:"BrtEndDeletedNames"},0x01C5:{n:"BrtBeginDeletedName"},0x01C6:{n:"BrtEndDeletedName"},0x01C7:{n:"BrtBeginQSIFs"},0x01C8:{n:"BrtEndQSIFs"},0x01C9:{n:"BrtBeginQSIF"},0x01CA:{n:"BrtEndQSIF"},0x01CB:{n:"BrtBeginAutoSortScope"},0x01CC:{n:"BrtEndAutoSortScope"},0x01CD:{n:"BrtBeginConditionalFormatting"},0x01CE:{n:"BrtEndConditionalFormatting"},0x01CF:{n:"BrtBeginCFRule"},0x01D0:{n:"BrtEndCFRule"},0x01D1:{n:"BrtBeginIconSet"},0x01D2:{n:"BrtEndIconSet"},0x01D3:{n:"BrtBeginDatabar"},0x01D4:{n:"BrtEndDatabar"},0x01D5:{n:"BrtBeginColorScale"},0x01D6:{n:"BrtEndColorScale"},0x01D7:{n:"BrtCFVO"},0x01D8:{n:"BrtExternValueMeta"},0x01D9:{n:"BrtBeginColorPalette"},0x01DA:{n:"BrtEndColorPalette"},0x01DB:{n:"BrtIndexedColor"},0x01DC:{n:"BrtMargins",f:parse_BrtMargins},0x01DD:{n:"BrtPrintOptions"},0x01DE:{n:"BrtPageSetup"},0x01DF:{n:"BrtBeginHeaderFooter"},0x01E0:{n:"BrtEndHeaderFooter"},0x01E1:{n:"BrtBeginSXCrtFormat"},0x01E2:{n:"BrtEndSXCrtFormat"},0x01E3:{n:"BrtBeginSXCrtFormats"},0x01E4:{n:"BrtEndSXCrtFormats"},0x01E5:{n:"BrtWsFmtInfo",f:parse_BrtWsFmtInfo},0x01E6:{n:"BrtBeginMgs"},0x01E7:{n:"BrtEndMGs"},0x01E8:{n:"BrtBeginMGMaps"},0x01E9:{n:"BrtEndMGMaps"},0x01EA:{n:"BrtBeginMG"},0x01EB:{n:"BrtEndMG"},0x01EC:{n:"BrtBeginMap"},0x01ED:{n:"BrtEndMap"},0x01EE:{n:"BrtHLink",f:parse_BrtHLink},0x01EF:{n:"BrtBeginDCon"},0x01F0:{n:"BrtEndDCon"},0x01F1:{n:"BrtBeginDRefs"},0x01F2:{n:"BrtEndDRefs"},0x01F3:{n:"BrtDRef"},0x01F4:{n:"BrtBeginScenMan"},0x01F5:{n:"BrtEndScenMan"},0x01F6:{n:"BrtBeginSct"},0x01F7:{n:"BrtEndSct"},0x01F8:{n:"BrtSlc"},0x01F9:{n:"BrtBeginDXFs"},0x01FA:{n:"BrtEndDXFs"},0x01FB:{n:"BrtDXF"},0x01FC:{n:"BrtBeginTableStyles"},0x01FD:{n:"BrtEndTableStyles"},0x01FE:{n:"BrtBeginTableStyle"},0x01FF:{n:"BrtEndTableStyle"},0x0200:{n:"BrtTableStyleElement"},0x0201:{n:"BrtTableStyleClient"},0x0202:{n:"BrtBeginVolDeps"},0x0203:{n:"BrtEndVolDeps"},0x0204:{n:"BrtBeginVolType"},0x0205:{n:"BrtEndVolType"},0x0206:{n:"BrtBeginVolMain"},0x0207:{n:"BrtEndVolMain"},0x0208:{n:"BrtBeginVolTopic"},0x0209:{n:"BrtEndVolTopic"},0x020A:{n:"BrtVolSubtopic"},0x020B:{n:"BrtVolRef"},0x020C:{n:"BrtVolNum"},0x020D:{n:"BrtVolErr"},0x020E:{n:"BrtVolStr"},0x020F:{n:"BrtVolBool"},0x0210:{n:"BrtBeginCalcChain$"},0x0211:{n:"BrtEndCalcChain$"},0x0212:{n:"BrtBeginSortState"},0x0213:{n:"BrtEndSortState"},0x0214:{n:"BrtBeginSortCond"},0x0215:{n:"BrtEndSortCond"},0x0216:{n:"BrtBookProtection"},0x0217:{n:"BrtSheetProtection"},0x0218:{n:"BrtRangeProtection"},0x0219:{n:"BrtPhoneticInfo"},0x021A:{n:"BrtBeginECTxtWiz"},0x021B:{n:"BrtEndECTxtWiz"},0x021C:{n:"BrtBeginECTWFldInfoLst"},0x021D:{n:"BrtEndECTWFldInfoLst"},0x021E:{n:"BrtBeginECTwFldInfo"},0x0224:{n:"BrtFileSharing"},0x0225:{n:"BrtOleSize"},0x0226:{n:"BrtDrawing",f:parse_RelID},0x0227:{n:"BrtLegacyDrawing"},0x0228:{n:"BrtLegacyDrawingHF"},0x0229:{n:"BrtWebOpt"},0x022A:{n:"BrtBeginWebPubItems"},0x022B:{n:"BrtEndWebPubItems"},0x022C:{n:"BrtBeginWebPubItem"},0x022D:{n:"BrtEndWebPubItem"},0x022E:{n:"BrtBeginSXCondFmt"},0x022F:{n:"BrtEndSXCondFmt"},0x0230:{n:"BrtBeginSXCondFmts"},0x0231:{n:"BrtEndSXCondFmts"},0x0232:{n:"BrtBkHim"},0x0234:{n:"BrtColor"},0x0235:{n:"BrtBeginIndexedColors"},0x0236:{n:"BrtEndIndexedColors"},0x0239:{n:"BrtBeginMRUColors"},0x023A:{n:"BrtEndMRUColors"},0x023C:{n:"BrtMRUColor"},0x023D:{n:"BrtBeginDVals"},0x023E:{n:"BrtEndDVals"},0x0241:{n:"BrtSupNameStart"},0x0242:{n:"BrtSupNameValueStart"},0x0243:{n:"BrtSupNameValueEnd"},0x0244:{n:"BrtSupNameNum"},0x0245:{n:"BrtSupNameErr"},0x0246:{n:"BrtSupNameSt"},0x0247:{n:"BrtSupNameNil"},0x0248:{n:"BrtSupNameBool"},0x0249:{n:"BrtSupNameFmla"},0x024A:{n:"BrtSupNameBits"},0x024B:{n:"BrtSupNameEnd"},0x024C:{n:"BrtEndSupBook"},0x024D:{n:"BrtCellSmartTagProperty"},0x024E:{n:"BrtBeginCellSmartTag"},0x024F:{n:"BrtEndCellSmartTag"},0x0250:{n:"BrtBeginCellSmartTags"},0x0251:{n:"BrtEndCellSmartTags"},0x0252:{n:"BrtBeginSmartTags"},0x0253:{n:"BrtEndSmartTags"},0x0254:{n:"BrtSmartTagType"},0x0255:{n:"BrtBeginSmartTagTypes"},0x0256:{n:"BrtEndSmartTagTypes"},0x0257:{n:"BrtBeginSXFilters"},0x0258:{n:"BrtEndSXFilters"},0x0259:{n:"BrtBeginSXFILTER"},0x025A:{n:"BrtEndSXFilter"},0x025B:{n:"BrtBeginFills"},0x025C:{n:"BrtEndFills"},0x025D:{n:"BrtBeginCellWatches"},0x025E:{n:"BrtEndCellWatches"},0x025F:{n:"BrtCellWatch"},0x0260:{n:"BrtBeginCRErrs"},0x0261:{n:"BrtEndCRErrs"},0x0262:{n:"BrtCrashRecErr"},0x0263:{n:"BrtBeginFonts"},0x0264:{n:"BrtEndFonts"},0x0265:{n:"BrtBeginBorders"},0x0266:{n:"BrtEndBorders"},0x0267:{n:"BrtBeginFmts"},0x0268:{n:"BrtEndFmts"},0x0269:{n:"BrtBeginCellXFs"},0x026A:{n:"BrtEndCellXFs"},0x026B:{n:"BrtBeginStyles"},0x026C:{n:"BrtEndStyles"},0x0271:{n:"BrtBigName"},0x0272:{n:"BrtBeginCellStyleXFs"},0x0273:{n:"BrtEndCellStyleXFs"},0x0274:{n:"BrtBeginComments"},0x0275:{n:"BrtEndComments"},0x0276:{n:"BrtBeginCommentAuthors"},0x0277:{n:"BrtEndCommentAuthors"},0x0278:{n:"BrtCommentAuthor",f:parse_BrtCommentAuthor},0x0279:{n:"BrtBeginCommentList"},0x027A:{n:"BrtEndCommentList"},0x027B:{n:"BrtBeginComment",f:parse_BrtBeginComment},0x027C:{n:"BrtEndComment"},0x027D:{n:"BrtCommentText",f:parse_BrtCommentText},0x027E:{n:"BrtBeginOleObjects"},0x027F:{n:"BrtOleObject"},0x0280:{n:"BrtEndOleObjects"},0x0281:{n:"BrtBeginSxrules"},0x0282:{n:"BrtEndSxRules"},0x0283:{n:"BrtBeginActiveXControls"},0x0284:{n:"BrtActiveX"},0x0285:{n:"BrtEndActiveXControls"},0x0286:{n:"BrtBeginPCDSDTCEMembersSortBy"},0x0288:{n:"BrtBeginCellIgnoreECs"},0x0289:{n:"BrtCellIgnoreEC"},0x028A:{n:"BrtEndCellIgnoreECs"},0x028B:{n:"BrtCsProp",f:parse_BrtCsProp},0x028C:{n:"BrtCsPageSetup"},0x028D:{n:"BrtBeginUserCsViews"},0x028E:{n:"BrtEndUserCsViews"},0x028F:{n:"BrtBeginUserCsView"},0x0290:{n:"BrtEndUserCsView"},0x0291:{n:"BrtBeginPcdSFCIEntries"},0x0292:{n:"BrtEndPCDSFCIEntries"},0x0293:{n:"BrtPCDSFCIEntry"},0x0294:{n:"BrtBeginListParts"},0x0295:{n:"BrtListPart"},0x0296:{n:"BrtEndListParts"},0x0297:{n:"BrtSheetCalcProp"},0x0298:{n:"BrtBeginFnGroup"},0x0299:{n:"BrtFnGroup"},0x029A:{n:"BrtEndFnGroup"},0x029B:{n:"BrtSupAddin"},0x029C:{n:"BrtSXTDMPOrder"},0x029D:{n:"BrtCsProtection"},0x029F:{n:"BrtBeginWsSortMap"},0x02A0:{n:"BrtEndWsSortMap"},0x02A1:{n:"BrtBeginRRSort"},0x02A2:{n:"BrtEndRRSort"},0x02A3:{n:"BrtRRSortItem"},0x02A4:{n:"BrtFileSharingIso"},0x02A5:{n:"BrtBookProtectionIso"},0x02A6:{n:"BrtSheetProtectionIso"},0x02A7:{n:"BrtCsProtectionIso"},0x02A8:{n:"BrtRangeProtectionIso"},0x02A9:{n:"BrtDValList"},0x0400:{n:"BrtRwDescent"},0x0401:{n:"BrtKnownFonts"},0x0402:{n:"BrtBeginSXTupleSet"},0x0403:{n:"BrtEndSXTupleSet"},0x0404:{n:"BrtBeginSXTupleSetHeader"},0x0405:{n:"BrtEndSXTupleSetHeader"},0x0406:{n:"BrtSXTupleSetHeaderItem"},0x0407:{n:"BrtBeginSXTupleSetData"},0x0408:{n:"BrtEndSXTupleSetData"},0x0409:{n:"BrtBeginSXTupleSetRow"},0x040A:{n:"BrtEndSXTupleSetRow"},0x040B:{n:"BrtSXTupleSetRowItem"},0x040C:{n:"BrtNameExt"},0x040D:{n:"BrtPCDH14"},0x040E:{n:"BrtBeginPCDCalcMem14"},0x040F:{n:"BrtEndPCDCalcMem14"},0x0410:{n:"BrtSXTH14"},0x0411:{n:"BrtBeginSparklineGroup"},0x0412:{n:"BrtEndSparklineGroup"},0x0413:{n:"BrtSparkline"},0x0414:{n:"BrtSXDI14"},0x0415:{n:"BrtWsFmtInfoEx14"},0x0416:{n:"BrtBeginConditionalFormatting14"},0x0417:{n:"BrtEndConditionalFormatting14"},0x0418:{n:"BrtBeginCFRule14"},0x0419:{n:"BrtEndCFRule14"},0x041A:{n:"BrtCFVO14"},0x041B:{n:"BrtBeginDatabar14"},0x041C:{n:"BrtBeginIconSet14"},0x041D:{n:"BrtDVal14",f:parse_BrtDVal14},0x041E:{n:"BrtBeginDVals14"},0x041F:{n:"BrtColor14"},0x0420:{n:"BrtBeginSparklines"},0x0421:{n:"BrtEndSparklines"},0x0422:{n:"BrtBeginSparklineGroups"},0x0423:{n:"BrtEndSparklineGroups"},0x0425:{n:"BrtSXVD14"},0x0426:{n:"BrtBeginSXView14"},0x0427:{n:"BrtEndSXView14"},0x0428:{n:"BrtBeginSXView16"},0x0429:{n:"BrtEndSXView16"},0x042A:{n:"BrtBeginPCD14"},0x042B:{n:"BrtEndPCD14"},0x042C:{n:"BrtBeginExtConn14"},0x042D:{n:"BrtEndExtConn14"},0x042E:{n:"BrtBeginSlicerCacheIDs"},0x042F:{n:"BrtEndSlicerCacheIDs"},0x0430:{n:"BrtBeginSlicerCacheID"},0x0431:{n:"BrtEndSlicerCacheID"},0x0433:{n:"BrtBeginSlicerCache"},0x0434:{n:"BrtEndSlicerCache"},0x0435:{n:"BrtBeginSlicerCacheDef"},0x0436:{n:"BrtEndSlicerCacheDef"},0x0437:{n:"BrtBeginSlicersEx"},0x0438:{n:"BrtEndSlicersEx"},0x0439:{n:"BrtBeginSlicerEx"},0x043A:{n:"BrtEndSlicerEx"},0x043B:{n:"BrtBeginSlicer"},0x043C:{n:"BrtEndSlicer"},0x043D:{n:"BrtSlicerCachePivotTables"},0x043E:{n:"BrtBeginSlicerCacheOlapImpl"},0x043F:{n:"BrtEndSlicerCacheOlapImpl"},0x0440:{n:"BrtBeginSlicerCacheLevelsData"},0x0441:{n:"BrtEndSlicerCacheLevelsData"},0x0442:{n:"BrtBeginSlicerCacheLevelData"},0x0443:{n:"BrtEndSlicerCacheLevelData"},0x0444:{n:"BrtBeginSlicerCacheSiRanges"},0x0445:{n:"BrtEndSlicerCacheSiRanges"},0x0446:{n:"BrtBeginSlicerCacheSiRange"},0x0447:{n:"BrtEndSlicerCacheSiRange"},0x0448:{n:"BrtSlicerCacheOlapItem"},0x0449:{n:"BrtBeginSlicerCacheSelections"},0x044A:{n:"BrtSlicerCacheSelection"},0x044B:{n:"BrtEndSlicerCacheSelections"},0x044C:{n:"BrtBeginSlicerCacheNative"},0x044D:{n:"BrtEndSlicerCacheNative"},0x044E:{n:"BrtSlicerCacheNativeItem"},0x044F:{n:"BrtRangeProtection14"},0x0450:{n:"BrtRangeProtectionIso14"},0x0451:{n:"BrtCellIgnoreEC14"},0x0457:{n:"BrtList14"},0x0458:{n:"BrtCFIcon"},0x0459:{n:"BrtBeginSlicerCachesPivotCacheIDs"},0x045A:{n:"BrtEndSlicerCachesPivotCacheIDs"},0x045B:{n:"BrtBeginSlicers"},0x045C:{n:"BrtEndSlicers"},0x045D:{n:"BrtWbProp14"},0x045E:{n:"BrtBeginSXEdit"},0x045F:{n:"BrtEndSXEdit"},0x0460:{n:"BrtBeginSXEdits"},0x0461:{n:"BrtEndSXEdits"},0x0462:{n:"BrtBeginSXChange"},0x0463:{n:"BrtEndSXChange"},0x0464:{n:"BrtBeginSXChanges"},0x0465:{n:"BrtEndSXChanges"},0x0466:{n:"BrtSXTupleItems"},0x0468:{n:"BrtBeginSlicerStyle"},0x0469:{n:"BrtEndSlicerStyle"},0x046A:{n:"BrtSlicerStyleElement"},0x046B:{n:"BrtBeginStyleSheetExt14"},0x046C:{n:"BrtEndStyleSheetExt14"},0x046D:{n:"BrtBeginSlicerCachesPivotCacheID"},0x046E:{n:"BrtEndSlicerCachesPivotCacheID"},0x046F:{n:"BrtBeginConditionalFormattings"},0x0470:{n:"BrtEndConditionalFormattings"},0x0471:{n:"BrtBeginPCDCalcMemExt"},0x0472:{n:"BrtEndPCDCalcMemExt"},0x0473:{n:"BrtBeginPCDCalcMemsExt"},0x0474:{n:"BrtEndPCDCalcMemsExt"},0x0475:{n:"BrtPCDField14"},0x0476:{n:"BrtBeginSlicerStyles"},0x0477:{n:"BrtEndSlicerStyles"},0x0478:{n:"BrtBeginSlicerStyleElements"},0x0479:{n:"BrtEndSlicerStyleElements"},0x047A:{n:"BrtCFRuleExt"},0x047B:{n:"BrtBeginSXCondFmt14"},0x047C:{n:"BrtEndSXCondFmt14"},0x047D:{n:"BrtBeginSXCondFmts14"},0x047E:{n:"BrtEndSXCondFmts14"},0x0480:{n:"BrtBeginSortCond14"},0x0481:{n:"BrtEndSortCond14"},0x0482:{n:"BrtEndDVals14"},0x0483:{n:"BrtEndIconSet14"},0x0484:{n:"BrtEndDatabar14"},0x0485:{n:"BrtBeginColorScale14"},0x0486:{n:"BrtEndColorScale14"},0x0487:{n:"BrtBeginSxrules14"},0x0488:{n:"BrtEndSxrules14"},0x0489:{n:"BrtBeginPRule14"},0x048A:{n:"BrtEndPRule14"},0x048B:{n:"BrtBeginPRFilters14"},0x048C:{n:"BrtEndPRFilters14"},0x048D:{n:"BrtBeginPRFilter14"},0x048E:{n:"BrtEndPRFilter14"},0x048F:{n:"BrtBeginPRFItem14"},0x0490:{n:"BrtEndPRFItem14"},0x0491:{n:"BrtBeginCellIgnoreECs14"},0x0492:{n:"BrtEndCellIgnoreECs14"},0x0493:{n:"BrtDxf14"},0x0494:{n:"BrtBeginDxF14s"},0x0495:{n:"BrtEndDxf14s"},0x0499:{n:"BrtFilter14"},0x049A:{n:"BrtBeginCustomFilters14"},0x049C:{n:"BrtCustomFilter14"},0x049D:{n:"BrtIconFilter14"},0x049E:{n:"BrtPivotCacheConnectionName"},0x0800:{n:"BrtBeginDecoupledPivotCacheIDs"},0x0801:{n:"BrtEndDecoupledPivotCacheIDs"},0x0802:{n:"BrtDecoupledPivotCacheID"},0x0803:{n:"BrtBeginPivotTableRefs"},0x0804:{n:"BrtEndPivotTableRefs"},0x0805:{n:"BrtPivotTableRef"},0x0806:{n:"BrtSlicerCacheBookPivotTables"},0x0807:{n:"BrtBeginSxvcells"},0x0808:{n:"BrtEndSxvcells"},0x0809:{n:"BrtBeginSxRow"},0x080A:{n:"BrtEndSxRow"},0x080C:{n:"BrtPcdCalcMem15"},0x0813:{n:"BrtQsi15"},0x0814:{n:"BrtBeginWebExtensions"},0x0815:{n:"BrtEndWebExtensions"},0x0816:{n:"BrtWebExtension"},0x0817:{n:"BrtAbsPath15"},0x0818:{n:"BrtBeginPivotTableUISettings"},0x0819:{n:"BrtEndPivotTableUISettings"},0x081B:{n:"BrtTableSlicerCacheIDs"},0x081C:{n:"BrtTableSlicerCacheID"},0x081D:{n:"BrtBeginTableSlicerCache"},0x081E:{n:"BrtEndTableSlicerCache"},0x081F:{n:"BrtSxFilter15"},0x0820:{n:"BrtBeginTimelineCachePivotCacheIDs"},0x0821:{n:"BrtEndTimelineCachePivotCacheIDs"},0x0822:{n:"BrtTimelineCachePivotCacheID"},0x0823:{n:"BrtBeginTimelineCacheIDs"},0x0824:{n:"BrtEndTimelineCacheIDs"},0x0825:{n:"BrtBeginTimelineCacheID"},0x0826:{n:"BrtEndTimelineCacheID"},0x0827:{n:"BrtBeginTimelinesEx"},0x0828:{n:"BrtEndTimelinesEx"},0x0829:{n:"BrtBeginTimelineEx"},0x082A:{n:"BrtEndTimelineEx"},0x082B:{n:"BrtWorkBookPr15"},0x082C:{n:"BrtPCDH15"},0x082D:{n:"BrtBeginTimelineStyle"},0x082E:{n:"BrtEndTimelineStyle"},0x082F:{n:"BrtTimelineStyleElement"},0x0830:{n:"BrtBeginTimelineStylesheetExt15"},0x0831:{n:"BrtEndTimelineStylesheetExt15"},0x0832:{n:"BrtBeginTimelineStyles"},0x0833:{n:"BrtEndTimelineStyles"},0x0834:{n:"BrtBeginTimelineStyleElements"},0x0835:{n:"BrtEndTimelineStyleElements"},0x0836:{n:"BrtDxf15"},0x0837:{n:"BrtBeginDxfs15"},0x0838:{n:"brtEndDxfs15"},0x0839:{n:"BrtSlicerCacheHideItemsWithNoData"},0x083A:{n:"BrtBeginItemUniqueNames"},0x083B:{n:"BrtEndItemUniqueNames"},0x083C:{n:"BrtItemUniqueName"},0x083D:{n:"BrtBeginExtConn15"},0x083E:{n:"BrtEndExtConn15"},0x083F:{n:"BrtBeginOledbPr15"},0x0840:{n:"BrtEndOledbPr15"},0x0841:{n:"BrtBeginDataFeedPr15"},0x0842:{n:"BrtEndDataFeedPr15"},0x0843:{n:"BrtTextPr15"},0x0844:{n:"BrtRangePr15"},0x0845:{n:"BrtDbCommand15"},0x0846:{n:"BrtBeginDbTables15"},0x0847:{n:"BrtEndDbTables15"},0x0848:{n:"BrtDbTable15"},0x0849:{n:"BrtBeginDataModel"},0x084A:{n:"BrtEndDataModel"},0x084B:{n:"BrtBeginModelTables"},0x084C:{n:"BrtEndModelTables"},0x084D:{n:"BrtModelTable"},0x084E:{n:"BrtBeginModelRelationships"},0x084F:{n:"BrtEndModelRelationships"},0x0850:{n:"BrtModelRelationship"},0x0851:{n:"BrtBeginECTxtWiz15"},0x0852:{n:"BrtEndECTxtWiz15"},0x0853:{n:"BrtBeginECTWFldInfoLst15"},0x0854:{n:"BrtEndECTWFldInfoLst15"},0x0855:{n:"BrtBeginECTWFldInfo15"},0x0856:{n:"BrtFieldListActiveItem"},0x0857:{n:"BrtPivotCacheIdVersion"},0x0858:{n:"BrtSXDI15"},0x0859:{n:"BrtBeginModelTimeGroupings"},0x085A:{n:"BrtEndModelTimeGroupings"},0x085B:{n:"BrtBeginModelTimeGrouping"},0x085C:{n:"BrtEndModelTimeGrouping"},0x085D:{n:"BrtModelTimeGroupingCalcCol"},0x0C00:{n:"BrtUid"},0x0C01:{n:"BrtRevisionPtr"},0x13e7:{n:"BrtBeginCalcFeatures"},0x13e8:{n:"BrtEndCalcFeatures"},0x13e9:{n:"BrtCalcFeature"},0xFFFF:{n:""}};var XLSBRE=evert_key(XLSBRecordEnum,'n');/*jshint -W069 */XLSBRE["BrtFRTArchID$"]=0x0010;/*jshint +W069 */ /* [MS-XLS] 2.3 Record Enumeration (and other sources) */var XLSRecordEnum={/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */0x0006:{n:"Formula",f:parse_Formula},0x000a:{n:'EOF',f:parsenoop2},0x000c:{n:"CalcCount",f:parseuint16},0x000d:{n:"CalcMode",f:parseuint16},0x000e:{n:"CalcPrecision",f:parsebool},0x000f:{n:"CalcRefMode",f:parsebool},0x0010:{n:"CalcDelta",f:parse_Xnum},0x0011:{n:"CalcIter",f:parsebool},0x0012:{n:"Protect",f:parsebool},0x0013:{n:"Password",f:parseuint16},0x0014:{n:"Header",f:parse_XLHeaderFooter},0x0015:{n:"Footer",f:parse_XLHeaderFooter},0x0017:{n:"ExternSheet",f:parse_ExternSheet},0x0018:{n:"Lbl",f:parse_Lbl},0x0019:{n:"WinProtect",f:parsebool},0x001a:{n:"VerticalPageBreaks"},0x001b:{n:"HorizontalPageBreaks"},0x001c:{n:"Note",f:parse_Note},0x001d:{n:"Selection"},0x0022:{n:"Date1904",f:parsebool},0x0023:{n:"ExternName",f:parse_ExternName},0x0026:{n:"LeftMargin",f:parse_Xnum},0x0027:{n:"RightMargin",f:parse_Xnum},0x0028:{n:"TopMargin",f:parse_Xnum},0x0029:{n:"BottomMargin",f:parse_Xnum},0x002a:{n:"PrintRowCol",f:parsebool},0x002b:{n:"PrintGrid",f:parsebool},0x002f:{n:"FilePass",f:parse_FilePass},0x0031:{n:"Font",f:parse_Font},0x0033:{n:"PrintSize",f:parseuint16},0x003c:{n:"Continue"},0x003d:{n:"Window1",f:parse_Window1},0x0040:{n:"Backup",f:parsebool},0x0041:{n:"Pane",f:parse_Pane},0x0042:{n:'CodePage',f:parseuint16},0x004d:{n:"Pls"},0x0050:{n:"DCon"},0x0051:{n:"DConRef"},0x0052:{n:"DConName"},0x0055:{n:"DefColWidth",f:parseuint16},0x0059:{n:"XCT"},0x005a:{n:"CRN"},0x005b:{n:"FileSharing"},0x005c:{n:'WriteAccess',f:parse_WriteAccess},0x005d:{n:"Obj",f:parse_Obj},0x005e:{n:"Uncalced"},0x005f:{n:"CalcSaveRecalc",f:parsebool},0x0060:{n:"Template"},0x0061:{n:"Intl"},0x0063:{n:"ObjProtect",f:parsebool},0x007d:{n:"ColInfo",f:parse_ColInfo},0x0080:{n:"Guts",f:parse_Guts},0x0081:{n:"WsBool",f:parse_WsBool},0x0082:{n:"GridSet",f:parseuint16},0x0083:{n:"HCenter",f:parsebool},0x0084:{n:"VCenter",f:parsebool},0x0085:{n:'BoundSheet8',f:parse_BoundSheet8},0x0086:{n:"WriteProtect"},0x008c:{n:"Country",f:parse_Country},0x008d:{n:"HideObj",f:parseuint16},0x0090:{n:"Sort"},0x0092:{n:"Palette",f:parse_Palette},0x0097:{n:"Sync"},0x0098:{n:"LPr"},0x0099:{n:"DxGCol"},0x009a:{n:"FnGroupName"},0x009b:{n:"FilterMode"},0x009c:{n:"BuiltInFnGroupCount",f:parseuint16},0x009d:{n:"AutoFilterInfo"},0x009e:{n:"AutoFilter"},0x00a0:{n:"Scl",f:parse_Scl},0x00a1:{n:"Setup",f:parse_Setup},0x00ae:{n:"ScenMan"},0x00af:{n:"SCENARIO"},0x00b0:{n:"SxView"},0x00b1:{n:"Sxvd"},0x00b2:{n:"SXVI"},0x00b4:{n:"SxIvd"},0x00b5:{n:"SXLI"},0x00b6:{n:"SXPI"},0x00b8:{n:"DocRoute"},0x00b9:{n:"RecipName"},0x00bd:{n:"MulRk",f:parse_MulRk},0x00be:{n:"MulBlank",f:parse_MulBlank},0x00c1:{n:'Mms',f:parsenoop2},0x00c5:{n:"SXDI"},0x00c6:{n:"SXDB"},0x00c7:{n:"SXFDB"},0x00c8:{n:"SXDBB"},0x00c9:{n:"SXNum"},0x00ca:{n:"SxBool",f:parsebool},0x00cb:{n:"SxErr"},0x00cc:{n:"SXInt"},0x00cd:{n:"SXString"},0x00ce:{n:"SXDtr"},0x00cf:{n:"SxNil"},0x00d0:{n:"SXTbl"},0x00d1:{n:"SXTBRGIITM"},0x00d2:{n:"SxTbpg"},0x00d3:{n:"ObProj"},0x00d5:{n:"SXStreamID"},0x00d7:{n:"DBCell"},0x00d8:{n:"SXRng"},0x00d9:{n:"SxIsxoper"},0x00da:{n:"BookBool",f:parseuint16},0x00dc:{n:"DbOrParamQry"},0x00dd:{n:"ScenarioProtect",f:parsebool},0x00de:{n:"OleObjectSize"},0x00e0:{n:"XF",f:parse_XF},0x00e1:{n:'InterfaceHdr',f:parse_InterfaceHdr},0x00e2:{n:'InterfaceEnd',f:parsenoop2},0x00e3:{n:"SXVS"},0x00e5:{n:"MergeCells",f:parse_MergeCells},0x00e9:{n:"BkHim"},0x00eb:{n:"MsoDrawingGroup"},0x00ec:{n:"MsoDrawing"},0x00ed:{n:"MsoDrawingSelection"},0x00ef:{n:"PhoneticInfo"},0x00f0:{n:"SxRule"},0x00f1:{n:"SXEx"},0x00f2:{n:"SxFilt"},0x00f4:{n:"SxDXF"},0x00f5:{n:"SxItm"},0x00f6:{n:"SxName"},0x00f7:{n:"SxSelect"},0x00f8:{n:"SXPair"},0x00f9:{n:"SxFmla"},0x00fb:{n:"SxFormat"},0x00fc:{n:"SST",f:parse_SST},0x00fd:{n:"LabelSst",f:parse_LabelSst},0x00ff:{n:"ExtSST",f:parse_ExtSST},0x0100:{n:"SXVDEx"},0x0103:{n:"SXFormula"},0x0122:{n:"SXDBEx"},0x0137:{n:"RRDInsDel"},0x0138:{n:"RRDHead"},0x013b:{n:"RRDChgCell"},0x013d:{n:"RRTabId",f:parseuint16a},0x013e:{n:"RRDRenSheet"},0x013f:{n:"RRSort"},0x0140:{n:"RRDMove"},0x014a:{n:"RRFormat"},0x014b:{n:"RRAutoFmt"},0x014d:{n:"RRInsertSh"},0x014e:{n:"RRDMoveBegin"},0x014f:{n:"RRDMoveEnd"},0x0150:{n:"RRDInsDelBegin"},0x0151:{n:"RRDInsDelEnd"},0x0152:{n:"RRDConflict"},0x0153:{n:"RRDDefName"},0x0154:{n:"RRDRstEtxp"},0x015f:{n:"LRng"},0x0160:{n:"UsesELFs",f:parsebool},0x0161:{n:"DSF",f:parsenoop2},0x0191:{n:"CUsr"},0x0192:{n:"CbUsr"},0x0193:{n:"UsrInfo"},0x0194:{n:"UsrExcl"},0x0195:{n:"FileLock"},0x0196:{n:"RRDInfo"},0x0197:{n:"BCUsrs"},0x0198:{n:"UsrChk"},0x01a9:{n:"UserBView"},0x01aa:{n:"UserSViewBegin"},0x01ab:{n:"UserSViewEnd"},0x01ac:{n:"RRDUserView"},0x01ad:{n:"Qsi"},0x01ae:{n:"SupBook",f:parse_SupBook},0x01af:{n:"Prot4Rev",f:parsebool},0x01b0:{n:"CondFmt"},0x01b1:{n:"CF"},0x01b2:{n:"DVal"},0x01b5:{n:"DConBin"},0x01b6:{n:"TxO",f:parse_TxO},0x01b7:{n:"RefreshAll",f:parsebool},0x01b8:{n:"HLink",f:parse_HLink},0x01b9:{n:"Lel"},0x01ba:{n:"CodeName",f:parse_XLUnicodeString},0x01bb:{n:"SXFDBType"},0x01bc:{n:"Prot4RevPass",f:parseuint16},0x01bd:{n:"ObNoMacros"},0x01be:{n:"Dv"},0x01c0:{n:"Excel9File",f:parsenoop2},0x01c1:{n:"RecalcId",f:parse_RecalcId,r:2},0x01c2:{n:"EntExU2",f:parsenoop2},0x0200:{n:"Dimensions",f:parse_Dimensions},0x0201:{n:"Blank",f:parse_Blank},0x0203:{n:"Number",f:parse_Number},0x0204:{n:"Label",f:parse_Label},0x0205:{n:"BoolErr",f:parse_BoolErr},0x0207:{n:"String",f:parse_String},0x0208:{n:'Row',f:parse_Row},0x020b:{n:"Index"},0x0221:{n:"Array",f:parse_Array},0x0225:{n:"DefaultRowHeight",f:parse_DefaultRowHeight},0x0236:{n:"Table"},0x023e:{n:"Window2",f:parse_Window2},0x027e:{n:"RK",f:parse_RK},0x0293:{n:"Style"},0x0418:{n:"BigName"},0x041e:{n:"Format",f:parse_Format},0x043c:{n:"ContinueBigName"},0x04bc:{n:"ShrFmla",f:parse_ShrFmla},0x0800:{n:"HLinkTooltip",f:parse_HLinkTooltip},0x0801:{n:"WebPub"},0x0802:{n:"QsiSXTag"},0x0803:{n:"DBQueryExt"},0x0804:{n:"ExtString"},0x0805:{n:"TxtQry"},0x0806:{n:"Qsir"},0x0807:{n:"Qsif"},0x0808:{n:"RRDTQSIF"},0x0809:{n:'BOF',f:parse_BOF},0x080a:{n:"OleDbConn"},0x080b:{n:"WOpt"},0x080c:{n:"SXViewEx"},0x080d:{n:"SXTH"},0x080e:{n:"SXPIEx"},0x080f:{n:"SXVDTEx"},0x0810:{n:"SXViewEx9"},0x0812:{n:"ContinueFrt"},0x0813:{n:"RealTimeData"},0x0850:{n:"ChartFrtInfo"},0x0851:{n:"FrtWrapper"},0x0852:{n:"StartBlock"},0x0853:{n:"EndBlock"},0x0854:{n:"StartObject"},0x0855:{n:"EndObject"},0x0856:{n:"CatLab"},0x0857:{n:"YMult"},0x0858:{n:"SXViewLink"},0x0859:{n:"PivotChartBits"},0x085a:{n:"FrtFontList"},0x0862:{n:"SheetExt"},0x0863:{n:"BookExt",r:12},0x0864:{n:"SXAddl"},0x0865:{n:"CrErr"},0x0866:{n:"HFPicture"},0x0867:{n:'FeatHdr',f:parsenoop2},0x0868:{n:"Feat"},0x086a:{n:"DataLabExt"},0x086b:{n:"DataLabExtContents"},0x086c:{n:"CellWatch"},0x0871:{n:"FeatHdr11"},0x0872:{n:"Feature11"},0x0874:{n:"DropDownObjIds"},0x0875:{n:"ContinueFrt11"},0x0876:{n:"DConn"},0x0877:{n:"List12"},0x0878:{n:"Feature12"},0x0879:{n:"CondFmt12"},0x087a:{n:"CF12"},0x087b:{n:"CFEx"},0x087c:{n:"XFCRC",f:parse_XFCRC,r:12},0x087d:{n:"XFExt",f:parse_XFExt,r:12},0x087e:{n:"AutoFilter12"},0x087f:{n:"ContinueFrt12"},0x0884:{n:"MDTInfo"},0x0885:{n:"MDXStr"},0x0886:{n:"MDXTuple"},0x0887:{n:"MDXSet"},0x0888:{n:"MDXProp"},0x0889:{n:"MDXKPI"},0x088a:{n:"MDB"},0x088b:{n:"PLV"},0x088c:{n:"Compat12",f:parsebool,r:12},0x088d:{n:"DXF"},0x088e:{n:"TableStyles",r:12},0x088f:{n:"TableStyle"},0x0890:{n:"TableStyleElement"},0x0892:{n:"StyleExt"},0x0893:{n:"NamePublish"},0x0894:{n:"NameCmt",f:parse_NameCmt,r:12},0x0895:{n:"SortData"},0x0896:{n:"Theme",f:parse_Theme,r:12},0x0897:{n:"GUIDTypeLib"},0x0898:{n:"FnGrp12"},0x0899:{n:"NameFnGrp12"},0x089a:{n:"MTRSettings",f:parse_MTRSettings,r:12},0x089b:{n:"CompressPictures",f:parsenoop2},0x089c:{n:"HeaderFooter"},0x089d:{n:"CrtLayout12"},0x089e:{n:"CrtMlFrt"},0x089f:{n:"CrtMlFrtContinue"},0x08a3:{n:"ForceFullCalculation",f:parse_ForceFullCalculation},0x08a4:{n:"ShapePropsStream"},0x08a5:{n:"TextPropsStream"},0x08a6:{n:"RichTextStream"},0x08a7:{n:"CrtLayout12A"},0x1001:{n:"Units"},0x1002:{n:"Chart"},0x1003:{n:"Series"},0x1006:{n:"DataFormat"},0x1007:{n:"LineFormat"},0x1009:{n:"MarkerFormat"},0x100a:{n:"AreaFormat"},0x100b:{n:"PieFormat"},0x100c:{n:"AttachedLabel"},0x100d:{n:"SeriesText"},0x1014:{n:"ChartFormat"},0x1015:{n:"Legend"},0x1016:{n:"SeriesList"},0x1017:{n:"Bar"},0x1018:{n:"Line"},0x1019:{n:"Pie"},0x101a:{n:"Area"},0x101b:{n:"Scatter"},0x101c:{n:"CrtLine"},0x101d:{n:"Axis"},0x101e:{n:"Tick"},0x101f:{n:"ValueRange"},0x1020:{n:"CatSerRange"},0x1021:{n:"AxisLine"},0x1022:{n:"CrtLink"},0x1024:{n:"DefaultText"},0x1025:{n:"Text"},0x1026:{n:"FontX",f:parseuint16},0x1027:{n:"ObjectLink"},0x1032:{n:"Frame"},0x1033:{n:"Begin"},0x1034:{n:"End"},0x1035:{n:"PlotArea"},0x103a:{n:"Chart3d"},0x103c:{n:"PicF"},0x103d:{n:"DropBar"},0x103e:{n:"Radar"},0x103f:{n:"Surf"},0x1040:{n:"RadarArea"},0x1041:{n:"AxisParent"},0x1043:{n:"LegendException"},0x1044:{n:"ShtProps",f:parse_ShtProps},0x1045:{n:"SerToCrt"},0x1046:{n:"AxesUsed"},0x1048:{n:"SBaseRef"},0x104a:{n:"SerParent"},0x104b:{n:"SerAuxTrend"},0x104e:{n:"IFmtRecord"},0x104f:{n:"Pos"},0x1050:{n:"AlRuns"},0x1051:{n:"BRAI"},0x105b:{n:"SerAuxErrBar"},0x105c:{n:"ClrtClient",f:parse_ClrtClient},0x105d:{n:"SerFmt"},0x105f:{n:"Chart3DBarShape"},0x1060:{n:"Fbi"},0x1061:{n:"BopPop"},0x1062:{n:"AxcExt"},0x1063:{n:"Dat"},0x1064:{n:"PlotGrowth"},0x1065:{n:"SIIndex"},0x1066:{n:"GelFrame"},0x1067:{n:"BopPopCustom"},0x1068:{n:"Fbi2"},0x0000:{n:"Dimensions",f:parse_Dimensions},0x0001:{n:"BIFF2BLANK"},0x0002:{n:"BIFF2INT",f:parse_BIFF2INT},0x0003:{n:"BIFF2NUM",f:parse_BIFF2NUM},0x0004:{n:"BIFF2STR",f:parse_BIFF2STR},0x0005:{n:"BoolErr",f:parse_BoolErr},0x0007:{n:"String",f:parse_BIFF2STRING},0x0008:{n:"BIFF2ROW"},0x0009:{n:'BOF',f:parse_BOF},0x000b:{n:"Index"},0x0016:{n:"ExternCount",f:parseuint16},0x001e:{n:"BIFF2FORMAT",f:parse_BIFF2Format},0x001f:{n:"BIFF2FMTCNT"},/* 16-bit cnt of BIFF2FORMAT records */0x0020:{n:"BIFF2COLINFO"},0x0021:{n:"Array",f:parse_Array},0x0024:{n:"COLWIDTH"},0x0025:{n:"DefaultRowHeight",f:parse_DefaultRowHeight},// 0x2c ??
// 0x2d ??
// 0x2e ??
// 0x30 FONTCOUNT: number of fonts
0x0032:{n:"BIFF2FONTXTRA",f:parse_BIFF2FONTXTRA},// 0x35: INFOOPTS
// 0x36: TABLE (BIFF2 only)
// 0x37: TABLE2 (BIFF2 only)
// 0x38: WNDESK
// 0x39 ??
// 0x3a: BEGINPREF
// 0x3b: ENDPREF
0x003e:{n:"BIFF2WINDOW2"},// 0x3f ??
// 0x46: SHOWSCROLL
// 0x47: SHOWFORMULA
// 0x48: STATUSBAR
// 0x49: SHORTMENUS
// 0x4A:
// 0x4B:
// 0x4C:
// 0x4E:
// 0x4F:
// 0x58: TOOLBAR (BIFF3)
/* - - - */0x0034:{n:"DDEObjName"},0x0043:{n:"BIFF2XF"},0x0044:{n:"BIFF2XFINDEX",f:parseuint16},0x0045:{n:"BIFF2FONTCLR"},0x0056:{n:"BIFF4FMTCNT"},/* 16-bit cnt, similar to BIFF2 */0x007e:{n:"RK"},/* Not necessarily same as 0x027e */0x007f:{n:"ImData",f:parse_ImData},0x0087:{n:"Addin"},0x0088:{n:"Edg"},0x0089:{n:"Pub"},// 0x8A
// 0x8B LH: alternate menu key flag (BIFF3/4)
// 0x8E
// 0x8F
0x0091:{n:"Sub"},// 0x93 STYLE
0x0094:{n:"LHRecord"},0x0095:{n:"LHNGraph"},0x0096:{n:"Sound"},// 0xA2 FNPROTO: function prototypes (BIFF4)
// 0xA3
// 0xA8
0x00a9:{n:"CoordList"},0x00ab:{n:"GCW"},0x00bc:{n:"ShrFmla"},/* Not necessarily same as 0x04bc */0x00bf:{n:"ToolbarHdr"},0x00c0:{n:"ToolbarEnd"},0x00c2:{n:"AddMenu"},0x00c3:{n:"DelMenu"},0x00d6:{n:"RString",f:parse_RString},0x00df:{n:"UDDesc"},0x00ea:{n:"TabIdConf"},0x0162:{n:"XL5Modify"},0x01a5:{n:"FileSharing2"},0x0206:{n:"Formula",f:parse_Formula},0x0209:{n:'BOF',f:parse_BOF},0x0218:{n:"Lbl",f:parse_Lbl},0x0223:{n:"ExternName",f:parse_ExternName},0x0231:{n:"Font"},0x0243:{n:"BIFF3XF"},0x0406:{n:"Formula",f:parse_Formula},0x0409:{n:'BOF',f:parse_BOF},0x0443:{n:"BIFF4XF"},0x086d:{n:"FeatInfo"},0x0873:{n:"FeatInfo11"},0x0881:{n:"SXAddl12"},0x08c0:{n:"AutoWebPub"},0x08c1:{n:"ListObj"},0x08c2:{n:"ListField"},0x08c3:{n:"ListDV"},0x08c4:{n:"ListCondFmt"},0x08c5:{n:"ListCF"},0x08c6:{n:"FMQry"},0x08c7:{n:"FMSQry"},0x08c8:{n:"PLV"},0x08c9:{n:"LnExt"},0x08ca:{n:"MkrExt"},0x08cb:{n:"CrtCoopt"},0x08d6:{n:"FRTArchId$",r:12},0x7262:{}};var XLSRE=evert_key(XLSRecordEnum,'n');function write_biff_rec(ba,type,payload,length){var t=typeof type=="number"?type:+type||+XLSRE[type];if(isNaN(t))return;var len=length||(payload||[]).length||0;var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,len);if(len>0&&is_buf(payload))ba.push(payload);}function write_biff_continue(ba,type,payload,length){var len=length||(payload||[]).length||0;if(len<=8224)return write_biff_rec(ba,type,payload,len);var t=+type||+XLSRE[type];if(isNaN(t))return;var parts=payload.parts||[],sidx=0;var i=0,w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;while(i<len){o=ba.next(4);o.write_shift(2,0x3c);// TODO: figure out correct continue type
w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;}}function write_BIFF2Cell(out,r,c){if(!out)out=new_buf(7);out.write_shift(2,r);out.write_shift(2,c);out.write_shift(2,0);out.write_shift(1,0);return out;}function write_BIFF2BERR(r,c,val,t){var out=new_buf(9);write_BIFF2Cell(out,r,c);write_Bes(val,t||'b',out);return out;}/* TODO: codepage, large strings */function write_BIFF2LABEL(r,c,val){var out=new_buf(8+2*val.length);write_BIFF2Cell(out,r,c);out.write_shift(1,val.length);out.write_shift(val.length,val,'sbcs');return out.l<out.length?out.slice(0,out.l):out;}function write_ws_biff2_cell(ba,cell,R,C){if(cell.v!=null)switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;if(v==(v|0)&&v>=0&&v<65536)write_biff_rec(ba,0x0002,write_BIFF2INT(R,C,v));else write_biff_rec(ba,0x0003,write_BIFF2NUM(R,C,v));return;case'b':case'e':write_biff_rec(ba,0x0005,write_BIFF2BERR(R,C,cell.v,cell.t));return;/* TODO: codepage, sst */case's':case'str':write_biff_rec(ba,0x0004,write_BIFF2LABEL(R,C,(cell.v||"").slice(0,255)));return;}write_biff_rec(ba,0x0001,write_BIFF2Cell(null,R,C));}function write_ws_biff2(ba,ws,idx,opts){var dense=Array.isArray(ws);var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols=[];if(range.e.c>0xFF||range.e.r>0x3FFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,0x3FFF);ref=encode_range(range);}for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff2_cell(ba,cell,R,C,opts);}}}/* Based on test files */function write_biff2_buf(wb,opts){var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ba=buf_array();var idx=0;for(var i=0;i<wb.SheetNames.length;++i)if(wb.SheetNames[i]==o.sheet)idx=i;if(idx==0&&!!o.sheet&&wb.SheetNames[0]!=o.sheet)throw new Error("Sheet not found: "+o.sheet);write_biff_rec(ba,o.biff==4?0x0409:o.biff==3?0x0209:0x0009,write_BOF(wb,0x10,o));/* ... */write_ws_biff2(ba,wb.Sheets[wb.SheetNames[idx]],idx,o,wb);/* ... */write_biff_rec(ba,0x000A);return ba.end();}function write_FONTS_biff8(ba,data,opts){write_biff_rec(ba,"Font",write_Font({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},opts));}function write_FMTS_biff8(ba,NF,opts){if(!NF)return;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!=null)write_biff_rec(ba,"Format",write_Format(i,NF[i],opts));});}function write_FEAT(ba,ws){/* [MS-XLS] 2.4.112 */var o=new_buf(19);o.write_shift(4,0x867);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,1);o.write_shift(4,0);write_biff_rec(ba,"FeatHdr",o);/* [MS-XLS] 2.4.111 */o=new_buf(39);o.write_shift(4,0x868);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,0);o.write_shift(4,0);o.write_shift(2,1);o.write_shift(4,4);o.write_shift(2,0);write_Ref8U(safe_decode_range(ws['!ref']||"A1"),o);o.write_shift(4,4);write_biff_rec(ba,"Feat",o);}function write_CELLXFS_biff8(ba,opts){for(var i=0;i<16;++i)write_biff_rec(ba,"XF",write_XF({numFmtId:0,style:true},0,opts));opts.cellXfs.forEach(function(c){write_biff_rec(ba,"XF",write_XF(c,0,opts));});}function write_ws_biff8_hlinks(ba,ws){for(var R=0;R<ws['!links'].length;++R){var HL=ws['!links'][R];write_biff_rec(ba,"HLink",write_HLink(HL));if(HL[1].Tooltip)write_biff_rec(ba,"HLinkTooltip",write_HLinkTooltip(HL));}delete ws['!links'];}function write_ws_cols_biff8(ba,cols,ws){if(!cols)return;var cnt=0;cols.forEach(function(col,idx){if(++cnt<=256&&col){write_biff_rec(ba,"ColInfo",write_ColInfo(col_obj_w(idx,col),idx));}});}function write_ws_biff8_cell(ba,cell,R,C,opts){var os=16+get_cell_style(opts.cellXfs,cell,opts);if(cell.v==null&&!cell.bf){write_biff_rec(ba,"Blank",write_XLSCell(R,C,os));return;}if(cell.bf)write_biff_rec(ba,"Formula",write_Formula(cell,R,C,opts,os));else switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;/* TODO: emit RK as appropriate */write_biff_rec(ba,"Number",write_Number(R,C,v,os,opts));break;case'b':case'e':write_biff_rec(ba,0x0205,write_BoolErr(R,C,cell.v,os,opts,cell.t));break;/* TODO: codepage, sst */case's':case'str':if(opts.bookSST){var isst=get_sst_id(opts.Strings,cell.v,opts.revStrings);write_biff_rec(ba,"LabelSst",write_LabelSst(R,C,isst,os,opts));}else write_biff_rec(ba,"Label",write_Label(R,C,(cell.v||"").slice(0,255),os,opts));break;default:write_biff_rec(ba,"Blank",write_XLSCell(R,C,os));}}/* [MS-XLS] 2.1.7.20.5 */function write_ws_biff8(idx,opts,wb){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var _WB=(wb||{}).Workbook||{};var _sheet=(_WB.Sheets||[])[idx]||{};var dense=Array.isArray(ws);var b8=opts.biff==8;var ref,rr="",cols=[];var range=safe_decode_range(ws['!ref']||"A1");var MAX_ROWS=b8?65536:16384;if(range.e.c>0xFF||range.e.r>=MAX_ROWS){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,MAX_ROWS-1);}write_biff_rec(ba,0x0809,write_BOF(wb,0x10,opts));/* [Uncalced] Index */write_biff_rec(ba,"CalcMode",writeuint16(1));write_biff_rec(ba,"CalcCount",writeuint16(100));write_biff_rec(ba,"CalcRefMode",writebool(true));write_biff_rec(ba,"CalcIter",writebool(false));write_biff_rec(ba,"CalcDelta",write_Xnum(0.001));write_biff_rec(ba,"CalcSaveRecalc",writebool(true));write_biff_rec(ba,"PrintRowCol",writebool(false));write_biff_rec(ba,"PrintGrid",writebool(false));write_biff_rec(ba,"GridSet",writeuint16(1));write_biff_rec(ba,"Guts",write_Guts([0,0]));/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */write_biff_rec(ba,"HCenter",writebool(false));write_biff_rec(ba,"VCenter",writebool(false));/* ... */if(b8)write_ws_cols_biff8(ba,ws["!cols"],ws);/* ... */write_biff_rec(ba,0x200,write_Dimensions(range,opts));/* ... */if(b8)ws['!links']=[];for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff8_cell(ba,cell,R,C,opts);if(b8&&cell.l)ws['!links'].push([ref,cell.l]);}}var cname=_sheet.CodeName||_sheet.name||s;/* ... */if(b8)write_biff_rec(ba,"Window2",write_Window2((_WB.Views||[])[0]));/* ... */if(b8&&(ws['!merges']||[]).length)write_biff_rec(ba,"MergeCells",write_MergeCells(ws['!merges']));/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */if(b8)write_ws_biff8_hlinks(ba,ws);/* [DVAL] */write_biff_rec(ba,"CodeName",write_XLUnicodeString(cname,opts));/* *WebPub *CellWatch [SheetExt] */if(b8)write_FEAT(ba,ws);/* *FEAT11 *RECORD12 */write_biff_rec(ba,"EOF");return ba.end();}/* [MS-XLS] 2.1.7.20.3 */function write_biff8_global(wb,bufs,opts){var A=buf_array();var _WB=(wb||{}).Workbook||{};var _sheets=_WB.Sheets||[];var _wb=_WB.WBProps||{};var b8=opts.biff==8,b5=opts.biff==5;write_biff_rec(A,0x0809,write_BOF(wb,0x05,opts));if(opts.bookType=="xla")write_biff_rec(A,"Addin");write_biff_rec(A,"InterfaceHdr",b8?writeuint16(0x04b0):null);write_biff_rec(A,"Mms",writezeroes(2));if(b5)write_biff_rec(A,"ToolbarHdr");if(b5)write_biff_rec(A,"ToolbarEnd");write_biff_rec(A,"InterfaceEnd");write_biff_rec(A,"WriteAccess",write_WriteAccess("SheetJS",opts));/* [FileSharing] */write_biff_rec(A,"CodePage",writeuint16(b8?0x04b0:0x04E4));/* *2047 Lel */if(b8)write_biff_rec(A,"DSF",writeuint16(0));if(b8)write_biff_rec(A,"Excel9File");write_biff_rec(A,"RRTabId",write_RRTabId(wb.SheetNames.length));if(b8&&wb.vbaraw)write_biff_rec(A,"ObProj");/* [ObNoMacros] */if(b8&&wb.vbaraw){var cname=_wb.CodeName||"ThisWorkbook";write_biff_rec(A,"CodeName",write_XLUnicodeString(cname,opts));}write_biff_rec(A,"BuiltInFnGroupCount",writeuint16(0x11));/* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */write_biff_rec(A,"WinProtect",writebool(false));write_biff_rec(A,"Protect",writebool(false));write_biff_rec(A,"Password",writeuint16(0));if(b8)write_biff_rec(A,"Prot4Rev",writebool(false));if(b8)write_biff_rec(A,"Prot4RevPass",writeuint16(0));write_biff_rec(A,"Window1",write_Window1(opts));write_biff_rec(A,"Backup",writebool(false));write_biff_rec(A,"HideObj",writeuint16(0));write_biff_rec(A,"Date1904",writebool(safe1904(wb)=="true"));write_biff_rec(A,"CalcPrecision",writebool(true));if(b8)write_biff_rec(A,"RefreshAll",writebool(false));write_biff_rec(A,"BookBool",writeuint16(0));/* ... */write_FONTS_biff8(A,wb,opts);write_FMTS_biff8(A,wb.SSF,opts);write_CELLXFS_biff8(A,opts);/* ... */if(b8)write_biff_rec(A,"UsesELFs",writebool(false));var a=A.end();var C=buf_array();/* METADATA [MTRSettings] [ForceFullCalculation] */if(b8)write_biff_rec(C,"Country",write_Country());/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */if(b8&&opts.Strings)write_biff_continue(C,"SST",write_SST(opts.Strings,opts));/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */write_biff_rec(C,"EOF");var c=C.end();var B=buf_array();var blen=0,j=0;for(j=0;j<wb.SheetNames.length;++j)blen+=(b8?12:11)+(b8?2:1)*wb.SheetNames[j].length;var start=a.length+blen+c.length;for(j=0;j<wb.SheetNames.length;++j){var _sheet=_sheets[j]||{};write_biff_rec(B,"BoundSheet8",write_BoundSheet8({pos:start,hs:_sheet.Hidden||0,dt:0,name:wb.SheetNames[j]},opts));start+=bufs[j].length;}/* 1*BoundSheet8 */var b=B.end();if(blen!=b.length)throw new Error("BS8 "+blen+" != "+b.length);var out=[];if(a.length)out.push(a);if(b.length)out.push(b);if(c.length)out.push(c);return __toBuffer([out]);}/* [MS-XLS] 2.1.7.20 Workbook Stream */function write_biff8_buf(wb,opts){var o=opts||{};var bufs=[];if(wb&&!wb.SSF){wb.SSF=SSF.get_table();}if(wb&&wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
o.revssf=evert_num(wb.SSF);o.revssf[wb.SSF[65535]]=0;o.ssf=wb.SSF;}o.Strings=[];o.Strings.Count=0;o.Strings.Unique=0;fix_write_opts(o);o.cellXfs=[];get_cell_style(o.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};for(var i=0;i<wb.SheetNames.length;++i)bufs[bufs.length]=write_ws_biff8(i,o,wb);bufs.unshift(write_biff8_global(wb,bufs,o));return __toBuffer([bufs]);}function write_biff_buf(wb,opts){for(var i=0;i<=wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=decode_range(ws["!ref"]);if(range.e.c>255){// note: 255 is IV
console.error("Worksheet '"+wb.SheetNames[i]+"' extends beyond column IV (255).  Data may be lost.");}}var o=opts||{};switch(o.biff||2){case 8:case 5:return write_biff8_buf(wb,opts);case 4:case 3:case 2:return write_biff2_buf(wb,opts);}throw new Error("invalid type "+o.bookType+" for BIFF");}/* note: browser DOM element cannot see mso- style attrs, must parse */var HTML_=function(){function html_to_sheet(str,_opts){var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var ws=opts.dense?[]:{};str=str.replace(/<!--.*?-->/g,"");var mtch=str.match(/<table/i);if(!mtch)throw new Error("Invalid HTML: could not find <table>");var mtch2=str.match(/<\/table/i);var i=mtch.index,j=mtch2&&mtch2.index||str.length;var rows=split_regex(str.slice(i,j),/(:?<tr[^>]*>)/i,"<tr>");var R=-1,C=0,RS=0,CS=0;var range={s:{r:10000000,c:10000000},e:{r:0,c:0}};var merges=[];for(i=0;i<rows.length;++i){var row=rows[i].trim();var hd=row.slice(0,3).toLowerCase();if(hd=="<tr"){++R;if(opts.sheetRows&&opts.sheetRows<=R){--R;break;}C=0;continue;}if(hd!="<td"&&hd!="<th")continue;var cells=row.split(/<\/t[dh]>/i);for(j=0;j<cells.length;++j){var cell=cells[j].trim();if(!cell.match(/<t[dh]/i))continue;var m=cell,cc=0;/* TODO: parse styles etc */while(m.charAt(0)=="<"&&(cc=m.indexOf(">"))>-1)m=m.slice(cc+1);for(var midx=0;midx<merges.length;++midx){var _merge=merges[midx];if(_merge.s.c==C&&_merge.s.r<R&&R<=_merge.e.r){C=_merge.e.c+1;midx=-1;}}var tag=parsexmltag(cell.slice(0,cell.indexOf(">")));CS=tag.colspan?+tag.colspan:1;if((RS=+tag.rowspan)>1||CS>1)merges.push({s:{r:R,c:C},e:{r:R+(RS||1)-1,c:C+CS-1}});var _t=tag.t||tag["data-t"]||"";/* TODO: generate stub cells */if(!m.length){C+=CS;continue;}m=htmldecode(m);if(range.s.r>R)range.s.r=R;if(range.e.r<R)range.e.r=R;if(range.s.c>C)range.s.c=C;if(range.e.c<C)range.e.c=C;if(!m.length)continue;var o={t:'s',v:m};if(opts.raw||!m.trim().length||_t=='s'){}else if(m==='TRUE')o={t:'b',v:true};else if(m==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(m)))o={t:'n',v:fuzzynum(m)};else if(!isNaN(fuzzydate(m).getDate())){o={t:'d',v:parseDate(m)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||SSF._table[14];}if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=o;}else ws[encode_cell({r:R,c:C})]=o;C+=CS;}}ws['!ref']=encode_range(range);if(merges.length)ws["!merges"]=merges;return ws;}function html_to_book(str,opts){var mtch=str.match(/<table.*?>[\s\S]*?<\/table>/gi);if(!mtch||mtch.length==0)throw new Error("Invalid HTML: could not find <table>");if(mtch.length==1)return sheet_to_workbook(html_to_sheet(mtch[0],opts),opts);var wb=utils.book_new();mtch.forEach(function(s,idx){utils.book_append_sheet(wb,html_to_sheet(s,opts),"Sheet"+(idx+1));});return wb;}function make_html_row(ws,r,R,o){var M=ws['!merges']||[];var oo=[];for(var C=r.s.c;C<=r.e.c;++C){var RS=0,CS=0;for(var j=0;j<M.length;++j){if(M[j].s.r>R||M[j].s.c>C)continue;if(M[j].e.r<R||M[j].e.c<C)continue;if(M[j].s.r<R||M[j].s.c<C){RS=-1;break;}RS=M[j].e.r-M[j].s.r+1;CS=M[j].e.c-M[j].s.c+1;break;}if(RS<0)continue;var coord=encode_cell({r:R,c:C});var cell=o.dense?(ws[R]||[])[C]:ws[coord];/* TODO: html entities */var w=cell&&cell.v!=null&&(cell.h||escapehtml(cell.w||(format_cell(cell),cell.w)||""))||"";var sp={};if(RS>1)sp.rowspan=RS;if(CS>1)sp.colspan=CS;if(o.editable)w='<span contenteditable="true">'+w+'</span>';else if(cell){sp["data-t"]=cell&&cell.t||'z';if(cell.v!=null)sp["data-v"]=cell.v;if(cell.z!=null)sp["data-z"]=cell.z;if(cell.l&&(cell.l.Target||"#").charAt(0)!="#")w='<a href="'+cell.l.Target+'">'+w+'</a>';}sp.id=(o.id||"sjs")+"-"+coord;oo.push(writextag('td',w,sp));}var preamble="<tr>";return preamble+oo.join("")+"</tr>";}function make_html_preamble(ws,R,o){var out=[];return out.join("")+'<table'+(o&&o.id?' id="'+o.id+'"':"")+'>';}var _BEGIN='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var _END='</body></html>';function sheet_to_html(ws,opts/*, wb:?Workbook*/){var o=opts||{};var header=o.header!=null?o.header:_BEGIN;var footer=o.footer!=null?o.footer:_END;var out=[header];var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);out.push(make_html_preamble(ws,r,o));for(var R=r.s.r;R<=r.e.r;++R)out.push(make_html_row(ws,r,R,o));out.push("</table>"+footer);return out.join("");}return{to_workbook:html_to_book,to_sheet:html_to_sheet,_row:make_html_row,BEGIN:_BEGIN,END:_END,_preamble:make_html_preamble,from_sheet:sheet_to_html};}();function sheet_add_dom(ws,table,_opts){var opts=_opts||{};if(DENSE!=null)opts.dense=DENSE;var or_R=0,or_C=0;if(opts.origin!=null){if(typeof opts.origin=='number')or_R=opts.origin;else{var _origin=typeof opts.origin=="string"?decode_cell(opts.origin):opts.origin;or_R=_origin.r;or_C=_origin.c;}}var rows=table.getElementsByTagName('tr');var sheetRows=Math.min(opts.sheetRows||10000000,rows.length);var range={s:{r:0,c:0},e:{r:or_R,c:or_C}};if(ws["!ref"]){var _range=decode_range(ws["!ref"]);range.s.r=Math.min(range.s.r,_range.s.r);range.s.c=Math.min(range.s.c,_range.s.c);range.e.r=Math.max(range.e.r,_range.e.r);range.e.c=Math.max(range.e.c,_range.e.c);if(or_R==-1)range.e.r=or_R=_range.e.r+1;}var merges=[],midx=0;var rowinfo=ws["!rows"]||(ws["!rows"]=[]);var _R=0,R=0,_C=0,C=0,RS=0,CS=0;if(!ws["!cols"])ws['!cols']=[];for(;_R<rows.length&&R<sheetRows;++_R){var row=rows[_R];if(is_dom_element_hidden(row)){if(opts.display)continue;rowinfo[R]={hidden:true};}var elts=row.children;for(_C=C=0;_C<elts.length;++_C){var elt=elts[_C];if(opts.display&&is_dom_element_hidden(elt))continue;var v=elt.hasAttribute('data-v')?elt.getAttribute('data-v'):elt.hasAttribute('v')?elt.getAttribute('v'):htmldecode(elt.innerHTML);var z=elt.getAttribute('data-z')||elt.getAttribute('z');for(midx=0;midx<merges.length;++midx){var m=merges[midx];if(m.s.c==C+or_C&&m.s.r<R+or_R&&R+or_R<=m.e.r){C=m.e.c+1-or_C;midx=-1;}}/* TODO: figure out how to extract nonstandard mso- style */CS=+elt.getAttribute("colspan")||1;if((RS=+elt.getAttribute("rowspan")||1)>1||CS>1)merges.push({s:{r:R+or_R,c:C+or_C},e:{r:R+or_R+(RS||1)-1,c:C+or_C+(CS||1)-1}});var o={t:'s',v:v};var _t=elt.getAttribute("data-t")||elt.getAttribute("t")||"";if(v!=null){if(v.length==0)o.t=_t||'z';else if(opts.raw||v.trim().length==0||_t=="s"){}else if(v==='TRUE')o={t:'b',v:true};else if(v==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(v)))o={t:'n',v:fuzzynum(v)};else if(!isNaN(fuzzydate(v).getDate())){o={t:'d',v:parseDate(v)};if(!opts.cellDates)o={t:'n',v:datenum(o.v)};o.z=opts.dateNF||SSF._table[14];}}if(o.z===undefined&&z!=null)o.z=z;/* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */var l="",Aelts=elt.getElementsByTagName("A");if(Aelts&&Aelts.length)for(var Aelti=0;Aelti<Aelts.length;++Aelti)if(Aelts[Aelti].hasAttribute("href")){l=Aelts[Aelti].getAttribute("href");if(l.charAt(0)!="#")break;}if(l&&l.charAt(0)!="#")o.l={Target:l};if(opts.dense){if(!ws[R+or_R])ws[R+or_R]=[];ws[R+or_R][C+or_C]=o;}else ws[encode_cell({c:C+or_C,r:R+or_R})]=o;if(range.e.c<C+or_C)range.e.c=C+or_C;C+=CS;}++R;}if(merges.length)ws['!merges']=(ws["!merges"]||[]).concat(merges);range.e.r=Math.max(range.e.r,R-1+or_R);ws['!ref']=encode_range(range);if(R>=sheetRows)ws['!fullref']=encode_range((range.e.r=rows.length-_R+R-1+or_R,range));// We can count the real number of rows to parse but we don't to improve the performance
return ws;}function parse_dom_table(table,_opts){var opts=_opts||{};var ws=opts.dense?[]:{};return sheet_add_dom(ws,table,_opts);}function table_to_book(table,opts){return sheet_to_workbook(parse_dom_table(table,opts),opts);}function is_dom_element_hidden(element){var display='';var get_computed_style=get_get_computed_style_function(element);if(get_computed_style)display=get_computed_style(element).getPropertyValue('display');if(!display)display=element.style.display;// Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
return display==='none';}/* global getComputedStyle */function get_get_computed_style_function(element){// The proper getComputedStyle implementation is the one defined in the element window
if(element.ownerDocument.defaultView&&typeof element.ownerDocument.defaultView.getComputedStyle==='function')return element.ownerDocument.defaultView.getComputedStyle;// If it is not available, try to get one from the global namespace
if(typeof getComputedStyle==='function')return getComputedStyle;return null;}/* OpenDocument */var parse_content_xml=function(){var parse_text_p=function(text){/* 6.1.2 White Space Characters */var fixed=text.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function($$,$1){return Array(parseInt($1,10)+1).join(" ");}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var v=unescapexml(fixed.replace(/<[^>]*>/g,""));return[v];};var number_formats={/* ods name: [short ssf fmt, long ssf fmt] */day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],/* there is no native representation of LO "Q" format */quarter:["\\Qm","m\\\"th quarter\""]};return function pcx(d,_opts){var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var str=xlml_normalize(d);var state=[],tmp;var tag;var NFtag={name:""},NF="",pidx=0;var sheetag;var rowtag;var Sheets={},SheetNames=[];var ws=opts.dense?[]:{};var Rn,q;var ctag={value:""};var textp="",textpidx=0,textptag;var textR=[];var R=-1,C=-1,range={s:{r:1000000,c:10000000},e:{r:0,c:0}};var row_ol=0;var number_format_map={};var merges=[],mrange={},mR=0,mC=0;var rowinfo=[],rowpeat=1,colpeat=1;var arrayf=[];var WB={Names:[]};var atag={};var _Ref=["",""];var comments=[],comment={};var creator="",creatoridx=0;var isstub=false,intable=false;var i=0;xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(Rn=xlmlregex.exec(str))switch(Rn[3]=Rn[3].replace(/_.*$/,"")){case'table':case'工作表':// 9.1.2 <table:table>
if(Rn[1]==='/'){if(range.e.c>=range.s.c&&range.e.r>=range.s.r)ws['!ref']=encode_range(range);else ws['!ref']="A1:A1";if(opts.sheetRows>0&&opts.sheetRows<=range.e.r){ws['!fullref']=ws['!ref'];range.e.r=opts.sheetRows-1;ws['!ref']=encode_range(range);}if(merges.length)ws['!merges']=merges;if(rowinfo.length)ws["!rows"]=rowinfo;sheetag.name=sheetag['名称']||sheetag.name;if(typeof JSON!=='undefined')JSON.stringify(sheetag);SheetNames.push(sheetag.name);Sheets[sheetag.name]=ws;intable=false;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){sheetag=parsexmltag(Rn[0],false);R=C=-1;range.s.r=range.s.c=10000000;range.e.r=range.e.c=0;ws=opts.dense?[]:{};merges=[];rowinfo=[];intable=true;}break;case'table-row-group':// 9.1.9 <table:table-row-group>
if(Rn[1]==="/")--row_ol;else++row_ol;break;case'table-row':case'行':// 9.1.3 <table:table-row>
if(Rn[1]==='/'){R+=rowpeat;rowpeat=1;break;}rowtag=parsexmltag(Rn[0],false);if(rowtag['行号'])R=rowtag['行号']-1;else if(R==-1)R=0;rowpeat=+rowtag['number-rows-repeated']||1;/* TODO: remove magic */if(rowpeat<10)for(i=0;i<rowpeat;++i)if(row_ol>0)rowinfo[R+i]={level:row_ol};C=-1;break;case'covered-table-cell':// 9.1.5 <table:covered-table-cell>
if(Rn[1]!=='/')++C;if(opts.sheetStubs){if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]={t:'z'};}else ws[encode_cell({r:R,c:C})]={t:'z'};}textp="";textR=[];break;/* stub */case'table-cell':case'数据':if(Rn[0].charAt(Rn[0].length-2)==='/'){++C;ctag=parsexmltag(Rn[0],false);colpeat=parseInt(ctag['number-columns-repeated']||"1",10);q={t:'z',v:null};if(ctag.formula&&opts.cellFormula!=false)q.f=ods_to_csf_formula(unescapexml(ctag.formula));if((ctag['数据类型']||ctag['value-type'])=="string"){q.t="s";q.v=unescapexml(ctag['string-value']||"");if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=q;}else{ws[encode_cell({r:R,c:C})]=q;}}C+=colpeat-1;}else if(Rn[1]!=='/'){++C;textp="";textpidx=0;textR=[];colpeat=1;var rptR=rowpeat?R+rowpeat-1:R;if(C>range.e.c)range.e.c=C;if(C<range.s.c)range.s.c=C;if(R<range.s.r)range.s.r=R;if(rptR>range.e.r)range.e.r=rptR;ctag=parsexmltag(Rn[0],false);comments=[];comment={};q={t:ctag['数据类型']||ctag['value-type'],v:null};if(opts.cellFormula){if(ctag.formula)ctag.formula=unescapexml(ctag.formula);if(ctag['number-matrix-columns-spanned']&&ctag['number-matrix-rows-spanned']){mR=parseInt(ctag['number-matrix-rows-spanned'],10)||0;mC=parseInt(ctag['number-matrix-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};q.F=encode_range(mrange);arrayf.push([mrange,q.F]);}if(ctag.formula)q.f=ods_to_csf_formula(ctag.formula);else for(i=0;i<arrayf.length;++i)if(R>=arrayf[i][0].s.r&&R<=arrayf[i][0].e.r)if(C>=arrayf[i][0].s.c&&C<=arrayf[i][0].e.c)q.F=arrayf[i][1];}if(ctag['number-columns-spanned']||ctag['number-rows-spanned']){mR=parseInt(ctag['number-rows-spanned'],10)||0;mC=parseInt(ctag['number-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};merges.push(mrange);}/* 19.675.2 table:number-columns-repeated */if(ctag['number-columns-repeated'])colpeat=parseInt(ctag['number-columns-repeated'],10);/* 19.385 office:value-type */switch(q.t){case'boolean':q.t='b';q.v=parsexmlbool(ctag['boolean-value']);break;case'float':q.t='n';q.v=parseFloat(ctag.value);break;case'percentage':q.t='n';q.v=parseFloat(ctag.value);break;case'currency':q.t='n';q.v=parseFloat(ctag.value);break;case'date':q.t='d';q.v=parseDate(ctag['date-value']);if(!opts.cellDates){q.t='n';q.v=datenum(q.v);}q.z='m/d/yy';break;case'time':q.t='n';q.v=parse_isodur(ctag['time-value'])/86400;if(opts.cellDates){q.t='d';q.v=numdate(q.v);}q.z='HH:MM:SS';break;case'number':q.t='n';q.v=parseFloat(ctag['数据数值']);break;default:if(q.t==='string'||q.t==='text'||!q.t){q.t='s';if(ctag['string-value']!=null){textp=unescapexml(ctag['string-value']);textR=[];}}else throw new Error('Unsupported value type '+q.t);}}else{isstub=false;if(q.t==='s'){q.v=textp||'';if(textR.length)q.R=textR;isstub=textpidx==0;}if(atag.Target)q.l=atag;if(comments.length>0){q.c=comments;comments=[];}if(textp&&opts.cellText!==false)q.w=textp;if(isstub){q.t="z";delete q.v;}if(!isstub||opts.sheetStubs){if(!(opts.sheetRows&&opts.sheetRows<=R)){for(var rpt=0;rpt<rowpeat;++rpt){colpeat=parseInt(ctag['number-columns-repeated']||"1",10);if(opts.dense){if(!ws[R+rpt])ws[R+rpt]=[];ws[R+rpt][C]=rpt==0?q:dup(q);while(--colpeat>0)ws[R+rpt][C+colpeat]=dup(q);}else{ws[encode_cell({r:R+rpt,c:C})]=q;while(--colpeat>0)ws[encode_cell({r:R+rpt,c:C+colpeat})]=dup(q);}if(range.e.c<=C)range.e.c=C;}}}colpeat=parseInt(ctag['number-columns-repeated']||"1",10);C+=colpeat-1;colpeat=0;q={};textp="";textR=[];}atag={};break;// 9.1.4 <table:table-cell>
/* pure state */case'document':// TODO: <office:document> is the root for FODS
case'document-content':case'电子表格文档':// 3.1.3.2 <office:document-content>
case'spreadsheet':case'主体':// 3.7 <office:spreadsheet>
case'scripts':// 3.12 <office:scripts>
case'styles':// TODO <office:styles>
case'font-face-decls':// 3.14 <office:font-face-decls>
case'master-styles':// 3.15.4 <office:master-styles> -- relevant for FODS
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'annotation':// 14.1 <office:annotation>
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;comment.t=textp;if(textR.length)comment.R=textR;comment.a=creator;comments.push(comment);}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){state.push([Rn[3],false]);}creator="";creatoridx=0;textp="";textpidx=0;textR=[];break;case'creator':// 4.3.2.7 <dc:creator>
if(Rn[1]==='/'){creator=str.slice(creatoridx,Rn.index);}else creatoridx=Rn.index+Rn[0].length;break;/* ignore state */case'meta':case'元数据':// TODO: <office:meta> <uof:元数据> FODS/UOF
case'settings':// TODO: <office:settings>
case'config-item-set':// TODO: <office:config-item-set>
case'config-item-map-indexed':// TODO: <office:config-item-map-indexed>
case'config-item-map-entry':// TODO: <office:config-item-map-entry>
case'config-item-map-named':// TODO: <office:config-item-map-entry>
case'shapes':// 9.2.8 <table:shapes>
case'frame':// 10.4.2 <draw:frame>
case'text-box':// 10.4.3 <draw:text-box>
case'image':// 10.4.4 <draw:image>
case'data-pilot-tables':// 9.6.2 <table:data-pilot-tables>
case'list-style':// 16.30 <text:list-style>
case'form':// 13.13 <form:form>
case'dde-links':// 9.8 <table:dde-links>
case'event-listeners':// TODO
case'chart':// TODO
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],false]);textp="";textpidx=0;textR=[];break;case'scientific-number':// TODO: <number:scientific-number>
break;case'currency-symbol':// TODO: <number:currency-symbol>
break;case'currency-style':// TODO: <number:currency-style>
break;case'number-style':// 16.27.2 <number:number-style>
case'percentage-style':// 16.27.9 <number:percentage-style>
case'date-style':// 16.27.10 <number:date-style>
case'time-style':// 16.27.18 <number:time-style>
if(Rn[1]==='/'){number_format_map[NFtag.name]=NF;if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){NF="";NFtag=parsexmltag(Rn[0],false);state.push([Rn[3],true]);}break;case'script':break;// 3.13 <office:script>
case'libraries':break;// TODO: <ooo:libraries>
case'automatic-styles':break;// 3.15.3 <office:automatic-styles>
case'default-style':// TODO: <style:default-style>
case'page-layout':break;// TODO: <style:page-layout>
case'style':// 16.2 <style:style>
break;case'map':break;// 16.3 <style:map>
case'font-face':break;// 16.21 <style:font-face>
case'paragraph-properties':break;// 17.6 <style:paragraph-properties>
case'table-properties':break;// 17.15 <style:table-properties>
case'table-column-properties':break;// 17.16 <style:table-column-properties>
case'table-row-properties':break;// 17.17 <style:table-row-properties>
case'table-cell-properties':break;// 17.18 <style:table-cell-properties>
case'number':// 16.27.3 <number:number>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats[Rn[3]][tag.style==='long'?1:0];break;}break;case'fraction':break;// TODO 16.27.6 <number:fraction>
case'day':// 16.27.11 <number:day>
case'month':// 16.27.12 <number:month>
case'year':// 16.27.13 <number:year>
case'era':// 16.27.14 <number:era>
case'day-of-week':// 16.27.15 <number:day-of-week>
case'week-of-year':// 16.27.16 <number:week-of-year>
case'quarter':// 16.27.17 <number:quarter>
case'hours':// 16.27.19 <number:hours>
case'minutes':// 16.27.20 <number:minutes>
case'seconds':// 16.27.21 <number:seconds>
case'am-pm':// 16.27.22 <number:am-pm>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats[Rn[3]][tag.style==='long'?1:0];break;}break;case'boolean-style':break;// 16.27.23 <number:boolean-style>
case'boolean':break;// 16.27.24 <number:boolean>
case'text-style':break;// 16.27.25 <number:text-style>
case'text':// 16.27.26 <number:text>
if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")switch(state[state.length-1][0]){case'number-style':case'date-style':case'time-style':NF+=str.slice(pidx,Rn.index);break;}else pidx=Rn.index+Rn[0].length;break;case'named-range':// 9.4.12 <table:named-range>
tag=parsexmltag(Rn[0],false);_Ref=ods_to_csf_3D(tag['cell-range-address']);var nrange={Name:tag.name,Ref:_Ref[0]+'!'+_Ref[1]};if(intable)nrange.Sheet=SheetNames.length;WB.Names.push(nrange);break;case'text-content':break;// 16.27.27 <number:text-content>
case'text-properties':break;// 16.27.27 <style:text-properties>
case'embedded-text':break;// 16.27.4 <number:embedded-text>
case'body':case'电子表格':break;// 3.3 16.9.6 19.726.3
case'forms':break;// 12.25.2 13.2
case'table-column':break;// 9.1.6 <table:table-column>
case'table-header-rows':break;// 9.1.7 <table:table-header-rows>
case'table-rows':break;// 9.1.12 <table:table-rows>
/* TODO: outline levels */case'table-column-group':break;// 9.1.10 <table:table-column-group>
case'table-header-columns':break;// 9.1.11 <table:table-header-columns>
case'table-columns':break;// 9.1.12 <table:table-columns>
case'null-date':break;// 9.4.2 <table:null-date> TODO: date1904
case'graphic-properties':break;// 17.21 <style:graphic-properties>
case'calculation-settings':break;// 9.4.1 <table:calculation-settings>
case'named-expressions':break;// 9.4.11 <table:named-expressions>
case'label-range':break;// 9.4.9 <table:label-range>
case'label-ranges':break;// 9.4.10 <table:label-ranges>
case'named-expression':break;// 9.4.13 <table:named-expression>
case'sort':break;// 9.4.19 <table:sort>
case'sort-by':break;// 9.4.20 <table:sort-by>
case'sort-groups':break;// 9.4.22 <table:sort-groups>
case'tab':break;// 6.1.4 <text:tab>
case'line-break':break;// 6.1.5 <text:line-break>
case'span':break;// 6.1.7 <text:span>
case'p':case'文本串':// 5.1.3 <text:p>
if(['master-styles'].indexOf(state[state.length-1][0])>-1)break;if(Rn[1]==='/'&&(!ctag||!ctag['string-value'])){var ptp=parse_text_p(str.slice(textpidx,Rn.index),textptag);textp=(textp.length>0?textp+"\n":"")+ptp[0];}else{textptag=parsexmltag(Rn[0],false);textpidx=Rn.index+Rn[0].length;}break;// <text:p>
case's':break;// <text:s>
case'database-range':// 9.4.15 <table:database-range>
if(Rn[1]==='/')break;try{_Ref=ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);Sheets[_Ref[0]]['!autofilter']={ref:_Ref[1]};}catch(e){/* empty */}break;case'date':break;// <*:date>
case'object':break;// 10.4.6.2 <draw:object>
case'title':case'标题':break;// <*:title> OR <uof:标题>
case'desc':break;// <*:desc>
case'binary-data':break;// 10.4.5 TODO: b64 blob
/* 9.2 Advanced Tables */case'table-source':break;// 9.2.6
case'scenario':break;// 9.2.6
case'iteration':break;// 9.4.3 <table:iteration>
case'content-validations':break;// 9.4.4 <table:
case'content-validation':break;// 9.4.5 <table:
case'help-message':break;// 9.4.6 <table:
case'error-message':break;// 9.4.7 <table:
case'database-ranges':break;// 9.4.14 <table:database-ranges>
case'filter':break;// 9.5.2 <table:filter>
case'filter-and':break;// 9.5.3 <table:filter-and>
case'filter-or':break;// 9.5.4 <table:filter-or>
case'filter-condition':break;// 9.5.5 <table:filter-condition>
case'list-level-style-bullet':break;// 16.31 <text:
case'list-level-style-number':break;// 16.32 <text:
case'list-level-properties':break;// 17.19 <style:
/* 7.3 Document Fields */case'sender-firstname':// 7.3.6.2
case'sender-lastname':// 7.3.6.3
case'sender-initials':// 7.3.6.4
case'sender-title':// 7.3.6.5
case'sender-position':// 7.3.6.6
case'sender-email':// 7.3.6.7
case'sender-phone-private':// 7.3.6.8
case'sender-fax':// 7.3.6.9
case'sender-company':// 7.3.6.10
case'sender-phone-work':// 7.3.6.11
case'sender-street':// 7.3.6.12
case'sender-city':// 7.3.6.13
case'sender-postal-code':// 7.3.6.14
case'sender-country':// 7.3.6.15
case'sender-state-or-province':// 7.3.6.16
case'author-name':// 7.3.7.1
case'author-initials':// 7.3.7.2
case'chapter':// 7.3.8
case'file-name':// 7.3.9
case'template-name':// 7.3.9
case'sheet-name':// 7.3.9
break;case'event-listener':break;/* TODO: FODS Properties */case'initial-creator':case'creation-date':case'print-date':case'generator':case'document-statistic':case'user-defined':case'editing-duration':case'editing-cycles':break;/* TODO: FODS Config */case'config-item':break;/* TODO: style tokens */case'page-number':break;// TODO <text:page-number>
case'page-count':break;// TODO <text:page-count>
case'time':break;// TODO <text:time>
/* 9.3 Advanced Table Cells */case'cell-range-source':break;// 9.3.1 <table:
case'detective':break;// 9.3.2 <table:
case'operation':break;// 9.3.3 <table:
case'highlighted-range':break;// 9.3.4 <table:
/* 9.6 Data Pilot Tables <table: */case'data-pilot-table':// 9.6.3
case'source-cell-range':// 9.6.5
case'source-service':// 9.6.6
case'data-pilot-field':// 9.6.7
case'data-pilot-level':// 9.6.8
case'data-pilot-subtotals':// 9.6.9
case'data-pilot-subtotal':// 9.6.10
case'data-pilot-members':// 9.6.11
case'data-pilot-member':// 9.6.12
case'data-pilot-display-info':// 9.6.13
case'data-pilot-sort-info':// 9.6.14
case'data-pilot-layout-info':// 9.6.15
case'data-pilot-field-reference':// 9.6.16
case'data-pilot-groups':// 9.6.17
case'data-pilot-group':// 9.6.18
case'data-pilot-group-member':// 9.6.19
break;/* 10.3 Drawing Shapes */case'rect':// 10.3.2
break;/* 14.6 DDE Connections */case'dde-connection-decls':// 14.6.2 <text:
case'dde-connection-decl':// 14.6.3 <text:
case'dde-link':// 14.6.4 <table:
case'dde-source':// 14.6.5 <office:
break;case'properties':break;// 13.7 <form:properties>
case'property':break;// 13.8 <form:property>
case'a':// 6.1.8 hyperlink
if(Rn[1]!=='/'){atag=parsexmltag(Rn[0],false);if(!atag.href)break;atag.Target=unescapexml(atag.href);delete atag.href;if(atag.Target.charAt(0)=="#"&&atag.Target.indexOf(".")>-1){_Ref=ods_to_csf_3D(atag.Target.slice(1));atag.Target="#"+_Ref[0]+"!"+_Ref[1];}else if(atag.Target.match(/^\.\.[\\\/]/))atag.Target=atag.Target.slice(3);}break;/* non-standard */case'table-protection':break;case'data-pilot-grand-total':break;// <table:
case'office-document-common-attrs':break;// bare
default:switch(Rn[2]){case'dc:':// TODO: properties
case'calcext:':// ignore undocumented extensions
case'loext:':// ignore undocumented extensions
case'ooo:':// ignore undocumented extensions
case'chartooo:':// ignore undocumented extensions
case'draw:':// TODO: drawing
case'style:':// TODO: styles
case'chart:':// TODO: charts
case'form:':// TODO: forms
case'uof:':// TODO: uof
case'表:':// TODO: uof
case'字:':// TODO: uof
break;default:if(opts.WTF)throw new Error(Rn);}}var out={Sheets:Sheets,SheetNames:SheetNames,Workbook:WB};if(opts.bookSheets)delete out.Sheets;return out;};}();function parse_ods(zip,opts){opts=opts||{};if(safegetzipfile(zip,'META-INF/manifest.xml'))parse_manifest(getzipdata(zip,'META-INF/manifest.xml'),opts);var content=getzipstr(zip,'content.xml');if(!content)throw new Error("Missing content.xml in ODS / UOF file");var wb=parse_content_xml(utf8read(content),opts);if(safegetzipfile(zip,'meta.xml'))wb.Props=parse_core_props(getzipdata(zip,'meta.xml'));return wb;}function parse_fods(data,opts){return parse_content_xml(data,opts);}/* OpenDocument */var write_styles_ods=function(){var master_styles=['<office:master-styles>','<style:master-page style:name="mp1" style:page-layout-name="mp1">','<style:header/>','<style:header-left style:display="false"/>','<style:footer/>','<style:footer-left style:display="false"/>','</style:master-page>','</office:master-styles>'].join("");var payload='<office:document-styles '+wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'office:version':"1.2"})+'>'+master_styles+'</office:document-styles>';return function wso(){return XML_HEADER+payload;};}();var write_content_ods=function(){/* 6.1.2 White Space Characters */var write_text_p=function(text){return escapexml(text).replace(/  +/g,function($$){return'<text:s text:c="'+$$.length+'"/>';}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");};var null_cell_xml='          <table:table-cell />\n';var covered_cell_xml='          <table:covered-table-cell/>\n';var write_ws=function(ws,wb,i){/* Section 9 Tables */var o=[];o.push('      <table:table table:name="'+escapexml(wb.SheetNames[i])+'" table:style-name="ta1">\n');var R=0,C=0,range=decode_range(ws['!ref']||"A1");var marr=ws['!merges']||[],mi=0;var dense=Array.isArray(ws);if(ws["!cols"]){for(C=0;C<=range.e.c;++C)o.push('        <table:table-column'+(ws["!cols"][C]?' table:style-name="co'+ws["!cols"][C].ods+'"':'')+'></table:table-column>\n');}var H="",ROWS=ws["!rows"]||[];for(R=0;R<range.s.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'></table:table-row>\n');}for(;R<=range.e.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'>\n');for(C=0;C<range.s.c;++C)o.push(null_cell_xml);for(;C<=range.e.c;++C){var skip=false,ct={},textp="";for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;ct['table:number-columns-spanned']=marr[mi].e.c-marr[mi].s.c+1;ct['table:number-rows-spanned']=marr[mi].e.r-marr[mi].s.r+1;break;}if(skip){o.push(covered_cell_xml);continue;}var ref=encode_cell({r:R,c:C}),cell=dense?(ws[R]||[])[C]:ws[ref];if(cell&&cell.f){ct['table:formula']=escapexml(csf_to_ods_formula(cell.f));if(cell.F){if(cell.F.slice(0,ref.length)==ref){var _Fref=decode_range(cell.F);ct['table:number-matrix-columns-spanned']=_Fref.e.c-_Fref.s.c+1;ct['table:number-matrix-rows-spanned']=_Fref.e.r-_Fref.s.r+1;}}}if(!cell){o.push(null_cell_xml);continue;}switch(cell.t){case'b':textp=cell.v?'TRUE':'FALSE';ct['office:value-type']="boolean";ct['office:boolean-value']=cell.v?'true':'false';break;case'n':textp=cell.w||String(cell.v||0);ct['office:value-type']="float";ct['office:value']=cell.v||0;break;case's':case'str':textp=cell.v==null?"":cell.v;ct['office:value-type']="string";break;case'd':textp=cell.w||parseDate(cell.v).toISOString();ct['office:value-type']="date";ct['office:date-value']=parseDate(cell.v).toISOString();ct['table:style-name']="ce1";break;//case 'e':
default:o.push(null_cell_xml);continue;}var text_p=write_text_p(textp);if(cell.l&&cell.l.Target){var _tgt=cell.l.Target;_tgt=_tgt.charAt(0)=="#"?"#"+csf_to_ods_3D(_tgt.slice(1)):_tgt;// TODO: choose correct parent path format based on link delimiters
if(_tgt.charAt(0)!="#"&&!_tgt.match(/^\w+:/))_tgt='../'+_tgt;text_p=writextag('text:a',text_p,{'xlink:href':_tgt.replace(/&/g,"&amp;")});}o.push('          '+writextag('table:table-cell',writextag('text:p',text_p,{}),ct)+'\n');}o.push('        </table:table-row>\n');}o.push('      </table:table>\n');return o.join("");};var write_automatic_styles_ods=function(o,wb){o.push(' <office:automatic-styles>\n');o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');o.push('   <number:month number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:day number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:year/>\n');o.push('  </number:date-style>\n');/* column styles */var cidx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!cols"]){for(var C=0;C<ws["!cols"].length;++C)if(ws["!cols"][C]){var colobj=ws["!cols"][C];if(colobj.width==null&&colobj.wpx==null&&colobj.wch==null)continue;process_col(colobj);colobj.ods=cidx;var w=ws["!cols"][C].wpx+"px";o.push('  <style:style style:name="co'+cidx+'" style:family="table-column">\n');o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+w+'"/>\n');o.push('  </style:style>\n');++cidx;}}});/* row styles */var ridx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!rows"]){for(var R=0;R<ws["!rows"].length;++R)if(ws["!rows"][R]){ws["!rows"][R].ods=ridx;var h=ws["!rows"][R].hpx+"px";o.push('  <style:style style:name="ro'+ridx+'" style:family="table-row">\n');o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+h+'"/>\n');o.push('  </style:style>\n');++ridx;}}});/* table */o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');o.push('  </style:style>\n');/* table cells, text */o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');/* page-layout */o.push(' </office:automatic-styles>\n');};return function wcx(wb,opts){var o=[XML_HEADER];/* 3.1.3.2 */var attr=wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:meta':"urn:oasis:names:tc:opendocument:xmlns:meta:1.0",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:presentation':"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:chart':"urn:oasis:names:tc:opendocument:xmlns:chart:1.0",'xmlns:dr3d':"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",'xmlns:math':"http://www.w3.org/1998/Math/MathML",'xmlns:form':"urn:oasis:names:tc:opendocument:xmlns:form:1.0",'xmlns:script':"urn:oasis:names:tc:opendocument:xmlns:script:1.0",'xmlns:ooo':"http://openoffice.org/2004/office",'xmlns:ooow':"http://openoffice.org/2004/writer",'xmlns:oooc':"http://openoffice.org/2004/calc",'xmlns:dom':"http://www.w3.org/2001/xml-events",'xmlns:xforms':"http://www.w3.org/2002/xforms",'xmlns:xsd':"http://www.w3.org/2001/XMLSchema",'xmlns:xsi':"http://www.w3.org/2001/XMLSchema-instance",'xmlns:sheet':"urn:oasis:names:tc:opendocument:sh33tjs:1.0",'xmlns:rpt':"http://openoffice.org/2005/report",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'xmlns:xhtml':"http://www.w3.org/1999/xhtml",'xmlns:grddl':"http://www.w3.org/2003/g/data-view#",'xmlns:tableooo':"http://openoffice.org/2009/table",'xmlns:drawooo':"http://openoffice.org/2010/draw",'xmlns:calcext':"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",'xmlns:loext':"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",'xmlns:field':"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",'xmlns:formx':"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",'xmlns:css3t':"http://www.w3.org/TR/css3-text/",'office:version':"1.2"});var fods=wxt_helper({'xmlns:config':"urn:oasis:names:tc:opendocument:xmlns:config:1.0",'office:mimetype':"application/vnd.oasis.opendocument.spreadsheet"});if(opts.bookType=="fods"){o.push('<office:document'+attr+fods+'>\n');o.push(write_meta_ods().replace(/office:document-meta/g,"office:meta"));// TODO: settings (equiv of settings.xml for ODS)
}else o.push('<office:document-content'+attr+'>\n');// o.push('  <office:scripts/>\n');
write_automatic_styles_ods(o,wb);o.push('  <office:body>\n');o.push('    <office:spreadsheet>\n');for(var i=0;i!=wb.SheetNames.length;++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]],wb,i,opts));o.push('    </office:spreadsheet>\n');o.push('  </office:body>\n');if(opts.bookType=="fods")o.push('</office:document>');else o.push('</office:document-content>');return o.join("");};}();function write_ods(wb,opts){if(opts.bookType=="fods")return write_content_ods(wb,opts);var zip=zip_new();var f="";var manifest=[];var rdf=[];/* Part 3 Section 3.3 MIME Media Type */f="mimetype";zip_add_file(zip,f,"application/vnd.oasis.opendocument.spreadsheet");/* Part 1 Section 2.2 Documents */f="content.xml";zip_add_file(zip,f,write_content_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"ContentFile"]);/* TODO: these are hard-coded styles to satiate excel */f="styles.xml";zip_add_file(zip,f,write_styles_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"StylesFile"]);/* TODO: this is hard-coded to satiate excel */f="meta.xml";zip_add_file(zip,f,XML_HEADER+write_meta_ods());manifest.push([f,"text/xml"]);rdf.push([f,"MetadataFile"]);/* Part 3 Section 6 Metadata Manifest File */f="manifest.rdf";zip_add_file(zip,f,write_rdf(rdf/*, opts*/));manifest.push([f,"application/rdf+xml"]);/* Part 3 Section 4 Manifest File */f="META-INF/manifest.xml";zip_add_file(zip,f,write_manifest(manifest/*, opts*/));return zip;}function write_sheet_index(wb,sheet){if(!sheet)return 0;var idx=wb.SheetNames.indexOf(sheet);if(idx==-1)throw new Error("Sheet not found: "+sheet);return idx;}function write_obj_str(factory){return function write_str(wb,o){var idx=write_sheet_index(wb,o.sheet);return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]],o,wb);};}var write_htm_str=write_obj_str(HTML_);var write_csv_str=write_obj_str({from_sheet:sheet_to_csv});var write_slk_str=write_obj_str(typeof SYLK!=="undefined"?SYLK:{});var write_dif_str=write_obj_str(typeof DIF!=="undefined"?DIF:{});var write_prn_str=write_obj_str(typeof PRN!=="undefined"?PRN:{});var write_rtf_str=write_obj_str(typeof RTF!=="undefined"?RTF:{});var write_txt_str=write_obj_str({from_sheet:sheet_to_txt});var write_dbf_buf=write_obj_str(typeof DBF!=="undefined"?DBF:{});var write_eth_str=write_obj_str(typeof ETH!=="undefined"?ETH:{});var write_wk1_buf=write_obj_str(typeof WK_!=="undefined"?{from_sheet:WK_.sheet_to_wk1}:{});function fix_opts_func(defaults){return function fix_opts(opts){for(var i=0;i!=defaults.length;++i){var d=defaults[i];if(opts[d[0]]===undefined)opts[d[0]]=d[1];if(d[2]==='n')opts[d[0]]=Number(opts[d[0]]);}};}var fix_read_opts=function(opts){fix_opts_func([['cellNF',false],/* emit cell number format string as .z */['cellHTML',true],/* emit html string as .h */['cellFormula',true],/* emit formulae as .f */['cellStyles',false],/* emits style/theme as .s */['cellText',true],/* emit formatted text as .w */['cellDates',false],/* emit date cells with type `d` */['sheetStubs',false],/* emit empty cells */['sheetRows',0,'n'],/* read n rows (0 = read all rows) */['bookDeps',false],/* parse calculation chains */['bookSheets',false],/* only try to get sheet names (no Sheets) */['bookProps',false],/* only try to get properties (no Sheets) */['bookFiles',false],/* include raw file structure (keys, files, cfb) */['bookVBA',false],/* include vba raw data (vbaraw) */['password',''],/* password */['WTF',false]/* WTF mode (throws errors) */])(opts);};var fix_write_opts=fix_opts_func([['cellDates',false],/* write date cells with type `d` */['bookSST',false],/* Generate Shared String Table */['bookType','xlsx'],/* Type of workbook (xlsx/m/b) */['compression',false],/* Use file compression */['WTF',false]/* WTF mode (throws errors) */]);function get_sheet_type(n){if(RELS.WS.indexOf(n)>-1)return"sheet";if(RELS.CS&&n==RELS.CS)return"chart";if(RELS.DS&&n==RELS.DS)return"dialog";if(RELS.MS&&n==RELS.MS)return"macro";return n&&n.length?n:"sheet";}function safe_parse_wbrels(wbrels,sheets){if(!wbrels)return 0;try{wbrels=sheets.map(function pwbr(w){if(!w.id)w.id=w.strRelID;return[w.name,wbrels['!id'][w.id].Target,get_sheet_type(wbrels['!id'][w.id].Type)];});}catch(e){return null;}return!wbrels||wbrels.length===0?null:wbrels;}function safe_parse_sheet(zip,path,relsPath,sheet,idx,sheetRels,sheets,stype,opts,wb,themes,styles){try{sheetRels[sheet]=parse_rels(getzipstr(zip,relsPath,true),path);var data=getzipdata(zip,path);var _ws;switch(stype){case'sheet':_ws=parse_ws(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'chart':_ws=parse_cs(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);if(!_ws||!_ws['!drawel'])break;var dfile=resolve_path(_ws['!drawel'].Target,path);var drelsp=get_rels_path(dfile);var draw=parse_drawing(getzipstr(zip,dfile,true),parse_rels(getzipstr(zip,drelsp,true),dfile));var chartp=resolve_path(draw,dfile);var crelsp=get_rels_path(chartp);_ws=parse_chart(getzipstr(zip,chartp,true),chartp,opts,parse_rels(getzipstr(zip,crelsp,true),chartp),wb,_ws);break;case'macro':_ws=parse_ms(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'dialog':_ws=parse_ds(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;default:throw new Error("Unrecognized sheet type "+stype);}sheets[sheet]=_ws;/* scan rels for comments */var comments=[];if(sheetRels&&sheetRels[sheet])keys(sheetRels[sheet]).forEach(function(n){if(sheetRels[sheet][n].Type==RELS.CMNT){var dfile=resolve_path(sheetRels[sheet][n].Target,path);comments=parse_cmnt(getzipdata(zip,dfile,true),dfile,opts);if(!comments||!comments.length)return;sheet_insert_comments(_ws,comments);}});}catch(e){if(opts.WTF)throw e;}}function strip_front_slash(x){return x.charAt(0)=='/'?x.slice(1):x;}function parse_zip(zip,opts){make_ssf(SSF);opts=opts||{};fix_read_opts(opts);/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */if(safegetzipfile(zip,'META-INF/manifest.xml'))return parse_ods(zip,opts);/* UOC */if(safegetzipfile(zip,'objectdata.xml'))return parse_ods(zip,opts);/* Numbers */if(safegetzipfile(zip,'Index/Document.iwa'))throw new Error('Unsupported NUMBERS file');if(!safegetzipfile(zip,'[Content_Types].xml')){if(safegetzipfile(zip,'index.xml.gz'))throw new Error('Unsupported NUMBERS 08 file');if(safegetzipfile(zip,'index.xml'))throw new Error('Unsupported NUMBERS 09 file');throw new Error('Unsupported ZIP file');}var entries=zipentries(zip);var dir=parse_ct(getzipstr(zip,'[Content_Types].xml'));var xlsb=false;var sheets,binname;if(dir.workbooks.length===0){binname="xl/workbook.xml";if(getzipdata(zip,binname,true))dir.workbooks.push(binname);}if(dir.workbooks.length===0){binname="xl/workbook.bin";if(!getzipdata(zip,binname,true))throw new Error("Could not find workbook");dir.workbooks.push(binname);xlsb=true;}if(dir.workbooks[0].slice(-3)=="bin")xlsb=true;var themes={};var styles={};if(!opts.bookSheets&&!opts.bookProps){strs=[];if(dir.sst)try{strs=parse_sst(getzipdata(zip,strip_front_slash(dir.sst)),dir.sst,opts);}catch(e){if(opts.WTF)throw e;}if(opts.cellStyles&&dir.themes.length)themes=parse_theme(getzipstr(zip,dir.themes[0].replace(/^\//,''),true)||"",dir.themes[0],opts);if(dir.style)styles=parse_sty(getzipdata(zip,strip_front_slash(dir.style)),dir.style,themes,opts);}/*var externbooks = */dir.links.map(function(link){try{var rels=parse_rels(getzipstr(zip,get_rels_path(strip_front_slash(link))),link);return parse_xlink(getzipdata(zip,strip_front_slash(link)),rels,link,opts);}catch(e){}});var wb=parse_wb(getzipdata(zip,strip_front_slash(dir.workbooks[0])),dir.workbooks[0],opts);var props={},propdata="";if(dir.coreprops.length){propdata=getzipdata(zip,strip_front_slash(dir.coreprops[0]),true);if(propdata)props=parse_core_props(propdata);if(dir.extprops.length!==0){propdata=getzipdata(zip,strip_front_slash(dir.extprops[0]),true);if(propdata)parse_ext_props(propdata,props,opts);}}var custprops={};if(!opts.bookSheets||opts.bookProps){if(dir.custprops.length!==0){propdata=getzipstr(zip,strip_front_slash(dir.custprops[0]),true);if(propdata)custprops=parse_cust_props(propdata,opts);}}var out={};if(opts.bookSheets||opts.bookProps){if(wb.Sheets)sheets=wb.Sheets.map(function pluck(x){return x.name;});else if(props.Worksheets&&props.SheetNames.length>0)sheets=props.SheetNames;if(opts.bookProps){out.Props=props;out.Custprops=custprops;}if(opts.bookSheets&&typeof sheets!=='undefined')out.SheetNames=sheets;if(opts.bookSheets?out.SheetNames:opts.bookProps)return out;}sheets={};var deps={};if(opts.bookDeps&&dir.calcchain)deps=parse_cc(getzipdata(zip,strip_front_slash(dir.calcchain)),dir.calcchain,opts);var i=0;var sheetRels={};var path,relsPath;{var wbsheets=wb.Sheets;props.Worksheets=wbsheets.length;props.SheetNames=[];for(var j=0;j!=wbsheets.length;++j){props.SheetNames[j]=wbsheets[j].name;}}var wbext=xlsb?"bin":"xml";var wbrelsi=dir.workbooks[0].lastIndexOf("/");var wbrelsfile=(dir.workbooks[0].slice(0,wbrelsi+1)+"_rels/"+dir.workbooks[0].slice(wbrelsi+1)+".rels").replace(/^\//,"");if(!safegetzipfile(zip,wbrelsfile))wbrelsfile='xl/_rels/workbook.'+wbext+'.rels';var wbrels=parse_rels(getzipstr(zip,wbrelsfile,true),wbrelsfile);if(wbrels)wbrels=safe_parse_wbrels(wbrels,wb.Sheets);/* Numbers iOS hack */var nmode=getzipdata(zip,"xl/worksheets/sheet.xml",true)?1:0;wsloop:for(i=0;i!=props.Worksheets;++i){var stype="sheet";if(wbrels&&wbrels[i]){path='xl/'+wbrels[i][1].replace(/[\/]?xl\//,"");if(!safegetzipfile(zip,path))path=wbrels[i][1];if(!safegetzipfile(zip,path))path=wbrelsfile.replace(/_rels\/.*$/,"")+wbrels[i][1];stype=wbrels[i][2];}else{path='xl/worksheets/sheet'+(i+1-nmode)+"."+wbext;path=path.replace(/sheet0\./,"sheet.");}relsPath=path.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(opts&&opts.sheets!=null)switch(typeof opts.sheets){case"number":if(i!=opts.sheets)continue wsloop;break;case"string":if(props.SheetNames[i].toLowerCase()!=opts.sheets.toLowerCase())continue wsloop;break;default:if(Array.isArray&&Array.isArray(opts.sheets)){var snjseen=false;for(var snj=0;snj!=opts.sheets.length;++snj){if(typeof opts.sheets[snj]=="number"&&opts.sheets[snj]==i)snjseen=1;if(typeof opts.sheets[snj]=="string"&&opts.sheets[snj].toLowerCase()==props.SheetNames[i].toLowerCase())snjseen=1;}if(!snjseen)continue wsloop;}}safe_parse_sheet(zip,path,relsPath,props.SheetNames[i],i,sheetRels,sheets,stype,opts,wb,themes,styles);}out={Directory:dir,Workbook:wb,Props:props,Custprops:custprops,Deps:deps,Sheets:sheets,SheetNames:props.SheetNames,Strings:strs,Styles:styles,Themes:themes,SSF:SSF.get_table()};if(opts&&opts.bookFiles){if(zip.files){out.keys=entries;out.files=zip.files;}else{out.keys=[];out.files={};zip.FullPaths.forEach(function(p,idx){p=p.replace(/^Root Entry[\/]/,"");out.keys.push(p);out.files[p]=zip.FileIndex[idx];});}}if(opts&&opts.bookVBA){if(dir.vba.length>0)out.vbaraw=getzipdata(zip,strip_front_slash(dir.vba[0]),true);else if(dir.defaults&&dir.defaults.bin===CT_VBA)out.vbaraw=getzipdata(zip,'xl/vbaProject.bin',true);}return out;}/* [MS-OFFCRYPTO] 2.1.1 */function parse_xlsxcfb(cfb,_opts){var opts=_opts||{};var f='Workbook',data=CFB.find(cfb,f);try{f='/!DataSpaces/Version';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var version = */parse_DataSpaceVersionInfo(data.content);/* 2.3.4.1 */f='/!DataSpaces/DataSpaceMap';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var dsm=parse_DataSpaceMap(data.content);if(dsm.length!==1||dsm[0].comps.length!==1||dsm[0].comps[0].t!==0||dsm[0].name!=="StrongEncryptionDataSpace"||dsm[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.2 */f='/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var seds=parse_DataSpaceDefinition(data.content);if(seds.length!=1||seds[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.3 */f='/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var hdr = */parse_Primary(data.content);}catch(e){}f='/EncryptionInfo';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var einfo=parse_EncryptionInfo(data.content);/* 2.3.4.4 */f='/EncryptedPackage';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*global decrypt_agile */if(einfo[0]==0x04&&typeof decrypt_agile!=='undefined')return decrypt_agile(einfo[1],data.content,opts.password||"",opts);/*global decrypt_std76 */if(einfo[0]==0x02&&typeof decrypt_std76!=='undefined')return decrypt_std76(einfo[1],data.content,opts.password||"",opts);throw new Error("File is password-protected");}function write_zip(wb,opts){_shapeid=1024;if(opts.bookType=="ods")return write_ods(wb,opts);if(wb&&!wb.SSF){wb.SSF=SSF.get_table();}if(wb&&wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=[];opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new Map();else{opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext=opts.bookType=="xlsb"?"bin":"xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames){/* empty */}else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else{var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i)if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":/* falls through */default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws(rId-1,f,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;if(comments&&comments.length>0){var cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_cmnt(comments,cf,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst(opts.Strings,f,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb(wb,f,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);/* TODO: something more intelligent with themes */f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);/* TODO: something more intelligent with styles */f="xl/styles."+wbext;zip_add_file(zip,f,write_sty(wb,f,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function firstbyte(f,o){var x="";switch((o||{}).type||"base64"){case'buffer':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];case'base64':x=Base64.decode(f.slice(0,12));break;case'binary':x=f;break;case'array':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];default:throw new Error("Unrecognized type "+(o&&o.type||"undefined"));}return[x.charCodeAt(0),x.charCodeAt(1),x.charCodeAt(2),x.charCodeAt(3),x.charCodeAt(4),x.charCodeAt(5),x.charCodeAt(6),x.charCodeAt(7)];}function read_cfb(cfb,opts){if(CFB.find(cfb,"EncryptedPackage"))return parse_xlsxcfb(cfb,opts);return parse_xlscfb(cfb,opts);}function read_zip(data,opts){var zip,d=data;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";zip=zip_read(d,o);return parse_zip(zip,o);}function read_plaintext(data,o){var i=0;main:while(i<data.length)switch(data.charCodeAt(i)){case 0x0A:case 0x0D:case 0x20:++i;break;case 0x3C:return parse_xlml(data.slice(i),o);default:break main;}return PRN.to_workbook(data,o);}function read_plaintext_raw(data,o){var str="",bytes=firstbyte(data,o);switch(o.type){case'base64':str=Base64.decode(data);break;case'binary':str=data;break;case'buffer':str=data.toString('binary');break;case'array':str=cc2str(data);break;default:throw new Error("Unrecognized type "+o.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str);return read_plaintext(str,o);}function read_utf16(data,o){var d=data;if(o.type=='base64')d=Base64.decode(d);d=cptable.utils.decode(1200,d.slice(2),'str');o.type="binary";return read_plaintext(d,o);}function bstrify(data){return!data.match(/[^\x00-\x7F]/)?data:utf8write(data);}function read_prn(data,d,o,str){if(str){o.type="string";return PRN.to_workbook(data,o);}return PRN.to_workbook(d,o);}function readSync(data,opts){reset_cp();var o=opts||{};if(typeof ArrayBuffer!=='undefined'&&data instanceof ArrayBuffer)return readSync(new Uint8Array(data),(o=dup(o),o.type="array",o));var d=data,n=[0,0,0,0],str=false;if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}_ssfopts={};if(o.dateNF)_ssfopts.dateNF=o.dateNF;if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";if(o.type=="file"){o.type=has_buf?"buffer":"binary";d=read_binary(data);}if(o.type=="string"){str=true;o.type="binary";o.codepage=65001;d=bstrify(data);}if(o.type=='array'&&typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&typeof ArrayBuffer!=='undefined'){// $FlowIgnore
var ab=new ArrayBuffer(3),vu=new Uint8Array(ab);vu.foo="bar";// $FlowIgnore
if(!vu.foo){o=dup(o);o.type='array';return readSync(ab2a(d),o);}}switch((n=firstbyte(d,o))[0]){case 0xD0:if(n[1]===0xCF&&n[2]===0x11&&n[3]===0xE0&&n[4]===0xA1&&n[5]===0xB1&&n[6]===0x1A&&n[7]===0xE1)return read_cfb(CFB.read(d,o),o);break;case 0x09:if(n[1]<=0x08)return parse_xlscfb(d,o);break;case 0x3C:return parse_xlml(d,o);case 0x49:if(n[1]===0x49&&n[2]===0x2a&&n[3]===0x00)throw new Error("TIFF Image File is not a spreadsheet");if(n[1]===0x44)return read_wb_ID(d,o);break;case 0x54:if(n[1]===0x41&&n[2]===0x42&&n[3]===0x4C)return DIF.to_workbook(d,o);break;case 0x50:return n[1]===0x4B&&n[2]<0x09&&n[3]<0x09?read_zip(d,o):read_prn(data,d,o,str);case 0xEF:return n[3]===0x3C?parse_xlml(d,o):read_prn(data,d,o,str);case 0xFF:if(n[1]===0xFE){return read_utf16(d,o);}else if(n[1]===0x00&&n[2]===0x02&&n[3]===0x00)return WK_.to_workbook(d,o);break;case 0x00:if(n[1]===0x00){if(n[2]>=0x02&&n[3]===0x00)return WK_.to_workbook(d,o);if(n[2]===0x00&&(n[3]===0x08||n[3]===0x09))return WK_.to_workbook(d,o);}break;case 0x03:case 0x83:case 0x8B:case 0x8C:return DBF.to_workbook(d,o);case 0x7B:if(n[1]===0x5C&&n[2]===0x72&&n[3]===0x74)return RTF.to_workbook(d,o);break;case 0x0A:case 0x0D:case 0x20:return read_plaintext_raw(d,o);case 0x89:if(n[1]===0x50&&n[2]===0x4E&&n[3]===0x47)throw new Error("PNG Image File is not a spreadsheet");break;}if(DBF.versions.indexOf(n[0])>-1&&n[2]<=12&&n[3]<=31)return DBF.to_workbook(d,o);return read_prn(data,d,o,str);}function readFileSync(filename,opts){var o=opts||{};o.type='file';return readSync(filename,o);}function write_cfb_ctr(cfb,o){switch(o.type){case"base64":case"binary":break;case"buffer":case"array":o.type="";break;case"file":return write_dl(o.file,CFB.write(cfb,{type:has_buf?'buffer':""}));case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");default:throw new Error("Unrecognized type "+o.type);}return CFB.write(cfb,o);}function write_zip_type(wb,opts){var o=dup(opts||{});var z=write_zip(wb,o);var oopts={};if(o.compression)oopts.compression='DEFLATE';if(o.password)oopts.type=has_buf?"nodebuffer":"string";else switch(o.type){case"base64":oopts.type="base64";break;case"binary":oopts.type="string";break;case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");case"buffer":case"file":oopts.type=has_buf?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+o.type);}var out=z.FullPaths?CFB.write(z,{fileType:"zip",type:{"nodebuffer":"buffer","string":"binary"}[oopts.type]||oopts.type}):z.generate(oopts);/*jshint -W083 */if(o.password&&typeof encrypt_agile!=='undefined')return write_cfb_ctr(encrypt_agile(out,o.password),o);// eslint-disable-line no-undef
/*jshint +W083 */if(o.type==="file")return write_dl(o.file,out);return o.type=="string"?utf8read(out):out;}function write_cfb_type(wb,opts){var o=opts||{};var cfb=write_xlscfb(wb,o);return write_cfb_ctr(cfb,o);}function write_string_type(out,opts,bom){if(!bom)bom="";var o=bom+out;switch(opts.type){case"base64":return Base64.encode(utf8write(o));case"binary":return utf8write(o);case"string":return out;case"file":return write_dl(opts.file,o,'utf8');case"buffer":{if(has_buf)return Buffer_from(o,'utf8');else return write_string_type(o,{type:'binary'}).split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}function write_stxt_type(out,opts){switch(opts.type){case"base64":return Base64.encode(out);case"binary":return out;case"string":return out;/* override in sheet_to_txt */case"file":return write_dl(opts.file,out,'binary');case"buffer":{if(has_buf)return Buffer_from(out,'binary');else return out.split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}/* TODO: test consistency */function write_binary_type(out,opts){switch(opts.type){case"string":case"base64":case"binary":var bstr="";// $FlowIgnore
for(var i=0;i<out.length;++i)bstr+=String.fromCharCode(out[i]);return opts.type=='base64'?Base64.encode(bstr):opts.type=='string'?utf8read(bstr):bstr;case"file":return write_dl(opts.file,out);case"buffer":return out;default:throw new Error("Unrecognized type "+opts.type);}}function writeSync(wb,opts){reset_cp();check_wb(wb);var o=dup(opts||{});if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out=writeSync(wb,o);o.type="array";return s2ab(out);}switch(o.bookType||'xlsb'){case'xml':case'xlml':return write_string_type(write_xlml(wb,o),o);case'slk':case'sylk':return write_string_type(write_slk_str(wb,o),o);case'htm':case'html':return write_string_type(write_htm_str(wb,o),o);case'txt':return write_stxt_type(write_txt_str(wb,o),o);case'csv':return write_string_type(write_csv_str(wb,o),o,"\ufeff");case'dif':return write_string_type(write_dif_str(wb,o),o);case'dbf':return write_binary_type(write_dbf_buf(wb,o),o);case'prn':return write_string_type(write_prn_str(wb,o),o);case'rtf':return write_string_type(write_rtf_str(wb,o),o);case'eth':return write_string_type(write_eth_str(wb,o),o);case'fods':return write_string_type(write_ods(wb,o),o);case'wk1':return write_binary_type(write_wk1_buf(wb,o),o);case'wk3':return write_binary_type(WK_.book_to_wk3(wb,o),o);case'biff2':if(!o.biff)o.biff=2;/* falls through */case'biff3':if(!o.biff)o.biff=3;/* falls through */case'biff4':if(!o.biff)o.biff=4;return write_binary_type(write_biff_buf(wb,o),o);case'biff5':if(!o.biff)o.biff=5;/* falls through */case'biff8':case'xla':case'xls':if(!o.biff)o.biff=8;return write_cfb_type(wb,o);case'xlsx':case'xlsm':case'xlam':case'xlsb':case'ods':return write_zip_type(wb,o);default:throw new Error("Unrecognized bookType |"+o.bookType+"|");}}function resolve_book_type(o){if(o.bookType)return;var _BT={"xls":"biff8","htm":"html","slk":"sylk","socialcalc":"eth","Sh33tJS":"WTF"};var ext=o.file.slice(o.file.lastIndexOf(".")).toLowerCase();if(ext.match(/^\.[a-z]+$/))o.bookType=ext.slice(1);o.bookType=_BT[o.bookType]||o.bookType;}function writeFileSync(wb,filename,opts){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSync(wb,o);}function writeFileAsync(filename,wb,opts,cb){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);o.type='buffer';var _cb=cb;if(!(_cb instanceof Function))_cb=opts;return _fs.writeFile(filename,writeSync(wb,o),_cb);}function make_json_row(sheet,r,R,cols,header,hdr,dense,o){var rr=encode_row(R);var defval=o.defval,raw=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw");var isempty=true;var row=header===1?[]:{};if(header!==1){if(Object.defineProperty)try{Object.defineProperty(row,'__rowNum__',{value:R,enumerable:false});}catch(e){row.__rowNum__=R;}else row.__rowNum__=R;}if(!dense||sheet[R])for(var C=r.s.c;C<=r.e.c;++C){var val=dense?sheet[R][C]:sheet[cols[C]+rr];if(val===undefined||val.t===undefined){if(defval===undefined)continue;if(hdr[C]!=null){row[hdr[C]]=defval;}continue;}var v=val.v;switch(val.t){case'z':if(v==null)break;continue;case'e':v=v==0?null:void 0;break;case's':case'd':case'b':case'n':break;default:throw new Error('unrecognized type '+val.t);}if(hdr[C]!=null){if(v==null){if(val.t=="e"&&v===null)row[hdr[C]]=null;else if(defval!==undefined)row[hdr[C]]=defval;else if(raw&&v===null)row[hdr[C]]=null;else continue;}else{row[hdr[C]]=raw||o.rawNumbers&&val.t=="n"?v:format_cell(val,v,o);}if(v!=null)isempty=false;}}return{row:row,isempty:isempty};}function sheet_to_json(sheet,opts){if(sheet==null||sheet["!ref"]==null)return[];var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;else if(o.header==null)header=0;switch(typeof range){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var out=[];var outi=0,counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0,CC=0;if(dense&&!sheet[R])sheet[R]=[];for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=0;for(CC=0;CC<hdr.length;++CC)if(hdr[CC]==vv)vv=v+"_"+ ++counter;hdr[C]=vv;}}for(R=r.s.r+offset;R<=r.e.r;++R){var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows))out[outi++]=row.row;}out.length=outi;return out;}var qreg=/"/g;function make_csv_row(sheet,r,R,cols,fs,rs,FS,o){var isempty=true;var row=[],txt="",rr=encode_row(R);for(var C=r.s.c;C<=r.e.c;++C){if(!cols[C])continue;var val=o.dense?(sheet[R]||[])[C]:sheet[cols[C]+rr];if(val==null)txt="";else if(val.v!=null){isempty=false;txt=''+(o.rawNumbers&&val.t=="n"?val.v:format_cell(val,null,o));for(var i=0,cc=0;i!==txt.length;++i)if((cc=txt.charCodeAt(i))===fs||cc===rs||cc===34||o.forceQuotes){txt="\""+txt.replace(qreg,'""')+"\"";break;}if(txt=="ID")txt='"ID"';}else if(val.f!=null&&!val.F){isempty=false;txt='='+val.f;if(txt.indexOf(",")>=0)txt='"'+txt.replace(qreg,'""')+'"';}else txt="";/* NOTE: Excel CSV does not support array formulae */row.push(txt);}if(o.blankrows===false&&isempty)return null;return row.join(FS);}function sheet_to_csv(sheet,opts){var out=[];var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null)return"";var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C)if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);for(var R=r.s.r;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;row=make_csv_row(sheet,r,R,cols,fs,rs,FS,o);if(row==null){continue;}if(o.strip)row=row.replace(endregex,"");out.push(row+RS);}delete o.dense;return out.join("");}function sheet_to_txt(sheet,opts){if(!opts)opts={};opts.FS="\t";opts.RS="\n";var s=sheet_to_csv(sheet,opts);if(typeof cptable=='undefined'||opts.type=='string')return s;var o=cptable.utils.encode(1200,s,'str');return String.fromCharCode(255)+String.fromCharCode(254)+o;}function sheet_to_formulae(sheet){var y="",x,val="";if(sheet==null||sheet["!ref"]==null)return[];var r=safe_decode_range(sheet['!ref']),rr="",cols=[],C;var cmds=[];var dense=Array.isArray(sheet);for(C=r.s.c;C<=r.e.c;++C)cols[C]=encode_col(C);for(var R=r.s.r;R<=r.e.r;++R){rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){y=cols[C]+rr;x=dense?(sheet[R]||[])[C]:sheet[y];val="";if(x===undefined)continue;else if(x.F!=null){y=x.F;if(!x.f)continue;val=x.f;if(y.indexOf(":")==-1)y=y+":"+y;}if(x.f!=null)val=x.f;else if(x.t=='z')continue;else if(x.t=='n'&&x.v!=null)val=""+x.v;else if(x.t=='b')val=x.v?"TRUE":"FALSE";else if(x.w!==undefined)val="'"+x.w;else if(x.v===undefined)continue;else if(x.t=='s')val="'"+x.v;else val=""+x.v;cmds[cmds.length]=y+"="+val;}}return cmds;}function sheet_add_json(_ws,js,opts){var o=opts||{};var offset=+!o.skipHeader;var ws=_ws||{};var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}}var cell;var range={s:{c:0,r:0},e:{c:_C,r:_R+js.length-1+offset}};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1){_R=_range.e.r+1;range.e.r=_R+js.length-1+offset;}}else{if(_R==-1){_R=0;range.e.r=js.length-1+offset;}}var hdr=o.header||[],C=0;js.forEach(function(JS,R){keys(JS).forEach(function(k){if((C=hdr.indexOf(k))==-1)hdr[C=hdr.length]=k;var v=JS[k];var t='z';var z="";var ref=encode_cell({c:_C+C,r:_R+R+offset});cell=utils.sheet_get_cell(ws,ref);if(v&&typeof v==='object'&&!(v instanceof Date)){ws[ref]=v;}else{if(typeof v=='number')t='n';else if(typeof v=='boolean')t='b';else if(typeof v=='string')t='s';else if(v instanceof Date){t='d';if(!o.cellDates){t='n';v=datenum(v);}z=o.dateNF||SSF._table[14];}else if(v===null&&o.nullError){t='e';v=0;}if(!cell)ws[ref]=cell={t:t,v:v};else{cell.t=t;cell.v=v;delete cell.w;delete cell.R;if(z)cell.z=z;}if(z)cell.z=z;}});});range.e.c=Math.max(range.e.c,_C+hdr.length-1);var __R=encode_row(_R);if(offset)for(C=0;C<hdr.length;++C)ws[encode_col(C+_C)+__R]={t:'s',v:hdr[C]};ws['!ref']=encode_range(range);return ws;}function json_to_sheet(js,opts){return sheet_add_json(null,js,opts);}var utils={encode_col:encode_col,encode_row:encode_row,encode_cell:encode_cell,encode_range:encode_range,decode_col:decode_col,decode_row:decode_row,split_cell:split_cell,decode_cell:decode_cell,decode_range:decode_range,format_cell:format_cell,get_formulae:sheet_to_formulae,make_csv:sheet_to_csv,make_json:sheet_to_json,make_formulae:sheet_to_formulae,sheet_add_aoa:sheet_add_aoa,sheet_add_json:sheet_add_json,sheet_add_dom:sheet_add_dom,aoa_to_sheet:aoa_to_sheet,json_to_sheet:json_to_sheet,table_to_sheet:parse_dom_table,table_to_book:table_to_book,sheet_to_csv:sheet_to_csv,sheet_to_txt:sheet_to_txt,sheet_to_json:sheet_to_json,sheet_to_html:HTML_.from_sheet,sheet_to_formulae:sheet_to_formulae,sheet_to_row_object_array:sheet_to_json};(function(utils){utils.consts=utils.consts||{};function add_consts(R/*Array<any>*/){R.forEach(function(a){utils.consts[a[0]]=a[1];});}function get_default(x,y,z){return x[y]!=null?x[y]:x[y]=z;}/* get cell, creating a stub if necessary */function ws_get_cell_stub(ws,R,C){/* A1 cell address */if(typeof R=="string"){/* dense */if(Array.isArray(ws)){var RC=decode_cell(R);if(!ws[RC.r])ws[RC.r]=[];return ws[RC.r][RC.c]||(ws[RC.r][RC.c]={t:'z'});}return ws[R]||(ws[R]={t:'z'});}/* cell address object */if(typeof R!="number")return ws_get_cell_stub(ws,encode_cell(R));/* R and C are 0-based indices */return ws_get_cell_stub(ws,encode_cell({r:R,c:C||0}));}utils.sheet_get_cell=ws_get_cell_stub;/* find sheet index for given name / validate index */function wb_sheet_idx(wb,sh){if(typeof sh=="number"){if(sh>=0&&wb.SheetNames.length>sh)return sh;throw new Error("Cannot find sheet # "+sh);}else if(typeof sh=="string"){var idx=wb.SheetNames.indexOf(sh);if(idx>-1)return idx;throw new Error("Cannot find sheet name |"+sh+"|");}else throw new Error("Cannot find sheet |"+sh+"|");}/* simple blank workbook object */utils.book_new=function(){return{SheetNames:[],Sheets:{}};};/* add a worksheet to the end of a given workbook */utils.book_append_sheet=function(wb,ws,name){if(!name)for(var i=1;i<=0xFFFF;++i,name=undefined)if(wb.SheetNames.indexOf(name="Sheet"+i)==-1)break;if(!name||wb.SheetNames.length>=0xFFFF)throw new Error("Too many worksheets");check_ws_name(name);if(wb.SheetNames.indexOf(name)>=0)throw new Error("Worksheet with name |"+name+"| already exists!");wb.SheetNames.push(name);wb.Sheets[name]=ws;};/* set sheet visibility (visible/hidden/very hidden) */utils.book_set_sheet_visibility=function(wb,sh,vis){get_default(wb,"Workbook",{});get_default(wb.Workbook,"Sheets",[]);var idx=wb_sheet_idx(wb,sh);// $FlowIgnore
get_default(wb.Workbook.Sheets,idx,{});switch(vis){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+vis);}// $FlowIgnore
wb.Workbook.Sheets[idx].Hidden=vis;};add_consts([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);/* set number format */utils.cell_set_number_format=function(cell,fmt){cell.z=fmt;return cell;};/* set cell hyperlink */utils.cell_set_hyperlink=function(cell,target,tooltip){if(!target){delete cell.l;}else{cell.l={Target:target};if(tooltip)cell.l.Tooltip=tooltip;}return cell;};utils.cell_set_internal_link=function(cell,range,tooltip){return utils.cell_set_hyperlink(cell,"#"+range,tooltip);};/* add to cell comments */utils.cell_add_comment=function(cell,text,author){if(!cell.c)cell.c=[];cell.c.push({t:text,a:author||"SheetJS"});};/* set array formula and flush related cells */utils.sheet_set_array_formula=function(ws,range,formula){var rng=typeof range!="string"?range:safe_decode_range(range);var rngstr=typeof range=="string"?range:encode_range(range);for(var R=rng.s.r;R<=rng.e.r;++R)for(var C=rng.s.c;C<=rng.e.c;++C){var cell=ws_get_cell_stub(ws,R,C);cell.t='n';cell.F=rngstr;delete cell.v;if(R==rng.s.r&&C==rng.s.c)cell.f=formula;}return ws;};return utils;})(utils);if(has_buf&&typeof require!='undefined')(function(){var strmod=require('stream');if(!strmod)return;var Readable=strmod.Readable;if(!Readable)return;var write_csv_stream=function(sheet,opts){var stream=Readable();var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols=[];o.dense=Array.isArray(sheet);var colinfo=o.skipHidden&&sheet["!cols"]||[];var rowinfo=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C)if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);var R=r.s.r;var BOM=false;stream._read=function(){if(!BOM){BOM=true;return stream.push("\uFEFF");}while(R<=r.e.r){++R;if((rowinfo[R-1]||{}).hidden)continue;row=make_csv_row(sheet,r,R-1,cols,fs,rs,FS,o);if(row!=null){if(o.strip)row=row.replace(endregex,"");stream.push(row+RS);break;}}if(R>r.e.r)return stream.push(null);};return stream;};var write_html_stream=function(ws,opts){var stream=Readable();var o=opts||{};var header=o.header!=null?o.header:HTML_.BEGIN;var footer=o.footer!=null?o.footer:HTML_.END;stream.push(header);var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);stream.push(HTML_._preamble(ws,r,o));var R=r.s.r;var end=false;stream._read=function(){if(R>r.e.r){if(!end){end=true;stream.push("</table>"+footer);}return stream.push(null);}while(R<=r.e.r){stream.push(HTML_._row(ws,r,R,o));++R;break;}};return stream;};var write_json_stream=function(sheet,opts){var stream=Readable({objectMode:true});if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var val={t:'n',v:0},header=0,offset=1,hdr=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;switch(typeof range){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=[];var counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0,CC=0;if(dense&&!sheet[R])sheet[R]=[];for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=0;for(CC=0;CC<hdr.length;++CC)if(hdr[CC]==vv)vv=v+"_"+ ++counter;hdr[C]=vv;}}R=r.s.r+offset;stream._read=function(){if(R>r.e.r)return stream.push(null);while(R<=r.e.r){//if ((rowinfo[R-1]||{}).hidden) continue;
var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);++R;if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows)){stream.push(row.row);break;}}};return stream;};XLSX.stream={to_json:write_json_stream,to_html:write_html_stream,to_csv:write_csv_stream};})();if(typeof parse_xlscfb!=="undefined")XLSX.parse_xlscfb=parse_xlscfb;XLSX.parse_zip=parse_zip;XLSX.read=readSync;//xlsread
XLSX.readFile=readFileSync;//readFile
XLSX.readFileSync=readFileSync;XLSX.write=writeSync;XLSX.writeFile=writeFileSync;XLSX.writeFileSync=writeFileSync;XLSX.writeFileAsync=writeFileAsync;XLSX.utils=utils;XLSX.SSF=SSF;if(typeof CFB!=="undefined")XLSX.CFB=CFB;}/*global define */if(typeof exports!=='undefined')make_xlsx_lib(exports);else if(typeof module!=='undefined'&&module.exports)make_xlsx_lib(module.exports);else if(typeof define==='function'&&define.amd)define('xlsx',function(){if(!XLSX.version)make_xlsx_lib(XLSX);return XLSX;});else make_xlsx_lib(XLSX);/* NOTE: the following extra line is needed for "Lightning Locker Service" */if(typeof window!=='undefined'&&!window.XLSX)try{window.XLSX=XLSX;}catch(e){}/*exported XLS, ODS */var XLS=XLSX,ODS=XLSX;
/*!

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE
*/
(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.JSZip = f();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }
        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  }({
    1: [function (require, module, exports) {
      'use strict';

      var DataReader = require('./dataReader');
      function ArrayReader(data) {
        if (data) {
          this.data = data;
          this.length = this.data.length;
          this.index = 0;
          this.zero = 0;
          for (var i = 0; i < this.data.length; i++) {
            data[i] = data[i] & 0xFF;
          }
        }
      }
      ArrayReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */
      ArrayReader.prototype.byteAt = function (i) {
        return this.data[this.zero + i];
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      ArrayReader.prototype.lastIndexOfSignature = function (sig) {
        var sig0 = sig.charCodeAt(0),
          sig1 = sig.charCodeAt(1),
          sig2 = sig.charCodeAt(2),
          sig3 = sig.charCodeAt(3);
        for (var i = this.length - 4; i >= 0; --i) {
          if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
          }
        }
        return -1;
      };
      /**
       * @see DataReader.readData
       */
      ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);
        if (size === 0) {
          return [];
        }
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = ArrayReader;
    }, {
      "./dataReader": 6
    }],
    2: [function (require, module, exports) {
      'use strict';

      // private property
      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

      // public method for encoding
      exports.encode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = (chr1 & 3) << 4 | chr2 >> 4;
          enc3 = (chr2 & 15) << 2 | chr3 >> 6;
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }
          output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
      };

      // public method for decoding
      exports.decode = function (input, utf8) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = enc1 << 2 | enc2 >> 4;
          chr2 = (enc2 & 15) << 4 | enc3 >> 2;
          chr3 = (enc3 & 3) << 6 | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }
        }
        return output;
      };
    }, {}],
    3: [function (require, module, exports) {
      'use strict';

      function CompressedObject() {
        this.compressedSize = 0;
        this.uncompressedSize = 0;
        this.crc32 = 0;
        this.compressionMethod = null;
        this.compressedContent = null;
      }
      CompressedObject.prototype = {
        /**
         * Return the decompressed content in an unspecified format.
         * The format will depend on the decompressor.
         * @return {Object} the decompressed content.
         */
        getContent: function () {
          return null; // see implementation
        },

        /**
         * Return the compressed content in an unspecified format.
         * The format will depend on the compressed conten source.
         * @return {Object} the compressed content.
         */
        getCompressedContent: function () {
          return null; // see implementation
        }
      };

      module.exports = CompressedObject;
    }, {}],
    4: [function (require, module, exports) {
      'use strict';

      exports.STORE = {
        magic: "\x00\x00",
        compress: function (content, compressionOptions) {
          return content; // no compression
        },

        uncompress: function (content) {
          return content; // no compression
        },

        compressInputType: null,
        uncompressInputType: null
      };
      exports.DEFLATE = require('./flate');
    }, {
      "./flate": 9
    }],
    5: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];

      /**
       *
       *  Javascript crc32
       *  http://www.webtoolkit.info/
       *
       */
      module.exports = function crc32(input, crc) {
        if (typeof input === "undefined" || !input.length) {
          return 0;
        }
        var isArray = utils.getTypeOf(input) !== "string";
        if (typeof crc == "undefined") {
          crc = 0;
        }
        var x = 0;
        var y = 0;
        var b = 0;
        crc = crc ^ -1;
        for (var i = 0, iTop = input.length; i < iTop; i++) {
          b = isArray ? input[i] : input.charCodeAt(i);
          y = (crc ^ b) & 0xFF;
          x = table[y];
          crc = crc >>> 8 ^ x;
        }
        return crc ^ -1;
      };
      // vim: set shiftwidth=4 softtabstop=4:
    }, {
      "./utils": 22
    }],
    6: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      function DataReader(data) {
        this.data = null; // type : see implementation
        this.length = 0;
        this.index = 0;
        this.zero = 0;
      }
      DataReader.prototype = {
        /**
         * Check that the offset will not go too far.
         * @param {string} offset the additional offset to check.
         * @throws {Error} an Error if the offset is out of bounds.
         */
        checkOffset: function (offset) {
          this.checkIndex(this.index + offset);
        },
        /**
         * Check that the specifed index will not be too far.
         * @param {string} newIndex the index to check.
         * @throws {Error} an Error if the index is out of bounds.
         */
        checkIndex: function (newIndex) {
          if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
          }
        },
        /**
         * Change the index.
         * @param {number} newIndex The new index.
         * @throws {Error} if the new index is out of the data.
         */
        setIndex: function (newIndex) {
          this.checkIndex(newIndex);
          this.index = newIndex;
        },
        /**
         * Skip the next n bytes.
         * @param {number} n the number of bytes to skip.
         * @throws {Error} if the new index is out of the data.
         */
        skip: function (n) {
          this.setIndex(this.index + n);
        },
        /**
         * Get the byte at the specified index.
         * @param {number} i the index to use.
         * @return {number} a byte.
         */
        byteAt: function (i) {
          // see implementations
        },
        /**
         * Get the next number with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {number} the corresponding number.
         */
        readInt: function (size) {
          var result = 0,
            i;
          this.checkOffset(size);
          for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
          }
          this.index += size;
          return result;
        },
        /**
         * Get the next string with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {string} the corresponding string.
         */
        readString: function (size) {
          return utils.transformTo("string", this.readData(size));
        },
        /**
         * Get raw data without conversion, <size> bytes.
         * @param {number} size the number of bytes to read.
         * @return {Object} the raw data, implementation specific.
         */
        readData: function (size) {
          // see implementations
        },
        /**
         * Find the last occurence of a zip signature (4 bytes).
         * @param {string} sig the signature to find.
         * @return {number} the index of the last occurence, -1 if not found.
         */
        lastIndexOfSignature: function (sig) {
          // see implementations
        },
        /**
         * Get the next date.
         * @return {Date} the date.
         */
        readDate: function () {
          var dostime = this.readInt(4);
          return new Date((dostime >> 25 & 0x7f) + 1980,
          // year
          (dostime >> 21 & 0x0f) - 1,
          // month
          dostime >> 16 & 0x1f,
          // day
          dostime >> 11 & 0x1f,
          // hour
          dostime >> 5 & 0x3f,
          // minute
          (dostime & 0x1f) << 1); // second
        }
      };

      module.exports = DataReader;
    }, {
      "./utils": 22
    }],
    7: [function (require, module, exports) {
      'use strict';

      exports.base64 = false;
      exports.binary = false;
      exports.dir = false;
      exports.createFolders = false;
      exports.date = null;
      exports.compression = null;
      exports.compressionOptions = null;
      exports.comment = null;
      exports.unixPermissions = null;
      exports.dosPermissions = null;
    }, {}],
    8: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2binary = function (str) {
        return utils.string2binary(str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2Uint8Array = function (str) {
        return utils.transformTo("uint8array", str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.uint8Array2String = function (array) {
        return utils.transformTo("string", array);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.string2Blob = function (str) {
        var buffer = utils.transformTo("arraybuffer", str);
        return utils.arrayBuffer2Blob(buffer);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.arrayBuffer2Blob = function (buffer) {
        return utils.arrayBuffer2Blob(buffer);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.transformTo = function (outputType, input) {
        return utils.transformTo(outputType, input);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.getTypeOf = function (input) {
        return utils.getTypeOf(input);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.checkSupport = function (type) {
        return utils.checkSupport(type);
      };

      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */
      exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

      /**
       * @deprecated
       * This value will be removed in a future version without replacement.
       */
      exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.pretty = function (str) {
        return utils.pretty(str);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.findCompression = function (compressionMethod) {
        return utils.findCompression(compressionMethod);
      };

      /**
       * @deprecated
       * This function will be removed in a future version without replacement.
       */
      exports.isRegExp = function (object) {
        return utils.isRegExp(object);
      };
    }, {
      "./utils": 22
    }],
    9: [function (require, module, exports) {
      'use strict';

      var USE_TYPEDARRAY = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Uint32Array !== 'undefined';
      var pako = require("pako");
      exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.magic = "\x08\x00";
      exports.compress = function (input, compressionOptions) {
        return pako.deflateRaw(input, {
          level: compressionOptions.level || -1 // default compression
        });
      };

      exports.uncompress = function (input) {
        return pako.inflateRaw(input);
      };
    }, {
      "pako": 25
    }],
    10: [function (require, module, exports) {
      'use strict';

      var base64 = require('./base64');

      /**
      Usage:
         zip = new JSZip();
         zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
         zip.folder("images").file("smile.gif", base64Data, {base64: true});
         zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
         zip.remove("tempfile");
      
         base64zip = zip.generate();
      
      **/

      /**
       * Representation a of zip file in js
       * @constructor
       * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
       * @param {Object=} options the options for creating this objects (optional).
       */
      function JSZip(data, options) {
        // if this constructor is used without `new`, it adds `new` before itself:
        if (!(this instanceof JSZip)) return new JSZip(data, options);

        // object containing the files :
        // {
        //   "folder/" : {...},
        //   "folder/data.txt" : {...}
        // }
        this.files = {};
        this.comment = null;

        // Where we are in the hierarchy
        this.root = "";
        if (data) {
          this.load(data, options);
        }
        this.clone = function () {
          var newObj = new JSZip();
          for (var i in this) {
            if (typeof this[i] !== "function") {
              newObj[i] = this[i];
            }
          }
          return newObj;
        };
      }
      JSZip.prototype = require('./object');
      JSZip.prototype.load = require('./load');
      JSZip.support = require('./support');
      JSZip.defaults = require('./defaults');

      /**
       * @deprecated
       * This namespace will be removed in a future version without replacement.
       */
      JSZip.utils = require('./deprecatedPublicUtils');
      JSZip.base64 = {
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        encode: function (input) {
          return base64.encode(input);
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        decode: function (input) {
          return base64.decode(input);
        }
      };
      JSZip.compressions = require('./compressions');
      module.exports = JSZip;
    }, {
      "./base64": 2,
      "./compressions": 4,
      "./defaults": 7,
      "./deprecatedPublicUtils": 8,
      "./load": 11,
      "./object": 14,
      "./support": 18
    }],
    11: [function (require, module, exports) {
      'use strict';

      var base64 = require('./base64');
      var utf8 = require('./utf8');
      var utils = require('./utils');
      var ZipEntries = require('./zipEntries');
      module.exports = function (data, options) {
        var files, zipEntries, i, input;
        options = utils.extend(options || {}, {
          base64: false,
          checkCRC32: false,
          optimizedBinaryString: false,
          createFolders: false,
          decodeFileName: utf8.utf8decode
        });
        if (options.base64) {
          data = base64.decode(data);
        }
        zipEntries = new ZipEntries(data, options);
        files = zipEntries.files;
        for (i = 0; i < files.length; i++) {
          input = files[i];
          this.file(input.fileNameStr, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment: input.fileCommentStr.length ? input.fileCommentStr : null,
            unixPermissions: input.unixPermissions,
            dosPermissions: input.dosPermissions,
            createFolders: options.createFolders
          });
        }
        if (zipEntries.zipComment.length) {
          this.comment = zipEntries.zipComment;
        }
        return this;
      };
    }, {
      "./base64": 2,
      "./utf8": 21,
      "./utils": 22,
      "./zipEntries": 23
    }],
    12: [function (require, module, exports) {
      (function (Buffer) {
        'use strict';

        module.exports = function (data, encoding) {
          return new Buffer(data, encoding);
        };
        module.exports.test = function (b) {
          return Buffer.isBuffer(b);
        };
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    13: [function (require, module, exports) {
      'use strict';

      var Uint8ArrayReader = require('./uint8ArrayReader');
      function NodeBufferReader(data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
        this.zero = 0;
      }
      NodeBufferReader.prototype = new Uint8ArrayReader();

      /**
       * @see DataReader.readData
       */
      NodeBufferReader.prototype.readData = function (size) {
        this.checkOffset(size);
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = NodeBufferReader;
    }, {
      "./uint8ArrayReader": 19
    }],
    14: [function (require, module, exports) {
      'use strict';

      var support = require('./support');
      var utils = require('./utils');
      var crc32 = require('./crc32');
      var signature = require('./signature');
      var defaults = require('./defaults');
      var base64 = require('./base64');
      var compressions = require('./compressions');
      var CompressedObject = require('./compressedObject');
      var nodeBuffer = require('./nodeBuffer');
      var utf8 = require('./utf8');
      var StringWriter = require('./stringWriter');
      var Uint8ArrayWriter = require('./uint8ArrayWriter');

      /**
       * Returns the raw data of a ZipObject, decompress the content if necessary.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */
      var getRawData = function (file) {
        if (file._data instanceof CompressedObject) {
          file._data = file._data.getContent();
          file.options.binary = true;
          file.options.base64 = false;
          if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data;
            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
            file._data = new Uint8Array(copy.length);
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            if (copy.length !== 0) {
              file._data.set(copy, 0);
            }
          }
        }
        return file._data;
      };

      /**
       * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
       * @param {ZipObject} file the file to use.
       * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
       */
      var getBinaryData = function (file) {
        var result = getRawData(file),
          type = utils.getTypeOf(result);
        if (type === "string") {
          if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
              return nodeBuffer(result, "utf-8");
            }
          }
          return file.asBinary();
        }
        return result;
      };

      /**
       * Transform this._data into a string.
       * @param {function} filter a function String -> String, applied if not null on the result.
       * @return {String} the string representing this._data.
       */
      var dataToString = function (asUTF8) {
        var result = getRawData(this);
        if (result === null || typeof result === "undefined") {
          return "";
        }
        // if the data is a base64 string, we decode it before checking the encoding !
        if (this.options.base64) {
          result = base64.decode(result);
        }
        if (asUTF8 && this.options.binary) {
          // JSZip.prototype.utf8decode supports arrays as input
          // skip to array => string step, utf8decode will do it.
          result = out.utf8decode(result);
        } else {
          // no utf8 transformation, do the array => string step.
          result = utils.transformTo("string", result);
        }
        if (!asUTF8 && !this.options.binary) {
          result = utils.transformTo("string", out.utf8encode(result));
        }
        return result;
      };
      /**
       * A simple object representing a file in the zip file.
       * @constructor
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
       * @param {Object} options the options of the file
       */
      var ZipObject = function (name, data, options) {
        this.name = name;
        this.dir = options.dir;
        this.date = options.date;
        this.comment = options.comment;
        this.unixPermissions = options.unixPermissions;
        this.dosPermissions = options.dosPermissions;
        this._data = data;
        this.options = options;

        /*
         * This object contains initial values for dir and date.
         * With them, we can check if the user changed the deprecated metadata in
         * `ZipObject#options` or not.
         */
        this._initialMetadata = {
          dir: options.dir,
          date: options.date
        };
      };
      ZipObject.prototype = {
        /**
         * Return the content as UTF8 string.
         * @return {string} the UTF8 string.
         */
        asText: function () {
          return dataToString.call(this, true);
        },
        /**
         * Returns the binary content.
         * @return {string} the content as binary.
         */
        asBinary: function () {
          return dataToString.call(this, false);
        },
        /**
         * Returns the content as a nodejs Buffer.
         * @return {Buffer} the content as a Buffer.
         */
        asNodeBuffer: function () {
          var result = getBinaryData(this);
          return utils.transformTo("nodebuffer", result);
        },
        /**
         * Returns the content as an Uint8Array.
         * @return {Uint8Array} the content as an Uint8Array.
         */
        asUint8Array: function () {
          var result = getBinaryData(this);
          return utils.transformTo("uint8array", result);
        },
        /**
         * Returns the content as an ArrayBuffer.
         * @return {ArrayBuffer} the content as an ArrayBufer.
         */
        asArrayBuffer: function () {
          return this.asUint8Array().buffer;
        }
      };

      /**
       * Transform an integer into a string in hexadecimal.
       * @private
       * @param {number} dec the number to convert.
       * @param {number} bytes the number of bytes to generate.
       * @returns {string} the result.
       */
      var decToHex = function (dec, bytes) {
        var hex = "",
          i;
        for (i = 0; i < bytes; i++) {
          hex += String.fromCharCode(dec & 0xff);
          dec = dec >>> 8;
        }
        return hex;
      };

      /**
       * Transforms the (incomplete) options from the user into the complete
       * set of options to create a file.
       * @private
       * @param {Object} o the options from the user.
       * @return {Object} the complete set of options.
       */
      var prepareFileAttrs = function (o) {
        o = o || {};
        if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
          o.binary = true;
        }
        o = utils.extend(o, defaults);
        o.date = o.date || new Date();
        if (o.compression !== null) o.compression = o.compression.toUpperCase();
        return o;
      };

      /**
       * Add a file in the current folder.
       * @private
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
       * @param {Object} o the options of the file
       * @return {Object} the new file.
       */
      var fileAdd = function (name, data, o) {
        // be sure sub folders exist
        var dataType = utils.getTypeOf(data),
          parent;
        o = prepareFileAttrs(o);
        if (typeof o.unixPermissions === "string") {
          o.unixPermissions = parseInt(o.unixPermissions, 8);
        }

        // UNX_IFDIR  0040000 see zipinfo.c
        if (o.unixPermissions && o.unixPermissions & 0x4000) {
          o.dir = true;
        }
        // Bit 4    Directory
        if (o.dosPermissions && o.dosPermissions & 0x0010) {
          o.dir = true;
        }
        if (o.dir) {
          name = forceTrailingSlash(name);
        }
        if (o.createFolders && (parent = parentFolder(name))) {
          folderAdd.call(this, parent, true);
        }
        if (o.dir || data === null || typeof data === "undefined") {
          o.base64 = false;
          o.binary = false;
          data = null;
          dataType = null;
        } else if (dataType === "string") {
          if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
              // this is a string, not in a base64 format.
              // Be sure that this is a correct "binary string"
              data = utils.string2binary(data);
            }
          }
        } else {
          // arraybuffer, uint8array, ...
          o.base64 = false;
          o.binary = true;
          if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
          }

          // special case : it's way easier to work with Uint8Array than with ArrayBuffer
          if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
          }
        }
        var object = new ZipObject(name, data, o);
        this.files[name] = object;
        return object;
      };

      /**
       * Find the parent folder of the path.
       * @private
       * @param {string} path the path to use
       * @return {string} the parent folder, or ""
       */
      var parentFolder = function (path) {
        if (path.slice(-1) == '/') {
          path = path.substring(0, path.length - 1);
        }
        var lastSlash = path.lastIndexOf('/');
        return lastSlash > 0 ? path.substring(0, lastSlash) : "";
      };

      /**
       * Returns the path with a slash at the end.
       * @private
       * @param {String} path the path to check.
       * @return {String} the path with a trailing slash.
       */
      var forceTrailingSlash = function (path) {
        // Check the name ends with a /
        if (path.slice(-1) != "/") {
          path += "/"; // IE doesn't like substr(-1)
        }

        return path;
      };
      /**
       * Add a (sub) folder in the current folder.
       * @private
       * @param {string} name the folder's name
       * @param {boolean=} [createFolders] If true, automatically create sub
       *  folders. Defaults to false.
       * @return {Object} the new folder.
       */
      var folderAdd = function (name, createFolders) {
        createFolders = typeof createFolders !== 'undefined' ? createFolders : false;
        name = forceTrailingSlash(name);

        // Does this folder already exist?
        if (!this.files[name]) {
          fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
          });
        }
        return this.files[name];
      };

      /**
       * Generate a JSZip.CompressedObject for a given zipOject.
       * @param {ZipObject} file the object to read.
       * @param {JSZip.compression} compression the compression to use.
       * @param {Object} compressionOptions the options to use when compressing.
       * @return {JSZip.CompressedObject} the compressed result.
       */
      var generateCompressedObjectFrom = function (file, compression, compressionOptions) {
        var result = new CompressedObject(),
          content;

        // the data has not been decompressed, we might reuse things !
        if (file._data instanceof CompressedObject) {
          result.uncompressedSize = file._data.uncompressedSize;
          result.crc32 = file._data.crc32;
          if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
          } else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
          } else {
            content = file._data.getContent();
            // need to decompress / recompress
            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
          }
        } else {
          // have uncompressed data
          content = getBinaryData(file);
          if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
          }
          result.uncompressedSize = content.length;
          result.crc32 = crc32(content);
          result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
        }
        result.compressedSize = result.compressedContent.length;
        result.compressionMethod = compression.magic;
        return result;
      };

      /**
       * Generate the UNIX part of the external file attributes.
       * @param {Object} unixPermissions the unix permissions or null.
       * @param {Boolean} isDir true if the entry is a directory, false otherwise.
       * @return {Number} a 32 bit integer.
       *
       * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
       *
       * TTTTsstrwxrwxrwx0000000000ADVSHR
       * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
       *     ^^^_________________________ setuid, setgid, sticky
       *        ^^^^^^^^^________________ permissions
       *                 ^^^^^^^^^^______ not used ?
       *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
       */
      var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
        var result = unixPermissions;
        if (!unixPermissions) {
          // I can't use octal values in strict mode, hence the hexa.
          //  040775 => 0x41fd
          // 0100664 => 0x81b4
          result = isDir ? 0x41fd : 0x81b4;
        }
        return (result & 0xFFFF) << 16;
      };

      /**
       * Generate the DOS part of the external file attributes.
       * @param {Object} dosPermissions the dos permissions or null.
       * @param {Boolean} isDir true if the entry is a directory, false otherwise.
       * @return {Number} a 32 bit integer.
       *
       * Bit 0     Read-Only
       * Bit 1     Hidden
       * Bit 2     System
       * Bit 3     Volume Label
       * Bit 4     Directory
       * Bit 5     Archive
       */
      var generateDosExternalFileAttr = function (dosPermissions, isDir) {
        // the dir flag is already set for compatibility

        return (dosPermissions || 0) & 0x3F;
      };

      /**
       * Generate the various parts used in the construction of the final zip file.
       * @param {string} name the file name.
       * @param {ZipObject} file the file content.
       * @param {JSZip.CompressedObject} compressedObject the compressed object.
       * @param {number} offset the current offset from the start of the zip file.
       * @param {String} platform let's pretend we are this platform (change platform dependents fields)
       * @param {Function} encodeFileName the function to encode the file name / comment.
       * @return {object} the zip parts.
       */
      var generateZipParts = function (name, file, compressedObject, offset, platform, encodeFileName) {
        var data = compressedObject.compressedContent,
          useCustomEncoding = encodeFileName !== utf8.utf8encode,
          encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
          utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
          comment = file.comment || "",
          encodedComment = utils.transformTo("string", encodeFileName(comment)),
          utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
          useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
          useUTF8ForComment = utfEncodedComment.length !== comment.length,
          o = file.options,
          dosTime,
          dosDate,
          extraFields = "",
          unicodePathExtraField = "",
          unicodeCommentExtraField = "",
          dir,
          date;

        // handle the deprecated options.dir
        if (file._initialMetadata.dir !== file.dir) {
          dir = file.dir;
        } else {
          dir = o.dir;
        }

        // handle the deprecated options.date
        if (file._initialMetadata.date !== file.date) {
          date = file.date;
        } else {
          date = o.date;
        }
        var extFileAttr = 0;
        var versionMadeBy = 0;
        if (dir) {
          // dos or unix, we set the dos dir flag
          extFileAttr |= 0x00010;
        }
        if (platform === "UNIX") {
          versionMadeBy = 0x031E; // UNIX, version 3.0
          extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
        } else {
          // DOS or other, fallback to DOS
          versionMadeBy = 0x0014; // DOS, version 2.0
          extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
        }

        // date
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

        dosTime = date.getHours();
        dosTime = dosTime << 6;
        dosTime = dosTime | date.getMinutes();
        dosTime = dosTime << 5;
        dosTime = dosTime | date.getSeconds() / 2;
        dosDate = date.getFullYear() - 1980;
        dosDate = dosDate << 4;
        dosDate = dosDate | date.getMonth() + 1;
        dosDate = dosDate << 5;
        dosDate = dosDate | date.getDate();
        if (useUTF8ForFileName) {
          // set the unicode path extra field. unzip needs at least one extra
          // field to correctly handle unicode path, so using the path is as good
          // as any other information. This could improve the situation with
          // other archive managers too.
          // This field is usually used without the utf8 flag, with a non
          // unicode path in the header (winrar, winzip). This helps (a bit)
          // with the messy Windows' default compressed folders feature but
          // breaks on p7zip which doesn't seek the unicode path extra field.
          // So for now, UTF-8 everywhere !
          unicodePathExtraField =
          // Version
          decToHex(1, 1) +
          // NameCRC32
          decToHex(crc32(encodedFileName), 4) +
          // UnicodeName
          utfEncodedFileName;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x70" +
          // size
          decToHex(unicodePathExtraField.length, 2) +
          // content
          unicodePathExtraField;
        }
        if (useUTF8ForComment) {
          unicodeCommentExtraField =
          // Version
          decToHex(1, 1) +
          // CommentCRC32
          decToHex(this.crc32(encodedComment), 4) +
          // UnicodeName
          utfEncodedComment;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x63" +
          // size
          decToHex(unicodeCommentExtraField.length, 2) +
          // content
          unicodeCommentExtraField;
        }
        var header = "";

        // version needed to extract
        header += "\x0A\x00";
        // general purpose bit flag
        // set bit 11 if utf8
        header += !useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
        // compression method
        header += compressedObject.compressionMethod;
        // last mod file time
        header += decToHex(dosTime, 2);
        // last mod file date
        header += decToHex(dosDate, 2);
        // crc-32
        header += decToHex(compressedObject.crc32, 4);
        // compressed size
        header += decToHex(compressedObject.compressedSize, 4);
        // uncompressed size
        header += decToHex(compressedObject.uncompressedSize, 4);
        // file name length
        header += decToHex(encodedFileName.length, 2);
        // extra field length
        header += decToHex(extraFields.length, 2);
        var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
        var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;
        return {
          fileRecord: fileRecord,
          dirRecord: dirRecord,
          compressedObject: compressedObject
        };
      };

      // return the actual prototype of JSZip
      var out = {
        /**
         * Read an existing zip and merge the data in the current JSZip object.
         * The implementation is in jszip-load.js, don't forget to include it.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
         * @param {Object} options Options for loading the stream.
         *  options.base64 : is the stream in base64 ? default : false
         * @return {JSZip} the current JSZip object
         */
        load: function (stream, options) {
          throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
        },
        /**
         * Filter nested files/folders with the specified function.
         * @param {Function} search the predicate to use :
         * function (relativePath, file) {...}
         * It takes 2 arguments : the relative path and the file.
         * @return {Array} An array of matching elements.
         */
        filter: function (search) {
          var result = [],
            filename,
            relativePath,
            file,
            fileClone;
          for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
              continue;
            }
            file = this.files[filename];
            // return a new object, don't let the user mess with our internal objects :)
            fileClone = new ZipObject(file.name, file._data, utils.extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);
            if (filename.slice(0, this.root.length) === this.root &&
            // the file is in the current root
            search(relativePath, fileClone)) {
              // and the file matches the function
              result.push(fileClone);
            }
          }
          return result;
        },
        /**
         * Add a file to the zip file, or search a file.
         * @param   {string|RegExp} name The name of the file to add (if data is defined),
         * the name of the file to find (if no data) or a regex to match files.
         * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
         * @param   {Object} o     File options
         * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
         * a file (when searching by string) or an array of files (when searching by regex).
         */
        file: function (name, data, o) {
          if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
              var regexp = name;
              return this.filter(function (relativePath, file) {
                return !file.dir && regexp.test(relativePath);
              });
            } else {
              // text
              return this.filter(function (relativePath, file) {
                return !file.dir && relativePath === name;
              })[0] || null;
            }
          } else {
            // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
          }
          return this;
        },
        /**
         * Add a directory to the zip file, or search.
         * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
         * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
         */
        folder: function (arg) {
          if (!arg) {
            return this;
          }
          if (utils.isRegExp(arg)) {
            return this.filter(function (relativePath, file) {
              return file.dir && arg.test(relativePath);
            });
          }

          // else, name is a new folder
          var name = this.root + arg;
          var newFolder = folderAdd.call(this, name);

          // Allow chaining by returning a new object with this folder as the root
          var ret = this.clone();
          ret.root = newFolder.name;
          return ret;
        },
        /**
         * Delete a file, or a directory and all sub-files, from the zip
         * @param {string} name the name of the file to delete
         * @return {JSZip} this JSZip object
         */
        remove: function (name) {
          name = this.root + name;
          var file = this.files[name];
          if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
              name += "/";
            }
            file = this.files[name];
          }
          if (file && !file.dir) {
            // file
            delete this.files[name];
          } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function (relativePath, file) {
              return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
              delete this.files[kids[i].name];
            }
          }
          return this;
        },
        /**
         * Generate the complete zip file
         * @param {Object} options the options to generate the zip file :
         * - base64, (deprecated, use type instead) true to generate base64.
         * - compression, "STORE" by default.
         * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
         * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
         */
        generate: function (options) {
          options = utils.extend(options || {}, {
            base64: true,
            compression: "STORE",
            compressionOptions: null,
            type: "base64",
            platform: "DOS",
            comment: null,
            mimeType: 'application/zip',
            encodeFileName: utf8.utf8encode
          });
          utils.checkSupport(options.type);

          // accept nodejs `process.platform`
          if (options.platform === 'darwin' || options.platform === 'freebsd' || options.platform === 'linux' || options.platform === 'sunos') {
            options.platform = "UNIX";
          }
          if (options.platform === 'win32') {
            options.platform = "DOS";
          }
          var zipData = [],
            localDirLength = 0,
            centralDirLength = 0,
            writer,
            i,
            encodedComment = utils.transformTo("string", options.encodeFileName(options.comment || this.comment || ""));

          // first, generate all the zip parts.
          for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
              continue;
            }
            var file = this.files[name];
            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];
            if (!compression) {
              throw new Error(compressionName + " is not a valid compression method !");
            }
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var compressedObject = generateCompressedObjectFrom.call(this, file, compression, compressionOptions);
            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength, options.platform, options.encodeFileName);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
          }
          var dirEnd = "";

          // end of central dir signature
          dirEnd = signature.CENTRAL_DIRECTORY_END +
          // number of this disk
          "\x00\x00" +
          // number of the disk with the start of the central directory
          "\x00\x00" +
          // total number of entries in the central directory on this disk
          decToHex(zipData.length, 2) +
          // total number of entries in the central directory
          decToHex(zipData.length, 2) +
          // size of the central directory   4 bytes
          decToHex(centralDirLength, 4) +
          // offset of start of central directory with respect to the starting disk number
          decToHex(localDirLength, 4) +
          // .ZIP file comment length
          decToHex(encodedComment.length, 2) +
          // .ZIP file comment
          encodedComment;

          // we have all the parts (and the total length)
          // time to create a writer !
          var typeName = options.type.toLowerCase();
          if (typeName === "uint8array" || typeName === "arraybuffer" || typeName === "blob" || typeName === "nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
          } else {
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
          }
          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
          }
          for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
          }
          writer.append(dirEnd);
          var zip = writer.finalize();
          switch (options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array":
            case "arraybuffer":
            case "nodebuffer":
              return utils.transformTo(options.type.toLowerCase(), zip);
            case "blob":
              return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip), options.mimeType);
            // case "zip is a string"
            case "base64":
              return options.base64 ? base64.encode(zip) : zip;
            default:
              // case "string" :
              return zip;
          }
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        crc32: function (input, crc) {
          return crc32(input, crc);
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8encode: function (string) {
          return utils.transformTo("string", utf8.utf8encode(string));
        },
        /**
         * @deprecated
         * This method will be removed in a future version without replacement.
         */
        utf8decode: function (input) {
          return utf8.utf8decode(input);
        }
      };
      module.exports = out;
    }, {
      "./base64": 2,
      "./compressedObject": 3,
      "./compressions": 4,
      "./crc32": 5,
      "./defaults": 7,
      "./nodeBuffer": 12,
      "./signature": 15,
      "./stringWriter": 17,
      "./support": 18,
      "./uint8ArrayWriter": 20,
      "./utf8": 21,
      "./utils": 22
    }],
    15: [function (require, module, exports) {
      'use strict';

      exports.LOCAL_FILE_HEADER = "PK\x03\x04";
      exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
      exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
      exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
      exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
      exports.DATA_DESCRIPTOR = "PK\x07\x08";
    }, {}],
    16: [function (require, module, exports) {
      'use strict';

      var DataReader = require('./dataReader');
      var utils = require('./utils');
      function StringReader(data, optimizedBinaryString) {
        this.data = data;
        if (!optimizedBinaryString) {
          this.data = utils.string2binary(this.data);
        }
        this.length = this.data.length;
        this.index = 0;
        this.zero = 0;
      }
      StringReader.prototype = new DataReader();
      /**
       * @see DataReader.byteAt
       */
      StringReader.prototype.byteAt = function (i) {
        return this.data.charCodeAt(this.zero + i);
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      StringReader.prototype.lastIndexOfSignature = function (sig) {
        return this.data.lastIndexOf(sig) - this.zero;
      };
      /**
       * @see DataReader.readData
       */
      StringReader.prototype.readData = function (size) {
        this.checkOffset(size);
        // this will work because the constructor applied the "& 0xff" mask.
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = StringReader;
    }, {
      "./dataReader": 6,
      "./utils": 22
    }],
    17: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');

      /**
       * An object to write any content to a string.
       * @constructor
       */
      var StringWriter = function () {
        this.data = [];
      };
      StringWriter.prototype = {
        /**
         * Append any content to the current string.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          input = utils.transformTo("string", input);
          this.data.push(input);
        },
        /**
         * Finalize the construction an return the result.
         * @return {string} the generated string.
         */
        finalize: function () {
          return this.data.join("");
        }
      };
      module.exports = StringWriter;
    }, {
      "./utils": 22
    }],
    18: [function (require, module, exports) {
      (function (Buffer) {
        'use strict';

        exports.base64 = true;
        exports.array = true;
        exports.string = true;
        exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
        // contains true if JSZip can read/generate nodejs Buffer, false otherwise.
        // Browserify will provide a Buffer implementation for browsers, which is
        // an augmented Uint8Array (i.e., can be used as either Buffer or U8).
        exports.nodebuffer = typeof Buffer !== "undefined";
        // contains true if JSZip can read/generate Uint8Array, false otherwise.
        exports.uint8array = typeof Uint8Array !== "undefined";
        if (typeof ArrayBuffer === "undefined") {
          exports.blob = false;
        } else {
          var buffer = new ArrayBuffer(0);
          try {
            exports.blob = new Blob([buffer], {
              type: "application/zip"
            }).size === 0;
          } catch (e) {
            try {
              var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
              var builder = new Builder();
              builder.append(buffer);
              exports.blob = builder.getBlob('application/zip').size === 0;
            } catch (e) {
              exports.blob = false;
            }
          }
        }
      }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined);
    }, {}],
    19: [function (require, module, exports) {
      'use strict';

      var ArrayReader = require('./arrayReader');
      function Uint8ArrayReader(data) {
        if (data) {
          this.data = data;
          this.length = this.data.length;
          this.index = 0;
          this.zero = 0;
        }
      }
      Uint8ArrayReader.prototype = new ArrayReader();
      /**
       * @see DataReader.readData
       */
      Uint8ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);
        if (size === 0) {
          // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
          return new Uint8Array(0);
        }
        var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = Uint8ArrayReader;
    }, {
      "./arrayReader": 1
    }],
    20: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');

      /**
       * An object to write any content to an Uint8Array.
       * @constructor
       * @param {number} length The length of the array.
       */
      var Uint8ArrayWriter = function (length) {
        this.data = new Uint8Array(length);
        this.index = 0;
      };
      Uint8ArrayWriter.prototype = {
        /**
         * Append any content to the current array.
         * @param {Object} input the content to add.
         */
        append: function (input) {
          if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
          }
        },
        /**
         * Finalize the construction an return the result.
         * @return {Uint8Array} the generated array.
         */
        finalize: function () {
          return this.data;
        }
      };
      module.exports = Uint8ArrayWriter;
    }, {
      "./utils": 22
    }],
    21: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      var support = require('./support');
      var nodeBuffer = require('./nodeBuffer');

      /**
       * The following functions come from pako, from pako/lib/utils/strings
       * released under the MIT license, see pako https://github.com/nodeca/pako/
       */

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new Array(256);
      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      var string2buf = function (str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        if (support.uint8array) {
          buf = new Uint8Array(buf_len);
        } else {
          buf = new Array(buf_len);
        }

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      var utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };

      // convert array to string
      var buf2string = function (buf) {
        var str, i, out, c, c_len;
        var len = buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }

        // shrinkBuf(utf16buf, out)
        if (utf16buf.length !== out) {
          if (utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
          } else {
            utf16buf.length = out;
          }
        }

        // return String.fromCharCode.apply(null, utf16buf);
        return utils.applyFromCharCode(utf16buf);
      };

      // That's all for the pako functions.

      /**
       * Transform a javascript string into an array (typed if possible) of bytes,
       * UTF-8 encoded.
       * @param {String} str the string to encode
       * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
       */
      exports.utf8encode = function utf8encode(str) {
        if (support.nodebuffer) {
          return nodeBuffer(str, "utf-8");
        }
        return string2buf(str);
      };

      /**
       * Transform a bytes array (or a representation) representing an UTF-8 encoded
       * string into a javascript string.
       * @param {Array|Uint8Array|Buffer} buf the data de decode
       * @return {String} the decoded string.
       */
      exports.utf8decode = function utf8decode(buf) {
        if (support.nodebuffer) {
          return utils.transformTo("nodebuffer", buf).toString("utf-8");
        }
        buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

        // return buf2string(buf);
        // Chrome prefers to work with "small" chunks of data
        // for the method buf2string.
        // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
        var result = [],
          k = 0,
          len = buf.length,
          chunk = 65536;
        while (k < len) {
          var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
          if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
          } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
          }
          k = nextBoundary;
        }
        return result.join("");
      };
      // vim: set shiftwidth=4 softtabstop=4:
    }, {
      "./nodeBuffer": 12,
      "./support": 18,
      "./utils": 22
    }],
    22: [function (require, module, exports) {
      'use strict';

      var support = require('./support');
      var compressions = require('./compressions');
      var nodeBuffer = require('./nodeBuffer');
      /**
       * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
       * @param {string} str the string to transform.
       * @return {String} the binary string.
       */
      exports.string2binary = function (str) {
        var result = "";
        for (var i = 0; i < str.length; i++) {
          result += String.fromCharCode(str.charCodeAt(i) & 0xff);
        }
        return result;
      };
      exports.arrayBuffer2Blob = function (buffer, mimeType) {
        exports.checkSupport("blob");
        mimeType = mimeType || 'application/zip';
        try {
          // Blob constructor
          return new Blob([buffer], {
            type: mimeType
          });
        } catch (e) {
          try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob(mimeType);
          } catch (e) {
            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      /**
       * The identity function.
       * @param {Object} input the input.
       * @return {Object} the same input.
       */
      function identity(input) {
        return input;
      }

      /**
       * Fill in an array with a string.
       * @param {String} str the string to use.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
       */
      function stringToArrayLike(str, array) {
        for (var i = 0; i < str.length; ++i) {
          array[i] = str.charCodeAt(i) & 0xFF;
        }
        return array;
      }

      /**
       * Transform an array-like object to a string.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
       * @return {String} the result.
       */
      function arrayLikeToString(array) {
        // Performances notes :
        // --------------------
        // String.fromCharCode.apply(null, array) is the fastest, see
        // see http://jsperf.com/converting-a-uint8array-to-a-string/2
        // but the stack is limited (and we can get huge arrays !).
        //
        // result += String.fromCharCode(array[i]); generate too many strings !
        //
        // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
        var chunk = 65536;
        var result = [],
          len = array.length,
          type = exports.getTypeOf(array),
          k = 0,
          canUseApply = true;
        try {
          switch (type) {
            case "uint8array":
              String.fromCharCode.apply(null, new Uint8Array(0));
              break;
            case "nodebuffer":
              String.fromCharCode.apply(null, nodeBuffer(0));
              break;
          }
        } catch (e) {
          canUseApply = false;
        }

        // no apply : slow and painful algorithm
        // default browser on android 4.*
        if (!canUseApply) {
          var resultStr = "";
          for (var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
          }
          return resultStr;
        }
        while (k < len && chunk > 1) {
          try {
            if (type === "array" || type === "nodebuffer") {
              result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            } else {
              result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
          } catch (e) {
            chunk = Math.floor(chunk / 2);
          }
        }
        return result.join("");
      }
      exports.applyFromCharCode = arrayLikeToString;

      /**
       * Copy the data from an array-like to an other array-like.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
       */
      function arrayLikeToArrayLike(arrayFrom, arrayTo) {
        for (var i = 0; i < arrayFrom.length; i++) {
          arrayTo[i] = arrayFrom[i];
        }
        return arrayTo;
      }

      // a matrix containing functions to transform everything into everything.
      var transform = {};

      // string to ?
      transform["string"] = {
        "string": identity,
        "array": function (input) {
          return stringToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["string"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return stringToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": function (input) {
          return stringToArrayLike(input, nodeBuffer(input.length));
        }
      };

      // array to ?
      transform["array"] = {
        "string": arrayLikeToString,
        "array": identity,
        "arraybuffer": function (input) {
          return new Uint8Array(input).buffer;
        },
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      };

      // arraybuffer to ?
      transform["arraybuffer"] = {
        "string": function (input) {
          return arrayLikeToString(new Uint8Array(input));
        },
        "array": function (input) {
          return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
        },
        "arraybuffer": identity,
        "uint8array": function (input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function (input) {
          return nodeBuffer(new Uint8Array(input));
        }
      };

      // uint8array to ?
      transform["uint8array"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return input.buffer;
        },
        "uint8array": identity,
        "nodebuffer": function (input) {
          return nodeBuffer(input);
        }
      };

      // nodebuffer to ?
      transform["nodebuffer"] = {
        "string": arrayLikeToString,
        "array": function (input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function (input) {
          return transform["nodebuffer"]["uint8array"](input).buffer;
        },
        "uint8array": function (input) {
          return arrayLikeToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": identity
      };

      /**
       * Transform an input into any type.
       * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
       * If no output type is specified, the unmodified input will be returned.
       * @param {String} outputType the output type.
       * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
       * @throws {Error} an Error if the browser doesn't support the requested output type.
       */
      exports.transformTo = function (outputType, input) {
        if (!input) {
          // undefined, null, etc
          // an empty string won't harm.
          input = "";
        }
        if (!outputType) {
          return input;
        }
        exports.checkSupport(outputType);
        var inputType = exports.getTypeOf(input);
        var result = transform[inputType][outputType](input);
        return result;
      };

      /**
       * Return the type of the input.
       * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
       * @param {Object} input the input to identify.
       * @return {String} the (lowercase) type of the input.
       */
      exports.getTypeOf = function (input) {
        if (typeof input === "string") {
          return "string";
        }
        if (Object.prototype.toString.call(input) === "[object Array]") {
          return "array";
        }
        if (support.nodebuffer && nodeBuffer.test(input)) {
          return "nodebuffer";
        }
        if (support.uint8array && input instanceof Uint8Array) {
          return "uint8array";
        }
        if (support.arraybuffer && input instanceof ArrayBuffer) {
          return "arraybuffer";
        }
      };

      /**
       * Throw an exception if the type is not supported.
       * @param {String} type the type to check.
       * @throws {Error} an Error if the browser doesn't support the requested type.
       */
      exports.checkSupport = function (type) {
        var supported = support[type.toLowerCase()];
        if (!supported) {
          throw new Error(type + " is not supported by this browser");
        }
      };
      exports.MAX_VALUE_16BITS = 65535;
      exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

      /**
       * Prettify a string read as binary.
       * @param {string} str the string to prettify.
       * @return {string} a pretty string.
       */
      exports.pretty = function (str) {
        var res = '',
          code,
          i;
        for (i = 0; i < (str || "").length; i++) {
          code = str.charCodeAt(i);
          res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
        }
        return res;
      };

      /**
       * Find a compression registered in JSZip.
       * @param {string} compressionMethod the method magic to find.
       * @return {Object|null} the JSZip compression object, null if none found.
       */
      exports.findCompression = function (compressionMethod) {
        for (var method in compressions) {
          if (!compressions.hasOwnProperty(method)) {
            continue;
          }
          if (compressions[method].magic === compressionMethod) {
            return compressions[method];
          }
        }
        return null;
      };
      /**
      * Cross-window, cross-Node-context regular expression detection
      * @param  {Object}  object Anything
      * @return {Boolean}        true if the object is a regular expression,
      * false otherwise
      */
      exports.isRegExp = function (object) {
        return Object.prototype.toString.call(object) === "[object RegExp]";
      };

      /**
       * Merge the objects passed as parameters into a new one.
       * @private
       * @param {...Object} var_args All objects to merge.
       * @return {Object} a new object with the data of the others.
       */
      exports.extend = function () {
        var result = {},
          i,
          attr;
        for (i = 0; i < arguments.length; i++) {
          // arguments is not enumerable in some browsers
          for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
              result[attr] = arguments[i][attr];
            }
          }
        }
        return result;
      };
    }, {
      "./compressions": 4,
      "./nodeBuffer": 12,
      "./support": 18
    }],
    23: [function (require, module, exports) {
      'use strict';

      var StringReader = require('./stringReader');
      var NodeBufferReader = require('./nodeBufferReader');
      var Uint8ArrayReader = require('./uint8ArrayReader');
      var ArrayReader = require('./arrayReader');
      var utils = require('./utils');
      var sig = require('./signature');
      var ZipEntry = require('./zipEntry');
      var support = require('./support');
      var jszipProto = require('./object');
      //  class ZipEntries {{{
      /**
       * All the entries in the zip file.
       * @constructor
       * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntries(data, loadOptions) {
        this.files = [];
        this.loadOptions = loadOptions;
        if (data) {
          this.load(data);
        }
      }
      ZipEntries.prototype = {
        /**
         * Check that the reader is on the speficied signature.
         * @param {string} expectedSignature the expected signature.
         * @throws {Error} if it is an other signature.
         */
        checkSignature: function (expectedSignature) {
          var signature = this.reader.readString(4);
          if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
          }
        },
        /**
         * Check if the given signature is at the given index.
         * @param {number} askedIndex the index to check.
         * @param {string} expectedSignature the signature to expect.
         * @return {boolean} true if the signature is here, false otherwise.
         */
        isSignature: function (askedIndex, expectedSignature) {
          var currentIndex = this.reader.index;
          this.reader.setIndex(askedIndex);
          var signature = this.reader.readString(4);
          var result = signature === expectedSignature;
          this.reader.setIndex(currentIndex);
          return result;
        },
        /**
         * Read the end of the central directory.
         */
        readBlockEndOfCentral: function () {
          this.diskNumber = this.reader.readInt(2);
          this.diskWithCentralDirStart = this.reader.readInt(2);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
          this.centralDirRecords = this.reader.readInt(2);
          this.centralDirSize = this.reader.readInt(4);
          this.centralDirOffset = this.reader.readInt(4);
          this.zipCommentLength = this.reader.readInt(2);
          // warning : the encoding depends of the system locale
          // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
          // On a windows machine, this field is encoded with the localized windows code page.
          var zipComment = this.reader.readData(this.zipCommentLength);
          var decodeParamType = support.uint8array ? "uint8array" : "array";
          // To get consistent behavior with the generation part, we will assume that
          // this is utf8 encoded unless specified otherwise.
          var decodeContent = utils.transformTo(decodeParamType, zipComment);
          this.zipComment = this.loadOptions.decodeFileName(decodeContent);
        },
        /**
         * Read the end of the Zip 64 central directory.
         * Not merged with the method readEndOfCentral :
         * The end of central can coexist with its Zip64 brother,
         * I don't want to read the wrong number of bytes !
         */
        readBlockZip64EndOfCentral: function () {
          this.zip64EndOfCentralSize = this.reader.readInt(8);
          this.versionMadeBy = this.reader.readString(2);
          this.versionNeeded = this.reader.readInt(2);
          this.diskNumber = this.reader.readInt(4);
          this.diskWithCentralDirStart = this.reader.readInt(4);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
          this.centralDirRecords = this.reader.readInt(8);
          this.centralDirSize = this.reader.readInt(8);
          this.centralDirOffset = this.reader.readInt(8);
          this.zip64ExtensibleData = {};
          var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },
        /**
         * Read the end of the Zip 64 central directory locator.
         */
        readBlockZip64EndOfCentralLocator: function () {
          this.diskWithZip64CentralDirStart = this.reader.readInt(4);
          this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
          this.disksCount = this.reader.readInt(4);
          if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
          }
        },
        /**
         * Read the local files, based on the offset read in the central part.
         */
        readLocalFiles: function () {
          var i, file;
          for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
          }
        },
        /**
         * Read the central directory.
         */
        readCentralDir: function () {
          var file;
          this.reader.setIndex(this.centralDirOffset);
          while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
              zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
          }
          if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
              // We expected some records but couldn't find ANY.
              // This is really suspicious, as if something went wrong.
              throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
              // We found some records but not all.
              // Something is wrong but we got something for the user: no error here.
              // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
          }
        },
        /**
         * Read the end of central directory.
         */
        readEndOfCentral: function () {
          var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
          if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
            if (isGarbage) {
              throw new Error("Can't find end of central directory : is this a zip file ? " + "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
              throw new Error("Corrupted zip : can't find end of central directory");
            }
          }
          this.reader.setIndex(offset);
          var endOfCentralDirOffset = offset;
          this.checkSignature(sig.CENTRAL_DIRECTORY_END);
          this.readBlockEndOfCentral();

          /* extract from the zip spec :
              4)  If one of the fields in the end of central directory
                  record is too small to hold required data, the field
                  should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                  ZIP64 format record should be created.
              5)  The end of central directory record and the
                  Zip64 end of central directory locator record must
                  reside on the same disk when splitting or spanning
                  an archive.
           */
          if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
              throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
              // console.warn("ZIP64 end of central directory not where expected.");
              this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
              if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
              }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
          }
          var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
          if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
          }
          var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
          if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
              // The offsets seem wrong, but we have something at the specified offset.
              // So… we keep it.
            } else {
              // the offset is wrong, update the "zero" of the reader
              // this happens if data has been prepended (crx files for example)
              this.reader.zero = extraBytes;
            }
          } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
          }
        },
        prepareReader: function (data) {
          var type = utils.getTypeOf(data);
          utils.checkSupport(type);
          if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
          } else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
          } else if (support.uint8array) {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
          } else if (support.array) {
            this.reader = new ArrayReader(utils.transformTo("array", data));
          } else {
            throw new Error("Unexpected error: unsupported type '" + type + "'");
          }
        },
        /**
         * Read a zip file and create ZipEntries.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
         */
        load: function (data) {
          this.prepareReader(data);
          this.readEndOfCentral();
          this.readCentralDir();
          this.readLocalFiles();
        }
      };
      // }}} end of ZipEntries
      module.exports = ZipEntries;
    }, {
      "./arrayReader": 1,
      "./nodeBufferReader": 13,
      "./object": 14,
      "./signature": 15,
      "./stringReader": 16,
      "./support": 18,
      "./uint8ArrayReader": 19,
      "./utils": 22,
      "./zipEntry": 24
    }],
    24: [function (require, module, exports) {
      'use strict';

      var StringReader = require('./stringReader');
      var utils = require('./utils');
      var CompressedObject = require('./compressedObject');
      var jszipProto = require('./object');
      var support = require('./support');
      var MADE_BY_DOS = 0x00;
      var MADE_BY_UNIX = 0x03;

      // class ZipEntry {{{
      /**
       * An entry in the zip file.
       * @constructor
       * @param {Object} options Options of the current file.
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntry(options, loadOptions) {
        this.options = options;
        this.loadOptions = loadOptions;
      }
      ZipEntry.prototype = {
        /**
         * say if the file is encrypted.
         * @return {boolean} true if the file is encrypted, false otherwise.
         */
        isEncrypted: function () {
          // bit 1 is set
          return (this.bitFlag & 0x0001) === 0x0001;
        },
        /**
         * say if the file has utf-8 filename/comment.
         * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
         */
        useUTF8: function () {
          // bit 11 is set
          return (this.bitFlag & 0x0800) === 0x0800;
        },
        /**
         * Prepare the function used to generate the compressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
         */
        prepareCompressedContent: function (reader, from, length) {
          return function () {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);
            return compressedFileData;
          };
        },
        /**
         * Prepare the function used to generate the uncompressed content from this ZipFile.
         * @param {DataReader} reader the reader to use.
         * @param {number} from the offset from where we should read the data.
         * @param {number} length the length of the data to read.
         * @param {JSZip.compression} compression the compression used on this file.
         * @param {number} uncompressedSize the uncompressed size to expect.
         * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
         */
        prepareContent: function (reader, from, length, compression, uncompressedSize) {
          return function () {
            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);
            if (uncompressedFileData.length !== uncompressedSize) {
              throw new Error("Bug : uncompressed data size mismatch");
            }
            return uncompressedFileData;
          };
        },
        /**
         * Read the local part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readLocalPart: function (reader) {
          var compression, localExtraFieldsLength;

          // we already know everything from the central dir !
          // If the central dir data are false, we are doomed.
          // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
          // The less data we get here, the more reliable this should be.
          // Let's skip the whole header and dash to the data !
          reader.skip(22);
          // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
          // Strangely, the filename here is OK.
          // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
          // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
          // Search "unzip mismatching "local" filename continuing with "central" filename version" on
          // the internet.
          //
          // I think I see the logic here : the central directory is used to display
          // content and the local directory is used to extract the files. Mixing / and \
          // may be used to display \ to windows users and use / when extracting the files.
          // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
          this.fileNameLength = reader.readInt(2);
          localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
          this.fileName = reader.readData(this.fileNameLength);
          reader.skip(localExtraFieldsLength);
          if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
          }
          compression = utils.findCompression(this.compressionMethod);
          if (compression === null) {
            // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
          }
          this.decompressed = new CompressedObject();
          this.decompressed.compressedSize = this.compressedSize;
          this.decompressed.uncompressedSize = this.uncompressedSize;
          this.decompressed.crc32 = this.crc32;
          this.decompressed.compressionMethod = this.compressionMethod;
          this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
          this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

          // we need to compute the crc32...
          if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
              throw new Error("Corrupted zip : CRC32 mismatch");
            }
          }
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readCentralPart: function (reader) {
          this.versionMadeBy = reader.readInt(2);
          this.versionNeeded = reader.readInt(2);
          this.bitFlag = reader.readInt(2);
          this.compressionMethod = reader.readString(2);
          this.date = reader.readDate();
          this.crc32 = reader.readInt(4);
          this.compressedSize = reader.readInt(4);
          this.uncompressedSize = reader.readInt(4);
          this.fileNameLength = reader.readInt(2);
          this.extraFieldsLength = reader.readInt(2);
          this.fileCommentLength = reader.readInt(2);
          this.diskNumberStart = reader.readInt(2);
          this.internalFileAttributes = reader.readInt(2);
          this.externalFileAttributes = reader.readInt(4);
          this.localHeaderOffset = reader.readInt(4);
          if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
          }
          this.fileName = reader.readData(this.fileNameLength);
          this.readExtraFields(reader);
          this.parseZIP64ExtraField(reader);
          this.fileComment = reader.readData(this.fileCommentLength);
        },
        /**
         * Parse the external file attributes and get the unix/dos permissions.
         */
        processAttributes: function () {
          this.unixPermissions = null;
          this.dosPermissions = null;
          var madeBy = this.versionMadeBy >> 8;

          // Check if we have the DOS directory flag set.
          // We look for it in the DOS and UNIX permissions
          // but some unknown platform could set it as a compatibility flag.
          this.dir = this.externalFileAttributes & 0x0010 ? true : false;
          if (madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
          }
          if (madeBy === MADE_BY_UNIX) {
            this.unixPermissions = this.externalFileAttributes >> 16 & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
          }

          // fail safe : if the name ends with a / it probably means a folder
          if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
          }
        },
        /**
         * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
         * @param {DataReader} reader the reader to use.
         */
        parseZIP64ExtraField: function (reader) {
          if (!this.extraFields[0x0001]) {
            return;
          }

          // should be something, preparing the extra reader
          var extraReader = new StringReader(this.extraFields[0x0001].value);

          // I really hope that these 64bits integer can fit in 32 bits integer, because js
          // won't let us have more.
          if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
          }
          if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
          }
          if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
          }
          if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
          }
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readExtraFields: function (reader) {
          var start = reader.index,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          this.extraFields = this.extraFields || {};
          while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);
            this.extraFields[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },
        /**
         * Apply an UTF8 transformation if needed.
         */
        handleUTF8: function () {
          var decodeParamType = support.uint8array ? "uint8array" : "array";
          if (this.useUTF8()) {
            this.fileNameStr = jszipProto.utf8decode(this.fileName);
            this.fileCommentStr = jszipProto.utf8decode(this.fileComment);
          } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
              this.fileNameStr = upath;
            } else {
              var fileNameByteArray = utils.transformTo(decodeParamType, this.fileName);
              this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
              this.fileCommentStr = ucomment;
            } else {
              var commentByteArray = utils.transformTo(decodeParamType, this.fileComment);
              this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
          }
        },
        /**
         * Find the unicode path declared in the extra field, if any.
         * @return {String} the unicode path, null otherwise.
         */
        findExtraFieldUnicodePath: function () {
          var upathField = this.extraFields[0x7075];
          if (upathField) {
            var extraReader = new StringReader(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
              return null;
            }
            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
          }
          return null;
        },
        /**
         * Find the unicode comment declared in the extra field, if any.
         * @return {String} the unicode comment, null otherwise.
         */
        findExtraFieldUnicodeComment: function () {
          var ucommentField = this.extraFields[0x6375];
          if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
              return null;
            }
            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
          }
          return null;
        }
      };
      module.exports = ZipEntry;
    }, {
      "./compressedObject": 3,
      "./object": 14,
      "./stringReader": 16,
      "./support": 18,
      "./utils": 22
    }],
    25: [function (require, module, exports) {
      // Top level file is just a mixin of submodules & constants
      'use strict';

      var assign = require('./lib/utils/common').assign;
      var deflate = require('./lib/deflate');
      var inflate = require('./lib/inflate');
      var constants = require('./lib/zlib/constants');
      var pako = {};
      assign(pako, deflate, inflate, constants);
      module.exports = pako;
    }, {
      "./lib/deflate": 26,
      "./lib/inflate": 27,
      "./lib/utils/common": 28,
      "./lib/zlib/constants": 31
    }],
    26: [function (require, module, exports) {
      'use strict';

      var zlib_deflate = require('./zlib/deflate');
      var utils = require('./utils/common');
      var strings = require('./utils/strings');
      var msg = require('./zlib/messages');
      var ZStream = require('./zlib/zstream');
      var toString = Object.prototype.toString;

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      var Z_NO_FLUSH = 0;
      var Z_FINISH = 4;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_SYNC_FLUSH = 2;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_DEFLATED = 8;

      /* ===========================================================================*/

      /**
       * class Deflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[deflate]],
       * [[deflateRaw]] and [[gzip]].
       **/

      /* internal
       * Deflate.chunks -> Array
       *
       * Chunks of output data, if [[Deflate#onData]] not overriden.
       **/

      /**
       * Deflate.result -> Uint8Array|Array
       *
       * Compressed result, generated by default [[Deflate#onData]]
       * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
       * push a chunk with explicit flush (call [[Deflate#push]] with
       * `Z_SYNC_FLUSH` param).
       **/

      /**
       * Deflate.err -> Number
       *
       * Error code after deflate finished. 0 (Z_OK) on success.
       * You will not need it in real life, because deflate errors
       * are possible only on wrong options or bad `onData` / `onEnd`
       * custom handlers.
       **/

      /**
       * Deflate.msg -> String
       *
       * Error message, if [[Deflate.err]] != 0
       **/

      /**
       * new Deflate(options)
       * - options (Object): zlib deflate options.
       *
       * Creates new deflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `level`
       * - `windowBits`
       * - `memLevel`
       * - `strategy`
       * - `dictionary`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw deflate
       * - `gzip` (Boolean) - create gzip wrapper
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       * - `header` (Object) - custom header for gzip
       *   - `text` (Boolean) - true if compressed data believed to be text
       *   - `time` (Number) - modification time, unix timestamp
       *   - `os` (Number) - operation system code
       *   - `extra` (Array) - array of bytes with extra data (max 65536)
       *   - `name` (String) - file name (binary string)
       *   - `comment` (String) - comment (binary string)
       *   - `hcrc` (Boolean) - true if header crc should be added
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var deflate = new pako.Deflate({ level: 3});
       *
       * deflate.push(chunk1, false);
       * deflate.push(chunk2, true);  // true -> last chunk
       *
       * if (deflate.err) { throw new Error(deflate.err); }
       *
       * console.log(deflate.result);
       * ```
       **/
      function Deflate(options) {
        if (!(this instanceof Deflate)) return new Deflate(options);
        this.options = utils.assign({
          level: Z_DEFAULT_COMPRESSION,
          method: Z_DEFLATED,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: Z_DEFAULT_STRATEGY,
          to: ''
        }, options || {});
        var opt = this.options;
        if (opt.raw && opt.windowBits > 0) {
          opt.windowBits = -opt.windowBits;
        } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
          opt.windowBits += 16;
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
        if (status !== Z_OK) {
          throw new Error(msg[status]);
        }
        if (opt.header) {
          zlib_deflate.deflateSetHeader(this.strm, opt.header);
        }
        if (opt.dictionary) {
          var dict;
          // Convert data if needed
          if (typeof opt.dictionary === 'string') {
            // If we need to compress text, change encoding to utf8.
            dict = strings.string2buf(opt.dictionary);
          } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
            dict = new Uint8Array(opt.dictionary);
          } else {
            dict = opt.dictionary;
          }
          status = zlib_deflate.deflateSetDictionary(this.strm, dict);
          if (status !== Z_OK) {
            throw new Error(msg[status]);
          }
          this._dict_set = true;
        }
      }

      /**
       * Deflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
       *   converted to utf8 byte sequence.
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
       * new compressed chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
       * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
       * can use mode Z_SYNC_FLUSH, keeping the compression context.
       *
       * On fail call [[Deflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * array format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Deflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var status, _mode;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // If we need to compress text, change encoding to utf8.
          strm.input = strings.string2buf(data);
        } else if (toString.call(data) === '[object ArrayBuffer]') {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_deflate.deflate(strm, _mode); /* no bad return value */

          if (status !== Z_STREAM_END && status !== Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') {
              this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
            } else {
              this.onData(utils.shrinkBuf(strm.output, strm.next_out));
            }
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

        // Finalize on the last chunk.
        if (_mode === Z_FINISH) {
          status = zlib_deflate.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK;
        }

        // callback interim results if Z_SYNC_FLUSH.
        if (_mode === Z_SYNC_FLUSH) {
          this.onEnd(Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };

      /**
       * Deflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Deflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Deflate#onEnd(status) -> Void
       * - status (Number): deflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell deflate that the input stream is
       * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
       * or if an error happened. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Deflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === Z_OK) {
          if (this.options.to === 'string') {
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * deflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * Compress `data` with deflate algorithm and `options`.
       *
       * Supported options are:
       *
       * - level
       * - windowBits
       * - memLevel
       * - strategy
       * - dictionary
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
       *
       * console.log(pako.deflate(data));
       * ```
       **/
      function deflate(input, options) {
        var deflator = new Deflate(options);
        deflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (deflator.err) {
          throw deflator.msg;
        }
        return deflator.result;
      }

      /**
       * deflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function deflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return deflate(input, options);
      }

      /**
       * gzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but create gzip wrapper instead of
       * deflate one.
       **/
      function gzip(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate(input, options);
      }
      exports.Deflate = Deflate;
      exports.deflate = deflate;
      exports.deflateRaw = deflateRaw;
      exports.gzip = gzip;
    }, {
      "./utils/common": 28,
      "./utils/strings": 29,
      "./zlib/deflate": 33,
      "./zlib/messages": 38,
      "./zlib/zstream": 40
    }],
    27: [function (require, module, exports) {
      'use strict';

      var zlib_inflate = require('./zlib/inflate');
      var utils = require('./utils/common');
      var strings = require('./utils/strings');
      var c = require('./zlib/constants');
      var msg = require('./zlib/messages');
      var ZStream = require('./zlib/zstream');
      var GZheader = require('./zlib/gzheader');
      var toString = Object.prototype.toString;

      /**
       * class Inflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[inflate]]
       * and [[inflateRaw]].
       **/

      /* internal
       * inflate.chunks -> Array
       *
       * Chunks of output data, if [[Inflate#onData]] not overriden.
       **/

      /**
       * Inflate.result -> Uint8Array|Array|String
       *
       * Uncompressed result, generated by default [[Inflate#onData]]
       * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
       * push a chunk with explicit flush (call [[Inflate#push]] with
       * `Z_SYNC_FLUSH` param).
       **/

      /**
       * Inflate.err -> Number
       *
       * Error code after inflate finished. 0 (Z_OK) on success.
       * Should be checked if broken data possible.
       **/

      /**
       * Inflate.msg -> String
       *
       * Error message, if [[Inflate.err]] != 0
       **/

      /**
       * new Inflate(options)
       * - options (Object): zlib inflate options.
       *
       * Creates new inflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `windowBits`
       * - `dictionary`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw inflate
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       * By default, when no options set, autodetect deflate/gzip data format via
       * wrapper header.
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var inflate = new pako.Inflate({ level: 3});
       *
       * inflate.push(chunk1, false);
       * inflate.push(chunk2, true);  // true -> last chunk
       *
       * if (inflate.err) { throw new Error(inflate.err); }
       *
       * console.log(inflate.result);
       * ```
       **/
      function Inflate(options) {
        if (!(this instanceof Inflate)) return new Inflate(options);
        this.options = utils.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ''
        }, options || {});
        var opt = this.options;

        // Force window size for `raw` data, if not set directly,
        // because we have no header for autodetect.
        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;
          if (opt.windowBits === 0) {
            opt.windowBits = -15;
          }
        }

        // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
        if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
          opt.windowBits += 32;
        }

        // Gzip header has no info about windows size, we can do autodetect only
        // for deflate. So, if window size not set, force it to max when gzip possible
        if (opt.windowBits > 15 && opt.windowBits < 48) {
          // bit 3 (16) -> gzipped data
          // bit 4 (32) -> autodetect gzip/deflate
          if ((opt.windowBits & 15) === 0) {
            opt.windowBits |= 15;
          }
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
        if (status !== c.Z_OK) {
          throw new Error(msg[status]);
        }
        this.header = new GZheader();
        zlib_inflate.inflateGetHeader(this.strm, this.header);
      }

      /**
       * Inflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|ArrayBuffer|String): input data
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
       * new output chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
       * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
       * can use mode Z_SYNC_FLUSH, keeping the decompression context.
       *
       * On fail call [[Inflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Inflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var dictionary = this.options.dictionary;
        var status, _mode;
        var next_out_utf8, tail, utf8str;
        var dict;

        // Flag to properly process Z_BUF_ERROR on testing inflate call
        // when we check that all output data was flushed.
        var allowBufError = false;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // Only binary strings can be decompressed on practice
          strm.input = strings.binstring2buf(data);
        } else if (toString.call(data) === '[object ArrayBuffer]') {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH); /* no bad return value */

          if (status === c.Z_NEED_DICT && dictionary) {
            // Convert data if needed
            if (typeof dictionary === 'string') {
              dict = strings.string2buf(dictionary);
            } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
              dict = new Uint8Array(dictionary);
            } else {
              dict = dictionary;
            }
            status = zlib_inflate.inflateSetDictionary(this.strm, dict);
          }
          if (status === c.Z_BUF_ERROR && allowBufError === true) {
            status = c.Z_OK;
            allowBufError = false;
          }
          if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.next_out) {
            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH)) {
              if (this.options.to === 'string') {
                next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                tail = strm.next_out - next_out_utf8;
                utf8str = strings.buf2string(strm.output, next_out_utf8);

                // move tail
                strm.next_out = tail;
                strm.avail_out = chunkSize - tail;
                if (tail) {
                  utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                }
                this.onData(utf8str);
              } else {
                this.onData(utils.shrinkBuf(strm.output, strm.next_out));
              }
            }
          }

          // When no more input data, we should check that internal inflate buffers
          // are flushed. The only way to do it when avail_out = 0 - run one more
          // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
          // Here we set flag to process this error properly.
          //
          // NOTE. Deflate does not return error in this case and does not needs such
          // logic.
          if (strm.avail_in === 0 && strm.avail_out === 0) {
            allowBufError = true;
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
        if (status === c.Z_STREAM_END) {
          _mode = c.Z_FINISH;
        }

        // Finalize on the last chunk.
        if (_mode === c.Z_FINISH) {
          status = zlib_inflate.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === c.Z_OK;
        }

        // callback interim results if Z_SYNC_FLUSH.
        if (_mode === c.Z_SYNC_FLUSH) {
          this.onEnd(c.Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };

      /**
       * Inflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Inflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Inflate#onEnd(status) -> Void
       * - status (Number): inflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called either after you tell inflate that the input stream is
       * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
       * or if an error happened. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Inflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === c.Z_OK) {
          if (this.options.to === 'string') {
            // Glue & convert here, until we teach pako to send
            // utf8 alligned strings to onData
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * inflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Decompress `data` with inflate/ungzip and `options`. Autodetect
       * format via wrapper header by default. That's why we don't provide
       * separate `ungzip` method.
       *
       * Supported options are:
       *
       * - windowBits
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
       *   , output;
       *
       * try {
       *   output = pako.inflate(input);
       * } catch (err)
       *   console.log(err);
       * }
       * ```
       **/
      function inflate(input, options) {
        var inflator = new Inflate(options);
        inflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (inflator.err) {
          throw inflator.msg;
        }
        return inflator.result;
      }

      /**
       * inflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * The same as [[inflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function inflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return inflate(input, options);
      }

      /**
       * ungzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Just shortcut to [[inflate]], because it autodetects format
       * by header.content. Done for convenience.
       **/

      exports.Inflate = Inflate;
      exports.inflate = inflate;
      exports.inflateRaw = inflateRaw;
      exports.ungzip = inflate;
    }, {
      "./utils/common": 28,
      "./utils/strings": 29,
      "./zlib/constants": 31,
      "./zlib/gzheader": 34,
      "./zlib/inflate": 36,
      "./zlib/messages": 38,
      "./zlib/zstream": 40
    }],
    28: [function (require, module, exports) {
      'use strict';

      var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
      exports.assign = function (obj /*from1, from2, from3, ...*/) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while (sources.length) {
          var source = sources.shift();
          if (!source) {
            continue;
          }
          if (typeof source !== 'object') {
            throw new TypeError(source + 'must be non-object');
          }
          for (var p in source) {
            if (source.hasOwnProperty(p)) {
              obj[p] = source[p];
            }
          }
        }
        return obj;
      };

      // reduce buffer size, avoiding mem copy
      exports.shrinkBuf = function (buf, size) {
        if (buf.length === size) {
          return buf;
        }
        if (buf.subarray) {
          return buf.subarray(0, size);
        }
        buf.length = size;
        return buf;
      };
      var fnTyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
          }
          // Fallback to ordinary array
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          var i, l, len, pos, chunk, result;

          // calculate data length
          len = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            len += chunks[i].length;
          }

          // join chunks
          result = new Uint8Array(len);
          pos = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
          }
          return result;
        }
      };
      var fnUntyped = {
        arraySet: function (dest, src, src_offs, len, dest_offs) {
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function (chunks) {
          return [].concat.apply([], chunks);
        }
      };

      // Enable/Disable typed arrays use, for testing
      //
      exports.setTyped = function (on) {
        if (on) {
          exports.Buf8 = Uint8Array;
          exports.Buf16 = Uint16Array;
          exports.Buf32 = Int32Array;
          exports.assign(exports, fnTyped);
        } else {
          exports.Buf8 = Array;
          exports.Buf16 = Array;
          exports.Buf32 = Array;
          exports.assign(exports, fnUntyped);
        }
      };
      exports.setTyped(TYPED_OK);
    }, {}],
    29: [function (require, module, exports) {
      // String encode/decode helpers
      'use strict';

      var utils = require('./common');

      // Quick check if we can use fast array to bin string conversion
      //
      // - apply(Array) can fail on Android 2.2
      // - apply(Uint8Array) can fail on iOS 5.1 Safary
      //
      var STR_APPLY_OK = true;
      var STR_APPLY_UIA_OK = true;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch (__) {
        STR_APPLY_OK = false;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (__) {
        STR_APPLY_UIA_OK = false;
      }

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new utils.Buf8(256);
      for (var q = 0; q < 256; q++) {
        _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      exports.string2buf = function (str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        buf = new utils.Buf8(buf_len);

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Helper (used in 2 places)
      function buf2binstring(buf, len) {
        // use fallback for big arrays to avoid stack overflow
        if (len < 65537) {
          if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
            return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
          }
        }
        var result = '';
        for (var i = 0; i < len; i++) {
          result += String.fromCharCode(buf[i]);
        }
        return result;
      }

      // Convert byte array to binary string
      exports.buf2binstring = function (buf) {
        return buf2binstring(buf, buf.length);
      };

      // Convert binary string (typed, when possible)
      exports.binstring2buf = function (str) {
        var buf = new utils.Buf8(str.length);
        for (var i = 0, len = buf.length; i < len; i++) {
          buf[i] = str.charCodeAt(i);
        }
        return buf;
      };

      // convert array to string
      exports.buf2string = function (buf, max) {
        var i, out, c, c_len;
        var len = max || buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }
        return buf2binstring(utf16buf, out);
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      exports.utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };
    }, {
      "./common": 28
    }],
    30: [function (require, module, exports) {
      'use strict';

      // Note: adler32 takes 12% for level 0 and 2% for level 6.
      // It doesn't worth to make additional optimizationa as in original.
      // Small size is preferable.
      function adler32(adler, buf, len, pos) {
        var s1 = adler & 0xffff | 0,
          s2 = adler >>> 16 & 0xffff | 0,
          n = 0;
        while (len !== 0) {
          // Set limit ~ twice less than 5552, to keep
          // s2 in 31-bits, because we force signed ints.
          // in other case %= will fail.
          n = len > 2000 ? 2000 : len;
          len -= n;
          do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
          } while (--n);
          s1 %= 65521;
          s2 %= 65521;
        }
        return s1 | s2 << 16 | 0;
      }
      module.exports = adler32;
    }, {}],
    31: [function (require, module, exports) {
      'use strict';

      module.exports = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        /* Return codes for the compression/decompression functions. Negative values
        * are errors, positive values are used for special but normal events.
        */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        //Z_MEM_ERROR:     -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,

        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,
        /* The deflate compression method */
        Z_DEFLATED: 8
        //Z_NULL:                 null // Use -1 or null inline, depending on var type
      };
    }, {}],
    32: [function (require, module, exports) {
      'use strict';

      // Note: we can't get significant speed boost here.
      // So write code to minimize size - no pregenerated tables
      // and array tools dependencies.

      // Use ordinary array, since untyped makes no boost here
      function makeTable() {
        var c,
          table = [];
        for (var n = 0; n < 256; n++) {
          c = n;
          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
          }
          table[n] = c;
        }
        return table;
      }

      // Create table on load. Just 255 signed longs. Not a problem.
      var crcTable = makeTable();
      function crc32(crc, buf, len, pos) {
        var t = crcTable,
          end = pos + len;
        crc ^= -1;
        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
        }
        return crc ^ -1; // >>> 0;
      }

      module.exports = crc32;
    }, {}],
    33: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils/common');
      var trees = require('./trees');
      var adler32 = require('./adler32');
      var crc32 = require('./crc32');
      var msg = require('./messages');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      var Z_NO_FLUSH = 0;
      var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      var Z_FULL_FLUSH = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      //var Z_TREES         = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      //var Z_NEED_DICT     = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      //var Z_MEM_ERROR     = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* compression levels */
      //var Z_NO_COMPRESSION      = 0;
      //var Z_BEST_SPEED          = 1;
      //var Z_BEST_COMPRESSION    = 9;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_FILTERED = 1;
      var Z_HUFFMAN_ONLY = 2;
      var Z_RLE = 3;
      var Z_FIXED = 4;
      var Z_DEFAULT_STRATEGY = 0;

      /* Possible values of the data_type field (though see inflate()) */
      //var Z_BINARY              = 0;
      //var Z_TEXT                = 1;
      //var Z_ASCII               = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /*============================================================================*/

      var MAX_MEM_LEVEL = 9;
      /* Maximum value for memLevel in deflateInit2 */
      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_MEM_LEVEL = 8;
      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */
      var LITERALS = 256;
      /* number of literal bytes 0..255 */
      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */
      var D_CODES = 30;
      /* number of distance codes */
      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */
      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */
      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
      var PRESET_DICT = 0x20;
      var INIT_STATE = 42;
      var EXTRA_STATE = 69;
      var NAME_STATE = 73;
      var COMMENT_STATE = 91;
      var HCRC_STATE = 103;
      var BUSY_STATE = 113;
      var FINISH_STATE = 666;
      var BS_NEED_MORE = 1; /* block not completed, need more input or more output */
      var BS_BLOCK_DONE = 2; /* block flush performed */
      var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
      var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */

      var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

      function err(strm, errorCode) {
        strm.msg = msg[errorCode];
        return errorCode;
      }
      function rank(f) {
        return (f << 1) - (f > 4 ? 9 : 0);
      }
      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      /* =========================================================================
       * Flush as much pending output as possible. All deflate() output goes
       * through this function so some applications may wish to modify it
       * to avoid allocating a large strm->output buffer and copying into it.
       * (See also read_buf()).
       */
      function flush_pending(strm) {
        var s = strm.state;

        //_tr_flush_bits(s);
        var len = s.pending;
        if (len > strm.avail_out) {
          len = strm.avail_out;
        }
        if (len === 0) {
          return;
        }
        utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
        strm.next_out += len;
        s.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s.pending -= len;
        if (s.pending === 0) {
          s.pending_out = 0;
        }
      }
      function flush_block_only(s, last) {
        trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
        s.block_start = s.strstart;
        flush_pending(s.strm);
      }
      function put_byte(s, b) {
        s.pending_buf[s.pending++] = b;
      }

      /* =========================================================================
       * Put a short in the pending buffer. The 16-bit value is put in MSB order.
       * IN assertion: the stream state is correct and there is enough room in
       * pending_buf.
       */
      function putShortMSB(s, b) {
        //  put_byte(s, (Byte)(b >> 8));
        //  put_byte(s, (Byte)(b & 0xff));
        s.pending_buf[s.pending++] = b >>> 8 & 0xff;
        s.pending_buf[s.pending++] = b & 0xff;
      }

      /* ===========================================================================
       * Read a new buffer from the current input stream, update the adler32
       * and total number of bytes read.  All deflate() input goes through
       * this function so some applications may wish to modify it to avoid
       * allocating a large strm->input buffer and copying from it.
       * (See also flush_pending()).
       */
      function read_buf(strm, buf, start, size) {
        var len = strm.avail_in;
        if (len > size) {
          len = size;
        }
        if (len === 0) {
          return 0;
        }
        strm.avail_in -= len;

        // zmemcpy(buf, strm->next_in, len);
        utils.arraySet(buf, strm.input, strm.next_in, len, start);
        if (strm.state.wrap === 1) {
          strm.adler = adler32(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
          strm.adler = crc32(strm.adler, buf, len, start);
        }
        strm.next_in += len;
        strm.total_in += len;
        return len;
      }

      /* ===========================================================================
       * Set match_start to the longest match starting at the given string and
       * return its length. Matches shorter or equal to prev_length are discarded,
       * in which case the result is equal to prev_length and match_start is
       * garbage.
       * IN assertions: cur_match is the head of the hash chain for the current
       *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
       * OUT assertion: the match length is not greater than s->lookahead.
       */
      function longest_match(s, cur_match) {
        var chain_length = s.max_chain_length; /* max hash chain length */
        var scan = s.strstart; /* current string */
        var match; /* matched string */
        var len; /* length of current match */
        var best_len = s.prev_length; /* best match length so far */
        var nice_match = s.nice_match; /* stop if match long enough */
        var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/;

        var _win = s.window; // shortcut

        var wmask = s.w_mask;
        var prev = s.prev;

        /* Stop when cur_match becomes <= limit. To simplify the code,
         * we prevent matches with the string of window index 0.
         */

        var strend = s.strstart + MAX_MATCH;
        var scan_end1 = _win[scan + best_len - 1];
        var scan_end = _win[scan + best_len];

        /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
         * It is easy to get rid of this optimization if necessary.
         */
        // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

        /* Do not waste too much time if we already have a good match: */
        if (s.prev_length >= s.good_match) {
          chain_length >>= 2;
        }
        /* Do not look for matches beyond the end of the input. This is necessary
         * to make deflate deterministic.
         */
        if (nice_match > s.lookahead) {
          nice_match = s.lookahead;
        }

        // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

        do {
          // Assert(cur_match < s->strstart, "no future");
          match = cur_match;

          /* Skip to next match if the match length cannot increase
           * or if the match length is less than 2.  Note that the checks below
           * for insufficient lookahead only occur occasionally for performance
           * reasons.  Therefore uninitialized memory will be accessed, and
           * conditional jumps will be made that depend on those values.
           * However the length of the match is limited to the lookahead, so
           * the output of deflate is not affected by the uninitialized values.
           */

          if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
            continue;
          }

          /* The check at best_len-1 can be removed because it will be made
           * again later. (This heuristic is not always a win.)
           * It is not necessary to compare scan[2] and match[2] since they
           * are always equal when the other bytes match, given that
           * the hash keys are equal and that HASH_BITS >= 8.
           */
          scan += 2;
          match++;
          // Assert(*scan == *match, "match[2]?");

          /* We check for insufficient lookahead only every 8th comparison;
           * the 256th check will be made at strstart+258.
           */
          do {
            /*jshint noempty:false*/
          } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);

          // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

          len = MAX_MATCH - (strend - scan);
          scan = strend - MAX_MATCH;
          if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) {
              break;
            }
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
          }
        } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
        if (best_len <= s.lookahead) {
          return best_len;
        }
        return s.lookahead;
      }

      /* ===========================================================================
       * Fill the window when the lookahead becomes insufficient.
       * Updates strstart and lookahead.
       *
       * IN assertion: lookahead < MIN_LOOKAHEAD
       * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
       *    At least one byte has been read, or avail_in == 0; reads are
       *    performed for at least two bytes (required for the zip translate_eol
       *    option -- not supported here).
       */
      function fill_window(s) {
        var _w_size = s.w_size;
        var p, n, m, more, str;

        //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

        do {
          more = s.window_size - s.lookahead - s.strstart;

          // JS ints have 32 bit, block below not needed
          /* Deal with !@#$% 64K limit: */
          //if (sizeof(int) <= 2) {
          //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
          //        more = wsize;
          //
          //  } else if (more == (unsigned)(-1)) {
          //        /* Very unlikely, but possible on 16 bit machine if
          //         * strstart == 0 && lookahead == 1 (input done a byte at time)
          //         */
          //        more--;
          //    }
          //}

          /* If the window is almost full and there is insufficient lookahead,
           * move the upper half to the lower one to make room in the upper half.
           */
          if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */
            s.block_start -= _w_size;

            /* Slide the hash table (could be avoided with 32 bit values
             at the expense of memory usage). We slide even when level == 0
             to keep the hash table consistent if we switch back to level > 0
             later. (Using level 0 permanently is not an optimal usage of
             zlib, so we don't care about this pathological case.)
             */

            n = s.hash_size;
            p = n;
            do {
              m = s.head[--p];
              s.head[p] = m >= _w_size ? m - _w_size : 0;
            } while (--n);
            n = _w_size;
            p = n;
            do {
              m = s.prev[--p];
              s.prev[p] = m >= _w_size ? m - _w_size : 0;
              /* If n is not on any hash chain, prev[n] is garbage but
               * its value will never be used.
               */
            } while (--n);
            more += _w_size;
          }
          if (s.strm.avail_in === 0) {
            break;
          }

          /* If there was no sliding:
           *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
           *    more == window_size - lookahead - strstart
           * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
           * => more >= window_size - 2*WSIZE + 2
           * In the BIG_MEM or MMAP case (not yet supported),
           *   window_size == input_size + MIN_LOOKAHEAD  &&
           *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
           * Otherwise, window_size == 2*WSIZE so more >= 2.
           * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
           */
          //Assert(more >= 2, "more < 2");
          n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
          s.lookahead += n;

          /* Initialize the hash value now that we have some input: */
          if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];

            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while (s.insert) {
              /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
              s.prev[str & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = str;
              str++;
              s.insert--;
              if (s.lookahead + s.insert < MIN_MATCH) {
                break;
              }
            }
          }
          /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
           * but this is not important since only literal bytes will be emitted.
           */
        } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

        /* If the WIN_INIT bytes after the end of the current data have never been
         * written, then zero those bytes in order to avoid memory check reports of
         * the use of uninitialized (or uninitialised as Julian writes) bytes by
         * the longest match routines.  Update the high water mark for the next
         * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
         * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
         */
        //  if (s.high_water < s.window_size) {
        //    var curr = s.strstart + s.lookahead;
        //    var init = 0;
        //
        //    if (s.high_water < curr) {
        //      /* Previous high water mark below current data -- zero WIN_INIT
        //       * bytes or up to end of window, whichever is less.
        //       */
        //      init = s.window_size - curr;
        //      if (init > WIN_INIT)
        //        init = WIN_INIT;
        //      zmemzero(s->window + curr, (unsigned)init);
        //      s->high_water = curr + init;
        //    }
        //    else if (s->high_water < (ulg)curr + WIN_INIT) {
        //      /* High water mark at or above current data, but below current data
        //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
        //       * to end of window, whichever is less.
        //       */
        //      init = (ulg)curr + WIN_INIT - s->high_water;
        //      if (init > s->window_size - s->high_water)
        //        init = s->window_size - s->high_water;
        //      zmemzero(s->window + s->high_water, (unsigned)init);
        //      s->high_water += init;
        //    }
        //  }
        //
        //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
        //    "not enough room for search");
      }

      /* ===========================================================================
       * Copy without compression as much as possible from the input stream, return
       * the current block state.
       * This function does not insert new strings in the dictionary since
       * uncompressible data is probably not useful. This function is used
       * only for the level=0 compression option.
       * NOTE: this function should be optimized to avoid extra copying from
       * window to pending_buf.
       */
      function deflate_stored(s, flush) {
        /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
         * to pending_buf_size, and each stored block has a 5 byte header:
         */
        var max_block_size = 0xffff;
        if (max_block_size > s.pending_buf_size - 5) {
          max_block_size = s.pending_buf_size - 5;
        }

        /* Copy as much as possible from input to output: */
        for (;;) {
          /* Fill the window as much as possible: */
          if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }

            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */
          }
          //Assert(s->block_start >= 0L, "block gone");
          //    if (s.block_start < 0) throw new Error("block gone");

          s.strstart += s.lookahead;
          s.lookahead = 0;

          /* Emit a stored block if pending_buf will be full: */
          var max_start = s.block_start + max_block_size;
          if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */
            s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          /* Flush if we may have to slide, otherwise block_start may become
           * negative and the data will be gone:
           */
          if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.strstart > s.block_start) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_NEED_MORE;
      }

      /* ===========================================================================
       * Compress as much as possible from the input stream, return the current
       * block state.
       * This function does not perform lazy evaluation of matches and inserts
       * new strings in the dictionary only for unmatched strings or for short
       * matches. It is used only for the fast compression options.
       */
      function deflate_fast(s, flush) {
        var hash_head; /* head of the hash chain */
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break; /* flush the current block */
            }
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           * At this point we have always match_length < MIN_MATCH
           */
          if (hash_head !== 0 /*NIL*/ && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */
          }

          if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                           s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;

            /* Insert new strings in the hash table only if the match length
             * is not too large. This saves time but degrades compression.
             */
            if (s.match_length <= s.max_lazy_match /*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
              s.match_length--; /* string at strstart already in table */
              do {
                s.strstart++;
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                 * always MIN_MATCH bytes ahead.
                 */
              } while (--s.match_length !== 0);
              s.strstart++;
            } else {
              s.strstart += s.match_length;
              s.match_length = 0;
              s.ins_h = s.window[s.strstart];
              /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;

              //#if MIN_MATCH != 3
              //                Call UPDATE_HASH() MIN_MATCH-3 more times
              //#endif
              /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
               * matter since it will be recomputed at next deflate call.
               */
            }
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * Same as above, but achieves better compression. We use a lazy
       * evaluation for matches: a match is finally adopted only if there is
       * no better match at the next window position.
       */
      function deflate_slow(s, flush) {
        var hash_head; /* head of hash chain */
        var bflush; /* set if current block must be flushed */

        var max_insert;

        /* Process the input block. */
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           */
          s.prev_length = s.match_length;
          s.prev_match = s.match_start;
          s.match_length = MIN_MATCH - 1;
          if (hash_head !== 0 /*NIL*/ && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */

            if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/)) {
              /* If prev_match is also MIN_MATCH, match_start is garbage
               * but we will ignore the current match anyway.
               */
              s.match_length = MIN_MATCH - 1;
            }
          }
          /* If there was a match at the previous step and the current
           * match is not better, output the previous match:
           */
          if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */

            //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                           s.prev_length - MIN_MATCH, bflush);***/
            bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
             * strstart-1 and strstart are already inserted. If there is not
             * enough lookahead, the last two strings are not inserted in
             * the hash table.
             */
            s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do {
              if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
              }
            } while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
              /*** FLUSH_BLOCK(s, 0); ***/
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          } else if (s.match_available) {
            /* If there was no match at the previous position, output a
             * single literal. If there was a match but the current match
             * is longer, truncate the previous match to a single literal.
             */
            //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) {
              /*** FLUSH_BLOCK_ONLY(s, 0) ***/
              flush_block_only(s, false);
              /***/
            }

            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          } else {
            /* There is no previous match to compare with, wait for
             * the next step to decide.
             */
            s.match_available = 1;
            s.strstart++;
            s.lookahead--;
          }
        }
        //Assert (flush != Z_NO_FLUSH, "no flush?");
        if (s.match_available) {
          //Tracevv((stderr,"%c", s->window[s->strstart-1]));
          /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
          s.match_available = 0;
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_RLE, simply look for runs of bytes, generate matches only of distance
       * one.  Do not maintain a hash table.  (It will be regenerated if this run of
       * deflate switches away from Z_RLE.)
       */
      function deflate_rle(s, flush) {
        var bflush; /* set if current block must be flushed */
        var prev; /* byte at distance one to match */
        var scan, strend; /* scan goes up to strend for length of run */

        var _win = s.window;
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the longest run, plus one for the unrolled loop.
           */
          if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* See how many times the previous byte repeats */
          s.match_length = 0;
          if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
              strend = s.strstart + MAX_MATCH;
              do {
                /*jshint noempty:false*/
              } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
              s.match_length = MAX_MATCH - (strend - scan);
              if (s.match_length > s.lookahead) {
                s.match_length = s.lookahead;
              }
            }
            //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
          }

          /* Emit match if have run of MIN_MATCH or longer, else emit literal */
          if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);

            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
       * (It will be regenerated if this run of deflate switches away from Huffman.)
       */
      function deflate_huff(s, flush) {
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we have a literal to write. */
          if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
              if (flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              break; /* flush the current block */
            }
          }

          /* Output a literal byte */
          s.match_length = 0;
          //Tracevv((stderr,"%c", s->window[s->strstart]));
          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }

        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }

        return BS_BLOCK_DONE;
      }

      /* Values for max_lazy_match, good_match and max_chain_length, depending on
       * the desired pack level (0..9). The values given below have been tuned to
       * exclude worst case performance for pathological files. Better values may be
       * found for specific files.
       */
      function Config(good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      }
      var configuration_table;
      configuration_table = [/*      good lazy nice chain */
      new Config(0, 0, 0, 0, deflate_stored), /* 0 store only */
      new Config(4, 4, 8, 4, deflate_fast), /* 1 max speed, no lazy matches */
      new Config(4, 5, 16, 8, deflate_fast), /* 2 */
      new Config(4, 6, 32, 32, deflate_fast), /* 3 */

      new Config(4, 4, 16, 16, deflate_slow), /* 4 lazy matches */
      new Config(8, 16, 32, 32, deflate_slow), /* 5 */
      new Config(8, 16, 128, 128, deflate_slow), /* 6 */
      new Config(8, 32, 128, 256, deflate_slow), /* 7 */
      new Config(32, 128, 258, 1024, deflate_slow), /* 8 */
      new Config(32, 258, 258, 4096, deflate_slow) /* 9 max compression */];

      /* ===========================================================================
       * Initialize the "longest match" routines for a new zlib stream
       */
      function lm_init(s) {
        s.window_size = 2 * s.w_size;

        /*** CLEAR_HASH(s); ***/
        zero(s.head); // Fill with NIL (= 0);

        /* Set the default configuration parameters:
         */
        s.max_lazy_match = configuration_table[s.level].max_lazy;
        s.good_match = configuration_table[s.level].good_length;
        s.nice_match = configuration_table[s.level].nice_length;
        s.max_chain_length = configuration_table[s.level].max_chain;
        s.strstart = 0;
        s.block_start = 0;
        s.lookahead = 0;
        s.insert = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        s.ins_h = 0;
      }
      function DeflateState() {
        this.strm = null; /* pointer back to this zlib stream */
        this.status = 0; /* as the name implies */
        this.pending_buf = null; /* output still pending */
        this.pending_buf_size = 0; /* size of pending_buf */
        this.pending_out = 0; /* next pending byte to output to the stream */
        this.pending = 0; /* nb of bytes in the pending buffer */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.gzhead = null; /* gzip header information to write */
        this.gzindex = 0; /* where in extra, name, or comment */
        this.method = Z_DEFLATED; /* can only be DEFLATED */
        this.last_flush = -1; /* value of flush param for previous deflate call */

        this.w_size = 0; /* LZ77 window size (32K by default) */
        this.w_bits = 0; /* log2(w_size)  (8..16) */
        this.w_mask = 0; /* w_size - 1 */

        this.window = null;
        /* Sliding window. Input bytes are read into the second half of the window,
         * and move to the first half later to keep a dictionary of at least wSize
         * bytes. With this organization, matches are limited to a distance of
         * wSize-MAX_MATCH bytes, but this ensures that IO is always
         * performed with a length multiple of the block size.
         */

        this.window_size = 0;
        /* Actual size of window: 2*wSize, except when the user input buffer
         * is directly used as sliding window.
         */

        this.prev = null;
        /* Link to older string with same hash index. To limit the size of this
         * array to 64K, this link is maintained only for the last 32K strings.
         * An index in this array is thus a window index modulo 32K.
         */

        this.head = null; /* Heads of the hash chains or NIL. */

        this.ins_h = 0; /* hash index of string to be inserted */
        this.hash_size = 0; /* number of elements in hash table */
        this.hash_bits = 0; /* log2(hash_size) */
        this.hash_mask = 0; /* hash_size-1 */

        this.hash_shift = 0;
        /* Number of bits by which ins_h must be shifted at each input
         * step. It must be such that after MIN_MATCH steps, the oldest
         * byte no longer takes part in the hash key, that is:
         *   hash_shift * MIN_MATCH >= hash_bits
         */

        this.block_start = 0;
        /* Window position at the beginning of the current output block. Gets
         * negative when the window is moved backwards.
         */

        this.match_length = 0; /* length of best match */
        this.prev_match = 0; /* previous match */
        this.match_available = 0; /* set if previous match exists */
        this.strstart = 0; /* start of string to insert */
        this.match_start = 0; /* start of matching string */
        this.lookahead = 0; /* number of valid bytes ahead in window */

        this.prev_length = 0;
        /* Length of the best match at previous step. Matches not greater than this
         * are discarded. This is used in the lazy match evaluation.
         */

        this.max_chain_length = 0;
        /* To speed up deflation, hash chains are never searched beyond this
         * length.  A higher limit improves compression ratio but degrades the
         * speed.
         */

        this.max_lazy_match = 0;
        /* Attempt to find a better match only when the current match is strictly
         * smaller than this value. This mechanism is used only for compression
         * levels >= 4.
         */
        // That's alias to max_lazy_match, don't use directly
        //this.max_insert_length = 0;
        /* Insert new strings in the hash table only if the match length is not
         * greater than this length. This saves time but degrades compression.
         * max_insert_length is used only for compression levels <= 3.
         */

        this.level = 0; /* compression level (1..9) */
        this.strategy = 0; /* favor or force Huffman coding*/

        this.good_match = 0;
        /* Use a faster search when the previous match is longer than this */

        this.nice_match = 0; /* Stop searching when current match exceeds this */

        /* used by trees.c: */

        /* Didn't use ct_data typedef below to suppress compiler warning */

        // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
        // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
        // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

        // Use flat array of DOUBLE size, with interleaved fata,
        // because JS does not support effective
        this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
        this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
        this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null; /* desc. for literal tree */
        this.d_desc = null; /* desc. for distance tree */
        this.bl_desc = null; /* desc. for bit length tree */

        //ush bl_count[MAX_BITS+1];
        this.bl_count = new utils.Buf16(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
        this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */
        zero(this.heap);
        this.heap_len = 0; /* number of elements in the heap */
        this.heap_max = 0; /* element of largest frequency */
        /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
         * The same heap array is used to build all trees.
         */

        this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
        zero(this.depth);
        /* Depth of each subtree used as tie breaker for trees of equal frequency
         */

        this.l_buf = 0; /* buffer index for literals or lengths */

        this.lit_bufsize = 0;
        /* Size of match buffer for literals/lengths.  There are 4 reasons for
         * limiting lit_bufsize to 64K:
         *   - frequencies can be kept in 16 bit counters
         *   - if compression is not successful for the first block, all input
         *     data is still in the window so we can still emit a stored block even
         *     when input comes from standard input.  (This can also be done for
         *     all blocks if lit_bufsize is not greater than 32K.)
         *   - if compression is not successful for a file smaller than 64K, we can
         *     even emit a stored file instead of a stored block (saving 5 bytes).
         *     This is applicable only for zip (not gzip or zlib).
         *   - creating new Huffman trees less frequently may not provide fast
         *     adaptation to changes in the input data statistics. (Take for
         *     example a binary file with poorly compressible code followed by
         *     a highly compressible string table.) Smaller buffer sizes give
         *     fast adaptation but have of course the overhead of transmitting
         *     trees more frequently.
         *   - I can't count above 4
         */

        this.last_lit = 0; /* running index in l_buf */

        this.d_buf = 0;
        /* Buffer index for distances. To simplify the code, d_buf and l_buf have
         * the same number of elements. To use different lengths, an extra flag
         * array would be necessary.
         */

        this.opt_len = 0; /* bit length of current block with optimal trees */
        this.static_len = 0; /* bit length of current block with static trees */
        this.matches = 0; /* number of string matches in current block */
        this.insert = 0; /* bytes at end of window left to insert */

        this.bi_buf = 0;
        /* Output buffer. bits are inserted starting at the bottom (least
         * significant bits).
         */
        this.bi_valid = 0;
        /* Number of valid bits in bi_buf.  All bits above the last valid bit
         * are always zero.
         */

        // Used for window memory init. We safely ignore it for JS. That makes
        // sense only for pointers and memory check tools.
        //this.high_water = 0;
        /* High water mark offset in window for initialized bytes -- bytes above
         * this are set to zero in order to avoid memory check warnings when
         * longest match routines access bytes past the input.  This is then
         * updated to the new high water mark.
         */
      }

      function deflateResetKeep(strm) {
        var s;
        if (!strm || !strm.state) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;
        s = strm.state;
        s.pending = 0;
        s.pending_out = 0;
        if (s.wrap < 0) {
          s.wrap = -s.wrap;
          /* was made negative by deflate(..., Z_FINISH); */
        }

        s.status = s.wrap ? INIT_STATE : BUSY_STATE;
        strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
        : 1; // adler32(0, Z_NULL, 0)
        s.last_flush = Z_NO_FLUSH;
        trees._tr_init(s);
        return Z_OK;
      }
      function deflateReset(strm) {
        var ret = deflateResetKeep(strm);
        if (ret === Z_OK) {
          lm_init(strm.state);
        }
        return ret;
      }
      function deflateSetHeader(strm, head) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        if (strm.state.wrap !== 2) {
          return Z_STREAM_ERROR;
        }
        strm.state.gzhead = head;
        return Z_OK;
      }
      function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
        if (!strm) {
          // === Z_NULL
          return Z_STREAM_ERROR;
        }
        var wrap = 1;
        if (level === Z_DEFAULT_COMPRESSION) {
          level = 6;
        }
        if (windowBits < 0) {
          /* suppress zlib wrapper */
          wrap = 0;
          windowBits = -windowBits;
        } else if (windowBits > 15) {
          wrap = 2; /* write gzip wrapper instead */
          windowBits -= 16;
        }
        if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
          return err(strm, Z_STREAM_ERROR);
        }
        if (windowBits === 8) {
          windowBits = 9;
        }
        /* until 256-byte window bug fixed */

        var s = new DeflateState();
        strm.state = s;
        s.strm = strm;
        s.wrap = wrap;
        s.gzhead = null;
        s.w_bits = windowBits;
        s.w_size = 1 << s.w_bits;
        s.w_mask = s.w_size - 1;
        s.hash_bits = memLevel + 7;
        s.hash_size = 1 << s.hash_bits;
        s.hash_mask = s.hash_size - 1;
        s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
        s.window = new utils.Buf8(s.w_size * 2);
        s.head = new utils.Buf16(s.hash_size);
        s.prev = new utils.Buf16(s.w_size);

        // Don't need mem init magic for JS.
        //s.high_water = 0;  /* nothing written to s->window yet */

        s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */

        s.pending_buf_size = s.lit_bufsize * 4;

        //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
        //s->pending_buf = (uchf *) overlay;
        s.pending_buf = new utils.Buf8(s.pending_buf_size);

        // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
        //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
        s.d_buf = 1 * s.lit_bufsize;

        //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
        s.l_buf = (1 + 2) * s.lit_bufsize;
        s.level = level;
        s.strategy = strategy;
        s.method = method;
        return deflateReset(strm);
      }
      function deflateInit(strm, level) {
        return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
      }
      function deflate(strm, flush) {
        var old_flush, s;
        var beg, val; // for gzip header write only

        if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
          return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
        }
        s = strm.state;
        if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
          return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
        }
        s.strm = strm; /* just in case */
        old_flush = s.last_flush;
        s.last_flush = flush;

        /* Write the header */
        if (s.status === INIT_STATE) {
          if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
              // s->gzhead == Z_NULL
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, OS_CODE);
              s.status = BUSY_STATE;
            } else {
              put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
              put_byte(s, s.gzhead.time & 0xff);
              put_byte(s, s.gzhead.time >> 8 & 0xff);
              put_byte(s, s.gzhead.time >> 16 & 0xff);
              put_byte(s, s.gzhead.time >> 24 & 0xff);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, s.gzhead.os & 0xff);
              if (s.gzhead.extra && s.gzhead.extra.length) {
                put_byte(s, s.gzhead.extra.length & 0xff);
                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
              }
              if (s.gzhead.hcrc) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
              }
              s.gzindex = 0;
              s.status = EXTRA_STATE;
            }
          } else
            // DEFLATE header
            {
              var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
              var level_flags = -1;
              if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
              } else if (s.level < 6) {
                level_flags = 1;
              } else if (s.level === 6) {
                level_flags = 2;
              } else {
                level_flags = 3;
              }
              header |= level_flags << 6;
              if (s.strstart !== 0) {
                header |= PRESET_DICT;
              }
              header += 31 - header % 31;
              s.status = BUSY_STATE;
              putShortMSB(s, header);

              /* Save the adler32 of the preset dictionary: */
              if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }
              strm.adler = 1; // adler32(0L, Z_NULL, 0);
            }
        }

        //#ifdef GZIP
        if (s.status === EXTRA_STATE) {
          if (s.gzhead.extra /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */

            while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  break;
                }
              }
              put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
              s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (s.gzindex === s.gzhead.extra.length) {
              s.gzindex = 0;
              s.status = NAME_STATE;
            }
          } else {
            s.status = NAME_STATE;
          }
        }
        if (s.status === NAME_STATE) {
          if (s.gzhead.name /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.name.length) {
                val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.gzindex = 0;
              s.status = COMMENT_STATE;
            }
          } else {
            s.status = COMMENT_STATE;
          }
        }
        if (s.status === COMMENT_STATE) {
          if (s.gzhead.comment /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.comment.length) {
                val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.status = HCRC_STATE;
            }
          } else {
            s.status = HCRC_STATE;
          }
        }
        if (s.status === HCRC_STATE) {
          if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
              flush_pending(strm);
            }
            if (s.pending + 2 <= s.pending_buf_size) {
              put_byte(s, strm.adler & 0xff);
              put_byte(s, strm.adler >> 8 & 0xff);
              strm.adler = 0; //crc32(0L, Z_NULL, 0);
              s.status = BUSY_STATE;
            }
          } else {
            s.status = BUSY_STATE;
          }
        }
        //#endif

        /* Flush as much pending output as possible */
        if (s.pending !== 0) {
          flush_pending(strm);
          if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
             * more output space, but possibly with both pending and
             * avail_in equal to zero. There won't be anything to do,
             * but this is not an error situation so make sure we
             * return OK instead of BUF_ERROR at next call of deflate:
             */
            s.last_flush = -1;
            return Z_OK;
          }

          /* Make sure there is something to do and avoid duplicate consecutive
           * flushes. For repeated and useless calls with Z_FINISH, we keep
           * returning Z_STREAM_END instead of Z_BUF_ERROR.
           */
        } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
          return err(strm, Z_BUF_ERROR);
        }

        /* User must not provide more input after the first FINISH: */
        if (s.status === FINISH_STATE && strm.avail_in !== 0) {
          return err(strm, Z_BUF_ERROR);
        }

        /* Start a new block or continue the current one.
         */
        if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
          var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
          if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
            s.status = FINISH_STATE;
          }
          if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) {
              s.last_flush = -1;
              /* avoid BUF_ERROR next call, see above */
            }

            return Z_OK;
            /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
             * of deflate should use the same flush parameter to make sure
             * that the flush is complete. So we don't have to output an
             * empty block here, this will be done at next call. This also
             * ensures that for a very small output buffer, we emit at most
             * one empty block.
             */
          }

          if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) {
              trees._tr_align(s);
            } else if (flush !== Z_BLOCK) {
              /* FULL_FLUSH or SYNC_FLUSH */

              trees._tr_stored_block(s, 0, 0, false);
              /* For a full flush, this empty block will be recognized
               * as a special marker by inflate_sync().
               */
              if (flush === Z_FULL_FLUSH) {
                /*** CLEAR_HASH(s); ***/ /* forget history */
                zero(s.head); // Fill with NIL (= 0);

                if (s.lookahead === 0) {
                  s.strstart = 0;
                  s.block_start = 0;
                  s.insert = 0;
                }
              }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
              s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
              return Z_OK;
            }
          }
        }
        //Assert(strm->avail_out > 0, "bug2");
        //if (strm.avail_out <= 0) { throw new Error("bug2");}

        if (flush !== Z_FINISH) {
          return Z_OK;
        }
        if (s.wrap <= 0) {
          return Z_STREAM_END;
        }

        /* Write the trailer */
        if (s.wrap === 2) {
          put_byte(s, strm.adler & 0xff);
          put_byte(s, strm.adler >> 8 & 0xff);
          put_byte(s, strm.adler >> 16 & 0xff);
          put_byte(s, strm.adler >> 24 & 0xff);
          put_byte(s, strm.total_in & 0xff);
          put_byte(s, strm.total_in >> 8 & 0xff);
          put_byte(s, strm.total_in >> 16 & 0xff);
          put_byte(s, strm.total_in >> 24 & 0xff);
        } else {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }
        flush_pending(strm);
        /* If avail_out is zero, the application will call deflate again
         * to flush the rest.
         */
        if (s.wrap > 0) {
          s.wrap = -s.wrap;
        }
        /* write the trailer only once! */
        return s.pending !== 0 ? Z_OK : Z_STREAM_END;
      }
      function deflateEnd(strm) {
        var status;
        if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
          return Z_STREAM_ERROR;
        }
        status = strm.state.status;
        if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.state = null;
        return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
      }

      /* =========================================================================
       * Initializes the compression dictionary from the given byte
       * sequence without producing any compressed output.
       */
      function deflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var s;
        var str, n;
        var wrap;
        var avail;
        var next;
        var input;
        var tmpDict;
        if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
          return Z_STREAM_ERROR;
        }
        s = strm.state;
        wrap = s.wrap;
        if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) {
          return Z_STREAM_ERROR;
        }

        /* when using zlib wrappers, compute Adler-32 for provided dictionary */
        if (wrap === 1) {
          /* adler32(strm->adler, dictionary, dictLength); */
          strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
        }
        s.wrap = 0; /* avoid computing Adler-32 in read_buf */

        /* if dictionary would fill window, just replace the history */
        if (dictLength >= s.w_size) {
          if (wrap === 0) {
            /* already empty otherwise */
            /*** CLEAR_HASH(s); ***/
            zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
          /* use the tail */
          // dictionary = dictionary.slice(dictLength - s.w_size);
          tmpDict = new utils.Buf8(s.w_size);
          utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
          dictionary = tmpDict;
          dictLength = s.w_size;
        }
        /* insert dictionary into window and hash */
        avail = strm.avail_in;
        next = strm.next_in;
        input = strm.input;
        strm.avail_in = dictLength;
        strm.next_in = 0;
        strm.input = dictionary;
        fill_window(s);
        while (s.lookahead >= MIN_MATCH) {
          str = s.strstart;
          n = s.lookahead - (MIN_MATCH - 1);
          do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
          } while (--n);
          s.strstart = str;
          s.lookahead = MIN_MATCH - 1;
          fill_window(s);
        }
        s.strstart += s.lookahead;
        s.block_start = s.strstart;
        s.insert = s.lookahead;
        s.lookahead = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        strm.next_in = next;
        strm.input = input;
        strm.avail_in = avail;
        s.wrap = wrap;
        return Z_OK;
      }
      exports.deflateInit = deflateInit;
      exports.deflateInit2 = deflateInit2;
      exports.deflateReset = deflateReset;
      exports.deflateResetKeep = deflateResetKeep;
      exports.deflateSetHeader = deflateSetHeader;
      exports.deflate = deflate;
      exports.deflateEnd = deflateEnd;
      exports.deflateSetDictionary = deflateSetDictionary;
      exports.deflateInfo = 'pako deflate (from Nodeca project)';

      /* Not implemented
      exports.deflateBound = deflateBound;
      exports.deflateCopy = deflateCopy;
      exports.deflateParams = deflateParams;
      exports.deflatePending = deflatePending;
      exports.deflatePrime = deflatePrime;
      exports.deflateTune = deflateTune;
      */
    }, {
      "../utils/common": 28,
      "./adler32": 30,
      "./crc32": 32,
      "./messages": 38,
      "./trees": 39
    }],
    34: [function (require, module, exports) {
      'use strict';

      function GZheader() {
        /* true if compressed data believed to be text */
        this.text = 0;
        /* modification time */
        this.time = 0;
        /* extra flags (not used when writing a gzip file) */
        this.xflags = 0;
        /* operating system */
        this.os = 0;
        /* pointer to extra field or Z_NULL if none */
        this.extra = null;
        /* extra field length (valid if extra != Z_NULL) */
        this.extra_len = 0; // Actually, we don't need it in JS,
        // but leave for few code modifications

        //
        // Setup limits is not necessary because in js we should not preallocate memory
        // for inflate use constant limit in 65536 bytes
        //

        /* space at extra (only when reading header) */
        // this.extra_max  = 0;
        /* pointer to zero-terminated file name or Z_NULL */
        this.name = '';
        /* space at name (only when reading header) */
        // this.name_max   = 0;
        /* pointer to zero-terminated comment or Z_NULL */
        this.comment = '';
        /* space at comment (only when reading header) */
        // this.comm_max   = 0;
        /* true if there was or will be a header crc */
        this.hcrc = 0;
        /* true when done reading gzip header (not used when writing a gzip file) */
        this.done = false;
      }
      module.exports = GZheader;
    }, {}],
    35: [function (require, module, exports) {
      'use strict';

      // See state defs from inflate.js
      var BAD = 30; /* got a data error -- remain here until reset */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */

      /*
         Decode literal, length, and distance codes and write out the resulting
         literal and match bytes until either not enough input or output is
         available, an end-of-block is encountered, or a data error is encountered.
         When large enough input and output buffers are supplied to inflate(), for
         example, a 16K input buffer and a 64K output buffer, more than 95% of the
         inflate execution time is spent in this routine.
      
         Entry assumptions:
      
              state.mode === LEN
              strm.avail_in >= 6
              strm.avail_out >= 258
              start >= strm.avail_out
              state.bits < 8
      
         On return, state.mode is one of:
      
              LEN -- ran out of enough output space or enough available input
              TYPE -- reached end of block code, inflate() to interpret next block
              BAD -- error in block data
      
         Notes:
      
          - The maximum input bits used by a length/distance pair is 15 bits for the
            length code, 5 bits for the length extra, 15 bits for the distance code,
            and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
            Therefore if strm.avail_in >= 6, then there is enough input to avoid
            checking for available input while decoding.
      
          - The maximum bytes that a single length/distance pair can output is 258
            bytes, which is the maximum length that can be coded.  inflate_fast()
            requires strm.avail_out >= 258 for each loop to avoid checking for
            output space.
       */
      module.exports = function inflate_fast(strm, start) {
        var state;
        var _in; /* local strm.input */
        var last; /* have enough input while in < last */
        var _out; /* local strm.output */
        var beg; /* inflate()'s initial strm.output */
        var end; /* while out < end, enough space available */
        //#ifdef INFLATE_STRICT
        var dmax; /* maximum distance from zlib header */
        //#endif
        var wsize; /* window size or zero if not using window */
        var whave; /* valid bytes in the window */
        var wnext; /* window write index */
        // Use `s_window` instead `window`, avoid conflict with instrumentation tools
        var s_window; /* allocated sliding window, if wsize != 0 */
        var hold; /* local strm.hold */
        var bits; /* local strm.bits */
        var lcode; /* local strm.lencode */
        var dcode; /* local strm.distcode */
        var lmask; /* mask for first level of length codes */
        var dmask; /* mask for first level of distance codes */
        var here; /* retrieved table entry */
        var op; /* code bits, operation, extra bits, or */
        /*  window position, window bytes to copy */
        var len; /* match length, unused bytes */
        var dist; /* match distance */
        var from; /* where to copy match from */
        var from_source;
        var input, output; // JS specific, because we have no pointers

        /* copy state to local variables */
        state = strm.state;
        //here = state.here;
        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257);
        //#ifdef INFLATE_STRICT
        dmax = state.dmax;
        //#endif
        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        s_window = state.window;
        hold = state.hold;
        bits = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;

        /* decode literals and length/distances until end-of-block or not enough
           input data or output space */

        top: do {
          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }
          here = lcode[hold & lmask];
          dolen: for (;;) {
            // Goto emulation
            op = here >>> 24 /*here.bits*/;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/;
            if (op === 0) {
              /* literal */
              //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
              //        "inflate:         literal '%c'\n" :
              //        "inflate:         literal 0x%02x\n", here.val));
              output[_out++] = here & 0xffff /*here.val*/;
            } else if (op & 16) {
              /* length base */
              len = here & 0xffff /*here.val*/;
              op &= 15; /* number of extra bits */
              if (op) {
                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                }
                len += hold & (1 << op) - 1;
                hold >>>= op;
                bits -= op;
              }
              //Tracevv((stderr, "inflate:         length %u\n", len));
              if (bits < 15) {
                hold += input[_in++] << bits;
                bits += 8;
                hold += input[_in++] << bits;
                bits += 8;
              }
              here = dcode[hold & dmask];
              dodist: for (;;) {
                // goto emulation
                op = here >>> 24 /*here.bits*/;
                hold >>>= op;
                bits -= op;
                op = here >>> 16 & 0xff /*here.op*/;

                if (op & 16) {
                  /* distance base */
                  dist = here & 0xffff /*here.val*/;
                  op &= 15; /* number of extra bits */
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    if (bits < op) {
                      hold += input[_in++] << bits;
                      bits += 8;
                    }
                  }
                  dist += hold & (1 << op) - 1;
                  //#ifdef INFLATE_STRICT
                  if (dist > dmax) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break top;
                  }
                  //#endif
                  hold >>>= op;
                  bits -= op;
                  //Tracevv((stderr, "inflate:         distance %u\n", dist));
                  op = _out - beg; /* max distance in output */
                  if (dist > op) {
                    /* see if copy from window */
                    op = dist - op; /* distance back in window */
                    if (op > whave) {
                      if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break top;
                      }

                      // (!) This block is disabled in zlib defailts,
                      // don't enable it for binary compatibility
                      //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                      //                if (len <= op - whave) {
                      //                  do {
                      //                    output[_out++] = 0;
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //                len -= op - whave;
                      //                do {
                      //                  output[_out++] = 0;
                      //                } while (--op > whave);
                      //                if (op === 0) {
                      //                  from = _out - dist;
                      //                  do {
                      //                    output[_out++] = output[from++];
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //#endif
                    }

                    from = 0; // window index
                    from_source = s_window;
                    if (wnext === 0) {
                      /* very common case */
                      from += wsize - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    } else if (wnext < op) {
                      /* wrap around window */
                      from += wsize + wnext - op;
                      op -= wnext;
                      if (op < len) {
                        /* some from end of window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = 0;
                        if (wnext < len) {
                          /* some from start of window */
                          op = wnext;
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = _out - dist; /* rest from output */
                          from_source = output;
                        }
                      }
                    } else {
                      /* contiguous in window */
                      from += wnext - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    }
                    while (len > 2) {
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      len -= 3;
                    }
                    if (len) {
                      output[_out++] = from_source[from++];
                      if (len > 1) {
                        output[_out++] = from_source[from++];
                      }
                    }
                  } else {
                    from = _out - dist; /* copy direct from output */
                    do {
                      /* minimum length is three */
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      len -= 3;
                    } while (len > 2);
                    if (len) {
                      output[_out++] = output[from++];
                      if (len > 1) {
                        output[_out++] = output[from++];
                      }
                    }
                  }
                } else if ((op & 64) === 0) {
                  /* 2nd level distance code */
                  here = dcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
                  continue dodist;
                } else {
                  strm.msg = 'invalid distance code';
                  state.mode = BAD;
                  break top;
                }
                break; // need to emulate goto via "continue"
              }
            } else if ((op & 64) === 0) {
              /* 2nd level length code */
              here = lcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
              continue dolen;
            } else if (op & 32) {
              /* end-of-block */
              //Tracevv((stderr, "inflate:         end of block\n"));
              state.mode = TYPE;
              break top;
            } else {
              strm.msg = 'invalid literal/length code';
              state.mode = BAD;
              break top;
            }
            break; // need to emulate goto via "continue"
          }
        } while (_in < last && _out < end);

        /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
        len = bits >> 3;
        _in -= len;
        bits -= len << 3;
        hold &= (1 << bits) - 1;

        /* update state and return */
        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits;
        return;
      };
    }, {}],
    36: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils/common');
      var adler32 = require('./adler32');
      var crc32 = require('./crc32');
      var inflate_fast = require('./inffast');
      var inflate_table = require('./inftrees');
      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      //var Z_NO_FLUSH      = 0;
      //var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      //var Z_FULL_FLUSH    = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_TREES = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_NEED_DICT = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_MEM_ERROR = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /* STATES ====================================================================*/
      /* ===========================================================================*/

      var HEAD = 1; /* i: waiting for magic header */
      var FLAGS = 2; /* i: waiting for method and flags (gzip) */
      var TIME = 3; /* i: waiting for modification time (gzip) */
      var OS = 4; /* i: waiting for extra flags and operating system (gzip) */
      var EXLEN = 5; /* i: waiting for extra length (gzip) */
      var EXTRA = 6; /* i: waiting for extra bytes (gzip) */
      var NAME = 7; /* i: waiting for end of file name (gzip) */
      var COMMENT = 8; /* i: waiting for end of comment (gzip) */
      var HCRC = 9; /* i: waiting for header crc (gzip) */
      var DICTID = 10; /* i: waiting for dictionary check value */
      var DICT = 11; /* waiting for inflateSetDictionary() call */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */
      var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */
      var STORED = 14; /* i: waiting for stored size (length and complement) */
      var COPY_ = 15; /* i/o: same as COPY below, but only first time in */
      var COPY = 16; /* i/o: waiting for input or output to copy stored block */
      var TABLE = 17; /* i: waiting for dynamic block table lengths */
      var LENLENS = 18; /* i: waiting for code length code lengths */
      var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */
      var LEN_ = 20; /* i: same as LEN below, but only first time in */
      var LEN = 21; /* i: waiting for length/lit/eob code */
      var LENEXT = 22; /* i: waiting for length extra bits */
      var DIST = 23; /* i: waiting for distance code */
      var DISTEXT = 24; /* i: waiting for distance extra bits */
      var MATCH = 25; /* o: waiting for output space to copy string */
      var LIT = 26; /* o: waiting for output space to write literal */
      var CHECK = 27; /* i: waiting for 32-bit check value */
      var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */
      var DONE = 29; /* finished check, done -- remain here until reset */
      var BAD = 30; /* got a data error -- remain here until reset */
      var MEM = 31; /* got an inflate() memory error -- remain here until reset */
      var SYNC = 32; /* looking for synchronization bytes to restart inflate() */

      /* ===========================================================================*/

      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_WBITS = MAX_WBITS;
      function zswap32(q) {
        return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
      }
      function InflateState() {
        this.mode = 0; /* current inflate mode */
        this.last = false; /* true if processing last block */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.havedict = false; /* true if dictionary provided */
        this.flags = 0; /* gzip header method and flags (0 if zlib) */
        this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
        this.check = 0; /* protected copy of check value */
        this.total = 0; /* protected copy of output count */
        // TODO: may be {}
        this.head = null; /* where to save gzip header information */

        /* sliding window */
        this.wbits = 0; /* log base 2 of requested window size */
        this.wsize = 0; /* window size or zero if not using window */
        this.whave = 0; /* valid bytes in the window */
        this.wnext = 0; /* window write index */
        this.window = null; /* allocated sliding window, if needed */

        /* bit accumulator */
        this.hold = 0; /* input bit accumulator */
        this.bits = 0; /* number of bits in "in" */

        /* for string and stored block copying */
        this.length = 0; /* literal or length of data to copy */
        this.offset = 0; /* distance back to copy string from */

        /* for table and code decoding */
        this.extra = 0; /* extra bits needed */

        /* fixed and dynamic code tables */
        this.lencode = null; /* starting table for length/literal codes */
        this.distcode = null; /* starting table for distance codes */
        this.lenbits = 0; /* index bits for lencode */
        this.distbits = 0; /* index bits for distcode */

        /* dynamic table building */
        this.ncode = 0; /* number of code length code lengths */
        this.nlen = 0; /* number of length code lengths */
        this.ndist = 0; /* number of distance code lengths */
        this.have = 0; /* number of code lengths in lens[] */
        this.next = null; /* next available space in codes[] */

        this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
        this.work = new utils.Buf16(288); /* work area for code table building */

        /*
         because we don't have pointers in js, we use lencode and distcode directly
         as buffers so we don't need codes
        */
        //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
        this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */
        this.distdyn = null; /* dynamic table for distance codes (JS specific) */
        this.sane = 0; /* if false, allow invalid distance too far */
        this.back = 0; /* bits back of last unprocessed length/lit */
        this.was = 0; /* initial length of match */
      }

      function inflateResetKeep(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = ''; /*Z_NULL*/
        if (state.wrap) {
          /* to support ill-conceived Java test suite */
          strm.adler = state.wrap & 1;
        }
        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.dmax = 32768;
        state.head = null /*Z_NULL*/;
        state.hold = 0;
        state.bits = 0;
        //state.lencode = state.distcode = state.next = state.codes;
        state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
        state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
        state.sane = 1;
        state.back = -1;
        //Tracev((stderr, "inflate: reset\n"));
        return Z_OK;
      }
      function inflateReset(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
      }
      function inflateReset2(strm, windowBits) {
        var wrap;
        var state;

        /* get the state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;

        /* extract wrap request from windowBits parameter */
        if (windowBits < 0) {
          wrap = 0;
          windowBits = -windowBits;
        } else {
          wrap = (windowBits >> 4) + 1;
          if (windowBits < 48) {
            windowBits &= 15;
          }
        }

        /* set number of window bits, free window if different */
        if (windowBits && (windowBits < 8 || windowBits > 15)) {
          return Z_STREAM_ERROR;
        }
        if (state.window !== null && state.wbits !== windowBits) {
          state.window = null;
        }

        /* update state and reset the rest of it */
        state.wrap = wrap;
        state.wbits = windowBits;
        return inflateReset(strm);
      }
      function inflateInit2(strm, windowBits) {
        var ret;
        var state;
        if (!strm) {
          return Z_STREAM_ERROR;
        }
        //strm.msg = Z_NULL;                 /* in case we return an error */

        state = new InflateState();

        //if (state === Z_NULL) return Z_MEM_ERROR;
        //Tracev((stderr, "inflate: allocated\n"));
        strm.state = state;
        state.window = null /*Z_NULL*/;
        ret = inflateReset2(strm, windowBits);
        if (ret !== Z_OK) {
          strm.state = null /*Z_NULL*/;
        }

        return ret;
      }
      function inflateInit(strm) {
        return inflateInit2(strm, DEF_WBITS);
      }

      /*
       Return state with length and distance decoding tables and index sizes set to
       fixed code decoding.  Normally this returns fixed tables from inffixed.h.
       If BUILDFIXED is defined, then instead this routine builds the tables the
       first time it's called, and returns those tables the first time and
       thereafter.  This reduces the size of the code by about 2K bytes, in
       exchange for a little execution time.  However, BUILDFIXED should not be
       used for threaded applications, since the rewriting of the tables and virgin
       may not be thread-safe.
       */
      var virgin = true;
      var lenfix, distfix; // We have no pointers in JS, so keep tables separate

      function fixedtables(state) {
        /* build fixed huffman tables if first call (may not be thread safe) */
        if (virgin) {
          var sym;
          lenfix = new utils.Buf32(512);
          distfix = new utils.Buf32(32);

          /* literal/length table */
          sym = 0;
          while (sym < 144) {
            state.lens[sym++] = 8;
          }
          while (sym < 256) {
            state.lens[sym++] = 9;
          }
          while (sym < 280) {
            state.lens[sym++] = 7;
          }
          while (sym < 288) {
            state.lens[sym++] = 8;
          }
          inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
          });

          /* distance table */
          sym = 0;
          while (sym < 32) {
            state.lens[sym++] = 5;
          }
          inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
          });

          /* do this just once */
          virgin = false;
        }
        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
      }

      /*
       Update the window with the last wsize (normally 32K) bytes written before
       returning.  If window does not exist yet, create it.  This is only called
       when a window is already in use, or when output has been written during this
       inflate call, but the end of the deflate stream has not been reached yet.
       It is also called to create a window for dictionary data when a dictionary
       is loaded.
      
       Providing output buffers larger than 32K to inflate() should provide a speed
       advantage, since only the last 32K of output is copied to the sliding window
       upon return from inflate(), and since all distances after the first 32K of
       output will fall in the output data, making match copies simpler and faster.
       The advantage may be dependent on the size of the processor's data caches.
       */
      function updatewindow(strm, src, end, copy) {
        var dist;
        var state = strm.state;

        /* if it hasn't been done already, allocate space for the window */
        if (state.window === null) {
          state.wsize = 1 << state.wbits;
          state.wnext = 0;
          state.whave = 0;
          state.window = new utils.Buf8(state.wsize);
        }

        /* copy state->wsize or less output bytes into the circular window */
        if (copy >= state.wsize) {
          utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
          state.wnext = 0;
          state.whave = state.wsize;
        } else {
          dist = state.wsize - state.wnext;
          if (dist > copy) {
            dist = copy;
          }
          //zmemcpy(state->window + state->wnext, end - copy, dist);
          utils.arraySet(state.window, src, end - copy, dist, state.wnext);
          copy -= dist;
          if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
          } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) {
              state.wnext = 0;
            }
            if (state.whave < state.wsize) {
              state.whave += dist;
            }
          }
        }
        return 0;
      }
      function inflate(strm, flush) {
        var state;
        var input, output; // input/output buffers
        var next; /* next input INDEX */
        var put; /* next output INDEX */
        var have, left; /* available input and output */
        var hold; /* bit buffer */
        var bits; /* bits in bit buffer */
        var _in, _out; /* save starting available input and output */
        var copy; /* number of stored or match bytes to copy */
        var from; /* where to copy match bytes from */
        var from_source;
        var here = 0; /* current decoding table entry */
        var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
        //var last;                   /* parent table entry */
        var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
        var len; /* length to copy for repeats, bits to drop */
        var ret; /* return code */
        var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */
        var opts;
        var n; // temporary var for NEED_BITS

        var order = /* permutation of code lengths */
        [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.mode === TYPE) {
          state.mode = TYPEDO;
        } /* skip check */

        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        _in = have;
        _out = left;
        ret = Z_OK;
        inf_leave:
        // goto emulation
        for (;;) {
          switch (state.mode) {
            case HEAD:
              if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
              }
              //=== NEEDBITS(16);
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//

                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
              }
              state.flags = 0; /* expect zlib header */
              if (state.head) {
                state.head.done = false;
              }
              if (!(state.wrap & 1) || /* check if zlib header allowed */
              (((hold & 0xff /*BITS(8)*/) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
              }
              if ((hold & 0x0f /*BITS(4)*/) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              len = (hold & 0x0f /*BITS(4)*/) + 8;
              if (state.wbits === 0) {
                state.wbits = len;
              } else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
              }
              state.dmax = 1 << len;
              //Tracev((stderr, "inflate:   zlib header ok\n"));
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = hold & 0x200 ? DICTID : TYPE;
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              break;
            case FLAGS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.flags = hold;
              if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
              }
              if (state.head) {
                state.head.text = hold >> 8 & 1;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = TIME;
            /* falls through */
            case TIME:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.time = hold;
              }
              if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
                //===
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = OS;
            /* falls through */
            case OS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = EXLEN;
            /* falls through */
            case EXLEN:
              if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) {
                  state.head.extra_len = hold;
                }
                if (state.flags & 0x0200) {
                  //=== CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = hold >>> 8 & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              } else if (state.head) {
                state.head.extra = null /*Z_NULL*/;
              }

              state.mode = EXTRA;
            /* falls through */
            case EXTRA:
              if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) {
                  copy = have;
                }
                if (copy) {
                  if (state.head) {
                    len = state.head.extra_len - state.length;
                    if (!state.head.extra) {
                      // Use untyped array for more conveniend processing later
                      state.head.extra = new Array(state.head.extra_len);
                    }
                    utils.arraySet(state.head.extra, input, next,
                    // extra field is limited to 65536 bytes
                    // - no need for additional size check
                    copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                  }

                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  state.length -= copy;
                }
                if (state.length) {
                  break inf_leave;
                }
              }
              state.length = 0;
              state.mode = NAME;
            /* falls through */
            case NAME:
              if (state.flags & 0x0800) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  // TODO: 2 or 1 bytes?
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.name_max*/) {
                    state.head.name += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.name = null;
              }
              state.length = 0;
              state.mode = COMMENT;
            /* falls through */
            case COMMENT:
              if (state.flags & 0x1000) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.comm_max*/) {
                    state.head.comment += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.comment = null;
              }
              state.mode = HCRC;
            /* falls through */
            case HCRC:
              if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                  strm.msg = 'header crc mismatch';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              }

              if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
              }
              strm.adler = state.check = 0;
              state.mode = TYPE;
              break;
            case DICTID:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              strm.adler = state.check = zswap32(hold);
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = DICT;
            /* falls through */
            case DICT:
              if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
              }
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = TYPE;
            /* falls through */
            case TYPE:
              if (flush === Z_BLOCK || flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case TYPEDO:
              if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
              }
              //=== NEEDBITS(3); */
              while (bits < 3) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.last = hold & 0x01 /*BITS(1)*/;
              //--- DROPBITS(1) ---//
              hold >>>= 1;
              bits -= 1;
              //---//

              switch (hold & 0x03 /*BITS(2)*/) {
                case 0:
                  /* stored block */
                  //Tracev((stderr, "inflate:     stored block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = STORED;
                  break;
                case 1:
                  /* fixed block */
                  fixedtables(state);
                  //Tracev((stderr, "inflate:     fixed codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = LEN_; /* decode codes */
                  if (flush === Z_TREES) {
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                    break inf_leave;
                  }
                  break;
                case 2:
                  /* dynamic block */
                  //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = TABLE;
                  break;
                case 3:
                  strm.msg = 'invalid block type';
                  state.mode = BAD;
              }
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break;
            case STORED:
              //--- BYTEBITS() ---// /* go to byte boundary */
              hold >>>= bits & 7;
              bits -= bits & 7;
              //---//
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
              }
              state.length = hold & 0xffff;
              //Tracev((stderr, "inflate:       stored length %u\n",
              //        state.length));
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = COPY_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case COPY_:
              state.mode = COPY;
            /* falls through */
            case COPY:
              copy = state.length;
              if (copy) {
                if (copy > have) {
                  copy = have;
                }
                if (copy > left) {
                  copy = left;
                }
                if (copy === 0) {
                  break inf_leave;
                }
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
              }
              //Tracev((stderr, "inflate:       stored end\n"));
              state.mode = TYPE;
              break;
            case TABLE:
              //=== NEEDBITS(14); */
              while (bits < 14) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.nlen = (hold & 0x1f /*BITS(5)*/) + 257;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ndist = (hold & 0x1f /*BITS(5)*/) + 1;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ncode = (hold & 0x0f /*BITS(4)*/) + 4;
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              //#ifndef PKZIP_BUG_WORKAROUND
              if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracev((stderr, "inflate:       table sizes ok\n"));
              state.have = 0;
              state.mode = LENLENS;
            /* falls through */
            case LENLENS:
              while (state.have < state.ncode) {
                //=== NEEDBITS(3);
                while (bits < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
                //---//
              }

              while (state.have < 19) {
                state.lens[order[state.have++]] = 0;
              }
              // We have separate tables & no pointers. 2 commented lines below not needed.
              //state.next = state.codes;
              //state.lencode = state.next;
              // Switch to use dynamic table
              state.lencode = state.lendyn;
              state.lenbits = 7;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;
              if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, "inflate:       code lengths ok\n"));
              state.have = 0;
              state.mode = CODELENS;
            /* falls through */
            case CODELENS:
              while (state.have < state.nlen + state.ndist) {
                for (;;) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }

                if (here_val < 16) {
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  state.lens[state.have++] = here_val;
                } else {
                  if (here_val === 16) {
                    //=== NEEDBITS(here.bits + 2);
                    n = here_bits + 2;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    if (state.have === 0) {
                      strm.msg = 'invalid bit length repeat';
                      state.mode = BAD;
                      break;
                    }
                    len = state.lens[state.have - 1];
                    copy = 3 + (hold & 0x03); //BITS(2);
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                  } else if (here_val === 17) {
                    //=== NEEDBITS(here.bits + 3);
                    n = here_bits + 3;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 3 + (hold & 0x07); //BITS(3);
                    //--- DROPBITS(3) ---//
                    hold >>>= 3;
                    bits -= 3;
                    //---//
                  } else {
                    //=== NEEDBITS(here.bits + 7);
                    n = here_bits + 7;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 11 + (hold & 0x7f); //BITS(7);
                    //--- DROPBITS(7) ---//
                    hold >>>= 7;
                    bits -= 7;
                    //---//
                  }

                  if (state.have + copy > state.nlen + state.ndist) {
                    strm.msg = 'invalid bit length repeat';
                    state.mode = BAD;
                    break;
                  }
                  while (copy--) {
                    state.lens[state.have++] = len;
                  }
                }
              }

              /* handle error breaks in while */
              if (state.mode === BAD) {
                break;
              }

              /* check for end-of-block code (better have one) */
              if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
              }

              /* build code tables -- note: do not change the lenbits or distbits
                 values here (9 and 6) without reading the comments in inftrees.h
                 concerning the ENOUGH constants, which depend on those values */
              state.lenbits = 9;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.lenbits = opts.bits;
              // state.lencode = state.next;

              if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
              }
              state.distbits = 6;
              //state.distcode.copy(state.codes);
              // Switch to use dynamic table
              state.distcode = state.distdyn;
              opts = {
                bits: state.distbits
              };
              ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.distbits = opts.bits;
              // state.distcode = state.next;

              if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, 'inflate:       codes ok\n'));
              state.mode = LEN_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case LEN_:
              state.mode = LEN;
            /* falls through */
            case LEN:
              if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---

                if (state.mode === TYPE) {
                  state.back = -1;
                }
                break;
              }
              state.back = 0;
              for (;;) {
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }

              if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              state.length = here_val;
              if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
              }
              if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
              }
              if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
              }
              state.extra = here_op & 15;
              state.mode = LENEXT;
            /* falls through */
            case LENEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //Tracevv((stderr, "inflate:         length %u\n", state.length));
              state.was = state.length;
              state.mode = DIST;
            /* falls through */
            case DIST:
              for (;;) {
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }

              if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
              }
              state.offset = here_val;
              state.extra = here_op & 15;
              state.mode = DISTEXT;
            /* falls through */
            case DISTEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //#ifdef INFLATE_STRICT
              if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
              state.mode = MATCH;
            /* falls through */
            case MATCH:
              if (left === 0) {
                break inf_leave;
              }
              copy = _out - left;
              if (state.offset > copy) {
                /* copy from window */
                copy = state.offset - copy;
                if (copy > state.whave) {
                  if (state.sane) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break;
                  }
                  // (!) This block is disabled in zlib defailts,
                  // don't enable it for binary compatibility
                  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                  //          Trace((stderr, "inflate.c too far\n"));
                  //          copy -= state.whave;
                  //          if (copy > state.length) { copy = state.length; }
                  //          if (copy > left) { copy = left; }
                  //          left -= copy;
                  //          state.length -= copy;
                  //          do {
                  //            output[put++] = 0;
                  //          } while (--copy);
                  //          if (state.length === 0) { state.mode = LEN; }
                  //          break;
                  //#endif
                }

                if (copy > state.wnext) {
                  copy -= state.wnext;
                  from = state.wsize - copy;
                } else {
                  from = state.wnext - copy;
                }
                if (copy > state.length) {
                  copy = state.length;
                }
                from_source = state.window;
              } else {
                /* copy from output */
                from_source = output;
                from = put - state.offset;
                copy = state.length;
              }
              if (copy > left) {
                copy = left;
              }
              left -= copy;
              state.length -= copy;
              do {
                output[put++] = from_source[from++];
              } while (--copy);
              if (state.length === 0) {
                state.mode = LEN;
              }
              break;
            case LIT:
              if (left === 0) {
                break inf_leave;
              }
              output[put++] = state.length;
              left--;
              state.mode = LEN;
              break;
            case CHECK:
              if (state.wrap) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  // Use '|' insdead of '+' to make sure that result is signed
                  hold |= input[next++] << bits;
                  bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) {
                  strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/
                  state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                }
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                  strm.msg = 'incorrect data check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   check matches trailer\n"));
              }

              state.mode = LENGTH;
            /* falls through */
            case LENGTH:
              if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                  strm.msg = 'incorrect length check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   length matches trailer\n"));
              }

              state.mode = DONE;
            /* falls through */
            case DONE:
              ret = Z_STREAM_END;
              break inf_leave;
            case BAD:
              ret = Z_DATA_ERROR;
              break inf_leave;
            case MEM:
              return Z_MEM_ERROR;
            case SYNC:
            /* falls through */
            default:
              return Z_STREAM_ERROR;
          }
        }

        // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

        /*
           Return from inflate(), updating the total counts and the check value.
           If there was no progress during the inflate() call, return a buffer
           error.  Call updatewindow() to create and/or update the window state.
           Note: a memory error from inflate() is non-recoverable.
         */

        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---

        if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
          if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
          }
        }
        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;
        if (state.wrap && _out) {
          strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
          state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
        }
        strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
        if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
          ret = Z_BUF_ERROR;
        }
        return ret;
      }
      function inflateEnd(strm) {
        if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
          return Z_STREAM_ERROR;
        }
        var state = strm.state;
        if (state.window) {
          state.window = null;
        }
        strm.state = null;
        return Z_OK;
      }
      function inflateGetHeader(strm, head) {
        var state;

        /* check state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if ((state.wrap & 2) === 0) {
          return Z_STREAM_ERROR;
        }

        /* save header structure */
        state.head = head;
        head.done = false;
        return Z_OK;
      }
      function inflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var state;
        var dictid;
        var ret;

        /* check state */
        if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.wrap !== 0 && state.mode !== DICT) {
          return Z_STREAM_ERROR;
        }

        /* check for correct dictionary identifier */
        if (state.mode === DICT) {
          dictid = 1; /* adler32(0, null, 0)*/
          /* dictid = adler32(dictid, dictionary, dictLength); */
          dictid = adler32(dictid, dictionary, dictLength, 0);
          if (dictid !== state.check) {
            return Z_DATA_ERROR;
          }
        }
        /* copy dictionary to window using updatewindow(), which will amend the
         existing dictionary if appropriate */
        ret = updatewindow(strm, dictionary, dictLength, dictLength);
        if (ret) {
          state.mode = MEM;
          return Z_MEM_ERROR;
        }
        state.havedict = 1;
        // Tracev((stderr, "inflate:   dictionary set\n"));
        return Z_OK;
      }
      exports.inflateReset = inflateReset;
      exports.inflateReset2 = inflateReset2;
      exports.inflateResetKeep = inflateResetKeep;
      exports.inflateInit = inflateInit;
      exports.inflateInit2 = inflateInit2;
      exports.inflate = inflate;
      exports.inflateEnd = inflateEnd;
      exports.inflateGetHeader = inflateGetHeader;
      exports.inflateSetDictionary = inflateSetDictionary;
      exports.inflateInfo = 'pako inflate (from Nodeca project)';

      /* Not implemented
      exports.inflateCopy = inflateCopy;
      exports.inflateGetDictionary = inflateGetDictionary;
      exports.inflateMark = inflateMark;
      exports.inflatePrime = inflatePrime;
      exports.inflateSync = inflateSync;
      exports.inflateSyncPoint = inflateSyncPoint;
      exports.inflateUndermine = inflateUndermine;
      */
    }, {
      "../utils/common": 28,
      "./adler32": 30,
      "./crc32": 32,
      "./inffast": 35,
      "./inftrees": 37
    }],
    37: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils/common');
      var MAXBITS = 15;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var lbase = [/* Length codes 257..285 base */
      3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
      var lext = [/* Length codes 257..285 extra */
      16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
      var dbase = [/* Distance codes 0..29 base */
      1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
      var dext = [/* Distance codes 0..29 extra */
      16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
        var bits = opts.bits;
        //here = opts.here; /* table entry for duplication */

        var len = 0; /* a code's length in bits */
        var sym = 0; /* index of code symbols */
        var min = 0,
          max = 0; /* minimum and maximum code lengths */
        var root = 0; /* number of index bits for root table */
        var curr = 0; /* number of index bits for current table */
        var drop = 0; /* code bits to drop for sub-table */
        var left = 0; /* number of prefix codes available */
        var used = 0; /* code entries in table used */
        var huff = 0; /* Huffman code */
        var incr; /* for incrementing code, index */
        var fill; /* index for replicating entries */
        var low; /* low bits for current root entry */
        var mask; /* mask for low root bits */
        var next; /* next available space in table */
        var base = null; /* base value table to use */
        var base_index = 0;
        //  var shoextra;    /* extra bits table to use */
        var end; /* use base and extra for symbol > end */
        var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
        var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
        var extra = null;
        var extra_index = 0;
        var here_bits, here_op, here_val;

        /*
         Process a set of code lengths to create a canonical Huffman code.  The
         code lengths are lens[0..codes-1].  Each length corresponds to the
         symbols 0..codes-1.  The Huffman code is generated by first sorting the
         symbols by length from short to long, and retaining the symbol order
         for codes with equal lengths.  Then the code starts with all zero bits
         for the first code of the shortest length, and the codes are integer
         increments for the same length, and zeros are appended as the length
         increases.  For the deflate format, these bits are stored backwards
         from their more natural integer increment ordering, and so when the
         decoding tables are built in the large loop below, the integer codes
         are incremented backwards.
          This routine assumes, but does not check, that all of the entries in
         lens[] are in the range 0..MAXBITS.  The caller must assure this.
         1..MAXBITS is interpreted as that code length.  zero means that that
         symbol does not occur in this code.
          The codes are sorted by computing a count of codes for each length,
         creating from that a table of starting indices for each length in the
         sorted table, and then entering the symbols in order in the sorted
         table.  The sorted table is work[], with that space being provided by
         the caller.
          The length counts are used for other purposes as well, i.e. finding
         the minimum and maximum length codes, determining if there are any
         codes at all, checking for a valid set of lengths, and looking ahead
         at length counts to determine sub-table sizes when building the
         decoding tables.
         */

        /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
        for (len = 0; len <= MAXBITS; len++) {
          count[len] = 0;
        }
        for (sym = 0; sym < codes; sym++) {
          count[lens[lens_index + sym]]++;
        }

        /* bound code lengths, force root to be within code lengths */
        root = bits;
        for (max = MAXBITS; max >= 1; max--) {
          if (count[max] !== 0) {
            break;
          }
        }
        if (root > max) {
          root = max;
        }
        if (max === 0) {
          /* no symbols to code at all */
          //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
          //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
          //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;

          //table.op[opts.table_index] = 64;
          //table.bits[opts.table_index] = 1;
          //table.val[opts.table_index++] = 0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          opts.bits = 1;
          return 0; /* no symbols, but wait for decoding to report error */
        }

        for (min = 1; min < max; min++) {
          if (count[min] !== 0) {
            break;
          }
        }
        if (root < min) {
          root = min;
        }

        /* check for an over-subscribed or incomplete set of lengths */
        left = 1;
        for (len = 1; len <= MAXBITS; len++) {
          left <<= 1;
          left -= count[len];
          if (left < 0) {
            return -1;
          } /* over-subscribed */
        }

        if (left > 0 && (type === CODES || max !== 1)) {
          return -1; /* incomplete set */
        }

        /* generate offsets into symbol table for each length for sorting */
        offs[1] = 0;
        for (len = 1; len < MAXBITS; len++) {
          offs[len + 1] = offs[len] + count[len];
        }

        /* sort symbols by length, by symbol order within each length */
        for (sym = 0; sym < codes; sym++) {
          if (lens[lens_index + sym] !== 0) {
            work[offs[lens[lens_index + sym]]++] = sym;
          }
        }

        /*
         Create and fill in decoding tables.  In this loop, the table being
         filled is at next and has curr index bits.  The code being used is huff
         with length len.  That code is converted to an index by dropping drop
         bits off of the bottom.  For codes where len is less than drop + curr,
         those top drop + curr - len bits are incremented through all values to
         fill the table with replicated entries.
          root is the number of index bits for the root table.  When len exceeds
         root, sub-tables are created pointed to by the root entry with an index
         of the low root bits of huff.  This is saved in low to check for when a
         new sub-table should be started.  drop is zero when the root table is
         being filled, and drop is root when sub-tables are being filled.
          When a new sub-table is needed, it is necessary to look ahead in the
         code lengths to determine what size sub-table is needed.  The length
         counts are used for this, and so count[] is decremented as codes are
         entered in the tables.
          used keeps track of how many table entries have been allocated from the
         provided *table space.  It is checked for LENS and DIST tables against
         the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
         the initial root table size constants.  See the comments in inftrees.h
         for more information.
          sym increments through all symbols, and the loop terminates when
         all codes of length max, i.e. all codes, have been processed.  This
         routine permits incomplete codes, so another loop after this one fills
         in the rest of the decoding tables with invalid code markers.
         */

        /* set up for code type */
        // poor man optimization - use if-else instead of switch,
        // to avoid deopts in old v8
        if (type === CODES) {
          base = extra = work; /* dummy value--not used */
          end = 19;
        } else if (type === LENS) {
          base = lbase;
          base_index -= 257;
          extra = lext;
          extra_index -= 257;
          end = 256;
        } else {
          /* DISTS */
          base = dbase;
          extra = dext;
          end = -1;
        }

        /* initialize opts for loop */
        huff = 0; /* starting code */
        sym = 0; /* starting code symbol */
        len = min; /* starting code length */
        next = table_index; /* current table to fill in */
        curr = root; /* current table index bits */
        drop = 0; /* current bits to drop from code for index */
        low = -1; /* trigger new sub-table when len > root */
        used = 1 << root; /* use root table entries */
        mask = used - 1; /* mask for comparing low */

        /* check available table space */
        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }
        var i = 0;
        /* process all codes and make table entries */
        for (;;) {
          i++;
          /* create table entry */
          here_bits = len - drop;
          if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
          } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
          } else {
            here_op = 32 + 64; /* end of block */
            here_val = 0;
          }

          /* replicate for those indices with low len bits equal to huff */
          incr = 1 << len - drop;
          fill = 1 << curr;
          min = fill; /* save offset to next table */
          do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
          } while (fill !== 0);

          /* backwards increment the len-bit code huff */
          incr = 1 << len - 1;
          while (huff & incr) {
            incr >>= 1;
          }
          if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
          } else {
            huff = 0;
          }

          /* go to next symbol, update count, len */
          sym++;
          if (--count[len] === 0) {
            if (len === max) {
              break;
            }
            len = lens[lens_index + work[sym]];
          }

          /* create new sub-table if needed */
          if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */
            if (drop === 0) {
              drop = root;
            }

            /* increment past last table */
            next += min; /* here min is 1 << curr */

            /* determine length of next table */
            curr = len - drop;
            left = 1 << curr;
            while (curr + drop < max) {
              left -= count[curr + drop];
              if (left <= 0) {
                break;
              }
              curr++;
              left <<= 1;
            }

            /* check for enough space */
            used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
              return 1;
            }

            /* point entry in root table to sub-table */
            low = huff & mask;
            /*table.op[low] = curr;
            table.bits[low] = root;
            table.val[low] = next - opts.table_index;*/
            table[low] = root << 24 | curr << 16 | next - table_index | 0;
          }
        }

        /* fill in remaining table entry if code is incomplete (guaranteed to have
         at most one remaining entry, since if the code is incomplete, the
         maximum code length that was allowed to get this far is one bit) */
        if (huff !== 0) {
          //table.op[next + huff] = 64;            /* invalid code marker */
          //table.bits[next + huff] = len - drop;
          //table.val[next + huff] = 0;
          table[next + huff] = len - drop << 24 | 64 << 16 | 0;
        }

        /* set return parameters */
        //opts.table_index += used;
        opts.bits = root;
        return 0;
      };
    }, {
      "../utils/common": 28
    }],
    38: [function (require, module, exports) {
      'use strict';

      module.exports = {
        2: 'need dictionary',
        /* Z_NEED_DICT       2  */
        1: 'stream end',
        /* Z_STREAM_END      1  */
        0: '',
        /* Z_OK              0  */
        '-1': 'file error',
        /* Z_ERRNO         (-1) */
        '-2': 'stream error',
        /* Z_STREAM_ERROR  (-2) */
        '-3': 'data error',
        /* Z_DATA_ERROR    (-3) */
        '-4': 'insufficient memory',
        /* Z_MEM_ERROR     (-4) */
        '-5': 'buffer error',
        /* Z_BUF_ERROR     (-5) */
        '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */
      };
    }, {}],
    39: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils/common');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      //var Z_FILTERED          = 1;
      //var Z_HUFFMAN_ONLY      = 2;
      //var Z_RLE               = 3;
      var Z_FIXED = 4;
      //var Z_DEFAULT_STRATEGY  = 0;

      /* Possible values of the data_type field (though see inflate()) */
      var Z_BINARY = 0;
      var Z_TEXT = 1;
      //var Z_ASCII             = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /*============================================================================*/

      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      // From zutil.h

      var STORED_BLOCK = 0;
      var STATIC_TREES = 1;
      var DYN_TREES = 2;
      /* The three kinds of block type */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      /* The minimum and maximum match lengths */

      // From deflate.h
      /* ===========================================================================
       * Internal compression state.
       */

      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */

      var LITERALS = 256;
      /* number of literal bytes 0..255 */

      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */

      var D_CODES = 30;
      /* number of distance codes */

      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */

      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */

      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var Buf_size = 16;
      /* size of bit buffer in bi_buf */

      /* ===========================================================================
       * Constants
       */

      var MAX_BL_BITS = 7;
      /* Bit length codes must not exceed MAX_BL_BITS bits */

      var END_BLOCK = 256;
      /* end of block literal code */

      var REP_3_6 = 16;
      /* repeat previous bit length 3-6 times (2 bits of repeat count) */

      var REPZ_3_10 = 17;
      /* repeat a zero length 3-10 times  (3 bits of repeat count) */

      var REPZ_11_138 = 18;
      /* repeat a zero length 11-138 times  (7 bits of repeat count) */

      /* eslint-disable comma-spacing,array-bracket-spacing */
      var extra_lbits = /* extra bits for each length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
      var extra_dbits = /* extra bits for each distance code */
      [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
      var extra_blbits = /* extra bits for each bit length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
      var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      /* eslint-enable comma-spacing,array-bracket-spacing */

      /* The lengths of the bit length codes are sent in order of decreasing
       * probability, to avoid transmitting the lengths for unused bit length codes.
       */

      /* ===========================================================================
       * Local data. These are initialized only once.
       */

      // We pre-fill arrays with 0 to avoid uninitialized gaps

      var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

      // !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
      var static_ltree = new Array((L_CODES + 2) * 2);
      zero(static_ltree);
      /* The static literal tree. Since the bit lengths are imposed, there is no
       * need for the L_CODES extra codes used during heap construction. However
       * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
       * below).
       */

      var static_dtree = new Array(D_CODES * 2);
      zero(static_dtree);
      /* The static distance tree. (Actually a trivial tree since all codes use
       * 5 bits.)
       */

      var _dist_code = new Array(DIST_CODE_LEN);
      zero(_dist_code);
      /* Distance codes. The first 256 values correspond to the distances
       * 3 .. 258, the last 256 values correspond to the top 8 bits of
       * the 15 bit distances.
       */

      var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
      zero(_length_code);
      /* length code for each normalized match length (0 == MIN_MATCH) */

      var base_length = new Array(LENGTH_CODES);
      zero(base_length);
      /* First normalized length for each code (0 = MIN_MATCH) */

      var base_dist = new Array(D_CODES);
      zero(base_dist);
      /* First normalized distance for each code (0 = distance of 1) */

      function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree; /* static tree or NULL */
        this.extra_bits = extra_bits; /* extra bits for each code or NULL */
        this.extra_base = extra_base; /* base index for extra_bits */
        this.elems = elems; /* max number of elements in the tree */
        this.max_length = max_length; /* max bit length for the codes */

        // show if `static_tree` has data or dummy - needed for monomorphic objects
        this.has_stree = static_tree && static_tree.length;
      }
      var static_l_desc;
      var static_d_desc;
      var static_bl_desc;
      function TreeDesc(dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree; /* the dynamic tree */
        this.max_code = 0; /* largest code with non zero frequency */
        this.stat_desc = stat_desc; /* the corresponding static tree */
      }

      function d_code(dist) {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
      }

      /* ===========================================================================
       * Output a short LSB first on the stream.
       * IN assertion: there is enough room in pendingBuf.
       */
      function put_short(s, w) {
        //    put_byte(s, (uch)((w) & 0xff));
        //    put_byte(s, (uch)((ush)(w) >> 8));
        s.pending_buf[s.pending++] = w & 0xff;
        s.pending_buf[s.pending++] = w >>> 8 & 0xff;
      }

      /* ===========================================================================
       * Send a value on a given number of bits.
       * IN assertion: length <= 16 and value fits in length bits.
       */
      function send_bits(s, value, length) {
        if (s.bi_valid > Buf_size - length) {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          put_short(s, s.bi_buf);
          s.bi_buf = value >> Buf_size - s.bi_valid;
          s.bi_valid += length - Buf_size;
        } else {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          s.bi_valid += length;
        }
      }
      function send_code(s, c, tree) {
        send_bits(s, tree[c * 2] /*.Code*/, tree[c * 2 + 1] /*.Len*/);
      }

      /* ===========================================================================
       * Reverse the first len bits of a code, using straightforward code (a faster
       * method would use a table)
       * IN assertion: 1 <= len <= 15
       */
      function bi_reverse(code, len) {
        var res = 0;
        do {
          res |= code & 1;
          code >>>= 1;
          res <<= 1;
        } while (--len > 0);
        return res >>> 1;
      }

      /* ===========================================================================
       * Flush the bit buffer, keeping at most 7 bits in it.
       */
      function bi_flush(s) {
        if (s.bi_valid === 16) {
          put_short(s, s.bi_buf);
          s.bi_buf = 0;
          s.bi_valid = 0;
        } else if (s.bi_valid >= 8) {
          s.pending_buf[s.pending++] = s.bi_buf & 0xff;
          s.bi_buf >>= 8;
          s.bi_valid -= 8;
        }
      }

      /* ===========================================================================
       * Compute the optimal bit lengths for a tree and update the total bit length
       * for the current block.
       * IN assertion: the fields freq and dad are set, heap[heap_max] and
       *    above are the tree nodes sorted by increasing frequency.
       * OUT assertions: the field len is set to the optimal bit length, the
       *     array bl_count contains the frequencies for each bit length.
       *     The length opt_len is updated; static_len is also updated if stree is
       *     not null.
       */
      function gen_bitlen(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc;    /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var max_code = desc.max_code;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var extra = desc.stat_desc.extra_bits;
        var base = desc.stat_desc.extra_base;
        var max_length = desc.stat_desc.max_length;
        var h; /* heap index */
        var n, m; /* iterate over the tree elements */
        var bits; /* bit length */
        var xbits; /* extra bits */
        var f; /* frequency */
        var overflow = 0; /* number of elements with bit length too large */

        for (bits = 0; bits <= MAX_BITS; bits++) {
          s.bl_count[bits] = 0;
        }

        /* In a first pass, compute the optimal bit lengths (which may
         * overflow in the case of the bit length tree).
         */
        tree[s.heap[s.heap_max] * 2 + 1] /*.Len*/ = 0; /* root of the heap */

        for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
          n = s.heap[h];
          bits = tree[tree[n * 2 + 1] /*.Dad*/ * 2 + 1] /*.Len*/ + 1;
          if (bits > max_length) {
            bits = max_length;
            overflow++;
          }
          tree[n * 2 + 1] /*.Len*/ = bits;
          /* We overwrite tree[n].Dad which is no longer needed */

          if (n > max_code) {
            continue;
          } /* not a leaf node */

          s.bl_count[bits]++;
          xbits = 0;
          if (n >= base) {
            xbits = extra[n - base];
          }
          f = tree[n * 2] /*.Freq*/;
          s.opt_len += f * (bits + xbits);
          if (has_stree) {
            s.static_len += f * (stree[n * 2 + 1] /*.Len*/ + xbits);
          }
        }
        if (overflow === 0) {
          return;
        }

        // Trace((stderr,"\nbit length overflow\n"));
        /* This happens for example on obj2 and pic of the Calgary corpus */

        /* Find the first bit length which could increase: */
        do {
          bits = max_length - 1;
          while (s.bl_count[bits] === 0) {
            bits--;
          }
          s.bl_count[bits]--; /* move one leaf down the tree */
          s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
          s.bl_count[max_length]--;
          /* The brother of the overflow item also moves one step up,
           * but this does not affect bl_count[max_length]
           */
          overflow -= 2;
        } while (overflow > 0);

        /* Now recompute all bit lengths, scanning in increasing frequency.
         * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
         * lengths instead of fixing only the wrong ones. This idea is taken
         * from 'ar' written by Haruhiko Okumura.)
         */
        for (bits = max_length; bits !== 0; bits--) {
          n = s.bl_count[bits];
          while (n !== 0) {
            m = s.heap[--h];
            if (m > max_code) {
              continue;
            }
            if (tree[m * 2 + 1] /*.Len*/ !== bits) {
              // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
              s.opt_len += (bits - tree[m * 2 + 1] /*.Len*/) * tree[m * 2] /*.Freq*/;
              tree[m * 2 + 1] /*.Len*/ = bits;
            }
            n--;
          }
        }
      }

      /* ===========================================================================
       * Generate the codes for a given tree and bit counts (which need not be
       * optimal).
       * IN assertion: the array bl_count contains the bit length statistics for
       * the given tree and the field len is set for all tree elements.
       * OUT assertion: the field code is set for all tree elements of non
       *     zero code length.
       */
      function gen_codes(tree, max_code, bl_count)
      //    ct_data *tree;             /* the tree to decorate */
      //    int max_code;              /* largest code with non zero frequency */
      //    ushf *bl_count;            /* number of codes at each bit length */
      {
        var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
        var code = 0; /* running code value */
        var bits; /* bit index */
        var n; /* code index */

        /* The distribution counts are first used to generate the code values
         * without bit reversal.
         */
        for (bits = 1; bits <= MAX_BITS; bits++) {
          next_code[bits] = code = code + bl_count[bits - 1] << 1;
        }
        /* Check that the bit counts in bl_count are consistent. The last code
         * must be all ones.
         */
        //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        //        "inconsistent bit counts");
        //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

        for (n = 0; n <= max_code; n++) {
          var len = tree[n * 2 + 1] /*.Len*/;
          if (len === 0) {
            continue;
          }
          /* Now reverse the bits */
          tree[n * 2] /*.Code*/ = bi_reverse(next_code[len]++, len);

          //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
          //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
        }
      }

      /* ===========================================================================
       * Initialize the various 'constant' tables.
       */
      function tr_static_init() {
        var n; /* iterates over tree elements */
        var bits; /* bit counter */
        var length; /* length value */
        var code; /* code value */
        var dist; /* distance index */
        var bl_count = new Array(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        // do check in _tr_init()
        //if (static_init_done) return;

        /* For some embedded targets, global variables are not initialized: */
        /*#ifdef NO_INIT_GLOBAL_POINTERS
          static_l_desc.static_tree = static_ltree;
          static_l_desc.extra_bits = extra_lbits;
          static_d_desc.static_tree = static_dtree;
          static_d_desc.extra_bits = extra_dbits;
          static_bl_desc.extra_bits = extra_blbits;
        #endif*/

        /* Initialize the mapping length (0..255) -> length code (0..28) */
        length = 0;
        for (code = 0; code < LENGTH_CODES - 1; code++) {
          base_length[code] = length;
          for (n = 0; n < 1 << extra_lbits[code]; n++) {
            _length_code[length++] = code;
          }
        }
        //Assert (length == 256, "tr_static_init: length != 256");
        /* Note that the length 255 (match length 258) can be represented
         * in two different ways: code 284 + 5 bits or code 285, so we
         * overwrite length_code[255] to use the best encoding:
         */
        _length_code[length - 1] = code;

        /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
        dist = 0;
        for (code = 0; code < 16; code++) {
          base_dist[code] = dist;
          for (n = 0; n < 1 << extra_dbits[code]; n++) {
            _dist_code[dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: dist != 256");
        dist >>= 7; /* from now on, all distances are divided by 128 */
        for (; code < D_CODES; code++) {
          base_dist[code] = dist << 7;
          for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
            _dist_code[256 + dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: 256+dist != 512");

        /* Construct the codes of the static literal tree */
        for (bits = 0; bits <= MAX_BITS; bits++) {
          bl_count[bits] = 0;
        }
        n = 0;
        while (n <= 143) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        while (n <= 255) {
          static_ltree[n * 2 + 1] /*.Len*/ = 9;
          n++;
          bl_count[9]++;
        }
        while (n <= 279) {
          static_ltree[n * 2 + 1] /*.Len*/ = 7;
          n++;
          bl_count[7]++;
        }
        while (n <= 287) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        /* Codes 286 and 287 do not exist, but we must include them in the
         * tree construction to get a canonical Huffman tree (longest code
         * all ones)
         */
        gen_codes(static_ltree, L_CODES + 1, bl_count);

        /* The static distance tree is trivial: */
        for (n = 0; n < D_CODES; n++) {
          static_dtree[n * 2 + 1] /*.Len*/ = 5;
          static_dtree[n * 2] /*.Code*/ = bi_reverse(n, 5);
        }

        // Now data ready and we can init static trees
        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
        static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
        static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);

        //static_init_done = true;
      }

      /* ===========================================================================
       * Initialize a new block.
       */
      function init_block(s) {
        var n; /* iterates over tree elements */

        /* Initialize the trees. */
        for (n = 0; n < L_CODES; n++) {
          s.dyn_ltree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < D_CODES; n++) {
          s.dyn_dtree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < BL_CODES; n++) {
          s.bl_tree[n * 2] /*.Freq*/ = 0;
        }
        s.dyn_ltree[END_BLOCK * 2] /*.Freq*/ = 1;
        s.opt_len = s.static_len = 0;
        s.last_lit = s.matches = 0;
      }

      /* ===========================================================================
       * Flush the bit buffer and align the output on a byte boundary
       */
      function bi_windup(s) {
        if (s.bi_valid > 8) {
          put_short(s, s.bi_buf);
        } else if (s.bi_valid > 0) {
          //put_byte(s, (Byte)s->bi_buf);
          s.pending_buf[s.pending++] = s.bi_buf;
        }
        s.bi_buf = 0;
        s.bi_valid = 0;
      }

      /* ===========================================================================
       * Copy a stored block, storing first the length and its
       * one's complement if requested.
       */
      function copy_block(s, buf, len, header)
      //DeflateState *s;
      //charf    *buf;    /* the input data */
      //unsigned len;     /* its length */
      //int      header;  /* true if block header must be written */
      {
        bi_windup(s); /* align on byte boundary */

        if (header) {
          put_short(s, len);
          put_short(s, ~len);
        }
        //  while (len--) {
        //    put_byte(s, *buf++);
        //  }
        utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
        s.pending += len;
      }

      /* ===========================================================================
       * Compares to subtrees, using the tree depth as tie breaker when
       * the subtrees have equal frequency. This minimizes the worst case length.
       */
      function smaller(tree, n, m, depth) {
        var _n2 = n * 2;
        var _m2 = m * 2;
        return tree[_n2] /*.Freq*/ < tree[_m2] /*.Freq*/ || tree[_n2] /*.Freq*/ === tree[_m2] /*.Freq*/ && depth[n] <= depth[m];
      }

      /* ===========================================================================
       * Restore the heap property by moving down the tree starting at node k,
       * exchanging a node with the smallest of its two sons if necessary, stopping
       * when the heap property is re-established (each father smaller than its
       * two sons).
       */
      function pqdownheap(s, tree, k)
      //    deflate_state *s;
      //    ct_data *tree;  /* the tree to restore */
      //    int k;               /* node to move down */
      {
        var v = s.heap[k];
        var j = k << 1; /* left son of k */
        while (j <= s.heap_len) {
          /* Set j to the smallest of the two sons: */
          if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
            j++;
          }
          /* Exit if v is smaller than both sons */
          if (smaller(tree, v, s.heap[j], s.depth)) {
            break;
          }

          /* Exchange v with the smallest son */
          s.heap[k] = s.heap[j];
          k = j;

          /* And continue down the tree, setting j to the left son of k */
          j <<= 1;
        }
        s.heap[k] = v;
      }

      // inlined manually
      // var SMALLEST = 1;

      /* ===========================================================================
       * Send the block data compressed using the given Huffman trees
       */
      function compress_block(s, ltree, dtree)
      //    deflate_state *s;
      //    const ct_data *ltree; /* literal tree */
      //    const ct_data *dtree; /* distance tree */
      {
        var dist; /* distance of matched string */
        var lc; /* match length or unmatched char (if dist == 0) */
        var lx = 0; /* running index in l_buf */
        var code; /* the code to send */
        var extra; /* number of extra bits to send */

        if (s.last_lit !== 0) {
          do {
            dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
            lc = s.pending_buf[s.l_buf + lx];
            lx++;
            if (dist === 0) {
              send_code(s, lc, ltree); /* send a literal byte */
              //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
            } else {
              /* Here, lc is the match length - MIN_MATCH */
              code = _length_code[lc];
              send_code(s, code + LITERALS + 1, ltree); /* send the length code */
              extra = extra_lbits[code];
              if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */
              }

              dist--; /* dist is now the match distance - 1 */
              code = d_code(dist);
              //Assert (code < D_CODES, "bad d_code");

              send_code(s, code, dtree); /* send the distance code */
              extra = extra_dbits[code];
              if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */
              }
            } /* literal or match pair ? */

            /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
            //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
            //       "pendingBuf overflow");
          } while (lx < s.last_lit);
        }
        send_code(s, END_BLOCK, ltree);
      }

      /* ===========================================================================
       * Construct one Huffman tree and assigns the code bit strings and lengths.
       * Update the total bit length for the current block.
       * IN assertion: the field freq is set for all tree elements.
       * OUT assertions: the fields len and code are set to the optimal bit length
       *     and corresponding code. The length opt_len is updated; static_len is
       *     also updated if stree is not null. The field max_code is set.
       */
      function build_tree(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc; /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var elems = desc.stat_desc.elems;
        var n, m; /* iterate over heap elements */
        var max_code = -1; /* largest code with non zero frequency */
        var node; /* new node being created */

        /* Construct the initial heap, with least frequent element in
         * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
         * heap[0] is not used.
         */
        s.heap_len = 0;
        s.heap_max = HEAP_SIZE;
        for (n = 0; n < elems; n++) {
          if (tree[n * 2] /*.Freq*/ !== 0) {
            s.heap[++s.heap_len] = max_code = n;
            s.depth[n] = 0;
          } else {
            tree[n * 2 + 1] /*.Len*/ = 0;
          }
        }

        /* The pkzip format requires that at least one distance code exists,
         * and that at least one bit should be sent even if there is only one
         * possible code. So to avoid special checks later on we force at least
         * two codes of non zero frequency.
         */
        while (s.heap_len < 2) {
          node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
          tree[node * 2] /*.Freq*/ = 1;
          s.depth[node] = 0;
          s.opt_len--;
          if (has_stree) {
            s.static_len -= stree[node * 2 + 1] /*.Len*/;
          }
          /* node is 0 or 1 so it does not have extra bits */
        }

        desc.max_code = max_code;

        /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
         * establish sub-heaps of increasing lengths:
         */
        for (n = s.heap_len >> 1 /*int /2*/; n >= 1; n--) {
          pqdownheap(s, tree, n);
        }

        /* Construct the Huffman tree by repeatedly combining the least two
         * frequent nodes.
         */
        node = elems; /* next internal node of the tree */
        do {
          //pqremove(s, tree, n);  /* n = node of least frequency */
          /*** pqremove ***/
          n = s.heap[1 /*SMALLEST*/];
          s.heap[1 /*SMALLEST*/] = s.heap[s.heap_len--];
          pqdownheap(s, tree, 1 /*SMALLEST*/);
          /***/

          m = s.heap[1 /*SMALLEST*/]; /* m = node of next least frequency */

          s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
          s.heap[--s.heap_max] = m;

          /* Create a new node father of n and m */
          tree[node * 2] /*.Freq*/ = tree[n * 2] /*.Freq*/ + tree[m * 2] /*.Freq*/;
          s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
          tree[n * 2 + 1] /*.Dad*/ = tree[m * 2 + 1] /*.Dad*/ = node;

          /* and insert the new node in the heap */
          s.heap[1 /*SMALLEST*/] = node++;
          pqdownheap(s, tree, 1 /*SMALLEST*/);
        } while (s.heap_len >= 2);
        s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/];

        /* At this point, the fields freq and dad are set. We can now
         * generate the bit lengths.
         */
        gen_bitlen(s, desc);

        /* The field len is now set, we can generate the bit codes */
        gen_codes(tree, max_code, s.bl_count);
      }

      /* ===========================================================================
       * Scan a literal or distance tree to determine the frequencies of the codes
       * in the bit length tree.
       */
      function scan_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree;   /* the tree to be scanned */
      //    int max_code;    /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] /*.Len*/ = 0xffff; /* guard */

        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            s.bl_tree[curlen * 2] /*.Freq*/ += count;
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              s.bl_tree[curlen * 2] /*.Freq*/++;
            }
            s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
          } else if (count <= 10) {
            s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
          } else {
            s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
          }

          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Send a literal or distance tree in compressed form, using the codes in
       * bl_tree.
       */
      function send_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree; /* the tree to be scanned */
      //    int max_code;       /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        /* tree[max_code+1].Len = -1; */ /* guard already set */
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;

          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            do {
              send_code(s, curlen, s.bl_tree);
            } while (--count !== 0);
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              send_code(s, curlen, s.bl_tree);
              count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
          } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
          } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Construct the Huffman tree for the bit lengths and return the index in
       * bl_order of the last bit length code to send.
       */
      function build_bl_tree(s) {
        var max_blindex; /* index of last bit length code of non zero freq */

        /* Determine the bit length frequencies for literal and distance trees */
        scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
        scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

        /* Build the bit length tree: */
        build_tree(s, s.bl_desc);
        /* opt_len now includes the length of the tree representations, except
         * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
         */

        /* Determine the number of bit length codes to send. The pkzip format
         * requires that at least 4 bit length codes be sent. (appnote.txt says
         * 3 but the actual value used is 4.)
         */
        for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
          if (s.bl_tree[bl_order[max_blindex] * 2 + 1] /*.Len*/ !== 0) {
            break;
          }
        }
        /* Update opt_len to include the bit length tree and counts */
        s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
        //        s->opt_len, s->static_len));

        return max_blindex;
      }

      /* ===========================================================================
       * Send the header for a block using dynamic Huffman trees: the counts, the
       * lengths of the bit length codes, the literal tree and the distance tree.
       * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
       */
      function send_all_trees(s, lcodes, dcodes, blcodes)
      //    deflate_state *s;
      //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
      {
        var rank; /* index in bl_order */

        //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
        //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
        //        "too many codes");
        //Tracev((stderr, "\nbl counts: "));
        send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
        send_bits(s, dcodes - 1, 5);
        send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
        for (rank = 0; rank < blcodes; rank++) {
          //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
          send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1] /*.Len*/, 3);
        }
        //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
        //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
        //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
      }

      /* ===========================================================================
       * Check if the data type is TEXT or BINARY, using the following algorithm:
       * - TEXT if the two conditions below are satisfied:
       *    a) There are no non-portable control characters belonging to the
       *       "black list" (0..6, 14..25, 28..31).
       *    b) There is at least one printable character belonging to the
       *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
       * - BINARY otherwise.
       * - The following partially-portable control characters form a
       *   "gray list" that is ignored in this detection algorithm:
       *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
       * IN assertion: the fields Freq of dyn_ltree are set.
       */
      function detect_data_type(s) {
        /* black_mask is the bit mask of black-listed bytes
         * set bits 0..6, 14..25, and 28..31
         * 0xf3ffc07f = binary 11110011111111111100000001111111
         */
        var black_mask = 0xf3ffc07f;
        var n;

        /* Check for non-textual ("black-listed") bytes. */
        for (n = 0; n <= 31; n++, black_mask >>>= 1) {
          if (black_mask & 1 && s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_BINARY;
          }
        }

        /* Check for textual ("white-listed") bytes. */
        if (s.dyn_ltree[9 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[10 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[13 * 2] /*.Freq*/ !== 0) {
          return Z_TEXT;
        }
        for (n = 32; n < LITERALS; n++) {
          if (s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_TEXT;
          }
        }

        /* There are no "black-listed" or "white-listed" bytes:
         * this stream either is empty or has tolerated ("gray-listed") bytes only.
         */
        return Z_BINARY;
      }
      var static_init_done = false;

      /* ===========================================================================
       * Initialize the tree data structures for a new zlib stream.
       */
      function _tr_init(s) {
        if (!static_init_done) {
          tr_static_init();
          static_init_done = true;
        }
        s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
        s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
        s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
        s.bi_buf = 0;
        s.bi_valid = 0;

        /* Initialize the first block of the first file: */
        init_block(s);
      }

      /* ===========================================================================
       * Send a stored block
       */
      function _tr_stored_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */
        copy_block(s, buf, stored_len, true); /* with header */
      }

      /* ===========================================================================
       * Send one empty static block to give enough lookahead for inflate.
       * This takes 10 bits, of which 7 may remain in the bit buffer.
       */
      function _tr_align(s) {
        send_bits(s, STATIC_TREES << 1, 3);
        send_code(s, END_BLOCK, static_ltree);
        bi_flush(s);
      }

      /* ===========================================================================
       * Determine the best encoding for the current block: dynamic trees, static
       * trees or store, and output the encoded block to the zip file.
       */
      function _tr_flush_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block, or NULL if too old */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        var opt_lenb, static_lenb; /* opt_len and static_len in bytes */
        var max_blindex = 0; /* index of last bit length code of non zero freq */

        /* Build the Huffman trees unless a stored block is forced */
        if (s.level > 0) {
          /* Check if the file is binary or text */
          if (s.strm.data_type === Z_UNKNOWN) {
            s.strm.data_type = detect_data_type(s);
          }

          /* Construct the literal and distance trees */
          build_tree(s, s.l_desc);
          // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));

          build_tree(s, s.d_desc);
          // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));
          /* At this point, opt_len and static_len are the total bit lengths of
           * the compressed block data, excluding the tree representations.
           */

          /* Build the bit length tree for the above two trees, and get the index
           * in bl_order of the last bit length code to send.
           */
          max_blindex = build_bl_tree(s);

          /* Determine the best encoding. Compute the block lengths in bytes. */
          opt_lenb = s.opt_len + 3 + 7 >>> 3;
          static_lenb = s.static_len + 3 + 7 >>> 3;

          // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
          //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
          //        s->last_lit));

          if (static_lenb <= opt_lenb) {
            opt_lenb = static_lenb;
          }
        } else {
          // Assert(buf != (char*)0, "lost buf");
          opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
        }

        if (stored_len + 4 <= opt_lenb && buf !== -1) {
          /* 4: two words for the lengths */

          /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
           * Otherwise we can't have processed more than WSIZE input bytes since
           * the last block flush, because compression would have been
           * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
           * transform a block into a stored block.
           */
          _tr_stored_block(s, buf, stored_len, last);
        } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
          send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
          compress_block(s, static_ltree, static_dtree);
        } else {
          send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
          send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
          compress_block(s, s.dyn_ltree, s.dyn_dtree);
        }
        // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
        /* The above check is made mod 2^32, for files larger than 512 MB
         * and uLong implemented on 32 bits.
         */
        init_block(s);
        if (last) {
          bi_windup(s);
        }
        // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
        //       s->compressed_len-7*last));
      }

      /* ===========================================================================
       * Save the match info and tally the frequency counts. Return true if
       * the current block must be flushed.
       */
      function _tr_tally(s, dist, lc)
      //    deflate_state *s;
      //    unsigned dist;  /* distance of matched string */
      //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
      {
        //var out_length, in_length, dcode;

        s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
        s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
        s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
        s.last_lit++;
        if (dist === 0) {
          /* lc is the unmatched char */
          s.dyn_ltree[lc * 2] /*.Freq*/++;
        } else {
          s.matches++;
          /* Here, lc is the match length - MIN_MATCH */
          dist--; /* dist = match distance - 1 */
          //Assert((ush)dist < (ush)MAX_DIST(s) &&
          //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
          //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

          s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
          s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
        }

        // (!) This block is disabled in zlib defailts,
        // don't enable it for binary compatibility

        //#ifdef TRUNCATE_BLOCK
        //  /* Try to guess if it is profitable to stop the current block here */
        //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
        //    /* Compute an upper bound for the compressed length */
        //    out_length = s.last_lit*8;
        //    in_length = s.strstart - s.block_start;
        //
        //    for (dcode = 0; dcode < D_CODES; dcode++) {
        //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
        //    }
        //    out_length >>>= 3;
        //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
        //    //       s->last_lit, in_length, out_length,
        //    //       100L - out_length*100L/in_length));
        //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
        //      return true;
        //    }
        //  }
        //#endif

        return s.last_lit === s.lit_bufsize - 1;
        /* We avoid equality with lit_bufsize because of wraparound at 64K
         * on 16 bit machines and because stored blocks are restricted to
         * 64K-1 bytes.
         */
      }

      exports._tr_init = _tr_init;
      exports._tr_stored_block = _tr_stored_block;
      exports._tr_flush_block = _tr_flush_block;
      exports._tr_tally = _tr_tally;
      exports._tr_align = _tr_align;
    }, {
      "../utils/common": 28
    }],
    40: [function (require, module, exports) {
      'use strict';

      function ZStream() {
        /* next input byte */
        this.input = null; // JS specific, because we have no pointers
        this.next_in = 0;
        /* number of bytes available at input */
        this.avail_in = 0;
        /* total number of input bytes read so far */
        this.total_in = 0;
        /* next output byte should be put there */
        this.output = null; // JS specific, because we have no pointers
        this.next_out = 0;
        /* remaining free space at output */
        this.avail_out = 0;
        /* total number of bytes output so far */
        this.total_out = 0;
        /* last error message, NULL if no error */
        this.msg = '' /*Z_NULL*/;
        /* not visible by applications */
        this.state = null;
        /* best guess about the data type: binary or text */
        this.data_type = 2 /*Z_UNKNOWN*/;
        /* adler32 value of the uncompressed data */
        this.adler = 0;
      }
      module.exports = ZStream;
    }, {}]
  }, {}, [10])(10);
});
/**
 * @license
 * lodash <https://lodash.com/>
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.15.0';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Used as the `TypeError` message for "Functions" methods. */var FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for function metadata. */var BIND_FLAG=1,BIND_KEY_FLAG=2,CURRY_BOUND_FLAG=4,CURRY_FLAG=8,CURRY_RIGHT_FLAG=16,PARTIAL_FLAG=32,PARTIAL_RIGHT_FLAG=64,ARY_FLAG=128,REARG_FLAG=256,FLIP_FLAG=512;/** Used to compose bitmasks for comparison styles. */var UNORDERED_COMPARE_FLAG=1,PARTIAL_COMPARE_FLAG=2;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=150,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',ARY_FLAG],['bind',BIND_FLAG],['bindKey',BIND_KEY_FLAG],['curry',CURRY_FLAG],['curryRight',CURRY_RIGHT_FLAG],['flip',FLIP_FLAG],['partial',PARTIAL_FLAG],['partialRight',PARTIAL_RIGHT_FLAG],['rearg',REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',promiseTag='[object Promise]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39|#96);/g,reUnescapedHtml=/[&<>"'`]/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,reLeadingDot=/^\./,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect hexadecimal string values. */var reHasHexPrefix=/^0x/i;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f\\ufe20-\\ufe23',rsComboSymbolsRange='\\u20d0-\\u20f0',rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboMarksRange+rsComboSymbolsRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsLowerMisc='(?:'+rsLower+'|'+rsMisc+')',rsUpperMisc='(?:'+rsUpper+'|'+rsMisc+')',rsOptLowerContr='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptUpperContr='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptLowerContr+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsUpperMisc+'+'+rsOptUpperContr+'(?='+[rsBreak,rsUpper+rsLowerMisc,'$'].join('|')+')',rsUpper+'?'+rsLowerMisc+'+'+rsOptLowerContr,rsUpper+'+'+rsOptUpperContr,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboMarksRange+rsComboSymbolsRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C','\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c','\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e','\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G','\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I','\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L','\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n','\u014c':'O','\u014e':'O','\u0150':'O','\u014d':'o','\u014f':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S','\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017b':'Z','\u017d':'Z','\u017a':'z','\u017c':'z','\u017e':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017f':'ss'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','`':'&#96;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'",'&#96;':'`'};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=typeof global=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=typeof exports=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&typeof module=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */function addMapEntry(map,pair){// Don't return `map.set` because it's not chainable in IE 11.
map.set(pair[0],pair[1]);return map;}/**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */function addSetEntry(set,value){// Don't return `set.add` because it's not chainable in IE 11.
set.add(value);return set;}/**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array?array.length:0;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array?array.length:0;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array?array.length:0;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array?array.length:0;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array?array.length:0,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array?array.length:0;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array?array.length:0;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array?array.length:0,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array?array.length:0;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array?array.length:0;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array?array.length:0;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){if(value!==value){return baseFindIndex(array,baseIsNaN,fromIndex);}var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array?array.length:0;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a cache value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){result++;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */function isHostObject(value){// Many host objects are `Object` objects that can coerce to strings
// despite having improperly defined `toString` methods.
var result=false;if(value!=null&&typeof value.toString!='function'){try{result=!!(value+'');}catch(e){}}return result;}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){result++;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Use `context` to stub `Date#getTime` use in `_.now`.
   * var stubbed = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': stubGetTime };
   *   }
   * });
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */function runInContext(context){context=context?_.defaults(root.Object(),context,_.pick(root,contextProps)):root;/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var objectToString=objectProto.toString;/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,Symbol=context.Symbol,Uint8Array=context.Uint8Array,getPrototype=overArg(Object.getPrototypeOf,Object),iteratorSymbol=Symbol?Symbol.iterator:undefined,objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined;/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/* Used to set `toString` methods. */var defineProperty=function(){var func=getNative(Object,'defineProperty'),name=getNative.name;return name&&name.length>2?func:undefined;}();/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */var nonEnumShadows=!propertyIsEnumerable.call({'valueOf':1},'valueOf');/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=Symbol?Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array of at least `200` elements
     * and any iteratees accept only one argument. The heuristic for whether a
     * section qualifies for shortcut fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||arrLength<LARGE_ARRAY_SIZE||arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){return this.has(key)&&delete this.__data__[key];}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries?entries.length:0;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){return getMapData(this,key)['delete'](key);}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){getMapData(this,key).set(key,value);return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values?values.length:0;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){this.__data__=new ListCache(entries);}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){return this.__data__['delete'](key);}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var cache=this.__data__;if(cache instanceof ListCache){var pairs=cache.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);return this;}cache=this.__data__=new MapCache(pairs);}cache.set(key,value);return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){// Safari 8.1 makes `arguments.callee` enumerable in strict mode.
// Safari 9 makes `arguments.length` enumerable in strict mode.
var result=isArray(value)||isArguments(value)?baseTimes(value.length,String):[];var length=result.length,skipIndexes=!!length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(key=='length'||isIndex(key,length)))){result.push(key);}}return result;}/**
     * Used by `_.defaults` to customize its `_.assignIn` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function assignInDefaults(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||typeof key=='number'&&value===undefined&&!(key in object)){object[key]=value;}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){object[key]=value;}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths of elements to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,isNil=object==null,length=paths.length,result=Array(length);while(++index<length){result[index]=isNil?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {boolean} [isFull] Specify a clone including symbols.
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,isDeep,isFull,customizer,key,object,stack){var result;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){if(isHostObject(value)){return object?value:{};}result=initCloneObject(isFunc?{}:value);if(!isDeep){return copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,baseClone,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(!isArr){var props=isFull?getAllKeys(value):keys(value);}arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,isDeep,isFull,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */function baseCreate(proto){return isObject(proto)?objectCreate(proto):{};}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=isKey(path,object)?[path]:castPath(path);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){return objectToString.call(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){if(!isKey(path,object)){path=castPath(path);object=parent(object,path);path=last(path);}var func=object==null?object:object[toKey(path)];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&objectToString.call(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&objectToString.call(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {boolean} [bitmask] The bitmask of comparison flags.
     *  The bitmask may be composed of the following flags:
     *     1 - Unordered comparison
     *     2 - Partial comparison
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,customizer,bitmask,stack){if(value===other){return true;}if(value==null||other==null||!isObject(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,baseIsEqual,customizer,bitmask,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,equalFunc,customizer,bitmask,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=arrayTag,othTag=arrayTag;if(!objIsArr){objTag=getTag(object);objTag=objTag==argsTag?objectTag:objTag;}if(!othIsArr){othTag=getTag(other);othTag=othTag==argsTag?objectTag:othTag;}var objIsObj=objTag==objectTag&&!isHostObject(object),othIsObj=othTag==objectTag&&!isHostObject(other),isSameTag=objTag==othTag;if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,equalFunc,customizer,bitmask,stack):equalByTag(object,other,objTag,equalFunc,customizer,bitmask,stack);}if(!(bitmask&PARTIAL_COMPARE_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,customizer,bitmask,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,equalFunc,customizer,bitmask,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,customizer,UNORDERED_COMPARE_FLAG|PARTIAL_COMPARE_FLAG,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)||isHostObject(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObject(value)&&objectToString.call(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[objectToString.call(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(typeof value=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,undefined,UNORDERED_COMPARE_FLAG|PARTIAL_COMPARE_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}if(!(isArray(source)||isTypedArray(source))){var props=baseKeysIn(source);}arrayEach(props||source,function(srcValue,key){if(props){key=srcValue;srcValue=source[key];}if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(object[key],srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}});}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=object[key],srcValue=source[key],stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){newValue=srcValue;if(isArray(srcValue)||isTypedArray(srcValue)){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else{isCommon=false;newValue=baseClone(srcValue,true);}}else if(isPlainObject(srcValue)||isArguments(srcValue)){if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){isCommon=false;newValue=baseClone(srcValue,true);}else{newValue=objValue;}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,props){object=Object(object);return basePickBy(object,props,function(value,key){return key in object;});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property identifiers to pick from.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,props,predicate){var index=-1,length=props.length,result={};while(++index<length){var key=props[index],value=object[key];if(predicate(value,key)){result[key]=value;}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else if(!isKey(index,array)){var path=castPath(index),object=parent(array,path);if(object!=null){delete object[toKey(last(path))];}}else{delete array[toKey(index)];}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=array;return apply(func,this,otherArgs);};}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=isKey(path,object)?[path]:castPath(path);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array?array.length:low;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array?array.length:0,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=isKey(path,object)?[path]:castPath(path);object=parent(object,path);var key=toKey(last(path));return!(object!=null&&hasOwnProperty.call(object,key))||delete object[key];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var index=-1,length=arrays.length;while(++index<length){var result=result?arrayPush(baseDifference(result,arrays[index],iteratee,comparator),baseDifference(arrays[index],result,iteratee,comparator)):arrays[index];}return result&&result.length?baseUniq(result,iteratee,comparator):[];}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value){return isArray(value)?value:stringToPath(value);}/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var result=new buffer.constructor(buffer.length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */function cloneMap(map,isDeep,cloneFunc){var array=isDeep?cloneFunc(mapToArray(map),true):mapToArray(map);return arrayReduce(array,addMapEntry,new map.constructor());}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */function cloneSet(set,isDeep,cloneFunc){var array=isDeep?cloneFunc(setToArray(set),true):setToArray(set);return arrayReduce(array,addSetEntry,new set.constructor());}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;assignValue(object,key,newValue===undefined?source[key]:newValue);}return object;}/**
     * Copies own symbol properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return baseRest(function(funcs){funcs=baseFlatten(funcs,1);var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(ARY_FLAG|CURRY_FLAG|PARTIAL_FLAG|REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)&&value.length>=LARGE_ARRAY_SIZE){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&ARY_FLAG,isBind=bitmask&BIND_FLAG,isBindKey=bitmask&BIND_KEY_FLAG,isCurried=bitmask&(CURRY_FLAG|CURRY_RIGHT_FLAG),isFlip=bitmask&FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return baseRest(function(iteratees){iteratees=iteratees.length==1&&isArray(iteratees[0])?arrayMap(iteratees[0],baseUnary(getIteratee())):arrayMap(baseFlatten(iteratees,1),baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?PARTIAL_FLAG:PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?PARTIAL_RIGHT_FLAG:PARTIAL_FLAG);if(!(bitmask&CURRY_BOUND_FLAG)){bitmask&=~(BIND_FLAG|BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     *   512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(PARTIAL_FLAG|PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]==null?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(CURRY_FLAG|CURRY_RIGHT_FLAG)){bitmask&=~(CURRY_FLAG|CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==CURRY_FLAG||bitmask==CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==PARTIAL_FLAG||bitmask==(BIND_FLAG|PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,equalFunc,customizer,bitmask,stack){var isPartial=bitmask&PARTIAL_COMPARE_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&UNORDERED_COMPARE_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!seen.has(othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,customizer,bitmask,stack))){return seen.add(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,customizer,bitmask,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,equalFunc,customizer,bitmask,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&PARTIAL_COMPARE_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=UNORDERED_COMPARE_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),equalFunc,customizer,bitmask,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} customizer The function to customize comparisons.
     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
     *  for more details.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,equalFunc,customizer,bitmask,stack){var isPartial=bitmask&PARTIAL_COMPARE_FLAG,objProps=keys(object),objLength=objProps.length,othProps=keys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,customizer,bitmask,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * Creates an array of the own enumerable symbol properties of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=nativeGetSymbols?overArg(nativeGetSymbols,Object):stubArray;/**
     * Creates an array of the own and inherited enumerable symbol properties
     * of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function(value){var result=objectToString.call(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):undefined;if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=isKey(path,object)?[path]:castPath(path);var result,index=-1,length=path.length;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result){return result;}var length=object?object.length:0;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,cloneFunc,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return cloneMap(object,isDeep,cloneFunc);case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return cloneSet(object,isDeep,cloneFunc);case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length,lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(typeof value=='number'||reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index;if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value;if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=typeof value;return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(BIND_FLAG|BIND_KEY_FLAG|ARY_FLAG);var isCombo=srcBitmask==ARY_FLAG&&bitmask==CURRY_FLAG||srcBitmask==ARY_FLAG&&bitmask==REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(ARY_FLAG|REARG_FLAG)&&source[7].length<=source[8]&&bitmask==CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&BIND_FLAG?0:CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function mergeDefaults(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,mergeDefaults,stack);stack['delete'](srcValue);}return objValue;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length==1?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=function(){var count=0,lastCalled=0;return function(key,value){var stamp=now(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return key;}}else{count=0;}return baseSetData(key,value);};}();/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */var setWrapToString=!defineProperty?identity:function(wrapper,reference,bitmask){var source=reference+'';return defineProperty(wrapper,'toString',{'configurable':true,'enumerable':false,'value':constant(insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)))});};/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoize(function(string){string=toString(string);var result=[];if(reLeadingDot.test(string)){result.push('');}string.replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to process.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array?array.length:0;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array?array.length:0,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length,args=Array(length?length-1:0),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return length?arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1)):[];}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order of result values is determined by the
     * order they occur in the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. Result values are chosen from the first array.
     * The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. Result values
     * are chosen from the first array. The comparator is invoked with two arguments:
     * (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array?array.length:0;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array?array.length:0;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array?array.length:0;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array?array.length:0;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs?pairs.length:0,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array?array.length:0;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order of result values is determined by the
     * order they occur in the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. Result values are chosen from the first array.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. Result values are chosen
     * from the first array. The comparator is invoked with two arguments:
     * (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(comparator===last(mapped)){comparator=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array?nativeJoin.call(array,separator):'';}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array?array.length:0;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array?array.length:0;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=(index<0?nativeMax(length+index,0):nativeMin(index,length-1))+1;}if(value!==value){return baseFindIndex(array,baseIsNaN,index-1,true);}while(index--){if(array[index]===value){return index;}}return-1;}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=baseRest(function(array,indexes){indexes=baseFlatten(indexes,1);var length=array?array.length:0,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array?nativeReverse.call(array):array;}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array?array.length:0;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array?array.length:0;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array?array.length:0;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array?array.length:0;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array?array.length:0;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);if(isArrayLikeObject(comparator)){comparator=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each
     * element is kept.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);if(isArrayLikeObject(comparator)){comparator=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths of elements to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=baseRest(function(paths){paths=baseFlatten(paths,1);var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){hasOwnProperty.call(result,key)?++result[key]:result[key]=1;});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity]
     *  The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _([1, 2]).forEach(function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{result[key]=[value];}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',isProp=isKey(path),result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){var func=isFunc?path:isProp&&value!=null?value[path]:undefined;result[++index]=func?apply(func,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity]
     *  The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){result[key]=value;});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var array=isArrayLike(collection)?collection:values(collection),length=array.length;return length>0?array[baseRandom(0,length-1)]:undefined;}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){var index=-1,result=toArray(collection),length=result.length,lastIndex=length-1;if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=baseClamp(toInteger(n),0,length);}while(++index<n){var rand=baseRandom(index,lastIndex),value=result[rand];result[rand]=result[index];result[index]=value;}result.length=n;return result;}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){return sampleSize(collection,MAX_ARRAY_LENGTH);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, function(o) { return o.user; });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     *
     * _.sortBy(users, 'user', function(o) {
     *   return Math.floor(o.age / 10);
     * });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=BIND_FLAG|BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,result=wait-timeSinceLastCall;return maxing?nativeMin(result,maxWait-timeSinceLastInvoke):result;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one or more milliseconds.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result);return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Assign cache to `_.memoize`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=baseRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=baseRest(function(func,indexes){return createWrap(func,REARG_FLAG,undefined,undefined,undefined,baseFlatten(indexes,1));});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){wrapper=wrapper==null?identity:wrapper;return partial(wrapper,value);}/*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,false,true);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){return baseClone(value,false,true,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,true,true);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){return baseClone(value,true,true,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */function isArguments(value){// Safari 8.1 makes `arguments.callee` enumerable in strict mode.
return isArrayLikeObject(value)&&hasOwnProperty.call(value,'callee')&&(!propertyIsEnumerable.call(value,'callee')||objectToString.call(value)==argsTag);}/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&objectToString.call(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return!!value&&value.nodeType===1&&isObjectLike(value)&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(nonEnumShadows||isPrototype(value)){return!nativeKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are **not** supported.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}return objectToString.call(value)==errorTag||typeof value.message=='string'&&typeof value.name=='string';}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 8-9 which returns 'object' for typed array and other constructors.
var tag=isObject(value)?objectToString.call(value):'';return tag==funcTag||tag==genTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=typeof value;return!!value&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return!!value&&typeof value=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error('This method is not supported with core-js. Try https://github.com/es-shims.');}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&objectToString.call(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||objectToString.call(value)!=objectTag||isHostObject(value)){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&objectToString.call(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return typeof value=='symbol'||isObjectLike(value)&&objectToString.call(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&objectToString.call(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(iteratorSymbol&&value[iteratorSymbol]){return iteratorToArray(value[iteratorSymbol]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER);}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(nonEnumShadows||isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths of elements to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=baseRest(function(object,paths){return baseAt(object,baseFlatten(paths,1));});/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties?baseAssign(result,properties):result;}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(args){args.push(undefined,assignInDefaults);return apply(assignInWith,undefined,args);});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,mergeDefaults);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){result[iteratee(value,key,object)]=value;});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){result[key]=iteratee(value,key,object);});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with seven arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable string keyed properties of `object` that are
     * not omitted.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=baseRest(function(object,props){if(object==null){return{};}props=arrayMap(baseFlatten(props,1),toKey);return basePick(object,baseDifference(getAllKeysIn(object),props));});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property identifiers to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=baseRest(function(object,props){return object==null?{}:basePick(object,arrayMap(baseFlatten(props,1),toKey));});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){return object==null?{}:basePickBy(object,getAllKeysIn(object),getIteratee(predicate));}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=isKey(path,object)?[path]:castPath(path);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){object=undefined;length=1;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){if(isArr||isObject(object)){var Ctor=object.constructor;if(isArr){accumulator=isArray(object)?new Ctor():[];}else{accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}}else{accumulator={};}}(isArr?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object?baseValues(object,keys(object)):[];}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in IE < 9, they can break out of
     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the
     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){// Chrome fails to trim leading <BOM> whitespace characters.
// See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}string=toString(string).replace(reTrim,'');return nativeParseInt(string,radix||(reHasHexPrefix.test(string)?16:10));}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,assignInDefaults);var imports=assignInWith({},options.imports,settings.imports,assignInDefaults),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=baseRest(function(object,methodNames){arrayEach(baseFlatten(methodNames,1),function(key){key=toKey(key);object[key]=bind(object[key],object);});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs?pairs.length:0,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,true));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,true));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,true));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,true));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(value));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){var filtered=this.__filtered__;if(filtered&&!index){return new LazyWrapper(this);}n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.clone();if(filtered){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(iteratorSymbol){lodash.prototype[iteratorSymbol]=wrapperToIterator;}return lodash;}/*--------------------------------------------------------------------------*/ // Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if(typeof define=='function'&&typeof define.amd=='object'&&define.amd){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
define(function(){return _;});}// Check for `exports` after `define` in case a build optimizer adds it.
else if(freeModule){// Export for Node.js.
(freeModule.exports=_)._=_;// Export for CommonJS support.
freeExports._=_;}else{// Export to the global object.
root._=_;}}).call(this);
/* ng-infinite-scroll - v1.3.0 - 2016-11-04 */
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['module', 'exports', 'angular'], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('angular'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.angular);
    global.infiniteScroll = mod.exports;
  }
})(this, function (module, exports, _angular) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _angular2 = _interopRequireDefault(_angular);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var MODULE_NAME = 'infinite-scroll';
  _angular2['default'].module(MODULE_NAME, []).value('THROTTLE_MILLISECONDS', null).directive('infiniteScroll', ['$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function ($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
    return {
      scope: {
        infiniteScroll: '&',
        infiniteScrollContainer: '=',
        infiniteScrollDistance: '=',
        infiniteScrollDisabled: '=',
        infiniteScrollUseDocumentBottom: '=',
        infiniteScrollListenForEvent: '@'
      },
      link: function link(scope, elem, attrs) {
        var windowElement = _angular2['default'].element($window);
        var scrollDistance = null;
        var scrollEnabled = null;
        var checkWhenEnabled = null;
        var container = null;
        var immediateCheck = true;
        var useDocumentBottom = false;
        var unregisterEventListener = null;
        var checkInterval = false;
        function height(element) {
          var el = element[0] || element;
          if (isNaN(el.offsetHeight)) {
            return el.document.documentElement.clientHeight;
          }
          return el.offsetHeight;
        }
        function pageYOffset(element) {
          var el = element[0] || element;
          if (isNaN(window.pageYOffset)) {
            return el.document.documentElement.scrollTop;
          }
          return el.ownerDocument.defaultView.pageYOffset;
        }
        function offsetTop(element) {
          if (!(!element[0].getBoundingClientRect || element.css('none'))) {
            return element[0].getBoundingClientRect().top + pageYOffset(element);
          }
          return undefined;
        }

        // infinite-scroll specifies a function to call when the window,
        // or some other container specified by infinite-scroll-container,
        // is scrolled within a certain range from the bottom of the
        // document. It is recommended to use infinite-scroll-disabled
        // with a boolean that is set to true when the function is
        // called in order to throttle the function call.
        function defaultHandler() {
          var containerBottom = void 0;
          var elementBottom = void 0;
          if (container === windowElement) {
            containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
            elementBottom = offsetTop(elem) + height(elem);
          } else {
            containerBottom = height(container);
            var containerTopOffset = 0;
            if (offsetTop(container) !== undefined) {
              containerTopOffset = offsetTop(container);
            }
            elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
          }
          if (useDocumentBottom) {
            elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
          }
          var remaining = elementBottom - containerBottom;
          var shouldScroll = remaining <= height(container) * scrollDistance + 1;
          if (shouldScroll) {
            checkWhenEnabled = true;
            if (scrollEnabled) {
              if (scope.$$phase || $rootScope.$$phase) {
                scope.infiniteScroll();
              } else {
                scope.$apply(scope.infiniteScroll);
              }
            }
          } else {
            if (checkInterval) {
              $interval.cancel(checkInterval);
            }
            checkWhenEnabled = false;
          }
        }

        // The optional THROTTLE_MILLISECONDS configuration value specifies
        // a minimum time that should elapse between each call to the
        // handler. N.b. the first call the handler will be run
        // immediately, and the final call will always result in the
        // handler being called after the `wait` period elapses.
        // A slimmed down version of underscore's implementation.
        function throttle(func, wait) {
          var timeout = null;
          var previous = 0;
          function later() {
            previous = new Date().getTime();
            $interval.cancel(timeout);
            timeout = null;
            return func.call();
          }
          function throttled() {
            var now = new Date().getTime();
            var remaining = wait - (now - previous);
            if (remaining <= 0) {
              $interval.cancel(timeout);
              timeout = null;
              previous = now;
              func.call();
            } else if (!timeout) {
              timeout = $interval(later, remaining, 1);
            }
          }
          return throttled;
        }
        var handler = THROTTLE_MILLISECONDS != null ? throttle(defaultHandler, THROTTLE_MILLISECONDS) : defaultHandler;
        function handleDestroy() {
          container.unbind('scroll', handler);
          if (unregisterEventListener != null) {
            unregisterEventListener();
            unregisterEventListener = null;
          }
          if (checkInterval) {
            $interval.cancel(checkInterval);
          }
        }
        scope.$on('$destroy', handleDestroy);

        // infinite-scroll-distance specifies how close to the bottom of the page
        // the window is allowed to be before we trigger a new scroll. The value
        // provided is multiplied by the container height; for example, to load
        // more when the bottom of the page is less than 3 container heights away,
        // specify a value of 3. Defaults to 0.
        function handleInfiniteScrollDistance(v) {
          scrollDistance = parseFloat(v) || 0;
        }
        scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
        // If I don't explicitly call the handler here, tests fail. Don't know why yet.
        handleInfiniteScrollDistance(scope.infiniteScrollDistance);

        // infinite-scroll-disabled specifies a boolean that will keep the
        // infnite scroll function from being called; this is useful for
        // debouncing or throttling the function call. If an infinite
        // scroll is triggered but this value evaluates to true, then
        // once it switches back to false the infinite scroll function
        // will be triggered again.
        function handleInfiniteScrollDisabled(v) {
          scrollEnabled = !v;
          if (scrollEnabled && checkWhenEnabled) {
            checkWhenEnabled = false;
            handler();
          }
        }
        scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
        // If I don't explicitly call the handler here, tests fail. Don't know why yet.
        handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);

        // use the bottom of the document instead of the element's bottom.
        // This useful when the element does not have a height due to its
        // children being absolute positioned.
        function handleInfiniteScrollUseDocumentBottom(v) {
          useDocumentBottom = v;
        }
        scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
        handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);

        // infinite-scroll-container sets the container which we want to be
        // infinte scrolled, instead of the whole window. Must be an
        // Angular or jQuery element, or, if jQuery is loaded,
        // a jQuery selector as a string.
        function changeContainer(newContainer) {
          if (container != null) {
            container.unbind('scroll', handler);
          }
          container = newContainer;
          if (newContainer != null) {
            container.bind('scroll', handler);
          }
        }
        changeContainer(windowElement);
        if (scope.infiniteScrollListenForEvent) {
          unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
        }
        function handleInfiniteScrollContainer(newContainer) {
          // TODO: For some reason newContainer is sometimes null instead
          // of the empty array, which Angular is supposed to pass when the
          // element is not defined
          // (https://github.com/sroze/ngInfiniteScroll/pull/7#commitcomment-5748431).
          // So I leave both checks.
          if (!(newContainer != null) || newContainer.length === 0) {
            return;
          }
          var newerContainer = void 0;
          if (newContainer.nodeType && newContainer.nodeType === 1) {
            newerContainer = _angular2['default'].element(newContainer);
          } else if (typeof newContainer.append === 'function') {
            newerContainer = _angular2['default'].element(newContainer[newContainer.length - 1]);
          } else if (typeof newContainer === 'string') {
            newerContainer = _angular2['default'].element(document.querySelector(newContainer));
          } else {
            newerContainer = newContainer;
          }
          if (newerContainer == null) {
            throw new Error('invalid infinite-scroll-container attribute.');
          }
          changeContainer(newerContainer);
        }
        scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
        handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);

        // infinite-scroll-parent establishes this element's parent as the
        // container infinitely scrolled instead of the whole window.
        if (attrs.infiniteScrollParent != null) {
          changeContainer(_angular2['default'].element(elem.parent()));
        }

        // infinte-scoll-immediate-check sets whether or not run the
        // expression passed on infinite-scroll for the first time when the
        // directive first loads, before any actual scroll.
        if (attrs.infiniteScrollImmediateCheck != null) {
          immediateCheck = scope.$eval(attrs.infiniteScrollImmediateCheck);
        }
        function intervalCheck() {
          if (immediateCheck) {
            handler();
          }
          return $interval.cancel(checkInterval);
        }
        checkInterval = $interval(intervalCheck);
        return checkInterval;
      }
    };
  }]);
  exports['default'] = MODULE_NAME;
  module.exports = exports['default'];
});
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
})(this, function () {
  'use strict';

  var hookCallback;
  function hooks() {
    return hookCallback.apply(null, arguments);
  }

  // This is done to register the method called with moment()
  // without creating circular dependencies.
  function setHookCallback(callback) {
    hookCallback = callback;
  }
  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }
  function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
  }
  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }
  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;
      for (k in obj) {
        if (hasOwnProp(obj, k)) {
          return false;
        }
      }
      return true;
    }
  }
  function isUndefined(input) {
    return input === void 0;
  }
  function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
  }
  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }
  function map(arr, fn) {
    var res = [],
      i,
      arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
      res.push(fn(arr[i], i));
    }
    return res;
  }
  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }
    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }
    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }
    return a;
  }
  function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }
  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidEra: null,
      invalidMonth: null,
      invalidOffset: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }
  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }
    return m._pf;
  }
  var some;
  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function (fun) {
      var t = Object(this),
        len = t.length >>> 0,
        i;
      for (i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }
      return false;
    };
  }
  function isValid$2(m) {
    var flags = null,
      parsedParts = false,
      isNowValid = m._d && !isNaN(m._d.getTime());
    if (isNowValid) {
      flags = getParsingFlags(m);
      parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      });
      isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
    return m._isValid;
  }
  function createInvalid$1(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }
    return m;
  }

  // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.
  var momentProperties = hooks.momentProperties = [],
    updateInProgress = false;
  function copyConfig(to, from) {
    var i,
      prop,
      val,
      momentPropertiesLen = momentProperties.length;
    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
      to._i = from._i;
    }
    if (!isUndefined(from._f)) {
      to._f = from._f;
    }
    if (!isUndefined(from._l)) {
      to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }
    if (momentPropertiesLen > 0) {
      for (i = 0; i < momentPropertiesLen; i++) {
        prop = momentProperties[i];
        val = from[prop];
        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }
    return to;
  }

  // Moment prototype object
  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
      this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }
  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }
  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }
  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }
      if (firstTime) {
        var args = [],
          arg,
          i,
          key,
          argLen = arguments.length;
        for (i = 0; i < argLen; i++) {
          arg = '';
          if (typeof arguments[i] === 'object') {
            arg += '\n[' + i + '] ';
            for (key in arguments[0]) {
              if (hasOwnProp(arguments[0], key)) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }
            }
            arg = arg.slice(0, -2); // Remove trailing comma and space
          } else {
            arg = arguments[i];
          }
          args.push(arg);
        }
        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
        firstTime = false;
      }
      return fn.apply(this, arguments);
    }, fn);
  }
  var deprecations = {};
  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
      warn(msg + '\n' + new Error().stack);
      deprecations[name] = true;
    }
  }
  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;
  function isFunction(input) {
    return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }
  var aliases = {
    D: 'date',
    dates: 'date',
    date: 'date',
    d: 'day',
    days: 'day',
    day: 'day',
    e: 'weekday',
    weekdays: 'weekday',
    weekday: 'weekday',
    E: 'isoWeekday',
    isoweekdays: 'isoWeekday',
    isoweekday: 'isoWeekday',
    DDD: 'dayOfYear',
    dayofyears: 'dayOfYear',
    dayofyear: 'dayOfYear',
    h: 'hour',
    hours: 'hour',
    hour: 'hour',
    ms: 'millisecond',
    milliseconds: 'millisecond',
    millisecond: 'millisecond',
    m: 'minute',
    minutes: 'minute',
    minute: 'minute',
    M: 'month',
    months: 'month',
    month: 'month',
    Q: 'quarter',
    quarters: 'quarter',
    quarter: 'quarter',
    s: 'second',
    seconds: 'second',
    second: 'second',
    gg: 'weekYear',
    weekyears: 'weekYear',
    weekyear: 'weekYear',
    GG: 'isoWeekYear',
    isoweekyears: 'isoWeekYear',
    isoweekyear: 'isoWeekYear',
    w: 'week',
    weeks: 'week',
    week: 'week',
    W: 'isoWeek',
    isoweeks: 'isoWeek',
    isoweek: 'isoWeek',
    y: 'year',
    years: 'year',
    year: 'year'
  };
  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }
  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
      normalizedProp,
      prop;
    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }
    return normalizedInput;
  }
  var priorities = {
    date: 9,
    day: 11,
    weekday: 11,
    isoWeekday: 11,
    dayOfYear: 4,
    hour: 13,
    millisecond: 16,
    minute: 14,
    month: 8,
    quarter: 7,
    second: 15,
    weekYear: 1,
    isoWeekYear: 1,
    week: 5,
    isoWeek: 5,
    year: 1
  };
  function getPrioritizedUnits(unitsObj) {
    var units = [],
      u;
    for (u in unitsObj) {
      if (hasOwnProp(unitsObj, u)) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }
    }
    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }
  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
      zerosToFill = targetLength - absNumber.length,
      sign = number >= 0;
    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }
  var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    formatFunctions = {},
    formatTokenFunctions = {};

  // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }
  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
      func = function () {
        return this[callback]();
      };
    }
    if (token) {
      formatTokenFunctions[token] = func;
    }
    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }
    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }
  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
  }
  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
      i,
      length;
    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }
    return function (mom) {
      var output = '',
        i;
      for (i = 0; i < length; i++) {
        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
      }
      return output;
    };
  }

  // format date using native date object
  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }
    format = expandFormat(format, m.localeData());
    var cacheKey = '$' + format;
    if (!hasOwnProp(formatFunctions, cacheKey)) {
      formatFunctions[cacheKey] = makeFormatFunction(format);
    }
    return formatFunctions[cacheKey](m);
  }
  function expandFormat(format, locale) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }
    return format;
  }
  var match1 = /\d/,
    //       0 - 9
    match2 = /\d\d/,
    //      00 - 99
    match3 = /\d{3}/,
    //     000 - 999
    match4 = /\d{4}/,
    //    0000 - 9999
    match6 = /[+-]?\d{6}/,
    // -999999 - 999999
    match1to2 = /\d\d?/,
    //       0 - 99
    match3to4 = /\d\d\d\d?/,
    //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
    //   99999 - 999999
    match1to3 = /\d{1,3}/,
    //       0 - 999
    match1to4 = /\d{1,4}/,
    //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
    // -999999 - 999999
    matchUnsigned = /\d+/,
    //       0 - inf
    matchSigned = /[+-]?\d+/,
    //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
    // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
    // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
    // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    match1to2NoLeadingZero = /^[1-9]\d?/,
    //         1-99
    match1to2HasZero = /^([1-9]\d|\d)/,
    //           0-99
    regexes;
  regexes = {};
  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }
  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }
    return regexes[token](config._strict, config._locale);
  }

  // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }
  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }
  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
      value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }
    return value;
  }
  var tokens = {};
  function addParseToken(token, callback) {
    var i,
      func = callback,
      tokenLen;
    if (typeof token === 'string') {
      token = [token];
    }
    if (isNumber(callback)) {
      func = function (input, array) {
        array[callback] = toInt(input);
      };
    }
    tokenLen = token.length;
    for (i = 0; i < tokenLen; i++) {
      tokens[token[i]] = func;
    }
  }
  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }
  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }
  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }
  var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;

  // FORMATTING

  addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

  // PARSING

  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
  });

  // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }

  // HOOKS

  hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  };

  // MOMENTS

  var getSetYear = makeGetSet('FullYear', true);
  function getIsLeapYear() {
    return isLeapYear(this.year());
  }
  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get$2(this, unit);
      }
    };
  }
  function get$2(mom, unit) {
    if (!mom.isValid()) {
      return NaN;
    }
    var d = mom._d,
      isUTC = mom._isUTC;
    switch (unit) {
      case 'Milliseconds':
        return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
      case 'Seconds':
        return isUTC ? d.getUTCSeconds() : d.getSeconds();
      case 'Minutes':
        return isUTC ? d.getUTCMinutes() : d.getMinutes();
      case 'Hours':
        return isUTC ? d.getUTCHours() : d.getHours();
      case 'Date':
        return isUTC ? d.getUTCDate() : d.getDate();
      case 'Day':
        return isUTC ? d.getUTCDay() : d.getDay();
      case 'Month':
        return isUTC ? d.getUTCMonth() : d.getMonth();
      case 'FullYear':
        return isUTC ? d.getUTCFullYear() : d.getFullYear();
      default:
        return NaN;
      // Just in case
    }
  }

  function set$1(mom, unit, value) {
    var d, isUTC, year, month, date;
    if (!mom.isValid() || isNaN(value)) {
      return;
    }
    d = mom._d;
    isUTC = mom._isUTC;
    switch (unit) {
      case 'Milliseconds':
        return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
      case 'Seconds':
        return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
      case 'Minutes':
        return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
      case 'Hours':
        return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
      case 'Date':
        return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case 'FullYear':
        break;
      // See below ...
      default:
        return;
      // Just in case
    }

    year = value;
    month = mom.month();
    date = mom.date();
    date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
    void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
  }

  // MOMENTS

  function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units]();
    }
    return this;
  }
  function stringSet(units, value) {
    if (typeof units === 'object') {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units),
        i,
        prioritizedLen = prioritized.length;
      for (i = 0; i < prioritizedLen; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units](value);
      }
    }
    return this;
  }
  function mod$1(n, x) {
    return (n % x + x) % x;
  }
  var indexOf;
  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function (o) {
      // I know
      var i;
      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }
      return -1;
    };
  }
  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }
    var modMonth = mod$1(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  }

  // FORMATTING

  addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
  });

  // PARSING

  addRegexToken('M', match1to2, match1to2NoLeadingZero);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  });

  // LOCALES

  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    defaultMonthsShortRegex = matchWord,
    defaultMonthsRegex = matchWord,
    monthsParseProperties = ['monthsParse', 'longMonthsParse', 'shortMonthsParse', 'monthsRegex', 'monthsShortRegex', 'monthsStrictRegex', 'monthsShortStrictRegex'];
  function clearMonthsParseCache(locale, config) {
    var i, prop;
    for (i = 0; i < monthsParseProperties.length; i++) {
      prop = monthsParseProperties[i];
      if (!hasOwnProp(config, prop)) {
        delete locale['_' + prop];
      }
    }
  }
  function localeMonths(m, format) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
  }
  function localeMonthsShort(m, format) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }
  function handleStrictParse$1(monthName, format, strict) {
    var i,
      ii,
      mom,
      llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
      for (i = 0; i < 12; ++i) {
        mom = createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;
    if (this._monthsParseExact) {
      return handleStrictParse$1.call(this, monthName, format, strict);
    }
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }
      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      // test the regex
      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function setMonth(mom, value) {
    if (!mom.isValid()) {
      // No op
      return mom;
    }
    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value);
        // TODO: Another silent failure?
        if (!isNumber(value)) {
          return mom;
        }
      }
    }
    var month = value,
      date = mom.date();
    date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
    void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
    return mom;
  }
  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get$2(this, 'Month');
    }
  }
  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }
  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsShortRegex')) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }
      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }
  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsRegex')) {
        this._monthsRegex = defaultMonthsRegex;
      }
      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }
  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var shortPieces = [],
      longPieces = [],
      mixedPieces = [],
      i,
      mom,
      shortP,
      longP;
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      shortP = regexEscape(this.monthsShort(mom, ''));
      longP = regexEscape(this.months(mom, ''));
      shortPieces.push(shortP);
      longPieces.push(longP);
      mixedPieces.push(longP);
      mixedPieces.push(shortP);
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  }

  // FORMATTING

  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday');
  addFormatToken('eHHmm', 0, 0, function () {
    return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
  });

  // PARSING

  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('eHHmm', match5to6);
  addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
  });
  addWeekParseToken('eHHmm', function (input, week, config) {
    var weekdayEnd = input.length - 4;
    week.e = toInt(input.substr(0, weekdayEnd));
    config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
    config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
  });

  // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }
    if (!isNaN(input)) {
      return parseInt(input, 10);
    }
    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
      return input;
    }
    return null;
  }
  function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
      return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
  }

  // LOCALES
  function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
  }
  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    defaultWeekdaysRegex = matchWord,
    defaultWeekdaysShortRegex = matchWord,
    defaultWeekdaysMinRegex = matchWord,
    weekdaysParseProperties = ['weekdaysParse', 'fullWeekdaysParse', 'shortWeekdaysParse', 'minWeekdaysParse', 'weekdaysRegex', 'weekdaysShortRegex', 'weekdaysMinRegex', 'weekdaysStrictRegex', 'weekdaysShortStrictRegex', 'weekdaysMinStrictRegex'];
  function clearWeekdaysParseCache(locale, config) {
    var i, prop;
    for (i = 0; i < weekdaysParseProperties.length; i++) {
      prop = weekdaysParseProperties[i];
      if (!hasOwnProp(config, prop)) {
        delete locale['_' + prop];
      }
    }
  }
  function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
  }
  function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }
  function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }
  function handleStrictParse(weekdayName, format, strict) {
    var i,
      ii,
      mom,
      llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];
      for (i = 0; i < 7; ++i) {
        mom = createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;
    if (this._weekdaysParseExact) {
      return handleStrictParse.call(this, weekdayName, format, strict);
    }
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }
    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already

      mom = createUTC([2000, 1]).day(i);
      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
      }
      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      // test the regex
      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var day = get$2(this, 'Day');
    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }
  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }
  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }
  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }
      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }
  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }
      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }
  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }
      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }
  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var minPieces = [],
      shortPieces = [],
      longPieces = [],
      mixedPieces = [],
      i,
      mom,
      minp,
      shortp,
      longp;
    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);
      minp = regexEscape(this.weekdaysMin(mom, ''));
      shortp = regexEscape(this.weekdaysShort(mom, ''));
      longp = regexEscape(this.weekdays(mom, ''));
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  }
  function set(config) {
    var prop, i;
    clearMonthsParseCache(this, config);
    clearWeekdaysParseCache(this, config);
    for (i in config) {
      if (hasOwnProp(config, i)) {
        prop = config[i];
        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
  }
  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
      prop;
    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }
    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }
    return res;
  }
  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }
  var keys;
  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function (obj) {
      var i,
        res = [];
      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }
      return res;
    };
  }
  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };
  function calendar$1(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
  }
  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };
  function longDateFormat(key) {
    var format = this._longDateFormat[key],
      formatUpper = this._longDateFormat[key.toUpperCase()],
      formatCache = this._longDateFormatCache;
    if (format || !formatUpper) {
      return format;
    }
    if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) {
      return formatCache[key].format;
    }
    format = formatUpper.match(formattingTokens).map(function (tok) {
      if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
        return tok.slice(1);
      }
      return tok;
    }).join('');
    if (!formatCache) {
      formatCache = this._longDateFormatCache = {};
    }
    formatCache[key] = {
      formatUpper: formatUpper,
      format: format
    };
    return format;
  }
  var defaultInvalidDate = 'Invalid date';
  function invalidDate() {
    return this._invalidDate;
  }
  var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;
  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }
  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };
  function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }
  function relativeTime$1(number, withoutSuffix, string, isFuture) {
    return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
  }
  function pastFutureWithoutPostformat(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }
  function pastFuture(diff, output) {
    return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
  }
  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      date = new Date(y + 400, m, d, h, M, s, ms);
      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }
    return date;
  }
  function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      args = Array.prototype.slice.call(arguments);
      // preserve leap years using a full 400 year cycle, then reset
      args[0] = y + 400;
      date = new Date(Date.UTC.apply(null, args));
      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(null, arguments));
    }
    return date;
  }

  // start-of-first-week - start-of-year
  function firstWeekOffset(year, dow, doy) {
    var
      // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
      // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  }

  // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
      weekOffset = firstWeekOffset(year, dow, doy),
      dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
      resYear,
      resDayOfYear;
    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }
    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }
  function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
      week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1,
      resWeek,
      resYear;
    if (week < 1) {
      resYear = year - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(year, dow, doy)) {
      resWeek = week - weeksInYear(year, dow, doy);
      resYear = year + 1;
    } else {
      resYear = year;
      resWeek = week;
    }
    return {
      week: resWeek,
      year: resYear
    };
  }
  function weekOfYear(mom, dow, doy) {
    return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
  }
  function weekOfYearFromDate(year, month, date, dow, doy) {
    var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
    return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
  }
  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
      weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  }

  // FORMATTING

  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

  // PARSING

  addRegexToken('w', match1to2, match1to2NoLeadingZero);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2, match1to2NoLeadingZero);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  });

  // HELPERS

  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }
  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 6th is the first week of the year.
  };

  function localeFirstDayOfWeek() {
    return this._week.dow;
  }
  function localeFirstDayOfYear() {
    return this._week.doy;
  }

  // MOMENTS

  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }
  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  }

  // FORMATTING

  function hFormat() {
    return this.hours() % 12 || 12;
  }
  function kFormat() {
    return this.hours() || 24;
  }
  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }
  meridiem('a', true);
  meridiem('A', false);

  // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }
  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2, match1to2HasZero);
  addRegexToken('h', match1to2, match1to2NoLeadingZero);
  addRegexToken('k', match1to2, match1to2NoLeadingZero);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('kk', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
      pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
      pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  });

  // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
  }
  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  }
  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  };

  // internal storage for locale config files
  var locales = {},
    localeFamilies = {},
    globalLocale;
  function commonPrefix(arr1, arr2) {
    var i,
      minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
      if (arr1[i] !== arr2[i]) {
        return i;
      }
    }
    return minl;
  }
  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  }

  // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
  function chooseLocale(names) {
    var i = 0,
      j,
      next,
      locale,
      split;
    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;
      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));
        if (locale) {
          return locale;
        }
        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
          //the next array item is better than a shallower substring of this one
          break;
        }
        j--;
      }
      i++;
    }
    return globalLocale;
  }
  function isLocaleNameSane(name) {
    // Only canonical locale module names are safe to append to the require path.
    return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
  }
  function loadLocale(name) {
    var oldLocale = null,
      aliasedRequire,
      normalizedName;

    // Preserve exact custom locale names before trying the canonical built-in name.
    // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
    // "constructor", or "prototype" can't resolve to an inherited Object.prototype
    // property instead of a real (or missing) locale entry.
    if (hasOwnProp(locales, name)) {
      return locales[name];
    }
    normalizedName = normalizeLocale(name);
    if (hasOwnProp(locales, normalizedName)) {
      return locales[normalizedName];
    }

    // TODO: Find a better way to register and load all the locales in Node
    if (typeof module !== 'undefined' && module && module.exports && isLocaleNameSane(normalizedName)) {
      try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = require;
        aliasedRequire('./locale/' + normalizedName);
        getSetGlobalLocale(oldLocale);
      } catch (e) {
        // mark as not found to avoid repeating expensive file require call causing high CPU
        // when trying to find en-US, en_US, en-us for every format call
        locales[normalizedName] = null; // null means not found
      }
    }

    if (hasOwnProp(locales, normalizedName)) {
      return locales[normalizedName];
    }
  }

  // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.
  function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }
      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      } else {
        if (typeof console !== 'undefined' && console.warn) {
          //warn user if arguments are passed but the locale could not be set
          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
      }
    }
    return globalLocale._abbr;
  }
  function defineLocale(name, config) {
    if (config !== null) {
      var locale,
        parentConfig = baseConfig;
      config.abbr = name;
      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale = loadLocale(config.parentLocale);
          if (locale != null) {
            parentConfig = locale._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }
            localeFamilies[config.parentLocale].push({
              name: name,
              config: config
            });
            return null;
          }
        }
      }
      locales[name] = new Locale(mergeConfigs(parentConfig, config));
      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
          defineLocale(x.name, x.config);
        });
      }

      // backwards compat for now: also set the locale
      // make sure we set the locale AFTER all child locales have been
      // created, so we won't end up with the child locale set.
      getSetGlobalLocale(name);
      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }
  function updateLocale(name, config) {
    var locale,
      tmpLocale = loadLocale(name),
      parentConfig = baseConfig;
    if (tmpLocale != null) {
      name = tmpLocale._abbr;
    }
    if (config != null) {
      if (locales[name] != null && locales[name].parentLocale != null) {
        // Update existing child locale in-place to avoid memory-leaks
        locales[name].set(mergeConfigs(locales[name]._config, config));
      } else {
        // MERGE
        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        if (tmpLocale == null) {
          // updateLocale is called for creating a new locale
          // Set abbr so it will have a name (getters return
          // undefined otherwise).
          config.abbr = name;
        }
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;
      }

      // backwards compat for now: also set the locale
      getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
          if (name === getSetGlobalLocale()) {
            getSetGlobalLocale(name);
          }
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }
    return locales[name];
  }

  // returns locale data
  function getLocale(key) {
    var locale;
    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }
    if (!key) {
      return globalLocale;
    }
    if (!isArray(key)) {
      //short-circuit everything else
      locale = loadLocale(key);
      if (locale) {
        return locale;
      }
      key = [key];
    }
    return chooseLocale(key);
  }
  function listLocales() {
    return keys(locales);
  }
  function checkOverflow(m) {
    var overflow,
      a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }
      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }
      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }
      getParsingFlags(m).overflow = overflow;
    }
    return m;
  }

  // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
    isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
    // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

  // date from iso format
  function configFromISO(config) {
    var i,
      l,
      string = config._i,
      match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
      allowTime,
      dateFormat,
      timeFormat,
      tzFormat,
      isoDatesLen = isoDates.length,
      isoTimesLen = isoTimes.length;
    if (match) {
      getParsingFlags(config).iso = true;
      for (i = 0, l = isoDatesLen; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }
      if (dateFormat == null) {
        config._isValid = false;
        return;
      }
      if (match[3]) {
        for (i = 0, l = isoTimesLen; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }
        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }
      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }
      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }
      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }
  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }
    return result;
  }
  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
      return 2000 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }
    return year;
  }
  function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }
  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
        weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }
    return true;
  }
  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      // the only allowed military tz is Z
      return 0;
    } else {
      var hm = parseInt(numOffset, 10),
        m = hm % 100,
        h = (hm - m) / 100;
      return h * 60 + m;
    }
  }

  // date and time from ref 2822 format
  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
      parsedArray;
    if (match) {
      parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }
      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  }

  // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }
    configFromISO(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    configFromRFC2822(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    if (config._strict) {
      config._isValid = false;
    } else {
      // Final attempt, use Input Fallback
      hooks.createFromInputFallback(config);
    }
  }
  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  });

  // Pick the first defined of two or three arguments.
  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }
    if (b != null) {
      return b;
    }
    return c;
  }
  function currentDateArray(config, now, forWeek) {
    var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'),
      weekContext = config._isDefaultDatePartsForWeek;

    // hooks is actually the exported moment object
    config._isDefaultDatePartsForWeek = !!forWeek;
    try {
      return hooks._getDefaultDateParts(config, now, forWeek);
    } finally {
      if (hadWeekContext) {
        config._isDefaultDatePartsForWeek = weekContext;
      } else {
        delete config._isDefaultDatePartsForWeek;
      }
    }
  }
  function currentDateNow(config) {
    var now = config._defaultDatePartsNow;
    if (!now) {
      return hooks.now();
    }
    if (!now.hasValue) {
      now.value = hooks.now();
      now.hasValue = true;
    }
    return now.value;
  }

  // Internal hook for extensions that supply omitted calendar fields.
  function getDefaultDateParts(config, now, forWeek) {
    var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek,
      nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
    if (useWeekDefaults) {
      return [nowValue.year(), nowValue.month(), nowValue.date()];
    }
    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  }
  hooks._getDefaultDateParts = getDefaultDateParts;

  // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]
  function configFromArray(config) {
    var i,
      date,
      input = [],
      now,
      currentDate,
      expectedWeekday,
      yearToUse,
      dateIsDefaulted;
    if (config._d) {
      return;
    }
    if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
      now = currentDateNow(config);
      currentDate = currentDateArray(config, now);
    }

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
      yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }
      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    }
    dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }
    if (config._nextDay) {
      config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }
  function dayOfYearFromWeekInfo(config, currentDate) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4;

      // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).
      weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);
      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

      // Default to current week.
      week = defaults(w.w, curWeek.week);
      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;
        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from beginning of week
        weekday = w.e + dow;
        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to beginning of week
        weekday = dow;
      }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  }

  // constant that refers to the ISO standard
  hooks.ISO_8601 = function () {};

  // constant that refers to the RFC 2822 form
  hooks.RFC_2822 = function () {};

  // date from string and format string
  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }
    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
      i,
      parsedInput,
      tokens,
      token,
      skipped,
      stringLength = string.length,
      totalParsedInputLength = 0,
      era,
      tokenLen;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    tokenLen = tokens.length;
    for (i = 0; i < tokenLen; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));
        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }
        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      }
      // don't parse if it's not a known token
      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }
        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    // handle era
    era = getParsingFlags(config).era;
    if (era !== null) {
      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }
    configFromArray(config);
    checkOverflow(config);
  }
  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;
    if (meridiem == null) {
      // nothing to do
      return hour;
    }
    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);
      if (isPm && hour < 12) {
        hour += 12;
      }
      if (!isPm && hour === 12) {
        hour = 0;
      }
      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  }

  // date from string and array of format strings
  function configFromStringAndArray(config) {
    var tempConfig,
      bestMoment,
      scoreToBeat,
      i,
      currentScore,
      validFormatFound,
      bestFormatIsValid = false,
      defaultDatePartsNow = {},
      configfLen = config._f.length;
    if (configfLen === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }
    for (i = 0; i < configfLen; i++) {
      currentScore = 0;
      validFormatFound = false;
      tempConfig = copyConfig({}, config);
      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }
      tempConfig._defaultDatePartsNow = defaultDatePartsNow;
      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);
      if (isValid$2(tempConfig)) {
        validFormatFound = true;
      }

      // if there is any input that was not parsed add a penalty for that format
      currentScore += getParsingFlags(tempConfig).charsLeftOver;

      //or tokens
      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;
      if (!bestFormatIsValid) {
        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
          if (validFormatFound) {
            bestFormatIsValid = true;
          }
        }
      } else {
        if (currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }
    }
    extend(config, bestMoment || tempConfig);
  }
  function configFromObject(config) {
    if (config._d) {
      return;
    }
    var i = normalizeObjectUnits(config._i),
      dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }
  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, 'd');
      res._nextDay = undefined;
    }
    return res;
  }
  function prepareConfig(config) {
    var input = config._i,
      format = config._f;
    config._locale = config._locale || getLocale(config._l);
    if (input === null || format === undefined && input === '') {
      return createInvalid$1({
        nullInput: true
      });
    }
    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }
    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }
    if (!isValid$2(config)) {
      config._d = null;
    }
    return config;
  }
  function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      // from milliseconds
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }
  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};
    if (format === true || format === false) {
      strict = format;
      format = undefined;
    }
    if (locale === true || locale === false) {
      strict = locale;
      locale = undefined;
    }
    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }
  function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }
  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid$1();
      }
    }),
    prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid$1();
      }
    });

  // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.
  function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }
    if (!moments.length) {
      return createLocal();
    }
    for (i = 0; i < moments.length; ++i) {
      if (isMoment(moments[i])) {
        res = moments[i];
        break;
      }
    }
    if (!res) {
      return createInvalid$1();
    }
    for (++i; i < moments.length; ++i) {
      if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) {
        res = moments[i];
      }
    }
    return res;
  }

  // TODO: Use [].sort instead?
  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }
  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }
  var now = function () {
    return Date.now ? Date.now() : +new Date();
  };
  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
  function isDurationValid(m) {
    var key,
      unitHasDecimal = false,
      i,
      orderLen = ordering.length;
    for (key in m) {
      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }
    for (i = 0; i < orderLen; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false; // only allow non-integers for smallest unit
        }

        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }
    return true;
  }
  function isValid$1() {
    return this._isValid;
  }
  function createInvalid() {
    return createDuration(NaN);
  }
  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
      years = normalizedInput.year || 0,
      quarters = normalizedInput.quarter || 0,
      months = normalizedInput.month || 0,
      weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
      days = normalizedInput.day || 0,
      hours = normalizedInput.hour || 0,
      minutes = normalizedInput.minute || 0,
      seconds = normalizedInput.second || 0,
      milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds + seconds * 1e3 +
    // 1000
    minutes * 6e4 +
    // 1000 * 60
    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();
    this._bubble();
  }
  function isDuration(obj) {
    return obj instanceof Duration;
  }
  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  }

  // compare two arrays, return the number of differences
  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
      lengthDiff = Math.abs(array1.length - array2.length),
      diffs = 0,
      i;
    for (i = 0; i < len; i++) {
      if (toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }
    return diffs + lengthDiff;
  }

  // FORMATTING

  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset(),
        sign = '+';
      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }
      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
  }
  offset('Z', ':');
  offset('ZZ', '');

  // PARSING

  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function (input, array, config) {
    var offset = offsetFromString(matchShortOffset, input);
    config._useUTC = true;
    config._tzm = offset;
    if (offset === null) {
      getParsingFlags(config).invalidOffset = input;
    }
  });

  // HELPERS

  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']
  var chunkOffset = /([\+\-]|\d\d)/gi;
  function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
      chunk,
      parts,
      minutes;
    if (matches === null) {
      return null;
    }
    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);
    if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 14 * 60 : minutes > 12 * 60)) {
      return null;
    }
    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
  }

  // Return a moment from input, that is local/utc/zone equivalent to model.
  function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
      // Use low-level api, because this fn is low-level api.
      res._d.setTime(res._d.valueOf() + diff);
      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }
  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
  }

  // HOOKS

  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.
  hooks.updateOffset = function () {};

  // MOMENTS

  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.
  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
      localAdjust;
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);
        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }
      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }
      this._offset = input;
      this._isUTC = true;
      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }
      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }
      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }
  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }
      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }
  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }
  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;
      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }
    return this;
  }
  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
      var tZone = offsetFromString(matchOffset, this._i);
      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }
    return this;
  }
  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }
  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }
  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }
    var c = {},
      other;
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }
    return this._isDSTShifted;
  }
  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }
  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }
  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  }

  // ASP.NET json date format regex
  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function createDuration(input, key) {
    var duration = input,
      // matching against regexp is expensive, do it on demand
      match = null,
      sign,
      ret,
      diffRes;
    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input) || !isNaN(+input)) {
      duration = {};
      if (key) {
        duration[key] = +input;
      } else {
        duration.milliseconds = +input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
      };
    } else if (match = isoRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      // checks for null or undefined
      duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }
    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
      ret._isValid = input._isValid;
    }
    return ret;
  }
  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid;
  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
  }
  function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }
    res.milliseconds = +other - +base.clone().add(res.months, 'M');
    return res;
  }
  function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }
    return res;
  }

  // TODO: remove 'name' arg after deprecation is removed
  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp;
      //invert the arguments, but complain about it
      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
        tmp = val;
        val = period;
        period = tmp;
      }
      dur = createDuration(val, period);
      addSubtract$1(this, dur, direction);
      return this;
    };
  }
  function addSubtract$1(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
      days = absRound(duration._days),
      months = absRound(duration._months);
    if (!mom.isValid()) {
      // No op
      return;
    }
    updateOffset = updateOffset == null ? true : updateOffset;
    if (months) {
      setMonth(mom, get$2(mom, 'Month') + months * isAdding);
    }
    if (days) {
      set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
      hooks.updateOffset(mom, days || months);
    }
  }
  var add$1 = createAdder(1, 'add'),
    subtract$1 = createAdder(-1, 'subtract');
  function isString(input) {
    return typeof input === 'string' || input instanceof String;
  }

  // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
  function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
  }
  function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
      propertyTest = false,
      properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
      i,
      property,
      propertyLen = properties.length;
    for (i = 0; i < propertyLen; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
      dataTypeTest = false;
    if (arrayTest) {
      dataTypeTest = input.filter(function (item) {
        return !isNumber(item) && isString(input);
      }).length === 0;
    }
    return arrayTest && dataTypeTest;
  }
  function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
      propertyTest = false,
      properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
      i,
      property;
    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
  }
  function calendar(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
      if (!arguments[0]) {
        time = undefined;
        formats = undefined;
      } else if (isMomentInput(arguments[0])) {
        time = arguments[0];
        formats = undefined;
      } else if (isCalendarSpec(arguments[0])) {
        formats = arguments[0];
        time = undefined;
      }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
      sod = cloneWithOffset(now, this).startOf('day'),
      format = hooks.calendarFormat(this, sod) || 'sameElse',
      output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
  }
  function clone$1() {
    return new Moment(this);
  }
  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }
  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }
  function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
      localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }
  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
      inputMs;
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }
  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }
  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }
  function diff(input, units, asFloat) {
    var that, zoneDelta, output;
    if (!this.isValid()) {
      return NaN;
    }
    that = cloneWithOffset(input, this);
    if (!that.isValid()) {
      return NaN;
    }
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    switch (units) {
      case 'year':
        output = monthDiff(this, that) / 12;
        break;
      case 'month':
        output = monthDiff(this, that);
        break;
      case 'quarter':
        output = monthDiff(this, that) / 3;
        break;
      case 'second':
        output = (this - that) / 1e3;
        break;
      // 1000
      case 'minute':
        output = (this - that) / 6e4;
        break;
      // 1000 * 60
      case 'hour':
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60
      case 'day':
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst
      case 'week':
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst
      default:
        output = this - that;
    }
    return asFloat ? output : absFloor(output);
  }
  function monthDiff(a, b) {
    if (a.date() < b.date()) {
      // end-of-month calculations work correct when the start month has more
      // days than the end month.
      return -monthDiff(b, a);
    }
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
      // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
      anchor2,
      adjust;
    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
  }
  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }
  function toISOString$1(keepOffset) {
    if (!this.isValid()) {
      return null;
    }
    var utc = keepOffset !== true,
      m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
      // native implementation is ~50x faster, use it when we can
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
      }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
  }

  /**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */
  function inspect() {
    if (!this.isValid()) {
      return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment',
      zone = '',
      prefix,
      year,
      datetime,
      suffix;
    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
      zone = 'Z';
    }
    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }
  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }
  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }
  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  }

  // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.
  function locale(key) {
    var newLocaleData;
    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);
      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }
      return this;
    }
  }
  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });
  function localeData() {
    return this._locale;
  }
  var MS_PER_SECOND = 1000,
    MS_PER_MINUTE = 60 * MS_PER_SECOND,
    MS_PER_HOUR = 60 * MS_PER_MINUTE,
    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

  // actual modulo - handles negative numbers (for dates before 1970):
  function mod(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
  }
  function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return new Date(y, m, d).valueOf();
    }
  }
  function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return Date.UTC(y, m, d);
    }
  }
  function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case 'year':
        time = startOfDate(this.year(), 0, 1);
        break;
      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
        break;
      case 'month':
        time = startOfDate(this.year(), this.month(), 1);
        break;
      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
        break;
      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;
      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date());
        break;
      case 'hour':
        time = this._d.valueOf();
        time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
        break;
      case 'minute':
        time = this._d.valueOf();
        time -= mod(time, MS_PER_MINUTE);
        break;
      case 'second':
        time = this._d.valueOf();
        time -= mod(time, MS_PER_SECOND);
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case 'year':
        time = startOfDate(this.year() + 1, 0, 1) - 1;
        break;
      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;
      case 'month':
        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
        break;
      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;
      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;
      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case 'hour':
        time = this._d.valueOf();
        time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
        break;
      case 'minute':
        time = this._d.valueOf();
        time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
        break;
      case 'second':
        time = this._d.valueOf();
        time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function valueOf$1() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
  }
  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }
  function toDate() {
    return new Date(this.valueOf());
  }
  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }
  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }
  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }
  function isValid() {
    return isValid$2(this);
  }
  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }
  function invalidAt() {
    return getParsingFlags(this).overflow;
  }
  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }
  addFormatToken('N', 0, 0, 'eraAbbr');
  addFormatToken('NN', 0, 0, 'eraAbbr');
  addFormatToken('NNN', 0, 0, 'eraAbbr');
  addFormatToken('NNNN', 0, 0, 'eraName');
  addFormatToken('NNNNN', 0, 0, 'eraNarrow');
  addFormatToken('y', ['y', 1], 'yo', 'eraYear');
  addFormatToken('y', ['yy', 2], 0, 'eraYear');
  addFormatToken('y', ['yyy', 3], 0, 'eraYear');
  addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
  addRegexToken('N', matchEraAbbr);
  addRegexToken('NN', matchEraAbbr);
  addRegexToken('NNN', matchEraAbbr);
  addRegexToken('NNNN', matchEraName);
  addRegexToken('NNNNN', matchEraNarrow);
  addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
    var era = config._locale.erasParse(input, token, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  });
  addRegexToken('y', matchUnsigned);
  addRegexToken('yy', matchUnsigned);
  addRegexToken('yyy', matchUnsigned);
  addRegexToken('yyyy', matchUnsigned);
  addRegexToken('yo', matchEraYearOrdinal);
  addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
  addParseToken(['yo'], function (input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
      match = input.match(config._locale._eraYearOrdinalRegex);
    }
    if (config._locale.eraYearOrdinalParse) {
      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
      array[YEAR] = parseInt(input, 10);
    }
  });
  function localeEras(m, format) {
    var i,
      l,
      date,
      eras = this._eras || getLocale('en')._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
      switch (typeof eras[i].since) {
        case 'string':
          // truncate time
          date = hooks(eras[i].since).startOf('day');
          eras[i].since = date.valueOf();
          break;
      }
      switch (typeof eras[i].until) {
        case 'undefined':
          eras[i].until = +Infinity;
          break;
        case 'string':
          // truncate time
          date = hooks(eras[i].until).startOf('day').valueOf();
          eras[i].until = date.valueOf();
          break;
      }
    }
    return eras;
  }
  function localeErasParse(eraName, format, strict) {
    var i,
      l,
      eras = this.eras(),
      name,
      abbr,
      narrow;
    eraName = eraName.toUpperCase();
    for (i = 0, l = eras.length; i < l; ++i) {
      name = eras[i].name.toUpperCase();
      abbr = eras[i].abbr.toUpperCase();
      narrow = eras[i].narrow.toUpperCase();
      if (strict) {
        switch (format) {
          case 'N':
          case 'NN':
          case 'NNN':
            if (abbr === eraName) {
              return eras[i];
            }
            break;
          case 'NNNN':
            if (name === eraName) {
              return eras[i];
            }
            break;
          case 'NNNNN':
            if (narrow === eraName) {
              return eras[i];
            }
            break;
        }
      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
        return eras[i];
      }
    }
  }
  function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? 1 : -1;
    if (year === undefined) {
      return hooks(era.since).year();
    } else {
      return hooks(era.since).year() + (year - era.offset) * dir;
    }
  }
  function getEraName() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].name;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].name;
      }
    }
    return '';
  }
  function getEraNarrow() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].narrow;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].narrow;
      }
    }
    return '';
  }
  function getEraAbbr() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].abbr;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].abbr;
      }
    }
    return '';
  }
  function getEraYear() {
    var i,
      l,
      dir,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      dir = eras[i].since <= eras[i].until ? 1 : -1;

      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
      }
    }
    return this.year();
  }
  function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
  }
  function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
  }
  function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
  }
  function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
  }
  function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
  }
  function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
  }
  function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
  }
  function computeErasParse() {
    var abbrPieces = [],
      namePieces = [],
      narrowPieces = [],
      mixedPieces = [],
      i,
      l,
      erasName,
      erasAbbr,
      erasNarrow,
      eras = this.eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      erasName = regexEscape(eras[i].name);
      erasAbbr = regexEscape(eras[i].abbr);
      erasNarrow = regexEscape(eras[i].narrow);
      namePieces.push(erasName);
      abbrPieces.push(erasAbbr);
      narrowPieces.push(erasNarrow);
      mixedPieces.push(erasName);
      mixedPieces.push(erasAbbr);
      mixedPieces.push(erasNarrow);
    }
    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
  }

  // FORMATTING

  addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
  });
  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }
  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear');

  // ALIASES

  // PARSING

  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
  });

  // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
  }
  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }
  function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
  }
  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }
  function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
  }
  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);
      if (week > weeksTarget) {
        week = weeksTarget;
      }
      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }
  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
      date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  }

  // FORMATTING

  addFormatToken('Q', 0, 'Qo', 'quarter');

  // PARSING

  addRegexToken('Q', match1);
  addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  });

  // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  }

  // FORMATTING

  addFormatToken('D', ['DD', 2], 'Do', 'date');

  // PARSING

  addRegexToken('D', match1to2, match1to2NoLeadingZero);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  });

  // MOMENTS

  var getSetDayOfMonth = makeGetSet('Date', true);

  // FORMATTING

  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

  // PARSING

  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
  });

  // HELPERS

  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
  }

  // FORMATTING

  addFormatToken('m', ['mm', 2], 0, 'minute');

  // PARSING

  addRegexToken('m', match1to2, match1to2HasZero);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE);

  // MOMENTS

  var getSetMinute = makeGetSet('Minutes', false);

  // FORMATTING

  addFormatToken('s', ['ss', 2], 0, 'second');

  // PARSING

  addRegexToken('s', match1to2, match1to2HasZero);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND);

  // MOMENTS

  var getSetSecond = makeGetSet('Seconds', false);

  // FORMATTING

  addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
  });

  // PARSING

  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token, getSetMillisecond;
  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }
  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }
  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  }
  getSetMillisecond = makeGetSet('Milliseconds', false);

  // FORMATTING

  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName');

  // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }
  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }
  var proto$2 = Moment.prototype;
  proto$2.add = add$1;
  proto$2.calendar = calendar;
  proto$2.clone = clone$1;
  proto$2.diff = diff;
  proto$2.endOf = endOf;
  proto$2.format = format;
  proto$2.from = from;
  proto$2.fromNow = fromNow;
  proto$2.to = to;
  proto$2.toNow = toNow;
  proto$2.get = stringGet;
  proto$2.invalidAt = invalidAt;
  proto$2.isAfter = isAfter;
  proto$2.isBefore = isBefore;
  proto$2.isBetween = isBetween;
  proto$2.isSame = isSame;
  proto$2.isSameOrAfter = isSameOrAfter;
  proto$2.isSameOrBefore = isSameOrBefore;
  proto$2.isValid = isValid;
  proto$2.lang = lang;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.max = prototypeMax;
  proto$2.min = prototypeMin;
  proto$2.parsingFlags = parsingFlags;
  proto$2.set = stringSet;
  proto$2.startOf = startOf;
  proto$2.subtract = subtract$1;
  proto$2.toArray = toArray;
  proto$2.toObject = toObject;
  proto$2.toDate = toDate;
  proto$2.toISOString = toISOString$1;
  proto$2.inspect = inspect;
  if (typeof Symbol !== 'undefined' && Symbol.for != null) {
    proto$2[Symbol.for('nodejs.util.inspect.custom')] = function () {
      return 'Moment<' + this.format() + '>';
    };
  }
  proto$2.toJSON = toJSON;
  proto$2.toString = toString;
  proto$2.unix = unix;
  proto$2.valueOf = valueOf$1;
  proto$2.creationData = creationData;
  proto$2.eraName = getEraName;
  proto$2.eraNarrow = getEraNarrow;
  proto$2.eraAbbr = getEraAbbr;
  proto$2.eraYear = getEraYear;
  proto$2.year = getSetYear;
  proto$2.isLeapYear = getIsLeapYear;
  proto$2.weekYear = getSetWeekYear;
  proto$2.isoWeekYear = getSetISOWeekYear;
  proto$2.quarter = proto$2.quarters = getSetQuarter;
  proto$2.month = getSetMonth;
  proto$2.daysInMonth = getDaysInMonth;
  proto$2.week = proto$2.weeks = getSetWeek;
  proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
  proto$2.weeksInYear = getWeeksInYear;
  proto$2.weeksInWeekYear = getWeeksInWeekYear;
  proto$2.isoWeeksInYear = getISOWeeksInYear;
  proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
  proto$2.date = getSetDayOfMonth;
  proto$2.day = proto$2.days = getSetDayOfWeek;
  proto$2.weekday = getSetLocaleDayOfWeek;
  proto$2.isoWeekday = getSetISODayOfWeek;
  proto$2.dayOfYear = getSetDayOfYear;
  proto$2.hour = proto$2.hours = getSetHour;
  proto$2.minute = proto$2.minutes = getSetMinute;
  proto$2.second = proto$2.seconds = getSetSecond;
  proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
  proto$2.utcOffset = getSetOffset;
  proto$2.utc = setOffsetToUTC;
  proto$2.local = setOffsetToLocal;
  proto$2.parseZone = setOffsetToParsedOffset;
  proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
  proto$2.isDST = isDaylightSavingTime;
  proto$2.isLocal = isLocal;
  proto$2.isUtcOffset = isUtcOffset;
  proto$2.isUtc = isUtc;
  proto$2.isUTC = isUtc;
  proto$2.zoneAbbr = getZoneAbbr;
  proto$2.zoneName = getZoneName;
  proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
  proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
  function createUnix(input) {
    return createLocal(input * 1000);
  }
  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }
  function preParsePostFormat(string) {
    return string;
  }
  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar$1;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime$1;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.eras = localeEras;
  proto$1.erasParse = localeErasParse;
  proto$1.erasConvertYear = localeErasConvertYear;
  proto$1.erasAbbrRegex = erasAbbrRegex;
  proto$1.erasNameRegex = erasNameRegex;
  proto$1.erasNarrowRegex = erasNarrowRegex;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;
  function get$1(format, index, field, setter) {
    var locale = getLocale(),
      utc = createUTC().set(setter, index);
    return locale[field](utc, format);
  }
  function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
      index = format;
      format = undefined;
    }
    format = format || '';
    if (index != null) {
      return get$1(format, index, field, 'month');
    }
    var i,
      out = [];
    for (i = 0; i < 12; i++) {
      out[i] = get$1(format, i, field, 'month');
    }
    return out;
  }

  // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)
  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
    }
    var locale = getLocale(),
      shift = localeSorted ? locale._week.dow : 0,
      i,
      out = [];
    if (index != null) {
      return get$1(format, (index + shift) % 7, field, 'day');
    }
    for (i = 0; i < 7; i++) {
      out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
  }
  function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }
  function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }
  function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }
  function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }
  function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }
  getSetGlobalLocale('en', {
    eras: [{
      since: '0001-01-01',
      until: +Infinity,
      offset: 1,
      name: 'Anno Domini',
      narrow: 'AD',
      abbr: 'AD'
    }, {
      since: '0000-12-31',
      until: -Infinity,
      offset: 1,
      name: 'Before Christ',
      narrow: 'BC',
      abbr: 'BC'
    }],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
      var b = number % 10,
        output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return number + output;
    }
  });

  // Side effect imports

  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
  var mathAbs = Math.abs;
  function abs$1() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }
  function addSubtract(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  }

  // supports only 2.0-style add(1, 's') or add(duration)
  function add(input, value) {
    return addSubtract(this, input, value, 1);
  }

  // supports only 2.0-style subtract(1, 's') or subtract(duration)
  function subtract(input, value) {
    return addSubtract(this, input, value, -1);
  }
  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }
  function bubble() {
    var milliseconds = this._milliseconds,
      days = this._days,
      months = this._months,
      data = this._data,
      seconds,
      minutes,
      hours,
      years,
      monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }
  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }
  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }
  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }
    var days,
      months,
      milliseconds = this._milliseconds;
    units = normalizeUnits(units);
    if (units === 'month' || units === 'quarter' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);
      switch (units) {
        case 'month':
          return months;
        case 'quarter':
          return months / 3;
        case 'year':
          return months / 12;
      }
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));
      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;
        case 'day':
          return days + milliseconds / 864e5;
        case 'hour':
          return days * 24 + milliseconds / 36e5;
        case 'minute':
          return days * 1440 + milliseconds / 6e4;
        case 'second':
          return days * 86400 + milliseconds / 1000;
        // Math.floor prevents floating point math errors here
        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;
        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  }
  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }
  var asMilliseconds = makeAs('ms'),
    asSeconds = makeAs('s'),
    asMinutes = makeAs('m'),
    asHours = makeAs('h'),
    asDays = makeAs('d'),
    asWeeks = makeAs('w'),
    asMonths = makeAs('M'),
    asQuarters = makeAs('Q'),
    asYears = makeAs('y'),
    valueOf = asMilliseconds;
  function clone() {
    return createDuration(this);
  }
  function get(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
  }
  function makeGetter(name) {
    return function () {
      return this.isValid() ? this._data[name] : NaN;
    };
  }
  var milliseconds = makeGetter('milliseconds'),
    seconds = makeGetter('seconds'),
    minutes = makeGetter('minutes'),
    hours = makeGetter('hours'),
    days = makeGetter('days'),
    months = makeGetter('months'),
    years = makeGetter('years');
  function weeks() {
    return absFloor(this.days() / 7);
  }
  var round = Math.round,
    thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11 // months to year
    };

  // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
  }
  function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
      seconds = round(duration.as('s')),
      minutes = round(duration.as('m')),
      hours = round(duration.as('h')),
      days = round(duration.as('d')),
      months = round(duration.as('M')),
      weeks = round(duration.as('w')),
      years = round(duration.as('y')),
      a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
    if (thresholds.w != null) {
      a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
    }
    a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  }

  // This function allows you to set the rounding function for relative time strings
  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }
    if (typeof roundingFunction === 'function') {
      round = roundingFunction;
      return true;
    }
    return false;
  }

  // This function allows you to set a threshold for relative time strings
  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }
    if (limit === undefined) {
      return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
      thresholds.ss = limit - 1;
    }
    return true;
  }
  function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var withSuffix = false,
      th = thresholds,
      locale,
      output;
    if (typeof argWithSuffix === 'object') {
      argThresholds = argWithSuffix;
      argWithSuffix = false;
    }
    if (typeof argWithSuffix === 'boolean') {
      withSuffix = argWithSuffix;
    }
    if (typeof argThresholds === 'object') {
      th = extend(extend({}, thresholds), argThresholds || {});
      if (argThresholds.s != null && argThresholds.ss == null) {
        th.ss = argThresholds.s - 1;
      }
    }
    locale = this.localeData();
    output = relativeTime(this, !withSuffix, th, locale);
    if (withSuffix) {
      output = pastFutureWithoutPostformat.call(locale, +this, output);
    }
    return locale.postformat(output);
  }
  var abs = Math.abs;
  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }
  function toISOString() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var seconds = abs(this._milliseconds) / 1000,
      days = abs(this._days),
      months = abs(this._months),
      minutes,
      hours,
      years,
      s,
      total = this.asSeconds(),
      totalSign,
      ymSign,
      daysSign,
      hmsSign;
    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return 'P0D';
    }

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
  }
  var proto = Duration.prototype;
  proto.isValid = isValid$1;
  proto.abs = abs$1;
  proto.add = add;
  proto.subtract = subtract;
  proto.as = as;
  proto.asMilliseconds = asMilliseconds;
  proto.asSeconds = asSeconds;
  proto.asMinutes = asMinutes;
  proto.asHours = asHours;
  proto.asDays = asDays;
  proto.asWeeks = asWeeks;
  proto.asMonths = asMonths;
  proto.asQuarters = asQuarters;
  proto.asYears = asYears;
  proto.valueOf = valueOf;
  proto._bubble = bubble;
  proto.clone = clone;
  proto.get = get;
  proto.milliseconds = milliseconds;
  proto.seconds = seconds;
  proto.minutes = minutes;
  proto.hours = hours;
  proto.days = days;
  proto.weeks = weeks;
  proto.months = months;
  proto.years = years;
  proto.humanize = humanize;
  proto.toISOString = toISOString;
  proto.toString = toISOString;
  proto.toJSON = toISOString;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
  proto.lang = lang;

  // FORMATTING

  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf');

  // PARSING

  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
  });
  addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
  });

  //! moment.js

  hooks.version = '2.31.0';
  setHookCallback(createLocal);
  hooks.fn = proto$2;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid$1;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto$2;

  // currently HTML5 input type only supports 24-hour formats
  hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',
    // <input type="date" />
    TIME: 'HH:mm',
    // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',
    // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',
    // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW',
    // <input type="week" />
    MONTH: 'YYYY-MM' // <input type="month" />
  };

  return hooks;
});
/*! ngImgCrop v0.3.2 License: MIT */!function () {
  "use strict";

  var e = angular.module("ngImgCrop", []);
  e.factory("cropAreaCircle", ["cropArea", function (e) {
    var t = function () {
      e.apply(this, arguments), this._boxResizeBaseSize = 20, this._boxResizeNormalRatio = .9, this._boxResizeHoverRatio = 1.2, this._iconMoveNormalRatio = .9, this._iconMoveHoverRatio = 1.2, this._boxResizeNormalSize = this._boxResizeBaseSize * this._boxResizeNormalRatio, this._boxResizeHoverSize = this._boxResizeBaseSize * this._boxResizeHoverRatio, this._posDragStartX = 0, this._posDragStartY = 0, this._posResizeStartX = 0, this._posResizeStartY = 0, this._posResizeStartSize = 0, this._boxResizeIsHover = !1, this._areaIsHover = !1, this._boxResizeIsDragging = !1, this._areaIsDragging = !1;
    };
    return t.prototype = new e(), t.prototype._calcCirclePerimeterCoords = function (e) {
      var t = this._size / 2,
        i = e * (Math.PI / 180),
        r = this._x + t * Math.cos(i),
        s = this._y + t * Math.sin(i);
      return [r, s];
    }, t.prototype._calcResizeIconCenterCoords = function () {
      return this._calcCirclePerimeterCoords(-45);
    }, t.prototype._isCoordWithinArea = function (e) {
      return Math.sqrt((e[0] - this._x) * (e[0] - this._x) + (e[1] - this._y) * (e[1] - this._y)) < this._size / 2;
    }, t.prototype._isCoordWithinBoxResize = function (e) {
      var t = this._calcResizeIconCenterCoords(),
        i = this._boxResizeHoverSize / 2;
      return e[0] > t[0] - i && e[0] < t[0] + i && e[1] > t[1] - i && e[1] < t[1] + i;
    }, t.prototype._drawArea = function (e, t, i) {
      e.arc(t[0], t[1], i / 2, 0, 2 * Math.PI);
    }, t.prototype.draw = function () {
      e.prototype.draw.apply(this, arguments), this._cropCanvas.drawIconMove([this._x, this._y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio), this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover ? this._boxResizeHoverRatio : this._boxResizeNormalRatio);
    }, t.prototype.processMouseMove = function (e, t) {
      var i = "default",
        r = !1;
      if (this._boxResizeIsHover = !1, this._areaIsHover = !1, this._areaIsDragging) this._x = e - this._posDragStartX, this._y = t - this._posDragStartY, this._areaIsHover = !0, i = "move", r = !0, this._events.trigger("area-move");else if (this._boxResizeIsDragging) {
        i = "nesw-resize";
        var s, o, a;
        o = e - this._posResizeStartX, a = this._posResizeStartY - t, s = o > a ? this._posResizeStartSize + 2 * a : this._posResizeStartSize + 2 * o, this._size = Math.max(this._minSize, s), this._boxResizeIsHover = !0, r = !0, this._events.trigger("area-resize");
      } else this._isCoordWithinBoxResize([e, t]) ? (i = "nesw-resize", this._areaIsHover = !1, this._boxResizeIsHover = !0, r = !0) : this._isCoordWithinArea([e, t]) && (i = "move", this._areaIsHover = !0, r = !0);
      return this._dontDragOutside(), angular.element(this._ctx.canvas).css({
        cursor: i
      }), r;
    }, t.prototype.processMouseDown = function (e, t) {
      this._isCoordWithinBoxResize([e, t]) ? (this._areaIsDragging = !1, this._areaIsHover = !1, this._boxResizeIsDragging = !0, this._boxResizeIsHover = !0, this._posResizeStartX = e, this._posResizeStartY = t, this._posResizeStartSize = this._size, this._events.trigger("area-resize-start")) : this._isCoordWithinArea([e, t]) && (this._areaIsDragging = !0, this._areaIsHover = !0, this._boxResizeIsDragging = !1, this._boxResizeIsHover = !1, this._posDragStartX = e - this._x, this._posDragStartY = t - this._y, this._events.trigger("area-move-start"));
    }, t.prototype.processMouseUp = function () {
      this._areaIsDragging && (this._areaIsDragging = !1, this._events.trigger("area-move-end")), this._boxResizeIsDragging && (this._boxResizeIsDragging = !1, this._events.trigger("area-resize-end")), this._areaIsHover = !1, this._boxResizeIsHover = !1, this._posDragStartX = 0, this._posDragStartY = 0;
    }, t;
  }]), e.factory("cropAreaSquare", ["cropArea", function (e) {
    var t = function () {
      e.apply(this, arguments), this._resizeCtrlBaseRadius = 10, this._resizeCtrlNormalRatio = .75, this._resizeCtrlHoverRatio = 1, this._iconMoveNormalRatio = .9, this._iconMoveHoverRatio = 1.2, this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio, this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio, this._posDragStartX = 0, this._posDragStartY = 0, this._posResizeStartX = 0, this._posResizeStartY = 0, this._posResizeStartSize = 0, this._resizeCtrlIsHover = -1, this._areaIsHover = !1, this._resizeCtrlIsDragging = -1, this._areaIsDragging = !1;
    };
    return t.prototype = new e(), t.prototype._calcSquareCorners = function () {
      var e = this._size / 2;
      return [[this._x - e, this._y - e], [this._x + e, this._y - e], [this._x - e, this._y + e], [this._x + e, this._y + e]];
    }, t.prototype._calcSquareDimensions = function () {
      var e = this._size / 2;
      return {
        left: this._x - e,
        top: this._y - e,
        right: this._x + e,
        bottom: this._y + e
      };
    }, t.prototype._isCoordWithinArea = function (e) {
      var t = this._calcSquareDimensions();
      return e[0] >= t.left && e[0] <= t.right && e[1] >= t.top && e[1] <= t.bottom;
    }, t.prototype._isCoordWithinResizeCtrl = function (e) {
      for (var t = this._calcSquareCorners(), i = -1, r = 0, s = t.length; s > r; r++) {
        var o = t[r];
        if (e[0] > o[0] - this._resizeCtrlHoverRadius && e[0] < o[0] + this._resizeCtrlHoverRadius && e[1] > o[1] - this._resizeCtrlHoverRadius && e[1] < o[1] + this._resizeCtrlHoverRadius) {
          i = r;
          break;
        }
      }
      return i;
    }, t.prototype._drawArea = function (e, t, i) {
      var r = i / 2;
      e.rect(t[0] - r, t[1] - r, i, i);
    }, t.prototype.draw = function () {
      e.prototype.draw.apply(this, arguments), this._cropCanvas.drawIconMove([this._x, this._y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);
      for (var t = this._calcSquareCorners(), i = 0, r = t.length; r > i; i++) {
        var s = t[i];
        this._cropCanvas.drawIconResizeCircle(s, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
      }
    }, t.prototype.processMouseMove = function (e, t) {
      var i = "default",
        r = !1;
      if (this._resizeCtrlIsHover = -1, this._areaIsHover = !1, this._areaIsDragging) this._x = e - this._posDragStartX, this._y = t - this._posDragStartY, this._areaIsHover = !0, i = "move", r = !0, this._events.trigger("area-move");else if (this._resizeCtrlIsDragging > -1) {
        var s, o;
        switch (this._resizeCtrlIsDragging) {
          case 0:
            s = -1, o = -1, i = "nwse-resize";
            break;
          case 1:
            s = 1, o = -1, i = "nesw-resize";
            break;
          case 2:
            s = -1, o = 1, i = "nesw-resize";
            break;
          case 3:
            s = 1, o = 1, i = "nwse-resize";
        }
        var a,
          n = (e - this._posResizeStartX) * s,
          h = (t - this._posResizeStartY) * o;
        a = n > h ? this._posResizeStartSize + h : this._posResizeStartSize + n;
        var c = this._size;
        this._size = Math.max(this._minSize, a);
        var l = (this._size - c) / 2;
        this._x += l * s, this._y += l * o, this._resizeCtrlIsHover = this._resizeCtrlIsDragging, r = !0, this._events.trigger("area-resize");
      } else {
        var u = this._isCoordWithinResizeCtrl([e, t]);
        if (u > -1) {
          switch (u) {
            case 0:
              i = "nwse-resize";
              break;
            case 1:
              i = "nesw-resize";
              break;
            case 2:
              i = "nesw-resize";
              break;
            case 3:
              i = "nwse-resize";
          }
          this._areaIsHover = !1, this._resizeCtrlIsHover = u, r = !0;
        } else this._isCoordWithinArea([e, t]) && (i = "move", this._areaIsHover = !0, r = !0);
      }
      return this._dontDragOutside(), angular.element(this._ctx.canvas).css({
        cursor: i
      }), r;
    }, t.prototype.processMouseDown = function (e, t) {
      var i = this._isCoordWithinResizeCtrl([e, t]);
      i > -1 ? (this._areaIsDragging = !1, this._areaIsHover = !1, this._resizeCtrlIsDragging = i, this._resizeCtrlIsHover = i, this._posResizeStartX = e, this._posResizeStartY = t, this._posResizeStartSize = this._size, this._events.trigger("area-resize-start")) : this._isCoordWithinArea([e, t]) && (this._areaIsDragging = !0, this._areaIsHover = !0, this._resizeCtrlIsDragging = -1, this._resizeCtrlIsHover = -1, this._posDragStartX = e - this._x, this._posDragStartY = t - this._y, this._events.trigger("area-move-start"));
    }, t.prototype.processMouseUp = function () {
      this._areaIsDragging && (this._areaIsDragging = !1, this._events.trigger("area-move-end")), this._resizeCtrlIsDragging > -1 && (this._resizeCtrlIsDragging = -1, this._events.trigger("area-resize-end")), this._areaIsHover = !1, this._resizeCtrlIsHover = -1, this._posDragStartX = 0, this._posDragStartY = 0;
    }, t;
  }]), e.factory("cropArea", ["cropCanvas", function (e) {
    var t = function (t, i) {
      this._ctx = t, this._events = i, this._minSize = 80, this._cropCanvas = new e(t), this._image = new Image(), this._x = 0, this._y = 0, this._size = 200;
    };
    return t.prototype.getImage = function () {
      return this._image;
    }, t.prototype.setImage = function (e) {
      this._image = e;
    }, t.prototype.getX = function () {
      return this._x;
    }, t.prototype.setX = function (e) {
      this._x = e, this._dontDragOutside();
    }, t.prototype.getY = function () {
      return this._y;
    }, t.prototype.setY = function (e) {
      this._y = e, this._dontDragOutside();
    }, t.prototype.getSize = function () {
      return this._size;
    }, t.prototype.setSize = function (e) {
      this._size = Math.max(this._minSize, e), this._dontDragOutside();
    }, t.prototype.getMinSize = function () {
      return this._minSize;
    }, t.prototype.setMinSize = function (e) {
      this._minSize = e, this._size = Math.max(this._minSize, this._size), this._dontDragOutside();
    }, t.prototype._dontDragOutside = function () {
      var e = this._ctx.canvas.height,
        t = this._ctx.canvas.width;
      this._size > t && (this._size = t), this._size > e && (this._size = e), this._x < this._size / 2 && (this._x = this._size / 2), this._x > t - this._size / 2 && (this._x = t - this._size / 2), this._y < this._size / 2 && (this._y = this._size / 2), this._y > e - this._size / 2 && (this._y = e - this._size / 2);
    }, t.prototype._drawArea = function () {}, t.prototype.draw = function () {
      this._cropCanvas.drawCropArea(this._image, [this._x, this._y], this._size, this._drawArea);
    }, t.prototype.processMouseMove = function () {}, t.prototype.processMouseDown = function () {}, t.prototype.processMouseUp = function () {}, t;
  }]), e.factory("cropCanvas", [function () {
    var e = [[-.5, -2], [-3, -4.5], [-.5, -7], [-7, -7], [-7, -.5], [-4.5, -3], [-2, -.5]],
      t = [[.5, -2], [3, -4.5], [.5, -7], [7, -7], [7, -.5], [4.5, -3], [2, -.5]],
      i = [[-.5, 2], [-3, 4.5], [-.5, 7], [-7, 7], [-7, .5], [-4.5, 3], [-2, .5]],
      r = [[.5, 2], [3, 4.5], [.5, 7], [7, 7], [7, .5], [4.5, 3], [2, .5]],
      s = [[-1.5, -2.5], [-1.5, -6], [-5, -6], [0, -11], [5, -6], [1.5, -6], [1.5, -2.5]],
      o = [[-2.5, -1.5], [-6, -1.5], [-6, -5], [-11, 0], [-6, 5], [-6, 1.5], [-2.5, 1.5]],
      a = [[-1.5, 2.5], [-1.5, 6], [-5, 6], [0, 11], [5, 6], [1.5, 6], [1.5, 2.5]],
      n = [[2.5, -1.5], [6, -1.5], [6, -5], [11, 0], [6, 5], [6, 1.5], [2.5, 1.5]],
      h = {
        areaOutline: "#fff",
        resizeBoxStroke: "#fff",
        resizeBoxFill: "#444",
        resizeBoxArrowFill: "#fff",
        resizeCircleStroke: "#fff",
        resizeCircleFill: "#444",
        moveIconFill: "#fff"
      };
    return function (c) {
      var l = function (e, t, i) {
          return [i * e[0] + t[0], i * e[1] + t[1]];
        },
        u = function (e, t, i, r) {
          c.save(), c.fillStyle = t, c.beginPath();
          var s,
            o = l(e[0], i, r);
          c.moveTo(o[0], o[1]);
          for (var a in e) a > 0 && (s = l(e[a], i, r), c.lineTo(s[0], s[1]));
          c.lineTo(o[0], o[1]), c.fill(), c.closePath(), c.restore();
        };
      this.drawIconMove = function (e, t) {
        u(s, h.moveIconFill, e, t), u(o, h.moveIconFill, e, t), u(a, h.moveIconFill, e, t), u(n, h.moveIconFill, e, t);
      }, this.drawIconResizeCircle = function (e, t, i) {
        var r = t * i;
        c.save(), c.strokeStyle = h.resizeCircleStroke, c.lineWidth = 2, c.fillStyle = h.resizeCircleFill, c.beginPath(), c.arc(e[0], e[1], r, 0, 2 * Math.PI), c.fill(), c.stroke(), c.closePath(), c.restore();
      }, this.drawIconResizeBoxBase = function (e, t, i) {
        var r = t * i;
        c.save(), c.strokeStyle = h.resizeBoxStroke, c.lineWidth = 2, c.fillStyle = h.resizeBoxFill, c.fillRect(e[0] - r / 2, e[1] - r / 2, r, r), c.strokeRect(e[0] - r / 2, e[1] - r / 2, r, r), c.restore();
      }, this.drawIconResizeBoxNESW = function (e, r, s) {
        this.drawIconResizeBoxBase(e, r, s), u(t, h.resizeBoxArrowFill, e, s), u(i, h.resizeBoxArrowFill, e, s);
      }, this.drawIconResizeBoxNWSE = function (t, i, s) {
        this.drawIconResizeBoxBase(t, i, s), u(e, h.resizeBoxArrowFill, t, s), u(r, h.resizeBoxArrowFill, t, s);
      }, this.drawCropArea = function (e, t, i, r) {
        var s = e.width / c.canvas.width,
          o = e.height / c.canvas.height,
          a = t[0] - i / 2,
          n = t[1] - i / 2;
        c.save(), c.strokeStyle = h.areaOutline, c.lineWidth = 2, c.beginPath(), r(c, t, i), c.stroke(), c.clip(), i > 0 && c.drawImage(e, a * s, n * o, i * s, i * o, a, n, i, i), c.beginPath(), r(c, t, i), c.stroke(), c.clip(), c.restore();
      };
    };
  }]), e.service("cropEXIF", [function () {
    function e(e) {
      return !!e.exifdata;
    }
    function t(e, t) {
      t = t || e.match(/^data\:([^\;]+)\;base64,/im)[1] || "", e = e.replace(/^data\:([^\;]+)\;base64,/gim, "");
      for (var i = atob(e), r = i.length, s = new ArrayBuffer(r), o = new Uint8Array(s), a = 0; r > a; a++) o[a] = i.charCodeAt(a);
      return s;
    }
    function i(e, t) {
      var i = new XMLHttpRequest();
      i.open("GET", e, !0), i.responseType = "blob", i.onload = function () {
        (200 == this.status || 0 === this.status) && t(this.response);
      }, i.send();
    }
    function r(e, r) {
      function a(t) {
        var i = s(t),
          a = o(t);
        e.exifdata = i || {}, e.iptcdata = a || {}, r && r.call(e);
      }
      if (e.src) {
        if (/^data\:/i.test(e.src)) {
          var n = t(e.src);
          a(n);
        } else if (/^blob\:/i.test(e.src)) {
          var h = new FileReader();
          h.onload = function (e) {
            a(e.target.result);
          }, i(e.src, function (e) {
            h.readAsArrayBuffer(e);
          });
        } else {
          var c = new XMLHttpRequest();
          c.onload = function () {
            if (200 != this.status && 0 !== this.status) throw "Could not load image";
            a(c.response), c = null;
          }, c.open("GET", e.src, !0), c.responseType = "arraybuffer", c.send(null);
        }
      } else if (window.FileReader && (e instanceof window.Blob || e instanceof window.File)) {
        var h = new FileReader();
        h.onload = function (e) {
          u && console.log("Got file of length " + e.target.result.byteLength), a(e.target.result);
        }, h.readAsArrayBuffer(e);
      }
    }
    function s(e) {
      var t = new DataView(e);
      if (u && console.log("Got file of length " + e.byteLength), 255 != t.getUint8(0) || 216 != t.getUint8(1)) return u && console.log("Not a valid JPEG"), !1;
      for (var i, r = 2, s = e.byteLength; s > r;) {
        if (255 != t.getUint8(r)) return u && console.log("Not a valid marker at offset " + r + ", found: " + t.getUint8(r)), !1;
        if (i = t.getUint8(r + 1), u && console.log(i), 225 == i) return u && console.log("Found 0xFFE1 marker"), l(t, r + 4, t.getUint16(r + 2) - 2);
        r += 2 + t.getUint16(r + 2);
      }
    }
    function o(e) {
      var t = new DataView(e);
      if (u && console.log("Got file of length " + e.byteLength), 255 != t.getUint8(0) || 216 != t.getUint8(1)) return u && console.log("Not a valid JPEG"), !1;
      for (var i = 2, r = e.byteLength, s = function (e, t) {
          return 56 === e.getUint8(t) && 66 === e.getUint8(t + 1) && 73 === e.getUint8(t + 2) && 77 === e.getUint8(t + 3) && 4 === e.getUint8(t + 4) && 4 === e.getUint8(t + 5);
        }; r > i;) {
        if (s(t, i)) {
          var o = t.getUint8(i + 7);
          o % 2 !== 0 && (o += 1), 0 === o && (o = 4);
          var n = i + 8 + o,
            h = t.getUint16(i + 6 + o);
          return a(e, n, h);
        }
        i++;
      }
    }
    function a(e, t, i) {
      for (var r, s, o, a, n, h = new DataView(e), l = {}, u = t; t + i > u;) 28 === h.getUint8(u) && 2 === h.getUint8(u + 1) && (a = h.getUint8(u + 2), a in _ && (o = h.getInt16(u + 3), n = o + 5, s = _[a], r = c(h, u + 5, o), l.hasOwnProperty(s) ? l[s] instanceof Array ? l[s].push(r) : l[s] = [l[s], r] : l[s] = r)), u++;
      return l;
    }
    function n(e, t, i, r, s) {
      var o,
        a,
        n,
        c = e.getUint16(i, !s),
        l = {};
      for (n = 0; c > n; n++) o = i + 12 * n + 2, a = r[e.getUint16(o, !s)], !a && u && console.log("Unknown tag: " + e.getUint16(o, !s)), l[a] = h(e, o, t, i, s);
      return l;
    }
    function h(e, t, i, r, s) {
      var o,
        a,
        n,
        h,
        l,
        u,
        g = e.getUint16(t + 2, !s),
        d = e.getUint32(t + 4, !s),
        f = e.getUint32(t + 8, !s) + i;
      switch (g) {
        case 1:
        case 7:
          if (1 == d) return e.getUint8(t + 8, !s);
          for (o = d > 4 ? f : t + 8, a = [], h = 0; d > h; h++) a[h] = e.getUint8(o + h);
          return a;
        case 2:
          return o = d > 4 ? f : t + 8, c(e, o, d - 1);
        case 3:
          if (1 == d) return e.getUint16(t + 8, !s);
          for (o = d > 2 ? f : t + 8, a = [], h = 0; d > h; h++) a[h] = e.getUint16(o + 2 * h, !s);
          return a;
        case 4:
          if (1 == d) return e.getUint32(t + 8, !s);
          for (a = [], h = 0; d > h; h++) a[h] = e.getUint32(f + 4 * h, !s);
          return a;
        case 5:
          if (1 == d) return l = e.getUint32(f, !s), u = e.getUint32(f + 4, !s), n = new Number(l / u), n.numerator = l, n.denominator = u, n;
          for (a = [], h = 0; d > h; h++) l = e.getUint32(f + 8 * h, !s), u = e.getUint32(f + 4 + 8 * h, !s), a[h] = new Number(l / u), a[h].numerator = l, a[h].denominator = u;
          return a;
        case 9:
          if (1 == d) return e.getInt32(t + 8, !s);
          for (a = [], h = 0; d > h; h++) a[h] = e.getInt32(f + 4 * h, !s);
          return a;
        case 10:
          if (1 == d) return e.getInt32(f, !s) / e.getInt32(f + 4, !s);
          for (a = [], h = 0; d > h; h++) a[h] = e.getInt32(f + 8 * h, !s) / e.getInt32(f + 4 + 8 * h, !s);
          return a;
      }
    }
    function c(e, t, i) {
      for (var r = "", s = t; t + i > s; s++) r += String.fromCharCode(e.getUint8(s));
      return r;
    }
    function l(e, t) {
      if ("Exif" != c(e, t, 4)) return u && console.log("Not valid EXIF data! " + c(e, t, 4)), !1;
      var i,
        r,
        s,
        o,
        a,
        h = t + 6;
      if (18761 == e.getUint16(h)) i = !1;else {
        if (19789 != e.getUint16(h)) return u && console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"), !1;
        i = !0;
      }
      if (42 != e.getUint16(h + 2, !i)) return u && console.log("Not valid TIFF data! (no 0x002A)"), !1;
      var l = e.getUint32(h + 4, !i);
      if (8 > l) return u && console.log("Not valid TIFF data! (First offset less than 8)", e.getUint32(h + 4, !i)), !1;
      if (r = n(e, h, h + l, d, i), r.ExifIFDPointer) {
        o = n(e, h, h + r.ExifIFDPointer, g, i);
        for (s in o) {
          switch (s) {
            case "LightSource":
            case "Flash":
            case "MeteringMode":
            case "ExposureProgram":
            case "SensingMethod":
            case "SceneCaptureType":
            case "SceneType":
            case "CustomRendered":
            case "WhiteBalance":
            case "GainControl":
            case "Contrast":
            case "Saturation":
            case "Sharpness":
            case "SubjectDistanceRange":
            case "FileSource":
              o[s] = p[s][o[s]];
              break;
            case "ExifVersion":
            case "FlashpixVersion":
              o[s] = String.fromCharCode(o[s][0], o[s][1], o[s][2], o[s][3]);
              break;
            case "ComponentsConfiguration":
              o[s] = p.Components[o[s][0]] + p.Components[o[s][1]] + p.Components[o[s][2]] + p.Components[o[s][3]];
          }
          r[s] = o[s];
        }
      }
      if (r.GPSInfoIFDPointer) {
        a = n(e, h, h + r.GPSInfoIFDPointer, f, i);
        for (s in a) {
          switch (s) {
            case "GPSVersionID":
              a[s] = a[s][0] + "." + a[s][1] + "." + a[s][2] + "." + a[s][3];
          }
          r[s] = a[s];
        }
      }
      return r;
    }
    var u = !1,
      g = this.Tags = {
        36864: "ExifVersion",
        40960: "FlashpixVersion",
        40961: "ColorSpace",
        40962: "PixelXDimension",
        40963: "PixelYDimension",
        37121: "ComponentsConfiguration",
        37122: "CompressedBitsPerPixel",
        37500: "MakerNote",
        37510: "UserComment",
        40964: "RelatedSoundFile",
        36867: "DateTimeOriginal",
        36868: "DateTimeDigitized",
        37520: "SubsecTime",
        37521: "SubsecTimeOriginal",
        37522: "SubsecTimeDigitized",
        33434: "ExposureTime",
        33437: "FNumber",
        34850: "ExposureProgram",
        34852: "SpectralSensitivity",
        34855: "ISOSpeedRatings",
        34856: "OECF",
        37377: "ShutterSpeedValue",
        37378: "ApertureValue",
        37379: "BrightnessValue",
        37380: "ExposureBias",
        37381: "MaxApertureValue",
        37382: "SubjectDistance",
        37383: "MeteringMode",
        37384: "LightSource",
        37385: "Flash",
        37396: "SubjectArea",
        37386: "FocalLength",
        41483: "FlashEnergy",
        41484: "SpatialFrequencyResponse",
        41486: "FocalPlaneXResolution",
        41487: "FocalPlaneYResolution",
        41488: "FocalPlaneResolutionUnit",
        41492: "SubjectLocation",
        41493: "ExposureIndex",
        41495: "SensingMethod",
        41728: "FileSource",
        41729: "SceneType",
        41730: "CFAPattern",
        41985: "CustomRendered",
        41986: "ExposureMode",
        41987: "WhiteBalance",
        41988: "DigitalZoomRation",
        41989: "FocalLengthIn35mmFilm",
        41990: "SceneCaptureType",
        41991: "GainControl",
        41992: "Contrast",
        41993: "Saturation",
        41994: "Sharpness",
        41995: "DeviceSettingDescription",
        41996: "SubjectDistanceRange",
        40965: "InteroperabilityIFDPointer",
        42016: "ImageUniqueID"
      },
      d = this.TiffTags = {
        256: "ImageWidth",
        257: "ImageHeight",
        34665: "ExifIFDPointer",
        34853: "GPSInfoIFDPointer",
        40965: "InteroperabilityIFDPointer",
        258: "BitsPerSample",
        259: "Compression",
        262: "PhotometricInterpretation",
        274: "Orientation",
        277: "SamplesPerPixel",
        284: "PlanarConfiguration",
        530: "YCbCrSubSampling",
        531: "YCbCrPositioning",
        282: "XResolution",
        283: "YResolution",
        296: "ResolutionUnit",
        273: "StripOffsets",
        278: "RowsPerStrip",
        279: "StripByteCounts",
        513: "JPEGInterchangeFormat",
        514: "JPEGInterchangeFormatLength",
        301: "TransferFunction",
        318: "WhitePoint",
        319: "PrimaryChromaticities",
        529: "YCbCrCoefficients",
        532: "ReferenceBlackWhite",
        306: "DateTime",
        270: "ImageDescription",
        271: "Make",
        272: "Model",
        305: "Software",
        315: "Artist",
        33432: "Copyright"
      },
      f = this.GPSTags = {
        0: "GPSVersionID",
        1: "GPSLatitudeRef",
        2: "GPSLatitude",
        3: "GPSLongitudeRef",
        4: "GPSLongitude",
        5: "GPSAltitudeRef",
        6: "GPSAltitude",
        7: "GPSTimeStamp",
        8: "GPSSatellites",
        9: "GPSStatus",
        10: "GPSMeasureMode",
        11: "GPSDOP",
        12: "GPSSpeedRef",
        13: "GPSSpeed",
        14: "GPSTrackRef",
        15: "GPSTrack",
        16: "GPSImgDirectionRef",
        17: "GPSImgDirection",
        18: "GPSMapDatum",
        19: "GPSDestLatitudeRef",
        20: "GPSDestLatitude",
        21: "GPSDestLongitudeRef",
        22: "GPSDestLongitude",
        23: "GPSDestBearingRef",
        24: "GPSDestBearing",
        25: "GPSDestDistanceRef",
        26: "GPSDestDistance",
        27: "GPSProcessingMethod",
        28: "GPSAreaInformation",
        29: "GPSDateStamp",
        30: "GPSDifferential"
      },
      p = this.StringValues = {
        ExposureProgram: {
          0: "Not defined",
          1: "Manual",
          2: "Normal program",
          3: "Aperture priority",
          4: "Shutter priority",
          5: "Creative program",
          6: "Action program",
          7: "Portrait mode",
          8: "Landscape mode"
        },
        MeteringMode: {
          0: "Unknown",
          1: "Average",
          2: "CenterWeightedAverage",
          3: "Spot",
          4: "MultiSpot",
          5: "Pattern",
          6: "Partial",
          255: "Other"
        },
        LightSource: {
          0: "Unknown",
          1: "Daylight",
          2: "Fluorescent",
          3: "Tungsten (incandescent light)",
          4: "Flash",
          9: "Fine weather",
          10: "Cloudy weather",
          11: "Shade",
          12: "Daylight fluorescent (D 5700 - 7100K)",
          13: "Day white fluorescent (N 4600 - 5400K)",
          14: "Cool white fluorescent (W 3900 - 4500K)",
          15: "White fluorescent (WW 3200 - 3700K)",
          17: "Standard light A",
          18: "Standard light B",
          19: "Standard light C",
          20: "D55",
          21: "D65",
          22: "D75",
          23: "D50",
          24: "ISO studio tungsten",
          255: "Other"
        },
        Flash: {
          0: "Flash did not fire",
          1: "Flash fired",
          5: "Strobe return light not detected",
          7: "Strobe return light detected",
          9: "Flash fired, compulsory flash mode",
          13: "Flash fired, compulsory flash mode, return light not detected",
          15: "Flash fired, compulsory flash mode, return light detected",
          16: "Flash did not fire, compulsory flash mode",
          24: "Flash did not fire, auto mode",
          25: "Flash fired, auto mode",
          29: "Flash fired, auto mode, return light not detected",
          31: "Flash fired, auto mode, return light detected",
          32: "No flash function",
          65: "Flash fired, red-eye reduction mode",
          69: "Flash fired, red-eye reduction mode, return light not detected",
          71: "Flash fired, red-eye reduction mode, return light detected",
          73: "Flash fired, compulsory flash mode, red-eye reduction mode",
          77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
          79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
          89: "Flash fired, auto mode, red-eye reduction mode",
          93: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
          95: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
          1: "Not defined",
          2: "One-chip color area sensor",
          3: "Two-chip color area sensor",
          4: "Three-chip color area sensor",
          5: "Color sequential area sensor",
          7: "Trilinear sensor",
          8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
          0: "Standard",
          1: "Landscape",
          2: "Portrait",
          3: "Night scene"
        },
        SceneType: {
          1: "Directly photographed"
        },
        CustomRendered: {
          0: "Normal process",
          1: "Custom process"
        },
        WhiteBalance: {
          0: "Auto white balance",
          1: "Manual white balance"
        },
        GainControl: {
          0: "None",
          1: "Low gain up",
          2: "High gain up",
          3: "Low gain down",
          4: "High gain down"
        },
        Contrast: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        Saturation: {
          0: "Normal",
          1: "Low saturation",
          2: "High saturation"
        },
        Sharpness: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        SubjectDistanceRange: {
          0: "Unknown",
          1: "Macro",
          2: "Close view",
          3: "Distant view"
        },
        FileSource: {
          3: "DSC"
        },
        Components: {
          0: "",
          1: "Y",
          2: "Cb",
          3: "Cr",
          4: "R",
          5: "G",
          6: "B"
        }
      },
      _ = {
        120: "caption",
        110: "credit",
        25: "keywords",
        55: "dateCreated",
        80: "byline",
        85: "bylineTitle",
        122: "captionWriter",
        105: "headline",
        116: "copyright",
        15: "category"
      };
    this.getData = function (t, i) {
      return (t instanceof Image || t instanceof HTMLImageElement) && !t.complete ? !1 : (e(t) ? i && i.call(t) : r(t, i), !0);
    }, this.getTag = function (t, i) {
      return e(t) ? t.exifdata[i] : void 0;
    }, this.getAllTags = function (t) {
      if (!e(t)) return {};
      var i,
        r = t.exifdata,
        s = {};
      for (i in r) r.hasOwnProperty(i) && (s[i] = r[i]);
      return s;
    }, this.pretty = function (t) {
      if (!e(t)) return "";
      var i,
        r = t.exifdata,
        s = "";
      for (i in r) r.hasOwnProperty(i) && (s += "object" == typeof r[i] ? r[i] instanceof Number ? i + " : " + r[i] + " [" + r[i].numerator + "/" + r[i].denominator + "]\r\n" : i + " : [" + r[i].length + " values]\r\n" : i + " : " + r[i] + "\r\n");
      return s;
    }, this.readFromBinaryFile = function (e) {
      return s(e);
    };
  }]), e.factory("cropHost", ["$document", "cropAreaCircle", "cropAreaSquare", "cropEXIF", function (e, t, i, r) {
    var s = function (e) {
      var t = e.getBoundingClientRect(),
        i = document.body,
        r = document.documentElement,
        s = window.pageYOffset || r.scrollTop || i.scrollTop,
        o = window.pageXOffset || r.scrollLeft || i.scrollLeft,
        a = r.clientTop || i.clientTop || 0,
        n = r.clientLeft || i.clientLeft || 0,
        h = t.top + s - a,
        c = t.left + o - n;
      return {
        top: Math.round(h),
        left: Math.round(c)
      };
    };
    return function (o, a, n) {
      function h() {
        c.clearRect(0, 0, c.canvas.width, c.canvas.height), null !== l && (c.drawImage(l, 0, 0, c.canvas.width, c.canvas.height), c.save(), c.fillStyle = "rgba(0, 0, 0, 0.65)", c.fillRect(0, 0, c.canvas.width, c.canvas.height), c.restore(), u.draw());
      }
      var c = null,
        l = null,
        u = null,
        g = [100, 100],
        d = [300, 300],
        f = 200,
        p = "image/png",
        _ = null,
        m = function () {
          if (null !== l) {
            u.setImage(l);
            var e = [l.width, l.height],
              t = l.width / l.height,
              i = e;
            i[0] > d[0] ? (i[0] = d[0], i[1] = i[0] / t) : i[0] < g[0] && (i[0] = g[0], i[1] = i[0] / t), i[1] > d[1] ? (i[1] = d[1], i[0] = i[1] * t) : i[1] < g[1] && (i[1] = g[1], i[0] = i[1] * t), o.prop("width", i[0]).prop("height", i[1]).css({
              "margin-left": -i[0] / 2 + "px",
              "margin-top": -i[1] / 2 + "px"
            }), u.setX(c.canvas.width / 2), u.setY(c.canvas.height / 2), u.setSize(Math.min(200, c.canvas.width / 2, c.canvas.height / 2));
          } else o.prop("width", 0).prop("height", 0).css({
            "margin-top": 0
          });
          h();
        },
        v = function (e) {
          return angular.isDefined(e.changedTouches) ? e.changedTouches : e.originalEvent.changedTouches;
        },
        S = function (e) {
          if (null !== l) {
            var t,
              i,
              r = s(c.canvas);
            "touchmove" === e.type ? (t = v(e)[0].pageX, i = v(e)[0].pageY) : (t = e.pageX, i = e.pageY), u.processMouseMove(t - r.left, i - r.top), h();
          }
        },
        z = function (e) {
          if (e.preventDefault(), e.stopPropagation(), null !== l) {
            var t,
              i,
              r = s(c.canvas);
            "touchstart" === e.type ? (t = v(e)[0].pageX, i = v(e)[0].pageY) : (t = e.pageX, i = e.pageY), u.processMouseDown(t - r.left, i - r.top), h();
          }
        },
        I = function (e) {
          if (null !== l) {
            var t,
              i,
              r = s(c.canvas);
            "touchend" === e.type ? (t = v(e)[0].pageX, i = v(e)[0].pageY) : (t = e.pageX, i = e.pageY), u.processMouseUp(t - r.left, i - r.top), h();
          }
        };
      this.getResultImageDataURI = function () {
        var e, t;
        return t = angular.element("<canvas></canvas>")[0], e = t.getContext("2d"), t.width = f, t.height = f, null !== l && e.drawImage(l, (u.getX() - u.getSize() / 2) * (l.width / c.canvas.width), (u.getY() - u.getSize() / 2) * (l.height / c.canvas.height), u.getSize() * (l.width / c.canvas.width), u.getSize() * (l.height / c.canvas.height), 0, 0, f, f), null !== _ ? t.toDataURL(p, _) : t.toDataURL(p);
      }, this.setNewImageSource = function (e) {
        if (l = null, m(), n.trigger("image-updated"), e) {
          var t = new Image();
          "http" === e.substring(0, 4).toLowerCase() && (t.crossOrigin = "anonymous"), t.onload = function () {
            n.trigger("load-done"), r.getData(t, function () {
              var e = r.getTag(t, "Orientation");
              if ([3, 6, 8].indexOf(e) > -1) {
                var i = document.createElement("canvas"),
                  s = i.getContext("2d"),
                  o = t.width,
                  a = t.height,
                  h = 0,
                  c = 0,
                  u = 0;
                switch (e) {
                  case 3:
                    h = -t.width, c = -t.height, u = 180;
                    break;
                  case 6:
                    o = t.height, a = t.width, c = -t.height, u = 90;
                    break;
                  case 8:
                    o = t.height, a = t.width, h = -t.width, u = 270;
                }
                i.width = o, i.height = a, s.rotate(u * Math.PI / 180), s.drawImage(t, h, c), l = new Image(), l.src = i.toDataURL("image/png");
              } else l = t;
              m(), n.trigger("image-updated");
            });
          }, t.onerror = function () {
            n.trigger("load-error");
          }, n.trigger("load-start"), t.src = e;
        }
      }, this.setMaxDimensions = function (e, t) {
        if (d = [e, t], null !== l) {
          var i = c.canvas.width,
            r = c.canvas.height,
            s = [l.width, l.height],
            a = l.width / l.height,
            n = s;
          n[0] > d[0] ? (n[0] = d[0], n[1] = n[0] / a) : n[0] < g[0] && (n[0] = g[0], n[1] = n[0] / a), n[1] > d[1] ? (n[1] = d[1], n[0] = n[1] * a) : n[1] < g[1] && (n[1] = g[1], n[0] = n[1] * a), o.prop("width", n[0]).prop("height", n[1]).css({
            "margin-left": -n[0] / 2 + "px",
            "margin-top": -n[1] / 2 + "px"
          });
          var f = c.canvas.width / i,
            p = c.canvas.height / r,
            _ = Math.min(f, p);
          u.setX(u.getX() * f), u.setY(u.getY() * p), u.setSize(u.getSize() * _);
        } else o.prop("width", 0).prop("height", 0).css({
          "margin-top": 0
        });
        h();
      }, this.setAreaMinSize = function (e) {
        e = parseInt(e, 10), isNaN(e) || (u.setMinSize(e), h());
      }, this.setResultImageSize = function (e) {
        e = parseInt(e, 10), isNaN(e) || (f = e);
      }, this.setResultImageFormat = function (e) {
        p = e;
      }, this.setResultImageQuality = function (e) {
        e = parseFloat(e), !isNaN(e) && e >= 0 && 1 >= e && (_ = e);
      }, this.setAreaType = function (e) {
        var r = u.getSize(),
          s = u.getMinSize(),
          o = u.getX(),
          a = u.getY(),
          g = t;
        "square" === e && (g = i), u = new g(c, n), u.setMinSize(s), u.setSize(r), u.setX(o), u.setY(a), null !== l && u.setImage(l), h();
      }, c = o[0].getContext("2d"), u = new t(c, n), e.on("mousemove", S), o.on("mousedown", z), e.on("mouseup", I), e.on("touchmove", S), o.on("touchstart", z), e.on("touchend", I), this.destroy = function () {
        e.off("mousemove", S), o.off("mousedown", z), e.off("mouseup", S), e.off("touchmove", S), o.off("touchstart", z), e.off("touchend", S), o.remove();
      };
    };
  }]), e.factory("cropPubSub", [function () {
    return function () {
      var e = {};
      this.on = function (t, i) {
        return t.split(" ").forEach(function (t) {
          e[t] || (e[t] = []), e[t].push(i);
        }), this;
      }, this.trigger = function (t, i) {
        return angular.forEach(e[t], function (e) {
          e.call(null, i);
        }), this;
      };
    };
  }]), e.directive("imgCrop", ["$timeout", "cropHost", "cropPubSub", function (e, t, i) {
    return {
      restrict: "E",
      scope: {
        image: "=",
        resultImage: "=",
        changeOnFly: "=",
        areaType: "@",
        areaMinSize: "=",
        resultImageSize: "=",
        resultImageFormat: "@",
        resultImageQuality: "=",
        onChange: "&",
        onLoadBegin: "&",
        onLoadDone: "&",
        onLoadError: "&"
      },
      template: "<canvas></canvas>",
      controller: ["$scope", function (e) {
        e.events = new i();
      }],
      link: function (i, r) {
        var s,
          o = i.events,
          a = new t(r.find("canvas"), {}, o),
          n = function (e) {
            var t = a.getResultImageDataURI();
            s !== t && (s = t, angular.isDefined(e.resultImage) && (e.resultImage = t), e.onChange({
              $dataURI: e.resultImage
            }));
          },
          h = function (t) {
            return function () {
              e(function () {
                i.$apply(function (e) {
                  t(e);
                });
              });
            };
          };
        o.on("load-start", h(function (e) {
          e.onLoadBegin({});
        })).on("load-done", h(function (e) {
          e.onLoadDone({});
        })).on("load-error", h(function (e) {
          e.onLoadError({});
        })).on("area-move area-resize", h(function (e) {
          e.changeOnFly && n(e);
        })).on("area-move-end area-resize-end image-updated", h(function (e) {
          n(e);
        })), i.$watch("image", function () {
          a.setNewImageSource(i.image);
        }), i.$watch("areaType", function () {
          a.setAreaType(i.areaType), n(i);
        }), i.$watch("areaMinSize", function () {
          a.setAreaMinSize(i.areaMinSize), n(i);
        }), i.$watch("resultImageSize", function () {
          a.setResultImageSize(i.resultImageSize), n(i);
        }), i.$watch("resultImageFormat", function () {
          a.setResultImageFormat(i.resultImageFormat), n(i);
        }), i.$watch("resultImageQuality", function () {
          a.setResultImageQuality(i.resultImageQuality), n(i);
        }), i.$watch(function () {
          return [r[0].clientWidth, r[0].clientHeight];
        }, function (e) {
          a.setMaxDimensions(e[0], e[1]), n(i);
        }, !0), i.$on("$destroy", function () {
          a.destroy();
        });
      }
    };
  }]);
}();
/** vim: et:ts=4:sw=4:sts=4
 * @license RequireJS 2.1.22 Copyright (c) 2010-2015, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/requirejs for details
 */
//Not using strict: uneven strict support in browsers, #392, and causes
//problems with requirejs.exec()/transpiler plugins that may not be strict.
/*jslint regexp: true, nomen: true, sloppy: true */
/*global window, navigator, document, importScripts, setTimeout, opera */

var requirejs, require, define;
(function (global) {
  var req,
    s,
    head,
    baseElement,
    dataMain,
    src,
    interactiveScript,
    currentlyAddingScript,
    mainScript,
    subPath,
    version = '2.1.22',
    commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,
    cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
    jsSuffixRegExp = /\.js$/,
    currDirRegExp = /^\.\//,
    op = Object.prototype,
    ostring = op.toString,
    hasOwn = op.hasOwnProperty,
    ap = Array.prototype,
    isBrowser = !!(typeof window !== 'undefined' && typeof navigator !== 'undefined' && window.document),
    isWebWorker = !isBrowser && typeof importScripts !== 'undefined',
    //PS3 indicates loaded and complete, but need to wait for complete
    //specifically. Sequence is 'loading', 'loaded', execution,
    // then 'complete'. The UA check is unfortunate, but not sure how
    //to feature test w/o causing perf issues.
    readyRegExp = isBrowser && navigator.platform === 'PLAYSTATION 3' ? /^complete$/ : /^(complete|loaded)$/,
    defContextName = '_',
    //Oh the tragedy, detecting opera. See the usage of isOpera for reason.
    isOpera = typeof opera !== 'undefined' && opera.toString() === '[object Opera]',
    contexts = {},
    cfg = {},
    globalDefQueue = [],
    useInteractive = false;
  function isFunction(it) {
    return ostring.call(it) === '[object Function]';
  }
  function isArray(it) {
    return ostring.call(it) === '[object Array]';
  }

  /**
   * Helper function for iterating over an array. If the func returns
   * a true value, it will break out of the loop.
   */
  function each(ary, func) {
    if (ary) {
      var i;
      for (i = 0; i < ary.length; i += 1) {
        if (ary[i] && func(ary[i], i, ary)) {
          break;
        }
      }
    }
  }

  /**
   * Helper function for iterating over an array backwards. If the func
   * returns a true value, it will break out of the loop.
   */
  function eachReverse(ary, func) {
    if (ary) {
      var i;
      for (i = ary.length - 1; i > -1; i -= 1) {
        if (ary[i] && func(ary[i], i, ary)) {
          break;
        }
      }
    }
  }
  function hasProp(obj, prop) {
    return hasOwn.call(obj, prop);
  }
  function getOwn(obj, prop) {
    return hasProp(obj, prop) && obj[prop];
  }

  /**
   * Cycles over properties in an object and calls a function for each
   * property value. If the function returns a truthy value, then the
   * iteration is stopped.
   */
  function eachProp(obj, func) {
    var prop;
    for (prop in obj) {
      if (hasProp(obj, prop)) {
        if (func(obj[prop], prop)) {
          break;
        }
      }
    }
  }

  /**
   * Simple function to mix in properties from source into target,
   * but only if target does not already have a property of the same name.
   */
  function mixin(target, source, force, deepStringMixin) {
    if (source) {
      eachProp(source, function (value, prop) {
        if (force || !hasProp(target, prop)) {
          if (deepStringMixin && typeof value === 'object' && value && !isArray(value) && !isFunction(value) && !(value instanceof RegExp)) {
            if (!target[prop]) {
              target[prop] = {};
            }
            mixin(target[prop], value, force, deepStringMixin);
          } else {
            target[prop] = value;
          }
        }
      });
    }
    return target;
  }

  //Similar to Function.prototype.bind, but the 'this' object is specified
  //first, since it is easier to read/figure out what 'this' will be.
  function bind(obj, fn) {
    return function () {
      return fn.apply(obj, arguments);
    };
  }
  function scripts() {
    return document.getElementsByTagName('script');
  }
  function defaultOnError(err) {
    throw err;
  }

  //Allow getting a global that is expressed in
  //dot notation, like 'a.b.c'.
  function getGlobal(value) {
    if (!value) {
      return value;
    }
    var g = global;
    each(value.split('.'), function (part) {
      g = g[part];
    });
    return g;
  }

  /**
   * Constructs an error with a pointer to an URL with more information.
   * @param {String} id the error ID that maps to an ID on a web page.
   * @param {String} message human readable error.
   * @param {Error} [err] the original error, if there is one.
   *
   * @returns {Error}
   */
  function makeError(id, msg, err, requireModules) {
    var e = new Error(msg + '\nhttp://requirejs.org/docs/errors.html#' + id);
    e.requireType = id;
    e.requireModules = requireModules;
    if (err) {
      e.originalError = err;
    }
    return e;
  }
  if (typeof define !== 'undefined') {
    //If a define is already in play via another AMD loader,
    //do not overwrite.
    return;
  }
  if (typeof requirejs !== 'undefined') {
    if (isFunction(requirejs)) {
      //Do not overwrite an existing requirejs instance.
      return;
    }
    cfg = requirejs;
    requirejs = undefined;
  }

  //Allow for a require config object
  if (typeof require !== 'undefined' && !isFunction(require)) {
    //assume it is a config object.
    cfg = require;
    require = undefined;
  }
  function newContext(contextName) {
    var inCheckLoaded,
      Module,
      context,
      handlers,
      checkLoadedTimeoutId,
      config = {
        //Defaults. Do not set a default for map
        //config to speed up normalize(), which
        //will run faster if there is no default.
        waitSeconds: 7,
        baseUrl: './',
        paths: {},
        bundles: {},
        pkgs: {},
        shim: {},
        config: {}
      },
      registry = {},
      //registry of just enabled modules, to speed
      //cycle breaking code when lots of modules
      //are registered, but not activated.
      enabledRegistry = {},
      undefEvents = {},
      defQueue = [],
      defined = {},
      urlFetched = {},
      bundlesMap = {},
      requireCounter = 1,
      unnormalizedCounter = 1;

    /**
     * Trims the . and .. from an array of path segments.
     * It will keep a leading path segment if a .. will become
     * the first path segment, to help with module name lookups,
     * which act like paths, but can be remapped. But the end result,
     * all paths that use this function should look normalized.
     * NOTE: this method MODIFIES the input array.
     * @param {Array} ary the array of path segments.
     */
    function trimDots(ary) {
      var i, part;
      for (i = 0; i < ary.length; i++) {
        part = ary[i];
        if (part === '.') {
          ary.splice(i, 1);
          i -= 1;
        } else if (part === '..') {
          // If at the start, or previous value is still ..,
          // keep them so that when converted to a path it may
          // still work when converted to a path, even though
          // as an ID it is less than ideal. In larger point
          // releases, may be better to just kick out an error.
          if (i === 0 || i === 1 && ary[2] === '..' || ary[i - 1] === '..') {
            continue;
          } else if (i > 0) {
            ary.splice(i - 1, 2);
            i -= 2;
          }
        }
      }
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @param {Boolean} applyMap apply the map config to the value. Should
     * only be done if this normalization is for a dependency ID.
     * @returns {String} normalized name
     */
    function normalize(name, baseName, applyMap) {
      var pkgMain,
        mapValue,
        nameParts,
        i,
        j,
        nameSegment,
        lastIndex,
        foundMap,
        foundI,
        foundStarMap,
        starI,
        normalizedBaseParts,
        baseParts = baseName && baseName.split('/'),
        map = config.map,
        starMap = map && map['*'];

      //Adjust any relative paths.
      if (name) {
        name = name.split('/');
        lastIndex = name.length - 1;

        // If wanting node ID compatibility, strip .js from end
        // of IDs. Have to do this here, and not in nameToUrl
        // because node allows either .js or non .js to map
        // to same file.
        if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
          name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
        }

        // Starts with a '.' so need the baseName
        if (name[0].charAt(0) === '.' && baseParts) {
          //Convert baseName to array, and lop off the last part,
          //so that . matches that 'directory' and not name of the baseName's
          //module. For instance, baseName of 'one/two/three', maps to
          //'one/two/three.js', but we want the directory, 'one/two' for
          //this normalization.
          normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
          name = normalizedBaseParts.concat(name);
        }
        trimDots(name);
        name = name.join('/');
      }

      //Apply map config if available.
      if (applyMap && map && (baseParts || starMap)) {
        nameParts = name.split('/');
        outerLoop: for (i = nameParts.length; i > 0; i -= 1) {
          nameSegment = nameParts.slice(0, i).join('/');
          if (baseParts) {
            //Find the longest baseName segment match in the config.
            //So, do joins on the biggest to smallest lengths of baseParts.
            for (j = baseParts.length; j > 0; j -= 1) {
              mapValue = getOwn(map, baseParts.slice(0, j).join('/'));

              //baseName segment has config, find if it has one for
              //this name.
              if (mapValue) {
                mapValue = getOwn(mapValue, nameSegment);
                if (mapValue) {
                  //Match, update name to the new value.
                  foundMap = mapValue;
                  foundI = i;
                  break outerLoop;
                }
              }
            }
          }

          //Check for a star map match, but just hold on to it,
          //if there is a shorter segment match later in a matching
          //config, then favor over this star map.
          if (!foundStarMap && starMap && getOwn(starMap, nameSegment)) {
            foundStarMap = getOwn(starMap, nameSegment);
            starI = i;
          }
        }
        if (!foundMap && foundStarMap) {
          foundMap = foundStarMap;
          foundI = starI;
        }
        if (foundMap) {
          nameParts.splice(0, foundI, foundMap);
          name = nameParts.join('/');
        }
      }

      // If the name points to a package's name, use
      // the package main instead.
      pkgMain = getOwn(config.pkgs, name);
      return pkgMain ? pkgMain : name;
    }
    function removeScript(name) {
      if (isBrowser) {
        each(scripts(), function (scriptNode) {
          if (scriptNode.getAttribute('data-requiremodule') === name && scriptNode.getAttribute('data-requirecontext') === context.contextName) {
            scriptNode.parentNode.removeChild(scriptNode);
            return true;
          }
        });
      }
    }
    function hasPathFallback(id) {
      var pathConfig = getOwn(config.paths, id);
      if (pathConfig && isArray(pathConfig) && pathConfig.length > 1) {
        //Pop off the first array value, since it failed, and
        //retry
        pathConfig.shift();
        context.require.undef(id);

        //Custom require that does not do map translation, since
        //ID is "absolute", already mapped/resolved.
        context.makeRequire(null, {
          skipMap: true
        })([id]);
        return true;
      }
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
      var prefix,
        index = name ? name.indexOf('!') : -1;
      if (index > -1) {
        prefix = name.substring(0, index);
        name = name.substring(index + 1, name.length);
      }
      return [prefix, name];
    }

    /**
     * Creates a module mapping that includes plugin prefix, module
     * name, and path. If parentModuleMap is provided it will
     * also normalize the name via require.normalize()
     *
     * @param {String} name the module name
     * @param {String} [parentModuleMap] parent module map
     * for the module name, used to resolve relative names.
     * @param {Boolean} isNormalized: is the ID already normalized.
     * This is true if this call is done for a define() module ID.
     * @param {Boolean} applyMap: apply the map config to the ID.
     * Should only be true if this map is for a dependency.
     *
     * @returns {Object}
     */
    function makeModuleMap(name, parentModuleMap, isNormalized, applyMap) {
      var url,
        pluginModule,
        suffix,
        nameParts,
        prefix = null,
        parentName = parentModuleMap ? parentModuleMap.name : null,
        originalName = name,
        isDefine = true,
        normalizedName = '';

      //If no name, then it means it is a require call, generate an
      //internal name.
      if (!name) {
        isDefine = false;
        name = '_@r' + (requireCounter += 1);
      }
      nameParts = splitPrefix(name);
      prefix = nameParts[0];
      name = nameParts[1];
      if (prefix) {
        prefix = normalize(prefix, parentName, applyMap);
        pluginModule = getOwn(defined, prefix);
      }

      //Account for relative paths if there is a base name.
      if (name) {
        if (prefix) {
          if (pluginModule && pluginModule.normalize) {
            //Plugin is loaded, use its normalize method.
            normalizedName = pluginModule.normalize(name, function (name) {
              return normalize(name, parentName, applyMap);
            });
          } else {
            // If nested plugin references, then do not try to
            // normalize, as it will not normalize correctly. This
            // places a restriction on resourceIds, and the longer
            // term solution is not to normalize until plugins are
            // loaded and all normalizations to allow for async
            // loading of a loader plugin. But for now, fixes the
            // common uses. Details in #1131
            normalizedName = name.indexOf('!') === -1 ? normalize(name, parentName, applyMap) : name;
          }
        } else {
          //A regular module.
          normalizedName = normalize(name, parentName, applyMap);

          //Normalized name may be a plugin ID due to map config
          //application in normalize. The map config values must
          //already be normalized, so do not need to redo that part.
          nameParts = splitPrefix(normalizedName);
          prefix = nameParts[0];
          normalizedName = nameParts[1];
          isNormalized = true;
          url = context.nameToUrl(normalizedName);
        }
      }

      //If the id is a plugin id that cannot be determined if it needs
      //normalization, stamp it with a unique ID so two matching relative
      //ids that may conflict can be separate.
      suffix = prefix && !pluginModule && !isNormalized ? '_unnormalized' + (unnormalizedCounter += 1) : '';
      return {
        prefix: prefix,
        name: normalizedName,
        parentMap: parentModuleMap,
        unnormalized: !!suffix,
        url: url,
        originalName: originalName,
        isDefine: isDefine,
        id: (prefix ? prefix + '!' + normalizedName : normalizedName) + suffix
      };
    }
    function getModule(depMap) {
      var id = depMap.id,
        mod = getOwn(registry, id);
      if (!mod) {
        mod = registry[id] = new context.Module(depMap);
      }
      return mod;
    }
    function on(depMap, name, fn) {
      var id = depMap.id,
        mod = getOwn(registry, id);
      if (hasProp(defined, id) && (!mod || mod.defineEmitComplete)) {
        if (name === 'defined') {
          fn(defined[id]);
        }
      } else {
        mod = getModule(depMap);
        if (mod.error && name === 'error') {
          fn(mod.error);
        } else {
          mod.on(name, fn);
        }
      }
    }
    function onError(err, errback) {
      var ids = err.requireModules,
        notified = false;
      if (errback) {
        errback(err);
      } else {
        each(ids, function (id) {
          var mod = getOwn(registry, id);
          if (mod) {
            //Set error on module, so it skips timeout checks.
            mod.error = err;
            if (mod.events.error) {
              notified = true;
              mod.emit('error', err);
            }
          }
        });
        if (!notified) {
          req.onError(err);
        }
      }
    }

    /**
     * Internal method to transfer globalQueue items to this context's
     * defQueue.
     */
    function takeGlobalQueue() {
      //Push all the globalDefQueue items into the context's defQueue
      if (globalDefQueue.length) {
        each(globalDefQueue, function (queueItem) {
          var id = queueItem[0];
          if (typeof id === 'string') {
            context.defQueueMap[id] = true;
          }
          defQueue.push(queueItem);
        });
        globalDefQueue = [];
      }
    }
    handlers = {
      'require': function (mod) {
        if (mod.require) {
          return mod.require;
        } else {
          return mod.require = context.makeRequire(mod.map);
        }
      },
      'exports': function (mod) {
        mod.usingExports = true;
        if (mod.map.isDefine) {
          if (mod.exports) {
            return defined[mod.map.id] = mod.exports;
          } else {
            return mod.exports = defined[mod.map.id] = {};
          }
        }
      },
      'module': function (mod) {
        if (mod.module) {
          return mod.module;
        } else {
          return mod.module = {
            id: mod.map.id,
            uri: mod.map.url,
            config: function () {
              return getOwn(config.config, mod.map.id) || {};
            },
            exports: mod.exports || (mod.exports = {})
          };
        }
      }
    };
    function cleanRegistry(id) {
      //Clean up machinery used for waiting modules.
      delete registry[id];
      delete enabledRegistry[id];
    }
    function breakCycle(mod, traced, processed) {
      var id = mod.map.id;
      if (mod.error) {
        mod.emit('error', mod.error);
      } else {
        traced[id] = true;
        each(mod.depMaps, function (depMap, i) {
          var depId = depMap.id,
            dep = getOwn(registry, depId);

          //Only force things that have not completed
          //being defined, so still in the registry,
          //and only if it has not been matched up
          //in the module already.
          if (dep && !mod.depMatched[i] && !processed[depId]) {
            if (getOwn(traced, depId)) {
              mod.defineDep(i, defined[depId]);
              mod.check(); //pass false?
            } else {
              breakCycle(dep, traced, processed);
            }
          }
        });
        processed[id] = true;
      }
    }
    function checkLoaded() {
      var err,
        usingPathFallback,
        waitInterval = config.waitSeconds * 1000,
        //It is possible to disable the wait interval by using waitSeconds of 0.
        expired = waitInterval && context.startTime + waitInterval < new Date().getTime(),
        noLoads = [],
        reqCalls = [],
        stillLoading = false,
        needCycleCheck = true;

      //Do not bother if this call was a result of a cycle break.
      if (inCheckLoaded) {
        return;
      }
      inCheckLoaded = true;

      //Figure out the state of all the modules.
      eachProp(enabledRegistry, function (mod) {
        var map = mod.map,
          modId = map.id;

        //Skip things that are not enabled or in error state.
        if (!mod.enabled) {
          return;
        }
        if (!map.isDefine) {
          reqCalls.push(mod);
        }
        if (!mod.error) {
          //If the module should be executed, and it has not
          //been inited and time is up, remember it.
          if (!mod.inited && expired) {
            if (hasPathFallback(modId)) {
              usingPathFallback = true;
              stillLoading = true;
            } else {
              noLoads.push(modId);
              removeScript(modId);
            }
          } else if (!mod.inited && mod.fetched && map.isDefine) {
            stillLoading = true;
            if (!map.prefix) {
              //No reason to keep looking for unfinished
              //loading. If the only stillLoading is a
              //plugin resource though, keep going,
              //because it may be that a plugin resource
              //is waiting on a non-plugin cycle.
              return needCycleCheck = false;
            }
          }
        }
      });
      if (expired && noLoads.length) {
        //If wait time expired, throw error of unloaded modules.
        err = makeError('timeout', 'Load timeout for modules: ' + noLoads, null, noLoads);
        err.contextName = context.contextName;
        return onError(err);
      }

      //Not expired, check for a cycle.
      if (needCycleCheck) {
        each(reqCalls, function (mod) {
          breakCycle(mod, {}, {});
        });
      }

      //If still waiting on loads, and the waiting load is something
      //other than a plugin resource, or there are still outstanding
      //scripts, then just try back later.
      if ((!expired || usingPathFallback) && stillLoading) {
        //Something is still waiting to load. Wait for it, but only
        //if a timeout is not already in effect.
        if ((isBrowser || isWebWorker) && !checkLoadedTimeoutId) {
          checkLoadedTimeoutId = setTimeout(function () {
            checkLoadedTimeoutId = 0;
            checkLoaded();
          }, 50);
        }
      }
      inCheckLoaded = false;
    }
    Module = function (map) {
      this.events = getOwn(undefEvents, map.id) || {};
      this.map = map;
      this.shim = getOwn(config.shim, map.id);
      this.depExports = [];
      this.depMaps = [];
      this.depMatched = [];
      this.pluginMaps = {};
      this.depCount = 0;

      /* this.exports this.factory
         this.depMaps = [],
         this.enabled, this.fetched
      */
    };

    Module.prototype = {
      init: function (depMaps, factory, errback, options) {
        options = options || {};

        //Do not do more inits if already done. Can happen if there
        //are multiple define calls for the same module. That is not
        //a normal, common case, but it is also not unexpected.
        if (this.inited) {
          return;
        }
        this.factory = factory;
        if (errback) {
          //Register for errors on this module.
          this.on('error', errback);
        } else if (this.events.error) {
          //If no errback already, but there are error listeners
          //on this module, set up an errback to pass to the deps.
          errback = bind(this, function (err) {
            this.emit('error', err);
          });
        }

        //Do a copy of the dependency array, so that
        //source inputs are not modified. For example
        //"shim" deps are passed in here directly, and
        //doing a direct modification of the depMaps array
        //would affect that config.
        this.depMaps = depMaps && depMaps.slice(0);
        this.errback = errback;

        //Indicate this module has be initialized
        this.inited = true;
        this.ignore = options.ignore;

        //Could have option to init this module in enabled mode,
        //or could have been previously marked as enabled. However,
        //the dependencies are not known until init is called. So
        //if enabled previously, now trigger dependencies as enabled.
        if (options.enabled || this.enabled) {
          //Enable this module and dependencies.
          //Will call this.check()
          this.enable();
        } else {
          this.check();
        }
      },
      defineDep: function (i, depExports) {
        //Because of cycles, defined callback for a given
        //export can be called more than once.
        if (!this.depMatched[i]) {
          this.depMatched[i] = true;
          this.depCount -= 1;
          this.depExports[i] = depExports;
        }
      },
      fetch: function () {
        if (this.fetched) {
          return;
        }
        this.fetched = true;
        context.startTime = new Date().getTime();
        var map = this.map;

        //If the manager is for a plugin managed resource,
        //ask the plugin to load it now.
        if (this.shim) {
          context.makeRequire(this.map, {
            enableBuildCallback: true
          })(this.shim.deps || [], bind(this, function () {
            return map.prefix ? this.callPlugin() : this.load();
          }));
        } else {
          //Regular dependency.
          return map.prefix ? this.callPlugin() : this.load();
        }
      },
      load: function () {
        var url = this.map.url;

        //Regular dependency.
        if (!urlFetched[url]) {
          urlFetched[url] = true;
          context.load(this.map.id, url);
        }
      },
      /**
       * Checks if the module is ready to define itself, and if so,
       * define it.
       */
      check: function () {
        if (!this.enabled || this.enabling) {
          return;
        }
        var err,
          cjsModule,
          id = this.map.id,
          depExports = this.depExports,
          exports = this.exports,
          factory = this.factory;
        if (!this.inited) {
          // Only fetch if not already in the defQueue.
          if (!hasProp(context.defQueueMap, id)) {
            this.fetch();
          }
        } else if (this.error) {
          this.emit('error', this.error);
        } else if (!this.defining) {
          //The factory could trigger another require call
          //that would result in checking this module to
          //define itself again. If already in the process
          //of doing that, skip this work.
          this.defining = true;
          if (this.depCount < 1 && !this.defined) {
            if (isFunction(factory)) {
              try {
                exports = context.execCb(id, factory, depExports, exports);
              } catch (e) {
                err = e;
              }

              // Favor return value over exports. If node/cjs in play,
              // then will not have a return value anyway. Favor
              // module.exports assignment over exports object.
              if (this.map.isDefine && exports === undefined) {
                cjsModule = this.module;
                if (cjsModule) {
                  exports = cjsModule.exports;
                } else if (this.usingExports) {
                  //exports already set the defined value.
                  exports = this.exports;
                }
              }
              if (err) {
                // If there is an error listener, favor passing
                // to that instead of throwing an error. However,
                // only do it for define()'d  modules. require
                // errbacks should not be called for failures in
                // their callbacks (#699). However if a global
                // onError is set, use that.
                if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) {
                  err.requireMap = this.map;
                  err.requireModules = this.map.isDefine ? [this.map.id] : null;
                  err.requireType = this.map.isDefine ? 'define' : 'require';
                  return onError(this.error = err);
                } else if (typeof console !== 'undefined' && console.error) {
                  // Log the error for debugging. If promises could be
                  // used, this would be different, but making do.
                  console.error(err);
                } else {
                  // Do not want to completely lose the error. While this
                  // will mess up processing and lead to similar results
                  // as bug 1440, it at least surfaces the error.
                  req.onError(err);
                }
              }
            } else {
              //Just a literal value
              exports = factory;
            }
            this.exports = exports;
            if (this.map.isDefine && !this.ignore) {
              defined[id] = exports;
              if (req.onResourceLoad) {
                var resLoadMaps = [];
                each(this.depMaps, function (depMap) {
                  resLoadMaps.push(depMap.normalizedMap || depMap);
                });
                req.onResourceLoad(context, this.map, resLoadMaps);
              }
            }

            //Clean up
            cleanRegistry(id);
            this.defined = true;
          }

          //Finished the define stage. Allow calling check again
          //to allow define notifications below in the case of a
          //cycle.
          this.defining = false;
          if (this.defined && !this.defineEmitted) {
            this.defineEmitted = true;
            this.emit('defined', this.exports);
            this.defineEmitComplete = true;
          }
        }
      },
      callPlugin: function () {
        var map = this.map,
          id = map.id,
          //Map already normalized the prefix.
          pluginMap = makeModuleMap(map.prefix);

        //Mark this as a dependency for this plugin, so it
        //can be traced for cycles.
        this.depMaps.push(pluginMap);
        on(pluginMap, 'defined', bind(this, function (plugin) {
          var load,
            normalizedMap,
            normalizedMod,
            bundleId = getOwn(bundlesMap, this.map.id),
            name = this.map.name,
            parentName = this.map.parentMap ? this.map.parentMap.name : null,
            localRequire = context.makeRequire(map.parentMap, {
              enableBuildCallback: true
            });

          //If current map is not normalized, wait for that
          //normalized name to load instead of continuing.
          if (this.map.unnormalized) {
            //Normalize the ID if the plugin allows it.
            if (plugin.normalize) {
              name = plugin.normalize(name, function (name) {
                return normalize(name, parentName, true);
              }) || '';
            }

            //prefix and name should already be normalized, no need
            //for applying map config again either.
            normalizedMap = makeModuleMap(map.prefix + '!' + name, this.map.parentMap);
            on(normalizedMap, 'defined', bind(this, function (value) {
              this.map.normalizedMap = normalizedMap;
              this.init([], function () {
                return value;
              }, null, {
                enabled: true,
                ignore: true
              });
            }));
            normalizedMod = getOwn(registry, normalizedMap.id);
            if (normalizedMod) {
              //Mark this as a dependency for this plugin, so it
              //can be traced for cycles.
              this.depMaps.push(normalizedMap);
              if (this.events.error) {
                normalizedMod.on('error', bind(this, function (err) {
                  this.emit('error', err);
                }));
              }
              normalizedMod.enable();
            }
            return;
          }

          //If a paths config, then just load that file instead to
          //resolve the plugin, as it is built into that paths layer.
          if (bundleId) {
            this.map.url = context.nameToUrl(bundleId);
            this.load();
            return;
          }
          load = bind(this, function (value) {
            this.init([], function () {
              return value;
            }, null, {
              enabled: true
            });
          });
          load.error = bind(this, function (err) {
            this.inited = true;
            this.error = err;
            err.requireModules = [id];

            //Remove temp unnormalized modules for this module,
            //since they will never be resolved otherwise now.
            eachProp(registry, function (mod) {
              if (mod.map.id.indexOf(id + '_unnormalized') === 0) {
                cleanRegistry(mod.map.id);
              }
            });
            onError(err);
          });

          //Allow plugins to load other code without having to know the
          //context or how to 'complete' the load.
          load.fromText = bind(this, function (text, textAlt) {
            /*jslint evil: true */
            var moduleName = map.name,
              moduleMap = makeModuleMap(moduleName),
              hasInteractive = useInteractive;

            //As of 2.1.0, support just passing the text, to reinforce
            //fromText only being called once per resource. Still
            //support old style of passing moduleName but discard
            //that moduleName in favor of the internal ref.
            if (textAlt) {
              text = textAlt;
            }

            //Turn off interactive script matching for IE for any define
            //calls in the text, then turn it back on at the end.
            if (hasInteractive) {
              useInteractive = false;
            }

            //Prime the system by creating a module instance for
            //it.
            getModule(moduleMap);

            //Transfer any config to this other module.
            if (hasProp(config.config, id)) {
              config.config[moduleName] = config.config[id];
            }
            try {
              req.exec(text);
            } catch (e) {
              return onError(makeError('fromtexteval', 'fromText eval for ' + id + ' failed: ' + e, e, [id]));
            }
            if (hasInteractive) {
              useInteractive = true;
            }

            //Mark this as a dependency for the plugin
            //resource
            this.depMaps.push(moduleMap);

            //Support anonymous modules.
            context.completeLoad(moduleName);

            //Bind the value of that module to the value for this
            //resource ID.
            localRequire([moduleName], load);
          });

          //Use parentName here since the plugin's name is not reliable,
          //could be some weird string with no path that actually wants to
          //reference the parentName's path.
          plugin.load(map.name, localRequire, load, config);
        }));
        context.enable(pluginMap, this);
        this.pluginMaps[pluginMap.id] = pluginMap;
      },
      enable: function () {
        enabledRegistry[this.map.id] = this;
        this.enabled = true;

        //Set flag mentioning that the module is enabling,
        //so that immediate calls to the defined callbacks
        //for dependencies do not trigger inadvertent load
        //with the depCount still being zero.
        this.enabling = true;

        //Enable each dependency
        each(this.depMaps, bind(this, function (depMap, i) {
          var id, mod, handler;
          if (typeof depMap === 'string') {
            //Dependency needs to be converted to a depMap
            //and wired up to this module.
            depMap = makeModuleMap(depMap, this.map.isDefine ? this.map : this.map.parentMap, false, !this.skipMap);
            this.depMaps[i] = depMap;
            handler = getOwn(handlers, depMap.id);
            if (handler) {
              this.depExports[i] = handler(this);
              return;
            }
            this.depCount += 1;
            on(depMap, 'defined', bind(this, function (depExports) {
              if (this.undefed) {
                return;
              }
              this.defineDep(i, depExports);
              this.check();
            }));
            if (this.errback) {
              on(depMap, 'error', bind(this, this.errback));
            } else if (this.events.error) {
              // No direct errback on this module, but something
              // else is listening for errors, so be sure to
              // propagate the error correctly.
              on(depMap, 'error', bind(this, function (err) {
                this.emit('error', err);
              }));
            }
          }
          id = depMap.id;
          mod = registry[id];

          //Skip special modules like 'require', 'exports', 'module'
          //Also, don't call enable if it is already enabled,
          //important in circular dependency cases.
          if (!hasProp(handlers, id) && mod && !mod.enabled) {
            context.enable(depMap, this);
          }
        }));

        //Enable each plugin that is used in
        //a dependency
        eachProp(this.pluginMaps, bind(this, function (pluginMap) {
          var mod = getOwn(registry, pluginMap.id);
          if (mod && !mod.enabled) {
            context.enable(pluginMap, this);
          }
        }));
        this.enabling = false;
        this.check();
      },
      on: function (name, cb) {
        var cbs = this.events[name];
        if (!cbs) {
          cbs = this.events[name] = [];
        }
        cbs.push(cb);
      },
      emit: function (name, evt) {
        each(this.events[name], function (cb) {
          cb(evt);
        });
        if (name === 'error') {
          //Now that the error handler was triggered, remove
          //the listeners, since this broken Module instance
          //can stay around for a while in the registry.
          delete this.events[name];
        }
      }
    };
    function callGetModule(args) {
      //Skip modules already defined.
      if (!hasProp(defined, args[0])) {
        getModule(makeModuleMap(args[0], null, true)).init(args[1], args[2]);
      }
    }
    function removeListener(node, func, name, ieName) {
      //Favor detachEvent because of IE9
      //issue, see attachEvent/addEventListener comment elsewhere
      //in this file.
      if (node.detachEvent && !isOpera) {
        //Probably IE. If not it will throw an error, which will be
        //useful to know.
        if (ieName) {
          node.detachEvent(ieName, func);
        }
      } else {
        node.removeEventListener(name, func, false);
      }
    }

    /**
     * Given an event from a script node, get the requirejs info from it,
     * and then removes the event listeners on the node.
     * @param {Event} evt
     * @returns {Object}
     */
    function getScriptData(evt) {
      //Using currentTarget instead of target for Firefox 2.0's sake. Not
      //all old browsers will be supported, but this one was easy enough
      //to support and still makes sense.
      var node = evt.currentTarget || evt.srcElement;

      //Remove the listeners once here.
      removeListener(node, context.onScriptLoad, 'load', 'onreadystatechange');
      removeListener(node, context.onScriptError, 'error');
      return {
        node: node,
        id: node && node.getAttribute('data-requiremodule')
      };
    }
    function intakeDefines() {
      var args;

      //Any defined modules in the global queue, intake them now.
      takeGlobalQueue();

      //Make sure any remaining defQueue items get properly processed.
      while (defQueue.length) {
        args = defQueue.shift();
        if (args[0] === null) {
          return onError(makeError('mismatch', 'Mismatched anonymous define() module: ' + args[args.length - 1]));
        } else {
          //args are id, deps, factory. Should be normalized by the
          //define() function.
          callGetModule(args);
        }
      }
      context.defQueueMap = {};
    }
    context = {
      config: config,
      contextName: contextName,
      registry: registry,
      defined: defined,
      urlFetched: urlFetched,
      defQueue: defQueue,
      defQueueMap: {},
      Module: Module,
      makeModuleMap: makeModuleMap,
      nextTick: req.nextTick,
      onError: onError,
      /**
       * Set a configuration for the context.
       * @param {Object} cfg config object to integrate.
       */
      configure: function (cfg) {
        //Make sure the baseUrl ends in a slash.
        if (cfg.baseUrl) {
          if (cfg.baseUrl.charAt(cfg.baseUrl.length - 1) !== '/') {
            cfg.baseUrl += '/';
          }
        }

        //Save off the paths since they require special processing,
        //they are additive.
        var shim = config.shim,
          objs = {
            paths: true,
            bundles: true,
            config: true,
            map: true
          };
        eachProp(cfg, function (value, prop) {
          if (objs[prop]) {
            if (!config[prop]) {
              config[prop] = {};
            }
            mixin(config[prop], value, true, true);
          } else {
            config[prop] = value;
          }
        });

        //Reverse map the bundles
        if (cfg.bundles) {
          eachProp(cfg.bundles, function (value, prop) {
            each(value, function (v) {
              if (v !== prop) {
                bundlesMap[v] = prop;
              }
            });
          });
        }

        //Merge shim
        if (cfg.shim) {
          eachProp(cfg.shim, function (value, id) {
            //Normalize the structure
            if (isArray(value)) {
              value = {
                deps: value
              };
            }
            if ((value.exports || value.init) && !value.exportsFn) {
              value.exportsFn = context.makeShimExports(value);
            }
            shim[id] = value;
          });
          config.shim = shim;
        }

        //Adjust packages if necessary.
        if (cfg.packages) {
          each(cfg.packages, function (pkgObj) {
            var location, name;
            pkgObj = typeof pkgObj === 'string' ? {
              name: pkgObj
            } : pkgObj;
            name = pkgObj.name;
            location = pkgObj.location;
            if (location) {
              config.paths[name] = pkgObj.location;
            }

            //Save pointer to main module ID for pkg name.
            //Remove leading dot in main, so main paths are normalized,
            //and remove any trailing .js, since different package
            //envs have different conventions: some use a module name,
            //some use a file name.
            config.pkgs[name] = pkgObj.name + '/' + (pkgObj.main || 'main').replace(currDirRegExp, '').replace(jsSuffixRegExp, '');
          });
        }

        //If there are any "waiting to execute" modules in the registry,
        //update the maps for them, since their info, like URLs to load,
        //may have changed.
        eachProp(registry, function (mod, id) {
          //If module already has init called, since it is too
          //late to modify them, and ignore unnormalized ones
          //since they are transient.
          if (!mod.inited && !mod.map.unnormalized) {
            mod.map = makeModuleMap(id, null, true);
          }
        });

        //If a deps array or a config callback is specified, then call
        //require with those args. This is useful when require is defined as a
        //config object before require.js is loaded.
        if (cfg.deps || cfg.callback) {
          context.require(cfg.deps || [], cfg.callback);
        }
      },
      makeShimExports: function (value) {
        function fn() {
          var ret;
          if (value.init) {
            ret = value.init.apply(global, arguments);
          }
          return ret || value.exports && getGlobal(value.exports);
        }
        return fn;
      },
      makeRequire: function (relMap, options) {
        options = options || {};
        function localRequire(deps, callback, errback) {
          var id, map, requireMod;
          if (options.enableBuildCallback && callback && isFunction(callback)) {
            callback.__requireJsBuild = true;
          }
          if (typeof deps === 'string') {
            if (isFunction(callback)) {
              //Invalid call
              return onError(makeError('requireargs', 'Invalid require call'), errback);
            }

            //If require|exports|module are requested, get the
            //value for them from the special handlers. Caveat:
            //this only works while module is being defined.
            if (relMap && hasProp(handlers, deps)) {
              return handlers[deps](registry[relMap.id]);
            }

            //Synchronous access to one module. If require.get is
            //available (as in the Node adapter), prefer that.
            if (req.get) {
              return req.get(context, deps, relMap, localRequire);
            }

            //Normalize module name, if it contains . or ..
            map = makeModuleMap(deps, relMap, false, true);
            id = map.id;
            if (!hasProp(defined, id)) {
              return onError(makeError('notloaded', 'Module name "' + id + '" has not been loaded yet for context: ' + contextName + (relMap ? '' : '. Use require([])')));
            }
            return defined[id];
          }

          //Grab defines waiting in the global queue.
          intakeDefines();

          //Mark all the dependencies as needing to be loaded.
          context.nextTick(function () {
            //Some defines could have been added since the
            //require call, collect them.
            intakeDefines();
            requireMod = getModule(makeModuleMap(null, relMap));

            //Store if map config should be applied to this require
            //call for dependencies.
            requireMod.skipMap = options.skipMap;
            requireMod.init(deps, callback, errback, {
              enabled: true
            });
            checkLoaded();
          });
          return localRequire;
        }
        mixin(localRequire, {
          isBrowser: isBrowser,
          /**
           * Converts a module name + .extension into an URL path.
           * *Requires* the use of a module name. It does not support using
           * plain URLs like nameToUrl.
           */
          toUrl: function (moduleNamePlusExt) {
            var ext,
              index = moduleNamePlusExt.lastIndexOf('.'),
              segment = moduleNamePlusExt.split('/')[0],
              isRelative = segment === '.' || segment === '..';

            //Have a file extension alias, and it is not the
            //dots from a relative path.
            if (index !== -1 && (!isRelative || index > 1)) {
              ext = moduleNamePlusExt.substring(index, moduleNamePlusExt.length);
              moduleNamePlusExt = moduleNamePlusExt.substring(0, index);
            }
            return context.nameToUrl(normalize(moduleNamePlusExt, relMap && relMap.id, true), ext, true);
          },
          defined: function (id) {
            return hasProp(defined, makeModuleMap(id, relMap, false, true).id);
          },
          specified: function (id) {
            id = makeModuleMap(id, relMap, false, true).id;
            return hasProp(defined, id) || hasProp(registry, id);
          }
        });

        //Only allow undef on top level require calls
        if (!relMap) {
          localRequire.undef = function (id) {
            //Bind any waiting define() calls to this context,
            //fix for #408
            takeGlobalQueue();
            var map = makeModuleMap(id, relMap, true),
              mod = getOwn(registry, id);
            mod.undefed = true;
            removeScript(id);
            delete defined[id];
            delete urlFetched[map.url];
            delete undefEvents[id];

            //Clean queued defines too. Go backwards
            //in array so that the splices do not
            //mess up the iteration.
            eachReverse(defQueue, function (args, i) {
              if (args[0] === id) {
                defQueue.splice(i, 1);
              }
            });
            delete context.defQueueMap[id];
            if (mod) {
              //Hold on to listeners in case the
              //module will be attempted to be reloaded
              //using a different config.
              if (mod.events.defined) {
                undefEvents[id] = mod.events;
              }
              cleanRegistry(id);
            }
          };
        }
        return localRequire;
      },
      /**
       * Called to enable a module if it is still in the registry
       * awaiting enablement. A second arg, parent, the parent module,
       * is passed in for context, when this method is overridden by
       * the optimizer. Not shown here to keep code compact.
       */
      enable: function (depMap) {
        var mod = getOwn(registry, depMap.id);
        if (mod) {
          getModule(depMap).enable();
        }
      },
      /**
       * Internal method used by environment adapters to complete a load event.
       * A load event could be a script load or just a load pass from a synchronous
       * load call.
       * @param {String} moduleName the name of the module to potentially complete.
       */
      completeLoad: function (moduleName) {
        var found,
          args,
          mod,
          shim = getOwn(config.shim, moduleName) || {},
          shExports = shim.exports;
        takeGlobalQueue();
        while (defQueue.length) {
          args = defQueue.shift();
          if (args[0] === null) {
            args[0] = moduleName;
            //If already found an anonymous module and bound it
            //to this name, then this is some other anon module
            //waiting for its completeLoad to fire.
            if (found) {
              break;
            }
            found = true;
          } else if (args[0] === moduleName) {
            //Found matching define call for this script!
            found = true;
          }
          callGetModule(args);
        }
        context.defQueueMap = {};

        //Do this after the cycle of callGetModule in case the result
        //of those calls/init calls changes the registry.
        mod = getOwn(registry, moduleName);
        if (!found && !hasProp(defined, moduleName) && mod && !mod.inited) {
          if (config.enforceDefine && (!shExports || !getGlobal(shExports))) {
            if (hasPathFallback(moduleName)) {
              return;
            } else {
              return onError(makeError('nodefine', 'No define call for ' + moduleName, null, [moduleName]));
            }
          } else {
            //A script that does not call define(), so just simulate
            //the call for it.
            callGetModule([moduleName, shim.deps || [], shim.exportsFn]);
          }
        }
        checkLoaded();
      },
      /**
       * Converts a module name to a file path. Supports cases where
       * moduleName may actually be just an URL.
       * Note that it **does not** call normalize on the moduleName,
       * it is assumed to have already been normalized. This is an
       * internal API, not a public one. Use toUrl for the public API.
       */
      nameToUrl: function (moduleName, ext, skipExt) {
        var paths,
          syms,
          i,
          parentModule,
          url,
          parentPath,
          bundleId,
          pkgMain = getOwn(config.pkgs, moduleName);
        if (pkgMain) {
          moduleName = pkgMain;
        }
        bundleId = getOwn(bundlesMap, moduleName);
        if (bundleId) {
          return context.nameToUrl(bundleId, ext, skipExt);
        }

        //If a colon is in the URL, it indicates a protocol is used and it is just
        //an URL to a file, or if it starts with a slash, contains a query arg (i.e. ?)
        //or ends with .js, then assume the user meant to use an url and not a module id.
        //The slash is important for protocol-less URLs as well as full paths.
        if (req.jsExtRegExp.test(moduleName)) {
          //Just a plain path, not module name lookup, so just return it.
          //Add extension if it is included. This is a bit wonky, only non-.js things pass
          //an extension, this method probably needs to be reworked.
          url = moduleName + (ext || '');
        } else {
          //A module that needs to be converted to a path.
          paths = config.paths;
          syms = moduleName.split('/');
          //For each module name segment, see if there is a path
          //registered for it. Start with most specific name
          //and work up from it.
          for (i = syms.length; i > 0; i -= 1) {
            parentModule = syms.slice(0, i).join('/');
            parentPath = getOwn(paths, parentModule);
            if (parentPath) {
              //If an array, it means there are a few choices,
              //Choose the one that is desired
              if (isArray(parentPath)) {
                parentPath = parentPath[0];
              }
              syms.splice(0, i, parentPath);
              break;
            }
          }

          //Join the path parts together, then figure out if baseUrl is needed.
          url = syms.join('/');
          url += ext || (/^data\:|\?/.test(url) || skipExt ? '' : '.js');
          url = (url.charAt(0) === '/' || url.match(/^[\w\+\.\-]+:/) ? '' : config.baseUrl) + url;
        }
        return config.urlArgs ? url + ((url.indexOf('?') === -1 ? '?' : '&') + config.urlArgs) : url;
      },
      //Delegates to req.load. Broken out as a separate function to
      //allow overriding in the optimizer.
      load: function (id, url) {
        req.load(context, id, url);
      },
      /**
       * Executes a module callback function. Broken out as a separate function
       * solely to allow the build system to sequence the files in the built
       * layer in the right sequence.
       *
       * @private
       */
      execCb: function (name, callback, args, exports) {
        return callback.apply(exports, args);
      },
      /**
       * callback for script loads, used to check status of loading.
       *
       * @param {Event} evt the event from the browser for the script
       * that was loaded.
       */
      onScriptLoad: function (evt) {
        //Using currentTarget instead of target for Firefox 2.0's sake. Not
        //all old browsers will be supported, but this one was easy enough
        //to support and still makes sense.
        if (evt.type === 'load' || readyRegExp.test((evt.currentTarget || evt.srcElement).readyState)) {
          //Reset interactive script so a script node is not held onto for
          //to long.
          interactiveScript = null;

          //Pull out the name of the module and the context.
          var data = getScriptData(evt);
          context.completeLoad(data.id);
        }
      },
      /**
       * Callback for script errors.
       */
      onScriptError: function (evt) {
        var data = getScriptData(evt);
        if (!hasPathFallback(data.id)) {
          var parents = [];
          eachProp(registry, function (value, key) {
            if (key.indexOf('_@r') !== 0) {
              each(value.depMaps, function (depMap) {
                if (depMap.id === data.id) {
                  parents.push(key);
                }
                return true;
              });
            }
          });
          return onError(makeError('scripterror', 'Script error for "' + data.id + (parents.length ? '", needed by: ' + parents.join(', ') : '"'), evt, [data.id]));
        }
      }
    };
    context.require = context.makeRequire();
    return context;
  }

  /**
   * Main entry point.
   *
   * If the only argument to require is a string, then the module that
   * is represented by that string is fetched for the appropriate context.
   *
   * If the first argument is an array, then it will be treated as an array
   * of dependency string names to fetch. An optional function callback can
   * be specified to execute when all of those dependencies are available.
   *
   * Make a local req variable to help Caja compliance (it assumes things
   * on a require that are not standardized), and to give a short
   * name for minification/local scope use.
   */
  req = requirejs = function (deps, callback, errback, optional) {
    //Find the right context, use default
    var context,
      config,
      contextName = defContextName;

    // Determine if have config object in the call.
    if (!isArray(deps) && typeof deps !== 'string') {
      // deps is a config object
      config = deps;
      if (isArray(callback)) {
        // Adjust args if there are dependencies
        deps = callback;
        callback = errback;
        errback = optional;
      } else {
        deps = [];
      }
    }
    if (config && config.context) {
      contextName = config.context;
    }
    context = getOwn(contexts, contextName);
    if (!context) {
      context = contexts[contextName] = req.s.newContext(contextName);
    }
    if (config) {
      context.configure(config);
    }
    return context.require(deps, callback, errback);
  };

  /**
   * Support require.config() to make it easier to cooperate with other
   * AMD loaders on globally agreed names.
   */
  req.config = function (config) {
    return req(config);
  };

  /**
   * Execute something after the current tick
   * of the event loop. Override for other envs
   * that have a better solution than setTimeout.
   * @param  {Function} fn function to execute later.
   */
  req.nextTick = typeof setTimeout !== 'undefined' ? function (fn) {
    setTimeout(fn, 4);
  } : function (fn) {
    fn();
  };

  /**
   * Export require as a global, but only if it does not already exist.
   */
  if (!require) {
    require = req;
  }
  req.version = version;

  //Used to filter out dependencies that are already paths.
  req.jsExtRegExp = /^\/|:|\?|\.js$/;
  req.isBrowser = isBrowser;
  s = req.s = {
    contexts: contexts,
    newContext: newContext
  };

  //Create default context.
  req({});

  //Exports some context-sensitive methods on global require.
  each(['toUrl', 'undef', 'defined', 'specified'], function (prop) {
    //Reference from contexts instead of early binding to default context,
    //so that during builds, the latest instance of the default context
    //with its config gets used.
    req[prop] = function () {
      var ctx = contexts[defContextName];
      return ctx.require[prop].apply(ctx, arguments);
    };
  });
  if (isBrowser) {
    head = s.head = document.getElementsByTagName('head')[0];
    //If BASE tag is in play, using appendChild is a problem for IE6.
    //When that browser dies, this can be removed. Details in this jQuery bug:
    //http://dev.jquery.com/ticket/2709
    baseElement = document.getElementsByTagName('base')[0];
    if (baseElement) {
      head = s.head = baseElement.parentNode;
    }
  }

  /**
   * Any errors that require explicitly generates will be passed to this
   * function. Intercept/override it if you want custom error handling.
   * @param {Error} err the error object.
   */
  req.onError = defaultOnError;

  /**
   * Creates the node for the load command. Only used in browser envs.
   */
  req.createNode = function (config, moduleName, url) {
    var node = config.xhtml ? document.createElementNS('http://www.w3.org/1999/xhtml', 'html:script') : document.createElement('script');
    node.type = config.scriptType || 'text/javascript';
    node.charset = 'utf-8';
    node.async = true;
    return node;
  };

  /**
   * Does the request to load a module for the browser case.
   * Make this a separate function to allow other environments
   * to override it.
   *
   * @param {Object} context the require context to find state.
   * @param {String} moduleName the name of the module.
   * @param {Object} url the URL to the module.
   */
  req.load = function (context, moduleName, url) {
    var config = context && context.config || {},
      node;
    if (isBrowser) {
      //In the browser so use a script tag
      node = req.createNode(config, moduleName, url);
      if (config.onNodeCreated) {
        config.onNodeCreated(node, config, moduleName, url);
      }
      node.setAttribute('data-requirecontext', context.contextName);
      node.setAttribute('data-requiremodule', moduleName);

      //Set up load listener. Test attachEvent first because IE9 has
      //a subtle issue in its addEventListener and script onload firings
      //that do not match the behavior of all other browsers with
      //addEventListener support, which fire the onload event for a
      //script right after the script execution. See:
      //https://connect.microsoft.com/IE/feedback/details/648057/script-onload-event-is-not-fired-immediately-after-script-execution
      //UNFORTUNATELY Opera implements attachEvent but does not follow the script
      //script execution mode.
      if (node.attachEvent &&
      //Check if node.attachEvent is artificially added by custom script or
      //natively supported by browser
      //read https://github.com/jrburke/requirejs/issues/187
      //if we can NOT find [native code] then it must NOT natively supported.
      //in IE8, node.attachEvent does not have toString()
      //Note the test for "[native code" with no closing brace, see:
      //https://github.com/jrburke/requirejs/issues/273
      !(node.attachEvent.toString && node.attachEvent.toString().indexOf('[native code') < 0) && !isOpera) {
        //Probably IE. IE (at least 6-8) do not fire
        //script onload right after executing the script, so
        //we cannot tie the anonymous define call to a name.
        //However, IE reports the script as being in 'interactive'
        //readyState at the time of the define call.
        useInteractive = true;
        node.attachEvent('onreadystatechange', context.onScriptLoad);
        //It would be great to add an error handler here to catch
        //404s in IE9+. However, onreadystatechange will fire before
        //the error handler, so that does not help. If addEventListener
        //is used, then IE will fire error before load, but we cannot
        //use that pathway given the connect.microsoft.com issue
        //mentioned above about not doing the 'script execute,
        //then fire the script load event listener before execute
        //next script' that other browsers do.
        //Best hope: IE10 fixes the issues,
        //and then destroys all installs of IE 6-9.
        //node.attachEvent('onerror', context.onScriptError);
      } else {
        node.addEventListener('load', context.onScriptLoad, false);
        node.addEventListener('error', context.onScriptError, false);
      }
      node.src = url;

      //For some cache cases in IE 6-8, the script executes before the end
      //of the appendChild execution, so to tie an anonymous define
      //call to the module name (which is stored on the node), hold on
      //to a reference to this node, but clear after the DOM insertion.
      currentlyAddingScript = node;
      if (baseElement) {
        head.insertBefore(node, baseElement);
      } else {
        head.appendChild(node);
      }
      currentlyAddingScript = null;
      return node;
    } else if (isWebWorker) {
      try {
        //In a web worker, use importScripts. This is not a very
        //efficient use of importScripts, importScripts will block until
        //its script is downloaded and evaluated. However, if web workers
        //are in play, the expectation is that a build has been done so
        //that only one script needs to be loaded anyway. This may need
        //to be reevaluated if other use cases become common.
        importScripts(url);

        //Account for anonymous modules
        context.completeLoad(moduleName);
      } catch (e) {
        context.onError(makeError('importscripts', 'importScripts failed for ' + moduleName + ' at ' + url, e, [moduleName]));
      }
    }
  };
  function getInteractiveScript() {
    if (interactiveScript && interactiveScript.readyState === 'interactive') {
      return interactiveScript;
    }
    eachReverse(scripts(), function (script) {
      if (script.readyState === 'interactive') {
        return interactiveScript = script;
      }
    });
    return interactiveScript;
  }

  //Look for a data-main script attribute, which could also adjust the baseUrl.
  if (isBrowser && !cfg.skipDataMain) {
    //Figure out baseUrl. Get it from the script tag with require.js in it.
    eachReverse(scripts(), function (script) {
      //Set the 'head' where we can append children by
      //using the script's parent.
      if (!head) {
        head = script.parentNode;
      }

      //Look for a data-main attribute to set main script for the page
      //to load. If it is there, the path to data main becomes the
      //baseUrl, if it is not already set.
      dataMain = script.getAttribute('data-main');
      if (dataMain) {
        //Preserve dataMain in case it is a path (i.e. contains '?')
        mainScript = dataMain;

        //Set final baseUrl if there is not already an explicit one.
        if (!cfg.baseUrl) {
          //Pull off the directory of data-main for use as the
          //baseUrl.
          src = mainScript.split('/');
          mainScript = src.pop();
          subPath = src.length ? src.join('/') + '/' : './';
          cfg.baseUrl = subPath;
        }

        //Strip off any trailing .js since mainScript is now
        //like a module name.
        mainScript = mainScript.replace(jsSuffixRegExp, '');

        //If mainScript is still a path, fall back to dataMain
        if (req.jsExtRegExp.test(mainScript)) {
          mainScript = dataMain;
        }

        //Put the data-main script in the files to load.
        cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript];
        return true;
      }
    });
  }

  /**
   * The function that handles definitions of modules. Differs from
   * require() in that a string for the module should be the first argument,
   * and the function to execute after dependencies are loaded should
   * return a value to define the module corresponding to the first argument's
   * name.
   */
  define = function (name, deps, callback) {
    var node, context;

    //Allow for anonymous modules
    if (typeof name !== 'string') {
      //Adjust args appropriately
      callback = deps;
      deps = name;
      name = null;
    }

    //This module may not have dependencies
    if (!isArray(deps)) {
      callback = deps;
      deps = null;
    }

    //If no name, and callback is a function, then figure out if it a
    //CommonJS thing with dependencies.
    if (!deps && isFunction(callback)) {
      deps = [];
      //Remove comments from the callback string,
      //look for require calls, and pull them into the dependencies,
      //but only if there are function args.
      if (callback.length) {
        callback.toString().replace(commentRegExp, '').replace(cjsRequireRegExp, function (match, dep) {
          deps.push(dep);
        });

        //May be a CommonJS thing even without require calls, but still
        //could use exports, and module. Avoid doing exports and module
        //work though if it just needs require.
        //REQUIRES the function to expect the CommonJS variables in the
        //order listed below.
        deps = (callback.length === 1 ? ['require'] : ['require', 'exports', 'module']).concat(deps);
      }
    }

    //If in IE 6-8 and hit an anonymous define() call, do the interactive
    //work.
    if (useInteractive) {
      node = currentlyAddingScript || getInteractiveScript();
      if (node) {
        if (!name) {
          name = node.getAttribute('data-requiremodule');
        }
        context = contexts[node.getAttribute('data-requirecontext')];
      }
    }

    //Always save off evaluating the def call until the script onload handler.
    //This allows multiple modules to be in a file without prematurely
    //tracing dependencies, and allows for anonymous module support,
    //where the module name is not known until the script onload event
    //occurs. If no context, use the global queue, and get it processed
    //in the onscript load callback.
    if (context) {
      context.defQueue.push([name, deps, callback]);
      context.defQueueMap[name] = true;
    } else {
      globalDefQueue.push([name, deps, callback]);
    }
  };
  define.amd = {
    jQuery: true
  };

  /**
   * Executes the text. Normally just uses eval, but can be modified
   * to use a better, environment-specific call. Only used for transpiling
   * loader plugins, not for plain JS modules.
   * @param {String} text the text to execute/evaluate.
   */
  req.exec = function (text) {
    /*jslint evil: true */
    return eval(text);
  };

  //Set up with config info.
  req(cfg);
})(this);